import _defineProperty from "/codebuild/output/src499199476/src/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/codebuild/output/src499199476/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["color", "size", "className"],
    _excluded2 = ["color", "size", "className"],
    _excluded3 = ["color", "size", "className"],
    _excluded4 = ["color", "size", "className"],
    _excluded5 = ["color", "size", "className"],
    _excluded6 = ["color", "size", "className"],
    _excluded7 = ["color", "size", "className"],
    _excluded8 = ["color", "size", "className"],
    _excluded9 = ["color", "size", "className"],
    _excluded10 = ["color", "size", "className"],
    _excluded11 = ["color", "size", "className"],
    _excluded12 = ["color", "size", "className"],
    _excluded13 = ["color", "size", "className"],
    _excluded14 = ["color", "size", "className"],
    _excluded15 = ["color", "size", "className"],
    _excluded16 = ["color", "size", "className"],
    _excluded17 = ["color", "size", "className"],
    _excluded18 = ["color", "size", "className"],
    _excluded19 = ["color", "size", "className"],
    _excluded20 = ["color", "size", "className"],
    _excluded21 = ["color", "size", "className"],
    _excluded22 = ["color", "size", "className"],
    _excluded23 = ["color", "size", "className"],
    _excluded24 = ["color", "size", "className"],
    _excluded25 = ["color", "size", "className"],
    _excluded26 = ["color", "size", "className"],
    _excluded27 = ["color", "size", "className"],
    _excluded28 = ["color", "size", "className"],
    _excluded29 = ["color", "size", "className"],
    _excluded30 = ["color", "size", "className"],
    _excluded31 = ["color", "size", "className"],
    _excluded32 = ["color", "size", "className"],
    _excluded33 = ["color", "size", "className"],
    _excluded34 = ["color", "size", "className"],
    _excluded35 = ["color", "size", "className"],
    _excluded36 = ["color", "size", "className"],
    _excluded37 = ["color", "size", "className"],
    _excluded38 = ["color", "size", "className"],
    _excluded39 = ["color", "size", "className"],
    _excluded40 = ["color", "size", "className"],
    _excluded41 = ["color", "size", "className"],
    _excluded42 = ["color", "size", "className"],
    _excluded43 = ["color", "size", "className"],
    _excluded44 = ["color", "size", "className"],
    _excluded45 = ["color", "size", "className"],
    _excluded46 = ["color", "size", "className"],
    _excluded47 = ["color", "size", "className"],
    _excluded48 = ["color", "size", "className"],
    _excluded49 = ["color", "size", "className"],
    _excluded50 = ["color", "size", "className"],
    _excluded51 = ["color", "size", "className"],
    _excluded52 = ["color", "size", "className"],
    _excluded53 = ["color", "size", "className"],
    _excluded54 = ["color", "size", "className"],
    _excluded55 = ["color", "size", "className"],
    _excluded56 = ["color", "size", "className"],
    _excluded57 = ["color", "size", "className"],
    _excluded58 = ["color", "size", "className"],
    _excluded59 = ["color", "size", "className"],
    _excluded60 = ["color", "size", "className"],
    _excluded61 = ["color", "size", "className"],
    _excluded62 = ["color", "size", "className"],
    _excluded63 = ["color", "size", "className"],
    _excluded64 = ["color", "size", "className"],
    _excluded65 = ["color", "size", "className"],
    _excluded66 = ["color", "size", "className"],
    _excluded67 = ["color", "size", "className"],
    _excluded68 = ["color", "size", "className"],
    _excluded69 = ["color", "size", "className"],
    _excluded70 = ["color", "size", "className"],
    _excluded71 = ["color", "size", "className"],
    _excluded72 = ["color", "size", "className"],
    _excluded73 = ["color", "size", "className"],
    _excluded74 = ["color", "size", "className"],
    _excluded75 = ["color", "size", "className"],
    _excluded76 = ["color", "size", "className"],
    _excluded77 = ["color", "size", "className"],
    _excluded78 = ["color", "size", "className"],
    _excluded79 = ["color", "size", "className"],
    _excluded80 = ["color", "size", "className"],
    _excluded81 = ["color", "size", "className"],
    _excluded82 = ["color", "size", "className"],
    _excluded83 = ["color", "size", "className"],
    _excluded84 = ["color", "size", "className"],
    _excluded85 = ["color", "size", "className"],
    _excluded86 = ["color", "size", "className"],
    _excluded87 = ["color", "size", "className"],
    _excluded88 = ["color", "size", "className"],
    _excluded89 = ["color", "size", "className"],
    _excluded90 = ["color", "size", "className"],
    _excluded91 = ["color", "size", "className"],
    _excluded92 = ["color", "size", "className"],
    _excluded93 = ["color", "size", "className"],
    _excluded94 = ["color", "size", "className"],
    _excluded95 = ["color", "size", "className"],
    _excluded96 = ["color", "size", "className"],
    _excluded97 = ["color", "size", "className"],
    _excluded98 = ["color", "size", "className"],
    _excluded99 = ["color", "size", "className"],
    _excluded100 = ["color", "size", "className"],
    _excluded101 = ["color", "size", "className"],
    _excluded102 = ["color", "size", "className"],
    _excluded103 = ["color", "size", "className"],
    _excluded104 = ["color", "size", "className"],
    _excluded105 = ["color", "size", "className"],
    _excluded106 = ["color", "size", "className"],
    _excluded107 = ["color", "size", "className"],
    _excluded108 = ["color", "size", "className"],
    _excluded109 = ["color", "size", "className"],
    _excluded110 = ["color", "size", "className"],
    _excluded111 = ["color", "size", "className"],
    _excluded112 = ["color", "size", "className"],
    _excluded113 = ["color", "size", "className"],
    _excluded114 = ["color", "size", "className"],
    _excluded115 = ["color", "size", "className"],
    _excluded116 = ["color", "size", "className"],
    _excluded117 = ["color", "size", "className"],
    _excluded118 = ["color", "size", "className"],
    _excluded119 = ["color", "size", "className"],
    _excluded120 = ["color", "size", "className"],
    _excluded121 = ["color", "size", "className"],
    _excluded122 = ["color", "size", "className"],
    _excluded123 = ["color", "size", "className"],
    _excluded124 = ["color", "size", "className"],
    _excluded125 = ["color", "size", "className"],
    _excluded126 = ["color", "size", "className"],
    _excluded127 = ["color", "size", "className"],
    _excluded128 = ["color", "size", "className"],
    _excluded129 = ["color", "size", "className"],
    _excluded130 = ["color", "size", "className"],
    _excluded131 = ["color", "size", "className"],
    _excluded132 = ["color", "size", "className"],
    _excluded133 = ["color", "size", "className"],
    _excluded134 = ["color", "size", "className"],
    _excluded135 = ["color", "size", "className"],
    _excluded136 = ["color", "size", "className"],
    _excluded137 = ["color", "size", "className"],
    _excluded138 = ["color", "size", "className"],
    _excluded139 = ["color", "size", "className"],
    _excluded140 = ["color", "size", "className"],
    _excluded141 = ["color", "size", "className"],
    _excluded142 = ["color", "size", "className"],
    _excluded143 = ["color", "size", "className"],
    _excluded144 = ["color", "size", "className"],
    _excluded145 = ["color", "size", "className"],
    _excluded146 = ["color", "size", "className"],
    _excluded147 = ["color", "size", "className"],
    _excluded148 = ["color", "size", "className"],
    _excluded149 = ["color", "size", "className"],
    _excluded150 = ["color", "size", "className"],
    _excluded151 = ["color", "size", "className"],
    _excluded152 = ["color", "size", "className"],
    _excluded153 = ["color", "size", "className"],
    _excluded154 = ["color", "size", "className"],
    _excluded155 = ["color", "size", "className"],
    _excluded156 = ["color", "size", "className"],
    _excluded157 = ["color", "size", "className"],
    _excluded158 = ["color", "size", "className"],
    _excluded159 = ["color", "size", "className"],
    _excluded160 = ["color", "size", "className"],
    _excluded161 = ["color", "size", "className"],
    _excluded162 = ["color", "size", "className"],
    _excluded163 = ["color", "size", "className"],
    _excluded164 = ["color", "size", "className"],
    _excluded165 = ["color", "size", "className"],
    _excluded166 = ["color", "size", "className"],
    _excluded167 = ["color", "size", "className"],
    _excluded168 = ["color", "size", "className"],
    _excluded169 = ["color", "size", "className"],
    _excluded170 = ["color", "size", "className"],
    _excluded171 = ["color", "size", "className"],
    _excluded172 = ["color", "size", "className"],
    _excluded173 = ["color", "size", "className"],
    _excluded174 = ["color", "size", "className"],
    _excluded175 = ["color", "size", "className"],
    _excluded176 = ["color", "size", "className"],
    _excluded177 = ["color", "size", "className"],
    _excluded178 = ["color", "size", "className"],
    _excluded179 = ["color", "size", "className"],
    _excluded180 = ["color", "size", "className"],
    _excluded181 = ["color", "size", "className"],
    _excluded182 = ["color", "size", "className"],
    _excluded183 = ["color", "size", "className"],
    _excluded184 = ["color", "size", "className"],
    _excluded185 = ["color", "size", "className"],
    _excluded186 = ["color", "size", "className"],
    _excluded187 = ["color", "size", "className"],
    _excluded188 = ["color", "size", "className"],
    _excluded189 = ["color", "size", "className"],
    _excluded190 = ["color", "size", "className"],
    _excluded191 = ["color", "size", "className"],
    _excluded192 = ["color", "size", "className"],
    _excluded193 = ["color", "size", "className"],
    _excluded194 = ["color", "size", "className"],
    _excluded195 = ["color", "size", "className"],
    _excluded196 = ["color", "size", "className"],
    _excluded197 = ["color", "size", "className"],
    _excluded198 = ["color", "size", "className"],
    _excluded199 = ["color", "size", "className"],
    _excluded200 = ["color", "size", "className"],
    _excluded201 = ["color", "size", "className"],
    _excluded202 = ["color", "size", "className"],
    _excluded203 = ["color", "size", "className"],
    _excluded204 = ["color", "size", "className"],
    _excluded205 = ["color", "size", "className"],
    _excluded206 = ["color", "size", "className"],
    _excluded207 = ["color", "size", "className"],
    _excluded208 = ["color", "size", "className"],
    _excluded209 = ["color", "size", "className"],
    _excluded210 = ["color", "size", "className"],
    _excluded211 = ["color", "size", "className"],
    _excluded212 = ["color", "size", "className"],
    _excluded213 = ["color", "size", "className"],
    _excluded214 = ["color", "size", "className"],
    _excluded215 = ["color", "size", "className"],
    _excluded216 = ["color", "size", "className"],
    _excluded217 = ["color", "size", "className"],
    _excluded218 = ["color", "size", "className"],
    _excluded219 = ["color", "size", "className"],
    _excluded220 = ["color", "size", "className"],
    _excluded221 = ["color", "size", "className"],
    _excluded222 = ["color", "size", "className"],
    _excluded223 = ["color", "size", "className"],
    _excluded224 = ["color", "size", "className"],
    _excluded225 = ["color", "size", "className"],
    _excluded226 = ["color", "size", "className"],
    _excluded227 = ["color", "size", "className"],
    _excluded228 = ["color", "size", "className"],
    _excluded229 = ["color", "size", "className"],
    _excluded230 = ["color", "size", "className"],
    _excluded231 = ["color", "size", "className"],
    _excluded232 = ["color", "size", "className"],
    _excluded233 = ["color", "size", "className"],
    _excluded234 = ["color", "size", "className"],
    _excluded235 = ["color", "size", "className"],
    _excluded236 = ["color", "size", "className"],
    _excluded237 = ["color", "size", "className"],
    _excluded238 = ["color", "size", "className"],
    _excluded239 = ["color", "size", "className"],
    _excluded240 = ["color", "size", "className"],
    _excluded241 = ["color", "size", "className"],
    _excluded242 = ["color", "size", "className"],
    _excluded243 = ["color", "size", "className"],
    _excluded244 = ["color", "size", "className"],
    _excluded245 = ["color", "size", "className"],
    _excluded246 = ["color", "size", "className"],
    _excluded247 = ["color", "size", "className"],
    _excluded248 = ["color", "size", "className"],
    _excluded249 = ["color", "size", "className"],
    _excluded250 = ["color", "size", "className"],
    _excluded251 = ["color", "size", "className"],
    _excluded252 = ["color", "size", "className"],
    _excluded253 = ["color", "size", "className"],
    _excluded254 = ["color", "size", "className"],
    _excluded255 = ["color", "size", "className"],
    _excluded256 = ["color", "size", "className"],
    _excluded257 = ["color", "size", "className"],
    _excluded258 = ["color", "size", "className"],
    _excluded259 = ["color", "size", "className"],
    _excluded260 = ["color", "size", "className"],
    _excluded261 = ["color", "size", "className"],
    _excluded262 = ["color", "size", "className"],
    _excluded263 = ["color", "size", "className"],
    _excluded264 = ["color", "size", "className"],
    _excluded265 = ["color", "size", "className"],
    _excluded266 = ["color", "size", "className"],
    _excluded267 = ["color", "size", "className"],
    _excluded268 = ["color", "size", "className"],
    _excluded269 = ["color", "size", "className"],
    _excluded270 = ["color", "size", "className"],
    _excluded271 = ["color", "size", "className"],
    _excluded272 = ["color", "size", "className"],
    _excluded273 = ["color", "size", "className"],
    _excluded274 = ["color", "size", "className"],
    _excluded275 = ["color", "size", "className"],
    _excluded276 = ["color", "size", "className"],
    _excluded277 = ["color", "size", "className"],
    _excluded278 = ["color", "size", "className"],
    _excluded279 = ["color", "size", "className"],
    _excluded280 = ["color", "size", "className"],
    _excluded281 = ["color", "size", "className"],
    _excluded282 = ["color", "size", "className"],
    _excluded283 = ["color", "size", "className"],
    _excluded284 = ["color", "size", "className"],
    _excluded285 = ["color", "size", "className"],
    _excluded286 = ["color", "size", "className"],
    _excluded287 = ["color", "size", "className"],
    _excluded288 = ["color", "size", "className"],
    _excluded289 = ["color", "size", "className"],
    _excluded290 = ["color", "size", "className"],
    _excluded291 = ["color", "size", "className"],
    _excluded292 = ["color", "size", "className"],
    _excluded293 = ["color", "size", "className"],
    _excluded294 = ["color", "size", "className"],
    _excluded295 = ["color", "size", "className"],
    _excluded296 = ["color", "size", "className"],
    _excluded297 = ["color", "size", "className"],
    _excluded298 = ["color", "size", "className"],
    _excluded299 = ["color", "size", "className"],
    _excluded300 = ["color", "size", "className"],
    _excluded301 = ["color", "size", "className"],
    _excluded302 = ["color", "size", "className"],
    _excluded303 = ["color", "size", "className"],
    _excluded304 = ["color", "size", "className"],
    _excluded305 = ["color", "size", "className"],
    _excluded306 = ["color", "size", "className"],
    _excluded307 = ["color", "size", "className"],
    _excluded308 = ["color", "size", "className"],
    _excluded309 = ["color", "size", "className"],
    _excluded310 = ["color", "size", "className"],
    _excluded311 = ["color", "size", "className"],
    _excluded312 = ["color", "size", "className"],
    _excluded313 = ["color", "size", "className"],
    _excluded314 = ["color", "size", "className"],
    _excluded315 = ["color", "size", "className"],
    _excluded316 = ["color", "size", "className"],
    _excluded317 = ["color", "size", "className"],
    _excluded318 = ["color", "size", "className"],
    _excluded319 = ["color", "size", "className"],
    _excluded320 = ["color", "size", "className"],
    _excluded321 = ["color", "size", "className"],
    _excluded322 = ["color", "size", "className"],
    _excluded323 = ["color", "size", "className"],
    _excluded324 = ["color", "size", "className"],
    _excluded325 = ["color", "size", "className"],
    _excluded326 = ["color", "size", "className"],
    _excluded327 = ["color", "size", "className"],
    _excluded328 = ["color", "size", "className"],
    _excluded329 = ["color", "size", "className"],
    _excluded330 = ["color", "size", "className"],
    _excluded331 = ["color", "size", "className"],
    _excluded332 = ["color", "size", "className"],
    _excluded333 = ["color", "size", "className"],
    _excluded334 = ["color", "size", "className"],
    _excluded335 = ["color", "size", "className"],
    _excluded336 = ["color", "size", "className"],
    _excluded337 = ["color", "size", "className"],
    _excluded338 = ["color", "size", "className"],
    _excluded339 = ["color", "size", "className"],
    _excluded340 = ["color", "size", "className"],
    _excluded341 = ["color", "size", "className"],
    _excluded342 = ["color", "size", "className"],
    _excluded343 = ["color", "size", "className"],
    _excluded344 = ["color", "size", "className"],
    _excluded345 = ["color", "size", "className"],
    _excluded346 = ["color", "size", "className"],
    _excluded347 = ["color", "size", "className"],
    _excluded348 = ["color", "size", "className"],
    _excluded349 = ["color", "size", "className"],
    _excluded350 = ["color", "size", "className"],
    _excluded351 = ["color", "size", "className"],
    _excluded352 = ["color", "size", "className"],
    _excluded353 = ["color", "size", "className"],
    _excluded354 = ["color", "size", "className"],
    _excluded355 = ["color", "size", "className"],
    _excluded356 = ["color", "size", "className"],
    _excluded357 = ["color", "size", "className"],
    _excluded358 = ["color", "size", "className"],
    _excluded359 = ["color", "size", "className"],
    _excluded360 = ["color", "size", "className"],
    _excluded361 = ["color", "size", "className"],
    _excluded362 = ["color", "size", "className"],
    _excluded363 = ["color", "size", "className"],
    _excluded364 = ["color", "size", "className"],
    _excluded365 = ["color", "size", "className"],
    _excluded366 = ["color", "size", "className"],
    _excluded367 = ["color", "size", "className"],
    _excluded368 = ["color", "size", "className"],
    _excluded369 = ["color", "size", "className"],
    _excluded370 = ["color", "size", "className"],
    _excluded371 = ["color", "size", "className"],
    _excluded372 = ["color", "size", "className"],
    _excluded373 = ["color", "size", "className"],
    _excluded374 = ["color", "size", "className"],
    _excluded375 = ["color", "size", "className"],
    _excluded376 = ["color", "size", "className"],
    _excluded377 = ["color", "size", "className"],
    _excluded378 = ["color", "size", "className"],
    _excluded379 = ["color", "size", "className"],
    _excluded380 = ["color", "size", "className"],
    _excluded381 = ["color", "size", "className"],
    _excluded382 = ["color", "size", "className"],
    _excluded383 = ["color", "size", "className"],
    _excluded384 = ["color", "size", "className"],
    _excluded385 = ["color", "size", "className"],
    _excluded386 = ["color", "size", "className"],
    _excluded387 = ["color", "size", "className"],
    _excluded388 = ["color", "size", "className"],
    _excluded389 = ["color", "size", "className"],
    _excluded390 = ["color", "size", "className"],
    _excluded391 = ["color", "size", "className"],
    _excluded392 = ["color", "size", "className"],
    _excluded393 = ["color", "size", "className"],
    _excluded394 = ["color", "size", "className"],
    _excluded395 = ["color", "size", "className"],
    _excluded396 = ["color", "size", "className"],
    _excluded397 = ["color", "size", "className"],
    _excluded398 = ["color", "size", "className"],
    _excluded399 = ["color", "size", "className"],
    _excluded400 = ["color", "size", "className"],
    _excluded401 = ["color", "size", "className"],
    _excluded402 = ["color", "size", "className"],
    _excluded403 = ["color", "size", "className"],
    _excluded404 = ["color", "size", "className"],
    _excluded405 = ["color", "size", "className"],
    _excluded406 = ["color", "size", "className"],
    _excluded407 = ["color", "size", "className"],
    _excluded408 = ["color", "size", "className"],
    _excluded409 = ["color", "size", "className"],
    _excluded410 = ["color", "size", "className"],
    _excluded411 = ["color", "size", "className"],
    _excluded412 = ["color", "size", "className"],
    _excluded413 = ["color", "size", "className"],
    _excluded414 = ["color", "size", "className"],
    _excluded415 = ["color", "size", "className"],
    _excluded416 = ["color", "size", "className"],
    _excluded417 = ["color", "size", "className"],
    _excluded418 = ["color", "size", "className"],
    _excluded419 = ["color", "size", "className"],
    _excluded420 = ["color", "size", "className"],
    _excluded421 = ["color", "size", "className"],
    _excluded422 = ["color", "size", "className"],
    _excluded423 = ["color", "size", "className"],
    _excluded424 = ["color", "size", "className"],
    _excluded425 = ["color", "size", "className"],
    _excluded426 = ["color", "size", "className"],
    _excluded427 = ["color", "size", "className"],
    _excluded428 = ["color", "size", "className"],
    _excluded429 = ["color", "size", "className"],
    _excluded430 = ["color", "size", "className"],
    _excluded431 = ["color", "size", "className"],
    _excluded432 = ["color", "size", "className"],
    _excluded433 = ["color", "size", "className"],
    _excluded434 = ["color", "size", "className"],
    _excluded435 = ["color", "size", "className"],
    _excluded436 = ["color", "size", "className"],
    _excluded437 = ["color", "size", "className"],
    _excluded438 = ["color", "size", "className"],
    _excluded439 = ["color", "size", "className"],
    _excluded440 = ["color", "size", "className"],
    _excluded441 = ["color", "size", "className"],
    _excluded442 = ["color", "size", "className"],
    _excluded443 = ["color", "size", "className"],
    _excluded444 = ["color", "size", "className"],
    _excluded445 = ["color", "size", "className"],
    _excluded446 = ["color", "size", "className"],
    _excluded447 = ["color", "size", "className"],
    _excluded448 = ["color", "size", "className"],
    _excluded449 = ["color", "size", "className"],
    _excluded450 = ["color", "size", "className"],
    _excluded451 = ["color", "size", "className"],
    _excluded452 = ["color", "size", "className"],
    _excluded453 = ["color", "size", "className"],
    _excluded454 = ["color", "size", "className"],
    _excluded455 = ["color", "size", "className"],
    _excluded456 = ["color", "size", "className"],
    _excluded457 = ["color", "size", "className"],
    _excluded458 = ["color", "size", "className"],
    _excluded459 = ["color", "size", "className"],
    _excluded460 = ["color", "size", "className"],
    _excluded461 = ["color", "size", "className"],
    _excluded462 = ["color", "size", "className"],
    _excluded463 = ["color", "size", "className"],
    _excluded464 = ["color", "size", "className"],
    _excluded465 = ["color", "size", "className"],
    _excluded466 = ["color", "size", "className"],
    _excluded467 = ["color", "size", "className"],
    _excluded468 = ["color", "size", "className"],
    _excluded469 = ["color", "size", "className"],
    _excluded470 = ["color", "size", "className"],
    _excluded471 = ["color", "size", "className"],
    _excluded472 = ["color", "size", "className"],
    _excluded473 = ["color", "size", "className"],
    _excluded474 = ["color", "size", "className"],
    _excluded475 = ["color", "size", "className"],
    _excluded476 = ["color", "size", "className"],
    _excluded477 = ["color", "size", "className"],
    _excluded478 = ["color", "size", "className"],
    _excluded479 = ["color", "size", "className"],
    _excluded480 = ["color", "size", "className"],
    _excluded481 = ["color", "size", "className"],
    _excluded482 = ["color", "size", "className"],
    _excluded483 = ["color", "size", "className"],
    _excluded484 = ["color", "size", "className"],
    _excluded485 = ["color", "size", "className"],
    _excluded486 = ["color", "size", "className"],
    _excluded487 = ["color", "size", "className"],
    _excluded488 = ["color", "size", "className"],
    _excluded489 = ["color", "size", "className"],
    _excluded490 = ["color", "size", "className"],
    _excluded491 = ["color", "size", "className"],
    _excluded492 = ["color", "size", "className"],
    _excluded493 = ["color", "size", "className"],
    _excluded494 = ["color", "size", "className"],
    _excluded495 = ["color", "size", "className"],
    _excluded496 = ["color", "size", "className"],
    _excluded497 = ["color", "size", "className"],
    _excluded498 = ["color", "size", "className"],
    _excluded499 = ["color", "size", "className"],
    _excluded500 = ["color", "size", "className"],
    _excluded501 = ["color", "size", "className"],
    _excluded502 = ["color", "size", "className"],
    _excluded503 = ["color", "size", "className"],
    _excluded504 = ["color", "size", "className"],
    _excluded505 = ["color", "size", "className"],
    _excluded506 = ["color", "size", "className"],
    _excluded507 = ["color", "size", "className"],
    _excluded508 = ["color", "size", "className"],
    _excluded509 = ["color", "size", "className"],
    _excluded510 = ["color", "size", "className"],
    _excluded511 = ["color", "size", "className"],
    _excluded512 = ["color", "size", "className"],
    _excluded513 = ["color", "size", "className"],
    _excluded514 = ["color", "size", "className"],
    _excluded515 = ["color", "size", "className"],
    _excluded516 = ["color", "size", "className"],
    _excluded517 = ["color", "size", "className"],
    _excluded518 = ["color", "size", "className"],
    _excluded519 = ["color", "size", "className"],
    _excluded520 = ["color", "size", "className"],
    _excluded521 = ["color", "size", "className"],
    _excluded522 = ["color", "size", "className"],
    _excluded523 = ["color", "size", "className"],
    _excluded524 = ["color", "size", "className"],
    _excluded525 = ["color", "size", "className"],
    _excluded526 = ["color", "size", "className"],
    _excluded527 = ["color", "size", "className"],
    _excluded528 = ["color", "size", "className"],
    _excluded529 = ["color", "size", "className"],
    _excluded530 = ["color", "size", "className"],
    _excluded531 = ["color", "size", "className"],
    _excluded532 = ["color", "size", "className"],
    _excluded533 = ["color", "size", "className"],
    _excluded534 = ["color", "size", "className"],
    _excluded535 = ["color", "size", "className"],
    _excluded536 = ["color", "size", "className"],
    _excluded537 = ["color", "size", "className"],
    _excluded538 = ["color", "size", "className"],
    _excluded539 = ["color", "size", "className"],
    _excluded540 = ["color", "size", "className"],
    _excluded541 = ["color", "size", "className"],
    _excluded542 = ["color", "size", "className"],
    _excluded543 = ["color", "size", "className"],
    _excluded544 = ["color", "size", "className"],
    _excluded545 = ["color", "size", "className"],
    _excluded546 = ["color", "size", "className"],
    _excluded547 = ["color", "size", "className"],
    _excluded548 = ["color", "size", "className"],
    _excluded549 = ["color", "size", "className"],
    _excluded550 = ["color", "size", "className"],
    _excluded551 = ["color", "size", "className"],
    _excluded552 = ["color", "size", "className"],
    _excluded553 = ["color", "size", "className"],
    _excluded554 = ["color", "size", "className"],
    _excluded555 = ["color", "size", "className"],
    _excluded556 = ["color", "size", "className"],
    _excluded557 = ["color", "size", "className"],
    _excluded558 = ["color", "size", "className"],
    _excluded559 = ["color", "size", "className"],
    _excluded560 = ["color", "size", "className"],
    _excluded561 = ["color", "size", "className"],
    _excluded562 = ["color", "size", "className"],
    _excluded563 = ["color", "size", "className"],
    _excluded564 = ["color", "size", "className"],
    _excluded565 = ["color", "size", "className"],
    _excluded566 = ["color", "size", "className"],
    _excluded567 = ["color", "size", "className"],
    _excluded568 = ["color", "size", "className"],
    _excluded569 = ["color", "size", "className"],
    _excluded570 = ["color", "size", "className"],
    _excluded571 = ["color", "size", "className"],
    _excluded572 = ["color", "size", "className"],
    _excluded573 = ["color", "size", "className"],
    _excluded574 = ["color", "size", "className"],
    _excluded575 = ["color", "size", "className"],
    _excluded576 = ["color", "size", "className"],
    _excluded577 = ["color", "size", "className"],
    _excluded578 = ["color", "size", "className"],
    _excluded579 = ["color", "size", "className"],
    _excluded580 = ["color", "size", "className"],
    _excluded581 = ["color", "size", "className"],
    _excluded582 = ["color", "size", "className"],
    _excluded583 = ["color", "size", "className"],
    _excluded584 = ["color", "size", "className"],
    _excluded585 = ["color", "size", "className"],
    _excluded586 = ["color", "size", "className"],
    _excluded587 = ["color", "size", "className"],
    _excluded588 = ["color", "size", "className"],
    _excluded589 = ["color", "size", "className"],
    _excluded590 = ["color", "size", "className"],
    _excluded591 = ["color", "size", "className"],
    _excluded592 = ["color", "size", "className"],
    _excluded593 = ["color", "size", "className"],
    _excluded594 = ["color", "size", "className"],
    _excluded595 = ["color", "size", "className"],
    _excluded596 = ["color", "size", "className"],
    _excluded597 = ["color", "size", "className"],
    _excluded598 = ["color", "size", "className"],
    _excluded599 = ["color", "size", "className"],
    _excluded600 = ["color", "size", "className"],
    _excluded601 = ["color", "size", "className"],
    _excluded602 = ["color", "size", "className"],
    _excluded603 = ["color", "size", "className"],
    _excluded604 = ["color", "size", "className"],
    _excluded605 = ["color", "size", "className"],
    _excluded606 = ["color", "size", "className"],
    _excluded607 = ["color", "size", "className"],
    _excluded608 = ["color", "size", "className"],
    _excluded609 = ["color", "size", "className"],
    _excluded610 = ["color", "size", "className"],
    _excluded611 = ["color", "size", "className"],
    _excluded612 = ["color", "size", "className"],
    _excluded613 = ["color", "size", "className"],
    _excluded614 = ["color", "size", "className"],
    _excluded615 = ["color", "size", "className"],
    _excluded616 = ["color", "size", "className"],
    _excluded617 = ["color", "size", "className"],
    _excluded618 = ["color", "size", "className"],
    _excluded619 = ["color", "size", "className"],
    _excluded620 = ["color", "size", "className"],
    _excluded621 = ["color", "size", "className"],
    _excluded622 = ["color", "size", "className"],
    _excluded623 = ["color", "size", "className"],
    _excluded624 = ["color", "size", "className"],
    _excluded625 = ["color", "size", "className"],
    _excluded626 = ["color", "size", "className"],
    _excluded627 = ["color", "size", "className"],
    _excluded628 = ["color", "size", "className"],
    _excluded629 = ["color", "size", "className"],
    _excluded630 = ["color", "size", "className"],
    _excluded631 = ["color", "size", "className"],
    _excluded632 = ["color", "size", "className"],
    _excluded633 = ["color", "size", "className"],
    _excluded634 = ["color", "size", "className"],
    _excluded635 = ["color", "size", "className"],
    _excluded636 = ["color", "size", "className"],
    _excluded637 = ["color", "size", "className"],
    _excluded638 = ["color", "size", "className"],
    _excluded639 = ["color", "size", "className"],
    _excluded640 = ["color", "size", "className"],
    _excluded641 = ["color", "size", "className"],
    _excluded642 = ["color", "size", "className"],
    _excluded643 = ["color", "size", "className"],
    _excluded644 = ["color", "size", "className"],
    _excluded645 = ["color", "size", "className"],
    _excluded646 = ["color", "size", "className"],
    _excluded647 = ["color", "size", "className"],
    _excluded648 = ["color", "size", "className"],
    _excluded649 = ["color", "size", "className"],
    _excluded650 = ["color", "size", "className"],
    _excluded651 = ["color", "size", "className"],
    _excluded652 = ["color", "size", "className"],
    _excluded653 = ["color", "size", "className"],
    _excluded654 = ["color", "size", "className"],
    _excluded655 = ["color", "size", "className"],
    _excluded656 = ["color", "size", "className"],
    _excluded657 = ["color", "size", "className"],
    _excluded658 = ["color", "size", "className"],
    _excluded659 = ["color", "size", "className"],
    _excluded660 = ["color", "size", "className"],
    _excluded661 = ["color", "size", "className"],
    _excluded662 = ["color", "size", "className"],
    _excluded663 = ["color", "size", "className"],
    _excluded664 = ["color", "size", "className"],
    _excluded665 = ["color", "size", "className"],
    _excluded666 = ["color", "size", "className"],
    _excluded667 = ["color", "size", "className"],
    _excluded668 = ["color", "size", "className"],
    _excluded669 = ["color", "size", "className"],
    _excluded670 = ["color", "size", "className"],
    _excluded671 = ["color", "size", "className"],
    _excluded672 = ["color", "size", "className"],
    _excluded673 = ["color", "size", "className"],
    _excluded674 = ["color", "size", "className"],
    _excluded675 = ["color", "size", "className"],
    _excluded676 = ["color", "size", "className"],
    _excluded677 = ["color", "size", "className"],
    _excluded678 = ["color", "size", "className"],
    _excluded679 = ["color", "size", "className"],
    _excluded680 = ["color", "size", "className"],
    _excluded681 = ["color", "size", "className"],
    _excluded682 = ["color", "size", "className"],
    _excluded683 = ["color", "size", "className"],
    _excluded684 = ["color", "size", "className"],
    _excluded685 = ["color", "size", "className"],
    _excluded686 = ["color", "size", "className"],
    _excluded687 = ["color", "size", "className"],
    _excluded688 = ["color", "size", "className"],
    _excluded689 = ["color", "size", "className"],
    _excluded690 = ["color", "size", "className"],
    _excluded691 = ["color", "size", "className"],
    _excluded692 = ["color", "size", "className"],
    _excluded693 = ["color", "size", "className"],
    _excluded694 = ["color", "size", "className"],
    _excluded695 = ["color", "size", "className"],
    _excluded696 = ["color", "size", "className"],
    _excluded697 = ["color", "size", "className"],
    _excluded698 = ["color", "size", "className"],
    _excluded699 = ["color", "size", "className"],
    _excluded700 = ["color", "size", "className"],
    _excluded701 = ["color", "size", "className"],
    _excluded702 = ["color", "size", "className"],
    _excluded703 = ["color", "size", "className"],
    _excluded704 = ["color", "size", "className"],
    _excluded705 = ["color", "size", "className"],
    _excluded706 = ["color", "size", "className"],
    _excluded707 = ["color", "size", "className"],
    _excluded708 = ["color", "size", "className"],
    _excluded709 = ["color", "size", "className"],
    _excluded710 = ["color", "size", "className"],
    _excluded711 = ["color", "size", "className"],
    _excluded712 = ["color", "size", "className"],
    _excluded713 = ["color", "size", "className"],
    _excluded714 = ["color", "size", "className"],
    _excluded715 = ["color", "size", "className"],
    _excluded716 = ["color", "size", "className"],
    _excluded717 = ["color", "size", "className"],
    _excluded718 = ["color", "size", "className"],
    _excluded719 = ["color", "size", "className"],
    _excluded720 = ["color", "size", "className"],
    _excluded721 = ["color", "size", "className"],
    _excluded722 = ["color", "size", "className"],
    _excluded723 = ["color", "size", "className"],
    _excluded724 = ["color", "size", "className"],
    _excluded725 = ["color", "size", "className"],
    _excluded726 = ["color", "size", "className"],
    _excluded727 = ["color", "size", "className"],
    _excluded728 = ["color", "size", "className"],
    _excluded729 = ["color", "size", "className"],
    _excluded730 = ["color", "size", "className"],
    _excluded731 = ["color", "size", "className"],
    _excluded732 = ["color", "size", "className"],
    _excluded733 = ["color", "size", "className"],
    _excluded734 = ["color", "size", "className"],
    _excluded735 = ["color", "size", "className"],
    _excluded736 = ["color", "size", "className"],
    _excluded737 = ["color", "size", "className"],
    _excluded738 = ["color", "size", "className"],
    _excluded739 = ["color", "size", "className"],
    _excluded740 = ["color", "size", "className"],
    _excluded741 = ["color", "size", "className"],
    _excluded742 = ["color", "size", "className"],
    _excluded743 = ["color", "size", "className"],
    _excluded744 = ["color", "size", "className"],
    _excluded745 = ["color", "size", "className"],
    _excluded746 = ["color", "size", "className"],
    _excluded747 = ["color", "size", "className"],
    _excluded748 = ["color", "size", "className"],
    _excluded749 = ["color", "size", "className"],
    _excluded750 = ["color", "size", "className"],
    _excluded751 = ["color", "size", "className"],
    _excluded752 = ["color", "size", "className"],
    _excluded753 = ["color", "size", "className"],
    _excluded754 = ["color", "size", "className"],
    _excluded755 = ["color", "size", "className"],
    _excluded756 = ["color", "size", "className"],
    _excluded757 = ["color", "size", "className"],
    _excluded758 = ["color", "size", "className"],
    _excluded759 = ["color", "size", "className"],
    _excluded760 = ["color", "size", "className"],
    _excluded761 = ["color", "size", "className"],
    _excluded762 = ["color", "size", "className"],
    _excluded763 = ["color", "size", "className"],
    _excluded764 = ["color", "size", "className"],
    _excluded765 = ["color", "size", "className"],
    _excluded766 = ["color", "size", "className"],
    _excluded767 = ["color", "size", "className"],
    _excluded768 = ["color", "size", "className"],
    _excluded769 = ["color", "size", "className"],
    _excluded770 = ["color", "size", "className"],
    _excluded771 = ["color", "size", "className"],
    _excluded772 = ["color", "size", "className"],
    _excluded773 = ["color", "size", "className"],
    _excluded774 = ["color", "size", "className"],
    _excluded775 = ["color", "size", "className"],
    _excluded776 = ["color", "size", "className"],
    _excluded777 = ["color", "size", "className"],
    _excluded778 = ["color", "size", "className"],
    _excluded779 = ["color", "size", "className"],
    _excluded780 = ["color", "size", "className"],
    _excluded781 = ["color", "size", "className"],
    _excluded782 = ["color", "size", "className"],
    _excluded783 = ["color", "size", "className"],
    _excluded784 = ["color", "size", "className"],
    _excluded785 = ["color", "size", "className"],
    _excluded786 = ["color", "size", "className"],
    _excluded787 = ["color", "size", "className"],
    _excluded788 = ["color", "size", "className"],
    _excluded789 = ["color", "size", "className"],
    _excluded790 = ["color", "size", "className"],
    _excluded791 = ["color", "size", "className"],
    _excluded792 = ["color", "size", "className"],
    _excluded793 = ["color", "size", "className"],
    _excluded794 = ["color", "size", "className"],
    _excluded795 = ["color", "size", "className"],
    _excluded796 = ["color", "size", "className"],
    _excluded797 = ["color", "size", "className"],
    _excluded798 = ["color", "size", "className"],
    _excluded799 = ["color", "size", "className"],
    _excluded800 = ["color", "size", "className"],
    _excluded801 = ["color", "size", "className"],
    _excluded802 = ["color", "size", "className"],
    _excluded803 = ["color", "size", "className"],
    _excluded804 = ["color", "size", "className"],
    _excluded805 = ["color", "size", "className"],
    _excluded806 = ["color", "size", "className"],
    _excluded807 = ["color", "size", "className"],
    _excluded808 = ["color", "size", "className"],
    _excluded809 = ["color", "size", "className"],
    _excluded810 = ["color", "size", "className"],
    _excluded811 = ["color", "size", "className"],
    _excluded812 = ["color", "size", "className"],
    _excluded813 = ["color", "size", "className"],
    _excluded814 = ["color", "size", "className"],
    _excluded815 = ["color", "size", "className"],
    _excluded816 = ["color", "size", "className"],
    _excluded817 = ["color", "size", "className"],
    _excluded818 = ["color", "size", "className"],
    _excluded819 = ["color", "size", "className"],
    _excluded820 = ["color", "size", "className"],
    _excluded821 = ["color", "size", "className"],
    _excluded822 = ["color", "size", "className"],
    _excluded823 = ["color", "size", "className"],
    _excluded824 = ["color", "size", "className"],
    _excluded825 = ["color", "size", "className"],
    _excluded826 = ["color", "size", "className"],
    _excluded827 = ["color", "size", "className"],
    _excluded828 = ["color", "size", "className"],
    _excluded829 = ["color", "size", "className"],
    _excluded830 = ["color", "size", "className"],
    _excluded831 = ["color", "size", "className"],
    _excluded832 = ["color", "size", "className"],
    _excluded833 = ["color", "size", "className"],
    _excluded834 = ["color", "size", "className"],
    _excluded835 = ["color", "size", "className"],
    _excluded836 = ["color", "size", "className"],
    _excluded837 = ["color", "size", "className"],
    _excluded838 = ["color", "size", "className"],
    _excluded839 = ["color", "size", "className"],
    _excluded840 = ["color", "size", "className"],
    _excluded841 = ["color", "size", "className"],
    _excluded842 = ["color", "size", "className"],
    _excluded843 = ["color", "size", "className"],
    _excluded844 = ["color", "size", "className"],
    _excluded845 = ["color", "size", "className"],
    _excluded846 = ["color", "size", "className"],
    _excluded847 = ["color", "size", "className"],
    _excluded848 = ["color", "size", "className"],
    _excluded849 = ["color", "size", "className"],
    _excluded850 = ["color", "size", "className"],
    _excluded851 = ["color", "size", "className"],
    _excluded852 = ["color", "size", "className"],
    _excluded853 = ["color", "size", "className"],
    _excluded854 = ["color", "size", "className"],
    _excluded855 = ["color", "size", "className"],
    _excluded856 = ["color", "size", "className"],
    _excluded857 = ["color", "size", "className"],
    _excluded858 = ["color", "size", "className"],
    _excluded859 = ["color", "size", "className"],
    _excluded860 = ["color", "size", "className"],
    _excluded861 = ["color", "size", "className"],
    _excluded862 = ["color", "size", "className"],
    _excluded863 = ["color", "size", "className"],
    _excluded864 = ["color", "size", "className"],
    _excluded865 = ["color", "size", "className"],
    _excluded866 = ["color", "size", "className"],
    _excluded867 = ["color", "size", "className"],
    _excluded868 = ["color", "size", "className"],
    _excluded869 = ["color", "size", "className"],
    _excluded870 = ["color", "size", "className"],
    _excluded871 = ["color", "size", "className"],
    _excluded872 = ["color", "size", "className"],
    _excluded873 = ["color", "size", "className"],
    _excluded874 = ["color", "size", "className"],
    _excluded875 = ["color", "size", "className"],
    _excluded876 = ["color", "size", "className"],
    _excluded877 = ["color", "size", "className"],
    _excluded878 = ["color", "size", "className"],
    _excluded879 = ["color", "size", "className"],
    _excluded880 = ["color", "size", "className"],
    _excluded881 = ["color", "size", "className"],
    _excluded882 = ["color", "size", "className"],
    _excluded883 = ["color", "size", "className"],
    _excluded884 = ["color", "size", "className"],
    _excluded885 = ["color", "size", "className"],
    _excluded886 = ["color", "size", "className"],
    _excluded887 = ["color", "size", "className"],
    _excluded888 = ["color", "size", "className"],
    _excluded889 = ["color", "size", "className"],
    _excluded890 = ["color", "size", "className"],
    _excluded891 = ["color", "size", "className"],
    _excluded892 = ["color", "size", "className"],
    _excluded893 = ["color", "size", "className"],
    _excluded894 = ["color", "size", "className"],
    _excluded895 = ["color", "size", "className"],
    _excluded896 = ["color", "size", "className"],
    _excluded897 = ["color", "size", "className"],
    _excluded898 = ["color", "size", "className"],
    _excluded899 = ["color", "size", "className"],
    _excluded900 = ["color", "size", "className"],
    _excluded901 = ["color", "size", "className"],
    _excluded902 = ["color", "size", "className"],
    _excluded903 = ["color", "size", "className"],
    _excluded904 = ["color", "size", "className"],
    _excluded905 = ["color", "size", "className"],
    _excluded906 = ["color", "size", "className"],
    _excluded907 = ["color", "size", "className"],
    _excluded908 = ["color", "size", "className"],
    _excluded909 = ["color", "size", "className"],
    _excluded910 = ["color", "size", "className"],
    _excluded911 = ["color", "size", "className"],
    _excluded912 = ["color", "size", "className"],
    _excluded913 = ["color", "size", "className"],
    _excluded914 = ["color", "size", "className"],
    _excluded915 = ["color", "size", "className"],
    _excluded916 = ["color", "size", "className"],
    _excluded917 = ["color", "size", "className"],
    _excluded918 = ["color", "size", "className"],
    _excluded919 = ["color", "size", "className"],
    _excluded920 = ["color", "size", "className"],
    _excluded921 = ["color", "size", "className"],
    _excluded922 = ["color", "size", "className"],
    _excluded923 = ["color", "size", "className"],
    _excluded924 = ["color", "size", "className"],
    _excluded925 = ["color", "size", "className"],
    _excluded926 = ["color", "size", "className"],
    _excluded927 = ["color", "size", "className"],
    _excluded928 = ["color", "size", "className"],
    _excluded929 = ["color", "size", "className"],
    _excluded930 = ["color", "size", "className"],
    _excluded931 = ["color", "size", "className"],
    _excluded932 = ["color", "size", "className"],
    _excluded933 = ["color", "size", "className"],
    _excluded934 = ["color", "size", "className"],
    _excluded935 = ["color", "size", "className"],
    _excluded936 = ["color", "size", "className"],
    _excluded937 = ["color", "size", "className"],
    _excluded938 = ["color", "size", "className"],
    _excluded939 = ["color", "size", "className"],
    _excluded940 = ["color", "size", "className"],
    _excluded941 = ["color", "size", "className"],
    _excluded942 = ["color", "size", "className"],
    _excluded943 = ["color", "size", "className"],
    _excluded944 = ["color", "size", "className"],
    _excluded945 = ["color", "size", "className"],
    _excluded946 = ["color", "size", "className"],
    _excluded947 = ["color", "size", "className"],
    _excluded948 = ["color", "size", "className"],
    _excluded949 = ["color", "size", "className"],
    _excluded950 = ["color", "size", "className"],
    _excluded951 = ["color", "size", "className"],
    _excluded952 = ["color", "size", "className"],
    _excluded953 = ["color", "size", "className"],
    _excluded954 = ["color", "size", "className"],
    _excluded955 = ["color", "size", "className"],
    _excluded956 = ["color", "size", "className"],
    _excluded957 = ["color", "size", "className"],
    _excluded958 = ["color", "size", "className"],
    _excluded959 = ["color", "size", "className"],
    _excluded960 = ["color", "size", "className"],
    _excluded961 = ["color", "size", "className"],
    _excluded962 = ["color", "size", "className"],
    _excluded963 = ["color", "size", "className"],
    _excluded964 = ["color", "size", "className"],
    _excluded965 = ["color", "size", "className"],
    _excluded966 = ["color", "size", "className"],
    _excluded967 = ["color", "size", "className"],
    _excluded968 = ["color", "size", "className"],
    _excluded969 = ["color", "size", "className"],
    _excluded970 = ["color", "size", "className"],
    _excluded971 = ["color", "size", "className"],
    _excluded972 = ["color", "size", "className"],
    _excluded973 = ["color", "size", "className"],
    _excluded974 = ["color", "size", "className"],
    _excluded975 = ["color", "size", "className"],
    _excluded976 = ["color", "size", "className"],
    _excluded977 = ["color", "size", "className"],
    _excluded978 = ["color", "size", "className"],
    _excluded979 = ["color", "size", "className"],
    _excluded980 = ["color", "size", "className"],
    _excluded981 = ["color", "size", "className"],
    _excluded982 = ["color", "size", "className"],
    _excluded983 = ["color", "size", "className"],
    _excluded984 = ["color", "size", "className"],
    _excluded985 = ["color", "size", "className"],
    _excluded986 = ["color", "size", "className"],
    _excluded987 = ["color", "size", "className"],
    _excluded988 = ["color", "size", "className"],
    _excluded989 = ["color", "size", "className"],
    _excluded990 = ["color", "size", "className"],
    _excluded991 = ["color", "size", "className"],
    _excluded992 = ["color", "size", "className"],
    _excluded993 = ["color", "size", "className"],
    _excluded994 = ["color", "size", "className"],
    _excluded995 = ["color", "size", "className"],
    _excluded996 = ["color", "size", "className"],
    _excluded997 = ["color", "size", "className"],
    _excluded998 = ["color", "size", "className"],
    _excluded999 = ["color", "size", "className"],
    _excluded1000 = ["color", "size", "className"],
    _excluded1001 = ["color", "size", "className"],
    _excluded1002 = ["color", "size", "className"],
    _excluded1003 = ["color", "size", "className"],
    _excluded1004 = ["color", "size", "className"],
    _excluded1005 = ["color", "size", "className"],
    _excluded1006 = ["color", "size", "className"],
    _excluded1007 = ["color", "size", "className"],
    _excluded1008 = ["color", "size", "className"],
    _excluded1009 = ["color", "size", "className"],
    _excluded1010 = ["color", "size", "className"],
    _excluded1011 = ["color", "size", "className"],
    _excluded1012 = ["color", "size", "className"],
    _excluded1013 = ["color", "size", "className"],
    _excluded1014 = ["color", "size", "className"],
    _excluded1015 = ["color", "size", "className"],
    _excluded1016 = ["color", "size", "className"],
    _excluded1017 = ["color", "size", "className"],
    _excluded1018 = ["color", "size", "className"],
    _excluded1019 = ["color", "size", "className"],
    _excluded1020 = ["color", "size", "className"],
    _excluded1021 = ["color", "size", "className"],
    _excluded1022 = ["color", "size", "className"],
    _excluded1023 = ["color", "size", "className"],
    _excluded1024 = ["color", "size", "className"],
    _excluded1025 = ["color", "size", "className"],
    _excluded1026 = ["color", "size", "className"],
    _excluded1027 = ["color", "size", "className"],
    _excluded1028 = ["color", "size", "className"],
    _excluded1029 = ["color", "size", "className"],
    _excluded1030 = ["color", "size", "className"],
    _excluded1031 = ["color", "size", "className"],
    _excluded1032 = ["color", "size", "className"],
    _excluded1033 = ["color", "size", "className"],
    _excluded1034 = ["color", "size", "className"],
    _excluded1035 = ["color", "size", "className"],
    _excluded1036 = ["color", "size", "className"],
    _excluded1037 = ["color", "size", "className"],
    _excluded1038 = ["color", "size", "className"],
    _excluded1039 = ["color", "size", "className"],
    _excluded1040 = ["color", "size", "className"],
    _excluded1041 = ["color", "size", "className"],
    _excluded1042 = ["color", "size", "className"],
    _excluded1043 = ["color", "size", "className"],
    _excluded1044 = ["color", "size", "className"],
    _excluded1045 = ["color", "size", "className"],
    _excluded1046 = ["color", "size", "className"],
    _excluded1047 = ["color", "size", "className"],
    _excluded1048 = ["color", "size", "className"],
    _excluded1049 = ["color", "size", "className"],
    _excluded1050 = ["color", "size", "className"],
    _excluded1051 = ["color", "size", "className"],
    _excluded1052 = ["color", "size", "className"],
    _excluded1053 = ["color", "size", "className"],
    _excluded1054 = ["color", "size", "className"],
    _excluded1055 = ["color", "size", "className"],
    _excluded1056 = ["color", "size", "className"],
    _excluded1057 = ["color", "size", "className"],
    _excluded1058 = ["color", "size", "className"],
    _excluded1059 = ["color", "size", "className"],
    _excluded1060 = ["color", "size", "className"],
    _excluded1061 = ["color", "size", "className"],
    _excluded1062 = ["color", "size", "className"],
    _excluded1063 = ["color", "size", "className"],
    _excluded1064 = ["color", "size", "className"],
    _excluded1065 = ["color", "size", "className"],
    _excluded1066 = ["color", "size", "className"],
    _excluded1067 = ["color", "size", "className"],
    _excluded1068 = ["color", "size", "className"],
    _excluded1069 = ["color", "size", "className"],
    _excluded1070 = ["color", "size", "className"],
    _excluded1071 = ["color", "size", "className"],
    _excluded1072 = ["color", "size", "className"],
    _excluded1073 = ["color", "size", "className"],
    _excluded1074 = ["color", "size", "className"],
    _excluded1075 = ["color", "size", "className"],
    _excluded1076 = ["color", "size", "className"],
    _excluded1077 = ["color", "size", "className"],
    _excluded1078 = ["color", "size", "className"],
    _excluded1079 = ["color", "size", "className"],
    _excluded1080 = ["color", "size", "className"],
    _excluded1081 = ["color", "size", "className"],
    _excluded1082 = ["color", "size", "className"],
    _excluded1083 = ["color", "size", "className"],
    _excluded1084 = ["color", "size", "className"],
    _excluded1085 = ["color", "size", "className"],
    _excluded1086 = ["color", "size", "className"],
    _excluded1087 = ["color", "size", "className"],
    _excluded1088 = ["color", "size", "className"],
    _excluded1089 = ["color", "size", "className"],
    _excluded1090 = ["color", "size", "className"],
    _excluded1091 = ["color", "size", "className"],
    _excluded1092 = ["color", "size", "className"],
    _excluded1093 = ["color", "size", "className"],
    _excluded1094 = ["color", "size", "className"],
    _excluded1095 = ["color", "size", "className"],
    _excluded1096 = ["color", "size", "className"],
    _excluded1097 = ["color", "size", "className"],
    _excluded1098 = ["color", "size", "className"],
    _excluded1099 = ["color", "size", "className"],
    _excluded1100 = ["color", "size", "className"],
    _excluded1101 = ["color", "size", "className"],
    _excluded1102 = ["color", "size", "className"],
    _excluded1103 = ["color", "size", "className"],
    _excluded1104 = ["color", "size", "className"],
    _excluded1105 = ["color", "size", "className"],
    _excluded1106 = ["color", "size", "className"],
    _excluded1107 = ["color", "size", "className"],
    _excluded1108 = ["color", "size", "className"],
    _excluded1109 = ["color", "size", "className"],
    _excluded1110 = ["color", "size", "className"],
    _excluded1111 = ["color", "size", "className"],
    _excluded1112 = ["color", "size", "className"],
    _excluded1113 = ["color", "size", "className"],
    _excluded1114 = ["color", "size", "className"],
    _excluded1115 = ["color", "size", "className"],
    _excluded1116 = ["color", "size", "className"],
    _excluded1117 = ["color", "size", "className"],
    _excluded1118 = ["color", "size", "className"],
    _excluded1119 = ["color", "size", "className"],
    _excluded1120 = ["color", "size", "className"],
    _excluded1121 = ["color", "size", "className"],
    _excluded1122 = ["color", "size", "className"],
    _excluded1123 = ["color", "size", "className"],
    _excluded1124 = ["color", "size", "className"],
    _excluded1125 = ["color", "size", "className"],
    _excluded1126 = ["color", "size", "className"],
    _excluded1127 = ["color", "size", "className"],
    _excluded1128 = ["color", "size", "className"],
    _excluded1129 = ["color", "size", "className"],
    _excluded1130 = ["color", "size", "className"],
    _excluded1131 = ["color", "size", "className"],
    _excluded1132 = ["color", "size", "className"],
    _excluded1133 = ["color", "size", "className"],
    _excluded1134 = ["color", "size", "className"],
    _excluded1135 = ["color", "size", "className"],
    _excluded1136 = ["color", "size", "className"],
    _excluded1137 = ["color", "size", "className"],
    _excluded1138 = ["color", "size", "className"],
    _excluded1139 = ["color", "size", "className"],
    _excluded1140 = ["color", "size", "className"],
    _excluded1141 = ["color", "size", "className"],
    _excluded1142 = ["color", "size", "className"],
    _excluded1143 = ["color", "size", "className"],
    _excluded1144 = ["color", "size", "className"],
    _excluded1145 = ["color", "size", "className"],
    _excluded1146 = ["color", "size", "className"],
    _excluded1147 = ["color", "size", "className"],
    _excluded1148 = ["color", "size", "className"],
    _excluded1149 = ["color", "size", "className"],
    _excluded1150 = ["color", "size", "className"],
    _excluded1151 = ["color", "size", "className"],
    _excluded1152 = ["color", "size", "className"],
    _excluded1153 = ["color", "size", "className"],
    _excluded1154 = ["color", "size", "className"],
    _excluded1155 = ["color", "size", "className"],
    _excluded1156 = ["color", "size", "className"],
    _excluded1157 = ["color", "size", "className"],
    _excluded1158 = ["color", "size", "className"],
    _excluded1159 = ["color", "size", "className"],
    _excluded1160 = ["color", "size", "className"],
    _excluded1161 = ["color", "size", "className"],
    _excluded1162 = ["color", "size", "className"],
    _excluded1163 = ["color", "size", "className"],
    _excluded1164 = ["color", "size", "className"],
    _excluded1165 = ["color", "size", "className"],
    _excluded1166 = ["color", "size", "className"],
    _excluded1167 = ["color", "size", "className"],
    _excluded1168 = ["color", "size", "className"],
    _excluded1169 = ["color", "size", "className"],
    _excluded1170 = ["color", "size", "className"],
    _excluded1171 = ["color", "size", "className"],
    _excluded1172 = ["color", "size", "className"],
    _excluded1173 = ["color", "size", "className"],
    _excluded1174 = ["color", "size", "className"],
    _excluded1175 = ["color", "size", "className"],
    _excluded1176 = ["color", "size", "className"],
    _excluded1177 = ["color", "size", "className"],
    _excluded1178 = ["color", "size", "className"],
    _excluded1179 = ["color", "size", "className"],
    _excluded1180 = ["color", "size", "className"],
    _excluded1181 = ["color", "size", "className"],
    _excluded1182 = ["color", "size", "className"],
    _excluded1183 = ["color", "size", "className"],
    _excluded1184 = ["color", "size", "className"],
    _excluded1185 = ["color", "size", "className"],
    _excluded1186 = ["color", "size", "className"],
    _excluded1187 = ["color", "size", "className"],
    _excluded1188 = ["color", "size", "className"],
    _excluded1189 = ["color", "size", "className"],
    _excluded1190 = ["color", "size", "className"],
    _excluded1191 = ["color", "size", "className"],
    _excluded1192 = ["color", "size", "className"],
    _excluded1193 = ["color", "size", "className"],
    _excluded1194 = ["color", "size", "className"],
    _excluded1195 = ["color", "size", "className"],
    _excluded1196 = ["color", "size", "className"],
    _excluded1197 = ["color", "size", "className"],
    _excluded1198 = ["color", "size", "className"],
    _excluded1199 = ["color", "size", "className"],
    _excluded1200 = ["color", "size", "className"],
    _excluded1201 = ["color", "size", "className"],
    _excluded1202 = ["color", "size", "className"],
    _excluded1203 = ["color", "size", "className"],
    _excluded1204 = ["color", "size", "className"],
    _excluded1205 = ["color", "size", "className"],
    _excluded1206 = ["color", "size", "className"],
    _excluded1207 = ["color", "size", "className"],
    _excluded1208 = ["color", "size", "className"],
    _excluded1209 = ["color", "size", "className"],
    _excluded1210 = ["color", "size", "className"],
    _excluded1211 = ["color", "size", "className"],
    _excluded1212 = ["color", "size", "className"],
    _excluded1213 = ["color", "size", "className"],
    _excluded1214 = ["color", "size", "className"],
    _excluded1215 = ["color", "size", "className"],
    _excluded1216 = ["color", "size", "className"],
    _excluded1217 = ["color", "size", "className"],
    _excluded1218 = ["color", "size", "className"],
    _excluded1219 = ["color", "size", "className"],
    _excluded1220 = ["color", "size", "className"],
    _excluded1221 = ["color", "size", "className"],
    _excluded1222 = ["color", "size", "className"],
    _excluded1223 = ["color", "size", "className"],
    _excluded1224 = ["color", "size", "className"],
    _excluded1225 = ["color", "size", "className"],
    _excluded1226 = ["color", "size", "className"],
    _excluded1227 = ["color", "size", "className"],
    _excluded1228 = ["color", "size", "className"],
    _excluded1229 = ["color", "size", "className"],
    _excluded1230 = ["color", "size", "className"],
    _excluded1231 = ["color", "size", "className"],
    _excluded1232 = ["color", "size", "className"],
    _excluded1233 = ["color", "size", "className"],
    _excluded1234 = ["color", "size", "className"],
    _excluded1235 = ["color", "size", "className"],
    _excluded1236 = ["color", "size", "className"],
    _excluded1237 = ["color", "size", "className"],
    _excluded1238 = ["color", "size", "className"],
    _excluded1239 = ["color", "size", "className"],
    _excluded1240 = ["color", "size", "className"],
    _excluded1241 = ["color", "size", "className"],
    _excluded1242 = ["color", "size", "className"],
    _excluded1243 = ["color", "size", "className"],
    _excluded1244 = ["color", "size", "className"],
    _excluded1245 = ["color", "size", "className"],
    _excluded1246 = ["color", "size", "className"],
    _excluded1247 = ["color", "size", "className"],
    _excluded1248 = ["color", "size", "className"],
    _excluded1249 = ["color", "size", "className"],
    _excluded1250 = ["color", "size", "className"],
    _excluded1251 = ["color", "size", "className"],
    _excluded1252 = ["color", "size", "className"],
    _excluded1253 = ["color", "size", "className"],
    _excluded1254 = ["color", "size", "className"],
    _excluded1255 = ["color", "size", "className"],
    _excluded1256 = ["color", "size", "className"],
    _excluded1257 = ["color", "size", "className"],
    _excluded1258 = ["color", "size", "className"],
    _excluded1259 = ["color", "size", "className"],
    _excluded1260 = ["color", "size", "className"],
    _excluded1261 = ["color", "size", "className"],
    _excluded1262 = ["color", "size", "className"],
    _excluded1263 = ["color", "size", "className"],
    _excluded1264 = ["color", "size", "className"],
    _excluded1265 = ["color", "size", "className"],
    _excluded1266 = ["color", "size", "className"],
    _excluded1267 = ["color", "size", "className"],
    _excluded1268 = ["color", "size", "className"],
    _excluded1269 = ["color", "size", "className"],
    _excluded1270 = ["color", "size", "className"],
    _excluded1271 = ["color", "size", "className"],
    _excluded1272 = ["color", "size", "className"],
    _excluded1273 = ["color", "size", "className"],
    _excluded1274 = ["color", "size", "className"],
    _excluded1275 = ["color", "size", "className"],
    _excluded1276 = ["color", "size", "className"],
    _excluded1277 = ["color", "size", "className"],
    _excluded1278 = ["color", "size", "className"],
    _excluded1279 = ["color", "size", "className"],
    _excluded1280 = ["color", "size", "className"],
    _excluded1281 = ["color", "size", "className"],
    _excluded1282 = ["color", "size", "className"],
    _excluded1283 = ["color", "size", "className"],
    _excluded1284 = ["color", "size", "className"],
    _excluded1285 = ["color", "size", "className"],
    _excluded1286 = ["color", "size", "className"],
    _excluded1287 = ["color", "size", "className"],
    _excluded1288 = ["color", "size", "className"],
    _excluded1289 = ["color", "size", "className"],
    _excluded1290 = ["color", "size", "className"],
    _excluded1291 = ["color", "size", "className"],
    _excluded1292 = ["color", "size", "className"],
    _excluded1293 = ["color", "size", "className"],
    _excluded1294 = ["color", "size", "className"],
    _excluded1295 = ["color", "size", "className"],
    _excluded1296 = ["color", "size", "className"],
    _excluded1297 = ["color", "size", "className"],
    _excluded1298 = ["color", "size", "className"],
    _excluded1299 = ["color", "size", "className"],
    _excluded1300 = ["color", "size", "className"],
    _excluded1301 = ["color", "size", "className"],
    _excluded1302 = ["color", "size", "className"],
    _excluded1303 = ["color", "size", "className"],
    _excluded1304 = ["color", "size", "className"],
    _excluded1305 = ["color", "size", "className"],
    _excluded1306 = ["color", "size", "className"],
    _excluded1307 = ["color", "size", "className"],
    _excluded1308 = ["color", "size", "className"],
    _excluded1309 = ["color", "size", "className"],
    _excluded1310 = ["color", "size", "className"],
    _excluded1311 = ["color", "size", "className"],
    _excluded1312 = ["color", "size", "className"],
    _excluded1313 = ["color", "size", "className"],
    _excluded1314 = ["color", "size", "className"],
    _excluded1315 = ["color", "size", "className"],
    _excluded1316 = ["color", "size", "className"],
    _excluded1317 = ["color", "size", "className"],
    _excluded1318 = ["color", "size", "className"],
    _excluded1319 = ["color", "size", "className"],
    _excluded1320 = ["color", "size", "className"],
    _excluded1321 = ["color", "size", "className"],
    _excluded1322 = ["color", "size", "className"],
    _excluded1323 = ["color", "size", "className"],
    _excluded1324 = ["color", "size", "className"],
    _excluded1325 = ["color", "size", "className"],
    _excluded1326 = ["color", "size", "className"],
    _excluded1327 = ["color", "size", "className"],
    _excluded1328 = ["color", "size", "className"],
    _excluded1329 = ["color", "size", "className"],
    _excluded1330 = ["color", "size", "className"],
    _excluded1331 = ["color", "size", "className"],
    _excluded1332 = ["color", "size", "className"],
    _excluded1333 = ["color", "size", "className"],
    _excluded1334 = ["color", "size", "className"],
    _excluded1335 = ["color", "size", "className"],
    _excluded1336 = ["color", "size", "className"],
    _excluded1337 = ["color", "size", "className"],
    _excluded1338 = ["color", "size", "className"],
    _excluded1339 = ["color", "size", "className"],
    _excluded1340 = ["color", "size", "className"],
    _excluded1341 = ["color", "size", "className"],
    _excluded1342 = ["color", "size", "className"],
    _excluded1343 = ["color", "size", "className"],
    _excluded1344 = ["color", "size", "className"],
    _excluded1345 = ["color", "size", "className"],
    _excluded1346 = ["color", "size", "className"],
    _excluded1347 = ["color", "size", "className"],
    _excluded1348 = ["color", "size", "className"],
    _excluded1349 = ["color", "size", "className"],
    _excluded1350 = ["color", "size", "className"],
    _excluded1351 = ["color", "size", "className"],
    _excluded1352 = ["color", "size", "className"],
    _excluded1353 = ["color", "size", "className"],
    _excluded1354 = ["color", "size", "className"],
    _excluded1355 = ["color", "size", "className"],
    _excluded1356 = ["color", "size", "className"],
    _excluded1357 = ["color", "size", "className"],
    _excluded1358 = ["color", "size", "className"],
    _excluded1359 = ["color", "size", "className"],
    _excluded1360 = ["color", "size", "className"],
    _excluded1361 = ["color", "size", "className"],
    _excluded1362 = ["color", "size", "className"],
    _excluded1363 = ["color", "size", "className"],
    _excluded1364 = ["color", "size", "className"],
    _excluded1365 = ["color", "size", "className"],
    _excluded1366 = ["color", "size", "className"],
    _excluded1367 = ["color", "size", "className"],
    _excluded1368 = ["color", "size", "className"],
    _excluded1369 = ["color", "size", "className"],
    _excluded1370 = ["color", "size", "className"],
    _excluded1371 = ["color", "size", "className"],
    _excluded1372 = ["color", "size", "className"],
    _excluded1373 = ["color", "size", "className"],
    _excluded1374 = ["color", "size", "className"],
    _excluded1375 = ["color", "size", "className"],
    _excluded1376 = ["color", "size", "className"],
    _excluded1377 = ["color", "size", "className"],
    _excluded1378 = ["color", "size", "className"],
    _excluded1379 = ["color", "size", "className"],
    _excluded1380 = ["color", "size", "className"],
    _excluded1381 = ["color", "size", "className"],
    _excluded1382 = ["color", "size", "className"],
    _excluded1383 = ["color", "size", "className"],
    _excluded1384 = ["color", "size", "className"],
    _excluded1385 = ["color", "size", "className"],
    _excluded1386 = ["color", "size", "className"],
    _excluded1387 = ["color", "size", "className"],
    _excluded1388 = ["color", "size", "className"],
    _excluded1389 = ["color", "size", "className"],
    _excluded1390 = ["color", "size", "className"],
    _excluded1391 = ["color", "size", "className"],
    _excluded1392 = ["color", "size", "className"],
    _excluded1393 = ["color", "size", "className"],
    _excluded1394 = ["color", "size", "className"],
    _excluded1395 = ["color", "size", "className"],
    _excluded1396 = ["color", "size", "className"],
    _excluded1397 = ["color", "size", "className"],
    _excluded1398 = ["color", "size", "className"],
    _excluded1399 = ["color", "size", "className"],
    _excluded1400 = ["color", "size", "className"],
    _excluded1401 = ["color", "size", "className"],
    _excluded1402 = ["color", "size", "className"],
    _excluded1403 = ["color", "size", "className"],
    _excluded1404 = ["color", "size", "className"],
    _excluded1405 = ["color", "size", "className"],
    _excluded1406 = ["color", "size", "className"],
    _excluded1407 = ["color", "size", "className"],
    _excluded1408 = ["color", "size", "className"],
    _excluded1409 = ["color", "size", "className"],
    _excluded1410 = ["color", "size", "className"],
    _excluded1411 = ["color", "size", "className"],
    _excluded1412 = ["color", "size", "className"],
    _excluded1413 = ["color", "size", "className"],
    _excluded1414 = ["color", "size", "className"],
    _excluded1415 = ["color", "size", "className"],
    _excluded1416 = ["color", "size", "className"],
    _excluded1417 = ["color", "size", "className"],
    _excluded1418 = ["color", "size", "className"],
    _excluded1419 = ["color", "size", "className"],
    _excluded1420 = ["color", "size", "className"],
    _excluded1421 = ["color", "size", "className"],
    _excluded1422 = ["color", "size", "className"],
    _excluded1423 = ["color", "size", "className"],
    _excluded1424 = ["color", "size", "className"],
    _excluded1425 = ["color", "size", "className"],
    _excluded1426 = ["color", "size", "className"],
    _excluded1427 = ["color", "size", "className"],
    _excluded1428 = ["color", "size", "className"],
    _excluded1429 = ["color", "size", "className"],
    _excluded1430 = ["color", "size", "className"],
    _excluded1431 = ["color", "size", "className"],
    _excluded1432 = ["color", "size", "className"],
    _excluded1433 = ["color", "size", "className"],
    _excluded1434 = ["color", "size", "className"],
    _excluded1435 = ["color", "size", "className"],
    _excluded1436 = ["color", "size", "className"],
    _excluded1437 = ["color", "size", "className"],
    _excluded1438 = ["color", "size", "className"],
    _excluded1439 = ["color", "size", "className"],
    _excluded1440 = ["color", "size", "className"],
    _excluded1441 = ["color", "size", "className"],
    _excluded1442 = ["color", "size", "className"],
    _excluded1443 = ["color", "size", "className"],
    _excluded1444 = ["color", "size", "className"],
    _excluded1445 = ["color", "size", "className"],
    _excluded1446 = ["color", "size", "className"],
    _excluded1447 = ["color", "size", "className"],
    _excluded1448 = ["color", "size", "className"],
    _excluded1449 = ["color", "size", "className"],
    _excluded1450 = ["color", "size", "className"],
    _excluded1451 = ["color", "size", "className"],
    _excluded1452 = ["color", "size", "className"],
    _excluded1453 = ["color", "size", "className"],
    _excluded1454 = ["color", "size", "className"],
    _excluded1455 = ["color", "size", "className"],
    _excluded1456 = ["color", "size", "className"],
    _excluded1457 = ["color", "size", "className"],
    _excluded1458 = ["color", "size", "className"],
    _excluded1459 = ["color", "size", "className"],
    _excluded1460 = ["color", "size", "className"],
    _excluded1461 = ["color", "size", "className"],
    _excluded1462 = ["color", "size", "className"],
    _excluded1463 = ["color", "size", "className"],
    _excluded1464 = ["color", "size", "className"],
    _excluded1465 = ["color", "size", "className"],
    _excluded1466 = ["color", "size", "className"],
    _excluded1467 = ["color", "size", "className"],
    _excluded1468 = ["color", "size", "className"],
    _excluded1469 = ["color", "size", "className"],
    _excluded1470 = ["color", "size", "className"],
    _excluded1471 = ["color", "size", "className"],
    _excluded1472 = ["color", "size", "className"],
    _excluded1473 = ["color", "size", "className"],
    _excluded1474 = ["color", "size", "className"],
    _excluded1475 = ["color", "size", "className"],
    _excluded1476 = ["color", "size", "className"],
    _excluded1477 = ["color", "size", "className"],
    _excluded1478 = ["color", "size", "className"],
    _excluded1479 = ["color", "size", "className"],
    _excluded1480 = ["color", "size", "className"],
    _excluded1481 = ["color", "size", "className"],
    _excluded1482 = ["color", "size", "className"],
    _excluded1483 = ["color", "size", "className"],
    _excluded1484 = ["color", "size", "className"],
    _excluded1485 = ["color", "size", "className"],
    _excluded1486 = ["color", "size", "className"],
    _excluded1487 = ["color", "size", "className"],
    _excluded1488 = ["color", "size", "className"],
    _excluded1489 = ["color", "size", "className"],
    _excluded1490 = ["color", "size", "className"],
    _excluded1491 = ["color", "size", "className"],
    _excluded1492 = ["color", "size", "className"],
    _excluded1493 = ["color", "size", "className"],
    _excluded1494 = ["color", "size", "className"],
    _excluded1495 = ["color", "size", "className"],
    _excluded1496 = ["color", "size", "className"],
    _excluded1497 = ["color", "size", "className"],
    _excluded1498 = ["color", "size", "className"],
    _excluded1499 = ["color", "size", "className"],
    _excluded1500 = ["color", "size", "className"],
    _excluded1501 = ["color", "size", "className"],
    _excluded1502 = ["color", "size", "className"],
    _excluded1503 = ["color", "size", "className"],
    _excluded1504 = ["color", "size", "className"],
    _excluded1505 = ["color", "size", "className"],
    _excluded1506 = ["color", "size", "className"],
    _excluded1507 = ["color", "size", "className"],
    _excluded1508 = ["color", "size", "className"],
    _excluded1509 = ["color", "size", "className"],
    _excluded1510 = ["color", "size", "className"],
    _excluded1511 = ["color", "size", "className"],
    _excluded1512 = ["color", "size", "className"],
    _excluded1513 = ["color", "size", "className"],
    _excluded1514 = ["color", "size", "className"],
    _excluded1515 = ["color", "size", "className"],
    _excluded1516 = ["color", "size", "className"],
    _excluded1517 = ["color", "size", "className"],
    _excluded1518 = ["color", "size", "className"],
    _excluded1519 = ["color", "size", "className"],
    _excluded1520 = ["color", "size", "className"],
    _excluded1521 = ["color", "size", "className"],
    _excluded1522 = ["color", "size", "className"],
    _excluded1523 = ["color", "size", "className"],
    _excluded1524 = ["color", "size", "className"],
    _excluded1525 = ["color", "size", "className"],
    _excluded1526 = ["color", "size", "className"],
    _excluded1527 = ["color", "size", "className"],
    _excluded1528 = ["color", "size", "className"],
    _excluded1529 = ["color", "size", "className"],
    _excluded1530 = ["color", "size", "className"],
    _excluded1531 = ["color", "size", "className"],
    _excluded1532 = ["color", "size", "className"],
    _excluded1533 = ["color", "size", "className"],
    _excluded1534 = ["color", "size", "className"],
    _excluded1535 = ["color", "size", "className"],
    _excluded1536 = ["color", "size", "className"],
    _excluded1537 = ["color", "size", "className"],
    _excluded1538 = ["color", "size", "className"],
    _excluded1539 = ["color", "size", "className"],
    _excluded1540 = ["color", "size", "className"],
    _excluded1541 = ["color", "size", "className"],
    _excluded1542 = ["color", "size", "className"],
    _excluded1543 = ["color", "size", "className"],
    _excluded1544 = ["color", "size", "className"],
    _excluded1545 = ["color", "size", "className"],
    _excluded1546 = ["color", "size", "className"],
    _excluded1547 = ["color", "size", "className"],
    _excluded1548 = ["color", "size", "className"],
    _excluded1549 = ["color", "size", "className"],
    _excluded1550 = ["color", "size", "className"],
    _excluded1551 = ["color", "size", "className"],
    _excluded1552 = ["color", "size", "className"],
    _excluded1553 = ["color", "size", "className"],
    _excluded1554 = ["color", "size", "className"],
    _excluded1555 = ["color", "size", "className"],
    _excluded1556 = ["color", "size", "className"],
    _excluded1557 = ["color", "size", "className"],
    _excluded1558 = ["color", "size", "className"],
    _excluded1559 = ["color", "size", "className"],
    _excluded1560 = ["color", "size", "className"],
    _excluded1561 = ["color", "size", "className"],
    _excluded1562 = ["color", "size", "className"],
    _excluded1563 = ["color", "size", "className"],
    _excluded1564 = ["color", "size", "className"],
    _excluded1565 = ["color", "size", "className"],
    _excluded1566 = ["color", "size", "className"],
    _excluded1567 = ["color", "size", "className"],
    _excluded1568 = ["color", "size", "className"],
    _excluded1569 = ["color", "size", "className"],
    _excluded1570 = ["color", "size", "className"],
    _excluded1571 = ["color", "size", "className"],
    _excluded1572 = ["color", "size", "className"],
    _excluded1573 = ["color", "size", "className"],
    _excluded1574 = ["color", "size", "className"],
    _excluded1575 = ["color", "size", "className"],
    _excluded1576 = ["color", "size", "className"],
    _excluded1577 = ["color", "size", "className"],
    _excluded1578 = ["color", "size", "className"],
    _excluded1579 = ["color", "size", "className"],
    _excluded1580 = ["color", "size", "className"],
    _excluded1581 = ["color", "size", "className"],
    _excluded1582 = ["color", "size", "className"],
    _excluded1583 = ["color", "size", "className"],
    _excluded1584 = ["color", "size", "className"],
    _excluded1585 = ["color", "size", "className"],
    _excluded1586 = ["color", "size", "className"],
    _excluded1587 = ["color", "size", "className"],
    _excluded1588 = ["color", "size", "className"],
    _excluded1589 = ["color", "size", "className"],
    _excluded1590 = ["color", "size", "className"],
    _excluded1591 = ["color", "size", "className"],
    _excluded1592 = ["color", "size", "className"],
    _excluded1593 = ["color", "size", "className"],
    _excluded1594 = ["color", "size", "className"],
    _excluded1595 = ["color", "size", "className"],
    _excluded1596 = ["color", "size", "className"],
    _excluded1597 = ["color", "size", "className"],
    _excluded1598 = ["color", "size", "className"],
    _excluded1599 = ["color", "size", "className"],
    _excluded1600 = ["color", "size", "className"],
    _excluded1601 = ["color", "size", "className"],
    _excluded1602 = ["color", "size", "className"],
    _excluded1603 = ["color", "size", "className"],
    _excluded1604 = ["color", "size", "className"],
    _excluded1605 = ["color", "size", "className"],
    _excluded1606 = ["color", "size", "className"],
    _excluded1607 = ["color", "size", "className"],
    _excluded1608 = ["color", "size", "className"],
    _excluded1609 = ["color", "size", "className"],
    _excluded1610 = ["color", "size", "className"],
    _excluded1611 = ["color", "size", "className"],
    _excluded1612 = ["color", "size", "className"],
    _excluded1613 = ["color", "size", "className"],
    _excluded1614 = ["color", "size", "className"],
    _excluded1615 = ["color", "size", "className"],
    _excluded1616 = ["color", "size", "className"],
    _excluded1617 = ["color", "size", "className"],
    _excluded1618 = ["color", "size", "className"],
    _excluded1619 = ["color", "size", "className"],
    _excluded1620 = ["color", "size", "className"],
    _excluded1621 = ["color", "size", "className"],
    _excluded1622 = ["color", "size", "className"],
    _excluded1623 = ["color", "size", "className"],
    _excluded1624 = ["color", "size", "className"],
    _excluded1625 = ["color", "size", "className"],
    _excluded1626 = ["color", "size", "className"],
    _excluded1627 = ["color", "size", "className"],
    _excluded1628 = ["color", "size", "className"],
    _excluded1629 = ["color", "size", "className"],
    _excluded1630 = ["color", "size", "className"],
    _excluded1631 = ["color", "size", "className"],
    _excluded1632 = ["color", "size", "className"],
    _excluded1633 = ["color", "size", "className"],
    _excluded1634 = ["color", "size", "className"],
    _excluded1635 = ["color", "size", "className"],
    _excluded1636 = ["color", "size", "className"],
    _excluded1637 = ["color", "size", "className"],
    _excluded1638 = ["color", "size", "className"],
    _excluded1639 = ["color", "size", "className"],
    _excluded1640 = ["color", "size", "className"],
    _excluded1641 = ["color", "size", "className"],
    _excluded1642 = ["color", "size", "className"],
    _excluded1643 = ["color", "size", "className"],
    _excluded1644 = ["color", "size", "className"],
    _excluded1645 = ["color", "size", "className"],
    _excluded1646 = ["color", "size", "className"],
    _excluded1647 = ["color", "size", "className"],
    _excluded1648 = ["color", "size", "className"],
    _excluded1649 = ["color", "size", "className"],
    _excluded1650 = ["color", "size", "className"],
    _excluded1651 = ["color", "size", "className"],
    _excluded1652 = ["color", "size", "className"],
    _excluded1653 = ["color", "size", "className"],
    _excluded1654 = ["color", "size", "className"],
    _excluded1655 = ["color", "size", "className"],
    _excluded1656 = ["color", "size", "className"],
    _excluded1657 = ["color", "size", "className"],
    _excluded1658 = ["color", "size", "className"],
    _excluded1659 = ["color", "size", "className"],
    _excluded1660 = ["color", "size", "className"],
    _excluded1661 = ["color", "size", "className"],
    _excluded1662 = ["color", "size", "className"],
    _excluded1663 = ["color", "size", "className"],
    _excluded1664 = ["color", "size", "className"],
    _excluded1665 = ["color", "size", "className"],
    _excluded1666 = ["color", "size", "className"],
    _excluded1667 = ["color", "size", "className"],
    _excluded1668 = ["color", "size", "className"],
    _excluded1669 = ["color", "size", "className"],
    _excluded1670 = ["color", "size", "className"],
    _excluded1671 = ["color", "size", "className"],
    _excluded1672 = ["color", "size", "className"],
    _excluded1673 = ["color", "size", "className"],
    _excluded1674 = ["color", "size", "className"],
    _excluded1675 = ["color", "size", "className"],
    _excluded1676 = ["color", "size", "className"],
    _excluded1677 = ["color", "size", "className"],
    _excluded1678 = ["color", "size", "className"],
    _excluded1679 = ["color", "size", "className"],
    _excluded1680 = ["color", "size", "className"],
    _excluded1681 = ["color", "size", "className"],
    _excluded1682 = ["color", "size", "className"],
    _excluded1683 = ["color", "size", "className"],
    _excluded1684 = ["color", "size", "className"],
    _excluded1685 = ["color", "size", "className"],
    _excluded1686 = ["color", "size", "className"],
    _excluded1687 = ["color", "size", "className"],
    _excluded1688 = ["color", "size", "className"],
    _excluded1689 = ["color", "size", "className"],
    _excluded1690 = ["color", "size", "className"],
    _excluded1691 = ["color", "size", "className"],
    _excluded1692 = ["color", "size", "className"],
    _excluded1693 = ["color", "size", "className"],
    _excluded1694 = ["color", "size", "className"],
    _excluded1695 = ["color", "size", "className"],
    _excluded1696 = ["color", "size", "className"],
    _excluded1697 = ["color", "size", "className"],
    _excluded1698 = ["color", "size", "className"],
    _excluded1699 = ["color", "size", "className"],
    _excluded1700 = ["color", "size", "className"],
    _excluded1701 = ["color", "size", "className"],
    _excluded1702 = ["color", "size", "className"],
    _excluded1703 = ["color", "size", "className"],
    _excluded1704 = ["color", "size", "className"],
    _excluded1705 = ["color", "size", "className"],
    _excluded1706 = ["color", "size", "className"],
    _excluded1707 = ["color", "size", "className"],
    _excluded1708 = ["color", "size", "className"],
    _excluded1709 = ["color", "size", "className"],
    _excluded1710 = ["color", "size", "className"],
    _excluded1711 = ["color", "size", "className"],
    _excluded1712 = ["color", "size", "className"],
    _excluded1713 = ["color", "size", "className"],
    _excluded1714 = ["color", "size", "className"],
    _excluded1715 = ["color", "size", "className"],
    _excluded1716 = ["color", "size", "className"],
    _excluded1717 = ["color", "size", "className"],
    _excluded1718 = ["color", "size", "className"],
    _excluded1719 = ["color", "size", "className"],
    _excluded1720 = ["color", "size", "className"],
    _excluded1721 = ["color", "size", "className"],
    _excluded1722 = ["color", "size", "className"],
    _excluded1723 = ["color", "size", "className"],
    _excluded1724 = ["color", "size", "className"],
    _excluded1725 = ["color", "size", "className"],
    _excluded1726 = ["color", "size", "className"],
    _excluded1727 = ["color", "size", "className"],
    _excluded1728 = ["color", "size", "className"],
    _excluded1729 = ["color", "size", "className"],
    _excluded1730 = ["color", "size", "className"],
    _excluded1731 = ["color", "size", "className"],
    _excluded1732 = ["color", "size", "className"],
    _excluded1733 = ["color", "size", "className"],
    _excluded1734 = ["color", "size", "className"],
    _excluded1735 = ["color", "size", "className"],
    _excluded1736 = ["color", "size", "className"],
    _excluded1737 = ["color", "size", "className"],
    _excluded1738 = ["color", "size", "className"],
    _excluded1739 = ["color", "size", "className"],
    _excluded1740 = ["color", "size", "className"],
    _excluded1741 = ["color", "size", "className"],
    _excluded1742 = ["color", "size", "className"],
    _excluded1743 = ["color", "size", "className"],
    _excluded1744 = ["color", "size", "className"],
    _excluded1745 = ["color", "size", "className"],
    _excluded1746 = ["color", "size", "className"],
    _excluded1747 = ["color", "size", "className"],
    _excluded1748 = ["color", "size", "className"],
    _excluded1749 = ["color", "size", "className"],
    _excluded1750 = ["color", "size", "className"],
    _excluded1751 = ["color", "size", "className"],
    _excluded1752 = ["color", "size", "className"],
    _excluded1753 = ["color", "size", "className"],
    _excluded1754 = ["color", "size", "className"],
    _excluded1755 = ["color", "size", "className"],
    _excluded1756 = ["color", "size", "className"],
    _excluded1757 = ["color", "size", "className"],
    _excluded1758 = ["color", "size", "className"],
    _excluded1759 = ["color", "size", "className"],
    _excluded1760 = ["color", "size", "className"],
    _excluded1761 = ["color", "size", "className"],
    _excluded1762 = ["color", "size", "className"],
    _excluded1763 = ["color", "size", "className"],
    _excluded1764 = ["color", "size", "className"],
    _excluded1765 = ["color", "size", "className"],
    _excluded1766 = ["color", "size", "className"],
    _excluded1767 = ["color", "size", "className"],
    _excluded1768 = ["color", "size", "className"],
    _excluded1769 = ["color", "size", "className"],
    _excluded1770 = ["color", "size", "className"],
    _excluded1771 = ["color", "size", "className"],
    _excluded1772 = ["color", "size", "className"],
    _excluded1773 = ["color", "size", "className"],
    _excluded1774 = ["color", "size", "className"],
    _excluded1775 = ["color", "size", "className"],
    _excluded1776 = ["color", "size", "className"],
    _excluded1777 = ["color", "size", "className"],
    _excluded1778 = ["color", "size", "className"],
    _excluded1779 = ["color", "size", "className"],
    _excluded1780 = ["color", "size", "className"],
    _excluded1781 = ["color", "size", "className"],
    _excluded1782 = ["color", "size", "className"],
    _excluded1783 = ["color", "size", "className"],
    _excluded1784 = ["color", "size", "className"],
    _excluded1785 = ["color", "size", "className"],
    _excluded1786 = ["color", "size", "className"],
    _excluded1787 = ["color", "size", "className"],
    _excluded1788 = ["color", "size", "className"],
    _excluded1789 = ["color", "size", "className"],
    _excluded1790 = ["color", "size", "className"],
    _excluded1791 = ["color", "size", "className"],
    _excluded1792 = ["color", "size", "className"],
    _excluded1793 = ["color", "size", "className"],
    _excluded1794 = ["color", "size", "className"],
    _excluded1795 = ["color", "size", "className"],
    _excluded1796 = ["color", "size", "className"],
    _excluded1797 = ["color", "size", "className"],
    _excluded1798 = ["color", "size", "className"],
    _excluded1799 = ["color", "size", "className"],
    _excluded1800 = ["color", "size", "className"],
    _excluded1801 = ["color", "size", "className"],
    _excluded1802 = ["color", "size", "className"],
    _excluded1803 = ["color", "size", "className"],
    _excluded1804 = ["color", "size", "className"],
    _excluded1805 = ["color", "size", "className"],
    _excluded1806 = ["color", "size", "className"],
    _excluded1807 = ["color", "size", "className"],
    _excluded1808 = ["color", "size", "className"],
    _excluded1809 = ["color", "size", "className"],
    _excluded1810 = ["color", "size", "className"],
    _excluded1811 = ["color", "size", "className"],
    _excluded1812 = ["color", "size", "className"],
    _excluded1813 = ["color", "size", "className"],
    _excluded1814 = ["color", "size", "className"],
    _excluded1815 = ["color", "size", "className"],
    _excluded1816 = ["color", "size", "className"],
    _excluded1817 = ["color", "size", "className"],
    _excluded1818 = ["color", "size", "className"],
    _excluded1819 = ["color", "size", "className"],
    _excluded1820 = ["color", "size", "className"],
    _excluded1821 = ["color", "size", "className"],
    _excluded1822 = ["color", "size", "className"],
    _excluded1823 = ["color", "size", "className"],
    _excluded1824 = ["color", "size", "className"],
    _excluded1825 = ["color", "size", "className"],
    _excluded1826 = ["color", "size", "className"],
    _excluded1827 = ["color", "size", "className"],
    _excluded1828 = ["color", "size", "className"],
    _excluded1829 = ["color", "size", "className"],
    _excluded1830 = ["color", "size", "className"],
    _excluded1831 = ["color", "size", "className"],
    _excluded1832 = ["color", "size", "className"],
    _excluded1833 = ["color", "size", "className"],
    _excluded1834 = ["color", "size", "className"],
    _excluded1835 = ["color", "size", "className"],
    _excluded1836 = ["color", "size", "className"],
    _excluded1837 = ["color", "size", "className"],
    _excluded1838 = ["color", "size", "className"],
    _excluded1839 = ["color", "size", "className"],
    _excluded1840 = ["color", "size", "className"],
    _excluded1841 = ["color", "size", "className"],
    _excluded1842 = ["color", "size", "className"],
    _excluded1843 = ["color", "size", "className"],
    _excluded1844 = ["color", "size", "className"],
    _excluded1845 = ["color", "size", "className"],
    _excluded1846 = ["color", "size", "className"],
    _excluded1847 = ["color", "size", "className"],
    _excluded1848 = ["color", "size", "className"],
    _excluded1849 = ["color", "size", "className"],
    _excluded1850 = ["color", "size", "className"],
    _excluded1851 = ["color", "size", "className"],
    _excluded1852 = ["color", "size", "className"],
    _excluded1853 = ["color", "size", "className"],
    _excluded1854 = ["color", "size", "className"],
    _excluded1855 = ["color", "size", "className"],
    _excluded1856 = ["color", "size", "className"],
    _excluded1857 = ["color", "size", "className"],
    _excluded1858 = ["color", "size", "className"],
    _excluded1859 = ["color", "size", "className"],
    _excluded1860 = ["color", "size", "className"],
    _excluded1861 = ["color", "size", "className"],
    _excluded1862 = ["color", "size", "className"],
    _excluded1863 = ["color", "size", "className"],
    _excluded1864 = ["color", "size", "className"],
    _excluded1865 = ["color", "size", "className"],
    _excluded1866 = ["color", "size", "className"],
    _excluded1867 = ["color", "size", "className"],
    _excluded1868 = ["color", "size", "className"],
    _excluded1869 = ["color", "size", "className"],
    _excluded1870 = ["color", "size", "className"],
    _excluded1871 = ["color", "size", "className"],
    _excluded1872 = ["color", "size", "className"],
    _excluded1873 = ["color", "size", "className"],
    _excluded1874 = ["color", "size", "className"],
    _excluded1875 = ["color", "size", "className"],
    _excluded1876 = ["color", "size", "className"],
    _excluded1877 = ["color", "size", "className"],
    _excluded1878 = ["color", "size", "className"],
    _excluded1879 = ["color", "size", "className"],
    _excluded1880 = ["color", "size", "className"],
    _excluded1881 = ["color", "size", "className"],
    _excluded1882 = ["color", "size", "className"],
    _excluded1883 = ["color", "size", "className"],
    _excluded1884 = ["color", "size", "className"],
    _excluded1885 = ["color", "size", "className"],
    _excluded1886 = ["color", "size", "className"],
    _excluded1887 = ["color", "size", "className"],
    _excluded1888 = ["color", "size", "className"],
    _excluded1889 = ["color", "size", "className"],
    _excluded1890 = ["color", "size", "className"],
    _excluded1891 = ["color", "size", "className"],
    _excluded1892 = ["color", "size", "className"],
    _excluded1893 = ["color", "size", "className"],
    _excluded1894 = ["color", "size", "className"],
    _excluded1895 = ["color", "size", "className"],
    _excluded1896 = ["color", "size", "className"],
    _excluded1897 = ["color", "size", "className"],
    _excluded1898 = ["color", "size", "className"],
    _excluded1899 = ["color", "size", "className"],
    _excluded1900 = ["color", "size", "className"],
    _excluded1901 = ["color", "size", "className"],
    _excluded1902 = ["color", "size", "className"],
    _excluded1903 = ["color", "size", "className"],
    _excluded1904 = ["color", "size", "className"],
    _excluded1905 = ["color", "size", "className"],
    _excluded1906 = ["color", "size", "className"],
    _excluded1907 = ["color", "size", "className"],
    _excluded1908 = ["color", "size", "className"],
    _excluded1909 = ["color", "size", "className"],
    _excluded1910 = ["color", "size", "className"],
    _excluded1911 = ["color", "size", "className"],
    _excluded1912 = ["color", "size", "className"],
    _excluded1913 = ["color", "size", "className"],
    _excluded1914 = ["color", "size", "className"],
    _excluded1915 = ["color", "size", "className"],
    _excluded1916 = ["color", "size", "className"],
    _excluded1917 = ["color", "size", "className"],
    _excluded1918 = ["color", "size", "className"],
    _excluded1919 = ["color", "size", "className"],
    _excluded1920 = ["color", "size", "className"],
    _excluded1921 = ["color", "size", "className"],
    _excluded1922 = ["color", "size", "className"],
    _excluded1923 = ["color", "size", "className"],
    _excluded1924 = ["color", "size", "className"],
    _excluded1925 = ["color", "size", "className"],
    _excluded1926 = ["color", "size", "className"],
    _excluded1927 = ["color", "size", "className"],
    _excluded1928 = ["color", "size", "className"],
    _excluded1929 = ["color", "size", "className"],
    _excluded1930 = ["color", "size", "className"],
    _excluded1931 = ["color", "size", "className"],
    _excluded1932 = ["color", "size", "className"],
    _excluded1933 = ["color", "size", "className"],
    _excluded1934 = ["color", "size", "className"],
    _excluded1935 = ["color", "size", "className"],
    _excluded1936 = ["color", "size", "className"],
    _excluded1937 = ["color", "size", "className"],
    _excluded1938 = ["color", "size", "className"],
    _excluded1939 = ["color", "size", "className"],
    _excluded1940 = ["color", "size", "className"],
    _excluded1941 = ["color", "size", "className"],
    _excluded1942 = ["color", "size", "className"],
    _excluded1943 = ["color", "size", "className"],
    _excluded1944 = ["color", "size", "className"],
    _excluded1945 = ["color", "size", "className"],
    _excluded1946 = ["color", "size", "className"],
    _excluded1947 = ["color", "size", "className"],
    _excluded1948 = ["color", "size", "className"],
    _excluded1949 = ["color", "size", "className"],
    _excluded1950 = ["color", "size", "className"],
    _excluded1951 = ["color", "size", "className"],
    _excluded1952 = ["color", "size", "className"],
    _excluded1953 = ["color", "size", "className"],
    _excluded1954 = ["color", "size", "className"],
    _excluded1955 = ["color", "size", "className"],
    _excluded1956 = ["color", "size", "className"],
    _excluded1957 = ["color", "size", "className"],
    _excluded1958 = ["color", "size", "className"],
    _excluded1959 = ["color", "size", "className"],
    _excluded1960 = ["color", "size", "className"],
    _excluded1961 = ["color", "size", "className"],
    _excluded1962 = ["color", "size", "className"],
    _excluded1963 = ["color", "size", "className"],
    _excluded1964 = ["color", "size", "className"],
    _excluded1965 = ["color", "size", "className"],
    _excluded1966 = ["color", "size", "className"],
    _excluded1967 = ["color", "size", "className"],
    _excluded1968 = ["color", "size", "className"],
    _excluded1969 = ["color", "size", "className"],
    _excluded1970 = ["color", "size", "className"],
    _excluded1971 = ["color", "size", "className"],
    _excluded1972 = ["color", "size", "className"],
    _excluded1973 = ["color", "size", "className"],
    _excluded1974 = ["color", "size", "className"],
    _excluded1975 = ["color", "size", "className"],
    _excluded1976 = ["color", "size", "className"],
    _excluded1977 = ["color", "size", "className"],
    _excluded1978 = ["color", "size", "className"],
    _excluded1979 = ["color", "size", "className"],
    _excluded1980 = ["color", "size", "className"],
    _excluded1981 = ["color", "size", "className"],
    _excluded1982 = ["color", "size", "className"],
    _excluded1983 = ["color", "size", "className"],
    _excluded1984 = ["color", "size", "className"],
    _excluded1985 = ["color", "size", "className"],
    _excluded1986 = ["color", "size", "className"],
    _excluded1987 = ["color", "size", "className"],
    _excluded1988 = ["color", "size", "className"],
    _excluded1989 = ["color", "size", "className"],
    _excluded1990 = ["color", "size", "className"],
    _excluded1991 = ["color", "size", "className"],
    _excluded1992 = ["color", "size", "className"],
    _excluded1993 = ["color", "size", "className"],
    _excluded1994 = ["color", "size", "className"],
    _excluded1995 = ["color", "size", "className"],
    _excluded1996 = ["color", "size", "className"],
    _excluded1997 = ["color", "size", "className"],
    _excluded1998 = ["color", "size", "className"],
    _excluded1999 = ["color", "size", "className"],
    _excluded2000 = ["color", "size", "className"],
    _excluded2001 = ["color", "size", "className"],
    _excluded2002 = ["color", "size", "className"],
    _excluded2003 = ["color", "size", "className"],
    _excluded2004 = ["color", "size", "className"],
    _excluded2005 = ["color", "size", "className"],
    _excluded2006 = ["color", "size", "className"],
    _excluded2007 = ["color", "size", "className"],
    _excluded2008 = ["color", "size", "className"],
    _excluded2009 = ["color", "size", "className"],
    _excluded2010 = ["color", "size", "className"],
    _excluded2011 = ["color", "size", "className"],
    _excluded2012 = ["color", "size", "className"],
    _excluded2013 = ["color", "size", "className"],
    _excluded2014 = ["color", "size", "className"],
    _excluded2015 = ["color", "size", "className"],
    _excluded2016 = ["color", "size", "className"],
    _excluded2017 = ["color", "size", "className"],
    _excluded2018 = ["color", "size", "className"],
    _excluded2019 = ["color", "size", "className"],
    _excluded2020 = ["color", "size", "className"],
    _excluded2021 = ["color", "size", "className"],
    _excluded2022 = ["color", "size", "className"],
    _excluded2023 = ["color", "size", "className"],
    _excluded2024 = ["color", "size", "className"],
    _excluded2025 = ["color", "size", "className"],
    _excluded2026 = ["color", "size", "className"],
    _excluded2027 = ["color", "size", "className"],
    _excluded2028 = ["color", "size", "className"],
    _excluded2029 = ["color", "size", "className"],
    _excluded2030 = ["color", "size", "className"],
    _excluded2031 = ["color", "size", "className"],
    _excluded2032 = ["color", "size", "className"],
    _excluded2033 = ["color", "size", "className"],
    _excluded2034 = ["color", "size", "className"],
    _excluded2035 = ["color", "size", "className"],
    _excluded2036 = ["color", "size", "className"],
    _excluded2037 = ["color", "size", "className"],
    _excluded2038 = ["color", "size", "className"],
    _excluded2039 = ["color", "size", "className"],
    _excluded2040 = ["color", "size", "className"],
    _excluded2041 = ["color", "size", "className"],
    _excluded2042 = ["color", "size", "className"],
    _excluded2043 = ["color", "size", "className"],
    _excluded2044 = ["color", "size", "className"],
    _excluded2045 = ["color", "size", "className"],
    _excluded2046 = ["color", "size", "className"],
    _excluded2047 = ["color", "size", "className"],
    _excluded2048 = ["color", "size", "className"],
    _excluded2049 = ["color", "size", "className"],
    _excluded2050 = ["color", "size", "className"],
    _excluded2051 = ["color", "size", "className"],
    _excluded2052 = ["color", "size", "className"],
    _excluded2053 = ["color", "size", "className"],
    _excluded2054 = ["color", "size", "className"],
    _excluded2055 = ["color", "size", "className"],
    _excluded2056 = ["color", "size", "className"],
    _excluded2057 = ["color", "size", "className"],
    _excluded2058 = ["color", "size", "className"],
    _excluded2059 = ["color", "size", "className"],
    _excluded2060 = ["color", "size", "className"],
    _excluded2061 = ["color", "size", "className"],
    _excluded2062 = ["color", "size", "className"],
    _excluded2063 = ["color", "size", "className"],
    _excluded2064 = ["color", "size", "className"],
    _excluded2065 = ["color", "size", "className"],
    _excluded2066 = ["color", "size", "className"],
    _excluded2067 = ["color", "size", "className"],
    _excluded2068 = ["color", "size", "className"],
    _excluded2069 = ["color", "size", "className"],
    _excluded2070 = ["color", "size", "className"],
    _excluded2071 = ["color", "size", "className"],
    _excluded2072 = ["color", "size", "className"],
    _excluded2073 = ["color", "size", "className"],
    _excluded2074 = ["color", "size", "className"],
    _excluded2075 = ["color", "size", "className"],
    _excluded2076 = ["color", "size", "className"],
    _excluded2077 = ["color", "size", "className"],
    _excluded2078 = ["color", "size", "className"],
    _excluded2079 = ["color", "size", "className"],
    _excluded2080 = ["color", "size", "className"],
    _excluded2081 = ["color", "size", "className"],
    _excluded2082 = ["color", "size", "className"],
    _excluded2083 = ["color", "size", "className"],
    _excluded2084 = ["color", "size", "className"],
    _excluded2085 = ["color", "size", "className"],
    _excluded2086 = ["color", "size", "className"],
    _excluded2087 = ["color", "size", "className"],
    _excluded2088 = ["color", "size", "className"],
    _excluded2089 = ["color", "size", "className"],
    _excluded2090 = ["color", "size", "className"],
    _excluded2091 = ["color", "size", "className"],
    _excluded2092 = ["color", "size", "className"],
    _excluded2093 = ["color", "size", "className"],
    _excluded2094 = ["color", "size", "className"],
    _excluded2095 = ["color", "size", "className"],
    _excluded2096 = ["color", "size", "className"],
    _excluded2097 = ["color", "size", "className"],
    _excluded2098 = ["color", "size", "className"],
    _excluded2099 = ["color", "size", "className"],
    _excluded2100 = ["color", "size", "className"],
    _excluded2101 = ["color", "size", "className"],
    _excluded2102 = ["color", "size", "className"],
    _excluded2103 = ["color", "size", "className"],
    _excluded2104 = ["color", "size", "className"],
    _excluded2105 = ["color", "size", "className"],
    _excluded2106 = ["color", "size", "className"],
    _excluded2107 = ["color", "size", "className"],
    _excluded2108 = ["color", "size", "className"],
    _excluded2109 = ["color", "size", "className"],
    _excluded2110 = ["color", "size", "className"],
    _excluded2111 = ["color", "size", "className"],
    _excluded2112 = ["color", "size", "className"],
    _excluded2113 = ["color", "size", "className"],
    _excluded2114 = ["color", "size", "className"],
    _excluded2115 = ["color", "size", "className"],
    _excluded2116 = ["color", "size", "className"],
    _excluded2117 = ["color", "size", "className"],
    _excluded2118 = ["color", "size", "className"],
    _excluded2119 = ["color", "size", "className"],
    _excluded2120 = ["color", "size", "className"],
    _excluded2121 = ["color", "size", "className"],
    _excluded2122 = ["color", "size", "className"],
    _excluded2123 = ["color", "size", "className"],
    _excluded2124 = ["color", "size", "className"],
    _excluded2125 = ["color", "size", "className"],
    _excluded2126 = ["color", "size", "className"],
    _excluded2127 = ["color", "size", "className"],
    _excluded2128 = ["color", "size", "className"],
    _excluded2129 = ["color", "size", "className"],
    _excluded2130 = ["color", "size", "className"],
    _excluded2131 = ["color", "size", "className"],
    _excluded2132 = ["color", "size", "className"],
    _excluded2133 = ["color", "size", "className"],
    _excluded2134 = ["color", "size", "className"],
    _excluded2135 = ["color", "size", "className"],
    _excluded2136 = ["color", "size", "className"],
    _excluded2137 = ["color", "size", "className"],
    _excluded2138 = ["color", "size", "className"],
    _excluded2139 = ["color", "size", "className"],
    _excluded2140 = ["color", "size", "className"],
    _excluded2141 = ["color", "size", "className"],
    _excluded2142 = ["color", "size", "className"],
    _excluded2143 = ["color", "size", "className"],
    _excluded2144 = ["color", "size", "className"],
    _excluded2145 = ["color", "size", "className"],
    _excluded2146 = ["color", "size", "className"],
    _excluded2147 = ["color", "size", "className"],
    _excluded2148 = ["color", "size", "className"],
    _excluded2149 = ["color", "size", "className"],
    _excluded2150 = ["color", "size", "className"],
    _excluded2151 = ["color", "size", "className"],
    _excluded2152 = ["color", "size", "className"],
    _excluded2153 = ["color", "size", "className"],
    _excluded2154 = ["color", "size", "className"],
    _excluded2155 = ["color", "size", "className"],
    _excluded2156 = ["color", "size", "className"],
    _excluded2157 = ["color", "size", "className"],
    _excluded2158 = ["color", "size", "className"],
    _excluded2159 = ["color", "size", "className"],
    _excluded2160 = ["color", "size", "className"],
    _excluded2161 = ["color", "size", "className"],
    _excluded2162 = ["color", "size", "className"],
    _excluded2163 = ["color", "size", "className"],
    _excluded2164 = ["color", "size", "className"],
    _excluded2165 = ["color", "size", "className"],
    _excluded2166 = ["color", "size", "className"],
    _excluded2167 = ["color", "size", "className"],
    _excluded2168 = ["color", "size", "className"],
    _excluded2169 = ["color", "size", "className"],
    _excluded2170 = ["color", "size", "className"],
    _excluded2171 = ["color", "size", "className"],
    _excluded2172 = ["color", "size", "className"],
    _excluded2173 = ["color", "size", "className"],
    _excluded2174 = ["color", "size", "className"],
    _excluded2175 = ["color", "size", "className"],
    _excluded2176 = ["color", "size", "className"],
    _excluded2177 = ["color", "size", "className"],
    _excluded2178 = ["color", "size", "className"],
    _excluded2179 = ["color", "size", "className"],
    _excluded2180 = ["color", "size", "className"],
    _excluded2181 = ["color", "size", "className"],
    _excluded2182 = ["color", "size", "className"],
    _excluded2183 = ["color", "size", "className"],
    _excluded2184 = ["color", "size", "className"],
    _excluded2185 = ["color", "size", "className"],
    _excluded2186 = ["color", "size", "className"],
    _excluded2187 = ["color", "size", "className"],
    _excluded2188 = ["color", "size", "className"],
    _excluded2189 = ["color", "size", "className"],
    _excluded2190 = ["color", "size", "className"],
    _excluded2191 = ["color", "size", "className"],
    _excluded2192 = ["color", "size", "className"],
    _excluded2193 = ["color", "size", "className"],
    _excluded2194 = ["color", "size", "className"],
    _excluded2195 = ["color", "size", "className"],
    _excluded2196 = ["color", "size", "className"],
    _excluded2197 = ["color", "size", "className"],
    _excluded2198 = ["color", "size", "className"],
    _excluded2199 = ["color", "size", "className"],
    _excluded2200 = ["color", "size", "className"],
    _excluded2201 = ["color", "size", "className"],
    _excluded2202 = ["color", "size", "className"],
    _excluded2203 = ["color", "size", "className"],
    _excluded2204 = ["color", "size", "className"],
    _excluded2205 = ["color", "size", "className"],
    _excluded2206 = ["color", "size", "className"],
    _excluded2207 = ["color", "size", "className"],
    _excluded2208 = ["color", "size", "className"],
    _excluded2209 = ["color", "size", "className"],
    _excluded2210 = ["color", "size", "className"],
    _excluded2211 = ["color", "size", "className"],
    _excluded2212 = ["color", "size", "className"],
    _excluded2213 = ["color", "size", "className"],
    _excluded2214 = ["color", "size", "className"],
    _excluded2215 = ["color", "size", "className"],
    _excluded2216 = ["color", "size", "className"],
    _excluded2217 = ["color", "size", "className"],
    _excluded2218 = ["color", "size", "className"],
    _excluded2219 = ["color", "size", "className"],
    _excluded2220 = ["color", "size", "className"],
    _excluded2221 = ["color", "size", "className"],
    _excluded2222 = ["color", "size", "className"],
    _excluded2223 = ["color", "size", "className"],
    _excluded2224 = ["color", "size", "className"],
    _excluded2225 = ["color", "size", "className"],
    _excluded2226 = ["color", "size", "className"],
    _excluded2227 = ["color", "size", "className"],
    _excluded2228 = ["color", "size", "className"],
    _excluded2229 = ["color", "size", "className"],
    _excluded2230 = ["color", "size", "className"],
    _excluded2231 = ["color", "size", "className"],
    _excluded2232 = ["color", "size", "className"],
    _excluded2233 = ["color", "size", "className"],
    _excluded2234 = ["color", "size", "className"],
    _excluded2235 = ["color", "size", "className"],
    _excluded2236 = ["color", "size", "className"],
    _excluded2237 = ["color", "size", "className"],
    _excluded2238 = ["color", "size", "className"],
    _excluded2239 = ["color", "size", "className"],
    _excluded2240 = ["color", "size", "className"],
    _excluded2241 = ["color", "size", "className"],
    _excluded2242 = ["color", "size", "className"],
    _excluded2243 = ["color", "size", "className"],
    _excluded2244 = ["color", "size", "className"],
    _excluded2245 = ["color", "size", "className"],
    _excluded2246 = ["color", "size", "className"],
    _excluded2247 = ["color", "size", "className"],
    _excluded2248 = ["color", "size", "className"],
    _excluded2249 = ["color", "size", "className"],
    _excluded2250 = ["color", "size", "className"],
    _excluded2251 = ["color", "size", "className"],
    _excluded2252 = ["color", "size", "className"],
    _excluded2253 = ["color", "size", "className"],
    _excluded2254 = ["color", "size", "className"],
    _excluded2255 = ["color", "size", "className"],
    _excluded2256 = ["color", "size", "className"],
    _excluded2257 = ["color", "size", "className"],
    _excluded2258 = ["color", "size", "className"],
    _excluded2259 = ["color", "size", "className"],
    _excluded2260 = ["color", "size", "className"],
    _excluded2261 = ["color", "size", "className"],
    _excluded2262 = ["color", "size", "className"],
    _excluded2263 = ["color", "size", "className"],
    _excluded2264 = ["color", "size", "className"],
    _excluded2265 = ["color", "size", "className"],
    _excluded2266 = ["color", "size", "className"],
    _excluded2267 = ["color", "size", "className"],
    _excluded2268 = ["color", "size", "className"],
    _excluded2269 = ["color", "size", "className"],
    _excluded2270 = ["color", "size", "className"],
    _excluded2271 = ["color", "size", "className"],
    _excluded2272 = ["color", "size", "className"],
    _excluded2273 = ["color", "size", "className"],
    _excluded2274 = ["color", "size", "className"],
    _excluded2275 = ["color", "size", "className"],
    _excluded2276 = ["color", "size", "className"],
    _excluded2277 = ["color", "size", "className"],
    _excluded2278 = ["color", "size", "className"],
    _excluded2279 = ["color", "size", "className"],
    _excluded2280 = ["color", "size", "className"],
    _excluded2281 = ["color", "size", "className"],
    _excluded2282 = ["color", "size", "className"],
    _excluded2283 = ["color", "size", "className"],
    _excluded2284 = ["color", "size", "className"],
    _excluded2285 = ["color", "size", "className"],
    _excluded2286 = ["color", "size", "className"],
    _excluded2287 = ["color", "size", "className"],
    _excluded2288 = ["color", "size", "className"],
    _excluded2289 = ["color", "size", "className"],
    _excluded2290 = ["color", "size", "className"],
    _excluded2291 = ["color", "size", "className"],
    _excluded2292 = ["color", "size", "className"],
    _excluded2293 = ["color", "size", "className"],
    _excluded2294 = ["color", "size", "className"],
    _excluded2295 = ["color", "size", "className"],
    _excluded2296 = ["color", "size", "className"],
    _excluded2297 = ["color", "size", "className"],
    _excluded2298 = ["color", "size", "className"],
    _excluded2299 = ["color", "size", "className"],
    _excluded2300 = ["color", "size", "className"],
    _excluded2301 = ["color", "size", "className"],
    _excluded2302 = ["color", "size", "className"],
    _excluded2303 = ["color", "size", "className"],
    _excluded2304 = ["color", "size", "className"],
    _excluded2305 = ["color", "size", "className"],
    _excluded2306 = ["color", "size", "className"],
    _excluded2307 = ["color", "size", "className"],
    _excluded2308 = ["color", "size", "className"],
    _excluded2309 = ["color", "size", "className"],
    _excluded2310 = ["color", "size", "className"],
    _excluded2311 = ["color", "size", "className"],
    _excluded2312 = ["color", "size", "className"],
    _excluded2313 = ["color", "size", "className"],
    _excluded2314 = ["color", "size", "className"],
    _excluded2315 = ["color", "size", "className"],
    _excluded2316 = ["color", "size", "className"],
    _excluded2317 = ["color", "size", "className"],
    _excluded2318 = ["color", "size", "className"],
    _excluded2319 = ["color", "size", "className"],
    _excluded2320 = ["color", "size", "className"],
    _excluded2321 = ["color", "size", "className"],
    _excluded2322 = ["color", "size", "className"],
    _excluded2323 = ["color", "size", "className"],
    _excluded2324 = ["color", "size", "className"],
    _excluded2325 = ["color", "size", "className"],
    _excluded2326 = ["color", "size", "className"],
    _excluded2327 = ["color", "size", "className"],
    _excluded2328 = ["color", "size", "className"],
    _excluded2329 = ["color", "size", "className"],
    _excluded2330 = ["color", "size", "className"],
    _excluded2331 = ["color", "size", "className"],
    _excluded2332 = ["color", "size", "className"],
    _excluded2333 = ["color", "size", "className"],
    _excluded2334 = ["color", "size", "className"],
    _excluded2335 = ["color", "size", "className"],
    _excluded2336 = ["color", "size", "className"],
    _excluded2337 = ["color", "size", "className"],
    _excluded2338 = ["color", "size", "className"],
    _excluded2339 = ["color", "size", "className"],
    _excluded2340 = ["color", "size", "className"],
    _excluded2341 = ["color", "size", "className"],
    _excluded2342 = ["color", "size", "className"],
    _excluded2343 = ["color", "size", "className"],
    _excluded2344 = ["color", "size", "className"],
    _excluded2345 = ["color", "size", "className"],
    _excluded2346 = ["color", "size", "className"],
    _excluded2347 = ["color", "size", "className"],
    _excluded2348 = ["color", "size", "className"],
    _excluded2349 = ["color", "size", "className"],
    _excluded2350 = ["color", "size", "className"],
    _excluded2351 = ["color", "size", "className"],
    _excluded2352 = ["color", "size", "className"],
    _excluded2353 = ["color", "size", "className"],
    _excluded2354 = ["color", "size", "className"],
    _excluded2355 = ["color", "size", "className"],
    _excluded2356 = ["color", "size", "className"],
    _excluded2357 = ["color", "size", "className"],
    _excluded2358 = ["color", "size", "className"],
    _excluded2359 = ["color", "size", "className"],
    _excluded2360 = ["color", "size", "className"],
    _excluded2361 = ["color", "size", "className"],
    _excluded2362 = ["color", "size", "className"],
    _excluded2363 = ["color", "size", "className"],
    _excluded2364 = ["color", "size", "className"],
    _excluded2365 = ["color", "size", "className"],
    _excluded2366 = ["color", "size", "className"],
    _excluded2367 = ["color", "size", "className"],
    _excluded2368 = ["color", "size", "className"],
    _excluded2369 = ["color", "size", "className"],
    _excluded2370 = ["color", "size", "className"],
    _excluded2371 = ["color", "size", "className"],
    _excluded2372 = ["color", "size", "className"],
    _excluded2373 = ["color", "size", "className"],
    _excluded2374 = ["color", "size", "className"],
    _excluded2375 = ["color", "size", "className"],
    _excluded2376 = ["color", "size", "className"],
    _excluded2377 = ["color", "size", "className"],
    _excluded2378 = ["color", "size", "className"],
    _excluded2379 = ["color", "size", "className"],
    _excluded2380 = ["color", "size", "className"],
    _excluded2381 = ["color", "size", "className"],
    _excluded2382 = ["color", "size", "className"],
    _excluded2383 = ["color", "size", "className"],
    _excluded2384 = ["color", "size", "className"],
    _excluded2385 = ["color", "size", "className"],
    _excluded2386 = ["color", "size", "className"],
    _excluded2387 = ["color", "size", "className"],
    _excluded2388 = ["color", "size", "className"],
    _excluded2389 = ["color", "size", "className"],
    _excluded2390 = ["color", "size", "className"],
    _excluded2391 = ["color", "size", "className"],
    _excluded2392 = ["color", "size", "className"],
    _excluded2393 = ["color", "size", "className"],
    _excluded2394 = ["color", "size", "className"],
    _excluded2395 = ["color", "size", "className"],
    _excluded2396 = ["color", "size", "className"],
    _excluded2397 = ["color", "size", "className"],
    _excluded2398 = ["color", "size", "className"],
    _excluded2399 = ["color", "size", "className"],
    _excluded2400 = ["color", "size", "className"],
    _excluded2401 = ["color", "size", "className"],
    _excluded2402 = ["color", "size", "className"],
    _excluded2403 = ["color", "size", "className"],
    _excluded2404 = ["color", "size", "className"],
    _excluded2405 = ["color", "size", "className"],
    _excluded2406 = ["color", "size", "className"],
    _excluded2407 = ["color", "size", "className"],
    _excluded2408 = ["color", "size", "className"],
    _excluded2409 = ["color", "size", "className"],
    _excluded2410 = ["color", "size", "className"],
    _excluded2411 = ["color", "size", "className"],
    _excluded2412 = ["color", "size", "className"],
    _excluded2413 = ["color", "size", "className"],
    _excluded2414 = ["color", "size", "className"],
    _excluded2415 = ["color", "size", "className"],
    _excluded2416 = ["color", "size", "className"],
    _excluded2417 = ["color", "size", "className"],
    _excluded2418 = ["color", "size", "className"],
    _excluded2419 = ["color", "size", "className"],
    _excluded2420 = ["color", "size", "className"],
    _excluded2421 = ["color", "size", "className"],
    _excluded2422 = ["color", "size", "className"],
    _excluded2423 = ["color", "size", "className"],
    _excluded2424 = ["color", "size", "className"],
    _excluded2425 = ["color", "size", "className"],
    _excluded2426 = ["color", "size", "className"],
    _excluded2427 = ["color", "size", "className"],
    _excluded2428 = ["color", "size", "className"],
    _excluded2429 = ["color", "size", "className"],
    _excluded2430 = ["color", "size", "className"],
    _excluded2431 = ["color", "size", "className"],
    _excluded2432 = ["color", "size", "className"],
    _excluded2433 = ["color", "size", "className"],
    _excluded2434 = ["color", "size", "className"],
    _excluded2435 = ["color", "size", "className"],
    _excluded2436 = ["color", "size", "className"],
    _excluded2437 = ["color", "size", "className"],
    _excluded2438 = ["color", "size", "className"],
    _excluded2439 = ["color", "size", "className"],
    _excluded2440 = ["color", "size", "className"],
    _excluded2441 = ["color", "size", "className"],
    _excluded2442 = ["color", "size", "className"],
    _excluded2443 = ["color", "size", "className"],
    _excluded2444 = ["color", "size", "className"],
    _excluded2445 = ["color", "size", "className"],
    _excluded2446 = ["color", "size", "className"],
    _excluded2447 = ["color", "size", "className"],
    _excluded2448 = ["color", "size", "className"],
    _excluded2449 = ["color", "size", "className"],
    _excluded2450 = ["color", "size", "className"],
    _excluded2451 = ["color", "size", "className"],
    _excluded2452 = ["color", "size", "className"],
    _excluded2453 = ["color", "size", "className"],
    _excluded2454 = ["color", "size", "className"],
    _excluded2455 = ["color", "size", "className"],
    _excluded2456 = ["color", "size", "className"],
    _excluded2457 = ["color", "size", "className"],
    _excluded2458 = ["color", "size", "className"],
    _excluded2459 = ["color", "size", "className"],
    _excluded2460 = ["color", "size", "className"],
    _excluded2461 = ["color", "size", "className"],
    _excluded2462 = ["color", "size", "className"],
    _excluded2463 = ["color", "size", "className"],
    _excluded2464 = ["color", "size", "className"],
    _excluded2465 = ["color", "size", "className"],
    _excluded2466 = ["color", "size", "className"],
    _excluded2467 = ["color", "size", "className"],
    _excluded2468 = ["color", "size", "className"],
    _excluded2469 = ["color", "size", "className"],
    _excluded2470 = ["color", "size", "className"],
    _excluded2471 = ["color", "size", "className"],
    _excluded2472 = ["color", "size", "className"],
    _excluded2473 = ["color", "size", "className"],
    _excluded2474 = ["color", "size", "className"],
    _excluded2475 = ["color", "size", "className"],
    _excluded2476 = ["color", "size", "className"],
    _excluded2477 = ["color", "size", "className"],
    _excluded2478 = ["color", "size", "className"],
    _excluded2479 = ["color", "size", "className"],
    _excluded2480 = ["color", "size", "className"],
    _excluded2481 = ["color", "size", "className"],
    _excluded2482 = ["color", "size", "className"],
    _excluded2483 = ["color", "size", "className"],
    _excluded2484 = ["color", "size", "className"],
    _excluded2485 = ["color", "size", "className"],
    _excluded2486 = ["color", "size", "className"],
    _excluded2487 = ["color", "size", "className"],
    _excluded2488 = ["color", "size", "className"],
    _excluded2489 = ["color", "size", "className"],
    _excluded2490 = ["color", "size", "className"],
    _excluded2491 = ["color", "size", "className"],
    _excluded2492 = ["color", "size", "className"],
    _excluded2493 = ["color", "size", "className"],
    _excluded2494 = ["color", "size", "className"],
    _excluded2495 = ["color", "size", "className"],
    _excluded2496 = ["color", "size", "className"],
    _excluded2497 = ["color", "size", "className"],
    _excluded2498 = ["color", "size", "className"],
    _excluded2499 = ["color", "size", "className"],
    _excluded2500 = ["color", "size", "className"],
    _excluded2501 = ["color", "size", "className"],
    _excluded2502 = ["color", "size", "className"],
    _excluded2503 = ["color", "size", "className"],
    _excluded2504 = ["color", "size", "className"],
    _excluded2505 = ["color", "size", "className"],
    _excluded2506 = ["color", "size", "className"],
    _excluded2507 = ["color", "size", "className"],
    _excluded2508 = ["color", "size", "className"],
    _excluded2509 = ["color", "size", "className"],
    _excluded2510 = ["color", "size", "className"],
    _excluded2511 = ["color", "size", "className"],
    _excluded2512 = ["color", "size", "className"],
    _excluded2513 = ["color", "size", "className"],
    _excluded2514 = ["color", "size", "className"],
    _excluded2515 = ["color", "size", "className"],
    _excluded2516 = ["color", "size", "className"],
    _excluded2517 = ["color", "size", "className"],
    _excluded2518 = ["color", "size", "className"],
    _excluded2519 = ["color", "size", "className"],
    _excluded2520 = ["color", "size", "className"],
    _excluded2521 = ["color", "size", "className"],
    _excluded2522 = ["color", "size", "className"],
    _excluded2523 = ["color", "size", "className"],
    _excluded2524 = ["color", "size", "className"],
    _excluded2525 = ["color", "size", "className"],
    _excluded2526 = ["color", "size", "className"],
    _excluded2527 = ["color", "size", "className"],
    _excluded2528 = ["color", "size", "className"],
    _excluded2529 = ["color", "size", "className"],
    _excluded2530 = ["color", "size", "className"],
    _excluded2531 = ["color", "size", "className"],
    _excluded2532 = ["color", "size", "className"],
    _excluded2533 = ["color", "size", "className"],
    _excluded2534 = ["color", "size", "className"],
    _excluded2535 = ["color", "size", "className"],
    _excluded2536 = ["color", "size", "className"],
    _excluded2537 = ["color", "size", "className"],
    _excluded2538 = ["color", "size", "className"],
    _excluded2539 = ["color", "size", "className"],
    _excluded2540 = ["color", "size", "className"],
    _excluded2541 = ["color", "size", "className"],
    _excluded2542 = ["color", "size", "className"],
    _excluded2543 = ["color", "size", "className"],
    _excluded2544 = ["color", "size", "className"],
    _excluded2545 = ["color", "size", "className"],
    _excluded2546 = ["color", "size", "className"],
    _excluded2547 = ["color", "size", "className"],
    _excluded2548 = ["color", "size", "className"],
    _excluded2549 = ["color", "size", "className"],
    _excluded2550 = ["color", "size", "className"],
    _excluded2551 = ["color", "size", "className"],
    _excluded2552 = ["color", "size", "className"],
    _excluded2553 = ["color", "size", "className"],
    _excluded2554 = ["color", "size", "className"],
    _excluded2555 = ["color", "size", "className"],
    _excluded2556 = ["color", "size", "className"],
    _excluded2557 = ["color", "size", "className"],
    _excluded2558 = ["color", "size", "className"],
    _excluded2559 = ["color", "size", "className"],
    _excluded2560 = ["color", "size", "className"],
    _excluded2561 = ["color", "size", "className"],
    _excluded2562 = ["color", "size", "className"],
    _excluded2563 = ["color", "size", "className"],
    _excluded2564 = ["color", "size", "className"],
    _excluded2565 = ["color", "size", "className"],
    _excluded2566 = ["color", "size", "className"],
    _excluded2567 = ["color", "size", "className"],
    _excluded2568 = ["color", "size", "className"],
    _excluded2569 = ["color", "size", "className"],
    _excluded2570 = ["color", "size", "className"],
    _excluded2571 = ["color", "size", "className"],
    _excluded2572 = ["color", "size", "className"],
    _excluded2573 = ["color", "size", "className"],
    _excluded2574 = ["color", "size", "className"],
    _excluded2575 = ["color", "size", "className"],
    _excluded2576 = ["color", "size", "className"],
    _excluded2577 = ["color", "size", "className"],
    _excluded2578 = ["color", "size", "className"],
    _excluded2579 = ["color", "size", "className"],
    _excluded2580 = ["color", "size", "className"],
    _excluded2581 = ["color", "size", "className"],
    _excluded2582 = ["color", "size", "className"],
    _excluded2583 = ["color", "size", "className"],
    _excluded2584 = ["color", "size", "className"],
    _excluded2585 = ["color", "size", "className"],
    _excluded2586 = ["color", "size", "className"],
    _excluded2587 = ["color", "size", "className"],
    _excluded2588 = ["color", "size", "className"],
    _excluded2589 = ["color", "size", "className"],
    _excluded2590 = ["color", "size", "className"],
    _excluded2591 = ["color", "size", "className"],
    _excluded2592 = ["color", "size", "className"],
    _excluded2593 = ["color", "size", "className"],
    _excluded2594 = ["color", "size", "className"],
    _excluded2595 = ["color", "size", "className"],
    _excluded2596 = ["color", "size", "className"],
    _excluded2597 = ["color", "size", "className"],
    _excluded2598 = ["color", "size", "className"],
    _excluded2599 = ["color", "size", "className"],
    _excluded2600 = ["color", "size", "className"],
    _excluded2601 = ["color", "size", "className"],
    _excluded2602 = ["color", "size", "className"],
    _excluded2603 = ["color", "size", "className"],
    _excluded2604 = ["color", "size", "className"],
    _excluded2605 = ["color", "size", "className"],
    _excluded2606 = ["color", "size", "className"],
    _excluded2607 = ["color", "size", "className"],
    _excluded2608 = ["color", "size", "className"],
    _excluded2609 = ["color", "size", "className"],
    _excluded2610 = ["color", "size", "className"],
    _excluded2611 = ["color", "size", "className"],
    _excluded2612 = ["color", "size", "className"],
    _excluded2613 = ["color", "size", "className"],
    _excluded2614 = ["color", "size", "className"],
    _excluded2615 = ["color", "size", "className"],
    _excluded2616 = ["color", "size", "className"],
    _excluded2617 = ["color", "size", "className"],
    _excluded2618 = ["color", "size", "className"],
    _excluded2619 = ["color", "size", "className"],
    _excluded2620 = ["color", "size", "className"],
    _excluded2621 = ["color", "size", "className"],
    _excluded2622 = ["color", "size", "className"],
    _excluded2623 = ["color", "size", "className"],
    _excluded2624 = ["color", "size", "className"],
    _excluded2625 = ["color", "size", "className"],
    _excluded2626 = ["color", "size", "className"],
    _excluded2627 = ["color", "size", "className"],
    _excluded2628 = ["color", "size", "className"],
    _excluded2629 = ["color", "size", "className"],
    _excluded2630 = ["color", "size", "className"],
    _excluded2631 = ["color", "size", "className"],
    _excluded2632 = ["color", "size", "className"],
    _excluded2633 = ["color", "size", "className"],
    _excluded2634 = ["color", "size", "className"],
    _excluded2635 = ["color", "size", "className"],
    _excluded2636 = ["color", "size", "className"],
    _excluded2637 = ["color", "size", "className"],
    _excluded2638 = ["color", "size", "className"],
    _excluded2639 = ["color", "size", "className"],
    _excluded2640 = ["color", "size", "className"],
    _excluded2641 = ["color", "size", "className"],
    _excluded2642 = ["color", "size", "className"],
    _excluded2643 = ["color", "size", "className"],
    _excluded2644 = ["color", "size", "className"],
    _excluded2645 = ["color", "size", "className"],
    _excluded2646 = ["color", "size", "className"],
    _excluded2647 = ["color", "size", "className"],
    _excluded2648 = ["color", "size", "className"],
    _excluded2649 = ["color", "size", "className"],
    _excluded2650 = ["color", "size", "className"],
    _excluded2651 = ["color", "size", "className"],
    _excluded2652 = ["color", "size", "className"],
    _excluded2653 = ["color", "size", "className"],
    _excluded2654 = ["color", "size", "className"],
    _excluded2655 = ["color", "size", "className"],
    _excluded2656 = ["color", "size", "className"],
    _excluded2657 = ["color", "size", "className"],
    _excluded2658 = ["color", "size", "className"],
    _excluded2659 = ["color", "size", "className"],
    _excluded2660 = ["color", "size", "className"],
    _excluded2661 = ["color", "size", "className"],
    _excluded2662 = ["color", "size", "className"],
    _excluded2663 = ["color", "size", "className"],
    _excluded2664 = ["color", "size", "className"],
    _excluded2665 = ["color", "size", "className"],
    _excluded2666 = ["color", "size", "className"],
    _excluded2667 = ["color", "size", "className"],
    _excluded2668 = ["color", "size", "className"],
    _excluded2669 = ["color", "size", "className"],
    _excluded2670 = ["color", "size", "className"],
    _excluded2671 = ["color", "size", "className"],
    _excluded2672 = ["color", "size", "className"],
    _excluded2673 = ["color", "size", "className"],
    _excluded2674 = ["color", "size", "className"],
    _excluded2675 = ["color", "size", "className"],
    _excluded2676 = ["color", "size", "className"],
    _excluded2677 = ["color", "size", "className"],
    _excluded2678 = ["color", "size", "className"],
    _excluded2679 = ["color", "size", "className"],
    _excluded2680 = ["color", "size", "className"],
    _excluded2681 = ["color", "size", "className"],
    _excluded2682 = ["color", "size", "className"],
    _excluded2683 = ["color", "size", "className"],
    _excluded2684 = ["color", "size", "className"],
    _excluded2685 = ["color", "size", "className"],
    _excluded2686 = ["color", "size", "className"],
    _excluded2687 = ["color", "size", "className"],
    _excluded2688 = ["color", "size", "className"],
    _excluded2689 = ["color", "size", "className"],
    _excluded2690 = ["color", "size", "className"],
    _excluded2691 = ["color", "size", "className"],
    _excluded2692 = ["color", "size", "className"],
    _excluded2693 = ["color", "size", "className"],
    _excluded2694 = ["color", "size", "className"],
    _excluded2695 = ["color", "size", "className"],
    _excluded2696 = ["color", "size", "className"],
    _excluded2697 = ["color", "size", "className"],
    _excluded2698 = ["color", "size", "className"],
    _excluded2699 = ["color", "size", "className"],
    _excluded2700 = ["color", "size", "className"],
    _excluded2701 = ["color", "size", "className"],
    _excluded2702 = ["color", "size", "className"],
    _excluded2703 = ["color", "size", "className"],
    _excluded2704 = ["color", "size", "className"],
    _excluded2705 = ["color", "size", "className"],
    _excluded2706 = ["color", "size", "className"],
    _excluded2707 = ["color", "size", "className"],
    _excluded2708 = ["color", "size", "className"],
    _excluded2709 = ["color", "size", "className"],
    _excluded2710 = ["color", "size", "className"],
    _excluded2711 = ["color", "size", "className"],
    _excluded2712 = ["color", "size", "className"],
    _excluded2713 = ["color", "size", "className"],
    _excluded2714 = ["color", "size", "className"],
    _excluded2715 = ["color", "size", "className"],
    _excluded2716 = ["color", "size", "className"],
    _excluded2717 = ["color", "size", "className"],
    _excluded2718 = ["color", "size", "className"],
    _excluded2719 = ["color", "size", "className"],
    _excluded2720 = ["color", "size", "className"],
    _excluded2721 = ["color", "size", "className"],
    _excluded2722 = ["color", "size", "className"],
    _excluded2723 = ["color", "size", "className"],
    _excluded2724 = ["color", "size", "className"],
    _excluded2725 = ["color", "size", "className"],
    _excluded2726 = ["color", "size", "className"],
    _excluded2727 = ["color", "size", "className"],
    _excluded2728 = ["color", "size", "className"],
    _excluded2729 = ["color", "size", "className"],
    _excluded2730 = ["color", "size", "className"],
    _excluded2731 = ["color", "size", "className"],
    _excluded2732 = ["color", "size", "className"],
    _excluded2733 = ["color", "size", "className"],
    _excluded2734 = ["color", "size", "className"],
    _excluded2735 = ["color", "size", "className"],
    _excluded2736 = ["color", "size", "className"],
    _excluded2737 = ["color", "size", "className"],
    _excluded2738 = ["color", "size", "className"],
    _excluded2739 = ["color", "size", "className"],
    _excluded2740 = ["color", "size", "className"],
    _excluded2741 = ["color", "size", "className"],
    _excluded2742 = ["color", "size", "className"],
    _excluded2743 = ["color", "size", "className"],
    _excluded2744 = ["color", "size", "className"],
    _excluded2745 = ["color", "size", "className"],
    _excluded2746 = ["color", "size", "className"],
    _excluded2747 = ["color", "size", "className"],
    _excluded2748 = ["color", "size", "className"],
    _excluded2749 = ["color", "size", "className"],
    _excluded2750 = ["color", "size", "className"],
    _excluded2751 = ["color", "size", "className"],
    _excluded2752 = ["color", "size", "className"],
    _excluded2753 = ["color", "size", "className"],
    _excluded2754 = ["color", "size", "className"],
    _excluded2755 = ["color", "size", "className"],
    _excluded2756 = ["color", "size", "className"],
    _excluded2757 = ["color", "size", "className"],
    _excluded2758 = ["color", "size", "className"],
    _excluded2759 = ["color", "size", "className"],
    _excluded2760 = ["color", "size", "className"],
    _excluded2761 = ["color", "size", "className"],
    _excluded2762 = ["color", "size", "className"],
    _excluded2763 = ["color", "size", "className"],
    _excluded2764 = ["color", "size", "className"],
    _excluded2765 = ["color", "size", "className"],
    _excluded2766 = ["color", "size", "className"],
    _excluded2767 = ["color", "size", "className"],
    _excluded2768 = ["color", "size", "className"],
    _excluded2769 = ["color", "size", "className"],
    _excluded2770 = ["color", "size", "className"],
    _excluded2771 = ["color", "size", "className"],
    _excluded2772 = ["color", "size", "className"],
    _excluded2773 = ["color", "size", "className"],
    _excluded2774 = ["color", "size", "className"],
    _excluded2775 = ["color", "size", "className"],
    _excluded2776 = ["color", "size", "className"],
    _excluded2777 = ["color", "size", "className"],
    _excluded2778 = ["color", "size", "className"],
    _excluded2779 = ["color", "size", "className"],
    _excluded2780 = ["color", "size", "className"],
    _excluded2781 = ["color", "size", "className"],
    _excluded2782 = ["color", "size", "className"],
    _excluded2783 = ["color", "size", "className"],
    _excluded2784 = ["color", "size", "className"],
    _excluded2785 = ["color", "size", "className"],
    _excluded2786 = ["color", "size", "className"],
    _excluded2787 = ["color", "size", "className"],
    _excluded2788 = ["color", "size", "className"],
    _excluded2789 = ["color", "size", "className"],
    _excluded2790 = ["color", "size", "className"],
    _excluded2791 = ["color", "size", "className"],
    _excluded2792 = ["color", "size", "className"],
    _excluded2793 = ["color", "size", "className"],
    _excluded2794 = ["color", "size", "className"],
    _excluded2795 = ["color", "size", "className"],
    _excluded2796 = ["color", "size", "className"],
    _excluded2797 = ["color", "size", "className"],
    _excluded2798 = ["color", "size", "className"],
    _excluded2799 = ["color", "size", "className"],
    _excluded2800 = ["color", "size", "className"],
    _excluded2801 = ["color", "size", "className"],
    _excluded2802 = ["color", "size", "className"],
    _excluded2803 = ["color", "size", "className"],
    _excluded2804 = ["color", "size", "className"],
    _excluded2805 = ["color", "size", "className"],
    _excluded2806 = ["color", "size", "className"],
    _excluded2807 = ["color", "size", "className"],
    _excluded2808 = ["color", "size", "className"],
    _excluded2809 = ["color", "size", "className"],
    _excluded2810 = ["color", "size", "className"],
    _excluded2811 = ["color", "size", "className"],
    _excluded2812 = ["color", "size", "className"],
    _excluded2813 = ["color", "size", "className"],
    _excluded2814 = ["color", "size", "className"],
    _excluded2815 = ["color", "size", "className"],
    _excluded2816 = ["color", "size", "className"],
    _excluded2817 = ["color", "size", "className"],
    _excluded2818 = ["color", "size", "className"],
    _excluded2819 = ["color", "size", "className"],
    _excluded2820 = ["color", "size", "className"],
    _excluded2821 = ["color", "size", "className"],
    _excluded2822 = ["color", "size", "className"],
    _excluded2823 = ["color", "size", "className"],
    _excluded2824 = ["color", "size", "className"],
    _excluded2825 = ["color", "size", "className"],
    _excluded2826 = ["color", "size", "className"],
    _excluded2827 = ["color", "size", "className"],
    _excluded2828 = ["color", "size", "className"],
    _excluded2829 = ["color", "size", "className"],
    _excluded2830 = ["color", "size", "className"],
    _excluded2831 = ["color", "size", "className"],
    _excluded2832 = ["color", "size", "className"],
    _excluded2833 = ["color", "size", "className"],
    _excluded2834 = ["color", "size", "className"],
    _excluded2835 = ["color", "size", "className"],
    _excluded2836 = ["color", "size", "className"],
    _excluded2837 = ["color", "size", "className"],
    _excluded2838 = ["color", "size", "className"],
    _excluded2839 = ["color", "size", "className"],
    _excluded2840 = ["color", "size", "className"],
    _excluded2841 = ["color", "size", "className"],
    _excluded2842 = ["color", "size", "className"],
    _excluded2843 = ["color", "size", "className"],
    _excluded2844 = ["color", "size", "className"],
    _excluded2845 = ["color", "size", "className"],
    _excluded2846 = ["color", "size", "className"],
    _excluded2847 = ["color", "size", "className"],
    _excluded2848 = ["color", "size", "className"],
    _excluded2849 = ["color", "size", "className"],
    _excluded2850 = ["color", "size", "className"],
    _excluded2851 = ["color", "size", "className"],
    _excluded2852 = ["color", "size", "className"],
    _excluded2853 = ["color", "size", "className"],
    _excluded2854 = ["color", "size", "className"],
    _excluded2855 = ["color", "size", "className"],
    _excluded2856 = ["color", "size", "className"],
    _excluded2857 = ["color", "size", "className"],
    _excluded2858 = ["color", "size", "className"],
    _excluded2859 = ["color", "size", "className"],
    _excluded2860 = ["color", "size", "className"],
    _excluded2861 = ["color", "size", "className"],
    _excluded2862 = ["color", "size", "className"],
    _excluded2863 = ["color", "size", "className"],
    _excluded2864 = ["color", "size", "className"],
    _excluded2865 = ["color", "size", "className"],
    _excluded2866 = ["color", "size", "className"],
    _excluded2867 = ["color", "size", "className"],
    _excluded2868 = ["color", "size", "className"],
    _excluded2869 = ["color", "size", "className"],
    _excluded2870 = ["color", "size", "className"],
    _excluded2871 = ["color", "size", "className"],
    _excluded2872 = ["color", "size", "className"],
    _excluded2873 = ["color", "size", "className"],
    _excluded2874 = ["color", "size", "className"],
    _excluded2875 = ["color", "size", "className"],
    _excluded2876 = ["color", "size", "className"],
    _excluded2877 = ["color", "size", "className"],
    _excluded2878 = ["color", "size", "className"],
    _excluded2879 = ["color", "size", "className"],
    _excluded2880 = ["color", "size", "className"],
    _excluded2881 = ["color", "size", "className"],
    _excluded2882 = ["color", "size", "className"],
    _excluded2883 = ["color", "size", "className"],
    _excluded2884 = ["color", "size", "className"],
    _excluded2885 = ["color", "size", "className"],
    _excluded2886 = ["color", "size", "className"],
    _excluded2887 = ["color", "size", "className"],
    _excluded2888 = ["color", "size", "className"],
    _excluded2889 = ["color", "size", "className"],
    _excluded2890 = ["color", "size", "className"],
    _excluded2891 = ["color", "size", "className"],
    _excluded2892 = ["color", "size", "className"],
    _excluded2893 = ["color", "size", "className"],
    _excluded2894 = ["color", "size", "className"],
    _excluded2895 = ["color", "size", "className"],
    _excluded2896 = ["color", "size", "className"],
    _excluded2897 = ["color", "size", "className"],
    _excluded2898 = ["color", "size", "className"],
    _excluded2899 = ["color", "size", "className"],
    _excluded2900 = ["color", "size", "className"],
    _excluded2901 = ["color", "size", "className"],
    _excluded2902 = ["color", "size", "className"],
    _excluded2903 = ["color", "size", "className"],
    _excluded2904 = ["color", "size", "className"],
    _excluded2905 = ["color", "size", "className"],
    _excluded2906 = ["color", "size", "className"],
    _excluded2907 = ["color", "size", "className"],
    _excluded2908 = ["color", "size", "className"],
    _excluded2909 = ["color", "size", "className"],
    _excluded2910 = ["color", "size", "className"],
    _excluded2911 = ["color", "size", "className"],
    _excluded2912 = ["color", "size", "className"],
    _excluded2913 = ["color", "size", "className"],
    _excluded2914 = ["color", "size", "className"],
    _excluded2915 = ["color", "size", "className"],
    _excluded2916 = ["color", "size", "className"],
    _excluded2917 = ["color", "size", "className"],
    _excluded2918 = ["color", "size", "className"],
    _excluded2919 = ["color", "size", "className"],
    _excluded2920 = ["color", "size", "className"],
    _excluded2921 = ["color", "size", "className"],
    _excluded2922 = ["color", "size", "className"],
    _excluded2923 = ["color", "size", "className"],
    _excluded2924 = ["color", "size", "className"],
    _excluded2925 = ["color", "size", "className"],
    _excluded2926 = ["color", "size", "className"],
    _excluded2927 = ["color", "size", "className"],
    _excluded2928 = ["color", "size", "className"],
    _excluded2929 = ["color", "size", "className"],
    _excluded2930 = ["color", "size", "className"],
    _excluded2931 = ["color", "size", "className"],
    _excluded2932 = ["color", "size", "className"],
    _excluded2933 = ["color", "size", "className"],
    _excluded2934 = ["color", "size", "className"],
    _excluded2935 = ["color", "size", "className"],
    _excluded2936 = ["color", "size", "className"],
    _excluded2937 = ["color", "size", "className"],
    _excluded2938 = ["color", "size", "className"],
    _excluded2939 = ["color", "size", "className"],
    _excluded2940 = ["color", "size", "className"],
    _excluded2941 = ["color", "size", "className"],
    _excluded2942 = ["color", "size", "className"],
    _excluded2943 = ["color", "size", "className"],
    _excluded2944 = ["color", "size", "className"],
    _excluded2945 = ["color", "size", "className"],
    _excluded2946 = ["color", "size", "className"],
    _excluded2947 = ["color", "size", "className"],
    _excluded2948 = ["color", "size", "className"],
    _excluded2949 = ["color", "size", "className"],
    _excluded2950 = ["color", "size", "className"],
    _excluded2951 = ["color", "size", "className"],
    _excluded2952 = ["color", "size", "className"],
    _excluded2953 = ["color", "size", "className"],
    _excluded2954 = ["color", "size", "className"],
    _excluded2955 = ["color", "size", "className"],
    _excluded2956 = ["color", "size", "className"],
    _excluded2957 = ["color", "size", "className"],
    _excluded2958 = ["color", "size", "className"],
    _excluded2959 = ["color", "size", "className"],
    _excluded2960 = ["color", "size", "className"],
    _excluded2961 = ["color", "size", "className"],
    _excluded2962 = ["color", "size", "className"],
    _excluded2963 = ["color", "size", "className"],
    _excluded2964 = ["color", "size", "className"],
    _excluded2965 = ["color", "size", "className"],
    _excluded2966 = ["color", "size", "className"],
    _excluded2967 = ["color", "size", "className"],
    _excluded2968 = ["color", "size", "className"],
    _excluded2969 = ["color", "size", "className"],
    _excluded2970 = ["color", "size", "className"],
    _excluded2971 = ["color", "size", "className"],
    _excluded2972 = ["color", "size", "className"],
    _excluded2973 = ["color", "size", "className"],
    _excluded2974 = ["color", "size", "className"],
    _excluded2975 = ["color", "size", "className"],
    _excluded2976 = ["color", "size", "className"],
    _excluded2977 = ["color", "size", "className"],
    _excluded2978 = ["color", "size", "className"],
    _excluded2979 = ["color", "size", "className"],
    _excluded2980 = ["color", "size", "className"],
    _excluded2981 = ["color", "size", "className"],
    _excluded2982 = ["color", "size", "className"],
    _excluded2983 = ["color", "size", "className"],
    _excluded2984 = ["color", "size", "className"],
    _excluded2985 = ["color", "size", "className"],
    _excluded2986 = ["color", "size", "className"],
    _excluded2987 = ["color", "size", "className"],
    _excluded2988 = ["color", "size", "className"],
    _excluded2989 = ["color", "size", "className"],
    _excluded2990 = ["color", "size", "className"],
    _excluded2991 = ["color", "size", "className"],
    _excluded2992 = ["color", "size", "className"],
    _excluded2993 = ["color", "size", "className"],
    _excluded2994 = ["color", "size", "className"],
    _excluded2995 = ["color", "size", "className"],
    _excluded2996 = ["color", "size", "className"],
    _excluded2997 = ["color", "size", "className"],
    _excluded2998 = ["color", "size", "className"],
    _excluded2999 = ["color", "size", "className"],
    _excluded3000 = ["color", "size", "className"],
    _excluded3001 = ["color", "size", "className"],
    _excluded3002 = ["color", "size", "className"],
    _excluded3003 = ["color", "size", "className"],
    _excluded3004 = ["color", "size", "className"],
    _excluded3005 = ["color", "size", "className"],
    _excluded3006 = ["color", "size", "className"],
    _excluded3007 = ["color", "size", "className"],
    _excluded3008 = ["color", "size", "className"],
    _excluded3009 = ["color", "size", "className"],
    _excluded3010 = ["color", "size", "className"],
    _excluded3011 = ["color", "size", "className"],
    _excluded3012 = ["color", "size", "className"],
    _excluded3013 = ["color", "size", "className"],
    _excluded3014 = ["color", "size", "className"],
    _excluded3015 = ["color", "size", "className"],
    _excluded3016 = ["color", "size", "className"],
    _excluded3017 = ["color", "size", "className"],
    _excluded3018 = ["color", "size", "className"],
    _excluded3019 = ["color", "size", "className"],
    _excluded3020 = ["color", "size", "className"],
    _excluded3021 = ["color", "size", "className"],
    _excluded3022 = ["color", "size", "className"],
    _excluded3023 = ["color", "size", "className"],
    _excluded3024 = ["color", "size", "className"],
    _excluded3025 = ["color", "size", "className"],
    _excluded3026 = ["color", "size", "className"],
    _excluded3027 = ["color", "size", "className"],
    _excluded3028 = ["color", "size", "className"],
    _excluded3029 = ["color", "size", "className"],
    _excluded3030 = ["color", "size", "className"],
    _excluded3031 = ["color", "size", "className"],
    _excluded3032 = ["color", "size", "className"],
    _excluded3033 = ["color", "size", "className"],
    _excluded3034 = ["color", "size", "className"],
    _excluded3035 = ["color", "size", "className"],
    _excluded3036 = ["color", "size", "className"],
    _excluded3037 = ["color", "size", "className"],
    _excluded3038 = ["color", "size", "className"],
    _excluded3039 = ["color", "size", "className"],
    _excluded3040 = ["color", "size", "className"],
    _excluded3041 = ["color", "size", "className"],
    _excluded3042 = ["color", "size", "className"],
    _excluded3043 = ["color", "size", "className"],
    _excluded3044 = ["color", "size", "className"],
    _excluded3045 = ["color", "size", "className"],
    _excluded3046 = ["color", "size", "className"],
    _excluded3047 = ["color", "size", "className"],
    _excluded3048 = ["color", "size", "className"],
    _excluded3049 = ["color", "size", "className"],
    _excluded3050 = ["color", "size", "className"],
    _excluded3051 = ["color", "size", "className"],
    _excluded3052 = ["color", "size", "className"],
    _excluded3053 = ["color", "size", "className"],
    _excluded3054 = ["color", "size", "className"],
    _excluded3055 = ["color", "size", "className"],
    _excluded3056 = ["color", "size", "className"],
    _excluded3057 = ["color", "size", "className"],
    _excluded3058 = ["color", "size", "className"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * @remixicon/react v4.1.0 - Apache-2.0
 */
import t from "react";

var s = function s(_ref) {
  var _ref$color = _ref.color,
      C = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$size = _ref.size,
      e = _ref$size === void 0 ? 24 : _ref$size,
      l = _ref.className,
      i = _objectWithoutProperties(_ref, _excluded);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.0049 13.0028C13.6617 13.0028 15.0049 14.346 15.0049 16.0028C15.0049 16.8519 14.6521 17.6187 14.0851 18.1645L12.175 20.0024L15.0049 20.0028V22.0028H9.00488L9.00398 20.2784L12.6983 16.7234C12.8874 16.5411 13.0049 16.2857 13.0049 16.0028C13.0049 15.4505 12.5572 15.0028 12.0049 15.0028C11.4526 15.0028 11.0049 15.4505 11.0049 16.0028H9.00488C9.00488 14.346 10.348 13.0028 12.0049 13.0028ZM18.0049 13.0028V17.0028H20.0049V13.0028H22.0049V22.0028H20.0049V19.0028H16.0049V13.0028H18.0049ZM4.00488 12.0028C4.00488 14.5294 5.17612 16.7824 7.00527 18.2485L7.0049 20.665C4.01588 18.9359 2.00488 15.7042 2.00488 12.0028H4.00488ZM12.0049 2.00281C17.1902 2.00281 21.4537 5.94943 21.9555 11.0027L19.943 11.0029C19.4509 7.05652 16.0845 4.00281 12.0049 4.00281C9.54102 4.00281 7.33731 5.11664 5.8698 6.86824L8.00488 9.00281H2.00488V3.00281L4.45144 5.44929C6.28491 3.3379 8.98898 2.00281 12.0049 2.00281Z"
  }));
},
    r = function r(_ref2) {
  var _ref2$color = _ref2.color,
      C = _ref2$color === void 0 ? "currentColor" : _ref2$color,
      _ref2$size = _ref2.size,
      e = _ref2$size === void 0 ? 24 : _ref2$size,
      l = _ref2.className,
      i = _objectWithoutProperties(_ref2, _excluded2);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.0049 13.0028C13.6617 13.0028 15.0049 14.346 15.0049 16.0028C15.0049 16.8519 14.6521 17.6187 14.0851 18.1645L12.175 20.0024L15.0049 20.0028V22.0028H9.00488L9.00398 20.2784L12.6983 16.7234C12.8874 16.5411 13.0049 16.2857 13.0049 16.0028C13.0049 15.4505 12.5572 15.0028 12.0049 15.0028C11.4526 15.0028 11.0049 15.4505 11.0049 16.0028H9.00488C9.00488 14.346 10.348 13.0028 12.0049 13.0028ZM18.0049 13.0028V17.0028H20.0049V13.0028H22.0049V22.0028H20.0049V19.0028H16.0049V13.0028H18.0049ZM4.00488 12.0028C4.00488 14.5294 5.17612 16.7824 7.00527 18.2485L7.0049 20.665C4.01588 18.9359 2.00488 15.7042 2.00488 12.0028H4.00488ZM12.0049 2.00281C17.1902 2.00281 21.4537 5.94943 21.9555 11.0027L19.943 11.0029C19.4509 7.05652 16.0845 4.00281 12.0049 4.00281C9.2551 4.00281 6.82935 5.39014 5.3894 7.50305L8.00488 7.50281V9.50281H2.00488V3.50281H4.00488L4.00477 6.00198C5.82922 3.57356 8.73362 2.00281 12.0049 2.00281Z"
  }));
},
    c = function c(_ref3) {
  var _ref3$color = _ref3.color,
      C = _ref3$color === void 0 ? "currentColor" : _ref3$color,
      _ref3$size = _ref3.size,
      e = _ref3$size === void 0 ? 24 : _ref3$size,
      l = _ref3.className,
      i = _objectWithoutProperties(_ref3, _excluded3);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM11.5 13.5V12H10.5V9H9V12H7.5V9H6V13.5H9V15H10.5V13.5H11.5ZM18 15L15.75 12L18 9H16.25L14.5 11.25V9H13V15H14.5V12.75L16.25 15H18Z"
  }));
},
    o = function o(_ref4) {
  var _ref4$color = _ref4.color,
      C = _ref4$color === void 0 ? "currentColor" : _ref4$color,
      _ref4$size = _ref4.size,
      e = _ref4$size === void 0 ? 24 : _ref4$size,
      l = _ref4.className,
      i = _objectWithoutProperties(_ref4, _excluded4);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 5V19H20V5H4ZM3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM11.5 13.5H10.5V15H9V13.5H6V9H7.5V12H9V9H10.5V12H11.5V13.5ZM18 15H16.25L14.5 12.75V15H13V9H14.5V11.25L16.25 9H18L15.75 12L18 15Z"
  }));
},
    a = function a(_ref5) {
  var _ref5$color = _ref5.color,
      C = _ref5$color === void 0 ? "currentColor" : _ref5$color,
      _ref5$size = _ref5.size,
      e = _ref5$size === void 0 ? 24 : _ref5$size,
      l = _ref5.className,
      i = _objectWithoutProperties(_ref5, _excluded5);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5 15V17C5 18.0544 5.95 19 7 19H10V21H7C4.79086 21 3 19.2091 3 17V15H5ZM18 10L22.4 21H20.245L19.044 18H14.954L13.755 21H11.601L16 10H18ZM17 12.8852L15.753 16H18.245L17 12.8852ZM3 3H9C10.6569 3 12 4.34315 12 6C12 6.76878 11.7108 7.47002 11.2353 8.00088C11.7112 8.53084 12 9.23169 12 10C12 11.6569 10.6569 13 9 13H3V3ZM9 9H5V11H9C9.55228 11 10 10.5523 10 10C10 9.45 9.55 9 9 9ZM17 3C19.2091 3 21 4.79086 21 7V9H19V7C19 5.89543 18.1046 5 17 5H14V3H17ZM9 5H5V7H9C9.55228 7 10 6.55228 10 6C10 5.45 9.55 5 9 5Z"
  }));
},
    n = function n(_ref6) {
  var _ref6$color = _ref6.color,
      C = _ref6$color === void 0 ? "currentColor" : _ref6$color,
      _ref6$size = _ref6.size,
      e = _ref6$size === void 0 ? 24 : _ref6$size,
      l = _ref6.className,
      i = _objectWithoutProperties(_ref6, _excluded6);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 4.99509C3 3.89323 3.89262 3 4.99509 3H19.0049C20.1068 3 21 3.89262 21 4.99509V19.0049C21 20.1068 20.1074 21 19.0049 21H4.99509C3.89323 21 3 20.1074 3 19.0049V4.99509ZM6.35687 18H17.8475C16.5825 16.1865 14.4809 15 12.1022 15C9.72344 15 7.62182 16.1865 6.35687 18ZM12 13C13.933 13 15.5 11.433 15.5 9.5C15.5 7.567 13.933 6 12 6C10.067 6 8.5 7.567 8.5 9.5C8.5 11.433 10.067 13 12 13Z"
  }));
},
    m = function m(_ref7) {
  var _ref7$color = _ref7.color,
      C = _ref7$color === void 0 ? "currentColor" : _ref7$color,
      _ref7$size = _ref7.size,
      e = _ref7$size === void 0 ? 24 : _ref7$size,
      l = _ref7.className,
      i = _objectWithoutProperties(_ref7, _excluded7);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 4.99509C3 3.89323 3.89262 3 4.99509 3H19.0049C20.1068 3 21 3.89262 21 4.99509V19.0049C21 20.1068 20.1074 21 19.0049 21H4.99509C3.89323 21 3 20.1074 3 19.0049V4.99509ZM5 5V19H19V5H5ZM7.97216 18.1808C7.35347 17.9129 6.76719 17.5843 6.22083 17.2024C7.46773 15.2753 9.63602 14 12.1022 14C14.5015 14 16.6189 15.2071 17.8801 17.0472C17.3438 17.4436 16.7664 17.7877 16.1555 18.0718C15.2472 16.8166 13.77 16 12.1022 16C10.3865 16 8.87271 16.8641 7.97216 18.1808ZM12 13C10.067 13 8.5 11.433 8.5 9.5C8.5 7.567 10.067 6 12 6C13.933 6 15.5 7.567 15.5 9.5C15.5 11.433 13.933 13 12 13ZM12 11C12.8284 11 13.5 10.3284 13.5 9.5C13.5 8.67157 12.8284 8 12 8C11.1716 8 10.5 8.67157 10.5 9.5C10.5 10.3284 11.1716 11 12 11Z"
  }));
},
    w = function w(_ref8) {
  var _ref8$color = _ref8.color,
      C = _ref8$color === void 0 ? "currentColor" : _ref8$color,
      _ref8$size = _ref8.size,
      e = _ref8$size === void 0 ? 24 : _ref8$size,
      l = _ref8.className,
      i = _objectWithoutProperties(_ref8, _excluded8);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2ZM6.02332 15.4163C7.49083 17.6069 9.69511 19 12.1597 19C14.6243 19 16.8286 17.6069 18.2961 15.4163C16.6885 13.9172 14.5312 13 12.1597 13C9.78821 13 7.63095 13.9172 6.02332 15.4163ZM12 11C13.6569 11 15 9.65685 15 8C15 6.34315 13.6569 5 12 5C10.3431 5 9 6.34315 9 8C9 9.65685 10.3431 11 12 11Z"
  }));
},
    L = function L(_ref9) {
  var _ref9$color = _ref9.color,
      C = _ref9$color === void 0 ? "currentColor" : _ref9$color,
      _ref9$size = _ref9.size,
      e = _ref9$size === void 0 ? 24 : _ref9$size,
      l = _ref9.className,
      i = _objectWithoutProperties(_ref9, _excluded9);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12.1597 16C10.1243 16 8.29182 16.8687 7.01276 18.2556C8.38039 19.3474 10.114 20 12 20C13.9695 20 15.7727 19.2883 17.1666 18.1081C15.8956 16.8074 14.1219 16 12.1597 16ZM12 4C7.58172 4 4 7.58172 4 12C4 13.8106 4.6015 15.4807 5.61557 16.8214C7.25639 15.0841 9.58144 14 12.1597 14C14.6441 14 16.8933 15.0066 18.5218 16.6342C19.4526 15.3267 20 13.7273 20 12C20 7.58172 16.4183 4 12 4ZM12 5C14.2091 5 16 6.79086 16 9C16 11.2091 14.2091 13 12 13C9.79086 13 8 11.2091 8 9C8 6.79086 9.79086 5 12 5ZM12 7C10.8954 7 10 7.89543 10 9C10 10.1046 10.8954 11 12 11C13.1046 11 14 10.1046 14 9C14 7.89543 13.1046 7 12 7Z"
  }));
},
    h = function h(_ref10) {
  var _ref10$color = _ref10.color,
      C = _ref10$color === void 0 ? "currentColor" : _ref10$color,
      _ref10$size = _ref10.size,
      e = _ref10$size === void 0 ? 24 : _ref10$size,
      l = _ref10.className,
      i = _objectWithoutProperties(_ref10, _excluded10);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14 21L12 23L10 21H4.99509C3.89323 21 3 20.1074 3 19.0049V4.99509C3 3.89323 3.89262 3 4.99509 3H19.0049C20.1068 3 21 3.89262 21 4.99509V19.0049C21 20.1068 20.1074 21 19.0049 21H14ZM6.35687 18H17.8475C16.5825 16.1865 14.4809 15 12.1022 15C9.72344 15 7.62182 16.1865 6.35687 18ZM12 13C13.933 13 15.5 11.433 15.5 9.5C15.5 7.567 13.933 6 12 6C10.067 6 8.5 7.567 8.5 9.5C8.5 11.433 10.067 13 12 13Z"
  }));
},
    H = function H(_ref11) {
  var _ref11$color = _ref11.color,
      C = _ref11$color === void 0 ? "currentColor" : _ref11$color,
      _ref11$size = _ref11.size,
      e = _ref11$size === void 0 ? 24 : _ref11$size,
      l = _ref11.className,
      i = _objectWithoutProperties(_ref11, _excluded11);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14 21L12 23L10 21H4.99509C3.89323 21 3 20.1074 3 19.0049V4.99509C3 3.89323 3.89262 3 4.99509 3H19.0049C20.1068 3 21 3.89262 21 4.99509V19.0049C21 20.1068 20.1074 21 19.0049 21H14ZM19 19V5H5V19H10.8284L12 20.1716L13.1716 19H19ZM7.97216 18.1808C7.35347 17.9129 6.76719 17.5843 6.22083 17.2024C7.46773 15.2753 9.63602 14 12.1022 14C14.5015 14 16.6189 15.2071 17.8801 17.0472C17.3438 17.4436 16.7664 17.7877 16.1555 18.0718C15.2472 16.8166 13.77 16 12.1022 16C10.3865 16 8.87271 16.8641 7.97216 18.1808ZM12 13C10.067 13 8.5 11.433 8.5 9.5C8.5 7.567 10.067 6 12 6C13.933 6 15.5 7.567 15.5 9.5C15.5 11.433 13.933 13 12 13ZM12 11C12.8284 11 13.5 10.3284 13.5 9.5C13.5 8.67157 12.8284 8 12 8C11.1716 8 10.5 8.67157 10.5 9.5C10.5 10.3284 11.1716 11 12 11Z"
  }));
},
    V = function V(_ref12) {
  var _ref12$color = _ref12.color,
      C = _ref12$color === void 0 ? "currentColor" : _ref12$color,
      _ref12$size = _ref12.size,
      e = _ref12$size === void 0 ? 24 : _ref12$size,
      l = _ref12.className,
      i = _objectWithoutProperties(_ref12, _excluded12);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14.2558 21.7442L12 24L9.74416 21.7442C5.30941 20.7204 2 16.7443 2 12C2 6.48 6.48 2 12 2C17.52 2 22 6.48 22 12C22 16.7443 18.6906 20.7204 14.2558 21.7442ZM6.02332 15.4163C7.49083 17.6069 9.69511 19 12.1597 19C14.6243 19 16.8286 17.6069 18.2961 15.4163C16.6885 13.9172 14.5312 13 12.1597 13C9.78821 13 7.63095 13.9172 6.02332 15.4163ZM12 11C13.6569 11 15 9.65685 15 8C15 6.34315 13.6569 5 12 5C10.3431 5 9 6.34315 9 8C9 9.65685 10.3431 11 12 11Z"
  }));
},
    g = function g(_ref13) {
  var _ref13$color = _ref13.color,
      C = _ref13$color === void 0 ? "currentColor" : _ref13$color,
      _ref13$size = _ref13.size,
      e = _ref13$size === void 0 ? 24 : _ref13$size,
      l = _ref13.className,
      i = _objectWithoutProperties(_ref13, _excluded13);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9.74462 21.7446C5.30798 20.7219 2 16.7473 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 16.7473 18.692 20.7219 14.2554 21.7446L12 24L9.74462 21.7446ZM7.01173 18.2567C7.92447 18.986 9.00433 19.5215 10.1939 19.7957L10.7531 19.9246L12 21.1716L13.2469 19.9246L13.8061 19.7957C15.0745 19.5033 16.2183 18.9139 17.1676 18.1091C15.8965 16.8078 14.1225 16 12.1597 16C10.1238 16 8.29083 16.8692 7.01173 18.2567ZM5.61562 16.8214C7.25644 15.0841 9.58146 14 12.1597 14C14.644 14 16.8931 15.0065 18.5216 16.634C19.4563 15.3185 20 13.7141 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 13.7964 4.59708 15.4722 5.61562 16.8214ZM12 13C9.79086 13 8 11.2091 8 9C8 6.79086 9.79086 5 12 5C14.2091 5 16 6.79086 16 9C16 11.2091 14.2091 13 12 13ZM12 11C13.1046 11 14 10.1046 14 9C14 7.89543 13.1046 7 12 7C10.8954 7 10 7.89543 10 9C10 10.1046 10.8954 11 12 11Z"
  }));
},
    M = function M(_ref14) {
  var _ref14$color = _ref14.color,
      C = _ref14$color === void 0 ? "currentColor" : _ref14$color,
      _ref14$size = _ref14.size,
      e = _ref14$size === void 0 ? 24 : _ref14$size,
      l = _ref14.className,
      i = _objectWithoutProperties(_ref14, _excluded14);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM11 11H7V13H11V17H13V13H17V11H13V7H11V11Z"
  }));
},
    Z = function Z(_ref15) {
  var _ref15$color = _ref15.color,
      C = _ref15$color === void 0 ? "currentColor" : _ref15$color,
      _ref15$size = _ref15.size,
      e = _ref15$size === void 0 ? 24 : _ref15$size,
      l = _ref15.className,
      i = _objectWithoutProperties(_ref15, _excluded15);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM5 5V19H19V5H5ZM11 11V7H13V11H17V13H13V17H11V13H7V11H11Z"
  }));
},
    x = function x(_ref16) {
  var _ref16$color = _ref16.color,
      C = _ref16$color === void 0 ? "currentColor" : _ref16$color,
      _ref16$size = _ref16.size,
      e = _ref16$size === void 0 ? 24 : _ref16$size,
      l = _ref16.className,
      i = _objectWithoutProperties(_ref16, _excluded16);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM11 11H7V13H11V17H13V13H17V11H13V7H11V11Z"
  }));
},
    v = function v(_ref17) {
  var _ref17$color = _ref17.color,
      C = _ref17$color === void 0 ? "currentColor" : _ref17$color,
      _ref17$size = _ref17.size,
      e = _ref17$size === void 0 ? 24 : _ref17$size,
      l = _ref17.className,
      i = _objectWithoutProperties(_ref17, _excluded17);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11 11V7H13V11H17V13H13V17H11V13H7V11H11ZM12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
  }));
},
    d = function d(_ref18) {
  var _ref18$color = _ref18.color,
      C = _ref18$color === void 0 ? "currentColor" : _ref18$color,
      _ref18$size = _ref18.size,
      e = _ref18$size === void 0 ? 24 : _ref18$size,
      l = _ref18.className,
      i = _objectWithoutProperties(_ref18, _excluded18);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11 11V5H13V11H19V13H13V19H11V13H5V11H11Z"
  }));
},
    p = function p(_ref19) {
  var _ref19$color = _ref19.color,
      C = _ref19$color === void 0 ? "currentColor" : _ref19$color,
      _ref19$size = _ref19.size,
      e = _ref19$size === void 0 ? 24 : _ref19$size,
      l = _ref19.className,
      i = _objectWithoutProperties(_ref19, _excluded19);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11 11V5H13V11H19V13H13V19H11V13H5V11H11Z"
  }));
},
    E = function E(_ref20) {
  var _ref20$color = _ref20.color,
      C = _ref20$color === void 0 ? "currentColor" : _ref20$color,
      _ref20$size = _ref20.size,
      e = _ref20$size === void 0 ? 24 : _ref20$size,
      l = _ref20.className,
      i = _objectWithoutProperties(_ref20, _excluded20);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 14V22H4C4 17.5817 7.58172 14 12 14ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM21 17H22V22H14V17H15V16C15 14.3431 16.3431 13 18 13C19.6569 13 21 14.3431 21 16V17ZM19 17V16C19 15.4477 18.5523 15 18 15C17.4477 15 17 15.4477 17 16V17H19Z"
  }));
},
    N = function N(_ref21) {
  var _ref21$color = _ref21.color,
      C = _ref21$color === void 0 ? "currentColor" : _ref21$color,
      _ref21$size = _ref21.size,
      e = _ref21$size === void 0 ? 24 : _ref21$size,
      l = _ref21.className,
      i = _objectWithoutProperties(_ref21, _excluded21);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 14V16C8.68629 16 6 18.6863 6 22H4C4 17.5817 7.58172 14 12 14ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11ZM21 17H22V22H14V17H15V16C15 14.3431 16.3431 13 18 13C19.6569 13 21 14.3431 21 16V17ZM19 17V16C19 15.4477 18.5523 15 18 15C17.4477 15 17 15.4477 17 16V17H19Z"
  }));
},
    u = function u(_ref22) {
  var _ref22$color = _ref22.color,
      C = _ref22$color === void 0 ? "currentColor" : _ref22$color,
      _ref22$size = _ref22.size,
      e = _ref22$size === void 0 ? 24 : _ref22$size,
      l = _ref22.className,
      i = _objectWithoutProperties(_ref22, _excluded22);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7.55197 13 8.39897 10.8852 9.24398 13H7.55197ZM16 12H17V14H16C15.4477 14 15 13.5523 15 13 15 12.4477 15.4477 12 16 12ZM21 3H3C2.44772 3 2 3.44772 2 4V20C2 20.5523 2.44772 21 3 21H21C21.5523 21 22 20.5523 22 20V4C22 3.44772 21.5523 3 21 3ZM12.598 16H10.443L10.043 15H6.75297L6.35297 16H4.19897L5.39797 13.002 5.39897 13 7.39897 8H9.39897L12.598 16ZM17 8H19V16H16C14.3431 16 13 14.6569 13 13 13 11.3431 14.3431 10 16 10H17V8Z"
  }));
},
    B = function B(_ref23) {
  var _ref23$color = _ref23.color,
      C = _ref23$color === void 0 ? "currentColor" : _ref23$color,
      _ref23$size = _ref23.size,
      e = _ref23$size === void 0 ? 24 : _ref23$size,
      l = _ref23.className,
      i = _objectWithoutProperties(_ref23, _excluded23);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.598 16 9.39893 8H7.39893L5.39893 13 5.39795 13.002 4.19897 16H6.35303L6.75293 15H10.043L10.443 16H12.598ZM7.552 13 8.39893 10.8851 9.24402 13H7.552ZM17 8H19V16H16C14.3431 16 13 14.6569 13 13 13 11.3431 14.3431 10 16 10H17V8ZM16 12C15.4478 12 15 12.4478 15 13 15 13.5522 15.4478 14 16 14H17V12H16ZM21 3H3C2.44775 3 2 3.44775 2 4V20C2 20.5522 2.44775 21 3 21H21C21.5522 21 22 20.5522 22 20V4C22 3.44775 21.5522 3 21 3ZM4 19V5H20V19H4Z"
  }));
},
    f = function f(_ref24) {
  var _ref24$color = _ref24.color,
      C = _ref24$color === void 0 ? "currentColor" : _ref24$color,
      _ref24$size = _ref24.size,
      e = _ref24$size === void 0 ? 24 : _ref24$size,
      l = _ref24.className,
      i = _objectWithoutProperties(_ref24, _excluded24);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.4 13.5333L17.4 20.2C17.5657 20.4209 17.5209 20.7343 17.3 20.9C17.2135 20.9649 17.1082 21 17 21H7C6.72386 21 6.5 20.7761 6.5 20.5C6.5 20.3918 6.53509 20.2865 6.6 20.2L11.6 13.5333C11.7657 13.3124 12.0791 13.2676 12.3 13.4333C12.3379 13.4618 12.3716 13.4954 12.4 13.5333ZM18 19V17H20V5H4V17H6V19H2.9918C2.44405 19 2 18.5554 2 17.9991V4.00087C2 3.44811 2.45531 3 2.9918 3H21.0082C21.556 3 22 3.44463 22 4.00087V17.9991C22 18.5519 21.5447 19 21.0082 19H18Z"
  }));
},
    R = function R(_ref25) {
  var _ref25$color = _ref25.color,
      C = _ref25$color === void 0 ? "currentColor" : _ref25$color,
      _ref25$size = _ref25.size,
      e = _ref25$size === void 0 ? 24 : _ref25$size,
      l = _ref25.className,
      i = _objectWithoutProperties(_ref25, _excluded25);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.4 13.5333L17.4 20.2C17.5657 20.4209 17.5209 20.7343 17.3 20.9C17.2135 20.9649 17.1082 21 17 21H7C6.72386 21 6.5 20.7761 6.5 20.5C6.5 20.3918 6.53509 20.2865 6.6 20.2L11.6 13.5333C11.7657 13.3124 12.0791 13.2676 12.3 13.4333C12.3379 13.4618 12.3716 13.4954 12.4 13.5333ZM12 16.33L10 19H14L12 16.33ZM18 19V17H20V5H4V17H6V19H2.9918C2.44405 19 2 18.5554 2 17.9991V4.00087C2 3.44811 2.45531 3 2.9918 3H21.0082C21.556 3 22 3.44463 22 4.00087V17.9991C22 18.5519 21.5447 19 21.0082 19H18Z"
  }));
},
    z = function z(_ref26) {
  var _ref26$color = _ref26.color,
      C = _ref26$color === void 0 ? "currentColor" : _ref26$color,
      _ref26$size = _ref26.size,
      e = _ref26$size === void 0 ? 24 : _ref26$size,
      l = _ref26.className,
      i = _objectWithoutProperties(_ref26, _excluded26);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.0001 22.0001C7.02956 22.0001 3.00012 17.9707 3.00012 13.0001C3.00012 8.02956 7.02956 4.00012 12.0001 4.00012C16.9707 4.00012 21.0001 8.02956 21.0001 13.0001C21.0001 17.9707 16.9707 22.0001 12.0001 22.0001ZM13.0001 13.0001V8.00012H11.0001V15.0001H16.0001V13.0001H13.0001ZM1.74707 6.2826L5.2826 2.74707L6.69682 4.16128L3.16128 7.69682L1.74707 6.2826ZM18.7176 2.74707L22.2532 6.2826L20.839 7.69682L17.3034 4.16128L18.7176 2.74707Z"
  }));
},
    F = function F(_ref27) {
  var _ref27$color = _ref27.color,
      C = _ref27$color === void 0 ? "currentColor" : _ref27$color,
      _ref27$size = _ref27.size,
      e = _ref27$size === void 0 ? 24 : _ref27$size,
      l = _ref27.className,
      i = _objectWithoutProperties(_ref27, _excluded27);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.0001 22.0001C7.02956 22.0001 3.00012 17.9707 3.00012 13.0001C3.00012 8.02956 7.02956 4.00012 12.0001 4.00012C16.9707 4.00012 21.0001 8.02956 21.0001 13.0001C21.0001 17.9707 16.9707 22.0001 12.0001 22.0001ZM12.0001 20.0001C15.8661 20.0001 19.0001 16.8661 19.0001 13.0001C19.0001 9.13412 15.8661 6.00012 12.0001 6.00012C8.13412 6.00012 5.00012 9.13412 5.00012 13.0001C5.00012 16.8661 8.13412 20.0001 12.0001 20.0001ZM13.0001 13.0001H16.0001V15.0001H11.0001V8.00012H13.0001V13.0001ZM1.74707 6.2826L5.2826 2.74707L6.69682 4.16128L3.16128 7.69682L1.74707 6.2826ZM18.7176 2.74707L22.2532 6.2826L20.839 7.69682L17.3034 4.16128L18.7176 2.74707Z"
  }));
},
    S = function S(_ref28) {
  var _ref28$color = _ref28.color,
      C = _ref28$color === void 0 ? "currentColor" : _ref28$color,
      _ref28$size = _ref28.size,
      e = _ref28$size === void 0 ? 24 : _ref28$size,
      l = _ref28.className,
      i = _objectWithoutProperties(_ref28, _excluded28);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4.00001 20V14C4.00001 9.58172 7.58173 6 12 6C16.4183 6 20 9.58172 20 14V20H21V22H3.00001V20H4.00001ZM6.00001 14H8.00001C8.00001 11.7909 9.79087 10 12 10V8C8.6863 8 6.00001 10.6863 6.00001 14ZM11 2H13V5H11V2ZM19.7782 4.80761L21.1924 6.22183L19.0711 8.34315L17.6569 6.92893L19.7782 4.80761ZM2.80762 6.22183L4.22183 4.80761L6.34315 6.92893L4.92894 8.34315L2.80762 6.22183Z"
  }));
},
    A = function A(_ref29) {
  var _ref29$color = _ref29.color,
      C = _ref29$color === void 0 ? "currentColor" : _ref29$color,
      _ref29$size = _ref29.size,
      e = _ref29$size === void 0 ? 24 : _ref29$size,
      l = _ref29.className,
      i = _objectWithoutProperties(_ref29, _excluded29);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4.00001 20V14C4.00001 9.58172 7.58173 6 12 6C16.4183 6 20 9.58172 20 14V20H21V22H3.00001V20H4.00001ZM6.00001 20H18V14C18 10.6863 15.3137 8 12 8C8.6863 8 6.00001 10.6863 6.00001 14V20ZM11 2H13V5H11V2ZM19.7782 4.80761L21.1924 6.22183L19.0711 8.34315L17.6569 6.92893L19.7782 4.80761ZM2.80762 6.22183L4.22183 4.80761L6.34315 6.92893L4.92894 8.34315L2.80762 6.22183ZM7.00001 14C7.00001 11.2386 9.23858 9 12 9V11C10.3432 11 9.00001 12.3431 9.00001 14H7.00001Z"
  }));
},
    k = function k(_ref30) {
  var _ref30$color = _ref30.color,
      C = _ref30$color === void 0 ? "currentColor" : _ref30$color,
      _ref30$size = _ref30.size,
      e = _ref30$size === void 0 ? 24 : _ref30$size,
      l = _ref30.className,
      i = _objectWithoutProperties(_ref30, _excluded30);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2ZM12 16C14.2133 16 16 14.2133 16 12C16 9.78667 14.2133 8 12 8C9.78667 8 8 9.78667 8 12C8 14.2133 9.78667 16 12 16ZM12 11C12.55 11 13 11.45 13 12C13 12.55 12.55 13 12 13C11.45 13 11 12.55 11 12C11 11.45 11.45 11 12 11Z"
  }));
},
    P = function P(_ref31) {
  var _ref31$color = _ref31.color,
      C = _ref31$color === void 0 ? "currentColor" : _ref31$color,
      _ref31$size = _ref31.size,
      e = _ref31$size === void 0 ? 24 : _ref31$size,
      l = _ref31.className,
      i = _objectWithoutProperties(_ref31, _excluded31);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14ZM12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12C16 14.2091 14.2091 16 12 16Z"
  }));
},
    D = function D(_ref32) {
  var _ref32$color = _ref32.color,
      C = _ref32$color === void 0 ? "currentColor" : _ref32$color,
      _ref32$size = _ref32.size,
      e = _ref32$size === void 0 ? 24 : _ref32$size,
      l = _ref32.className,
      i = _objectWithoutProperties(_ref32, _excluded32);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.8659 3.00017L22.3922 19.5002C22.6684 19.9785 22.5045 20.5901 22.0262 20.8662C21.8742 20.954 21.7017 21.0002 21.5262 21.0002H2.47363C1.92135 21.0002 1.47363 20.5525 1.47363 20.0002C1.47363 19.8246 1.51984 19.6522 1.60761 19.5002L11.1339 3.00017C11.41 2.52187 12.0216 2.358 12.4999 2.63414C12.6519 2.72191 12.7782 2.84815 12.8659 3.00017ZM10.9999 16.0002V18.0002H12.9999V16.0002H10.9999ZM10.9999 9.00017V14.0002H12.9999V9.00017H10.9999Z"
  }));
},
    y = function y(_ref33) {
  var _ref33$color = _ref33.color,
      C = _ref33$color === void 0 ? "currentColor" : _ref33$color,
      _ref33$size = _ref33.size,
      e = _ref33$size === void 0 ? 24 : _ref33$size,
      l = _ref33.className,
      i = _objectWithoutProperties(_ref33, _excluded33);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.8659 3.00017L22.3922 19.5002C22.6684 19.9785 22.5045 20.5901 22.0262 20.8662C21.8742 20.954 21.7017 21.0002 21.5262 21.0002H2.47363C1.92135 21.0002 1.47363 20.5525 1.47363 20.0002C1.47363 19.8246 1.51984 19.6522 1.60761 19.5002L11.1339 3.00017C11.41 2.52187 12.0216 2.358 12.4999 2.63414C12.6519 2.72191 12.7782 2.84815 12.8659 3.00017ZM4.20568 19.0002H19.7941L11.9999 5.50017L4.20568 19.0002ZM10.9999 16.0002H12.9999V18.0002H10.9999V16.0002ZM10.9999 9.00017H12.9999V14.0002H10.9999V9.00017Z"
  }));
},
    b = function b(_ref34) {
  var _ref34$color = _ref34.color,
      C = _ref34$color === void 0 ? "currentColor" : _ref34$color,
      _ref34$size = _ref34.size,
      e = _ref34$size === void 0 ? 24 : _ref34$size,
      l = _ref34.className,
      i = _objectWithoutProperties(_ref34, _excluded34);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C16.6944 2 20.5 5.80558 20.5 10.5C20.5 17 15 22.5 12 22.5C9 22.5 3.5 17 3.5 10.5C3.5 5.80558 7.30558 2 12 2ZM17.5 12C15.0147 12 13 14.0147 13 16.5C13 16.6603 13.0084 16.8186 13.0252 16.9752C13.1812 16.9916 13.3396 17 13.5 17C15.9853 17 18 14.9853 18 12.5C18 12.3396 17.9916 12.1812 17.9746 12.0247C17.8186 12.0084 17.6603 12 17.5 12ZM6.5 12C6.33963 12 6.18121 12.0084 6.02475 12.0252C6.00839 12.1812 6 12.3396 6 12.5C6 14.9853 8.01472 17 10.5 17C10.6603 17 10.8186 16.9916 10.9753 16.9746C10.9916 16.8186 11 16.6603 11 16.5C11 14.0147 8.98528 12 6.5 12Z"
  }));
},
    T = function T(_ref35) {
  var _ref35$color = _ref35.color,
      C = _ref35$color === void 0 ? "currentColor" : _ref35$color,
      _ref35$size = _ref35.size,
      e = _ref35$size === void 0 ? 24 : _ref35$size,
      l = _ref35.className,
      i = _objectWithoutProperties(_ref35, _excluded35);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C16.6944 2 20.5 5.80558 20.5 10.5C20.5 17 15 22.5 12 22.5C9 22.5 3.5 17 3.5 10.5C3.5 5.80558 7.30558 2 12 2ZM12 4C8.41015 4 5.5 6.91015 5.5 10.5C5.5 15.2938 9.665 20.5 12 20.5C14.335 20.5 18.5 15.2938 18.5 10.5C18.5 6.91015 15.5899 4 12 4ZM17.5 11C17.6603 11 17.8186 11.0084 17.9746 11.0247C17.9916 11.1812 18 11.3396 18 11.5C18 13.9853 15.9853 16 13.5 16C13.3396 16 13.1812 15.9916 13.0252 15.9752C13.0084 15.8186 13 15.6603 13 15.5C13 13.0147 15.0147 11 17.5 11ZM6.5 11C8.98528 11 11 13.0147 11 15.5C11 15.6603 10.9916 15.8186 10.9753 15.9746C10.8186 15.9916 10.6603 16 10.5 16C8.01472 16 6 13.9853 6 11.5C6 11.3396 6.00839 11.1812 6.02475 11.0252C6.18121 11.0084 6.33963 11 6.5 11Z"
  }));
},
    U = function U(_ref36) {
  var _ref36$color = _ref36.color,
      C = _ref36$color === void 0 ? "currentColor" : _ref36$color,
      _ref36$size = _ref36.size,
      e = _ref36$size === void 0 ? 24 : _ref36$size,
      l = _ref36.className,
      i = _objectWithoutProperties(_ref36, _excluded36);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 19H21V21H3V19ZM8 13H11L7 17L3 13H6V3H8V13ZM18 13H21L17 17L13 13H16V3H18V13Z"
  }));
},
    G = function G(_ref37) {
  var _ref37$color = _ref37.color,
      C = _ref37$color === void 0 ? "currentColor" : _ref37$color,
      _ref37$size = _ref37.size,
      e = _ref37$size === void 0 ? 24 : _ref37$size,
      l = _ref37.className,
      i = _objectWithoutProperties(_ref37, _excluded37);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 4H21V6H3V4ZM5 19H19V21H5V19ZM3 14H21V16H3V14ZM5 9H19V11H5V9Z"
  }));
},
    I = function I(_ref38) {
  var _ref38$color = _ref38.color,
      C = _ref38$color === void 0 ? "currentColor" : _ref38$color,
      _ref38$size = _ref38.size,
      e = _ref38$size === void 0 ? 24 : _ref38$size,
      l = _ref38.className,
      i = _objectWithoutProperties(_ref38, _excluded38);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 4H21V6H3V4ZM3 19H21V21H3V19ZM3 14H21V16H3V14ZM3 9H21V11H3V9Z"
  }));
},
    W = function W(_ref39) {
  var _ref39$color = _ref39.color,
      C = _ref39$color === void 0 ? "currentColor" : _ref39$color,
      _ref39$size = _ref39.size,
      e = _ref39$size === void 0 ? 24 : _ref39$size,
      l = _ref39.className,
      i = _objectWithoutProperties(_ref39, _excluded39);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 4H21V6H3V4ZM3 19H17V21H3V19ZM3 14H21V16H3V14ZM3 9H17V11H3V9Z"
  }));
},
    O = function O(_ref40) {
  var _ref40$color = _ref40.color,
      C = _ref40$color === void 0 ? "currentColor" : _ref40$color,
      _ref40$size = _ref40.size,
      e = _ref40$size === void 0 ? 24 : _ref40$size,
      l = _ref40.className,
      i = _objectWithoutProperties(_ref40, _excluded40);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 4H21V6H3V4ZM7 19H21V21H7V19ZM3 14H21V16H3V14ZM7 9H21V11H7V9Z"
  }));
},
    K = function K(_ref41) {
  var _ref41$color = _ref41.color,
      C = _ref41$color === void 0 ? "currentColor" : _ref41$color,
      _ref41$size = _ref41.size,
      e = _ref41$size === void 0 ? 24 : _ref41$size,
      l = _ref41.className,
      i = _objectWithoutProperties(_ref41, _excluded41);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 3H21V5H3V3ZM8 11V21H6V11H3L7 7L11 11H8ZM18 11V21H16V11H13L17 7L21 11H18Z"
  }));
},
    Q = function Q(_ref42) {
  var _ref42$color = _ref42.color,
      C = _ref42$color === void 0 ? "currentColor" : _ref42$color,
      _ref42$size = _ref42.size,
      e = _ref42$size === void 0 ? 24 : _ref42$size,
      l = _ref42.className,
      i = _objectWithoutProperties(_ref42, _excluded42);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 11H21V13H3V11ZM18 18V21H16V18H13L17 14L21 18H18ZM8 18V21H6V18H3L7 14L11 18H8ZM18 6H21L17 10L13 6H16V3H18V6ZM8 6H11L7 10L3 6H6V3H8V6Z"
  }));
},
    q = function q(_ref43) {
  var _ref43$color = _ref43.color,
      C = _ref43$color === void 0 ? "currentColor" : _ref43$color,
      _ref43$size = _ref43.size,
      e = _ref43$size === void 0 ? 24 : _ref43$size,
      l = _ref43.className,
      i = _objectWithoutProperties(_ref43, _excluded43);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21.4224 15.3576C17.5929 14.2048 15.3667 13.5176 14.744 13.296C15.312 12.32 15.768 11.2 16.064 9.976H12.8V8.872H16.8V8.192H12.8V6.344H11.264C10.984 6.344 10.952 6.592 10.952 6.592V8.184H7.2V8.864H10.952V9.968H7.88V10.584H14.104C13.88 11.36 13.576 12.096 13.216 12.76C11.808 12.296 11.024 11.976 9.304 11.816C6.048 11.504 5.296 13.296 5.176 14.392C5 16.064 6.48 17.424 8.688 17.424C10.896 17.424 12.368 16.4 13.768 14.704C14.9346 15.2619 17.1059 16.2293 20.2819 17.6062C18.4835 20.2577 15.4452 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 13.1778 21.7964 14.3081 21.4224 15.3576ZM8.432 16.368C6.096 16.368 5.728 14.888 5.848 14.272C5.968 13.656 6.648 12.856 7.952 12.856C9.448 12.856 10.784 13.24 12.392 14.016C11.256 15.496 9.872 16.368 8.432 16.368Z"
  }));
},
    j = function j(_ref44) {
  var _ref44$color = _ref44.color,
      C = _ref44$color === void 0 ? "currentColor" : _ref44$color,
      _ref44$size = _ref44.size,
      e = _ref44$size === void 0 ? 24 : _ref44$size,
      l = _ref44.className,
      i = _objectWithoutProperties(_ref44, _excluded44);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18.4079 16.7903C16.2353 15.8398 14.6887 15.1443 13.768 14.704C12.368 16.4 10.896 17.424 8.688 17.424C6.48 17.424 5 16.064 5.176 14.392C5.296 13.296 6.048 11.504 9.304 11.816C11.024 11.976 11.808 12.296 13.216 12.76C13.576 12.096 13.88 11.36 14.104 10.584H7.88V9.968H10.952V8.864H7.2V8.184H10.952V6.592C10.952 6.592 10.984 6.344 11.264 6.344H12.8V8.192H16.8V8.872H12.8V9.976H16.064C15.768 11.2 15.312 12.32 14.744 13.296C15.2543 13.4776 16.841 13.9718 19.5043 14.7785C19.8249 13.913 20 12.977 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C14.6217 20 16.9488 18.7389 18.4079 16.7903ZM12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM8.432 16.368C9.872 16.368 11.256 15.496 12.392 14.016C10.784 13.24 9.448 12.856 7.952 12.856C6.648 12.856 5.968 13.656 5.848 14.272C5.728 14.888 6.096 16.368 8.432 16.368Z"
  }));
},
    X = function X(_ref45) {
  var _ref45$color = _ref45.color,
      C = _ref45$color === void 0 ? "currentColor" : _ref45$color,
      _ref45$size = _ref45.size,
      e = _ref45$size === void 0 ? 24 : _ref45$size,
      l = _ref45.className,
      i = _objectWithoutProperties(_ref45, _excluded45);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21.997 18.2294C21.997 18.9572 21.5919 20.3571 20.6823 21.1263C20.5002 21.2667 20.3181 21.187 20.3979 20.983C20.6625 20.3352 21.2694 18.8356 20.985 18.4912C20.7839 18.2294 19.954 18.2485 19.2462 18.3092C18.923 18.3501 18.6393 18.3699 18.4191 18.4136C18.2152 18.4305 18.1736 18.2513 18.3775 18.1109C18.6393 17.926 18.923 17.7855 19.2483 17.6832C20.3979 17.3388 21.7269 17.5461 21.9172 17.7658C21.954 17.8083 21.997 17.926 21.997 18.2294ZM20.0754 19.5244C19.8136 19.7262 19.5299 19.9104 19.2462 20.0734C17.1235 21.3493 14.3748 22.0168 11.9875 22.0168C8.14505 22.0168 4.70765 20.5998 2.10014 18.2294C1.87644 18.0474 2.06133 17.7827 2.32314 17.926C5.13247 19.566 8.6108 20.5582 12.2112 20.5582C14.4772 20.5582 16.9195 20.1341 19.2462 19.2216C19.4085 19.1609 19.5906 19.0784 19.7501 19.0205C20.117 18.8547 20.4395 19.2625 20.0754 19.5244ZM13.9051 8.49485C13.9059 7.45265 13.9472 6.8397 13.6019 6.31359C13.2955 5.88081 12.7691 5.62128 12.0335 5.66194C11.2353 5.70607 10.3784 6.22935 10.1595 7.18824C10.1174 7.40711 9.98855 7.6235 9.72343 7.6714L7.28779 7.36168C7.11352 7.32039 6.84922 7.18824 6.93595 6.8397C7.45875 4.08774 9.81097 3.12884 12.0335 3H12.5563C13.7762 3 15.3438 3.34854 16.3473 4.26448C17.5639 5.40012 17.4342 6.92642 17.4342 8.58487V12.5113C17.4342 13.6891 17.9116 14.211 18.3923 14.8247C18.522 15.0436 18.5666 15.3021 18.3477 15.4797C17.867 15.9149 16.9535 16.6987 16.4307 17.134C16.2565 17.2669 15.9424 17.2811 15.8212 17.1794C15.0514 16.5336 14.8631 16.1759 14.3857 15.5209C13.5565 16.3923 12.8594 16.873 12.0302 17.134C11.5074 17.2669 10.9433 17.3504 10.2462 17.3504C8.15583 17.3504 6.50069 16.0471 6.50069 13.4694C6.50069 11.4211 7.5909 10.0276 9.20062 9.36867C10.8103 8.7097 13.1505 8.49857 13.9051 8.49485ZM13.4277 13.6858C13.9472 12.8144 13.9051 12.0996 13.9051 10.501C13.2534 10.501 12.5985 10.5464 12.0335 10.6786C10.9887 10.9817 10.1595 11.6399 10.1595 13.0341C10.1595 14.1243 10.7269 14.866 11.685 14.866C11.8171 14.866 11.9328 14.8495 12.0335 14.8214C12.7028 14.6346 13.1213 14.2986 13.4277 13.6858Z"
  }));
},
    J = function J(_ref46) {
  var _ref46$color = _ref46.color,
      C = _ref46$color === void 0 ? "currentColor" : _ref46$color,
      _ref46$size = _ref46.size,
      e = _ref46$size === void 0 ? 24 : _ref46$size,
      l = _ref46.className,
      i = _objectWithoutProperties(_ref46, _excluded46);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15.6262 14.6201C14.5191 16.2386 12.8976 17.0042 11.0007 17.0042C8.69659 17.0042 6.7243 15.2315 7.00788 12.8803C7.32248 10.272 9.34731 9.14962 12.716 8.73726C13.3171 8.66367 13.566 8.64299 14.8629 8.54691C14.9116 8.54331 14.9575 8.53988 15.001 8.5366C15.0008 8.46544 15.0007 8.39386 15.0007 8.32185C15.0007 6.52595 13.9328 5.30005 12.5007 5.30005C11.0638 5.30005 10.0603 6.0474 9.44592 7.82645L7.55546 7.17365C8.44288 4.60377 10.1935 3.30005 12.5007 3.30005C15.1034 3.30005 17.0007 5.47803 17.0007 8.32185C17.0007 10.9707 17.164 13.0776 17.484 13.8794C17.84 14.7715 17.9698 14.9959 18.3677 15.4921L16.8075 16.7434C16.2843 16.091 16.0549 15.6945 15.6264 14.6207L15.6262 14.6201ZM21.2572 20.5453C20.9864 20.7452 20.5157 20.6263 20.7288 20.1048C20.9934 19.4569 21.2755 18.6971 20.9911 18.3527C20.7807 18.098 20.5235 17.9711 19.9637 17.9711C19.5041 17.9711 19.2733 18.0305 18.9688 18.0508C18.7646 18.0645 18.6753 17.7537 18.8775 17.6109C19.1393 17.426 19.4216 17.2811 19.7483 17.1833C20.8979 16.8389 22.253 17.0276 22.4172 17.2658C22.7826 17.7959 22.2189 19.835 21.2572 20.5453ZM20.0754 19.4608C19.8136 19.7164 19.5299 19.9496 19.2462 20.156C17.1235 21.7716 14.3748 22.6169 11.9875 22.6169C8.14505 22.6169 4.70765 20.8226 2.10014 17.8212C1.87644 17.5906 2.06133 17.2555 2.32314 17.4369C5.13247 19.5136 8.6108 20.7699 12.2112 20.7699C14.4772 20.7699 16.9195 20.2329 19.2462 19.0775C19.4085 19.0007 19.5906 18.8961 19.7501 18.8228C20.117 18.6128 20.4395 19.1293 20.0754 19.4608ZM15.0107 10.5414C13.7522 10.6347 13.5147 10.6544 12.959 10.7224C10.4062 11.0349 9.16175 11.7247 8.99349 13.1198C8.86763 14.1633 9.80321 15.0042 11.0007 15.0042C13.0397 15.0042 14.5179 13.7764 15.0227 10.5406C15.0187 10.5409 15.0147 10.5411 15.0107 10.5414Z"
  }));
},
    Y = function Y(_ref47) {
  var _ref47$color = _ref47.color,
      C = _ref47$color === void 0 ? "currentColor" : _ref47$color,
      _ref47$size = _ref47.size,
      e = _ref47$size === void 0 ? 24 : _ref47$size,
      l = _ref47.className,
      i = _objectWithoutProperties(_ref47, _excluded47);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13 9.87398V19.928C16.6187 19.4745 19.4869 16.5923 19.9381 12.9558H17L20.7042 7C21.529 8.46132 22 10.1508 22 11.9509C22 17.5009 17.5228 22 12 22C6.47715 22 2 17.5009 2 11.9509C2 10.1508 2.47097 8.46132 3.29582 7L7 12.9558H4.06189C4.51314 16.5923 7.38128 19.4745 11 19.928V9.87398C9.27477 9.42994 8 7.86384 8 6C8 3.79086 9.79086 2 12 2C14.2091 2 16 3.79086 16 6C16 7.86384 14.7252 9.42994 13 9.87398ZM12 8C13.1046 8 14 7.10457 14 6C14 4.89543 13.1046 4 12 4C10.8954 4 10 4.89543 10 6C10 7.10457 10.8954 8 12 8Z"
  }));
},
    _ = function _(_ref48) {
  var _ref48$color = _ref48.color,
      C = _ref48$color === void 0 ? "currentColor" : _ref48$color,
      _ref48$size = _ref48.size,
      e = _ref48$size === void 0 ? 24 : _ref48$size,
      l = _ref48.className,
      i = _objectWithoutProperties(_ref48, _excluded48);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2.04938 11H7V13H4.06189C4.51314 16.6187 7.38128 19.4869 11 19.9381V9.87398C9.27477 9.42994 8 7.86384 8 6C8 3.79086 9.79086 2 12 2C14.2091 2 16 3.79086 16 6C16 7.86384 14.7252 9.42994 13 9.87398V19.9381C16.6187 19.4869 19.4869 16.6187 19.9381 13H17V11H21.9506C21.9833 11.3289 22 11.6625 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 11.6625 2.01672 11.3289 2.04938 11ZM12 8C13.1046 8 14 7.10457 14 6C14 4.89543 13.1046 4 12 4C10.8954 4 10 4.89543 10 6C10 7.10457 10.8954 8 12 8Z"
  }));
},
    $ = function $(_ref49) {
  var _ref49$color = _ref49.color,
      C = _ref49$color === void 0 ? "currentColor" : _ref49$color,
      _ref49$size = _ref49.size,
      e = _ref49$size === void 0 ? 24 : _ref49$size,
      l = _ref49.className,
      i = _objectWithoutProperties(_ref49, _excluded49);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.9641 3H17.0359C17.2844 4.722 18.7602 6 20.5 6C20.8322 6 21.1626 5.95271 21.4815 5.85956C21.2972 7.64386 19.7938 9 18 9H6C4.20622 9 2.7028 7.64386 2.51852 5.85957C2.83736 5.95271 3.16783 6 3.5 6C5.23985 6 6.71555 4.722 6.9641 3ZM22.9786 11.1114C22.5422 11.3591 22.0376 11.5005 21.5 11.5005C20.3896 11.5005 19.4201 10.8972 18.9013 10.0005H5.09865C4.57994 10.8972 3.61042 11.5005 2.5 11.5005C1.96237 11.5005 1.45778 11.3591 1.02138 11.1114C1.00725 11.2391 1 11.369 1 11.5005C1 12.8967 1.81753 14.1019 3 14.6637V21H9V19C9 17.3431 10.3432 16 12 16C13.6569 16 15 17.3431 15 19V21H21V14.6637C22.1825 14.1019 23 12.8967 23 11.5005C23 11.369 22.9927 11.2391 22.9786 11.1114Z"
  }));
},
    e1 = function e1(_ref50) {
  var _ref50$color = _ref50.color,
      C = _ref50$color === void 0 ? "currentColor" : _ref50$color,
      _ref50$size = _ref50.size,
      e = _ref50$size === void 0 ? 24 : _ref50$size,
      l = _ref50.className,
      i = _objectWithoutProperties(_ref50, _excluded50);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.96407 3H17.0358C17.2844 4.72201 18.7601 6 20.5 6 20.8321 6 21.1626 5.95272 21.4814 5.85957 21.2972 7.64386 19.7937 9 18 9H5.99997C4.20619 9 2.70278 7.64386 2.51849 5.85957 2.83733 5.95272 3.16781 6 3.49997 6 5.23982 6 6.71552 4.72201 6.96407 3ZM16.8994 6.65761C16.3391 6.1724 15.902 5.61986 15.5881 5H8.41184C8.09793 5.61986 7.66084 6.1724 7.10057 6.65761 6.9591 6.78013 6.8145 6.89426 6.66678 7H17.3331C17.1855 6.89426 17.0409 6.78013 16.8994 6.65761ZM21.5 11.5005C22.0376 11.5005 22.5422 11.3591 22.9786 11.1114 22.9927 11.2391 23 11.369 23 11.5005 23 12.8967 22.1825 14.1019 21 14.6637V21H14V19C14 17.8954 13.1046 17 12 17 10.8954 17 10 17.8954 10 19V21H3V14.6637C1.81753 14.1019 1 12.8967 1 11.5005 1 11.369 1.00725 11.2391 1.02138 11.1114 1.45778 11.3591 1.96237 11.5005 2.5 11.5005 3.61042 11.5005 4.57994 10.8972 5.09865 10.0005H18.9013C19.4201 10.8972 20.3896 11.5005 21.5 11.5005ZM18.9632 12.8097C18.5756 12.5812 18.2296 12.3115 17.9252 12.0005H6.07479C5.77042 12.3115 5.42443 12.5812 5.03683 12.8097 4.834 12.9293 4.62683 13.0333 4.41532 13.1218L5 13.3996V19H8C8 17.8954 8.39052 16.9526 9.17157 16.1716 9.95262 15.3905 10.8954 15 12 15 13.1046 15 14.0474 15.3905 14.8284 16.1716 15.6095 16.9526 16 17.8954 16 19H19V13.3996L19.5847 13.1218C19.3732 13.0333 19.166 12.9293 18.9632 12.8097Z"
  }));
},
    t1 = function t1(_ref51) {
  var _ref51$color = _ref51.color,
      C = _ref51$color === void 0 ? "currentColor" : _ref51$color,
      _ref51$size = _ref51.size,
      e = _ref51$size === void 0 ? 24 : _ref51$size,
      l = _ref51.className,
      i = _objectWithoutProperties(_ref51, _excluded51);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M1.51587 7.87678C1.67997 9.82977 3.0892 11.452 5.00006 11.8875V19.0013H3.00006V21.0013H21.0001V19.0013H19.0001V11.8875C20.9109 11.452 22.3202 9.82977 22.4842 7.87678C21.9938 7.95878 21.4973 8 21.0001 8C17.186 8 13.7861 5.59592 12.5148 2H11.4853C10.214 5.59592 6.81411 8 3.00006 8C2.50278 8 2.00635 7.95878 1.51587 7.87678ZM17.0001 19.0013H7.00006V12H17.0001V19.0013Z"
  }));
},
    C1 = function C1(_ref52) {
  var _ref52$color = _ref52.color,
      C = _ref52$color === void 0 ? "currentColor" : _ref52$color,
      _ref52$size = _ref52.size,
      e = _ref52$size === void 0 ? 24 : _ref52$size,
      l = _ref52.className,
      i = _objectWithoutProperties(_ref52, _excluded52);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M1.51587 7.87678C1.67997 9.82977 3.0892 11.452 5.00006 11.8875V19.0013H3.00006V21.0013H21.0001V19.0013H19.0001V11.8875C20.9109 11.452 22.3202 9.82977 22.4842 7.87678C21.9938 7.95878 21.4973 8 21.0001 8C17.186 8 13.7861 5.59592 12.5148 2H11.4853C10.214 5.59592 6.81411 8 3.00006 8C2.50278 8 2.00635 7.95878 1.51587 7.87678ZM17.0001 19.0013H7.00006V12H17.0001V19.0013ZM18.5556 9.93749L18.2813 10H5.71878L5.44452 9.93749C5.30845 9.90648 5.17809 9.86594 5.05345 9.81587C6.59012 9.53219 8.02261 8.92072 9.35093 7.98146C10.4075 7.23431 11.2906 6.35588 12.0001 5.34615C12.7096 6.35588 13.5926 7.23431 14.6492 7.98146C15.9775 8.92072 17.41 9.53219 18.9467 9.81587C18.8221 9.86594 18.6917 9.90648 18.5556 9.93749Z"
  }));
},
    l1 = function l1(_ref53) {
  var _ref53$color = _ref53.color,
      C = _ref53$color === void 0 ? "currentColor" : _ref53$color,
      _ref53$size = _ref53.size,
      e = _ref53$size === void 0 ? 24 : _ref53$size,
      l = _ref53.className,
      i = _objectWithoutProperties(_ref53, _excluded53);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.38231 3.9681C7.92199 2.73647 9.87499 2 12 2C14.125 2 16.078 2.73647 17.6177 3.9681L19.0711 2.51472L20.4853 3.92893L19.0319 5.38231C20.2635 6.92199 21 8.87499 21 11V12H3V11C3 8.87499 3.73647 6.92199 4.9681 5.38231L3.51472 3.92893L4.92893 2.51472L6.38231 3.9681ZM3 14H21V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V14ZM9 9C9.55228 9 10 8.55228 10 8C10 7.44772 9.55228 7 9 7C8.44772 7 8 7.44772 8 8C8 8.55228 8.44772 9 9 9ZM15 9C15.5523 9 16 8.55228 16 8C16 7.44772 15.5523 7 15 7C14.4477 7 14 7.44772 14 8C14 8.55228 14.4477 9 15 9Z"
  }));
},
    i1 = function i1(_ref54) {
  var _ref54$color = _ref54.color,
      C = _ref54$color === void 0 ? "currentColor" : _ref54$color,
      _ref54$size = _ref54.size,
      e = _ref54$size === void 0 ? 24 : _ref54$size,
      l = _ref54.className,
      i = _objectWithoutProperties(_ref54, _excluded54);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19 13H5V20H19V13ZM19 11C19 7.13401 15.866 4 12 4C8.13401 4 5 7.13401 5 11H19ZM6.38231 3.9681C7.92199 2.73647 9.87499 2 12 2C14.125 2 16.078 2.73647 17.6177 3.9681L19.0711 2.51472L20.4853 3.92893L19.0319 5.38231C20.2635 6.92199 21 8.87499 21 11V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V11C3 8.87499 3.73647 6.92199 4.9681 5.38231L3.51472 3.92893L4.92893 2.51472L6.38231 3.9681ZM9 9C8.44772 9 8 8.55228 8 8C8 7.44772 8.44772 7 9 7C9.55228 7 10 7.44772 10 8C10 8.55228 9.55228 9 9 9ZM15 9C14.4477 9 14 8.55228 14 8C14 7.44772 14.4477 7 15 7C15.5523 7 16 7.44772 16 8C16 8.55228 15.5523 9 15 9Z"
  }));
},
    s1 = function s1(_ref55) {
  var _ref55$color = _ref55.color,
      C = _ref55$color === void 0 ? "currentColor" : _ref55$color,
      _ref55$size = _ref55.size,
      e = _ref55$size === void 0 ? 24 : _ref55$size,
      l = _ref55.className,
      i = _objectWithoutProperties(_ref55, _excluded55);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.0002 2L21.3002 5.32L19.8817 17.63L12.0002 22L4.11867 17.63L2.7002 5.32L12.0002 2ZM12.0002 4.21L6.18645 17.26H8.35412L9.52286 14.34H14.4576L15.6263 17.26H17.794L12.0002 4.21ZM13.6984 12.54H10.302L12.0002 8.45L13.6984 12.54Z"
  }));
},
    r1 = function r1(_ref56) {
  var _ref56$color = _ref56.color,
      C = _ref56$color === void 0 ? "currentColor" : _ref56$color,
      _ref56$size = _ref56.size,
      e = _ref56$size === void 0 ? 24 : _ref56$size,
      l = _ref56.className,
      i = _objectWithoutProperties(_ref56, _excluded56);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17.5235 16.6507L18.0126 16.3795L19.1315 6.66941L12.0002 4.12362L4.86892 6.66941L5.98781 16.3795L6.46166 16.6422L12.0002 4.21L17.5235 16.6507ZM16.4246 17.26H15.6263L14.4576 14.34H9.52286L8.35412 17.26H7.57582L12.0002 19.7131L16.4246 17.26ZM12.0002 2L21.3002 5.32L19.8817 17.63L12.0002 22L4.11867 17.63L2.7002 5.32L12.0002 2ZM13.6984 12.54L12.0002 8.45L10.302 12.54H13.6984Z"
  }));
},
    c1 = function c1(_ref57) {
  var _ref57$color = _ref57.color,
      C = _ref57$color === void 0 ? "currentColor" : _ref57$color,
      _ref57$size = _ref57.size,
      e = _ref57$size === void 0 ? 24 : _ref57$size,
      l = _ref57.className,
      i = _objectWithoutProperties(_ref57, _excluded57);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14 4H16C18.7614 4 21 6.23858 21 9V13H19V9C19 7.34315 17.6569 6 16 6H14V9L9 5L14 1V4ZM15 11V21C15 21.5523 14.5523 22 14 22H4C3.44772 22 3 21.5523 3 21V11C3 10.4477 3.44772 10 4 10H14C14.5523 10 15 10.4477 15 11Z"
  }));
},
    o1 = function o1(_ref58) {
  var _ref58$color = _ref58.color,
      C = _ref58$color === void 0 ? "currentColor" : _ref58$color,
      _ref58$size = _ref58.size,
      e = _ref58$size === void 0 ? 24 : _ref58$size,
      l = _ref58.className,
      i = _objectWithoutProperties(_ref58, _excluded58);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13.4142 5.99996L15.2426 7.82839L13.8284 9.24261L9.58579 4.99996L13.8284 0.757324L15.2426 2.17154L13.4142 3.99996H16C18.7614 3.99996 21 6.23854 21 8.99996V13H19V8.99996C19 7.34311 17.6569 5.99996 16 5.99996H13.4142ZM15 11V21C15 21.5522 14.5523 22 14 22H4C3.44772 22 3 21.5522 3 21V11C3 10.4477 3.44772 9.99996 4 9.99996H14C14.5523 9.99996 15 10.4477 15 11ZM13 12H5V20H13V12Z"
  }));
},
    a1 = function a1(_ref59) {
  var _ref59$color = _ref59.color,
      C = _ref59$color === void 0 ? "currentColor" : _ref59$color,
      _ref59$size = _ref59.size,
      e = _ref59$size === void 0 ? 24 : _ref59$size,
      l = _ref59.className,
      i = _objectWithoutProperties(_ref59, _excluded59);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6 10H9L5 15L1 10H4V8C4 5.23858 6.23858 3 9 3H13V5H9C7.34315 5 6 6.34315 6 8V10ZM11 9H21C21.5523 9 22 9.44772 22 10V20C22 20.5523 21.5523 21 21 21H11C10.4477 21 10 20.5523 10 20V10C10 9.44772 10.4477 9 11 9Z"
  }));
},
    n1 = function n1(_ref60) {
  var _ref60$color = _ref60.color,
      C = _ref60$color === void 0 ? "currentColor" : _ref60$color,
      _ref60$size = _ref60.size,
      e = _ref60$size === void 0 ? 24 : _ref60$size,
      l = _ref60.className,
      i = _objectWithoutProperties(_ref60, _excluded60);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11 9H21C21.5522 9 22 9.44772 22 10V20C22 20.5523 21.5522 21 21 21H11C10.4477 21 9.99996 20.5523 9.99996 20V10C9.99996 9.44772 10.4477 9 11 9ZM12 11V19H20V11H12ZM5.99996 10.5858L7.82839 8.75736L9.24261 10.1716L4.99996 14.4142L0.757324 10.1716L2.17154 8.75736L3.99996 10.5858V8C3.99996 5.23858 6.23854 3 8.99996 3H13V5H8.99996C7.34311 5 5.99996 6.34315 5.99996 8V10.5858Z"
  }));
},
    m1 = function m1(_ref61) {
  var _ref61$color = _ref61.color,
      C = _ref61$color === void 0 ? "currentColor" : _ref61$color,
      _ref61$size = _ref61.size,
      e = _ref61$size === void 0 ? 24 : _ref61$size,
      l = _ref61.className,
      i = _objectWithoutProperties(_ref61, _excluded61);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM8.82258 15.3427C8.42804 14.8663 7.9373 14.6957 7.34401 14.834L7.19355 14.875L6.60484 15.8911C6.37903 16.2863 6.5121 16.7903 6.90726 17.0161C7.26949 17.2231 7.7232 17.1286 7.97023 16.807L8.03226 16.7137L8.82258 15.3427ZM13.2097 8.66129C12.7218 9.06452 12.2298 10.2581 12.9194 11.4476L15.9597 16.7137C16.1895 17.1089 16.6895 17.2419 17.0847 17.0161C17.4469 16.8054 17.5889 16.3677 17.4361 15.9919L17.3871 15.8911L16.5847 14.5H17.7742C18.2298 14.5 18.5968 14.1331 18.5968 13.6774C18.5968 13.2568 18.2841 12.9118 17.8776 12.8612L17.7742 12.8548H15.6331L13.44 9.05741L13.2097 8.66129ZM13.4879 5.61694C13.1257 5.40995 12.672 5.50451 12.4249 5.82608L12.3629 5.91935L11.996 6.55242L11.6371 5.91935C11.4073 5.52419 10.9073 5.39113 10.5121 5.61694C10.1499 5.82762 10.0079 6.26532 10.1606 6.64118L10.2097 6.74194L11.0484 8.19758L8.3629 12.8508H6.26613C5.81048 12.8508 5.44355 13.2177 5.44355 13.6734C5.44355 14.094 5.7562 14.439 6.16268 14.4896L6.26613 14.496H13.746C14.0869 13.8562 13.6854 12.9472 12.9357 12.8579L12.8145 12.8508H10.2621L13.7903 6.74194C14.0161 6.34677 13.8831 5.84274 13.4879 5.61694Z"
  }));
},
    w1 = function w1(_ref62) {
  var _ref62$color = _ref62.color,
      C = _ref62$color === void 0 ? "currentColor" : _ref62$color,
      _ref62$size = _ref62.size,
      e = _ref62$size === void 0 ? 24 : _ref62$size,
      l = _ref62.className,
      i = _objectWithoutProperties(_ref62, _excluded62);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM8.82258 15.3427L8.03226 16.7137C7.80645 17.1089 7.30242 17.2419 6.90726 17.0161C6.5121 16.7903 6.37903 16.2863 6.60484 15.8911L7.19355 14.875C7.85484 14.6694 8.39516 14.8266 8.82258 15.3427ZM13.2097 8.66129L15.6331 12.8548H17.7742C18.2298 12.8548 18.5968 13.2218 18.5968 13.6774C18.5968 14.1331 18.2298 14.5 17.7742 14.5H16.5847L17.3871 15.8911C17.6129 16.2863 17.4798 16.7863 17.0847 17.0161C16.6895 17.2419 16.1895 17.1089 15.9597 16.7137L12.9194 11.4476C12.2298 10.2581 12.7218 9.06452 13.2097 8.66129ZM13.4879 5.61694C13.8831 5.84274 14.0161 6.34677 13.7903 6.74194L10.2621 12.8508H12.8145C13.6411 12.8508 14.1048 13.8226 13.746 14.496H6.26613C5.81048 14.496 5.44355 14.129 5.44355 13.6734C5.44355 13.2177 5.81048 12.8508 6.26613 12.8508H8.3629L11.0484 8.19758L10.2097 6.74194C9.98387 6.34677 10.1169 5.84677 10.5121 5.61694C10.9073 5.39113 11.4073 5.52419 11.6371 5.91935L11.996 6.55242L12.3629 5.91935C12.5887 5.52419 13.0927 5.39113 13.4879 5.61694Z"
  }));
},
    L1 = function L1(_ref63) {
  var _ref63$color = _ref63.color,
      C = _ref63$color === void 0 ? "currentColor" : _ref63$color,
      _ref63$size = _ref63.size,
      e = _ref63$size === void 0 ? 24 : _ref63$size,
      l = _ref63.className,
      i = _objectWithoutProperties(_ref63, _excluded63);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11.6734 7.22198C10.7974 7.22198 9.44138 6.22598 8.01338 6.26198C6.12938 6.28598 4.40138 7.35397 3.42938 9.04597C1.47338 12.442 2.92538 17.458 4.83338 20.218C5.76938 21.562 6.87338 23.074 8.33738 23.026C9.74138 22.966 10.2694 22.114 11.9734 22.114C13.6654 22.114 14.1454 23.026 15.6334 22.99C17.1454 22.966 18.1054 21.622 19.0294 20.266C20.0974 18.706 20.5414 17.194 20.5654 17.11C20.5294 17.098 17.6254 15.982 17.5894 12.622C17.5654 9.81397 19.8814 8.46998 19.9894 8.40998C18.6694 6.47798 16.6414 6.26198 15.9334 6.21398C14.0854 6.06998 12.5374 7.22198 11.6734 7.22198ZM14.7934 4.38998C15.5734 3.45398 16.0894 2.14598 15.9454 0.849976C14.8294 0.897976 13.4854 1.59398 12.6814 2.52998C11.9614 3.35798 11.3374 4.68998 11.5054 5.96198C12.7414 6.05798 14.0134 5.32598 14.7934 4.38998Z"
  }));
},
    h1 = function h1(_ref64) {
  var _ref64$color = _ref64.color,
      C = _ref64$color === void 0 ? "currentColor" : _ref64$color,
      _ref64$size = _ref64.size,
      e = _ref64$size === void 0 ? 24 : _ref64$size,
      l = _ref64.className,
      i = _objectWithoutProperties(_ref64, _excluded64);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15.778 8.20793C15.3053 8.1711 14.7974 8.28434 14.0197 8.58067C14.085 8.55577 13.2775 8.87173 13.0511 8.95077C12.5494 9.12593 12.1364 9.22198 11.6734 9.22198C11.2151 9.22198 10.7925 9.13042 10.3078 8.96683C10.1524 8.91441 9.99616 8.8564 9.80283 8.7809C9.71993 8.74852 9.41997 8.62947 9.3544 8.60379C8.70626 8.34996 8.34154 8.25434 8.03885 8.26181C6.88626 8.2765 5.79557 8.9421 5.16246 10.0442C3.87037 12.2875 4.58583 16.3428 6.47459 19.075C7.4802 20.5189 8.03062 21.035 8.25199 21.0279C8.4743 21.0183 8.63777 20.9713 9.03567 20.8026C9.11485 20.7689 9.11485 20.7689 9.202 20.7317C10.2077 20.3032 10.9118 20.114 11.9734 20.114C12.9944 20.114 13.6763 20.2997 14.6416 20.7159C14.7302 20.7542 14.7302 20.7542 14.8097 20.7884C15.2074 20.9588 15.3509 20.9962 15.6016 20.9902C15.9591 20.9846 16.4003 20.5726 17.3791 19.1362C17.6471 18.7447 17.884 18.3333 18.0895 17.9168C17.9573 17.8077 17.826 17.6917 17.6975 17.5693C16.4086 16.3408 15.6114 14.6845 15.5895 12.6391C15.5756 11.0186 16.1057 9.61487 16.999 8.45797C16.6293 8.3142 16.2216 8.23805 15.778 8.20793ZM15.9334 6.21398C16.6414 6.26198 18.6694 6.47798 19.9894 8.40998C19.8814 8.46998 17.5654 9.81397 17.5894 12.622C17.6254 15.982 20.5294 17.098 20.5654 17.11C20.5414 17.194 20.0974 18.706 19.0294 20.266C18.1054 21.622 17.1454 22.966 15.6334 22.99C14.1454 23.026 13.6654 22.114 11.9734 22.114C10.2694 22.114 9.74138 22.966 8.33738 23.026C6.87338 23.074 5.76938 21.562 4.83338 20.218C2.92538 17.458 1.47338 12.442 3.42938 9.04597C4.40138 7.35397 6.12938 6.28598 8.01338 6.26198C9.44138 6.22598 10.7974 7.22198 11.6734 7.22198C12.5374 7.22198 14.0854 6.06998 15.9334 6.21398ZM14.7934 4.38998C14.0134 5.32598 12.7414 6.05798 11.5054 5.96198C11.3374 4.68998 11.9614 3.35798 12.6814 2.52998C13.4854 1.59398 14.8294 0.897976 15.9454 0.849976C16.0894 2.14598 15.5734 3.45398 14.7934 4.38998Z"
  }));
},
    H1 = function H1(_ref65) {
  var _ref65$color = _ref65.color,
      C = _ref65$color === void 0 ? "currentColor" : _ref65$color,
      _ref65$size = _ref65.size,
      e = _ref65$size === void 0 ? 24 : _ref65$size,
      l = _ref65.className,
      i = _objectWithoutProperties(_ref65, _excluded65);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7 11.5C4.51472 11.5 2.5 9.48528 2.5 7C2.5 4.51472 4.51472 2.5 7 2.5C9.48528 2.5 11.5 4.51472 11.5 7C11.5 9.48528 9.48528 11.5 7 11.5ZM7 21.5C4.51472 21.5 2.5 19.4853 2.5 17C2.5 14.5147 4.51472 12.5 7 12.5C9.48528 12.5 11.5 14.5147 11.5 17C11.5 19.4853 9.48528 21.5 7 21.5ZM17 11.5C14.5147 11.5 12.5 9.48528 12.5 7C12.5 4.51472 14.5147 2.5 17 2.5C19.4853 2.5 21.5 4.51472 21.5 7C21.5 9.48528 19.4853 11.5 17 11.5ZM17 21.5C14.5147 21.5 12.5 19.4853 12.5 17C12.5 14.5147 14.5147 12.5 17 12.5C19.4853 12.5 21.5 14.5147 21.5 17C21.5 19.4853 19.4853 21.5 17 21.5Z"
  }));
},
    V1 = function V1(_ref66) {
  var _ref66$color = _ref66.color,
      C = _ref66$color === void 0 ? "currentColor" : _ref66$color,
      _ref66$size = _ref66.size,
      e = _ref66$size === void 0 ? 24 : _ref66$size,
      l = _ref66.className,
      i = _objectWithoutProperties(_ref66, _excluded66);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7 11.5C4.51472 11.5 2.5 9.48528 2.5 7C2.5 4.51472 4.51472 2.5 7 2.5C9.48528 2.5 11.5 4.51472 11.5 7C11.5 9.48528 9.48528 11.5 7 11.5ZM7 21.5C4.51472 21.5 2.5 19.4853 2.5 17C2.5 14.5147 4.51472 12.5 7 12.5C9.48528 12.5 11.5 14.5147 11.5 17C11.5 19.4853 9.48528 21.5 7 21.5ZM17 11.5C14.5147 11.5 12.5 9.48528 12.5 7C12.5 4.51472 14.5147 2.5 17 2.5C19.4853 2.5 21.5 4.51472 21.5 7C21.5 9.48528 19.4853 11.5 17 11.5ZM17 21.5C14.5147 21.5 12.5 19.4853 12.5 17C12.5 14.5147 14.5147 12.5 17 12.5C19.4853 12.5 21.5 14.5147 21.5 17C21.5 19.4853 19.4853 21.5 17 21.5ZM7 9.5C8.38071 9.5 9.5 8.38071 9.5 7C9.5 5.61929 8.38071 4.5 7 4.5C5.61929 4.5 4.5 5.61929 4.5 7C4.5 8.38071 5.61929 9.5 7 9.5ZM7 19.5C8.38071 19.5 9.5 18.3807 9.5 17C9.5 15.6193 8.38071 14.5 7 14.5C5.61929 14.5 4.5 15.6193 4.5 17C4.5 18.3807 5.61929 19.5 7 19.5ZM17 9.5C18.3807 9.5 19.5 8.38071 19.5 7C19.5 5.61929 18.3807 4.5 17 4.5C15.6193 4.5 14.5 5.61929 14.5 7C14.5 8.38071 15.6193 9.5 17 9.5ZM17 19.5C18.3807 19.5 19.5 18.3807 19.5 17C19.5 15.6193 18.3807 14.5 17 14.5C15.6193 14.5 14.5 15.6193 14.5 17C14.5 18.3807 15.6193 19.5 17 19.5Z"
  }));
},
    g1 = function g1(_ref67) {
  var _ref67$color = _ref67.color,
      C = _ref67$color === void 0 ? "currentColor" : _ref67$color,
      _ref67$size = _ref67.size,
      e = _ref67$size === void 0 ? 24 : _ref67$size,
      l = _ref67.className,
      i = _objectWithoutProperties(_ref67, _excluded67);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.75 2.5C9.09721 2.5 11 4.40279 11 6.75V11H6.75C4.40279 11 2.5 9.09721 2.5 6.75C2.5 4.40279 4.40279 2.5 6.75 2.5ZM6.75 13H11V17.25C11 19.5972 9.09721 21.5 6.75 21.5C4.40279 21.5 2.5 19.5972 2.5 17.25C2.5 14.9028 4.40279 13 6.75 13ZM17.25 2.5C19.5972 2.5 21.5 4.40279 21.5 6.75C21.5 9.09721 19.5972 11 17.25 11H13V6.75C13 4.40279 14.9028 2.5 17.25 2.5ZM13 13H17.25C19.5972 13 21.5 14.9028 21.5 17.25C21.5 19.5972 19.5972 21.5 17.25 21.5C14.9028 21.5 13 19.5972 13 17.25V13Z"
  }));
},
    M1 = function M1(_ref68) {
  var _ref68$color = _ref68.color,
      C = _ref68$color === void 0 ? "currentColor" : _ref68$color,
      _ref68$size = _ref68.size,
      e = _ref68$size === void 0 ? 24 : _ref68$size,
      l = _ref68.className,
      i = _objectWithoutProperties(_ref68, _excluded68);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.75 2.5C9.09721 2.5 11 4.40279 11 6.75V11H6.75C4.40279 11 2.5 9.09721 2.5 6.75C2.5 4.40279 4.40279 2.5 6.75 2.5ZM9 9V6.75C9 5.50736 7.99264 4.5 6.75 4.5C5.50736 4.5 4.5 5.50736 4.5 6.75C4.5 7.99264 5.50736 9 6.75 9H9ZM6.75 13H11V17.25C11 19.5972 9.09721 21.5 6.75 21.5C4.40279 21.5 2.5 19.5972 2.5 17.25C2.5 14.9028 4.40279 13 6.75 13ZM6.75 15C5.50736 15 4.5 16.0074 4.5 17.25C4.5 18.4926 5.50736 19.5 6.75 19.5C7.99264 19.5 9 18.4926 9 17.25V15H6.75ZM17.25 2.5C19.5972 2.5 21.5 4.40279 21.5 6.75C21.5 9.09721 19.5972 11 17.25 11H13V6.75C13 4.40279 14.9028 2.5 17.25 2.5ZM17.25 9C18.4926 9 19.5 7.99264 19.5 6.75C19.5 5.50736 18.4926 4.5 17.25 4.5C16.0074 4.5 15 5.50736 15 6.75V9H17.25ZM13 13H17.25C19.5972 13 21.5 14.9028 21.5 17.25C21.5 19.5972 19.5972 21.5 17.25 21.5C14.9028 21.5 13 19.5972 13 17.25V13ZM15 15V17.25C15 18.4926 16.0074 19.5 17.25 19.5C18.4926 19.5 19.5 18.4926 19.5 17.25C19.5 16.0074 18.4926 15 17.25 15H15Z"
  }));
},
    Z1 = function Z1(_ref69) {
  var _ref69$color = _ref69.color,
      C = _ref69$color === void 0 ? "currentColor" : _ref69$color,
      _ref69$size = _ref69.size,
      e = _ref69$size === void 0 ? 24 : _ref69$size,
      l = _ref69.className,
      i = _objectWithoutProperties(_ref69, _excluded69);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 13H21V21.0025C21 21.5534 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5537 3 21.0025V13ZM3 2.99754C3 2.44662 3.44495 2 3.9934 2H20.0066C20.5552 2 21 2.44631 21 2.99754V11H3V2.99754ZM9 5V7H15V5H9ZM9 16V18H15V16H9Z"
  }));
},
    x1 = function x1(_ref70) {
  var _ref70$color = _ref70.color,
      C = _ref70$color === void 0 ? "currentColor" : _ref70$color,
      _ref70$size = _ref70.size,
      e = _ref70$size === void 0 ? 24 : _ref70$size,
      l = _ref70.className,
      i = _objectWithoutProperties(_ref70, _excluded70);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 2.9918C3 2.44405 3.44495 2 3.9934 2H20.0066C20.5552 2 21 2.45531 21 2.9918V21.0082C21 21.556 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918ZM19 11V4H5V11H19ZM19 13H5V20H19V13ZM9 6H15V8H9V6ZM9 15H15V17H9V15Z"
  }));
},
    v1 = function v1(_ref71) {
  var _ref71$color = _ref71.color,
      C = _ref71$color === void 0 ? "currentColor" : _ref71$color,
      _ref71$size = _ref71.size,
      e = _ref71$size === void 0 ? 24 : _ref71$size,
      l = _ref71.className,
      i = _objectWithoutProperties(_ref71, _excluded71);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 10H21V20.0044C21 20.5543 20.5551 21 20.0066 21H3.9934C3.44476 21 3 20.5552 3 20.0044V10ZM9 12V14H15V12H9ZM2 3.99981C2 3.44763 2.45531 3 2.9918 3H21.0082C21.556 3 22 3.44372 22 3.99981V8H2V3.99981Z"
  }));
},
    d1 = function d1(_ref72) {
  var _ref72$color = _ref72.color,
      C = _ref72$color === void 0 ? "currentColor" : _ref72$color,
      _ref72$size = _ref72.size,
      e = _ref72$size === void 0 ? 24 : _ref72$size,
      l = _ref72.className,
      i = _objectWithoutProperties(_ref72, _excluded72);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 10H2V4.00293C2 3.44903 2.45531 3 2.9918 3H21.0082C21.556 3 22 3.43788 22 4.00293V10H21V20.0015C21 20.553 20.5551 21 20.0066 21H3.9934C3.44476 21 3 20.5525 3 20.0015V10ZM19 10H5V19H19V10ZM4 5V8H20V5H4ZM9 12H15V14H9V12Z"
  }));
},
    p1 = function p1(_ref73) {
  var _ref73$color = _ref73.color,
      C = _ref73$color === void 0 ? "currentColor" : _ref73$color,
      _ref73$size = _ref73.size,
      e = _ref73$size === void 0 ? 24 : _ref73$size,
      l = _ref73.className,
      i = _objectWithoutProperties(_ref73, _excluded73);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2ZM13 12V8H11V12H8L12 16L16 12H13Z"
  }));
},
    E1 = function E1(_ref74) {
  var _ref74$color = _ref74.color,
      C = _ref74$color === void 0 ? "currentColor" : _ref74$color,
      _ref74$size = _ref74.size,
      e = _ref74$size === void 0 ? 24 : _ref74$size,
      l = _ref74.className,
      i = _objectWithoutProperties(_ref74, _excluded74);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2ZM12 20C16.42 20 20 16.42 20 12C20 7.58 16.42 4 12 4C7.58 4 4 7.58 4 12C4 16.42 7.58 20 12 20ZM13 12H16L12 16L8 12H11V8H13V12Z"
  }));
},
    N1 = function N1(_ref75) {
  var _ref75$color = _ref75.color,
      C = _ref75$color === void 0 ? "currentColor" : _ref75$color,
      _ref75$size = _ref75.size,
      e = _ref75$size === void 0 ? 24 : _ref75$size,
      l = _ref75.className,
      i = _objectWithoutProperties(_ref75, _excluded75);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13 12H20L12 20L4 12H11V4H13V12Z"
  }));
},
    u1 = function u1(_ref76) {
  var _ref76$color = _ref76.color,
      C = _ref76$color === void 0 ? "currentColor" : _ref76$color,
      _ref76$size = _ref76.size,
      e = _ref76$size === void 0 ? 24 : _ref76$size,
      l = _ref76.className,
      i = _objectWithoutProperties(_ref76, _excluded76);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13.0001 16.1716L18.3641 10.8076L19.7783 12.2218L12.0001 20L4.22192 12.2218L5.63614 10.8076L11.0001 16.1716V4H13.0001V16.1716Z"
  }));
},
    B1 = function B1(_ref77) {
  var _ref77$color = _ref77.color,
      C = _ref77$color === void 0 ? "currentColor" : _ref77$color,
      _ref77$size = _ref77.size,
      e = _ref77$size === void 0 ? 24 : _ref77$size,
      l = _ref77.className,
      i = _objectWithoutProperties(_ref77, _excluded77);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 16L6 10H18L12 16Z"
  }));
},
    f1 = function f1(_ref78) {
  var _ref78$color = _ref78.color,
      C = _ref78$color === void 0 ? "currentColor" : _ref78$color,
      _ref78$size = _ref78.size,
      e = _ref78$size === void 0 ? 24 : _ref78$size,
      l = _ref78.className,
      i = _objectWithoutProperties(_ref78, _excluded78);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11.9999 13.1714L16.9497 8.22168L18.3639 9.63589L11.9999 15.9999L5.63599 9.63589L7.0502 8.22168L11.9999 13.1714Z"
  }));
},
    R1 = function R1(_ref79) {
  var _ref79$color = _ref79.color,
      C = _ref79$color === void 0 ? "currentColor" : _ref79$color,
      _ref79$size = _ref79.size,
      e = _ref79$size === void 0 ? 24 : _ref79$size,
      l = _ref79.className,
      i = _objectWithoutProperties(_ref79, _excluded79);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 14L8 10H16L12 14Z"
  }));
},
    z1 = function z1(_ref80) {
  var _ref80$color = _ref80.color,
      C = _ref80$color === void 0 ? "currentColor" : _ref80$color,
      _ref80$size = _ref80.size,
      e = _ref80$size === void 0 ? 24 : _ref80$size,
      l = _ref80.className,
      i = _objectWithoutProperties(_ref80, _excluded80);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 15.0006L7.75732 10.758L9.17154 9.34375L12 12.1722L14.8284 9.34375L16.2426 10.758L12 15.0006Z"
  }));
},
    F1 = function F1(_ref81) {
  var _ref81$color = _ref81.color,
      C = _ref81$color === void 0 ? "currentColor" : _ref81$color,
      _ref81$size = _ref81.size,
      e = _ref81$size === void 0 ? 24 : _ref81$size,
      l = _ref81.className,
      i = _objectWithoutProperties(_ref81, _excluded81);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9 12L13 8V16L9 12Z"
  }));
},
    S1 = function S1(_ref82) {
  var _ref82$color = _ref82.color,
      C = _ref82$color === void 0 ? "currentColor" : _ref82$color,
      _ref82$size = _ref82.size,
      e = _ref82$size === void 0 ? 24 : _ref82$size,
      l = _ref82.className,
      i = _objectWithoutProperties(_ref82, _excluded82);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11.8284 12.0005L14.6569 14.8289L13.2426 16.2431L9 12.0005L13.2426 7.75781L14.6569 9.17203L11.8284 12.0005Z"
  }));
},
    A1 = function A1(_ref83) {
  var _ref83$color = _ref83.color,
      C = _ref83$color === void 0 ? "currentColor" : _ref83$color,
      _ref83$size = _ref83.size,
      e = _ref83$size === void 0 ? 24 : _ref83$size,
      l = _ref83.className,
      i = _objectWithoutProperties(_ref83, _excluded83);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14 12L10 16V8L14 12Z"
  }));
},
    k1 = function k1(_ref84) {
  var _ref84$color = _ref84.color,
      C = _ref84$color === void 0 ? "currentColor" : _ref84$color,
      _ref84$size = _ref84.size,
      e = _ref84$size === void 0 ? 24 : _ref84$size,
      l = _ref84.className,
      i = _objectWithoutProperties(_ref84, _excluded84);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.1717 12.0005L9.34326 9.17203L10.7575 7.75781L15.0001 12.0005L10.7575 16.2431L9.34326 14.8289L12.1717 12.0005Z"
  }));
},
    P1 = function P1(_ref85) {
  var _ref85$color = _ref85.color,
      C = _ref85$color === void 0 ? "currentColor" : _ref85$color,
      _ref85$size = _ref85.size,
      e = _ref85$size === void 0 ? 24 : _ref85$size,
      l = _ref85.className,
      i = _objectWithoutProperties(_ref85, _excluded85);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 10L16 14H8L12 10Z"
  }));
},
    D1 = function D1(_ref86) {
  var _ref86$color = _ref86.color,
      C = _ref86$color === void 0 ? "currentColor" : _ref86$color,
      _ref86$size = _ref86.size,
      e = _ref86$size === void 0 ? 24 : _ref86$size,
      l = _ref86.className,
      i = _objectWithoutProperties(_ref86, _excluded86);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 11.8284L9.17154 14.6569L7.75732 13.2426L12 9L16.2426 13.2426L14.8284 14.6569L12 11.8284Z"
  }));
},
    y1 = function y1(_ref87) {
  var _ref87$color = _ref87.color,
      C = _ref87$color === void 0 ? "currentColor" : _ref87$color,
      _ref87$size = _ref87.size,
      e = _ref87$size === void 0 ? 24 : _ref87$size,
      l = _ref87.className,
      i = _objectWithoutProperties(_ref87, _excluded87);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8 7V11L2 6L8 1V5H13C17.4183 5 21 8.58172 21 13C21 17.4183 17.4183 21 13 21H4V19H13C16.3137 19 19 16.3137 19 13C19 9.68629 16.3137 7 13 7H8Z"
  }));
},
    b1 = function b1(_ref88) {
  var _ref88$color = _ref88.color,
      C = _ref88$color === void 0 ? "currentColor" : _ref88$color,
      _ref88$size = _ref88.size,
      e = _ref88$size === void 0 ? 24 : _ref88$size,
      l = _ref88.className,
      i = _objectWithoutProperties(_ref88, _excluded88);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5.82843 6.99955L8.36396 9.53509L6.94975 10.9493L2 5.99955L6.94975 1.0498L8.36396 2.46402L5.82843 4.99955H13C17.4183 4.99955 21 8.58127 21 12.9996C21 17.4178 17.4183 20.9996 13 20.9996H4V18.9996H13C16.3137 18.9996 19 16.3133 19 12.9996C19 9.68584 16.3137 6.99955 13 6.99955H5.82843Z"
  }));
},
    T1 = function T1(_ref89) {
  var _ref89$color = _ref89.color,
      C = _ref89$color === void 0 ? "currentColor" : _ref89$color,
      _ref89$size = _ref89.size,
      e = _ref89$size === void 0 ? 24 : _ref89$size,
      l = _ref89.className,
      i = _objectWithoutProperties(_ref89, _excluded89);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16 7H11C7.68629 7 5 9.68629 5 13C5 16.3137 7.68629 19 11 19H20V21H11C6.58172 21 3 17.4183 3 13C3 8.58172 6.58172 5 11 5H16V1L22 6L16 11V7Z"
  }));
},
    U1 = function U1(_ref90) {
  var _ref90$color = _ref90.color,
      C = _ref90$color === void 0 ? "currentColor" : _ref90$color,
      _ref90$size = _ref90.size,
      e = _ref90$size === void 0 ? 24 : _ref90$size,
      l = _ref90.className,
      i = _objectWithoutProperties(_ref90, _excluded90);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18.1716 6.99955H11C7.68629 6.99955 5 9.68584 5 12.9996C5 16.3133 7.68629 18.9996 11 18.9996H20V20.9996H11C6.58172 20.9996 3 17.4178 3 12.9996C3 8.58127 6.58172 4.99955 11 4.99955H18.1716L15.636 2.46402L17.0503 1.0498L22 5.99955L17.0503 10.9493L15.636 9.53509L18.1716 6.99955Z"
  }));
},
    G1 = function G1(_ref91) {
  var _ref91$color = _ref91.color,
      C = _ref91$color === void 0 ? "currentColor" : _ref91$color,
      _ref91$size = _ref91.size,
      e = _ref91$size === void 0 ? 24 : _ref91$size,
      l = _ref91.className,
      i = _objectWithoutProperties(_ref91, _excluded91);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2ZM12 11V8L8 12L12 16V13H16V11H12Z"
  }));
},
    I1 = function I1(_ref92) {
  var _ref92$color = _ref92.color,
      C = _ref92$color === void 0 ? "currentColor" : _ref92$color,
      _ref92$size = _ref92.size,
      e = _ref92$size === void 0 ? 24 : _ref92$size,
      l = _ref92.className,
      i = _objectWithoutProperties(_ref92, _excluded92);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2ZM12 20C16.42 20 20 16.42 20 12C20 7.58 16.42 4 12 4C7.58 4 4 7.58 4 12C4 16.42 7.58 20 12 20ZM12 11H16V13H12V16L8 12L12 8V11Z"
  }));
},
    W1 = function W1(_ref93) {
  var _ref93$color = _ref93.color,
      C = _ref93$color === void 0 ? "currentColor" : _ref93$color,
      _ref93$size = _ref93.size,
      e = _ref93$size === void 0 ? 24 : _ref93$size,
      l = _ref93.className,
      i = _objectWithoutProperties(_ref93, _excluded93);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.3608 13.0515L17.3105 18.0013H5.99683V6.68758L10.9466 11.6373L16.6034 5.98047L18.0176 7.39468L12.3608 13.0515Z"
  }));
},
    O1 = function O1(_ref94) {
  var _ref94$color = _ref94.color,
      C = _ref94$color === void 0 ? "currentColor" : _ref94$color,
      _ref94$size = _ref94.size,
      e = _ref94$size === void 0 ? 24 : _ref94$size,
      l = _ref94.className,
      i = _objectWithoutProperties(_ref94, _excluded94);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9 13.589L17.6066 4.98242L19.0208 6.39664L10.4142 15.0032H18V17.0032H7V6.00324H9V13.589Z"
  }));
},
    K1 = function K1(_ref95) {
  var _ref95$color = _ref95.color,
      C = _ref95$color === void 0 ? "currentColor" : _ref95$color,
      _ref95$size = _ref95.size,
      e = _ref95$size === void 0 ? 24 : _ref95$size,
      l = _ref95.className,
      i = _objectWithoutProperties(_ref95, _excluded95);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 13V20L4 12L12 4V11H20V13H12Z"
  }));
},
    Q1 = function Q1(_ref96) {
  var _ref96$color = _ref96.color,
      C = _ref96$color === void 0 ? "currentColor" : _ref96$color,
      _ref96$size = _ref96.size,
      e = _ref96$size === void 0 ? 24 : _ref96$size,
      l = _ref96.className,
      i = _objectWithoutProperties(_ref96, _excluded96);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7.82843 10.9999H20V12.9999H7.82843L13.1924 18.3638L11.7782 19.778L4 11.9999L11.7782 4.22168L13.1924 5.63589L7.82843 10.9999Z"
  }));
},
    q1 = function q1(_ref97) {
  var _ref97$color = _ref97.color,
      C = _ref97$color === void 0 ? "currentColor" : _ref97$color,
      _ref97$size = _ref97.size,
      e = _ref97$size === void 0 ? 24 : _ref97$size,
      l = _ref97.className,
      i = _objectWithoutProperties(_ref97, _excluded97);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16 16V12L21 17L16 22V18H4V16H16ZM8 2V5.999L20 6V8H8V12L3 7L8 2Z"
  }));
},
    j1 = function j1(_ref98) {
  var _ref98$color = _ref98.color,
      C = _ref98$color === void 0 ? "currentColor" : _ref98$color,
      _ref98$size = _ref98.size,
      e = _ref98$size === void 0 ? 24 : _ref98$size,
      l = _ref98.className,
      i = _objectWithoutProperties(_ref98, _excluded98);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16.0503 12.0498L21 16.9996L16.0503 21.9493L14.636 20.5351L17.172 17.9988L4 17.9996V15.9996L17.172 15.9988L14.636 13.464L16.0503 12.0498ZM7.94975 2.0498L9.36396 3.46402L6.828 5.9988L20 5.99955V7.99955L6.828 7.9988L9.36396 10.5351L7.94975 11.9493L3 6.99955L7.94975 2.0498Z"
  }));
},
    X1 = function X1(_ref99) {
  var _ref99$color = _ref99.color,
      C = _ref99$color === void 0 ? "currentColor" : _ref99$color,
      _ref99$size = _ref99.size,
      e = _ref99$size === void 0 ? 24 : _ref99$size,
      l = _ref99.className,
      i = _objectWithoutProperties(_ref99, _excluded99);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8 12L14 6V18L8 12Z"
  }));
},
    J1 = function J1(_ref100) {
  var _ref100$color = _ref100.color,
      C = _ref100$color === void 0 ? "currentColor" : _ref100$color,
      _ref100$size = _ref100.size,
      e = _ref100$size === void 0 ? 24 : _ref100$size,
      l = _ref100.className,
      i = _objectWithoutProperties(_ref100, _excluded100);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10.8284 12.0007L15.7782 16.9504L14.364 18.3646L8 12.0007L14.364 5.63672L15.7782 7.05093L10.8284 12.0007Z"
  }));
},
    Y1 = function Y1(_ref101) {
  var _ref101$color = _ref101.color,
      C = _ref101$color === void 0 ? "currentColor" : _ref101$color,
      _ref101$size = _ref101.size,
      e = _ref101$size === void 0 ? 24 : _ref101$size,
      l = _ref101.className,
      i = _objectWithoutProperties(_ref101, _excluded101);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.3608 10.9468L18.0176 16.6037L16.6034 18.0179L10.9466 12.361L5.99683 17.3108V5.99707H17.3105L12.3608 10.9468Z"
  }));
},
    _1 = function _1(_ref102) {
  var _ref102$color = _ref102.color,
      C = _ref102$color === void 0 ? "currentColor" : _ref102$color,
      _ref102$size = _ref102.size,
      e = _ref102$size === void 0 ? 24 : _ref102$size,
      l = _ref102.className,
      i = _objectWithoutProperties(_ref102, _excluded102);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9.41421 8L18.0208 16.6066L16.6066 18.0208L8 9.41421V17H6V6H17V8H9.41421Z"
  }));
},
    $1 = function $1(_ref103) {
  var _ref103$color = _ref103.color,
      C = _ref103$color === void 0 ? "currentColor" : _ref103$color,
      _ref103$size = _ref103.size,
      e = _ref103$size === void 0 ? 24 : _ref103$size,
      l = _ref103.className,
      i = _objectWithoutProperties(_ref103, _excluded103);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2ZM12 11H8V13H12V16L16 12L12 8V11Z"
  }));
},
    e2 = function e2(_ref104) {
  var _ref104$color = _ref104.color,
      C = _ref104$color === void 0 ? "currentColor" : _ref104$color,
      _ref104$size = _ref104.size,
      e = _ref104$size === void 0 ? 24 : _ref104$size,
      l = _ref104.className,
      i = _objectWithoutProperties(_ref104, _excluded104);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 11V8L16 12L12 16V13H8V11H12ZM12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2ZM12 20C16.42 20 20 16.42 20 12C20 7.58 16.42 4 12 4C7.58 4 4 7.58 4 12C4 16.42 7.58 20 12 20Z"
  }));
},
    t2 = function t2(_ref105) {
  var _ref105$color = _ref105.color,
      C = _ref105$color === void 0 ? "currentColor" : _ref105$color,
      _ref105$size = _ref105.size,
      e = _ref105$size === void 0 ? 24 : _ref105$size,
      l = _ref105.className,
      i = _objectWithoutProperties(_ref105, _excluded105);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11.6366 13.0515L5.97974 7.39468L7.39395 5.98047L13.0508 11.6373L18.0006 6.68758V18.0013H6.68684L11.6366 13.0515Z"
  }));
},
    C2 = function C2(_ref106) {
  var _ref106$color = _ref106.color,
      C = _ref106$color === void 0 ? "currentColor" : _ref106$color,
      _ref106$size = _ref106.size,
      e = _ref106$size === void 0 ? 24 : _ref106$size,
      l = _ref106.className,
      i = _objectWithoutProperties(_ref106, _excluded106);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14.5895 16.0032L5.98291 7.39664L7.39712 5.98242L16.0037 14.589V7.00324H18.0037V18.0032H7.00373V16.0032H14.5895Z"
  }));
},
    l2 = function l2(_ref107) {
  var _ref107$color = _ref107.color,
      C = _ref107$color === void 0 ? "currentColor" : _ref107$color,
      _ref107$size = _ref107.size,
      e = _ref107$size === void 0 ? 24 : _ref107$size,
      l = _ref107.className,
      i = _objectWithoutProperties(_ref107, _excluded107);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 13H4V11H12V4L20 12L12 20V13Z"
  }));
},
    i2 = function i2(_ref108) {
  var _ref108$color = _ref108.color,
      C = _ref108$color === void 0 ? "currentColor" : _ref108$color,
      _ref108$size = _ref108.size,
      e = _ref108$size === void 0 ? 24 : _ref108$size,
      l = _ref108.className,
      i = _objectWithoutProperties(_ref108, _excluded108);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z"
  }));
},
    s2 = function s2(_ref109) {
  var _ref109$color = _ref109.color,
      C = _ref109$color === void 0 ? "currentColor" : _ref109$color,
      _ref109$size = _ref109.size,
      e = _ref109$size === void 0 ? 24 : _ref109$size,
      l = _ref109.className,
      i = _objectWithoutProperties(_ref109, _excluded109);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16 12L10 18V6L16 12Z"
  }));
},
    r2 = function r2(_ref110) {
  var _ref110$color = _ref110.color,
      C = _ref110$color === void 0 ? "currentColor" : _ref110$color,
      _ref110$size = _ref110.size,
      e = _ref110$size === void 0 ? 24 : _ref110$size,
      l = _ref110.className,
      i = _objectWithoutProperties(_ref110, _excluded110);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13.1717 12.0007L8.22192 7.05093L9.63614 5.63672L16.0001 12.0007L9.63614 18.3646L8.22192 16.9504L13.1717 12.0007Z"
  }));
},
    c2 = function c2(_ref111) {
  var _ref111$color = _ref111.color,
      C = _ref111$color === void 0 ? "currentColor" : _ref111$color,
      _ref111$size = _ref111.size,
      e = _ref111$size === void 0 ? 24 : _ref111$size,
      l = _ref111.className,
      i = _objectWithoutProperties(_ref111, _excluded111);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13.0508 12.361L7.39395 18.0179L5.97974 16.6037L11.6366 10.9468L6.68684 5.99707H18.0006V17.3108L13.0508 12.361Z"
  }));
},
    o2 = function o2(_ref112) {
  var _ref112$color = _ref112.color,
      C = _ref112$color === void 0 ? "currentColor" : _ref112$color,
      _ref112$size = _ref112.size,
      e = _ref112$size === void 0 ? 24 : _ref112$size,
      l = _ref112.className,
      i = _objectWithoutProperties(_ref112, _excluded112);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16.0037 9.41421L7.39712 18.0208L5.98291 16.6066L14.5895 8H7.00373V6H18.0037V17H16.0037V9.41421Z"
  }));
},
    a2 = function a2(_ref113) {
  var _ref113$color = _ref113.color,
      C = _ref113$color === void 0 ? "currentColor" : _ref113$color,
      _ref113$size = _ref113.size,
      e = _ref113$size === void 0 ? 24 : _ref113$size,
      l = _ref113.className,
      i = _objectWithoutProperties(_ref113, _excluded113);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2ZM13 12H16L12 8L8 12H11V16H13V12Z"
  }));
},
    n2 = function n2(_ref114) {
  var _ref114$color = _ref114.color,
      C = _ref114$color === void 0 ? "currentColor" : _ref114$color,
      _ref114$size = _ref114.size,
      e = _ref114$size === void 0 ? 24 : _ref114$size,
      l = _ref114.className,
      i = _objectWithoutProperties(_ref114, _excluded114);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2ZM12 20C16.42 20 20 16.42 20 12C20 7.58 16.42 4 12 4C7.58 4 4 7.58 4 12C4 16.42 7.58 20 12 20ZM13 12V16H11V12H8L12 8L16 12H13Z"
  }));
},
    m2 = function m2(_ref115) {
  var _ref115$color = _ref115.color,
      C = _ref115$color === void 0 ? "currentColor" : _ref115$color,
      _ref115$size = _ref115.size,
      e = _ref115$size === void 0 ? 24 : _ref115$size,
      l = _ref115.className,
      i = _objectWithoutProperties(_ref115, _excluded115);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 8H8.001L8 20H6V8H2L7 3L12 8ZM22 16L17 21L12 16H16V4H18V16H22Z"
  }));
},
    w2 = function w2(_ref116) {
  var _ref116$color = _ref116.color,
      C = _ref116$color === void 0 ? "currentColor" : _ref116$color,
      _ref116$size = _ref116.size,
      e = _ref116$size === void 0 ? 24 : _ref116$size,
      l = _ref116.className,
      i = _objectWithoutProperties(_ref116, _excluded116);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11.9498 7.94975L10.5356 9.36396L8.00079 6.828L8.00004 20H6.00004L6.00079 6.828L3.46451 9.36396L2.05029 7.94975L7.00004 3L11.9498 7.94975ZM21.9498 16.0503L17 21L12.0503 16.0503L13.4645 14.636L16.0008 17.172L16 4H18L18.0008 17.172L20.5356 14.636L21.9498 16.0503Z"
  }));
},
    L2 = function L2(_ref117) {
  var _ref117$color = _ref117.color,
      C = _ref117$color === void 0 ? "currentColor" : _ref117$color,
      _ref117$size = _ref117.size,
      e = _ref117$size === void 0 ? 24 : _ref117$size,
      l = _ref117.className,
      i = _objectWithoutProperties(_ref117, _excluded117);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13 12V20H11V12H4L12 4L20 12H13Z"
  }));
},
    h2 = function h2(_ref118) {
  var _ref118$color = _ref118.color,
      C = _ref118$color === void 0 ? "currentColor" : _ref118$color,
      _ref118$size = _ref118.size,
      e = _ref118$size === void 0 ? 24 : _ref118$size,
      l = _ref118.className,
      i = _objectWithoutProperties(_ref118, _excluded118);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13.0001 7.82843V20H11.0001V7.82843L5.63614 13.1924L4.22192 11.7782L12.0001 4L19.7783 11.7782L18.3641 13.1924L13.0001 7.82843Z"
  }));
},
    H2 = function H2(_ref119) {
  var _ref119$color = _ref119.color,
      C = _ref119$color === void 0 ? "currentColor" : _ref119$color,
      _ref119$size = _ref119.size,
      e = _ref119$size === void 0 ? 24 : _ref119$size,
      l = _ref119.className,
      i = _objectWithoutProperties(_ref119, _excluded119);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 8L18 14H6L12 8Z"
  }));
},
    V2 = function V2(_ref120) {
  var _ref120$color = _ref120.color,
      C = _ref120$color === void 0 ? "currentColor" : _ref120$color,
      _ref120$size = _ref120.size,
      e = _ref120$size === void 0 ? 24 : _ref120$size,
      l = _ref120.className,
      i = _objectWithoutProperties(_ref120, _excluded120);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11.9999 10.8284L7.0502 15.7782L5.63599 14.364L11.9999 8L18.3639 14.364L16.9497 15.7782L11.9999 10.8284Z"
  }));
},
    g2 = function g2(_ref121) {
  var _ref121$color = _ref121.color,
      C = _ref121$color === void 0 ? "currentColor" : _ref121$color,
      _ref121$size = _ref121.size,
      e = _ref121$size === void 0 ? 24 : _ref121$size,
      l = _ref121.className,
      i = _objectWithoutProperties(_ref121, _excluded121);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6 6H18V18H6V6ZM6 2H8V5H6V2ZM6 19H8V22H6V19ZM2 6H5V8H2V6ZM2 16H5V18H2V16ZM19 6H22V8H19V6ZM19 16H22V18H19V16ZM16 2H18V5H16V2ZM16 19H18V22H16V19Z"
  }));
},
    M2 = function M2(_ref122) {
  var _ref122$color = _ref122.color,
      C = _ref122$color === void 0 ? "currentColor" : _ref122$color,
      _ref122$size = _ref122.size,
      e = _ref122$size === void 0 ? 24 : _ref122$size,
      l = _ref122.className,
      i = _objectWithoutProperties(_ref122, _excluded122);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8 8V16H16V8H8ZM6 6H18V18H6V6ZM6 2H8V5H6V2ZM6 19H8V22H6V19ZM2 6H5V8H2V6ZM2 16H5V18H2V16ZM19 6H22V8H19V6ZM19 16H22V18H19V16ZM16 2H18V5H16V2ZM16 19H18V22H16V19Z"
  }));
},
    Z2 = function Z2(_ref123) {
  var _ref123$color = _ref123.color,
      C = _ref123$color === void 0 ? "currentColor" : _ref123$color,
      _ref123$size = _ref123.size,
      e = _ref123$size === void 0 ? 24 : _ref123$size,
      l = _ref123.className,
      i = _objectWithoutProperties(_ref123, _excluded123);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8.58579 17H3V15H21V17H15.4142L18.6569 20.2426L17.2426 21.6569L13 17.4142V20H11V17.4142L6.75736 21.6569L5.34315 20.2426L8.58579 17ZM5 3H19C19.5523 3 20 3.44772 20 4V14H4V4C4 3.44772 4.44772 3 5 3Z"
  }));
},
    x2 = function x2(_ref124) {
  var _ref124$color = _ref124.color,
      C = _ref124$color === void 0 ? "currentColor" : _ref124$color,
      _ref124$size = _ref124.size,
      e = _ref124$size === void 0 ? 24 : _ref124$size,
      l = _ref124.className,
      i = _objectWithoutProperties(_ref124, _excluded124);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8.58579 17H3V15H21V17H15.4142L18.6569 20.2426L17.2426 21.6569L13 17.4142V20H11V17.4142L6.75736 21.6569L5.34315 20.2426L8.58579 17ZM5 3H19C19.5523 3 20 3.44772 20 4V14H4V4C4 3.44772 4.44772 3 5 3ZM6 5V12H18V5H6Z"
  }));
},
    v2 = function v2(_ref125) {
  var _ref125$color = _ref125.color,
      C = _ref125$color === void 0 ? "currentColor" : _ref125$color,
      _ref125$size = _ref125.size,
      e = _ref125$size === void 0 ? 24 : _ref125$size,
      l = _ref125.className,
      i = _objectWithoutProperties(_ref125, _excluded125);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 22H4C3.44772 22 3 21.5523 3 21V3C3 2.44772 3.44772 2 4 2H20C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22ZM7 6V10H11V6H7ZM7 12V14H17V12H7ZM7 16V18H17V16H7ZM13 7V9H17V7H13Z"
  }));
},
    d2 = function d2(_ref126) {
  var _ref126$color = _ref126.color,
      C = _ref126$color === void 0 ? "currentColor" : _ref126$color,
      _ref126$size = _ref126.size,
      e = _ref126$size === void 0 ? 24 : _ref126$size,
      l = _ref126.className,
      i = _objectWithoutProperties(_ref126, _excluded126);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 22H4C3.44772 22 3 21.5523 3 21V3C3 2.44772 3.44772 2 4 2H20C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22ZM19 20V4H5V20H19ZM7 6H11V10H7V6ZM7 12H17V14H7V12ZM7 16H17V18H7V16ZM13 7H17V9H13V7Z"
  }));
},
    p2 = function p2(_ref127) {
  var _ref127$color = _ref127.color,
      C = _ref127$color === void 0 ? "currentColor" : _ref127$color,
      _ref127$size = _ref127.size,
      e = _ref127$size === void 0 ? 24 : _ref127$size,
      l = _ref127.className,
      i = _objectWithoutProperties(_ref127, _excluded127);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 3C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21ZM18 12H16V15H13V17H18V12ZM11 7H6V12H8V9H11V7Z"
  }));
},
    E2 = function E2(_ref128) {
  var _ref128$color = _ref128.color,
      C = _ref128$color === void 0 ? "currentColor" : _ref128$color,
      _ref128$size = _ref128.size,
      e = _ref128$size === void 0 ? 24 : _ref128$size,
      l = _ref128.className,
      i = _objectWithoutProperties(_ref128, _excluded128);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 3C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21ZM20 5H4V19H20V5ZM13 17V15H16V12H18V17H13ZM11 7V9H8V12H6V7H11Z"
  }));
},
    N2 = function N2(_ref129) {
  var _ref129$color = _ref129.color,
      C = _ref129$color === void 0 ? "currentColor" : _ref129$color,
      _ref129$size = _ref129.size,
      e = _ref129$size === void 0 ? 24 : _ref129$size,
      l = _ref129.className,
      i = _objectWithoutProperties(_ref129, _excluded129);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.9998 3L12.9996 10.267L19.294 6.63397L20.294 8.36602L14.0006 11.999L20.294 15.634L19.294 17.366L12.9996 13.732L12.9998 21H10.9998L10.9996 13.732L4.70557 17.366L3.70557 15.634L9.99857 12L3.70557 8.36602L4.70557 6.63397L10.9996 10.267L10.9998 3H12.9998Z"
  }));
},
    u2 = function u2(_ref130) {
  var _ref130$color = _ref130.color,
      C = _ref130$color === void 0 ? "currentColor" : _ref130$color,
      _ref130$size = _ref130.size,
      e = _ref130$size === void 0 ? 24 : _ref130$size,
      l = _ref130.className,
      i = _objectWithoutProperties(_ref130, _excluded130);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C13.4702 20 14.8478 19.6034 16.0316 18.9114L15.0237 17.1835C14.1359 17.7026 13.1027 18 12 18C8.68629 18 6 15.3137 6 12C6 8.68629 8.68629 6 12 6C15.3137 6 18 8.68629 18 12V13C18 13.5523 17.5523 14 17 14C16.4477 14 16 13.5523 16 13V9H14.6458C13.9407 8.37764 13.0144 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16C13.0465 16 13.9991 15.5982 14.7119 14.9404C15.2622 15.5886 16.0831 16 17 16C18.6569 16 20 14.6569 20 13V12ZM12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10Z"
  }));
},
    B2 = function B2(_ref131) {
  var _ref131$color = _ref131.color,
      C = _ref131$color === void 0 ? "currentColor" : _ref131$color,
      _ref131$size = _ref131.size,
      e = _ref131$size === void 0 ? 24 : _ref131$size,
      l = _ref131.className,
      i = _objectWithoutProperties(_ref131, _excluded131);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C13.6418 20 15.1681 19.5054 16.4381 18.6571L17.5476 20.3214C15.9602 21.3818 14.0523 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12V13.5C22 15.433 20.433 17 18.5 17C17.2958 17 16.2336 16.3918 15.6038 15.4659C14.6942 16.4115 13.4158 17 12 17C9.23858 17 7 14.7614 7 12C7 9.23858 9.23858 7 12 7C13.1258 7 14.1647 7.37209 15.0005 8H17V13.5C17 14.3284 17.6716 15 18.5 15C19.3284 15 20 14.3284 20 13.5V12ZM12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9Z"
  }));
},
    f2 = function f2(_ref132) {
  var _ref132$color = _ref132.color,
      C = _ref132$color === void 0 ? "currentColor" : _ref132$color,
      _ref132$size = _ref132.size,
      e = _ref132$size === void 0 ? 24 : _ref132$size,
      l = _ref132.className,
      i = _objectWithoutProperties(_ref132, _excluded132);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14.8287 7.75737L9.1718 13.4142C8.78127 13.8047 8.78127 14.4379 9.1718 14.8284C9.56232 15.219 10.1955 15.219 10.586 14.8284L16.2429 9.17158C17.4144 8.00001 17.4144 6.10052 16.2429 4.92894C15.0713 3.75737 13.1718 3.75737 12.0002 4.92894L6.34337 10.5858C4.39075 12.5384 4.39075 15.7042 6.34337 17.6569C8.29599 19.6095 11.4618 19.6095 13.4144 17.6569L19.0713 12L20.4855 13.4142L14.8287 19.0711C12.095 21.8047 7.66283 21.8047 4.92916 19.0711C2.19549 16.3374 2.19549 11.9053 4.92916 9.17158L10.586 3.51473C12.5386 1.56211 15.7045 1.56211 17.6571 3.51473C19.6097 5.46735 19.6097 8.63317 17.6571 10.5858L12.0002 16.2427C10.8287 17.4142 8.92916 17.4142 7.75759 16.2427C6.58601 15.0711 6.58601 13.1716 7.75759 12L13.4144 6.34316L14.8287 7.75737Z"
  }));
},
    R2 = function R2(_ref133) {
  var _ref133$color = _ref133.color,
      C = _ref133$color === void 0 ? "currentColor" : _ref133$color,
      _ref133$size = _ref133.size,
      e = _ref133$size === void 0 ? 24 : _ref133$size,
      l = _ref133.className,
      i = _objectWithoutProperties(_ref133, _excluded133);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.997 2.9918L20.9998 21.0082C20.9998 21.5447 20.5552 22 20.0066 22H3.9934C3.44495 22 3 21.556 3 21.0082V2.9918C3 2.45531 3.44468 2 3.99322 2H20.0036C20.5519 2 20.9969 2.44405 20.997 2.9918ZM9 13V9C9 8.44772 9.44772 8 10 8C10.5523 8 11 8.44772 11 9V13C11 13.5523 11.4477 14 12 14C12.5523 14 13 13.5523 13 13V9C13 7.34315 11.6569 6 10 6C8.34315 6 7 7.34315 7 9V13C7 15.7614 9.23858 18 12 18C14.7614 18 17 15.7614 17 13V8H15V13C15 14.6569 13.6569 16 12 16C10.3431 16 9 14.6569 9 13Z"
  }));
},
    z2 = function z2(_ref134) {
  var _ref134$color = _ref134.color,
      C = _ref134$color === void 0 ? "currentColor" : _ref134$color,
      _ref134$size = _ref134.size,
      e = _ref134$size === void 0 ? 24 : _ref134$size,
      l = _ref134.className,
      i = _objectWithoutProperties(_ref134, _excluded134);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14 13.5V8C14 5.79086 12.2091 4 10 4C7.79086 4 6 5.79086 6 8V13.5C6 17.0899 8.91015 20 12.5 20C16.0899 20 19 17.0899 19 13.5V4H21V13.5C21 18.1944 17.1944 22 12.5 22C7.80558 22 4 18.1944 4 13.5V8C4 4.68629 6.68629 2 10 2C13.3137 2 16 4.68629 16 8V13.5C16 15.433 14.433 17 12.5 17C10.567 17 9 15.433 9 13.5V8H11V13.5C11 14.3284 11.6716 15 12.5 15C13.3284 15 14 14.3284 14 13.5Z"
  }));
},
    F2 = function F2(_ref135) {
  var _ref135$color = _ref135.color,
      C = _ref135$color === void 0 ? "currentColor" : _ref135$color,
      _ref135$size = _ref135.size,
      e = _ref135$size === void 0 ? 24 : _ref135$size,
      l = _ref135.className,
      i = _objectWithoutProperties(_ref135, _excluded135);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14.0049 20.0028V22.0028H2.00488V20.0028H14.0049ZM14.5907 0.689087L22.3688 8.46726L20.9546 9.88147L19.894 9.52792L17.4191 12.0028L23.076 17.6597L21.6617 19.0739L16.0049 13.417L13.6007 15.8212L13.8836 16.9525L12.4693 18.3668L4.69117 10.5886L6.10539 9.17437L7.23676 9.45721L13.53 3.16396L13.1765 2.1033L14.5907 0.689087Z"
  }));
},
    S2 = function S2(_ref136) {
  var _ref136$color = _ref136.color,
      C = _ref136$color === void 0 ? "currentColor" : _ref136$color,
      _ref136$size = _ref136.size,
      e = _ref136$size === void 0 ? 24 : _ref136$size,
      l = _ref136.className,
      i = _objectWithoutProperties(_ref136, _excluded136);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14.0049 20.0028V22.0028H2.00488V20.0028H14.0049ZM14.5907 0.689087L22.3688 8.46726L20.9546 9.88147L19.894 9.52792L17.4191 12.0028L23.076 17.6597L21.6617 19.0739L16.0049 13.417L13.6007 15.8212L13.8836 16.9525L12.4693 18.3668L4.69117 10.5886L6.10539 9.17437L7.23676 9.45721L13.53 3.16396L13.1765 2.1033L14.5907 0.689087ZM15.2978 4.22462L8.22671 11.2957L11.7622 14.8312L18.8333 7.76015L15.2978 4.22462Z"
  }));
},
    A2 = function A2(_ref137) {
  var _ref137$color = _ref137.color,
      C = _ref137$color === void 0 ? "currentColor" : _ref137$color,
      _ref137$size = _ref137.size,
      e = _ref137$size === void 0 ? 24 : _ref137$size,
      l = _ref137.className,
      i = _objectWithoutProperties(_ref137, _excluded137);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17 15.2454V22.1169C17 22.393 16.7761 22.617 16.5 22.617C16.4094 22.617 16.3205 22.5923 16.2428 22.5457L12 20L7.75725 22.5457C7.52046 22.6877 7.21333 22.6109 7.07125 22.3742C7.02463 22.2964 7 22.2075 7 22.1169V15.2454C5.17107 13.7793 4 11.5264 4 9C4 4.58172 7.58172 1 12 1C16.4183 1 20 4.58172 20 9C20 11.5264 18.8289 13.7793 17 15.2454ZM12 15C15.3137 15 18 12.3137 18 9C18 5.68629 15.3137 3 12 3C8.68629 3 6 5.68629 6 9C6 12.3137 8.68629 15 12 15ZM12 13C9.79086 13 8 11.2091 8 9C8 6.79086 9.79086 5 12 5C14.2091 5 16 6.79086 16 9C16 11.2091 14.2091 13 12 13Z"
  }));
},
    k2 = function k2(_ref138) {
  var _ref138$color = _ref138.color,
      C = _ref138$color === void 0 ? "currentColor" : _ref138$color,
      _ref138$size = _ref138.size,
      e = _ref138$size === void 0 ? 24 : _ref138$size,
      l = _ref138.className,
      i = _objectWithoutProperties(_ref138, _excluded138);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17 15.2454V22.1169C17 22.393 16.7761 22.617 16.5 22.617C16.4094 22.617 16.3205 22.5923 16.2428 22.5457L12 20L7.75725 22.5457C7.52046 22.6877 7.21333 22.6109 7.07125 22.3742C7.02463 22.2964 7 22.2075 7 22.1169V15.2454C5.17107 13.7793 4 11.5264 4 9C4 4.58172 7.58172 1 12 1C16.4183 1 20 4.58172 20 9C20 11.5264 18.8289 13.7793 17 15.2454ZM9 16.4185V19.4676L12 17.6676L15 19.4676V16.4185C14.0736 16.7935 13.0609 17 12 17C10.9391 17 9.92643 16.7935 9 16.4185ZM12 15C15.3137 15 18 12.3137 18 9C18 5.68629 15.3137 3 12 3C8.68629 3 6 5.68629 6 9C6 12.3137 8.68629 15 12 15Z"
  }));
},
    P2 = function P2(_ref139) {
  var _ref139$color = _ref139.color,
      C = _ref139$color === void 0 ? "currentColor" : _ref139$color,
      _ref139$size = _ref139.size,
      e = _ref139$size === void 0 ? 24 : _ref139$size,
      l = _ref139.className,
      i = _objectWithoutProperties(_ref139, _excluded139);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5.92636 12.4965C7.98921 12.0535 7.70815 9.5883 7.64641 9.04949C7.54538 8.21882 6.56836 6.76688 5.24162 6.88173C3.57208 7.03154 3.32815 9.44324 3.32815 9.44324C3.10235 10.558 3.86869 12.9399 5.92636 12.4965ZM8.11701 16.7845C8.05656 16.9577 7.92186 17.4011 8.03843 17.787C8.26855 18.6531 9.02021 18.692 9.02021 18.692H10.1004V16.0514H8.94379C8.42397 16.2064 8.17313 16.611 8.11701 16.7845ZM9.75503 8.36259C10.8944 8.36259 11.8153 7.0514 11.8153 5.43022C11.8153 3.81076 10.8944 2.5 9.75503 2.5C8.61739 2.5 7.69433 3.81076 7.69433 5.43022C7.69433 7.0514 8.61783 8.36259 9.75503 8.36259ZM14.6622 8.55644C16.1849 8.75418 17.1641 7.12911 17.3588 5.89736C17.5574 4.66733 16.5748 3.23871 15.4967 2.99305C14.4165 2.74523 13.0678 4.47564 12.9447 5.60378C12.7979 6.98275 13.142 8.36087 14.6622 8.55644ZM14.6617 12.0039C12.7975 9.09914 10.1492 10.2812 9.26328 11.7587C8.38123 13.2356 7.00657 14.1699 6.81143 14.4173C6.61326 14.6608 3.9654 16.0903 4.55343 18.701C5.14103 21.31 7.20561 21.2604 7.20561 21.2604C7.20561 21.2604 8.72706 21.4102 10.492 21.0152C12.2578 20.6236 13.778 21.1127 13.778 21.1127C13.778 21.1127 17.9024 22.4939 19.031 19.8352C20.1582 17.1757 18.3933 15.7967 18.3933 15.7967C18.3933 15.7967 16.0373 13.9739 14.6617 12.0039ZM8.65496 19.7536C7.49703 19.5226 7.03593 18.7325 6.97765 18.5978C6.92066 18.461 6.59167 17.8259 6.76566 16.7453C7.26605 15.1262 8.69295 15.0101 8.69295 15.0101H10.1203V13.2555L11.3361 13.2741V19.7536H8.65496ZM13.2448 19.735C12.0489 19.4268 11.9932 18.5771 11.9932 18.5771V15.1651L13.2448 15.1448V18.2114C13.3212 18.5387 13.7275 18.5978 13.7275 18.5978H14.9989V15.1651H16.3304V19.735H13.2448ZM20.6983 10.6249C20.6983 10.0356 20.2087 8.26113 18.3933 8.26113C16.5748 8.26113 16.3317 9.93585 16.3317 11.1197C16.3317 12.2495 16.4271 13.8267 18.686 13.7766C20.9457 13.7265 20.6983 11.2173 20.6983 10.6249Z"
  }));
},
    D2 = function D2(_ref140) {
  var _ref140$color = _ref140.color,
      C = _ref140$color === void 0 ? "currentColor" : _ref140$color,
      _ref140$size = _ref140.size,
      e = _ref140$size === void 0 ? 24 : _ref140$size,
      l = _ref140.className,
      i = _objectWithoutProperties(_ref140, _excluded140);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7.56331 19.2798C7.73337 19.2876 7.92984 19.2906 8.14727 19.2863C8.77279 19.2739 9.4239 19.2047 10.059 19.0626C11.0716 18.838 12.0771 18.8143 13.0395 18.9318C13.5864 18.9986 14.0247 19.0969 14.3275 19.1891C15.4052 19.4638 16.9386 19.4119 17.3331 18.7782C17.6238 18.3113 17.5856 17.9916 17.3071 17.5803C17.2466 17.4909 17.1809 17.4105 17.1185 17.3445C17.1097 17.3351 17.1016 17.3269 17.0945 17.3197C17.0282 17.267 16.9917 17.2377 16.9302 17.1878C16.7544 17.0449 16.5599 16.8823 16.3513 16.702C15.7559 16.1875 15.1602 15.6296 14.5987 15.0426C13.9929 14.4095 13.461 13.7777 13.0219 13.1489L12.9861 13.0958C12.2441 11.9571 11.428 12.029 10.9837 12.7785C10.7019 13.254 10.3821 13.696 10.029 14.1105C9.61853 14.5924 9.19882 15.0001 8.72348 15.4067C8.60056 15.5119 8.22086 15.8269 8.31171 15.751C8.30802 15.7541 8.29484 15.7661 8.36265 15.6797C8.26441 15.8004 7.41258 16.5574 7.16177 16.8417C6.64726 17.4248 6.44014 17.9224 6.51725 18.3224C6.58965 18.6978 6.73623 18.9089 6.96754 19.0667C7.08515 19.1469 7.22108 19.2086 7.35634 19.2494C7.39091 19.2598 7.42153 19.2677 7.44674 19.2732C7.48007 19.2755 7.51904 19.2777 7.56331 19.2798ZM14.6617 12.0039C16.0373 13.9739 18.3933 15.7967 18.3933 15.7967C18.3933 15.7967 20.4569 17.5447 19.031 19.8352C17.605 22.1257 13.778 21.1127 13.778 21.1127C13.778 21.1127 12.2578 20.6236 10.492 21.0152C8.72706 21.4102 7.20561 21.2604 7.20561 21.2604C7.20561 21.2604 4.99964 21.0152 4.55343 18.701C4.10721 16.3869 6.61326 14.6608 6.81143 14.4173C7.00657 14.1699 8.32336 13.3442 9.26328 11.7587C10.2032 10.1731 12.8471 9.21909 14.6617 12.0039ZM20.2002 10.5846C20.2002 11.0415 20.391 12.9772 18.6478 13.0158C16.9053 13.0544 16.8317 11.8378 16.8317 10.9662C16.8317 10.053 17.0192 8.76113 18.422 8.76113C19.8225 8.76113 20.2002 10.13 20.2002 10.5846ZM14.7711 7.80669C13.591 7.65486 13.3238 6.58499 13.4378 5.51446C13.5333 4.63866 14.5804 3.2953 15.419 3.48769C16.2559 3.6784 17.0188 4.78748 16.8646 5.74238C16.7134 6.69862 15.9533 7.9602 14.7711 7.80669ZM9.75498 7.43996C8.89373 7.43996 8.19433 6.44695 8.19433 5.21916C8.19433 3.99269 8.8934 3 9.75498 3C10.6179 3 11.3153 3.99269 11.3153 5.21916C11.3153 6.44695 10.6179 7.43996 9.75498 7.43996ZM5.96186 12.0061C4.26673 12.3714 3.63542 10.4091 3.82144 9.49078C3.82144 9.49078 4.02239 7.50401 5.39776 7.38059C6.49074 7.28599 7.29562 8.4821 7.37884 9.16641C7.42971 9.61029 7.66125 11.6412 5.96186 12.0061Z"
  }));
},
    y2 = function y2(_ref141) {
  var _ref141$color = _ref141.color,
      C = _ref141$color === void 0 ? "currentColor" : _ref141$color,
      _ref141$size = _ref141.size,
      e = _ref141$size === void 0 ? 24 : _ref141$size,
      l = _ref141.className,
      i = _objectWithoutProperties(_ref141, _excluded141);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17.8492 11.805L17.1421 11.0979L7.24264 20.9974H3V16.7547L14.3137 5.44101L19.9706 11.0979C20.3611 11.4884 20.3611 12.1216 19.9706 12.5121L12.8995 19.5831L11.4853 18.1689L17.8492 11.805ZM18.5563 2.61258L21.3848 5.44101C21.7753 5.83153 21.7753 6.4647 21.3848 6.85522L19.9706 8.26943L15.7279 4.02679L17.1421 2.61258C17.5327 2.22206 18.1658 2.22206 18.5563 2.61258Z"
  }));
},
    b2 = function b2(_ref142) {
  var _ref142$color = _ref142.color,
      C = _ref142$color === void 0 ? "currentColor" : _ref142$color,
      _ref142$size = _ref142.size,
      e = _ref142$size === void 0 ? 24 : _ref142$size,
      l = _ref142.className,
      i = _objectWithoutProperties(_ref142, _excluded142);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17.8492 11.6983L17.1421 10.9912L7.24264 20.8907H3V16.648L14.3137 5.33432L19.9706 10.9912C20.3611 11.3817 20.3611 12.0149 19.9706 12.4054L12.8995 19.4765L11.4853 18.0622L17.8492 11.6983ZM15.7279 9.57696L14.3137 8.16274L5 17.4765V18.8907H6.41421L15.7279 9.57696ZM18.5563 2.50589L21.3848 5.33432C21.7753 5.72484 21.7753 6.35801 21.3848 6.74853L19.9706 8.16274L15.7279 3.9201L17.1421 2.50589C17.5327 2.11537 18.1658 2.11537 18.5563 2.50589Z"
  }));
},
    T2 = function T2(_ref143) {
  var _ref143$color = _ref143.color,
      C = _ref143$color === void 0 ? "currentColor" : _ref143$color,
      _ref143$size = _ref143.size,
      e = _ref143$size === void 0 ? 24 : _ref143$size,
      l = _ref143.className,
      i = _objectWithoutProperties(_ref143, _excluded143);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22.0049 10.9998V19.9998C22.0049 20.5521 21.5572 20.9998 21.0049 20.9998H3.00488C2.4526 20.9998 2.00488 20.5521 2.00488 19.9998V10.9998H22.0049ZM22.0049 6.99979H2.00488V3.99979C2.00488 3.4475 2.4526 2.99979 3.00488 2.99979H21.0049C21.5572 2.99979 22.0049 3.4475 22.0049 3.99979V6.99979Z"
  }));
},
    U2 = function U2(_ref144) {
  var _ref144$color = _ref144.color,
      C = _ref144$color === void 0 ? "currentColor" : _ref144$color,
      _ref144$size = _ref144.size,
      e = _ref144$size === void 0 ? 24 : _ref144$size,
      l = _ref144.className,
      i = _objectWithoutProperties(_ref144, _excluded144);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3.00488 2.99979H21.0049C21.5572 2.99979 22.0049 3.4475 22.0049 3.99979V19.9998C22.0049 20.5521 21.5572 20.9998 21.0049 20.9998H3.00488C2.4526 20.9998 2.00488 20.5521 2.00488 19.9998V3.99979C2.00488 3.4475 2.4526 2.99979 3.00488 2.99979ZM20.0049 11.9998H4.00488V18.9998H20.0049V11.9998ZM20.0049 7.99979V4.99979H4.00488V7.99979H20.0049Z"
  }));
},
    G2 = function G2(_ref145) {
  var _ref145$color = _ref145.color,
      C = _ref145$color === void 0 ? "currentColor" : _ref145$color,
      _ref145$size = _ref145.size,
      e = _ref145$size === void 0 ? 24 : _ref145$size,
      l = _ref145.className,
      i = _objectWithoutProperties(_ref145, _excluded145);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22.0049 9.99979V19.9998C22.0049 20.5521 21.5572 20.9998 21.0049 20.9998H3.00488C2.4526 20.9998 2.00488 20.5521 2.00488 19.9998V9.99979H22.0049ZM22.0049 7.99979H2.00488V3.99979C2.00488 3.4475 2.4526 2.99979 3.00488 2.99979H21.0049C21.5572 2.99979 22.0049 3.4475 22.0049 3.99979V7.99979ZM15.0049 15.9998V17.9998H19.0049V15.9998H15.0049Z"
  }));
},
    I2 = function I2(_ref146) {
  var _ref146$color = _ref146.color,
      C = _ref146$color === void 0 ? "currentColor" : _ref146$color,
      _ref146$size = _ref146.size,
      e = _ref146$size === void 0 ? 24 : _ref146$size,
      l = _ref146.className,
      i = _objectWithoutProperties(_ref146, _excluded146);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3.00488 2.99979H21.0049C21.5572 2.99979 22.0049 3.4475 22.0049 3.99979V19.9998C22.0049 20.5521 21.5572 20.9998 21.0049 20.9998H3.00488C2.4526 20.9998 2.00488 20.5521 2.00488 19.9998V3.99979C2.00488 3.4475 2.4526 2.99979 3.00488 2.99979ZM20.0049 10.9998H4.00488V18.9998H20.0049V10.9998ZM20.0049 8.99979V4.99979H4.00488V8.99979H20.0049ZM14.0049 14.9998H18.0049V16.9998H14.0049V14.9998Z"
  }));
},
    W2 = function W2(_ref147) {
  var _ref147$color = _ref147.color,
      C = _ref147$color === void 0 ? "currentColor" : _ref147$color,
      _ref147$size = _ref147.size,
      e = _ref147$size === void 0 ? 24 : _ref147$size,
      l = _ref147.className,
      i = _objectWithoutProperties(_ref147, _excluded147);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 20H22V22H2V20ZM4 12H6V19H4V12ZM9 12H11V19H9V12ZM13 12H15V19H13V12ZM18 12H20V19H18V12ZM2 7L12 2L22 7V11H2V7ZM12 8C12.5523 8 13 7.55228 13 7C13 6.44772 12.5523 6 12 6C11.4477 6 11 6.44772 11 7C11 7.55228 11.4477 8 12 8Z"
  }));
},
    O2 = function O2(_ref148) {
  var _ref148$color = _ref148.color,
      C = _ref148$color === void 0 ? "currentColor" : _ref148$color,
      _ref148$size = _ref148.size,
      e = _ref148$size === void 0 ? 24 : _ref148$size,
      l = _ref148.className,
      i = _objectWithoutProperties(_ref148, _excluded148);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 20H22V22H2V20ZM4 12H6V19H4V12ZM9 12H11V19H9V12ZM13 12H15V19H13V12ZM18 12H20V19H18V12ZM2 7L12 2L22 7V11H2V7ZM4 8.23607V9H20V8.23607L12 4.23607L4 8.23607ZM12 8C11.4477 8 11 7.55228 11 7C11 6.44772 11.4477 6 12 6C12.5523 6 13 6.44772 13 7C13 7.55228 12.5523 8 12 8Z"
  }));
},
    K2 = function K2(_ref149) {
  var _ref149$color = _ref149.color,
      C = _ref149$color === void 0 ? "currentColor" : _ref149$color,
      _ref149$size = _ref149.size,
      e = _ref149$size === void 0 ? 24 : _ref149$size,
      l = _ref149.className,
      i = _objectWithoutProperties(_ref149, _excluded149);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 13H8V21H2V13ZM9 3H15V21H9V3ZM16 8H22V21H16V8Z"
  }));
},
    Q2 = function Q2(_ref150) {
  var _ref150$color = _ref150.color,
      C = _ref150$color === void 0 ? "currentColor" : _ref150$color,
      _ref150$size = _ref150.size,
      e = _ref150$size === void 0 ? 24 : _ref150$size,
      l = _ref150.className,
      i = _objectWithoutProperties(_ref150, _excluded150);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 13H8V21H2V13ZM16 8H22V21H16V8ZM9 3H15V21H9V3ZM4 15V19H6V15H4ZM11 5V19H13V5H11ZM18 10V19H20V10H18Z"
  }));
},
    q2 = function q2(_ref151) {
  var _ref151$color = _ref151.color,
      C = _ref151$color === void 0 ? "currentColor" : _ref151$color,
      _ref151$size = _ref151.size,
      e = _ref151$size === void 0 ? 24 : _ref151$size,
      l = _ref151.className,
      i = _objectWithoutProperties(_ref151, _excluded151);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM7 13V17H9V13H7ZM11 7V17H13V7H11ZM15 10V17H17V10H15Z"
  }));
},
    j2 = function j2(_ref152) {
  var _ref152$color = _ref152.color,
      C = _ref152$color === void 0 ? "currentColor" : _ref152$color,
      _ref152$size = _ref152.size,
      e = _ref152$size === void 0 ? 24 : _ref152$size,
      l = _ref152.className,
      i = _objectWithoutProperties(_ref152, _excluded152);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM4 5V19H20V5H4ZM7 13H9V17H7V13ZM11 7H13V17H11V7ZM15 10H17V17H15V10Z"
  }));
},
    X2 = function X2(_ref153) {
  var _ref153$color = _ref153.color,
      C = _ref153$color === void 0 ? "currentColor" : _ref153$color,
      _ref153$size = _ref153.size,
      e = _ref153$size === void 0 ? 24 : _ref153$size,
      l = _ref153.className,
      i = _objectWithoutProperties(_ref153, _excluded153);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 12H7V21H3V12ZM17 8H21V21H17V8ZM10 2H14V21H10V2Z"
  }));
},
    J2 = function J2(_ref154) {
  var _ref154$color = _ref154.color,
      C = _ref154$color === void 0 ? "currentColor" : _ref154$color,
      _ref154$size = _ref154.size,
      e = _ref154$size === void 0 ? 24 : _ref154$size,
      l = _ref154.className,
      i = _objectWithoutProperties(_ref154, _excluded154);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 12H4V21H2V12ZM5 14H7V21H5V14ZM16 8H18V21H16V8ZM19 10H21V21H19V10ZM9 2H11V21H9V2ZM12 4H14V21H12V4Z"
  }));
},
    Y2 = function Y2(_ref155) {
  var _ref155$color = _ref155.color,
      C = _ref155$color === void 0 ? "currentColor" : _ref155$color,
      _ref155$size = _ref155.size,
      e = _ref155$size === void 0 ? 24 : _ref155$size,
      l = _ref155.className,
      i = _objectWithoutProperties(_ref155, _excluded155);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 12H4V21H2V12ZM5 14H7V21H5V14ZM16 8H18V21H16V8ZM19 10H21V21H19V10ZM9 2H11V21H9V2ZM12 4H14V21H12V4Z"
  }));
},
    _2 = function _2(_ref156) {
  var _ref156$color = _ref156.color,
      C = _ref156$color === void 0 ? "currentColor" : _ref156$color,
      _ref156$size = _ref156.size,
      e = _ref156$size === void 0 ? 24 : _ref156$size,
      l = _ref156.className,
      i = _objectWithoutProperties(_ref156, _excluded156);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 3V7H3V3H12ZM16 17V21H3V17H16ZM22 10V14H3V10H22Z"
  }));
},
    $2 = function $2(_ref157) {
  var _ref157$color = _ref157.color,
      C = _ref157$color === void 0 ? "currentColor" : _ref157$color,
      _ref157$size = _ref157.size,
      e = _ref157$size === void 0 ? 24 : _ref157$size,
      l = _ref157.className,
      i = _objectWithoutProperties(_ref157, _excluded157);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 3V5H3V3H12ZM16 19V21H3V19H16ZM22 11V13H3V11H22Z"
  }));
},
    e0 = function e0(_ref158) {
  var _ref158$color = _ref158.color,
      C = _ref158$color === void 0 ? "currentColor" : _ref158$color,
      _ref158$size = _ref158.size,
      e = _ref158$size === void 0 ? 24 : _ref158$size,
      l = _ref158.className,
      i = _objectWithoutProperties(_ref158, _excluded158);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 12H5V21H3V12ZM19 8H21V21H19V8ZM11 2H13V21H11V2Z"
  }));
},
    t0 = function t0(_ref159) {
  var _ref159$color = _ref159.color,
      C = _ref159$color === void 0 ? "currentColor" : _ref159$color,
      _ref159$size = _ref159.size,
      e = _ref159$size === void 0 ? 24 : _ref159$size,
      l = _ref159.className,
      i = _objectWithoutProperties(_ref159, _excluded159);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM6 7V17H9V7H6ZM10 7V17H12V7H10ZM13 7V17H14V7H13ZM15 7V17H18V7H15Z"
  }));
},
    C0 = function C0(_ref160) {
  var _ref160$color = _ref160.color,
      C = _ref160$color === void 0 ? "currentColor" : _ref160$color,
      _ref160$size = _ref160.size,
      e = _ref160$size === void 0 ? 24 : _ref160$size,
      l = _ref160.className,
      i = _objectWithoutProperties(_ref160, _excluded160);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 5V19H20V5H4ZM3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM6 7H9V17H6V7ZM10 7H12V17H10V7ZM13 7H14V17H13V7ZM15 7H18V17H15V7Z"
  }));
},
    l0 = function l0(_ref161) {
  var _ref161$color = _ref161.color,
      C = _ref161$color === void 0 ? "currentColor" : _ref161$color,
      _ref161$size = _ref161.size,
      e = _ref161$size === void 0 ? 24 : _ref161$size,
      l = _ref161.className,
      i = _objectWithoutProperties(_ref161, _excluded161);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 4H4V20H2V4ZM6 4H8V20H6V4ZM9 4H12V20H9V4ZM13 4H15V20H13V4ZM16 4H18V20H16V4ZM19 4H22V20H19V4Z"
  }));
},
    i0 = function i0(_ref162) {
  var _ref162$color = _ref162.color,
      C = _ref162$color === void 0 ? "currentColor" : _ref162$color,
      _ref162$size = _ref162.size,
      e = _ref162$size === void 0 ? 24 : _ref162$size,
      l = _ref162.className,
      i = _objectWithoutProperties(_ref162, _excluded162);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 4H4V20H2V4ZM6 4H7V20H6V4ZM8 4H10V20H8V4ZM11 4H13V20H11V4ZM14 4H16V20H14V4ZM17 4H18V20H17V4ZM19 4H22V20H19V4Z"
  }));
},
    s0 = function s0(_ref163) {
  var _ref163$color = _ref163.color,
      C = _ref163$color === void 0 ? "currentColor" : _ref163$color,
      _ref163$size = _ref163.size,
      e = _ref163$size === void 0 ? 24 : _ref163$size,
      l = _ref163.className,
      i = _objectWithoutProperties(_ref163, _excluded163);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19.5556 19H21V21H3V19H4.44444L5.33333 15H18.6667L19.5556 19ZM17.3333 9L18.2222 13H5.77778L6.66667 9H17.3333ZM16.8889 7H7.11111L7.82598 3.78307C7.92766 3.32553 8.33347 3 8.80217 3H15.1978C15.6665 3 16.0723 3.32553 16.174 3.78307L16.8889 7Z"
  }));
},
    r0 = function r0(_ref164) {
  var _ref164$color = _ref164.color,
      C = _ref164$color === void 0 ? "currentColor" : _ref164$color,
      _ref164$size = _ref164.size,
      e = _ref164$size === void 0 ? 24 : _ref164$size,
      l = _ref164.className,
      i = _objectWithoutProperties(_ref164, _excluded164);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.49323 19H17.5068L16.8401 16H7.1599L6.49323 19ZM19.5556 19H21V21H3V19H4.44444L7.82598 3.78307C7.92766 3.32553 8.33347 3 8.80217 3H15.1978C15.6665 3 16.0723 3.32553 16.174 3.78307L19.5556 19ZM7.60434 14H16.3957L15.5068 10H8.49323L7.60434 14ZM8.93768 8H15.0623L14.3957 5H9.60434L8.93768 8Z"
  }));
},
    c0 = function c0(_ref165) {
  var _ref165$color = _ref165.color,
      C = _ref165$color === void 0 ? "currentColor" : _ref165$color,
      _ref165$size = _ref165.size,
      e = _ref165$size === void 0 ? 24 : _ref165$size,
      l = _ref165.className,
      i = _objectWithoutProperties(_ref165, _excluded165);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 13L18 22H6L12 13ZM10.9393 10.5606C10.3536 9.97486 10.3536 9.02511 10.9393 8.43933C11.5251 7.85354 12.4749 7.85354 13.0607 8.43933C13.6464 9.02511 13.6464 9.97486 13.0607 10.5606C12.4749 11.1464 11.5251 11.1464 10.9393 10.5606ZM5.28249 2.78247L6.6967 4.19668C3.76777 7.12562 3.76777 11.8744 6.6967 14.8033L5.28249 16.2175C1.5725 12.5075 1.5725 6.49245 5.28249 2.78247ZM18.7175 2.78247C22.4275 6.49245 22.4275 12.5075 18.7175 16.2175L17.3033 14.8033C20.2322 11.8744 20.2322 7.12562 17.3033 4.19668L18.7175 2.78247ZM8.11091 5.6109L9.52513 7.02511C8.15829 8.39195 8.15829 10.608 9.52513 11.9749L8.11091 13.3891C5.96303 11.2412 5.96303 7.75878 8.11091 5.6109H8.11091ZM15.8891 5.6109C18.037 7.75878 18.037 11.2412 15.8891 13.3891L14.4749 11.9749C15.8417 10.608 15.8417 8.39195 14.4749 7.02511L15.8891 5.6109Z"
  }));
},
    o0 = function o0(_ref166) {
  var _ref166$color = _ref166.color,
      C = _ref166$color === void 0 ? "currentColor" : _ref166$color,
      _ref166$size = _ref166.size,
      e = _ref166$size === void 0 ? 24 : _ref166$size,
      l = _ref166.className,
      i = _objectWithoutProperties(_ref166, _excluded166);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 13L18 22H6L12 13ZM12 16.6L9.74 20H14.26L12 16.6ZM10.9393 10.5606C10.3536 9.97486 10.3536 9.02511 10.9393 8.43933C11.5251 7.85354 12.4749 7.85354 13.0607 8.43933C13.6464 9.02511 13.6464 9.97486 13.0607 10.5606C12.4749 11.1464 11.5251 11.1464 10.9393 10.5606ZM5.28249 2.78247L6.6967 4.19668C3.76777 7.12562 3.76777 11.8744 6.6967 14.8033L5.28249 16.2175C1.5725 12.5075 1.5725 6.49245 5.28249 2.78247ZM18.7175 2.78247C22.4275 6.49245 22.4275 12.5075 18.7175 16.2175L17.3033 14.8033C20.2322 11.8744 20.2322 7.12562 17.3033 4.19668L18.7175 2.78247ZM8.11091 5.6109L9.52513 7.02511C8.15829 8.39195 8.15829 10.608 9.52513 11.9749L8.11091 13.3891C5.96303 11.2412 5.96303 7.75878 8.11091 5.6109H8.11091ZM15.8891 5.6109C18.037 7.75878 18.037 11.2412 15.8891 13.3891L14.4749 11.9749C15.8417 10.608 15.8417 8.39195 14.4749 7.02511L15.8891 5.6109Z"
  }));
},
    a0 = function a0(_ref167) {
  var _ref167$color = _ref167.color,
      C = _ref167$color === void 0 ? "currentColor" : _ref167$color,
      _ref167$size = _ref167.size,
      e = _ref167$size === void 0 ? 24 : _ref167$size,
      l = _ref167.className,
      i = _objectWithoutProperties(_ref167, _excluded167);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.366 13.366L14.1407 14.3911C13.05 16.8036 12.9953 19.4669 13.8296 21.8314C13.2375 21.9426 12.6255 22 12 22C10.5353 22 9.14414 21.6851 7.89054 21.1193L12.366 13.366ZM15.8835 15.3976L20.1168 17.8423C19.0224 19.3601 17.5128 20.5586 15.7543 21.2714C15.1047 19.511 15.0756 17.5348 15.7624 15.7017L15.8835 15.3976ZM8.85892 11.3417L10.634 12.366L6.15773 20.1168C4.5194 18.9355 3.25309 17.2704 2.56813 15.3308C4.92702 14.8924 7.11579 13.6115 8.65334 11.6179L8.85892 11.3417ZM21.9051 10.6165C21.9677 11.0687 22 11.5306 22 12C22 13.4647 21.6851 14.8559 21.1193 16.1095L16.8838 13.6649C18.1057 12.0497 19.8575 11.0078 21.7497 10.6436L21.9051 10.6165ZM2.8807 7.89054L7.11588 10.3356C5.86043 11.9949 4.0458 13.0491 2.09489 13.3854C2.03239 12.932 2 12.4698 2 12C2 10.5353 2.3149 9.14414 2.8807 7.89054ZM17.8423 3.88318C19.4803 5.06428 20.7465 6.72901 21.4315 8.66817C19.0721 9.108 16.8836 10.3891 15.3463 12.3826L15.1407 12.6588L13.366 11.634L17.8423 3.88318ZM12 2C13.4647 2 14.8559 2.3149 16.1095 2.8807L11.634 10.634L9.85892 9.60983C10.95 7.19703 11.0048 4.53332 10.1704 2.16848C10.7625 2.05742 11.3745 2 12 2ZM8.24679 2.72936C8.89548 4.48945 8.92444 6.46595 8.2373 8.2992L8.11613 8.60335L3.88318 6.15773C4.93611 4.69744 6.37339 3.53272 8.04682 2.81177L8.24679 2.72936Z"
  }));
},
    n0 = function n0(_ref168) {
  var _ref168$color = _ref168.color,
      C = _ref168$color === void 0 ? "currentColor" : _ref168$color,
      _ref168$size = _ref168.size,
      e = _ref168$size === void 0 ? 24 : _ref168$size,
      l = _ref168.className,
      i = _objectWithoutProperties(_ref168, _excluded168);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12.366 13.366L8.89708 19.376C9.85124 19.7779 10.8997 20 12 20C12.4622 20 12.9152 19.9608 13.3559 19.8856C13.0984 18.0632 13.3411 16.1601 14.1404 14.3917L12.366 13.366ZM15.8835 15.3974C15.3519 16.6567 15.1671 17.9943 15.2969 19.2905C16.5173 18.7384 17.5737 17.8888 18.3745 16.8346L15.8835 15.3974ZM8.85855 11.3422C7.7265 12.919 6.1993 14.0809 4.49366 14.7699C5.0255 16.2135 5.96211 17.4604 7.16543 18.3745L10.634 12.366L8.85855 11.3422ZM19.9616 11.2111L19.7038 11.3328C18.6197 11.8687 17.6478 12.6548 16.8834 13.6653L19.3756 15.1039C19.7777 14.1495 20 13.1007 20 12C20 11.7338 19.987 11.4706 19.9616 11.2111ZM4 12C4 12.2662 4.013 12.5294 4.03841 12.7889C5.22626 12.2534 6.29168 11.4249 7.11596 10.3355L4.62402 8.89708C4.22214 9.85124 4 10.8997 4 12ZM16.8346 5.62552L13.366 11.634L15.1407 12.6588C16.2731 11.0812 17.8009 9.91878 19.5073 9.22969C19.0134 7.89068 18.1702 6.71922 17.0884 5.82653L16.8346 5.62552ZM12 4C11.5375 4 11.0841 4.03925 10.6431 4.1146C10.9016 5.93748 10.6588 7.8408 9.85915 9.60931L11.634 10.634L15.1029 4.62402C14.1488 4.22214 13.1003 4 12 4ZM8.70313 4.70955L8.51189 4.79845C7.37266 5.35126 6.38436 6.16644 5.62552 7.16543L8.11608 8.60349C8.64798 7.34403 8.83295 6.00607 8.70313 4.70955Z"
  }));
},
    m0 = function m0(_ref169) {
  var _ref169$color = _ref169.color,
      C = _ref169$color === void 0 ? "currentColor" : _ref169$color,
      _ref169$size = _ref169.size,
      e = _ref169$size === void 0 ? 24 : _ref169$size,
      l = _ref169.className,
      i = _objectWithoutProperties(_ref169, _excluded169);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9 4V3C9 2.44772 9.44772 2 10 2H14C14.5523 2 15 2.44772 15 3V4H18C18.5523 4 19 4.44772 19 5V21C19 21.5523 18.5523 22 18 22H6C5.44772 22 5 21.5523 5 21V5C5 4.44772 5.44772 4 6 4H9ZM13 12V7L8 14H11V19L16 12H13Z"
  }));
},
    w0 = function w0(_ref170) {
  var _ref170$color = _ref170.color,
      C = _ref170$color === void 0 ? "currentColor" : _ref170$color,
      _ref170$size = _ref170.size,
      e = _ref170$size === void 0 ? 24 : _ref170$size,
      l = _ref170.className,
      i = _objectWithoutProperties(_ref170, _excluded170);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13 12H16L11 19V14H8L13 7V12ZM11 6H7V20H17V6H13V4H11V6ZM9 4V3C9 2.44772 9.44772 2 10 2H14C14.5523 2 15 2.44772 15 3V4H18C18.5523 4 19 4.44772 19 5V21C19 21.5523 18.5523 22 18 22H6C5.44772 22 5 21.5523 5 21V5C5 4.44772 5.44772 4 6 4H9Z"
  }));
},
    L0 = function L0(_ref171) {
  var _ref171$color = _ref171.color,
      C = _ref171$color === void 0 ? "currentColor" : _ref171$color,
      _ref171$size = _ref171.size,
      e = _ref171$size === void 0 ? 24 : _ref171$size,
      l = _ref171.className,
      i = _objectWithoutProperties(_ref171, _excluded171);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9 4V3C9 2.44772 9.44772 2 10 2H14C14.5523 2 15 2.44772 15 3V4H18C18.5523 4 19 4.44772 19 5V21C19 21.5523 18.5523 22 18 22H6C5.44772 22 5 21.5523 5 21V5C5 4.44772 5.44772 4 6 4H9Z"
  }));
},
    h0 = function h0(_ref172) {
  var _ref172$color = _ref172.color,
      C = _ref172$color === void 0 ? "currentColor" : _ref172$color,
      _ref172$size = _ref172.size,
      e = _ref172$size === void 0 ? 24 : _ref172$size,
      l = _ref172.className,
      i = _objectWithoutProperties(_ref172, _excluded172);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11 6H7V20H17V6H13V4H11V6ZM9 4V3C9 2.44772 9.44772 2 10 2H14C14.5523 2 15 2.44772 15 3V4H18C18.5523 4 19 4.44772 19 5V21C19 21.5523 18.5523 22 18 22H6C5.44772 22 5 21.5523 5 21V5C5 4.44772 5.44772 4 6 4H9Z"
  }));
},
    H0 = function H0(_ref173) {
  var _ref173$color = _ref173.color,
      C = _ref173$color === void 0 ? "currentColor" : _ref173$color,
      _ref173$size = _ref173.size,
      e = _ref173$size === void 0 ? 24 : _ref173$size,
      l = _ref173.className,
      i = _objectWithoutProperties(_ref173, _excluded173);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 11V5L7 13H10V19L15 11H12ZM3 5H19C19.5523 5 20 5.44772 20 6V18C20 18.5523 19.5523 19 19 19H3C2.44772 19 2 18.5523 2 18V6C2 5.44772 2.44772 5 3 5ZM21 9H23V15H21V9Z"
  }));
},
    V0 = function V0(_ref174) {
  var _ref174$color = _ref174.color,
      C = _ref174$color === void 0 ? "currentColor" : _ref174$color,
      _ref174$size = _ref174.size,
      e = _ref174$size === void 0 ? 24 : _ref174$size,
      l = _ref174.className,
      i = _objectWithoutProperties(_ref174, _excluded174);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8 19H3C2.44772 19 2 18.5523 2 18V6C2 5.44772 2.44772 5 3 5H9.625L8.45833 7H4V17H8V19ZM12.375 19L13.5417 17H18V7H14V5H19C19.5523 5 20 5.44772 20 6V18C20 18.5523 19.5523 19 19 19H12.375ZM21 9H23V15H21V9ZM12 11H15L10 19V13H7L12 5V11Z"
  }));
},
    g0 = function g0(_ref175) {
  var _ref175$color = _ref175.color,
      C = _ref175$color === void 0 ? "currentColor" : _ref175$color,
      _ref175$size = _ref175.size,
      e = _ref175$size === void 0 ? 24 : _ref175$size,
      l = _ref175.className,
      i = _objectWithoutProperties(_ref175, _excluded175);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 5H19C19.5523 5 20 5.44772 20 6V18C20 18.5523 19.5523 19 19 19H3C2.44772 19 2 18.5523 2 18V6C2 5.44772 2.44772 5 3 5ZM21 9H23V15H21V9Z"
  }));
},
    M0 = function M0(_ref176) {
  var _ref176$color = _ref176.color,
      C = _ref176$color === void 0 ? "currentColor" : _ref176$color,
      _ref176$size = _ref176.size,
      e = _ref176$size === void 0 ? 24 : _ref176$size,
      l = _ref176.className,
      i = _objectWithoutProperties(_ref176, _excluded176);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 7V17H18V7H4ZM3 5H19C19.5523 5 20 5.44772 20 6V18C20 18.5523 19.5523 19 19 19H3C2.44772 19 2 18.5523 2 18V6C2 5.44772 2.44772 5 3 5ZM21 9H23V15H21V9Z"
  }));
},
    Z0 = function Z0(_ref177) {
  var _ref177$color = _ref177.color,
      C = _ref177$color === void 0 ? "currentColor" : _ref177$color,
      _ref177$size = _ref177.size,
      e = _ref177$size === void 0 ? 24 : _ref177$size,
      l = _ref177.className,
      i = _objectWithoutProperties(_ref177, _excluded177);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 5H19C19.5523 5 20 5.44772 20 6V18C20 18.5523 19.5523 19 19 19H3C2.44772 19 2 18.5523 2 18V6C2 5.44772 2.44772 5 3 5ZM5 8V16H9V8H5ZM21 9H23V15H21V9Z"
  }));
},
    x0 = function x0(_ref178) {
  var _ref178$color = _ref178.color,
      C = _ref178$color === void 0 ? "currentColor" : _ref178$color,
      _ref178$size = _ref178.size,
      e = _ref178$size === void 0 ? 24 : _ref178$size,
      l = _ref178.className,
      i = _objectWithoutProperties(_ref178, _excluded178);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 7V17H18V7H4ZM3 5H19C19.5523 5 20 5.44772 20 6V18C20 18.5523 19.5523 19 19 19H3C2.44772 19 2 18.5523 2 18V6C2 5.44772 2.44772 5 3 5ZM5 8H9V16H5V8ZM21 9H23V15H21V9Z"
  }));
},
    v0 = function v0(_ref179) {
  var _ref179$color = _ref179.color,
      C = _ref179$color === void 0 ? "currentColor" : _ref179$color,
      _ref179$size = _ref179.size,
      e = _ref179$size === void 0 ? 24 : _ref179$size,
      l = _ref179.className,
      i = _objectWithoutProperties(_ref179, _excluded179);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14 2C14.5523 2 15 2.44772 15 3V4H18C18.5523 4 19 4.44772 19 5V21C19 21.5523 18.5523 22 18 22H6C5.44772 22 5 21.5523 5 21V5C5 4.44772 5.44772 4 6 4H9V3C9 2.44772 9.44772 2 10 2H14ZM13 9H11V12H8V14H11V17H13V14H16V12H13V9Z"
  }));
},
    d0 = function d0(_ref180) {
  var _ref180$color = _ref180.color,
      C = _ref180$color === void 0 ? "currentColor" : _ref180$color,
      _ref180$size = _ref180.size,
      e = _ref180$size === void 0 ? 24 : _ref180$size,
      l = _ref180.className,
      i = _objectWithoutProperties(_ref180, _excluded180);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14 2C14.5523 2 15 2.44772 15 3V4H18C18.5523 4 19 4.44772 19 5V21C19 21.5523 18.5523 22 18 22H6C5.44772 22 5 21.5523 5 21V5C5 4.44772 5.44772 4 6 4H9V3C9 2.44772 9.44772 2 10 2H14ZM13 4H11V6H7V20H17V6H13V4ZM13 9V12H16V14H13V17H11V14H8V12H11V9H13Z"
  }));
},
    p0 = function p0(_ref181) {
  var _ref181$color = _ref181.color,
      C = _ref181$color === void 0 ? "currentColor" : _ref181$color,
      _ref181$size = _ref181.size,
      e = _ref181$size === void 0 ? 24 : _ref181$size,
      l = _ref181.className,
      i = _objectWithoutProperties(_ref181, _excluded181);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14 2C14.5523 2 15 2.44772 15 3V4H18C18.5523 4 19 4.44772 19 5V11.2L15 8V11H14C11.8578 11 10 12.79 10 15V18H12V15C12 13.95 12.95 13 14 13H15V16L19 12.8V21C19 21.5523 18.5523 22 18 22H6C5.44772 22 5 21.5523 5 21V5C5 4.44772 5.44772 4 6 4H9V3C9 2.44772 9.44772 2 10 2H14Z"
  }));
},
    E0 = function E0(_ref182) {
  var _ref182$color = _ref182.color,
      C = _ref182$color === void 0 ? "currentColor" : _ref182$color,
      _ref182$size = _ref182.size,
      e = _ref182$size === void 0 ? 24 : _ref182$size,
      l = _ref182.className,
      i = _objectWithoutProperties(_ref182, _excluded182);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14 2C14.5523 2 15 2.44772 15 3V4H18C18.5523 4 19 4.44772 19 5V7H17V6H13V4H11V6H7V20H17V17H19V21C19 21.5523 18.5523 22 18 22H6C5.44772 22 5 21.5523 5 21V5C5 4.44772 5.44772 4 6 4H9V3C9 2.44772 9.44772 2 10 2H14ZM15 8L20 12L15 16V13H14C12.9456 13 12 13.95 12 15V18H10V15C10 12.7909 11.7909 11 14 11H15V8Z"
  }));
},
    N0 = function N0(_ref183) {
  var _ref183$color = _ref183.color,
      C = _ref183$color === void 0 ? "currentColor" : _ref183$color,
      _ref183$size = _ref183.size,
      e = _ref183$size === void 0 ? 24 : _ref183$size,
      l = _ref183.className,
      i = _objectWithoutProperties(_ref183, _excluded183);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17.5 2C19.9853 2 22 4.01472 22 6.5C22 7.85621 21.4001 9.07229 20.4511 9.89732C20.8061 10.8644 21 11.9096 21 13C21 17.9706 16.9706 22 12 22C7.02944 22 3 17.9706 3 13C3 11.9096 3.19392 10.8644 3.54916 9.8972C2.59995 9.07229 2 7.85621 2 6.5C2 4.01472 4.01472 2 6.5 2C8.12553 2 9.54976 2.86189 10.3406 4.15362C10.8774 4.05251 11.4326 4 12 4C12.5674 4 13.1226 4.05251 13.6609 4.15294C14.4502 2.86189 15.8745 2 17.5 2ZM10 13H8C8 15.2091 9.79086 17 12 17C14.2091 17 16 15.2091 16 13H14C14 14.1046 13.1046 15 12 15C10.8954 15 10 14.1046 10 13Z"
  }));
},
    u0 = function u0(_ref184) {
  var _ref184$color = _ref184.color,
      C = _ref184$color === void 0 ? "currentColor" : _ref184$color,
      _ref184$size = _ref184.size,
      e = _ref184$size === void 0 ? 24 : _ref184$size,
      l = _ref184.className,
      i = _objectWithoutProperties(_ref184, _excluded184);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 17C14.2091 17 16 15.2091 16 13H14C14 14.1046 13.1046 15 12 15 10.8954 15 10 14.1046 10 13H8C8 15.2091 9.79086 17 12 17ZM6.5 2C4.01472 2 2 4.01472 2 6.5 2 7.85729 2.60121 9.07332 3.54934 9.89751 3.19384 10.8656 3 11.911 3 13 3 17.9706 7.02944 22 12 22 16.9706 22 21 17.9706 21 13 21 11.911 20.8062 10.8656 20.4507 9.89751 21.3988 9.07332 22 7.85729 22 6.5 22 4.01472 19.9853 2 17.5 2 15.8737 2 14.4505 2.8624 13.6601 4.15297 13.1215 4.05246 12.5665 4 12 4 11.4335 4 10.8785 4.05246 10.3399 4.15297 9.5495 2.8624 8.12635 2 6.5 2ZM4 6.5C4 5.11929 5.11929 4 6.5 4 7.58033 4 8.50304 4.68577 8.8517 5.64896L9.1696 6.52718 10.0675 6.26991C10.6801 6.09435 11.3282 6 12 6 12.6718 6 13.3199 6.09435 13.9325 6.26991L14.8304 6.52718 15.1483 5.64896C15.497 4.68577 16.4197 4 17.5 4 18.8807 4 20 5.11929 20 6.5 20 7.43301 19.4894 8.24804 18.7275 8.67859L17.9141 9.13832 18.3176 9.98107C18.7547 10.8939 19 11.9169 19 13 19 16.866 15.866 20 12 20 8.13401 20 5 16.866 5 13 5 11.9169 5.24529 10.8939 5.6824 9.98107L6.08595 9.13832 5.27248 8.6786C4.51064 8.24805 4 7.43301 4 6.5Z"
  }));
},
    B0 = function B0(_ref185) {
  var _ref185$color = _ref185.color,
      C = _ref185$color === void 0 ? "currentColor" : _ref185$color,
      _ref185$size = _ref185.size,
      e = _ref185$size === void 0 ? 24 : _ref185$size,
      l = _ref185.className,
      i = _objectWithoutProperties(_ref185, _excluded185);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7.44262 5.34998C8.08197 5.34998 8.67213 5.39945 9.21311 5.54786C9.7541 5.6468 10.1967 5.84468 10.5902 6.09203C10.9836 6.33938 11.2787 6.68566 11.4754 7.13089C11.6721 7.57612 11.7705 8.12029 11.7705 8.71393C11.7705 9.40651 11.623 10.0002 11.2787 10.4454C10.9836 10.8906 10.4918 11.2864 9.90164 11.5832C10.7377 11.8305 11.377 12.2758 11.7705 12.8694C12.1639 13.463 12.4098 14.2051 12.4098 15.0461C12.4098 15.7387 12.2623 16.3323 12.0164 16.827C11.7705 17.3217 11.377 17.7669 10.9344 18.0638C10.4918 18.3606 9.95082 18.6079 9.36066 18.7563C8.77049 18.9047 8.18033 19.0037 7.59016 19.0037H1V5.34998H7.44262ZM7.04918 10.8906C7.59016 10.8906 8.03279 10.7422 8.37705 10.4949C8.72131 10.2475 8.86885 9.80227 8.86885 9.2581C8.86885 8.96128 8.81967 8.66446 8.72131 8.46658C8.62295 8.2687 8.47541 8.12029 8.27869 7.97188C8.08197 7.87294 7.88525 7.774 7.63934 7.72453C7.39344 7.67506 7.14754 7.67506 6.85246 7.67506H4V10.8906H7.04918ZM7.19672 16.7281C7.4918 16.7281 7.78689 16.6786 8.03279 16.6291C8.27869 16.5797 8.52459 16.4807 8.72131 16.3323C8.91803 16.1839 9.06557 16.0355 9.21311 15.7881C9.31148 15.5408 9.40984 15.244 9.40984 14.8977C9.40984 14.2051 9.21312 13.7104 8.81967 13.3641C8.42623 13.0673 7.88525 12.9189 7.2459 12.9189H4V16.7281H7.19672ZM16.6885 16.6786C17.082 17.0744 17.6721 17.2722 18.459 17.2722C19 17.2722 19.4918 17.1238 19.8852 16.8765C20.2787 16.5797 20.5246 16.2828 20.623 15.986H23.0328C22.6393 17.1733 22.0492 18.0143 21.2623 18.5585C20.4754 19.0532 19.541 19.35 18.4098 19.35C17.6229 19.35 16.9344 19.2016 16.2951 18.9542C15.6557 18.7069 15.1639 18.3606 14.7213 17.8659C14.2787 17.4206 13.9344 16.8765 13.7377 16.2334C13.4918 15.5903 13.3934 14.8977 13.3934 14.1062C13.3934 13.3641 13.4918 12.6715 13.7377 12.0284C13.9836 11.3853 14.3279 10.8411 14.7705 10.3464C15.2131 9.90121 15.7541 9.50545 16.3443 9.2581C16.9836 9.01075 17.6229 8.86234 18.4098 8.86234C19.2459 8.86234 19.9836 9.01075 20.623 9.35704C21.2623 9.70333 21.7541 10.0991 22.1475 10.6927C22.541 11.2369 22.8361 11.88 23.0328 12.5726C23.1311 13.2652 23.1803 13.9577 23.1311 14.7493H16C16 15.5408 16.2951 16.2828 16.6885 16.6786ZM19.7869 11.4843C19.4426 11.138 18.9016 10.9401 18.2623 10.9401C17.8197 10.9401 17.4754 11.039 17.1803 11.1874C16.8852 11.3358 16.6885 11.5337 16.4918 11.7316C16.2951 11.9295 16.1967 12.1768 16.1475 12.4242C16.0984 12.6715 16.0492 12.8694 16.0492 13.0673H20.4754C20.3771 12.3252 20.1311 11.8305 19.7869 11.4843ZM15.459 6.2899H20.9672V7.62559H15.459V6.2899Z"
  }));
},
    f0 = function f0(_ref186) {
  var _ref186$color = _ref186.color,
      C = _ref186$color === void 0 ? "currentColor" : _ref186$color,
      _ref186$size = _ref186.size,
      e = _ref186$size === void 0 ? 24 : _ref186$size,
      l = _ref186.className,
      i = _objectWithoutProperties(_ref186, _excluded186);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7.5 11C8.60457 11 9.5 10.1046 9.5 9C9.5 7.89543 8.60457 7 7.5 7H3V11H7.5ZM8.5 13H3V17H8.5C9.60457 17 10.5 16.1046 10.5 15C10.5 13.8954 9.60457 13 8.5 13ZM10.5632 11.5725C11.7239 12.2726 12.5 13.5457 12.5 15C12.5 17.2091 10.7091 19 8.5 19H1V5H7.5C9.70914 5 11.5 6.79086 11.5 9C11.5 9.97964 11.1478 10.877 10.5632 11.5725ZM15.5 6H21V7.5H15.5V6ZM23 14.5H15.5V14.75C15.5 16.2688 16.7312 17.5 18.25 17.5C19.3187 17.5 20.245 16.8904 20.7001 16H22.8338C22.2851 18.0169 20.4407 19.5 18.25 19.5C15.6266 19.5 13.5 17.3734 13.5 14.75V13.25C13.5 10.6266 15.6266 8.5 18.25 8.5C20.8734 8.5 23 10.6266 23 13.25V14.5ZM20.8965 12.5C20.57 11.3457 19.5088 10.5 18.25 10.5C16.9912 10.5 15.93 11.3457 15.6035 12.5H20.8965Z"
  }));
},
    R0 = function R0(_ref187) {
  var _ref187$color = _ref187.color,
      C = _ref187$color === void 0 ? "currentColor" : _ref187$color,
      _ref187$size = _ref187.size,
      e = _ref187$size === void 0 ? 24 : _ref187$size,
      l = _ref187.className,
      i = _objectWithoutProperties(_ref187, _excluded187);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13.4142 10.5859L13.8936 11.0719L14.3585 11.5567L14.8177 12.0492C18.2758 15.8132 20.2896 19.2668 19.4246 20.1318C19.0242 20.5322 18.069 20.3157 16.7851 19.6246C13.5839 21.6383 9.38982 21.441 6.38249 19.0327L9.36197 16.0538C10.0289 16.2315 10.7697 16.0587 11.2929 15.5356C12.0739 14.7546 12.0739 13.4882 11.2929 12.7072C10.5118 11.9261 9.24551 11.9261 8.46447 12.7072C7.98129 13.1904 7.79702 13.8592 7.91165 14.4841L7.94653 14.6392L4.968 17.6184C2.55913 14.611 2.36164 10.4164 4.37553 7.21435C3.68433 5.93106 3.46783 4.97589 3.86827 4.57545C4.84458 3.59914 9.11845 6.29009 13.4142 10.5859ZM19.7782 4.2219C20.5592 5.00294 20.5592 6.26927 19.7782 7.05032C19.7254 7.10309 19.6704 7.15229 19.6135 7.19793C21.2304 9.75414 21.4333 12.9498 20.2214 15.6677C19.0324 13.7136 17.1513 11.4945 14.8284 9.17164L14.2905 8.63984C12.1634 6.56151 10.1352 4.87572 8.3327 3.77928C11.0504 2.56691 14.2459 2.76965 16.804 4.38713C16.8478 4.32964 16.897 4.27466 16.9497 4.2219C17.7308 3.44085 18.9971 3.44085 19.7782 4.2219Z"
  }));
},
    z0 = function z0(_ref188) {
  var _ref188$color = _ref188.color,
      C = _ref188$color === void 0 ? "currentColor" : _ref188$color,
      _ref188$size = _ref188.size,
      e = _ref188$size === void 0 ? 24 : _ref188$size,
      l = _ref188.className,
      i = _objectWithoutProperties(_ref188, _excluded188);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14.1213 9.87865C18.4171 14.1744 20.9497 18.6066 19.7782 19.7782C19.3031 20.2532 18.2918 20.1192 16.971 19.5055C13.746 21.6451 9.44716 21.4873 6.38175 19.032L6.34315 19.071L4.92893 17.6568L4.96734 17.6174C2.51262 14.5521 2.35503 10.2537 4.49456 7.03005C3.88075 5.70797 3.74678 4.69685 4.22183 4.2218C5.34959 3.09404 9.49865 5.39866 13.639 9.40425L14.1213 9.87865ZM12.7071 11.2929C10.823 9.40876 8.86963 7.84195 7.23581 6.86954L7.05025 7.05023C4.55691 9.54357 4.33771 13.4499 6.39266 16.1917L8.23943 14.3462C8.06128 13.679 8.23392 12.9376 8.75736 12.4142C9.53841 11.6331 10.8047 11.6331 11.5858 12.4142C12.3668 13.1952 12.3668 14.4616 11.5858 15.2426C11.0626 15.7658 10.3218 15.9385 9.65487 15.7608L7.80749 17.6067C10.5493 19.6623 14.4562 19.4433 16.9497 16.9497L17.1286 16.7623L17.076 16.6734C16.1001 15.0582 14.5564 13.1422 12.7071 11.2929ZM19.7782 4.2218C20.5592 5.00285 20.5592 6.26918 19.7782 7.05023C19.7254 7.10299 19.6704 7.1522 19.6135 7.19783C21.2057 9.71504 21.4267 12.8522 20.276 15.5426C19.8994 14.8064 19.4347 14.0317 18.8899 13.2368C19.2795 11.0596 18.6326 8.73308 16.9497 7.05023C15.2669 5.36737 12.9404 4.72049 10.7627 5.10957C9.96765 4.56488 9.19311 4.10029 8.45731 3.72447C11.1478 2.57335 14.2849 2.79427 16.8039 4.38695C16.8478 4.32955 16.897 4.27457 16.9497 4.2218C17.7308 3.44075 18.9971 3.44075 19.7782 4.2218Z"
  }));
},
    F0 = function F0(_ref189) {
  var _ref189$color = _ref189.color,
      C = _ref189$color === void 0 ? "currentColor" : _ref189$color,
      _ref189$size = _ref189.size,
      e = _ref189$size === void 0 ? 24 : _ref189$size,
      l = _ref189.className,
      i = _objectWithoutProperties(_ref189, _excluded189);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5.5 12H4V7H2V5H8V7H6V9.79548L15.8131 7.16607L15.2327 5H12V3H15.9784C16.4286 2.98994 16.8442 3.28693 16.9659 3.74118L18.5188 9.53674L16.587 10.0544L16.3307 9.09792L5.5 12ZM5 21C2.79086 21 1 19.2091 1 17C1 14.7909 2.79086 13 5 13C7.20914 13 9 14.7909 9 17C9 19.2091 7.20914 21 5 21ZM5 18C5.55228 18 6 17.5523 6 17C6 16.4477 5.55228 16 5 16C4.44772 16 4 16.4477 4 17C4 17.5523 4.44772 18 5 18ZM18 21C15.2386 21 13 18.7614 13 16C13 13.2386 15.2386 11 18 11C20.7614 11 23 13.2386 23 16C23 18.7614 20.7614 21 18 21ZM18 17C18.5523 17 19 16.5523 19 16C19 15.4477 18.5523 15 18 15C17.4477 15 17 15.4477 17 16C17 16.5523 17.4477 17 18 17Z"
  }));
},
    S0 = function S0(_ref190) {
  var _ref190$color = _ref190.color,
      C = _ref190$color === void 0 ? "currentColor" : _ref190$color,
      _ref190$size = _ref190.size,
      e = _ref190$size === void 0 ? 24 : _ref190$size,
      l = _ref190.className,
      i = _objectWithoutProperties(_ref190, _excluded190);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5.5 12H4V7H2V5H8V7H6V9.79548L15.8131 7.16607L15.2327 5H12V3H15.9784C16.4286 2.98994 16.8442 3.28693 16.9659 3.74118L18.5188 9.53674L16.587 10.0544L16.3307 9.09792L5.5 12ZM5 19C6.10457 19 7 18.1046 7 17C7 15.8954 6.10457 15 5 15C3.89543 15 3 15.8954 3 17C3 18.1046 3.89543 19 5 19ZM5 21C2.79086 21 1 19.2091 1 17C1 14.7909 2.79086 13 5 13C7.20914 13 9 14.7909 9 17C9 19.2091 7.20914 21 5 21ZM18 19C19.6569 19 21 17.6569 21 16C21 14.3431 19.6569 13 18 13C16.3431 13 15 14.3431 15 16C15 17.6569 16.3431 19 18 19ZM18 21C15.2386 21 13 18.7614 13 16C13 13.2386 15.2386 11 18 11C20.7614 11 23 13.2386 23 16C23 18.7614 20.7614 21 18 21Z"
  }));
},
    A0 = function A0(_ref191) {
  var _ref191$color = _ref191.color,
      C = _ref191$color === void 0 ? "currentColor" : _ref191$color,
      _ref191$size = _ref191.size,
      e = _ref191$size === void 0 ? 24 : _ref191$size,
      l = _ref191.className,
      i = _objectWithoutProperties(_ref191, _excluded191);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18.223 3.08609C18.7112 3.57424 18.7112 4.3657 18.223 4.85385L17.08 5.99622L18.25 5.99662C20.3211 5.99662 22 7.67555 22 9.74662V17.2466C22 19.3177 20.3211 20.9966 18.25 20.9966H5.75C3.67893 20.9966 2 19.3177 2 17.2466V9.74662C2 7.67555 3.67893 5.99662 5.75 5.99662L6.91625 5.99622L5.77466 4.85481C5.28651 4.36665 5.28651 3.5752 5.77466 3.08704C6.26282 2.59889 7.05427 2.59889 7.54243 3.08704L10.1941 5.73869C10.2729 5.81753 10.339 5.90428 10.3924 5.99638L13.6046 5.99661C13.6581 5.90407 13.7244 5.81691 13.8036 5.73774L16.4553 3.08609C16.9434 2.59793 17.7349 2.59793 18.223 3.08609ZM18.25 8.50662H5.75C5.09102 8.50662 4.55115 9.01654 4.50343 9.66333L4.5 9.75662V17.2566C4.5 17.9156 5.00992 18.4555 5.65671 18.5032L5.75 18.5066H18.25C18.909 18.5066 19.4489 17.9967 19.4966 17.3499L19.5 17.2566V9.75662C19.5 9.06626 18.9404 8.50662 18.25 8.50662ZM8.25 11.0066C8.94036 11.0066 9.5 11.5663 9.5 12.2566V13.5066C9.5 14.197 8.94036 14.7566 8.25 14.7566C7.55964 14.7566 7 14.197 7 13.5066V12.2566C7 11.5663 7.55964 11.0066 8.25 11.0066ZM15.75 11.0066C16.4404 11.0066 17 11.5663 17 12.2566V13.5066C17 14.197 16.4404 14.7566 15.75 14.7566C15.0596 14.7566 14.5 14.197 14.5 13.5066V12.2566C14.5 11.5663 15.0596 11.0066 15.75 11.0066Z"
  }));
},
    k0 = function k0(_ref192) {
  var _ref192$color = _ref192.color,
      C = _ref192$color === void 0 ? "currentColor" : _ref192$color,
      _ref192$size = _ref192.size,
      e = _ref192$size === void 0 ? 24 : _ref192$size,
      l = _ref192.className,
      i = _objectWithoutProperties(_ref192, _excluded192);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7.17157 2.75737L10.414 5.99948H13.585L16.8284 2.75737C17.219 2.36685 17.8521 2.36685 18.2426 2.75737C18.6332 3.1479 18.6332 3.78106 18.2426 4.17158L16.414 5.99948L18.5 6.00001C20.433 6.00001 22 7.56701 22 9.50001V17.5C22 19.433 20.433 21 18.5 21H5.5C3.567 21 2 19.433 2 17.5V9.50001C2 7.56701 3.567 6.00001 5.5 6.00001L7.585 5.99948L5.75736 4.17158C5.36684 3.78106 5.36684 3.1479 5.75736 2.75737C6.14788 2.36685 6.78105 2.36685 7.17157 2.75737ZM18.5 8.00001H5.5C4.7203 8.00001 4.07955 8.5949 4.00687 9.35555L4 9.50001V17.5C4 18.2797 4.59489 18.9205 5.35554 18.9931L5.5 19H18.5C19.2797 19 19.9204 18.4051 19.9931 17.6445L20 17.5V9.50001C20 8.67158 19.3284 8.00001 18.5 8.00001ZM8 11C8.55228 11 9 11.4477 9 12V14C9 14.5523 8.55228 15 8 15C7.44772 15 7 14.5523 7 14V12C7 11.4477 7.44772 11 8 11ZM16 11C16.5523 11 17 11.4477 17 12V14C17 14.5523 16.5523 15 16 15C15.4477 15 15 14.5523 15 14V12C15 11.4477 15.4477 11 16 11Z"
  }));
},
    P0 = function P0(_ref193) {
  var _ref193$color = _ref193.color,
      C = _ref193$color === void 0 ? "currentColor" : _ref193$color,
      _ref193$size = _ref193.size,
      e = _ref193$size === void 0 ? 24 : _ref193$size,
      l = _ref193.className,
      i = _objectWithoutProperties(_ref193, _excluded193);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 22H4C3.44772 22 3 21.5523 3 21V3C3 2.44772 3.44772 2 4 2H20C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22ZM8 9V11H16V9H8ZM8 13V15H16V13H8Z"
  }));
},
    D0 = function D0(_ref194) {
  var _ref194$color = _ref194.color,
      C = _ref194$color === void 0 ? "currentColor" : _ref194$color,
      _ref194$size = _ref194.size,
      e = _ref194$size === void 0 ? 24 : _ref194$size,
      l = _ref194.className,
      i = _objectWithoutProperties(_ref194, _excluded194);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 22H4C3.44772 22 3 21.5523 3 21V3C3 2.44772 3.44772 2 4 2H20C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22ZM19 20V4H5V20H19ZM8 9H16V11H8V9ZM8 13H16V15H8V13Z"
  }));
},
    y0 = function y0(_ref195) {
  var _ref195$color = _ref195.color,
      C = _ref195$color === void 0 ? "currentColor" : _ref195$color,
      _ref195$size = _ref195.size,
      e = _ref195$size === void 0 ? 24 : _ref195$size,
      l = _ref195.className,
      i = _objectWithoutProperties(_ref195, _excluded195);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6ZM12 7.75C13.3807 7.75 14.5 8.86929 14.5 10.25C14.5 10.8815 14.2658 11.4584 13.8796 11.8984C14.4447 12.354 14.8 13.0149 14.8 13.75C14.8 15.1307 13.5464 16.25 12 16.25C10.4536 16.25 9.2 15.1307 9.2 13.75C9.2 13.0149 9.5553 12.354 10.1209 11.8966C9.73416 11.4584 9.5 10.8815 9.5 10.25C9.5 8.86929 10.6193 7.75 12 7.75ZM12 12.75C11.2465 12.75 10.7 13.238 10.7 13.75C10.7 14.262 11.2465 14.75 12 14.75C12.7535 14.75 13.3 14.262 13.3 13.75C13.3 13.238 12.7535 12.75 12 12.75ZM12 9.25C11.4477 9.25 11 9.69772 11 10.25C11 10.8023 11.4477 11.25 12 11.25C12.5523 11.25 13 10.8023 13 10.25C13 9.69772 12.5523 9.25 12 9.25Z"
  }));
},
    b0 = function b0(_ref196) {
  var _ref196$color = _ref196.color,
      C = _ref196$color === void 0 ? "currentColor" : _ref196$color,
      _ref196$size = _ref196.size,
      e = _ref196$size === void 0 ? 24 : _ref196$size,
      l = _ref196.className,
      i = _objectWithoutProperties(_ref196, _excluded196);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM12 6C15.3137 6 18 8.68629 18 12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12C6 8.68629 8.68629 6 12 6ZM12 7.75C10.6193 7.75 9.5 8.86929 9.5 10.25C9.5 10.8815 9.73416 11.4584 10.1209 11.8966C9.5553 12.354 9.2 13.0149 9.2 13.75C9.2 15.1307 10.4536 16.25 12 16.25C13.5464 16.25 14.8 15.1307 14.8 13.75C14.8 13.0149 14.4447 12.354 13.8796 11.8984C14.2658 11.4584 14.5 10.8815 14.5 10.25C14.5 8.86929 13.3807 7.75 12 7.75ZM12 12.75C12.7535 12.75 13.3 13.238 13.3 13.75C13.3 14.262 12.7535 14.75 12 14.75C11.2465 14.75 10.7 14.262 10.7 13.75C10.7 13.238 11.2465 12.75 12 12.75ZM12 9.25C12.5523 9.25 13 9.69772 13 10.25C13 10.8023 12.5523 11.25 12 11.25C11.4477 11.25 11 10.8023 11 10.25C11 9.69772 11.4477 9.25 12 9.25Z"
  }));
},
    T0 = function T0(_ref197) {
  var _ref197$color = _ref197.color,
      C = _ref197$color === void 0 ? "currentColor" : _ref197$color,
      _ref197$size = _ref197.size,
      e = _ref197$size === void 0 ? 24 : _ref197$size,
      l = _ref197.className,
      i = _objectWithoutProperties(_ref197, _excluded197);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.0049 22.0028C6.48204 22.0028 2.00488 17.5257 2.00488 12.0028C2.00488 6.47996 6.48204 2.00281 12.0049 2.00281C17.5277 2.00281 22.0049 6.47996 22.0049 12.0028C22.0049 17.5257 17.5277 22.0028 12.0049 22.0028ZM11.0049 16.0028V18.0028H13.0049V16.0028H14.0049C15.3856 16.0028 16.5049 14.8835 16.5049 13.5028C16.5049 12.94 16.3189 12.4206 16.0051 12.0028C16.3189 11.585 16.5049 11.0656 16.5049 10.5028C16.5049 9.1221 15.3856 8.00281 14.0049 8.00281H13.0049V6.00281H11.0049V8.00281H8.00488V16.0028H11.0049ZM10.0049 13.0028H14.0049C14.281 13.0028 14.5049 13.2267 14.5049 13.5028C14.5049 13.7789 14.281 14.0028 14.0049 14.0028H10.0049V13.0028ZM10.0049 10.0028H14.0049C14.281 10.0028 14.5049 10.2267 14.5049 10.5028C14.5049 10.7789 14.281 11.0028 14.0049 11.0028H10.0049V10.0028Z"
  }));
},
    U0 = function U0(_ref198) {
  var _ref198$color = _ref198.color,
      C = _ref198$color === void 0 ? "currentColor" : _ref198$color,
      _ref198$size = _ref198.size,
      e = _ref198$size === void 0 ? 24 : _ref198$size,
      l = _ref198.className,
      i = _objectWithoutProperties(_ref198, _excluded198);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.0049 22.0028C6.48204 22.0028 2.00488 17.5257 2.00488 12.0028C2.00488 6.47996 6.48204 2.00281 12.0049 2.00281C17.5277 2.00281 22.0049 6.47996 22.0049 12.0028C22.0049 17.5257 17.5277 22.0028 12.0049 22.0028ZM12.0049 20.0028C16.4232 20.0028 20.0049 16.4211 20.0049 12.0028C20.0049 7.58453 16.4232 4.00281 12.0049 4.00281C7.5866 4.00281 4.00488 7.58453 4.00488 12.0028C4.00488 16.4211 7.5866 20.0028 12.0049 20.0028ZM11.0049 16.0028H8.00488V8.00281H11.0049V6.00281H13.0049V8.00281H14.0049C15.3856 8.00281 16.5049 9.1221 16.5049 10.5028C16.5049 11.0656 16.3189 11.585 16.0051 12.0028C16.3189 12.4206 16.5049 12.94 16.5049 13.5028C16.5049 14.8835 15.3856 16.0028 14.0049 16.0028H13.0049V18.0028H11.0049V16.0028ZM10.0049 13.0028V14.0028H14.0049C14.281 14.0028 14.5049 13.7789 14.5049 13.5028C14.5049 13.2267 14.281 13.0028 14.0049 13.0028H10.0049ZM10.0049 10.0028V11.0028H14.0049C14.281 11.0028 14.5049 10.7789 14.5049 10.5028C14.5049 10.2267 14.281 10.0028 14.0049 10.0028H10.0049Z"
  }));
},
    G0 = function G0(_ref199) {
  var _ref199$color = _ref199.color,
      C = _ref199$color === void 0 ? "currentColor" : _ref199$color,
      _ref199$size = _ref199.size,
      e = _ref199$size === void 0 ? 24 : _ref199$size,
      l = _ref199.className,
      i = _objectWithoutProperties(_ref199, _excluded199);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18.5 9C19.5 10.0606 20 11.3939 20 13C20 16.4664 16.3 17.276 14.5 22C13.8333 21.4254 13.5 20.5921 13.5 19.5C13.5 16.0181 18.5 14.2101 18.5 9ZM14.5 5C15.7 6.23841 16.3 7.57175 16.3 9C16.3 13.9513 10.2552 14.6918 11.5 22C9.83333 20.8392 9 19.1726 9 17C9 13.675 14.5 11 14.5 5ZM10 1C11.3333 2.66667 12 4.16667 12 5.5C12 11.75 3.5 13.7218 8 22C5.38352 21.4203 3.5 19 3.5 16C3.5 9.5 10 8.5 10 1Z"
  }));
},
    I0 = function I0(_ref200) {
  var _ref200$color = _ref200.color,
      C = _ref200$color === void 0 ? "currentColor" : _ref200$color,
      _ref200$size = _ref200.size,
      e = _ref200$size === void 0 ? 24 : _ref200$size,
      l = _ref200.className,
      i = _objectWithoutProperties(_ref200, _excluded200);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19 9C19.6667 10.0606 20 11.3939 20 13C20 16 16.5 17 15 22C14.3333 21.4254 14 20.5921 14 19.5C14 16.0181 19 14.2101 19 9ZM14.5 5C15.1667 6.23841 15.5 7.57175 15.5 9C15.5 14 9.5 15 11.5 22C9.83333 20.8392 9 19.1726 9 17C9 13.675 14.5 11 14.5 5ZM10 1C10.6667 2.33333 11 3.83333 11 5.5C11 11.5 2 13 8 22C5.5 21.5 3.5 19 3.5 16C3.5 9.5 10 8.5 10 1Z"
  }));
},
    W0 = function W0(_ref201) {
  var _ref201$color = _ref201.color,
      C = _ref201$color === void 0 ? "currentColor" : _ref201$color,
      _ref201$size = _ref201.size,
      e = _ref201$size === void 0 ? 24 : _ref201$size,
      l = _ref201.className,
      i = _objectWithoutProperties(_ref201, _excluded201);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14.3113 12L18.6544 16.3431L12.9976 22H10.9976V15.3137L6.63359 19.6777L5.21938 18.2635L10.9976 12.4853V11.5147L5.21938 5.73654L6.63359 4.32233L10.9976 8.68629V2H12.9976L18.6544 7.65685L14.3113 12ZM12.9976 13.5147V19.1716L15.826 16.3431L12.9976 13.5147ZM12.9976 10.4853L15.826 7.65685L12.9976 4.82843V10.4853ZM19.5 13.5C18.6716 13.5 18 12.8284 18 12C18 11.1716 18.6716 10.5 19.5 10.5C20.3284 10.5 21 11.1716 21 12C21 12.8284 20.3284 13.5 19.5 13.5ZM6.5 13.5C5.67157 13.5 5 12.8284 5 12C5 11.1716 5.67157 10.5 6.5 10.5C7.32843 10.5 8 11.1716 8 12C8 12.8284 7.32843 13.5 6.5 13.5Z"
  }));
},
    O0 = function O0(_ref202) {
  var _ref202$color = _ref202.color,
      C = _ref202$color === void 0 ? "currentColor" : _ref202$color,
      _ref202$size = _ref202.size,
      e = _ref202$size === void 0 ? 24 : _ref202$size,
      l = _ref202.className,
      i = _objectWithoutProperties(_ref202, _excluded202);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14.3113 12L18.6544 16.3431L12.9976 22H10.9976V15.3137L6.63359 19.6777L5.21938 18.2635L10.9976 12.4853V11.5147L5.21938 5.73654L6.63359 4.32233L10.9976 8.68629V2H12.9976L18.6544 7.65685L14.3113 12ZM12.9976 13.5147V19.1716L15.826 16.3431L12.9976 13.5147ZM12.9976 10.4853L15.826 7.65685L12.9976 4.82843V10.4853ZM19.5 13.5C18.6716 13.5 18 12.8284 18 12C18 11.1716 18.6716 10.5 19.5 10.5C20.3284 10.5 21 11.1716 21 12C21 12.8284 20.3284 13.5 19.5 13.5ZM6.5 13.5C5.67157 13.5 5 12.8284 5 12C5 11.1716 5.67157 10.5 6.5 10.5C7.32843 10.5 8 11.1716 8 12C8 12.8284 7.32843 13.5 6.5 13.5Z"
  }));
},
    K0 = function K0(_ref203) {
  var _ref203$color = _ref203.color,
      C = _ref203$color === void 0 ? "currentColor" : _ref203$color,
      _ref203$size = _ref203.size,
      e = _ref203$size === void 0 ? 24 : _ref203$size,
      l = _ref203.className,
      i = _objectWithoutProperties(_ref203, _excluded203);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14.3116 12L18.6548 16.3431L12.9979 22H10.9979V15.3137L6.63394 19.6777L5.21973 18.2635L10.9979 12.4853V11.5147L5.21973 5.73654L6.63394 4.32233L10.9979 8.68629V2H12.9979L18.6548 7.65685L14.3116 12ZM12.9979 13.5147V19.1716L15.8263 16.3431L12.9979 13.5147ZM12.9979 10.4853L15.8263 7.65685L12.9979 4.82843V10.4853Z"
  }));
},
    Q0 = function Q0(_ref204) {
  var _ref204$color = _ref204.color,
      C = _ref204$color === void 0 ? "currentColor" : _ref204$color,
      _ref204$size = _ref204.size,
      e = _ref204$size === void 0 ? 24 : _ref204$size,
      l = _ref204.className,
      i = _objectWithoutProperties(_ref204, _excluded204);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14.3116 12L18.6548 16.3431L12.9979 22H10.9979V15.3137L6.63394 19.6777L5.21973 18.2635L10.9979 12.4853V11.5147L5.21973 5.73654L6.63394 4.32233L10.9979 8.68629V2H12.9979L18.6548 7.65685L14.3116 12ZM12.9979 13.5147V19.1716L15.8263 16.3431L12.9979 13.5147ZM12.9979 10.4853L15.8263 7.65685L12.9979 4.82843V10.4853Z"
  }));
},
    q0 = function q0(_ref205) {
  var _ref205$color = _ref205.color,
      C = _ref205$color === void 0 ? "currentColor" : _ref205$color,
      _ref205$size = _ref205.size,
      e = _ref205$size === void 0 ? 24 : _ref205$size,
      l = _ref205.className,
      i = _objectWithoutProperties(_ref205, _excluded205);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5.43239 6.8433L1.39355 2.80445L2.80777 1.39024L22.6068 21.1892L21.1925 22.6034L18.1537 19.5646C14.6255 22.8742 9.08161 22.8062 5.6362 19.3608C2.19078 15.9154 2.12284 10.3715 5.43239 6.8433ZM8.2433 4.02578L12.0002 0.268921L18.3641 6.63288C20.9499 9.21864 21.6333 12.9863 20.4144 16.1969L8.2433 4.02578Z"
  }));
},
    j0 = function j0(_ref206) {
  var _ref206$color = _ref206.color,
      C = _ref206$color === void 0 ? "currentColor" : _ref206$color,
      _ref206$size = _ref206.size,
      e = _ref206$size === void 0 ? 24 : _ref206$size,
      l = _ref206.className,
      i = _objectWithoutProperties(_ref206, _excluded206);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18.1537 19.5646C14.6255 22.8742 9.08161 22.8062 5.6362 19.3608C2.19078 15.9154 2.12284 10.3715 5.43239 6.8433L1.39355 2.80445L2.80777 1.39024L22.6068 21.1892L21.1925 22.6034L18.1537 19.5646ZM6.84756 8.25846C4.3185 11.0046 4.38612 15.2823 7.05041 17.9466C9.7147 20.6109 13.9924 20.6785 16.7385 18.1494L6.84756 8.25846ZM20.4144 16.1969L18.8156 14.598C19.3488 12.3187 18.7269 9.82407 16.9499 8.0471L12.0002 3.09735L9.65751 5.43999L8.2433 4.02578L12.0002 0.268921L18.3641 6.63288C20.9499 9.21864 21.6333 12.9863 20.4144 16.1969Z"
  }));
},
    X0 = function X0(_ref207) {
  var _ref207$color = _ref207.color,
      C = _ref207$color === void 0 ? "currentColor" : _ref207$color,
      _ref207$size = _ref207.size,
      e = _ref207$size === void 0 ? 24 : _ref207$size,
      l = _ref207.className,
      i = _objectWithoutProperties(_ref207, _excluded207);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 16V20H8V22H2V16H4ZM22 16V22H16V20H20V16H22ZM7.5 7C7.5 9.48528 9.51472 11.5 12 11.5C14.4853 11.5 16.5 9.48528 16.5 7H18.5C18.5 9.50729 17.0804 11.683 15.0011 12.7672L15 19H9L8.99992 12.7677C6.92007 11.6837 5.5 9.50769 5.5 7H7.5ZM12 5C13.3807 5 14.5 6.11929 14.5 7.5C14.5 8.88071 13.3807 10 12 10C10.6193 10 9.5 8.88071 9.5 7.5C9.5 6.11929 10.6193 5 12 5ZM8 2V4L4 3.999V8H2V2H8ZM22 2V8H20V4H16V2H22Z"
  }));
},
    J0 = function J0(_ref208) {
  var _ref208$color = _ref208.color,
      C = _ref208$color === void 0 ? "currentColor" : _ref208$color,
      _ref208$size = _ref208.size,
      e = _ref208$size === void 0 ? 24 : _ref208$size,
      l = _ref208.className,
      i = _objectWithoutProperties(_ref208, _excluded208);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 16V20H8V22H2V16H4ZM22 16V22H16V20H20V16H22ZM7.5 7C7.5 9.1416 8.99603 10.9338 11 11.3885L11 17H13L13.001 11.3883C15.0045 10.9332 16.5 9.14125 16.5 7H18.5C18.5 9.50729 17.0804 11.683 15.0011 12.7672L15 19H9L8.99992 12.7677C6.92007 11.6837 5.5 9.50769 5.5 7H7.5ZM12 5C13.3807 5 14.5 6.11929 14.5 7.5C14.5 8.88071 13.3807 10 12 10C10.6193 10 9.5 8.88071 9.5 7.5C9.5 6.11929 10.6193 5 12 5ZM8 2V4L4 3.999V8H2V2H8ZM22 2V8H20V4H16V2H22Z"
  }));
},
    Y0 = function Y0(_ref209) {
  var _ref209$color = _ref209.color,
      C = _ref209$color === void 0 ? "currentColor" : _ref209$color,
      _ref209$size = _ref209.size,
      e = _ref209$size === void 0 ? 24 : _ref209$size,
      l = _ref209.className,
      i = _objectWithoutProperties(_ref209, _excluded209);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8 11H12.5C13.8807 11 15 9.88071 15 8.5C15 7.11929 13.8807 6 12.5 6H8V11ZM18 15.5C18 17.9853 15.9853 20 13.5 20H6V4H12.5C14.9853 4 17 6.01472 17 8.5C17 9.70431 16.5269 10.7981 15.7564 11.6058C17.0979 12.3847 18 13.837 18 15.5ZM8 13V18H13.5C14.8807 18 16 16.8807 16 15.5C16 14.1193 14.8807 13 13.5 13H8Z"
  }));
},
    _0 = function _0(_ref210) {
  var _ref210$color = _ref210.color,
      C = _ref210$color === void 0 ? "currentColor" : _ref210$color,
      _ref210$size = _ref210.size,
      e = _ref210$size === void 0 ? 24 : _ref210$size,
      l = _ref210.className,
      i = _objectWithoutProperties(_ref210, _excluded210);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 18H6C5.44772 18 5 18.4477 5 19C5 19.5523 5.44772 20 6 20H21V22H6C4.34315 22 3 20.6569 3 19V4C3 2.89543 3.89543 2 5 2H21V18ZM16 9V7H8V9H16Z"
  }));
},
    $0 = function $0(_ref211) {
  var _ref211$color = _ref211.color,
      C = _ref211$color === void 0 ? "currentColor" : _ref211$color,
      _ref211$size = _ref211.size,
      e = _ref211$size === void 0 ? 24 : _ref211$size,
      l = _ref211.className,
      i = _objectWithoutProperties(_ref211, _excluded211);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 18H6C5.44772 18 5 18.4477 5 19C5 19.5523 5.44772 20 6 20H21V22H6C4.34315 22 3 20.6569 3 19V4C3 2.89543 3.89543 2 5 2H21V18ZM5 16.05C5.16156 16.0172 5.32877 16 5.5 16H19V4H5V16.05ZM16 9H8V7H16V9Z"
  }));
},
    e4 = function e4(_ref212) {
  var _ref212$color = _ref212.color,
      C = _ref212$color === void 0 ? "currentColor" : _ref212$color,
      _ref212$size = _ref212.size,
      e = _ref212$size === void 0 ? 24 : _ref212$size,
      l = _ref212.className,
      i = _objectWithoutProperties(_ref212, _excluded212);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 4H7C5.89543 4 5 4.89543 5 6C5 7.10457 5.89543 8 7 8H21V21C21 21.5523 20.5523 22 20 22H7C4.79086 22 3 20.2091 3 18V6C3 3.79086 4.79086 2 7 2H20C20.5523 2 21 2.44772 21 3V4ZM20 7H7C6.44772 7 6 6.55228 6 6C6 5.44772 6.44772 5 7 5H20V7Z"
  }));
},
    t4 = function t4(_ref213) {
  var _ref213$color = _ref213.color,
      C = _ref213$color === void 0 ? "currentColor" : _ref213$color,
      _ref213$size = _ref213.size,
      e = _ref213$size === void 0 ? 24 : _ref213$size,
      l = _ref213.className,
      i = _objectWithoutProperties(_ref213, _excluded213);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 4H7C5.89543 4 5 4.89543 5 6C5 7.10457 5.89543 8 7 8H21V21C21 21.5523 20.5523 22 20 22H7C4.79086 22 3 20.2091 3 18V6C3 3.79086 4.79086 2 7 2H20C20.5523 2 21 2.44772 21 3V4ZM5 18C5 19.1046 5.89543 20 7 20H19V10H7C6.27143 10 5.58835 9.80521 5 9.46487V18ZM20 7H7C6.44772 7 6 6.55228 6 6C6 5.44772 6.44772 5 7 5H20V7Z"
  }));
},
    C4 = function C4(_ref214) {
  var _ref214$color = _ref214.color,
      C = _ref214$color === void 0 ? "currentColor" : _ref214$color,
      _ref214$size = _ref214.size,
      e = _ref214$size === void 0 ? 24 : _ref214$size,
      l = _ref214.className,
      i = _objectWithoutProperties(_ref214, _excluded214);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 22H6.5C4.567 22 3 20.433 3 18.5V5C3 3.34315 4.34315 2 6 2H20C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22ZM19 20V17H6.5C5.67157 17 5 17.6716 5 18.5C5 19.3284 5.67157 20 6.5 20H19Z"
  }));
},
    l4 = function l4(_ref215) {
  var _ref215$color = _ref215.color,
      C = _ref215$color === void 0 ? "currentColor" : _ref215$color,
      _ref215$size = _ref215.size,
      e = _ref215$size === void 0 ? 24 : _ref215$size,
      l = _ref215.className,
      i = _objectWithoutProperties(_ref215, _excluded215);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 18.5V5C3 3.34315 4.34315 2 6 2H20C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22H6.5C4.567 22 3 20.433 3 18.5ZM19 20V17H6.5C5.67157 17 5 17.6716 5 18.5C5 19.3284 5.67157 20 6.5 20H19ZM5 15.3368C5.45463 15.1208 5.9632 15 6.5 15H19V4H6C5.44772 4 5 4.44772 5 5V15.3368Z"
  }));
},
    i4 = function i4(_ref216) {
  var _ref216$color = _ref216.color,
      C = _ref216$color === void 0 ? "currentColor" : _ref216$color,
      _ref216$size = _ref216.size,
      e = _ref216$size === void 0 ? 24 : _ref216$size,
      l = _ref216.className,
      i = _objectWithoutProperties(_ref216, _excluded216);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 22H6.5C4.567 22 3 20.433 3 18.5V5C3 3.34315 4.34315 2 6 2H20C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22ZM19 20V17H6.5C5.67157 17 5 17.6716 5 18.5C5 19.3284 5.67157 20 6.5 20H19ZM10 4V12L13.5 10L17 12V4H10Z"
  }));
},
    s4 = function s4(_ref217) {
  var _ref217$color = _ref217.color,
      C = _ref217$color === void 0 ? "currentColor" : _ref217$color,
      _ref217$size = _ref217.size,
      e = _ref217$size === void 0 ? 24 : _ref217$size,
      l = _ref217.className,
      i = _objectWithoutProperties(_ref217, _excluded217);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 18.5V5C3 3.34315 4.34315 2 6 2H20C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22H6.5C4.567 22 3 20.433 3 18.5ZM19 20V17H6.5C5.67157 17 5 17.6716 5 18.5C5 19.3284 5.67157 20 6.5 20H19ZM10 4H6C5.44772 4 5 4.44772 5 5V15.3368C5.45463 15.1208 5.9632 15 6.5 15H19V4H17V12L13.5 10L10 12V4Z"
  }));
},
    r4 = function r4(_ref218) {
  var _ref218$color = _ref218.color,
      C = _ref218$color === void 0 ? "currentColor" : _ref218$color,
      _ref218$size = _ref218.size,
      e = _ref218$size === void 0 ? 24 : _ref218$size,
      l = _ref218.className,
      i = _objectWithoutProperties(_ref218, _excluded218);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 21H13V6C13 4.34315 14.3431 3 16 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21ZM11 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H8C9.65685 3 11 4.34315 11 6V21ZM11 21H13V23H11V21Z"
  }));
},
    c4 = function c4(_ref219) {
  var _ref219$color = _ref219.color,
      C = _ref219$color === void 0 ? "currentColor" : _ref219$color,
      _ref219$size = _ref219.size,
      e = _ref219$size === void 0 ? 24 : _ref219$size,
      l = _ref219.className,
      i = _objectWithoutProperties(_ref219, _excluded219);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13 21V23H11V21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H9C10.1947 3 11.2671 3.52375 12 4.35418C12.7329 3.52375 13.8053 3 15 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H13ZM20 19V5H15C13.8954 5 13 5.89543 13 7V19H20ZM11 19V7C11 5.89543 10.1046 5 9 5H4V19H11Z"
  }));
},
    o4 = function o4(_ref220) {
  var _ref220$color = _ref220.color,
      C = _ref220$color === void 0 ? "currentColor" : _ref220$color,
      _ref220$size = _ref220.size,
      e = _ref220$size === void 0 ? 24 : _ref220$size,
      l = _ref220.className,
      i = _objectWithoutProperties(_ref220, _excluded220);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 3.9934C2 3.44476 2.45531 3 2.9918 3H21.0082C21.556 3 22 3.44495 22 3.9934V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5551 2 20.0066V3.9934ZM12 5V19H20V5H12ZM13 7H19V9H13V7ZM13 10H19V12H13V10Z"
  }));
},
    a4 = function a4(_ref221) {
  var _ref221$color = _ref221.color,
      C = _ref221$color === void 0 ? "currentColor" : _ref221$color,
      _ref221$size = _ref221.size,
      e = _ref221$size === void 0 ? 24 : _ref221$size,
      l = _ref221.className,
      i = _objectWithoutProperties(_ref221, _excluded221);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 3.9934C2 3.44476 2.45531 3 2.9918 3H21.0082C21.556 3 22 3.44495 22 3.9934V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5551 2 20.0066V3.9934ZM11 5H4V19H11V5ZM13 5V19H20V5H13ZM14 7H19V9H14V7ZM14 10H19V12H14V10Z"
  }));
},
    n4 = function n4(_ref222) {
  var _ref222$color = _ref222.color,
      C = _ref222$color === void 0 ? "currentColor" : _ref222$color,
      _ref222$size = _ref222.size,
      e = _ref222$size === void 0 ? 24 : _ref222$size,
      l = _ref222.className,
      i = _objectWithoutProperties(_ref222, _excluded222);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8 2V22H4V18H2V16H4V13H2V11H4V8H2V6H4V2H8ZM20.0049 2C21.1068 2 22 2.89821 22 3.9908V20.0092C22 21.1087 21.1074 22 20.0049 22H10V2H20.0049Z"
  }));
},
    m4 = function m4(_ref223) {
  var _ref223$color = _ref223.color,
      C = _ref223$color === void 0 ? "currentColor" : _ref223$color,
      _ref223$size = _ref223.size,
      e = _ref223$size === void 0 ? 24 : _ref223$size,
      l = _ref223.className,
      i = _objectWithoutProperties(_ref223, _excluded223);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.0049 2C21.1068 2 22 2.89821 22 3.9908V20.0092C22 21.1087 21.1074 22 20.0049 22H4V18H2V16H4V13H2V11H4V8H2V6H4V2H20.0049ZM8 4H6V20H8V4ZM20 4H10V20H20V4Z"
  }));
},
    w4 = function w4(_ref224) {
  var _ref224$color = _ref224.color,
      C = _ref224$color === void 0 ? "currentColor" : _ref224$color,
      _ref224$size = _ref224.size,
      e = _ref224$size === void 0 ? 24 : _ref224$size,
      l = _ref224.className,
      i = _objectWithoutProperties(_ref224, _excluded224);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5 2H19C19.5523 2 20 2.44772 20 3V22.1433C20 22.4194 19.7761 22.6434 19.5 22.6434C19.4061 22.6434 19.314 22.6168 19.2344 22.5669L12 18.0313L4.76559 22.5669C4.53163 22.7136 4.22306 22.6429 4.07637 22.4089C4.02647 22.3293 4 22.2373 4 22.1433V3C4 2.44772 4.44772 2 5 2ZM8 9V11H16V9H8Z"
  }));
},
    L4 = function L4(_ref225) {
  var _ref225$color = _ref225.color,
      C = _ref225$color === void 0 ? "currentColor" : _ref225$color,
      _ref225$size = _ref225.size,
      e = _ref225$size === void 0 ? 24 : _ref225$size,
      l = _ref225.className,
      i = _objectWithoutProperties(_ref225, _excluded225);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5 2H19C19.5523 2 20 2.44772 20 3V22.1433C20 22.4194 19.7761 22.6434 19.5 22.6434C19.4061 22.6434 19.314 22.6168 19.2344 22.5669L12 18.0313L4.76559 22.5669C4.53163 22.7136 4.22306 22.6429 4.07637 22.4089C4.02647 22.3293 4 22.2373 4 22.1433V3C4 2.44772 4.44772 2 5 2ZM18 4H6V19.4324L12 15.6707L18 19.4324V4ZM8 9H16V11H8V9Z"
  }));
},
    h4 = function h4(_ref226) {
  var _ref226$color = _ref226.color,
      C = _ref226$color === void 0 ? "currentColor" : _ref226$color,
      _ref226$size = _ref226.size,
      e = _ref226$size === void 0 ? 24 : _ref226$size,
      l = _ref226.className,
      i = _objectWithoutProperties(_ref226, _excluded226);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 2H20C20.5523 2 21 2.44772 21 3V22.2763C21 22.5525 20.7761 22.7764 20.5 22.7764C20.4298 22.7764 20.3604 22.7615 20.2963 22.7329L12 19.0313L3.70373 22.7329C3.45155 22.8455 3.15591 22.7322 3.04339 22.4801C3.01478 22.4159 3 22.3465 3 22.2763V3C3 2.44772 3.44772 2 4 2ZM12 13.5L14.9389 15.0451L14.3776 11.7725L16.7553 9.45492L13.4695 8.97746L12 6L10.5305 8.97746L7.24472 9.45492L9.62236 11.7725L9.06107 15.0451L12 13.5Z"
  }));
},
    H4 = function H4(_ref227) {
  var _ref227$color = _ref227.color,
      C = _ref227$color === void 0 ? "currentColor" : _ref227$color,
      _ref227$size = _ref227.size,
      e = _ref227$size === void 0 ? 24 : _ref227$size,
      l = _ref227.className,
      i = _objectWithoutProperties(_ref227, _excluded227);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 2H20C20.5523 2 21 2.44772 21 3V22.2763C21 22.5525 20.7761 22.7764 20.5 22.7764C20.4298 22.7764 20.3604 22.7615 20.2963 22.7329L12 19.0313L3.70373 22.7329C3.45155 22.8455 3.15591 22.7322 3.04339 22.4801C3.01478 22.4159 3 22.3465 3 22.2763V3C3 2.44772 3.44772 2 4 2ZM19 19.9645V4H5V19.9645L12 16.8412L19 19.9645ZM12 13.5L9.06107 15.0451L9.62236 11.7725L7.24472 9.45492L10.5305 8.97746L12 6L13.4695 8.97746L16.7553 9.45492L14.3776 11.7725L14.9389 15.0451L12 13.5Z"
  }));
},
    V4 = function V4(_ref228) {
  var _ref228$color = _ref228.color,
      C = _ref228$color === void 0 ? "currentColor" : _ref228$color,
      _ref228$size = _ref228.size,
      e = _ref228$size === void 0 ? 24 : _ref228$size,
      l = _ref228.className,
      i = _objectWithoutProperties(_ref228, _excluded228);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5 2H19C19.5523 2 20 2.44772 20 3V22.1433C20 22.4194 19.7761 22.6434 19.5 22.6434C19.4061 22.6434 19.314 22.6168 19.2344 22.5669L12 18.0313L4.76559 22.5669C4.53163 22.7136 4.22306 22.6429 4.07637 22.4089C4.02647 22.3293 4 22.2373 4 22.1433V3C4 2.44772 4.44772 2 5 2Z"
  }));
},
    g4 = function g4(_ref229) {
  var _ref229$color = _ref229.color,
      C = _ref229$color === void 0 ? "currentColor" : _ref229$color,
      _ref229$size = _ref229.size,
      e = _ref229$size === void 0 ? 24 : _ref229$size,
      l = _ref229.className,
      i = _objectWithoutProperties(_ref229, _excluded229);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5 2H19C19.5523 2 20 2.44772 20 3V22.1433C20 22.4194 19.7761 22.6434 19.5 22.6434C19.4061 22.6434 19.314 22.6168 19.2344 22.5669L12 18.0313L4.76559 22.5669C4.53163 22.7136 4.22306 22.6429 4.07637 22.4089C4.02647 22.3293 4 22.2373 4 22.1433V3C4 2.44772 4.44772 2 5 2ZM18 4H6V19.4324L12 15.6707L18 19.4324V4Z"
  }));
},
    M4 = function M4(_ref230) {
  var _ref230$color = _ref230.color,
      C = _ref230$color === void 0 ? "currentColor" : _ref230$color,
      _ref230$size = _ref230.size,
      e = _ref230$size === void 0 ? 24 : _ref230$size,
      l = _ref230.className,
      i = _objectWithoutProperties(_ref230, _excluded230);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9.501 11L9.64546 11.0069C10.3586 11.075 10.926 11.6424 10.9941 12.3555L11.001 12.5L10.9941 12.6445C10.926 13.3576 10.3586 13.925 9.64546 13.9931L9.501 14H6.001V16H9.501C11.2009 16 12.6178 14.7881 12.9348 13.1811L12.9654 13.0009L19.001 13C19.7123 13 20.3889 12.8515 21.0015 12.5837L21.001 17C21.001 18.3059 20.1666 19.4169 19.0019 19.829L19.001 21C19.001 21.5523 18.5533 22 18.001 22H6.001C5.44872 22 5.001 21.5523 5.001 21L5.00109 19.8293C3.83585 19.4175 3.001 18.3063 3.001 17V13C3.001 11.8954 3.89643 11 5.001 11H9.501ZM22.001 7.5V8L21.9959 8.17627C21.908 9.69275 20.6938 10.907 19.1773 10.9949L19.001 11H12.6642C12.1305 9.87663 11.0161 9.08266 9.70894 9.00607L9.501 9H5.001C4.27201 9 3.58857 9.19501 3 9.53571L3.001 6C3.001 3.79086 4.79186 2 7.001 2H16.501C19.5386 2 22.001 4.46243 22.001 7.5Z"
  }));
},
    Z4 = function Z4(_ref231) {
  var _ref231$color = _ref231.color,
      C = _ref231$color === void 0 ? "currentColor" : _ref231$color,
      _ref231$size = _ref231.size,
      e = _ref231$size === void 0 ? 24 : _ref231$size,
      l = _ref231.className,
      i = _objectWithoutProperties(_ref231, _excluded231);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16.5 2C19.5376 2 22 4.46243 22 7.5V10C22 10.8881 21.6141 11.686 21.0009 12.2353L21 17C21 18.3059 20.1656 19.4169 19.0009 19.829L19 21C19 21.5523 18.5523 22 18 22H6C5.44772 22 5 21.5523 5 21L5.00009 19.8293C3.83485 19.4175 3 18.3063 3 17V6C3 3.79086 4.79086 2 7 2H16.5ZM9.5 11H5V17C5 17.5128 5.38604 17.9355 5.88338 17.9933L6 18H18C18.5128 18 18.9355 17.614 18.9933 17.1166L19 17V13L12.9644 13.0009C12.7214 14.6966 11.2629 16 9.5 16H6V14H9.5C10.2797 14 10.9204 13.4051 10.9931 12.6445L11 12.5C11 11.7203 10.4051 11.0796 9.64446 11.0069L9.5 11ZM16.5 4H7C5.94564 4 5.08183 4.81588 5.00549 5.85074L5 6V9H9.5C10.8962 9 12.1014 9.81751 12.6632 11H19C19.5128 11 19.9355 10.614 19.9933 10.1166L20 10V7.5C20 5.63144 18.5357 4.10487 16.692 4.00518L16.5 4Z"
  }));
},
    x4 = function x4(_ref232) {
  var _ref232$color = _ref232.color,
      C = _ref232$color === void 0 ? "currentColor" : _ref232$color,
      _ref232$size = _ref232.size,
      e = _ref232$size === void 0 ? 24 : _ref232$size,
      l = _ref232.className,
      i = _objectWithoutProperties(_ref232, _excluded232);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 18V14.3C4 13.4716 3.32843 12.8 2.5 12.8H2V11.2H2.5C3.32843 11.2 4 10.5284 4 9.7V6C4 4.34315 5.34315 3 7 3H8V5H7C6.44772 5 6 5.44772 6 6V10.1C6 10.9858 5.42408 11.7372 4.62623 12C5.42408 12.2628 6 13.0142 6 13.9V18C6 18.5523 6.44772 19 7 19H8V21H7C5.34315 21 4 19.6569 4 18ZM20 14.3V18C20 19.6569 18.6569 21 17 21H16V19H17C17.5523 19 18 18.5523 18 18V13.9C18 13.0142 18.5759 12.2628 19.3738 12C18.5759 11.7372 18 10.9858 18 10.1V6C18 5.44772 17.5523 5 17 5H16V3H17C18.6569 3 20 4.34315 20 6V9.7C20 10.5284 20.6716 11.2 21.5 11.2H22V12.8H21.5C20.6716 12.8 20 13.4716 20 14.3Z"
  }));
},
    v4 = function v4(_ref233) {
  var _ref233$color = _ref233.color,
      C = _ref233$color === void 0 ? "currentColor" : _ref233$color,
      _ref233$size = _ref233.size,
      e = _ref233$size === void 0 ? 24 : _ref233$size,
      l = _ref233.className,
      i = _objectWithoutProperties(_ref233, _excluded233);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 18V14.3C4 13.4716 3.32843 12.8 2.5 12.8H2V11.2H2.5C3.32843 11.2 4 10.5284 4 9.7V6C4 4.34315 5.34315 3 7 3H8V5H7C6.44772 5 6 5.44772 6 6V10.1C6 10.9858 5.42408 11.7372 4.62623 12C5.42408 12.2628 6 13.0142 6 13.9V18C6 18.5523 6.44772 19 7 19H8V21H7C5.34315 21 4 19.6569 4 18ZM20 14.3V18C20 19.6569 18.6569 21 17 21H16V19H17C17.5523 19 18 18.5523 18 18V13.9C18 13.0142 18.5759 12.2628 19.3738 12C18.5759 11.7372 18 10.9858 18 10.1V6C18 5.44772 17.5523 5 17 5H16V3H17C18.6569 3 20 4.34315 20 6V9.7C20 10.5284 20.6716 11.2 21.5 11.2H22V12.8H21.5C20.6716 12.8 20 13.4716 20 14.3Z"
  }));
},
    d4 = function d4(_ref234) {
  var _ref234$color = _ref234.color,
      C = _ref234$color === void 0 ? "currentColor" : _ref234$color,
      _ref234$size = _ref234.size,
      e = _ref234$size === void 0 ? 24 : _ref234$size,
      l = _ref234.className,
      i = _objectWithoutProperties(_ref234, _excluded234);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9 3V5H6V19H9V21H4V3H9ZM15 3H20V21H15V19H18V5H15V3Z"
  }));
},
    p4 = function p4(_ref235) {
  var _ref235$color = _ref235.color,
      C = _ref235$color === void 0 ? "currentColor" : _ref235$color,
      _ref235$size = _ref235.size,
      e = _ref235$size === void 0 ? 24 : _ref235$size,
      l = _ref235.className,
      i = _objectWithoutProperties(_ref235, _excluded235);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9 3V5H6V19H9V21H4V3H9ZM15 3H20V21H15V19H18V5H15V3Z"
  }));
},
    E4 = function E4(_ref236) {
  var _ref236$color = _ref236.color,
      C = _ref236$color === void 0 ? "currentColor" : _ref236$color,
      _ref236$size = _ref236.size,
      e = _ref236$size === void 0 ? 24 : _ref236$size,
      l = _ref236.className,
      i = _objectWithoutProperties(_ref236, _excluded236);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7 5V2C7 1.44772 7.44772 1 8 1H16C16.5523 1 17 1.44772 17 2V5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V6C2 5.44772 2.44772 5 3 5H7ZM17 13V10H15V13H9V10H7V13H4V19H20V13H17ZM9 3V5H15V3H9Z"
  }));
},
    N4 = function N4(_ref237) {
  var _ref237$color = _ref237.color,
      C = _ref237$color === void 0 ? "currentColor" : _ref237$color,
      _ref237$size = _ref237.size,
      e = _ref237$size === void 0 ? 24 : _ref237$size,
      l = _ref237.className,
      i = _objectWithoutProperties(_ref237, _excluded237);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7 5V2C7 1.44772 7.44772 1 8 1H16C16.5523 1 17 1.44772 17 2V5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V6C2 5.44772 2.44772 5 3 5H7ZM20 13H4V19H20V13ZM20 7H4V11H7V9H9V11H15V9H17V11H20V7ZM9 3V5H15V3H9Z"
  }));
},
    u4 = function u4(_ref238) {
  var _ref238$color = _ref238.color,
      C = _ref238$color === void 0 ? "currentColor" : _ref238$color,
      _ref238$size = _ref238.size,
      e = _ref238$size === void 0 ? 24 : _ref238$size,
      l = _ref238.className,
      i = _objectWithoutProperties(_ref238, _excluded238);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7 5V2C7 1.44772 7.44772 1 8 1H16C16.5523 1 17 1.44772 17 2V5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V6C2 5.44772 2.44772 5 3 5H7ZM17 7V12H20V7H17ZM15 7H9V12H15V7ZM7 7H4V12H7V7ZM9 3V5H15V3H9Z"
  }));
},
    B4 = function B4(_ref239) {
  var _ref239$color = _ref239.color,
      C = _ref239$color === void 0 ? "currentColor" : _ref239$color,
      _ref239$size = _ref239.size,
      e = _ref239$size === void 0 ? 24 : _ref239$size,
      l = _ref239.className,
      i = _objectWithoutProperties(_ref239, _excluded239);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7 5V2C7 1.44772 7.44772 1 8 1H16C16.5523 1 17 1.44772 17 2V5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V6C2 5.44772 2.44772 5 3 5H7ZM15 7H9V19H15V7ZM7 7H4V19H7V7ZM17 7V19H20V7H17ZM9 3V5H15V3H9Z"
  }));
},
    f4 = function f4(_ref240) {
  var _ref240$color = _ref240.color,
      C = _ref240$color === void 0 ? "currentColor" : _ref240$color,
      _ref240$size = _ref240.size,
      e = _ref240$size === void 0 ? 24 : _ref240$size,
      l = _ref240.className,
      i = _objectWithoutProperties(_ref240, _excluded240);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9 13V16H15V13H22V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V13H9ZM11 11H13V14H11V11ZM7 5V2C7 1.44772 7.44772 1 8 1H16C16.5523 1 17 1.44772 17 2V5H21C21.5523 5 22 5.44772 22 6V11H15V9H9V11H2V6C2 5.44772 2.44772 5 3 5H7ZM9 3V5H15V3H9Z"
  }));
},
    R4 = function R4(_ref241) {
  var _ref241$color = _ref241.color,
      C = _ref241$color === void 0 ? "currentColor" : _ref241$color,
      _ref241$size = _ref241.size,
      e = _ref241$size === void 0 ? 24 : _ref241$size,
      l = _ref241.className,
      i = _objectWithoutProperties(_ref241, _excluded241);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7 5V2C7 1.44772 7.44772 1 8 1H16C16.5523 1 17 1.44772 17 2V5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V6C2 5.44772 2.44772 5 3 5H7ZM9 13H4V19H20V13H15V16H9V13ZM20 7H4V11H9V9H15V11H20V7ZM11 11V14H13V11H11ZM9 3V5H15V3H9Z"
  }));
},
    z4 = function z4(_ref242) {
  var _ref242$color = _ref242.color,
      C = _ref242$color === void 0 ? "currentColor" : _ref242$color,
      _ref242$size = _ref242.size,
      e = _ref242$size === void 0 ? 24 : _ref242$size,
      l = _ref242.className,
      i = _objectWithoutProperties(_ref242, _excluded242);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7 5V2C7 1.44772 7.44772 1 8 1H16C16.5523 1 17 1.44772 17 2V5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V6C2 5.44772 2.44772 5 3 5H7ZM6 13V7H4V13H6ZM8 7V13H11V11H13V13H16V7H8ZM18 13H20V7H18V13ZM9 3V5H15V3H9Z"
  }));
},
    F4 = function F4(_ref243) {
  var _ref243$color = _ref243.color,
      C = _ref243$color === void 0 ? "currentColor" : _ref243$color,
      _ref243$size = _ref243.size,
      e = _ref243$size === void 0 ? 24 : _ref243$size,
      l = _ref243.className,
      i = _objectWithoutProperties(_ref243, _excluded243);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7 5V2C7 1.44772 7.44772 1 8 1H16C16.5523 1 17 1.44772 17 2V5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V6C2 5.44772 2.44772 5 3 5H7ZM16 15H13V16H11V15H8V19H16V15ZM8 7V13H11V12H13V13H16V7H8ZM6 13V7H4V13H6ZM18 13H20V7H18V13ZM6 15H4V19H6V15ZM18 15V19H20V15H18ZM9 3V5H15V3H9Z"
  }));
},
    S4 = function S4(_ref244) {
  var _ref244$color = _ref244.color,
      C = _ref244$color === void 0 ? "currentColor" : _ref244$color,
      _ref244$size = _ref244.size,
      e = _ref244$size === void 0 ? 24 : _ref244$size,
      l = _ref244.className,
      i = _objectWithoutProperties(_ref244, _excluded244);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7 5V2C7 1.44772 7.44772 1 8 1H16C16.5523 1 17 1.44772 17 2V5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V6C2 5.44772 2.44772 5 3 5H7ZM4 15V19H20V15H4ZM11 11V13H13V11H11ZM9 3V5H15V3H9Z"
  }));
},
    A4 = function A4(_ref245) {
  var _ref245$color = _ref245.color,
      C = _ref245$color === void 0 ? "currentColor" : _ref245$color,
      _ref245$size = _ref245.size,
      e = _ref245$size === void 0 ? 24 : _ref245$size,
      l = _ref245.className,
      i = _objectWithoutProperties(_ref245, _excluded245);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7 5V2C7 1.44772 7.44772 1 8 1H16C16.5523 1 17 1.44772 17 2V5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V6C2 5.44772 2.44772 5 3 5H7ZM4 16V19H20V16H4ZM4 14H20V7H4V14ZM9 3V5H15V3H9ZM11 11H13V13H11V11Z"
  }));
},
    k4 = function k4(_ref246) {
  var _ref246$color = _ref246.color,
      C = _ref246$color === void 0 ? "currentColor" : _ref246$color,
      _ref246$size = _ref246.size,
      e = _ref246$size === void 0 ? 24 : _ref246$size,
      l = _ref246.className,
      i = _objectWithoutProperties(_ref246, _excluded246);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14 3C14.5523 3 15 3.44772 15 4V9H20C20.5523 9 21 9.44772 21 10V20C21 20.5523 20.5523 21 20 21H10C9.44772 21 9 20.5523 9 20V15H4C3.44772 15 3 14.5523 3 14V4C3 3.44772 3.44772 3 4 3H14ZM13 5H5V13H13V5Z"
  }));
},
    P4 = function P4(_ref247) {
  var _ref247$color = _ref247.color,
      C = _ref247$color === void 0 ? "currentColor" : _ref247$color,
      _ref247$size = _ref247.size,
      e = _ref247$size === void 0 ? 24 : _ref247$size,
      l = _ref247.className,
      i = _objectWithoutProperties(_ref247, _excluded247);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11 3C11.5523 3 12 3.44772 12 4V6H17C17.5523 6 18 6.44772 18 7V12H20C20.5523 12 21 12.4477 21 13V20C21 20.5523 20.5523 21 20 21H13C12.4477 21 12 20.5523 12 20V18H7C6.44772 18 6 17.5523 6 17V12H4C3.44772 12 3 11.5523 3 11V4C3 3.44772 3.44772 3 4 3H11ZM16 8H8V16H16V8Z"
  }));
},
    D4 = function D4(_ref248) {
  var _ref248$color = _ref248.color,
      C = _ref248$color === void 0 ? "currentColor" : _ref248$color,
      _ref248$size = _ref248.size,
      e = _ref248$size === void 0 ? 24 : _ref248$size,
      l = _ref248.className,
      i = _objectWithoutProperties(_ref248, _excluded248);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4.92893 2.92896L6.34315 4.34317C4.89543 5.79088 4 7.79088 4 10C4 12.2092 4.89543 14.2092 6.34315 15.6569L4.92893 17.0711C3.11929 15.2614 2 12.7614 2 10C2 7.2386 3.11929 4.7386 4.92893 2.92896ZM19.0711 2.92896C20.8807 4.7386 22 7.2386 22 10C22 12.7614 20.8807 15.2614 19.0711 17.0711L17.6569 15.6569C19.1046 14.2092 20 12.2092 20 10C20 7.79088 19.1046 5.79088 17.6569 4.34317L19.0711 2.92896ZM7.75736 5.75738L9.17157 7.1716C8.44771 7.89545 8 8.89545 8 10C8 11.1046 8.44771 12.1046 9.17157 12.8285L7.75736 14.2427C6.67157 13.1569 6 11.6569 6 10C6 8.34317 6.67157 6.84317 7.75736 5.75738ZM16.2426 5.75738C17.3284 6.84317 18 8.34317 18 10C18 11.6569 17.3284 13.1569 16.2426 14.2427L14.8284 12.8285C15.5523 12.1046 16 11.1046 16 10C16 8.89545 15.5523 7.89545 14.8284 7.1716L16.2426 5.75738ZM12 12C10.8954 12 10 11.1046 10 10C10 8.89545 10.8954 8.00002 12 8.00002C13.1046 8.00002 14 8.89545 14 10C14 11.1046 13.1046 12 12 12ZM12 14C12.5798 14 13.0774 14.413 13.1843 14.9829L14.5 22H9.5L10.8157 14.9829C10.9226 14.413 11.4202 14 12 14Z"
  }));
},
    y4 = function y4(_ref249) {
  var _ref249$color = _ref249.color,
      C = _ref249$color === void 0 ? "currentColor" : _ref249$color,
      _ref249$size = _ref249.size,
      e = _ref249$size === void 0 ? 24 : _ref249$size,
      l = _ref249.className,
      i = _objectWithoutProperties(_ref249, _excluded249);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4.92893 2.92896L6.34315 4.34317C4.89543 5.79088 4 7.79088 4 10C4 12.2092 4.89543 14.2092 6.34315 15.6569L4.92893 17.0711C3.11929 15.2614 2 12.7614 2 10C2 7.2386 3.11929 4.7386 4.92893 2.92896ZM19.0711 2.92896C20.8807 4.7386 22 7.2386 22 10C22 12.7614 20.8807 15.2614 19.0711 17.0711L17.6569 15.6569C19.1046 14.2092 20 12.2092 20 10C20 7.79088 19.1046 5.79088 17.6569 4.34317L19.0711 2.92896ZM7.75736 5.75738L9.17157 7.1716C8.44771 7.89545 8 8.89545 8 10C8 11.1046 8.44771 12.1046 9.17157 12.8285L7.75736 14.2427C6.67157 13.1569 6 11.6569 6 10C6 8.34317 6.67157 6.84317 7.75736 5.75738ZM16.2426 5.75738C17.3284 6.84317 18 8.34317 18 10C18 11.6569 17.3284 13.1569 16.2426 14.2427L14.8284 12.8285C15.5523 12.1046 16 11.1046 16 10C16 8.89545 15.5523 7.89545 14.8284 7.1716L16.2426 5.75738ZM12 12C10.8954 12 10 11.1046 10 10C10 8.89545 10.8954 8.00002 12 8.00002C13.1046 8.00002 14 8.89545 14 10C14 11.1046 13.1046 12 12 12ZM11 14H13V22H11V14Z"
  }));
},
    b4 = function b4(_ref250) {
  var _ref250$color = _ref250.color,
      C = _ref250$color === void 0 ? "currentColor" : _ref250$color,
      _ref250$size = _ref250.size,
      e = _ref250$size === void 0 ? 24 : _ref250$size,
      l = _ref250.className,
      i = _objectWithoutProperties(_ref250, _excluded250);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16.5357 15.9465L18.657 13.8252L15.475 10.6432L19.0106 7.10768L16.8892 4.98636L13.3537 8.52189L10.1717 5.33991L8.05041 7.46123L16.5357 15.9465ZM13.3537 5.69346L16.1821 2.86504C16.5727 2.47451 17.2058 2.47451 17.5963 2.86504L21.1319 6.40057C21.5224 6.79109 21.5224 7.42426 21.1319 7.81478L18.3035 10.6432L20.7783 13.1181C21.1689 13.5086 21.1689 14.1418 20.7783 14.5323L13.0002 22.3105C12.6096 22.701 11.9765 22.701 11.5859 22.3105L1.68645 12.411C1.29592 12.0205 1.29592 11.3873 1.68645 10.9968L9.46462 3.21859C9.85515 2.82807 10.4883 2.82807 10.8788 3.21859L13.3537 5.69346Z"
  }));
},
    T4 = function T4(_ref251) {
  var _ref251$color = _ref251.color,
      C = _ref251$color === void 0 ? "currentColor" : _ref251$color,
      _ref251$size = _ref251.size,
      e = _ref251$size === void 0 ? 24 : _ref251$size,
      l = _ref251.className,
      i = _objectWithoutProperties(_ref251, _excluded251);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16.5357 15.9465L18.657 13.8252L15.475 10.6432L19.0106 7.10768L16.8892 4.98636L13.3537 8.52189L10.1717 5.33991L8.05041 7.46123L16.5357 15.9465ZM15.1215 17.3607L6.6362 8.87544L3.80777 11.7039L12.293 20.1892L15.1215 17.3607ZM13.3537 5.69346L16.1821 2.86504C16.5727 2.47451 17.2058 2.47451 17.5963 2.86504L21.1319 6.40057C21.5224 6.79109 21.5224 7.42426 21.1319 7.81478L18.3035 10.6432L20.7783 13.1181C21.1689 13.5086 21.1689 14.1418 20.7783 14.5323L13.0002 22.3105C12.6096 22.701 11.9765 22.701 11.5859 22.3105L1.68645 12.411C1.29592 12.0205 1.29592 11.3873 1.68645 10.9968L9.46462 3.21859C9.85515 2.82807 10.4883 2.82807 10.8788 3.21859L13.3537 5.69346Z"
  }));
},
    U4 = function U4(_ref252) {
  var _ref252$color = _ref252.color,
      C = _ref252$color === void 0 ? "currentColor" : _ref252$color,
      _ref252$size = _ref252.size,
      e = _ref252$size === void 0 ? 24 : _ref252$size,
      l = _ref252.className,
      i = _objectWithoutProperties(_ref252, _excluded252);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 10.9967V7.9967H14V3.9967H10V7.9967H4V10.9967H20ZM21 12.9967V20.9967C21 21.549 20.5523 21.9967 20 21.9967H10V15.9967H8V21.9967H4C3.44772 21.9967 3 21.549 3 20.9967V12.9967H2V6.9967C2 6.44442 2.44772 5.9967 3 5.9967H8V2.9967C8 2.44442 8.44772 1.9967 9 1.9967H15C15.5523 1.9967 16 2.44442 16 2.9967V5.9967H21C21.5523 5.9967 22 6.44442 22 6.9967V12.9967H21Z"
  }));
},
    G4 = function G4(_ref253) {
  var _ref253$color = _ref253.color,
      C = _ref253$color === void 0 ? "currentColor" : _ref253$color,
      _ref253$size = _ref253.size,
      e = _ref253$size === void 0 ? 24 : _ref253$size,
      l = _ref253.className,
      i = _objectWithoutProperties(_ref253, _excluded253);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8 19.9967V14.9967H10V19.9967H19V12.9967H5V19.9967H8ZM4 10.9967H20V7.9967H14V3.9967H10V7.9967H4V10.9967ZM3 20.9967V12.9967H2V6.9967C2 6.44442 2.44772 5.9967 3 5.9967H8V2.9967C8 2.44442 8.44772 1.9967 9 1.9967H15C15.5523 1.9967 16 2.44442 16 2.9967V5.9967H21C21.5523 5.9967 22 6.44442 22 6.9967V12.9967H21V20.9967C21 21.549 20.5523 21.9967 20 21.9967H4C3.44772 21.9967 3 21.549 3 20.9967Z"
  }));
},
    I4 = function I4(_ref254) {
  var _ref254$color = _ref254.color,
      C = _ref254$color === void 0 ? "currentColor" : _ref254$color,
      _ref254$size = _ref254.size,
      e = _ref254$size === void 0 ? 24 : _ref254$size,
      l = _ref254.className,
      i = _objectWithoutProperties(_ref254, _excluded254);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 15.9967H4V17.9967H20V15.9967ZM3 13.9967V3.9967C3 3.44442 3.44772 2.9967 4 2.9967H7V11.2694H9V2.9967H20C20.5523 2.9967 21 3.44442 21 3.9967V13.9967H22V18.9967C22 19.549 21.5523 19.9967 21 19.9967H13V22.9967H11V19.9967H3C2.44772 19.9967 2 19.549 2 18.9967V13.9967H3Z"
  }));
},
    W4 = function W4(_ref255) {
  var _ref255$color = _ref255.color,
      C = _ref255$color === void 0 ? "currentColor" : _ref255$color,
      _ref255$size = _ref255.size,
      e = _ref255$size === void 0 ? 24 : _ref255$size,
      l = _ref255.className,
      i = _objectWithoutProperties(_ref255, _excluded255);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9 4.9967V11.2694H7V4.9967H5V13.9967H19V4.9967H9ZM20 15.9967H4V17.9967H20V15.9967ZM3 13.9967V3.9967C3 3.44442 3.44772 2.9967 4 2.9967H20C20.5523 2.9967 21 3.44442 21 3.9967V13.9967H22V18.9967C22 19.549 21.5523 19.9967 21 19.9967H13V22.9967H11V19.9967H3C2.44772 19.9967 2 19.549 2 18.9967V13.9967H3Z"
  }));
},
    O4 = function O4(_ref256) {
  var _ref256$color = _ref256.color,
      C = _ref256$color === void 0 ? "currentColor" : _ref256$color,
      _ref256$size = _ref256.size,
      e = _ref256$size === void 0 ? 24 : _ref256$size,
      l = _ref256.className,
      i = _objectWithoutProperties(_ref256, _excluded256);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13.2886 6.21301L18.2278 2.37142C18.6259 2.0618 19.1922 2.09706 19.5488 2.45367L22.543 5.44787C22.8997 5.80448 22.9349 6.37082 22.6253 6.76891L18.7847 11.7068C19.0778 12.8951 19.0836 14.1721 18.7444 15.4379C17.8463 18.7897 14.8142 20.9986 11.5016 20.9986C8 20.9986 3.5 19.4967 1 17.9967C4.97978 14.9967 4.04722 13.1865 4.5 11.4967C5.55843 7.54658 9.34224 5.23935 13.2886 6.21301ZM16.7015 8.09161C16.7673 8.15506 16.8319 8.21964 16.8952 8.28533L18.0297 9.41984L20.5046 6.23786L18.7589 4.4921L15.5769 6.96698L16.7015 8.09161Z"
  }));
},
    K4 = function K4(_ref257) {
  var _ref257$color = _ref257.color,
      C = _ref257$color === void 0 ? "currentColor" : _ref257$color,
      _ref257$size = _ref257.size,
      e = _ref257$size === void 0 ? 24 : _ref257$size,
      l = _ref257.className,
      i = _objectWithoutProperties(_ref257, _excluded257);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15.4565 9.67503L15.3144 9.53297C14.6661 8.90796 13.8549 8.43369 12.9235 8.18412C10.0168 7.40527 7.22541 9.05273 6.43185 12.0143C6.38901 12.1742 6.36574 12.3537 6.3285 12.8051C6.17423 14.6752 5.73449 16.0697 4.5286 17.4842C6.78847 18.3727 9.46572 18.9986 11.5016 18.9986C13.9702 18.9986 16.1644 17.3394 16.8126 14.9202C17.3306 12.9869 16.7513 11.0181 15.4565 9.67503ZM13.2886 6.21301L18.2278 2.37142C18.6259 2.0618 19.1922 2.09706 19.5488 2.45367L22.543 5.44787C22.8997 5.80448 22.9349 6.37082 22.6253 6.76891L18.7847 11.7068C19.0778 12.8951 19.0836 14.1721 18.7444 15.4379C17.8463 18.7897 14.8142 20.9986 11.5016 20.9986C8 20.9986 3.5 19.4967 1 17.9967C4.97978 14.9967 4.04722 13.1865 4.5 11.4967C5.55843 7.54658 9.34224 5.23935 13.2886 6.21301ZM16.7015 8.09161C16.7673 8.15506 16.8319 8.21964 16.8952 8.28533L18.0297 9.41984L20.5046 6.23786L18.7589 4.4921L15.5769 6.96698L16.7015 8.09161Z"
  }));
},
    Q4 = function Q4(_ref258) {
  var _ref258$color = _ref258.color,
      C = _ref258$color === void 0 ? "currentColor" : _ref258$color,
      _ref258$size = _ref258.size,
      e = _ref258$size === void 0 ? 24 : _ref258$size,
      l = _ref258.className,
      i = _objectWithoutProperties(_ref258, _excluded258);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16 16C17.6569 16 19 17.3431 19 19C19 20.6569 17.6569 22 16 22C14.3431 22 13 20.6569 13 19C13 17.3431 14.3431 16 16 16ZM6 12C8.20914 12 10 13.7909 10 16C10 18.2091 8.20914 20 6 20C3.79086 20 2 18.2091 2 16C2 13.7909 3.79086 12 6 12ZM14.5 2C17.5376 2 20 4.46243 20 7.5C20 10.5376 17.5376 13 14.5 13C11.4624 13 9 10.5376 9 7.5C9 4.46243 11.4624 2 14.5 2Z"
  }));
},
    q4 = function q4(_ref259) {
  var _ref259$color = _ref259.color,
      C = _ref259$color === void 0 ? "currentColor" : _ref259$color,
      _ref259$size = _ref259.size,
      e = _ref259$size === void 0 ? 24 : _ref259$size,
      l = _ref259.className,
      i = _objectWithoutProperties(_ref259, _excluded259);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16 16C17.6569 16 19 17.3431 19 19C19 20.6569 17.6569 22 16 22C14.3431 22 13 20.6569 13 19C13 17.3431 14.3431 16 16 16ZM6 12C8.20914 12 10 13.7909 10 16C10 18.2091 8.20914 20 6 20C3.79086 20 2 18.2091 2 16C2 13.7909 3.79086 12 6 12ZM16 18C15.4477 18 15 18.4477 15 19C15 19.5523 15.4477 20 16 20C16.5523 20 17 19.5523 17 19C17 18.4477 16.5523 18 16 18ZM6 14C4.89543 14 4 14.8954 4 16C4 17.1046 4.89543 18 6 18C7.10457 18 8 17.1046 8 16C8 14.8954 7.10457 14 6 14ZM14.5 2C17.5376 2 20 4.46243 20 7.5C20 10.5376 17.5376 13 14.5 13C11.4624 13 9 10.5376 9 7.5C9 4.46243 11.4624 2 14.5 2ZM14.5 4C12.567 4 11 5.567 11 7.5C11 9.433 12.567 11 14.5 11C16.433 11 18 9.433 18 7.5C18 5.567 16.433 4 14.5 4Z"
  }));
},
    j4 = function j4(_ref260) {
  var _ref260$color = _ref260.color,
      C = _ref260$color === void 0 ? "currentColor" : _ref260$color,
      _ref260$size = _ref260.size,
      e = _ref260$size === void 0 ? 24 : _ref260$size,
      l = _ref260.className,
      i = _objectWithoutProperties(_ref260, _excluded260);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5.07089 16C5.02417 15.6734 5 15.3395 5 15V14H3V12H5V11C5 10.6605 5.02417 10.3266 5.07089 10H3V8.00001H5.67363C6.28647 6.70996 7.28227 5.6371 8.51412 4.92834L7.46447 3.87869L8.87868 2.46448L10.5621 4.14785C11.0262 4.05095 11.5071 4.00001 12 4.00001C12.4929 4.00001 12.9738 4.05095 13.4379 4.14785L15.1213 2.46448L16.5355 3.87869L15.4859 4.92834C16.7177 5.6371 17.7135 6.70996 18.3264 8.00001H21V10H18.9291C18.9758 10.3266 19 10.6605 19 11V12H21V14H19V15C19 15.3395 18.9758 15.6734 18.9291 16H21V18H18.3264C17.2029 20.365 14.7924 22 12 22C9.2076 22 6.7971 20.365 5.67363 18H3V16H5.07089ZM9 10V12H15V10H9ZM9 14V16H15V14H9Z"
  }));
},
    X4 = function X4(_ref261) {
  var _ref261$color = _ref261.color,
      C = _ref261$color === void 0 ? "currentColor" : _ref261$color,
      _ref261$size = _ref261.size,
      e = _ref261$size === void 0 ? 24 : _ref261$size,
      l = _ref261.className,
      i = _objectWithoutProperties(_ref261, _excluded261);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10.5621 4.14785C11.0262 4.05095 11.5071 4.00001 12 4.00001C12.4929 4.00001 12.9738 4.05095 13.4379 4.14785L15.1213 2.46448L16.5355 3.87869L15.4859 4.92834C16.7177 5.6371 17.7135 6.70996 18.3264 8.00001H21V10H18.9291C18.9758 10.3266 19 10.6605 19 11V12H21V14H19V15C19 15.3395 18.9758 15.6734 18.9291 16H21V18H18.3264C17.2029 20.365 14.7924 22 12 22C9.2076 22 6.7971 20.365 5.67363 18H3V16H5.07089C5.02417 15.6734 5 15.3395 5 15V14H3V12H5V11C5 10.6605 5.02417 10.3266 5.07089 10H3V8.00001H5.67363C6.28647 6.70996 7.28227 5.6371 8.51412 4.92834L7.46447 3.87869L8.87868 2.46448L10.5621 4.14785ZM12 6.00001C9.23858 6.00001 7 8.23859 7 11V15C7 17.7614 9.23858 20 12 20C14.7614 20 17 17.7614 17 15V11C17 8.23859 14.7614 6.00001 12 6.00001ZM9 14H15V16H9V14ZM9 10H15V12H9V10Z"
  }));
},
    J4 = function J4(_ref262) {
  var _ref262$color = _ref262.color,
      C = _ref262$color === void 0 ? "currentColor" : _ref262$color,
      _ref262$size = _ref262.size,
      e = _ref262$size === void 0 ? 24 : _ref262$size,
      l = _ref262.className,
      i = _objectWithoutProperties(_ref262, _excluded262);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.05636 8.30049C6.11995 8.19854 6.18609 8.09835 6.25469 8H17.7453C17.8139 8.09835 17.88 8.19854 17.9436 8.30049L19.9641 7.13397L20.9641 8.86602L18.7512 10.1436C18.9134 10.7348 19 11.3573 19 12V13H22V15H19C19 15.9534 18.8094 16.8623 18.4642 17.6907L20.9641 19.134L19.9641 20.866L17.4383 19.4077C16.3533 20.7447 14.7853 21.6737 13 21.9291V14H11V21.9291C9.21467 21.6737 7.64665 20.7447 6.56171 19.4077L4.0359 20.866L3.0359 19.134L5.5358 17.6907C5.19061 16.8623 5 15.9534 5 15H2V13H5V12C5 11.3573 5.08661 10.7348 5.2488 10.1436L3.0359 8.86602L4.0359 7.13397L6.05636 8.30049ZM8 6C8 3.79086 9.79086 2 12 2C14.2091 2 16 3.79086 16 6H8Z"
  }));
},
    Y4 = function Y4(_ref263) {
  var _ref263$color = _ref263.color,
      C = _ref263$color === void 0 ? "currentColor" : _ref263$color,
      _ref263$size = _ref263.size,
      e = _ref263$size === void 0 ? 24 : _ref263$size,
      l = _ref263.className,
      i = _objectWithoutProperties(_ref263, _excluded263);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13 19.9C15.2822 19.4367 17 17.419 17 15V12C17 11.299 16.8564 10.6219 16.5846 10H7.41538C7.14358 10.6219 7 11.299 7 12V15C7 17.419 8.71776 19.4367 11 19.9V14H13V19.9ZM5.5358 17.6907C5.19061 16.8623 5 15.9534 5 15H2V13H5V12C5 11.3573 5.08661 10.7348 5.2488 10.1436L3.0359 8.86602L4.0359 7.13397L6.05636 8.30049C6.11995 8.19854 6.18609 8.09835 6.25469 8H17.7453C17.8139 8.09835 17.88 8.19854 17.9436 8.30049L19.9641 7.13397L20.9641 8.86602L18.7512 10.1436C18.9134 10.7348 19 11.3573 19 12V13H22V15H19C19 15.9534 18.8094 16.8623 18.4642 17.6907L20.9641 19.134L19.9641 20.866L17.4383 19.4077C16.1549 20.9893 14.1955 22 12 22C9.80453 22 7.84512 20.9893 6.56171 19.4077L4.0359 20.866L3.0359 19.134L5.5358 17.6907ZM8 6C8 3.79086 9.79086 2 12 2C14.2091 2 16 3.79086 16 6H8Z"
  }));
},
    _4 = function _4(_ref264) {
  var _ref264$color = _ref264.color,
      C = _ref264$color === void 0 ? "currentColor" : _ref264$color,
      _ref264$size = _ref264.size,
      e = _ref264$size === void 0 ? 24 : _ref264$size,
      l = _ref264.className,
      i = _objectWithoutProperties(_ref264, _excluded264);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 19H14V6.00003L20.3939 8.74028C20.7616 8.89786 21 9.2594 21 9.65943V19H23V21H1V19H3V5.6499C3 5.25472 3.23273 4.89659 3.59386 4.73609L11.2969 1.31251C11.5493 1.20035 11.8448 1.314 11.9569 1.56634C11.9853 1.63027 12 1.69945 12 1.76941V19Z"
  }));
},
    $4 = function $4(_ref265) {
  var _ref265$color = _ref265.color,
      C = _ref265$color === void 0 ? "currentColor" : _ref265$color,
      _ref265$size = _ref265.size,
      e = _ref265$size === void 0 ? 24 : _ref265$size,
      l = _ref265.className,
      i = _objectWithoutProperties(_ref265, _excluded265);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 19V5.70046C3 5.27995 3.26307 4.90437 3.65826 4.76067L13.3291 1.24398C13.5886 1.14961 13.8755 1.28349 13.9699 1.54301C13.9898 1.59778 14 1.65561 14 1.71388V6.6667L20.3162 8.77211C20.7246 8.90822 21 9.29036 21 9.72079V19H23V21H1V19H3ZM5 19H12V3.85543L5 6.40089V19ZM19 19V10.4416L14 8.77488V19H19Z"
  }));
},
    e5 = function e5(_ref266) {
  var _ref266$color = _ref266.color,
      C = _ref266$color === void 0 ? "currentColor" : _ref266$color,
      _ref266$size = _ref266.size,
      e = _ref266$size === void 0 ? 24 : _ref266$size,
      l = _ref266.className,
      i = _objectWithoutProperties(_ref266, _excluded266);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10 10.1111V1L21 7V21H3V7L10 10.1111Z"
  }));
},
    t5 = function t5(_ref267) {
  var _ref267$color = _ref267.color,
      C = _ref267$color === void 0 ? "currentColor" : _ref267$color,
      _ref267$size = _ref267.size,
      e = _ref267$size === void 0 ? 24 : _ref267$size,
      l = _ref267.className,
      i = _objectWithoutProperties(_ref267, _excluded267);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10 10.1111V1L21 7V21H3V7L10 10.1111ZM12 4.36908V13.1886L5 10.0775V19H19V8.18727L12 4.36908Z"
  }));
},
    C5 = function C5(_ref268) {
  var _ref268$color = _ref268.color,
      C = _ref268$color === void 0 ? "currentColor" : _ref268$color,
      _ref268$size = _ref268.size,
      e = _ref268$size === void 0 ? 24 : _ref268$size,
      l = _ref268.className,
      i = _objectWithoutProperties(_ref268, _excluded268);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 20H23V22H1V20H3V3C3 2.44772 3.44772 2 4 2H20C20.5523 2 21 2.44772 21 3V20ZM8 11V13H11V11H8ZM8 7V9H11V7H8ZM8 15V17H11V15H8ZM13 15V17H16V15H13ZM13 11V13H16V11H13ZM13 7V9H16V7H13Z"
  }));
},
    l5 = function l5(_ref269) {
  var _ref269$color = _ref269.color,
      C = _ref269$color === void 0 ? "currentColor" : _ref269$color,
      _ref269$size = _ref269.size,
      e = _ref269$size === void 0 ? 24 : _ref269$size,
      l = _ref269.className,
      i = _objectWithoutProperties(_ref269, _excluded269);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 20H23V22H1V20H3V3C3 2.44772 3.44772 2 4 2H20C20.5523 2 21 2.44772 21 3V20ZM19 20V4H5V20H19ZM8 11H11V13H8V11ZM8 7H11V9H8V7ZM8 15H11V17H8V15ZM13 15H16V17H13V15ZM13 11H16V13H13V11ZM13 7H16V9H13V7Z"
  }));
},
    i5 = function i5(_ref270) {
  var _ref270$color = _ref270.color,
      C = _ref270$color === void 0 ? "currentColor" : _ref270$color,
      _ref270$size = _ref270.size,
      e = _ref270$size === void 0 ? 24 : _ref270$size,
      l = _ref270.className,
      i = _objectWithoutProperties(_ref270, _excluded270);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 19H23V21H1V19H3V4C3 3.44772 3.44772 3 4 3H14C14.5523 3 15 3.44772 15 4V19H17V9H20C20.5523 9 21 9.44772 21 10V19ZM7 11V13H11V11H7ZM7 7V9H11V7H7Z"
  }));
},
    s5 = function s5(_ref271) {
  var _ref271$color = _ref271.color,
      C = _ref271$color === void 0 ? "currentColor" : _ref271$color,
      _ref271$size = _ref271.size,
      e = _ref271$size === void 0 ? 24 : _ref271$size,
      l = _ref271.className,
      i = _objectWithoutProperties(_ref271, _excluded271);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 19H23V21H1V19H3V4C3 3.44772 3.44772 3 4 3H14C14.5523 3 15 3.44772 15 4V19H19V11H17V9H20C20.5523 9 21 9.44772 21 10V19ZM5 5V19H13V5H5ZM7 11H11V13H7V11ZM7 7H11V9H7V7Z"
  }));
},
    r5 = function r5(_ref272) {
  var _ref272$color = _ref272.color,
      C = _ref272$color === void 0 ? "currentColor" : _ref272$color,
      _ref272$size = _ref272.size,
      e = _ref272$size === void 0 ? 24 : _ref272$size,
      l = _ref272.className,
      i = _objectWithoutProperties(_ref272, _excluded272);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17 20H7V21C7 21.5523 6.55228 22 6 22H4C3.44772 22 3 21.5523 3 21V12H2V8H3V5C3 3.89543 3.89543 3 5 3H19C20.1046 3 21 3.89543 21 5V8H22V12H21V21C21 21.5523 20.5523 22 20 22H18C17.4477 22 17 21.5523 17 21V20ZM5 5V12H19V5H5ZM7.5 18C8.32843 18 9 17.3284 9 16.5C9 15.6716 8.32843 15 7.5 15C6.67157 15 6 15.6716 6 16.5C6 17.3284 6.67157 18 7.5 18ZM16.5 18C17.3284 18 18 17.3284 18 16.5C18 15.6716 17.3284 15 16.5 15C15.6716 15 15 15.6716 15 16.5C15 17.3284 15.6716 18 16.5 18Z"
  }));
},
    c5 = function c5(_ref273) {
  var _ref273$color = _ref273.color,
      C = _ref273$color === void 0 ? "currentColor" : _ref273$color,
      _ref273$size = _ref273.size,
      e = _ref273$size === void 0 ? 24 : _ref273$size,
      l = _ref273.className,
      i = _objectWithoutProperties(_ref273, _excluded273);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17 20H7V21C7 21.5523 6.55228 22 6 22H4C3.44772 22 3 21.5523 3 21V12H2V8H3V5C3 3.89543 3.89543 3 5 3H19C20.1046 3 21 3.89543 21 5V8H22V12H21V21C21 21.5523 20.5523 22 20 22H18C17.4477 22 17 21.5523 17 21V20ZM5 5V11H19V5H5ZM19 13H5V18H19V13ZM7.5 17C6.67157 17 6 16.3284 6 15.5C6 14.6716 6.67157 14 7.5 14C8.32843 14 9 14.6716 9 15.5C9 16.3284 8.32843 17 7.5 17ZM16.5 17C15.6716 17 15 16.3284 15 15.5C15 14.6716 15.6716 14 16.5 14C17.3284 14 18 14.6716 18 15.5C18 16.3284 17.3284 17 16.5 17Z"
  }));
},
    o5 = function o5(_ref274) {
  var _ref274$color = _ref274.color,
      C = _ref274$color === void 0 ? "currentColor" : _ref274$color,
      _ref274$size = _ref274.size,
      e = _ref274$size === void 0 ? 24 : _ref274$size,
      l = _ref274.className,
      i = _objectWithoutProperties(_ref274, _excluded274);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17 20H7V21C7 21.5523 6.55228 22 6 22H5C4.44772 22 4 21.5523 4 21V20H3V12H2V8H3V5C3 3.89543 3.89543 3 5 3H19C20.1046 3 21 3.89543 21 5V8H22V12H21V20H20V21C20 21.5523 19.5523 22 19 22H18C17.4477 22 17 21.5523 17 21V20ZM5 5V14H19V5H5ZM5 16V18H9V16H5ZM15 16V18H19V16H15Z"
  }));
},
    a5 = function a5(_ref275) {
  var _ref275$color = _ref275.color,
      C = _ref275$color === void 0 ? "currentColor" : _ref275$color,
      _ref275$size = _ref275.size,
      e = _ref275$size === void 0 ? 24 : _ref275$size,
      l = _ref275.className,
      i = _objectWithoutProperties(_ref275, _excluded275);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17 20H7V21C7 21.5523 6.55228 22 6 22H5C4.44772 22 4 21.5523 4 21V20H3V12H2V8H3V5C3 3.89543 3.89543 3 5 3H19C20.1046 3 21 3.89543 21 5V8H22V12H21V20H20V21C20 21.5523 19.5523 22 19 22H18C17.4477 22 17 21.5523 17 21V20ZM19 12V5H5V12H19ZM19 14H5V18H19V14ZM6 15H10V17H6V15ZM14 15H18V17H14V15Z"
  }));
},
    n5 = function n5(_ref276) {
  var _ref276$color = _ref276.color,
      C = _ref276$color === void 0 ? "currentColor" : _ref276$color,
      _ref276$size = _ref276.size,
      e = _ref276$size === void 0 ? 24 : _ref276$size,
      l = _ref276.className,
      i = _objectWithoutProperties(_ref276, _excluded276);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 3V5H5V14H19V12H21V20H20V21C20 21.5523 19.5523 22 19 22H18C17.4477 22 17 21.5523 17 21V20H7V21C7 21.5523 6.55228 22 6 22H5C4.44772 22 4 21.5523 4 21V20H3V12H2V8H3V5C3 3.89543 3.89543 3 5 3H12ZM9 16H5V18H9V16ZM19 16H15V18H19V16ZM18.5 1C20.9853 1 23 3.01472 23 5.5C23 7.98528 20.9853 10 18.5 10C16.0147 10 14 7.98528 14 5.5C14 3.01472 16.0147 1 18.5 1ZM18.4998 6.16667C18.0089 6.16667 17.5593 6.34354 17.2113 6.63704L17.0856 6.75245L18.4998 8.16667L19.9131 6.7515C19.5512 6.39013 19.0516 6.16667 18.4998 6.16667ZM18.4998 3.5C17.2966 3.5 16.1998 3.95536 15.3722 4.70316L15.199 4.86781L16.1428 5.80964C16.746 5.20643 17.5794 4.83333 18.4998 4.83333C19.3436 4.83333 20.1141 5.14684 20.7013 5.66372L20.8569 5.80964L21.7997 4.86684C20.9552 4.02233 19.7885 3.5 18.4998 3.5Z"
  }));
},
    m5 = function m5(_ref277) {
  var _ref277$color = _ref277.color,
      C = _ref277$color === void 0 ? "currentColor" : _ref277$color,
      _ref277$size = _ref277.size,
      e = _ref277$size === void 0 ? 24 : _ref277$size,
      l = _ref277.className,
      i = _objectWithoutProperties(_ref277, _excluded277);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 3V5H5V12H21V20H20V21C20 21.5523 19.5523 22 19 22H18C17.4477 22 17 21.5523 17 21V20H7V21C7 21.5523 6.55228 22 6 22H5C4.44772 22 4 21.5523 4 21V20H3V12H2V8H3V5C3 3.89543 3.89543 3 5 3H12ZM19 14H5V18H19V14ZM10 15V17H6V15H10ZM18 15V17H14V15H18ZM18.5 1C20.9853 1 23 3.01472 23 5.5C23 7.98528 20.9853 10 18.5 10C16.0147 10 14 7.98528 14 5.5C14 3.01472 16.0147 1 18.5 1ZM18.4998 6.16667C18.0089 6.16667 17.5593 6.34354 17.2113 6.63704L17.0856 6.75245L18.4998 8.16667L19.9131 6.7515C19.5512 6.39013 19.0516 6.16667 18.4998 6.16667ZM18.4998 3.5C17.2966 3.5 16.1998 3.95536 15.3722 4.70316L15.199 4.86781L16.1428 5.80964C16.746 5.20643 17.5794 4.83333 18.4998 4.83333C19.3436 4.83333 20.1141 5.14684 20.7013 5.66372L20.8569 5.80964L21.7997 4.86684C20.9552 4.02233 19.7885 3.5 18.4998 3.5Z"
  }));
},
    w5 = function w5(_ref278) {
  var _ref278$color = _ref278.color,
      C = _ref278$color === void 0 ? "currentColor" : _ref278$color,
      _ref278$size = _ref278.size,
      e = _ref278$size === void 0 ? 24 : _ref278$size,
      l = _ref278.className,
      i = _objectWithoutProperties(_ref278, _excluded278);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11.998 2C14.2072 2 15.998 3.79086 15.998 6V15H16.998C17.5476 15 17.998 14.55 17.998 14V8C17.998 7.44772 18.4458 7 18.998 7C19.5503 7 19.998 7.44772 19.998 8V14C19.998 15.6569 18.6549 17 16.998 17H15.998V20H17.998V22H5.99805V20H7.99805V14H6.99805C5.34119 14 3.99805 12.6569 3.99805 11V9C3.99805 8.44772 4.44576 8 4.99805 8C5.55033 8 5.99805 8.44772 5.99805 9V11C5.99805 11.55 6.44805 12 6.99805 12C7.36471 12 7.69805 12 7.99805 12V6C7.99805 3.79086 9.78891 2 11.998 2Z"
  }));
},
    L5 = function L5(_ref279) {
  var _ref279$color = _ref279.color,
      C = _ref279$color === void 0 ? "currentColor" : _ref279$color,
      _ref279$size = _ref279.size,
      e = _ref279$size === void 0 ? 24 : _ref279$size,
      l = _ref279.className,
      i = _objectWithoutProperties(_ref279, _excluded279);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11.998 2C14.2072 2 15.998 3.79086 15.998 6V15H16.998C17.548 15 17.998 14.55 17.998 14V8C17.998 7.44772 18.4458 7 18.998 7C19.5503 7 19.998 7.44772 19.998 8V14C19.998 15.66 18.658 17 16.998 17H15.998V20H17.998V22H5.99805V20H7.99805V14H6.99805C5.34119 14 3.99805 12.6569 3.99805 11V9C3.99805 8.44772 4.44576 8 4.99805 8C5.55033 8 5.99805 8.44772 5.99805 9V11C5.99805 11.55 6.44805 12 6.99805 12H7.99805V6C7.99805 3.79086 9.78891 2 11.998 2ZM11.998 4C10.8935 4 9.99805 4.89543 9.99805 6V20H13.998V6C13.998 4.89543 13.1026 4 11.998 4Z"
  }));
},
    h5 = function h5(_ref280) {
  var _ref280$color = _ref280.color,
      C = _ref280$color === void 0 ? "currentColor" : _ref280$color,
      _ref280$size = _ref280.size,
      e = _ref280$size === void 0 ? 24 : _ref280$size,
      l = _ref280.className,
      i = _objectWithoutProperties(_ref280, _excluded280);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8 6V9.999H11V6H13V9.999H16V6H18V9.999L19 10C20.5977 10 21.9037 11.2489 21.9949 12.8237L22 13V14C22 15.0139 21.6227 15.9397 21.001 16.6447L21 21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21L2.99917 16.6401C2.47812 16.0464 2.12795 15.2943 2.02793 14.4584L2.00551 14.2052L2 14V13C2 11.4023 3.24892 10.0963 4.82373 10.0051L5 10L6 9.999V6H8ZM19 12H5C4.48716 12 4.06449 12.386 4.00673 12.8834L4 13L3.99958 13.9711L4.00342 14.1184C4.06444 15.1715 4.93934 16 6 16C7.00762 16 7.84761 15.2523 7.98033 14.2995L7.99532 14.1474L8.00042 13.9711C8.03649 12.7225 9.82713 12.6779 9.98853 13.8373L9.99958 13.9711L10.0034 14.1184C10.0644 15.1715 10.9393 16 12 16C13.0544 16 13.9182 15.1841 13.9945 14.1493L14.007 13.8668C14.131 12.7111 15.869 12.7111 15.993 13.8668L16.0055 14.1493C16.0818 15.1841 16.9456 16 18 16C19.0544 16 19.9182 15.1841 19.9945 14.1493L20 14V13C20 12.4872 19.614 12.0645 19.1166 12.0067L19 12ZM7 1C8.31948 1.87119 8.6633 3.08803 8.44889 3.88823C8.23448 4.68843 7.41197 5.1633 6.61177 4.94889C5.81157 4.73448 5.3367 3.91197 5.55111 3.11177C5.84871 2.00111 7 2.5 7 1ZM12 1C13.3195 1.87119 13.6633 3.08803 13.4489 3.88823C13.2345 4.68843 12.412 5.1633 11.6118 4.94889C10.8116 4.73448 10.3367 3.91197 10.5511 3.11177C10.8487 2.00111 12 2.5 12 1ZM17 1C18.3195 1.87119 18.6633 3.08803 18.4489 3.88823C18.2345 4.68843 17.412 5.1633 16.6118 4.94889C15.8116 4.73448 15.3367 3.91197 15.5511 3.11177C15.8487 2.00111 17 2.5 17 1Z"
  }));
},
    H5 = function H5(_ref281) {
  var _ref281$color = _ref281.color,
      C = _ref281$color === void 0 ? "currentColor" : _ref281$color,
      _ref281$size = _ref281.size,
      e = _ref281$size === void 0 ? 24 : _ref281$size,
      l = _ref281.className,
      i = _objectWithoutProperties(_ref281, _excluded281);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8 6V9.999H11V6H13V9.999H16V6H18V9.999L19 10C20.5977 10 21.9037 11.2489 21.9949 12.8237L22 13V14C22 15.0139 21.6227 15.9397 21.001 16.6447L21 21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21L2.99917 16.6401C2.47812 16.0464 2.12795 15.2943 2.02793 14.4584L2.00551 14.2052L2 14V13C2 11.4023 3.24892 10.0963 4.82373 10.0051L5 10L6 9.999V6H8ZM9.002 16.641L8.94768 16.7041C8.30742 17.4013 7.42357 17.8697 6.43424 17.9767L6.20413 17.9949L6 18C5.65524 18 5.32032 17.9563 5.00061 17.8738L5 20H19L19.0008 17.8738C18.6809 17.9562 18.3456 18 18 18C16.9378 18 15.9724 17.586 15.2561 16.9106L15.1065 16.7619L15 16.644L14.8935 16.7619C14.2607 17.4246 13.4024 17.8703 12.4418 17.9759L12.1996 17.9951L12 18C10.914 18 9.92563 17.5661 9.20287 16.8557L9.05211 16.6993L9.002 16.641ZM19 12H5C4.48716 12 4.06449 12.386 4.00673 12.8834L4 13L3.99958 13.9711L4.00342 14.1184C4.06444 15.1715 4.93934 16 6 16C7.00762 16 7.84761 15.2523 7.98033 14.2995L7.99532 14.1474L8.00042 13.9711C8.03649 12.7225 9.82713 12.6779 9.98853 13.8373L9.99958 13.9711L10.0034 14.1184C10.0644 15.1715 10.9393 16 12 16C13.0544 16 13.9182 15.1841 13.9945 14.1493L14.007 13.8668C14.131 12.7111 15.869 12.7111 15.993 13.8668L16.0055 14.1493C16.0818 15.1841 16.9456 16 18 16C19.0544 16 19.9182 15.1841 19.9945 14.1493L20 14V13C20 12.4872 19.614 12.0645 19.1166 12.0067L19 12ZM7 1C8.31948 1.87119 8.6633 3.08803 8.44889 3.88823C8.23448 4.68843 7.41197 5.1633 6.61177 4.94889C5.81157 4.73448 5.3367 3.91197 5.55111 3.11177C5.84871 2.00111 7 2.5 7 1ZM12 1C13.3195 1.87119 13.6633 3.08803 13.4489 3.88823C13.2345 4.68843 12.412 5.1633 11.6118 4.94889C10.8116 4.73448 10.3367 3.91197 10.5511 3.11177C10.8487 2.00111 12 2.5 12 1ZM17 1C18.3195 1.87119 18.6633 3.08803 18.4489 3.88823C18.2345 4.68843 17.412 5.1633 16.6118 4.94889C15.8116 4.73448 15.3367 3.91197 15.5511 3.11177C15.8487 2.00111 17 2.5 17 1Z"
  }));
},
    V5 = function V5(_ref282) {
  var _ref282$color = _ref282.color,
      C = _ref282$color === void 0 ? "currentColor" : _ref282$color,
      _ref282$size = _ref282.size,
      e = _ref282$size === void 0 ? 24 : _ref282$size,
      l = _ref282.className,
      i = _objectWithoutProperties(_ref282, _excluded282);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15.5 2C17.433 2 19 3.567 19 5.5C19 5.72679 18.9784 5.94854 18.9372 6.16332L18.9223 6.22941C20.7106 6.82471 22 8.51178 22 10.5C22 12.3741 20.8544 13.9806 19.2253 14.6574L18.1393 21.1644C18.0589 21.6466 17.6417 22 17.1529 22H6.84713C6.35829 22 5.9411 21.6466 5.86073 21.1644L4.832 14.994C3.24892 14.9037 2 13.5977 2 12C2 10.6926 2.83627 9.5806 4.00306 9.16963L4 9C4 5.68629 6.68629 3 10 3C10.9216 3 11.7947 3.20779 12.575 3.57908C13.1988 2.62827 14.276 2 15.5 2ZM11 15H9V20H11V15ZM15 15H13V20H15V15ZM17.5 13C18.8807 13 20 11.8807 20 10.5C20 9.11929 18.8807 8 17.5 8C17.1643 8 16.8417 8.06519 16.5442 8.18959L16.3688 8.27129C15.4021 8.76932 14.2253 8.40165 13.7059 7.46716L13.6362 7.32984C12.9876 5.92108 11.5778 5 10 5C7.8578 5 6.10892 6.68397 6.0046 8.76748L5.99967 8.96394L6.00273 9.13357C6.0173 9.94127 5.54534 10.6726 4.8166 10.9967L4.6675 11.056C4.27121 11.1956 4 11.5722 4 12C4 12.5523 4.44772 13 5 13H17.5Z"
  }));
},
    g5 = function g5(_ref283) {
  var _ref283$color = _ref283.color,
      C = _ref283$color === void 0 ? "currentColor" : _ref283$color,
      _ref283$size = _ref283.size,
      e = _ref283$size === void 0 ? 24 : _ref283$size,
      l = _ref283.className,
      i = _objectWithoutProperties(_ref283, _excluded283);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15.5 2C17.433 2 19 3.567 19 5.5C19 5.72679 18.9784 5.94854 18.9372 6.16332L18.9223 6.22941C20.7106 6.82471 22 8.51178 22 10.5C22 12.3741 20.8544 13.9806 19.2253 14.6574L18.1393 21.1644C18.0589 21.6466 17.6417 22 17.1529 22H6.84713C6.35829 22 5.9411 21.6466 5.86073 21.1644L4.832 14.994C3.24892 14.9037 2 13.5977 2 12C2 10.6926 2.83627 9.5806 4.00306 9.16963L4 9C4 5.68629 6.68629 3 10 3C10.9212 3 11.794 3.20761 12.574 3.5786C13.1984 2.62849 14.2758 2 15.5 2ZM9 15H6.86L7.694 20H9V15ZM13 15H11V20H13V15ZM17.139 15H15V20H16.305L17.139 15ZM10 5C7.8578 5 6.10892 6.68397 6.0046 8.76748L5.99967 8.96394L6.00273 9.13357C6.0173 9.94127 5.54534 10.6726 4.8166 10.9967L4.6675 11.056C4.27121 11.1956 4 11.5722 4 12C4 12.5523 4.44772 13 5 13H17.5C18.8807 13 20 11.8807 20 10.5C20 9.11929 18.8807 8 17.5 8C17.1643 8 16.8417 8.06519 16.5442 8.18959L16.3688 8.27129C15.4021 8.76932 14.2253 8.40165 13.7059 7.46716L13.6362 7.32984C12.9876 5.92108 11.5778 5 10 5ZM15.5 4C14.9536 4 14.4755 4.29211 14.2132 4.72868C14.7264 5.2345 15.1481 5.83144 15.4529 6.49336C15.8966 6.26481 16.3838 6.10867 16.8988 6.03984C16.9645 5.87263 17 5.69046 17 5.5C17 4.67157 16.3284 4 15.5 4Z"
  }));
},
    M5 = function M5(_ref284) {
  var _ref284$color = _ref284.color,
      C = _ref284$color === void 0 ? "currentColor" : _ref284$color,
      _ref284$size = _ref284.size,
      e = _ref284$size === void 0 ? 24 : _ref284$size,
      l = _ref284.className,
      i = _objectWithoutProperties(_ref284, _excluded284);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13 6.99993V10.9999L20 10.9999C20.5523 10.9999 21 11.4476 21 11.9999V19.9999L23 19.9999V21.9999H1V19.9999L3 19.9999V11.9999C3 11.4476 3.44772 10.9999 4 10.9999L11 10.9999V6.99993H13ZM13.8301 0.401855C14.6586 1.83673 14.1669 3.6715 12.7321 4.49993L11 5.49993C10.1716 4.06505 10.6632 2.23028 12.0981 1.40186L13.8301 0.401855Z"
  }));
},
    Z5 = function Z5(_ref285) {
  var _ref285$color = _ref285.color,
      C = _ref285$color === void 0 ? "currentColor" : _ref285$color,
      _ref285$size = _ref285.size,
      e = _ref285$size === void 0 ? 24 : _ref285$size,
      l = _ref285.className,
      i = _objectWithoutProperties(_ref285, _excluded285);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13 6.99993V10.9999L20 10.9999C20.5523 10.9999 21 11.4476 21 11.9999V19.9999L23 19.9999V21.9999H1V19.9999L3 19.9999V11.9999C3 11.4476 3.44772 10.9999 4 10.9999L11 10.9999V6.99993H13ZM19 12.9999H5V19.9999H19V12.9999ZM13.8301 0.401855C14.6586 1.83673 14.1669 3.6715 12.7321 4.49993L11 5.49993C10.1716 4.06505 10.6632 2.23028 12.0981 1.40186L13.8301 0.401855Z"
  }));
},
    x5 = function x5(_ref286) {
  var _ref286$color = _ref286.color,
      C = _ref286$color === void 0 ? "currentColor" : _ref286$color,
      _ref286$size = _ref286.size,
      e = _ref286$size === void 0 ? 24 : _ref286$size,
      l = _ref286.className,
      i = _objectWithoutProperties(_ref286, _excluded286);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 2H20C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V3C3 2.44772 3.44772 2 4 2ZM7 12V14H9V12H7ZM7 16V18H9V16H7ZM11 12V14H13V12H11ZM11 16V18H13V16H11ZM15 12V18H17V12H15ZM7 6V10H17V6H7Z"
  }));
},
    v5 = function v5(_ref287) {
  var _ref287$color = _ref287.color,
      C = _ref287$color === void 0 ? "currentColor" : _ref287$color,
      _ref287$size = _ref287.size,
      e = _ref287$size === void 0 ? 24 : _ref287$size,
      l = _ref287.className,
      i = _objectWithoutProperties(_ref287, _excluded287);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 2H20C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V3C3 2.44772 3.44772 2 4 2ZM5 4V20H19V4H5ZM7 6H17V10H7V6ZM7 12H9V14H7V12ZM7 16H9V18H7V16ZM11 12H13V14H11V12ZM11 16H13V18H11V16ZM15 12H17V18H15V12Z"
  }));
},
    d5 = function d5(_ref288) {
  var _ref288$color = _ref288.color,
      C = _ref288$color === void 0 ? "currentColor" : _ref288$color,
      _ref288$size = _ref288.size,
      e = _ref288$size === void 0 ? 24 : _ref288$size,
      l = _ref288.className,
      i = _objectWithoutProperties(_ref288, _excluded288);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H7V1H9V3H15V1H17V3ZM4 9V19H20V9H4ZM6 11H8V13H6V11ZM11 11H13V13H11V11ZM16 11H18V13H16V11Z"
  }));
},
    p5 = function p5(_ref289) {
  var _ref289$color = _ref289.color,
      C = _ref289$color === void 0 ? "currentColor" : _ref289$color,
      _ref289$size = _ref289.size,
      e = _ref289$size === void 0 ? 24 : _ref289$size,
      l = _ref289.className,
      i = _objectWithoutProperties(_ref289, _excluded289);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9 1V3H15V1H17V3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H7V1H9ZM20 11H4V19H20V11ZM8 13V15H6V13H8ZM13 13V15H11V13H13ZM18 13V15H16V13H18ZM7 5H4V9H20V5H17V7H15V5H9V7H7V5Z"
  }));
},
    E5 = function E5(_ref290) {
  var _ref290$color = _ref290.color,
      C = _ref290$color === void 0 ? "currentColor" : _ref290$color,
      _ref290$size = _ref290.size,
      e = _ref290$size === void 0 ? 24 : _ref290$size,
      l = _ref290.className,
      i = _objectWithoutProperties(_ref290, _excluded290);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9 1V3H15V1H17V3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H7V1H9ZM20 8H4V19H20V8ZM15.0355 10.136L16.4497 11.5503L11.5 16.5L7.96447 12.9645L9.37868 11.5503L11.5 13.6716L15.0355 10.136Z"
  }));
},
    N5 = function N5(_ref291) {
  var _ref291$color = _ref291.color,
      C = _ref291$color === void 0 ? "currentColor" : _ref291$color,
      _ref291$size = _ref291.size,
      e = _ref291$size === void 0 ? 24 : _ref291$size,
      l = _ref291.className,
      i = _objectWithoutProperties(_ref291, _excluded291);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9 1V3H15V1H17V3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H7V1H9ZM20 10H4V19H20V10ZM15.0355 11.136L16.4497 12.5503L11.5 17.5L7.96447 13.9645L9.37868 12.5503L11.5 14.6716L15.0355 11.136ZM7 5H4V8H20V5H17V6H15V5H9V6H7V5Z"
  }));
},
    u5 = function u5(_ref292) {
  var _ref292$color = _ref292.color,
      C = _ref292$color === void 0 ? "currentColor" : _ref292$color,
      _ref292$size = _ref292.size,
      e = _ref292$size === void 0 ? 24 : _ref292$size,
      l = _ref292.className,
      i = _objectWithoutProperties(_ref292, _excluded292);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H7V1H9V3H15V1H17V3ZM4 9V19H20V9H4ZM6 13H11V17H6V13Z"
  }));
},
    B5 = function B5(_ref293) {
  var _ref293$color = _ref293.color,
      C = _ref293$color === void 0 ? "currentColor" : _ref293$color,
      _ref293$size = _ref293.size,
      e = _ref293$size === void 0 ? 24 : _ref293$size,
      l = _ref293.className,
      i = _objectWithoutProperties(_ref293, _excluded293);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9 1V3H15V1H17V3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H7V1H9ZM20 11H4V19H20V11ZM11 13V17H6V13H11ZM7 5H4V9H20V5H17V7H15V5H9V7H7V5Z"
  }));
},
    f5 = function f5(_ref294) {
  var _ref294$color = _ref294.color,
      C = _ref294$color === void 0 ? "currentColor" : _ref294$color,
      _ref294$size = _ref294.size,
      e = _ref294$size === void 0 ? 24 : _ref294$size,
      l = _ref294.className,
      i = _objectWithoutProperties(_ref294, _excluded294);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 11H22V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V11ZM17 3H21C21.5523 3 22 3.44772 22 4V9H2V4C2 3.44772 2.44772 3 3 3H7V1H9V3H15V1H17V3Z"
  }));
},
    R5 = function R5(_ref295) {
  var _ref295$color = _ref295.color,
      C = _ref295$color === void 0 ? "currentColor" : _ref295$color,
      _ref295$size = _ref295.size,
      e = _ref295$size === void 0 ? 24 : _ref295$size,
      l = _ref295.className,
      i = _objectWithoutProperties(_ref295, _excluded295);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9 1V3H15V1H17V3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H7V1H9ZM20 11H4V19H20V11ZM7 5H4V9H20V5H17V7H15V5H9V7H7V5Z"
  }));
},
    z5 = function z5(_ref296) {
  var _ref296$color = _ref296.color,
      C = _ref296$color === void 0 ? "currentColor" : _ref296$color,
      _ref296$size = _ref296.size,
      e = _ref296$size === void 0 ? 24 : _ref296$size,
      l = _ref296.className,
      i = _objectWithoutProperties(_ref296, _excluded296);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H7V1H9V3H15V1H17V3ZM4 9V19H20V9H4ZM6 11H8V13H6V11ZM6 15H8V17H6V15ZM10 11H18V13H10V11ZM10 15H15V17H10V15Z"
  }));
},
    F5 = function F5(_ref297) {
  var _ref297$color = _ref297.color,
      C = _ref297$color === void 0 ? "currentColor" : _ref297$color,
      _ref297$size = _ref297.size,
      e = _ref297$size === void 0 ? 24 : _ref297$size,
      l = _ref297.className,
      i = _objectWithoutProperties(_ref297, _excluded297);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9 1V3H15V1H17V3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H7V1H9ZM20 11H4V19H20V11ZM8 14V16H6V14H8ZM18 14V16H10V14H18ZM7 5H4V9H20V5H17V7H15V5H9V7H7V5Z"
  }));
},
    S5 = function S5(_ref298) {
  var _ref298$color = _ref298.color,
      C = _ref298$color === void 0 ? "currentColor" : _ref298$color,
      _ref298$size = _ref298.size,
      e = _ref298$size === void 0 ? 24 : _ref298$size,
      l = _ref298.className,
      i = _objectWithoutProperties(_ref298, _excluded298);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 3.9934C2 3.44476 2.45531 3 2.9918 3H21.0082C21.556 3 22 3.44495 22 3.9934V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5551 2 20.0066V3.9934ZM12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12C15 13.6569 13.6569 15 12 15ZM12 17C14.7614 17 17 14.7614 17 12C17 9.23858 14.7614 7 12 7C9.23858 7 7 9.23858 7 12C7 14.7614 9.23858 17 12 17ZM18 5V7H20V5H18Z"
  }));
},
    A5 = function A5(_ref299) {
  var _ref299$color = _ref299.color,
      C = _ref299$color === void 0 ? "currentColor" : _ref299$color,
      _ref299$size = _ref299.size,
      e = _ref299$size === void 0 ? 24 : _ref299$size,
      l = _ref299.className,
      i = _objectWithoutProperties(_ref299, _excluded299);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 3.9934C2 3.44476 2.45531 3 2.9918 3H21.0082C21.556 3 22 3.44495 22 3.9934V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5551 2 20.0066V3.9934ZM4 5V19H20V5H4ZM12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15ZM12 17C9.23858 17 7 14.7614 7 12C7 9.23858 9.23858 7 12 7C14.7614 7 17 9.23858 17 12C17 14.7614 14.7614 17 12 17ZM17 6H19V8H17V6Z"
  }));
},
    k5 = function k5(_ref300) {
  var _ref300$color = _ref300.color,
      C = _ref300$color === void 0 ? "currentColor" : _ref300$color,
      _ref300$size = _ref300.size,
      e = _ref300$size === void 0 ? 24 : _ref300$size,
      l = _ref300.className,
      i = _objectWithoutProperties(_ref300, _excluded300);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 6.00087C2 5.44811 2.45531 5 2.9918 5H21.0082C21.556 5 22 5.44463 22 6.00087V19.9991C22 20.5519 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5554 2 19.9991V6.00087ZM14 18C16.7614 18 19 15.7614 19 13C19 10.2386 16.7614 8 14 8C11.2386 8 9 10.2386 9 13C9 15.7614 11.2386 18 14 18ZM4 7V9H7V7H4ZM4 2H10V4H4V2Z"
  }));
},
    P5 = function P5(_ref301) {
  var _ref301$color = _ref301.color,
      C = _ref301$color === void 0 ? "currentColor" : _ref301$color,
      _ref301$size = _ref301.size,
      e = _ref301$size === void 0 ? 24 : _ref301$size,
      l = _ref301.className,
      i = _objectWithoutProperties(_ref301, _excluded301);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 6.00087C2 5.44811 2.45531 5 2.9918 5H21.0082C21.556 5 22 5.44463 22 6.00087V19.9991C22 20.5519 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5554 2 19.9991V6.00087ZM4 7V19H20V7H4ZM14 16C15.6569 16 17 14.6569 17 13C17 11.3431 15.6569 10 14 10C12.3431 10 11 11.3431 11 13C11 14.6569 12.3431 16 14 16ZM14 18C11.2386 18 9 15.7614 9 13C9 10.2386 11.2386 8 14 8C16.7614 8 19 10.2386 19 13C19 15.7614 16.7614 18 14 18ZM4 2H10V4H4V2Z"
  }));
},
    D5 = function D5(_ref302) {
  var _ref302$color = _ref302.color,
      C = _ref302$color === void 0 ? "currentColor" : _ref302$color,
      _ref302$size = _ref302.size,
      e = _ref302$size === void 0 ? 24 : _ref302$size,
      l = _ref302.className,
      i = _objectWithoutProperties(_ref302, _excluded302);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9 3H15L17 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V6C2 5.44772 2.44772 5 3 5H7L9 3ZM12 19C15.3137 19 18 16.3137 18 13C18 9.68629 15.3137 7 12 7C8.68629 7 6 9.68629 6 13C6 16.3137 8.68629 19 12 19ZM12 17C9.79086 17 8 15.2091 8 13C8 10.7909 9.79086 9 12 9C14.2091 9 16 10.7909 16 13C16 15.2091 14.2091 17 12 17Z"
  }));
},
    y5 = function y5(_ref303) {
  var _ref303$color = _ref303.color,
      C = _ref303$color === void 0 ? "currentColor" : _ref303$color,
      _ref303$size = _ref303.size,
      e = _ref303$size === void 0 ? 24 : _ref303$size,
      l = _ref303.className,
      i = _objectWithoutProperties(_ref303, _excluded303);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9.82726 21.7633L14.3094 14L17.8413 20.1175C16.198 21.3021 14.1805 22 12 22C11.2538 22 10.5268 21.9183 9.82726 21.7633ZM7.88985 21.119C5.3115 19.955 3.31516 17.7297 2.4578 15H11.4226L7.88985 21.119ZM2.04938 13C2.01672 12.6711 2 12.3375 2 12C2 9.39284 2.99773 7.0187 4.6322 5.23859L9.11325 13H2.04938ZM6.15866 3.88251C7.80198 2.6979 9.81949 2 12 2C12.7462 2 13.4732 2.08172 14.1727 2.2367L9.6906 10L6.15866 3.88251ZM16.1101 2.88101C18.6885 4.04495 20.6848 6.27028 21.5422 9H12.5774L16.1101 2.88101ZM21.9506 11C21.9833 11.3289 22 11.6625 22 12C22 14.6072 21.0023 16.9813 19.3678 18.7614L14.8868 11H21.9506Z"
  }));
},
    b5 = function b5(_ref304) {
  var _ref304$color = _ref304.color,
      C = _ref304$color === void 0 ? "currentColor" : _ref304$color,
      _ref304$size = _ref304.size,
      e = _ref304$size === void 0 ? 24 : _ref304$size,
      l = _ref304.className,
      i = _objectWithoutProperties(_ref304, _excluded304);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9.85802 19.71L12 16H5.07026C6.10692 17.7921 7.8188 19.1447 9.85802 19.71ZM4.25204 14H8.5359L5.07103 7.99867C4.38987 9.17566 4 10.5423 4 12C4 12.6906 4.08751 13.3608 4.25204 14ZM6.39496 6.29179L8.5359 10L12 4C9.8171 4 7.8384 4.87429 6.39496 6.29179ZM14.142 4.28998L12 8H18.9297C17.8931 6.20791 16.1812 4.85529 14.142 4.28998ZM19.748 10H15.4641L18.929 16.0013C19.6101 14.8243 20 13.4577 20 12C20 11.3094 19.9125 10.6392 19.748 10ZM17.605 17.7082L15.4641 14L12 20C14.1829 20 16.1616 19.1257 17.605 17.7082ZM12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM13.1547 10H10.8453L9.6906 12L10.8453 14H13.1547L14.3094 12L13.1547 10Z"
  }));
},
    T5 = function T5(_ref305) {
  var _ref305$color = _ref305.color,
      C = _ref305$color === void 0 ? "currentColor" : _ref305$color,
      _ref305$size = _ref305.size,
      e = _ref305$size === void 0 ? 24 : _ref305$size,
      l = _ref305.className,
      i = _objectWithoutProperties(_ref305, _excluded305);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9.82843 5L7.82843 7H4V19H20V7H16.1716L14.1716 5H9.82843ZM9 3H15L17 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V6C2 5.44772 2.44772 5 3 5H7L9 3ZM12 18C8.96243 18 6.5 15.5376 6.5 12.5C6.5 9.46243 8.96243 7 12 7C15.0376 7 17.5 9.46243 17.5 12.5C17.5 15.5376 15.0376 18 12 18ZM12 16C13.933 16 15.5 14.433 15.5 12.5C15.5 10.567 13.933 9 12 9C10.067 9 8.5 10.567 8.5 12.5C8.5 14.433 10.067 16 12 16Z"
  }));
},
    U5 = function U5(_ref306) {
  var _ref306$color = _ref306.color,
      C = _ref306$color === void 0 ? "currentColor" : _ref306$color,
      _ref306$size = _ref306.size,
      e = _ref306$size === void 0 ? 24 : _ref306$size,
      l = _ref306.className,
      i = _objectWithoutProperties(_ref306, _excluded306);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19.5859 21H3.00016C2.44787 21 2.00016 20.5523 2.00016 20V6.00003C2.00016 5.44775 2.44787 5.00003 3.00016 5.00003H3.58594L1.39355 2.80765L2.80777 1.39343L22.6068 21.1924L21.1925 22.6066L19.5859 21ZM7.55544 8.96953C6.58902 10.0346 6.00016 11.4486 6.00016 13C6.00016 16.3137 8.68645 19 12.0002 19C13.5516 19 14.9656 18.4112 16.0307 17.4448L14.6139 16.028C13.9129 16.6337 12.9993 17 12.0002 17C9.79102 17 8.00016 15.2092 8.00016 13C8.00016 12.0009 8.36649 11.0873 8.97217 10.3863L7.55544 8.96953ZM22.0002 17.7858L17.9549 13.7406C17.9848 13.4979 18.0002 13.2508 18.0002 13C18.0002 9.68633 15.3139 7.00003 12.0002 7.00003C11.7494 7.00003 11.5023 7.01541 11.2596 7.04528L8.10726 3.89293L9.00016 3.00003H15.0002L17.0002 5.00003H21.0002C21.5524 5.00003 22.0002 5.44775 22.0002 6.00003V17.7858ZM13.5085 9.29418C14.5045 9.69999 15.3002 10.4957 15.706 11.4917L13.5085 9.29418Z"
  }));
},
    G5 = function G5(_ref307) {
  var _ref307$color = _ref307.color,
      C = _ref307$color === void 0 ? "currentColor" : _ref307$color,
      _ref307$size = _ref307.size,
      e = _ref307$size === void 0 ? 24 : _ref307$size,
      l = _ref307.className,
      i = _objectWithoutProperties(_ref307, _excluded307);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19.5859 21H3.00016C2.44787 21 2.00016 20.5523 2.00016 20V6.00003C2.00016 5.44775 2.44787 5.00003 3.00016 5.00003H3.58594L1.39355 2.80765L2.80777 1.39343L22.6068 21.1924L21.1925 22.6066L19.5859 21ZM5.58594 7.00003H4.00016V19H17.5859L15.4053 16.8194C14.4688 17.5588 13.286 18 12.0002 18C8.96259 18 6.50016 15.5376 6.50016 12.5C6.50016 11.2142 6.94141 10.0314 7.68076 9.09485L5.58594 7.00003ZM9.11052 10.5246C8.72543 11.0868 8.50016 11.7671 8.50016 12.5C8.50016 14.433 10.0672 16 12.0002 16C12.7331 16 13.4134 15.7748 13.9756 15.3897L9.11052 10.5246ZM22.0002 17.7858L20.0002 15.7858V7.00003H16.1717L14.1717 5.00003H9.82858L9.52147 5.30715L8.10726 3.89293L9.00016 3.00003H15.0002L17.0002 5.00003H21.0002C21.5524 5.00003 22.0002 5.44775 22.0002 6.00003V17.7858ZM11.2633 7.04897C11.5043 7.0167 11.7503 7.00003 12.0002 7.00003C15.0377 7.00003 17.5002 9.46247 17.5002 12.5C17.5002 12.7499 17.4835 12.9959 17.4512 13.2369L15.1133 10.899C14.7794 10.251 14.2492 9.72077 13.6012 9.38686L11.2633 7.04897Z"
  }));
},
    I5 = function I5(_ref308) {
  var _ref308$color = _ref308.color,
      C = _ref308$color === void 0 ? "currentColor" : _ref308$color,
      _ref308$size = _ref308.size,
      e = _ref308$size === void 0 ? 24 : _ref308$size,
      l = _ref308.className,
      i = _objectWithoutProperties(_ref308, _excluded308);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9 3H15L17 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V6C2 5.44772 2.44772 5 3 5H7L9 3ZM14.6839 18.3677L13.7892 16.5785C13.2509 16.8482 12.6432 17 12 17C9.79086 17 8 15.2091 8 13H10L7.83875 8.67749C6.70523 9.76898 6 11.3021 6 13C6 16.3137 8.68629 19 12 19C12.9647 19 13.8763 18.7723 14.6839 18.3677ZM9.31613 7.63226L10.2108 9.42151C10.7491 9.15179 11.3568 9 12 9C14.2091 9 16 10.7909 16 13H14L16.1613 17.3225C17.2948 16.231 18 14.6979 18 13C18 9.68629 15.3137 7 12 7C11.0353 7 10.1237 7.22769 9.31613 7.63226Z"
  }));
},
    W5 = function W5(_ref309) {
  var _ref309$color = _ref309.color,
      C = _ref309$color === void 0 ? "currentColor" : _ref309$color,
      _ref309$size = _ref309.size,
      e = _ref309$size === void 0 ? 24 : _ref309$size,
      l = _ref309.className,
      i = _objectWithoutProperties(_ref309, _excluded309);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9.82843 5L7.82843 7H4V19H20V7H16.1716L14.1716 5H9.82843ZM9 3H15L17 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V6C2 5.44772 2.44772 5 3 5H7L9 3ZM9.64042 7.53044C10.3555 7.19033 11.1555 7 12 7C15.0376 7 17.5 9.46243 17.5 12.5C17.5 14.05 16.8588 15.4502 15.8273 16.4499L13.75 12.6H15.4986C15.4995 12.5668 15.5 12.5334 15.5 12.5C15.5 10.567 13.933 9 12 9C11.4912 9 11.0078 9.10856 10.5716 9.30378L9.64042 7.53044ZM14.3175 17.4894C13.6132 17.817 12.828 18 12 18C8.96243 18 6.5 15.5376 6.5 12.5C6.5 10.9678 7.12654 9.58193 8.13738 8.58462L10.25 12.5H8.5C8.5 14.433 10.067 16 12 16C12.4923 16 12.9608 15.8984 13.3857 15.715L14.3175 17.4894Z"
  }));
},
    O5 = function O5(_ref310) {
  var _ref310$color = _ref310.color,
      C = _ref310$color === void 0 ? "currentColor" : _ref310$color,
      _ref310$size = _ref310.size,
      e = _ref310$size === void 0 ? 24 : _ref310$size,
      l = _ref310.className,
      i = _objectWithoutProperties(_ref310, _excluded310);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19.7786 4.22184C22.1217 6.56498 22.1217 10.364 19.7786 12.7071L17.6565 14.8277L12.7075 19.7782C10.3643 22.1213 6.56535 22.1213 4.2222 19.7782C1.87906 17.435 1.87906 13.6361 4.2222 11.2929L11.2933 4.22184C13.6364 1.87869 17.4354 1.87869 19.7786 4.22184ZM14.8288 14.8284L9.17195 9.17158L5.63642 12.7071C4.07432 14.2692 4.07432 16.8019 5.63642 18.364C7.19851 19.9261 9.73117 19.9261 11.2933 18.364L14.8288 14.8284Z"
  }));
},
    K5 = function K5(_ref311) {
  var _ref311$color = _ref311.color,
      C = _ref311$color === void 0 ? "currentColor" : _ref311$color,
      _ref311$size = _ref311.size,
      e = _ref311$size === void 0 ? 24 : _ref311$size,
      l = _ref311.className,
      i = _objectWithoutProperties(_ref311, _excluded311);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19.7786 4.22184C22.1217 6.56498 22.1217 10.364 19.7786 12.7071L12.7075 19.7782C10.3643 22.1213 6.56535 22.1213 4.2222 19.7782C1.87906 17.435 1.87906 13.6361 4.2222 11.2929L11.2933 4.22184C13.6364 1.87869 17.4354 1.87869 19.7786 4.22184ZM14.1224 15.5348L8.46555 9.87798L5.63642 12.7071C4.07432 14.2692 4.07432 16.8019 5.63642 18.364C7.19851 19.9261 9.73117 19.9261 11.2933 18.364L14.1224 15.5348ZM18.3643 5.63605C16.8022 4.07395 14.2696 4.07395 12.7075 5.63605L9.87976 8.46377L15.5366 14.1206L18.3643 11.2929C19.9264 9.73081 19.9264 7.19815 18.3643 5.63605Z"
  }));
},
    Q5 = function Q5(_ref312) {
  var _ref312$color = _ref312.color,
      C = _ref312$color === void 0 ? "currentColor" : _ref312$color,
      _ref312$size = _ref312.size,
      e = _ref312$size === void 0 ? 24 : _ref312$size,
      l = _ref312.className,
      i = _objectWithoutProperties(_ref312, _excluded312);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19 20H5V21C5 21.5523 4.55228 22 4 22H3C2.44772 22 2 21.5523 2 21V12L4.51334 5.29775C4.80607 4.51715 5.55231 4 6.386 4H17.614C18.4477 4 19.1939 4.51715 19.4867 5.29775L22 12V21C22 21.5523 21.5523 22 21 22H20C19.4477 22 19 21.5523 19 21V20ZM4.136 12H19.864L17.614 6H6.386L4.136 12ZM6.5 17C7.32843 17 8 16.3284 8 15.5C8 14.6716 7.32843 14 6.5 14C5.67157 14 5 14.6716 5 15.5C5 16.3284 5.67157 17 6.5 17ZM17.5 17C18.3284 17 19 16.3284 19 15.5C19 14.6716 18.3284 14 17.5 14C16.6716 14 16 14.6716 16 15.5C16 16.3284 16.6716 17 17.5 17Z"
  }));
},
    q5 = function q5(_ref313) {
  var _ref313$color = _ref313.color,
      C = _ref313$color === void 0 ? "currentColor" : _ref313$color,
      _ref313$size = _ref313.size,
      e = _ref313$size === void 0 ? 24 : _ref313$size,
      l = _ref313.className,
      i = _objectWithoutProperties(_ref313, _excluded313);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19 20H5V21C5 21.5523 4.55228 22 4 22H3C2.44772 22 2 21.5523 2 21V11L4.4805 5.21216C4.79566 4.47679 5.51874 4 6.31879 4H17.6812C18.4813 4 19.2043 4.47679 19.5195 5.21216L22 11V21C22 21.5523 21.5523 22 21 22H20C19.4477 22 19 21.5523 19 21V20ZM20 13H4V18H20V13ZM4.17594 11H19.8241L17.6812 6H6.31879L4.17594 11ZM6.5 17C5.67157 17 5 16.3284 5 15.5C5 14.6716 5.67157 14 6.5 14C7.32843 14 8 14.6716 8 15.5C8 16.3284 7.32843 17 6.5 17ZM17.5 17C16.6716 17 16 16.3284 16 15.5C16 14.6716 16.6716 14 17.5 14C18.3284 14 19 14.6716 19 15.5C19 16.3284 18.3284 17 17.5 17Z"
  }));
},
    j5 = function j5(_ref314) {
  var _ref314$color = _ref314.color,
      C = _ref314$color === void 0 ? "currentColor" : _ref314$color,
      _ref314$size = _ref314.size,
      e = _ref314$size === void 0 ? 24 : _ref314$size,
      l = _ref314.className,
      i = _objectWithoutProperties(_ref314, _excluded314);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19 21H5V22C5 22.5523 4.55228 23 4 23H3C2.44772 23 2 22.5523 2 22V13L4.4174 8.97099C4.77884 8.36858 5.42986 7.99998 6.13238 7.99998H17.8676C18.5701 7.99998 19.2212 8.36858 19.5826 8.97099L22 13V22C22 22.5523 21.5523 23 21 23H20C19.4477 23 19 22.5523 19 22V21ZM4.33238 13H19.6676L17.8676 9.99998H6.13238L4.33238 13ZM6.5 18C7.32843 18 8 17.3284 8 16.5C8 15.6716 7.32843 15 6.5 15C5.67157 15 5 15.6716 5 16.5C5 17.3284 5.67157 18 6.5 18ZM17.5 18C18.3284 18 19 17.3284 19 16.5C19 15.6716 18.3284 15 17.5 15C16.6716 15 16 15.6716 16 16.5C16 17.3284 16.6716 18 17.5 18ZM5.43934 3.43932L6.5 2.37866L7.56066 3.43932C7.83211 3.71077 8 4.08577 8 4.49998C8 5.32841 7.32843 5.99998 6.5 5.99998C5.67157 5.99998 5 5.32841 5 4.49998C5 4.08577 5.16789 3.71077 5.43934 3.43932ZM10.9393 3.43932L12 2.37866L13.0607 3.43932C13.3321 3.71077 13.5 4.08577 13.5 4.49998C13.5 5.32841 12.8284 5.99998 12 5.99998C11.1716 5.99998 10.5 5.32841 10.5 4.49998C10.5 4.08577 10.6679 3.71077 10.9393 3.43932ZM16.4393 3.43932L17.5 2.37866L18.5607 3.43932C18.8321 3.71077 19 4.08577 19 4.49998C19 5.32841 18.3284 5.99998 17.5 5.99998C16.6716 5.99998 16 5.32841 16 4.49998C16 4.08577 16.1679 3.71077 16.4393 3.43932Z"
  }));
},
    X5 = function X5(_ref315) {
  var _ref315$color = _ref315.color,
      C = _ref315$color === void 0 ? "currentColor" : _ref315$color,
      _ref315$size = _ref315.size,
      e = _ref315$size === void 0 ? 24 : _ref315$size,
      l = _ref315.className,
      i = _objectWithoutProperties(_ref315, _excluded315);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19 21H5V22C5 22.5523 4.55228 23 4 23H3C2.44772 23 2 22.5523 2 22V12L4.4174 7.97099C4.77884 7.36858 5.42986 6.99998 6.13238 6.99998H17.8676C18.5701 6.99998 19.2212 7.36858 19.5826 7.97099L22 12V22C22 22.5523 21.5523 23 21 23H20C19.4477 23 19 22.5523 19 22V21ZM20 14H4V19H20V14ZM4.33238 12H19.6676L17.8676 8.99998H6.13238L4.33238 12ZM5.43934 3.43932L6.5 2.37866L7.56066 3.43932C7.83211 3.71077 8 4.08577 8 4.49998C8 5.32841 7.32843 5.99998 6.5 5.99998C5.67157 5.99998 5 5.32841 5 4.49998C5 4.08577 5.16789 3.71077 5.43934 3.43932ZM10.9393 3.43932L12 2.37866L13.0607 3.43932C13.3321 3.71077 13.5 4.08577 13.5 4.49998C13.5 5.32841 12.8284 5.99998 12 5.99998C11.1716 5.99998 10.5 5.32841 10.5 4.49998C10.5 4.08577 10.6679 3.71077 10.9393 3.43932ZM16.4393 3.43932L17.5 2.37866L18.5607 3.43932C18.8321 3.71077 19 4.08577 19 4.49998C19 5.32841 18.3284 5.99998 17.5 5.99998C16.6716 5.99998 16 5.32841 16 4.49998C16 4.08577 16.1679 3.71077 16.4393 3.43932ZM6.5 18C5.67157 18 5 17.3284 5 16.5C5 15.6716 5.67157 15 6.5 15C7.32843 15 8 15.6716 8 16.5C8 17.3284 7.32843 18 6.5 18ZM17.5 18C16.6716 18 16 17.3284 16 16.5C16 15.6716 16.6716 15 17.5 15C18.3284 15 19 15.6716 19 16.5C19 17.3284 18.3284 18 17.5 18Z"
  }));
},
    J5 = function J5(_ref316) {
  var _ref316$color = _ref316.color,
      C = _ref316$color === void 0 ? "currentColor" : _ref316$color,
      _ref316$size = _ref316.size,
      e = _ref316$size === void 0 ? 24 : _ref316$size,
      l = _ref316.className,
      i = _objectWithoutProperties(_ref316, _excluded316);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14.1716 3C14.702 3 15.2107 3.21071 15.5858 3.58579L20.4142 8.41421C20.7893 8.78929 21 9.29799 21 9.82843V17H23V19L14.8738 19.0008C14.4295 20.7256 12.8636 22 11 22C9.13643 22 7.57052 20.7256 7.12621 19.0008L3 19C2.44772 19 2 18.5523 2 18V5C2 3.89543 2.89543 3 4 3H14.1716ZM11 16C9.89543 16 9 16.8954 9 18C9 19.1046 9.89543 20 11 20C12.1046 20 13 19.1046 13 18C13 16.8954 12.1046 16 11 16ZM14 7H6V13H14V7ZM12 9V11H8V9H12Z"
  }));
},
    Y5 = function Y5(_ref317) {
  var _ref317$color = _ref317.color,
      C = _ref317$color === void 0 ? "currentColor" : _ref317$color,
      _ref317$size = _ref317.size,
      e = _ref317$size === void 0 ? 24 : _ref317$size,
      l = _ref317.className,
      i = _objectWithoutProperties(_ref317, _excluded317);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14.1716 3C14.702 3 15.2107 3.21071 15.5858 3.58579L20.4142 8.41421C20.7893 8.78929 21 9.29799 21 9.82843V17H23V19L14.8738 19.0008C14.4295 20.7256 12.8636 22 11 22C9.13643 22 7.57052 20.7256 7.12621 19.0008L3 19C2.44772 19 2 18.5523 2 18V5C2 3.89543 2.89543 3 4 3H14.1716ZM11 16C9.89543 16 9 16.8954 9 18C9 19.1046 9.89543 20 11 20C12.1046 20 13 19.1046 13 18C13 16.8954 12.1046 16 11 16ZM14.1716 5H4V17L7.12595 17.0002C7.56991 15.2749 9.13607 14 11 14C12.8639 14 14.4301 15.2749 14.874 17.0002L19 17V9.82843L14.1716 5ZM14 7V13H6V7H14ZM12 9H8V11H12V9Z"
  }));
},
    _5 = function _5(_ref318) {
  var _ref318$color = _ref318.color,
      C = _ref318$color === void 0 ? "currentColor" : _ref318$color,
      _ref318$size = _ref318.size,
      e = _ref318$size === void 0 ? 24 : _ref318$size,
      l = _ref318.className,
      i = _objectWithoutProperties(_ref318, _excluded318);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H15C15 20.3199 14.9478 19.6519 14.8471 19H20V5H4V8.1529C3.34806 8.05223 2.68013 8 2 8V4C2 3.44772 2.44772 3 3 3ZM13 21H11C11 16.0294 6.97056 12 2 12V10C8.07513 10 13 14.9249 13 21ZM9 21H7C7 18.2386 4.76142 16 2 16V14C5.86599 14 9 17.134 9 21ZM5 21H2V18C3.65685 18 5 19.3431 5 21ZM14.373 17C13.093 13.0376 9.9624 9.90704 6 8.627V7H18V17H14.373Z"
  }));
},
    $5 = function $5(_ref319) {
  var _ref319$color = _ref319.color,
      C = _ref319$color === void 0 ? "currentColor" : _ref319$color,
      _ref319$size = _ref319.size,
      e = _ref319$size === void 0 ? 24 : _ref319$size,
      l = _ref319.className,
      i = _objectWithoutProperties(_ref319, _excluded319);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H15C15 20.3199 14.9478 19.6519 14.8471 19H20V5H4V8.1529C3.34806 8.05223 2.68013 8 2 8V4C2 3.44772 2.44772 3 3 3ZM13 21H11C11 16.0294 6.97056 12 2 12V10C8.07513 10 13 14.9249 13 21ZM9 21H7C7 18.2386 4.76142 16 2 16V14C5.86599 14 9 17.134 9 21ZM5 21H2V18C3.65685 18 5 19.3431 5 21Z"
  }));
},
    e9 = function e9(_ref320) {
  var _ref320$color = _ref320.color,
      C = _ref320$color === void 0 ? "currentColor" : _ref320$color,
      _ref320$size = _ref320.size,
      e = _ref320$size === void 0 ? 24 : _ref320$size,
      l = _ref320.className,
      i = _objectWithoutProperties(_ref320, _excluded320);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7 2H18C18.5523 2 19 2.44772 19 3V21C19 21.5523 18.5523 22 18 22H6C5.44772 22 5 21.5523 5 21V0H7V2ZM7 4V9H17V4H7Z"
  }));
},
    t9 = function t9(_ref321) {
  var _ref321$color = _ref321.color,
      C = _ref321$color === void 0 ? "currentColor" : _ref321$color,
      _ref321$size = _ref321.size,
      e = _ref321$size === void 0 ? 24 : _ref321$size,
      l = _ref321.className,
      i = _objectWithoutProperties(_ref321, _excluded321);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7 2H18C18.5523 2 19 2.44772 19 3V21C19 21.5523 18.5523 22 18 22H6C5.44772 22 5 21.5523 5 21V0H7V2ZM7 9H17V4H7V9ZM7 11V20H17V11H7Z"
  }));
},
    C9 = function C9(_ref322) {
  var _ref322$color = _ref322.color,
      C = _ref322$color === void 0 ? "currentColor" : _ref322$color,
      _ref322$size = _ref322.size,
      e = _ref322$size === void 0 ? 24 : _ref322$size,
      l = _ref322.className,
      i = _objectWithoutProperties(_ref322, _excluded322);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4.5 10C2.567 10 1 8.433 1 6.5C1 4.567 2.567 3 4.5 3C6.433 3 8 4.567 8 6.5C8 8.433 6.433 10 4.5 10ZM4.5 8C5.32843 8 6 7.32843 6 6.5C6 5.67157 5.32843 5 4.5 5C3.67157 5 3 5.67157 3 6.5C3 7.32843 3.67157 8 4.5 8ZM22 10H20C20 7.79086 18.2091 6 16 6C13.7909 6 12 7.79086 12 10V15C12 17.2091 13.7909 19 16 19C18.2091 19 20 17.2091 20 15H22C22 18.3137 19.3137 21 16 21C12.6863 21 10 18.3137 10 15V10C10 6.68629 12.6863 4 16 4C19.3137 4 22 6.68629 22 10Z"
  }));
},
    l9 = function l9(_ref323) {
  var _ref323$color = _ref323.color,
      C = _ref323$color === void 0 ? "currentColor" : _ref323$color,
      _ref323$size = _ref323.size,
      e = _ref323$size === void 0 ? 24 : _ref323$size,
      l = _ref323.className,
      i = _objectWithoutProperties(_ref323, _excluded323);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4.5 10C2.567 10 1 8.433 1 6.5C1 4.567 2.567 3 4.5 3C6.433 3 8 4.567 8 6.5C8 8.433 6.433 10 4.5 10ZM4.5 8C5.32843 8 6 7.32843 6 6.5C6 5.67157 5.32843 5 4.5 5C3.67157 5 3 5.67157 3 6.5C3 7.32843 3.67157 8 4.5 8ZM22 10H20C20 7.79086 18.2091 6 16 6C13.7909 6 12 7.79086 12 10V15C12 17.2091 13.7909 19 16 19C18.2091 19 20 17.2091 20 15H22C22 18.3137 19.3137 21 16 21C12.6863 21 10 18.3137 10 15V10C10 6.68629 12.6863 4 16 4C19.3137 4 22 6.68629 22 10Z"
  }));
},
    i9 = function i9(_ref324) {
  var _ref324$color = _ref324.color,
      C = _ref324$color === void 0 ? "currentColor" : _ref324$color,
      _ref324$size = _ref324.size,
      e = _ref324$size === void 0 ? 24 : _ref324$size,
      l = _ref324.className,
      i = _objectWithoutProperties(_ref324, _excluded324);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 13.0607L16.47 17.531L12 22L7.53 17.53L12 13.0607ZM3.99968 16.1207L7.87868 19.9997L4 20L3.99968 16.1207ZM19.9997 16.1207L20 20L16.1207 19.9997L19.9997 16.1207ZM17.53 7.53L22 12L17.531 16.47L13.0607 12L17.53 7.53ZM6.47 7.53L10.9393 12L6.469 16.469L2 12L6.47 7.53ZM12 2L16.469 6.469L12 10.9393L7.53 6.47L12 2ZM7.87868 3.99968L3.99968 7.87868L4 4L7.87868 3.99968ZM20 4L19.9997 7.87868L16.1207 3.99968L20 4Z"
  }));
},
    s9 = function s9(_ref325) {
  var _ref325$color = _ref325.color,
      C = _ref325$color === void 0 ? "currentColor" : _ref325$color,
      _ref325$size = _ref325.size,
      e = _ref325$size === void 0 ? 24 : _ref325$size,
      l = _ref325.className,
      i = _objectWithoutProperties(_ref325, _excluded325);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2L16.292 6.292L17.353 5.232L16.1207 3.99968L20 4L19.9997 7.87868L18.767 6.646L17.707 7.707L22 12L17.708 16.293L18.767 17.352L19.9997 16.1207L20 20L16.1207 19.9997L17.352 18.767L16.293 17.707L12 22L7.707 17.707L6.646 18.767L7.87868 19.9997L4 20L3.99968 16.1207L5.231 17.352L6.292 16.292L2 12L6.293 7.707L5.231 6.646L3.99968 7.87868L4 4L7.87868 3.99968L6.646 5.231L7.708 6.293L12 2ZM12 13.4128L9.12 16.292L12 19.1716L14.879 16.292L12 13.4128ZM7.707 9.121L4.82843 12L7.706 14.878L10.5858 11.9986L7.707 9.121ZM16.292 9.121L13.4149 11.9993L16.293 14.878L19.1716 12L16.292 9.121ZM12 4.82843L9.122 7.707L12.0007 10.5851L14.878 7.706L12 4.82843Z"
  }));
},
    r9 = function r9(_ref326) {
  var _ref326$color = _ref326.color,
      C = _ref326$color === void 0 ? "currentColor" : _ref326$color,
      _ref326$size = _ref326.size,
      e = _ref326$size === void 0 ? 24 : _ref326$size,
      l = _ref326.className,
      i = _objectWithoutProperties(_ref326, _excluded326);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.998 3V21H2.99805V3H20.998ZM12.997 6H10.997L6.59805 17H8.75205L9.95105 14H14.041L15.242 17H17.397L12.997 6ZM11.997 8.88517L13.242 12H10.75L11.997 8.88517Z"
  }));
},
    c9 = function c9(_ref327) {
  var _ref327$color = _ref327.color,
      C = _ref327$color === void 0 ? "currentColor" : _ref327$color,
      _ref327$size = _ref327.size,
      e = _ref327$size === void 0 ? 24 : _ref327$size,
      l = _ref327.className,
      i = _objectWithoutProperties(_ref327, _excluded327);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4.99805 15V19H8.99805V21H2.99805V15H4.99805ZM20.998 15V21H14.998V19H18.998V15H20.998ZM12.997 6L17.397 17H15.242L14.041 14H9.95105L8.75205 17H6.59805L10.997 6H12.997ZM11.997 8.88517L10.75 12H13.242L11.997 8.88517ZM8.99805 3V5H4.99805V9H2.99805V3H8.99805ZM20.998 3V9H18.998V5H14.998V3H20.998Z"
  }));
},
    o9 = function o9(_ref328) {
  var _ref328$color = _ref328.color,
      C = _ref328$color === void 0 ? "currentColor" : _ref328$color,
      _ref328$size = _ref328.size,
      e = _ref328$size === void 0 ? 24 : _ref328$size,
      l = _ref328.className,
      i = _objectWithoutProperties(_ref328, _excluded328);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 11H19V7H20V4H22V7H23V11H22V18C22 19.6569 20.6569 21 19 21C17.3431 21 16 19.6569 16 18V14H14V19H15V21H2V19H3V4C3 3.44772 3.44772 3 4 3H13C13.5523 3 14 3.44772 14 4V12H16C17.1046 12 18 12.8954 18 14V18C18 18.5523 18.4477 19 19 19C19.5523 19 20 18.5523 20 18V11ZM9 11V7L5 13H8V17L12 11H9Z"
  }));
},
    a9 = function a9(_ref329) {
  var _ref329$color = _ref329.color,
      C = _ref329$color === void 0 ? "currentColor" : _ref329$color,
      _ref329$size = _ref329.size,
      e = _ref329$size === void 0 ? 24 : _ref329$size,
      l = _ref329.className,
      i = _objectWithoutProperties(_ref329, _excluded329);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 11H19V7H20V4H22V7H23V11H22V18C22 19.6569 20.6569 21 19 21C17.3431 21 16 19.6569 16 18V14H14V19H15V21H2V19H3V4C3 3.44772 3.44772 3 4 3H13C13.5523 3 14 3.44772 14 4V12H16C17.1046 12 18 12.8954 18 14V18C18 18.5523 18.4477 19 19 19C19.5523 19 20 18.5523 20 18V11ZM12 19V5H5V19H12ZM9 11H12L8 17V13H5L9 7V11Z"
  }));
},
    n9 = function n9(_ref330) {
  var _ref330$color = _ref330.color,
      C = _ref330$color === void 0 ? "currentColor" : _ref330$color,
      _ref330$size = _ref330.size,
      e = _ref330$size === void 0 ? 24 : _ref330$size,
      l = _ref330.className,
      i = _objectWithoutProperties(_ref330, _excluded330);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 19V4C3 3.44772 3.44772 3 4 3H13C13.5523 3 14 3.44772 14 4V12H16C17.1046 12 18 12.8954 18 14V18C18 18.5523 18.4477 19 19 19C19.5523 19 20 18.5523 20 18V11H18C17.4477 11 17 10.5523 17 10V6.41421L15.3431 4.75736L16.7574 3.34315L21.7071 8.29289C21.9024 8.48816 22 8.74408 22 9V18C22 19.6569 20.6569 21 19 21C17.3431 21 16 19.6569 16 18V14H14V19H15V21H2V19H3ZM9 11V7L5 13H8V17L12 11H9Z"
  }));
},
    m9 = function m9(_ref331) {
  var _ref331$color = _ref331.color,
      C = _ref331$color === void 0 ? "currentColor" : _ref331$color,
      _ref331$size = _ref331.size,
      e = _ref331$size === void 0 ? 24 : _ref331$size,
      l = _ref331.className,
      i = _objectWithoutProperties(_ref331, _excluded331);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14 19H15V21H2V19H3V4C3 3.44772 3.44772 3 4 3H13C13.5523 3 14 3.44772 14 4V12H16C17.1046 12 18 12.8954 18 14V18C18 18.5523 18.4477 19 19 19C19.5523 19 20 18.5523 20 18V11H18C17.4477 11 17 10.5523 17 10V6.41421L15.3431 4.75736L16.7574 3.34315L21.7071 8.29289C21.9024 8.48816 22 8.74408 22 9V18C22 19.6569 20.6569 21 19 21C17.3431 21 16 19.6569 16 18V14H14V19ZM5 19H12V5H5V19ZM9 11H12L8 17V13H5L9 7V11Z"
  }));
},
    w9 = function w9(_ref332) {
  var _ref332$color = _ref332.color,
      C = _ref332$color === void 0 ? "currentColor" : _ref332$color,
      _ref332$size = _ref332.size,
      e = _ref332$size === void 0 ? 24 : _ref332$size,
      l = _ref332.className,
      i = _objectWithoutProperties(_ref332, _excluded332);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10 3H14C18.4183 3 22 6.58172 22 11C22 15.4183 18.4183 19 14 19V22.5C9 20.5 2 17.5 2 11C2 6.58172 5.58172 3 10 3Z"
  }));
},
    L9 = function L9(_ref333) {
  var _ref333$color = _ref333.color,
      C = _ref333$color === void 0 ? "currentColor" : _ref333$color,
      _ref333$size = _ref333.size,
      e = _ref333$size === void 0 ? 24 : _ref333$size,
      l = _ref333.className,
      i = _objectWithoutProperties(_ref333, _excluded333);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10 3H14C18.4183 3 22 6.58172 22 11C22 15.4183 18.4183 19 14 19V22.5C9 20.5 2 17.5 2 11C2 6.58172 5.58172 3 10 3ZM12 17H14C17.3137 17 20 14.3137 20 11C20 7.68629 17.3137 5 14 5H10C6.68629 5 4 7.68629 4 11C4 14.61 6.46208 16.9656 12 19.4798V17Z"
  }));
},
    h9 = function h9(_ref334) {
  var _ref334$color = _ref334.color,
      C = _ref334$color === void 0 ? "currentColor" : _ref334$color,
      _ref334$size = _ref334.size,
      e = _ref334$size === void 0 ? 24 : _ref334$size,
      l = _ref334.className,
      i = _objectWithoutProperties(_ref334, _excluded334);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14.45 19L12 22.5L9.55 19H3C2.44772 19 2 18.5523 2 18V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H14.45Z"
  }));
},
    H9 = function H9(_ref335) {
  var _ref335$color = _ref335.color,
      C = _ref335$color === void 0 ? "currentColor" : _ref335$color,
      _ref335$size = _ref335.size,
      e = _ref335$size === void 0 ? 24 : _ref335$size,
      l = _ref335.className,
      i = _objectWithoutProperties(_ref335, _excluded335);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14.45 19L12 22.5L9.55 19H3C2.73478 19 2.48043 18.8946 2.29289 18.7071C2.10536 18.5196 2 18.2652 2 18V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V18C22 18.2652 21.8946 18.5196 21.7071 18.7071C21.5196 18.8946 21.2652 19 21 19H14.45ZM13.409 17H20V5H4V17H10.591L12 19.012L13.409 17Z"
  }));
},
    V9 = function V9(_ref336) {
  var _ref336$color = _ref336.color,
      C = _ref336$color === void 0 ? "currentColor" : _ref336$color,
      _ref336$size = _ref336.size,
      e = _ref336$size === void 0 ? 24 : _ref336$size,
      l = _ref336.className,
      i = _objectWithoutProperties(_ref336, _excluded336);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7.29117 20.8242L2 22L3.17581 16.7088C2.42544 15.3056 2 13.7025 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C10.2975 22 8.6944 21.5746 7.29117 20.8242Z"
  }));
},
    g9 = function g9(_ref337) {
  var _ref337$color = _ref337.color,
      C = _ref337$color === void 0 ? "currentColor" : _ref337$color,
      _ref337$size = _ref337.size,
      e = _ref337$size === void 0 ? 24 : _ref337$size,
      l = _ref337.className,
      i = _objectWithoutProperties(_ref337, _excluded337);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7.29117 20.8242L2 22L3.17581 16.7088C2.42544 15.3056 2 13.7025 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C10.2975 22 8.6944 21.5746 7.29117 20.8242ZM7.58075 18.711L8.23428 19.0605C9.38248 19.6745 10.6655 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 13.3345 4.32549 14.6175 4.93949 15.7657L5.28896 16.4192L4.63416 19.3658L7.58075 18.711Z"
  }));
},
    M9 = function M9(_ref338) {
  var _ref338$color = _ref338.color,
      C = _ref338$color === void 0 ? "currentColor" : _ref338$color,
      _ref338$size = _ref338.size,
      e = _ref338$size === void 0 ? 24 : _ref338$size,
      l = _ref338.className,
      i = _objectWithoutProperties(_ref338, _excluded338);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.45455 19L2 22.5V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.45455Z"
  }));
},
    Z9 = function Z9(_ref339) {
  var _ref339$color = _ref339.color,
      C = _ref339$color === void 0 ? "currentColor" : _ref339$color,
      _ref339$size = _ref339.size,
      e = _ref339$size === void 0 ? 24 : _ref339$size,
      l = _ref339.className,
      i = _objectWithoutProperties(_ref339, _excluded339);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5.76282 17H20V5H4V18.3851L5.76282 17ZM6.45455 19L2 22.5V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.45455Z"
  }));
},
    x9 = function x9(_ref340) {
  var _ref340$color = _ref340.color,
      C = _ref340$color === void 0 ? "currentColor" : _ref340$color,
      _ref340$size = _ref340.size,
      e = _ref340$size === void 0 ? 24 : _ref340$size,
      l = _ref340.className,
      i = _objectWithoutProperties(_ref340, _excluded340);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.45455 19L2 22.5V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.45455ZM11.2929 12.1213L8.81802 9.64645L7.40381 11.0607L11.2929 14.9497L16.9497 9.29289L15.5355 7.87868L11.2929 12.1213Z"
  }));
},
    v9 = function v9(_ref341) {
  var _ref341$color = _ref341.color,
      C = _ref341$color === void 0 ? "currentColor" : _ref341$color,
      _ref341$size = _ref341.size,
      e = _ref341$size === void 0 ? 24 : _ref341$size,
      l = _ref341.className,
      i = _objectWithoutProperties(_ref341, _excluded341);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.45455 19L2 22.5V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.45455ZM5.76282 17H20V5H4V18.3851L5.76282 17ZM11.2929 12.1213L15.5355 7.87868L16.9497 9.29289L11.2929 14.9497L7.40381 11.0607L8.81802 9.64645L11.2929 12.1213Z"
  }));
},
    d9 = function d9(_ref342) {
  var _ref342$color = _ref342.color,
      C = _ref342$color === void 0 ? "currentColor" : _ref342$color,
      _ref342$size = _ref342.size,
      e = _ref342$size === void 0 ? 24 : _ref342$size,
      l = _ref342.className,
      i = _objectWithoutProperties(_ref342, _excluded342);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.45455 19L2 22.5V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.45455ZM13.4142 11L15.8891 8.52513L14.4749 7.11091L12 9.58579L9.52513 7.11091L8.11091 8.52513L10.5858 11L8.11091 13.4749L9.52513 14.8891L12 12.4142L14.4749 14.8891L15.8891 13.4749L13.4142 11Z"
  }));
},
    p9 = function p9(_ref343) {
  var _ref343$color = _ref343.color,
      C = _ref343$color === void 0 ? "currentColor" : _ref343$color,
      _ref343$size = _ref343.size,
      e = _ref343$size === void 0 ? 24 : _ref343$size,
      l = _ref343.className,
      i = _objectWithoutProperties(_ref343, _excluded343);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.45455 19L2 22.5V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.45455ZM4 18.3851L5.76282 17H20V5H4V18.3851ZM13.4142 11L15.8891 13.4749L14.4749 14.8891L12 12.4142L9.52513 14.8891L8.11091 13.4749L10.5858 11L8.11091 8.52513L9.52513 7.11091L12 9.58579L14.4749 7.11091L15.8891 8.52513L13.4142 11Z"
  }));
},
    E9 = function E9(_ref344) {
  var _ref344$color = _ref344.color,
      C = _ref344$color === void 0 ? "currentColor" : _ref344$color,
      _ref344$size = _ref344.size,
      e = _ref344$size === void 0 ? 24 : _ref344$size,
      l = _ref344.className,
      i = _objectWithoutProperties(_ref344, _excluded344);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.45455 19L2 22.5V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.45455ZM13 11V7H11V11H8L12 15L16 11H13Z"
  }));
},
    N9 = function N9(_ref345) {
  var _ref345$color = _ref345.color,
      C = _ref345$color === void 0 ? "currentColor" : _ref345$color,
      _ref345$size = _ref345.size,
      e = _ref345$size === void 0 ? 24 : _ref345$size,
      l = _ref345.className,
      i = _objectWithoutProperties(_ref345, _excluded345);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.45455 19L2 22.5V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.45455ZM4 18.3851L5.76282 17H20V5H4V18.3851ZM13 11H16L12 15L8 11H11V7H13V11Z"
  }));
},
    u9 = function u9(_ref346) {
  var _ref346$color = _ref346.color,
      C = _ref346$color === void 0 ? "currentColor" : _ref346$color,
      _ref346$size = _ref346.size,
      e = _ref346$size === void 0 ? 24 : _ref346$size,
      l = _ref346.className,
      i = _objectWithoutProperties(_ref346, _excluded346);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 3C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.455L2 22.5V4C2 3.44772 2.44772 3 3 3H21ZM17 7H15V15H17V7ZM11 8H9V9.999L7 10V12L9 11.999V14H11V11.999L13 12V10L11 9.999V8Z"
  }));
},
    B9 = function B9(_ref347) {
  var _ref347$color = _ref347.color,
      C = _ref347$color === void 0 ? "currentColor" : _ref347$color,
      _ref347$size = _ref347.size,
      e = _ref347$size === void 0 ? 24 : _ref347$size,
      l = _ref347.className,
      i = _objectWithoutProperties(_ref347, _excluded347);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 3C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.455L2 22.5V4C2 3.44772 2.44772 3 3 3H21ZM20 5H4V18.385L5.76333 17H20V5ZM17 7V15H15V7H17ZM11 8V9.999L13 10V12L11 11.999V14H9V11.999L7 12V10L9 9.999V8H11Z"
  }));
},
    f9 = function f9(_ref348) {
  var _ref348$color = _ref348.color,
      C = _ref348$color === void 0 ? "currentColor" : _ref348$color,
      _ref348$size = _ref348.size,
      e = _ref348$size === void 0 ? 24 : _ref348$size,
      l = _ref348.className,
      i = _objectWithoutProperties(_ref348, _excluded348);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.45455 19L2 22.5V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.45455ZM12 10H8V12H12V15L16 11L12 7V10Z"
  }));
},
    R9 = function R9(_ref349) {
  var _ref349$color = _ref349.color,
      C = _ref349$color === void 0 ? "currentColor" : _ref349$color,
      _ref349$size = _ref349.size,
      e = _ref349$size === void 0 ? 24 : _ref349$size,
      l = _ref349.className,
      i = _objectWithoutProperties(_ref349, _excluded349);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.45455 19L2 22.5V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.45455ZM4 18.3851L5.76282 17H20V5H4V18.3851ZM12 10V7L16 11L12 15V12H8V10H12Z"
  }));
},
    z9 = function z9(_ref350) {
  var _ref350$color = _ref350.color,
      C = _ref350$color === void 0 ? "currentColor" : _ref350$color,
      _ref350$size = _ref350.size,
      e = _ref350$size === void 0 ? 24 : _ref350$size,
      l = _ref350.className,
      i = _objectWithoutProperties(_ref350, _excluded350);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.45455 19L2 22.5V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.45455ZM12.0178 14.6997L15.3765 11.341C16.2552 10.4623 16.2552 9.03769 15.3765 8.15901C14.4978 7.28033 13.0732 7.28033 12.1945 8.15901L12.0178 8.33579L11.841 8.15901C10.9623 7.28033 9.53769 7.28033 8.65901 8.15901C7.78033 9.03769 7.78033 10.4623 8.65901 11.341L12.0178 14.6997Z"
  }));
},
    F9 = function F9(_ref351) {
  var _ref351$color = _ref351.color,
      C = _ref351$color === void 0 ? "currentColor" : _ref351$color,
      _ref351$size = _ref351.size,
      e = _ref351$size === void 0 ? 24 : _ref351$size,
      l = _ref351.className,
      i = _objectWithoutProperties(_ref351, _excluded351);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.45455 19L2 22.5V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.45455ZM4 18.3851L5.76282 17H20V5H4V18.3851ZM12.0178 14.6997L8.65901 11.341C7.78033 10.4623 7.78033 9.03769 8.65901 8.15901C9.53769 7.28033 10.9623 7.28033 11.841 8.15901L12.0178 8.33579L12.1945 8.15901C13.0732 7.28033 14.4978 7.28033 15.3765 8.15901C16.2552 9.03769 16.2552 10.4623 15.3765 11.341L12.0178 14.6997Z"
  }));
},
    S9 = function S9(_ref352) {
  var _ref352$color = _ref352.color,
      C = _ref352$color === void 0 ? "currentColor" : _ref352$color,
      _ref352$size = _ref352.size,
      e = _ref352$size === void 0 ? 24 : _ref352$size,
      l = _ref352.className,
      i = _objectWithoutProperties(_ref352, _excluded352);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C10.298 22 8.69525 21.5748 7.29229 20.8248L2 22L3.17629 16.7097C2.42562 15.3063 2 13.7028 2 12C2 6.47715 6.47715 2 12 2ZM13 7H11V14H17V12H13V7Z"
  }));
},
    A9 = function A9(_ref353) {
  var _ref353$color = _ref353.color,
      C = _ref353$color === void 0 ? "currentColor" : _ref353$color,
      _ref353$size = _ref353.size,
      e = _ref353$size === void 0 ? 24 : _ref353$size,
      l = _ref353.className,
      i = _objectWithoutProperties(_ref353, _excluded353);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C10.298 22 8.69525 21.5748 7.29229 20.8248L2 22L3.17629 16.7097C2.42562 15.3063 2 13.7028 2 12C2 6.47715 6.47715 2 12 2ZM12 4C7.58172 4 4 7.58172 4 12C4 13.3347 4.32563 14.6181 4.93987 15.7664L5.28952 16.4201L4.63445 19.3663L7.58189 18.7118L8.23518 19.061C9.38315 19.6747 10.6659 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM13 7V12H17V14H11V7H13Z"
  }));
},
    k9 = function k9(_ref354) {
  var _ref354$color = _ref354.color,
      C = _ref354$color === void 0 ? "currentColor" : _ref354$color,
      _ref354$size = _ref354.size,
      e = _ref354$size === void 0 ? 24 : _ref354$size,
      l = _ref354.className,
      i = _objectWithoutProperties(_ref354, _excluded354);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.45455 19L2 22.5V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.45455ZM11 10H8V12H11V15H13V12H16V10H13V7H11V10Z"
  }));
},
    P9 = function P9(_ref355) {
  var _ref355$color = _ref355.color,
      C = _ref355$color === void 0 ? "currentColor" : _ref355$color,
      _ref355$size = _ref355.size,
      e = _ref355$size === void 0 ? 24 : _ref355$size,
      l = _ref355.className,
      i = _objectWithoutProperties(_ref355, _excluded355);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14 3V5H4V18.3851L5.76282 17H20V10H22V18C22 18.5523 21.5523 19 21 19H6.45455L2 22.5V4C2 3.44772 2.44772 3 3 3H14ZM19 3V0H21V3H24V5H21V8H19V5H16V3H19Z"
  }));
},
    D9 = function D9(_ref356) {
  var _ref356$color = _ref356.color,
      C = _ref356$color === void 0 ? "currentColor" : _ref356$color,
      _ref356$size = _ref356.size,
      e = _ref356$size === void 0 ? 24 : _ref356$size,
      l = _ref356.className,
      i = _objectWithoutProperties(_ref356, _excluded356);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2.80777 1.39337L22.6068 21.1924L21.1925 22.6066L17.5846 18.9994L6.45516 19L2.00016 22.5V3.99997C2.00016 3.83067 2.04223 3.6712 2.11649 3.53143L1.39355 2.80759L2.80777 1.39337ZM21.0002 2.99997C21.5524 2.99997 22.0002 3.44769 22.0002 3.99997V17.785L7.21416 2.99997H21.0002Z"
  }));
},
    y9 = function y9(_ref357) {
  var _ref357$color = _ref357.color,
      C = _ref357$color === void 0 ? "currentColor" : _ref357$color,
      _ref357$size = _ref357.size,
      e = _ref357$size === void 0 ? 24 : _ref357$size,
      l = _ref357.className,
      i = _objectWithoutProperties(_ref357, _excluded357);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2.80777 1.3934L22.6068 21.1924L21.1925 22.6066L17.5846 18.9994L6.45516 19L2.00016 22.5V4C2.00016 3.8307 2.04223 3.67123 2.11649 3.53146L1.39355 2.80762L2.80777 1.3934ZM3.99955 5.4134L4.00016 18.3853L5.76349 17L15.5846 16.9994L3.99955 5.4134ZM21.0002 3C21.5524 3 22.0002 3.44772 22.0002 4V17.785L20.0002 15.785V5L9.21316 4.999L7.21416 3H21.0002Z"
  }));
},
    b9 = function b9(_ref358) {
  var _ref358$color = _ref358.color,
      C = _ref358$color === void 0 ? "currentColor" : _ref358$color,
      _ref358$size = _ref358.size,
      e = _ref358$size === void 0 ? 24 : _ref358$size,
      l = _ref358.className,
      i = _objectWithoutProperties(_ref358, _excluded358);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 3C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.455L2 22.5V4C2 3.44772 2.44772 3 3 3H21ZM13 7H11V15H13V7ZM17 9H15V15H17V9ZM9 11H7V15H9V11Z"
  }));
},
    T9 = function T9(_ref359) {
  var _ref359$color = _ref359.color,
      C = _ref359$color === void 0 ? "currentColor" : _ref359$color,
      _ref359$size = _ref359.size,
      e = _ref359$size === void 0 ? 24 : _ref359$size,
      l = _ref359.className,
      i = _objectWithoutProperties(_ref359, _excluded359);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 3C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.455L2 22.5V4C2 3.44772 2.44772 3 3 3H21ZM20 5H4V18.385L5.76333 17H20V5ZM13 7V15H11V7H13ZM17 9V15H15V9H17ZM9 11V15H7V11H9Z"
  }));
},
    U9 = function U9(_ref360) {
  var _ref360$color = _ref360.color,
      C = _ref360$color === void 0 ? "currentColor" : _ref360$color,
      _ref360$size = _ref360.size,
      e = _ref360$size === void 0 ? 24 : _ref360$size,
      l = _ref360.className,
      i = _objectWithoutProperties(_ref360, _excluded360);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C10.298 22 8.69525 21.5748 7.29229 20.8248L2 22L3.17629 16.7097C2.42562 15.3063 2 13.7028 2 12C2 6.47715 6.47715 2 12 2ZM12 7C10.4023 7 9 8.34 9 10V11H8V16H16V11H15V10C15 8.34315 13.6569 7 12 7ZM14 13V14H10V13H14ZM12 9C12.4762 9 13 9.49 13 10V11H11V10C11 9.49 11.4872 9 12 9Z"
  }));
},
    G9 = function G9(_ref361) {
  var _ref361$color = _ref361.color,
      C = _ref361$color === void 0 ? "currentColor" : _ref361$color,
      _ref361$size = _ref361.size,
      e = _ref361$size === void 0 ? 24 : _ref361$size,
      l = _ref361.className,
      i = _objectWithoutProperties(_ref361, _excluded361);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C10.298 22 8.69525 21.5748 7.29229 20.8248L2 22L3.17629 16.7097C2.42562 15.3063 2 13.7028 2 12C2 6.47715 6.47715 2 12 2ZM12 4C7.58172 4 4 7.58172 4 12C4 13.3347 4.32563 14.6181 4.93987 15.7664L5.28952 16.4201L4.63445 19.3663L7.58189 18.7118L8.23518 19.061C9.38315 19.6747 10.6659 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM12 7C13.6569 7 15 8.34315 15 10V11H16V16H8V11H9V10C9 8.34315 10.3431 7 12 7ZM14 13H10V14H14V13ZM12 9C11.4477 9 11 9.45 11 10V11H13V10C13 9.44772 12.5523 9 12 9Z"
  }));
},
    I9 = function I9(_ref362) {
  var _ref362$color = _ref362.color,
      C = _ref362$color === void 0 ? "currentColor" : _ref362$color,
      _ref362$size = _ref362.size,
      e = _ref362$size === void 0 ? 24 : _ref362$size,
      l = _ref362.className,
      i = _objectWithoutProperties(_ref362, _excluded362);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 3C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.455L2 22.5V4C2 3.44772 2.44772 3 3 3H21ZM10.5153 7.4116C8.72825 8.18684 7.5 9.75543 7.5 11.5052C7.5 12.5 7.77658 13.1137 8.29171 13.6605C8.61598 14.0048 9.12905 14.25 9.66558 14.25C10.6321 14.25 11.4156 13.4665 11.4156 12.5C11.4156 11.5795 10.7045 10.8389 9.80236 10.7553C9.64107 10.7403 9.47827 10.7431 9.32317 10.7645L9.32344 10.6729C9.32873 10.2322 9.4223 8.9333 10.9616 8.1004L10.5153 7.4116ZM15.5153 7.4116C13.7283 8.18684 12.5 9.75543 12.5 11.5052C12.5 12.5 12.7766 13.1137 13.2917 13.6605C13.616 14.0048 14.1291 14.25 14.6656 14.25C15.6321 14.25 16.4156 13.4665 16.4156 12.5C16.4156 11.5795 15.7045 10.8389 14.8024 10.7553C14.6411 10.7403 14.4783 10.7431 14.3232 10.7645L14.3234 10.6729C14.3287 10.2322 14.4223 8.9333 15.9616 8.1004L15.5153 7.4116Z"
  }));
},
    W9 = function W9(_ref363) {
  var _ref363$color = _ref363.color,
      C = _ref363$color === void 0 ? "currentColor" : _ref363$color,
      _ref363$size = _ref363.size,
      e = _ref363$size === void 0 ? 24 : _ref363$size,
      l = _ref363.className,
      i = _objectWithoutProperties(_ref363, _excluded363);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 3C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.455L2 22.5V4C2 3.44772 2.44772 3 3 3H21ZM20 5H4V18.385L5.76333 17H20V5ZM10.5153 7.4116L10.9616 8.1004C9.29402 9.0027 9.32317 10.4519 9.32317 10.7645C9.47827 10.7431 9.64107 10.7403 9.80236 10.7553C10.7045 10.8389 11.4156 11.5795 11.4156 12.5C11.4156 13.4665 10.6321 14.25 9.66558 14.25C9.12905 14.25 8.61598 14.0048 8.29171 13.6605C7.77658 13.1137 7.5 12.5 7.5 11.5052C7.5 9.75543 8.72825 8.18684 10.5153 7.4116ZM15.5153 7.4116L15.9616 8.1004C14.294 9.0027 14.3232 10.4519 14.3232 10.7645C14.4783 10.7431 14.6411 10.7403 14.8024 10.7553C15.7045 10.8389 16.4156 11.5795 16.4156 12.5C16.4156 13.4665 15.6321 14.25 14.6656 14.25C14.1291 14.25 13.616 14.0048 13.2917 13.6605C12.7766 13.1137 12.5 12.5 12.5 11.5052C12.5 9.75543 13.7283 8.18684 15.5153 7.4116Z"
  }));
},
    O9 = function O9(_ref364) {
  var _ref364$color = _ref364.color,
      C = _ref364$color === void 0 ? "currentColor" : _ref364$color,
      _ref364$size = _ref364.size,
      e = _ref364$size === void 0 ? 24 : _ref364$size,
      l = _ref364.className,
      i = _objectWithoutProperties(_ref364, _excluded364);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.45455 19L2 22.5V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.45455ZM8.14499 12.071L7.16987 12.634L8.16987 14.366L9.1459 13.8025C9.64746 14.3133 10.2851 14.69 11 14.874V16H13V14.874C13.7149 14.69 14.3525 14.3133 14.8541 13.8025L15.8301 14.366L16.8301 12.634L15.855 12.071C15.9495 11.7301 16 11.371 16 11C16 10.629 15.9495 10.2699 15.855 9.92901L16.8301 9.36602L15.8301 7.63397L14.8541 8.19748C14.3525 7.68674 13.7149 7.31003 13 7.12602V6H11V7.12602C10.2851 7.31003 9.64746 7.68674 9.1459 8.19748L8.16987 7.63397L7.16987 9.36602L8.14499 9.92901C8.0505 10.2699 8 10.629 8 11C8 11.371 8.0505 11.7301 8.14499 12.071ZM12 13C10.8954 13 10 12.1046 10 11C10 9.89543 10.8954 9 12 9C13.1046 9 14 9.89543 14 11C14 12.1046 13.1046 13 12 13Z"
  }));
},
    K9 = function K9(_ref365) {
  var _ref365$color = _ref365.color,
      C = _ref365$color === void 0 ? "currentColor" : _ref365$color,
      _ref365$size = _ref365.size,
      e = _ref365$size === void 0 ? 24 : _ref365$size,
      l = _ref365.className,
      i = _objectWithoutProperties(_ref365, _excluded365);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22 12H20V5H4V18.3851L5.76282 17H12V19H6.45455L2 22.5V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V12ZM14.145 19.071C14.0505 18.7301 14 18.371 14 18C14 17.629 14.0505 17.2699 14.145 16.929L13.1699 16.366L14.1699 14.634L15.1459 15.1975C15.6475 14.6867 16.2851 14.31 17 14.126V13H19V14.126C19.7149 14.31 20.3525 14.6867 20.8541 15.1975L21.8301 14.634L22.8301 16.366L21.855 16.929C21.9495 17.2699 22 17.629 22 18C22 18.371 21.9495 18.7301 21.855 19.071L22.8301 19.634L21.8301 21.366L20.8541 20.8025C20.3525 21.3133 19.7149 21.69 19 21.874V23H17V21.874C16.2851 21.69 15.6475 21.3133 15.1459 20.8025L14.1699 21.366L13.1699 19.634L14.145 19.071ZM18 20C19.1046 20 20 19.1046 20 18C20 16.8954 19.1046 16 18 16C16.8954 16 16 16.8954 16 18C16 19.1046 16.8954 20 18 20Z"
  }));
},
    Q9 = function Q9(_ref366) {
  var _ref366$color = _ref366.color,
      C = _ref366$color === void 0 ? "currentColor" : _ref366$color,
      _ref366$size = _ref366.size,
      e = _ref366$size === void 0 ? 24 : _ref366$size,
      l = _ref366.className,
      i = _objectWithoutProperties(_ref366, _excluded366);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7.29117 20.8242L2 22L3.17581 16.7088C2.42544 15.3056 2 13.7025 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C10.2975 22 8.6944 21.5746 7.29117 20.8242ZM7 12C7 14.7614 9.23858 17 12 17C14.7614 17 17 14.7614 17 12H15C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12H7Z"
  }));
},
    q9 = function q9(_ref367) {
  var _ref367$color = _ref367.color,
      C = _ref367$color === void 0 ? "currentColor" : _ref367$color,
      _ref367$size = _ref367.size,
      e = _ref367$size === void 0 ? 24 : _ref367$size,
      l = _ref367.className,
      i = _objectWithoutProperties(_ref367, _excluded367);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7.29117 20.8242L2 22L3.17581 16.7088C2.42544 15.3056 2 13.7025 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C10.2975 22 8.6944 21.5746 7.29117 20.8242ZM7.58075 18.711L8.23428 19.0605C9.38248 19.6745 10.6655 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 13.3345 4.32549 14.6175 4.93949 15.7657L5.28896 16.4192L4.63416 19.3658L7.58075 18.711ZM7 12H9C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12H17C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12Z"
  }));
},
    j9 = function j9(_ref368) {
  var _ref368$color = _ref368.color,
      C = _ref368$color === void 0 ? "currentColor" : _ref368$color,
      _ref368$size = _ref368.size,
      e = _ref368$size === void 0 ? 24 : _ref368$size,
      l = _ref368.className,
      i = _objectWithoutProperties(_ref368, _excluded368);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22H2L4.92893 19.0711C3.11929 17.2614 2 14.7614 2 12C2 6.47715 6.47715 2 12 2ZM16 13H8C8 15.2091 9.79086 17 12 17C14.2091 17 16 15.2091 16 13Z"
  }));
},
    X9 = function X9(_ref369) {
  var _ref369$color = _ref369.color,
      C = _ref369$color === void 0 ? "currentColor" : _ref369$color,
      _ref369$size = _ref369.size,
      e = _ref369$size === void 0 ? 24 : _ref369$size,
      l = _ref369.className,
      i = _objectWithoutProperties(_ref369, _excluded369);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22H2L4.92893 19.0711C3.11929 17.2614 2 14.7614 2 12ZM6.82843 20H12C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 14.1524 4.85124 16.1649 6.34315 17.6569L7.75736 19.0711L6.82843 20ZM8 13H16C16 15.2091 14.2091 17 12 17C9.79086 17 8 15.2091 8 13Z"
  }));
},
    J9 = function J9(_ref370) {
  var _ref370$color = _ref370.color,
      C = _ref370$color === void 0 ? "currentColor" : _ref370$color,
      _ref370$size = _ref370.size,
      e = _ref370$size === void 0 ? 24 : _ref370$size,
      l = _ref370.className,
      i = _objectWithoutProperties(_ref370, _excluded370);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.45455 19L2 22.5V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.45455ZM7 10C7 12.7614 9.23858 15 12 15C14.7614 15 17 12.7614 17 10H15C15 11.6569 13.6569 13 12 13C10.3431 13 9 11.6569 9 10H7Z"
  }));
},
    Y9 = function Y9(_ref371) {
  var _ref371$color = _ref371.color,
      C = _ref371$color === void 0 ? "currentColor" : _ref371$color,
      _ref371$size = _ref371.size,
      e = _ref371$size === void 0 ? 24 : _ref371$size,
      l = _ref371.className,
      i = _objectWithoutProperties(_ref371, _excluded371);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.45455 19L2 22.5V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.45455ZM5.76282 17H20V5H4V18.3851L5.76282 17ZM7 10H9C9 11.6569 10.3431 13 12 13C13.6569 13 15 11.6569 15 10H17C17 12.7614 14.7614 15 12 15C9.23858 15 7 12.7614 7 10Z"
  }));
},
    _9 = function _9(_ref372) {
  var _ref372$color = _ref372.color,
      C = _ref372$color === void 0 ? "currentColor" : _ref372$color,
      _ref372$size = _ref372.size,
      e = _ref372$size === void 0 ? 24 : _ref372$size,
      l = _ref372.className,
      i = _objectWithoutProperties(_ref372, _excluded372);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.45455 19L2 22.5V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.45455ZM13 11H16L12 7L8 11H11V15H13V11Z"
  }));
},
    $9 = function $9(_ref373) {
  var _ref373$color = _ref373.color,
      C = _ref373$color === void 0 ? "currentColor" : _ref373$color,
      _ref373$size = _ref373.size,
      e = _ref373$size === void 0 ? 24 : _ref373$size,
      l = _ref373.className,
      i = _objectWithoutProperties(_ref373, _excluded373);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.45455 19L2 22.5V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.45455ZM4 18.3851L5.76282 17H20V5H4V18.3851ZM13 11V15H11V11H8L12 7L16 11H13Z"
  }));
},
    e7 = function e7(_ref374) {
  var _ref374$color = _ref374.color,
      C = _ref374$color === void 0 ? "currentColor" : _ref374$color,
      _ref374$size = _ref374.size,
      e = _ref374$size === void 0 ? 24 : _ref374$size,
      l = _ref374.className,
      i = _objectWithoutProperties(_ref374, _excluded374);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4.92893 19.0711C3.11929 17.2614 2 14.7614 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22H2L4.92893 19.0711ZM11 6V18H13V6H11ZM7 9V15H9V9H7ZM15 9V15H17V9H15Z"
  }));
},
    t7 = function t7(_ref375) {
  var _ref375$color = _ref375.color,
      C = _ref375$color === void 0 ? "currentColor" : _ref375$color,
      _ref375$size = _ref375.size,
      e = _ref375$size === void 0 ? 24 : _ref375$size,
      l = _ref375.className,
      i = _objectWithoutProperties(_ref375, _excluded375);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22H2L4.92893 19.0711C3.11929 17.2614 2 14.7614 2 12ZM6.82843 20H12C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 14.1524 4.85124 16.1649 6.34315 17.6569L7.75736 19.0711L6.82843 20ZM11 6H13V18H11V6ZM7 9H9V15H7V9ZM15 9H17V15H15V9Z"
  }));
},
    C7 = function C7(_ref376) {
  var _ref376$color = _ref376.color,
      C = _ref376$color === void 0 ? "currentColor" : _ref376$color,
      _ref376$size = _ref376.size,
      e = _ref376$size === void 0 ? 24 : _ref376$size,
      l = _ref376.className,
      i = _objectWithoutProperties(_ref376, _excluded376);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11.602 13.7599L13.014 15.1719L21.4795 6.7063L22.8938 8.12051L13.014 18.0003L6.65 11.6363L8.06421 10.2221L10.189 12.3469L11.6025 13.7594L11.602 13.7599ZM11.6037 10.9322L16.5563 5.97949L17.9666 7.38977L13.014 12.3424L11.6037 10.9322ZM8.77698 16.5873L7.36396 18.0003L1 11.6363L2.41421 10.2221L3.82723 11.6352L3.82604 11.6363L8.77698 16.5873Z"
  }));
},
    l7 = function l7(_ref377) {
  var _ref377$color = _ref377.color,
      C = _ref377$color === void 0 ? "currentColor" : _ref377$color,
      _ref377$size = _ref377.size,
      e = _ref377$size === void 0 ? 24 : _ref377$size,
      l = _ref377.className,
      i = _objectWithoutProperties(_ref377, _excluded377);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11.602 13.7599L13.014 15.1719L21.4795 6.7063L22.8938 8.12051L13.014 18.0003L6.65 11.6363L8.06421 10.2221L10.189 12.3469L11.6025 13.7594L11.602 13.7599ZM11.6037 10.9322L16.5563 5.97949L17.9666 7.38977L13.014 12.3424L11.6037 10.9322ZM8.77698 16.5873L7.36396 18.0003L1 11.6363L2.41421 10.2221L3.82723 11.6352L3.82604 11.6363L8.77698 16.5873Z"
  }));
},
    i7 = function i7(_ref378) {
  var _ref378$color = _ref378.color,
      C = _ref378$color === void 0 ? "currentColor" : _ref378$color,
      _ref378$size = _ref378.size,
      e = _ref378$size === void 0 ? 24 : _ref378$size,
      l = _ref378.className,
      i = _objectWithoutProperties(_ref378, _excluded378);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9.9997 15.1709L19.1921 5.97852L20.6063 7.39273L9.9997 17.9993L3.63574 11.6354L5.04996 10.2212L9.9997 15.1709Z"
  }));
},
    s7 = function s7(_ref379) {
  var _ref379$color = _ref379.color,
      C = _ref379$color === void 0 ? "currentColor" : _ref379$color,
      _ref379$size = _ref379.size,
      e = _ref379$size === void 0 ? 24 : _ref379$size,
      l = _ref379.className,
      i = _objectWithoutProperties(_ref379, _excluded379);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9.9997 15.1709L19.1921 5.97852L20.6063 7.39273L9.9997 17.9993L3.63574 11.6354L5.04996 10.2212L9.9997 15.1709Z"
  }));
},
    r7 = function r7(_ref380) {
  var _ref380$color = _ref380.color,
      C = _ref380$color === void 0 ? "currentColor" : _ref380$color,
      _ref380$size = _ref380.size,
      e = _ref380$size === void 0 ? 24 : _ref380$size,
      l = _ref380.className,
      i = _objectWithoutProperties(_ref380, _excluded380);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
  }));
},
    c7 = function c7(_ref381) {
  var _ref381$color = _ref381.color,
      C = _ref381$color === void 0 ? "currentColor" : _ref381$color,
      _ref381$size = _ref381.size,
      e = _ref381$size === void 0 ? 24 : _ref381$size,
      l = _ref381.className,
      i = _objectWithoutProperties(_ref381, _excluded381);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
  }));
},
    o7 = function o7(_ref382) {
  var _ref382$color = _ref382.color,
      C = _ref382$color === void 0 ? "currentColor" : _ref382$color,
      _ref382$size = _ref382.size,
      e = _ref382$size === void 0 ? 24 : _ref382$size,
      l = _ref382.className,
      i = _objectWithoutProperties(_ref382, _excluded382);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3Z"
  }));
},
    a7 = function a7(_ref383) {
  var _ref383$color = _ref383.color,
      C = _ref383$color === void 0 ? "currentColor" : _ref383$color,
      _ref383$size = _ref383.size,
      e = _ref383$size === void 0 ? 24 : _ref383$size,
      l = _ref383.className,
      i = _objectWithoutProperties(_ref383, _excluded383);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM5 5V19H19V5H5Z"
  }));
},
    n7 = function n7(_ref384) {
  var _ref384$color = _ref384.color,
      C = _ref384$color === void 0 ? "currentColor" : _ref384$color,
      _ref384$size = _ref384.size,
      e = _ref384$size === void 0 ? 24 : _ref384$size,
      l = _ref384.className,
      i = _objectWithoutProperties(_ref384, _excluded384);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM17.4571 9.45711L11 15.9142L6.79289 11.7071L8.20711 10.2929L11 13.0858L16.0429 8.04289L17.4571 9.45711Z"
  }));
},
    m7 = function m7(_ref385) {
  var _ref385$color = _ref385.color,
      C = _ref385$color === void 0 ? "currentColor" : _ref385$color,
      _ref385$size = _ref385.size,
      e = _ref385$size === void 0 ? 24 : _ref385$size,
      l = _ref385.className,
      i = _objectWithoutProperties(_ref385, _excluded385);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12ZM12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM17.4571 9.45711L16.0429 8.04289L11 13.0858L8.20711 10.2929L6.79289 11.7071L11 15.9142L17.4571 9.45711Z"
  }));
},
    w7 = function w7(_ref386) {
  var _ref386$color = _ref386.color,
      C = _ref386$color === void 0 ? "currentColor" : _ref386$color,
      _ref386$size = _ref386.size,
      e = _ref386$size === void 0 ? 24 : _ref386$size,
      l = _ref386.className,
      i = _objectWithoutProperties(_ref386, _excluded386);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM11.0026 16L18.0737 8.92893L16.6595 7.51472L11.0026 13.1716L8.17421 10.3431L6.75999 11.7574L11.0026 16Z"
  }));
},
    L7 = function L7(_ref387) {
  var _ref387$color = _ref387.color,
      C = _ref387$color === void 0 ? "currentColor" : _ref387$color,
      _ref387$size = _ref387.size,
      e = _ref387$size === void 0 ? 24 : _ref387$size,
      l = _ref387.className,
      i = _objectWithoutProperties(_ref387, _excluded387);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM7 11V13H17V11H7Z"
  }));
},
    h7 = function h7(_ref388) {
  var _ref388$color = _ref388.color,
      C = _ref388$color === void 0 ? "currentColor" : _ref388$color,
      _ref388$size = _ref388.size,
      e = _ref388$size === void 0 ? 24 : _ref388$size,
      l = _ref388.className,
      i = _objectWithoutProperties(_ref388, _excluded388);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM5 5V19H19V5H5ZM7 11H17V13H7V11Z"
  }));
},
    H7 = function H7(_ref389) {
  var _ref389$color = _ref389.color,
      C = _ref389$color === void 0 ? "currentColor" : _ref389$color,
      _ref389$size = _ref389.size,
      e = _ref389$size === void 0 ? 24 : _ref389$size,
      l = _ref389.className,
      i = _objectWithoutProperties(_ref389, _excluded389);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM5 5V19H19V5H5ZM11.0026 16L6.75999 11.7574L8.17421 10.3431L11.0026 13.1716L16.6595 7.51472L18.0737 8.92893L11.0026 16Z"
  }));
},
    V7 = function V7(_ref390) {
  var _ref390$color = _ref390.color,
      C = _ref390$color === void 0 ? "currentColor" : _ref390$color,
      _ref390$size = _ref390.size,
      e = _ref390$size === void 0 ? 24 : _ref390$size,
      l = _ref390.className,
      i = _objectWithoutProperties(_ref390, _excluded390);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.99979 7V3C6.99979 2.44772 7.4475 2 7.99979 2H20.9998C21.5521 2 21.9998 2.44772 21.9998 3V16C21.9998 16.5523 21.5521 17 20.9998 17H17V20.9925C17 21.5489 16.551 22 15.9925 22H3.00728C2.45086 22 2 21.5511 2 20.9925L2.00276 8.00748C2.00288 7.45107 2.4518 7 3.01025 7H6.99979ZM8.99979 7H15.9927C16.549 7 17 7.44892 17 8.00748V15H19.9998V4H8.99979V7Z"
  }));
},
    g7 = function g7(_ref391) {
  var _ref391$color = _ref391.color,
      C = _ref391$color === void 0 ? "currentColor" : _ref391$color,
      _ref391$size = _ref391.size,
      e = _ref391$size === void 0 ? 24 : _ref391$size,
      l = _ref391.className,
      i = _objectWithoutProperties(_ref391, _excluded391);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.99979 7V3C6.99979 2.44772 7.4475 2 7.99979 2H20.9998C21.5521 2 21.9998 2.44772 21.9998 3V16C21.9998 16.5523 21.5521 17 20.9998 17H17V20.9925C17 21.5489 16.551 22 15.9925 22H3.00728C2.45086 22 2 21.5511 2 20.9925L2.00276 8.00748C2.00288 7.45107 2.4518 7 3.01025 7H6.99979ZM8.99979 7H15.9927C16.549 7 17 7.44892 17 8.00748V15H19.9998V4H8.99979V7ZM4.00255 9L4.00021 20H15V9H4.00255Z"
  }));
},
    M7 = function M7(_ref392) {
  var _ref392$color = _ref392.color,
      C = _ref392$color === void 0 ? "currentColor" : _ref392$color,
      _ref392$size = _ref392.size,
      e = _ref392$size === void 0 ? 24 : _ref392$size,
      l = _ref392.className,
      i = _objectWithoutProperties(_ref392, _excluded392);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.99979 7V3C6.99979 2.44772 7.4475 2 7.99979 2H20.9998C21.5521 2 21.9998 2.44772 21.9998 3V16C21.9998 16.5523 21.5521 17 20.9998 17H17V20.9925C17 21.5489 16.551 22 15.9925 22H3.00728C2.45086 22 2 21.5511 2 20.9925L2.00276 8.00748C2.00288 7.45107 2.4518 7 3.01025 7H6.99979ZM8.99979 7H15.9927C16.549 7 17 7.44892 17 8.00748V15H19.9998V4H8.99979V7ZM8.50242 18L14.1593 12.3431L12.7451 10.9289L8.50242 15.1716L6.3811 13.0503L4.96689 14.4645L8.50242 18Z"
  }));
},
    Z7 = function Z7(_ref393) {
  var _ref393$color = _ref393.color,
      C = _ref393$color === void 0 ? "currentColor" : _ref393$color,
      _ref393$size = _ref393.size,
      e = _ref393$size === void 0 ? 24 : _ref393$size,
      l = _ref393.className,
      i = _objectWithoutProperties(_ref393, _excluded393);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.99979 7V3C6.99979 2.44772 7.4475 2 7.99979 2H20.9998C21.5521 2 21.9998 2.44772 21.9998 3V16C21.9998 16.5523 21.5521 17 20.9998 17H17V20.9925C17 21.5489 16.551 22 15.9925 22H3.00728C2.45086 22 2 21.5511 2 20.9925L2.00276 8.00748C2.00288 7.45107 2.4518 7 3.01025 7H6.99979ZM8.99979 7H15.9927C16.549 7 17 7.44892 17 8.00748V15H19.9998V4H8.99979V7ZM15 9H4.00255L4.00021 20H15V9ZM8.50242 18L4.96689 14.4645L6.3811 13.0503L8.50242 15.1716L12.7451 10.9289L14.1593 12.3431L8.50242 18Z"
  }));
},
    x7 = function x7(_ref394) {
  var _ref394$color = _ref394.color,
      C = _ref394$color === void 0 ? "currentColor" : _ref394$color,
      _ref394$size = _ref394.size,
      e = _ref394$size === void 0 ? 24 : _ref394$size,
      l = _ref394.className,
      i = _objectWithoutProperties(_ref394, _excluded394);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11 19V13L9 12V9H15V12L13 13V19L18 20V22H6V20L11 19ZM10 2.22302V1H14V2.22302C18.008 3.13247 21 6.71683 21 11C21 14.1235 19.4088 16.8754 16.9928 18.4892L15.8833 16.825C17.7624 15.5697 19 13.4294 19 11C19 7.13401 15.866 4 12 4C8.13401 4 5 7.13401 5 11C5 13.4294 6.23758 15.5697 8.11669 16.825L7.00717 18.4892C4.59118 16.8754 3 14.1235 3 11C3 6.71683 5.99202 3.13247 10 2.22302Z"
  }));
},
    v7 = function v7(_ref395) {
  var _ref395$color = _ref395.color,
      C = _ref395$color === void 0 ? "currentColor" : _ref395$color,
      _ref395$size = _ref395.size,
      e = _ref395$size === void 0 ? 24 : _ref395$size,
      l = _ref395.className,
      i = _objectWithoutProperties(_ref395, _excluded395);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11 20V13H9V10H15V13H13V20H18V22H6V20H11ZM10 2.22302V1H14V2.22302C18.008 3.13247 21 6.71683 21 11C21 14.1235 19.4088 16.8754 16.9928 18.4892L15.8833 16.825C17.7624 15.5697 19 13.4294 19 11C19 7.13401 15.866 4 12 4C8.13401 4 5 7.13401 5 11C5 13.4294 6.23758 15.5697 8.11669 16.825L7.00717 18.4892C4.59118 16.8754 3 14.1235 3 11C3 6.71683 5.99202 3.13247 10 2.22302Z"
  }));
},
    d7 = function d7(_ref396) {
  var _ref396$color = _ref396.color,
      C = _ref396$color === void 0 ? "currentColor" : _ref396$color,
      _ref396$size = _ref396.size,
      e = _ref396$size === void 0 ? 24 : _ref396$size,
      l = _ref396.className,
      i = _objectWithoutProperties(_ref396, _excluded396);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9.82726 21.7633C5.34912 20.7712 2 16.7767 2 12C2 10.1779 2.48734 8.46958 3.33878 6.99834L7.62189 14.4169C8.47396 15.9571 10.1152 17 12 17C12.2023 17 12.4018 16.988 12.5978 16.9646L9.82726 21.7633ZM12 22L16.2868 14.5751C16.7396 13.8229 17 12.9419 17 12C17 10.8744 16.6281 9.83566 16.0004 9H21.5422C21.8396 9.94704 22 10.9548 22 12C22 17.5228 17.5228 22 12 22ZM14.5721 13.545C14.0473 14.4168 13.0917 15 12 15C10.8897 15 9.92024 14.3968 9.40149 13.5002L9.37313 13.4501C9.13535 13.0203 9 12.526 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12C15 12.5465 14.8539 13.0589 14.5985 13.5002L14.5721 13.545ZM4.6322 5.23859C6.46008 3.24783 9.08432 2 12 2C15.7014 2 18.9331 4.01099 20.6622 7H12C9.93635 7 8.1647 8.25019 7.40112 10.0345L4.6322 5.23859Z"
  }));
},
    p7 = function p7(_ref397) {
  var _ref397$color = _ref397.color,
      C = _ref397$color === void 0 ? "currentColor" : _ref397$color,
      _ref397$size = _ref397.size,
      e = _ref397$size === void 0 ? 24 : _ref397$size,
      l = _ref397.className,
      i = _objectWithoutProperties(_ref397, _excluded397);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10.3645 19.8327L12.2941 16.4905C12.1969 16.4968 12.0988 16.5 12 16.5C10.3037 16.5 8.82656 15.5614 8.0597 14.1752L4.79459 8.51986C4.28545 9.57206 4 10.7527 4 12C4 15.8578 6.73064 19.0778 10.3645 19.8327ZM12.5897 19.9786C16.7326 19.6767 20 16.2199 20 12C20 11.1269 19.8601 10.2865 19.6016 9.5H15.7422C16.2209 10.215 16.5 11.0749 16.5 12C16.5 12.8477 16.2656 13.6406 15.8581 14.3175L12.5897 19.9786ZM14.1434 13.2875L14.1651 13.25C14.3782 12.8824 14.5 12.4554 14.5 12C14.5 10.6193 13.3807 9.5 12 9.5C10.6193 9.5 9.5 10.6193 9.5 12C9.5 12.4383 9.6128 12.8503 9.81094 13.2084L9.83494 13.25C10.2669 13.9973 11.0747 14.5 12 14.5C12.9098 14.5 13.7061 14.014 14.1434 13.2875ZM6.03522 6.66871L7.9635 10.0086C8.69821 8.52222 10.2297 7.5 12 7.5H18.6153C17.1753 5.38723 14.7497 4 12 4C9.62968 4 7.50014 5.03086 6.03522 6.66871ZM12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22Z"
  }));
},
    E7 = function E7(_ref398) {
  var _ref398$color = _ref398.color,
      C = _ref398$color === void 0 ? "currentColor" : _ref398$color,
      _ref398$size = _ref398.size,
      e = _ref398$size === void 0 ? 24 : _ref398$size,
      l = _ref398.className,
      i = _objectWithoutProperties(_ref398, _excluded398);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17.9981 7L20.3075 3H21.0082C21.556 3 22 3.44495 22 3.9934V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5551 2 20.0066V3.9934C2 3.44476 2.45531 3 2.9918 3H5.99807L3.68867 7H5.99807L8.30747 3H11.9981L9.68867 7H11.9981L14.3075 3H17.9981L15.6887 7H17.9981Z"
  }));
},
    N7 = function N7(_ref399) {
  var _ref399$color = _ref399.color,
      C = _ref399$color === void 0 ? "currentColor" : _ref399$color,
      _ref399$size = _ref399.size,
      e = _ref399$size === void 0 ? 24 : _ref399$size,
      l = _ref399.className,
      i = _objectWithoutProperties(_ref399, _excluded399);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5.99807 7L8.30747 3H11.9981L9.68867 7H5.99807ZM11.9981 7L14.3075 3H17.9981L15.6887 7H11.9981ZM17.9981 7L20.3075 3H21.0082C21.556 3 22 3.44495 22 3.9934V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5551 2 20.0066V3.9934C2 3.44476 2.45531 3 2.9918 3H5.99807L4 6.46076V19H20V7H17.9981Z"
  }));
},
    u7 = function u7(_ref400) {
  var _ref400$color = _ref400.color,
      C = _ref400$color === void 0 ? "currentColor" : _ref400$color,
      _ref400$size = _ref400.size,
      e = _ref400$size === void 0 ? 24 : _ref400$size,
      l = _ref400.className,
      i = _objectWithoutProperties(_ref400, _excluded400);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6 4V8H18V4H20.0066C20.5552 4 21 4.44495 21 4.9934V21.0066C21 21.5552 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5551 3 21.0066V4.9934C3 4.44476 3.44495 4 3.9934 4H6ZM8 2H16V6H8V2Z"
  }));
},
    B7 = function B7(_ref401) {
  var _ref401$color = _ref401.color,
      C = _ref401$color === void 0 ? "currentColor" : _ref401$color,
      _ref401$size = _ref401.size,
      e = _ref401$size === void 0 ? 24 : _ref401$size,
      l = _ref401.className,
      i = _objectWithoutProperties(_ref401, _excluded401);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7 4V2H17V4H20.0066C20.5552 4 21 4.44495 21 4.9934V21.0066C21 21.5552 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5551 3 21.0066V4.9934C3 4.44476 3.44495 4 3.9934 4H7ZM7 6H5V20H19V6H17V8H7V6ZM9 4V6H15V4H9Z"
  }));
},
    f7 = function f7(_ref402) {
  var _ref402$color = _ref402.color,
      C = _ref402$color === void 0 ? "currentColor" : _ref402$color,
      _ref402$size = _ref402.size,
      e = _ref402$size === void 0 ? 24 : _ref402$size,
      l = _ref402.className,
      i = _objectWithoutProperties(_ref402, _excluded402);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10 4V1L15 5L10 9V6H8C6.34315 6 5 7.34315 5 9V13H3V9C3 6.23858 5.23858 4 8 4H10ZM9 11C9 10.4477 9.44772 10 10 10H20C20.5523 10 21 10.4477 21 11V21C21 21.5523 20.5523 22 20 22H10C9.44772 22 9 21.5523 9 21V11Z"
  }));
},
    R7 = function R7(_ref403) {
  var _ref403$color = _ref403.color,
      C = _ref403$color === void 0 ? "currentColor" : _ref403$color,
      _ref403$size = _ref403.size,
      e = _ref403$size === void 0 ? 24 : _ref403$size,
      l = _ref403.className,
      i = _objectWithoutProperties(_ref403, _excluded403);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10.5858 3.99997L8.75736 2.17154L10.1716 0.757324L14.4142 4.99997L10.1716 9.24261L8.75736 7.82839L10.5858 5.99997H8C6.34315 5.99997 5 7.34311 5 8.99997V13H3V8.99997C3 6.23854 5.23858 3.99997 8 3.99997H10.5858ZM9 11C9 10.4477 9.44772 9.99997 10 9.99997H20C20.5523 9.99997 21 10.4477 21 11V21C21 21.5522 20.5523 22 20 22H10C9.44772 22 9 21.5522 9 21V11ZM11 12V20H19V12H11Z"
  }));
},
    z7 = function z7(_ref404) {
  var _ref404$color = _ref404.color,
      C = _ref404$color === void 0 ? "currentColor" : _ref404$color,
      _ref404$size = _ref404.size,
      e = _ref404$size === void 0 ? 24 : _ref404$size,
      l = _ref404.className,
      i = _objectWithoutProperties(_ref404, _excluded404);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 10H23L19 15L15 10H18V8C18 6.34315 16.6569 5 15 5H11V3H15C17.7614 3 20 5.23858 20 8V10ZM13 9C13.5523 9 14 9.44772 14 10V20C14 20.5523 13.5523 21 13 21H3C2.44772 21 2 20.5523 2 20V10C2 9.44772 2.44772 9 3 9H13Z"
  }));
},
    F7 = function F7(_ref405) {
  var _ref405$color = _ref405.color,
      C = _ref405$color === void 0 ? "currentColor" : _ref405$color,
      _ref405$size = _ref405.size,
      e = _ref405$size === void 0 ? 24 : _ref405$size,
      l = _ref405.className,
      i = _objectWithoutProperties(_ref405, _excluded405);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 10.5858L21.8284 8.75736L23.2426 10.1716L19 14.4142L14.7574 10.1716L16.1716 8.75736L18 10.5858V8C18 6.34315 16.6569 5 15 5H11V3H15C17.7614 3 20 5.23858 20 8V10.5858ZM13 9C13.5523 9 14 9.44772 14 10V20C14 20.5523 13.5523 21 13 21H3C2.44772 21 2 20.5523 2 20V10C2 9.44772 2.44772 9 3 9H13ZM12 11H4V19H12V11Z"
  }));
},
    S7 = function S7(_ref406) {
  var _ref406$color = _ref406.color,
      C = _ref406$color === void 0 ? "currentColor" : _ref406$color,
      _ref406$size = _ref406.size,
      e = _ref406$size === void 0 ? 24 : _ref406$size,
      l = _ref406.className,
      i = _objectWithoutProperties(_ref406, _excluded406);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 10.5858L9.17157 7.75736L7.75736 9.17157L10.5858 12L7.75736 14.8284L9.17157 16.2426L12 13.4142L14.8284 16.2426L16.2426 14.8284L13.4142 12L16.2426 9.17157L14.8284 7.75736L12 10.5858Z"
  }));
},
    A7 = function A7(_ref407) {
  var _ref407$color = _ref407.color,
      C = _ref407$color === void 0 ? "currentColor" : _ref407$color,
      _ref407$size = _ref407.size,
      e = _ref407$size === void 0 ? 24 : _ref407$size,
      l = _ref407.className,
      i = _objectWithoutProperties(_ref407, _excluded407);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 10.5858L14.8284 7.75736L16.2426 9.17157L13.4142 12L16.2426 14.8284L14.8284 16.2426L12 13.4142L9.17157 16.2426L7.75736 14.8284L10.5858 12L7.75736 9.17157L9.17157 7.75736L12 10.5858Z"
  }));
},
    k7 = function k7(_ref408) {
  var _ref408$color = _ref408.color,
      C = _ref408$color === void 0 ? "currentColor" : _ref408$color,
      _ref408$size = _ref408.size,
      e = _ref408$size === void 0 ? 24 : _ref408$size,
      l = _ref408.className,
      i = _objectWithoutProperties(_ref408, _excluded408);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11.9997 10.5865L16.9495 5.63672L18.3637 7.05093L13.4139 12.0007L18.3637 16.9504L16.9495 18.3646L11.9997 13.4149L7.04996 18.3646L5.63574 16.9504L10.5855 12.0007L5.63574 7.05093L7.04996 5.63672L11.9997 10.5865Z"
  }));
},
    P7 = function P7(_ref409) {
  var _ref409$color = _ref409.color,
      C = _ref409$color === void 0 ? "currentColor" : _ref409$color,
      _ref409$size = _ref409.size,
      e = _ref409$size === void 0 ? 24 : _ref409$size,
      l = _ref409.className,
      i = _objectWithoutProperties(_ref409, _excluded409);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11.9997 10.5865L16.9495 5.63672L18.3637 7.05093L13.4139 12.0007L18.3637 16.9504L16.9495 18.3646L11.9997 13.4149L7.04996 18.3646L5.63574 16.9504L10.5855 12.0007L5.63574 7.05093L7.04996 5.63672L11.9997 10.5865Z"
  }));
},
    D7 = function D7(_ref410) {
  var _ref410$color = _ref410.color,
      C = _ref410$color === void 0 ? "currentColor" : _ref410$color,
      _ref410$size = _ref410.size,
      e = _ref410$size === void 0 ? 24 : _ref410$size,
      l = _ref410.className,
      i = _objectWithoutProperties(_ref410, _excluded410);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 3C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21ZM9 8C6.792 8 5 9.792 5 12C5 14.208 6.792 16 9 16C10.1 16 11.1 15.55 11.828 14.828L10.4144 13.4144C10.0525 13.7762 9.5525 14 9 14C7.895 14 7 13.105 7 12C7 10.895 7.895 10 9 10C9.55 10 10.0483 10.22 10.4153 10.5866L11.829 9.173C11.1049 8.44841 10.1045 8 9 8ZM16 8C13.792 8 12 9.792 12 12C12 14.208 13.792 16 16 16C17.104 16 18.104 15.552 18.828 14.828L17.4144 13.4144C17.0525 13.7762 16.5525 14 16 14C14.895 14 14 13.105 14 12C14 10.895 14.895 10 16 10C16.553 10 17.0534 10.2241 17.4153 10.5866L18.829 9.173C18.1049 8.44841 17.1045 8 16 8Z"
  }));
},
    y7 = function y7(_ref411) {
  var _ref411$color = _ref411.color,
      C = _ref411$color === void 0 ? "currentColor" : _ref411$color,
      _ref411$size = _ref411.size,
      e = _ref411$size === void 0 ? 24 : _ref411$size,
      l = _ref411.className,
      i = _objectWithoutProperties(_ref411, _excluded411);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 3C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21ZM20 5H4V19H20V5ZM9 8C10.1045 8 11.1049 8.44841 11.829 9.173L10.4153 10.5866C10.0534 10.2241 9.55299 10 9 10C7.895 10 7 10.895 7 12C7 13.105 7.895 14 9 14C9.5525 14 10.0525 13.7762 10.4144 13.4144L11.828 14.828C11.104 15.552 10.104 16 9 16C6.792 16 5 14.208 5 12C5 9.792 6.792 8 9 8ZM16 8C17.1045 8 18.1049 8.44841 18.829 9.173L17.4153 10.5866C17.0534 10.2241 16.553 10 16 10C14.895 10 14 10.895 14 12C14 13.105 14.895 14 16 14C16.5525 14 17.0525 13.7762 17.4144 13.4144L18.828 14.828C18.104 15.552 17.104 16 16 16C13.792 16 12 14.208 12 12C12 9.792 13.792 8 16 8Z"
  }));
},
    b7 = function b7(_ref412) {
  var _ref412$color = _ref412.color,
      C = _ref412$color === void 0 ? "currentColor" : _ref412$color,
      _ref412$size = _ref412.size,
      e = _ref412$size === void 0 ? 24 : _ref412$size,
      l = _ref412.className,
      i = _objectWithoutProperties(_ref412, _excluded412);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17 7C13.5705 7 10.6449 9.15804 9.50734 12.1903L11.3805 12.8927C12.2337 10.6185 14.4278 9 17 9C17.6983 9 18.3687 9.11928 18.992 9.33857C21.3265 10.16 23 12.3846 23 15C23 18.3137 20.3137 21 17 21H7C3.68629 21 1 18.3137 1 15C1 12.3846 2.67346 10.16 5.00804 9.33857C5.0027 9.22639 5 9.11351 5 9C5 5.13401 8.13401 2 12 2C15.242 2 17.9693 4.20399 18.7652 7.19539C18.1973 7.0675 17.6065 7 17 7Z"
  }));
},
    T7 = function T7(_ref413) {
  var _ref413$color = _ref413.color,
      C = _ref413$color === void 0 ? "currentColor" : _ref413$color,
      _ref413$size = _ref413.size,
      e = _ref413$size === void 0 ? 24 : _ref413$size,
      l = _ref413.className,
      i = _objectWithoutProperties(_ref413, _excluded413);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C15.866 2 19 5.13401 19 9C19 9.11351 18.9973 9.22639 18.992 9.33857C21.3265 10.16 23 12.3846 23 15C23 18.3137 20.3137 21 17 21H7C3.68629 21 1 18.3137 1 15C1 12.3846 2.67346 10.16 5.00804 9.33857C5.0027 9.22639 5 9.11351 5 9C5 5.13401 8.13401 2 12 2ZM12 4C9.23858 4 7 6.23858 7 9C7 9.08147 7.00193 9.16263 7.00578 9.24344L7.07662 10.7309L5.67183 11.2252C4.0844 11.7837 3 13.2889 3 15C3 17.2091 4.79086 19 7 19H17C19.2091 19 21 17.2091 21 15C21 12.79 19.21 11 17 11C15.233 11 13.7337 12.1457 13.2042 13.7347L11.3064 13.1021C12.1005 10.7185 14.35 9 17 9C17 6.23858 14.7614 4 12 4Z"
  }));
},
    U7 = function U7(_ref414) {
  var _ref414$color = _ref414.color,
      C = _ref414$color === void 0 ? "currentColor" : _ref414$color,
      _ref414$size = _ref414.size,
      e = _ref414$size === void 0 ? 24 : _ref414$size,
      l = _ref414.className,
      i = _objectWithoutProperties(_ref414, _excluded414);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3.51472 2.10051L22.6066 21.1924L21.1924 22.6066L19.1782 20.5924C18.503 20.8556 17.7684 21 17 21H7C3.68629 21 1 18.3137 1 15C1 12.3846 2.67346 10.16 5.00804 9.33857C5.0027 9.22639 5 9.11351 5 9C5 8.22228 5.12683 7.47418 5.36094 6.77527L2.10051 3.51472L3.51472 2.10051ZM17 9C17.6983 9 18.3687 9.11928 18.992 9.33857C21.3265 10.16 23 12.3846 23 15C23 16.0883 22.7103 17.1089 22.2037 17.9889L14.0109 9.79638C14.891 9.28977 15.9117 9 17 9ZM12 2C15.242 2 17.9693 4.20399 18.7652 7.19539C18.1973 7.0675 17.6065 7 17 7C15.357 7 13.8297 7.49529 12.5592 8.34471L7.69418 3.48056C8.88169 2.55284 10.3763 2 12 2Z"
  }));
},
    G7 = function G7(_ref415) {
  var _ref415$color = _ref415.color,
      C = _ref415$color === void 0 ? "currentColor" : _ref415$color,
      _ref415$size = _ref415.size,
      e = _ref415$size === void 0 ? 24 : _ref415$size,
      l = _ref415.className,
      i = _objectWithoutProperties(_ref415, _excluded415);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3.51472 2.10051L22.6066 21.1924L21.1924 22.6066L19.1782 20.5924C18.503 20.8556 17.7684 21 17 21H7C3.68629 21 1 18.3137 1 15C1 12.3846 2.67346 10.16 5.00804 9.33857C5.0027 9.22639 5 9.11351 5 9C5 8.22228 5.12683 7.47418 5.36094 6.77527L2.10051 3.51472L3.51472 2.10051ZM7 9C7 9.08147 7.00193 9.16263 7.00578 9.24344L7.07662 10.7309L5.67183 11.2252C4.0844 11.7837 3 13.2889 3 15C3 17.2091 4.79086 19 7 19H17C17.1858 19 17.3687 18.9873 17.5478 18.9628L7.03043 8.44519C7.01032 8.62736 7 8.81247 7 9ZM12 2C15.866 2 19 5.13401 19 9C19 9.11351 18.9973 9.22639 18.992 9.33857C21.3265 10.16 23 12.3846 23 15C23 16.0883 22.7103 17.1089 22.2037 17.9889L20.7111 16.4955C20.8974 16.0335 21 15.5287 21 15C21 12.79 19.21 11 17 11C16.4711 11 15.9661 11.1027 15.5039 11.2892L14.0111 9.7964C14.8912 9.28978 15.9118 9 17 9C17 6.23858 14.7614 4 12 4C10.9295 4 9.93766 4.33639 9.12428 4.90922L7.69418 3.48056C8.88169 2.55284 10.3763 2 12 2Z"
  }));
},
    I7 = function I7(_ref416) {
  var _ref416$color = _ref416.color,
      C = _ref416$color === void 0 ? "currentColor" : _ref416$color,
      _ref416$size = _ref416.size,
      e = _ref416$size === void 0 ? 24 : _ref416$size,
      l = _ref416.className,
      i = _objectWithoutProperties(_ref416, _excluded416);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14 19V15.0069H2.07423C1.39109 13.8286 1 12.46 1 11C1 6.58172 4.58172 3 9 3C12.3949 3 15.2959 5.11466 16.4576 8.09864C16.7951 8.0339 17.1436 8 17.5 8C20.5376 8 23 10.4624 23 13.5C23 16.5376 20.5376 19 17.5 19H14ZM6 21H16V23H6V21ZM2 17H12V19H2V17Z"
  }));
},
    W7 = function W7(_ref417) {
  var _ref417$color = _ref417.color,
      C = _ref417$color === void 0 ? "currentColor" : _ref417$color,
      _ref417$size = _ref417.size,
      e = _ref417$size === void 0 ? 24 : _ref417$size,
      l = _ref417.className,
      i = _objectWithoutProperties(_ref417, _excluded417);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14 18V16H17.5C19.433 16 21 14.433 21 12.5C21 10.567 19.433 9 17.5 9C16.5205 9 15.6351 9.40232 14.9998 10.0507C14.9999 10.0338 15 10.0169 15 10C15 6.68629 12.3137 4 9 4C5.68629 4 3 6.68629 3 10V10.0069H1V10C1 5.58172 4.58172 2 9 2C12.3949 2 15.2959 4.11466 16.4576 7.09864C16.7951 7.0339 17.1436 7 17.5 7C20.5376 7 23 9.46243 23 12.5C23 15.5376 20.5376 18 17.5 18H14ZM6 20H16V22H6V20ZM6 12H14V14H6V12ZM2 16H12V18H2V16Z"
  }));
},
    O7 = function O7(_ref418) {
  var _ref418$color = _ref418.color,
      C = _ref418$color === void 0 ? "currentColor" : _ref418$color,
      _ref418$size = _ref418.size,
      e = _ref418$size === void 0 ? 24 : _ref418$size,
      l = _ref418.className,
      i = _objectWithoutProperties(_ref418, _excluded418);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17 21H7C3.68629 21 1 18.3137 1 15C1 12.3846 2.67346 10.16 5.00804 9.33857C5.0027 9.22639 5 9.11351 5 9C5 5.13401 8.13401 2 12 2C15.866 2 19 5.13401 19 9C19 9.11351 18.9973 9.22639 18.992 9.33857C21.3265 10.16 23 12.3846 23 15C23 18.3137 20.3137 21 17 21Z"
  }));
},
    K7 = function K7(_ref419) {
  var _ref419$color = _ref419.color,
      C = _ref419$color === void 0 ? "currentColor" : _ref419$color,
      _ref419$size = _ref419.size,
      e = _ref419$size === void 0 ? 24 : _ref419$size,
      l = _ref419.className,
      i = _objectWithoutProperties(_ref419, _excluded419);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17 21H7C3.68629 21 1 18.3137 1 15C1 12.3846 2.67346 10.16 5.00804 9.33857C5.0027 9.22639 5 9.11351 5 9C5 5.13401 8.13401 2 12 2C15.866 2 19 5.13401 19 9C19 9.11351 18.9973 9.22639 18.992 9.33857C21.3265 10.16 23 12.3846 23 15C23 18.3137 20.3137 21 17 21ZM7 19H17C19.2091 19 21 17.2091 21 15C21 12.7909 19.2091 11 17 11C16.8561 11 16.714 11.0076 16.5741 11.0224C16.8479 10.4041 17 9.71979 17 9C17 6.23858 14.7614 4 12 4C9.23858 4 7 6.23858 7 9C7 9.71979 7.15209 10.4041 7.4259 11.0224C7.28596 11.0076 7.14387 11 7 11C4.79086 11 3 12.7909 3 15C3 17.2091 4.79086 19 7 19Z"
  }));
},
    Q7 = function Q7(_ref420) {
  var _ref420$color = _ref420.color,
      C = _ref420$color === void 0 ? "currentColor" : _ref420$color,
      _ref420$size = _ref420.size,
      e = _ref420$size === void 0 ? 24 : _ref420$size,
      l = _ref420.className,
      i = _objectWithoutProperties(_ref420, _excluded420);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9 20.9855C4.53831 20.7267 1 17.0266 1 12.5C1 7.80558 4.80558 4 9.5 4C12.5433 4 15.2131 5.59939 16.7146 8.00348C20.2051 8.11671 23 10.982 23 14.5C23 17.9216 20.3562 20.7257 17 20.9811V21H9V20.9855Z"
  }));
},
    q7 = function q7(_ref421) {
  var _ref421$color = _ref421.color,
      C = _ref421$color === void 0 ? "currentColor" : _ref421$color,
      _ref421$size = _ref421.size,
      e = _ref421$size === void 0 ? 24 : _ref421$size,
      l = _ref421.className,
      i = _objectWithoutProperties(_ref421, _excluded421);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9.5 6C5.91015 6 3 8.91015 3 12.5C3 16.0899 5.91015 19 9.5 19H16.5C18.9853 19 21 16.9853 21 14.5C21 12.0147 18.9853 10 16.5 10C16.1717 10 15.8516 10.0352 15.5433 10.1019C14.589 7.69894 12.2429 6 9.5 6ZM16.5 21H9.5C4.80558 21 1 17.1944 1 12.5C1 7.80558 4.80558 4 9.5 4C12.5433 4 15.2131 5.59939 16.7146 8.00348C20.2051 8.11671 23 10.982 23 14.5C23 18.0899 20.0899 21 16.5 21Z"
  }));
},
    j7 = function j7(_ref422) {
  var _ref422$color = _ref422.color,
      C = _ref422$color === void 0 ? "currentColor" : _ref422$color,
      _ref422$size = _ref422.size,
      e = _ref422$size === void 0 ? 24 : _ref422$size,
      l = _ref422.className,
      i = _objectWithoutProperties(_ref422, _excluded422);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM16.4645 15.5355L20 12L16.4645 8.46447L15.0503 9.87868L17.1716 12L15.0503 14.1213L16.4645 15.5355ZM6.82843 12L8.94975 9.87868L7.53553 8.46447L4 12L7.53553 15.5355L8.94975 14.1213L6.82843 12ZM11.2443 17L14.884 7H12.7557L9.11597 17H11.2443Z"
  }));
},
    X7 = function X7(_ref423) {
  var _ref423$color = _ref423.color,
      C = _ref423$color === void 0 ? "currentColor" : _ref423$color,
      _ref423$size = _ref423.size,
      e = _ref423$size === void 0 ? 24 : _ref423$size,
      l = _ref423.className,
      i = _objectWithoutProperties(_ref423, _excluded423);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM4 5V19H20V5H4ZM20 12L16.4645 15.5355L15.0503 14.1213L17.1716 12L15.0503 9.87868L16.4645 8.46447L20 12ZM6.82843 12L8.94975 14.1213L7.53553 15.5355L4 12L7.53553 8.46447L8.94975 9.87868L6.82843 12ZM11.2443 17H9.11597L12.7557 7H14.884L11.2443 17Z"
  }));
},
    J7 = function J7(_ref424) {
  var _ref424$color = _ref424.color,
      C = _ref424$color === void 0 ? "currentColor" : _ref424$color,
      _ref424$size = _ref424.size,
      e = _ref424$size === void 0 ? 24 : _ref424$size,
      l = _ref424.className,
      i = _objectWithoutProperties(_ref424, _excluded424);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M23 12L15.9289 19.0711L14.5147 17.6569L20.1716 12L14.5147 6.34317L15.9289 4.92896L23 12ZM3.82843 12L9.48528 17.6569L8.07107 19.0711L1 12L8.07107 4.92896L9.48528 6.34317L3.82843 12Z"
  }));
},
    Y7 = function Y7(_ref425) {
  var _ref425$color = _ref425.color,
      C = _ref425$color === void 0 ? "currentColor" : _ref425$color,
      _ref425$size = _ref425.size,
      e = _ref425$size === void 0 ? 24 : _ref425$size,
      l = _ref425.className,
      i = _objectWithoutProperties(_ref425, _excluded425);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M23 12L15.9289 19.0711L14.5147 17.6569L20.1716 12L14.5147 6.34317L15.9289 4.92896L23 12ZM3.82843 12L9.48528 17.6569L8.07107 19.0711L1 12L8.07107 4.92896L9.48528 6.34317L3.82843 12Z"
  }));
},
    _7 = function _7(_ref426) {
  var _ref426$color = _ref426.color,
      C = _ref426$color === void 0 ? "currentColor" : _ref426$color,
      _ref426$size = _ref426.size,
      e = _ref426$size === void 0 ? 24 : _ref426$size,
      l = _ref426.className,
      i = _objectWithoutProperties(_ref426, _excluded426);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M24 12L18.3431 17.6568L16.9289 16.2426L21.1716 12L16.9289 7.75735L18.3431 6.34314L24 12ZM2.82843 12L7.07107 16.2426L5.65685 17.6568L0 12L5.65685 6.34314L7.07107 7.75735L2.82843 12Z"
  }));
},
    $7 = function $7(_ref427) {
  var _ref427$color = _ref427.color,
      C = _ref427$color === void 0 ? "currentColor" : _ref427$color,
      _ref427$size = _ref427.size,
      e = _ref427$size === void 0 ? 24 : _ref427$size,
      l = _ref427.className,
      i = _objectWithoutProperties(_ref427, _excluded427);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M24 12L18.3431 17.6568L16.9289 16.2426L21.1716 12L16.9289 7.75735L18.3431 6.34314L24 12ZM2.82843 12L7.07107 16.2426L5.65685 17.6568L0 12L5.65685 6.34314L7.07107 7.75735L2.82843 12Z"
  }));
},
    e3 = function e3(_ref428) {
  var _ref428$color = _ref428.color,
      C = _ref428$color === void 0 ? "currentColor" : _ref428$color,
      _ref428$size = _ref428.size,
      e = _ref428$size === void 0 ? 24 : _ref428$size,
      l = _ref428.className,
      i = _objectWithoutProperties(_ref428, _excluded428);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M24 12L18.3431 17.6569L16.9289 16.2426L21.1716 12L16.9289 7.75736L18.3431 6.34315L24 12ZM2.82843 12L7.07107 16.2426L5.65685 17.6569L0 12L5.65685 6.34315L7.07107 7.75736L2.82843 12ZM9.78845 21H7.66009L14.2116 3H16.3399L9.78845 21Z"
  }));
},
    t3 = function t3(_ref429) {
  var _ref429$color = _ref429.color,
      C = _ref429$color === void 0 ? "currentColor" : _ref429$color,
      _ref429$size = _ref429.size,
      e = _ref429$size === void 0 ? 24 : _ref429$size,
      l = _ref429.className,
      i = _objectWithoutProperties(_ref429, _excluded429);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M24 12L18.3431 17.6569L16.9289 16.2426L21.1716 12L16.9289 7.75736L18.3431 6.34315L24 12ZM2.82843 12L7.07107 16.2426L5.65685 17.6569L0 12L5.65685 6.34315L7.07107 7.75736L2.82843 12ZM9.78845 21H7.66009L14.2116 3H16.3399L9.78845 21Z"
  }));
},
    C3 = function C3(_ref430) {
  var _ref430$color = _ref430.color,
      C = _ref430$color === void 0 ? "currentColor" : _ref430$color,
      _ref430$size = _ref430.size,
      e = _ref430$size === void 0 ? 24 : _ref430$size,
      l = _ref430.className,
      i = _objectWithoutProperties(_ref430, _excluded430);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16.95 8.46448L18.3642 7.05026L23.3139 12L18.3642 16.9498L16.95 15.5355L20.4855 12L16.95 8.46448ZM7.05048 8.46448L3.51495 12L7.05048 15.5355L5.63627 16.9498L0.686523 12L5.63627 7.05026L7.05048 8.46448Z"
  }));
},
    l3 = function l3(_ref431) {
  var _ref431$color = _ref431.color,
      C = _ref431$color === void 0 ? "currentColor" : _ref431$color,
      _ref431$size = _ref431.size,
      e = _ref431$size === void 0 ? 24 : _ref431$size,
      l = _ref431.className,
      i = _objectWithoutProperties(_ref431, _excluded431);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 10.2018L9.30278 12L12 13.7982L14.6972 12L12 10.2018ZM16.5 10.7982L19.1972 9L13 4.86852V8.46482L16.5 10.7982ZM20 10.8685L18.3028 12L20 13.1315V10.8685ZM16.5 13.2018L13 15.5352V19.1315L19.1972 15L16.5 13.2018ZM11 8.46482V4.86852L4.80278 9L7.5 10.7982L11 8.46482ZM4.80278 15L11 19.1315V15.5352L7.5 13.2018L4.80278 15ZM5.69722 12L4 10.8685V13.1315L5.69722 12ZM2 9C2 8.66565 2.1671 8.35342 2.4453 8.16795L11.4453 2.16795C11.7812 1.94402 12.2188 1.94402 12.5547 2.16795L21.5547 8.16795C21.8329 8.35342 22 8.66565 22 9V15C22 15.3344 21.8329 15.6466 21.5547 15.8321L12.5547 21.8321C12.2188 22.056 11.7812 22.056 11.4453 21.8321L2.4453 15.8321C2.1671 15.6466 2 15.3344 2 15V9Z"
  }));
},
    i3 = function i3(_ref432) {
  var _ref432$color = _ref432.color,
      C = _ref432$color === void 0 ? "currentColor" : _ref432$color,
      _ref432$size = _ref432.size,
      e = _ref432$size === void 0 ? 24 : _ref432$size,
      l = _ref432.className,
      i = _objectWithoutProperties(_ref432, _excluded432);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16.5 13.2018L13 15.5352V19.1315L19.1972 15L16.5 13.2018ZM14.6972 12L12 10.2018L9.30278 12L12 13.7982L14.6972 12ZM20 10.8685L18.3028 12L20 13.1315V10.8685ZM19.1972 9L13 4.86852V8.46482L16.5 10.7982L19.1972 9ZM7.5 10.7982L11 8.46482V4.86852L4.80278 9L7.5 10.7982ZM4.80278 15L11 19.1315V15.5352L7.5 13.2018L4.80278 15ZM4 13.1315L5.69722 12L4 10.8685V13.1315ZM2 9C2 8.66565 2.1671 8.35342 2.4453 8.16795L11.4453 2.16795C11.7812 1.94402 12.2188 1.94402 12.5547 2.16795L21.5547 8.16795C21.8329 8.35342 22 8.66565 22 9V15C22 15.3344 21.8329 15.6466 21.5547 15.8321L12.5547 21.8321C12.2188 22.056 11.7812 22.056 11.4453 21.8321L2.4453 15.8321C2.1671 15.6466 2 15.3344 2 15V9Z"
  }));
},
    s3 = function s3(_ref433) {
  var _ref433$color = _ref433.color,
      C = _ref433$color === void 0 ? "currentColor" : _ref433$color,
      _ref433$size = _ref433.size,
      e = _ref433$size === void 0 ? 24 : _ref433$size,
      l = _ref433.className,
      i = _objectWithoutProperties(_ref433, _excluded433);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M23.0049 12.0028V14.0028C23.0049 17.3165 18.08 20.0028 12.0049 20.0028C6.03824 20.0028 1.18114 17.4116 1.00957 14.1797L1.00488 14.0028V12.0028C1.00488 15.3165 5.92975 18.0028 12.0049 18.0028C18.08 18.0028 23.0049 15.3165 23.0049 12.0028ZM12.0049 4.00281C18.08 4.00281 23.0049 6.6891 23.0049 10.0028C23.0049 13.3165 18.08 16.0028 12.0049 16.0028C5.92975 16.0028 1.00488 13.3165 1.00488 10.0028C1.00488 6.6891 5.92975 4.00281 12.0049 4.00281Z"
  }));
},
    r3 = function r3(_ref434) {
  var _ref434$color = _ref434.color,
      C = _ref434$color === void 0 ? "currentColor" : _ref434$color,
      _ref434$size = _ref434.size,
      e = _ref434$size === void 0 ? 24 : _ref434$size,
      l = _ref434.className,
      i = _objectWithoutProperties(_ref434, _excluded434);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.0049 4.00281C18.08 4.00281 23.0049 6.6891 23.0049 10.0028V14.0028C23.0049 17.3165 18.08 20.0028 12.0049 20.0028C6.03824 20.0028 1.18114 17.4116 1.00957 14.1797L1.00488 14.0028V10.0028C1.00488 6.6891 5.92975 4.00281 12.0049 4.00281ZM12.0049 16.0028C8.28443 16.0028 4.99537 14.9953 3.00466 13.4533L3.00488 14.0028C3.00488 15.885 6.88751 18.0028 12.0049 18.0028C17.0156 18.0028 20.8426 15.9723 20.9999 14.1207L21.0049 14.0028L21.0061 13.4525C19.0155 14.995 15.726 16.0028 12.0049 16.0028ZM12.0049 6.00281C6.88751 6.00281 3.00488 8.12061 3.00488 10.0028C3.00488 11.885 6.88751 14.0028 12.0049 14.0028C17.1223 14.0028 21.0049 11.885 21.0049 10.0028C21.0049 8.12061 17.1223 6.00281 12.0049 6.00281Z"
  }));
},
    c3 = function c3(_ref435) {
  var _ref435$color = _ref435.color,
      C = _ref435$color === void 0 ? "currentColor" : _ref435$color,
      _ref435$size = _ref435.size,
      e = _ref435$size === void 0 ? 24 : _ref435$size,
      l = _ref435.className,
      i = _objectWithoutProperties(_ref435, _excluded435);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14.0049 2.00281C18.4232 2.00281 22.0049 5.58453 22.0049 10.0028C22.0049 13.2474 20.0733 16.0409 17.2973 17.296C16.0422 20.0718 13.249 22.0028 10.0049 22.0028C5.5866 22.0028 2.00488 18.4211 2.00488 14.0028C2.00488 10.7587 3.9359 7.96554 6.71122 6.71012C7.96681 3.93438 10.7603 2.00281 14.0049 2.00281ZM11.0049 9.00281H9.00488V10.0028C7.62417 10.0028 6.50488 11.1221 6.50488 12.5028C6.50488 13.8283 7.53642 14.9128 8.84051 14.9975L9.00488 15.0028H11.0049L11.0948 15.0109C11.328 15.0532 11.5049 15.2573 11.5049 15.5028C11.5049 15.7483 11.328 15.9524 11.0948 15.9948L11.0049 16.0028H7.00488V18.0028H9.00488V19.0028H11.0049V18.0028C12.3856 18.0028 13.5049 16.8835 13.5049 15.5028C13.5049 14.1773 12.4733 13.0928 11.1693 13.0081L11.0049 13.0028H9.00488L8.91501 12.9948C8.68176 12.9524 8.50488 12.7483 8.50488 12.5028C8.50488 12.2573 8.68176 12.0532 8.91501 12.0109L9.00488 12.0028H13.0049V10.0028H11.0049V9.00281ZM14.0049 4.00281C12.2214 4.00281 10.6196 4.78097 9.52064 6.01629C9.68133 6.00764 9.84254 6.00281 10.0049 6.00281C14.4232 6.00281 18.0049 9.58453 18.0049 14.0028C18.0049 14.1655 18 14.327 17.9905 14.4873C19.2265 13.3885 20.0049 11.7866 20.0049 10.0028C20.0049 6.6891 17.3186 4.00281 14.0049 4.00281Z"
  }));
},
    o3 = function o3(_ref436) {
  var _ref436$color = _ref436.color,
      C = _ref436$color === void 0 ? "currentColor" : _ref436$color,
      _ref436$size = _ref436.size,
      e = _ref436$size === void 0 ? 24 : _ref436$size,
      l = _ref436.className,
      i = _objectWithoutProperties(_ref436, _excluded436);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14.0049 2.00281C18.4232 2.00281 22.0049 5.58453 22.0049 10.0028C22.0049 13.2474 20.0733 16.0409 17.2973 17.296C16.0422 20.0718 13.249 22.0028 10.0049 22.0028C5.5866 22.0028 2.00488 18.4211 2.00488 14.0028C2.00488 10.7587 3.9359 7.96554 6.71122 6.71012C7.96681 3.93438 10.7603 2.00281 14.0049 2.00281ZM10.0049 8.00281C6.69117 8.00281 4.00488 10.6891 4.00488 14.0028C4.00488 17.3165 6.69117 20.0028 10.0049 20.0028C13.3186 20.0028 16.0049 17.3165 16.0049 14.0028C16.0049 10.6891 13.3186 8.00281 10.0049 8.00281ZM11.0049 9.00281V10.0028H13.0049V12.0028H9.00488C8.72874 12.0028 8.50488 12.2267 8.50488 12.5028C8.50488 12.7483 8.68176 12.9524 8.91501 12.9948L9.00488 13.0028H11.0049C12.3856 13.0028 13.5049 14.1221 13.5049 15.5028C13.5049 16.8835 12.3856 18.0028 11.0049 18.0028V19.0028H9.00488V18.0028H7.00488V16.0028H11.0049C11.281 16.0028 11.5049 15.7789 11.5049 15.5028C11.5049 15.2573 11.328 15.0532 11.0948 15.0109L11.0049 15.0028H9.00488C7.62417 15.0028 6.50488 13.8835 6.50488 12.5028C6.50488 11.1221 7.62417 10.0028 9.00488 10.0028V9.00281H11.0049ZM14.0049 4.00281C12.2214 4.00281 10.6196 4.78097 9.52064 6.01629C9.68133 6.00764 9.84254 6.00281 10.0049 6.00281C14.4232 6.00281 18.0049 9.58453 18.0049 14.0028C18.0049 14.1655 18 14.327 17.9905 14.4873C19.2265 13.3885 20.0049 11.7866 20.0049 10.0028C20.0049 6.6891 17.3186 4.00281 14.0049 4.00281Z"
  }));
},
    a3 = function a3(_ref437) {
  var _ref437$color = _ref437.color,
      C = _ref437$color === void 0 ? "currentColor" : _ref437$color,
      _ref437$size = _ref437.size,
      e = _ref437$size === void 0 ? 24 : _ref437$size,
      l = _ref437.className,
      i = _objectWithoutProperties(_ref437, _excluded437);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11.1889 13.2642L12.5715 21.106L4.00024 21.1067C3.44795 21.1067 3.00024 20.659 3.00024 20.1067L2.99951 14.709L11.1889 13.2642ZM20.0002 3.10668C20.5525 3.10668 21.0002 3.5544 21.0002 4.10668V20.1067C21.0002 20.659 20.5525 21.1067 20.0002 21.1067L14.6025 21.106L11.4285 3.10596L20.0002 3.10668ZM9.39751 3.10596L10.8416 11.2945L2.99951 12.678L3.00024 4.10668C3.00024 3.5544 3.44795 3.10668 4.00024 3.10668L9.39751 3.10596Z"
  }));
},
    n3 = function n3(_ref438) {
  var _ref438$color = _ref438.color,
      C = _ref438$color === void 0 ? "currentColor" : _ref438$color,
      _ref438$size = _ref438.size,
      e = _ref438$size === void 0 ? 24 : _ref438$size,
      l = _ref438.className,
      i = _objectWithoutProperties(_ref438, _excluded438);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 3.10669C20.5523 3.10669 21 3.5544 21 4.10669V20.1067C21 20.659 20.5523 21.1067 20 21.1067H4C3.44772 21.1067 3 20.659 3 20.1067V4.10669C3 3.5544 3.44772 3.10669 4 3.10669H20ZM11.1888 13.2651L5 14.3557V19.1067H12.218L11.1888 13.2651ZM19 5.10669H11.781L14.249 19.1067H19V5.10669ZM9.75 5.10669H5V12.3247L10.8415 11.2955L9.75 5.10669Z"
  }));
},
    m3 = function m3(_ref439) {
  var _ref439$color = _ref439.color,
      C = _ref439$color === void 0 ? "currentColor" : _ref439$color,
      _ref439$size = _ref439.size,
      e = _ref439$size === void 0 ? 24 : _ref439$size,
      l = _ref439.className,
      i = _objectWithoutProperties(_ref439, _excluded439);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10 8H14V6.5C14 4.567 15.567 3 17.5 3C19.433 3 21 4.567 21 6.5C21 8.433 19.433 10 17.5 10H16V14H17.5C19.433 14 21 15.567 21 17.5C21 19.433 19.433 21 17.5 21C15.567 21 14 19.433 14 17.5V16H10V17.5C10 19.433 8.433 21 6.5 21C4.567 21 3 19.433 3 17.5C3 15.567 4.567 14 6.5 14H8V10H6.5C4.567 10 3 8.433 3 6.5C3 4.567 4.567 3 6.5 3C8.433 3 10 4.567 10 6.5V8ZM8 8V6.5C8 5.67157 7.32843 5 6.5 5C5.67157 5 5 5.67157 5 6.5C5 7.32843 5.67157 8 6.5 8H8ZM8 16H6.5C5.67157 16 5 16.6716 5 17.5C5 18.3284 5.67157 19 6.5 19C7.32843 19 8 18.3284 8 17.5V16ZM16 8H17.5C18.3284 8 19 7.32843 19 6.5C19 5.67157 18.3284 5 17.5 5C16.6716 5 16 5.67157 16 6.5V8ZM16 16V17.5C16 18.3284 16.6716 19 17.5 19C18.3284 19 19 18.3284 19 17.5C19 16.6716 18.3284 16 17.5 16H16ZM10 10V14H14V10H10Z"
  }));
},
    w3 = function w3(_ref440) {
  var _ref440$color = _ref440.color,
      C = _ref440$color === void 0 ? "currentColor" : _ref440$color,
      _ref440$size = _ref440.size,
      e = _ref440$size === void 0 ? 24 : _ref440$size,
      l = _ref440.className,
      i = _objectWithoutProperties(_ref440, _excluded440);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10 8H14V6.5C14 4.567 15.567 3 17.5 3C19.433 3 21 4.567 21 6.5C21 8.433 19.433 10 17.5 10H16V14H17.5C19.433 14 21 15.567 21 17.5C21 19.433 19.433 21 17.5 21C15.567 21 14 19.433 14 17.5V16H10V17.5C10 19.433 8.433 21 6.5 21C4.567 21 3 19.433 3 17.5C3 15.567 4.567 14 6.5 14H8V10H6.5C4.567 10 3 8.433 3 6.5C3 4.567 4.567 3 6.5 3C8.433 3 10 4.567 10 6.5V8ZM8 8V6.5C8 5.67157 7.32843 5 6.5 5C5.67157 5 5 5.67157 5 6.5C5 7.32843 5.67157 8 6.5 8H8ZM8 16H6.5C5.67157 16 5 16.6716 5 17.5C5 18.3284 5.67157 19 6.5 19C7.32843 19 8 18.3284 8 17.5V16ZM16 8H17.5C18.3284 8 19 7.32843 19 6.5C19 5.67157 18.3284 5 17.5 5C16.6716 5 16 5.67157 16 6.5V8ZM16 16V17.5C16 18.3284 16.6716 19 17.5 19C18.3284 19 19 18.3284 19 17.5C19 16.6716 18.3284 16 17.5 16H16ZM10 10V14H14V10H10Z"
  }));
},
    L3 = function L3(_ref441) {
  var _ref441$color = _ref441.color,
      C = _ref441$color === void 0 ? "currentColor" : _ref441$color,
      _ref441$size = _ref441.size,
      e = _ref441$size === void 0 ? 24 : _ref441$size,
      l = _ref441.className,
      i = _objectWithoutProperties(_ref441, _excluded441);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9 19H12V12.9416L8 9.45402L4 12.9416V19H7V15H9V19ZM21 21H3C2.44772 21 2 20.5523 2 20V12.4868C2 12.1978 2.12501 11.9229 2.34282 11.733L6 8.54435V4C6 3.44772 6.44772 3 7 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21ZM16 11V13H18V11H16ZM16 15V17H18V15H16ZM16 7V9H18V7H16ZM12 7V9H14V7H12Z"
  }));
},
    h3 = function h3(_ref442) {
  var _ref442$color = _ref442.color,
      C = _ref442$color === void 0 ? "currentColor" : _ref442$color,
      _ref442$size = _ref442.size,
      e = _ref442$size === void 0 ? 24 : _ref442$size,
      l = _ref442.className,
      i = _objectWithoutProperties(_ref442, _excluded442);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 21H3C2.44772 21 2 20.5523 2 20V12.4868C2 12.1978 2.12501 11.9229 2.34282 11.733L6 8.54435V4C6 3.44772 6.44772 3 7 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21ZM9 19H12V12.9416L8 9.45402L4 12.9416V19H7V15H9V19ZM14 19H20V5H8V7.12729C8.23444 7.12729 8.46888 7.20938 8.65718 7.37355L13.6572 11.733C13.875 11.9229 14 12.1978 14 12.4868V19ZM16 11H18V13H16V11ZM16 15H18V17H16V15ZM16 7H18V9H16V7ZM12 7H14V9H12V7Z"
  }));
},
    H3 = function H3(_ref443) {
  var _ref443$color = _ref443.color,
      C = _ref443$color === void 0 ? "currentColor" : _ref443$color,
      _ref443$size = _ref443.size,
      e = _ref443$size === void 0 ? 24 : _ref443$size,
      l = _ref443.className,
      i = _objectWithoutProperties(_ref443, _excluded443);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18.3277 4.25809L10.5858 12L12 13.4142L19.7419 5.6723C21.153 7.39641 22 9.5999 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2C14.4001 2 16.6036 2.84695 18.3277 4.25809Z"
  }));
},
    V3 = function V3(_ref444) {
  var _ref444$color = _ref444.color,
      C = _ref444$color === void 0 ? "currentColor" : _ref444$color,
      _ref444$size = _ref444.size,
      e = _ref444$size === void 0 ? 24 : _ref444$size,
      l = _ref444.className,
      i = _objectWithoutProperties(_ref444, _excluded444);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16.6248 3.13258L15.1247 4.63267C14.1648 4.22531 13.1088 4 12 4C7.58 4 4 7.58 4 12C4 16.42 7.58 20 12 20C16.42 20 20 16.42 20 12C20 10.8912 19.7747 9.83517 19.3673 8.87531L20.8674 7.37522C21.5908 8.75852 22 10.3318 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2C13.6682 2 15.2415 2.40918 16.6248 3.13258ZM18.364 4.22183L19.7782 5.63604L12 13.4142L10.5858 12L18.364 4.22183Z"
  }));
},
    g3 = function g3(_ref445) {
  var _ref445$color = _ref445.color,
      C = _ref445$color === void 0 ? "currentColor" : _ref445$color,
      _ref445$size = _ref445.size,
      e = _ref445$size === void 0 ? 24 : _ref445$size,
      l = _ref445.className,
      i = _objectWithoutProperties(_ref445, _excluded445);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM16.5 7.5L10 10L7.5 16.5L14 14L16.5 7.5ZM12 13C11.4477 13 11 12.5523 11 12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12C13 12.5523 12.5523 13 12 13Z"
  }));
},
    M3 = function M3(_ref446) {
  var _ref446$color = _ref446.color,
      C = _ref446$color === void 0 ? "currentColor" : _ref446$color,
      _ref446$size = _ref446.size,
      e = _ref446$size === void 0 ? 24 : _ref446$size,
      l = _ref446.className,
      i = _objectWithoutProperties(_ref446, _excluded446);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM16.5 7.5L14 14L7.5 16.5L10 10L16.5 7.5ZM12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
  }));
},
    Z3 = function Z3(_ref447) {
  var _ref447$color = _ref447.color,
      C = _ref447$color === void 0 ? "currentColor" : _ref447$color,
      _ref447$size = _ref447.size,
      e = _ref447$size === void 0 ? 24 : _ref447$size,
      l = _ref447.className,
      i = _objectWithoutProperties(_ref447, _excluded447);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM15.4462 9.96803C15.102 9.38559 14.6144 8.89798 14.032 8.55382L8.55382 14.032C8.89798 14.6144 9.38559 15.102 9.96803 15.4462L15.4462 9.96803Z"
  }));
},
    x3 = function x3(_ref448) {
  var _ref448$color = _ref448.color,
      C = _ref448$color === void 0 ? "currentColor" : _ref448$color,
      _ref448$size = _ref448.size,
      e = _ref448$size === void 0 ? 24 : _ref448$size,
      l = _ref448.className,
      i = _objectWithoutProperties(_ref448, _excluded448);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM15.4462 9.96803L9.96803 15.4462C9.38559 15.102 8.89798 14.6144 8.55382 14.032L14.032 8.55382C14.6144 8.89798 15.102 9.38559 15.4462 9.96803Z"
  }));
},
    v3 = function v3(_ref449) {
  var _ref449$color = _ref449.color,
      C = _ref449$color === void 0 ? "currentColor" : _ref449$color,
      _ref449$size = _ref449.size,
      e = _ref449$size === void 0 ? 24 : _ref449$size,
      l = _ref449.className,
      i = _objectWithoutProperties(_ref449, _excluded449);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13 22C7.47715 22 3 17.5228 3 12C3 6.47715 7.47715 2 13 2C18.5228 2 23 6.47715 23 12C23 17.5228 18.5228 22 13 22ZM8 11.5L12 13L13.5 17.0021L17 8L8 11.5Z"
  }));
},
    d3 = function d3(_ref450) {
  var _ref450$color = _ref450.color,
      C = _ref450$color === void 0 ? "currentColor" : _ref450$color,
      _ref450$size = _ref450.size,
      e = _ref450$size === void 0 ? 24 : _ref450$size,
      l = _ref450.className,
      i = _objectWithoutProperties(_ref450, _excluded450);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM7 11.5L16 8L12.5 17.0021L11 13L7 11.5Z"
  }));
},
    p3 = function p3(_ref451) {
  var _ref451$color = _ref451.color,
      C = _ref451$color === void 0 ? "currentColor" : _ref451$color,
      _ref451$size = _ref451.size,
      e = _ref451$size === void 0 ? 24 : _ref451$size,
      l = _ref451.className,
      i = _objectWithoutProperties(_ref451, _excluded451);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM15.5 8.5L10.5 10.5L8.5 15.5L13.5 13.5L15.5 8.5Z"
  }));
},
    E3 = function E3(_ref452) {
  var _ref452$color = _ref452.color,
      C = _ref452$color === void 0 ? "currentColor" : _ref452$color,
      _ref452$size = _ref452.size,
      e = _ref452$size === void 0 ? 24 : _ref452$size,
      l = _ref452.className,
      i = _objectWithoutProperties(_ref452, _excluded452);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM15.5 8.5L13.5 13.5L8.5 15.5L10.5 10.5L15.5 8.5Z"
  }));
},
    N3 = function N3(_ref453) {
  var _ref453$color = _ref453.color,
      C = _ref453$color === void 0 ? "currentColor" : _ref453$color,
      _ref453$size = _ref453.size,
      e = _ref453$size === void 0 ? 24 : _ref453$size,
      l = _ref453.className,
      i = _objectWithoutProperties(_ref453, _excluded453);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16.3303 13.497C17.9562 12.2151 19 10.2278 19 7.9967H21C21 10.9687 19.5595 13.6043 17.3385 15.2432L19.8661 19.6211C20.4183 20.5776 20.0906 21.8008 19.134 22.3531L15.6073 16.2447C14.5029 16.7283 13.2828 16.9967 12 16.9967C10.7172 16.9967 9.49712 16.7283 8.39278 16.2447L4.86606 22.3531C3.90947 21.8008 3.58172 20.5776 4.13401 19.6211L9.19751 10.8508C8.45844 10.125 8.00003 9.11439 8.00003 7.9967C8.00003 6.13286 9.2748 4.56676 11 4.12272V1.9967H13V4.12272C14.7253 4.56676 16 6.13286 16 7.9967C16 9.11439 15.5416 10.125 14.8025 10.8508L16.3303 13.497ZM14.599 14.4983L13.071 11.8517C12.7302 11.9462 12.371 11.9967 12 11.9967C11.6291 11.9967 11.2699 11.9462 10.929 11.8517L9.40101 14.4983C10.2046 14.8198 11.0817 14.9967 12 14.9967C12.9184 14.9967 13.7955 14.8198 14.599 14.4983ZM12 8.9967C12.5523 8.9967 13 8.54899 13 7.9967C13 7.44442 12.5523 6.9967 12 6.9967C11.4477 6.9967 11 7.44442 11 7.9967C11 8.54899 11.4477 8.9967 12 8.9967Z"
  }));
},
    u3 = function u3(_ref454) {
  var _ref454$color = _ref454.color,
      C = _ref454$color === void 0 ? "currentColor" : _ref454$color,
      _ref454$size = _ref454.size,
      e = _ref454$size === void 0 ? 24 : _ref454$size,
      l = _ref454.className,
      i = _objectWithoutProperties(_ref454, _excluded454);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16.3303 13.497C17.9562 12.2151 19 10.2278 19 7.9967H21C21 10.9687 19.5595 13.6043 17.3385 15.2432L19.8661 19.6211C20.4183 20.5776 20.0906 21.8008 19.134 22.3531L15.6073 16.2447C14.5029 16.7283 13.2828 16.9967 12 16.9967C10.7172 16.9967 9.49712 16.7283 8.39278 16.2447L4.86606 22.3531C3.90947 21.8008 3.58172 20.5776 4.13401 19.6211L9.19751 10.8508C8.45844 10.125 8.00003 9.11439 8.00003 7.9967C8.00003 6.13286 9.2748 4.56676 11 4.12272V1.9967H13V4.12272C14.7253 4.56676 16 6.13286 16 7.9967C16 9.11439 15.5416 10.125 14.8025 10.8508L16.3303 13.497ZM14.599 14.4983L13.071 11.8517C12.7302 11.9462 12.371 11.9967 12 11.9967C11.6291 11.9967 11.2699 11.9462 10.929 11.8517L9.40101 14.4983C10.2046 14.8198 11.0817 14.9967 12 14.9967C12.9184 14.9967 13.7955 14.8198 14.599 14.4983ZM12 9.9967C13.1046 9.9967 14 9.10127 14 7.9967C14 6.89213 13.1046 5.9967 12 5.9967C10.8955 5.9967 10 6.89213 10 7.9967C10 9.10127 10.8955 9.9967 12 9.9967Z"
  }));
},
    B3 = function B3(_ref455) {
  var _ref455$color = _ref455.color,
      C = _ref455$color === void 0 ? "currentColor" : _ref455$color,
      _ref455$size = _ref455.size,
      e = _ref455$size === void 0 ? 24 : _ref455$size,
      l = _ref455.className,
      i = _objectWithoutProperties(_ref455, _excluded455);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10.9998 4.12272V1.9967H12.9998V4.12272C14.725 4.56676 15.9998 6.13286 15.9998 7.9967C15.9998 9.11439 15.5414 10.125 14.8023 10.8508L20.8658 21.3531L19.1338 22.3531L13.0708 11.8517C12.7299 11.9462 12.3708 11.9967 11.9998 11.9967C11.6289 11.9967 11.2697 11.9462 10.9288 11.8517L4.86584 22.3531L3.13379 21.3531L9.1973 10.8508C8.45823 10.125 7.99981 9.11439 7.99981 7.9967C7.99981 6.13286 9.27459 4.56676 10.9998 4.12272ZM11.9998 8.9967C12.5521 8.9967 12.9998 8.54899 12.9998 7.9967C12.9998 7.44442 12.5521 6.9967 11.9998 6.9967C11.4475 6.9967 10.9998 7.44442 10.9998 7.9967C10.9998 8.54899 11.4475 8.9967 11.9998 8.9967Z"
  }));
},
    f3 = function f3(_ref456) {
  var _ref456$color = _ref456.color,
      C = _ref456$color === void 0 ? "currentColor" : _ref456$color,
      _ref456$size = _ref456.size,
      e = _ref456$size === void 0 ? 24 : _ref456$size,
      l = _ref456.className,
      i = _objectWithoutProperties(_ref456, _excluded456);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10.9998 4.12272V1.9967H12.9998V4.12272C14.725 4.56676 15.9998 6.13286 15.9998 7.9967C15.9998 9.11439 15.5414 10.125 14.8023 10.8508L20.8658 21.3531L19.1338 22.3531L13.0708 11.8517C12.7299 11.9462 12.3708 11.9967 11.9998 11.9967C11.6289 11.9967 11.2697 11.9462 10.9288 11.8517L4.86584 22.3531L3.13379 21.3531L9.1973 10.8508C8.45823 10.125 7.99981 9.11439 7.99981 7.9967C7.99981 6.13286 9.27459 4.56676 10.9998 4.12272ZM11.9998 9.9967C13.1044 9.9967 13.9998 9.10127 13.9998 7.9967C13.9998 6.89213 13.1044 5.9967 11.9998 5.9967C10.8952 5.9967 9.99981 6.89213 9.99981 7.9967C9.99981 9.10127 10.8952 9.9967 11.9998 9.9967Z"
  }));
},
    R3 = function R3(_ref457) {
  var _ref457$color = _ref457.color,
      C = _ref457$color === void 0 ? "currentColor" : _ref457$color,
      _ref457$size = _ref457.size,
      e = _ref457$size === void 0 ? 24 : _ref457$size,
      l = _ref457.className,
      i = _objectWithoutProperties(_ref457, _excluded457);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13 18V20H17V22H7V20H11V18H2.9918C2.44405 18 2 17.5511 2 16.9925V4.00748C2 3.45107 2.45531 3 2.9918 3H21.0082C21.556 3 22 3.44892 22 4.00748V16.9925C22 17.5489 21.5447 18 21.0082 18H13Z"
  }));
},
    z3 = function z3(_ref458) {
  var _ref458$color = _ref458.color,
      C = _ref458$color === void 0 ? "currentColor" : _ref458$color,
      _ref458$size = _ref458.size,
      e = _ref458$size === void 0 ? 24 : _ref458$size,
      l = _ref458.className,
      i = _objectWithoutProperties(_ref458, _excluded458);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 16H20V5H4V16ZM13 18V20H17V22H7V20H11V18H2.9918C2.44405 18 2 17.5511 2 16.9925V4.00748C2 3.45107 2.45531 3 2.9918 3H21.0082C21.556 3 22 3.44892 22 4.00748V16.9925C22 17.5489 21.5447 18 21.0082 18H13Z"
  }));
},
    F3 = function F3(_ref459) {
  var _ref459$color = _ref459.color,
      C = _ref459$color === void 0 ? "currentColor" : _ref459$color,
      _ref459$size = _ref459.size,
      e = _ref459$size === void 0 ? 24 : _ref459$size,
      l = _ref459.className,
      i = _objectWithoutProperties(_ref459, _excluded459);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 22H6C4.34315 22 3 20.6569 3 19V5C3 3.34315 4.34315 2 6 2H20C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22ZM19 20V18H6C5.44772 18 5 18.4477 5 19C5 19.5523 5.44772 20 6 20H19ZM12 10C13.1046 10 14 9.10457 14 8C14 6.89543 13.1046 6 12 6C10.8954 6 10 6.89543 10 8C10 9.10457 10.8954 10 12 10ZM9 14H15C15 12.3431 13.6569 11 12 11C10.3431 11 9 12.3431 9 14Z"
  }));
},
    S3 = function S3(_ref460) {
  var _ref460$color = _ref460.color,
      C = _ref460$color === void 0 ? "currentColor" : _ref460$color,
      _ref460$size = _ref460.size,
      e = _ref460$size === void 0 ? 24 : _ref460$size,
      l = _ref460.className,
      i = _objectWithoutProperties(_ref460, _excluded460);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 22H6C4.34315 22 3 20.6569 3 19V5C3 3.34315 4.34315 2 6 2H20C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22ZM19 20V18H6C5.44772 18 5 18.4477 5 19C5 19.5523 5.44772 20 6 20H19ZM5 16.1707C5.31278 16.0602 5.64936 16 6 16H19V4H6C5.44772 4 5 4.44772 5 5V16.1707ZM12 10C10.8954 10 10 9.10457 10 8C10 6.89543 10.8954 6 12 6C13.1046 6 14 6.89543 14 8C14 9.10457 13.1046 10 12 10ZM9 14C9 12.3431 10.3431 11 12 11C13.6569 11 15 12.3431 15 14H9Z"
  }));
},
    A3 = function A3(_ref461) {
  var _ref461$color = _ref461.color,
      C = _ref461$color === void 0 ? "currentColor" : _ref461$color,
      _ref461$size = _ref461.size,
      e = _ref461$size === void 0 ? 24 : _ref461$size,
      l = _ref461.className,
      i = _objectWithoutProperties(_ref461, _excluded461);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7 2V22H3V2H7ZM9 2H19.0049C20.1068 2 21 2.89821 21 3.9908V20.0092C21 21.1087 20.1074 22 19.0049 22H9V2ZM22 6H24V10H22V6ZM22 12H24V16H22V12ZM15 12C16.1046 12 17 11.1046 17 10C17 8.89543 16.1046 8 15 8C13.8954 8 13 8.89543 13 10C13 11.1046 13.8954 12 15 12ZM12 16H18C18 14.3431 16.6569 13 15 13C13.3431 13 12 14.3431 12 16Z"
  }));
},
    k3 = function k3(_ref462) {
  var _ref462$color = _ref462.color,
      C = _ref462$color === void 0 ? "currentColor" : _ref462$color,
      _ref462$size = _ref462.size,
      e = _ref462$size === void 0 ? 24 : _ref462$size,
      l = _ref462.className,
      i = _objectWithoutProperties(_ref462, _excluded462);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 2H19.0049C20.1068 2 21 2.89821 21 3.9908V20.0092C21 21.1087 20.1074 22 19.0049 22H3V2ZM7 4H5V20H7V4ZM9 20H19V4H9V20ZM11 16C11 14.3431 12.3431 13 14 13C15.6569 13 17 14.3431 17 16H11ZM14 12C12.8954 12 12 11.1046 12 10C12 8.89543 12.8954 8 14 8C15.1046 8 16 8.89543 16 10C16 11.1046 15.1046 12 14 12ZM22 6H24V10H22V6ZM22 12H24V16H22V12Z"
  }));
},
    P3 = function P3(_ref463) {
  var _ref463$color = _ref463.color,
      C = _ref463$color === void 0 ? "currentColor" : _ref463$color,
      _ref463$size = _ref463.size,
      e = _ref463$size === void 0 ? 24 : _ref463$size,
      l = _ref463.className,
      i = _objectWithoutProperties(_ref463, _excluded463);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7 2V22H3V2H7ZM19.0049 2C20.1068 2 21 2.89821 21 3.9908V20.0092C21 21.1087 20.1074 22 19.0049 22H9V2H19.0049ZM15 8L11 12H14V16H16V12H19L15 8ZM24 12V16H22V12H24ZM24 6V10H22V6H24Z"
  }));
},
    D3 = function D3(_ref464) {
  var _ref464$color = _ref464.color,
      C = _ref464$color === void 0 ? "currentColor" : _ref464$color,
      _ref464$size = _ref464.size,
      e = _ref464$size === void 0 ? 24 : _ref464$size,
      l = _ref464.className,
      i = _objectWithoutProperties(_ref464, _excluded464);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19.0049 2C20.1068 2 21 2.89821 21 3.9908V20.0092C21 21.1087 20.1074 22 19.0049 22H3V2H19.0049ZM7 4H5V20H7V4ZM19 4H9V20H19V4ZM14 8L18 12H15V16H13V12H10L14 8ZM24 12V16H22V12H24ZM24 6V10H22V6H24Z"
  }));
},
    y3 = function y3(_ref465) {
  var _ref465$color = _ref465.color,
      C = _ref465$color === void 0 ? "currentColor" : _ref465$color,
      _ref465$size = _ref465.size,
      e = _ref465$size === void 0 ? 24 : _ref465$size,
      l = _ref465.className,
      i = _objectWithoutProperties(_ref465, _excluded465);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 22C2 17.5817 5.58172 14 10 14C14.4183 14 18 17.5817 18 22H2ZM10 13C6.685 13 4 10.315 4 7C4 3.685 6.685 1 10 1C13.315 1 16 3.685 16 7C16 10.315 13.315 13 10 13ZM20 17H24V19H20V17ZM17 12H24V14H17V12ZM19 7H24V9H19V7Z"
  }));
},
    b3 = function b3(_ref466) {
  var _ref466$color = _ref466.color,
      C = _ref466$color === void 0 ? "currentColor" : _ref466$color,
      _ref466$size = _ref466.size,
      e = _ref466$size === void 0 ? 24 : _ref466$size,
      l = _ref466.className,
      i = _objectWithoutProperties(_ref466, _excluded466);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19 7H24V9H19V7ZM17 12H24V14H17V12ZM20 17H24V19H20V17ZM2 22C2 17.5817 5.58172 14 10 14C14.4183 14 18 17.5817 18 22H16C16 18.6863 13.3137 16 10 16C6.68629 16 4 18.6863 4 22H2ZM10 13C6.685 13 4 10.315 4 7C4 3.685 6.685 1 10 1C13.315 1 16 3.685 16 7C16 10.315 13.315 13 10 13ZM10 11C12.21 11 14 9.21 14 7C14 4.79 12.21 3 10 3C7.79 3 6 4.79 6 7C6 9.21 7.79 11 10 11Z"
  }));
},
    T3 = function T3(_ref467) {
  var _ref467$color = _ref467.color,
      C = _ref467$color === void 0 ? "currentColor" : _ref467$color,
      _ref467$size = _ref467.size,
      e = _ref467$size === void 0 ? 24 : _ref467$size,
      l = _ref467.className,
      i = _objectWithoutProperties(_ref467, _excluded467);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 21.9967C6.47715 21.9967 2 17.5196 2 11.9967C2 6.47386 6.47715 1.9967 12 1.9967C17.5228 1.9967 22 6.47386 22 11.9967C22 17.5196 17.5228 21.9967 12 21.9967ZM5.32889 16.422C6.76378 18.5675 9.20868 19.9803 11.9836 19.9803C16.4018 19.9803 19.9836 16.3985 19.9836 11.9803C19.9836 9.2053 18.5707 6.76034 16.4251 5.32547C17.2705 8.35324 16.5025 11.7369 14.1213 14.1181C11.7401 16.4993 8.3566 17.2672 5.32889 16.422Z"
  }));
},
    U3 = function U3(_ref468) {
  var _ref468$color = _ref468.color,
      C = _ref468$color === void 0 ? "currentColor" : _ref468$color,
      _ref468$size = _ref468.size,
      e = _ref468$size === void 0 ? 24 : _ref468$size,
      l = _ref468.className,
      i = _objectWithoutProperties(_ref468, _excluded468);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 21.9967C6.47715 21.9967 2 17.5196 2 11.9967C2 6.47386 6.47715 1.9967 12 1.9967C17.5228 1.9967 22 6.47386 22 11.9967C22 17.5196 17.5228 21.9967 12 21.9967ZM12 19.9967C16.4183 19.9967 20 16.415 20 11.9967C20 7.57843 16.4183 3.9967 12 3.9967C7.58172 3.9967 4 7.57843 4 11.9967C4 16.415 7.58172 19.9967 12 19.9967ZM7.00035 15.316C9.07995 15.1646 11.117 14.2939 12.7071 12.7038C14.2972 11.1137 15.1679 9.07666 15.3193 6.99706C15.6454 7.21408 15.955 7.46642 16.2426 7.75406C18.5858 10.0972 18.5858 13.8962 16.2426 16.2393C13.8995 18.5825 10.1005 18.5825 7.75736 16.2393C7.46971 15.9517 7.21738 15.6421 7.00035 15.316Z"
  }));
},
    G3 = function G3(_ref469) {
  var _ref469$color = _ref469.color,
      C = _ref469$color === void 0 ? "currentColor" : _ref469$color,
      _ref469$size = _ref469.size,
      e = _ref469$size === void 0 ? 24 : _ref469$size,
      l = _ref469.className,
      i = _objectWithoutProperties(_ref469, _excluded469);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5.63604 6.63288L12 0.268921L18.364 6.63288C21.8787 10.1476 21.8787 15.8461 18.364 19.3608C14.8492 22.8755 9.15076 22.8755 5.63604 19.3608C2.12132 15.8461 2.12132 10.1476 5.63604 6.63288H5.63604ZM12 3.09735L7.05025 8.0471C5.7835 9.31385 5 11.0638 5 12.9968H19C19 11.0638 18.2165 9.31385 16.9497 8.0471L12 3.09735Z"
  }));
},
    I3 = function I3(_ref470) {
  var _ref470$color = _ref470.color,
      C = _ref470$color === void 0 ? "currentColor" : _ref470$color,
      _ref470$size = _ref470.size,
      e = _ref470$size === void 0 ? 24 : _ref470$size,
      l = _ref470.className,
      i = _objectWithoutProperties(_ref470, _excluded470);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 3.09735L7.05025 8.04709C4.31658 10.7808 4.31658 15.2129 7.05025 17.9466C9.78392 20.6803 14.2161 20.6803 16.9497 17.9466C19.6834 15.2129 19.6834 10.7808 16.9497 8.0471L12 3.09735ZM12 0.268921L18.364 6.63288C21.8787 10.1476 21.8787 15.8461 18.364 19.3608C14.8492 22.8755 9.15076 22.8755 5.63604 19.3608C2.12132 15.8461 2.12132 10.1476 5.63604 6.63288L12 0.268921ZM7 12.9968H17C17 15.7583 14.7614 17.9968 12 17.9968C9.23858 17.9968 7 15.7583 7 12.9968Z"
  }));
},
    W3 = function W3(_ref471) {
  var _ref471$color = _ref471.color,
      C = _ref471$color === void 0 ? "currentColor" : _ref471$color,
      _ref471$size = _ref471.size,
      e = _ref471$size === void 0 ? 24 : _ref471$size,
      l = _ref471.className,
      i = _objectWithoutProperties(_ref471, _excluded471);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 0.268921L18.364 6.63288C21.8787 10.1476 21.8787 15.8461 18.364 19.3608C14.8492 22.8755 9.15076 22.8755 5.63604 19.3608C2.12132 15.8461 2.12132 10.1476 5.63604 6.63288L12 0.268921ZM12 3.09735L7.05025 8.0471C4.31658 10.7808 4.31658 15.2129 7.05025 17.9466C8.41814 19.3145 10.2113 19.9979 12.0042 19.9968L12 3.09735Z"
  }));
},
    O3 = function O3(_ref472) {
  var _ref472$color = _ref472.color,
      C = _ref472$color === void 0 ? "currentColor" : _ref472$color,
      _ref472$size = _ref472.size,
      e = _ref472$size === void 0 ? 24 : _ref472$size,
      l = _ref472.className,
      i = _objectWithoutProperties(_ref472, _excluded472);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 3.09735L7.05025 8.04709C4.31658 10.7808 4.31658 15.2129 7.05025 17.9466C9.78392 20.6803 14.2161 20.6803 16.9497 17.9466C19.6834 15.2129 19.6834 10.7808 16.9497 8.0471L12 3.09735ZM12 0.268921L18.364 6.63288C21.8787 10.1476 21.8787 15.8461 18.364 19.3608C14.8492 22.8755 9.15076 22.8755 5.63604 19.3608C2.12132 15.8461 2.12132 10.1476 5.63604 6.63288L12 0.268921ZM12 17.9968V7.99684C14.7614 7.99684 17 10.2354 17 12.9968C17 15.7583 14.7614 17.9968 12 17.9968Z"
  }));
},
    K3 = function K3(_ref473) {
  var _ref473$color = _ref473.color,
      C = _ref473$color === void 0 ? "currentColor" : _ref473$color,
      _ref473$size = _ref473.size,
      e = _ref473$size === void 0 ? 24 : _ref473$size,
      l = _ref473.className,
      i = _objectWithoutProperties(_ref473, _excluded473);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 21.9967C6.47715 21.9967 2 17.5196 2 11.9967C2 6.47386 6.47715 1.9967 12 1.9967C17.5228 1.9967 22 6.47386 22 11.9967C22 17.5196 17.5228 21.9967 12 21.9967ZM12 19.9967V3.9967C7.58172 3.9967 4 7.57843 4 11.9967C4 16.415 7.58172 19.9967 12 19.9967Z"
  }));
},
    Q3 = function Q3(_ref474) {
  var _ref474$color = _ref474.color,
      C = _ref474$color === void 0 ? "currentColor" : _ref474$color,
      _ref474$size = _ref474.size,
      e = _ref474$size === void 0 ? 24 : _ref474$size,
      l = _ref474.className,
      i = _objectWithoutProperties(_ref474, _excluded474);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 21.9967C6.47715 21.9967 2 17.5196 2 11.9967C2 6.47386 6.47715 1.9967 12 1.9967C17.5228 1.9967 22 6.47386 22 11.9967C22 17.5196 17.5228 21.9967 12 21.9967ZM12 19.9967C16.4183 19.9967 20 16.415 20 11.9967C20 7.57843 16.4183 3.9967 12 3.9967C7.58172 3.9967 4 7.57843 4 11.9967C4 16.415 7.58172 19.9967 12 19.9967ZM12 17.9967V5.9967C15.3137 5.9967 18 8.683 18 11.9967C18 15.3104 15.3137 17.9967 12 17.9967Z"
  }));
},
    q3 = function q3(_ref475) {
  var _ref475$color = _ref475.color,
      C = _ref475$color === void 0 ? "currentColor" : _ref475$color,
      _ref475$size = _ref475.size,
      e = _ref475$size === void 0 ? 24 : _ref475$size,
      l = _ref475.className,
      i = _objectWithoutProperties(_ref475, _excluded475);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.0049 22.0027C6.48204 22.0027 2.00488 17.5256 2.00488 12.0027C2.00488 6.4799 6.48204 2.00275 12.0049 2.00275C17.5277 2.00275 22.0049 6.4799 22.0049 12.0027C22.0049 17.5256 17.5277 22.0027 12.0049 22.0027ZM12.0049 7.76011L7.76224 12.0027L12.0049 16.2454L16.2475 12.0027L12.0049 7.76011Z"
  }));
},
    j3 = function j3(_ref476) {
  var _ref476$color = _ref476.color,
      C = _ref476$color === void 0 ? "currentColor" : _ref476$color,
      _ref476$size = _ref476.size,
      e = _ref476$size === void 0 ? 24 : _ref476$size,
      l = _ref476.className,
      i = _objectWithoutProperties(_ref476, _excluded476);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.0049 22.0027C6.48204 22.0027 2.00488 17.5256 2.00488 12.0027C2.00488 6.4799 6.48204 2.00275 12.0049 2.00275C17.5277 2.00275 22.0049 6.4799 22.0049 12.0027C22.0049 17.5256 17.5277 22.0027 12.0049 22.0027ZM12.0049 20.0027C16.4232 20.0027 20.0049 16.421 20.0049 12.0027C20.0049 7.58447 16.4232 4.00275 12.0049 4.00275C7.5866 4.00275 4.00488 7.58447 4.00488 12.0027C4.00488 16.421 7.5866 20.0027 12.0049 20.0027ZM12.0049 7.053L16.9546 12.0027L12.0049 16.9525L7.05514 12.0027L12.0049 7.053ZM12.0049 9.88143L9.88356 12.0027L12.0049 14.1241L14.1262 12.0027L12.0049 9.88143Z"
  }));
},
    X3 = function X3(_ref477) {
  var _ref477$color = _ref477.color,
      C = _ref477$color === void 0 ? "currentColor" : _ref477$color,
      _ref477$size = _ref477.size,
      e = _ref477$size === void 0 ? 24 : _ref477$size,
      l = _ref477.className,
      i = _objectWithoutProperties(_ref477, _excluded477);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.0049 22.0027C6.48204 22.0027 2.00488 17.5256 2.00488 12.0027C2.00488 6.4799 6.48204 2.00275 12.0049 2.00275C17.5277 2.00275 22.0049 6.4799 22.0049 12.0027C22.0049 17.5256 17.5277 22.0027 12.0049 22.0027ZM9.50488 9.00275L7.00488 11.5027L12.0041 16.5027L17.0049 11.5027L14.5049 9.00275H9.50488Z"
  }));
},
    J3 = function J3(_ref478) {
  var _ref478$color = _ref478.color,
      C = _ref478$color === void 0 ? "currentColor" : _ref478$color,
      _ref478$size = _ref478.size,
      e = _ref478$size === void 0 ? 24 : _ref478$size,
      l = _ref478.className,
      i = _objectWithoutProperties(_ref478, _excluded478);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.0049 22.0027C6.48204 22.0027 2.00488 17.5256 2.00488 12.0027C2.00488 6.4799 6.48204 2.00275 12.0049 2.00275C17.5277 2.00275 22.0049 6.4799 22.0049 12.0027C22.0049 17.5256 17.5277 22.0027 12.0049 22.0027ZM12.0049 20.0027C16.4232 20.0027 20.0049 16.421 20.0049 12.0027C20.0049 7.58447 16.4232 4.00275 12.0049 4.00275C7.5866 4.00275 4.00488 7.58447 4.00488 12.0027C4.00488 16.421 7.5866 20.0027 12.0049 20.0027ZM9.00488 8.00275H15.0049L17.5049 11.5027L12.0041 17.0027L6.50488 11.5027L9.00488 8.00275ZM10.0349 10.0027L9.11488 11.2927L12.0041 14.1827L14.8949 11.2927L13.9749 10.0027H10.0349Z"
  }));
},
    Y3 = function Y3(_ref479) {
  var _ref479$color = _ref479.color,
      C = _ref479$color === void 0 ? "currentColor" : _ref479$color,
      _ref479$size = _ref479.size,
      e = _ref479$size === void 0 ? 24 : _ref479$size,
      l = _ref479.className,
      i = _objectWithoutProperties(_ref479, _excluded479);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22ZM12 17C14.76 17 17 14.76 17 12C17 9.24 14.76 7 12 7C10.1805 7 8.58698 7.9735 7.71225 9.42771L9.42709 10.4558C9.95162 9.58339 10.9074 9 12 9C13.6575 9 15 10.3425 15 12C15 13.6575 13.6575 15 12 15C10.9069 15 9.95089 14.4162 9.42649 13.5432L7.71225 14.5723C8.58698 16.0265 10.1805 17 12 17Z"
  }));
},
    _3 = function _3(_ref480) {
  var _ref480$color = _ref480.color,
      C = _ref480$color === void 0 ? "currentColor" : _ref480$color,
      _ref480$size = _ref480.size,
      e = _ref480$size === void 0 ? 24 : _ref480$size,
      l = _ref480.className,
      i = _objectWithoutProperties(_ref480, _excluded480);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22ZM12 20C16.42 20 20 16.42 20 12C20 7.58 16.42 4 12 4C7.58 4 4 7.58 4 12C4 16.42 7.58 20 12 20ZM12 17C10.1805 17 8.58698 16.0265 7.71225 14.5723L9.42649 13.5432C9.95089 14.4162 10.9069 15 12 15C13.6575 15 15 13.6575 15 12C15 10.3425 13.6575 9 12 9C10.9074 9 9.95162 9.58339 9.42709 10.4558L7.71225 9.42771C8.58698 7.9735 10.1805 7 12 7C14.76 7 17 9.24 17 12C17 14.76 14.76 17 12 17Z"
  }));
},
    $3 = function $3(_ref481) {
  var _ref481$color = _ref481.color,
      C = _ref481$color === void 0 ? "currentColor" : _ref481$color,
      _ref481$size = _ref481.size,
      e = _ref481$size === void 0 ? 24 : _ref481$size,
      l = _ref481.className,
      i = _objectWithoutProperties(_ref481, _excluded481);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2ZM12 7C9.24 7 7 9.24 7 12C7 14.76 9.24 17 12 17C13.8195 17 15.413 16.0265 16.2878 14.5723L14.5729 13.5442C14.0484 14.4166 13.0926 15 12 15C10.3425 15 9 13.6575 9 12C9 10.3425 10.3425 9 12 9C13.0931 9 14.0491 9.58383 14.5735 10.4568L16.2878 9.42771C15.413 7.9735 13.8195 7 12 7Z"
  }));
},
    e8 = function e8(_ref482) {
  var _ref482$color = _ref482.color,
      C = _ref482$color === void 0 ? "currentColor" : _ref482$color,
      _ref482$size = _ref482.size,
      e = _ref482$size === void 0 ? 24 : _ref482$size,
      l = _ref482.className,
      i = _objectWithoutProperties(_ref482, _excluded482);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16.2877 9.42773C15.413 7.97351 13.8195 7 12 7 9.23999 7 7 9.23999 7 12 7 14.76 9.23999 17 12 17 13.8195 17 15.413 16.0265 16.2877 14.5723L14.5729 13.5442C14.0483 14.4166 13.0927 15 12 15 10.3425 15 9 13.6575 9 12 9 10.3425 10.3425 9 12 9 13.093 9 14.0491 9.58386 14.5735 10.4568L16.2877 9.42773ZM22 12C22 6.47998 17.52 2 12 2 6.47998 2 2 6.47998 2 12 2 17.52 6.47998 22 12 22 17.52 22 22 17.52 22 12ZM4 12C4 7.57996 7.57996 4 12 4 16.42 4 20 7.57996 20 12 20 16.42 16.42 20 12 20 7.57996 20 4 16.42 4 12Z"
  }));
},
    t8 = function t8(_ref483) {
  var _ref483$color = _ref483.color,
      C = _ref483$color === void 0 ? "currentColor" : _ref483$color,
      _ref483$size = _ref483.size,
      e = _ref483$size === void 0 ? 24 : _ref483$size,
      l = _ref483.className,
      i = _objectWithoutProperties(_ref483, _excluded483);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM8.32864 12.3036C8.28909 13.1546 8.36645 14.0015 8.44669 14.8484C8.45244 14.9088 8.47434 14.9217 8.52744 14.9287C8.93342 14.982 9.33986 15.0298 9.74853 15.0555C10.7131 15.116 11.6771 15.1936 12.6447 15.1398C13.1941 15.1092 13.7446 15.0924 14.2925 15.0446C15.0732 14.9766 15.8524 14.8895 16.6224 14.7333C17.5814 14.5388 18.5298 14.3079 19.4238 13.888C19.829 13.6976 20.2136 13.4729 20.537 13.1521C20.7745 12.9167 20.9448 12.6445 20.9472 12.2929C20.9493 11.9788 20.9333 11.6646 20.9022 11.3524C20.8281 10.606 20.6748 9.87659 20.4205 9.17197C19.8367 7.55443 18.9115 6.18315 17.5955 5.10253C16.4576 4.16822 15.1751 3.5396 13.744 3.23907C13.2445 3.13419 12.7381 3.09535 12.2299 3.05885C11.6571 3.01769 11.1662 3.17993 10.7418 3.57258C10.2472 4.03031 9.90481 4.5975 9.62019 5.2061C8.95309 6.63257 8.64727 8.15994 8.45434 9.71384C8.34789 10.5713 8.28789 11.435 8.32864 12.3036ZM11.8988 7.27379C12.8578 7.30486 13.6687 7.59825 14.3926 8.12993C15.2883 8.78776 15.8625 9.65802 16.1068 10.742C16.1752 11.0457 16.2039 11.3537 16.2104 11.6637C16.2148 11.8727 16.1005 12.0258 15.9478 12.1541C15.6412 12.4116 15.2773 12.5552 14.898 12.6615C14.1573 12.8692 13.4021 12.9885 12.6328 13.028C12.1326 13.0537 11.6331 13.0628 11.133 13.038C10.9406 13.0285 10.7485 13.0136 10.5561 13.0061C10.4964 13.0038 10.4758 12.9861 10.4725 12.9246C10.4491 12.4909 10.4152 12.0572 10.4219 11.6228C10.4376 10.5969 10.5163 9.57811 10.819 8.5893C10.9197 8.26005 11.0423 7.93967 11.2396 7.6532C11.4118 7.40327 11.6175 7.21569 11.8988 7.27379Z"
  }));
},
    C8 = function C8(_ref484) {
  var _ref484$color = _ref484.color,
      C = _ref484$color === void 0 ? "currentColor" : _ref484$color,
      _ref484$size = _ref484.size,
      e = _ref484$size === void 0 ? 24 : _ref484$size,
      l = _ref484.className,
      i = _objectWithoutProperties(_ref484, _excluded484);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9.45447 4.41393C8.31731 4.79453 7.24869 5.4376 6.34315 6.34315C3.21895 9.46734 3.21895 14.5327 6.34315 17.6569C9.46734 20.781 14.5327 20.781 17.6569 17.6569C18.6209 16.6929 19.2874 15.544 19.6565 14.3245C16.2563 15.7834 12.4077 16.3049 8.11091 15.8891C7.39961 11.7635 7.84746 7.93846 9.45447 4.41393ZM11.9023 4.00059C11.2268 5.21641 10.7129 6.47151 10.3605 7.76913C11.853 7.80085 13.3359 8.38618 14.4749 9.52513C15.5494 10.5997 16.1312 11.9804 16.2202 13.3864C17.5495 13.0447 18.8086 12.5666 19.9999 11.9528C19.9922 10.6417 19.6642 9.33223 19.016 8.15169C18.6567 7.49783 18.202 6.88829 17.6569 6.34315C17.0828 5.76913 16.4374 5.29549 15.7442 4.92788C14.5473 4.29366 13.2232 3.98456 11.9023 4.00059ZM4.92893 19.0711C1.02369 15.1658 1.02369 8.83418 4.92893 4.92893C8.83418 1.02369 15.1658 1.02369 19.0711 4.92893C22.9763 8.83418 22.9763 15.1658 19.0711 19.0711C15.1658 22.9763 8.83418 22.9763 4.92893 19.0711ZM9.94875 9.77776C9.75716 11.1407 9.73211 12.5491 9.87338 14.0066C11.3972 14.0679 12.8495 13.9948 14.2322 13.788C14.2374 12.7576 13.8469 11.7255 13.0607 10.9393C12.2075 10.0861 11.0647 9.69895 9.94875 9.77776Z"
  }));
},
    l8 = function l8(_ref485) {
  var _ref485$color = _ref485.color,
      C = _ref485$color === void 0 ? "currentColor" : _ref485$color,
      _ref485$size = _ref485.size,
      e = _ref485$size === void 0 ? 24 : _ref485$size,
      l = _ref485.className,
      i = _objectWithoutProperties(_ref485, _excluded485);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14.0049 2.99966V20.9997H3.00488C2.4526 20.9997 2.00488 20.5519 2.00488 19.9997V14.4997C3.38559 14.4997 4.50488 13.3804 4.50488 11.9997C4.50488 10.619 3.38559 9.49966 2.00488 9.49966V3.99966C2.00488 3.44738 2.4526 2.99966 3.00488 2.99966H14.0049ZM16.0049 2.99966H21.0049C21.5572 2.99966 22.0049 3.44738 22.0049 3.99966V9.49966C20.6242 9.49966 19.5049 10.619 19.5049 11.9997C19.5049 13.3804 20.6242 14.4997 22.0049 14.4997V19.9997C22.0049 20.5519 21.5572 20.9997 21.0049 20.9997H16.0049V2.99966Z"
  }));
},
    i8 = function i8(_ref486) {
  var _ref486$color = _ref486.color,
      C = _ref486$color === void 0 ? "currentColor" : _ref486$color,
      _ref486$size = _ref486.size,
      e = _ref486$size === void 0 ? 24 : _ref486$size,
      l = _ref486.className,
      i = _objectWithoutProperties(_ref486, _excluded486);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2.00488 9.49979V3.99979C2.00488 3.4475 2.4526 2.99979 3.00488 2.99979H21.0049C21.5572 2.99979 22.0049 3.4475 22.0049 3.99979V9.49979C20.6242 9.49979 19.5049 10.6191 19.5049 11.9998C19.5049 13.3805 20.6242 14.4998 22.0049 14.4998V19.9998C22.0049 20.5521 21.5572 20.9998 21.0049 20.9998H3.00488C2.4526 20.9998 2.00488 20.5521 2.00488 19.9998V14.4998C3.38559 14.4998 4.50488 13.3805 4.50488 11.9998C4.50488 10.6191 3.38559 9.49979 2.00488 9.49979ZM14.0049 4.99979H4.00488V7.96755C5.4866 8.7039 6.50488 10.2329 6.50488 11.9998C6.50488 13.7666 5.4866 15.2957 4.00488 16.032V18.9998H14.0049V4.99979ZM16.0049 4.99979V18.9998H20.0049V16.032C18.5232 15.2957 17.5049 13.7666 17.5049 11.9998C17.5049 10.2329 18.5232 8.7039 20.0049 7.96755V4.99979H16.0049Z"
  }));
},
    s8 = function s8(_ref487) {
  var _ref487$color = _ref487.color,
      C = _ref487$color === void 0 ? "currentColor" : _ref487$color,
      _ref487$size = _ref487.size,
      e = _ref487$size === void 0 ? 24 : _ref487$size,
      l = _ref487.className,
      i = _objectWithoutProperties(_ref487, _excluded487);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11.0049 20.9997C11.0049 20.1712 10.3333 19.4997 9.50488 19.4997C8.67646 19.4997 8.00488 20.1712 8.00488 20.9997H3.00488C2.4526 20.9997 2.00488 20.5519 2.00488 19.9997V3.99966C2.00488 3.44738 2.4526 2.99966 3.00488 2.99966H8.00488C8.00488 3.82809 8.67646 4.49966 9.50488 4.49966C10.3333 4.49966 11.0049 3.82809 11.0049 2.99966H21.0049C21.5572 2.99966 22.0049 3.44738 22.0049 3.99966V9.49966C20.6242 9.49966 19.5049 10.619 19.5049 11.9997C19.5049 13.3804 20.6242 14.4997 22.0049 14.4997V19.9997C22.0049 20.5519 21.5572 20.9997 21.0049 20.9997H11.0049ZM9.50488 10.4997C10.3333 10.4997 11.0049 9.82809 11.0049 8.99966C11.0049 8.17124 10.3333 7.49966 9.50488 7.49966C8.67646 7.49966 8.00488 8.17124 8.00488 8.99966C8.00488 9.82809 8.67646 10.4997 9.50488 10.4997ZM9.50488 16.4997C10.3333 16.4997 11.0049 15.8281 11.0049 14.9997C11.0049 14.1712 10.3333 13.4997 9.50488 13.4997C8.67646 13.4997 8.00488 14.1712 8.00488 14.9997C8.00488 15.8281 8.67646 16.4997 9.50488 16.4997Z"
  }));
},
    r8 = function r8(_ref488) {
  var _ref488$color = _ref488.color,
      C = _ref488$color === void 0 ? "currentColor" : _ref488$color,
      _ref488$size = _ref488.size,
      e = _ref488$size === void 0 ? 24 : _ref488$size,
      l = _ref488.className,
      i = _objectWithoutProperties(_ref488, _excluded488);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2.00488 3.99979C2.00488 3.4475 2.4526 2.99979 3.00488 2.99979H21.0049C21.5572 2.99979 22.0049 3.4475 22.0049 3.99979V9.49979C20.6242 9.49979 19.5049 10.6191 19.5049 11.9998C19.5049 13.3805 20.6242 14.4998 22.0049 14.4998V19.9998C22.0049 20.5521 21.5572 20.9998 21.0049 20.9998H3.00488C2.4526 20.9998 2.00488 20.5521 2.00488 19.9998V3.99979ZM8.09024 18.9998C8.29615 18.4172 8.85177 17.9998 9.50488 17.9998C10.158 17.9998 10.7136 18.4172 10.9195 18.9998H20.0049V16.032C18.5232 15.2957 17.5049 13.7666 17.5049 11.9998C17.5049 10.2329 18.5232 8.7039 20.0049 7.96755V4.99979H10.9195C10.7136 5.58238 10.158 5.99979 9.50488 5.99979C8.85177 5.99979 8.29615 5.58238 8.09024 4.99979H4.00488V18.9998H8.09024ZM9.50488 10.9998C8.67646 10.9998 8.00488 10.3282 8.00488 9.49979C8.00488 8.67136 8.67646 7.99979 9.50488 7.99979C10.3333 7.99979 11.0049 8.67136 11.0049 9.49979C11.0049 10.3282 10.3333 10.9998 9.50488 10.9998ZM9.50488 15.9998C8.67646 15.9998 8.00488 15.3282 8.00488 14.4998C8.00488 13.6714 8.67646 12.9998 9.50488 12.9998C10.3333 12.9998 11.0049 13.6714 11.0049 14.4998C11.0049 15.3282 10.3333 15.9998 9.50488 15.9998Z"
  }));
},
    c8 = function c8(_ref489) {
  var _ref489$color = _ref489.color,
      C = _ref489$color === void 0 ? "currentColor" : _ref489$color,
      _ref489$size = _ref489.size,
      e = _ref489$size === void 0 ? 24 : _ref489$size,
      l = _ref489.className,
      i = _objectWithoutProperties(_ref489, _excluded489);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10.0049 20.9997H3.00488C2.4526 20.9997 2.00488 20.552 2.00488 19.9997V3.99969C2.00488 3.44741 2.4526 2.99969 3.00488 2.99969H10.0049C10.0049 4.10426 10.9003 4.99969 12.0049 4.99969C13.1095 4.99969 14.0049 4.10426 14.0049 2.99969H21.0049C21.5572 2.99969 22.0049 3.44741 22.0049 3.99969V19.9997C22.0049 20.552 21.5572 20.9997 21.0049 20.9997H14.0049C14.0049 19.8951 13.1095 18.9997 12.0049 18.9997C10.9003 18.9997 10.0049 19.8951 10.0049 20.9997ZM6.00488 7.99969V15.9997H8.00488V7.99969H6.00488ZM16.0049 7.99969V15.9997H18.0049V7.99969H16.0049Z"
  }));
},
    o8 = function o8(_ref490) {
  var _ref490$color = _ref490.color,
      C = _ref490$color === void 0 ? "currentColor" : _ref490$color,
      _ref490$size = _ref490.size,
      e = _ref490$size === void 0 ? 24 : _ref490$size,
      l = _ref490.className,
      i = _objectWithoutProperties(_ref490, _excluded490);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10.0049 20.9998H3.00488C2.4526 20.9998 2.00488 20.5521 2.00488 19.9998V3.99979C2.00488 3.4475 2.4526 2.99979 3.00488 2.99979H10.0049C10.0049 4.10436 10.9003 4.99979 12.0049 4.99979C13.1095 4.99979 14.0049 4.10436 14.0049 2.99979H21.0049C21.5572 2.99979 22.0049 3.4475 22.0049 3.99979V19.9998C22.0049 20.5521 21.5572 20.9998 21.0049 20.9998H14.0049C14.0049 19.8952 13.1095 18.9998 12.0049 18.9998C10.9003 18.9998 10.0049 19.8952 10.0049 20.9998ZM8.54001 18.9998C9.23163 17.8042 10.5243 16.9998 12.0049 16.9998C13.4854 16.9998 14.7781 17.8042 15.4698 18.9998H20.0049V4.99979H15.4698C14.7781 6.19539 13.4854 6.99979 12.0049 6.99979C10.5243 6.99979 9.23163 6.19539 8.54001 4.99979H4.00488V18.9998H8.54001ZM6.00488 7.99979H8.00488V15.9998H6.00488V7.99979ZM16.0049 7.99979H18.0049V15.9998H16.0049V7.99979Z"
  }));
},
    a8 = function a8(_ref491) {
  var _ref491$color = _ref491.color,
      C = _ref491$color === void 0 ? "currentColor" : _ref491$color,
      _ref491$size = _ref491.size,
      e = _ref491$size === void 0 ? 24 : _ref491$size,
      l = _ref491.className,
      i = _objectWithoutProperties(_ref491, _excluded491);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21.0049 13.9997V20.9997C21.0049 21.552 20.5572 21.9997 20.0049 21.9997H4.00488C3.4526 21.9997 3.00488 21.552 3.00488 20.9997V13.9997C4.10945 13.9997 5.00488 13.1043 5.00488 11.9997C5.00488 10.8951 4.10945 9.99969 3.00488 9.99969V2.99969C3.00488 2.44741 3.4526 1.99969 4.00488 1.99969H20.0049C20.5572 1.99969 21.0049 2.44741 21.0049 2.99969V9.99969C19.9003 9.99969 19.0049 10.8951 19.0049 11.9997C19.0049 13.1043 19.9003 13.9997 21.0049 13.9997ZM9.00488 5.99969V7.99969H15.0049V5.99969H9.00488ZM9.00488 15.9997V17.9997H15.0049V15.9997H9.00488Z"
  }));
},
    n8 = function n8(_ref492) {
  var _ref492$color = _ref492.color,
      C = _ref492$color === void 0 ? "currentColor" : _ref492$color,
      _ref492$size = _ref492.size,
      e = _ref492$size === void 0 ? 24 : _ref492$size,
      l = _ref492.className,
      i = _objectWithoutProperties(_ref492, _excluded492);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21.0049 13.9998V20.9998C21.0049 21.5521 20.5572 21.9998 20.0049 21.9998H4.00488C3.4526 21.9998 3.00488 21.5521 3.00488 20.9998V13.9998C4.10945 13.9998 5.00488 13.1044 5.00488 11.9998C5.00488 10.8952 4.10945 9.99979 3.00488 9.99979V2.99979C3.00488 2.4475 3.4526 1.99979 4.00488 1.99979H20.0049C20.5572 1.99979 21.0049 2.4475 21.0049 2.99979V9.99979C19.9003 9.99979 19.0049 10.8952 19.0049 11.9998C19.0049 13.1044 19.9003 13.9998 21.0049 13.9998ZM19.0049 15.4647C17.8093 14.773 17.0049 13.4804 17.0049 11.9998C17.0049 10.5192 17.8093 9.22653 19.0049 8.53491V3.99979H5.00488V8.53491C6.20049 9.22653 7.00488 10.5192 7.00488 11.9998C7.00488 13.4804 6.20049 14.773 5.00488 15.4647V19.9998H19.0049V15.4647ZM9.00488 5.99979H15.0049V7.99979H9.00488V5.99979ZM9.00488 15.9998H15.0049V17.9998H9.00488V15.9998Z"
  }));
},
    m8 = function m8(_ref493) {
  var _ref493$color = _ref493.color,
      C = _ref493$color === void 0 ? "currentColor" : _ref493$color,
      _ref493$size = _ref493.size,
      e = _ref493$size === void 0 ? 24 : _ref493$size,
      l = _ref493.className,
      i = _objectWithoutProperties(_ref493, _excluded493);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2.00488 9.49966V3.99966C2.00488 3.44738 2.4526 2.99966 3.00488 2.99966H21.0049C21.5572 2.99966 22.0049 3.44738 22.0049 3.99966V9.49966C20.6242 9.49966 19.5049 10.619 19.5049 11.9997C19.5049 13.3804 20.6242 14.4997 22.0049 14.4997V19.9997C22.0049 20.5519 21.5572 20.9997 21.0049 20.9997H3.00488C2.4526 20.9997 2.00488 20.5519 2.00488 19.9997V14.4997C3.38559 14.4997 4.50488 13.3804 4.50488 11.9997C4.50488 10.619 3.38559 9.49966 2.00488 9.49966ZM9.00488 8.99966V10.9997H15.0049V8.99966H9.00488ZM9.00488 12.9997V14.9997H15.0049V12.9997H9.00488Z"
  }));
},
    w8 = function w8(_ref494) {
  var _ref494$color = _ref494.color,
      C = _ref494$color === void 0 ? "currentColor" : _ref494$color,
      _ref494$size = _ref494.size,
      e = _ref494$size === void 0 ? 24 : _ref494$size,
      l = _ref494.className,
      i = _objectWithoutProperties(_ref494, _excluded494);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2.00488 9.49979V3.99979C2.00488 3.4475 2.4526 2.99979 3.00488 2.99979H21.0049C21.5572 2.99979 22.0049 3.4475 22.0049 3.99979V9.49979C20.6242 9.49979 19.5049 10.6191 19.5049 11.9998C19.5049 13.3805 20.6242 14.4998 22.0049 14.4998V19.9998C22.0049 20.5521 21.5572 20.9998 21.0049 20.9998H3.00488C2.4526 20.9998 2.00488 20.5521 2.00488 19.9998V14.4998C3.38559 14.4998 4.50488 13.3805 4.50488 11.9998C4.50488 10.6191 3.38559 9.49979 2.00488 9.49979ZM4.00488 7.96755C5.4866 8.7039 6.50488 10.2329 6.50488 11.9998C6.50488 13.7666 5.4866 15.2957 4.00488 16.032V18.9998H20.0049V16.032C18.5232 15.2957 17.5049 13.7666 17.5049 11.9998C17.5049 10.2329 18.5232 8.7039 20.0049 7.96755V4.99979H4.00488V7.96755ZM9.00488 8.99979H15.0049V10.9998H9.00488V8.99979ZM9.00488 12.9998H15.0049V14.9998H9.00488V12.9998Z"
  }));
},
    L8 = function L8(_ref495) {
  var _ref495$color = _ref495.color,
      C = _ref495$color === void 0 ? "currentColor" : _ref495$color,
      _ref495$size = _ref495.size,
      e = _ref495$size === void 0 ? 24 : _ref495$size,
      l = _ref495.className,
      i = _objectWithoutProperties(_ref495, _excluded495);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14 20H10V22H8V20H5C4.44772 20 4 19.5523 4 19V16H2V14H4V10H2V8H4V5C4 4.44772 4.44772 4 5 4H8V2H10V4H14V2H16V4H19C19.5523 4 20 4.44772 20 5V8H22V10H20V14H22V16H20V19C20 19.5523 19.5523 20 19 20H16V22H14V20ZM7 7V11H11V7H7Z"
  }));
},
    h8 = function h8(_ref496) {
  var _ref496$color = _ref496.color,
      C = _ref496$color === void 0 ? "currentColor" : _ref496$color,
      _ref496$size = _ref496.size,
      e = _ref496$size === void 0 ? 24 : _ref496$size,
      l = _ref496.className,
      i = _objectWithoutProperties(_ref496, _excluded496);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6 18H18V6H6V18ZM14 20H10V22H8V20H5C4.44772 20 4 19.5523 4 19V16H2V14H4V10H2V8H4V5C4 4.44772 4.44772 4 5 4H8V2H10V4H14V2H16V4H19C19.5523 4 20 4.44772 20 5V8H22V10H20V14H22V16H20V19C20 19.5523 19.5523 20 19 20H16V22H14V20ZM8 8H16V16H8V8Z"
  }));
},
    H8 = function H8(_ref497) {
  var _ref497$color = _ref497.color,
      C = _ref497$color === void 0 ? "currentColor" : _ref497$color,
      _ref497$size = _ref497.size,
      e = _ref497$size === void 0 ? 24 : _ref497$size,
      l = _ref497.className,
      i = _objectWithoutProperties(_ref497, _excluded497);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM14 10H10C9.44772 10 9 10.4477 9 11V15H10.5V19H13.5V15H15V11C15 10.4477 14.5523 10 14 10ZM12 5C10.8954 5 10 5.89543 10 7C10 8.10457 10.8954 9 12 9C13.1046 9 14 8.10457 14 7C14 5.89543 13.1046 5 12 5Z"
  }));
},
    V8 = function V8(_ref498) {
  var _ref498$color = _ref498.color,
      C = _ref498$color === void 0 ? "currentColor" : _ref498$color,
      _ref498$size = _ref498.size,
      e = _ref498$size === void 0 ? 24 : _ref498$size,
      l = _ref498.className,
      i = _objectWithoutProperties(_ref498, _excluded498);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14 7C14 8.10461 13.1046 9 12 9 10.8954 9 10 8.10461 10 7 10 5.89539 10.8954 5 12 5 13.1046 5 14 5.89539 14 7ZM15 11C15 10.4478 14.5522 10 14 10H10C9.44775 10 9 10.4478 9 11V15H10.5V19H13.5V15H15V11ZM12 2C6.47717 2 2 6.47717 2 12 2 17.5228 6.47717 22 12 22 17.5228 22 22 17.5228 22 12 22 6.47717 17.5228 2 12 2ZM4 12C4 7.58167 7.58167 4 12 4 16.4183 4 20 7.58167 20 12 20 16.4183 16.4183 20 12 20 7.58167 20 4 16.4183 4 12Z"
  }));
},
    g8 = function g8(_ref499) {
  var _ref499$color = _ref499.color,
      C = _ref499$color === void 0 ? "currentColor" : _ref499$color,
      _ref499$size = _ref499.size,
      e = _ref499$size === void 0 ? 24 : _ref499$size,
      l = _ref499.className,
      i = _objectWithoutProperties(_ref499, _excluded499);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM9 8C6.792 8 5 9.792 5 12C5 14.208 6.792 16 9 16C10.104 16 11.104 15.552 11.828 14.828L10.4144 13.4144C10.0525 13.7762 9.5525 14 9 14C7.895 14 7 13.105 7 12C7 10.895 7.895 10 9 10C9.55299 10 10.0534 10.2241 10.4153 10.5866L11.829 9.173C11.1049 8.44841 10.1045 8 9 8ZM16 8C13.792 8 12 9.792 12 12C12 14.208 13.792 16 16 16C17.104 16 18.104 15.552 18.828 14.828L17.4144 13.4144C17.0525 13.7762 16.5525 14 16 14C14.895 14 14 13.105 14 12C14 10.895 14.895 10 16 10C16.553 10 17.0534 10.2241 17.4153 10.5866L18.829 9.173C18.1049 8.44841 17.1045 8 16 8Z"
  }));
},
    M8 = function M8(_ref500) {
  var _ref500$color = _ref500.color,
      C = _ref500$color === void 0 ? "currentColor" : _ref500$color,
      _ref500$size = _ref500.size,
      e = _ref500$size === void 0 ? 24 : _ref500$size,
      l = _ref500.className,
      i = _objectWithoutProperties(_ref500, _excluded500);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9 8C10.1045 8 11.1049 8.44836 11.829 9.17297L10.4153 10.5865C10.0533 10.2241 9.55298 10 9 10 7.89502 10 7 10.895 7 12 7 13.105 7.89502 14 9 14 9.55249 14 10.0525 13.7762 10.4144 13.4144L11.828 14.828C11.104 15.552 10.104 16 9 16 6.79199 16 5 14.208 5 12 5 9.79199 6.79199 8 9 8ZM18.829 9.17297C18.1049 8.44836 17.1045 8 16 8 13.792 8 12 9.79199 12 12 12 14.208 13.792 16 16 16 17.104 16 18.104 15.552 18.828 14.828L17.4144 13.4144C17.0525 13.7762 16.5525 14 16 14 14.895 14 14 13.105 14 12 14 10.895 14.895 10 16 10 16.553 10 17.0533 10.2241 17.4153 10.5865L18.829 9.17297ZM2 12C2 6.47717 6.47717 2 12 2 17.5228 2 22 6.47717 22 12 22 17.5228 17.5228 22 12 22 6.47717 22 2 17.5228 2 12ZM12 4C7.58167 4 4 7.58167 4 12 4 16.4183 7.58167 20 12 20 16.4183 20 20 16.4183 20 12 20 7.58167 16.4183 4 12 4Z"
  }));
},
    Z8 = function Z8(_ref501) {
  var _ref501$color = _ref501.color,
      C = _ref501$color === void 0 ? "currentColor" : _ref501$color,
      _ref501$size = _ref501.size,
      e = _ref501$size === void 0 ? 24 : _ref501$size,
      l = _ref501.className,
      i = _objectWithoutProperties(_ref501, _excluded501);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4.25639 5.67208L7.83528 9.24858C7.62206 9.61662 7.5 10.0441 7.5 10.5C7.5 11.8807 8.61929 13 10 13H14L14.0899 13.0081C14.3231 13.0504 14.5 13.2545 14.5 13.5C14.5 13.7761 14.2761 14 14 14H8.5V16H11V18H13V16H14C14.1817 16 14.3589 15.9806 14.5296 15.9438L18.3279 19.7436C16.6042 21.1539 14.4009 22 12 22C6.47715 22 2 17.5228 2 12C2 9.5991 2.8461 7.39583 4.25639 5.67208ZM12 2C17.5228 2 22 6.47715 22 12C22 14.4009 21.1539 16.6042 19.7436 18.3279L16.1652 14.7507C16.3781 14.3828 16.5 13.9556 16.5 13.5C16.5 12.1193 15.3807 11 14 11H10L9.91012 10.9919C9.67688 10.9496 9.5 10.7455 9.5 10.5C9.5 10.2239 9.72386 10 10 10H15.5V8H13V6H11V8H10C9.81853 8 9.64159 8.01933 9.4711 8.05605L5.67208 4.25639C7.39583 2.8461 9.5991 2 12 2Z"
  }));
},
    x8 = function x8(_ref502) {
  var _ref502$color = _ref502.color,
      C = _ref502$color === void 0 ? "currentColor" : _ref502$color,
      _ref502$size = _ref502.size,
      e = _ref502$size === void 0 ? 24 : _ref502$size,
      l = _ref502.className,
      i = _objectWithoutProperties(_ref502, _excluded502);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C6.47717 2 2 6.47717 2 12C2 17.5228 6.47717 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47717 17.5228 2 12 2ZM7.09436 5.68018C8.4491 4.62708 10.1512 4 12 4C16.4183 4 20 7.58167 20 12C20 13.8488 19.3729 15.5509 18.3198 16.9056L16.165 14.7509C16.3781 14.3829 16.5 13.9557 16.5 13.5C16.5 12.1193 15.3807 11 14 11H10C9.72388 11 9.5 10.7761 9.5 10.5C9.5 10.2239 9.72388 10 10 10H15.5V8H13V6H11V8H10C9.81836 8 9.64111 8.01929 9.47046 8.05615L7.09436 5.68018ZM5.68018 7.09436L7.83496 9.24915C7.62195 9.61707 7.5 10.0443 7.5 10.5C7.5 11.8807 8.61926 13 10 13H14C14.2761 13 14.5 13.2239 14.5 13.5C14.5 13.7761 14.2761 14 14 14H8.5V16H11V18H13V16H14C14.1818 16 14.359 15.9807 14.5297 15.9438L16.9056 18.3198C15.5509 19.3729 13.8488 20 12 20C7.58167 20 4 16.4183 4 12C4 10.1512 4.62708 8.4491 5.68018 7.09436Z"
  }));
},
    v8 = function v8(_ref503) {
  var _ref503$color = _ref503.color,
      C = _ref503$color === void 0 ? "currentColor" : _ref503$color,
      _ref503$size = _ref503.size,
      e = _ref503$size === void 0 ? 24 : _ref503$size,
      l = _ref503.className,
      i = _objectWithoutProperties(_ref503, _excluded503);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM16 13H8V15H16V13ZM16 9H8V11H16V9Z"
  }));
},
    d8 = function d8(_ref504) {
  var _ref504$color = _ref504.color,
      C = _ref504$color === void 0 ? "currentColor" : _ref504$color,
      _ref504$size = _ref504.size,
      e = _ref504$size === void 0 ? 24 : _ref504$size,
      l = _ref504.className,
      i = _objectWithoutProperties(_ref504, _excluded504);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8 9H16V11H8V9ZM8 15V13H16V15H8ZM2 12C2 6.47717 6.47717 2 12 2 17.5228 2 22 6.47717 22 12 22 17.5228 17.5228 22 12 22 6.47717 22 2 17.5228 2 12ZM12 4C7.58167 4 4 7.58167 4 12 4 16.4183 7.58167 20 12 20 16.4183 20 20 16.4183 20 12 20 7.58167 16.4183 4 12 4Z"
  }));
},
    p8 = function p8(_ref505) {
  var _ref505$color = _ref505.color,
      C = _ref505$color === void 0 ? "currentColor" : _ref505$color,
      _ref505$size = _ref505.size,
      e = _ref505$size === void 0 ? 24 : _ref505$size,
      l = _ref505.className,
      i = _objectWithoutProperties(_ref505, _excluded505);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2ZM12 6C9.82278 6 7.97058 7.66991 7.28433 10.0006L6 10L8.5 13L11 10L9.40123 10.0003C9.91991 8.80452 10.8895 8 12 8C13.6569 8 15 9.79086 15 12C15 14.2091 13.6569 16 12 16C10.8899 16 9.92064 15.1961 9.40181 14.0011L7.28471 14.0007C7.97126 16.3307 9.82318 18 12 18C14.7614 18 17 15.3137 17 12C17 8.68629 14.7614 6 12 6Z"
  }));
},
    E8 = function E8(_ref506) {
  var _ref506$color = _ref506.color,
      C = _ref506$color === void 0 ? "currentColor" : _ref506$color,
      _ref506$size = _ref506.size,
      e = _ref506$size === void 0 ? 24 : _ref506$size,
      l = _ref506.className,
      i = _objectWithoutProperties(_ref506, _excluded506);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17 12C17 8.68628 14.7615 6 12 6 9.82275 6 7.97058 7.66992 7.2843 10.0006L6 10 8.5 13 11 10 9.40125 10.0002C9.91992 8.80457 10.8895 8 12 8 13.6569 8 15 9.79089 15 12 15 14.2091 13.6569 16 12 16 10.8899 16 9.92065 15.196 9.40186 14.0011L7.28467 14.0006C7.97131 16.3307 9.82312 18 12 18 14.7615 18 17 15.3137 17 12ZM12 2C9.23987 2 6.73865 3.12134 4.93005 4.93005 3.12134 6.73865 2 9.23987 2 12 2 14.7601 3.12134 17.2614 4.93005 19.0699 6.73865 20.8787 9.23987 22 12 22 14.7601 22 17.2614 20.8787 19.0699 19.0699 20.8787 17.2614 22 14.7601 22 12 22 9.23987 20.8787 6.73865 19.0699 4.93005 17.2614 3.12134 14.7601 2 12 2ZM6.34424 6.34424C7.79358 4.8949 9.79224 4 12 4 14.2078 4 16.2064 4.8949 17.6558 6.34424 19.1051 7.79358 20 9.79224 20 12 20 14.2078 19.1051 16.2064 17.6558 17.6558 16.2064 19.1051 14.2078 20 12 20 9.79224 20 7.79358 19.1051 6.34424 17.6558 4.8949 16.2064 4 14.2078 4 12 4 9.79224 4.8949 7.79358 6.34424 6.34424Z"
  }));
},
    N8 = function N8(_ref507) {
  var _ref507$color = _ref507.color,
      C = _ref507$color === void 0 ? "currentColor" : _ref507$color,
      _ref507$size = _ref507.size,
      e = _ref507$size === void 0 ? 24 : _ref507$size,
      l = _ref507.className,
      i = _objectWithoutProperties(_ref507, _excluded507);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2ZM12 6C9.23858 6 7 8.68629 7 12C7 15.3137 9.23858 18 12 18C14.7614 18 17 15.3137 17 12C17 8.68629 14.7614 6 12 6ZM14.3253 9.47238C14.747 10.1614 15 11.0413 15 12C15 14.2091 13.6569 16 12 16C11.5589 16 11.1401 15.8731 10.7629 15.6452L14.3253 9.47238ZM12 8C12.4411 8 12.8599 8.12691 13.2371 8.35483L9.67474 14.5276C9.25296 13.8386 9 12.9587 9 12C9 9.79086 10.3431 8 12 8Z"
  }));
},
    u8 = function u8(_ref508) {
  var _ref508$color = _ref508.color,
      C = _ref508$color === void 0 ? "currentColor" : _ref508$color,
      _ref508$size = _ref508.size,
      e = _ref508$size === void 0 ? 24 : _ref508$size,
      l = _ref508.className,
      i = _objectWithoutProperties(_ref508, _excluded508);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17 12C17 8.68628 14.7615 6 12 6 9.23853 6 7 8.68628 7 12 7 15.3137 9.23853 18 12 18 14.7615 18 17 15.3137 17 12ZM10.7629 15.6451 14.3253 9.47241C14.7471 10.1614 15 11.0413 15 12 15 14.2091 13.6569 16 12 16 11.559 16 11.1401 15.873 10.7629 15.6451ZM9 12C9 9.79089 10.3431 8 12 8 12.441 8 12.8599 8.12695 13.2371 8.35486L9.67468 14.5276C9.25293 13.8386 9 12.9587 9 12ZM12 2C9.23987 2 6.73865 3.12134 4.93005 4.93005 3.12134 6.73865 2 9.23987 2 12 2 14.7601 3.12134 17.2614 4.93005 19.0699 6.73865 20.8787 9.23987 22 12 22 14.7601 22 17.2614 20.8787 19.0699 19.0699 20.8787 17.2614 22 14.7601 22 12 22 9.23987 20.8787 6.73865 19.0699 4.93005 17.2614 3.12134 14.7601 2 12 2ZM6.34424 6.34424C7.79358 4.8949 9.79224 4 12 4 14.2078 4 16.2064 4.8949 17.6558 6.34424 19.1051 7.79358 20 9.79224 20 12 20 14.2078 19.1051 16.2064 17.6558 17.6558 16.2064 19.1051 14.2078 20 12 20 9.79224 20 7.79358 19.1051 6.34424 17.6558 4.8949 16.2064 4 14.2078 4 12 4 9.79224 4.8949 7.79358 6.34424 6.34424Z"
  }));
},
    B8 = function B8(_ref509) {
  var _ref509$color = _ref509.color,
      C = _ref509$color === void 0 ? "currentColor" : _ref509$color,
      _ref509$size = _ref509.size,
      e = _ref509$size === void 0 ? 24 : _ref509$size,
      l = _ref509.className,
      i = _objectWithoutProperties(_ref509, _excluded509);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C16.9706 2 21 6.02944 21 11C21 13.2031 20.2084 15.2213 18.8941 16.7858C20.1491 17.6156 20.9275 18.6754 20.9952 19.835L21 20L12 22L3 20L3.00481 19.835C3.0725 18.6755 3.85076 17.6158 5.10554 16.7859C3.79194 15.2222 3 13.2036 3 11C3 6.02944 7.02944 2 12 2ZM12 13C10.6193 13 9.5 13.6716 9.5 14.5C9.5 15.3284 10.6193 16 12 16C13.3807 16 14.5 15.3284 14.5 14.5C14.5 13.6716 13.3807 13 12 13ZM9 8C7.89543 8 7 8.67157 7 9.5C7 10.3284 7.89543 11 9 11C10.1046 11 11 10.3284 11 9.5C11 8.67157 10.1046 8 9 8ZM15 8C13.8954 8 13 8.67157 13 9.5C13 10.3284 13.8954 11 15 11C16.1046 11 17 10.3284 17 9.5C17 8.67157 16.1046 8 15 8Z"
  }));
},
    f8 = function f8(_ref510) {
  var _ref510$color = _ref510.color,
      C = _ref510$color === void 0 ? "currentColor" : _ref510$color,
      _ref510$size = _ref510.size,
      e = _ref510$size === void 0 ? 24 : _ref510$size,
      l = _ref510.className,
      i = _objectWithoutProperties(_ref510, _excluded510);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C16.9706 2 21 6.02944 21 11C21 13.2031 20.2084 15.2213 18.8941 16.7858C20.1491 17.6156 20.9275 18.6754 20.9952 19.835L21 20L12 22L3 20L3.00481 19.835C3.0725 18.6755 3.85076 17.6158 5.10554 16.7859C3.79194 15.2222 3 13.2036 3 11C3 6.02944 7.02944 2 12 2ZM12 4C8.13401 4 5 7.13401 5 11C5 12.5669 5.5143 14.0501 6.44521 15.261L6.63691 15.4995L8.07955 17.2168L6.11776 18.5156L5.981 18.613L12 19.951L18.018 18.613L17.9693 18.577L17.791 18.454L15.9199 17.2168L17.3628 15.4993C18.415 14.2468 19 12.6712 19 11C19 7.13401 15.866 4 12 4ZM12 13C13.3807 13 14.5 13.6716 14.5 14.5C14.5 15.3284 13.3807 16 12 16C10.6193 16 9.5 15.3284 9.5 14.5C9.5 13.6716 10.6193 13 12 13ZM9 8C10.1046 8 11 8.67157 11 9.5C11 10.3284 10.1046 11 9 11C7.89543 11 7 10.3284 7 9.5C7 8.67157 7.89543 8 9 8ZM15 8C16.1046 8 17 8.67157 17 9.5C17 10.3284 16.1046 11 15 11C13.8954 11 13 10.3284 13 9.5C13 8.67157 13.8954 8 15 8Z"
  }));
},
    R8 = function R8(_ref511) {
  var _ref511$color = _ref511.color,
      C = _ref511$color === void 0 ? "currentColor" : _ref511$color,
      _ref511$size = _ref511.size,
      e = _ref511$size === void 0 ? 24 : _ref511$size,
      l = _ref511.className,
      i = _objectWithoutProperties(_ref511, _excluded511);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17.5858 5L20.1421 2.44365L21.5563 3.85786L19 6.41421V17H22V19H19V22H17V7H9V5H17.5858ZM15 17V19H6C5.44772 19 5 18.5523 5 18V7H2V5H5V2H7V17H15ZM9 9H15V15H9V9Z"
  }));
},
    z8 = function z8(_ref512) {
  var _ref512$color = _ref512.color,
      C = _ref512$color === void 0 ? "currentColor" : _ref512$color,
      _ref512$size = _ref512.size,
      e = _ref512$size === void 0 ? 24 : _ref512$size,
      l = _ref512.className,
      i = _objectWithoutProperties(_ref512, _excluded512);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8.41421 17H15V19H6C5.44772 19 5 18.5523 5 18V7H2V5H5V2H7V15.5858L15.5858 7H9V5H17.5858L20.1421 2.44365L21.5563 3.85786L19 6.41421V17H22V19H19V22H17V8.41421L8.41421 17Z"
  }));
},
    F8 = function F8(_ref513) {
  var _ref513$color = _ref513.color,
      C = _ref513$color === void 0 ? "currentColor" : _ref513$color,
      _ref513$size = _ref513.size,
      e = _ref513$size === void 0 ? 24 : _ref513$size,
      l = _ref513.className,
      i = _objectWithoutProperties(_ref513, _excluded513);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19 17H22V19H19V22H17V19H6C5.44772 19 5 18.5523 5 18V7H2V5H5V2H7V5H18C18.5523 5 19 5.44772 19 6V17Z"
  }));
},
    S8 = function S8(_ref514) {
  var _ref514$color = _ref514.color,
      C = _ref514$color === void 0 ? "currentColor" : _ref514$color,
      _ref514$size = _ref514.size,
      e = _ref514$size === void 0 ? 24 : _ref514$size,
      l = _ref514.className,
      i = _objectWithoutProperties(_ref514, _excluded514);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15 17V19H6C5.44772 19 5 18.5523 5 18V7H2V5H5V2H7V17H15ZM17 22V7H9V5H18C18.5523 5 19 5.44772 19 6V17H22V19H19V22H17Z"
  }));
},
    A8 = function A8(_ref515) {
  var _ref515$color = _ref515.color,
      C = _ref515$color === void 0 ? "currentColor" : _ref515$color,
      _ref515$size = _ref515.size,
      e = _ref515$size === void 0 ? 24 : _ref515$size,
      l = _ref515.className,
      i = _objectWithoutProperties(_ref515, _excluded515);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5.00006 3L4.35006 6.34H17.9401L17.5001 8.5H3.92006L3.26006 11.83H16.8501L16.0901 15.64L10.6101 17.45L5.86006 15.64L6.19006 14H2.85006L2.06006 18L9.91006 21L18.9601 18L20.1601 11.97L20.4001 10.76L21.9401 3H5.00006Z"
  }));
},
    k8 = function k8(_ref516) {
  var _ref516$color = _ref516.color,
      C = _ref516$color === void 0 ? "currentColor" : _ref516$color,
      _ref516$size = _ref516.size,
      e = _ref516$size === void 0 ? 24 : _ref516$size,
      l = _ref516.className,
      i = _objectWithoutProperties(_ref516, _excluded516);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2.8 14H4.83961L4.2947 16.7245L10.0393 18.8787L17.2665 16.4697L18.3604 11H3.4L3.8 9H18.7604L19.5604 5H4.6L5 3H22L19 18L10 21L2 18L2.8 14Z"
  }));
},
    P8 = function P8(_ref517) {
  var _ref517$color = _ref517.color,
      C = _ref517$color === void 0 ? "currentColor" : _ref517$color,
      _ref517$size = _ref517.size,
      e = _ref517$size === void 0 ? 24 : _ref517$size,
      l = _ref517.className,
      i = _objectWithoutProperties(_ref517, _excluded517);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5 3H20C21.1046 3 22 3.89543 22 5V8C22 9.10457 21.1046 10 20 10H18V13C18 15.2091 16.2091 17 14 17H8C5.79086 17 4 15.2091 4 13V4C4 3.44772 4.44772 3 5 3ZM18 5V8H20V5H18ZM2 19H20V21H2V19Z"
  }));
},
    D8 = function D8(_ref518) {
  var _ref518$color = _ref518.color,
      C = _ref518$color === void 0 ? "currentColor" : _ref518$color,
      _ref518$size = _ref518.size,
      e = _ref518$size === void 0 ? 24 : _ref518$size,
      l = _ref518.className,
      i = _objectWithoutProperties(_ref518, _excluded518);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16 13V5H6V13C6 14.1046 6.89543 15 8 15H14C15.1046 15 16 14.1046 16 13ZM5 3H20C21.1046 3 22 3.89543 22 5V8C22 9.10457 21.1046 10 20 10H18V13C18 15.2091 16.2091 17 14 17H8C5.79086 17 4 15.2091 4 13V4C4 3.44772 4.44772 3 5 3ZM18 5V8H20V5H18ZM2 19H20V21H2V19Z"
  }));
},
    y8 = function y8(_ref519) {
  var _ref519$color = _ref519.color,
      C = _ref519$color === void 0 ? "currentColor" : _ref519$color,
      _ref519$size = _ref519.size,
      e = _ref519$size === void 0 ? 24 : _ref519$size,
      l = _ref519.className,
      i = _objectWithoutProperties(_ref519, _excluded519);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17.0047 16.0028H19.0047V4.00281H9.00468V6.00281H17.0047V16.0028ZM17.0047 18.0028V21.0019C17.0047 21.5547 16.5547 22.0028 15.9978 22.0028H4.01154C3.45548 22.0028 3.00488 21.5582 3.00488 21.0019L3.00748 7.00368C3.00759 6.45091 3.45752 6.00281 4.0143 6.00281H7.00468V3.00281C7.00468 2.45052 7.4524 2.00281 8.00468 2.00281H20.0047C20.557 2.00281 21.0047 2.45052 21.0047 3.00281V17.0028C21.0047 17.5551 20.557 18.0028 20.0047 18.0028H17.0047ZM7.00468 16.0028V18.0028H9.00468V19.0028H11.0047V18.0028H11.5047C12.8854 18.0028 14.0047 16.8835 14.0047 15.5028C14.0047 14.1221 12.8854 13.0028 11.5047 13.0028H8.50468C8.22854 13.0028 8.00468 12.7789 8.00468 12.5028C8.00468 12.2267 8.22854 12.0028 8.50468 12.0028H13.0047V10.0028H11.0047V9.00281H9.00468V10.0028H8.50468C7.12397 10.0028 6.00468 11.1221 6.00468 12.5028C6.00468 13.8835 7.12397 15.0028 8.50468 15.0028H11.5047C11.7808 15.0028 12.0047 15.2267 12.0047 15.5028C12.0047 15.7789 11.7808 16.0028 11.5047 16.0028H7.00468Z"
  }));
},
    b8 = function b8(_ref520) {
  var _ref520$color = _ref520.color,
      C = _ref520$color === void 0 ? "currentColor" : _ref520$color,
      _ref520$size = _ref520.size,
      e = _ref520$size === void 0 ? 24 : _ref520$size,
      l = _ref520.className,
      i = _objectWithoutProperties(_ref520, _excluded520);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17.0047 16.0028H19.0047V4.00281H9.00468V6.00281H17.0047V16.0028ZM17.0047 18.0028V21.0019C17.0047 21.5547 16.5547 22.0028 15.9978 22.0028H4.01154C3.45548 22.0028 3.00488 21.5582 3.00488 21.0019L3.00748 7.00368C3.00759 6.45091 3.45752 6.00281 4.0143 6.00281H7.00468V3.00281C7.00468 2.45052 7.4524 2.00281 8.00468 2.00281H20.0047C20.557 2.00281 21.0047 2.45052 21.0047 3.00281V17.0028C21.0047 17.5551 20.557 18.0028 20.0047 18.0028H17.0047ZM5.0073 8.00281L5.00507 20.0028H15.0047V8.00281H5.0073ZM7.00468 16.0028H11.5047C11.7808 16.0028 12.0047 15.7789 12.0047 15.5028C12.0047 15.2267 11.7808 15.0028 11.5047 15.0028H8.50468C7.12397 15.0028 6.00468 13.8835 6.00468 12.5028C6.00468 11.1221 7.12397 10.0028 8.50468 10.0028H9.00468V9.00281H11.0047V10.0028H13.0047V12.0028H8.50468C8.22854 12.0028 8.00468 12.2267 8.00468 12.5028C8.00468 12.7789 8.22854 13.0028 8.50468 13.0028H11.5047C12.8854 13.0028 14.0047 14.1221 14.0047 15.5028C14.0047 16.8835 12.8854 18.0028 11.5047 18.0028H11.0047V19.0028H9.00468V18.0028H7.00468V16.0028Z"
  }));
},
    T8 = function T8(_ref521) {
  var _ref521$color = _ref521.color,
      C = _ref521$color === void 0 ? "currentColor" : _ref521$color,
      _ref521$size = _ref521.size,
      e = _ref521$size === void 0 ? 24 : _ref521$size,
      l = _ref521.className,
      i = _objectWithoutProperties(_ref521, _excluded521);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13.9093 12.3603L17.0007 20.8537L14.1816 21.8798L11.0902 13.3864L6.91797 16.5422L8.4087 1.63318L19.134 12.0959L13.9093 12.3603Z"
  }));
},
    U8 = function U8(_ref522) {
  var _ref522$color = _ref522.color,
      C = _ref522$color === void 0 ? "currentColor" : _ref522$color,
      _ref522$size = _ref522.size,
      e = _ref522$size === void 0 ? 24 : _ref522$size,
      l = _ref522.className,
      i = _objectWithoutProperties(_ref522, _excluded522);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15.3873 13.4975L17.9403 20.5117L13.2418 22.2218L10.6889 15.2076L6.79004 17.6529L8.4086 1.63318L19.9457 12.8646L15.3873 13.4975ZM15.3768 19.3163L12.6618 11.8568L15.6212 11.4459L9.98201 5.9561L9.19088 13.7863L11.7221 12.1988L14.4371 19.6583L15.3768 19.3163Z"
  }));
},
    G8 = function G8(_ref523) {
  var _ref523$color = _ref523.color,
      C = _ref523$color === void 0 ? "currentColor" : _ref523$color,
      _ref523$size = _ref523.size,
      e = _ref523$size === void 0 ? 24 : _ref523$size,
      l = _ref523.className,
      i = _objectWithoutProperties(_ref523, _excluded523);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 8C22.1046 8 23 8.89543 23 10V14C23 15.1046 22.1046 16 21 16H19.9381C19.446 19.9463 16.0796 23 12 23V21C15.3137 21 18 18.3137 18 15V9C18 5.68629 15.3137 3 12 3C8.68629 3 6 5.68629 6 9V16H3C1.89543 16 1 15.1046 1 14V10C1 8.89543 1.89543 8 3 8H4.06189C4.55399 4.05369 7.92038 1 12 1C16.0796 1 19.446 4.05369 19.9381 8H21ZM7.75944 15.7849L8.81958 14.0887C9.74161 14.6662 10.8318 15 12 15C13.1682 15 14.2584 14.6662 15.1804 14.0887L16.2406 15.7849C15.0112 16.5549 13.5576 17 12 17C10.4424 17 8.98882 16.5549 7.75944 15.7849Z"
  }));
},
    I8 = function I8(_ref524) {
  var _ref524$color = _ref524.color,
      C = _ref524$color === void 0 ? "currentColor" : _ref524$color,
      _ref524$size = _ref524.size,
      e = _ref524$size === void 0 ? 24 : _ref524$size,
      l = _ref524.className,
      i = _objectWithoutProperties(_ref524, _excluded524);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19.9381 8H21C22.1046 8 23 8.89543 23 10V14C23 15.1046 22.1046 16 21 16H19.9381C19.446 19.9463 16.0796 23 12 23V21C15.3137 21 18 18.3137 18 15V9C18 5.68629 15.3137 3 12 3C8.68629 3 6 5.68629 6 9V16H3C1.89543 16 1 15.1046 1 14V10C1 8.89543 1.89543 8 3 8H4.06189C4.55399 4.05369 7.92038 1 12 1C16.0796 1 19.446 4.05369 19.9381 8ZM3 10V14H4V10H3ZM20 10V14H21V10H20ZM7.75944 15.7849L8.81958 14.0887C9.74161 14.6662 10.8318 15 12 15C13.1682 15 14.2584 14.6662 15.1804 14.0887L16.2406 15.7849C15.0112 16.5549 13.5576 17 12 17C10.4424 17 8.98882 16.5549 7.75944 15.7849Z"
  }));
},
    W8 = function W8(_ref525) {
  var _ref525$color = _ref525.color,
      C = _ref525$color === void 0 ? "currentColor" : _ref525$color,
      _ref525$size = _ref525.size,
      e = _ref525$size === void 0 ? 24 : _ref525$size,
      l = _ref525.className,
      i = _objectWithoutProperties(_ref525, _excluded525);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22 17.0022C21.999 19.8731 19.9816 22.2726 17.2872 22.8616L16.6492 20.9476C17.8532 20.7511 18.8765 20.0171 19.4649 19H17C15.8954 19 15 18.1046 15 17V13C15 11.8954 15.8954 11 17 11H19.9381C19.446 7.05369 16.0796 4 12 4C7.92038 4 4.55399 7.05369 4.06189 11H7C8.10457 11 9 11.8954 9 13V17C9 18.1046 8.10457 19 7 19H4C2.89543 19 2 18.1046 2 17V12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12V12.9987V13V17V17.0013V17.0022Z"
  }));
},
    O8 = function O8(_ref526) {
  var _ref526$color = _ref526.color,
      C = _ref526$color === void 0 ? "currentColor" : _ref526$color,
      _ref526$size = _ref526.size,
      e = _ref526$size === void 0 ? 24 : _ref526$size,
      l = _ref526.className,
      i = _objectWithoutProperties(_ref526, _excluded526);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22 17.0022C21.999 19.8731 19.9816 22.2726 17.2872 22.8616L16.6492 20.9476C17.8532 20.7511 18.8765 20.0171 19.4649 19H17C15.8954 19 15 18.1046 15 17V13C15 11.8954 15.8954 11 17 11H19.9381C19.446 7.05369 16.0796 4 12 4C7.92038 4 4.55399 7.05369 4.06189 11H7C8.10457 11 9 11.8954 9 13V17C9 18.1046 8.10457 19 7 19H4C2.89543 19 2 18.1046 2 17V12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12V12.9987V13V17V17.0013V17.0022ZM20 17V13H17V17H20ZM4 13V17H7V13H4Z"
  }));
},
    K8 = function K8(_ref527) {
  var _ref527$color = _ref527.color,
      C = _ref527$color === void 0 ? "currentColor" : _ref527$color,
      _ref527$size = _ref527.size,
      e = _ref527$size === void 0 ? 24 : _ref527$size,
      l = _ref527.className,
      i = _objectWithoutProperties(_ref527, _excluded527);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 5C8.13401 5 5 8.13401 5 12C5 13.8525 5.71957 15.5368 6.89445 16.7889L7.05025 16.9497L8.46447 15.5355C7.55964 14.6307 7 13.3807 7 12C7 9.23858 9.23858 7 12 7C12.448 7 12.8822 7.05892 13.2954 7.16944L14.8579 5.60806C13.9852 5.21731 13.018 5 12 5ZM18.3924 9.14312L16.8306 10.7046C16.9411 11.1178 17 11.552 17 12C17 13.3807 16.4404 14.6307 15.5355 15.5355L16.9497 16.9497C18.2165 15.683 19 13.933 19 12C19 10.9824 18.7829 10.0155 18.3924 9.14312ZM16.2426 6.34315L12.517 10.0675C12.3521 10.0235 12.1788 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14C13.1046 14 14 13.1046 14 12C14 11.8212 13.9765 11.6479 13.9325 11.483L17.6569 7.75736L16.2426 6.34315Z"
  }));
},
    Q8 = function Q8(_ref528) {
  var _ref528$color = _ref528.color,
      C = _ref528$color === void 0 ? "currentColor" : _ref528$color,
      _ref528$size = _ref528.size,
      e = _ref528$size === void 0 ? 24 : _ref528$size,
      l = _ref528.className,
      i = _objectWithoutProperties(_ref528, _excluded528);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM12 5C13.018 5 13.9852 5.21731 14.8579 5.60806L13.2954 7.16944C12.8822 7.05892 12.448 7 12 7C9.23858 7 7 9.23858 7 12C7 13.3807 7.55964 14.6307 8.46447 15.5355L7.05025 16.9497L6.89445 16.7889C5.71957 15.5368 5 13.8525 5 12C5 8.13401 8.13401 5 12 5ZM18.3924 9.14312C18.7829 10.0155 19 10.9824 19 12C19 13.933 18.2165 15.683 16.9497 16.9497L15.5355 15.5355C16.4404 14.6307 17 13.3807 17 12C17 11.552 16.9411 11.1178 16.8306 10.7046L18.3924 9.14312ZM16.2426 6.34315L17.6569 7.75736L13.9325 11.483C13.9765 11.6479 14 11.8212 14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C12.1788 10 12.3521 10.0235 12.517 10.0675L16.2426 6.34315Z"
  }));
},
    q8 = function q8(_ref529) {
  var _ref529$color = _ref529.color,
      C = _ref529$color === void 0 ? "currentColor" : _ref529$color,
      _ref529$size = _ref529.size,
      e = _ref529$size === void 0 ? 24 : _ref529$size,
      l = _ref529.className,
      i = _objectWithoutProperties(_ref529, _excluded529);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM16.5962 7.40381C16.3916 7.19926 16.0697 7.17128 15.8329 7.33748C12.9438 9.36549 11.3126 10.5661 10.9393 10.9393C10.3536 11.5251 10.3536 12.4749 10.9393 13.0607C11.5251 13.6464 12.4749 13.6464 13.0607 13.0607C13.2796 12.8417 14.479 11.2095 16.6587 8.16418C16.8267 7.92955 16.8002 7.60784 16.5962 7.40381ZM17.5 11C16.9477 11 16.5 11.4477 16.5 12C16.5 12.5523 16.9477 13 17.5 13C18.0523 13 18.5 12.5523 18.5 12C18.5 11.4477 18.0523 11 17.5 11ZM6.5 11C5.94772 11 5.5 11.4477 5.5 12C5.5 12.5523 5.94772 13 6.5 13C7.05228 13 7.5 12.5523 7.5 12C7.5 11.4477 7.05228 11 6.5 11ZM8.81802 7.40381C8.4275 7.01328 7.79433 7.01328 7.40381 7.40381C7.01328 7.79433 7.01328 8.4275 7.40381 8.81802C7.79433 9.20854 8.4275 9.20854 8.81802 8.81802C9.20854 8.4275 9.20854 7.79433 8.81802 7.40381ZM12 5.5C11.4477 5.5 11 5.94772 11 6.5C11 7.05228 11.4477 7.5 12 7.5C12.5523 7.5 13 7.05228 13 6.5C13 5.94772 12.5523 5.5 12 5.5Z"
  }));
},
    j8 = function j8(_ref530) {
  var _ref530$color = _ref530.color,
      C = _ref530$color === void 0 ? "currentColor" : _ref530$color,
      _ref530$size = _ref530.size,
      e = _ref530$size === void 0 ? 24 : _ref530$size,
      l = _ref530.className,
      i = _objectWithoutProperties(_ref530, _excluded530);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM15.8329 7.33748C16.0697 7.17128 16.3916 7.19926 16.5962 7.40381C16.8002 7.60784 16.8267 7.92955 16.6587 8.16418C14.479 11.2095 13.2796 12.8417 13.0607 13.0607C12.4749 13.6464 11.5251 13.6464 10.9393 13.0607C10.3536 12.4749 10.3536 11.5251 10.9393 10.9393C11.3126 10.5661 12.9438 9.36549 15.8329 7.33748ZM17.5 11C18.0523 11 18.5 11.4477 18.5 12C18.5 12.5523 18.0523 13 17.5 13C16.9477 13 16.5 12.5523 16.5 12C16.5 11.4477 16.9477 11 17.5 11ZM6.5 11C7.05228 11 7.5 11.4477 7.5 12C7.5 12.5523 7.05228 13 6.5 13C5.94772 13 5.5 12.5523 5.5 12C5.5 11.4477 5.94772 11 6.5 11ZM8.81802 7.40381C9.20854 7.79433 9.20854 8.4275 8.81802 8.81802C8.4275 9.20854 7.79433 9.20854 7.40381 8.81802C7.01328 8.4275 7.01328 7.79433 7.40381 7.40381C7.79433 7.01328 8.4275 7.01328 8.81802 7.40381ZM12 5.5C12.5523 5.5 13 5.94772 13 6.5C13 7.05228 12.5523 7.5 12 7.5C11.4477 7.5 11 7.05228 11 6.5C11 5.94772 11.4477 5.5 12 5.5Z"
  }));
},
    X8 = function X8(_ref531) {
  var _ref531$color = _ref531.color,
      C = _ref531$color === void 0 ? "currentColor" : _ref531$color,
      _ref531$size = _ref531.size,
      e = _ref531$size === void 0 ? 24 : _ref531$size,
      l = _ref531.className,
      i = _objectWithoutProperties(_ref531, _excluded531);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 12C3 12.5523 3.44772 13 4 13H10C10.5523 13 11 12.5523 11 12V4C11 3.44772 10.5523 3 10 3H4C3.44772 3 3 3.44772 3 4V12ZM3 20C3 20.5523 3.44772 21 4 21H10C10.5523 21 11 20.5523 11 20V16C11 15.4477 10.5523 15 10 15H4C3.44772 15 3 15.4477 3 16V20ZM13 20C13 20.5523 13.4477 21 14 21H20C20.5523 21 21 20.5523 21 20V12C21 11.4477 20.5523 11 20 11H14C13.4477 11 13 11.4477 13 12V20ZM14 3C13.4477 3 13 3.44772 13 4V8C13 8.55228 13.4477 9 14 9H20C20.5523 9 21 8.55228 21 8V4C21 3.44772 20.5523 3 20 3H14Z"
  }));
},
    J8 = function J8(_ref532) {
  var _ref532$color = _ref532.color,
      C = _ref532$color === void 0 ? "currentColor" : _ref532$color,
      _ref532$size = _ref532.size,
      e = _ref532$size === void 0 ? 24 : _ref532$size,
      l = _ref532.className,
      i = _objectWithoutProperties(_ref532, _excluded532);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14 21C13.4477 21 13 20.5523 13 20V12C13 11.4477 13.4477 11 14 11H20C20.5523 11 21 11.4477 21 12V20C21 20.5523 20.5523 21 20 21H14ZM4 13C3.44772 13 3 12.5523 3 12V4C3 3.44772 3.44772 3 4 3H10C10.5523 3 11 3.44772 11 4V12C11 12.5523 10.5523 13 10 13H4ZM9 11V5H5V11H9ZM4 21C3.44772 21 3 20.5523 3 20V16C3 15.4477 3.44772 15 4 15H10C10.5523 15 11 15.4477 11 16V20C11 20.5523 10.5523 21 10 21H4ZM5 19H9V17H5V19ZM15 19H19V13H15V19ZM13 4C13 3.44772 13.4477 3 14 3H20C20.5523 3 21 3.44772 21 4V8C21 8.55228 20.5523 9 20 9H14C13.4477 9 13 8.55228 13 8V4ZM15 5V7H19V5H15Z"
  }));
},
    Y8 = function Y8(_ref533) {
  var _ref533$color = _ref533.color,
      C = _ref533$color === void 0 ? "currentColor" : _ref533$color,
      _ref533$size = _ref533.size,
      e = _ref533$size === void 0 ? 24 : _ref533$size,
      l = _ref533.className,
      i = _objectWithoutProperties(_ref533, _excluded533);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 9.5V12.5C21 14.9853 16.9706 17 12 17C7.02944 17 3 14.9853 3 12.5V9.5C3 11.9853 7.02944 14 12 14C16.9706 14 21 11.9853 21 9.5ZM3 14.5C3 16.9853 7.02944 19 12 19C16.9706 19 21 16.9853 21 14.5V17.5C21 19.9853 16.9706 22 12 22C7.02944 22 3 19.9853 3 17.5V14.5ZM12 12C7.02944 12 3 9.98528 3 7.5C3 5.01472 7.02944 3 12 3C16.9706 3 21 5.01472 21 7.5C21 9.98528 16.9706 12 12 12Z"
  }));
},
    _8 = function _8(_ref534) {
  var _ref534$color = _ref534.color,
      C = _ref534$color === void 0 ? "currentColor" : _ref534$color,
      _ref534$size = _ref534.size,
      e = _ref534$size === void 0 ? 24 : _ref534$size,
      l = _ref534.className,
      i = _objectWithoutProperties(_ref534, _excluded534);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5 12.5C5 12.8134 5.46101 13.3584 6.53047 13.8931C7.91405 14.5849 9.87677 15 12 15C14.1232 15 16.0859 14.5849 17.4695 13.8931C18.539 13.3584 19 12.8134 19 12.5V10.3287C17.35 11.3482 14.8273 12 12 12C9.17273 12 6.64996 11.3482 5 10.3287V12.5ZM19 15.3287C17.35 16.3482 14.8273 17 12 17C9.17273 17 6.64996 16.3482 5 15.3287V17.5C5 17.8134 5.46101 18.3584 6.53047 18.8931C7.91405 19.5849 9.87677 20 12 20C14.1232 20 16.0859 19.5849 17.4695 18.8931C18.539 18.3584 19 17.8134 19 17.5V15.3287ZM3 17.5V7.5C3 5.01472 7.02944 3 12 3C16.9706 3 21 5.01472 21 7.5V17.5C21 19.9853 16.9706 22 12 22C7.02944 22 3 19.9853 3 17.5ZM12 10C14.1232 10 16.0859 9.58492 17.4695 8.89313C18.539 8.3584 19 7.81342 19 7.5C19 7.18658 18.539 6.6416 17.4695 6.10687C16.0859 5.41508 14.1232 5 12 5C9.87677 5 7.91405 5.41508 6.53047 6.10687C5.46101 6.6416 5 7.18658 5 7.5C5 7.81342 5.46101 8.3584 6.53047 8.89313C7.91405 9.58492 9.87677 10 12 10Z"
  }));
},
    $8 = function $8(_ref535) {
  var _ref535$color = _ref535.color,
      C = _ref535$color === void 0 ? "currentColor" : _ref535$color,
      _ref535$size = _ref535.size,
      e = _ref535$size === void 0 ? 24 : _ref535$size,
      l = _ref535.className,
      i = _objectWithoutProperties(_ref535, _excluded535);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11 7V4C11 3.44772 11.4477 3 12 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V8C2 7.44772 2.44772 7 3 7H11ZM5 16V18H10V16H5ZM14 16V18H19V16H14ZM14 13V15H19V13H14ZM14 10V12H19V10H14ZM5 13V15H10V13H5Z"
  }));
},
    e6 = function e6(_ref536) {
  var _ref536$color = _ref536.color,
      C = _ref536$color === void 0 ? "currentColor" : _ref536$color,
      _ref536$size = _ref536.size,
      e = _ref536$size === void 0 ? 24 : _ref536$size,
      l = _ref536.className,
      i = _objectWithoutProperties(_ref536, _excluded536);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11 19V9H4V19H11ZM11 7V4C11 3.44772 11.4477 3 12 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V8C2 7.44772 2.44772 7 3 7H11ZM13 5V19H20V5H13ZM5 16H10V18H5V16ZM14 16H19V18H14V16ZM14 13H19V15H14V13ZM14 10H19V12H14V10ZM5 13H10V15H5V13Z"
  }));
},
    t6 = function t6(_ref537) {
  var _ref537$color = _ref537.color,
      C = _ref537$color === void 0 ? "currentColor" : _ref537$color,
      _ref537$size = _ref537.size,
      e = _ref537$size === void 0 ? 24 : _ref537$size,
      l = _ref537.className,
      i = _objectWithoutProperties(_ref537, _excluded537);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.53451 3H20.9993C21.5516 3 21.9993 3.44772 21.9993 4V20C21.9993 20.5523 21.5516 21 20.9993 21H6.53451C6.20015 21 5.88792 20.8329 5.70246 20.5547L0.369122 12.5547C0.145189 12.2188 0.145189 11.7812 0.369122 11.4453L5.70246 3.4453C5.88792 3.1671 6.20015 3 6.53451 3ZM12.9993 10.5858L10.1709 7.75736L8.75668 9.17157L11.5851 12L8.75668 14.8284L10.1709 16.2426L12.9993 13.4142L15.8277 16.2426L17.242 14.8284L14.4135 12L17.242 9.17157L15.8277 7.75736L12.9993 10.5858Z"
  }));
},
    C6 = function C6(_ref538) {
  var _ref538$color = _ref538.color,
      C = _ref538$color === void 0 ? "currentColor" : _ref538$color,
      _ref538$size = _ref538.size,
      e = _ref538$size === void 0 ? 24 : _ref538$size,
      l = _ref538.className,
      i = _objectWithoutProperties(_ref538, _excluded538);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.53451 3H20.9993C21.5516 3 21.9993 3.44772 21.9993 4V20C21.9993 20.5523 21.5516 21 20.9993 21H6.53451C6.20015 21 5.88792 20.8329 5.70246 20.5547L0.369122 12.5547C0.145189 12.2188 0.145189 11.7812 0.369122 11.4453L5.70246 3.4453C5.88792 3.1671 6.20015 3 6.53451 3ZM7.06969 5L2.40302 12L7.06969 19H19.9993V5H7.06969ZM12.9993 10.5858L15.8277 7.75736L17.242 9.17157L14.4135 12L17.242 14.8284L15.8277 16.2426L12.9993 13.4142L10.1709 16.2426L8.75668 14.8284L11.5851 12L8.75668 9.17157L10.1709 7.75736L12.9993 10.5858Z"
  }));
},
    l6 = function l6(_ref539) {
  var _ref539$color = _ref539.color,
      C = _ref539$color === void 0 ? "currentColor" : _ref539$color,
      _ref539$size = _ref539.size,
      e = _ref539$size === void 0 ? 24 : _ref539$size,
      l = _ref539.className,
      i = _objectWithoutProperties(_ref539, _excluded539);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.53451 3H20.9993C21.5516 3 21.9993 3.44772 21.9993 4V20C21.9993 20.5523 21.5516 21 20.9993 21H6.53451C6.20015 21 5.88792 20.8329 5.70246 20.5547L0.369122 12.5547C0.145189 12.2188 0.145189 11.7812 0.369122 11.4453L5.70246 3.4453C5.88792 3.1671 6.20015 3 6.53451 3ZM15.9993 11H8.99932V13H15.9993V11Z"
  }));
},
    i6 = function i6(_ref540) {
  var _ref540$color = _ref540.color,
      C = _ref540$color === void 0 ? "currentColor" : _ref540$color,
      _ref540$size = _ref540.size,
      e = _ref540$size === void 0 ? 24 : _ref540$size,
      l = _ref540.className,
      i = _objectWithoutProperties(_ref540, _excluded540);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.53451 3H20.9993C21.5516 3 21.9993 3.44772 21.9993 4V20C21.9993 20.5523 21.5516 21 20.9993 21H6.53451C6.20015 21 5.88792 20.8329 5.70246 20.5547L0.369122 12.5547C0.145189 12.2188 0.145189 11.7812 0.369122 11.4453L5.70246 3.4453C5.88792 3.1671 6.20015 3 6.53451 3ZM7.06969 5L2.40302 12L7.06969 19H19.9993V5H7.06969ZM15.9993 11V13H8.99932V11H15.9993Z"
  }));
},
    s6 = function s6(_ref541) {
  var _ref541$color = _ref541.color,
      C = _ref541$color === void 0 ? "currentColor" : _ref541$color,
      _ref541$size = _ref541.size,
      e = _ref541$size === void 0 ? 24 : _ref541$size,
      l = _ref541.className,
      i = _objectWithoutProperties(_ref541, _excluded541);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7 6V3C7 2.44772 7.44772 2 8 2H16C16.5523 2 17 2.44772 17 3V6H22V8H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V8H2V6H7ZM13.4142 13.9997L15.182 12.232L13.7678 10.8178L12 12.5855L10.2322 10.8178L8.81802 12.232L10.5858 13.9997L8.81802 15.7675L10.2322 17.1817L12 15.4139L13.7678 17.1817L15.182 15.7675L13.4142 13.9997ZM9 4V6H15V4H9Z"
  }));
},
    r6 = function r6(_ref542) {
  var _ref542$color = _ref542.color,
      C = _ref542$color === void 0 ? "currentColor" : _ref542$color,
      _ref542$size = _ref542.size,
      e = _ref542$size === void 0 ? 24 : _ref542$size,
      l = _ref542.className,
      i = _objectWithoutProperties(_ref542, _excluded542);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17 6H22V8H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V8H2V6H7V3C7 2.44772 7.44772 2 8 2H16C16.5523 2 17 2.44772 17 3V6ZM18 8H6V20H18V8ZM13.4142 13.9997L15.182 15.7675L13.7678 17.1817L12 15.4139L10.2322 17.1817L8.81802 15.7675L10.5858 13.9997L8.81802 12.232L10.2322 10.8178L12 12.5855L13.7678 10.8178L15.182 12.232L13.4142 13.9997ZM9 4V6H15V4H9Z"
  }));
},
    c6 = function c6(_ref543) {
  var _ref543$color = _ref543.color,
      C = _ref543$color === void 0 ? "currentColor" : _ref543$color,
      _ref543$size = _ref543.size,
      e = _ref543$size === void 0 ? 24 : _ref543$size,
      l = _ref543.className,
      i = _objectWithoutProperties(_ref543, _excluded543);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 7V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V7H2V5H22V7H20ZM11 9V11H13V9H11ZM11 12V14H13V12H11ZM11 15V17H13V15H11ZM7 2H17V4H7V2Z"
  }));
},
    o6 = function o6(_ref544) {
  var _ref544$color = _ref544.color,
      C = _ref544$color === void 0 ? "currentColor" : _ref544$color,
      _ref544$size = _ref544.size,
      e = _ref544$size === void 0 ? 24 : _ref544$size,
      l = _ref544.className,
      i = _objectWithoutProperties(_ref544, _excluded544);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 7V20C20 21.1046 19.1046 22 18 22H6C4.89543 22 4 21.1046 4 20V7H2V5H22V7H20ZM6 7V20H18V7H6ZM11 9H13V11H11V9ZM11 12H13V14H11V12ZM11 15H13V17H11V15ZM7 2H17V4H7V2Z"
  }));
},
    a6 = function a6(_ref545) {
  var _ref545$color = _ref545.color,
      C = _ref545$color === void 0 ? "currentColor" : _ref545$color,
      _ref545$size = _ref545.size,
      e = _ref545$size === void 0 ? 24 : _ref545$size,
      l = _ref545.className,
      i = _objectWithoutProperties(_ref545, _excluded545);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 7V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V7H2V5H22V7H20ZM11 10V17H13V10H11ZM7 2H17V4H7V2Z"
  }));
},
    n6 = function n6(_ref546) {
  var _ref546$color = _ref546.color,
      C = _ref546$color === void 0 ? "currentColor" : _ref546$color,
      _ref546$size = _ref546.size,
      e = _ref546$size === void 0 ? 24 : _ref546$size,
      l = _ref546.className,
      i = _objectWithoutProperties(_ref546, _excluded546);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 7V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V7H2V5H22V7H20ZM6 7V20H18V7H6ZM7 2H17V4H7V2ZM11 10H13V17H11V10Z"
  }));
},
    m6 = function m6(_ref547) {
  var _ref547$color = _ref547.color,
      C = _ref547$color === void 0 ? "currentColor" : _ref547$color,
      _ref547$size = _ref547.size,
      e = _ref547$size === void 0 ? 24 : _ref547$size,
      l = _ref547.className,
      i = _objectWithoutProperties(_ref547, _excluded547);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 8H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V8ZM7 5V3C7 2.44772 7.44772 2 8 2H16C16.5523 2 17 2.44772 17 3V5H22V7H2V5H7ZM9 4V5H15V4H9ZM9 12V18H11V12H9ZM13 12V18H15V12H13Z"
  }));
},
    w6 = function w6(_ref548) {
  var _ref548$color = _ref548.color,
      C = _ref548$color === void 0 ? "currentColor" : _ref548$color,
      _ref548$size = _ref548.size,
      e = _ref548$size === void 0 ? 24 : _ref548$size,
      l = _ref548.className,
      i = _objectWithoutProperties(_ref548, _excluded548);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 8H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V8ZM6 10V20H18V10H6ZM9 12H11V18H9V12ZM13 12H15V18H13V12ZM7 5V3C7 2.44772 7.44772 2 8 2H16C16.5523 2 17 2.44772 17 3V5H22V7H2V5H7ZM9 4V5H15V4H9Z"
  }));
},
    L6 = function L6(_ref549) {
  var _ref549$color = _ref549.color,
      C = _ref549$color === void 0 ? "currentColor" : _ref549$color,
      _ref549$size = _ref549.size,
      e = _ref549$size === void 0 ? 24 : _ref549$size,
      l = _ref549.className,
      i = _objectWithoutProperties(_ref549, _excluded549);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17 4H22V6H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V6H2V4H7V2H17V4ZM9 9V17H11V9H9ZM13 9V17H15V9H13Z"
  }));
},
    h6 = function h6(_ref550) {
  var _ref550$color = _ref550.color,
      C = _ref550$color === void 0 ? "currentColor" : _ref550$color,
      _ref550$size = _ref550.size,
      e = _ref550$size === void 0 ? 24 : _ref550$size,
      l = _ref550.className,
      i = _objectWithoutProperties(_ref550, _excluded550);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7 4V2H17V4H22V6H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V6H2V4H7ZM6 6V20H18V6H6ZM9 9H11V17H9V9ZM13 9H15V17H13V9Z"
  }));
},
    H6 = function H6(_ref551) {
  var _ref551$color = _ref551.color,
      C = _ref551$color === void 0 ? "currentColor" : _ref551$color,
      _ref551$size = _ref551.size,
      e = _ref551$size === void 0 ? 24 : _ref551$size,
      l = _ref551.className,
      i = _objectWithoutProperties(_ref551, _excluded551);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7 6V3C7 2.44772 7.44772 2 8 2H16C16.5523 2 17 2.44772 17 3V6H22V8H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V8H2V6H7ZM9 4V6H15V4H9Z"
  }));
},
    V6 = function V6(_ref552) {
  var _ref552$color = _ref552.color,
      C = _ref552$color === void 0 ? "currentColor" : _ref552$color,
      _ref552$size = _ref552.size,
      e = _ref552$size === void 0 ? 24 : _ref552$size,
      l = _ref552.className,
      i = _objectWithoutProperties(_ref552, _excluded552);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17 6H22V8H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V8H2V6H7V3C7 2.44772 7.44772 2 8 2H16C16.5523 2 17 2.44772 17 3V6ZM18 8H6V20H18V8ZM9 4V6H15V4H9Z"
  }));
},
    g6 = function g6(_ref553) {
  var _ref553$color = _ref553.color,
      C = _ref553$color === void 0 ? "currentColor" : _ref553$color,
      _ref553$size = _ref553.size,
      e = _ref553$size === void 0 ? 24 : _ref553$size,
      l = _ref553.className,
      i = _objectWithoutProperties(_ref553, _excluded553);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17 6H22V8H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V8H2V6H7V3C7 2.44772 7.44772 2 8 2H16C16.5523 2 17 2.44772 17 3V6ZM9 11V17H11V11H9ZM13 11V17H15V11H13ZM9 4V6H15V4H9Z"
  }));
},
    M6 = function M6(_ref554) {
  var _ref554$color = _ref554.color,
      C = _ref554$color === void 0 ? "currentColor" : _ref554$color,
      _ref554$size = _ref554.size,
      e = _ref554$size === void 0 ? 24 : _ref554$size,
      l = _ref554.className,
      i = _objectWithoutProperties(_ref554, _excluded554);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17 6H22V8H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V8H2V6H7V3C7 2.44772 7.44772 2 8 2H16C16.5523 2 17 2.44772 17 3V6ZM18 8H6V20H18V8ZM9 11H11V17H9V11ZM13 11H15V17H13V11ZM9 4V6H15V4H9Z"
  }));
},
    Z6 = function Z6(_ref555) {
  var _ref555$color = _ref555.color,
      C = _ref555$color === void 0 ? "currentColor" : _ref555$color,
      _ref555$size = _ref555.size,
      e = _ref555$size === void 0 ? 24 : _ref555$size,
      l = _ref555.className,
      i = _objectWithoutProperties(_ref555, _excluded555);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 3C12.5523 3 13 3.44772 13 4L12.9998 11.9998C13.8355 11.372 14.8743 11 16 11C18.7614 11 21 13.2386 21 16C21 18.7614 18.7614 21 16 21C14.9681 21 14.0092 20.6874 13.2129 20.1518L13 20C13 20.5523 12.5523 21 12 21H6C5.44772 21 5 20.5523 5 20V4C5 3.44772 5.44772 3 6 3H12ZM11 5H7V19H11V5ZM19 15H13V17H19V15Z"
  }));
},
    x6 = function x6(_ref556) {
  var _ref556$color = _ref556.color,
      C = _ref556$color === void 0 ? "currentColor" : _ref556$color,
      _ref556$size = _ref556.size,
      e = _ref556$size === void 0 ? 24 : _ref556$size,
      l = _ref556.className,
      i = _objectWithoutProperties(_ref556, _excluded556);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 5C20.5523 5 21 5.44772 21 6V12C21 12.5523 20.5523 13 20 13C20.628 13.8355 21 14.8743 21 16C21 18.7614 18.7614 21 16 21C13.2386 21 11 18.7614 11 16C11 14.8743 11.372 13.8355 11.9998 12.9998L4 13C3.44772 13 3 12.5523 3 12V6C3 5.44772 3.44772 5 4 5H20ZM13 15V17H19V15H13ZM19 7H5V11H19V7Z"
  }));
},
    v6 = function v6(_ref557) {
  var _ref557$color = _ref557.color,
      C = _ref557$color === void 0 ? "currentColor" : _ref557$color,
      _ref557$size = _ref557.size,
      e = _ref557$size === void 0 ? 24 : _ref557$size,
      l = _ref557.className,
      i = _objectWithoutProperties(_ref557, _excluded557);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19 6H11C10.4477 6 10 6.44772 10 7V20H4C3.44772 20 3 19.5523 3 19V3C3 2.44772 3.44772 2 4 2H18C18.5523 2 19 2.44772 19 3V6ZM13 8H21C21.5523 8 22 8.44772 22 9V21C22 21.5523 21.5523 22 21 22H13C12.4477 22 12 21.5523 12 21V9C12 8.44772 12.4477 8 13 8Z"
  }));
},
    d6 = function d6(_ref558) {
  var _ref558$color = _ref558.color,
      C = _ref558$color === void 0 ? "currentColor" : _ref558$color,
      _ref558$size = _ref558.size,
      e = _ref558$size === void 0 ? 24 : _ref558$size,
      l = _ref558.className,
      i = _objectWithoutProperties(_ref558, _excluded558);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19 8H21C21.5523 8 22 8.44772 22 9V21C22 21.5523 21.5523 22 21 22H13C12.4477 22 12 21.5523 12 21V20H4C3.44772 20 3 19.5523 3 19V3C3 2.44772 3.44772 2 4 2H18C18.5523 2 19 2.44772 19 3V8ZM17 8V4H5V18H12V9C12 8.44772 12.4477 8 13 8H17ZM14 10V20H20V10H14Z"
  }));
},
    p6 = function p6(_ref559) {
  var _ref559$color = _ref559.color,
      C = _ref559$color === void 0 ? "currentColor" : _ref559$color,
      _ref559$size = _ref559.size,
      e = _ref559$size === void 0 ? 24 : _ref559$size,
      l = _ref559.className,
      i = _objectWithoutProperties(_ref559, _excluded559);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19 2C19.5523 2 20 2.44772 20 3V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V3C4 2.44772 4.44772 2 5 2H19ZM12 7C9.23858 7 7 9.23858 7 12C7 14.7614 9.23858 17 12 17C12.33 17 12.65 16.97 12.9552 16.9089L12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.5977 9 15 10.3393 15 12H12.5L14.6282 16.2544C16.0517 15.3731 17 13.7973 17 12C17 9.23858 14.7614 7 12 7Z"
  }));
},
    E6 = function E6(_ref560) {
  var _ref560$color = _ref560.color,
      C = _ref560$color === void 0 ? "currentColor" : _ref560$color,
      _ref560$size = _ref560.size,
      e = _ref560$size === void 0 ? 24 : _ref560$size,
      l = _ref560.className,
      i = _objectWithoutProperties(_ref560, _excluded560);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19 2C19.5523 2 20 2.44772 20 3V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V3C4 2.44772 4.44772 2 5 2H19ZM18 4H6V20H18V4ZM12 7C14.7614 7 17 9.23858 17 12C17 13.7973 16.0517 15.3731 14.6282 16.2544L12.5 12H15C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15L12.9552 16.9089C12.646 16.9687 12.3267 17 12 17C9.23858 17 7 14.7614 7 12C7 9.23858 9.23858 7 12 7Z"
  }));
},
    N6 = function N6(_ref561) {
  var _ref561$color = _ref561.color,
      C = _ref561$color === void 0 ? "currentColor" : _ref561$color,
      _ref561$size = _ref561.size,
      e = _ref561$size === void 0 ? 24 : _ref561$size,
      l = _ref561.className,
      i = _objectWithoutProperties(_ref561, _excluded561);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C6.47717 2 2 6.47715 2 12C2 17.5229 6.47717 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47717 17.5229 2 12 2ZM16.4904 11.0399L16.4838 11.0543C16.0641 11.9522 14.9684 13.7132 14.9684 13.7132C14.9684 13.7132 14.9669 13.7091 14.9627 13.7022L14.6424 14.2596H16.1856L13.2383 18.1788L13.9074 15.5127H12.6931L13.115 13.7496C12.7736 13.832 12.3703 13.9451 11.8923 14.0988C11.8923 14.0988 11.2459 14.4774 10.0302 13.3705C10.0302 13.3705 9.21029 12.6482 9.68568 12.4676C9.88788 12.3909 10.6672 12.2935 11.2805 12.2106C12.1092 12.0985 12.619 12.0392 12.619 12.0392C12.619 12.0392 10.0641 12.0775 9.45797 11.9821C8.85178 11.8868 8.08285 10.8753 7.91909 9.98621C7.91909 9.98621 7.66575 9.49805 8.46378 9.72912C9.26178 9.96021 12.5653 10.6286 12.5653 10.6286C12.5653 10.6286 8.26903 9.31176 7.98319 8.99048C7.69727 8.66918 7.14179 7.23638 7.21412 6.35602C7.21412 6.35602 7.24548 6.13656 7.47054 6.19532C7.47054 6.19532 10.6467 7.64667 12.8184 8.44116C14.9902 9.23567 16.8784 9.63987 16.6345 10.6686C16.6136 10.7563 16.5624 10.8848 16.4904 11.0399Z"
  }));
},
    u6 = function u6(_ref562) {
  var _ref562$color = _ref562.color,
      C = _ref562$color === void 0 ? "currentColor" : _ref562$color,
      _ref562$size = _ref562.size,
      e = _ref562$size === void 0 ? 24 : _ref562$size,
      l = _ref562.className,
      i = _objectWithoutProperties(_ref562, _excluded562);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 4C7.58173 4 4 7.58172 4 12C4 16.4183 7.58173 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58173 16.4183 4 12 4ZM12 2C17.5229 2 22 6.47717 22 12C22 17.5228 17.5228 22 12 22C6.47717 22 2 17.5229 2 12C2 6.47715 6.47717 2 12 2ZM16.4904 11.0399L16.4838 11.0543C16.0641 11.9522 14.9684 13.7132 14.9684 13.7132C14.9684 13.7132 14.9669 13.7091 14.9627 13.7022L14.6424 14.2596H16.1856L13.2383 18.1788L13.9074 15.5127H12.6931L13.115 13.7496C12.7736 13.832 12.3703 13.9451 11.8923 14.0988C11.8923 14.0988 11.2459 14.4774 10.0302 13.3705C10.0302 13.3705 9.21029 12.6482 9.68568 12.4676C9.88788 12.3909 10.6672 12.2935 11.2805 12.2106C12.1092 12.0985 12.619 12.0392 12.619 12.0392C12.619 12.0392 10.0641 12.0775 9.45797 11.9821C8.85178 11.8868 8.08285 10.8753 7.91909 9.98621C7.91909 9.98621 7.66575 9.49805 8.46378 9.72912C9.26178 9.96021 12.5653 10.6286 12.5653 10.6286C12.5653 10.6286 8.26903 9.31176 7.98319 8.99048C7.69727 8.66918 7.14179 7.23638 7.21412 6.35602C7.21412 6.35602 7.24548 6.13656 7.47054 6.19532C7.47054 6.19532 10.6467 7.64667 12.8184 8.44116C14.9902 9.23567 16.8784 9.63987 16.6345 10.6686C16.6136 10.7563 16.5624 10.8848 16.4904 11.0399Z"
  }));
},
    B6 = function B6(_ref563) {
  var _ref563$color = _ref563.color,
      C = _ref563$color === void 0 ? "currentColor" : _ref563$color,
      _ref563$size = _ref563.size,
      e = _ref563$size === void 0 ? 24 : _ref563$size,
      l = _ref563.className,
      i = _objectWithoutProperties(_ref563, _excluded563);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9.00008 10.0001C8.4478 10.0001 8.00008 10.4478 8.00008 11.0001V15.0001H10.0001V12.0001H13.0001V14.5001L16.5001 11.0001L13.0001 7.50008V10.0001H9.00008ZM12.7072 1.39348L22.6067 11.293C22.9972 11.6835 22.9972 12.3167 22.6067 12.7072L12.7072 22.6067C12.3167 22.9972 11.6835 22.9972 11.293 22.6067L1.39348 12.7072C1.00295 12.3167 1.00295 11.6835 1.39348 11.293L11.293 1.39348C11.6835 1.00295 12.3167 1.00295 12.7072 1.39348Z"
  }));
},
    f6 = function f6(_ref564) {
  var _ref564$color = _ref564.color,
      C = _ref564$color === void 0 ? "currentColor" : _ref564$color,
      _ref564$size = _ref564.size,
      e = _ref564$size === void 0 ? 24 : _ref564$size,
      l = _ref564.className,
      i = _objectWithoutProperties(_ref564, _excluded564);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.0001 3.5148L3.5148 12.0001L12.0001 20.4854L20.4854 12.0001L12.0001 3.5148ZM12.7072 1.39348L22.6067 11.293C22.9972 11.6835 22.9972 12.3167 22.6067 12.7072L12.7072 22.6067C12.3167 22.9972 11.6835 22.9972 11.293 22.6067L1.39348 12.7072C1.00295 12.3167 1.00295 11.6835 1.39348 11.293L11.293 1.39348C11.6835 1.00295 12.3167 1.00295 12.7072 1.39348ZM13.0001 10.0001V7.50008L16.5001 11.0001L13.0001 14.5001V12.0001H10.0001V15.0001H8.00008V11.0001C8.00008 10.4478 8.4478 10.0001 9.00008 10.0001H13.0001Z"
  }));
},
    R6 = function R6(_ref565) {
  var _ref565$color = _ref565.color,
      C = _ref565$color === void 0 ? "currentColor" : _ref565$color,
      _ref565$size = _ref565.size,
      e = _ref565$size === void 0 ? 24 : _ref565$size,
      l = _ref565.className,
      i = _objectWithoutProperties(_ref565, _excluded565);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13 9.17071C12.6872 9.06015 12.3506 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12V2.4578C19.0571 3.73207 22 7.52236 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C12.3375 2 12.6711 2.01672 13 2.04938V9.17071Z"
  }));
},
    z6 = function z6(_ref566) {
  var _ref566$color = _ref566.color,
      C = _ref566$color === void 0 ? "currentColor" : _ref566$color,
      _ref566$size = _ref566.size,
      e = _ref566$size === void 0 ? 24 : _ref566$size,
      l = _ref566.className,
      i = _objectWithoutProperties(_ref566, _excluded566);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15 4.58152V12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C12.3506 9 12.6872 9.06016 13 9.17071V2.04938C18.0533 2.5511 22 6.81465 22 12C22 17.5229 17.5228 22 12 22C6.47715 22 2 17.5229 2 12C2 6.81465 5.94668 2.5511 11 2.04938V4.0619C7.05369 4.55399 4 7.92038 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 8.64262 17.9318 5.76829 15 4.58152Z"
  }));
},
    F6 = function F6(_ref567) {
  var _ref567$color = _ref567.color,
      C = _ref567$color === void 0 ? "currentColor" : _ref567$color,
      _ref567$size = _ref567.size,
      e = _ref567$size === void 0 ? 24 : _ref567$size,
      l = _ref567.className,
      i = _objectWithoutProperties(_ref567, _excluded567);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19.3034 5.33716C17.9344 4.71103 16.4805 4.2547 14.9629 4C14.7719 4.32899 14.5596 4.77471 14.411 5.12492C12.7969 4.89144 11.1944 4.89144 9.60255 5.12492C9.45397 4.77471 9.2311 4.32899 9.05068 4C7.52251 4.2547 6.06861 4.71103 4.70915 5.33716C1.96053 9.39111 1.21766 13.3495 1.5891 17.2549C3.41443 18.5815 5.17612 19.388 6.90701 19.9187C7.33151 19.3456 7.71356 18.73 8.04255 18.0827C7.41641 17.8492 6.82211 17.5627 6.24904 17.2231C6.39762 17.117 6.5462 17.0003 6.68416 16.8835C10.1438 18.4648 13.8911 18.4648 17.3082 16.8835C17.4568 17.0003 17.5948 17.117 17.7434 17.2231C17.1703 17.5627 16.576 17.8492 15.9499 18.0827C16.2789 18.73 16.6609 19.3456 17.0854 19.9187C18.8152 19.388 20.5875 18.5815 22.4033 17.2549C22.8596 12.7341 21.6806 8.80747 19.3034 5.33716ZM8.5201 14.8459C7.48007 14.8459 6.63107 13.9014 6.63107 12.7447C6.63107 11.5879 7.45884 10.6434 8.5201 10.6434C9.57071 10.6434 10.4303 11.5879 10.4091 12.7447C10.4091 13.9014 9.57071 14.8459 8.5201 14.8459ZM15.4936 14.8459C14.4535 14.8459 13.6034 13.9014 13.6034 12.7447C13.6034 11.5879 14.4323 10.6434 15.4936 10.6434C16.5442 10.6434 17.4038 11.5879 17.3825 12.7447C17.3825 13.9014 16.5548 14.8459 15.4936 14.8459Z"
  }));
},
    S6 = function S6(_ref568) {
  var _ref568$color = _ref568.color,
      C = _ref568$color === void 0 ? "currentColor" : _ref568$color,
      _ref568$size = _ref568.size,
      e = _ref568$size === void 0 ? 24 : _ref568$size,
      l = _ref568.className,
      i = _objectWithoutProperties(_ref568, _excluded568);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8.52062 13.8458C7.48059 13.8458 6.63159 12.9014 6.63159 11.7446 6.63159 10.5879 7.45936 9.64331 8.52062 9.64331 9.57123 9.64331 10.4308 10.5879 10.4096 11.7446 10.4096 12.9014 9.57123 13.8458 8.52062 13.8458ZM15.4941 13.8458C14.454 13.8458 13.604 12.9014 13.604 11.7446 13.604 10.5879 14.4328 9.64331 15.4941 9.64331 16.5447 9.64331 17.4043 10.5879 17.3831 11.7446 17.3831 12.9014 16.5553 13.8458 15.4941 13.8458ZM10.1253 4.32296 9.81655 3.76001 9.18323 3.86556C7.71915 4.10958 6.32658 4.54677 5.02544 5.14604L4.79651 5.25148 4.65507 5.46009C2.0418 9.31441 1.3258 13.1087 1.68032 16.8362L1.71897 17.2425 2.04912 17.4824C3.78851 18.7465 5.47417 19.5189 7.12727 20.0257L7.91657 20.2676 9.03013 17.5506C10.9397 18.0226 13.0592 18.0228 14.969 17.5511L16.0757 20.2683 16.8668 20.0256C18.5173 19.5193 20.2137 18.7472 21.9466 17.4811L22.2726 17.243 22.3131 16.8414C22.7491 12.5213 21.616 8.75773 19.3547 5.45652L19.2128 5.24944 18.9846 5.14504C17.6767 4.54685 16.2852 4.10981 14.8309 3.86573L14.2132 3.76207 13.8987 4.30369C13.8112 4.45445 13.7215 4.62464 13.6364 4.79687 12.5441 4.6847 11.456 4.68446 10.3726 4.79652 10.2882 4.62736 10.2025 4.4638 10.1253 4.32296ZM6.71436 16.6102C6.91235 16.7243 7.11973 16.8358 7.32557 16.9381L6.8764 18.034C5.75585 17.6259 4.61837 17.0637 3.4476 16.2557 3.22313 13.1178 3.86092 9.951 6.01196 6.68626 6.90962 6.29123 7.8535 5.98279 8.83606 5.77295 8.89631 5.89831 8.95235 6.02066 8.99839 6.12917L9.27128 6.77238 9.96259 6.67098C11.3152 6.4726 12.6772 6.47234 14.0523 6.67124L14.7424 6.77106 15.0147 6.12917C15.0621 6.01743 15.1167 5.89547 15.1743 5.77322 16.1525 5.98326 17.098 6.29212 18.0029 6.68812 19.8781 9.50857 20.8241 12.6544 20.5486 16.2552 19.3837 17.0625 18.2422 17.6249 17.1193 18.0335L16.6735 16.939C16.8799 16.8365 17.0879 16.7246 17.2865 16.6102 17.7763 16.328 18.3039 15.976 18.6402 15.6397L17.3606 14.3602C17.1969 14.5239 16.837 14.7808 16.3831 15.0423 15.9388 15.2983 15.498 15.5052 15.2164 15.5983 13.2126 16.2608 10.7883 16.2608 8.78443 15.5983 8.50285 15.5052 8.06205 15.2983 7.61772 15.0423 7.16383 14.7808 6.80392 14.5239 6.64017 14.3602L5.36065 15.6397C5.6969 15.976 6.2245 16.328 6.71436 16.6102Z"
  }));
},
    A6 = function A6(_ref569) {
  var _ref569$color = _ref569.color,
      C = _ref569$color === void 0 ? "currentColor" : _ref569$color,
      _ref569$size = _ref569.size,
      e = _ref569$size === void 0 ? 24 : _ref569$size,
      l = _ref569.className,
      i = _objectWithoutProperties(_ref569, _excluded569);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16.8 19L14 22.5L11.2 19H6C5.44772 19 5 18.5523 5 18V7.10256C5 6.55028 5.44772 6.10256 6 6.10256H22C22.5523 6.10256 23 6.55028 23 7.10256V18C23 18.5523 22.5523 19 22 19H16.8ZM2 2H19V4H3V15H1V3C1 2.44772 1.44772 2 2 2Z"
  }));
},
    k6 = function k6(_ref570) {
  var _ref570$color = _ref570.color,
      C = _ref570$color === void 0 ? "currentColor" : _ref570$color,
      _ref570$size = _ref570.size,
      e = _ref570$size === void 0 ? 24 : _ref570$size,
      l = _ref570.className,
      i = _objectWithoutProperties(_ref570, _excluded570);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14 22.5L11.2 19H6C5.44772 19 5 18.5523 5 18V7.10256C5 6.55028 5.44772 6.10256 6 6.10256H22C22.5523 6.10256 23 6.55028 23 7.10256V18C23 18.5523 22.5523 19 22 19H16.8L14 22.5ZM15.8387 17H21V8.10256H7V17H11.2H12.1613L14 19.2984L15.8387 17ZM2 2H19V4H3V15H1V3C1 2.44772 1.44772 2 2 2Z"
  }));
},
    P6 = function P6(_ref571) {
  var _ref571$color = _ref571.color,
      C = _ref571$color === void 0 ? "currentColor" : _ref571$color,
      _ref571$size = _ref571.size,
      e = _ref571$size === void 0 ? 24 : _ref571$size,
      l = _ref571.className,
      i = _objectWithoutProperties(_ref571, _excluded571);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2.80777 1.3934L21.1925 19.7782L19.7783 21.1924L16.0316 17.4454L12 21.485L3.52154 12.993C1.48186 10.7094 1.49309 7.24014 3.55524 4.96959L1.39355 2.80762L2.80777 1.3934ZM20.2428 4.75736C22.5054 7.02472 22.5831 10.637 20.4788 12.993L18.8442 14.629L7.2604 3.04551C8.92926 2.83935 10.6682 3.33369 12.0011 4.52853C14.3502 2.42 17.9802 2.49 20.2428 4.75736Z"
  }));
},
    D6 = function D6(_ref572) {
  var _ref572$color = _ref572.color,
      C = _ref572$color === void 0 ? "currentColor" : _ref572$color,
      _ref572$size = _ref572.size,
      e = _ref572$size === void 0 ? 24 : _ref572$size,
      l = _ref572.className,
      i = _objectWithoutProperties(_ref572, _excluded572);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2.80777 1.3934L21.1925 19.7782L19.7783 21.1924L16.0316 17.4454L12 21.485L3.52154 12.993C1.48186 10.7094 1.49309 7.24014 3.55524 4.96959L1.39355 2.80762L2.80777 1.3934ZM4.98009 11.6232L12 18.6543L14.6176 16.0314L4.97206 6.38623C3.67816 7.88265 3.67138 10.121 4.98009 11.6232ZM20.2428 4.75736C22.5054 7.02472 22.5831 10.637 20.4788 12.993L18.8442 14.629L17.4302 13.215L19.0202 11.6232C20.3937 10.0467 20.3191 7.66525 18.8271 6.1701C17.3281 4.66794 14.9078 4.60702 13.3371 6.01688L12.0021 7.21524L10.6662 6.01781C10.3163 5.70415 9.92487 5.46325 9.51117 5.29473L7.2604 3.04551C8.92926 2.83935 10.6682 3.33369 12.0011 4.52853C14.3502 2.42 17.9802 2.49 20.2428 4.75736Z"
  }));
},
    y6 = function y6(_ref573) {
  var _ref573$color = _ref573.color,
      C = _ref573$color === void 0 ? "currentColor" : _ref573$color,
      _ref573$size = _ref573.size,
      e = _ref573$size === void 0 ? 24 : _ref573$size,
      l = _ref573.className,
      i = _objectWithoutProperties(_ref573, _excluded573);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C9.47017 22 7.15975 21.0606 5.39856 19.5116L1.5 20L2.92355 16.2031C2.33082 14.9253 2 13.5013 2 12C2 6.47715 6.47715 2 12 2ZM8 7.0003V17.0003H11.7335L11.9959 16.9963C15.3714 16.8928 17.3333 14.7848 17.3333 11.9714V11.9436L17.3295 11.7287C17.2307 8.95633 15.2107 7.0003 11.7896 7.0003H8ZM11.8314 9.45793C13.4594 9.45793 14.54 10.3861 14.54 11.9868V12.0147L14.5352 12.1978C14.4561 13.6979 13.3968 14.5434 11.8314 14.5434H10.723V9.45793H11.8314Z"
  }));
},
    b6 = function b6(_ref574) {
  var _ref574$color = _ref574.color,
      C = _ref574$color === void 0 ? "currentColor" : _ref574$color,
      _ref574$size = _ref574.size,
      e = _ref574$size === void 0 ? 24 : _ref574$size,
      l = _ref574.className,
      i = _objectWithoutProperties(_ref574, _excluded574);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11.9971 2C17.52 2 21.9971 6.47715 21.9971 12C21.9971 17.5228 17.52 22 11.9971 22C9.69135 22 7.50495 21.2156 5.74846 19.8078L1.03027 20.3973L2.74948 15.8116C2.2553 14.614 1.99712 13.3245 1.99712 12C1.99712 6.47715 6.47427 2 11.9971 2ZM11.9971 4C7.57884 4 3.99712 7.58172 3.99712 12C3.99712 13.178 4.25126 14.3181 4.73544 15.3619L4.91161 15.7418L4.06396 18.0027L6.37947 17.7134L6.71733 18.0105C8.16756 19.2855 10.0256 20 11.9971 20C16.4154 20 19.9971 16.4183 19.9971 12C19.9971 7.58172 16.4154 4 11.9971 4ZM8.04712 7.0003H11.8367C15.2578 7.0003 17.2778 8.95633 17.3766 11.7287L17.3805 11.9436V11.9714C17.3805 14.7848 15.4185 16.8928 12.043 16.9963L11.7806 17.0003H8.04712V7.0003H11.8367H8.04712ZM11.8785 9.45793H10.7701V14.5434H11.8785C13.4439 14.5434 14.5032 13.6979 14.5824 12.1978L14.5871 12.0147V11.9868C14.5871 10.3861 13.5065 9.45793 11.8785 9.45793Z"
  }));
},
    T6 = function T6(_ref575) {
  var _ref575$color = _ref575.color,
      C = _ref575$color === void 0 ? "currentColor" : _ref575$color,
      _ref575$size = _ref575.size,
      e = _ref575$size === void 0 ? 24 : _ref575$size,
      l = _ref575.className,
      i = _objectWithoutProperties(_ref575, _excluded575);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5 11H19V13H5V11ZM12 8C11.1716 8 10.5 7.32843 10.5 6.5C10.5 5.67157 11.1716 5 12 5C12.8284 5 13.5 5.67157 13.5 6.5C13.5 7.32843 12.8284 8 12 8ZM12 19C11.1716 19 10.5 18.3284 10.5 17.5C10.5 16.6716 11.1716 16 12 16C12.8284 16 13.5 16.6716 13.5 17.5C13.5 18.3284 12.8284 19 12 19Z"
  }));
},
    U6 = function U6(_ref576) {
  var _ref576$color = _ref576.color,
      C = _ref576$color === void 0 ? "currentColor" : _ref576$color,
      _ref576$size = _ref576.size,
      e = _ref576$size === void 0 ? 24 : _ref576$size,
      l = _ref576.className,
      i = _objectWithoutProperties(_ref576, _excluded576);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5 11H19V13H5V11ZM12 8C11.1716 8 10.5 7.32843 10.5 6.5C10.5 5.67157 11.1716 5 12 5C12.8284 5 13.5 5.67157 13.5 6.5C13.5 7.32843 12.8284 8 12 8ZM12 19C11.1716 19 10.5 18.3284 10.5 17.5C10.5 16.6716 11.1716 16 12 16C12.8284 16 13.5 16.6716 13.5 17.5C13.5 18.3284 12.8284 19 12 19Z"
  }));
},
    G6 = function G6(_ref577) {
  var _ref577$color = _ref577.color,
      C = _ref577$color === void 0 ? "currentColor" : _ref577$color,
      _ref577$size = _ref577.size,
      e = _ref577$size === void 0 ? 24 : _ref577$size,
      l = _ref577.className,
      i = _objectWithoutProperties(_ref577, _excluded577);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10.9999 2.04938L11 5.07088C7.6077 5.55612 5 8.47352 5 12C5 15.866 8.13401 19 12 19C13.5723 19 15.0236 18.4816 16.1922 17.6064L18.3289 19.7428C16.605 21.1536 14.4014 22 12 22C6.47715 22 2 17.5228 2 12C2 6.81468 5.94662 2.55115 10.9999 2.04938ZM21.9506 13.0001C21.7509 15.0111 20.9555 16.8468 19.7433 18.3283L17.6064 16.1922C18.2926 15.2759 18.7595 14.1859 18.9291 13L21.9506 13.0001ZM13.0011 2.04948C17.725 2.51902 21.4815 6.27589 21.9506 10.9999L18.9291 10.9998C18.4905 7.93452 16.0661 5.50992 13.001 5.07103L13.0011 2.04948Z"
  }));
},
    I6 = function I6(_ref578) {
  var _ref578$color = _ref578.color,
      C = _ref578$color === void 0 ? "currentColor" : _ref578$color,
      _ref578$size = _ref578.size,
      e = _ref578$size === void 0 ? 24 : _ref578$size,
      l = _ref578.className,
      i = _objectWithoutProperties(_ref578, _excluded578);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10.9999 2.04938L11 4.06188C7.05371 4.55396 4 7.92036 4 12C4 16.4183 7.58172 20 12 20C13.8487 20 15.5509 19.3729 16.9055 18.3199L18.3289 19.7428C16.605 21.1536 14.4014 22 12 22C6.47715 22 2 17.5228 2 12C2 6.81468 5.94662 2.55115 10.9999 2.04938ZM21.9506 13.0001C21.7509 15.0111 20.9555 16.8468 19.7433 18.3283L18.3199 16.9055C19.1801 15.799 19.756 14.4606 19.9381 12.9999L21.9506 13.0001ZM13.0011 2.04948C17.725 2.51902 21.4815 6.27589 21.9506 10.9999L19.9381 11C19.4869 7.38162 16.6192 4.51364 13.001 4.062L13.0011 2.04948Z"
  }));
},
    W6 = function W6(_ref579) {
  var _ref579$color = _ref579.color,
      C = _ref579$color === void 0 ? "currentColor" : _ref579$color,
      _ref579$size = _ref579.size,
      e = _ref579$size === void 0 ? 24 : _ref579$size,
      l = _ref579.className,
      i = _objectWithoutProperties(_ref579, _excluded579);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2.99805 21V19H4.99805V4C4.99805 3.44772 5.44576 3 5.99805 3H17.998C18.5503 3 18.998 3.44772 18.998 4V19H20.998V21H2.99805ZM14.998 11H12.998V13H14.998V11Z"
  }));
},
    O6 = function O6(_ref580) {
  var _ref580$color = _ref580.color,
      C = _ref580$color === void 0 ? "currentColor" : _ref580$color,
      _ref580$size = _ref580.size,
      e = _ref580$size === void 0 ? 24 : _ref580$size,
      l = _ref580.className,
      i = _objectWithoutProperties(_ref580, _excluded580);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2.99805 21V19H4.99805V4C4.99805 3.44772 5.44576 3 5.99805 3H17.998C18.5503 3 18.998 3.44772 18.998 4V19H20.998V21H2.99805ZM16.998 5H6.99805V19H16.998V5ZM14.998 11V13H12.998V11H14.998Z"
  }));
},
    K6 = function K6(_ref581) {
  var _ref581$color = _ref581.color,
      C = _ref581$color === void 0 ? "currentColor" : _ref581$color,
      _ref581$size = _ref581.size,
      e = _ref581$size === void 0 ? 24 : _ref581$size,
      l = _ref581.className,
      i = _objectWithoutProperties(_ref581, _excluded581);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17.998 3C18.5503 3 18.998 3.44772 18.998 4V20C18.998 20.5523 18.5503 21 17.998 21H5.99805C5.44576 21 4.99805 20.5523 4.99805 20V4C4.99805 3.44772 5.44576 3 5.99805 3H17.998ZM13.998 11C13.4458 11 12.998 11.4477 12.998 12C12.998 12.5523 13.4458 13 13.998 13C14.5503 13 14.998 12.5523 14.998 12C14.998 11.4477 14.5503 11 13.998 11Z"
  }));
},
    Q6 = function Q6(_ref582) {
  var _ref582$color = _ref582.color,
      C = _ref582$color === void 0 ? "currentColor" : _ref582$color,
      _ref582$size = _ref582.size,
      e = _ref582$size === void 0 ? 24 : _ref582$size,
      l = _ref582.className,
      i = _objectWithoutProperties(_ref582, _excluded582);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17.998 3C18.5503 3 18.998 3.44772 18.998 4V20C18.998 20.5523 18.5503 21 17.998 21H5.99805C5.44576 21 4.99805 20.5523 4.99805 20V4C4.99805 3.44772 5.44576 3 5.99805 3H17.998ZM16.998 5H6.99805V19H16.998V5ZM14.998 11V13H12.998V11H14.998Z"
  }));
},
    q6 = function q6(_ref583) {
  var _ref583$color = _ref583.color,
      C = _ref583$color === void 0 ? "currentColor" : _ref583$color,
      _ref583$size = _ref583.size,
      e = _ref583$size === void 0 ? 24 : _ref583$size,
      l = _ref583.className,
      i = _objectWithoutProperties(_ref583, _excluded583);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM11 12.792V16H13V12.792C13.883 12.4062 14.5 11.5252 14.5 10.5C14.5 9.11929 13.3807 8 12 8C10.6193 8 9.5 9.11929 9.5 10.5C9.5 11.5252 10.117 12.4062 11 12.792Z"
  }));
},
    j6 = function j6(_ref584) {
  var _ref584$color = _ref584.color,
      C = _ref584$color === void 0 ? "currentColor" : _ref584$color,
      _ref584$size = _ref584.size,
      e = _ref584$size === void 0 ? 24 : _ref584$size,
      l = _ref584.className,
      i = _objectWithoutProperties(_ref584, _excluded584);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM5 5V19H19V5H5ZM11 12.792C10.117 12.4062 9.5 11.5252 9.5 10.5C9.5 9.11929 10.6193 8 12 8C13.3807 8 14.5 9.11929 14.5 10.5C14.5 11.5252 13.883 12.4062 13 12.792V16H11V12.792Z"
  }));
},
    X6 = function X6(_ref585) {
  var _ref585$color = _ref585.color,
      C = _ref585$color === void 0 ? "currentColor" : _ref585$color,
      _ref585$size = _ref585.size,
      e = _ref585$size === void 0 ? 24 : _ref585$size,
      l = _ref585.className,
      i = _objectWithoutProperties(_ref585, _excluded585);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM11 12.792V16H13V12.792C13.883 12.4062 14.5 11.5252 14.5 10.5C14.5 9.11929 13.3807 8 12 8C10.6193 8 9.5 9.11929 9.5 10.5C9.5 11.5252 10.117 12.4062 11 12.792Z"
  }));
},
    J6 = function J6(_ref586) {
  var _ref586$color = _ref586.color,
      C = _ref586$color === void 0 ? "currentColor" : _ref586$color,
      _ref586$size = _ref586.size,
      e = _ref586$size === void 0 ? 24 : _ref586$size,
      l = _ref586.className,
      i = _objectWithoutProperties(_ref586, _excluded586);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM11 12.792C10.117 12.4062 9.5 11.5252 9.5 10.5C9.5 9.11929 10.6193 8 12 8C13.3807 8 14.5 9.11929 14.5 10.5C14.5 11.5252 13.883 12.4062 13 12.792V16H11V12.792Z"
  }));
},
    Y6 = function Y6(_ref587) {
  var _ref587$color = _ref587.color,
      C = _ref587$color === void 0 ? "currentColor" : _ref587$color,
      _ref587$size = _ref587.size,
      e = _ref587$size === void 0 ? 24 : _ref587$size,
      l = _ref587.className,
      i = _objectWithoutProperties(_ref587, _excluded587);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M1.99805 21.0001V19.0001L3.99805 18.9999V4.83465C3.99805 4.35136 4.34367 3.93723 4.81916 3.85078L14.2907 2.12868C14.6167 2.0694 14.9291 2.28564 14.9884 2.61167C14.9948 2.64708 14.998 2.68301 14.998 2.719V3.9999L18.998 4.00007C19.5503 4.00007 19.998 4.44779 19.998 5.00007V18.9999L21.998 19.0001V21.0001H17.998V6.00007L14.998 5.9999V21.0001H1.99805ZM11.998 11.0001H9.99805V13.0001H11.998V11.0001Z"
  }));
},
    _6 = function _6(_ref588) {
  var _ref588$color = _ref588.color,
      C = _ref588$color === void 0 ? "currentColor" : _ref588$color,
      _ref588$size = _ref588.size,
      e = _ref588$size === void 0 ? 24 : _ref588$size,
      l = _ref588.className,
      i = _objectWithoutProperties(_ref588, _excluded588);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M1.99805 21.0001V19.0001L3.99805 18.9999V4.83465C3.99805 4.35136 4.34367 3.93723 4.81916 3.85078L14.2907 2.12868C14.6167 2.0694 14.9291 2.28564 14.9884 2.61167C14.9948 2.64708 14.998 2.68301 14.998 2.719V3.9999L18.998 4.00007C19.5503 4.00007 19.998 4.44779 19.998 5.00007V18.9999L21.998 19.0001V21.0001H17.998V6.00007L14.998 5.9999V21.0001H1.99805ZM12.998 4.3965L5.99805 5.66923V19.0001H12.998V4.3965ZM11.998 11.0001V13.0001H9.99805V11.0001H11.998Z"
  }));
},
    $6 = function $6(_ref589) {
  var _ref589$color = _ref589.color,
      C = _ref589$color === void 0 ? "currentColor" : _ref589$color,
      _ref589$size = _ref589.size,
      e = _ref589$size === void 0 ? 24 : _ref589$size,
      l = _ref589.className,
      i = _objectWithoutProperties(_ref589, _excluded589);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17 2V4H20C20.5523 4 21 4.44772 21 5V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V5C3 4.44772 3.44772 4 4 4H7V2H17ZM13 11H11V13H9V15H10.999L11 17H13L12.999 15H15V13H13V11ZM15 4H9V6H15V4Z"
  }));
},
    ee = function ee(_ref590) {
  var _ref590$color = _ref590.color,
      C = _ref590$color === void 0 ? "currentColor" : _ref590$color,
      _ref590$size = _ref590.size,
      e = _ref590$size === void 0 ? 24 : _ref590$size,
      l = _ref590.className,
      i = _objectWithoutProperties(_ref590, _excluded590);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17 2V4H20C20.5523 4 21 4.44772 21 5V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V5C3 4.44772 3.44772 4 4 4H7V2H17ZM7 6H5V20H19V6H17V8H7V6ZM13 11V13H15V15H12.999L13 17H11L10.999 15H9V13H11V11H13ZM15 4H9V6H15V4Z"
  }));
},
    te = function te(_ref591) {
  var _ref591$color = _ref591.color,
      C = _ref591$color === void 0 ? "currentColor" : _ref591$color,
      _ref591$size = _ref591.size,
      e = _ref591$size === void 0 ? 24 : _ref591$size,
      l = _ref591.className,
      i = _objectWithoutProperties(_ref591, _excluded591);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16.3143 19.1379H20.3793C20.7221 19.1379 21 19.4158 21 19.7586V20.3793C21 20.7221 20.7221 21 20.3793 21H3.62069C3.27789 21 3 20.7221 3 20.3793V19.7586C3 19.4158 3.27789 19.1379 3.62069 19.1379H7.37438L6.41379 16.0345H8.60436C8.87152 16.0345 9.10871 16.2054 9.19319 16.4589L10.0862 19.1379H13.5988L14.8236 15.1034H5.17241C4.82962 15.1034 4.55172 14.8256 4.55172 14.4828V7.34483C4.55172 7.00203 4.82962 6.72414 5.17241 6.72414H18.8276C19.1704 6.72414 19.4483 7.00203 19.4483 7.34483V14.4828C19.4483 14.8256 19.1704 15.1034 18.8276 15.1034H17.5391L16.3143 19.1379ZM3.93103 3H20.069C20.4118 3 20.6897 3.27789 20.6897 3.62069V4.24138C20.6897 4.58418 20.4118 4.86207 20.069 4.86207H3.93103C3.58824 4.86207 3.31034 4.58418 3.31034 4.24138V3.62069C3.31034 3.27789 3.58824 3 3.93103 3ZM7.18966 8.58621C7.10396 8.58621 7.03448 8.65568 7.03448 8.74138V12.7759C7.03448 12.8616 7.10396 12.931 7.18966 12.931H16.8103C16.896 12.931 16.9655 12.8616 16.9655 12.7759V8.74138C16.9655 8.65568 16.896 8.58621 16.8103 8.58621H7.18966Z"
  }));
},
    Ce = function Ce(_ref592) {
  var _ref592$color = _ref592.color,
      C = _ref592$color === void 0 ? "currentColor" : _ref592$color,
      _ref592$size = _ref592.size,
      e = _ref592$size === void 0 ? 24 : _ref592$size,
      l = _ref592.className,
      i = _objectWithoutProperties(_ref592, _excluded592);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15.2735 15H5V7H19V15H17.3764L16.0767 19H21V21H3V19H7.6123L6.8 16.5L8.70211 15.882L9.71522 19H13.9738L15.2735 15ZM3.5 3H20.5V5H3.5V3ZM7 9V13H17V9H7Z"
  }));
},
    le = function le(_ref593) {
  var _ref593$color = _ref593.color,
      C = _ref593$color === void 0 ? "currentColor" : _ref593$color,
      _ref593$size = _ref593.size,
      e = _ref593$size === void 0 ? 24 : _ref593$size,
      l = _ref593.className,
      i = _objectWithoutProperties(_ref593, _excluded593);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4.58341 17.3211C3.55316 16.2274 3 15 3 13.0103C3 9.51086 5.45651 6.37366 9.03059 4.82318L9.92328 6.20079C6.58804 8.00539 5.93618 10.346 5.67564 11.822C6.21263 11.5443 6.91558 11.4466 7.60471 11.5105C9.40908 11.6778 10.8312 13.159 10.8312 15C10.8312 16.933 9.26416 18.5 7.33116 18.5C6.2581 18.5 5.23196 18.0095 4.58341 17.3211ZM14.5834 17.3211C13.5532 16.2274 13 15 13 13.0103C13 9.51086 15.4565 6.37366 19.0306 4.82318L19.9233 6.20079C16.588 8.00539 15.9362 10.346 15.6756 11.822C16.2126 11.5443 16.9156 11.4466 17.6047 11.5105C19.4091 11.6778 20.8312 13.159 20.8312 15C20.8312 16.933 19.2642 18.5 17.3312 18.5C16.2581 18.5 15.232 18.0095 14.5834 17.3211Z"
  }));
},
    ie = function ie(_ref594) {
  var _ref594$color = _ref594.color,
      C = _ref594$color === void 0 ? "currentColor" : _ref594$color,
      _ref594$size = _ref594.size,
      e = _ref594$size === void 0 ? 24 : _ref594$size,
      l = _ref594.className,
      i = _objectWithoutProperties(_ref594, _excluded594);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19.4167 6.67891C20.4469 7.77257 21.0001 9 21.0001 10.9897C21.0001 14.4891 18.5436 17.6263 14.9695 19.1768L14.0768 17.7992C17.4121 15.9946 18.0639 13.6539 18.3245 12.178C17.7875 12.4557 17.0845 12.5533 16.3954 12.4895C14.591 12.3222 13.1689 10.8409 13.1689 9C13.1689 7.067 14.7359 5.5 16.6689 5.5C17.742 5.5 18.7681 5.99045 19.4167 6.67891ZM9.41669 6.67891C10.4469 7.77257 11.0001 9 11.0001 10.9897C11.0001 14.4891 8.54359 17.6263 4.96951 19.1768L4.07682 17.7992C7.41206 15.9946 8.06392 13.6539 8.32447 12.178C7.78747 12.4557 7.08452 12.5533 6.39539 12.4895C4.59102 12.3222 3.16895 10.8409 3.16895 9C3.16895 7.067 4.73595 5.5 6.66895 5.5C7.742 5.5 8.76814 5.99045 9.41669 6.67891Z"
  }));
},
    se = function se(_ref595) {
  var _ref595$color = _ref595.color,
      C = _ref595$color === void 0 ? "currentColor" : _ref595$color,
      _ref595$size = _ref595.size,
      e = _ref595$size === void 0 ? 24 : _ref595$size,
      l = _ref595.className,
      i = _objectWithoutProperties(_ref595, _excluded595);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 19H20V12H22V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V12H4V19ZM14 9H19L12 16L5 9H10V3H14V9Z"
  }));
},
    re = function re(_ref596) {
  var _ref596$color = _ref596.color,
      C = _ref596$color === void 0 ? "currentColor" : _ref596$color,
      _ref596$size = _ref596.size,
      e = _ref596$size === void 0 ? 24 : _ref596$size,
      l = _ref596.className,
      i = _objectWithoutProperties(_ref596, _excluded596);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13 10H18L12 16L6 10H11V3H13V10ZM4 19H20V12H22V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V12H4V19Z"
  }));
},
    ce = function ce(_ref597) {
  var _ref597$color = _ref597.color,
      C = _ref597$color === void 0 ? "currentColor" : _ref597$color,
      _ref597$size = _ref597.size,
      e = _ref597$size === void 0 ? 24 : _ref597$size,
      l = _ref597.className,
      i = _objectWithoutProperties(_ref597, _excluded597);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13 13V18.585L14.8284 16.7574L16.2426 18.1716L12 22.4142L7.75736 18.1716L9.17157 16.7574L11 18.585V13H13ZM12 2C15.5934 2 18.5544 4.70761 18.9541 8.19395C21.2858 8.83154 23 10.9656 23 13.5C23 16.3688 20.8036 18.7246 18.0006 18.9776L18 17C18 13.6863 15.3137 11 12 11C8.7616 11 6.12243 13.5656 6.00414 16.7751L6 17L6.00039 18.9776C3.19696 18.7252 1 16.3692 1 13.5C1 10.9656 2.71424 8.83154 5.04648 8.19411C5.44561 4.70761 8.40661 2 12 2Z"
  }));
},
    oe = function oe(_ref598) {
  var _ref598$color = _ref598.color,
      C = _ref598$color === void 0 ? "currentColor" : _ref598$color,
      _ref598$size = _ref598.size,
      e = _ref598$size === void 0 ? 24 : _ref598$size,
      l = _ref598.className,
      i = _objectWithoutProperties(_ref598, _excluded598);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13 13V18.585L14.8284 16.7574L16.2426 18.1716L12 22.4142L7.75736 18.1716L9.17157 16.7574L11 18.585V13H13ZM12 2C15.5934 2 18.5544 4.70761 18.9541 8.19395C21.2858 8.83154 23 10.9656 23 13.5C23 16.3688 20.8036 18.7246 18.0006 18.9776L18.0009 16.9644C19.6966 16.7214 21 15.2629 21 13.5C21 11.567 19.433 10 17.5 10C17.2912 10 17.0867 10.0183 16.8887 10.054C16.9616 9.7142 17 9.36158 17 9C17 6.23858 14.7614 4 12 4C9.23858 4 7 6.23858 7 9C7 9.36158 7.03838 9.7142 7.11205 10.0533C6.91331 10.0183 6.70879 10 6.5 10C4.567 10 3 11.567 3 13.5C3 15.2003 4.21241 16.6174 5.81986 16.934L6.00005 16.9646L6.00039 18.9776C3.19696 18.7252 1 16.3692 1 13.5C1 10.9656 2.71424 8.83154 5.04648 8.19411C5.44561 4.70761 8.40661 2 12 2Z"
  }));
},
    ae = function ae(_ref599) {
  var _ref599$color = _ref599.color,
      C = _ref599$color === void 0 ? "currentColor" : _ref599$color,
      _ref599$size = _ref599.size,
      e = _ref599$size === void 0 ? 24 : _ref599$size,
      l = _ref599.className,
      i = _objectWithoutProperties(_ref599, _excluded599);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7 20.9811C3.64378 20.7257 1 17.9216 1 14.5C1 12.1716 2.22429 10.1291 4.06426 8.9812C4.56469 5.044 7.92686 2 12 2C16.0731 2 19.4353 5.044 19.9357 8.9812C21.7757 10.1291 23 12.1716 23 14.5C23 17.9216 20.3562 20.7257 17 20.9811V21H7V20.9811ZM13 12V8H11V12H8L12 17L16 12H13Z"
  }));
},
    ne = function ne(_ref600) {
  var _ref600$color = _ref600.color,
      C = _ref600$color === void 0 ? "currentColor" : _ref600$color,
      _ref600$size = _ref600.size,
      e = _ref600$size === void 0 ? 24 : _ref600$size,
      l = _ref600.className,
      i = _objectWithoutProperties(_ref600, _excluded600);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M1 14.5C1 12.1716 2.22429 10.1291 4.06426 8.9812C4.56469 5.044 7.92686 2 12 2C16.0731 2 19.4353 5.044 19.9357 8.9812C21.7757 10.1291 23 12.1716 23 14.5C23 17.9216 20.3562 20.7257 17 20.9811L7 21C3.64378 20.7257 1 17.9216 1 14.5ZM16.8483 18.9868C19.1817 18.8093 21 16.8561 21 14.5C21 12.927 20.1884 11.4962 18.8771 10.6781L18.0714 10.1754L17.9517 9.23338C17.5735 6.25803 15.0288 4 12 4C8.97116 4 6.42647 6.25803 6.0483 9.23338L5.92856 10.1754L5.12288 10.6781C3.81156 11.4962 3 12.927 3 14.5C3 16.8561 4.81833 18.8093 7.1517 18.9868L7.325 19H16.675L16.8483 18.9868ZM13 12H16L12 17L8 12H11V8H13V12Z"
  }));
},
    me = function me(_ref601) {
  var _ref601$color = _ref601.color,
      C = _ref601$color === void 0 ? "currentColor" : _ref601$color,
      _ref601$size = _ref601.size,
      e = _ref601$size === void 0 ? 24 : _ref601$size,
      l = _ref601.className,
      i = _objectWithoutProperties(_ref601, _excluded601);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 19H21V21H3V19ZM13 9H20L12 17L4 9H11V1H13V9Z"
  }));
},
    we = function we(_ref602) {
  var _ref602$color = _ref602.color,
      C = _ref602$color === void 0 ? "currentColor" : _ref602$color,
      _ref602$size = _ref602.size,
      e = _ref602$size === void 0 ? 24 : _ref602$size,
      l = _ref602.className,
      i = _objectWithoutProperties(_ref602, _excluded602);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 19H21V21H3V19ZM13 13.1716L19.0711 7.1005L20.4853 8.51472L12 17L3.51472 8.51472L4.92893 7.1005L11 13.1716V2H13V13.1716Z"
  }));
},
    Le = function Le(_ref603) {
  var _ref603$color = _ref603.color,
      C = _ref603$color === void 0 ? "currentColor" : _ref603$color,
      _ref603$size = _ref603.size,
      e = _ref603$size === void 0 ? 24 : _ref603$size,
      l = _ref603.className,
      i = _objectWithoutProperties(_ref603, _excluded603);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 2C20.5523 2 21 2.44772 21 3V6.757L12.0012 15.7562L11.995 19.995L16.2414 20.0012L21 15.242V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V3C3 2.44772 3.44772 2 4 2H20ZM21.7782 8.80761L23.1924 10.2218L15.4142 18L13.9979 17.9979L14 16.5858L21.7782 8.80761ZM12 12H7V14H12V12ZM15 8H7V10H15V8Z"
  }));
},
    he = function he(_ref604) {
  var _ref604$color = _ref604.color,
      C = _ref604$color === void 0 ? "currentColor" : _ref604$color,
      _ref604$size = _ref604.size,
      e = _ref604$size === void 0 ? 24 : _ref604$size,
      l = _ref604.className,
      i = _objectWithoutProperties(_ref604, _excluded604);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 2C20.5523 2 21 2.44772 21 3V6.757L19 8.757V4H5V20H19V17.242L21 15.242V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V3C3 2.44772 3.44772 2 4 2H20ZM21.7782 8.80761L23.1924 10.2218L15.4142 18L13.9979 17.9979L14 16.5858L21.7782 8.80761ZM13 12V14H8V12H13ZM16 8V10H8V8H16Z"
  }));
},
    He = function He(_ref605) {
  var _ref605$color = _ref605.color,
      C = _ref605$color === void 0 ? "currentColor" : _ref605$color,
      _ref605$size = _ref605.size,
      e = _ref605$size === void 0 ? 24 : _ref605$size,
      l = _ref605.className,
      i = _objectWithoutProperties(_ref605, _excluded605);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14 6H16V8H21C21.5523 8 22 8.44772 22 9V16.5L16 13L16.0359 21.0622L18.2592 18.9129L20.041 22H9C8.44772 22 8 21.5523 8 21V16H6V14H8V9C8 8.44772 8.44772 8 9 8H14V6ZM22 17.338V21C22 21.107 21.9832 21.2101 21.9521 21.3068L19.9913 17.9129L22 17.338ZM4 14V16H2V14H4ZM4 10V12H2V10H4ZM4 6V8H2V6H4ZM4 2V4H2V2H4ZM8 2V4H6V2H8ZM12 2V4H10V2H12ZM16 2V4H14V2H16Z"
  }));
},
    Ve = function Ve(_ref606) {
  var _ref606$color = _ref606.color,
      C = _ref606$color === void 0 ? "currentColor" : _ref606$color,
      _ref606$size = _ref606.size,
      e = _ref606$size === void 0 ? 24 : _ref606$size,
      l = _ref606.className,
      i = _objectWithoutProperties(_ref606, _excluded606);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16 13L22.9641 17.0622L19.9913 17.9129L22.116 21.5933L20.384 22.5933L18.2592 18.9129L16.0359 21.0622L16 13ZM14 6H16V8H21C21.5523 8 22 8.44772 22 9V13H20V10H10V20H14V22H9C8.44772 22 8 21.5523 8 21V16H6V14H8V9C8 8.44772 8.44772 8 9 8H14V6ZM4 14V16H2V14H4ZM4 10V12H2V10H4ZM4 6V8H2V6H4ZM4 2V4H2V2H4ZM8 2V4H6V2H8ZM12 2V4H10V2H12ZM16 2V4H14V2H16Z"
  }));
},
    ge = function ge(_ref607) {
  var _ref607$color = _ref607.color,
      C = _ref607$color === void 0 ? "currentColor" : _ref607$color,
      _ref607$size = _ref607.size,
      e = _ref607$size === void 0 ? 24 : _ref607$size,
      l = _ref607.className,
      i = _objectWithoutProperties(_ref607, _excluded607);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18 11V8L22 12L18 16V13H13V18H16L12 22L8 18H11V13H6V16L2 12L6 8V11H11V6H8L12 2L16 6H13V11H18Z"
  }));
},
    Me = function Me(_ref608) {
  var _ref608$color = _ref608.color,
      C = _ref608$color === void 0 ? "currentColor" : _ref608$color,
      _ref608$size = _ref608.size,
      e = _ref608$size === void 0 ? 24 : _ref608$size,
      l = _ref608.className,
      i = _objectWithoutProperties(_ref608, _excluded608);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11 11V5.82843L9.17157 7.65685L7.75736 6.24264L12 2L16.2426 6.24264L14.8284 7.65685L13 5.82843V11H18.1716L16.3431 9.17157L17.7574 7.75736L22 12L17.7574 16.2426L16.3431 14.8284L18.1716 13H13V18.1716L14.8284 16.3431L16.2426 17.7574L12 22L7.75736 17.7574L9.17157 16.3431L11 18.1716V13H5.82843L7.65685 14.8284L6.24264 16.2426L2 12L6.24264 7.75736L7.65685 9.17157L5.82843 11H11Z"
  }));
},
    Ze = function Ze(_ref609) {
  var _ref609$color = _ref609.color,
      C = _ref609$color === void 0 ? "currentColor" : _ref609$color,
      _ref609$size = _ref609.size,
      e = _ref609$size === void 0 ? 24 : _ref609$size,
      l = _ref609.className,
      i = _objectWithoutProperties(_ref609, _excluded609);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22L8 18H16L12 22ZM12 2L16 6H8L12 2ZM12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14ZM2 12L6 8V16L2 12ZM22 12L18 16V8L22 12Z"
  }));
},
    xe = function xe(_ref610) {
  var _ref610$color = _ref610.color,
      C = _ref610$color === void 0 ? "currentColor" : _ref610$color,
      _ref610$size = _ref610.size,
      e = _ref610$size === void 0 ? 24 : _ref610$size,
      l = _ref610.className,
      i = _objectWithoutProperties(_ref610, _excluded610);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2L16.2426 6.24264L14.8284 7.65685L12 4.82843L9.17157 7.65685L7.75736 6.24264L12 2ZM2 12L6.24264 7.75736L7.65685 9.17157L4.82843 12L7.65685 14.8284L6.24264 16.2426L2 12ZM22 12L17.7574 16.2426L16.3431 14.8284L19.1716 12L16.3431 9.17157L17.7574 7.75736L22 12ZM12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14ZM12 22L7.75736 17.7574L9.17157 16.3431L12 19.1716L14.8284 16.3431L16.2426 17.7574L12 22Z"
  }));
},
    ve = function ve(_ref611) {
  var _ref611$color = _ref611.color,
      C = _ref611$color === void 0 ? "currentColor" : _ref611$color,
      _ref611$size = _ref611.size,
      e = _ref611$size === void 0 ? 24 : _ref611$size,
      l = _ref611.className,
      i = _objectWithoutProperties(_ref611, _excluded611);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C6.47939 2 2 6.47939 2 12C2 17.5206 6.47939 22 12 22C17.5098 22 22 17.5206 22 12C22 6.47939 17.5098 2 12 2ZM18.6052 6.60954C19.7983 8.06291 20.5141 9.91756 20.5358 11.9241C20.2538 11.8699 17.4338 11.295 14.5922 11.6529C14.5271 11.5119 14.4729 11.3601 14.4078 11.2083C14.2343 10.7961 14.0391 10.3731 13.8438 9.97181C16.9891 8.692 18.4208 6.84816 18.6052 6.60954ZM12 3.47506C14.1692 3.47506 16.154 4.28851 17.6616 5.62256C17.5098 5.83948 16.2191 7.56399 13.1822 8.70281C11.7831 6.13232 10.2321 4.0282 9.9935 3.70282C10.6334 3.55097 11.3059 3.47506 12 3.47506ZM8.36662 4.27766C8.59437 4.58134 10.1128 6.69631 11.5336 9.21256C7.5423 10.2755 4.01736 10.2538 3.63774 10.2538C4.19089 7.60738 5.98047 5.40564 8.36662 4.27766ZM3.45336 12.0109C3.45336 11.9241 3.45336 11.8373 3.45336 11.7506C3.82212 11.7614 7.96529 11.8156 12.2277 10.5358C12.4773 11.013 12.705 11.5011 12.9219 11.9891C12.8134 12.0217 12.6941 12.0542 12.5857 12.0868C8.18221 13.5076 5.83948 17.3904 5.64425 17.7158C4.2885 16.2083 3.45336 14.2017 3.45336 12.0109ZM12 20.5466C10.026 20.5466 8.20391 19.8742 6.76139 18.7462C6.91323 18.4317 8.64856 15.0911 13.4642 13.41C13.4859 13.3991 13.4967 13.3991 13.5184 13.3883C14.7223 16.5011 15.2104 19.1149 15.3406 19.8633C14.3102 20.308 13.1822 20.5466 12 20.5466ZM16.7614 19.0824C16.6746 18.5618 16.2191 16.0672 15.1019 12.9978C17.7809 12.5748 20.1236 13.269 20.4165 13.3666C20.0478 15.7419 18.6811 17.7917 16.7614 19.0824Z"
  }));
},
    de = function de(_ref612) {
  var _ref612$color = _ref612.color,
      C = _ref612$color === void 0 ? "currentColor" : _ref612$color,
      _ref612$size = _ref612.size,
      e = _ref612$size === void 0 ? 24 : _ref612$size,
      l = _ref612.className,
      i = _objectWithoutProperties(_ref612, _excluded612);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19.9887 11.5716C19.9029 9.94513 19.3313 8.44745 18.4163 7.22097C18.1749 7.48407 17.8785 7.7698 17.4957 8.09159C16.5881 8.85458 15.4887 9.54307 14.1834 10.101C14.3498 10.4506 14.5029 10.7899 14.6376 11.1098L14.6388 11.1125C14.6652 11.1742 14.6879 11.2306 14.7321 11.3418C14.7379 11.3562 14.7433 11.3697 14.7485 11.3825C16.2621 11.2122 17.8576 11.2749 19.4049 11.4845C19.6106 11.5123 19.805 11.5415 19.9887 11.5716ZM10.6044 4.1213C10.7783 4.36621 10.9602 4.62859 11.1803 4.95378C11.7929 5.8589 12.396 6.81391 12.9604 7.79507C13.0749 7.99416 13.187 8.19289 13.2964 8.39112C14.5193 7.90993 15.5296 7.30281 16.3438 6.62486C16.6731 6.35063 16.9383 6.093 17.1403 5.86972C15.7501 4.70277 13.9571 4 12 4C11.524 4 11.0576 4.04158 10.6044 4.1213ZM4.25266 9.99755C4.83145 9.98452 5.48467 9.94941 6.29303 9.87518C7.90024 9.72758 9.54141 9.46249 11.1549 9.05274C10.5719 8.03721 9.93888 7.02331 9.29452 6.05378C8.98479 5.58775 8.68357 5.14992 8.45484 4.82642C6.39541 5.84613 4.83794 7.72658 4.25266 9.99755ZM5.78366 17.036C6.17111 16.4693 6.68061 15.8314 7.35797 15.1374C8.81199 13.6478 10.5286 12.4878 12.5139 11.8473C12.5417 11.8391 12.5604 11.8336 12.576 11.829C12.411 11.4651 12.2562 11.1405 12.1003 10.8342C10.2643 11.3687 8.3303 11.703 6.40279 11.8762C5.46319 11.9606 4.62005 11.9981 4 12.0044C4.00102 13.9112 4.66915 15.662 5.78366 17.036ZM15.0045 19.4166C14.9001 18.8745 14.7669 18.2706 14.5899 17.574C14.2689 16.3112 13.8668 15.012 13.373 13.7078C11.3712 14.4343 9.77574 15.4974 8.54309 16.7649C7.94904 17.3757 7.51244 17.9537 7.22642 18.4203C8.55892 19.4127 10.2109 20 12 20C13.0626 20 14.0769 19.7928 15.0045 19.4166ZM16.8778 18.3414C18.4073 17.1632 19.4985 15.444 19.8652 13.4703C19.5253 13.3865 19.094 13.3005 18.6196 13.2346C17.5756 13.0897 16.5014 13.0655 15.4409 13.2018C15.8933 14.4764 16.2642 15.7332 16.5608 16.9361C16.6903 17.4614 16.7958 17.9358 16.8778 18.3414ZM12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22Z"
  }));
},
    pe = function pe(_ref613) {
  var _ref613$color = _ref613.color,
      C = _ref613$color === void 0 ? "currentColor" : _ref613$color,
      _ref613$size = _ref613.size,
      e = _ref613$size === void 0 ? 24 : _ref613$size,
      l = _ref613.className,
      i = _objectWithoutProperties(_ref613, _excluded613);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7.94037 4.14596L11.4217 10.1759L5.48201 20.4688L2 14.44L7.94037 4.14596ZM10.1161 14.44H22L18.518 20.4688H6.63537L10.1161 14.44ZM14.4589 13.4399L8.51799 3.14502H15.482L21.4229 13.4399H14.4589Z"
  }));
},
    Ee = function Ee(_ref614) {
  var _ref614$color = _ref614.color,
      C = _ref614$color === void 0 ? "currentColor" : _ref614$color,
      _ref614$size = _ref614.size,
      e = _ref614$size === void 0 ? 24 : _ref614$size,
      l = _ref614.className,
      i = _objectWithoutProperties(_ref614, _excluded614);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9.09742 6.15015L4.31009 14.4431L6.06471 17.4746L10.8502 9.18597L9.09742 6.15015ZM7.79701 18.4742H17.3651L19.1162 15.44H9.54877L7.79701 18.4742ZM19.1109 13.44L14.3252 5.15002H10.8294L15.6156 13.44H19.1109ZM8.52 3.15002H15.48L22 14.4444L18.52 20.4742H5.49L2 14.4444L8.52 3.15002ZM12.0049 11.186L10.7035 13.44H13.3062L12.0049 11.186Z"
  }));
},
    Ne = function Ne(_ref615) {
  var _ref615$color = _ref615.color,
      C = _ref615$color === void 0 ? "currentColor" : _ref615$color,
      _ref615$size = _ref615.size,
      e = _ref615$size === void 0 ? 24 : _ref615$size,
      l = _ref615.className,
      i = _objectWithoutProperties(_ref615, _excluded615);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11 18V21H9V18C4.58172 18 1 14.4183 1 10C1 5.58172 4.58172 2 9 2C12.3949 2 15.2959 4.11466 16.4576 7.09864C16.7951 7.0339 17.1436 7 17.5 7C20.5376 7 23 9.46243 23 12.5C23 15.5376 20.5376 18 17.5 18H11ZM13 20H15V23H13V20Z"
  }));
},
    ue = function ue(_ref616) {
  var _ref616$color = _ref616.color,
      C = _ref616$color === void 0 ? "currentColor" : _ref616$color,
      _ref616$size = _ref616.size,
      e = _ref616$size === void 0 ? 24 : _ref616$size,
      l = _ref616.className,
      i = _objectWithoutProperties(_ref616, _excluded616);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17 18V16H17.5C19.433 16 21 14.433 21 12.5C21 10.567 19.433 9 17.5 9C16.5205 9 15.6351 9.40232 14.9998 10.0507C14.9999 10.0338 15 10.0169 15 10C15 6.68629 12.3137 4 9 4C5.68629 4 3 6.68629 3 10C3 12.6124 4.66962 14.8349 7 15.6586V17.748C3.54955 16.8599 1 13.7277 1 10C1 5.58172 4.58172 2 9 2C12.3949 2 15.2959 4.11466 16.4576 7.09864C16.7951 7.0339 17.1436 7 17.5 7C20.5376 7 23 9.46243 23 12.5C23 15.5376 20.5376 18 17.5 18H17ZM9 16H11V20H9V16ZM13 19H15V23H13V19Z"
  }));
},
    Be = function Be(_ref617) {
  var _ref617$color = _ref617.color,
      C = _ref617$color === void 0 ? "currentColor" : _ref617$color,
      _ref617$size = _ref617.size,
      e = _ref617$size === void 0 ? 24 : _ref617$size,
      l = _ref617.className,
      i = _objectWithoutProperties(_ref617, _excluded617);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5.63604 6.63288L12 0.268921L18.364 6.63288C21.8787 10.1476 21.8787 15.8461 18.364 19.3608C14.8492 22.8755 9.15076 22.8755 5.63604 19.3608C2.12132 15.8461 2.12132 10.1476 5.63604 6.63288H5.63604Z"
  }));
},
    fe = function fe(_ref618) {
  var _ref618$color = _ref618.color,
      C = _ref618$color === void 0 ? "currentColor" : _ref618$color,
      _ref618$size = _ref618.size,
      e = _ref618$size === void 0 ? 24 : _ref618$size,
      l = _ref618.className,
      i = _objectWithoutProperties(_ref618, _excluded618);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 3.09723L7.05025 8.04697C4.31658 10.7806 4.31658 15.2128 7.05025 17.9465C9.78392 20.6801 14.2161 20.6801 16.9497 17.9465C19.6834 15.2128 19.6834 10.7806 16.9497 8.04697L12 3.09723ZM12 0.268799L18.364 6.63276C21.8787 10.1475 21.8787 15.846 18.364 19.3607C14.8492 22.8754 9.15076 22.8754 5.63604 19.3607C2.12132 15.846 2.12132 10.1475 5.63604 6.63276L12 0.268799Z"
  }));
},
    Re = function Re(_ref619) {
  var _ref619$color = _ref619.color,
      C = _ref619$color === void 0 ? "currentColor" : _ref619$color,
      _ref619$size = _ref619.size,
      e = _ref619$size === void 0 ? 24 : _ref619$size,
      l = _ref619.className,
      i = _objectWithoutProperties(_ref619, _excluded619);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17.2847 10.6683L22.5 13.9909L17.248 17.3368L12 13.9934L6.75198 17.3368L1.5 13.9909L6.7152 10.6684L1.5 7.34587L6.75206 4L11.9999 7.34335L17.2481 4L22.5 7.34587L17.2847 10.6683ZM17.2112 10.6684L11.9999 7.3484L6.78869 10.6683L12 13.9883L17.2112 10.6684ZM6.78574 18.4456L12.0377 15.1L17.2898 18.4456L12.0377 21.7916L6.78574 18.4456Z"
  }));
},
    ze = function ze(_ref620) {
  var _ref620$color = _ref620.color,
      C = _ref620$color === void 0 ? "currentColor" : _ref620$color,
      _ref620$size = _ref620.size,
      e = _ref620$size === void 0 ? 24 : _ref620$size,
      l = _ref620.className,
      i = _objectWithoutProperties(_ref620, _excluded620);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8.65039 17.2607L12.0422 19.4216L15.434 17.2607L17.2942 18.4457L12.0422 21.7916L6.79021 18.4457L8.65039 17.2607ZM7.77356 8.98007L10.1669 7.42738L7.74124 5.85351L5.28562 7.36988L7.77356 8.98007ZM9.61315 10.1706L12.0045 11.7183L14.3953 10.1709L12.0042 8.61946L9.61315 10.1706ZM13.845 12.9095L16.2689 14.4782L18.7187 12.9761L16.2335 11.3636L13.845 12.9095ZM12.0042 6.2354L16.2413 3.48657L22.4656 7.3302L18.073 10.1731L22.4669 13.024L16.2401 16.8419L12.0045 14.1006L7.76898 16.8419L1.54004 13.0241L5.93528 10.1727L1.54332 7.3302L7.7677 3.48657L12.0042 6.2354ZM13.8415 7.42749L16.2349 8.9804L18.7233 7.36988L16.2677 5.85349L13.8415 7.42749ZM10.164 12.9095L7.77487 11.3632L5.2889 12.976L7.73997 14.4783L10.164 12.9095Z"
  }));
},
    Fe = function Fe(_ref621) {
  var _ref621$color = _ref621.color,
      C = _ref621$color === void 0 ? "currentColor" : _ref621$color,
      _ref621$size = _ref621.size,
      e = _ref621$size === void 0 ? 24 : _ref621$size,
      l = _ref621.className,
      i = _objectWithoutProperties(_ref621, _excluded621);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15 2L19.7071 6.70711C19.8946 6.89464 20 7.149 20 7.41421V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V3C4 2.44772 4.44772 2 5 2H15ZM13 8H10V10H11V16H13V8Z"
  }));
},
    Se = function Se(_ref622) {
  var _ref622$color = _ref622.color,
      C = _ref622$color === void 0 ? "currentColor" : _ref622$color,
      _ref622$size = _ref622.size,
      e = _ref622$size === void 0 ? 24 : _ref622$size,
      l = _ref622.className,
      i = _objectWithoutProperties(_ref622, _excluded622);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15 2L19.7071 6.70711C19.8946 6.89464 20 7.149 20 7.41421V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V3C4 2.44772 4.44772 2 5 2H15ZM14.171 4H6V20H18V7.829L14.171 4ZM13 16H11V10H10V8H13V16Z"
  }));
},
    Ae = function Ae(_ref623) {
  var _ref623$color = _ref623.color,
      C = _ref623$color === void 0 ? "currentColor" : _ref623$color,
      _ref623$size = _ref623.size,
      e = _ref623$size === void 0 ? 24 : _ref623$size,
      l = _ref623.className,
      i = _objectWithoutProperties(_ref623, _excluded623);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15 2L19.7071 6.70711C19.8946 6.89464 20 7.149 20 7.41421V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V3C4 2.44772 4.44772 2 5 2H15ZM12 7.5C10.4023 7.5 9.09634 8.74892 9.00509 10.3237L9 10.5H11C11 9.94772 11.4477 9.5 12 9.5C12.5523 9.5 13 9.94772 13 10.5C13 10.7528 12.9062 10.9836 12.7514 11.1598L12.6691 11.2431L8.99926 14.547L9 16H15V14H12.5953L14.0074 12.7294L14.0013 12.72L14.009 12.728C14.6175 12.179 15 11.3841 15 10.5C15 8.84315 13.6569 7.5 12 7.5Z"
  }));
},
    ke = function ke(_ref624) {
  var _ref624$color = _ref624.color,
      C = _ref624$color === void 0 ? "currentColor" : _ref624$color,
      _ref624$size = _ref624.size,
      e = _ref624$size === void 0 ? 24 : _ref624$size,
      l = _ref624.className,
      i = _objectWithoutProperties(_ref624, _excluded624);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15 2L19.7071 6.70711C19.8946 6.89464 20 7.149 20 7.41421V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V3C4 2.44772 4.44772 2 5 2H15ZM14.171 4H6V20H18V7.829L14.171 4ZM12 7.5C13.6569 7.5 15 8.84315 15 10.5C15 11.3841 14.6175 12.179 14.009 12.728L14.0013 12.72L14.0074 12.7294L12.5953 14H15V16H9L8.99926 14.547L12.6691 11.2431C12.8723 11.06 13 10.7949 13 10.5C13 9.94772 12.5523 9.5 12 9.5C11.4477 9.5 11 9.94772 11 10.5H9C9 8.84315 10.3431 7.5 12 7.5Z"
  }));
},
    Pe = function Pe(_ref625) {
  var _ref625$color = _ref625.color,
      C = _ref625$color === void 0 ? "currentColor" : _ref625$color,
      _ref625$size = _ref625.size,
      e = _ref625$size === void 0 ? 24 : _ref625$size,
      l = _ref625.className,
      i = _objectWithoutProperties(_ref625, _excluded625);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 14.7453C2.18652 13.4804 1 11.3787 1 9C1 5.13401 4.13401 2 8 2C11.866 2 15 5.13401 15 9C15 11.3787 13.8135 13.4804 12 14.7453V21C12 21.5523 11.5523 22 11 22H5C4.44772 22 4 21.5523 4 21V14.7453ZM8 14C10.7614 14 13 11.7614 13 9C13 6.23858 10.7614 4 8 4C5.23858 4 3 6.23858 3 9C3 11.7614 5.23858 14 8 14ZM7 18V20H9V18H7ZM8 12C6.34315 12 5 10.6569 5 9C5 7.34315 6.34315 6 8 6C9.65685 6 11 7.34315 11 9C11 10.6569 9.65685 12 8 12ZM14 17V15.7083C15.8412 14.0604 17 11.6655 17 9C17 6.69494 16.1334 4.59227 14.7083 3H21C21.5523 3 22 3.44772 22 4V16C22 16.5523 21.5523 17 21 17H14ZM18 7V9H20V7H18Z"
  }));
},
    De = function De(_ref626) {
  var _ref626$color = _ref626.color,
      C = _ref626$color === void 0 ? "currentColor" : _ref626$color,
      _ref626$size = _ref626.size,
      e = _ref626$size === void 0 ? 24 : _ref626$size,
      l = _ref626.className,
      i = _objectWithoutProperties(_ref626, _excluded626);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11.6076 3H21C21.5523 3 22 3.44772 22 4V16C22 16.5523 21.5523 17 21 17H14V15H20V5H13.7453C14.5362 6.13386 15 7.51276 15 9C15 11.3787 13.8135 13.4804 12 14.7453V21C12 21.5523 11.5523 22 11 22H5C4.44772 22 4 21.5523 4 21V14.7453C2.18652 13.4804 1 11.3787 1 9C1 5.13401 4.13401 2 8 2C9.31966 2 10.554 2.36517 11.6076 2.99999L11.6076 3ZM6 13.584V20H10V13.584C11.7659 12.8124 13 11.0503 13 9C13 6.23858 10.7614 4 8 4C5.23858 4 3 6.23858 3 9C3 11.0503 4.2341 12.8124 6 13.584ZM8 12C6.34315 12 5 10.6569 5 9C5 7.34315 6.34315 6 8 6C9.65685 6 11 7.34315 11 9C11 10.6569 9.65685 12 8 12ZM8 10C8.55228 10 9 9.55228 9 9C9 8.44772 8.55228 8 8 8C7.44772 8 7 8.44772 7 9C7 9.55228 7.44772 10 8 10ZM17 7H19V9H17V7ZM7 17H9V19H7V17Z"
  }));
},
    ye = function ye(_ref627) {
  var _ref627$color = _ref627.color,
      C = _ref627$color === void 0 ? "currentColor" : _ref627$color,
      _ref627$size = _ref627.size,
      e = _ref627$size === void 0 ? 24 : _ref627$size,
      l = _ref627.className,
      i = _objectWithoutProperties(_ref627, _excluded627);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13 11V6L8 13H11V18L16 11H13ZM12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22Z"
  }));
},
    be = function be(_ref628) {
  var _ref628$color = _ref628.color,
      C = _ref628$color === void 0 ? "currentColor" : _ref628$color,
      _ref628$size = _ref628.size,
      e = _ref628$size === void 0 ? 24 : _ref628$size,
      l = _ref628.className,
      i = _objectWithoutProperties(_ref628, _excluded628);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM13 11H16L11 18V13H8L13 6V11Z"
  }));
},
    Te = function Te(_ref629) {
  var _ref629$color = _ref629.color,
      C = _ref629$color === void 0 ? "currentColor" : _ref629$color,
      _ref629$size = _ref629.size,
      e = _ref629$size === void 0 ? 24 : _ref629$size,
      l = _ref629.className,
      i = _objectWithoutProperties(_ref629, _excluded629);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16 1C16.5523 1 17 1.44772 17 2V3H22V9H19.981L22.7271 16.5448C22.9033 16.9958 23 17.4866 23 18C23 20.2091 21.2091 22 19 22C17.1362 22 15.5701 20.7252 15.126 19H10.874C10.4299 20.7252 8.86384 22 7 22C5.05551 22 3.43508 20.6125 3.07474 18.7736C2.43596 18.4396 2 17.7707 2 17V7C2 6.44772 2.44772 6 3 6H10C10.5523 6 11 6.44772 11 7V12C11 12.5523 11.4477 13 12 13H14C14.5523 13 15 12.5523 15 12V3H12V1H16ZM19 16C17.8954 16 17 16.8954 17 18C17 19.1046 17.8954 20 19 20C20.1046 20 21 19.1046 21 18C21 17.7597 20.9576 17.5292 20.8799 17.3158L20.8635 17.2724C20.5725 16.5276 19.8479 16 19 16ZM7 16C5.89543 16 5 16.8954 5 18C5 19.1046 5.89543 20 7 20C8.10457 20 9 19.1046 9 18C9 16.8954 8.10457 16 7 16ZM9 8H4V10H9V8ZM20 5H17V7H20V5Z"
  }));
},
    Ue = function Ue(_ref630) {
  var _ref630$color = _ref630.color,
      C = _ref630$color === void 0 ? "currentColor" : _ref630$color,
      _ref630$size = _ref630.size,
      e = _ref630$size === void 0 ? 24 : _ref630$size,
      l = _ref630.className,
      i = _objectWithoutProperties(_ref630, _excluded630);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16 1C16.5523 1 17 1.44772 17 2V3H22V9H19.9813L22.7271 16.5439C22.9033 16.9948 23 17.4856 23 17.999C23 20.2082 21.2091 21.999 19 21.999C17.1365 21.999 15.5707 20.7247 15.1263 19H10.874C10.4299 20.7252 8.86384 22 7 22C5.05551 22 3.43508 20.6125 3.07474 18.7736C2.43596 18.4396 2 17.7707 2 17V7C2 6.44772 2.44772 6 3 6H10C10.5523 6 11 6.44772 11 7V12C11 12.5523 11.4477 13 12 13H14C14.5523 13 15 12.5523 15 12V3H12V1H16ZM7 16C5.89543 16 5 16.8954 5 18C5 19.1046 5.89543 20 7 20C8.10457 20 9 19.1046 9 18C9 16.8954 8.10457 16 7 16ZM19 15.999C17.8954 15.999 17 16.8944 17 17.999C17 19.1036 17.8954 19.999 19 19.999C20.1046 19.999 21 19.1036 21 17.999C21 17.7587 20.9576 17.5282 20.8799 17.3148L20.8635 17.2714C20.5725 16.5266 19.8479 15.999 19 15.999ZM17.853 9H17V12C17 13.6569 15.6569 15 14 15H12C10.3431 15 9 13.6569 9 12H4V15.3542C4.73294 14.5238 5.80531 14 7 14C8.86384 14 10.4299 15.2748 10.874 17H15.1258C15.5695 15.2743 17.1358 13.999 19 13.999C19.2368 13.999 19.4688 14.0196 19.6943 14.0591L17.853 9ZM9 8H4V10H9V8ZM20 5H17V7H20V5Z"
  }));
},
    Ge = function Ge(_ref631) {
  var _ref631$color = _ref631.color,
      C = _ref631$color === void 0 ? "currentColor" : _ref631$color,
      _ref631$size = _ref631.size,
      e = _ref631$size === void 0 ? 24 : _ref631$size,
      l = _ref631.className,
      i = _objectWithoutProperties(_ref631, _excluded631);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15.5006 6.93685C17.5926 8.14727 19 10.4093 19 13V21H14.8293C14.4175 22.1652 13.3062 23 12 23C10.6938 23 9.58254 22.1652 9.17071 21H5V13C5 10.4093 6.40741 8.14727 8.49936 6.93685C8.33754 6.645 8.21115 6.33078 8.12602 6H5V4H8.12602C8.57006 2.27477 10.1362 1 12 1C13.8638 1 15.4299 2.27477 15.874 4H19V6H15.874C15.7888 6.33078 15.6625 6.645 15.5006 6.93685ZM12 14C11.4477 14 11 14.4477 11 15V20C11 20.5523 11.4477 21 12 21C12.5523 21 13 20.5523 13 20V15C13 14.4477 12.5523 14 12 14ZM12 7C13.1046 7 14 6.10457 14 5C14 3.89543 13.1046 3 12 3C10.8954 3 10 3.89543 10 5C10 6.10457 10.8954 7 12 7Z"
  }));
},
    Ie = function Ie(_ref632) {
  var _ref632$color = _ref632.color,
      C = _ref632$color === void 0 ? "currentColor" : _ref632$color,
      _ref632$size = _ref632.size,
      e = _ref632$size === void 0 ? 24 : _ref632$size,
      l = _ref632.className,
      i = _objectWithoutProperties(_ref632, _excluded632);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15.5006 6.93685C17.5926 8.14727 19 10.4093 19 13V21H14.8293C14.4175 22.1652 13.3062 23 12 23C10.6938 23 9.58254 22.1652 9.17071 21H5V13C5 10.4093 6.40741 8.14727 8.49936 6.93685C8.33754 6.645 8.21115 6.33078 8.12602 6H5V4H8.12602C8.57006 2.27477 10.1362 1 12 1C13.8638 1 15.4299 2.27477 15.874 4H19V6H15.874C15.7888 6.33078 15.6625 6.645 15.5006 6.93685ZM14.0474 8.43703C13.4484 8.79457 12.7482 9 12 9C11.2518 9 10.5516 8.79457 9.95263 8.43703C8.21207 9.21922 7 10.9681 7 13V19H9V15C9 13.3431 10.3431 12 12 12C13.6569 12 15 13.3431 15 15V19H17V13C17 10.9681 15.7879 9.21922 14.0474 8.43703ZM12 14C11.4477 14 11 14.4477 11 15V20C11 20.5523 11.4477 21 12 21C12.5523 21 13 20.5523 13 20V15C13 14.4477 12.5523 14 12 14ZM12 7C13.1046 7 14 6.10457 14 5C14 3.89543 13.1046 3 12 3C10.8954 3 10 3.89543 10 5C10 6.10457 10.8954 7 12 7Z"
  }));
},
    We = function We(_ref633) {
  var _ref633$color = _ref633.color,
      C = _ref633$color === void 0 ? "currentColor" : _ref633$color,
      _ref633$size = _ref633.size,
      e = _ref633$size === void 0 ? 24 : _ref633$size,
      l = _ref633.className,
      i = _objectWithoutProperties(_ref633, _excluded633);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM16.0043 12.8777C15.6589 12.3533 15.4097 11.9746 14.4622 12.1248C12.6717 12.409 12.4732 12.7224 12.3877 13.2375L12.3636 13.3943L12.3393 13.5597C12.2416 14.2428 12.2453 14.5012 12.5589 14.8308C13.8241 16.1582 14.582 17.115 14.8116 17.6746C14.9237 17.9484 15.2119 18.7751 15.0136 19.5927C16.2372 19.1066 17.3156 18.3332 18.1653 17.3559C18.2755 16.9821 18.3551 16.5166 18.3551 15.9518V15.8472C18.3551 14.9247 18.3551 14.504 17.7031 14.1314C17.428 13.9751 17.2227 13.881 17.0582 13.8064C16.691 13.6394 16.4479 13.5297 16.1198 13.0499C16.0807 12.9928 16.0425 12.9358 16.0043 12.8777ZM12 3.83333C9.68259 3.83333 7.59062 4.79858 6.1042 6.34896C6.28116 6.47186 6.43537 6.64453 6.54129 6.88256C6.74529 7.34029 6.74529 7.8112 6.74529 8.22764C6.74488 8.55621 6.74442 8.8672 6.84992 9.09302C6.99443 9.40134 7.6164 9.53227 8.16548 9.64736C8.36166 9.68867 8.56395 9.73083 8.74797 9.78176C9.25405 9.92233 9.64554 10.3765 9.95938 10.7412C10.0896 10.8931 10.2819 11.1163 10.3783 11.1717C10.4286 11.1356 10.59 10.9608 10.6699 10.6735C10.7307 10.4547 10.7134 10.2597 10.6239 10.1543C10.0648 9.49445 10.0952 8.2232 10.268 7.75495C10.5402 7.01606 11.3905 7.07058 12.012 7.11097C12.2438 7.12589 12.4626 7.14023 12.6257 7.11976C13.2482 7.04166 13.4396 6.09538 13.575 5.91C13.8671 5.50981 14.7607 4.9071 15.3158 4.53454C14.3025 4.08382 13.1805 3.83333 12 3.83333Z"
  }));
},
    Oe = function Oe(_ref634) {
  var _ref634$color = _ref634.color,
      C = _ref634$color === void 0 ? "currentColor" : _ref634$color,
      _ref634$size = _ref634.size,
      e = _ref634$size === void 0 ? 24 : _ref634$size,
      l = _ref634.className,
      i = _objectWithoutProperties(_ref634, _excluded634);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.23509 6.45329C4.85101 7.89148 4 9.84636 4 12C4 16.4183 7.58172 20 12 20C13.0808 20 14.1116 19.7857 15.0521 19.3972C15.1671 18.6467 14.9148 17.9266 14.8116 17.6746C14.582 17.115 13.8241 16.1582 12.5589 14.8308C12.2212 14.4758 12.2429 14.2035 12.3636 13.3943L12.3775 13.3029C12.4595 12.7486 12.5971 12.4209 14.4622 12.1248C15.4097 11.9746 15.6589 12.3533 16.0043 12.8777C16.0425 12.9358 16.0807 12.9928 16.1198 13.0499C16.4479 13.5297 16.691 13.6394 17.0582 13.8064C17.2227 13.881 17.428 13.9751 17.7031 14.1314C18.3551 14.504 18.3551 14.9247 18.3551 15.8472V15.9518C18.3551 16.3434 18.3168 16.6872 18.2566 16.9859C19.3478 15.6185 20 13.8854 20 12C20 8.70089 18.003 5.8682 15.1519 4.64482C14.5987 5.01813 13.8398 5.54726 13.575 5.91C13.4396 6.09538 13.2482 7.04166 12.6257 7.11976C12.4626 7.14023 12.2438 7.12589 12.012 7.11097C11.3905 7.07058 10.5402 7.01606 10.268 7.75495C10.0952 8.2232 10.0648 9.49445 10.6239 10.1543C10.7134 10.2597 10.7307 10.4547 10.6699 10.6735C10.59 10.9608 10.4286 11.1356 10.3783 11.1717C10.2819 11.1163 10.0896 10.8931 9.95938 10.7412C9.64554 10.3765 9.25405 9.92233 8.74797 9.78176C8.56395 9.73083 8.36166 9.68867 8.16548 9.64736C7.6164 9.53227 6.99443 9.40134 6.84992 9.09302C6.74442 8.8672 6.74488 8.55621 6.74529 8.22764C6.74529 7.8112 6.74529 7.34029 6.54129 6.88256C6.46246 6.70541 6.35689 6.56446 6.23509 6.45329ZM12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22Z"
  }));
},
    Ke = function Ke(_ref635) {
  var _ref635$color = _ref635.color,
      C = _ref635$color === void 0 ? "currentColor" : _ref635$color,
      _ref635$size = _ref635.size,
      e = _ref635$size === void 0 ? 24 : _ref635$size,
      l = _ref635.className,
      i = _objectWithoutProperties(_ref635, _excluded635);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11.3273 1.6115C11.677 1.29365 12.1956 1.26716 12.5734 1.53204L12.6727 1.6115L23 11H20V20C20 20.5128 19.614 20.9355 19.1166 20.9933L19 21H12.5L15 17L11.5 14L15.5 11L13 8.99998L13.5 5.99998L10.5 8.99998L13 11L8 14L11.75 17.5L8.5 21H5C4.48716 21 4.06449 20.6139 4.00673 20.1166L4 20V11H1L11.3273 1.6115Z"
  }));
},
    Qe = function Qe(_ref636) {
  var _ref636$color = _ref636.color,
      C = _ref636$color === void 0 ? "currentColor" : _ref636$color,
      _ref636$size = _ref636.size,
      e = _ref636$size === void 0 ? 24 : _ref636$size,
      l = _ref636.className,
      i = _objectWithoutProperties(_ref636, _excluded636);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5 21C4.48716 21 4.06449 20.6139 4.00673 20.1166L4 20V11H1L11.3273 1.6115C11.677 1.29365 12.1956 1.26716 12.5734 1.53204L12.6727 1.6115L23 11H20V20C20 20.5128 19.614 20.9355 19.1166 20.9933L19 21H5ZM12 3.70198L6 9.15598V19L10.357 18.9994L11.75 17.5L8 14L13 11L10.5 8.99998L13.5 5.99998L13 8.99998L15.5 11L11.5 14L15 17L13.75 18.9994L18 19V9.15698L12 3.70198Z"
  }));
},
    qe = function qe(_ref637) {
  var _ref637$color = _ref637.color,
      C = _ref637$color === void 0 ? "currentColor" : _ref637$color,
      _ref637$size = _ref637.size,
      e = _ref637$size === void 0 ? 24 : _ref637$size,
      l = _ref637.className,
      i = _objectWithoutProperties(_ref637, _excluded637);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.645 8.586C20.475 7.875 20.204 7.138 19.871 6.565C19.1 5.236 18.407 4.328 16.694 3.245C14.981 2.162 13.077 2 12.171 2C9.75598 2 7.95998 2.86 6.64598 3.887C3.34498 6.47 3.00098 11 3.00098 11C3.00098 11 4.22198 8.955 6.54098 7.474C7.94398 6.579 9.94198 6 11.569 6C15.886 6 16.001 10 16.001 10H9.00098C9.00098 8 10.001 7 10.001 7C10.001 7 5.00098 9 5.00098 14.044C5.00098 14.531 4.99798 15.416 5.24898 16.327C5.48098 17.17 5.94898 18.032 6.38098 18.68C7.60198 20.512 9.42598 21.294 10.297 21.584C11.293 21.916 12.326 22 13.307 22C16.027 22 18.184 21.114 19.001 20.725V16.553C18.243 17.007 16.322 18 14.001 18C9.00098 18 9.00098 14 9.00098 14H21.001V11.51C21.001 11.51 20.962 9.917 20.645 8.586Z"
  }));
},
    je = function je(_ref638) {
  var _ref638$color = _ref638.color,
      C = _ref638$color === void 0 ? "currentColor" : _ref638$color,
      _ref638$size = _ref638.size,
      e = _ref638$size === void 0 ? 24 : _ref638$size,
      l = _ref638.className,
      i = _objectWithoutProperties(_ref638, _excluded638);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8.00776 14.0012C8.00326 14.0837 8.00098 14.1666 8.00098 14.25C8.00098 16.6319 9.75362 19 13.001 19C15.3739 19 17.5285 18.345 19.001 17.4465V20.7972C17.2123 21.5636 15.1135 22 13.001 22C7.49897 22 5.00098 18.5302 5.00098 14.25C5.00098 11.0187 7.04227 8.24935 9.94376 7.08603C8.53997 8.66307 8.00098 10.3413 8.00098 10.9952L18.001 11C18.001 7.59382 15.4528 5 12.001 5C7.00098 5 3.99969 8.9877 3.00098 10.9989C3.29063 6.23741 7.01012 2 12.001 2C17.201 2 21.001 6.02944 21.001 11V14H8.00098L8.00776 14.0012Z"
  }));
},
    Xe = function Xe(_ref639) {
  var _ref639$color = _ref639.color,
      C = _ref639$color === void 0 ? "currentColor" : _ref639$color,
      _ref639$size = _ref639.size,
      e = _ref639$size === void 0 ? 24 : _ref639$size,
      l = _ref639.className,
      i = _objectWithoutProperties(_ref639, _excluded639);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9.24264 18.9967H21V20.9967H3V16.754L12.8995 6.85453L17.1421 11.0972L9.24264 18.9967ZM14.3137 5.44032L16.435 3.319C16.8256 2.92848 17.4587 2.92848 17.8492 3.319L20.6777 6.14743C21.0682 6.53795 21.0682 7.17112 20.6777 7.56164L18.5563 9.68296L14.3137 5.44032Z"
  }));
},
    Je = function Je(_ref640) {
  var _ref640$color = _ref640.color,
      C = _ref640$color === void 0 ? "currentColor" : _ref640$color,
      _ref640$size = _ref640.size,
      e = _ref640$size === void 0 ? 24 : _ref640$size,
      l = _ref640.className,
      i = _objectWithoutProperties(_ref640, _excluded640);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5 18.89H6.41421L15.7279 9.57627L14.3137 8.16206L5 17.4758V18.89ZM21 20.89H3V16.6473L16.435 3.21231C16.8256 2.82179 17.4587 2.82179 17.8492 3.21231L20.6777 6.04074C21.0682 6.43126 21.0682 7.06443 20.6777 7.45495L9.24264 18.89H21V20.89ZM15.7279 6.74785L17.1421 8.16206L18.5563 6.74785L17.1421 5.33363L15.7279 6.74785Z"
  }));
},
    Ye = function Ye(_ref641) {
  var _ref641$color = _ref641.color,
      C = _ref641$color === void 0 ? "currentColor" : _ref641$color,
      _ref641$size = _ref641.size,
      e = _ref641$size === void 0 ? 24 : _ref641$size,
      l = _ref641.className,
      i = _objectWithoutProperties(_ref641, _excluded641);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16.7574 2.99678L9.29145 10.4627L9.29886 14.7099L13.537 14.7024L21 7.23943V19.9968C21 20.5491 20.5523 20.9968 20 20.9968H4C3.44772 20.9968 3 20.5491 3 19.9968V3.99678C3 3.4445 3.44772 2.99678 4 2.99678H16.7574ZM20.4853 2.09729L21.8995 3.5115L12.7071 12.7039L11.2954 12.7064L11.2929 11.2897L20.4853 2.09729Z"
  }));
},
    _e = function _e(_ref642) {
  var _ref642$color = _ref642.color,
      C = _ref642$color === void 0 ? "currentColor" : _ref642$color,
      _ref642$size = _ref642.size,
      e = _ref642$size === void 0 ? 24 : _ref642$size,
      l = _ref642.className,
      i = _objectWithoutProperties(_ref642, _excluded642);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16.7574 2.99678L14.7574 4.99678H5V18.9968H19V9.23943L21 7.23943V19.9968C21 20.5491 20.5523 20.9968 20 20.9968H4C3.44772 20.9968 3 20.5491 3 19.9968V3.99678C3 3.4445 3.44772 2.99678 4 2.99678H16.7574ZM20.4853 2.09729L21.8995 3.5115L12.7071 12.7039L11.2954 12.7064L11.2929 11.2897L20.4853 2.09729Z"
  }));
},
    $e = function $e(_ref643) {
  var _ref643$color = _ref643.color,
      C = _ref643$color === void 0 ? "currentColor" : _ref643$color,
      _ref643$size = _ref643.size,
      e = _ref643$size === void 0 ? 24 : _ref643$size,
      l = _ref643.className,
      i = _objectWithoutProperties(_ref643, _excluded643);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16.6256 3.1285L9.29145 10.4626L9.29886 14.7098L13.537 14.7024L20.8682 7.37114C21.5912 8.75438 22 10.3278 22 11.9967C22 17.5196 17.5228 21.9967 12 21.9967C6.47715 21.9967 2 17.5196 2 11.9967C2 6.47386 6.47715 1.9967 12 1.9967C13.6689 1.9967 15.2423 2.40553 16.6256 3.1285ZM20.4853 2.09721L21.8995 3.51142L12.7071 12.7038L11.2954 12.7063L11.2929 11.2896L20.4853 2.09721Z"
  }));
},
    et = function et(_ref644) {
  var _ref644$color = _ref644.color,
      C = _ref644$color === void 0 ? "currentColor" : _ref644$color,
      _ref644$size = _ref644.size,
      e = _ref644$size === void 0 ? 24 : _ref644$size,
      l = _ref644.className,
      i = _objectWithoutProperties(_ref644, _excluded644);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.6844 4.02547C12.4588 4.00646 12.2306 3.9967 12 3.9967C7.58172 3.9967 4 7.57843 4 11.9967C4 16.415 7.58172 19.9967 12 19.9967C16.4183 19.9967 20 16.415 20 11.9967C20 11.7662 19.9902 11.5379 19.9711 11.3123C19.8996 10.4646 19.6953 9.6442 19.368 8.87344L20.8682 7.37114C21.2031 8.01192 21.4706 8.6935 21.6613 9.40649C21.8213 10.0063 21.9258 10.6222 21.9723 11.248C21.9907 11.4952 22 11.7449 22 11.9967C22 17.5196 17.5228 21.9967 12 21.9967C6.47715 21.9967 2 17.5196 2 11.9967C2 6.47386 6.47715 1.9967 12 1.9967C12.2518 1.9967 12.5015 2.00601 12.7487 2.02431C13.3745 2.07081 13.9904 2.17542 14.5898 2.3358C15.3032 2.52609 15.9848 2.79359 16.6256 3.1285L15.1247 4.62934C14.3525 4.30143 13.5321 4.09707 12.6844 4.02547ZM20.4853 2.09721L21.8995 3.51142L12.7071 12.7038L11.2954 12.7063L11.2929 11.2896L20.4853 2.09721Z"
  }));
},
    tt = function tt(_ref645) {
  var _ref645$color = _ref645.color,
      C = _ref645$color === void 0 ? "currentColor" : _ref645$color,
      _ref645$size = _ref645.size,
      e = _ref645$size === void 0 ? 24 : _ref645$size,
      l = _ref645.className,
      i = _objectWithoutProperties(_ref645, _excluded645);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7.24264 17.9967H3V13.754L14.435 2.319C14.8256 1.92848 15.4587 1.92848 15.8492 2.319L18.6777 5.14743C19.0682 5.53795 19.0682 6.17112 18.6777 6.56164L7.24264 17.9967ZM3 19.9967H21V21.9967H3V19.9967Z"
  }));
},
    Ct = function Ct(_ref646) {
  var _ref646$color = _ref646.color,
      C = _ref646$color === void 0 ? "currentColor" : _ref646$color,
      _ref646$size = _ref646.size,
      e = _ref646$size === void 0 ? 24 : _ref646$size,
      l = _ref646.className,
      i = _objectWithoutProperties(_ref646, _excluded646);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.41421 15.89L16.5563 5.74785L15.1421 4.33363L5 14.4758V15.89H6.41421ZM7.24264 17.89H3V13.6473L14.435 2.21231C14.8256 1.82179 15.4587 1.82179 15.8492 2.21231L18.6777 5.04074C19.0682 5.43126 19.0682 6.06443 18.6777 6.45495L7.24264 17.89ZM3 19.89H21V21.89H3V19.89Z"
  }));
},
    lt = function lt(_ref647) {
  var _ref647$color = _ref647.color,
      C = _ref647$color === void 0 ? "currentColor" : _ref647$color,
      _ref647$size = _ref647.size,
      e = _ref647$size === void 0 ? 24 : _ref647$size,
      l = _ref647.className,
      i = _objectWithoutProperties(_ref647, _excluded647);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.416 3.62407L19.4818 14.2227C19.6349 14.4524 19.5729 14.7629 19.3431 14.9161C19.261 14.9708 19.1645 15 19.0657 15H4.93426C4.65812 15 4.43426 14.7762 4.43426 14.5C4.43426 14.4013 4.46348 14.3048 4.51823 14.2227L11.584 3.62407C11.7372 3.39431 12.0476 3.33222 12.2774 3.4854C12.3323 3.52201 12.3794 3.56914 12.416 3.62407ZM5 17H19C19.5523 17 20 17.4477 20 18C20 18.5523 19.5523 19 19 19H5C4.44772 19 4 18.5523 4 18C4 17.4477 4.44772 17 5 17Z"
  }));
},
    it = function it(_ref648) {
  var _ref648$color = _ref648.color,
      C = _ref648$color === void 0 ? "currentColor" : _ref648$color,
      _ref648$size = _ref648.size,
      e = _ref648$size === void 0 ? 24 : _ref648$size,
      l = _ref648.className,
      i = _objectWithoutProperties(_ref648, _excluded648);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7.73703 13H16.263L12 6.60558L7.73703 13ZM12.416 3.62407L19.4818 14.2227C19.6349 14.4524 19.5729 14.7629 19.3431 14.9161C19.261 14.9708 19.1645 15 19.0657 15H4.93426C4.65812 15 4.43426 14.7762 4.43426 14.5C4.43426 14.4013 4.46348 14.3048 4.51823 14.2227L11.584 3.62407C11.7372 3.39431 12.0476 3.33222 12.2774 3.4854C12.3323 3.52201 12.3794 3.56914 12.416 3.62407ZM5 17H19C19.5523 17 20 17.4477 20 18C20 18.5523 19.5523 19 19 19H5C4.44772 19 4 18.5523 4 18C4 17.4477 4.44772 17 5 17Z"
  }));
},
    st = function st(_ref649) {
  var _ref649$color = _ref649.color,
      C = _ref649$color === void 0 ? "currentColor" : _ref649$color,
      _ref649$size = _ref649.size,
      e = _ref649$size === void 0 ? 24 : _ref649$size,
      l = _ref649.className,
      i = _objectWithoutProperties(_ref649, _excluded649);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM8 13C8 15.2091 9.79086 17 12 17C14.2091 17 16 15.2091 16 13H8Z"
  }));
},
    rt = function rt(_ref650) {
  var _ref650$color = _ref650.color,
      C = _ref650$color === void 0 ? "currentColor" : _ref650$color,
      _ref650$size = _ref650.size,
      e = _ref650$size === void 0 ? 24 : _ref650$size,
      l = _ref650.className,
      i = _objectWithoutProperties(_ref650, _excluded650);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM8 13H16C16 15.2091 14.2091 17 12 17C9.79086 17 8 15.2091 8 13Z"
  }));
},
    ct = function ct(_ref651) {
  var _ref651$color = _ref651.color,
      C = _ref651$color === void 0 ? "currentColor" : _ref651$color,
      _ref651$size = _ref651.size,
      e = _ref651$size === void 0 ? 24 : _ref651$size,
      l = _ref651.className,
      i = _objectWithoutProperties(_ref651, _excluded651);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM8 13C8 15.2091 9.79086 17 12 17C14.2091 17 16 15.2091 16 13H8ZM8 11C8.82843 11 9.5 10.3284 9.5 9.5C9.5 8.67157 8.82843 8 8 8C7.17157 8 6.5 8.67157 6.5 9.5C6.5 10.3284 7.17157 11 8 11ZM16 11C16.8284 11 17.5 10.3284 17.5 9.5C17.5 8.67157 16.8284 8 16 8C15.1716 8 14.5 8.67157 14.5 9.5C14.5 10.3284 15.1716 11 16 11Z"
  }));
},
    ot = function ot(_ref652) {
  var _ref652$color = _ref652.color,
      C = _ref652$color === void 0 ? "currentColor" : _ref652$color,
      _ref652$size = _ref652.size,
      e = _ref652$size === void 0 ? 24 : _ref652$size,
      l = _ref652.className,
      i = _objectWithoutProperties(_ref652, _excluded652);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM7 13C7 15.7614 9.23858 18 12 18C14.7614 18 17 15.7614 17 13H15C15 14.6569 13.6569 16 12 16C10.3431 16 9 14.6569 9 13H7ZM8 11C8.82843 11 9.5 10.3284 9.5 9.5C9.5 8.67157 8.82843 8 8 8C7.17157 8 6.5 8.67157 6.5 9.5C6.5 10.3284 7.17157 11 8 11ZM16 11C16.8284 11 17.5 10.3284 17.5 9.5C17.5 8.67157 16.8284 8 16 8C15.1716 8 14.5 8.67157 14.5 9.5C14.5 10.3284 15.1716 11 16 11Z"
  }));
},
    at = function at(_ref653) {
  var _ref653$color = _ref653.color,
      C = _ref653$color === void 0 ? "currentColor" : _ref653$color,
      _ref653$size = _ref653.size,
      e = _ref653$size === void 0 ? 24 : _ref653$size,
      l = _ref653.className,
      i = _objectWithoutProperties(_ref653, _excluded653);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM7 13H9C9 14.6569 10.3431 16 12 16C13.6569 16 15 14.6569 15 13H17C17 15.7614 14.7614 18 12 18C9.23858 18 7 15.7614 7 13ZM8 11C7.17157 11 6.5 10.3284 6.5 9.5C6.5 8.67157 7.17157 8 8 8C8.82843 8 9.5 8.67157 9.5 9.5C9.5 10.3284 8.82843 11 8 11ZM16 11C15.1716 11 14.5 10.3284 14.5 9.5C14.5 8.67157 15.1716 8 16 8C16.8284 8 17.5 8.67157 17.5 9.5C17.5 10.3284 16.8284 11 16 11Z"
  }));
},
    nt = function nt(_ref654) {
  var _ref654$color = _ref654.color,
      C = _ref654$color === void 0 ? "currentColor" : _ref654$color,
      _ref654$size = _ref654.size,
      e = _ref654$size === void 0 ? 24 : _ref654$size,
      l = _ref654.className,
      i = _objectWithoutProperties(_ref654, _excluded654);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 11C10 11 8.33333 11.3333 7 12C7 14.7614 9.23858 17 12 17C14.7614 17 17 14.7614 17 12C15.6667 11.3333 14 11 12 11ZM8.5 7C7.34792 7 6.37786 7.77929 6.08818 8.8395L6.04989 9.00057H10.9501C10.7187 7.85917 9.70968 7 8.5 7ZM15.5 7C14.3479 7 13.3779 7.77929 13.0882 8.8395L13.0499 9.00057H17.9501C17.7187 7.85917 16.7097 7 15.5 7Z"
  }));
},
    mt = function mt(_ref655) {
  var _ref655$color = _ref655.color,
      C = _ref655$color === void 0 ? "currentColor" : _ref655$color,
      _ref655$size = _ref655.size,
      e = _ref655$size === void 0 ? 24 : _ref655$size,
      l = _ref655.className,
      i = _objectWithoutProperties(_ref655, _excluded655);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM12 11C14 11 15.6667 11.3333 17 12C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12C8.33333 11.3333 10 11 12 11ZM8.5 7C9.70968 7 10.7187 7.85917 10.9501 9.00057H6.04989C6.28131 7.85917 7.29032 7 8.5 7ZM15.5 7C16.7097 7 17.7187 7.85917 17.9501 9.00057H13.0499C13.2813 7.85917 14.2903 7 15.5 7Z"
  }));
},
    wt = function wt(_ref656) {
  var _ref656$color = _ref656.color,
      C = _ref656$color === void 0 ? "currentColor" : _ref656$color,
      _ref656$size = _ref656.size,
      e = _ref656$size === void 0 ? 24 : _ref656$size,
      l = _ref656.className,
      i = _objectWithoutProperties(_ref656, _excluded656);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM8 13H16C16 15.2091 14.2091 17 12 17C9.79086 17 8 15.2091 8 13ZM8 11C7.17157 11 6.5 10.3284 6.5 9.5C6.5 8.67157 7.17157 8 8 8C8.82843 8 9.5 8.67157 9.5 9.5C9.5 10.3284 8.82843 11 8 11ZM16 11C15.1716 11 14.5 10.3284 14.5 9.5C14.5 8.67157 15.1716 8 16 8C16.8284 8 17.5 8.67157 17.5 9.5C17.5 10.3284 16.8284 11 16 11Z"
  }));
},
    Lt = function Lt(_ref657) {
  var _ref657$color = _ref657.color,
      C = _ref657$color === void 0 ? "currentColor" : _ref657$color,
      _ref657$size = _ref657.size,
      e = _ref657$size === void 0 ? 24 : _ref657$size,
      l = _ref657.className,
      i = _objectWithoutProperties(_ref657, _excluded657);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM8 14V16H16V14H8ZM8 11C8.82843 11 9.5 10.3284 9.5 9.5C9.5 8.67157 8.82843 8 8 8C7.17157 8 6.5 8.67157 6.5 9.5C6.5 10.3284 7.17157 11 8 11ZM16 11C16.8284 11 17.5 10.3284 17.5 9.5C17.5 8.67157 16.8284 8 16 8C15.1716 8 14.5 8.67157 14.5 9.5C14.5 10.3284 15.1716 11 16 11Z"
  }));
},
    ht = function ht(_ref658) {
  var _ref658$color = _ref658.color,
      C = _ref658$color === void 0 ? "currentColor" : _ref658$color,
      _ref658$size = _ref658.size,
      e = _ref658$size === void 0 ? 24 : _ref658$size,
      l = _ref658.className,
      i = _objectWithoutProperties(_ref658, _excluded658);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM8 14H16V16H8V14ZM8 11C7.17157 11 6.5 10.3284 6.5 9.5C6.5 8.67157 7.17157 8 8 8C8.82843 8 9.5 8.67157 9.5 9.5C9.5 10.3284 8.82843 11 8 11ZM16 11C15.1716 11 14.5 10.3284 14.5 9.5C14.5 8.67157 15.1716 8 16 8C16.8284 8 17.5 8.67157 17.5 9.5C17.5 10.3284 16.8284 11 16 11Z"
  }));
},
    Ht = function Ht(_ref659) {
  var _ref659$color = _ref659.color,
      C = _ref659$color === void 0 ? "currentColor" : _ref659$color,
      _ref659$size = _ref659.size,
      e = _ref659$size === void 0 ? 24 : _ref659$size,
      l = _ref659.className,
      i = _objectWithoutProperties(_ref659, _excluded659);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C17.5228 2 22 6.47715 22 12C22 13.6169 21.6162 15.1442 20.9348 16.4958C20.8633 16.2175 20.7307 15.9523 20.5374 15.7206L20.4142 15.5858L19 14.1716L17.5858 15.5858L17.469 15.713C16.8069 16.4988 16.8458 17.6743 17.5858 18.4142C18.014 18.8424 18.588 19.0358 19.148 18.9946C17.3323 20.8487 14.8006 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 15C10.6199 15 9.37036 15.5592 8.46564 16.4633L8.30009 16.6368L9.24506 17.4961C10.035 17.1825 10.982 17 12 17C12.9049 17 13.7537 17.1442 14.4859 17.3965L14.7549 17.4961L15.6999 16.6368C14.7853 15.6312 13.4664 15 12 15ZM8.5 10C7.67157 10 7 10.6716 7 11.5C7 12.3284 7.67157 13 8.5 13C9.32843 13 10 12.3284 10 11.5C10 10.6716 9.32843 10 8.5 10ZM15.5 10C14.6716 10 14 10.6716 14 11.5C14 12.3284 14.6716 13 15.5 13C16.3284 13 17 12.3284 17 11.5C17 10.6716 16.3284 10 15.5 10Z"
  }));
},
    Vt = function Vt(_ref660) {
  var _ref660$color = _ref660.color,
      C = _ref660$color === void 0 ? "currentColor" : _ref660$color,
      _ref660$size = _ref660.size,
      e = _ref660$size === void 0 ? 24 : _ref660$size,
      l = _ref660.className,
      i = _objectWithoutProperties(_ref660, _excluded660);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C17.5228 2 22 6.47715 22 12C22 12.7266 21.9225 13.4351 21.7753 14.1177L19.9931 12.3355C19.9977 12.2242 20 12.1124 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C13.3023 20 14.5319 19.6888 15.6186 19.1368C15.7735 19.3828 15.958 19.6149 16.1716 19.8284C16.4739 20.1307 16.8125 20.3745 17.1734 20.5598C15.6642 21.4737 13.8936 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM19 14.1716L20.4142 15.5858C21.1953 16.3668 21.1953 17.6332 20.4142 18.4142C19.6332 19.1953 18.3668 19.1953 17.5858 18.4142C16.8402 17.6687 16.8064 16.481 17.4841 15.6952L17.5858 15.5858L19 14.1716ZM12 15C13.4664 15 14.7853 15.6312 15.6999 16.6368L14.7549 17.4961C13.965 17.1825 13.018 17 12 17C10.982 17 10.035 17.1825 9.24506 17.4961L8.30009 16.6368C9.21468 15.6312 10.5336 15 12 15ZM8.5 10C9.32843 10 10 10.6716 10 11.5C10 12.3284 9.32843 13 8.5 13C7.67157 13 7 12.3284 7 11.5C7 10.6716 7.67157 10 8.5 10ZM15.5 10C16.3284 10 17 10.6716 17 11.5C17 12.3284 16.3284 13 15.5 13C14.6716 13 14 12.3284 14 11.5C14 10.6716 14.6716 10 15.5 10Z"
  }));
},
    gt = function gt(_ref661) {
  var _ref661$color = _ref661.color,
      C = _ref661$color === void 0 ? "currentColor" : _ref661$color,
      _ref661$size = _ref661.size,
      e = _ref661$size === void 0 ? 24 : _ref661$size,
      l = _ref661.className,
      i = _objectWithoutProperties(_ref661, _excluded661);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM7 17H9C9 15.3431 10.3431 14 12 14C13.6569 14 15 15.3431 15 17H17C17 14.2386 14.7614 12 12 12C9.23858 12 7 14.2386 7 17ZM8 11C8.82843 11 9.5 10.3284 9.5 9.5C9.5 8.67157 8.82843 8 8 8C7.17157 8 6.5 8.67157 6.5 9.5C6.5 10.3284 7.17157 11 8 11ZM16 11C16.8284 11 17.5 10.3284 17.5 9.5C17.5 8.67157 16.8284 8 16 8C15.1716 8 14.5 8.67157 14.5 9.5C14.5 10.3284 15.1716 11 16 11Z"
  }));
},
    Mt = function Mt(_ref662) {
  var _ref662$color = _ref662.color,
      C = _ref662$color === void 0 ? "currentColor" : _ref662$color,
      _ref662$size = _ref662.size,
      e = _ref662$size === void 0 ? 24 : _ref662$size,
      l = _ref662.className,
      i = _objectWithoutProperties(_ref662, _excluded662);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM7 17C7 14.2386 9.23858 12 12 12C14.7614 12 17 14.2386 17 17H15C15 15.3431 13.6569 14 12 14C10.3431 14 9 15.3431 9 17H7ZM8 11C7.17157 11 6.5 10.3284 6.5 9.5C6.5 8.67157 7.17157 8 8 8C8.82843 8 9.5 8.67157 9.5 9.5C9.5 10.3284 8.82843 11 8 11ZM16 11C15.1716 11 14.5 10.3284 14.5 9.5C14.5 8.67157 15.1716 8 16 8C16.8284 8 17.5 8.67157 17.5 9.5C17.5 10.3284 16.8284 11 16 11Z"
  }));
},
    Zt = function Zt(_ref663) {
  var _ref663$color = _ref663.color,
      C = _ref663$color === void 0 ? "currentColor" : _ref663$color,
      _ref663$size = _ref663.size,
      e = _ref663$size === void 0 ? 24 : _ref663$size,
      l = _ref663.className,
      i = _objectWithoutProperties(_ref663, _excluded663);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18.3643 10.9792C19.9264 12.5413 19.9264 15.0739 18.3643 16.636L12.7075 22.2929C12.317 22.6834 11.6838 22.6834 11.2933 22.2929L5.63642 16.636C4.07432 15.0739 4.07432 12.5413 5.63642 10.9792C7.19851 9.41709 9.73117 9.41709 11.2933 10.9792L11.9997 11.6856L12.7075 10.9792C14.2696 9.41709 16.8022 9.41709 18.3643 10.9792ZM12.0004 1C14.2095 1 16.0004 2.79086 16.0004 5C16.0004 7.20914 14.2095 9 12.0004 9C9.79124 9 8.00038 7.20914 8.00038 5C8.00038 2.79086 9.79124 1 12.0004 1Z"
  }));
},
    xt = function xt(_ref664) {
  var _ref664$color = _ref664.color,
      C = _ref664$color === void 0 ? "currentColor" : _ref664$color,
      _ref664$size = _ref664.size,
      e = _ref664$size === void 0 ? 24 : _ref664$size,
      l = _ref664.className,
      i = _objectWithoutProperties(_ref664, _excluded664);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18.3643 10.9792C19.9264 12.5413 19.9264 15.0739 18.3643 16.636L12.7075 22.2929C12.317 22.6834 11.6838 22.6834 11.2933 22.2929L5.63642 16.636C4.07432 15.0739 4.07432 12.5413 5.63642 10.9792C7.19851 9.41709 9.73117 9.41709 11.2933 10.9792L11.9997 11.6856L12.7075 10.9792C14.2696 9.41709 16.8022 9.41709 18.3643 10.9792ZM7.05063 12.3934C6.26958 13.1744 6.26958 14.4408 7.05063 15.2218L12.0004 20.1716L16.9501 15.2218C17.7312 14.4408 17.7312 13.1744 16.9501 12.3934C16.1691 11.6123 14.9027 11.6123 14.1203 12.3948L11.9983 14.5126L9.87906 12.3934C9.09801 11.6123 7.83168 11.6123 7.05063 12.3934ZM12.0004 1C14.2095 1 16.0004 2.79086 16.0004 5C16.0004 7.20914 14.2095 9 12.0004 9C9.79124 9 8.00038 7.20914 8.00038 5C8.00038 2.79086 9.79124 1 12.0004 1ZM12.0004 3C10.8958 3 10.0004 3.89543 10.0004 5C10.0004 6.10457 10.8958 7 12.0004 7C13.1049 7 14.0004 6.10457 14.0004 5C14.0004 3.89543 13.1049 3 12.0004 3Z"
  }));
},
    vt = function vt(_ref665) {
  var _ref665$color = _ref665.color,
      C = _ref665$color === void 0 ? "currentColor" : _ref665$color,
      _ref665$size = _ref665.size,
      e = _ref665$size === void 0 ? 24 : _ref665$size,
      l = _ref665.className,
      i = _objectWithoutProperties(_ref665, _excluded665);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 19C12.8284 19 13.5 19.6716 13.5 20.5C13.5 21.3284 12.8284 22 12 22C11.1716 22 10.5 21.3284 10.5 20.5C10.5 19.6716 11.1716 19 12 19ZM6.5 19C7.32843 19 8 19.6716 8 20.5C8 21.3284 7.32843 22 6.5 22C5.67157 22 5 21.3284 5 20.5C5 19.6716 5.67157 19 6.5 19ZM17.5 19C18.3284 19 19 19.6716 19 20.5C19 21.3284 18.3284 22 17.5 22C16.6716 22 16 21.3284 16 20.5C16 19.6716 16.6716 19 17.5 19ZM13 2V4H19V6L17.0322 6.0006C16.2423 8.3666 14.9984 10.5065 13.4107 12.302C14.9544 13.6737 16.7616 14.7204 18.7379 15.3443L18.2017 17.2736C15.8917 16.5557 13.787 15.3326 12.0005 13.7257C10.214 15.332 8.10914 16.5553 5.79891 17.2734L5.26257 15.3442C7.2385 14.7203 9.04543 13.6737 10.5904 12.3021C9.46307 11.0285 8.50916 9.58052 7.76789 8.00128L10.0074 8.00137C10.5706 9.03952 11.2401 10.0037 11.9998 10.8772C13.2283 9.46508 14.2205 7.81616 14.9095 6.00101L5 6V4H11V2H13Z"
  }));
},
    dt = function dt(_ref666) {
  var _ref666$color = _ref666.color,
      C = _ref666$color === void 0 ? "currentColor" : _ref666$color,
      _ref666$size = _ref666.size,
      e = _ref666$size === void 0 ? 24 : _ref666$size,
      l = _ref666.className,
      i = _objectWithoutProperties(_ref666, _excluded666);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 19C12.8284 19 13.5 19.6716 13.5 20.5C13.5 21.3284 12.8284 22 12 22C11.1716 22 10.5 21.3284 10.5 20.5C10.5 19.6716 11.1716 19 12 19ZM6.5 19C7.32843 19 8 19.6716 8 20.5C8 21.3284 7.32843 22 6.5 22C5.67157 22 5 21.3284 5 20.5C5 19.6716 5.67157 19 6.5 19ZM17.5 19C18.3284 19 19 19.6716 19 20.5C19 21.3284 18.3284 22 17.5 22C16.6716 22 16 21.3284 16 20.5C16 19.6716 16.6716 19 17.5 19ZM18 3V5H8V9H17V11H8V15H18V17H6V3H18Z"
  }));
},
    pt = function pt(_ref667) {
  var _ref667$color = _ref667.color,
      C = _ref667$color === void 0 ? "currentColor" : _ref667$color,
      _ref667$size = _ref667.size,
      e = _ref667$size === void 0 ? 24 : _ref667$size,
      l = _ref667.className,
      i = _objectWithoutProperties(_ref667, _excluded667);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14 10H16L16.0005 10.7574C16.7154 10.279 17.5751 10 18.5 10C20.9853 10 23 12.0147 23 14.5V20H21V14.5C21 13.07 19.8255 12 18.5 12C17.1745 12 16 13.07 16 14.5V20H14V10ZM12 4V6H4V11H12V13H4V18H12V20H2V4H12Z"
  }));
},
    Et = function Et(_ref668) {
  var _ref668$color = _ref668.color,
      C = _ref668$color === void 0 ? "currentColor" : _ref668$color,
      _ref668$size = _ref668.size,
      e = _ref668$size === void 0 ? 24 : _ref668$size,
      l = _ref668.className,
      i = _objectWithoutProperties(_ref668, _excluded668);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.17071 18C6.58254 16.8348 7.69378 16 9 16C10.3062 16 11.4175 16.8348 11.8293 18H22V20H11.8293C11.4175 21.1652 10.3062 22 9 22C7.69378 22 6.58254 21.1652 6.17071 20H2V18H6.17071ZM12.1707 11C12.5825 9.83481 13.6938 9 15 9C16.3062 9 17.4175 9.83481 17.8293 11H22V13H17.8293C17.4175 14.1652 16.3062 15 15 15C13.6938 15 12.5825 14.1652 12.1707 13H2V11H12.1707ZM6.17071 4C6.58254 2.83481 7.69378 2 9 2C10.3062 2 11.4175 2.83481 11.8293 4H22V6H11.8293C11.4175 7.16519 10.3062 8 9 8C7.69378 8 6.58254 7.16519 6.17071 6H2V4H6.17071Z"
  }));
},
    Nt = function Nt(_ref669) {
  var _ref669$color = _ref669.color,
      C = _ref669$color === void 0 ? "currentColor" : _ref669$color,
      _ref669$size = _ref669.size,
      e = _ref669$size === void 0 ? 24 : _ref669$size,
      l = _ref669.className,
      i = _objectWithoutProperties(_ref669, _excluded669);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.17071 18C6.58254 16.8348 7.69378 16 9 16C10.3062 16 11.4175 16.8348 11.8293 18H22V20H11.8293C11.4175 21.1652 10.3062 22 9 22C7.69378 22 6.58254 21.1652 6.17071 20H2V18H6.17071ZM12.1707 11C12.5825 9.83481 13.6938 9 15 9C16.3062 9 17.4175 9.83481 17.8293 11H22V13H17.8293C17.4175 14.1652 16.3062 15 15 15C13.6938 15 12.5825 14.1652 12.1707 13H2V11H12.1707ZM6.17071 4C6.58254 2.83481 7.69378 2 9 2C10.3062 2 11.4175 2.83481 11.8293 4H22V6H11.8293C11.4175 7.16519 10.3062 8 9 8C7.69378 8 6.58254 7.16519 6.17071 6H2V4H6.17071ZM9 6C9.55228 6 10 5.55228 10 5C10 4.44772 9.55228 4 9 4C8.44772 4 8 4.44772 8 5C8 5.55228 8.44772 6 9 6ZM15 13C15.5523 13 16 12.5523 16 12C16 11.4477 15.5523 11 15 11C14.4477 11 14 11.4477 14 12C14 12.5523 14.4477 13 15 13ZM9 20C9.55228 20 10 19.5523 10 19C10 18.4477 9.55228 18 9 18C8.44772 18 8 18.4477 8 19C8 19.5523 8.44772 20 9 20Z"
  }));
},
    ut = function ut(_ref670) {
  var _ref670$color = _ref670.color,
      C = _ref670$color === void 0 ? "currentColor" : _ref670$color,
      _ref670$size = _ref670.size,
      e = _ref670$size === void 0 ? 24 : _ref670$size,
      l = _ref670.className,
      i = _objectWithoutProperties(_ref670, _excluded670);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13.9999 18.9966H20.9999V20.9966H11.9999L8.00229 20.9991L1.51457 14.5113C1.12405 14.1208 1.12405 13.4877 1.51457 13.0971L12.1212 2.49053C12.5117 2.1 13.1449 2.1 13.5354 2.49053L21.3136 10.2687C21.7041 10.6592 21.7041 11.2924 21.3136 11.6829L13.9999 18.9966ZM15.6567 14.5113L19.1922 10.9758L12.8283 4.61185L9.29275 8.14738L15.6567 14.5113Z"
  }));
},
    Bt = function Bt(_ref671) {
  var _ref671$color = _ref671.color,
      C = _ref671$color === void 0 ? "currentColor" : _ref671$color,
      _ref671$size = _ref671.size,
      e = _ref671$size === void 0 ? 24 : _ref671$size,
      l = _ref671.className,
      i = _objectWithoutProperties(_ref671, _excluded671);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8.58564 8.85449L3.63589 13.8042L8.83021 18.9985L9.99985 18.9978V18.9966H11.1714L14.9496 15.2184L8.58564 8.85449ZM9.99985 7.44027L16.3638 13.8042L19.1922 10.9758L12.8283 4.61185L9.99985 7.44027ZM13.9999 18.9966H20.9999V20.9966H11.9999L8.00229 20.9991L1.51457 14.5113C1.12405 14.1208 1.12405 13.4877 1.51457 13.0971L12.1212 2.49053C12.5117 2.1 13.1449 2.1 13.5354 2.49053L21.3136 10.2687C21.7041 10.6592 21.7041 11.2924 21.3136 11.6829L13.9999 18.9966Z"
  }));
},
    ft = function ft(_ref672) {
  var _ref672$color = _ref672.color,
      C = _ref672$color === void 0 ? "currentColor" : _ref672$color,
      _ref672$size = _ref672.size,
      e = _ref672$size === void 0 ? 24 : _ref672$size,
      l = _ref672.className,
      i = _objectWithoutProperties(_ref672, _excluded672);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM11 15V17H13V15H11ZM11 7V13H13V7H11Z"
  }));
},
    Rt = function Rt(_ref673) {
  var _ref673$color = _ref673.color,
      C = _ref673$color === void 0 ? "currentColor" : _ref673$color,
      _ref673$size = _ref673.size,
      e = _ref673$size === void 0 ? 24 : _ref673$size,
      l = _ref673.className,
      i = _objectWithoutProperties(_ref673, _excluded673);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM11 15H13V17H11V15ZM11 7H13V13H11V7Z"
  }));
},
    zt = function zt(_ref674) {
  var _ref674$color = _ref674.color,
      C = _ref674$color === void 0 ? "currentColor" : _ref674$color,
      _ref674$size = _ref674.size,
      e = _ref674$size === void 0 ? 24 : _ref674$size,
      l = _ref674.className,
      i = _objectWithoutProperties(_ref674, _excluded674);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8.63007 7.75444C8.41531 7.95499 8.08524 7.97086 7.88803 7.97086H5.77723C5.16722 7.97086 4.80372 7.97086 4.55721 8.00429C4.42435 8.021 4.25973 8.08785 4.177 8.12128C4.14358 8.13715 4.14358 8.12128 4.16029 8.10456L8.97602 3.16516C8.99273 3.14845 9.00944 3.14845 8.99273 3.18187C8.9593 3.2646 8.89413 3.43089 8.87741 3.56376C8.84399 3.81277 8.84399 4.17878 8.84399 4.7938V7.00571C8.84399 7.20626 8.82728 7.53884 8.63007 7.75444ZM13.3129 21.9384C12.7531 21.5724 12.4556 21.0902 12.3403 20.7911C12.2216 20.5006 12.1601 20.1899 12.1589 19.8761C12.1603 18.4916 13.2813 17.3691 14.6658 17.3658C15.0778 17.3658 15.4079 17.6984 15.4079 18.1137C15.4097 18.383 15.2641 18.6318 15.0285 18.7622C14.9458 18.8123 14.8304 18.8457 14.7477 18.8625C14.6658 18.8792 14.3525 18.9126 14.2045 19.0446C14.0391 19.1783 13.9071 19.3939 13.9071 19.6271C13.9071 19.8761 14.0057 20.1092 14.1711 20.2755C14.4678 20.5747 14.8639 20.7409 15.2925 20.7409C15.8327 20.739 16.3499 20.5224 16.7303 20.1388C17.1107 19.7553 17.3231 19.2363 17.3206 18.6962C17.3206 17.6817 16.6446 16.7834 15.7538 16.3848C15.6218 16.318 15.4079 16.2678 15.2098 16.2177C15.046 16.184 14.881 16.1564 14.7151 16.135C14.0224 16.0514 12.291 15.5032 12.1748 13.9573C12.1748 13.9573 11.6642 16.2845 10.6414 16.9163C10.5428 16.9664 10.4108 17.0165 10.2621 17.05C10.1141 17.0834 9.94953 17.1001 9.89939 17.1001C8.23398 17.1995 6.46913 16.6673 5.24911 15.4038C5.24911 15.4038 4.42435 14.7219 3.99567 12.81C3.89706 12.3437 3.69902 11.5123 3.5837 10.7309C3.53357 10.4485 3.51685 10.2321 3.50098 10.0324C3.50098 9.21762 3.99567 8.66945 4.62239 8.58672H7.98663C8.56322 8.58672 8.89413 8.43631 9.10805 8.23659C9.38882 7.97086 9.45483 7.58815 9.45483 7.13941V3.73005V3.63144C9.53589 3.01558 10.0816 2.5 10.8888 2.5H11.2849C11.4495 2.5 11.6475 2.51671 11.8289 2.53343C11.9609 2.55014 12.0762 2.58356 12.2742 2.6337C13.2803 2.88272 13.4943 3.91388 13.4943 3.91388C13.4943 3.91388 15.3911 4.24646 16.3479 4.41276C17.2546 4.57905 19.4983 4.72862 19.9261 7.00655C20.9322 12.4273 20.3222 17.6817 20.2729 17.6817C19.5634 22.8033 15.3418 22.5534 15.3418 22.5534C14.6175 22.5681 13.9072 22.3528 13.3129 21.9384ZM15.9351 11.6292C15.9017 11.7128 15.8691 11.8122 15.8858 11.8616C15.9025 11.9117 15.936 11.9284 15.9686 11.9451C16.1666 12.0454 16.4958 12.0947 16.9747 12.1448C17.4526 12.195 17.7827 12.2284 17.9966 12.195C18.0301 12.195 18.0635 12.1783 18.0961 12.1281C18.1295 12.078 18.1128 11.9777 18.1128 11.895C18.0626 11.4462 17.6507 11.1137 17.1067 11.0468C16.5619 10.9967 16.1006 11.2139 15.9351 11.6292Z"
  }));
},
    Ft = function Ft(_ref675) {
  var _ref675$color = _ref675.color,
      C = _ref675$color === void 0 ? "currentColor" : _ref675$color,
      _ref675$size = _ref675.size,
      e = _ref675$size === void 0 ? 24 : _ref675$size,
      l = _ref675.className,
      i = _objectWithoutProperties(_ref675, _excluded675);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10.501 8.5C10.501 9.05228 10.0533 9.5 9.50098 9.5H6.00219C5.666 9.5 5.50098 9.76137 5.50098 10.0324C5.50098 11.3515 5.75509 12.4035 6.16482 13.2251C6.38075 13.6581 6.56374 13.8948 6.68785 14.0145C7.42307 14.7759 8.57381 15.1757 9.78018 15.1037C9.87471 15.098 9.97857 15.0401 10.1116 14.8962C10.2335 14.7644 10.3154 14.6277 10.3263 14.6029C10.7514 13.6301 11.8626 13.1589 12.8574 13.5297C13.5504 13.788 14.1339 13.9641 14.6703 14.0899C14.8658 14.1357 15.0452 14.1728 15.2562 14.2125C15.1787 14.1979 15.6579 14.2861 15.7742 14.3101C16.1144 14.3802 16.372 14.4561 16.6573 14.6005C17.3644 14.9585 17.9744 15.4655 18.4316 16.0752C18.4768 15.4836 18.5086 14.8073 18.5187 14.0487C18.5474 11.8917 18.3803 9.63789 17.9605 7.37573C17.8858 6.97793 17.7238 6.8136 17.2965 6.65764C17.1327 6.59785 16.9423 6.5482 16.7101 6.50321C16.5635 6.4748 16.0594 6.39296 16.0166 6.38528C16.002 6.38265 16.002 6.38265 16.0055 6.38322C15.7139 6.33254 15.3189 6.26362 14.8459 6.18094C14.4683 6.11492 14.2042 6.0687 13.6764 5.97628C13.2544 5.90233 13.2544 5.90233 13.1489 5.88383C12.4543 5.76205 11.8751 5.28347 11.6247 4.62426C11.6118 4.59043 11.6006 4.56115 11.5907 4.53583C11.4779 4.52134 11.2541 4.5 10.8888 4.5C10.6179 4.5 10.501 4.62426 10.501 4.96269V8.5ZM16.7303 20.1388C17.0834 19.7828 17.2917 19.3101 17.3178 18.812C17.3722 17.776 16.4941 16.3326 15.001 16.1783C14.3842 16.1146 13.4151 15.872 12.1589 15.4038C12.1589 15.4038 11.4583 17.007 9.89939 17.1001C8.23398 17.1995 6.46913 16.6673 5.24911 15.4038C5.24911 15.4038 3.50098 13.7647 3.50098 10.0324C3.50098 9.21762 3.79137 8.60963 4.14931 8.12783C5.10894 6.83612 6.65415 5.34816 8.28241 3.82392C9.00098 3.15126 9.70215 2.5 10.8888 2.5C12.9294 2.5 13.2094 3.16415 13.4943 3.91388C13.4943 3.91388 15.3911 4.24646 16.3479 4.41276C17.2546 4.57905 19.4983 4.72862 19.9261 7.00655C20.9322 12.4273 20.3843 16.8774 20.2729 17.6817C19.5634 22.8033 15.501 22.5534 15.3418 22.5534C13.283 22.5534 12.1636 21.1796 12.1589 19.8761C12.1559 19.0394 12.5664 18.2985 13.1973 17.8423C13.8061 17.4021 14.4359 17.3642 14.7236 17.3642C15.0285 17.3642 15.4111 17.6817 15.4111 18.117C15.4111 18.4869 15.1561 18.6916 15.0285 18.7622C14.8055 18.8855 13.9071 18.9355 13.9071 19.6271C13.9071 19.9438 14.2563 20.7409 15.2925 20.7409C15.8813 20.7409 16.3865 20.4855 16.7303 20.1388ZM14.9351 10.6292C15.1006 10.2139 15.5619 9.99668 16.1067 10.0468C16.6507 10.1137 17.0626 10.4462 17.1128 10.895C17.1128 10.9777 17.1295 11.078 17.0961 11.1281C17.0635 11.1783 17.0301 11.195 16.9966 11.195C16.7827 11.2284 16.4526 11.195 15.9747 11.1448C15.4958 11.0947 15.1666 11.0454 14.9686 10.9451C14.936 10.9284 14.9025 10.9117 14.8858 10.8616C14.8691 10.8122 14.9017 10.7128 14.9351 10.6292Z"
  }));
},
    St = function St(_ref676) {
  var _ref676$color = _ref676.color,
      C = _ref676$color === void 0 ? "currentColor" : _ref676$color,
      _ref676$size = _ref676.size,
      e = _ref676$size === void 0 ? 24 : _ref676$size,
      l = _ref676.className,
      i = _objectWithoutProperties(_ref676, _excluded676);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3.00488 3.00275H21.0049C21.5572 3.00275 22.0049 3.45046 22.0049 4.00275V20.0027C22.0049 20.555 21.5572 21.0027 21.0049 21.0027H3.00488C2.4526 21.0027 2.00488 20.555 2.00488 20.0027V4.00275C2.00488 3.45046 2.4526 3.00275 3.00488 3.00275ZM12.0049 9.00275H8.00488V11.0027H17.0049L12.0049 6.00275V9.00275ZM7.00488 13.0027L12.0049 18.0027V15.0027H16.0049V13.0027H7.00488Z"
  }));
},
    At = function At(_ref677) {
  var _ref677$color = _ref677.color,
      C = _ref677$color === void 0 ? "currentColor" : _ref677$color,
      _ref677$size = _ref677.size,
      e = _ref677$size === void 0 ? 24 : _ref677$size,
      l = _ref677.className,
      i = _objectWithoutProperties(_ref677, _excluded677);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4.00488 5.00275V19.0027H20.0049V5.00275H4.00488ZM3.00488 3.00275H21.0049C21.5572 3.00275 22.0049 3.45046 22.0049 4.00275V20.0027C22.0049 20.555 21.5572 21.0027 21.0049 21.0027H3.00488C2.4526 21.0027 2.00488 20.555 2.00488 20.0027V4.00275C2.00488 3.45046 2.4526 3.00275 3.00488 3.00275ZM12.0049 9.00275V6.00275L17.0049 11.0027H8.00488V9.00275H12.0049ZM7.00488 13.0027H16.0049V15.0027H12.0049V18.0027L7.00488 13.0027Z"
  }));
},
    kt = function kt(_ref678) {
  var _ref678$color = _ref678.color,
      C = _ref678$color === void 0 ? "currentColor" : _ref678$color,
      _ref678$size = _ref678.size,
      e = _ref678$size === void 0 ? 24 : _ref678$size,
      l = _ref678.className,
      i = _objectWithoutProperties(_ref678, _excluded678);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5.37833 4.51335C7.14264 2.95113 9.46301 2.00275 12.0049 2.00275C17.5277 2.00275 22.0049 6.4799 22.0049 12.0027C22.0049 14.1277 21.3421 16.0978 20.212 17.7177L17.5049 12.0027H20.0049C20.0049 7.58447 16.4232 4.00275 12.0049 4.00275C9.76058 4.00275 7.73213 4.92691 6.27932 6.41544L5.37833 4.51335ZM18.6314 19.4921C16.8671 21.0544 14.5468 22.0027 12.0049 22.0027C6.48204 22.0027 2.00488 17.5256 2.00488 12.0027C2.00488 9.8778 2.66767 7.90766 3.79778 6.28776L6.50488 12.0027H4.00488C4.00488 16.421 7.5866 20.0027 12.0049 20.0027C14.2492 20.0027 16.2776 19.0786 17.7304 17.59L18.6314 19.4921ZM13.0049 13.5383H16.0049V15.5383H13.0049V17.5383H11.0049V15.5383H8.00488V13.5383H11.0049V12.5383H8.00488V10.5383H10.5907L8.46935 8.41696L9.88356 7.00275L12.0049 9.12407L14.1262 7.00275L15.5404 8.41696L13.4191 10.5383H16.0049V12.5383H13.0049V13.5383Z"
  }));
},
    Pt = function Pt(_ref679) {
  var _ref679$color = _ref679.color,
      C = _ref679$color === void 0 ? "currentColor" : _ref679$color,
      _ref679$size = _ref679.size,
      e = _ref679$size === void 0 ? 24 : _ref679$size,
      l = _ref679.className,
      i = _objectWithoutProperties(_ref679, _excluded679);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19.3788 15.1057C20.9258 11.4421 19.5373 7.11431 16.0042 5.0745C13.4511 3.60046 10.4232 3.69365 8.03452 5.0556L7.04216 3.31879C10.028 1.61639 13.8128 1.4999 17.0042 3.34245C21.4949 5.93513 23.2139 11.4848 21.1217 16.112L22.4635 16.8867L18.2984 19.1008L18.1334 14.3867L19.3788 15.1057ZM4.62961 8.89968C3.08263 12.5633 4.47116 16.8911 8.00421 18.9309C10.5573 20.4049 13.5851 20.3118 15.9737 18.9499L16.9661 20.6867C13.9803 22.389 10.1956 22.5055 7.00421 20.663C2.51357 18.0703 0.794565 12.5206 2.88672 7.89342L1.54492 7.11873L5.70999 4.90463L5.87505 9.61873L4.62961 8.89968ZM13.0042 13.5382H16.0042V15.5382H13.0042V17.5382H11.0042V15.5382H8.00421V13.5382H11.0042V12.5382H8.00421V10.5382H10.59L8.46868 8.41692L9.88289 7.00271L12.0042 9.12403L14.1255 7.00271L15.5397 8.41692L13.4184 10.5382H16.0042V12.5382H13.0042V13.5382Z"
  }));
},
    Dt = function Dt(_ref680) {
  var _ref680$color = _ref680.color,
      C = _ref680$color === void 0 ? "currentColor" : _ref680$color,
      _ref680$size = _ref680.size,
      e = _ref680$size === void 0 ? 24 : _ref680$size,
      l = _ref680.className,
      i = _objectWithoutProperties(_ref680, _excluded680);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5.37833 4.51335C7.14264 2.95113 9.46301 2.00275 12.0049 2.00275C17.5277 2.00275 22.0049 6.4799 22.0049 12.0027C22.0049 14.1277 21.3421 16.0978 20.212 17.7177L17.5049 12.0027H20.0049C20.0049 7.58447 16.4232 4.00275 12.0049 4.00275C9.76058 4.00275 7.73213 4.92691 6.27932 6.41544L5.37833 4.51335ZM18.6314 19.4921C16.8671 21.0544 14.5468 22.0027 12.0049 22.0027C6.48204 22.0027 2.00488 17.5256 2.00488 12.0027C2.00488 9.8778 2.66767 7.90766 3.79778 6.28776L6.50488 12.0027H4.00488C4.00488 16.421 7.5866 20.0027 12.0049 20.0027C14.2492 20.0027 16.2776 19.0786 17.7304 17.59L18.6314 19.4921ZM8.50488 14.0027H14.0049C14.281 14.0027 14.5049 13.7789 14.5049 13.5027C14.5049 13.2266 14.281 13.0027 14.0049 13.0027H10.0049C8.62417 13.0027 7.50488 11.8835 7.50488 10.5027C7.50488 9.12203 8.62417 8.00275 10.0049 8.00275H11.0049V7.00275H13.0049V8.00275H15.5049V10.0027H10.0049C9.72874 10.0027 9.50488 10.2266 9.50488 10.5027C9.50488 10.7789 9.72874 11.0027 10.0049 11.0027H14.0049C15.3856 11.0027 16.5049 12.122 16.5049 13.5027C16.5049 14.8835 15.3856 16.0027 14.0049 16.0027H13.0049V17.0027H11.0049V16.0027H8.50488V14.0027Z"
  }));
},
    yt = function yt(_ref681) {
  var _ref681$color = _ref681.color,
      C = _ref681$color === void 0 ? "currentColor" : _ref681$color,
      _ref681$size = _ref681.size,
      e = _ref681$size === void 0 ? 24 : _ref681$size,
      l = _ref681.className,
      i = _objectWithoutProperties(_ref681, _excluded681);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19.3788 15.1057C20.9258 11.4421 19.5373 7.11431 16.0042 5.0745C13.4511 3.60046 10.4232 3.69365 8.03452 5.0556L7.04216 3.31879C10.028 1.61639 13.8128 1.4999 17.0042 3.34245C21.4949 5.93513 23.2139 11.4848 21.1217 16.112L22.4635 16.8867L18.2984 19.1008L18.1334 14.3867L19.3788 15.1057ZM4.62961 8.89968C3.08263 12.5633 4.47116 16.8911 8.00421 18.9309C10.5573 20.4049 13.5851 20.3118 15.9737 18.9499L16.9661 20.6867C13.9803 22.389 10.1956 22.5055 7.00421 20.663C2.51357 18.0703 0.794565 12.5206 2.88672 7.89342L1.54492 7.11873L5.70999 4.90463L5.87505 9.61873L4.62961 8.89968ZM8.50421 14.0027H14.0042C14.2804 14.0027 14.5042 13.7788 14.5042 13.5027C14.5042 13.2266 14.2804 13.0027 14.0042 13.0027H10.0042C8.6235 13.0027 7.50421 11.8834 7.50421 10.5027C7.50421 9.122 8.6235 8.00271 10.0042 8.00271H11.0042V7.00271H13.0042V8.00271H15.5042V10.0027H10.0042C9.72807 10.0027 9.50421 10.2266 9.50421 10.5027C9.50421 10.7788 9.72807 11.0027 10.0042 11.0027H14.0042C15.3849 11.0027 16.5042 12.122 16.5042 13.5027C16.5042 14.8834 15.3849 16.0027 14.0042 16.0027H13.0042V17.0027H11.0042V16.0027H8.50421V14.0027Z"
  }));
},
    bt = function bt(_ref682) {
  var _ref682$color = _ref682.color,
      C = _ref682$color === void 0 ? "currentColor" : _ref682$color,
      _ref682$size = _ref682.size,
      e = _ref682$size === void 0 ? 24 : _ref682$size,
      l = _ref682.className,
      i = _objectWithoutProperties(_ref682, _excluded682);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.0049 22.0027C6.48204 22.0027 2.00488 17.5256 2.00488 12.0027C2.00488 6.4799 6.48204 2.00275 12.0049 2.00275C17.5277 2.00275 22.0049 6.4799 22.0049 12.0027C22.0049 17.5256 17.5277 22.0027 12.0049 22.0027ZM12.0049 9.00275H8.00488V11.0027H17.0049L12.0049 6.00275V9.00275ZM7.00488 13.0027L12.0049 18.0027V15.0027H16.0049V13.0027H7.00488Z"
  }));
},
    Tt = function Tt(_ref683) {
  var _ref683$color = _ref683.color,
      C = _ref683$color === void 0 ? "currentColor" : _ref683$color,
      _ref683$size = _ref683.size,
      e = _ref683$size === void 0 ? 24 : _ref683$size,
      l = _ref683.className,
      i = _objectWithoutProperties(_ref683, _excluded683);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5.37833 4.51335C7.14264 2.95113 9.46301 2.00275 12.0049 2.00275C17.5277 2.00275 22.0049 6.4799 22.0049 12.0027C22.0049 14.1277 21.3421 16.0978 20.212 17.7177L17.5049 12.0027H20.0049C20.0049 7.58447 16.4232 4.00275 12.0049 4.00275C9.76058 4.00275 7.73213 4.92691 6.27932 6.41544L5.37833 4.51335ZM18.6314 19.4921C16.8671 21.0544 14.5468 22.0027 12.0049 22.0027C6.48204 22.0027 2.00488 17.5256 2.00488 12.0027C2.00488 9.8778 2.66767 7.90766 3.79778 6.28776L6.50488 12.0027H4.00488C4.00488 16.421 7.5866 20.0027 12.0049 20.0027C14.2492 20.0027 16.2776 19.0786 17.7304 17.59L18.6314 19.4921ZM13.4191 14.8312L10.5907 12.0027L7.76224 14.8312L6.34803 13.417L10.5907 9.17432L13.4191 12.0027L16.2475 9.17432L17.6617 10.5885L13.4191 14.8312Z"
  }));
},
    Ut = function Ut(_ref684) {
  var _ref684$color = _ref684.color,
      C = _ref684$color === void 0 ? "currentColor" : _ref684$color,
      _ref684$size = _ref684.size,
      e = _ref684$size === void 0 ? 24 : _ref684$size,
      l = _ref684.className,
      i = _objectWithoutProperties(_ref684, _excluded684);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19.3788 15.1057C20.9258 11.4421 19.5373 7.11431 16.0042 5.0745C13.4511 3.60046 10.4232 3.69365 8.03452 5.0556L7.04216 3.31879C10.028 1.61639 13.8128 1.4999 17.0042 3.34245C21.4949 5.93513 23.2139 11.4848 21.1217 16.112L22.4635 16.8867L18.2984 19.1008L18.1334 14.3867L19.3788 15.1057ZM4.62961 8.89968C3.08263 12.5633 4.47116 16.8911 8.00421 18.9309C10.5573 20.4049 13.5851 20.3118 15.9737 18.9499L16.9661 20.6867C13.9803 22.389 10.1956 22.5055 7.00421 20.663C2.51357 18.0703 0.794565 12.5206 2.88672 7.89342L1.54492 7.11873L5.70999 4.90463L5.87505 9.61873L4.62961 8.89968ZM13.4184 14.8311L10.59 12.0027L7.76157 14.8311L6.34736 13.4169L10.59 9.17428L13.4184 12.0027L16.2469 9.17428L17.6611 10.5885L13.4184 14.8311Z"
  }));
},
    Gt = function Gt(_ref685) {
  var _ref685$color = _ref685.color,
      C = _ref685$color === void 0 ? "currentColor" : _ref685$color,
      _ref685$size = _ref685.size,
      e = _ref685$size === void 0 ? 24 : _ref685$size,
      l = _ref685.className,
      i = _objectWithoutProperties(_ref685, _excluded685);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.0049 22.0027C6.48204 22.0027 2.00488 17.5256 2.00488 12.0027C2.00488 6.4799 6.48204 2.00275 12.0049 2.00275C17.5277 2.00275 22.0049 6.4799 22.0049 12.0027C22.0049 17.5256 17.5277 22.0027 12.0049 22.0027ZM12.0049 20.0027C16.4232 20.0027 20.0049 16.421 20.0049 12.0027C20.0049 7.58447 16.4232 4.00275 12.0049 4.00275C7.5866 4.00275 4.00488 7.58447 4.00488 12.0027C4.00488 16.421 7.5866 20.0027 12.0049 20.0027ZM7.00488 13.0027H16.0049V15.0027H12.0049V18.0027L7.00488 13.0027ZM12.0049 9.00275V6.00275L17.0049 11.0027H8.00488V9.00275H12.0049Z"
  }));
},
    It = function It(_ref686) {
  var _ref686$color = _ref686.color,
      C = _ref686$color === void 0 ? "currentColor" : _ref686$color,
      _ref686$size = _ref686.size,
      e = _ref686$size === void 0 ? 24 : _ref686$size,
      l = _ref686.className,
      i = _objectWithoutProperties(_ref686, _excluded686);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10 6V8H5V19H16V14H18V20C18 20.5523 17.5523 21 17 21H4C3.44772 21 3 20.5523 3 20V7C3 6.44772 3.44772 6 4 6H10ZM21 3V12L17.206 8.207L11.2071 14.2071L9.79289 12.7929L15.792 6.793L12 3H21Z"
  }));
},
    Wt = function Wt(_ref687) {
  var _ref687$color = _ref687.color,
      C = _ref687$color === void 0 ? "currentColor" : _ref687$color,
      _ref687$size = _ref687.size,
      e = _ref687$size === void 0 ? 24 : _ref687$size,
      l = _ref687.className,
      i = _objectWithoutProperties(_ref687, _excluded687);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10 6V8H5V19H16V14H18V20C18 20.5523 17.5523 21 17 21H4C3.44772 21 3 20.5523 3 20V7C3 6.44772 3.44772 6 4 6H10ZM21 3V11H19L18.9999 6.413L11.2071 14.2071L9.79289 12.7929L17.5849 5H13V3H21Z"
  }));
},
    Ot = function Ot(_ref688) {
  var _ref688$color = _ref688.color,
      C = _ref688$color === void 0 ? "currentColor" : _ref688$color,
      _ref688$size = _ref688.size,
      e = _ref688$size === void 0 ? 24 : _ref688$size,
      l = _ref688.className,
      i = _objectWithoutProperties(_ref688, _excluded688);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 7C11.4872 7 10.9925 7.07719 10.5269 7.21995C11.3954 7.61175 12 8.48527 12 9.5C12 10.8807 10.8807 12 9.5 12C8.48527 12 7.61175 11.3954 7.22057 10.5268C7.07719 10.9925 7 11.4872 7 12C7 14.7614 9.23858 17 12 17C14.7614 17 17 14.7614 17 12C17 9.23858 14.7614 7 12 7Z"
  }));
},
    Kt = function Kt(_ref689) {
  var _ref689$color = _ref689.color,
      C = _ref689$color === void 0 ? "currentColor" : _ref689$color,
      _ref689$size = _ref689.size,
      e = _ref689$size === void 0 ? 24 : _ref689$size,
      l = _ref689.className,
      i = _objectWithoutProperties(_ref689, _excluded689);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM12 7C14.7614 7 17 9.23858 17 12C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12C7 11.4872 7.07719 10.9925 7.22057 10.5268C7.61175 11.3954 8.48527 12 9.5 12C10.8807 12 12 10.8807 12 9.5C12 8.48527 11.3954 7.61175 10.5269 7.21995C10.9925 7.07719 11.4872 7 12 7Z"
  }));
},
    Qt = function Qt(_ref690) {
  var _ref690$color = _ref690.color,
      C = _ref690$color === void 0 ? "currentColor" : _ref690$color,
      _ref690$size = _ref690.size,
      e = _ref690$size === void 0 ? 24 : _ref690$size,
      l = _ref690.className,
      i = _objectWithoutProperties(_ref690, _excluded690);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10.1305 15.8421L9.34268 18.7821L7.41083 18.2645L8.1983 15.3256C7.00919 14.8876 5.91661 14.2501 4.96116 13.4536L2.80783 15.6069L1.39362 14.1927L3.54695 12.0394C2.35581 10.6105 1.52014 8.8749 1.17578 6.96843L2.07634 6.80469C4.86882 8.81573 8.29618 10.0003 12.0002 10.0003C15.7043 10.0003 19.1316 8.81573 21.9241 6.80469L22.8247 6.96843C22.4803 8.8749 21.6446 10.6105 20.4535 12.0394L22.6068 14.1927L21.1926 15.6069L19.0393 13.4536C18.0838 14.2501 16.9912 14.8876 15.8021 15.3256L16.5896 18.2645L14.6578 18.7821L13.87 15.8421C13.2623 15.9461 12.6376 16.0003 12.0002 16.0003C11.3629 16.0003 10.7381 15.9461 10.1305 15.8421Z"
  }));
},
    qt = function qt(_ref691) {
  var _ref691$color = _ref691.color,
      C = _ref691$color === void 0 ? "currentColor" : _ref691$color,
      _ref691$size = _ref691.size,
      e = _ref691$size === void 0 ? 24 : _ref691$size,
      l = _ref691.className,
      i = _objectWithoutProperties(_ref691, _excluded691);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9.34268 18.7819L7.41083 18.2642L8.1983 15.3254C7.00919 14.8874 5.91661 14.2498 4.96116 13.4534L2.80783 15.6067L1.39362 14.1925L3.54695 12.0392C2.35581 10.6103 1.52014 8.87466 1.17578 6.96818L3.14386 6.61035C3.90289 10.8126 7.57931 14.0001 12.0002 14.0001C16.4211 14.0001 20.0976 10.8126 20.8566 6.61035L22.8247 6.96818C22.4803 8.87466 21.6446 10.6103 20.4535 12.0392L22.6068 14.1925L21.1926 15.6067L19.0393 13.4534C18.0838 14.2498 16.9912 14.8874 15.8021 15.3254L16.5896 18.2642L14.6578 18.7819L13.87 15.8418C13.2623 15.9459 12.6376 16.0001 12.0002 16.0001C11.3629 16.0001 10.7381 15.9459 10.1305 15.8418L9.34268 18.7819Z"
  }));
},
    jt = function jt(_ref692) {
  var _ref692$color = _ref692.color,
      C = _ref692$color === void 0 ? "currentColor" : _ref692$color,
      _ref692$size = _ref692.size,
      e = _ref692$size === void 0 ? 24 : _ref692$size,
      l = _ref692.className,
      i = _objectWithoutProperties(_ref692, _excluded692);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M1.18164 12C2.12215 6.87976 6.60812 3 12.0003 3C17.3924 3 21.8784 6.87976 22.8189 12C21.8784 17.1202 17.3924 21 12.0003 21C6.60812 21 2.12215 17.1202 1.18164 12ZM12.0003 17C14.7617 17 17.0003 14.7614 17.0003 12C17.0003 9.23858 14.7617 7 12.0003 7C9.23884 7 7.00026 9.23858 7.00026 12C7.00026 14.7614 9.23884 17 12.0003 17ZM12.0003 15C10.3434 15 9.00026 13.6569 9.00026 12C9.00026 10.3431 10.3434 9 12.0003 9C13.6571 9 15.0003 10.3431 15.0003 12C15.0003 13.6569 13.6571 15 12.0003 15Z"
  }));
},
    Xt = function Xt(_ref693) {
  var _ref693$color = _ref693.color,
      C = _ref693$color === void 0 ? "currentColor" : _ref693$color,
      _ref693$size = _ref693.size,
      e = _ref693$size === void 0 ? 24 : _ref693$size,
      l = _ref693.className,
      i = _objectWithoutProperties(_ref693, _excluded693);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.0003 3C17.3924 3 21.8784 6.87976 22.8189 12C21.8784 17.1202 17.3924 21 12.0003 21C6.60812 21 2.12215 17.1202 1.18164 12C2.12215 6.87976 6.60812 3 12.0003 3ZM12.0003 19C16.2359 19 19.8603 16.052 20.7777 12C19.8603 7.94803 16.2359 5 12.0003 5C7.7646 5 4.14022 7.94803 3.22278 12C4.14022 16.052 7.7646 19 12.0003 19ZM12.0003 16.5C9.51498 16.5 7.50026 14.4853 7.50026 12C7.50026 9.51472 9.51498 7.5 12.0003 7.5C14.4855 7.5 16.5003 9.51472 16.5003 12C16.5003 14.4853 14.4855 16.5 12.0003 16.5ZM12.0003 14.5C13.381 14.5 14.5003 13.3807 14.5003 12C14.5003 10.6193 13.381 9.5 12.0003 9.5C10.6196 9.5 9.50026 10.6193 9.50026 12C9.50026 13.3807 10.6196 14.5 12.0003 14.5Z"
  }));
},
    Jt = function Jt(_ref694) {
  var _ref694$color = _ref694.color,
      C = _ref694$color === void 0 ? "currentColor" : _ref694$color,
      _ref694$size = _ref694.size,
      e = _ref694$size === void 0 ? 24 : _ref694$size,
      l = _ref694.className,
      i = _objectWithoutProperties(_ref694, _excluded694);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4.52047 5.93457L1.39366 2.80777L2.80788 1.39355L22.6069 21.1925L21.1927 22.6068L17.8827 19.2968C16.1814 20.3755 14.1638 21.0002 12.0003 21.0002C6.60812 21.0002 2.12215 17.1204 1.18164 12.0002C1.61832 9.62282 2.81932 7.5129 4.52047 5.93457ZM14.7577 16.1718L13.2937 14.7078C12.902 14.8952 12.4634 15.0002 12.0003 15.0002C10.3434 15.0002 9.00026 13.657 9.00026 12.0002C9.00026 11.537 9.10522 11.0984 9.29263 10.7067L7.82866 9.24277C7.30514 10.0332 7.00026 10.9811 7.00026 12.0002C7.00026 14.7616 9.23884 17.0002 12.0003 17.0002C13.0193 17.0002 13.9672 16.6953 14.7577 16.1718ZM7.97446 3.76015C9.22127 3.26959 10.5793 3.00016 12.0003 3.00016C17.3924 3.00016 21.8784 6.87992 22.8189 12.0002C22.5067 13.6998 21.8038 15.2628 20.8068 16.5925L16.947 12.7327C16.9821 12.4936 17.0003 12.249 17.0003 12.0002C17.0003 9.23873 14.7617 7.00016 12.0003 7.00016C11.7514 7.00016 11.5068 7.01833 11.2677 7.05343L7.97446 3.76015Z"
  }));
},
    Yt = function Yt(_ref695) {
  var _ref695$color = _ref695.color,
      C = _ref695$color === void 0 ? "currentColor" : _ref695$color,
      _ref695$size = _ref695.size,
      e = _ref695$size === void 0 ? 24 : _ref695$size,
      l = _ref695.className,
      i = _objectWithoutProperties(_ref695, _excluded695);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17.8827 19.2968C16.1814 20.3755 14.1638 21.0002 12.0003 21.0002C6.60812 21.0002 2.12215 17.1204 1.18164 12.0002C1.61832 9.62282 2.81932 7.5129 4.52047 5.93457L1.39366 2.80777L2.80788 1.39355L22.6069 21.1925L21.1927 22.6068L17.8827 19.2968ZM5.9356 7.3497C4.60673 8.56015 3.6378 10.1672 3.22278 12.0002C4.14022 16.0521 7.7646 19.0002 12.0003 19.0002C13.5997 19.0002 15.112 18.5798 16.4243 17.8384L14.396 15.8101C13.7023 16.2472 12.8808 16.5002 12.0003 16.5002C9.51498 16.5002 7.50026 14.4854 7.50026 12.0002C7.50026 11.1196 7.75317 10.2981 8.19031 9.60442L5.9356 7.3497ZM12.9139 14.328L9.67246 11.0866C9.5613 11.3696 9.50026 11.6777 9.50026 12.0002C9.50026 13.3809 10.6196 14.5002 12.0003 14.5002C12.3227 14.5002 12.6309 14.4391 12.9139 14.328ZM20.8068 16.5925L19.376 15.1617C20.0319 14.2268 20.5154 13.1586 20.7777 12.0002C19.8603 7.94818 16.2359 5.00016 12.0003 5.00016C11.1544 5.00016 10.3329 5.11773 9.55249 5.33818L7.97446 3.76015C9.22127 3.26959 10.5793 3.00016 12.0003 3.00016C17.3924 3.00016 21.8784 6.87992 22.8189 12.0002C22.5067 13.6998 21.8038 15.2628 20.8068 16.5925ZM11.7229 7.50857C11.8146 7.50299 11.9071 7.50016 12.0003 7.50016C14.4855 7.50016 16.5003 9.51488 16.5003 12.0002C16.5003 12.0933 16.4974 12.1858 16.4919 12.2775L11.7229 7.50857Z"
  }));
},
    _t = function _t(_ref696) {
  var _ref696$color = _ref696.color,
      C = _ref696$color === void 0 ? "currentColor" : _ref696$color,
      _ref696$size = _ref696.size,
      e = _ref696$size === void 0 ? 24 : _ref696$size,
      l = _ref696.className,
      i = _objectWithoutProperties(_ref696, _excluded696);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15.4024 21V14.0344H17.7347L18.0838 11.3265H15.4024V9.59765C15.4024 8.81364 15.62 8.27934 16.7443 8.27934L18.1783 8.27867V5.85676C17.9302 5.82382 17.0791 5.75006 16.0888 5.75006C14.0213 5.75006 12.606 7.01198 12.606 9.32952V11.3265H10.2677V14.0344H12.606V21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H15.4024Z"
  }));
},
    $t = function $t(_ref697) {
  var _ref697$color = _ref697.color,
      C = _ref697$color === void 0 ? "currentColor" : _ref697$color,
      _ref697$size = _ref697.size,
      e = _ref697$size === void 0 ? 24 : _ref697$size,
      l = _ref697.className,
      i = _objectWithoutProperties(_ref697, _excluded697);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14 19H19V5H5V19H12V14H10V12H12V10.3458C12 9.00855 12.1392 8.52362 12.4007 8.03473C12.6622 7.54584 13.0458 7.16216 13.5347 6.9007C13.9174 6.69604 14.3922 6.57252 15.2217 6.51954C15.551 6.49851 15.9771 6.52533 16.5 6.6V8.5H16C15.0827 8.5 14.7042 8.54332 14.4779 8.66433C14.3376 8.73939 14.2394 8.83758 14.1643 8.97793C14.0433 9.20418 14 9.42853 14 10.3458V12H16.5L16 14H14V19ZM4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3Z"
  }));
},
    eC = function eC(_ref698) {
  var _ref698$color = _ref698.color,
      C = _ref698$color === void 0 ? "currentColor" : _ref698$color,
      _ref698$size = _ref698.size,
      e = _ref698$size === void 0 ? 24 : _ref698$size,
      l = _ref698.className,
      i = _objectWithoutProperties(_ref698, _excluded698);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.001 2C6.47813 2 2.00098 6.47715 2.00098 12C2.00098 16.9913 5.65783 21.1283 10.4385 21.8785V14.8906H7.89941V12H10.4385V9.79688C10.4385 7.29063 11.9314 5.90625 14.2156 5.90625C15.3097 5.90625 16.4541 6.10156 16.4541 6.10156V8.5625H15.1931C13.9509 8.5625 13.5635 9.33334 13.5635 10.1242V12H16.3369L15.8936 14.8906H13.5635V21.8785C18.3441 21.1283 22.001 16.9913 22.001 12C22.001 6.47715 17.5238 2 12.001 2Z"
  }));
},
    tC = function tC(_ref699) {
  var _ref699$color = _ref699.color,
      C = _ref699$color === void 0 ? "currentColor" : _ref699$color,
      _ref699$size = _ref699.size,
      e = _ref699$size === void 0 ? 24 : _ref699$size,
      l = _ref699.className,
      i = _objectWithoutProperties(_ref699, _excluded699);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13.001 19.9381C16.9473 19.446 20.001 16.0796 20.001 12C20.001 7.58172 16.4193 4 12.001 4C7.5827 4 4.00098 7.58172 4.00098 12C4.00098 16.0796 7.05467 19.446 11.001 19.9381V14H9.00098V12H11.001V10.3458C11.001 9.00855 11.1402 8.52362 11.4017 8.03473C11.6631 7.54584 12.0468 7.16216 12.5357 6.9007C12.9184 6.69604 13.3931 6.57252 14.2227 6.51954C14.5519 6.49851 14.9781 6.52533 15.501 6.6V8.5H15.001C14.0837 8.5 13.7052 8.54332 13.4789 8.66433C13.3386 8.73939 13.2404 8.83758 13.1653 8.97793C13.0443 9.20418 13.001 9.42853 13.001 10.3458V12H15.501L15.001 14H13.001V19.9381ZM12.001 22C6.47813 22 2.00098 17.5228 2.00098 12C2.00098 6.47715 6.47813 2 12.001 2C17.5238 2 22.001 6.47715 22.001 12C22.001 17.5228 17.5238 22 12.001 22Z"
  }));
},
    CC = function CC(_ref700) {
  var _ref700$color = _ref700.color,
      C = _ref700$color === void 0 ? "currentColor" : _ref700$color,
      _ref700$size = _ref700.size,
      e = _ref700$size === void 0 ? 24 : _ref700$size,
      l = _ref700.className,
      i = _objectWithoutProperties(_ref700, _excluded700);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14 13.5H16.5L17.5 9.5H14V7.5C14 6.47062 14 5.5 16 5.5H17.5V2.1401C17.1743 2.09685 15.943 2 14.6429 2C11.9284 2 10 3.65686 10 6.69971V9.5H7V13.5H10V22H14V13.5Z"
  }));
},
    lC = function lC(_ref701) {
  var _ref701$color = _ref701.color,
      C = _ref701$color === void 0 ? "currentColor" : _ref701$color,
      _ref701$size = _ref701.size,
      e = _ref701$size === void 0 ? 24 : _ref701$size,
      l = _ref701.className,
      i = _objectWithoutProperties(_ref701, _excluded701);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13 9H17.5L17 11H13V20H11V11H7V9H11V7.12777C11 5.34473 11.1857 4.69816 11.5343 4.04631C11.8829 3.39446 12.3945 2.88288 13.0463 2.53427C13.6982 2.18565 14.3447 2 16.1278 2C16.6498 2 17.1072 2.05 17.5 2.15V4H16.1278C14.8041 4 14.401 4.07784 13.9895 4.29789C13.6862 4.46011 13.4601 4.68619 13.2979 4.98951C13.0778 5.40096 13 5.80407 13 7.12777V9Z"
  }));
},
    iC = function iC(_ref702) {
  var _ref702$color = _ref702.color,
      C = _ref702$color === void 0 ? "currentColor" : _ref702$color,
      _ref702$size = _ref702.size,
      e = _ref702$size === void 0 ? 24 : _ref702$size,
      l = _ref702.className,
      i = _objectWithoutProperties(_ref702, _excluded702);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 12H19V14H12V21H10V8C10 5.79086 11.7909 4 14 4H21V6H14C12.8954 6 12 6.89543 12 8V12ZM4.5 10C2.567 10 1 8.433 1 6.5C1 4.567 2.567 3 4.5 3C6.433 3 8 4.567 8 6.5C8 8.433 6.433 10 4.5 10ZM4.5 8C5.32843 8 6 7.32843 6 6.5C6 5.67157 5.32843 5 4.5 5C3.67157 5 3 5.67157 3 6.5C3 7.32843 3.67157 8 4.5 8Z"
  }));
},
    sC = function sC(_ref703) {
  var _ref703$color = _ref703.color,
      C = _ref703$color === void 0 ? "currentColor" : _ref703$color,
      _ref703$size = _ref703.size,
      e = _ref703$size === void 0 ? 24 : _ref703$size,
      l = _ref703.className,
      i = _objectWithoutProperties(_ref703, _excluded703);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 12H19V14H12V21H10V8C10 5.79086 11.7909 4 14 4H21V6H14C12.8954 6 12 6.89543 12 8V12ZM4.5 10C2.567 10 1 8.433 1 6.5C1 4.567 2.567 3 4.5 3C6.433 3 8 4.567 8 6.5C8 8.433 6.433 10 4.5 10ZM4.5 8C5.32843 8 6 7.32843 6 6.5C6 5.67157 5.32843 5 4.5 5C3.67157 5 3 5.67157 3 6.5C3 7.32843 3.67157 8 4.5 8Z"
  }));
},
    rC = function rC(_ref704) {
  var _ref704$color = _ref704.color,
      C = _ref704$color === void 0 ? "currentColor" : _ref704$color,
      _ref704$size = _ref704.size,
      e = _ref704$size === void 0 ? 24 : _ref704$size,
      l = _ref704.className,
      i = _objectWithoutProperties(_ref704, _excluded704);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.45455 19L2 22.5V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.45455ZM11 13V15H13V13H11ZM11 7V12H13V7H11Z"
  }));
},
    cC = function cC(_ref705) {
  var _ref705$color = _ref705.color,
      C = _ref705$color === void 0 ? "currentColor" : _ref705$color,
      _ref705$size = _ref705.size,
      e = _ref705$size === void 0 ? 24 : _ref705$size,
      l = _ref705.className,
      i = _objectWithoutProperties(_ref705, _excluded705);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.45455 19L2 22.5V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.45455ZM4 18.3851L5.76282 17H20V5H4V18.3851ZM11 13H13V15H11V13ZM11 7H13V12H11V7Z"
  }));
},
    oC = function oC(_ref706) {
  var _ref706$color = _ref706.color,
      C = _ref706$color === void 0 ? "currentColor" : _ref706$color,
      _ref706$size = _ref706.size,
      e = _ref706$size === void 0 ? 24 : _ref706$size,
      l = _ref706.className,
      i = _objectWithoutProperties(_ref706, _excluded706);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 9H9C9.55228 9 10 8.55228 10 8V2H20.0017C20.5531 2 21 2.45531 21 2.9918V21.0082C21 21.556 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5511 3 20.9925V9ZM3 7L8 2.00318V7H3Z"
  }));
},
    aC = function aC(_ref707) {
  var _ref707$color = _ref707.color,
      C = _ref707$color === void 0 ? "currentColor" : _ref707$color,
      _ref707$size = _ref707.size,
      e = _ref707$size === void 0 ? 24 : _ref707$size,
      l = _ref707.className,
      i = _objectWithoutProperties(_ref707, _excluded707);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 8L9.00319 2H19.9978C20.5513 2 21 2.45531 21 2.9918V21.0082C21 21.556 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5501 3 20.9932V8ZM10 4V9H5V20H19V4H10Z"
  }));
},
    nC = function nC(_ref708) {
  var _ref708$color = _ref708.color,
      C = _ref708$color === void 0 ? "currentColor" : _ref708$color,
      _ref708$size = _ref708.size,
      e = _ref708$size === void 0 ? 24 : _ref708$size,
      l = _ref708.className,
      i = _objectWithoutProperties(_ref708, _excluded708);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 9V20.9925C21 21.5511 20.5552 22 20.0066 22H3.9934C3.44495 22 3 21.556 3 21.0082V2.9918C3 2.45531 3.44694 2 3.99826 2H14V8C14 8.55228 14.4477 9 15 9H21ZM21 7H16V2.00318L21 7Z"
  }));
},
    mC = function mC(_ref709) {
  var _ref709$color = _ref709.color,
      C = _ref709$color === void 0 ? "currentColor" : _ref709$color,
      _ref709$size = _ref709.size,
      e = _ref709$size === void 0 ? 24 : _ref709$size,
      l = _ref709.className,
      i = _objectWithoutProperties(_ref709, _excluded709);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 8V20.9932C21 21.5501 20.5552 22 20.0066 22H3.9934C3.44495 22 3 21.556 3 21.0082V2.9918C3 2.45531 3.4487 2 4.00221 2H14.9968L21 8ZM19 9H14V4H5V20H19V9Z"
  }));
},
    wC = function wC(_ref710) {
  var _ref710$color = _ref710.color,
      C = _ref710$color === void 0 ? "currentColor" : _ref710$color,
      _ref710$size = _ref710.size,
      e = _ref710$size === void 0 ? 24 : _ref710$size,
      l = _ref710.className,
      i = _objectWithoutProperties(_ref710, _excluded710);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 15H14V22H3.99826C3.44694 22 3 21.5447 3 21.0082V2.9918C3 2.44405 3.44495 2 3.9934 2H20.0066C20.5552 2 21 2.44892 21 3.00748V15ZM21 17L16 21.9968V17H21Z"
  }));
},
    LC = function LC(_ref711) {
  var _ref711$color = _ref711.color,
      C = _ref711$color === void 0 ? "currentColor" : _ref711$color,
      _ref711$size = _ref711.size,
      e = _ref711$size === void 0 ? 24 : _ref711$size,
      l = _ref711.className,
      i = _objectWithoutProperties(_ref711, _excluded711);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 16L14.9968 22H4C3.44772 22 3 21.5523 3 21V3C3 2.44772 3.44772 2 4 2H20C20.5523 2 21 2.44772 21 3V16ZM19 15V4H5V20H14V15H19Z"
  }));
},
    hC = function hC(_ref712) {
  var _ref712$color = _ref712.color,
      C = _ref712$color === void 0 ? "currentColor" : _ref712$color,
      _ref712$size = _ref712.size,
      e = _ref712$size === void 0 ? 24 : _ref712$size,
      l = _ref712.className,
      i = _objectWithoutProperties(_ref712, _excluded712);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16 2L21 7V21.0082C21 21.556 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918C3 2.44405 3.44495 2 3.9934 2H16ZM11 11H8V13H11V16H13V13H16V11H13V8H11V11Z"
  }));
},
    HC = function HC(_ref713) {
  var _ref713$color = _ref713.color,
      C = _ref713$color === void 0 ? "currentColor" : _ref713$color,
      _ref713$size = _ref713.size,
      e = _ref713$size === void 0 ? 24 : _ref713$size,
      l = _ref713.className,
      i = _objectWithoutProperties(_ref713, _excluded713);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15 4H5V20H19V8H15V4ZM3 2.9918C3 2.44405 3.44749 2 3.9985 2H16L20.9997 7L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918ZM11 11V8H13V11H16V13H13V16H11V13H8V11H11Z"
  }));
},
    VC = function VC(_ref714) {
  var _ref714$color = _ref714.color,
      C = _ref714$color === void 0 ? "currentColor" : _ref714$color,
      _ref714$size = _ref714.size,
      e = _ref714$size === void 0 ? 24 : _ref714$size,
      l = _ref714.className,
      i = _objectWithoutProperties(_ref714, _excluded714);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16 2L21 7V21.0082C21 21.556 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918C3 2.44405 3.44495 2 3.9934 2H16ZM12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12H12V8Z"
  }));
},
    gC = function gC(_ref715) {
  var _ref715$color = _ref715.color,
      C = _ref715$color === void 0 ? "currentColor" : _ref715$color,
      _ref715$size = _ref715.size,
      e = _ref715$size === void 0 ? 24 : _ref715$size,
      l = _ref715.className,
      i = _objectWithoutProperties(_ref715, _excluded715);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15 4H5V20H19V8H15V4ZM3 2.9918C3 2.44405 3.44749 2 3.9985 2H16L20.9997 7L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918ZM12 8V12H16C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8Z"
  }));
},
    MC = function MC(_ref716) {
  var _ref716$color = _ref716.color,
      C = _ref716$color === void 0 ? "currentColor" : _ref716$color,
      _ref716$size = _ref716.size,
      e = _ref716$size === void 0 ? 24 : _ref716$size,
      l = _ref716.className,
      i = _objectWithoutProperties(_ref716, _excluded716);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16 2L21 7V21.0082C21 21.556 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918C3 2.44405 3.44495 2 3.9934 2H16ZM11 7V17H13V7H11ZM15 11V17H17V11H15ZM7 13V17H9V13H7Z"
  }));
},
    ZC = function ZC(_ref717) {
  var _ref717$color = _ref717.color,
      C = _ref717$color === void 0 ? "currentColor" : _ref717$color,
      _ref717$size = _ref717.size,
      e = _ref717$size === void 0 ? 24 : _ref717$size,
      l = _ref717.className,
      i = _objectWithoutProperties(_ref717, _excluded717);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11 7H13V17H11V7ZM15 11H17V17H15V11ZM7 13H9V17H7V13ZM15 4H5V20H19V8H15V4ZM3 2.9918C3 2.44405 3.44749 2 3.9985 2H16L20.9997 7L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918Z"
  }));
},
    xC = function xC(_ref718) {
  var _ref718$color = _ref718.color,
      C = _ref718$color === void 0 ? "currentColor" : _ref718$color,
      _ref718$size = _ref718.size,
      e = _ref718$size === void 0 ? 24 : _ref718$size,
      l = _ref718.className,
      i = _objectWithoutProperties(_ref718, _excluded718);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14.9968 2L21 8L21.0012 12.2606C20.0501 11.4722 18.8302 11 17.5 11L17.2788 11.0044C14.784 11.103 12.7164 12.8635 12.1523 15.2093L12.136 15.283L12.1068 15.3024C10.8223 16.1634 10 17.6255 10 19.25C10 20.273 10.3242 21.2231 10.8771 22.0006L3.9934 22C3.48412 22 3.06409 21.6171 3.00669 21.1239L3 21.0082V2.9918C3 2.49363 3.38689 2.06546 3.88533 2.00683L4.00221 2H14.9968ZM17.5 13C19.433 13 21 14.567 21 16.5L20.9985 16.6033C22.1531 16.9285 23 17.9903 23 19.25C23 20.7125 21.8583 21.9084 20.4175 21.995L20.25 22H14.75L14.5825 21.995C13.1417 21.9084 12 20.7125 12 19.25C12 17.99 12.8474 16.9279 14.0034 16.6025L14 16.5C14 14.567 15.567 13 17.5 13Z"
  }));
},
    vC = function vC(_ref719) {
  var _ref719$color = _ref719.color,
      C = _ref719$color === void 0 ? "currentColor" : _ref719$color,
      _ref719$size = _ref719.size,
      e = _ref719$size === void 0 ? 24 : _ref719$size,
      l = _ref719.className,
      i = _objectWithoutProperties(_ref719, _excluded719);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14.9968 2L21 8L21.0012 12.2606C20.4221 11.7806 19.7434 11.4178 19.0008 11.2074L19 9H14V4H5V20L10.0591 20.0009C10.1761 20.7365 10.4622 21.4172 10.8771 22.0006L3.9934 22C3.48412 22 3.06409 21.6171 3.00669 21.1239L3 21.0082V2.9918C3 2.49363 3.38689 2.06546 3.88533 2.00683L4.00221 2H14.9968ZM17.5 13C19.433 13 21 14.567 21 16.5L20.9985 16.6033C22.1531 16.9285 23 17.9903 23 19.25C23 20.7125 21.8583 21.9084 20.4175 21.995L20.25 22H14.75L14.5825 21.995C13.1417 21.9084 12 20.7125 12 19.25C12 17.99 12.8474 16.9279 14.0034 16.6025L14 16.5C14 14.567 15.567 13 17.5 13ZM17.5 15C16.769 15 16.1602 15.5229 16.027 16.215L16.0069 16.3555L16 16.5V18.12L14.5559 18.5256C14.1558 18.6328 13.9183 19.044 14.0256 19.4441C14.105 19.7405 14.3512 19.9476 14.6362 19.9915L14.7446 20.0002H20.2554C20.5846 19.998 20.8851 19.7775 20.9744 19.4441C21.0817 19.044 20.8442 18.6328 20.4441 18.5256L19.4322 18.2432L19 18.12V16.5L18.9931 16.3555C18.9204 15.5949 18.2797 15 17.5 15Z"
  }));
},
    dC = function dC(_ref720) {
  var _ref720$color = _ref720.color,
      C = _ref720$color === void 0 ? "currentColor" : _ref720$color,
      _ref720$size = _ref720.size,
      e = _ref720$size === void 0 ? 24 : _ref720$size,
      l = _ref720.className,
      i = _objectWithoutProperties(_ref720, _excluded720);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16 2L21 7V21.0082C21 21.556 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918C3 2.44405 3.44495 2 3.9934 2H16ZM17.6569 12L14.1213 8.46447L12.7071 9.87868L14.8284 12L12.7071 14.1213L14.1213 15.5355L17.6569 12ZM6.34315 12L9.87868 15.5355L11.2929 14.1213L9.17157 12L11.2929 9.87868L9.87868 8.46447L6.34315 12Z"
  }));
},
    pC = function pC(_ref721) {
  var _ref721$color = _ref721.color,
      C = _ref721$color === void 0 ? "currentColor" : _ref721$color,
      _ref721$size = _ref721.size,
      e = _ref721$size === void 0 ? 24 : _ref721$size,
      l = _ref721.className,
      i = _objectWithoutProperties(_ref721, _excluded721);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15 4H5V20H19V8H15V4ZM3 2.9918C3 2.44405 3.44749 2 3.9985 2H16L20.9997 7L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918ZM17.6569 12L14.1213 15.5355L12.7071 14.1213L14.8284 12L12.7071 9.87868L14.1213 8.46447L17.6569 12ZM6.34315 12L9.87868 8.46447L11.2929 9.87868L9.17157 12L11.2929 14.1213L9.87868 15.5355L6.34315 12Z"
  }));
},
    EC = function EC(_ref722) {
  var _ref722$color = _ref722.color,
      C = _ref722$color === void 0 ? "currentColor" : _ref722$color,
      _ref722$size = _ref722.size,
      e = _ref722$size === void 0 ? 24 : _ref722$size,
      l = _ref722.className,
      i = _objectWithoutProperties(_ref722, _excluded722);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.9998 6V3C6.9998 2.44772 7.44752 2 7.9998 2H19.9998C20.5521 2 20.9998 2.44772 20.9998 3V17C20.9998 17.5523 20.5521 18 19.9998 18H16.9998V20.9991C16.9998 21.5519 16.5499 22 15.993 22H4.00666C3.45059 22 3 21.5554 3 20.9991L3.0026 7.00087C3.0027 6.44811 3.45264 6 4.00942 6H6.9998ZM8.9998 6H16.9998V16H18.9998V4H8.9998V6ZM6.9998 11V13H12.9998V11H6.9998ZM6.9998 15V17H12.9998V15H6.9998Z"
  }));
},
    NC = function NC(_ref723) {
  var _ref723$color = _ref723.color,
      C = _ref723$color === void 0 ? "currentColor" : _ref723$color,
      _ref723$size = _ref723.size,
      e = _ref723$size === void 0 ? 24 : _ref723$size,
      l = _ref723.className,
      i = _objectWithoutProperties(_ref723, _excluded723);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.9998 6V3C6.9998 2.44772 7.44752 2 7.9998 2H19.9998C20.5521 2 20.9998 2.44772 20.9998 3V17C20.9998 17.5523 20.5521 18 19.9998 18H16.9998V20.9991C16.9998 21.5519 16.5499 22 15.993 22H4.00666C3.45059 22 3 21.5554 3 20.9991L3.0026 7.00087C3.0027 6.44811 3.45264 6 4.00942 6H6.9998ZM5.00242 8L5.00019 20H14.9998V8H5.00242ZM8.9998 6H16.9998V16H18.9998V4H8.9998V6ZM7 11H13V13H7V11ZM7 15H13V17H7V15Z"
  }));
},
    uC = function uC(_ref724) {
  var _ref724$color = _ref724.color,
      C = _ref724$color === void 0 ? "currentColor" : _ref724$color,
      _ref724$size = _ref724.size,
      e = _ref724$size === void 0 ? 24 : _ref724$size,
      l = _ref724.className,
      i = _objectWithoutProperties(_ref724, _excluded724);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.9998 6V3C6.9998 2.44772 7.44752 2 7.9998 2H19.9998C20.5521 2 20.9998 2.44772 20.9998 3V17C20.9998 17.5523 20.5521 18 19.9998 18H16.9998V20.9991C16.9998 21.5519 16.5499 22 15.993 22H4.00666C3.45059 22 3 21.5554 3 20.9991L3.0026 7.00087C3.0027 6.44811 3.45264 6 4.00942 6H6.9998ZM8.9998 6H16.9998V16H18.9998V4H8.9998V6Z"
  }));
},
    BC = function BC(_ref725) {
  var _ref725$color = _ref725.color,
      C = _ref725$color === void 0 ? "currentColor" : _ref725$color,
      _ref725$size = _ref725.size,
      e = _ref725$size === void 0 ? 24 : _ref725$size,
      l = _ref725.className,
      i = _objectWithoutProperties(_ref725, _excluded725);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.9998 6V3C6.9998 2.44772 7.44752 2 7.9998 2H19.9998C20.5521 2 20.9998 2.44772 20.9998 3V17C20.9998 17.5523 20.5521 18 19.9998 18H16.9998V20.9991C16.9998 21.5519 16.5499 22 15.993 22H4.00666C3.45059 22 3 21.5554 3 20.9991L3.0026 7.00087C3.0027 6.44811 3.45264 6 4.00942 6H6.9998ZM5.00242 8L5.00019 20H14.9998V8H5.00242ZM8.9998 6H16.9998V16H18.9998V4H8.9998V6Z"
  }));
},
    fC = function fC(_ref726) {
  var _ref726$color = _ref726.color,
      C = _ref726$color === void 0 ? "currentColor" : _ref726$color,
      _ref726$size = _ref726.size,
      e = _ref726$size === void 0 ? 24 : _ref726$size,
      l = _ref726.className,
      i = _objectWithoutProperties(_ref726, _excluded726);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 14L7 16.5L10 13L13 17L15 14.5L18 15L15 12L13 14.5L10 9.5L6.5 13.25L3 10V2.9918C3 2.45531 3.44694 2 3.99826 2H14V8C14 8.55228 14.4477 9 15 9H21V20.9925C21 21.5511 20.5552 22 20.0066 22H3.9934C3.44495 22 3 21.556 3 21.0082V14ZM21 7H16V2.00318L21 7Z"
  }));
},
    RC = function RC(_ref727) {
  var _ref727$color = _ref727.color,
      C = _ref727$color === void 0 ? "currentColor" : _ref727$color,
      _ref727$size = _ref727.size,
      e = _ref727$size === void 0 ? 24 : _ref727$size,
      l = _ref727.className,
      i = _objectWithoutProperties(_ref727, _excluded727);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19 9H14V4H5V11.8571L6.5 13.25L10 9.5L13 14.5L15 12L18 15L15 14.5L13 17L10 13L7 16.5L5 15.25V20H19V9ZM21 8V20.9932C21 21.5501 20.5552 22 20.0066 22H3.9934C3.44495 22 3 21.556 3 21.0082V2.9918C3 2.45531 3.4487 2 4.00221 2H14.9968L21 8Z"
  }));
},
    zC = function zC(_ref728) {
  var _ref728$color = _ref728.color,
      C = _ref728$color === void 0 ? "currentColor" : _ref728$color,
      _ref728$size = _ref728.size,
      e = _ref728$size === void 0 ? 24 : _ref728$size,
      l = _ref728.className,
      i = _objectWithoutProperties(_ref728, _excluded728);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16 2L21 7V21.0082C21 21.556 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918C3 2.44405 3.44495 2 3.9934 2H16ZM13 12V8H11V12H8L12 16L16 12H13Z"
  }));
},
    FC = function FC(_ref729) {
  var _ref729$color = _ref729.color,
      C = _ref729$color === void 0 ? "currentColor" : _ref729$color,
      _ref729$size = _ref729.size,
      e = _ref729$size === void 0 ? 24 : _ref729$size,
      l = _ref729.className,
      i = _objectWithoutProperties(_ref729, _excluded729);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13 12H16L12 16L8 12H11V8H13V12ZM15 4H5V20H19V8H15V4ZM3 2.9918C3 2.44405 3.44749 2 3.9985 2H16L20.9997 7L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918Z"
  }));
},
    SC = function SC(_ref730) {
  var _ref730$color = _ref730.color,
      C = _ref730$color === void 0 ? "currentColor" : _ref730$color,
      _ref730$size = _ref730.size,
      e = _ref730$size === void 0 ? 24 : _ref730$size,
      l = _ref730.className,
      i = _objectWithoutProperties(_ref730, _excluded730);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 15.2426V21.0082C21 21.556 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5511 3 20.9925V9H9C9.55228 9 10 8.55228 10 8V2H20.0017C20.5531 2 21 2.45531 21 2.9918V6.75736L12.0012 15.7562L11.995 19.995L16.2414 20.0012L21 15.2426ZM21.7782 8.80761L23.1924 10.2218L15.4142 18L13.9979 17.9979L14 16.5858L21.7782 8.80761ZM3 7L8 2.00318V7H3Z"
  }));
},
    AC = function AC(_ref731) {
  var _ref731$color = _ref731.color,
      C = _ref731$color === void 0 ? "currentColor" : _ref731$color,
      _ref731$size = _ref731.size,
      e = _ref731$size === void 0 ? 24 : _ref731$size,
      l = _ref731.className,
      i = _objectWithoutProperties(_ref731, _excluded731);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 6.75736L19 8.75736V4H10V9H5V20H19V17.2426L21 15.2426V21.0082C21 21.556 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5501 3 20.9932V8L9.00319 2H19.9978C20.5513 2 21 2.45531 21 2.9918V6.75736ZM21.7782 8.80761L23.1924 10.2218L15.4142 18L13.9979 17.9979L14 16.5858L21.7782 8.80761Z"
  }));
},
    kC = function kC(_ref732) {
  var _ref732$color = _ref732.color,
      C = _ref732$color === void 0 ? "currentColor" : _ref732$color,
      _ref732$size = _ref732.size,
      e = _ref732$size === void 0 ? 24 : _ref732$size,
      l = _ref732.className,
      i = _objectWithoutProperties(_ref732, _excluded732);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2.85858 2.87732L15.4293 1.0815C15.7027 1.04245 15.9559 1.2324 15.995 1.50577C15.9983 1.52919 16 1.55282 16 1.57648V22.4235C16 22.6996 15.7761 22.9235 15.5 22.9235C15.4763 22.9235 15.4527 22.9218 15.4293 22.9184L2.85858 21.1226C2.36593 21.0522 2 20.6303 2 20.1327V3.86727C2 3.36962 2.36593 2.9477 2.85858 2.87732ZM17 2.99997H21C21.5523 2.99997 22 3.44769 22 3.99997V20C22 20.5523 21.5523 21 21 21H17V2.99997ZM10.2 12L13 7.99997H10.6L9 10.2857L7.39999 7.99997H5L7.8 12L5 16H7.39999L9 13.7143L10.6 16H13L10.2 12Z"
  }));
},
    PC = function PC(_ref733) {
  var _ref733$color = _ref733.color,
      C = _ref733$color === void 0 ? "currentColor" : _ref733$color,
      _ref733$size = _ref733.size,
      e = _ref733$size === void 0 ? 24 : _ref733$size,
      l = _ref733.className,
      i = _objectWithoutProperties(_ref733, _excluded733);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2.85858 2.87732L15.4293 1.0815C15.7027 1.04245 15.9559 1.2324 15.995 1.50577C15.9983 1.52919 16 1.55282 16 1.57648V22.4235C16 22.6996 15.7761 22.9235 15.5 22.9235C15.4763 22.9235 15.4527 22.9218 15.4293 22.9184L2.85858 21.1226C2.36593 21.0522 2 20.6303 2 20.1327V3.86727C2 3.36962 2.36593 2.9477 2.85858 2.87732ZM4 4.73457V19.2654L14 20.694V3.30599L4 4.73457ZM17 19H20V4.99997H17V2.99997H21C21.5523 2.99997 22 3.44769 22 3.99997V20C22 20.5523 21.5523 21 21 21H17V19ZM10.2 12L13 16H10.6L9 13.7143L7.39999 16H5L7.8 12L5 7.99997H7.39999L9 10.2857L10.6 7.99997H13L10.2 12Z"
  }));
},
    DC = function DC(_ref734) {
  var _ref734$color = _ref734.color,
      C = _ref734$color === void 0 ? "currentColor" : _ref734$color,
      _ref734$size = _ref734.size,
      e = _ref734$size === void 0 ? 24 : _ref734$size,
      l = _ref734.className,
      i = _objectWithoutProperties(_ref734, _excluded734);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16 2L21 7V21.0082C21 21.556 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918C3 2.44405 3.44495 2 3.9934 2H16ZM13.2 12L16 8H13.6L12 10.2857L10.4 8H8L10.8 12L8 16H10.4L12 13.7143L13.6 16H16L13.2 12Z"
  }));
},
    yC = function yC(_ref735) {
  var _ref735$color = _ref735.color,
      C = _ref735$color === void 0 ? "currentColor" : _ref735$color,
      _ref735$size = _ref735.size,
      e = _ref735$size === void 0 ? 24 : _ref735$size,
      l = _ref735.className,
      i = _objectWithoutProperties(_ref735, _excluded735);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13.2 12L16 16H13.6L12 13.7143L10.4 16H8L10.8 12L8 8H10.4L12 10.2857L13.6 8H15V4H5V20H19V8H16L13.2 12ZM3 2.9918C3 2.44405 3.44749 2 3.9985 2H16L20.9997 7L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918Z"
  }));
},
    bC = function bC(_ref736) {
  var _ref736$color = _ref736.color,
      C = _ref736$color === void 0 ? "currentColor" : _ref736$color,
      _ref736$size = _ref736.size,
      e = _ref736$size === void 0 ? 24 : _ref736$size,
      l = _ref736.className,
      i = _objectWithoutProperties(_ref736, _excluded736);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 8L9.00319 2H19.9978C20.5513 2 21 2.45531 21 2.9918V21.0082C21 21.556 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5501 3 20.9932V8ZM10 3.5L4.5 9H10V3.5Z"
  }));
},
    TC = function TC(_ref737) {
  var _ref737$color = _ref737.color,
      C = _ref737$color === void 0 ? "currentColor" : _ref737$color,
      _ref737$size = _ref737.size,
      e = _ref737$size === void 0 ? 24 : _ref737$size,
      l = _ref737.className,
      i = _objectWithoutProperties(_ref737, _excluded737);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 11.6736C20.0907 11.2417 19.0736 11 18 11C14.134 11 11 14.134 11 18C11 19.4872 11.4638 20.8662 12.2547 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918C3 2.44405 3.44495 2 3.9934 2H16L21 7V11.6736ZM18 23C15.2386 23 13 20.7614 13 18C13 15.2386 15.2386 13 18 13C20.7614 13 23 15.2386 23 18C23 20.7614 20.7614 23 18 23ZM16.7066 20.7076C17.0982 20.895 17.5369 21 18 21C19.6569 21 21 19.6569 21 18C21 17.5369 20.895 17.0982 20.7076 16.7066L16.7066 20.7076ZM15.2924 19.2934L19.2934 15.2924C18.9018 15.105 18.4631 15 18 15C16.3431 15 15 16.3431 15 18C15 18.4631 15.105 18.9018 15.2924 19.2934Z"
  }));
},
    UC = function UC(_ref738) {
  var _ref738$color = _ref738.color,
      C = _ref738$color === void 0 ? "currentColor" : _ref738$color,
      _ref738$size = _ref738.size,
      e = _ref738$size === void 0 ? 24 : _ref738$size,
      l = _ref738.className,
      i = _objectWithoutProperties(_ref738, _excluded738);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11.2899 20C11.5049 20.7224 11.8334 21.396 12.2547 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918C3 2.44405 3.44749 2 3.9985 2H16L20.9998 7V11.6735C20.3781 11.3782 19.7061 11.1719 19 11.0709V8H15V4H5V20H11.2899ZM18 23C15.2386 23 13 20.7614 13 18C13 15.2386 15.2386 13 18 13C20.7614 13 23 15.2386 23 18C23 20.7614 20.7614 23 18 23ZM16.7066 20.7076C17.0982 20.895 17.5369 21 18 21C19.6569 21 21 19.6569 21 18C21 17.5369 20.895 17.0982 20.7076 16.7066L16.7066 20.7076ZM15.2924 19.2934L19.2934 15.2924C18.9018 15.105 18.4631 15 18 15C16.3431 15 15 16.3431 15 18C15 18.4631 15.105 18.9018 15.2924 19.2934Z"
  }));
},
    GC = function GC(_ref739) {
  var _ref739$color = _ref739.color,
      C = _ref739$color === void 0 ? "currentColor" : _ref739$color,
      _ref739$size = _ref739.size,
      e = _ref739$size === void 0 ? 24 : _ref739$size,
      l = _ref739.className,
      i = _objectWithoutProperties(_ref739, _excluded739);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16 2L20.9997 7L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918C3 2.44405 3.44749 2 3.9985 2H16ZM13 10H12V15H13V10ZM11 10H9C7.89543 10 7 10.8954 7 12V13C7 14.1046 7.89543 15 9 15H10C10.5523 15 11 14.5523 11 14V12H9V13H10V14H9C8.44772 14 8 13.5523 8 13V12C8 11.4477 8.44772 11 9 11H11V10ZM17 10H14V15H15V13H17V12H15V11H17V10Z"
  }));
},
    IC = function IC(_ref740) {
  var _ref740$color = _ref740.color,
      C = _ref740$color === void 0 ? "currentColor" : _ref740$color,
      _ref740$size = _ref740.size,
      e = _ref740$size === void 0 ? 24 : _ref740$size,
      l = _ref740.className,
      i = _objectWithoutProperties(_ref740, _excluded740);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16 2L20.9997 7L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918C3 2.44405 3.44749 2 3.9985 2H16ZM15 4H5V20H19V8H15V4ZM13 10V15H12V10H13ZM11 10V11H9C8.44772 11 8 11.4477 8 12V13C8 13.5523 8.44772 14 9 14H10V13H9V12H11V14C11 14.5523 10.5523 15 10 15H9C7.89543 15 7 14.1046 7 13V12C7 10.8954 7.89543 10 9 10H11ZM17 10V11H15V12H17V13H15V15H14V10H17Z"
  }));
},
    WC = function WC(_ref741) {
  var _ref741$color = _ref741.color,
      C = _ref741$color === void 0 ? "currentColor" : _ref741$color,
      _ref741$size = _ref741.size,
      e = _ref741$size === void 0 ? 24 : _ref741$size,
      l = _ref741.className,
      i = _objectWithoutProperties(_ref741, _excluded741);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16 2L21 6.999V21.0082C21 21.556 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918C3 2.44405 3.44495 2 3.9934 2H16ZM13 9H11V15H16V13H13V9Z"
  }));
},
    OC = function OC(_ref742) {
  var _ref742$color = _ref742.color,
      C = _ref742$color === void 0 ? "currentColor" : _ref742$color,
      _ref742$size = _ref742.size,
      e = _ref742$size === void 0 ? 24 : _ref742$size,
      l = _ref742.className,
      i = _objectWithoutProperties(_ref742, _excluded742);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16 2L20.9997 7L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918C3 2.44405 3.44749 2 3.9985 2H16ZM15 4H5V20H19V8H15V4ZM13 9V13H16V15H11V9H13Z"
  }));
},
    KC = function KC(_ref743) {
  var _ref743$color = _ref743.color,
      C = _ref743$color === void 0 ? "currentColor" : _ref743$color,
      _ref743$size = _ref743.size,
      e = _ref743$size === void 0 ? 24 : _ref743$size,
      l = _ref743.className,
      i = _objectWithoutProperties(_ref743, _excluded743);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16 2L20.9997 7L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918C3 2.44405 3.44749 2 3.9985 2H16ZM9.33333 14.6667H8V18H16V16.6667L9.333 16.666L9.33333 14.6667ZM12 14.3333C11.4477 14.3333 11 14.781 11 15.3333C11 15.8856 11.4477 16.3333 12 16.3333C12.5523 16.3333 13 15.8856 13 15.3333C13 14.781 12.5523 14.3333 12 14.3333ZM12 9C10.6193 9 9.5 10.1193 9.5 11.5C9.5 12.8807 10.6193 14 12 14C13.3807 14 14.5 12.8807 14.5 11.5C14.5 10.1193 13.3807 9 12 9ZM12 10.3333C12.6443 10.3333 13.1667 10.8557 13.1667 11.5C13.1667 12.1443 12.6443 12.6667 12 12.6667C11.3557 12.6667 10.8333 12.1443 10.8333 11.5C10.8333 10.8557 11.3557 10.3333 12 10.3333ZM12.6667 6H11.3333L11.333 7.333L8 7.33333V8.66667H16V7.33333L12.666 7.333L12.6667 6Z"
  }));
},
    QC = function QC(_ref744) {
  var _ref744$color = _ref744.color,
      C = _ref744$color === void 0 ? "currentColor" : _ref744$color,
      _ref744$size = _ref744.size,
      e = _ref744$size === void 0 ? 24 : _ref744$size,
      l = _ref744.className,
      i = _objectWithoutProperties(_ref744, _excluded744);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16 2L20.9997 7L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918C3 2.44405 3.44749 2 3.9985 2H16ZM16 8.66667H8V7.33333L11.333 7.333L11.3333 6H12.6667L12.666 7.333H14.999L15 4H5V20H19V8L16 7.999V8.66667ZM9.33333 14.6667L9.333 16.666L16 16.6667V18H8V14.6667H9.33333ZM12 14.3333C12.5523 14.3333 13 14.781 13 15.3333C13 15.8856 12.5523 16.3333 12 16.3333C11.4477 16.3333 11 15.8856 11 15.3333C11 14.781 11.4477 14.3333 12 14.3333ZM12 9C13.3807 9 14.5 10.1193 14.5 11.5C14.5 12.8807 13.3807 14 12 14C10.6193 14 9.5 12.8807 9.5 11.5C9.5 10.1193 10.6193 9 12 9ZM12 10.3333C11.3557 10.3333 10.8333 10.8557 10.8333 11.5C10.8333 12.1443 11.3557 12.6667 12 12.6667C12.6443 12.6667 13.1667 12.1443 13.1667 11.5C13.1667 10.8557 12.6443 10.3333 12 10.3333Z"
  }));
},
    qC = function qC(_ref745) {
  var _ref745$color = _ref745.color,
      C = _ref745$color === void 0 ? "currentColor" : _ref745$color,
      _ref745$size = _ref745.size,
      e = _ref745$size === void 0 ? 24 : _ref745$size,
      l = _ref745.className,
      i = _objectWithoutProperties(_ref745, _excluded745);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16 2L21 7V21.0082C21 21.556 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918C3 2.44405 3.44495 2 3.9934 2H16ZM11 7V9H13V7H11ZM11 11V17H13V11H11Z"
  }));
},
    jC = function jC(_ref746) {
  var _ref746$color = _ref746.color,
      C = _ref746$color === void 0 ? "currentColor" : _ref746$color,
      _ref746$size = _ref746.size,
      e = _ref746$size === void 0 ? 24 : _ref746$size,
      l = _ref746.className,
      i = _objectWithoutProperties(_ref746, _excluded746);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15 4H5V20H19V8H15V4ZM3 2.9918C3 2.44405 3.44749 2 3.9985 2H16L20.9997 7L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918ZM11 11H13V17H11V11ZM11 7H13V9H11V7Z"
  }));
},
    XC = function XC(_ref747) {
  var _ref747$color = _ref747.color,
      C = _ref747$color === void 0 ? "currentColor" : _ref747$color,
      _ref747$size = _ref747.size,
      e = _ref747$size === void 0 ? 24 : _ref747$size,
      l = _ref747.className,
      i = _objectWithoutProperties(_ref747, _excluded747);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9 2.00318V2H19.9978C20.5513 2 21 2.45531 21 2.9918V21.0082C21 21.556 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5501 3 20.9932V8L9 2.00318ZM5.82918 8H9V4.83086L5.82918 8ZM11 4V9C11 9.55228 10.5523 10 10 10H5V20H19V4H11Z"
  }));
},
    JC = function JC(_ref748) {
  var _ref748$color = _ref748.color,
      C = _ref748$color === void 0 ? "currentColor" : _ref748$color,
      _ref748$size = _ref748.size,
      e = _ref748$size === void 0 ? 24 : _ref748$size,
      l = _ref748.className,
      i = _objectWithoutProperties(_ref748, _excluded748);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 22H4C3.44772 22 3 21.5523 3 21V3C3 2.44772 3.44772 2 4 2H20C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22ZM8 7V9H16V7H8ZM8 11V13H16V11H8ZM8 15V17H13V15H8Z"
  }));
},
    YC = function YC(_ref749) {
  var _ref749$color = _ref749.color,
      C = _ref749$color === void 0 ? "currentColor" : _ref749$color,
      _ref749$size = _ref749.size,
      e = _ref749$size === void 0 ? 24 : _ref749$size,
      l = _ref749.className,
      i = _objectWithoutProperties(_ref749, _excluded749);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 22H4C3.44772 22 3 21.5523 3 21V3C3 2.44772 3.44772 2 4 2H20C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22ZM19 20V4H5V20H19ZM8 7H16V9H8V7ZM8 11H16V13H8V11ZM8 15H13V17H8V15Z"
  }));
},
    _C = function _C(_ref750) {
  var _ref750$color = _ref750.color,
      C = _ref750$color === void 0 ? "currentColor" : _ref750$color,
      _ref750$size = _ref750.size,
      e = _ref750$size === void 0 ? 24 : _ref750$size,
      l = _ref750.className,
      i = _objectWithoutProperties(_ref750, _excluded750);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19 22H5C3.34315 22 2 20.6569 2 19V3C2 2.44772 2.44772 2 3 2H17C17.5523 2 18 2.44772 18 3V15H22V19C22 20.6569 20.6569 22 19 22ZM18 17V19C18 19.5523 18.4477 20 19 20C19.5523 20 20 19.5523 20 19V17H18ZM6 7V9H14V7H6ZM6 11V13H14V11H6ZM6 15V17H11V15H6Z"
  }));
},
    $C = function $C(_ref751) {
  var _ref751$color = _ref751.color,
      C = _ref751$color === void 0 ? "currentColor" : _ref751$color,
      _ref751$size = _ref751.size,
      e = _ref751$size === void 0 ? 24 : _ref751$size,
      l = _ref751.className,
      i = _objectWithoutProperties(_ref751, _excluded751);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19 22H5C3.34315 22 2 20.6569 2 19V3C2 2.44772 2.44772 2 3 2H17C17.5523 2 18 2.44772 18 3V15H22V19C22 20.6569 20.6569 22 19 22ZM18 17V19C18 19.5523 18.4477 20 19 20C19.5523 20 20 19.5523 20 19V17H18ZM16 20V4H4V19C4 19.5523 4.44772 20 5 20H16ZM6 7H14V9H6V7ZM6 11H14V13H6V11ZM6 15H11V17H6V15Z"
  }));
},
    el = function el(_ref752) {
  var _ref752$color = _ref752.color,
      C = _ref752$color === void 0 ? "currentColor" : _ref752$color,
      _ref752$size = _ref752.size,
      e = _ref752$size === void 0 ? 24 : _ref752$size,
      l = _ref752.className,
      i = _objectWithoutProperties(_ref752, _excluded752);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 22H4C3.44772 22 3 21.5523 3 21V3C3 2.44772 3.44772 2 4 2H20C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22ZM8 7V9H16V7H8ZM8 11V13H16V11H8ZM8 15V17H16V15H8Z"
  }));
},
    tl = function tl(_ref753) {
  var _ref753$color = _ref753.color,
      C = _ref753$color === void 0 ? "currentColor" : _ref753$color,
      _ref753$size = _ref753.size,
      e = _ref753$size === void 0 ? 24 : _ref753$size,
      l = _ref753.className,
      i = _objectWithoutProperties(_ref753, _excluded753);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 22H4C3.44772 22 3 21.5523 3 21V3C3 2.44772 3.44772 2 4 2H20C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22ZM19 20V4H5V20H19ZM8 7H16V9H8V7ZM8 11H16V13H8V11ZM8 15H16V17H8V15Z"
  }));
},
    Cl = function Cl(_ref754) {
  var _ref754$color = _ref754.color,
      C = _ref754$color === void 0 ? "currentColor" : _ref754$color,
      _ref754$size = _ref754.size,
      e = _ref754$size === void 0 ? 24 : _ref754$size,
      l = _ref754.className,
      i = _objectWithoutProperties(_ref754, _excluded754);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16 2L21 7V21.0082C21 21.556 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918C3 2.44405 3.44495 2 3.9934 2H16ZM15 11V10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10V11H8V16H16V11H15ZM13 11H11V10C11 9.44772 11.4477 9 12 9C12.5523 9 13 9.44772 13 10V11Z"
  }));
},
    ll = function ll(_ref755) {
  var _ref755$color = _ref755.color,
      C = _ref755$color === void 0 ? "currentColor" : _ref755$color,
      _ref755$size = _ref755.size,
      e = _ref755$size === void 0 ? 24 : _ref755$size,
      l = _ref755.className,
      i = _objectWithoutProperties(_ref755, _excluded755);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15 4H5V20H19V8H15V4ZM3 2.9918C3 2.44405 3.44749 2 3.9985 2H16L20.9997 7L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918ZM15 11H16V16H8V11H9V10C9 8.34315 10.3431 7 12 7C13.6569 7 15 8.34315 15 10V11ZM13 11V10C13 9.44772 12.5523 9 12 9C11.4477 9 11 9.44772 11 10V11H13Z"
  }));
},
    il = function il(_ref756) {
  var _ref756$color = _ref756.color,
      C = _ref756$color === void 0 ? "currentColor" : _ref756$color,
      _ref756$size = _ref756.size,
      e = _ref756$size === void 0 ? 24 : _ref756$size,
      l = _ref756.className,
      i = _objectWithoutProperties(_ref756, _excluded756);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 2.9918V21.0082C21 21.5447 20.5552 22 20.0066 22H3.9934C3.44495 22 3 21.556 3 21.0082V2.9918C3 2.45531 3.44476 2 3.9934 2H20.0066C20.5551 2 21 2.44405 21 2.9918ZM7 4V13L10.5 11L14 13V4H7Z"
  }));
},
    sl = function sl(_ref757) {
  var _ref757$color = _ref757.color,
      C = _ref757$color === void 0 ? "currentColor" : _ref757$color,
      _ref757$size = _ref757.size,
      e = _ref757$size === void 0 ? 24 : _ref757$size,
      l = _ref757.className,
      i = _objectWithoutProperties(_ref757, _excluded757);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 22H4C3.44772 22 3 21.5523 3 21V3C3 2.44772 3.44772 2 4 2H20C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22ZM7 4H5V20H19V4H14V13L10.5 11L7 13V4Z"
  }));
},
    rl = function rl(_ref758) {
  var _ref758$color = _ref758.color,
      C = _ref758$color === void 0 ? "currentColor" : _ref758$color,
      _ref758$size = _ref758.size,
      e = _ref758$size === void 0 ? 24 : _ref758$size,
      l = _ref758.className,
      i = _objectWithoutProperties(_ref758, _excluded758);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16 2L21 7V21.0082C21 21.556 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918C3 2.44405 3.44495 2 3.9934 2H16ZM11 12.05C10.8384 12.0172 10.6712 12 10.5 12C9.11929 12 8 13.1193 8 14.5C8 15.8807 9.11929 17 10.5 17C11.8807 17 13 15.8807 13 14.5V10H16V8H11V12.05Z"
  }));
},
    cl = function cl(_ref759) {
  var _ref759$color = _ref759.color,
      C = _ref759$color === void 0 ? "currentColor" : _ref759$color,
      _ref759$size = _ref759.size,
      e = _ref759$size === void 0 ? 24 : _ref759$size,
      l = _ref759.className,
      i = _objectWithoutProperties(_ref759, _excluded759);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16 8V10H13V14.5C13 15.8807 11.8807 17 10.5 17C9.11929 17 8 15.8807 8 14.5C8 13.1193 9.11929 12 10.5 12C10.6712 12 10.8384 12.0172 11 12.05V8H15V4H5V20H19V8H16ZM3 2.9918C3 2.44405 3.44749 2 3.9985 2H16L20.9997 7L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918Z"
  }));
},
    ol = function ol(_ref760) {
  var _ref760$color = _ref760.color,
      C = _ref760$color === void 0 ? "currentColor" : _ref760$color,
      _ref760$size = _ref760.size,
      e = _ref760$size === void 0 ? 24 : _ref760$size,
      l = _ref760.className,
      i = _objectWithoutProperties(_ref760, _excluded760);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 2C21.6569 2 23 3.34315 23 5V7H21V19C21 20.6569 19.6569 22 18 22H4C2.34315 22 1 20.6569 1 19V17H17V19C17 19.5128 17.386 19.9355 17.8834 19.9933L18 20C18.5128 20 18.9355 19.614 18.9933 19.1166L19 19V15H3V5C3 3.34315 4.34315 2 6 2H20Z"
  }));
},
    al = function al(_ref761) {
  var _ref761$color = _ref761.color,
      C = _ref761$color === void 0 ? "currentColor" : _ref761$color,
      _ref761$size = _ref761.size,
      e = _ref761$size === void 0 ? 24 : _ref761$size,
      l = _ref761.className,
      i = _objectWithoutProperties(_ref761, _excluded761);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 2C21.6569 2 23 3.34315 23 5V7H21V19C21 20.6569 19.6569 22 18 22H4C2.34315 22 1 20.6569 1 19V17H17V19C17 19.5128 17.386 19.9355 17.8834 19.9933L18 20C18.5128 20 18.9355 19.614 18.9933 19.1166L19 19V4H6C5.48716 4 5.06449 4.38604 5.00673 4.88338L5 5V15H3V5C3 3.34315 4.34315 2 6 2H20Z"
  }));
},
    nl = function nl(_ref762) {
  var _ref762$color = _ref762.color,
      C = _ref762$color === void 0 ? "currentColor" : _ref762$color,
      _ref762$size = _ref762.size,
      e = _ref762$size === void 0 ? 24 : _ref762$size,
      l = _ref762.className,
      i = _objectWithoutProperties(_ref762, _excluded762);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 15V3C3 2.44772 3.44772 2 4 2H20C20.5523 2 21 2.44772 21 3V19C21 20.6569 19.6569 22 18 22H4C2.34315 22 1 20.6569 1 19V17H17V19C17 19.5523 17.4477 20 18 20C18.5523 20 19 19.5523 19 19V15H3Z"
  }));
},
    ml = function ml(_ref763) {
  var _ref763$color = _ref763.color,
      C = _ref763$color === void 0 ? "currentColor" : _ref763$color,
      _ref763$size = _ref763.size,
      e = _ref763$size === void 0 ? 24 : _ref763$size,
      l = _ref763.className,
      i = _objectWithoutProperties(_ref763, _excluded763);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17 17V19C17 19.5523 17.4477 20 18 20C18.5523 20 19 19.5523 19 19V4H5V15H3V3C3 2.44772 3.44772 2 4 2H20C20.5523 2 21 2.44772 21 3V19C21 20.6569 19.6569 22 18 22H4C2.34315 22 1 20.6569 1 19V17H17Z"
  }));
},
    wl = function wl(_ref764) {
  var _ref764$color = _ref764.color,
      C = _ref764$color === void 0 ? "currentColor" : _ref764$color,
      _ref764$size = _ref764.size,
      e = _ref764$size === void 0 ? 24 : _ref764$size,
      l = _ref764.className,
      i = _objectWithoutProperties(_ref764, _excluded764);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16 2L21 7V21.0082C21 21.556 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918C3 2.44405 3.44495 2 3.9934 2H16ZM12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8H8V16H12ZM10 10H12C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14H10V10Z"
  }));
},
    Ll = function Ll(_ref765) {
  var _ref765$color = _ref765.color,
      C = _ref765$color === void 0 ? "currentColor" : _ref765$color,
      _ref765$size = _ref765.size,
      e = _ref765$size === void 0 ? 24 : _ref765$size,
      l = _ref765.className,
      i = _objectWithoutProperties(_ref765, _excluded765);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 16H8V8H12C14.2091 8 16 9.79086 16 12C16 14.2091 14.2091 16 12 16ZM10 10V14H12C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10H10ZM15 4H5V20H19V8H15V4ZM3 2.9918C3 2.44405 3.44749 2 3.9985 2H16L20.9997 7L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918Z"
  }));
},
    hl = function hl(_ref766) {
  var _ref766$color = _ref766.color,
      C = _ref766$color === void 0 ? "currentColor" : _ref766$color,
      _ref766$size = _ref766.size,
      e = _ref766$size === void 0 ? 24 : _ref766$size,
      l = _ref766.className,
      i = _objectWithoutProperties(_ref766, _excluded766);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17 2.99997H21C21.5523 2.99997 22 3.44769 22 3.99997V20C22 20.5523 21.5523 21 21 21H17V2.99997ZM2.85858 2.87732L15.4293 1.0815C15.7027 1.04245 15.9559 1.2324 15.995 1.50577C15.9983 1.52919 16 1.55282 16 1.57648V22.4235C16 22.6996 15.7761 22.9235 15.5 22.9235C15.4763 22.9235 15.4527 22.9218 15.4293 22.9184L2.85858 21.1226C2.36593 21.0522 2 20.6303 2 20.1327V3.86727C2 3.36962 2.36593 2.9477 2.85858 2.87732ZM5 7.99997V16H7V14H13V7.99997H5ZM7 9.99998H11V12H7V9.99998Z"
  }));
},
    Hl = function Hl(_ref767) {
  var _ref767$color = _ref767.color,
      C = _ref767$color === void 0 ? "currentColor" : _ref767$color,
      _ref767$size = _ref767.size,
      e = _ref767$size === void 0 ? 24 : _ref767$size,
      l = _ref767.className,
      i = _objectWithoutProperties(_ref767, _excluded767);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2.85858 2.87732L15.4293 1.0815C15.7027 1.04245 15.9559 1.2324 15.995 1.50577C15.9983 1.52919 16 1.55282 16 1.57648V22.4235C16 22.6996 15.7761 22.9235 15.5 22.9235C15.4763 22.9235 15.4527 22.9218 15.4293 22.9184L2.85858 21.1226C2.36593 21.0522 2 20.6303 2 20.1327V3.86727C2 3.36962 2.36593 2.9477 2.85858 2.87732ZM4 4.73457V19.2654L14 20.694V3.30599L4 4.73457ZM17 19H20V4.99997H17V2.99997H21C21.5523 2.99997 22 3.44769 22 3.99997V20C22 20.5523 21.5523 21 21 21H17V19ZM5 7.99997H13V14H7V16H5V7.99997ZM7 9.99998V12H11V9.99998H7Z"
  }));
},
    Vl = function Vl(_ref768) {
  var _ref768$color = _ref768.color,
      C = _ref768$color === void 0 ? "currentColor" : _ref768$color,
      _ref768$size = _ref768.size,
      e = _ref768$size === void 0 ? 24 : _ref768$size,
      l = _ref768.className,
      i = _objectWithoutProperties(_ref768, _excluded768);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16 2L21 7V21.0082C21 21.556 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918C3 2.44405 3.44495 2 3.9934 2H16ZM8 8V16H10V14H16V8H8ZM10 10H14V12H10V10Z"
  }));
},
    gl = function gl(_ref769) {
  var _ref769$color = _ref769.color,
      C = _ref769$color === void 0 ? "currentColor" : _ref769$color,
      _ref769$size = _ref769.size,
      e = _ref769$size === void 0 ? 24 : _ref769$size,
      l = _ref769.className,
      i = _objectWithoutProperties(_ref769, _excluded769);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 2.9918C3 2.44405 3.44749 2 3.9985 2H16L20.9997 7L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918ZM5 4V20H19V8H16V14H10V16H8V8H15V4H5ZM10 10V12H14V10H10Z"
  }));
},
    Ml = function Ml(_ref770) {
  var _ref770$color = _ref770.color,
      C = _ref770$color === void 0 ? "currentColor" : _ref770$color,
      _ref770$size = _ref770.size,
      e = _ref770$size === void 0 ? 24 : _ref770$size,
      l = _ref770.className,
      i = _objectWithoutProperties(_ref770, _excluded770);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16 2L21 7V21.0082C21 21.556 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918C3 2.44405 3.44495 2 3.9934 2H16ZM8 11V13H16V11H8Z"
  }));
},
    Zl = function Zl(_ref771) {
  var _ref771$color = _ref771.color,
      C = _ref771$color === void 0 ? "currentColor" : _ref771$color,
      _ref771$size = _ref771.size,
      e = _ref771$size === void 0 ? 24 : _ref771$size,
      l = _ref771.className,
      i = _objectWithoutProperties(_ref771, _excluded771);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15 4H5V20H19V8H15V4ZM3 2.9918C3 2.44405 3.44749 2 3.9985 2H16L20.9997 7L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918ZM16 11V13H8V11H16Z"
  }));
},
    xl = function xl(_ref772) {
  var _ref772$color = _ref772.color,
      C = _ref772$color === void 0 ? "currentColor" : _ref772$color,
      _ref772$size = _ref772.size,
      e = _ref772$size === void 0 ? 24 : _ref772$size,
      l = _ref772.className,
      i = _objectWithoutProperties(_ref772, _excluded772);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16 2L21 7V21.0082C21 21.556 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918C3 2.44405 3.44495 2 3.9934 2H16ZM13.529 14.4464L15.7395 16.6569L17.1537 15.2426L14.9432 13.0322C15.8492 11.4983 15.6432 9.48951 14.3252 8.17157C12.7631 6.60948 10.2305 6.60948 8.66839 8.17157C7.1063 9.73367 7.1063 12.2663 8.66839 13.8284C9.98633 15.1464 11.9951 15.3524 13.529 14.4464ZM12.911 12.4142C12.13 13.1953 10.8637 13.1953 10.0826 12.4142C9.30156 11.6332 9.30156 10.3668 10.0826 9.58579C10.8637 8.80474 12.13 8.80474 12.911 9.58579C13.6921 10.3668 13.6921 11.6332 12.911 12.4142Z"
  }));
},
    vl = function vl(_ref773) {
  var _ref773$color = _ref773.color,
      C = _ref773$color === void 0 ? "currentColor" : _ref773$color,
      _ref773$size = _ref773.size,
      e = _ref773$size === void 0 ? 24 : _ref773$size,
      l = _ref773.className,
      i = _objectWithoutProperties(_ref773, _excluded773);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15 4H5V20H19V8H15V4ZM3 2.9918C3 2.44405 3.44749 2 3.9985 2H16L20.9997 7L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918ZM13.529 14.4464C11.9951 15.3524 9.98633 15.1464 8.66839 13.8284C7.1063 12.2663 7.1063 9.73367 8.66839 8.17157C10.2305 6.60948 12.7631 6.60948 14.3252 8.17157C15.6432 9.48951 15.8492 11.4983 14.9432 13.0322L17.1537 15.2426L15.7395 16.6569L13.529 14.4464ZM12.911 12.4142C13.6921 11.6332 13.6921 10.3668 12.911 9.58579C12.13 8.80474 10.8637 8.80474 10.0826 9.58579C9.30156 10.3668 9.30156 11.6332 10.0826 12.4142C10.8637 13.1953 12.13 13.1953 12.911 12.4142Z"
  }));
},
    dl = function dl(_ref774) {
  var _ref774$color = _ref774.color,
      C = _ref774$color === void 0 ? "currentColor" : _ref774$color,
      _ref774$size = _ref774.size,
      e = _ref774$size === void 0 ? 24 : _ref774$size,
      l = _ref774.className,
      i = _objectWithoutProperties(_ref774, _excluded774);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16 2L21 7V21.0082C21 21.556 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918C3 2.44405 3.44495 2 3.9934 2H16ZM8.59456 12.8115L7.60291 13.384L8.60297 15.1161L9.59532 14.5431C9.98844 14.915 10.4677 15.1967 11.0001 15.3551V16.5H13.0001V15.355C13.5325 15.1966 14.0117 14.9149 14.4048 14.543L15.3972 15.116L16.3972 13.3839L15.4055 12.8114C15.4673 12.551 15.5 12.2793 15.5 12C15.5 11.7207 15.4673 11.449 15.4054 11.1885L16.3972 10.616L15.3971 8.88393L14.4047 9.4569C14.0116 9.08506 13.5324 8.80337 13 8.64494V7.5H11V8.64494C10.4676 8.80338 9.98834 9.08508 9.59523 9.45694L8.60291 8.88402L7.60291 10.6161L8.59454 11.1886C8.53272 11.449 8.5 11.7207 8.5 12C8.5 12.2794 8.53273 12.5511 8.59456 12.8115ZM12 13.5C11.1716 13.5 10.5 12.8284 10.5 12C10.5 11.1716 11.1716 10.5 12 10.5C12.8284 10.5 13.5 11.1716 13.5 12C13.5 12.8284 12.8284 13.5 12 13.5Z"
  }));
},
    pl = function pl(_ref775) {
  var _ref775$color = _ref775.color,
      C = _ref775$color === void 0 ? "currentColor" : _ref775$color,
      _ref775$size = _ref775.size,
      e = _ref775$size === void 0 ? 24 : _ref775$size,
      l = _ref775.className,
      i = _objectWithoutProperties(_ref775, _excluded775);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8.59456 12.8115C8.53273 12.5511 8.5 12.2794 8.5 12C8.5 11.7207 8.53272 11.449 8.59454 11.1886L7.60291 10.6161L8.60291 8.88402L9.59523 9.45694C9.98834 9.08508 10.4676 8.80338 11 8.64494V7.5H13V8.64494C13.5324 8.80337 14.0116 9.08506 14.4047 9.4569L15.3971 8.88393L16.3972 10.616L15.4054 11.1885C15.4673 11.449 15.5 11.7207 15.5 12C15.5 12.2793 15.4673 12.551 15.4055 12.8114L16.3972 13.3839L15.3972 15.116L14.4048 14.543C14.0117 14.9149 13.5325 15.1966 13.0001 15.355V16.5H11.0001V15.3551C10.4677 15.1967 9.98844 14.915 9.59532 14.5431L8.60297 15.1161L7.60291 13.384L8.59456 12.8115ZM12 13.5C12.8284 13.5 13.5 12.8284 13.5 12C13.5 11.1716 12.8284 10.5 12 10.5C11.1716 10.5 10.5 11.1716 10.5 12C10.5 12.8284 11.1716 13.5 12 13.5ZM15 4H5V20H19V8H15V4ZM3 2.9918C3 2.44405 3.44749 2 3.9985 2H16L20.9997 7L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918Z"
  }));
},
    El = function El(_ref776) {
  var _ref776$color = _ref776.color,
      C = _ref776$color === void 0 ? "currentColor" : _ref776$color,
      _ref776$size = _ref776.size,
      e = _ref776$size === void 0 ? 24 : _ref776$size,
      l = _ref776.className,
      i = _objectWithoutProperties(_ref776, _excluded776);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 10H11V17.3823C11 18.9449 11.7775 20.4053 13.074 21.2742L14.1569 22H3.9934C3.44495 22 3 21.556 3 21.0082V2.9918C3 2.45531 3.44694 2 3.99826 2H15.9968L21 7V10ZM13 12H21V17.3823C21 18.2786 20.5544 19.1156 19.8125 19.6128L17 21.4978L14.1875 19.6128C13.4456 19.1156 13 18.2786 13 17.3823V12Z"
  }));
},
    Nl = function Nl(_ref777) {
  var _ref777$color = _ref777.color,
      C = _ref777$color === void 0 ? "currentColor" : _ref777$color,
      _ref777$size = _ref777.size,
      e = _ref777$size === void 0 ? 24 : _ref777$size,
      l = _ref777.className,
      i = _objectWithoutProperties(_ref777, _excluded777);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14 9V4H5V20H11.0563C11.3838 20.4171 11.7803 20.7847 12.236 21.0848L13.626 22H3.9934C3.44495 22 3 21.556 3 21.0082V2.9918C3 2.45531 3.4487 2 4.00221 2H14.9968L21 8V9H14ZM12 11H21V16.949C21 17.9397 20.4987 18.8648 19.6641 19.4144L16.5 21.4978L13.3359 19.4144C12.5013 18.8648 12 17.9397 12 16.949V11ZM14 16.949C14 17.2652 14.1616 17.5634 14.4358 17.744L16.5 19.1032L18.5642 17.744C18.8384 17.5634 19 17.2652 19 16.949V13H14V16.949Z"
  }));
},
    ul = function ul(_ref778) {
  var _ref778$color = _ref778.color,
      C = _ref778$color === void 0 ? "currentColor" : _ref778$color,
      _ref778$size = _ref778.size,
      e = _ref778$size === void 0 ? 24 : _ref778$size,
      l = _ref778.className,
      i = _objectWithoutProperties(_ref778, _excluded778);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 7V20.9925C21 21.5511 20.5552 22 20.0066 22H3.9934C3.44495 22 3 21.556 3 21.0082V2.9918C3 2.45531 3.44694 2 3.99826 2H15.9968L21 7ZM8 8V13.6002C8 14.4496 8.4456 15.2427 9.18747 15.7138L12 17.5L14.8125 15.7138C15.5544 15.2427 16 14.4496 16 13.6002V8H8ZM10 10H14V13.6002C14 13.7579 13.9103 13.9176 13.7403 14.0255L12 15.1308L10.2597 14.0255C10.0897 13.9176 10 13.7579 10 13.6002V10Z"
  }));
},
    Bl = function Bl(_ref779) {
  var _ref779$color = _ref779.color,
      C = _ref779$color === void 0 ? "currentColor" : _ref779$color,
      _ref779$size = _ref779.size,
      e = _ref779$size === void 0 ? 24 : _ref779$size,
      l = _ref779.className,
      i = _objectWithoutProperties(_ref779, _excluded779);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14 8V4H5V20H19V9H16V13.6195C16 14.4641 15.5544 15.2529 14.8125 15.7215L12 17.4978L9.18747 15.7215C8.4456 15.2529 8 14.4641 8 13.6195V8H14ZM21 8V20.9932C21 21.5501 20.5552 22 20.0066 22H3.9934C3.44495 22 3 21.556 3 21.0082V2.9918C3 2.45531 3.4487 2 4.00221 2H14.9968L21 8ZM10 13.6195C10 13.7698 10.0872 13.9242 10.2554 14.0305L12 15.1323L13.7446 14.0305C13.9128 13.9242 14 13.7698 14 13.6195V10H10V13.6195Z"
  }));
},
    fl = function fl(_ref780) {
  var _ref780$color = _ref780.color,
      C = _ref780$color === void 0 ? "currentColor" : _ref780$color,
      _ref780$size = _ref780.size,
      e = _ref780$size === void 0 ? 24 : _ref780$size,
      l = _ref780.className,
      i = _objectWithoutProperties(_ref780, _excluded780);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22 12V14H2V12H4V2.9954C4 2.44565 4.44484 2 4.99558 2H15L19.9997 7L20 12H22ZM3 16H5V22H3V16ZM19 16H21V22H19V16ZM15 16H17V22H15V16ZM11 16H13V22H11V16ZM7 16H9V22H7V16Z"
  }));
},
    Rl = function Rl(_ref781) {
  var _ref781$color = _ref781.color,
      C = _ref781$color === void 0 ? "currentColor" : _ref781$color,
      _ref781$size = _ref781.size,
      e = _ref781$size === void 0 ? 24 : _ref781$size,
      l = _ref781.className,
      i = _objectWithoutProperties(_ref781, _excluded781);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6 12H18V8H14V4H6V12ZM4 12V2.9954C4 2.44565 4.44484 2 4.99558 2H15L19.9997 7L20 12H22V14H2V12H4ZM3 16H5V22H3V16ZM19 16H21V22H19V16ZM15 16H17V22H15V16ZM11 16H13V22H11V16ZM7 16H9V22H7V16Z"
  }));
},
    zl = function zl(_ref782) {
  var _ref782$color = _ref782.color,
      C = _ref782$color === void 0 ? "currentColor" : _ref782$color,
      _ref782$size = _ref782.size,
      e = _ref782$size === void 0 ? 24 : _ref782$size,
      l = _ref782.className,
      i = _objectWithoutProperties(_ref782, _excluded782);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 9V20.9925C21 21.5511 20.5552 22 20.0066 22H3.9934C3.44495 22 3 21.556 3 21.0082V2.9918C3 2.45531 3.44694 2 3.99826 2H14V8C14 8.55228 14.4477 9 15 9H21ZM21 7H16V2.00318L21 7ZM8 7V9H11V7H8ZM8 11V13H16V11H8ZM8 15V17H16V15H8Z"
  }));
},
    Fl = function Fl(_ref783) {
  var _ref783$color = _ref783.color,
      C = _ref783$color === void 0 ? "currentColor" : _ref783$color,
      _ref783$size = _ref783.size,
      e = _ref783$size === void 0 ? 24 : _ref783$size,
      l = _ref783.className,
      i = _objectWithoutProperties(_ref783, _excluded783);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 8V20.9932C21 21.5501 20.5552 22 20.0066 22H3.9934C3.44495 22 3 21.556 3 21.0082V2.9918C3 2.45531 3.4487 2 4.00221 2H14.9968L21 8ZM19 9H14V4H5V20H19V9ZM8 7H11V9H8V7ZM8 11H16V13H8V11ZM8 15H16V17H8V15Z"
  }));
},
    Sl = function Sl(_ref784) {
  var _ref784$color = _ref784.color,
      C = _ref784$color === void 0 ? "currentColor" : _ref784$color,
      _ref784$size = _ref784.size,
      e = _ref784$size === void 0 ? 24 : _ref784$size,
      l = _ref784.className,
      i = _objectWithoutProperties(_ref784, _excluded784);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16 2L21 7V21.0082C21 21.556 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918C3 2.44405 3.44495 2 3.9934 2H16ZM12 11H8V13H12V16L16 12L12 8V11Z"
  }));
},
    Al = function Al(_ref785) {
  var _ref785$color = _ref785.color,
      C = _ref785$color === void 0 ? "currentColor" : _ref785$color,
      _ref785$size = _ref785.size,
      e = _ref785$size === void 0 ? 24 : _ref785$size,
      l = _ref785.className,
      i = _objectWithoutProperties(_ref785, _excluded785);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15 4H5V20H19V8H15V4ZM3 2.9918C3 2.44405 3.44749 2 3.9985 2H16L20.9997 7L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918ZM12 11V8L16 12L12 16V13H8V11H12Z"
  }));
},
    kl = function kl(_ref786) {
  var _ref786$color = _ref786.color,
      C = _ref786$color === void 0 ? "currentColor" : _ref786$color,
      _ref786$size = _ref786.size,
      e = _ref786$size === void 0 ? 24 : _ref786$size,
      l = _ref786.className,
      i = _objectWithoutProperties(_ref786, _excluded786);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16 2L21 7V21.0082C21 21.556 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918C3 2.44405 3.44495 2 3.9934 2H16ZM11 15V17H13V15H11ZM13 13.3551C14.4457 12.9248 15.5 11.5855 15.5 10C15.5 8.067 13.933 6.5 12 6.5C10.302 6.5 8.88637 7.70919 8.56731 9.31346L10.5288 9.70577C10.6656 9.01823 11.2723 8.5 12 8.5C12.8284 8.5 13.5 9.17157 13.5 10C13.5 10.8284 12.8284 11.5 12 11.5C11.4477 11.5 11 11.9477 11 12.5V14H13V13.3551Z"
  }));
},
    Pl = function Pl(_ref787) {
  var _ref787$color = _ref787.color,
      C = _ref787$color === void 0 ? "currentColor" : _ref787$color,
      _ref787$size = _ref787.size,
      e = _ref787$size === void 0 ? 24 : _ref787$size,
      l = _ref787.className,
      i = _objectWithoutProperties(_ref787, _excluded787);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11 15H13V17H11V15ZM13 13.3551V14H11V12.5C11 11.9477 11.4477 11.5 12 11.5C12.8284 11.5 13.5 10.8284 13.5 10C13.5 9.17157 12.8284 8.5 12 8.5C11.2723 8.5 10.6656 9.01823 10.5288 9.70577L8.56731 9.31346C8.88637 7.70919 10.302 6.5 12 6.5C13.933 6.5 15.5 8.067 15.5 10C15.5 11.5855 14.4457 12.9248 13 13.3551ZM15 4H5V20H19V8H15V4ZM3 2.9918C3 2.44405 3.44749 2 3.9985 2H16L20.9997 7L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918Z"
  }));
},
    Dl = function Dl(_ref788) {
  var _ref788$color = _ref788.color,
      C = _ref788$color === void 0 ? "currentColor" : _ref788$color,
      _ref788$size = _ref788.size,
      e = _ref788$size === void 0 ? 24 : _ref788$size,
      l = _ref788.className,
      i = _objectWithoutProperties(_ref788, _excluded788);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16 2L21 7V21.0082C21 21.556 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918C3 2.44405 3.44495 2 3.9934 2H16ZM13 12H16L12 8L8 12H11V16H13V12Z"
  }));
},
    yl = function yl(_ref789) {
  var _ref789$color = _ref789.color,
      C = _ref789$color === void 0 ? "currentColor" : _ref789$color,
      _ref789$size = _ref789.size,
      e = _ref789$size === void 0 ? 24 : _ref789$size,
      l = _ref789.className,
      i = _objectWithoutProperties(_ref789, _excluded789);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15 4H5V20H19V8H15V4ZM3 2.9918C3 2.44405 3.44749 2 3.9985 2H16L20.9997 7L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918ZM13 12V16H11V12H8L12 8L16 12H13Z"
  }));
},
    bl = function bl(_ref790) {
  var _ref790$color = _ref790.color,
      C = _ref790$color === void 0 ? "currentColor" : _ref790$color,
      _ref790$size = _ref790.size,
      e = _ref790$size === void 0 ? 24 : _ref790$size,
      l = _ref790.className,
      i = _objectWithoutProperties(_ref790, _excluded790);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16 2L21 7V21.0082C21 21.556 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918C3 2.44405 3.44495 2 3.9934 2H16ZM12 11.5C13.3807 11.5 14.5 10.3807 14.5 9C14.5 7.61929 13.3807 6.5 12 6.5C10.6193 6.5 9.5 7.61929 9.5 9C9.5 10.3807 10.6193 11.5 12 11.5ZM7.52746 17H16.4725C16.2238 14.75 14.3163 13 12 13C9.68372 13 7.77619 14.75 7.52746 17Z"
  }));
},
    Tl = function Tl(_ref791) {
  var _ref791$color = _ref791.color,
      C = _ref791$color === void 0 ? "currentColor" : _ref791$color,
      _ref791$size = _ref791.size,
      e = _ref791$size === void 0 ? 24 : _ref791$size,
      l = _ref791.className,
      i = _objectWithoutProperties(_ref791, _excluded791);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15 4H5V20H19V8H15V4ZM3 2.9918C3 2.44405 3.44749 2 3.9985 2H16L20.9997 7L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918ZM12 11.5C10.6193 11.5 9.5 10.3807 9.5 9C9.5 7.61929 10.6193 6.5 12 6.5C13.3807 6.5 14.5 7.61929 14.5 9C14.5 10.3807 13.3807 11.5 12 11.5ZM7.52746 17C7.77619 14.75 9.68372 13 12 13C14.3163 13 16.2238 14.75 16.4725 17H7.52746Z"
  }));
},
    Ul = function Ul(_ref792) {
  var _ref792$color = _ref792.color,
      C = _ref792$color === void 0 ? "currentColor" : _ref792$color,
      _ref792$size = _ref792.size,
      e = _ref792$size === void 0 ? 24 : _ref792$size,
      l = _ref792.className,
      i = _objectWithoutProperties(_ref792, _excluded792);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16 2L21 7V21.0082C21 21.556 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918C3 2.44405 3.44495 2 3.9934 2H16ZM11 15V17H13V15H11ZM11 7V13H13V7H11Z"
  }));
},
    Gl = function Gl(_ref793) {
  var _ref793$color = _ref793.color,
      C = _ref793$color === void 0 ? "currentColor" : _ref793$color,
      _ref793$size = _ref793.size,
      e = _ref793$size === void 0 ? 24 : _ref793$size,
      l = _ref793.className,
      i = _objectWithoutProperties(_ref793, _excluded793);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15 4H5V20H19V8H15V4ZM3 2.9918C3 2.44405 3.44749 2 3.9985 2H16L20.9997 7L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918ZM11 15H13V17H11V15ZM11 7H13V13H11V7Z"
  }));
},
    Il = function Il(_ref794) {
  var _ref794$color = _ref794.color,
      C = _ref794$color === void 0 ? "currentColor" : _ref794$color,
      _ref794$size = _ref794.size,
      e = _ref794$size === void 0 ? 24 : _ref794$size,
      l = _ref794.className,
      i = _objectWithoutProperties(_ref794, _excluded794);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17 2.99997H21C21.5523 2.99997 22 3.44769 22 3.99997V20C22 20.5523 21.5523 21 21 21H17V2.99997ZM2.85858 2.87732L15.4293 1.0815C15.7027 1.04245 15.9559 1.2324 15.995 1.50577C15.9983 1.52919 16 1.55282 16 1.57648V22.4235C16 22.6996 15.7761 22.9235 15.5 22.9235C15.4763 22.9235 15.4527 22.9218 15.4293 22.9184L2.85858 21.1226C2.36593 21.0522 2 20.6303 2 20.1327V3.86727C2 3.36962 2.36593 2.9477 2.85858 2.87732ZM11 7.99997V12.989L9 11L7.01083 13L7 7.99997H5V16H7L9 14L11 16H13V7.99997H11Z"
  }));
},
    Wl = function Wl(_ref795) {
  var _ref795$color = _ref795.color,
      C = _ref795$color === void 0 ? "currentColor" : _ref795$color,
      _ref795$size = _ref795.size,
      e = _ref795$size === void 0 ? 24 : _ref795$size,
      l = _ref795.className,
      i = _objectWithoutProperties(_ref795, _excluded795);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17 19H20V4.99997H17V2.99997H21C21.5523 2.99997 22 3.44769 22 3.99997V20C22 20.5523 21.5523 21 21 21H17V19ZM2.85858 2.87732L15.4293 1.0815C15.7027 1.04245 15.9559 1.2324 15.995 1.50577C15.9983 1.52919 16 1.55282 16 1.57648V22.4235C16 22.6996 15.7761 22.9235 15.5 22.9235C15.4763 22.9235 15.4527 22.9218 15.4293 22.9184L2.85858 21.1226C2.36593 21.0522 2 20.6303 2 20.1327V3.86727C2 3.36962 2.36593 2.9477 2.85858 2.87732ZM4 4.73457V19.2654L14 20.694V3.30599L4 4.73457ZM11 7.99997H13V16H11L9 14L7 16H5V7.99997H7L7.01083 13L9 11L11 12.989V7.99997Z"
  }));
},
    Ol = function Ol(_ref796) {
  var _ref796$color = _ref796.color,
      C = _ref796$color === void 0 ? "currentColor" : _ref796$color,
      _ref796$size = _ref796.size,
      e = _ref796$size === void 0 ? 24 : _ref796$size,
      l = _ref796.className,
      i = _objectWithoutProperties(_ref796, _excluded796);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16 2L21 7V21.0082C21 21.556 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918C3 2.44405 3.44495 2 3.9934 2H16ZM14 8V12.989L12 11L10.0108 13L10 8H8V16H10L12 14L14 16H16V8H14Z"
  }));
},
    Kl = function Kl(_ref797) {
  var _ref797$color = _ref797.color,
      C = _ref797$color === void 0 ? "currentColor" : _ref797$color,
      _ref797$size = _ref797.size,
      e = _ref797$size === void 0 ? 24 : _ref797$size,
      l = _ref797.className,
      i = _objectWithoutProperties(_ref797, _excluded797);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16 8V16H14L12 14L10 16H8V8H10V13L12 11L14 13V8H15V4H5V20H19V8H16ZM3 2.9918C3 2.44405 3.44749 2 3.9985 2H16L20.9997 7L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918Z"
  }));
},
    Ql = function Ql(_ref798) {
  var _ref798$color = _ref798.color,
      C = _ref798$color === void 0 ? "currentColor" : _ref798$color,
      _ref798$size = _ref798.size,
      e = _ref798$size === void 0 ? 24 : _ref798$size,
      l = _ref798.className,
      i = _objectWithoutProperties(_ref798, _excluded798);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10 2V4H12V2H20.0066C20.5551 2 21 2.44405 21 2.9918V21.0082C21 21.5447 20.5552 22 20.0066 22H3.9934C3.44495 22 3 21.556 3 21.0082V2.9918C3 2.45531 3.44476 2 3.9934 2H10ZM12 4V6H14V4H12ZM10 6V8H12V6H10ZM12 8V10H14V8H12ZM10 10V12H12V10H10ZM12 12V14H10V17H14V12H12Z"
  }));
},
    ql = function ql(_ref799) {
  var _ref799$color = _ref799.color,
      C = _ref799$color === void 0 ? "currentColor" : _ref799$color,
      _ref799$size = _ref799.size,
      e = _ref799$size === void 0 ? 24 : _ref799$size,
      l = _ref799.className,
      i = _objectWithoutProperties(_ref799, _excluded799);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 22H4C3.44772 22 3 21.5523 3 21V3C3 2.44772 3.44772 2 4 2H20C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22ZM19 20V4H5V20H19ZM14 12V17H10V14H12V12H14ZM12 4H14V6H12V4ZM10 6H12V8H10V6ZM12 8H14V10H12V8ZM10 10H12V12H10V10Z"
  }));
},
    jl = function jl(_ref800) {
  var _ref800$color = _ref800.color,
      C = _ref800$color === void 0 ? "currentColor" : _ref800$color,
      _ref800$size = _ref800.size,
      e = _ref800$size === void 0 ? 24 : _ref800$size,
      l = _ref800.className,
      i = _objectWithoutProperties(_ref800, _excluded800);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 3.9934C2 3.44476 2.45531 3 2.9918 3H21.0082C21.556 3 22 3.44495 22 3.9934V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5551 2 20.0066V3.9934ZM4 5V7H6V5H4ZM18 5V7H20V5H18ZM4 9V11H6V9H4ZM18 9V11H20V9H18ZM4 13V15H6V13H4ZM18 13V15H20V13H18ZM4 17V19H6V17H4ZM18 17V19H20V17H18Z"
  }));
},
    Xl = function Xl(_ref801) {
  var _ref801$color = _ref801.color,
      C = _ref801$color === void 0 ? "currentColor" : _ref801$color,
      _ref801$size = _ref801.size,
      e = _ref801$size === void 0 ? 24 : _ref801$size,
      l = _ref801.className,
      i = _objectWithoutProperties(_ref801, _excluded801);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 3.9934C2 3.44476 2.45531 3 2.9918 3H21.0082C21.556 3 22 3.44495 22 3.9934V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5551 2 20.0066V3.9934ZM8 5V19H16V5H8ZM4 5V7H6V5H4ZM18 5V7H20V5H18ZM4 9V11H6V9H4ZM18 9V11H20V9H18ZM4 13V15H6V13H4ZM18 13V15H20V13H18ZM4 17V19H6V17H4ZM18 17V19H20V17H18Z"
  }));
},
    Jl = function Jl(_ref802) {
  var _ref802$color = _ref802.color,
      C = _ref802$color === void 0 ? "currentColor" : _ref802$color,
      _ref802$size = _ref802.size,
      e = _ref802$size === void 0 ? 24 : _ref802$size,
      l = _ref802.className,
      i = _objectWithoutProperties(_ref802, _excluded802);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10 14L4 5V3H20V5L14 14V20L10 22V14Z"
  }));
},
    Yl = function Yl(_ref803) {
  var _ref803$color = _ref803.color,
      C = _ref803$color === void 0 ? "currentColor" : _ref803$color,
      _ref803$size = _ref803.size,
      e = _ref803$size === void 0 ? 24 : _ref803$size,
      l = _ref803.className,
      i = _objectWithoutProperties(_ref803, _excluded803);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14 14V20L10 22V14L4 5V3H20V5L14 14ZM6.4037 5L12 13.3944L17.5963 5H6.4037Z"
  }));
},
    _l = function _l(_ref804) {
  var _ref804$color = _ref804.color,
      C = _ref804$color === void 0 ? "currentColor" : _ref804$color,
      _ref804$size = _ref804.size,
      e = _ref804$size === void 0 ? 24 : _ref804$size,
      l = _ref804.className,
      i = _objectWithoutProperties(_ref804, _excluded804);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10 18H14V16H10V18ZM3 6V8H21V6H3ZM6 13H18V11H6V13Z"
  }));
},
    $l = function $l(_ref805) {
  var _ref805$color = _ref805.color,
      C = _ref805$color === void 0 ? "currentColor" : _ref805$color,
      _ref805$size = _ref805.size,
      e = _ref805$size === void 0 ? 24 : _ref805$size,
      l = _ref805.className,
      i = _objectWithoutProperties(_ref805, _excluded805);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10 18H14V16H10V18ZM3 6V8H21V6H3ZM6 13H18V11H6V13Z"
  }));
},
    ei = function ei(_ref806) {
  var _ref806$color = _ref806.color,
      C = _ref806$color === void 0 ? "currentColor" : _ref806$color,
      _ref806$size = _ref806.size,
      e = _ref806$size === void 0 ? 24 : _ref806$size,
      l = _ref806.className,
      i = _objectWithoutProperties(_ref806, _excluded806);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 4V6H20L14 15V22H10V15L4 6H3V4H21Z"
  }));
},
    ti = function ti(_ref807) {
  var _ref807$color = _ref807.color,
      C = _ref807$color === void 0 ? "currentColor" : _ref807$color,
      _ref807$size = _ref807.size,
      e = _ref807$size === void 0 ? 24 : _ref807$size,
      l = _ref807.className,
      i = _objectWithoutProperties(_ref807, _excluded807);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 4V6H20L15 13.5V22H9V13.5L4 6H3V4H21ZM6.4037 6L11 12.8944V20H13V12.8944L17.5963 6H6.4037Z"
  }));
},
    Ci = function Ci(_ref808) {
  var _ref808$color = _ref808.color,
      C = _ref808$color === void 0 ? "currentColor" : _ref808$color,
      _ref808$size = _ref808.size,
      e = _ref808$size === void 0 ? 24 : _ref808$size,
      l = _ref808.className,
      i = _objectWithoutProperties(_ref808, _excluded808);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.92893 0.514648L21.0711 14.6568L19.6569 16.071L15.834 12.2486L14 14.9999V21.9999H10V14.9999L4 5.99993H3V3.99993L7.585 3.99965L5.51472 1.92886L6.92893 0.514648ZM21 3.99993V5.99993H20L18.085 8.87193L13.213 3.99993H21Z"
  }));
},
    li = function li(_ref809) {
  var _ref809$color = _ref809.color,
      C = _ref809$color === void 0 ? "currentColor" : _ref809$color,
      _ref809$size = _ref809.size,
      e = _ref809$size === void 0 ? 24 : _ref809$size,
      l = _ref809.className,
      i = _objectWithoutProperties(_ref809, _excluded809);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.92893 0.514648L21.0711 14.6568L19.6569 16.071L15.834 12.2486L15 13.4999V21.9999H9V13.4999L4 5.99993H3V3.99993L7.585 3.99965L5.51472 1.92886L6.92893 0.514648ZM9.585 5.99965L6.4037 5.99993L11 12.8944V19.9999H13V12.8944L14.392 10.8066L9.585 5.99965ZM21 3.99993V5.99993H20L18.085 8.87193L16.643 7.42893L17.5963 5.99993H15.213L13.213 3.99993H21Z"
  }));
},
    ii = function ii(_ref810) {
  var _ref810$color = _ref810.color,
      C = _ref810$color === void 0 ? "currentColor" : _ref810$color,
      _ref810$size = _ref810.size,
      e = _ref810$size === void 0 ? 24 : _ref810$size,
      l = _ref810.className,
      i = _objectWithoutProperties(_ref810, _excluded810);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18.031 16.6168L22.3137 20.8995L20.8995 22.3137L16.6168 18.031C15.0769 19.263 13.124 20 11 20C6.032 20 2 15.968 2 11C2 6.032 6.032 2 11 2C15.968 2 20 6.032 20 11C20 13.124 19.263 15.0769 18.031 16.6168ZM16.6589 9C15.8357 6.66906 13.6136 5 11 5C7.685 5 5 7.685 5 11H7C7 8.792 8.792 7 11 7C11.6912 7 12.3417 7.17563 12.9092 7.48467L12 9H16.6589ZM17 11H15C15 13.208 13.208 15 11 15C10.3088 15 9.65828 14.8244 9.0908 14.5153L10 13H7.53567H5.34109C6.16433 15.3309 8.38635 17 11 17C14.315 17 17 14.315 17 11Z"
  }));
},
    si = function si(_ref811) {
  var _ref811$color = _ref811.color,
      C = _ref811$color === void 0 ? "currentColor" : _ref811$color,
      _ref811$size = _ref811.size,
      e = _ref811$size === void 0 ? 24 : _ref811$size,
      l = _ref811.className,
      i = _objectWithoutProperties(_ref811, _excluded811);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18.0326 16.6184L22.3137 20.8995L20.8995 22.3137L16.6184 18.0326C15.0789 19.2639 13.1258 20 11 20C7.46456 20 4.40684 17.964 2.93475 15H6H9L7.69597 17.1734C8.67997 17.7009 9.80489 18 11 18C12.8956 18 14.6146 17.2475 15.8748 16.0247L16.0247 15.8748C17.2475 14.6146 18 12.8956 18 11C18 10.305 17.8988 9.63365 17.7104 9H19.7772C19.923 9.64318 20 10.3126 20 11C20 13.1258 19.2639 15.0789 18.0326 16.6184ZM19.0652 7H13L14.304 4.82662C13.32 4.29912 12.1951 4 11 4C7.1325 4 4 7.1325 4 11C4 11.695 4.10117 12.3663 4.2896 13H2.22279C2.07698 12.3568 2 11.6874 2 11C2 6.0275 6.0275 2 11 2C14.5354 2 17.5932 4.03597 19.0652 7Z"
  }));
},
    ri = function ri(_ref812) {
  var _ref812$color = _ref812.color,
      C = _ref812$color === void 0 ? "currentColor" : _ref812$color,
      _ref812$size = _ref812.size,
      e = _ref812$size === void 0 ? 24 : _ref812$size,
      l = _ref812.className,
      i = _objectWithoutProperties(_ref812, _excluded812);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21.001 3C21.5533 3 22.001 3.44772 22.001 4V20C22.001 20.5523 21.5533 21 21.001 21H3.00098C2.44869 21 2.00098 20.5523 2.00098 20V4C2.00098 3.44772 2.44869 3 3.00098 3H21.001ZM20.001 4.99996H11.5356C10.8458 6.97692 10.501 9.6436 10.501 13H13.501C13.386 13.9194 13.3504 14.8785 13.3939 15.8772C14.6196 15.6656 16.0978 15.1004 17.421 14.1679L18.5557 15.8321C16.914 16.9265 15.2534 17.6108 13.5802 17.8753C13.6316 18.2452 13.6929 18.6202 13.7642 19.0001L20.001 19V4.99996ZM6.55568 14.1679L5.44628 15.8321C7.60332 17.2701 9.79308 18 12.001 18V16C10.2089 16 8.39863 15.3966 6.55568 14.1679ZM17.001 7C17.5533 7 18.001 7.44772 18.001 8V9C18.001 9.55228 17.5533 10 17.001 10C16.4487 10 16.001 9.55228 16.001 9V8C16.001 7.44772 16.4487 7 17.001 7ZM7.00098 7C6.44869 7 6.00098 7.45174 6.00098 8C6.00098 8.3655 6.00098 8.69884 6.00098 9C6.00098 9.55228 6.44869 10 7.00098 10C7.55326 10 8.00098 9.55 8.00098 9V8C8.00098 7.44772 7.55326 7 7.00098 7Z"
  }));
},
    ci = function ci(_ref813) {
  var _ref813$color = _ref813.color,
      C = _ref813$color === void 0 ? "currentColor" : _ref813$color,
      _ref813$size = _ref813.size,
      e = _ref813$size === void 0 ? 24 : _ref813$size,
      l = _ref813.className,
      i = _objectWithoutProperties(_ref813, _excluded813);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21.001 3C21.5533 3 22.001 3.44772 22.001 4V20C22.001 20.5523 21.5533 21 21.001 21H3.00098C2.44869 21 2.00098 20.5523 2.00098 20V4C2.00098 3.44772 2.44869 3 3.00098 3H21.001ZM10.4817 4.99884L4.00098 5V19L12.747 18.9997C12.6851 18.6562 12.6308 18.3163 12.5844 17.98C12.2874 17.9933 12.0929 18 12.001 18C9.79308 18 7.60332 17.2701 5.44628 15.8321L6.55568 14.1679C8.39863 15.3966 10.2089 16 12.001 16C12.1337 16 12.2664 15.9967 12.3993 15.9901C12.3747 15.4926 12.3747 14.5797 12.4064 14H9.50098V13C9.50098 9.72527 9.82146 7.06094 10.4817 4.99884ZM12.601 4.99851C11.9358 6.58176 11.5567 9.41121 11.5119 12H14.6338L14.4933 13.124C14.3927 13.9288 14.3567 14.7687 14.3857 15.6439C15.3987 15.3449 16.4174 14.8539 17.4463 14.1679L18.5557 15.8321C17.2358 16.7119 15.9038 17.3267 14.5628 17.6714C14.62 18.1052 14.6937 18.5482 14.7819 18.999L20.001 19V5L12.601 4.99851ZM7.00098 7C7.55326 7 8.00098 7.44772 8.00098 8V9C8.00098 9.55228 7.55326 10 7.00098 10C6.44869 10 6.00098 9.55228 6.00098 9V8C6.00098 7.44772 6.44869 7 7.00098 7ZM17.001 7C17.5533 7 18.001 7.44772 18.001 8V9C18.001 9.55228 17.5533 10 17.001 10C16.4487 10 16.001 9.55228 16.001 9V8C16.001 7.44772 16.4487 7 17.001 7Z"
  }));
},
    oi = function oi(_ref814) {
  var _ref814$color = _ref814.color,
      C = _ref814$color === void 0 ? "currentColor" : _ref814$color,
      _ref814$size = _ref814.size,
      e = _ref814$size === void 0 ? 24 : _ref814$size,
      l = _ref814.className,
      i = _objectWithoutProperties(_ref814, _excluded814);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 1C16.9706 1 21 5.02944 21 10V14C21 17.0383 19.4945 19.7249 17.1887 21.3546C17.7164 19.6635 18 17.8649 18 16L17.9996 13.999H15.9996L16 16L15.997 16.3149C15.9535 18.5643 15.4459 20.7 14.5657 22.6304C13.7516 22.8705 12.8909 23 12 23C11.6587 23 11.3218 22.981 10.9903 22.944C12.2637 20.9354 13 18.5537 13 16V9H11V16L10.9963 16.2884C10.9371 18.5891 10.1714 20.7142 8.90785 22.4547C7.9456 22.1028 7.05988 21.5909 6.28319 20.9515C7.35876 19.5892 8 17.8695 8 16V10L8.0049 9.80036C8.03767 9.1335 8.23376 8.50957 8.554 7.96773L7.10935 6.52332C6.41083 7.50417 6 8.70411 6 10V16L5.99586 16.2249C5.95095 17.4436 5.54259 18.5694 4.87532 19.4973C3.69863 17.9762 3 16.0697 3 14V10C3 5.02944 7.02944 1 12 1ZM12 4C10.7042 4 9.50434 4.41077 8.52353 5.10921L9.96848 6.55356C10.5639 6.20183 11.2584 6 12 6C14.2091 6 16 7.79086 16 10V12H18V10C18 6.68629 15.3137 4 12 4Z"
  }));
},
    ai = function ai(_ref815) {
  var _ref815$color = _ref815.color,
      C = _ref815$color === void 0 ? "currentColor" : _ref815$color,
      _ref815$size = _ref815.size,
      e = _ref815$size === void 0 ? 24 : _ref815$size,
      l = _ref815.className,
      i = _objectWithoutProperties(_ref815, _excluded815);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 1C16.9706 1 21 5.02944 21 10V14C21 18.9706 16.9706 23 12 23C10.9137 23 9.8724 22.8076 8.90826 22.4549C9.03638 22.2782 9.15938 22.0977 9.27703 21.9134L9.44782 21.633C10.388 20.0636 10.9461 18.2391 10.9963 16.2884L11 16V9H13V16C13 17.7724 12.6453 19.4619 12.0031 21.0015C12.7954 21 13.5599 20.8673 14.2724 20.6229C14.7147 19.2616 14.966 17.8148 14.9968 16.3138L15 16L14.9998 12.999H16.9998L17 16C17 17.0885 16.8977 18.1531 16.7022 19.1847C18.0583 17.9552 18.9297 16.2 18.9959 14.2407L19 14V10C19 6.13401 15.866 3 12 3C10.4277 3 8.97638 3.51841 7.8078 4.39364L6.38282 2.96769C7.92242 1.73631 9.87522 1 12 1ZM7 10C7 7.23858 9.23858 5 12 5C14.7614 5 17 7.23858 17 10V11H15V10C15 8.34315 13.6569 7 12 7C10.4023 7 9.09634 8.24892 9.00509 9.82373L9 10V16C9 17.5669 8.5996 19.0402 7.89554 20.3233L7.87214 20.3627C7.64284 20.7771 7.38087 21.1711 7.09037 21.5417C6.6495 21.2545 6.23541 20.9297 5.85264 20.5719L5.5445 20.2711C3.96956 18.65 3 16.4382 3 14V10C3 7.87522 3.73631 5.92242 4.96769 4.38282L6.39364 5.8078C5.56325 6.91652 5.05405 8.27971 5.00406 9.75935L5 10V14C5 15.6748 5.58816 17.2122 6.56918 18.4169C6.82239 17.7351 6.97017 17.0034 6.99594 16.2407L7 16V10Z"
  }));
},
    ni = function ni(_ref816) {
  var _ref816$color = _ref816.color,
      C = _ref816$color === void 0 ? "currentColor" : _ref816$color,
      _ref816$size = _ref816.size,
      e = _ref816$size === void 0 ? 24 : _ref816$size,
      l = _ref816.className,
      i = _objectWithoutProperties(_ref816, _excluded816);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17.0003 13V14C17.0003 16.7696 16.3364 19.445 15.0853 21.8455L14.8585 22.2663L13.1116 21.2924C14.2716 19.2115 14.9211 16.8817 14.9935 14.4559L15.0003 14V13H17.0003ZM11.0003 10H13.0003V14L12.9948 14.3787C12.9153 17.1495 11.9645 19.7731 10.3038 21.928L10.073 22.2189L8.52406 20.9536C10.0408 19.0969 10.9145 16.8017 10.9943 14.3663L11.0003 14V10ZM12.0003 6C14.7617 6 17.0003 8.23858 17.0003 11H15.0003C15.0003 9.34315 13.6571 8 12.0003 8C10.3434 8 9.00025 9.34315 9.00025 11V14C9.00025 16.2354 8.1806 18.3444 6.72928 19.9768L6.51767 20.2067L5.06955 18.8273C6.23328 17.6056 6.92099 16.0118 6.99381 14.3027L7.00025 14V11C7.00025 8.23858 9.23883 6 12.0003 6ZM12.0003 2C16.9708 2 21.0003 6.02944 21.0003 11V14C21.0003 15.6979 20.7985 17.3699 20.4035 18.9903L20.2647 19.5285L18.3349 19.0032C18.726 17.5662 18.9475 16.0808 18.9919 14.5684L19.0003 14V11C19.0003 7.13401 15.8662 4 12.0003 4C10.4279 4 8.97663 4.51841 7.80805 5.39364L6.38308 3.96769C7.92267 2.73631 9.87547 2 12.0003 2ZM4.96794 5.38282L6.39389 6.8078C5.5635 7.91652 5.0543 9.27971 5.00431 10.7593L4.99961 10.999L5.00378 13C5.00378 14.1195 4.73991 15.2026 4.24263 16.1772L4.08648 16.4663L2.34961 15.4747C2.72889 14.8103 2.95077 14.0681 2.99539 13.2924L3.00378 13L3.00361 11C3.00025 8.87522 3.73656 6.92242 4.96794 5.38282Z"
  }));
},
    mi = function mi(_ref817) {
  var _ref817$color = _ref817.color,
      C = _ref817$color === void 0 ? "currentColor" : _ref817$color,
      _ref817$size = _ref817.size,
      e = _ref817$size === void 0 ? 24 : _ref817$size,
      l = _ref817.className,
      i = _objectWithoutProperties(_ref817, _excluded817);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17.0003 13V14C17.0003 16.7696 16.3364 19.445 15.0853 21.8455L14.8585 22.2663L13.1116 21.2924C14.2716 19.2115 14.9211 16.8817 14.9935 14.4559L15.0003 14V13H17.0003ZM11.0003 10H13.0003V14L12.9948 14.3787C12.9153 17.1495 11.9645 19.7731 10.3038 21.928L10.073 22.2189L8.52406 20.9536C10.0408 19.0969 10.9145 16.8017 10.9943 14.3663L11.0003 14V10ZM12.0003 6C14.7617 6 17.0003 8.23858 17.0003 11H15.0003C15.0003 9.34315 13.6571 8 12.0003 8C10.3434 8 9.00025 9.34315 9.00025 11V14C9.00025 16.2354 8.1806 18.3444 6.72928 19.9768L6.51767 20.2067L5.06955 18.8273C6.23328 17.6056 6.92099 16.0118 6.99381 14.3027L7.00025 14V11C7.00025 8.23858 9.23883 6 12.0003 6ZM12.0003 2C16.9708 2 21.0003 6.02944 21.0003 11V14C21.0003 15.6979 20.7985 17.3699 20.4035 18.9903L20.2647 19.5285L18.3349 19.0032C18.726 17.5662 18.9475 16.0808 18.9919 14.5684L19.0003 14V11C19.0003 7.13401 15.8662 4 12.0003 4C10.4279 4 8.97663 4.51841 7.80805 5.39364L6.38308 3.96769C7.92267 2.73631 9.87547 2 12.0003 2ZM4.96794 5.38282L6.39389 6.8078C5.5635 7.91652 5.0543 9.27971 5.00431 10.7593L4.99961 10.999L5.00378 13C5.00378 14.1195 4.73991 15.2026 4.24263 16.1772L4.08648 16.4663L2.34961 15.4747C2.72889 14.8103 2.95077 14.0681 2.99539 13.2924L3.00378 13L3.00361 11C3.00025 8.87522 3.73656 6.92242 4.96794 5.38282Z"
  }));
},
    wi = function wi(_ref818) {
  var _ref818$color = _ref818.color,
      C = _ref818$color === void 0 ? "currentColor" : _ref818$color,
      _ref818$size = _ref818.size,
      e = _ref818$size === void 0 ? 24 : _ref818$size,
      l = _ref818.className,
      i = _objectWithoutProperties(_ref818, _excluded818);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 23C7.85786 23 4.5 19.6421 4.5 15.5C4.5 13.3462 5.40786 11.4045 6.86179 10.0366C8.20403 8.77375 11.5 6.49951 11 1.5C17 5.5 20 9.5 14 15.5C15 15.5 16.5 15.5 19 13.0296C19.2697 13.8032 19.5 14.6345 19.5 15.5C19.5 19.6421 16.1421 23 12 23Z"
  }));
},
    Li = function Li(_ref819) {
  var _ref819$color = _ref819.color,
      C = _ref819$color === void 0 ? "currentColor" : _ref819$color,
      _ref819$size = _ref819.size,
      e = _ref819$size === void 0 ? 24 : _ref819$size,
      l = _ref819.className,
      i = _objectWithoutProperties(_ref819, _excluded819);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 23C16.1421 23 19.5 19.6421 19.5 15.5C19.5 14.6345 19.2697 13.8032 19 13.0296C17.3333 14.6765 16.0667 15.5 15.2 15.5C19.1954 8.5 17 5.5 11 1.5C11.5 6.49951 8.20403 8.77375 6.86179 10.0366C5.40786 11.4045 4.5 13.3462 4.5 15.5C4.5 19.6421 7.85786 23 12 23ZM12.7094 5.23498C15.9511 7.98528 15.9666 10.1223 13.463 14.5086C12.702 15.8419 13.6648 17.5 15.2 17.5C15.8884 17.5 16.5841 17.2992 17.3189 16.9051C16.6979 19.262 14.5519 21 12 21C8.96243 21 6.5 18.5376 6.5 15.5C6.5 13.9608 7.13279 12.5276 8.23225 11.4932C8.35826 11.3747 8.99749 10.8081 9.02477 10.7836C9.44862 10.4021 9.7978 10.0663 10.1429 9.69677C11.3733 8.37932 12.2571 6.91631 12.7094 5.23498Z"
  }));
},
    hi = function hi(_ref820) {
  var _ref820$color = _ref820.color,
      C = _ref820$color === void 0 ? "currentColor" : _ref820$color,
      _ref820$size = _ref820.size,
      e = _ref820$size === void 0 ? 24 : _ref820$size,
      l = _ref820.className,
      i = _objectWithoutProperties(_ref820, _excluded820);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.001 2C17.5238 2 22.001 6.47715 22.001 12C22.001 17.5228 17.5238 22 12.001 22C6.47813 22 2.00098 17.5228 2.00098 12C2.00098 10.5365 2.31538 9.14635 2.88033 7.89353C3.34744 6.95503 4.11409 6.01955 4.73082 5.7004C4.07759 6.98266 3.75823 8.24073 3.69049 9.08266C4.14533 7.58266 5.00622 6.32621 6.21106 5.43911C8.27719 3.92016 11.059 3.85202 12.1671 4.81976C10.1107 5.52581 7.87073 8.36653 8.36428 11.6952C8.44419 12.2447 8.60906 12.7785 8.85299 13.2774C8.46912 12.2661 8.43525 10.8435 9.05461 9.91935C9.74654 8.88911 10.7332 8.67137 11.2607 8.78266C11.0526 8.73911 10.5929 9.61936 10.5252 9.77419C10.3523 10.1679 10.2664 10.5943 10.2736 11.0242C10.2888 11.9223 10.6594 12.7778 11.3042 13.4032C13.2256 15.2754 16.3268 14.5387 17.7155 12.4016C18.6687 10.9306 18.7848 8.43427 17.5607 6.4504C17.2554 5.96696 16.8913 5.52325 16.4768 5.12944C14.6262 3.36387 11.9979 2.56054 9.49503 2.92549C8.38907 3.10214 7.44765 3.42052 6.67077 3.88065C7.75554 2.79776 9.9123 2 12.001 2Z"
  }));
},
    Hi = function Hi(_ref821) {
  var _ref821$color = _ref821.color,
      C = _ref821$color === void 0 ? "currentColor" : _ref821$color,
      _ref821$size = _ref821.size,
      e = _ref821$size === void 0 ? 24 : _ref821$size,
      l = _ref821.className,
      i = _objectWithoutProperties(_ref821, _excluded821);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.001 2C17.5238 2 22.001 6.47715 22.001 12C22.001 17.5228 17.5238 22 12.001 22C6.47813 22 2.00098 17.5228 2.00098 12C2.00098 10.5365 2.31538 9.14635 2.88033 7.89353C3.34744 6.95503 4.11409 6.01955 4.73082 5.7004C4.07759 6.98266 3.75823 8.24073 3.69049 9.08266C4.14533 7.58266 5.00622 6.32621 6.21106 5.43911C8.27719 3.92016 11.059 3.85202 12.1671 4.81976C10.1107 5.52581 7.87073 8.36653 8.36428 11.6952C8.44419 12.2447 8.60906 12.7785 8.85299 13.2774C8.46912 12.2661 8.43525 10.8435 9.05461 9.91935C9.74654 8.88911 10.7332 8.67137 11.2607 8.78266C11.0526 8.73911 10.5929 9.61936 10.5252 9.77419C10.3523 10.1679 10.2664 10.5943 10.2736 11.0242C10.2888 11.9223 10.6594 12.7778 11.3042 13.4032C13.2256 15.2754 16.3268 14.5387 17.7155 12.4016C18.6687 10.9306 18.7848 8.43427 17.5607 6.4504C17.2554 5.96696 16.8913 5.52325 16.4768 5.12944C14.6262 3.36387 11.9979 2.56054 9.49503 2.92549C8.38907 3.10214 7.44765 3.42052 6.67077 3.88065C7.75554 2.79776 9.9123 2 12.001 2ZM6.87552 7.7048C4.62257 8.48634 3.37469 10.8751 4.29738 14.165C5.22008 17.4549 8.19356 19.8873 11.7518 19.9962L12.001 20C16.2525 20 19.7295 16.6835 19.9858 12.4965L19.995 12.284C19.8654 12.6327 19.7118 12.958 19.5321 13.2648L19.3925 13.4914C17.2881 16.7299 12.7109 17.5664 9.91169 14.8388C9.52745 14.4661 9.20448 14.042 8.94958 13.5821L8.84398 13.381C7.10788 12.994 6.26027 12.0549 6.30116 10.5637C6.32833 9.5728 6.53175 8.6049 6.87552 7.7048Z"
  }));
},
    Vi = function Vi(_ref822) {
  var _ref822$color = _ref822.color,
      C = _ref822$color === void 0 ? "currentColor" : _ref822$color,
      _ref822$size = _ref822.size,
      e = _ref822$size === void 0 ? 24 : _ref822$size,
      l = _ref822.className,
      i = _objectWithoutProperties(_ref822, _excluded822);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16 1C16.5523 1 17 1.44772 17 2V5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V6C2 5.44772 2.44772 5 3 5H7V2C7 1.44772 7.44772 1 8 1H16ZM13 9H11V12H8V14H10.999L11 17H13L12.999 14H16V12H13V9ZM15 3H9V5H15V3Z"
  }));
},
    gi = function gi(_ref823) {
  var _ref823$color = _ref823.color,
      C = _ref823$color === void 0 ? "currentColor" : _ref823$color,
      _ref823$size = _ref823.size,
      e = _ref823$size === void 0 ? 24 : _ref823$size,
      l = _ref823.className,
      i = _objectWithoutProperties(_ref823, _excluded823);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16 1C16.5523 1 17 1.44772 17 2V5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V6C2 5.44772 2.44772 5 3 5H7V2C7 1.44772 7.44772 1 8 1H16ZM20 7H4V19H20V7ZM13 9V12H16V14H12.999L13 17H11L10.999 14H8V12H11V9H13ZM15 3H9V5H15V3Z"
  }));
},
    Mi = function Mi(_ref824) {
  var _ref824$color = _ref824.color,
      C = _ref824$color === void 0 ? "currentColor" : _ref824$color,
      _ref824$size = _ref824.size,
      e = _ref824$size === void 0 ? 24 : _ref824$size,
      l = _ref824.className,
      i = _objectWithoutProperties(_ref824, _excluded824);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 3H21.1384C21.4146 3 21.6385 3.22386 21.6385 3.5C21.6385 3.58701 21.6157 3.67252 21.5725 3.74807L18 10L21.5725 16.2519C21.7095 16.4917 21.6262 16.7971 21.3865 16.9341C21.3109 16.9773 21.2254 17 21.1384 17H4V22H2V3Z"
  }));
},
    Zi = function Zi(_ref825) {
  var _ref825$color = _ref825.color,
      C = _ref825$color === void 0 ? "currentColor" : _ref825$color,
      _ref825$size = _ref825.size,
      e = _ref825$size === void 0 ? 24 : _ref825$size,
      l = _ref825.className,
      i = _objectWithoutProperties(_ref825, _excluded825);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21.1384 3C21.4146 3 21.6385 3.22386 21.6385 3.5C21.6385 3.58701 21.6157 3.67252 21.5725 3.74807L18 10L21.5725 16.2519C21.7095 16.4917 21.6262 16.7971 21.3865 16.9341C21.3109 16.9773 21.2254 17 21.1384 17H4V22H2V3H21.1384ZM18.5536 5H4V15H18.5536L15.6965 10L18.5536 5Z"
  }));
},
    xi = function xi(_ref826) {
  var _ref826$color = _ref826.color,
      C = _ref826$color === void 0 ? "currentColor" : _ref826$color,
      _ref826$size = _ref826.size,
      e = _ref826$size === void 0 ? 24 : _ref826$size,
      l = _ref826.className,
      i = _objectWithoutProperties(_ref826, _excluded826);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 3H12.382C12.7607 3 13.107 3.214 13.2764 3.55279L14 5H20C20.5523 5 21 5.44772 21 6V17C21 17.5523 20.5523 18 20 18H13.618C13.2393 18 12.893 17.786 12.7236 17.4472L12 16H5V22H3V3Z"
  }));
},
    vi = function vi(_ref827) {
  var _ref827$color = _ref827.color,
      C = _ref827$color === void 0 ? "currentColor" : _ref827$color,
      _ref827$size = _ref827.size,
      e = _ref827$size === void 0 ? 24 : _ref827$size,
      l = _ref827.className,
      i = _objectWithoutProperties(_ref827, _excluded827);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.382 3C12.7607 3 13.107 3.214 13.2764 3.55279L14 5H20C20.5523 5 21 5.44772 21 6V17C21 17.5523 20.5523 18 20 18H13.618C13.2393 18 12.893 17.786 12.7236 17.4472L12 16H5V22H3V3H12.382ZM11.7639 5H5V14H13.2361L14.2361 16H19V7H12.7639L11.7639 5Z"
  }));
},
    di = function di(_ref828) {
  var _ref828$color = _ref828.color,
      C = _ref828$color === void 0 ? "currentColor" : _ref828$color,
      _ref828$size = _ref828.size,
      e = _ref828$size === void 0 ? 24 : _ref828$size,
      l = _ref828.className,
      i = _objectWithoutProperties(_ref828, _excluded828);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13 10H20L11 23V14H4L13 1V10Z"
  }));
},
    pi = function pi(_ref829) {
  var _ref829$color = _ref829.color,
      C = _ref829$color === void 0 ? "currentColor" : _ref829$color,
      _ref829$size = _ref829.size,
      e = _ref829$size === void 0 ? 24 : _ref829$size,
      l = _ref829.className,
      i = _objectWithoutProperties(_ref829, _excluded829);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13 9H21L11 24V15H4L13 0V9ZM11 11V7.22063L7.53238 13H13V17.3944L17.263 11H11Z"
  }));
},
    Ei = function Ei(_ref830) {
  var _ref830$color = _ref830.color,
      C = _ref830$color === void 0 ? "currentColor" : _ref830$color,
      _ref830$size = _ref830.size,
      e = _ref830$size === void 0 ? 24 : _ref830$size,
      l = _ref830.className,
      i = _objectWithoutProperties(_ref830, _excluded830);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15.9994 2V4H14.9994V7.24291C14.9994 8.40051 15.2506 9.54432 15.7357 10.5954L20.017 19.8714C20.3641 20.6236 20.0358 21.5148 19.2836 21.8619C19.0865 21.9529 18.8721 22 18.655 22H5.34375C4.51532 22 3.84375 21.3284 3.84375 20.5C3.84375 20.2829 3.89085 20.0685 3.98181 19.8714L8.26306 10.5954C8.74816 9.54432 8.99939 8.40051 8.99939 7.24291V4H7.99939V2H15.9994ZM12.9994 4H10.9994V8H12.9994V4Z"
  }));
},
    Ni = function Ni(_ref831) {
  var _ref831$color = _ref831.color,
      C = _ref831$color === void 0 ? "currentColor" : _ref831$color,
      _ref831$size = _ref831.size,
      e = _ref831$size === void 0 ? 24 : _ref831$size,
      l = _ref831.className,
      i = _objectWithoutProperties(_ref831, _excluded831);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15.9994 2V4H14.9994V7.24291C14.9994 8.40051 15.2506 9.54432 15.7357 10.5954L20.017 19.8714C20.3641 20.6236 20.0358 21.5148 19.2836 21.8619C19.0865 21.9529 18.8721 22 18.655 22H5.34375C4.51532 22 3.84375 21.3284 3.84375 20.5C3.84375 20.2829 3.89085 20.0685 3.98181 19.8714L8.26306 10.5954C8.74816 9.54432 8.99939 8.40051 8.99939 7.24291V4H7.99939V2H15.9994ZM13.3873 10.0012H10.6115C10.5072 10.3644 10.3823 10.7221 10.2371 11.0724L10.079 11.4335L6.12439 20H17.8734L13.9198 11.4335C13.7054 10.9691 13.5276 10.4902 13.3873 10.0012ZM10.9994 7.24291C10.9994 7.49626 10.9898 7.7491 10.9706 8.00087H13.0282C13.0189 7.87982 13.0119 7.75852 13.0072 7.63704L12.9994 7.24291V4H10.9994V7.24291Z"
  }));
},
    ui = function ui(_ref832) {
  var _ref832$color = _ref832.color,
      C = _ref832$color === void 0 ? "currentColor" : _ref832$color,
      _ref832$size = _ref832.size,
      e = _ref832$size === void 0 ? 24 : _ref832$size,
      l = _ref832.className,
      i = _objectWithoutProperties(_ref832, _excluded832);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.949 14.8882C20.7346 15.6884 19.9121 16.1633 19.1119 15.9489L3.44528 11.751C3.00205 11.6323 2.69653 11.2271 2.70424 10.7683L2.79514 5.36515L4.24403 5.75338L5.15891 9.10435L10.2542 10.4696L9.88479 2.08844L11.8166 2.60608L14.6269 11.6413L19.8883 13.0511C20.6885 13.2655 21.1634 14.088 20.949 14.8882ZM4.00008 19H20.0001V21H4.00008V19Z"
  }));
},
    Bi = function Bi(_ref833) {
  var _ref833$color = _ref833.color,
      C = _ref833$color === void 0 ? "currentColor" : _ref833$color,
      _ref833$size = _ref833.size,
      e = _ref833$size === void 0 ? 24 : _ref833$size,
      l = _ref833.className,
      i = _objectWithoutProperties(_ref833, _excluded833);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.949 14.8882C20.7346 15.6884 19.9121 16.1633 19.1119 15.9489L3.44528 11.751C3.00205 11.6323 2.69653 11.2271 2.70424 10.7683L2.79514 5.36515L4.24403 5.75338L5.15891 9.10435L10.2542 10.4696L9.88479 2.08844L11.8166 2.60608L14.6269 11.6413L19.8883 13.0511C20.6885 13.2655 21.1634 14.088 20.949 14.8882ZM4.00008 19H20.0001V21H4.00008V19Z"
  }));
},
    fi = function fi(_ref834) {
  var _ref834$color = _ref834.color,
      C = _ref834$color === void 0 ? "currentColor" : _ref834$color,
      _ref834$size = _ref834.size,
      e = _ref834$size === void 0 ? 24 : _ref834$size,
      l = _ref834.className,
      i = _objectWithoutProperties(_ref834, _excluded834);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21.949 10.1118C22.1634 10.912 21.6886 11.7345 20.8884 11.9489L5.2218 16.1467C4.77856 16.2655 4.31138 16.0674 4.08866 15.6662L1.46582 10.9415L2.91471 10.5533L5.3825 12.9979L10.4778 11.6326L5.96728 4.55896L7.89913 4.04132L14.8505 10.4609L20.1119 9.05113C20.9121 8.83671 21.7346 9.31159 21.949 10.1118ZM4.00013 19H20.0001V21H4.00013V19Z"
  }));
},
    Ri = function Ri(_ref835) {
  var _ref835$color = _ref835.color,
      C = _ref835$color === void 0 ? "currentColor" : _ref835$color,
      _ref835$size = _ref835.size,
      e = _ref835$size === void 0 ? 24 : _ref835$size,
      l = _ref835.className,
      i = _objectWithoutProperties(_ref835, _excluded835);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21.949 10.1118C22.1634 10.912 21.6886 11.7345 20.8884 11.9489L5.2218 16.1467C4.77856 16.2655 4.31138 16.0674 4.08866 15.6662L1.46582 10.9415L2.91471 10.5533L5.3825 12.9979L10.4778 11.6326L5.96728 4.55896L7.89913 4.04132L14.8505 10.4609L20.1119 9.05113C20.9121 8.83671 21.7346 9.31159 21.949 10.1118ZM4.00013 19H20.0001V21H4.00013V19Z"
  }));
},
    zi = function zi(_ref836) {
  var _ref836$color = _ref836.color,
      C = _ref836$color === void 0 ? "currentColor" : _ref836$color,
      _ref836$size = _ref836.size,
      e = _ref836$size === void 0 ? 24 : _ref836$size,
      l = _ref836.className,
      i = _objectWithoutProperties(_ref836, _excluded836);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16.0001 17.4723C17.0616 18.4223 18.4634 19 20 19H22V21H20C18.5428 21 17.1766 20.6104 15.9998 19.9296C14.8242 20.6101 13.4576 21 12 21C10.5428 21 9.17657 20.6104 7.99984 19.9296C6.8242 20.6101 5.45763 21 4 21H2V19H4C5.53713 19 6.93925 18.422 8.00013 17.4723C9.06163 18.4223 10.4634 19 12 19C13.5371 19 14.9393 18.422 16.0001 17.4723ZM12.5734 1.53204L12.6727 1.6115L23 11H20V17C18.3643 17 16.912 16.2145 15.9998 15.0002C15.088 16.2145 13.6357 17 12 17C10.3643 17 8.91199 16.2145 7.99978 15.0002C7.08801 16.2145 5.63573 17 4 17L3.999 10.9994L1 11L11.3273 1.6115C11.6452 1.32254 12.1027 1.27439 12.4671 1.46702L12.5734 1.53204Z"
  }));
},
    Fi = function Fi(_ref837) {
  var _ref837$color = _ref837.color,
      C = _ref837$color === void 0 ? "currentColor" : _ref837$color,
      _ref837$size = _ref837.size,
      e = _ref837$size === void 0 ? 24 : _ref837$size,
      l = _ref837.className,
      i = _objectWithoutProperties(_ref837, _excluded837);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16.0001 17.4723C17.0616 18.4223 18.4634 19 20 19H22V21H20C18.5428 21 17.1766 20.6104 15.9998 19.9296C14.8242 20.6101 13.4576 21 12 21C10.5428 21 9.17657 20.6104 7.99984 19.9296C6.8242 20.6101 5.45763 21 4 21H2V19H4C5.53713 19 6.93925 18.422 8.00013 17.4723C9.06163 18.4223 10.4634 19 12 19C13.5371 19 14.9393 18.422 16.0001 17.4723ZM12.5734 1.53204L12.6727 1.6115L23 11H20V17C19.2988 17 18.6258 16.8797 18.0003 16.6587L18 9.15698L12 3.70198L6 9.15598L6.00125 16.6582C5.4648 16.8479 4.89325 16.9635 4.29898 16.9927L4 17V11H1L11.3273 1.6115C11.677 1.29365 12.1956 1.26716 12.5734 1.53204Z"
  }));
},
    Si = function Si(_ref838) {
  var _ref838$color = _ref838.color,
      C = _ref838$color === void 0 ? "currentColor" : _ref838$color,
      _ref838$size = _ref838.size,
      e = _ref838$size === void 0 ? 24 : _ref838$size,
      l = _ref838.className,
      i = _objectWithoutProperties(_ref838, _excluded838);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6 21.5C4.067 21.5 2.5 19.933 2.5 18C2.5 16.067 4.067 14.5 6 14.5C7.5852 14.5 8.92427 15.5539 9.35481 16.9992L15 16.9994V15L17 14.9994V9.24339L14.757 6.99938H9V9.00003H3V3.00003H9V4.99939H14.757L18 1.75739L22.2426 6.00003L19 9.24139V14.9994L21 15V21H15V18.9994L9.35499 19.0003C8.92464 20.4459 7.58543 21.5 6 21.5ZM6 16.5C5.17157 16.5 4.5 17.1716 4.5 18C4.5 18.8285 5.17157 19.5 6 19.5C6.82843 19.5 7.5 18.8285 7.5 18C7.5 17.1716 6.82843 16.5 6 16.5ZM19 17H17V19H19V17ZM18 4.58581L16.5858 6.00003L18 7.41424L19.4142 6.00003L18 4.58581ZM7 5.00003H5V7.00003H7V5.00003Z"
  }));
},
    Ai = function Ai(_ref839) {
  var _ref839$color = _ref839.color,
      C = _ref839$color === void 0 ? "currentColor" : _ref839$color,
      _ref839$size = _ref839.size,
      e = _ref839$size === void 0 ? 24 : _ref839$size,
      l = _ref839.className,
      i = _objectWithoutProperties(_ref839, _excluded839);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13.5039 2.00098L3.50391 12.001L6.58724 15.0843L19.6673 2.00098H13.5039ZM13.4985 11.1989L8.12328 16.6199L13.4956 21.9998H19.6842L14.2975 16.5999L19.6856 11.1998L13.4985 11.1989Z"
  }));
},
    ki = function ki(_ref840) {
  var _ref840$color = _ref840.color,
      C = _ref840$color === void 0 ? "currentColor" : _ref840$color,
      _ref840$size = _ref840.size,
      e = _ref840$size === void 0 ? 24 : _ref840$size,
      l = _ref840.className,
      i = _objectWithoutProperties(_ref840, _excluded840);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14.5979 10.6843H17.4264L11.7688 16.3419L17.4264 21.998H14.5979L8.94108 16.3412L14.5979 10.6843ZM14.4044 2.00439H17.2328L5.9191 13.3181L4.50488 11.9039L14.4044 2.00439Z"
  }));
},
    Pi = function Pi(_ref841) {
  var _ref841$color = _ref841.color,
      C = _ref841$color === void 0 ? "currentColor" : _ref841$color,
      _ref841$size = _ref841.size,
      e = _ref841$size === void 0 ? 24 : _ref841$size,
      l = _ref841.className,
      i = _objectWithoutProperties(_ref841, _excluded841);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2ZM12 20C16.4267 20 20 16.4267 20 12C20 7.57333 16.4267 4 12 4C7.57333 4 4 7.57333 4 12C4 16.4267 7.57333 20 12 20ZM12 18C8.68 18 6 15.32 6 12C6 8.68 8.68 6 12 6C15.32 6 18 8.68 18 12C18 15.32 15.32 18 12 18ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10Z"
  }));
},
    Di = function Di(_ref842) {
  var _ref842$color = _ref842.color,
      C = _ref842$color === void 0 ? "currentColor" : _ref842$color,
      _ref842$size = _ref842.size,
      e = _ref842$size === void 0 ? 24 : _ref842$size,
      l = _ref842.className,
      i = _objectWithoutProperties(_ref842, _excluded842);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16ZM12 18C8.68629 18 6 15.3137 6 12C6 8.68629 8.68629 6 12 6C15.3137 6 18 8.68629 18 12C18 15.3137 15.3137 18 12 18ZM12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14Z"
  }));
},
    yi = function yi(_ref843) {
  var _ref843$color = _ref843.color,
      C = _ref843$color === void 0 ? "currentColor" : _ref843$color,
      _ref843$size = _ref843.size,
      e = _ref843$size === void 0 ? 24 : _ref843$size,
      l = _ref843.className,
      i = _objectWithoutProperties(_ref843, _excluded843);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13 1L13.001 4.06201C16.6192 4.51365 19.4869 7.38163 19.9381 11L23 11V13L19.938 13.001C19.4864 16.6189 16.6189 19.4864 13.001 19.938L13 23H11L11 19.9381C7.38163 19.4869 4.51365 16.6192 4.06201 13.001L1 13V11L4.06189 11C4.51312 7.38129 7.38129 4.51312 11 4.06189L11 1H13ZM12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10Z"
  }));
},
    bi = function bi(_ref844) {
  var _ref844$color = _ref844.color,
      C = _ref844$color === void 0 ? "currentColor" : _ref844$color,
      _ref844$size = _ref844.size,
      e = _ref844$size === void 0 ? 24 : _ref844$size,
      l = _ref844.className,
      i = _objectWithoutProperties(_ref844, _excluded844);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13 1L13.001 4.06201C16.6192 4.51365 19.4869 7.38163 19.9381 11L23 11V13L19.938 13.001C19.4864 16.6189 16.6189 19.4864 13.001 19.938L13 23H11L11 19.9381C7.38163 19.4869 4.51365 16.6192 4.06201 13.001L1 13V11L4.06189 11C4.51312 7.38129 7.38129 4.51312 11 4.06189L11 1H13ZM12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6ZM12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10Z"
  }));
},
    Ti = function Ti(_ref845) {
  var _ref845$color = _ref845.color,
      C = _ref845$color === void 0 ? "currentColor" : _ref845$color,
      _ref845$size = _ref845.size,
      e = _ref845$size === void 0 ? 24 : _ref845$size,
      l = _ref845.className,
      i = _objectWithoutProperties(_ref845, _excluded845);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10Z"
  }));
},
    Ui = function Ui(_ref846) {
  var _ref846$color = _ref846.color,
      C = _ref846$color === void 0 ? "currentColor" : _ref846$color,
      _ref846$size = _ref846.size,
      e = _ref846$size === void 0 ? 24 : _ref846$size,
      l = _ref846.className,
      i = _objectWithoutProperties(_ref846, _excluded846);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14Z"
  }));
},
    Gi = function Gi(_ref847) {
  var _ref847$color = _ref847.color,
      C = _ref847$color === void 0 ? "currentColor" : _ref847$color,
      _ref847$size = _ref847.size,
      e = _ref847$size === void 0 ? 24 : _ref847$size,
      l = _ref847.className,
      i = _objectWithoutProperties(_ref847, _excluded847);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M1.5843 13.0069C1.20753 12.0786 1 11.0635 1 10C1 5.58172 4.58172 2 9 2C12.3949 2 15.2959 4.11466 16.4576 7.09864C16.7951 7.0339 17.1436 7 17.5 7C20.5376 7 23 9.46243 23 12.5C23 12.6709 22.9922 12.8399 22.977 13.0069H1.5843ZM4 19H21V21H4V19ZM2 15H23V17H2V15Z"
  }));
},
    Ii = function Ii(_ref848) {
  var _ref848$color = _ref848.color,
      C = _ref848$color === void 0 ? "currentColor" : _ref848$color,
      _ref848$size = _ref848.size,
      e = _ref848$size === void 0 ? 24 : _ref848$size,
      l = _ref848.className,
      i = _objectWithoutProperties(_ref848, _excluded848);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M1.5843 13.0069C1.20753 12.0786 1 11.0635 1 10C1 5.58172 4.58172 2 9 2C12.3949 2 15.2959 4.11466 16.4576 7.09864C16.7951 7.0339 17.1436 7 17.5 7C20.5376 7 23 9.46243 23 12.5C23 12.6709 22.9922 12.8399 22.977 13.0069H20.9636C20.9876 12.8414 21 12.6721 21 12.5C21 10.567 19.433 9 17.5 9C16.5205 9 15.6351 9.40232 14.9998 10.0507C14.9999 10.0338 15 10.0169 15 10C15 6.68629 12.3137 4 9 4C5.68629 4 3 6.68629 3 10C3 11.0957 3.2937 12.1228 3.80666 13.0069H1.5843ZM4 19H21V21H4V19ZM2 15H23V17H2V15Z"
  }));
},
    Wi = function Wi(_ref849) {
  var _ref849$color = _ref849.color,
      C = _ref849$color === void 0 ? "currentColor" : _ref849$color,
      _ref849$size = _ref849.size,
      e = _ref849$size === void 0 ? 24 : _ref849$size,
      l = _ref849.className,
      i = _objectWithoutProperties(_ref849, _excluded849);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22 11V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V11H22ZM22 9H2V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5H21C21.5523 5 22 5.44772 22 6V9Z"
  }));
},
    Oi = function Oi(_ref850) {
  var _ref850$color = _ref850.color,
      C = _ref850$color === void 0 ? "currentColor" : _ref850$color,
      _ref850$size = _ref850.size,
      e = _ref850$size === void 0 ? 24 : _ref850$size,
      l = _ref850.className,
      i = _objectWithoutProperties(_ref850, _excluded850);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5ZM20 11H4V19H20V11ZM20 9V7H11.5858L9.58579 5H4V9H20Z"
  }));
},
    Ki = function Ki(_ref851) {
  var _ref851$color = _ref851.color,
      C = _ref851$color === void 0 ? "currentColor" : _ref851$color,
      _ref851$size = _ref851.size,
      e = _ref851$size === void 0 ? 24 : _ref851$size,
      l = _ref851.className,
      i = _objectWithoutProperties(_ref851, _excluded851);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22 8V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V7H21C21.5523 7 22 7.44772 22 8ZM12.4142 5H2V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5Z"
  }));
},
    Qi = function Qi(_ref852) {
  var _ref852$color = _ref852.color,
      C = _ref852$color === void 0 ? "currentColor" : _ref852$color,
      _ref852$size = _ref852.size,
      e = _ref852$size === void 0 ? 24 : _ref852$size,
      l = _ref852.className,
      i = _objectWithoutProperties(_ref852, _excluded852);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5ZM4 7V19H20V7H4Z"
  }));
},
    qi = function qi(_ref853) {
  var _ref853$color = _ref853.color,
      C = _ref853$color === void 0 ? "currentColor" : _ref853$color,
      _ref853$size = _ref853.size,
      e = _ref853$size === void 0 ? 24 : _ref853$size,
      l = _ref853.className,
      i = _objectWithoutProperties(_ref853, _excluded853);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8 21V11H22V20C22 20.5523 21.5523 21 21 21H8ZM6 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5H21C21.5523 5 22 5.44772 22 6V9H7C6.44772 9 6 9.44772 6 10V21Z"
  }));
},
    ji = function ji(_ref854) {
  var _ref854$color = _ref854.color,
      C = _ref854$color === void 0 ? "currentColor" : _ref854$color,
      _ref854$size = _ref854.size,
      e = _ref854$size === void 0 ? 24 : _ref854$size,
      l = _ref854.className,
      i = _objectWithoutProperties(_ref854, _excluded854);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5ZM8 19H20V11H8V19ZM6 19V10C6 9.44772 6.44772 9 7 9H20V7H11.5858L9.58579 5H4V19H6Z"
  }));
},
    Xi = function Xi(_ref855) {
  var _ref855$color = _ref855.color,
      C = _ref855$color === void 0 ? "currentColor" : _ref855$color,
      _ref855$size = _ref855.size,
      e = _ref855$size === void 0 ? 24 : _ref855$size,
      l = _ref855.className,
      i = _objectWithoutProperties(_ref855, _excluded855);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13.4144 5H20.0002C20.5525 5 21.0002 5.44772 21.0002 6V7H3.00017V4C3.00017 3.44772 3.44789 3 4.00017 3H11.4144L13.4144 5ZM3.08697 9H20.9134C21.4657 9 21.9134 9.44772 21.9134 10C21.9134 10.0277 21.9122 10.0554 21.9099 10.083L21.0766 20.083C21.0334 20.6013 20.6001 21 20.08 21H3.9203C3.40021 21 2.96695 20.6013 2.92376 20.083L2.09042 10.083C2.04456 9.53267 2.45355 9.04932 3.00392 9.00345C3.03155 9.00115 3.05925 9 3.08697 9Z"
  }));
},
    Ji = function Ji(_ref856) {
  var _ref856$color = _ref856.color,
      C = _ref856$color === void 0 ? "currentColor" : _ref856$color,
      _ref856$size = _ref856.size,
      e = _ref856$size === void 0 ? 24 : _ref856$size,
      l = _ref856.className,
      i = _objectWithoutProperties(_ref856, _excluded856);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3.08697 9H20.9134C21.4657 9 21.9134 9.44772 21.9134 10C21.9134 10.0277 21.9122 10.0554 21.9099 10.083L21.0766 20.083C21.0334 20.6013 20.6001 21 20.08 21H3.9203C3.40021 21 2.96695 20.6013 2.92376 20.083L2.09042 10.083C2.04456 9.53267 2.45355 9.04932 3.00392 9.00345C3.03155 9.00115 3.05925 9 3.08697 9ZM4.84044 19H19.1599L19.8266 11H4.17377L4.84044 19ZM13.4144 5H20.0002C20.5525 5 21.0002 5.44772 21.0002 6V7H3.00017V4C3.00017 3.44772 3.44789 3 4.00017 3H11.4144L13.4144 5Z"
  }));
},
    Yi = function Yi(_ref857) {
  var _ref857$color = _ref857.color,
      C = _ref857$color === void 0 ? "currentColor" : _ref857$color,
      _ref857$size = _ref857.size,
      e = _ref857$size === void 0 ? 24 : _ref857$size,
      l = _ref857.className,
      i = _objectWithoutProperties(_ref857, _excluded857);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5ZM11 12H8V14H11V17H13V14H16V12H13V9H11V12Z"
  }));
},
    _i = function _i(_ref858) {
  var _ref858$color = _ref858.color,
      C = _ref858$color === void 0 ? "currentColor" : _ref858$color,
      _ref858$size = _ref858.size,
      e = _ref858$size === void 0 ? 24 : _ref858$size,
      l = _ref858.className,
      i = _objectWithoutProperties(_ref858, _excluded858);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5ZM4 5V19H20V7H11.5858L9.58579 5H4ZM11 12V9H13V12H16V14H13V17H11V14H8V12H11Z"
  }));
},
    $i = function $i(_ref859) {
  var _ref859$color = _ref859.color,
      C = _ref859$color === void 0 ? "currentColor" : _ref859$color,
      _ref859$size = _ref859.size,
      e = _ref859$size === void 0 ? 24 : _ref859$size,
      l = _ref859.className,
      i = _objectWithoutProperties(_ref859, _excluded859);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5ZM12 9C9.79086 9 8 10.7909 8 13C8 15.2091 9.79086 17 12 17C14.2091 17 16 15.2091 16 13H12V9Z"
  }));
},
    es = function es(_ref860) {
  var _ref860$color = _ref860.color,
      C = _ref860$color === void 0 ? "currentColor" : _ref860$color,
      _ref860$size = _ref860.size,
      e = _ref860$size === void 0 ? 24 : _ref860$size,
      l = _ref860.className,
      i = _objectWithoutProperties(_ref860, _excluded860);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5ZM4 5V19H20V7H11.5858L9.58579 5H4ZM12 9V13H16C16 15.2091 14.2091 17 12 17C9.79086 17 8 15.2091 8 13C8 10.7909 9.79086 9 12 9Z"
  }));
},
    ts = function ts(_ref861) {
  var _ref861$color = _ref861.color,
      C = _ref861$color === void 0 ? "currentColor" : _ref861$color,
      _ref861$size = _ref861.size,
      e = _ref861$size === void 0 ? 24 : _ref861$size,
      l = _ref861.className,
      i = _objectWithoutProperties(_ref861, _excluded861);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5ZM11 9V17H13V9H11ZM15 12V17H17V12H15ZM7 14V17H9V14H7Z"
  }));
},
    Cs = function Cs(_ref862) {
  var _ref862$color = _ref862.color,
      C = _ref862$color === void 0 ? "currentColor" : _ref862$color,
      _ref862$size = _ref862.size,
      e = _ref862$size === void 0 ? 24 : _ref862$size,
      l = _ref862.className,
      i = _objectWithoutProperties(_ref862, _excluded862);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5ZM4 5V19H20V7H11.5858L9.58579 5H4ZM11 9H13V17H11V9ZM15 12H17V17H15V12ZM7 14H9V17H7V14Z"
  }));
},
    ls = function ls(_ref863) {
  var _ref863$color = _ref863.color,
      C = _ref863$color === void 0 ? "currentColor" : _ref863$color,
      _ref863$size = _ref863.size,
      e = _ref863$size === void 0 ? 24 : _ref863$size,
      l = _ref863.className,
      i = _objectWithoutProperties(_ref863, _excluded863);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5ZM13 13V9H11V13H8L12 17L16 13H13Z"
  }));
},
    is = function is(_ref864) {
  var _ref864$color = _ref864.color,
      C = _ref864$color === void 0 ? "currentColor" : _ref864$color,
      _ref864$size = _ref864.size,
      e = _ref864$size === void 0 ? 24 : _ref864$size,
      l = _ref864.className,
      i = _objectWithoutProperties(_ref864, _excluded864);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5ZM4 5V19H20V7H11.5858L9.58579 5H4ZM13 13H16L12 17L8 13H11V9H13V13Z"
  }));
},
    ss = function ss(_ref865) {
  var _ref865$color = _ref865.color,
      C = _ref865$color === void 0 ? "currentColor" : _ref865$color,
      _ref865$size = _ref865.size,
      e = _ref865$size === void 0 ? 24 : _ref865$size,
      l = _ref865.className,
      i = _objectWithoutProperties(_ref865, _excluded865);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5Z"
  }));
},
    rs = function rs(_ref866) {
  var _ref866$color = _ref866.color,
      C = _ref866$color === void 0 ? "currentColor" : _ref866$color,
      _ref866$size = _ref866.size,
      e = _ref866$size === void 0 ? 24 : _ref866$size,
      l = _ref866.className,
      i = _objectWithoutProperties(_ref866, _excluded866);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22 11.2547C20.8662 10.4638 19.4872 10 18 10C14.134 10 11 13.134 11 17C11 18.4872 11.4638 19.8662 12.2547 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5H21C21.5523 5 22 5.44772 22 6V11.2547ZM18 22C15.2386 22 13 19.7614 13 17C13 14.2386 15.2386 12 18 12C20.7614 12 23 14.2386 23 17C23 19.7614 20.7614 22 18 22ZM16.7066 19.7076C17.0982 19.895 17.5369 20 18 20C19.6569 20 21 18.6569 21 17C21 16.5369 20.895 16.0982 20.7076 15.7066L16.7066 19.7076ZM15.2924 18.2934L19.2934 14.2924C18.9018 14.105 18.4631 14 18 14C16.3431 14 15 15.3431 15 17C15 17.4631 15.105 17.9018 15.2924 18.2934Z"
  }));
},
    cs = function cs(_ref867) {
  var _ref867$color = _ref867.color,
      C = _ref867$color === void 0 ? "currentColor" : _ref867$color,
      _ref867$size = _ref867.size,
      e = _ref867$size === void 0 ? 24 : _ref867$size,
      l = _ref867.className,
      i = _objectWithoutProperties(_ref867, _excluded867);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22 11.2547C21.396 10.8334 20.7224 10.5049 20 10.2899V7H11.5858L9.58579 5H4V19H11.2899C11.5049 19.7224 11.8334 20.396 12.2547 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5H21C21.5523 5 22 5.44772 22 6V11.2547ZM18 22C15.2386 22 13 19.7614 13 17C13 14.2386 15.2386 12 18 12C20.7614 12 23 14.2386 23 17C23 19.7614 20.7614 22 18 22ZM16.7066 19.7076C17.0982 19.895 17.5369 20 18 20C19.6569 20 21 18.6569 21 17C21 16.5369 20.895 16.0982 20.7076 15.7066L16.7066 19.7076ZM15.2924 18.2934L19.2934 14.2924C18.9018 14.105 18.4631 14 18 14C16.3431 14 15 15.3431 15 17C15 17.4631 15.105 17.9018 15.2924 18.2934Z"
  }));
},
    os = function os(_ref868) {
  var _ref868$color = _ref868.color,
      C = _ref868$color === void 0 ? "currentColor" : _ref868$color,
      _ref868$size = _ref868.size,
      e = _ref868$size === void 0 ? 24 : _ref868$size,
      l = _ref868.className,
      i = _objectWithoutProperties(_ref868, _excluded868);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10.4142 3L12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142ZM13 9H11V15H16V13H13V9Z"
  }));
},
    as = function as(_ref869) {
  var _ref869$color = _ref869.color,
      C = _ref869$color === void 0 ? "currentColor" : _ref869$color,
      _ref869$size = _ref869.size,
      e = _ref869$size === void 0 ? 24 : _ref869$size,
      l = _ref869.className,
      i = _objectWithoutProperties(_ref869, _excluded869);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10.4142 3L12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142ZM9.58579 5H4V19H20V7H11.5858L9.58579 5ZM13 9V13H16V15H11V9H13Z"
  }));
},
    ns = function ns(_ref870) {
  var _ref870$color = _ref870.color,
      C = _ref870$color === void 0 ? "currentColor" : _ref870$color,
      _ref870$size = _ref870.size,
      e = _ref870$size === void 0 ? 24 : _ref870$size,
      l = _ref870.className,
      i = _objectWithoutProperties(_ref870, _excluded870);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5ZM11 9V11H13V9H11ZM11 12V17H13V12H11Z"
  }));
},
    ms = function ms(_ref871) {
  var _ref871$color = _ref871.color,
      C = _ref871$color === void 0 ? "currentColor" : _ref871$color,
      _ref871$size = _ref871.size,
      e = _ref871$size === void 0 ? 24 : _ref871$size,
      l = _ref871.className,
      i = _objectWithoutProperties(_ref871, _excluded871);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5ZM4 5V19H20V7H11.5858L9.58579 5H4ZM11 12H13V17H11V12ZM11 9H13V11H11V9Z"
  }));
},
    ws = function ws(_ref872) {
  var _ref872$color = _ref872.color,
      C = _ref872$color === void 0 ? "currentColor" : _ref872$color,
      _ref872$size = _ref872.size,
      e = _ref872$size === void 0 ? 24 : _ref872$size,
      l = _ref872.className,
      i = _objectWithoutProperties(_ref872, _excluded872);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10.4142 3L12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142ZM12 9C10.8954 9 10 9.89543 10 11C10 11.7403 10.4022 12.3866 10.9999 12.7324L11 17H13L13.0011 12.7318C13.5983 12.3858 14 11.7398 14 11C14 9.89543 13.1046 9 12 9Z"
  }));
},
    Ls = function Ls(_ref873) {
  var _ref873$color = _ref873.color,
      C = _ref873$color === void 0 ? "currentColor" : _ref873$color,
      _ref873$size = _ref873.size,
      e = _ref873$size === void 0 ? 24 : _ref873$size,
      l = _ref873.className,
      i = _objectWithoutProperties(_ref873, _excluded873);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10.4142 3L12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142ZM9.58579 5H4V19H20V7H11.5858L9.58579 5ZM12 9C13.1046 9 14 9.89543 14 11C14 11.7398 13.5983 12.3858 13.0011 12.7318L13 17H11L10.9999 12.7324C10.4022 12.3866 10 11.7403 10 11C10 9.89543 10.8954 9 12 9Z"
  }));
},
    hs = function hs(_ref874) {
  var _ref874$color = _ref874.color,
      C = _ref874$color === void 0 ? "currentColor" : _ref874$color,
      _ref874$size = _ref874.size,
      e = _ref874$size === void 0 ? 24 : _ref874$size,
      l = _ref874.className,
      i = _objectWithoutProperties(_ref874, _excluded874);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 5V19H20V7H11.5858L9.58579 5H4ZM12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5Z"
  }));
},
    Hs = function Hs(_ref875) {
  var _ref875$color = _ref875.color,
      C = _ref875$color === void 0 ? "currentColor" : _ref875$color,
      _ref875$size = _ref875.size,
      e = _ref875$size === void 0 ? 24 : _ref875$size,
      l = _ref875.className,
      i = _objectWithoutProperties(_ref875, _excluded875);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5ZM15 13V12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12V13H8V17H16V13H15ZM13 13H11V12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12V13Z"
  }));
},
    Vs = function Vs(_ref876) {
  var _ref876$color = _ref876.color,
      C = _ref876$color === void 0 ? "currentColor" : _ref876$color,
      _ref876$size = _ref876.size,
      e = _ref876$size === void 0 ? 24 : _ref876$size,
      l = _ref876.className,
      i = _objectWithoutProperties(_ref876, _excluded876);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5ZM4 5V19H20V7H11.5858L9.58579 5H4ZM15 13H16V17H8V13H9V12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12V13ZM13 13V12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12V13H13Z"
  }));
},
    gs = function gs(_ref877) {
  var _ref877$color = _ref877.color,
      C = _ref877$color === void 0 ? "currentColor" : _ref877$color,
      _ref877$size = _ref877.size,
      e = _ref877$size === void 0 ? 24 : _ref877$size,
      l = _ref877.className,
      i = _objectWithoutProperties(_ref877, _excluded877);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5ZM11 13.05C10.8384 13.0172 10.6712 13 10.5 13C9.11929 13 8 14.1193 8 15.5C8 16.8807 9.11929 18 10.5 18C11.8807 18 13 16.8807 13 15.5V11H16V9H11V13.05Z"
  }));
},
    Ms = function Ms(_ref878) {
  var _ref878$color = _ref878.color,
      C = _ref878$color === void 0 ? "currentColor" : _ref878$color,
      _ref878$size = _ref878.size,
      e = _ref878$size === void 0 ? 24 : _ref878$size,
      l = _ref878.className,
      i = _objectWithoutProperties(_ref878, _excluded878);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5ZM4 5V19H20V7H11.5858L9.58579 5H4ZM11 13.05V9H16V11H13V15.5C13 16.8807 11.8807 18 10.5 18C9.11929 18 8 16.8807 8 15.5C8 14.1193 9.11929 13 10.5 13C10.6712 13 10.8384 13.0172 11 13.05Z"
  }));
},
    Zs = function Zs(_ref879) {
  var _ref879$color = _ref879.color,
      C = _ref879$color === void 0 ? "currentColor" : _ref879$color,
      _ref879$size = _ref879.size,
      e = _ref879$size === void 0 ? 24 : _ref879$size,
      l = _ref879.className,
      i = _objectWithoutProperties(_ref879, _excluded879);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 21C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5H20C20.5523 5 21 5.44772 21 6V9H4V18.996L6 11H22.5L20.1894 20.2425C20.0781 20.6877 19.6781 21 19.2192 21H3Z"
  }));
},
    xs = function xs(_ref880) {
  var _ref880$color = _ref880.color,
      C = _ref880$color === void 0 ? "currentColor" : _ref880$color,
      _ref880$size = _ref880.size,
      e = _ref880$size === void 0 ? 24 : _ref880$size,
      l = _ref880.className,
      i = _objectWithoutProperties(_ref880, _excluded880);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 21C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5H20C20.5523 5 21 5.44772 21 6V9H19V7H11.5858L9.58579 5H4V16.998L5.5 11H22.5L20.1894 20.2425C20.0781 20.6877 19.6781 21 19.2192 21H3ZM19.9384 13H7.06155L5.56155 19H18.4384L19.9384 13Z"
  }));
},
    vs = function vs(_ref881) {
  var _ref881$color = _ref881.color,
      C = _ref881$color === void 0 ? "currentColor" : _ref881$color,
      _ref881$size = _ref881.size,
      e = _ref881$size === void 0 ? 24 : _ref881$size,
      l = _ref881.className,
      i = _objectWithoutProperties(_ref881, _excluded881);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22 13.126C21.0149 12.4174 19.8062 12 18.5 12C15.1863 12 12.5 14.6863 12.5 18C12.5 19.0929 12.7922 20.1175 13.3027 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5H21C21.5523 5 22 5.44772 22 6V13.126ZM20 17H23V19H20V22.5L15 18L20 13.5V17Z"
  }));
},
    ds = function ds(_ref882) {
  var _ref882$color = _ref882.color,
      C = _ref882$color === void 0 ? "currentColor" : _ref882$color,
      _ref882$size = _ref882.size,
      e = _ref882$size === void 0 ? 24 : _ref882$size,
      l = _ref882.className,
      i = _objectWithoutProperties(_ref882, _excluded882);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22 13H20V7H11.5858L9.58579 5H4V19H13V21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5H21C21.5523 5 22 5.44772 22 6V13ZM20 17H23V19H20V22.5L15 18L20 13.5V17Z"
  }));
},
    ps = function ps(_ref883) {
  var _ref883$color = _ref883.color,
      C = _ref883$color === void 0 ? "currentColor" : _ref883$color,
      _ref883$size = _ref883.size,
      e = _ref883$size === void 0 ? 24 : _ref883$size,
      l = _ref883.className,
      i = _objectWithoutProperties(_ref883, _excluded883);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5ZM8 12V14H16V12H8Z"
  }));
},
    Es = function Es(_ref884) {
  var _ref884$color = _ref884.color,
      C = _ref884$color === void 0 ? "currentColor" : _ref884$color,
      _ref884$size = _ref884.size,
      e = _ref884$size === void 0 ? 24 : _ref884$size,
      l = _ref884.className,
      i = _objectWithoutProperties(_ref884, _excluded884);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5ZM4 5V19H20V7H11.5858L9.58579 5H4ZM8 12H16V14H8V12Z"
  }));
},
    Ns = function Ns(_ref885) {
  var _ref885$color = _ref885.color,
      C = _ref885$color === void 0 ? "currentColor" : _ref885$color,
      _ref885$size = _ref885.size,
      e = _ref885$size === void 0 ? 24 : _ref885$size,
      l = _ref885.className,
      i = _objectWithoutProperties(_ref885, _excluded885);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5ZM8.59114 13.8089L7.59998 14.3812L8.59954 16.1124L9.59141 15.5397C9.98434 15.9114 10.4634 16.1929 10.9955 16.3513V17.4956H12.9945V16.3512C13.5266 16.1928 14.0057 15.9113 14.3986 15.5396L15.3905 16.1123L16.39 14.3811L15.3987 13.8088C15.4605 13.5485 15.4932 13.277 15.4932 12.9978C15.4932 12.7186 15.4605 12.447 15.3987 12.1867L16.39 11.6145L15.3904 9.88325L14.3985 10.4559C14.0056 10.0843 13.5265 9.80274 12.9944 9.64438V8.5H10.9954V9.64438C10.4633 9.80275 9.98424 10.0843 9.59133 10.456L8.59949 9.88335L7.59998 11.6146L8.59112 12.1868C8.52933 12.4471 8.49663 12.7186 8.49663 12.9978C8.49663 13.277 8.52934 13.5486 8.59114 13.8089ZM11.9949 14.4971C11.1669 14.4971 10.4957 13.8258 10.4957 12.9978C10.4957 12.1698 11.1669 11.4985 11.9949 11.4985C12.8229 11.4985 13.4942 12.1698 13.4942 12.9978C13.4942 13.8258 12.8229 14.4971 11.9949 14.4971Z"
  }));
},
    us = function us(_ref886) {
  var _ref886$color = _ref886.color,
      C = _ref886$color === void 0 ? "currentColor" : _ref886$color,
      _ref886$size = _ref886.size,
      e = _ref886$size === void 0 ? 24 : _ref886$size,
      l = _ref886.className,
      i = _objectWithoutProperties(_ref886, _excluded886);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5ZM4 5V19H20V7H11.5858L9.58579 5H4ZM8.59114 13.8089C8.52934 13.5486 8.49663 13.277 8.49663 12.9978C8.49663 12.7186 8.52933 12.4471 8.59112 12.1868L7.59998 11.6146L8.59949 9.88335L9.59133 10.456C9.98424 10.0843 10.4633 9.80275 10.9954 9.64438V8.5H12.9944V9.64438C13.5265 9.80274 14.0056 10.0843 14.3985 10.4559L15.3904 9.88325L16.39 11.6145L15.3987 12.1867C15.4605 12.447 15.4932 12.7186 15.4932 12.9978C15.4932 13.277 15.4605 13.5485 15.3987 13.8088L16.39 14.3811L15.3905 16.1123L14.3986 15.5396C14.0057 15.9113 13.5266 16.1928 12.9945 16.3512V17.4956H10.9955V16.3513C10.4634 16.1929 9.98434 15.9114 9.59141 15.5397L8.59954 16.1124L7.59998 14.3812L8.59114 13.8089ZM11.9949 14.4971C12.8229 14.4971 13.4942 13.8258 13.4942 12.9978C13.4942 12.1698 12.8229 11.4985 11.9949 11.4985C11.1669 11.4985 10.4957 12.1698 10.4957 12.9978C10.4957 13.8258 11.1669 14.4971 11.9949 14.4971Z"
  }));
},
    Bs = function Bs(_ref887) {
  var _ref887$color = _ref887.color,
      C = _ref887$color === void 0 ? "currentColor" : _ref887$color,
      _ref887$size = _ref887.size,
      e = _ref887$size === void 0 ? 24 : _ref887$size,
      l = _ref887.className,
      i = _objectWithoutProperties(_ref887, _excluded887);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22 13.126C21.0149 12.4174 19.8062 12 18.5 12C15.1863 12 12.5 14.6863 12.5 18C12.5 19.0929 12.7922 20.1175 13.3027 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5H21C21.5523 5 22 5.44772 22 6V13.126ZM18 17V13.5L23 18L18 22.5V19H15V17H18Z"
  }));
},
    fs = function fs(_ref888) {
  var _ref888$color = _ref888.color,
      C = _ref888$color === void 0 ? "currentColor" : _ref888$color,
      _ref888$size = _ref888.size,
      e = _ref888$size === void 0 ? 24 : _ref888$size,
      l = _ref888.className,
      i = _objectWithoutProperties(_ref888, _excluded888);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22 13H20V7H11.5858L9.58579 5H4V19H13V21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5H21C21.5523 5 22 5.44772 22 6V13ZM18 17V13.5L23 18L18 22.5V19H15V17H18Z"
  }));
},
    Rs = function Rs(_ref889) {
  var _ref889$color = _ref889.color,
      C = _ref889$color === void 0 ? "currentColor" : _ref889$color,
      _ref889$size = _ref889.size,
      e = _ref889$size === void 0 ? 24 : _ref889$size,
      l = _ref889.className,
      i = _objectWithoutProperties(_ref889, _excluded889);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22 10H12V17.3823C12 18.7906 12.6315 20.1159 13.7054 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5H21C21.5523 5 22 5.44772 22 6V10ZM14 12H22V17.3823C22 18.2786 21.5544 19.1156 20.8125 19.6128L18 21.4978L15.1875 19.6128C14.4456 19.1156 14 18.2786 14 17.3823V12Z"
  }));
},
    zs = function zs(_ref890) {
  var _ref890$color = _ref890.color,
      C = _ref890$color === void 0 ? "currentColor" : _ref890$color,
      _ref890$size = _ref890.size,
      e = _ref890$size === void 0 ? 24 : _ref890$size,
      l = _ref890.className,
      i = _objectWithoutProperties(_ref890, _excluded890);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22 9H20V7H11.5858L9.58579 5H4V19H11.4469C11.8089 19.7916 12.3786 20.4853 13.1114 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5H21C21.5523 5 22 5.44772 22 6V9ZM13 11H22V16.949C22 17.9397 21.4987 18.8648 20.6641 19.4144L17.5 21.4978L14.3359 19.4144C13.5013 18.8648 13 17.9397 13 16.949V11ZM15 16.949C15 17.2652 15.1616 17.5634 15.4358 17.744L17.5 19.1032L19.5642 17.744C19.8384 17.5634 20 17.2652 20 16.949V13H15V16.949Z"
  }));
},
    Fs = function Fs(_ref891) {
  var _ref891$color = _ref891.color,
      C = _ref891$color === void 0 ? "currentColor" : _ref891$color,
      _ref891$size = _ref891.size,
      e = _ref891$size === void 0 ? 24 : _ref891$size,
      l = _ref891.className,
      i = _objectWithoutProperties(_ref891, _excluded891);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5ZM8 9V13.904C8 14.7956 8.4456 15.6282 9.18747 16.1228L12 17.9978L14.8125 16.1228C15.5544 15.6282 16 14.7956 16 13.904V9H8ZM10 13.904V11H14V13.904C14 14.1269 13.8886 14.335 13.7031 14.4587L12 15.5941L10.2969 14.4587C10.1114 14.335 10 14.1269 10 13.904Z"
  }));
},
    Ss = function Ss(_ref892) {
  var _ref892$color = _ref892.color,
      C = _ref892$color === void 0 ? "currentColor" : _ref892$color,
      _ref892$size = _ref892.size,
      e = _ref892$size === void 0 ? 24 : _ref892$size,
      l = _ref892.className,
      i = _objectWithoutProperties(_ref892, _excluded892);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5ZM4 5V19H20V7H11.5858L9.58579 5H4ZM8 9H16V13.904C16 14.7956 15.5544 15.6282 14.8125 16.1228L12 17.9978L9.18747 16.1228C8.4456 15.6282 8 14.7956 8 13.904V9ZM10 13.904C10 14.1269 10.1114 14.335 10.2969 14.4587L12 15.5941L13.7031 14.4587C13.8886 14.335 14 14.1269 14 13.904V11H10V13.904Z"
  }));
},
    As = function As(_ref893) {
  var _ref893$color = _ref893.color,
      C = _ref893$color === void 0 ? "currentColor" : _ref893$color,
      _ref893$size = _ref893.size,
      e = _ref893$size === void 0 ? 24 : _ref893$size,
      l = _ref893.className,
      i = _objectWithoutProperties(_ref893, _excluded893);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5ZM12 12H8V14H12V17L16 13L12 9V12Z"
  }));
},
    ks = function ks(_ref894) {
  var _ref894$color = _ref894.color,
      C = _ref894$color === void 0 ? "currentColor" : _ref894$color,
      _ref894$size = _ref894.size,
      e = _ref894$size === void 0 ? 24 : _ref894$size,
      l = _ref894.className,
      i = _objectWithoutProperties(_ref894, _excluded894);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5ZM4 5V19H20V7H11.5858L9.58579 5H4ZM12 12V9L16 13L12 17V14H8V12H12Z"
  }));
},
    Ps = function Ps(_ref895) {
  var _ref895$color = _ref895.color,
      C = _ref895$color === void 0 ? "currentColor" : _ref895$color,
      _ref895$size = _ref895.size,
      e = _ref895$size === void 0 ? 24 : _ref895$size,
      l = _ref895.className,
      i = _objectWithoutProperties(_ref895, _excluded895);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5ZM11 16V18H13V16H11ZM8.56731 10.8135L10.5288 11.2058C10.6656 10.5182 11.2723 10 12 10C12.8284 10 13.5 10.6716 13.5 11.5C13.5 12.3284 12.8284 13 12 13H11V15H12C13.933 15 15.5 13.433 15.5 11.5C15.5 9.567 13.933 8 12 8C10.302 8 8.88637 9.20919 8.56731 10.8135Z"
  }));
},
    Ds = function Ds(_ref896) {
  var _ref896$color = _ref896.color,
      C = _ref896$color === void 0 ? "currentColor" : _ref896$color,
      _ref896$size = _ref896.size,
      e = _ref896$size === void 0 ? 24 : _ref896$size,
      l = _ref896.className,
      i = _objectWithoutProperties(_ref896, _excluded896);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5ZM4 5V19H20V7H11.5858L9.58579 5H4ZM11 16H13V18H11V16ZM8.56731 10.8135C8.88637 9.20919 10.302 8 12 8C13.933 8 15.5 9.567 15.5 11.5C15.5 13.433 13.933 15 12 15H11V13H12C12.8284 13 13.5 12.3284 13.5 11.5C13.5 10.6716 12.8284 10 12 10C11.2723 10 10.6656 10.5182 10.5288 11.2058L8.56731 10.8135Z"
  }));
},
    ys = function ys(_ref897) {
  var _ref897$color = _ref897.color,
      C = _ref897$color === void 0 ? "currentColor" : _ref897$color,
      _ref897$size = _ref897.size,
      e = _ref897$size === void 0 ? 24 : _ref897$size,
      l = _ref897.className,
      i = _objectWithoutProperties(_ref897, _excluded897);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5ZM13 13H16L12 9L8 13H11V17H13V13Z"
  }));
},
    bs = function bs(_ref898) {
  var _ref898$color = _ref898.color,
      C = _ref898$color === void 0 ? "currentColor" : _ref898$color,
      _ref898$size = _ref898.size,
      e = _ref898$size === void 0 ? 24 : _ref898$size,
      l = _ref898.className,
      i = _objectWithoutProperties(_ref898, _excluded898);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5ZM4 5V19H20V7H11.5858L9.58579 5H4ZM13 13V17H11V13H8L12 9L16 13H13Z"
  }));
},
    Ts = function Ts(_ref899) {
  var _ref899$color = _ref899.color,
      C = _ref899$color === void 0 ? "currentColor" : _ref899$color,
      _ref899$size = _ref899.size,
      e = _ref899$size === void 0 ? 24 : _ref899$size,
      l = _ref899.className,
      i = _objectWithoutProperties(_ref899, _excluded899);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5ZM12 13C13.3807 13 14.5 11.8807 14.5 10.5C14.5 9.11929 13.3807 8 12 8C10.6193 8 9.5 9.11929 9.5 10.5C9.5 11.8807 10.6193 13 12 13ZM8 18H16C16 15.7909 14.2091 14 12 14C9.79086 14 8 15.7909 8 18Z"
  }));
},
    Us = function Us(_ref900) {
  var _ref900$color = _ref900.color,
      C = _ref900$color === void 0 ? "currentColor" : _ref900$color,
      _ref900$size = _ref900.size,
      e = _ref900$size === void 0 ? 24 : _ref900$size,
      l = _ref900.className,
      i = _objectWithoutProperties(_ref900, _excluded900);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5ZM4 5V19H20V7H11.5858L9.58579 5H4ZM8 18C8 15.7909 9.79086 14 12 14C14.2091 14 16 15.7909 16 18H8ZM12 13C10.6193 13 9.5 11.8807 9.5 10.5C9.5 9.11929 10.6193 8 12 8C13.3807 8 14.5 9.11929 14.5 10.5C14.5 11.8807 13.3807 13 12 13Z"
  }));
},
    Gs = function Gs(_ref901) {
  var _ref901$color = _ref901.color,
      C = _ref901$color === void 0 ? "currentColor" : _ref901$color,
      _ref901$size = _ref901.size,
      e = _ref901$size === void 0 ? 24 : _ref901$size,
      l = _ref901.className,
      i = _objectWithoutProperties(_ref901, _excluded901);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5ZM11 9V14H13V9H11ZM11 15V17H13V15H11Z"
  }));
},
    Is = function Is(_ref902) {
  var _ref902$color = _ref902.color,
      C = _ref902$color === void 0 ? "currentColor" : _ref902$color,
      _ref902$size = _ref902.size,
      e = _ref902$size === void 0 ? 24 : _ref902$size,
      l = _ref902.className,
      i = _objectWithoutProperties(_ref902, _excluded902);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5ZM4 5V19H20V7H11.5858L9.58579 5H4ZM11 15H13V17H11V15ZM11 9H13V14H11V9Z"
  }));
},
    Ws = function Ws(_ref903) {
  var _ref903$color = _ref903.color,
      C = _ref903$color === void 0 ? "currentColor" : _ref903$color,
      _ref903$size = _ref903.size,
      e = _ref903$size === void 0 ? 24 : _ref903$size,
      l = _ref903.className,
      i = _objectWithoutProperties(_ref903, _excluded903);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 5C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5H16V7H18V5H21ZM18 13H16V15H14V18H18V13ZM16 11H14V13H16V11ZM18 9H16V11H18V9ZM16 7H14V9H16V7Z"
  }));
},
    Os = function Os(_ref904) {
  var _ref904$color = _ref904.color,
      C = _ref904$color === void 0 ? "currentColor" : _ref904$color,
      _ref904$size = _ref904.size,
      e = _ref904$size === void 0 ? 24 : _ref904$size,
      l = _ref904.className,
      i = _objectWithoutProperties(_ref904, _excluded904);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10.4142 3L12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142ZM18 18H14V15H16V13H14V11H16V9H14V7H11.5858L9.58579 5H4V19H20V7H16V9H18V11H16V13H18V18Z"
  }));
},
    Ks = function Ks(_ref905) {
  var _ref905$color = _ref905.color,
      C = _ref905$color === void 0 ? "currentColor" : _ref905$color,
      _ref905$size = _ref905.size,
      e = _ref905$size === void 0 ? 24 : _ref905$size,
      l = _ref905.className,
      i = _objectWithoutProperties(_ref905, _excluded905);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6 7V4C6 3.44772 6.44772 3 7 3H13.4142L15.4142 5H21C21.5523 5 22 5.44772 22 6V16C22 16.5523 21.5523 17 21 17H18V20C18 20.5523 17.5523 21 17 21H3C2.44772 21 2 20.5523 2 20V8C2 7.44772 2.44772 7 3 7H6ZM6 9H4V19H16V17H6V9Z"
  }));
},
    Qs = function Qs(_ref906) {
  var _ref906$color = _ref906.color,
      C = _ref906$color === void 0 ? "currentColor" : _ref906$color,
      _ref906$size = _ref906.size,
      e = _ref906$size === void 0 ? 24 : _ref906$size,
      l = _ref906.className,
      i = _objectWithoutProperties(_ref906, _excluded906);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6 7V4C6 3.44772 6.44772 3 7 3H13.4142L15.4142 5H21C21.5523 5 22 5.44772 22 6V16C22 16.5523 21.5523 17 21 17H18V20C18 20.5523 17.5523 21 17 21H3C2.44772 21 2 20.5523 2 20V8C2 7.44772 2.44772 7 3 7H6ZM6 9H4V19H16V17H6V9ZM8 5V15H20V7H14.5858L12.5858 5H8Z"
  }));
},
    qs = function qs(_ref907) {
  var _ref907$color = _ref907.color,
      C = _ref907$color === void 0 ? "currentColor" : _ref907$color,
      _ref907$size = _ref907.size,
      e = _ref907$size === void 0 ? 24 : _ref907$size,
      l = _ref907.className,
      i = _objectWithoutProperties(_ref907, _excluded907);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15.2459 14H8.75407L7.15407 18H5L11 3H13L19 18H16.8459L15.2459 14ZM14.4459 12L12 5.88516L9.55407 12H14.4459ZM3 20H21V22H3V20Z"
  }));
},
    js = function js(_ref908) {
  var _ref908$color = _ref908.color,
      C = _ref908$color === void 0 ? "currentColor" : _ref908$color,
      _ref908$size = _ref908.size,
      e = _ref908$size === void 0 ? 24 : _ref908$size,
      l = _ref908.className,
      i = _objectWithoutProperties(_ref908, _excluded908);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10 6V21H8V6H2V4H16V6H10ZM18 14V21H16V14H13V12H21V14H18Z"
  }));
},
    Xs = function Xs(_ref909) {
  var _ref909$color = _ref909.color,
      C = _ref909$color === void 0 ? "currentColor" : _ref909$color,
      _ref909$size = _ref909.size,
      e = _ref909$size === void 0 ? 24 : _ref909$size,
      l = _ref909.className,
      i = _objectWithoutProperties(_ref909, _excluded909);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11.246 15H4.75416L2.75416 20H0.600098L7.0001 4H9.0001L15.4001 20H13.246L11.246 15ZM10.446 13L8.0001 6.88516L5.55416 13H10.446ZM21.0001 12.5351V12H23.0001V20H21.0001V19.4649C20.4118 19.8052 19.7287 20 19.0001 20C16.791 20 15.0001 18.2091 15.0001 16C15.0001 13.7909 16.791 12 19.0001 12C19.7287 12 20.4118 12.1948 21.0001 12.5351ZM19.0001 18C20.1047 18 21.0001 17.1046 21.0001 16C21.0001 14.8954 20.1047 14 19.0001 14C17.8955 14 17.0001 14.8954 17.0001 16C17.0001 17.1046 17.8955 18 19.0001 18Z"
  }));
},
    Js = function Js(_ref910) {
  var _ref910$color = _ref910.color,
      C = _ref910$color === void 0 ? "currentColor" : _ref910$color,
      _ref910$size = _ref910.size,
      e = _ref910$size === void 0 ? 24 : _ref910$size,
      l = _ref910.className,
      i = _objectWithoutProperties(_ref910, _excluded910);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM13.6695 15.9999H10.3295L8.95053 17.8969L9.5044 19.6031C10.2897 19.8607 11.1286 20 12 20C12.8714 20 13.7103 19.8607 14.4956 19.6031L15.0485 17.8969L13.6695 15.9999ZM5.29354 10.8719L4.00222 11.8095L4 12C4 13.7297 4.54894 15.3312 5.4821 16.6397L7.39254 16.6399L8.71453 14.8199L7.68654 11.6499L5.29354 10.8719ZM18.7055 10.8719L16.3125 11.6499L15.2845 14.8199L16.6065 16.6399L18.5179 16.6397C19.4511 15.3312 20 13.7297 20 12L19.997 11.809L18.7055 10.8719ZM14.2914 4.33299L12.9995 5.27293V7.78993L15.6935 9.74693L17.9325 9.01993L18.4867 7.3168C17.467 5.90685 15.9988 4.84254 14.2914 4.33299ZM9.70857 4.33299C8.00078 4.84265 6.53236 5.90735 5.51261 7.31778L6.06653 9.01993L8.30554 9.74693L10.9995 7.78993V5.27293L9.70857 4.33299Z"
  }));
},
    Ys = function Ys(_ref911) {
  var _ref911$color = _ref911.color,
      C = _ref911$color === void 0 ? "currentColor" : _ref911$color,
      _ref911$size = _ref911.size,
      e = _ref911$size === void 0 ? 24 : _ref911$size,
      l = _ref911.className,
      i = _objectWithoutProperties(_ref911, _excluded911);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM13.6695 15.9999H10.3295L8.95053 17.8969L9.5044 19.6031C10.2897 19.8607 11.1286 20 12 20C12.8714 20 13.7103 19.8607 14.4956 19.6031L15.0485 17.8969L13.6695 15.9999ZM5.29354 10.8719L4.00222 11.8095L4 12C4 13.7297 4.54894 15.3312 5.4821 16.6397L7.39254 16.6399L8.71453 14.8199L7.68654 11.6499L5.29354 10.8719ZM18.7055 10.8719L16.3125 11.6499L15.2845 14.8199L16.6065 16.6399L18.5179 16.6397C19.4511 15.3312 20 13.7297 20 12L19.997 11.81L18.7055 10.8719ZM12 9.536L9.656 11.238L10.552 14H13.447L14.343 11.238L12 9.536ZM14.2914 4.33299L12.9995 5.27293V7.78993L15.6935 9.74693L17.9325 9.01993L18.4867 7.3168C17.467 5.90685 15.9988 4.84254 14.2914 4.33299ZM9.70757 4.33329C8.00021 4.84307 6.53216 5.90762 5.51261 7.31778L6.06653 9.01993L8.30554 9.74693L10.9995 7.78993V5.27293L9.70757 4.33329Z"
  }));
},
    _s = function _s(_ref912) {
  var _ref912$color = _ref912.color,
      C = _ref912$color === void 0 ? "currentColor" : _ref912$color,
      _ref912$size = _ref912.size,
      e = _ref912$size === void 0 ? 24 : _ref912$size,
      l = _ref912.className,
      i = _objectWithoutProperties(_ref912, _excluded912);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 18.0001H9.5V19.2501C9.5 20.7688 8.26878 22.0001 6.75 22.0001C5.23122 22.0001 4 20.7688 4 19.2501V18.0001ZM8 6.12067C10 6.12067 11 9.00006 11 11.0001C11 12.0001 10.5 13.0001 10 14.5001L9.5 16.0001H4C4 15.0001 3.5 13.5001 3.5 11.0001C3.5 8.50006 5.49783 6.12067 8 6.12067ZM20.054 14.0984L19.8369 15.3294C19.5732 16.8251 18.1468 17.8238 16.6511 17.5601C15.1554 17.2964 14.1567 15.87 14.4205 14.3743L14.6375 13.1433L20.054 14.0984ZM18.1776 1.70488C20.6417 2.13938 22.196 4.82954 21.7619 7.29156C21.3278 9.75358 20.5749 11.144 20.4013 12.1288L14.9848 11.1737L14.7529 9.60967C14.5209 8.04564 14.2022 6.974 14.3758 5.9892C14.7231 4.01958 16.2079 1.35759 18.1776 1.70488Z"
  }));
},
    $s = function $s(_ref913) {
  var _ref913$color = _ref913.color,
      C = _ref913$color === void 0 ? "currentColor" : _ref913$color,
      _ref913$size = _ref913.size,
      e = _ref913$size === void 0 ? 24 : _ref913$size,
      l = _ref913.className,
      i = _objectWithoutProperties(_ref913, _excluded913);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 18.0001H9.5V19.2501C9.5 20.7688 8.26878 22.0001 6.75 22.0001C5.23122 22.0001 4 20.7688 4 19.2501V18.0001ZM8.05848 14.0001L8.10263 13.8676C8.86974 11.7622 9 11.3714 9 11.0001C9 10.2506 8.79747 9.35748 8.47234 8.72683C8.23039 8.25753 8.06 8.12067 8 8.12067C6.72086 8.12067 5.5 9.48451 5.5 11.0001C5.5 11.9589 5.57517 12.7733 5.72674 13.7584C5.7328 13.7978 5.74709 13.8873 5.76512 14.0001H8.05848ZM8 6.12067C10 6.12067 11 9.00006 11 11.0001C11 12.0001 10.5 13.0001 10 14.5001L9.5 16.0001H4C4 15.0001 3.5 13.5001 3.5 11.0001C3.5 8.50006 5.49783 6.12067 8 6.12067ZM20.054 14.0984L19.8369 15.3294C19.5732 16.8251 18.1468 17.8238 16.6511 17.5601C15.1554 17.2964 14.1567 15.87 14.4205 14.3743L14.6375 13.1433L20.054 14.0984ZM19.0045 9.85164C19.1695 9.35187 19.3054 8.95753 19.3071 8.95187C19.5089 8.29375 19.668 7.64892 19.7923 6.94426C20.0555 5.45173 19.09 3.89662 17.8303 3.6745C17.7712 3.66408 17.5796 3.76927 17.2598 4.18943C16.8301 4.75404 16.4756 5.59839 16.3455 6.33649C16.2872 6.6667 16.2964 6.74073 16.6158 8.59948C16.6596 8.8547 16.697 9.08523 16.7312 9.3163L16.7517 9.45441L19.0045 9.85164ZM18.1776 1.70488C20.6417 2.13938 22.196 4.82954 21.7619 7.29156C21.3278 9.75358 20.5749 11.144 20.4013 12.1288L14.9848 11.1737L14.7529 9.60967C14.5209 8.04564 14.2022 6.974 14.3758 5.9892C14.7231 4.01958 16.2079 1.35759 18.1776 1.70488Z"
  }));
},
    er = function er(_ref914) {
  var _ref914$color = _ref914.color,
      C = _ref914$color === void 0 ? "currentColor" : _ref914$color,
      _ref914$size = _ref914.size,
      e = _ref914$size === void 0 ? 24 : _ref914$size,
      l = _ref914.className,
      i = _objectWithoutProperties(_ref914, _excluded914);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM16.8911 8.52313C16.6997 8.25459 16.4836 7.99828 16.2426 7.75736C16.0017 7.51644 15.7454 7.30029 15.4769 7.10891L7.10891 15.4769C7.30029 15.7454 7.51644 16.0017 7.75736 16.2426C7.99828 16.4836 8.25459 16.6997 8.52313 16.8911L16.8911 8.52313Z"
  }));
},
    tr = function tr(_ref915) {
  var _ref915$color = _ref915.color,
      C = _ref915$color === void 0 ? "currentColor" : _ref915$color,
      _ref915$size = _ref915.size,
      e = _ref915$size === void 0 ? 24 : _ref915$size,
      l = _ref915.className,
      i = _objectWithoutProperties(_ref915, _excluded915);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM16.8911 8.52313L8.52313 16.8911C8.25459 16.6997 7.99828 16.4836 7.75736 16.2426C7.51644 16.0017 7.30029 15.7454 7.10891 15.4769L15.4769 7.10891C15.7454 7.30029 16.0017 7.51644 16.2426 7.75736C16.4836 7.99828 16.6997 8.25459 16.8911 8.52313Z"
  }));
},
    Cr = function Cr(_ref916) {
  var _ref916$color = _ref916.color,
      C = _ref916$color === void 0 ? "currentColor" : _ref916$color,
      _ref916$size = _ref916.size,
      e = _ref916$size === void 0 ? 24 : _ref916$size,
      l = _ref916.className,
      i = _objectWithoutProperties(_ref916, _excluded916);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM8.52313 7.10891C8.25459 7.30029 7.99828 7.51644 7.75736 7.75736C7.51644 7.99828 7.30029 8.25459 7.10891 8.52313L15.4769 16.8911C15.7454 16.6997 16.0017 16.4836 16.2426 16.2426C16.4836 16.0017 16.6997 15.7454 16.8911 15.4769L8.52313 7.10891Z"
  }));
},
    lr = function lr(_ref917) {
  var _ref917$color = _ref917.color,
      C = _ref917$color === void 0 ? "currentColor" : _ref917$color,
      _ref917$size = _ref917.size,
      e = _ref917$size === void 0 ? 24 : _ref917$size,
      l = _ref917.className,
      i = _objectWithoutProperties(_ref917, _excluded917);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM8.52313 7.10891L16.8911 15.4769C16.6997 15.7454 16.4836 16.0017 16.2426 16.2426C16.0017 16.4836 15.7454 16.6997 15.4769 16.8911L7.10891 8.52313C7.30029 8.25459 7.51644 7.99828 7.75736 7.75736C7.99828 7.51644 8.25459 7.30029 8.52313 7.10891Z"
  }));
},
    ir = function ir(_ref918) {
  var _ref918$color = _ref918.color,
      C = _ref918$color === void 0 ? "currentColor" : _ref918$color,
      _ref918$size = _ref918.size,
      e = _ref918$size === void 0 ? 24 : _ref918$size,
      l = _ref918.className,
      i = _objectWithoutProperties(_ref918, _excluded918);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.6512 14.0654L11.6047 20H9.57389L10.9247 12.339L3.51465 4.92892L4.92886 3.51471L20.4852 19.0711L19.071 20.4853L12.6512 14.0654ZM11.7727 7.53009L12.0425 5.99999H10.2426L8.24257 3.99999H19.9999V5.99999H14.0733L13.4991 9.25652L11.7727 7.53009Z"
  }));
},
    sr = function sr(_ref919) {
  var _ref919$color = _ref919.color,
      C = _ref919$color === void 0 ? "currentColor" : _ref919$color,
      _ref919$size = _ref919.size,
      e = _ref919$size === void 0 ? 24 : _ref919$size,
      l = _ref919.className,
      i = _objectWithoutProperties(_ref919, _excluded919);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19.998 12V22C19.998 22.5523 19.5503 23 18.998 23H4.99805C4.44576 23 3.99805 22.5523 3.99805 22V12H19.998ZM8.99805 14H6.99805V19H8.99805V14ZM18.998 1C19.5503 1 19.998 1.44772 19.998 2V10H3.99805V2C3.99805 1.44772 4.44576 1 4.99805 1H18.998ZM8.99805 4H6.99805V8H8.99805V4Z"
  }));
},
    rr = function rr(_ref920) {
  var _ref920$color = _ref920.color,
      C = _ref920$color === void 0 ? "currentColor" : _ref920$color,
      _ref920$size = _ref920.size,
      e = _ref920$size === void 0 ? 24 : _ref920$size,
      l = _ref920.className,
      i = _objectWithoutProperties(_ref920, _excluded920);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18.998 1C19.5503 1 19.998 1.44772 19.998 2V22C19.998 22.5523 19.5503 23 18.998 23H4.99805C4.44576 23 3.99805 22.5523 3.99805 22V2C3.99805 1.44772 4.44576 1 4.99805 1H18.998ZM17.998 12H5.99805V21H17.998V12ZM9.99805 14V18H7.99805V14H9.99805ZM17.998 3H5.99805V10H17.998V3ZM9.99805 5V8H7.99805V5H9.99805Z"
  }));
},
    cr = function cr(_ref921) {
  var _ref921$color = _ref921.color,
      C = _ref921$color === void 0 ? "currentColor" : _ref921$color,
      _ref921$size = _ref921.size,
      e = _ref921$size === void 0 ? 24 : _ref921$size,
      l = _ref921.className,
      i = _objectWithoutProperties(_ref921, _excluded921);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18 7H22V9H16V3H18V7ZM8 9H2V7H6V3H8V9ZM18 17V21H16V15H22V17H18ZM8 15V21H6V17H2V15H8Z"
  }));
},
    or = function or(_ref922) {
  var _ref922$color = _ref922.color,
      C = _ref922$color === void 0 ? "currentColor" : _ref922$color,
      _ref922$size = _ref922.size,
      e = _ref922$size === void 0 ? 24 : _ref922$size,
      l = _ref922.className,
      i = _objectWithoutProperties(_ref922, _excluded922);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18 7H22V9H16V3H18V7ZM8 9H2V7H6V3H8V9ZM18 17V21H16V15H22V17H18ZM8 15V21H6V17H2V15H8Z"
  }));
},
    ar = function ar(_ref923) {
  var _ref923$color = _ref923.color,
      C = _ref923$color === void 0 ? "currentColor" : _ref923$color,
      _ref923$size = _ref923.size,
      e = _ref923$size === void 0 ? 24 : _ref923$size,
      l = _ref923.className,
      i = _objectWithoutProperties(_ref923, _excluded923);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16 3H22V9H20V5H16V3ZM2 3H8V5H4V9H2V3ZM20 19V15H22V21H16V19H20ZM4 19H8V21H2V15H4V19Z"
  }));
},
    nr = function nr(_ref924) {
  var _ref924$color = _ref924.color,
      C = _ref924$color === void 0 ? "currentColor" : _ref924$color,
      _ref924$size = _ref924.size,
      e = _ref924$size === void 0 ? 24 : _ref924$size,
      l = _ref924.className,
      i = _objectWithoutProperties(_ref924, _excluded924);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8 3V5H4V9H2V3H8ZM2 21V15H4V19H8V21H2ZM22 21H16V19H20V15H22V21ZM22 9H20V5H16V3H22V9Z"
  }));
},
    mr = function mr(_ref925) {
  var _ref925$color = _ref925.color,
      C = _ref925$color === void 0 ? "currentColor" : _ref925$color,
      _ref925$size = _ref925.size,
      e = _ref925$size === void 0 ? 24 : _ref925$size,
      l = _ref925.className,
      i = _objectWithoutProperties(_ref925, _excluded925);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 4C3 3.44772 3.44772 3 4 3H10C10.5523 3 11 3.44772 11 4V10C11 10.5523 10.5523 11 10 11H4C3.44772 11 3 10.5523 3 10V4ZM3 14C3 13.4477 3.44772 13 4 13H10C10.5523 13 11 13.4477 11 14V20C11 20.5523 10.5523 21 10 21H4C3.44772 21 3 20.5523 3 20V14ZM13 4C13 3.44772 13.4477 3 14 3H20C20.5523 3 21 3.44772 21 4V10C21 10.5523 20.5523 11 20 11H14C13.4477 11 13 10.5523 13 10V4ZM13 14C13 13.4477 13.4477 13 14 13H20C20.5523 13 21 13.4477 21 14V20C21 20.5523 20.5523 21 20 21H14C13.4477 21 13 20.5523 13 20V14Z"
  }));
},
    wr = function wr(_ref926) {
  var _ref926$color = _ref926.color,
      C = _ref926$color === void 0 ? "currentColor" : _ref926$color,
      _ref926$size = _ref926.size,
      e = _ref926$size === void 0 ? 24 : _ref926$size,
      l = _ref926.className,
      i = _objectWithoutProperties(_ref926, _excluded926);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 4C3 3.44772 3.44772 3 4 3H10C10.5523 3 11 3.44772 11 4V10C11 10.5523 10.5523 11 10 11H4C3.44772 11 3 10.5523 3 10V4ZM3 14C3 13.4477 3.44772 13 4 13H10C10.5523 13 11 13.4477 11 14V20C11 20.5523 10.5523 21 10 21H4C3.44772 21 3 20.5523 3 20V14ZM13 4C13 3.44772 13.4477 3 14 3H20C20.5523 3 21 3.44772 21 4V10C21 10.5523 20.5523 11 20 11H14C13.4477 11 13 10.5523 13 10V4ZM13 14C13 13.4477 13.4477 13 14 13H20C20.5523 13 21 13.4477 21 14V20C21 20.5523 20.5523 21 20 21H14C13.4477 21 13 20.5523 13 20V14ZM15 5V9H19V5H15ZM15 15V19H19V15H15ZM5 5V9H9V5H5ZM5 15V19H9V15H5Z"
  }));
},
    Lr = function Lr(_ref927) {
  var _ref927$color = _ref927.color,
      C = _ref927$color === void 0 ? "currentColor" : _ref927$color,
      _ref927$size = _ref927.size,
      e = _ref927$size === void 0 ? 24 : _ref927$size,
      l = _ref927.className,
      i = _objectWithoutProperties(_ref927, _excluded927);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5 18L12.6796 12L5 6V4H19V6H8.26348L16 12L8.26348 18H19V20H5V18Z"
  }));
},
    hr = function hr(_ref928) {
  var _ref928$color = _ref928.color,
      C = _ref928$color === void 0 ? "currentColor" : _ref928$color,
      _ref928$size = _ref928.size,
      e = _ref928$size === void 0 ? 24 : _ref928$size,
      l = _ref928.className,
      i = _objectWithoutProperties(_ref928, _excluded928);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3.00488 3.00281H21.0049C21.5572 3.00281 22.0049 3.45052 22.0049 4.00281V20.0028C22.0049 20.5551 21.5572 21.0028 21.0049 21.0028H3.00488C2.4526 21.0028 2.00488 20.5551 2.00488 20.0028V4.00281C2.00488 3.45052 2.4526 3.00281 3.00488 3.00281ZM14.7978 9.7957L12.348 12.2454L10.2267 10.1241L5.98407 14.3668L7.39828 15.781L10.2267 12.9526L12.348 15.0739L16.212 11.2099L18.0049 13.0028V8.00281H13.0049L14.7978 9.7957Z"
  }));
},
    Hr = function Hr(_ref929) {
  var _ref929$color = _ref929.color,
      C = _ref929$color === void 0 ? "currentColor" : _ref929$color,
      _ref929$size = _ref929.size,
      e = _ref929$size === void 0 ? 24 : _ref929$size,
      l = _ref929.className,
      i = _objectWithoutProperties(_ref929, _excluded929);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4.00488 5.00281V19.0028H20.0049V5.00281H4.00488ZM3.00488 3.00281H21.0049C21.5572 3.00281 22.0049 3.45052 22.0049 4.00281V20.0028C22.0049 20.5551 21.5572 21.0028 21.0049 21.0028H3.00488C2.4526 21.0028 2.00488 20.5551 2.00488 20.0028V4.00281C2.00488 3.45052 2.4526 3.00281 3.00488 3.00281ZM14.7978 9.7957L13.0049 8.00281H18.0049V13.0028L16.212 11.2099L12.348 15.0739L10.2267 12.9526L7.39828 15.781L5.98407 14.3668L10.2267 10.1241L12.348 12.2454L14.7978 9.7957Z"
  }));
},
    Vr = function Vr(_ref930) {
  var _ref930$color = _ref930.color,
      C = _ref930$color === void 0 ? "currentColor" : _ref930$color,
      _ref930$size = _ref930.size,
      e = _ref930$size === void 0 ? 24 : _ref930$size,
      l = _ref930.className,
      i = _objectWithoutProperties(_ref930, _excluded930);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3.90145 17.8636L7.81249 13.9526L10.6409 16.781L15.212 12.2099L17.0049 14.0028V9.00281H12.0049L13.7978 10.7957L10.6409 13.9526L7.81249 11.1241L2.86662 16.07C2.31276 14.8274 2.00488 13.4511 2.00488 12.0028C2.00488 6.47996 6.48204 2.00281 12.0049 2.00281C17.5277 2.00281 22.0049 6.47996 22.0049 12.0028C22.0049 17.5257 17.5277 22.0028 12.0049 22.0028C8.67116 22.0028 5.71844 20.3715 3.90145 17.8636Z"
  }));
},
    gr = function gr(_ref931) {
  var _ref931$color = _ref931.color,
      C = _ref931$color === void 0 ? "currentColor" : _ref931$color,
      _ref931$size = _ref931.size,
      e = _ref931$size === void 0 ? 24 : _ref931$size,
      l = _ref931.className,
      i = _objectWithoutProperties(_ref931, _excluded931);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4.41085 14.5258L7.81249 11.1241L10.6409 13.9526L13.7978 10.7957L12.0049 9.00281H17.0049V14.0028L15.212 12.2099L10.6409 16.781L7.81249 13.9526L5.33834 16.4267C6.77158 18.5822 9.22233 20.0028 12.0049 20.0028C16.4232 20.0028 20.0049 16.4211 20.0049 12.0028C20.0049 7.58453 16.4232 4.00281 12.0049 4.00281C7.5866 4.00281 4.00488 7.58453 4.00488 12.0028C4.00488 12.8844 4.14747 13.7326 4.41085 14.5258ZM2.87288 16.084L2.86275 16.0739L2.86662 16.07C2.31276 14.8274 2.00488 13.4511 2.00488 12.0028C2.00488 6.47996 6.48204 2.00281 12.0049 2.00281C17.5277 2.00281 22.0049 6.47996 22.0049 12.0028C22.0049 17.5257 17.5277 22.0028 12.0049 22.0028C7.93574 22.0028 4.43426 19.5724 2.87288 16.084Z"
  }));
},
    Mr = function Mr(_ref932) {
  var _ref932$color = _ref932.color,
      C = _ref932$color === void 0 ? "currentColor" : _ref932$color,
      _ref932$size = _ref932.size,
      e = _ref932$size === void 0 ? 24 : _ref932$size,
      l = _ref932.className,
      i = _objectWithoutProperties(_ref932, _excluded932);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17.409 19C16.633 16.6012 15.1323 15.1147 13.1434 13.3979C15.0238 11.8971 17.4071 11 20 11V3H21.0082C21.556 3 22 3.44495 22 3.9934V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5551 2 20.0066V3.9934C2 3.44476 2.45531 3 2.9918 3H6V1H8V5H4V12C9.22015 12 13.6618 14.4616 15.3127 19H17.409ZM18 1V5H10V3H16V1H18ZM16.5 10C15.6716 10 15 9.32843 15 8.5C15 7.67157 15.6716 7 16.5 7C17.3284 7 18 7.67157 18 8.5C18 9.32843 17.3284 10 16.5 10Z"
  }));
},
    Zr = function Zr(_ref933) {
  var _ref933$color = _ref933.color,
      C = _ref933$color === void 0 ? "currentColor" : _ref933$color,
      _ref933$size = _ref933.size,
      e = _ref933$size === void 0 ? 24 : _ref933$size,
      l = _ref933.className,
      i = _objectWithoutProperties(_ref933, _excluded933);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 13C18.3221 13 16.7514 13.4592 15.4068 14.2587C16.5908 15.6438 17.5269 17.2471 18.1465 19H20V13ZM16.0037 19C14.0446 14.3021 9.4079 11 4 11V19H16.0037ZM4 9C7.82914 9 11.3232 10.4348 13.9738 12.7961C15.7047 11.6605 17.7752 11 20 11V3H21.0082C21.556 3 22 3.44495 22 3.9934V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5551 2 20.0066V3.9934C2 3.44476 2.45531 3 2.9918 3H6V1H8V5H4V9ZM18 1V5H10V3H16V1H18ZM16.5 10C15.6716 10 15 9.32843 15 8.5C15 7.67157 15.6716 7 16.5 7C17.3284 7 18 7.67157 18 8.5C18 9.32843 17.3284 10 16.5 10Z"
  }));
},
    xr = function xr(_ref934) {
  var _ref934$color = _ref934.color,
      C = _ref934$color === void 0 ? "currentColor" : _ref934$color,
      _ref934$size = _ref934.size,
      e = _ref934$size === void 0 ? 24 : _ref934$size,
      l = _ref934.className,
      i = _objectWithoutProperties(_ref934, _excluded934);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8 1V3H16V1H18V3H21.0082C21.556 3 22 3.44495 22 3.9934V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5551 2 20.0066V3.9934C2 3.44476 2.45531 3 2.9918 3H6V1H8ZM12 8L8 12H11V16H13V12H16L12 8Z"
  }));
},
    vr = function vr(_ref935) {
  var _ref935$color = _ref935.color,
      C = _ref935$color === void 0 ? "currentColor" : _ref935$color,
      _ref935$size = _ref935.size,
      e = _ref935$size === void 0 ? 24 : _ref935$size,
      l = _ref935.className,
      i = _objectWithoutProperties(_ref935, _excluded935);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8 1V5H4V19H20V3H21.0082C21.556 3 22 3.44495 22 3.9934V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5551 2 20.0066V3.9934C2 3.44476 2.45531 3 2.9918 3H6V1H8ZM12 8L16 12H13V16H11V12H8L12 8ZM18 1V5H10V3H16V1H18Z"
  }));
},
    dr = function dr(_ref936) {
  var _ref936$color = _ref936.color,
      C = _ref936$color === void 0 ? "currentColor" : _ref936$color,
      _ref936$size = _ref936.size,
      e = _ref936$size === void 0 ? 24 : _ref936$size,
      l = _ref936.className,
      i = _objectWithoutProperties(_ref936, _excluded936);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C15.1215 2 17.9089 3.43021 19.7428 5.67108L13.4142 12L19.7428 18.3289C17.9089 20.5698 15.1215 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 5C11.1716 5 10.5 5.67157 10.5 6.5C10.5 7.32843 11.1716 8 12 8C12.8284 8 13.5 7.32843 13.5 6.5C13.5 5.67157 12.8284 5 12 5Z"
  }));
},
    pr = function pr(_ref937) {
  var _ref937$color = _ref937.color,
      C = _ref937$color === void 0 ? "currentColor" : _ref937$color,
      _ref937$size = _ref937.size,
      e = _ref937$size === void 0 ? 24 : _ref937$size,
      l = _ref937.className,
      i = _objectWithoutProperties(_ref937, _excluded937);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C15.1215 2 17.9089 3.43021 19.7428 5.67108L13.4142 12L19.7428 18.3289C17.9089 20.5698 15.1215 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C13.7232 20 15.3548 19.4531 16.6974 18.4774L16.905 18.32L10.5859 12L16.905 5.679L16.6974 5.52261C15.4338 4.60431 13.9142 4.06583 12.3031 4.00565L12 4ZM12 5C12.8284 5 13.5 5.67157 13.5 6.5C13.5 7.32843 12.8284 8 12 8C11.1716 8 10.5 7.32843 10.5 6.5C10.5 5.67157 11.1716 5 12 5Z"
  }));
},
    Er = function Er(_ref938) {
  var _ref938$color = _ref938.color,
      C = _ref938$color === void 0 ? "currentColor" : _ref938$color,
      _ref938$size = _ref938.size,
      e = _ref938$size === void 0 ? 24 : _ref938$size,
      l = _ref938.className,
      i = _objectWithoutProperties(_ref938, _excluded938);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17 4C20.3137 4 23 6.68629 23 10V14C23 17.3137 20.3137 20 17 20H7C3.68629 20 1 17.3137 1 14V10C1 6.68629 3.68629 4 7 4H17ZM10 9H8V11H6V13H7.999L8 15H10L9.999 13H12V11H10V9ZM18 13H16V15H18V13ZM16 9H14V11H16V9Z"
  }));
},
    Nr = function Nr(_ref939) {
  var _ref939$color = _ref939.color,
      C = _ref939$color === void 0 ? "currentColor" : _ref939$color,
      _ref939$size = _ref939.size,
      e = _ref939$size === void 0 ? 24 : _ref939$size,
      l = _ref939.className,
      i = _objectWithoutProperties(_ref939, _excluded939);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17 4C20.3137 4 23 6.68629 23 10V14C23 17.3137 20.3137 20 17 20H7C3.68629 20 1 17.3137 1 14V10C1 6.68629 3.68629 4 7 4H17ZM17 6H7C4.8578 6 3.10892 7.68397 3.0049 9.80036L3 10V14C3 16.1422 4.68397 17.8911 6.80036 17.9951L7 18H17C19.1422 18 20.8911 16.316 20.9951 14.1996L21 14V10C21 7.8578 19.316 6.10892 17.1996 6.0049L17 6ZM10 9V11H12V13H9.999L10 15H8L7.999 13H6V11H8V9H10ZM18 13V15H16V13H18ZM16 9V11H14V9H16Z"
  }));
},
    ur = function ur(_ref940) {
  var _ref940$color = _ref940.color,
      C = _ref940$color === void 0 ? "currentColor" : _ref940$color,
      _ref940$size = _ref940.size,
      e = _ref940$size === void 0 ? 24 : _ref940$size,
      l = _ref940.className,
      i = _objectWithoutProperties(_ref940, _excluded940);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 19V4C3 3.44772 3.44772 3 4 3H13C13.5523 3 14 3.44772 14 4V12H16C17.1046 12 18 12.8954 18 14V18C18 18.5523 18.4477 19 19 19C19.5523 19 20 18.5523 20 18V11H18C17.4477 11 17 10.5523 17 10V6.41421L15.3431 4.75736L16.7574 3.34315L21.7071 8.29289C21.9024 8.48816 22 8.74408 22 9V18C22 19.6569 20.6569 21 19 21C17.3431 21 16 19.6569 16 18V14H14V19H15V21H2V19H3ZM5 5V11H12V5H5Z"
  }));
},
    Br = function Br(_ref941) {
  var _ref941$color = _ref941.color,
      C = _ref941$color === void 0 ? "currentColor" : _ref941$color,
      _ref941$size = _ref941.size,
      e = _ref941$size === void 0 ? 24 : _ref941$size,
      l = _ref941.className,
      i = _objectWithoutProperties(_ref941, _excluded941);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14 19H15V21H2V19H3V4C3 3.44772 3.44772 3 4 3H13C13.5523 3 14 3.44772 14 4V12H16C17.1046 12 18 12.8954 18 14V18C18 18.5523 18.4477 19 19 19C19.5523 19 20 18.5523 20 18V11H18C17.4477 11 17 10.5523 17 10V6.41421L15.3431 4.75736L16.7574 3.34315L21.7071 8.29289C21.9024 8.48816 22 8.74408 22 9V18C22 19.6569 20.6569 21 19 21C17.3431 21 16 19.6569 16 18V14H14V19ZM5 19H12V13H5V19ZM5 5V11H12V5H5Z"
  }));
},
    fr = function fr(_ref942) {
  var _ref942$color = _ref942.color,
      C = _ref942$color === void 0 ? "currentColor" : _ref942$color,
      _ref942$size = _ref942.size,
      e = _ref942$size === void 0 ? 24 : _ref942$size,
      l = _ref942.className,
      i = _objectWithoutProperties(_ref942, _excluded942);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.001 2C6.50098 2 2.00098 6.5 2.00098 12C2.00098 17.5 6.50098 22 12.001 22C17.501 22 22.001 17.5 22.001 12C22.001 6.5 17.501 2 12.001 2ZM6.42956 17.5714C4.92956 16.0714 4.14385 14.0714 4.14385 12.1429L11.9297 19.8571C9.92973 19.7857 7.92973 19.0714 6.42956 17.5714ZM13.7151 19.6429L4.3581 10.2857C5.14385 6.78571 8.28681 4.14286 12.001 4.14286C14.6439 4.14286 16.9297 5.42857 18.3581 7.35712L17.2868 8.28571C16.0722 6.64288 14.1439 5.57143 12.001 5.57143C9.21514 5.57143 6.8581 7.35713 5.92956 9.85713L14.1439 18.0714C16.2151 17.3571 17.7868 15.5714 18.2868 13.4286H14.8581V12H19.8581C19.8581 15.7143 17.2151 18.8571 13.7151 19.6429Z"
  }));
},
    Rr = function Rr(_ref943) {
  var _ref943$color = _ref943.color,
      C = _ref943$color === void 0 ? "currentColor" : _ref943$color,
      _ref943$size = _ref943.size,
      e = _ref943$size === void 0 ? 24 : _ref943$size,
      l = _ref943.className,
      i = _objectWithoutProperties(_ref943, _excluded943);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11.7519 21.997C6.53059 21.8694 2.3017 17.7397 2.01626 12.559L2.00391 12.246L11.7519 21.997ZM12.0009 2C15.39 2 18.3854 3.68597 20.194 6.26495L18.556 7.41293C17.1092 5.3492 14.7126 4 12.0009 4C8.59784 4 5.69105 6.12484 4.53491 9.12017L14.8807 19.466C17.2681 18.5445 19.1025 16.5109 19.7488 14.0004L15.5009 14V12H22.0009C22.0009 16.7261 18.7223 20.6865 14.3155 21.7308L2.27013 9.68538C3.31443 5.27856 7.27479 2 12.0009 2Z"
  }));
},
    zr = function zr(_ref944) {
  var _ref944$color = _ref944.color,
      C = _ref944$color === void 0 ? "currentColor" : _ref944$color,
      _ref944$size = _ref944.size,
      e = _ref944$size === void 0 ? 24 : _ref944$size,
      l = _ref944.className,
      i = _objectWithoutProperties(_ref944, _excluded944);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11 7.06609V1H13V7.06609C16.6694 7.55498 19.5 10.6969 19.5 14.5C19.5 18.6421 16.1421 22 12 22C7.85786 22 4.5 18.6421 4.5 14.5C4.5 10.6969 7.33064 7.55498 11 7.06609Z"
  }));
},
    Fr = function Fr(_ref945) {
  var _ref945$color = _ref945.color,
      C = _ref945$color === void 0 ? "currentColor" : _ref945$color,
      _ref945$size = _ref945.size,
      e = _ref945$size === void 0 ? 24 : _ref945$size,
      l = _ref945.className,
      i = _objectWithoutProperties(_ref945, _excluded945);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13 7.06609C16.6694 7.55498 19.5 10.6969 19.5 14.5C19.5 18.6421 16.1421 22 12 22C7.85786 22 4.5 18.6421 4.5 14.5C4.5 10.6969 7.33064 7.55498 11 7.06609V1H13V7.06609ZM12 20C15.0376 20 17.5 17.5376 17.5 14.5C17.5 11.4624 15.0376 9 12 9C8.96243 9 6.5 11.4624 6.5 14.5C6.5 17.5376 8.96243 20 12 20Z"
  }));
},
    Sr = function Sr(_ref946) {
  var _ref946$color = _ref946.color,
      C = _ref946$color === void 0 ? "currentColor" : _ref946$color,
      _ref946$size = _ref946.size,
      e = _ref946$size === void 0 ? 24 : _ref946$size,
      l = _ref946.className,
      i = _objectWithoutProperties(_ref946, _excluded946);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C15.5 2 18 5 19 8C22 9 23 11.73 23 14L20.2253 14.7928C19.796 14.9154 19.5 15.3078 19.5 15.7543V17.25C19.5 18.2165 18.7165 19 17.75 19H17.1536C16.4825 19 15.8562 19.3366 15.4858 19.8962C14.5576 21.2987 13.3957 22 12 22C10.6043 22 9.44238 21.2987 8.5142 19.8962C8.14383 19.3366 7.51746 19 6.84636 19H6.25C5.2835 19 4.5 18.2165 4.5 17.25V15.7543C4.5 15.3078 4.20402 14.9154 3.77472 14.7928L1 14C1 11.7337 2 9 5 8C6 5 8.5 2 12 2ZM12 12C11.1716 12 10.5 13.1193 10.5 14.5C10.5 15.8807 11.1716 17 12 17C12.8284 17 13.5 15.8807 13.5 14.5C13.5 13.1193 12.8284 12 12 12ZM9.5 8C8.67157 8 8 8.67157 8 9.5C8 10.3284 8.67157 11 9.5 11C10.3284 11 11 10.3284 11 9.5C11 8.67157 10.3284 8 9.5 8ZM14.5 8C13.6716 8 13 8.67157 13 9.5C13 10.3284 13.6716 11 14.5 11C15.3284 11 16 10.3284 16 9.5C16 8.67157 15.3284 8 14.5 8Z"
  }));
},
    Ar = function Ar(_ref947) {
  var _ref947$color = _ref947.color,
      C = _ref947$color === void 0 ? "currentColor" : _ref947$color,
      _ref947$size = _ref947.size,
      e = _ref947$size === void 0 ? 24 : _ref947$size,
      l = _ref947.className,
      i = _objectWithoutProperties(_ref947, _excluded947);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C15.5 2 18 5 19 8C22 9 23 11.73 23 14L20.2253 14.7928C19.796 14.9154 19.5 15.3078 19.5 15.7543V17.25C19.5 18.2165 18.7165 19 17.75 19H17.1536C16.4825 19 15.8562 19.3366 15.4858 19.8962C14.5576 21.2987 13.3957 22 12 22C10.6043 22 9.44238 21.2987 8.5142 19.8962C8.14383 19.3366 7.51746 19 6.84636 19H6.25C5.2835 19 4.5 18.2165 4.5 17.25V15.7543C4.5 15.3078 4.20402 14.9154 3.77472 14.7928L1 14C1 11.7337 2 9 5 8C6 5 8.5 2 12 2ZM12 4C9.8906 4 7.93534 5.78788 6.98864 8.37148L6.89737 8.63246L6.58114 9.58114L5.63246 9.89737C4.37721 10.3158 3.56485 11.238 3.20834 12.4564L3.185 12.543L4.32416 12.8697C5.55353 13.221 6.41845 14.3095 6.49454 15.5727L6.5 15.7543V17H6.84636C8.1096 17 9.29359 17.5963 10.0461 18.5996L10.182 18.7925C10.7584 19.6634 11.3162 20 12 20C12.6382 20 13.1667 19.7068 13.7029 18.9596L13.818 18.7925C14.5151 17.739 15.6658 17.0807 16.9178 17.0069L17.1536 17H17.5V15.7543C17.5 14.4757 18.309 13.3451 19.5027 12.9249L19.6758 12.8697L20.815 12.543L20.7918 12.4555C20.4554 11.3047 19.7124 10.4193 18.5728 9.97176L18.3675 9.89737L17.4189 9.58114L17.1026 8.63246C16.1948 5.90906 14.1797 4 12 4ZM12 12C12.8284 12 13.5 13.1193 13.5 14.5C13.5 15.8807 12.8284 17 12 17C11.1716 17 10.5 15.8807 10.5 14.5C10.5 13.1193 11.1716 12 12 12ZM9.5 8C10.3284 8 11 8.67157 11 9.5C11 10.3284 10.3284 11 9.5 11C8.67157 11 8 10.3284 8 9.5C8 8.67157 8.67157 8 9.5 8ZM14.5 8C15.3284 8 16 8.67157 16 9.5C16 10.3284 15.3284 11 14.5 11C13.6716 11 13 10.3284 13 9.5C13 8.67157 13.6716 8 14.5 8Z"
  }));
},
    kr = function kr(_ref948) {
  var _ref948$color = _ref948.color,
      C = _ref948$color === void 0 ? "currentColor" : _ref948$color,
      _ref948$size = _ref948.size,
      e = _ref948$size === void 0 ? 24 : _ref948$size,
      l = _ref948.className,
      i = _objectWithoutProperties(_ref948, _excluded948);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C16.9706 2 21 6.02944 21 11V18.5C21 20.433 19.433 22 17.5 22C16.3001 22 15.2413 21.3962 14.6107 20.476C14.0976 21.3857 13.1205 22 12 22C10.8795 22 9.9024 21.3857 9.38728 20.4754C8.75869 21.3962 7.69985 22 6.5 22C4.63144 22 3.10487 20.5357 3.00518 18.692L3 18.5V11C3 6.02944 7.02944 2 12 2ZM12 12C10.8954 12 10 13.1193 10 14.5C10 15.8807 10.8954 17 12 17C13.1046 17 14 15.8807 14 14.5C14 13.1193 13.1046 12 12 12ZM9.5 8C8.67157 8 8 8.67157 8 9.5C8 10.3284 8.67157 11 9.5 11C10.3284 11 11 10.3284 11 9.5C11 8.67157 10.3284 8 9.5 8ZM14.5 8C13.6716 8 13 8.67157 13 9.5C13 10.3284 13.6716 11 14.5 11C15.3284 11 16 10.3284 16 9.5C16 8.67157 15.3284 8 14.5 8Z"
  }));
},
    Pr = function Pr(_ref949) {
  var _ref949$color = _ref949.color,
      C = _ref949$color === void 0 ? "currentColor" : _ref949$color,
      _ref949$size = _ref949.size,
      e = _ref949$size === void 0 ? 24 : _ref949$size,
      l = _ref949.className,
      i = _objectWithoutProperties(_ref949, _excluded949);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C16.9706 2 21 6.02944 21 11V18.5C21 20.433 19.433 22 17.5 22C16.3001 22 15.2413 21.3962 14.6107 20.476C14.0976 21.3857 13.1205 22 12 22C10.8795 22 9.9024 21.3857 9.38728 20.4754C8.75869 21.3962 7.69985 22 6.5 22C4.63144 22 3.10487 20.5357 3.00518 18.692L3 18.5V11C3 6.02944 7.02944 2 12 2ZM12 4C8.21455 4 5.1309 7.00478 5.00406 10.7593L5 11L4.99927 18.4461L5.00226 18.584C5.04504 19.3751 5.70251 20 6.5 20C6.95179 20 7.36652 19.8007 7.64704 19.4648L7.73545 19.3478C8.57033 18.1248 10.3985 18.2016 11.1279 19.4904C11.3053 19.8038 11.6345 20 12 20C12.3651 20 12.6933 19.8044 12.8687 19.4934C13.5692 18.2516 15.2898 18.1317 16.1636 19.2151L16.2606 19.3455C16.5401 19.7534 16.9976 20 17.5 20C18.2797 20 18.9204 19.4051 18.9931 18.6445L19 18.5V11C19 7.13401 15.866 4 12 4ZM12 12C13.1046 12 14 13.1193 14 14.5C14 15.8807 13.1046 17 12 17C10.8954 17 10 15.8807 10 14.5C10 13.1193 10.8954 12 12 12ZM9.5 8C10.3284 8 11 8.67157 11 9.5C11 10.3284 10.3284 11 9.5 11C8.67157 11 8 10.3284 8 9.5C8 8.67157 8.67157 8 9.5 8ZM14.5 8C15.3284 8 16 8.67157 16 9.5C16 10.3284 15.3284 11 14.5 11C13.6716 11 13 10.3284 13 9.5C13 8.67157 13.6716 8 14.5 8Z"
  }));
},
    Dr = function Dr(_ref950) {
  var _ref950$color = _ref950.color,
      C = _ref950$color === void 0 ? "currentColor" : _ref950$color,
      _ref950$size = _ref950.size,
      e = _ref950$size === void 0 ? 24 : _ref950$size,
      l = _ref950.className,
      i = _objectWithoutProperties(_ref950, _excluded950);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C16.9706 2 21 6.02944 21 11V18.5C21 20.433 19.433 22 17.5 22C16.3001 22 15.2413 21.3962 14.6107 20.476C14.0976 21.3857 13.1205 22 12 22C10.8795 22 9.9024 21.3857 9.38728 20.4754C8.75869 21.3962 7.69985 22 6.5 22C4.63144 22 3.10487 20.5357 3.00518 18.692L3 18.5V11C3 6.02944 7.02944 2 12 2ZM16 13H14C14 14.1046 13.1046 15 12 15C10.9456 15 10.0818 14.1841 10.0055 13.1493L10 13H8L8.0049 13.1996C8.10892 15.316 9.8578 17 12 17C14.1422 17 15.8911 15.316 15.9951 13.1996L16 13ZM12 7C10.8954 7 10 7.89543 10 9C10 10.1046 10.8954 11 12 11C13.1046 11 14 10.1046 14 9C14 7.89543 13.1046 7 12 7Z"
  }));
},
    yr = function yr(_ref951) {
  var _ref951$color = _ref951.color,
      C = _ref951$color === void 0 ? "currentColor" : _ref951$color,
      _ref951$size = _ref951.size,
      e = _ref951$size === void 0 ? 24 : _ref951$size,
      l = _ref951.className,
      i = _objectWithoutProperties(_ref951, _excluded951);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C16.9706 2 21 6.02944 21 11V18.5C21 20.433 19.433 22 17.5 22C16.3001 22 15.2413 21.3962 14.6107 20.476C14.0976 21.3857 13.1205 22 12 22C10.8795 22 9.9024 21.3857 9.38728 20.4754C8.75869 21.3962 7.69985 22 6.5 22C4.63144 22 3.10487 20.5357 3.00518 18.692L3 18.5V11C3 6.02944 7.02944 2 12 2ZM12 4C8.21455 4 5.1309 7.00478 5.00406 10.7593L5 11L4.99927 18.4461L5.00226 18.584C5.04504 19.3751 5.70251 20 6.5 20C6.95179 20 7.36652 19.8007 7.64704 19.4648L7.73545 19.3478C8.57033 18.1248 10.3985 18.2016 11.1279 19.4904C11.3053 19.8038 11.6345 20 12 20C12.3651 20 12.6933 19.8044 12.8687 19.4934C13.5692 18.2516 15.2898 18.1317 16.1636 19.2151L16.2606 19.3455C16.5401 19.7534 16.9976 20 17.5 20C18.2797 20 18.9204 19.4051 18.9931 18.6445L19 18.5V11C19 7.13401 15.866 4 12 4ZM16 13C16 15.2091 14.2091 17 12 17C9.8578 17 8.10892 15.316 8.0049 13.1996L8 13H10C10 14.1046 10.8954 15 12 15C13.1046 15 14 14.1046 14 13H16ZM12 7C13.1046 7 14 7.89543 14 9C14 10.1046 13.1046 11 12 11C10.8954 11 10 10.1046 10 9C10 7.89543 10.8954 7 12 7Z"
  }));
},
    br = function br(_ref952) {
  var _ref952$color = _ref952.color,
      C = _ref952$color === void 0 ? "currentColor" : _ref952$color,
      _ref952$size = _ref952.size,
      e = _ref952$size === void 0 ? 24 : _ref952$size,
      l = _ref952.className,
      i = _objectWithoutProperties(_ref952, _excluded952);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.0049 13.0028V20.0028C20.0049 20.5551 19.5572 21.0028 19.0049 21.0028H5.00488C4.4526 21.0028 4.00488 20.5551 4.00488 20.0028V13.0028H20.0049ZM14.5049 2.00281C16.4379 2.00281 18.0049 3.56981 18.0049 5.50281C18.0049 6.04001 17.8839 6.54895 17.6676 7.00385L21.0049 7.00281C21.5572 7.00281 22.0049 7.45052 22.0049 8.00281V11.0028C22.0049 11.5551 21.5572 12.0028 21.0049 12.0028H3.00488C2.4526 12.0028 2.00488 11.5551 2.00488 11.0028V8.00281C2.00488 7.45052 2.4526 7.00281 3.00488 7.00281L6.34219 7.00385C6.12591 6.54895 6.00488 6.04001 6.00488 5.50281C6.00488 3.56981 7.57189 2.00281 9.50488 2.00281C10.4849 2.00281 11.3708 2.40557 12.0061 3.05459C12.639 2.40557 13.5249 2.00281 14.5049 2.00281ZM9.50488 4.00281C8.67646 4.00281 8.00488 4.67438 8.00488 5.50281C8.00488 6.2825 8.59977 6.92326 9.36042 6.99594L9.50488 7.00281H11.0049V5.50281C11.0049 4.72311 10.41 4.08236 9.64934 4.00967L9.50488 4.00281ZM14.5049 4.00281L14.3604 4.00967C13.6473 4.07782 13.0799 4.64524 13.0117 5.35835L13.0049 5.50281V7.00281H14.5049L14.6493 6.99594C15.41 6.92326 16.0049 6.2825 16.0049 5.50281C16.0049 4.72311 15.41 4.08236 14.6493 4.00967L14.5049 4.00281Z"
  }));
},
    Tr = function Tr(_ref953) {
  var _ref953$color = _ref953.color,
      C = _ref953$color === void 0 ? "currentColor" : _ref953$color,
      _ref953$size = _ref953.size,
      e = _ref953$size === void 0 ? 24 : _ref953$size,
      l = _ref953.className,
      i = _objectWithoutProperties(_ref953, _excluded953);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14.5049 2.00281C16.4379 2.00281 18.0049 3.56981 18.0049 5.50281C18.0049 6.04001 17.8839 6.54895 17.6676 7.00385L21.0049 7.00281C21.5572 7.00281 22.0049 7.45052 22.0049 8.00281V12.0028C22.0049 12.5551 21.5572 13.0028 21.0049 13.0028H20.0049V21.0028C20.0049 21.5551 19.5572 22.0028 19.0049 22.0028H5.00488C4.4526 22.0028 4.00488 21.5551 4.00488 21.0028V13.0028H3.00488C2.4526 13.0028 2.00488 12.5551 2.00488 12.0028V8.00281C2.00488 7.45052 2.4526 7.00281 3.00488 7.00281L6.34219 7.00385C6.12591 6.54895 6.00488 6.04001 6.00488 5.50281C6.00488 3.56981 7.57189 2.00281 9.50488 2.00281C10.4849 2.00281 11.3708 2.40557 12.0061 3.05459C12.639 2.40557 13.5249 2.00281 14.5049 2.00281ZM18.0049 13.0028H6.00488V20.0028H18.0049V13.0028ZM20.0049 9.00281H4.00488V11.0028H20.0049V9.00281ZM9.50488 4.00281C8.67646 4.00281 8.00488 4.67438 8.00488 5.50281C8.00488 6.2825 8.59977 6.92326 9.36042 6.99594L9.50488 7.00281H11.0049V5.50281C11.0049 4.72311 10.41 4.08236 9.64934 4.00967L9.50488 4.00281ZM14.5049 4.00281L14.3604 4.00967C13.6473 4.07782 13.0799 4.64524 13.0117 5.35835L13.0049 5.50281V7.00281H14.5049L14.6493 6.99594C15.41 6.92326 16.0049 6.2825 16.0049 5.50281C16.0049 4.72311 15.41 4.08236 14.6493 4.00967L14.5049 4.00281Z"
  }));
},
    Ur = function Ur(_ref954) {
  var _ref954$color = _ref954.color,
      C = _ref954$color === void 0 ? "currentColor" : _ref954$color,
      _ref954$size = _ref954.size,
      e = _ref954$size === void 0 ? 24 : _ref954$size,
      l = _ref954.className,
      i = _objectWithoutProperties(_ref954, _excluded954);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15.0049 2.00281C17.214 2.00281 19.0049 3.79367 19.0049 6.00281C19.0049 6.73184 18.8098 7.41532 18.4691 8.00392L23.0049 8.00281V10.0028H21.0049V20.0028C21.0049 20.5551 20.5572 21.0028 20.0049 21.0028H4.00488C3.4526 21.0028 3.00488 20.5551 3.00488 20.0028V10.0028H1.00488V8.00281L5.54065 8.00392C5.19992 7.41532 5.00488 6.73184 5.00488 6.00281C5.00488 3.79367 6.79574 2.00281 9.00488 2.00281C10.2001 2.00281 11.2729 2.52702 12.0058 3.35807C12.7369 2.52702 13.8097 2.00281 15.0049 2.00281ZM13.0049 10.0028H11.0049V20.0028H13.0049V10.0028ZM9.00488 4.00281C7.90031 4.00281 7.00488 4.89824 7.00488 6.00281C7.00488 7.05717 7.82076 7.92097 8.85562 7.99732L9.00488 8.00281H11.0049V6.00281C11.0049 5.00116 10.2686 4.1715 9.30766 4.02558L9.15415 4.00829L9.00488 4.00281ZM15.0049 4.00281C13.9505 4.00281 13.0867 4.81869 13.0104 5.85355L13.0049 6.00281V8.00281H15.0049C16.0592 8.00281 16.923 7.18693 16.9994 6.15207L17.0049 6.00281C17.0049 4.89824 16.1095 4.00281 15.0049 4.00281Z"
  }));
},
    Gr = function Gr(_ref955) {
  var _ref955$color = _ref955.color,
      C = _ref955$color === void 0 ? "currentColor" : _ref955$color,
      _ref955$size = _ref955.size,
      e = _ref955$size === void 0 ? 24 : _ref955$size,
      l = _ref955.className,
      i = _objectWithoutProperties(_ref955, _excluded955);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15.0049 2.00281C17.214 2.00281 19.0049 3.79367 19.0049 6.00281C19.0049 6.73184 18.8098 7.41532 18.4691 8.00392L23.0049 8.00281V10.0028H21.0049V20.0028C21.0049 20.5551 20.5572 21.0028 20.0049 21.0028H4.00488C3.4526 21.0028 3.00488 20.5551 3.00488 20.0028V10.0028H1.00488V8.00281L5.54065 8.00392C5.19992 7.41532 5.00488 6.73184 5.00488 6.00281C5.00488 3.79367 6.79574 2.00281 9.00488 2.00281C10.2001 2.00281 11.2729 2.52702 12.0058 3.35807C12.7369 2.52702 13.8097 2.00281 15.0049 2.00281ZM11.0049 10.0028H5.00488V19.0028H11.0049V10.0028ZM19.0049 10.0028H13.0049V19.0028H19.0049V10.0028ZM9.00488 4.00281C7.90031 4.00281 7.00488 4.89824 7.00488 6.00281C7.00488 7.05717 7.82076 7.92097 8.85562 7.99732L9.00488 8.00281H11.0049V6.00281C11.0049 5.00116 10.2686 4.1715 9.30766 4.02558L9.15415 4.00829L9.00488 4.00281ZM15.0049 4.00281C13.9505 4.00281 13.0867 4.81869 13.0104 5.85355L13.0049 6.00281V8.00281H15.0049C16.0592 8.00281 16.923 7.18693 16.9994 6.15207L17.0049 6.00281C17.0049 4.89824 16.1095 4.00281 15.0049 4.00281Z"
  }));
},
    Ir = function Ir(_ref956) {
  var _ref956$color = _ref956.color,
      C = _ref956$color === void 0 ? "currentColor" : _ref956$color,
      _ref956$size = _ref956.size,
      e = _ref956$size === void 0 ? 24 : _ref956$size,
      l = _ref956.className,
      i = _objectWithoutProperties(_ref956, _excluded956);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7.10508 15.2101C8.21506 15.6501 9 16.7334 9 18C9 19.6569 7.65685 21 6 21C4.34315 21 3 19.6569 3 18C3 16.6938 3.83481 15.5825 5 15.1707V8.82929C3.83481 8.41746 3 7.30622 3 6C3 4.34315 4.34315 3 6 3C7.65685 3 9 4.34315 9 6C9 7.30622 8.16519 8.41746 7 8.82929V11.9996C7.83566 11.3719 8.87439 11 10 11H14C15.3835 11 16.5482 10.0635 16.8949 8.78991C15.7849 8.34988 15 7.26661 15 6C15 4.34315 16.3431 3 18 3C19.6569 3 21 4.34315 21 6C21 7.3332 20.1303 8.46329 18.9274 8.85392C18.5222 11.2085 16.4703 13 14 13H10C8.61653 13 7.45179 13.9365 7.10508 15.2101Z"
  }));
},
    Wr = function Wr(_ref957) {
  var _ref957$color = _ref957.color,
      C = _ref957$color === void 0 ? "currentColor" : _ref957$color,
      _ref957$size = _ref957.size,
      e = _ref957$size === void 0 ? 24 : _ref957$size,
      l = _ref957.className,
      i = _objectWithoutProperties(_ref957, _excluded957);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7.10508 15.2101C8.21506 15.6501 9 16.7334 9 18C9 19.6569 7.65685 21 6 21C4.34315 21 3 19.6569 3 18C3 16.6938 3.83481 15.5825 5 15.1707V8.82929C3.83481 8.41746 3 7.30622 3 6C3 4.34315 4.34315 3 6 3C7.65685 3 9 4.34315 9 6C9 7.30622 8.16519 8.41746 7 8.82929V11.9996C7.83566 11.3719 8.87439 11 10 11H14C15.3835 11 16.5482 10.0635 16.8949 8.78991C15.7849 8.34988 15 7.26661 15 6C15 4.34315 16.3431 3 18 3C19.6569 3 21 4.34315 21 6C21 7.3332 20.1303 8.46329 18.9274 8.85392C18.5222 11.2085 16.4703 13 14 13H10C8.61653 13 7.45179 13.9365 7.10508 15.2101ZM6 17C5.44772 17 5 17.4477 5 18C5 18.5523 5.44772 19 6 19C6.55228 19 7 18.5523 7 18C7 17.4477 6.55228 17 6 17ZM6 5C5.44772 5 5 5.44772 5 6C5 6.55228 5.44772 7 6 7C6.55228 7 7 6.55228 7 6C7 5.44772 6.55228 5 6 5ZM18 5C17.4477 5 17 5.44772 17 6C17 6.55228 17.4477 7 18 7C18.5523 7 19 6.55228 19 6C19 5.44772 18.5523 5 18 5Z"
  }));
},
    Or = function Or(_ref958) {
  var _ref958$color = _ref958.color,
      C = _ref958$color === void 0 ? "currentColor" : _ref958$color,
      _ref958$size = _ref958.size,
      e = _ref958$size === void 0 ? 24 : _ref958$size,
      l = _ref958.className,
      i = _objectWithoutProperties(_ref958, _excluded958);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15.874 13C15.4299 14.7252 13.8638 16 12 16C10.1362 16 8.57006 14.7252 8.12602 13H3V11H8.12602C8.57006 9.27477 10.1362 8 12 8C13.8638 8 15.4299 9.27477 15.874 11H21V13H15.874Z"
  }));
},
    Kr = function Kr(_ref959) {
  var _ref959$color = _ref959.color,
      C = _ref959$color === void 0 ? "currentColor" : _ref959$color,
      _ref959$size = _ref959.size,
      e = _ref959$size === void 0 ? 24 : _ref959$size,
      l = _ref959.className,
      i = _objectWithoutProperties(_ref959, _excluded959);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15.874 13C15.4299 14.7252 13.8638 16 12 16C10.1362 16 8.57006 14.7252 8.12602 13H3V11H8.12602C8.57006 9.27477 10.1362 8 12 8C13.8638 8 15.4299 9.27477 15.874 11H21V13H15.874ZM12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z"
  }));
},
    Qr = function Qr(_ref960) {
  var _ref960$color = _ref960.color,
      C = _ref960$color === void 0 ? "currentColor" : _ref960$color,
      _ref960$size = _ref960.size,
      e = _ref960$size === void 0 ? 24 : _ref960$size,
      l = _ref960.className,
      i = _objectWithoutProperties(_ref960, _excluded960);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7.10508 8.78991C7.45179 10.0635 8.61653 11 10 11H14C16.4703 11 18.5222 12.7915 18.9274 15.1461C20.1303 15.5367 21 16.6668 21 18C21 19.6569 19.6569 21 18 21C16.3431 21 15 19.6569 15 18C15 16.7334 15.7849 15.6501 16.8949 15.2101C16.5482 13.9365 15.3835 13 14 13H10C8.87439 13 7.83566 12.6281 7 12.0004V15.1707C8.16519 15.5825 9 16.6938 9 18C9 19.6569 7.65685 21 6 21C4.34315 21 3 19.6569 3 18C3 16.6938 3.83481 15.5825 5 15.1707V8.82929C3.83481 8.41746 3 7.30622 3 6C3 4.34315 4.34315 3 6 3C7.65685 3 9 4.34315 9 6C9 7.26661 8.21506 8.34988 7.10508 8.78991Z"
  }));
},
    qr = function qr(_ref961) {
  var _ref961$color = _ref961.color,
      C = _ref961$color === void 0 ? "currentColor" : _ref961$color,
      _ref961$size = _ref961.size,
      e = _ref961$size === void 0 ? 24 : _ref961$size,
      l = _ref961.className,
      i = _objectWithoutProperties(_ref961, _excluded961);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7.10508 8.78991C7.45179 10.0635 8.61653 11 10 11H14C16.4703 11 18.5222 12.7915 18.9274 15.1461C20.1303 15.5367 21 16.6668 21 18C21 19.6569 19.6569 21 18 21C16.3431 21 15 19.6569 15 18C15 16.7334 15.7849 15.6501 16.8949 15.2101C16.5482 13.9365 15.3835 13 14 13H10C8.87439 13 7.83566 12.6281 7 12.0004V15.1707C8.16519 15.5825 9 16.6938 9 18C9 19.6569 7.65685 21 6 21C4.34315 21 3 19.6569 3 18C3 16.6938 3.83481 15.5825 5 15.1707V8.82929C3.83481 8.41746 3 7.30622 3 6C3 4.34315 4.34315 3 6 3C7.65685 3 9 4.34315 9 6C9 7.26661 8.21506 8.34988 7.10508 8.78991ZM6 7C6.55228 7 7 6.55228 7 6C7 5.44772 6.55228 5 6 5C5.44772 5 5 5.44772 5 6C5 6.55228 5.44772 7 6 7ZM6 19C6.55228 19 7 18.5523 7 18C7 17.4477 6.55228 17 6 17C5.44772 17 5 17.4477 5 18C5 18.5523 5.44772 19 6 19ZM18 19C18.5523 19 19 18.5523 19 18C19 17.4477 18.5523 17 18 17C17.4477 17 17 17.4477 17 18C17 18.5523 17.4477 19 18 19Z"
  }));
},
    jr = function jr(_ref962) {
  var _ref962$color = _ref962.color,
      C = _ref962$color === void 0 ? "currentColor" : _ref962$color,
      _ref962$size = _ref962.size,
      e = _ref962$size === void 0 ? 24 : _ref962$size,
      l = _ref962.className,
      i = _objectWithoutProperties(_ref962, _excluded962);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15 5H17C18.1046 5 19 5.89543 19 7V15.1707C20.1652 15.5825 21 16.6938 21 18C21 19.6569 19.6569 21 18 21C16.3431 21 15 19.6569 15 18C15 16.6938 15.8348 15.5825 17 15.1707V7H15V10L10.5 6L15 2V5ZM5 8.82929C3.83481 8.41746 3 7.30622 3 6C3 4.34315 4.34315 3 6 3C7.65685 3 9 4.34315 9 6C9 7.30622 8.16519 8.41746 7 8.82929V15.1707C8.16519 15.5825 9 16.6938 9 18C9 19.6569 7.65685 21 6 21C4.34315 21 3 19.6569 3 18C3 16.6938 3.83481 15.5825 5 15.1707V8.82929Z"
  }));
},
    Xr = function Xr(_ref963) {
  var _ref963$color = _ref963.color,
      C = _ref963$color === void 0 ? "currentColor" : _ref963$color,
      _ref963$size = _ref963.size,
      e = _ref963$size === void 0 ? 24 : _ref963$size,
      l = _ref963.className,
      i = _objectWithoutProperties(_ref963, _excluded963);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15 5H17C18.1046 5 19 5.89543 19 7V15.1707C20.1652 15.5825 21 16.6938 21 18C21 19.6569 19.6569 21 18 21C16.3431 21 15 19.6569 15 18C15 16.6938 15.8348 15.5825 17 15.1707V7H15V10L10.5 6L15 2V5ZM5 8.82929C3.83481 8.41746 3 7.30622 3 6C3 4.34315 4.34315 3 6 3C7.65685 3 9 4.34315 9 6C9 7.30622 8.16519 8.41746 7 8.82929V15.1707C8.16519 15.5825 9 16.6938 9 18C9 19.6569 7.65685 21 6 21C4.34315 21 3 19.6569 3 18C3 16.6938 3.83481 15.5825 5 15.1707V8.82929ZM6 7C6.55228 7 7 6.55228 7 6C7 5.44772 6.55228 5 6 5C5.44772 5 5 5.44772 5 6C5 6.55228 5.44772 7 6 7ZM6 19C6.55228 19 7 18.5523 7 18C7 17.4477 6.55228 17 6 17C5.44772 17 5 17.4477 5 18C5 18.5523 5.44772 19 6 19ZM18 19C18.5523 19 19 18.5523 19 18C19 17.4477 18.5523 17 18 17C17.4477 17 17 17.4477 17 18C17 18.5523 17.4477 19 18 19Z"
  }));
},
    Jr = function Jr(_ref964) {
  var _ref964$color = _ref964.color,
      C = _ref964$color === void 0 ? "currentColor" : _ref964$color,
      _ref964$size = _ref964.size,
      e = _ref964$size === void 0 ? 24 : _ref964$size,
      l = _ref964.className,
      i = _objectWithoutProperties(_ref964, _excluded964);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14 17V23H12V17H9L13 12L17 17H14ZM16 19H19V16H18.2L13 9.5L7.64706 16H6.5C5.67157 16 5 16.6716 5 17.5C5 18.3284 5.67157 19 6.5 19H10V21H6.5C4.567 21 3 19.433 3 17.5V5C3 3.34315 4.34315 2 6 2H20C20.5523 2 21 2.44772 21 3V20C21 20.5523 20.5523 21 20 21H16V19ZM7 5V7H9V5H7ZM7 8V10H9V8H7Z"
  }));
},
    Yr = function Yr(_ref965) {
  var _ref965$color = _ref965.color,
      C = _ref965$color === void 0 ? "currentColor" : _ref965$color,
      _ref965$size = _ref965.size,
      e = _ref965$size === void 0 ? 24 : _ref965$size,
      l = _ref965.className,
      i = _objectWithoutProperties(_ref965, _excluded965);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18 16V14H19V4H6V14.0354C6.1633 14.0121 6.33024 14 6.5 14H8V16H6.5C5.67157 16 5 16.6716 5 17.5C5 18.3284 5.67157 19 6.5 19H10V21H6.5C4.567 21 3 19.433 3 17.5V5C3 3.34315 4.34315 2 6 2H20C20.5523 2 21 2.44772 21 3V20C21 20.5523 20.5523 21 20 21H16V19H19V16H18ZM7 5H9V7H7V5ZM7 8H9V10H7V8ZM14 17V23H12V17H9L13 12L17 17H14Z"
  }));
},
    _r = function _r(_ref966) {
  var _ref966$color = _ref966.color,
      C = _ref966$color === void 0 ? "currentColor" : _ref966$color,
      _ref966$size = _ref966.size,
      e = _ref966$size === void 0 ? 24 : _ref966$size,
      l = _ref966.className,
      i = _objectWithoutProperties(_ref966, _excluded966);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13 21V23.5L10 21.5L7 23.5V21H6.5C4.567 21 3 19.433 3 17.5V5C3 3.34315 4.34315 2 6 2H20C20.5523 2 21 2.44772 21 3V20C21 20.5523 20.5523 21 20 21H13ZM7 19V17H13V19H19V16H6.5C5.67157 16 5 16.6716 5 17.5C5 18.3284 5.67157 19 6.5 19H7ZM7 5V7H9V5H7ZM7 8V10H9V8H7ZM7 11V13H9V11H7Z"
  }));
},
    $r = function $r(_ref967) {
  var _ref967$color = _ref967.color,
      C = _ref967$color === void 0 ? "currentColor" : _ref967$color,
      _ref967$size = _ref967.size,
      e = _ref967$size === void 0 ? 24 : _ref967$size,
      l = _ref967.className,
      i = _objectWithoutProperties(_ref967, _excluded967);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13 21V23.5L10 21.5L7 23.5V21H6.5C4.567 21 3 19.433 3 17.5V5C3 3.34315 4.34315 2 6 2H20C20.5523 2 21 2.44772 21 3V20C21 20.5523 20.5523 21 20 21H13ZM13 19H19V16H6.5C5.67157 16 5 16.6716 5 17.5C5 18.3284 5.67157 19 6.5 19H7V17H13V19ZM19 14V4H6V14.0354C6.1633 14.0121 6.33024 14 6.5 14H19ZM7 5H9V7H7V5ZM7 8H9V10H7V8ZM7 11H9V13H7V11Z"
  }));
},
    ec = function ec(_ref968) {
  var _ref968$color = _ref968.color,
      C = _ref968$color === void 0 ? "currentColor" : _ref968$color,
      _ref968$size = _ref968.size,
      e = _ref968$size === void 0 ? 24 : _ref968$size,
      l = _ref968.className,
      i = _objectWithoutProperties(_ref968, _excluded968);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18 8H20C20.5523 8 21 8.44772 21 9V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V9C3 8.44772 3.44772 8 4 8H6V7C6 3.68629 8.68629 1 12 1C15.3137 1 18 3.68629 18 7V8ZM16 8V7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7V8H16ZM7 11V13H9V11H7ZM7 14V16H9V14H7ZM7 17V19H9V17H7Z"
  }));
},
    tc = function tc(_ref969) {
  var _ref969$color = _ref969.color,
      C = _ref969$color === void 0 ? "currentColor" : _ref969$color,
      _ref969$size = _ref969.size,
      e = _ref969$size === void 0 ? 24 : _ref969$size,
      l = _ref969.className,
      i = _objectWithoutProperties(_ref969, _excluded969);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6 10V20H19V10H6ZM18 8H20C20.5523 8 21 8.44772 21 9V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V9C3 8.44772 3.44772 8 4 8H6V7C6 3.68629 8.68629 1 12 1C15.3137 1 18 3.68629 18 7V8ZM16 8V7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7V8H16ZM7 11H9V13H7V11ZM7 14H9V16H7V14ZM7 17H9V19H7V17Z"
  }));
},
    Cc = function Cc(_ref970) {
  var _ref970$color = _ref970.color,
      C = _ref970$color === void 0 ? "currentColor" : _ref970$color,
      _ref970$size = _ref970.size,
      e = _ref970$size === void 0 ? 24 : _ref970$size,
      l = _ref970.className,
      i = _objectWithoutProperties(_ref970, _excluded970);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.001 2C6.47598 2 2.00098 6.475 2.00098 12C2.00098 16.425 4.86348 20.1625 8.83848 21.4875C9.33848 21.575 9.52598 21.275 9.52598 21.0125C9.52598 20.775 9.51348 19.9875 9.51348 19.15C7.00098 19.6125 6.35098 18.5375 6.15098 17.975C6.03848 17.6875 5.55098 16.8 5.12598 16.5625C4.77598 16.375 4.27598 15.9125 5.11348 15.9C5.90098 15.8875 6.46348 16.625 6.65098 16.925C7.55098 18.4375 8.98848 18.0125 9.56348 17.75C9.65098 17.1 9.91348 16.6625 10.201 16.4125C7.97598 16.1625 5.65098 15.3 5.65098 11.475C5.65098 10.3875 6.03848 9.4875 6.67598 8.7875C6.57598 8.5375 6.22598 7.5125 6.77598 6.1375C6.77598 6.1375 7.61348 5.875 9.52598 7.1625C10.326 6.9375 11.176 6.825 12.026 6.825C12.876 6.825 13.726 6.9375 14.526 7.1625C16.4385 5.8625 17.276 6.1375 17.276 6.1375C17.826 7.5125 17.476 8.5375 17.376 8.7875C18.0135 9.4875 18.401 10.375 18.401 11.475C18.401 15.3125 16.0635 16.1625 13.8385 16.4125C14.201 16.725 14.5135 17.325 14.5135 18.2625C14.5135 19.6 14.501 20.675 14.501 21.0125C14.501 21.275 14.6885 21.5875 15.1885 21.4875C19.259 20.1133 21.9999 16.2963 22.001 12C22.001 6.475 17.526 2 12.001 2Z"
  }));
},
    lc = function lc(_ref971) {
  var _ref971$color = _ref971.color,
      C = _ref971$color === void 0 ? "currentColor" : _ref971$color,
      _ref971$size = _ref971.size,
      e = _ref971$size === void 0 ? 24 : _ref971$size,
      l = _ref971.className,
      i = _objectWithoutProperties(_ref971, _excluded971);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5.88401 18.6533C5.58404 18.4526 5.32587 18.1975 5.0239 17.8369C4.91473 17.7065 4.47283 17.1524 4.55811 17.2583C4.09533 16.6833 3.80296 16.417 3.50156 16.3089C2.9817 16.1225 2.7114 15.5499 2.89784 15.0301C3.08428 14.5102 3.65685 14.2399 4.17672 14.4263C4.92936 14.6963 5.43847 15.1611 6.12425 16.0143C6.03025 15.8974 6.46364 16.441 6.55731 16.5529C6.74784 16.7804 6.88732 16.9182 6.99629 16.9911C7.20118 17.1283 7.58451 17.1874 8.14709 17.1311C8.17065 16.7489 8.24136 16.3783 8.34919 16.0358C5.38097 15.3104 3.70116 13.3952 3.70116 9.63971C3.70116 8.40085 4.0704 7.28393 4.75917 6.3478C4.5415 5.45392 4.57433 4.37284 5.06092 3.15636C5.1725 2.87739 5.40361 2.66338 5.69031 2.57352C5.77242 2.54973 5.81791 2.53915 5.89878 2.52673C6.70167 2.40343 7.83573 2.69705 9.31449 3.62336C10.181 3.41879 11.0885 3.315 12.0012 3.315C12.9129 3.315 13.8196 3.4186 14.6854 3.62277C16.1619 2.69 17.2986 2.39649 18.1072 2.52651C18.1919 2.54013 18.2645 2.55783 18.3249 2.57766C18.6059 2.66991 18.8316 2.88179 18.9414 3.15636C19.4279 4.37256 19.4608 5.45344 19.2433 6.3472C19.9342 7.28337 20.3012 8.39208 20.3012 9.63971C20.3012 13.3968 18.627 15.3048 15.6588 16.032C15.7837 16.447 15.8496 16.9105 15.8496 17.4121C15.8496 18.0765 15.8471 18.711 15.8424 19.4225C15.8412 19.6127 15.8397 19.8159 15.8375 20.1281C16.2129 20.2109 16.5229 20.5077 16.6031 20.9089C16.7114 21.4504 16.3602 21.9773 15.8186 22.0856C14.6794 22.3134 13.8353 21.5538 13.8353 20.5611C13.8353 20.4708 13.836 20.3417 13.8375 20.1145C13.8398 19.8015 13.8412 19.599 13.8425 19.4094C13.8471 18.7019 13.8496 18.0716 13.8496 17.4121C13.8496 16.7148 13.6664 16.2602 13.4237 16.051C12.7627 15.4812 13.0977 14.3973 13.965 14.2999C16.9314 13.9666 18.3012 12.8177 18.3012 9.63971C18.3012 8.68508 17.9893 7.89571 17.3881 7.23559C17.1301 6.95233 17.0567 6.54659 17.199 6.19087C17.3647 5.77663 17.4354 5.23384 17.2941 4.57702L17.2847 4.57968C16.7928 4.71886 16.1744 5.0198 15.4261 5.5285C15.182 5.69438 14.8772 5.74401 14.5932 5.66413C13.7729 5.43343 12.8913 5.315 12.0012 5.315C11.111 5.315 10.2294 5.43343 9.40916 5.66413C9.12662 5.74359 8.82344 5.69492 8.57997 5.53101C7.8274 5.02439 7.2056 4.72379 6.71079 4.58376C6.56735 5.23696 6.63814 5.77782 6.80336 6.19087C6.94565 6.54659 6.87219 6.95233 6.61423 7.23559C6.01715 7.8912 5.70116 8.69376 5.70116 9.63971C5.70116 12.8116 7.07225 13.9683 10.023 14.2999C10.8883 14.3971 11.2246 15.4769 10.5675 16.0482C10.3751 16.2156 10.1384 16.7802 10.1384 17.4121V20.5611C10.1384 21.5474 9.30356 22.2869 8.17878 22.09C7.63476 21.9948 7.27093 21.4766 7.36613 20.9326C7.43827 20.5204 7.75331 20.2116 8.13841 20.1276V19.1381C7.22829 19.1994 6.47656 19.0498 5.88401 18.6533Z"
  }));
},
    ic = function ic(_ref972) {
  var _ref972$color = _ref972.color,
      C = _ref972$color === void 0 ? "currentColor" : _ref972$color,
      _ref972$size = _ref972.size,
      e = _ref972$size === void 0 ? 24 : _ref972$size,
      l = _ref972.className,
      i = _objectWithoutProperties(_ref972, _excluded972);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21.6634 9.98681L21.6354 9.91518L18.9164 2.8208C18.8612 2.68166 18.7634 2.56353 18.6371 2.48326C18.5098 2.40292 18.3607 2.36406 18.2104 2.37206C18.0601 2.38006 17.9159 2.43452 17.7979 2.52792C17.6809 2.62169 17.5966 2.75 17.5569 2.89453L15.7187 8.52037H8.28157L6.44336 2.89453C6.40366 2.75 6.31934 2.62169 6.20241 2.52792C6.08487 2.43389 5.94083 2.37903 5.79052 2.37102C5.64021 2.36301 5.49116 2.40226 5.36429 2.48326C5.2374 2.5632 5.13921 2.6814 5.08388 2.8208L2.36183 9.9245L2.33379 9.99512C1.94304 11.0182 1.895 12.1406 2.19691 13.1933C2.49882 14.2461 3.13436 15.1724 4.00794 15.8329L4.01832 15.8401L4.04221 15.8588L8.18917 18.9631L10.2393 20.5157L11.4856 21.4597C11.6319 21.5704 11.8104 21.6302 11.9939 21.6302C12.1774 21.6302 12.3559 21.5704 12.5023 21.4597L13.7486 20.5157L15.7997 18.9631L19.9706 15.8401L19.9819 15.8318C20.8585 15.1719 21.4966 14.2449 21.7999 13.1904C22.1033 12.1361 22.0553 11.0116 21.6634 9.98681Z"
  }));
},
    sc = function sc(_ref973) {
  var _ref973$color = _ref973.color,
      C = _ref973$color === void 0 ? "currentColor" : _ref973$color,
      _ref973$size = _ref973.size,
      e = _ref973$size === void 0 ? 24 : _ref973$size,
      l = _ref973.className,
      i = _objectWithoutProperties(_ref973, _excluded973);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5.54429 2.67305C5.81644 2.49995 6.13587 2.41612 6.45799 2.43329C6.78102 2.4505 7.09056 2.56841 7.34318 2.77049L7.34405 2.77119C7.59044 2.96879 7.76998 3.2372 7.85866 3.5399L9.30537 7.96754H14.6944L16.1411 3.5399C16.2298 3.23722 16.4093 2.96879 16.6557 2.77116L16.6604 2.76745C16.9128 2.56777 17.2209 2.45133 17.5424 2.43423C17.8638 2.41712 18.1826 2.50023 18.4547 2.67197L18.4571 2.67347C18.7307 2.84735 18.9427 3.10328 19.0624 3.40486L19.0664 3.41491L21.5393 9.86622C21.9619 10.9712 22.0136 12.1836 21.6865 13.3205C21.3594 14.4574 20.6715 15.457 19.7263 16.1685L12.9955 21.2331L12.9945 21.2338C12.7066 21.4513 12.3554 21.5692 11.9943 21.5692C11.6332 21.5692 11.2819 21.4513 10.9939 21.2337L4.26254 16.1683C3.32063 15.4562 2.63541 14.4574 2.30989 13.3224C1.98437 12.1873 2.03616 10.9772 2.45747 9.8741L4.93724 3.40497C5.0571 3.10297 5.26966 2.84673 5.54429 2.67305ZM6.35534 4.73567L4.16029 10.4639C3.87993 11.2013 3.82298 12.0676 4.04049 12.8261C4.25704 13.5811 4.71123 14.2461 5.33544 14.7225L11.9943 19.7329L18.6484 14.7265C19.2789 14.2502 19.7379 13.5822 19.9563 12.8227C20.1751 12.0624 20.1148 11.1847 19.8328 10.4455L17.6444 4.73558L16.0001 9.76791H7.9996L6.35534 4.73567Z"
  }));
},
    rc = function rc(_ref974) {
  var _ref974$color = _ref974.color,
      C = _ref974$color === void 0 ? "currentColor" : _ref974$color,
      _ref974$size = _ref974.size,
      e = _ref974$size === void 0 ? 24 : _ref974$size,
      l = _ref974.className,
      i = _objectWithoutProperties(_ref974, _excluded974);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2.04932 12.9999H7.52725C7.70624 16.2688 8.7574 19.3053 10.452 21.8809C5.98761 21.1871 2.5001 17.5402 2.04932 12.9999ZM2.04932 10.9999C2.5001 6.45968 5.98761 2.81276 10.452 2.11902C8.7574 4.69456 7.70624 7.73111 7.52725 10.9999H2.04932ZM21.9506 10.9999H16.4726C16.2936 7.73111 15.2425 4.69456 13.5479 2.11902C18.0123 2.81276 21.4998 6.45968 21.9506 10.9999ZM21.9506 12.9999C21.4998 17.5402 18.0123 21.1871 13.5479 21.8809C15.2425 19.3053 16.2936 16.2688 16.4726 12.9999H21.9506ZM9.53068 12.9999H14.4692C14.2976 15.7828 13.4146 18.3732 11.9999 20.5915C10.5852 18.3732 9.70229 15.7828 9.53068 12.9999ZM9.53068 10.9999C9.70229 8.21709 10.5852 5.62672 11.9999 3.40841C13.4146 5.62672 14.2976 8.21709 14.4692 10.9999H9.53068Z"
  }));
},
    cc = function cc(_ref975) {
  var _ref975$color = _ref975.color,
      C = _ref975$color === void 0 ? "currentColor" : _ref975$color,
      _ref975$size = _ref975.size,
      e = _ref975$size === void 0 ? 24 : _ref975$size,
      l = _ref975.className,
      i = _objectWithoutProperties(_ref975, _excluded975);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM9.71002 19.6674C8.74743 17.6259 8.15732 15.3742 8.02731 13H4.06189C4.458 16.1765 6.71639 18.7747 9.71002 19.6674ZM10.0307 13C10.1811 15.4388 10.8778 17.7297 12 19.752C13.1222 17.7297 13.8189 15.4388 13.9693 13H10.0307ZM19.9381 13H15.9727C15.8427 15.3742 15.2526 17.6259 14.29 19.6674C17.2836 18.7747 19.542 16.1765 19.9381 13ZM4.06189 11H8.02731C8.15732 8.62577 8.74743 6.37407 9.71002 4.33256C6.71639 5.22533 4.458 7.8235 4.06189 11ZM10.0307 11H13.9693C13.8189 8.56122 13.1222 6.27025 12 4.24799C10.8778 6.27025 10.1811 8.56122 10.0307 11ZM14.29 4.33256C15.2526 6.37407 15.8427 8.62577 15.9727 11H19.9381C19.542 7.8235 17.2836 5.22533 14.29 4.33256Z"
  }));
},
    oc = function oc(_ref976) {
  var _ref976$color = _ref976.color,
      C = _ref976$color === void 0 ? "currentColor" : _ref976$color,
      _ref976$size = _ref976.size,
      e = _ref976$size === void 0 ? 24 : _ref976$size,
      l = _ref976.className,
      i = _objectWithoutProperties(_ref976, _excluded976);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13.0003 21H18.0003V23H6.00032V21H11.0003V19.9506C7.70689 19.6236 4.88351 17.6987 3.31641 14.9622L5.05319 13.9697C6.43208 16.3776 9.02674 18 12.0003 18C16.4186 18 20.0003 14.4182 20.0003 9.99995C20.0003 7.02637 18.378 4.43171 15.9701 3.05282L16.9626 1.31604C19.9724 3.03965 22.0003 6.28297 22.0003 9.99995C22.0003 15.1853 18.0536 19.4489 13.0003 19.9506V21ZM12.0003 17C8.13433 17 5.00032 13.8659 5.00032 9.99995C5.00032 6.13396 8.13433 2.99995 12.0003 2.99995C15.8663 2.99995 19.0003 6.13396 19.0003 9.99995C19.0003 13.8659 15.8663 17 12.0003 17Z"
  }));
},
    ac = function ac(_ref977) {
  var _ref977$color = _ref977.color,
      C = _ref977$color === void 0 ? "currentColor" : _ref977$color,
      _ref977$size = _ref977.size,
      e = _ref977$size === void 0 ? 24 : _ref977$size,
      l = _ref977.className,
      i = _objectWithoutProperties(_ref977, _excluded977);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13.0003 21H18.0003V23H6.00032V21H11.0003V19.9506C7.70689 19.6236 4.88351 17.6987 3.31641 14.9622L5.05319 13.9697C6.43208 16.3776 9.02674 18 12.0003 18C16.4186 18 20.0003 14.4182 20.0003 9.99995C20.0003 7.02637 18.378 4.43171 15.9701 3.05282L16.9626 1.31604C19.9724 3.03965 22.0003 6.28297 22.0003 9.99995C22.0003 15.1853 18.0536 19.4489 13.0003 19.9506V21ZM12.0003 17C8.13433 17 5.00032 13.8659 5.00032 9.99995C5.00032 6.13396 8.13433 2.99995 12.0003 2.99995C15.8663 2.99995 19.0003 6.13396 19.0003 9.99995C19.0003 13.8659 15.8663 17 12.0003 17ZM12.0003 15C14.7617 15 17.0003 12.7614 17.0003 9.99995C17.0003 7.23853 14.7617 4.99995 12.0003 4.99995C9.2389 4.99995 7.00032 7.23853 7.00032 9.99995C7.00032 12.7614 9.2389 15 12.0003 15Z"
  }));
},
    nc = function nc(_ref978) {
  var _ref978$color = _ref978.color,
      C = _ref978$color === void 0 ? "currentColor" : _ref978$color,
      _ref978$size = _ref978.size,
      e = _ref978$size === void 0 ? 24 : _ref978$size,
      l = _ref978.className,
      i = _objectWithoutProperties(_ref978, _excluded978);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11 19V13.8889L3 5V3H21V5L13 13.8889V19H18V21H6V19H11ZM7.49073 7H16.5093L18.3093 5H5.69072L7.49073 7Z"
  }));
},
    mc = function mc(_ref979) {
  var _ref979$color = _ref979.color,
      C = _ref979$color === void 0 ? "currentColor" : _ref979$color,
      _ref979$size = _ref979.size,
      e = _ref979$size === void 0 ? 24 : _ref979$size,
      l = _ref979.className,
      i = _objectWithoutProperties(_ref979, _excluded979);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11 19V13.8889L3 5V3H21V5L13 13.8889V19H18V21H6V19H11ZM7.49073 7H16.5093L18.3093 5H5.69072L7.49073 7ZM9.29072 9L12 12.0103L14.7093 9H9.29072Z"
  }));
},
    wc = function wc(_ref980) {
  var _ref980$color = _ref980.color,
      C = _ref980$color === void 0 ? "currentColor" : _ref980$color,
      _ref980$size = _ref980.size,
      e = _ref980$size === void 0 ? 24 : _ref980$size,
      l = _ref980.className,
      i = _objectWithoutProperties(_ref980, _excluded980);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3.06364 7.50914C4.70909 4.24092 8.09084 2 12 2C14.6954 2 16.959 2.99095 18.6909 4.60455L15.8227 7.47274C14.7864 6.48185 13.4681 5.97727 12 5.97727C9.39542 5.97727 7.19084 7.73637 6.40455 10.1C6.2045 10.7 6.09086 11.3409 6.09086 12C6.09086 12.6591 6.2045 13.3 6.40455 13.9C7.19084 16.2636 9.39542 18.0227 12 18.0227C13.3454 18.0227 14.4909 17.6682 15.3864 17.0682C16.4454 16.3591 17.15 15.3 17.3818 14.05H12V10.1818H21.4181C21.5364 10.8363 21.6 11.5182 21.6 12.2273C21.6 15.2727 20.5091 17.8363 18.6181 19.5773C16.9636 21.1046 14.7 22 12 22C8.09084 22 4.70909 19.7591 3.06364 16.4909C2.38638 15.1409 2 13.6136 2 12C2 10.3864 2.38638 8.85911 3.06364 7.50914Z"
  }));
},
    Lc = function Lc(_ref981) {
  var _ref981$color = _ref981.color,
      C = _ref981$color === void 0 ? "currentColor" : _ref981$color,
      _ref981$size = _ref981.size,
      e = _ref981$size === void 0 ? 24 : _ref981$size,
      l = _ref981.className,
      i = _objectWithoutProperties(_ref981, _excluded981);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 11H20.5329C20.5769 11.3847 20.6 11.7792 20.6 12.1837C20.6 14.9184 19.6204 17.2204 17.9224 18.7837C16.4367 20.1551 14.404 20.9592 11.9796 20.9592C8.46933 20.9592 5.43266 18.947 3.9551 16.0123C3.34695 14.8 3 13.4286 3 11.9796C3 10.5306 3.34695 9.1592 3.9551 7.94698C5.43266 5.01226 8.46933 3 11.9796 3C14.4 3 16.4326 3.88983 17.9877 5.33878L16.5255 6.80101C15.3682 5.68153 13.8028 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C15.5265 19 18.1443 16.3923 18.577 13H12V11Z"
  }));
},
    hc = function hc(_ref982) {
  var _ref982$color = _ref982.color,
      C = _ref982$color === void 0 ? "currentColor" : _ref982$color,
      _ref982$size = _ref982.size,
      e = _ref982$size === void 0 ? 24 : _ref982$size,
      l = _ref982.className,
      i = _objectWithoutProperties(_ref982, _excluded982);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3.60972 1.81396L13.793 12L3.61082 22.1864C3.41776 22.1048 3.24866 21.962 3.13555 21.7667C3.0474 21.6144 3.00098 21.4416 3.00098 21.2656V2.73453C3.00098 2.32109 3.25188 1.96625 3.60972 1.81396ZM14.5 12.707L16.802 15.009L5.86498 21.342L14.5 12.707ZM17.699 9.50896L20.5061 11.1347C20.9841 11.4114 21.1473 12.0232 20.8705 12.5011C20.783 12.6523 20.6574 12.778 20.5061 12.8655L17.698 14.491L15.207 12L17.699 9.50896ZM5.86498 2.65796L16.803 8.98996L14.5 11.293L5.86498 2.65796Z"
  }));
},
    Hc = function Hc(_ref983) {
  var _ref983$color = _ref983.color,
      C = _ref983$color === void 0 ? "currentColor" : _ref983$color,
      _ref983$size = _ref983.size,
      e = _ref983$size === void 0 ? 24 : _ref983$size,
      l = _ref983.className,
      i = _objectWithoutProperties(_ref983, _excluded983);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4.00098 1.73438C4.17692 1.73438 4.34975 1.7808 4.50201 1.86895L20.5061 11.1345C20.9841 11.4112 21.1473 12.023 20.8705 12.501C20.783 12.6522 20.6574 12.7778 20.5061 12.8654L4.50201 22.1309C4.02405 22.4076 3.41226 22.2445 3.13555 21.7665C3.0474 21.6143 3.00098 21.4414 3.00098 21.2655V2.73438C3.00098 2.18209 3.44869 1.73438 4.00098 1.73438ZM12.2931 13.4132L7.79498 17.9124L13.494 14.6134L12.2931 13.4132ZM4.99998 6.11938V17.8784L10.8791 11.9992L4.99998 6.11938ZM15.284 10.4214L13.7071 11.9992L15.285 13.5764L18.009 11.9999L15.284 10.4214ZM7.79398 6.08537L12.2931 10.5852L13.493 9.38437L7.79398 6.08537Z"
  }));
},
    Vc = function Vc(_ref984) {
  var _ref984$color = _ref984.color,
      C = _ref984$color === void 0 ? "currentColor" : _ref984$color,
      _ref984$size = _ref984.size,
      e = _ref984$size === void 0 ? 24 : _ref984$size,
      l = _ref984.className,
      i = _objectWithoutProperties(_ref984, _excluded984);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 19V8H1V6H4V4C4 3.44772 4.44772 3 5 3H19C19.5523 3 20 3.44772 20 4V6H23V8H22V19H23V21H1V19H2ZM13 19V12H11V19H13ZM8 19V12H6V19H8ZM18 19V12H16V19H18ZM6 5V6H18V5H6Z"
  }));
},
    gc = function gc(_ref985) {
  var _ref985$color = _ref985.color,
      C = _ref985$color === void 0 ? "currentColor" : _ref985$color,
      _ref985$size = _ref985.size,
      e = _ref985$size === void 0 ? 24 : _ref985$size,
      l = _ref985.className,
      i = _objectWithoutProperties(_ref985, _excluded985);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 6H23V8H22V19H23V21H1V19H2V8H1V6H4V4C4 3.44772 4.44772 3 5 3H19C19.5523 3 20 3.44772 20 4V6ZM20 8H4V19H7V12H9V19H11V12H13V19H15V12H17V19H20V8ZM6 5V6H18V5H6Z"
  }));
},
    Mc = function Mc(_ref986) {
  var _ref986$color = _ref986.color,
      C = _ref986$color === void 0 ? "currentColor" : _ref986$color,
      _ref986$size = _ref986.size,
      e = _ref986$size === void 0 ? 24 : _ref986$size,
      l = _ref986.className,
      i = _objectWithoutProperties(_ref986, _excluded986);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 16L15 22H9L12 16ZM9.37258 16.2548C7.94863 15.3737 7 13.7976 7 12C7 9.23858 9.23858 7 12 7C14.7614 7 17 9.23858 17 12C17 13.7976 16.0514 15.3737 14.6274 16.2548L13.2718 13.5436C13.7165 13.1768 14 12.6215 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 12.6215 10.2835 13.1768 10.7282 13.5436L9.37258 16.2548ZM7.13153 20.7369C4.07014 19.0274 2 15.7554 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 15.7554 19.9299 19.0274 16.8685 20.7369L15.5246 18.0492C17.6033 16.8354 19 14.5808 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 14.5808 6.39666 16.8354 8.47539 18.0492L7.13153 20.7369Z"
  }));
},
    Zc = function Zc(_ref987) {
  var _ref987$color = _ref987.color,
      C = _ref987$color === void 0 ? "currentColor" : _ref987$color,
      _ref987$size = _ref987.size,
      e = _ref987$size === void 0 ? 24 : _ref987$size,
      l = _ref987.className,
      i = _objectWithoutProperties(_ref987, _excluded987);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7.13173 20.7371C4.07023 19.0275 2 15.7555 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 15.7555 19.9298 19.0275 16.8683 20.7371L15.9724 18.9457C18.3788 17.5664 20 14.9725 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 14.9725 5.62119 17.5664 8.02763 18.9457L7.13173 20.7371ZM8.92427 17.1528C7.17271 16.105 6 14.1894 6 12C6 8.68629 8.68629 6 12 6C15.3137 6 18 8.68629 18 12C18 14.1894 16.8273 16.105 15.0757 17.1528L14.1772 15.3561C15.2744 14.6429 16 13.4062 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 13.4062 8.72559 14.6429 9.82279 15.3561L8.92427 17.1528ZM12 16L15 22H9L12 16Z"
  }));
},
    xc = function xc(_ref988) {
  var _ref988$color = _ref988.color,
      C = _ref988$color === void 0 ? "currentColor" : _ref988$color,
      _ref988$size = _ref988.size,
      e = _ref988$size === void 0 ? 24 : _ref988$size,
      l = _ref988.className,
      i = _objectWithoutProperties(_ref988, _excluded988);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM8.12602 11H4.06189C4.02104 11.3276 4 11.6613 4 12C4 12.3387 4.02104 12.6724 4.06189 13H8.12602C8.04375 12.6804 8 12.3453 8 12C8 11.6547 8.04375 11.3196 8.12602 11ZM15.874 11C15.9562 11.3196 16 11.6547 16 12C16 12.3453 15.9562 12.6804 15.874 13H19.9381C19.979 12.6724 20 12.3387 20 12C20 11.6613 19.979 11.3276 19.9381 11H15.874ZM12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z"
  }));
},
    vc = function vc(_ref989) {
  var _ref989$color = _ref989.color,
      C = _ref989$color === void 0 ? "currentColor" : _ref989$color,
      _ref989$size = _ref989.size,
      e = _ref989$size === void 0 ? 24 : _ref989$size,
      l = _ref989.className,
      i = _objectWithoutProperties(_ref989, _excluded989);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2.04932 13H4.06184C4.55393 16.9463 7.92032 20 11.9999 20C16.0796 20 19.4459 16.9463 19.938 13H21.9506C21.4488 18.0533 17.1853 22 11.9999 22C6.81459 22 2.55104 18.0533 2.04932 13ZM2.04932 11C2.55104 5.94668 6.81459 2 11.9999 2C17.1853 2 21.4488 5.94668 21.9506 11H19.938C19.4459 7.05369 16.0796 4 11.9999 4C7.92032 4 4.55393 7.05369 4.06184 11H2.04932ZM11.9999 14C10.8954 14 9.99994 13.1046 9.99994 12C9.99994 10.8954 10.8954 10 11.9999 10C13.1045 10 13.9999 10.8954 13.9999 12C13.9999 13.1046 13.1045 14 11.9999 14Z"
  }));
},
    dc = function dc(_ref990) {
  var _ref990$color = _ref990.color,
      C = _ref990$color === void 0 ? "currentColor" : _ref990$color,
      _ref990$size = _ref990.size,
      e = _ref990$size === void 0 ? 24 : _ref990$size,
      l = _ref990.className,
      i = _objectWithoutProperties(_ref990, _excluded990);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14 10V14H10V10H14ZM16 10H21V14H16V10ZM14 21H10V16H14V21ZM16 21V16H21V20C21 20.5523 20.5523 21 20 21H16ZM14 3V8H10V3H14ZM16 3H20C20.5523 3 21 3.44772 21 4V8H16V3ZM8 10V14H3V10H8ZM8 21H4C3.44772 21 3 20.5523 3 20V16H8V21ZM8 3V8H3V4C3 3.44772 3.44772 3 4 3H8Z"
  }));
},
    pc = function pc(_ref991) {
  var _ref991$color = _ref991.color,
      C = _ref991$color === void 0 ? "currentColor" : _ref991$color,
      _ref991$size = _ref991.size,
      e = _ref991$size === void 0 ? 24 : _ref991$size,
      l = _ref991.className,
      i = _objectWithoutProperties(_ref991, _excluded991);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14 10H10V14H14V10ZM16 10V14H19V10H16ZM14 19V16H10V19H14ZM16 19H19V16H16V19ZM14 5H10V8H14V5ZM16 5V8H19V5H16ZM8 10H5V14H8V10ZM8 19V16H5V19H8ZM8 5H5V8H8V5ZM4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3Z"
  }));
},
    Ec = function Ec(_ref992) {
  var _ref992$color = _ref992.color,
      C = _ref992$color === void 0 ? "currentColor" : _ref992$color,
      _ref992$size = _ref992.size,
      e = _ref992$size === void 0 ? 24 : _ref992$size,
      l = _ref992.className,
      i = _objectWithoutProperties(_ref992, _excluded992);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10 19.748V16.4C10 15.1174 10.9948 14.1076 12.4667 13.5321C11.5431 13.188 10.5435 13 9.5 13C7.61013 13 5.86432 13.6168 4.45286 14.66C5.33199 17.1544 7.41273 19.082 10 19.748ZM18.8794 16.0859C18.4862 15.5526 17.1708 15 15.5 15C13.4939 15 12 15.7967 12 16.4V20C14.9255 20 17.4843 18.4296 18.8794 16.0859ZM9.55 11.5C10.7926 11.5 11.8 10.4926 11.8 9.25C11.8 8.00736 10.7926 7 9.55 7C8.30736 7 7.3 8.00736 7.3 9.25C7.3 10.4926 8.30736 11.5 9.55 11.5ZM15.5 12.5C16.6046 12.5 17.5 11.6046 17.5 10.5C17.5 9.39543 16.6046 8.5 15.5 8.5C14.3954 8.5 13.5 9.39543 13.5 10.5C13.5 11.6046 14.3954 12.5 15.5 12.5ZM12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22Z"
  }));
},
    Nc = function Nc(_ref993) {
  var _ref993$color = _ref993.color,
      C = _ref993$color === void 0 ? "currentColor" : _ref993$color,
      _ref993$size = _ref993.size,
      e = _ref993$size === void 0 ? 24 : _ref993$size,
      l = _ref993.className,
      i = _objectWithoutProperties(_ref993, _excluded993);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9.55 11.5C8.30736 11.5 7.3 10.4926 7.3 9.25C7.3 8.00736 8.30736 7 9.55 7C10.7926 7 11.8 8.00736 11.8 9.25C11.8 10.4926 10.7926 11.5 9.55 11.5ZM10 19.748V16.4C10 15.9116 10.1442 15.4627 10.4041 15.0624C10.1087 15.0213 9.80681 15 9.5 15C7.93201 15 6.49369 15.5552 5.37091 16.4797C6.44909 18.0721 8.08593 19.2553 10 19.748ZM4.45286 14.66C5.86432 13.6168 7.61013 13 9.5 13C10.5435 13 11.5431 13.188 12.4667 13.5321C13.3447 13.1888 14.3924 13 15.5 13C17.1597 13 18.6849 13.4239 19.706 14.1563C19.8976 13.4703 20 12.7471 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 12.9325 4.15956 13.8278 4.45286 14.66ZM18.8794 16.0859C18.4862 15.5526 17.1708 15 15.5 15C13.4939 15 12 15.7967 12 16.4V20C14.9255 20 17.4843 18.4296 18.8794 16.0859ZM12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM15.5 12.5C14.3954 12.5 13.5 11.6046 13.5 10.5C13.5 9.39543 14.3954 8.5 15.5 8.5C16.6046 8.5 17.5 9.39543 17.5 10.5C17.5 11.6046 16.6046 12.5 15.5 12.5Z"
  }));
},
    uc = function uc(_ref994) {
  var _ref994$color = _ref994.color,
      C = _ref994$color === void 0 ? "currentColor" : _ref994$color,
      _ref994$size = _ref994.size,
      e = _ref994$size === void 0 ? 24 : _ref994$size,
      l = _ref994.className,
      i = _objectWithoutProperties(_ref994, _excluded994);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 22C2 17.5817 5.58172 14 10 14C14.4183 14 18 17.5817 18 22H2ZM10 13C6.685 13 4 10.315 4 7C4 3.685 6.685 1 10 1C13.315 1 16 3.685 16 7C16 10.315 13.315 13 10 13ZM17.3628 15.2332C20.4482 16.0217 22.7679 18.7235 22.9836 22H20C20 19.3902 19.0002 17.0139 17.3628 15.2332ZM15.3401 12.9569C16.9728 11.4922 18 9.36607 18 7C18 5.58266 17.6314 4.25141 16.9849 3.09687C19.2753 3.55397 21 5.57465 21 8C21 10.7625 18.7625 13 16 13C15.7763 13 15.556 12.9853 15.3401 12.9569Z"
  }));
},
    Bc = function Bc(_ref995) {
  var _ref995$color = _ref995.color,
      C = _ref995$color === void 0 ? "currentColor" : _ref995$color,
      _ref995$size = _ref995.size,
      e = _ref995$size === void 0 ? 24 : _ref995$size,
      l = _ref995.className,
      i = _objectWithoutProperties(_ref995, _excluded995);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 22C2 17.5817 5.58172 14 10 14C14.4183 14 18 17.5817 18 22H16C16 18.6863 13.3137 16 10 16C6.68629 16 4 18.6863 4 22H2ZM10 13C6.685 13 4 10.315 4 7C4 3.685 6.685 1 10 1C13.315 1 16 3.685 16 7C16 10.315 13.315 13 10 13ZM10 11C12.21 11 14 9.21 14 7C14 4.79 12.21 3 10 3C7.79 3 6 4.79 6 7C6 9.21 7.79 11 10 11ZM18.2837 14.7028C21.0644 15.9561 23 18.752 23 22H21C21 19.564 19.5483 17.4671 17.4628 16.5271L18.2837 14.7028ZM17.5962 3.41321C19.5944 4.23703 21 6.20361 21 8.5C21 11.3702 18.8042 13.7252 16 13.9776V11.9646C17.6967 11.7222 19 10.264 19 8.5C19 7.11935 18.2016 5.92603 17.041 5.35635L17.5962 3.41321Z"
  }));
},
    fc = function fc(_ref996) {
  var _ref996$color = _ref996.color,
      C = _ref996$color === void 0 ? "currentColor" : _ref996$color,
      _ref996$size = _ref996.size,
      e = _ref996$size === void 0 ? 24 : _ref996$size,
      l = _ref996.className,
      i = _objectWithoutProperties(_ref996, _excluded996);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13 8V16C13 17.6569 11.6569 19 10 19H7.82929C7.41746 20.1652 6.30622 21 5 21C3.34315 21 2 19.6569 2 18C2 16.3431 3.34315 15 5 15C6.30622 15 7.41746 15.8348 7.82929 17H10C10.5523 17 11 16.5523 11 16V8C11 6.34315 12.3431 5 14 5H17V2L22 6L17 10V7H14C13.4477 7 13 7.44772 13 8Z"
  }));
},
    Rc = function Rc(_ref997) {
  var _ref997$color = _ref997.color,
      C = _ref997$color === void 0 ? "currentColor" : _ref997$color,
      _ref997$size = _ref997.size,
      e = _ref997$size === void 0 ? 24 : _ref997$size,
      l = _ref997.className,
      i = _objectWithoutProperties(_ref997, _excluded997);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13 8V16C13 17.6569 11.6569 19 10 19H7.82929C7.41746 20.1652 6.30622 21 5 21C3.34315 21 2 19.6569 2 18C2 16.3431 3.34315 15 5 15C6.30622 15 7.41746 15.8348 7.82929 17H10C10.5523 17 11 16.5523 11 16V8C11 6.34315 12.3431 5 14 5H17V2L22 6L17 10V7H14C13.4477 7 13 7.44772 13 8ZM5 19C5.55228 19 6 18.5523 6 18C6 17.4477 5.55228 17 5 17C4.44772 17 4 17.4477 4 18C4 18.5523 4.44772 19 5 19Z"
  }));
},
    zc = function zc(_ref998) {
  var _ref998$color = _ref998.color,
      C = _ref998$color === void 0 ? "currentColor" : _ref998$color,
      _ref998$size = _ref998.size,
      e = _ref998$size === void 0 ? 24 : _ref998$size,
      l = _ref998.className,
      i = _objectWithoutProperties(_ref998, _excluded998);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13 20H11V13H4V20H2V4H4V11H11V4H13V20ZM21.0005 8V20H19.0005L19 10.204L17 10.74V8.67L19.5005 8H21.0005Z"
  }));
},
    Fc = function Fc(_ref999) {
  var _ref999$color = _ref999.color,
      C = _ref999$color === void 0 ? "currentColor" : _ref999$color,
      _ref999$size = _ref999.size,
      e = _ref999$size === void 0 ? 24 : _ref999$size,
      l = _ref999.className,
      i = _objectWithoutProperties(_ref999, _excluded999);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 4V11H11V4H13V20H11V13H4V20H2V4H4ZM18.5 8C20.5711 8 22.25 9.67893 22.25 11.75C22.25 12.6074 21.9623 13.3976 21.4781 14.0292L21.3302 14.2102L18.0343 18H22V20H15L14.9993 18.444L19.8207 12.8981C20.0881 12.5908 20.25 12.1893 20.25 11.75C20.25 10.7835 19.4665 10 18.5 10C17.5818 10 16.8288 10.7071 16.7558 11.6065L16.75 11.75H14.75C14.75 9.67893 16.4289 8 18.5 8Z"
  }));
},
    Sc = function Sc(_ref1000) {
  var _ref1000$color = _ref1000.color,
      C = _ref1000$color === void 0 ? "currentColor" : _ref1000$color,
      _ref1000$size = _ref1000.size,
      e = _ref1000$size === void 0 ? 24 : _ref1000$size,
      l = _ref1000.className,
      i = _objectWithoutProperties(_ref1000, _excluded1000);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22 8L21.9984 10L19.4934 12.883C21.0823 13.3184 22.25 14.7728 22.25 16.5C22.25 18.5711 20.5711 20.25 18.5 20.25C16.674 20.25 15.1528 18.9449 14.8184 17.2166L16.7821 16.8352C16.9384 17.6413 17.6481 18.25 18.5 18.25C19.4665 18.25 20.25 17.4665 20.25 16.5C20.25 15.5335 19.4665 14.75 18.5 14.75C18.214 14.75 17.944 14.8186 17.7056 14.9403L16.3992 13.3932L19.3484 10H15V8H22ZM4 4V11H11V4H13V20H11V13H4V20H2V4H4Z"
  }));
},
    Ac = function Ac(_ref1001) {
  var _ref1001$color = _ref1001.color,
      C = _ref1001$color === void 0 ? "currentColor" : _ref1001$color,
      _ref1001$size = _ref1001.size,
      e = _ref1001$size === void 0 ? 24 : _ref1001$size,
      l = _ref1001.className,
      i = _objectWithoutProperties(_ref1001, _excluded1001);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13 20H11V13H4V20H2V4H4V11H11V4H13V20ZM22 8V16H23.5V18H22V20H20V18H14.5V16.66L19.5 8H22ZM20 11.133L17.19 16H20V11.133Z"
  }));
},
    kc = function kc(_ref1002) {
  var _ref1002$color = _ref1002.color,
      C = _ref1002$color === void 0 ? "currentColor" : _ref1002$color,
      _ref1002$size = _ref1002.size,
      e = _ref1002$size === void 0 ? 24 : _ref1002$size,
      l = _ref1002.className,
      i = _objectWithoutProperties(_ref1002, _excluded1002);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22 8V10H17.6769L17.2126 12.6358C17.5435 12.5472 17.8912 12.5 18.25 12.5C20.4591 12.5 22.25 14.2909 22.25 16.5C22.25 18.7091 20.4591 20.5 18.25 20.5C16.4233 20.5 14.8827 19.2756 14.4039 17.6027L16.3271 17.0519C16.5667 17.8881 17.3369 18.5 18.25 18.5C19.3546 18.5 20.25 17.6046 20.25 16.5C20.25 15.3954 19.3546 14.5 18.25 14.5C17.6194 14.5 17.057 14.7918 16.6904 15.2478L14.8803 14.3439L16 8H22ZM4 4V11H11V4H13V20H11V13H4V20H2V4H4Z"
  }));
},
    Pc = function Pc(_ref1003) {
  var _ref1003$color = _ref1003.color,
      C = _ref1003$color === void 0 ? "currentColor" : _ref1003$color,
      _ref1003$size = _ref1003.size,
      e = _ref1003$size === void 0 ? 24 : _ref1003$size,
      l = _ref1003.className,
      i = _objectWithoutProperties(_ref1003, _excluded1003);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21.097 8L18.499 12.5C20.7091 12.5 22.5 14.2909 22.5 16.5C22.5 18.7091 20.7091 20.5 18.5 20.5C16.2909 20.5 14.5 18.7091 14.5 16.5C14.5 15.7636 14.699 15.0737 15.0461 14.4811L18.788 8H21.097ZM4 4V11H11V4H13V20H11V13H4V20H2V4H4ZM18.5 14.5C17.3954 14.5 16.5 15.3954 16.5 16.5C16.5 17.6046 17.3954 18.5 18.5 18.5C19.6046 18.5 20.5 17.6046 20.5 16.5C20.5 15.3954 19.6046 14.5 18.5 14.5Z"
  }));
},
    Dc = function Dc(_ref1004) {
  var _ref1004$color = _ref1004.color,
      C = _ref1004$color === void 0 ? "currentColor" : _ref1004$color,
      _ref1004$size = _ref1004.size,
      e = _ref1004$size === void 0 ? 24 : _ref1004$size,
      l = _ref1004.className,
      i = _objectWithoutProperties(_ref1004, _excluded1004);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18.9948 17.7944C18.8878 15.6808 17.1402 14 15 14C14.622 14 14.2562 14.0524 13.9096 14.1504C13.5201 12.3494 11.9176 11 10 11C7.79086 11 6 12.7909 6 15C6 16.0794 6.42752 17.0589 7.12246 17.7784C3.61004 16.9337 1 13.7716 1 10C1 5.58172 4.58172 2 9 2C12.3949 2 15.2959 4.11466 16.4576 7.09864C16.7951 7.0339 17.1436 7 17.5 7C20.5376 7 23 9.46243 23 12.5C23 15.0194 21.306 17.1432 18.9948 17.7944ZM10 17C8.89543 17 8 16.1046 8 15C8 13.8954 8.89543 13 10 13C11.1046 13 12 13.8954 12 15C12 16.1046 11.1046 17 10 17ZM15 20C13.8954 20 13 19.1046 13 18C13 16.8954 13.8954 16 15 16C16.1046 16 17 16.8954 17 18C17 19.1046 16.1046 20 15 20ZM10 23C8.89543 23 8 22.1046 8 21C8 19.8954 8.89543 19 10 19C11.1046 19 12 19.8954 12 21C12 22.1046 11.1046 23 10 23Z"
  }));
},
    yc = function yc(_ref1005) {
  var _ref1005$color = _ref1005.color,
      C = _ref1005$color === void 0 ? "currentColor" : _ref1005$color,
      _ref1005$size = _ref1005.size,
      e = _ref1005$size === void 0 ? 24 : _ref1005$size,
      l = _ref1005.className,
      i = _objectWithoutProperties(_ref1005, _excluded1005);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6 17.4185C3.06817 16.2317 1 13.3574 1 10C1 5.58172 4.58172 2 9 2C12.3949 2 15.2959 4.11466 16.4576 7.09864C16.7951 7.0339 17.1436 7 17.5 7C20.5376 7 23 9.46243 23 12.5C23 15.0176 21.3085 17.14 19 17.793V15.6632C20.1825 15.1015 21 13.8962 21 12.5C21 10.567 19.433 9 17.5 9C16.5205 9 15.6351 9.40232 14.9998 10.0507C14.9999 10.0338 15 10.0169 15 10C15 6.68629 12.3137 4 9 4C5.68629 4 3 6.68629 3 10C3 12.2208 4.2066 14.1599 6 15.1973V17.4185ZM10 17C8.89543 17 8 16.1046 8 15C8 13.8954 8.89543 13 10 13C11.1046 13 12 13.8954 12 15C12 16.1046 11.1046 17 10 17ZM15 20C13.8954 20 13 19.1046 13 18C13 16.8954 13.8954 16 15 16C16.1046 16 17 16.8954 17 18C17 19.1046 16.1046 20 15 20ZM10 23C8.89543 23 8 22.1046 8 21C8 19.8954 8.89543 19 10 19C11.1046 19 12 19.8954 12 21C12 22.1046 11.1046 23 10 23Z"
  }));
},
    bc = function bc(_ref1006) {
  var _ref1006$color = _ref1006.color,
      C = _ref1006$color === void 0 ? "currentColor" : _ref1006$color,
      _ref1006$size = _ref1006.size,
      e = _ref1006$size === void 0 ? 24 : _ref1006$size,
      l = _ref1006.className,
      i = _objectWithoutProperties(_ref1006, _excluded1006);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17 8V2H20C20.5523 2 21 2.44772 21 3V7C21 7.55228 20.5523 8 20 8H17ZM15 22C15 22.5523 14.5523 23 14 23H10C9.44772 23 9 22.5523 9 22V8H2.5V6.07437C2.5 5.7187 2.68891 5.3898 2.99613 5.21059L8.5 2H15V22Z"
  }));
},
    Tc = function Tc(_ref1007) {
  var _ref1007$color = _ref1007.color,
      C = _ref1007$color === void 0 ? "currentColor" : _ref1007$color,
      _ref1007$size = _ref1007.size,
      e = _ref1007$size === void 0 ? 24 : _ref1007$size,
      l = _ref1007.className,
      i = _objectWithoutProperties(_ref1007, _excluded1007);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 2C20.5523 2 21 2.44772 21 3V8C21 8.55228 20.5523 9 20 9H15V22C15 22.5523 14.5523 23 14 23H10C9.44772 23 9 22.5523 9 22V9H3.5C2.94772 9 2.5 8.55228 2.5 8V5.61803C2.5 5.23926 2.714 4.893 3.05279 4.72361L8.5 2H20ZM15 4H8.97214L4.5 6.23607V7H11V21H13V7H15V4ZM19 4H17V7H19V4Z"
  }));
},
    Uc = function Uc(_ref1008) {
  var _ref1008$color = _ref1008.color,
      C = _ref1008$color === void 0 ? "currentColor" : _ref1008$color,
      _ref1008$size = _ref1008.size,
      e = _ref1008$size === void 0 ? 24 : _ref1008$size,
      l = _ref1008.className,
      i = _objectWithoutProperties(_ref1008, _excluded1008);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9.3349 11.5023L11.5049 11.5028C13.9902 11.5028 16.0049 13.5175 16.0049 16.0028H9.00388L9.00488 17.0028L17.0049 17.002V16.0028C17.0049 14.9204 16.6867 13.8997 16.1188 13.002L19.0049 13.0028C20.9972 13.0028 22.7173 14.1681 23.521 15.8542C21.1562 18.9748 17.3268 21.0028 13.0049 21.0028C10.2436 21.0028 7.90445 20.4122 6.00456 19.378L6.00592 10.0738C7.25147 10.2522 8.39122 10.7585 9.3349 11.5023ZM5.00488 19.0028C5.00488 19.5551 4.55717 20.0028 4.00488 20.0028H2.00488C1.4526 20.0028 1.00488 19.5551 1.00488 19.0028V10.0028C1.00488 9.45052 1.4526 9.00281 2.00488 9.00281H4.00488C4.55717 9.00281 5.00488 9.45052 5.00488 10.0028V19.0028ZM18.0049 5.00281C19.6617 5.00281 21.0049 6.34595 21.0049 8.00281C21.0049 9.65966 19.6617 11.0028 18.0049 11.0028C16.348 11.0028 15.0049 9.65966 15.0049 8.00281C15.0049 6.34595 16.348 5.00281 18.0049 5.00281ZM11.0049 2.00281C12.6617 2.00281 14.0049 3.34595 14.0049 5.00281C14.0049 6.65966 12.6617 8.00281 11.0049 8.00281C9.34803 8.00281 8.00488 6.65966 8.00488 5.00281C8.00488 3.34595 9.34803 2.00281 11.0049 2.00281Z"
  }));
},
    Gc = function Gc(_ref1009) {
  var _ref1009$color = _ref1009.color,
      C = _ref1009$color === void 0 ? "currentColor" : _ref1009$color,
      _ref1009$size = _ref1009.size,
      e = _ref1009$size === void 0 ? 24 : _ref1009$size,
      l = _ref1009.className,
      i = _objectWithoutProperties(_ref1009, _excluded1009);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5.00488 9.00281C5.55717 9.00281 6.00488 9.45052 6.00488 10.0028C7.63965 10.0028 9.14352 10.5632 10.3349 11.5023L12.5049 11.5028C13.8375 11.5028 15.0348 12.0821 15.8588 13.0025L19.0049 13.0028C20.9972 13.0028 22.7173 14.1681 23.521 15.8542C21.1562 18.9748 17.3268 21.0028 13.0049 21.0028C10.2142 21.0028 7.85466 20.3996 5.944 19.3449C5.80557 19.7284 5.43727 20.0028 5.00488 20.0028H2.00488C1.4526 20.0028 1.00488 19.5551 1.00488 19.0028V10.0028C1.00488 9.45052 1.4526 9.00281 2.00488 9.00281H5.00488ZM6.00589 12.0028L6.00488 17.0248L6.05024 17.0573C7.84406 18.3177 10.183 19.0028 13.0049 19.0028C16.0089 19.0028 18.8035 17.8472 20.84 15.8734L20.9729 15.7398L20.8537 15.6394C20.3897 15.2764 19.8205 15.0512 19.2099 15.0097L19.0049 15.0028L16.8934 15.0028C16.9664 15.3244 17.0049 15.6591 17.0049 16.0028V17.0028H8.00488V15.0028L14.7949 15.0018L14.7605 14.9233C14.38 14.1297 13.593 13.5681 12.6693 13.5081L12.5049 13.5028L9.57547 13.5027C8.66823 12.5773 7.40412 12.0031 6.00589 12.0028ZM4.00488 11.0028H3.00488V18.0028H4.00488V11.0028ZM18.0049 5.00281C19.6617 5.00281 21.0049 6.34595 21.0049 8.00281C21.0049 9.65966 19.6617 11.0028 18.0049 11.0028C16.348 11.0028 15.0049 9.65966 15.0049 8.00281C15.0049 6.34595 16.348 5.00281 18.0049 5.00281ZM18.0049 7.00281C17.4526 7.00281 17.0049 7.45052 17.0049 8.00281C17.0049 8.55509 17.4526 9.00281 18.0049 9.00281C18.5572 9.00281 19.0049 8.55509 19.0049 8.00281C19.0049 7.45052 18.5572 7.00281 18.0049 7.00281ZM11.0049 2.00281C12.6617 2.00281 14.0049 3.34595 14.0049 5.00281C14.0049 6.65966 12.6617 8.00281 11.0049 8.00281C9.34803 8.00281 8.00488 6.65966 8.00488 5.00281C8.00488 3.34595 9.34803 2.00281 11.0049 2.00281ZM11.0049 4.00281C10.4526 4.00281 10.0049 4.45052 10.0049 5.00281C10.0049 5.55509 10.4526 6.00281 11.0049 6.00281C11.5572 6.00281 12.0049 5.55509 12.0049 5.00281C12.0049 4.45052 11.5572 4.00281 11.0049 4.00281Z"
  }));
},
    Ic = function Ic(_ref1010) {
  var _ref1010$color = _ref1010.color,
      C = _ref1010$color === void 0 ? "currentColor" : _ref1010$color,
      _ref1010$size = _ref1010.size,
      e = _ref1010$size === void 0 ? 24 : _ref1010$size,
      l = _ref1010.className,
      i = _objectWithoutProperties(_ref1010, _excluded1010);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9.3349 11.5022L11.5049 11.5027C13.9902 11.5027 16.0049 13.5174 16.0049 16.0027L9.00388 16.0018L9.00488 17.0027L17.0049 17.0019V16.0027C17.0049 14.9202 16.6867 13.8996 16.1188 13.0019L19.0049 13.0027C20.9972 13.0027 22.7173 14.1679 23.521 15.8541C21.1562 18.9747 17.3268 21.0027 13.0049 21.0027C10.2436 21.0027 7.90437 20.4121 6.00447 19.3779L6.00592 10.0737C7.25147 10.2521 8.39122 10.7583 9.3349 11.5022ZM4.00488 9.00268C4.51772 9.00268 4.94039 9.38872 4.99816 9.88606L5.00488 10.0018V19.0027C5.00488 19.555 4.55717 20.0027 4.00488 20.0027H2.00488C1.4526 20.0027 1.00488 19.555 1.00488 19.0027V10.0027C1.00488 9.45039 1.4526 9.00268 2.00488 9.00268H4.00488ZM13.6513 3.57806L14.0046 3.93183L14.3584 3.57806C15.3347 2.60175 16.9177 2.60175 17.894 3.57806C18.8703 4.55437 18.8703 6.13728 17.894 7.11359L14.0049 11.0027L10.1158 7.11359C9.13948 6.13728 9.13948 4.55437 10.1158 3.57806C11.0921 2.60175 12.675 2.60175 13.6513 3.57806Z"
  }));
},
    Wc = function Wc(_ref1011) {
  var _ref1011$color = _ref1011.color,
      C = _ref1011$color === void 0 ? "currentColor" : _ref1011$color,
      _ref1011$size = _ref1011.size,
      e = _ref1011$size === void 0 ? 24 : _ref1011$size,
      l = _ref1011.className,
      i = _objectWithoutProperties(_ref1011, _excluded1011);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5.00488 9.00268C5.55717 9.00268 6.00488 9.45039 6.00488 10.0027C7.63965 10.0027 9.14352 10.5631 10.3349 11.5022L12.5049 11.5027C13.837 11.5027 15.0339 12.0815 15.8579 13.0014L19.0049 13.0027C20.9972 13.0027 22.7173 14.1679 23.521 15.8541C21.1562 18.9747 17.3268 21.0027 13.0049 21.0027C10.2142 21.0027 7.85466 20.3994 5.944 19.3447C5.80557 19.7283 5.43727 20.0027 5.00488 20.0027H2.00488C1.4526 20.0027 1.00488 19.555 1.00488 19.0027V10.0027C1.00488 9.45039 1.4526 9.00268 2.00488 9.00268H5.00488ZM6.00589 12.0027L6.00488 17.0238L6.05024 17.0572C7.84406 18.3176 10.183 19.0027 13.0049 19.0027C16.0089 19.0027 18.8035 17.847 20.84 15.8732L20.9729 15.7397L20.8537 15.6393C20.3897 15.2763 19.8205 15.051 19.2099 15.0096L19.0049 15.0027L16.8932 15.0017C16.9663 15.3236 17.0049 15.6586 17.0049 16.0027V17.0027H8.00488V15.0027L14.7949 15.0017L14.7605 14.9232C14.38 14.1296 13.593 13.568 12.6693 13.508L12.5049 13.5027L9.57547 13.5025C8.66823 12.5772 7.40412 12.003 6.00589 12.0027ZM4.00488 11.0027H3.00488V18.0027H4.00488V11.0027ZM13.6513 3.57806L14.0046 3.93183L14.3584 3.57806C15.3347 2.60175 16.9177 2.60175 17.894 3.57806C18.8703 4.55437 18.8703 6.13728 17.894 7.11359L14.0049 11.0027L10.1158 7.11359C9.13948 6.13728 9.13948 4.55437 10.1158 3.57806C11.0921 2.60175 12.675 2.60175 13.6513 3.57806ZM11.53 4.99227C11.3564 5.16584 11.3372 5.43526 11.4714 5.62938L11.5289 5.69831L14.0039 8.17368L16.4798 5.69938C16.6533 5.52581 16.6726 5.25639 16.5376 5.06152L16.4798 4.99227C16.3062 4.81871 16.0368 4.79942 15.8417 4.93457L15.7724 4.99249L14.0033 6.76111L12.236 4.9912L12.1679 4.93442C11.973 4.79942 11.7036 4.81871 11.53 4.99227Z"
  }));
},
    Oc = function Oc(_ref1012) {
  var _ref1012$color = _ref1012.color,
      C = _ref1012$color === void 0 ? "currentColor" : _ref1012$color,
      _ref1012$size = _ref1012.size,
      e = _ref1012$size === void 0 ? 24 : _ref1012$size,
      l = _ref1012.className,
      i = _objectWithoutProperties(_ref1012, _excluded1012);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17.0002 2V4L13.0002 3.999V6H16.0002V8C18.2093 8 20.0002 9.79086 20.0002 12V20C20.0002 21.1046 19.1048 22 18.0002 22H6.0002C4.89563 22 4.0002 21.1046 4.0002 20V12C4.0002 9.79086 5.79106 8 8.0002 8V6H11.0002V3.999L7.5002 4C6.8702 4 6.1302 4.49 5.3002 5.6L3.7002 4.4C4.8702 2.84 6.1302 2 7.5002 2H17.0002ZM13.0002 12H11.0002V14H9.0002V16H10.9992L11.0002 18H13.0002L12.9992 16H15.0002V14H13.0002V12Z"
  }));
},
    Kc = function Kc(_ref1013) {
  var _ref1013$color = _ref1013.color,
      C = _ref1013$color === void 0 ? "currentColor" : _ref1013$color,
      _ref1013$size = _ref1013.size,
      e = _ref1013$size === void 0 ? 24 : _ref1013$size,
      l = _ref1013.className,
      i = _objectWithoutProperties(_ref1013, _excluded1013);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17.0002 2V4L13.0002 3.999V6H16.0002V8C18.2093 8 20.0002 9.79086 20.0002 12V20C20.0002 21.1046 19.1048 22 18.0002 22H6.0002C4.89563 22 4.0002 21.1046 4.0002 20V12C4.0002 9.79086 5.79106 8 8.0002 8V6H11.0002V3.999L7.5002 4C6.8702 4 6.1302 4.49 5.3002 5.6L3.7002 4.4C4.8702 2.84 6.1302 2 7.5002 2H17.0002ZM16.0002 10H8.0002C6.89563 10 6.0002 10.8954 6.0002 12V20H18.0002V12C18.0002 10.8954 17.1048 10 16.0002 10ZM13.0002 12V14H15.0002V16H12.9992L13.0002 18H11.0002L10.9992 16H9.0002V14H11.0002V12H13.0002Z"
  }));
},
    Qc = function Qc(_ref1014) {
  var _ref1014$color = _ref1014.color,
      C = _ref1014$color === void 0 ? "currentColor" : _ref1014$color,
      _ref1014$size = _ref1014.size,
      e = _ref1014$size === void 0 ? 24 : _ref1014$size,
      l = _ref1014.className,
      i = _objectWithoutProperties(_ref1014, _excluded1014);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.0002 2C15.8662 2 19.0002 5.13401 19.0002 9H20.0742C20.5967 9 21.0311 9.40231 21.0712 9.9233L21.9174 20.9233C21.9597 21.474 21.5477 21.9547 20.997 21.9971L20.9203 22H3.08008C2.52779 22 2.08008 21.5523 2.08008 21L2.08302 20.9233L2.92918 9.9233C2.96925 9.40231 3.4037 9 3.92623 9H5.0002C5.0002 5.13401 8.13421 2 12.0002 2ZM14.0002 13H10.0002V15H14.0002V13ZM12.0002 4C9.31145 4 7.11838 6.12231 7.00482 8.78311L7.0002 9H17.0002C17.0002 6.31124 14.8779 4.11818 12.2171 4.00462L12.0002 4Z"
  }));
},
    qc = function qc(_ref1015) {
  var _ref1015$color = _ref1015.color,
      C = _ref1015$color === void 0 ? "currentColor" : _ref1015$color,
      _ref1015$size = _ref1015.size,
      e = _ref1015$size === void 0 ? 24 : _ref1015$size,
      l = _ref1015.className,
      i = _objectWithoutProperties(_ref1015, _excluded1015);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.0002 2C15.8662 2 19.0002 5.13401 19.0002 9H20.0742C20.5967 9 21.0311 9.40231 21.0712 9.9233L21.9174 20.9233C21.9597 21.474 21.5477 21.9547 20.997 21.9971L20.9203 22H3.08008C2.52779 22 2.08008 21.5523 2.08008 21L2.08302 20.9233L2.92918 9.9233C2.96925 9.40231 3.4037 9 3.92623 9H5.0002C5.0002 5.13401 8.13421 2 12.0002 2ZM19.1472 11H4.8522L4.1592 20H19.8402L19.1472 11ZM14.0002 13V15H10.0002V13H14.0002ZM12.0002 4C9.31145 4 7.11838 6.12231 7.00482 8.78311L7.0002 9H17.0002C17.0002 6.31124 14.8779 4.11818 12.2171 4.00462L12.0002 4Z"
  }));
},
    jc = function jc(_ref1016) {
  var _ref1016$color = _ref1016.color,
      C = _ref1016$color === void 0 ? "currentColor" : _ref1016$color,
      _ref1016$size = _ref1016.size,
      e = _ref1016$size === void 0 ? 24 : _ref1016$size,
      l = _ref1016.className,
      i = _objectWithoutProperties(_ref1016, _excluded1016);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 3V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V3C3 2.44772 3.44772 2 4 2H20C20.5523 2 21 2.44772 21 3ZM5 16V20H19V16H5ZM15 17H17V19H15V17Z"
  }));
},
    Xc = function Xc(_ref1017) {
  var _ref1017$color = _ref1017.color,
      C = _ref1017$color === void 0 ? "currentColor" : _ref1017$color,
      _ref1017$size = _ref1017.size,
      e = _ref1017$size === void 0 ? 24 : _ref1017$size,
      l = _ref1017.className,
      i = _objectWithoutProperties(_ref1017, _excluded1017);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5 14H19V4H5V14ZM5 16V20H19V16H5ZM4 2H20C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V3C3 2.44772 3.44772 2 4 2ZM15 17H17V19H15V17Z"
  }));
},
    Jc = function Jc(_ref1018) {
  var _ref1018$color = _ref1018.color,
      C = _ref1018$color === void 0 ? "currentColor" : _ref1018$color,
      _ref1018$size = _ref1018.size,
      e = _ref1018$size === void 0 ? 24 : _ref1018$size,
      l = _ref1018.className,
      i = _objectWithoutProperties(_ref1018, _excluded1018);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13.9506 2H20C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V12.9506C3.32891 12.9833 3.6625 13 4 13C9.52285 13 14 8.52285 14 3C14 2.6625 13.9833 2.32891 13.9506 2ZM15 16V18H17V16H15ZM11.9381 2C11.979 2.32759 12 2.66134 12 3C12 7.41828 8.41828 11 4 11C3.66134 11 3.32759 10.979 3 10.9381V3C3 2.44772 3.44772 2 4 2H11.9381Z"
  }));
},
    Yc = function Yc(_ref1019) {
  var _ref1019$color = _ref1019.color,
      C = _ref1019$color === void 0 ? "currentColor" : _ref1019$color,
      _ref1019$size = _ref1019.size,
      e = _ref1019$size === void 0 ? 24 : _ref1019$size,
      l = _ref1019.className,
      i = _objectWithoutProperties(_ref1019, _excluded1019);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5 10.9381C8.61872 10.4869 11.4869 7.61872 11.9381 4H5V10.9381ZM5 12.9506V20H19V4H13.9506C13.4816 8.72442 9.72442 12.4816 5 12.9506ZM4 2H20C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V3C3 2.44772 3.44772 2 4 2ZM15 16H17V18H15V16Z"
  }));
},
    _c = function _c(_ref1020) {
  var _ref1020$color = _ref1020.color,
      C = _ref1020$color === void 0 ? "currentColor" : _ref1020$color,
      _ref1020$size = _ref1020.size,
      e = _ref1020$size === void 0 ? 24 : _ref1020$size,
      l = _ref1020.className,
      i = _objectWithoutProperties(_ref1020, _excluded1020);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7.78428 14L8.2047 10H4V8H8.41491L8.94043 3H10.9514L10.4259 8H14.4149L14.9404 3H16.9514L16.4259 8H20V10H16.2157L15.7953 14H20V16H15.5851L15.0596 21H13.0486L13.5741 16H9.58509L9.05957 21H7.04855L7.57407 16H4V14H7.78428ZM9.7953 14H13.7843L14.2047 10H10.2157L9.7953 14Z"
  }));
},
    $c = function $c(_ref1021) {
  var _ref1021$color = _ref1021.color,
      C = _ref1021$color === void 0 ? "currentColor" : _ref1021$color,
      _ref1021$size = _ref1021.size,
      e = _ref1021$size === void 0 ? 24 : _ref1021$size,
      l = _ref1021.className,
      i = _objectWithoutProperties(_ref1021, _excluded1021);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 19C12.8284 19 13.5 19.6716 13.5 20.5C13.5 21.3284 12.8284 22 12 22C11.1716 22 10.5 21.3284 10.5 20.5C10.5 19.6716 11.1716 19 12 19ZM19.5 19C20.3284 19 21 19.6716 21 20.5C21 21.3284 20.3284 22 19.5 22C18.6716 22 18 21.3284 18 20.5C18 19.6716 18.6716 19 19.5 19ZM4.5 19C5.32843 19 6 19.6716 6 20.5C6 21.3284 5.32843 22 4.5 22C3.67157 22 3 21.3284 3 20.5C3 19.6716 3.67157 19 4.5 19ZM17 7C19.7614 7 22 9.23858 22 12C22 14.7614 19.7614 17 17 17C15.1564 17 13.4896 15.9595 11.9997 13.8785C10.5104 15.9595 8.84364 17 7 17C4.23858 17 2 14.7614 2 12C2 9.23858 4.23858 7 7 7C8.84364 7 10.5104 8.04052 12.0003 10.1215C13.4896 8.04052 15.1564 7 17 7ZM12 2C12.8284 2 13.5 2.67157 13.5 3.5C13.5 4.32843 12.8284 5 12 5C11.1716 5 10.5 4.32843 10.5 3.5C10.5 2.67157 11.1716 2 12 2ZM4.5 2C5.32843 2 6 2.67157 6 3.5C6 4.32843 5.32843 5 4.5 5C3.67157 5 3 4.32843 3 3.5C3 2.67157 3.67157 2 4.5 2ZM19.5 2C20.3284 2 21 2.67157 21 3.5C21 4.32843 20.3284 5 19.5 5C18.6716 5 18 4.32843 18 3.5C18 2.67157 18.6716 2 19.5 2Z"
  }));
},
    eo = function eo(_ref1022) {
  var _ref1022$color = _ref1022.color,
      C = _ref1022$color === void 0 ? "currentColor" : _ref1022$color,
      _ref1022$size = _ref1022.size,
      e = _ref1022$size === void 0 ? 24 : _ref1022$size,
      l = _ref1022.className,
      i = _objectWithoutProperties(_ref1022, _excluded1022);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 19C12.8284 19 13.5 19.6716 13.5 20.5C13.5 21.3284 12.8284 22 12 22C11.1716 22 10.5 21.3284 10.5 20.5C10.5 19.6716 11.1716 19 12 19ZM19.5 19C20.3284 19 21 19.6716 21 20.5C21 21.3284 20.3284 22 19.5 22C18.6716 22 18 21.3284 18 20.5C18 19.6716 18.6716 19 19.5 19ZM4.5 19C5.32843 19 6 19.6716 6 20.5C6 21.3284 5.32843 22 4.5 22C3.67157 22 3 21.3284 3 20.5C3 19.6716 3.67157 19 4.5 19ZM17 7C19.7614 7 22 9.23858 22 12C22 14.7614 19.7614 17 17 17C15.1564 17 13.4896 15.9595 11.9997 13.8785C10.5104 15.9595 8.84364 17 7 17C4.23858 17 2 14.7614 2 12C2 9.23858 4.23858 7 7 7C8.84364 7 10.5104 8.04052 12.0003 10.1215C13.4896 8.04052 15.1564 7 17 7ZM7 9C5.34315 9 4 10.3431 4 12C4 13.6569 5.34315 15 7 15C8.25368 15 9.50923 14.1248 10.7587 12.1459L10.848 11.999L10.7587 11.8541C9.56129 9.95762 8.3583 9.07485 7.15672 9.00457L7 9ZM17 9C15.7463 9 14.4908 9.87517 13.2413 11.8541L13.151 12L13.2413 12.1459C14.4387 14.0424 15.6417 14.9252 16.8433 14.9954L17 15C18.6569 15 20 13.6569 20 12C20 10.3431 18.6569 9 17 9ZM12 2C12.8284 2 13.5 2.67157 13.5 3.5C13.5 4.32843 12.8284 5 12 5C11.1716 5 10.5 4.32843 10.5 3.5C10.5 2.67157 11.1716 2 12 2ZM4.5 2C5.32843 2 6 2.67157 6 3.5C6 4.32843 5.32843 5 4.5 5C3.67157 5 3 4.32843 3 3.5C3 2.67157 3.67157 2 4.5 2ZM19.5 2C20.3284 2 21 2.67157 21 3.5C21 4.32843 20.3284 5 19.5 5C18.6716 5 18 4.32843 18 3.5C18 2.67157 18.6716 2 19.5 2Z"
  }));
},
    to = function to(_ref1023) {
  var _ref1023$color = _ref1023.color,
      C = _ref1023$color === void 0 ? "currentColor" : _ref1023$color,
      _ref1023$size = _ref1023.size,
      e = _ref1023$size === void 0 ? 24 : _ref1023$size,
      l = _ref1023.className,
      i = _objectWithoutProperties(_ref1023, _excluded1023);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.08296 13C6.0284 12.6748 6 12.3407 6 12C6 8.68629 8.68629 6 12 6C15.3137 6 18 8.68629 18 12C18 12.3407 17.9716 12.6748 17.917 13H6.08296ZM2 15H12V17H2V15ZM14 15H22V17H14V15ZM16 19H20V21H16V19ZM4 19H14V21H4V19ZM11 1H13V4H11V1ZM3.51472 4.92893L4.92893 3.51472L7.05025 5.63604L5.63604 7.05025L3.51472 4.92893ZM19.0711 3.51472L20.4853 4.92893L18.364 7.05025L16.9497 5.63604L19.0711 3.51472ZM23 11V13H20V11H23ZM4 11V13H1V11H4Z"
  }));
},
    Co = function Co(_ref1024) {
  var _ref1024$color = _ref1024.color,
      C = _ref1024$color === void 0 ? "currentColor" : _ref1024$color,
      _ref1024$size = _ref1024.size,
      e = _ref1024$size === void 0 ? 24 : _ref1024$size,
      l = _ref1024.className,
      i = _objectWithoutProperties(_ref1024, _excluded1024);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.08296 13C6.0284 12.6748 6 12.3407 6 12C6 8.68629 8.68629 6 12 6C15.3137 6 18 8.68629 18 12C18 12.3407 17.9716 12.6748 17.917 13H15.874C15.9562 12.6804 16 12.3453 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 12.3453 8.04375 12.6804 8.12602 13H6.08296ZM2 15H12V17H2V15ZM14 15H22V17H14V15ZM16 19H20V21H16V19ZM4 19H14V21H4V19ZM11 1H13V4H11V1ZM3.51472 4.92893L4.92893 3.51472L7.05025 5.63604L5.63604 7.05025L3.51472 4.92893ZM19.0711 3.51472L20.4853 4.92893L18.364 7.05025L16.9497 5.63604L19.0711 3.51472ZM23 11V13H20V11H23ZM4 11V13H1V11H4Z"
  }));
},
    lo = function lo(_ref1025) {
  var _ref1025$color = _ref1025.color,
      C = _ref1025$color === void 0 ? "currentColor" : _ref1025$color,
      _ref1025$size = _ref1025.size,
      e = _ref1025$size === void 0 ? 24 : _ref1025$size,
      l = _ref1025.className,
      i = _objectWithoutProperties(_ref1025, _excluded1025);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM7.5 11.25V9H6V15H7.5V12.75H9.5V15H11V9H9.5V11.25H7.5ZM14.5 10.5H16C16.2761 10.5 16.5 10.7239 16.5 11V13C16.5 13.2761 16.2761 13.5 16 13.5H14.5V10.5ZM13 9V15H16C17.1046 15 18 14.1046 18 13V11C18 9.89543 17.1046 9 16 9H13Z"
  }));
},
    io = function io(_ref1026) {
  var _ref1026$color = _ref1026.color,
      C = _ref1026$color === void 0 ? "currentColor" : _ref1026$color,
      _ref1026$size = _ref1026.size,
      e = _ref1026$size === void 0 ? 24 : _ref1026$size,
      l = _ref1026.className,
      i = _objectWithoutProperties(_ref1026, _excluded1026);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 5V19H20V5H4ZM3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM7.5 11.25H9.5V9H11V15H9.5V12.75H7.5V15H6V9H7.5V11.25ZM14.5 10.5V13.5H16C16.2761 13.5 16.5 13.2761 16.5 13V11C16.5 10.7239 16.2761 10.5 16 10.5H14.5ZM13 9H16C17.1046 9 18 9.89543 18 11V13C18 14.1046 17.1046 15 16 15H13V9Z"
  }));
},
    so = function so(_ref1027) {
  var _ref1027$color = _ref1027.color,
      C = _ref1027$color === void 0 ? "currentColor" : _ref1027$color,
      _ref1027$size = _ref1027.size,
      e = _ref1027$size === void 0 ? 24 : _ref1027$size,
      l = _ref1027.className,
      i = _objectWithoutProperties(_ref1027, _excluded1027);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17 11V4H19V21H17V13H7V21H5V4H7V11H17Z"
  }));
},
    ro = function ro(_ref1028) {
  var _ref1028$color = _ref1028.color,
      C = _ref1028$color === void 0 ? "currentColor" : _ref1028$color,
      _ref1028$size = _ref1028.size,
      e = _ref1028$size === void 0 ? 24 : _ref1028$size,
      l = _ref1028.className,
      i = _objectWithoutProperties(_ref1028, _excluded1028);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 12H7C8.10457 12 9 12.8954 9 14V19C9 20.1046 8.10457 21 7 21H4C2.89543 21 2 20.1046 2 19V12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12V19C22 20.1046 21.1046 21 20 21H17C15.8954 21 15 20.1046 15 19V14C15 12.8954 15.8954 12 17 12H20C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12Z"
  }));
},
    co = function co(_ref1029) {
  var _ref1029$color = _ref1029.color,
      C = _ref1029$color === void 0 ? "currentColor" : _ref1029$color,
      _ref1029$size = _ref1029.size,
      e = _ref1029$size === void 0 ? 24 : _ref1029$size,
      l = _ref1029.className,
      i = _objectWithoutProperties(_ref1029, _excluded1029);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 4C7.58172 4 4 7.58172 4 12H7C8.10457 12 9 12.8954 9 14V19C9 20.1046 8.10457 21 7 21H4C2.89543 21 2 20.1046 2 19V12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12V19C22 20.1046 21.1046 21 20 21H17C15.8954 21 15 20.1046 15 19V14C15 12.8954 15.8954 12 17 12H20C20 7.58172 16.4183 4 12 4ZM4 14V19H7V14H4ZM17 14V19H20V14H17Z"
  }));
},
    oo = function oo(_ref1030) {
  var _ref1030$color = _ref1030.color,
      C = _ref1030$color === void 0 ? "currentColor" : _ref1030$color,
      _ref1030$size = _ref1030.size,
      e = _ref1030$size === void 0 ? 24 : _ref1030$size,
      l = _ref1030.className,
      i = _objectWithoutProperties(_ref1030, _excluded1030);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 2C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22H6C5.44772 22 5 21.5523 5 21V19H3V17H5V15H3V13H5V11H3V9H5V7H3V5H5V3C5 2.44772 5.44772 2 6 2H20ZM14 8H12V11H9V13H11.999L12 16H14L13.999 13H17V11H14V8Z"
  }));
},
    ao = function ao(_ref1031) {
  var _ref1031$color = _ref1031.color,
      C = _ref1031$color === void 0 ? "currentColor" : _ref1031$color,
      _ref1031$size = _ref1031.size,
      e = _ref1031$size === void 0 ? 24 : _ref1031$size,
      l = _ref1031.className,
      i = _objectWithoutProperties(_ref1031, _excluded1031);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 2C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22H6C5.44772 22 5 21.5523 5 21V19H3V17H5V15H3V13H5V11H3V9H5V7H3V5H5V3C5 2.44772 5.44772 2 6 2H20ZM19 4H7V20H19V4ZM14 8V11H17V13H13.999L14 16H12L11.999 13H9V11H12V8H14Z"
  }));
},
    no = function no(_ref1032) {
  var _ref1032$color = _ref1032.color,
      C = _ref1032$color === void 0 ? "currentColor" : _ref1032$color,
      _ref1032$size = _ref1032.size,
      e = _ref1032$size === void 0 ? 24 : _ref1032$size,
      l = _ref1032.className,
      i = _objectWithoutProperties(_ref1032, _excluded1032);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.2426 4.75736C22.5053 7.02472 22.583 10.637 20.4786 12.993L11.9999 21.485L3.52138 12.993C1.41705 10.637 1.49571 7.01901 3.75736 4.75736C5.51545 2.99926 8.09315 2.56029 10.2605 3.44044L6.34315 7.35843L7.75736 8.77264L12 4.53L11.9872 4.51617C11.9918 4.52028 11.9964 4.5244 12.001 4.52853C14.35 2.42 17.98 2.49 20.2426 4.75736Z"
  }));
},
    mo = function mo(_ref1033) {
  var _ref1033$color = _ref1033.color,
      C = _ref1033$color === void 0 ? "currentColor" : _ref1033$color,
      _ref1033$size = _ref1033.size,
      e = _ref1033$size === void 0 ? 24 : _ref1033$size,
      l = _ref1033.className,
      i = _objectWithoutProperties(_ref1033, _excluded1033);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.2426 4.75736C22.5053 7.02472 22.583 10.637 20.4786 12.993L11.9999 21.485L3.52138 12.993C1.41705 10.637 1.49571 7.01901 3.75736 4.75736C6.02157 2.49315 9.64519 2.41687 12.001 4.52853C14.35 2.42 17.98 2.49 20.2426 4.75736ZM5.17157 6.17157C3.68183 7.66131 3.60704 10.0473 4.97993 11.6232L11.9999 18.6543L19.0201 11.6232C20.3935 10.0467 20.319 7.66525 18.827 6.1701C17.3397 4.67979 14.9458 4.60806 13.3743 5.98376L9.17157 10.1869L7.75736 8.77264L10.582 5.946L10.5002 5.87701C8.92545 4.61197 6.62322 4.71993 5.17157 6.17157Z"
  }));
},
    wo = function wo(_ref1034) {
  var _ref1034$color = _ref1034.color,
      C = _ref1034$color === void 0 ? "currentColor" : _ref1034$color,
      _ref1034$size = _ref1034.size,
      e = _ref1034$size === void 0 ? 24 : _ref1034$size,
      l = _ref1034.className,
      i = _objectWithoutProperties(_ref1034, _excluded1034);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16.5 3C19.5376 3 22 5.5 22 9C22 16 14.5 20 12 21.5C9.5 20 2 16 2 9C2 5.5 4.5 3 7.5 3C9.35997 3 11 4 12 5C13 4 14.64 3 16.5 3Z"
  }));
},
    Lo = function Lo(_ref1035) {
  var _ref1035$color = _ref1035.color,
      C = _ref1035$color === void 0 ? "currentColor" : _ref1035$color,
      _ref1035$size = _ref1035.size,
      e = _ref1035$size === void 0 ? 24 : _ref1035$size,
      l = _ref1035.className,
      i = _objectWithoutProperties(_ref1035, _excluded1035);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16.5 3C19.5376 3 22 5.5 22 9C22 16 14.5 20 12 21.5C9.5 20 2 16 2 9C2 5.5 4.5 3 7.5 3C9.35997 3 11 4 12 5C13 4 14.64 3 16.5 3ZM12.9339 18.6038C13.8155 18.0485 14.61 17.4955 15.3549 16.9029C18.3337 14.533 20 11.9435 20 9C20 6.64076 18.463 5 16.5 5C15.4241 5 14.2593 5.56911 13.4142 6.41421L12 7.82843L10.5858 6.41421C9.74068 5.56911 8.5759 5 7.5 5C5.55906 5 4 6.6565 4 9C4 11.9435 5.66627 14.533 8.64514 16.9029C9.39 17.4955 10.1845 18.0485 11.0661 18.6038C11.3646 18.7919 11.6611 18.9729 12 19.1752C12.3389 18.9729 12.6354 18.7919 12.9339 18.6038Z"
  }));
},
    ho = function ho(_ref1036) {
  var _ref1036$color = _ref1036.color,
      C = _ref1036$color === void 0 ? "currentColor" : _ref1036$color,
      _ref1036$size = _ref1036.size,
      e = _ref1036$size === void 0 ? 24 : _ref1036$size,
      l = _ref1036.className,
      i = _objectWithoutProperties(_ref1036, _excluded1036);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19.0001 13.9999V16.9999H22.0001V18.9999H18.9991L19.0001 21.9999H17.0001L16.9991 18.9999H14.0001V16.9999H17.0001V13.9999H19.0001ZM20.2426 4.75736C22.4033 6.92253 22.5715 10.3141 20.7498 12.667C19.9261 12.2403 18.9911 12 18 12C14.6863 12 12 14.6863 12 18C12 19.0089 12.249 19.9596 12.6889 20.794L11.9999 21.485L3.52138 12.993C1.41705 10.637 1.49571 7.01901 3.75736 4.75736C6.02157 2.49315 9.64519 2.41687 12.001 4.52853C14.35 2.42 17.98 2.49 20.2426 4.75736Z"
  }));
},
    Ho = function Ho(_ref1037) {
  var _ref1037$color = _ref1037.color,
      C = _ref1037$color === void 0 ? "currentColor" : _ref1037$color,
      _ref1037$size = _ref1037.size,
      e = _ref1037$size === void 0 ? 24 : _ref1037$size,
      l = _ref1037.className,
      i = _objectWithoutProperties(_ref1037, _excluded1037);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19.0001 14V17H22.0001V19H18.9991L19.0001 22H17.0001L16.9991 19H14.0001V17H17.0001V14H19.0001ZM20.2426 4.75748C22.505 7.02453 22.5829 10.6361 20.4795 12.9921L19.06 11.5741C20.3901 10.05 20.3201 7.66 18.827 6.17022C17.3244 4.67104 14.9076 4.60713 13.337 6.017L12.0019 7.21536L10.6661 6.01793C9.09098 4.60609 6.67506 4.66821 5.17157 6.1717C3.68183 7.66143 3.60704 10.0474 4.97993 11.6233L13.412 20.0691L11.9999 21.4851L3.52138 12.9931C1.41705 10.6371 1.49571 7.01913 3.75736 4.75748C6.02157 2.49327 9.64519 2.41699 12.001 4.52865C14.35 2.42012 17.98 2.49012 20.2426 4.75748Z"
  }));
},
    Vo = function Vo(_ref1038) {
  var _ref1038$color = _ref1038.color,
      C = _ref1038$color === void 0 ? "currentColor" : _ref1038$color,
      _ref1038$size = _ref1038.size,
      e = _ref1038$size === void 0 ? 24 : _ref1038$size,
      l = _ref1038.className,
      i = _objectWithoutProperties(_ref1038, _excluded1038);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.001 4.52853C14.35 2.42 17.98 2.49 20.2426 4.75736C22.5053 7.02472 22.583 10.637 20.4786 12.993L11.9999 21.485L3.52138 12.993C1.41705 10.637 1.49571 7.01901 3.75736 4.75736C6.02157 2.49315 9.64519 2.41687 12.001 4.52853Z"
  }));
},
    go = function go(_ref1039) {
  var _ref1039$color = _ref1039.color,
      C = _ref1039$color === void 0 ? "currentColor" : _ref1039$color,
      _ref1039$size = _ref1039.size,
      e = _ref1039$size === void 0 ? 24 : _ref1039$size,
      l = _ref1039.className,
      i = _objectWithoutProperties(_ref1039, _excluded1039);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.001 4.52853C14.35 2.42 17.98 2.49 20.2426 4.75736C22.5053 7.02472 22.583 10.637 20.4786 12.993L11.9999 21.485L3.52138 12.993C1.41705 10.637 1.49571 7.01901 3.75736 4.75736C6.02157 2.49315 9.64519 2.41687 12.001 4.52853ZM18.827 6.1701C17.3279 4.66794 14.9076 4.60701 13.337 6.01687L12.0019 7.21524L10.6661 6.01781C9.09098 4.60597 6.67506 4.66808 5.17157 6.17157C3.68183 7.66131 3.60704 10.0473 4.97993 11.6232L11.9999 18.6543L19.0201 11.6232C20.3935 10.0467 20.319 7.66525 18.827 6.1701Z"
  }));
},
    Mo = function Mo(_ref1040) {
  var _ref1040$color = _ref1040.color,
      C = _ref1040$color === void 0 ? "currentColor" : _ref1040$color,
      _ref1040$size = _ref1040.size,
      e = _ref1040$size === void 0 ? 24 : _ref1040$size,
      l = _ref1040.className,
      i = _objectWithoutProperties(_ref1040, _excluded1040);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16.5 3C19.5376 3 22 5.5 22 9C22 16 14.5 20 12 21.5C10.0224 20.3135 4.91625 17.5626 2.8685 13L7.56619 13L8.5 11.4437L11.5 16.4437L13.5662 13H17V11H12.4338L11.5 12.5563L8.5 7.55635L6.43381 11L2.21024 10.9999C2.07418 10.3626 2 9.69615 2 9C2 5.5 4.5 3 7.5 3C9.35997 3 11 4 12 5C13 4 14.64 3 16.5 3Z"
  }));
},
    Zo = function Zo(_ref1041) {
  var _ref1041$color = _ref1041.color,
      C = _ref1041$color === void 0 ? "currentColor" : _ref1041$color,
      _ref1041$size = _ref1041.size,
      e = _ref1041$size === void 0 ? 24 : _ref1041$size,
      l = _ref1041.className,
      i = _objectWithoutProperties(_ref1041, _excluded1041);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16.5 3C19.5376 3 22 5.5 22 9C22 16 14.5 20 12 21.5C10.0226 20.3135 4.91699 17.563 2.86894 13.001L1 13V11L2.21045 11.0009C2.07425 10.3633 2 9.69651 2 9C2 5.5 4.5 3 7.5 3C9.35997 3 11 4 12 5C13 4 14.64 3 16.5 3ZM16.5 5C15.4241 5 14.2593 5.56911 13.4142 6.41421L12 7.82843L10.5858 6.41421C9.74068 5.56911 8.5759 5 7.5 5C5.55906 5 4 6.6565 4 9C4 9.68542 4.09035 10.3516 4.26658 11.0004L6.43381 11L8.5 7.55635L11.5 12.5563L12.4338 11H17V13H13.5662L11.5 16.4437L8.5 11.4437L7.56619 13L5.10789 13.0006C5.89727 14.3737 7.09304 15.6681 8.64514 16.9029C9.39001 17.4955 10.1845 18.0485 11.0661 18.6038C11.3646 18.7919 11.6611 18.9729 12 19.1752C12.3389 18.9729 12.6354 18.7919 12.9339 18.6038C13.8155 18.0485 14.61 17.4955 15.3549 16.9029C18.3337 14.533 20 11.9435 20 9C20 6.64076 18.463 5 16.5 5Z"
  }));
},
    xo = function xo(_ref1042) {
  var _ref1042$color = _ref1042.color,
      C = _ref1042$color === void 0 ? "currentColor" : _ref1042$color,
      _ref1042$size = _ref1042.size,
      e = _ref1042$size === void 0 ? 24 : _ref1042$size,
      l = _ref1042.className,
      i = _objectWithoutProperties(_ref1042, _excluded1042);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17.3631 11.0453C18.767 9.65157 21.0432 9.65157 22.4471 11.0453C23.851 12.439 23.851 14.6987 22.4471 16.0924L17 21.5L11.5529 16.0924C10.149 14.6987 10.149 12.439 11.5529 11.0453C12.9568 9.65157 15.233 9.65157 16.6369 11.0453L16.9996 11.4051L17.3631 11.0453ZM19.2426 4.75736C20.1831 5.69977 20.7461 6.87453 20.9318 8.09485C19.5993 7.84749 18.1932 8.08543 17.0001 8.808C14.8491 7.50516 12.0056 7.7777 10.1439 9.62594C8.01293 11.7414 7.95374 15.1405 9.96628 17.3273L10.1439 17.5117L12.565 19.916L10.9999 21.485L2.52138 12.993C0.417048 10.637 0.495706 7.01901 2.75736 4.75736C5.02157 2.49315 8.64519 2.41687 11.001 4.52853C13.35 2.42 16.98 2.49 19.2426 4.75736Z"
  }));
},
    vo = function vo(_ref1043) {
  var _ref1043$color = _ref1043.color,
      C = _ref1043$color === void 0 ? "currentColor" : _ref1043$color,
      _ref1043$size = _ref1043.size,
      e = _ref1043$size === void 0 ? 24 : _ref1043$size,
      l = _ref1043.className,
      i = _objectWithoutProperties(_ref1043, _excluded1043);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19.2426 4.75736C20.705 6.2228 21.2547 8.25005 20.8924 10.1368C21.4614 10.2972 21.9987 10.6002 22.4471 11.0453C23.851 12.439 23.851 14.6987 22.4471 16.0924L17 21.5L13.978 18.5L10.9999 21.485L2.52138 12.993C0.417048 10.637 0.495706 7.01901 2.75736 4.75736C5.02157 2.49315 8.64519 2.41687 11.001 4.52853C13.35 2.42 16.98 2.49 19.2426 4.75736ZM12.962 12.4646C12.346 13.0761 12.346 14.0615 12.962 14.673L17 18.6818L21.038 14.673C21.654 14.0615 21.654 13.0761 21.038 12.4646C20.414 11.8451 19.3962 11.8451 18.77 12.4668L16.9979 14.2206L15.591 12.825L15.2278 12.4646C14.6038 11.8451 13.586 11.8451 12.962 12.4646ZM4.17157 6.17157C2.68183 7.66131 2.60704 10.0473 3.97993 11.6232L10.9999 18.6543L12.559 17.092L11.5529 16.0924C10.149 14.6987 10.149 12.439 11.5529 11.0453C12.9568 9.65157 15.233 9.65157 16.6369 11.0453L16.9996 11.4051L17.3631 11.0453C17.7877 10.6238 18.2921 10.3297 18.828 10.1632C19.2436 8.79577 18.9058 7.25122 17.827 6.1701C16.3279 4.66794 13.9076 4.60701 12.337 6.01687L11.0019 7.21524L9.66605 6.01781C8.09098 4.60597 5.67506 4.66808 4.17157 6.17157Z"
  }));
},
    po = function po(_ref1044) {
  var _ref1044$color = _ref1044.color,
      C = _ref1044$color === void 0 ? "currentColor" : _ref1044$color,
      _ref1044$size = _ref1044.size,
      e = _ref1044$size === void 0 ? 24 : _ref1044$size,
      l = _ref1044.className,
      i = _objectWithoutProperties(_ref1044, _excluded1044);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13 18V23H11V18H9V21H7V17.748C3.54955 16.8599 1 13.7277 1 10C1 5.58172 4.58172 2 9 2C12.3949 2 15.2959 4.11466 16.4576 7.09864C16.7951 7.0339 17.1436 7 17.5 7C20.5376 7 23 9.46243 23 12.5C23 15.5376 20.5376 18 17.5 18H17V21H15V18H13Z"
  }));
},
    Eo = function Eo(_ref1045) {
  var _ref1045$color = _ref1045.color,
      C = _ref1045$color === void 0 ? "currentColor" : _ref1045$color,
      _ref1045$size = _ref1045.size,
      e = _ref1045$size === void 0 ? 24 : _ref1045$size,
      l = _ref1045.className,
      i = _objectWithoutProperties(_ref1045, _excluded1045);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5 16.9297C2.60879 15.5465 1 12.9611 1 10C1 5.58172 4.58172 2 9 2C12.3949 2 15.2959 4.11466 16.4576 7.09864C16.7951 7.0339 17.1436 7 17.5 7C20.5376 7 23 9.46243 23 12.5C23 15.0176 21.3085 17.14 19 17.793V15.6632C20.1825 15.1015 21 13.8962 21 12.5C21 10.567 19.433 9 17.5 9C16.5205 9 15.6351 9.40232 14.9998 10.0507C14.9999 10.0338 15 10.0169 15 10C15 6.68629 12.3137 4 9 4C5.68629 4 3 6.68629 3 10C3 11.777 3.7725 13.3736 5 14.4722V16.9297ZM7 14H9V20H7V14ZM15 14H17V20H15V14ZM11 17H13V23H11V17Z"
  }));
},
    No = function No(_ref1046) {
  var _ref1046$color = _ref1046.color,
      C = _ref1046$color === void 0 ? "currentColor" : _ref1046$color,
      _ref1046$size = _ref1046.size,
      e = _ref1046$size === void 0 ? 24 : _ref1046$size,
      l = _ref1046.className,
      i = _objectWithoutProperties(_ref1046, _excluded1046);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12H4C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C9.53614 4 7.33243 5.11383 5.86492 6.86543L8 9H2V3L4.44656 5.44648C6.28002 3.33509 8.9841 2 12 2ZM13 7L12.9998 11.585L16.2426 14.8284L14.8284 16.2426L10.9998 12.413L11 7H13Z"
  }));
},
    uo = function uo(_ref1047) {
  var _ref1047$color = _ref1047.color,
      C = _ref1047$color === void 0 ? "currentColor" : _ref1047$color,
      _ref1047$size = _ref1047.size,
      e = _ref1047$size === void 0 ? 24 : _ref1047$size,
      l = _ref1047.className,
      i = _objectWithoutProperties(_ref1047, _excluded1047);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12H4C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C9.25022 4 6.82447 5.38734 5.38451 7.50024L8 7.5V9.5H2V3.5H4L3.99989 5.99918C5.82434 3.57075 8.72873 2 12 2ZM13 7L12.9998 11.585L16.2426 14.8284L14.8284 16.2426L10.9998 12.413L11 7H13Z"
  }));
},
    Bo = function Bo(_ref1048) {
  var _ref1048$color = _ref1048.color,
      C = _ref1048$color === void 0 ? "currentColor" : _ref1048$color,
      _ref1048$size = _ref1048.size,
      e = _ref1048$size === void 0 ? 24 : _ref1048$size,
      l = _ref1048.className,
      i = _objectWithoutProperties(_ref1048, _excluded1048);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 20C20 20.5523 19.5523 21 19 21H5C4.44772 21 4 20.5523 4 20V11L1 11L11.3273 1.6115C11.7087 1.26475 12.2913 1.26475 12.6727 1.6115L23 11L20 11V20Z"
  }));
},
    fo = function fo(_ref1049) {
  var _ref1049$color = _ref1049.color,
      C = _ref1049$color === void 0 ? "currentColor" : _ref1049$color,
      _ref1049$size = _ref1049.size,
      e = _ref1049$size === void 0 ? 24 : _ref1049$size,
      l = _ref1049.className,
      i = _objectWithoutProperties(_ref1049, _excluded1049);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19 21H5C4.44772 21 4 20.5523 4 20V11L1 11L11.3273 1.6115C11.7087 1.26475 12.2913 1.26475 12.6727 1.6115L23 11L20 11V20C20 20.5523 19.5523 21 19 21ZM6 19H18V9.15745L12 3.7029L6 9.15745V19Z"
  }));
},
    Ro = function Ro(_ref1050) {
  var _ref1050$color = _ref1050.color,
      C = _ref1050$color === void 0 ? "currentColor" : _ref1050$color,
      _ref1050$size = _ref1050.size,
      e = _ref1050$size === void 0 ? 24 : _ref1050$size,
      l = _ref1050.className,
      i = _objectWithoutProperties(_ref1050, _excluded1050);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 20C20 20.5523 19.5523 21 19 21H5C4.44772 21 4 20.5523 4 20V11L1 11L11.3273 1.6115C11.7087 1.26475 12.2913 1.26475 12.6727 1.6115L23 11L20 11V20ZM8 15V17H16V15H8Z"
  }));
},
    zo = function zo(_ref1051) {
  var _ref1051$color = _ref1051.color,
      C = _ref1051$color === void 0 ? "currentColor" : _ref1051$color,
      _ref1051$size = _ref1051.size,
      e = _ref1051$size === void 0 ? 24 : _ref1051$size,
      l = _ref1051.className,
      i = _objectWithoutProperties(_ref1051, _excluded1051);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19 21H5C4.44772 21 4 20.5523 4 20V11L1 11L11.3273 1.6115C11.7087 1.26475 12.2913 1.26475 12.6727 1.6115L23 11L20 11V20C20 20.5523 19.5523 21 19 21ZM6 19H18V9.15745L12 3.7029L6 9.15745V19ZM8 15H16V17H8V15Z"
  }));
},
    Fo = function Fo(_ref1052) {
  var _ref1052$color = _ref1052.color,
      C = _ref1052$color === void 0 ? "currentColor" : _ref1052$color,
      _ref1052$size = _ref1052.size,
      e = _ref1052$size === void 0 ? 24 : _ref1052$size,
      l = _ref1052.className,
      i = _objectWithoutProperties(_ref1052, _excluded1052);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 20C20 20.5523 19.5523 21 19 21H5C4.44772 21 4 20.5523 4 20V11L1 11L11.3273 1.6115C11.7087 1.26475 12.2913 1.26475 12.6727 1.6115L23 11L20 11V20ZM11 13V19H13V13H11Z"
  }));
},
    So = function So(_ref1053) {
  var _ref1053$color = _ref1053.color,
      C = _ref1053$color === void 0 ? "currentColor" : _ref1053$color,
      _ref1053$size = _ref1053.size,
      e = _ref1053$size === void 0 ? 24 : _ref1053$size,
      l = _ref1053.className,
      i = _objectWithoutProperties(_ref1053, _excluded1053);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19 21H5C4.44772 21 4 20.5523 4 20V11L1 11L11.3273 1.6115C11.7087 1.26475 12.2913 1.26475 12.6727 1.6115L23 11L20 11V20C20 20.5523 19.5523 21 19 21ZM13 19H18V9.15745L12 3.7029L6 9.15745V19H11V13H13V19Z"
  }));
},
    Ao = function Ao(_ref1054) {
  var _ref1054$color = _ref1054.color,
      C = _ref1054$color === void 0 ? "currentColor" : _ref1054$color,
      _ref1054$size = _ref1054.size,
      e = _ref1054$size === void 0 ? 24 : _ref1054$size,
      l = _ref1054.className,
      i = _objectWithoutProperties(_ref1054, _excluded1054);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V9.48907C3 9.18048 3.14247 8.88917 3.38606 8.69972L11.3861 2.47749C11.7472 2.19663 12.2528 2.19663 12.6139 2.47749L20.6139 8.69972C20.8575 8.88917 21 9.18048 21 9.48907V20ZM11 13V19H13V13H11Z"
  }));
},
    ko = function ko(_ref1055) {
  var _ref1055$color = _ref1055.color,
      C = _ref1055$color === void 0 ? "currentColor" : _ref1055$color,
      _ref1055$size = _ref1055.size,
      e = _ref1055$size === void 0 ? 24 : _ref1055$size,
      l = _ref1055.className,
      i = _objectWithoutProperties(_ref1055, _excluded1055);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13 19H19V9.97815L12 4.53371L5 9.97815V19H11V13H13V19ZM21 20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V9.48907C3 9.18048 3.14247 8.88917 3.38606 8.69972L11.3861 2.47749C11.7472 2.19663 12.2528 2.19663 12.6139 2.47749L20.6139 8.69972C20.8575 8.88917 21 9.18048 21 9.48907V20Z"
  }));
},
    Po = function Po(_ref1056) {
  var _ref1056$color = _ref1056.color,
      C = _ref1056$color === void 0 ? "currentColor" : _ref1056$color,
      _ref1056$size = _ref1056.size,
      e = _ref1056$size === void 0 ? 24 : _ref1056$size,
      l = _ref1056.className,
      i = _objectWithoutProperties(_ref1056, _excluded1056);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V9.48907C3 9.18048 3.14247 8.88917 3.38606 8.69972L11.3861 2.47749C11.7472 2.19663 12.2528 2.19663 12.6139 2.47749L20.6139 8.69972C20.8575 8.88917 21 9.18048 21 9.48907V20ZM7 15V17H17V15H7Z"
  }));
},
    Do = function Do(_ref1057) {
  var _ref1057$color = _ref1057.color,
      C = _ref1057$color === void 0 ? "currentColor" : _ref1057$color,
      _ref1057$size = _ref1057.size,
      e = _ref1057$size === void 0 ? 24 : _ref1057$size,
      l = _ref1057.className,
      i = _objectWithoutProperties(_ref1057, _excluded1057);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V9.48907C3 9.18048 3.14247 8.88917 3.38606 8.69972L11.3861 2.47749C11.7472 2.19663 12.2528 2.19663 12.6139 2.47749L20.6139 8.69972C20.8575 8.88917 21 9.18048 21 9.48907V20ZM19 19V9.97815L12 4.53371L5 9.97815V19H19ZM7 15H17V17H7V15Z"
  }));
},
    yo = function yo(_ref1058) {
  var _ref1058$color = _ref1058.color,
      C = _ref1058$color === void 0 ? "currentColor" : _ref1058$color,
      _ref1058$size = _ref1058.size,
      e = _ref1058$size === void 0 ? 24 : _ref1058$size,
      l = _ref1058.className,
      i = _objectWithoutProperties(_ref1058, _excluded1058);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 20C20 20.5523 19.5523 21 19 21H5C4.44772 21 4 20.5523 4 20V11L1 11L11.3273 1.6115C11.7087 1.26475 12.2913 1.26475 12.6727 1.6115L23 11L20 11V20ZM12 15C13.3807 15 14.5 13.8807 14.5 12.5C14.5 11.1193 13.3807 9.99998 12 9.99998C10.6193 9.99998 9.5 11.1193 9.5 12.5C9.5 13.8807 10.6193 15 12 15Z"
  }));
},
    bo = function bo(_ref1059) {
  var _ref1059$color = _ref1059.color,
      C = _ref1059$color === void 0 ? "currentColor" : _ref1059$color,
      _ref1059$size = _ref1059.size,
      e = _ref1059$size === void 0 ? 24 : _ref1059$size,
      l = _ref1059.className,
      i = _objectWithoutProperties(_ref1059, _excluded1059);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19 21H5C4.44772 21 4 20.5523 4 20V11L1 11L11.3273 1.6115C11.7087 1.26475 12.2913 1.26475 12.6727 1.6115L23 11L20 11V20C20 20.5523 19.5523 21 19 21ZM6 19H18V9.15745L12 3.7029L6 9.15745V19ZM12 15C10.6193 15 9.5 13.8807 9.5 12.5C9.5 11.1193 10.6193 9.99998 12 9.99998C13.3807 9.99998 14.5 11.1193 14.5 12.5C14.5 13.8807 13.3807 15 12 15Z"
  }));
},
    To = function To(_ref1060) {
  var _ref1060$color = _ref1060.color,
      C = _ref1060$color === void 0 ? "currentColor" : _ref1060$color,
      _ref1060$size = _ref1060.size,
      e = _ref1060$size === void 0 ? 24 : _ref1060$size,
      l = _ref1060.className,
      i = _objectWithoutProperties(_ref1060, _excluded1060);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 20C20 20.5523 19.5523 21 19 21H5C4.44772 21 4 20.5523 4 20V11L1 11L11.3273 1.6115C11.7087 1.26475 12.2913 1.26475 12.6727 1.6115L23 11L20 11V20ZM9 9.99998V16H15V9.99998H9ZM11 12H13V14H11V12Z"
  }));
},
    Uo = function Uo(_ref1061) {
  var _ref1061$color = _ref1061.color,
      C = _ref1061$color === void 0 ? "currentColor" : _ref1061$color,
      _ref1061$size = _ref1061.size,
      e = _ref1061$size === void 0 ? 24 : _ref1061$size,
      l = _ref1061.className,
      i = _objectWithoutProperties(_ref1061, _excluded1061);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19 21H5C4.44772 21 4 20.5523 4 20V11L1 11L11.3273 1.6115C11.7087 1.26475 12.2913 1.26475 12.6727 1.6115L23 11L20 11V20C20 20.5523 19.5523 21 19 21ZM6 19H18V9.15745L12 3.7029L6 9.15745V19ZM9 9.99998H15V16H9V9.99998ZM11 12V14H13V12H11Z"
  }));
},
    Go = function Go(_ref1062) {
  var _ref1062$color = _ref1062.color,
      C = _ref1062$color === void 0 ? "currentColor" : _ref1062$color,
      _ref1062$size = _ref1062.size,
      e = _ref1062$size === void 0 ? 24 : _ref1062$size,
      l = _ref1062.className,
      i = _objectWithoutProperties(_ref1062, _excluded1062);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V9.48907C3 9.18048 3.14247 8.88917 3.38606 8.69972L11.3861 2.47749C11.7472 2.19663 12.2528 2.19663 12.6139 2.47749L20.6139 8.69972C20.8575 8.88917 21 9.18048 21 9.48907V20Z"
  }));
},
    Io = function Io(_ref1063) {
  var _ref1063$color = _ref1063.color,
      C = _ref1063$color === void 0 ? "currentColor" : _ref1063$color,
      _ref1063$size = _ref1063.size,
      e = _ref1063$size === void 0 ? 24 : _ref1063$size,
      l = _ref1063.className,
      i = _objectWithoutProperties(_ref1063, _excluded1063);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 20C20 20.5523 19.5523 21 19 21H5C4.44772 21 4 20.5523 4 20V11L1 11L11.3273 1.6115C11.7087 1.26475 12.2913 1.26475 12.6727 1.6115L23 11L20 11V20ZM8.59208 13.808L7.60099 14.3802L8.6017 16.1133L9.5943 15.5402C9.98756 15.9116 10.467 16.193 10.9994 16.3512V17.4956H13.0007V16.3512C13.5331 16.1929 14.0125 15.9115 14.4057 15.5401L15.3984 16.1132L16.399 14.3801L15.4079 13.8078C15.4696 13.5478 15.5022 13.2766 15.5022 12.9978C15.5022 12.7189 15.4696 12.4477 15.4078 12.1877L16.399 11.6154L15.3983 9.88225L14.4056 10.4554C14.0124 10.084 13.533 9.80264 13.0006 9.64436V8.49998H10.9993V9.64436C10.4669 9.80265 9.98747 10.084 9.59421 10.4554L8.60164 9.88234L7.60099 11.6155L8.59205 12.1877C8.53034 12.4477 8.49768 12.7189 8.49768 12.9978C8.49768 13.2767 8.53035 13.5479 8.59208 13.808ZM12 14.4971C11.171 14.4971 10.499 13.8258 10.499 12.9978C10.499 12.1698 11.171 11.4985 12 11.4985C12.8289 11.4985 13.5009 12.1698 13.5009 12.9978C13.5009 13.8258 12.8289 14.4971 12 14.4971Z"
  }));
},
    Wo = function Wo(_ref1064) {
  var _ref1064$color = _ref1064.color,
      C = _ref1064$color === void 0 ? "currentColor" : _ref1064$color,
      _ref1064$size = _ref1064.size,
      e = _ref1064$size === void 0 ? 24 : _ref1064$size,
      l = _ref1064.className,
      i = _objectWithoutProperties(_ref1064, _excluded1064);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19 21H5C4.44772 21 4 20.5523 4 20V11L1 11L11.3273 1.6115C11.7087 1.26475 12.2913 1.26475 12.6727 1.6115L23 11L20 11V20C20 20.5523 19.5523 21 19 21ZM6 19H18V9.15745L12 3.7029L6 9.15745V19ZM8.59117 13.8089C8.52937 13.5486 8.49666 13.277 8.49666 12.9978C8.49666 12.7186 8.52936 12.4471 8.59115 12.1868L7.60001 11.6145L8.59952 9.88333L9.59136 10.456C9.98427 10.0843 10.4633 9.80273 10.9954 9.64436V8.49998H12.9945V9.64436C13.5266 9.80272 14.0056 10.0843 14.3985 10.4559L15.3904 9.88323L16.39 11.6144L15.3987 12.1867C15.4605 12.447 15.4932 12.7186 15.4932 12.9978C15.4932 13.277 15.4605 13.5485 15.3988 13.8088L16.39 14.381L15.3905 16.1122L14.3986 15.5396C14.0057 15.9112 13.5267 16.1928 12.9946 16.3512V17.4956H10.9955V16.3512C10.4634 16.1929 9.98437 15.9114 9.59144 15.5397L8.59957 16.1123L7.60001 14.3811L8.59117 13.8089ZM11.995 14.4971C12.823 14.4971 13.4942 13.8258 13.4942 12.9978C13.4942 12.1698 12.823 11.4985 11.995 11.4985C11.1669 11.4985 10.4957 12.1698 10.4957 12.9978C10.4957 13.8258 11.1669 14.4971 11.995 14.4971Z"
  }));
},
    Oo = function Oo(_ref1065) {
  var _ref1065$color = _ref1065.color,
      C = _ref1065$color === void 0 ? "currentColor" : _ref1065$color,
      _ref1065$size = _ref1065.size,
      e = _ref1065$size === void 0 ? 24 : _ref1065$size,
      l = _ref1065.className,
      i = _objectWithoutProperties(_ref1065, _excluded1065);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 20C20 20.5523 19.5523 21 19 21H5C4.44772 21 4 20.5523 4 20V11H1L11.3273 1.6115C11.7087 1.26475 12.2913 1.26475 12.6727 1.6115L23 11H20V20ZM12 17L15.3588 13.6412C16.2374 12.7625 16.2374 11.3379 15.3588 10.4592C14.4801 9.58056 13.0555 9.58056 12.1768 10.4592L12 10.636L11.8232 10.4592C10.9445 9.58056 9.51992 9.58056 8.64124 10.4592C7.76256 11.3379 7.76256 12.7625 8.64124 13.6412L12 17Z"
  }));
},
    Ko = function Ko(_ref1066) {
  var _ref1066$color = _ref1066.color,
      C = _ref1066$color === void 0 ? "currentColor" : _ref1066$color,
      _ref1066$size = _ref1066.size,
      e = _ref1066$size === void 0 ? 24 : _ref1066$size,
      l = _ref1066.className,
      i = _objectWithoutProperties(_ref1066, _excluded1066);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 20C20 20.5523 19.5523 21 19 21H5C4.44772 21 4 20.5523 4 20V11H1L11.3273 1.6115C11.7087 1.26475 12.2913 1.26475 12.6727 1.6115L23 11H20V20ZM18 19V9.15745L12 3.7029L6 9.15745V19H18ZM12 17L8.64124 13.6412C7.76256 12.7625 7.76256 11.3379 8.64124 10.4592C9.51992 9.58056 10.9445 9.58056 11.8232 10.4592L12 10.636L12.1768 10.4592C13.0555 9.58056 14.4801 9.58056 15.3588 10.4592C16.2374 11.3379 16.2374 12.7625 15.3588 13.6412L12 17Z"
  }));
},
    Qo = function Qo(_ref1067) {
  var _ref1067$color = _ref1067.color,
      C = _ref1067$color === void 0 ? "currentColor" : _ref1067$color,
      _ref1067$size = _ref1067.size,
      e = _ref1067$size === void 0 ? 24 : _ref1067$size,
      l = _ref1067.className,
      i = _objectWithoutProperties(_ref1067, _excluded1067);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V9.48907C3 9.18048 3.14247 8.88917 3.38606 8.69972L11.3861 2.47749C11.7472 2.19663 12.2528 2.19663 12.6139 2.47749L20.6139 8.69972C20.8575 8.88917 21 9.18048 21 9.48907V20ZM19 19V9.97815L12 4.53371L5 9.97815V19H19Z"
  }));
},
    qo = function qo(_ref1068) {
  var _ref1068$color = _ref1068.color,
      C = _ref1068$color === void 0 ? "currentColor" : _ref1068$color,
      _ref1068$size = _ref1068.size,
      e = _ref1068$size === void 0 ? 24 : _ref1068$size,
      l = _ref1068.className,
      i = _objectWithoutProperties(_ref1068, _excluded1068);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V9.31391C3 9.00773 3.14027 8.71843 3.38065 8.52879L11.3807 2.21793C11.7438 1.93142 12.2562 1.93142 12.6193 2.21793L20.6193 8.52879C20.8597 8.71843 21 9.00773 21 9.31391V20ZM7 12C7 14.7614 9.23858 17 12 17C14.7614 17 17 14.7614 17 12H15C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12H7Z"
  }));
},
    jo = function jo(_ref1069) {
  var _ref1069$color = _ref1069.color,
      C = _ref1069$color === void 0 ? "currentColor" : _ref1069$color,
      _ref1069$size = _ref1069.size,
      e = _ref1069$size === void 0 ? 24 : _ref1069$size,
      l = _ref1069.className,
      i = _objectWithoutProperties(_ref1069, _excluded1069);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19 19V9.79875L12 4.27675L5 9.79875V19H19ZM21 20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V9.31391C3 9.00773 3.14027 8.71843 3.38065 8.52879L11.3807 2.21793C11.7438 1.93142 12.2562 1.93142 12.6193 2.21793L20.6193 8.52879C20.8597 8.71843 21 9.00773 21 9.31391V20ZM7 12H9C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12H17C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12Z"
  }));
},
    Xo = function Xo(_ref1070) {
  var _ref1070$color = _ref1070.color,
      C = _ref1070$color === void 0 ? "currentColor" : _ref1070$color,
      _ref1070$size = _ref1070.size,
      e = _ref1070$size === void 0 ? 24 : _ref1070$size,
      l = _ref1070.className,
      i = _objectWithoutProperties(_ref1070, _excluded1070);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 20C20 20.5523 19.5523 21 19 21H5C4.44772 21 4 20.5523 4 20V11L1 11L11.3273 1.6115C11.7087 1.26475 12.2913 1.26475 12.6727 1.6115L23 11L20 11V20ZM7.5 13C7.5 15.4853 9.51472 17.5 12 17.5C14.4853 17.5 16.5 15.4853 16.5 13H14.5C14.5 14.3807 13.3807 15.5 12 15.5C10.6193 15.5 9.5 14.3807 9.5 13H7.5Z"
  }));
},
    Jo = function Jo(_ref1071) {
  var _ref1071$color = _ref1071.color,
      C = _ref1071$color === void 0 ? "currentColor" : _ref1071$color,
      _ref1071$size = _ref1071.size,
      e = _ref1071$size === void 0 ? 24 : _ref1071$size,
      l = _ref1071.className,
      i = _objectWithoutProperties(_ref1071, _excluded1071);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6 19H18V9.15745L12 3.7029L6 9.15745V19ZM19 21H5C4.44772 21 4 20.5523 4 20V11L1 11L11.3273 1.6115C11.7087 1.26475 12.2913 1.26475 12.6727 1.6115L23 11L20 11V20C20 20.5523 19.5523 21 19 21ZM7.5 13H9.5C9.5 14.3807 10.6193 15.5 12 15.5C13.3807 15.5 14.5 14.3807 14.5 13H16.5C16.5 15.4853 14.4853 17.5 12 17.5C9.51472 17.5 7.5 15.4853 7.5 13Z"
  }));
},
    Yo = function Yo(_ref1072) {
  var _ref1072$color = _ref1072.color,
      C = _ref1072$color === void 0 ? "currentColor" : _ref1072$color,
      _ref1072$size = _ref1072.size,
      e = _ref1072$size === void 0 ? 24 : _ref1072$size,
      l = _ref1072.className,
      i = _objectWithoutProperties(_ref1072, _excluded1072);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 20C20 20.5523 19.5523 21 19 21H5C4.44772 21 4 20.5523 4 20V11L1 11L11.3273 1.6115C11.7087 1.26475 12.2913 1.26475 12.6727 1.6115L23 11L20 11V20ZM7 11V13C9.76142 13 12 15.2386 12 18H14C14 14.134 10.866 11 7 11ZM7 15V18H10C10 16.3431 8.65685 15 7 15Z"
  }));
},
    _o = function _o(_ref1073) {
  var _ref1073$color = _ref1073.color,
      C = _ref1073$color === void 0 ? "currentColor" : _ref1073$color,
      _ref1073$size = _ref1073.size,
      e = _ref1073$size === void 0 ? 24 : _ref1073$size,
      l = _ref1073.className,
      i = _objectWithoutProperties(_ref1073, _excluded1073);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6 19H18V9.15745L12 3.7029L6 9.15745V19ZM19 21H5C4.44772 21 4 20.5523 4 20V11L1 11L11.3273 1.6115C11.7087 1.26475 12.2913 1.26475 12.6727 1.6115L23 11L20 11V20C20 20.5523 19.5523 21 19 21ZM8 9.99998C11.866 9.99998 15 13.134 15 17H13C13 14.2386 10.7614 12 8 12V9.99998ZM8 14C9.65685 14 11 15.3431 11 17H8V14Z"
  }));
},
    $o = function $o(_ref1074) {
  var _ref1074$color = _ref1074.color,
      C = _ref1074$color === void 0 ? "currentColor" : _ref1074$color,
      _ref1074$size = _ref1074.size,
      e = _ref1074$size === void 0 ? 24 : _ref1074$size,
      l = _ref1074.className,
      i = _objectWithoutProperties(_ref1074, _excluded1074);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21.1592 4.25759C21.1934 7.75736 21.7504 9.06895 21.947 10.9594C22.248 13.8533 21.2897 16.8534 19.072 19.0711C15.4057 22.7374 9.60078 22.9617 5.67278 19.744L8.52438 16.8913C10.8676 18.561 14.1415 18.3448 16.2436 16.2426C18.346 14.1403 18.562 10.8658 16.8917 8.52257L21.1592 4.25759ZM18.3292 4.25604L15.4776 7.10872C13.1344 5.439 9.86048 5.65522 7.75834 7.75736C5.65619 9.8595 5.43998 13.1334 7.10969 15.4766L2.8428 19.7424C2.80859 16.2426 2.25158 14.931 2.05494 13.0406C1.75392 10.1467 2.71224 7.1466 4.92991 4.92893C8.59624 1.2626 14.4012 1.03831 18.3292 4.25604ZM12.001 8C14.2101 8 16.001 9.79086 16.001 12C16.001 14.2091 14.2101 16 12.001 16C9.79184 16 8.00098 14.2091 8.00098 12C8.00098 9.79086 9.79184 8 12.001 8ZM12.001 10.5C11.1725 10.5 10.501 11.1716 10.501 12C10.501 12.8284 11.1725 13.5 12.001 13.5C12.8294 13.5 13.501 12.8284 13.501 12C13.501 11.1716 12.8294 10.5 12.001 10.5Z"
  }));
},
    ea = function ea(_ref1075) {
  var _ref1075$color = _ref1075.color,
      C = _ref1075$color === void 0 ? "currentColor" : _ref1075$color,
      _ref1075$size = _ref1075.size,
      e = _ref1075$size === void 0 ? 24 : _ref1075$size,
      l = _ref1075.className,
      i = _objectWithoutProperties(_ref1075, _excluded1075);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18.3292 4.25604L16.9062 5.67921C13.7678 3.23734 9.22861 3.45865 6.34412 6.34315C3.97034 8.71692 3.40017 12.2113 4.63361 15.1234L7.0508 12.7061C6.83751 11.2027 7.30906 9.62085 8.46544 8.46447C10.1757 6.75423 12.8166 6.54193 14.7579 7.82757L13.2937 9.2919C12.1787 8.75967 10.8031 8.95526 9.87966 9.87868C8.95624 10.8021 8.76065 12.1777 9.29288 13.2927L2.8428 19.7424C2.80859 16.2426 2.25158 14.931 2.05494 13.0406C1.75392 10.1467 2.71224 7.1466 4.92991 4.92893C8.59624 1.2626 14.4012 1.03831 18.3292 4.25604ZM21.1592 4.25759C21.1934 7.75736 21.7504 9.06895 21.947 10.9594C22.248 13.8533 21.2897 16.8534 19.072 19.0711C15.4057 22.7374 9.60078 22.9617 5.67278 19.744L7.09575 18.3208C10.2342 20.7627 14.7733 20.5413 17.6578 17.6569C20.0316 15.2831 20.6018 11.7887 19.3683 8.87656L16.9512 11.2939C17.1644 12.7973 16.6929 14.3792 15.5365 15.5355C13.8263 17.2458 11.1853 17.4581 9.24404 16.1724L10.7083 14.7081C11.8233 15.2403 13.1989 15.0447 14.1223 14.1213C15.0457 13.1979 15.2413 11.8223 14.7091 10.7073L21.1592 4.25759Z"
  }));
},
    ta = function ta(_ref1076) {
  var _ref1076$color = _ref1076.color,
      C = _ref1076$color === void 0 ? "currentColor" : _ref1076$color,
      _ref1076$size = _ref1076.size,
      e = _ref1076$size === void 0 ? 24 : _ref1076$size,
      l = _ref1076.className,
      i = _objectWithoutProperties(_ref1076, _excluded1076);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 4V18.7215C21 18.9193 20.8833 19.0986 20.7024 19.1787L12 23.0313L3.29759 19.1787C3.11667 19.0986 3 18.9193 3 18.7215V4H1V2H23V4H21ZM8 12V14H16V12H8ZM8 8V10H16V8H8Z"
  }));
},
    Ca = function Ca(_ref1077) {
  var _ref1077$color = _ref1077.color,
      C = _ref1077$color === void 0 ? "currentColor" : _ref1077$color,
      _ref1077$size = _ref1077.size,
      e = _ref1077$size === void 0 ? 24 : _ref1077$size,
      l = _ref1077.className,
      i = _objectWithoutProperties(_ref1077, _excluded1077);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 4V18.7215C21 18.9193 20.8833 19.0986 20.7024 19.1787L12 23.0313L3.29759 19.1787C3.11667 19.0986 3 18.9193 3 18.7215V4H1V2H23V4H21ZM5 4V17.7451L12 20.8441L19 17.7451V4H5ZM8 8H16V10H8V8ZM8 12H16V14H8V12Z"
  }));
},
    la = function la(_ref1078) {
  var _ref1078$color = _ref1078.color,
      C = _ref1078$color === void 0 ? "currentColor" : _ref1078$color,
      _ref1078$size = _ref1078.size,
      e = _ref1078$size === void 0 ? 24 : _ref1078$size,
      l = _ref1078.className,
      i = _objectWithoutProperties(_ref1078, _excluded1078);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 20H23V22H1V20H3V3C3 2.44772 3.44772 2 4 2H20C20.5523 2 21 2.44772 21 3V20ZM11 8H9V10H11V12H13V10H15V8H13V6H11V8ZM14 20H16V14H8V20H10V16H14V20Z"
  }));
},
    ia = function ia(_ref1079) {
  var _ref1079$color = _ref1079.color,
      C = _ref1079$color === void 0 ? "currentColor" : _ref1079$color,
      _ref1079$size = _ref1079.size,
      e = _ref1079$size === void 0 ? 24 : _ref1079$size,
      l = _ref1079.className,
      i = _objectWithoutProperties(_ref1079, _excluded1079);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8 20V14H16V20H19V4H5V20H8ZM10 20H14V16H10V20ZM21 20H23V22H1V20H3V3C3 2.44772 3.44772 2 4 2H20C20.5523 2 21 2.44772 21 3V20ZM11 8V6H13V8H15V10H13V12H11V10H9V8H11Z"
  }));
},
    sa = function sa(_ref1080) {
  var _ref1080$color = _ref1080.color,
      C = _ref1080$color === void 0 ? "currentColor" : _ref1080$color,
      _ref1080$size = _ref1080.size,
      e = _ref1080$size === void 0 ? 24 : _ref1080$size,
      l = _ref1080.className,
      i = _objectWithoutProperties(_ref1080, _excluded1080);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22 11V20H20V17H4V20H2V4H4V14H12V7H18C20.2091 7 22 8.79086 22 11ZM8 13C6.34315 13 5 11.6569 5 10C5 8.34315 6.34315 7 8 7C9.65685 7 11 8.34315 11 10C11 11.6569 9.65685 13 8 13Z"
  }));
},
    ra = function ra(_ref1081) {
  var _ref1081$color = _ref1081.color,
      C = _ref1081$color === void 0 ? "currentColor" : _ref1081$color,
      _ref1081$size = _ref1081.size,
      e = _ref1081$size === void 0 ? 24 : _ref1081$size,
      l = _ref1081.className,
      i = _objectWithoutProperties(_ref1081, _excluded1081);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22 11V20H20V17H4V20H2V4H4V14H12V7H18C20.2091 7 22 8.79086 22 11ZM20 14V11C20 9.89543 19.1046 9 18 9H14V14H20ZM8 11C8.55228 11 9 10.5523 9 10C9 9.44772 8.55228 9 8 9C7.44772 9 7 9.44772 7 10C7 10.5523 7.44772 11 8 11ZM8 13C6.34315 13 5 11.6569 5 10C5 8.34315 6.34315 7 8 7C9.65685 7 11 8.34315 11 10C11 11.6569 9.65685 13 8 13Z"
  }));
},
    ca = function ca(_ref1082) {
  var _ref1082$color = _ref1082.color,
      C = _ref1082$color === void 0 ? "currentColor" : _ref1082$color,
      _ref1082$size = _ref1082.size,
      e = _ref1082$size === void 0 ? 24 : _ref1082$size,
      l = _ref1082.className,
      i = _objectWithoutProperties(_ref1082, _excluded1082);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17 19H19V11H13V19H15V13H17V19ZM3 19V4C3 3.44772 3.44772 3 4 3H18C18.5523 3 19 3.44772 19 4V9H21V19H22V21H2V19H3ZM7 11V13H9V11H7ZM7 15V17H9V15H7ZM7 7V9H9V7H7Z"
  }));
},
    oa = function oa(_ref1083) {
  var _ref1083$color = _ref1083.color,
      C = _ref1083$color === void 0 ? "currentColor" : _ref1083$color,
      _ref1083$size = _ref1083.size,
      e = _ref1083$size === void 0 ? 24 : _ref1083$size,
      l = _ref1083.className,
      i = _objectWithoutProperties(_ref1083, _excluded1083);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22 21H2V19H3V4C3 3.44772 3.44772 3 4 3H18C18.5523 3 19 3.44772 19 4V9H21V19H22V21ZM17 19H19V11H13V19H15V13H17V19ZM17 9V5H5V19H11V9H17ZM7 11H9V13H7V11ZM7 15H9V17H7V15ZM7 7H9V9H7V7Z"
  }));
},
    aa = function aa(_ref1084) {
  var _ref1084$color = _ref1084.color,
      C = _ref1084$color === void 0 ? "currentColor" : _ref1084$color,
      _ref1084$size = _ref1084.size,
      e = _ref1084$size === void 0 ? 24 : _ref1084$size,
      l = _ref1084.className,
      i = _objectWithoutProperties(_ref1084, _excluded1084);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11 2V11H18V21C18 21.5523 17.5523 22 17 22H5C4.44772 22 4 21.5523 4 21V3C4 2.44772 4.44772 2 5 2H11ZM13 7C14.1046 7 15 7.89543 15 9H13V7ZM13 4C15.7614 4 18 6.23858 18 9H16C16 7.34315 14.6569 6 13 6V4ZM13 1C17.4183 1 21 4.58172 21 9H19C19 5.68629 16.3137 3 13 3V1Z"
  }));
},
    na = function na(_ref1085) {
  var _ref1085$color = _ref1085.color,
      C = _ref1085$color === void 0 ? "currentColor" : _ref1085$color,
      _ref1085$size = _ref1085.size,
      e = _ref1085$size === void 0 ? 24 : _ref1085$size,
      l = _ref1085.className,
      i = _objectWithoutProperties(_ref1085, _excluded1085);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11 2V4H7V20H17V11H19V21C19 21.5523 18.5523 22 18 22H6C5.44772 22 5 21.5523 5 21V3C5 2.44772 5.44772 2 6 2H11ZM13 7C14.1046 7 15 7.89543 15 9H13V7ZM13 4C15.7614 4 18 6.23858 18 9H16C16 7.34315 14.6569 6 13 6V4ZM13 1C17.4183 1 21 4.58172 21 9H19C19 5.68629 16.3137 3 13 3V1Z"
  }));
},
    ma = function ma(_ref1086) {
  var _ref1086$color = _ref1086.color,
      C = _ref1086$color === void 0 ? "currentColor" : _ref1086$color,
      _ref1086$size = _ref1086.size,
      e = _ref1086$size === void 0 ? 24 : _ref1086$size,
      l = _ref1086.className,
      i = _objectWithoutProperties(_ref1086, _excluded1086);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM7.5 11.25V9H6V15H7.5V12.75H9.5V15H11V9H9.5V11.25H7.5ZM16.25 15H17C17.5523 15 18 14.5523 18 14V10C18 9.44772 17.5523 9 17 9H14C13.4477 9 13 9.44772 13 10V14C13 14.5523 13.4477 15 14 15H14.75V16.5H16.25V15ZM14.5 10.5H16.5V13.5H14.5V10.5Z"
  }));
},
    wa = function wa(_ref1087) {
  var _ref1087$color = _ref1087.color,
      C = _ref1087$color === void 0 ? "currentColor" : _ref1087$color,
      _ref1087$size = _ref1087.size,
      e = _ref1087$size === void 0 ? 24 : _ref1087$size,
      l = _ref1087.className,
      i = _objectWithoutProperties(_ref1087, _excluded1087);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 5V19H20V5H4ZM3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM7.5 11.25H9.5V9H11V15H9.5V12.75H7.5V15H6V9H7.5V11.25ZM16.25 15V16.5H14.75V15H14C13.4477 15 13 14.5523 13 14V10C13 9.44772 13.4477 9 14 9H17C17.5523 9 18 9.44772 18 10V14C18 14.5523 17.5523 15 17 15H16.25ZM14.5 10.5V13.5H16.5V10.5H14.5Z"
  }));
},
    La = function La(_ref1088) {
  var _ref1088$color = _ref1088.color,
      C = _ref1088$color === void 0 ? "currentColor" : _ref1088$color,
      _ref1088$size = _ref1088.size,
      e = _ref1088$size === void 0 ? 24 : _ref1088$size,
      l = _ref1088.className,
      i = _objectWithoutProperties(_ref1088, _excluded1088);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 18.1778L16.6192 16.9222L17.2434 10.1444H9.02648L8.82219 7.88889H17.4477L17.6747 5.67778H6.32535L6.96091 12.3556H14.7806L14.5195 15.2222L12 15.8889L9.48045 15.2222L9.32156 13.3778H7.0517L7.38083 16.9222L12 18.1778ZM3 2H21L19.377 20L12 22L4.62295 20L3 2Z"
  }));
},
    ha = function ha(_ref1089) {
  var _ref1089$color = _ref1089.color,
      C = _ref1089$color === void 0 ? "currentColor" : _ref1089$color,
      _ref1089$size = _ref1089.size,
      e = _ref1089$size === void 0 ? 24 : _ref1089$size,
      l = _ref1089.className,
      i = _objectWithoutProperties(_ref1089, _excluded1089);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 18.1778L7.38083 16.9222L7.0517 13.3778H9.32156L9.48045 15.2222L12 15.8889L14.5195 15.2222L14.7806 12.3556H6.96091L6.32535 5.67778H17.6747L17.4477 7.88889H8.82219L9.02648 10.1444H17.2434L16.6192 16.9222L12 18.1778ZM3 2H21L19.377 20L12 22L4.62295 20L3 2ZM5.18844 4L6.48986 18.4339L12 19.9278L17.5101 18.4339L18.8116 4H5.18844Z"
  }));
},
    Ha = function Ha(_ref1090) {
  var _ref1090$color = _ref1090.color,
      C = _ref1090$color === void 0 ? "currentColor" : _ref1090$color,
      _ref1090$size = _ref1090.size,
      e = _ref1090$size === void 0 ? 24 : _ref1090$size,
      l = _ref1090.className,
      i = _objectWithoutProperties(_ref1090, _excluded1090);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8.61295 20.1193C5.86915 21.6102 3.50024 21.9188 2.1909 20.6106C0.847101 19.2694 1.56267 15.7588 3.50394 12.2367C4.4519 10.5168 5.69213 8.79409 7.12757 7.31987C7.31507 7.13266 8.25257 6.19657 8.31507 6.19657C8.31507 6.19657 7.81507 6.5086 7.75257 6.5086C5.80254 7.60383 4.09018 9.58895 3.71617 10.0345C3.77393 9.77522 3.84289 9.52012 3.92249 9.26978C5.07865 5.63404 8.48217 3.00008 12.5009 3.00008C12.7308 3.00008 12.9586 3.0087 13.1842 3.02563C16.2787 1.62287 19.158 1.29938 20.3759 2.51465C21.5009 3.63795 21.4384 5.51011 20.5009 7.75671C20.4918 7.77847 20.4828 7.79991 20.4739 7.82104C21.1298 9.06983 21.5009 10.4916 21.5009 12.0001C21.5009 12.3794 21.4774 12.7531 21.4319 13.1201H20.6274C20.5763 13.1219 20.529 13.1227 20.4855 13.1227H8.69007V13.31C8.75173 15.3069 10.5017 17.0543 12.6267 17.0543C14.1267 17.0543 15.5642 16.243 16.1892 15.0573H20.9683C20.9608 15.0783 20.953 15.0992 20.9451 15.1201C19.6766 18.5528 16.3746 21.0001 12.5009 21.0001C11.1084 21.0001 9.7898 20.6839 8.61295 20.1193ZM8.00613 19.7991C6.1803 18.7445 4.75932 17.0672 4.03351 15.0575C2.87291 17.3392 2.57399 19.2474 3.56507 20.237C4.37757 21.0491 6.00257 20.861 8.00257 19.801L8.00613 19.7991ZM20.1728 7.29218C20.178 7.28091 20.1832 7.26962 20.1884 7.2583C20.9384 5.63576 21.0009 4.26367 20.3134 3.4524C19.4442 2.58451 17.7732 2.70192 15.7906 3.62029C17.6193 4.33877 19.1559 5.63857 20.1728 7.29218ZM16.5642 10.753V10.6906C16.4392 8.63122 14.8142 7.07108 12.8142 7.07108C10.6892 7.07108 8.87757 8.75603 8.75257 10.6906V10.753H16.5642Z"
  }));
},
    Va = function Va(_ref1091) {
  var _ref1091$color = _ref1091.color,
      C = _ref1091$color === void 0 ? "currentColor" : _ref1091$color,
      _ref1091$size = _ref1091.size,
      e = _ref1091$size === void 0 ? 24 : _ref1091$size,
      l = _ref1091.className,
      i = _objectWithoutProperties(_ref1091, _excluded1091);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18.1595 10.0001C17.3358 7.6697 15.1133 6.00008 12.5009 6.00008C9.88846 6.00008 7.66598 7.6697 6.84231 10.0001H18.1595ZM6.58385 13.0001C7.05993 15.8378 9.5279 18.0001 12.5009 18.0001C14.698 18.0001 16.6193 16.8191 17.6647 15.0573H20.9683C20.9608 15.0783 20.953 15.0992 20.9451 15.1201C19.6766 18.5528 16.3746 21.0001 12.5009 21.0001C11.1084 21.0001 9.7898 20.6839 8.61295 20.1193C5.86915 21.6102 3.50024 21.9188 2.1909 20.6106C0.847101 19.2694 1.56267 15.7588 3.50394 12.2367C4.19428 10.9842 5.03962 9.7302 6.00247 8.57179C6.36179 8.13949 6.73747 7.72051 7.12757 7.31987C6.85302 7.37539 5.24718 8.17147 3.71617 10.0345C3.77393 9.77522 3.84289 9.52012 3.92249 9.26978C5.07865 5.63404 8.48217 3.00008 12.5009 3.00008C12.7308 3.00008 12.9586 3.0087 13.1842 3.02563C16.2787 1.62287 19.158 1.29938 20.3759 2.51465C21.5009 3.63795 21.4384 5.51011 20.5009 7.75671C20.4918 7.77847 20.4828 7.79991 20.4739 7.82104C21.1298 9.06983 21.5009 10.4916 21.5009 12.0001C21.5009 12.3381 21.4823 12.6718 21.446 13.0001H18.4179H6.58385ZM8.00613 19.7991C6.1803 18.7445 4.75932 17.0672 4.03351 15.0575C2.87291 17.3392 2.57399 19.2474 3.56507 20.237C4.37757 21.0491 6.00257 20.861 8.00257 19.801L8.00613 19.7991ZM20.1728 7.29218C20.178 7.28091 20.1832 7.26962 20.1884 7.2583C20.9384 5.63576 21.0009 4.26367 20.3134 3.4524C19.4442 2.58451 17.7732 2.70192 15.7906 3.62029C17.6193 4.33877 19.1559 5.63857 20.1728 7.29218Z"
  }));
},
    ga = function ga(_ref1092) {
  var _ref1092$color = _ref1092.color,
      C = _ref1092$color === void 0 ? "currentColor" : _ref1092$color,
      _ref1092$size = _ref1092.size,
      e = _ref1092$size === void 0 ? 24 : _ref1092$size,
      l = _ref1092.className,
      i = _objectWithoutProperties(_ref1092, _excluded1092);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5 11.1005L7 9.1005L12.5 14.6005L16 11.1005L19 14.1005V5H5V11.1005ZM4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM15.5 10C14.6716 10 14 9.32843 14 8.5C14 7.67157 14.6716 7 15.5 7C16.3284 7 17 7.67157 17 8.5C17 9.32843 16.3284 10 15.5 10Z"
  }));
},
    Ma = function Ma(_ref1093) {
  var _ref1093$color = _ref1093.color,
      C = _ref1093$color === void 0 ? "currentColor" : _ref1093$color,
      _ref1093$size = _ref1093.size,
      e = _ref1093$size === void 0 ? 24 : _ref1093$size,
      l = _ref1093.className,
      i = _objectWithoutProperties(_ref1093, _excluded1093);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5 11.1005L7 9.1005L12.5 14.6005L16 11.1005L19 14.1005V5H5V11.1005ZM5 13.9289V19H8.1005L11.0858 16.0147L7 11.9289L5 13.9289ZM10.9289 19H19V16.9289L16 13.9289L10.9289 19ZM4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM15.5 10C14.6716 10 14 9.32843 14 8.5C14 7.67157 14.6716 7 15.5 7C16.3284 7 17 7.67157 17 8.5C17 9.32843 16.3284 10 15.5 10Z"
  }));
},
    Za = function Za(_ref1094) {
  var _ref1094$color = _ref1094.color,
      C = _ref1094$color === void 0 ? "currentColor" : _ref1094$color,
      _ref1094$size = _ref1094.size,
      e = _ref1094$size === void 0 ? 24 : _ref1094$size,
      l = _ref1094.className,
      i = _objectWithoutProperties(_ref1094, _excluded1094);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 15V18H24V20H21V23H19V20H16V18H19V15H21ZM21.0082 3C21.556 3 22 3.44495 22 3.9934L22.0007 13.3417C21.3749 13.1204 20.7015 13 20 13V5H4L4.001 19L13.2929 9.70715C13.6528 9.34604 14.22 9.31823 14.6123 9.62322L14.7065 9.70772L18.2521 13.2586C15.791 14.0069 14 16.2943 14 19C14 19.7015 14.1204 20.3749 14.3417 21.0007L2.9918 21C2.44405 21 2 20.5551 2 20.0066V3.9934C2 3.44476 2.45531 3 2.9918 3H21.0082ZM8 7C9.10457 7 10 7.89543 10 9C10 10.1046 9.10457 11 8 11C6.89543 11 6 10.1046 6 9C6 7.89543 6.89543 7 8 7Z"
  }));
},
    xa = function xa(_ref1095) {
  var _ref1095$color = _ref1095.color,
      C = _ref1095$color === void 0 ? "currentColor" : _ref1095$color,
      _ref1095$size = _ref1095.size,
      e = _ref1095$size === void 0 ? 24 : _ref1095$size,
      l = _ref1095.className,
      i = _objectWithoutProperties(_ref1095, _excluded1095);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 15V18H24V20H21V23H19V20H16V18H19V15H21ZM21.0082 3C21.556 3 22 3.44495 22 3.9934V13H20V5H4V18.999L14 9L17 12V14.829L14 11.8284L6.827 19H14V21H2.9918C2.44405 21 2 20.5551 2 20.0066V3.9934C2 3.44476 2.45531 3 2.9918 3H21.0082ZM8 7C9.10457 7 10 7.89543 10 9C10 10.1046 9.10457 11 8 11C6.89543 11 6 10.1046 6 9C6 7.89543 6.89543 7 8 7Z"
  }));
},
    va = function va(_ref1096) {
  var _ref1096$color = _ref1096.color,
      C = _ref1096$color === void 0 ? "currentColor" : _ref1096$color,
      _ref1096$size = _ref1096.size,
      e = _ref1096$size === void 0 ? 24 : _ref1096$size,
      l = _ref1096.className,
      i = _objectWithoutProperties(_ref1096, _excluded1096);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 3C20.5523 3 21 3.44772 21 4V5.757L19 7.757V5H5V13.1L9 9.1005L13.328 13.429L12.0012 14.7562L11.995 18.995L16.2414 19.0012L17.571 17.671L18.8995 19H19V16.242L21 14.242V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3H20ZM21.7782 7.80761L23.1924 9.22183L15.4142 17L13.9979 16.9979L14 15.5858L21.7782 7.80761ZM15.5 7C16.3284 7 17 7.67157 17 8.5C17 9.32843 16.3284 10 15.5 10C14.6716 10 14 9.32843 14 8.5C14 7.67157 14.6716 7 15.5 7Z"
  }));
},
    da = function da(_ref1097) {
  var _ref1097$color = _ref1097.color,
      C = _ref1097$color === void 0 ? "currentColor" : _ref1097$color,
      _ref1097$size = _ref1097.size,
      e = _ref1097$size === void 0 ? 24 : _ref1097$size,
      l = _ref1097.className,
      i = _objectWithoutProperties(_ref1097, _excluded1097);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 3C20.5523 3 21 3.44772 21 4V5.757L19 7.757V5H5V13.1L9 9.1005L13.328 13.429L11.9132 14.8422L9 11.9289L5 15.928V19H15.533L16.2414 19.0012L17.57 17.671L18.8995 19H19V16.242L21 14.242V20C21 20.5523 20.5523 21 20 21H4C3.45 21 3 20.55 3 20V4C3 3.44772 3.44772 3 4 3H20ZM21.7782 7.80761L23.1924 9.22183L15.4142 17L13.9979 16.9979L14 15.5858L21.7782 7.80761ZM15.5 7C16.3284 7 17 7.67157 17 8.5C17 9.32843 16.3284 10 15.5 10C14.6716 10 14 9.32843 14 8.5C14 7.67157 14.6716 7 15.5 7Z"
  }));
},
    pa = function pa(_ref1098) {
  var _ref1098$color = _ref1098.color,
      C = _ref1098$color === void 0 ? "currentColor" : _ref1098$color,
      _ref1098$size = _ref1098.size,
      e = _ref1098$size === void 0 ? 24 : _ref1098$size,
      l = _ref1098.className,
      i = _objectWithoutProperties(_ref1098, _excluded1098);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 5H4V19L13.2923 9.70649C13.6828 9.31595 14.3159 9.31591 14.7065 9.70641L20 15.0104V5ZM2 3.9934C2 3.44476 2.45531 3 2.9918 3H21.0082C21.556 3 22 3.44495 22 3.9934V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5551 2 20.0066V3.9934ZM8 11C6.89543 11 6 10.1046 6 9C6 7.89543 6.89543 7 8 7C9.10457 7 10 7.89543 10 9C10 10.1046 9.10457 11 8 11Z"
  }));
},
    Ea = function Ea(_ref1099) {
  var _ref1099$color = _ref1099.color,
      C = _ref1099$color === void 0 ? "currentColor" : _ref1099$color,
      _ref1099$size = _ref1099.size,
      e = _ref1099$size === void 0 ? 24 : _ref1099$size,
      l = _ref1099.className,
      i = _objectWithoutProperties(_ref1099, _excluded1099);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2.9918 21C2.44405 21 2 20.5551 2 20.0066V3.9934C2 3.44476 2.45531 3 2.9918 3H21.0082C21.556 3 22 3.44495 22 3.9934V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918ZM20 15V5H4V19L14 9L20 15ZM20 17.8284L14 11.8284L6.82843 19H20V17.8284ZM8 11C6.89543 11 6 10.1046 6 9C6 7.89543 6.89543 7 8 7C9.10457 7 10 7.89543 10 9C10 10.1046 9.10457 11 8 11Z"
  }));
},
    Na = function Na(_ref1100) {
  var _ref1100$color = _ref1100.color,
      C = _ref1100$color === void 0 ? "currentColor" : _ref1100$color,
      _ref1100$size = _ref1100.size,
      e = _ref1100$size === void 0 ? 24 : _ref1100$size,
      l = _ref1100.className,
      i = _objectWithoutProperties(_ref1100, _excluded1100);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 3H20L22 7V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V7.00353L4 3ZM13 14V10H11V14H8L12 18L16 14H13ZM19.7639 7L18.7639 5H5.23656L4.23744 7H19.7639Z"
  }));
},
    ua = function ua(_ref1101) {
  var _ref1101$color = _ref1101.color,
      C = _ref1101$color === void 0 ? "currentColor" : _ref1101$color,
      _ref1101$size = _ref1101.size,
      e = _ref1101$size === void 0 ? 24 : _ref1101$size,
      l = _ref1101.className,
      i = _objectWithoutProperties(_ref1101, _excluded1101);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 3L22 7V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V7.00353L4 3H20ZM20 9H4V19H20V9ZM13 10V14H16L12 18L8 14H11V10H13ZM18.7639 5H5.23656L4.23744 7H19.7639L18.7639 5Z"
  }));
},
    Ba = function Ba(_ref1102) {
  var _ref1102$color = _ref1102.color,
      C = _ref1102$color === void 0 ? "currentColor" : _ref1102$color,
      _ref1102$size = _ref1102.size,
      e = _ref1102$size === void 0 ? 24 : _ref1102$size,
      l = _ref1102.className,
      i = _objectWithoutProperties(_ref1102, _excluded1102);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM9 12C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12H20V5H4V12H9Z"
  }));
},
    fa = function fa(_ref1103) {
  var _ref1103$color = _ref1103.color,
      C = _ref1103$color === void 0 ? "currentColor" : _ref1103$color,
      _ref1103$size = _ref1103.size,
      e = _ref1103$size === void 0 ? 24 : _ref1103$size,
      l = _ref1103.className,
      i = _objectWithoutProperties(_ref1103, _excluded1103);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 3C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21ZM7.41604 14H4V19H20V14H16.584C15.8124 15.7659 14.0503 17 12 17C9.94968 17 8.1876 15.7659 7.41604 14ZM20 5H4V12H9C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12H20V5Z"
  }));
},
    Ra = function Ra(_ref1104) {
  var _ref1104$color = _ref1104.color,
      C = _ref1104$color === void 0 ? "currentColor" : _ref1104$color,
      _ref1104$size = _ref1104.size,
      e = _ref1104$size === void 0 ? 24 : _ref1104$size,
      l = _ref1104.className,
      i = _objectWithoutProperties(_ref1104, _excluded1104);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 3L22 7V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V7.00353L4 3H20ZM12 10L8 14H11V18H13V14H16L12 10ZM18.764 5H5.236L4.237 7H19.764L18.764 5Z"
  }));
},
    za = function za(_ref1105) {
  var _ref1105$color = _ref1105.color,
      C = _ref1105$color === void 0 ? "currentColor" : _ref1105$color,
      _ref1105$size = _ref1105.size,
      e = _ref1105$size === void 0 ? 24 : _ref1105$size,
      l = _ref1105.className,
      i = _objectWithoutProperties(_ref1105, _excluded1105);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 3L22 7V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V7.00353L4 3H20ZM20 9H4V19H20V9ZM12 10L16 14H13V18H11V14H8L12 10ZM18.764 5H5.236L4.237 7H19.764L18.764 5Z"
  }));
},
    Fa = function Fa(_ref1106) {
  var _ref1106$color = _ref1106.color,
      C = _ref1106$color === void 0 ? "currentColor" : _ref1106$color,
      _ref1106$size = _ref1106.size,
      e = _ref1106$size === void 0 ? 24 : _ref1106$size,
      l = _ref1106.className,
      i = _objectWithoutProperties(_ref1106, _excluded1106);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3.00488 3.00275H21.0049C21.5572 3.00275 22.0049 3.45046 22.0049 4.00275V20.0027C22.0049 20.555 21.5572 21.0027 21.0049 21.0027H3.00488C2.4526 21.0027 2.00488 20.555 2.00488 20.0027V4.00275C2.00488 3.45046 2.4526 3.00275 3.00488 3.00275ZM9.00488 11.0027V9.00275H7.00488V11.0027H5.00488V13.0027H7.00488V15.0027H9.00488V13.0027H11.0049V11.0027H9.00488ZM13.0049 11.0027V13.0027H19.0049V11.0027H13.0049Z"
  }));
},
    Sa = function Sa(_ref1107) {
  var _ref1107$color = _ref1107.color,
      C = _ref1107$color === void 0 ? "currentColor" : _ref1107$color,
      _ref1107$size = _ref1107.size,
      e = _ref1107$size === void 0 ? 24 : _ref1107$size,
      l = _ref1107.className,
      i = _objectWithoutProperties(_ref1107, _excluded1107);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3.00488 3.00275H21.0049C21.5572 3.00275 22.0049 3.45046 22.0049 4.00275V20.0027C22.0049 20.555 21.5572 21.0027 21.0049 21.0027H3.00488C2.4526 21.0027 2.00488 20.555 2.00488 20.0027V4.00275C2.00488 3.45046 2.4526 3.00275 3.00488 3.00275ZM4.00488 5.00275V19.0027H20.0049V5.00275H4.00488ZM9.00488 11.0027H11.0049V13.0027H9.00488V15.0027H7.00488V13.0027H5.00488V11.0027H7.00488V9.00275H9.00488V11.0027ZM13.0049 11.0027H19.0049V13.0027H13.0049V11.0027Z"
  }));
},
    Aa = function Aa(_ref1108) {
  var _ref1108$color = _ref1108.color,
      C = _ref1108$color === void 0 ? "currentColor" : _ref1108$color,
      _ref1108$size = _ref1108.size,
      e = _ref1108$size === void 0 ? 24 : _ref1108$size,
      l = _ref1108.className,
      i = _objectWithoutProperties(_ref1108, _excluded1108);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 4H21V6H3V4ZM3 19H21V21H3V19ZM11 14H21V16H11V14ZM11 9H21V11H11V9ZM3 12.5L7 9V16L3 12.5Z"
  }));
},
    ka = function ka(_ref1109) {
  var _ref1109$color = _ref1109.color,
      C = _ref1109$color === void 0 ? "currentColor" : _ref1109$color,
      _ref1109$size = _ref1109.size,
      e = _ref1109$size === void 0 ? 24 : _ref1109$size,
      l = _ref1109.className,
      i = _objectWithoutProperties(_ref1109, _excluded1109);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 4H21V6H3V4ZM3 19H21V21H3V19ZM11 14H21V16H11V14ZM11 9H21V11H11V9ZM7 12.5L3 16V9L7 12.5Z"
  }));
},
    Pa = function Pa(_ref1110) {
  var _ref1110$color = _ref1110.color,
      C = _ref1110$color === void 0 ? "currentColor" : _ref1110$color,
      _ref1110$size = _ref1110.size,
      e = _ref1110$size === void 0 ? 24 : _ref1110$size,
      l = _ref1110.className,
      i = _objectWithoutProperties(_ref1110, _excluded1110);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM7 11V13H17V11H7Z"
  }));
},
    Da = function Da(_ref1111) {
  var _ref1111$color = _ref1111.color,
      C = _ref1111$color === void 0 ? "currentColor" : _ref1111$color,
      _ref1111$size = _ref1111.size,
      e = _ref1111$size === void 0 ? 24 : _ref1111$size,
      l = _ref1111.className,
      i = _objectWithoutProperties(_ref1111, _excluded1111);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM7 11H17V13H7V11Z"
  }));
},
    ya = function ya(_ref1112) {
  var _ref1112$color = _ref1112.color,
      C = _ref1112$color === void 0 ? "currentColor" : _ref1112$color,
      _ref1112$size = _ref1112.size,
      e = _ref1112$size === void 0 ? 24 : _ref1112$size,
      l = _ref1112.className,
      i = _objectWithoutProperties(_ref1112, _excluded1112);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM11 11V17H13V11H11ZM11 7V9H13V7H11Z"
  }));
},
    ba = function ba(_ref1113) {
  var _ref1113$color = _ref1113.color,
      C = _ref1113$color === void 0 ? "currentColor" : _ref1113$color,
      _ref1113$size = _ref1113.size,
      e = _ref1113$size === void 0 ? 24 : _ref1113$size,
      l = _ref1113.className,
      i = _objectWithoutProperties(_ref1113, _excluded1113);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM11 7H13V9H11V7ZM11 11H13V17H11V11Z"
  }));
},
    Ta = function Ta(_ref1114) {
  var _ref1114$color = _ref1114.color,
      C = _ref1114$color === void 0 ? "currentColor" : _ref1114$color,
      _ref1114$size = _ref1114.size,
      e = _ref1114$size === void 0 ? 24 : _ref1114$size,
      l = _ref1114.className,
      i = _objectWithoutProperties(_ref1114, _excluded1114);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 2V11H17.999L18 12C18 14.2091 16.2091 16 14 16H12.621L12.0084 19.1113L12.9192 20.4324C13.2327 20.8871 13.1182 21.5098 12.6635 21.8233C12.4966 21.9384 12.2987 22 12.0959 22H3L5.31286 11.9762L3 11L7 2H21ZM15.999 11H13.6051L13.014 14H14C15.1046 14 16 13.1046 16 12L15.999 11Z"
  }));
},
    Ua = function Ua(_ref1115) {
  var _ref1115$color = _ref1115.color,
      C = _ref1115$color === void 0 ? "currentColor" : _ref1115$color,
      _ref1115$size = _ref1115.size,
      e = _ref1115$size === void 0 ? 24 : _ref1115$size,
      l = _ref1115.className,
      i = _objectWithoutProperties(_ref1115, _excluded1115);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 2V11H17.999L18 12C18 14.2091 16.2091 16 14 16H12.621L12.0084 19.1113L12.9192 20.4324C13.2327 20.8871 13.1182 21.5098 12.6635 21.8233C12.4966 21.9384 12.2987 22 12.0959 22H3L5.31286 11.9762L3 11L7 2H21ZM19 4H8.29975L5.65535 9.9499L7.6397 10.7874L5.51402 20H10.1918L9.88322 19.5524L11.9604 9H19V4ZM15.999 11H13.6051L13.014 14H14C15.1046 14 16 13.1046 16 12L15.999 11Z"
  }));
},
    Ga = function Ga(_ref1116) {
  var _ref1116$color = _ref1116.color,
      C = _ref1116$color === void 0 ? "currentColor" : _ref1116$color,
      _ref1116$size = _ref1116.size,
      e = _ref1116$size === void 0 ? 24 : _ref1116$size,
      l = _ref1116.className,
      i = _objectWithoutProperties(_ref1116, _excluded1116);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16 8.99669L20.3714 10.7452C20.751 10.8971 21 11.2648 21 11.6737V20.9967C21 21.549 20.5523 21.9967 20 21.9967H4C3.44772 21.9967 3 21.549 3 20.9967V11.6737C3 11.2648 3.24895 10.8971 3.62861 10.7452L8 8.99669H16ZM20 13.9967H8V18.9967H20V13.9967ZM16 2.99669C16.5523 2.99669 17 3.4444 17 3.99669V7.99669H7V3.99669C7 3.4444 7.44772 2.99669 8 2.99669H16Z"
  }));
},
    Ia = function Ia(_ref1117) {
  var _ref1117$color = _ref1117.color,
      C = _ref1117$color === void 0 ? "currentColor" : _ref1117$color,
      _ref1117$size = _ref1117.size,
      e = _ref1117$size === void 0 ? 24 : _ref1117$size,
      l = _ref1117.className,
      i = _objectWithoutProperties(_ref1117, _excluded1117);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16 8.99669L20.3714 10.7452C20.751 10.8971 21 11.2648 21 11.6737V20.9967C21 21.549 20.5523 21.9967 20 21.9967H4C3.44772 21.9967 3 21.549 3 20.9967V11.6737C3 11.2648 3.24895 10.8971 3.62861 10.7452L8 8.99669H16ZM15.6148 10.9967H8.38517L5 12.3508V19.9967H19V18.9967H8V13.9967H19V12.3508L15.6148 10.9967ZM16 2.99669C16.5523 2.99669 17 3.4444 17 3.99669V7.99669H7V3.99669C7 3.4444 7.44772 2.99669 8 2.99669H16ZM15 4.99669H9V5.99669H15V4.99669Z"
  }));
},
    Wa = function Wa(_ref1118) {
  var _ref1118$color = _ref1118.color,
      C = _ref1118$color === void 0 ? "currentColor" : _ref1118$color,
      _ref1118$size = _ref1118.size,
      e = _ref1118$size === void 0 ? 24 : _ref1118$size,
      l = _ref1118.className,
      i = _objectWithoutProperties(_ref1118, _excluded1118);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8 21V19H11V5H8V3H16V5H13V19H16V21H8ZM18.0503 7.05025L23 12L18.0503 16.9497L16.636 15.5355L20.1716 12L16.636 8.46447L18.0503 7.05025ZM5.94975 7.05025L7.36396 8.46447L3.82843 12L7.36396 15.5355L5.94975 16.9497L1 12L5.94975 7.05025Z"
  }));
},
    Oa = function Oa(_ref1119) {
  var _ref1119$color = _ref1119.color,
      C = _ref1119$color === void 0 ? "currentColor" : _ref1119$color,
      _ref1119$size = _ref1119.size,
      e = _ref1119$size === void 0 ? 24 : _ref1119$size,
      l = _ref1119.className,
      i = _objectWithoutProperties(_ref1119, _excluded1119);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM9.86885 15H14.1311L14.9508 17H17.1667L13 7H11L6.83333 17H9.04918L9.86885 15ZM10.6885 13L12 9.8L13.3115 13H10.6885Z"
  }));
},
    Ka = function Ka(_ref1120) {
  var _ref1120$color = _ref1120.color,
      C = _ref1120$color === void 0 ? "currentColor" : _ref1120$color,
      _ref1120$size = _ref1120.size,
      e = _ref1120$size === void 0 ? 24 : _ref1120$size,
      l = _ref1120.className,
      i = _objectWithoutProperties(_ref1120, _excluded1120);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5 5V19H19V5H5ZM4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM9.86885 15L9.04918 17H6.83333L11 7H13L17.1667 17H14.9508L14.1311 15H9.86885ZM10.6885 13H13.3115L12 9.8L10.6885 13Z"
  }));
},
    Qa = function Qa(_ref1121) {
  var _ref1121$color = _ref1121.color,
      C = _ref1121$color === void 0 ? "currentColor" : _ref1121$color,
      _ref1121$size = _ref1121.size,
      e = _ref1121$size === void 0 ? 24 : _ref1121$size,
      l = _ref1121.className,
      i = _objectWithoutProperties(_ref1121, _excluded1121);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 3C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H14C13.4477 21 13 20.5523 13 20V4C13 3.44772 13.4477 3 14 3H20ZM19 5H15V19H19V5ZM6 7C8.76142 7 11 9.23858 11 12C11 14.7614 8.76142 17 6 17C3.23858 17 1 14.7614 1 12C1 9.23858 3.23858 7 6 7ZM7 9H5V10.999L3 11V13L5 12.999V15H7V12.999L9 13V11L7 10.999V9Z"
  }));
},
    qa = function qa(_ref1122) {
  var _ref1122$color = _ref1122.color,
      C = _ref1122$color === void 0 ? "currentColor" : _ref1122$color,
      _ref1122$size = _ref1122.size,
      e = _ref1122$size === void 0 ? 24 : _ref1122$size,
      l = _ref1122.className,
      i = _objectWithoutProperties(_ref1122, _excluded1122);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10 3C10.5523 3 11 3.44772 11 4V20C11 20.5523 10.5523 21 10 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3H10ZM9 5H5V19H9V5ZM18 7C20.7614 7 23 9.23858 23 12C23 14.7614 20.7614 17 18 17C15.2386 17 13 14.7614 13 12C13 9.23858 15.2386 7 18 7ZM19 9H17V10.999L15 11V13L17 12.999V15H19V12.999L21 13V11L19 10.999V9Z"
  }));
},
    ja = function ja(_ref1123) {
  var _ref1123$color = _ref1123.color,
      C = _ref1123$color === void 0 ? "currentColor" : _ref1123$color,
      _ref1123$size = _ref1123.size,
      e = _ref1123$size === void 0 ? 24 : _ref1123$size,
      l = _ref1123.className,
      i = _objectWithoutProperties(_ref1123, _excluded1123);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 13C14.7614 13 17 15.2386 17 18C17 20.7614 14.7614 23 12 23C9.23858 23 7 20.7614 7 18C7 15.2386 9.23858 13 12 13ZM13 15H11V16.999L9 17V19L11 18.999V21H13V18.999L15 19V17L13 16.999V15ZM20 3C20.5523 3 21 3.44772 21 4V10C21 10.5523 20.5523 11 20 11H4C3.44772 11 3 10.5523 3 10V4C3 3.44772 3.44772 3 4 3H20ZM5 5V9H19V5H5Z"
  }));
},
    Xa = function Xa(_ref1124) {
  var _ref1124$color = _ref1124.color,
      C = _ref1124$color === void 0 ? "currentColor" : _ref1124$color,
      _ref1124$size = _ref1124.size,
      e = _ref1124$size === void 0 ? 24 : _ref1124$size,
      l = _ref1124.className,
      i = _objectWithoutProperties(_ref1124, _excluded1124);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 13C20.5523 13 21 13.4477 21 14V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V14C3 13.4477 3.44772 13 4 13H20ZM19 15H5V19H19V15ZM12 1C14.7614 1 17 3.23858 17 6C17 8.76142 14.7614 11 12 11C9.23858 11 7 8.76142 7 6C7 3.23858 9.23858 1 12 1ZM13 3H11V4.999L9 5V7L11 6.999V9H13V6.999L15 7V5L13 4.999V3Z"
  }));
},
    Ja = function Ja(_ref1125) {
  var _ref1125$color = _ref1125.color,
      C = _ref1125$color === void 0 ? "currentColor" : _ref1125$color,
      _ref1125$size = _ref1125.size,
      e = _ref1125$size === void 0 ? 24 : _ref1125$size,
      l = _ref1125.className,
      i = _objectWithoutProperties(_ref1125, _excluded1125);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13.0281 2.00073C14.1535 2.00259 14.7238 2.00855 15.2166 2.02322L15.4107 2.02956C15.6349 2.03753 15.8561 2.04753 16.1228 2.06003C17.1869 2.1092 17.9128 2.27753 18.5503 2.52503C19.2094 2.7792 19.7661 3.12253 20.3219 3.67837C20.8769 4.2342 21.2203 4.79253 21.4753 5.45003C21.7219 6.0867 21.8903 6.81337 21.9403 7.87753C21.9522 8.1442 21.9618 8.3654 21.9697 8.58964L21.976 8.78373C21.9906 9.27647 21.9973 9.84686 21.9994 10.9723L22.0002 11.7179C22.0003 11.809 22.0003 11.903 22.0003 12L22.0002 12.2821L21.9996 13.0278C21.9977 14.1532 21.9918 14.7236 21.9771 15.2163L21.9707 15.4104C21.9628 15.6347 21.9528 15.8559 21.9403 16.1225C21.8911 17.1867 21.7219 17.9125 21.4753 18.55C21.2211 19.2092 20.8769 19.7659 20.3219 20.3217C19.7661 20.8767 19.2069 21.22 18.5503 21.475C17.9128 21.7217 17.1869 21.89 16.1228 21.94C15.8561 21.9519 15.6349 21.9616 15.4107 21.9694L15.2166 21.9757C14.7238 21.9904 14.1535 21.997 13.0281 21.9992L12.2824 22C12.1913 22 12.0973 22 12.0003 22L11.7182 22L10.9725 21.9993C9.8471 21.9975 9.27672 21.9915 8.78397 21.9768L8.58989 21.9705C8.36564 21.9625 8.14444 21.9525 7.87778 21.94C6.81361 21.8909 6.08861 21.7217 5.45028 21.475C4.79194 21.2209 4.23444 20.8767 3.67861 20.3217C3.12278 19.7659 2.78028 19.2067 2.52528 18.55C2.27778 17.9125 2.11028 17.1867 2.06028 16.1225C2.0484 15.8559 2.03871 15.6347 2.03086 15.4104L2.02457 15.2163C2.00994 14.7236 2.00327 14.1532 2.00111 13.0278L2.00098 10.9723C2.00284 9.84686 2.00879 9.27647 2.02346 8.78373L2.02981 8.58964C2.03778 8.3654 2.04778 8.1442 2.06028 7.87753C2.10944 6.81253 2.27778 6.08753 2.52528 5.45003C2.77944 4.7917 3.12278 4.2342 3.67861 3.67837C4.23444 3.12253 4.79278 2.78003 5.45028 2.52503C6.08778 2.27753 6.81278 2.11003 7.87778 2.06003C8.14444 2.04816 8.36564 2.03847 8.58989 2.03062L8.78397 2.02433C9.27672 2.00969 9.8471 2.00302 10.9725 2.00086L13.0281 2.00073ZM12.0003 7.00003C9.23738 7.00003 7.00028 9.23956 7.00028 12C7.00028 14.7629 9.23981 17 12.0003 17C14.7632 17 17.0003 14.7605 17.0003 12C17.0003 9.23713 14.7607 7.00003 12.0003 7.00003ZM12.0003 9.00003C13.6572 9.00003 15.0003 10.3427 15.0003 12C15.0003 13.6569 13.6576 15 12.0003 15C10.3434 15 9.00028 13.6574 9.00028 12C9.00028 10.3431 10.3429 9.00003 12.0003 9.00003ZM17.2503 5.50003C16.561 5.50003 16.0003 6.05994 16.0003 6.74918C16.0003 7.43843 16.5602 7.9992 17.2503 7.9992C17.9395 7.9992 18.5003 7.4393 18.5003 6.74918C18.5003 6.05994 17.9386 5.49917 17.2503 5.50003Z"
  }));
},
    Ya = function Ya(_ref1126) {
  var _ref1126$color = _ref1126.color,
      C = _ref1126$color === void 0 ? "currentColor" : _ref1126$color,
      _ref1126$size = _ref1126.size,
      e = _ref1126$size === void 0 ? 24 : _ref1126$size,
      l = _ref1126.className,
      i = _objectWithoutProperties(_ref1126, _excluded1126);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.001 9C10.3436 9 9.00098 10.3431 9.00098 12C9.00098 13.6573 10.3441 15 12.001 15C13.6583 15 15.001 13.6569 15.001 12C15.001 10.3427 13.6579 9 12.001 9ZM12.001 7C14.7614 7 17.001 9.2371 17.001 12C17.001 14.7605 14.7639 17 12.001 17C9.24051 17 7.00098 14.7629 7.00098 12C7.00098 9.23953 9.23808 7 12.001 7ZM18.501 6.74915C18.501 7.43926 17.9402 7.99917 17.251 7.99917C16.5609 7.99917 16.001 7.4384 16.001 6.74915C16.001 6.0599 16.5617 5.5 17.251 5.5C17.9393 5.49913 18.501 6.0599 18.501 6.74915ZM12.001 4C9.5265 4 9.12318 4.00655 7.97227 4.0578C7.18815 4.09461 6.66253 4.20007 6.17416 4.38967C5.74016 4.55799 5.42709 4.75898 5.09352 5.09255C4.75867 5.4274 4.55804 5.73963 4.3904 6.17383C4.20036 6.66332 4.09493 7.18811 4.05878 7.97115C4.00703 9.0752 4.00098 9.46105 4.00098 12C4.00098 14.4745 4.00753 14.8778 4.05877 16.0286C4.0956 16.8124 4.2012 17.3388 4.39034 17.826C4.5591 18.2606 4.7605 18.5744 5.09246 18.9064C5.42863 19.2421 5.74179 19.4434 6.17187 19.6094C6.66619 19.8005 7.19148 19.9061 7.97212 19.9422C9.07618 19.9939 9.46203 20 12.001 20C14.4755 20 14.8788 19.9934 16.0296 19.9422C16.8117 19.9055 17.3385 19.7996 17.827 19.6106C18.2604 19.4423 18.5752 19.2402 18.9074 18.9085C19.2436 18.5718 19.4445 18.2594 19.6107 17.8283C19.8013 17.3358 19.9071 16.8098 19.9432 16.0289C19.9949 14.9248 20.001 14.5389 20.001 12C20.001 9.52552 19.9944 9.12221 19.9432 7.97137C19.9064 7.18906 19.8005 6.66149 19.6113 6.17318C19.4434 5.74038 19.2417 5.42635 18.9084 5.09255C18.573 4.75715 18.2616 4.55693 17.8271 4.38942C17.338 4.19954 16.8124 4.09396 16.0298 4.05781C14.9258 4.00605 14.5399 4 12.001 4ZM12.001 2C14.7176 2 15.0568 2.01 16.1235 2.06C17.1876 2.10917 17.9135 2.2775 18.551 2.525C19.2101 2.77917 19.7668 3.1225 20.3226 3.67833C20.8776 4.23417 21.221 4.7925 21.476 5.45C21.7226 6.08667 21.891 6.81333 21.941 7.8775C21.9885 8.94417 22.001 9.28333 22.001 12C22.001 14.7167 21.991 15.0558 21.941 16.1225C21.8918 17.1867 21.7226 17.9125 21.476 18.55C21.2218 19.2092 20.8776 19.7658 20.3226 20.3217C19.7668 20.8767 19.2076 21.22 18.551 21.475C17.9135 21.7217 17.1876 21.89 16.1235 21.94C15.0568 21.9875 14.7176 22 12.001 22C9.28431 22 8.94514 21.99 7.87848 21.94C6.81431 21.8908 6.08931 21.7217 5.45098 21.475C4.79264 21.2208 4.23514 20.8767 3.67931 20.3217C3.12348 19.7658 2.78098 19.2067 2.52598 18.55C2.27848 17.9125 2.11098 17.1867 2.06098 16.1225C2.01348 15.0558 2.00098 14.7167 2.00098 12C2.00098 9.28333 2.01098 8.94417 2.06098 7.8775C2.11014 6.8125 2.27848 6.0875 2.52598 5.45C2.78014 4.79167 3.12348 4.23417 3.67931 3.67833C4.23514 3.1225 4.79348 2.78 5.45098 2.525C6.08848 2.2775 6.81348 2.11 7.87848 2.06C8.94514 2.0125 9.28431 2 12.001 2Z"
  }));
},
    _a = function _a(_ref1127) {
  var _ref1127$color = _ref1127.color,
      C = _ref1127$color === void 0 ? "currentColor" : _ref1127$color,
      _ref1127$size = _ref1127.size,
      e = _ref1127$size === void 0 ? 24 : _ref1127$size,
      l = _ref1127.className,
      i = _objectWithoutProperties(_ref1127, _excluded1127);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11 2V7H8L12 11L16 7H13V2H20C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V3C3 2.44772 3.44772 2 4 2H11ZM19 16H5V20H19V16ZM17 17V19H15V17H17Z"
  }));
},
    $a = function $a(_ref1128) {
  var _ref1128$color = _ref1128.color,
      C = _ref1128$color === void 0 ? "currentColor" : _ref1128$color,
      _ref1128$size = _ref1128.size,
      e = _ref1128$size === void 0 ? 24 : _ref1128$size,
      l = _ref1128.className,
      i = _objectWithoutProperties(_ref1128, _excluded1128);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9 2V4H5L4.999 14H18.999L19 4H15V2H20C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V3C3 2.44772 3.44772 2 4 2H9ZM18.999 16H4.999L5 20H19L18.999 16ZM17 17V19H15V17H17ZM13 2V7H16L12 11L8 7H11V2H13Z"
  }));
},
    en = function en(_ref1129) {
  var _ref1129$color = _ref1129.color,
      C = _ref1129$color === void 0 ? "currentColor" : _ref1129$color,
      _ref1129$size = _ref1129.size,
      e = _ref1129$size === void 0 ? 24 : _ref1129$size,
      l = _ref1129.className,
      i = _objectWithoutProperties(_ref1129, _excluded1129);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4.00098 3H20.001C20.5533 3 21.001 3.44772 21.001 4V20C21.001 20.5523 20.5533 21 20.001 21H4.00098C3.44869 21 3.00098 20.5523 3.00098 20V4C3.00098 3.44772 3.44869 3 4.00098 3ZM6.98859 14.065C6.92833 14.3319 6.89804 14.6202 6.89804 14.8553C6.89804 15.7819 7.38103 16.397 8.40727 16.397C9.25846 16.397 9.94845 15.8711 10.4453 15.022L10.1419 16.2887H11.8321L12.798 12.2578C13.0395 11.2372 13.5073 10.7074 14.2167 10.7074C14.7751 10.7074 15.1222 11.0687 15.1222 11.6652C15.1222 11.838 15.1071 12.0263 15.0468 12.2304L14.5486 14.0832C14.4732 14.3502 14.4431 14.6173 14.4431 14.8683C14.4431 15.7479 14.941 16.3913 15.9824 16.3913C16.8729 16.3913 17.5821 15.7949 17.9746 14.366L17.3106 14.0993C16.9785 15.0566 16.6917 15.2297 16.4654 15.2297C16.239 15.2297 16.1182 15.0727 16.1182 14.7589C16.1182 14.6176 16.1485 14.4607 16.1937 14.2719L16.6767 12.4668C16.7974 12.043 16.8428 11.6671 16.8428 11.3218C16.8428 9.97143 16.0579 9.26673 15.1071 9.26673C14.2167 9.26673 13.3111 10.1023 12.8585 10.9817L13.1904 9.40324H10.6098L10.2475 10.7936H11.4549L10.7114 13.8906C10.1275 15.2409 9.05502 15.2628 8.92043 15.2314C8.69942 15.1796 8.55815 15.0923 8.55815 14.7935C8.55815 14.6211 8.58825 14.3735 8.66372 14.0749L9.79573 9.40324H6.92833L6.56612 10.7936H7.75826L6.98859 14.065ZM8.62598 8.625C9.2473 8.625 9.75098 8.12132 9.75098 7.5C9.75098 6.87868 9.2473 6.375 8.62598 6.375C8.00466 6.375 7.50098 6.87868 7.50098 7.5C7.50098 8.12132 8.00466 8.625 8.62598 8.625Z"
  }));
},
    tn = function tn(_ref1130) {
  var _ref1130$color = _ref1130.color,
      C = _ref1130$color === void 0 ? "currentColor" : _ref1130$color,
      _ref1130$size = _ref1130.size,
      e = _ref1130$size === void 0 ? 24 : _ref1130$size,
      l = _ref1130.className,
      i = _objectWithoutProperties(_ref1130, _excluded1130);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4.00098 3H20.001C20.5533 3 21.001 3.44772 21.001 4V20C21.001 20.5523 20.5533 21 20.001 21H4.00098C3.44869 21 3.00098 20.5523 3.00098 20V4C3.00098 3.44772 3.44869 3 4.00098 3ZM5.00098 5V19H19.001V5H5.00098ZM6.98859 14.065L7.75826 10.7936H6.56612L6.92833 9.40324H9.79573L8.66372 14.0749C8.58825 14.3735 8.55815 14.6211 8.55815 14.7935C8.55815 15.0923 8.69942 15.1796 8.92043 15.2314C9.05502 15.2628 10.1275 15.2409 10.7114 13.8906L11.4549 10.7936H10.2475L10.6098 9.40324H13.1904L12.8585 10.9817C13.3111 10.1023 14.2167 9.26673 15.1071 9.26673C16.0579 9.26673 16.8428 9.97143 16.8428 11.3218C16.8428 11.6671 16.7974 12.043 16.6767 12.4668L16.1937 14.2719C16.1485 14.4607 16.1182 14.6176 16.1182 14.7589C16.1182 15.0727 16.239 15.2297 16.4654 15.2297C16.6917 15.2297 16.9785 15.0566 17.3106 14.0993L17.9746 14.366C17.5821 15.7949 16.8729 16.3913 15.9824 16.3913C14.941 16.3913 14.4431 15.7479 14.4431 14.8683C14.4431 14.6173 14.4732 14.3502 14.5486 14.0832L15.0468 12.2304C15.1071 12.0263 15.1222 11.838 15.1222 11.6652C15.1222 11.0687 14.7751 10.7074 14.2167 10.7074C13.5073 10.7074 13.0395 11.2372 12.798 12.2578L11.8321 16.2887H10.1419L10.4453 15.022C9.94845 15.8711 9.25846 16.397 8.40727 16.397C7.38103 16.397 6.89804 15.7819 6.89804 14.8553C6.89804 14.6202 6.92833 14.3319 6.98859 14.065ZM8.62598 8.625C8.00466 8.625 7.50098 8.12132 7.50098 7.5C7.50098 6.87868 8.00466 6.375 8.62598 6.375C9.2473 6.375 9.75098 6.87868 9.75098 7.5C9.75098 8.12132 9.2473 8.625 8.62598 8.625Z"
  }));
},
    Cn = function Cn(_ref1131) {
  var _ref1131$color = _ref1131.color,
      C = _ref1131$color === void 0 ? "currentColor" : _ref1131$color,
      _ref1131$size = _ref1131.size,
      e = _ref1131$size === void 0 ? 24 : _ref1131$size,
      l = _ref1131.className,
      i = _objectWithoutProperties(_ref1131, _excluded1131);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15 20H7V18H9.92661L12.0425 6H9V4H17V6H14.0734L11.9575 18H15V20Z"
  }));
},
    ln = function ln(_ref1132) {
  var _ref1132$color = _ref1132.color,
      C = _ref1132$color === void 0 ? "currentColor" : _ref1132$color,
      _ref1132$size = _ref1132.size,
      e = _ref1132$size === void 0 ? 24 : _ref1132$size,
      l = _ref1132.className,
      i = _objectWithoutProperties(_ref1132, _excluded1132);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.0009 3C17.7999 3 22.501 6.66445 22.501 11.1847C22.501 15.705 17.7999 19.3694 12.0009 19.3694C11.4127 19.3694 10.8361 19.331 10.2742 19.2586L5.86611 22.1419C5.36471 22.4073 5.18769 22.3778 5.39411 21.7289L6.28571 18.0513C3.40572 16.5919 1.50098 14.0619 1.50098 11.1847C1.50098 6.66445 6.20194 3 12.0009 3ZM17.908 11.0591L19.3783 9.63617C19.5656 9.45485 19.5705 9.15617 19.3893 8.96882C19.2081 8.78172 18.9094 8.77668 18.7219 8.95788L16.7937 10.8239V9.28226C16.7937 9.02172 16.5825 8.81038 16.3218 8.81038C16.0613 8.81038 15.8499 9.02172 15.8499 9.28226V11.8393C15.8321 11.9123 15.8325 11.9879 15.8499 12.0611V13.5C15.8499 13.7606 16.0613 13.9719 16.3218 13.9719C16.5825 13.9719 16.7937 13.7606 16.7937 13.5V12.1373L17.2213 11.7236L18.6491 13.7565C18.741 13.8873 18.8873 13.9573 19.0357 13.9573C19.1295 13.9573 19.2241 13.9293 19.3066 13.8714C19.5199 13.7217 19.5713 13.4273 19.4215 13.214L17.908 11.0591ZM14.9503 12.9839H13.4904V9.29702C13.4904 9.03648 13.2791 8.82514 13.0184 8.82514C12.7579 8.82514 12.5467 9.03648 12.5467 9.29702V13.4557C12.5467 13.7164 12.7579 13.9276 13.0184 13.9276H14.9503C15.211 13.9276 15.4222 13.7164 15.4222 13.4557C15.4222 13.1952 15.211 12.9839 14.9503 12.9839ZM9.09318 11.8925L9.78919 10.1849L10.4265 11.8925H9.09318ZM11.6159 12.3802C11.6161 12.3748 11.6175 12.3699 11.6175 12.3645C11.6175 12.2405 11.5687 12.1287 11.4906 12.0445L10.4452 9.24376C10.3468 8.9639 10.1005 8.77815 9.81761 8.77028C9.53948 8.76277 9.28066 8.93672 9.16453 9.21669L7.50348 13.2924C7.40519 13.5337 7.52107 13.8092 7.76242 13.9076C8.00378 14.006 8.2792 13.89 8.37749 13.6486L8.70852 12.8364H10.7787L11.077 13.6356C11.1479 13.8254 11.3278 13.9426 11.5193 13.9425C11.5741 13.9425 11.6298 13.9329 11.6842 13.9126C11.9284 13.8216 12.0524 13.5497 11.9612 13.3054L11.6159 12.3802ZM8.29446 9.30194C8.29446 9.0414 8.08312 8.83006 7.82258 8.83006H4.57822C4.31755 8.83006 4.10622 9.0414 4.10622 9.30194C4.10622 9.56249 4.31755 9.77382 4.57822 9.77382H5.73824V13.5099C5.73824 13.7705 5.94957 13.9817 6.21012 13.9817C6.47078 13.9817 6.68212 13.7705 6.68212 13.5099V9.77382H7.82258C8.08312 9.77382 8.29446 9.56249 8.29446 9.30194Z"
  }));
},
    sn = function sn(_ref1133) {
  var _ref1133$color = _ref1133.color,
      C = _ref1133$color === void 0 ? "currentColor" : _ref1133$color,
      _ref1133$size = _ref1133.size,
      e = _ref1133$size === void 0 ? 24 : _ref1133$size,
      l = _ref1133.className,
      i = _objectWithoutProperties(_ref1133, _excluded1133);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5.67859 18.123C3.09315 16.5658 1.50098 14.112 1.50098 11.4052C1.50098 6.70096 6.24882 3 12.0009 3C17.753 3 22.501 6.70097 22.501 11.4052C22.501 16.1094 17.753 19.8104 12.0009 19.8104C11.5591 19.8104 11.1195 19.7883 10.6834 19.7446L6.91829 22.2026C6.3026 22.5286 5.96085 22.6281 5.4334 22.2685C4.8127 21.8453 4.83666 21.3768 5.05149 20.7096L5.67859 18.123ZM3.50098 11.4052C3.50098 13.5368 4.91871 15.5282 7.28204 16.7258L7.98846 17.0838L7.80187 17.8535L7.40093 19.5022L10.2003 17.6711L10.5665 17.7183C11.04 17.7794 11.5188 17.8104 12.0009 17.8104C16.7422 17.8104 20.501 14.8805 20.501 11.4052C20.501 7.92993 16.7422 5 12.0009 5C7.25967 5 3.50098 7.92991 3.50098 11.4052ZM17.908 11.0591L19.4215 13.214C19.5713 13.4273 19.5199 13.7217 19.3066 13.8714C19.2241 13.9293 19.1295 13.9573 19.0357 13.9573C18.8873 13.9573 18.741 13.8873 18.6491 13.7565L17.2213 11.7236L16.7937 12.1373V13.5C16.7937 13.7606 16.5825 13.9719 16.3218 13.9719C16.0613 13.9719 15.8499 13.7606 15.8499 13.5V12.0611C15.8325 11.9879 15.8321 11.9123 15.8499 11.8393V9.28226C15.8499 9.02172 16.0613 8.81038 16.3218 8.81038C16.5825 8.81038 16.7937 9.02172 16.7937 9.28226V10.8239L18.7219 8.95788C18.9094 8.77668 19.2081 8.78172 19.3893 8.96882C19.5705 9.15617 19.5656 9.45485 19.3783 9.63617L17.908 11.0591ZM14.9503 12.9839C15.211 12.9839 15.4222 13.1952 15.4222 13.4557C15.4222 13.7164 15.211 13.9276 14.9503 13.9276H13.0184C12.7579 13.9276 12.5467 13.7164 12.5467 13.4557V9.29702C12.5467 9.03648 12.7579 8.82514 13.0184 8.82514C13.2791 8.82514 13.4904 9.03648 13.4904 9.29702V12.9839H14.9503ZM9.09318 11.8925H10.4265L9.78919 10.1849L9.09318 11.8925ZM11.6159 12.3802L11.9612 13.3054C12.0524 13.5497 11.9284 13.8216 11.6842 13.9126C11.6298 13.9329 11.5741 13.9425 11.5193 13.9425C11.3278 13.9426 11.1479 13.8254 11.077 13.6356L10.7787 12.8364H8.70852L8.37749 13.6486C8.2792 13.89 8.00378 14.006 7.76242 13.9076C7.52107 13.8092 7.40519 13.5337 7.50348 13.2924L9.16453 9.21669C9.28066 8.93672 9.53948 8.76277 9.81761 8.77028C10.1005 8.77815 10.3468 8.9639 10.4452 9.24376L11.4906 12.0445C11.5687 12.1287 11.6175 12.2405 11.6175 12.3645C11.6175 12.3699 11.6161 12.3748 11.6159 12.3802ZM8.29446 9.30194C8.29446 9.56249 8.08312 9.77382 7.82258 9.77382H6.68212V13.5099C6.68212 13.7705 6.47078 13.9817 6.21012 13.9817C5.94957 13.9817 5.73824 13.7705 5.73824 13.5099V9.77382H4.57822C4.31755 9.77382 4.10622 9.56249 4.10622 9.30194C4.10622 9.0414 4.31755 8.83006 4.57822 8.83006H7.82258C8.08312 8.83006 8.29446 9.0414 8.29446 9.30194Z"
  }));
},
    rn = function rn(_ref1134) {
  var _ref1134$color = _ref1134.color,
      C = _ref1134$color === void 0 ? "currentColor" : _ref1134$color,
      _ref1134$size = _ref1134.size,
      e = _ref1134$size === void 0 ? 24 : _ref1134$size,
      l = _ref1134.className,
      i = _objectWithoutProperties(_ref1134, _excluded1134);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10.313 11.5656L18.253 3.62561L20.3744 5.74693L18.9602 7.16114L21.0815 9.28246L17.5459 12.818L15.4246 10.6967L12.4343 13.687C13.4182 15.5719 13.1186 17.9524 11.5355 19.5355C9.58291 21.4881 6.41709 21.4881 4.46447 19.5355C2.51184 17.5829 2.51184 14.4171 4.46447 12.4644C6.04755 10.8814 8.42809 10.5818 10.313 11.5656ZM9.41421 17.4142C10.1953 16.6331 10.1953 15.3668 9.41421 14.5858C8.63316 13.8047 7.36684 13.8047 6.58579 14.5858C5.80474 15.3668 5.80474 16.6331 6.58579 17.4142C7.36684 18.1952 8.63316 18.1952 9.41421 17.4142Z"
  }));
},
    cn = function cn(_ref1135) {
  var _ref1135$color = _ref1135.color,
      C = _ref1135$color === void 0 ? "currentColor" : _ref1135$color,
      _ref1135$size = _ref1135.size,
      e = _ref1135$size === void 0 ? 24 : _ref1135$size,
      l = _ref1135.className,
      i = _objectWithoutProperties(_ref1135, _excluded1135);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10.7577 11.8281L18.6066 3.97919L20.0208 5.3934L18.6066 6.80761L21.0815 9.28249L19.6673 10.6967L17.1924 8.22183L15.7782 9.63604L17.8995 11.7574L16.4853 13.1716L14.364 11.0503L12.1719 13.2423C13.4581 15.1837 13.246 17.8251 11.5355 19.5355C9.58291 21.4882 6.41709 21.4882 4.46447 19.5355C2.51184 17.5829 2.51184 14.4171 4.46447 12.4645C6.17493 10.754 8.81633 10.5419 10.7577 11.8281ZM10.1213 18.1213C11.2929 16.9497 11.2929 15.0503 10.1213 13.8787C8.94975 12.7071 7.05025 12.7071 5.87868 13.8787C4.70711 15.0503 4.70711 16.9497 5.87868 18.1213C7.05025 19.2929 8.94975 19.2929 10.1213 18.1213Z"
  }));
},
    on = function on(_ref1136) {
  var _ref1136$color = _ref1136.color,
      C = _ref1136$color === void 0 ? "currentColor" : _ref1136$color,
      _ref1136$size = _ref1136.size,
      e = _ref1136$size === void 0 ? 24 : _ref1136$size,
      l = _ref1136.className,
      i = _objectWithoutProperties(_ref1136, _excluded1136);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17 14H12.6586C11.8349 16.3304 9.61244 18 7 18C3.68629 18 1 15.3137 1 12C1 8.68629 3.68629 6 7 6C9.61244 6 11.8349 7.66962 12.6586 10H23V14H21V18H17V14ZM7 14C8.10457 14 9 13.1046 9 12C9 10.8954 8.10457 10 7 10C5.89543 10 5 10.8954 5 12C5 13.1046 5.89543 14 7 14Z"
  }));
},
    an = function an(_ref1137) {
  var _ref1137$color = _ref1137.color,
      C = _ref1137$color === void 0 ? "currentColor" : _ref1137$color,
      _ref1137$size = _ref1137.size,
      e = _ref1137$size === void 0 ? 24 : _ref1137$size,
      l = _ref1137.className,
      i = _objectWithoutProperties(_ref1137, _excluded1137);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.917 13C12.441 15.8377 9.973 18 7 18C3.68629 18 1 15.3137 1 12C1 8.68629 3.68629 6 7 6C9.973 6 12.441 8.16229 12.917 11H23V13H21V17H19V13H17V17H15V13H12.917ZM7 16C9.20914 16 11 14.2091 11 12C11 9.79086 9.20914 8 7 8C4.79086 8 3 9.79086 3 12C3 14.2091 4.79086 16 7 16Z"
  }));
},
    nn = function nn(_ref1138) {
  var _ref1138$color = _ref1138.color,
      C = _ref1138$color === void 0 ? "currentColor" : _ref1138$color,
      _ref1138$size = _ref1138.size,
      e = _ref1138$size === void 0 ? 24 : _ref1138$size,
      l = _ref1138.className,
      i = _objectWithoutProperties(_ref1138, _excluded1138);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM5 7V9H7V7H5ZM5 11V13H7V11H5ZM5 15V17H19V15H5ZM9 11V13H11V11H9ZM9 7V9H11V7H9ZM13 7V9H15V7H13ZM17 7V9H19V7H17ZM13 11V13H15V11H13ZM17 11V13H19V11H17Z"
  }));
},
    mn = function mn(_ref1139) {
  var _ref1139$color = _ref1139.color,
      C = _ref1139$color === void 0 ? "currentColor" : _ref1139$color,
      _ref1139$size = _ref1139.size,
      e = _ref1139$size === void 0 ? 24 : _ref1139$size,
      l = _ref1139.className,
      i = _objectWithoutProperties(_ref1139, _excluded1139);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 5V19H20V5H4ZM3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM6 7H8V9H6V7ZM6 11H8V13H6V11ZM6 15H18V17H6V15ZM11 11H13V13H11V11ZM11 7H13V9H11V7ZM16 7H18V9H16V7ZM16 11H18V13H16V11Z"
  }));
},
    wn = function wn(_ref1140) {
  var _ref1140$color = _ref1140.color,
      C = _ref1140$color === void 0 ? "currentColor" : _ref1140$color,
      _ref1140$size = _ref1140.size,
      e = _ref1140$size === void 0 ? 24 : _ref1140$size,
      l = _ref1140.className,
      i = _objectWithoutProperties(_ref1140, _excluded1140);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 17H21V19H3V17ZM3 11H6V14H3V11ZM8 11H11V14H8V11ZM3 5H6V8H3V5ZM13 5H16V8H13V5ZM18 5H21V8H18V5ZM13 11H16V14H13V11ZM18 11H21V14H18V11ZM8 5H11V8H8V5Z"
  }));
},
    Ln = function Ln(_ref1141) {
  var _ref1141$color = _ref1141.color,
      C = _ref1141$color === void 0 ? "currentColor" : _ref1141$color,
      _ref1141$size = _ref1141.size,
      e = _ref1141$size === void 0 ? 24 : _ref1141$size,
      l = _ref1141.className,
      i = _objectWithoutProperties(_ref1141, _excluded1141);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 17H21V19H3V17ZM3 11H6V14H3V11ZM8 11H11V14H8V11ZM3 5H6V8H3V5ZM13 5H16V8H13V5ZM18 5H21V8H18V5ZM13 11H16V14H13V11ZM18 11H21V14H18V11ZM8 5H11V8H8V5Z"
  }));
},
    hn = function hn(_ref1142) {
  var _ref1142$color = _ref1142.color,
      C = _ref1142$color === void 0 ? "currentColor" : _ref1142$color,
      _ref1142$size = _ref1142.size,
      e = _ref1142$size === void 0 ? 24 : _ref1142$size,
      l = _ref1142.className,
      i = _objectWithoutProperties(_ref1142, _excluded1142);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18.9992 2C19.552 2 20.086 2.42969 20.1955 2.97705L21.8047 11.023C21.9126 11.5626 21.5448 12 21.0083 12H12.9998V20H17.0001V22H7.00006V20H10.9998V12H2.99187C2.44411 12 2.086 11.5703 2.19547 11.023L3.80465 2.97705C3.91258 2.43744 4.4447 2 5.00094 2H18.9992Z"
  }));
},
    Hn = function Hn(_ref1143) {
  var _ref1143$color = _ref1143.color,
      C = _ref1143$color === void 0 ? "currentColor" : _ref1143$color,
      _ref1143$size = _ref1143.size,
      e = _ref1143$size === void 0 ? 24 : _ref1143$size,
      l = _ref1143.className,
      i = _objectWithoutProperties(_ref1143, _excluded1143);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4.43967 10H19.5605L18.3605 4H5.63967L4.43967 10ZM13.0001 12V20H17.0001V22H7.00006V20H11.0001V12H2.99187C2.44411 12 2.086 11.5703 2.19547 11.023L3.80465 2.97705C3.91258 2.43744 4.4447 2 5.00094 2H18.9992C19.552 2 20.086 2.42969 20.1955 2.97705L21.8047 11.023C21.9126 11.5626 21.5448 12 21.0083 12H13.0001Z"
  }));
},
    Vn = function Vn(_ref1144) {
  var _ref1144$color = _ref1144.color,
      C = _ref1144$color === void 0 ? "currentColor" : _ref1144$color,
      _ref1144$size = _ref1144.size,
      e = _ref1144$size === void 0 ? 24 : _ref1144$size,
      l = _ref1144.className,
      i = _objectWithoutProperties(_ref1144, _excluded1144);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4.34315 1.4082L22.3744 19.4394C22.9602 20.0252 22.9602 20.975 22.3744 21.5607C21.7886 22.1465 20.8388 22.1465 20.253 21.5607L15.6569 16.9646L12.1213 20.5001L8.001 16.3792L8.00129 19.0001C8.00129 19.5524 7.55358 20.0001 7.00129 20.0001C6.44901 20.0001 6.00129 19.5524 6.00129 19.0001V15.0001C6.00129 14.4478 5.55358 14.0001 5.00129 14.0001C4.48846 14.0001 4.06578 14.3861 4.00802 14.8835L4.00129 15.0001V16.0001C4.00129 16.5524 3.55358 17.0001 3.00129 17.0001C2.44901 17.0001 2.00129 16.5524 2.00129 16.0001L2.00138 7.21394C1.96402 5.19447 2.68678 3.16356 4.16964 1.58709L4.34315 1.4082Z"
  }));
},
    gn = function gn(_ref1145) {
  var _ref1145$color = _ref1145.color,
      C = _ref1145$color === void 0 ? "currentColor" : _ref1145$color,
      _ref1145$size = _ref1145.size,
      e = _ref1145$size === void 0 ? 24 : _ref1145$size,
      l = _ref1145.className,
      i = _objectWithoutProperties(_ref1145, _excluded1145);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4.34315 1.4082L22.3744 19.4394C22.9602 20.0252 22.9602 20.975 22.3744 21.5607C21.7886 22.1465 20.8388 22.1465 20.253 21.5607L15.6569 16.9646L12.1213 20.5001L8.001 16.3792L8.00129 19.0001C8.00129 19.5524 7.55358 20.0001 7.00129 20.0001C6.44901 20.0001 6.00129 19.5524 6.00129 19.0001V15.0001C6.00129 14.4478 5.55358 14.0001 5.00129 14.0001C4.48846 14.0001 4.06578 14.3861 4.00802 14.8835L4.00129 15.0001V16.0001C4.00129 16.5524 3.55358 17.0001 3.00129 17.0001C2.44901 17.0001 2.00129 16.5524 2.00129 16.0001L2.00138 7.21394C1.96402 5.19447 2.68678 3.16356 4.16964 1.58709L4.34315 1.4082ZM4.58437 4.47838L4.5329 4.58823C4.22968 5.2577 4.05601 5.97117 4.01149 6.69097L4.00129 7.00009L4.00024 7.1196C4.01358 8.55874 4.54144 9.9933 5.58066 11.1234L5.75736 11.3077L12.1207 17.6716L14.9491 14.8431L4.58437 4.47838Z"
  }));
},
    Mn = function Mn(_ref1146) {
  var _ref1146$color = _ref1146.color,
      C = _ref1146$color === void 0 ? "currentColor" : _ref1146$color,
      _ref1146$size = _ref1146.size,
      e = _ref1146$size === void 0 ? 24 : _ref1146$size,
      l = _ref1146.className,
      i = _objectWithoutProperties(_ref1146, _excluded1146);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22.3744 19.4394C22.9602 20.0252 22.9602 20.975 22.3744 21.5607C21.7886 22.1465 20.8388 22.1465 20.253 21.5607L15.6569 16.9646L12.1213 20.5001L4.34315 12.7219C1.2779 9.65666 1.22006 4.72285 4.16964 1.58709L4.34315 1.4082L22.3744 19.4394Z"
  }));
},
    Zn = function Zn(_ref1147) {
  var _ref1147$color = _ref1147.color,
      C = _ref1147$color === void 0 ? "currentColor" : _ref1147$color,
      _ref1147$size = _ref1147.size,
      e = _ref1147$size === void 0 ? 24 : _ref1147$size,
      l = _ref1147.className,
      i = _objectWithoutProperties(_ref1147, _excluded1147);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4.34315 1.4082L22.3744 19.4394C22.9602 20.0252 22.9602 20.975 22.3744 21.5607C21.7886 22.1465 20.8388 22.1465 20.253 21.5607L15.6569 16.9646L12.1213 20.5001L4.34315 12.7219C1.2779 9.65666 1.22006 4.72285 4.16964 1.58709L4.34315 1.4082ZM4.58437 4.47838L4.5329 4.58823C3.56416 6.72709 3.91772 9.315 5.58066 11.1234L5.75736 11.3077L12.1207 17.6716L14.9491 14.8431L4.58437 4.47838Z"
  }));
},
    xn = function xn(_ref1148) {
  var _ref1148$color = _ref1148.color,
      C = _ref1148$color === void 0 ? "currentColor" : _ref1148$color,
      _ref1148$size = _ref1148.size,
      e = _ref1148$size === void 0 ? 24 : _ref1148$size,
      l = _ref1148.className,
      i = _objectWithoutProperties(_ref1148, _excluded1148);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16 21L11.2381 12.2698L15 6L23 21H16ZM8 10L14 21H2L8 10ZM5.5 8C4.11929 8 3 6.88071 3 5.5C3 4.11929 4.11929 3 5.5 3C6.88071 3 8 4.11929 8 5.5C8 6.88071 6.88071 8 5.5 8Z"
  }));
},
    vn = function vn(_ref1149) {
  var _ref1149$color = _ref1149.color,
      C = _ref1149$color === void 0 ? "currentColor" : _ref1149$color,
      _ref1149$size = _ref1149.size,
      e = _ref1149$size === void 0 ? 24 : _ref1149$size,
      l = _ref1149.className,
      i = _objectWithoutProperties(_ref1149, _excluded1149);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11.2703 12.2162L15 6L23 21H2L9 8L11.2703 12.2162ZM12.3897 14.2378L14.9873 19H19.6667L14.8976 10.058L12.3897 14.2378ZM5.34843 19H12.6516L9 12.2185L5.34843 19ZM5.5 8C4.11929 8 3 6.88071 3 5.5C3 4.11929 4.11929 3 5.5 3C6.88071 3 8 4.11929 8 5.5C8 6.88071 6.88071 8 5.5 8Z"
  }));
},
    dn = function dn(_ref1150) {
  var _ref1150$color = _ref1150.color,
      C = _ref1150$color === void 0 ? "currentColor" : _ref1150$color,
      _ref1150$size = _ref1150.size,
      e = _ref1150$size === void 0 ? 24 : _ref1150$size,
      l = _ref1150.className,
      i = _objectWithoutProperties(_ref1150, _excluded1150);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11 3V21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3H11ZM21 13V20C21 20.5523 20.5523 21 20 21H13V13H21ZM20 3C20.5523 3 21 3.44772 21 4V11H13V3H20Z"
  }));
},
    pn = function pn(_ref1151) {
  var _ref1151$color = _ref1151.color,
      C = _ref1151$color === void 0 ? "currentColor" : _ref1151$color,
      _ref1151$size = _ref1151.size,
      e = _ref1151$size === void 0 ? 24 : _ref1151$size,
      l = _ref1151.className,
      i = _objectWithoutProperties(_ref1151, _excluded1151);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3H20C20.5523 3 21 3.44772 21 4V20ZM11 5H5V19H11V5ZM19 13H13V19H19V13ZM19 5H13V11H19V5Z"
  }));
},
    En = function En(_ref1152) {
  var _ref1152$color = _ref1152.color,
      C = _ref1152$color === void 0 ? "currentColor" : _ref1152$color,
      _ref1152$size = _ref1152.size,
      e = _ref1152$size === void 0 ? 24 : _ref1152$size,
      l = _ref1152.className,
      i = _objectWithoutProperties(_ref1152, _excluded1152);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8 10V21H4C3.44772 21 3 20.5523 3 20V10H8ZM21 10V20C21 20.5523 20.5523 21 20 21H10V10H21ZM20 3C20.5523 3 21 3.44772 21 4V8H3V4C3 3.44772 3.44772 3 4 3H20Z"
  }));
},
    Nn = function Nn(_ref1153) {
  var _ref1153$color = _ref1153.color,
      C = _ref1153$color === void 0 ? "currentColor" : _ref1153$color,
      _ref1153$size = _ref1153.size,
      e = _ref1153$size === void 0 ? 24 : _ref1153$size,
      l = _ref1153.className,
      i = _objectWithoutProperties(_ref1153, _excluded1153);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 21C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4ZM8 10H5V19H8V10ZM19 10H10V19H19V10ZM19 5H5V8H19V5Z"
  }));
},
    un = function un(_ref1154) {
  var _ref1154$color = _ref1154.color,
      C = _ref1154$color === void 0 ? "currentColor" : _ref1154$color,
      _ref1154$size = _ref1154.size,
      e = _ref1154$size === void 0 ? 24 : _ref1154$size,
      l = _ref1154.className,
      i = _objectWithoutProperties(_ref1154, _excluded1154);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11 13V21H4C3.44772 21 3 20.5523 3 20V13H11ZM13 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H13V3ZM3 4C3 3.44772 3.44772 3 4 3H11V11H3V4Z"
  }));
},
    Bn = function Bn(_ref1155) {
  var _ref1155$color = _ref1155.color,
      C = _ref1155$color === void 0 ? "currentColor" : _ref1155$color,
      _ref1155$size = _ref1155.size,
      e = _ref1155$size === void 0 ? 24 : _ref1155$size,
      l = _ref1155.className,
      i = _objectWithoutProperties(_ref1155, _excluded1155);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 3C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3H20ZM11 13H5V19H11V13ZM13 19H19V5H13V19ZM11 5H5V11H11V5Z"
  }));
},
    fn = function fn(_ref1156) {
  var _ref1156$color = _ref1156.color,
      C = _ref1156$color === void 0 ? "currentColor" : _ref1156$color,
      _ref1156$size = _ref1156.size,
      e = _ref1156$size === void 0 ? 24 : _ref1156$size,
      l = _ref1156.className,
      i = _objectWithoutProperties(_ref1156, _excluded1156);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7 10V21H3C2.44772 21 2 20.5523 2 20V10H7ZM22 10V20C22 20.5523 21.5523 21 21 21H9V10H22ZM21 3C21.5523 3 22 3.44772 22 4V8H2V4C2 3.44772 2.44772 3 3 3H21Z"
  }));
},
    Rn = function Rn(_ref1157) {
  var _ref1157$color = _ref1157.color,
      C = _ref1157$color === void 0 ? "currentColor" : _ref1157$color,
      _ref1157$size = _ref1157.size,
      e = _ref1157$size === void 0 ? 24 : _ref1157$size,
      l = _ref1157.className,
      i = _objectWithoutProperties(_ref1157, _excluded1157);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 21C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3ZM7 10H4V19H7V10ZM20 10H9V19H20V10ZM20 5H4V8H20V5Z"
  }));
},
    zn = function zn(_ref1158) {
  var _ref1158$color = _ref1158.color,
      C = _ref1158$color === void 0 ? "currentColor" : _ref1158$color,
      _ref1158$size = _ref1158.size,
      e = _ref1158$size === void 0 ? 24 : _ref1158$size,
      l = _ref1158.className,
      i = _objectWithoutProperties(_ref1158, _excluded1158);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15 10V21H3C2.44772 21 2 20.5523 2 20V10H15ZM22 10V20C22 20.5523 21.5523 21 21 21H17V10H22ZM21 3C21.5523 3 22 3.44772 22 4V8H2V4C2 3.44772 2.44772 3 3 3H21Z"
  }));
},
    Fn = function Fn(_ref1159) {
  var _ref1159$color = _ref1159.color,
      C = _ref1159$color === void 0 ? "currentColor" : _ref1159$color,
      _ref1159$size = _ref1159.size,
      e = _ref1159$size === void 0 ? 24 : _ref1159$size,
      l = _ref1159.className,
      i = _objectWithoutProperties(_ref1159, _excluded1159);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 21C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3ZM15 10H4V19H15V10ZM20 10H17V19H20V10ZM20 5H4V8H20V5Z"
  }));
},
    Sn = function Sn(_ref1160) {
  var _ref1160$color = _ref1160.color,
      C = _ref1160$color === void 0 ? "currentColor" : _ref1160$color,
      _ref1160$size = _ref1160.size,
      e = _ref1160$size === void 0 ? 24 : _ref1160$size,
      l = _ref1160.className,
      i = _objectWithoutProperties(_ref1160, _excluded1160);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 3C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21ZM19 16H5V18H19V16Z"
  }));
},
    An = function An(_ref1161) {
  var _ref1161$color = _ref1161.color,
      C = _ref1161$color === void 0 ? "currentColor" : _ref1161$color,
      _ref1161$size = _ref1161.size,
      e = _ref1161$size === void 0 ? 24 : _ref1161$size,
      l = _ref1161.className,
      i = _objectWithoutProperties(_ref1161, _excluded1161);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 3C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21ZM20 5H4V19H20V5ZM18 15V17H6V15H18Z"
  }));
},
    kn = function kn(_ref1162) {
  var _ref1162$color = _ref1162.color,
      C = _ref1162$color === void 0 ? "currentColor" : _ref1162$color,
      _ref1162$size = _ref1162.size,
      e = _ref1162$size === void 0 ? 24 : _ref1162$size,
      l = _ref1162.className,
      i = _objectWithoutProperties(_ref1162, _excluded1162);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22 16V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V16H22ZM21 3C21.5523 3 22 3.44772 22 4V14H2V4C2 3.44772 2.44772 3 3 3H21Z"
  }));
},
    Pn = function Pn(_ref1163) {
  var _ref1163$color = _ref1163.color,
      C = _ref1163$color === void 0 ? "currentColor" : _ref1163$color,
      _ref1163$size = _ref1163.size,
      e = _ref1163$size === void 0 ? 24 : _ref1163$size,
      l = _ref1163.className,
      i = _objectWithoutProperties(_ref1163, _excluded1163);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 3C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21ZM4 16V19H20V16H4ZM4 14H20V5H4V14Z"
  }));
},
    Dn = function Dn(_ref1164) {
  var _ref1164$color = _ref1164.color,
      C = _ref1164$color === void 0 ? "currentColor" : _ref1164$color,
      _ref1164$size = _ref1164.size,
      e = _ref1164$size === void 0 ? 24 : _ref1164$size,
      l = _ref1164.className,
      i = _objectWithoutProperties(_ref1164, _excluded1164);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 5V19H19V5H12ZM4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3Z"
  }));
},
    yn = function yn(_ref1165) {
  var _ref1165$color = _ref1165.color,
      C = _ref1165$color === void 0 ? "currentColor" : _ref1165$color,
      _ref1165$size = _ref1165.size,
      e = _ref1165$size === void 0 ? 24 : _ref1165$size,
      l = _ref1165.className,
      i = _objectWithoutProperties(_ref1165, _excluded1165);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11 5H5V19H11V5ZM13 5V19H19V5H13ZM4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3Z"
  }));
},
    bn = function bn(_ref1166) {
  var _ref1166$color = _ref1166.color,
      C = _ref1166$color === void 0 ? "currentColor" : _ref1166$color,
      _ref1166$size = _ref1166.size,
      e = _ref1166$size === void 0 ? 24 : _ref1166$size,
      l = _ref1166.className,
      i = _objectWithoutProperties(_ref1166, _excluded1166);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16 21V10H21V20C21 20.5523 20.5523 21 20 21H16ZM14 21H4C3.44772 21 3 20.5523 3 20V10H14V21ZM21 8H3V4C3 3.44772 3.44772 3 4 3H20C20.5523 3 21 3.44772 21 4V8Z"
  }));
},
    Tn = function Tn(_ref1167) {
  var _ref1167$color = _ref1167.color,
      C = _ref1167$color === void 0 ? "currentColor" : _ref1167$color,
      _ref1167$size = _ref1167.size,
      e = _ref1167$size === void 0 ? 24 : _ref1167$size,
      l = _ref1167.className,
      i = _objectWithoutProperties(_ref1167, _excluded1167);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22 12.999V20C22 20.5523 21.5523 21 21 21H13V12.999H22ZM11 12.999V21H3C2.44772 21 2 20.5523 2 20V12.999H11ZM11 3V10.999H2V4C2 3.44772 2.44772 3 3 3H11ZM21 3C21.5523 3 22 3.44772 22 4V10.999H13V3H21Z"
  }));
},
    Un = function Un(_ref1168) {
  var _ref1168$color = _ref1168.color,
      C = _ref1168$color === void 0 ? "currentColor" : _ref1168$color,
      _ref1168$size = _ref1168.size,
      e = _ref1168$size === void 0 ? 24 : _ref1168$size,
      l = _ref1168.className,
      i = _objectWithoutProperties(_ref1168, _excluded1168);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 3C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21ZM11 13H4V19H11V13ZM20 13H13V19H20V13ZM11 5H4V11H11V5ZM20 5H13V11H20V5Z"
  }));
},
    Gn = function Gn(_ref1169) {
  var _ref1169$color = _ref1169.color,
      C = _ref1169$color === void 0 ? "currentColor" : _ref1169$color,
      _ref1169$size = _ref1169.size,
      e = _ref1169$size === void 0 ? 24 : _ref1169$size,
      l = _ref1169.className,
      i = _objectWithoutProperties(_ref1169, _excluded1169);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 3C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21ZM7 6H5V18H7V6Z"
  }));
},
    In = function In(_ref1170) {
  var _ref1170$color = _ref1170.color,
      C = _ref1170$color === void 0 ? "currentColor" : _ref1170$color,
      _ref1170$size = _ref1170.size,
      e = _ref1170$size === void 0 ? 24 : _ref1170$size,
      l = _ref1170.className,
      i = _objectWithoutProperties(_ref1170, _excluded1170);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 3C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21ZM20 5H4V19H20V5ZM8 7V17H6V7H8Z"
  }));
},
    Wn = function Wn(_ref1171) {
  var _ref1171$color = _ref1171.color,
      C = _ref1171$color === void 0 ? "currentColor" : _ref1171$color,
      _ref1171$size = _ref1171.size,
      e = _ref1171$size === void 0 ? 24 : _ref1171$size,
      l = _ref1171.className,
      i = _objectWithoutProperties(_ref1171, _excluded1171);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 3C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H9V3H21ZM7 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H7V21Z"
  }));
},
    On = function On(_ref1172) {
  var _ref1172$color = _ref1172.color,
      C = _ref1172$color === void 0 ? "currentColor" : _ref1172$color,
      _ref1172$size = _ref1172.size,
      e = _ref1172$size === void 0 ? 24 : _ref1172$size,
      l = _ref1172.className,
      i = _objectWithoutProperties(_ref1172, _excluded1172);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 3C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21ZM7 5H4V19H7V5ZM20 5H9V19H20V5Z"
  }));
},
    Kn = function Kn(_ref1173) {
  var _ref1173$color = _ref1173.color,
      C = _ref1173$color === void 0 ? "currentColor" : _ref1173$color,
      _ref1173$size = _ref1173.size,
      e = _ref1173$size === void 0 ? 24 : _ref1173$size,
      l = _ref1173.className,
      i = _objectWithoutProperties(_ref1173, _excluded1173);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5 8H19V5H5V8ZM14 19V10H5V19H14ZM16 19H19V10H16V19ZM4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3Z"
  }));
},
    Qn = function Qn(_ref1174) {
  var _ref1174$color = _ref1174.color,
      C = _ref1174$color === void 0 ? "currentColor" : _ref1174$color,
      _ref1174$size = _ref1174.size,
      e = _ref1174$size === void 0 ? 24 : _ref1174$size,
      l = _ref1174.className,
      i = _objectWithoutProperties(_ref1174, _excluded1174);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22 9.999V20C22 20.5523 21.5523 21 21 21H13V9.999H22ZM11 15.999V21H3C2.44772 21 2 20.5523 2 20V15.999H11ZM11 3V13.999H2V4C2 3.44772 2.44772 3 3 3H11ZM21 3C21.5523 3 22 3.44772 22 4V7.999H13V3H21Z"
  }));
},
    qn = function qn(_ref1175) {
  var _ref1175$color = _ref1175.color,
      C = _ref1175$color === void 0 ? "currentColor" : _ref1175$color,
      _ref1175$size = _ref1175.size,
      e = _ref1175$size === void 0 ? 24 : _ref1175$size,
      l = _ref1175.className,
      i = _objectWithoutProperties(_ref1175, _excluded1175);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22 20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V20ZM11 15H4V19H11V15ZM20 11H13V19H20V11ZM11 5H4V13H11V5ZM20 5H13V9H20V5Z"
  }));
},
    jn = function jn(_ref1176) {
  var _ref1176$color = _ref1176.color,
      C = _ref1176$color === void 0 ? "currentColor" : _ref1176$color,
      _ref1176$size = _ref1176.size,
      e = _ref1176$size === void 0 ? 24 : _ref1176$size,
      l = _ref1176.className,
      i = _objectWithoutProperties(_ref1176, _excluded1176);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 3C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21ZM19 6H17V18H19V6Z"
  }));
},
    Xn = function Xn(_ref1177) {
  var _ref1177$color = _ref1177.color,
      C = _ref1177$color === void 0 ? "currentColor" : _ref1177$color,
      _ref1177$size = _ref1177.size,
      e = _ref1177$size === void 0 ? 24 : _ref1177$size,
      l = _ref1177.className,
      i = _objectWithoutProperties(_ref1177, _excluded1177);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 3C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21ZM20 5H4V19H20V5ZM18 7V17H16V7H18Z"
  }));
},
    Jn = function Jn(_ref1178) {
  var _ref1178$color = _ref1178.color,
      C = _ref1178$color === void 0 ? "currentColor" : _ref1178$color,
      _ref1178$size = _ref1178.size,
      e = _ref1178$size === void 0 ? 24 : _ref1178$size,
      l = _ref1178.className,
      i = _objectWithoutProperties(_ref1178, _excluded1178);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 3C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H17V3H21ZM15 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H15V21Z"
  }));
},
    Yn = function Yn(_ref1179) {
  var _ref1179$color = _ref1179.color,
      C = _ref1179$color === void 0 ? "currentColor" : _ref1179$color,
      _ref1179$size = _ref1179.size,
      e = _ref1179$size === void 0 ? 24 : _ref1179$size,
      l = _ref1179.className,
      i = _objectWithoutProperties(_ref1179, _excluded1179);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 3C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21ZM15 5H4V19H15V5ZM20 5H17V19H20V5Z"
  }));
},
    _n = function _n(_ref1180) {
  var _ref1180$color = _ref1180.color,
      C = _ref1180$color === void 0 ? "currentColor" : _ref1180$color,
      _ref1180$size = _ref1180.size,
      e = _ref1180$size === void 0 ? 24 : _ref1180$size,
      l = _ref1180.className,
      i = _objectWithoutProperties(_ref1180, _excluded1180);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19 12H5V19H19V12ZM4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3Z"
  }));
},
    $n = function $n(_ref1181) {
  var _ref1181$color = _ref1181.color,
      C = _ref1181$color === void 0 ? "currentColor" : _ref1181$color,
      _ref1181$size = _ref1181.size,
      e = _ref1181$size === void 0 ? 24 : _ref1181$size,
      l = _ref1181.className,
      i = _objectWithoutProperties(_ref1181, _excluded1181);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19 11V5H5V11H19ZM19 13H5V19H19V13ZM4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3Z"
  }));
},
    em = function em(_ref1182) {
  var _ref1182$color = _ref1182.color,
      C = _ref1182$color === void 0 ? "currentColor" : _ref1182$color,
      _ref1182$size = _ref1182.size,
      e = _ref1182$size === void 0 ? 24 : _ref1182$size,
      l = _ref1182.className,
      i = _objectWithoutProperties(_ref1182, _excluded1182);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 3C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21ZM19 6H5V8H19V6Z"
  }));
},
    tm = function tm(_ref1183) {
  var _ref1183$color = _ref1183.color,
      C = _ref1183$color === void 0 ? "currentColor" : _ref1183$color,
      _ref1183$size = _ref1183.size,
      e = _ref1183$size === void 0 ? 24 : _ref1183$size,
      l = _ref1183.className,
      i = _objectWithoutProperties(_ref1183, _excluded1183);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 3C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21ZM20 5H4V19H20V5ZM18 7V9H6V7H18Z"
  }));
},
    Cm = function Cm(_ref1184) {
  var _ref1184$color = _ref1184.color,
      C = _ref1184$color === void 0 ? "currentColor" : _ref1184$color,
      _ref1184$size = _ref1184.size,
      e = _ref1184$size === void 0 ? 24 : _ref1184$size,
      l = _ref1184.className,
      i = _objectWithoutProperties(_ref1184, _excluded1184);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22 10V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V10H22ZM21 3C21.5523 3 22 3.44772 22 4V8H2V4C2 3.44772 2.44772 3 3 3H21Z"
  }));
},
    lm = function lm(_ref1185) {
  var _ref1185$color = _ref1185.color,
      C = _ref1185$color === void 0 ? "currentColor" : _ref1185$color,
      _ref1185$size = _ref1185.size,
      e = _ref1185$size === void 0 ? 24 : _ref1185$size,
      l = _ref1185.className,
      i = _objectWithoutProperties(_ref1185, _excluded1185);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 3C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21ZM4 10V19H20V10H4ZM4 8H20V5H4V8Z"
  }));
},
    im = function im(_ref1186) {
  var _ref1186$color = _ref1186.color,
      C = _ref1186$color === void 0 ? "currentColor" : _ref1186$color,
      _ref1186$size = _ref1186.size,
      e = _ref1186$size === void 0 ? 24 : _ref1186$size,
      l = _ref1186.className,
      i = _objectWithoutProperties(_ref1186, _excluded1186);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.998 3V5C20.998 14.6274 15.6255 19 8.99805 19L7.0964 18.9999C7.3079 15.9876 8.24541 14.1648 10.6939 11.9989C11.8979 10.9338 11.7965 10.3189 11.2029 10.6721C7.1193 13.1016 5.09114 16.3862 5.00119 21.6302L4.99805 22H2.99805C2.99805 20.6373 3.11376 19.3997 3.34381 18.2682C3.1133 16.9741 2.99805 15.2176 2.99805 13C2.99805 7.47715 7.4752 3 12.998 3C14.998 3 16.998 4 20.998 3Z"
  }));
},
    sm = function sm(_ref1187) {
  var _ref1187$color = _ref1187.color,
      C = _ref1187$color === void 0 ? "currentColor" : _ref1187$color,
      _ref1187$size = _ref1187.size,
      e = _ref1187$size === void 0 ? 24 : _ref1187$size,
      l = _ref1187.className,
      i = _objectWithoutProperties(_ref1187, _excluded1187);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.998 3V5C20.998 14.6274 15.6255 19 8.99805 19L5.24077 18.9999C5.0786 19.912 4.99805 20.907 4.99805 22H2.99805C2.99805 20.6373 3.11376 19.3997 3.34381 18.2682C3.1133 16.9741 2.99805 15.2176 2.99805 13C2.99805 7.47715 7.4752 3 12.998 3C14.998 3 16.998 4 20.998 3ZM12.998 5C8.57977 5 4.99805 8.58172 4.99805 13C4.99805 13.3624 5.00125 13.7111 5.00759 14.0459C6.26198 12.0684 8.09902 10.5048 10.5019 9.13176L11.4942 10.8682C8.6393 12.4996 6.74554 14.3535 5.77329 16.9998L8.99805 17C15.0132 17 18.8692 13.0269 18.9949 5.38766C17.6229 5.52113 16.3481 5.436 14.7754 5.20009C13.6243 5.02742 13.3988 5 12.998 5Z"
  }));
},
    rm = function rm(_ref1188) {
  var _ref1188$color = _ref1188.color,
      C = _ref1188$color === void 0 ? "currentColor" : _ref1188$color,
      _ref1188$size = _ref1188.size,
      e = _ref1188$size === void 0 ? 24 : _ref1188$size,
      l = _ref1188.className,
      i = _objectWithoutProperties(_ref1188, _excluded1188);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM7.19709 14.682L5.02243 16.8555C5.52665 17.5788 6.14045 18.2199 6.83975 18.7549L7.14462 18.9777L9.31803 16.8029C8.51078 16.3512 7.82909 15.7018 7.33848 14.9203L7.19709 14.682ZM16.8029 14.682C16.3512 15.4892 15.7018 16.1709 14.9203 16.6615L14.682 16.8029L16.8555 18.9776C17.5787 18.4734 18.2198 17.8596 18.7549 17.1604L18.9776 16.8555L16.8029 14.682ZM12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8ZM7.14462 5.02232C6.42133 5.52656 5.78012 6.14039 5.24506 6.83973L5.02232 7.14462L7.19709 9.31803C7.64883 8.51078 8.2982 7.82909 9.07969 7.33848L9.31803 7.19709L7.14462 5.02232ZM16.8555 5.02243L14.682 7.19709C15.4892 7.64883 16.1709 8.2982 16.6615 9.07969L16.8029 9.31803L18.9777 7.14462C18.4735 6.42137 17.8597 5.7802 17.1604 5.24516L16.8555 5.02243Z"
  }));
},
    cm = function cm(_ref1189) {
  var _ref1189$color = _ref1189.color,
      C = _ref1189$color === void 0 ? "currentColor" : _ref1189$color,
      _ref1189$size = _ref1189.size,
      e = _ref1189$size === void 0 ? 24 : _ref1189$size,
      l = _ref1189.className,
      i = _objectWithoutProperties(_ref1189, _excluded1189);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 17C11.355 17 10.7386 16.8779 10.1725 16.6555L7.93604 18.8923C9.12707 19.5961 10.5164 20 12 20C13.4836 20 14.8729 19.5961 16.064 18.8923L13.8275 16.6555C13.2614 16.8779 12.645 17 12 17ZM4 12C4 13.4836 4.40386 14.8729 5.10765 16.064L7.34451 13.8275C7.12213 13.2614 7 12.645 7 12C7 11.355 7.12213 10.7386 7.34451 10.1725L5.10765 7.93604C4.40386 9.12707 4 10.5164 4 12ZM18.8923 7.93604L16.6555 10.1725C16.8779 10.7386 17 11.355 17 12C17 12.645 16.8779 13.2614 16.6555 13.8275L18.8923 16.064C19.5961 14.8729 20 13.4836 20 12C20 10.5164 19.5961 9.12707 18.8923 7.93604ZM12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9ZM12 4C10.5164 4 9.12707 4.40386 7.93604 5.10765L10.1725 7.34451C10.7386 7.12213 11.355 7 12 7C12.645 7 13.2614 7.12213 13.8275 7.34451L16.064 5.10765C14.8729 4.40386 13.4836 4 12 4Z"
  }));
},
    om = function om(_ref1190) {
  var _ref1190$color = _ref1190.color,
      C = _ref1190$color === void 0 ? "currentColor" : _ref1190$color,
      _ref1190$size = _ref1190.size,
      e = _ref1190$size === void 0 ? 24 : _ref1190$size,
      l = _ref1190.className,
      i = _objectWithoutProperties(_ref1190, _excluded1190);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11 18H7.94101C7.64391 16.7274 6.30412 15.6857 5.75395 14.9992C4.65645 13.6297 4 11.8915 4 10C4 5.58172 7.58172 2 12 2C16.4183 2 20 5.58172 20 10C20 11.8925 19.3428 13.6315 18.2443 15.0014C17.6944 15.687 16.3558 16.7276 16.059 18H13V13H11V18ZM16 20V21C16 22.1046 15.1046 23 14 23H10C8.89543 23 8 22.1046 8 21V20H16Z"
  }));
},
    am = function am(_ref1191) {
  var _ref1191$color = _ref1191.color,
      C = _ref1191$color === void 0 ? "currentColor" : _ref1191$color,
      _ref1191$size = _ref1191.size,
      e = _ref1191$size === void 0 ? 24 : _ref1191$size,
      l = _ref1191.className,
      i = _objectWithoutProperties(_ref1191, _excluded1191);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7.94101 18C7.64391 16.7274 6.30412 15.6857 5.75395 14.9992C4.65645 13.6297 4 11.8915 4 10C4 5.58172 7.58172 2 12 2C16.4183 2 20 5.58172 20 10C20 11.8925 19.3428 13.6315 18.2443 15.0014C17.6944 15.687 16.3558 16.7276 16.059 18H7.94101ZM16 20V21C16 22.1046 15.1046 23 14 23H10C8.89543 23 8 22.1046 8 21V20H16ZM13 10.0048V6L8.5 12.0048H11V16.0048L15.5 10.0048H13Z"
  }));
},
    nm = function nm(_ref1192) {
  var _ref1192$color = _ref1192.color,
      C = _ref1192$color === void 0 ? "currentColor" : _ref1192$color,
      _ref1192$size = _ref1192.size,
      e = _ref1192$size === void 0 ? 24 : _ref1192$size,
      l = _ref1192.className,
      i = _objectWithoutProperties(_ref1192, _excluded1192);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9.97308 18H14.0269C14.1589 16.7984 14.7721 15.8065 15.7676 14.7226C15.8797 14.6006 16.5988 13.8564 16.6841 13.7501C17.5318 12.6931 18 11.385 18 10C18 6.68629 15.3137 4 12 4C8.68629 4 6 6.68629 6 10C6 11.3843 6.46774 12.6917 7.31462 13.7484C7.40004 13.855 8.12081 14.6012 8.23154 14.7218C9.22766 15.8064 9.84103 16.7984 9.97308 18ZM14 20H10V21H14V20ZM5.75395 14.9992C4.65645 13.6297 4 11.8915 4 10C4 5.58172 7.58172 2 12 2C16.4183 2 20 5.58172 20 10C20 11.8925 19.3428 13.6315 18.2443 15.0014C17.624 15.7748 16 17 16 18.5V21C16 22.1046 15.1046 23 14 23H10C8.89543 23 8 22.1046 8 21V18.5C8 17 6.37458 15.7736 5.75395 14.9992ZM13 10.0048H15.5L11 16.0048V12.0048H8.5L13 6V10.0048Z"
  }));
},
    mm = function mm(_ref1193) {
  var _ref1193$color = _ref1193.color,
      C = _ref1193$color === void 0 ? "currentColor" : _ref1193$color,
      _ref1193$size = _ref1193.size,
      e = _ref1193$size === void 0 ? 24 : _ref1193$size,
      l = _ref1193.className,
      i = _objectWithoutProperties(_ref1193, _excluded1193);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9.97308 18H11V13H13V18H14.0269C14.1589 16.7984 14.7721 15.8065 15.7676 14.7226C15.8797 14.6006 16.5988 13.8564 16.6841 13.7501C17.5318 12.6931 18 11.385 18 10C18 6.68629 15.3137 4 12 4C8.68629 4 6 6.68629 6 10C6 11.3843 6.46774 12.6917 7.31462 13.7484C7.40004 13.855 8.12081 14.6012 8.23154 14.7218C9.22766 15.8064 9.84103 16.7984 9.97308 18ZM10 20V21H14V20H10ZM5.75395 14.9992C4.65645 13.6297 4 11.8915 4 10C4 5.58172 7.58172 2 12 2C16.4183 2 20 5.58172 20 10C20 11.8925 19.3428 13.6315 18.2443 15.0014C17.624 15.7748 16 17 16 18.5V21C16 22.1046 15.1046 23 14 23H10C8.89543 23 8 22.1046 8 21V18.5C8 17 6.37458 15.7736 5.75395 14.9992Z"
  }));
},
    wm = function wm(_ref1194) {
  var _ref1194$color = _ref1194.color,
      C = _ref1194$color === void 0 ? "currentColor" : _ref1194$color,
      _ref1194$size = _ref1194.size,
      e = _ref1194$size === void 0 ? 24 : _ref1194$size,
      l = _ref1194.className,
      i = _objectWithoutProperties(_ref1194, _excluded1194);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5 3V19H21V21H3V3H5ZM19.9393 5.93934L22.0607 8.06066L16 14.1213L13 11.121L9.06066 15.0607L6.93934 12.9393L13 6.87868L16 9.879L19.9393 5.93934Z"
  }));
},
    Lm = function Lm(_ref1195) {
  var _ref1195$color = _ref1195.color,
      C = _ref1195$color === void 0 ? "currentColor" : _ref1195$color,
      _ref1195$size = _ref1195.size,
      e = _ref1195$size === void 0 ? 24 : _ref1195$size,
      l = _ref1195.className,
      i = _objectWithoutProperties(_ref1195, _excluded1195);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5 3V19H21V21H3V3H5ZM20.2929 6.29289L21.7071 7.70711L16 13.4142L13 10.415L8.70711 14.7071L7.29289 13.2929L13 7.58579L16 10.585L20.2929 6.29289Z"
  }));
},
    hm = function hm(_ref1196) {
  var _ref1196$color = _ref1196.color,
      C = _ref1196$color === void 0 ? "currentColor" : _ref1196$color,
      _ref1196$size = _ref1196.size,
      e = _ref1196$size === void 0 ? 24 : _ref1196$size,
      l = _ref1196.className,
      i = _objectWithoutProperties(_ref1196, _excluded1196);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18.6635 10.8404C18.6635 11.1279 18.4293 11.3654 18.1385 11.3654H16.676V12.3029H18.1385C18.4293 12.3029 18.6635 12.5387 18.6635 12.8279C18.6635 13.1145 18.4293 13.352 18.1385 13.352H16.1501C15.8626 13.352 15.6276 13.1145 15.6276 12.8279V8.85202C15.6276 8.56452 15.8626 8.32702 16.1526 8.32702H18.141C18.4293 8.32702 18.6635 8.56452 18.6635 8.85202C18.6635 9.14286 18.4293 9.37702 18.1385 9.37702H16.676V10.3145H18.1385C18.4293 10.3145 18.6635 10.552 18.6635 10.8404ZM14.566 13.3245C14.5126 13.342 14.4551 13.3504 14.4001 13.3504C14.2243 13.3504 14.0743 13.2754 13.9751 13.142L11.9393 10.3779V12.8279C11.9393 13.1145 11.7068 13.352 11.4135 13.352C11.1251 13.352 10.8918 13.1145 10.8918 12.8279V8.85202C10.8918 8.62702 11.036 8.42702 11.2501 8.35619C11.3001 8.33702 11.3635 8.32869 11.4118 8.32869C11.5743 8.32869 11.7243 8.41536 11.8243 8.54036L13.876 11.3154V8.85202C13.876 8.56452 14.111 8.32702 14.401 8.32702C14.6885 8.32702 14.926 8.56452 14.926 8.85202V12.8279C14.926 13.0529 14.781 13.2529 14.566 13.3245ZM9.61598 13.352C9.32848 13.352 9.09348 13.1145 9.09348 12.8279V8.85202C9.09348 8.56452 9.32848 8.32702 9.61848 8.32702C9.90681 8.32702 10.1418 8.56452 10.1418 8.85202V12.8279C10.1418 13.1145 9.90681 13.352 9.61598 13.352ZM8.08681 13.352H6.09848C5.81098 13.352 5.57348 13.1145 5.57348 12.8279V8.85202C5.57348 8.56452 5.81098 8.32702 6.09848 8.32702C6.38848 8.32702 6.62348 8.56452 6.62348 8.85202V12.3029H8.08681C8.37681 12.3029 8.61098 12.5387 8.61098 12.8279C8.61098 13.1145 8.37598 13.352 8.08681 13.352ZM12.001 2.57202C6.48848 2.57202 2.00098 6.21452 2.00098 10.6904C2.00098 14.6995 5.55931 18.0587 10.3635 18.697C10.6893 18.7654 11.1326 18.912 11.2451 19.1887C11.3451 19.4395 11.311 19.827 11.2768 20.0887L11.1401 20.9387C11.1026 21.1895 10.9401 21.927 12.0143 21.4762C13.0901 21.027 17.7776 18.0779 19.8776 15.6637C21.3143 14.0895 22.001 12.477 22.001 10.6904C22.001 6.21452 17.5135 2.57202 12.001 2.57202Z"
  }));
},
    Hm = function Hm(_ref1197) {
  var _ref1197$color = _ref1197.color,
      C = _ref1197$color === void 0 ? "currentColor" : _ref1197$color,
      _ref1197$size = _ref1197.size,
      e = _ref1197$size === void 0 ? 24 : _ref1197$size,
      l = _ref1197.className,
      i = _objectWithoutProperties(_ref1197, _excluded1197);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11 4H21V6H11V4ZM6 7V11H4V7H1L5 3L9 7H6ZM6 17H9L5 21L1 17H4V13H6V17ZM11 18H21V20H11V18ZM9 11H21V13H9V11Z"
  }));
},
    Vm = function Vm(_ref1198) {
  var _ref1198$color = _ref1198.color,
      C = _ref1198$color === void 0 ? "currentColor" : _ref1198$color,
      _ref1198$size = _ref1198.size,
      e = _ref1198$size === void 0 ? 24 : _ref1198$size,
      l = _ref1198.className,
      i = _objectWithoutProperties(_ref1198, _excluded1198);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22.001 10.6904C22.001 12.477 21.3143 14.0895 19.8776 15.6637C17.7776 18.0779 13.0901 21.027 12.0143 21.4762C10.9401 21.927 11.1026 21.1895 11.1401 20.9387L11.2768 20.0887C11.311 19.827 11.3451 19.4395 11.2451 19.1887C11.1326 18.912 10.6893 18.7654 10.3635 18.697C5.55931 18.0587 2.00098 14.6995 2.00098 10.6904C2.00098 6.21452 6.48848 2.57202 12.001 2.57202C17.5135 2.57202 22.001 6.21452 22.001 10.6904ZM18.4004 14.3155C19.514 13.0952 20.001 11.954 20.001 10.6904C20.001 7.42195 16.4903 4.57202 12.001 4.57202C7.51164 4.57202 4.00098 7.42195 4.00098 10.6904C4.00098 13.5953 6.7293 16.1966 10.6269 16.7144L10.774 16.7396C11.8525 16.9658 12.6581 17.3539 13.1029 18.448C13.1158 18.4802 13.1279 18.5121 13.1395 18.5438C14.9449 17.3676 17.313 15.565 18.4004 14.3155ZM18.1385 10.3145C18.4293 10.3145 18.6635 10.552 18.6635 10.8404C18.6635 11.1279 18.4293 11.3654 18.1385 11.3654H16.676V12.3029H18.1385C18.4293 12.3029 18.6635 12.5387 18.6635 12.8279C18.6635 13.1145 18.4293 13.352 18.1385 13.352H16.1501C15.8626 13.352 15.6276 13.1145 15.6276 12.8279V8.85202C15.6276 8.56452 15.8626 8.32702 16.1526 8.32702H18.141C18.4293 8.32702 18.6635 8.56452 18.6635 8.85202C18.6635 9.14286 18.4293 9.37702 18.1385 9.37702H16.676V10.3145H18.1385ZM14.926 12.8279C14.926 13.0529 14.781 13.2529 14.566 13.3245C14.5126 13.342 14.4551 13.3504 14.4001 13.3504C14.2243 13.3504 14.0743 13.2754 13.9751 13.142L11.9393 10.3779V12.8279C11.9393 13.1145 11.7068 13.352 11.4135 13.352C11.1251 13.352 10.8918 13.1145 10.8918 12.8279V8.85202C10.8918 8.62702 11.036 8.42702 11.2501 8.35619C11.3001 8.33702 11.3635 8.32869 11.4118 8.32869C11.5743 8.32869 11.7243 8.41536 11.8243 8.54036L13.876 11.3154V8.85202C13.876 8.56452 14.111 8.32702 14.401 8.32702C14.6885 8.32702 14.926 8.56452 14.926 8.85202V12.8279ZM10.1418 12.8279C10.1418 13.1145 9.90681 13.352 9.61598 13.352C9.32848 13.352 9.09348 13.1145 9.09348 12.8279V8.85202C9.09348 8.56452 9.32848 8.32702 9.61848 8.32702C9.90681 8.32702 10.1418 8.56452 10.1418 8.85202V12.8279ZM8.08681 13.352H6.09848C5.81098 13.352 5.57348 13.1145 5.57348 12.8279V8.85202C5.57348 8.56452 5.81098 8.32702 6.09848 8.32702C6.38848 8.32702 6.62348 8.56452 6.62348 8.85202V12.3029H8.08681C8.37681 12.3029 8.61098 12.5387 8.61098 12.8279C8.61098 13.1145 8.37598 13.352 8.08681 13.352Z"
  }));
},
    gm = function gm(_ref1199) {
  var _ref1199$color = _ref1199.color,
      C = _ref1199$color === void 0 ? "currentColor" : _ref1199$color,
      _ref1199$size = _ref1199.size,
      e = _ref1199$size === void 0 ? 24 : _ref1199$size,
      l = _ref1199.className,
      i = _objectWithoutProperties(_ref1199, _excluded1199);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17.6567 14.8284L16.2425 13.4142L17.6567 12C19.2188 10.4379 19.2188 7.90524 17.6567 6.34314C16.0946 4.78105 13.5619 4.78105 11.9998 6.34314L10.5856 7.75736L9.17139 6.34314L10.5856 4.92893C12.9287 2.58578 16.7277 2.58578 19.0709 4.92893C21.414 7.27208 21.414 11.0711 19.0709 13.4142L17.6567 14.8284ZM14.8282 17.6569L13.414 19.0711C11.0709 21.4142 7.27189 21.4142 4.92875 19.0711C2.5856 16.7279 2.5856 12.9289 4.92875 10.5858L6.34296 9.17157L7.75717 10.5858L6.34296 12C4.78086 13.5621 4.78086 16.0948 6.34296 17.6569C7.90506 19.2189 10.4377 19.2189 11.9998 17.6569L13.414 16.2426L14.8282 17.6569ZM14.8282 7.75736L16.2425 9.17157L9.17139 16.2426L7.75717 14.8284L14.8282 7.75736Z"
  }));
},
    Mm = function Mm(_ref1200) {
  var _ref1200$color = _ref1200.color,
      C = _ref1200$color === void 0 ? "currentColor" : _ref1200$color,
      _ref1200$size = _ref1200.size,
      e = _ref1200$size === void 0 ? 24 : _ref1200$size,
      l = _ref1200.className,
      i = _objectWithoutProperties(_ref1200, _excluded1200);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17.657 14.8284L16.2428 13.4142L17.657 12C19.2191 10.4379 19.2191 7.90526 17.657 6.34316C16.0949 4.78106 13.5622 4.78106 12.0001 6.34316L10.5859 7.75737L9.17171 6.34316L10.5859 4.92895C12.9291 2.5858 16.7281 2.5858 19.0712 4.92895C21.4143 7.27209 21.4143 11.0711 19.0712 13.4142L17.657 14.8284ZM14.8286 17.6569L13.4143 19.0711C11.0712 21.4142 7.27221 21.4142 4.92907 19.0711C2.58592 16.7279 2.58592 12.9289 4.92907 10.5858L6.34328 9.17159L7.75749 10.5858L6.34328 12C4.78118 13.5621 4.78118 16.0948 6.34328 17.6569C7.90538 19.219 10.438 19.219 12.0001 17.6569L13.4143 16.2427L14.8286 17.6569ZM14.8286 7.75737L16.2428 9.17159L9.17171 16.2427L7.75749 14.8284L14.8286 7.75737ZM5.77539 2.29291L7.70724 1.77527L8.74252 5.63897L6.81067 6.15661L5.77539 2.29291ZM15.2578 18.3611L17.1896 17.8434L18.2249 21.7071L16.293 22.2248L15.2578 18.3611ZM2.29303 5.77527L6.15673 6.81054L5.63909 8.7424L1.77539 7.70712L2.29303 5.77527ZM18.3612 15.2576L22.2249 16.2929L21.7072 18.2248L17.8435 17.1895L18.3612 15.2576Z"
  }));
},
    Zm = function Zm(_ref1201) {
  var _ref1201$color = _ref1201.color,
      C = _ref1201$color === void 0 ? "currentColor" : _ref1201$color,
      _ref1201$size = _ref1201.size,
      e = _ref1201$size === void 0 ? 24 : _ref1201$size,
      l = _ref1201.className,
      i = _objectWithoutProperties(_ref1201, _excluded1201);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17 17H22V19H19V22H17V17ZM7 7H2V5H5V2H7V7ZM18.364 15.5355L16.9497 14.1213L18.364 12.7071C20.3166 10.7545 20.3166 7.58866 18.364 5.63604C16.4113 3.68342 13.2455 3.68342 11.2929 5.63604L9.87868 7.05025L8.46447 5.63604L9.87868 4.22183C12.6123 1.48816 17.0445 1.48816 19.7782 4.22183C22.5118 6.9555 22.5118 11.3877 19.7782 14.1213L18.364 15.5355ZM15.5355 18.364L14.1213 19.7782C11.3877 22.5118 6.9555 22.5118 4.22183 19.7782C1.48816 17.0445 1.48816 12.6123 4.22183 9.87868L5.63604 8.46447L7.05025 9.87868L5.63604 11.2929C3.68342 13.2455 3.68342 16.4113 5.63604 18.364C7.58866 20.3166 10.7545 20.3166 12.7071 18.364L14.1213 16.9497L15.5355 18.364ZM14.8284 7.75736L16.2426 9.17157L9.17157 16.2426L7.75736 14.8284L14.8284 7.75736Z"
  }));
},
    xm = function xm(_ref1202) {
  var _ref1202$color = _ref1202.color,
      C = _ref1202$color === void 0 ? "currentColor" : _ref1202$color,
      _ref1202$size = _ref1202.size,
      e = _ref1202$size === void 0 ? 24 : _ref1202$size,
      l = _ref1202.className,
      i = _objectWithoutProperties(_ref1202, _excluded1202);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18.3638 15.5355L16.9496 14.1213L18.3638 12.7071C20.3164 10.7545 20.3164 7.58866 18.3638 5.63604C16.4112 3.68341 13.2453 3.68341 11.2927 5.63604L9.87849 7.05025L8.46428 5.63604L9.87849 4.22182C12.6122 1.48815 17.0443 1.48815 19.778 4.22182C22.5117 6.95549 22.5117 11.3876 19.778 14.1213L18.3638 15.5355ZM15.5353 18.364L14.1211 19.7782C11.3875 22.5118 6.95531 22.5118 4.22164 19.7782C1.48797 17.0445 1.48797 12.6123 4.22164 9.87868L5.63585 8.46446L7.05007 9.87868L5.63585 11.2929C3.68323 13.2455 3.68323 16.4113 5.63585 18.364C7.58847 20.3166 10.7543 20.3166 12.7069 18.364L14.1211 16.9497L15.5353 18.364ZM14.8282 7.75736L16.2425 9.17157L9.17139 16.2426L7.75717 14.8284L14.8282 7.75736Z"
  }));
},
    vm = function vm(_ref1203) {
  var _ref1203$color = _ref1203.color,
      C = _ref1203$color === void 0 ? "currentColor" : _ref1203$color,
      _ref1203$size = _ref1203.size,
      e = _ref1203$size === void 0 ? 24 : _ref1203$size,
      l = _ref1203.className,
      i = _objectWithoutProperties(_ref1203, _excluded1203);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18.3362 18.339H15.6707V14.1622C15.6707 13.1662 15.6505 11.8845 14.2817 11.8845C12.892 11.8845 12.6797 12.9683 12.6797 14.0887V18.339H10.0142V9.75H12.5747V10.9207H12.6092C12.967 10.2457 13.837 9.53325 15.1367 9.53325C17.8375 9.53325 18.337 11.3108 18.337 13.6245V18.339H18.3362ZM7.00373 8.57475C6.14573 8.57475 5.45648 7.88025 5.45648 7.026C5.45648 6.1725 6.14648 5.47875 7.00373 5.47875C7.85873 5.47875 8.55173 6.1725 8.55173 7.026C8.55173 7.88025 7.85798 8.57475 7.00373 8.57475ZM8.34023 18.339H5.66723V9.75H8.34023V18.339ZM19.6697 3H4.32923C3.59498 3 3.00098 3.5805 3.00098 4.29675V19.7033C3.00098 20.4202 3.59498 21 4.32923 21H19.6675C20.401 21 21.001 20.4202 21.001 19.7033V4.29675C21.001 3.5805 20.401 3 19.6675 3H19.6697Z"
  }));
},
    dm = function dm(_ref1204) {
  var _ref1204$color = _ref1204.color,
      C = _ref1204$color === void 0 ? "currentColor" : _ref1204$color,
      _ref1204$size = _ref1204.size,
      e = _ref1204$size === void 0 ? 24 : _ref1204$size,
      l = _ref1204.className,
      i = _objectWithoutProperties(_ref1204, _excluded1204);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4.00098 3H20.001C20.5533 3 21.001 3.44772 21.001 4V20C21.001 20.5523 20.5533 21 20.001 21H4.00098C3.44869 21 3.00098 20.5523 3.00098 20V4C3.00098 3.44772 3.44869 3 4.00098 3ZM5.00098 5V19H19.001V5H5.00098ZM7.50098 9C6.67255 9 6.00098 8.32843 6.00098 7.5C6.00098 6.67157 6.67255 6 7.50098 6C8.3294 6 9.00098 6.67157 9.00098 7.5C9.00098 8.32843 8.3294 9 7.50098 9ZM6.50098 10H8.50098V17.5H6.50098V10ZM12.001 10.4295C12.5854 9.86534 13.2665 9.5 14.001 9.5C16.072 9.5 17.501 11.1789 17.501 13.25V17.5H15.501V13.25C15.501 12.2835 14.7175 11.5 13.751 11.5C12.7845 11.5 12.001 12.2835 12.001 13.25V17.5H10.001V10H12.001V10.4295Z"
  }));
},
    pm = function pm(_ref1205) {
  var _ref1205$color = _ref1205.color,
      C = _ref1205$color === void 0 ? "currentColor" : _ref1205$color,
      _ref1205$size = _ref1205.size,
      e = _ref1205$size === void 0 ? 24 : _ref1205$size,
      l = _ref1205.className,
      i = _objectWithoutProperties(_ref1205, _excluded1205);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.94048 4.99993C6.94011 5.81424 6.44608 6.54702 5.69134 6.85273C4.9366 7.15845 4.07187 6.97605 3.5049 6.39155C2.93793 5.80704 2.78195 4.93715 3.1105 4.19207C3.43906 3.44699 4.18654 2.9755 5.00048 2.99993C6.08155 3.03238 6.94097 3.91837 6.94048 4.99993ZM7.00048 8.47993H3.00048V20.9999H7.00048V8.47993ZM13.3205 8.47993H9.34048V20.9999H13.2805V14.4299C13.2805 10.7699 18.0505 10.4299 18.0505 14.4299V20.9999H22.0005V13.0699C22.0005 6.89993 14.9405 7.12993 13.2805 10.1599L13.3205 8.47993Z"
  }));
},
    Em = function Em(_ref1206) {
  var _ref1206$color = _ref1206.color,
      C = _ref1206$color === void 0 ? "currentColor" : _ref1206$color,
      _ref1206$size = _ref1206.size,
      e = _ref1206$size === void 0 ? 24 : _ref1206$size,
      l = _ref1206.className,
      i = _objectWithoutProperties(_ref1206, _excluded1206);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.001 9.55005C12.9181 8.61327 14.1121 8 15.501 8C18.5385 8 21.001 10.4624 21.001 13.5V21H19.001V13.5C19.001 11.567 17.434 10 15.501 10C13.568 10 12.001 11.567 12.001 13.5V21H10.001V8.5H12.001V9.55005ZM5.00098 6.5C4.17255 6.5 3.50098 5.82843 3.50098 5C3.50098 4.17157 4.17255 3.5 5.00098 3.5C5.8294 3.5 6.50098 4.17157 6.50098 5C6.50098 5.82843 5.8294 6.5 5.00098 6.5ZM4.00098 8.5H6.00098V21H4.00098V8.5Z"
  }));
},
    Nm = function Nm(_ref1207) {
  var _ref1207$color = _ref1207.color,
      C = _ref1207$color === void 0 ? "currentColor" : _ref1207$color,
      _ref1207$size = _ref1207.size,
      e = _ref1207$size === void 0 ? 24 : _ref1207$size,
      l = _ref1207.className,
      i = _objectWithoutProperties(_ref1207, _excluded1207);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13.0607 8.11097L14.4749 9.52518C17.2086 12.2589 17.2086 16.691 14.4749 19.4247L14.1214 19.7782C11.3877 22.5119 6.95555 22.5119 4.22188 19.7782C1.48821 17.0446 1.48821 12.6124 4.22188 9.87874L5.6361 11.293C3.68348 13.2456 3.68348 16.4114 5.6361 18.364C7.58872 20.3166 10.7545 20.3166 12.7072 18.364L13.0607 18.0105C15.0133 16.0578 15.0133 12.892 13.0607 10.9394L11.6465 9.52518L13.0607 8.11097ZM19.7782 14.1214L18.364 12.7072C20.3166 10.7545 20.3166 7.58872 18.364 5.6361C16.4114 3.68348 13.2456 3.68348 11.293 5.6361L10.9394 5.98965C8.98678 7.94227 8.98678 11.1081 10.9394 13.0607L12.3536 14.4749L10.9394 15.8891L9.52518 14.4749C6.79151 11.7413 6.79151 7.30911 9.52518 4.57544L9.87874 4.22188C12.6124 1.48821 17.0446 1.48821 19.7782 4.22188C22.5119 6.95555 22.5119 11.3877 19.7782 14.1214Z"
  }));
},
    um = function um(_ref1208) {
  var _ref1208$color = _ref1208.color,
      C = _ref1208$color === void 0 ? "currentColor" : _ref1208$color,
      _ref1208$size = _ref1208.size,
      e = _ref1208$size === void 0 ? 24 : _ref1208$size,
      l = _ref1208.className,
      i = _objectWithoutProperties(_ref1208, _excluded1208);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13.0607 8.11097L14.4749 9.52518C17.2086 12.2589 17.2086 16.691 14.4749 19.4247L14.1214 19.7782C11.3877 22.5119 6.95555 22.5119 4.22188 19.7782C1.48821 17.0446 1.48821 12.6124 4.22188 9.87874L5.6361 11.293C3.68348 13.2456 3.68348 16.4114 5.6361 18.364C7.58872 20.3166 10.7545 20.3166 12.7072 18.364L13.0607 18.0105C15.0133 16.0578 15.0133 12.892 13.0607 10.9394L11.6465 9.52518L13.0607 8.11097ZM19.7782 14.1214L18.364 12.7072C20.3166 10.7545 20.3166 7.58872 18.364 5.6361C16.4114 3.68348 13.2456 3.68348 11.293 5.6361L10.9394 5.98965C8.98678 7.94227 8.98678 11.1081 10.9394 13.0607L12.3536 14.4749L10.9394 15.8891L9.52518 14.4749C6.79151 11.7413 6.79151 7.30911 9.52518 4.57544L9.87874 4.22188C12.6124 1.48821 17.0446 1.48821 19.7782 4.22188C22.5119 6.95555 22.5119 11.3877 19.7782 14.1214Z"
  }));
},
    Bm = function Bm(_ref1209) {
  var _ref1209$color = _ref1209.color,
      C = _ref1209$color === void 0 ? "currentColor" : _ref1209$color,
      _ref1209$size = _ref1209.size,
      e = _ref1209$size === void 0 ? 24 : _ref1209$size,
      l = _ref1209.className,
      i = _objectWithoutProperties(_ref1209, _excluded1209);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11 4H21V6H11V4ZM11 8H17V10H11V8ZM11 14H21V16H11V14ZM11 18H17V20H11V18ZM3 4H9V10H3V4ZM5 6V8H7V6H5ZM3 14H9V20H3V14ZM5 16V18H7V16H5Z"
  }));
},
    fm = function fm(_ref1210) {
  var _ref1210$color = _ref1210.color,
      C = _ref1210$color === void 0 ? "currentColor" : _ref1210$color,
      _ref1210$size = _ref1210.size,
      e = _ref1210$size === void 0 ? 24 : _ref1210$size,
      l = _ref1210.className,
      i = _objectWithoutProperties(_ref1210, _excluded1210);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8 4H21V6H8V4ZM3 3.5H6V6.5H3V3.5ZM3 10.5H6V13.5H3V10.5ZM3 17.5H6V20.5H3V17.5ZM8 11H21V13H8V11ZM8 18H21V20H8V18Z"
  }));
},
    Rm = function Rm(_ref1211) {
  var _ref1211$color = _ref1211.color,
      C = _ref1211$color === void 0 ? "currentColor" : _ref1211$color,
      _ref1211$size = _ref1211.size,
      e = _ref1211$size === void 0 ? 24 : _ref1211$size,
      l = _ref1211.className,
      i = _objectWithoutProperties(_ref1211, _excluded1211);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8 4H21V6H8V4ZM5 3V6H6V7H3V6H4V4H3V3H5ZM3 14V11.5H5V11H3V10H6V12.5H4V13H6V14H3ZM5 19.5H3V18.5H5V18H3V17H6V21H3V20H5V19.5ZM8 11H21V13H8V11ZM8 18H21V20H8V18Z"
  }));
},
    zm = function zm(_ref1212) {
  var _ref1212$color = _ref1212.color,
      C = _ref1212$color === void 0 ? "currentColor" : _ref1212$color,
      _ref1212$size = _ref1212.size,
      e = _ref1212$size === void 0 ? 24 : _ref1212$size,
      l = _ref1212.className,
      i = _objectWithoutProperties(_ref1212, _excluded1212);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 18H9V20H2V18ZM2 11H11V13H2V11ZM2 4H22V6H2V4ZM20.674 13.0251L21.8301 12.634L22.8301 14.366L21.914 15.1711C21.9704 15.4386 22 15.7158 22 16C22 16.2842 21.9704 16.5614 21.914 16.8289L22.8301 17.634L21.8301 19.366L20.674 18.9749C20.2635 19.3441 19.7763 19.6295 19.2391 19.8044L19 21H17L16.7609 19.8044C16.2237 19.6295 15.7365 19.3441 15.326 18.9749L14.1699 19.366L13.1699 17.634L14.086 16.8289C14.0296 16.5614 14 16.2842 14 16C14 15.7158 14.0296 15.4386 14.086 15.1711L13.1699 14.366L14.1699 12.634L15.326 13.0251C15.7365 12.6559 16.2237 12.3705 16.7609 12.1956L17 11H19L19.2391 12.1956C19.7763 12.3705 20.2635 12.6559 20.674 13.0251ZM18 17C18.5523 17 19 16.5523 19 16C19 15.4477 18.5523 15 18 15C17.4477 15 17 15.4477 17 16C17 16.5523 17.4477 17 18 17Z"
  }));
},
    Fm = function Fm(_ref1213) {
  var _ref1213$color = _ref1213.color,
      C = _ref1213$color === void 0 ? "currentColor" : _ref1213$color,
      _ref1213$size = _ref1213.size,
      e = _ref1213$size === void 0 ? 24 : _ref1213$size,
      l = _ref1213.className,
      i = _objectWithoutProperties(_ref1213, _excluded1213);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 18H9V20H2V18ZM2 11H11V13H2V11ZM2 4H22V6H2V4ZM20.674 13.0251L21.8301 12.634L22.8301 14.366L21.914 15.1711C21.9704 15.4386 22 15.7158 22 16C22 16.2842 21.9704 16.5614 21.914 16.8289L22.8301 17.634L21.8301 19.366L20.674 18.9749C20.2635 19.3441 19.7763 19.6295 19.2391 19.8044L19 21H17L16.7609 19.8044C16.2237 19.6295 15.7365 19.3441 15.326 18.9749L14.1699 19.366L13.1699 17.634L14.086 16.8289C14.0296 16.5614 14 16.2842 14 16C14 15.7158 14.0296 15.4386 14.086 15.1711L13.1699 14.366L14.1699 12.634L15.326 13.0251C15.7365 12.6559 16.2237 12.3705 16.7609 12.1956L17 11H19L19.2391 12.1956C19.7763 12.3705 20.2635 12.6559 20.674 13.0251ZM18 18C19.1046 18 20 17.1046 20 16C20 14.8954 19.1046 14 18 14C16.8954 14 16 14.8954 16 16C16 17.1046 16.8954 18 18 18Z"
  }));
},
    Sm = function Sm(_ref1214) {
  var _ref1214$color = _ref1214.color,
      C = _ref1214$color === void 0 ? "currentColor" : _ref1214$color,
      _ref1214$size = _ref1214.size,
      e = _ref1214$size === void 0 ? 24 : _ref1214$size,
      l = _ref1214.className,
      i = _objectWithoutProperties(_ref1214, _excluded1214);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8 4H21V6H8V4ZM4.5 6.5C3.67157 6.5 3 5.82843 3 5C3 4.17157 3.67157 3.5 4.5 3.5C5.32843 3.5 6 4.17157 6 5C6 5.82843 5.32843 6.5 4.5 6.5ZM4.5 13.5C3.67157 13.5 3 12.8284 3 12C3 11.1716 3.67157 10.5 4.5 10.5C5.32843 10.5 6 11.1716 6 12C6 12.8284 5.32843 13.5 4.5 13.5ZM4.5 20.4C3.67157 20.4 3 19.7284 3 18.9C3 18.0716 3.67157 17.4 4.5 17.4C5.32843 17.4 6 18.0716 6 18.9C6 19.7284 5.32843 20.4 4.5 20.4ZM8 11H21V13H8V11ZM8 18H21V20H8V18Z"
  }));
},
    Am = function Am(_ref1215) {
  var _ref1215$color = _ref1215.color,
      C = _ref1215$color === void 0 ? "currentColor" : _ref1215$color,
      _ref1215$size = _ref1215.size,
      e = _ref1215$size === void 0 ? 24 : _ref1215$size,
      l = _ref1215.className,
      i = _objectWithoutProperties(_ref1215, _excluded1215);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16 4C16.5523 4 17 4.44772 17 5V9.2L22.2133 5.55071C22.4395 5.39235 22.7513 5.44737 22.9096 5.6736C22.9684 5.75764 23 5.85774 23 5.96033V18.0397C23 18.3158 22.7761 18.5397 22.5 18.5397C22.3974 18.5397 22.2973 18.5081 22.2133 18.4493L17 14.8V19C17 19.5523 16.5523 20 16 20H2C1.44772 20 1 19.5523 1 19V5C1 4.44772 1.44772 4 2 4H16ZM7.4 8.82867C7.2067 8.82867 7.04543 8.96578 7.00813 9.14806L7 9.22867V14.7713C7 14.8474 7.02169 14.9219 7.06254 14.9861C7.16631 15.1492 7.36858 15.2116 7.54238 15.1452L7.61475 15.1088L11.9697 12.3375C12.0191 12.306 12.061 12.2641 12.0924 12.2148C12.1962 12.0517 12.1671 11.842 12.0333 11.7127L11.9697 11.6625L7.61475 8.8912C7.55057 8.85036 7.47607 8.82867 7.4 8.82867Z"
  }));
},
    km = function km(_ref1216) {
  var _ref1216$color = _ref1216.color,
      C = _ref1216$color === void 0 ? "currentColor" : _ref1216$color,
      _ref1216$size = _ref1216.size,
      e = _ref1216$size === void 0 ? 24 : _ref1216$size,
      l = _ref1216.className,
      i = _objectWithoutProperties(_ref1216, _excluded1216);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16 4C16.5523 4 17 4.44772 17 5V9.2L22.2133 5.55071C22.4395 5.39235 22.7513 5.44737 22.9096 5.6736C22.9684 5.75764 23 5.85774 23 5.96033V18.0397C23 18.3158 22.7761 18.5397 22.5 18.5397C22.3974 18.5397 22.2973 18.5081 22.2133 18.4493L17 14.8V19C17 19.5523 16.5523 20 16 20H2C1.44772 20 1 19.5523 1 19V5C1 4.44772 1.44772 4 2 4H16ZM15 6H3V18H15V6ZM7.4 8.82867C7.47607 8.82867 7.55057 8.85036 7.61475 8.8912L11.9697 11.6625C12.1561 11.7811 12.211 12.0284 12.0924 12.2148C12.061 12.2641 12.0191 12.306 11.9697 12.3375L7.61475 15.1088C7.42837 15.2274 7.18114 15.1725 7.06254 14.9861C7.02169 14.9219 7 14.8474 7 14.7713V9.22867C7 9.00776 7.17909 8.82867 7.4 8.82867ZM21 8.84131L17 11.641V12.359L21 15.1587V8.84131Z"
  }));
},
    Pm = function Pm(_ref1217) {
  var _ref1217$color = _ref1217.color,
      C = _ref1217$color === void 0 ? "currentColor" : _ref1217$color,
      _ref1217$size = _ref1217.size,
      e = _ref1217$size === void 0 ? 24 : _ref1217$size,
      l = _ref1217.className,
      i = _objectWithoutProperties(_ref1217, _excluded1217);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C12.5523 2 13 2.44772 13 3V6C13 6.55228 12.5523 7 12 7C11.4477 7 11 6.55228 11 6V3C11 2.44772 11.4477 2 12 2ZM12 17C12.5523 17 13 17.4477 13 18V21C13 21.5523 12.5523 22 12 22C11.4477 22 11 21.5523 11 21V18C11 17.4477 11.4477 17 12 17ZM22 12C22 12.5523 21.5523 13 21 13H18C17.4477 13 17 12.5523 17 12C17 11.4477 17.4477 11 18 11H21C21.5523 11 22 11.4477 22 12ZM7 12C7 12.5523 6.55228 13 6 13H3C2.44772 13 2 12.5523 2 12C2 11.4477 2.44772 11 3 11H6C6.55228 11 7 11.4477 7 12ZM19.0711 19.0711C18.6805 19.4616 18.0474 19.4616 17.6569 19.0711L15.5355 16.9497C15.145 16.5592 15.145 15.9261 15.5355 15.5355C15.9261 15.145 16.5592 15.145 16.9497 15.5355L19.0711 17.6569C19.4616 18.0474 19.4616 18.6805 19.0711 19.0711ZM8.46447 8.46447C8.07394 8.85499 7.44078 8.85499 7.05025 8.46447L4.92893 6.34315C4.53841 5.95262 4.53841 5.31946 4.92893 4.92893C5.31946 4.53841 5.95262 4.53841 6.34315 4.92893L8.46447 7.05025C8.85499 7.44078 8.85499 8.07394 8.46447 8.46447ZM4.92893 19.0711C4.53841 18.6805 4.53841 18.0474 4.92893 17.6569L7.05025 15.5355C7.44078 15.145 8.07394 15.145 8.46447 15.5355C8.85499 15.9261 8.85499 16.5592 8.46447 16.9497L6.34315 19.0711C5.95262 19.4616 5.31946 19.4616 4.92893 19.0711ZM15.5355 8.46447C15.145 8.07394 15.145 7.44078 15.5355 7.05025L17.6569 4.92893C18.0474 4.53841 18.6805 4.53841 19.0711 4.92893C19.4616 5.31946 19.4616 5.95262 19.0711 6.34315L16.9497 8.46447C16.5592 8.85499 15.9261 8.85499 15.5355 8.46447Z"
  }));
},
    Dm = function Dm(_ref1218) {
  var _ref1218$color = _ref1218.color,
      C = _ref1218$color === void 0 ? "currentColor" : _ref1218$color,
      _ref1218$size = _ref1218.size,
      e = _ref1218$size === void 0 ? 24 : _ref1218$size,
      l = _ref1218.className,
      i = _objectWithoutProperties(_ref1218, _excluded1218);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C12.5523 2 13 2.44772 13 3V6C13 6.55228 12.5523 7 12 7C11.4477 7 11 6.55228 11 6V3C11 2.44772 11.4477 2 12 2ZM12 17C12.5523 17 13 17.4477 13 18V21C13 21.5523 12.5523 22 12 22C11.4477 22 11 21.5523 11 21V18C11 17.4477 11.4477 17 12 17ZM22 12C22 12.5523 21.5523 13 21 13H18C17.4477 13 17 12.5523 17 12C17 11.4477 17.4477 11 18 11H21C21.5523 11 22 11.4477 22 12ZM7 12C7 12.5523 6.55228 13 6 13H3C2.44772 13 2 12.5523 2 12C2 11.4477 2.44772 11 3 11H6C6.55228 11 7 11.4477 7 12ZM19.0711 19.0711C18.6805 19.4616 18.0474 19.4616 17.6569 19.0711L15.5355 16.9497C15.145 16.5592 15.145 15.9261 15.5355 15.5355C15.9261 15.145 16.5592 15.145 16.9497 15.5355L19.0711 17.6569C19.4616 18.0474 19.4616 18.6805 19.0711 19.0711ZM8.46447 8.46447C8.07394 8.85499 7.44078 8.85499 7.05025 8.46447L4.92893 6.34315C4.53841 5.95262 4.53841 5.31946 4.92893 4.92893C5.31946 4.53841 5.95262 4.53841 6.34315 4.92893L8.46447 7.05025C8.85499 7.44078 8.85499 8.07394 8.46447 8.46447ZM4.92893 19.0711C4.53841 18.6805 4.53841 18.0474 4.92893 17.6569L7.05025 15.5355C7.44078 15.145 8.07394 15.145 8.46447 15.5355C8.85499 15.9261 8.85499 16.5592 8.46447 16.9497L6.34315 19.0711C5.95262 19.4616 5.31946 19.4616 4.92893 19.0711ZM15.5355 8.46447C15.145 8.07394 15.145 7.44078 15.5355 7.05025L17.6569 4.92893C18.0474 4.53841 18.6805 4.53841 19.0711 4.92893C19.4616 5.31946 19.4616 5.95262 19.0711 6.34315L16.9497 8.46447C16.5592 8.85499 15.9261 8.85499 15.5355 8.46447Z"
  }));
},
    ym = function ym(_ref1219) {
  var _ref1219$color = _ref1219.color,
      C = _ref1219$color === void 0 ? "currentColor" : _ref1219$color,
      _ref1219$size = _ref1219.size,
      e = _ref1219$size === void 0 ? 24 : _ref1219$size,
      l = _ref1219.className,
      i = _objectWithoutProperties(_ref1219, _excluded1219);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3.05469 13H5.07065C5.55588 16.3923 8.47329 19 11.9998 19C15.5262 19 18.4436 16.3923 18.9289 13H20.9448C20.4474 17.5 16.6323 21 11.9998 21C7.36721 21 3.55213 17.5 3.05469 13ZM3.05469 11C3.55213 6.50005 7.36721 3 11.9998 3C16.6323 3 20.4474 6.50005 20.9448 11H18.9289C18.4436 7.60771 15.5262 5 11.9998 5C8.47329 5 5.55588 7.60771 5.07065 11H3.05469Z"
  }));
},
    bm = function bm(_ref1220) {
  var _ref1220$color = _ref1220.color,
      C = _ref1220$color === void 0 ? "currentColor" : _ref1220$color,
      _ref1220$size = _ref1220.size,
      e = _ref1220$size === void 0 ? 24 : _ref1220$size,
      l = _ref1220.className,
      i = _objectWithoutProperties(_ref1220, _excluded1220);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3.05469 13H5.07065C5.55588 16.3923 8.47329 19 11.9998 19C15.5262 19 18.4436 16.3923 18.9289 13H20.9448C20.4474 17.5 16.6323 21 11.9998 21C7.36721 21 3.55213 17.5 3.05469 13ZM3.05469 11C3.55213 6.50005 7.36721 3 11.9998 3C16.6323 3 20.4474 6.50005 20.9448 11H18.9289C18.4436 7.60771 15.5262 5 11.9998 5C8.47329 5 5.55588 7.60771 5.07065 11H3.05469Z"
  }));
},
    Tm = function Tm(_ref1221) {
  var _ref1221$color = _ref1221.color,
      C = _ref1221$color === void 0 ? "currentColor" : _ref1221$color,
      _ref1221$size = _ref1221.size,
      e = _ref1221$size === void 0 ? 24 : _ref1221$size,
      l = _ref1221.className,
      i = _objectWithoutProperties(_ref1221, _excluded1221);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18.364 5.63604L16.9497 7.05025C15.683 5.7835 13.933 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C15.866 19 19 15.866 19 12H21C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C14.4853 3 16.7353 4.00736 18.364 5.63604Z"
  }));
},
    Um = function Um(_ref1222) {
  var _ref1222$color = _ref1222.color,
      C = _ref1222$color === void 0 ? "currentColor" : _ref1222$color,
      _ref1222$size = _ref1222.size,
      e = _ref1222$size === void 0 ? 24 : _ref1222$size,
      l = _ref1222.className,
      i = _objectWithoutProperties(_ref1222, _excluded1222);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18.364 5.63604L16.9497 7.05025C15.683 5.7835 13.933 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C15.866 19 19 15.866 19 12H21C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C14.4853 3 16.7353 4.00736 18.364 5.63604Z"
  }));
},
    Gm = function Gm(_ref1223) {
  var _ref1223$color = _ref1223.color,
      C = _ref1223$color === void 0 ? "currentColor" : _ref1223$color,
      _ref1223$size = _ref1223.size,
      e = _ref1223$size === void 0 ? 24 : _ref1223$size,
      l = _ref1223.className,
      i = _objectWithoutProperties(_ref1223, _excluded1223);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 3C16.9706 3 21 7.02944 21 12H19C19 8.13401 15.866 5 12 5V3Z"
  }));
},
    Im = function Im(_ref1224) {
  var _ref1224$color = _ref1224.color,
      C = _ref1224$color === void 0 ? "currentColor" : _ref1224$color,
      _ref1224$size = _ref1224.size,
      e = _ref1224$size === void 0 ? 24 : _ref1224$size,
      l = _ref1224.className,
      i = _objectWithoutProperties(_ref1224, _excluded1224);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 3C16.9706 3 21 7.02944 21 12H19C19 8.13401 15.866 5 12 5V3Z"
  }));
},
    Wm = function Wm(_ref1225) {
  var _ref1225$color = _ref1225.color,
      C = _ref1225$color === void 0 ? "currentColor" : _ref1225$color,
      _ref1225$size = _ref1225.size,
      e = _ref1225$size === void 0 ? 24 : _ref1225$size,
      l = _ref1225.className,
      i = _objectWithoutProperties(_ref1225, _excluded1225);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11.9995 2C12.5518 2 12.9995 2.44772 12.9995 3V6C12.9995 6.55228 12.5518 7 11.9995 7C11.4472 7 10.9995 6.55228 10.9995 6V3C10.9995 2.44772 11.4472 2 11.9995 2ZM11.9995 17C12.5518 17 12.9995 17.4477 12.9995 18V21C12.9995 21.5523 12.5518 22 11.9995 22C11.4472 22 10.9995 21.5523 10.9995 21V18C10.9995 17.4477 11.4472 17 11.9995 17ZM20.6597 7C20.9359 7.47829 20.772 8.08988 20.2937 8.36602L17.6956 9.86602C17.2173 10.1422 16.6057 9.97829 16.3296 9.5C16.0535 9.02171 16.2173 8.41012 16.6956 8.13398L19.2937 6.63397C19.772 6.35783 20.3836 6.52171 20.6597 7ZM7.66935 14.5C7.94549 14.9783 7.78161 15.5899 7.30332 15.866L4.70525 17.366C4.22695 17.6422 3.61536 17.4783 3.33922 17C3.06308 16.5217 3.22695 15.9101 3.70525 15.634L6.30332 14.134C6.78161 13.8578 7.3932 14.0217 7.66935 14.5ZM20.6597 17C20.3836 17.4783 19.772 17.6422 19.2937 17.366L16.6956 15.866C16.2173 15.5899 16.0535 14.9783 16.3296 14.5C16.6057 14.0217 17.2173 13.8578 17.6956 14.134L20.2937 15.634C20.772 15.9101 20.9359 16.5217 20.6597 17ZM7.66935 9.5C7.3932 9.97829 6.78161 10.1422 6.30332 9.86602L3.70525 8.36602C3.22695 8.08988 3.06308 7.47829 3.33922 7C3.61536 6.52171 4.22695 6.35783 4.70525 6.63397L7.30332 8.13398C7.78161 8.41012 7.94549 9.02171 7.66935 9.5Z"
  }));
},
    Om = function Om(_ref1226) {
  var _ref1226$color = _ref1226.color,
      C = _ref1226$color === void 0 ? "currentColor" : _ref1226$color,
      _ref1226$size = _ref1226.size,
      e = _ref1226$size === void 0 ? 24 : _ref1226$size,
      l = _ref1226.className,
      i = _objectWithoutProperties(_ref1226, _excluded1226);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11.9995 2C12.5518 2 12.9995 2.44772 12.9995 3V6C12.9995 6.55228 12.5518 7 11.9995 7C11.4472 7 10.9995 6.55228 10.9995 6V3C10.9995 2.44772 11.4472 2 11.9995 2ZM11.9995 17C12.5518 17 12.9995 17.4477 12.9995 18V21C12.9995 21.5523 12.5518 22 11.9995 22C11.4472 22 10.9995 21.5523 10.9995 21V18C10.9995 17.4477 11.4472 17 11.9995 17ZM20.6597 7C20.9359 7.47829 20.772 8.08988 20.2937 8.36602L17.6956 9.86602C17.2173 10.1422 16.6057 9.97829 16.3296 9.5C16.0535 9.02171 16.2173 8.41012 16.6956 8.13398L19.2937 6.63397C19.772 6.35783 20.3836 6.52171 20.6597 7ZM7.66935 14.5C7.94549 14.9783 7.78161 15.5899 7.30332 15.866L4.70525 17.366C4.22695 17.6422 3.61536 17.4783 3.33922 17C3.06308 16.5217 3.22695 15.9101 3.70525 15.634L6.30332 14.134C6.78161 13.8578 7.3932 14.0217 7.66935 14.5ZM20.6597 17C20.3836 17.4783 19.772 17.6422 19.2937 17.366L16.6956 15.866C16.2173 15.5899 16.0535 14.9783 16.3296 14.5C16.6057 14.0217 17.2173 13.8578 17.6956 14.134L20.2937 15.634C20.772 15.9101 20.9359 16.5217 20.6597 17ZM7.66935 9.5C7.3932 9.97829 6.78161 10.1422 6.30332 9.86602L3.70525 8.36602C3.22695 8.08988 3.06308 7.47829 3.33922 7C3.61536 6.52171 4.22695 6.35783 4.70525 6.63397L7.30332 8.13398C7.78161 8.41012 7.94549 9.02171 7.66935 9.5Z"
  }));
},
    Km = function Km(_ref1227) {
  var _ref1227$color = _ref1227.color,
      C = _ref1227$color === void 0 ? "currentColor" : _ref1227$color,
      _ref1227$size = _ref1227.size,
      e = _ref1227$size === void 0 ? 24 : _ref1227$size,
      l = _ref1227.className,
      i = _objectWithoutProperties(_ref1227, _excluded1227);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18 8H20C20.5523 8 21 8.44772 21 9V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V9C3 8.44772 3.44772 8 4 8H6V7C6 3.68629 8.68629 1 12 1C15.3137 1 18 3.68629 18 7V8ZM11 15.7324V18H13V15.7324C13.5978 15.3866 14 14.7403 14 14C14 12.8954 13.1046 12 12 12C10.8954 12 10 12.8954 10 14C10 14.7403 10.4022 15.3866 11 15.7324ZM16 8V7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7V8H16Z"
  }));
},
    Qm = function Qm(_ref1228) {
  var _ref1228$color = _ref1228.color,
      C = _ref1228$color === void 0 ? "currentColor" : _ref1228$color,
      _ref1228$size = _ref1228.size,
      e = _ref1228$size === void 0 ? 24 : _ref1228$size,
      l = _ref1228.className,
      i = _objectWithoutProperties(_ref1228, _excluded1228);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6 8V7C6 3.68629 8.68629 1 12 1C15.3137 1 18 3.68629 18 7V8H20C20.5523 8 21 8.44772 21 9V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V9C3 8.44772 3.44772 8 4 8H6ZM19 10H5V20H19V10ZM11 15.7324C10.4022 15.3866 10 14.7403 10 14C10 12.8954 10.8954 12 12 12C13.1046 12 14 12.8954 14 14C14 14.7403 13.5978 15.3866 13 15.7324V18H11V15.7324ZM8 8H16V7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7V8Z"
  }));
},
    qm = function qm(_ref1229) {
  var _ref1229$color = _ref1229.color,
      C = _ref1229$color === void 0 ? "currentColor" : _ref1229$color,
      _ref1229$size = _ref1229.size,
      e = _ref1229$size === void 0 ? 24 : _ref1229$size,
      l = _ref1229.className,
      i = _objectWithoutProperties(_ref1229, _excluded1229);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19 10H20C20.5523 10 21 10.4477 21 11V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V11C3 10.4477 3.44772 10 4 10H5V9C5 5.13401 8.13401 2 12 2C15.866 2 19 5.13401 19 9V10ZM17 10V9C17 6.23858 14.7614 4 12 4C9.23858 4 7 6.23858 7 9V10H17ZM11 14V18H13V14H11Z"
  }));
},
    jm = function jm(_ref1230) {
  var _ref1230$color = _ref1230.color,
      C = _ref1230$color === void 0 ? "currentColor" : _ref1230$color,
      _ref1230$size = _ref1230.size,
      e = _ref1230$size === void 0 ? 24 : _ref1230$size,
      l = _ref1230.className,
      i = _objectWithoutProperties(_ref1230, _excluded1230);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19 10H20C20.5523 10 21 10.4477 21 11V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V11C3 10.4477 3.44772 10 4 10H5V9C5 5.13401 8.13401 2 12 2C15.866 2 19 5.13401 19 9V10ZM5 12V20H19V12H5ZM11 14H13V18H11V14ZM17 10V9C17 6.23858 14.7614 4 12 4C9.23858 4 7 6.23858 7 9V10H17Z"
  }));
},
    Xm = function Xm(_ref1231) {
  var _ref1231$color = _ref1231.color,
      C = _ref1231$color === void 0 ? "currentColor" : _ref1231$color,
      _ref1231$size = _ref1231.size,
      e = _ref1231$size === void 0 ? 24 : _ref1231$size,
      l = _ref1231.className,
      i = _objectWithoutProperties(_ref1231, _excluded1231);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18 8H20C20.5523 8 21 8.44772 21 9V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V9C3 8.44772 3.44772 8 4 8H6V7C6 3.68629 8.68629 1 12 1C15.3137 1 18 3.68629 18 7V8ZM16 8V7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7V8H16ZM11 14V16H13V14H11ZM7 14V16H9V14H7ZM15 14V16H17V14H15Z"
  }));
},
    Jm = function Jm(_ref1232) {
  var _ref1232$color = _ref1232.color,
      C = _ref1232$color === void 0 ? "currentColor" : _ref1232$color,
      _ref1232$size = _ref1232.size,
      e = _ref1232$size === void 0 ? 24 : _ref1232$size,
      l = _ref1232.className,
      i = _objectWithoutProperties(_ref1232, _excluded1232);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18 8H20C20.5523 8 21 8.44772 21 9V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V9C3 8.44772 3.44772 8 4 8H6V7C6 3.68629 8.68629 1 12 1C15.3137 1 18 3.68629 18 7V8ZM5 10V20H19V10H5ZM11 14H13V16H11V14ZM7 14H9V16H7V14ZM15 14H17V16H15V14ZM16 8V7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7V8H16Z"
  }));
},
    Ym = function Ym(_ref1233) {
  var _ref1233$color = _ref1233.color,
      C = _ref1233$color === void 0 ? "currentColor" : _ref1233$color,
      _ref1233$size = _ref1233.size,
      e = _ref1233$size === void 0 ? 24 : _ref1233$size,
      l = _ref1233.className,
      i = _objectWithoutProperties(_ref1233, _excluded1233);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7 10H20C20.5523 10 21 10.4477 21 11V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V11C3 10.4477 3.44772 10 4 10H5V9C5 5.13401 8.13401 2 12 2C14.7405 2 17.1131 3.5748 18.2624 5.86882L16.4731 6.76344C15.6522 5.12486 13.9575 4 12 4C9.23858 4 7 6.23858 7 9V10ZM10 15V17H14V15H10Z"
  }));
},
    _m = function _m(_ref1234) {
  var _ref1234$color = _ref1234.color,
      C = _ref1234$color === void 0 ? "currentColor" : _ref1234$color,
      _ref1234$size = _ref1234.size,
      e = _ref1234$size === void 0 ? 24 : _ref1234$size,
      l = _ref1234.className,
      i = _objectWithoutProperties(_ref1234, _excluded1234);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7 10H20C20.5523 10 21 10.4477 21 11V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V11C3 10.4477 3.44772 10 4 10H5V9C5 5.13401 8.13401 2 12 2C14.7405 2 17.1131 3.5748 18.2624 5.86882L16.4731 6.76344C15.6522 5.12486 13.9575 4 12 4C9.23858 4 7 6.23858 7 9V10ZM5 12V20H19V12H5ZM10 15H14V17H10V15Z"
  }));
},
    $m = function $m(_ref1235) {
  var _ref1235$color = _ref1235.color,
      C = _ref1235$color === void 0 ? "currentColor" : _ref1235$color,
      _ref1235$size = _ref1235.size,
      e = _ref1235$size === void 0 ? 24 : _ref1235$size,
      l = _ref1235.className,
      i = _objectWithoutProperties(_ref1235, _excluded1235);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10 11H4V3C4 2.44772 4.44772 2 5 2H19C19.5523 2 20 2.44772 20 3V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V13H10V16L15 12L10 8V11Z"
  }));
},
    ew = function ew(_ref1236) {
  var _ref1236$color = _ref1236.color,
      C = _ref1236$color === void 0 ? "currentColor" : _ref1236$color,
      _ref1236$size = _ref1236.size,
      e = _ref1236$size === void 0 ? 24 : _ref1236$size,
      l = _ref1236.className,
      i = _objectWithoutProperties(_ref1236, _excluded1236);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 15H6V20H18V4H6V9H4V3C4 2.44772 4.44772 2 5 2H19C19.5523 2 20 2.44772 20 3V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V15ZM10 11V8L15 12L10 16V13H2V11H10Z"
  }));
},
    tw = function tw(_ref1237) {
  var _ref1237$color = _ref1237.color,
      C = _ref1237$color === void 0 ? "currentColor" : _ref1237$color,
      _ref1237$size = _ref1237.size,
      e = _ref1237$size === void 0 ? 24 : _ref1237$size,
      l = _ref1237.className,
      i = _objectWithoutProperties(_ref1237, _excluded1237);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9.99945 11H2.04883C2.55055 5.94668 6.8141 2 11.9995 2C17.5223 2 21.9995 6.47715 21.9995 12C21.9995 17.5228 17.5223 22 11.9995 22C6.8141 22 2.55055 18.0533 2.04883 13H9.99945V16L14.9995 12L9.99945 8V11Z"
  }));
},
    Cw = function Cw(_ref1238) {
  var _ref1238$color = _ref1238.color,
      C = _ref1238$color === void 0 ? "currentColor" : _ref1238$color,
      _ref1238$size = _ref1238.size,
      e = _ref1238$size === void 0 ? 24 : _ref1238$size,
      l = _ref1238.className,
      i = _objectWithoutProperties(_ref1238, _excluded1238);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10 11V8L15 12L10 16V13H1V11H10ZM2.4578 15H4.58152C5.76829 17.9318 8.64262 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C8.64262 4 5.76829 6.06817 4.58152 9H2.4578C3.73207 4.94289 7.52236 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C7.52236 22 3.73207 19.0571 2.4578 15Z"
  }));
},
    lw = function lw(_ref1239) {
  var _ref1239$color = _ref1239.color,
      C = _ref1239$color === void 0 ? "currentColor" : _ref1239$color,
      _ref1239$size = _ref1239.size,
      e = _ref1239$size === void 0 ? 24 : _ref1239$size,
      l = _ref1239.className,
      i = _objectWithoutProperties(_ref1239, _excluded1239);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5 2H19C19.5523 2 20 2.44772 20 3V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V3C4 2.44772 4.44772 2 5 2ZM9 11V8L4 12L9 16V13H15V11H9Z"
  }));
},
    iw = function iw(_ref1240) {
  var _ref1240$color = _ref1240.color,
      C = _ref1240$color === void 0 ? "currentColor" : _ref1240$color,
      _ref1240$size = _ref1240.size,
      e = _ref1240$size === void 0 ? 24 : _ref1240$size,
      l = _ref1240.className,
      i = _objectWithoutProperties(_ref1240, _excluded1240);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 18H6V20H18V4H6V6H4V3C4 2.44772 4.44772 2 5 2H19C19.5523 2 20 2.44772 20 3V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V18ZM6 11H13V13H6V16L1 12L6 8V11Z"
  }));
},
    sw = function sw(_ref1241) {
  var _ref1241$color = _ref1241.color,
      C = _ref1241$color === void 0 ? "currentColor" : _ref1241$color,
      _ref1241$size = _ref1241.size,
      e = _ref1241$size === void 0 ? 24 : _ref1241$size,
      l = _ref1241.className,
      i = _objectWithoutProperties(_ref1241, _excluded1241);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5 22C4.44772 22 4 21.5523 4 21V3C4 2.44772 4.44772 2 5 2H19C19.5523 2 20 2.44772 20 3V21C20 21.5523 19.5523 22 19 22H5ZM15 16L20 12L15 8V11H9V13H15V16Z"
  }));
},
    rw = function rw(_ref1242) {
  var _ref1242$color = _ref1242.color,
      C = _ref1242$color === void 0 ? "currentColor" : _ref1242$color,
      _ref1242$size = _ref1242.size,
      e = _ref1242$size === void 0 ? 24 : _ref1242$size,
      l = _ref1242.className,
      i = _objectWithoutProperties(_ref1242, _excluded1242);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5 22C4.44772 22 4 21.5523 4 21V3C4 2.44772 4.44772 2 5 2H19C19.5523 2 20 2.44772 20 3V6H18V4H6V20H18V18H20V21C20 21.5523 19.5523 22 19 22H5ZM18 16V13H11V11H18V8L23 12L18 16Z"
  }));
},
    cw = function cw(_ref1243) {
  var _ref1243$color = _ref1243.color,
      C = _ref1243$color === void 0 ? "currentColor" : _ref1243$color,
      _ref1243$size = _ref1243.size,
      e = _ref1243$size === void 0 ? 24 : _ref1243$size,
      l = _ref1243.className,
      i = _objectWithoutProperties(_ref1243, _excluded1243);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM7 11V8L2 12L7 16V13H15V11H7Z"
  }));
},
    ow = function ow(_ref1244) {
  var _ref1244$color = _ref1244.color,
      C = _ref1244$color === void 0 ? "currentColor" : _ref1244$color,
      _ref1244$size = _ref1244.size,
      e = _ref1244$size === void 0 ? 24 : _ref1244$size,
      l = _ref1244.className,
      i = _objectWithoutProperties(_ref1244, _excluded1244);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5 11H13V13H5V16L0 12L5 8V11ZM3.99927 18H6.70835C8.11862 19.2447 9.97111 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C9.97111 4 8.11862 4.75527 6.70835 6H3.99927C5.82368 3.57111 8.72836 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C8.72836 22 5.82368 20.4289 3.99927 18Z"
  }));
},
    aw = function aw(_ref1245) {
  var _ref1245$color = _ref1245.color,
      C = _ref1245$color === void 0 ? "currentColor" : _ref1245$color,
      _ref1245$size = _ref1245.size,
      e = _ref1245$size === void 0 ? 24 : _ref1245$size,
      l = _ref1245.className,
      i = _objectWithoutProperties(_ref1245, _excluded1245);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM17 16L22 12L17 8V11H9V13H17V16Z"
  }));
},
    nw = function nw(_ref1246) {
  var _ref1246$color = _ref1246.color,
      C = _ref1246$color === void 0 ? "currentColor" : _ref1246$color,
      _ref1246$size = _ref1246.size,
      e = _ref1246$size === void 0 ? 24 : _ref1246$size,
      l = _ref1246.className,
      i = _objectWithoutProperties(_ref1246, _excluded1246);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C15.2713 2 18.1757 3.57078 20.0002 5.99923L17.2909 5.99931C15.8807 4.75499 14.0285 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C14.029 20 15.8816 19.2446 17.2919 17.9998L20.0009 17.9998C18.1765 20.4288 15.2717 22 12 22ZM19 16V13H11V11H19V8L24 12L19 16Z"
  }));
},
    mw = function mw(_ref1247) {
  var _ref1247$color = _ref1247.color,
      C = _ref1247$color === void 0 ? "currentColor" : _ref1247$color,
      _ref1247$size = _ref1247.size,
      e = _ref1247$size === void 0 ? 24 : _ref1247$size,
      l = _ref1247.className,
      i = _objectWithoutProperties(_ref1247, _excluded1247);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5.50045 20C6.32888 20 7.00045 20.6715 7.00045 21.5C7.00045 22.3284 6.32888 23 5.50045 23C4.67203 23 4.00045 22.3284 4.00045 21.5C4.00045 20.6715 4.67203 20 5.50045 20ZM18.5005 20C19.3289 20 20.0005 20.6715 20.0005 21.5C20.0005 22.3284 19.3289 23 18.5005 23C17.672 23 17.0005 22.3284 17.0005 21.5C17.0005 20.6715 17.672 20 18.5005 20ZM2.17203 1.75732L5.99981 5.58532V16.9993L20.0005 17V19H5.00045C4.44817 19 4.00045 18.5522 4.00045 18L3.99981 6.41332L0.757812 3.17154L2.17203 1.75732ZM16.0005 2.99996C16.5527 2.99996 17.0005 3.44768 17.0005 3.99996L16.9998 5.99932L19.9936 5.99996C20.5497 5.99996 21.0005 6.45563 21.0005 6.99536V15.0046C21.0005 15.5543 20.5505 16 19.9936 16H8.0073C7.45123 16 7.00045 15.5443 7.00045 15.0046V6.99536C7.00045 6.44562 7.4504 5.99996 8.0073 5.99996L10.9998 5.99932L11.0005 3.99996C11.0005 3.44768 11.4482 2.99996 12.0005 2.99996H16.0005ZM11.0005 7.99996H10.0005V14H11.0005V7.99996ZM18.0005 7.99996H17.0005V14H18.0005V7.99996ZM15.0005 4.99996H13.0005V5.99996H15.0005V4.99996Z"
  }));
},
    ww = function ww(_ref1248) {
  var _ref1248$color = _ref1248.color,
      C = _ref1248$color === void 0 ? "currentColor" : _ref1248$color,
      _ref1248$size = _ref1248.size,
      e = _ref1248$size === void 0 ? 24 : _ref1248$size,
      l = _ref1248.className,
      i = _objectWithoutProperties(_ref1248, _excluded1248);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5.50045 20C6.32888 20 7.00045 20.6715 7.00045 21.5C7.00045 22.3284 6.32888 23 5.50045 23C4.67203 23 4.00045 22.3284 4.00045 21.5C4.00045 20.6715 4.67203 20 5.50045 20ZM18.5005 20C19.3289 20 20.0005 20.6715 20.0005 21.5C20.0005 22.3284 19.3289 23 18.5005 23C17.672 23 17.0005 22.3284 17.0005 21.5C17.0005 20.6715 17.672 20 18.5005 20ZM2.17203 1.75732L5.99981 5.58532V16.9993L20.0005 17V19H5.00045C4.44817 19 4.00045 18.5522 4.00045 18L3.99981 6.41332L0.757812 3.17154L2.17203 1.75732ZM16.0005 2.99996C16.5527 2.99996 17.0005 3.44768 17.0005 3.99996L16.9998 5.99932L19.9936 5.99996C20.5497 5.99996 21.0005 6.45563 21.0005 6.99536V15.0046C21.0005 15.5543 20.5505 16 19.9936 16H8.0073C7.45123 16 7.00045 15.5443 7.00045 15.0046V6.99536C7.00045 6.44562 7.4504 5.99996 8.0073 5.99996L10.9998 5.99932L11.0005 3.99996C11.0005 3.44768 11.4482 2.99996 12.0005 2.99996H16.0005ZM9.99981 7.99932L9.00045 7.99996V14L9.99981 13.9993V7.99932ZM15.9998 7.99932H11.9998V13.9993H15.9998V7.99932ZM19.0005 7.99996L17.9998 7.99932V13.9993L19.0005 14V7.99996ZM15.0005 4.99996H13.0005V5.99996H15.0005V4.99996Z"
  }));
},
    Lw = function Lw(_ref1249) {
  var _ref1249$color = _ref1249.color,
      C = _ref1249$color === void 0 ? "currentColor" : _ref1249$color,
      _ref1249$size = _ref1249.size,
      e = _ref1249$size === void 0 ? 24 : _ref1249$size,
      l = _ref1249.className,
      i = _objectWithoutProperties(_ref1249, _excluded1249);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15 3C15.5523 3 16 3.44772 16 4V6H20C20.5523 6 21 6.44772 21 7V19H23V21H1V19H3V7C3 6.44772 3.44772 6 4 6H8V4C8 3.44772 8.44772 3 9 3H15ZM10 8H8V19H10V8ZM16 8H14V19H16V8ZM14 5H10V6H14V5Z"
  }));
},
    hw = function hw(_ref1250) {
  var _ref1250$color = _ref1250.color,
      C = _ref1250$color === void 0 ? "currentColor" : _ref1250$color,
      _ref1250$size = _ref1250.size,
      e = _ref1250$size === void 0 ? 24 : _ref1250$size,
      l = _ref1250.className,
      i = _objectWithoutProperties(_ref1250, _excluded1250);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15 3C15.5523 3 16 3.44772 16 4V6H20C20.5523 6 21 6.44772 21 7V19H23V21H1V19H3V7C3 6.44772 3.44772 6 4 6H8V4C8 3.44772 8.44772 3 9 3H15ZM8 8H5V19H8V8ZM14 8H10V19H14V8ZM19 8H16V19H19V8ZM14 5H10V6H14V5Z"
  }));
},
    Hw = function Hw(_ref1251) {
  var _ref1251$color = _ref1251.color,
      C = _ref1251$color === void 0 ? "currentColor" : _ref1251$color,
      _ref1251$size = _ref1251.size,
      e = _ref1251$size === void 0 ? 24 : _ref1251$size,
      l = _ref1251.className,
      i = _objectWithoutProperties(_ref1251, _excluded1251);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8.5 5.5C9.91162 5.97054 10.5483 7.65881 10.8268 9.52302L6.30385 12.134L7.30385 13.866L11.014 11.7247C11.0598 13.0789 11 14.3085 11 15C11 18 10 21 6 21C2 21 2 21 2 17C2 9.5 5.50055 4.50018 8.5 5.5ZM22.0012 17L22.001 17.436C21.9956 21 21.8503 21 18.0012 21C14.0012 21 13.0013 18 13.0013 15C13.0013 14.3086 12.9415 13.0795 12.9872 11.7257L16.6962 13.866L17.6962 12.134L13.1743 9.52402C13.4527 7.65942 14.0894 5.97062 15.5013 5.5C18.5007 4.50018 22.0012 9.5 22.0012 17ZM13 2V11H11V2H13Z"
  }));
},
    Vw = function Vw(_ref1252) {
  var _ref1252$color = _ref1252.color,
      C = _ref1252$color === void 0 ? "currentColor" : _ref1252$color,
      _ref1252$size = _ref1252.size,
      e = _ref1252$size === void 0 ? 24 : _ref1252$size,
      l = _ref1252.className,
      i = _objectWithoutProperties(_ref1252, _excluded1252);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22.0013 17C22 21 22 21 18.0012 21C14.0012 21 13.0013 18 13.0013 15C13.0013 14.6216 12.9834 14.0822 12.9746 13.4495L14.9976 14.6186L15.0013 15C15.0013 17.7759 15.8173 19 18.0012 19C19.1415 19 19.6118 18.993 19.9637 18.9625C19.9943 18.6106 20.0012 18.1403 20.0012 17C20.0012 13.7947 19.298 10.9675 18.1657 9.09922C17.3283 7.71769 16.5533 7.2575 16.1337 7.39737C15.8411 7.49489 15.5286 8.04672 15.3027 9.02034L13.5124 7.98683C13.882 6.79047 14.4945 5.83557 15.5013 5.5C18.5007 4.50018 22.0036 9.5 22.0013 17ZM8.5 5.5C9.50665 5.83555 10.1192 6.79037 10.4888 7.98665L8.69853 9.02034C8.47269 8.04672 8.16013 7.49489 7.86754 7.39737C7.44794 7.2575 6.67292 7.71769 5.83557 9.09922C4.70322 10.9675 4 13.7947 4 17C4 18.1403 4.00698 18.6106 4.0375 18.9625C4.3894 18.993 4.85973 19 6 19C8.18395 19 9 17.7759 9 15L9.00367 14.6176L11.0266 13.4502C11.0179 14.0826 11 14.6218 11 15C11 18 10 21 6 21C2 21 2 21 2 17C2 9.5 5.50055 4.50018 8.5 5.5ZM13 2L12.9998 9.422L17.6962 12.134L16.6962 13.866L11.9998 11.155L7.30385 13.866L6.30385 12.134L10.9998 9.422L11 2H13Z"
  }));
},
    gw = function gw(_ref1253) {
  var _ref1253$color = _ref1253.color,
      C = _ref1253$color === void 0 ? "currentColor" : _ref1253$color,
      _ref1253$size = _ref1253.size,
      e = _ref1253$size === void 0 ? 24 : _ref1253$size,
      l = _ref1253.className,
      i = _objectWithoutProperties(_ref1253, _excluded1253);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14 18V20L16 21V22H8L7.99639 21.0036L10 20V18H2.9918C2.44405 18 2 17.5511 2 16.9925V4.00748C2 3.45107 2.45531 3 2.9918 3H21.0082C21.556 3 22 3.44892 22 4.00748V16.9925C22 17.5489 21.5447 18 21.0082 18H14ZM4 14V16H20V14H4Z"
  }));
},
    Mw = function Mw(_ref1254) {
  var _ref1254$color = _ref1254.color,
      C = _ref1254$color === void 0 ? "currentColor" : _ref1254$color,
      _ref1254$size = _ref1254.size,
      e = _ref1254$size === void 0 ? 24 : _ref1254$size,
      l = _ref1254.className,
      i = _objectWithoutProperties(_ref1254, _excluded1254);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14 18V20L16 21V22H8L7.99639 21.0036L10 20V18H2.9918C2.44405 18 2 17.5511 2 16.9925V4.00748C2 3.45107 2.45531 3 2.9918 3H21.0082C21.556 3 22 3.44892 22 4.00748V16.9925C22 17.5489 21.5447 18 21.0082 18H14ZM4 5V14H20V5H4Z"
  }));
},
    Zw = function Zw(_ref1255) {
  var _ref1255$color = _ref1255.color,
      C = _ref1255$color === void 0 ? "currentColor" : _ref1255$color,
      _ref1255$size = _ref1255.size,
      e = _ref1255$size === void 0 ? 24 : _ref1255$size,
      l = _ref1255.className,
      i = _objectWithoutProperties(_ref1255, _excluded1255);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 4.00685C2 3.45078 2.45531 3 2.9918 3H21.0082C21.556 3 22 3.44995 22 4.00685V17H2V4.00685ZM1 19H23V21H1V19Z"
  }));
},
    xw = function xw(_ref1256) {
  var _ref1256$color = _ref1256.color,
      C = _ref1256$color === void 0 ? "currentColor" : _ref1256$color,
      _ref1256$size = _ref1256.size,
      e = _ref1256$size === void 0 ? 24 : _ref1256$size,
      l = _ref1256.className,
      i = _objectWithoutProperties(_ref1256, _excluded1256);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 5V16H20V5H4ZM2 4.00748C2 3.45107 2.45531 3 2.9918 3H21.0082C21.556 3 22 3.44892 22 4.00748V18H2V4.00748ZM1 19H23V21H1V19Z"
  }));
},
    vw = function vw(_ref1257) {
  var _ref1257$color = _ref1257.color,
      C = _ref1257$color === void 0 ? "currentColor" : _ref1257$color,
      _ref1257$size = _ref1257.size,
      e = _ref1257$size === void 0 ? 24 : _ref1257$size,
      l = _ref1257.className,
      i = _objectWithoutProperties(_ref1257, _excluded1257);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15.2238 15.5079L13.0111 20.1581C12.8687 20.4573 12.5107 20.5844 12.2115 20.442C12.1448 20.4103 12.0845 20.3665 12.0337 20.3129L8.49229 16.5741C8.39749 16.474 8.27113 16.4096 8.13445 16.3918L3.02816 15.7243C2.69958 15.6814 2.46804 15.3802 2.51099 15.0516C2.52056 14.9784 2.54359 14.9075 2.5789 14.8426L5.04031 10.3192C5.1062 10.1981 5.12839 10.058 5.10314 9.92253L4.16 4.85991C4.09931 4.53414 4.3142 4.22086 4.63997 4.16017C4.7126 4.14664 4.78711 4.14664 4.85974 4.16017L9.92237 5.10331C10.0579 5.12855 10.198 5.10637 10.319 5.04048L14.8424 2.57907C15.1335 2.42068 15.4979 2.52825 15.6562 2.81931C15.6916 2.88421 15.7146 2.95507 15.7241 3.02833L16.3916 8.13462C16.4095 8.2713 16.4739 8.39766 16.5739 8.49245L20.3127 12.0338C20.5533 12.2617 20.5636 12.6415 20.3357 12.8821C20.2849 12.9357 20.2246 12.9795 20.1579 13.0112L15.5078 15.224C15.3833 15.2832 15.283 15.3835 15.2238 15.5079ZM16.0206 17.435L17.4348 16.0208L21.6775 20.2634L20.2633 21.6776L16.0206 17.435Z"
  }));
},
    dw = function dw(_ref1258) {
  var _ref1258$color = _ref1258.color,
      C = _ref1258$color === void 0 ? "currentColor" : _ref1258$color,
      _ref1258$size = _ref1258.size,
      e = _ref1258$size === void 0 ? 24 : _ref1258$size,
      l = _ref1258.className,
      i = _objectWithoutProperties(_ref1258, _excluded1258);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15.1986 9.94447C14.7649 9.5337 14.4859 8.98613 14.4085 8.39384L14.0056 5.31138L11.275 6.79724C10.7503 7.08274 10.1433 7.17888 9.55608 7.06948L6.49998 6.50015L7.06931 9.55625C7.17871 10.1435 7.08257 10.7505 6.79707 11.2751L5.31121 14.0057L8.39367 14.4086C8.98596 14.4861 9.53353 14.7651 9.94431 15.1987L12.0821 17.4557L13.4178 14.6486C13.6745 14.1092 14.109 13.6747 14.6484 13.418L17.4555 12.0823L15.1986 9.94447ZM15.2238 15.5079L13.0111 20.1581C12.8687 20.4573 12.5107 20.5844 12.2115 20.442C12.1448 20.4103 12.0845 20.3665 12.0337 20.3129L8.49229 16.5741C8.39749 16.474 8.27113 16.4096 8.13445 16.3918L3.02816 15.7243C2.69958 15.6814 2.46804 15.3802 2.51099 15.0516C2.52056 14.9784 2.54359 14.9075 2.5789 14.8426L5.04031 10.3192C5.1062 10.1981 5.12839 10.058 5.10314 9.92253L4.16 4.85991C4.09931 4.53414 4.3142 4.22086 4.63997 4.16017C4.7126 4.14664 4.78711 4.14664 4.85974 4.16017L9.92237 5.10331C10.0579 5.12855 10.198 5.10637 10.319 5.04048L14.8424 2.57907C15.1335 2.42068 15.4979 2.52825 15.6562 2.81931C15.6916 2.88421 15.7146 2.95507 15.7241 3.02833L16.3916 8.13462C16.4095 8.2713 16.4739 8.39766 16.5739 8.49245L20.3127 12.0338C20.5533 12.2617 20.5636 12.6415 20.3357 12.8821C20.2849 12.9357 20.2246 12.9795 20.1579 13.0112L15.5078 15.224C15.3833 15.2832 15.283 15.3835 15.2238 15.5079ZM16.0206 17.435L17.4348 16.0208L21.6775 20.2634L20.2633 21.6776L16.0206 17.435Z"
  }));
},
    pw = function pw(_ref1259) {
  var _ref1259$color = _ref1259.color,
      C = _ref1259$color === void 0 ? "currentColor" : _ref1259$color,
      _ref1259$size = _ref1259.size,
      e = _ref1259$size === void 0 ? 24 : _ref1259$size,
      l = _ref1259.className,
      i = _objectWithoutProperties(_ref1259, _excluded1259);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22 13.3414C21.3744 13.1203 20.7013 13 20 13C16.6863 13 14 15.6863 14 19C14 19.7013 14.1203 20.3744 14.3414 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V13.3414ZM12.0606 11.6829L5.64722 6.2377L4.35278 7.7623L12.0731 14.3171L19.6544 7.75616L18.3456 6.24384L12.0606 11.6829ZM21 18H24V20H21V23H19V20H16V18H19V15H21V18Z"
  }));
},
    Ew = function Ew(_ref1260) {
  var _ref1260$color = _ref1260.color,
      C = _ref1260$color === void 0 ? "currentColor" : _ref1260$color,
      _ref1260$size = _ref1260.size,
      e = _ref1260$size === void 0 ? 24 : _ref1260$size,
      l = _ref1260.className,
      i = _objectWithoutProperties(_ref1260, _excluded1260);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22 13H20V7.23792L12.0718 14.338L4 7.21594V19H14V21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V13ZM4.51146 5L12.0619 11.662L19.501 5H4.51146ZM21 18H24V20H21V23H19V20H16V18H19V15H21V18Z"
  }));
},
    Nw = function Nw(_ref1261) {
  var _ref1261$color = _ref1261.color,
      C = _ref1261$color === void 0 ? "currentColor" : _ref1261$color,
      _ref1261$size = _ref1261.size,
      e = _ref1261$size === void 0 ? 24 : _ref1261$size,
      l = _ref1261.className,
      i = _objectWithoutProperties(_ref1261, _excluded1261);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22 13.3414C21.3744 13.1203 20.7013 13 20 13C16.6863 13 14 15.6863 14 19C14 19.7013 14.1203 20.3744 14.3414 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V13.3414ZM12.0606 11.6829L5.64722 6.2377L4.35278 7.7623L12.0731 14.3171L19.6544 7.75616L18.3456 6.24384L12.0606 11.6829ZM19 22L15.4645 18.4645L16.8787 17.0503L19 19.1716L22.5355 15.636L23.9497 17.0503L19 22Z"
  }));
},
    uw = function uw(_ref1262) {
  var _ref1262$color = _ref1262.color,
      C = _ref1262$color === void 0 ? "currentColor" : _ref1262$color,
      _ref1262$size = _ref1262.size,
      e = _ref1262$size === void 0 ? 24 : _ref1262$size,
      l = _ref1262.className,
      i = _objectWithoutProperties(_ref1262, _excluded1262);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22 14H20V7.23792L12.0718 14.338L4 7.21594V19H14V21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V14ZM4.51146 5L12.0619 11.662L19.501 5H4.51146ZM19 22L15.4645 18.4645L16.8787 17.0503L19 19.1716L22.5355 15.636L23.9497 17.0503L19 22Z"
  }));
},
    Bw = function Bw(_ref1263) {
  var _ref1263$color = _ref1263.color,
      C = _ref1263$color === void 0 ? "currentColor" : _ref1263$color,
      _ref1263$size = _ref1263.size,
      e = _ref1263$size === void 0 ? 24 : _ref1263$size,
      l = _ref1263.className,
      i = _objectWithoutProperties(_ref1263, _excluded1263);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22 13.3414C21.3744 13.1203 20.7013 13 20 13C16.6863 13 14 15.6863 14 19C14 19.7013 14.1203 20.3744 14.3414 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V13.3414ZM12.0606 11.6829L5.64722 6.2377L4.35278 7.7623L12.0731 14.3171L19.6544 7.75616L18.3456 6.24384L12.0606 11.6829ZM21.4142 19L23.5355 21.1213L22.1213 22.5355L20 20.4142L17.8787 22.5355L16.4645 21.1213L18.5858 19L16.4645 16.8787L17.8787 15.4645L20 17.5858L22.1213 15.4645L23.5355 16.8787L21.4142 19Z"
  }));
},
    fw = function fw(_ref1264) {
  var _ref1264$color = _ref1264.color,
      C = _ref1264$color === void 0 ? "currentColor" : _ref1264$color,
      _ref1264$size = _ref1264.size,
      e = _ref1264$size === void 0 ? 24 : _ref1264$size,
      l = _ref1264.className,
      i = _objectWithoutProperties(_ref1264, _excluded1264);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22 14H20V7.23792L12.0718 14.338L4 7.21594V19H15V21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V14ZM4.51146 5L12.0619 11.662L19.501 5H4.51146ZM21.4142 19L23.5355 21.1213L22.1213 22.5355L20 20.4142L17.8787 22.5355L16.4645 21.1213L18.5858 19L16.4645 16.8787L17.8787 15.4645L20 17.5858L22.1213 15.4645L23.5355 16.8787L21.4142 19Z"
  }));
},
    Rw = function Rw(_ref1265) {
  var _ref1265$color = _ref1265.color,
      C = _ref1265$color === void 0 ? "currentColor" : _ref1265$color,
      _ref1265$size = _ref1265.size,
      e = _ref1265$size === void 0 ? 24 : _ref1265$size,
      l = _ref1265.className,
      i = _objectWithoutProperties(_ref1265, _excluded1265);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22 12.8027C21.1175 12.2922 20.0929 12 19 12C15.6863 12 13 14.6863 13 18C13 19.0929 13.2922 20.1175 13.8027 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V12.8027ZM12.0606 11.6829L5.64722 6.2377L4.35278 7.7623L12.0731 14.3171L19.6544 7.75616L18.3456 6.24384L12.0606 11.6829ZM20 18H23L19 22L15 18H18V14H20V18Z"
  }));
},
    zw = function zw(_ref1266) {
  var _ref1266$color = _ref1266.color,
      C = _ref1266$color === void 0 ? "currentColor" : _ref1266$color,
      _ref1266$size = _ref1266.size,
      e = _ref1266$size === void 0 ? 24 : _ref1266$size,
      l = _ref1266.className,
      i = _objectWithoutProperties(_ref1266, _excluded1266);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 7.23792L12.0718 14.338L4 7.21594V19H13V21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V12H20V7.23792ZM19.501 5H4.51146L12.0619 11.662L19.501 5ZM20 18H23L19 22L15 18H18V14H20V18Z"
  }));
},
    Fw = function Fw(_ref1267) {
  var _ref1267$color = _ref1267.color,
      C = _ref1267$color === void 0 ? "currentColor" : _ref1267$color,
      _ref1267$size = _ref1267.size,
      e = _ref1267$size === void 0 ? 24 : _ref1267$size,
      l = _ref1267.className,
      i = _objectWithoutProperties(_ref1267, _excluded1267);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM12.0606 11.6829L5.64722 6.2377L4.35278 7.7623L12.0731 14.3171L19.6544 7.75616L18.3456 6.24384L12.0606 11.6829Z"
  }));
},
    Sw = function Sw(_ref1268) {
  var _ref1268$color = _ref1268.color,
      C = _ref1268$color === void 0 ? "currentColor" : _ref1268$color,
      _ref1268$size = _ref1268.size,
      e = _ref1268$size === void 0 ? 24 : _ref1268$size,
      l = _ref1268.className,
      i = _objectWithoutProperties(_ref1268, _excluded1268);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15.2657 11.5541L19.6544 7.75616L18.3456 6.24384L12.0606 11.6829L5.64722 6.2377L4.35278 7.7623L12.0554 14.3021C11.3865 15.3751 11 16.6424 11 18C11 19.0736 11.2417 20.0907 11.6736 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V12.2547C20.8662 11.4638 19.4872 11 18 11C17.0298 11 16.1057 11.1974 15.2657 11.5541ZM16.7066 20.7076C17.0982 20.895 17.5369 21 18 21C19.6569 21 21 19.6569 21 18C21 17.5369 20.895 17.0982 20.7076 16.7066L16.7066 20.7076ZM15.2924 19.2934L19.2934 15.2924C18.9018 15.105 18.4631 15 18 15C16.3431 15 15 16.3431 15 18C15 18.4631 15.105 18.9018 15.2924 19.2934ZM18 23C15.2386 23 13 20.7614 13 18C13 15.2386 15.2386 13 18 13C20.7614 13 23 15.2386 23 18C23 20.7614 20.7614 23 18 23Z"
  }));
},
    Aw = function Aw(_ref1269) {
  var _ref1269$color = _ref1269.color,
      C = _ref1269$color === void 0 ? "currentColor" : _ref1269$color,
      _ref1269$size = _ref1269.size,
      e = _ref1269$size === void 0 ? 24 : _ref1269$size,
      l = _ref1269.className,
      i = _objectWithoutProperties(_ref1269, _excluded1269);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 7.23792L12.0718 14.338L4 7.21594V19H11.0709C11.1719 19.7061 11.3783 20.3783 11.6736 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V12.2547C21.396 11.8334 20.7224 11.5049 20 11.2899V7.23792ZM19.501 5H4.51146L12.0619 11.662L19.501 5ZM16.7066 20.7076C17.0982 20.895 17.5369 21 18 21C19.6569 21 21 19.6569 21 18C21 17.5369 20.895 17.0982 20.7076 16.7066L16.7066 20.7076ZM15.2924 19.2934L19.2934 15.2924C18.9018 15.105 18.4631 15 18 15C16.3431 15 15 16.3431 15 18C15 18.4631 15.105 18.9018 15.2924 19.2934ZM18 23C15.2386 23 13 20.7614 13 18C13 15.2386 15.2386 13 18 13C20.7614 13 23 15.2386 23 18C23 20.7614 20.7614 23 18 23Z"
  }));
},
    kw = function kw(_ref1270) {
  var _ref1270$color = _ref1270.color,
      C = _ref1270$color === void 0 ? "currentColor" : _ref1270$color,
      _ref1270$size = _ref1270.size,
      e = _ref1270$size === void 0 ? 24 : _ref1270$size,
      l = _ref1270.className,
      i = _objectWithoutProperties(_ref1270, _excluded1270);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM20 7.23792L12.0718 14.338L4 7.21594V19H20V7.23792ZM4.51146 5L12.0619 11.662L19.501 5H4.51146Z"
  }));
},
    Pw = function Pw(_ref1271) {
  var _ref1271$color = _ref1271.color,
      C = _ref1271$color === void 0 ? "currentColor" : _ref1271$color,
      _ref1271$size = _ref1271.size,
      e = _ref1271$size === void 0 ? 24 : _ref1271$size,
      l = _ref1271.className,
      i = _objectWithoutProperties(_ref1271, _excluded1271);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22 11.9996C21.1643 11.3719 20.1256 11 19 11C16.581 11 14.5633 12.7178 14.1 15H13V21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V11.9996ZM12.0606 11.6829L5.64722 6.2377L4.35278 7.7623L12.0731 14.3171L19.6544 7.75616L18.3456 6.24384L12.0606 11.6829ZM22 17H23V22H15V17H16V16C16 14.3431 17.3431 13 19 13C20.6569 13 22 14.3431 22 16V17ZM20 17V16C20 15.4477 19.5523 15 19 15C18.4477 15 18 15.4477 18 16V17H20Z"
  }));
},
    Dw = function Dw(_ref1272) {
  var _ref1272$color = _ref1272.color,
      C = _ref1272$color === void 0 ? "currentColor" : _ref1272$color,
      _ref1272$size = _ref1272.size,
      e = _ref1272$size === void 0 ? 24 : _ref1272$size,
      l = _ref1272.className,
      i = _objectWithoutProperties(_ref1272, _excluded1272);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 7.23792L12.0718 14.338L4 7.21594V19H13V21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V11H20V7.23792ZM19.501 5H4.51146L12.0619 11.662L19.501 5ZM22 17H23V22H15V17H16V16C16 14.3431 17.3431 13 19 13C20.6569 13 22 14.3431 22 16V17ZM20 17V16C20 15.4477 19.5523 15 19 15C18.4477 15 18 15.4477 18 16V17H20Z"
  }));
},
    yw = function yw(_ref1273) {
  var _ref1273$color = _ref1273.color,
      C = _ref1273$color === void 0 ? "currentColor" : _ref1273$color,
      _ref1273$size = _ref1273.size,
      e = _ref1273$size === void 0 ? 24 : _ref1273$size,
      l = _ref1273.className,
      i = _objectWithoutProperties(_ref1273, _excluded1273);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2.24283 6.85435L11.4895 1.3086C11.8062 1.11865 12.2019 1.11872 12.5185 1.30878L21.7573 6.85433C21.9079 6.9447 22 7.10743 22 7.28303V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V7.28315C2 7.10748 2.09218 6.94471 2.24283 6.85435ZM18.3456 8.24383L12.0606 13.6829L5.64722 8.23769L4.35278 9.7623L12.0731 16.3171L19.6544 9.75615L18.3456 8.24383Z"
  }));
},
    bw = function bw(_ref1274) {
  var _ref1274$color = _ref1274.color,
      C = _ref1274$color === void 0 ? "currentColor" : _ref1274$color,
      _ref1274$size = _ref1274.size,
      e = _ref1274$size === void 0 ? 24 : _ref1274$size,
      l = _ref1274.className,
      i = _objectWithoutProperties(_ref1274, _excluded1274);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2.24283 6.85435L11.4895 1.3086C11.8062 1.11865 12.2019 1.11872 12.5185 1.30878L21.7573 6.85433C21.9079 6.9447 22 7.10743 22 7.28303V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V7.28315C2 7.10748 2.09218 6.94471 2.24283 6.85435ZM4 8.13261V19H20V8.13214L12.0037 3.33237L4 8.13261ZM12.0597 13.6983L17.3556 9.23532L18.6444 10.7647L12.074 16.3017L5.36401 10.7717L6.63599 9.2283L12.0597 13.6983Z"
  }));
},
    Tw = function Tw(_ref1275) {
  var _ref1275$color = _ref1275.color,
      C = _ref1275$color === void 0 ? "currentColor" : _ref1275$color,
      _ref1275$size = _ref1275.size,
      e = _ref1275$size === void 0 ? 24 : _ref1275$size,
      l = _ref1275.className,
      i = _objectWithoutProperties(_ref1275, _excluded1275);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 5.5V3.9934C2 3.44476 2.45531 3 2.9918 3H21.0082C21.556 3 22 3.44495 22 3.9934V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5551 2 20.0066V19H20V7.3L12 14.5L2 5.5ZM0 10H5V12H0V10ZM0 15H8V17H0V15Z"
  }));
},
    Uw = function Uw(_ref1276) {
  var _ref1276$color = _ref1276.color,
      C = _ref1276$color === void 0 ? "currentColor" : _ref1276$color,
      _ref1276$size = _ref1276.size,
      e = _ref1276$size === void 0 ? 24 : _ref1276$size,
      l = _ref1276.className,
      i = _objectWithoutProperties(_ref1276, _excluded1276);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 3C21.5523 3 22 3.44772 22 4V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5551 2 20.0066V19H20V7.3L12 14.5L2 5.5V4C2 3.44772 2.44772 3 3 3H21ZM8 15V17H0V15H8ZM5 10V12H0V10H5ZM19.5659 5H4.43414L12 11.8093L19.5659 5Z"
  }));
},
    Gw = function Gw(_ref1277) {
  var _ref1277$color = _ref1277.color,
      C = _ref1277$color === void 0 ? "currentColor" : _ref1277$color,
      _ref1277$size = _ref1277.size,
      e = _ref1277$size === void 0 ? 24 : _ref1277$size,
      l = _ref1277.className,
      i = _objectWithoutProperties(_ref1277, _excluded1277);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22 13.3414C21.3744 13.1203 20.7013 13 20 13C16.6863 13 14 15.6863 14 19C14 19.7013 14.1203 20.3744 14.3414 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V13.3414ZM12.0606 11.6829L5.64722 6.2377L4.35278 7.7623L12.0731 14.3171L19.6544 7.75616L18.3456 6.24384L12.0606 11.6829ZM17.05 19.5485C17.0172 19.3706 17 19.1873 17 19C17 18.8127 17.0172 18.6294 17.05 18.4515L16.0359 17.866L17.0359 16.134L18.0505 16.7197C18.3278 16.4824 18.6489 16.2948 19 16.1707V15H21V16.1707C21.3511 16.2948 21.6722 16.4824 21.9495 16.7197L22.9641 16.134L23.9641 17.866L22.95 18.4515C22.9828 18.6294 23 18.8127 23 19C23 19.1873 22.9828 19.3706 22.95 19.5485L23.9641 20.134L22.9641 21.866L21.9495 21.2803C21.6722 21.5176 21.3511 21.7052 21 21.8293V23H19V21.8293C18.6489 21.7052 18.3278 21.5176 18.0505 21.2803L17.0359 21.866L16.0359 20.134L17.05 19.5485ZM20 20C20.5523 20 21 19.5523 21 19C21 18.4477 20.5523 18 20 18C19.4477 18 19 18.4477 19 19C19 19.5523 19.4477 20 20 20Z"
  }));
},
    Iw = function Iw(_ref1278) {
  var _ref1278$color = _ref1278.color,
      C = _ref1278$color === void 0 ? "currentColor" : _ref1278$color,
      _ref1278$size = _ref1278.size,
      e = _ref1278$size === void 0 ? 24 : _ref1278$size,
      l = _ref1278.className,
      i = _objectWithoutProperties(_ref1278, _excluded1278);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 7.23792L12.0718 14.338L4 7.21594V19H14V21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V13H20V7.23792ZM19.501 5H4.51146L12.0619 11.662L19.501 5ZM17.05 19.5485C17.0172 19.3706 17 19.1873 17 19C17 18.8127 17.0172 18.6294 17.05 18.4515L16.0359 17.866L17.0359 16.134L18.0505 16.7197C18.3278 16.4824 18.6489 16.2948 19 16.1707V15H21V16.1707C21.3511 16.2948 21.6722 16.4824 21.9495 16.7197L22.9641 16.134L23.9641 17.866L22.95 18.4515C22.9828 18.6294 23 18.8127 23 19C23 19.1873 22.9828 19.3706 22.95 19.5485L23.9641 20.134L22.9641 21.866L21.9495 21.2803C21.6722 21.5176 21.3511 21.7052 21 21.8293V23H19V21.8293C18.6489 21.7052 18.3278 21.5176 18.0505 21.2803L17.0359 21.866L16.0359 20.134L17.05 19.5485ZM20 20C20.5523 20 21 19.5523 21 19C21 18.4477 20.5523 18 20 18C19.4477 18 19 18.4477 19 19C19 19.5523 19.4477 20 20 20Z"
  }));
},
    Ww = function Ww(_ref1279) {
  var _ref1279$color = _ref1279.color,
      C = _ref1279$color === void 0 ? "currentColor" : _ref1279$color,
      _ref1279$size = _ref1279.size,
      e = _ref1279$size === void 0 ? 24 : _ref1279$size,
      l = _ref1279.className,
      i = _objectWithoutProperties(_ref1279, _excluded1279);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22 14.044C21.2389 13.6947 20.3922 13.5 19.5 13.5C16.1863 13.5 13.5 16.1863 13.5 19.5C13.5 20.018 13.5656 20.5206 13.689 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V14.044ZM12.0606 11.6829L5.64722 6.2377L4.35278 7.7623L12.0731 14.3171L19.6544 7.75616L18.3456 6.24384L12.0606 11.6829ZM19.5 21.75L16.855 23.1406L17.3601 20.1953L15.2202 18.1094L18.1775 17.6797L19.5 15L20.8225 17.6797L23.7798 18.1094L21.6399 20.1953L22.145 23.1406L19.5 21.75Z"
  }));
},
    Ow = function Ow(_ref1280) {
  var _ref1280$color = _ref1280.color,
      C = _ref1280$color === void 0 ? "currentColor" : _ref1280$color,
      _ref1280$size = _ref1280.size,
      e = _ref1280$size === void 0 ? 24 : _ref1280$size,
      l = _ref1280.className,
      i = _objectWithoutProperties(_ref1280, _excluded1280);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22 13H20V7.23792L12.0718 14.338L4 7.21594V19H14V21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V13ZM4.51146 5L12.0619 11.662L19.501 5H4.51146ZM19.5 21.75L16.855 23.1406L17.3601 20.1953L15.2202 18.1094L18.1775 17.6797L19.5 15L20.8225 17.6797L23.7798 18.1094L21.6399 20.1953L22.145 23.1406L19.5 21.75Z"
  }));
},
    Kw = function Kw(_ref1281) {
  var _ref1281$color = _ref1281.color,
      C = _ref1281$color === void 0 ? "currentColor" : _ref1281$color,
      _ref1281$size = _ref1281.size,
      e = _ref1281$size === void 0 ? 24 : _ref1281$size,
      l = _ref1281.className,
      i = _objectWithoutProperties(_ref1281, _excluded1281);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18.8032 8.4928C19.4663 8.81764 20.2118 9 21 9C21.3425 9 21.6769 8.96557 22 8.89998V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H16.1C16.0344 3.32311 16 3.65753 16 4C16 5.23672 16.449 6.36857 17.1929 7.24142L12.0606 11.6829L5.64722 6.2377L4.35278 7.7623L12.0731 14.3171L18.8032 8.4928ZM21 7C19.3431 7 18 5.65685 18 4C18 2.34315 19.3431 1 21 1C22.6569 1 24 2.34315 24 4C24 5.65685 22.6569 7 21 7Z"
  }));
},
    Qw = function Qw(_ref1282) {
  var _ref1282$color = _ref1282.color,
      C = _ref1282$color === void 0 ? "currentColor" : _ref1282$color,
      _ref1282$size = _ref1282.size,
      e = _ref1282$size === void 0 ? 24 : _ref1282$size,
      l = _ref1282.className,
      i = _objectWithoutProperties(_ref1282, _excluded1282);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16.1 3C16.0344 3.32311 16 3.65753 16 4C16 4.34247 16.0344 4.67689 16.1 5H4.51146L12.0619 11.662L17.1098 7.14141C17.5363 7.66888 18.0679 8.10787 18.6728 8.42652L12.0718 14.338L4 7.21594V19H20V8.89998C20.3231 8.96557 20.6575 9 21 9C21.3425 9 21.6769 8.96557 22 8.89998V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H16.1ZM21 1C22.6569 1 24 2.34315 24 4C24 5.65685 22.6569 7 21 7C19.3431 7 18 5.65685 18 4C18 2.34315 19.3431 1 21 1Z"
  }));
},
    qw = function qw(_ref1283) {
  var _ref1283$color = _ref1283.color,
      C = _ref1283$color === void 0 ? "currentColor" : _ref1283$color,
      _ref1283$size = _ref1283.size,
      e = _ref1283$size === void 0 ? 24 : _ref1283$size,
      l = _ref1283.className,
      i = _objectWithoutProperties(_ref1283, _excluded1283);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 14.5V23.5L16.667 21H14V17H16.667L20 14.5ZM21 3C21.5523 3 22 3.44772 22 4L22.0009 14.5286C20.9393 13.578 19.5371 13 18 13C14.6863 13 12 15.6863 12 19C12 19.7015 12.1204 20.3749 12.3417 21.0007L3 21C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21ZM21 17C22.1046 17 23 17.8954 23 19C23 20.0544 22.1841 20.9182 21.1493 20.9945L21 21V17ZM5.64722 6.2377L4.35278 7.7623L12.0731 14.3171L19.6544 7.75616L18.3456 6.24384L12.06 11.682L5.64722 6.2377Z"
  }));
},
    jw = function jw(_ref1284) {
  var _ref1284$color = _ref1284.color,
      C = _ref1284$color === void 0 ? "currentColor" : _ref1284$color,
      _ref1284$size = _ref1284.size,
      e = _ref1284$size === void 0 ? 24 : _ref1284$size,
      l = _ref1284.className,
      i = _objectWithoutProperties(_ref1284, _excluded1284);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 14.5V23.5L16.667 21H14V17H16.667L20 14.5ZM21 3C21.5523 3 22 3.44772 22 4V13H20V7.237L12.0718 14.338L4 7.215V19H12V21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21ZM21 17C22.1046 17 23 17.8954 23 19C23 20.0544 22.1841 20.9182 21.1493 20.9945L21 21V17ZM19.5 5H4.511L12.061 11.662L19.5 5Z"
  }));
},
    Xw = function Xw(_ref1285) {
  var _ref1285$color = _ref1285.color,
      C = _ref1285$color === void 0 ? "currentColor" : _ref1285$color,
      _ref1285$size = _ref1285.size,
      e = _ref1285$size === void 0 ? 24 : _ref1285$size,
      l = _ref1285.className,
      i = _objectWithoutProperties(_ref1285, _excluded1285);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 5L9 2L15 5L21.303 2.2987C21.5569 2.18992 21.8508 2.30749 21.9596 2.56131C21.9862 2.62355 22 2.69056 22 2.75827V19L15 22L9 19L2.69696 21.7013C2.44314 21.8101 2.14921 21.6925 2.04043 21.4387C2.01375 21.3765 2 21.3094 2 21.2417V5ZM15 19.7639V7.17594L14.9352 7.20369L9 4.23607V16.8241L9.06476 16.7963L15 19.7639Z"
  }));
},
    Jw = function Jw(_ref1286) {
  var _ref1286$color = _ref1286.color,
      C = _ref1286$color === void 0 ? "currentColor" : _ref1286$color,
      _ref1286$size = _ref1286.size,
      e = _ref1286$size === void 0 ? 24 : _ref1286$size,
      l = _ref1286.className,
      i = _objectWithoutProperties(_ref1286, _excluded1286);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 5L9 2L15 5L21.303 2.2987C21.5569 2.18992 21.8508 2.30749 21.9596 2.56131C21.9862 2.62355 22 2.69056 22 2.75827V19L15 22L9 19L2.69696 21.7013C2.44314 21.8101 2.14921 21.6925 2.04043 21.4387C2.01375 21.3765 2 21.3094 2 21.2417V5ZM16 19.3955L20 17.6812V5.03308L16 6.74736V19.3955ZM14 19.2639V6.73607L10 4.73607V17.2639L14 19.2639ZM8 17.2526V4.60451L4 6.31879V18.9669L8 17.2526Z"
  }));
},
    Yw = function Yw(_ref1287) {
  var _ref1287$color = _ref1287.color,
      C = _ref1287$color === void 0 ? "currentColor" : _ref1287$color,
      _ref1287$size = _ref1287.size,
      e = _ref1287$size === void 0 ? 24 : _ref1287$size,
      l = _ref1287.className,
      i = _objectWithoutProperties(_ref1287, _excluded1287);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 5L9 2L15 5L21.303 2.2987C21.5569 2.18992 21.8508 2.30749 21.9596 2.56131C21.9862 2.62355 22 2.69056 22 2.75827V19L15 22L9 19L2.69696 21.7013C2.44314 21.8101 2.14921 21.6925 2.04043 21.4387C2.01375 21.3765 2 21.3094 2 21.2417V5Z"
  }));
},
    _w = function _w(_ref1288) {
  var _ref1288$color = _ref1288.color,
      C = _ref1288$color === void 0 ? "currentColor" : _ref1288$color,
      _ref1288$size = _ref1288.size,
      e = _ref1288$size === void 0 ? 24 : _ref1288$size,
      l = _ref1288.className,
      i = _objectWithoutProperties(_ref1288, _excluded1288);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 5L9 2L15 5L21.303 2.2987C21.5569 2.18992 21.8508 2.30749 21.9596 2.56131C21.9862 2.62355 22 2.69056 22 2.75827V19L15 22L9 19L2.69696 21.7013C2.44314 21.8101 2.14921 21.6925 2.04043 21.4387C2.01375 21.3765 2 21.3094 2 21.2417V5ZM14.9352 7.20369L8.93524 4.20369L4 6.31879V18.9669L9.06476 16.7963L15.0648 19.7963L20 17.6812V5.03308L14.9352 7.20369Z"
  }));
},
    $w = function $w(_ref1289) {
  var _ref1289$color = _ref1289.color,
      C = _ref1289$color === void 0 ? "currentColor" : _ref1289$color,
      _ref1289$size = _ref1289.size,
      e = _ref1289$size === void 0 ? 24 : _ref1289$size,
      l = _ref1289.className,
      i = _objectWithoutProperties(_ref1289, _excluded1289);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18.364 17.364L12 23.7279L5.63604 17.364C2.12132 13.8492 2.12132 8.15076 5.63604 4.63604C9.15076 1.12132 14.8492 1.12132 18.364 4.63604C21.8787 8.15076 21.8787 13.8492 18.364 17.364ZM12 13C13.1046 13 14 12.1046 14 11C14 9.89543 13.1046 9 12 9C10.8954 9 10 9.89543 10 11C10 12.1046 10.8954 13 12 13Z"
  }));
},
    eL = function eL(_ref1290) {
  var _ref1290$color = _ref1290.color,
      C = _ref1290$color === void 0 ? "currentColor" : _ref1290$color,
      _ref1290$size = _ref1290.size,
      e = _ref1290$size === void 0 ? 24 : _ref1290$size,
      l = _ref1290.className,
      i = _objectWithoutProperties(_ref1290, _excluded1290);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 23.7279L5.63604 17.364C2.12132 13.8492 2.12132 8.15076 5.63604 4.63604C9.15076 1.12132 14.8492 1.12132 18.364 4.63604C21.8787 8.15076 21.8787 13.8492 18.364 17.364L12 23.7279ZM16.9497 15.9497C19.6834 13.2161 19.6834 8.78392 16.9497 6.05025C14.2161 3.31658 9.78392 3.31658 7.05025 6.05025C4.31658 8.78392 4.31658 13.2161 7.05025 15.9497L12 20.8995L16.9497 15.9497ZM12 13C10.8954 13 10 12.1046 10 11C10 9.89543 10.8954 9 12 9C13.1046 9 14 9.89543 14 11C14 12.1046 13.1046 13 12 13Z"
  }));
},
    tL = function tL(_ref1291) {
  var _ref1291$color = _ref1291.color,
      C = _ref1291$color === void 0 ? "currentColor" : _ref1291$color,
      _ref1291$size = _ref1291.size,
      e = _ref1291$size === void 0 ? 24 : _ref1291$size,
      l = _ref1291.className,
      i = _objectWithoutProperties(_ref1291, _excluded1291);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11 19.9451C6.50005 19.4476 3 15.6326 3 11C3 6.02944 7.02944 2 12 2C16.9706 2 21 6.02944 21 11C21 15.6326 17.5 19.4476 13 19.9451V24H11V19.9451Z"
  }));
},
    CL = function CL(_ref1292) {
  var _ref1292$color = _ref1292.color,
      C = _ref1292$color === void 0 ? "currentColor" : _ref1292$color,
      _ref1292$size = _ref1292.size,
      e = _ref1292$size === void 0 ? 24 : _ref1292$size,
      l = _ref1292.className,
      i = _objectWithoutProperties(_ref1292, _excluded1292);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11 19.9451C6.50005 19.4476 3 15.6326 3 11C3 6.02944 7.02944 2 12 2C16.9706 2 21 6.02944 21 11C21 15.6326 17.5 19.4476 13 19.9451V24H11V19.9451ZM12 18C15.866 18 19 14.866 19 11C19 7.13401 15.866 4 12 4C8.13401 4 5 7.13401 5 11C5 14.866 8.13401 18 12 18Z"
  }));
},
    lL = function lL(_ref1293) {
  var _ref1293$color = _ref1293.color,
      C = _ref1293$color === void 0 ? "currentColor" : _ref1293$color,
      _ref1293$size = _ref1293.size,
      e = _ref1293$size === void 0 ? 24 : _ref1293$size,
      l = _ref1293.className,
      i = _objectWithoutProperties(_ref1293, _excluded1293);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11 17.9381C7.05369 17.446 4 14.0796 4 10C4 5.58172 7.58172 2 12 2C16.4183 2 20 5.58172 20 10C20 14.0796 16.9463 17.446 13 17.9381V21H11V17.9381ZM5 22H19V24H5V22Z"
  }));
},
    iL = function iL(_ref1294) {
  var _ref1294$color = _ref1294.color,
      C = _ref1294$color === void 0 ? "currentColor" : _ref1294$color,
      _ref1294$size = _ref1294.size,
      e = _ref1294$size === void 0 ? 24 : _ref1294$size,
      l = _ref1294.className,
      i = _objectWithoutProperties(_ref1294, _excluded1294);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11 17.9381C7.05369 17.446 4 14.0796 4 10C4 5.58172 7.58172 2 12 2C16.4183 2 20 5.58172 20 10C20 14.0796 16.9463 17.446 13 17.9381V21H11V17.9381ZM12 16C15.3137 16 18 13.3137 18 10C18 6.68629 15.3137 4 12 4C8.68629 4 6 6.68629 6 10C6 13.3137 8.68629 16 12 16ZM5 22H19V24H5V22Z"
  }));
},
    sL = function sL(_ref1295) {
  var _ref1295$color = _ref1295.color,
      C = _ref1295$color === void 0 ? "currentColor" : _ref1295$color,
      _ref1295$size = _ref1295.size,
      e = _ref1295$size === void 0 ? 24 : _ref1295$size,
      l = _ref1295.className,
      i = _objectWithoutProperties(_ref1295, _excluded1295);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17.6569 15.6569L12 21.3137L6.34315 15.6569C3.21895 12.5327 3.21895 7.46734 6.34315 4.34315C9.46734 1.21895 14.5327 1.21895 17.6569 4.34315C20.781 7.46734 20.781 12.5327 17.6569 15.6569ZM5 22H19V24H5V22Z"
  }));
},
    rL = function rL(_ref1296) {
  var _ref1296$color = _ref1296.color,
      C = _ref1296$color === void 0 ? "currentColor" : _ref1296$color,
      _ref1296$size = _ref1296.size,
      e = _ref1296$size === void 0 ? 24 : _ref1296$size,
      l = _ref1296.className,
      i = _objectWithoutProperties(_ref1296, _excluded1296);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 18.4853L16.2426 14.2426C18.5858 11.8995 18.5858 8.10051 16.2426 5.75736C13.8995 3.41421 10.1005 3.41421 7.75736 5.75736C5.41421 8.10051 5.41421 11.8995 7.75736 14.2426L12 18.4853ZM17.6569 15.6569L12 21.3137L6.34315 15.6569C3.21895 12.5327 3.21895 7.46734 6.34315 4.34315C9.46734 1.21895 14.5327 1.21895 17.6569 4.34315C20.781 7.46734 20.781 12.5327 17.6569 15.6569ZM5 22H19V24H5V22Z"
  }));
},
    cL = function cL(_ref1297) {
  var _ref1297$color = _ref1297.color,
      C = _ref1297$color === void 0 ? "currentColor" : _ref1297$color,
      _ref1297$size = _ref1297.size,
      e = _ref1297$size === void 0 ? 24 : _ref1297$size,
      l = _ref1297.className,
      i = _objectWithoutProperties(_ref1297, _excluded1297);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18.364 17.364L12 23.7279L5.63604 17.364C2.12132 13.8492 2.12132 8.15076 5.63604 4.63604C9.15076 1.12132 14.8492 1.12132 18.364 4.63604C21.8787 8.15076 21.8787 13.8492 18.364 17.364ZM11 10H8V12H11V15H13V12H16V10H13V7H11V10Z"
  }));
},
    oL = function oL(_ref1298) {
  var _ref1298$color = _ref1298.color,
      C = _ref1298$color === void 0 ? "currentColor" : _ref1298$color,
      _ref1298$size = _ref1298.size,
      e = _ref1298$size === void 0 ? 24 : _ref1298$size,
      l = _ref1298.className,
      i = _objectWithoutProperties(_ref1298, _excluded1298);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 20.8995L16.9497 15.9497C19.6834 13.2161 19.6834 8.78392 16.9497 6.05025C14.2161 3.31658 9.78392 3.31658 7.05025 6.05025C4.31658 8.78392 4.31658 13.2161 7.05025 15.9497L12 20.8995ZM12 23.7279L5.63604 17.364C2.12132 13.8492 2.12132 8.15076 5.63604 4.63604C9.15076 1.12132 14.8492 1.12132 18.364 4.63604C21.8787 8.15076 21.8787 13.8492 18.364 17.364L12 23.7279ZM11 10V7H13V10H16V12H13V15H11V12H8V10H11Z"
  }));
},
    aL = function aL(_ref1299) {
  var _ref1299$color = _ref1299.color,
      C = _ref1299$color === void 0 ? "currentColor" : _ref1299$color,
      _ref1299$size = _ref1299.size,
      e = _ref1299$size === void 0 ? 24 : _ref1299$size,
      l = _ref1299.className,
      i = _objectWithoutProperties(_ref1299, _excluded1299);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18.364 17.364L12 23.7279L5.63604 17.364C2.12132 13.8492 2.12132 8.15076 5.63604 4.63604C9.15076 1.12132 14.8492 1.12132 18.364 4.63604C21.8787 8.15076 21.8787 13.8492 18.364 17.364ZM12 15C14.2091 15 16 13.2091 16 11C16 8.79086 14.2091 7 12 7C9.79086 7 8 8.79086 8 11C8 13.2091 9.79086 15 12 15ZM12 13C10.8954 13 10 12.1046 10 11C10 9.89543 10.8954 9 12 9C13.1046 9 14 9.89543 14 11C14 12.1046 13.1046 13 12 13Z"
  }));
},
    nL = function nL(_ref1300) {
  var _ref1300$color = _ref1300.color,
      C = _ref1300$color === void 0 ? "currentColor" : _ref1300$color,
      _ref1300$size = _ref1300.size,
      e = _ref1300$size === void 0 ? 24 : _ref1300$size,
      l = _ref1300.className,
      i = _objectWithoutProperties(_ref1300, _excluded1300);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 20.8995L16.9497 15.9497C19.6834 13.2161 19.6834 8.78392 16.9497 6.05025C14.2161 3.31658 9.78392 3.31658 7.05025 6.05025C4.31658 8.78392 4.31658 13.2161 7.05025 15.9497L12 20.8995ZM12 23.7279L5.63604 17.364C2.12132 13.8492 2.12132 8.15076 5.63604 4.63604C9.15076 1.12132 14.8492 1.12132 18.364 4.63604C21.8787 8.15076 21.8787 13.8492 18.364 17.364L12 23.7279ZM12 13C13.1046 13 14 12.1046 14 11C14 9.89543 13.1046 9 12 9C10.8954 9 10 9.89543 10 11C10 12.1046 10.8954 13 12 13ZM12 15C9.79086 15 8 13.2091 8 11C8 8.79086 9.79086 7 12 7C14.2091 7 16 8.79086 16 11C16 13.2091 14.2091 15 12 15Z"
  }));
},
    mL = function mL(_ref1301) {
  var _ref1301$color = _ref1301.color,
      C = _ref1301$color === void 0 ? "currentColor" : _ref1301$color,
      _ref1301$size = _ref1301.size,
      e = _ref1301$size === void 0 ? 24 : _ref1301$size,
      l = _ref1301.className,
      i = _objectWithoutProperties(_ref1301, _excluded1301);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11 17.9381C7.05369 17.446 4 14.0796 4 10C4 5.58172 7.58172 2 12 2C16.4183 2 20 5.58172 20 10C20 14.0796 16.9463 17.446 13 17.9381V20.0116C16.9463 20.1039 20 20.7351 20 21.5C20 22.3284 16.4183 23 12 23C7.58172 23 4 22.3284 4 21.5C4 20.7351 7.05369 20.1039 11 20.0116V17.9381ZM12 12C13.1046 12 14 11.1046 14 10C14 8.89543 13.1046 8 12 8C10.8954 8 10 8.89543 10 10C10 11.1046 10.8954 12 12 12Z"
  }));
},
    wL = function wL(_ref1302) {
  var _ref1302$color = _ref1302.color,
      C = _ref1302$color === void 0 ? "currentColor" : _ref1302$color,
      _ref1302$size = _ref1302.size,
      e = _ref1302$size === void 0 ? 24 : _ref1302$size,
      l = _ref1302.className,
      i = _objectWithoutProperties(_ref1302, _excluded1302);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11 17.9381C7.05369 17.446 4 14.0796 4 10C4 5.58172 7.58172 2 12 2C16.4183 2 20 5.58172 20 10C20 14.0796 16.9463 17.446 13 17.9381V20.0116C16.9463 20.1039 20 20.7351 20 21.5C20 22.3284 16.4183 23 12 23C7.58172 23 4 22.3284 4 21.5C4 20.7351 7.05369 20.1039 11 20.0116V17.9381ZM12 16C15.3137 16 18 13.3137 18 10C18 6.68629 15.3137 4 12 4C8.68629 4 6 6.68629 6 10C6 13.3137 8.68629 16 12 16ZM12 12C10.8954 12 10 11.1046 10 10C10 8.89543 10.8954 8 12 8C13.1046 8 14 8.89543 14 10C14 11.1046 13.1046 12 12 12Z"
  }));
},
    LL = function LL(_ref1303) {
  var _ref1303$color = _ref1303.color,
      C = _ref1303$color === void 0 ? "currentColor" : _ref1303$color,
      _ref1303$size = _ref1303.size,
      e = _ref1303$size === void 0 ? 24 : _ref1303$size,
      l = _ref1303.className,
      i = _objectWithoutProperties(_ref1303, _excluded1303);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13 11V6H11V13H17V11H13ZM18.364 17.364L12 23.7279L5.63604 17.364C2.12132 13.8492 2.12132 8.15076 5.63604 4.63604C9.15076 1.12132 14.8492 1.12132 18.364 4.63604C21.8787 8.15076 21.8787 13.8492 18.364 17.364Z"
  }));
},
    hL = function hL(_ref1304) {
  var _ref1304$color = _ref1304.color,
      C = _ref1304$color === void 0 ? "currentColor" : _ref1304$color,
      _ref1304$size = _ref1304.size,
      e = _ref1304$size === void 0 ? 24 : _ref1304$size,
      l = _ref1304.className,
      i = _objectWithoutProperties(_ref1304, _excluded1304);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16.9497 15.9497C19.6834 13.2161 19.6834 8.78392 16.9497 6.05025C14.2161 3.31658 9.78392 3.31658 7.05025 6.05025C4.31658 8.78392 4.31658 13.2161 7.05025 15.9497L12 20.8995L16.9497 15.9497ZM12 23.7279L5.63604 17.364C2.12132 13.8492 2.12132 8.15076 5.63604 4.63604C9.15076 1.12132 14.8492 1.12132 18.364 4.63604C21.8787 8.15076 21.8787 13.8492 18.364 17.364L12 23.7279ZM13 11H17V13H11V6H13V11Z"
  }));
},
    HL = function HL(_ref1305) {
  var _ref1305$color = _ref1305.color,
      C = _ref1305$color === void 0 ? "currentColor" : _ref1305$color,
      _ref1305$size = _ref1305.size,
      e = _ref1305$size === void 0 ? 24 : _ref1305$size,
      l = _ref1305.className,
      i = _objectWithoutProperties(_ref1305, _excluded1305);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17.0839 15.812C19.6827 13.0691 19.6379 8.73845 16.9497 6.05025C14.2161 3.31658 9.78392 3.31658 7.05025 6.05025C4.36205 8.73845 4.31734 13.0691 6.91612 15.812C7.97763 14.1228 9.8577 13 12 13C14.1423 13 16.0224 14.1228 17.0839 15.812ZM12 23.7279L5.63604 17.364C2.12132 13.8492 2.12132 8.15076 5.63604 4.63604C9.15076 1.12132 14.8492 1.12132 18.364 4.63604C21.8787 8.15076 21.8787 13.8492 18.364 17.364L12 23.7279ZM12 12C10.3431 12 9 10.6569 9 9C9 7.34315 10.3431 6 12 6C13.6569 6 15 7.34315 15 9C15 10.6569 13.6569 12 12 12Z"
  }));
},
    VL = function VL(_ref1306) {
  var _ref1306$color = _ref1306.color,
      C = _ref1306$color === void 0 ? "currentColor" : _ref1306$color,
      _ref1306$size = _ref1306.size,
      e = _ref1306$size === void 0 ? 24 : _ref1306$size,
      l = _ref1306.className,
      i = _objectWithoutProperties(_ref1306, _excluded1306);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17.0839 15.812C19.6827 13.0691 19.6379 8.73845 16.9497 6.05025C14.2161 3.31658 9.78392 3.31658 7.05025 6.05025C4.36205 8.73845 4.31734 13.0691 6.91612 15.812C7.97763 14.1228 9.8577 13 12 13C14.1423 13 16.0224 14.1228 17.0839 15.812ZM8.38535 17.2848L12 20.8995L15.6147 17.2848C14.9725 15.9339 13.5953 15 12 15C10.4047 15 9.0275 15.9339 8.38535 17.2848ZM12 23.7279L5.63604 17.364C2.12132 13.8492 2.12132 8.15076 5.63604 4.63604C9.15076 1.12132 14.8492 1.12132 18.364 4.63604C21.8787 8.15076 21.8787 13.8492 18.364 17.364L12 23.7279ZM12 10C12.5523 10 13 9.55228 13 9C13 8.44772 12.5523 8 12 8C11.4477 8 11 8.44772 11 9C11 9.55228 11.4477 10 12 10ZM12 12C10.3431 12 9 10.6569 9 9C9 7.34315 10.3431 6 12 6C13.6569 6 15 7.34315 15 9C15 10.6569 13.6569 12 12 12Z"
  }));
},
    gL = function gL(_ref1307) {
  var _ref1307$color = _ref1307.color,
      C = _ref1307$color === void 0 ? "currentColor" : _ref1307$color,
      _ref1307$size = _ref1307.size,
      e = _ref1307$size === void 0 ? 24 : _ref1307$size,
      l = _ref1307.className,
      i = _objectWithoutProperties(_ref1307, _excluded1307);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15.9498 2.39017L21.6066 8.04702C21.9972 8.43755 21.9972 9.07071 21.6066 9.46124L13.8285 17.2394L11.7071 17.9465L10.2929 19.3607C9.90241 19.7513 9.26925 19.7513 8.87872 19.3607L4.63608 15.1181C4.24556 14.7276 4.24556 14.0944 4.63608 13.7039L6.0503 12.2897L6.7574 10.1683L14.5356 2.39017C14.9261 1.99964 15.5593 1.99964 15.9498 2.39017ZM16.6569 5.9257L10.2929 12.2897L11.7071 13.7039L18.0711 7.33992L16.6569 5.9257ZM4.28253 16.8859L7.11096 19.7143L5.69674 21.1285L1.4541 19.7143L4.28253 16.8859Z"
  }));
},
    ML = function ML(_ref1308) {
  var _ref1308$color = _ref1308.color,
      C = _ref1308$color === void 0 ? "currentColor" : _ref1308$color,
      _ref1308$size = _ref1308.size,
      e = _ref1308$size === void 0 ? 24 : _ref1308$size,
      l = _ref1308.className,
      i = _objectWithoutProperties(_ref1308, _excluded1308);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15.2427 4.51149L8.50547 11.2487L7.79836 13.37L6.7574 14.411L9.58583 17.2394L10.6268 16.1985L12.7481 15.4913L19.4853 8.75413L15.2427 4.51149ZM21.6066 8.04702C21.9972 8.43755 21.9972 9.07071 21.6066 9.46124L13.8285 17.2394L11.7071 17.9465L10.2929 19.3607C9.90241 19.7513 9.26925 19.7513 8.87872 19.3607L4.63608 15.1181C4.24556 14.7276 4.24556 14.0944 4.63608 13.7039L6.0503 12.2897L6.7574 10.1683L14.5356 2.39017C14.9261 1.99964 15.5593 1.99964 15.9498 2.39017L21.6066 8.04702ZM15.2427 7.33992L16.6569 8.75413L11.7071 13.7039L10.2929 12.2897L15.2427 7.33992ZM4.28253 16.8859L7.11096 19.7143L5.69674 21.1285L1.4541 19.7143L4.28253 16.8859Z"
  }));
},
    ZL = function ZL(_ref1309) {
  var _ref1309$color = _ref1309.color,
      C = _ref1309$color === void 0 ? "currentColor" : _ref1309$color,
      _ref1309$size = _ref1309.size,
      e = _ref1309$size === void 0 ? 24 : _ref1309$size,
      l = _ref1309.className,
      i = _objectWithoutProperties(_ref1309, _excluded1309);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM7 15.5V11.5L9 13.5L11 11.5V15.5H13V8.5H11L9 10.5L7 8.5H5V15.5H7ZM18 12.5V8.5H16V12.5H14L17 15.5L20 12.5H18Z"
  }));
},
    xL = function xL(_ref1310) {
  var _ref1310$color = _ref1310.color,
      C = _ref1310$color === void 0 ? "currentColor" : _ref1310$color,
      _ref1310$size = _ref1310.size,
      e = _ref1310$size === void 0 ? 24 : _ref1310$size,
      l = _ref1310.className,
      i = _objectWithoutProperties(_ref1310, _excluded1310);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM4 5V19H20V5H4ZM7 15.5H5V8.5H7L9 10.5L11 8.5H13V15.5H11V11.5L9 13.5L7 11.5V15.5ZM18 12.5H20L17 15.5L14 12.5H16V8.5H18V12.5Z"
  }));
},
    vL = function vL(_ref1311) {
  var _ref1311$color = _ref1311.color,
      C = _ref1311$color === void 0 ? "currentColor" : _ref1311$color,
      _ref1311$size = _ref1311.size,
      e = _ref1311$size === void 0 ? 24 : _ref1311$size,
      l = _ref1311.className,
      i = _objectWithoutProperties(_ref1311, _excluded1311);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 21.9967C6.47715 21.9967 2 17.5195 2 11.9967C2 6.47384 6.47715 1.99669 12 1.99669C17.5228 1.99669 22 6.47384 22 11.9967C22 17.5195 17.5228 21.9967 12 21.9967ZM17.051 18.2008L16.1894 14.7542C16.0781 14.309 15.6781 13.9967 15.2192 13.9967H8.78078C8.32191 13.9967 7.92193 14.309 7.81063 14.7542L6.94897 18.2008C8.32629 19.3235 10.0845 19.9967 12 19.9967C13.9155 19.9967 15.6737 19.3235 17.051 18.2008ZM10 11.9967H14V10.4967L12.9615 6.86202C12.8666 6.52981 12.6069 6.27014 12.2747 6.17522C11.7437 6.0235 11.1902 6.33099 11.0385 6.86202L10 10.4967V11.9967Z"
  }));
},
    dL = function dL(_ref1312) {
  var _ref1312$color = _ref1312.color,
      C = _ref1312$color === void 0 ? "currentColor" : _ref1312$color,
      _ref1312$size = _ref1312.size,
      e = _ref1312$size === void 0 ? 24 : _ref1312$size,
      l = _ref1312.className,
      i = _objectWithoutProperties(_ref1312, _excluded1312);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10 10.4967L11.0385 6.86202C11.1902 6.33099 11.7437 6.0235 12.2747 6.17522C12.6069 6.27014 12.8666 6.52981 12.9615 6.86202L14 10.4967V11.9967H14.7192C15.1781 11.9967 15.5781 12.309 15.6894 12.7542L17.051 18.2008C18.8507 16.7339 20 14.4995 20 11.9967C20 7.57841 16.4183 3.99669 12 3.99669C7.58172 3.99669 4 7.57841 4 11.9967C4 14.4995 5.14932 16.7339 6.94897 18.2008L8.31063 12.7542C8.42193 12.309 8.82191 11.9967 9.28078 11.9967H10V10.4967ZM12 19.9967C12.2415 19.9967 12.4813 19.986 12.7189 19.9649C13.6187 19.8847 14.4756 19.6556 15.2649 19.3023L13.9384 13.9967H10.0616L8.73514 19.3023C9.52438 19.6556 10.3813 19.8847 11.2811 19.9648C11.5187 19.986 11.7585 19.9967 12 19.9967ZM12 21.9967C6.47715 21.9967 2 17.5195 2 11.9967C2 6.47384 6.47715 1.99669 12 1.99669C17.5228 1.99669 22 6.47384 22 11.9967C22 17.5195 17.5228 21.9967 12 21.9967Z"
  }));
},
    pL = function pL(_ref1313) {
  var _ref1313$color = _ref1313.color,
      C = _ref1313$color === void 0 ? "currentColor" : _ref1313$color,
      _ref1313$size = _ref1313.size,
      e = _ref1313$size === void 0 ? 24 : _ref1313$size,
      l = _ref1313.className,
      i = _objectWithoutProperties(_ref1313, _excluded1313);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.001 6.65407C13.5816 7.89878 14.5965 9.82972 14.5965 11.9977C14.5965 14.1657 13.5816 16.0966 12.001 17.3413C10.4204 16.0966 9.40547 14.1657 9.40547 11.9977C9.40547 9.82972 10.4204 7.89878 12.001 6.65407ZM11.1316 6.0717C9.46024 7.50229 8.40098 9.62742 8.40098 12C8.40098 14.371 9.45891 16.4949 11.1285 17.9255C10.1444 18.4795 9.00847 18.7955 7.79873 18.7955C4.04443 18.7955 1.00098 15.752 1.00098 11.9977C1.00098 8.24341 4.04443 5.19995 7.79873 5.19995C9.00976 5.19995 10.1468 5.51663 11.1316 6.0717ZM12.8735 17.9255C14.543 16.4949 15.601 14.371 15.601 12C15.601 9.62742 14.5417 7.50229 12.8703 6.0717C13.8551 5.51663 14.9922 5.19995 16.2032 5.19995C19.9575 5.19995 23.001 8.24341 23.001 11.9977C23.001 15.752 19.9575 18.7955 16.2032 18.7955C14.9935 18.7955 13.8576 18.4795 12.8735 17.9255Z"
  }));
},
    EL = function EL(_ref1314) {
  var _ref1314$color = _ref1314.color,
      C = _ref1314$color === void 0 ? "currentColor" : _ref1314$color,
      _ref1314$size = _ref1314.size,
      e = _ref1314$size === void 0 ? 24 : _ref1314$size,
      l = _ref1314.className,
      i = _objectWithoutProperties(_ref1314, _excluded1314);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.001 18.2942C10.916 18.9333 9.65132 19.3 8.30098 19.3C4.2693 19.3 1.00098 16.0316 1.00098 12C1.00098 7.96827 4.2693 4.69995 8.30098 4.69995C9.65132 4.69995 10.916 5.06659 12.001 5.70575C13.0859 5.06659 14.3506 4.69995 15.701 4.69995C19.7327 4.69995 23.001 7.96827 23.001 12C23.001 16.0316 19.7327 19.3 15.701 19.3C14.3506 19.3 13.0859 18.9333 12.001 18.2942ZM13.7027 16.9103C14.3194 17.1615 14.994 17.3 15.701 17.3C18.6281 17.3 21.001 14.9271 21.001 12C21.001 9.07284 18.6281 6.69995 15.701 6.69995C14.994 6.69995 14.3194 6.83837 13.7027 7.08957C14.8821 8.38619 15.601 10.1091 15.601 12C15.601 13.8908 14.8821 15.6137 13.7027 16.9103ZM10.2992 7.08957C9.68255 6.83837 9.00793 6.69995 8.30098 6.69995C5.37387 6.69995 3.00098 9.07284 3.00098 12C3.00098 14.9271 5.37387 17.3 8.30098 17.3C9.00793 17.3 9.68255 17.1615 10.2992 16.9103C9.11986 15.6137 8.40098 13.8908 8.40098 12C8.40098 10.1091 9.11986 8.38619 10.2992 7.08957ZM12.001 8.20521C11.0139 9.16781 10.401 10.5123 10.401 12C10.401 13.4876 11.0139 14.8321 12.001 15.7947C12.9881 14.8321 13.601 13.4876 13.601 12C13.601 10.5123 12.9881 9.16781 12.001 8.20521Z"
  }));
},
    NL = function NL(_ref1315) {
  var _ref1315$color = _ref1315.color,
      C = _ref1315$color === void 0 ? "currentColor" : _ref1315$color,
      _ref1315$size = _ref1315.size,
      e = _ref1315$size === void 0 ? 24 : _ref1315$size,
      l = _ref1315.className,
      i = _objectWithoutProperties(_ref1315, _excluded1315);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21.2595 13.9898C20.9852 15.4006 18.8033 16.9446 16.2974 17.2439C14.9907 17.3998 13.7041 17.5431 12.3321 17.4802C10.0885 17.3774 8.31809 16.9446 8.31809 16.9446C8.31809 17.163 8.33156 17.371 8.3585 17.5655C8.65019 19.7797 10.5541 19.9124 12.3576 19.9742C14.1779 20.0365 15.7987 19.5254 15.7987 19.5254L15.8735 21.1711C15.8735 21.1711 14.6003 21.8548 12.3321 21.9805C11.0814 22.0493 9.52849 21.9491 7.71973 21.4703C3.79684 20.432 3.12219 16.2504 3.01896 12.0074C2.98749 10.7477 3.00689 9.55981 3.00689 8.56632C3.00689 4.22771 5.84955 2.95599 5.84955 2.95599C7.2829 2.29772 9.74238 2.0209 12.2993 2H12.3621C14.919 2.0209 17.3801 2.29772 18.8133 2.95599C18.8133 2.95599 21.6559 4.22771 21.6559 8.56632C21.6559 8.56632 21.6916 11.7674 21.2595 13.9898ZM18.3029 8.9029C18.3029 7.82924 18.0295 6.97604 17.4805 6.34482C16.9142 5.71359 16.1726 5.39001 15.2522 5.39001C14.187 5.39001 13.3805 5.79937 12.8473 6.61819L12.3288 7.48723L11.8104 6.61819C11.2771 5.79937 10.4706 5.39001 9.40554 5.39001C8.485 5.39001 7.74344 5.71359 7.17719 6.34482C6.62807 6.97604 6.3547 7.82924 6.3547 8.9029V14.1562H8.43597V9.05731C8.43597 7.98246 8.88822 7.4369 9.79281 7.4369C10.793 7.4369 11.2944 8.08408 11.2944 9.36376V12.1547H13.3634V9.36376C13.3634 8.08408 13.8646 7.4369 14.8648 7.4369C15.7694 7.4369 16.2216 7.98246 16.2216 9.05731V14.1562H18.3029V8.9029Z"
  }));
},
    uL = function uL(_ref1316) {
  var _ref1316$color = _ref1316.color,
      C = _ref1316$color === void 0 ? "currentColor" : _ref1316$color,
      _ref1316$size = _ref1316.size,
      e = _ref1316$size === void 0 ? 24 : _ref1316$size,
      l = _ref1316.className,
      i = _objectWithoutProperties(_ref1316, _excluded1316);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3.019 12.0075C2.98744 10.7478 3.00692 9.5598 3.00692 8.56644C3.00692 4.22767 5.84954 2.95597 5.84954 2.95597C7.28286 2.29767 9.74238 2.0209 12.2993 2H12.3621C14.919 2.0209 17.3801 2.29767 18.8134 2.95597C18.8134 2.95597 21.656 4.22767 21.656 8.56644C21.656 8.56644 21.6916 11.7674 21.2596 13.9898C20.9852 15.4007 18.8034 16.9446 16.2974 17.2438C14.9906 17.3999 13.7042 17.5431 12.3322 17.4802C10.0885 17.3775 8.31815 16.9446 8.31815 16.9446C8.31815 17.1631 8.33166 17.3711 8.35853 17.5655C8.44182 18.1978 8.65659 18.6604 8.96296 19C9.72944 19.8497 11.0692 19.9301 12.3577 19.9743C14.178 20.0366 15.7986 19.5254 15.7986 19.5254L15.8735 21.1712C15.8735 21.1712 14.6003 21.8548 12.3322 21.9805C11.0815 22.0493 9.52858 21.9491 7.71969 21.4704C6.18802 21.065 5.15153 20.1804 4.45091 19C3.35714 17.1573 3.08191 14.5938 3.019 12.0075ZM6.31815 16.9446V14.3967L8.79316 15.0018C8.8405 15.0134 8.95098 15.0383 9.11692 15.0723C9.40521 15.1313 9.73416 15.1908 10.0959 15.2467C10.8485 15.3628 11.6341 15.4462 12.4237 15.4823C13.4425 15.529 14.3249 15.4652 16.0603 15.2579C17.7233 15.0594 19.208 14.0622 19.2963 13.6082C19.3783 13.1861 19.4472 12.6858 19.5021 12.1261C19.5714 11.4205 19.6155 10.6558 19.6388 9.88068C19.654 9.37026 19.6582 8.93648 19.6564 8.62452L19.656 8.56644C19.656 7.1368 19.2873 6.12756 18.6928 5.40793C18.5008 5.17553 18.3004 4.99408 18.1087 4.85958C18.0183 4.79617 17.9737 4.77136 17.9787 4.77345C16.9662 4.30844 14.8859 4.02069 12.3621 3.99993H12.3156C9.77596 4.02069 7.6969 4.30836 6.66627 4.78161C6.68919 4.77136 6.64459 4.79617 6.55423 4.85958C6.36257 4.99408 6.16214 5.17553 5.97016 5.40793C5.37568 6.12756 5.00692 7.1368 5.00692 8.56644C5.00692 8.7976 5.00628 8.96339 5.00392 9.44137C4.9981 10.6238 5.00004 11.2256 5.01841 11.9589C5.07185 14.156 5.2822 15.7941 5.71797 17C5.93023 17.5874 6.19005 18.0709 6.49741 18.4507C6.37791 18.0162 6.31815 17.5142 6.31815 16.9446ZM8.08576 6.37135C8.71735 6.37135 9.22924 6.88324 9.22924 7.51482C9.22924 8.14626 8.71735 8.6583 8.08576 8.6583C7.45432 8.6583 6.94229 8.14626 6.94229 7.51482C6.94229 6.88324 7.45432 6.37135 8.08576 6.37135Z"
  }));
},
    BL = function BL(_ref1317) {
  var _ref1317$color = _ref1317.color,
      C = _ref1317$color === void 0 ? "currentColor" : _ref1317$color,
      _ref1317$size = _ref1317.size,
      e = _ref1317$size === void 0 ? 24 : _ref1317$size,
      l = _ref1317.className,
      i = _objectWithoutProperties(_ref1317, _excluded1317);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.0001 8.5L14.1161 13.5875L19.6085 14.0279L15.4239 17.6125L16.7023 22.9721L12.0001 20.1L7.29777 22.9721L8.57625 17.6125L4.3916 14.0279L9.88403 13.5875L12.0001 8.5ZM8.00005 2V11H6.00005V2H8.00005ZM18.0001 2V11H16.0001V2H18.0001ZM13.0001 2V7H11.0001V2H13.0001Z"
  }));
},
    fL = function fL(_ref1318) {
  var _ref1318$color = _ref1318.color,
      C = _ref1318$color === void 0 ? "currentColor" : _ref1318$color,
      _ref1318$size = _ref1318.size,
      e = _ref1318$size === void 0 ? 24 : _ref1318$size,
      l = _ref1318.className,
      i = _objectWithoutProperties(_ref1318, _excluded1318);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.0001 8.5L14.1161 13.5875L19.6085 14.0279L15.4239 17.6125L16.7023 22.9721L12.0001 20.1L7.29777 22.9721L8.57625 17.6125L4.3916 14.0279L9.88403 13.5875L12.0001 8.5ZM12.0001 13.707L11.2615 15.4835L9.34505 15.637L10.8051 16.8883L10.3581 18.759L12.0001 17.7564L13.6411 18.759L13.195 16.8883L14.6541 15.637L12.7386 15.4835L12.0001 13.707ZM8.00005 2V11H6.00005V2H8.00005ZM18.0001 2V11H16.0001V2H18.0001ZM13.0001 2V7H11.0001V2H13.0001Z"
  }));
},
    RL = function RL(_ref1319) {
  var _ref1319$color = _ref1319.color,
      C = _ref1319$color === void 0 ? "currentColor" : _ref1319$color,
      _ref1319$size = _ref1319.size,
      e = _ref1319$size === void 0 ? 24 : _ref1319$size,
      l = _ref1319.className,
      i = _objectWithoutProperties(_ref1319, _excluded1319);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 7.00002C16.4183 7.00002 20 10.5817 20 15C20 19.4183 16.4183 23 12 23C7.58172 23 4 19.4183 4 15C4 10.5817 7.58172 7.00002 12 7.00002ZM12 10.5L10.6775 13.1797L7.72025 13.6094L9.86012 15.6953L9.35497 18.6406L12 17.25L14.645 18.6406L14.1399 15.6953L16.2798 13.6094L13.3225 13.1797L12 10.5ZM13 1.99902L18 2.00002V5.00002L16.6366 6.13758C15.5305 5.55773 14.3025 5.17887 13.0011 5.04951L13 1.99902ZM11 1.99902L10.9997 5.04943C9.6984 5.17866 8.47046 5.55738 7.36441 6.13706L6 5.00002V2.00002L11 1.99902Z"
  }));
},
    zL = function zL(_ref1320) {
  var _ref1320$color = _ref1320.color,
      C = _ref1320$color === void 0 ? "currentColor" : _ref1320$color,
      _ref1320$size = _ref1320.size,
      e = _ref1320$size === void 0 ? 24 : _ref1320$size,
      l = _ref1320.className,
      i = _objectWithoutProperties(_ref1320, _excluded1320);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 6.99999C16.4183 6.99999 20 10.5817 20 15C20 19.4183 16.4183 23 12 23C7.58172 23 4 19.4183 4 15C4 10.5817 7.58172 6.99999 12 6.99999ZM12 8.99999C8.68629 8.99999 6 11.6863 6 15C6 18.3137 8.68629 21 12 21C15.3137 21 18 18.3137 18 15C18 11.6863 15.3137 8.99999 12 8.99999ZM12 10.5L13.3225 13.1797L16.2798 13.6094L14.1399 15.6953L14.645 18.6406L12 17.25L9.35497 18.6406L9.86012 15.6953L7.72025 13.6094L10.6775 13.1797L12 10.5ZM18 1.99999V4.99999L16.6366 6.13755C15.5305 5.5577 14.3025 5.17884 13.0011 5.04948L13 1.99899L18 1.99999ZM11 1.99899L10.9997 5.04939C9.6984 5.17863 8.47046 5.55735 7.36441 6.13703L6 4.99999V1.99999L11 1.99899Z"
  }));
},
    FL = function FL(_ref1321) {
  var _ref1321$color = _ref1321.color,
      C = _ref1321$color === void 0 ? "currentColor" : _ref1321$color,
      _ref1321$size = _ref1321.size,
      e = _ref1321$size === void 0 ? 24 : _ref1321$size,
      l = _ref1321.className,
      i = _objectWithoutProperties(_ref1321, _excluded1321);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17 5V7C18.6569 7 20 8.34315 20 10V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V10C4 8.34315 5.34315 7 7 7V5H17ZM13 11H11V13H9V15H10.999L11 17H13L12.999 15H15V13H13V11ZM19 2V4H5V2H19Z"
  }));
},
    SL = function SL(_ref1322) {
  var _ref1322$color = _ref1322.color,
      C = _ref1322$color === void 0 ? "currentColor" : _ref1322$color,
      _ref1322$size = _ref1322.size,
      e = _ref1322$size === void 0 ? 24 : _ref1322$size,
      l = _ref1322.className,
      i = _objectWithoutProperties(_ref1322, _excluded1322);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19 2V4H17V7C18.6569 7 20 8.34315 20 10V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V10C4 8.34315 5.34315 7 7 7V4H5V2H19ZM17 9H7C6.44772 9 6 9.44772 6 10V20H18V10C18 9.44772 17.5523 9 17 9ZM13 11V13H15V15H12.999L13 17H11L10.999 15H9V13H11V11H13ZM15 4H9V7H15V4Z"
  }));
},
    AL = function AL(_ref1323) {
  var _ref1323$color = _ref1323.color,
      C = _ref1323$color === void 0 ? "currentColor" : _ref1323$color,
      _ref1323$size = _ref1323.size,
      e = _ref1323$size === void 0 ? 24 : _ref1323$size,
      l = _ref1323.className,
      i = _objectWithoutProperties(_ref1323, _excluded1323);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.15789 3H17.8421C19.5862 3 21 4.41384 21 6.15789V9.52368C20.9185 9.51825 20.8369 9.51611 20.7552 9.51611C20.3527 9.51611 19.8589 9.61374 19.5076 9.79063C19.1075 9.97583 18.7548 10.2528 18.4613 10.6162C17.9888 11.2018 17.7025 11.9931 17.6329 12.8824C17.618 13.059 17.6131 13.2366 17.6163 13.4138C17.6632 15.4279 18.7512 17.0376 20.6837 17.0376C20.7919 17.0376 20.8974 17.0325 21 17.0226V17.8421C21 19.5862 19.5862 21 17.8421 21H6.15789C4.41384 21 3 19.5862 3 17.8421V6.15789C3 4.41384 4.41384 3 6.15789 3ZM21 15.3878V12.6621H19.3473C19.2728 13.9784 19.9927 15.0913 21 15.3878ZM21 12.2813V9.97343C20.92 9.95153 20.8345 9.93978 20.7435 9.93827C19.9294 9.95506 19.4442 10.9302 19.3838 12.2813H21ZM17.6973 7.30004L17.7115 7.29693V7.18701H14.8127L12.1211 13.5132L9.42952 7.18701H6.30572V7.29693L6.31975 7.30004C6.84885 7.41946 7.11748 7.59757 7.11748 8.23987V15.7595C7.11748 16.4018 6.84782 16.5799 6.31871 16.6993L6.30469 16.7024V16.8127H8.42408V16.7028L8.41007 16.6996C7.88095 16.5802 7.61232 16.4021 7.61232 15.7598V8.67605L11.07 16.8127H11.2661L14.8245 8.44914V15.9455C14.7792 16.4528 14.513 16.6095 14.0339 16.7176L14.0197 16.7209V16.83H17.7115V16.7209L17.6973 16.7176C17.2177 16.6095 16.9451 16.4528 16.8998 15.9455L16.8974 8.23987H16.8998C16.8998 7.59757 17.1684 7.41946 17.6973 7.30004Z"
  }));
},
    kL = function kL(_ref1324) {
  var _ref1324$color = _ref1324.color,
      C = _ref1324$color === void 0 ? "currentColor" : _ref1324$color,
      _ref1324$size = _ref1324.size,
      e = _ref1324$size === void 0 ? 24 : _ref1324$size,
      l = _ref1324.className,
      i = _objectWithoutProperties(_ref1324, _excluded1324);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.15791 4H17.8422C19.034 4 20.0001 4.96612 20.0001 6.15789V9.61314C19.8226 9.65789 19.653 9.71748 19.5077 9.79063C19.1077 9.97583 18.7549 10.2528 18.4614 10.6162C17.9888 11.2018 17.7026 11.9931 17.633 12.8824C17.6181 13.059 17.6132 13.2366 17.6164 13.4138C17.6574 15.1766 18.4959 16.6295 20.0001 16.9647V17.8421C20.0001 19.0339 19.034 20 17.8422 20H6.15791C4.96613 20 4.00001 19.0339 4.00001 17.8421V6.15789C4.00001 4.96612 4.96613 4 6.15791 4ZM21.0001 6.15789C21.0001 4.41384 19.5863 3 17.8422 3H6.15791C4.41385 3 3 4.41384 3 6.15789V17.8421C3 19.5862 4.41385 21 6.15791 21H17.8422C19.5863 21 21.0001 19.5862 21.0001 17.8421V6.15789ZM20.0001 10.298V12.2813H19.3839C19.4227 11.4139 19.6365 10.7014 20.0001 10.298ZM20.0001 12.6621V14.7252C19.5588 14.2117 19.3013 13.4758 19.3474 12.6621H20.0001ZM17.6974 7.30004L17.7116 7.29693V7.18701H14.8128L12.1212 13.5132L9.42956 7.18701H6.30575V7.29693L6.31977 7.30004C6.84888 7.41946 7.11751 7.59757 7.11751 8.23987V15.7595C7.11751 16.4018 6.84784 16.5799 6.31874 16.6993L6.30471 16.7024V16.8127H8.42412V16.7028L8.41011 16.6996C7.88098 16.5802 7.61235 16.4021 7.61235 15.7598V8.67605L11.07 16.8127H11.2661L14.8246 8.44914V15.9455C14.7792 16.4528 14.513 16.6095 14.0339 16.7176L14.0197 16.7209V16.83H17.7116V16.7209L17.6974 16.7176C17.2178 16.6095 16.9452 16.4528 16.8999 15.9455L16.8974 8.23987H16.8999C16.8999 7.59757 17.1685 7.41946 17.6974 7.30004Z"
  }));
},
    PL = function PL(_ref1325) {
  var _ref1325$color = _ref1325.color,
      C = _ref1325$color === void 0 ? "currentColor" : _ref1325$color,
      _ref1325$size = _ref1325.size,
      e = _ref1325$size === void 0 ? 24 : _ref1325$size,
      l = _ref1325.className,
      i = _objectWithoutProperties(_ref1325, _excluded1325);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18.5858 5H14V3H22V11H20V6.41421L16.4633 9.95088C17.4274 11.2127 18 12.7895 18 14.5C18 18.6421 14.6421 22 10.5 22C6.35786 22 3 18.6421 3 14.5C3 10.3579 6.35786 7 10.5 7C12.2105 7 13.7873 7.57264 15.0491 8.53666L18.5858 5Z"
  }));
},
    DL = function DL(_ref1326) {
  var _ref1326$color = _ref1326.color,
      C = _ref1326$color === void 0 ? "currentColor" : _ref1326$color,
      _ref1326$size = _ref1326.size,
      e = _ref1326$size === void 0 ? 24 : _ref1326$size,
      l = _ref1326.className,
      i = _objectWithoutProperties(_ref1326, _excluded1326);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15.0491 8.53666L18.5858 5H14V3H22V11H20V6.41421L16.4633 9.95088C17.4274 11.2127 18 12.7895 18 14.5C18 18.6421 14.6421 22 10.5 22C6.35786 22 3 18.6421 3 14.5C3 10.3579 6.35786 7 10.5 7C12.2105 7 13.7873 7.57264 15.0491 8.53666ZM10.5 20C13.5376 20 16 17.5376 16 14.5C16 11.4624 13.5376 9 10.5 9C7.46243 9 5 11.4624 5 14.5C5 17.5376 7.46243 20 10.5 20Z"
  }));
},
    yL = function yL(_ref1327) {
  var _ref1327$color = _ref1327.color,
      C = _ref1327$color === void 0 ? "currentColor" : _ref1327$color,
      _ref1327$size = _ref1327.size,
      e = _ref1327$size === void 0 ? 24 : _ref1327$size,
      l = _ref1327.className,
      i = _objectWithoutProperties(_ref1327, _excluded1327);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11 2C15.0675 2 18.426 5.03562 18.9337 8.96494L21.1842 12.5037C21.3324 12.7367 21.3025 13.0847 20.9593 13.2317L19 14.071V17C19 18.1046 18.1046 19 17 19H15.001L15 22H6L6.00025 18.3061C6.00033 17.1252 5.56351 16.0087 4.7555 15.0011C3.65707 13.6313 3 11.8924 3 10C3 5.58172 6.58172 2 11 2ZM10.4697 7.76256C9.78625 7.07915 8.67821 7.07915 7.9948 7.76256C7.31138 8.44598 7.31138 9.55402 7.9948 10.2374L11 13.2426L14.0052 10.2374C14.6886 9.55402 14.6886 8.44598 14.0052 7.76256C13.3218 7.07915 12.2137 7.07915 11.5303 7.76256L11 8.29289L10.4697 7.76256Z"
  }));
},
    bL = function bL(_ref1328) {
  var _ref1328$color = _ref1328.color,
      C = _ref1328$color === void 0 ? "currentColor" : _ref1328$color,
      _ref1328$size = _ref1328.size,
      e = _ref1328$size === void 0 ? 24 : _ref1328$size,
      l = _ref1328.className,
      i = _objectWithoutProperties(_ref1328, _excluded1328);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11 2C15.0675 2 18.426 5.03562 18.9337 8.96494L21.1842 12.5037C21.3324 12.7367 21.3025 13.0847 20.9593 13.2317L19 14.071V17C19 18.1046 18.1046 19 17 19H15.001L15 22H6L6.00025 18.3061C6.00033 17.1252 5.56351 16.0087 4.7555 15.0011C3.65707 13.6313 3 11.8924 3 10C3 5.58172 6.58172 2 11 2ZM11 4C7.68629 4 5 6.68629 5 10C5 11.3849 5.46818 12.6929 6.31578 13.7499C7.40965 15.114 8.00036 16.6672 8.00025 18.3063L8.00013 20H13.0007L13.0017 17H17V12.7519L18.5497 12.0881L17.0072 9.66262L16.9501 9.22118C16.5665 6.25141 14.0243 4 11 4ZM10.4697 7.76256L11 8.29289L11.5303 7.76256C12.2137 7.07915 13.3218 7.07915 14.0052 7.76256C14.6886 8.44598 14.6886 9.55402 14.0052 10.2374L11 13.2426L7.9948 10.2374C7.31138 9.55402 7.31138 8.44598 7.9948 7.76256C8.67821 7.07915 9.78625 7.07915 10.4697 7.76256Z"
  }));
},
    TL = function TL(_ref1329) {
  var _ref1329$color = _ref1329.color,
      C = _ref1329$color === void 0 ? "currentColor" : _ref1329$color,
      _ref1329$size = _ref1329.size,
      e = _ref1329$size === void 0 ? 24 : _ref1329$size,
      l = _ref1329.className,
      i = _objectWithoutProperties(_ref1329, _excluded1329);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 4H21V6H3V4ZM3 11H15V13H3V11ZM3 18H21V20H3V18Z"
  }));
},
    UL = function UL(_ref1330) {
  var _ref1330$color = _ref1330.color,
      C = _ref1330$color === void 0 ? "currentColor" : _ref1330$color,
      _ref1330$size = _ref1330.size,
      e = _ref1330$size === void 0 ? 24 : _ref1330$size,
      l = _ref1330.className,
      i = _objectWithoutProperties(_ref1330, _excluded1330);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 4H21V6H3V4ZM3 11H15V13H3V11ZM3 18H21V20H3V18Z"
  }));
},
    GL = function GL(_ref1331) {
  var _ref1331$color = _ref1331.color,
      C = _ref1331$color === void 0 ? "currentColor" : _ref1331$color,
      _ref1331$size = _ref1331.size,
      e = _ref1331$size === void 0 ? 24 : _ref1331$size,
      l = _ref1331.className,
      i = _objectWithoutProperties(_ref1331, _excluded1331);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 4H21V6H3V4ZM9 11H21V13H9V11ZM3 18H21V20H3V18Z"
  }));
},
    IL = function IL(_ref1332) {
  var _ref1332$color = _ref1332.color,
      C = _ref1332$color === void 0 ? "currentColor" : _ref1332$color,
      _ref1332$size = _ref1332.size,
      e = _ref1332$size === void 0 ? 24 : _ref1332$size,
      l = _ref1332.className,
      i = _objectWithoutProperties(_ref1332, _excluded1332);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 4H21V6H3V4ZM9 11H21V13H9V11ZM3 18H21V20H3V18Z"
  }));
},
    WL = function WL(_ref1333) {
  var _ref1333$color = _ref1333.color,
      C = _ref1333$color === void 0 ? "currentColor" : _ref1333$color,
      _ref1333$size = _ref1333.size,
      e = _ref1333$size === void 0 ? 24 : _ref1333$size,
      l = _ref1333.className,
      i = _objectWithoutProperties(_ref1333, _excluded1333);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16 18V20H5V18H16ZM21 11V13H3V11H21ZM19 4V6H8V4H19Z"
  }));
},
    OL = function OL(_ref1334) {
  var _ref1334$color = _ref1334.color,
      C = _ref1334$color === void 0 ? "currentColor" : _ref1334$color,
      _ref1334$size = _ref1334.size,
      e = _ref1334$size === void 0 ? 24 : _ref1334$size,
      l = _ref1334.className,
      i = _objectWithoutProperties(_ref1334, _excluded1334);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16 18V20H5V18H16ZM21 11V13H3V11H21ZM19 4V6H8V4H19Z"
  }));
},
    KL = function KL(_ref1335) {
  var _ref1335$color = _ref1335.color,
      C = _ref1335$color === void 0 ? "currentColor" : _ref1335$color,
      _ref1335$size = _ref1335.size,
      e = _ref1335$size === void 0 ? 24 : _ref1335$size,
      l = _ref1335.className,
      i = _objectWithoutProperties(_ref1335, _excluded1335);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18 18V20H6V18H18ZM21 11V13H3V11H21ZM18 4V6H6V4H18Z"
  }));
},
    QL = function QL(_ref1336) {
  var _ref1336$color = _ref1336.color,
      C = _ref1336$color === void 0 ? "currentColor" : _ref1336$color,
      _ref1336$size = _ref1336.size,
      e = _ref1336$size === void 0 ? 24 : _ref1336$size,
      l = _ref1336.className,
      i = _objectWithoutProperties(_ref1336, _excluded1336);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18 18V20H6V18H18ZM21 11V13H3V11H21ZM18 4V6H6V4H18Z"
  }));
},
    qL = function qL(_ref1337) {
  var _ref1337$color = _ref1337.color,
      C = _ref1337$color === void 0 ? "currentColor" : _ref1337$color,
      _ref1337$size = _ref1337.size,
      e = _ref1337$size === void 0 ? 24 : _ref1337$size,
      l = _ref1337.className,
      i = _objectWithoutProperties(_ref1337, _excluded1337);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18 15L17.999 18H21V20H17.999L18 23H16L15.999 20H13V18H15.999L16 15H18ZM11 18V20H3V18H11ZM21 11V13H3V11H21ZM21 4V6H3V4H21Z"
  }));
},
    jL = function jL(_ref1338) {
  var _ref1338$color = _ref1338.color,
      C = _ref1338$color === void 0 ? "currentColor" : _ref1338$color,
      _ref1338$size = _ref1338.size,
      e = _ref1338$size === void 0 ? 24 : _ref1338$size,
      l = _ref1338.className,
      i = _objectWithoutProperties(_ref1338, _excluded1338);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18 15L17.999 18H21V20H17.999L18 23H16L15.999 20H13V18H15.999L16 15H18ZM11 18V20H3V18H11ZM21 11V13H3V11H21ZM21 4V6H3V4H21Z"
  }));
},
    XL = function XL(_ref1339) {
  var _ref1339$color = _ref1339.color,
      C = _ref1339$color === void 0 ? "currentColor" : _ref1339$color,
      _ref1339$size = _ref1339.size,
      e = _ref1339$size === void 0 ? 24 : _ref1339$size,
      l = _ref1339.className,
      i = _objectWithoutProperties(_ref1339, _excluded1339);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 4H21V6H3V4ZM3 11H21V13H3V11ZM3 18H21V20H3V18Z"
  }));
},
    JL = function JL(_ref1340) {
  var _ref1340$color = _ref1340.color,
      C = _ref1340$color === void 0 ? "currentColor" : _ref1340$color,
      _ref1340$size = _ref1340.size,
      e = _ref1340$size === void 0 ? 24 : _ref1340$size,
      l = _ref1340.className,
      i = _objectWithoutProperties(_ref1340, _excluded1340);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 17.9996V19.9996H3V17.9996H21ZM7 3.5V13.5L2 8.49955L7 3.5ZM21 10.9996V12.9996H12V10.9996H21ZM21 3.99955V5.99955H12V3.99955H21Z"
  }));
},
    YL = function YL(_ref1341) {
  var _ref1341$color = _ref1341.color,
      C = _ref1341$color === void 0 ? "currentColor" : _ref1341$color,
      _ref1341$size = _ref1341.size,
      e = _ref1341$size === void 0 ? 24 : _ref1341$size,
      l = _ref1341.className,
      i = _objectWithoutProperties(_ref1341, _excluded1341);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 17.9995V19.9995H3V17.9995H21ZM6.59619 3.90332L8.01041 5.31753L4.82843 8.49951L8.01041 11.6815L6.59619 13.0957L2 8.49951L6.59619 3.90332ZM21 10.9995V12.9995H12V10.9995H21ZM21 3.99951V5.99951H12V3.99951H21Z"
  }));
},
    _L = function _L(_ref1342) {
  var _ref1342$color = _ref1342.color,
      C = _ref1342$color === void 0 ? "currentColor" : _ref1342$color,
      _ref1342$size = _ref1342.size,
      e = _ref1342$size === void 0 ? 24 : _ref1342$size,
      l = _ref1342.className,
      i = _objectWithoutProperties(_ref1342, _excluded1342);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 4H21V6H3V4ZM3 11H21V13H3V11ZM3 18H21V20H3V18Z"
  }));
},
    $L = function $L(_ref1343) {
  var _ref1343$color = _ref1343.color,
      C = _ref1343$color === void 0 ? "currentColor" : _ref1343$color,
      _ref1343$size = _ref1343.size,
      e = _ref1343$size === void 0 ? 24 : _ref1343$size,
      l = _ref1343.className,
      i = _objectWithoutProperties(_ref1343, _excluded1343);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 17.9996V19.9996H3V17.9996H21ZM17 3.5L22 8.49955L17 13.5V3.5ZM12 10.9996V12.9996H3V10.9996H12ZM12 3.99955V5.99955H3V3.99955H12Z"
  }));
},
    eh = function eh(_ref1344) {
  var _ref1344$color = _ref1344.color,
      C = _ref1344$color === void 0 ? "currentColor" : _ref1344$color,
      _ref1344$size = _ref1344.size,
      e = _ref1344$size === void 0 ? 24 : _ref1344$size,
      l = _ref1344.className,
      i = _objectWithoutProperties(_ref1344, _excluded1344);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 17.9995V19.9995H3V17.9995H21ZM17.4038 3.90332L22 8.49951L17.4038 13.0957L15.9896 11.6815L19.1716 8.49951L15.9896 5.31753L17.4038 3.90332ZM12 10.9995V12.9995H3V10.9995H12ZM12 3.99951V5.99951H3V3.99951H12Z"
  }));
},
    th = function th(_ref1345) {
  var _ref1345$color = _ref1345.color,
      C = _ref1345$color === void 0 ? "currentColor" : _ref1345$color,
      _ref1345$size = _ref1345.size,
      e = _ref1345$size === void 0 ? 24 : _ref1345$size,
      l = _ref1345.className,
      i = _objectWithoutProperties(_ref1345, _excluded1345);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 3C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3H20ZM11 5H5V10.999H7V9L10 12L7 15V13H5V19H11V17H13V19H19V13H17V15L14 12L17 9V10.999H19V5H13V7H11V5ZM13 13V15H11V13H13ZM13 9V11H11V9H13Z"
  }));
},
    Ch = function Ch(_ref1346) {
  var _ref1346$color = _ref1346.color,
      C = _ref1346$color === void 0 ? "currentColor" : _ref1346$color,
      _ref1346$size = _ref1346.size,
      e = _ref1346$size === void 0 ? 24 : _ref1346$size,
      l = _ref1346.className,
      i = _objectWithoutProperties(_ref1346, _excluded1346);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3H20C20.5523 3 21 3.44772 21 4V20ZM19 11V5H13.001V7H15L12 10L9 7H11V5H5V11H7V13H5V19H11V17H9L12 14L15 17H13.001V19H19V13H17V11H19ZM11 13H9V11H11V13ZM15 13H13V11H15V13Z"
  }));
},
    lh = function lh(_ref1347) {
  var _ref1347$color = _ref1347.color,
      C = _ref1347$color === void 0 ? "currentColor" : _ref1347$color,
      _ref1347$size = _ref1347.size,
      e = _ref1347$size === void 0 ? 24 : _ref1347$size,
      l = _ref1347.className,
      i = _objectWithoutProperties(_ref1347, _excluded1347);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.45455 19L2 22.5V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.45455ZM7 10V12H9V10H7ZM11 10V12H13V10H11ZM15 10V12H17V10H15Z"
  }));
},
    ih = function ih(_ref1348) {
  var _ref1348$color = _ref1348.color,
      C = _ref1348$color === void 0 ? "currentColor" : _ref1348$color,
      _ref1348$size = _ref1348.size,
      e = _ref1348$size === void 0 ? 24 : _ref1348$size,
      l = _ref1348.className,
      i = _objectWithoutProperties(_ref1348, _excluded1348);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.45455 19L2 22.5V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.45455ZM5.76282 17H20V5H4V18.3851L5.76282 17ZM11 10H13V12H11V10ZM7 10H9V12H7V10ZM15 10H17V12H15V10Z"
  }));
},
    sh = function sh(_ref1349) {
  var _ref1349$color = _ref1349.color,
      C = _ref1349$color === void 0 ? "currentColor" : _ref1349$color,
      _ref1349$size = _ref1349.size,
      e = _ref1349$size === void 0 ? 24 : _ref1349$size,
      l = _ref1349.className,
      i = _objectWithoutProperties(_ref1349, _excluded1349);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 8.99374C2 5.68349 4.67654 3 8.00066 3H15.9993C19.3134 3 22 5.69478 22 8.99374V21H8.00066C4.68659 21 2 18.3052 2 15.0063V8.99374ZM14 11V13H16V11H14ZM8 11V13H10V11H8Z"
  }));
},
    rh = function rh(_ref1350) {
  var _ref1350$color = _ref1350.color,
      C = _ref1350$color === void 0 ? "currentColor" : _ref1350$color,
      _ref1350$size = _ref1350.size,
      e = _ref1350$size === void 0 ? 24 : _ref1350$size,
      l = _ref1350.className,
      i = _objectWithoutProperties(_ref1350, _excluded1350);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 8.99374C2 5.68349 4.67654 3 8.00066 3H15.9993C19.3134 3 22 5.69478 22 8.99374V21H8.00066C4.68659 21 2 18.3052 2 15.0063V8.99374ZM20 19V8.99374C20 6.79539 18.2049 5 15.9993 5H8.00066C5.78458 5 4 6.78458 4 8.99374V15.0063C4 17.2046 5.79512 19 8.00066 19H20ZM14 11H16V13H14V11ZM8 11H10V13H8V11Z"
  }));
},
    ch = function ch(_ref1351) {
  var _ref1351$color = _ref1351.color,
      C = _ref1351$color === void 0 ? "currentColor" : _ref1351$color,
      _ref1351$size = _ref1351.size,
      e = _ref1351$size === void 0 ? 24 : _ref1351$size,
      l = _ref1351.className,
      i = _objectWithoutProperties(_ref1351, _excluded1351);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.45455 19L2 22.5V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.45455ZM8 10V12H16V10H8Z"
  }));
},
    oh = function oh(_ref1352) {
  var _ref1352$color = _ref1352.color,
      C = _ref1352$color === void 0 ? "currentColor" : _ref1352$color,
      _ref1352$size = _ref1352.size,
      e = _ref1352$size === void 0 ? 24 : _ref1352$size,
      l = _ref1352.className,
      i = _objectWithoutProperties(_ref1352, _excluded1352);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.45455 19L2 22.5V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.45455ZM5.76282 17H20V5H4V18.3851L5.76282 17ZM8 10H16V12H8V10Z"
  }));
},
    ah = function ah(_ref1353) {
  var _ref1353$color = _ref1353.color,
      C = _ref1353$color === void 0 ? "currentColor" : _ref1353$color,
      _ref1353$size = _ref1353.size,
      e = _ref1353$size === void 0 ? 24 : _ref1353$size,
      l = _ref1353.className,
      i = _objectWithoutProperties(_ref1353, _excluded1353);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.001 2C17.6345 2 22.001 6.1265 22.001 11.7C22.001 17.2735 17.6345 21.4 12.001 21.4C11.0233 21.4023 10.0497 21.273 9.10648 21.0155C8.92907 20.9668 8.7403 20.9808 8.57198 21.055L6.58748 21.931C6.34398 22.0386 6.06291 22.018 5.83768 21.8761C5.61244 21.7342 5.47254 21.4896 5.46448 21.2235L5.40998 19.4445C5.40257 19.2257 5.30547 19.0196 5.14148 18.8745C3.19598 17.1345 2.00098 14.6155 2.00098 11.7C2.00098 6.1265 6.36748 2 12.001 2ZM5.99598 14.5365C5.71398 14.984 6.26398 15.488 6.68498 15.1685L9.84048 12.7735C10.0543 12.6122 10.3491 12.6122 10.563 12.7735L12.8995 14.5235C13.2346 14.7749 13.6596 14.8747 14.0716 14.7987C14.4836 14.7227 14.8451 14.4779 15.0685 14.1235L18.006 9.4635C18.288 9.016 17.738 8.512 17.317 8.8315L14.1615 11.2265C13.9476 11.3878 13.6528 11.3878 13.439 11.2265L11.1025 9.4765C10.7673 9.22511 10.3423 9.12532 9.93034 9.2013C9.51834 9.27728 9.15689 9.5221 8.93348 9.8765L5.99598 14.5365Z"
  }));
},
    nh = function nh(_ref1354) {
  var _ref1354$color = _ref1354.color,
      C = _ref1354$color === void 0 ? "currentColor" : _ref1354$color,
      _ref1354$size = _ref1354.size,
      e = _ref1354$size === void 0 ? 24 : _ref1354$size,
      l = _ref1354.className,
      i = _objectWithoutProperties(_ref1354, _excluded1354);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7.76497 19.225C8.35411 18.9652 9.01479 18.9164 9.63316 19.0861C10.4032 19.2963 11.198 19.4019 12.001 19.4C16.5861 19.4 20.001 16.1135 20.001 11.7C20.001 7.28651 16.5861 4 12.001 4C7.41585 4 4.00098 7.28651 4.00098 11.7C4.00098 13.9699 4.89652 15.9722 6.46655 17.3764C7.0418 17.8853 7.38251 18.6082 7.409 19.3822L7.76497 19.225ZM12.001 2C17.6345 2 22.001 6.1265 22.001 11.7C22.001 17.2735 17.6345 21.4 12.001 21.4C11.0233 21.4023 10.0497 21.273 9.10648 21.0155C8.92907 20.9668 8.7403 20.9808 8.57198 21.055L6.58748 21.931C6.34398 22.0386 6.06291 22.018 5.83768 21.8761C5.61244 21.7342 5.47254 21.4896 5.46448 21.2235L5.40998 19.4445C5.40257 19.2257 5.30547 19.0196 5.14148 18.8745C3.19598 17.1345 2.00098 14.6155 2.00098 11.7C2.00098 6.1265 6.36748 2 12.001 2ZM5.99598 14.5365L8.93348 9.8765C9.15689 9.5221 9.51834 9.27728 9.93034 9.2013C10.3423 9.12532 10.7673 9.22511 11.1025 9.4765L13.439 11.2265C13.6528 11.3878 13.9476 11.3878 14.1615 11.2265L17.317 8.8315C17.738 8.512 18.288 9.016 18.006 9.4635L15.0685 14.1235C14.8451 14.4779 14.4836 14.7227 14.0716 14.7987C13.6596 14.8747 13.2346 14.7749 12.8995 14.5235L10.563 12.7735C10.3491 12.6122 10.0543 12.6122 9.84048 12.7735L6.68498 15.1685C6.26398 15.488 5.71398 14.984 5.99598 14.5365Z"
  }));
},
    mh = function mh(_ref1355) {
  var _ref1355$color = _ref1355.color,
      C = _ref1355$color === void 0 ? "currentColor" : _ref1355$color,
      _ref1355$size = _ref1355.size,
      e = _ref1355$size === void 0 ? 24 : _ref1355$size,
      l = _ref1355.className,
      i = _objectWithoutProperties(_ref1355, _excluded1355);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 1V13C21 17.9706 16.9706 22 12 22C7.02944 22 3 17.9706 3 13C3 9.72064 4.75393 6.85093 7.37488 5.27777L14 1.453V4.223L21 1ZM12 8C9.23858 8 7 10.2386 7 13C7 15.7614 9.23858 18 12 18C14.7614 18 17 15.7614 17 13C17 10.2386 14.7614 8 12 8Z"
  }));
},
    wh = function wh(_ref1356) {
  var _ref1356$color = _ref1356.color,
      C = _ref1356$color === void 0 ? "currentColor" : _ref1356$color,
      _ref1356$size = _ref1356.size,
      e = _ref1356$size === void 0 ? 24 : _ref1356$size,
      l = _ref1356.className,
      i = _objectWithoutProperties(_ref1356, _excluded1356);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 1V13C21 17.9706 16.9706 22 12 22C7.02944 22 3 17.9706 3 13C3 9.72064 4.75393 6.85093 7.37488 5.27777L14 1.453V4.223L21 1ZM19 4.122L12 7.34567V4.916L8.59717 6.88088C6.47212 8.06588 5.10056 10.2673 5.00531 12.7258L5 13C5 16.866 8.13401 20 12 20C15.7855 20 18.8691 16.9952 18.9959 13.2407L19 13V4.122ZM12 8C14.7614 8 17 10.2386 17 13C17 15.7614 14.7614 18 12 18C9.23858 18 7 15.7614 7 13C7 10.2386 9.23858 8 12 8ZM12 10C10.3431 10 9 11.3431 9 13C9 14.6569 10.3431 16 12 16C13.6569 16 15 14.6569 15 13C15 11.3431 13.6569 10 12 10Z"
  }));
},
    Lh = function Lh(_ref1357) {
  var _ref1357$color = _ref1357.color,
      C = _ref1357$color === void 0 ? "currentColor" : _ref1357$color,
      _ref1357$size = _ref1357.size,
      e = _ref1357$size === void 0 ? 24 : _ref1357$size,
      l = _ref1357.className,
      i = _objectWithoutProperties(_ref1357, _excluded1357);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.0001 1C14.7615 1 17.0001 3.23858 17.0001 6V12C17.0001 14.7614 14.7615 17 12.0001 17C9.23865 17 7.00008 14.7614 7.00008 12V6C7.00008 3.23858 9.23865 1 12.0001 1ZM2.19238 13.9615L4.15392 13.5692C4.88321 17.2361 8.11888 20 12.0001 20C15.8813 20 19.1169 17.2361 19.8462 13.5692L21.8078 13.9615C20.8961 18.5452 16.8516 22 12.0001 22C7.14858 22 3.104 18.5452 2.19238 13.9615Z"
  }));
},
    hh = function hh(_ref1358) {
  var _ref1358$color = _ref1358.color,
      C = _ref1358$color === void 0 ? "currentColor" : _ref1358$color,
      _ref1358$size = _ref1358.size,
      e = _ref1358$size === void 0 ? 24 : _ref1358$size,
      l = _ref1358.className,
      i = _objectWithoutProperties(_ref1358, _excluded1358);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.0001 3C10.3432 3 9.00008 4.34315 9.00008 6V12C9.00008 13.6569 10.3432 15 12.0001 15C13.6569 15 15.0001 13.6569 15.0001 12V6C15.0001 4.34315 13.6569 3 12.0001 3ZM12.0001 1C14.7615 1 17.0001 3.23858 17.0001 6V12C17.0001 14.7614 14.7615 17 12.0001 17C9.23865 17 7.00008 14.7614 7.00008 12V6C7.00008 3.23858 9.23865 1 12.0001 1ZM2.19238 13.9615L4.15392 13.5692C4.88321 17.2361 8.11888 20 12.0001 20C15.8813 20 19.1169 17.2361 19.8462 13.5692L21.8078 13.9615C20.8961 18.5452 16.8516 22 12.0001 22C7.14858 22 3.104 18.5452 2.19238 13.9615Z"
  }));
},
    Hh = function Hh(_ref1359) {
  var _ref1359$color = _ref1359.color,
      C = _ref1359$color === void 0 ? "currentColor" : _ref1359$color,
      _ref1359$size = _ref1359.size,
      e = _ref1359$size === void 0 ? 24 : _ref1359$size,
      l = _ref1359.className,
      i = _objectWithoutProperties(_ref1359, _excluded1359);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11.9998 1C14.7612 1 16.9998 3.23858 16.9998 6V10C16.9998 12.7614 14.7612 15 11.9998 15C9.23833 15 6.99976 12.7614 6.99976 10V6C6.99976 3.23858 9.23833 1 11.9998 1ZM3.05469 11H5.07065C5.55588 14.3923 8.47329 17 11.9998 17C15.5262 17 18.4436 14.3923 18.9289 11H20.9448C20.4837 15.1716 17.1714 18.4839 12.9998 18.9451V23H10.9998V18.9451C6.82814 18.4839 3.51584 15.1716 3.05469 11Z"
  }));
},
    Vh = function Vh(_ref1360) {
  var _ref1360$color = _ref1360.color,
      C = _ref1360$color === void 0 ? "currentColor" : _ref1360$color,
      _ref1360$size = _ref1360.size,
      e = _ref1360$size === void 0 ? 24 : _ref1360$size,
      l = _ref1360.className,
      i = _objectWithoutProperties(_ref1360, _excluded1360);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11.9998 3C10.3429 3 8.99976 4.34315 8.99976 6V10C8.99976 11.6569 10.3429 13 11.9998 13C13.6566 13 14.9998 11.6569 14.9998 10V6C14.9998 4.34315 13.6566 3 11.9998 3ZM11.9998 1C14.7612 1 16.9998 3.23858 16.9998 6V10C16.9998 12.7614 14.7612 15 11.9998 15C9.23833 15 6.99976 12.7614 6.99976 10V6C6.99976 3.23858 9.23833 1 11.9998 1ZM3.05469 11H5.07065C5.55588 14.3923 8.47329 17 11.9998 17C15.5262 17 18.4436 14.3923 18.9289 11H20.9448C20.4837 15.1716 17.1714 18.4839 12.9998 18.9451V23H10.9998V18.9451C6.82814 18.4839 3.51584 15.1716 3.05469 11Z"
  }));
},
    gh = function gh(_ref1361) {
  var _ref1361$color = _ref1361.color,
      C = _ref1361$color === void 0 ? "currentColor" : _ref1361$color,
      _ref1361$size = _ref1361.size,
      e = _ref1361$size === void 0 ? 24 : _ref1361$size,
      l = _ref1361.className,
      i = _objectWithoutProperties(_ref1361, _excluded1361);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16.4249 17.839C15.3929 18.4228 14.2341 18.8087 13.0002 18.9451V23H11.0002V18.9451C6.82854 18.4839 3.51623 15.1716 3.05509 11H5.07105C5.55627 14.3923 8.47368 17 12.0002 17C13.0503 17 14.0464 16.7688 14.9404 16.3544L13.3902 14.8042C12.9489 14.9317 12.4825 15 12.0002 15C9.23873 15 7.00016 12.7614 7.00016 10V8.41421L1.39355 2.80761L2.80777 1.3934L22.6068 21.1924L21.1925 22.6066L16.4249 17.839ZM19.3747 15.1604L17.9323 13.7179C18.4407 12.9084 18.788 11.9874 18.9293 11H20.9452C20.7754 12.5366 20.2187 13.9565 19.3747 15.1604ZM16.4658 12.2514L7.68575 3.47139C8.55427 1.99268 10.1613 1 12.0002 1C14.7616 1 17.0002 3.23858 17.0002 6V10C17.0002 10.8099 16.8076 11.5748 16.4658 12.2514Z"
  }));
},
    Mh = function Mh(_ref1362) {
  var _ref1362$color = _ref1362.color,
      C = _ref1362$color === void 0 ? "currentColor" : _ref1362$color,
      _ref1362$size = _ref1362.size,
      e = _ref1362$size === void 0 ? 24 : _ref1362$size,
      l = _ref1362.className,
      i = _objectWithoutProperties(_ref1362, _excluded1362);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16.4249 17.839L21.1925 22.6066L22.6068 21.1924L2.80777 1.3934L1.39355 2.80761L7.00016 8.41421V10C7.00016 12.7614 9.23873 15 12.0002 15C12.4825 15 12.9489 14.9317 13.3902 14.8042L14.9404 16.3544C14.0464 16.7688 13.0503 17 12.0002 17C8.47368 17 5.55627 14.3923 5.07105 11H3.05509C3.51623 15.1716 6.82854 18.4839 11.0002 18.9451V23H13.0002V18.9451C14.2341 18.8087 15.3929 18.4228 16.4249 17.839ZM11.5528 12.9669C10.2541 12.7727 9.22745 11.7461 9.03328 10.4473L11.5528 12.9669ZM19.3747 15.1604L17.9323 13.7179C18.4407 12.9084 18.788 11.9874 18.9293 11H20.9452C20.7754 12.5366 20.2187 13.9565 19.3747 15.1604ZM16.4658 12.2514L14.9173 10.703C14.9715 10.4775 15.0002 10.2421 15.0002 10V6C15.0002 4.34315 13.657 3 12.0002 3C10.7059 3 9.6031 3.81956 9.18237 4.96802L7.68575 3.47139C8.55427 1.99268 10.1613 1 12.0002 1C14.7616 1 17.0002 3.23858 17.0002 6V10C17.0002 10.8099 16.8076 11.5748 16.4658 12.2514Z"
  }));
},
    Zh = function Zh(_ref1363) {
  var _ref1363$color = _ref1363.color,
      C = _ref1363$color === void 0 ? "currentColor" : _ref1363$color,
      _ref1363$size = _ref1363.size,
      e = _ref1363$size === void 0 ? 24 : _ref1363$size,
      l = _ref1363.className,
      i = _objectWithoutProperties(_ref1363, _excluded1363);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18.5 2C20.9853 2 23 4.01472 23 6.5C23 8.68314 21.4454 10.5032 19.3828 10.9134C19.7802 11.8623 20 12.9055 20 14C20 18.4183 16.4183 22 12 22C7.58172 22 4 18.4183 4 14C4 12.9055 4.21981 11.8623 4.61769 10.9121C2.55463 10.5032 1 8.68314 1 6.5C1 4.01472 3.01472 2 5.5 2C7.90278 2 9.86572 3.88317 9.9934 6.2541C10.6348 6.08809 11.3071 6 12 6C12.6929 6 13.3652 6.08809 14.0064 6.25368C14.1343 3.88317 16.0972 2 18.5 2Z"
  }));
},
    xh = function xh(_ref1364) {
  var _ref1364$color = _ref1364.color,
      C = _ref1364$color === void 0 ? "currentColor" : _ref1364$color,
      _ref1364$size = _ref1364.size,
      e = _ref1364$size === void 0 ? 24 : _ref1364$size,
      l = _ref1364.className,
      i = _objectWithoutProperties(_ref1364, _excluded1364);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4.61716 10.9134C2.5546 10.5031 1 8.68312 1 6.5C1 4.01472 3.01472 2 5.5 2C7.90266 2 9.86552 3.88299 9.99338 6.25375C10.6346 6.08811 11.307 6 12 6C12.693 6 13.3654 6.08811 14.0066 6.25375C14.1345 3.88299 16.0973 2 18.5 2C20.9853 2 23 4.01472 23 6.5C23 8.68312 21.4454 10.5031 19.3828 10.9134C19.7804 11.8632 20 12.906 20 14C20 18.4183 16.4183 22 12 22C7.58172 22 4 18.4183 4 14C4 12.906 4.21961 11.8632 4.61716 10.9134ZM3 6.5C3 7.88071 4.11929 9 5.5 9C5.5898 9 5.6785 8.99527 5.76585 8.98603C6.36594 8.24086 7.0969 7.60551 7.92382 7.11489C7.97357 6.91818 8 6.71217 8 6.5C8 5.11929 6.88071 4 5.5 4C4.11929 4 3 5.11929 3 6.5ZM18.2341 8.98603C18.3215 8.99527 18.4102 9 18.5 9C19.8807 9 21 7.88071 21 6.5C21 5.11929 19.8807 4 18.5 4C17.1193 4 16 5.11929 16 6.5C16 6.71217 16.0264 6.91818 16.0762 7.11489C16.9031 7.60551 17.6341 8.24086 18.2341 8.98603ZM6 14C6 17.3137 8.68629 20 12 20C15.3137 20 18 17.3137 18 14C18 10.6863 15.3137 8 12 8C8.68629 8 6 10.6863 6 14Z"
  }));
},
    vh = function vh(_ref1365) {
  var _ref1365$color = _ref1365.color,
      C = _ref1365$color === void 0 ? "currentColor" : _ref1365$color,
      _ref1365$size = _ref1365.size,
      e = _ref1365$size === void 0 ? 24 : _ref1365$size,
      l = _ref1365.className,
      i = _objectWithoutProperties(_ref1365, _excluded1365);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13.1962 2.26797L16.4462 7.89714C16.7223 8.37543 16.5584 8.98702 16.0801 9.26316L14.7806 10.0123L15.7811 11.7452L14.049 12.7452L13.0485 11.0123L11.75 11.7632C11.2717 12.0393 10.6601 11.8754 10.384 11.3971L8.5462 8.21466C6.49383 8.83736 5 10.7442 5 13C5 13.6254 5.1148 14.2239 5.32447 14.7757C6.0992 14.284 7.01643 14 8 14C9.68408 14 11.1737 14.8326 12.0797 16.1086L19.7681 11.6704L20.7681 13.4025L12.8898 17.951C12.962 18.2893 13 18.6402 13 19C13 19.3427 12.9655 19.6774 12.8999 20.0007L21 20V22L4.00054 22.0012C3.3723 21.1654 3 20.1262 3 19C3 17.9928 3.29782 17.0551 3.81021 16.2703C3.29276 15.2948 3 14.1816 3 13C3 10.0047 4.88131 7.44881 7.52677 6.44948L7.13397 5.76797C6.58169 4.81139 6.90944 3.58821 7.86603 3.03592L10.4641 1.53592C11.4207 0.983638 12.6439 1.31139 13.1962 2.26797Z"
  }));
},
    dh = function dh(_ref1366) {
  var _ref1366$color = _ref1366.color,
      C = _ref1366$color === void 0 ? "currentColor" : _ref1366$color,
      _ref1366$size = _ref1366.size,
      e = _ref1366$size === void 0 ? 24 : _ref1366$size,
      l = _ref1366.className,
      i = _objectWithoutProperties(_ref1366, _excluded1366);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13.1962 2.26797L16.4462 7.89714C16.7223 8.37543 16.5584 8.98702 16.0801 9.26316L14.7806 10.0123L15.7811 11.7452L14.049 12.7452L13.0485 11.0123L11.75 11.7632C11.2717 12.0393 10.6601 11.8754 10.384 11.3971L8.5462 8.21466C6.49383 8.83736 5 10.7442 5 13C5 13.6254 5.1148 14.2239 5.32447 14.7757C6.0992 14.284 7.01643 14 8 14C9.68408 14 11.1737 14.8326 12.0797 16.1086L19.7681 11.6704L20.7681 13.4025L12.8898 17.951C12.962 18.2893 13 18.6402 13 19C13 19.3427 12.9655 19.6774 12.8999 20.0007L21 20V22L4.00054 22.0012C3.3723 21.1654 3 20.1262 3 19C3 17.9928 3.29782 17.0551 3.81021 16.2703C3.29276 15.2948 3 14.1816 3 13C3 10.0047 4.88131 7.44881 7.52677 6.44948L7.13397 5.76797C6.58169 4.81139 6.90944 3.58821 7.86603 3.03592L10.4641 1.53592C11.4207 0.983638 12.6439 1.31139 13.1962 2.26797ZM8 16C6.34315 16 5 17.3432 5 19C5 19.3506 5.06014 19.6872 5.17067 19.9999H10.8293C10.9399 19.6872 11 19.3506 11 19C11 17.3432 9.65685 16 8 16ZM11.4641 3.26797L8.86602 4.76797L11.616 9.53111L14.2141 8.03111L11.4641 3.26797Z"
  }));
},
    ph = function ph(_ref1367) {
  var _ref1367$color = _ref1367.color,
      C = _ref1367$color === void 0 ? "currentColor" : _ref1367$color,
      _ref1367$size = _ref1367.size,
      e = _ref1367$size === void 0 ? 24 : _ref1367$size,
      l = _ref1367.className,
      i = _objectWithoutProperties(_ref1367, _excluded1367);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11.501 3V11.5H3.00098V3H11.501ZM11.501 21H3.00098V12.5H11.501V21ZM12.501 3H21.001V11.5H12.501V3ZM21.001 12.5V21H12.501V12.5H21.001Z"
  }));
},
    Eh = function Eh(_ref1368) {
  var _ref1368$color = _ref1368.color,
      C = _ref1368$color === void 0 ? "currentColor" : _ref1368$color,
      _ref1368$size = _ref1368.size,
      e = _ref1368$size === void 0 ? 24 : _ref1368$size,
      l = _ref1368.className,
      i = _objectWithoutProperties(_ref1368, _excluded1368);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11.001 5H5.00098V11H11.001V5ZM13.001 5V11H19.001V5H13.001ZM19.001 13H13.001V19H19.001V13ZM11.001 19V13H5.00098V19H11.001ZM3.00098 3H21.001V21H3.00098V3Z"
  }));
},
    Nh = function Nh(_ref1369) {
  var _ref1369$color = _ref1369.color,
      C = _ref1369$color === void 0 ? "currentColor" : _ref1369$color,
      _ref1369$size = _ref1369.size,
      e = _ref1369$size === void 0 ? 24 : _ref1369$size,
      l = _ref1369.className,
      i = _objectWithoutProperties(_ref1369, _excluded1369);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18 3C19.6569 3 21 4.34315 21 6C21 7.65685 19.6569 9 18 9H15C13.6941 9 12.5831 8.16562 12.171 7.0009L11 7C9.9 7 9 7.9 9 9L9.0009 9.17102C10.1656 9.58312 11 10.6941 11 12C11 13.3059 10.1656 14.4169 9.0009 14.829L9 15C9 16.1 9.9 17 11 17L12.1707 17.0001C12.5825 15.8349 13.6937 15 15 15H18C19.6569 15 21 16.3431 21 18C21 19.6569 19.6569 21 18 21H15C13.6941 21 12.5831 20.1656 12.171 19.0009L11 19C8.79 19 7 17.21 7 15H5C3.34315 15 2 13.6569 2 12C2 10.3431 3.34315 9 5 9H7C7 6.79086 8.79086 5 11 5L12.1707 5.00009C12.5825 3.83485 13.6937 3 15 3H18ZM18 17H15C14.4477 17 14 17.4477 14 18C14 18.5523 14.4477 19 15 19H18C18.5523 19 19 18.5523 19 18C19 17.4477 18.5523 17 18 17ZM8 11H5C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13H8C8.55228 13 9 12.5523 9 12C9 11.4477 8.55228 11 8 11ZM18 5H15C14.4477 5 14 5.44772 14 6C14 6.55228 14.4477 7 15 7H18C18.5523 7 19 6.55228 19 6C19 5.44772 18.5523 5 18 5Z"
  }));
},
    uh = function uh(_ref1370) {
  var _ref1370$color = _ref1370.color,
      C = _ref1370$color === void 0 ? "currentColor" : _ref1370$color,
      _ref1370$size = _ref1370.size,
      e = _ref1370$size === void 0 ? 24 : _ref1370$size,
      l = _ref1370.className,
      i = _objectWithoutProperties(_ref1370, _excluded1370);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15.8407 12.691C15.8185 12.6975 15.7966 12.7043 15.7743 12.7104C15.6382 12.749 15.4987 12.7727 15.3604 12.7727C14.7502 12.7727 14.4056 12.3605 14.5907 11.852C14.7261 11.4801 15.0814 11.1663 15.5152 11.021C16.1874 10.7758 16.6571 10.2167 16.6571 9.56612C16.6571 8.68948 15.8043 7.97881 14.7523 7.97881C13.7003 7.97881 12.8475 8.68948 12.8475 9.56612V14.4339C12.8475 15.6046 12.1693 16.6311 11.1544 17.2117C10.6012 17.5282 9.94956 17.7143 9.24971 17.7143C7.26575 17.7143 5.6518 16.2427 5.6518 14.4339C5.6518 13.8581 5.81642 13.3174 6.10329 12.8466C6.54725 12.1179 7.28702 11.5599 8.17307 11.3055C8.32463 11.2584 8.47956 11.2325 8.63232 11.2325C9.24523 11.2325 9.59142 11.6466 9.40553 12.1574C9.27956 12.5035 8.94031 12.8016 8.54478 12.9601C8.49754 12.9759 8.45157 12.9936 8.4062 13.0122C7.77792 13.2716 7.34493 13.8099 7.34493 14.4339C7.34493 15.3105 8.19769 16.0211 9.24971 16.0211C10.3016 16.0211 11.1544 15.3105 11.1544 14.4339V9.56612C11.1544 8.39537 11.8326 7.36888 12.8475 6.78821C13.4008 6.47172 14.0524 6.28567 14.7523 6.28567C16.7362 6.28567 18.3502 7.75724 18.3502 9.56612C18.3502 10.1418 18.1855 10.6826 17.8987 11.1534C17.4566 11.8789 16.7214 12.435 15.8407 12.691ZM2.00098 12C2.00098 17.5228 6.47814 22 12.001 22C17.5238 22 22.001 17.5228 22.001 12C22.001 6.47716 17.5238 2 12.001 2C6.47814 2 2.00098 6.47716 2.00098 12Z"
  }));
},
    Bh = function Bh(_ref1371) {
  var _ref1371$color = _ref1371.color,
      C = _ref1371$color === void 0 ? "currentColor" : _ref1371$color,
      _ref1371$size = _ref1371.size,
      e = _ref1371$size === void 0 ? 24 : _ref1371$size,
      l = _ref1371.className,
      i = _objectWithoutProperties(_ref1371, _excluded1371);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.001 22C6.47813 22 2.00098 17.5228 2.00098 12C2.00098 6.47715 6.47813 2 12.001 2C17.5238 2 22.001 6.47715 22.001 12C22.001 17.5228 17.5238 22 12.001 22ZM12.001 20C16.4193 20 20.001 16.4183 20.001 12C20.001 7.58172 16.4193 4 12.001 4C7.5827 4 4.00098 7.58172 4.00098 12C4.00098 16.4183 7.5827 20 12.001 20ZM13.001 14C13.001 15.9332 11.434 17.5002 9.50098 17.5002C7.56798 17.5002 6.00098 15.9332 6.00098 14.0002C6.00098 12.6262 6.80048 11.3965 8.02405 10.8265C8.52467 10.5932 9.11958 10.81 9.35282 11.3106C9.58607 11.8112 9.36932 12.4061 8.86871 12.6393C8.34353 12.884 8.00098 13.4109 8.00098 14.0002C8.00098 14.8287 8.67255 15.5002 9.50098 15.5002C10.3294 15.5002 11.001 14.8287 11.001 14.0002V10C11.001 8.067 12.568 6.5 14.501 6.5C16.434 6.5 18.001 8.067 18.001 10C18.001 11.3741 17.2015 12.6037 15.9779 13.1738C15.4773 13.407 14.8824 13.1903 14.6491 12.6897C14.4159 12.189 14.6326 11.5941 15.1332 11.3609C15.6584 11.1162 16.001 10.5894 16.001 10C16.001 9.17157 15.3294 8.5 14.501 8.5C13.6725 8.5 13.001 9.17157 13.001 10V14Z"
  }));
},
    fh = function fh(_ref1372) {
  var _ref1372$color = _ref1372.color,
      C = _ref1372$color === void 0 ? "currentColor" : _ref1372$color,
      _ref1372$size = _ref1372.size,
      e = _ref1372$size === void 0 ? 24 : _ref1372$size,
      l = _ref1372.className,
      i = _objectWithoutProperties(_ref1372, _excluded1372);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 4H8V6H4V4ZM16 19H20V21H16V19ZM2 9H12V11H2V9ZM14 9H20V11H14V9ZM4 14H10V16H4V14ZM12 14H22V16H12V14ZM10 4H22V6H10V4ZM2 19H14V21H2V19Z"
  }));
},
    Rh = function Rh(_ref1373) {
  var _ref1373$color = _ref1373.color,
      C = _ref1373$color === void 0 ? "currentColor" : _ref1373$color,
      _ref1373$size = _ref1373.size,
      e = _ref1373$size === void 0 ? 24 : _ref1373$size,
      l = _ref1373.className,
      i = _objectWithoutProperties(_ref1373, _excluded1373);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 4H8V6H4V4ZM16 19H20V21H16V19ZM2 9H7V11H2V9ZM9 9H12V11H9V9ZM14 9H20V11H14V9ZM4 14H10V16H4V14ZM12 14H15V16H12V14ZM17 14H22V16H17V14ZM10 4H22V6H10V4ZM2 19H14V21H2V19Z"
  }));
},
    zh = function zh(_ref1374) {
  var _ref1374$color = _ref1374.color,
      C = _ref1374$color === void 0 ? "currentColor" : _ref1374$color,
      _ref1374$size = _ref1374.size,
      e = _ref1374$size === void 0 ? 24 : _ref1374$size,
      l = _ref1374.className,
      i = _objectWithoutProperties(_ref1374, _excluded1374);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3.00488 3.00275H21.0049C21.5572 3.00275 22.0049 3.45046 22.0049 4.00275V20.0027C22.0049 20.555 21.5572 21.0027 21.0049 21.0027H3.00488C2.4526 21.0027 2.00488 20.555 2.00488 20.0027V4.00275C2.00488 3.45046 2.4526 3.00275 3.00488 3.00275ZM13.0049 13.0027V12.0027H16.0049V10.0027H13.4191L15.5404 7.88143L14.1262 6.46721L12.0049 8.58853L9.88356 6.46721L8.46935 7.88143L10.5907 10.0027H8.00488V12.0027H11.0049V13.0027H8.00488V15.0027H11.0049V17.0027H13.0049V15.0027H16.0049V13.0027H13.0049Z"
  }));
},
    Fh = function Fh(_ref1375) {
  var _ref1375$color = _ref1375.color,
      C = _ref1375$color === void 0 ? "currentColor" : _ref1375$color,
      _ref1375$size = _ref1375.size,
      e = _ref1375$size === void 0 ? 24 : _ref1375$size,
      l = _ref1375.className,
      i = _objectWithoutProperties(_ref1375, _excluded1375);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3.00488 3.00275H21.0049C21.5572 3.00275 22.0049 3.45046 22.0049 4.00275V20.0027C22.0049 20.555 21.5572 21.0027 21.0049 21.0027H3.00488C2.4526 21.0027 2.00488 20.555 2.00488 20.0027V4.00275C2.00488 3.45046 2.4526 3.00275 3.00488 3.00275ZM4.00488 5.00275V19.0027H20.0049V5.00275H4.00488ZM13.0049 13.0027H16.0049V15.0027H13.0049V17.0027H11.0049V15.0027H8.00488V13.0027H11.0049V12.0027H8.00488V10.0027H10.5907L8.46935 7.88143L9.88356 6.46721L12.0049 8.58853L14.1262 6.46721L15.5404 7.88143L13.4191 10.0027H16.0049V12.0027H13.0049V13.0027Z"
  }));
},
    Sh = function Sh(_ref1376) {
  var _ref1376$color = _ref1376.color,
      C = _ref1376$color === void 0 ? "currentColor" : _ref1376$color,
      _ref1376$size = _ref1376.size,
      e = _ref1376$size === void 0 ? 24 : _ref1376$size,
      l = _ref1376.className,
      i = _objectWithoutProperties(_ref1376, _excluded1376);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.0049 22.0027C6.48204 22.0027 2.00488 17.5256 2.00488 12.0027C2.00488 6.4799 6.48204 2.00275 12.0049 2.00275C17.5277 2.00275 22.0049 6.4799 22.0049 12.0027C22.0049 17.5256 17.5277 22.0027 12.0049 22.0027ZM13.0049 13.0027V12.0027H16.0049V10.0027H13.4191L15.5404 7.88143L14.1262 6.46721L12.0049 8.58853L9.88356 6.46721L8.46935 7.88143L10.5907 10.0027H8.00488V12.0027H11.0049V13.0027H8.00488V15.0027H11.0049V17.0027H13.0049V15.0027H16.0049V13.0027H13.0049Z"
  }));
},
    Ah = function Ah(_ref1377) {
  var _ref1377$color = _ref1377.color,
      C = _ref1377$color === void 0 ? "currentColor" : _ref1377$color,
      _ref1377$size = _ref1377.size,
      e = _ref1377$size === void 0 ? 24 : _ref1377$size,
      l = _ref1377.className,
      i = _objectWithoutProperties(_ref1377, _excluded1377);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.0049 22.0027C6.48204 22.0027 2.00488 17.5256 2.00488 12.0027C2.00488 6.4799 6.48204 2.00275 12.0049 2.00275C17.5277 2.00275 22.0049 6.4799 22.0049 12.0027C22.0049 17.5256 17.5277 22.0027 12.0049 22.0027ZM12.0049 20.0027C16.4232 20.0027 20.0049 16.421 20.0049 12.0027C20.0049 7.58447 16.4232 4.00275 12.0049 4.00275C7.5866 4.00275 4.00488 7.58447 4.00488 12.0027C4.00488 16.421 7.5866 20.0027 12.0049 20.0027ZM13.0049 13.0027H16.0049V15.0027H13.0049V17.0027H11.0049V15.0027H8.00488V13.0027H11.0049V12.0027H8.00488V10.0027H10.5907L8.46935 7.88143L9.88356 6.46721L12.0049 8.58853L14.1262 6.46721L15.5404 7.88143L13.4191 10.0027H16.0049V12.0027H13.0049V13.0027Z"
  }));
},
    kh = function kh(_ref1378) {
  var _ref1378$color = _ref1378.color,
      C = _ref1378$color === void 0 ? "currentColor" : _ref1378$color,
      _ref1378$size = _ref1378.size,
      e = _ref1378$size === void 0 ? 24 : _ref1378$size,
      l = _ref1378.className,
      i = _objectWithoutProperties(_ref1378, _excluded1378);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3.00488 3.00275H21.0049C21.5572 3.00275 22.0049 3.45046 22.0049 4.00275V20.0027C22.0049 20.555 21.5572 21.0027 21.0049 21.0027H3.00488C2.4526 21.0027 2.00488 20.555 2.00488 20.0027V4.00275C2.00488 3.45046 2.4526 3.00275 3.00488 3.00275ZM8.50488 14.0027V16.0027H11.0049V18.0027H13.0049V16.0027H14.0049C15.3856 16.0027 16.5049 14.8835 16.5049 13.5027C16.5049 12.122 15.3856 11.0027 14.0049 11.0027H10.0049C9.72874 11.0027 9.50488 10.7789 9.50488 10.5027C9.50488 10.2266 9.72874 10.0027 10.0049 10.0027H15.5049V8.00275H13.0049V6.00275H11.0049V8.00275H10.0049C8.62417 8.00275 7.50488 9.12203 7.50488 10.5027C7.50488 11.8835 8.62417 13.0027 10.0049 13.0027H14.0049C14.281 13.0027 14.5049 13.2266 14.5049 13.5027C14.5049 13.7789 14.281 14.0027 14.0049 14.0027H8.50488Z"
  }));
},
    Ph = function Ph(_ref1379) {
  var _ref1379$color = _ref1379.color,
      C = _ref1379$color === void 0 ? "currentColor" : _ref1379$color,
      _ref1379$size = _ref1379.size,
      e = _ref1379$size === void 0 ? 24 : _ref1379$size,
      l = _ref1379.className,
      i = _objectWithoutProperties(_ref1379, _excluded1379);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3.00488 3.00275H21.0049C21.5572 3.00275 22.0049 3.45046 22.0049 4.00275V20.0027C22.0049 20.555 21.5572 21.0027 21.0049 21.0027H3.00488C2.4526 21.0027 2.00488 20.555 2.00488 20.0027V4.00275C2.00488 3.45046 2.4526 3.00275 3.00488 3.00275ZM4.00488 5.00275V19.0027H20.0049V5.00275H4.00488ZM8.50488 14.0027H14.0049C14.281 14.0027 14.5049 13.7789 14.5049 13.5027C14.5049 13.2266 14.281 13.0027 14.0049 13.0027H10.0049C8.62417 13.0027 7.50488 11.8835 7.50488 10.5027C7.50488 9.12203 8.62417 8.00275 10.0049 8.00275H11.0049V6.00275H13.0049V8.00275H15.5049V10.0027H10.0049C9.72874 10.0027 9.50488 10.2266 9.50488 10.5027C9.50488 10.7789 9.72874 11.0027 10.0049 11.0027H14.0049C15.3856 11.0027 16.5049 12.122 16.5049 13.5027C16.5049 14.8835 15.3856 16.0027 14.0049 16.0027H13.0049V18.0027H11.0049V16.0027H8.50488V14.0027Z"
  }));
},
    Dh = function Dh(_ref1380) {
  var _ref1380$color = _ref1380.color,
      C = _ref1380$color === void 0 ? "currentColor" : _ref1380$color,
      _ref1380$size = _ref1380.size,
      e = _ref1380$size === void 0 ? 24 : _ref1380$size,
      l = _ref1380.className,
      i = _objectWithoutProperties(_ref1380, _excluded1380);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.0049 22.0027C6.48204 22.0027 2.00488 17.5256 2.00488 12.0027C2.00488 6.4799 6.48204 2.00275 12.0049 2.00275C17.5277 2.00275 22.0049 6.4799 22.0049 12.0027C22.0049 17.5256 17.5277 22.0027 12.0049 22.0027ZM8.50488 14.0027V16.0027H11.0049V18.0027H13.0049V16.0027H14.0049C15.3856 16.0027 16.5049 14.8835 16.5049 13.5027C16.5049 12.122 15.3856 11.0027 14.0049 11.0027H10.0049C9.72874 11.0027 9.50488 10.7789 9.50488 10.5027C9.50488 10.2266 9.72874 10.0027 10.0049 10.0027H15.5049V8.00275H13.0049V6.00275H11.0049V8.00275H10.0049C8.62417 8.00275 7.50488 9.12203 7.50488 10.5027C7.50488 11.8835 8.62417 13.0027 10.0049 13.0027H14.0049C14.281 13.0027 14.5049 13.2266 14.5049 13.5027C14.5049 13.7789 14.281 14.0027 14.0049 14.0027H8.50488Z"
  }));
},
    yh = function yh(_ref1381) {
  var _ref1381$color = _ref1381.color,
      C = _ref1381$color === void 0 ? "currentColor" : _ref1381$color,
      _ref1381$size = _ref1381.size,
      e = _ref1381$size === void 0 ? 24 : _ref1381$size,
      l = _ref1381.className,
      i = _objectWithoutProperties(_ref1381, _excluded1381);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.0049 22.0027C6.48204 22.0027 2.00488 17.5256 2.00488 12.0027C2.00488 6.4799 6.48204 2.00275 12.0049 2.00275C17.5277 2.00275 22.0049 6.4799 22.0049 12.0027C22.0049 17.5256 17.5277 22.0027 12.0049 22.0027ZM12.0049 20.0027C16.4232 20.0027 20.0049 16.421 20.0049 12.0027C20.0049 7.58447 16.4232 4.00275 12.0049 4.00275C7.5866 4.00275 4.00488 7.58447 4.00488 12.0027C4.00488 16.421 7.5866 20.0027 12.0049 20.0027ZM8.50488 14.0027H14.0049C14.281 14.0027 14.5049 13.7789 14.5049 13.5027C14.5049 13.2266 14.281 13.0027 14.0049 13.0027H10.0049C8.62417 13.0027 7.50488 11.8835 7.50488 10.5027C7.50488 9.12203 8.62417 8.00275 10.0049 8.00275H11.0049V6.00275H13.0049V8.00275H15.5049V10.0027H10.0049C9.72874 10.0027 9.50488 10.2266 9.50488 10.5027C9.50488 10.7789 9.72874 11.0027 10.0049 11.0027H14.0049C15.3856 11.0027 16.5049 12.122 16.5049 13.5027C16.5049 14.8835 15.3856 16.0027 14.0049 16.0027H13.0049V18.0027H11.0049V16.0027H8.50488V14.0027Z"
  }));
},
    bh = function bh(_ref1382) {
  var _ref1382$color = _ref1382.color,
      C = _ref1382$color === void 0 ? "currentColor" : _ref1382$color,
      _ref1382$size = _ref1382.size,
      e = _ref1382$size === void 0 ? 24 : _ref1382$size,
      l = _ref1382.className,
      i = _objectWithoutProperties(_ref1382, _excluded1382);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3.00488 3.00275H21.0049C21.5572 3.00275 22.0049 3.45046 22.0049 4.00275V20.0027C22.0049 20.555 21.5572 21.0027 21.0049 21.0027H3.00488C2.4526 21.0027 2.00488 20.555 2.00488 20.0027V4.00275C2.00488 3.45046 2.4526 3.00275 3.00488 3.00275ZM10.0549 11.0027C10.2865 9.86163 11.2954 9.00275 12.5049 9.00275C13.1201 9.00275 13.6834 9.22496 14.1189 9.59351L15.8198 8.45951C14.9973 7.56402 13.8166 7.00275 12.5049 7.00275C10.1886 7.00275 8.28107 8.75277 8.03235 11.0027H7.00488V13.0027H8.03235C8.28107 15.2527 10.1886 17.0027 12.5049 17.0027C13.8166 17.0027 14.9973 16.4415 15.8198 15.546L14.1188 14.412C13.6833 14.7806 13.1201 15.0027 12.5049 15.0027C11.2954 15.0027 10.2865 14.1439 10.0549 13.0027H15.0049V11.0027H10.0549Z"
  }));
},
    Th = function Th(_ref1383) {
  var _ref1383$color = _ref1383.color,
      C = _ref1383$color === void 0 ? "currentColor" : _ref1383$color,
      _ref1383$size = _ref1383.size,
      e = _ref1383$size === void 0 ? 24 : _ref1383$size,
      l = _ref1383.className,
      i = _objectWithoutProperties(_ref1383, _excluded1383);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3.00488 3.00275H21.0049C21.5572 3.00275 22.0049 3.45046 22.0049 4.00275V20.0027C22.0049 20.555 21.5572 21.0027 21.0049 21.0027H3.00488C2.4526 21.0027 2.00488 20.555 2.00488 20.0027V4.00275C2.00488 3.45046 2.4526 3.00275 3.00488 3.00275ZM4.00488 5.00275V19.0027H20.0049V5.00275H4.00488ZM10.0549 11.0027H15.0049V13.0027H10.0549C10.2865 14.1439 11.2954 15.0027 12.5049 15.0027C13.1201 15.0027 13.6833 14.7806 14.1188 14.412L15.8198 15.546C14.9973 16.4415 13.8166 17.0027 12.5049 17.0027C10.1886 17.0027 8.28107 15.2527 8.03235 13.0027H7.00488V11.0027H8.03235C8.28107 8.75277 10.1886 7.00275 12.5049 7.00275C13.8166 7.00275 14.9973 7.56402 15.8198 8.45951L14.1189 9.59351C13.6834 9.22496 13.1201 9.00275 12.5049 9.00275C11.2954 9.00275 10.2865 9.86163 10.0549 11.0027Z"
  }));
},
    Uh = function Uh(_ref1384) {
  var _ref1384$color = _ref1384.color,
      C = _ref1384$color === void 0 ? "currentColor" : _ref1384$color,
      _ref1384$size = _ref1384.size,
      e = _ref1384$size === void 0 ? 24 : _ref1384$size,
      l = _ref1384.className,
      i = _objectWithoutProperties(_ref1384, _excluded1384);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.0049 22.0027C6.48204 22.0027 2.00488 17.5256 2.00488 12.0027C2.00488 6.4799 6.48204 2.00275 12.0049 2.00275C17.5277 2.00275 22.0049 6.4799 22.0049 12.0027C22.0049 17.5256 17.5277 22.0027 12.0049 22.0027ZM10.0549 11.0027C10.2865 9.86163 11.2954 9.00275 12.5049 9.00275C13.1201 9.00275 13.6834 9.22496 14.1189 9.59351L15.8198 8.45951C14.9973 7.56402 13.8166 7.00275 12.5049 7.00275C10.1886 7.00275 8.28107 8.75277 8.03235 11.0027H7.00488V13.0027H8.03235C8.28107 15.2527 10.1886 17.0027 12.5049 17.0027C13.8166 17.0027 14.9973 16.4415 15.8198 15.546L14.1188 14.412C13.6833 14.7806 13.1201 15.0027 12.5049 15.0027C11.2954 15.0027 10.2865 14.1439 10.0549 13.0027H15.0049V11.0027H10.0549Z"
  }));
},
    Gh = function Gh(_ref1385) {
  var _ref1385$color = _ref1385.color,
      C = _ref1385$color === void 0 ? "currentColor" : _ref1385$color,
      _ref1385$size = _ref1385.size,
      e = _ref1385$size === void 0 ? 24 : _ref1385$size,
      l = _ref1385.className,
      i = _objectWithoutProperties(_ref1385, _excluded1385);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.0049 22.0027C6.48204 22.0027 2.00488 17.5256 2.00488 12.0027C2.00488 6.4799 6.48204 2.00275 12.0049 2.00275C17.5277 2.00275 22.0049 6.4799 22.0049 12.0027C22.0049 17.5256 17.5277 22.0027 12.0049 22.0027ZM12.0049 20.0027C16.4232 20.0027 20.0049 16.421 20.0049 12.0027C20.0049 7.58447 16.4232 4.00275 12.0049 4.00275C7.5866 4.00275 4.00488 7.58447 4.00488 12.0027C4.00488 16.421 7.5866 20.0027 12.0049 20.0027ZM10.0549 11.0027H15.0049V13.0027H10.0549C10.2865 14.1439 11.2954 15.0027 12.5049 15.0027C13.1201 15.0027 13.6833 14.7806 14.1188 14.412L15.8198 15.546C14.9973 16.4415 13.8166 17.0027 12.5049 17.0027C10.1886 17.0027 8.28107 15.2527 8.03235 13.0027H7.00488V11.0027H8.03235C8.28107 8.75277 10.1886 7.00275 12.5049 7.00275C13.8166 7.00275 14.9973 7.56402 15.8198 8.45951L14.1189 9.59351C13.6834 9.22496 13.1201 9.00275 12.5049 9.00275C11.2954 9.00275 10.2865 9.86163 10.0549 11.0027Z"
  }));
},
    Ih = function Ih(_ref1386) {
  var _ref1386$color = _ref1386.color,
      C = _ref1386$color === void 0 ? "currentColor" : _ref1386$color,
      _ref1386$size = _ref1386.size,
      e = _ref1386$size === void 0 ? 24 : _ref1386$size,
      l = _ref1386.className,
      i = _objectWithoutProperties(_ref1386, _excluded1386);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3.00488 3.00275H21.0049C21.5572 3.00275 22.0049 3.45046 22.0049 4.00275V20.0027C22.0049 20.555 21.5572 21.0027 21.0049 21.0027H3.00488C2.4526 21.0027 2.00488 20.555 2.00488 20.0027V4.00275C2.00488 3.45046 2.4526 3.00275 3.00488 3.00275ZM9.00488 13.0027V15.0027H8.00488V17.0027H16.0049V15.0027H11.0049V13.0027H14.0049V11.0027H11.0049V10.0027C11.0049 9.17432 11.6765 8.50275 12.5049 8.50275C13.0329 8.50275 13.4971 8.77553 13.7644 9.18786L15.7509 8.69125C15.2319 7.40804 13.9741 6.50275 12.5049 6.50275C10.5719 6.50275 9.00488 8.06975 9.00488 10.0027V11.0027H8.00488V13.0027H9.00488Z"
  }));
},
    Wh = function Wh(_ref1387) {
  var _ref1387$color = _ref1387.color,
      C = _ref1387$color === void 0 ? "currentColor" : _ref1387$color,
      _ref1387$size = _ref1387.size,
      e = _ref1387$size === void 0 ? 24 : _ref1387$size,
      l = _ref1387.className,
      i = _objectWithoutProperties(_ref1387, _excluded1387);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3.00488 3.00275H21.0049C21.5572 3.00275 22.0049 3.45046 22.0049 4.00275V20.0027C22.0049 20.555 21.5572 21.0027 21.0049 21.0027H3.00488C2.4526 21.0027 2.00488 20.555 2.00488 20.0027V4.00275C2.00488 3.45046 2.4526 3.00275 3.00488 3.00275ZM4.00488 5.00275V19.0027H20.0049V5.00275H4.00488ZM9.00488 13.0027H8.00488V11.0027H9.00488V10.0027C9.00488 8.06975 10.5719 6.50275 12.5049 6.50275C13.9741 6.50275 15.2319 7.40804 15.7509 8.69125L13.7644 9.18786C13.4971 8.77553 13.0329 8.50275 12.5049 8.50275C11.6765 8.50275 11.0049 9.17432 11.0049 10.0027V11.0027H14.0049V13.0027H11.0049V15.0027H16.0049V17.0027H8.00488V15.0027H9.00488V13.0027Z"
  }));
},
    Oh = function Oh(_ref1388) {
  var _ref1388$color = _ref1388.color,
      C = _ref1388$color === void 0 ? "currentColor" : _ref1388$color,
      _ref1388$size = _ref1388.size,
      e = _ref1388$size === void 0 ? 24 : _ref1388$size,
      l = _ref1388.className,
      i = _objectWithoutProperties(_ref1388, _excluded1388);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.0049 22.0027C6.48204 22.0027 2.00488 17.5256 2.00488 12.0027C2.00488 6.4799 6.48204 2.00275 12.0049 2.00275C17.5277 2.00275 22.0049 6.4799 22.0049 12.0027C22.0049 17.5256 17.5277 22.0027 12.0049 22.0027ZM9.00488 13.0027V15.0027H8.00488V17.0027H16.0049V15.0027H11.0049V13.0027H14.0049V11.0027H11.0049V10.0027C11.0049 9.17432 11.6765 8.50275 12.5049 8.50275C13.0329 8.50275 13.4971 8.77553 13.7644 9.18786L15.7509 8.69125C15.2319 7.40804 13.9741 6.50275 12.5049 6.50275C10.5719 6.50275 9.00488 8.06975 9.00488 10.0027V11.0027H8.00488V13.0027H9.00488Z"
  }));
},
    Kh = function Kh(_ref1389) {
  var _ref1389$color = _ref1389.color,
      C = _ref1389$color === void 0 ? "currentColor" : _ref1389$color,
      _ref1389$size = _ref1389.size,
      e = _ref1389$size === void 0 ? 24 : _ref1389$size,
      l = _ref1389.className,
      i = _objectWithoutProperties(_ref1389, _excluded1389);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.0049 22.0027C6.48204 22.0027 2.00488 17.5256 2.00488 12.0027C2.00488 6.4799 6.48204 2.00275 12.0049 2.00275C17.5277 2.00275 22.0049 6.4799 22.0049 12.0027C22.0049 17.5256 17.5277 22.0027 12.0049 22.0027ZM12.0049 20.0027C16.4232 20.0027 20.0049 16.421 20.0049 12.0027C20.0049 7.58447 16.4232 4.00275 12.0049 4.00275C7.5866 4.00275 4.00488 7.58447 4.00488 12.0027C4.00488 16.421 7.5866 20.0027 12.0049 20.0027ZM9.00488 13.0027H8.00488V11.0027H9.00488V10.0027C9.00488 8.06975 10.5719 6.50275 12.5049 6.50275C13.9741 6.50275 15.2319 7.40804 15.7509 8.69125L13.7644 9.18786C13.4971 8.77553 13.0329 8.50275 12.5049 8.50275C11.6765 8.50275 11.0049 9.17432 11.0049 10.0027V11.0027H14.0049V13.0027H11.0049V15.0027H16.0049V17.0027H8.00488V15.0027H9.00488V13.0027Z"
  }));
},
    Qh = function Qh(_ref1390) {
  var _ref1390$color = _ref1390.color,
      C = _ref1390$color === void 0 ? "currentColor" : _ref1390$color,
      _ref1390$size = _ref1390.size,
      e = _ref1390$size === void 0 ? 24 : _ref1390$size,
      l = _ref1390.className,
      i = _objectWithoutProperties(_ref1390, _excluded1390);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9.8216 2.23796C9.29417 3.38265 9 4.65697 9 6C9 10.9706 13.0294 15 18 15C19.343 15 20.6174 14.7058 21.762 14.1784C20.7678 18.6537 16.7747 22 12 22C6.47715 22 2 17.5228 2 12C2 7.22532 5.3463 3.23221 9.8216 2.23796ZM18.1642 2.29104L19 2.5V3.5L18.1642 3.70896C17.4476 3.8881 16.8881 4.4476 16.709 5.16417L16.5 6H15.5L15.291 5.16417C15.1119 4.4476 14.5524 3.8881 13.8358 3.70896L13 3.5V2.5L13.8358 2.29104C14.5524 2.1119 15.1119 1.5524 15.291 0.835829L15.5 0H16.5L16.709 0.835829C16.8881 1.5524 17.4476 2.1119 18.1642 2.29104ZM23.1642 7.29104L24 7.5V8.5L23.1642 8.70896C22.4476 8.8881 21.8881 9.4476 21.709 10.1642L21.5 11H20.5L20.291 10.1642C20.1119 9.4476 19.5524 8.8881 18.8358 8.70896L18 8.5V7.5L18.8358 7.29104C19.5524 7.1119 20.1119 6.5524 20.291 5.83583L20.5 5H21.5L21.709 5.83583C21.8881 6.5524 22.4476 7.1119 23.1642 7.29104Z"
  }));
},
    qh = function qh(_ref1391) {
  var _ref1391$color = _ref1391.color,
      C = _ref1391$color === void 0 ? "currentColor" : _ref1391$color,
      _ref1391$size = _ref1391.size,
      e = _ref1391$size === void 0 ? 24 : _ref1391$size,
      l = _ref1391.className,
      i = _objectWithoutProperties(_ref1391, _excluded1391);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10 6C10 10.4183 13.5817 14 18 14C19.4386 14 20.7885 13.6203 21.9549 12.9556C21.4738 18.0302 17.2005 22 12 22C6.47715 22 2 17.5228 2 12C2 6.79948 5.9698 2.52616 11.0444 2.04507C10.3797 3.21152 10 4.56142 10 6ZM4 12C4 16.4183 7.58172 20 12 20C14.9654 20 17.5757 18.3788 18.9571 15.9546C18.6407 15.9848 18.3214 16 18 16C12.4772 16 8 11.5228 8 6C8 5.67863 8.01524 5.35933 8.04536 5.04293C5.62119 6.42426 4 9.03458 4 12ZM18.1642 2.29104L19 2.5V3.5L18.1642 3.70896C17.4476 3.8881 16.8881 4.4476 16.709 5.16417L16.5 6H15.5L15.291 5.16417C15.1119 4.4476 14.5524 3.8881 13.8358 3.70896L13 3.5V2.5L13.8358 2.29104C14.5524 2.1119 15.1119 1.5524 15.291 0.835829L15.5 0H16.5L16.709 0.835829C16.8881 1.5524 17.4476 2.1119 18.1642 2.29104ZM23.1642 7.29104L24 7.5V8.5L23.1642 8.70896C22.4476 8.8881 21.8881 9.4476 21.709 10.1642L21.5 11H20.5L20.291 10.1642C20.1119 9.4476 19.5524 8.8881 18.8358 8.70896L18 8.5V7.5L18.8358 7.29104C19.5524 7.1119 20.1119 6.5524 20.291 5.83583L20.5 5H21.5L21.709 5.83583C21.8881 6.5524 22.4476 7.1119 23.1642 7.29104Z"
  }));
},
    jh = function jh(_ref1392) {
  var _ref1392$color = _ref1392.color,
      C = _ref1392$color === void 0 ? "currentColor" : _ref1392$color,
      _ref1392$size = _ref1392.size,
      e = _ref1392$size === void 0 ? 24 : _ref1392$size,
      l = _ref1392.className,
      i = _objectWithoutProperties(_ref1392, _excluded1392);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8.67047 5.00666C9.79257 2.63812 12.205 1 15 1C15.4162 1 15.8239 1.03632 16.2201 1.10596C16.0772 1.54488 16 2.01342 16 2.5C16 4.98528 18.0147 7 20.5 7C20.9866 7 21.4551 6.92277 21.894 6.77991C21.9637 7.17612 22 7.58382 22 8C22 9.2228 21.6865 10.3724 21.1354 11.3727C22.2787 12.3806 23 13.856 23 15.5C23 18.5376 20.5376 21 17.5 21H9C4.58172 21 1 17.4183 1 13C1 8.6921 4.405 5.17948 8.67047 5.00666ZM10.8473 5.21433C13.4205 5.82257 15.5135 7.67351 16.4576 10.0986C16.7951 10.0339 17.1436 10 17.5 10C18.1745 10 18.8207 10.1214 19.4179 10.3436C19.6433 9.91944 19.8095 9.45894 19.9054 8.97316C16.79 8.69062 14.3094 6.20996 14.0268 3.09465C12.7061 3.35519 11.5722 4.13582 10.8473 5.21433Z"
  }));
},
    Xh = function Xh(_ref1393) {
  var _ref1393$color = _ref1393.color,
      C = _ref1393$color === void 0 ? "currentColor" : _ref1393$color,
      _ref1393$size = _ref1393.size,
      e = _ref1393$size === void 0 ? 24 : _ref1393$size,
      l = _ref1393.className,
      i = _objectWithoutProperties(_ref1393, _excluded1393);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8.67047 5.00666C9.79257 2.63812 12.205 1 15 1C15.4162 1 15.8239 1.03632 16.2201 1.10596C16.0772 1.54488 16 2.01342 16 2.5C16 4.98528 18.0147 7 20.5 7C20.9866 7 21.4551 6.92277 21.894 6.77991C21.9637 7.17612 22 7.58382 22 8C22 9.2228 21.6865 10.3724 21.1354 11.3727C22.2787 12.3806 23 13.856 23 15.5C23 18.5376 20.5376 21 17.5 21H9C4.58172 21 1 17.4183 1 13C1 8.6921 4.405 5.17948 8.67047 5.00666ZM10.8473 5.21433C13.4205 5.82257 15.5135 7.67351 16.4576 10.0986C16.7951 10.0339 17.1436 10 17.5 10C18.1745 10 18.8207 10.1214 19.4179 10.3436C19.6433 9.91944 19.8095 9.45894 19.9054 8.97316C16.79 8.69062 14.3094 6.20996 14.0268 3.09465C12.7061 3.35519 11.5722 4.13582 10.8473 5.21433ZM17.5 19C19.433 19 21 17.433 21 15.5C21 13.567 19.433 12 17.5 12C16.5205 12 15.6351 12.4023 14.9998 13.0507C14.9999 13.0338 15 13.0169 15 13C15 9.68629 12.3137 7 9 7C5.68629 7 3 9.68629 3 13C3 16.3137 5.68629 19 9 19H17.5Z"
  }));
},
    Jh = function Jh(_ref1394) {
  var _ref1394$color = _ref1394.color,
      C = _ref1394$color === void 0 ? "currentColor" : _ref1394$color,
      _ref1394$size = _ref1394.size,
      e = _ref1394$size === void 0 ? 24 : _ref1394$size,
      l = _ref1394.className,
      i = _objectWithoutProperties(_ref1394, _excluded1394);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11.3807 2.01886C9.91573 3.38768 9 5.3369 9 7.49999C9 11.6421 12.3579 15 16.5 15C18.6631 15 20.6123 14.0843 21.9811 12.6193C21.6613 17.8537 17.3149 22 12 22C6.47715 22 2 17.5228 2 12C2 6.68514 6.14629 2.33869 11.3807 2.01886Z"
  }));
},
    Yh = function Yh(_ref1395) {
  var _ref1395$color = _ref1395.color,
      C = _ref1395$color === void 0 ? "currentColor" : _ref1395$color,
      _ref1395$size = _ref1395.size,
      e = _ref1395$size === void 0 ? 24 : _ref1395$size,
      l = _ref1395.className,
      i = _objectWithoutProperties(_ref1395, _excluded1395);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16 20.3345V18H14V14H3.33238C3.11567 13.2034 3 12.3652 3 11.5C3 6.93954 6.21346 3.1296 10.4996 2.211C10.1765 3.07941 10 4.01909 10 5.00001C10 9.41829 13.5817 13 18 13C19.4531 13 20.8157 12.6126 21.9902 11.9354C21.8178 15.7576 19.3867 18.9916 16 20.3345ZM7 20H14V22H7V20ZM2 16H12V18H2V16Z"
  }));
},
    _h = function _h(_ref1396) {
  var _ref1396$color = _ref1396.color,
      C = _ref1396$color === void 0 ? "currentColor" : _ref1396$color,
      _ref1396$size = _ref1396.size,
      e = _ref1396$size === void 0 ? 24 : _ref1396$size,
      l = _ref1396.className,
      i = _objectWithoutProperties(_ref1396, _excluded1396);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16 20.3345V18.135C17.6993 17.2367 19.012 15.7047 19.6233 13.8537C19.0927 13.9504 18.5498 14 18 14C13.0294 14 9 9.97059 9 5.00003C9 4.95443 9.00034 4.90887 9.00102 4.86337C7.04146 5.89875 5.60285 7.77581 5.15045 10H3.11775C3.79375 5.73826 7.30375 2.42006 11.6562 2.03699C11.2352 2.93681 11 3.94095 11 5.00003C11 8.86602 14.134 12 18 12C19.475 12 20.8435 11.5438 21.972 10.7648C21.9905 11.0074 22 11.2526 22 11.5C22 15.5107 19.5146 18.9409 16 20.3345ZM7 20H14V22H7V20ZM4 12H10V14H4V12ZM2 16H12V18H2V16Z"
  }));
},
    $h = function $h(_ref1397) {
  var _ref1397$color = _ref1397.color,
      C = _ref1397$color === void 0 ? "currentColor" : _ref1397$color,
      _ref1397$size = _ref1397.size,
      e = _ref1397$size === void 0 ? 24 : _ref1397$size,
      l = _ref1397.className,
      i = _objectWithoutProperties(_ref1397, _excluded1397);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10 7C10 10.866 13.134 14 17 14C18.9584 14 20.729 13.1957 21.9995 11.8995C22 11.933 22 11.9665 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C12.0335 2 12.067 2 12.1005 2.00049C10.8043 3.27098 10 5.04157 10 7ZM4 12C4 16.4183 7.58172 20 12 20C15.0583 20 17.7158 18.2839 19.062 15.7621C18.3945 15.9187 17.7035 16 17 16C12.0294 16 8 11.9706 8 7C8 6.29648 8.08133 5.60547 8.2379 4.938C5.71611 6.28423 4 8.9417 4 12Z"
  }));
},
    eH = function eH(_ref1398) {
  var _ref1398$color = _ref1398.color,
      C = _ref1398$color === void 0 ? "currentColor" : _ref1398$color,
      _ref1398$size = _ref1398.size,
      e = _ref1398$size === void 0 ? 24 : _ref1398$size,
      l = _ref1398.className,
      i = _objectWithoutProperties(_ref1398, _excluded1398);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 3C10.9 3 10 3.9 10 5C10 6.1 10.9 7 12 7C13.1 7 14 6.1 14 5C14 3.9 13.1 3 12 3ZM12 17C10.9 17 10 17.9 10 19C10 20.1 10.9 21 12 21C13.1 21 14 20.1 14 19C14 17.9 13.1 17 12 17ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10Z"
  }));
},
    tH = function tH(_ref1399) {
  var _ref1399$color = _ref1399.color,
      C = _ref1399$color === void 0 ? "currentColor" : _ref1399$color,
      _ref1399$size = _ref1399.size,
      e = _ref1399$size === void 0 ? 24 : _ref1399$size,
      l = _ref1399.className,
      i = _objectWithoutProperties(_ref1399, _excluded1399);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 3C11.175 3 10.5 3.675 10.5 4.5C10.5 5.325 11.175 6 12 6C12.825 6 13.5 5.325 13.5 4.5C13.5 3.675 12.825 3 12 3ZM12 18C11.175 18 10.5 18.675 10.5 19.5C10.5 20.325 11.175 21 12 21C12.825 21 13.5 20.325 13.5 19.5C13.5 18.675 12.825 18 12 18ZM12 10.5C11.175 10.5 10.5 11.175 10.5 12C10.5 12.825 11.175 13.5 12 13.5C12.825 13.5 13.5 12.825 13.5 12C13.5 11.175 12.825 10.5 12 10.5Z"
  }));
},
    CH = function CH(_ref1400) {
  var _ref1400$color = _ref1400.color,
      C = _ref1400$color === void 0 ? "currentColor" : _ref1400$color,
      _ref1400$size = _ref1400.size,
      e = _ref1400$size === void 0 ? 24 : _ref1400$size,
      l = _ref1400.className,
      i = _objectWithoutProperties(_ref1400, _excluded1400);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5 10C3.9 10 3 10.9 3 12C3 13.1 3.9 14 5 14C6.1 14 7 13.1 7 12C7 10.9 6.1 10 5 10ZM19 10C17.9 10 17 10.9 17 12C17 13.1 17.9 14 19 14C20.1 14 21 13.1 21 12C21 10.9 20.1 10 19 10ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10Z"
  }));
},
    lH = function lH(_ref1401) {
  var _ref1401$color = _ref1401.color,
      C = _ref1401$color === void 0 ? "currentColor" : _ref1401$color,
      _ref1401$size = _ref1401.size,
      e = _ref1401$size === void 0 ? 24 : _ref1401$size,
      l = _ref1401.className,
      i = _objectWithoutProperties(_ref1401, _excluded1401);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4.5 10.5C3.675 10.5 3 11.175 3 12C3 12.825 3.675 13.5 4.5 13.5C5.325 13.5 6 12.825 6 12C6 11.175 5.325 10.5 4.5 10.5ZM19.5 10.5C18.675 10.5 18 11.175 18 12C18 12.825 18.675 13.5 19.5 13.5C20.325 13.5 21 12.825 21 12C21 11.175 20.325 10.5 19.5 10.5ZM12 10.5C11.175 10.5 10.5 11.175 10.5 12C10.5 12.825 11.175 13.5 12 13.5C12.825 13.5 13.5 12.825 13.5 12C13.5 11.175 12.825 10.5 12 10.5Z"
  }));
},
    iH = function iH(_ref1402) {
  var _ref1402$color = _ref1402.color,
      C = _ref1402$color === void 0 ? "currentColor" : _ref1402$color,
      _ref1402$size = _ref1402.size,
      e = _ref1402$size === void 0 ? 24 : _ref1402$size,
      l = _ref1402.className,
      i = _objectWithoutProperties(_ref1402, _excluded1402);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8.36547 10L11.2 8H14.6915L13.5996 5H11V3H15L16.0919 6H20V9H17.1838L18.6405 13.0022C21.0608 13.0764 23 15.0617 23 17.5C23 19.9853 20.9853 22 18.5 22C16.0147 22 14 19.9853 14 17.5C14 15.6722 15.0897 14.0989 16.6549 13.3944L15.4194 10H14.4718L12.89 15.87L9.96536 16.9389C9.98822 17.1227 10 17.31 10 17.5C10 19.9853 7.98528 22 5.5 22C3.01472 22 1 19.9853 1 17.5C1 15.5407 2.25221 13.8738 4 13.2561V12H2V10H8.36547ZM5.5 20C6.88071 20 8 18.8807 8 17.5C8 16.1193 6.88071 15 5.5 15C4.11929 15 3 16.1193 3 17.5C3 18.8807 4.11929 20 5.5 20ZM18.5 20C19.8807 20 21 18.8807 21 17.5C21 16.1193 19.8807 15 18.5 15C17.1193 15 16 16.1193 16 17.5C16 18.8807 17.1193 20 18.5 20Z"
  }));
},
    sH = function sH(_ref1403) {
  var _ref1403$color = _ref1403.color,
      C = _ref1403$color === void 0 ? "currentColor" : _ref1403$color,
      _ref1403$size = _ref1403.size,
      e = _ref1403$size === void 0 ? 24 : _ref1403$size,
      l = _ref1403.className,
      i = _objectWithoutProperties(_ref1403, _excluded1403);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 13.2561V12H2V10H8.36547L11.2 8H14.6915L13.5996 5H11V3H15L16.0919 6H20V9H17.1838L18.6405 13.0022C21.0608 13.0764 23 15.0617 23 17.5C23 19.9853 20.9853 22 18.5 22C16.0147 22 14 19.9853 14 17.5C14 15.6722 15.0897 14.0989 16.6549 13.3944L15.4194 10H14.4718L12.89 15.87L12.8876 15.8689L12.8897 15.8745L9.96536 16.9389C9.98822 17.1227 10 17.31 10 17.5C10 19.9853 7.98528 22 5.5 22C3.01472 22 1 19.9853 1 17.5C1 15.5407 2.25221 13.8738 4 13.2561ZM6 13.0275C7.37617 13.1796 8.56531 13.9523 9.28138 15.0595L11.2383 14.3472L12.4032 10H11.8563L9 12H6V13.0275ZM5.5 20C6.88071 20 8 18.8807 8 17.5C8 16.1193 6.88071 15 5.5 15C4.11929 15 3 16.1193 3 17.5C3 18.8807 4.11929 20 5.5 20ZM18.5 20C19.8807 20 21 18.8807 21 17.5C21 16.1193 19.8807 15 18.5 15C17.1193 15 16 16.1193 16 17.5C16 18.8807 17.1193 20 18.5 20Z"
  }));
},
    rH = function rH(_ref1404) {
  var _ref1404$color = _ref1404.color,
      C = _ref1404$color === void 0 ? "currentColor" : _ref1404$color,
      _ref1404$size = _ref1404.size,
      e = _ref1404$size === void 0 ? 24 : _ref1404$size,
      l = _ref1404.className,
      i = _objectWithoutProperties(_ref1404, _excluded1404);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11.1411 2H12.8589C14.8728 2 15.9528 2.27848 16.9305 2.8014C17.9083 3.32432 18.6757 4.09169 19.1986 5.06946C19.7215 6.04724 20 7.12721 20 9.14111V14.8589C20 16.8728 19.7215 17.9528 19.1986 18.9305C18.6757 19.9083 17.9083 20.6757 16.9305 21.1986C15.9528 21.7215 14.8728 22 12.8589 22H11.1411C9.12721 22 8.04724 21.7215 7.06946 21.1986C6.09169 20.6757 5.32432 19.9083 4.8014 18.9305C4.27848 17.9528 4 16.8728 4 14.8589V9.14111C4 7.12721 4.27848 6.04724 4.8014 5.06946C5.32432 4.09169 6.09169 3.32432 7.06946 2.8014C8.04724 2.27848 9.12721 2 11.1411 2ZM11 6V11H13V6H11Z"
  }));
},
    cH = function cH(_ref1405) {
  var _ref1405$color = _ref1405.color,
      C = _ref1405$color === void 0 ? "currentColor" : _ref1405$color,
      _ref1405$size = _ref1405.size,
      e = _ref1405$size === void 0 ? 24 : _ref1405$size,
      l = _ref1405.className,
      i = _objectWithoutProperties(_ref1405, _excluded1405);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11.1411 4C9.5587 4 8.75361 4.16876 8.01266 4.56502C7.38342 4.90155 6.90155 5.38342 6.56502 6.01266C6.16876 6.75361 6 7.5587 6 9.14111V14.8589C6 16.4413 6.16876 17.2464 6.56502 17.9873C6.90155 18.6166 7.38342 19.0985 8.01266 19.435C8.75361 19.8312 9.5587 20 11.1411 20H12.8589C14.4413 20 15.2464 19.8312 15.9873 19.435C16.6166 19.0985 17.0985 18.6166 17.435 17.9873C17.8312 17.2464 18 16.4413 18 14.8589V9.14111C18 7.5587 17.8312 6.75361 17.435 6.01266C17.0985 5.38342 16.6166 4.90155 15.9873 4.56502C15.2464 4.16876 14.4413 4 12.8589 4H11.1411ZM11.1411 2H12.8589C14.8728 2 15.9528 2.27848 16.9305 2.8014C17.9083 3.32432 18.6757 4.09169 19.1986 5.06946C19.7215 6.04724 20 7.12721 20 9.14111V14.8589C20 16.8728 19.7215 17.9528 19.1986 18.9305C18.6757 19.9083 17.9083 20.6757 16.9305 21.1986C15.9528 21.7215 14.8728 22 12.8589 22H11.1411C9.12721 22 8.04724 21.7215 7.06946 21.1986C6.09169 20.6757 5.32432 19.9083 4.8014 18.9305C4.27848 17.9528 4 16.8728 4 14.8589V9.14111C4 7.12721 4.27848 6.04724 4.8014 5.06946C5.32432 4.09169 6.09169 3.32432 7.06946 2.8014C8.04724 2.27848 9.12721 2 11.1411 2ZM11 6H13V11H11V6Z"
  }));
},
    oH = function oH(_ref1406) {
  var _ref1406$color = _ref1406.color,
      C = _ref1406$color === void 0 ? "currentColor" : _ref1406$color,
      _ref1406$size = _ref1406.size,
      e = _ref1406$size === void 0 ? 24 : _ref1406$size,
      l = _ref1406.className,
      i = _objectWithoutProperties(_ref1406, _excluded1406);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18.001 20H20V22H12C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 15.2712 20.4293 18.1755 18.001 20ZM12 10C13.1046 10 14 9.10457 14 8C14 6.89543 13.1046 6 12 6C10.8954 6 10 6.89543 10 8C10 9.10457 10.8954 10 12 10ZM8 14C9.10457 14 10 13.1046 10 12C10 10.8954 9.10457 10 8 10C6.89543 10 6 10.8954 6 12C6 13.1046 6.89543 14 8 14ZM16 14C17.1046 14 18 13.1046 18 12C18 10.8954 17.1046 10 16 10C14.8954 10 14 10.8954 14 12C14 13.1046 14.8954 14 16 14ZM12 18C13.1046 18 14 17.1046 14 16C14 14.8954 13.1046 14 12 14C10.8954 14 10 14.8954 10 16C10 17.1046 10.8954 18 12 18Z"
  }));
},
    aH = function aH(_ref1407) {
  var _ref1407$color = _ref1407.color,
      C = _ref1407$color === void 0 ? "currentColor" : _ref1407$color,
      _ref1407$size = _ref1407.size,
      e = _ref1407$size === void 0 ? 24 : _ref1407$size,
      l = _ref1407.className,
      i = _objectWithoutProperties(_ref1407, _excluded1407);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 20H20V22H12C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 14.2512 21.2561 16.3287 20.0007 18H17.2916C18.9525 16.5341 20 14.3894 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 10C10.8954 10 10 9.10457 10 8C10 6.89543 10.8954 6 12 6C13.1046 6 14 6.89543 14 8C14 9.10457 13.1046 10 12 10ZM8 14C6.89543 14 6 13.1046 6 12C6 10.8954 6.89543 10 8 10C9.10457 10 10 10.8954 10 12C10 13.1046 9.10457 14 8 14ZM16 14C14.8954 14 14 13.1046 14 12C14 10.8954 14.8954 10 16 10C17.1046 10 18 10.8954 18 12C18 13.1046 17.1046 14 16 14ZM12 18C10.8954 18 10 17.1046 10 16C10 14.8954 10.8954 14 12 14C13.1046 14 14 14.8954 14 16C14 17.1046 13.1046 18 12 18Z"
  }));
},
    nH = function nH(_ref1408) {
  var _ref1408$color = _ref1408.color,
      C = _ref1408$color === void 0 ? "currentColor" : _ref1408$color,
      _ref1408$size = _ref1408.size,
      e = _ref1408$size === void 0 ? 24 : _ref1408$size,
      l = _ref1408.className,
      i = _objectWithoutProperties(_ref1408, _excluded1408);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 3.9934C2 3.44476 2.45531 3 2.9918 3H21.0082C21.556 3 22 3.44495 22 3.9934V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5551 2 20.0066V3.9934ZM10.6219 8.41459C10.5562 8.37078 10.479 8.34741 10.4 8.34741C10.1791 8.34741 10 8.52649 10 8.74741V15.2526C10 15.3316 10.0234 15.4088 10.0672 15.4745C10.1897 15.6583 10.4381 15.708 10.6219 15.5854L15.5008 12.3328C15.5447 12.3035 15.5824 12.2658 15.6117 12.2219C15.7343 12.0381 15.6846 11.7897 15.5008 11.6672L10.6219 8.41459Z"
  }));
},
    mH = function mH(_ref1409) {
  var _ref1409$color = _ref1409.color,
      C = _ref1409$color === void 0 ? "currentColor" : _ref1409$color,
      _ref1409$size = _ref1409.size,
      e = _ref1409$size === void 0 ? 24 : _ref1409$size,
      l = _ref1409.className,
      i = _objectWithoutProperties(_ref1409, _excluded1409);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 3.9934C2 3.44476 2.45531 3 2.9918 3H21.0082C21.556 3 22 3.44495 22 3.9934V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5551 2 20.0066V3.9934ZM4 5V19H20V5H4ZM10.6219 8.41459L15.5008 11.6672C15.6846 11.7897 15.7343 12.0381 15.6117 12.2219C15.5824 12.2658 15.5447 12.3035 15.5008 12.3328L10.6219 15.5854C10.4381 15.708 10.1897 15.6583 10.0672 15.4745C10.0234 15.4088 10 15.3316 10 15.2526V8.74741C10 8.52649 10.1791 8.34741 10.4 8.34741C10.479 8.34741 10.5562 8.37078 10.6219 8.41459Z"
  }));
},
    wH = function wH(_ref1410) {
  var _ref1410$color = _ref1410.color,
      C = _ref1410$color === void 0 ? "currentColor" : _ref1410$color,
      _ref1410$size = _ref1410.size,
      e = _ref1410$size === void 0 ? 24 : _ref1410$size,
      l = _ref1410.className,
      i = _objectWithoutProperties(_ref1410, _excluded1410);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 3V17C20 19.2091 18.2091 21 16 21C13.7909 21 12 19.2091 12 17C12 14.7909 13.7909 13 16 13C16.7286 13 17.4117 13.1948 18 13.5351V6H9V17C9 19.2091 7.20914 21 5 21C2.79086 21 1 19.2091 1 17C1 14.7909 2.79086 13 5 13C5.72857 13 6.41165 13.1948 7 13.5351V3H20Z"
  }));
},
    LH = function LH(_ref1411) {
  var _ref1411$color = _ref1411.color,
      C = _ref1411$color === void 0 ? "currentColor" : _ref1411$color,
      _ref1411$size = _ref1411.size,
      e = _ref1411$size === void 0 ? 24 : _ref1411$size,
      l = _ref1411.className,
      i = _objectWithoutProperties(_ref1411, _excluded1411);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 3V17C20 19.2091 18.2091 21 16 21C13.7909 21 12 19.2091 12 17C12 14.7909 13.7909 13 16 13C16.7286 13 17.4117 13.1948 18 13.5351V5H9V17C9 19.2091 7.20914 21 5 21C2.79086 21 1 19.2091 1 17C1 14.7909 2.79086 13 5 13C5.72857 13 6.41165 13.1948 7 13.5351V3H20ZM5 19C6.10457 19 7 18.1046 7 17C7 15.8954 6.10457 15 5 15C3.89543 15 3 15.8954 3 17C3 18.1046 3.89543 19 5 19ZM16 19C17.1046 19 18 18.1046 18 17C18 15.8954 17.1046 15 16 15C14.8954 15 14 15.8954 14 17C14 18.1046 14.8954 19 16 19Z"
  }));
},
    hH = function hH(_ref1412) {
  var _ref1412$color = _ref1412.color,
      C = _ref1412$color === void 0 ? "currentColor" : _ref1412$color,
      _ref1412$size = _ref1412.size,
      e = _ref1412$size === void 0 ? 24 : _ref1412$size,
      l = _ref1412.className,
      i = _objectWithoutProperties(_ref1412, _excluded1412);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 13.5351V3H20V6H14V17C14 19.2091 12.2091 21 10 21C7.79086 21 6 19.2091 6 17C6 14.7909 7.79086 13 10 13C10.7286 13 11.4117 13.1948 12 13.5351Z"
  }));
},
    HH = function HH(_ref1413) {
  var _ref1413$color = _ref1413.color,
      C = _ref1413$color === void 0 ? "currentColor" : _ref1413$color,
      _ref1413$size = _ref1413.size,
      e = _ref1413$size === void 0 ? 24 : _ref1413$size,
      l = _ref1413.className,
      i = _objectWithoutProperties(_ref1413, _excluded1413);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 13.5351V3H20V5H14V17C14 19.2091 12.2091 21 10 21C7.79086 21 6 19.2091 6 17C6 14.7909 7.79086 13 10 13C10.7286 13 11.4117 13.1948 12 13.5351ZM10 19C11.1046 19 12 18.1046 12 17C12 15.8954 11.1046 15 10 15C8.89543 15 8 15.8954 8 17C8 18.1046 8.89543 19 10 19Z"
  }));
},
    VH = function VH(_ref1414) {
  var _ref1414$color = _ref1414.color,
      C = _ref1414$color === void 0 ? "currentColor" : _ref1414$color,
      _ref1414$size = _ref1414.size,
      e = _ref1414$size === void 0 ? 24 : _ref1414$size,
      l = _ref1414.className,
      i = _objectWithoutProperties(_ref1414, _excluded1414);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 3.9934C2 3.44476 2.45531 3 2.9918 3H21.0082C21.556 3 22 3.44495 22 3.9934V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5551 2 20.0066V3.9934ZM12 12.1707C11.6872 12.0602 11.3506 12 11 12C9.34315 12 8 13.3431 8 15C8 16.6569 9.34315 18 11 18C12.6569 18 14 16.6569 14 15V8H17V6H12V12.1707Z"
  }));
},
    gH = function gH(_ref1415) {
  var _ref1415$color = _ref1415.color,
      C = _ref1415$color === void 0 ? "currentColor" : _ref1415$color,
      _ref1415$size = _ref1415.size,
      e = _ref1415$size === void 0 ? 24 : _ref1415$size,
      l = _ref1415.className,
      i = _objectWithoutProperties(_ref1415, _excluded1415);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 3.9934C2 3.44476 2.45531 3 2.9918 3H21.0082C21.556 3 22 3.44495 22 3.9934V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5551 2 20.0066V3.9934ZM4 5V19H20V5H4ZM12 12.1707V6H17V8H14V15C14 16.6569 12.6569 18 11 18C9.34315 18 8 16.6569 8 15C8 13.3431 9.34315 12 11 12C11.3506 12 11.6872 12.0602 12 12.1707Z"
  }));
},
    MH = function MH(_ref1416) {
  var _ref1416$color = _ref1416.color,
      C = _ref1416$color === void 0 ? "currentColor" : _ref1416$color,
      _ref1416$size = _ref1416.size,
      e = _ref1416$size === void 0 ? 24 : _ref1416$size,
      l = _ref1416.className,
      i = _objectWithoutProperties(_ref1416, _excluded1416);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2.89945 2.29983L21.7052 8.56842C21.9672 8.65574 22.1088 8.93891 22.0215 9.20088C21.975 9.3404 21.8694 9.45238 21.7328 9.507L13.0002 13.0001L8.57501 21.8504C8.45151 22.0974 8.15118 22.1975 7.90419 22.074C7.77883 22.0113 7.68553 21.8989 7.64703 21.7641L2.26058 2.91153C2.18472 2.64601 2.33846 2.36927 2.60398 2.29341C2.70087 2.26573 2.80386 2.26796 2.89945 2.29983Z"
  }));
},
    ZH = function ZH(_ref1417) {
  var _ref1417$color = _ref1417.color,
      C = _ref1417$color === void 0 ? "currentColor" : _ref1417$color,
      _ref1417$size = _ref1417.size,
      e = _ref1417$size === void 0 ? 24 : _ref1417$size,
      l = _ref1417.className,
      i = _objectWithoutProperties(_ref1417, _excluded1417);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4.96488 5.09625L8.5107 17.5066L11.5514 11.4253L17.188 9.17062L4.96488 5.09625ZM2.89945 2.29958L21.7052 8.56818C21.9672 8.6555 22.1088 8.93866 22.0215 9.20063C21.975 9.34016 21.8694 9.45214 21.7328 9.50676L13.0002 12.9998L8.57501 21.8501C8.45151 22.0971 8.15118 22.1972 7.90419 22.0737C7.77883 22.011 7.68553 21.8986 7.64703 21.7639L2.26058 2.91129C2.18472 2.64577 2.33846 2.36903 2.60398 2.29316C2.70087 2.26548 2.80386 2.26772 2.89945 2.29958Z"
  }));
},
    xH = function xH(_ref1418) {
  var _ref1418$color = _ref1418.color,
      C = _ref1418$color === void 0 ? "currentColor" : _ref1418$color,
      _ref1418$size = _ref1418.size,
      e = _ref1418$size === void 0 ? 24 : _ref1418$size,
      l = _ref1418.className,
      i = _objectWithoutProperties(_ref1418, _excluded1418);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.001 22C6.47813 22 2.00098 17.5228 2.00098 12C2.00098 6.47715 6.47813 2 12.001 2C17.5238 2 22.001 6.47715 22.001 12C22.001 17.5228 17.5238 22 12.001 22ZM10.915 11.5684C11.1559 10.7273 11.9899 10.0266 12.9053 9.9202C13.092 10.6139 13.2926 11.2934 13.4503 11.9826C13.503 12.2127 13.4869 12.4776 13.4317 12.7098C13.2195 13.6019 12.1844 13.9521 11.4543 13.3949C10.9232 12.9896 10.7125 12.2757 10.915 11.5684ZM14.7323 11.3707C14.6071 10.9065 14.476 10.4438 14.3394 9.95097C14.8388 10.081 15.2465 10.3108 15.594 10.6485C16.8506 11.87 16.9793 13.9488 15.888 15.3804C14.7526 16.8698 12.7331 17.5141 10.8596 16.9848C8.55798 16.3345 7.05207 14.0327 7.41861 11.6692C7.69287 9.90076 8.68938 8.66514 10.3187 7.93582C10.7257 7.75367 10.8985 7.37612 10.739 7.0063C10.5818 6.64172 10.1984 6.50242 9.79548 6.66349C7.07384 7.7515 5.47405 10.7974 6.12578 13.6503C6.83792 16.7679 9.61963 18.8125 12.7995 18.5089C14.5318 18.3435 15.9636 17.5609 17.0156 16.1624C18.5218 14.1599 18.3131 11.3794 16.5534 9.66325C15.8867 9.01311 15.0816 8.64501 14.1638 8.50972C14.08 8.49736 13.9463 8.45787 13.9314 8.40426C13.8437 8.09092 13.7506 7.77237 13.7249 7.45035C13.6963 7.09273 14.0143 6.80938 14.3753 6.80488C14.6282 6.80173 14.8087 6.93579 14.9784 7.10468C15.2805 7.40513 15.6824 7.42674 15.9662 7.16733C16.2551 6.90322 16.2624 6.48912 15.984 6.15892C15.4178 5.48746 14.3978 5.26779 13.5545 5.63572C12.7067 6.00566 12.233 6.82256 12.3546 7.72916C12.3922 8.00993 12.4639 8.28616 12.5213 8.57131C12.4302 8.59639 12.3452 8.61951 12.2605 8.64317C11.4048 8.88224 10.6999 9.34675 10.1634 10.0575C9.24196 11.2778 9.22657 12.8846 10.1219 14.0044C11.3962 15.5982 13.8687 15.2882 14.6453 13.4357C14.9287 12.7595 14.9201 12.0676 14.7323 11.3707Z"
  }));
},
    vH = function vH(_ref1419) {
  var _ref1419$color = _ref1419.color,
      C = _ref1419$color === void 0 ? "currentColor" : _ref1419$color,
      _ref1419$size = _ref1419.size,
      e = _ref1419$size === void 0 ? 24 : _ref1419$size,
      l = _ref1419.className,
      i = _objectWithoutProperties(_ref1419, _excluded1419);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10.4222 11.375C10.1278 12.4026 10.4341 13.4395 11.2058 14.0282C12.267 14.8376 13.7712 14.3289 14.0796 13.0331C14.1599 12.6958 14.1833 12.311 14.1067 11.9767C13.8775 10.9756 13.586 9.98862 13.3147 8.98094C11.9843 9.13543 10.7722 10.1533 10.4222 11.375ZM15.9698 11.0879C16.2427 12.1002 16.2553 13.1053 15.8435 14.0875C14.7148 16.7784 11.1215 17.2286 9.26951 14.9136C7.96829 13.2869 7.99065 10.953 9.32982 9.18031C10.1096 8.14796 11.1339 7.47322 12.3776 7.12595C12.5007 7.09159 12.6241 7.058 12.7566 7.02157C12.6731 6.60736 12.569 6.20612 12.5143 5.79828C12.3375 4.48137 13.026 3.29477 14.2582 2.7574C15.4836 2.22294 16.9661 2.54204 17.7889 3.51738C18.1936 3.99703 18.183 4.59854 17.7631 4.98218C17.3507 5.359 16.7665 5.32761 16.3276 4.89118C16.0809 4.64585 15.8185 4.45112 15.451 4.45569C14.9264 4.46223 14.4642 4.87382 14.5058 5.39329C14.5432 5.86105 14.6785 6.32376 14.8058 6.77892C14.8276 6.85679 15.0218 6.91415 15.1436 6.9321C16.4775 7.12862 17.6476 7.66332 18.6165 8.60769C21.1739 11.1006 21.4772 15.1394 19.2882 18.0482C17.7593 20.0797 15.6785 21.2165 13.1609 21.4567C8.53953 21.8977 4.49683 18.9278 3.46188 14.3992C2.5147 10.2551 4.8397 5.83074 8.79509 4.25032C9.38067 4.01635 9.93787 4.21869 10.1664 4.74827C10.3982 5.28546 10.147 5.83389 9.55552 6.09847C7.18759 7.15787 5.73935 8.9527 5.34076 11.5215C4.80806 14.9546 6.99662 18.2982 10.3416 19.2428C13.0644 20.0117 15.9994 19.0758 17.6494 16.9123C19.2354 14.8328 19.0484 11.8131 17.2221 10.0389C16.7172 9.54838 16.1246 9.21455 15.3988 9.02564C15.5974 9.74151 15.7879 10.4136 15.9698 11.0879Z"
  }));
},
    dH = function dH(_ref1420) {
  var _ref1420$color = _ref1420.color,
      C = _ref1420$color === void 0 ? "currentColor" : _ref1420$color,
      _ref1420$size = _ref1420.size,
      e = _ref1420$size === void 0 ? 24 : _ref1420$size,
      l = _ref1420.className,
      i = _objectWithoutProperties(_ref1420, _excluded1420);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11.2917 3.81415L13.3102 9.52081L13.7059 10.6371L13.7132 5.82625L13.7222 1.00908H17.9931L18.0004 11.8713C18.0031 17.8519 17.9967 22.7617 17.9849 22.7708C17.9731 22.7798 17.7762 22.7708 17.5493 22.7435C16.5601 22.6256 15.2596 22.5076 14.2096 22.4622C13.8629 22.4459 13.5761 22.4277 13.5725 22.4241C13.5698 22.4205 13.3002 21.6618 12.7966 20.2397L12.7967 20.2359C12.3051 18.8476 11.5851 16.8121 10.653 14.1746L10.3126 13.2214L10.3054 17.8066C10.299 22.1718 10.2954 22.4168 10.2482 22.4168C10.0849 22.4168 8.67819 22.5076 8.20809 22.553C7.89953 22.5802 7.28241 22.6437 6.83772 22.6982C6.39212 22.749 6.02185 22.7835 6.01459 22.7762C6.00733 22.7689 6.00098 17.8674 6.00098 11.8831V1.00182H6.00615L6.00551 1H10.2936L10.3217 1.08077C10.3288 1.09558 10.3865 1.25644 10.479 1.51683L11.1204 3.29515L11.2928 3.79066L11.2917 3.81415Z"
  }));
},
    pH = function pH(_ref1421) {
  var _ref1421$color = _ref1421.color,
      C = _ref1421$color === void 0 ? "currentColor" : _ref1421$color,
      _ref1421$size = _ref1421.size,
      e = _ref1421$size === void 0 ? 24 : _ref1421$size,
      l = _ref1421.className,
      i = _objectWithoutProperties(_ref1421, _excluded1421);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15.9853 17.2079L16.001 2H18.001V22C17.3209 21.7333 16.6476 21.5667 15.9809 21.5L8.00098 6.30216V21.5C7.33431 21.5667 6.66764 21.7333 6.00098 22V2H8.00098L15.9853 17.2079Z"
  }));
},
    EH = function EH(_ref1422) {
  var _ref1422$color = _ref1422.color,
      C = _ref1422$color === void 0 ? "currentColor" : _ref1422$color,
      _ref1422$size = _ref1422.size,
      e = _ref1422$size === void 0 ? 24 : _ref1422$size,
      l = _ref1422.className,
      i = _objectWithoutProperties(_ref1422, _excluded1422);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19 22H5C3.34315 22 2 20.6569 2 19V3C2 2.44772 2.44772 2 3 2H17C17.5523 2 18 2.44772 18 3V10H22V19C22 20.6569 20.6569 22 19 22ZM18 12V19C18 19.5523 18.4477 20 19 20C19.5523 20 20 19.5523 20 19V12H18ZM5 6V12H11V6H5ZM5 13V15H15V13H5ZM5 16V18H15V16H5ZM7 8H9V10H7V8Z"
  }));
},
    NH = function NH(_ref1423) {
  var _ref1423$color = _ref1423.color,
      C = _ref1423$color === void 0 ? "currentColor" : _ref1423$color,
      _ref1423$size = _ref1423.size,
      e = _ref1423$size === void 0 ? 24 : _ref1423$size,
      l = _ref1423.className,
      i = _objectWithoutProperties(_ref1423, _excluded1423);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16 20V4H4V19C4 19.5523 4.44772 20 5 20H16ZM19 22H5C3.34315 22 2 20.6569 2 19V3C2 2.44772 2.44772 2 3 2H17C17.5523 2 18 2.44772 18 3V10H22V19C22 20.6569 20.6569 22 19 22ZM18 12V19C18 19.5523 18.4477 20 19 20C19.5523 20 20 19.5523 20 19V12H18ZM6 6H12V12H6V6ZM8 8V10H10V8H8ZM6 13H14V15H6V13ZM6 16H14V18H6V16Z"
  }));
},
    uH = function uH(_ref1424) {
  var _ref1424$color = _ref1424.color,
      C = _ref1424$color === void 0 ? "currentColor" : _ref1424$color,
      _ref1424$size = _ref1424.size,
      e = _ref1424$size === void 0 ? 24 : _ref1424$size,
      l = _ref1424.className,
      i = _objectWithoutProperties(_ref1424, _excluded1424);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10 2C10.5523 2 11 2.44772 11 3V7C11 7.55228 10.5523 8 10 8H8V10H13V9C13 8.44772 13.4477 8 14 8H20C20.5523 8 21 8.44772 21 9V13C21 13.5523 20.5523 14 20 14H14C13.4477 14 13 13.5523 13 13V12H8V18H13V17C13 16.4477 13.4477 16 14 16H20C20.5523 16 21 16.4477 21 17V21C21 21.5523 20.5523 22 20 22H14C13.4477 22 13 21.5523 13 21V20H7C6.44772 20 6 19.5523 6 19V8H4C3.44772 8 3 7.55228 3 7V3C3 2.44772 3.44772 2 4 2H10ZM19 18H15V20H19V18ZM19 10H15V12H19V10ZM9 4H5V6H9V4Z"
  }));
},
    BH = function BH(_ref1425) {
  var _ref1425$color = _ref1425.color,
      C = _ref1425$color === void 0 ? "currentColor" : _ref1425$color,
      _ref1425$size = _ref1425.size,
      e = _ref1425$size === void 0 ? 24 : _ref1425$size,
      l = _ref1425.className,
      i = _objectWithoutProperties(_ref1425, _excluded1425);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22 20H2V18H3V11.0314C3 6.04348 7.02944 2 12 2C16.9706 2 21 6.04348 21 11.0314V18H22V20ZM9.5 21H14.5C14.5 22.3807 13.3807 23.5 12 23.5C10.6193 23.5 9.5 22.3807 9.5 21Z"
  }));
},
    fH = function fH(_ref1426) {
  var _ref1426$color = _ref1426.color,
      C = _ref1426$color === void 0 ? "currentColor" : _ref1426$color,
      _ref1426$size = _ref1426.size,
      e = _ref1426$size === void 0 ? 24 : _ref1426$size,
      l = _ref1426.className,
      i = _objectWithoutProperties(_ref1426, _excluded1426);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22 20H2V18H3V11.0314C3 6.04348 7.02944 2 12 2C16.9706 2 21 6.04348 21 11.0314V18H22V20ZM5 18H19V11.0314C19 7.14806 15.866 4 12 4C8.13401 4 5 7.14806 5 11.0314V18ZM9.5 21H14.5C14.5 22.3807 13.3807 23.5 12 23.5C10.6193 23.5 9.5 22.3807 9.5 21Z"
  }));
},
    RH = function RH(_ref1427) {
  var _ref1427$color = _ref1427.color,
      C = _ref1427$color === void 0 ? "currentColor" : _ref1427$color,
      _ref1427$size = _ref1427.size,
      e = _ref1427$size === void 0 ? 24 : _ref1427$size,
      l = _ref1427.className,
      i = _objectWithoutProperties(_ref1427, _excluded1427);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 17H22V19H2V17H4V10C4 5.58172 7.58172 2 12 2C16.4183 2 20 5.58172 20 10V17ZM9 21H15V23H9V21Z"
  }));
},
    zH = function zH(_ref1428) {
  var _ref1428$color = _ref1428.color,
      C = _ref1428$color === void 0 ? "currentColor" : _ref1428$color,
      _ref1428$size = _ref1428.size,
      e = _ref1428$size === void 0 ? 24 : _ref1428$size,
      l = _ref1428.className,
      i = _objectWithoutProperties(_ref1428, _excluded1428);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 17H22V19H2V17H4V10C4 5.58172 7.58172 2 12 2C16.4183 2 20 5.58172 20 10V17ZM18 17V10C18 6.68629 15.3137 4 12 4C8.68629 4 6 6.68629 6 10V17H18ZM9 21H15V23H9V21Z"
  }));
},
    FH = function FH(_ref1429) {
  var _ref1429$color = _ref1429.color,
      C = _ref1429$color === void 0 ? "currentColor" : _ref1429$color,
      _ref1429$size = _ref1429.size,
      e = _ref1429$size === void 0 ? 24 : _ref1429$size,
      l = _ref1429.className,
      i = _objectWithoutProperties(_ref1429, _excluded1429);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 18.6667L20.4 19.2C20.5657 19.4209 20.5209 19.7343 20.3 19.9C20.2135 19.9649 20.1082 20 20 20H4C3.72386 20 3.5 19.7761 3.5 19.5C3.5 19.3918 3.53509 19.2865 3.6 19.2L4 18.6667V10C4 5.58172 7.58172 2 12 2C16.4183 2 20 5.58172 20 10V18.6667ZM9.5 21H14.5C14.5 22.3807 13.3807 23.5 12 23.5C10.6193 23.5 9.5 22.3807 9.5 21Z"
  }));
},
    SH = function SH(_ref1430) {
  var _ref1430$color = _ref1430.color,
      C = _ref1430$color === void 0 ? "currentColor" : _ref1430$color,
      _ref1430$size = _ref1430.size,
      e = _ref1430$size === void 0 ? 24 : _ref1430$size,
      l = _ref1430.className,
      i = _objectWithoutProperties(_ref1430, _excluded1430);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18 10C18 6.68629 15.3137 4 12 4C8.68629 4 6 6.68629 6 10V18H18V10ZM20 18.6667L20.4 19.2C20.5657 19.4209 20.5209 19.7343 20.3 19.9C20.2135 19.9649 20.1082 20 20 20H4C3.72386 20 3.5 19.7761 3.5 19.5C3.5 19.3918 3.53509 19.2865 3.6 19.2L4 18.6667V10C4 5.58172 7.58172 2 12 2C16.4183 2 20 5.58172 20 10V18.6667ZM9.5 21H14.5C14.5 22.3807 13.3807 23.5 12 23.5C10.6193 23.5 9.5 22.3807 9.5 21Z"
  }));
},
    AH = function AH(_ref1431) {
  var _ref1431$color = _ref1431.color,
      C = _ref1431$color === void 0 ? "currentColor" : _ref1431$color,
      _ref1431$size = _ref1431.size,
      e = _ref1431$size === void 0 ? 24 : _ref1431$size,
      l = _ref1431.className,
      i = _objectWithoutProperties(_ref1431, _excluded1431);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13.3414 4C13.1203 4.62556 13 5.29873 13 6C13 9.31371 15.6863 12 19 12C19.7013 12 20.3744 11.8797 21 11.6586V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V5C3 4.44772 3.44772 4 4 4H13.3414ZM19 10C16.7909 10 15 8.20914 15 6C15 3.79086 16.7909 2 19 2C21.2091 2 23 3.79086 23 6C23 8.20914 21.2091 10 19 10Z"
  }));
},
    kH = function kH(_ref1432) {
  var _ref1432$color = _ref1432.color,
      C = _ref1432$color === void 0 ? "currentColor" : _ref1432$color,
      _ref1432$size = _ref1432.size,
      e = _ref1432$size === void 0 ? 24 : _ref1432$size,
      l = _ref1432.className,
      i = _objectWithoutProperties(_ref1432, _excluded1432);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13.3414 4C13.1203 4.62556 13 5.29873 13 6H5V20H19V12C19.7013 12 20.3744 11.8797 21 11.6586V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V5C3 4.44772 3.44772 4 4 4H13.3414ZM19 8C20.1046 8 21 7.10457 21 6C21 4.89543 20.1046 4 19 4C17.8954 4 17 4.89543 17 6C17 7.10457 17.8954 8 19 8ZM19 10C16.7909 10 15 8.20914 15 6C15 3.79086 16.7909 2 19 2C21.2091 2 23 3.79086 23 6C23 8.20914 21.2091 10 19 10Z"
  }));
},
    PH = function PH(_ref1433) {
  var _ref1433$color = _ref1433.color,
      C = _ref1433$color === void 0 ? "currentColor" : _ref1433$color,
      _ref1433$size = _ref1433.size,
      e = _ref1433$size === void 0 ? 24 : _ref1433$size,
      l = _ref1433.className,
      i = _objectWithoutProperties(_ref1433, _excluded1433);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C16.9706 2 21 6.04348 21 11.0314V20H3V11.0314C3 6.04348 7.02944 2 12 2ZM9.5 21H14.5C14.5 22.3807 13.3807 23.5 12 23.5C10.6193 23.5 9.5 22.3807 9.5 21Z"
  }));
},
    DH = function DH(_ref1434) {
  var _ref1434$color = _ref1434.color,
      C = _ref1434$color === void 0 ? "currentColor" : _ref1434$color,
      _ref1434$size = _ref1434.size,
      e = _ref1434$size === void 0 ? 24 : _ref1434$size,
      l = _ref1434.className,
      i = _objectWithoutProperties(_ref1434, _excluded1434);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5 18H19V11.0314C19 7.14806 15.866 4 12 4C8.13401 4 5 7.14806 5 11.0314V18ZM12 2C16.9706 2 21 6.04348 21 11.0314V20H3V11.0314C3 6.04348 7.02944 2 12 2ZM9.5 21H14.5C14.5 22.3807 13.3807 23.5 12 23.5C10.6193 23.5 9.5 22.3807 9.5 21Z"
  }));
},
    yH = function yH(_ref1435) {
  var _ref1435$color = _ref1435.color,
      C = _ref1435$color === void 0 ? "currentColor" : _ref1435$color,
      _ref1435$size = _ref1435.size,
      e = _ref1435$size === void 0 ? 24 : _ref1435$size,
      l = _ref1435.className,
      i = _objectWithoutProperties(_ref1435, _excluded1435);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18.5859 20H4.00016C3.72401 20 3.50016 19.7762 3.50016 19.5C3.50016 19.3918 3.53525 19.2866 3.60016 19.2L4.00016 18.6667V10C4.00016 8.67022 4.32462 7.41619 4.8987 6.31279L1.39355 2.80765L2.80777 1.39343L22.6068 21.1924L21.1925 22.6066L18.5859 20ZM20.0002 15.7858L7.55919 3.34486C8.8297 2.49537 10.3571 2.00003 12.0002 2.00003C16.4184 2.00003 20.0002 5.58176 20.0002 10V15.7858ZM9.50016 21H14.5002C14.5002 22.3807 13.3809 23.5 12.0002 23.5C10.6194 23.5 9.50016 22.3807 9.50016 21Z"
  }));
},
    bH = function bH(_ref1436) {
  var _ref1436$color = _ref1436.color,
      C = _ref1436$color === void 0 ? "currentColor" : _ref1436$color,
      _ref1436$size = _ref1436.size,
      e = _ref1436$size === void 0 ? 24 : _ref1436$size,
      l = _ref1436.className,
      i = _objectWithoutProperties(_ref1436, _excluded1436);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18.5859 20H4.00016C3.72401 20 3.50016 19.7762 3.50016 19.5C3.50016 19.3918 3.53525 19.2866 3.60016 19.2L4.00016 18.6667V10C4.00016 8.67022 4.32462 7.41619 4.8987 6.31279L1.39355 2.80765L2.80777 1.39343L22.6068 21.1924L21.1925 22.6066L18.5859 20ZM6.40776 7.82185C6.14458 8.49707 6.00016 9.23169 6.00016 10V18H16.5859L6.40776 7.82185ZM20.0002 15.7858L18.0002 13.7858V10C18.0002 6.68633 15.3139 4.00003 12.0002 4.00003C10.9117 4.00003 9.89096 4.28986 9.01087 4.79655L7.55919 3.34486C8.8297 2.49537 10.3571 2.00003 12.0002 2.00003C16.4184 2.00003 20.0002 5.58176 20.0002 10V15.7858ZM9.50016 21H14.5002C14.5002 22.3807 13.3809 23.5 12.0002 23.5C10.6194 23.5 9.50016 22.3807 9.50016 21Z"
  }));
},
    TH = function TH(_ref1437) {
  var _ref1437$color = _ref1437.color,
      C = _ref1437$color === void 0 ? "currentColor" : _ref1437$color,
      _ref1437$size = _ref1437.size,
      e = _ref1437$size === void 0 ? 24 : _ref1437$size,
      l = _ref1437.className,
      i = _objectWithoutProperties(_ref1437, _excluded1437);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.001 3C20.5533 3 21.001 3.44772 21.001 4V20C21.001 20.5523 20.5533 21 20.001 21H4.00098C3.44869 21 3.00098 20.5523 3.00098 20V4C3.00098 3.44772 3.44869 3 4.00098 3H20.001ZM17.001 7H7.00098V17H12.001V9.5H14.501V17H17.001V7Z"
  }));
},
    UH = function UH(_ref1438) {
  var _ref1438$color = _ref1438.color,
      C = _ref1438$color === void 0 ? "currentColor" : _ref1438$color,
      _ref1438$size = _ref1438.size,
      e = _ref1438$size === void 0 ? 24 : _ref1438$size,
      l = _ref1438.className,
      i = _objectWithoutProperties(_ref1438, _excluded1438);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.001 3C20.5533 3 21.001 3.44772 21.001 4V20C21.001 20.5523 20.5533 21 20.001 21H4.00098C3.44869 21 3.00098 20.5523 3.00098 20V4C3.00098 3.44772 3.44869 3 4.00098 3H20.001ZM19.001 5H5.00098V19H19.001V5ZM17.001 7V17H14.501V9.5H12.001V17H7.00098V7H17.001Z"
  }));
},
    GH = function GH(_ref1439) {
  var _ref1439$color = _ref1439.color,
      C = _ref1439$color === void 0 ? "currentColor" : _ref1439$color,
      _ref1439$size = _ref1439.size,
      e = _ref1439$size === void 0 ? 24 : _ref1439$size,
      l = _ref1439.className,
      i = _objectWithoutProperties(_ref1439, _excluded1439);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 1.5C13.3212 1.5 14.4839 1.84812 15.4468 2.49362C16.4098 3.13913 17.1731 4.08202 17.6956 5.27156C18.2182 6.4611 18.5 7.8973 18.5 9.52941V14.4706C18.5 16.1027 18.2182 17.5389 17.6956 18.7284C17.1731 19.918 16.4098 20.8609 15.4468 21.5064C14.4839 22.1519 13.3212 22.5 12 22.5C10.6788 22.5 9.51613 22.1519 8.55317 21.5064C7.5902 20.8609 6.82691 19.918 6.30436 18.7284C5.78181 17.5389 5.5 16.1027 5.5 14.4706V9.52941C5.5 7.8973 5.78181 6.4611 6.30436 5.27156C6.82691 4.08202 7.5902 3.13913 8.55317 2.49362C9.51613 1.84812 10.6788 1.5 12 1.5ZM12 3.5C11.084 3.5 10.3059 3.72649 9.66678 4.15491C9.02961 4.58202 8.50949 5.22453 8.13547 6.07594C7.72283 7.01528 7.5 8.18343 7.5 9.52941V14.4706C7.5 15.8166 7.72283 16.9847 8.13547 17.9241C8.50949 18.7755 9.02961 19.418 9.66678 19.8451C10.3059 20.2735 11.084 20.5 12 20.5C12.916 20.5 13.6941 20.2735 14.3332 19.8451C14.9704 19.418 15.4905 18.7755 15.8645 17.9241C16.2772 16.9847 16.5 15.8166 16.5 14.4706V9.52941C16.5 8.18343 16.2772 7.01528 15.8645 6.07594C15.4905 5.22453 14.9704 4.58202 14.3332 4.15491C13.6941 3.72649 12.916 3.5 12 3.5Z"
  }));
},
    IH = function IH(_ref1440) {
  var _ref1440$color = _ref1440.color,
      C = _ref1440$color === void 0 ? "currentColor" : _ref1440$color,
      _ref1440$size = _ref1440.size,
      e = _ref1440$size === void 0 ? 24 : _ref1440$size,
      l = _ref1440.className,
      i = _objectWithoutProperties(_ref1440, _excluded1440);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14 1.5V22H12V3.704L7.5 4.91V2.839L12.5 1.5H14Z"
  }));
},
    WH = function WH(_ref1441) {
  var _ref1441$color = _ref1441.color,
      C = _ref1441$color === void 0 ? "currentColor" : _ref1441$color,
      _ref1441$size = _ref1441.size,
      e = _ref1441$size === void 0 ? 24 : _ref1441$size,
      l = _ref1441.className,
      i = _objectWithoutProperties(_ref1441, _excluded1441);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16.0002 7.5C16.0002 5.29086 14.2094 3.5 12.0002 3.5C9.7911 3.5 8.00024 5.29086 8.00024 7.5H6.00024C6.00024 4.18629 8.68653 1.5 12.0002 1.5C15.314 1.5 18.0002 4.18629 18.0002 7.5C18.0002 8.93092 17.4993 10.2448 16.6633 11.276L9.344 19.9991L18.0002 20V22H6.00024L6 20.8731L15.0642 10.071C15.6485 9.37595 16.0002 8.47905 16.0002 7.5Z"
  }));
},
    OH = function OH(_ref1442) {
  var _ref1442$color = _ref1442.color,
      C = _ref1442$color === void 0 ? "currentColor" : _ref1442$color,
      _ref1442$size = _ref1442.size,
      e = _ref1442$size === void 0 ? 24 : _ref1442$size,
      l = _ref1442.className,
      i = _objectWithoutProperties(_ref1442, _excluded1442);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18.0001 2V3.36217L12.8087 9.54981C16.0169 9.94792 18.5001 12.684 18.5001 16C18.5001 19.5899 15.5899 22.5 12.0001 22.5C8.95434 22.5 6.39789 20.4052 5.69287 17.5778L7.63351 17.0922C8.12156 19.0497 9.89144 20.5 12.0001 20.5C14.4853 20.5 16.5001 18.4853 16.5001 16C16.5001 13.5147 14.4853 11.5 12.0001 11.5C11.2795 11.5 10.5985 11.6694 9.99465 11.9705L9.76692 12.0923L9.07705 10.8852L14.8551 3.99917L6.50006 4V2H18.0001Z"
  }));
},
    KH = function KH(_ref1443) {
  var _ref1443$color = _ref1443.color,
      C = _ref1443$color === void 0 ? "currentColor" : _ref1443$color,
      _ref1443$size = _ref1443.size,
      e = _ref1443$size === void 0 ? 24 : _ref1443$size,
      l = _ref1443.className,
      i = _objectWithoutProperties(_ref1443, _excluded1443);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16.0001 1.5L16 16H19.0001V18H16L16.0001 22H14.0001L14 18H4V16.898L14.0001 1.5H16.0001ZM14 16V5.171L6.968 16H14Z"
  }));
},
    QH = function QH(_ref1444) {
  var _ref1444$color = _ref1444.color,
      C = _ref1444$color === void 0 ? "currentColor" : _ref1444$color,
      _ref1444$size = _ref1444.size,
      e = _ref1444$size === void 0 ? 24 : _ref1444$size,
      l = _ref1444.className,
      i = _objectWithoutProperties(_ref1444, _excluded1444);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18.0001 2V4H9.30024L8.62337 10.4448C9.6075 9.84532 10.7634 9.5 12.0001 9.5C15.5899 9.5 18.5001 12.4101 18.5001 16C18.5001 19.5899 15.5899 22.5 12.0001 22.5C8.95434 22.5 6.39789 20.4052 5.69287 17.5778L7.63351 17.0922C8.12156 19.0497 9.89144 20.5 12.0001 20.5C14.4853 20.5 16.5001 18.4853 16.5001 16C16.5001 13.5147 14.4853 11.5 12.0001 11.5C9.97783 11.5 8.72237 12.139 8.03985 13.0293L6.46487 11.848L7.50006 2H18.0001Z"
  }));
},
    qH = function qH(_ref1445) {
  var _ref1445$color = _ref1445.color,
      C = _ref1445$color === void 0 ? "currentColor" : _ref1445$color,
      _ref1445$size = _ref1445.size,
      e = _ref1445$size === void 0 ? 24 : _ref1445$size,
      l = _ref1445.className,
      i = _objectWithoutProperties(_ref1445, _excluded1445);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14.886 2L10.4482 9.6864C10.9454 9.56459 11.4652 9.5 12 9.5C15.5899 9.5 18.5 12.4101 18.5 16C18.5 19.5899 15.5899 22.5 12 22.5C8.41015 22.5 5.5 19.5899 5.5 16C5.5 14.7949 5.82793 13.6665 6.39941 12.699L12.576 2H14.886ZM12 11.5C9.51472 11.5 7.5 13.5147 7.5 16C7.5 18.4853 9.51472 20.5 12 20.5C14.4853 20.5 16.5 18.4853 16.5 16C16.5 13.5147 14.4853 11.5 12 11.5Z"
  }));
},
    jH = function jH(_ref1446) {
  var _ref1446$color = _ref1446.color,
      C = _ref1446$color === void 0 ? "currentColor" : _ref1446$color,
      _ref1446$size = _ref1446.size,
      e = _ref1446$size === void 0 ? 24 : _ref1446$size,
      l = _ref1446.className,
      i = _objectWithoutProperties(_ref1446, _excluded1446);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19 2V3.5L10.763 21.9995H8.574L16.587 4H6V2H19Z"
  }));
},
    XH = function XH(_ref1447) {
  var _ref1447$color = _ref1447.color,
      C = _ref1447$color === void 0 ? "currentColor" : _ref1447$color,
      _ref1447$size = _ref1447.size,
      e = _ref1447$size === void 0 ? 24 : _ref1447$size,
      l = _ref1447.className,
      i = _objectWithoutProperties(_ref1447, _excluded1447);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 1.5C15.0376 1.5 17.5 3.96243 17.5 7C17.5 8.77579 16.6584 10.355 15.3523 11.3606C17.2389 12.4091 18.5 14.3186 18.5 16.5C18.5 19.8137 15.5899 22.5 12 22.5C8.41015 22.5 5.5 19.8137 5.5 16.5C5.5 14.3186 6.7611 12.4091 8.64703 11.3589C7.34158 10.355 6.5 8.77579 6.5 7C6.5 3.96243 8.96243 1.5 12 1.5ZM12 12.5C9.48055 12.5 7.5 14.3282 7.5 16.5C7.5 18.6718 9.48055 20.5 12 20.5C14.5194 20.5 16.5 18.6718 16.5 16.5C16.5 14.3282 14.5194 12.5 12 12.5ZM12 3.5C10.067 3.5 8.5 5.067 8.5 7C8.5 8.933 10.067 10.5 12 10.5C13.933 10.5 15.5 8.933 15.5 7C15.5 5.067 13.933 3.5 12 3.5Z"
  }));
},
    JH = function JH(_ref1448) {
  var _ref1448$color = _ref1448.color,
      C = _ref1448$color === void 0 ? "currentColor" : _ref1448$color,
      _ref1448$size = _ref1448.size,
      e = _ref1448$size === void 0 ? 24 : _ref1448$size,
      l = _ref1448.className,
      i = _objectWithoutProperties(_ref1448, _excluded1448);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 1.5C15.5899 1.5 18.5 4.41015 18.5 8C18.5 9.19219 18.179 10.3094 17.6188 11.27L11.423 21.999H9.114L13.5528 14.3134C13.0553 14.4353 12.5352 14.5 12 14.5C8.41015 14.5 5.5 11.5899 5.5 8C5.5 4.41015 8.41015 1.5 12 1.5ZM12 3.5C9.51472 3.5 7.5 5.51472 7.5 8C7.5 10.4853 9.51472 12.5 12 12.5C14.4853 12.5 16.5 10.4853 16.5 8C16.5 5.51472 14.4853 3.5 12 3.5Z"
  }));
},
    YH = function YH(_ref1449) {
  var _ref1449$color = _ref1449.color,
      C = _ref1449$color === void 0 ? "currentColor" : _ref1449$color,
      _ref1449$size = _ref1449.size,
      e = _ref1449$size === void 0 ? 24 : _ref1449$size,
      l = _ref1449.className,
      i = _objectWithoutProperties(_ref1449, _excluded1449);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9 18H4V10H9V18ZM15 18H10V6H15V18ZM21 18H16V2H21V18ZM22 22H3V20H22V22Z"
  }));
},
    _H = function _H(_ref1450) {
  var _ref1450$color = _ref1450.color,
      C = _ref1450$color === void 0 ? "currentColor" : _ref1450$color,
      _ref1450$size = _ref1450.size,
      e = _ref1450$size === void 0 ? 24 : _ref1450$size,
      l = _ref1450.className,
      i = _objectWithoutProperties(_ref1450, _excluded1450);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9 18H4V10H9V18ZM7 16V12H6V16H7ZM13 16V8H12V16H13ZM15 18H10V6H15V18ZM19 16V4H18V16H19ZM21 18H16V2H21V18ZM22 22H3V20H22V22Z"
  }));
},
    $H = function $H(_ref1451) {
  var _ref1451$color = _ref1451.color,
      C = _ref1451$color === void 0 ? "currentColor" : _ref1451$color,
      _ref1451$size = _ref1451.size,
      e = _ref1451$size === void 0 ? 24 : _ref1451$size,
      l = _ref1451.className,
      i = _objectWithoutProperties(_ref1451, _excluded1451);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14.9571 15.564C17.6154 16.6219 19.5726 19.0639 19.9387 22H4.0625C4.42862 19.0639 6.38587 16.6219 9.04417 15.564L12.0006 20L14.9571 15.564ZM18.0006 2V8C18.0006 11.3137 15.3143 14 12.0006 14C8.6869 14 6.00061 11.3137 6.00061 8V2H18.0006ZM16.0006 8H8.00061C8.00061 10.2091 9.79147 12 12.0006 12C14.2098 12 16.0006 10.2091 16.0006 8Z"
  }));
},
    eV = function eV(_ref1452) {
  var _ref1452$color = _ref1452.color,
      C = _ref1452$color === void 0 ? "currentColor" : _ref1452$color,
      _ref1452$size = _ref1452.size,
      e = _ref1452$size === void 0 ? 24 : _ref1452$size,
      l = _ref1452.className,
      i = _objectWithoutProperties(_ref1452, _excluded1452);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.0006 15C16.0802 15 19.4466 18.0537 19.9387 22H4.0625C4.55458 18.0537 7.92098 15 12.0006 15ZM10.1875 17.2795C8.75387 17.734 7.54637 18.7133 6.80201 20L12.0006 20L10.1875 17.2795ZM13.8141 17.2797L12.0006 20L17.1992 20C16.4549 18.7135 15.2476 17.7342 13.8141 17.2797ZM18.0006 2V8C18.0006 11.3137 15.3143 14 12.0006 14C8.6869 14 6.00061 11.3137 6.00061 8V2H18.0006ZM8.00061 8C8.00061 10.2091 9.79147 12 12.0006 12C14.2098 12 16.0006 10.2091 16.0006 8H8.00061ZM16.0006 4H8.00061L8.0005 6H16.0005L16.0006 4Z"
  }));
},
    tV = function tV(_ref1453) {
  var _ref1453$color = _ref1453.color,
      C = _ref1453$color === void 0 ? "currentColor" : _ref1453$color,
      _ref1453$size = _ref1453.size,
      e = _ref1453$size === void 0 ? 24 : _ref1453$size,
      l = _ref1453.className,
      i = _objectWithoutProperties(_ref1453, _excluded1453);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8 5H19C19.5523 5 20 5.44772 20 6V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V11L8 5ZM13 1H18C18.5523 1 19 1.44772 19 2V4H12V2C12 1.44772 12.4477 1 13 1ZM6 12V19H8V12H6Z"
  }));
},
    CV = function CV(_ref1454) {
  var _ref1454$color = _ref1454.color,
      C = _ref1454$color === void 0 ? "currentColor" : _ref1454$color,
      _ref1454$size = _ref1454.size,
      e = _ref1454$size === void 0 ? 24 : _ref1454$size,
      l = _ref1454.className,
      i = _objectWithoutProperties(_ref1454, _excluded1454);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9.07037 7L6 11.6056V20H18V7H9.07037ZM8 5H19C19.5523 5 20 5.44772 20 6V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V11L8 5ZM13 1H18C18.5523 1 19 1.44772 19 2V4H12V2C12 1.44772 12.4477 1 13 1ZM8 12H10V18H8V12Z"
  }));
},
    lV = function lV(_ref1455) {
  var _ref1455$color = _ref1455.color,
      C = _ref1455$color === void 0 ? "currentColor" : _ref1455$color,
      _ref1455$size = _ref1455.size,
      e = _ref1455$size === void 0 ? 24 : _ref1455$size,
      l = _ref1455.className,
      i = _objectWithoutProperties(_ref1455, _excluded1455);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14 20V17.8432C15.8631 16.6512 17.5 13.9677 17.5 10.8844C17.5 7.8107 15.5 4.85516 12 4.85516C8.5 4.85516 6.5 7.8107 6.5 10.8844C6.5 13.9677 8.13687 16.6512 10 17.8432V20H3V18H7.7597C5.66635 16.5054 4 13.9889 4 10.8844C4 6.24653 7.5 3 12 3C16.5 3 20 6.24653 20 10.8844C20 13.9889 18.3336 16.5054 16.2403 18H21V20H14Z"
  }));
},
    iV = function iV(_ref1456) {
  var _ref1456$color = _ref1456.color,
      C = _ref1456$color === void 0 ? "currentColor" : _ref1456$color,
      _ref1456$size = _ref1456.size,
      e = _ref1456$size === void 0 ? 24 : _ref1456$size,
      l = _ref1456.className,
      i = _objectWithoutProperties(_ref1456, _excluded1456);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.0004 12C9.23902 12 7.00045 9.76142 7.00045 7C7.00045 4.23858 9.23902 2 12.0004 2C14.7619 2 17.0004 4.23858 17.0004 7C17.0004 9.76142 14.7619 12 12.0004 12ZM18.0004 17V22H16.0004V17C16.0004 12.5487 18.6444 8.71498 22.4475 6.98352L23.2753 8.8047C20.1637 10.2213 18.0004 13.3581 18.0004 17ZM8.00045 17V22H6.00045V17C6.00045 13.3581 3.83723 10.2213 0.725586 8.8047L1.55339 6.98352C5.35651 8.71498 8.00045 12.5487 8.00045 17Z"
  }));
},
    sV = function sV(_ref1457) {
  var _ref1457$color = _ref1457.color,
      C = _ref1457$color === void 0 ? "currentColor" : _ref1457$color,
      _ref1457$size = _ref1457.size,
      e = _ref1457$size === void 0 ? 24 : _ref1457$size,
      l = _ref1457.className,
      i = _objectWithoutProperties(_ref1457, _excluded1457);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18.0004 17V22H16.0004V17C16.0004 12.5487 18.6444 8.71498 22.4475 6.98352L23.2753 8.8047C20.1637 10.2213 18.0004 13.3581 18.0004 17ZM8.00045 17V22H6.00045V17C6.00045 13.3581 3.83723 10.2213 0.725586 8.8047L1.55339 6.98352C5.35651 8.71498 8.00045 12.5487 8.00045 17ZM12.0004 12C9.23902 12 7.00045 9.76142 7.00045 7C7.00045 4.23858 9.23902 2 12.0004 2C14.7619 2 17.0004 4.23858 17.0004 7C17.0004 9.76142 14.7619 12 12.0004 12ZM12.0004 10C13.6573 10 15.0004 8.65685 15.0004 7C15.0004 5.34315 13.6573 4 12.0004 4C10.3436 4 9.00045 5.34315 9.00045 7C9.00045 8.65685 10.3436 10 12.0004 10Z"
  }));
},
    rV = function rV(_ref1458) {
  var _ref1458$color = _ref1458.color,
      C = _ref1458$color === void 0 ? "currentColor" : _ref1458$color,
      _ref1458$size = _ref1458.size,
      e = _ref1458$size === void 0 ? 24 : _ref1458$size,
      l = _ref1458.className,
      i = _objectWithoutProperties(_ref1458, _excluded1458);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.001 2C17.5238 2 22.001 6.47715 22.001 12C22.001 16.1302 19.497 19.6757 15.9243 21.201L13.4058 14.6514C14.3548 14.1476 15.001 13.1493 15.001 12C15.001 10.3431 13.6578 9 12.001 9C10.3441 9 9.00098 10.3431 9.00098 12C9.00098 13.1497 9.64766 14.1483 10.5971 14.6519L8.07863 21.2014C4.5054 19.6763 2.00098 16.1306 2.00098 12C2.00098 6.47715 6.47813 2 12.001 2Z"
  }));
},
    cV = function cV(_ref1459) {
  var _ref1459$color = _ref1459.color,
      C = _ref1459$color === void 0 ? "currentColor" : _ref1459$color,
      _ref1459$size = _ref1459.size,
      e = _ref1459$size === void 0 ? 24 : _ref1459$size,
      l = _ref1459.className,
      i = _objectWithoutProperties(_ref1459, _excluded1459);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.001 2C17.5238 2 22.001 6.47715 22.001 12C22.001 16.3996 19.1598 20.1355 15.2122 21.4732L14.9859 21.5469L12.082 13.997C13.151 13.95 14.001 13.0544 14.001 12C14.001 10.8954 13.1055 10 12.001 10C10.8964 10 10.001 10.8954 10.001 12C10.001 13.0768 10.8519 13.9548 11.918 13.9983L9.01501 21.5466L8.78975 21.4732C4.84212 20.1355 2.00098 16.3996 2.00098 12C2.00098 6.47715 6.47813 2 12.001 2ZM12.001 4C7.5827 4 4.00098 7.58172 4.00098 12C4.00098 14.9201 5.56547 17.4747 7.90198 18.8715L9.38145 15.023C8.5358 14.2896 8.00098 13.2073 8.00098 12C8.00098 9.79086 9.79184 8 12.001 8C14.2101 8 16.001 9.79086 16.001 12C16.001 13.2075 15.466 14.29 14.62 15.0234C15.1861 16.4969 15.6797 17.7803 16.0998 18.8729C18.4362 17.4751 20.001 14.9203 20.001 12C20.001 7.58172 16.4193 4 12.001 4Z"
  }));
},
    oV = function oV(_ref1460) {
  var _ref1460$color = _ref1460.color,
      C = _ref1460$color === void 0 ? "currentColor" : _ref1460$color,
      _ref1460$size = _ref1460.size,
      e = _ref1460$size === void 0 ? 24 : _ref1460$size,
      l = _ref1460.className,
      i = _objectWithoutProperties(_ref1460, _excluded1460);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8.71014 6.365C7.60348 7.67 6.88848 9.60083 6.83848 11.765V12.235C6.88931 14.4 7.60348 16.3283 8.71014 17.6342C10.1443 19.4975 12.276 20.6792 14.6593 20.6792C16.1226 20.6792 17.4926 20.2317 18.6651 19.4533C16.9001 21.0383 14.5626 22 12.001 22C11.841 22 11.6818 21.9967 11.526 21.9883C6.22098 21.7408 2.00098 17.3633 2.00098 12C2.00098 6.47583 6.47848 2 12.001 2H12.0385C14.5843 2.01 16.9051 2.97167 18.666 4.54583C17.4926 3.77083 16.1235 3.32 14.6576 3.32C12.276 3.32 10.1435 4.50333 8.70764 6.365H8.71014ZM22.001 12C22.001 14.9633 20.7135 17.6233 18.666 19.4542C16.101 20.7042 13.711 19.83 12.9193 19.2833C15.4385 18.73 17.3418 15.6833 17.3418 12C17.3418 8.315 15.4393 5.27083 12.9193 4.71667C13.7101 4.17167 16.101 3.2975 18.666 4.54583C20.7135 6.375 22.001 9.0375 22.001 12Z"
  }));
},
    aV = function aV(_ref1461) {
  var _ref1461$color = _ref1461.color,
      C = _ref1461$color === void 0 ? "currentColor" : _ref1461$color,
      _ref1461$size = _ref1461.size,
      e = _ref1461$size === void 0 ? 24 : _ref1461$size,
      l = _ref1461.className,
      i = _objectWithoutProperties(_ref1461, _excluded1461);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14.7665 19.5091C17.8219 18.3834 20.001 15.4462 20.001 12C20.001 8.55381 17.8219 5.61656 14.7665 4.4909C16.7122 5.97596 18.001 8.93354 18.001 12C18.001 15.0665 16.7122 18.024 14.7665 19.5091ZM9.23543 4.4909C6.18001 5.61656 4.00098 8.55381 4.00098 12C4.00098 15.4462 6.18001 18.3834 9.23543 19.5091C7.28979 18.024 6.00098 15.0665 6.00098 12C6.00098 8.93354 7.28979 5.97596 9.23543 4.4909ZM12.001 22C6.47813 22 2.00098 17.5228 2.00098 12C2.00098 6.47715 6.47813 2 12.001 2C17.5238 2 22.001 6.47715 22.001 12C22.001 17.5228 17.5238 22 12.001 22ZM12.001 18.5C14.001 18.5 16.001 15.4667 16.001 12C16.001 8.53333 14.001 5.5 12.001 5.5C10.001 5.5 8.00098 8.53333 8.00098 12C8.00098 15.4667 10.001 18.5 12.001 18.5Z"
  }));
},
    nV = function nV(_ref1462) {
  var _ref1462$color = _ref1462.color,
      C = _ref1462$color === void 0 ? "currentColor" : _ref1462$color,
      _ref1462$size = _ref1462.size,
      e = _ref1462$size === void 0 ? 24 : _ref1462$size,
      l = _ref1462.className,
      i = _objectWithoutProperties(_ref1462, _excluded1462);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17 3.99998V2.0675C17 1.79136 17.2239 1.5675 17.5 1.5675C17.617 1.5675 17.7302 1.60851 17.8201 1.68339L21.9391 5.11587C22.1512 5.29266 22.1799 5.60794 22.0031 5.82008C21.9081 5.93407 21.7674 5.99998 21.619 5.99998H2V3.99998H17ZM2 18H22V20H2V18ZM2 11H22V13H2V11Z"
  }));
},
    mV = function mV(_ref1463) {
  var _ref1463$color = _ref1463.color,
      C = _ref1463$color === void 0 ? "currentColor" : _ref1463$color,
      _ref1463$size = _ref1463.size,
      e = _ref1463$size === void 0 ? 24 : _ref1463$size,
      l = _ref1463.className,
      i = _objectWithoutProperties(_ref1463, _excluded1463);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17 3.99998V2.0675C17 1.79136 17.2239 1.5675 17.5 1.5675C17.617 1.5675 17.7302 1.60851 17.8201 1.68339L21.9391 5.11587C22.1512 5.29266 22.1799 5.60794 22.0031 5.82008C21.9081 5.93407 21.7674 5.99998 21.619 5.99998H2V3.99998H17ZM2 18H22V20H2V18ZM2 11H22V13H2V11Z"
  }));
},
    wV = function wV(_ref1464) {
  var _ref1464$color = _ref1464.color,
      C = _ref1464$color === void 0 ? "currentColor" : _ref1464$color,
      _ref1464$size = _ref1464.size,
      e = _ref1464$size === void 0 ? 24 : _ref1464$size,
      l = _ref1464.className,
      i = _objectWithoutProperties(_ref1464, _excluded1464);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15 3C15.5523 3 16 3.44772 16 4V8C16 8.55228 15.5523 9 15 9H13V11H17C17.5523 11 18 11.4477 18 12V15H20C20.5523 15 21 15.4477 21 16V20C21 20.5523 20.5523 21 20 21H14C13.4477 21 13 20.5523 13 20V16C13 15.4477 13.4477 15 14 15H16V13H8V15H10C10.5523 15 11 15.4477 11 16V20C11 20.5523 10.5523 21 10 21H4C3.44772 21 3 20.5523 3 20V16C3 15.4477 3.44772 15 4 15H6V12C6 11.4477 6.44772 11 7 11H11V9H9C8.44772 9 8 8.55228 8 8V4C8 3.44772 8.44772 3 9 3H15ZM9 17H5V19H9V17ZM19 17H15V19H19V17ZM14 5H10V7H14V5Z"
  }));
},
    LV = function LV(_ref1465) {
  var _ref1465$color = _ref1465.color,
      C = _ref1465$color === void 0 ? "currentColor" : _ref1465$color,
      _ref1465$size = _ref1465.size,
      e = _ref1465$size === void 0 ? 24 : _ref1465$size,
      l = _ref1465.className,
      i = _objectWithoutProperties(_ref1465, _excluded1465);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM11 7V11H13V7H11ZM14 12V16H16V12H14ZM8 12V16H10V12H8Z"
  }));
},
    hV = function hV(_ref1466) {
  var _ref1466$color = _ref1466.color,
      C = _ref1466$color === void 0 ? "currentColor" : _ref1466$color,
      _ref1466$size = _ref1466.size,
      e = _ref1466$size === void 0 ? 24 : _ref1466$size,
      l = _ref1466.className,
      i = _objectWithoutProperties(_ref1466, _excluded1466);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM11 7H13V11H11V7ZM14 12H16V16H14V12ZM8 12H10V16H8V12Z"
  }));
},
    HV = function HV(_ref1467) {
  var _ref1467$color = _ref1467.color,
      C = _ref1467$color === void 0 ? "currentColor" : _ref1467$color,
      _ref1467$size = _ref1467.size,
      e = _ref1467$size === void 0 ? 24 : _ref1467$size,
      l = _ref1467.className,
      i = _objectWithoutProperties(_ref1467, _excluded1467);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM14 10V14H16V10H14ZM8 10V14H10V10H8Z"
  }));
},
    VV = function VV(_ref1468) {
  var _ref1468$color = _ref1468.color,
      C = _ref1468$color === void 0 ? "currentColor" : _ref1468$color,
      _ref1468$size = _ref1468.size,
      e = _ref1468$size === void 0 ? 24 : _ref1468$size,
      l = _ref1468.className,
      i = _objectWithoutProperties(_ref1468, _excluded1468);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM14 10H16V14H14V10ZM8 10H10V14H8V10Z"
  }));
},
    gV = function gV(_ref1469) {
  var _ref1469$color = _ref1469.color,
      C = _ref1469$color === void 0 ? "currentColor" : _ref1469$color,
      _ref1469$size = _ref1469.size,
      e = _ref1469$size === void 0 ? 24 : _ref1469$size,
      l = _ref1469.className,
      i = _objectWithoutProperties(_ref1469, _excluded1469);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17 21V17H7V21H5V16C5 15.4477 5.44772 15 6 15H18C18.5523 15 19 15.4477 19 16V21H17ZM7 3V7H17V3H19V8C19 8.55228 18.5523 9 18 9H6C5.44772 9 5 8.55228 5 8V3H7ZM2 9L6 12L2 15V9ZM22 9V15L18 12L22 9Z"
  }));
},
    MV = function MV(_ref1470) {
  var _ref1470$color = _ref1470.color,
      C = _ref1470$color === void 0 ? "currentColor" : _ref1470$color,
      _ref1470$size = _ref1470.size,
      e = _ref1470$size === void 0 ? 24 : _ref1470$size,
      l = _ref1470.className,
      i = _objectWithoutProperties(_ref1470, _excluded1470);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 22H4C3.44772 22 3 21.5523 3 21V8H21V21C21 21.5523 20.5523 22 20 22ZM21 6H3V3C3 2.44772 3.44772 2 4 2H20C20.5523 2 21 2.44772 21 3V6ZM7 11V15H11V11H7ZM7 17V19H17V17H7ZM13 12V14H17V12H13Z"
  }));
},
    ZV = function ZV(_ref1471) {
  var _ref1471$color = _ref1471.color,
      C = _ref1471$color === void 0 ? "currentColor" : _ref1471$color,
      _ref1471$size = _ref1471.size,
      e = _ref1471$size === void 0 ? 24 : _ref1471$size,
      l = _ref1471.className,
      i = _objectWithoutProperties(_ref1471, _excluded1471);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5 8V20H19V8H5ZM5 6H19V4H5V6ZM20 22H4C3.44772 22 3 21.5523 3 21V3C3 2.44772 3.44772 2 4 2H20C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22ZM7 10H11V14H7V10ZM7 16H17V18H7V16ZM13 11H17V13H13V11Z"
  }));
},
    xV = function xV(_ref1472) {
  var _ref1472$color = _ref1472.color,
      C = _ref1472$color === void 0 ? "currentColor" : _ref1472$color,
      _ref1472$size = _ref1472.size,
      e = _ref1472$size === void 0 ? 24 : _ref1472$size,
      l = _ref1472.className,
      i = _objectWithoutProperties(_ref1472, _excluded1472);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 2.9967H20C20.5523 2.9967 21 3.44442 21 3.9967V8.9967C21 9.54899 20.5523 9.9967 20 9.9967H4C3.44772 9.9967 3 9.54899 3 8.9967V3.9967C3 3.44442 3.44772 2.9967 4 2.9967ZM6 11.9967H12C12.5523 11.9967 13 12.4444 13 12.9967V15.9967H14V21.9967H10V15.9967H11V13.9967H5C4.44772 13.9967 4 13.549 4 12.9967V10.9967H6V11.9967ZM17.7322 13.7289L19.5 11.9612L21.2678 13.7289C22.2441 14.7052 22.2441 16.2882 21.2678 17.2645C20.2915 18.2408 18.7085 18.2408 17.7322 17.2645C16.7559 16.2882 16.7559 14.7052 17.7322 13.7289Z"
  }));
},
    vV = function vV(_ref1473) {
  var _ref1473$color = _ref1473.color,
      C = _ref1473$color === void 0 ? "currentColor" : _ref1473$color,
      _ref1473$size = _ref1473.size,
      e = _ref1473$size === void 0 ? 24 : _ref1473$size,
      l = _ref1473.className,
      i = _objectWithoutProperties(_ref1473, _excluded1473);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5 4.9967V7.9967H19V4.9967H5ZM4 2.9967H20C20.5523 2.9967 21 3.44442 21 3.9967V8.9967C21 9.54899 20.5523 9.9967 20 9.9967H4C3.44772 9.9967 3 9.54899 3 8.9967V3.9967C3 3.44442 3.44772 2.9967 4 2.9967ZM6 11.9967H12C12.5523 11.9967 13 12.4444 13 12.9967V15.9967H14V21.9967H10V15.9967H11V13.9967H5C4.44772 13.9967 4 13.549 4 12.9967V10.9967H6V11.9967ZM17.7322 13.7289L19.5 11.9612L21.2678 13.7289C22.2441 14.7052 22.2441 16.2882 21.2678 17.2645C20.2915 18.2408 18.7085 18.2408 17.7322 17.2645C16.7559 16.2882 16.7559 14.7052 17.7322 13.7289Z"
  }));
},
    dV = function dV(_ref1474) {
  var _ref1474$color = _ref1474.color,
      C = _ref1474$color === void 0 ? "currentColor" : _ref1474$color,
      _ref1474$size = _ref1474.size,
      e = _ref1474$size === void 0 ? 24 : _ref1474$size,
      l = _ref1474.className,
      i = _objectWithoutProperties(_ref1474, _excluded1474);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19.2277 18.7323L20.9955 16.9645L22.7632 18.7323C23.7395 19.7086 23.7395 21.2915 22.7632 22.2678C21.7869 23.2441 20.204 23.2441 19.2277 22.2678C18.2514 21.2915 18.2514 19.7086 19.2277 18.7323ZM8.87861 1.07971L20.1923 12.3934C20.5828 12.7839 20.5828 13.4171 20.1923 13.8076L11.707 22.2929C11.3165 22.6834 10.6833 22.6834 10.2928 22.2929L1.80754 13.8076C1.41702 13.4171 1.41702 12.7839 1.80754 12.3934L9.58572 4.61525L7.4644 2.49393L8.87861 1.07971ZM10.9999 6.02946L3.92886 13.1005H18.071L10.9999 6.02946Z"
  }));
},
    pV = function pV(_ref1475) {
  var _ref1475$color = _ref1475.color,
      C = _ref1475$color === void 0 ? "currentColor" : _ref1475$color,
      _ref1475$size = _ref1475.size,
      e = _ref1475$size === void 0 ? 24 : _ref1475$size,
      l = _ref1475.className,
      i = _objectWithoutProperties(_ref1475, _excluded1475);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19.2277 18.7323L20.9955 16.9645L22.7632 18.7323C23.7395 19.7086 23.7395 21.2915 22.7632 22.2678C21.7869 23.2441 20.204 23.2441 19.2277 22.2678C18.2514 21.2915 18.2514 19.7086 19.2277 18.7323ZM8.87861 1.07971L20.1923 12.3934C20.5828 12.7839 20.5828 13.4171 20.1923 13.8076L11.707 22.2929C11.3165 22.6834 10.6833 22.6834 10.2928 22.2929L1.80754 13.8076C1.41702 13.4171 1.41702 12.7839 1.80754 12.3934L9.58572 4.61525L7.4644 2.49393L8.87861 1.07971ZM10.9999 6.02946L3.92886 13.1005L10.9999 20.1716L18.071 13.1005L10.9999 6.02946Z"
  }));
},
    EV = function EV(_ref1476) {
  var _ref1476$color = _ref1476.color,
      C = _ref1476$color === void 0 ? "currentColor" : _ref1476$color,
      _ref1476$size = _ref1476.size,
      e = _ref1476$size === void 0 ? 24 : _ref1476$size,
      l = _ref1476.className,
      i = _objectWithoutProperties(_ref1476, _excluded1476);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C17.5222 2 22 5.97778 22 10.8889C22 13.9556 19.5111 16.4444 16.4444 16.4444H14.4778C13.5556 16.4444 12.8111 17.1889 12.8111 18.1111C12.8111 18.5333 12.9778 18.9222 13.2333 19.2111C13.5 19.5111 13.6667 19.9 13.6667 20.3333C13.6667 21.2556 12.9 22 12 22C6.47778 22 2 17.5222 2 12C2 6.47778 6.47778 2 12 2ZM7.5 12C8.32843 12 9 11.3284 9 10.5C9 9.67157 8.32843 9 7.5 9C6.67157 9 6 9.67157 6 10.5C6 11.3284 6.67157 12 7.5 12ZM16.5 12C17.3284 12 18 11.3284 18 10.5C18 9.67157 17.3284 9 16.5 9C15.6716 9 15 9.67157 15 10.5C15 11.3284 15.6716 12 16.5 12ZM12 9C12.8284 9 13.5 8.32843 13.5 7.5C13.5 6.67157 12.8284 6 12 6C11.1716 6 10.5 6.67157 10.5 7.5C10.5 8.32843 11.1716 9 12 9Z"
  }));
},
    NV = function NV(_ref1477) {
  var _ref1477$color = _ref1477.color,
      C = _ref1477$color === void 0 ? "currentColor" : _ref1477$color,
      _ref1477$size = _ref1477.size,
      e = _ref1477$size === void 0 ? 24 : _ref1477$size,
      l = _ref1477.className,
      i = _objectWithoutProperties(_ref1477, _excluded1477);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C17.5222 2 22 5.97778 22 10.8889C22 13.9556 19.5111 16.4444 16.4444 16.4444H14.4778C13.5556 16.4444 12.8111 17.1889 12.8111 18.1111C12.8111 18.5333 12.9778 18.9222 13.2333 19.2111C13.5 19.5111 13.6667 19.9 13.6667 20.3333C13.6667 21.2556 12.9 22 12 22C6.47778 22 2 17.5222 2 12C2 6.47778 6.47778 2 12 2ZM10.8111 18.1111C10.8111 16.0843 12.451 14.4444 14.4778 14.4444H16.4444C18.4065 14.4444 20 12.851 20 10.8889C20 7.1392 16.4677 4 12 4C7.58235 4 4 7.58235 4 12C4 16.19 7.2226 19.6285 11.324 19.9718C10.9948 19.4168 10.8111 18.7761 10.8111 18.1111ZM7.5 12C6.67157 12 6 11.3284 6 10.5C6 9.67157 6.67157 9 7.5 9C8.32843 9 9 9.67157 9 10.5C9 11.3284 8.32843 12 7.5 12ZM16.5 12C15.6716 12 15 11.3284 15 10.5C15 9.67157 15.6716 9 16.5 9C17.3284 9 18 9.67157 18 10.5C18 11.3284 17.3284 12 16.5 12ZM12 9C11.1716 9 10.5 8.32843 10.5 7.5C10.5 6.67157 11.1716 6 12 6C12.8284 6 13.5 6.67157 13.5 7.5C13.5 8.32843 12.8284 9 12 9Z"
  }));
},
    uV = function uV(_ref1478) {
  var _ref1478$color = _ref1478.color,
      C = _ref1478$color === void 0 ? "currentColor" : _ref1478$color,
      _ref1478$size = _ref1478.size,
      e = _ref1478$size === void 0 ? 24 : _ref1478$size,
      l = _ref1478.className,
      i = _objectWithoutProperties(_ref1478, _excluded1478);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4.00021 18.9223L2.65056 18.377C2.13849 18.1701 1.89109 17.5873 2.09798 17.0752L4.00021 12.3671V18.9223ZM8.85987 21H7.00021C6.44792 21 6.00021 20.5523 6.00021 20V13.9221L8.85987 21ZM6.02202 5.96771L15.2939 2.22164C15.8059 2.01475 16.3888 2.26215 16.5956 2.77422L22.2147 16.682C22.4216 17.194 22.1742 17.7769 21.6622 17.9838L12.3903 21.7298C11.8783 21.9367 11.2954 21.6893 11.0885 21.1773L5.46944 7.2695C5.26255 6.75743 5.50995 6.1746 6.02202 5.96771ZM9.00021 9.00004C9.55249 9.00004 10.0002 8.55233 10.0002 8.00004C10.0002 7.44776 9.55249 7.00004 9.00021 7.00004C8.44792 7.00004 8.00021 7.44776 8.00021 8.00004C8.00021 8.55233 8.44792 9.00004 9.00021 9.00004Z"
  }));
},
    BV = function BV(_ref1479) {
  var _ref1479$color = _ref1479.color,
      C = _ref1479$color === void 0 ? "currentColor" : _ref1479$color,
      _ref1479$size = _ref1479.size,
      e = _ref1479$size === void 0 ? 24 : _ref1479$size,
      l = _ref1479.className,
      i = _objectWithoutProperties(_ref1479, _excluded1479);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5.7646 7.99998L5.46944 7.26944C5.26255 6.75737 5.50995 6.17454 6.02202 5.96765L15.2939 2.22158C15.8059 2.01469 16.3888 2.26209 16.5956 2.77416L22.2147 16.6819C22.4216 17.194 22.1742 17.7768 21.6622 17.9837L12.3903 21.7298C11.8783 21.9367 11.2954 21.6893 11.0885 21.1772L11.0002 20.9586V21H7.00021C6.44792 21 6.00021 20.5523 6.00021 20V19.7303L2.65056 18.377C2.13849 18.1701 1.89109 17.5873 2.09798 17.0752L5.7646 7.99998ZM8.00021 19H10.2089L8.00021 13.5333V19ZM6.00021 12.7558L4.32696 16.8972L6.00021 17.6084V12.7558ZM7.69842 7.44741L12.5683 19.5008L19.9858 16.5039L15.1159 4.45055L7.69842 7.44741ZM10.6766 9.47974C10.1645 9.68663 9.5817 9.43924 9.37481 8.92717C9.16792 8.4151 9.41532 7.83227 9.92739 7.62538C10.4395 7.41849 11.0223 7.66588 11.2292 8.17795C11.4361 8.69002 11.1887 9.27286 10.6766 9.47974Z"
  }));
},
    fV = function fV(_ref1480) {
  var _ref1480$color = _ref1480.color,
      C = _ref1480$color === void 0 ? "currentColor" : _ref1480$color,
      _ref1480$size = _ref1480.size,
      e = _ref1480$size === void 0 ? 24 : _ref1480$size,
      l = _ref1480.className,
      i = _objectWithoutProperties(_ref1480, _excluded1480);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 6V21H10V16C6.68629 16 4 13.3137 4 10C4 6.68629 6.68629 4 10 4H20V6H17V21H15V6H12ZM10 6C7.79086 6 6 7.79086 6 10C6 12.2091 7.79086 14 10 14V6Z"
  }));
},
    RV = function RV(_ref1481) {
  var _ref1481$color = _ref1481.color,
      C = _ref1481$color === void 0 ? "currentColor" : _ref1481$color,
      _ref1481$size = _ref1481.size,
      e = _ref1481$size === void 0 ? 24 : _ref1481$size,
      l = _ref1481.className,
      i = _objectWithoutProperties(_ref1481, _excluded1481);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7 11C4.51472 11 2.5 8.98528 2.5 6.5C2.5 4.01472 4.51472 2 7 2C9.48528 2 11.5 4.01472 11.5 6.5C11.5 8.98528 9.48528 11 7 11ZM17.5 15C15.2909 15 13.5 13.2091 13.5 11C13.5 8.79086 15.2909 7 17.5 7C19.7091 7 21.5 8.79086 21.5 11C21.5 13.2091 19.7091 15 17.5 15ZM17.5 16C19.9853 16 22 18.0147 22 20.5V21H13V20.5C13 18.0147 15.0147 16 17.5 16ZM7 12C9.76142 12 12 14.2386 12 17V21H2V17C2 14.2386 4.23858 12 7 12Z"
  }));
},
    zV = function zV(_ref1482) {
  var _ref1482$color = _ref1482.color,
      C = _ref1482$color === void 0 ? "currentColor" : _ref1482$color,
      _ref1482$size = _ref1482.size,
      e = _ref1482$size === void 0 ? 24 : _ref1482$size,
      l = _ref1482.className,
      i = _objectWithoutProperties(_ref1482, _excluded1482);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7 9C8.38071 9 9.5 7.88071 9.5 6.5C9.5 5.11929 8.38071 4 7 4C5.61929 4 4.5 5.11929 4.5 6.5C4.5 7.88071 5.61929 9 7 9ZM7 11C4.51472 11 2.5 8.98528 2.5 6.5C2.5 4.01472 4.51472 2 7 2C9.48528 2 11.5 4.01472 11.5 6.5C11.5 8.98528 9.48528 11 7 11ZM17.5 13C18.6046 13 19.5 12.1046 19.5 11C19.5 9.89543 18.6046 9 17.5 9C16.3954 9 15.5 9.89543 15.5 11C15.5 12.1046 16.3954 13 17.5 13ZM17.5 15C15.2909 15 13.5 13.2091 13.5 11C13.5 8.79086 15.2909 7 17.5 7C19.7091 7 21.5 8.79086 21.5 11C21.5 13.2091 19.7091 15 17.5 15ZM20 21V20.5C20 19.1193 18.8807 18 17.5 18C16.1193 18 15 19.1193 15 20.5V21H13V20.5C13 18.0147 15.0147 16 17.5 16C19.9853 16 22 18.0147 22 20.5V21H20ZM10 21V17C10 15.3431 8.65685 14 7 14C5.34315 14 4 15.3431 4 17V21H2V17C2 14.2386 4.23858 12 7 12C9.76142 12 12 14.2386 12 17V21H10Z"
  }));
},
    FV = function FV(_ref1483) {
  var _ref1483$color = _ref1483.color,
      C = _ref1483$color === void 0 ? "currentColor" : _ref1483$color,
      _ref1483$size = _ref1483.size,
      e = _ref1483$size === void 0 ? 24 : _ref1483$size,
      l = _ref1483.className,
      i = _objectWithoutProperties(_ref1483, _excluded1483);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.92316 21C5.11268 18.6642 4 15.493 4 12C4 8.50702 5.11268 5.33579 6.92316 3H8.93729C7.23506 5.3884 6.2 8.54241 6.2 12C6.2 15.4576 7.23506 18.6116 8.93729 21H6.92316ZM17.0741 21H15.06C16.7622 18.6116 17.7973 15.4576 17.7973 12C17.7973 8.54241 16.7622 5.3884 15.06 3H17.0741C18.8846 5.33579 19.9973 8.50702 19.9973 12C19.9973 15.493 18.8846 18.6642 17.0741 21Z"
  }));
},
    SV = function SV(_ref1484) {
  var _ref1484$color = _ref1484.color,
      C = _ref1484$color === void 0 ? "currentColor" : _ref1484$color,
      _ref1484$size = _ref1484.size,
      e = _ref1484$size === void 0 ? 24 : _ref1484$size,
      l = _ref1484.className,
      i = _objectWithoutProperties(_ref1484, _excluded1484);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.92316 21C5.11268 18.6642 4 15.493 4 12C4 8.50702 5.11268 5.33579 6.92316 3H8.93729C7.23506 5.3884 6.2 8.54241 6.2 12C6.2 15.4576 7.23506 18.6116 8.93729 21H6.92316ZM17.0741 21H15.06C16.7622 18.6116 17.7973 15.4576 17.7973 12C17.7973 8.54241 16.7622 5.3884 15.06 3H17.0741C18.8846 5.33579 19.9973 8.50702 19.9973 12C19.9973 15.493 18.8846 18.6642 17.0741 21Z"
  }));
},
    AV = function AV(_ref1485) {
  var _ref1485$color = _ref1485.color,
      C = _ref1485$color === void 0 ? "currentColor" : _ref1485$color,
      _ref1485$size = _ref1485.size,
      e = _ref1485$size === void 0 ? 24 : _ref1485$size,
      l = _ref1485.className,
      i = _objectWithoutProperties(_ref1485, _excluded1485);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11 14H12.5C14.433 14 16 12.433 16 10.5C16 8.567 14.433 7 12.5 7H9V17H11V14ZM4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM11 9H12.5C13.3284 9 14 9.67157 14 10.5C14 11.3284 13.3284 12 12.5 12H11V9Z"
  }));
},
    kV = function kV(_ref1486) {
  var _ref1486$color = _ref1486.color,
      C = _ref1486$color === void 0 ? "currentColor" : _ref1486$color,
      _ref1486$size = _ref1486.size,
      e = _ref1486$size === void 0 ? 24 : _ref1486$size,
      l = _ref1486.className,
      i = _objectWithoutProperties(_ref1486, _excluded1486);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM5 5V19H19V5H5ZM9 7H12.5C14.433 7 16 8.567 16 10.5C16 12.433 14.433 14 12.5 14H11V17H9V7ZM11 9V12H12.5C13.3284 12 14 11.3284 14 10.5C14 9.67157 13.3284 9 12.5 9H11Z"
  }));
},
    PV = function PV(_ref1487) {
  var _ref1487$color = _ref1487.color,
      C = _ref1487$color === void 0 ? "currentColor" : _ref1487$color,
      _ref1487$size = _ref1487.size,
      e = _ref1487$size === void 0 ? 24 : _ref1487$size,
      l = _ref1487.className,
      i = _objectWithoutProperties(_ref1487, _excluded1487);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6 3H13C16.3137 3 19 5.68629 19 9C19 12.3137 16.3137 15 13 15H10V21H6V3ZM10 7V11H13C14.1046 11 15 10.1046 15 9C15 7.89543 14.1046 7 13 7H10Z"
  }));
},
    DV = function DV(_ref1488) {
  var _ref1488$color = _ref1488.color,
      C = _ref1488$color === void 0 ? "currentColor" : _ref1488$color,
      _ref1488$size = _ref1488.size,
      e = _ref1488$size === void 0 ? 24 : _ref1488$size,
      l = _ref1488.className,
      i = _objectWithoutProperties(_ref1488, _excluded1488);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6 3H13C16.3137 3 19 5.68629 19 9C19 12.3137 16.3137 15 13 15H8V21H6V3ZM8 5V13H13C15.2091 13 17 11.2091 17 9C17 6.79086 15.2091 5 13 5H8Z"
  }));
},
    yV = function yV(_ref1489) {
  var _ref1489$color = _ref1489.color,
      C = _ref1489$color === void 0 ? "currentColor" : _ref1489$color,
      _ref1489$size = _ref1489.size,
      e = _ref1489$size === void 0 ? 24 : _ref1489$size,
      l = _ref1489.className,
      i = _objectWithoutProperties(_ref1489, _excluded1489);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 2C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V3C3 2.44772 3.44772 2 4 2H20ZM16 16H8V18H16V16ZM12 6C9.79086 6 8 7.79086 8 10C8 12.2091 9.79086 14 12 14C14.2091 14 16 12.2091 16 10C16 7.79086 14.2091 6 12 6ZM12 8C13.1046 8 14 8.89543 14 10C14 11.1046 13.1046 12 12 12C10.8954 12 10 11.1046 10 10C10 8.89543 10.8954 8 12 8Z"
  }));
},
    bV = function bV(_ref1490) {
  var _ref1490$color = _ref1490.color,
      C = _ref1490$color === void 0 ? "currentColor" : _ref1490$color,
      _ref1490$size = _ref1490.size,
      e = _ref1490$size === void 0 ? 24 : _ref1490$size,
      l = _ref1490.className,
      i = _objectWithoutProperties(_ref1490, _excluded1490);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 2C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V3C3 2.44772 3.44772 2 4 2H20ZM19 4H5V20H19V4ZM16 16V18H8V16H16ZM12 6C14.2091 6 16 7.79086 16 10C16 12.2091 14.2091 14 12 14C9.79086 14 8 12.2091 8 10C8 7.79086 9.79086 6 12 6ZM12 8C10.8954 8 10 8.89543 10 10C10 11.1046 10.8954 12 12 12C13.1046 12 14 11.1046 14 10C14 8.89543 13.1046 8 12 8Z"
  }));
},
    TV = function TV(_ref1491) {
  var _ref1491$color = _ref1491.color,
      C = _ref1491$color === void 0 ? "currentColor" : _ref1491$color,
      _ref1491$size = _ref1491.size,
      e = _ref1491$size === void 0 ? 24 : _ref1491$size,
      l = _ref1491.className,
      i = _objectWithoutProperties(_ref1491, _excluded1491);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15.001 17C10.8588 17 7.50098 13.6421 7.50098 9.5C7.50098 5.35786 10.8588 2 15.001 2C19.1431 2 22.501 5.35786 22.501 9.5C22.501 13.6421 19.1431 17 15.001 17ZM2.00098 2H6.00098V22H2.00098V2Z"
  }));
},
    UV = function UV(_ref1492) {
  var _ref1492$color = _ref1492.color,
      C = _ref1492$color === void 0 ? "currentColor" : _ref1492$color,
      _ref1492$size = _ref1492.size,
      e = _ref1492$size === void 0 ? 24 : _ref1492$size,
      l = _ref1492.className,
      i = _objectWithoutProperties(_ref1492, _excluded1492);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15.001 17C10.8588 17 7.50098 13.6421 7.50098 9.5C7.50098 5.35786 10.8588 2 15.001 2C19.1431 2 22.501 5.35786 22.501 9.5C22.501 13.6421 19.1431 17 15.001 17ZM15.001 15C18.0385 15 20.501 12.5376 20.501 9.5C20.501 6.46243 18.0385 4 15.001 4C11.9634 4 9.50098 6.46243 9.50098 9.5C9.50098 12.5376 11.9634 15 15.001 15ZM2.00098 2H7.00098V22H2.00098V2ZM4.00098 4V20H5.00098V4H4.00098Z"
  }));
},
    GV = function GV(_ref1493) {
  var _ref1493$color = _ref1493.color,
      C = _ref1493$color === void 0 ? "currentColor" : _ref1493$color,
      _ref1493$size = _ref1493.size,
      e = _ref1493$size === void 0 ? 24 : _ref1493$size,
      l = _ref1493.className,
      i = _objectWithoutProperties(_ref1493, _excluded1493);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM9 9V15H11V9H9ZM13 9V15H15V9H13Z"
  }));
},
    IV = function IV(_ref1494) {
  var _ref1494$color = _ref1494.color,
      C = _ref1494$color === void 0 ? "currentColor" : _ref1494$color,
      _ref1494$size = _ref1494.size,
      e = _ref1494$size === void 0 ? 24 : _ref1494$size,
      l = _ref1494.className,
      i = _objectWithoutProperties(_ref1494, _excluded1494);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM9 9H11V15H9V9ZM13 9H15V15H13V9Z"
  }));
},
    WV = function WV(_ref1495) {
  var _ref1495$color = _ref1495.color,
      C = _ref1495$color === void 0 ? "currentColor" : _ref1495$color,
      _ref1495$size = _ref1495.size,
      e = _ref1495$size === void 0 ? 24 : _ref1495$size,
      l = _ref1495.className,
      i = _objectWithoutProperties(_ref1495, _excluded1495);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6 5H8V19H6V5ZM16 5H18V19H16V5Z"
  }));
},
    OV = function OV(_ref1496) {
  var _ref1496$color = _ref1496.color,
      C = _ref1496$color === void 0 ? "currentColor" : _ref1496$color,
      _ref1496$size = _ref1496.size,
      e = _ref1496$size === void 0 ? 24 : _ref1496$size,
      l = _ref1496.className,
      i = _objectWithoutProperties(_ref1496, _excluded1496);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6 5H8V19H6V5ZM16 5H18V19H16V5Z"
  }));
},
    KV = function KV(_ref1497) {
  var _ref1497$color = _ref1497.color,
      C = _ref1497$color === void 0 ? "currentColor" : _ref1497$color,
      _ref1497$size = _ref1497.size,
      e = _ref1497$size === void 0 ? 24 : _ref1497$size,
      l = _ref1497.className,
      i = _objectWithoutProperties(_ref1497, _excluded1497);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15 7C15 6.44772 15.4477 6 16 6C16.5523 6 17 6.44772 17 7V17C17 17.5523 16.5523 18 16 18C15.4477 18 15 17.5523 15 17V7ZM7 7C7 6.44772 7.44772 6 8 6C8.55228 6 9 6.44772 9 7V17C9 17.5523 8.55228 18 8 18C7.44772 18 7 17.5523 7 17V7Z"
  }));
},
    QV = function QV(_ref1498) {
  var _ref1498$color = _ref1498.color,
      C = _ref1498$color === void 0 ? "currentColor" : _ref1498$color,
      _ref1498$size = _ref1498.size,
      e = _ref1498$size === void 0 ? 24 : _ref1498$size,
      l = _ref1498.className,
      i = _objectWithoutProperties(_ref1498, _excluded1498);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15 7C15 6.44772 15.4477 6 16 6C16.5523 6 17 6.44772 17 7V17C17 17.5523 16.5523 18 16 18C15.4477 18 15 17.5523 15 17V7ZM7 7C7 6.44772 7.44772 6 8 6C8.55228 6 9 6.44772 9 7V17C9 17.5523 8.55228 18 8 18C7.44772 18 7 17.5523 7 17V7Z"
  }));
},
    qV = function qV(_ref1499) {
  var _ref1499$color = _ref1499.color,
      C = _ref1499$color === void 0 ? "currentColor" : _ref1499$color,
      _ref1499$size = _ref1499.size,
      e = _ref1499$size === void 0 ? 24 : _ref1499$size,
      l = _ref1499.className,
      i = _objectWithoutProperties(_ref1499, _excluded1499);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.0673 8.47768C20.5591 9.35823 20.6237 10.4924 20.3676 11.8053C19.627 15.6107 17.0916 16.9253 13.8536 16.9253H13.3536C12.9583 16.9253 12.6216 17.214 12.5596 17.6047L12.519 17.8253L11.8896 21.818L11.857 21.988C11.795 22.3787 11.4583 22.6667 11.063 22.6667H7.72031C7.42365 22.6667 7.19698 22.402 7.24298 22.1093L7.41807 21H8.9367L9.88603 14.9793H11.2716C15.9496 14.9793 19.0209 12.7768 20.0673 8.47768ZM17.1066 3.38784C17.8693 4.25635 18.0908 5.19891 17.8597 6.67324C17.8405 6.79594 17.82 6.91391 17.7973 7.03253C17.0621 10.8057 14.7087 12.4793 10.8417 12.4793H8.95703C8.32647 12.4793 7.78368 12.8928 7.60372 13.4811L7.58913 13.4788L6.65969 19.3733H3.12169C3.08991 19.3733 3.06598 19.3454 3.07097 19.3136L5.66905 2.80233C5.74174 2.34036 6.13984 2 6.6075 2H12.583C14.7658 2 16.2998 2.46869 17.1066 3.38784Z"
  }));
},
    jV = function jV(_ref1500) {
  var _ref1500$color = _ref1500.color,
      C = _ref1500$color === void 0 ? "currentColor" : _ref1500$color,
      _ref1500$size = _ref1500.size,
      e = _ref1500$size === void 0 ? 24 : _ref1500$size,
      l = _ref1500.className,
      i = _objectWithoutProperties(_ref1500, _excluded1500);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8.49626 20.6667H10.0474L10.5852 17.2912C10.8012 15.93 11.9747 14.9253 13.3545 14.9253H13.8545C16.5322 14.9253 17.915 13.9421 18.4055 11.4224C18.6134 10.3564 18.5222 9.69183 18.2339 9.32047C17.0272 12.3744 14.4449 13.4793 11.2725 13.4793H10.3878C10.004 13.4793 9.59454 13.6889 9.53611 14.0602L8.49626 20.6667ZM3.55247 20.3733C3.21381 20.3733 2.95514 20.0713 3.00781 19.736L5.68247 2.776C5.75314 2.32933 6.13847 2 6.59047 2H13.0138C15.2265 2 16.9558 2.46733 17.9131 3.558C18.783 4.54853 19.0364 5.64237 18.7846 7.25001C19.1438 7.44133 19.4518 7.67467 19.6998 7.956C20.5185 8.88867 20.6785 10.216 20.3685 11.8053C19.6278 15.6107 17.0925 16.9253 13.8545 16.9253H13.3545C12.9591 16.9253 12.6225 17.214 12.5605 17.6047L11.8578 21.988C11.7958 22.3787 11.4591 22.6667 11.0638 22.6667H6.72114C6.42447 22.6667 6.19781 22.402 6.24381 22.1093L6.51781 20.3733H3.55247ZM10.3878 11.4793H11.2725C14.462 11.4793 16.1671 10.2667 16.7549 7.2501C16.7744 7.14856 16.7919 7.04727 16.8086 6.94101C16.9746 5.88187 16.8586 5.38808 16.4104 4.87773C15.9451 4.34763 14.8073 4 13.0138 4H7.51416L5.24742 18.3733H6.80845L7.53821 13.7452L7.54562 13.7463C7.84632 12.4296 9.0169 11.4793 10.3878 11.4793Z"
  }));
},
    XV = function XV(_ref1501) {
  var _ref1501$color = _ref1501.color,
      C = _ref1501$color === void 0 ? "currentColor" : _ref1501$color,
      _ref1501$size = _ref1501.size,
      e = _ref1501$size === void 0 ? 24 : _ref1501$size,
      l = _ref1501.className,
      i = _objectWithoutProperties(_ref1501, _excluded1501);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4.92898 21.4819L10.775 15.6359C11.4423 15.8141 12.1837 15.6414 12.7071 15.118C13.4882 14.3369 13.4882 13.0706 12.7071 12.2896C11.9261 11.5085 10.6598 11.5085 9.87872 12.2896C9.35526 12.813 9.18263 13.5544 9.36081 14.2217L3.51476 20.0677L2.4541 19.0071C5.28253 15.7072 6.34319 12.0539 7.7574 5.9256L14.1214 5.21849L19.7783 10.8754L19.0711 17.2393C12.9429 18.6535 9.28947 19.7142 5.98964 22.5426L4.92898 21.4819ZM16.5962 2.03651L22.9428 8.38312C23.1381 8.57838 23.1381 8.89496 22.9428 9.09022C22.8679 9.16513 22.7712 9.21431 22.6665 9.23067L21.1924 9.46113L15.5356 3.80428L15.7477 2.31935C15.7868 2.04599 16.04 1.85604 16.3134 1.89509C16.4205 1.91039 16.5197 1.96001 16.5962 2.03651Z"
  }));
},
    JV = function JV(_ref1502) {
  var _ref1502$color = _ref1502.color,
      C = _ref1502$color === void 0 ? "currentColor" : _ref1502$color,
      _ref1502$size = _ref1502.size,
      e = _ref1502$size === void 0 ? 24 : _ref1502$size,
      l = _ref1502.className,
      i = _objectWithoutProperties(_ref1502, _excluded1502);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16.5962 1.03651L22.9428 7.38312C23.1381 7.57838 23.1381 7.89496 22.9428 8.09022C22.8679 8.16513 22.7712 8.21431 22.6665 8.23067L21.1924 8.46113L15.5356 2.80428L15.7477 1.31935C15.7868 1.04599 16.04 0.856036 16.3134 0.895088C16.4205 0.910388 16.5197 0.960011 16.5962 1.03651ZM4.59487 20.1478C8.31725 16.8163 12.5899 15.82 17.2379 14.6273L17.6843 10.6099L13.3869 6.31241L9.36936 6.7588C8.17674 11.4068 7.18038 15.6795 3.84886 19.4018L2.4541 18.0071C5.28253 14.7072 6.34319 11.0539 7.7574 4.9256L14.1214 4.21849L19.7783 9.87539L19.0711 16.2393C12.9429 17.6535 9.28947 18.7142 5.98964 21.5426L4.59487 20.1478ZM9.87872 14.118C9.09767 13.3369 9.09767 12.0706 9.87872 11.2896C10.6598 10.5085 11.9261 10.5085 12.7071 11.2896C13.4882 12.0706 13.4882 13.3369 12.7071 14.118C11.9261 14.899 10.6598 14.899 9.87872 14.118Z"
  }));
},
    YV = function YV(_ref1503) {
  var _ref1503$color = _ref1503.color,
      C = _ref1503$color === void 0 ? "currentColor" : _ref1503$color,
      _ref1503$size = _ref1503.size,
      e = _ref1503$size === void 0 ? 24 : _ref1503$size,
      l = _ref1503.className,
      i = _objectWithoutProperties(_ref1503, _excluded1503);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.8995 6.85453L17.1421 11.0972L7.24264 20.9967H3V16.754L12.8995 6.85453ZM14.3137 5.44032L16.435 3.319C16.8256 2.92848 17.4587 2.92848 17.8492 3.319L20.6777 6.14743C21.0682 6.53795 21.0682 7.17112 20.6777 7.56164L18.5563 9.68296L14.3137 5.44032Z"
  }));
},
    _V = function _V(_ref1504) {
  var _ref1504$color = _ref1504.color,
      C = _ref1504$color === void 0 ? "currentColor" : _ref1504$color,
      _ref1504$size = _ref1504.size,
      e = _ref1504$size === void 0 ? 24 : _ref1504$size,
      l = _ref1504.className,
      i = _objectWithoutProperties(_ref1504, _excluded1504);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15.7279 9.57627L14.3137 8.16206L5 17.4758V18.89H6.41421L15.7279 9.57627ZM17.1421 8.16206L18.5563 6.74785L17.1421 5.33363L15.7279 6.74785L17.1421 8.16206ZM7.24264 20.89H3V16.6473L16.435 3.21231C16.8256 2.82179 17.4587 2.82179 17.8492 3.21231L20.6777 6.04074C21.0682 6.43126 21.0682 7.06443 20.6777 7.45495L7.24264 20.89Z"
  }));
},
    $V = function $V(_ref1505) {
  var _ref1505$color = _ref1505.color,
      C = _ref1505$color === void 0 ? "currentColor" : _ref1505$color,
      _ref1505$size = _ref1505.size,
      e = _ref1505$size === void 0 ? 24 : _ref1505$size,
      l = _ref1505.className,
      i = _objectWithoutProperties(_ref1505, _excluded1505);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5.63611 12.7071L7.46454 14.5355L8.87875 13.1213L7.05033 11.2929L8.46454 9.87869L10.293 11.7071L11.7072 10.2929L9.87875 8.46448L11.293 7.05026L13.1214 8.87869L14.5356 7.46448L12.7072 5.63605L15.5356 2.80762C15.9261 2.4171 16.5593 2.4171 16.9498 2.80762L21.1925 7.05026C21.583 7.44079 21.583 8.07395 21.1925 8.46448L8.46454 21.1924C8.07401 21.5829 7.44085 21.5829 7.05033 21.1924L2.80768 16.9498C2.41716 16.5592 2.41716 15.9261 2.80768 15.5355L5.63611 12.7071ZM14.1214 18.3635L18.364 14.1208L20.9997 16.7565V20.9999H16.7578L14.1214 18.3635ZM5.63597 9.87806L2.80754 7.04963C2.41702 6.65911 2.41702 6.02594 2.80754 5.63542L5.63597 2.80699C6.02649 2.41647 6.65966 2.41647 7.05018 2.80699L9.87861 5.63542L5.63597 9.87806Z"
  }));
},
    eg = function eg(_ref1506) {
  var _ref1506$color = _ref1506.color,
      C = _ref1506$color === void 0 ? "currentColor" : _ref1506$color,
      _ref1506$size = _ref1506.size,
      e = _ref1506$size === void 0 ? 24 : _ref1506$size,
      l = _ref1506.className,
      i = _objectWithoutProperties(_ref1506, _excluded1506);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7.05033 14.1213L4.929 16.2427L7.75743 19.0711L19.0711 7.75737L16.2427 4.92894L14.1214 7.05026L15.5356 8.46448L14.1214 9.87869L12.7072 8.46448L11.293 9.87869L12.7072 11.2929L11.293 12.7071L9.87875 11.2929L8.46454 12.7071L9.87875 14.1213L8.46454 15.5355L7.05033 14.1213ZM16.9498 2.80762L21.1925 7.05026C21.583 7.44079 21.583 8.07395 21.1925 8.46448L8.46454 21.1924C8.07401 21.5829 7.44085 21.5829 7.05033 21.1924L2.80768 16.9498C2.41716 16.5592 2.41716 15.9261 2.80768 15.5355L15.5356 2.80762C15.9261 2.4171 16.5593 2.4171 16.9498 2.80762ZM14.1214 18.3635L15.5356 16.9493L17.7781 19.1918H19.1923V17.7776L16.9498 15.5351L18.364 14.1208L20.9997 16.7565V20.9999H16.7578L14.1214 18.3635ZM5.63597 9.87806L2.80754 7.04963C2.41702 6.65911 2.41702 6.02594 2.80754 5.63542L5.63597 2.80699C6.02649 2.41647 6.65966 2.41647 7.05018 2.80699L9.87861 5.63542L8.4644 7.04963L6.34308 4.92831L4.92886 6.34253L7.05018 8.46385L5.63597 9.87806Z"
  }));
},
    tg = function tg(_ref1507) {
  var _ref1507$color = _ref1507.color,
      C = _ref1507$color === void 0 ? "currentColor" : _ref1507$color,
      _ref1507$size = _ref1507.size,
      e = _ref1507$size === void 0 ? 24 : _ref1507$size,
      l = _ref1507.className,
      i = _objectWithoutProperties(_ref1507, _excluded1507);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5 18V20H9V18H5ZM3 7L7 2L11 7V22H3V7ZM21 8H19V10H21V12H18V14H21V16H19V18H21V21C21 21.5523 20.5523 22 20 22H14C13.4477 22 13 21.5523 13 21V5C13 4.44772 13.4477 4 14 4H20C20.5523 4 21 4.44772 21 5V8Z"
  }));
},
    Cg = function Cg(_ref1508) {
  var _ref1508$color = _ref1508.color,
      C = _ref1508$color === void 0 ? "currentColor" : _ref1508$color,
      _ref1508$size = _ref1508.size,
      e = _ref1508$size === void 0 ? 24 : _ref1508$size,
      l = _ref1508.className,
      i = _objectWithoutProperties(_ref1508, _excluded1508);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5 8V20H9V8H5ZM3 7L7 2L11 7V22H3V7ZM19 16V14H16V12H19V10H17V8H19V6H15V20H19V18H17V16H19ZM14 4H20C20.5523 4 21 4.44772 21 5V21C21 21.5523 20.5523 22 20 22H14C13.4477 22 13 21.5523 13 21V5C13 4.44772 13.4477 4 14 4Z"
  }));
},
    lg = function lg(_ref1509) {
  var _ref1509$color = _ref1509.color,
      C = _ref1509$color === void 0 ? "currentColor" : _ref1509$color,
      _ref1509$size = _ref1509.size,
      e = _ref1509$size === void 0 ? 24 : _ref1509$size,
      l = _ref1509.className,
      i = _objectWithoutProperties(_ref1509, _excluded1509);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17.5049 21.0027C15.5719 21.0027 14.0049 19.4357 14.0049 17.5027C14.0049 15.5697 15.5719 14.0027 17.5049 14.0027C19.4379 14.0027 21.0049 15.5697 21.0049 17.5027C21.0049 19.4357 19.4379 21.0027 17.5049 21.0027ZM6.50488 10.0027C4.57189 10.0027 3.00488 8.43574 3.00488 6.50275C3.00488 4.56975 4.57189 3.00275 6.50488 3.00275C8.43788 3.00275 10.0049 4.56975 10.0049 6.50275C10.0049 8.43574 8.43788 10.0027 6.50488 10.0027ZM19.076 3.51747L20.4902 4.93168L4.93382 20.488L3.5196 19.0738L19.076 3.51747Z"
  }));
},
    ig = function ig(_ref1510) {
  var _ref1510$color = _ref1510.color,
      C = _ref1510$color === void 0 ? "currentColor" : _ref1510$color,
      _ref1510$size = _ref1510.size,
      e = _ref1510$size === void 0 ? 24 : _ref1510$size,
      l = _ref1510.className,
      i = _objectWithoutProperties(_ref1510, _excluded1510);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17.5049 21.0027C15.5719 21.0027 14.0049 19.4357 14.0049 17.5027C14.0049 15.5697 15.5719 14.0027 17.5049 14.0027C19.4379 14.0027 21.0049 15.5697 21.0049 17.5027C21.0049 19.4357 19.4379 21.0027 17.5049 21.0027ZM17.5049 19.0027C18.3333 19.0027 19.0049 18.3312 19.0049 17.5027C19.0049 16.6743 18.3333 16.0027 17.5049 16.0027C16.6765 16.0027 16.0049 16.6743 16.0049 17.5027C16.0049 18.3312 16.6765 19.0027 17.5049 19.0027ZM6.50488 10.0027C4.57189 10.0027 3.00488 8.43574 3.00488 6.50275C3.00488 4.56975 4.57189 3.00275 6.50488 3.00275C8.43788 3.00275 10.0049 4.56975 10.0049 6.50275C10.0049 8.43574 8.43788 10.0027 6.50488 10.0027ZM6.50488 8.00275C7.33331 8.00275 8.00488 7.33117 8.00488 6.50275C8.00488 5.67432 7.33331 5.00275 6.50488 5.00275C5.67646 5.00275 5.00488 5.67432 5.00488 6.50275C5.00488 7.33117 5.67646 8.00275 6.50488 8.00275ZM19.076 3.51747L20.4902 4.93168L4.93382 20.488L3.5196 19.0738L19.076 3.51747Z"
  }));
},
    sg = function sg(_ref1511) {
  var _ref1511$color = _ref1511.color,
      C = _ref1511$color === void 0 ? "currentColor" : _ref1511$color,
      _ref1511$size = _ref1511.size,
      e = _ref1511$size === void 0 ? 24 : _ref1511$size,
      l = _ref1511.className,
      i = _objectWithoutProperties(_ref1511, _excluded1511);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14.8027 4C14.2922 4.88252 14 5.90714 14 7C14 10.3137 16.6863 13 20 13C21.0929 13 22.1175 12.7078 23 12.1973V18.9991C23 19.5519 22.5605 20 21.9975 20H2.00246C1.44882 20 1 19.5554 1 18.9991V5.00087C1 4.44811 1.43946 4 2.00246 4H14.8027ZM20 11C17.7909 11 16 9.20914 16 7C16 4.79086 17.7909 3 20 3C22.2091 3 24 4.79086 24 7C24 9.20914 22.2091 11 20 11ZM20 9C21.1046 9 22 8.10457 22 7C22 5.89543 21.1046 5 20 5C18.8954 5 18 5.89543 18 7C18 8.10457 18.8954 9 20 9ZM19 15V18H21V15H19Z"
  }));
},
    rg = function rg(_ref1512) {
  var _ref1512$color = _ref1512.color,
      C = _ref1512$color === void 0 ? "currentColor" : _ref1512$color,
      _ref1512$size = _ref1512.size,
      e = _ref1512$size === void 0 ? 24 : _ref1512$size,
      l = _ref1512.className,
      i = _objectWithoutProperties(_ref1512, _excluded1512);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14.8027 4C14.4513 4.60738 14.2034 5.28208 14.083 6H3V18H21V12.917C21.7179 12.7966 22.3926 12.5487 23 12.1973V18.9991C23 19.5519 22.5605 20 21.9975 20H2.00246C1.44882 20 1 19.5554 1 18.9991V5.00087C1 4.44811 1.43946 4 2.00246 4H14.8027ZM20 9C21.1046 9 22 8.10457 22 7C22 5.89543 21.1046 5 20 5C18.8954 5 18 5.89543 18 7C18 8.10457 18.8954 9 20 9ZM20 11C17.7909 11 16 9.20914 16 7C16 4.79086 17.7909 3 20 3C22.2091 3 24 4.79086 24 7C24 9.20914 22.2091 11 20 11ZM18 13H20V16H18V13Z"
  }));
},
    cg = function cg(_ref1513) {
  var _ref1513$color = _ref1513.color,
      C = _ref1513$color === void 0 ? "currentColor" : _ref1513$color,
      _ref1513$size = _ref1513.size,
      e = _ref1513$size === void 0 ? 24 : _ref1513$size,
      l = _ref1513.className,
      i = _objectWithoutProperties(_ref1513, _excluded1513);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 16.42V19.9561C21 20.4811 20.5941 20.9167 20.0705 20.9537C19.6331 20.9846 19.2763 21 19 21C10.1634 21 3 13.8366 3 5C3 4.72371 3.01545 4.36687 3.04635 3.9295C3.08337 3.40588 3.51894 3 4.04386 3H7.5801C7.83678 3 8.05176 3.19442 8.07753 3.4498C8.10067 3.67907 8.12218 3.86314 8.14207 4.00202C8.34435 5.41472 8.75753 6.75936 9.3487 8.00303C9.44359 8.20265 9.38171 8.44159 9.20185 8.57006L7.04355 10.1118C8.35752 13.1811 10.8189 15.6425 13.8882 16.9565L15.4271 14.8019C15.5572 14.6199 15.799 14.5573 16.001 14.6532C17.2446 15.2439 18.5891 15.6566 20.0016 15.8584C20.1396 15.8782 20.3225 15.8995 20.5502 15.9225C20.8056 15.9483 21 16.1633 21 16.42Z"
  }));
},
    og = function og(_ref1514) {
  var _ref1514$color = _ref1514.color,
      C = _ref1514$color === void 0 ? "currentColor" : _ref1514$color,
      _ref1514$size = _ref1514.size,
      e = _ref1514$size === void 0 ? 24 : _ref1514$size,
      l = _ref1514.className,
      i = _objectWithoutProperties(_ref1514, _excluded1514);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18 2C18.5523 2 19 2.44772 19 3L19.0009 11.5286C17.9393 10.578 16.5371 10 15 10C11.6863 10 9 12.6863 9 16C9 19.2384 11.76 22 15 22H6C5.44772 22 5 21.5523 5 21V3C5 2.44772 5.44772 2 6 2H18ZM15 12C17.2091 12 19 13.7909 19 16C19 16.7418 18.7981 17.4365 18.4462 18.032L20.6569 20.2426L19.2426 21.6569L17.032 19.4462C16.4365 19.7981 15.7418 20 15 20C12.7909 20 11 18.2091 11 16C11 13.7909 12.7909 12 15 12ZM15 14C13.8954 14 13 14.8954 13 16C13 17.1046 13.8954 18 15 18C16.1046 18 17 17.1046 17 16C17 14.8954 16.1046 14 15 14Z"
  }));
},
    ag = function ag(_ref1515) {
  var _ref1515$color = _ref1515.color,
      C = _ref1515$color === void 0 ? "currentColor" : _ref1515$color,
      _ref1515$size = _ref1515.size,
      e = _ref1515$size === void 0 ? 24 : _ref1515$size,
      l = _ref1515.className,
      i = _objectWithoutProperties(_ref1515, _excluded1515);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18 2C18.5523 2 19 2.44772 19 3V11H17V4H7V20H11V22H6C5.44772 22 5 21.5523 5 21V3C5 2.44772 5.44772 2 6 2H18ZM15 12C17.2091 12 19 13.7909 19 16C19 16.7419 18.798 17.4366 18.446 18.0322L20.6569 20.2426L19.2426 21.6569L17.0313 19.4466C16.4359 19.7982 15.7415 20 15 20C12.7909 20 11 18.2091 11 16C11 13.7909 12.7909 12 15 12ZM15 14C13.8954 14 13 14.8954 13 16C13 17.1046 13.8954 18 15 18C16.1046 18 17 17.1046 17 16C17 14.8954 16.1046 14 15 14Z"
  }));
},
    ng = function ng(_ref1516) {
  var _ref1516$color = _ref1516.color,
      C = _ref1516$color === void 0 ? "currentColor" : _ref1516$color,
      _ref1516$size = _ref1516.size,
      e = _ref1516$size === void 0 ? 24 : _ref1516$size,
      l = _ref1516.className,
      i = _objectWithoutProperties(_ref1516, _excluded1516);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9.36556 10.6821C10.302 12.3288 11.6712 13.698 13.3179 14.6344L14.2024 13.3961C14.4965 12.9845 15.0516 12.8573 15.4956 13.0998C16.9024 13.8683 18.4571 14.3353 20.0789 14.4637C20.599 14.5049 21 14.9389 21 15.4606V19.9234C21 20.4361 20.6122 20.8657 20.1022 20.9181C19.5723 20.9726 19.0377 21 18.5 21C9.93959 21 3 14.0604 3 5.5C3 4.96227 3.02742 4.42771 3.08189 3.89776C3.1343 3.38775 3.56394 3 4.07665 3H8.53942C9.0611 3 9.49513 3.40104 9.5363 3.92109C9.66467 5.54288 10.1317 7.09764 10.9002 8.50444C11.1427 8.9484 11.0155 9.50354 10.6039 9.79757L9.36556 10.6821ZM6.84425 10.0252L8.7442 8.66809C8.20547 7.50514 7.83628 6.27183 7.64727 5H5.00907C5.00303 5.16632 5 5.333 5 5.5C5 12.9558 11.0442 19 18.5 19C18.667 19 18.8337 18.997 19 18.9909V16.3527C17.7282 16.1637 16.4949 15.7945 15.3319 15.2558L13.9748 17.1558C13.4258 16.9425 12.8956 16.6915 12.3874 16.4061L12.3293 16.373C10.3697 15.2587 8.74134 13.6303 7.627 11.6707L7.59394 11.6126C7.30849 11.1044 7.05754 10.5742 6.84425 10.0252Z"
  }));
},
    mg = function mg(_ref1517) {
  var _ref1517$color = _ref1517.color,
      C = _ref1517$color === void 0 ? "currentColor" : _ref1517$color,
      _ref1517$size = _ref1517.size,
      e = _ref1517$size === void 0 ? 24 : _ref1517$size,
      l = _ref1517.className,
      i = _objectWithoutProperties(_ref1517, _excluded1517);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18 2C18.5523 2 19 2.44772 19 3L19.0012 10.1003C18.6777 10.0345 18.3429 10 18 10C15.5811 10 13.5634 11.7177 13.1001 13.9998L12 14V22H6C5.44772 22 5 21.5523 5 21V3C5 2.44772 5.44772 2 6 2H18ZM18 12C19.6569 12 21 13.3431 21 15V16H22V21C22 21.5523 21.5523 22 21 22H15C14.4477 22 14 21.5523 14 21V16H15V15C15 13.3431 16.3431 12 18 12ZM18 14C17.4872 14 17 14.45 17 15V16H19V15C19 14.4477 18.5523 14 18 14Z"
  }));
},
    wg = function wg(_ref1518) {
  var _ref1518$color = _ref1518.color,
      C = _ref1518$color === void 0 ? "currentColor" : _ref1518$color,
      _ref1518$size = _ref1518.size,
      e = _ref1518$size === void 0 ? 24 : _ref1518$size,
      l = _ref1518.className,
      i = _objectWithoutProperties(_ref1518, _excluded1518);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18 2C18.5523 2 19 2.44772 19 3V10H17V4H7V20H12V22H6C5.44772 22 5 21.5523 5 21V3C5 2.44772 5.44772 2 6 2H18ZM18 12C19.6569 12 21 13.3431 21 15V16H22V21C22 21.5523 21.5523 22 21 22H15C14.4477 22 14 21.5523 14 21V16H15V15C15 13.3431 16.3431 12 18 12ZM20 18H16V20H20V18ZM18 14C17.4919 14 17 14.45 17 15V16H19V15C19 14.4477 18.5523 14 18 14Z"
  }));
},
    Lg = function Lg(_ref1519) {
  var _ref1519$color = _ref1519.color,
      C = _ref1519$color === void 0 ? "currentColor" : _ref1519$color,
      _ref1519$size = _ref1519.size,
      e = _ref1519$size === void 0 ? 24 : _ref1519$size,
      l = _ref1519.className,
      i = _objectWithoutProperties(_ref1519, _excluded1519);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 3C21.5523 3 22 3.44772 22 4V11H20V5H4V19H10V21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21ZM21 13C21.5523 13 22 13.4477 22 14V20C22 20.5523 21.5523 21 21 21H13C12.4477 21 12 20.5523 12 20V14C12 13.4477 12.4477 13 13 13H21ZM6.70711 6.29289L8.95689 8.54289L11 6.5V12H5.5L7.54289 9.95689L5.29289 7.70711L6.70711 6.29289Z"
  }));
},
    hg = function hg(_ref1520) {
  var _ref1520$color = _ref1520.color,
      C = _ref1520$color === void 0 ? "currentColor" : _ref1520$color,
      _ref1520$size = _ref1520.size,
      e = _ref1520$size === void 0 ? 24 : _ref1520$size,
      l = _ref1520.className,
      i = _objectWithoutProperties(_ref1520, _excluded1520);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 3C21.5523 3 22 3.44772 22 4V11H20V5H4V19H10V21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21ZM21 13C21.5523 13 22 13.4477 22 14V20C22 20.5523 21.5523 21 21 21H13C12.4477 21 12 20.5523 12 20V14C12 13.4477 12.4477 13 13 13H21ZM20 15H14V19H20V15ZM6.70711 6.29289L8.95689 8.54289L11 6.5V12H5.5L7.54289 9.95689L5.29289 7.70711L6.70711 6.29289Z"
  }));
},
    Hg = function Hg(_ref1521) {
  var _ref1521$color = _ref1521.color,
      C = _ref1521$color === void 0 ? "currentColor" : _ref1521$color,
      _ref1521$size = _ref1521.size,
      e = _ref1521$size === void 0 ? 24 : _ref1521$size,
      l = _ref1521.className,
      i = _objectWithoutProperties(_ref1521, _excluded1521);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 3C21.5523 3 22 3.44772 22 4V11H20V5H4V19H10V21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21ZM21 13C21.5523 13 22 13.4477 22 14V20C22 20.5523 21.5523 21 21 21H13C12.4477 21 12 20.5523 12 20V14C12 13.4477 12.4477 13 13 13H21ZM11.5 7L9.45711 9.04311L11.7071 11.2929L10.2929 12.7071L8.04311 10.4571L6 12.5V7H11.5Z"
  }));
},
    Vg = function Vg(_ref1522) {
  var _ref1522$color = _ref1522.color,
      C = _ref1522$color === void 0 ? "currentColor" : _ref1522$color,
      _ref1522$size = _ref1522.size,
      e = _ref1522$size === void 0 ? 24 : _ref1522$size,
      l = _ref1522.className,
      i = _objectWithoutProperties(_ref1522, _excluded1522);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 3C21.5523 3 22 3.44772 22 4V11H20V5H4V19H10V21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21ZM21 13C21.5523 13 22 13.4477 22 14V20C22 20.5523 21.5523 21 21 21H13C12.4477 21 12 20.5523 12 20V14C12 13.4477 12.4477 13 13 13H21ZM20 15H14V19H20V15ZM11.5 7L9.45711 9.04311L11.7071 11.2929L10.2929 12.7071L8.04311 10.4571L6 12.5V7H11.5Z"
  }));
},
    gg = function gg(_ref1523) {
  var _ref1523$color = _ref1523.color,
      C = _ref1523$color === void 0 ? "currentColor" : _ref1523$color,
      _ref1523$size = _ref1523.size,
      e = _ref1523$size === void 0 ? 24 : _ref1523$size,
      l = _ref1523.className,
      i = _objectWithoutProperties(_ref1523, _excluded1523);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 3C21.5523 3 22 3.44772 22 4V11H20V5H4V19H10V21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21ZM21 13C21.5523 13 22 13.4477 22 14V20C22 20.5523 21.5523 21 21 21H13C12.4477 21 12 20.5523 12 20V14C12 13.4477 12.4477 13 13 13H21Z"
  }));
},
    Mg = function Mg(_ref1524) {
  var _ref1524$color = _ref1524.color,
      C = _ref1524$color === void 0 ? "currentColor" : _ref1524$color,
      _ref1524$size = _ref1524.size,
      e = _ref1524$size === void 0 ? 24 : _ref1524$size,
      l = _ref1524.className,
      i = _objectWithoutProperties(_ref1524, _excluded1524);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 3C21.5523 3 22 3.44772 22 4V11H20V5H4V19H10V21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21ZM21 13C21.5523 13 22 13.4477 22 14V20C22 20.5523 21.5523 21 21 21H13C12.4477 21 12 20.5523 12 20V14C12 13.4477 12.4477 13 13 13H21ZM20 15H14V19H20V15Z"
  }));
},
    Zg = function Zg(_ref1525) {
  var _ref1525$color = _ref1525.color,
      C = _ref1525$color === void 0 ? "currentColor" : _ref1525$color,
      _ref1525$size = _ref1525.size,
      e = _ref1525$size === void 0 ? 24 : _ref1525$size,
      l = _ref1525.className,
      i = _objectWithoutProperties(_ref1525, _excluded1525);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11 2.04935V13H21.9506C21.4489 18.0533 17.1853 22 12 22C6.47715 22 2 17.5228 2 12C2 6.81462 5.94668 2.55107 11 2.04935ZM13 0.542847C18.5535 1.02121 22.9788 5.4465 23.4571 11H13V0.542847Z"
  }));
},
    xg = function xg(_ref1526) {
  var _ref1526$color = _ref1526.color,
      C = _ref1526$color === void 0 ? "currentColor" : _ref1526$color,
      _ref1526$size = _ref1526.size,
      e = _ref1526$size === void 0 ? 24 : _ref1526$size,
      l = _ref1526.className,
      i = _objectWithoutProperties(_ref1526, _excluded1526);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 0.5C18.3513 0.5 23.5 5.64873 23.5 12C23.5 12.3369 23.4855 12.6704 23.4571 13H21.9506C21.4489 18.0533 17.1853 22 12 22C6.47715 22 2 17.5228 2 12C2 6.81465 5.94668 2.5511 11 2.04938V0.542876C11.3296 0.514488 11.6631 0.5 12 0.5ZM11 4.06189C7.05369 4.55399 4 7.92038 4 12C4 16.4183 7.58172 20 12 20C16.0796 20 19.446 16.9463 19.9381 13H11V4.06189ZM13 2.552V11H21.448C20.9827 6.55197 17.448 3.01732 13 2.552Z"
  }));
},
    vg = function vg(_ref1527) {
  var _ref1527$color = _ref1527.color,
      C = _ref1527$color === void 0 ? "currentColor" : _ref1527$color,
      _ref1527$size = _ref1527.size,
      e = _ref1527$size === void 0 ? 24 : _ref1527$size,
      l = _ref1527.className,
      i = _objectWithoutProperties(_ref1527, _excluded1527);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM16.9 13H11V7.10002C8.71776 7.56329 7 9.58104 7 12C7 14.7614 9.23858 17 12 17C14.419 17 16.4367 15.2822 16.9 13ZM16.9 11C16.5023 9.04087 14.9591 7.4977 13 7.10002V11H16.9Z"
  }));
},
    dg = function dg(_ref1528) {
  var _ref1528$color = _ref1528.color,
      C = _ref1528$color === void 0 ? "currentColor" : _ref1528$color,
      _ref1528$size = _ref1528.size,
      e = _ref1528$size === void 0 ? 24 : _ref1528$size,
      l = _ref1528.className,
      i = _objectWithoutProperties(_ref1528, _excluded1528);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM4 5V19H20V5H4ZM16.9 13C16.4367 15.2822 14.419 17 12 17C9.23858 17 7 14.7614 7 12C7 9.58104 8.71776 7.56329 11 7.10002V13H16.9ZM16.9 11H13V7.10002C14.9591 7.4977 16.5023 9.04087 16.9 11Z"
  }));
},
    pg = function pg(_ref1529) {
  var _ref1529$color = _ref1529.color,
      C = _ref1529$color === void 0 ? "currentColor" : _ref1529$color,
      _ref1529$size = _ref1529.size,
      e = _ref1529$size === void 0 ? 24 : _ref1529$size,
      l = _ref1529.className,
      i = _objectWithoutProperties(_ref1529, _excluded1529);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11 2.04938V13H21.9506C21.4489 18.0533 17.1853 22 12 22C6.47715 22 2 17.5229 2 12C2 6.81465 5.94668 2.5511 11 2.04938ZM13 2.04938C17.7244 2.51845 21.4816 6.27559 21.9506 11H13V2.04938Z"
  }));
},
    Eg = function Eg(_ref1530) {
  var _ref1530$color = _ref1530.color,
      C = _ref1530$color === void 0 ? "currentColor" : _ref1530$color,
      _ref1530$size = _ref1530.size,
      e = _ref1530$size === void 0 ? 24 : _ref1530$size,
      l = _ref1530.className,
      i = _objectWithoutProperties(_ref1530, _excluded1530);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9 2.4578V4.58152C6.06817 5.76829 4 8.64262 4 12C4 16.4183 7.58172 20 12 20C15.3574 20 18.2317 17.9318 19.4185 15H21.5422C20.2679 19.0571 16.4776 22 12 22C6.47715 22 2 17.5228 2 12C2 7.52236 4.94289 3.73207 9 2.4578ZM12 2C17.5228 2 22 6.47715 22 12C22 12.3375 21.9833 12.6711 21.9506 13H11V2.04938C11.3289 2.01672 11.6625 2 12 2ZM13 4.06189V11H19.9381C19.4869 7.38128 16.6187 4.51314 13 4.06189Z"
  }));
},
    Ng = function Ng(_ref1531) {
  var _ref1531$color = _ref1531.color,
      C = _ref1531$color === void 0 ? "currentColor" : _ref1531$color,
      _ref1531$size = _ref1531.size,
      e = _ref1531$size === void 0 ? 24 : _ref1531$size,
      l = _ref1531.className,
      i = _objectWithoutProperties(_ref1531, _excluded1531);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11.3891 10.3891L7.5 14.2782L3.61091 10.3891C1.46303 8.2412 1.46303 4.7588 3.61091 2.61091C5.7588 0.463029 9.2412 0.463029 11.3891 2.61091C13.537 4.7588 13.537 8.2412 11.3891 10.3891ZM7.5 8.5C8.60457 8.5 9.5 7.60457 9.5 6.5C9.5 5.39543 8.60457 4.5 7.5 4.5C6.39543 4.5 5.5 5.39543 5.5 6.5C5.5 7.60457 6.39543 8.5 7.5 8.5ZM20.3891 19.3891L16.5 23.2782L12.6109 19.3891C10.463 17.2412 10.463 13.7588 12.6109 11.6109C14.7588 9.46303 18.2412 9.46303 20.3891 11.6109C22.537 13.7588 22.537 17.2412 20.3891 19.3891ZM16.5 17.5C17.6046 17.5 18.5 16.6046 18.5 15.5C18.5 14.3954 17.6046 13.5 16.5 13.5C15.3954 13.5 14.5 14.3954 14.5 15.5C14.5 16.6046 15.3954 17.5 16.5 17.5Z"
  }));
},
    ug = function ug(_ref1532) {
  var _ref1532$color = _ref1532.color,
      C = _ref1532$color === void 0 ? "currentColor" : _ref1532$color,
      _ref1532$size = _ref1532.size,
      e = _ref1532$size === void 0 ? 24 : _ref1532$size,
      l = _ref1532.className,
      i = _objectWithoutProperties(_ref1532, _excluded1532);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9.97487 8.97487C11.3417 7.60804 11.3417 5.39196 9.97487 4.02513C8.60804 2.65829 6.39196 2.65829 5.02513 4.02513C3.65829 5.39196 3.65829 7.60804 5.02513 8.97487L7.5 11.4497L9.97487 8.97487ZM7.5 14.2782L3.61091 10.3891C1.46303 8.2412 1.46303 4.7588 3.61091 2.61091C5.7588 0.463029 9.2412 0.463029 11.3891 2.61091C13.537 4.7588 13.537 8.2412 11.3891 10.3891L7.5 14.2782ZM7.5 8C6.67157 8 6 7.32843 6 6.5C6 5.67157 6.67157 5 7.5 5C8.32843 5 9 5.67157 9 6.5C9 7.32843 8.32843 8 7.5 8ZM16.5 20.4497L18.9749 17.9749C20.3417 16.608 20.3417 14.392 18.9749 13.0251C17.608 11.6583 15.392 11.6583 14.0251 13.0251C12.6583 14.392 12.6583 16.608 14.0251 17.9749L16.5 20.4497ZM20.3891 19.3891L16.5 23.2782L12.6109 19.3891C10.463 17.2412 10.463 13.7588 12.6109 11.6109C14.7588 9.46303 18.2412 9.46303 20.3891 11.6109C22.537 13.7588 22.537 17.2412 20.3891 19.3891ZM16.5 17C15.6716 17 15 16.3284 15 15.5C15 14.6716 15.6716 14 16.5 14C17.3284 14 18 14.6716 18 15.5C18 16.3284 17.3284 17 16.5 17Z"
  }));
},
    Bg = function Bg(_ref1533) {
  var _ref1533$color = _ref1533.color,
      C = _ref1533$color === void 0 ? "currentColor" : _ref1533$color,
      _ref1533$size = _ref1533.size,
      e = _ref1533$size === void 0 ? 24 : _ref1533$size,
      l = _ref1533.className,
      i = _objectWithoutProperties(_ref1533, _excluded1533);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11.5 2C16.7467 2 21 6.25329 21 11.5C21 13.0291 20.6387 14.4739 19.9969 15.7536L22.4602 18.2175C22.8507 18.608 22.8507 19.2412 22.4602 19.6317L19.6317 22.4602C19.2412 22.8507 18.608 22.8507 18.2175 22.4602L15.7536 19.9969C14.4739 20.6387 13.0291 21 11.5 21C6.25329 21 2 16.7467 2 11.5C2 6.25329 6.25329 2 11.5 2ZM16.8033 15.3877L15.3891 16.8019L18.9246 20.3375L20.3388 18.9233L16.8033 15.3877ZM18.6669 9.28305L9.28305 18.6669C9.98371 18.8834 10.7282 19 11.5 19C12.4671 19 13.3914 18.817 14.2403 18.4836L13.2678 17.5104C12.8772 17.1199 12.8772 16.4867 13.2678 16.0962L16.0962 13.2678C16.4867 12.8772 17.1199 12.8772 17.5104 13.2678L18.4836 14.2403C18.817 13.3914 19 12.4671 19 11.5C19 10.7282 18.8834 9.98371 18.6669 9.28305Z"
  }));
},
    fg = function fg(_ref1534) {
  var _ref1534$color = _ref1534.color,
      C = _ref1534$color === void 0 ? "currentColor" : _ref1534$color,
      _ref1534$size = _ref1534.size,
      e = _ref1534$size === void 0 ? 24 : _ref1534$size,
      l = _ref1534.className,
      i = _objectWithoutProperties(_ref1534, _excluded1534);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11.5 2C16.7467 2 21 6.25329 21 11.5C21 13.0291 20.6387 14.4739 19.9969 15.7536L22.4602 18.2175C22.8507 18.608 22.8507 19.2412 22.4602 19.6317L19.6317 22.4602C19.2412 22.8507 18.608 22.8507 18.2175 22.4602L15.7536 19.9969C14.4739 20.6387 13.0291 21 11.5 21C6.25329 21 2 16.7467 2 11.5C2 6.25329 6.25329 2 11.5 2ZM16.8033 15.3877L15.3891 16.8019L18.9246 20.3375L20.3388 18.9233L16.8033 15.3877ZM18.6669 9.28305L9.28305 18.6669C9.98371 18.8834 10.7282 19 11.5 19C12.4671 19 13.3914 18.817 14.2403 18.4836L13.2678 17.5104C12.8772 17.1199 12.8772 16.4867 13.2678 16.0962L16.0962 13.2678C16.4867 12.8772 17.1199 12.8772 17.5104 13.2678L18.4836 14.2403C18.817 13.3914 19 12.4671 19 11.5C19 10.7282 18.8834 9.98371 18.6669 9.28305ZM11.5 4C7.35786 4 4 7.35786 4 11.5C4 14.1135 5.3368 16.4148 7.36394 17.7574L17.7574 7.36394C16.4148 5.3368 14.1135 4 11.5 4Z"
  }));
},
    Rg = function Rg(_ref1535) {
  var _ref1535$color = _ref1535.color,
      C = _ref1535$color === void 0 ? "currentColor" : _ref1535$color,
      _ref1535$size = _ref1535.size,
      e = _ref1535$size === void 0 ? 24 : _ref1535$size,
      l = _ref1535.className,
      i = _objectWithoutProperties(_ref1535, _excluded1535);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13.3717 2.09442C8.42512 1.41268 3.73383 4.48505 2.38064 9.29256C1.02745 14.1001 3.42711 19.1692 8.00271 21.1689C7.94264 20.4008 7.99735 19.628 8.16502 18.8761C8.34964 18.0374 9.46121 13.4132 9.46121 13.4132C9.23971 12.9173 9.12893 12.379 9.13659 11.8359C9.13659 10.3509 9.99353 9.24295 11.0597 9.24295C11.4472 9.23718 11.8181 9.40028 12.0758 9.68981C12.3335 9.97934 12.4526 10.3667 12.402 10.751C12.402 11.6512 11.8236 13.0131 11.5228 14.2903C11.4014 14.7656 11.5131 15.2703 11.8237 15.65C12.1343 16.0296 12.6069 16.2389 13.0967 16.2139C14.9944 16.2139 16.2675 13.7825 16.2675 10.9126C16.2675 8.71205 14.8098 7.0655 12.1243 7.0655C10.826 7.01531 9.56388 7.4996 8.63223 8.40543C7.70057 9.31126 7.18084 10.5595 7.19423 11.859C7.16563 12.5722 7.39566 13.2717 7.84194 13.8287C8.01361 13.9564 8.07985 14.1825 8.00425 14.3827C7.9581 14.5673 7.84194 15.0059 7.79578 15.1675C7.77632 15.278 7.70559 15.3728 7.60516 15.4228C7.50473 15.4729 7.38651 15.4724 7.28654 15.4214C5.9019 14.8674 5.24957 13.3439 5.24957 11.6051C5.24957 8.75822 7.63424 5.3497 12.4036 5.3497C16.1998 5.3497 18.723 8.1273 18.723 11.0972C18.723 15.0059 16.5468 17.9451 13.3298 17.9451C12.3526 17.9761 11.4273 17.5061 10.8759 16.6986C10.8759 16.6986 10.2974 19.0146 10.1835 19.4531C9.95101 20.2099 9.60779 20.9281 9.16505 21.5844C10.0877 21.8643 11.0471 22.0044 12.0113 22C14.6636 22.0017 17.2078 20.9484 19.0829 19.072C20.958 17.1957 22.0099 14.6504 22.0069 11.9975C22.004 7.00306 18.3183 2.77616 13.3717 2.09442Z"
  }));
},
    zg = function zg(_ref1536) {
  var _ref1536$color = _ref1536.color,
      C = _ref1536$color === void 0 ? "currentColor" : _ref1536$color,
      _ref1536$size = _ref1536.size,
      e = _ref1536$size === void 0 ? 24 : _ref1536$size,
      l = _ref1536.className,
      i = _objectWithoutProperties(_ref1536, _excluded1536);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8.49161 19.1912C8.51535 18.8546 8.56306 18.5199 8.63456 18.1897C8.69754 17.8951 8.88867 17.0596 9.16872 15.8498L9.17581 15.8191C9.29895 15.2872 9.43089 14.7192 9.56283 14.1525C9.64199 13.8124 9.70356 13.5484 9.74438 13.4602C9.55012 13.0123 9.45298 12.5263 9.45969 12.0373C9.45969 10.6999 10.2157 9.66359 11.1958 9.6636C11.5555 9.65809 11.8996 9.81388 12.1383 10.09C12.3764 10.3655 12.4863 10.7335 12.4404 11.086C12.4404 11.5385 12.3548 11.8844 11.9865 13.1212C11.9158 13.3587 11.8674 13.5254 11.8215 13.692C11.7696 13.8799 11.7261 14.0503 11.6887 14.2136C11.5928 14.6003 11.6811 15.011 11.9262 15.3195C12.1707 15.6272 12.5421 15.7966 12.9319 15.7762C14.4242 15.7762 15.5321 13.7911 15.5321 11.2277C15.5321 9.25804 14.2412 7.95424 12.1 7.95416C11.0224 7.91127 9.97466 8.32523 9.20095 9.09986C8.42664 9.87508 7.99452 10.9437 8.00559 12.0614C7.98214 12.6633 8.17064 13.2536 8.51804 13.7053C8.69915 13.8441 8.76869 14.0885 8.69262 14.2941C8.65157 14.4632 8.55259 14.8473 8.51649 14.9755C8.49464 15.1032 8.41497 15.2131 8.30126 15.2715C8.18678 15.3303 8.05172 15.3297 7.94618 15.2737C6.78507 14.7954 6.14967 13.4963 6.14967 11.8349C6.14967 8.84907 8.64129 6.2497 12.3417 6.2497C15.4772 6.2497 17.8231 8.57864 17.8231 11.3896C17.8231 14.922 15.8911 17.4942 13.1337 17.4942C12.3393 17.5202 11.5838 17.162 11.087 16.535L11.044 16.712C10.9499 17.0992 10.9028 17.2928 10.8368 17.5638L10.8349 17.5715C10.6887 18.1717 10.5867 18.5885 10.5471 18.7452C10.4412 19.0998 10.307 19.448 10.1471 19.7841C10.7421 19.9253 11.3628 20 12.001 20C16.4193 20 20.001 16.4183 20.001 12C20.001 7.58172 16.4193 4 12.001 4C7.5827 4 4.00098 7.58172 4.00098 12C4.00098 15.1594 5.83244 17.8911 8.49161 19.1912ZM12.001 22C6.47813 22 2.00098 17.5228 2.00098 12C2.00098 6.47715 6.47813 2 12.001 2C17.5238 2 22.001 6.47715 22.001 12C22.001 17.5228 17.5238 22 12.001 22Z"
  }));
},
    Fg = function Fg(_ref1537) {
  var _ref1537$color = _ref1537.color,
      C = _ref1537$color === void 0 ? "currentColor" : _ref1537$color,
      _ref1537$size = _ref1537.size,
      e = _ref1537$size === void 0 ? 24 : _ref1537$size,
      l = _ref1537.className,
      i = _objectWithoutProperties(_ref1537, _excluded1537);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17.934 3.0359L19.666 4.0359L18.531 6H21V8H19V12H21V14H19V21H17V14L13.9157 14.0004C13.5914 16.8623 12.3522 19.3936 10.5466 21.1933L8.98361 19.9233C10.5031 18.4847 11.5801 16.4008 11.9008 14.0009L10 14V12L12 11.999V8H10V6H12.467L11.334 4.0359L13.066 3.0359L14.777 6H16.221L17.934 3.0359ZM5 13.803L3 14.339V12.268L5 11.732V8H3V6H5V3H7V6H9V8H7V11.197L9 10.661V12.731L7 13.267V18.5C7 19.8807 5.88071 21 4.5 21H3V19H4.5C4.74546 19 4.94961 18.8231 4.99194 18.5899L5 18.5V13.803ZM17 8H14V12H17V8Z"
  }));
},
    Sg = function Sg(_ref1538) {
  var _ref1538$color = _ref1538.color,
      C = _ref1538$color === void 0 ? "currentColor" : _ref1538$color,
      _ref1538$size = _ref1538.size,
      e = _ref1538$size === void 0 ? 24 : _ref1538$size,
      l = _ref1538.className,
      i = _objectWithoutProperties(_ref1538, _excluded1538);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.001 2C17.5238 2 22.001 6.47715 22.001 12C22.001 17.5228 17.5238 22 12.001 22C6.47813 22 2.00098 17.5228 2.00098 12C2.00098 6.47715 6.47813 2 12.001 2ZM13.0322 8.09865H10.4084C9.42035 8.09865 8.61941 8.87488 8.61941 9.83241V16.5804L11.2143 14.109H13.0322C14.7448 14.109 16.1331 12.7635 16.1331 11.1038C16.1331 9.44411 14.7448 8.09865 13.0322 8.09865Z"
  }));
},
    Ag = function Ag(_ref1539) {
  var _ref1539$color = _ref1539.color,
      C = _ref1539$color === void 0 ? "currentColor" : _ref1539$color,
      _ref1539$size = _ref1539.size,
      e = _ref1539$size === void 0 ? 24 : _ref1539$size,
      l = _ref1539.className,
      i = _objectWithoutProperties(_ref1539, _excluded1539);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.001 2C17.5238 2 22.001 6.47715 22.001 12C22.001 17.5228 17.5238 22 12.001 22C6.47813 22 2.00098 17.5228 2.00098 12C2.00098 6.47715 6.47813 2 12.001 2ZM12.001 4C7.5827 4 4.00098 7.58172 4.00098 12C4.00098 16.4183 7.5827 20 12.001 20C16.4193 20 20.001 16.4183 20.001 12C20.001 7.58172 16.4193 4 12.001 4ZM13.0322 8.09865C14.7448 8.09865 16.1331 9.44411 16.1331 11.1038C16.1331 12.7635 14.7448 14.109 13.0322 14.109H11.2143L8.61941 16.5804V9.83241C8.61941 8.87488 9.42035 8.09865 10.4084 8.09865H13.0322Z"
  }));
},
    kg = function kg(_ref1540) {
  var _ref1540$color = _ref1540.color,
      C = _ref1540$color === void 0 ? "currentColor" : _ref1540$color,
      _ref1540$size = _ref1540.size,
      e = _ref1540$size === void 0 ? 24 : _ref1540$size,
      l = _ref1540.className,
      i = _objectWithoutProperties(_ref1540, _excluded1540);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14 8.94737L22 14V16L14 13.4737V18.8333L17 20.5V22L12.5 21L8 22V20.5L11 18.8333V13.4737L3 16V14L11 8.94737V3.5C11 2.67157 11.6716 2 12.5 2C13.3284 2 14 2.67157 14 3.5V8.94737Z"
  }));
},
    Pg = function Pg(_ref1541) {
  var _ref1541$color = _ref1541.color,
      C = _ref1541$color === void 0 ? "currentColor" : _ref1541$color,
      _ref1541$size = _ref1541.size,
      e = _ref1541$size === void 0 ? 24 : _ref1541$size,
      l = _ref1541.className,
      i = _objectWithoutProperties(_ref1541, _excluded1541);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14 8.94737L22 14V16L14 13.4737V18.8333L17 20.5V22L12.5 21L8 22V20.5L11 18.8333V13.4737L3 16V14L11 8.94737V3.5C11 2.67157 11.6716 2 12.5 2C13.3284 2 14 2.67157 14 3.5V8.94737Z"
  }));
},
    Dg = function Dg(_ref1542) {
  var _ref1542$color = _ref1542.color,
      C = _ref1542$color === void 0 ? "currentColor" : _ref1542$color,
      _ref1542$size = _ref1542.size,
      e = _ref1542$size === void 0 ? 24 : _ref1542$size,
      l = _ref1542.className,
      i = _objectWithoutProperties(_ref1542, _excluded1542);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.998 3V5C20.998 8.86599 17.864 12 13.998 12H12.998V13H17.998V20C17.998 21.1046 17.1026 22 15.998 22H7.99805C6.89348 22 5.99805 21.1046 5.99805 20V13H10.998V10C10.998 6.13401 14.1321 3 17.998 3H20.998ZM5.49805 2C8.02667 2 10.263 3.25136 11.6216 5.1686C10.6026 6.51084 9.99805 8.18482 9.99805 10V11H9.49805C5.35591 11 1.99805 7.64214 1.99805 3.5V2H5.49805Z"
  }));
},
    yg = function yg(_ref1543) {
  var _ref1543$color = _ref1543.color,
      C = _ref1543$color === void 0 ? "currentColor" : _ref1543$color,
      _ref1543$size = _ref1543.size,
      e = _ref1543$size === void 0 ? 24 : _ref1543$size,
      l = _ref1543.className,
      i = _objectWithoutProperties(_ref1543, _excluded1543);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5.99805 2C8.68733 2 11.0224 3.51653 12.1947 5.74104C13.372 4.08252 15.3086 3 17.498 3H20.998V5.5C20.998 9.08985 18.0879 12 14.498 12H12.998V13H17.998V20C17.998 21.1046 17.1026 22 15.998 22H7.99805C6.89348 22 5.99805 21.1046 5.99805 20V13H10.998V11H8.99805C5.13205 11 1.99805 7.86599 1.99805 4V2H5.99805ZM15.998 15H7.99805V20H15.998V15ZM18.998 5H17.498C15.0128 5 12.998 7.01472 12.998 9.5V10H14.498C16.9833 10 18.998 7.98528 18.998 5.5V5ZM5.99805 4H3.99805C3.99805 6.76142 6.23662 9 8.99805 9H10.998C10.998 6.23858 8.75947 4 5.99805 4Z"
  }));
},
    bg = function bg(_ref1544) {
  var _ref1544$color = _ref1544.color,
      C = _ref1544$color === void 0 ? "currentColor" : _ref1544$color,
      _ref1544$size = _ref1544.size,
      e = _ref1544$size === void 0 ? 24 : _ref1544$size,
      l = _ref1544.className,
      i = _objectWithoutProperties(_ref1544, _excluded1544);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM10.6219 8.41459C10.5562 8.37078 10.479 8.34741 10.4 8.34741C10.1791 8.34741 10 8.52649 10 8.74741V15.2526C10 15.3316 10.0234 15.4088 10.0672 15.4745C10.1897 15.6583 10.4381 15.708 10.6219 15.5854L15.5008 12.3328C15.5447 12.3035 15.5824 12.2658 15.6117 12.2219C15.7343 12.0381 15.6846 11.7897 15.5008 11.6672L10.6219 8.41459Z"
  }));
},
    Tg = function Tg(_ref1545) {
  var _ref1545$color = _ref1545.color,
      C = _ref1545$color === void 0 ? "currentColor" : _ref1545$color,
      _ref1545$size = _ref1545.size,
      e = _ref1545$size === void 0 ? 24 : _ref1545$size,
      l = _ref1545.className,
      i = _objectWithoutProperties(_ref1545, _excluded1545);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM10.6219 8.41459L15.5008 11.6672C15.6846 11.7897 15.7343 12.0381 15.6117 12.2219C15.5824 12.2658 15.5447 12.3035 15.5008 12.3328L10.6219 15.5854C10.4381 15.708 10.1897 15.6583 10.0672 15.4745C10.0234 15.4088 10 15.3316 10 15.2526V8.74741C10 8.52649 10.1791 8.34741 10.4 8.34741C10.479 8.34741 10.5562 8.37078 10.6219 8.41459Z"
  }));
},
    Ug = function Ug(_ref1546) {
  var _ref1546$color = _ref1546.color,
      C = _ref1546$color === void 0 ? "currentColor" : _ref1546$color,
      _ref1546$size = _ref1546.size,
      e = _ref1546$size === void 0 ? 24 : _ref1546$size,
      l = _ref1546.className,
      i = _objectWithoutProperties(_ref1546, _excluded1546);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19.376 12.4161L8.77735 19.4818C8.54759 19.635 8.23715 19.5729 8.08397 19.3432C8.02922 19.261 8 19.1645 8 19.0658V4.93433C8 4.65818 8.22386 4.43433 8.5 4.43433C8.59871 4.43433 8.69522 4.46355 8.77735 4.5183L19.376 11.584C19.6057 11.7372 19.6678 12.0477 19.5146 12.2774C19.478 12.3323 19.4309 12.3795 19.376 12.4161Z"
  }));
},
    Gg = function Gg(_ref1547) {
  var _ref1547$color = _ref1547.color,
      C = _ref1547$color === void 0 ? "currentColor" : _ref1547$color,
      _ref1547$size = _ref1547.size,
      e = _ref1547$size === void 0 ? 24 : _ref1547$size,
      l = _ref1547.className,
      i = _objectWithoutProperties(_ref1547, _excluded1547);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16.3944 12.0001L10 7.7371V16.263L16.3944 12.0001ZM19.376 12.4161L8.77735 19.4818C8.54759 19.635 8.23715 19.5729 8.08397 19.3432C8.02922 19.261 8 19.1645 8 19.0658V4.93433C8 4.65818 8.22386 4.43433 8.5 4.43433C8.59871 4.43433 8.69522 4.46355 8.77735 4.5183L19.376 11.584C19.6057 11.7372 19.6678 12.0477 19.5146 12.2774C19.478 12.3323 19.4309 12.3795 19.376 12.4161Z"
  }));
},
    Ig = function Ig(_ref1548) {
  var _ref1548$color = _ref1548.color,
      C = _ref1548$color === void 0 ? "currentColor" : _ref1548$color,
      _ref1548$size = _ref1548.size,
      e = _ref1548$size === void 0 ? 24 : _ref1548$size,
      l = _ref1548.className,
      i = _objectWithoutProperties(_ref1548, _excluded1548);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22 18V20H2V18H22ZM2 3.5L10 8.5L2 13.5V3.5ZM22 11V13H12V11H22ZM22 4V6H12V4H22Z"
  }));
},
    Wg = function Wg(_ref1549) {
  var _ref1549$color = _ref1549.color,
      C = _ref1549$color === void 0 ? "currentColor" : _ref1549$color,
      _ref1549$size = _ref1549.size,
      e = _ref1549$size === void 0 ? 24 : _ref1549$size,
      l = _ref1549.className,
      i = _objectWithoutProperties(_ref1549, _excluded1549);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22 18V20H2V18H22ZM2 3.5L10 8.5L2 13.5V3.5ZM22 11V13H12V11H22ZM4 7.1085V9.8915L6.22641 8.5L4 7.1085ZM22 4V6H12V4H22Z"
  }));
},
    Og = function Og(_ref1550) {
  var _ref1550$color = _ref1550.color,
      C = _ref1550$color === void 0 ? "currentColor" : _ref1550$color,
      _ref1550$size = _ref1550.size,
      e = _ref1550$size === void 0 ? 24 : _ref1550$size,
      l = _ref1550.className,
      i = _objectWithoutProperties(_ref1550, _excluded1550);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 18H12V20H2V18ZM2 11H22V13H2V11ZM2 4H22V6H2V4ZM18 18V15H20V18H23V20H20V23H18V20H15V18H18Z"
  }));
},
    Kg = function Kg(_ref1551) {
  var _ref1551$color = _ref1551.color,
      C = _ref1551$color === void 0 ? "currentColor" : _ref1551$color,
      _ref1551$size = _ref1551.size,
      e = _ref1551$size === void 0 ? 24 : _ref1551$size,
      l = _ref1551.className,
      i = _objectWithoutProperties(_ref1551, _excluded1551);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 18H12V20H2V18ZM2 11H22V13H2V11ZM2 4H22V6H2V4ZM18 18V15H20V18H23V20H20V23H18V20H15V18H18Z"
  }));
},
    Qg = function Qg(_ref1552) {
  var _ref1552$color = _ref1552.color,
      C = _ref1552$color === void 0 ? "currentColor" : _ref1552$color,
      _ref1552$size = _ref1552.size,
      e = _ref1552$size === void 0 ? 24 : _ref1552$size,
      l = _ref1552.className,
      i = _objectWithoutProperties(_ref1552, _excluded1552);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 18H12V20H2V18ZM2 11H16V13H2V11ZM2 4H22V6H2V4ZM19 15.1707V9H24V11H21V18C21 19.6569 19.6569 21 18 21C16.3431 21 15 19.6569 15 18C15 16.3431 16.3431 15 18 15C18.3506 15 18.6872 15.0602 19 15.1707Z"
  }));
},
    qg = function qg(_ref1553) {
  var _ref1553$color = _ref1553.color,
      C = _ref1553$color === void 0 ? "currentColor" : _ref1553$color,
      _ref1553$size = _ref1553.size,
      e = _ref1553$size === void 0 ? 24 : _ref1553$size,
      l = _ref1553.className,
      i = _objectWithoutProperties(_ref1553, _excluded1553);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 18H12V20H2V18ZM2 11H16V13H2V11ZM2 4H22V6H2V4ZM19 15.1707V9H24V11H21V18C21 19.6569 19.6569 21 18 21C16.3431 21 15 19.6569 15 18C15 16.3431 16.3431 15 18 15C18.3506 15 18.6872 15.0602 19 15.1707ZM18 19C18.5523 19 19 18.5523 19 18C19 17.4477 18.5523 17 18 17C17.4477 17 17 17.4477 17 18C17 18.5523 17.4477 19 18 19Z"
  }));
},
    jg = function jg(_ref1554) {
  var _ref1554$color = _ref1554.color,
      C = _ref1554$color === void 0 ? "currentColor" : _ref1554$color,
      _ref1554$size = _ref1554.size,
      e = _ref1554$size === void 0 ? 24 : _ref1554$size,
      l = _ref1554.className,
      i = _objectWithoutProperties(_ref1554, _excluded1554);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7.75194 5.43872L18.2596 11.5682C18.4981 11.7073 18.5787 12.0135 18.4396 12.252C18.3961 12.3265 18.3341 12.3885 18.2596 12.432L7.75194 18.5615C7.51341 18.7006 7.20725 18.62 7.06811 18.3815C7.0235 18.305 7 18.2181 7 18.1296V5.87061C7 5.59446 7.22386 5.37061 7.5 5.37061C7.58853 5.37061 7.67547 5.39411 7.75194 5.43872Z"
  }));
},
    Xg = function Xg(_ref1555) {
  var _ref1555$color = _ref1555.color,
      C = _ref1555$color === void 0 ? "currentColor" : _ref1555$color,
      _ref1555$size = _ref1555.size,
      e = _ref1555$size === void 0 ? 24 : _ref1555$size,
      l = _ref1555.className,
      i = _objectWithoutProperties(_ref1555, _excluded1555);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9 8.48216V15.518L15.0307 12.0001L9 8.48216ZM7.75194 5.43872L18.2596 11.5682C18.4981 11.7073 18.5787 12.0135 18.4396 12.252C18.3961 12.3265 18.3341 12.3885 18.2596 12.432L7.75194 18.5615C7.51341 18.7006 7.20725 18.62 7.06811 18.3815C7.0235 18.305 7 18.2181 7 18.1296V5.87061C7 5.59446 7.22386 5.37061 7.5 5.37061C7.58853 5.37061 7.67547 5.39411 7.75194 5.43872Z"
  }));
},
    Jg = function Jg(_ref1556) {
  var _ref1556$color = _ref1556.color,
      C = _ref1556$color === void 0 ? "currentColor" : _ref1556$color,
      _ref1556$size = _ref1556.size,
      e = _ref1556$size === void 0 ? 24 : _ref1556$size,
      l = _ref1556.className,
      i = _objectWithoutProperties(_ref1556, _excluded1556);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22.5846 17.0112C22.1549 17.554 21.102 17.9412 21.102 17.9412L13.2697 20.7579V18.6806L19.0337 16.6244C19.6878 16.3898 19.7883 16.0581 19.2566 15.884C18.7259 15.7094 17.765 15.7594 17.1104 15.9951L13.2697 17.3494V15.1936L13.491 15.1185C13.491 15.1185 14.6009 14.7253 16.1614 14.5522C17.722 14.3801 19.6329 14.5757 21.133 15.1451C22.8235 15.6799 23.0139 16.4683 22.5846 17.0112ZM14.0152 13.4741V8.16195C14.0152 7.53808 13.9003 6.96374 13.3156 6.80115C12.8679 6.65756 12.5901 7.07381 12.5901 7.69718V21L9.0067 19.8613V4C10.5303 4.28317 12.75 4.95256 13.9433 5.3553C16.978 6.39841 18.0068 7.69667 18.0068 10.6219C18.0068 13.4731 16.2489 14.5537 14.0152 13.4741ZM2.43161 18.4635C0.696139 17.9742 0.407311 16.9546 1.19834 16.3673C1.92941 15.825 3.17267 15.4167 3.17267 15.4167L8.31061 13.5876V15.6729L4.61331 16.9976C3.9602 17.2323 3.85976 17.5645 4.39044 17.7386C4.92163 17.9127 5.88305 17.8632 6.53717 17.628L8.31061 16.9836V18.8492C8.19818 18.8692 8.07275 18.8893 7.95682 18.9088C6.18288 19.1989 4.2935 19.0779 2.43161 18.4635Z"
  }));
},
    Yg = function Yg(_ref1557) {
  var _ref1557$color = _ref1557.color,
      C = _ref1557$color === void 0 ? "currentColor" : _ref1557$color,
      _ref1557$size = _ref1557.size,
      e = _ref1557$size === void 0 ? 24 : _ref1557$size,
      l = _ref1557.className,
      i = _objectWithoutProperties(_ref1557, _excluded1557);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22.5846 17.0112C22.1549 17.554 21.102 17.9412 21.102 17.9412L13.2697 20.7579V18.6806L19.0337 16.6244C19.6878 16.3898 19.7883 16.0581 19.2566 15.884C18.7259 15.7094 17.765 15.7594 17.1104 15.9951L13.2697 17.3494V15.1936L13.491 15.1185C13.491 15.1185 14.6009 14.7253 16.1614 14.5522C17.722 14.3801 19.6329 14.5757 21.133 15.1451C22.8235 15.6799 23.0139 16.4683 22.5846 17.0112ZM14.0152 13.4741V8.16195C14.0152 7.53808 13.9003 6.96374 13.3156 6.80115C12.8679 6.65756 12.5901 7.07381 12.5901 7.69718V21L9.0067 19.8613V4C10.5303 4.28317 12.75 4.95256 13.9433 5.3553C16.978 6.39841 18.0068 7.69667 18.0068 10.6219C18.0068 13.4731 16.2489 14.5537 14.0152 13.4741ZM2.43161 18.4635C0.696139 17.9742 0.407311 16.9546 1.19834 16.3673C1.92941 15.825 3.17267 15.4167 3.17267 15.4167L8.31061 13.5876V15.6729L4.61331 16.9976C3.9602 17.2323 3.85976 17.5645 4.39044 17.7386C4.92163 17.9127 5.88305 17.8632 6.53717 17.628L8.31061 16.9836V18.8492C8.19818 18.8692 8.07275 18.8893 7.95682 18.9088C6.18288 19.1989 4.2935 19.0779 2.43161 18.4635Z"
  }));
},
    _g = function _g(_ref1558) {
  var _ref1558$color = _ref1558.color,
      C = _ref1558$color === void 0 ? "currentColor" : _ref1558$color,
      _ref1558$size = _ref1558.size,
      e = _ref1558$size === void 0 ? 24 : _ref1558$size,
      l = _ref1558.className,
      i = _objectWithoutProperties(_ref1558, _excluded1558);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13 18V20H19V22H13C11.8954 22 11 21.1046 11 20V18H8C5.79086 18 4 16.2091 4 14V10H20V14C20 16.2091 18.2091 18 16 18H13ZM17 6H19C19.5523 6 20 6.44772 20 7V9H4V7C4 6.44772 4.44772 6 5 6H7V2H9V6H15V2H17V6ZM12 14.5C12.5523 14.5 13 14.0523 13 13.5C13 12.9477 12.5523 12.5 12 12.5C11.4477 12.5 11 12.9477 11 13.5C11 14.0523 11.4477 14.5 12 14.5ZM11 2H13V5H11V2Z"
  }));
},
    $g = function $g(_ref1559) {
  var _ref1559$color = _ref1559.color,
      C = _ref1559$color === void 0 ? "currentColor" : _ref1559$color,
      _ref1559$size = _ref1559.size,
      e = _ref1559$size === void 0 ? 24 : _ref1559$size,
      l = _ref1559.className,
      i = _objectWithoutProperties(_ref1559, _excluded1559);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13 18V20H19V22H13C11.8954 22 11 21.1046 11 20V18H8C5.79086 18 4 16.2091 4 14V7C4 6.44772 4.44772 6 5 6H7V2H9V6H15V2H17V6H19C19.5523 6 20 6.44772 20 7V14C20 16.2091 18.2091 18 16 18H13ZM8 16H16C17.1046 16 18 15.1046 18 14V11H6V14C6 15.1046 6.89543 16 8 16ZM18 8H6V9H18V8ZM12 14.5C11.4477 14.5 11 14.0523 11 13.5C11 12.9477 11.4477 12.5 12 12.5C12.5523 12.5 13 12.9477 13 13.5C13 14.0523 12.5523 14.5 12 14.5ZM11 2H13V5H11V2Z"
  }));
},
    eM = function eM(_ref1560) {
  var _ref1560$color = _ref1560.color,
      C = _ref1560$color === void 0 ? "currentColor" : _ref1560$color,
      _ref1560$size = _ref1560.size,
      e = _ref1560$size === void 0 ? 24 : _ref1560$size,
      l = _ref1560.className,
      i = _objectWithoutProperties(_ref1560, _excluded1560);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13 18V20H19V22H13C11.8954 22 11 21.1046 11 20V18H8C5.79086 18 4 16.2091 4 14V10H20V14C20 16.2091 18.2091 18 16 18H13ZM16 6H19C19.5523 6 20 6.44772 20 7V9H4V7C4 6.44772 4.44772 6 5 6H8V2H10V6H14V2H16V6ZM12 14.5C12.5523 14.5 13 14.0523 13 13.5C13 12.9477 12.5523 12.5 12 12.5C11.4477 12.5 11 12.9477 11 13.5C11 14.0523 11.4477 14.5 12 14.5Z"
  }));
},
    tM = function tM(_ref1561) {
  var _ref1561$color = _ref1561.color,
      C = _ref1561$color === void 0 ? "currentColor" : _ref1561$color,
      _ref1561$size = _ref1561.size,
      e = _ref1561$size === void 0 ? 24 : _ref1561$size,
      l = _ref1561.className,
      i = _objectWithoutProperties(_ref1561, _excluded1561);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13 18V20H19V22H13C11.8954 22 11 21.1046 11 20V18H8C5.79086 18 4 16.2091 4 14V7C4 6.44772 4.44772 6 5 6H8V2H10V6H14V2H16V6H19C19.5523 6 20 6.44772 20 7V14C20 16.2091 18.2091 18 16 18H13ZM8 16H16C17.1046 16 18 15.1046 18 14V11H6V14C6 15.1046 6.89543 16 8 16ZM18 8H6V9H18V8ZM12 14.5C11.4477 14.5 11 14.0523 11 13.5C11 12.9477 11.4477 12.5 12 12.5C12.5523 12.5 13 12.9477 13 13.5C13 14.0523 12.5523 14.5 12 14.5Z"
  }));
},
    CM = function CM(_ref1562) {
  var _ref1562$color = _ref1562.color,
      C = _ref1562$color === void 0 ? "currentColor" : _ref1562$color,
      _ref1562$size = _ref1562.size,
      e = _ref1562$size === void 0 ? 24 : _ref1562$size,
      l = _ref1562.className,
      i = _objectWithoutProperties(_ref1562, _excluded1562);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 3.9934C3 3.44476 3.44495 3 3.9934 3H20.0066C20.5552 3 21 3.44495 21 3.9934V20.0066C21 20.5552 20.5551 21 20.0066 21H3.9934C3.44476 21 3 20.5551 3 20.0066V3.9934ZM6 17V19H18V17H6ZM5 5V7H7V5H5ZM12 12C10.8954 12 10 11.1046 10 10C10 8.89543 10.8954 8 12 8C13.1046 8 14 8.89543 14 10C14 11.1046 13.1046 12 12 12ZM12 14C14.2091 14 16 12.2091 16 10C16 7.79086 14.2091 6 12 6C9.79086 6 8 7.79086 8 10C8 12.2091 9.79086 14 12 14Z"
  }));
},
    lM = function lM(_ref1563) {
  var _ref1563$color = _ref1563.color,
      C = _ref1563$color === void 0 ? "currentColor" : _ref1563$color,
      _ref1563$size = _ref1563.size,
      e = _ref1563$size === void 0 ? 24 : _ref1563$size,
      l = _ref1563.className,
      i = _objectWithoutProperties(_ref1563, _excluded1563);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19 15V5H5V15H19ZM3 3.9934C3 3.44476 3.44495 3 3.9934 3H20.0066C20.5552 3 21 3.44495 21 3.9934V20.0066C21 20.5552 20.5551 21 20.0066 21H3.9934C3.44476 21 3 20.5551 3 20.0066V3.9934ZM12 12C13.1046 12 14 11.1046 14 10C14 8.89543 13.1046 8 12 8C10.8954 8 10 8.89543 10 10C10 11.1046 10.8954 12 12 12ZM12 14C9.79086 14 8 12.2091 8 10C8 7.79086 9.79086 6 12 6C14.2091 6 16 7.79086 16 10C16 12.2091 14.2091 14 12 14ZM6 6H8V8H6V6ZM6 17V19H18V17H6Z"
  }));
},
    iM = function iM(_ref1564) {
  var _ref1564$color = _ref1564.color,
      C = _ref1564$color === void 0 ? "currentColor" : _ref1564$color,
      _ref1564$size = _ref1564.size,
      e = _ref1564$size === void 0 ? 24 : _ref1564$size,
      l = _ref1564.className,
      i = _objectWithoutProperties(_ref1564, _excluded1564);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.6586 10C19.8349 7.66962 17.6124 6 15 6C11.6863 6 9 8.68629 9 12C9 15.3137 11.6863 18 15 18C17.6124 18 19.8349 16.3304 20.6586 14H21V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3H20C20.5523 3 21 3.44772 21 4V10H20.6586ZM5 6V9H7V6H5ZM15 16C12.7909 16 11 14.2091 11 12C11 9.79086 12.7909 8 15 8C17.2091 8 19 9.79086 19 12C19 14.2091 17.2091 16 15 16ZM15 14C16.1046 14 17 13.1046 17 12C17 10.8954 16.1046 10 15 10C13.8954 10 13 10.8954 13 12C13 13.1046 13.8954 14 15 14Z"
  }));
},
    sM = function sM(_ref1565) {
  var _ref1565$color = _ref1565.color,
      C = _ref1565$color === void 0 ? "currentColor" : _ref1565$color,
      _ref1565$size = _ref1565.size,
      e = _ref1565$size === void 0 ? 24 : _ref1565$size,
      l = _ref1565.className,
      i = _objectWithoutProperties(_ref1565, _excluded1565);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 6H19V5H5V19H19V18H21V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3H20C20.5523 3 21 3.44772 21 4V6ZM6 6H8V9H6V6ZM15 16C17.2091 16 19 14.2091 19 12C19 9.79086 17.2091 8 15 8C12.7909 8 11 9.79086 11 12C11 14.2091 12.7909 16 15 16ZM15 18C11.6863 18 9 15.3137 9 12C9 8.68629 11.6863 6 15 6C18.3137 6 21 8.68629 21 12C21 15.3137 18.3137 18 15 18ZM15 14C13.8954 14 13 13.1046 13 12C13 10.8954 13.8954 10 15 10C16.1046 10 17 10.8954 17 12C17 13.1046 16.1046 14 15 14Z"
  }));
},
    rM = function rM(_ref1566) {
  var _ref1566$color = _ref1566.color,
      C = _ref1566$color === void 0 ? "currentColor" : _ref1566$color,
      _ref1566$size = _ref1566.size,
      e = _ref1566$size === void 0 ? 24 : _ref1566$size,
      l = _ref1566.className,
      i = _objectWithoutProperties(_ref1566, _excluded1566);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22 13.5V21C22 21.5523 21.5523 22 21 22H20C19.4477 22 19 21.5523 19 21V20H5V21C5 21.5523 4.55228 22 4 22H3C2.44772 22 2 21.5523 2 21V13.5L0.757464 13.1894C0.312297 13.0781 0 12.6781 0 12.2192V11.5C0 11.2239 0.223858 11 0.5 11H2.42857L4.4805 6.21216C4.79566 5.47679 5.51874 5 6.31879 5H8V3H11V5H13V3H16V5H17.6812C18.4813 5 19.2043 5.47679 19.5195 6.21216L21.5714 11H23.5C23.7761 11 24 11.2239 24 11.5V12.2192C24 12.6781 23.6877 13.0781 23.2425 13.1894L22 13.5ZM4 15V17C4 17.5523 4.44772 18 5 18H8.24496C8.3272 18 8.40818 17.9797 8.4807 17.9409C8.72418 17.8107 8.81602 17.5078 8.68582 17.2643L8.68588 17.2643C7.87868 15.7548 6.31672 15 4 15ZM20 15C17.6833 15 16.1213 15.7548 15.3141 17.2643L15.3142 17.2643C15.184 17.5078 15.2758 17.8107 15.5193 17.9409C15.5918 17.9797 15.6728 18 15.755 18H19C19.5523 18 20 17.5523 20 17V15ZM6 7L4.54856 10.6286C4.50131 10.7467 4.47703 10.8728 4.47703 11C4.47703 11.5523 4.92475 12 5.47703 12H18.523C18.6502 12 18.7762 11.9757 18.8944 11.9285C19.4071 11.7234 19.6566 11.1414 19.4514 10.6286L18 7H6Z"
  }));
},
    cM = function cM(_ref1567) {
  var _ref1567$color = _ref1567.color,
      C = _ref1567$color === void 0 ? "currentColor" : _ref1567$color,
      _ref1567$size = _ref1567.size,
      e = _ref1567$size === void 0 ? 24 : _ref1567$size,
      l = _ref1567.className,
      i = _objectWithoutProperties(_ref1567, _excluded1567);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 13V18H20V13H4ZM5.61803 11H18.382C18.5372 11 18.6903 10.9639 18.8292 10.8944C19.3232 10.6474 19.5234 10.0468 19.2764 9.55279L18 7H6L4.72361 9.55279C4.65418 9.69164 4.61803 9.84475 4.61803 10C4.61803 10.5523 5.06575 11 5.61803 11ZM22 13.5V21C22 21.5523 21.5523 22 21 22H20C19.4477 22 19 21.5523 19 21V20H5V21C5 21.5523 4.55228 22 4 22H3C2.44772 22 2 21.5523 2 21V13.5L0.757464 13.1894C0.312297 13.0781 0 12.6781 0 12.2192V11.5C0 11.2239 0.223858 11 0.5 11H2L4.44721 6.10557C4.786 5.428 5.47852 5 6.23607 5H8V3H11V5H13V3H16V5H17.7639C18.5215 5 19.214 5.428 19.5528 6.10557L22 11H23.5C23.7761 11 24 11.2239 24 11.5V12.2192C24 12.6781 23.6877 13.0781 23.2425 13.1894L22 13.5ZM5 14C7.31672 14 8.87868 14.7548 9.68588 16.2643L9.68582 16.2643C9.81602 16.5078 9.72418 16.8107 9.4807 16.9409C9.40818 16.9797 9.3272 17 9.24496 17H6C5.44772 17 5 16.5523 5 16V14ZM19 14V16C19 16.5523 18.5523 17 18 17H14.755C14.6728 17 14.5918 16.9797 14.5193 16.9409C14.2758 16.8107 14.184 16.5078 14.3142 16.2643L14.3141 16.2643C15.1213 14.7548 16.6833 14 19 14Z"
  }));
},
    oM = function oM(_ref1568) {
  var _ref1568$color = _ref1568.color,
      C = _ref1568$color === void 0 ? "currentColor" : _ref1568$color,
      _ref1568$size = _ref1568.size,
      e = _ref1568$size === void 0 ? 24 : _ref1568$size,
      l = _ref1568.className,
      i = _objectWithoutProperties(_ref1568, _excluded1568);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3.00488 6.99972L11.4502 1.36952C11.7861 1.14559 12.2237 1.14559 12.5596 1.36952L21.0049 6.99972V20.9997C21.0049 21.552 20.5572 21.9997 20.0049 21.9997H4.00488C3.4526 21.9997 3.00488 21.552 3.00488 20.9997V6.99972ZM12.0049 10.9997C13.1095 10.9997 14.0049 10.1043 14.0049 8.99972C14.0049 7.89515 13.1095 6.99972 12.0049 6.99972C10.9003 6.99972 10.0049 7.89515 10.0049 8.99972C10.0049 10.1043 10.9003 10.9997 12.0049 10.9997ZM8.00488 15.9997V17.9997H16.0049V15.9997H8.00488ZM8.00488 12.9997V14.9997H16.0049V12.9997H8.00488Z"
  }));
},
    aM = function aM(_ref1569) {
  var _ref1569$color = _ref1569.color,
      C = _ref1569$color === void 0 ? "currentColor" : _ref1569$color,
      _ref1569$size = _ref1569.size,
      e = _ref1569$size === void 0 ? 24 : _ref1569$size,
      l = _ref1569.className,
      i = _objectWithoutProperties(_ref1569, _excluded1569);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3.00488 6.99972L11.4502 1.36952C11.7861 1.14559 12.2237 1.14559 12.5596 1.36952L21.0049 6.99972V20.9997C21.0049 21.552 20.5572 21.9997 20.0049 21.9997H4.00488C3.4526 21.9997 3.00488 21.552 3.00488 20.9997V6.99972ZM5.00488 8.07009V19.9997H19.0049V8.07009L12.0049 3.40342L5.00488 8.07009ZM8.00488 15.9997H16.0049V17.9997H8.00488V15.9997ZM8.00488 12.9997H16.0049V14.9997H8.00488V12.9997ZM12.0049 10.9997C10.9003 10.9997 10.0049 10.1043 10.0049 8.99972C10.0049 7.89515 10.9003 6.99972 12.0049 6.99972C13.1095 6.99972 14.0049 7.89515 14.0049 8.99972C14.0049 10.1043 13.1095 10.9997 12.0049 10.9997Z"
  }));
},
    nM = function nM(_ref1570) {
  var _ref1570$color = _ref1570.color,
      C = _ref1570$color === void 0 ? "currentColor" : _ref1570$color,
      _ref1570$size = _ref1570.size,
      e = _ref1570$size === void 0 ? 24 : _ref1570$size,
      l = _ref1570.className,
      i = _objectWithoutProperties(_ref1570, _excluded1570);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10.9042 2.10025L20.8037 3.51446L22.2179 13.414L13.0255 22.6063C12.635 22.9969 12.0019 22.9969 11.6113 22.6063L1.71184 12.7069C1.32131 12.3163 1.32131 11.6832 1.71184 11.2926L10.9042 2.10025ZM13.7327 10.5855C14.5137 11.3666 15.78 11.3666 16.5611 10.5855C17.3421 9.80448 17.3421 8.53815 16.5611 7.7571C15.78 6.97606 14.5137 6.97606 13.7327 7.7571C12.9516 8.53815 12.9516 9.80448 13.7327 10.5855Z"
  }));
},
    mM = function mM(_ref1571) {
  var _ref1571$color = _ref1571.color,
      C = _ref1571$color === void 0 ? "currentColor" : _ref1571$color,
      _ref1571$size = _ref1571.size,
      e = _ref1571$size === void 0 ? 24 : _ref1571$size,
      l = _ref1571.className,
      i = _objectWithoutProperties(_ref1571, _excluded1571);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10.9042 2.10025L20.8037 3.51446L22.2179 13.414L13.0255 22.6063C12.635 22.9969 12.0019 22.9969 11.6113 22.6063L1.71184 12.7069C1.32131 12.3163 1.32131 11.6832 1.71184 11.2926L10.9042 2.10025ZM11.6113 4.22157L3.83316 11.9997L12.3184 20.485L20.0966 12.7069L19.036 5.28223L11.6113 4.22157ZM13.7327 10.5855C12.9516 9.80448 12.9516 8.53815 13.7327 7.7571C14.5137 6.97606 15.78 6.97606 16.5611 7.7571C17.3421 8.53815 17.3421 9.80448 16.5611 10.5855C15.78 11.3666 14.5137 11.3666 13.7327 10.5855Z"
  }));
},
    wM = function wM(_ref1572) {
  var _ref1572$color = _ref1572.color,
      C = _ref1572$color === void 0 ? "currentColor" : _ref1572$color,
      _ref1572$size = _ref1572.size,
      e = _ref1572$size === void 0 ? 24 : _ref1572$size,
      l = _ref1572.className,
      i = _objectWithoutProperties(_ref1572, _excluded1572);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3.00488 6.99972L11.4502 1.36952C11.7861 1.14559 12.2237 1.14559 12.5596 1.36952L21.0049 6.99972V20.9997C21.0049 21.552 20.5572 21.9997 20.0049 21.9997H4.00488C3.4526 21.9997 3.00488 21.552 3.00488 20.9997V6.99972ZM12.0049 10.9997C13.1095 10.9997 14.0049 10.1043 14.0049 8.99972C14.0049 7.89515 13.1095 6.99972 12.0049 6.99972C10.9003 6.99972 10.0049 7.89515 10.0049 8.99972C10.0049 10.1043 10.9003 10.9997 12.0049 10.9997Z"
  }));
},
    LM = function LM(_ref1573) {
  var _ref1573$color = _ref1573.color,
      C = _ref1573$color === void 0 ? "currentColor" : _ref1573$color,
      _ref1573$size = _ref1573.size,
      e = _ref1573$size === void 0 ? 24 : _ref1573$size,
      l = _ref1573.className,
      i = _objectWithoutProperties(_ref1573, _excluded1573);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3.00488 6.99972L11.4502 1.36952C11.7861 1.14559 12.2237 1.14559 12.5596 1.36952L21.0049 6.99972V20.9997C21.0049 21.552 20.5572 21.9997 20.0049 21.9997H4.00488C3.4526 21.9997 3.00488 21.552 3.00488 20.9997V6.99972ZM5.00488 8.07009V19.9997H19.0049V8.07009L12.0049 3.40342L5.00488 8.07009ZM12.0049 10.9997C10.9003 10.9997 10.0049 10.1043 10.0049 8.99972C10.0049 7.89515 10.9003 6.99972 12.0049 6.99972C13.1095 6.99972 14.0049 7.89515 14.0049 8.99972C14.0049 10.1043 13.1095 10.9997 12.0049 10.9997Z"
  }));
},
    hM = function hM(_ref1574) {
  var _ref1574$color = _ref1574.color,
      C = _ref1574$color === void 0 ? "currentColor" : _ref1574$color,
      _ref1574$size = _ref1574.size,
      e = _ref1574$size === void 0 ? 24 : _ref1574$size,
      l = _ref1574.className,
      i = _objectWithoutProperties(_ref1574, _excluded1574);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7 2H17C17.5523 2 18 2.44771 18 3V6H6V3C6 2.44771 6.44772 2 7 2ZM22 9C22 8.44771 21.5523 8 21 8H3C2.44771 8 2 8.44771 2 9V19C2 19.5523 2.44771 20 3 20H5V15H12.1938C12.4371 14.1087 12.9094 13.3124 13.6109 12.6109C14.6848 11.537 15.9812 11 17.5 11C19.0188 11 20.3152 11.537 21.3891 12.6109C21.6169 12.8387 21.8205 13.0765 22 13.3243V9ZM8 10V12H5V10H8ZM21 16.5C21 14.567 19.433 13 17.5 13C15.567 13 14 14.567 14 16.5L14.0034 16.6025C12.8474 16.9279 12 17.99 12 19.25C12 20.7125 13.1417 21.9084 14.5825 21.995L14.75 22H20.25L20.4175 21.995C21.8583 21.9084 23 20.7125 23 19.25C23 17.9903 22.1531 16.9285 20.9985 16.6033L21 16.5ZM7 17H10.562C10.1873 17.6859 10 18.4359 10 19.25C10 20.2823 10.2905 21.199 10.8715 22H7V17Z"
  }));
},
    HM = function HM(_ref1575) {
  var _ref1575$color = _ref1575.color,
      C = _ref1575$color === void 0 ? "currentColor" : _ref1575$color,
      _ref1575$size = _ref1575.size,
      e = _ref1575$size === void 0 ? 24 : _ref1575$size,
      l = _ref1575.className,
      i = _objectWithoutProperties(_ref1575, _excluded1575);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17 2C17.5523 2 18 2.44771 18 3V7H21C21.5523 7 22 7.44772 22 8V13.3243C21.8205 13.0765 21.6169 12.8387 21.3891 12.6109C20.9614 12.1832 20.4983 11.8406 20 11.5832V9H4V17H6V16C6 15.4477 6.44772 15 7 15H12.1938C12.1683 15.0933 12.1454 15.1877 12.1249 15.283C11.6949 15.5675 11.314 15.9255 10.9824 16.357C10.8228 16.5647 10.6827 16.779 10.562 17H8V20H10.0541C10.1628 20.7319 10.4352 21.3985 10.8715 22H7C6.44772 22 6 21.5523 6 21V19H3C2.44771 19 2 18.5523 2 18V8C2 7.44772 2.44771 7 3 7H6V3C6 2.44771 6.44772 2 7 2H17ZM16 4H8V7H16V4ZM8 10V12H5V10H8ZM21 16.5C21 14.567 19.433 13 17.5 13C15.567 13 14 14.567 14 16.5L14.0034 16.6025C12.8474 16.9279 12 17.99 12 19.25C12 20.7125 13.1417 21.9084 14.5825 21.995L14.75 22H20.25L20.4175 21.995C21.8583 21.9084 23 20.7125 23 19.25C23 17.9903 22.1531 16.9285 20.9985 16.6033L21 16.5ZM16.0069 16.3555C16.0796 15.5949 16.7203 15 17.5 15C18.2797 15 18.9204 15.5949 18.9931 16.3555L19 16.5V18.12C19.696 18.3189 20.1774 18.4541 20.4441 18.5256C20.8442 18.6328 21.0816 19.044 20.9744 19.4441C20.8851 19.7775 20.5846 19.998 20.2554 20.0002H14.7446C14.4154 19.998 14.1149 19.7775 14.0256 19.4441C13.9183 19.044 14.1558 18.6328 14.5559 18.5256C14.793 18.462 15.1997 18.3482 15.7759 18.1839L16 18.12V16.5L16.0069 16.3555Z"
  }));
},
    VM = function VM(_ref1576) {
  var _ref1576$color = _ref1576.color,
      C = _ref1576$color === void 0 ? "currentColor" : _ref1576$color,
      _ref1576$size = _ref1576.size,
      e = _ref1576$size === void 0 ? 24 : _ref1576$size,
      l = _ref1576.className,
      i = _objectWithoutProperties(_ref1576, _excluded1576);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7 17H17V22H7V17ZM19 20V15H5V20H3C2.44772 20 2 19.5523 2 19V9C2 8.44772 2.44772 8 3 8H21C21.5523 8 22 8.44772 22 9V19C22 19.5523 21.5523 20 21 20H19ZM5 10V12H8V10H5ZM7 2H17C17.5523 2 18 2.44772 18 3V6H6V3C6 2.44772 6.44772 2 7 2Z"
  }));
},
    gM = function gM(_ref1577) {
  var _ref1577$color = _ref1577.color,
      C = _ref1577$color === void 0 ? "currentColor" : _ref1577$color,
      _ref1577$size = _ref1577.size,
      e = _ref1577$size === void 0 ? 24 : _ref1577$size,
      l = _ref1577.className,
      i = _objectWithoutProperties(_ref1577, _excluded1577);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17 2C17.5523 2 18 2.44772 18 3V7H21C21.5523 7 22 7.44772 22 8V18C22 18.5523 21.5523 19 21 19H18V21C18 21.5523 17.5523 22 17 22H7C6.44772 22 6 21.5523 6 21V19H3C2.44772 19 2 18.5523 2 18V8C2 7.44772 2.44772 7 3 7H6V3C6 2.44772 6.44772 2 7 2H17ZM16 17H8V20H16V17ZM20 9H4V17H6V16C6 15.4477 6.44772 15 7 15H17C17.5523 15 18 15.4477 18 16V17H20V9ZM8 10V12H5V10H8ZM16 4H8V7H16V4Z"
  }));
},
    MM = function MM(_ref1578) {
  var _ref1578$color = _ref1578.color,
      C = _ref1578$color === void 0 ? "currentColor" : _ref1578$color,
      _ref1578$size = _ref1578.size,
      e = _ref1578$size === void 0 ? 24 : _ref1578$size,
      l = _ref1578.className,
      i = _objectWithoutProperties(_ref1578, _excluded1578);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.001 22C6.47813 22 2.00098 17.5228 2.00098 12C2.00098 6.47715 6.47813 2 12.001 2C17.5238 2 22.001 6.47715 22.001 12C22.001 17.5228 17.5238 22 12.001 22ZM13.3345 12H10.501V9H13.3345C14.1629 9 14.8345 9.67157 14.8345 10.5C14.8345 11.3284 14.1629 12 13.3345 12ZM13.3345 7H8.50098V17H10.501V14H13.3345C15.2675 14 16.8345 12.433 16.8345 10.5C16.8345 8.567 15.2675 7 13.3345 7Z"
  }));
},
    ZM = function ZM(_ref1579) {
  var _ref1579$color = _ref1579.color,
      C = _ref1579$color === void 0 ? "currentColor" : _ref1579$color,
      _ref1579$size = _ref1579.size,
      e = _ref1579$size === void 0 ? 24 : _ref1579$size,
      l = _ref1579.className,
      i = _objectWithoutProperties(_ref1579, _excluded1579);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.001 22C6.47813 22 2.00098 17.5228 2.00098 12C2.00098 6.47715 6.47813 2 12.001 2C17.5238 2 22.001 6.47715 22.001 12C22.001 17.5228 17.5238 22 12.001 22ZM12.001 20C16.4193 20 20.001 16.4183 20.001 12C20.001 7.58172 16.4193 4 12.001 4C7.5827 4 4.00098 7.58172 4.00098 12C4.00098 16.4183 7.5827 20 12.001 20ZM13.3345 12C14.1629 12 14.8345 11.3284 14.8345 10.5C14.8345 9.67157 14.1629 9 13.3345 9H10.501V12H13.3345ZM13.3345 7C15.2675 7 16.8345 8.567 16.8345 10.5C16.8345 12.433 15.2675 14 13.3345 14H10.501V17H8.50098V7H13.3345Z"
  }));
},
    xM = function xM(_ref1580) {
  var _ref1580$color = _ref1580.color,
      C = _ref1580$color === void 0 ? "currentColor" : _ref1580$color,
      _ref1580$size = _ref1580.size,
      e = _ref1580$size === void 0 ? 24 : _ref1580$size,
      l = _ref1580.className,
      i = _objectWithoutProperties(_ref1580, _excluded1580);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 3.9934C2 3.44476 2.45531 3 2.9918 3H21.0082C21.556 3 22 3.44495 22 3.9934V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5551 2 20.0066V3.9934ZM6 15V17H18V15H6ZM6 7V13H12V7H6ZM14 7V9H18V7H14ZM14 11V13H18V11H14ZM8 9H10V11H8V9Z"
  }));
},
    vM = function vM(_ref1581) {
  var _ref1581$color = _ref1581.color,
      C = _ref1581$color === void 0 ? "currentColor" : _ref1581$color,
      _ref1581$size = _ref1581.size,
      e = _ref1581$size === void 0 ? 24 : _ref1581$size,
      l = _ref1581.className,
      i = _objectWithoutProperties(_ref1581, _excluded1581);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21.0082 3C21.556 3 22 3.44495 22 3.9934V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5551 2 20.0066V3.9934C2 3.44476 2.45531 3 2.9918 3H21.0082ZM20 5H4V19H20V5ZM18 15V17H6V15H18ZM12 7V13H6V7H12ZM18 11V13H14V11H18ZM10 9H8V11H10V9ZM18 7V9H14V7H18Z"
  }));
},
    dM = function dM(_ref1582) {
  var _ref1582$color = _ref1582.color,
      C = _ref1582$color === void 0 ? "currentColor" : _ref1582$color,
      _ref1582$size = _ref1582.size,
      e = _ref1582$size === void 0 ? 24 : _ref1582$size,
      l = _ref1582.className,
      i = _objectWithoutProperties(_ref1582, _excluded1582);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22 19V21H20V19H4V21H2V19C1.44772 19 1 18.5523 1 18V6C1 5.44772 1.44772 5 2 5H11.8096C12.9925 3.76733 14.6566 3 16.5 3C18.3434 3 20.0075 3.76733 21.1904 5H22C22.5523 5 23 5.44772 23 6V18C23 18.5523 22.5523 19 22 19ZM16.5 14C18.9853 14 21 11.9853 21 9.5C21 7.01472 18.9853 5 16.5 5C14.0147 5 12 7.01472 12 9.5C12 11.9853 14.0147 14 16.5 14ZM16.5 12C15.1193 12 14 10.8807 14 9.5C14 8.11929 15.1193 7 16.5 7C17.8807 7 19 8.11929 19 9.5C19 10.8807 17.8807 12 16.5 12ZM4 13V15H6V13H4ZM8 13V15H10V13H8Z"
  }));
},
    pM = function pM(_ref1583) {
  var _ref1583$color = _ref1583.color,
      C = _ref1583$color === void 0 ? "currentColor" : _ref1583$color,
      _ref1583$size = _ref1583.size,
      e = _ref1583$size === void 0 ? 24 : _ref1583$size,
      l = _ref1583.className,
      i = _objectWithoutProperties(_ref1583, _excluded1583);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22 19V21H20V19H4V21H2V19C1.44772 19 1 18.5523 1 18V6C1 5.44772 1.44772 5 2 5H12.5278C13.6264 3.7725 15.223 3 17 3C18.777 3 20.3736 3.7725 21.4722 5H22C22.5523 5 23 5.44772 23 6V18C23 18.5523 22.5523 19 22 19ZM11.3414 7H3V17H21V13.4722C19.9385 14.4223 18.5367 15 17 15C13.6863 15 11 12.3137 11 9C11 8.29873 11.1203 7.62556 11.3414 7ZM17 13C19.2091 13 21 11.2091 21 9C21 6.79086 19.2091 5 17 5C14.7909 5 13 6.79086 13 9C13 11.2091 14.7909 13 17 13ZM5 13H7V15H5V13ZM8 13H10V15H8V13Z"
  }));
},
    EM = function EM(_ref1584) {
  var _ref1584$color = _ref1584.color,
      C = _ref1584$color === void 0 ? "currentColor" : _ref1584$color,
      _ref1584$size = _ref1584.size,
      e = _ref1584$size === void 0 ? 24 : _ref1584$size,
      l = _ref1584.className,
      i = _objectWithoutProperties(_ref1584, _excluded1584);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 3H21C21.5523 3 22 3.44772 22 4V10H18.874C18.4299 8.27477 16.8638 7 15 7C13.1362 7 11.5701 8.27477 11.126 10H2V4C2 3.44772 2.44772 3 3 3ZM2 12V20C2 20.5523 2.44772 21 3 21H21C21.5523 21 22 20.5523 22 20V12H18.874C18.4299 13.7252 16.8638 15 15 15C13.1362 15 11.5701 13.7252 11.126 12H2ZM15 9C13.8954 9 13 9.89543 13 11C13 12.1046 13.8954 13 15 13C16.1046 13 17 12.1046 17 11C17 9.89543 16.1046 9 15 9ZM6 15H8V17H6V15Z"
  }));
},
    NM = function NM(_ref1585) {
  var _ref1585$color = _ref1585.color,
      C = _ref1585$color === void 0 ? "currentColor" : _ref1585$color,
      _ref1585$size = _ref1585.size,
      e = _ref1585$size === void 0 ? 24 : _ref1585$size,
      l = _ref1585.className,
      i = _objectWithoutProperties(_ref1585, _excluded1585);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM11.126 12H4V19H20V12H18.874C18.4299 13.7252 16.8638 15 15 15C13.1362 15 11.5701 13.7252 11.126 12ZM11.126 10C11.5701 8.27477 13.1362 7 15 7C16.8638 7 18.4299 8.27477 18.874 10H20V5H4V10H11.126ZM15 13C16.1046 13 17 12.1046 17 11C17 9.89543 16.1046 9 15 9C13.8954 9 13 9.89543 13 11C13 12.1046 13.8954 13 15 13ZM6 15H8V17H6V15Z"
  }));
},
    uM = function uM(_ref1586) {
  var _ref1586$color = _ref1586.color,
      C = _ref1586$color === void 0 ? "currentColor" : _ref1586$color,
      _ref1586$size = _ref1586.size,
      e = _ref1586$size === void 0 ? 24 : _ref1586$size,
      l = _ref1586.className,
      i = _objectWithoutProperties(_ref1586, _excluded1586);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11 2C15.0675 2 18.426 5.03562 18.9337 8.96494L21.1842 12.5037C21.3324 12.7367 21.3025 13.0847 20.9593 13.2317L19 14.071V17C19 18.1046 18.1046 19 17 19H15.001L15 22H6L6.00025 18.3061C6.00033 17.1252 5.56351 16.0087 4.7555 15.0011C3.65707 13.6313 3 11.8924 3 10C3 5.58172 6.58172 2 11 2ZM11 7C10.4477 7 10 7.44772 10 8V8.999L9 9C8.44772 9 8 9.44772 8 10C8 10.5523 8.44772 11 9 11L10 10.999V12C10 12.5523 10.4477 13 11 13C11.5523 13 12 12.5523 12 12V11H13C13.5523 11 14 10.5523 14 10C14 9.44772 13.5523 9 13 9H12V8C12 7.44772 11.5523 7 11 7Z"
  }));
},
    BM = function BM(_ref1587) {
  var _ref1587$color = _ref1587.color,
      C = _ref1587$color === void 0 ? "currentColor" : _ref1587$color,
      _ref1587$size = _ref1587.size,
      e = _ref1587$size === void 0 ? 24 : _ref1587$size,
      l = _ref1587.className,
      i = _objectWithoutProperties(_ref1587, _excluded1587);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11 2C15.0675 2 18.426 5.03562 18.9337 8.96494L21.1842 12.5037C21.3324 12.7367 21.3025 13.0847 20.9593 13.2317L19 14.071V17C19 18.1046 18.1046 19 17 19H15.001L15 22H6L6.00025 18.3061C6.00033 17.1252 5.56351 16.0087 4.7555 15.0011C3.65707 13.6313 3 11.8924 3 10C3 5.58172 6.58172 2 11 2ZM11 4C7.68629 4 5 6.68629 5 10C5 11.3849 5.46818 12.6929 6.31578 13.7499C7.40965 15.114 8.00036 16.6672 8.00025 18.3063L8.00013 20H13.0007L13.0017 17H17V12.7519L18.5497 12.0881L17.0072 9.66262L16.9501 9.22118C16.5665 6.25141 14.0243 4 11 4ZM11 7C11.5523 7 12 7.44772 12 8V9H13C13.5523 9 14 9.44772 14 10C14 10.5523 13.5523 11 13 11H12V12C12 12.5523 11.5523 13 11 13C10.4477 13 10 12.5523 10 12V10.999L9 11C8.44772 11 8 10.5523 8 10C8 9.44772 8.44772 9 9 9L10 8.999V8C10 7.44772 10.4477 7 11 7Z"
  }));
},
    fM = function fM(_ref1588) {
  var _ref1588$color = _ref1588.color,
      C = _ref1588$color === void 0 ? "currentColor" : _ref1588$color,
      _ref1588$size = _ref1588.size,
      e = _ref1588$size === void 0 ? 24 : _ref1588$size,
      l = _ref1588.className,
      i = _objectWithoutProperties(_ref1588, _excluded1588);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9 7.53861L15 21.5386L18.6594 13H23V11H17.3406L15 16.4614L9 2.46143L5.3406 11H1V13H6.6594L9 7.53861Z"
  }));
},
    RM = function RM(_ref1589) {
  var _ref1589$color = _ref1589.color,
      C = _ref1589$color === void 0 ? "currentColor" : _ref1589$color,
      _ref1589$size = _ref1589.size,
      e = _ref1589$size === void 0 ? 24 : _ref1589$size,
      l = _ref1589.className,
      i = _objectWithoutProperties(_ref1589, _excluded1589);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9 7.53861L15 21.5386L18.6594 13H23V11H17.3406L15 16.4614L9 2.46143L5.3406 11H1V13H6.6594L9 7.53861Z"
  }));
},
    zM = function zM(_ref1590) {
  var _ref1590$color = _ref1590.color,
      C = _ref1590$color === void 0 ? "currentColor" : _ref1590$color,
      _ref1590$size = _ref1590.size,
      e = _ref1590$size === void 0 ? 24 : _ref1590$size,
      l = _ref1590.className,
      i = _objectWithoutProperties(_ref1590, _excluded1590);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18 3V5H17V11L19 14V16H13V23H11V16H5V14L7 11V5H6V3H18Z"
  }));
},
    FM = function FM(_ref1591) {
  var _ref1591$color = _ref1591.color,
      C = _ref1591$color === void 0 ? "currentColor" : _ref1591$color,
      _ref1591$size = _ref1591.size,
      e = _ref1591$size === void 0 ? 24 : _ref1591$size,
      l = _ref1591.className,
      i = _objectWithoutProperties(_ref1591, _excluded1591);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18 3V5H17V11L19 14V16H13V23H11V16H5V14L7 11V5H6V3H18ZM9 5V11.6056L7.4037 14H16.5963L15 11.6056V5H9Z"
  }));
},
    SM = function SM(_ref1592) {
  var _ref1592$color = _ref1592.color,
      C = _ref1592$color === void 0 ? "currentColor" : _ref1592$color,
      _ref1592$size = _ref1592.size,
      e = _ref1592$size === void 0 ? 24 : _ref1592$size,
      l = _ref1592.className,
      i = _objectWithoutProperties(_ref1592, _excluded1592);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22.3126 10.1753L20.8984 11.5895L20.1913 10.8824L15.9486 15.125L15.2415 18.6606L13.8273 20.0748L9.58466 15.8321L4.63492 20.7819L3.2207 19.3677L8.17045 14.4179L3.92781 10.1753L5.34202 8.76107L8.87756 8.05396L13.1202 3.81132L12.4131 3.10422L13.8273 1.69L22.3126 10.1753Z"
  }));
},
    AM = function AM(_ref1593) {
  var _ref1593$color = _ref1593.color,
      C = _ref1593$color === void 0 ? "currentColor" : _ref1593$color,
      _ref1593$size = _ref1593.size,
      e = _ref1593$size === void 0 ? 24 : _ref1593$size,
      l = _ref1593.className,
      i = _objectWithoutProperties(_ref1593, _excluded1593);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13.8273 1.69L22.3126 10.1753L20.8984 11.5895L20.1913 10.8824L15.9486 15.125L15.2415 18.6606L13.8273 20.0748L9.58466 15.8321L4.63492 20.7819L3.2207 19.3677L8.17045 14.4179L3.92781 10.1753L5.34202 8.76107L8.87756 8.05396L13.1202 3.81132L12.4131 3.10422L13.8273 1.69ZM14.5344 5.22554L9.86358 9.89637L7.0417 10.4607L13.5418 16.9609L14.1062 14.139L18.7771 9.46818L14.5344 5.22554Z"
  }));
},
    kM = function kM(_ref1594) {
  var _ref1594$color = _ref1594.color,
      C = _ref1594$color === void 0 ? "currentColor" : _ref1594$color,
      _ref1594$size = _ref1594.size,
      e = _ref1594$size === void 0 ? 24 : _ref1594$size,
      l = _ref1594.className,
      i = _objectWithoutProperties(_ref1594, _excluded1594);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19.9139 14.529C19.7336 13.955 19.4877 13.2856 19.2385 12.643L18.3288 10.3969C18.3295 10.371 18.3408 9.92858 18.3408 9.70053C18.3408 5.8599 16.5082 2.00037 12.0009 2C7.49403 2.00037 5.66113 5.8599 5.66113 9.70053C5.66113 9.92858 5.67237 10.371 5.67312 10.3969L4.76379 12.643C4.51453 13.2856 4.26827 13.955 4.08798 14.529C3.2285 17.2657 3.507 18.3982 3.71915 18.4238C4.17419 18.4779 5.49021 16.3635 5.49021 16.3635C5.49021 17.5879 6.12741 19.1858 7.5064 20.3398C6.99064 20.4971 6.35868 20.7388 5.95237 21.0355C5.58729 21.3025 5.63302 21.5743 5.69861 21.6841C5.9876 22.1661 10.6542 21.9918 12.0017 21.8417C13.3488 21.9918 18.0158 22.1661 18.3044 21.6841C18.3704 21.5743 18.4157 21.3025 18.0507 21.0355C17.6443 20.7388 17.012 20.4971 16.4959 20.3395C17.8745 19.1858 18.5117 17.5879 18.5117 16.3635C18.5117 16.3635 19.8281 18.4779 20.2831 18.4238C20.4949 18.3982 20.7734 17.2657 19.9139 14.529Z"
  }));
},
    PM = function PM(_ref1595) {
  var _ref1595$color = _ref1595.color,
      C = _ref1595$color === void 0 ? "currentColor" : _ref1595$color,
      _ref1595$size = _ref1595.size,
      e = _ref1595$size === void 0 ? 24 : _ref1595$size,
      l = _ref1595.className,
      i = _objectWithoutProperties(_ref1595, _excluded1595);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17.5359 12.5144L16.8402 10.7175C16.8408 10.6968 16.8494 10.3429 16.8494 10.1604C16.8494 7.08792 15.448 4.0003 12.0012 4C8.55459 4.0003 7.15292 7.08792 7.15292 10.1604C7.15292 10.3429 7.16151 10.6968 7.16209 10.7175L6.4667 12.5144C6.27608 13.0285 6.08776 13.564 5.94988 14.0232C5.29262 16.2126 5.50559 17.1186 5.66783 17.139C6.01581 17.1823 7.02221 15.4908 7.02221 15.4908C7.02221 16.4704 7.5095 17.7487 8.56405 18.6719C8.16963 18.7976 7.68635 18.9911 7.37564 19.2284C7.09645 19.442 7.13142 19.6594 7.18158 19.7473C7.40258 20.1329 10.9713 19.9935 12.0017 19.8733C13.0319 19.9935 16.6009 20.1329 16.8216 19.7473C16.872 19.6594 16.9067 19.442 16.6275 19.2284C16.3168 18.9911 15.8333 18.7976 15.4386 18.6716C16.4928 17.7487 16.9801 16.4704 16.9801 15.4908C16.9801 15.4908 17.9868 17.1823 18.3348 17.139C18.4967 17.1186 18.7131 16.2108 18.0524 14.0232C17.9125 13.56 17.7265 13.0285 17.5359 12.5144ZM18.5574 20.7407C18.1843 21.3926 17.7237 21.6334 17.1187 21.7981C16.8792 21.8633 16.621 21.9056 16.325 21.936C15.8844 21.9814 15.3392 22.001 14.712 22C13.786 21.9985 12.693 21.9491 12.0017 21.884C11.3103 21.9491 10.2173 21.9985 9.29129 22C8.66414 22.001 8.11889 21.9814 7.67832 21.936C7.38236 21.9056 7.12409 21.8633 6.88467 21.7981C6.27994 21.6335 5.81954 21.393 5.44496 20.7393C5.15165 20.2258 5.07747 19.6406 5.20612 19.0866C4.61376 18.9546 4.20483 18.6045 3.92733 18.1757C3.77911 17.9466 3.68408 17.7127 3.61845 17.4663C3.53001 17.1344 3.49486 16.7666 3.50184 16.3601C3.51532 15.5749 3.68902 14.5984 4.03435 13.4481C4.17427 12.9821 4.3614 12.4396 4.6015 11.7926L5.15467 10.3632C5.1536 10.287 5.15292 10.2154 5.15292 10.1604C5.15292 5.6047 7.58875 2.00038 12.0013 2C16.4138 2.00038 18.8494 5.60454 18.8494 10.1604C18.8494 10.2154 18.8487 10.2869 18.8477 10.3631L19.401 11.7923L19.4112 11.8191C19.636 12.4254 19.8242 12.9722 19.967 13.445C20.3145 14.5956 20.4889 15.5735 20.5018 16.361C20.5085 16.768 20.4728 17.1365 20.3837 17.4689C20.3178 17.7148 20.2226 17.9483 20.0746 18.1768C19.7976 18.6041 19.3905 18.9532 18.7974 19.0862C18.9266 19.6411 18.8523 20.2274 18.5574 20.7407Z"
  }));
},
    DM = function DM(_ref1596) {
  var _ref1596$color = _ref1596.color,
      C = _ref1596$color === void 0 ? "currentColor" : _ref1596$color,
      _ref1596$size = _ref1596.size,
      e = _ref1596$size === void 0 ? 24 : _ref1596$size,
      l = _ref1596.className,
      i = _objectWithoutProperties(_ref1596, _excluded1596);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16 17V16H13V13H16V15H18V17H17V19H15V21H13V18H15V17H16ZM21 21H17V19H19V17H21V21ZM3 3H11V11H3V3ZM13 3H21V11H13V3ZM3 13H11V21H3V13ZM18 13H21V15H18V13ZM6 6V8H8V6H6ZM6 16V18H8V16H6ZM16 6V8H18V6H16Z"
  }));
},
    yM = function yM(_ref1597) {
  var _ref1597$color = _ref1597.color,
      C = _ref1597$color === void 0 ? "currentColor" : _ref1597$color,
      _ref1597$size = _ref1597.size,
      e = _ref1597$size === void 0 ? 24 : _ref1597$size,
      l = _ref1597.className,
      i = _objectWithoutProperties(_ref1597, _excluded1597);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16 17V16H13V13H16V15H18V17H17V19H15V21H13V18H15V17H16ZM21 21H17V19H19V17H21V21ZM3 3H11V11H3V3ZM5 5V9H9V5H5ZM13 3H21V11H13V3ZM15 5V9H19V5H15ZM3 13H11V21H3V13ZM5 15V19H9V15H5ZM18 13H21V15H18V13ZM6 6H8V8H6V6ZM6 16H8V18H6V16ZM16 6H18V8H16V6Z"
  }));
},
    bM = function bM(_ref1598) {
  var _ref1598$color = _ref1598.color,
      C = _ref1598$color === void 0 ? "currentColor" : _ref1598$color,
      _ref1598$size = _ref1598.size,
      e = _ref1598$size === void 0 ? 24 : _ref1598$size,
      l = _ref1598.className,
      i = _objectWithoutProperties(_ref1598, _excluded1598);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15 3H21V9H15V3ZM9 3V9H3V3H9ZM15 21V15H21V21H15ZM9 21H3V15H9V21ZM3 11H21V13H3V11Z"
  }));
},
    TM = function TM(_ref1599) {
  var _ref1599$color = _ref1599.color,
      C = _ref1599$color === void 0 ? "currentColor" : _ref1599$color,
      _ref1599$size = _ref1599.size,
      e = _ref1599$size === void 0 ? 24 : _ref1599$size,
      l = _ref1599.className,
      i = _objectWithoutProperties(_ref1599, _excluded1599);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15 3H21V8H19V5H15V3ZM9 3V5H5V8H3V3H9ZM15 21V19H19V16H21V21H15ZM9 21H3V16H5V19H9V21ZM3 11H21V13H3V11Z"
  }));
},
    UM = function UM(_ref1600) {
  var _ref1600$color = _ref1600.color,
      C = _ref1600$color === void 0 ? "currentColor" : _ref1600$color,
      _ref1600$size = _ref1600.size,
      e = _ref1600$size === void 0 ? 24 : _ref1600$size,
      l = _ref1600.className,
      i = _objectWithoutProperties(_ref1600, _excluded1600);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 15V20.0066C21 20.5552 20.5551 21 20.0066 21H3.9934C3.44476 21 3 20.5551 3 20.0066V15H21ZM2 11H22V13H2V11ZM21 9H3V3.9934C3 3.44476 3.44495 3 3.9934 3H20.0066C20.5552 3 21 3.44495 21 3.9934V9Z"
  }));
},
    GM = function GM(_ref1601) {
  var _ref1601$color = _ref1601.color,
      C = _ref1601$color === void 0 ? "currentColor" : _ref1601$color,
      _ref1601$size = _ref1601.size,
      e = _ref1601$size === void 0 ? 24 : _ref1601$size,
      l = _ref1601.className,
      i = _objectWithoutProperties(_ref1601, _excluded1601);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 16V21H3V16H5V19H19V16H21ZM3 11H21V13H3V11ZM21 8H19V5H5V8H3V3H21V8Z"
  }));
},
    IM = function IM(_ref1602) {
  var _ref1602$color = _ref1602.color,
      C = _ref1602$color === void 0 ? "currentColor" : _ref1602$color,
      _ref1602$size = _ref1602.size,
      e = _ref1602$size === void 0 ? 24 : _ref1602$size,
      l = _ref1602.className,
      i = _objectWithoutProperties(_ref1602, _excluded1602);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8 18H18.2372L20 19.3851V9H21C21.5523 9 22 9.44772 22 10V23.5L17.5455 20H9C8.44772 20 8 19.5523 8 19V18ZM5.45455 16L1 19.5V4C1 3.44772 1.44772 3 2 3H17C17.5523 3 18 3.44772 18 4V16H5.45455Z"
  }));
},
    WM = function WM(_ref1603) {
  var _ref1603$color = _ref1603.color,
      C = _ref1603$color === void 0 ? "currentColor" : _ref1603$color,
      _ref1603$size = _ref1603.size,
      e = _ref1603$size === void 0 ? 24 : _ref1603$size,
      l = _ref1603.className,
      i = _objectWithoutProperties(_ref1603, _excluded1603);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5.45455 15L1 18.5V3C1 2.44772 1.44772 2 2 2H17C17.5523 2 18 2.44772 18 3V15H5.45455ZM4.76282 13H16V4H3V14.3851L4.76282 13ZM8 17H18.2372L20 18.3851V8H21C21.5523 8 22 8.44772 22 9V22.5L17.5455 19H9C8.44772 19 8 18.5523 8 18V17Z"
  }));
},
    OM = function OM(_ref1604) {
  var _ref1604$color = _ref1604.color,
      C = _ref1604$color === void 0 ? "currentColor" : _ref1604$color,
      _ref1604$size = _ref1604.size,
      e = _ref1604$size === void 0 ? 24 : _ref1604$size,
      l = _ref1604.className,
      i = _objectWithoutProperties(_ref1604, _excluded1604);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM11 15V17H13V15H11ZM13 13.3551C14.4457 12.9248 15.5 11.5855 15.5 10C15.5 8.067 13.933 6.5 12 6.5C10.302 6.5 8.88637 7.70919 8.56731 9.31346L10.5288 9.70577C10.6656 9.01823 11.2723 8.5 12 8.5C12.8284 8.5 13.5 9.17157 13.5 10C13.5 10.8284 12.8284 11.5 12 11.5C11.4477 11.5 11 11.9477 11 12.5V14H13V13.3551Z"
  }));
},
    KM = function KM(_ref1605) {
  var _ref1605$color = _ref1605.color,
      C = _ref1605$color === void 0 ? "currentColor" : _ref1605$color,
      _ref1605$size = _ref1605.size,
      e = _ref1605$size === void 0 ? 24 : _ref1605$size,
      l = _ref1605.className,
      i = _objectWithoutProperties(_ref1605, _excluded1605);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM11 15H13V17H11V15ZM13 13.3551V14H11V12.5C11 11.9477 11.4477 11.5 12 11.5C12.8284 11.5 13.5 10.8284 13.5 10C13.5 9.17157 12.8284 8.5 12 8.5C11.2723 8.5 10.6656 9.01823 10.5288 9.70577L8.56731 9.31346C8.88637 7.70919 10.302 6.5 12 6.5C13.933 6.5 15.5 8.067 15.5 10C15.5 11.5855 14.4457 12.9248 13 13.3551Z"
  }));
},
    QM = function QM(_ref1606) {
  var _ref1606$color = _ref1606.color,
      C = _ref1606$color === void 0 ? "currentColor" : _ref1606$color,
      _ref1606$size = _ref1606.size,
      e = _ref1606$size === void 0 ? 24 : _ref1606$size,
      l = _ref1606.className,
      i = _objectWithoutProperties(_ref1606, _excluded1606);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 19C12.8284 19 13.5 19.6716 13.5 20.5C13.5 21.3284 12.8284 22 12 22C11.1716 22 10.5 21.3284 10.5 20.5C10.5 19.6716 11.1716 19 12 19ZM12 2C15.3137 2 18 4.68629 18 8C18 10.1646 17.2474 11.2907 15.3259 12.9231C13.3986 14.5604 13 15.2969 13 17H11C11 14.526 11.787 13.3052 14.031 11.3989C15.5479 10.1102 16 9.43374 16 8C16 5.79086 14.2091 4 12 4C9.79086 4 8 5.79086 8 8V9H6V8C6 4.68629 8.68629 2 12 2Z"
  }));
},
    qM = function qM(_ref1607) {
  var _ref1607$color = _ref1607.color,
      C = _ref1607$color === void 0 ? "currentColor" : _ref1607$color,
      _ref1607$size = _ref1607.size,
      e = _ref1607$size === void 0 ? 24 : _ref1607$size,
      l = _ref1607.className,
      i = _objectWithoutProperties(_ref1607, _excluded1607);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.45455 19L2 22.5V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.45455ZM11 14V16H13V14H11ZM8.56731 8.81346L10.5288 9.20577C10.6656 8.51823 11.2723 8 12 8C12.8284 8 13.5 8.67157 13.5 9.5C13.5 10.3284 12.8284 11 12 11H11V13H12C13.933 13 15.5 11.433 15.5 9.5C15.5 7.567 13.933 6 12 6C10.302 6 8.88637 7.20919 8.56731 8.81346Z"
  }));
},
    jM = function jM(_ref1608) {
  var _ref1608$color = _ref1608.color,
      C = _ref1608$color === void 0 ? "currentColor" : _ref1608$color,
      _ref1608$size = _ref1608.size,
      e = _ref1608$size === void 0 ? 24 : _ref1608$size,
      l = _ref1608.className,
      i = _objectWithoutProperties(_ref1608, _excluded1608);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5.76282 17H20V5H4V18.3851L5.76282 17ZM6.45455 19L2 22.5V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.45455ZM11 14H13V16H11V14ZM8.56731 8.81346C8.88637 7.20919 10.302 6 12 6C13.933 6 15.5 7.567 15.5 9.5C15.5 11.433 13.933 13 12 13H11V11H12C12.8284 11 13.5 10.3284 13.5 9.5C13.5 8.67157 12.8284 8 12 8C11.2723 8 10.6656 8.51823 10.5288 9.20577L8.56731 8.81346Z"
  }));
},
    XM = function XM(_ref1609) {
  var _ref1609$color = _ref1609.color,
      C = _ref1609$color === void 0 ? "currentColor" : _ref1609$color,
      _ref1609$size = _ref1609.size,
      e = _ref1609$size === void 0 ? 24 : _ref1609$size,
      l = _ref1609.className,
      i = _objectWithoutProperties(_ref1609, _excluded1609);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 1.99669C6 1.99669 4 15.9967 3 21.9967C3.66667 21.9967 4.33275 21.9967 4.99824 21.9967C5.66421 18.6636 7.33146 16.8303 10 16.4967C14 15.9967 17 12.4967 18 9.49669L16.5 8.49669C16.8333 8.16336 17.1667 7.83002 17.5 7.49669C18.5 6.49669 19.5042 4.99669 21 1.99669Z"
  }));
},
    JM = function JM(_ref1610) {
  var _ref1610$color = _ref1610.color,
      C = _ref1610$color === void 0 ? "currentColor" : _ref1610$color,
      _ref1610$size = _ref1610.size,
      e = _ref1610$size === void 0 ? 24 : _ref1610$size,
      l = _ref1610.className,
      i = _objectWithoutProperties(_ref1610, _excluded1610);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.93912 14.0328C6.7072 14.6563 6.51032 15.2331 6.33421 15.8155C7.29345 15.1189 8.43544 14.6767 9.75193 14.5121C12.2652 14.198 14.4976 12.5385 15.6279 10.4537L14.1721 8.99888L15.5848 7.58417C15.9185 7.25004 16.2521 6.91614 16.5858 6.58248C17.0151 6.15312 17.5 5.35849 18.0129 4.2149C12.4197 5.08182 8.99484 8.50647 6.93912 14.0328ZM17 8.99739L18 9.99669C17 12.9967 14 15.9967 10 16.4967C7.33146 16.8303 5.66421 18.6636 4.99824 21.9967H3C4 15.9967 6 1.99669 21 1.99669C20.0009 4.99402 19.0018 6.99313 18.0027 7.99402C17.6662 8.33049 17.3331 8.66382 17 8.99739Z"
  }));
},
    YM = function YM(_ref1611) {
  var _ref1611$color = _ref1611.color,
      C = _ref1611$color === void 0 ? "currentColor" : _ref1611$color,
      _ref1611$size = _ref1611.size,
      e = _ref1611$size === void 0 ? 24 : _ref1611$size,
      l = _ref1611.className,
      i = _objectWithoutProperties(_ref1611, _excluded1611);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14.3685 4.39807L10.8842 10.433L12.6163 11.433L16.1006 5.39807C20.27 8.17002 22.4058 12.4771 20.6605 15.5C18.8003 18.7221 13.4717 18.8551 8.75027 16.1292C4.0289 13.4033 1.47976 8.72208 3.34002 5.50001C5.08527 2.47715 9.88324 2.17321 14.3685 4.39807ZM15.8842 1.77277L17.6163 2.77277L16.1163 5.37084L14.3842 4.37084L15.8842 1.77277ZM6.73233 20H17.0003V22H5.01761C4.94008 22.0014 4.86194 21.9938 4.78481 21.9768C4.77025 21.9735 4.7558 21.97 4.74147 21.9662C4.6589 21.944 4.57784 21.9108 4.50028 21.866C4.47106 21.8492 4.44301 21.831 4.41616 21.8118C4.30161 21.7292 4.20524 21.623 4.1342 21.5003C4.06328 21.3772 4.01939 21.2404 4.00518 21.0997C4.00446 21.0924 4.00381 21.085 4.00325 21.0777C3.98786 20.883 4.02924 20.6819 4.13425 20.5L6.38425 16.6029L8.1163 17.6029L6.73233 20Z"
  }));
},
    _M = function _M(_ref1612) {
  var _ref1612$color = _ref1612.color,
      C = _ref1612$color === void 0 ? "currentColor" : _ref1612$color,
      _ref1612$size = _ref1612.size,
      e = _ref1612$size === void 0 ? 24 : _ref1612$size,
      l = _ref1612.className,
      i = _objectWithoutProperties(_ref1612, _excluded1612);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.5065 3.62326L11.4835 5.39501C8.57378 4.51629 5.96968 4.94531 5.07207 6.50001C3.89477 8.53915 5.86239 12.1524 9.75027 14.3971C13.6382 16.6418 17.7512 16.5392 18.9285 14.5C19.8261 12.9453 18.8956 10.4756 16.6797 8.39501L17.7026 6.62326C20.7847 9.33196 22.1654 12.8934 20.6605 15.5C18.8003 18.7221 13.4717 18.8551 8.75027 16.1292C4.0289 13.4033 1.47976 8.72208 3.34002 5.50001C4.84492 2.89344 8.61964 2.30849 12.5065 3.62326ZM15.8842 1.77277L17.6163 2.77277L12.6163 11.433L10.8842 10.433L15.8842 1.77277ZM6.73233 20H17.0003V22H5.01761C4.94008 22.0014 4.86194 21.9938 4.78481 21.9768C4.77025 21.9735 4.7558 21.97 4.74147 21.9662C4.6589 21.944 4.57784 21.9108 4.50028 21.866C4.47106 21.8492 4.44301 21.831 4.41616 21.8118C4.30161 21.7292 4.20524 21.623 4.1342 21.5003C4.06328 21.3772 4.01939 21.2404 4.00518 21.0997C4.00446 21.0924 4.00381 21.085 4.00325 21.0777C3.98786 20.883 4.02924 20.6819 4.13425 20.5L6.38425 16.6029L8.1163 17.6029L6.73233 20Z"
  }));
},
    $M = function $M(_ref1613) {
  var _ref1613$color = _ref1613.color,
      C = _ref1613$color === void 0 ? "currentColor" : _ref1613$color,
      _ref1613$size = _ref1613.size,
      e = _ref1613$size === void 0 ? 24 : _ref1613$size,
      l = _ref1613.className,
      i = _objectWithoutProperties(_ref1613, _excluded1613);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6 3V1H8V3H21.0082C21.556 3 22 3.44495 22 3.9934V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5551 2 20.0066V3.9934C2 3.44476 2.45531 3 2.9918 3H6ZM9 15C10.6569 15 12 13.6569 12 12C12 10.3431 10.6569 9 9 9C7.34315 9 6 10.3431 6 12C6 13.6569 7.34315 15 9 15ZM14 9V11H18V9H14ZM14 13V15H18V13H14Z"
  }));
},
    eZ = function eZ(_ref1614) {
  var _ref1614$color = _ref1614.color,
      C = _ref1614$color === void 0 ? "currentColor" : _ref1614$color,
      _ref1614$size = _ref1614.size,
      e = _ref1614$size === void 0 ? 24 : _ref1614$size,
      l = _ref1614.className,
      i = _objectWithoutProperties(_ref1614, _excluded1614);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6 3V1H8V3H21.0082C21.556 3 22 3.44495 22 3.9934V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5551 2 20.0066V3.9934C2 3.44476 2.45531 3 2.9918 3H6ZM4 5V19H20V5H4ZM9 15C7.34315 15 6 13.6569 6 12C6 10.3431 7.34315 9 9 9C10.6569 9 12 10.3431 12 12C12 13.6569 10.6569 15 9 15ZM14 9H18V11H14V9ZM14 13H18V15H14V13Z"
  }));
},
    tZ = function tZ(_ref1615) {
  var _ref1615$color = _ref1615.color,
      C = _ref1615$color === void 0 ? "currentColor" : _ref1615$color,
      _ref1615$size = _ref1615.size,
      e = _ref1615$size === void 0 ? 24 : _ref1615$size,
      l = _ref1615.className,
      i = _objectWithoutProperties(_ref1615, _excluded1615);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z"
  }));
},
    CZ = function CZ(_ref1616) {
  var _ref1616$color = _ref1616.color,
      C = _ref1616$color === void 0 ? "currentColor" : _ref1616$color,
      _ref1616$size = _ref1616.size,
      e = _ref1616$size === void 0 ? 24 : _ref1616$size,
      l = _ref1616.className,
      i = _objectWithoutProperties(_ref1616, _excluded1616);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 17C9.23858 17 7 14.7614 7 12C7 9.23858 9.23858 7 12 7C14.7614 7 17 9.23858 17 12C17 14.7614 14.7614 17 12 17Z"
  }));
},
    lZ = function lZ(_ref1617) {
  var _ref1617$color = _ref1617.color,
      C = _ref1617$color === void 0 ? "currentColor" : _ref1617$color,
      _ref1617$size = _ref1617.size,
      e = _ref1617$size === void 0 ? 24 : _ref1617$size,
      l = _ref1617.className,
      i = _objectWithoutProperties(_ref1617, _excluded1617);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17 10H20V6H4V10H15V8H17V10ZM6 3V1H8V3H21.0082C21.556 3 22 3.44495 22 3.9934V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5551 2 20.0066V3.9934C2 3.44476 2.45531 3 2.9918 3H6ZM7 19C8.65685 19 10 17.6569 10 16C10 14.3431 8.65685 13 7 13C5.34315 13 4 14.3431 4 16C4 17.6569 5.34315 19 7 19Z"
  }));
},
    iZ = function iZ(_ref1618) {
  var _ref1618$color = _ref1618.color,
      C = _ref1618$color === void 0 ? "currentColor" : _ref1618$color,
      _ref1618$size = _ref1618.size,
      e = _ref1618$size === void 0 ? 24 : _ref1618$size,
      l = _ref1618.className,
      i = _objectWithoutProperties(_ref1618, _excluded1618);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17 10V8H15V10H5V6H19V10H17ZM6 3V1H8V3H21.0082C21.556 3 22 3.44495 22 3.9934V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5551 2 20.0066V3.9934C2 3.44476 2.45531 3 2.9918 3H6ZM4 5V19H20V5H4ZM8 18C6.34315 18 5 16.6569 5 15C5 13.3431 6.34315 12 8 12C9.65685 12 11 13.3431 11 15C11 16.6569 9.65685 18 8 18Z"
  }));
},
    sZ = function sZ(_ref1619) {
  var _ref1619$color = _ref1619.color,
      C = _ref1619$color === void 0 ? "currentColor" : _ref1619$color,
      _ref1619$size = _ref1619.size,
      e = _ref1619$size === void 0 ? 24 : _ref1619$size,
      l = _ref1619.className,
      i = _objectWithoutProperties(_ref1619, _excluded1619);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 4C18.0751 4 23 8.92487 23 15V20H20V15C20 10.6651 16.5522 7.13546 12.2492 7.00381L12 7C7.66509 7 4.13546 10.4478 4.00381 14.7508L4 15V20H1V15C1 8.92487 5.92487 4 12 4ZM12 8C15.866 8 19 11.134 19 15V20H16V15C16 12.8578 14.316 11.1089 12.1996 11.0049L12 11C9.8578 11 8.10892 12.684 8.0049 14.8004L8 15V20H5V15C5 11.134 8.13401 8 12 8ZM12 12C13.6569 12 15 13.3431 15 15V20H9V15C9 13.3431 10.3431 12 12 12Z"
  }));
},
    rZ = function rZ(_ref1620) {
  var _ref1620$color = _ref1620.color,
      C = _ref1620$color === void 0 ? "currentColor" : _ref1620$color,
      _ref1620$size = _ref1620.size,
      e = _ref1620$size === void 0 ? 24 : _ref1620$size,
      l = _ref1620.className,
      i = _objectWithoutProperties(_ref1620, _excluded1620);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 4C18.0751 4 23 8.92487 23 15V20H21V15C21 10.1182 17.1132 6.14421 12.2654 6.00384L12 6C7.1182 6 3.14421 9.88681 3.00384 14.7346L3 15V20H1V15C1 8.92487 5.92487 4 12 4ZM12 8C15.866 8 19 11.134 19 15V20H17V15C17 12.3112 14.8777 10.1182 12.2169 10.0046L12 10C9.31124 10 7.11818 12.1223 7.00462 14.7831L7 15V20H5V15C5 11.134 8.13401 8 12 8ZM12 12C13.6569 12 15 13.3431 15 15V20H13V15C13 14.4872 12.614 14.0645 12.1166 14.0067L12 14C11.4872 14 11.0645 14.386 11.0067 14.8834L11 15V20H9V15C9 13.3431 10.3431 12 12 12Z"
  }));
},
    cZ = function cZ(_ref1621) {
  var _ref1621$color = _ref1621.color,
      C = _ref1621$color === void 0 ? "currentColor" : _ref1621$color,
      _ref1621$size = _ref1621.size,
      e = _ref1621$size === void 0 ? 24 : _ref1621$size,
      l = _ref1621.className,
      i = _objectWithoutProperties(_ref1621, _excluded1621);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15.86 18L12.7071 14.8471C12.3166 14.4566 11.6834 14.4566 11.2929 14.8471L8.18137 17.9586C4.14765 17.5486 1 14.1419 1 10C1 5.58172 4.58172 2 9 2C11.9967 2 14.6086 3.64768 15.9791 6.08651C16.3109 6.02963 16.652 6 17 6C20.3137 6 23 8.68629 23 12C23 15.3137 20.3137 18 17 18H15.86ZM10.2322 18.7322L12 16.9645L13.7678 18.7322C14.7441 19.7085 14.7441 21.2915 13.7678 22.2678C12.7915 23.2441 11.2085 23.2441 10.2322 22.2678C9.25592 21.2915 9.25592 19.7085 10.2322 18.7322Z"
  }));
},
    oZ = function oZ(_ref1622) {
  var _ref1622$color = _ref1622.color,
      C = _ref1622$color === void 0 ? "currentColor" : _ref1622$color,
      _ref1622$size = _ref1622.size,
      e = _ref1622$size === void 0 ? 24 : _ref1622$size,
      l = _ref1622.className,
      i = _objectWithoutProperties(_ref1622, _excluded1622);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16 18V16H17C19.2091 16 21 14.2091 21 12C21 9.79086 19.2091 8 17 8C16.2057 8 15.4654 8.23153 14.8431 8.63079C14.2236 5.97685 11.8427 4 9 4C5.68629 4 3 6.68629 3 10C3 12.973 5.16229 15.441 8 15.917V17.9381C4.05369 17.446 1 14.0796 1 10C1 5.58172 4.58172 2 9 2C11.9967 2 14.6086 3.64768 15.9791 6.08651C16.3109 6.02963 16.652 6 17 6C20.3137 6 23 8.68629 23 12C23 15.3137 20.3137 18 17 18H16ZM10.2322 18.7322L12 16.9645L13.7678 18.7322C14.7441 19.7085 14.7441 21.2915 13.7678 22.2678C12.7915 23.2441 11.2085 23.2441 10.2322 22.2678C9.25592 21.2915 9.25592 19.7085 10.2322 18.7322Z"
  }));
},
    aZ = function aZ(_ref1623) {
  var _ref1623$color = _ref1623.color,
      C = _ref1623$color === void 0 ? "currentColor" : _ref1623$color,
      _ref1623$size = _ref1623.size,
      e = _ref1623$size === void 0 ? 24 : _ref1623$size,
      l = _ref1623.className,
      i = _objectWithoutProperties(_ref1623, _excluded1623);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14.448 16.2394C13.8809 17.0412 13.2933 17.7714 12.7015 18.4146C14.3738 20.0375 15.9291 20.7975 16.792 20.2993C17.6549 19.8011 17.7744 18.0742 17.2051 15.8145C16.3521 16.0054 15.426 16.1492 14.448 16.2394ZM13.138 16.3265C12.7641 16.342 12.3845 16.3499 12.0003 16.3499C11.6161 16.3499 11.2365 16.342 10.8627 16.3265C11.2394 16.8188 11.6208 17.2749 12.0003 17.6905C12.3798 17.2749 12.7612 16.8188 13.138 16.3265ZM18.1787 8.43278C20.8434 9.19718 22.5837 10.4672 22.5837 11.9999C22.5837 13.5325 20.8434 14.8026 18.1787 15.567C18.8491 18.2569 18.6193 20.399 17.292 21.1653C15.9647 21.9316 13.9947 21.0595 12.0003 19.134C10.006 21.0595 8.03596 21.9316 6.70866 21.1653C5.38136 20.399 5.15158 18.2569 5.82195 15.567C3.15724 14.8026 1.41699 13.5325 1.41699 11.9999C1.41699 10.4672 3.15724 9.19718 5.82195 8.43278C5.15158 5.74288 5.38136 3.60075 6.70866 2.83443C8.03596 2.06811 10.006 2.94019 12.0003 4.86569C13.9947 2.94019 15.9647 2.06811 17.292 2.83443C18.6193 3.60075 18.8491 5.74288 18.1787 8.43278ZM17.2051 8.18527C17.7744 5.92558 17.6549 4.19865 16.792 3.70046C15.9291 3.20226 14.3738 3.96221 12.7015 5.58509C13.2933 6.2283 13.8809 6.95849 14.448 7.76031C15.426 7.85054 16.3521 7.99432 17.2051 8.18527ZM6.79554 15.8145C6.22624 18.0742 6.34577 19.8011 7.20866 20.2993C8.07155 20.7975 9.62688 20.0375 11.2992 18.4146C10.7073 17.7714 10.1197 17.0412 9.55262 16.2394C8.57467 16.1492 7.6485 16.0054 6.79554 15.8145ZM10.8627 7.67324C11.2365 7.65776 11.6161 7.64987 12.0003 7.64987C12.3845 7.64987 12.7641 7.65776 13.138 7.67324C12.7612 7.18096 12.3798 6.7248 12.0003 6.30922C11.6208 6.7248 11.2394 7.18096 10.8627 7.67324ZM9.55262 7.76031C10.1197 6.95849 10.7073 6.2283 11.2992 5.58509C9.62688 3.96221 8.07155 3.20226 7.20866 3.70046C6.34577 4.19865 6.22624 5.92558 6.79554 8.18527C7.6485 7.99432 8.57467 7.85054 9.55262 7.76031ZM13.8939 15.2797C14.2395 14.7728 14.5772 14.2366 14.9015 13.6749C15.2258 13.1131 15.5213 12.5526 15.7875 11.9999C15.5213 11.4471 15.2258 10.8866 14.9015 10.3249C14.5772 9.76311 14.2395 9.22694 13.8939 8.72005C13.2821 8.6742 12.649 8.64987 12.0003 8.64987C11.3517 8.64987 10.7185 8.6742 10.1067 8.72005C9.76112 9.22694 9.42347 9.76311 9.09914 10.3249C8.77481 10.8866 8.4793 11.4471 8.21312 11.9999C8.4793 12.5526 8.77481 13.1131 9.09914 13.6749C9.42347 14.2366 9.76112 14.7728 10.1067 15.2797C10.7185 15.3255 11.3517 15.3499 12.0003 15.3499C12.649 15.3499 13.2821 15.3255 13.8939 15.2797ZM15.1785 15.1484C15.7932 15.0683 16.3789 14.9661 16.9286 14.8452C16.7584 14.3087 16.5541 13.7504 16.3161 13.178C16.1426 13.5095 15.9596 13.8421 15.7675 14.1749C15.5754 14.5076 15.3788 14.8324 15.1785 15.1484ZM8.82218 8.85133C8.20747 8.93147 7.62174 9.03367 7.07208 9.15454C7.24223 9.691 7.44659 10.2494 7.68454 10.8218C7.85806 10.4903 8.04101 10.1576 8.23311 9.82487C8.42522 9.49212 8.62185 9.16736 8.82218 8.85133ZM7.07208 14.8452C7.62174 14.9661 8.20747 15.0683 8.82218 15.1484C8.62185 14.8324 8.42522 14.5076 8.23311 14.1749C8.04101 13.8421 7.85806 13.5095 7.68454 13.178C7.44659 13.7504 7.24223 14.3087 7.07208 14.8452ZM6.09439 14.6C6.35551 13.7659 6.69407 12.8919 7.10491 11.9999C6.69407 11.1078 6.35551 10.2339 6.09439 9.39969C3.85279 10.0365 2.41699 11.0035 2.41699 11.9999C2.41699 12.9962 3.85279 13.9632 6.09439 14.6ZM16.9286 9.15454C16.3789 9.03367 15.7932 8.93147 15.1785 8.85133C15.3788 9.16736 15.5754 9.49212 15.7675 9.82487C15.9596 10.1576 16.1426 10.4903 16.3161 10.8218C16.5541 10.2494 16.7584 9.691 16.9286 9.15454ZM17.9063 9.39969C17.6451 10.2339 17.3066 11.1078 16.8957 11.9999C17.3066 12.8919 17.6451 13.7659 17.9063 14.6C20.1479 13.9632 21.5837 12.9962 21.5837 11.9999C21.5837 11.0035 20.1479 10.0365 17.9063 9.39969ZM12.0003 13.879C10.9625 13.879 10.1212 13.0377 10.1212 11.9999C10.1212 10.962 10.9625 10.1207 12.0003 10.1207C13.0382 10.1207 13.8795 10.962 13.8795 11.9999C13.8795 13.0377 13.0382 13.879 12.0003 13.879Z"
  }));
},
    nZ = function nZ(_ref1624) {
  var _ref1624$color = _ref1624.color,
      C = _ref1624$color === void 0 ? "currentColor" : _ref1624$color,
      _ref1624$size = _ref1624.size,
      e = _ref1624$size === void 0 ? 24 : _ref1624$size,
      l = _ref1624.className,
      i = _objectWithoutProperties(_ref1624, _excluded1624);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.001 13.5001C11.1725 13.5001 10.501 12.8285 10.501 12.0001C10.501 11.1716 11.1725 10.5001 12.001 10.5001C12.8294 10.5001 13.501 11.1716 13.501 12.0001C13.501 12.8285 12.8294 13.5001 12.001 13.5001ZM11.4733 16.4945C11.6479 16.705 11.8239 16.908 12.001 17.103C12.178 16.908 12.3541 16.705 12.5286 16.4945C12.3538 16.4982 12.1779 16.5001 12.001 16.5001C11.824 16.5001 11.6481 16.4982 11.4733 16.4945ZM9.47837 16.3694C8.6762 16.2846 7.91035 16.1603 7.19268 16.0016C7.11832 16.3512 7.06134 16.6904 7.02243 17.0166C6.83358 18.6 7.09805 19.5617 7.50098 19.7943C7.9039 20.0269 8.86893 19.7751 10.1458 18.8199C10.4088 18.6231 10.6741 18.4042 10.9397 18.1649C10.4434 17.6228 9.95287 17.0217 9.47837 16.3694ZM16.8093 16.0016C16.0916 16.1603 15.3257 16.2846 14.5236 16.3694C14.0491 17.0217 13.5585 17.6228 13.0622 18.1649C13.3279 18.4042 13.5931 18.6231 13.8562 18.8199C15.133 19.7751 16.0981 20.0269 16.501 19.7943C16.9039 19.5617 17.1684 18.6 16.9795 17.0166C16.9406 16.6904 16.8836 16.3512 16.8093 16.0016ZM18.2598 15.6136C18.8364 18.2526 18.5328 20.3533 17.251 21.0933C15.9691 21.8334 13.9981 21.046 12.001 19.2271C10.0038 21.046 8.03282 21.8334 6.75098 21.0933C5.46913 20.3533 5.16555 18.2526 5.74217 15.6136C3.16842 14.7935 1.50098 13.4802 1.50098 12.0001C1.50098 10.5199 3.16842 9.20668 5.74217 8.38654C5.16555 5.74754 5.46913 3.64687 6.75098 2.9068C8.03282 2.16673 10.0038 2.95415 12.001 4.77302C13.9981 2.95415 15.9691 2.16673 17.251 2.9068C18.5328 3.64687 18.8364 5.74754 18.2598 8.38654C20.8335 9.20668 22.501 10.5199 22.501 12.0001C22.501 13.4802 20.8335 14.7935 18.2598 15.6136ZM10.9397 5.83521C10.6741 5.59597 10.4088 5.37703 10.1458 5.18024C8.86893 4.22499 7.9039 3.97321 7.50098 4.20584C7.09805 4.43847 6.83358 5.4001 7.02243 6.9835C7.06134 7.30969 7.11832 7.6489 7.19268 7.99857C7.91035 7.83985 8.6762 7.71556 9.47837 7.63078C9.95287 6.97848 10.4434 6.37737 10.9397 5.83521ZM14.5236 7.63078C15.3257 7.71556 16.0916 7.83985 16.8093 7.99857C16.8836 7.6489 16.9406 7.30969 16.9795 6.9835C17.1684 5.4001 16.9039 4.43847 16.501 4.20584C16.0981 3.97321 15.133 4.22499 13.8562 5.18024C13.5931 5.37703 13.3279 5.59597 13.0622 5.83521C13.5585 6.37737 14.0491 6.97848 14.5236 7.63078ZM12.5286 7.50565C12.3541 7.29515 12.178 7.09211 12.001 6.89711C11.8239 7.09211 11.6479 7.29515 11.4733 7.50565C11.6481 7.50194 11.824 7.50007 12.001 7.50007C12.1779 7.50007 12.3538 7.50194 12.5286 7.50565ZM8.37252 14.7042C8.28191 14.5547 8.19233 14.4033 8.10386 14.2501C8.01539 14.0968 7.92906 13.9435 7.84488 13.7903C7.74985 14.0467 7.66205 14.3007 7.58169 14.5515C7.83908 14.6074 8.10295 14.6583 8.37252 14.7042ZM10.3049 14.9377C10.8579 14.9788 11.4251 15.0001 12.001 15.0001C12.5769 15.0001 13.144 14.9788 13.697 14.9377C14.0091 14.4793 14.3111 13.9988 14.5991 13.5001C14.887 13.0013 15.1522 12.4995 15.393 12.0001C15.1522 11.5006 14.887 10.9988 14.5991 10.5001C14.3111 10.0013 14.0091 9.52081 13.697 9.06246C13.144 9.02133 12.5769 9.00007 12.001 9.00007C11.4251 9.00007 10.8579 9.02133 10.3049 9.06246C9.99283 9.52081 9.69086 10.0013 9.4029 10.5001C9.11494 10.9988 8.8498 11.5006 8.60892 12.0001C8.8498 12.4995 9.11494 13.0013 9.4029 13.5001C9.69086 13.9988 9.99283 14.4793 10.3049 14.9377ZM16.1571 10.2098C16.2521 9.9534 16.3399 9.6994 16.4203 9.44859C16.1629 9.39278 15.899 9.34182 15.6294 9.29591C15.72 9.44543 15.8096 9.59683 15.8981 9.75007C15.9866 9.9033 16.0729 10.0566 16.1571 10.2098ZM6.13143 9.83671C5.79142 9.94714 5.46917 10.0674 5.16723 10.1968C3.70154 10.825 3.00098 11.5348 3.00098 12.0001C3.00098 12.4653 3.70154 13.1752 5.16723 13.8033C5.46917 13.9327 5.79142 14.053 6.13143 14.1634C6.35281 13.4625 6.6281 12.7371 6.95576 12.0001C6.6281 11.263 6.35281 10.5376 6.13143 9.83671ZM7.58169 9.44859C7.66205 9.6994 7.74985 9.9534 7.84488 10.2098C7.92906 10.0566 8.01539 9.9033 8.10386 9.75007C8.19233 9.59683 8.28191 9.44543 8.37252 9.29591C8.10295 9.34182 7.83908 9.39278 7.58169 9.44859ZM17.8705 14.1634C18.2105 14.053 18.5328 13.9327 18.8347 13.8033C20.3004 13.1752 21.001 12.4653 21.001 12.0001C21.001 11.5348 20.3004 10.825 18.8347 10.1968C18.5328 10.0674 18.2105 9.94714 17.8705 9.83671C17.6491 10.5376 17.3739 11.263 17.0462 12.0001C17.3739 12.7371 17.6491 13.4625 17.8705 14.1634ZM16.4203 14.5515C16.3399 14.3007 16.2521 14.0467 16.1571 13.7903C16.0729 13.9435 15.9866 14.0968 15.8981 14.2501C15.8096 14.4033 15.72 14.5547 15.6294 14.7042C15.899 14.6583 16.1629 14.6074 16.4203 14.5515Z"
  }));
},
    mZ = function mZ(_ref1625) {
  var _ref1625$color = _ref1625.color,
      C = _ref1625$color === void 0 ? "currentColor" : _ref1625$color,
      _ref1625$size = _ref1625.size,
      e = _ref1625$size === void 0 ? 24 : _ref1625$size,
      l = _ref1625.className,
      i = _objectWithoutProperties(_ref1625, _excluded1625);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
  }));
},
    wZ = function wZ(_ref1626) {
  var _ref1626$color = _ref1626.color,
      C = _ref1626$color === void 0 ? "currentColor" : _ref1626$color,
      _ref1626$size = _ref1626.size,
      e = _ref1626$size === void 0 ? 24 : _ref1626$size,
      l = _ref1626.className,
      i = _objectWithoutProperties(_ref1626, _excluded1626);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12C15 13.6569 13.6569 15 12 15Z"
  }));
},
    LZ = function LZ(_ref1627) {
  var _ref1627$color = _ref1627.color,
      C = _ref1627$color === void 0 ? "currentColor" : _ref1627$color,
      _ref1627$size = _ref1627.size,
      e = _ref1627$size === void 0 ? 24 : _ref1627$size,
      l = _ref1627.className,
      i = _objectWithoutProperties(_ref1627, _excluded1627);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9.74284 15H14.2572C13.4718 14.0491 13 12.8296 13 11.5C13 8.46243 15.4624 6 18.5 6C21.5376 6 24 8.46243 24 11.5C24 14.5376 21.5376 17 18.5 17H5.5C2.46243 17 0 14.5376 0 11.5C0 8.46243 2.46243 6 5.5 6C8.53757 6 11 8.46243 11 11.5C11 12.8296 10.5282 14.0491 9.74284 15ZM5.5 13C6.32843 13 7 12.3284 7 11.5C7 10.6716 6.32843 10 5.5 10C4.67157 10 4 10.6716 4 11.5C4 12.3284 4.67157 13 5.5 13ZM18.5 13C19.3284 13 20 12.3284 20 11.5C20 10.6716 19.3284 10 18.5 10C17.6716 10 17 10.6716 17 11.5C17 12.3284 17.6716 13 18.5 13Z"
  }));
},
    hZ = function hZ(_ref1628) {
  var _ref1628$color = _ref1628.color,
      C = _ref1628$color === void 0 ? "currentColor" : _ref1628$color,
      _ref1628$size = _ref1628.size,
      e = _ref1628$size === void 0 ? 24 : _ref1628$size,
      l = _ref1628.className,
      i = _objectWithoutProperties(_ref1628, _excluded1628);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14.2572 15C13.4718 14.0491 13 12.8296 13 11.5C13 8.46243 15.4624 6 18.5 6C21.5376 6 24 8.46243 24 11.5C24 14.5376 21.5376 17 18.5 17H5.5C2.46243 17 0 14.5376 0 11.5C0 8.46243 2.46243 6 5.5 6C8.53757 6 11 8.46243 11 11.5C11 12.8296 10.5282 14.0491 9.74284 15H14.2572ZM5.5 15C7.433 15 9 13.433 9 11.5C9 9.567 7.433 8 5.5 8C3.567 8 2 9.567 2 11.5C2 13.433 3.567 15 5.5 15ZM18.5 15C20.433 15 22 13.433 22 11.5C22 9.567 20.433 8 18.5 8C16.567 8 15 9.567 15 11.5C15 13.433 16.567 15 18.5 15Z"
  }));
},
    HZ = function HZ(_ref1629) {
  var _ref1629$color = _ref1629.color,
      C = _ref1629$color === void 0 ? "currentColor" : _ref1629$color,
      _ref1629$size = _ref1629.size,
      e = _ref1629$size === void 0 ? 24 : _ref1629$size,
      l = _ref1629.className,
      i = _objectWithoutProperties(_ref1629, _excluded1629);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19.5611 12.0985L21.0926 14.7501C22.0591 16.4241 21.4855 18.5647 19.8115 19.5312C19.2794 19.8384 18.6759 20.0001 18.0615 20.0001L15.9993 19.9995V22.0001L10.9993 18.5001L15.9993 15.0001V16.9995L18.0615 17.0001C18.1493 17.0001 18.2355 16.977 18.3115 16.9331C18.5241 16.8104 18.6124 16.5551 18.5325 16.332L18.4945 16.2501L16.9631 13.5985L19.5611 12.0985ZM7.73617 9.38407L8.26726 15.4642L6.53571 14.4645L5.50412 16.2501C5.46023 16.3261 5.43713 16.4123 5.43713 16.5001C5.43713 16.7456 5.614 16.9497 5.84725 16.992L5.93713 17.0001L8.99919 16.9997V19.9996L5.93713 20.0001C4.00413 20.0001 2.43713 18.4331 2.43713 16.5001C2.43713 15.8857 2.59885 15.2822 2.90604 14.7501L3.93763 12.9645L2.20508 11.9642L7.73617 9.38407ZM13.7493 2.96901C14.2814 3.2762 14.7232 3.71803 15.0304 4.2501L16.061 6.03629L17.7935 5.03599L17.2624 11.1161L11.7314 8.53599L13.4629 7.53629L12.4323 5.7501C12.3884 5.67409 12.3253 5.61097 12.2493 5.56708C12.0367 5.44435 11.7715 5.49546 11.6182 5.67629L11.5663 5.7501L10.0356 8.40209L7.4376 6.90216L8.96822 4.2501C9.93472 2.57607 12.0753 2.00251 13.7493 2.96901Z"
  }));
},
    VZ = function VZ(_ref1630) {
  var _ref1630$color = _ref1630.color,
      C = _ref1630$color === void 0 ? "currentColor" : _ref1630$color,
      _ref1630$size = _ref1630.size,
      e = _ref1630$size === void 0 ? 24 : _ref1630$size,
      l = _ref1630.className,
      i = _objectWithoutProperties(_ref1630, _excluded1630);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19.5605 12.0975L21.092 14.7501C22.0585 16.4241 21.4849 18.5647 19.8109 19.5312C19.2788 19.8384 18.6753 20.0001 18.0609 20.0001L15.9985 19.9995L15.9987 22.5001L10.9987 19.0001L15.9987 15.5001L15.9985 17.9995L18.0609 18.0001C18.3242 18.0001 18.5829 17.9308 18.8109 17.7991C19.5283 17.3849 19.7742 16.4675 19.3599 15.7501L17.8285 13.0975L19.5605 12.0975ZM7.30257 9.13407L7.83366 15.2142L5.66848 13.9635L4.63751 15.7501C4.50586 15.9781 4.43655 16.2368 4.43655 16.5001C4.43655 17.3285 5.10812 18.0001 5.93655 18.0001L8.99948 18.0002V20.0001H5.93655C4.00355 20.0001 2.43655 18.4331 2.43655 16.5001C2.43655 15.8857 2.59827 15.2822 2.90546 14.7501L3.93648 12.9635L1.77148 11.7142L7.30257 9.13407ZM13.7487 2.96901C14.2808 3.2762 14.7226 3.71803 15.0298 4.2501L16.0605 6.03551L18.226 4.78599L17.6949 10.8661L12.1638 8.28599L14.3285 7.03551L13.2978 5.2501C13.1661 5.02207 12.9768 4.83271 12.7487 4.70106C12.0313 4.28684 11.1139 4.53266 10.6997 5.2501L9.16818 7.90261L7.43615 6.90266L8.96764 4.2501C9.93414 2.57607 12.0747 2.00251 13.7487 2.96901Z"
  }));
},
    gZ = function gZ(_ref1631) {
  var _ref1631$color = _ref1631.color,
      C = _ref1631$color === void 0 ? "currentColor" : _ref1631$color,
      _ref1631$size = _ref1631.size,
      e = _ref1631$size === void 0 ? 24 : _ref1631$size,
      l = _ref1631.className,
      i = _objectWithoutProperties(_ref1631, _excluded1631);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21.0049 5.94028C19.2657 7.91075 16.8895 9.30566 14.1986 9.80276C13.7739 9.02805 12.9507 8.50281 12.0049 8.50281C11.0591 8.50281 10.2359 9.02805 9.8112 9.80276C7.12025 9.30566 4.74405 7.91075 3.00488 5.94028V3.00281C3.00488 2.45052 3.4526 2.00281 4.00488 2.00281H20.0049C20.5572 2.00281 21.0049 2.45052 21.0049 3.00281V5.94028ZM21.0049 8.72704V21.0028C21.0049 21.5551 20.5572 22.0028 20.0049 22.0028H4.00488C3.4526 22.0028 3.00488 21.5551 3.00488 21.0028V8.72704C4.86501 10.2897 7.13757 11.3774 9.63575 11.8032C9.96947 12.7914 10.9041 13.5028 12.0049 13.5028C13.1057 13.5028 14.0403 12.7914 14.374 11.8032C16.8722 11.3774 19.1448 10.2897 21.0049 8.72704Z"
  }));
},
    MZ = function MZ(_ref1632) {
  var _ref1632$color = _ref1632.color,
      C = _ref1632$color === void 0 ? "currentColor" : _ref1632$color,
      _ref1632$size = _ref1632.size,
      e = _ref1632$size === void 0 ? 24 : _ref1632$size,
      l = _ref1632.className,
      i = _objectWithoutProperties(_ref1632, _excluded1632);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14.178 9.76602C16.0334 9.35487 17.695 8.4283 19.0049 7.14424V4.00281H5.00488V7.14424C6.31472 8.4283 7.97632 9.35487 9.83175 9.76602C10.2621 9.01149 11.0741 8.50281 12.0049 8.50281C12.9357 8.50281 13.7477 9.01149 14.178 9.76602ZM14.3861 11.7666C14.0633 12.7737 13.1192 13.5028 12.0049 13.5028C10.8905 13.5028 9.94648 12.7737 9.6237 11.7666C7.92722 11.425 6.36024 10.7257 5.00488 9.75071V20.0028H19.0049V9.75071C17.6495 10.7257 16.0825 11.425 14.3861 11.7666ZM4.00488 2.00281H20.0049C20.5572 2.00281 21.0049 2.45052 21.0049 3.00281V21.0028C21.0049 21.5551 20.5572 22.0028 20.0049 22.0028H4.00488C3.4526 22.0028 3.00488 21.5551 3.00488 21.0028V3.00281C3.00488 2.45052 3.4526 2.00281 4.00488 2.00281Z"
  }));
},
    ZZ = function ZZ(_ref1633) {
  var _ref1633$color = _ref1633.color,
      C = _ref1633$color === void 0 ? "currentColor" : _ref1633$color,
      _ref1633$size = _ref1633.size,
      e = _ref1633$size === void 0 ? 24 : _ref1633$size,
      l = _ref1633.className,
      i = _objectWithoutProperties(_ref1633, _excluded1633);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.001 22C6.47813 22 2.00098 17.5228 2.00098 12C2.00098 6.47715 6.47813 2 12.001 2C17.5238 2 22.001 6.47715 22.001 12C22.001 17.5228 17.5238 22 12.001 22ZM18.671 12C18.65 11.425 18.2932 10.916 17.7598 10.7C17.2265 10.4841 16.6161 10.6016 16.201 11C15.0634 10.2267 13.7262 9.7995 12.351 9.77L13.001 6.65L15.141 7.1C15.1935 7.58851 15.5932 7.96647 16.0839 7.99172C16.5745 8.01696 17.0109 7.68201 17.1133 7.20147C17.2157 6.72094 16.9538 6.23719 16.4955 6.06019C16.0372 5.88318 15.5181 6.06536 15.271 6.49L12.821 6C12.74 5.98224 12.6554 5.99763 12.5858 6.04272C12.5163 6.08781 12.4678 6.15886 12.451 6.24L11.711 9.71C10.3189 9.73099 8.96325 10.1585 7.81098 10.94C7.38972 10.5436 6.77418 10.4333 6.2415 10.6588C5.70882 10.8842 5.35944 11.4028 5.35067 11.9812C5.3419 12.5595 5.67538 13.0885 6.20098 13.33C6.18972 13.4765 6.18972 13.6235 6.20098 13.77C6.20098 16.01 8.81098 17.83 12.031 17.83C15.251 17.83 17.861 16.01 17.861 13.77C17.8722 13.6235 17.8722 13.4765 17.861 13.33C18.3646 13.0797 18.6797 12.5623 18.671 12ZM8.67098 13C8.67098 12.4477 9.11869 12 9.67098 12C10.2233 12 10.671 12.4477 10.671 13C10.671 13.5523 10.2233 14 9.67098 14C9.40576 14 9.15141 13.8946 8.96387 13.7071C8.77633 13.5196 8.67098 13.2652 8.67098 13ZM14.481 15.75C13.7715 16.2847 12.8986 16.5568 12.011 16.52C11.1234 16.5568 10.2505 16.2847 9.54098 15.75C9.45288 15.6427 9.46057 15.486 9.55877 15.3878C9.65696 15.2896 9.81363 15.2819 9.92098 15.37C10.5222 15.811 11.2561 16.0333 12.001 16C12.7468 16.0406 13.4841 15.8254 14.091 15.39C14.1624 15.3203 14.2656 15.2941 14.3617 15.3211C14.4577 15.3482 14.5321 15.4244 14.5567 15.5211C14.5813 15.6178 14.5524 15.7203 14.481 15.79V15.75ZM14.301 14.04C13.7487 14.04 13.301 13.5923 13.301 13.04C13.301 12.4877 13.7487 12.04 14.301 12.04C14.8533 12.04 15.301 12.4877 15.301 13.04C15.312 13.3138 15.2101 13.5802 15.0192 13.7767C14.8282 13.9733 14.565 14.083 14.291 14.08L14.301 14.04Z"
  }));
},
    xZ = function xZ(_ref1634) {
  var _ref1634$color = _ref1634.color,
      C = _ref1634$color === void 0 ? "currentColor" : _ref1634$color,
      _ref1634$size = _ref1634.size,
      e = _ref1634$size === void 0 ? 24 : _ref1634$size,
      l = _ref1634.className,
      i = _objectWithoutProperties(_ref1634, _excluded1634);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11.0526 7.8154L11.8042 4.27941C12.0339 3.19898 13.0959 2.50929 14.1764 2.73894L17.3725 3.4183C17.8351 2.90546 18.5509 2.64644 19.275 2.80035C20.3554 3.03 21.0451 4.09204 20.8155 5.17247C20.5858 6.2529 19.5238 6.94259 18.4434 6.71294C17.7193 6.55903 17.1707 6.03124 16.9567 5.3746L13.7605 4.69523L13.0943 7.82978C14.8789 7.96683 16.6522 8.56079 18.2581 9.52961C19.0892 9.06763 20.0992 8.99337 21.007 9.36091C22.1731 9.833 22.9531 10.9459 22.9991 12.2031L22.9996 12.2241C23.0151 13.2277 22.559 14.1657 21.792 14.7742C21.7899 14.8178 21.7871 14.859 21.7836 14.8971C21.7836 18.8949 17.3341 21.9267 11.9852 21.9267C6.65232 21.9267 2.27693 18.9027 2.27987 14.9738C2.27523 14.9134 2.27162 14.853 2.26905 14.7926C1.46701 14.1873 0.984722 13.2277 1.00037 12.1962C1.01955 10.9317 1.78341 9.79777 2.94804 9.30491C3.85909 8.91936 4.881 8.98299 5.72371 9.44381C7.3578 8.46653 9.15777 7.91241 11.0526 7.8154ZM20.3385 13.341C20.7466 13.1382 21.003 12.7207 21.0001 12.2656C20.9789 11.8005 20.6887 11.3897 20.2565 11.2147C19.821 11.0384 19.3226 11.1343 18.9837 11.4597L18.3991 12.0207L17.729 11.5652C16.1137 10.4672 14.2771 9.8397 12.4995 9.80134L11.493 9.80123C9.61791 9.8295 7.84136 10.4002 6.25552 11.4757L5.59246 11.9254L5.00897 11.3764C4.66501 11.0528 4.16243 10.9627 3.7275 11.1468C3.29257 11.3308 3.0073 11.7543 3 12.2265C2.99298 12.6987 3.26526 13.1307 3.69441 13.3278L4.32738 13.6186L4.27399 14.3132C4.261 14.482 4.261 14.6516 4.27693 14.8971C4.27693 17.6071 7.63313 19.9267 11.9852 19.9267C16.3561 19.9267 19.7836 17.5913 19.7865 14.8205C19.7995 14.6516 19.7995 14.482 19.7865 14.3132L19.7348 13.6411L20.3385 13.341ZM6.95075 13.4999C6.95075 12.6715 7.62232 11.9999 8.45075 11.9999C9.27918 11.9999 9.95075 12.6715 9.95075 13.4999C9.95075 14.3283 9.27918 14.9999 8.45075 14.9999C8.05292 14.9999 7.67139 14.8419 7.39009 14.5606C7.10878 14.2793 6.95075 13.8977 6.95075 13.4999ZM13.9507 13.4999C13.9507 12.6715 14.6223 11.9999 15.4507 11.9999C16.2792 11.9999 16.9507 12.6715 16.9507 13.4999C16.9507 14.3283 16.2792 14.9999 15.4507 14.9999C15.0529 14.9999 14.6714 14.8419 14.3901 14.5606C14.1088 14.2793 13.9507 13.8977 13.9507 13.4999ZM11.9665 18.6028C10.5693 18.6028 9.19993 18.2329 8.08503 17.3928C7.94659 17.2241 7.95868 16.9779 8.11299 16.8236C8.2673 16.6693 8.51349 16.6572 8.68218 16.7956C9.62697 17.4886 10.805 17.7856 11.9507 17.7856C13.0965 17.7856 14.2813 17.5112 15.235 16.8271C15.3473 16.7176 15.5095 16.6763 15.6604 16.7188C15.8114 16.7613 15.9282 16.8811 15.9669 17.0331C16.0055 17.1851 15.9517 17.3346 15.8479 17.4556C15.1638 18.2531 13.3636 18.6028 11.9665 18.6028Z"
  }));
},
    vZ = function vZ(_ref1635) {
  var _ref1635$color = _ref1635.color,
      C = _ref1635$color === void 0 ? "currentColor" : _ref1635$color,
      _ref1635$size = _ref1635.size,
      e = _ref1635$size === void 0 ? 24 : _ref1635$size,
      l = _ref1635.className,
      i = _objectWithoutProperties(_ref1635, _excluded1635);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM16.8201 17.0761C18.1628 15.8007 19 13.9981 19 12C19 8.13401 15.866 5 12 5C10.9391 5 9.9334 5.23599 9.03241 5.65834L10.0072 7.41292C10.6177 7.14729 11.2917 7 12 7C14.7614 7 17 9.23858 17 12H14L16.8201 17.0761ZM14.9676 18.3417L13.9928 16.5871C13.3823 16.8527 12.7083 17 12 17C9.23858 17 7 14.7614 7 12H10L7.17993 6.92387C5.83719 8.19929 5 10.0019 5 12C5 15.866 8.13401 19 12 19C13.0609 19 14.0666 18.764 14.9676 18.3417Z"
  }));
},
    dZ = function dZ(_ref1636) {
  var _ref1636$color = _ref1636.color,
      C = _ref1636$color === void 0 ? "currentColor" : _ref1636$color,
      _ref1636$size = _ref1636.size,
      e = _ref1636$size === void 0 ? 24 : _ref1636$size,
      l = _ref1636.className,
      i = _objectWithoutProperties(_ref1636, _excluded1636);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5.46257 4.43262C7.21556 2.91688 9.5007 2 12 2C17.5228 2 22 6.47715 22 12C22 14.1361 21.3302 16.1158 20.1892 17.7406L17 12H20C20 7.58172 16.4183 4 12 4C9.84982 4 7.89777 4.84827 6.46023 6.22842L5.46257 4.43262ZM18.5374 19.5674C16.7844 21.0831 14.4993 22 12 22C6.47715 22 2 17.5228 2 12C2 9.86386 2.66979 7.88416 3.8108 6.25944L7 12H4C4 16.4183 7.58172 20 12 20C14.1502 20 16.1022 19.1517 17.5398 17.7716L18.5374 19.5674Z"
  }));
},
    pZ = function pZ(_ref1637) {
  var _ref1637$color = _ref1637.color,
      C = _ref1637$color === void 0 ? "currentColor" : _ref1637$color,
      _ref1637$size = _ref1637.size,
      e = _ref1637$size === void 0 ? 24 : _ref1637$size,
      l = _ref1637.className,
      i = _objectWithoutProperties(_ref1637, _excluded1637);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.0049 2C17.5277 2 22.0049 6.47715 22.0049 12C22.0049 17.5228 17.5277 22 12.0049 22C9.57847 22 7.3539 21.1358 5.62216 19.6985L5.37815 19.4892L6.27949 17.5875C7.73229 19.0759 9.76067 20 12.0049 20C16.4232 20 20.0049 16.4183 20.0049 12C20.0049 7.58172 16.4232 4 12.0049 4C7.66997 4 4.14034 7.44784 4.00869 11.7508L4.00488 12H6.50488L3.79854 17.7161C2.66796 16.096 2.00488 14.1254 2.00488 12C2.00488 6.47715 6.48204 2 12.0049 2ZM13.0049 6V8H15.5049V10H10.0049C9.72874 10 9.50488 10.2239 9.50488 10.5C9.50488 10.7455 9.68176 10.9496 9.91501 10.9919L10.0049 11H14.0049C15.3856 11 16.5049 12.1193 16.5049 13.5C16.5049 14.8807 15.3856 16 14.0049 16H13.0049V18H11.0049V16H8.50488V14H14.0049C14.281 14 14.5049 13.7761 14.5049 13.5C14.5049 13.2545 14.328 13.0504 14.0948 13.0081L14.0049 13H10.0049C8.62417 13 7.50488 11.8807 7.50488 10.5C7.50488 9.11929 8.62417 8 10.0049 8H11.0049V6H13.0049Z"
  }));
},
    EZ = function EZ(_ref1638) {
  var _ref1638$color = _ref1638.color,
      C = _ref1638$color === void 0 ? "currentColor" : _ref1638$color,
      _ref1638$size = _ref1638.size,
      e = _ref1638$size === void 0 ? 24 : _ref1638$size,
      l = _ref1638.className,
      i = _objectWithoutProperties(_ref1638, _excluded1638);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5.67591 4.25667C9.60392 1.03828 15.4094 1.26236 19.076 4.92893C22.9812 8.83418 22.9812 15.1658 19.076 19.0711C15.1707 22.9763 8.83906 22.9763 4.93382 19.0711C2.40932 16.5466 1.51676 13.0081 2.25611 9.76666L2.33275 9.45394L4.26718 9.96315C3.56967 12.623 4.26329 15.5721 6.34803 17.6569C9.47222 20.781 14.5375 20.781 17.6617 17.6569C20.7859 14.5327 20.7859 9.46734 17.6617 6.34315C14.8441 3.5255 10.4475 3.24903 7.32006 5.51375L7.09886 5.67983L8.1158 6.6967L3.5196 7.75736L4.58026 3.16117L5.67591 4.25667ZM13.0049 6V8H15.5049V10H10.0049C9.72874 10 9.50488 10.2239 9.50488 10.5C9.50488 10.7455 9.68176 10.9496 9.91501 10.9919L10.0049 11H14.0049C15.3856 11 16.5049 12.1193 16.5049 13.5C16.5049 14.8807 15.3856 16 14.0049 16H13.0049V18H11.0049V16H8.50488V14H14.0049C14.281 14 14.5049 13.7761 14.5049 13.5C14.5049 13.2545 14.328 13.0504 14.0948 13.0081L14.0049 13H10.0049C8.62417 13 7.50488 11.8807 7.50488 10.5C7.50488 9.11929 8.62417 8 10.0049 8H11.0049V6H13.0049Z"
  }));
},
    NZ = function NZ(_ref1639) {
  var _ref1639$color = _ref1639.color,
      C = _ref1639$color === void 0 ? "currentColor" : _ref1639$color,
      _ref1639$size = _ref1639.size,
      e = _ref1639$size === void 0 ? 24 : _ref1639$size,
      l = _ref1639.className,
      i = _objectWithoutProperties(_ref1639, _excluded1639);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22.0049 7H2.00488V4C2.00488 3.44772 2.4526 3 3.00488 3H21.0049C21.5572 3 22.0049 3.44772 22.0049 4V7ZM22.0049 9V20C22.0049 20.5523 21.5572 21 21.0049 21H3.00488C2.4526 21 2.00488 20.5523 2.00488 20V9H22.0049ZM11.0049 14V11.5L6.50488 16H17.0049V14H11.0049Z"
  }));
},
    uZ = function uZ(_ref1640) {
  var _ref1640$color = _ref1640.color,
      C = _ref1640$color === void 0 ? "currentColor" : _ref1640$color,
      _ref1640$size = _ref1640.size,
      e = _ref1640$size === void 0 ? 24 : _ref1640$size,
      l = _ref1640.className,
      i = _objectWithoutProperties(_ref1640, _excluded1640);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.0049 8V5H4.00488V8H20.0049ZM20.0049 10H4.00488V19H20.0049V10ZM3.00488 3H21.0049C21.5572 3 22.0049 3.44772 22.0049 4V20C22.0049 20.5523 21.5572 21 21.0049 21H3.00488C2.4526 21 2.00488 20.5523 2.00488 20V4C2.00488 3.44772 2.4526 3 3.00488 3ZM11.0049 14H17.0049V16H6.50488L11.0049 11.5V14Z"
  }));
},
    BZ = function BZ(_ref1641) {
  var _ref1641$color = _ref1641.color,
      C = _ref1641$color === void 0 ? "currentColor" : _ref1641$color,
      _ref1641$size = _ref1641.size,
      e = _ref1641$size === void 0 ? 24 : _ref1641$size,
      l = _ref1641.className,
      i = _objectWithoutProperties(_ref1641, _excluded1641);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12.5 7H8V17H10V14H12.217L14.397 17H16.869L14.3191 13.4907C15.327 12.8763 16 11.7668 16 10.5C16 8.63144 14.5357 7.10487 12.692 7.00518L12.5 7ZM12.5 9C13.2797 9 13.9204 9.59489 13.9931 10.3555L14 10.5L13.9931 10.6445C13.925 11.3576 13.3576 11.925 12.6445 11.9931L12.5 12H10V9H12.5Z"
  }));
},
    fZ = function fZ(_ref1642) {
  var _ref1642$color = _ref1642.color,
      C = _ref1642$color === void 0 ? "currentColor" : _ref1642$color,
      _ref1642$size = _ref1642.size,
      e = _ref1642$size === void 0 ? 24 : _ref1642$size,
      l = _ref1642.className,
      i = _objectWithoutProperties(_ref1642, _excluded1642);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM12.5 7C14.433 7 16 8.567 16 10.5C16 11.7668 15.327 12.8763 14.3191 13.4907L16.869 17H14.397L12.217 14H10V17H8V7H12.5ZM12.5 9H10V12H12.5C13.2797 12 13.9204 11.4051 13.9931 10.6445L14 10.5C14 9.67157 13.3284 9 12.5 9Z"
  }));
},
    RZ = function RZ(_ref1643) {
  var _ref1643$color = _ref1643.color,
      C = _ref1643$color === void 0 ? "currentColor" : _ref1643$color,
      _ref1643$size = _ref1643.size,
      e = _ref1643$size === void 0 ? 24 : _ref1643$size,
      l = _ref1643.className,
      i = _objectWithoutProperties(_ref1643, _excluded1643);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16.5301 17.5291L20.001 21H3.00098V4H13.6676V4.0078C13.7781 4.00262 13.8892 4 14.001 4C14.0464 4 14.0918 4.00043 14.137 4.0013C14.048 4.37162 14.001 4.76172 14.001 5.16667C14.001 7.48528 16.0157 9.5 18.6676 9.5C19.3921 9.5 20.0868 9.30333 20.6997 8.96217C20.8956 9.60697 21.001 10.2912 21.001 11C21.001 13.9742 19.1461 16.5151 16.5301 17.5291ZM18.501 7.5C17.1203 7.5 16.001 6.38071 16.001 5C16.001 3.61929 17.1203 2.5 18.501 2.5C19.8817 2.5 21.001 3.61929 21.001 5C21.001 6.38071 19.8817 7.5 18.501 7.5Z"
  }));
},
    zZ = function zZ(_ref1644) {
  var _ref1644$color = _ref1644.color,
      C = _ref1644$color === void 0 ? "currentColor" : _ref1644$color,
      _ref1644$size = _ref1644.size,
      e = _ref1644$size === void 0 ? 24 : _ref1644$size,
      l = _ref1644.className,
      i = _objectWithoutProperties(_ref1644, _excluded1644);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.36461 6L15.1491 15.6629L15.8699 15.38C17.5538 14.719 18.7326 13.2237 18.9607 11.4839C18.8083 11.4946 18.655 11.5 18.501 11.5C15.2512 11.5 12.5584 9.11509 12.0774 6H6.36461ZM14.001 5C14.001 7.48528 16.0157 9.5 18.501 9.5C19.306 9.5 20.0617 9.28861 20.7155 8.91831C20.9013 9.53558 21.001 10.1891 21.001 10.8654C21.001 13.7561 19.1794 16.2295 16.6006 17.2417L20.001 21H3.00098V4H14.001C14.0381 4 14.0753 4.00028 14.1123 4.00085C14.0394 4.3222 14.001 4.65661 14.001 5ZM18.501 7.5C17.1203 7.5 16.001 6.38071 16.001 5C16.001 3.61929 17.1203 2.5 18.501 2.5C19.8817 2.5 21.001 3.61929 21.001 5C21.001 6.38071 19.8817 7.5 18.501 7.5ZM5.00098 7.47V19H15.481L5.00098 7.47Z"
  }));
},
    FZ = function FZ(_ref1645) {
  var _ref1645$color = _ref1645.color,
      C = _ref1645$color === void 0 ? "currentColor" : _ref1645$color,
      _ref1645$size = _ref1645.size,
      e = _ref1645$size === void 0 ? 24 : _ref1645$size,
      l = _ref1645.className,
      i = _objectWithoutProperties(_ref1645, _excluded1645);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18 2C18.5523 2 19 2.44772 19 3V21C19 21.5523 18.5523 22 18 22H6C5.44772 22 5 21.5523 5 21V3C5 2.44772 5.44772 2 6 2H18ZM15 15H13V17H15V15ZM11 15H9V17H11V15ZM13 6H11V8H9V10H10.999L11 12H13L12.999 10H15V8H13V6Z"
  }));
},
    SZ = function SZ(_ref1646) {
  var _ref1646$color = _ref1646.color,
      C = _ref1646$color === void 0 ? "currentColor" : _ref1646$color,
      _ref1646$size = _ref1646.size,
      e = _ref1646$size === void 0 ? 24 : _ref1646$size,
      l = _ref1646.className,
      i = _objectWithoutProperties(_ref1646, _excluded1646);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18 2C18.5523 2 19 2.44772 19 3V21C19 21.5523 18.5523 22 18 22H6C5.44772 22 5 21.5523 5 21V3C5 2.44772 5.44772 2 6 2H18ZM17 4H7V20H17V4ZM15 15V17H13V15H15ZM11 15V17H9V15H11ZM13 6V8H15V10H12.999L13 12H11L10.999 10H9V8H11V6H13Z"
  }));
},
    AZ = function AZ(_ref1647) {
  var _ref1647$color = _ref1647.color,
      C = _ref1647$color === void 0 ? "currentColor" : _ref1647$color,
      _ref1647$size = _ref1647.size,
      e = _ref1647$size === void 0 ? 24 : _ref1647$size,
      l = _ref1647.className,
      i = _objectWithoutProperties(_ref1647, _excluded1647);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17.0001 12C17.5524 12 18.0001 12.4477 18.0001 13V22H6.00015V13C6.00015 12.4477 6.44786 12 7.00015 12H17.0001ZM10.0001 14H8.00015V16H10.0001V14ZM12.0001 6C14.3491 6 16.3827 7.34978 17.3678 9.31602L15.5787 10.2108C14.922 8.89991 13.5662 8 12.0001 8C10.4341 8 9.07833 8.89991 8.42163 10.2108L6.63247 9.31602C7.61755 7.34978 9.65122 6 12.0001 6ZM12.0001 2C15.9153 2 19.3049 4.24991 20.9466 7.5273L19.1576 8.42242C17.8443 5.80019 15.1325 4 12.0001 4C8.86783 4 6.15596 5.80019 4.84271 8.42242L3.05371 7.5273C4.69541 4.24991 8.08503 2 12.0001 2Z"
  }));
},
    kZ = function kZ(_ref1648) {
  var _ref1648$color = _ref1648.color,
      C = _ref1648$color === void 0 ? "currentColor" : _ref1648$color,
      _ref1648$size = _ref1648.size,
      e = _ref1648$size === void 0 ? 24 : _ref1648$size,
      l = _ref1648.className,
      i = _objectWithoutProperties(_ref1648, _excluded1648);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17.0001 12C17.5524 12 18.0001 12.4477 18.0001 13V22H16.0001V14H8.00015V22H6.00015V13C6.00015 12.4477 6.44786 12 7.00015 12H17.0001ZM12.0001 16V18H10.0001V16H12.0001ZM12.0001 6C14.3491 6 16.3827 7.34978 17.3678 9.31602L15.5787 10.2108C14.922 8.89991 13.5662 8 12.0001 8C10.4341 8 9.07833 8.89991 8.42163 10.2108L6.63247 9.31602C7.61755 7.34978 9.65122 6 12.0001 6ZM12.0001 2C15.9153 2 19.3049 4.24991 20.9466 7.5273L19.1576 8.42242C17.8443 5.80019 15.1325 4 12.0001 4C8.86783 4 6.15596 5.80019 4.84271 8.42242L3.05371 7.5273C4.69541 4.24991 8.08503 2 12.0001 2Z"
  }));
},
    PZ = function PZ(_ref1649) {
  var _ref1649$color = _ref1649.color,
      C = _ref1649$color === void 0 ? "currentColor" : _ref1649$color,
      _ref1649$size = _ref1649.size,
      e = _ref1649$size === void 0 ? 24 : _ref1649$size,
      l = _ref1649.className,
      i = _objectWithoutProperties(_ref1649, _excluded1649);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8 20V21.9325C8 22.2086 7.77614 22.4325 7.5 22.4325C7.38303 22.4325 7.26977 22.3915 7.17991 22.3166L3.06093 18.8841C2.84879 18.7073 2.82013 18.392 2.99691 18.1799C3.09191 18.0659 3.23264 18 3.38103 18L18 18C19.1046 18 20 17.1046 20 16V8H22V16C22 18.2091 20.2091 20 18 20H8ZM16 4V2.0675C16 1.79136 16.2239 1.5675 16.5 1.5675C16.617 1.5675 16.7302 1.60851 16.8201 1.68339L20.9391 5.11587C21.1512 5.29266 21.1799 5.60794 21.0031 5.82008C20.9081 5.93407 20.7674 5.99998 20.619 5.99998L6 6C4.89543 6 4 6.89543 4 8V16H2V8C2 5.79086 3.79086 4 6 4H16Z"
  }));
},
    DZ = function DZ(_ref1650) {
  var _ref1650$color = _ref1650.color,
      C = _ref1650$color === void 0 ? "currentColor" : _ref1650$color,
      _ref1650$size = _ref1650.size,
      e = _ref1650$size === void 0 ? 24 : _ref1650$size,
      l = _ref1650.className,
      i = _objectWithoutProperties(_ref1650, _excluded1650);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8 20V21.9324C8 22.2086 7.77614 22.4324 7.5 22.4324C7.38303 22.4324 7.26977 22.3914 7.17991 22.3165L3.06093 18.8841C2.84879 18.7073 2.82013 18.392 2.99691 18.1799C3.09191 18.0659 3.23264 18 3.38103 18L18 18C19.1046 18 20 17.1045 20 16V7.99997H22V16C22 18.2091 20.2091 20 18 20H8ZM16 3.99997V2.0675C16 1.79136 16.2239 1.5675 16.5 1.5675C16.617 1.5675 16.7302 1.60851 16.8201 1.68339L20.9391 5.11587C21.1512 5.29266 21.1799 5.60794 21.0031 5.82008C20.9081 5.93407 20.7674 5.99998 20.619 5.99998L6 5.99997C4.89543 5.99997 4 6.8954 4 7.99997V16H2V7.99997C2 5.79083 3.79086 3.99997 6 3.99997H16Z"
  }));
},
    yZ = function yZ(_ref1651) {
  var _ref1651$color = _ref1651.color,
      C = _ref1651$color === void 0 ? "currentColor" : _ref1651$color,
      _ref1651$size = _ref1651.size,
      e = _ref1651$size === void 0 ? 24 : _ref1651$size,
      l = _ref1651.className,
      i = _objectWithoutProperties(_ref1651, _excluded1651);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6 4H21C21.5523 4 22 4.44772 22 5V12H20V6H6V9L1 5L6 1V4ZM18 20H3C2.44772 20 2 19.5523 2 19V12H4V18H18V15L23 19L18 23V20Z"
  }));
},
    bZ = function bZ(_ref1652) {
  var _ref1652$color = _ref1652.color,
      C = _ref1652$color === void 0 ? "currentColor" : _ref1652$color,
      _ref1652$size = _ref1652.size,
      e = _ref1652$size === void 0 ? 24 : _ref1652$size,
      l = _ref1652.className,
      i = _objectWithoutProperties(_ref1652, _excluded1652);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6 4H21C21.5523 4 22 4.44772 22 5V12H20V6H6V9L1 5L6 1V4ZM18 20H3C2.44772 20 2 19.5523 2 19V12H4V18H18V15L23 19L18 23V20Z"
  }));
},
    TZ = function TZ(_ref1653) {
  var _ref1653$color = _ref1653.color,
      C = _ref1653$color === void 0 ? "currentColor" : _ref1653$color,
      _ref1653$size = _ref1653.size,
      e = _ref1653$size === void 0 ? 24 : _ref1653$size,
      l = _ref1653.className,
      i = _objectWithoutProperties(_ref1653, _excluded1653);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8 20V21.9325C8 22.2086 7.77614 22.4325 7.5 22.4325C7.38303 22.4325 7.26977 22.3915 7.17991 22.3166L3.06093 18.8841C2.84879 18.7073 2.82013 18.392 2.99691 18.1799C3.09191 18.0659 3.23264 18 3.38103 18H8L18 18C19.1046 18 20 17.1046 20 16V8H22V16C22 18.2091 20.2091 20 18 20H8ZM16 4V2.0675C16 1.79136 16.2239 1.5675 16.5 1.5675C16.617 1.5675 16.7302 1.60851 16.8201 1.68339L20.9391 5.11587C21.1512 5.29266 21.1799 5.60794 21.0031 5.82008C20.9081 5.93407 20.7674 5.99998 20.619 5.99998H16L6 6C4.89543 6 4 6.89543 4 8V16H2V8C2 5.79086 3.79086 4 6 4H16ZM11 8H13V16H11V10H9V9L11 8Z"
  }));
},
    UZ = function UZ(_ref1654) {
  var _ref1654$color = _ref1654.color,
      C = _ref1654$color === void 0 ? "currentColor" : _ref1654$color,
      _ref1654$size = _ref1654.size,
      e = _ref1654$size === void 0 ? 24 : _ref1654$size,
      l = _ref1654.className,
      i = _objectWithoutProperties(_ref1654, _excluded1654);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8 20V21.9325C8 22.2086 7.77614 22.4325 7.5 22.4325C7.38303 22.4325 7.26977 22.3915 7.17991 22.3166L3.06093 18.8841C2.84879 18.7073 2.82013 18.392 2.99691 18.1799C3.09191 18.0659 3.23264 18 3.38103 18L18 18C19.1046 18 20 17.1046 20 16V8H22V16C22 18.2091 20.2091 20 18 20H8ZM16 2.0675C16 1.79136 16.2239 1.5675 16.5 1.5675C16.617 1.5675 16.7302 1.60851 16.8201 1.68339L20.9391 5.11587C21.1512 5.29266 21.1799 5.60794 21.0031 5.82008C20.9081 5.93407 20.7674 5.99998 20.619 5.99998L6 6C4.89543 6 4 6.89543 4 8V16H2V8C2 5.79086 3.79086 4 6 4H16V2.0675ZM11 8H13V16H11V10H9V9L11 8Z"
  }));
},
    GZ = function GZ(_ref1655) {
  var _ref1655$color = _ref1655.color,
      C = _ref1655$color === void 0 ? "currentColor" : _ref1655$color,
      _ref1655$size = _ref1655.size,
      e = _ref1655$size === void 0 ? 24 : _ref1655$size,
      l = _ref1655.className,
      i = _objectWithoutProperties(_ref1655, _excluded1655);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14 4.5V9C19.5228 9 24 13.4772 24 19C24 19.2727 23.9891 19.5428 23.9677 19.81C22.5055 17.0364 19.6381 15.119 16.313 15.0053L16 15H13.9999L14 19.5L6 12L14 4.5ZM8 4.5V7.237L2.92 12L7.999 16.761L8 19.5L0 12L8 4.5Z"
  }));
},
    IZ = function IZ(_ref1656) {
  var _ref1656$color = _ref1656.color,
      C = _ref1656$color === void 0 ? "currentColor" : _ref1656$color,
      _ref1656$size = _ref1656.size,
      e = _ref1656$size === void 0 ? 24 : _ref1656$size,
      l = _ref1656.className,
      i = _objectWithoutProperties(_ref1656, _excluded1656);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14 4.5V9C19.5228 9 24 13.4772 24 19C24 19.2727 23.9891 19.5428 23.9677 19.81C22.5055 17.0364 19.6381 15.119 16.313 15.0053L16 15H13.9999L14 19.5L6 12L14 4.5ZM8 4.5V7.237L2.92 12L7.999 16.761L8 19.5L0 12L8 4.5ZM12 9.11646L8.92423 12L11.9999 14.8834L11.9999 13L16.0341 13.0003L16.3814 13.0065C17.6657 13.0504 18.9053 13.3165 20.0568 13.7734C18.5898 12.0749 16.4204 11 14 11H12V9.11646Z"
  }));
},
    WZ = function WZ(_ref1657) {
  var _ref1657$color = _ref1657.color,
      C = _ref1657$color === void 0 ? "currentColor" : _ref1657$color,
      _ref1657$size = _ref1657.size,
      e = _ref1657$size === void 0 ? 24 : _ref1657$size,
      l = _ref1657.className,
      i = _objectWithoutProperties(_ref1657, _excluded1657);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11 20L1 12L11 4V9C16.5228 9 21 13.4772 21 19C21 19.2729 20.9891 19.5433 20.9676 19.8107C19.4605 16.9502 16.458 15 13 15H11V20Z"
  }));
},
    OZ = function OZ(_ref1658) {
  var _ref1658$color = _ref1658.color,
      C = _ref1658$color === void 0 ? "currentColor" : _ref1658$color,
      _ref1658$size = _ref1658.size,
      e = _ref1658$size === void 0 ? 24 : _ref1658$size,
      l = _ref1658.className,
      i = _objectWithoutProperties(_ref1658, _excluded1658);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11 20L1 12L11 4V9C16.5228 9 21 13.4772 21 19C21 19.2727 20.9891 19.5428 20.9677 19.81C19.5055 17.0364 16.6381 15.119 13.313 15.0053L13 15H10.9999L11 20ZM8.99986 13H10.9999L13.0341 13.0003L13.3814 13.0065C14.6657 13.0504 15.9053 13.3165 17.0568 13.7734C15.5898 12.0749 13.4204 11 11 11H9V8.16125L4.20156 12L8.99992 15.8387L8.99986 13Z"
  }));
},
    KZ = function KZ(_ref1659) {
  var _ref1659$color = _ref1659.color,
      C = _ref1659$color === void 0 ? "currentColor" : _ref1659$color,
      _ref1659$size = _ref1659.size,
      e = _ref1659$size === void 0 ? 24 : _ref1659$size,
      l = _ref1659.className,
      i = _objectWithoutProperties(_ref1659, _excluded1659);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13 15V19H16V21H8V19H11V15H4C3.44772 15 3 14.5523 3 14V4C3 3.44772 3.44772 3 4 3H20C20.5523 3 21 3.44772 21 4V14C21 14.5523 20.5523 15 20 15H13ZM8 8V10H16V8H8Z"
  }));
},
    QZ = function QZ(_ref1660) {
  var _ref1660$color = _ref1660.color,
      C = _ref1660$color === void 0 ? "currentColor" : _ref1660$color,
      _ref1660$size = _ref1660.size,
      e = _ref1660$size === void 0 ? 24 : _ref1660$size,
      l = _ref1660.className,
      i = _objectWithoutProperties(_ref1660, _excluded1660);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13 15V19H16V21H8V19H11V15H4C3.44772 15 3 14.5523 3 14V4C3 3.44772 3.44772 3 4 3H20C20.5523 3 21 3.44772 21 4V14C21 14.5523 20.5523 15 20 15H13ZM5 13H19V5H5V13ZM8 8H16V10H8V8Z"
  }));
},
    qZ = function qZ(_ref1661) {
  var _ref1661$color = _ref1661.color,
      C = _ref1661$color === void 0 ? "currentColor" : _ref1661$color,
      _ref1661$size = _ref1661.size,
      e = _ref1661$size === void 0 ? 24 : _ref1661$size,
      l = _ref1661.className,
      i = _objectWithoutProperties(_ref1661, _excluded1661);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11 6V14H19C19 18.4183 15.4183 22 11 22C6.58172 22 3 18.4183 3 14C3 9.66509 6.58 6 11 6ZM21 2V4L15.6726 10H21V12H13V10L18.3256 4H13V2H21Z"
  }));
},
    jZ = function jZ(_ref1662) {
  var _ref1662$color = _ref1662.color,
      C = _ref1662$color === void 0 ? "currentColor" : _ref1662$color,
      _ref1662$size = _ref1662.size,
      e = _ref1662$size === void 0 ? 24 : _ref1662$size,
      l = _ref1662.className,
      i = _objectWithoutProperties(_ref1662, _excluded1662);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11 6V8C7.68629 8 5 10.6863 5 14C5 17.3137 7.68629 20 11 20C14.2384 20 16.8776 17.4344 16.9959 14.2249L17 14H19C19 18.4183 15.4183 22 11 22C6.58172 22 3 18.4183 3 14C3 9.66509 6.58 6 11 6ZM21 2V4L15.6726 10H21V12H13V10L18.3256 4H13V2H21Z"
  }));
},
    XZ = function XZ(_ref1663) {
  var _ref1663$color = _ref1663.color,
      C = _ref1663$color === void 0 ? "currentColor" : _ref1663$color,
      _ref1663$size = _ref1663.size,
      e = _ref1663$size === void 0 ? 24 : _ref1663$size,
      l = _ref1663.className,
      i = _objectWithoutProperties(_ref1663, _excluded1663);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM16.8201 17.0761C18.1628 15.8007 19 13.9981 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C13.0609 19 14.0666 18.764 14.9676 18.3417L13.9928 16.5871C13.3823 16.8527 12.7083 17 12 17C9.23858 17 7 14.7614 7 12C7 9.23858 9.23858 7 12 7C14.7614 7 17 9.23858 17 12H14L16.8201 17.0761Z"
  }));
},
    JZ = function JZ(_ref1664) {
  var _ref1664$color = _ref1664.color,
      C = _ref1664$color === void 0 ? "currentColor" : _ref1664$color,
      _ref1664$size = _ref1664.size,
      e = _ref1664$size === void 0 ? 24 : _ref1664$size,
      l = _ref1664.className,
      i = _objectWithoutProperties(_ref1664, _excluded1664);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18.5374 19.5674C16.7844 21.0831 14.4993 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 14.1361 21.3302 16.1158 20.1892 17.7406L17 12H20C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C14.1502 20 16.1022 19.1517 17.5398 17.7716L18.5374 19.5674Z"
  }));
},
    YZ = function YZ(_ref1665) {
  var _ref1665$color = _ref1665.color,
      C = _ref1665$color === void 0 ? "currentColor" : _ref1665$color,
      _ref1665$size = _ref1665.size,
      e = _ref1665$size === void 0 ? 24 : _ref1665$size,
      l = _ref1665.className,
      i = _objectWithoutProperties(_ref1665, _excluded1665);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4.22235 3.80753L10.9399 10.525L8.11144 13.3535L4.22235 9.46438C2.66026 7.90229 2.66026 5.36963 4.22235 3.80753ZM14.2683 12.1464L13.4147 12.9999L20.4858 20.071L19.0716 21.4852L12.0005 14.4141L4.92946 21.4852L3.51525 20.071L12.854 10.7322C12.2664 9.27525 12.8738 7.1769 14.4754 5.5753C16.428 3.62268 19.119 3.1478 20.4858 4.51464C21.8526 5.88147 21.3778 8.57242 19.4251 10.525C17.8235 12.1267 15.7252 12.7341 14.2683 12.1464Z"
  }));
},
    _Z = function _Z(_ref1666) {
  var _ref1666$color = _ref1666.color,
      C = _ref1666$color === void 0 ? "currentColor" : _ref1666$color,
      _ref1666$size = _ref1666.size,
      e = _ref1666$size === void 0 ? 24 : _ref1666$size,
      l = _ref1666.className,
      i = _objectWithoutProperties(_ref1666, _excluded1666);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14.2683 12.1466L13.4147 13.0002L20.4858 20.0712L19.0716 21.4854L12.0005 14.4144L4.92946 21.4854L3.51525 20.0712L12.854 10.7324C12.2664 9.27549 12.8738 7.17715 14.4754 5.57554C16.428 3.62292 19.119 3.14805 20.4858 4.51488C21.8526 5.88172 21.3778 8.57267 19.4251 10.5253C17.8235 12.1269 15.7252 12.7343 14.2683 12.1466ZM4.22235 3.80777L10.9399 10.5253L8.11144 13.3537L4.22235 9.46463C2.66026 7.90253 2.66026 5.36987 4.22235 3.80777ZM18.0109 9.11107C19.2682 7.85386 19.5274 6.38488 19.0716 5.92909C18.6158 5.47331 17.1468 5.73254 15.8896 6.98975C14.6324 8.24697 14.3732 9.71595 14.829 10.1717C15.2847 10.6275 16.7537 10.3683 18.0109 9.11107Z"
  }));
},
    $Z = function $Z(_ref1667) {
  var _ref1667$color = _ref1667.color,
      C = _ref1667$color === void 0 ? "currentColor" : _ref1667$color,
      _ref1667$size = _ref1667.size,
      e = _ref1667$size === void 0 ? 24 : _ref1667$size,
      l = _ref1667.className,
      i = _objectWithoutProperties(_ref1667, _excluded1667);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 2V22H19V14H16V7C16 4.23858 18.2386 2 21 2ZM9 13.9V22H7V13.9C4.71776 13.4367 3 11.419 3 9V3H5V10H7V3H9V10H11V3H13V9C13 11.419 11.2822 13.4367 9 13.9Z"
  }));
},
    ex = function ex(_ref1668) {
  var _ref1668$color = _ref1668.color,
      C = _ref1668$color === void 0 ? "currentColor" : _ref1668$color,
      _ref1668$size = _ref1668.size,
      e = _ref1668$size === void 0 ? 24 : _ref1668$size,
      l = _ref1668.className,
      i = _objectWithoutProperties(_ref1668, _excluded1668);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 2V22H19V15H15V8C15 4.68629 17.6863 2 21 2ZM19 4.53C18.17 5 17 6.17 17 8V13H19V4.53ZM9 13.9V22H7V13.9C4.71776 13.4367 3 11.419 3 9V3H5V10H7V3H9V10H11V3H13V9C13 11.419 11.2822 13.4367 9 13.9Z"
  }));
},
    tx = function tx(_ref1669) {
  var _ref1669$color = _ref1669.color,
      C = _ref1669$color === void 0 ? "currentColor" : _ref1669$color,
      _ref1669$size = _ref1669.size,
      e = _ref1669$size === void 0 ? 24 : _ref1669$size,
      l = _ref1669.className,
      i = _objectWithoutProperties(_ref1669, _excluded1669);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 10.6667L21.2227 4.51823C21.4524 4.36506 21.7629 4.42714 21.9161 4.65691C21.9708 4.73904 22 4.83554 22 4.93426V19.0657C22 19.3419 21.7762 19.5657 21.5 19.5657C21.4013 19.5657 21.3048 19.5365 21.2227 19.4818L12 13.3333V19.0657C12 19.3419 11.7762 19.5657 11.5 19.5657C11.4013 19.5657 11.3048 19.5365 11.2227 19.4818L0.62407 12.416C0.394306 12.2628 0.332219 11.9524 0.485395 11.7226C0.522013 11.6677 0.569144 11.6206 0.62407 11.584L11.2227 4.51823C11.4524 4.36506 11.7629 4.42714 11.9161 4.65691C11.9708 4.73904 12 4.83554 12 4.93426V10.6667Z"
  }));
},
    Cx = function Cx(_ref1670) {
  var _ref1670$color = _ref1670.color,
      C = _ref1670$color === void 0 ? "currentColor" : _ref1670$color,
      _ref1670$size = _ref1670.size,
      e = _ref1670$size === void 0 ? 24 : _ref1670$size,
      l = _ref1670.className,
      i = _objectWithoutProperties(_ref1670, _excluded1670);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 10.6667L21.2227 4.51823C21.4524 4.36506 21.7629 4.42714 21.9161 4.65691C21.9708 4.73904 22 4.83554 22 4.93426V19.0657C22 19.3419 21.7762 19.5657 21.5 19.5657C21.4013 19.5657 21.3048 19.5365 21.2227 19.4818L12 13.3333V19.0657C12 19.3419 11.7762 19.5657 11.5 19.5657C11.4013 19.5657 11.3048 19.5365 11.2227 19.4818L0.62407 12.416C0.394306 12.2628 0.332219 11.9524 0.485395 11.7226C0.522013 11.6677 0.569144 11.6206 0.62407 11.584L11.2227 4.51823C11.4524 4.36506 11.7629 4.42714 11.9161 4.65691C11.9708 4.73904 12 4.83554 12 4.93426V10.6667ZM10 16.263V7.73703L3.60558 12L10 16.263ZM20 16.263V7.73703L13.6056 12L20 16.263Z"
  }));
},
    lx = function lx(_ref1671) {
  var _ref1671$color = _ref1671.color,
      C = _ref1671$color === void 0 ? "currentColor" : _ref1671$color,
      _ref1671$size = _ref1671.size,
      e = _ref1671$size === void 0 ? 24 : _ref1671$size,
      l = _ref1671.className,
      i = _objectWithoutProperties(_ref1671, _excluded1671);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11.0002 17.035C11.0002 17.1383 10.9682 17.239 10.9087 17.3234C10.7494 17.549 10.4375 17.6028 10.2119 17.4435L3.07889 12.4085C3.03228 12.3756 2.99164 12.335 2.95874 12.2883C2.7995 12.0627 2.85329 11.7508 3.07889 11.5915L10.2119 6.55648C10.2962 6.49693 10.3969 6.46497 10.5002 6.46497C10.7763 6.46497 11.0002 6.68882 11.0002 6.96497V17.035ZM12.0789 12.4085C12.0323 12.3756 11.9916 12.335 11.9587 12.2883C11.7995 12.0627 11.8533 11.7508 12.0789 11.5915L19.2119 6.55648C19.2962 6.49693 19.3969 6.46497 19.5002 6.46497C19.7763 6.46497 20.0002 6.68882 20.0002 6.96497V17.035C20.0002 17.1383 19.9682 17.239 19.9087 17.3234C19.7494 17.549 19.4375 17.6028 19.2119 17.4435L12.0789 12.4085Z"
  }));
},
    ix = function ix(_ref1672) {
  var _ref1672$color = _ref1672.color,
      C = _ref1672$color === void 0 ? "currentColor" : _ref1672$color,
      _ref1672$size = _ref1672.size,
      e = _ref1672$size === void 0 ? 24 : _ref1672$size,
      l = _ref1672.className,
      i = _objectWithoutProperties(_ref1672, _excluded1672);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9.0002 9.85985L5.96831 12L9.0002 14.1402V9.85985ZM10.9087 17.3234C10.7494 17.549 10.4375 17.6028 10.2119 17.4435L3.07889 12.4085C3.03228 12.3756 2.99164 12.335 2.95874 12.2883C2.7995 12.0627 2.85329 11.7508 3.07889 11.5915L10.2119 6.55648C10.2962 6.49693 10.3969 6.46497 10.5002 6.46497C10.7763 6.46497 11.0002 6.68882 11.0002 6.96497V17.035C11.0002 17.1383 10.9682 17.239 10.9087 17.3234ZM18.0002 14.1402V9.85985L14.9683 12L18.0002 14.1402ZM12.0789 12.4085C12.0323 12.3756 11.9916 12.335 11.9587 12.2883C11.7995 12.0627 11.8533 11.7508 12.0789 11.5915L19.2119 6.55648C19.2962 6.49693 19.3969 6.46497 19.5002 6.46497C19.7763 6.46497 20.0002 6.68882 20.0002 6.96497V17.035C20.0002 17.1383 19.9682 17.239 19.9087 17.3234C19.7494 17.549 19.4375 17.6028 19.2119 17.4435L12.0789 12.4085Z"
  }));
},
    sx = function sx(_ref1673) {
  var _ref1673$color = _ref1673.color,
      C = _ref1673$color === void 0 ? "currentColor" : _ref1673$color,
      _ref1673$size = _ref1673.size,
      e = _ref1673$size === void 0 ? 24 : _ref1673$size,
      l = _ref1673.className,
      i = _objectWithoutProperties(_ref1673, _excluded1673);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 9H4V21H2V9ZM8 3H10V21H8V3ZM14 12H16V21H14V12ZM20 6H22V21H20V6Z"
  }));
},
    rx = function rx(_ref1674) {
  var _ref1674$color = _ref1674.color,
      C = _ref1674$color === void 0 ? "currentColor" : _ref1674$color,
      _ref1674$size = _ref1674.size,
      e = _ref1674$size === void 0 ? 24 : _ref1674$size,
      l = _ref1674.className,
      i = _objectWithoutProperties(_ref1674, _excluded1674);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 9H4V21H2V9ZM8 3H10V21H8V3ZM14 12H16V21H14V12ZM20 6H22V21H20V6Z"
  }));
},
    cx = function cx(_ref1675) {
  var _ref1675$color = _ref1675.color,
      C = _ref1675$color === void 0 ? "currentColor" : _ref1675$color,
      _ref1675$size = _ref1675.size,
      e = _ref1675$size === void 0 ? 24 : _ref1675$size,
      l = _ref1675.className,
      i = _objectWithoutProperties(_ref1675, _excluded1675);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5.5 21C3.01472 21 1 18.9853 1 16.5C1 14.0147 3.01472 12 5.5 12C7.98528 12 10 14.0147 10 16.5C10 18.9853 7.98528 21 5.5 21ZM5.5 18C6.32843 18 7 17.3284 7 16.5C7 15.6716 6.32843 15 5.5 15C4.67157 15 4 15.6716 4 16.5C4 17.3284 4.67157 18 5.5 18ZM18.5 21C16.0147 21 14 18.9853 14 16.5C14 14.0147 16.0147 12 18.5 12C20.9853 12 23 14.0147 23 16.5C23 18.9853 20.9853 21 18.5 21ZM18.5 18C19.3284 18 20 17.3284 20 16.5C20 15.6716 19.3284 15 18.5 15C17.6716 15 17 15.6716 17 16.5C17 17.3284 17.6716 18 18.5 18ZM11.5314 9.79706L13 12V18H11V13L8.28117 10.7343C8.18221 10.6661 8.08802 10.588 8 10.5C7.21895 9.71895 7.21895 8.45262 8 7.67157L10.8284 4.84315C11.6095 4.0621 12.8758 4.0621 13.6569 4.84315L15.0711 6.25736C16.1746 7.36086 17.5548 8.01891 18.9884 8.23151L18.978 10.2474C17.0335 10.0218 15.1485 9.16323 13.6569 7.67157L11.5314 9.79706ZM16 5C14.8954 5 14 4.10457 14 3C14 1.89543 14.8954 1 16 1C17.1046 1 18 1.89543 18 3C18 4.10457 17.1046 5 16 5Z"
  }));
},
    ox = function ox(_ref1676) {
  var _ref1676$color = _ref1676.color,
      C = _ref1676$color === void 0 ? "currentColor" : _ref1676$color,
      _ref1676$size = _ref1676.size,
      e = _ref1676$size === void 0 ? 24 : _ref1676$size,
      l = _ref1676.className,
      i = _objectWithoutProperties(_ref1676, _excluded1676);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5.5 21C3.01472 21 1 18.9853 1 16.5C1 14.0147 3.01472 12 5.5 12C7.98528 12 10 14.0147 10 16.5C10 18.9853 7.98528 21 5.5 21ZM5.5 19C6.88071 19 8 17.8807 8 16.5C8 15.1193 6.88071 14 5.5 14C4.11929 14 3 15.1193 3 16.5C3 17.8807 4.11929 19 5.5 19ZM18.5 21C16.0147 21 14 18.9853 14 16.5C14 14.0147 16.0147 12 18.5 12C20.9853 12 23 14.0147 23 16.5C23 18.9853 20.9853 21 18.5 21ZM18.5 19C19.8807 19 21 17.8807 21 16.5C21 15.1193 19.8807 14 18.5 14C17.1193 14 16 15.1193 16 16.5C16 17.8807 17.1193 19 18.5 19ZM11.023 10.3054L13 12V18H11V13L8.28117 10.7343C8.18221 10.6661 8.08802 10.588 8 10.5C7.21895 9.71895 7.21895 8.45262 8 7.67157L10.8284 4.84315C11.6095 4.0621 12.8758 4.0621 13.6569 4.84315L15.0711 6.25736C16.1746 7.36086 17.5548 8.01891 18.9884 8.23151L18.978 10.2474C17.0335 10.0218 15.1485 9.16323 13.6569 7.67157L11.023 10.3054ZM16 5C14.8954 5 14 4.10457 14 3C14 1.89543 14.8954 1 16 1C17.1046 1 18 1.89543 18 3C18 4.10457 17.1046 5 16 5Z"
  }));
},
    ax = function ax(_ref1677) {
  var _ref1677$color = _ref1677.color,
      C = _ref1677$color === void 0 ? "currentColor" : _ref1677$color,
      _ref1677$size = _ref1677.size,
      e = _ref1677$size === void 0 ? 24 : _ref1677$size,
      l = _ref1677.className,
      i = _objectWithoutProperties(_ref1677, _excluded1677);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16.9497 11.9497C18.7347 10.1648 19.3542 7.65558 18.8081 5.36796L21.303 4.2987C21.5569 4.18992 21.8508 4.30749 21.9596 4.56131C21.9862 4.62355 22 4.69056 22 4.75827V19L15 22L9 19L2.69696 21.7013C2.44314 21.8101 2.14921 21.6925 2.04043 21.4387C2.01375 21.3765 2 21.3094 2 21.2417V7L5.12892 5.65904C4.70023 7.86632 5.34067 10.2402 7.05025 11.9497L12 16.8995L16.9497 11.9497ZM15.5355 10.5355L12 14.0711L8.46447 10.5355C6.51184 8.58291 6.51184 5.41709 8.46447 3.46447C10.4171 1.51184 13.5829 1.51184 15.5355 3.46447C17.4882 5.41709 17.4882 8.58291 15.5355 10.5355Z"
  }));
},
    nx = function nx(_ref1678) {
  var _ref1678$color = _ref1678.color,
      C = _ref1678$color === void 0 ? "currentColor" : _ref1678$color,
      _ref1678$size = _ref1678.size,
      e = _ref1678$size === void 0 ? 24 : _ref1678$size,
      l = _ref1678.className,
      i = _objectWithoutProperties(_ref1678, _excluded1678);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 6.14286V18.9669L9.06476 16.7963L15.0648 19.7963L20 17.6812V4.85714L21.303 4.2987C21.5569 4.18992 21.8508 4.30749 21.9596 4.56131C21.9862 4.62355 22 4.69056 22 4.75827V19L15 22L9 19L2.69696 21.7013C2.44314 21.8101 2.14921 21.6925 2.04043 21.4387C2.01375 21.3765 2 21.3094 2 21.2417V7L4 6.14286ZM16.2426 11.2426L12 15.4853L7.75736 11.2426C5.41421 8.89949 5.41421 5.10051 7.75736 2.75736C10.1005 0.414214 13.8995 0.414214 16.2426 2.75736C18.5858 5.10051 18.5858 8.89949 16.2426 11.2426ZM12 12.6569L14.8284 9.82843C16.3905 8.26633 16.3905 5.73367 14.8284 4.17157C13.2663 2.60948 10.7337 2.60948 9.17157 4.17157C7.60948 5.73367 7.60948 8.26633 9.17157 9.82843L12 12.6569Z"
  }));
},
    mx = function mx(_ref1679) {
  var _ref1679$color = _ref1679.color,
      C = _ref1679$color === void 0 ? "currentColor" : _ref1679$color,
      _ref1679$size = _ref1679.size,
      e = _ref1679$size === void 0 ? 24 : _ref1679$size,
      l = _ref1679.className,
      i = _objectWithoutProperties(_ref1679, _excluded1679);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22 13.5V21C22 21.5523 21.5523 22 21 22H20C19.4477 22 19 21.5523 19 21V20H5V21C5 21.5523 4.55228 22 4 22H3C2.44772 22 2 21.5523 2 21V13.5L0.757464 13.1894C0.312297 13.0781 0 12.6781 0 12.2192V11.5C0 11.2239 0.223858 11 0.5 11H2.375L4.51334 5.29775C4.80607 4.51715 5.55231 4 6.386 4H17.614C18.4477 4 19.1939 4.51715 19.4867 5.29775L21.625 11H23.5C23.7761 11 24 11.2239 24 11.5V12.2192C24 12.6781 23.6877 13.0781 23.2425 13.1894L22 13.5ZM4 15V17C4 17.5523 4.44772 18 5 18H8.24496C8.3272 18 8.40818 17.9797 8.4807 17.9409C8.72418 17.8107 8.81602 17.5078 8.68582 17.2643L8.68588 17.2643C7.87868 15.7548 6.31672 15 4 15ZM20 15C17.6833 15 16.1213 15.7548 15.3141 17.2643L15.3142 17.2643C15.184 17.5078 15.2758 17.8107 15.5193 17.9409C15.5918 17.9797 15.6728 18 15.755 18H19C19.5523 18 20 17.5523 20 17V15ZM6 6L4.43874 10.6838C4.40475 10.7857 4.38743 10.8925 4.38743 11C4.38743 11.5523 4.83514 12 5.38743 12H18.6126C18.7201 12 18.8268 11.9827 18.9288 11.9487C19.4527 11.774 19.7359 11.2077 19.5613 10.6838L18 6H6Z"
  }));
},
    wx = function wx(_ref1680) {
  var _ref1680$color = _ref1680.color,
      C = _ref1680$color === void 0 ? "currentColor" : _ref1680$color,
      _ref1680$size = _ref1680.size,
      e = _ref1680$size === void 0 ? 24 : _ref1680$size,
      l = _ref1680.className,
      i = _objectWithoutProperties(_ref1680, _excluded1680);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19 20H5V21C5 21.5523 4.55228 22 4 22H3C2.44772 22 2 21.5523 2 21V13.5L0.757464 13.1894C0.312297 13.0781 0 12.6781 0 12.2192V11.5C0 11.2239 0.223858 11 0.5 11H2L4.4805 5.21216C4.79566 4.47679 5.51874 4 6.31879 4H17.6812C18.4813 4 19.2043 4.47679 19.5195 5.21216L22 11H23.5C23.7761 11 24 11.2239 24 11.5V12.2192C24 12.6781 23.6877 13.0781 23.2425 13.1894L22 13.5V21C22 21.5523 21.5523 22 21 22H20C19.4477 22 19 21.5523 19 21V20ZM20 18V13H4V18H20ZM5.47703 11H18.523C18.6502 11 18.7762 10.9757 18.8944 10.9285C19.4071 10.7234 19.6566 10.1414 19.4514 9.62861L18 6H6L4.54856 9.62861C4.50131 9.74673 4.47703 9.87278 4.47703 10C4.47703 10.5523 4.92475 11 5.47703 11ZM5 14C7.31672 14 8.87868 14.7548 9.68588 16.2643L9.68582 16.2643C9.81602 16.5078 9.72418 16.8107 9.4807 16.9409C9.40818 16.9797 9.3272 17 9.24496 17H6C5.44772 17 5 16.5523 5 16V14ZM19 14V16C19 16.5523 18.5523 17 18 17H14.755C14.6728 17 14.5918 16.9797 14.5193 16.9409C14.2758 16.8107 14.184 16.5078 14.3142 16.2643L14.3141 16.2643C15.1213 14.7548 16.6833 14 19 14Z"
  }));
},
    Lx = function Lx(_ref1681) {
  var _ref1681$color = _ref1681.color,
      C = _ref1681$color === void 0 ? "currentColor" : _ref1681$color,
      _ref1681$size = _ref1681.size,
      e = _ref1681$size === void 0 ? 24 : _ref1681$size,
      l = _ref1681.className,
      i = _objectWithoutProperties(_ref1681, _excluded1681);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13 4.05493C17.5 4.55237 21 8.36745 21 13V22H3V13C3 8.36745 6.50005 4.55237 11 4.05493V1H13V4.05493ZM12 18C14.7614 18 17 15.7614 17 13C17 10.2386 14.7614 8 12 8C9.23858 8 7 10.2386 7 13C7 15.7614 9.23858 18 12 18ZM12 16C10.3431 16 9 14.6569 9 13C9 11.3431 10.3431 10 12 10C13.6569 10 15 11.3431 15 13C15 14.6569 13.6569 16 12 16ZM12 14C12.5523 14 13 13.5523 13 13C13 12.4477 12.5523 12 12 12C11.4477 12 11 12.4477 11 13C11 13.5523 11.4477 14 12 14Z"
  }));
},
    hx = function hx(_ref1682) {
  var _ref1682$color = _ref1682.color,
      C = _ref1682$color === void 0 ? "currentColor" : _ref1682$color,
      _ref1682$size = _ref1682.size,
      e = _ref1682$size === void 0 ? 24 : _ref1682$size,
      l = _ref1682.className,
      i = _objectWithoutProperties(_ref1682, _excluded1682);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13 4.05493C17.5 4.55237 21 8.36745 21 13V22H3V13C3 8.36745 6.50005 4.55237 11 4.05493V1H13V4.05493ZM19 20V13C19 9.13401 15.866 6 12 6C8.13401 6 5 9.13401 5 13V20H19ZM12 18C9.23858 18 7 15.7614 7 13C7 10.2386 9.23858 8 12 8C14.7614 8 17 10.2386 17 13C17 15.7614 14.7614 18 12 18ZM12 16C13.6569 16 15 14.6569 15 13C15 11.3431 13.6569 10 12 10C10.3431 10 9 11.3431 9 13C9 14.6569 10.3431 16 12 16ZM12 14C11.4477 14 11 13.5523 11 13C11 12.4477 11.4477 12 12 12C12.5523 12 13 12.4477 13 13C13 13.5523 12.5523 14 12 14Z"
  }));
},
    Hx = function Hx(_ref1683) {
  var _ref1683$color = _ref1683.color,
      C = _ref1683$color === void 0 ? "currentColor" : _ref1683$color,
      _ref1683$size = _ref1683.size,
      e = _ref1683$size === void 0 ? 24 : _ref1683$size,
      l = _ref1683.className,
      i = _objectWithoutProperties(_ref1683, _excluded1683);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8.49816 20.0048H15.5018C14.8432 21.5842 13.5794 22.848 12 23.5066C10.4206 22.848 9.15679 21.5842 8.49816 20.0048ZM18 14.8095L20 17.0778V19.0048H4V17.0778L6 14.8095V9.00481C6 5.52156 8.50442 2.55825 12 1.46002C15.4956 2.55825 18 5.52156 18 9.00481V14.8095ZM12 11.0048C13.1046 11.0048 14 10.1094 14 9.00481C14 7.90024 13.1046 7.00481 12 7.00481C10.8954 7.00481 10 7.90024 10 9.00481C10 10.1094 10.8954 11.0048 12 11.0048Z"
  }));
},
    Vx = function Vx(_ref1684) {
  var _ref1684$color = _ref1684.color,
      C = _ref1684$color === void 0 ? "currentColor" : _ref1684$color,
      _ref1684$size = _ref1684.size,
      e = _ref1684$size === void 0 ? 24 : _ref1684$size,
      l = _ref1684.className,
      i = _objectWithoutProperties(_ref1684, _excluded1684);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15.5018 20.0048C14.8432 21.5841 13.5794 22.848 12 23.5066C10.4206 22.848 9.15679 21.5841 8.49816 20.0048H10.7575C11.0838 20.4934 11.5051 20.9171 12 21.248C12.4949 20.9171 12.9162 20.4934 13.2425 20.0048H15.5018ZM18 14.8095L20 17.0777V19.0048H4V17.0777L6 14.8095V9.00478C6 5.52153 8.50442 2.55822 12 1.45999C15.4956 2.55822 18 5.52153 18 9.00478V14.8095ZM17.2692 17.0048L16 15.5653V9.00478C16 6.68694 14.4292 4.57431 12 3.58384C9.57078 4.57431 8 6.68694 8 9.00478V15.5653L6.73076 17.0048H17.2692ZM12 11.0048C10.8954 11.0048 10 10.1093 10 9.00478C10 7.90021 10.8954 7.00478 12 7.00478C13.1046 7.00478 14 7.90021 14 9.00478C14 10.1093 13.1046 11.0048 12 11.0048Z"
  }));
},
    gx = function gx(_ref1685) {
  var _ref1685$color = _ref1685.color,
      C = _ref1685$color === void 0 ? "currentColor" : _ref1685$color,
      _ref1685$size = _ref1685.size,
      e = _ref1685$size === void 0 ? 24 : _ref1685$size,
      l = _ref1685.className,
      i = _objectWithoutProperties(_ref1685, _excluded1685);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5.33053 15.9288C5.115 14.9914 5.00054 14.0103 5.00054 12.9999C5.00054 7.91198 7.90319 3.5636 12.0005 1.81799C16.0979 3.5636 19.0005 7.91198 19.0005 12.9999C19.0005 14.0103 18.8861 14.9914 18.6706 15.9288L20.6907 17.7245C20.8704 17.8842 20.9109 18.1493 20.7872 18.3555L18.33 22.4508C18.1879 22.6876 17.8808 22.7644 17.644 22.6223C17.609 22.6013 17.5766 22.576 17.5477 22.5471L15.2934 20.2928C15.1059 20.1053 14.8515 19.9999 14.5863 19.9999H9.41476C9.14954 19.9999 8.89519 20.1053 8.70765 20.2928L6.45337 22.5471C6.2581 22.7424 5.94152 22.7424 5.74626 22.5471C5.71735 22.5182 5.6921 22.4859 5.67107 22.4508L3.21385 18.3555C3.09014 18.1493 3.13071 17.8842 3.31042 17.7245L5.33053 15.9288ZM12.0005 12.9999C13.1051 12.9999 14.0005 12.1045 14.0005 10.9999C14.0005 9.89537 13.1051 8.99994 12.0005 8.99994C10.896 8.99994 10.0005 9.89537 10.0005 10.9999C10.0005 12.1045 10.896 12.9999 12.0005 12.9999Z"
  }));
},
    Mx = function Mx(_ref1686) {
  var _ref1686$color = _ref1686.color,
      C = _ref1686$color === void 0 ? "currentColor" : _ref1686$color,
      _ref1686$size = _ref1686.size,
      e = _ref1686$size === void 0 ? 24 : _ref1686$size,
      l = _ref1686.className,
      i = _objectWithoutProperties(_ref1686, _excluded1686);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4.99958 12.9999C4.99958 7.91198 7.90222 3.5636 11.9996 1.81799C16.0969 3.5636 18.9996 7.91198 18.9996 12.9999C18.9996 13.8229 18.9236 14.6264 18.779 15.4027L20.7194 17.2353C20.8845 17.3913 20.9238 17.6389 20.815 17.8383L18.3196 22.4133C18.1873 22.6557 17.8836 22.7451 17.6412 22.6128C17.5993 22.59 17.5608 22.5612 17.5271 22.5274L15.2925 20.2928C15.1049 20.1053 14.8506 19.9999 14.5854 19.9999H9.41379C9.14857 19.9999 8.89422 20.1053 8.70668 20.2928L6.47209 22.5274C6.27683 22.7227 5.96025 22.7227 5.76498 22.5274C5.73122 22.4937 5.70246 22.4552 5.67959 22.4133L3.18412 17.8383C3.07537 17.6389 3.11464 17.3913 3.27975 17.2353L5.22014 15.4027C5.07551 14.6264 4.99958 13.8229 4.99958 12.9999ZM6.47542 19.6957L7.29247 18.8786C7.85508 18.316 8.61814 17.9999 9.41379 17.9999H14.5854C15.381 17.9999 16.1441 18.316 16.7067 18.8786L17.5237 19.6957L18.5056 17.8955L17.4058 16.8568C16.9117 16.3901 16.6884 15.7045 16.8128 15.0364C16.9366 14.3722 16.9996 13.6911 16.9996 12.9999C16.9996 9.13037 15.0045 5.69965 11.9996 4.04033C8.99462 5.69965 6.99958 9.13037 6.99958 12.9999C6.99958 13.6911 7.06255 14.3722 7.18631 15.0364C7.31078 15.7045 7.08746 16.3901 6.59338 16.8568L5.49353 17.8955L6.47542 19.6957ZM11.9996 12.9999C10.895 12.9999 9.99958 12.1045 9.99958 10.9999C9.99958 9.89537 10.895 8.99994 11.9996 8.99994C13.1041 8.99994 13.9996 9.89537 13.9996 10.9999C13.9996 12.1045 13.1041 12.9999 11.9996 12.9999Z"
  }));
},
    Zx = function Zx(_ref1687) {
  var _ref1687$color = _ref1687.color,
      C = _ref1687$color === void 0 ? "currentColor" : _ref1687$color,
      _ref1687$size = _ref1687.size,
      e = _ref1687$size === void 0 ? 24 : _ref1687$size,
      l = _ref1687.className,
      i = _objectWithoutProperties(_ref1687, _excluded1687);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C17.5228 2 22 6.47715 22 12C22 14.1364 21.3301 16.1162 20.1889 17.741L17 12H20C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C14.1502 20 16.1023 19.1517 17.5398 17.7716L18.5379 19.567C16.7848 21.083 14.4995 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 7C13.6569 7 15 8.34315 15 10V11H16V16H8V11H9V10C9 8.34315 10.3431 7 12 7ZM12 9C11.4872 9 11.0645 9.38604 11.0067 9.88338L11 10V11H13V10C13 9.48716 12.614 9.06449 12.1166 9.00673L12 9Z"
  }));
},
    xx = function xx(_ref1688) {
  var _ref1688$color = _ref1688.color,
      C = _ref1688$color === void 0 ? "currentColor" : _ref1688$color,
      _ref1688$size = _ref1688.size,
      e = _ref1688$size === void 0 ? 24 : _ref1688$size,
      l = _ref1688.className,
      i = _objectWithoutProperties(_ref1688, _excluded1688);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C17.5228 2 22 6.47715 22 12C22 14.1364 21.3301 16.1162 20.1889 17.741L17 12H20C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C14.1502 20 16.1023 19.1517 17.5398 17.7716L18.5379 19.567C16.7848 21.083 14.4995 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 7C13.6569 7 15 8.34315 15 10V11H16V16H8V11H9V10C9 8.34315 10.3431 7 12 7ZM14 13H10V14H14V13ZM12 9C11.4872 9 11.0645 9.38604 11.0067 9.88338L11 10V11H13V10C13 9.48716 12.614 9.06449 12.1166 9.00673L12 9Z"
  }));
},
    vx = function vx(_ref1689) {
  var _ref1689$color = _ref1689.color,
      C = _ref1689$color === void 0 ? "currentColor" : _ref1689$color,
      _ref1689$size = _ref1689.size,
      e = _ref1689$size === void 0 ? 24 : _ref1689$size,
      l = _ref1689.className,
      i = _objectWithoutProperties(_ref1689, _excluded1689);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 19V21H19V19H21ZM17 19V21H15V19H17ZM13 19V21H11V19H13ZM9 19V21H7V19H9ZM5 19V21H3V19H5ZM21 15V17H19V15H21ZM5 15V17H3V15H5ZM5 11V13H3V11H5ZM16 3C18.6874 3 20.8817 5.12366 20.9954 7.78322L21 8V13H19V8C19 6.40893 17.7447 5.09681 16.1756 5.00512L16 5H11V3H16ZM5 7V9H3V7H5ZM5 3V5H3V3H5ZM9 3V5H7V3H9Z"
  }));
},
    dx = function dx(_ref1690) {
  var _ref1690$color = _ref1690.color,
      C = _ref1690$color === void 0 ? "currentColor" : _ref1690$color,
      _ref1690$size = _ref1690.size,
      e = _ref1690$size === void 0 ? 24 : _ref1690$size,
      l = _ref1690.className,
      i = _objectWithoutProperties(_ref1690, _excluded1690);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 15V8.5C4 6.01472 6.01472 4 8.5 4C10.9853 4 13 6.01472 13 8.5V15.5C13 16.8807 14.1193 18 15.5 18C16.8807 18 18 16.8807 18 15.5V8.82929C16.8348 8.41746 16 7.30622 16 6C16 4.34315 17.3431 3 19 3C20.6569 3 22 4.34315 22 6C22 7.30622 21.1652 8.41746 20 8.82929V15.5C20 17.9853 17.9853 20 15.5 20C13.0147 20 11 17.9853 11 15.5V8.5C11 7.11929 9.88071 6 8.5 6C7.11929 6 6 7.11929 6 8.5V15H9L5 20L1 15H4Z"
  }));
},
    px = function px(_ref1691) {
  var _ref1691$color = _ref1691.color,
      C = _ref1691$color === void 0 ? "currentColor" : _ref1691$color,
      _ref1691$size = _ref1691.size,
      e = _ref1691$size === void 0 ? 24 : _ref1691$size,
      l = _ref1691.className,
      i = _objectWithoutProperties(_ref1691, _excluded1691);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 15V8.5C4 6.01472 6.01472 4 8.5 4C10.9853 4 13 6.01472 13 8.5V15.5C13 16.8807 14.1193 18 15.5 18C16.8807 18 18 16.8807 18 15.5V8.82929C16.8348 8.41746 16 7.30622 16 6C16 4.34315 17.3431 3 19 3C20.6569 3 22 4.34315 22 6C22 7.30622 21.1652 8.41746 20 8.82929V15.5C20 17.9853 17.9853 20 15.5 20C13.0147 20 11 17.9853 11 15.5V8.5C11 7.11929 9.88071 6 8.5 6C7.11929 6 6 7.11929 6 8.5V15H9L5 20L1 15H4ZM19 7C19.5523 7 20 6.55228 20 6C20 5.44772 19.5523 5 19 5C18.4477 5 18 5.44772 18 6C18 6.55228 18.4477 7 19 7Z"
  }));
},
    Ex = function Ex(_ref1692) {
  var _ref1692$color = _ref1692.color,
      C = _ref1692$color === void 0 ? "currentColor" : _ref1692$color,
      _ref1692$size = _ref1692.size,
      e = _ref1692$size === void 0 ? 24 : _ref1692$size,
      l = _ref1692.className,
      i = _objectWithoutProperties(_ref1692, _excluded1692);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11.0001 14V11H13.0001V14H18.0001C18.5524 14 19.0001 14.4477 19.0001 15V21C19.0001 21.5523 18.5524 22 18.0001 22H6.00015C5.44786 22 5.00015 21.5523 5.00015 21V15C5.00015 14.4477 5.44786 14 6.00015 14H11.0001ZM2.51074 8.83686C3.83432 4.86424 7.58275 2 12.0001 2C16.4176 2 20.166 4.86424 21.4896 8.83686L19.5917 9.46949C18.5328 6.29139 15.5341 4 12.0001 4C8.46623 4 5.46749 6.29139 4.40862 9.46949L2.51074 8.83686ZM6.3065 10.1021C7.10065 7.71854 9.34971 6 12.0001 6C14.6506 6 16.8996 7.71854 17.6938 10.1021L15.7959 10.7347C15.2665 9.1457 13.7671 8 12.0001 8C10.2332 8 8.73382 9.1457 8.20439 10.7347L6.3065 10.1021Z"
  }));
},
    Nx = function Nx(_ref1693) {
  var _ref1693$color = _ref1693.color,
      C = _ref1693$color === void 0 ? "currentColor" : _ref1693$color,
      _ref1693$size = _ref1693.size,
      e = _ref1693$size === void 0 ? 24 : _ref1693$size,
      l = _ref1693.className,
      i = _objectWithoutProperties(_ref1693, _excluded1693);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11.0001 14V11H13.0001V14H18.0001C18.5524 14 19.0001 14.4477 19.0001 15V21C19.0001 21.5523 18.5524 22 18.0001 22H6.00015C5.44786 22 5.00015 21.5523 5.00015 21V15C5.00015 14.4477 5.44786 14 6.00015 14H11.0001ZM2.51074 8.83686C3.83432 4.86424 7.58275 2 12.0001 2C16.4176 2 20.166 4.86424 21.4896 8.83686L19.5917 9.46949C18.5328 6.29139 15.5341 4 12.0001 4C8.46623 4 5.46749 6.29139 4.40862 9.46949L2.51074 8.83686ZM6.3065 10.1021C7.10065 7.71854 9.34971 6 12.0001 6C14.6506 6 16.8996 7.71854 17.6938 10.1021L15.7959 10.7347C15.2665 9.1457 13.7671 8 12.0001 8C10.2332 8 8.73382 9.1457 8.20439 10.7347L6.3065 10.1021ZM7.00015 16V20H17.0001V16H7.00015Z"
  }));
},
    ux = function ux(_ref1694) {
  var _ref1694$color = _ref1694.color,
      C = _ref1694$color === void 0 ? "currentColor" : _ref1694$color,
      _ref1694$size = _ref1694.size,
      e = _ref1694$size === void 0 ? 24 : _ref1694$size,
      l = _ref1694.className,
      i = _objectWithoutProperties(_ref1694, _excluded1694);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 3C12.9411 3 21 11.0589 21 21H18C18 12.7157 11.2843 6 3 6V3ZM3 10C9.07513 10 14 14.9249 14 21H11C11 16.5817 7.41828 13 3 13V10ZM3 17C5.20914 17 7 18.7909 7 21H3V17Z"
  }));
},
    Bx = function Bx(_ref1695) {
  var _ref1695$color = _ref1695.color,
      C = _ref1695$color === void 0 ? "currentColor" : _ref1695$color,
      _ref1695$size = _ref1695.size,
      e = _ref1695$size === void 0 ? 24 : _ref1695$size,
      l = _ref1695.className,
      i = _objectWithoutProperties(_ref1695, _excluded1695);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 17C5.20914 17 7 18.7909 7 21H3V17ZM3 10C9.07513 10 14 14.9249 14 21H12C12 16.0294 7.97056 12 3 12V10ZM3 3C12.9411 3 21 11.0589 21 21H19C19 12.1634 11.8366 5 3 5V3Z"
  }));
},
    fx = function fx(_ref1696) {
  var _ref1696$color = _ref1696.color,
      C = _ref1696$color === void 0 ? "currentColor" : _ref1696$color,
      _ref1696$size = _ref1696.size,
      e = _ref1696$size === void 0 ? 24 : _ref1696$size,
      l = _ref1696.className,
      i = _objectWithoutProperties(_ref1696, _excluded1696);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15 21H13V18H11V21H9V19H7V21H4C3.44772 21 3 20.5523 3 20V17H5V15H3V13H6V11H3V9H5V7H3V4C3 3.44772 3.44772 3 4 3H10C10.5523 3 11 3.44772 11 4V13H20C20.5523 13 21 13.4477 21 14V20C21 20.5523 20.5523 21 20 21H17V19H15V21Z"
  }));
},
    Rx = function Rx(_ref1697) {
  var _ref1697$color = _ref1697.color,
      C = _ref1697$color === void 0 ? "currentColor" : _ref1697$color,
      _ref1697$size = _ref1697.size,
      e = _ref1697$size === void 0 ? 24 : _ref1697$size,
      l = _ref1697.className,
      i = _objectWithoutProperties(_ref1697, _excluded1697);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17 19H19V14H10V5H5V7H7V9H5V11H8V13H5V15H7V17H5V19H7V17H9V19H11V16H13V19H15V17H17V19ZM12 12H20C20.5523 12 21 12.4477 21 13V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3H11C11.5523 3 12 3.44772 12 4V12Z"
  }));
},
    zx = function zx(_ref1698) {
  var _ref1698$color = _ref1698.color,
      C = _ref1698$color === void 0 ? "currentColor" : _ref1698$color,
      _ref1698$size = _ref1698.size,
      e = _ref1698$size === void 0 ? 24 : _ref1698$size,
      l = _ref1698.className,
      i = _objectWithoutProperties(_ref1698, _excluded1698);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4.92901 13.3138L7.05033 15.4351L8.46455 14.0209L6.34323 11.8996L8.46455 9.77828L11.293 12.6067L12.7072 11.1925L9.87876 8.36407L12.0001 6.24275L14.1214 8.36407L15.5356 6.94986L13.4143 4.82853L16.2427 2.00011C16.6332 1.60958 17.2664 1.60958 17.6569 2.00011L22.6067 6.94986C22.9972 7.34038 22.9972 7.97354 22.6067 8.36407L7.75744 23.2133C7.36692 23.6038 6.73375 23.6038 6.34323 23.2133L1.39348 18.2636C1.00295 17.873 1.00295 17.2399 1.39348 16.8494L4.92901 13.3138Z"
  }));
},
    Fx = function Fx(_ref1699) {
  var _ref1699$color = _ref1699.color,
      C = _ref1699$color === void 0 ? "currentColor" : _ref1699$color,
      _ref1699$size = _ref1699.size,
      e = _ref1699$size === void 0 ? 24 : _ref1699$size,
      l = _ref1699.className,
      i = _objectWithoutProperties(_ref1699, _excluded1699);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.34323 14.728L3.5148 17.5565L7.05033 21.092L20.4854 7.65696L16.9498 4.12143L14.8285 6.24275L16.2427 7.65696L14.8285 9.07118L13.4143 7.65696L11.293 9.77828L13.4143 11.8996L12.0001 13.3138L9.87876 11.1925L7.75744 13.3138L9.17165 14.728L7.75744 16.1422L6.34323 14.728ZM17.6569 2.00011L22.6067 6.94986C22.9972 7.34038 22.9972 7.97354 22.6067 8.36407L7.75744 23.2133C7.36692 23.6038 6.73375 23.6038 6.34323 23.2133L1.39348 18.2636C1.00295 17.873 1.00295 17.2399 1.39348 16.8494L16.2427 2.00011C16.6332 1.60958 17.2664 1.60958 17.6569 2.00011Z"
  }));
},
    Sx = function Sx(_ref1700) {
  var _ref1700$color = _ref1700.color,
      C = _ref1700$color === void 0 ? "currentColor" : _ref1700$color,
      _ref1700$size = _ref1700.size,
      e = _ref1700$size === void 0 ? 24 : _ref1700$size,
      l = _ref1700.className,
      i = _objectWithoutProperties(_ref1700, _excluded1700);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9.82986 8.78986L7.99998 9.45588V13H5.99998V8.05H6.015L11.2834 6.13247C11.5274 6.03855 11.7922 5.99162 12.0648 6.0008C13.1762 6.02813 14.1522 6.75668 14.4917 7.82036C14.678 8.40431 14.848 8.79836 15.0015 9.0025C15.9138 10.2155 17.3653 11 19 11V13C16.8253 13 14.8823 12.0083 13.5984 10.4526L13.017 13.7497L15 15.67V23H13V17.0142L10.9507 15.0271L10.003 19.3253L3.10938 18.1098L3.45667 16.1401L8.38071 17.0084L9.82986 8.78986ZM13.5 5.5C12.3954 5.5 11.5 4.60457 11.5 3.5C11.5 2.39543 12.3954 1.5 13.5 1.5C14.6046 1.5 15.5 2.39543 15.5 3.5C15.5 4.60457 14.6046 5.5 13.5 5.5Z"
  }));
},
    Ax = function Ax(_ref1701) {
  var _ref1701$color = _ref1701.color,
      C = _ref1701$color === void 0 ? "currentColor" : _ref1701$color,
      _ref1701$size = _ref1701.size,
      e = _ref1701$size === void 0 ? 24 : _ref1701$size,
      l = _ref1701.className,
      i = _objectWithoutProperties(_ref1701, _excluded1701);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9.82986 8.78986L7.99998 9.45588V13H5.99998V8.05H6.015L11.2834 6.13247C11.5274 6.03855 11.7922 5.99162 12.0648 6.0008C13.1762 6.02813 14.1522 6.75668 14.4917 7.82036C14.678 8.40431 14.848 8.79836 15.0015 9.0025C15.9138 10.2155 17.3653 11 19 11V13C16.8253 13 14.8823 12.0083 13.5984 10.4526L12.9008 14.4085L15 16.17V23H13V17.1025L10.7307 15.1984L10.003 19.3253L3.10938 18.1098L3.45667 16.1401L8.38071 17.0084L9.82986 8.78986ZM13.5 5.5C12.3954 5.5 11.5 4.60457 11.5 3.5C11.5 2.39543 12.3954 1.5 13.5 1.5C14.6046 1.5 15.5 2.39543 15.5 3.5C15.5 4.60457 14.6046 5.5 13.5 5.5Z"
  }));
},
    kx = function kx(_ref1702) {
  var _ref1702$color = _ref1702.color,
      C = _ref1702$color === void 0 ? "currentColor" : _ref1702$color,
      _ref1702$size = _ref1702.size,
      e = _ref1702$size === void 0 ? 24 : _ref1702$size,
      l = _ref1702.className,
      i = _objectWithoutProperties(_ref1702, _excluded1702);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16.7012 6.80069L10.5868 10.5858L6.80166 16.7002L6.69768 16.5962L5.28346 18.0104L5.99057 18.7175L7.40478 17.3033L7.3008 17.1993L13.4152 13.4142L17.2003 7.29982L17.3043 7.40381L18.7185 5.98959L18.0114 5.28249L16.5972 6.6967L16.7012 6.80069ZM12.001 22C6.47813 22 2.00098 17.5228 2.00098 12C2.00098 6.47715 6.47813 2 12.001 2C17.5238 2 22.001 6.47715 22.001 12C22.001 17.5228 17.5238 22 12.001 22ZM11.501 3V5H12.501V3H11.501ZM11.501 19V21H12.501V19H11.501ZM8.09489 3.87643L8.86025 5.72418L9.78413 5.3415L9.01877 3.49374L8.09489 3.87643ZM14.2178 18.6585L14.9832 20.5063L15.9071 20.1236L15.1417 18.2758L14.2178 18.6585ZM14.9832 3.49374L14.2178 5.3415L15.1417 5.72418L15.9071 3.87643L14.9832 3.49374ZM8.86025 18.2758L8.09489 20.1236L9.01877 20.5063L9.78413 18.6585L8.86025 18.2758ZM21.001 11.5H19.001V12.5H21.001V11.5ZM5.00098 11.5H3.00098V12.5H5.00098V11.5ZM20.4593 15.1155L18.6238 14.3212L18.2267 15.2389L20.0622 16.0332L20.4593 15.1155ZM5.77527 8.76109L3.93976 7.96679L3.54261 8.88455L5.37812 9.67884L5.77527 8.76109ZM20.1245 8.09391L18.2768 8.85928L18.6595 9.78316L20.5072 9.01779L20.1245 8.09391ZM5.34248 14.2168L3.49472 14.9822L3.8774 15.9061L5.72516 15.1407L5.34248 14.2168ZM18.7185 18.0104L17.3043 16.5962L16.5972 17.3033L18.0114 18.7175L18.7185 18.0104ZM7.40478 6.6967L5.99057 5.28249L5.28346 5.98959L6.69768 7.40381L7.40478 6.6967ZM11.3132 11.3122L14.9241 9.07686L12.6888 12.6878L11.3132 11.3122Z"
  }));
},
    Px = function Px(_ref1703) {
  var _ref1703$color = _ref1703.color,
      C = _ref1703$color === void 0 ? "currentColor" : _ref1703$color,
      _ref1703$size = _ref1703.size,
      e = _ref1703$size === void 0 ? 24 : _ref1703$size,
      l = _ref1703.className,
      i = _objectWithoutProperties(_ref1703, _excluded1703);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17.8133 6.50295L13.4152 13.4142L6.50392 17.8123C7.70928 18.9527 9.26918 19.7222 11.001 19.9381V18H13.001V19.9381C14.4617 19.756 15.8001 19.18 16.9066 18.3199L15.5365 16.9497L16.9507 15.5355L18.3208 16.9056C19.181 15.7991 19.7569 14.4607 19.9391 13H18.001V11H19.9391C19.7231 9.2682 18.9536 7.70831 17.8133 6.50295ZM17.498 6.18771C16.2927 5.04733 14.7328 4.27785 13.001 4.06189V6H11.001V4.06189C9.54027 4.24404 8.20186 4.81999 7.09533 5.68014L8.46544 7.05025L7.05123 8.46447L5.68112 7.09436C4.82097 8.20088 4.24502 9.53929 4.06287 11H6.00098V13H4.06287C4.27882 14.7318 5.04831 16.2917 6.18868 17.4971L10.5868 10.5858L17.498 6.18771ZM12.001 22C6.47813 22 2.00098 17.5228 2.00098 12C2.00098 6.47715 6.47813 2 12.001 2C17.5238 2 22.001 6.47715 22.001 12C22.001 17.5228 17.5238 22 12.001 22Z"
  }));
},
    Dx = function Dx(_ref1704) {
  var _ref1704$color = _ref1704.color,
      C = _ref1704$color === void 0 ? "currentColor" : _ref1704$color,
      _ref1704$size = _ref1704.size,
      e = _ref1704$size === void 0 ? 24 : _ref1704$size,
      l = _ref1704.className,
      i = _objectWithoutProperties(_ref1704, _excluded1704);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10.0049 19.9998H6.00488V21.9998H4.00488V19.9998H3.00488C2.4526 19.9998 2.00488 19.552 2.00488 18.9998V3.99977C2.00488 3.44748 2.4526 2.99977 3.00488 2.99977H10.0049V1.59C10.0049 1.31385 10.2287 1.09 10.5049 1.09C10.5324 1.09 10.5599 1.09227 10.5871 1.0968L21.1693 2.8605C21.6515 2.94086 22.0049 3.35805 22.0049 3.84689V5.99977H23.0049V7.99977H22.0049V14.9998H23.0049V16.9998H22.0049V19.1526C22.0049 19.6415 21.6515 20.0587 21.1693 20.139L20.0049 20.3331V21.9998H18.0049V20.6664L10.5871 21.9027C10.3147 21.9481 10.0571 21.7641 10.0117 21.4917C10.0072 21.4646 10.0049 21.4371 10.0049 21.4095V19.9998ZM12.0049 19.6388L20.0049 18.3055V4.69402L12.0049 3.36069V19.6388ZM16.5049 13.9998C15.6765 13.9998 15.0049 12.8805 15.0049 11.4998C15.0049 10.1191 15.6765 8.99977 16.5049 8.99977C17.3333 8.99977 18.0049 10.1191 18.0049 11.4998C18.0049 12.8805 17.3333 13.9998 16.5049 13.9998Z"
  }));
},
    yx = function yx(_ref1705) {
  var _ref1705$color = _ref1705.color,
      C = _ref1705$color === void 0 ? "currentColor" : _ref1705$color,
      _ref1705$size = _ref1705.size,
      e = _ref1705$size === void 0 ? 24 : _ref1705$size,
      l = _ref1705.className,
      i = _objectWithoutProperties(_ref1705, _excluded1705);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.0049 20.3331V21.9998H18.0049V20.6664L10.5871 21.9027C10.3147 21.9481 10.0571 21.7641 10.0117 21.4917C10.0072 21.4646 10.0049 21.4371 10.0049 21.4095V19.9998H6.00488V21.9998H4.00488V19.9998H3.00488C2.4526 19.9998 2.00488 19.552 2.00488 18.9998V3.99977C2.00488 3.44748 2.4526 2.99977 3.00488 2.99977H10.0049V1.59C10.0049 1.31385 10.2287 1.09 10.5049 1.09C10.5324 1.09 10.5599 1.09227 10.5871 1.0968L21.1693 2.8605C21.6515 2.94086 22.0049 3.35805 22.0049 3.84689V5.99977H23.0049V7.99977H22.0049V14.9998H23.0049V16.9998H22.0049V19.1526C22.0049 19.6415 21.6515 20.0587 21.1693 20.139L20.0049 20.3331ZM4.00488 4.99977V17.9998H10.0049V4.99977H4.00488ZM12.0049 19.6388L20.0049 18.3055V4.69402L12.0049 3.36069V19.6388ZM16.5049 13.9998C15.6765 13.9998 15.0049 12.8805 15.0049 11.4998C15.0049 10.1191 15.6765 8.99977 16.5049 8.99977C17.3333 8.99977 18.0049 10.1191 18.0049 11.4998C18.0049 12.8805 17.3333 13.9998 16.5049 13.9998Z"
  }));
},
    bx = function bx(_ref1706) {
  var _ref1706$color = _ref1706.color,
      C = _ref1706$color === void 0 ? "currentColor" : _ref1706$color,
      _ref1706$size = _ref1706.size,
      e = _ref1706$size === void 0 ? 24 : _ref1706$size,
      l = _ref1706.className,
      i = _objectWithoutProperties(_ref1706, _excluded1706);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18.0049 19.9998H6.00488V21.9998H4.00488V19.9998H3.00488C2.4526 19.9998 2.00488 19.5521 2.00488 18.9998V3.99979C2.00488 3.4475 2.4526 2.99979 3.00488 2.99979H21.0049C21.5572 2.99979 22.0049 3.4475 22.0049 3.99979V18.9998C22.0049 19.5521 21.5572 19.9998 21.0049 19.9998H20.0049V21.9998H18.0049V19.9998ZM11.0049 13.8738V16.9998H13.0049V13.8738C14.7301 13.4297 16.0049 11.8636 16.0049 9.99979C16.0049 7.79065 14.214 5.99979 12.0049 5.99979C9.79574 5.99979 8.00488 7.79065 8.00488 9.99979C8.00488 11.8636 9.27966 13.4297 11.0049 13.8738ZM12.0049 11.9998C10.9003 11.9998 10.0049 11.1044 10.0049 9.99979C10.0049 8.89522 10.9003 7.99979 12.0049 7.99979C13.1095 7.99979 14.0049 8.89522 14.0049 9.99979C14.0049 11.1044 13.1095 11.9998 12.0049 11.9998Z"
  }));
},
    Tx = function Tx(_ref1707) {
  var _ref1707$color = _ref1707.color,
      C = _ref1707$color === void 0 ? "currentColor" : _ref1707$color,
      _ref1707$size = _ref1707.size,
      e = _ref1707$size === void 0 ? 24 : _ref1707$size,
      l = _ref1707.className,
      i = _objectWithoutProperties(_ref1707, _excluded1707);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18.0049 19.9998H6.00488V21.9998H4.00488V19.9998H3.00488C2.4526 19.9998 2.00488 19.5521 2.00488 18.9998V3.99979C2.00488 3.4475 2.4526 2.99979 3.00488 2.99979H21.0049C21.5572 2.99979 22.0049 3.4475 22.0049 3.99979V18.9998C22.0049 19.5521 21.5572 19.9998 21.0049 19.9998H20.0049V21.9998H18.0049V19.9998ZM4.00488 17.9998H20.0049V4.99979H4.00488V17.9998ZM13.0049 13.8738V16.9998H11.0049V13.8738C9.27966 13.4297 8.00488 11.8636 8.00488 9.99979C8.00488 7.79065 9.79574 5.99979 12.0049 5.99979C14.214 5.99979 16.0049 7.79065 16.0049 9.99979C16.0049 11.8636 14.7301 13.4297 13.0049 13.8738ZM12.0049 11.9998C13.1095 11.9998 14.0049 11.1044 14.0049 9.99979C14.0049 8.89522 13.1095 7.99979 12.0049 7.99979C10.9003 7.99979 10.0049 8.89522 10.0049 9.99979C10.0049 11.1044 10.9003 11.9998 12.0049 11.9998Z"
  }));
},
    Ux = function Ux(_ref1708) {
  var _ref1708$color = _ref1708.color,
      C = _ref1708$color === void 0 ? "currentColor" : _ref1708$color,
      _ref1708$size = _ref1708.size,
      e = _ref1708$size === void 0 ? 24 : _ref1708$size,
      l = _ref1708.className,
      i = _objectWithoutProperties(_ref1708, _excluded1708);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3.00003 17.9999H21C21.2762 17.9999 21.5 18.2238 21.5 18.4999C21.5 18.6081 21.4649 18.7134 21.4 18.7999L19.3 21.5999C19.1112 21.8517 18.8148 21.9999 18.5 21.9999H5.50003C5.18527 21.9999 4.88888 21.8517 4.70003 21.5999L2.60003 18.7999C2.43434 18.579 2.47912 18.2656 2.70003 18.0999C2.78658 18.035 2.89184 17.9999 3.00003 17.9999ZM15 2.42531V14.9999C15 15.5522 14.5523 15.9999 14 15.9999H4.04034C3.7642 15.9999 3.54034 15.7761 3.54034 15.4999C3.54034 15.3864 3.57898 15.2762 3.64991 15.1876L14.1096 2.11296C14.2821 1.89733 14.5967 1.86237 14.8124 2.03488C14.931 2.12976 15 2.27342 15 2.42531Z"
  }));
},
    Gx = function Gx(_ref1709) {
  var _ref1709$color = _ref1709.color,
      C = _ref1709$color === void 0 ? "currentColor" : _ref1709$color,
      _ref1709$size = _ref1709.size,
      e = _ref1709$size === void 0 ? 24 : _ref1709$size,
      l = _ref1709.className,
      i = _objectWithoutProperties(_ref1709, _excluded1709);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3.00003 18H21C21.2762 18 21.5 18.2239 21.5 18.5C21.5 18.6082 21.4649 18.7135 21.4 18.8L19.3 21.6C19.1112 21.8518 18.8148 22 18.5 22H5.50003C5.18527 22 4.88888 21.8518 4.70003 21.6L2.60003 18.8C2.43434 18.5791 2.47912 18.2657 2.70003 18.1C2.78658 18.0351 2.89184 18 3.00003 18ZM7.16128 14H13V6.7016L7.16128 14ZM15 2.42543V15C15 15.5523 14.5523 16 14 16H4.04034C3.7642 16 3.54034 15.7762 3.54034 15.5C3.54034 15.3865 3.57898 15.2764 3.64991 15.1877L14.1096 2.11309C14.2821 1.89745 14.5967 1.86249 14.8124 2.035C14.931 2.12989 15 2.27354 15 2.42543Z"
  }));
},
    Ix = function Ix(_ref1710) {
  var _ref1710$color = _ref1710.color,
      C = _ref1710$color === void 0 ? "currentColor" : _ref1710$color,
      _ref1710$size = _ref1710.size,
      e = _ref1710$size === void 0 ? 24 : _ref1710$size,
      l = _ref1710.className,
      i = _objectWithoutProperties(_ref1710, _excluded1710);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 3H17L20.7071 6.70711C20.8946 6.89464 21 7.149 21 7.41421V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM12 18C13.6569 18 15 16.6569 15 15C15 13.3431 13.6569 12 12 12C10.3431 12 9 13.3431 9 15C9 16.6569 10.3431 18 12 18ZM5 5V9H15V5H5Z"
  }));
},
    Wx = function Wx(_ref1711) {
  var _ref1711$color = _ref1711.color,
      C = _ref1711$color === void 0 ? "currentColor" : _ref1711$color,
      _ref1711$size = _ref1711.size,
      e = _ref1711$size === void 0 ? 24 : _ref1711$size,
      l = _ref1711.className,
      i = _objectWithoutProperties(_ref1711, _excluded1711);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5 5V19H19V7.82843L16.1716 5H5ZM4 3H17L20.7071 6.70711C20.8946 6.89464 21 7.149 21 7.41421V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM12 18C10.3431 18 9 16.6569 9 15C9 13.3431 10.3431 12 12 12C13.6569 12 15 13.3431 15 15C15 16.6569 13.6569 18 12 18ZM6 6H15V10H6V6Z"
  }));
},
    Ox = function Ox(_ref1712) {
  var _ref1712$color = _ref1712.color,
      C = _ref1712$color === void 0 ? "currentColor" : _ref1712$color,
      _ref1712$size = _ref1712.size,
      e = _ref1712$size === void 0 ? 24 : _ref1712$size,
      l = _ref1712.className,
      i = _objectWithoutProperties(_ref1712, _excluded1712);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 3H18L20.7071 5.70711C20.8946 5.89464 21 6.149 21 6.41421V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM7 4V9H16V4H7ZM6 12V19H18V12H6ZM13 5H15V8H13V5Z"
  }));
},
    Kx = function Kx(_ref1713) {
  var _ref1713$color = _ref1713.color,
      C = _ref1713$color === void 0 ? "currentColor" : _ref1713$color,
      _ref1713$size = _ref1713.size,
      e = _ref1713$size === void 0 ? 24 : _ref1713$size,
      l = _ref1713.className,
      i = _objectWithoutProperties(_ref1713, _excluded1713);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18 19H19V6.82843L17.1716 5H16V9H7V5H5V19H6V12H18V19ZM4 3H18L20.7071 5.70711C20.8946 5.89464 21 6.149 21 6.41421V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM8 14V19H16V14H8Z"
  }));
},
    Qx = function Qx(_ref1714) {
  var _ref1714$color = _ref1714.color,
      C = _ref1714$color === void 0 ? "currentColor" : _ref1714$color,
      _ref1714$size = _ref1714.size,
      e = _ref1714$size === void 0 ? 24 : _ref1714$size,
      l = _ref1714.className,
      i = _objectWithoutProperties(_ref1714, _excluded1714);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18 21V13H6V21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3H17L21 7V20C21 20.5523 20.5523 21 20 21H18ZM16 21H8V15H16V21Z"
  }));
},
    qx = function qx(_ref1715) {
  var _ref1715$color = _ref1715.color,
      C = _ref1715$color === void 0 ? "currentColor" : _ref1715$color,
      _ref1715$size = _ref1715.size,
      e = _ref1715$size === void 0 ? 24 : _ref1715$size,
      l = _ref1715.className,
      i = _objectWithoutProperties(_ref1715, _excluded1715);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7 19V13H17V19H19V7.82843L16.1716 5H5V19H7ZM4 3H17L21 7V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM9 15V19H15V15H9Z"
  }));
},
    jx = function jx(_ref1716) {
  var _ref1716$color = _ref1716.color,
      C = _ref1716$color === void 0 ? "currentColor" : _ref1716$color,
      _ref1716$size = _ref1716.size,
      e = _ref1716$size === void 0 ? 24 : _ref1716$size,
      l = _ref1716.className,
      i = _objectWithoutProperties(_ref1716, _excluded1716);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5.99805 2C5.99805 2.51284 6.48805 3 6.99805 3H16.998C17.5109 3 17.998 2.51 17.998 2H19.998C19.998 3.65685 18.6549 5 16.998 5H12.998L12.999 7.06201C16.9449 7.55453 19.998 10.9207 19.998 15V21C19.998 21.5523 19.5503 22 18.998 22H4.99805C4.44576 22 3.99805 21.5523 3.99805 21V15C3.99805 10.9204 7.05176 7.55396 10.9981 7.06189L10.998 5H6.99805C5.33805 5 3.99805 3.66 3.99805 2H5.99805ZM11.998 11C9.78891 11 7.99805 12.7909 7.99805 15C7.99805 17.2091 9.78891 19 11.998 19C14.2072 19 15.998 17.2091 15.998 15C15.998 14.2582 15.7961 13.5635 15.4442 12.968L12.7052 15.7071L12.6109 15.7903C12.2187 16.0953 11.6514 16.0676 11.2909 15.7071C10.9004 15.3166 10.9004 14.6834 11.2909 14.2929L14.03 11.5538C13.4345 11.2019 12.7399 11 11.998 11Z"
  }));
},
    Xx = function Xx(_ref1717) {
  var _ref1717$color = _ref1717.color,
      C = _ref1717$color === void 0 ? "currentColor" : _ref1717$color,
      _ref1717$size = _ref1717.size,
      e = _ref1717$size === void 0 ? 24 : _ref1717$size,
      l = _ref1717.className,
      i = _objectWithoutProperties(_ref1717, _excluded1717);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5.99805 2C5.99805 2.51284 6.48805 3 6.99805 3H16.998C17.5109 3 17.998 2.51 17.998 2H19.998C19.998 3.65685 18.6549 5 16.998 5H12.998L12.999 7.06201C16.9449 7.55453 19.998 10.9207 19.998 15V21C19.998 21.5523 19.5503 22 18.998 22H4.99805C4.44576 22 3.99805 21.5523 3.99805 21V15C3.99805 10.9204 7.05176 7.55396 10.9981 7.06189L10.998 5H6.99805C5.33805 5 3.99805 3.66 3.99805 2H5.99805ZM11.998 9C8.75965 9 5.99805 11.76 5.99805 15V20H17.998V15C17.998 11.7616 15.2364 9 11.998 9ZM11.998 11C12.7399 11 13.4345 11.2019 14.03 11.5538L11.2909 14.2929C10.9004 14.6834 10.9004 15.3166 11.2909 15.7071C11.6514 16.0676 12.2187 16.0953 12.6109 15.7903L12.7052 15.7071L15.4442 12.968C15.7961 13.5635 15.998 14.2582 15.998 15C15.998 17.2091 14.2072 19 11.998 19C9.78891 19 7.99805 17.2091 7.99805 15C7.99805 12.7909 9.78891 11 11.998 11Z"
  }));
},
    Jx = function Jx(_ref1718) {
  var _ref1718$color = _ref1718.color,
      C = _ref1718$color === void 0 ? "currentColor" : _ref1718$color,
      _ref1718$size = _ref1718.size,
      e = _ref1718$size === void 0 ? 24 : _ref1718$size,
      l = _ref1718.className,
      i = _objectWithoutProperties(_ref1718, _excluded1718);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.9985 2L12.9979 3.278L17.9985 4.94591L21.631 3.73509L22.2634 5.63246L19.2319 6.643L22.3272 15.1549C21.2353 16.2921 19.6996 17 17.9985 17C16.2975 17 14.7618 16.2921 13.6699 15.1549L16.7639 6.643L12.9979 5.387V19H16.9985V21H6.99854V19H10.9979V5.387L7.23192 6.643L10.3272 15.1549C9.23528 16.2921 7.69957 17 5.99854 17C4.2975 17 2.76179 16.2921 1.66992 15.1549L4.76392 6.643L1.73363 5.63246L2.36608 3.73509L5.99854 4.94591L10.9979 3.278L10.9985 2H12.9985ZM17.9985 9.10267L16.5809 13H19.4159L17.9985 9.10267ZM5.99854 9.10267L4.58092 13H7.41592L5.99854 9.10267Z"
  }));
},
    Yx = function Yx(_ref1719) {
  var _ref1719$color = _ref1719.color,
      C = _ref1719$color === void 0 ? "currentColor" : _ref1719$color,
      _ref1719$size = _ref1719.size,
      e = _ref1719$size === void 0 ? 24 : _ref1719$size,
      l = _ref1719.className,
      i = _objectWithoutProperties(_ref1719, _excluded1719);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.9985 2L12.9979 3.278L17.9985 4.94591L21.631 3.73509L22.2634 5.63246L19.2319 6.643L22.3272 15.1549C21.2353 16.2921 19.6996 17 17.9985 17C16.2975 17 14.7618 16.2921 13.6699 15.1549L16.7639 6.643L12.9979 5.387V19H16.9985V21H6.99854V19H10.9979V5.387L7.23192 6.643L10.3272 15.1549C9.23528 16.2921 7.69957 17 5.99854 17C4.2975 17 2.76179 16.2921 1.66992 15.1549L4.76392 6.643L1.73363 5.63246L2.36608 3.73509L5.99854 4.94591L10.9979 3.278L10.9985 2H12.9985ZM17.9985 9.10267L16.04 14.4892C16.628 14.8201 17.2979 15 17.9985 15C18.6992 15 19.3691 14.8201 19.957 14.4892L17.9985 9.10267ZM5.99854 9.10267L4.04004 14.4892C4.62795 14.8201 5.29792 15 5.99854 15C6.69916 15 7.36912 14.8201 7.95703 14.4892L5.99854 9.10267Z"
  }));
},
    _x = function _x(_ref1720) {
  var _ref1720$color = _ref1720.color,
      C = _ref1720$color === void 0 ? "currentColor" : _ref1720$color,
      _ref1720$size = _ref1720.size,
      e = _ref1720$size === void 0 ? 24 : _ref1720$size,
      l = _ref1720.className,
      i = _objectWithoutProperties(_ref1720, _excluded1720);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.998 2V3H19.998V5H12.998V19H16.998V21H6.99805V19H10.998V5H3.99805V3H10.998V2H12.998ZM4.99805 6.34315L7.82647 9.17157C8.55033 9.89543 8.99805 10.8954 8.99805 12C8.99805 14.2091 7.20719 16 4.99805 16C2.78891 16 0.998047 14.2091 0.998047 12C0.998047 10.8954 1.44576 9.89543 2.16962 9.17157L4.99805 6.34315ZM18.998 6.34315L21.8265 9.17157C22.5503 9.89543 22.998 10.8954 22.998 12C22.998 14.2091 21.2072 16 18.998 16C16.7889 16 14.998 14.2091 14.998 12C14.998 10.8954 15.4458 9.89543 16.1696 9.17157L18.998 6.34315ZM18.998 9.17157L17.5838 10.5858C17.2099 10.9597 16.998 11.4606 16.998 12L20.998 12.001C20.998 11.4606 20.7862 10.9597 20.4123 10.5858L18.998 9.17157ZM4.99805 9.17157L3.58383 10.5858C3.20988 10.9597 2.99805 11.4606 2.99805 12L6.99805 12.001C6.99805 11.4606 6.78621 10.9597 6.41226 10.5858L4.99805 9.17157Z"
  }));
},
    $x = function $x(_ref1721) {
  var _ref1721$color = _ref1721.color,
      C = _ref1721$color === void 0 ? "currentColor" : _ref1721$color,
      _ref1721$size = _ref1721.size,
      e = _ref1721$size === void 0 ? 24 : _ref1721$size,
      l = _ref1721.className,
      i = _objectWithoutProperties(_ref1721, _excluded1721);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.998 2V3H19.998V5H12.998V19H16.998V21H6.99805V19H10.998V5H3.99805V3H10.998V2H12.998ZM4.99805 6.34315L7.82647 9.17157C8.55033 9.89543 8.99805 10.8954 8.99805 12C8.99805 14.2091 7.20719 16 4.99805 16C2.78891 16 0.998047 14.2091 0.998047 12C0.998047 10.8954 1.44576 9.89543 2.16962 9.17157L4.99805 6.34315ZM18.998 6.34315L21.8265 9.17157C22.5503 9.89543 22.998 10.8954 22.998 12C22.998 14.2091 21.2072 16 18.998 16C16.7889 16 14.998 14.2091 14.998 12C14.998 10.8954 15.4458 9.89543 16.1696 9.17157L18.998 6.34315ZM4.99805 9.17157L3.58383 10.5858C3.20988 10.9597 2.99805 11.4606 2.99805 12C2.99805 13.1046 3.89348 14 4.99805 14C6.10262 14 6.99805 13.1046 6.99805 12C6.99805 11.4606 6.78621 10.9597 6.41226 10.5858L4.99805 9.17157ZM18.998 9.17157L17.5838 10.5858C17.2099 10.9597 16.998 11.4606 16.998 12C16.998 13.1046 17.8935 14 18.998 14C20.1026 14 20.998 13.1046 20.998 12C20.998 11.4606 20.7862 10.9597 20.4123 10.5858L18.998 9.17157Z"
  }));
},
    ev = function ev(_ref1722) {
  var _ref1722$color = _ref1722.color,
      C = _ref1722$color === void 0 ? "currentColor" : _ref1722$color,
      _ref1722$size = _ref1722.size,
      e = _ref1722$size === void 0 ? 24 : _ref1722$size,
      l = _ref1722.className,
      i = _objectWithoutProperties(_ref1722, _excluded1722);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4.25705 5.67127L6.39362 7.80783C5.5184 8.97641 5 10.4277 5 12C5 15.866 8.13401 19 12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C10.4277 5 8.97641 5.5184 7.80783 6.39362L5.67127 4.25705C7.39514 2.84637 9.59873 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 9.59873 2.84637 7.39514 4.25705 5.67127ZM7.8284 9.24261L12 13.4142L13.4142 12L9.24261 7.8284C10.033 7.30488 10.9809 7 12 7C14.7614 7 17 9.23858 17 12C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12C7 10.9809 7.30488 10.033 7.8284 9.24261Z"
  }));
},
    tv = function tv(_ref1723) {
  var _ref1723$color = _ref1723.color,
      C = _ref1723$color === void 0 ? "currentColor" : _ref1723$color,
      _ref1723$size = _ref1723.size,
      e = _ref1723$size === void 0 ? 24 : _ref1723$size,
      l = _ref1723.className,
      i = _objectWithoutProperties(_ref1723, _excluded1723);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5.67127 4.25705L13.4142 12L12 13.4142L8.55382 9.96803C8.20193 10.5635 8 11.2582 8 12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12C16 9.87494 14.3429 8.13693 12.2503 8.00771L10.4459 6.20323C10.9416 6.07067 11.4625 6 12 6C15.3137 6 18 8.68629 18 12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12C6 10.7042 6.41079 9.50428 7.10925 8.52347L5.68014 7.09436C4.62708 8.44904 4 10.1513 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C10.8915 4 9.83557 4.22547 8.8757 4.63306L7.37443 3.13179C8.75768 2.40883 10.3311 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 8.87842 3.43029 6.09091 5.67127 4.25705Z"
  }));
},
    Cv = function Cv(_ref1724) {
  var _ref1724$color = _ref1724.color,
      C = _ref1724$color === void 0 ? "currentColor" : _ref1724$color,
      _ref1724$size = _ref1724.size,
      e = _ref1724$size === void 0 ? 24 : _ref1724$size,
      l = _ref1724.className,
      i = _objectWithoutProperties(_ref1724, _excluded1724);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4.25705 5.67127L12 13.4142L13.4142 12L5.67127 4.25705C7.39514 2.84637 9.59873 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 9.59873 2.84637 7.39514 4.25705 5.67127Z"
  }));
},
    lv = function lv(_ref1725) {
  var _ref1725$color = _ref1725.color,
      C = _ref1725$color === void 0 ? "currentColor" : _ref1725$color,
      _ref1725$size = _ref1725.size,
      e = _ref1725$size === void 0 ? 24 : _ref1725$size,
      l = _ref1725.className,
      i = _objectWithoutProperties(_ref1725, _excluded1725);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5.67127 4.25705L13.4142 12L12 13.4142L5.68014 7.09436C4.62708 8.44904 4 10.1513 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C11.0848 4 10.2054 4.15369 9.38641 4.43667L7.84921 2.89947C9.11354 2.32187 10.5192 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 8.87842 3.43029 6.09091 5.67127 4.25705Z"
  }));
},
    iv = function iv(_ref1726) {
  var _ref1726$color = _ref1726.color,
      C = _ref1726$color === void 0 ? "currentColor" : _ref1726$color,
      _ref1726$size = _ref1726.size,
      e = _ref1726$size === void 0 ? 24 : _ref1726$size,
      l = _ref1726.className,
      i = _objectWithoutProperties(_ref1726, _excluded1726);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 14.1179L9.68347 16.4345C9.88726 16.9144 10 17.4423 10 17.9966C10 20.2058 8.20914 21.9966 6 21.9966C3.79086 21.9966 2 20.2058 2 17.9966C2 15.7875 3.79086 13.9966 6 13.9966C6.55427 13.9966 7.08222 14.1094 7.56215 14.3131L9.87868 11.9966L4.21142 6.32936C3.43037 5.54831 3.43037 4.28198 4.21142 3.50093L4.91852 2.79382L12 9.8753L19.0815 2.79382L19.7886 3.50093C20.5696 4.28198 20.5696 5.54831 19.7886 6.32936L14.1213 11.9966L16.4379 14.3131C16.9178 14.1094 17.4457 13.9966 18 13.9966C20.2091 13.9966 22 15.7875 22 17.9966C22 20.2058 20.2091 21.9966 18 21.9966C15.7909 21.9966 14 20.2058 14 17.9966C14 17.4423 14.1127 16.9144 14.3165 16.4345L12 14.1179ZM6 19.9966C7.10457 19.9966 8 19.1012 8 17.9966C8 16.892 7.10457 15.9966 6 15.9966C4.89543 15.9966 4 16.892 4 17.9966C4 19.1012 4.89543 19.9966 6 19.9966ZM18 19.9966C19.1046 19.9966 20 19.1012 20 17.9966C20 16.892 19.1046 15.9966 18 15.9966C16.8954 15.9966 16 16.892 16 17.9966C16 19.1012 16.8954 19.9966 18 19.9966Z"
  }));
},
    sv = function sv(_ref1727) {
  var _ref1727$color = _ref1727.color,
      C = _ref1727$color === void 0 ? "currentColor" : _ref1727$color,
      _ref1727$size = _ref1727.size,
      e = _ref1727$size === void 0 ? 24 : _ref1727$size,
      l = _ref1727.className,
      i = _objectWithoutProperties(_ref1727, _excluded1727);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 13.4108L9.44618 15.9646C9.79807 16.5601 10 17.2548 10 17.9966C10 20.2057 8.20914 21.9966 6 21.9966C3.79086 21.9966 2 20.2057 2 17.9966C2 15.7874 3.79086 13.9966 6 13.9966C6.74181 13.9966 7.43645 14.1985 8.03197 14.5504L10.5858 11.9966L4.56497 5.97577C3.78392 5.19472 3.78392 3.92839 4.56497 3.14734L12 10.5824L19.435 3.14734C20.2161 3.92839 20.2161 5.19472 19.435 5.97577L13.4142 11.9966L15.968 14.5504C16.5635 14.1985 17.2582 13.9966 18 13.9966C20.2091 13.9966 22 15.7874 22 17.9966C22 20.2057 20.2091 21.9966 18 21.9966C15.7909 21.9966 14 20.2057 14 17.9966C14 17.2548 14.2019 16.5601 14.5538 15.9646L12 13.4108ZM6 19.9966C7.10457 19.9966 8 19.1012 8 17.9966C8 16.892 7.10457 15.9966 6 15.9966C4.89543 15.9966 4 16.892 4 17.9966C4 19.1012 4.89543 19.9966 6 19.9966ZM18 19.9966C19.1046 19.9966 20 19.1012 20 17.9966C20 16.892 19.1046 15.9966 18 15.9966C16.8954 15.9966 16 16.892 16 17.9966C16 19.1012 16.8954 19.9966 18 19.9966Z"
  }));
},
    rv = function rv(_ref1728) {
  var _ref1728$color = _ref1728.color,
      C = _ref1728$color === void 0 ? "currentColor" : _ref1728$color,
      _ref1728$size = _ref1728.size,
      e = _ref1728$size === void 0 ? 24 : _ref1728$size,
      l = _ref1728.className,
      i = _objectWithoutProperties(_ref1728, _excluded1728);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9.87868 11.9967L7.56215 9.68017C7.08222 9.88397 6.55427 9.9967 6 9.9967C3.79086 9.9967 2 8.20584 2 5.9967C2 3.78756 3.79086 1.9967 6 1.9967C8.20914 1.9967 10 3.78756 10 5.9967C10 6.55098 9.88726 7.07892 9.68347 7.55885L12 9.87538L18.3744 3.50102C19.1554 2.71997 20.4217 2.71997 21.2028 3.50102L21.9099 4.20812L9.68347 16.4346C9.88726 16.9145 10 17.4424 10 17.9967C10 20.2058 8.20914 21.9967 6 21.9967C3.79086 21.9967 2 20.2058 2 17.9967C2 15.7876 3.79086 13.9967 6 13.9967C6.55427 13.9967 7.08222 14.1094 7.56215 14.3132L9.87868 11.9967ZM6 7.9967C7.10457 7.9967 8 7.10127 8 5.9967C8 4.89213 7.10457 3.9967 6 3.9967C4.89543 3.9967 4 4.89213 4 5.9967C4 7.10127 4.89543 7.9967 6 7.9967ZM6 19.9967C7.10457 19.9967 8 19.1013 8 17.9967C8 16.8921 7.10457 15.9967 6 15.9967C4.89543 15.9967 4 16.8921 4 17.9967C4 19.1013 4.89543 19.9967 6 19.9967ZM15.5346 13.41L21.9099 19.7853L21.2028 20.4924C20.4217 21.2734 19.1554 21.2734 18.3744 20.4924L13.4133 15.5313L15.5346 13.41ZM16 10.9967H18V12.9967H16V10.9967ZM20 10.9967H22V12.9967H20V10.9967ZM6 10.9967H8V12.9967H6V10.9967ZM2 10.9967H4V12.9967H2V10.9967Z"
  }));
},
    cv = function cv(_ref1729) {
  var _ref1729$color = _ref1729.color,
      C = _ref1729$color === void 0 ? "currentColor" : _ref1729$color,
      _ref1729$size = _ref1729.size,
      e = _ref1729$size === void 0 ? 24 : _ref1729$size,
      l = _ref1729.className,
      i = _objectWithoutProperties(_ref1729, _excluded1729);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10 5.9967C10 6.7292 9.80311 7.41571 9.45936 8.0062L12 10.5825L18.7279 3.85457C19.509 3.07352 20.7753 3.07352 21.5563 3.85457L9.44618 15.9647C9.79807 16.5603 10 17.2549 10 17.9967C10 20.2058 8.20914 21.9967 6 21.9967C3.79086 21.9967 2 20.2058 2 17.9967C2 15.7876 3.79086 13.9967 6 13.9967C6.74181 13.9967 7.43645 14.1986 8.03197 14.5505L10.5858 11.9967L8.03197 9.44289C7.43645 9.79478 6.74181 9.9967 6 9.9967C3.79086 9.9967 2 8.20584 2 5.9967C2 3.78756 3.79086 1.9967 6 1.9967C8.20914 1.9967 10 3.78756 10 5.9967ZM8 5.9967C8 4.89213 7.10457 3.9967 6 3.9967C4.89543 3.9967 4 4.89213 4 5.9967C4 7.10127 4.89543 7.9967 6 7.9967C7.10457 7.9967 8 7.10127 8 5.9967ZM21.5563 20.1388C20.7753 20.9199 19.509 20.9199 18.7279 20.1388L13.4113 14.8222L14.8255 13.408L21.5563 20.1388ZM16 10.9967H18V12.9967H16V10.9967ZM20 10.9967H22V12.9967H20V10.9967ZM6 10.9967H8V12.9967H6V10.9967ZM2 10.9967H4V12.9967H2V10.9967ZM6 19.9967C7.10457 19.9967 8 19.1013 8 17.9967C8 16.8921 7.10457 15.9967 6 15.9967C4.89543 15.9967 4 16.8921 4 17.9967C4 19.1013 4.89543 19.9967 6 19.9967Z"
  }));
},
    ov = function ov(_ref1730) {
  var _ref1730$color = _ref1730.color,
      C = _ref1730$color === void 0 ? "currentColor" : _ref1730$color,
      _ref1730$size = _ref1730.size,
      e = _ref1730$size === void 0 ? 24 : _ref1730$size,
      l = _ref1730.className,
      i = _objectWithoutProperties(_ref1730, _excluded1730);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9.68347 7.55885L12 9.87538L18.3744 3.50102C19.1554 2.71997 20.4217 2.71997 21.2028 3.50102L21.9099 4.20812L9.68347 16.4346C9.88726 16.9145 10 17.4424 10 17.9967C10 20.2058 8.20914 21.9967 6 21.9967C3.79086 21.9967 2 20.2058 2 17.9967C2 15.7876 3.79086 13.9967 6 13.9967C6.55427 13.9967 7.08222 14.1094 7.56215 14.3132L9.87868 11.9967L7.56215 9.68017C7.08222 9.88397 6.55427 9.9967 6 9.9967C3.79086 9.9967 2 8.20584 2 5.9967C2 3.78756 3.79086 1.9967 6 1.9967C8.20914 1.9967 10 3.78756 10 5.9967C10 6.55098 9.88726 7.07892 9.68347 7.55885ZM6 7.9967C7.10457 7.9967 8 7.10127 8 5.9967C8 4.89213 7.10457 3.9967 6 3.9967C4.89543 3.9967 4 4.89213 4 5.9967C4 7.10127 4.89543 7.9967 6 7.9967ZM6 19.9967C7.10457 19.9967 8 19.1013 8 17.9967C8 16.8921 7.10457 15.9967 6 15.9967C4.89543 15.9967 4 16.8921 4 17.9967C4 19.1013 4.89543 19.9967 6 19.9967ZM15.5346 13.41L21.9099 19.7853L21.2028 20.4924C20.4217 21.2734 19.1554 21.2734 18.3744 20.4924L13.4133 15.5313L15.5346 13.41Z"
  }));
},
    av = function av(_ref1731) {
  var _ref1731$color = _ref1731.color,
      C = _ref1731$color === void 0 ? "currentColor" : _ref1731$color,
      _ref1731$size = _ref1731.size,
      e = _ref1731$size === void 0 ? 24 : _ref1731$size,
      l = _ref1731.className,
      i = _objectWithoutProperties(_ref1731, _excluded1731);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9.44618 8.02867L12 10.5825L18.7279 3.85457C19.509 3.07352 20.7753 3.07352 21.5563 3.85457L9.44618 15.9647C9.79807 16.5603 10 17.2549 10 17.9967C10 20.2058 8.20914 21.9967 6 21.9967C3.79086 21.9967 2 20.2058 2 17.9967C2 15.7876 3.79086 13.9967 6 13.9967C6.74181 13.9967 7.43645 14.1986 8.03197 14.5505L10.5858 11.9967L8.03197 9.44289C7.43645 9.79478 6.74181 9.9967 6 9.9967C3.79086 9.9967 2 8.20584 2 5.9967C2 3.78756 3.79086 1.9967 6 1.9967C8.20914 1.9967 10 3.78756 10 5.9967C10 6.73851 9.79807 7.43316 9.44618 8.02867ZM14.8255 13.408L21.5563 20.1388C20.7753 20.9199 19.509 20.9199 18.7279 20.1388L13.4113 14.8222L14.8255 13.408ZM7.41421 16.5825C7.05228 16.2206 6.55228 15.9967 6 15.9967C4.89543 15.9967 4 16.8921 4 17.9967C4 19.1013 4.89543 19.9967 6 19.9967C7.10457 19.9967 8 19.1013 8 17.9967C8 17.4444 7.77614 16.9444 7.41421 16.5825ZM7.41421 7.41092C7.77614 7.04899 8 6.54899 8 5.9967C8 4.89213 7.10457 3.9967 6 3.9967C4.89543 3.9967 4 4.89213 4 5.9967C4 7.10127 4.89543 7.9967 6 7.9967C6.55228 7.9967 7.05228 7.77285 7.41421 7.41092Z"
  }));
},
    nv = function nv(_ref1732) {
  var _ref1732$color = _ref1732.color,
      C = _ref1732$color === void 0 ? "currentColor" : _ref1732$color,
      _ref1732$size = _ref1732.size,
      e = _ref1732$size === void 0 ? 24 : _ref1732$size,
      l = _ref1732.className,
      i = _objectWithoutProperties(_ref1732, _excluded1732);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 3H5V5H3V3ZM7 3H9V5H7V3ZM11 3H13V5H11V3ZM15 3H17V5H15V3ZM19 3H21V5H19V3ZM19 7H21V9H19V7ZM3 19H5V21H3V19ZM3 15H5V17H3V15ZM3 11H5V13H3V11ZM3 7H5V9H3V7ZM10.6667 11L11.7031 9.4453C11.8886 9.1671 12.2008 9 12.5352 9H15.4648C15.7992 9 16.1114 9.1671 16.2969 9.4453L17.3333 11H20C20.5523 11 21 11.4477 21 12V20C21 20.5523 20.5523 21 20 21H8C7.44772 21 7 20.5523 7 20V12C7 11.4477 7.44772 11 8 11H10.6667ZM14 18C15.1046 18 16 17.1046 16 16C16 14.8954 15.1046 14 14 14C12.8954 14 12 14.8954 12 16C12 17.1046 12.8954 18 14 18Z"
  }));
},
    mv = function mv(_ref1733) {
  var _ref1733$color = _ref1733.color,
      C = _ref1733$color === void 0 ? "currentColor" : _ref1733$color,
      _ref1733$size = _ref1733.size,
      e = _ref1733$size === void 0 ? 24 : _ref1733$size,
      l = _ref1733.className,
      i = _objectWithoutProperties(_ref1733, _excluded1733);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 3H5V5H3V3ZM7 3H9V5H7V3ZM11 3H13V5H11V3ZM15 3H17V5H15V3ZM19 3H21V5H19V3ZM19 7H21V9H19V7ZM3 19H5V21H3V19ZM3 15H5V17H3V15ZM3 11H5V13H3V11ZM3 7H5V9H3V7ZM10.6667 11L11.7031 9.4453C11.8886 9.1671 12.2008 9 12.5352 9H15.4648C15.7992 9 16.1114 9.1671 16.2969 9.4453L17.3333 11H20C20.5523 11 21 11.4477 21 12V20C21 20.5523 20.5523 21 20 21H8C7.44772 21 7 20.5523 7 20V12C7 11.4477 7.44772 11 8 11H10.6667ZM9 19H19V13H16.263L14.9296 11H13.0704L11.737 13H9V19ZM14 18C12.8954 18 12 17.1046 12 16C12 14.8954 12.8954 14 14 14C15.1046 14 16 14.8954 16 16C16 17.1046 15.1046 18 14 18Z"
  }));
},
    wv = function wv(_ref1734) {
  var _ref1734$color = _ref1734.color,
      C = _ref1734$color === void 0 ? "currentColor" : _ref1734$color,
      _ref1734$size = _ref1734.size,
      e = _ref1734$size === void 0 ? 24 : _ref1734$size,
      l = _ref1734.className,
      i = _objectWithoutProperties(_ref1734, _excluded1734);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11.9926 14.4068L10.4406 15.9587C10.7959 16.5563 11 17.2543 11 18C11 20.2091 9.20914 22 7 22C4.79086 22 3 20.2091 3 18C3 15.7909 4.79086 14 7 14C7.73792 14 8.42917 14.1998 9.0226 14.5483L10.5783 12.9926L7.45406 9.86827C6.86827 9.28249 6.86827 8.33274 7.45406 7.74695L7.80761 7.3934L11.9926 11.5783L16.1819 7.38904L16.5354 7.74259C17.1212 8.32838 17.1212 9.27813 16.5354 9.86391L13.4068 12.9926L14.968 14.5538C15.5635 14.2019 16.2582 14 17 14C19.2091 14 21 15.7909 21 18C21 20.2091 19.2091 22 17 22C14.7909 22 13 20.2091 13 18C13 17.2582 13.2019 16.5635 13.5538 15.968L11.9926 14.4068ZM19 13V5H5V13H3V4C3 3.44772 3.44772 3 4 3H20C20.5523 3 21 3.44772 21 4V13H19ZM7 20C8.10457 20 9 19.1046 9 18C9 16.8954 8.10457 16 7 16C5.89543 16 5 16.8954 5 18C5 19.1046 5.89543 20 7 20ZM17 20C18.1046 20 19 19.1046 19 18C19 16.8954 18.1046 16 17 16C15.8954 16 15 16.8954 15 18C15 19.1046 15.8954 20 17 20Z"
  }));
},
    Lv = function Lv(_ref1735) {
  var _ref1735$color = _ref1735.color,
      C = _ref1735$color === void 0 ? "currentColor" : _ref1735$color,
      _ref1735$size = _ref1735.size,
      e = _ref1735$size === void 0 ? 24 : _ref1735$size,
      l = _ref1735.className,
      i = _objectWithoutProperties(_ref1735, _excluded1735);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11.9926 14.4068L10.4406 15.9587C10.7959 16.5563 11 17.2543 11 18C11 20.2091 9.20914 22 7 22C4.79086 22 3 20.2091 3 18C3 15.7909 4.79086 14 7 14C7.73792 14 8.42917 14.1998 9.0226 14.5483L10.5783 12.9926L6.3934 8.80761L7.80761 7.3934L11.9926 11.5783L16.1819 7.38904L17.5961 8.80325L13.4068 12.9926L14.968 14.5538C15.5635 14.2019 16.2582 14 17 14C19.2091 14 21 15.7909 21 18C21 20.2091 19.2091 22 17 22C14.7909 22 13 20.2091 13 18C13 17.2582 13.2019 16.5635 13.5538 15.968L11.9926 14.4068ZM7 20C8.10457 20 9 19.1046 9 18C9 16.8954 8.10457 16 7 16C5.89543 16 5 16.8954 5 18C5 19.1046 5.89543 20 7 20ZM17 20C18.1046 20 19 19.1046 19 18C19 16.8954 18.1046 16 17 16C15.8954 16 15 16.8954 15 18C15 19.1046 15.8954 20 17 20ZM19 13V5H5V13H3V4C3 3.44772 3.44772 3 4 3H20C20.5523 3 21 3.44772 21 4V13H19Z"
  }));
},
    hv = function hv(_ref1736) {
  var _ref1736$color = _ref1736.color,
      C = _ref1736$color === void 0 ? "currentColor" : _ref1736$color,
      _ref1736$size = _ref1736.size,
      e = _ref1736$size === void 0 ? 24 : _ref1736$size,
      l = _ref1736.className,
      i = _objectWithoutProperties(_ref1736, _excluded1736);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4.29289 6.70711L9 2H19C19.5523 2 20 2.44772 20 3V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V7.41421C4 7.149 4.10536 6.89464 4.29289 6.70711ZM15 5V9H17V5H15ZM12 5V9H14V5H12ZM9 5V9H11V5H9Z"
  }));
},
    Hv = function Hv(_ref1737) {
  var _ref1737$color = _ref1737.color,
      C = _ref1737$color === void 0 ? "currentColor" : _ref1737$color,
      _ref1737$size = _ref1737.size,
      e = _ref1737$size === void 0 ? 24 : _ref1737$size,
      l = _ref1737.className,
      i = _objectWithoutProperties(_ref1737, _excluded1737);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6 7.82843V20H18V4H9.82843L6 7.82843ZM4.29289 6.70711L9 2H19C19.5523 2 20 2.44772 20 3V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V7.41421C4 7.149 4.10536 6.89464 4.29289 6.70711ZM15 5H17V9H15V5ZM12 5H14V9H12V5ZM9 6H11V9H9V6Z"
  }));
},
    Vv = function Vv(_ref1738) {
  var _ref1738$color = _ref1738.color,
      C = _ref1738$color === void 0 ? "currentColor" : _ref1738$color,
      _ref1738$size = _ref1738.size,
      e = _ref1738$size === void 0 ? 24 : _ref1738$size,
      l = _ref1738.className,
      i = _objectWithoutProperties(_ref1738, _excluded1738);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7 2H19C19.5523 2 20 2.44772 20 3V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V12.4196C4 12.1549 4.10493 11.901 4.29179 11.7135L5.8541 10.1464C5.94754 10.0526 6 9.92569 6 9.79335V3C6 2.44772 6.44772 2 7 2ZM15 4V8H17V4H15ZM12 4V8H14V4H12ZM9 4V8H11V4H9Z"
  }));
},
    gv = function gv(_ref1739) {
  var _ref1739$color = _ref1739.color,
      C = _ref1739$color === void 0 ? "currentColor" : _ref1739$color,
      _ref1739$size = _ref1739.size,
      e = _ref1739$size === void 0 ? 24 : _ref1739$size,
      l = _ref1739.className,
      i = _objectWithoutProperties(_ref1739, _excluded1739);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8 4V9.79335C8 10.455 7.73768 11.0897 7.27052 11.5584L6 12.8329V20H18V4H8ZM7 2H19C19.5523 2 20 2.44772 20 3V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V12.4196C4 12.1549 4.10493 11.901 4.29179 11.7135L5.8541 10.1464C5.94754 10.0526 6 9.92569 6 9.79335V3C6 2.44772 6.44772 2 7 2ZM15 5H17V9H15V5ZM12 5H14V9H12V5ZM9 5H11V9H9V5Z"
  }));
},
    Mv = function Mv(_ref1740) {
  var _ref1740$color = _ref1740.color,
      C = _ref1740$color === void 0 ? "currentColor" : _ref1740$color,
      _ref1740$size = _ref1740.size,
      e = _ref1740$size === void 0 ? 24 : _ref1740$size,
      l = _ref1740.className,
      i = _objectWithoutProperties(_ref1740, _excluded1740);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11 2C15.968 2 20 6.032 20 11C20 15.968 15.968 20 11 20C6.032 20 2 15.968 2 11C2 6.032 6.032 2 11 2ZM19.4853 18.0711L22.3137 20.8995L20.8995 22.3137L18.0711 19.4853L19.4853 18.0711Z"
  }));
},
    Zv = function Zv(_ref1741) {
  var _ref1741$color = _ref1741.color,
      C = _ref1741$color === void 0 ? "currentColor" : _ref1741$color,
      _ref1741$size = _ref1741.size,
      e = _ref1741$size === void 0 ? 24 : _ref1741$size,
      l = _ref1741.className,
      i = _objectWithoutProperties(_ref1741, _excluded1741);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11 2C15.968 2 20 6.032 20 11C20 15.968 15.968 20 11 20C6.032 20 2 15.968 2 11C2 6.032 6.032 2 11 2ZM11 18C14.8675 18 18 14.8675 18 11C18 7.1325 14.8675 4 11 4C7.1325 4 4 7.1325 4 11C4 14.8675 7.1325 18 11 18ZM19.4853 18.0711L22.3137 20.8995L20.8995 22.3137L18.0711 19.4853L19.4853 18.0711Z"
  }));
},
    xv = function xv(_ref1742) {
  var _ref1742$color = _ref1742.color,
      C = _ref1742$color === void 0 ? "currentColor" : _ref1742$color,
      _ref1742$size = _ref1742.size,
      e = _ref1742$size === void 0 ? 24 : _ref1742$size,
      l = _ref1742.className,
      i = _objectWithoutProperties(_ref1742, _excluded1742);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18.031 16.6168L22.3137 20.8995L20.8995 22.3137L16.6168 18.031C15.0769 19.263 13.124 20 11 20C6.032 20 2 15.968 2 11C2 6.032 6.032 2 11 2C15.968 2 20 6.032 20 11C20 13.124 19.263 15.0769 18.031 16.6168ZM12.1779 7.17624C11.8055 7.06167 11.41 7 11 7C8.79086 7 7 8.79086 7 11C7 13.2091 8.79086 15 11 15C13.2091 15 15 13.2091 15 11C15 10.59 14.9383 10.1945 14.8238 9.82212C14.5102 10.5166 13.8115 11 13 11C11.8954 11 11 10.1046 11 9C11 8.18846 11.4834 7.48982 12.1779 7.17624Z"
  }));
},
    vv = function vv(_ref1743) {
  var _ref1743$color = _ref1743.color,
      C = _ref1743$color === void 0 ? "currentColor" : _ref1743$color,
      _ref1743$size = _ref1743.size,
      e = _ref1743$size === void 0 ? 24 : _ref1743$size,
      l = _ref1743.className,
      i = _objectWithoutProperties(_ref1743, _excluded1743);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18.031 16.6168L22.3137 20.8995L20.8995 22.3137L16.6168 18.031C15.0769 19.263 13.124 20 11 20C6.032 20 2 15.968 2 11C2 6.032 6.032 2 11 2C15.968 2 20 6.032 20 11C20 13.124 19.263 15.0769 18.031 16.6168ZM16.0247 15.8748C17.2475 14.6146 18 12.8956 18 11C18 7.1325 14.8675 4 11 4C7.1325 4 4 7.1325 4 11C4 14.8675 7.1325 18 11 18C12.8956 18 14.6146 17.2475 15.8748 16.0247L16.0247 15.8748ZM12.1779 7.17624C11.4834 7.48982 11 8.18846 11 9C11 10.1046 11.8954 11 13 11C13.8115 11 14.5102 10.5166 14.8238 9.82212C14.9383 10.1945 15 10.59 15 11C15 13.2091 13.2091 15 11 15C8.79086 15 7 13.2091 7 11C7 8.79086 8.79086 7 11 7C11.41 7 11.8055 7.06167 12.1779 7.17624Z"
  }));
},
    dv = function dv(_ref1744) {
  var _ref1744$color = _ref1744.color,
      C = _ref1744$color === void 0 ? "currentColor" : _ref1744$color,
      _ref1744$size = _ref1744.size,
      e = _ref1744$size === void 0 ? 24 : _ref1744$size,
      l = _ref1744.className,
      i = _objectWithoutProperties(_ref1744, _excluded1744);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18.031 16.6168L22.3137 20.8995L20.8995 22.3137L16.6168 18.031C15.0769 19.263 13.124 20 11 20C6.032 20 2 15.968 2 11C2 6.032 6.032 2 11 2C15.968 2 20 6.032 20 11C20 13.124 19.263 15.0769 18.031 16.6168Z"
  }));
},
    pv = function pv(_ref1745) {
  var _ref1745$color = _ref1745.color,
      C = _ref1745$color === void 0 ? "currentColor" : _ref1745$color,
      _ref1745$size = _ref1745.size,
      e = _ref1745$size === void 0 ? 24 : _ref1745$size,
      l = _ref1745.className,
      i = _objectWithoutProperties(_ref1745, _excluded1745);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18.031 16.6168L22.3137 20.8995L20.8995 22.3137L16.6168 18.031C15.0769 19.263 13.124 20 11 20C6.032 20 2 15.968 2 11C2 6.032 6.032 2 11 2C15.968 2 20 6.032 20 11C20 13.124 19.263 15.0769 18.031 16.6168ZM16.0247 15.8748C17.2475 14.6146 18 12.8956 18 11C18 7.1325 14.8675 4 11 4C7.1325 4 4 7.1325 4 11C4 14.8675 7.1325 18 11 18C12.8956 18 14.6146 17.2475 15.8748 16.0247L16.0247 15.8748Z"
  }));
},
    Ev = function Ev(_ref1746) {
  var _ref1746$color = _ref1746.color,
      C = _ref1746$color === void 0 ? "currentColor" : _ref1746$color,
      _ref1746$size = _ref1746.size,
      e = _ref1746$size === void 0 ? 24 : _ref1746$size,
      l = _ref1746.className,
      i = _objectWithoutProperties(_ref1746, _excluded1746);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11.0049 2L18.3032 4.28071C18.7206 4.41117 19.0049 4.79781 19.0049 5.23519V7H21.0049C21.5572 7 22.0049 7.44772 22.0049 8V10H9.00488V8C9.00488 7.44772 9.4526 7 10.0049 7H17.0049V5.97L11.0049 4.094L5.00488 5.97V13.3744C5.00488 14.6193 5.58406 15.7884 6.56329 16.5428L6.75154 16.6793L11.0049 19.579L14.7869 17H10.0049C9.4526 17 9.00488 16.5523 9.00488 16V12H22.0049V16C22.0049 16.5523 21.5572 17 21.0049 17L17.7848 17.0011C17.3982 17.5108 16.9276 17.9618 16.3849 18.3318L11.0049 22L5.62486 18.3318C3.98563 17.2141 3.00488 15.3584 3.00488 13.3744V5.23519C3.00488 4.79781 3.28913 4.41117 3.70661 4.28071L11.0049 2Z"
  }));
},
    Nv = function Nv(_ref1747) {
  var _ref1747$color = _ref1747.color,
      C = _ref1747$color === void 0 ? "currentColor" : _ref1747$color,
      _ref1747$size = _ref1747.size,
      e = _ref1747$size === void 0 ? 24 : _ref1747$size,
      l = _ref1747.className,
      i = _objectWithoutProperties(_ref1747, _excluded1747);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11.0049 2L18.3032 4.28071C18.7206 4.41117 19.0049 4.79781 19.0049 5.23519V7H21.0049C21.5572 7 22.0049 7.44772 22.0049 8V16C22.0049 16.5523 21.5572 17 21.0049 17L17.7848 17.0011C17.3982 17.5108 16.9276 17.9618 16.3849 18.3318L11.0049 22L5.62486 18.3318C3.98563 17.2141 3.00488 15.3584 3.00488 13.3744V5.23519C3.00488 4.79781 3.28913 4.41117 3.70661 4.28071L11.0049 2ZM11.0049 4.094L5.00488 5.97V13.3744C5.00488 14.6193 5.58406 15.7884 6.56329 16.5428L6.75154 16.6793L11.0049 19.579L14.7869 17H10.0049C9.4526 17 9.00488 16.5523 9.00488 16V8C9.00488 7.44772 9.4526 7 10.0049 7H17.0049V5.97L11.0049 4.094ZM11.0049 12V15H20.0049V12H11.0049ZM11.0049 10H20.0049V9H11.0049V10Z"
  }));
},
    uv = function uv(_ref1748) {
  var _ref1748$color = _ref1748.color,
      C = _ref1748$color === void 0 ? "currentColor" : _ref1748$color,
      _ref1748$size = _ref1748.size,
      e = _ref1748$size === void 0 ? 24 : _ref1748$size,
      l = _ref1748.className,
      i = _objectWithoutProperties(_ref1748, _excluded1748);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21.998 7V9.5C21.998 13.0899 19.0879 16 15.498 16H12.998V21H10.998V14L11.0169 13.0007C11.2719 9.64413 14.0762 7 17.498 7H21.998ZM5.99805 3C9.0904 3 11.7144 5.00519 12.6408 7.78626C11.1417 9.06119 10.1516 10.9143 10.0144 13.0004L8.99805 13C5.13205 13 1.99805 9.86599 1.99805 6V3H5.99805Z"
  }));
},
    Bv = function Bv(_ref1749) {
  var _ref1749$color = _ref1749.color,
      C = _ref1749$color === void 0 ? "currentColor" : _ref1749$color,
      _ref1749$size = _ref1749.size,
      e = _ref1749$size === void 0 ? 24 : _ref1749$size,
      l = _ref1749.className,
      i = _objectWithoutProperties(_ref1749, _excluded1749);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5.99805 3C9.48787 3 12.3812 5.55379 12.9112 8.8945C14.0863 7.72389 15.7076 7 17.498 7H21.998V9.5C21.998 13.0899 19.0879 16 15.498 16H12.998V21H10.998V13H8.99805C5.13205 13 1.99805 9.86599 1.99805 6V3H5.99805ZM19.998 9H17.498C15.0128 9 12.998 11.0147 12.998 13.5V14H15.498C17.9833 14 19.998 11.9853 19.998 9.5V9ZM5.99805 5H3.99805V6C3.99805 8.76142 6.23662 11 8.99805 11H10.998V10C10.998 7.23858 8.75947 5 5.99805 5Z"
  }));
},
    fv = function fv(_ref1750) {
  var _ref1750$color = _ref1750.color,
      C = _ref1750$color === void 0 ? "currentColor" : _ref1750$color,
      _ref1750$size = _ref1750.size,
      e = _ref1750$size === void 0 ? 24 : _ref1750$size,
      l = _ref1750.className,
      i = _objectWithoutProperties(_ref1750, _excluded1750);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14 3C14.5523 3 15 3.44772 15 4V9H20C20.5523 9 21 9.44772 21 10V20C21 20.5523 20.5523 21 20 21H10C9.44772 21 9 20.5523 9 20V15H4C3.44772 15 3 14.5523 3 14V4C3 3.44772 3.44772 3 4 3H14ZM13 5H5V13H9V10C9 9.44772 9.44772 9 10 9H13V5Z"
  }));
},
    Rv = function Rv(_ref1751) {
  var _ref1751$color = _ref1751.color,
      C = _ref1751$color === void 0 ? "currentColor" : _ref1751$color,
      _ref1751$size = _ref1751.size,
      e = _ref1751$size === void 0 ? 24 : _ref1751$size,
      l = _ref1751.className,
      i = _objectWithoutProperties(_ref1751, _excluded1751);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 12.9999H9V10.9999H3V1.84558C3 1.56944 3.22386 1.34558 3.5 1.34558C3.58425 1.34558 3.66714 1.36687 3.74096 1.40747L22.2034 11.5618C22.4454 11.6949 22.5337 11.9989 22.4006 12.2409C22.3549 12.324 22.2865 12.3924 22.2034 12.4381L3.74096 22.5924C3.499 22.7255 3.19497 22.6372 3.06189 22.3953C3.02129 22.3214 3 22.2386 3 22.1543V12.9999Z"
  }));
},
    zv = function zv(_ref1752) {
  var _ref1752$color = _ref1752.color,
      C = _ref1752$color === void 0 ? "currentColor" : _ref1752$color,
      _ref1752$size = _ref1752.size,
      e = _ref1752$size === void 0 ? 24 : _ref1752$size,
      l = _ref1752.className,
      i = _objectWithoutProperties(_ref1752, _excluded1752);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3.5 1.34558C3.58425 1.34558 3.66714 1.36687 3.74096 1.40747L22.2034 11.5618C22.4454 11.6949 22.5337 11.9989 22.4006 12.2409C22.3549 12.324 22.2865 12.3924 22.2034 12.4381L3.74096 22.5924C3.499 22.7255 3.19497 22.6372 3.06189 22.3953C3.02129 22.3214 3 22.2386 3 22.1543V1.84558C3 1.56944 3.22386 1.34558 3.5 1.34558ZM5 4.38249V10.9999H10V12.9999H5V19.6174L18.8499 11.9999L5 4.38249Z"
  }));
},
    Fv = function Fv(_ref1753) {
  var _ref1753$color = _ref1753.color,
      C = _ref1753$color === void 0 ? "currentColor" : _ref1753$color,
      _ref1753$size = _ref1753.size,
      e = _ref1753$size === void 0 ? 24 : _ref1753$size,
      l = _ref1753.className,
      i = _objectWithoutProperties(_ref1753, _excluded1753);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M1.94607 9.31543C1.42353 9.14125 1.4194 8.86022 1.95682 8.68108L21.043 2.31901C21.5715 2.14285 21.8746 2.43866 21.7265 2.95694L16.2733 22.0432C16.1223 22.5716 15.8177 22.59 15.5944 22.0876L11.9999 14L17.9999 6.00005L9.99992 12L1.94607 9.31543Z"
  }));
},
    Sv = function Sv(_ref1754) {
  var _ref1754$color = _ref1754.color,
      C = _ref1754$color === void 0 ? "currentColor" : _ref1754$color,
      _ref1754$size = _ref1754.size,
      e = _ref1754$size === void 0 ? 24 : _ref1754$size,
      l = _ref1754.className,
      i = _objectWithoutProperties(_ref1754, _excluded1754);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21.7267 2.95694L16.2734 22.0432C16.1225 22.5716 15.7979 22.5956 15.5563 22.1126L11 13L1.9229 9.36919C1.41322 9.16532 1.41953 8.86022 1.95695 8.68108L21.0432 2.31901C21.5716 2.14285 21.8747 2.43866 21.7267 2.95694ZM19.0353 5.09647L6.81221 9.17085L12.4488 11.4255L15.4895 17.5068L19.0353 5.09647Z"
  }));
},
    Av = function Av(_ref1755) {
  var _ref1755$color = _ref1755.color,
      C = _ref1755$color === void 0 ? "currentColor" : _ref1755$color,
      _ref1755$size = _ref1755.size,
      e = _ref1755$size === void 0 ? 24 : _ref1755$size,
      l = _ref1755.className,
      i = _objectWithoutProperties(_ref1755, _excluded1755);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11 3C11.5523 3 12 3.44772 12 4V6H17C17.5523 6 18 6.44772 18 7V12H20C20.5523 12 21 12.4477 21 13V20C21 20.5523 20.5523 21 20 21H13C12.4477 21 12 20.5523 12 20V18H7C6.44772 18 6 17.5523 6 17V12H4C3.44772 12 3 11.5523 3 11V4C3 3.44772 3.44772 3 4 3H11ZM16 8H12V11C12 11.5523 11.5523 12 11 12H8V16H12V13C12 12.4477 12.4477 12 13 12H16V8Z"
  }));
},
    kv = function kv(_ref1756) {
  var _ref1756$color = _ref1756.color,
      C = _ref1756$color === void 0 ? "currentColor" : _ref1756$color,
      _ref1756$size = _ref1756.size,
      e = _ref1756$size === void 0 ? 24 : _ref1756$size,
      l = _ref1756.className,
      i = _objectWithoutProperties(_ref1756, _excluded1756);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6 8V10H18V8H15V2H17V6H22V8H20V20C20 20.5523 19.5523 21 19 21H5C4.44772 21 4 20.5523 4 20V8H2V6H7V2H9V8H6ZM13 2V8H11V2H13Z"
  }));
},
    Pv = function Pv(_ref1757) {
  var _ref1757$color = _ref1757.color,
      C = _ref1757$color === void 0 ? "currentColor" : _ref1757$color,
      _ref1757$size = _ref1757.size,
      e = _ref1757$size === void 0 ? 24 : _ref1757$size,
      l = _ref1757.className,
      i = _objectWithoutProperties(_ref1757, _excluded1757);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6 8V19H18V8H15V2H17V6H22V8H20V20C20 20.5523 19.5523 21 19 21H5C4.44772 21 4 20.5523 4 20V8H2V6H7V2H9V8H6ZM13 2V8H11V2H13Z"
  }));
},
    Dv = function Dv(_ref1758) {
  var _ref1758$color = _ref1758.color,
      C = _ref1758$color === void 0 ? "currentColor" : _ref1758$color,
      _ref1758$size = _ref1758.size,
      e = _ref1758$size === void 0 ? 24 : _ref1758$size,
      l = _ref1758.className,
      i = _objectWithoutProperties(_ref1758, _excluded1758);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 11H4V13H2V11ZM6 11H18V13H6V11ZM20 11H22V13H20V11Z"
  }));
},
    yv = function yv(_ref1759) {
  var _ref1759$color = _ref1759.color,
      C = _ref1759$color === void 0 ? "currentColor" : _ref1759$color,
      _ref1759$size = _ref1759.size,
      e = _ref1759$size === void 0 ? 24 : _ref1759$size,
      l = _ref1759.className,
      i = _objectWithoutProperties(_ref1759, _excluded1759);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 3H20C20.5523 3 21 3.44772 21 4V11H3V4C3 3.44772 3.44772 3 4 3ZM3 13H21V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V13ZM7 16V18H10V16H7ZM7 6V8H10V6H7Z"
  }));
},
    bv = function bv(_ref1760) {
  var _ref1760$color = _ref1760.color,
      C = _ref1760$color === void 0 ? "currentColor" : _ref1760$color,
      _ref1760$size = _ref1760.size,
      e = _ref1760$size === void 0 ? 24 : _ref1760$size,
      l = _ref1760.className,
      i = _objectWithoutProperties(_ref1760, _excluded1760);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5 11H19V5H5V11ZM21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3H20C20.5523 3 21 3.44772 21 4ZM19 13H5V19H19V13ZM7 15H10V17H7V15ZM7 7H10V9H7V7Z"
  }));
},
    Tv = function Tv(_ref1761) {
  var _ref1761$color = _ref1761.color,
      C = _ref1761$color === void 0 ? "currentColor" : _ref1761$color,
      _ref1761$size = _ref1761.size,
      e = _ref1761$size === void 0 ? 24 : _ref1761$size,
      l = _ref1761.className,
      i = _objectWithoutProperties(_ref1761, _excluded1761);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14.1213 10.4792C13.7308 10.0886 13.0976 10.0886 12.7071 10.4792L12 11.1863C11.2189 11.9673 9.95259 11.9673 9.17154 11.1863C8.39049 10.4052 8.39049 9.13888 9.17154 8.35783L14.8022 2.72568C16.9061 2.24973 19.2008 2.83075 20.8388 4.46875C23.2582 6.88811 23.3716 10.7402 21.1792 13.2939L19.071 15.4289L14.1213 10.4792ZM3.16113 4.46875C5.33452 2.29536 8.66411 1.98283 11.17 3.53116L7.75732 6.94362C6.19523 8.50572 6.19523 11.0384 7.75732 12.6005C9.27209 14.1152 11.6995 14.1611 13.2695 12.7382L13.4142 12.6005L17.6568 16.8431L13.4142 21.0858C12.6331 21.8668 11.3668 21.8668 10.5858 21.0858L3.16113 13.6611C0.622722 11.1227 0.622722 7.00715 3.16113 4.46875Z"
  }));
},
    Uv = function Uv(_ref1762) {
  var _ref1762$color = _ref1762.color,
      C = _ref1762$color === void 0 ? "currentColor" : _ref1762$color,
      _ref1762$size = _ref1762.size,
      e = _ref1762$size === void 0 ? 24 : _ref1762$size,
      l = _ref1762.className,
      i = _objectWithoutProperties(_ref1762, _excluded1762);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3.16113 4.46875C5.58508 2.0448 9.44716 1.9355 12.0008 4.14085C14.5528 1.9355 18.4149 2.0448 20.8388 4.46875C23.2584 6.88836 23.3716 10.741 21.1785 13.2947L13.4142 21.0858C12.6686 21.8313 11.4809 21.8652 10.6952 21.1874L10.5858 21.0858L2.82141 13.2947C0.628282 10.741 0.741522 6.88836 3.16113 4.46875ZM4.57534 5.88296C2.86819 7.59011 2.81942 10.3276 4.42902 12.0937L4.57534 12.2469L12 19.6715L17.3026 14.3675L13.7677 10.8327L12.7071 11.8934C11.5355 13.0649 9.636 13.0649 8.46443 11.8934C7.29286 10.7218 7.29286 8.8223 8.46443 7.65073L10.5656 5.54823C8.85292 4.17713 6.37076 4.23993 4.7286 5.73663L4.57534 5.88296ZM13.0606 8.71139C13.4511 8.32086 14.0843 8.32086 14.4748 8.71139L18.7168 12.9533L19.4246 12.2469C21.1819 10.4896 21.1819 7.64032 19.4246 5.88296C17.7174 4.17581 14.9799 4.12704 13.2139 5.73663L13.0606 5.88296L9.87864 9.06494C9.51601 9.42757 9.49011 9.99942 9.80094 10.3919L9.87864 10.4792C10.2413 10.8418 10.8131 10.8677 11.2056 10.5569L11.2929 10.4792L13.0606 8.71139Z"
  }));
},
    Gv = function Gv(_ref1763) {
  var _ref1763$color = _ref1763.color,
      C = _ref1763$color === void 0 ? "currentColor" : _ref1763$color,
      _ref1763$size = _ref1763.size,
      e = _ref1763$size === void 0 ? 24 : _ref1763$size,
      l = _ref1763.className,
      i = _objectWithoutProperties(_ref1763, _excluded1763);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8.68637 4.00008L11.293 1.39348C11.6835 1.00295 12.3167 1.00295 12.7072 1.39348L15.3138 4.00008H19.0001C19.5524 4.00008 20.0001 4.4478 20.0001 5.00008V8.68637L22.6067 11.293C22.9972 11.6835 22.9972 12.3167 22.6067 12.7072L20.0001 15.3138V19.0001C20.0001 19.5524 19.5524 20.0001 19.0001 20.0001H15.3138L12.7072 22.6067C12.3167 22.9972 11.6835 22.9972 11.293 22.6067L8.68637 20.0001H5.00008C4.4478 20.0001 4.00008 19.5524 4.00008 19.0001V15.3138L1.39348 12.7072C1.00295 12.3167 1.00295 11.6835 1.39348 11.293L4.00008 8.68637V5.00008C4.00008 4.4478 4.4478 4.00008 5.00008 4.00008H8.68637ZM12.0001 15.0001C13.6569 15.0001 15.0001 13.6569 15.0001 12.0001C15.0001 10.3432 13.6569 9.00008 12.0001 9.00008C10.3432 9.00008 9.00008 10.3432 9.00008 12.0001C9.00008 13.6569 10.3432 15.0001 12.0001 15.0001Z"
  }));
},
    Iv = function Iv(_ref1764) {
  var _ref1764$color = _ref1764.color,
      C = _ref1764$color === void 0 ? "currentColor" : _ref1764$color,
      _ref1764$size = _ref1764.size,
      e = _ref1764$size === void 0 ? 24 : _ref1764$size,
      l = _ref1764.className,
      i = _objectWithoutProperties(_ref1764, _excluded1764);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8.68637 4.00008L11.293 1.39348C11.6835 1.00295 12.3167 1.00295 12.7072 1.39348L15.3138 4.00008H19.0001C19.5524 4.00008 20.0001 4.4478 20.0001 5.00008V8.68637L22.6067 11.293C22.9972 11.6835 22.9972 12.3167 22.6067 12.7072L20.0001 15.3138V19.0001C20.0001 19.5524 19.5524 20.0001 19.0001 20.0001H15.3138L12.7072 22.6067C12.3167 22.9972 11.6835 22.9972 11.293 22.6067L8.68637 20.0001H5.00008C4.4478 20.0001 4.00008 19.5524 4.00008 19.0001V15.3138L1.39348 12.7072C1.00295 12.3167 1.00295 11.6835 1.39348 11.293L4.00008 8.68637V5.00008C4.00008 4.4478 4.4478 4.00008 5.00008 4.00008H8.68637ZM6.00008 6.00008V9.5148L3.5148 12.0001L6.00008 14.4854V18.0001H9.5148L12.0001 20.4854L14.4854 18.0001H18.0001V14.4854L20.4854 12.0001L18.0001 9.5148V6.00008H14.4854L12.0001 3.5148L9.5148 6.00008H6.00008ZM12.0001 16.0001C9.79094 16.0001 8.00008 14.2092 8.00008 12.0001C8.00008 9.79094 9.79094 8.00008 12.0001 8.00008C14.2092 8.00008 16.0001 9.79094 16.0001 12.0001C16.0001 14.2092 14.2092 16.0001 12.0001 16.0001ZM12.0001 14.0001C13.1047 14.0001 14.0001 13.1047 14.0001 12.0001C14.0001 10.8955 13.1047 10.0001 12.0001 10.0001C10.8955 10.0001 10.0001 10.8955 10.0001 12.0001C10.0001 13.1047 10.8955 14.0001 12.0001 14.0001Z"
  }));
},
    Wv = function Wv(_ref1765) {
  var _ref1765$color = _ref1765.color,
      C = _ref1765$color === void 0 ? "currentColor" : _ref1765$color,
      _ref1765$size = _ref1765.size,
      e = _ref1765$size === void 0 ? 24 : _ref1765$size,
      l = _ref1765.className,
      i = _objectWithoutProperties(_ref1765, _excluded1765);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9.95401 2.2106C11.2876 1.93144 12.6807 1.92263 14.0449 2.20785C14.2219 3.3674 14.9048 4.43892 15.9997 5.07103C17.0945 5.70313 18.364 5.75884 19.4566 5.3323C20.3858 6.37118 21.0747 7.58203 21.4997 8.87652C20.5852 9.60958 19.9997 10.736 19.9997 11.9992C19.9997 13.2632 20.5859 14.3902 21.5013 15.1232C21.29 15.7636 21.0104 16.3922 20.6599 16.9992C20.3094 17.6063 19.9049 18.1627 19.4559 18.6659C18.3634 18.2396 17.0943 18.2955 15.9997 18.9274C14.9057 19.559 14.223 20.6294 14.0453 21.7879C12.7118 22.067 11.3187 22.0758 9.95443 21.7906C9.77748 20.6311 9.09451 19.5595 7.99967 18.9274C6.90484 18.2953 5.63539 18.2396 4.54272 18.6662C3.61357 17.6273 2.92466 16.4164 2.49964 15.1219C3.41412 14.3889 3.99968 13.2624 3.99968 11.9992C3.99968 10.7353 3.41344 9.60827 2.49805 8.87524C2.70933 8.23482 2.98894 7.60629 3.33942 6.99923C3.68991 6.39217 4.09443 5.83576 4.54341 5.33257C5.63593 5.75881 6.90507 5.703 7.99967 5.07103C9.09364 4.43942 9.7764 3.3691 9.95401 2.2106ZM11.9997 14.9992C13.6565 14.9992 14.9997 13.6561 14.9997 11.9992C14.9997 10.3424 13.6565 8.99923 11.9997 8.99923C10.3428 8.99923 8.99967 10.3424 8.99967 11.9992C8.99967 13.6561 10.3428 14.9992 11.9997 14.9992Z"
  }));
},
    Ov = function Ov(_ref1766) {
  var _ref1766$color = _ref1766.color,
      C = _ref1766$color === void 0 ? "currentColor" : _ref1766$color,
      _ref1766$size = _ref1766.size,
      e = _ref1766$size === void 0 ? 24 : _ref1766$size,
      l = _ref1766.className,
      i = _objectWithoutProperties(_ref1766, _excluded1766);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3.33946 17.0002C2.90721 16.2515 2.58277 15.4702 2.36133 14.6741C3.3338 14.1779 3.99972 13.1668 3.99972 12.0002C3.99972 10.8345 3.3348 9.824 2.36353 9.32741C2.81025 7.71651 3.65857 6.21627 4.86474 4.99001C5.7807 5.58416 6.98935 5.65534 7.99972 5.072C9.01009 4.48866 9.55277 3.40635 9.4962 2.31604C11.1613 1.8846 12.8847 1.90004 14.5031 2.31862C14.4475 3.40806 14.9901 4.48912 15.9997 5.072C17.0101 5.65532 18.2187 5.58416 19.1346 4.99007C19.7133 5.57986 20.2277 6.25151 20.66 7.00021C21.0922 7.7489 21.4167 8.53025 21.6381 9.32628C20.6656 9.82247 19.9997 10.8336 19.9997 12.0002C19.9997 13.166 20.6646 14.1764 21.6359 14.673C21.1892 16.2839 20.3409 17.7841 19.1347 19.0104C18.2187 18.4163 17.0101 18.3451 15.9997 18.9284C14.9893 19.5117 14.4467 20.5941 14.5032 21.6844C12.8382 22.1158 11.1148 22.1004 9.49633 21.6818C9.55191 20.5923 9.00929 19.5113 7.99972 18.9284C6.98938 18.3451 5.78079 18.4162 4.86484 19.0103C4.28617 18.4205 3.77172 17.7489 3.33946 17.0002ZM8.99972 17.1964C10.0911 17.8265 10.8749 18.8227 11.2503 19.9659C11.7486 20.0133 12.2502 20.014 12.7486 19.9675C13.1238 18.8237 13.9078 17.8268 14.9997 17.1964C16.0916 16.5659 17.347 16.3855 18.5252 16.6324C18.8146 16.224 19.0648 15.7892 19.2729 15.334C18.4706 14.4373 17.9997 13.2604 17.9997 12.0002C17.9997 10.74 18.4706 9.5632 19.2729 8.6665C19.1688 8.4405 19.0538 8.21822 18.9279 8.00021C18.802 7.78219 18.667 7.57148 18.5233 7.36842C17.3457 7.61476 16.0911 7.43414 14.9997 6.80405C13.9083 6.17395 13.1246 5.17768 12.7491 4.03455C12.2509 3.98714 11.7492 3.98646 11.2509 4.03292C10.8756 5.17671 10.0916 6.17364 8.99972 6.80405C7.9078 7.43447 6.65245 7.61494 5.47428 7.36803C5.18485 7.77641 4.93463 8.21117 4.72656 8.66637C5.52881 9.56311 5.99972 10.74 5.99972 12.0002C5.99972 13.2604 5.52883 14.4372 4.72656 15.3339C4.83067 15.5599 4.94564 15.7822 5.07152 16.0002C5.19739 16.2182 5.3324 16.4289 5.47612 16.632C6.65377 16.3857 7.90838 16.5663 8.99972 17.1964ZM11.9997 15.0002C10.3429 15.0002 8.99972 13.6571 8.99972 12.0002C8.99972 10.3434 10.3429 9.00021 11.9997 9.00021C13.6566 9.00021 14.9997 10.3434 14.9997 12.0002C14.9997 13.6571 13.6566 15.0002 11.9997 15.0002ZM11.9997 13.0002C12.552 13.0002 12.9997 12.5525 12.9997 12.0002C12.9997 11.4479 12.552 11.0002 11.9997 11.0002C11.4474 11.0002 10.9997 11.4479 10.9997 12.0002C10.9997 12.5525 11.4474 13.0002 11.9997 13.0002Z"
  }));
},
    Kv = function Kv(_ref1767) {
  var _ref1767$color = _ref1767.color,
      C = _ref1767$color === void 0 ? "currentColor" : _ref1767$color,
      _ref1767$size = _ref1767.size,
      e = _ref1767$size === void 0 ? 24 : _ref1767$size,
      l = _ref1767.className,
      i = _objectWithoutProperties(_ref1767, _excluded1767);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5.33409 4.54491C6.3494 3.63637 7.55145 2.9322 8.87555 2.49707C9.60856 3.4128 10.7358 3.99928 12 3.99928C13.2642 3.99928 14.3914 3.4128 15.1245 2.49707C16.4486 2.9322 17.6506 3.63637 18.6659 4.54491C18.2405 5.637 18.2966 6.90531 18.9282 7.99928C19.5602 9.09388 20.6314 9.77679 21.7906 9.95392C21.9279 10.6142 22 11.2983 22 11.9993C22 12.7002 21.9279 13.3844 21.7906 14.0446C20.6314 14.2218 19.5602 14.9047 18.9282 15.9993C18.2966 17.0932 18.2405 18.3616 18.6659 19.4536C17.6506 20.3622 16.4486 21.0664 15.1245 21.5015C14.3914 20.5858 13.2642 19.9993 12 19.9993C10.7358 19.9993 9.60856 20.5858 8.87555 21.5015C7.55145 21.0664 6.3494 20.3622 5.33409 19.4536C5.75952 18.3616 5.7034 17.0932 5.0718 15.9993C4.43983 14.9047 3.36862 14.2218 2.20935 14.0446C2.07212 13.3844 2 12.7002 2 11.9993C2 11.2983 2.07212 10.6142 2.20935 9.95392C3.36862 9.77679 4.43983 9.09388 5.0718 7.99928C5.7034 6.90531 5.75952 5.637 5.33409 4.54491ZM13.5 14.5974C14.9349 13.7689 15.4265 11.9342 14.5981 10.4993C13.7696 9.0644 11.9349 8.57277 10.5 9.4012C9.06512 10.2296 8.5735 12.0644 9.40192 13.4993C10.2304 14.9342 12.0651 15.4258 13.5 14.5974Z"
  }));
},
    Qv = function Qv(_ref1768) {
  var _ref1768$color = _ref1768.color,
      C = _ref1768$color === void 0 ? "currentColor" : _ref1768$color,
      _ref1768$size = _ref1768.size,
      e = _ref1768$size === void 0 ? 24 : _ref1768$size,
      l = _ref1768.className,
      i = _objectWithoutProperties(_ref1768, _excluded1768);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 11.9998C2 11.1353 2.1097 10.2964 2.31595 9.49631C3.40622 9.55283 4.48848 9.01015 5.0718 7.99982C5.65467 6.99025 5.58406 5.78271 4.99121 4.86701C6.18354 3.69529 7.66832 2.82022 9.32603 2.36133C9.8222 3.33385 10.8333 3.99982 12 3.99982C13.1667 3.99982 14.1778 3.33385 14.674 2.36133C16.3317 2.82022 17.8165 3.69529 19.0088 4.86701C18.4159 5.78271 18.3453 6.99025 18.9282 7.99982C19.5115 9.01015 20.5938 9.55283 21.6841 9.49631C21.8903 10.2964 22 11.1353 22 11.9998C22 12.8643 21.8903 13.7032 21.6841 14.5033C20.5938 14.4468 19.5115 14.9895 18.9282 15.9998C18.3453 17.0094 18.4159 18.2169 19.0088 19.1326C17.8165 20.3043 16.3317 21.1794 14.674 21.6383C14.1778 20.6658 13.1667 19.9998 12 19.9998C10.8333 19.9998 9.8222 20.6658 9.32603 21.6383C7.66832 21.1794 6.18354 20.3043 4.99121 19.1326C5.58406 18.2169 5.65467 17.0094 5.0718 15.9998C4.48848 14.9895 3.40622 14.4468 2.31595 14.5033C2.1097 13.7032 2 12.8643 2 11.9998ZM6.80385 14.9998C7.43395 16.0912 7.61458 17.3459 7.36818 18.5236C7.77597 18.8138 8.21005 19.0652 8.66489 19.2741C9.56176 18.4712 10.7392 17.9998 12 17.9998C13.2608 17.9998 14.4382 18.4712 15.3351 19.2741C15.7899 19.0652 16.224 18.8138 16.6318 18.5236C16.3854 17.3459 16.566 16.0912 17.1962 14.9998C17.8262 13.9085 18.8225 13.1248 19.9655 12.7493C19.9884 12.5015 20 12.2516 20 11.9998C20 11.7481 19.9884 11.4981 19.9655 11.2504C18.8225 10.8749 17.8262 10.0912 17.1962 8.99982C16.566 7.90845 16.3854 6.65378 16.6318 5.47605C16.224 5.18588 15.7899 4.93447 15.3351 4.72552C14.4382 5.52844 13.2608 5.99982 12 5.99982C10.7392 5.99982 9.56176 5.52844 8.66489 4.72552C8.21005 4.93447 7.77597 5.18588 7.36818 5.47605C7.61458 6.65378 7.43395 7.90845 6.80385 8.99982C6.17376 10.0912 5.17754 10.8749 4.03451 11.2504C4.01157 11.4981 4 11.7481 4 11.9998C4 12.2516 4.01157 12.5015 4.03451 12.7493C5.17754 13.1248 6.17376 13.9085 6.80385 14.9998ZM12 14.9998C10.3431 14.9998 9 13.6567 9 11.9998C9 10.343 10.3431 8.99982 12 8.99982C13.6569 8.99982 15 10.343 15 11.9998C15 13.6567 13.6569 14.9998 12 14.9998ZM12 12.9998C12.5523 12.9998 13 12.5521 13 11.9998C13 11.4475 12.5523 10.9998 12 10.9998C11.4477 10.9998 11 11.4475 11 11.9998C11 12.5521 11.4477 12.9998 12 12.9998Z"
  }));
},
    qv = function qv(_ref1769) {
  var _ref1769$color = _ref1769.color,
      C = _ref1769$color === void 0 ? "currentColor" : _ref1769$color,
      _ref1769$size = _ref1769.size,
      e = _ref1769$size === void 0 ? 24 : _ref1769$size,
      l = _ref1769.className,
      i = _objectWithoutProperties(_ref1769, _excluded1769);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2.13127 13.6308C1.9492 12.5349 1.95521 11.434 2.13216 10.3695C3.23337 10.3963 4.22374 9.86798 4.60865 8.93871C4.99357 8.00944 4.66685 6.93557 3.86926 6.17581C4.49685 5.29798 5.27105 4.51528 6.17471 3.86911C6.9345 4.66716 8.0087 4.99416 8.93822 4.60914C9.86774 4.22412 10.3961 3.23332 10.369 2.13176C11.4649 1.94969 12.5658 1.9557 13.6303 2.13265C13.6036 3.23385 14.1319 4.22422 15.0612 4.60914C15.9904 4.99406 17.0643 4.66733 17.8241 3.86975C18.7019 4.49734 19.4846 5.27153 20.1308 6.1752C19.3327 6.93499 19.0057 8.00919 19.3907 8.93871C19.7757 9.86823 20.7665 10.3966 21.8681 10.3695C22.0502 11.4654 22.0442 12.5663 21.8672 13.6308C20.766 13.6041 19.7756 14.1324 19.3907 15.0616C19.0058 15.9909 19.3325 17.0648 20.1301 17.8245C19.5025 18.7024 18.7283 19.4851 17.8247 20.1312C17.0649 19.3332 15.9907 19.0062 15.0612 19.3912C14.1316 19.7762 13.6033 20.767 13.6303 21.8686C12.5344 22.0507 11.4335 22.0447 10.3691 21.8677C10.3958 20.7665 9.86749 19.7761 8.93822 19.3912C8.00895 19.0063 6.93508 19.333 6.17532 20.1306C5.29749 19.503 4.51479 18.7288 3.86862 17.8252C4.66667 17.0654 4.99367 15.9912 4.60865 15.0616C4.22363 14.1321 3.23284 13.6038 2.13127 13.6308ZM11.9997 15.0002C13.6565 15.0002 14.9997 13.657 14.9997 12.0002C14.9997 10.3433 13.6565 9.00018 11.9997 9.00018C10.3428 9.00018 8.99969 10.3433 8.99969 12.0002C8.99969 13.657 10.3428 15.0002 11.9997 15.0002Z"
  }));
},
    jv = function jv(_ref1770) {
  var _ref1770$color = _ref1770.color,
      C = _ref1770$color === void 0 ? "currentColor" : _ref1770$color,
      _ref1770$size = _ref1770.size,
      e = _ref1770$size === void 0 ? 24 : _ref1770$size,
      l = _ref1770.className,
      i = _objectWithoutProperties(_ref1770, _excluded1770);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2.21232 14.0601C1.91928 12.6755 1.93115 11.2743 2.21316 9.94038C3.32308 10.0711 4.29187 9.7035 4.60865 8.93871C4.92544 8.17392 4.50032 7.22896 3.62307 6.53655C4.3669 5.3939 5.34931 4.39471 6.53554 3.62289C7.228 4.50059 8.17324 4.92601 8.93822 4.60914C9.7032 4.29227 10.0708 3.32308 9.93979 2.21281C11.3243 1.91977 12.7255 1.93164 14.0595 2.21364C13.9288 3.32356 14.2964 4.29235 15.0612 4.60914C15.8259 4.92593 16.7709 4.5008 17.4633 3.62356C18.606 4.36739 19.6052 5.3498 20.377 6.53602C19.4993 7.22849 19.0739 8.17373 19.3907 8.93871C19.7076 9.70369 20.6768 10.0713 21.7871 9.94028C22.0801 11.3248 22.0682 12.726 21.7862 14.06C20.6763 13.9293 19.7075 14.2969 19.3907 15.0616C19.0739 15.8264 19.4991 16.7714 20.3763 17.4638C19.6325 18.6064 18.6501 19.6056 17.4638 20.3775C16.7714 19.4998 15.8261 19.0743 15.0612 19.3912C14.2962 19.7081 13.9286 20.6773 14.0596 21.7875C12.675 22.0806 11.2738 22.0687 9.93989 21.7867C10.0706 20.6768 9.70301 19.708 8.93822 19.3912C8.17343 19.0744 7.22848 19.4995 6.53606 20.3768C5.39341 19.633 4.39422 18.6506 3.62241 17.4643C4.5001 16.7719 4.92552 15.8266 4.60865 15.0616C4.29179 14.2967 3.32259 13.9291 2.21232 14.0601ZM3.99975 12.2104C5.09956 12.5148 6.00718 13.2117 6.45641 14.2963C6.90564 15.3808 6.75667 16.5154 6.19421 17.5083C6.29077 17.61 6.38998 17.7092 6.49173 17.8056C7.4846 17.2432 8.61912 17.0943 9.70359 17.5435C10.7881 17.9927 11.485 18.9002 11.7894 19.9999C11.9295 20.0037 12.0697 20.0038 12.2099 20.0001C12.5143 18.9003 13.2112 17.9927 14.2958 17.5435C15.3803 17.0942 16.5149 17.2432 17.5078 17.8057C17.6096 17.7091 17.7087 17.6099 17.8051 17.5081C17.2427 16.5153 17.0938 15.3807 17.543 14.2963C17.9922 13.2118 18.8997 12.5149 19.9994 12.2105C20.0032 12.0704 20.0033 11.9301 19.9996 11.7899C18.8998 11.4856 17.9922 10.7886 17.543 9.70407C17.0937 8.61953 17.2427 7.48494 17.8052 6.49204C17.7086 6.39031 17.6094 6.2912 17.5076 6.19479C16.5148 6.75717 15.3803 6.9061 14.2958 6.4569C13.2113 6.0077 12.5144 5.10016 12.21 4.00044C12.0699 3.99666 11.9297 3.99659 11.7894 4.00024C11.4851 5.10005 10.7881 6.00767 9.70359 6.4569C8.61904 6.90613 7.48446 6.75715 6.49155 6.1947C6.38982 6.29126 6.29071 6.39047 6.19431 6.49222C6.75668 7.48509 6.90561 8.61961 6.45641 9.70407C6.00721 10.7885 5.09967 11.4855 3.99995 11.7899C3.99617 11.93 3.9961 12.0702 3.99975 12.2104ZM11.9997 15.0002C10.3428 15.0002 8.99969 13.657 8.99969 12.0002C8.99969 10.3433 10.3428 9.00018 11.9997 9.00018C13.6565 9.00018 14.9997 10.3433 14.9997 12.0002C14.9997 13.657 13.6565 15.0002 11.9997 15.0002ZM11.9997 13.0002C12.552 13.0002 12.9997 12.5525 12.9997 12.0002C12.9997 11.4479 12.552 11.0002 11.9997 11.0002C11.4474 11.0002 10.9997 11.4479 10.9997 12.0002C10.9997 12.5525 11.4474 13.0002 11.9997 13.0002Z"
  }));
},
    Xv = function Xv(_ref1771) {
  var _ref1771$color = _ref1771.color,
      C = _ref1771$color === void 0 ? "currentColor" : _ref1771$color,
      _ref1771$size = _ref1771.size,
      e = _ref1771$size === void 0 ? 24 : _ref1771$size,
      l = _ref1771.className,
      i = _objectWithoutProperties(_ref1771, _excluded1771);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17.5 2.47363L23 11.9999L17.5 21.5262H6.5L1 11.9999L6.5 2.47363H17.5ZM8.63398 8.16979L13.634 16.83L15.366 15.83L10.366 7.16979L8.63398 8.16979Z"
  }));
},
    Jv = function Jv(_ref1772) {
  var _ref1772$color = _ref1772.color,
      C = _ref1772$color === void 0 ? "currentColor" : _ref1772$color,
      _ref1772$size = _ref1772.size,
      e = _ref1772$size === void 0 ? 24 : _ref1772$size,
      l = _ref1772.className,
      i = _objectWithoutProperties(_ref1772, _excluded1772);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17.5 2.47363L23 11.9999L17.5 21.5262H6.5L1 11.9999L6.5 2.47363H17.5ZM16.3453 4.47363H7.6547L3.3094 11.9999L7.6547 19.5262H16.3453L20.6906 11.9999L16.3453 4.47363ZM8.63398 8.16979L10.366 7.16979L15.366 15.83L13.634 16.83L8.63398 8.16979Z"
  }));
},
    Yv = function Yv(_ref1773) {
  var _ref1773$color = _ref1773.color,
      C = _ref1773$color === void 0 ? "currentColor" : _ref1773$color,
      _ref1773$size = _ref1773.size,
      e = _ref1773$size === void 0 ? 24 : _ref1773$size,
      l = _ref1773.className,
      i = _objectWithoutProperties(_ref1773, _excluded1773);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 1L21.5 6.5V17.5L12 23L2.5 17.5V6.5L12 1ZM12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
  }));
},
    _v = function _v(_ref1774) {
  var _ref1774$color = _ref1774.color,
      C = _ref1774$color === void 0 ? "currentColor" : _ref1774$color,
      _ref1774$size = _ref1774.size,
      e = _ref1774$size === void 0 ? 24 : _ref1774$size,
      l = _ref1774.className,
      i = _objectWithoutProperties(_ref1774, _excluded1774);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 1L21.5 6.5V17.5L12 23L2.5 17.5V6.5L12 1ZM12 3.311L4.5 7.65311V16.3469L12 20.689L19.5 16.3469V7.65311L12 3.311ZM12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12C16 14.2091 14.2091 16 12 16ZM12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z"
  }));
},
    $v = function $v(_ref1775) {
  var _ref1775$color = _ref1775.color,
      C = _ref1775$color === void 0 ? "currentColor" : _ref1775$color,
      _ref1775$size = _ref1775.size,
      e = _ref1775$size === void 0 ? 24 : _ref1775$size,
      l = _ref1775.className,
      i = _objectWithoutProperties(_ref1775, _excluded1775);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 2H7V7H2V2ZM2 17H7V22H2V17ZM17 2H22V7H17V2ZM17 17H22V22H17V17ZM8 4H16V6H8V4ZM4 8H6V16H4V8ZM18 8H20V16H18V8ZM8 18H16V20H8V18Z"
  }));
},
    ed = function ed(_ref1776) {
  var _ref1776$color = _ref1776.color,
      C = _ref1776$color === void 0 ? "currentColor" : _ref1776$color,
      _ref1776$size = _ref1776.size,
      e = _ref1776$size === void 0 ? 24 : _ref1776$size,
      l = _ref1776.className,
      i = _objectWithoutProperties(_ref1776, _excluded1776);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 16H22V22H16V20H8V22H2V16H4V8H2V2H8V4H16V2H22V8H20V16ZM18 16V8H16V6H8V8H6V16H8V18H16V16H18ZM4 4V6H6V4H4ZM4 18V20H6V18H4ZM18 4V6H20V4H18ZM18 18V20H20V18H18Z"
  }));
},
    td = function td(_ref1777) {
  var _ref1777$color = _ref1777.color,
      C = _ref1777$color === void 0 ? "currentColor" : _ref1777$color,
      _ref1777$size = _ref1777.size,
      e = _ref1777$size === void 0 ? 24 : _ref1777$size,
      l = _ref1777.className,
      i = _objectWithoutProperties(_ref1777, _excluded1777);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5 8C3.34315 8 2 6.65685 2 5C2 3.34315 3.34315 2 5 2C6.65685 2 8 3.34315 8 5C8 6.65685 6.65685 8 5 8ZM19 8C17.3431 8 16 6.65685 16 5C16 3.34315 17.3431 2 19 2C20.6569 2 22 3.34315 22 5C22 6.65685 20.6569 8 19 8ZM19 22C17.3431 22 16 20.6569 16 19C16 17.3431 17.3431 16 19 16C20.6569 16 22 17.3431 22 19C22 20.6569 20.6569 22 19 22ZM5 22C3.34315 22 2 20.6569 2 19C2 17.3431 3.34315 16 5 16C6.65685 16 8 17.3431 8 19C8 20.6569 6.65685 22 5 22ZM9 4H15V6H9V4ZM9 18H15V20H9V18ZM4 9H6V15H4V9ZM18 9H20V15H18V9Z"
  }));
},
    Cd = function Cd(_ref1778) {
  var _ref1778$color = _ref1778.color,
      C = _ref1778$color === void 0 ? "currentColor" : _ref1778$color,
      _ref1778$size = _ref1778.size,
      e = _ref1778$size === void 0 ? 24 : _ref1778$size,
      l = _ref1778.className,
      i = _objectWithoutProperties(_ref1778, _excluded1778);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7.82929 20C7.41746 21.1652 6.30622 22 5 22C3.34315 22 2 20.6569 2 19C2 17.6938 2.83481 16.5825 4 16.1707V7.82929C2.83481 7.41746 2 6.30622 2 5C2 3.34315 3.34315 2 5 2C6.30622 2 7.41746 2.83481 7.82929 4H16.1707C16.5825 2.83481 17.6938 2 19 2C20.6569 2 22 3.34315 22 5C22 6.30622 21.1652 7.41746 20 7.82929V16.1707C21.1652 16.5825 22 17.6938 22 19C22 20.6569 20.6569 22 19 22C17.6938 22 16.5825 21.1652 16.1707 20H7.82929ZM7.82929 18H16.1707C16.472 17.1476 17.1476 16.472 18 16.1707V7.82929C17.1476 7.52801 16.472 6.85241 16.1707 6H7.82929C7.52801 6.85241 6.85241 7.52801 6 7.82929V16.1707C6.85241 16.472 7.52801 17.1476 7.82929 18ZM5 6C5.55228 6 6 5.55228 6 5C6 4.44772 5.55228 4 5 4C4.44772 4 4 4.44772 4 5C4 5.55228 4.44772 6 5 6ZM19 6C19.5523 6 20 5.55228 20 5C20 4.44772 19.5523 4 19 4C18.4477 4 18 4.44772 18 5C18 5.55228 18.4477 6 19 6ZM19 20C19.5523 20 20 19.5523 20 19C20 18.4477 19.5523 18 19 18C18.4477 18 18 18.4477 18 19C18 19.5523 18.4477 20 19 20ZM5 20C5.55228 20 6 19.5523 6 19C6 18.4477 5.55228 18 5 18C4.44772 18 4 18.4477 4 19C4 19.5523 4.44772 20 5 20Z"
  }));
},
    ld = function ld(_ref1779) {
  var _ref1779$color = _ref1779.color,
      C = _ref1779$color === void 0 ? "currentColor" : _ref1779$color,
      _ref1779$size = _ref1779.size,
      e = _ref1779$size === void 0 ? 24 : _ref1779$size,
      l = _ref1779.className,
      i = _objectWithoutProperties(_ref1779, _excluded1779);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10 3V5H5V19H19V14H21V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3H10ZM17.7071 7.70711L12 13.4142L10.5858 12L16.2929 6.29289L13 3H21V11L17.7071 7.70711Z"
  }));
},
    id = function id(_ref1780) {
  var _ref1780$color = _ref1780.color,
      C = _ref1780$color === void 0 ? "currentColor" : _ref1780$color,
      _ref1780$size = _ref1780.size,
      e = _ref1780$size === void 0 ? 24 : _ref1780$size,
      l = _ref1780.className,
      i = _objectWithoutProperties(_ref1780, _excluded1780);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10 3V5H5V19H19V14H21V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3H10ZM17.5858 5H13V3H21V11H19V6.41421L12 13.4142L10.5858 12L17.5858 5Z"
  }));
},
    sd = function sd(_ref1781) {
  var _ref1781$color = _ref1781.color,
      C = _ref1781$color === void 0 ? "currentColor" : _ref1781$color,
      _ref1781$size = _ref1781.size,
      e = _ref1781$size === void 0 ? 24 : _ref1781$size,
      l = _ref1781.className,
      i = _objectWithoutProperties(_ref1781, _excluded1781);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11 2.04938V4.06189C7.05369 4.55399 4 7.92038 4 12C4 16.4183 7.58172 20 12 20C16.0796 20 19.446 16.9463 19.9381 13H21.9506C21.4489 18.0533 17.1853 22 12 22C6.47715 22 2 17.5228 2 12C2 6.81465 5.94668 2.5511 11 2.04938ZM18.7071 6.70711L12 13.4142L10.5858 12L17.2929 5.29289L14 2H22V10L18.7071 6.70711Z"
  }));
},
    rd = function rd(_ref1782) {
  var _ref1782$color = _ref1782.color,
      C = _ref1782$color === void 0 ? "currentColor" : _ref1782$color,
      _ref1782$size = _ref1782.size,
      e = _ref1782$size === void 0 ? 24 : _ref1782$size,
      l = _ref1782.className,
      i = _objectWithoutProperties(_ref1782, _excluded1782);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11 2.04938V4.06189C7.05369 4.55399 4 7.92038 4 12C4 16.4183 7.58172 20 12 20C16.0796 20 19.446 16.9463 19.9381 13H21.9506C21.4489 18.0533 17.1853 22 12 22C6.47715 22 2 17.5228 2 12C2 6.81465 5.94668 2.5511 11 2.04938ZM20 5.41421L12 13.4142L10.5858 12L18.5858 4H14V2H22V10H20V5.41421Z"
  }));
},
    cd = function cd(_ref1783) {
  var _ref1783$color = _ref1783.color,
      C = _ref1783$color === void 0 ? "currentColor" : _ref1783$color,
      _ref1783$size = _ref1783.size,
      e = _ref1783$size === void 0 ? 24 : _ref1783$size,
      l = _ref1783.className,
      i = _objectWithoutProperties(_ref1783, _excluded1783);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13.5759 17.2714L8.46576 14.484C7.83312 15.112 6.96187 15.5 6 15.5C4.067 15.5 2.5 13.933 2.5 12C2.5 10.067 4.067 8.5 6 8.5C6.96181 8.5 7.83301 8.88796 8.46564 9.51593L13.5759 6.72855C13.5262 6.49354 13.5 6.24983 13.5 6C13.5 4.067 15.067 2.5 17 2.5C18.933 2.5 20.5 4.067 20.5 6C20.5 7.933 18.933 9.5 17 9.5C16.0381 9.5 15.1669 9.11201 14.5343 8.48399L9.42404 11.2713C9.47382 11.5064 9.5 11.7501 9.5 12C9.5 12.2498 9.47383 12.4935 9.42408 12.7285L14.5343 15.516C15.167 14.888 16.0382 14.5 17 14.5C18.933 14.5 20.5 16.067 20.5 18C20.5 19.933 18.933 21.5 17 21.5C15.067 21.5 13.5 19.933 13.5 18C13.5 17.7502 13.5262 17.5064 13.5759 17.2714Z"
  }));
},
    od = function od(_ref1784) {
  var _ref1784$color = _ref1784.color,
      C = _ref1784$color === void 0 ? "currentColor" : _ref1784$color,
      _ref1784$size = _ref1784.size,
      e = _ref1784$size === void 0 ? 24 : _ref1784$size,
      l = _ref1784.className,
      i = _objectWithoutProperties(_ref1784, _excluded1784);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 19H20V14H22V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V14H4V19ZM12 10H9C7.00442 10 5.23638 10.9742 4.14556 12.473C4.85831 8.78512 8.10391 6 12 6V2L20 8L12 14V10Z"
  }));
},
    ad = function ad(_ref1785) {
  var _ref1785$color = _ref1785.color,
      C = _ref1785$color === void 0 ? "currentColor" : _ref1785$color,
      _ref1785$size = _ref1785.size,
      e = _ref1785$size === void 0 ? 24 : _ref1785$size,
      l = _ref1785.className,
      i = _objectWithoutProperties(_ref1785, _excluded1785);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 18.9997H20V13.9997H22V19.9997C22 20.552 21.5523 20.9997 21 20.9997H3C2.44772 20.9997 2 20.552 2 19.9997V13.9997H4V18.9997ZM16.1716 6.9997L12.2218 3.04996L13.636 1.63574L20 7.9997L13.636 14.3637L12.2218 12.9495L16.1716 8.9997H5V6.9997H16.1716Z"
  }));
},
    nd = function nd(_ref1786) {
  var _ref1786$color = _ref1786.color,
      C = _ref1786$color === void 0 ? "currentColor" : _ref1786$color,
      _ref1786$size = _ref1786.size,
      e = _ref1786$size === void 0 ? 24 : _ref1786$size,
      l = _ref1786.className,
      i = _objectWithoutProperties(_ref1786, _excluded1786);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9 3V5H4V19H20V10H22V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H9ZM16 5V1L23 7H14C12.8954 7 12 7.89543 12 9V15H10V9C10 6.79086 11.7909 5 14 5H16Z"
  }));
},
    md = function md(_ref1787) {
  var _ref1787$color = _ref1787.color,
      C = _ref1787$color === void 0 ? "currentColor" : _ref1787$color,
      _ref1787$size = _ref1787.size,
      e = _ref1787$size === void 0 ? 24 : _ref1787$size,
      l = _ref1787.className,
      i = _objectWithoutProperties(_ref1787, _excluded1787);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9 2.9997V4.9997H4V18.9997H20V9.9997H22V19.9997C22 20.552 21.5523 20.9997 21 20.9997H3C2.44772 20.9997 2 20.552 2 19.9997V3.9997C2 3.44742 2.44772 2.9997 3 2.9997H9ZM18.9497 4.9997L16 2.04996L17.4142 0.635742L22.7539 5.97544C22.9882 6.20975 22.9882 6.58965 22.7539 6.82397C22.6414 6.93649 22.4888 6.9997 22.3296 6.9997H14C12.8954 6.9997 12 7.89513 12 8.9997V14.9997H10V8.9997C10 6.79056 11.7909 4.9997 14 4.9997H18.9497Z"
  }));
},
    wd = function wd(_ref1788) {
  var _ref1788$color = _ref1788.color,
      C = _ref1788$color === void 0 ? "currentColor" : _ref1788$color,
      _ref1788$size = _ref1788.size,
      e = _ref1788$size === void 0 ? 24 : _ref1788$size,
      l = _ref1788.className,
      i = _objectWithoutProperties(_ref1788, _excluded1788);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13 14H11C7.54202 14 4.53953 15.9502 3.03239 18.8107C3.01093 18.5433 3 18.2729 3 18C3 12.4772 7.47715 8 13 8V3L23 11L13 19V14Z"
  }));
},
    Ld = function Ld(_ref1789) {
  var _ref1789$color = _ref1789.color,
      C = _ref1789$color === void 0 ? "currentColor" : _ref1789$color,
      _ref1789$size = _ref1789.size,
      e = _ref1789$size === void 0 ? 24 : _ref1789$size,
      l = _ref1789.className,
      i = _objectWithoutProperties(_ref1789, _excluded1789);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13 14H11C7.54202 14 4.53953 15.9502 3.03239 18.8107C3.01093 18.5433 3 18.2729 3 18C3 12.4772 7.47715 8 13 8V2.5L23.5 11L13 19.5V14ZM11 12H15V15.3078L20.3214 11L15 6.69224V10H13C10.5795 10 8.41011 11.0749 6.94312 12.7735C8.20873 12.2714 9.58041 12 11 12Z"
  }));
},
    hd = function hd(_ref1790) {
  var _ref1790$color = _ref1790.color,
      C = _ref1790$color === void 0 ? "currentColor" : _ref1790$color,
      _ref1790$size = _ref1790.size,
      e = _ref1790$size === void 0 ? 24 : _ref1790$size,
      l = _ref1790.className,
      i = _objectWithoutProperties(_ref1790, _excluded1790);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13.1202 17.0228L8.92129 14.7324C8.19135 15.5125 7.15261 16 6 16C3.79086 16 2 14.2091 2 12C2 9.79086 3.79086 8 6 8C7.15255 8 8.19125 8.48746 8.92118 9.26746L13.1202 6.97713C13.0417 6.66441 13 6.33707 13 6C13 3.79086 14.7909 2 17 2C19.2091 2 21 3.79086 21 6C21 8.20914 19.2091 10 17 10C15.8474 10 14.8087 9.51251 14.0787 8.73246L9.87977 11.0228C9.9583 11.3355 10 11.6629 10 12C10 12.3371 9.95831 12.6644 9.87981 12.9771L14.0788 15.2675C14.8087 14.4875 15.8474 14 17 14C19.2091 14 21 15.7909 21 18C21 20.2091 19.2091 22 17 22C14.7909 22 13 20.2091 13 18C13 17.6629 13.0417 17.3355 13.1202 17.0228ZM6 14C7.10457 14 8 13.1046 8 12C8 10.8954 7.10457 10 6 10C4.89543 10 4 10.8954 4 12C4 13.1046 4.89543 14 6 14ZM17 8C18.1046 8 19 7.10457 19 6C19 4.89543 18.1046 4 17 4C15.8954 4 15 4.89543 15 6C15 7.10457 15.8954 8 17 8ZM17 20C18.1046 20 19 19.1046 19 18C19 16.8954 18.1046 16 17 16C15.8954 16 15 16.8954 15 18C15 19.1046 15.8954 20 17 20Z"
  }));
},
    Hd = function Hd(_ref1791) {
  var _ref1791$color = _ref1791.color,
      C = _ref1791$color === void 0 ? "currentColor" : _ref1791$color,
      _ref1791$size = _ref1791.size,
      e = _ref1791$size === void 0 ? 24 : _ref1791$size,
      l = _ref1791.className,
      i = _objectWithoutProperties(_ref1791, _excluded1791);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 1L20.2169 2.82598C20.6745 2.92766 21 3.33347 21 3.80217V13.7889C21 15.795 19.9974 17.6684 18.3282 18.7812L12 23L5.6718 18.7812C4.00261 17.6684 3 15.795 3 13.7889V3.80217C3 3.33347 3.32553 2.92766 3.78307 2.82598L12 1ZM16.4524 8.22183L11.5019 13.1709L8.67421 10.3431L7.25999 11.7574L11.5026 16L17.8666 9.63604L16.4524 8.22183Z"
  }));
},
    Vd = function Vd(_ref1792) {
  var _ref1792$color = _ref1792.color,
      C = _ref1792$color === void 0 ? "currentColor" : _ref1792$color,
      _ref1792$size = _ref1792.size,
      e = _ref1792$size === void 0 ? 24 : _ref1792$size,
      l = _ref1792.className,
      i = _objectWithoutProperties(_ref1792, _excluded1792);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 1L20.2169 2.82598C20.6745 2.92766 21 3.33347 21 3.80217V13.7889C21 15.795 19.9974 17.6684 18.3282 18.7812L12 23L5.6718 18.7812C4.00261 17.6684 3 15.795 3 13.7889V3.80217C3 3.33347 3.32553 2.92766 3.78307 2.82598L12 1ZM12 3.04879L5 4.60434V13.7889C5 15.1263 5.6684 16.3752 6.7812 17.1171L12 20.5963L17.2188 17.1171C18.3316 16.3752 19 15.1263 19 13.7889V4.60434L12 3.04879ZM16.4524 8.22183L17.8666 9.63604L11.5026 16L7.25999 11.7574L8.67421 10.3431L11.5019 13.1709L16.4524 8.22183Z"
  }));
},
    gd = function gd(_ref1793) {
  var _ref1793$color = _ref1793.color,
      C = _ref1793$color === void 0 ? "currentColor" : _ref1793$color,
      _ref1793$size = _ref1793.size,
      e = _ref1793$size === void 0 ? 24 : _ref1793$size,
      l = _ref1793.className,
      i = _objectWithoutProperties(_ref1793, _excluded1793);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3.78307 2.82598L12 1L20.2169 2.82598C20.6745 2.92766 21 3.33347 21 3.80217V13.7889C21 15.795 19.9974 17.6684 18.3282 18.7812L12 23L5.6718 18.7812C4.00261 17.6684 3 15.795 3 13.7889V3.80217C3 3.33347 3.32553 2.92766 3.78307 2.82598ZM11 10H8V12H11V15H13V12H16V10H13V7H11V10Z"
  }));
},
    Md = function Md(_ref1794) {
  var _ref1794$color = _ref1794.color,
      C = _ref1794$color === void 0 ? "currentColor" : _ref1794$color,
      _ref1794$size = _ref1794.size,
      e = _ref1794$size === void 0 ? 24 : _ref1794$size,
      l = _ref1794.className,
      i = _objectWithoutProperties(_ref1794, _excluded1794);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3.78307 2.82598L12 1L20.2169 2.82598C20.6745 2.92766 21 3.33347 21 3.80217V13.7889C21 15.795 19.9974 17.6684 18.3282 18.7812L12 23L5.6718 18.7812C4.00261 17.6684 3 15.795 3 13.7889V3.80217C3 3.33347 3.32553 2.92766 3.78307 2.82598ZM5 4.60434V13.7889C5 15.1263 5.6684 16.3752 6.7812 17.1171L12 20.5963L17.2188 17.1171C18.3316 16.3752 19 15.1263 19 13.7889V4.60434L12 3.04879L5 4.60434ZM11 10V7H13V10H16V12H13V15H11V12H8V10H11Z"
  }));
},
    Zd = function Zd(_ref1795) {
  var _ref1795$color = _ref1795.color,
      C = _ref1795$color === void 0 ? "currentColor" : _ref1795$color,
      _ref1795$size = _ref1795.size,
      e = _ref1795$size === void 0 ? 24 : _ref1795$size,
      l = _ref1795.className,
      i = _objectWithoutProperties(_ref1795, _excluded1795);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3.78307 2.82598L12 1L20.2169 2.82598C20.6745 2.92766 21 3.33347 21 3.80217V13.7889C21 15.795 19.9974 17.6684 18.3282 18.7812L12 23L5.6718 18.7812C4.00261 17.6684 3 15.795 3 13.7889V3.80217C3 3.33347 3.32553 2.92766 3.78307 2.82598Z"
  }));
},
    xd = function xd(_ref1796) {
  var _ref1796$color = _ref1796.color,
      C = _ref1796$color === void 0 ? "currentColor" : _ref1796$color,
      _ref1796$size = _ref1796.size,
      e = _ref1796$size === void 0 ? 24 : _ref1796$size,
      l = _ref1796.className,
      i = _objectWithoutProperties(_ref1796, _excluded1796);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3.78307 2.82598L12 1L20.2169 2.82598C20.6745 2.92766 21 3.33347 21 3.80217V13.7889C21 15.795 19.9974 17.6684 18.3282 18.7812L12 23L5.6718 18.7812C4.00261 17.6684 3 15.795 3 13.7889V3.80217C3 3.33347 3.32553 2.92766 3.78307 2.82598ZM13 10V5L8 12H11V17L16 10H13Z"
  }));
},
    vd = function vd(_ref1797) {
  var _ref1797$color = _ref1797.color,
      C = _ref1797$color === void 0 ? "currentColor" : _ref1797$color,
      _ref1797$size = _ref1797.size,
      e = _ref1797$size === void 0 ? 24 : _ref1797$size,
      l = _ref1797.className,
      i = _objectWithoutProperties(_ref1797, _excluded1797);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3.78307 2.82598L12 1L20.2169 2.82598C20.6745 2.92766 21 3.33347 21 3.80217V13.7889C21 15.795 19.9974 17.6684 18.3282 18.7812L12 23L5.6718 18.7812C4.00261 17.6684 3 15.795 3 13.7889V3.80217C3 3.33347 3.32553 2.92766 3.78307 2.82598ZM5 4.60434V13.7889C5 15.1263 5.6684 16.3752 6.7812 17.1171L12 20.5963L17.2188 17.1171C18.3316 16.3752 19 15.1263 19 13.7889V4.60434L12 3.04879L5 4.60434ZM13 10H16L11 17V12H8L13 5V10Z"
  }));
},
    dd = function dd(_ref1798) {
  var _ref1798$color = _ref1798.color,
      C = _ref1798$color === void 0 ? "currentColor" : _ref1798$color,
      _ref1798$size = _ref1798.size,
      e = _ref1798$size === void 0 ? 24 : _ref1798$size,
      l = _ref1798.className,
      i = _objectWithoutProperties(_ref1798, _excluded1798);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 1L20.2169 2.82598C20.6745 2.92766 21 3.33347 21 3.80217V13.7889C21 15.795 19.9974 17.6684 18.3282 18.7812L12 23L5.6718 18.7812C4.00261 17.6684 3 15.795 3 13.7889V3.80217C3 3.33347 3.32553 2.92766 3.78307 2.82598L12 1ZM12 7C10.8954 7 10 7.89543 10 9C10 9.74025 10.4022 10.3866 10.9999 10.7324L11 15H13L13.0011 10.7318C13.5983 10.3858 14 9.73984 14 9C14 7.89543 13.1046 7 12 7Z"
  }));
},
    pd = function pd(_ref1799) {
  var _ref1799$color = _ref1799.color,
      C = _ref1799$color === void 0 ? "currentColor" : _ref1799$color,
      _ref1799$size = _ref1799.size,
      e = _ref1799$size === void 0 ? 24 : _ref1799$size,
      l = _ref1799.className,
      i = _objectWithoutProperties(_ref1799, _excluded1799);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 1L20.2169 2.82598C20.6745 2.92766 21 3.33347 21 3.80217V13.7889C21 15.795 19.9974 17.6684 18.3282 18.7812L12 23L5.6718 18.7812C4.00261 17.6684 3 15.795 3 13.7889V3.80217C3 3.33347 3.32553 2.92766 3.78307 2.82598L12 1ZM12 3.04879L5 4.60434V13.7889C5 15.1263 5.6684 16.3752 6.7812 17.1171L12 20.5963L17.2188 17.1171C18.3316 16.3752 19 15.1263 19 13.7889V4.60434L12 3.04879ZM12 7C13.1046 7 14 7.89543 14 9C14 9.73984 13.5983 10.3858 13.0011 10.7318L13 15H11L10.9999 10.7324C10.4022 10.3866 10 9.74025 10 9C10 7.89543 10.8954 7 12 7Z"
  }));
},
    Ed = function Ed(_ref1800) {
  var _ref1800$color = _ref1800.color,
      C = _ref1800$color === void 0 ? "currentColor" : _ref1800$color,
      _ref1800$size = _ref1800.size,
      e = _ref1800$size === void 0 ? 24 : _ref1800$size,
      l = _ref1800.className,
      i = _objectWithoutProperties(_ref1800, _excluded1800);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3.78307 2.82598L12 1L20.2169 2.82598C20.6745 2.92766 21 3.33347 21 3.80217V13.7889C21 15.795 19.9974 17.6684 18.3282 18.7812L12 23L5.6718 18.7812C4.00261 17.6684 3 15.795 3 13.7889V3.80217C3 3.33347 3.32553 2.92766 3.78307 2.82598ZM5 4.60434V13.7889C5 15.1263 5.6684 16.3752 6.7812 17.1171L12 20.5963L17.2188 17.1171C18.3316 16.3752 19 15.1263 19 13.7889V4.60434L12 3.04879L5 4.60434Z"
  }));
},
    Nd = function Nd(_ref1801) {
  var _ref1801$color = _ref1801.color,
      C = _ref1801$color === void 0 ? "currentColor" : _ref1801$color,
      _ref1801$size = _ref1801.size,
      e = _ref1801$size === void 0 ? 24 : _ref1801$size,
      l = _ref1801.className,
      i = _objectWithoutProperties(_ref1801, _excluded1801);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3.78307 2.82598L12 1L20.2169 2.82598C20.6745 2.92766 21 3.33347 21 3.80217V13.7889C21 15.795 19.9974 17.6684 18.3282 18.7812L12 23L5.6718 18.7812C4.00261 17.6684 3 15.795 3 13.7889V3.80217C3 3.33347 3.32553 2.92766 3.78307 2.82598ZM12 13.5L14.9389 15.0451L14.3776 11.7725L16.7553 9.45492L13.4695 8.97746L12 6L10.5305 8.97746L7.24472 9.45492L9.62236 11.7725L9.06107 15.0451L12 13.5Z"
  }));
},
    ud = function ud(_ref1802) {
  var _ref1802$color = _ref1802.color,
      C = _ref1802$color === void 0 ? "currentColor" : _ref1802$color,
      _ref1802$size = _ref1802.size,
      e = _ref1802$size === void 0 ? 24 : _ref1802$size,
      l = _ref1802.className,
      i = _objectWithoutProperties(_ref1802, _excluded1802);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5 4.60434V13.7889C5 15.1263 5.6684 16.3752 6.7812 17.1171L12 20.5963L17.2188 17.1171C18.3316 16.3752 19 15.1263 19 13.7889V4.60434L12 3.04879L5 4.60434ZM3.78307 2.82598L12 1L20.2169 2.82598C20.6745 2.92766 21 3.33347 21 3.80217V13.7889C21 15.795 19.9974 17.6684 18.3282 18.7812L12 23L5.6718 18.7812C4.00261 17.6684 3 15.795 3 13.7889V3.80217C3 3.33347 3.32553 2.92766 3.78307 2.82598ZM12 13.5L9.06107 15.0451L9.62236 11.7725L7.24472 9.45492L10.5305 8.97746L12 6L13.4695 8.97746L16.7553 9.45492L14.3776 11.7725L14.9389 15.0451L12 13.5Z"
  }));
},
    Bd = function Bd(_ref1803) {
  var _ref1803$color = _ref1803.color,
      C = _ref1803$color === void 0 ? "currentColor" : _ref1803$color,
      _ref1803$size = _ref1803.size,
      e = _ref1803$size === void 0 ? 24 : _ref1803$size,
      l = _ref1803.className,
      i = _objectWithoutProperties(_ref1803, _excluded1803);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3.78307 2.82598L12 1L20.2169 2.82598C20.6745 2.92766 21 3.33347 21 3.80217V13.7889C21 15.795 19.9974 17.6684 18.3282 18.7812L12 23L5.6718 18.7812C4.00261 17.6684 3 15.795 3 13.7889V3.80217C3 3.33347 3.32553 2.92766 3.78307 2.82598ZM12 11C13.3807 11 14.5 9.88071 14.5 8.5C14.5 7.11929 13.3807 6 12 6C10.6193 6 9.5 7.11929 9.5 8.5C9.5 9.88071 10.6193 11 12 11ZM7.52746 16H16.4725C16.2238 13.75 14.3163 12 12 12C9.68372 12 7.77619 13.75 7.52746 16Z"
  }));
},
    fd = function fd(_ref1804) {
  var _ref1804$color = _ref1804.color,
      C = _ref1804$color === void 0 ? "currentColor" : _ref1804$color,
      _ref1804$size = _ref1804.size,
      e = _ref1804$size === void 0 ? 24 : _ref1804$size,
      l = _ref1804.className,
      i = _objectWithoutProperties(_ref1804, _excluded1804);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3.78307 2.82598L12 1L20.2169 2.82598C20.6745 2.92766 21 3.33347 21 3.80217V13.7889C21 15.795 19.9974 17.6684 18.3282 18.7812L12 23L5.6718 18.7812C4.00261 17.6684 3 15.795 3 13.7889V3.80217C3 3.33347 3.32553 2.92766 3.78307 2.82598ZM5 4.60434V13.7889C5 15.1263 5.6684 16.3752 6.7812 17.1171L12 20.5963L17.2188 17.1171C18.3316 16.3752 19 15.1263 19 13.7889V4.60434L12 3.04879L5 4.60434ZM12 11C10.6193 11 9.5 9.88071 9.5 8.5C9.5 7.11929 10.6193 6 12 6C13.3807 6 14.5 7.11929 14.5 8.5C14.5 9.88071 13.3807 11 12 11ZM7.52746 16C7.77619 13.75 9.68372 12 12 12C14.3163 12 16.2238 13.75 16.4725 16H7.52746Z"
  }));
},
    Rd = function Rd(_ref1805) {
  var _ref1805$color = _ref1805.color,
      C = _ref1805$color === void 0 ? "currentColor" : _ref1805$color,
      _ref1805$size = _ref1805.size,
      e = _ref1805$size === void 0 ? 24 : _ref1805$size,
      l = _ref1805.className,
      i = _objectWithoutProperties(_ref1805, _excluded1805);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9 4H14.4458C14.7905 4 15.111 4.17762 15.2938 4.47L18.75 10H23.1577C23.4339 10 23.6577 10.2239 23.6577 10.5C23.6577 10.5837 23.6367 10.666 23.5967 10.7394L19.6599 17.9568C19.444 17.9853 19.2237 18 19 18C17.3644 18 15.9122 17.2147 15 16.0005C14.0878 17.2147 12.6356 18 11 18C9.3644 18 7.91223 17.2147 7 16.0005C6.08777 17.2147 4.6356 18 3 18C2.81381 18 2.63 17.9898 2.44909 17.97L1.21434 11.1789C1.11555 10.6355 1.47595 10.1149 2.01933 10.0161C2.07835 10.0054 2.13822 10 2.19821 10H3V5C3 4.44772 3.44772 4 4 4H5V1H9V4ZM5 10H16.3915L13.8915 6H5V10ZM3 20C4.53671 20 5.93849 19.4223 7 18.4722C8.06151 19.4223 9.46329 20 11 20C12.5367 20 13.9385 19.4223 15 18.4722C16.0615 19.4223 17.4633 20 19 20H21V22H19C17.5429 22 16.1767 21.6104 15 20.9297C13.8233 21.6104 12.4571 22 11 22C9.54285 22 8.17669 21.6104 7 20.9297C5.82331 21.6104 4.45715 22 3 22H1V20H3Z"
  }));
},
    zd = function zd(_ref1806) {
  var _ref1806$color = _ref1806.color,
      C = _ref1806$color === void 0 ? "currentColor" : _ref1806$color,
      _ref1806$size = _ref1806.size,
      e = _ref1806$size === void 0 ? 24 : _ref1806$size,
      l = _ref1806.className,
      i = _objectWithoutProperties(_ref1806, _excluded1806);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9 4H14.4458C14.7905 4 15.111 4.17762 15.2938 4.47L18.75 10H23.1577C23.4339 10 23.6577 10.2239 23.6577 10.5C23.6577 10.5837 23.6367 10.666 23.5967 10.7394L19.6364 18H19C18.4694 18 17.9548 17.9311 17.4648 17.8018L20.63 12H3.4L4.44833 17.824C3.9845 17.939 3.49937 18 3 18H2.45455L1.21434 11.1789C1.11555 10.6355 1.47595 10.1149 2.01933 10.0161C2.07835 10.0054 2.13822 10 2.19821 10H3V5C3 4.44772 3.44772 4 4 4H5V1H9V4ZM5 10H16.3915L13.8915 6H5V10ZM3 20C4.53671 20 5.93849 19.4223 7 18.4722C8.06151 19.4223 9.46329 20 11 20C12.5367 20 13.9385 19.4223 15 18.4722C16.0615 19.4223 17.4633 20 19 20H21V22H19C17.5429 22 16.1767 21.6104 15 20.9297C13.8233 21.6104 12.4571 22 11 22C9.54285 22 8.17669 21.6104 7 20.9297C5.82331 21.6104 4.45715 22 3 22H1V20H3Z"
  }));
},
    Fd = function Fd(_ref1807) {
  var _ref1807$color = _ref1807.color,
      C = _ref1807$color === void 0 ? "currentColor" : _ref1807$color,
      _ref1807$size = _ref1807.size,
      e = _ref1807$size === void 0 ? 24 : _ref1807$size,
      l = _ref1807.className,
      i = _objectWithoutProperties(_ref1807, _excluded1807);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 10.4V4C4 3.44772 4.44772 3 5 3H10V1H14V3H19C19.5523 3 20 3.44772 20 4V10.4L21.0857 10.7257C21.5974 10.8792 21.8981 11.4078 21.7685 11.9261L20.2516 17.9938C20.1682 17.9979 20.0844 18 20 18C18.3644 18 16.9122 17.2147 16 16.0005C15.0878 17.2147 13.6356 18 12 18C10.3644 18 8.91223 17.2147 8 16.0005C7.08777 17.2147 5.6356 18 4 18C3.91564 18 3.83178 17.9979 3.74845 17.9938L2.23152 11.9261C2.10195 11.4078 2.40262 10.8792 2.91431 10.7257L4 10.4ZM6 9.8L12 8L14.7541 8.82624L16.5627 9.36882L18 9.8V5H6V9.8ZM4 20C5.53671 20 6.93849 19.4223 8 18.4722C9.06151 19.4223 10.4633 20 12 20C13.5367 20 14.9385 19.4223 16 18.4722C17.0615 19.4223 18.4633 20 20 20H22V22H20C18.5429 22 17.1767 21.6104 16 20.9297C14.8233 21.6104 13.4571 22 12 22C10.5429 22 9.17669 21.6104 8 20.9297C6.82331 21.6104 5.45715 22 4 22H2V20H4Z"
  }));
},
    Sd = function Sd(_ref1808) {
  var _ref1808$color = _ref1808.color,
      C = _ref1808$color === void 0 ? "currentColor" : _ref1808$color,
      _ref1808$size = _ref1808.size,
      e = _ref1808$size === void 0 ? 24 : _ref1808$size,
      l = _ref1808.className,
      i = _objectWithoutProperties(_ref1808, _excluded1808);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 10.4V4C4 3.44772 4.44772 3 5 3H10V1H14V3H19C19.5523 3 20 3.44772 20 4V10.4L21.0857 10.7257C21.5974 10.8792 21.8981 11.4078 21.7685 11.9261L20.2516 17.9938C20.1682 17.9979 20.0844 18 20 18C19.4218 18 18.8665 17.9019 18.3499 17.7213L19.6 12.37L12 10L4.4 12.37L5.65008 17.7213C5.13348 17.9019 4.5782 18 4 18C3.91564 18 3.83178 17.9979 3.74845 17.9938L2.23152 11.9261C2.10195 11.4078 2.40262 10.8792 2.91431 10.7257L4 10.4ZM6 9.8L12 8L18 9.8V5H6V9.8ZM4 20C5.53671 20 6.93849 19.4223 8 18.4722C9.06151 19.4223 10.4633 20 12 20C13.5367 20 14.9385 19.4223 16 18.4722C17.0615 19.4223 18.4633 20 20 20H22V22H20C18.5429 22 17.1767 21.6104 16 20.9297C14.8233 21.6104 13.4571 22 12 22C10.5429 22 9.17669 21.6104 8 20.9297C6.82331 21.6104 5.45715 22 4 22H2V20H4Z"
  }));
},
    Ad = function Ad(_ref1809) {
  var _ref1809$color = _ref1809.color,
      C = _ref1809$color === void 0 ? "currentColor" : _ref1809$color,
      _ref1809$size = _ref1809.size,
      e = _ref1809$size === void 0 ? 24 : _ref1809$size,
      l = _ref1809.className,
      i = _objectWithoutProperties(_ref1809, _excluded1809);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.99805 4V11L11.998 8.5L16.998 11V4H19.998C20.5503 4 20.998 4.44772 20.998 5V21C20.998 21.5523 20.5503 22 19.998 22H3.99805C3.44576 22 2.99805 21.5523 2.99805 21V5C2.99805 4.44772 3.44576 4 3.99805 4H6.99805ZM11.998 8L7.49805 3H16.498L11.998 8ZM12.998 11.2361L11.998 10.7361L10.998 11.2361V20H12.998V11.2361ZM14.998 14V16H18.998V14H14.998Z"
  }));
},
    kd = function kd(_ref1810) {
  var _ref1810$color = _ref1810.color,
      C = _ref1810$color === void 0 ? "currentColor" : _ref1810$color,
      _ref1810$size = _ref1810.size,
      e = _ref1810$size === void 0 ? 24 : _ref1810$size,
      l = _ref1810.className,
      i = _objectWithoutProperties(_ref1810, _excluded1810);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.998 20H18.998V16H14.998V14H18.998V6H16.998V11L12.998 9.4V20ZM10.998 20V9.4L6.99805 11V6H4.99805V20H10.998ZM6.99805 4V3H16.998V4H19.998C20.5503 4 20.998 4.44772 20.998 5V21C20.998 21.5523 20.5503 22 19.998 22H3.99805C3.44576 22 2.99805 21.5523 2.99805 21V5C2.99805 4.44772 3.44576 4 3.99805 4H6.99805ZM11.998 8L15.498 5H8.49805L11.998 8Z"
  }));
},
    Pd = function Pd(_ref1811) {
  var _ref1811$color = _ref1811.color,
      C = _ref1811$color === void 0 ? "currentColor" : _ref1811$color,
      _ref1811$size = _ref1811.size,
      e = _ref1811$size === void 0 ? 24 : _ref1811$size,
      l = _ref1811.className,
      i = _objectWithoutProperties(_ref1811, _excluded1811);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.0049 22H4.00488C3.4526 22 3.00488 21.5523 3.00488 21V3C3.00488 2.44772 3.4526 2 4.00488 2H20.0049C20.5572 2 21.0049 2.44772 21.0049 3V21C21.0049 21.5523 20.5572 22 20.0049 22ZM9.00488 6H7.00488V8C7.00488 10.7614 9.24346 13 12.0049 13C14.7663 13 17.0049 10.7614 17.0049 8V6H15.0049V8C15.0049 9.65685 13.6617 11 12.0049 11C10.348 11 9.00488 9.65685 9.00488 8V6Z"
  }));
},
    Dd = function Dd(_ref1812) {
  var _ref1812$color = _ref1812.color,
      C = _ref1812$color === void 0 ? "currentColor" : _ref1812$color,
      _ref1812$size = _ref1812.size,
      e = _ref1812$size === void 0 ? 24 : _ref1812$size,
      l = _ref1812.className,
      i = _objectWithoutProperties(_ref1812, _excluded1812);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.0049 22H4.00488C3.4526 22 3.00488 21.5523 3.00488 21V3C3.00488 2.44772 3.4526 2 4.00488 2H20.0049C20.5572 2 21.0049 2.44772 21.0049 3V21C21.0049 21.5523 20.5572 22 20.0049 22ZM19.0049 20V4H5.00488V20H19.0049ZM9.00488 6V8C9.00488 9.65685 10.348 11 12.0049 11C13.6617 11 15.0049 9.65685 15.0049 8V6H17.0049V8C17.0049 10.7614 14.7663 13 12.0049 13C9.24346 13 7.00488 10.7614 7.00488 8V6H9.00488Z"
  }));
},
    yd = function yd(_ref1813) {
  var _ref1813$color = _ref1813.color,
      C = _ref1813$color === void 0 ? "currentColor" : _ref1813$color,
      _ref1813$size = _ref1813.size,
      e = _ref1813$size === void 0 ? 24 : _ref1813$size,
      l = _ref1813.className,
      i = _objectWithoutProperties(_ref1813, _excluded1813);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.50488 2H17.5049C17.8196 2 18.116 2.14819 18.3049 2.4L21.0049 6V21C21.0049 21.5523 20.5572 22 20.0049 22H4.00488C3.4526 22 3.00488 21.5523 3.00488 21V6L5.70488 2.4C5.89374 2.14819 6.19013 2 6.50488 2ZM18.5049 6L17.0049 4H7.00488L5.50488 6H18.5049ZM9.00488 10H7.00488V12C7.00488 14.7614 9.24346 17 12.0049 17C14.7663 17 17.0049 14.7614 17.0049 12V10H15.0049V12C15.0049 13.6569 13.6617 15 12.0049 15C10.348 15 9.00488 13.6569 9.00488 12V10Z"
  }));
},
    bd = function bd(_ref1814) {
  var _ref1814$color = _ref1814.color,
      C = _ref1814$color === void 0 ? "currentColor" : _ref1814$color,
      _ref1814$size = _ref1814.size,
      e = _ref1814$size === void 0 ? 24 : _ref1814$size,
      l = _ref1814.className,
      i = _objectWithoutProperties(_ref1814, _excluded1814);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.50488 2H17.5049C17.8196 2 18.116 2.14819 18.3049 2.4L21.0049 6V21C21.0049 21.5523 20.5572 22 20.0049 22H4.00488C3.4526 22 3.00488 21.5523 3.00488 21V6L5.70488 2.4C5.89374 2.14819 6.19013 2 6.50488 2ZM19.0049 8H5.00488V20H19.0049V8ZM18.5049 6L17.0049 4H7.00488L5.50488 6H18.5049ZM9.00488 10V12C9.00488 13.6569 10.348 15 12.0049 15C13.6617 15 15.0049 13.6569 15.0049 12V10H17.0049V12C17.0049 14.7614 14.7663 17 12.0049 17C9.24346 17 7.00488 14.7614 7.00488 12V10H9.00488Z"
  }));
},
    Td = function Td(_ref1815) {
  var _ref1815$color = _ref1815.color,
      C = _ref1815$color === void 0 ? "currentColor" : _ref1815$color,
      _ref1815$size = _ref1815.size,
      e = _ref1815$size === void 0 ? 24 : _ref1815$size,
      l = _ref1815.className,
      i = _objectWithoutProperties(_ref1815, _excluded1815);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.0049 0.999695C14.7663 0.999695 17.0049 3.23827 17.0049 5.99969V7.99969H20.0049C20.5572 7.99969 21.0049 8.44741 21.0049 8.99969V20.9997C21.0049 21.552 20.5572 21.9997 20.0049 21.9997H4.00488C3.4526 21.9997 3.00488 21.552 3.00488 20.9997V8.99969C3.00488 8.44741 3.4526 7.99969 4.00488 7.99969H7.00488V5.99969C7.00488 3.23827 9.24346 0.999695 12.0049 0.999695ZM17.0049 10.9997H15.0049V11.9997C15.0049 12.552 15.4526 12.9997 16.0049 12.9997C16.5177 12.9997 16.9404 12.6137 16.9982 12.1163L17.0049 11.9997V10.9997ZM9.00488 10.9997H7.00488V11.9997C7.00488 12.552 7.4526 12.9997 8.00488 12.9997C8.51772 12.9997 8.94039 12.6137 8.99815 12.1163L9.00488 11.9997V10.9997ZM12.0049 2.99969C10.4072 2.99969 9.10122 4.24861 9.00998 5.82342L9.00488 5.99969V7.99969H15.0049V5.99969C15.0049 4.40201 13.756 3.09603 12.1812 3.00479L12.0049 2.99969Z"
  }));
},
    Ud = function Ud(_ref1816) {
  var _ref1816$color = _ref1816.color,
      C = _ref1816$color === void 0 ? "currentColor" : _ref1816$color,
      _ref1816$size = _ref1816.size,
      e = _ref1816$size === void 0 ? 24 : _ref1816$size,
      l = _ref1816.className,
      i = _objectWithoutProperties(_ref1816, _excluded1816);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7.00488 7.99966V5.99966C7.00488 3.23824 9.24346 0.999664 12.0049 0.999664C14.7663 0.999664 17.0049 3.23824 17.0049 5.99966V7.99966H20.0049C20.5572 7.99966 21.0049 8.44738 21.0049 8.99966V20.9997C21.0049 21.5519 20.5572 21.9997 20.0049 21.9997H4.00488C3.4526 21.9997 3.00488 21.5519 3.00488 20.9997V8.99966C3.00488 8.44738 3.4526 7.99966 4.00488 7.99966H7.00488ZM7.00488 9.99966H5.00488V19.9997H19.0049V9.99966H17.0049V11.9997H15.0049V9.99966H9.00488V11.9997H7.00488V9.99966ZM9.00488 7.99966H15.0049V5.99966C15.0049 4.34281 13.6617 2.99966 12.0049 2.99966C10.348 2.99966 9.00488 4.34281 9.00488 5.99966V7.99966Z"
  }));
},
    Gd = function Gd(_ref1817) {
  var _ref1817$color = _ref1817.color,
      C = _ref1817$color === void 0 ? "currentColor" : _ref1817$color,
      _ref1817$size = _ref1817.size,
      e = _ref1817$size === void 0 ? 24 : _ref1817$size,
      l = _ref1817.className,
      i = _objectWithoutProperties(_ref1817, _excluded1817);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15.3709 3.44L18.5819 9.002L22.0049 9.00218V11.0022L20.8379 11.002L20.0813 20.0852C20.0381 20.6035 19.6048 21.0022 19.0847 21.0022H4.92502C4.40493 21.0022 3.97166 20.6035 3.92847 20.0852L3.17088 11.002L2.00488 11.0022V9.00218L5.42688 9.002L8.63886 3.44L10.3709 4.44L7.73688 9.002H16.2719L13.6389 4.44L15.3709 3.44ZM13.0049 13.0022H11.0049V17.0022H13.0049V13.0022ZM9.00488 13.0022H7.00488V17.0022H9.00488V13.0022ZM17.0049 13.0022H15.0049V17.0022H17.0049V13.0022Z"
  }));
},
    Id = function Id(_ref1818) {
  var _ref1818$color = _ref1818.color,
      C = _ref1818$color === void 0 ? "currentColor" : _ref1818$color,
      _ref1818$size = _ref1818.size,
      e = _ref1818$size === void 0 ? 24 : _ref1818$size,
      l = _ref1818.className,
      i = _objectWithoutProperties(_ref1818, _excluded1818);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15.3709 3.44L18.5819 9.002L22.0049 9.00218V11.0022L20.8379 11.002L20.0813 20.0852C20.0381 20.6035 19.6048 21.0022 19.0847 21.0022H4.92502C4.40493 21.0022 3.97166 20.6035 3.92847 20.0852L3.17088 11.002L2.00488 11.0022V9.00218L5.42688 9.002L8.63886 3.44L10.3709 4.44L7.73688 9.002H16.2719L13.6389 4.44L15.3709 3.44ZM18.8309 11.002L5.17788 11.0022L5.84488 19.0022H18.1639L18.8309 11.002ZM13.0049 13.0022V17.0022H11.0049V13.0022H13.0049ZM9.00488 13.0022V17.0022H7.00488V13.0022H9.00488ZM17.0049 13.0022V17.0022H15.0049V13.0022H17.0049Z"
  }));
},
    Wd = function Wd(_ref1819) {
  var _ref1819$color = _ref1819.color,
      C = _ref1819$color === void 0 ? "currentColor" : _ref1819$color,
      _ref1819$size = _ref1819.size,
      e = _ref1819$size === void 0 ? 24 : _ref1819$size,
      l = _ref1819.className,
      i = _objectWithoutProperties(_ref1819, _excluded1819);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.0049 2C15.3186 2 18.0049 4.68629 18.0049 8V9H22.0049V11H20.8379L20.0813 20.083C20.0381 20.6013 19.6048 21 19.0847 21H4.92502C4.40493 21 3.97166 20.6013 3.92847 20.083L3.17088 11H2.00488V9H6.00488V8C6.00488 4.68629 8.69117 2 12.0049 2ZM13.0049 13H11.0049V17H13.0049V13ZM9.00488 13H7.00488V17H9.00488V13ZM17.0049 13H15.0049V17H17.0049V13ZM12.0049 4C9.86269 4 8.1138 5.68397 8.00978 7.80036L8.00488 8V9H16.0049V8C16.0049 5.8578 14.3209 4.10892 12.2045 4.0049L12.0049 4Z"
  }));
},
    Od = function Od(_ref1820) {
  var _ref1820$color = _ref1820.color,
      C = _ref1820$color === void 0 ? "currentColor" : _ref1820$color,
      _ref1820$size = _ref1820.size,
      e = _ref1820$size === void 0 ? 24 : _ref1820$size,
      l = _ref1820.className,
      i = _objectWithoutProperties(_ref1820, _excluded1820);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.0049 2C15.3186 2 18.0049 4.68629 18.0049 8V9H22.0049V11H20.8379L20.0813 20.083C20.0381 20.6013 19.6048 21 19.0847 21H4.92502C4.40493 21 3.97166 20.6013 3.92847 20.083L3.17088 11H2.00488V9H6.00488V8C6.00488 4.68629 8.69117 2 12.0049 2ZM18.8309 11H5.17788L5.84488 19H18.1639L18.8309 11ZM13.0049 13V17H11.0049V13H13.0049ZM9.00488 13V17H7.00488V13H9.00488ZM17.0049 13V17H15.0049V13H17.0049ZM12.0049 4C9.86269 4 8.1138 5.68397 8.00978 7.80036L8.00488 8V9H16.0049V8C16.0049 5.8578 14.3209 4.10892 12.2045 4.0049L12.0049 4Z"
  }));
},
    Kd = function Kd(_ref1821) {
  var _ref1821$color = _ref1821.color,
      C = _ref1821$color === void 0 ? "currentColor" : _ref1821$color,
      _ref1821$size = _ref1821.size,
      e = _ref1821$size === void 0 ? 24 : _ref1821$size,
      l = _ref1821.className,
      i = _objectWithoutProperties(_ref1821, _excluded1821);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4.00436 6.41686L0.761719 3.17422L2.17593 1.76001L5.41857 5.00265H20.6603C21.2126 5.00265 21.6603 5.45037 21.6603 6.00265C21.6603 6.09997 21.6461 6.19678 21.6182 6.29L19.2182 14.29C19.0913 14.713 18.7019 15.0027 18.2603 15.0027H6.00436V17.0027H17.0044V19.0027H5.00436C4.45207 19.0027 4.00436 18.5549 4.00436 18.0027V6.41686ZM5.50436 23.0027C4.67593 23.0027 4.00436 22.3311 4.00436 21.5027C4.00436 20.6742 4.67593 20.0027 5.50436 20.0027C6.33279 20.0027 7.00436 20.6742 7.00436 21.5027C7.00436 22.3311 6.33279 23.0027 5.50436 23.0027ZM17.5044 23.0027C16.6759 23.0027 16.0044 22.3311 16.0044 21.5027C16.0044 20.6742 16.6759 20.0027 17.5044 20.0027C18.3328 20.0027 19.0044 20.6742 19.0044 21.5027C19.0044 22.3311 18.3328 23.0027 17.5044 23.0027Z"
  }));
},
    Qd = function Qd(_ref1822) {
  var _ref1822$color = _ref1822.color,
      C = _ref1822$color === void 0 ? "currentColor" : _ref1822$color,
      _ref1822$size = _ref1822.size,
      e = _ref1822$size === void 0 ? 24 : _ref1822$size,
      l = _ref1822.className,
      i = _objectWithoutProperties(_ref1822, _excluded1822);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4.00436 6.41686L0.761719 3.17422L2.17593 1.76001L5.41857 5.00265H20.6603C21.2126 5.00265 21.6603 5.45037 21.6603 6.00265C21.6603 6.09997 21.6461 6.19678 21.6182 6.29L19.2182 14.29C19.0913 14.713 18.7019 15.0027 18.2603 15.0027H6.00436V17.0027H17.0044V19.0027H5.00436C4.45207 19.0027 4.00436 18.5549 4.00436 18.0027V6.41686ZM6.00436 7.00265V13.0027H17.5163L19.3163 7.00265H6.00436ZM5.50436 23.0027C4.67593 23.0027 4.00436 22.3311 4.00436 21.5027C4.00436 20.6742 4.67593 20.0027 5.50436 20.0027C6.33279 20.0027 7.00436 20.6742 7.00436 21.5027C7.00436 22.3311 6.33279 23.0027 5.50436 23.0027ZM17.5044 23.0027C16.6759 23.0027 16.0044 22.3311 16.0044 21.5027C16.0044 20.6742 16.6759 20.0027 17.5044 20.0027C18.3328 20.0027 19.0044 20.6742 19.0044 21.5027C19.0044 22.3311 18.3328 23.0027 17.5044 23.0027Z"
  }));
},
    qd = function qd(_ref1823) {
  var _ref1823$color = _ref1823.color,
      C = _ref1823$color === void 0 ? "currentColor" : _ref1823$color,
      _ref1823$size = _ref1823.size,
      e = _ref1823$size === void 0 ? 24 : _ref1823$size,
      l = _ref1823.className,
      i = _objectWithoutProperties(_ref1823, _excluded1823);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.00488 9H19.9433L20.4433 7H8.00488V5H21.7241C22.2764 5 22.7241 5.44772 22.7241 6C22.7241 6.08176 22.7141 6.16322 22.6942 6.24254L20.1942 16.2425C20.083 16.6877 19.683 17 19.2241 17H5.00488C4.4526 17 4.00488 16.5523 4.00488 16V4H2.00488V2H5.00488C5.55717 2 6.00488 2.44772 6.00488 3V9ZM6.00488 23C4.90031 23 4.00488 22.1046 4.00488 21C4.00488 19.8954 4.90031 19 6.00488 19C7.10945 19 8.00488 19.8954 8.00488 21C8.00488 22.1046 7.10945 23 6.00488 23ZM18.0049 23C16.9003 23 16.0049 22.1046 16.0049 21C16.0049 19.8954 16.9003 19 18.0049 19C19.1095 19 20.0049 19.8954 20.0049 21C20.0049 22.1046 19.1095 23 18.0049 23Z"
  }));
},
    jd = function jd(_ref1824) {
  var _ref1824$color = _ref1824.color,
      C = _ref1824$color === void 0 ? "currentColor" : _ref1824$color,
      _ref1824$size = _ref1824.size,
      e = _ref1824$size === void 0 ? 24 : _ref1824$size,
      l = _ref1824.className,
      i = _objectWithoutProperties(_ref1824, _excluded1824);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4.00488 16V4H2.00488V2H5.00488C5.55717 2 6.00488 2.44772 6.00488 3V15H18.4433L20.4433 7H8.00488V5H21.7241C22.2764 5 22.7241 5.44772 22.7241 6C22.7241 6.08176 22.7141 6.16322 22.6942 6.24254L20.1942 16.2425C20.083 16.6877 19.683 17 19.2241 17H5.00488C4.4526 17 4.00488 16.5523 4.00488 16ZM6.00488 23C4.90031 23 4.00488 22.1046 4.00488 21C4.00488 19.8954 4.90031 19 6.00488 19C7.10945 19 8.00488 19.8954 8.00488 21C8.00488 22.1046 7.10945 23 6.00488 23ZM18.0049 23C16.9003 23 16.0049 22.1046 16.0049 21C16.0049 19.8954 16.9003 19 18.0049 19C19.1095 19 20.0049 19.8954 20.0049 21C20.0049 22.1046 19.1095 23 18.0049 23Z"
  }));
},
    Xd = function Xd(_ref1825) {
  var _ref1825$color = _ref1825.color,
      C = _ref1825$color === void 0 ? "currentColor" : _ref1825$color,
      _ref1825$size = _ref1825.size,
      e = _ref1825$size === void 0 ? 24 : _ref1825$size,
      l = _ref1825.className,
      i = _objectWithoutProperties(_ref1825, _excluded1825);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15 18H9V21H7V17.748C3.54955 16.8599 1 13.7277 1 10C1 5.58172 4.58172 2 9 2C12.3949 2 15.2959 4.11466 16.4576 7.09864C16.7951 7.0339 17.1436 7 17.5 7C20.5376 7 23 9.46243 23 12.5C23 15.5376 20.5376 18 17.5 18H17V21H15V18ZM11 20H13V23H11V20Z"
  }));
},
    Jd = function Jd(_ref1826) {
  var _ref1826$color = _ref1826.color,
      C = _ref1826$color === void 0 ? "currentColor" : _ref1826$color,
      _ref1826$size = _ref1826.size,
      e = _ref1826$size === void 0 ? 24 : _ref1826$size,
      l = _ref1826.className,
      i = _objectWithoutProperties(_ref1826, _excluded1826);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5 16.9297C2.60879 15.5465 1 12.9611 1 10C1 5.58172 4.58172 2 9 2C12.3949 2 15.2959 4.11466 16.4576 7.09864C16.7951 7.0339 17.1436 7 17.5 7C20.5376 7 23 9.46243 23 12.5C23 15.0176 21.3085 17.14 19 17.793V15.6632C20.1825 15.1015 21 13.8962 21 12.5C21 10.567 19.433 9 17.5 9C16.5205 9 15.6351 9.40232 14.9998 10.0507C14.9999 10.0338 15 10.0169 15 10C15 6.68629 12.3137 4 9 4C5.68629 4 3 6.68629 3 10C3 11.777 3.7725 13.3736 5 14.4722V16.9297ZM7 16H9V20H7V16ZM15 16H17V20H15V16ZM11 19H13V23H11V19Z"
  }));
},
    Yd = function Yd(_ref1827) {
  var _ref1827$color = _ref1827.color,
      C = _ref1827$color === void 0 ? "currentColor" : _ref1827$color,
      _ref1827$size = _ref1827.size,
      e = _ref1827$size === void 0 ? 24 : _ref1827$size,
      l = _ref1827.className,
      i = _objectWithoutProperties(_ref1827, _excluded1827);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18 17.8832V16L23 19L18 22V19.9095C14.9224 19.4698 12.2513 17.4584 11.0029 14.5453L11 14.5386L10.9971 14.5453C9.57893 17.8544 6.32508 20 2.72483 20H2V18H2.72483C5.52503 18 8.05579 16.3312 9.15885 13.7574L9.91203 12L9.15885 10.2426C8.05579 7.66878 5.52503 6 2.72483 6H2V4H2.72483C6.32508 4 9.57893 6.14557 10.9971 9.45473L11 9.46141L11.0029 9.45473C12.2513 6.5416 14.9224 4.53022 18 4.09051V2L23 5L18 8V6.11684C15.7266 6.53763 13.7737 8.0667 12.8412 10.2426L12.088 12L12.8412 13.7574C13.7737 15.9333 15.7266 17.4624 18 17.8832Z"
  }));
},
    _d = function _d(_ref1828) {
  var _ref1828$color = _ref1828.color,
      C = _ref1828$color === void 0 ? "currentColor" : _ref1828$color,
      _ref1828$size = _ref1828.size,
      e = _ref1828$size === void 0 ? 24 : _ref1828$size,
      l = _ref1828.className,
      i = _objectWithoutProperties(_ref1828, _excluded1828);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18 17.8832V16L23 19L18 22V19.9095C14.9224 19.4698 12.2513 17.4584 11.0029 14.5453L11 14.5386L10.9971 14.5453C9.57893 17.8544 6.32508 20 2.72483 20H2V18H2.72483C5.52503 18 8.05579 16.3312 9.15885 13.7574L9.91203 12L9.15885 10.2426C8.05579 7.66878 5.52503 6 2.72483 6H2V4H2.72483C6.32508 4 9.57893 6.14557 10.9971 9.45473L11 9.46141L11.0029 9.45473C12.2513 6.5416 14.9224 4.53022 18 4.09051V2L23 5L18 8V6.11684C15.7266 6.53763 13.7737 8.0667 12.8412 10.2426L12.088 12L12.8412 13.7574C13.7737 15.9333 15.7266 17.4624 18 17.8832Z"
  }));
},
    $d = function $d(_ref1829) {
  var _ref1829$color = _ref1829.color,
      C = _ref1829$color === void 0 ? "currentColor" : _ref1829$color,
      _ref1829$size = _ref1829.size,
      e = _ref1829$size === void 0 ? 24 : _ref1829$size,
      l = _ref1829.className,
      i = _objectWithoutProperties(_ref1829, _excluded1829);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11 2.04938V12H13V2.04938C18.0533 2.5511 22 6.81465 22 12C22 17.5229 17.5228 22 12 22C6.47715 22 2 17.5229 2 12C2 6.81465 5.94668 2.5511 11 2.04938Z"
  }));
},
    ep = function ep(_ref1830) {
  var _ref1830$color = _ref1830.color,
      C = _ref1830$color === void 0 ? "currentColor" : _ref1830$color,
      _ref1830$size = _ref1830.size,
      e = _ref1830$size === void 0 ? 24 : _ref1830$size,
      l = _ref1830.className,
      i = _objectWithoutProperties(_ref1830, _excluded1830);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.26489 3.80698L7.41191 5.44558C5.34875 6.89247 4 9.28873 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 9.28873 18.6512 6.89247 16.5881 5.44558L17.7351 3.80698C20.3141 5.61559 22 8.61091 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 8.61091 3.68594 5.61559 6.26489 3.80698ZM11 12V2H13V12H11Z"
  }));
},
    tp = function tp(_ref1831) {
  var _ref1831$color = _ref1831.color,
      C = _ref1831$color === void 0 ? "currentColor" : _ref1831$color,
      _ref1831$size = _ref1831.size,
      e = _ref1831$size === void 0 ? 24 : _ref1831$size,
      l = _ref1831.className,
      i = _objectWithoutProperties(_ref1831, _excluded1831);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM9 5V19H20V5H9Z"
  }));
},
    Cp = function Cp(_ref1832) {
  var _ref1832$color = _ref1832.color,
      C = _ref1832$color === void 0 ? "currentColor" : _ref1832$color,
      _ref1832$size = _ref1832.size,
      e = _ref1832$size === void 0 ? 24 : _ref1832$size,
      l = _ref1832.className,
      i = _objectWithoutProperties(_ref1832, _excluded1832);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM8 5H4V19H8V5ZM10 5V19H20V5H10Z"
  }));
},
    lp = function lp(_ref1833) {
  var _ref1833$color = _ref1833.color,
      C = _ref1833$color === void 0 ? "currentColor" : _ref1833$color,
      _ref1833$size = _ref1833.size,
      e = _ref1833$size === void 0 ? 24 : _ref1833$size,
      l = _ref1833.className,
      i = _objectWithoutProperties(_ref1833, _excluded1833);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.11629 20.0868C3.62137 18.2684 2 15.3236 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 15.3236 20.3786 18.2684 17.8837 20.0868L16.8692 18.348C18.7729 16.8856 20 14.5861 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 14.5861 5.2271 16.8856 7.1308 18.348L6.11629 20.0868ZM8.14965 16.6018C6.83562 15.5012 6 13.8482 6 12C6 8.68629 8.68629 6 12 6C15.3137 6 18 8.68629 18 12C18 13.8482 17.1644 15.5012 15.8503 16.6018L14.8203 14.8365C15.549 14.112 16 13.1087 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 13.1087 8.45105 14.112 9.17965 14.8365L8.14965 16.6018ZM11 13H13L14 22H10L11 13Z"
  }));
},
    ip = function ip(_ref1834) {
  var _ref1834$color = _ref1834.color,
      C = _ref1834$color === void 0 ? "currentColor" : _ref1834$color,
      _ref1834$size = _ref1834.size,
      e = _ref1834$size === void 0 ? 24 : _ref1834$size,
      l = _ref1834.className,
      i = _objectWithoutProperties(_ref1834, _excluded1834);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.11629 20.0868L7.1308 18.348C5.2271 16.8856 4 14.5861 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 14.5861 18.7729 16.8856 16.8692 18.348L17.8837 20.0868C20.3786 18.2684 22 15.3236 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 15.3236 3.62137 18.2684 6.11629 20.0868ZM8.14965 16.6018C6.83562 15.5012 6 13.8482 6 12C6 8.68629 8.68629 6 12 6C15.3137 6 18 8.68629 18 12C18 13.8482 17.1644 15.5012 15.8503 16.6018L14.8203 14.8365C15.549 14.112 16 13.1087 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 13.1087 8.45105 14.112 9.17965 14.8365L8.14965 16.6018ZM11 13H13V22H11V13Z"
  }));
},
    sp = function sp(_ref1835) {
  var _ref1835$color = _ref1835.color,
      C = _ref1835$color === void 0 ? "currentColor" : _ref1835$color,
      _ref1835$size = _ref1835.size,
      e = _ref1835$size === void 0 ? 24 : _ref1835$size,
      l = _ref1835.className,
      i = _objectWithoutProperties(_ref1835, _excluded1835);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.0005 3C16.2849 3 20.2196 4.49683 23.3104 6.99607L12.0005 21L0.689941 6.99671C3.78078 4.49709 7.71583 3 12.0005 3ZM12.0005 5C8.97296 5 6.07788 5.84185 3.57997 7.39179L8.68885 13.7155C9.69799 13.256 10.8194 13 12.0005 13C13.1818 13 14.3032 13.256 15.3123 13.7155L20.4204 7.39132C17.9226 5.84167 15.0278 5 12.0005 5Z"
  }));
},
    rp = function rp(_ref1836) {
  var _ref1836$color = _ref1836.color,
      C = _ref1836$color === void 0 ? "currentColor" : _ref1836$color,
      _ref1836$size = _ref1836.size,
      e = _ref1836$size === void 0 ? 24 : _ref1836$size,
      l = _ref1836.className,
      i = _objectWithoutProperties(_ref1836, _excluded1836);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.0005 3C16.2849 3 20.2196 4.49683 23.3104 6.99607L12.0005 21L0.689941 6.99671C3.78078 4.49709 7.71583 3 12.0005 3ZM12.0005 15C11.3072 15 10.6331 15.1174 10.0002 15.3409L12.0005 17.8169L13.9999 15.34C13.3705 15.12 12.6939 15 12.0005 15ZM12.0005 5C8.97296 5 6.07788 5.84185 3.57997 7.39179L8.68885 13.7155C9.69799 13.256 10.8194 13 12.0005 13C13.1818 13 14.3032 13.256 15.3123 13.7155L20.4204 7.39132C17.9226 5.84167 15.0278 5 12.0005 5Z"
  }));
},
    cp = function cp(_ref1837) {
  var _ref1837$color = _ref1837.color,
      C = _ref1837$color === void 0 ? "currentColor" : _ref1837$color,
      _ref1837$size = _ref1837.size,
      e = _ref1837$size === void 0 ? 24 : _ref1837$size,
      l = _ref1837.className,
      i = _objectWithoutProperties(_ref1837, _excluded1837);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.0005 3C16.2849 3 20.2196 4.49683 23.3104 6.99607L12.0005 21L0.689941 6.99671C3.78078 4.49709 7.71583 3 12.0005 3ZM12.0005 5C8.97296 5 6.07788 5.84185 3.57997 7.39179L6.75851 11.327C8.31685 10.4807 10.1026 10 12.0005 10C13.8983 10 15.6838 10.4806 17.242 11.3267L20.4204 7.39132C17.9226 5.84167 15.0278 5 12.0005 5Z"
  }));
},
    op = function op(_ref1838) {
  var _ref1838$color = _ref1838.color,
      C = _ref1838$color === void 0 ? "currentColor" : _ref1838$color,
      _ref1838$size = _ref1838.size,
      e = _ref1838$size === void 0 ? 24 : _ref1838$size,
      l = _ref1838.className,
      i = _objectWithoutProperties(_ref1838, _excluded1838);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.0005 3C16.2849 3 20.2196 4.49683 23.3104 6.99607L12.0005 21L0.689941 6.99671C3.78078 4.49709 7.71583 3 12.0005 3ZM12.0005 12C10.58 12 9.23638 12.3291 8.04168 12.9152L12.0005 17.8169L15.9589 12.915C14.7643 12.329 13.4209 12 12.0005 12ZM12.0005 5C8.97296 5 6.07788 5.84185 3.57997 7.39179L6.75851 11.327C8.31685 10.4807 10.1026 10 12.0005 10C13.8983 10 15.6838 10.4806 17.242 11.3267L20.4204 7.39132C17.9226 5.84167 15.0278 5 12.0005 5Z"
  }));
},
    ap = function ap(_ref1839) {
  var _ref1839$color = _ref1839.color,
      C = _ref1839$color === void 0 ? "currentColor" : _ref1839$color,
      _ref1839$size = _ref1839.size,
      e = _ref1839$size === void 0 ? 24 : _ref1839$size,
      l = _ref1839.className,
      i = _objectWithoutProperties(_ref1839, _excluded1839);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.0005 3C16.2849 3 20.2196 4.49683 23.3104 6.99607L12.0005 21L0.689941 6.99671C3.78078 4.49709 7.71583 3 12.0005 3ZM12.0005 5C8.97296 5 6.07788 5.84185 3.57997 7.39179L5.48439 9.74853C7.40016 8.63663 9.626 8 12.0005 8C14.3751 8 16.6011 8.63667 18.5169 9.74863L20.4204 7.39132C17.9226 5.84167 15.0278 5 12.0005 5Z"
  }));
},
    np = function np(_ref1840) {
  var _ref1840$color = _ref1840.color,
      C = _ref1840$color === void 0 ? "currentColor" : _ref1840$color,
      _ref1840$size = _ref1840.size,
      e = _ref1840$size === void 0 ? 24 : _ref1840$size,
      l = _ref1840.className,
      i = _objectWithoutProperties(_ref1840, _excluded1840);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.0005 3C16.2849 3 20.2196 4.49683 23.3104 6.99607L12.0005 21L0.689941 6.99671C3.78078 4.49709 7.71583 3 12.0005 3ZM12.0005 10C10.1028 10 8.31726 10.4806 6.75905 11.3267L12.0005 17.8169L17.2419 11.3266C15.6837 10.4805 13.8982 10 12.0005 10ZM12.0005 5C8.97296 5 6.07788 5.84185 3.57997 7.39179L5.48439 9.74853C7.40016 8.63663 9.626 8 12.0005 8C14.3751 8 16.6011 8.63667 18.5169 9.74863L20.4204 7.39132C17.9226 5.84167 15.0278 5 12.0005 5Z"
  }));
},
    mp = function mp(_ref1841) {
  var _ref1841$color = _ref1841.color,
      C = _ref1841$color === void 0 ? "currentColor" : _ref1841$color,
      _ref1841$size = _ref1841.size,
      e = _ref1841$size === void 0 ? 24 : _ref1841$size,
      l = _ref1841.className,
      i = _objectWithoutProperties(_ref1841, _excluded1841);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.0005 3C16.2849 3 20.2196 4.49683 23.3104 6.99607L22.4989 8H18.0005L17.9999 13.571L12.0005 21L0.689941 6.99671C3.78078 4.49709 7.71583 3 12.0005 3ZM22.0005 19V21H20.0005V19H22.0005ZM22.0005 10V17H20.0005V10H22.0005Z"
  }));
},
    wp = function wp(_ref1842) {
  var _ref1842$color = _ref1842.color,
      C = _ref1842$color === void 0 ? "currentColor" : _ref1842$color,
      _ref1842$size = _ref1842.size,
      e = _ref1842$size === void 0 ? 24 : _ref1842$size,
      l = _ref1842.className,
      i = _objectWithoutProperties(_ref1842, _excluded1842);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.0005 3C16.2849 3 20.2196 4.49683 23.3104 6.99607L22.0539 8.55224C19.3066 6.33059 15.809 5 12.0005 5C8.91158 5 6.02706 5.87535 3.58152 7.39152L12.0005 17.8169L17.9999 10.388V13.571L12.0005 21L0.689941 6.99671C3.78078 4.49709 7.71583 3 12.0005 3ZM22.0005 19V21H20.0005V19H22.0005ZM22.0005 10V17H20.0005V10H22.0005Z"
  }));
},
    Lp = function Lp(_ref1843) {
  var _ref1843$color = _ref1843.color,
      C = _ref1843$color === void 0 ? "currentColor" : _ref1843$color,
      _ref1843$size = _ref1843.size,
      e = _ref1843$size === void 0 ? 24 : _ref1843$size,
      l = _ref1843.className,
      i = _objectWithoutProperties(_ref1843, _excluded1843);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.0005 3C16.2849 3 20.2196 4.49683 23.3104 6.99607L12.0005 21L0.689941 6.99671C3.78078 4.49709 7.71583 3 12.0005 3Z"
  }));
},
    hp = function hp(_ref1844) {
  var _ref1844$color = _ref1844.color,
      C = _ref1844$color === void 0 ? "currentColor" : _ref1844$color,
      _ref1844$size = _ref1844.size,
      e = _ref1844$size === void 0 ? 24 : _ref1844$size,
      l = _ref1844.className,
      i = _objectWithoutProperties(_ref1844, _excluded1844);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.0005 3C16.2849 3 20.2196 4.49683 23.3104 6.99607L12.0005 21L0.689941 6.99671C3.78078 4.49709 7.71583 3 12.0005 3ZM12.0005 5C8.97296 5 6.07788 5.84185 3.57997 7.39179L12.0005 17.8169L20.4204 7.39132C17.9226 5.84167 15.0278 5 12.0005 5Z"
  }));
},
    Hp = function Hp(_ref1845) {
  var _ref1845$color = _ref1845.color,
      C = _ref1845$color === void 0 ? "currentColor" : _ref1845$color,
      _ref1845$size = _ref1845.size,
      e = _ref1845$size === void 0 ? 24 : _ref1845$size,
      l = _ref1845.className,
      i = _objectWithoutProperties(_ref1845, _excluded1845);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2.80815 1.39343L20.4858 19.0711L19.0716 20.4853L15.3889 16.8024L12.0005 21L0.689941 6.99674C1.60407 6.25747 2.59204 5.60589 3.64107 5.05479L1.39394 2.80765L2.80815 1.39343ZM12.0005 3.00003C16.2849 3.00003 20.2196 4.49687 23.3104 6.99611L17.9039 13.689L7.72504 3.51088C9.09547 3.17702 10.5273 3.00003 12.0005 3.00003Z"
  }));
},
    Vp = function Vp(_ref1846) {
  var _ref1846$color = _ref1846.color,
      C = _ref1846$color === void 0 ? "currentColor" : _ref1846$color,
      _ref1846$size = _ref1846.size,
      e = _ref1846$size === void 0 ? 24 : _ref1846$size,
      l = _ref1846.className,
      i = _objectWithoutProperties(_ref1846, _excluded1846);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2.80815 1.39343L20.4858 19.0711L19.0716 20.4853L15.3889 16.8034L12.0005 21L0.689941 6.99674C1.60407 6.25747 2.59204 5.60589 3.64107 5.05479L1.39394 2.80765L2.80815 1.39343ZM3.57997 7.39183L12.0005 17.817L13.9669 15.3804L5.13163 6.54439C4.59981 6.79756 4.08187 7.0804 3.57997 7.39183ZM12.0005 3.00003C16.2849 3.00003 20.2196 4.49687 23.3104 6.99611L17.9039 13.689L16.4819 12.267L20.4204 7.39135C17.9226 5.84171 15.0278 5.00003 12.0005 5.00003C11.1277 5.00003 10.2659 5.07 9.42141 5.20674L7.72504 3.51088C9.09547 3.17702 10.5273 3.00003 12.0005 3.00003Z"
  }));
},
    gp = function gp(_ref1847) {
  var _ref1847$color = _ref1847.color,
      C = _ref1847$color === void 0 ? "currentColor" : _ref1847$color,
      _ref1847$size = _ref1847.size,
      e = _ref1847$size === void 0 ? 24 : _ref1847$size,
      l = _ref1847.className,
      i = _objectWithoutProperties(_ref1847, _excluded1847);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5 2H15L19.7071 6.70711C19.8946 6.89464 20 7.149 20 7.41421V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V3C4 2.44772 4.44772 2 5 2ZM13 18V10H8V12H11V18H13ZM8 13V15H10V13H8ZM14 13V15H16V13H14ZM14 10V12H16V10H14ZM8 16V18H10V16H8ZM14 16V18H16V16H14Z"
  }));
},
    Mp = function Mp(_ref1848) {
  var _ref1848$color = _ref1848.color,
      C = _ref1848$color === void 0 ? "currentColor" : _ref1848$color,
      _ref1848$size = _ref1848.size,
      e = _ref1848$size === void 0 ? 24 : _ref1848$size,
      l = _ref1848.className,
      i = _objectWithoutProperties(_ref1848, _excluded1848);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6 4V20H18V7.82843L14.1716 4H6ZM5 2H15L19.7071 6.70711C19.8946 6.89464 20 7.149 20 7.41421V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V3C4 2.44772 4.44772 2 5 2ZM13 10V18H11V12H8V10H13ZM8 13H10V15H8V13ZM14 13H16V15H14V13ZM14 10H16V12H14V10ZM8 16H10V18H8V16ZM14 16H16V18H14V16Z"
  }));
},
    Zp = function Zp(_ref1849) {
  var _ref1849$color = _ref1849.color,
      C = _ref1849$color === void 0 ? "currentColor" : _ref1849$color,
      _ref1849$size = _ref1849.size,
      e = _ref1849$size === void 0 ? 24 : _ref1849$size,
      l = _ref1849.className,
      i = _objectWithoutProperties(_ref1849, _excluded1849);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5 2H15L19.7071 6.70711C19.8946 6.89464 20 7.149 20 7.41421V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V3C4 2.44772 4.44772 2 5 2ZM8 12V18H16V12H8Z"
  }));
},
    xp = function xp(_ref1850) {
  var _ref1850$color = _ref1850.color,
      C = _ref1850$color === void 0 ? "currentColor" : _ref1850$color,
      _ref1850$size = _ref1850.size,
      e = _ref1850$size === void 0 ? 24 : _ref1850$size,
      l = _ref1850.className,
      i = _objectWithoutProperties(_ref1850, _excluded1850);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6 4V20H18V7.82843L14.1716 4H6ZM5 2H15L19.7071 6.70711C19.8946 6.89464 20 7.149 20 7.41421V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V3C4 2.44772 4.44772 2 5 2ZM8 12H16V18H8V12Z"
  }));
},
    vp = function vp(_ref1851) {
  var _ref1851$color = _ref1851.color,
      C = _ref1851$color === void 0 ? "currentColor" : _ref1851$color,
      _ref1851$size = _ref1851.size,
      e = _ref1851$size === void 0 ? 24 : _ref1851$size,
      l = _ref1851.className,
      i = _objectWithoutProperties(_ref1851, _excluded1851);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9.58341 17.3211C8.55316 16.2274 8 15 8 13.0103C8 9.51086 10.4565 6.37366 14.0306 4.82318L14.9233 6.20079C11.588 8.00539 10.9362 10.346 10.6756 11.822C11.2126 11.5443 11.9156 11.4466 12.6047 11.5105C14.4091 11.6778 15.8312 13.159 15.8312 15C15.8312 16.933 14.2642 18.5 12.3312 18.5C11.2581 18.5 10.232 18.0095 9.58341 17.3211Z"
  }));
},
    dp = function dp(_ref1852) {
  var _ref1852$color = _ref1852.color,
      C = _ref1852$color === void 0 ? "currentColor" : _ref1852$color,
      _ref1852$size = _ref1852.size,
      e = _ref1852$size === void 0 ? 24 : _ref1852$size,
      l = _ref1852.className,
      i = _objectWithoutProperties(_ref1852, _excluded1852);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14.4167 6.67891C15.4469 7.77257 16.0001 9 16.0001 10.9897C16.0001 14.4891 13.5436 17.6263 9.96951 19.1768L9.07682 17.7992C12.4121 15.9946 13.0639 13.6539 13.3245 12.178C12.7875 12.4557 12.0845 12.5533 11.3954 12.4895C9.59102 12.3222 8.16895 10.8409 8.16895 9C8.16895 7.067 9.73595 5.5 11.6689 5.5C12.742 5.5 13.7681 5.99045 14.4167 6.67891Z"
  }));
},
    pp = function pp(_ref1853) {
  var _ref1853$color = _ref1853.color,
      C = _ref1853$color === void 0 ? "currentColor" : _ref1853$color,
      _ref1853$size = _ref1853.size,
      e = _ref1853$size === void 0 ? 24 : _ref1853$size,
      l = _ref1853.className,
      i = _objectWithoutProperties(_ref1853, _excluded1853);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13.9602 6.50108L16.7886 3.67265C17.1791 3.28213 17.8123 3.28213 18.2028 3.67265L20.3241 5.79397C20.7146 6.1845 20.7146 6.81766 20.3241 7.20819L17.4957 10.0366L19.2635 11.8044L17.8492 13.2186L10.7782 6.14753L12.1924 4.73331L13.9602 6.50108ZM10.7782 8.97596L15.0208 13.2186L7.24264 20.9968H3V16.7541L10.7782 8.97596Z"
  }));
},
    Ep = function Ep(_ref1854) {
  var _ref1854$color = _ref1854.color,
      C = _ref1854$color === void 0 ? "currentColor" : _ref1854$color,
      _ref1854$size = _ref1854.size,
      e = _ref1854$size === void 0 ? 24 : _ref1854$size,
      l = _ref1854.className,
      i = _objectWithoutProperties(_ref1854, _excluded1854);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.45711 18.9539L15.0208 10.3902L13.6066 8.97596L5.04289 17.5397L6.45711 18.9539ZM12.1924 7.56174L10.7782 6.14753L12.1924 4.73331L13.9602 6.50108L16.7886 3.67265C17.1791 3.28213 17.8123 3.28213 18.2028 3.67265L20.3241 5.79397C20.7146 6.1845 20.7146 6.81766 20.3241 7.20819L17.4957 10.0366L19.2635 11.8044L17.8492 13.2186L16.435 11.8044L7.24264 20.9968H3V16.7541L12.1924 7.56174Z"
  }));
},
    Np = function Np(_ref1855) {
  var _ref1855$color = _ref1855.color,
      C = _ref1855$color === void 0 ? "currentColor" : _ref1855$color,
      _ref1855$size = _ref1855.size,
      e = _ref1855$size === void 0 ? 24 : _ref1855$size,
      l = _ref1855.className,
      i = _objectWithoutProperties(_ref1855, _excluded1855);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8 11.3333L18.2227 4.51823C18.4524 4.36506 18.7628 4.42714 18.916 4.65691C18.9708 4.73904 19 4.83555 19 4.93426V19.0657C19 19.3419 18.7761 19.5657 18.5 19.5657C18.4013 19.5657 18.3048 19.5365 18.2227 19.4818L8 12.6667V19C8 19.5523 7.55228 20 7 20C6.44772 20 6 19.5523 6 19V5C6 4.44772 6.44772 4 7 4C7.55228 4 8 4.44772 8 5V11.3333Z"
  }));
},
    up = function up(_ref1856) {
  var _ref1856$color = _ref1856.color,
      C = _ref1856$color === void 0 ? "currentColor" : _ref1856$color,
      _ref1856$size = _ref1856.size,
      e = _ref1856$size === void 0 ? 24 : _ref1856$size,
      l = _ref1856.className,
      i = _objectWithoutProperties(_ref1856, _excluded1856);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7 4C7.55228 4 8 4.44772 8 5V11.3333L18.2227 4.51823C18.4524 4.36506 18.7628 4.42714 18.916 4.65691C18.9708 4.73904 19 4.83555 19 4.93426V19.0657C19 19.3419 18.7761 19.5657 18.5 19.5657C18.4013 19.5657 18.3048 19.5365 18.2227 19.4818L8 12.6667V19C8 19.5523 7.55228 20 7 20C6.44772 20 6 19.5523 6 19V5C6 4.44772 6.44772 4 7 4ZM17 7.73703L10.6056 12L17 16.263V7.73703Z"
  }));
},
    Bp = function Bp(_ref1857) {
  var _ref1857$color = _ref1857.color,
      C = _ref1857$color === void 0 ? "currentColor" : _ref1857$color,
      _ref1857$size = _ref1857.size,
      e = _ref1857$size === void 0 ? 24 : _ref1857$size,
      l = _ref1857.className,
      i = _objectWithoutProperties(_ref1857, _excluded1857);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7 6C7.55228 6 8 6.44772 8 7V17C8 17.5523 7.55228 18 7 18C6.44772 18 6 17.5523 6 17V7C6 6.44772 6.44772 6 7 6ZM9.07869 12.4085C9.03208 12.3756 8.99144 12.3349 8.95854 12.2883C8.7993 12.0627 8.85309 11.7508 9.07869 11.5915L16.2117 6.55648C16.296 6.49693 16.3967 6.46496 16.5 6.46496C16.7761 6.46496 17 6.68882 17 6.96496V17.035C17 17.1383 16.968 17.239 16.9085 17.3234C16.7492 17.549 16.4373 17.6028 16.2117 17.4435L9.07869 12.4085Z"
  }));
},
    fp = function fp(_ref1858) {
  var _ref1858$color = _ref1858.color,
      C = _ref1858$color === void 0 ? "currentColor" : _ref1858$color,
      _ref1858$size = _ref1858.size,
      e = _ref1858$size === void 0 ? 24 : _ref1858$size,
      l = _ref1858.className,
      i = _objectWithoutProperties(_ref1858, _excluded1858);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7 6C7.55228 6 8 6.44772 8 7V17C8 17.5523 7.55228 18 7 18C6.44772 18 6 17.5523 6 17V7C6 6.44772 6.44772 6 7 6ZM15 14.1402V9.85984L11.9681 12L15 14.1402ZM9.07869 12.4085C9.03208 12.3756 8.99144 12.3349 8.95854 12.2883C8.7993 12.0627 8.85309 11.7508 9.07869 11.5915L16.2117 6.55648C16.296 6.49693 16.3967 6.46496 16.5 6.46496C16.7761 6.46496 17 6.68882 17 6.96496V17.035C17 17.1383 16.968 17.239 16.9085 17.3234C16.7492 17.549 16.4373 17.6028 16.2117 17.4435L9.07869 12.4085Z"
  }));
},
    Rp = function Rp(_ref1859) {
  var _ref1859$color = _ref1859.color,
      C = _ref1859$color === void 0 ? "currentColor" : _ref1859$color,
      _ref1859$size = _ref1859.size,
      e = _ref1859$size === void 0 ? 24 : _ref1859$size,
      l = _ref1859.className,
      i = _objectWithoutProperties(_ref1859, _excluded1859);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16 12.6667L5.77735 19.4818C5.54759 19.6349 5.23715 19.5729 5.08397 19.3431C5.02922 19.261 5 19.1645 5 19.0657V4.93426C5 4.65812 5.22386 4.43426 5.5 4.43426C5.59871 4.43426 5.69522 4.46348 5.77735 4.51823L16 11.3333V5C16 4.44772 16.4477 4 17 4C17.5523 4 18 4.44772 18 5V19C18 19.5523 17.5523 20 17 20C16.4477 20 16 19.5523 16 19V12.6667Z"
  }));
},
    zp = function zp(_ref1860) {
  var _ref1860$color = _ref1860.color,
      C = _ref1860$color === void 0 ? "currentColor" : _ref1860$color,
      _ref1860$size = _ref1860.size,
      e = _ref1860$size === void 0 ? 24 : _ref1860$size,
      l = _ref1860.className,
      i = _objectWithoutProperties(_ref1860, _excluded1860);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16 12.6667L5.77735 19.4818C5.54759 19.6349 5.23715 19.5729 5.08397 19.3431C5.02922 19.261 5 19.1645 5 19.0657V4.93426C5 4.65812 5.22386 4.43426 5.5 4.43426C5.59871 4.43426 5.69522 4.46348 5.77735 4.51823L16 11.3333V5C16 4.44772 16.4477 4 17 4C17.5523 4 18 4.44772 18 5V19C18 19.5523 17.5523 20 17 20C16.4477 20 16 19.5523 16 19V12.6667ZM7 7.73703V16.263L13.3944 12L7 7.73703Z"
  }));
},
    Fp = function Fp(_ref1861) {
  var _ref1861$color = _ref1861.color,
      C = _ref1861$color === void 0 ? "currentColor" : _ref1861$color,
      _ref1861$size = _ref1861.size,
      e = _ref1861$size === void 0 ? 24 : _ref1861$size,
      l = _ref1861.className,
      i = _objectWithoutProperties(_ref1861, _excluded1861);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7.78834 17.4435C7.70398 17.5031 7.60326 17.535 7.5 17.535C7.22386 17.535 7 17.3112 7 17.035V6.96496C7 6.8617 7.03197 6.76098 7.09152 6.67662C7.25076 6.45102 7.56274 6.39723 7.78834 6.55648L14.9213 11.5915C14.9679 11.6244 15.0086 11.665 15.0415 11.7117C15.2007 11.9373 15.1469 12.2492 14.9213 12.4085L7.78834 17.4435ZM16 7C16 6.44772 16.4477 6 17 6C17.5523 6 18 6.44772 18 7V17C18 17.5523 17.5523 18 17 18C16.4477 18 16 17.5523 16 17V7Z"
  }));
},
    Sp = function Sp(_ref1862) {
  var _ref1862$color = _ref1862.color,
      C = _ref1862$color === void 0 ? "currentColor" : _ref1862$color,
      _ref1862$size = _ref1862.size,
      e = _ref1862$size === void 0 ? 24 : _ref1862$size,
      l = _ref1862.className,
      i = _objectWithoutProperties(_ref1862, _excluded1862);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.0319 12L9 9.85984V14.1402L12.0319 12ZM7.5 17.535C7.22386 17.535 7 17.3112 7 17.035V6.96496C7 6.8617 7.03197 6.76098 7.09152 6.67662C7.25076 6.45102 7.56274 6.39723 7.78834 6.55648L14.9213 11.5915C14.9679 11.6244 15.0086 11.665 15.0415 11.7117C15.2007 11.9373 15.1469 12.2492 14.9213 12.4085L7.78834 17.4435C7.70398 17.5031 7.60326 17.535 7.5 17.535ZM16 7C16 6.44772 16.4477 6 17 6C17.5523 6 18 6.44772 18 7V17C18 17.5523 17.5523 18 17 18C16.4477 18 16 17.5523 16 17V7Z"
  }));
},
    Ap = function Ap(_ref1863) {
  var _ref1863$color = _ref1863.color,
      C = _ref1863$color === void 0 ? "currentColor" : _ref1863$color,
      _ref1863$size = _ref1863.size,
      e = _ref1863$size === void 0 ? 24 : _ref1863$size,
      l = _ref1863.className,
      i = _objectWithoutProperties(_ref1863, _excluded1863);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C17.5228 2 22 6.47715 22 12V15.7639C22 16.5215 21.572 17.214 20.8944 17.5528L18 19V20C18 21.5977 16.7511 22.9037 15.1763 22.9949L14.9499 23.0004C14.9718 22.8926 14.9868 22.7823 14.9943 22.67L15 22.5V22C15 20.9456 14.1841 20.0818 13.1493 20.0055L13 20H11C9.94564 20 9.08183 20.8159 9.00549 21.8507L9 22V22.5C9 22.6714 9.01725 22.8387 9.0501 23.0004L9 23C7.34315 23 6 21.6569 6 20V19L3.10557 17.5528C2.428 17.214 2 16.5215 2 15.7639V12C2 6.47715 6.47715 2 12 2ZM8 11C6.89543 11 6 11.8954 6 13C6 14.1046 6.89543 15 8 15C9.10457 15 10 14.1046 10 13C10 11.8954 9.10457 11 8 11ZM16 11C14.8954 11 14 11.8954 14 13C14 14.1046 14.8954 15 16 15C17.1046 15 18 14.1046 18 13C18 11.8954 17.1046 11 16 11Z"
  }));
},
    kp = function kp(_ref1864) {
  var _ref1864$color = _ref1864.color,
      C = _ref1864$color === void 0 ? "currentColor" : _ref1864$color,
      _ref1864$size = _ref1864.size,
      e = _ref1864$size === void 0 ? 24 : _ref1864$size,
      l = _ref1864.className,
      i = _objectWithoutProperties(_ref1864, _excluded1864);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C17.5228 2 22 6.47715 22 12V15.7639C22 16.5215 21.572 17.214 20.8944 17.5528L18 19V20C18 21.5977 16.7511 22.9037 15.1763 22.9949L14.9499 23.0004C14.9718 22.8926 14.9868 22.7823 14.9943 22.67L15 22.5V22C15 20.9456 14.1841 20.0818 13.1493 20.0055L13 20H11C9.94564 20 9.08183 20.8159 9.00549 21.8507L9 22V22.5C9 22.6714 9.01725 22.8387 9.0501 23.0004L9 23C7.34315 23 6 21.6569 6 20V19L3.10557 17.5528C2.428 17.214 2 16.5215 2 15.7639V12C2 6.47715 6.47715 2 12 2ZM12 4C7.66509 4 4.13546 7.44784 4.00381 11.7508L4 12V15.7639L8 17.7639V19.355L8.07537 19.2711C8.76418 18.5335 9.72777 18.0584 10.7981 18.005L11 18L13.0735 18.0013L13.2964 18.0109C14.2947 18.0846 15.1868 18.5219 15.8452 19.1884L16 19.355V17.7639L20 15.7639V12C20 7.58172 16.4183 4 12 4ZM8 11C9.10457 11 10 11.8954 10 13C10 14.1046 9.10457 15 8 15C6.89543 15 6 14.1046 6 13C6 11.8954 6.89543 11 8 11ZM16 11C17.1046 11 18 11.8954 18 13C18 14.1046 17.1046 15 16 15C14.8954 15 14 14.1046 14 13C14 11.8954 14.8954 11 16 11Z"
  }));
},
    Pp = function Pp(_ref1865) {
  var _ref1865$color = _ref1865.color,
      C = _ref1865$color === void 0 ? "currentColor" : _ref1865$color,
      _ref1865$size = _ref1865.size,
      e = _ref1865$size === void 0 ? 24 : _ref1865$size,
      l = _ref1865.className,
      i = _objectWithoutProperties(_ref1865, _excluded1865);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18 18V21C18 21.5523 17.5523 22 17 22H7C6.44772 22 6 21.5523 6 21V18H3C2.44772 18 2 17.5523 2 17V12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12V17C22 17.5523 21.5523 18 21 18H18ZM7.5 14C8.32843 14 9 13.3284 9 12.5C9 11.6716 8.32843 11 7.5 11C6.67157 11 6 11.6716 6 12.5C6 13.3284 6.67157 14 7.5 14ZM16.5 14C17.3284 14 18 13.3284 18 12.5C18 11.6716 17.3284 11 16.5 11C15.6716 11 15 11.6716 15 12.5C15 13.3284 15.6716 14 16.5 14Z"
  }));
},
    Dp = function Dp(_ref1866) {
  var _ref1866$color = _ref1866.color,
      C = _ref1866$color === void 0 ? "currentColor" : _ref1866$color,
      _ref1866$size = _ref1866.size,
      e = _ref1866$size === void 0 ? 24 : _ref1866$size,
      l = _ref1866.className,
      i = _objectWithoutProperties(_ref1866, _excluded1866);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12V16H7C7.55228 16 8 16.4477 8 17V20H16V17C16 16.4477 16.4477 16 17 16H20V12ZM18 18V21C18 21.5523 17.5523 22 17 22H7C6.44772 22 6 21.5523 6 21V18H3C2.44772 18 2 17.5523 2 17V12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12V17C22 17.5523 21.5523 18 21 18H18ZM7.5 14C6.67157 14 6 13.3284 6 12.5C6 11.6716 6.67157 11 7.5 11C8.32843 11 9 11.6716 9 12.5C9 13.3284 8.32843 14 7.5 14ZM16.5 14C15.6716 14 15 13.3284 15 12.5C15 11.6716 15.6716 11 16.5 11C17.3284 11 18 11.6716 18 12.5C18 13.3284 17.3284 14 16.5 14Z"
  }));
},
    yp = function yp(_ref1867) {
  var _ref1867$color = _ref1867.color,
      C = _ref1867$color === void 0 ? "currentColor" : _ref1867$color,
      _ref1867$size = _ref1867.size,
      e = _ref1867$size === void 0 ? 24 : _ref1867$size,
      l = _ref1867.className,
      i = _objectWithoutProperties(_ref1867, _excluded1867);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13.3109 20.3997C12.8839 20.4657 12.4464 20.5 12.001 20.5C7.30656 20.5 3.50098 16.6944 3.50098 12C3.50098 11.5545 3.53524 11.1171 3.60129 10.6901C3.21792 9.96108 3.00098 9.13087 3.00098 8.25C3.00098 5.35051 5.35148 3 8.25098 3C9.13185 3 9.96205 3.21694 10.6911 3.60031C11.118 3.53427 11.5555 3.5 12.001 3.5C16.6954 3.5 20.501 7.30558 20.501 12C20.501 12.4455 20.4667 12.8829 20.4007 13.3099C20.784 14.0389 21.001 14.8691 21.001 15.75C21.001 18.6495 18.6505 21 15.751 21C14.8701 21 14.0399 20.7831 13.3109 20.3997ZM12.0532 17.1555L12.0126 17.1562C14.8854 17.1562 16.3158 15.7703 16.3158 13.9132C16.3158 12.7148 15.7645 11.442 13.5904 10.9552L11.6073 10.515C10.8522 10.3433 9.98514 10.1145 9.98514 9.39975C9.98514 8.685 10.6041 8.187 11.7088 8.187C13.9394 8.187 13.7355 9.71475 14.8403 9.71475C15.4156 9.71475 15.933 9.37275 15.933 8.78475C15.933 7.41525 13.7355 6.3855 11.8773 6.3855C9.85579 6.3855 7.70421 7.2435 7.70421 9.52875C7.70421 10.6275 8.09753 11.799 10.2634 12.342L12.9527 13.0133C13.7686 13.215 13.9709 13.6718 13.9709 14.085C13.9709 14.772 13.2873 15.4432 12.0532 15.4432C9.6362 15.4432 9.97461 13.5855 8.67885 13.5855C8.09828 13.5855 7.67639 13.9837 7.67639 14.5575C7.67639 15.6712 9.0278 17.1555 12.0532 17.1555Z"
  }));
},
    bp = function bp(_ref1868) {
  var _ref1868$color = _ref1868.color,
      C = _ref1868$color === void 0 ? "currentColor" : _ref1868$color,
      _ref1868$size = _ref1868.size,
      e = _ref1868$size === void 0 ? 24 : _ref1868$size,
      l = _ref1868.className,
      i = _objectWithoutProperties(_ref1868, _excluded1868);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13.0052 18.4232C13.4288 18.3577 13.8623 18.43 14.2418 18.6295C14.7026 18.8719 15.2154 19 15.751 19C17.5459 19 19.001 17.5449 19.001 15.75C19.001 15.2144 18.8728 14.7016 18.6305 14.2408C18.431 13.8613 18.3586 13.4278 18.4242 13.0042C18.4752 12.6746 18.501 12.3393 18.501 12C18.501 8.41015 15.5908 5.5 12.001 5.5C11.6617 5.5 11.3264 5.52582 10.9968 5.57681C10.5731 5.64234 10.1396 5.57001 9.7602 5.37047C9.29939 5.12815 8.7866 5 8.25098 5C6.45605 5 5.00098 6.45507 5.00098 8.25C5.00098 8.78562 5.12912 9.29841 5.37145 9.75922C5.57098 10.1387 5.64332 10.5722 5.57778 10.9958C5.5268 11.3254 5.50098 11.6607 5.50098 12C5.50098 15.5899 8.41113 18.5 12.001 18.5C12.3403 18.5 12.6755 18.4742 13.0052 18.4232ZM12.001 20.5C7.30656 20.5 3.50098 16.6944 3.50098 12C3.50098 11.5545 3.53524 11.1171 3.60129 10.6901C3.21792 9.96108 3.00098 9.13087 3.00098 8.25C3.00098 5.35051 5.35148 3 8.25098 3C9.13185 3 9.96205 3.21694 10.6911 3.60031C11.118 3.53427 11.5555 3.5 12.001 3.5C16.6954 3.5 20.501 7.30558 20.501 12C20.501 12.4455 20.4667 12.8829 20.4007 13.3099C20.784 14.0389 21.001 14.8691 21.001 15.75C21.001 18.6495 18.6505 21 15.751 21C14.8701 21 14.0399 20.7831 13.3109 20.3997C12.8839 20.4657 12.4464 20.5 12.001 20.5ZM12.0539 16.9993C9.25237 16.9993 8.00098 15.6213 8.00098 14.5872C8.00098 14.0545 8.39165 13.6848 8.92925 13.6848C10.1291 13.6848 9.81574 15.4096 12.0539 15.4096C13.1967 15.4096 13.8297 14.7864 13.8297 14.1485C13.8297 13.7648 13.6423 13.3408 12.8868 13.1535L10.3965 12.5303C8.39095 12.0261 8.02674 10.9384 8.02674 9.91832C8.02674 7.7966 10.0191 7 11.8909 7C13.6117 7 15.6465 7.95606 15.6465 9.22756C15.6465 9.77348 15.1674 10.091 14.6347 10.091C13.6117 10.091 13.8004 8.67259 11.735 8.67259C10.712 8.67259 10.1389 9.13495 10.1389 9.79855C10.1389 10.4622 10.9418 10.6745 11.6409 10.834L13.4773 11.2427C15.4905 11.6947 16.001 12.8763 16.001 13.9891C16.001 15.7132 14.6765 17 12.0163 17L12.0539 16.9993Z"
  }));
},
    Tp = function Tp(_ref1869) {
  var _ref1869$color = _ref1869.color,
      C = _ref1869$color === void 0 ? "currentColor" : _ref1869$color,
      _ref1869$size = _ref1869.size,
      e = _ref1869$size === void 0 ? 24 : _ref1869$size,
      l = _ref1869.className,
      i = _objectWithoutProperties(_ref1869, _excluded1869);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.52739 14.5136C6.52739 15.5966 5.64264 16.4814 4.55959 16.4814C3.47654 16.4814 2.5918 15.5966 2.5918 14.5136C2.5918 13.4305 3.47654 12.5458 4.55959 12.5458H6.52739V14.5136ZM7.51892 14.5136C7.51892 13.4305 8.40366 12.5458 9.48671 12.5458C10.5698 12.5458 11.4545 13.4305 11.4545 14.5136V19.4407C11.4545 20.5238 10.5698 21.4085 9.48671 21.4085C8.40366 21.4085 7.51892 20.5238 7.51892 19.4407V14.5136ZM9.48671 6.52715C8.40366 6.52715 7.51892 5.6424 7.51892 4.55935C7.51892 3.4763 8.40366 2.59155 9.48671 2.59155C10.5698 2.59155 11.4545 3.4763 11.4545 4.55935V6.52715H9.48671ZM9.48671 7.51867C10.5698 7.51867 11.4545 8.40342 11.4545 9.48647C11.4545 10.5695 10.5698 11.4543 9.48671 11.4543H4.55959C3.47654 11.4543 2.5918 10.5695 2.5918 9.48647C2.5918 8.40342 3.47654 7.51867 4.55959 7.51867H9.48671ZM17.4732 9.48647C17.4732 8.40342 18.3579 7.51867 19.4409 7.51867C20.524 7.51867 21.4087 8.40342 21.4087 9.48647C21.4087 10.5695 20.524 11.4543 19.4409 11.4543H17.4732V9.48647ZM16.4816 9.48647C16.4816 10.5695 15.5969 11.4543 14.5138 11.4543C13.4308 11.4543 12.546 10.5695 12.546 9.48647V4.55935C12.546 3.4763 13.4308 2.59155 14.5138 2.59155C15.5969 2.59155 16.4816 3.4763 16.4816 4.55935V9.48647ZM14.5138 17.4729C15.5969 17.4729 16.4816 18.3577 16.4816 19.4407C16.4816 20.5238 15.5969 21.4085 14.5138 21.4085C13.4308 21.4085 12.546 20.5238 12.546 19.4407V17.4729H14.5138ZM14.5138 16.4814C13.4308 16.4814 12.546 15.5966 12.546 14.5136C12.546 13.4305 13.4308 12.5458 14.5138 12.5458H19.4409C20.524 12.5458 21.4087 13.4305 21.4087 14.5136C21.4087 15.5966 20.524 16.4814 19.4409 16.4814H14.5138Z"
  }));
},
    Up = function Up(_ref1870) {
  var _ref1870$color = _ref1870.color,
      C = _ref1870$color === void 0 ? "currentColor" : _ref1870$color,
      _ref1870$size = _ref1870.size,
      e = _ref1870$size === void 0 ? 24 : _ref1870$size,
      l = _ref1870.className,
      i = _objectWithoutProperties(_ref1870, _excluded1870);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14.501 3C15.3294 3 16.001 3.67157 16.001 4.5V9.5C16.001 10.3284 15.3294 11 14.501 11C13.6725 11 13.001 10.3284 13.001 9.5V4.5C13.001 3.67157 13.6725 3 14.501 3ZM4.50098 13H6.00098V14.5C6.00098 15.3284 5.3294 16 4.50098 16C3.67255 16 3.00098 15.3284 3.00098 14.5C3.00098 13.6716 3.67255 13 4.50098 13ZM13.001 18H14.501C15.3294 18 16.001 18.6716 16.001 19.5C16.001 20.3284 15.3294 21 14.501 21C13.6725 21 13.001 20.3284 13.001 19.5V18ZM14.501 13H19.501C20.3294 13 21.001 13.6716 21.001 14.5C21.001 15.3284 20.3294 16 19.501 16H14.501C13.6725 16 13.001 15.3284 13.001 14.5C13.001 13.6716 13.6725 13 14.501 13ZM19.501 8C20.3294 8 21.001 8.67157 21.001 9.5C21.001 10.3284 20.3294 11 19.501 11H18.001V9.5C18.001 8.67157 18.6725 8 19.501 8ZM4.50098 8H9.50098C10.3294 8 11.001 8.67157 11.001 9.5C11.001 10.3284 10.3294 11 9.50098 11H4.50098C3.67255 11 3.00098 10.3284 3.00098 9.5C3.00098 8.67157 3.67255 8 4.50098 8ZM9.50098 3C10.3294 3 11.001 3.67157 11.001 4.5V6H9.50098C8.67255 6 8.00098 5.32843 8.00098 4.5C8.00098 3.67157 8.67255 3 9.50098 3ZM9.50098 13C10.3294 13 11.001 13.6716 11.001 14.5V19.5C11.001 20.3284 10.3294 21 9.50098 21C8.67255 21 8.00098 20.3284 8.00098 19.5V14.5C8.00098 13.6716 8.67255 13 9.50098 13Z"
  }));
},
    Gp = function Gp(_ref1871) {
  var _ref1871$color = _ref1871.color,
      C = _ref1871$color === void 0 ? "currentColor" : _ref1871$color,
      _ref1871$size = _ref1871.size,
      e = _ref1871$size === void 0 ? 24 : _ref1871$size,
      l = _ref1871.className,
      i = _objectWithoutProperties(_ref1871, _excluded1871);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13.7678 12.2288L15.8892 14.3501C11.293 18.9463 5.63612 20.3605 2.10059 19.6534L17.6569 4.09705L19.7783 6.21837L13.7678 12.2288Z"
  }));
},
    Ip = function Ip(_ref1872) {
  var _ref1872$color = _ref1872.color,
      C = _ref1872$color === void 0 ? "currentColor" : _ref1872$color,
      _ref1872$size = _ref1872.size,
      e = _ref1872$size === void 0 ? 24 : _ref1872$size,
      l = _ref1872.className,
      i = _objectWithoutProperties(_ref1872, _excluded1872);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15.6909 12.9147L17.4587 14.6824C11.4482 20.6929 6.4985 20.6929 2.25586 19.2786L17.8122 3.72229L21.3477 7.25782L15.6909 12.9147ZM12.8625 12.9147L18.5193 7.25782L17.8122 6.55072L6.3145 18.0484C9.04606 18.1558 11.6722 17.142 14.5808 14.633L12.8625 12.9147Z"
  }));
},
    Wp = function Wp(_ref1873) {
  var _ref1873$color = _ref1873.color,
      C = _ref1873$color === void 0 ? "currentColor" : _ref1873$color,
      _ref1873$size = _ref1873.size,
      e = _ref1873$size === void 0 ? 24 : _ref1873$size,
      l = _ref1873.className,
      i = _objectWithoutProperties(_ref1873, _excluded1873);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13 17V20H18V22H6V20H11V17H4C3.44772 17 3 16.5523 3 16V4H2V2H22V4H21V16C21 16.5523 20.5523 17 20 17H13ZM10 6V13L15 9.5L10 6Z"
  }));
},
    Op = function Op(_ref1874) {
  var _ref1874$color = _ref1874.color,
      C = _ref1874$color === void 0 ? "currentColor" : _ref1874$color,
      _ref1874$size = _ref1874.size,
      e = _ref1874$size === void 0 ? 24 : _ref1874$size,
      l = _ref1874.className,
      i = _objectWithoutProperties(_ref1874, _excluded1874);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13 17V20H18V22H6V20H11V17H4C3.44772 17 3 16.5523 3 16V4H2V2H22V4H21V16C21 16.5523 20.5523 17 20 17H13ZM5 15H19V4H5V15ZM10 6L15 9.5L10 13V6Z"
  }));
},
    Kp = function Kp(_ref1875) {
  var _ref1875$color = _ref1875.color,
      C = _ref1875$color === void 0 ? "currentColor" : _ref1875$color,
      _ref1875$size = _ref1875.size,
      e = _ref1875$size === void 0 ? 24 : _ref1875$size,
      l = _ref1875.className,
      i = _objectWithoutProperties(_ref1875, _excluded1875);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13 18V20H17V22H7V20H11V18H3C2.44772 18 2 17.5523 2 17V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V17C22 17.5523 21.5523 18 21 18H13ZM10 7.5V13.5L15 10.5L10 7.5Z"
  }));
},
    Qp = function Qp(_ref1876) {
  var _ref1876$color = _ref1876.color,
      C = _ref1876$color === void 0 ? "currentColor" : _ref1876$color,
      _ref1876$size = _ref1876.size,
      e = _ref1876$size === void 0 ? 24 : _ref1876$size,
      l = _ref1876.className,
      i = _objectWithoutProperties(_ref1876, _excluded1876);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13 18V20H17V22H7V20H11V18H3C2.44772 18 2 17.5523 2 17V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V17C22 17.5523 21.5523 18 21 18H13ZM4 5V16H20V5H4ZM10 7.5L15 10.5L10 13.5V7.5Z"
  }));
},
    qp = function qp(_ref1877) {
  var _ref1877$color = _ref1877.color,
      C = _ref1877$color === void 0 ? "currentColor" : _ref1877$color,
      _ref1877$size = _ref1877.size,
      e = _ref1877$size === void 0 ? 24 : _ref1877$size,
      l = _ref1877.className,
      i = _objectWithoutProperties(_ref1877, _excluded1877);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8.17071 3C8.58254 1.83481 9.69378 1 11 1H13C14.3062 1 15.4175 1.83481 15.8293 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H8.17071ZM10 9V15L15 12L10 9ZM11 3C10.4477 3 10 3.44772 10 4C10 4.55228 10.4477 5 11 5H13C13.5523 5 14 4.55228 14 4C14 3.44772 13.5523 3 13 3H11Z"
  }));
},
    jp = function jp(_ref1878) {
  var _ref1878$color = _ref1878.color,
      C = _ref1878$color === void 0 ? "currentColor" : _ref1878$color,
      _ref1878$size = _ref1878.size,
      e = _ref1878$size === void 0 ? 24 : _ref1878$size,
      l = _ref1878.className,
      i = _objectWithoutProperties(_ref1878, _excluded1878);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8.17071 3C8.58254 1.83481 9.69378 1 11 1H13C14.3062 1 15.4175 1.83481 15.8293 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H8.17071ZM4 5V19H20V5H15.8293C15.4175 6.16519 14.3062 7 13 7H11C9.69378 7 8.58254 6.16519 8.17071 5H4ZM11 3C10.4477 3 10 3.44772 10 4C10 4.55228 10.4477 5 11 5H13C13.5523 5 14 4.55228 14 4C14 3.44772 13.5523 3 13 3H11ZM10 9L15 12L10 15V9Z"
  }));
},
    Xp = function Xp(_ref1879) {
  var _ref1879$color = _ref1879.color,
      C = _ref1879$color === void 0 ? "currentColor" : _ref1879$color,
      _ref1879$size = _ref1879.size,
      e = _ref1879$size === void 0 ? 24 : _ref1879$size,
      l = _ref1879.className,
      i = _objectWithoutProperties(_ref1879, _excluded1879);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13 21V23H11V21H3C2.44772 21 2 20.5523 2 20V6H22V20C22 20.5523 21.5523 21 21 21H13ZM8 10C6.34315 10 5 11.3431 5 13C5 14.6569 6.34315 16 8 16C9.65685 16 11 14.6569 11 13H8V10ZM13 10V12H19V10H13ZM13 14V16H19V14H13ZM2 3H22V5H2V3Z"
  }));
},
    Jp = function Jp(_ref1880) {
  var _ref1880$color = _ref1880.color,
      C = _ref1880$color === void 0 ? "currentColor" : _ref1880$color,
      _ref1880$size = _ref1880.size,
      e = _ref1880$size === void 0 ? 24 : _ref1880$size,
      l = _ref1880.className,
      i = _objectWithoutProperties(_ref1880, _excluded1880);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13 21V23H11V21H3C2.44772 21 2 20.5523 2 20V6H22V20C22 20.5523 21.5523 21 21 21H13ZM4 19H20V8H4V19ZM13 10H18V12H13V10ZM13 14H18V16H13V14ZM9 10V13H12C12 14.6569 10.6569 16 9 16C7.34315 16 6 14.6569 6 13C6 11.3431 7.34315 10 9 10ZM2 3H22V5H2V3Z"
  }));
},
    Yp = function Yp(_ref1881) {
  var _ref1881$color = _ref1881.color,
      C = _ref1881$color === void 0 ? "currentColor" : _ref1881$color,
      _ref1881$size = _ref1881.size,
      e = _ref1881$size === void 0 ? 24 : _ref1881$size,
      l = _ref1881.className,
      i = _objectWithoutProperties(_ref1881, _excluded1881);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6 2H18C18.5523 2 19 2.44772 19 3V21C19 21.5523 18.5523 22 18 22H6C5.44772 22 5 21.5523 5 21V3C5 2.44772 5.44772 2 6 2ZM12 17C11.4477 17 11 17.4477 11 18C11 18.5523 11.4477 19 12 19C12.5523 19 13 18.5523 13 18C13 17.4477 12.5523 17 12 17Z"
  }));
},
    _p = function _p(_ref1882) {
  var _ref1882$color = _ref1882.color,
      C = _ref1882$color === void 0 ? "currentColor" : _ref1882$color,
      _ref1882$size = _ref1882.size,
      e = _ref1882$size === void 0 ? 24 : _ref1882$size,
      l = _ref1882.className,
      i = _objectWithoutProperties(_ref1882, _excluded1882);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7 4V20H17V4H7ZM6 2H18C18.5523 2 19 2.44772 19 3V21C19 21.5523 18.5523 22 18 22H6C5.44772 22 5 21.5523 5 21V3C5 2.44772 5.44772 2 6 2ZM12 17C12.5523 17 13 17.4477 13 18C13 18.5523 12.5523 19 12 19C11.4477 19 11 18.5523 11 18C11 17.4477 11.4477 17 12 17Z"
  }));
},
    $p = function $p(_ref1883) {
  var _ref1883$color = _ref1883.color,
      C = _ref1883$color === void 0 ? "currentColor" : _ref1883$color,
      _ref1883$size = _ref1883.size,
      e = _ref1883$size === void 0 ? 24 : _ref1883$size,
      l = _ref1883.className,
      i = _objectWithoutProperties(_ref1883, _excluded1883);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11.872 21.7645C10.6817 21.7645 9.88811 21.2027 9.17926 20.7079C8.67548 20.3512 8.20292 20.0124 7.64564 19.9188C7.37369 19.8697 7.09729 19.8519 6.84317 19.8519C6.3706 19.8519 5.99612 19.9232 5.72863 19.9767C5.55922 20.0079 5.41655 20.0347 5.3051 20.0347C5.18919 20.0347 5.04207 20.0035 4.98411 19.8073C4.93507 19.6468 4.90386 19.4953 4.87266 19.3481C4.79241 18.9781 4.72554 18.7507 4.58733 18.7285C3.0983 18.5011 2.20667 18.1578 2.0328 17.7521C2.01942 17.7075 2.00159 17.6629 2.00159 17.6273C1.99267 17.5025 2.08184 17.3999 2.20667 17.3776C3.38808 17.1815 4.44913 16.5529 5.34522 15.5186C6.0407 14.7161 6.37952 13.9404 6.41073 13.8557C6.41073 13.8467 6.41964 13.8467 6.41964 13.8467C6.58906 13.4946 6.62472 13.1959 6.52218 12.9507C6.33048 12.4915 5.69742 12.2953 5.26498 12.1616C5.15352 12.1303 5.0599 12.0947 4.97965 12.0679C4.60962 11.9208 3.9944 11.6087 4.07464 11.1763C4.1326 10.8642 4.54721 10.6413 4.88603 10.6413C4.97965 10.6413 5.0599 10.6547 5.12677 10.6904C5.50572 10.8642 5.849 10.9534 6.14324 10.9534C6.50881 10.9534 6.68268 10.8152 6.72726 10.7706C6.71834 10.5744 6.70497 10.3694 6.69159 10.1777C6.60243 8.81346 6.49989 7.11936 6.93234 6.14747C8.22967 3.24074 10.9848 3.00892 11.8007 3.00892C11.823 3.00892 12.1573 3 12.1573 3C12.1707 3 12.1885 3 12.2064 3C13.0222 3 15.7774 3.22737 17.0747 6.13856C17.5116 7.11044 17.4046 8.80901 17.3154 10.1687L17.3065 10.2356C17.2976 10.4184 17.2842 10.5923 17.2753 10.7706C17.3199 10.8063 17.4804 10.94 17.8103 10.9445C18.0956 10.9356 18.4077 10.8419 18.7643 10.6814C18.8758 10.6324 18.9917 10.6146 19.0764 10.6146C19.2012 10.6146 19.3261 10.6458 19.4331 10.6814H19.442C19.7407 10.7929 19.9368 11.0024 19.9368 11.2209C19.9458 11.426 19.7853 11.738 19.0229 12.0456C18.9427 12.0768 18.849 12.1125 18.7376 12.1393C18.3141 12.2686 17.681 12.4736 17.4804 12.9284C17.3689 13.1691 17.4135 13.4767 17.5829 13.8245C17.5829 13.8334 17.5918 13.8334 17.5918 13.8334C17.6409 13.9582 18.9293 16.8828 21.7959 17.3598C21.9207 17.3821 22.001 17.4846 22.001 17.6094C22.001 17.654 21.9921 17.6986 21.9698 17.7387C21.7959 18.1489 20.9132 18.4833 19.4152 18.7151C19.277 18.7374 19.2102 18.9647 19.1299 19.3348C19.0987 19.4863 19.063 19.6335 19.0185 19.794C18.9739 19.9411 18.8803 20.0213 18.7198 20.0213H18.6975C18.5949 20.0213 18.4567 20.0079 18.2739 19.9723C17.953 19.9054 17.6008 19.8564 17.1594 19.8564C16.8964 19.8564 16.6244 19.8787 16.3569 19.9232C15.8041 20.0124 15.3271 20.3557 14.8233 20.7123C14.1055 21.2027 13.3075 21.7645 12.1261 21.7645C12.1261 21.7645 11.9077 21.7645 11.872 21.7645Z"
  }));
},
    eE = function eE(_ref1884) {
  var _ref1884$color = _ref1884.color,
      C = _ref1884$color === void 0 ? "currentColor" : _ref1884$color,
      _ref1884$size = _ref1884.size,
      e = _ref1884$size === void 0 ? 24 : _ref1884$size,
      l = _ref1884.className,
      i = _objectWithoutProperties(_ref1884, _excluded1884);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15.3826 10.5792C15.3904 10.4826 15.3969 10.4035 15.4025 10.3311C15.4137 10.1844 15.4243 10.0268 15.4344 9.85059C15.4662 9.29326 15.4853 8.67669 15.4853 8.00554C15.4853 7.1344 15.191 6.51928 14.571 5.94177C13.9117 5.3277 13.1124 5 11.9819 5C10.8441 5 10.0229 5.33486 9.4705 5.88766C8.77543 6.58319 8.51358 7.10616 8.51358 7.98803C8.51358 8.50939 8.57456 9.98166 8.60927 10.6065C8.63818 11.1269 8.46325 11.6252 8.14058 12.0076C8.19484 12.1062 8.24561 12.2117 8.29289 12.3251C8.59378 13.0961 8.4912 13.8677 8.1413 14.5963C7.74878 15.4136 7.41022 15.9889 6.7313 16.7497C6.52804 16.9775 6.31412 17.1923 6.08941 17.3927C6.25199 17.5489 6.38901 17.7334 6.49251 17.9404C6.49542 17.9462 6.49827 17.9519 6.50106 17.9575C7.01006 17.9137 7.52238 17.93 8.08587 18.032C8.89536 18.1784 9.41032 18.4661 10.2803 19.0933L10.2958 19.1042C10.4079 19.184 10.4079 19.184 10.5093 19.2562C11.1281 19.6957 11.3863 19.802 11.9819 19.802C12.5908 19.802 12.892 19.6808 13.5054 19.2501C13.554 19.2159 13.6109 19.1756 13.7125 19.1036C14.5885 18.4722 15.1194 18.1765 15.9433 18.0281C16.4093 17.9491 16.9362 17.9154 17.5022 17.9538C17.517 17.9255 17.5331 17.8957 17.551 17.8635C17.6502 17.685 17.7747 17.525 17.9192 17.3873C17.7052 17.1946 17.4999 16.9885 17.3032 16.7705C16.8745 16.2954 16.5148 15.7932 16.2164 15.2892C16.0348 14.9826 15.9084 14.7317 15.8559 14.611C15.4931 13.8621 15.3867 13.0718 15.7191 12.29C15.7598 12.1923 15.8038 12.1005 15.8509 12.0139C15.5196 11.6223 15.3447 11.1099 15.3826 10.5792ZM5.06689 10.4776C5.48626 10.4776 5.66798 10.7826 6.28626 10.7826C6.44278 10.7826 6.54713 10.7478 6.61235 10.7174C6.60365 10.5609 6.51358 8.73083 6.51358 7.98803C6.51358 6.29966 7.23253 5.29775 8.05583 4.47391C8.87912 3.65008 10.1616 3 11.9819 3C13.8022 3 15.0481 3.65305 15.9341 4.47826C16.8201 5.30347 17.4853 6.4089 17.4853 8.00554C17.4853 9.56082 17.3863 10.6 17.3776 10.7217C17.4341 10.7522 17.5294 10.787 17.6558 10.787C18.2866 10.787 18.2866 10.4776 18.9863 10.4776C19.6715 10.4776 19.9689 11.0468 19.9689 11.3C19.9689 11.9213 19.1368 12.2675 18.6384 12.4261C18.2703 12.5433 17.708 12.7174 17.5645 13.0609C17.4906 13.2348 17.521 13.4609 17.6558 13.7391C17.6597 13.747 18.9167 16.6217 21.5863 17.0652C21.821 17.1 21.9776 17.3065 21.9776 17.5478C21.9776 17.8805 21.608 18.1652 21.2515 18.3304C20.808 18.5304 20.1602 18.7 19.2993 18.8348C19.2558 18.913 19.1648 19.3201 19.0645 19.7217C18.9292 20.2636 18.2633 20.0881 18.0732 20.0478C17.2413 19.8716 16.5341 19.9565 16.2776 20C15.795 20.087 15.3645 20.3783 14.8819 20.7261C14.1689 21.2304 13.4172 21.802 11.9819 21.802C10.5466 21.802 9.83843 21.2304 9.12539 20.7261C8.64278 20.3783 8.22066 20.0888 7.72974 20C6.83117 19.8374 6.15981 20.0357 5.93409 20.0565C5.70837 20.0773 5.09257 20.3009 4.93843 19.7304C4.89359 19.5645 4.74713 18.9217 4.70365 18.8348C3.84713 18.7 3.19496 18.5217 2.75148 18.3217C2.38626 18.1565 2.02539 17.8787 2.02539 17.5435C2.02539 17.3078 2.18336 17.1034 2.41669 17.0609C5.06017 16.5785 6.18185 14.0565 6.33843 13.7304C6.47054 13.4554 6.4993 13.2304 6.42974 13.0522C6.28626 12.7087 5.72539 12.5391 5.35583 12.4174C5.25148 12.3826 4.02067 12.0445 4.02067 11.3C4.02067 11.06 4.22508 10.7269 4.60241 10.5704C4.76382 10.5035 4.9609 10.4776 5.06689 10.4776Z"
  }));
},
    tE = function tE(_ref1885) {
  var _ref1885$color = _ref1885.color,
      C = _ref1885$color === void 0 ? "currentColor" : _ref1885$color,
      _ref1885$size = _ref1885.size,
      e = _ref1885$size === void 0 ? 24 : _ref1885$size,
      l = _ref1885.className,
      i = _objectWithoutProperties(_ref1885, _excluded1885);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.02679 17.4293C3.08078 16.2492 1 13.3676 1 10C1 5.58172 4.58172 2 9 2C12.3949 2 15.2959 4.11466 16.4576 7.09864C16.7951 7.0339 17.1436 7 17.5 7C20.5376 7 23 9.46243 23 12.5C23 15.369 20.8032 17.725 18 17.9776C17.9879 14.6742 15.3062 12 12 12C8.87879 12 6.31421 14.3833 6.02679 17.4293ZM13 16.268L14.9641 15.134L15.9641 16.866L14 18L15.9641 19.134L14.9641 20.866L13 19.732V22H11V19.732L9.0359 20.866L8.0359 19.134L10 18L8.0359 16.866L9.0359 15.134L11 16.268V14H13V16.268Z"
  }));
},
    CE = function CE(_ref1886) {
  var _ref1886$color = _ref1886.color,
      C = _ref1886$color === void 0 ? "currentColor" : _ref1886$color,
      _ref1886$size = _ref1886.size,
      e = _ref1886$size === void 0 ? 24 : _ref1886$size,
      l = _ref1886.className,
      i = _objectWithoutProperties(_ref1886, _excluded1886);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13 16.268L14.9641 15.134L15.9641 16.866L14 18L15.9641 19.134L14.9641 20.866L13 19.732V22H11V19.732L9.0359 20.866L8.0359 19.134L10 18L8.0359 16.866L9.0359 15.134L11 16.268V14H13V16.268ZM17 18V16H17.5C19.433 16 21 14.433 21 12.5C21 10.567 19.433 9 17.5 9C16.5205 9 15.6351 9.40232 14.9998 10.0507C14.9999 10.0338 15 10.0169 15 10C15 6.68629 12.3137 4 9 4C5.68629 4 3 6.68629 3 10C3 12.6124 4.66962 14.8349 7 15.6586V17.748C3.54955 16.8599 1 13.7277 1 10C1 5.58172 4.58172 2 9 2C12.3949 2 15.2959 4.11466 16.4576 7.09864C16.7951 7.0339 17.1436 7 17.5 7C20.5376 7 23 9.46243 23 12.5C23 15.5376 20.5376 18 17.5 18H17Z"
  }));
},
    lE = function lE(_ref1887) {
  var _ref1887$color = _ref1887.color,
      C = _ref1887$color === void 0 ? "currentColor" : _ref1887$color,
      _ref1887$size = _ref1887.size,
      e = _ref1887$size === void 0 ? 24 : _ref1887$size,
      l = _ref1887.className,
      i = _objectWithoutProperties(_ref1887, _excluded1887);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19 3L23 8H20V20H18V8H15L19 3ZM14 18V20H3V18H14ZM14 11V13H3V11H14ZM12 4V6H3V4H12Z"
  }));
},
    iE = function iE(_ref1888) {
  var _ref1888$color = _ref1888.color,
      C = _ref1888$color === void 0 ? "currentColor" : _ref1888$color,
      _ref1888$size = _ref1888.size,
      e = _ref1888$size === void 0 ? 24 : _ref1888$size,
      l = _ref1888.className,
      i = _objectWithoutProperties(_ref1888, _excluded1888);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 4V16H23L19 21L15 16H18V4H20ZM12 18V20H3V18H12ZM14 11V13H3V11H14ZM14 4V6H3V4H14Z"
  }));
},
    sE = function sE(_ref1889) {
  var _ref1889$color = _ref1889.color,
      C = _ref1889$color === void 0 ? "currentColor" : _ref1889$color,
      _ref1889$size = _ref1889.size,
      e = _ref1889$size === void 0 ? 24 : _ref1889$size,
      l = _ref1889.className,
      i = _objectWithoutProperties(_ref1889, _excluded1889);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 18V21H19V18H17V15H23V18H21ZM5 18V21H3V18H1V15H7V18H5ZM11 6V3H13V6H15V9H9V6H11ZM11 11H13V21H11V11ZM3 13V3H5V13H3ZM19 13V3H21V13H19Z"
  }));
},
    rE = function rE(_ref1890) {
  var _ref1890$color = _ref1890.color,
      C = _ref1890$color === void 0 ? "currentColor" : _ref1890$color,
      _ref1890$size = _ref1890.size,
      e = _ref1890$size === void 0 ? 24 : _ref1890$size,
      l = _ref1890.className,
      i = _objectWithoutProperties(_ref1890, _excluded1890);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 18V21H19V18H17V16H23V18H21ZM5 18V21H3V18H1V16H7V18H5ZM11 6V3H13V6H15V8H9V6H11ZM11 10H13V21H11V10ZM3 14V3H5V14H3ZM19 14V3H21V14H19Z"
  }));
},
    cE = function cE(_ref1891) {
  var _ref1891$color = _ref1891.color,
      C = _ref1891$color === void 0 ? "currentColor" : _ref1891$color,
      _ref1891$size = _ref1891.size,
      e = _ref1891$size === void 0 ? 24 : _ref1891$size,
      l = _ref1891.className,
      i = _objectWithoutProperties(_ref1891, _excluded1891);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10.464 8.59606C10.7291 8.59606 10.944 10.7021 10.944 13.3001L10.9427 13.6511C10.9244 16.0851 10.717 18.0041 10.464 18.0041C10.2079 18.0041 9.99871 16.0392 9.98474 13.564L9.98408 13.2117C9.98889 10.6545 10.2019 8.59606 10.464 8.59606ZM8.8 9.55606C9.05863 9.55606 9.26949 11.3561 9.27962 13.6102V13.9499C9.26949 16.204 9.05863 18.0041 8.8 18.0041C8.5446 18.0041 8.33579 16.2488 8.32086 14.0343L8.3201 13.6949L8.32241 13.3544C8.34666 11.2214 8.55123 9.55606 8.8 9.55606ZM7.136 9.55606C7.3914 9.55606 7.60021 11.3114 7.61515 13.5259L7.6159 13.8652L7.61359 14.2057C7.58934 16.3387 7.38477 18.0041 7.136 18.0041C6.87737 18.0041 6.66651 16.204 6.65638 13.9499V13.6102C6.66651 11.3561 6.87737 9.55606 7.136 9.55606ZM5.472 10.1321C5.7371 10.1321 5.952 11.8943 5.952 14.0681L5.95028 14.4033C5.92954 16.4202 5.72333 18.0041 5.472 18.0041C5.21035 18.0041 4.99759 16.2873 4.99211 14.1525V13.9836C4.99759 11.8488 5.21035 10.1321 5.472 10.1321ZM3.808 11.8601C4.0731 11.8601 4.288 13.2354 4.288 14.9321L4.28738 15.0901C4.27452 16.7133 4.06481 18.0041 3.808 18.0041C3.5429 18.0041 3.328 16.6287 3.328 14.9321L3.32862 14.774C3.34148 13.1508 3.55119 11.8601 3.808 11.8601ZM14.592 7.06006C17.1727 7.06006 19.3129 8.94578 19.71 11.4145C20.0053 11.3295 20.3173 11.2841 20.64 11.2841C22.4957 11.2841 24 12.7884 24 14.6441C24 16.4786 22.5297 17.9698 20.7031 18.0035L20.64 18.0041H12.48C12.0558 18.0041 11.712 17.6602 11.712 17.2361V7.93296C12.5358 7.3816 13.5263 7.06006 14.592 7.06006ZM2.144 11.6681C2.4091 11.6681 2.624 13.0005 2.624 14.6441L2.62336 14.7996C2.6103 16.3709 2.40068 17.6201 2.144 17.6201C1.88311 17.6201 1.67084 16.3296 1.66416 14.7221L1.664 14.6441C1.664 13.0005 1.8789 11.6681 2.144 11.6681ZM0.48 12.6281C0.745097 12.6281 0.96 13.5736 0.96 14.7401L0.959091 14.8711C0.943709 15.9765 0.735093 16.8521 0.48 16.8521C0.214903 16.8521 0 15.9065 0 14.7401L0.000909213 14.609C0.0162906 13.5036 0.224907 12.6281 0.48 12.6281Z"
  }));
},
    oE = function oE(_ref1892) {
  var _ref1892$color = _ref1892.color,
      C = _ref1892$color === void 0 ? "currentColor" : _ref1892$color,
      _ref1892$size = _ref1892.size,
      e = _ref1892$size === void 0 ? 24 : _ref1892$size,
      l = _ref1892.className,
      i = _objectWithoutProperties(_ref1892, _excluded1892);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 10C4.55228 10 5 10.4477 5 11V18C5 18.5523 4.55228 19 4 19C3.44772 19 3 18.5523 3 18V11C3 10.4477 3.44772 10 4 10ZM7 11C7.55228 11 8 11.4477 8 12V18C8 18.5523 7.55228 19 7 19C6.44772 19 6 18.5523 6 18V12C6 11.4477 6.44772 11 7 11ZM10 7C10.5523 7 11 7.44772 11 8V18C11 18.5523 10.5523 19 10 19C9.44771 19 9 18.5523 9 18V8C9 7.44772 9.44771 7 10 7ZM15 6C18.2384 6 20.8776 8.56557 20.9959 11.7751L20.999 12.0353C22.6956 12.2775 24 13.7364 24 15.5C24 17.3686 22.5357 18.8951 20.692 18.9948L20.5 19H16.999C16.4468 19 15.999 18.5523 15.999 18C15.9989 17.4872 16.3849 17.0645 16.8823 17.0067L16.999 17L20.4461 17.0007L20.584 16.9977C21.3751 16.955 22 16.2975 22 15.5C22 14.7984 21.5142 14.199 20.8512 14.0409L20.7164 14.0152L18.9467 13.7626L18.999 11.976L18.9951 11.8004C18.8943 9.75011 17.2499 8.10567 15.1996 8.0049L15 8C14.7321 8 14.4687 8.02612 14.2123 8.07715L13.999 8.126L13.999 18.0005C13.999 18.5131 13.6132 18.9355 13.1161 18.9933L12.9995 19C12.4475 19 12 18.5525 11.9999 18.0005L11.999 6.80325C12.8818 6.2924 13.9067 6 15 6ZM1 12C1.55228 12 2 12.4477 2 13V17C2 17.5523 1.55228 18 1 18C0.447715 18 0 17.5523 0 17V13C0 12.4477 0.447715 12 1 12Z"
  }));
},
    aE = function aE(_ref1893) {
  var _ref1893$color = _ref1893.color,
      C = _ref1893$color === void 0 ? "currentColor" : _ref1893$color,
      _ref1893$size = _ref1893.size,
      e = _ref1893$size === void 0 ? 24 : _ref1893$size,
      l = _ref1893.className,
      i = _objectWithoutProperties(_ref1893, _excluded1893);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2.87988 18.049C4.23015 12.0557 7.07526 6.6285 11.003 2.17958C11.1105 2.05778 11.2465 1.90742 11.411 1.72851L11.411 1.72849C11.7101 1.40325 12.2162 1.38203 12.5414 1.68109C12.5579 1.69623 12.5737 1.71205 12.5888 1.72851C12.7553 1.90958 12.8929 2.06164 13.0015 2.1847C16.9268 6.63267 19.7703 12.058 21.12 18.049C18.9786 18.5004 16.7797 18.796 14.5359 18.9235L12.4472 23.101C12.3237 23.348 12.0233 23.4481 11.7763 23.3246C11.6796 23.2762 11.6011 23.1977 11.5527 23.101L9.46401 18.9235C7.22018 18.796 5.02133 18.5004 2.87988 18.049ZM11.9999 14.9954C13.6568 14.9954 14.9999 13.6523 14.9999 11.9954C14.9999 10.3386 13.6568 8.99541 11.9999 8.99541C10.3431 8.99541 8.99994 10.3386 8.99994 11.9954C8.99994 13.6523 10.3431 14.9954 11.9999 14.9954Z"
  }));
},
    nE = function nE(_ref1894) {
  var _ref1894$color = _ref1894.color,
      C = _ref1894$color === void 0 ? "currentColor" : _ref1894$color,
      _ref1894$size = _ref1894.size,
      e = _ref1894$size === void 0 ? 24 : _ref1894$size,
      l = _ref1894.className,
      i = _objectWithoutProperties(_ref1894, _excluded1894);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2.87988 18.0491C4.23015 12.0558 7.07526 6.62853 11.003 2.17961C11.1105 2.05781 11.2465 1.90745 11.411 1.72854C11.7101 1.40328 12.2162 1.38206 12.5414 1.68112C12.5579 1.69626 12.5737 1.71207 12.5888 1.72854C12.7553 1.9096 12.8929 2.06167 13.0015 2.18473C16.9268 6.6327 19.7703 12.0581 21.12 18.0491C18.9786 18.5004 16.7797 18.7961 14.5359 18.9236L12.4472 23.101C12.3237 23.348 12.0233 23.4481 11.7763 23.3246C11.6796 23.2762 11.6011 23.1978 11.5527 23.101L9.46401 18.9236C7.22018 18.7961 5.02133 18.5004 2.87988 18.0491ZM9.57748 16.9268L10.7346 16.9925L11.9999 19.5233L13.2653 16.9925L14.4224 16.9268C15.8443 16.846 17.2543 16.6941 18.6488 16.4724C17.3229 11.9192 15.0539 7.70522 11.9999 4.08528C8.94595 7.7052 6.67696 11.9192 5.35112 16.4724C6.74562 16.6941 8.15563 16.846 9.57748 16.9268ZM11.9999 14.9954C10.3431 14.9954 8.99994 13.6523 8.99994 11.9954C8.99994 10.3386 10.3431 8.99544 11.9999 8.99544C13.6568 8.99544 14.9999 10.3386 14.9999 11.9954C14.9999 13.6523 13.6568 14.9954 11.9999 14.9954ZM11.9999 12.9954C12.5522 12.9954 12.9999 12.5477 12.9999 11.9954C12.9999 11.4432 12.5522 10.9954 11.9999 10.9954C11.4477 10.9954 10.9999 11.4432 10.9999 11.9954C10.9999 12.5477 11.4477 12.9954 11.9999 12.9954Z"
  }));
},
    mE = function mE(_ref1895) {
  var _ref1895$color = _ref1895.color,
      C = _ref1895$color === void 0 ? "currentColor" : _ref1895$color,
      _ref1895$size = _ref1895.size,
      e = _ref1895$size === void 0 ? 24 : _ref1895$size,
      l = _ref1895.className,
      i = _objectWithoutProperties(_ref1895, _excluded1895);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 9V13H20V9H22V14C22 14.5523 21.5523 15 21 15H3C2.44772 15 2 14.5523 2 14V9H4Z"
  }));
},
    wE = function wE(_ref1896) {
  var _ref1896$color = _ref1896.color,
      C = _ref1896$color === void 0 ? "currentColor" : _ref1896$color,
      _ref1896$size = _ref1896.size,
      e = _ref1896$size === void 0 ? 24 : _ref1896$size,
      l = _ref1896.className,
      i = _objectWithoutProperties(_ref1896, _excluded1896);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15.936 2.50098L21.501 8.06595V15.936L15.936 21.501H8.06595L2.50098 15.936V8.06595L8.06595 2.50098H15.936ZM11.0002 15.0002V17.0002H13.0002V15.0002H11.0002ZM11.0002 7.00024V13.0002H13.0002V7.00024H11.0002Z"
  }));
},
    LE = function LE(_ref1897) {
  var _ref1897$color = _ref1897.color,
      C = _ref1897$color === void 0 ? "currentColor" : _ref1897$color,
      _ref1897$size = _ref1897.size,
      e = _ref1897$size === void 0 ? 24 : _ref1897$size,
      l = _ref1897.className,
      i = _objectWithoutProperties(_ref1897, _excluded1897);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15.936 2.50098L21.501 8.06595V15.936L15.936 21.501H8.06595L2.50098 15.936V8.06595L8.06595 2.50098H15.936ZM15.1076 4.50098H8.89437L4.50098 8.89437V15.1076L8.89437 19.501H15.1076L19.501 15.1076V8.89437L15.1076 4.50098ZM11.0002 15.0002H13.0002V17.0002H11.0002V15.0002ZM11.0002 7.00024H13.0002V13.0002H11.0002V7.00024Z"
  }));
},
    hE = function hE(_ref1898) {
  var _ref1898$color = _ref1898.color,
      C = _ref1898$color === void 0 ? "currentColor" : _ref1898$color,
      _ref1898$size = _ref1898.size,
      e = _ref1898$size === void 0 ? 24 : _ref1898$size,
      l = _ref1898.className,
      i = _objectWithoutProperties(_ref1898, _excluded1898);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15.936 2.50098L21.501 8.06595V15.936L15.936 21.501H8.06595L2.50098 15.936V8.06595L8.06595 2.50098H15.936ZM8.00024 11.0002V13.0002H16.0002V11.0002H8.00024Z"
  }));
},
    HE = function HE(_ref1899) {
  var _ref1899$color = _ref1899.color,
      C = _ref1899$color === void 0 ? "currentColor" : _ref1899$color,
      _ref1899$size = _ref1899.size,
      e = _ref1899$size === void 0 ? 24 : _ref1899$size,
      l = _ref1899.className,
      i = _objectWithoutProperties(_ref1899, _excluded1899);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15.936 2.50098L21.501 8.06595V15.936L15.936 21.501H8.06595L2.50098 15.936V8.06595L8.06595 2.50098H15.936ZM15.1076 4.50098H8.89437L4.50098 8.89437V15.1076L8.89437 19.501H15.1076L19.501 15.1076V8.89437L15.1076 4.50098ZM8.00024 11.0002H16.0002V13.0002H8.00024V11.0002Z"
  }));
},
    VE = function VE(_ref1900) {
  var _ref1900$color = _ref1900.color,
      C = _ref1900$color === void 0 ? "currentColor" : _ref1900$color,
      _ref1900$size = _ref1900.size,
      e = _ref1900$size === void 0 ? 24 : _ref1900$size,
      l = _ref1900.className,
      i = _objectWithoutProperties(_ref1900, _excluded1900);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17.5 2.5L23 12L17.5 21.5H6.5L1 12L6.5 2.5H17.5ZM11 15V17H13V15H11ZM11 7V13H13V7H11Z"
  }));
},
    gE = function gE(_ref1901) {
  var _ref1901$color = _ref1901.color,
      C = _ref1901$color === void 0 ? "currentColor" : _ref1901$color,
      _ref1901$size = _ref1901.size,
      e = _ref1901$size === void 0 ? 24 : _ref1901$size,
      l = _ref1901.className,
      i = _objectWithoutProperties(_ref1901, _excluded1901);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17.5 2.5L23 12L17.5 21.5H6.5L1 12L6.5 2.5H17.5ZM16.3469 4.5H7.65311L3.311 12L7.65311 19.5H16.3469L20.689 12L16.3469 4.5ZM11 15H13V17H11V15ZM11 7H13V13H11V7Z"
  }));
},
    ME = function ME(_ref1902) {
  var _ref1902$color = _ref1902.color,
      C = _ref1902$color === void 0 ? "currentColor" : _ref1902$color,
      _ref1902$size = _ref1902.size,
      e = _ref1902$size === void 0 ? 24 : _ref1902$size,
      l = _ref1902.className,
      i = _objectWithoutProperties(_ref1902, _excluded1902);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM12 17C9.23858 17 7 14.7614 7 12C7 9.23858 9.23858 7 12 7C14.7614 7 17 9.23858 17 12C17 14.7614 14.7614 17 12 17ZM12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19ZM12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z"
  }));
},
    ZE = function ZE(_ref1903) {
  var _ref1903$color = _ref1903.color,
      C = _ref1903$color === void 0 ? "currentColor" : _ref1903$color,
      _ref1903$size = _ref1903.size,
      e = _ref1903$size === void 0 ? 24 : _ref1903$size,
      l = _ref1903.className,
      i = _objectWithoutProperties(_ref1903, _excluded1903);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5 5V19H19V5H5ZM4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16ZM12 18C8.68629 18 6 15.3137 6 12C6 8.68629 8.68629 6 12 6C15.3137 6 18 8.68629 18 12C18 15.3137 15.3137 18 12 18ZM12 13.5C11.1716 13.5 10.5 12.8284 10.5 12C10.5 11.1716 11.1716 10.5 12 10.5C12.8284 10.5 13.5 11.1716 13.5 12C13.5 12.8284 12.8284 13.5 12 13.5Z"
  }));
},
    xE = function xE(_ref1904) {
  var _ref1904$color = _ref1904.color,
      C = _ref1904$color === void 0 ? "currentColor" : _ref1904$color,
      _ref1904$size = _ref1904.size,
      e = _ref1904$size === void 0 ? 24 : _ref1904$size,
      l = _ref1904.className,
      i = _objectWithoutProperties(_ref1904, _excluded1904);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12C16 14.2091 14.2091 16 12 16ZM12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18ZM6 7C6.55228 7 7 6.55228 7 6C7 5.44772 6.55228 5 6 5C5.44772 5 5 5.44772 5 6C5 6.55228 5.44772 7 6 7ZM18 7C18.5523 7 19 6.55228 19 6C19 5.44772 18.5523 5 18 5C17.4477 5 17 5.44772 17 6C17 6.55228 17.4477 7 18 7ZM18 19C18.5523 19 19 18.5523 19 18C19 17.4477 18.5523 17 18 17C17.4477 17 17 17.4477 17 18C17 18.5523 17.4477 19 18 19ZM6 19C6.55228 19 7 18.5523 7 18C7 17.4477 6.55228 17 6 17C5.44772 17 5 17.4477 5 18C5 18.5523 5.44772 19 6 19ZM12 13.5C12.8284 13.5 13.5 12.8284 13.5 12C13.5 11.1716 12.8284 10.5 12 10.5C11.1716 10.5 10.5 11.1716 10.5 12C10.5 12.8284 11.1716 13.5 12 13.5Z"
  }));
},
    vE = function vE(_ref1905) {
  var _ref1905$color = _ref1905.color,
      C = _ref1905$color === void 0 ? "currentColor" : _ref1905$color,
      _ref1905$size = _ref1905.size,
      e = _ref1905$size === void 0 ? 24 : _ref1905$size,
      l = _ref1905.className,
      i = _objectWithoutProperties(_ref1905, _excluded1905);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5 5V19H19V5H5ZM4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM7 8C6.44772 8 6 7.55228 6 7C6 6.44772 6.44772 6 7 6C7.55228 6 8 6.44772 8 7C8 7.55228 7.55228 8 7 8ZM17 8C16.4477 8 16 7.55228 16 7C16 6.44772 16.4477 6 17 6C17.5523 6 18 6.44772 18 7C18 7.55228 17.5523 8 17 8ZM17 18C16.4477 18 16 17.5523 16 17C16 16.4477 16.4477 16 17 16C17.5523 16 18 16.4477 18 17C18 17.5523 17.5523 18 17 18ZM7 18C6.44772 18 6 17.5523 6 17C6 16.4477 6.44772 16 7 16C7.55228 16 8 16.4477 8 17C8 17.5523 7.55228 18 7 18ZM12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15ZM12 17C9.23858 17 7 14.7614 7 12C7 9.23858 9.23858 7 12 7C14.7614 7 17 9.23858 17 12C17 14.7614 14.7614 17 12 17ZM12 13C11.4477 13 11 12.5523 11 12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12C13 12.5523 12.5523 13 12 13Z"
  }));
},
    dE = function dE(_ref1906) {
  var _ref1906$color = _ref1906.color,
      C = _ref1906$color === void 0 ? "currentColor" : _ref1906$color,
      _ref1906$size = _ref1906.size,
      e = _ref1906$size === void 0 ? 24 : _ref1906$size,
      l = _ref1906.className,
      i = _objectWithoutProperties(_ref1906, _excluded1906);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 2H20C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V3C3 2.44772 3.44772 2 4 2ZM12 20C14.7614 20 17 17.7614 17 15C17 12.2386 14.7614 10 12 10C9.23858 10 7 12.2386 7 15C7 17.7614 9.23858 20 12 20ZM12 8C12.8284 8 13.5 7.32843 13.5 6.5C13.5 5.67157 12.8284 5 12 5C11.1716 5 10.5 5.67157 10.5 6.5C10.5 7.32843 11.1716 8 12 8ZM12 18C10.3431 18 9 16.6569 9 15C9 13.3431 10.3431 12 12 12C13.6569 12 15 13.3431 15 15C15 16.6569 13.6569 18 12 18Z"
  }));
},
    pE = function pE(_ref1907) {
  var _ref1907$color = _ref1907.color,
      C = _ref1907$color === void 0 ? "currentColor" : _ref1907$color,
      _ref1907$size = _ref1907.size,
      e = _ref1907$size === void 0 ? 24 : _ref1907$size,
      l = _ref1907.className,
      i = _objectWithoutProperties(_ref1907, _excluded1907);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5 4V20H19V4H5ZM4 2H20C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V3C3 2.44772 3.44772 2 4 2ZM12 17C13.3807 17 14.5 15.8807 14.5 14.5C14.5 13.1193 13.3807 12 12 12C10.6193 12 9.5 13.1193 9.5 14.5C9.5 15.8807 10.6193 17 12 17ZM12 19C9.51472 19 7.5 16.9853 7.5 14.5C7.5 12.0147 9.51472 10 12 10C14.4853 10 16.5 12.0147 16.5 14.5C16.5 16.9853 14.4853 19 12 19ZM12 8.5C11.1716 8.5 10.5 7.82843 10.5 7C10.5 6.17157 11.1716 5.5 12 5.5C12.8284 5.5 13.5 6.17157 13.5 7C13.5 7.82843 12.8284 8.5 12 8.5Z"
  }));
},
    EE = function EE(_ref1908) {
  var _ref1908$color = _ref1908.color,
      C = _ref1908$color === void 0 ? "currentColor" : _ref1908$color,
      _ref1908$size = _ref1908.size,
      e = _ref1908$size === void 0 ? 24 : _ref1908$size,
      l = _ref1908.className,
      i = _objectWithoutProperties(_ref1908, _excluded1908);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13.1997 2.00596C21.2413 2.09306 22.0006 3.25009 22.0006 12.0001L21.9948 13.1991C21.9077 21.2408 20.7506 22.0001 12.0006 22.0001L10.8016 21.9942C3.14288 21.9113 2.08947 20.8579 2.00651 13.1991L2.00098 11.6908L2.00651 10.801C2.09154 2.95085 3.19615 2.04037 11.3885 2.00146L13.1997 2.00596ZM8.25064 7.00009H7.66731C7.33265 7.00009 7.0555 7.24681 7.00787 7.56825L7.00064 7.66675V11.3334C7.00064 11.6683 7.24737 11.9453 7.56881 11.9929L7.66731 12.0001H8.25064C10.2549 12.0001 11.8919 13.5725 11.9954 15.5509L12.0006 15.7501V16.3334C12.0006 16.6683 12.2474 16.9453 12.5688 16.9929L12.6673 17.0001H16.334C16.6686 17.0001 16.9458 16.7535 16.9934 16.432L17.0006 16.3334V15.7501C17.0006 11.0039 13.2218 7.14029 8.50863 7.00382L8.25064 7.00009Z"
  }));
},
    NE = function NE(_ref1909) {
  var _ref1909$color = _ref1909.color,
      C = _ref1909$color === void 0 ? "currentColor" : _ref1909$color,
      _ref1909$size = _ref1909.size,
      e = _ref1909$size === void 0 ? 24 : _ref1909$size,
      l = _ref1909.className,
      i = _objectWithoutProperties(_ref1909, _excluded1909);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11.3885 2.00146L13.1997 2.00596L14.0434 2.0199C21.2046 2.18454 21.982 3.53205 22.0003 11.6871L21.9948 13.1991L21.9808 14.0429C21.8162 21.204 20.4687 21.9814 12.3136 21.9997L10.8016 21.9942L9.91389 21.9792C3.06016 21.8164 2.08615 20.5515 2.00651 13.1991L2.00098 11.6908L2.00651 10.801L2.02094 9.9364C2.18566 2.88296 3.50725 2.03889 11.3885 2.00146ZM14.1204 4.00883L10.8829 4.00079L9.561 4.01053C4.07209 4.09335 4.01663 4.83194 4.0016 11.414L4.00259 13.5888L4.0132 14.6296C4.10138 19.6115 4.80564 19.9723 10.4119 19.9981L13.8667 19.9965L14.6429 19.9873C19.7508 19.8957 19.9894 19.1505 20.0002 13.1103L19.998 10.3675L19.9859 9.31193C19.892 4.51568 19.201 4.06256 14.1204 4.00883ZM8.25064 7.00009C13.0831 7.00009 17.0006 10.9176 17.0006 15.7501V16.3334C17.0006 16.7018 16.7021 17.0001 16.334 17.0001H12.6673C12.2992 17.0001 12.0006 16.7018 12.0006 16.3334V15.7501C12.0006 13.679 10.3217 12.0001 8.25064 12.0001H7.66731C7.29918 12.0001 7.00064 11.7018 7.00064 11.3334V7.66675C7.00064 7.29863 7.29918 7.00009 7.66731 7.00009H8.25064Z"
  }));
},
    uE = function uE(_ref1910) {
  var _ref1910$color = _ref1910.color,
      C = _ref1910$color === void 0 ? "currentColor" : _ref1910$color,
      _ref1910$size = _ref1910.size,
      e = _ref1910$size === void 0 ? 24 : _ref1910$size,
      l = _ref1910.className,
      i = _objectWithoutProperties(_ref1910, _excluded1910);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 13.3334L2.77735 19.4818C2.54759 19.635 2.23715 19.5729 2.08397 19.3432C2.02922 19.261 2 19.1645 2 19.0658V4.93433C2 4.65818 2.22386 4.43433 2.5 4.43433C2.59871 4.43433 2.69522 4.46355 2.77735 4.5183L12 10.6667V4.93433C12 4.65818 12.2239 4.43433 12.5 4.43433C12.5987 4.43433 12.6952 4.46355 12.7774 4.5183L23.376 11.584C23.6057 11.7372 23.6678 12.0477 23.5146 12.2774C23.478 12.3323 23.4309 12.3795 23.376 12.4161L12.7774 19.4818C12.5476 19.635 12.2372 19.5729 12.084 19.3432C12.0292 19.261 12 19.1645 12 19.0658V13.3334Z"
  }));
},
    BE = function BE(_ref1911) {
  var _ref1911$color = _ref1911.color,
      C = _ref1911$color === void 0 ? "currentColor" : _ref1911$color,
      _ref1911$size = _ref1911.size,
      e = _ref1911$size === void 0 ? 24 : _ref1911$size,
      l = _ref1911.className,
      i = _objectWithoutProperties(_ref1911, _excluded1911);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 13.3334L2.77735 19.4818C2.54759 19.635 2.23715 19.5729 2.08397 19.3432C2.02922 19.261 2 19.1645 2 19.0658V4.93433C2 4.65818 2.22386 4.43433 2.5 4.43433C2.59871 4.43433 2.69522 4.46355 2.77735 4.5183L12 10.6667V4.93433C12 4.65818 12.2239 4.43433 12.5 4.43433C12.5987 4.43433 12.6952 4.46355 12.7774 4.5183L23.376 11.584C23.6057 11.7372 23.6678 12.0477 23.5146 12.2774C23.478 12.3323 23.4309 12.3795 23.376 12.4161L12.7774 19.4818C12.5476 19.635 12.2372 19.5729 12.084 19.3432C12.0292 19.261 12 19.1645 12 19.0658V13.3334ZM10.3944 12.0001L4 7.7371V16.263L10.3944 12.0001ZM14 7.7371V16.263L20.3944 12.0001L14 7.7371Z"
  }));
},
    fE = function fE(_ref1912) {
  var _ref1912$color = _ref1912.color,
      C = _ref1912$color === void 0 ? "currentColor" : _ref1912$color,
      _ref1912$size = _ref1912.size,
      e = _ref1912$size === void 0 ? 24 : _ref1912$size,
      l = _ref1912.className,
      i = _objectWithoutProperties(_ref1912, _excluded1912);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4.78834 17.4434C4.70398 17.503 4.60326 17.535 4.5 17.535C4.22386 17.535 4 17.3111 4 17.035V6.96488C4 6.86163 4.03197 6.7609 4.09152 6.67654C4.25076 6.45094 4.56274 6.39715 4.78834 6.5564L11.9213 11.5914C11.9679 11.6243 12.0086 11.665 12.0415 11.7116C12.2007 11.9372 12.1469 12.2492 11.9213 12.4084L4.78834 17.4434ZM13 6.96488C13 6.86163 13.032 6.7609 13.0915 6.67654C13.2508 6.45094 13.5627 6.39715 13.7883 6.5564L20.9213 11.5914C20.9679 11.6243 21.0086 11.665 21.0415 11.7116C21.2007 11.9372 21.1469 12.2492 20.9213 12.4084L13.7883 17.4434C13.704 17.503 13.6033 17.535 13.5 17.535C13.2239 17.535 13 17.3111 13 17.035V6.96488Z"
  }));
},
    RE = function RE(_ref1913) {
  var _ref1913$color = _ref1913.color,
      C = _ref1913$color === void 0 ? "currentColor" : _ref1913$color,
      _ref1913$size = _ref1913.size,
      e = _ref1913$size === void 0 ? 24 : _ref1913$size,
      l = _ref1913.className,
      i = _objectWithoutProperties(_ref1913, _excluded1913);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9.03189 11.9999L6 9.85977V14.1401L9.03189 11.9999ZM4.78834 17.4434C4.70398 17.503 4.60326 17.535 4.5 17.535C4.22386 17.535 4 17.3111 4 17.035V6.96488C4 6.86163 4.03197 6.7609 4.09152 6.67654C4.25076 6.45094 4.56274 6.39715 4.78834 6.5564L11.9213 11.5914C11.9679 11.6243 12.0086 11.665 12.0415 11.7116C12.2007 11.9372 12.1469 12.2492 11.9213 12.4084L4.78834 17.4434ZM15 14.1401L18.0319 11.9999L15 9.85977V14.1401ZM13 6.96488C13 6.86163 13.032 6.7609 13.0915 6.67654C13.2508 6.45094 13.5627 6.39715 13.7883 6.5564L20.9213 11.5914C20.9679 11.6243 21.0086 11.665 21.0415 11.7116C21.2007 11.9372 21.1469 12.2492 20.9213 12.4084L13.7883 17.4434C13.704 17.503 13.6033 17.535 13.5 17.535C13.2239 17.535 13 17.3111 13 17.035V6.96488Z"
  }));
},
    zE = function zE(_ref1914) {
  var _ref1914$color = _ref1914.color,
      C = _ref1914$color === void 0 ? "currentColor" : _ref1914$color,
      _ref1914$size = _ref1914.size,
      e = _ref1914$size === void 0 ? 24 : _ref1914$size,
      l = _ref1914.className,
      i = _objectWithoutProperties(_ref1914, _excluded1914);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 3C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3H20ZM11 5H5V19H11V15H13V19H19V5H13V9H11V5ZM15 9L18 12L15 15V13H9V15L6 12L9 9V11H15V9Z"
  }));
},
    FE = function FE(_ref1915) {
  var _ref1915$color = _ref1915.color,
      C = _ref1915$color === void 0 ? "currentColor" : _ref1915$color,
      _ref1915$size = _ref1915.size,
      e = _ref1915$size === void 0 ? 24 : _ref1915$size,
      l = _ref1915.className,
      i = _objectWithoutProperties(_ref1915, _excluded1915);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 3C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3H20ZM19 5H5V10.999L9 11V13H5V19H19V13H15V11L19 10.999V5ZM12 6L15 9H13V15H15L12 18L9 15H11V9H9L12 6Z"
  }));
},
    SE = function SE(_ref1916) {
  var _ref1916$color = _ref1916.color,
      C = _ref1916$color === void 0 ? "currentColor" : _ref1916$color,
      _ref1916$size = _ref1916.size,
      e = _ref1916$size === void 0 ? 24 : _ref1916$size,
      l = _ref1916.className,
      i = _objectWithoutProperties(_ref1916, _excluded1916);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.001 2C6.50098 2 2.00098 6.5 2.00098 12C2.00098 17.5 6.50098 22 12.001 22C17.501 22 22.001 17.5 22.001 12C22.001 6.5 17.551 2 12.001 2ZM15.751 16.65C13.401 15.2 10.451 14.8992 6.95014 15.6992C6.60181 15.8008 6.30098 15.55 6.20098 15.25C6.10098 14.8992 6.35098 14.6 6.65098 14.5C10.451 13.6492 13.751 14 16.351 15.6C16.701 15.75 16.7501 16.1492 16.6018 16.45C16.4018 16.7492 16.0518 16.85 15.751 16.65ZM16.7501 13.95C14.051 12.3 9.95098 11.8 6.80098 12.8C6.40181 12.9 5.95098 12.7 5.85098 12.3C5.75098 11.9 5.95098 11.4492 6.35098 11.3492C10.001 10.25 14.501 10.8008 17.601 12.7C17.9018 12.8508 18.051 13.35 17.8018 13.7C17.551 14.05 17.101 14.2 16.7501 13.95ZM6.30098 9.75083C5.80098 9.9 5.30098 9.6 5.15098 9.15C5.00098 8.64917 5.30098 8.15 5.75098 7.99917C9.30098 6.94917 15.151 7.14917 18.8518 9.35C19.301 9.6 19.451 10.2 19.201 10.65C18.9518 11.0008 18.351 11.1492 17.9018 10.9C14.701 9 9.35098 8.8 6.30098 9.75083Z"
  }));
},
    AE = function AE(_ref1917) {
  var _ref1917$color = _ref1917.color,
      C = _ref1917$color === void 0 ? "currentColor" : _ref1917$color,
      _ref1917$size = _ref1917.size,
      e = _ref1917$size === void 0 ? 24 : _ref1917$size,
      l = _ref1917.className,
      i = _objectWithoutProperties(_ref1917, _excluded1917);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.001 2C17.551 2 22.001 6.5 22.001 12C22.001 17.5 17.501 22 12.001 22C6.50098 22 2.00098 17.5 2.00098 12C2.00098 6.5 6.50098 2 12.001 2ZM12.001 4C7.60555 4 4.00098 7.60457 4.00098 12C4.00098 16.3954 7.60555 20 12.001 20C16.3964 20 20.001 16.3954 20.001 12C20.001 7.58572 16.4276 4 12.001 4ZM15.751 16.65C13.401 15.2 10.451 14.8992 6.95014 15.6992C6.60181 15.8008 6.30098 15.55 6.20098 15.25C6.10098 14.8992 6.35098 14.6 6.65098 14.5C10.451 13.6492 13.751 14 16.351 15.6C16.701 15.75 16.7501 16.1492 16.6018 16.45C16.4018 16.7492 16.0518 16.85 15.751 16.65ZM16.7501 13.95C14.051 12.3 9.95098 11.8 6.80098 12.8C6.40181 12.9 5.95098 12.7 5.85098 12.3C5.75098 11.9 5.95098 11.4492 6.35098 11.3492C10.001 10.25 14.501 10.8008 17.601 12.7C17.9018 12.8508 18.051 13.35 17.8018 13.7C17.551 14.05 17.101 14.2 16.7501 13.95ZM6.30098 9.75083C5.80098 9.9 5.30098 9.6 5.15098 9.15C5.00098 8.64917 5.30098 8.15 5.75098 7.99917C9.30098 6.94917 15.151 7.14917 18.8518 9.35C19.301 9.6 19.451 10.2 19.201 10.65C18.9518 11.0008 18.351 11.1492 17.9018 10.9C14.701 9 9.35098 8.8 6.30098 9.75083Z"
  }));
},
    kE = function kE(_ref1918) {
  var _ref1918$color = _ref1918.color,
      C = _ref1918$color === void 0 ? "currentColor" : _ref1918$color,
      _ref1918$size = _ref1918.size,
      e = _ref1918$size === void 0 ? 24 : _ref1918$size,
      l = _ref1918.className,
      i = _objectWithoutProperties(_ref1918, _excluded1918);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17 13C19.2091 13 21 14.7909 21 17C21 19.2091 19.2091 21 17 21C14.8578 21 13 19.21 13 17H11C11 19.2091 9.20914 21 7 21C4.79086 21 3 19.2091 3 17C3 14.7909 4.79086 13 7 13C8.48052 13 9.77317 13.8043 10.4648 14.9999H13.5352C14.2268 13.8043 15.5195 13 17 13ZM2 12V10H4V7C4 4.79086 5.79086 3 8 3H16C18.2091 3 20 4.79086 20 7V10H22V12H2Z"
  }));
},
    PE = function PE(_ref1919) {
  var _ref1919$color = _ref1919.color,
      C = _ref1919$color === void 0 ? "currentColor" : _ref1919$color,
      _ref1919$size = _ref1919.size,
      e = _ref1919$size === void 0 ? 24 : _ref1919$size,
      l = _ref1919.className,
      i = _objectWithoutProperties(_ref1919, _excluded1919);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17 13C19.2091 13 21 14.7909 21 17C21 19.2091 19.2091 21 17 21C14.7909 21 13 19.2091 13 17H11C11 19.2091 9.20914 21 7 21C4.79086 21 3 19.2091 3 17C3 14.7909 4.79086 13 7 13C8.48052 13 9.77317 13.8043 10.4648 14.9999H13.5352C14.2268 13.8043 15.5195 13 17 13ZM7 15C5.89543 15 5 15.8954 5 17C5 18.1046 5.89543 19 7 19C8.10457 19 9 18.1046 9 17C9 15.8954 8.10457 15 7 15ZM17 15C15.8954 15 15 15.8954 15 17C15 18.1046 15.8954 19 17 19C18.1046 19 19 18.1046 19 17C19 15.8954 18.1046 15 17 15ZM16 3C18.2091 3 20 4.79086 20 7V10H22V12H2V10H4V7C4 4.79086 5.79086 3 8 3H16ZM16 5H8C6.94564 5 6 5.95 6 7V10H18V7C18 5.94564 17.05 5 16 5Z"
  }));
},
    DE = function DE(_ref1920) {
  var _ref1920$color = _ref1920.color,
      C = _ref1920$color === void 0 ? "currentColor" : _ref1920$color,
      _ref1920$size = _ref1920.size,
      e = _ref1920$size === void 0 ? 24 : _ref1920$size,
      l = _ref1920.className,
      i = _objectWithoutProperties(_ref1920, _excluded1920);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.0833 10.4999L21.2854 11.2212C21.5221 11.3633 21.5989 11.6704 21.4569 11.9072C21.4146 11.9776 21.3557 12.0365 21.2854 12.0787L11.9999 17.6499L2.71451 12.0787C2.47772 11.9366 2.40093 11.6295 2.54301 11.3927C2.58523 11.3223 2.64413 11.2634 2.71451 11.2212L3.9166 10.4999L11.9999 15.3499L20.0833 10.4999ZM20.0833 15.1999L21.2854 15.9212C21.5221 16.0633 21.5989 16.3704 21.4569 16.6072C21.4146 16.6776 21.3557 16.7365 21.2854 16.7787L12.5144 22.0412C12.1977 22.2313 11.8021 22.2313 11.4854 22.0412L2.71451 16.7787C2.47772 16.6366 2.40093 16.3295 2.54301 16.0927C2.58523 16.0223 2.64413 15.9634 2.71451 15.9212L3.9166 15.1999L11.9999 20.0499L20.0833 15.1999ZM12.5144 1.30864L21.2854 6.5712C21.5221 6.71327 21.5989 7.0204 21.4569 7.25719C21.4146 7.32757 21.3557 7.38647 21.2854 7.42869L11.9999 12.9999L2.71451 7.42869C2.47772 7.28662 2.40093 6.97949 2.54301 6.7427C2.58523 6.67232 2.64413 6.61343 2.71451 6.5712L11.4854 1.30864C11.8021 1.11864 12.1977 1.11864 12.5144 1.30864Z"
  }));
},
    yE = function yE(_ref1921) {
  var _ref1921$color = _ref1921.color,
      C = _ref1921$color === void 0 ? "currentColor" : _ref1921$color,
      _ref1921$size = _ref1921.size,
      e = _ref1921$size === void 0 ? 24 : _ref1921$size,
      l = _ref1921.className,
      i = _objectWithoutProperties(_ref1921, _excluded1921);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.0833 15.1999L21.2854 15.9212C21.5221 16.0633 21.5989 16.3704 21.4569 16.6072C21.4146 16.6776 21.3557 16.7365 21.2854 16.7787L12.5144 22.0412C12.1977 22.2313 11.8021 22.2313 11.4854 22.0412L2.71451 16.7787C2.47772 16.6366 2.40093 16.3295 2.54301 16.0927C2.58523 16.0223 2.64413 15.9634 2.71451 15.9212L3.9166 15.1999L11.9999 20.0499L20.0833 15.1999ZM20.0833 10.4999L21.2854 11.2212C21.5221 11.3633 21.5989 11.6704 21.4569 11.9072C21.4146 11.9776 21.3557 12.0365 21.2854 12.0787L11.9999 17.6499L2.71451 12.0787C2.47772 11.9366 2.40093 11.6295 2.54301 11.3927C2.58523 11.3223 2.64413 11.2634 2.71451 11.2212L3.9166 10.4999L11.9999 15.3499L20.0833 10.4999ZM12.5144 1.30864L21.2854 6.5712C21.5221 6.71327 21.5989 7.0204 21.4569 7.25719C21.4146 7.32757 21.3557 7.38647 21.2854 7.42869L11.9999 12.9999L2.71451 7.42869C2.47772 7.28662 2.40093 6.97949 2.54301 6.7427C2.58523 6.67232 2.64413 6.61343 2.71451 6.5712L11.4854 1.30864C11.8021 1.11864 12.1977 1.11864 12.5144 1.30864ZM11.9999 3.33233L5.88723 6.99995L11.9999 10.6676L18.1126 6.99995L11.9999 3.33233Z"
  }));
},
    bE = function bE(_ref1922) {
  var _ref1922$color = _ref1922.color,
      C = _ref1922$color === void 0 ? "currentColor" : _ref1922$color,
      _ref1922$size = _ref1922.size,
      e = _ref1922$size === void 0 ? 24 : _ref1922$size,
      l = _ref1922.className,
      i = _objectWithoutProperties(_ref1922, _excluded1922);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18.001 20.0026V14.6693H20.001V22.0026H4.00098V14.6693H6.00098V20.0026H18.001ZM7.59977 14.7359L7.913 12.7566L16.75 14.456L16.6367 16.0421L7.59977 14.7359ZM8.79937 10.2041L9.53245 8.60463L17.5298 12.3367L16.7967 13.9362L8.79937 10.2041ZM11.0653 6.27208L12.1982 4.9392L18.9959 10.604L17.863 11.9368L11.0653 6.27208ZM15.3972 2.14014L20.6621 9.20443L19.2625 10.2707L13.9976 3.20645L15.3972 2.14014ZM7.33319 18.6679V16.6686H16.6634V18.6679H7.33319Z"
  }));
},
    TE = function TE(_ref1923) {
  var _ref1923$color = _ref1923.color,
      C = _ref1923$color === void 0 ? "currentColor" : _ref1923$color,
      _ref1923$size = _ref1923.size,
      e = _ref1923$size === void 0 ? 24 : _ref1923$size,
      l = _ref1923.className,
      i = _objectWithoutProperties(_ref1923, _excluded1923);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18.001 20.0025V15.0001H20.001V22.0025H4.00098V15.0001H6.00098V20.0025H18.001ZM7.50098 18.0001V16.0001H16.501V18.0001H7.50098ZM7.578 13.6197L7.9253 11.65L16.7886 13.2129L16.4413 15.1825L7.578 13.6197ZM9.21156 8.11608L10.2116 6.38403L18.0058 10.884L17.0058 12.6161L9.21156 8.11608ZM12.6289 3.5031L14.161 2.21753L19.9461 9.11193L18.414 10.3975L12.6289 3.5031Z"
  }));
},
    UE = function UE(_ref1924) {
  var _ref1924$color = _ref1924.color,
      C = _ref1924$color === void 0 ? "currentColor" : _ref1924$color,
      _ref1924$size = _ref1924.size,
      e = _ref1924$size === void 0 ? 24 : _ref1924$size,
      l = _ref1924.className,
      i = _objectWithoutProperties(_ref1924, _excluded1924);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21.001 3C21.5533 3 22.001 3.44772 22.001 4V20C22.001 20.5523 21.5533 21 21.001 21H3.00098C2.44869 21 2.00098 20.5523 2.00098 20V4C2.00098 3.44772 2.44869 3 3.00098 3H21.001ZM16.7931 5.62118C15.782 5.62118 14.9292 6.29705 14.6603 7.22158H12.6618L10.2022 11.4056H8.76433C8.49549 10.481 7.64267 9.80516 6.63133 9.80516C5.40457 9.80516 4.40993 10.8 4.40993 12.0269C4.40993 13.2536 5.40457 14.2483 6.63133 14.2483C7.64267 14.2483 8.49549 13.5724 8.76433 12.6481H10.2353L12.6523 16.7815H14.6696C14.9383 17.7057 15.7913 18.3814 16.8023 18.3814C18.0294 18.3814 19.024 17.3868 19.024 16.1599C19.024 14.933 18.0294 13.9382 16.8023 13.9382C15.7913 13.9382 14.9383 14.6142 14.6696 15.5387H13.3526L11.2968 12.0017L13.3495 8.46402H14.6603C14.9292 9.38855 15.782 10.0644 16.7931 10.0644C18.0201 10.0644 19.0148 9.06963 19.0148 7.84287C19.0148 6.61597 18.0201 5.62118 16.7931 5.62118ZM16.8044 15.0484C17.448 15.0484 17.9718 15.5721 17.9718 16.2158C17.9718 16.8596 17.448 17.3829 16.8044 17.3829C16.2384 17.3829 15.7658 16.9779 15.6598 16.4427C15.6598 16.4427 15.629 16.2164 15.6598 15.9893C15.7656 15.4537 16.2384 15.0484 16.8044 15.0484ZM6.65209 10.8387C7.29588 10.8387 7.81948 11.3622 7.81948 12.006C7.81948 12.6495 7.29588 13.1732 6.65209 13.1732C6.00844 13.1732 5.48485 12.6495 5.48485 12.006C5.48485 11.3622 6.00844 10.8387 6.65209 10.8387ZM16.8023 6.62903C17.4461 6.62903 17.9697 7.15248 17.9697 7.79627C17.9697 8.43977 17.4461 8.96352 16.8023 8.96352C16.2365 8.96352 15.7637 8.55837 15.6578 8.02287C15.6316 7.81689 15.6578 7.57679 15.6578 7.57679C15.7637 7.03418 16.2365 6.62903 16.8023 6.62903Z"
  }));
},
    GE = function GE(_ref1925) {
  var _ref1925$color = _ref1925.color,
      C = _ref1925$color === void 0 ? "currentColor" : _ref1925$color,
      _ref1925$size = _ref1925.size,
      e = _ref1925$size === void 0 ? 24 : _ref1925$size,
      l = _ref1925.className,
      i = _objectWithoutProperties(_ref1925, _excluded1925);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9.53698 13L7.32995 13.0009C6.91786 14.1656 5.80686 15 4.50098 15C2.84412 15 1.50098 13.6569 1.50098 12C1.50098 10.3431 2.84412 9 4.50098 9C5.80723 9 6.91849 9.83485 7.3303 11.0001L9.53698 11L13.001 5L16.1716 5.00009C16.5835 3.83485 17.6947 3 19.001 3C20.6578 3 22.001 4.34315 22.001 6C22.001 7.65685 20.6578 9 19.001 9C17.6951 9 16.5841 8.16562 16.172 7.0009L14.155 7L11.269 11.999L14.156 17L16.1716 17.0001C16.5835 15.8349 17.6947 15 19.001 15C20.6578 15 22.001 16.3431 22.001 18C22.001 19.6569 20.6578 21 19.001 21C17.6951 21 16.5841 20.1656 16.172 19.0009L13.001 19L9.53698 13ZM19.001 17C18.4487 17 18.001 17.4477 18.001 18C18.001 18.5523 18.4487 19 19.001 19C19.5533 19 20.001 18.5523 20.001 18C20.001 17.4477 19.5533 17 19.001 17ZM4.50098 11C3.94869 11 3.50098 11.4477 3.50098 12C3.50098 12.5523 3.94869 13 4.50098 13C5.05326 13 5.50098 12.5523 5.50098 12C5.50098 11.4477 5.05326 11 4.50098 11ZM19.001 5C18.4487 5 18.001 5.44772 18.001 6C18.001 6.55228 18.4487 7 19.001 7C19.5533 7 20.001 6.55228 20.001 6C20.001 5.44772 19.5533 5 19.001 5Z"
  }));
},
    IE = function IE(_ref1926) {
  var _ref1926$color = _ref1926.color,
      C = _ref1926$color === void 0 ? "currentColor" : _ref1926$color,
      _ref1926$size = _ref1926.size,
      e = _ref1926$size === void 0 ? 24 : _ref1926$size,
      l = _ref1926.className,
      i = _objectWithoutProperties(_ref1926, _excluded1926);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.0006 18.26L4.94715 22.2082L6.52248 14.2799L0.587891 8.7918L8.61493 7.84006L12.0006 0.5L15.3862 7.84006L23.4132 8.7918L17.4787 14.2799L19.054 22.2082L12.0006 18.26Z"
  }));
},
    WE = function WE(_ref1927) {
  var _ref1927$color = _ref1927.color,
      C = _ref1927$color === void 0 ? "currentColor" : _ref1927$color,
      _ref1927$size = _ref1927.size,
      e = _ref1927$size === void 0 ? 24 : _ref1927$size,
      l = _ref1927.className,
      i = _objectWithoutProperties(_ref1927, _excluded1927);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.0006 15.968L16.2473 18.3451L15.2988 13.5717L18.8719 10.2674L14.039 9.69434L12.0006 5.27502V15.968ZM12.0006 18.26L4.94715 22.2082L6.52248 14.2799L0.587891 8.7918L8.61493 7.84006L12.0006 0.5L15.3862 7.84006L23.4132 8.7918L17.4787 14.2799L19.054 22.2082L12.0006 18.26Z"
  }));
},
    OE = function OE(_ref1928) {
  var _ref1928$color = _ref1928.color,
      C = _ref1928$color === void 0 ? "currentColor" : _ref1928$color,
      _ref1928$size = _ref1928.size,
      e = _ref1928$size === void 0 ? 24 : _ref1928$size,
      l = _ref1928.className,
      i = _objectWithoutProperties(_ref1928, _excluded1928);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.0006 15.968L16.2473 18.3451L15.2988 13.5717L18.8719 10.2674L14.039 9.69434L12.0006 5.27502V15.968ZM12.0006 18.26L4.94715 22.2082L6.52248 14.2799L0.587891 8.7918L8.61493 7.84006L12.0006 0.5L15.3862 7.84006L23.4132 8.7918L17.4787 14.2799L19.054 22.2082L12.0006 18.26Z"
  }));
},
    KE = function KE(_ref1929) {
  var _ref1929$color = _ref1929.color,
      C = _ref1929$color === void 0 ? "currentColor" : _ref1929$color,
      _ref1929$size = _ref1929.size,
      e = _ref1929$size === void 0 ? 24 : _ref1929$size,
      l = _ref1929.className,
      i = _objectWithoutProperties(_ref1929, _excluded1929);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11.9998 14.6564L14.8165 16.3769L14.0507 13.1664L16.5574 11.0192L13.2673 10.7554L11.9998 7.70792V14.6564ZM11.9998 17L6.12197 20.5902L7.72007 13.8906L2.48926 9.40983L9.35479 8.85942L11.9998 2.5L14.6449 8.85942L21.5104 9.40983L16.2796 13.8906L17.8777 20.5902L11.9998 17Z"
  }));
},
    QE = function QE(_ref1930) {
  var _ref1930$color = _ref1930.color,
      C = _ref1930$color === void 0 ? "currentColor" : _ref1930$color,
      _ref1930$size = _ref1930.size,
      e = _ref1930$size === void 0 ? 24 : _ref1930$size,
      l = _ref1930.className,
      i = _objectWithoutProperties(_ref1930, _excluded1930);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11.9998 14.6564L14.8165 16.3769L14.0507 13.1664L16.5574 11.0192L13.2673 10.7554L11.9998 7.70792V14.6564ZM11.9998 17L6.12197 20.5902L7.72007 13.8906L2.48926 9.40983L9.35479 8.85942L11.9998 2.5L14.6449 8.85942L21.5104 9.40983L16.2796 13.8906L17.8777 20.5902L11.9998 17Z"
  }));
},
    qE = function qE(_ref1931) {
  var _ref1931$color = _ref1931.color,
      C = _ref1931$color === void 0 ? "currentColor" : _ref1931$color,
      _ref1931$size = _ref1931.size,
      e = _ref1931$size === void 0 ? 24 : _ref1931$size,
      l = _ref1931.className,
      i = _objectWithoutProperties(_ref1931, _excluded1931);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.0006 18.26L4.94715 22.2082L6.52248 14.2799L0.587891 8.7918L8.61493 7.84006L12.0006 0.5L15.3862 7.84006L23.4132 8.7918L17.4787 14.2799L19.054 22.2082L12.0006 18.26ZM12.0006 15.968L16.2473 18.3451L15.2988 13.5717L18.8719 10.2674L14.039 9.69434L12.0006 5.27502L9.96214 9.69434L5.12921 10.2674L8.70231 13.5717L7.75383 18.3451L12.0006 15.968Z"
  }));
},
    jE = function jE(_ref1932) {
  var _ref1932$color = _ref1932.color,
      C = _ref1932$color === void 0 ? "currentColor" : _ref1932$color,
      _ref1932$size = _ref1932.size,
      e = _ref1932$size === void 0 ? 24 : _ref1932$size,
      l = _ref1932.className,
      i = _objectWithoutProperties(_ref1932, _excluded1932);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11.9998 17L6.12197 20.5902L7.72007 13.8906L2.48926 9.40983L9.35479 8.85942L11.9998 2.5L14.6449 8.85942L21.5104 9.40983L16.2796 13.8906L17.8777 20.5902L11.9998 17Z"
  }));
},
    XE = function XE(_ref1933) {
  var _ref1933$color = _ref1933.color,
      C = _ref1933$color === void 0 ? "currentColor" : _ref1933$color,
      _ref1933$size = _ref1933.size,
      e = _ref1933$size === void 0 ? 24 : _ref1933$size,
      l = _ref1933.className,
      i = _objectWithoutProperties(_ref1933, _excluded1933);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11.9998 17L6.12197 20.5902L7.72007 13.8906L2.48926 9.40983L9.35479 8.85942L11.9998 2.5L14.6449 8.85942L21.5104 9.40983L16.2796 13.8906L17.8777 20.5902L11.9998 17ZM11.9998 14.6564L14.8165 16.3769L14.0507 13.1664L16.5574 11.0192L13.2673 10.7554L11.9998 7.70792L10.7323 10.7554L7.44228 11.0192L9.94893 13.1664L9.18311 16.3769L11.9998 14.6564Z"
  }));
},
    JE = function JE(_ref1934) {
  var _ref1934$color = _ref1934.color,
      C = _ref1934$color === void 0 ? "currentColor" : _ref1934$color,
      _ref1934$size = _ref1934.size,
      e = _ref1934$size === void 0 ? 24 : _ref1934$size,
      l = _ref1934.className,
      i = _objectWithoutProperties(_ref1934, _excluded1934);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11.9996 0.5L16.2256 6.68342L23.4123 8.7918L18.8374 14.7217L19.053 22.2082L11.9996 19.6897L4.94617 22.2082L5.16179 14.7217L0.586914 8.7918L7.7736 6.68342L11.9996 0.5ZM9.99959 12H7.99959C7.99959 14.2091 9.79045 16 11.9996 16C14.1418 16 15.8907 14.316 15.9947 12.1996L15.9996 12H13.9996C13.9996 13.1046 13.1042 14 11.9996 14C10.9452 14 10.0814 13.1841 10.0051 12.1493L9.99959 12Z"
  }));
},
    YE = function YE(_ref1935) {
  var _ref1935$color = _ref1935.color,
      C = _ref1935$color === void 0 ? "currentColor" : _ref1935$color,
      _ref1935$size = _ref1935.size,
      e = _ref1935$size === void 0 ? 24 : _ref1935$size,
      l = _ref1935.className,
      i = _objectWithoutProperties(_ref1935, _excluded1935);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11.9996 0.5L16.2256 6.68342L23.4123 8.7918L18.8374 14.7217L19.053 22.2082L11.9996 19.6897L4.94617 22.2082L5.16179 14.7217L0.586914 8.7918L7.7736 6.68342L11.9996 0.5ZM11.9996 4.044L9.02186 8.40151L3.95659 9.887L7.18152 14.0655L7.02859 19.34L11.9996 17.566L16.9696 19.34L16.8177 14.0655L20.0416 9.887L14.9773 8.40151L11.9996 4.044ZM9.99959 12C9.99959 13.1046 10.895 14 11.9996 14C13.1042 14 13.9996 13.1046 13.9996 12H15.9996C15.9996 14.2091 14.2087 16 11.9996 16C9.79045 16 7.99959 14.2091 7.99959 12H9.99959Z"
  }));
},
    _E = function _E(_ref1936) {
  var _ref1936$color = _ref1936.color,
      C = _ref1936$color === void 0 ? "currentColor" : _ref1936$color,
      _ref1936$size = _ref1936.size,
      e = _ref1936$size === void 0 ? 24 : _ref1936$size,
      l = _ref1936.className,
      i = _objectWithoutProperties(_ref1936, _excluded1936);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.0052 2C6.75435 2 2.44852 6.05 2.04102 11.1975L7.40102 13.4125C7.85518 13.1033 8.40352 12.9208 8.99435 12.9208C9.04685 12.9208 9.09852 12.9242 9.15102 12.9258L11.5352 9.47417V9.425C11.5352 7.34583 13.2252 5.655 15.3052 5.655C17.3835 5.655 19.0752 7.3475 19.0752 9.4275C19.0752 11.5075 17.3835 13.1983 15.3052 13.1983H15.2177L11.821 15.6242C11.821 15.6675 11.8243 15.7117 11.8243 15.7567C11.8243 17.3192 10.5618 18.5867 8.99935 18.5867C7.63685 18.5867 6.48602 17.6092 6.22352 16.3142L2.38602 14.725C3.57435 18.9225 7.42768 22 12.0052 22C17.5277 22 22.0043 17.5225 22.0043 12C22.0043 6.4775 17.5268 2 12.0052 2ZM7.07852 16.6667C7.29685 17.1192 7.67352 17.4992 8.17352 17.7083C9.25435 18.1575 10.501 17.645 10.9502 16.5625C11.1693 16.0375 11.1702 15.4633 10.9543 14.9383C10.7385 14.4133 10.3293 14.0042 9.80685 13.7858C9.28685 13.5692 8.73185 13.5783 8.24185 13.7608L9.51102 14.2858C10.3077 14.6192 10.6852 15.5358 10.3518 16.3317C10.021 17.1292 9.10435 17.5067 8.30685 17.175L7.07852 16.6667ZM17.8185 9.4225C17.8185 8.0375 16.691 6.91 15.306 6.91C13.9185 6.91 12.7935 8.0375 12.7935 9.4225C12.7935 10.81 13.9185 11.935 15.306 11.935C16.6918 11.935 17.8185 10.81 17.8185 9.4225ZM15.3118 7.53C16.3527 7.53 17.2002 8.375 17.2002 9.41833C17.2002 10.4608 16.3527 11.3058 15.3118 11.3058C14.2677 11.3058 13.4243 10.4608 13.4243 9.41833C13.4243 8.375 14.2685 7.53 15.3118 7.53Z"
  }));
},
    $E = function $E(_ref1937) {
  var _ref1937$color = _ref1937.color,
      C = _ref1937$color === void 0 ? "currentColor" : _ref1937$color,
      _ref1937$size = _ref1937.size,
      e = _ref1937$size === void 0 ? 24 : _ref1937$size,
      l = _ref1937.className,
      i = _objectWithoutProperties(_ref1937, _excluded1937);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17.0011 4C19.7625 4 22.0011 6.23858 22.0011 9C22.0011 11.7614 19.7625 14 17.0011 14C16.6966 14 16.3985 13.9728 16.1091 13.9207L13.4577 15.9089C13.4863 16.1018 13.5011 16.2992 13.5011 16.5C13.5011 18.7091 11.7102 20.5 9.50106 20.5C7.29192 20.5 5.50106 18.7091 5.50106 16.5C5.50106 16.3225 5.51262 16.1477 5.53503 15.9764L1.70898 14.4303L2.4582 12.576L6.28509 14.121C7.01383 13.1375 8.183 12.5 9.50106 12.5C9.66379 12.5 9.82424 12.5097 9.98188 12.5286L12.0226 9.4676C12.0084 9.31365 12.0011 9.15768 12.0011 9C12.0011 6.23858 14.2396 4 17.0011 4ZM9.50106 14.5C9.03676 14.5 8.6094 14.6582 8.26998 14.9237L9.87567 15.5728C10.3877 15.7797 10.6351 16.3625 10.4282 16.8746C10.2214 17.3867 9.63853 17.6341 9.12646 17.4272L7.52032 16.7787C7.65592 17.7513 8.49106 18.5 9.50106 18.5C10.6056 18.5 11.5011 17.6046 11.5011 16.5C11.5011 15.3954 10.6056 14.5 9.50106 14.5ZM12.8647 11.8099L11.8821 13.2855C12.1661 13.4963 12.4213 13.7438 12.6405 14.021L14.0009 13.0002C13.5599 12.669 13.1755 12.2665 12.8647 11.8099ZM17.0011 6C15.3442 6 14.0011 7.34315 14.0011 9C14.0011 10.6569 15.3442 12 17.0011 12C18.6579 12 20.0011 10.6569 20.0011 9C20.0011 7.34315 18.6579 6 17.0011 6ZM17.0011 7C18.1056 7 19.0011 7.89543 19.0011 9C19.0011 10.1046 18.1056 11 17.0011 11C15.8965 11 15.0011 10.1046 15.0011 9C15.0011 7.89543 15.8965 7 17.0011 7Z"
  }));
},
    eN = function eN(_ref1938) {
  var _ref1938$color = _ref1938.color,
      C = _ref1938$color === void 0 ? "currentColor" : _ref1938$color,
      _ref1938$size = _ref1938.size,
      e = _ref1938$size === void 0 ? 24 : _ref1938$size,
      l = _ref1938.className,
      i = _objectWithoutProperties(_ref1938, _excluded1938);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM8 13L4.06201 13.001C4.51365 16.6192 7.38163 19.4869 11 19.9381V16C9.34315 16 8 14.6569 8 13ZM19.938 13.001L16 13C16 14.6569 14.6569 16 13 16L13.001 19.938C16.6189 19.4864 19.4864 16.6189 19.938 13.001ZM12 4C7.92037 4 4.55396 7.05371 4.06189 11H8C8 10.4477 8.44772 10 9 10H15C15.5523 10 16 10.4477 16 11H19.9381C19.446 7.05371 16.0796 4 12 4Z"
  }));
},
    tN = function tN(_ref1939) {
  var _ref1939$color = _ref1939.color,
      C = _ref1939$color === void 0 ? "currentColor" : _ref1939$color,
      _ref1939$size = _ref1939.size,
      e = _ref1939$size === void 0 ? 24 : _ref1939$size,
      l = _ref1939.className,
      i = _objectWithoutProperties(_ref1939, _excluded1939);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM8 13L4.06201 13.001C4.51365 16.6192 7.38163 19.4869 11 19.9381V16C9.34315 16 8 14.6569 8 13ZM19.938 13.001L16 13C16 14.6569 14.6569 16 13 16L13.001 19.938C16.6189 19.4864 19.4864 16.6189 19.938 13.001ZM14 12H10V13C10 13.5523 10.4477 14 11 14H13C13.5523 14 14 13.5523 14 13V12ZM12 4C7.92037 4 4.55396 7.05371 4.06189 11H8C8 10.4477 8.44772 10 9 10H15C15.5523 10 16 10.4477 16 11H19.9381C19.446 7.05371 16.0796 4 12 4Z"
  }));
},
    CN = function CN(_ref1940) {
  var _ref1940$color = _ref1940.color,
      C = _ref1940$color === void 0 ? "currentColor" : _ref1940$color,
      _ref1940$size = _ref1940.size,
      e = _ref1940$size === void 0 ? 24 : _ref1940$size,
      l = _ref1940.className,
      i = _objectWithoutProperties(_ref1940, _excluded1940);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21.7992 14.001C20.9633 18.1168 17.5995 21.3145 13.399 21.9028L13.3992 19.878C16.4926 19.3321 18.9729 17.0086 19.7473 14.0004L21.7992 14.001ZM4.25157 14.0004C5.01757 16.9759 7.45244 19.2814 10.4989 19.8595V21.8882C6.3456 21.2632 3.02888 18.0838 2.19968 14.001L4.25157 14.0004ZM17.9994 11V13H16.9994C14.8572 13 13.1084 14.684 13.0043 16.8004L12.9994 17V18H10.9994V17C10.9994 14.8578 9.31547 13.1089 7.19908 13.0049L6.99944 13H5.99944V11H17.9994ZM11.9994 2C17.1848 2 21.4483 5.94662 21.9501 10.9999L19.9376 11C19.4455 7.05371 16.0791 4 11.9994 4C7.91981 4 4.55341 7.05371 4.06133 11L2.04883 10.9999C2.5506 5.94662 6.81413 2 11.9994 2Z"
  }));
},
    lN = function lN(_ref1941) {
  var _ref1941$color = _ref1941.color,
      C = _ref1941$color === void 0 ? "currentColor" : _ref1941$color,
      _ref1941$size = _ref1941.size,
      e = _ref1941$size === void 0 ? 24 : _ref1941$size,
      l = _ref1941.className,
      i = _objectWithoutProperties(_ref1941, _excluded1941);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21.7992 14.001C20.9633 18.1168 17.5995 21.3145 13.399 21.9028L13.3992 19.878C16.4926 19.3321 18.9729 17.0086 19.7473 14.0004L21.7992 14.001ZM4.25157 14.0004C5.01757 16.9759 7.45244 19.2814 10.4989 19.8595V21.8882C6.3456 21.2632 3.02888 18.0838 2.19968 14.001L4.25157 14.0004ZM17.9994 11V13H14.9994C13.9451 13 13.0813 13.8159 13.0049 14.8507L12.9994 15V18H10.9994V15C10.9994 13.9456 10.1836 13.0818 9.14871 13.0055L8.99944 13H5.99944V11H17.9994ZM11.9994 2C17.1848 2 21.4483 5.94662 21.9501 10.9999L19.9376 11C19.4455 7.05371 16.0791 4 11.9994 4C7.91981 4 4.55341 7.05371 4.06133 11L2.04883 10.9999C2.5506 5.94662 6.81413 2 11.9994 2Z"
  }));
},
    iN = function iN(_ref1942) {
  var _ref1942$color = _ref1942.color,
      C = _ref1942$color === void 0 ? "currentColor" : _ref1942$color,
      _ref1942$size = _ref1942.size,
      e = _ref1942$size === void 0 ? 24 : _ref1942$size,
      l = _ref1942.className,
      i = _objectWithoutProperties(_ref1942, _excluded1942);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8 3V5H6V9C6 11.2091 7.79086 13 10 13C12.2091 13 14 11.2091 14 9V5H12V3H15C15.5523 3 16 3.44772 16 4V9C16 11.9727 13.8381 14.4405 11.0008 14.9169L11 16.5C11 18.433 12.567 20 14.5 20C15.9973 20 17.275 19.0598 17.7749 17.7375C16.7283 17.27 16 16.2201 16 15C16 13.3431 17.3431 12 19 12C20.6569 12 22 13.3431 22 15C22 16.3711 21.0802 17.5274 19.824 17.8854C19.2102 20.252 17.0592 22 14.5 22C11.4624 22 9 19.5376 9 16.5L9.00019 14.9171C6.16238 14.4411 4 11.9731 4 9V4C4 3.44772 4.44772 3 5 3H8Z"
  }));
},
    sN = function sN(_ref1943) {
  var _ref1943$color = _ref1943.color,
      C = _ref1943$color === void 0 ? "currentColor" : _ref1943$color,
      _ref1943$size = _ref1943.size,
      e = _ref1943$size === void 0 ? 24 : _ref1943$size,
      l = _ref1943.className,
      i = _objectWithoutProperties(_ref1943, _excluded1943);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8 3V5H6V9C6 11.2091 7.79086 13 10 13C12.2091 13 14 11.2091 14 9V5H12V3H15C15.5523 3 16 3.44772 16 4V9C16 11.9727 13.8381 14.4405 11.0008 14.9169L11 16.5C11 18.433 12.567 20 14.5 20C15.9973 20 17.275 19.0598 17.7749 17.7375C16.7283 17.27 16 16.2201 16 15C16 13.3431 17.3431 12 19 12C20.6569 12 22 13.3431 22 15C22 16.3711 21.0802 17.5274 19.824 17.8854C19.2102 20.252 17.0592 22 14.5 22C11.4624 22 9 19.5376 9 16.5L9.00019 14.9171C6.16238 14.4411 4 11.9731 4 9V4C4 3.44772 4.44772 3 5 3H8ZM19 14C18.4477 14 18 14.4477 18 15C18 15.5523 18.4477 16 19 16C19.5523 16 20 15.5523 20 15C20 14.4477 19.5523 14 19 14Z"
  }));
},
    rN = function rN(_ref1944) {
  var _ref1944$color = _ref1944.color,
      C = _ref1944$color === void 0 ? "currentColor" : _ref1944$color,
      _ref1944$size = _ref1944.size,
      e = _ref1944$size === void 0 ? 24 : _ref1944$size,
      l = _ref1944.className,
      i = _objectWithoutProperties(_ref1944, _excluded1944);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 16L15.9968 21H3.99826C3.44694 21 3 20.5551 3 20.0066V3.9934C3 3.44476 3.44495 3 3.9934 3H20.0066C20.5552 3 21 3.44749 21 3.9985V16Z"
  }));
},
    cN = function cN(_ref1945) {
  var _ref1945$color = _ref1945.color,
      C = _ref1945$color === void 0 ? "currentColor" : _ref1945$color,
      _ref1945$size = _ref1945.size,
      e = _ref1945$size === void 0 ? 24 : _ref1945$size,
      l = _ref1945.className,
      i = _objectWithoutProperties(_ref1945, _excluded1945);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3.99826 21C3.44694 21 3 20.5551 3 20.0066V3.9934C3 3.44476 3.44495 3 3.9934 3H20.0066C20.5552 3 21 3.44749 21 3.9985V16L15.9968 21H3.99826ZM5 19H15.1688L19 15.1712V5H5V19Z"
  }));
},
    oN = function oN(_ref1946) {
  var _ref1946$color = _ref1946.color,
      C = _ref1946$color === void 0 ? "currentColor" : _ref1946$color,
      _ref1946$size = _ref1946.size,
      e = _ref1946$size === void 0 ? 24 : _ref1946$size,
      l = _ref1946.className,
      i = _objectWithoutProperties(_ref1946, _excluded1946);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15 14L14.8834 14.0067C14.4243 14.0601 14.0601 14.4243 14.0067 14.8834L14 15V21H3.99826C3.44694 21 3 20.5551 3 20.0066V3.9934C3 3.44476 3.44495 3 3.9934 3H20.0066C20.5552 3 21 3.44749 21 3.9985V14H15ZM21 16L16 20.997V16H21Z"
  }));
},
    aN = function aN(_ref1947) {
  var _ref1947$color = _ref1947.color,
      C = _ref1947$color === void 0 ? "currentColor" : _ref1947$color,
      _ref1947$size = _ref1947.size,
      e = _ref1947$size === void 0 ? 24 : _ref1947$size,
      l = _ref1947.className,
      i = _objectWithoutProperties(_ref1947, _excluded1947);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 15L15 20.996L4.00221 21C3.4487 21 3 20.5551 3 20.0066V3.9934C3 3.44476 3.44495 3 3.9934 3H20.0066C20.5552 3 21 3.45576 21 4.00247V15ZM19 5H5V19H13V14C13 13.4872 13.386 13.0645 13.8834 13.0067L14 13L19 12.999V5ZM18.171 14.999L15 15V18.169L18.171 14.999Z"
  }));
},
    nN = function nN(_ref1948) {
  var _ref1948$color = _ref1948.color,
      C = _ref1948$color === void 0 ? "currentColor" : _ref1948$color,
      _ref1948$size = _ref1948.size,
      e = _ref1948$size === void 0 ? 24 : _ref1948$size,
      l = _ref1948.className,
      i = _objectWithoutProperties(_ref1948, _excluded1948);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8.00488 5.00281H11.0049V14.0028H8.00488V17.0028H6.00488V14.0028H3.00488V5.00281H6.00488V2.00281H8.00488V5.00281ZM18.0049 10.0028H21.0049V19.0028H18.0049V22.0028H16.0049V19.0028H13.0049V10.0028H16.0049V7.00281H18.0049V10.0028Z"
  }));
},
    mN = function mN(_ref1949) {
  var _ref1949$color = _ref1949.color,
      C = _ref1949$color === void 0 ? "currentColor" : _ref1949$color,
      _ref1949$size = _ref1949.size,
      e = _ref1949$size === void 0 ? 24 : _ref1949$size,
      l = _ref1949.className,
      i = _objectWithoutProperties(_ref1949, _excluded1949);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8.00488 5.00281H11.0049V14.0028H8.00488V17.0028H6.00488V14.0028H3.00488V5.00281H6.00488V2.00281H8.00488V5.00281ZM5.00488 7.00281V12.0028H9.00488V7.00281H5.00488ZM18.0049 10.0028H21.0049V19.0028H18.0049V22.0028H16.0049V19.0028H13.0049V10.0028H16.0049V7.00281H18.0049V10.0028ZM15.0049 12.0028V17.0028H19.0049V12.0028H15.0049Z"
  }));
},
    wN = function wN(_ref1950) {
  var _ref1950$color = _ref1950.color,
      C = _ref1950$color === void 0 ? "currentColor" : _ref1950$color,
      _ref1950$size = _ref1950.size,
      e = _ref1950$size === void 0 ? 24 : _ref1950$size,
      l = _ref1950.className,
      i = _objectWithoutProperties(_ref1950, _excluded1950);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM9 9V15H15V9H9Z"
  }));
},
    LN = function LN(_ref1951) {
  var _ref1951$color = _ref1951.color,
      C = _ref1951$color === void 0 ? "currentColor" : _ref1951$color,
      _ref1951$size = _ref1951.size,
      e = _ref1951$size === void 0 ? 24 : _ref1951$size,
      l = _ref1951.className,
      i = _objectWithoutProperties(_ref1951, _excluded1951);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM9 9H15V15H9V9Z"
  }));
},
    hN = function hN(_ref1952) {
  var _ref1952$color = _ref1952.color,
      C = _ref1952$color === void 0 ? "currentColor" : _ref1952$color,
      _ref1952$size = _ref1952.size,
      e = _ref1952$size === void 0 ? 24 : _ref1952$size,
      l = _ref1952.className,
      i = _objectWithoutProperties(_ref1952, _excluded1952);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6 5H18C18.5523 5 19 5.44772 19 6V18C19 18.5523 18.5523 19 18 19H6C5.44772 19 5 18.5523 5 18V6C5 5.44772 5.44772 5 6 5Z"
  }));
},
    HN = function HN(_ref1953) {
  var _ref1953$color = _ref1953.color,
      C = _ref1953$color === void 0 ? "currentColor" : _ref1953$color,
      _ref1953$size = _ref1953.size,
      e = _ref1953$size === void 0 ? 24 : _ref1953$size,
      l = _ref1953.className,
      i = _objectWithoutProperties(_ref1953, _excluded1953);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7 7V17H17V7H7ZM6 5H18C18.5523 5 19 5.44772 19 6V18C19 18.5523 18.5523 19 18 19H6C5.44772 19 5 18.5523 5 18V6C5 5.44772 5.44772 5 6 5Z"
  }));
},
    VN = function VN(_ref1954) {
  var _ref1954$color = _ref1954.color,
      C = _ref1954$color === void 0 ? "currentColor" : _ref1954$color,
      _ref1954$size = _ref1954.size,
      e = _ref1954$size === void 0 ? 24 : _ref1954$size,
      l = _ref1954.className,
      i = _objectWithoutProperties(_ref1954, _excluded1954);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6 7V17C6 17.5523 6.44772 18 7 18H17C17.5523 18 18 17.5523 18 17V7C18 6.44772 17.5523 6 17 6H7C6.44772 6 6 6.44772 6 7Z"
  }));
},
    gN = function gN(_ref1955) {
  var _ref1955$color = _ref1955.color,
      C = _ref1955$color === void 0 ? "currentColor" : _ref1955$color,
      _ref1955$size = _ref1955.size,
      e = _ref1955$size === void 0 ? 24 : _ref1955$size,
      l = _ref1955.className,
      i = _objectWithoutProperties(_ref1955, _excluded1955);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6 7C6 6.44772 6.44772 6 7 6H17C17.5523 6 18 6.44772 18 7V17C18 17.5523 17.5523 18 17 18H7C6.44772 18 6 17.5523 6 17V7ZM8 8V16H16V8H8Z"
  }));
},
    MN = function MN(_ref1956) {
  var _ref1956$color = _ref1956.color,
      C = _ref1956$color === void 0 ? "currentColor" : _ref1956$color,
      _ref1956$size = _ref1956.size,
      e = _ref1956$size === void 0 ? 24 : _ref1956$size,
      l = _ref1956.className,
      i = _objectWithoutProperties(_ref1956, _excluded1956);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22 20V22H2V20H3V13.2422C1.79401 12.435 1 11.0602 1 9.5C1 8.67286 1.22443 7.87621 1.63322 7.19746L4.3453 2.5C4.52393 2.1906 4.85406 2 5.21132 2H18.7887C19.1459 2 19.4761 2.1906 19.6547 2.5L22.3575 7.18172C22.7756 7.87621 23 8.67286 23 9.5C23 11.0602 22.206 12.435 21 13.2422V20H22ZM5.78865 4L3.35598 8.21321C3.12409 8.59843 3 9.0389 3 9.5C3 10.8807 4.11929 12 5.5 12C6.53096 12 7.44467 11.3703 7.82179 10.4295C8.1574 9.59223 9.3426 9.59223 9.67821 10.4295C10.0553 11.3703 10.969 12 12 12C13.031 12 13.9447 11.3703 14.3218 10.4295C14.6574 9.59223 15.8426 9.59223 16.1782 10.4295C16.5553 11.3703 17.469 12 18.5 12C19.8807 12 21 10.8807 21 9.5C21 9.0389 20.8759 8.59843 20.6347 8.19746L18.2113 4H5.78865Z"
  }));
},
    ZN = function ZN(_ref1957) {
  var _ref1957$color = _ref1957.color,
      C = _ref1957$color === void 0 ? "currentColor" : _ref1957$color,
      _ref1957$size = _ref1957.size,
      e = _ref1957$size === void 0 ? 24 : _ref1957$size,
      l = _ref1957.className,
      i = _objectWithoutProperties(_ref1957, _excluded1957);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 13.2422V20H22V22H2V20H3V13.2422C1.79401 12.435 1 11.0602 1 9.5C1 8.67286 1.22443 7.87621 1.63322 7.19746L4.3453 2.5C4.52393 2.1906 4.85406 2 5.21132 2H18.7887C19.1459 2 19.4761 2.1906 19.6547 2.5L22.3575 7.18172C22.7756 7.87621 23 8.67286 23 9.5C23 11.0602 22.206 12.435 21 13.2422ZM19 13.9725C18.8358 13.9907 18.669 14 18.5 14C17.2409 14 16.0789 13.478 15.25 12.6132C14.4211 13.478 13.2591 14 12 14C10.7409 14 9.5789 13.478 8.75 12.6132C7.9211 13.478 6.75911 14 5.5 14C5.331 14 5.16417 13.9907 5 13.9725V20H19V13.9725ZM5.78865 4L3.35598 8.21321C3.12409 8.59843 3 9.0389 3 9.5C3 10.8807 4.11929 12 5.5 12C6.53096 12 7.44467 11.3703 7.82179 10.4295C8.1574 9.59223 9.3426 9.59223 9.67821 10.4295C10.0553 11.3703 10.969 12 12 12C13.031 12 13.9447 11.3703 14.3218 10.4295C14.6574 9.59223 15.8426 9.59223 16.1782 10.4295C16.5553 11.3703 17.469 12 18.5 12C19.8807 12 21 10.8807 21 9.5C21 9.0389 20.8759 8.59843 20.6347 8.19746L18.2113 4H5.78865Z"
  }));
},
    xN = function xN(_ref1958) {
  var _ref1958$color = _ref1958.color,
      C = _ref1958$color === void 0 ? "currentColor" : _ref1958$color,
      _ref1958$size = _ref1958.size,
      e = _ref1958$size === void 0 ? 24 : _ref1958$size,
      l = _ref1958.className,
      i = _objectWithoutProperties(_ref1958, _excluded1958);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 13V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V13H2V11L3 6H21L22 11V13H21ZM5 13V19H19V13H5ZM6 14H14V17H6V14ZM3 3H21V5H3V3Z"
  }));
},
    vN = function vN(_ref1959) {
  var _ref1959$color = _ref1959.color,
      C = _ref1959$color === void 0 ? "currentColor" : _ref1959$color,
      _ref1959$size = _ref1959.size,
      e = _ref1959$size === void 0 ? 24 : _ref1959$size,
      l = _ref1959.className,
      i = _objectWithoutProperties(_ref1959, _excluded1959);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 13V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V13H2V11L3 6H21L22 11V13H21ZM5 13V19H19V13H5ZM4.03961 11H19.9604L19.3604 8H4.63961L4.03961 11ZM6 14H14V17H6V14ZM3 3H21V5H3V3Z"
  }));
},
    dN = function dN(_ref1960) {
  var _ref1960$color = _ref1960.color,
      C = _ref1960$color === void 0 ? "currentColor" : _ref1960$color,
      _ref1960$size = _ref1960.size,
      e = _ref1960$size === void 0 ? 24 : _ref1960$size,
      l = _ref1960.className,
      i = _objectWithoutProperties(_ref1960, _excluded1960);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 11.6458V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V11.6458C2.37764 10.9407 2 10.0144 2 9V3C2 2.44772 2.44772 2 3 2H21C21.5523 2 22 2.44772 22 3V9C22 10.0144 21.6224 10.9407 21 11.6458ZM14 9C14 8.44772 14.4477 8 15 8C15.5523 8 16 8.44772 16 9C16 10.1046 16.8954 11 18 11C19.1046 11 20 10.1046 20 9V4H4V9C4 10.1046 4.89543 11 6 11C7.10457 11 8 10.1046 8 9C8 8.44772 8.44772 8 9 8C9.55228 8 10 8.44772 10 9C10 10.1046 10.8954 11 12 11C13.1046 11 14 10.1046 14 9Z"
  }));
},
    pN = function pN(_ref1961) {
  var _ref1961$color = _ref1961.color,
      C = _ref1961$color === void 0 ? "currentColor" : _ref1961$color,
      _ref1961$size = _ref1961.size,
      e = _ref1961$size === void 0 ? 24 : _ref1961$size,
      l = _ref1961.className,
      i = _objectWithoutProperties(_ref1961, _excluded1961);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 11.6458V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V11.6458C2.37764 10.9407 2 10.0144 2 9V3C2 2.44772 2.44772 2 3 2H21C21.5523 2 22 2.44772 22 3V9C22 10.0144 21.6224 10.9407 21 11.6458ZM19 12.874C18.6804 12.9562 18.3453 13 18 13C16.8053 13 15.7329 12.4762 15 11.6458C14.2671 12.4762 13.1947 13 12 13C10.8053 13 9.73294 12.4762 9 11.6458C8.26706 12.4762 7.19469 13 6 13C5.6547 13 5.31962 12.9562 5 12.874V20H19V12.874ZM14 9C14 8.44772 14.4477 8 15 8C15.5523 8 16 8.44772 16 9C16 10.1046 16.8954 11 18 11C19.1046 11 20 10.1046 20 9V4H4V9C4 10.1046 4.89543 11 6 11C7.10457 11 8 10.1046 8 9C8 8.44772 8.44772 8 9 8C9.55228 8 10 8.44772 10 9C10 10.1046 10.8954 11 12 11C13.1046 11 14 10.1046 14 9Z"
  }));
},
    EN = function EN(_ref1962) {
  var _ref1962$color = _ref1962.color,
      C = _ref1962$color === void 0 ? "currentColor" : _ref1962$color,
      _ref1962$size = _ref1962.size,
      e = _ref1962$size === void 0 ? 24 : _ref1962$size,
      l = _ref1962.className,
      i = _objectWithoutProperties(_ref1962, _excluded1962);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13 9H11V6H5V4H19V6H13V9ZM13 15V20H11V15H13ZM3 11H21V13H3V11Z"
  }));
},
    NN = function NN(_ref1963) {
  var _ref1963$color = _ref1963.color,
      C = _ref1963$color === void 0 ? "currentColor" : _ref1963$color,
      _ref1963$size = _ref1963.size,
      e = _ref1963$size === void 0 ? 24 : _ref1963$size,
      l = _ref1963.className,
      i = _objectWithoutProperties(_ref1963, _excluded1963);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17.1538 14C17.3846 14.5161 17.5 15.0893 17.5 15.7196C17.5 17.0625 16.9762 18.1116 15.9286 18.867C14.8809 19.6223 13.4335 20 11.5862 20C9.94674 20 8.32335 19.6185 6.71592 18.8555V16.6009C8.23538 17.4783 9.7908 17.917 11.3822 17.917C13.9333 17.917 15.2128 17.1846 15.2208 15.7196C15.2208 15.0939 15.0049 14.5598 14.5731 14.1173C14.5339 14.0772 14.4939 14.0381 14.4531 14H3V12H21V14H17.1538ZM13.076 11H7.62908C7.4566 10.8433 7.29616 10.6692 7.14776 10.4778C6.71592 9.92084 6.5 9.24559 6.5 8.45207C6.5 7.21602 6.96583 6.165 7.89749 5.299C8.82916 4.43299 10.2706 4 12.2219 4C13.6934 4 15.1009 4.32808 16.4444 4.98426V7.13591C15.2448 6.44921 13.9293 6.10587 12.4978 6.10587C10.0187 6.10587 8.77917 6.88793 8.77917 8.45207C8.77917 8.87172 8.99709 9.23796 9.43293 9.55079C9.86878 9.86362 10.4066 10.1135 11.0463 10.3004C11.6665 10.4816 12.3431 10.7148 13.076 11H13.076Z"
  }));
},
    uN = function uN(_ref1964) {
  var _ref1964$color = _ref1964.color,
      C = _ref1964$color === void 0 ? "currentColor" : _ref1964$color,
      _ref1964$size = _ref1964.size,
      e = _ref1964$size === void 0 ? 24 : _ref1964$size,
      l = _ref1964.className,
      i = _objectWithoutProperties(_ref1964, _excluded1964);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11 6V19H9V6H3V4H17V6H11ZM19.5507 16.5803C19.7042 16.4345 19.8 16.2284 19.8 16C19.8 15.5582 19.4418 15.2 19 15.2C18.5582 15.2 18.2 15.5582 18.2 16C18.2 16.0762 18.2107 16.15 18.2306 16.2198L17.0765 16.5496C17.0267 16.375 17 16.1906 17 16C17 14.8954 17.8954 14 19 14C20.1046 14 21 14.8954 21 16C21 16.5727 20.7593 17.0892 20.3735 17.4538L18.7441 19H21V20H17V19L19.5507 16.5803V16.5803Z"
  }));
},
    BN = function BN(_ref1965) {
  var _ref1965$color = _ref1965.color,
      C = _ref1965$color === void 0 ? "currentColor" : _ref1965$color,
      _ref1965$size = _ref1965.size,
      e = _ref1965$size === void 0 ? 24 : _ref1965$size,
      l = _ref1965.className,
      i = _objectWithoutProperties(_ref1965, _excluded1965);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5.59567 4L10.5 9.92831L15.4043 4H18L11.7978 11.4971L18 18.9943V19H15.4091L10.5 13.0659L5.59092 19H3V18.9943L9.20216 11.4971L3 4H5.59567ZM21.8 16C21.8 15.5582 21.4418 15.2 21 15.2C20.5582 15.2 20.2 15.5582 20.2 16C20.2 16.0762 20.2107 16.15 20.2306 16.2198L19.0765 16.5496C19.0267 16.375 19 16.1906 19 16C19 14.8954 19.8954 14 21 14C22.1046 14 23 14.8954 23 16C23 16.5727 22.7593 17.0892 22.3735 17.4538L20.7441 19H23V20H19V19L21.5507 16.5803C21.7042 16.4345 21.8 16.2284 21.8 16Z"
  }));
},
    fN = function fN(_ref1966) {
  var _ref1966$color = _ref1966.color,
      C = _ref1966$color === void 0 ? "currentColor" : _ref1966$color,
      _ref1966$size = _ref1966.size,
      e = _ref1966$size === void 0 ? 24 : _ref1966$size,
      l = _ref1966.className,
      i = _objectWithoutProperties(_ref1966, _excluded1966);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19 11H5V13H19V11Z"
  }));
},
    RN = function RN(_ref1967) {
  var _ref1967$color = _ref1967.color,
      C = _ref1967$color === void 0 ? "currentColor" : _ref1967$color,
      _ref1967$size = _ref1967.size,
      e = _ref1967$size === void 0 ? 24 : _ref1967$size,
      l = _ref1967.className,
      i = _objectWithoutProperties(_ref1967, _excluded1967);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5 11V13H19V11H5Z"
  }));
},
    zN = function zN(_ref1968) {
  var _ref1968$color = _ref1968.color,
      C = _ref1968$color === void 0 ? "currentColor" : _ref1968$color,
      _ref1968$size = _ref1968.size,
      e = _ref1968$size === void 0 ? 24 : _ref1968$size,
      l = _ref1968.className,
      i = _objectWithoutProperties(_ref1968, _excluded1968);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17.2 20L19 21.5V22H5V21.5L6.8 20H5C3.89543 20 3 19.1046 3 18V7C3 4.79086 4.79086 3 7 3H17C19.2091 3 21 4.79086 21 7V18C21 19.1046 20.1046 20 19 20H17.2ZM11 12V5H7C5.89543 5 5 5.89543 5 7V12H11ZM13 12H19V7C19 5.89543 18.1046 5 17 5H13V12ZM7.5 18C8.32843 18 9 17.3284 9 16.5C9 15.6716 8.32843 15 7.5 15C6.67157 15 6 15.6716 6 16.5C6 17.3284 6.67157 18 7.5 18ZM16.5 18C17.3284 18 18 17.3284 18 16.5C18 15.6716 17.3284 15 16.5 15C15.6716 15 15 15.6716 15 16.5C15 17.3284 15.6716 18 16.5 18Z"
  }));
},
    FN = function FN(_ref1969) {
  var _ref1969$color = _ref1969.color,
      C = _ref1969$color === void 0 ? "currentColor" : _ref1969$color,
      _ref1969$size = _ref1969.size,
      e = _ref1969$size === void 0 ? 24 : _ref1969$size,
      l = _ref1969.className,
      i = _objectWithoutProperties(_ref1969, _excluded1969);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17.2 20L19 21.5V22H5V21.5L6.8 20H5C3.89543 20 3 19.1046 3 18V7C3 4.79086 4.79086 3 7 3H17C19.2091 3 21 4.79086 21 7V18C21 19.1046 20.1046 20 19 20H17.2ZM13 5V11H19V7C19 5.89543 18.1046 5 17 5H13ZM11 5H7C5.89543 5 5 5.89543 5 7V11H11V5ZM19 13H5V18H19V13ZM7.5 17C6.67157 17 6 16.3284 6 15.5C6 14.6716 6.67157 14 7.5 14C8.32843 14 9 14.6716 9 15.5C9 16.3284 8.32843 17 7.5 17ZM16.5 17C15.6716 17 15 16.3284 15 15.5C15 14.6716 15.6716 14 16.5 14C17.3284 14 18 14.6716 18 15.5C18 16.3284 17.3284 17 16.5 17Z"
  }));
},
    SN = function SN(_ref1970) {
  var _ref1970$color = _ref1970.color,
      C = _ref1970$color === void 0 ? "currentColor" : _ref1970$color,
      _ref1970$size = _ref1970.size,
      e = _ref1970$size === void 0 ? 24 : _ref1970$size,
      l = _ref1970.className,
      i = _objectWithoutProperties(_ref1970, _excluded1970);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13 3V12H21V18C21 19.1046 20.1046 20 19 20H17.2L19 21.5V22H5V21.5L6.8 20H5C3.89543 20 3 19.1046 3 18V7C3 4.79086 4.79086 3 7 3H13ZM7.5 15C6.67157 15 6 15.6716 6 16.5C6 17.3284 6.67157 18 7.5 18C8.32843 18 9 17.3284 9 16.5C9 15.6716 8.32843 15 7.5 15ZM16.5 15C15.6716 15 15 15.6716 15 16.5C15 17.3284 15.6716 18 16.5 18C17.3284 18 18 17.3284 18 16.5C18 15.6716 17.3284 15 16.5 15ZM11 5H7C5.94564 5 5.08183 5.81588 5.00549 6.85074L5 7V12H11V5ZM18.5 1C20.9853 1 23 3.01472 23 5.5C23 7.98528 20.9853 10 18.5 10C16.0147 10 14 7.98528 14 5.5C14 3.01472 16.0147 1 18.5 1ZM18.4998 6.16667C18.0089 6.16667 17.5593 6.34354 17.2113 6.63704L17.0856 6.75245L18.4998 8.16667L19.9131 6.7515C19.5512 6.39013 19.0516 6.16667 18.4998 6.16667ZM18.4998 3.5C17.2966 3.5 16.1998 3.95536 15.3722 4.70316L15.199 4.86781L16.1428 5.80964C16.746 5.20643 17.5794 4.83333 18.4998 4.83333C19.3436 4.83333 20.1141 5.14684 20.7013 5.66372L20.8569 5.80964L21.7997 4.86684C20.9552 4.02233 19.7885 3.5 18.4998 3.5Z"
  }));
},
    AN = function AN(_ref1971) {
  var _ref1971$color = _ref1971.color,
      C = _ref1971$color === void 0 ? "currentColor" : _ref1971$color,
      _ref1971$size = _ref1971.size,
      e = _ref1971$size === void 0 ? 24 : _ref1971$size,
      l = _ref1971.className,
      i = _objectWithoutProperties(_ref1971, _excluded1971);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 18C21 19.1046 20.1046 20 19 20H17.2L19 21.5V22H5V21.5L6.8 20H5C3.89543 20 3 19.1046 3 18V7C3 4.79086 4.79086 3 7 3H13V11H21V18ZM19 13H5V18H19V13ZM7.5 14C8.32843 14 9 14.6716 9 15.5C9 16.3284 8.32843 17 7.5 17C6.67157 17 6 16.3284 6 15.5C6 14.6716 6.67157 14 7.5 14ZM16.5 14C17.3284 14 18 14.6716 18 15.5C18 16.3284 17.3284 17 16.5 17C15.6716 17 15 16.3284 15 15.5C15 14.6716 15.6716 14 16.5 14ZM11 5H7C5.94564 5 5.08183 5.81588 5.00549 6.85074L5 7V11H11V5ZM18.5 1C20.9853 1 23 3.01472 23 5.5C23 7.98528 20.9853 10 18.5 10C16.0147 10 14 7.98528 14 5.5C14 3.01472 16.0147 1 18.5 1ZM18.4998 6.16667C18.0089 6.16667 17.5593 6.34354 17.2113 6.63704L17.0856 6.75245L18.4998 8.16667L19.9131 6.7515C19.5512 6.39013 19.0516 6.16667 18.4998 6.16667ZM18.4998 3.5C17.2966 3.5 16.1998 3.95536 15.3722 4.70316L15.199 4.86781L16.1428 5.80964C16.746 5.20643 17.5794 4.83333 18.4998 4.83333C19.3436 4.83333 20.1141 5.14684 20.7013 5.66372L20.8569 5.80964L21.7997 4.86684C20.9552 4.02233 19.7885 3.5 18.4998 3.5Z"
  }));
},
    kN = function kN(_ref1972) {
  var _ref1972$color = _ref1972.color,
      C = _ref1972$color === void 0 ? "currentColor" : _ref1972$color,
      _ref1972$size = _ref1972.size,
      e = _ref1972$size === void 0 ? 24 : _ref1972$size,
      l = _ref1972.className,
      i = _objectWithoutProperties(_ref1972, _excluded1972);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18 23H16V22H8V23H6V22H5C3.89543 22 3 21.1046 3 20V7C3 5.89543 3.89543 5 5 5H8V3C8 2.44772 8.44772 2 9 2H15C15.5523 2 16 2.44772 16 3V5H19C20.1046 5 21 5.89543 21 7V20C21 21.1046 20.1046 22 19 22H18V23ZM10 9H8V18H10V9ZM16 9H14V18H16V9ZM14 4H10V5H14V4Z"
  }));
},
    PN = function PN(_ref1973) {
  var _ref1973$color = _ref1973.color,
      C = _ref1973$color === void 0 ? "currentColor" : _ref1973$color,
      _ref1973$size = _ref1973.size,
      e = _ref1973$size === void 0 ? 24 : _ref1973$size,
      l = _ref1973.className,
      i = _objectWithoutProperties(_ref1973, _excluded1973);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18 23H16V22H8V23H6V22H5C3.89543 22 3 21.1046 3 20V7C3 5.89543 3.89543 5 5 5H8V3C8 2.44772 8.44772 2 9 2H15C15.5523 2 16 2.44772 16 3V5H19C20.1046 5 21 5.89543 21 7V20C21 21.1046 20.1046 22 19 22H18V23ZM19 7H5V20H19V7ZM10 9V18H8V9H10ZM16 9V18H14V9H16ZM14 4H10V5H14V4Z"
  }));
},
    DN = function DN(_ref1974) {
  var _ref1974$color = _ref1974.color,
      C = _ref1974$color === void 0 ? "currentColor" : _ref1974$color,
      _ref1974$size = _ref1974.size,
      e = _ref1974$size === void 0 ? 24 : _ref1974$size,
      l = _ref1974.className,
      i = _objectWithoutProperties(_ref1974, _excluded1974);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15 1C15.5523 1 16 1.44772 16 2V7H17V6H19V7H20C20.5523 7 21 7.44772 21 8V20C21 20.5523 20.5523 21 20 21H19V22H17V21H7V22H5V21H4C3.44772 21 3 20.5523 3 20V8C3 7.44772 3.44772 7 4 7H5V6H7V7H8V2C8 1.44772 8.44772 1 9 1H15ZM9 10H7V18H9V10ZM13 10H11V18H13V10ZM17 10H15V18H17V10ZM14 3H10V7H14V3Z"
  }));
},
    yN = function yN(_ref1975) {
  var _ref1975$color = _ref1975.color,
      C = _ref1975$color === void 0 ? "currentColor" : _ref1975$color,
      _ref1975$size = _ref1975.size,
      e = _ref1975$size === void 0 ? 24 : _ref1975$size,
      l = _ref1975.className,
      i = _objectWithoutProperties(_ref1975, _excluded1975);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15 1C15.5523 1 16 1.44772 16 2V7H17V6H19V7H20C20.5523 7 21 7.44772 21 8V20C21 20.5523 20.5523 21 20 21H19V22H17V21H7V22H5V21H4C3.44772 21 3 20.5523 3 20V8C3 7.44772 3.44772 7 4 7H5V6H7V7H8V2C8 1.44772 8.44772 1 9 1H15ZM19 9H5V19H19V9ZM9 10V18H7V10H9ZM13 10V18H11V10H13ZM17 10V18H15V10H17ZM14 3H10V7H14V3Z"
  }));
},
    bN = function bN(_ref1976) {
  var _ref1976$color = _ref1976.color,
      C = _ref1976$color === void 0 ? "currentColor" : _ref1976$color,
      _ref1976$size = _ref1976.size,
      e = _ref1976$size === void 0 ? 24 : _ref1976$size,
      l = _ref1976.className,
      i = _objectWithoutProperties(_ref1976, _excluded1976);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15 3C15.5523 3 16 3.44772 16 4V6H21C21.5523 6 22 6.44772 22 7V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V7C2 6.44772 2.44772 6 3 6H8V4C8 3.44772 8.44772 3 9 3H15ZM8 8H6V19H8V8ZM18 8H16V19H18V8ZM14 5H10V6H14V5Z"
  }));
},
    TN = function TN(_ref1977) {
  var _ref1977$color = _ref1977.color,
      C = _ref1977$color === void 0 ? "currentColor" : _ref1977$color,
      _ref1977$size = _ref1977.size,
      e = _ref1977$size === void 0 ? 24 : _ref1977$size,
      l = _ref1977.className,
      i = _objectWithoutProperties(_ref1977, _excluded1977);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15 3C15.5523 3 16 3.44772 16 4V6H21C21.5523 6 22 6.44772 22 7V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V7C2 6.44772 2.44772 6 3 6H8V4C8 3.44772 8.44772 3 9 3H15ZM16 8H8V19H16V8ZM4 8V19H6V8H4ZM14 5H10V6H14V5ZM18 8V19H20V8H18Z"
  }));
},
    UN = function UN(_ref1978) {
  var _ref1978$color = _ref1978.color,
      C = _ref1978$color === void 0 ? "currentColor" : _ref1978$color,
      _ref1978$size = _ref1978.size,
      e = _ref1978$size === void 0 ? 24 : _ref1978$size,
      l = _ref1978.className,
      i = _objectWithoutProperties(_ref1978, _excluded1978);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9.98392 5.05991C11.1323 3.22236 13.1734 2 15.5 2C19.0899 2 22 4.91015 22 8.5C22 9.58031 21.7365 10.5991 21.2701 11.4955C22.3351 12.4985 23 13.9216 23 15.5C23 18.5376 20.5376 21 17.5 21H9C4.58172 21 1 17.4183 1 13C1 8.58172 4.58172 5 9 5C9.33312 5 9.66149 5.02036 9.98392 5.05991ZM12.0554 5.60419C14.0675 6.43637 15.6662 8.06578 16.4576 10.0986C16.7951 10.0339 17.1436 10 17.5 10C18.2351 10 18.9366 10.1442 19.5776 10.4059C19.8486 9.82719 20 9.18128 20 8.5C20 6.01472 17.9853 4 15.5 4C14.1177 4 12.8809 4.6233 12.0554 5.60419Z"
  }));
},
    GN = function GN(_ref1979) {
  var _ref1979$color = _ref1979.color,
      C = _ref1979$color === void 0 ? "currentColor" : _ref1979$color,
      _ref1979$size = _ref1979.size,
      e = _ref1979$size === void 0 ? 24 : _ref1979$size,
      l = _ref1979.className,
      i = _objectWithoutProperties(_ref1979, _excluded1979);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9.98392 5.05991C11.1323 3.22236 13.1734 2 15.5 2C19.0899 2 22 4.91015 22 8.5C22 9.58031 21.7365 10.5991 21.2701 11.4955C22.3351 12.4985 23 13.9216 23 15.5C23 18.5376 20.5376 21 17.5 21H9C4.58172 21 1 17.4183 1 13C1 8.58172 4.58172 5 9 5C9.33312 5 9.66149 5.02036 9.98392 5.05991ZM12.0554 5.60419C14.0675 6.43637 15.6662 8.06578 16.4576 10.0986C16.7951 10.0339 17.1436 10 17.5 10C18.2351 10 18.9366 10.1442 19.5776 10.4059C19.8486 9.82719 20 9.18128 20 8.5C20 6.01472 17.9853 4 15.5 4C14.1177 4 12.8809 4.6233 12.0554 5.60419ZM17.5 19C19.433 19 21 17.433 21 15.5C21 13.567 19.433 12 17.5 12C16.5205 12 15.6351 12.4023 14.9998 13.0507C14.9999 13.0338 15 13.0169 15 13C15 9.68629 12.3137 7 9 7C5.68629 7 3 9.68629 3 13C3 16.3137 5.68629 19 9 19H17.5Z"
  }));
},
    IN = function IN(_ref1980) {
  var _ref1980$color = _ref1980.color,
      C = _ref1980$color === void 0 ? "currentColor" : _ref1980$color,
      _ref1980$size = _ref1980.size,
      e = _ref1980$size === void 0 ? 24 : _ref1980$size,
      l = _ref1980.className,
      i = _objectWithoutProperties(_ref1980, _excluded1980);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 18C8.68629 18 6 15.3137 6 12C6 8.68629 8.68629 6 12 6C15.3137 6 18 8.68629 18 12C18 15.3137 15.3137 18 12 18ZM11 1H13V4H11V1ZM11 20H13V23H11V20ZM3.51472 4.92893L4.92893 3.51472L7.05025 5.63604L5.63604 7.05025L3.51472 4.92893ZM16.9497 18.364L18.364 16.9497L20.4853 19.0711L19.0711 20.4853L16.9497 18.364ZM19.0711 3.51472L20.4853 4.92893L18.364 7.05025L16.9497 5.63604L19.0711 3.51472ZM5.63604 16.9497L7.05025 18.364L4.92893 20.4853L3.51472 19.0711L5.63604 16.9497ZM23 11V13H20V11H23ZM4 11V13H1V11H4Z"
  }));
},
    WN = function WN(_ref1981) {
  var _ref1981$color = _ref1981.color,
      C = _ref1981$color === void 0 ? "currentColor" : _ref1981$color,
      _ref1981$size = _ref1981.size,
      e = _ref1981$size === void 0 ? 24 : _ref1981$size,
      l = _ref1981.className,
      i = _objectWithoutProperties(_ref1981, _excluded1981);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.34141 14C6.12031 13.3744 6 12.7013 6 12C6 8.68629 8.68629 6 12 6C15.3137 6 18 8.68629 18 12C18 15.3137 15.3137 18 12 18V14H6.34141ZM6 20H15V22H6V20ZM1 11H4V13H1V11ZM2 16H10V18H2V16ZM11 1H13V4H11V1ZM3.51472 4.92893L4.92893 3.51472L7.05025 5.63604L5.63604 7.05025L3.51472 4.92893ZM16.9497 18.364L18.364 16.9497L20.4853 19.0711L19.0711 20.4853L16.9497 18.364ZM19.0711 3.51472L20.4853 4.92893L18.364 7.05025L16.9497 5.63604L19.0711 3.51472ZM23 11V13H20V11H23Z"
  }));
},
    ON = function ON(_ref1982) {
  var _ref1982$color = _ref1982.color,
      C = _ref1982$color === void 0 ? "currentColor" : _ref1982$color,
      _ref1982$size = _ref1982.size,
      e = _ref1982$size === void 0 ? 24 : _ref1982$size,
      l = _ref1982.className,
      i = _objectWithoutProperties(_ref1982, _excluded1982);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8 12H10V14H4V12H6C6 8.68629 8.68629 6 12 6C15.3137 6 18 8.68629 18 12C18 15.3137 15.3137 18 12 18V16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12ZM6 20H15V22H6V20ZM2 16H10V18H2V16ZM11 1H13V4H11V1ZM3.51472 4.92893L4.92893 3.51472L7.05025 5.63604L5.63604 7.05025L3.51472 4.92893ZM16.9497 18.364L18.364 16.9497L20.4853 19.0711L19.0711 20.4853L16.9497 18.364ZM19.0711 3.51472L20.4853 4.92893L18.364 7.05025L16.9497 5.63604L19.0711 3.51472ZM23 11V13H20V11H23Z"
  }));
},
    KN = function KN(_ref1983) {
  var _ref1983$color = _ref1983.color,
      C = _ref1983$color === void 0 ? "currentColor" : _ref1983$color,
      _ref1983$size = _ref1983.size,
      e = _ref1983$size === void 0 ? 24 : _ref1983$size,
      l = _ref1983.className,
      i = _objectWithoutProperties(_ref1983, _excluded1983);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 18C8.68629 18 6 15.3137 6 12C6 8.68629 8.68629 6 12 6C15.3137 6 18 8.68629 18 12C18 15.3137 15.3137 18 12 18ZM12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16ZM11 1H13V4H11V1ZM11 20H13V23H11V20ZM3.51472 4.92893L4.92893 3.51472L7.05025 5.63604L5.63604 7.05025L3.51472 4.92893ZM16.9497 18.364L18.364 16.9497L20.4853 19.0711L19.0711 20.4853L16.9497 18.364ZM19.0711 3.51472L20.4853 4.92893L18.364 7.05025L16.9497 5.63604L19.0711 3.51472ZM5.63604 16.9497L7.05025 18.364L4.92893 20.4853L3.51472 19.0711L5.63604 16.9497ZM23 11V13H20V11H23ZM4 11V13H1V11H4Z"
  }));
},
    QN = function QN(_ref1984) {
  var _ref1984$color = _ref1984.color,
      C = _ref1984$color === void 0 ? "currentColor" : _ref1984$color,
      _ref1984$size = _ref1984.size,
      e = _ref1984$size === void 0 ? 24 : _ref1984$size,
      l = _ref1984.className,
      i = _objectWithoutProperties(_ref1984, _excluded1984);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11 7V20H9V7H3V5H15V7H11ZM19.5507 6.5803C19.7042 6.43453 19.8 6.22845 19.8 6C19.8 5.55817 19.4418 5.2 19 5.2C18.5582 5.2 18.2 5.55817 18.2 6C18.2 6.07624 18.2107 6.14999 18.2306 6.21983L17.0765 6.54958C17.0267 6.37497 17 6.1906 17 6C17 4.89543 17.8954 4 19 4C20.1046 4 21 4.89543 21 6C21 6.57273 20.7593 7.08923 20.3735 7.45384L18.7441 9H21V10H17V9L19.5507 6.5803V6.5803Z"
  }));
},
    qN = function qN(_ref1985) {
  var _ref1985$color = _ref1985.color,
      C = _ref1985$color === void 0 ? "currentColor" : _ref1985$color,
      _ref1985$size = _ref1985.size,
      e = _ref1985$size === void 0 ? 24 : _ref1985$size,
      l = _ref1985.className,
      i = _objectWithoutProperties(_ref1985, _excluded1985);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5.59567 5L10.5 10.9283L15.4043 5H18L11.7978 12.4971L18 19.9943V20H15.4091L10.5 14.0659L5.59092 20H3V19.9943L9.20216 12.4971L3 5H5.59567ZM21.5507 6.5803C21.7042 6.43453 21.8 6.22845 21.8 6C21.8 5.55817 21.4418 5.2 21 5.2C20.5582 5.2 20.2 5.55817 20.2 6C20.2 6.07624 20.2107 6.14999 20.2306 6.21983L19.0765 6.54958C19.0267 6.37497 19 6.1906 19 6C19 4.89543 19.8954 4 21 4C22.1046 4 23 4.89543 23 6C23 6.57273 22.7593 7.08923 22.3735 7.45384L20.7441 9H23V10H19V9L21.5507 6.5803V6.5803Z"
  }));
},
    jN = function jN(_ref1986) {
  var _ref1986$color = _ref1986.color,
      C = _ref1986$color === void 0 ? "currentColor" : _ref1986$color,
      _ref1986$size = _ref1986.size,
      e = _ref1986$size === void 0 ? 24 : _ref1986$size,
      l = _ref1986.className,
      i = _objectWithoutProperties(_ref1986, _excluded1986);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.4851 3.12124L20.2425 5.0606C20.6877 5.1719 21 5.57188 21 6.03075V6.99952L22 6.99997C23.1 6.99997 24 7.89997 24 8.99997V12C24 13.6568 22.6569 15 21 15L20.5789 15.0003C20.0443 16.3501 19.0275 17.4862 17.6833 18.1583L12.8944 20.5528C12.3314 20.8343 11.6686 20.8343 11.1056 20.5528L6.31672 18.1583C4.97252 17.4862 3.95573 16.3501 3.42113 15.0003L3 15C1.34315 15 0 13.6568 0 12V8.99997C0 7.8954 0.89543 6.99997 2 6.99997L3 6.99952V6.03075C3 5.57188 3.3123 5.1719 3.75746 5.0606L11.5149 3.12124C11.8334 3.04162 12.1666 3.04162 12.4851 3.12124ZM3 8.99997H2V12C2 12.5523 2.44772 13 3 13V8.99997ZM22 8.99997H21V13C21.5523 13 22 12.5523 22 12V8.99997Z"
  }));
},
    XN = function XN(_ref1987) {
  var _ref1987$color = _ref1987.color,
      C = _ref1987$color === void 0 ? "currentColor" : _ref1987$color,
      _ref1987$size = _ref1987.size,
      e = _ref1987$size === void 0 ? 24 : _ref1987$size,
      l = _ref1987.className,
      i = _objectWithoutProperties(_ref1987, _excluded1987);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.4851 3.12124L20.2425 5.0606C20.6877 5.1719 21 5.57188 21 6.03075V6.99952L22 6.99997C23.1 6.99997 24 7.89997 24 8.99997V12C24 13.6568 22.6569 15 21 15L20.5789 15.0003C20.0443 16.3501 19.0275 17.4862 17.6833 18.1583L12.8944 20.5528C12.3314 20.8343 11.6686 20.8343 11.1056 20.5528L6.31672 18.1583C4.97252 17.4862 3.95573 16.3501 3.42113 15.0003L3 15C1.34315 15 0 13.6568 0 12V8.99997C0 7.8954 0.89543 6.99997 2 6.99997L3 6.99952V6.03075C3 5.57188 3.3123 5.1719 3.75746 5.0606L11.5149 3.12124C11.8334 3.04162 12.1666 3.04162 12.4851 3.12124ZM12 5.06152L5 6.81152V12.7918C5 14.3069 5.85601 15.6919 7.21115 16.3695L12 18.7639L16.7889 16.3695C18.144 15.6919 19 14.3069 19 12.7918V6.81152L12 5.06152ZM3 8.99997H2V12C2 12.5523 2.44772 13 3 13V8.99997ZM22 8.99997H21V13C21.5523 13 22 12.5523 22 12V8.99997Z"
  }));
},
    JN = function JN(_ref1988) {
  var _ref1988$color = _ref1988.color,
      C = _ref1988$color === void 0 ? "currentColor" : _ref1988$color,
      _ref1988$size = _ref1988.size,
      e = _ref1988$size === void 0 ? 24 : _ref1988$size,
      l = _ref1988.className,
      i = _objectWithoutProperties(_ref1988, _excluded1988);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM7.05025 7.12132C5.7835 8.38807 5 10.1381 5 12.0711C5 14.0041 5.7835 15.7541 7.05025 17.0208L8.46447 15.6066C7.55964 14.7018 7 13.4518 7 12.0711C7 10.6904 7.55964 9.44036 8.46447 8.53553L7.05025 7.12132ZM16.9497 7.12132L15.5355 8.53553C16.4404 9.44036 17 10.6904 17 12.0711C17 13.4518 16.4404 14.7018 15.5355 15.6066L16.9497 17.0208C18.2165 15.7541 19 14.0041 19 12.0711C19 10.1381 18.2165 8.38807 16.9497 7.12132ZM12 15.0711C13.6569 15.0711 15 13.7279 15 12.0711C15 10.4142 13.6569 9.07107 12 9.07107C10.3431 9.07107 9 10.4142 9 12.0711C9 13.7279 10.3431 15.0711 12 15.0711ZM12 13.0711C11.4477 13.0711 11 12.6234 11 12.0711C11 11.5188 11.4477 11.0711 12 11.0711C12.5523 11.0711 13 11.5188 13 12.0711C13 12.6234 12.5523 13.0711 12 13.0711Z"
  }));
},
    YN = function YN(_ref1989) {
  var _ref1989$color = _ref1989.color,
      C = _ref1989$color === void 0 ? "currentColor" : _ref1989$color,
      _ref1989$size = _ref1989.size,
      e = _ref1989$size === void 0 ? 24 : _ref1989$size,
      l = _ref1989.className,
      i = _objectWithoutProperties(_ref1989, _excluded1989);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 5V19H20V5H4ZM3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM7.05025 7.12132L8.46447 8.53553C7.55964 9.44036 7 10.6904 7 12.0711C7 13.4518 7.55964 14.7018 8.46447 15.6066L7.05025 17.0208C5.7835 15.7541 5 14.0041 5 12.0711C5 10.1381 5.7835 8.38807 7.05025 7.12132ZM16.9497 7.12132C18.2165 8.38807 19 10.1381 19 12.0711C19 14.0041 18.2165 15.7541 16.9497 17.0208L15.5355 15.6066C16.4404 14.7018 17 13.4518 17 12.0711C17 10.6904 16.4404 9.44036 15.5355 8.53553L16.9497 7.12132ZM12 13.0711C12.5523 13.0711 13 12.6234 13 12.0711C13 11.5188 12.5523 11.0711 12 11.0711C11.4477 11.0711 11 11.5188 11 12.0711C11 12.6234 11.4477 13.0711 12 13.0711ZM12 15.0711C10.3431 15.0711 9 13.7279 9 12.0711C9 10.4142 10.3431 9.07107 12 9.07107C13.6569 9.07107 15 10.4142 15 12.0711C15 13.7279 13.6569 15.0711 12 15.0711Z"
  }));
},
    _N = function _N(_ref1990) {
  var _ref1990$color = _ref1990.color,
      C = _ref1990$color === void 0 ? "currentColor" : _ref1990$color,
      _ref1990$size = _ref1990.size,
      e = _ref1990$size === void 0 ? 24 : _ref1990$size,
      l = _ref1990.className,
      i = _objectWithoutProperties(_ref1990, _excluded1990);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6 4V8H18V4H20.0066C20.5552 4 21 4.44495 21 4.9934V21.0066C21 21.5552 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5551 3 21.0066V4.9934C3 4.44476 3.44495 4 3.9934 4H6ZM9 17H7V19H9V17ZM9 14H7V16H9V14ZM9 11H7V13H9V11ZM16 2V6H8V2H16Z"
  }));
},
    $N = function $N(_ref1991) {
  var _ref1991$color = _ref1991.color,
      C = _ref1991$color === void 0 ? "currentColor" : _ref1991$color,
      _ref1991$size = _ref1991.size,
      e = _ref1991$size === void 0 ? 24 : _ref1991$size,
      l = _ref1991.className,
      i = _objectWithoutProperties(_ref1991, _excluded1991);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17 2V4H20.0066C20.5552 4 21 4.44495 21 4.9934V21.0066C21 21.5552 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5551 3 21.0066V4.9934C3 4.44476 3.44495 4 3.9934 4H7V2H17ZM7 6H5V20H19V6H17V8H7V6ZM9 16V18H7V16H9ZM9 13V15H7V13H9ZM9 10V12H7V10H9ZM15 4H9V6H15V4Z"
  }));
},
    eu = function eu(_ref1992) {
  var _ref1992$color = _ref1992.color,
      C = _ref1992$color === void 0 ? "currentColor" : _ref1992$color,
      _ref1992$size = _ref1992.size,
      e = _ref1992$size === void 0 ? 24 : _ref1992$size,
      l = _ref1992.className,
      i = _objectWithoutProperties(_ref1992, _excluded1992);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3.00488 3.00275H21.0049C21.5572 3.00275 22.0049 3.45046 22.0049 4.00275V20.0027C22.0049 20.555 21.5572 21.0027 21.0049 21.0027H3.00488C2.4526 21.0027 2.00488 20.555 2.00488 20.0027V4.00275C2.00488 3.45046 2.4526 3.00275 3.00488 3.00275ZM15.0049 7.00275V9.00275H11.0049V11.0027H15.0049V13.0027L18.5049 10.0027L15.0049 7.00275ZM9.00488 17.0027V15.0027H13.0049V13.0027H9.00488V11.0027L5.50488 14.0027L9.00488 17.0027Z"
  }));
},
    tu = function tu(_ref1993) {
  var _ref1993$color = _ref1993.color,
      C = _ref1993$color === void 0 ? "currentColor" : _ref1993$color,
      _ref1993$size = _ref1993.size,
      e = _ref1993$size === void 0 ? 24 : _ref1993$size,
      l = _ref1993.className,
      i = _objectWithoutProperties(_ref1993, _excluded1993);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4.00488 5.00275V19.0027H20.0049V5.00275H4.00488ZM3.00488 3.00275H21.0049C21.5572 3.00275 22.0049 3.45046 22.0049 4.00275V20.0027C22.0049 20.555 21.5572 21.0027 21.0049 21.0027H3.00488C2.4526 21.0027 2.00488 20.555 2.00488 20.0027V4.00275C2.00488 3.45046 2.4526 3.00275 3.00488 3.00275ZM15.0049 7.00275L18.5049 10.0027L15.0049 13.0027V11.0027H11.0049V9.00275H15.0049V7.00275ZM9.00488 17.0027L5.50488 14.0027L9.00488 11.0027V13.0027H13.0049V15.0027H9.00488V17.0027Z"
  }));
},
    Cu = function Cu(_ref1994) {
  var _ref1994$color = _ref1994.color,
      C = _ref1994$color === void 0 ? "currentColor" : _ref1994$color,
      _ref1994$size = _ref1994.size,
      e = _ref1994$size === void 0 ? 24 : _ref1994$size,
      l = _ref1994.className,
      i = _objectWithoutProperties(_ref1994, _excluded1994);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.0049 22.0027C6.48204 22.0027 2.00488 17.5256 2.00488 12.0027C2.00488 6.4799 6.48204 2.00275 12.0049 2.00275C17.5277 2.00275 22.0049 6.4799 22.0049 12.0027C22.0049 17.5256 17.5277 22.0027 12.0049 22.0027ZM7.00488 9.00275H9.00488V13.0027H11.0049V9.00275H13.0049L10.0049 5.50275L7.00488 9.00275ZM17.0049 15.0027H15.0049V11.0027H13.0049V15.0027H11.0049L14.0049 18.5027L17.0049 15.0027Z"
  }));
},
    lu = function lu(_ref1995) {
  var _ref1995$color = _ref1995.color,
      C = _ref1995$color === void 0 ? "currentColor" : _ref1995$color,
      _ref1995$size = _ref1995.size,
      e = _ref1995$size === void 0 ? 24 : _ref1995$size,
      l = _ref1995.className,
      i = _objectWithoutProperties(_ref1995, _excluded1995);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.0049 22.0027C6.48204 22.0027 2.00488 17.5256 2.00488 12.0027C2.00488 6.4799 6.48204 2.00275 12.0049 2.00275C17.5277 2.00275 22.0049 6.4799 22.0049 12.0027C22.0049 17.5256 17.5277 22.0027 12.0049 22.0027ZM12.0049 20.0027C16.4232 20.0027 20.0049 16.421 20.0049 12.0027C20.0049 7.58447 16.4232 4.00275 12.0049 4.00275C7.5866 4.00275 4.00488 7.58447 4.00488 12.0027C4.00488 16.421 7.5866 20.0027 12.0049 20.0027ZM7.00488 9.00275L10.0049 5.50275L13.0049 9.00275H11.0049V13.0027H9.00488V9.00275H7.00488ZM17.0049 15.0027L14.0049 18.5027L11.0049 15.0027H13.0049V11.0027H15.0049V15.0027H17.0049Z"
  }));
},
    iu = function iu(_ref1996) {
  var _ref1996$color = _ref1996.color,
      C = _ref1996$color === void 0 ? "currentColor" : _ref1996$color,
      _ref1996$size = _ref1996.size,
      e = _ref1996$size === void 0 ? 24 : _ref1996$size,
      l = _ref1996.className,
      i = _objectWithoutProperties(_ref1996, _excluded1996);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13.62 21C13.5351 21 13.4786 20.9434 13.4927 20.8727V3.12726C13.4927 3.0707 13.5351 3.01414 13.6058 3.01414H16.3914C18.9366 3.01414 21.001 5.07855 21.001 7.62372V16.3904C21.001 18.9356 18.9366 21 16.3914 21H13.62ZM17.0418 11.0738C16.0379 11.0738 15.2178 11.894 15.2178 12.8979C15.2178 13.9018 16.0379 14.7219 17.0418 14.7219C18.0458 14.7219 18.8659 13.9018 18.8659 12.8979C18.8659 11.894 18.0458 11.0738 17.0418 11.0738ZM5.80066 8.40141C5.80066 7.46819 6.56421 6.70463 7.49744 6.70463C8.43067 6.70463 9.19422 7.46819 9.19422 8.40141C9.19422 9.33464 8.43067 10.0982 7.49744 10.0982C6.56421 10.0982 5.80066 9.33464 5.80066 8.40141ZM11.5414 3C11.6263 3 11.6828 3.05656 11.6687 3.12726V20.8586C11.6687 20.9293 11.6121 20.9859 11.5414 20.9859H7.61056C5.06539 20.9859 3.00098 18.9214 3.00098 16.3763V7.60958C3.00098 5.06441 5.06539 3 7.61056 3H11.5414ZM10.2264 19.5436V4.44226H7.61056C6.76217 4.44226 5.97034 4.78162 5.37647 5.37549C4.76846 5.96936 4.44324 6.76119 4.44324 7.60958V16.3763C4.44324 17.2247 4.78259 18.0165 5.37647 18.6104C5.97034 19.2184 6.76217 19.5436 7.61056 19.5436H10.2264Z"
  }));
},
    su = function su(_ref1997) {
  var _ref1997$color = _ref1997.color,
      C = _ref1997$color === void 0 ? "currentColor" : _ref1997$color,
      _ref1997$size = _ref1997.size,
      e = _ref1997$size === void 0 ? 24 : _ref1997$size,
      l = _ref1997.className,
      i = _objectWithoutProperties(_ref1997, _excluded1997);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.001 3V21H7.60098C5.06047 21 3.00098 18.9405 3.00098 16.4V7.6C3.00098 5.05949 5.06047 3 7.60098 3H12.001ZM10.001 5H7.60098C6.16504 5 5.00098 6.16406 5.00098 7.6V16.4C5.00098 17.8359 6.16504 19 7.60098 19H10.001V5ZM7.50098 10C6.67255 10 6.00098 9.32843 6.00098 8.5C6.00098 7.67157 6.67255 7 7.50098 7C8.3294 7 9.00098 7.67157 9.00098 8.5C9.00098 9.32843 8.3294 10 7.50098 10ZM14.001 3H16.401C18.9415 3 21.001 5.05949 21.001 7.6V16.4C21.001 18.9405 18.9415 21 16.401 21H14.001V3ZM17.001 14.7C17.9951 14.7 18.801 13.8941 18.801 12.9C18.801 11.9059 17.9951 11.1 17.001 11.1C16.0069 11.1 15.201 11.9059 15.201 12.9C15.201 13.8941 16.0069 14.7 17.001 14.7Z"
  }));
},
    ru = function ru(_ref1998) {
  var _ref1998$color = _ref1998.color,
      C = _ref1998$color === void 0 ? "currentColor" : _ref1998$color,
      _ref1998$size = _ref1998.size,
      e = _ref1998$size === void 0 ? 24 : _ref1998$size,
      l = _ref1998.className,
      i = _objectWithoutProperties(_ref1998, _excluded1998);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7.04813 13.4061L10.5831 16.9421L9.1703 18.3558L10.5849 19.7711L9.17064 21.1853L6.69614 18.71L3.86734 21.5388L2.45312 20.1246L5.28192 17.2958L2.80668 14.8213L4.22089 13.4071L5.63477 14.8202L7.04813 13.4061ZM2.99907 3L6.54506 3.00335L18.3624 14.8207L19.7772 13.4071L21.1915 14.8213L18.7166 17.2962L21.545 20.1246L20.1308 21.5388L17.3024 18.7104L14.8275 21.1853L13.4133 19.7711L14.8269 18.3562L3.00181 6.53118L2.99907 3ZM17.4563 3.0001L20.9991 3.00335L21.001 6.52648L16.9481 10.5781L13.4121 7.0431L17.4563 3.0001Z"
  }));
},
    cu = function cu(_ref1999) {
  var _ref1999$color = _ref1999.color,
      C = _ref1999$color === void 0 ? "currentColor" : _ref1999$color,
      _ref1999$size = _ref1999.size,
      e = _ref1999$size === void 0 ? 24 : _ref1999$size,
      l = _ref1999.className,
      i = _objectWithoutProperties(_ref1999, _excluded1999);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17.4563 3L20.9991 3.00335L21.001 6.52648L15.5341 11.992L18.3624 14.8207L19.7772 13.4071L21.1915 14.8213L18.7166 17.2962L21.545 20.1246L20.1308 21.5388L17.3024 18.7104L14.8275 21.1853L13.4133 19.7711L14.8269 18.3562L11.9981 15.528L9.1703 18.3558L10.5849 19.7711L9.17064 21.1853L6.69614 18.71L3.86734 21.5388L2.45312 20.1246L5.28192 17.2958L2.80668 14.8213L4.22089 13.4071L5.63477 14.8202L8.46212 11.992L3.00181 6.53118L2.99907 3L6.54506 3.00335L11.9981 8.457L17.4563 3ZM9.87612 13.406L7.04807 16.234L7.75607 16.941L10.5831 14.113L9.87612 13.406ZM19.0001 5.001H18.2831L13.4121 9.87L14.1191 10.577L19.0001 5.698V5.001ZM5.00007 5.001V5.701L16.2411 16.942L16.9482 16.2349L5.71507 5.002L5.00007 5.001Z"
  }));
},
    ou = function ou(_ref2000) {
  var _ref2000$color = _ref2000.color,
      C = _ref2000$color === void 0 ? "currentColor" : _ref2000$color,
      _ref2000$size = _ref2000.size,
      e = _ref2000$size === void 0 ? 24 : _ref2000$size,
      l = _ref2000.className,
      i = _objectWithoutProperties(_ref2000, _excluded2000);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21.6779 7.97918L20.2637 9.39339L18.1424 7.27207L16.021 9.39339L19.5566 12.9289L18.1424 14.3431L17.4353 13.636L11.0713 20H5.41444L3.29312 22.1213L1.87891 20.7071L4.00023 18.5858V12.9289L10.3642 6.56497L9.65708 5.85786L11.0713 4.44365L14.6068 7.97918L16.7281 5.85786L14.6068 3.73654L16.021 2.32233L21.6779 7.97918ZM9.65708 14.3431L6.82865 11.5147L5.41444 12.9289L8.24287 15.7574L9.65708 14.3431ZM12.4855 11.5147L9.65708 8.68629L8.24287 10.1005L11.0713 12.9289L12.4855 11.5147Z"
  }));
},
    au = function au(_ref2001) {
  var _ref2001$color = _ref2001.color,
      C = _ref2001$color === void 0 ? "currentColor" : _ref2001$color,
      _ref2001$size = _ref2001.size,
      e = _ref2001$size === void 0 ? 24 : _ref2001$size,
      l = _ref2001.className,
      i = _objectWithoutProperties(_ref2001, _excluded2001);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21.6779 7.97918L20.2637 9.39339L18.1424 7.27207L16.021 9.39339L19.5566 12.9289L18.1424 14.3431L17.4353 13.636L11.0713 20H5.41444L3.29312 22.1213L1.87891 20.7071L4.00023 18.5858V12.9289L10.3642 6.56497L9.65708 5.85786L11.0713 4.44365L14.6068 7.97918L16.7281 5.85786L14.6068 3.73654L16.021 2.32233L21.6779 7.97918ZM16.021 12.2218L11.7784 7.97918L10.3642 9.39339L12.4855 11.5147L11.0713 12.9289L8.94997 10.8076L7.53576 12.2218L9.65708 14.3431L8.24287 15.7574L6.12155 13.636L6.00023 13.7574V18H10.2429L16.021 12.2218Z"
  }));
},
    nu = function nu(_ref2002) {
  var _ref2002$color = _ref2002.color,
      C = _ref2002$color === void 0 ? "currentColor" : _ref2002$color,
      _ref2002$size = _ref2002.size,
      e = _ref2002$size === void 0 ? 24 : _ref2002$size,
      l = _ref2002.className,
      i = _objectWithoutProperties(_ref2002, _excluded2002);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17 8H7V10H11V17H13V10H17V8ZM4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3Z"
  }));
},
    mu = function mu(_ref2003) {
  var _ref2003$color = _ref2003.color,
      C = _ref2003$color === void 0 ? "currentColor" : _ref2003$color,
      _ref2003$size = _ref2003.size,
      e = _ref2003$size === void 0 ? 24 : _ref2003$size,
      l = _ref2003.className,
      i = _objectWithoutProperties(_ref2003, _excluded2003);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5 5V19H19V5H5ZM4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM13 10V17H11V10H7V8H17V10H13Z"
  }));
},
    wu = function wu(_ref2004) {
  var _ref2004$color = _ref2004.color,
      C = _ref2004$color === void 0 ? "currentColor" : _ref2004$color,
      _ref2004$size = _ref2004.size,
      e = _ref2004$size === void 0 ? 24 : _ref2004$size,
      l = _ref2004.className,
      i = _objectWithoutProperties(_ref2004, _excluded2004);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.998 3C21.5503 3 21.998 3.44772 21.998 4V11C21.998 11.5523 21.5503 12 20.998 12H18.997L18.998 20C18.998 20.5523 18.5503 21 17.998 21H5.99805C5.44576 21 4.99805 20.5523 4.99805 20L4.99705 11.999L2.99805 12C2.44576 12 1.99805 11.5523 1.99805 11V4C1.99805 3.44772 2.44576 3 2.99805 3H8.99805C8.99805 4.65685 10.3412 6 11.998 6C13.6549 6 14.998 4.65685 14.998 3H20.998Z"
  }));
},
    Lu = function Lu(_ref2005) {
  var _ref2005$color = _ref2005.color,
      C = _ref2005$color === void 0 ? "currentColor" : _ref2005$color,
      _ref2005$size = _ref2005.size,
      e = _ref2005$size === void 0 ? 24 : _ref2005$size,
      l = _ref2005.className,
      i = _objectWithoutProperties(_ref2005, _excluded2005);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8.99805 3C8.99805 4.65685 10.3412 6 11.998 6C13.6549 6 14.998 4.65685 14.998 3H20.998C21.5503 3 21.998 3.44772 21.998 4V11C21.998 11.5523 21.5503 12 20.998 12H18.997L18.998 20C18.998 20.5523 18.5503 21 17.998 21H5.99805C5.44576 21 4.99805 20.5523 4.99805 20L4.99705 11.999L2.99805 12C2.44576 12 1.99805 11.5523 1.99805 11V4C1.99805 3.44772 2.44576 3 2.99805 3H8.99805ZM19.998 4.999H16.581L16.5642 5.04018C15.8115 6.7223 14.1566 7.91251 12.2149 7.99538L11.998 8C9.96331 8 8.21245 6.7846 7.43186 5.04018L7.41405 4.999H3.99805V9.999L6.9968 9.998L6.99705 19H16.998L16.9968 10L19.998 9.999V4.999Z"
  }));
},
    hu = function hu(_ref2006) {
  var _ref2006$color = _ref2006.color,
      C = _ref2006$color === void 0 ? "currentColor" : _ref2006$color,
      _ref2006$size = _ref2006.size,
      e = _ref2006$size === void 0 ? 24 : _ref2006$size,
      l = _ref2006.className,
      i = _objectWithoutProperties(_ref2006, _excluded2006);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.7052 17.7929C13.5319 18.6197 14.2926 19 14.998 19C15.3763 19 15.6782 18.9326 16.2349 18.724L16.6267 18.5715C17.6779 18.151 18.2065 18 18.998 18C20.2117 18 21.3768 18.5446 22.4844 19.5794L22.7052 19.7929L21.2909 21.2071C20.4642 20.3803 19.7035 20 18.998 20C18.6198 20 18.3179 20.0674 17.7612 20.276L17.3694 20.4285C16.3182 20.849 15.7896 21 14.998 21C13.7844 21 12.6193 20.4554 11.5117 19.4206L11.2909 19.2071L12.7052 17.7929ZM8.99805 3C8.99805 4.65685 10.3412 6 11.998 6C13.6549 6 14.998 4.65685 14.998 3H20.998C21.5503 3 21.998 3.44772 21.998 4V11C21.998 11.5523 21.5503 12 20.998 12H11.998C10.9437 12 10.0799 12.8159 10.0035 13.8507L9.99805 14V21H5.99805C5.44576 21 4.99805 20.5523 4.99805 20L4.99705 11.999L2.99805 12C2.44576 12 1.99805 11.5523 1.99805 11V4C1.99805 3.44772 2.44576 3 2.99805 3H8.99805ZM12.7052 13.7929C13.5319 14.6197 14.2926 15 14.998 15C15.3763 15 15.6782 14.9326 16.2349 14.724L16.6267 14.5715C17.6779 14.151 18.2065 14 18.998 14C20.2117 14 21.3768 14.5446 22.4844 15.5794L22.7052 15.7929L21.2909 17.2071C20.4642 16.3803 19.7035 16 18.998 16C18.6198 16 18.3179 16.0674 17.7612 16.276L17.3694 16.4285C16.3182 16.849 15.7896 17 14.998 17C13.7844 17 12.6193 16.4554 11.5117 15.4206L11.2909 15.2071L12.7052 13.7929Z"
  }));
},
    Hu = function Hu(_ref2007) {
  var _ref2007$color = _ref2007.color,
      C = _ref2007$color === void 0 ? "currentColor" : _ref2007$color,
      _ref2007$size = _ref2007.size,
      e = _ref2007$size === void 0 ? 24 : _ref2007$size,
      l = _ref2007.className,
      i = _objectWithoutProperties(_ref2007, _excluded2007);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.7052 17.7929C13.5319 18.6197 14.2926 19 14.998 19C15.3763 19 15.6782 18.9326 16.2349 18.724L16.6267 18.5715C17.6779 18.151 18.2065 18 18.998 18C20.2117 18 21.3768 18.5446 22.4844 19.5794L22.7052 19.7929L21.2909 21.2071C20.4642 20.3803 19.7035 20 18.998 20C18.6198 20 18.3179 20.0674 17.7612 20.276L17.3694 20.4285C16.3182 20.849 15.7896 21 14.998 21C13.7844 21 12.6193 20.4554 11.5117 19.4206L11.2909 19.2071L12.7052 17.7929ZM8.99805 3C8.99805 4.65685 10.3412 6 11.998 6C13.6549 6 14.998 4.65685 14.998 3H20.998C21.5503 3 21.998 3.44772 21.998 4V11C21.998 11.5523 21.5503 12 20.998 12H16.996L16.9968 10L19.998 9.999V4.999H16.581L16.5642 5.04018C15.8115 6.7223 14.1566 7.91251 12.2149 7.99538L11.998 8C9.96331 8 8.21245 6.7846 7.43186 5.04018L7.41405 4.999H3.99805V9.999L6.9968 9.998L6.99705 19H9.99805V21H5.99805C5.44576 21 4.99805 20.5523 4.99805 20L4.99705 11.999L2.99805 12C2.44576 12 1.99805 11.5523 1.99805 11V4C1.99805 3.44772 2.44576 3 2.99805 3H8.99805ZM12.7052 13.7929C13.5319 14.6197 14.2926 15 14.998 15C15.3763 15 15.6782 14.9326 16.2349 14.724L16.6267 14.5715C17.6779 14.151 18.2065 14 18.998 14C20.2117 14 21.3768 14.5446 22.4844 15.5794L22.7052 15.7929L21.2909 17.2071C20.4642 16.3803 19.7035 16 18.998 16C18.6198 16 18.3179 16.0674 17.7612 16.276L17.3694 16.4285C16.3182 16.849 15.7896 17 14.998 17C13.7844 17 12.6193 16.4554 11.5117 15.4206L11.2909 15.2071L12.7052 13.7929Z"
  }));
},
    Vu = function Vu(_ref2008) {
  var _ref2008$color = _ref2008.color,
      C = _ref2008$color === void 0 ? "currentColor" : _ref2008$color,
      _ref2008$size = _ref2008.size,
      e = _ref2008$size === void 0 ? 24 : _ref2008$size,
      l = _ref2008.className,
      i = _objectWithoutProperties(_ref2008, _excluded2008);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14.5135 5.00008L17.1201 2.39348C17.5106 2.00295 18.1438 2.00295 18.5343 2.39348L22.777 6.63612C23.1675 7.02664 23.1675 7.65981 22.777 8.05033L18.9988 11.8285V21.0001C18.9988 21.5524 18.5511 22.0001 17.9988 22.0001H5.9988C5.44652 22.0001 4.9988 21.5524 4.9988 21.0001V11.8285L1.22063 8.05033C0.830103 7.65981 0.830103 7.02664 1.22063 6.63612L5.46327 2.39348C5.85379 2.00295 6.48696 2.00295 6.87748 2.39348L9.48408 5.00008H14.5135Z"
  }));
},
    gu = function gu(_ref2009) {
  var _ref2009$color = _ref2009.color,
      C = _ref2009$color === void 0 ? "currentColor" : _ref2009$color,
      _ref2009$size = _ref2009.size,
      e = _ref2009$size === void 0 ? 24 : _ref2009$size,
      l = _ref2009.className,
      i = _objectWithoutProperties(_ref2009, _excluded2009);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14.5135 5.00008L17.1201 2.39348C17.5106 2.00295 18.1438 2.00295 18.5343 2.39348L22.777 6.63612C23.1675 7.02664 23.1675 7.65981 22.777 8.05033L18.9988 11.8285V21.0001C18.9988 21.5524 18.5511 22.0001 17.9988 22.0001H5.9988C5.44652 22.0001 4.9988 21.5524 4.9988 21.0001V11.8285L1.22063 8.05033C0.830103 7.65981 0.830103 7.02664 1.22063 6.63612L5.46327 2.39348C5.85379 2.00295 6.48696 2.00295 6.87748 2.39348L9.48408 5.00008H14.5135ZM15.3419 7.00008H8.65566L6.17037 4.5148L3.34195 7.34323L6.9988 11.0001V20.0001H16.9988V11.0001L20.6557 7.34323L17.8272 4.5148L15.3419 7.00008Z"
  }));
},
    Mu = function Mu(_ref2010) {
  var _ref2010$color = _ref2010.color,
      C = _ref2010$color === void 0 ? "currentColor" : _ref2010$color,
      _ref2010$size = _ref2010.size,
      e = _ref2010$size === void 0 ? 24 : _ref2010$size,
      l = _ref2010.className,
      i = _objectWithoutProperties(_ref2010, _excluded2010);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13 10V14H19V10H13ZM11 10H5V14H11V10ZM13 19H19V16H13V19ZM11 19V16H5V19H11ZM13 5V8H19V5H13ZM11 5H5V8H11V5ZM4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3Z"
  }));
},
    Zu = function Zu(_ref2011) {
  var _ref2011$color = _ref2011.color,
      C = _ref2011$color === void 0 ? "currentColor" : _ref2011$color,
      _ref2011$size = _ref2011.size,
      e = _ref2011$size === void 0 ? 24 : _ref2011$size,
      l = _ref2011.className,
      i = _objectWithoutProperties(_ref2011, _excluded2011);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7 14V3H3C2.44772 3 2 3.44772 2 4V14H7ZM15 14V3H9V14H15ZM22 14V4C22 3.44772 21.5523 3 21 3H17V14H22ZM21 21C21.5523 21 22 20.5523 22 20V16H2V20C2 20.5523 2.44772 21 3 21H21Z"
  }));
},
    xu = function xu(_ref2012) {
  var _ref2012$color = _ref2012.color,
      C = _ref2012$color === void 0 ? "currentColor" : _ref2012$color,
      _ref2012$size = _ref2012.size,
      e = _ref2012$size === void 0 ? 24 : _ref2012$size,
      l = _ref2012.className,
      i = _objectWithoutProperties(_ref2012, _excluded2012);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 3C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21ZM20 16H4V19H20V16ZM8 5H4V14H8V5ZM14 5H10V14H14V5ZM20 5H16V14H20V5Z"
  }));
},
    vu = function vu(_ref2013) {
  var _ref2013$color = _ref2013.color,
      C = _ref2013$color === void 0 ? "currentColor" : _ref2013$color,
      _ref2013$size = _ref2013.size,
      e = _ref2013$size === void 0 ? 24 : _ref2013$size,
      l = _ref2013.className,
      i = _objectWithoutProperties(_ref2013, _excluded2013);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15 21H9V10H15V21ZM17 21V10H22V20C22 20.5523 21.5523 21 21 21H17ZM7 21H3C2.44772 21 2 20.5523 2 20V10H7V21ZM22 8H2V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V8Z"
  }));
},
    du = function du(_ref2014) {
  var _ref2014$color = _ref2014.color,
      C = _ref2014$color === void 0 ? "currentColor" : _ref2014$color,
      _ref2014$size = _ref2014.size,
      e = _ref2014$size === void 0 ? 24 : _ref2014$size,
      l = _ref2014.className,
      i = _objectWithoutProperties(_ref2014, _excluded2014);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 8H20V5H4V8ZM14 19V10H10V19H14ZM16 19H20V10H16V19ZM8 19V10H4V19H8ZM3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3Z"
  }));
},
    pu = function pu(_ref2015) {
  var _ref2015$color = _ref2015.color,
      C = _ref2015$color === void 0 ? "currentColor" : _ref2015$color,
      _ref2015$size = _ref2015.size,
      e = _ref2015$size === void 0 ? 24 : _ref2015$size,
      l = _ref2015.className,
      i = _objectWithoutProperties(_ref2015, _excluded2015);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5 2H19C19.5523 2 20 2.44772 20 3V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V3C4 2.44772 4.44772 2 5 2ZM12 17C11.4477 17 11 17.4477 11 18C11 18.5523 11.4477 19 12 19C12.5523 19 13 18.5523 13 18C13 17.4477 12.5523 17 12 17Z"
  }));
},
    Eu = function Eu(_ref2016) {
  var _ref2016$color = _ref2016.color,
      C = _ref2016$color === void 0 ? "currentColor" : _ref2016$color,
      _ref2016$size = _ref2016.size,
      e = _ref2016$size === void 0 ? 24 : _ref2016$size,
      l = _ref2016.className,
      i = _objectWithoutProperties(_ref2016, _excluded2016);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6 4V20H18V4H6ZM5 2H19C19.5523 2 20 2.44772 20 3V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V3C4 2.44772 4.44772 2 5 2ZM12 17C12.5523 17 13 17.4477 13 18C13 18.5523 12.5523 19 12 19C11.4477 19 11 18.5523 11 18C11 17.4477 11.4477 17 12 17Z"
  }));
},
    Nu = function Nu(_ref2017) {
  var _ref2017$color = _ref2017.color,
      C = _ref2017$color === void 0 ? "currentColor" : _ref2017$color,
      _ref2017$size = _ref2017.size,
      e = _ref2017$size === void 0 ? 24 : _ref2017$size,
      l = _ref2017.className,
      i = _objectWithoutProperties(_ref2017, _excluded2017);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16 1C16.5523 1 17 1.44772 17 2V2.999L22 3V9L19.98 8.999L22.7467 16.5953C22.9105 17.032 23 17.5051 23 17.999C23 20.2082 21.2091 21.999 19 21.999C17.1368 21.999 15.5711 20.7251 15.1265 19.0008L10.8738 19.0008C10.4295 20.7256 8.86357 22 7 22C5.05513 22 3.43445 20.612 3.07453 18.7725C2.43558 18.439 2 17.7704 2 17V12H11C11 12.5128 11.386 12.9355 11.8834 12.9933L12 13H14C14.5128 13 14.9355 12.614 14.9933 12.1166L15 12V3H12V1H16ZM7 16C5.89543 16 5 16.8954 5 18C5 19.1046 5.89543 20 7 20C8.10457 20 9 19.1046 9 18C9 16.8954 8.10457 16 7 16ZM19 16C17.8954 16 17 16.8954 17 18C17 19.1046 17.8954 20 19 20C20.1046 20 21 19.1046 21 18C21 16.8954 20.1046 16 19 16ZM10 3C10.5523 3 11 3.44772 11 4V11H2V4C2 3.44772 2.44772 3 3 3H10ZM20 5H17V7H20V5ZM9 5H4V6H9V5Z"
  }));
},
    uu = function uu(_ref2018) {
  var _ref2018$color = _ref2018.color,
      C = _ref2018$color === void 0 ? "currentColor" : _ref2018$color,
      _ref2018$size = _ref2018.size,
      e = _ref2018$size === void 0 ? 24 : _ref2018$size,
      l = _ref2018.className,
      i = _objectWithoutProperties(_ref2018, _excluded2018);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16 1C16.5523 1 17 1.44772 17 2V2.999L22 3V9L19.98 8.999L22.7467 16.5953C22.9105 17.032 23 17.5051 23 17.999C23 20.2082 21.2091 21.999 19 21.999C17.1368 21.999 15.5711 20.7251 15.1265 19.0008L10.8738 19.0008C10.4295 20.7256 8.86357 22 7 22C5.05513 22 3.43445 20.612 3.07453 18.7725C2.43558 18.439 2 17.7704 2 17V4C2 3.44772 2.44772 3 3 3H10C10.5523 3 11 3.44772 11 4V12C11 12.5128 11.386 12.9355 11.8834 12.9933L12 13H14C14.5128 13 14.9355 12.614 14.9933 12.1166L15 12V3H12V1H16ZM7 16C5.89543 16 5 16.8954 5 18C5 19.1046 5.89543 20 7 20C8.10457 20 9 19.1046 9 18C9 16.8954 8.10457 16 7 16ZM19 15.999C17.8954 15.999 17 16.8944 17 17.999C17 19.1036 17.8954 19.999 19 19.999C20.1046 19.999 21 19.1036 21 17.999C21 16.8944 20.1046 15.999 19 15.999ZM17.852 8.999H17V12C17 13.6569 15.6569 15 14 15H12C10.6941 15 9.58312 14.1656 9.17102 13.0009L3.99994 13V15.3542C4.73289 14.5238 5.80528 14 7 14C8.86393 14 10.4301 15.2749 10.874 17.0003H15.1257C15.5693 15.2744 17.1357 13.999 19 13.999C19.2373 13.999 19.4697 14.0197 19.6957 14.0593L17.852 8.999ZM9 8H4V11H9V8ZM20 5H17V7H20V5ZM9 5H4V6H9V5Z"
  }));
},
    Bu = function Bu(_ref2019) {
  var _ref2019$color = _ref2019.color,
      C = _ref2019$color === void 0 ? "currentColor" : _ref2019$color,
      _ref2019$size = _ref2019.size,
      e = _ref2019$size === void 0 ? 24 : _ref2019$size,
      l = _ref2019.className,
      i = _objectWithoutProperties(_ref2019, _excluded2019);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3.57626 8.27675L2.38292 10.1192L4.58416 11.4899C4.58416 11.4899 6.04762 12.2438 5.34613 13.6589C4.69704 14.9974 1.5 17.9284 1.5 17.9284L4.36242 19.7264C6.34596 15.4006 6.21292 15.9771 6.7088 14.4209C7.22081 12.8405 7.3337 11.627 6.46691 10.7441C5.35419 9.61926 5.22921 9.51444 3.57626 8.27675ZM5.14052 7.58332C6.18067 7.58332 7.02327 6.82538 7.02327 5.89005C7.02327 4.94666 6.18067 4.18872 5.14052 4.18872C4.09231 4.18872 3.25374 4.95069 3.25374 5.89005C3.25777 6.82135 4.09231 7.58332 5.14052 7.58332ZM22.1457 7.79296C22.1457 7.79296 21.5208 2.92281 10.9379 5.93843C11.3935 5.14421 11.6072 4.6322 11.6072 4.6322L8.96649 3.88232C8.96649 3.88232 7.89812 7.3898 5.99521 9.02259C5.99521 9.02259 7.84168 10.095 7.82152 10.0627C8.34966 9.53057 8.82538 8.99034 9.22854 8.46623C9.65186 8.27675 10.059 8.10339 10.4541 7.94213C9.96229 8.82907 9.17613 10.1595 8.38594 10.9981L9.49866 11.9818C9.49866 11.9818 10.2606 11.244 11.0871 10.3611H12.0305V11.9979H8.34562V13.3041H12.0305V16.4367L11.8894 16.4326C11.4822 16.4125 10.8533 16.3439 10.6033 15.9488C10.305 15.4651 10.5267 14.5902 10.5388 14.0459H7.99488L7.90215 14.0984C7.90215 14.0984 6.96682 18.3033 10.5912 18.2106C13.9777 18.3033 15.921 17.2551 16.8563 16.5334L17.2272 17.9284L19.3156 17.0454L17.9005 13.5622L16.2072 14.0984L16.5217 15.2877C16.0943 15.6183 15.5904 15.8602 15.0542 16.0416V13.3041H18.6463V11.9939H15.0542V10.357H18.6584V9.05081H12.2482C12.7118 8.48236 13.0706 7.96228 13.1674 7.63573L12.0466 7.32933C16.8442 5.59575 19.5171 5.89408 19.497 8.73232V16.2069C19.497 16.2069 19.7792 18.771 16.8603 18.5895L15.2799 18.2468L14.9131 19.7587C14.9131 19.7587 21.7305 21.7261 22.2868 16.4447C22.8392 11.1634 22.1457 7.79296 22.1457 7.79296Z"
  }));
},
    fu = function fu(_ref2020) {
  var _ref2020$color = _ref2020.color,
      C = _ref2020$color === void 0 ? "currentColor" : _ref2020$color,
      _ref2020$size = _ref2020.size,
      e = _ref2020$size === void 0 ? 24 : _ref2020$size,
      l = _ref2020.className,
      i = _objectWithoutProperties(_ref2020, _excluded2020);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17.1727 13.9999H14.5011V15.3754C15.0503 15.1534 15.6538 14.8841 16.3132 14.5649C16.2861 14.4868 16.2586 14.4074 16.2306 14.3266L17.1727 13.9999ZM18.0011 13.7127L18.1202 13.6713C18.762 15.5221 19.1553 16.6828 19.3059 17.1716L17.3945 17.7604C17.3205 17.5201 17.1778 17.0885 16.9672 16.4682C10.8856 19.3524 8.29581 18.5224 7.95943 14.5605L9.95226 14.3913C10.0512 15.5564 10.2958 16.0124 10.8486 16.1431C11.2419 16.2361 11.7895 16.2063 12.5011 16.0387V13.9999H9.00108V11.9999H9.51418L8.34713 10.6098C9.39046 9.73389 10.2047 8.78007 10.7955 7.74628C10.2773 7.88065 9.75799 8.02599 9.24396 8.18095C8.70907 8.96474 8.12459 9.66791 7.49009 10.2898L6.09012 8.86151C7.36251 7.61436 8.42283 5.95255 9.26582 3.86768L11.12 4.61738C10.9669 4.99606 10.8067 5.36325 10.6394 5.71891C14.3425 4.78342 17.9154 4.40172 19.7784 5.03888C21.0008 5.45698 21.6968 6.43023 21.9655 7.62301C22.1357 8.37871 22.2785 10.3119 22.2785 12.7455C22.2785 15.5532 22.2225 16.5166 21.9385 17.3676C21.6414 18.2577 21.2416 18.7856 20.5308 19.3518C19.874 19.8749 18.9779 20.115 17.8864 20.175C17.213 20.212 16.5177 20.1775 15.7915 20.0958C15.6722 20.0824 15.5574 20.0683 15.4372 20.0526C15.3685 20.0436 15.2944 20.0336 15.195 20.0202L15.4588 18.0377C15.5638 18.0519 15.6325 18.0611 15.6962 18.0695C15.8053 18.0837 15.9084 18.0964 16.0149 18.1083C16.6398 18.1786 17.2313 18.208 17.7767 18.178C18.4915 18.1387 19.0222 17.9965 19.2848 17.7874C19.7107 17.4481 19.8761 17.2298 20.0414 16.7344C20.2266 16.1795 20.2785 15.286 20.2785 12.7455C20.2785 10.4473 20.1453 8.64365 20.0144 8.06259C19.8845 7.48621 19.6032 7.09269 19.1312 6.93126C17.9245 6.51856 15.3297 6.73704 12.4792 7.34744L13.0936 7.60982C12.9644 7.91233 12.8213 8.20904 12.6645 8.49993H18.0011V10.4999H14.5011V11.9999H18.0011V13.7127ZM12.5011 10.4999H11.2926C10.8487 11.0233 10.3508 11.5234 9.79935 11.9999H12.5011V10.4999ZM2.4625 10.0616L3.53965 8.37644C4.602 9.05549 6.47526 10.8035 6.87794 11.538C8.1167 13.7975 7.07554 15.7136 3.75606 19.5354L2.24609 18.2239C4.9334 15.1299 5.74623 13.6341 5.12421 12.4995C4.91013 12.109 3.26737 10.5761 2.4625 10.0616ZM5.14134 7.58334C4.09313 7.58334 3.25859 6.82137 3.25456 5.89007C3.25456 4.95071 4.09313 4.18875 5.14134 4.18875C6.18149 4.18875 7.02409 4.94668 7.02409 5.89007C7.02409 6.8254 6.18149 7.58334 5.14134 7.58334Z"
  }));
},
    Ru = function Ru(_ref2021) {
  var _ref2021$color = _ref2021.color,
      C = _ref2021$color === void 0 ? "currentColor" : _ref2021$color,
      _ref2021$size = _ref2021.size,
      e = _ref2021$size === void 0 ? 24 : _ref2021$size,
      l = _ref2021.className,
      i = _objectWithoutProperties(_ref2021, _excluded2021);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10.8293 13C10.9398 12.6872 11 12.3506 11 12C11 10.3431 9.65685 9 8 9C6.34315 9 5 10.3431 5 12C5 13.6569 6.34315 15 8 15H16C17.6569 15 19 13.6569 19 12C19 10.3431 17.6569 9 16 9C14.3431 9 13 10.3431 13 12C13 12.3506 13.0602 12.6872 13.1707 13H10.8293ZM3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM16 13C15.4477 13 15 12.5523 15 12C15 11.4477 15.4477 11 16 11C16.5523 11 17 11.4477 17 12C17 12.5523 16.5523 13 16 13ZM8 13C7.44772 13 7 12.5523 7 12C7 11.4477 7.44772 11 8 11C8.55228 11 9 11.4477 9 12C9 12.5523 8.55228 13 8 13Z"
  }));
},
    zu = function zu(_ref2022) {
  var _ref2022$color = _ref2022.color,
      C = _ref2022$color === void 0 ? "currentColor" : _ref2022$color,
      _ref2022$size = _ref2022.size,
      e = _ref2022$size === void 0 ? 24 : _ref2022$size,
      l = _ref2022.className,
      i = _objectWithoutProperties(_ref2022, _excluded2022);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10.8293 13H13.1707C13.0602 12.6872 13 12.3506 13 12C13 10.3431 14.3431 9 16 9C17.6569 9 19 10.3431 19 12C19 13.6569 17.6569 15 16 15H8C6.34315 15 5 13.6569 5 12C5 10.3431 6.34315 9 8 9C9.65685 9 11 10.3431 11 12C11 12.3506 10.9398 12.6872 10.8293 13ZM4 5V19H20V5H4ZM3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM8 13C8.55228 13 9 12.5523 9 12C9 11.4477 8.55228 11 8 11C7.44772 11 7 11.4477 7 12C7 12.5523 7.44772 13 8 13ZM16 13C16.5523 13 17 12.5523 17 12C17 11.4477 16.5523 11 16 11C15.4477 11 15 11.4477 15 12C15 12.5523 15.4477 13 16 13Z"
  }));
},
    Fu = function Fu(_ref2023) {
  var _ref2023$color = _ref2023.color,
      C = _ref2023$color === void 0 ? "currentColor" : _ref2023$color,
      _ref2023$size = _ref2023.size,
      e = _ref2023$size === void 0 ? 24 : _ref2023$size,
      l = _ref2023.className,
      i = _objectWithoutProperties(_ref2023, _excluded2023);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 3V21.0082C21 21.556 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918C3 2.44405 3.44495 2 3.9934 2H20C20.5523 2 21 2.44772 21 3ZM11.2929 13.1213L8.81802 10.6464L7.40381 12.0607L11.2929 15.9497L16.9497 10.2929L15.5355 8.87868L11.2929 13.1213Z"
  }));
},
    Su = function Su(_ref2024) {
  var _ref2024$color = _ref2024.color,
      C = _ref2024$color === void 0 ? "currentColor" : _ref2024$color,
      _ref2024$size = _ref2024.size,
      e = _ref2024$size === void 0 ? 24 : _ref2024$size,
      l = _ref2024.className,
      i = _objectWithoutProperties(_ref2024, _excluded2024);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19 4H5V20H19V4ZM3 2.9918C3 2.44405 3.44749 2 3.9985 2H19.9997C20.5519 2 20.9996 2.44772 20.9997 3L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918ZM11.2929 13.1213L15.5355 8.87868L16.9497 10.2929L11.2929 15.9497L7.40381 12.0607L8.81802 10.6464L11.2929 13.1213Z"
  }));
},
    Au = function Au(_ref2025) {
  var _ref2025$color = _ref2025.color,
      C = _ref2025$color === void 0 ? "currentColor" : _ref2025$color,
      _ref2025$size = _ref2025.size,
      e = _ref2025$size === void 0 ? 24 : _ref2025$size,
      l = _ref2025.className,
      i = _objectWithoutProperties(_ref2025, _excluded2025);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22 12V21C22 21.5523 21.5523 22 21 22H20C19.4477 22 19 21.5523 19 21V20H5V21C5 21.5523 4.55228 22 4 22H3C2.44772 22 2 21.5523 2 21V12L4.4805 6.21216C4.79566 5.47679 5.51874 5 6.31879 5H9V3H15V5H17.6812C18.4813 5 19.2043 5.47679 19.5195 6.21216L22 12ZM4.17594 12H19.8241L17.6812 7H6.31879L4.17594 12ZM6.5 17C7.32843 17 8 16.3284 8 15.5C8 14.6716 7.32843 14 6.5 14C5.67157 14 5 14.6716 5 15.5C5 16.3284 5.67157 17 6.5 17ZM17.5 17C18.3284 17 19 16.3284 19 15.5C19 14.6716 18.3284 14 17.5 14C16.6716 14 16 14.6716 16 15.5C16 16.3284 16.6716 17 17.5 17Z"
  }));
},
    ku = function ku(_ref2026) {
  var _ref2026$color = _ref2026.color,
      C = _ref2026$color === void 0 ? "currentColor" : _ref2026$color,
      _ref2026$size = _ref2026.size,
      e = _ref2026$size === void 0 ? 24 : _ref2026$size,
      l = _ref2026.className,
      i = _objectWithoutProperties(_ref2026, _excluded2026);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22 11V21C22 21.5523 21.5523 22 21 22H20C19.4477 22 19 21.5523 19 21V20H5V21C5 21.5523 4.55228 22 4 22H3C2.44772 22 2 21.5523 2 21V11L4.44721 6.10557C4.786 5.428 5.47852 5 6.23607 5H9V3H15V5H17.7639C18.5215 5 19.214 5.428 19.5528 6.10557L22 11ZM20 13H4V18H20V13ZM4.23607 11H19.7639L17.7639 7H6.23607L4.23607 11ZM6.5 17C5.67157 17 5 16.3284 5 15.5C5 14.6716 5.67157 14 6.5 14C7.32843 14 8 14.6716 8 15.5C8 16.3284 7.32843 17 6.5 17ZM17.5 17C16.6716 17 16 16.3284 16 15.5C16 14.6716 16.6716 14 17.5 14C18.3284 14 19 14.6716 19 15.5C19 16.3284 18.3284 17 17.5 17Z"
  }));
},
    Pu = function Pu(_ref2027) {
  var _ref2027$color = _ref2027.color,
      C = _ref2027$color === void 0 ? "currentColor" : _ref2027$color,
      _ref2027$size = _ref2027.size,
      e = _ref2027$size === void 0 ? 24 : _ref2027$size,
      l = _ref2027.className,
      i = _objectWithoutProperties(_ref2027, _excluded2027);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 3V7H6.31879L4.175 12H22V21C22 21.5523 21.5523 22 21 22H20C19.4477 22 19 21.5523 19 21V20H5V21C5 21.5523 4.55228 22 4 22H3C2.44772 22 2 21.5523 2 21V12L4.4805 6.21216C4.79566 5.47679 5.51874 5 6.31879 5H9V3H12ZM6.5 14C5.67157 14 5 14.6716 5 15.5C5 16.3284 5.67157 17 6.5 17C7.32843 17 8 16.3284 8 15.5C8 14.6716 7.32843 14 6.5 14ZM17.5 14C16.6716 14 16 14.6716 16 15.5C16 16.3284 16.6716 17 17.5 17C18.3284 17 19 16.3284 19 15.5C19 14.6716 18.3284 14 17.5 14ZM18.5 1C20.9853 1 23 3.01472 23 5.5C23 7.98528 20.9853 10 18.5 10C16.0147 10 14 7.98528 14 5.5C14 3.01472 16.0147 1 18.5 1ZM18.4998 6.16667C18.0089 6.16667 17.5593 6.34354 17.2113 6.63704L17.0856 6.75245L18.4998 8.16667L19.9131 6.7515C19.5512 6.39013 19.0516 6.16667 18.4998 6.16667ZM18.4998 3.5C17.2966 3.5 16.1998 3.95536 15.3722 4.70316L15.199 4.86781L16.1428 5.80964C16.746 5.20643 17.5794 4.83333 18.4998 4.83333C19.3436 4.83333 20.1141 5.14684 20.7013 5.66372L20.8569 5.80964L21.7997 4.86684C20.9552 4.02233 19.7885 3.5 18.4998 3.5Z"
  }));
},
    Du = function Du(_ref2028) {
  var _ref2028$color = _ref2028.color,
      C = _ref2028$color === void 0 ? "currentColor" : _ref2028$color,
      _ref2028$size = _ref2028.size,
      e = _ref2028$size === void 0 ? 24 : _ref2028$size,
      l = _ref2028.className,
      i = _objectWithoutProperties(_ref2028, _excluded2028);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 3V7H6.23607L4.235 11H22V21C22 21.5523 21.5523 22 21 22H20C19.4477 22 19 21.5523 19 21V20H5V21C5 21.5523 4.55228 22 4 22H3C2.44772 22 2 21.5523 2 21V11L4.44721 6.10557C4.786 5.428 5.47852 5 6.23607 5H9V3H12ZM20 13H4V18H20V13ZM6.5 14C7.32843 14 8 14.6716 8 15.5C8 16.3284 7.32843 17 6.5 17C5.67157 17 5 16.3284 5 15.5C5 14.6716 5.67157 14 6.5 14ZM17.5 14C18.3284 14 19 14.6716 19 15.5C19 16.3284 18.3284 17 17.5 17C16.6716 17 16 16.3284 16 15.5C16 14.6716 16.6716 14 17.5 14ZM18.5 1C20.9853 1 23 3.01472 23 5.5C23 7.98528 20.9853 10 18.5 10C16.0147 10 14 7.98528 14 5.5C14 3.01472 16.0147 1 18.5 1ZM18.4998 6.16667C18.0089 6.16667 17.5593 6.34354 17.2113 6.63704L17.0856 6.75245L18.4998 8.16667L19.9131 6.7515C19.5512 6.39013 19.0516 6.16667 18.4998 6.16667ZM18.4998 3.5C17.2966 3.5 16.1998 3.95536 15.3722 4.70316L15.199 4.86781L16.1428 5.80964C16.746 5.20643 17.5794 4.83333 18.4998 4.83333C19.3436 4.83333 20.1141 5.14684 20.7013 5.66372L20.8569 5.80964L21.7997 4.86684C20.9552 4.02233 19.7885 3.5 18.4998 3.5Z"
  }));
},
    yu = function yu(_ref2029) {
  var _ref2029$color = _ref2029.color,
      C = _ref2029$color === void 0 ? "currentColor" : _ref2029$color,
      _ref2029$size = _ref2029.size,
      e = _ref2029$size === void 0 ? 24 : _ref2029$size,
      l = _ref2029.className,
      i = _objectWithoutProperties(_ref2029, _excluded2029);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 10C14.2091 10 16 8.20914 16 6 16 3.79086 14.2091 2 12 2 9.79086 2 8 3.79086 8 6 8 8.20914 9.79086 10 12 10ZM5.5 13C6.88071 13 8 11.8807 8 10.5 8 9.11929 6.88071 8 5.5 8 4.11929 8 3 9.11929 3 10.5 3 11.8807 4.11929 13 5.5 13ZM21 10.5C21 11.8807 19.8807 13 18.5 13 17.1193 13 16 11.8807 16 10.5 16 9.11929 17.1193 8 18.5 8 19.8807 8 21 9.11929 21 10.5ZM12 11C14.7614 11 17 13.2386 17 16V22H7V16C7 13.2386 9.23858 11 12 11ZM5 15.9999C5 15.307 5.10067 14.6376 5.28818 14.0056L5.11864 14.0204C3.36503 14.2104 2 15.6958 2 17.4999V21.9999H5V15.9999ZM22 21.9999V17.4999C22 15.6378 20.5459 14.1153 18.7118 14.0056 18.8993 14.6376 19 15.307 19 15.9999V21.9999H22Z"
  }));
},
    bu = function bu(_ref2030) {
  var _ref2030$color = _ref2030.color,
      C = _ref2030$color === void 0 ? "currentColor" : _ref2030$color,
      _ref2030$size = _ref2030.size,
      e = _ref2030$size === void 0 ? 24 : _ref2030$size,
      l = _ref2030.className,
      i = _objectWithoutProperties(_ref2030, _excluded2030);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 11C14.7614 11 17 13.2386 17 16V22H15V16C15 14.4023 13.7511 13.0963 12.1763 13.0051L12 13C10.4023 13 9.09634 14.2489 9.00509 15.8237L9 16V22H7V16C7 13.2386 9.23858 11 12 11ZM5.5 14C5.77885 14 6.05009 14.0326 6.3101 14.0942C6.14202 14.594 6.03873 15.122 6.00896 15.6693L6 16L6.0007 16.0856C5.88757 16.0456 5.76821 16.0187 5.64446 16.0069L5.5 16C4.7203 16 4.07955 16.5949 4.00687 17.3555L4 17.5V22H2V17.5C2 15.567 3.567 14 5.5 14ZM18.5 14C20.433 14 22 15.567 22 17.5V22H20V17.5C20 16.7203 19.4051 16.0796 18.6445 16.0069L18.5 16C18.3248 16 18.1566 16.03 18.0003 16.0852L18 16C18 15.3343 17.8916 14.694 17.6915 14.0956C17.9499 14.0326 18.2211 14 18.5 14ZM5.5 8C6.88071 8 8 9.11929 8 10.5C8 11.8807 6.88071 13 5.5 13C4.11929 13 3 11.8807 3 10.5C3 9.11929 4.11929 8 5.5 8ZM18.5 8C19.8807 8 21 9.11929 21 10.5C21 11.8807 19.8807 13 18.5 13C17.1193 13 16 11.8807 16 10.5C16 9.11929 17.1193 8 18.5 8ZM5.5 10C5.22386 10 5 10.2239 5 10.5C5 10.7761 5.22386 11 5.5 11C5.77614 11 6 10.7761 6 10.5C6 10.2239 5.77614 10 5.5 10ZM18.5 10C18.2239 10 18 10.2239 18 10.5C18 10.7761 18.2239 11 18.5 11C18.7761 11 19 10.7761 19 10.5C19 10.2239 18.7761 10 18.5 10ZM12 2C14.2091 2 16 3.79086 16 6C16 8.20914 14.2091 10 12 10C9.79086 10 8 8.20914 8 6C8 3.79086 9.79086 2 12 2ZM12 4C10.8954 4 10 4.89543 10 6C10 7.10457 10.8954 8 12 8C13.1046 8 14 7.10457 14 6C14 4.89543 13.1046 4 12 4Z"
  }));
},
    Tu = function Tu(_ref2031) {
  var _ref2031$color = _ref2031.color,
      C = _ref2031$color === void 0 ? "currentColor" : _ref2031$color,
      _ref2031$size = _ref2031.size,
      e = _ref2031$size === void 0 ? 24 : _ref2031$size,
      l = _ref2031.className,
      i = _objectWithoutProperties(_ref2031, _excluded2031);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM12.3584 9.38246C11.3857 9.78702 9.4418 10.6244 6.5266 11.8945C6.05321 12.0827 5.80524 12.2669 5.78266 12.4469C5.74451 12.7513 6.12561 12.8711 6.64458 13.0343C6.71517 13.0565 6.78832 13.0795 6.8633 13.1039C7.37388 13.2698 8.06071 13.464 8.41776 13.4717C8.74164 13.4787 9.10313 13.3452 9.50222 13.0711C12.226 11.2325 13.632 10.3032 13.7203 10.2832C13.7826 10.269 13.8689 10.2513 13.9273 10.3032C13.9858 10.3552 13.98 10.4536 13.9739 10.48C13.9361 10.641 12.4401 12.0318 11.666 12.7515C11.4351 12.9661 11.2101 13.1853 10.9833 13.4039C10.509 13.8611 10.1533 14.204 11.003 14.764C11.8644 15.3317 12.7323 15.8982 13.5724 16.4971C13.9867 16.7925 14.359 17.0579 14.8188 17.0156C15.0861 16.991 15.3621 16.7397 15.5022 15.9903C15.8335 14.2193 16.4847 10.3821 16.6352 8.80083C16.6484 8.6623 16.6318 8.485 16.6185 8.40717C16.6052 8.32934 16.5773 8.21844 16.4762 8.13635C16.3563 8.03913 16.1714 8.01863 16.0887 8.02009C15.7125 8.02672 15.1355 8.22737 12.3584 9.38246Z"
  }));
},
    Uu = function Uu(_ref2032) {
  var _ref2032$color = _ref2032.color,
      C = _ref2032$color === void 0 ? "currentColor" : _ref2032$color,
      _ref2032$size = _ref2032.size,
      e = _ref2032$size === void 0 ? 24 : _ref2032$size,
      l = _ref2032.className,
      i = _objectWithoutProperties(_ref2032, _excluded2032);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12.3584 9.38246C11.3857 9.78702 9.4418 10.6244 6.5266 11.8945C6.05321 12.0827 5.80524 12.2669 5.78266 12.4469C5.74451 12.7513 6.12561 12.8711 6.64458 13.0343C6.71517 13.0565 6.78832 13.0795 6.8633 13.1039C7.37388 13.2698 8.06071 13.464 8.41776 13.4717C8.74164 13.4787 9.10313 13.3452 9.50222 13.0711C12.226 11.2325 13.632 10.3032 13.7203 10.2832C13.7826 10.269 13.8689 10.2513 13.9273 10.3032C13.9858 10.3552 13.98 10.4536 13.9739 10.48C13.9361 10.641 12.4401 12.0318 11.6659 12.7515C11.4351 12.9661 11.2101 13.1853 10.9833 13.4039C10.509 13.8611 10.1533 14.204 11.003 14.764C11.8644 15.3317 12.7323 15.8982 13.5724 16.4971C13.9867 16.7925 14.359 17.0579 14.8188 17.0156C15.0861 16.991 15.3621 16.7397 15.5022 15.9903C15.8335 14.2193 16.4847 10.3821 16.6352 8.80083C16.6484 8.6623 16.6318 8.485 16.6185 8.40717C16.6052 8.32934 16.5773 8.21844 16.4762 8.13635C16.3563 8.03913 16.1714 8.01863 16.0887 8.02009C15.7125 8.02672 15.1355 8.22737 12.3584 9.38246Z"
  }));
},
    Gu = function Gu(_ref2033) {
  var _ref2033$color = _ref2033.color,
      C = _ref2033$color === void 0 ? "currentColor" : _ref2033$color,
      _ref2033$size = _ref2033.size,
      e = _ref2033$size === void 0 ? 24 : _ref2033$size,
      l = _ref2033.className,
      i = _objectWithoutProperties(_ref2033, _excluded2033);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8 10.2547V5C8 2.79086 9.79086 1 12 1C14.2091 1 16 2.79086 16 5V10.2547C17.8135 11.5196 19 13.6213 19 16C19 19.866 15.866 23 12 23C8.13401 23 5 19.866 5 16C5 13.6213 6.18652 11.5196 8 10.2547ZM8 16C8 18.2091 9.79086 20 12 20C14.2091 20 16 18.2091 16 16H8Z"
  }));
},
    Iu = function Iu(_ref2034) {
  var _ref2034$color = _ref2034.color,
      C = _ref2034$color === void 0 ? "currentColor" : _ref2034$color,
      _ref2034$size = _ref2034.size,
      e = _ref2034$size === void 0 ? 24 : _ref2034$size,
      l = _ref2034.className,
      i = _objectWithoutProperties(_ref2034, _excluded2034);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8 5C8 2.79086 9.79086 1 12 1C14.2091 1 16 2.79086 16 5V10.2547C17.8135 11.5196 19 13.6213 19 16C19 19.866 15.866 23 12 23C8.13401 23 5 19.866 5 16C5 13.6213 6.18652 11.5196 8 10.2547V5ZM9.1442 11.8951C7.80943 12.8261 7 14.3432 7 16C7 18.7614 9.23858 21 12 21C14.7614 21 17 18.7614 17 16C17 14.3432 16.1906 12.8261 14.8558 11.8951L14 11.2981V5C14 3.89543 13.1046 3 12 3C10.8954 3 10 3.89543 10 5V11.2981L9.1442 11.8951ZM8 16H16C16 18.2091 14.2091 20 12 20C9.79086 20 8 18.2091 8 16Z"
  }));
},
    Wu = function Wu(_ref2035) {
  var _ref2035$color = _ref2035.color,
      C = _ref2035$color === void 0 ? "currentColor" : _ref2035$color,
      _ref2035$size = _ref2035.size,
      e = _ref2035$size === void 0 ? 24 : _ref2035$size,
      l = _ref2035.className,
      i = _objectWithoutProperties(_ref2035, _excluded2035);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8 10.2547V5C8 2.79086 9.79086 1 12 1C14.2091 1 16 2.79086 16 5V10.2547C17.8135 11.5196 19 13.6213 19 16C19 19.866 15.866 23 12 23C8.13401 23 5 19.866 5 16C5 13.6213 6.18652 11.5196 8 10.2547ZM11 12.126C9.27477 12.5701 8 14.1362 8 16C8 18.2091 9.79086 20 12 20C14.2091 20 16 18.2091 16 16C16 14.1362 14.7252 12.5701 13 12.126V5H11V12.126Z"
  }));
},
    Ou = function Ou(_ref2036) {
  var _ref2036$color = _ref2036.color,
      C = _ref2036$color === void 0 ? "currentColor" : _ref2036$color,
      _ref2036$size = _ref2036.size,
      e = _ref2036$size === void 0 ? 24 : _ref2036$size,
      l = _ref2036.className,
      i = _objectWithoutProperties(_ref2036, _excluded2036);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8 5C8 2.79086 9.79086 1 12 1C14.2091 1 16 2.79086 16 5V10.2547C17.8135 11.5196 19 13.6213 19 16C19 19.866 15.866 23 12 23C8.13401 23 5 19.866 5 16C5 13.6213 6.18652 11.5196 8 10.2547V5ZM9.1442 11.8951C7.80943 12.8261 7 14.3432 7 16C7 18.7614 9.23858 21 12 21C14.7614 21 17 18.7614 17 16C17 14.3432 16.1906 12.8261 14.8558 11.8951L14 11.2981V5C14 3.89543 13.1046 3 12 3C10.8954 3 10 3.89543 10 5V11.2981L9.1442 11.8951ZM11 12.126V5H13V12.126C14.7252 12.5701 16 14.1362 16 16C16 18.2091 14.2091 20 12 20C9.79086 20 8 18.2091 8 16C8 14.1362 9.27477 12.5701 11 12.126ZM12 18C13.1046 18 14 17.1046 14 16C14 14.8954 13.1046 14 12 14C10.8954 14 10 14.8954 10 16C10 17.1046 10.8954 18 12 18Z"
  }));
},
    Ku = function Ku(_ref2037) {
  var _ref2037$color = _ref2037.color,
      C = _ref2037$color === void 0 ? "currentColor" : _ref2037$color,
      _ref2037$size = _ref2037.size,
      e = _ref2037$size === void 0 ? 24 : _ref2037$size,
      l = _ref2037.className,
      i = _objectWithoutProperties(_ref2037, _excluded2037);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM12 15V17H18V15H12ZM8.41421 12L5.58579 14.8284L7 16.2426L11.2426 12L7 7.75736L5.58579 9.17157L8.41421 12Z"
  }));
},
    Qu = function Qu(_ref2038) {
  var _ref2038$color = _ref2038.color,
      C = _ref2038$color === void 0 ? "currentColor" : _ref2038$color,
      _ref2038$size = _ref2038.size,
      e = _ref2038$size === void 0 ? 24 : _ref2038$size,
      l = _ref2038.className,
      i = _objectWithoutProperties(_ref2038, _excluded2038);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM4 5V19H20V5H4ZM12 15H18V17H12V15ZM8.66685 12L5.83842 9.17157L7.25264 7.75736L11.4953 12L7.25264 16.2426L5.83842 14.8284L8.66685 12Z"
  }));
},
    qu = function qu(_ref2039) {
  var _ref2039$color = _ref2039.color,
      C = _ref2039$color === void 0 ? "currentColor" : _ref2039$color,
      _ref2039$size = _ref2039.size,
      e = _ref2039$size === void 0 ? 24 : _ref2039$size,
      l = _ref2039.className,
      i = _objectWithoutProperties(_ref2039, _excluded2039);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10.9999 12L3.92886 19.0711L2.51465 17.6569L8.1715 12L2.51465 6.34317L3.92886 4.92896L10.9999 12ZM10.9999 19H20.9999V21H10.9999V19Z"
  }));
},
    ju = function ju(_ref2040) {
  var _ref2040$color = _ref2040.color,
      C = _ref2040$color === void 0 ? "currentColor" : _ref2040$color,
      _ref2040$size = _ref2040.size,
      e = _ref2040$size === void 0 ? 24 : _ref2040$size,
      l = _ref2040.className,
      i = _objectWithoutProperties(_ref2040, _excluded2040);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10.9999 12L3.92886 19.0711L2.51465 17.6569L8.1715 12L2.51465 6.34317L3.92886 4.92896L10.9999 12ZM10.9999 19H20.9999V21H10.9999V19Z"
  }));
},
    Xu = function Xu(_ref2041) {
  var _ref2041$color = _ref2041.color,
      C = _ref2041$color === void 0 ? "currentColor" : _ref2041$color,
      _ref2041$size = _ref2041.size,
      e = _ref2041$size === void 0 ? 24 : _ref2041$size,
      l = _ref2041.className,
      i = _objectWithoutProperties(_ref2041, _excluded2041);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 10H4V19H20V10ZM3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM5 6V8H7V6H5ZM9 6V8H11V6H9ZM5 11H8V16H5V11Z"
  }));
},
    Ju = function Ju(_ref2042) {
  var _ref2042$color = _ref2042.color,
      C = _ref2042$color === void 0 ? "currentColor" : _ref2042$color,
      _ref2042$size = _ref2042.size,
      e = _ref2042$size === void 0 ? 24 : _ref2042$size,
      l = _ref2042.className,
      i = _objectWithoutProperties(_ref2042, _excluded2042);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 9V5H4V9H20ZM20 11H4V19H20V11ZM3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM5 12H8V17H5V12ZM5 6H7V8H5V6ZM9 6H11V8H9V6Z"
  }));
},
    Yu = function Yu(_ref2043) {
  var _ref2043$color = _ref2043.color,
      C = _ref2043$color === void 0 ? "currentColor" : _ref2043$color,
      _ref2043$size = _ref2043.size,
      e = _ref2043$size === void 0 ? 24 : _ref2043$size,
      l = _ref2043.className,
      i = _objectWithoutProperties(_ref2043, _excluded2043);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17 2V4H16V18C16 20.2091 14.2091 22 12 22C9.79086 22 8 20.2091 8 18V4H7V2H17ZM13 15C12.4477 15 12 15.4477 12 16C12 16.5523 12.4477 17 13 17C13.5523 17 14 16.5523 14 16C14 15.4477 13.5523 15 13 15ZM11 12C10.4477 12 10 12.4477 10 13C10 13.5523 10.4477 14 11 14C11.5523 14 12 13.5523 12 13C12 12.4477 11.5523 12 11 12ZM14 4H10V8H14V4Z"
  }));
},
    _u = function _u(_ref2044) {
  var _ref2044$color = _ref2044.color,
      C = _ref2044$color === void 0 ? "currentColor" : _ref2044$color,
      _ref2044$size = _ref2044.size,
      e = _ref2044$size === void 0 ? 24 : _ref2044$size,
      l = _ref2044.className,
      i = _objectWithoutProperties(_ref2044, _excluded2044);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17 2V4H16V18C16 20.2091 14.2091 22 12 22C9.79086 22 8 20.2091 8 18V4H7V2H17ZM14 10H10V18C10 19.1046 10.8954 20 12 20C13.1046 20 14 19.1046 14 18V10ZM13 15C13.5523 15 14 15.4477 14 16C14 16.5523 13.5523 17 13 17C12.4477 17 12 16.5523 12 16C12 15.4477 12.4477 15 13 15ZM11 12C11.5523 12 12 12.4477 12 13C12 13.5523 11.5523 14 11 14C10.4477 14 10 13.5523 10 13C10 12.4477 10.4477 12 11 12ZM14 4H10V8H14V4Z"
  }));
},
    $u = function $u(_ref2045) {
  var _ref2045$color = _ref2045.color,
      C = _ref2045$color === void 0 ? "currentColor" : _ref2045$color,
      _ref2045$size = _ref2045.size,
      e = _ref2045$size === void 0 ? 24 : _ref2045$size,
      l = _ref2045.className,
      i = _objectWithoutProperties(_ref2045, _excluded2045);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11 5V15H9V11C6.79086 11 5 9.20914 5 7C5 4.79086 6.79086 3 9 3H17V5H15V15H13V5H11ZM9 5C7.89543 5 7 5.89543 7 7C7 8.10457 7.89543 9 9 9V5ZM17 17V14.5L21 18L17 21.5V19H5V17H17Z"
  }));
},
    eB = function eB(_ref2046) {
  var _ref2046$color = _ref2046.color,
      C = _ref2046$color === void 0 ? "currentColor" : _ref2046$color,
      _ref2046$size = _ref2046.size,
      e = _ref2046$size === void 0 ? 24 : _ref2046$size,
      l = _ref2046.className,
      i = _objectWithoutProperties(_ref2046, _excluded2046);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11 5V15H9V11C6.79086 11 5 9.20914 5 7C5 4.79086 6.79086 3 9 3H17V5H15V15H13V5H11ZM9 5C7.89543 5 7 5.89543 7 7C7 8.10457 7.89543 9 9 9V5ZM7 17H19V19H7V21.5L3 18L7 14.5V17Z"
  }));
},
    tB = function tB(_ref2047) {
  var _ref2047$color = _ref2047.color,
      C = _ref2047$color === void 0 ? "currentColor" : _ref2047$color,
      _ref2047$size = _ref2047.size,
      e = _ref2047$size === void 0 ? 24 : _ref2047$size,
      l = _ref2047.className,
      i = _objectWithoutProperties(_ref2047, _excluded2047);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7 17H17V14.5L20.5 18L17 21.5V19H7V21.5L3.5 18L7 14.5V17ZM13 6V15H11V6H5V4H19V6H13Z"
  }));
},
    CB = function CB(_ref2048) {
  var _ref2048$color = _ref2048.color,
      C = _ref2048$color === void 0 ? "currentColor" : _ref2048$color,
      _ref2048$size = _ref2048.size,
      e = _ref2048$size === void 0 ? 24 : _ref2048$size,
      l = _ref2048.className,
      i = _objectWithoutProperties(_ref2048, _excluded2048);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15 18H16.5C17.8807 18 19 16.8807 19 15.5C19 14.1193 17.8807 13 16.5 13H3V11H16.5C18.9853 11 21 13.0147 21 15.5C21 17.9853 18.9853 20 16.5 20H15V22L11 19L15 16V18ZM3 4H21V6H3V4ZM9 18V20H3V18H9Z"
  }));
},
    lB = function lB(_ref2049) {
  var _ref2049$color = _ref2049.color,
      C = _ref2049$color === void 0 ? "currentColor" : _ref2049$color,
      _ref2049$size = _ref2049.size,
      e = _ref2049$size === void 0 ? 24 : _ref2049$size,
      l = _ref2049.className,
      i = _objectWithoutProperties(_ref2049, _excluded2049);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13 6V21H11V6H5V4H19V6H13Z"
  }));
},
    iB = function iB(_ref2050) {
  var _ref2050$color = _ref2050.color,
      C = _ref2050$color === void 0 ? "currentColor" : _ref2050$color,
      _ref2050$size = _ref2050.size,
      e = _ref2050$size === void 0 ? 24 : _ref2050$size,
      l = _ref2050.className,
      i = _objectWithoutProperties(_ref2050, _excluded2050);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.5565 3.44367C22.1186 5.00576 22.1186 7.53842 20.5565 9.10052L12.3563 17.3008C11.714 17.943 10.8723 18.3476 9.96957 18.4479L6.59094 18.8221L4.29304 21.1213C3.90252 21.5119 3.26936 21.5119 2.87883 21.1213C2.48831 20.7308 2.48831 20.0976 2.87883 19.7071L5.17694 17.4081L5.55231 14.0306C5.65261 13.1279 6.05716 12.2862 6.69942 11.6439L14.8996 3.44367C16.4617 1.88157 18.9944 1.88157 20.5565 3.44367ZM11.3641 12.6361L9.9499 14.0503L12.0712 16.1716L13.4854 14.7574L11.3641 12.6361ZM14.1925 9.80763L12.7783 11.2218L14.8996 13.3432L16.3139 11.9289L14.1925 9.80763ZM17.021 6.9792L15.6068 8.39341L17.7281 10.5147L19.1423 9.10052L17.021 6.9792Z"
  }));
},
    sB = function sB(_ref2051) {
  var _ref2051$color = _ref2051.color,
      C = _ref2051$color === void 0 ? "currentColor" : _ref2051$color,
      _ref2051$size = _ref2051.size,
      e = _ref2051$size === void 0 ? 24 : _ref2051$size,
      l = _ref2051.className,
      i = _objectWithoutProperties(_ref2051, _excluded2051);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.5565 3.44367C22.1186 5.00576 22.1186 7.53842 20.5565 9.10052L12.3563 17.3008C11.714 17.943 10.8723 18.3476 9.96957 18.4479L6.59094 18.8221L4.29304 21.1213C3.90252 21.5119 3.26936 21.5119 2.87883 21.1213C2.48831 20.7308 2.48831 20.0976 2.87883 19.7071L5.17694 17.4081L5.55231 14.0306C5.65261 13.1279 6.05716 12.2862 6.69942 11.6439L14.8996 3.44367C16.4617 1.88157 18.9944 1.88157 20.5565 3.44367ZM16.3139 4.85788L8.11363 13.0581C7.7925 13.3792 7.59023 13.8001 7.54008 14.2515L7.264 16.7362L9.74871 16.4601C10.2001 16.4099 10.6209 16.2077 10.9421 15.8865L11.3639 15.4641L9.9499 14.0503L11.3641 12.6361L12.7779 14.0501L14.1919 12.6361L12.7783 11.2218L14.1925 9.80763L15.6069 11.2221L17.0209 9.8071L15.6068 8.39341L17.021 6.9792L18.4349 8.39309L19.1423 7.68631C19.9233 6.90526 19.9233 5.63893 19.1423 4.85788C18.3612 4.07683 17.0949 4.07683 16.3139 4.85788Z"
  }));
},
    rB = function rB(_ref2052) {
  var _ref2052$color = _ref2052.color,
      C = _ref2052$color === void 0 ? "currentColor" : _ref2052$color,
      _ref2052$size = _ref2052.size,
      e = _ref2052$size === void 0 ? 24 : _ref2052$size,
      l = _ref2052.className,
      i = _objectWithoutProperties(_ref2052, _excluded2052);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22 15H19V3H22C22.5523 3 23 3.44772 23 4V14C23 14.5523 22.5523 15 22 15ZM16.7071 16.2929L10.3066 22.6934C10.1307 22.8693 9.85214 22.8891 9.65308 22.7398L8.8005 22.1004C8.3158 21.7369 8.09739 21.1174 8.24686 20.5303L9.40017 16H3C1.89543 16 1 15.1046 1 14V11.8957C1 11.6344 1.05118 11.3757 1.15064 11.1342L4.24501 3.61925C4.3993 3.24455 4.76447 3 5.16969 3H16C16.5523 3 17 3.44772 17 4V15.5858C17 15.851 16.8946 16.1054 16.7071 16.2929Z"
  }));
},
    cB = function cB(_ref2053) {
  var _ref2053$color = _ref2053.color,
      C = _ref2053$color === void 0 ? "currentColor" : _ref2053$color,
      _ref2053$size = _ref2053.size,
      e = _ref2053$size === void 0 ? 24 : _ref2053$size,
      l = _ref2053.className,
      i = _objectWithoutProperties(_ref2053, _excluded2053);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9.40017 16H3C1.89543 16 1 15.1046 1 14V11.8957C1 11.6344 1.05118 11.3757 1.15064 11.1342L4.24501 3.61925C4.3993 3.24455 4.76447 3 5.16969 3H22C22.5523 3 23 3.44772 23 4V14C23 14.5523 22.5523 15 22 15H18.5182C18.1932 15 17.8886 15.1579 17.7012 15.4233L12.2478 23.149C12.1053 23.3508 11.8367 23.4184 11.6157 23.3078L9.80163 22.4008C8.74998 21.875 8.20687 20.6874 8.49694 19.548L9.40017 16ZM17 13.4125V5H5.83939L3 11.8957V14H9.40017C10.7049 14 11.6602 15.229 11.3384 16.4934L10.4351 20.0414C10.3771 20.2693 10.4857 20.5068 10.6961 20.612L11.3572 20.9425L16.0673 14.27C16.3172 13.9159 16.6366 13.6257 17 13.4125ZM19 13H21V5H19V13Z"
  }));
},
    oB = function oB(_ref2054) {
  var _ref2054$color = _ref2054.color,
      C = _ref2054$color === void 0 ? "currentColor" : _ref2054$color,
      _ref2054$size = _ref2054.size,
      e = _ref2054$size === void 0 ? 24 : _ref2054$size,
      l = _ref2054.className,
      i = _objectWithoutProperties(_ref2054, _excluded2054);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 8.99997H5V21H2C1.44772 21 1 20.5523 1 20V9.99997C1 9.44769 1.44772 8.99997 2 8.99997ZM7.29289 7.70708L13.6934 1.30661C13.8693 1.13066 14.1479 1.11087 14.3469 1.26016L15.1995 1.8996C15.6842 2.26312 15.9026 2.88253 15.7531 3.46966L14.5998 7.99997H21C22.1046 7.99997 23 8.8954 23 9.99997V12.1043C23 12.3656 22.9488 12.6243 22.8494 12.8658L19.755 20.3807C19.6007 20.7554 19.2355 21 18.8303 21H8C7.44772 21 7 20.5523 7 20V8.41419C7 8.14897 7.10536 7.89462 7.29289 7.70708Z"
  }));
},
    aB = function aB(_ref2055) {
  var _ref2055$color = _ref2055.color,
      C = _ref2055$color === void 0 ? "currentColor" : _ref2055$color,
      _ref2055$size = _ref2055.size,
      e = _ref2055$size === void 0 ? 24 : _ref2055$size,
      l = _ref2055.className,
      i = _objectWithoutProperties(_ref2055, _excluded2055);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14.5998 8.00033H21C22.1046 8.00033 23 8.89576 23 10.0003V12.1047C23 12.3659 22.9488 12.6246 22.8494 12.8662L19.755 20.3811C19.6007 20.7558 19.2355 21.0003 18.8303 21.0003H2C1.44772 21.0003 1 20.5526 1 20.0003V10.0003C1 9.44804 1.44772 9.00033 2 9.00033H5.48184C5.80677 9.00033 6.11143 8.84246 6.29881 8.57701L11.7522 0.851355C11.8947 0.649486 12.1633 0.581978 12.3843 0.692483L14.1984 1.59951C15.25 2.12534 15.7931 3.31292 15.5031 4.45235L14.5998 8.00033ZM7 10.5878V19.0003H18.1606L21 12.1047V10.0003H14.5998C13.2951 10.0003 12.3398 8.77128 12.6616 7.50691L13.5649 3.95894C13.6229 3.73105 13.5143 3.49353 13.3039 3.38837L12.6428 3.0578L7.93275 9.73038C7.68285 10.0844 7.36341 10.3746 7 10.5878ZM5 11.0003H3V19.0003H5V11.0003Z"
  }));
},
    nB = function nB(_ref2056) {
  var _ref2056$color = _ref2056.color,
      C = _ref2056$color === void 0 ? "currentColor" : _ref2056$color,
      _ref2056$size = _ref2056.size,
      e = _ref2056$size === void 0 ? 24 : _ref2056$size,
      l = _ref2056.className,
      i = _objectWithoutProperties(_ref2056, _excluded2056);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16.9885 18L18.2044 16.4194C18.4061 16.1572 18.5154 15.8356 18.5154 15.5048C18.5154 14.6764 17.8439 14.0048 17.0154 14.0048H15V10.0291C15 9.56319 14.7835 9.12374 14.4141 8.83982C13.7573 8.33495 12.8156 8.45813 12.3107 9.11494L5.9453 17.3961C3.04248 16.1959 1 13.3365 1 10C1 5.58172 4.58172 2 9 2C12.3949 2 15.2959 4.11466 16.4576 7.09864C16.7951 7.0339 17.1436 7 17.5 7C20.5376 7 23 9.46243 23 12.5C23 15.5376 20.5376 18 17.5 18H16.9885ZM13 16.0048H16L11 22.5048V18.0048H8L13 11.5V16.0048Z"
  }));
},
    mB = function mB(_ref2057) {
  var _ref2057$color = _ref2057.color,
      C = _ref2057$color === void 0 ? "currentColor" : _ref2057$color,
      _ref2057$size = _ref2057.size,
      e = _ref2057$size === void 0 ? 24 : _ref2057$size,
      l = _ref2057.className,
      i = _objectWithoutProperties(_ref2057, _excluded2057);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17 18V16H17.5C19.433 16 21 14.433 21 12.5C21 10.567 19.433 9 17.5 9C16.5205 9 15.6351 9.40232 14.9998 10.0507C14.9999 10.0338 15 10.0169 15 10C15 6.68629 12.3137 4 9 4C5.68629 4 3 6.68629 3 10C3 12.6124 4.66962 14.8349 7 15.6586V17.748C3.54955 16.8599 1 13.7277 1 10C1 5.58172 4.58172 2 9 2C12.3949 2 15.2959 4.11466 16.4576 7.09864C16.7951 7.0339 17.1436 7 17.5 7C20.5376 7 23 9.46243 23 12.5C23 15.5376 20.5376 18 17.5 18H17ZM13 16.0048H16L11 22.5048V18.0048H8L13 11.5V16.0048Z"
  }));
},
    wB = function wB(_ref2058) {
  var _ref2058$color = _ref2058.color,
      C = _ref2058$color === void 0 ? "currentColor" : _ref2058$color,
      _ref2058$size = _ref2058.size,
      e = _ref2058$size === void 0 ? 24 : _ref2058$size,
      l = _ref2058.className,
      i = _objectWithoutProperties(_ref2058, _excluded2058);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21.0049 2.99966C21.5572 2.99966 22.0049 3.44738 22.0049 3.99966V9.49966C20.6242 9.49966 19.5049 10.619 19.5049 11.9997C19.5049 13.3804 20.6242 14.4997 22.0049 14.4997V19.9997C22.0049 20.5519 21.5572 20.9997 21.0049 20.9997H3.00488C2.4526 20.9997 2.00488 20.5519 2.00488 19.9997V14.4997C3.38559 14.4997 4.50488 13.3804 4.50488 11.9997C4.50488 10.619 3.38559 9.49966 2.00488 9.49966V3.99966C2.00488 3.44738 2.4526 2.99966 3.00488 2.99966H21.0049ZM16.0049 8.99966H8.00488V14.9997H16.0049V8.99966Z"
  }));
},
    LB = function LB(_ref2059) {
  var _ref2059$color = _ref2059.color,
      C = _ref2059$color === void 0 ? "currentColor" : _ref2059$color,
      _ref2059$size = _ref2059.size,
      e = _ref2059$size === void 0 ? 24 : _ref2059$size,
      l = _ref2059.className,
      i = _objectWithoutProperties(_ref2059, _excluded2059);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21.0049 2.99979C21.5572 2.99979 22.0049 3.4475 22.0049 3.99979V9.49979C20.6242 9.49979 19.5049 10.6191 19.5049 11.9998C19.5049 13.3805 20.6242 14.4998 22.0049 14.4998V19.9998C22.0049 20.5521 21.5572 20.9998 21.0049 20.9998H3.00488C2.4526 20.9998 2.00488 20.5521 2.00488 19.9998V14.4998C3.38559 14.4998 4.50488 13.3805 4.50488 11.9998C4.50488 10.6191 3.38559 9.49979 2.00488 9.49979V3.99979C2.00488 3.4475 2.4526 2.99979 3.00488 2.99979H21.0049ZM20.0049 4.99979H4.00488V7.96779L4.16077 8.04886C5.49935 8.78084 6.42516 10.1733 6.49998 11.788L6.50488 11.9998C6.50488 13.704 5.55755 15.1869 4.16077 15.9507L4.00488 16.0308V18.9998H20.0049V16.0308L19.849 15.9507C18.5104 15.2187 17.5846 13.8263 17.5098 12.2116L17.5049 11.9998C17.5049 10.2956 18.4522 8.81266 19.849 8.04886L20.0049 7.96779V4.99979ZM16.0049 8.99979V14.9998H8.00488V8.99979H16.0049Z"
  }));
},
    hB = function hB(_ref2060) {
  var _ref2060$color = _ref2060.color,
      C = _ref2060$color === void 0 ? "currentColor" : _ref2060$color,
      _ref2060$size = _ref2060.size,
      e = _ref2060$size === void 0 ? 24 : _ref2060$size,
      l = _ref2060.className,
      i = _objectWithoutProperties(_ref2060, _excluded2060);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21.0049 2.99966C21.5572 2.99966 22.0049 3.44738 22.0049 3.99966V9.49966C20.6242 9.49966 19.5049 10.619 19.5049 11.9997C19.5049 13.3804 20.6242 14.4997 22.0049 14.4997V19.9997C22.0049 20.5519 21.5572 20.9997 21.0049 20.9997H3.00488C2.4526 20.9997 2.00488 20.5519 2.00488 19.9997V14.4997C3.38559 14.4997 4.50488 13.3804 4.50488 11.9997C4.50488 10.619 3.38559 9.49966 2.00488 9.49966V3.99966C2.00488 3.44738 2.4526 2.99966 3.00488 2.99966H21.0049Z"
  }));
},
    HB = function HB(_ref2061) {
  var _ref2061$color = _ref2061.color,
      C = _ref2061$color === void 0 ? "currentColor" : _ref2061$color,
      _ref2061$size = _ref2061.size,
      e = _ref2061$size === void 0 ? 24 : _ref2061$size,
      l = _ref2061.className,
      i = _objectWithoutProperties(_ref2061, _excluded2061);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21.0049 2.99979C21.5572 2.99979 22.0049 3.4475 22.0049 3.99979V9.49979C20.6242 9.49979 19.5049 10.6191 19.5049 11.9998C19.5049 13.3805 20.6242 14.4998 22.0049 14.4998V19.9998C22.0049 20.5521 21.5572 20.9998 21.0049 20.9998H3.00488C2.4526 20.9998 2.00488 20.5521 2.00488 19.9998V14.4998C3.38559 14.4998 4.50488 13.3805 4.50488 11.9998C4.50488 10.6191 3.38559 9.49979 2.00488 9.49979V3.99979C2.00488 3.4475 2.4526 2.99979 3.00488 2.99979H21.0049ZM20.0049 4.99979H4.00488V7.96779L4.16077 8.04886C5.49935 8.78084 6.42516 10.1733 6.49998 11.788L6.50488 11.9998C6.50488 13.704 5.55755 15.1869 4.16077 15.9507L4.00488 16.0308V18.9998H20.0049V16.0308L19.849 15.9507C18.5104 15.2187 17.5846 13.8263 17.5098 12.2116L17.5049 11.9998C17.5049 10.2956 18.4522 8.81266 19.849 8.04886L20.0049 7.96779V4.99979Z"
  }));
},
    VB = function VB(_ref2062) {
  var _ref2062$color = _ref2062.color,
      C = _ref2062$color === void 0 ? "currentColor" : _ref2062$color,
      _ref2062$size = _ref2062.size,
      e = _ref2062$size === void 0 ? 24 : _ref2062$size,
      l = _ref2062.className,
      i = _objectWithoutProperties(_ref2062, _excluded2062);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM13 12V7H11V14H17V12H13Z"
  }));
},
    gB = function gB(_ref2063) {
  var _ref2063$color = _ref2063.color,
      C = _ref2063$color === void 0 ? "currentColor" : _ref2063$color,
      _ref2063$size = _ref2063.size,
      e = _ref2063$size === void 0 ? 24 : _ref2063$size,
      l = _ref2063.className,
      i = _objectWithoutProperties(_ref2063, _excluded2063);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM13 12H17V14H11V7H13V12Z"
  }));
},
    MB = function MB(_ref2064) {
  var _ref2064$color = _ref2064.color,
      C = _ref2064$color === void 0 ? "currentColor" : _ref2064$color,
      _ref2064$size = _ref2064.size,
      e = _ref2064$size === void 0 ? 24 : _ref2064$size,
      l = _ref2064.className,
      i = _objectWithoutProperties(_ref2064, _excluded2064);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2ZM15.5355 7.05025L10.5858 12L12 13.4142L16.9497 8.46447L15.5355 7.05025Z"
  }));
},
    ZB = function ZB(_ref2065) {
  var _ref2065$color = _ref2065.color,
      C = _ref2065$color === void 0 ? "currentColor" : _ref2065$color,
      _ref2065$size = _ref2065.size,
      e = _ref2065$size === void 0 ? 24 : _ref2065$size,
      l = _ref2065.className,
      i = _objectWithoutProperties(_ref2065, _excluded2065);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2ZM12 20C16.42 20 20 16.42 20 12C20 7.58 16.42 4 12 4C7.58 4 4 7.58 4 12C4 16.42 7.58 20 12 20ZM15.5355 7.05025L16.9497 8.46447L12 13.4142L10.5858 12L15.5355 7.05025Z"
  }));
},
    xB = function xB(_ref2066) {
  var _ref2066$color = _ref2066.color,
      C = _ref2066$color === void 0 ? "currentColor" : _ref2066$color,
      _ref2066$size = _ref2066.size,
      e = _ref2066$size === void 0 ? 24 : _ref2066$size,
      l = _ref2066.className,
      i = _objectWithoutProperties(_ref2066, _excluded2066);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17.6177 5.9681L19.0711 4.51472L20.4853 5.92893L19.0319 7.38231C20.2635 8.92199 21 10.875 21 13C21 17.9706 16.9706 22 12 22C7.02944 22 3 17.9706 3 13C3 8.02944 7.02944 4 12 4C14.125 4 16.078 4.73647 17.6177 5.9681ZM11 8V14H13V8H11ZM8 1H16V3H8V1Z"
  }));
},
    vB = function vB(_ref2067) {
  var _ref2067$color = _ref2067.color,
      C = _ref2067$color === void 0 ? "currentColor" : _ref2067$color,
      _ref2067$size = _ref2067.size,
      e = _ref2067$size === void 0 ? 24 : _ref2067$size,
      l = _ref2067.className,
      i = _objectWithoutProperties(_ref2067, _excluded2067);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.38231 5.9681C7.92199 4.73647 9.87499 4 12 4C14.125 4 16.078 4.73647 17.6177 5.9681L19.0711 4.51472L20.4853 5.92893L19.0319 7.38231C20.2635 8.92199 21 10.875 21 13C21 17.9706 16.9706 22 12 22C7.02944 22 3 17.9706 3 13C3 10.875 3.73647 8.92199 4.9681 7.38231L3.51472 5.92893L4.92893 4.51472L6.38231 5.9681ZM13 12V7.4952L8 14H11V18.5L16 12H13ZM8 1H16V3H8V1Z"
  }));
},
    dB = function dB(_ref2068) {
  var _ref2068$color = _ref2068.color,
      C = _ref2068$color === void 0 ? "currentColor" : _ref2068$color,
      _ref2068$size = _ref2068.size,
      e = _ref2068$size === void 0 ? 24 : _ref2068$size,
      l = _ref2068.className,
      i = _objectWithoutProperties(_ref2068, _excluded2068);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.38231 5.9681C7.92199 4.73647 9.87499 4 12 4C14.125 4 16.078 4.73647 17.6177 5.9681L19.0711 4.51472L20.4853 5.92893L19.0319 7.38231C20.2635 8.92199 21 10.875 21 13C21 17.9706 16.9706 22 12 22C7.02944 22 3 17.9706 3 13C3 10.875 3.73647 8.92199 4.9681 7.38231L3.51472 5.92893L4.92893 4.51472L6.38231 5.9681ZM12 20C15.866 20 19 16.866 19 13C19 9.13401 15.866 6 12 6C8.13401 6 5 9.13401 5 13C5 16.866 8.13401 20 12 20ZM13 12H16L11 18.5V14H8L13 7.4952V12ZM8 1H16V3H8V1Z"
  }));
},
    pB = function pB(_ref2069) {
  var _ref2069$color = _ref2069.color,
      C = _ref2069$color === void 0 ? "currentColor" : _ref2069$color,
      _ref2069$size = _ref2069.size,
      e = _ref2069$size === void 0 ? 24 : _ref2069$size,
      l = _ref2069.className,
      i = _objectWithoutProperties(_ref2069, _excluded2069);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17.6177 5.9681L19.0711 4.51472L20.4853 5.92893L19.0319 7.38231C20.2635 8.92199 21 10.875 21 13C21 17.9706 16.9706 22 12 22C7.02944 22 3 17.9706 3 13C3 8.02944 7.02944 4 12 4C14.125 4 16.078 4.73647 17.6177 5.9681ZM12 20C15.866 20 19 16.866 19 13C19 9.13401 15.866 6 12 6C8.13401 6 5 9.13401 5 13C5 16.866 8.13401 20 12 20ZM11 8H13V14H11V8ZM8 1H16V3H8V1Z"
  }));
},
    EB = function EB(_ref2070) {
  var _ref2070$color = _ref2070.color,
      C = _ref2070$color === void 0 ? "currentColor" : _ref2070$color,
      _ref2070$size = _ref2070.size,
      e = _ref2070$size === void 0 ? 24 : _ref2070$size,
      l = _ref2070.className,
      i = _objectWithoutProperties(_ref2070, _excluded2070);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17 2H20C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V3C3 2.44772 3.44772 2 4 2H7V0H9V2H15V0H17V2ZM7 8V10H17V8H7ZM7 12V14H17V12H7Z"
  }));
},
    NB = function NB(_ref2071) {
  var _ref2071$color = _ref2071.color,
      C = _ref2071$color === void 0 ? "currentColor" : _ref2071$color,
      _ref2071$size = _ref2071.size,
      e = _ref2071$size === void 0 ? 24 : _ref2071$size,
      l = _ref2071.className,
      i = _objectWithoutProperties(_ref2071, _excluded2071);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17 2H20C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V3C3 2.44772 3.44772 2 4 2H7V0H9V2H15V0H17V2ZM17 4V6H15V4H9V6H7V4H5V20H19V4H17ZM7 8H17V10H7V8ZM7 12H17V14H7V12Z"
  }));
},
    uB = function uB(_ref2072) {
  var _ref2072$color = _ref2072.color,
      C = _ref2072$color === void 0 ? "currentColor" : _ref2072$color,
      _ref2072$size = _ref2072.size,
      e = _ref2072$size === void 0 ? 24 : _ref2072$size,
      l = _ref2072.className,
      i = _objectWithoutProperties(_ref2072, _excluded2072);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8 5H16C19.866 5 23 8.13401 23 12C23 15.866 19.866 19 16 19H8C4.13401 19 1 15.866 1 12C1 8.13401 4.13401 5 8 5ZM16 15C17.6569 15 19 13.6569 19 12C19 10.3431 17.6569 9 16 9C14.3431 9 13 10.3431 13 12C13 13.6569 14.3431 15 16 15Z"
  }));
},
    BB = function BB(_ref2073) {
  var _ref2073$color = _ref2073.color,
      C = _ref2073$color === void 0 ? "currentColor" : _ref2073$color,
      _ref2073$size = _ref2073.size,
      e = _ref2073$size === void 0 ? 24 : _ref2073$size,
      l = _ref2073.className,
      i = _objectWithoutProperties(_ref2073, _excluded2073);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8 7C5.23858 7 3 9.23858 3 12C3 14.7614 5.23858 17 8 17H16C18.7614 17 21 14.7614 21 12C21 9.23858 18.7614 7 16 7H8ZM8 5H16C19.866 5 23 8.13401 23 12C23 15.866 19.866 19 16 19H8C4.13401 19 1 15.866 1 12C1 8.13401 4.13401 5 8 5ZM8 15C6.34315 15 5 13.6569 5 12C5 10.3431 6.34315 9 8 9C9.65685 9 11 10.3431 11 12C11 13.6569 9.65685 15 8 15Z"
  }));
},
    fB = function fB(_ref2074) {
  var _ref2074$color = _ref2074.color,
      C = _ref2074$color === void 0 ? "currentColor" : _ref2074$color,
      _ref2074$size = _ref2074.size,
      e = _ref2074$size === void 0 ? 24 : _ref2074$size,
      l = _ref2074.className,
      i = _objectWithoutProperties(_ref2074, _excluded2074);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5.32943 3.27158C6.56252 2.8332 7.9923 3.10749 8.97927 4.09446C9.96652 5.08171 10.2407 6.51202 9.80178 7.74535L20.6465 18.5902L18.5252 20.7115L7.67936 9.86709C6.44627 10.3055 5.01649 10.0312 4.02952 9.04421C3.04227 8.05696 2.7681 6.62665 3.20701 5.39332L5.44373 7.63C6.02952 8.21578 6.97927 8.21578 7.56505 7.63C8.15084 7.04421 8.15084 6.09446 7.56505 5.50868L5.32943 3.27158ZM15.6968 5.15512L18.8788 3.38736L20.293 4.80157L18.5252 7.98355L16.7574 8.3371L14.6361 10.4584L13.2219 9.04421L15.3432 6.92289L15.6968 5.15512ZM8.62572 12.9333L10.747 15.0546L5.79729 20.0044C5.2115 20.5902 4.26175 20.5902 3.67597 20.0044C3.12464 19.453 3.09221 18.5793 3.57867 17.99L3.67597 17.883L8.62572 12.9333Z"
  }));
},
    RB = function RB(_ref2075) {
  var _ref2075$color = _ref2075.color,
      C = _ref2075$color === void 0 ? "currentColor" : _ref2075$color,
      _ref2075$size = _ref2075.size,
      e = _ref2075$size === void 0 ? 24 : _ref2075$size,
      l = _ref2075.className,
      i = _objectWithoutProperties(_ref2075, _excluded2075);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5.32943 3.27158C6.56252 2.8332 7.9923 3.10749 8.97927 4.09446C10.1002 5.21537 10.3019 6.90741 9.5843 8.23385L20.293 18.9437L18.8788 20.3579L8.16982 9.64875C6.84325 10.3669 5.15069 10.1654 4.02952 9.04421C3.04227 8.05696 2.7681 6.62665 3.20701 5.39332L5.44373 7.63C6.02952 8.21578 6.97927 8.21578 7.56505 7.63C8.15084 7.04421 8.15084 6.09446 7.56505 5.50868L5.32943 3.27158ZM15.6968 5.15512L18.8788 3.38736L20.293 4.80157L18.5252 7.98355L16.7574 8.3371L14.6361 10.4584L13.2219 9.04421L15.3432 6.92289L15.6968 5.15512ZM8.97927 13.2868L10.3935 14.7011L5.09018 20.0044C4.69966 20.3949 4.06649 20.3949 3.67597 20.0044C3.31334 19.6417 3.28744 19.0699 3.59826 18.6774L3.67597 18.5902L8.97927 13.2868Z"
  }));
},
    zB = function zB(_ref2076) {
  var _ref2076$color = _ref2076.color,
      C = _ref2076$color === void 0 ? "currentColor" : _ref2076$color,
      _ref2076$size = _ref2076.size,
      e = _ref2076$size === void 0 ? 24 : _ref2076$size,
      l = _ref2076.className,
      i = _objectWithoutProperties(_ref2076, _excluded2076);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 3H22V5H2V3ZM4 7H20V9H4V7ZM8 11H22V13H8V11ZM10 15H18V17H10V15ZM8 19H14V21H8V19Z"
  }));
},
    FB = function FB(_ref2077) {
  var _ref2077$color = _ref2077.color,
      C = _ref2077$color === void 0 ? "currentColor" : _ref2077$color,
      _ref2077$size = _ref2077.size,
      e = _ref2077$size === void 0 ? 24 : _ref2077$size,
      l = _ref2077.className,
      i = _objectWithoutProperties(_ref2077, _excluded2077);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 3H22V5H2V3ZM4 7H20V9H4V7ZM8 11H22V13H8V11ZM10 15H18V17H10V15ZM8 19H14V21H8V19Z"
  }));
},
    SB = function SB(_ref2078) {
  var _ref2078$color = _ref2078.color,
      C = _ref2078$color === void 0 ? "currentColor" : _ref2078$color,
      _ref2078$size = _ref2078.size,
      e = _ref2078$size === void 0 ? 24 : _ref2078$size,
      l = _ref2078.className,
      i = _objectWithoutProperties(_ref2078, _excluded2078);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10 6V8H6V18H4V8H0V6H10ZM12 6H14.5L17.4999 11.196L20.5 6H23V18H21V9.133L17.4999 15.196L14 9.135V18H12V6Z"
  }));
},
    AB = function AB(_ref2079) {
  var _ref2079$color = _ref2079.color,
      C = _ref2079$color === void 0 ? "currentColor" : _ref2079$color,
      _ref2079$size = _ref2079.size,
      e = _ref2079$size === void 0 ? 24 : _ref2079$size,
      l = _ref2079.className,
      i = _objectWithoutProperties(_ref2079, _excluded2079);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10 6V8H6V18H4V8H0V6H10ZM12 6H14.5L17.4999 11.196L20.5 6H23V18H21V9.133L17.4999 15.196L14 9.135V18H12V6Z"
  }));
},
    kB = function kB(_ref2080) {
  var _ref2080$color = _ref2080.color,
      C = _ref2080$color === void 0 ? "currentColor" : _ref2080$color,
      _ref2080$size = _ref2080.size,
      e = _ref2080$size === void 0 ? 24 : _ref2080$size,
      l = _ref2080.className,
      i = _objectWithoutProperties(_ref2080, _excluded2080);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7 4V3C7 2.44772 7.44772 2 8 2H16C16.5523 2 17 2.44772 17 3V4H20C20 6.5 17.5 7.5 17 7.5V10H20C20 12.5 17.5 13.5 17 13.5V16H20C20 18.5 17.5 19.5 17 19.5V21C17 21.5523 16.5523 22 16 22H8C7.44772 22 7 21.5523 7 21V19.5C6.5 19.5 4 18.5 4 16H7V13.5C6.5 13.5 4 12.5 4 10H7V7.5C6.5 7.5 4 6.5 4 4H7ZM12 20C13.1046 20 14 19.1046 14 18C14 16.8954 13.1046 16 12 16C10.8954 16 10 16.8954 10 18C10 19.1046 10.8954 20 12 20ZM12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14ZM12 8C13.1046 8 14 7.10457 14 6C14 4.89543 13.1046 4 12 4C10.8954 4 10 4.89543 10 6C10 7.10457 10.8954 8 12 8Z"
  }));
},
    PB = function PB(_ref2081) {
  var _ref2081$color = _ref2081.color,
      C = _ref2081$color === void 0 ? "currentColor" : _ref2081$color,
      _ref2081$size = _ref2081.size,
      e = _ref2081$size === void 0 ? 24 : _ref2081$size,
      l = _ref2081.className,
      i = _objectWithoutProperties(_ref2081, _excluded2081);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7 4V3C7 2.44772 7.44772 2 8 2H16C16.5523 2 17 2.44772 17 3V4H20C20 6.5 17.5 7.5 17 7.5V10H20C20 12.5 17.5 13.5 17 13.5V16H20C20 18.5 17.5 19.5 17 19.5V21C17 21.5523 16.5523 22 16 22H8C7.44772 22 7 21.5523 7 21V19.5C6.5 19.5 4 18.5 4 16H7V13.5C6.5 13.5 4 12.5 4 10H7V7.5C6.5 7.5 4 6.5 4 4H7ZM12 20C13.1046 20 14 19.1046 14 18C14 16.8954 13.1046 16 12 16C10.8954 16 10 16.8954 10 18C10 19.1046 10.8954 20 12 20ZM12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14ZM12 8C13.1046 8 14 7.10457 14 6C14 4.89543 13.1046 4 12 4C10.8954 4 10 4.89543 10 6C10 7.10457 10.8954 8 12 8Z"
  }));
},
    DB = function DB(_ref2082) {
  var _ref2082$color = _ref2082.color,
      C = _ref2082$color === void 0 ? "currentColor" : _ref2082$color,
      _ref2082$size = _ref2082.size,
      e = _ref2082$size === void 0 ? 24 : _ref2082$size,
      l = _ref2082.className,
      i = _objectWithoutProperties(_ref2082, _excluded2082);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17.2 20L19 21.5V22H5V21.5L6.8 20H5C3.89543 20 3 19.1046 3 18V7C3 4.79086 4.79086 3 7 3H17C19.2091 3 21 4.79086 21 7V18C21 19.1046 20.1046 20 19 20H17.2ZM5 7V11H19V7H5ZM12 18C13.1046 18 14 17.1046 14 16C14 14.8954 13.1046 14 12 14C10.8954 14 10 14.8954 10 16C10 17.1046 10.8954 18 12 18Z"
  }));
},
    yB = function yB(_ref2083) {
  var _ref2083$color = _ref2083.color,
      C = _ref2083$color === void 0 ? "currentColor" : _ref2083$color,
      _ref2083$size = _ref2083.size,
      e = _ref2083$size === void 0 ? 24 : _ref2083$size,
      l = _ref2083.className,
      i = _objectWithoutProperties(_ref2083, _excluded2083);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17.2 20L19 21.5V22H5V21.5L6.8 20H5C3.89543 20 3 19.1046 3 18V7C3 4.79086 4.79086 3 7 3H17C19.2091 3 21 4.79086 21 7V18C21 19.1046 20.1046 20 19 20H17.2ZM7 5C5.89543 5 5 5.89543 5 7V18H19V7C19 5.89543 18.1046 5 17 5H7ZM12 17C10.8954 17 10 16.1046 10 15C10 13.8954 10.8954 13 12 13C13.1046 13 14 13.8954 14 15C14 16.1046 13.1046 17 12 17ZM6 7H18V11H6V7Z"
  }));
},
    bB = function bB(_ref2084) {
  var _ref2084$color = _ref2084.color,
      C = _ref2084$color === void 0 ? "currentColor" : _ref2084$color,
      _ref2084$size = _ref2084.size,
      e = _ref2084$size === void 0 ? 24 : _ref2084$size,
      l = _ref2084.className,
      i = _objectWithoutProperties(_ref2084, _excluded2084);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.4981 3C12.1772 3.76965 12 4.61413 12 5.5C12 6.01621 12.0602 6.51837 12.1739 6.99984L5 7V11L15.035 11.0004C16.038 11.6336 17.2262 12 18.5 12C19.3861 12 20.2308 11.8227 21.0006 11.5016L21 18C21 19.1046 20.1046 20 19 20H17.2L19 21.5V22H5V21.5L6.8 20H5C3.89543 20 3 19.1046 3 18V7C3 4.79086 4.79086 3 7 3H12.4981ZM12 14C10.8954 14 10 14.8954 10 16C10 17.1046 10.8954 18 12 18C13.1046 18 14 17.1046 14 16C14 14.8954 13.1046 14 12 14ZM18.5 1C20.9853 1 23 3.01472 23 5.5C23 7.98528 20.9853 10 18.5 10C16.0147 10 14 7.98528 14 5.5C14 3.01472 16.0147 1 18.5 1ZM18.4998 6.16667C18.0089 6.16667 17.5593 6.34354 17.2113 6.63704L17.0856 6.75245L18.4998 8.16667L19.9131 6.7515C19.5512 6.39013 19.0516 6.16667 18.4998 6.16667ZM18.4998 3.5C17.2966 3.5 16.1998 3.95536 15.3722 4.70316L15.199 4.86781L16.1428 5.80964C16.746 5.20643 17.5794 4.83333 18.4998 4.83333C19.3436 4.83333 20.1141 5.14684 20.7013 5.66372L20.8569 5.80964L21.7997 4.86684C20.9552 4.02233 19.7885 3.5 18.4998 3.5Z"
  }));
},
    TB = function TB(_ref2085) {
  var _ref2085$color = _ref2085.color,
      C = _ref2085$color === void 0 ? "currentColor" : _ref2085$color,
      _ref2085$size = _ref2085.size,
      e = _ref2085$size === void 0 ? 24 : _ref2085$size,
      l = _ref2085.className,
      i = _objectWithoutProperties(_ref2085, _excluded2085);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.4981 3C12.2382 3.6234 12.0725 4.29587 12.019 4.99967L7 5C5.94564 5 5.08183 5.81588 5.00549 6.85074L5 7V18H19L19.0003 11.981C19.7044 11.9274 20.3771 11.7617 21.0006 11.5016L21 18C21 19.1046 20.1046 20 19 20H17.2L19 21.5V22H5V21.5L6.8 20H5C3.89543 20 3 19.1046 3 18V7C3 4.79086 4.79086 3 7 3H12.4981ZM12 13C13.1046 13 14 13.8954 14 15C14 16.1046 13.1046 17 12 17C10.8954 17 10 16.1046 10 15C10 13.8954 10.8954 13 12 13ZM12.1741 7.00084C12.5709 8.67951 13.6186 10.1066 15.036 11.0011L6 11V7L12.1741 7.00084ZM18.5 1C20.9853 1 23 3.01472 23 5.5C23 7.98528 20.9853 10 18.5 10C16.0147 10 14 7.98528 14 5.5C14 3.01472 16.0147 1 18.5 1ZM18.4998 6.16667C18.0089 6.16667 17.5593 6.34354 17.2113 6.63704L17.0856 6.75245L18.4998 8.16667L19.9131 6.7515C19.5512 6.39013 19.0516 6.16667 18.4998 6.16667ZM18.4998 3.5C17.2966 3.5 16.1998 3.95536 15.3722 4.70316L15.199 4.86781L16.1428 5.80964C16.746 5.20643 17.5794 4.83333 18.4998 4.83333C19.3436 4.83333 20.1141 5.14684 20.7013 5.66372L20.8569 5.80964L21.7997 4.86684C20.9552 4.02233 19.7885 3.5 18.4998 3.5Z"
  }));
},
    UB = function UB(_ref2086) {
  var _ref2086$color = _ref2086.color,
      C = _ref2086$color === void 0 ? "currentColor" : _ref2086$color,
      _ref2086$size = _ref2086.size,
      e = _ref2086$size === void 0 ? 24 : _ref2086$size,
      l = _ref2086.className,
      i = _objectWithoutProperties(_ref2086, _excluded2086);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18.5 10L22.9 21H20.745L19.544 18H15.454L14.255 21H12.101L16.5 10H18.5ZM10 2V4H16V6L14.0322 6.0006C13.2425 8.36616 11.9988 10.5057 10.4115 12.301C11.1344 12.9457 11.917 13.5176 12.7475 14.0079L11.9969 15.8855C10.9237 15.2781 9.91944 14.5524 8.99961 13.7249C7.21403 15.332 5.10914 16.5553 2.79891 17.2734L2.26257 15.3442C4.2385 14.7203 6.04543 13.6737 7.59042 12.3021C6.46277 11.0281 5.50873 9.57985 4.76742 8.00028L7.00684 8.00037C7.57018 9.03885 8.23979 10.0033 8.99967 10.877C10.2283 9.46508 11.2205 7.81616 11.9095 6.00101L2 6V4H8V2H10ZM17.5 12.8852L16.253 16H18.745L17.5 12.8852Z"
  }));
},
    GB = function GB(_ref2087) {
  var _ref2087$color = _ref2087.color,
      C = _ref2087$color === void 0 ? "currentColor" : _ref2087$color,
      _ref2087$size = _ref2087.size,
      e = _ref2087$size === void 0 ? 24 : _ref2087$size,
      l = _ref2087.className,
      i = _objectWithoutProperties(_ref2087, _excluded2087);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5 15V17C5 18.0544 5.81588 18.9182 6.85074 18.9945L7 19H10V21H7C4.79086 21 3 19.2091 3 17V15H5ZM18 10L22.4 21H20.245L19.044 18H14.954L13.755 21H11.601L16 10H18ZM17 12.8852L15.753 16H18.245L17 12.8852ZM8 2V4H12V11H8V14H6V11H2V4H6V2H8ZM17 3C19.2091 3 21 4.79086 21 7V9H19V7C19 5.89543 18.1046 5 17 5H14V3H17ZM6 6H4V9H6V6ZM10 6H8V9H10V6Z"
  }));
},
    IB = function IB(_ref2088) {
  var _ref2088$color = _ref2088.color,
      C = _ref2088$color === void 0 ? "currentColor" : _ref2088$color,
      _ref2088$size = _ref2088.size,
      e = _ref2088$size === void 0 ? 24 : _ref2088$size,
      l = _ref2088.className,
      i = _objectWithoutProperties(_ref2088, _excluded2088);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7.53705 9.95089L4.66155 7.0754L2.18667 9.55027L0.772461 8.13606L7.13642 1.77209L8.55064 3.18631L6.07576 5.66118L8.95126 8.53668C10.2131 7.57265 11.7898 7.00002 13.5004 7.00002C17.6425 7.00002 21.0004 10.3579 21.0004 14.5C21.0004 18.6422 17.6425 22 13.5004 22C9.35825 22 6.00038 18.6422 6.00038 14.5C6.00038 12.7895 6.57302 11.2127 7.53705 9.95089Z"
  }));
},
    WB = function WB(_ref2089) {
  var _ref2089$color = _ref2089.color,
      C = _ref2089$color === void 0 ? "currentColor" : _ref2089$color,
      _ref2089$size = _ref2089.size,
      e = _ref2089$size === void 0 ? 24 : _ref2089$size,
      l = _ref2089.className,
      i = _objectWithoutProperties(_ref2089, _excluded2089);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8.95126 8.53668C10.2131 7.57265 11.7898 7.00002 13.5004 7.00002C17.6425 7.00002 21.0004 10.3579 21.0004 14.5C21.0004 18.6422 17.6425 22 13.5004 22C9.35825 22 6.00038 18.6422 6.00038 14.5C6.00038 12.7895 6.57302 11.2127 7.53705 9.95089L4.66155 7.0754L2.18667 9.55027L0.772461 8.13606L7.13642 1.77209L8.55064 3.18631L6.07576 5.66118L8.95126 8.53668ZM13.5004 20C16.5379 20 19.0004 17.5376 19.0004 14.5C19.0004 11.4625 16.5379 9.00002 13.5004 9.00002C10.4628 9.00002 8.00038 11.4625 8.00038 14.5C8.00038 17.5376 10.4628 20 13.5004 20Z"
  }));
},
    OB = function OB(_ref2090) {
  var _ref2090$color = _ref2090.color,
      C = _ref2090$color === void 0 ? "currentColor" : _ref2090$color,
      _ref2090$size = _ref2090.size,
      e = _ref2090$size === void 0 ? 24 : _ref2090$size,
      l = _ref2090.className,
      i = _objectWithoutProperties(_ref2090, _excluded2090);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 5L9 2L15 5L21.303 2.2987C21.5569 2.18992 21.8508 2.30749 21.9596 2.56131C21.9862 2.62355 22 2.69056 22 2.75827V19L15 22L9 19L2.69696 21.7013C2.44314 21.8101 2.14921 21.6925 2.04043 21.4387C2.01375 21.3765 2 21.3094 2 21.2417V5ZM6 11V13H8V11H6ZM10 11V13H12V11H10ZM16 10.9393L14.7626 9.7019L13.7019 10.7626L14.9393 12L13.7019 13.2374L14.7626 14.2981L16 13.0607L17.2374 14.2981L18.2981 13.2374L17.0607 12L18.2981 10.7626L17.2374 9.7019L16 10.9393Z"
  }));
},
    KB = function KB(_ref2091) {
  var _ref2091$color = _ref2091.color,
      C = _ref2091$color === void 0 ? "currentColor" : _ref2091$color,
      _ref2091$size = _ref2091.size,
      e = _ref2091$size === void 0 ? 24 : _ref2091$size,
      l = _ref2091.className,
      i = _objectWithoutProperties(_ref2091, _excluded2091);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14.9352 7.20369L8.93524 4.20369L4 6.31879V18.9669L9.06476 16.7963L15.0648 19.7963L20 17.6812V5.03308L14.9352 7.20369ZM2 5L9 2L15 5L21.303 2.2987C21.5569 2.18992 21.8508 2.30749 21.9596 2.56131C21.9862 2.62355 22 2.69056 22 2.75827V19L15 22L9 19L2.69696 21.7013C2.44314 21.8101 2.14921 21.6925 2.04043 21.4387C2.01375 21.3765 2 21.3094 2 21.2417V5ZM6 11H8V13H6V11ZM10 11H12V13H10V11ZM15.9981 10.9374L17.2355 9.7L18.2962 10.7607L17.0588 11.9981L18.2962 13.2355L17.2355 14.2962L15.9981 13.0588L14.7607 14.2962L13.7 13.2355L14.9374 11.9981L13.7 10.7607L14.7607 9.7L15.9981 10.9374Z"
  }));
},
    QB = function QB(_ref2092) {
  var _ref2092$color = _ref2092.color,
      C = _ref2092$color === void 0 ? "currentColor" : _ref2092$color,
      _ref2092$size = _ref2092.size,
      e = _ref2092$size === void 0 ? 24 : _ref2092$size,
      l = _ref2092.className,
      i = _objectWithoutProperties(_ref2092, _excluded2092);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5.25098 3H18.751C19.993 3 21.001 4.00737 21.001 5.25V18.75C21.001 19.992 19.9935 21 18.751 21H5.25098C4.00898 21 3.00098 19.9925 3.00098 18.75V5.25C3.00098 4.008 4.00835 3 5.25098 3ZM13.171 6.42054V12.1795C13.171 12.7762 13.6545 13.26 14.2507 13.26H17.5812C18.1776 13.26 18.661 12.7765 18.661 12.1795V6.42054C18.661 5.82384 18.1774 5.34 17.5812 5.34H14.2507C13.6543 5.34 13.171 5.82348 13.171 6.42054ZM5.34098 6.42045V16.6796C5.34098 17.2762 5.82455 17.76 6.42071 17.76H9.75125C10.3476 17.76 10.831 17.277 10.831 16.6796V6.42045C10.831 5.82375 10.3474 5.34 9.75125 5.34H6.42071C5.82428 5.34 5.34098 5.82303 5.34098 6.42045Z"
  }));
},
    qB = function qB(_ref2093) {
  var _ref2093$color = _ref2093.color,
      C = _ref2093$color === void 0 ? "currentColor" : _ref2093$color,
      _ref2093$size = _ref2093.size,
      e = _ref2093$size === void 0 ? 24 : _ref2093$size,
      l = _ref2093.className,
      i = _objectWithoutProperties(_ref2093, _excluded2093);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5.00098 5V19H19.001V5H5.00098ZM5.00098 3H19.001C20.1055 3 21.001 3.89543 21.001 5V19C21.001 20.1046 20.1055 21 19.001 21H5.00098C3.89641 21 3.00098 20.1046 3.00098 19V5C3.00098 3.89543 3.89641 3 5.00098 3ZM8.00098 7H10.001C10.5533 7 11.001 7.44772 11.001 8V16C11.001 16.5523 10.5533 17 10.001 17H8.00098C7.44869 17 7.00098 16.5523 7.00098 16V8C7.00098 7.44772 7.44869 7 8.00098 7ZM14.001 7H16.001C16.5533 7 17.001 7.44772 17.001 8V12C17.001 12.5523 16.5533 13 16.001 13H14.001C13.4487 13 13.001 12.5523 13.001 12V8C13.001 7.44772 13.4487 7 14.001 7Z"
  }));
},
    jB = function jB(_ref2094) {
  var _ref2094$color = _ref2094.color,
      C = _ref2094$color === void 0 ? "currentColor" : _ref2094$color,
      _ref2094$size = _ref2094.size,
      e = _ref2094$size === void 0 ? 24 : _ref2094$size,
      l = _ref2094.className,
      i = _objectWithoutProperties(_ref2094, _excluded2094);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13.0049 16.9409V19.0027H18.0049V21.0027H6.00488V19.0027H11.0049V16.9409C7.05857 16.4488 4.00488 13.0824 4.00488 9.00275V3.00275H20.0049V9.00275C20.0049 13.0824 16.9512 16.4488 13.0049 16.9409ZM1.00488 5.00275H3.00488V9.00275H1.00488V5.00275ZM21.0049 5.00275H23.0049V9.00275H21.0049V5.00275Z"
  }));
},
    XB = function XB(_ref2095) {
  var _ref2095$color = _ref2095.color,
      C = _ref2095$color === void 0 ? "currentColor" : _ref2095$color,
      _ref2095$size = _ref2095.size,
      e = _ref2095$size === void 0 ? 24 : _ref2095$size,
      l = _ref2095.className,
      i = _objectWithoutProperties(_ref2095, _excluded2095);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13.0049 16.9409V19.0027H18.0049V21.0027H6.00488V19.0027H11.0049V16.9409C7.05857 16.4488 4.00488 13.0824 4.00488 9.00275V3.00275H20.0049V9.00275C20.0049 13.0824 16.9512 16.4488 13.0049 16.9409ZM6.00488 5.00275V9.00275C6.00488 12.3165 8.69117 15.0027 12.0049 15.0027C15.3186 15.0027 18.0049 12.3165 18.0049 9.00275V5.00275H6.00488ZM1.00488 5.00275H3.00488V9.00275H1.00488V5.00275ZM21.0049 5.00275H23.0049V9.00275H21.0049V5.00275Z"
  }));
},
    JB = function JB(_ref2096) {
  var _ref2096$color = _ref2096.color,
      C = _ref2096$color === void 0 ? "currentColor" : _ref2096$color,
      _ref2096$size = _ref2096.size,
      e = _ref2096$size === void 0 ? 24 : _ref2096$size,
      l = _ref2096.className,
      i = _objectWithoutProperties(_ref2096, _excluded2096);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17 8H20L23 12.0557V18H20.9646C20.7219 19.6961 19.2632 21 17.5 21C15.7368 21 14.2781 19.6961 14.0354 18H8.96456C8.72194 19.6961 7.26324 21 5.5 21C3.73676 21 2.27806 19.6961 2.03544 18H1V6C1 5.44772 1.44772 5 2 5H16C16.5523 5 17 5.44772 17 6V8ZM17 10V13H21V12.715L18.9917 10H17Z"
  }));
},
    YB = function YB(_ref2097) {
  var _ref2097$color = _ref2097.color,
      C = _ref2097$color === void 0 ? "currentColor" : _ref2097$color,
      _ref2097$size = _ref2097.size,
      e = _ref2097$size === void 0 ? 24 : _ref2097$size,
      l = _ref2097.className,
      i = _objectWithoutProperties(_ref2097, _excluded2097);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8.96456 18C8.72194 19.6961 7.26324 21 5.5 21C3.73676 21 2.27806 19.6961 2.03544 18H1V6C1 5.44772 1.44772 5 2 5H16C16.5523 5 17 5.44772 17 6V8H20L23 12.0557V18H20.9646C20.7219 19.6961 19.2632 21 17.5 21C15.7368 21 14.2781 19.6961 14.0354 18H8.96456ZM15 7H3V15.0505C3.63526 14.4022 4.52066 14 5.5 14C6.8962 14 8.10145 14.8175 8.66318 16H14.3368C14.5045 15.647 14.7296 15.3264 15 15.0505V7ZM17 13H21V12.715L18.9917 10H17V13ZM17.5 19C18.1531 19 18.7087 18.5826 18.9146 18C18.9699 17.8436 19 17.6753 19 17.5C19 16.6716 18.3284 16 17.5 16C16.6716 16 16 16.6716 16 17.5C16 17.6753 16.0301 17.8436 16.0854 18C16.2913 18.5826 16.8469 19 17.5 19ZM7 17.5C7 16.6716 6.32843 16 5.5 16C4.67157 16 4 16.6716 4 17.5C4 17.6753 4.03008 17.8436 4.08535 18C4.29127 18.5826 4.84689 19 5.5 19C6.15311 19 6.70873 18.5826 6.91465 18C6.96992 17.8436 7 17.6753 7 17.5Z"
  }));
},
    _B = function _B(_ref2098) {
  var _ref2098$color = _ref2098.color,
      C = _ref2098$color === void 0 ? "currentColor" : _ref2098$color,
      _ref2098$size = _ref2098.size,
      e = _ref2098$size === void 0 ? 24 : _ref2098$size,
      l = _ref2098.className,
      i = _objectWithoutProperties(_ref2098, _excluded2098);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.27051 7.62976C8.86829 7.07312 10.816 4.76401 10.816 2H13.8463V7.15152H17.4826V10.7879H13.8463V16.2424C13.8463 16.7566 14.044 17.4493 14.7554 17.9091C15.2296 18.2156 16.2397 18.3671 17.7857 18.3636V22H13.5432C11.0329 22 8.99778 19.9649 8.99778 17.4545V10.7879H6.27051V7.62976Z"
  }));
},
    $B = function $B(_ref2099) {
  var _ref2099$color = _ref2099.color,
      C = _ref2099$color === void 0 ? "currentColor" : _ref2099$color,
      _ref2099$size = _ref2099.size,
      e = _ref2099$size === void 0 ? 24 : _ref2099$size,
      l = _ref2099.className,
      i = _objectWithoutProperties(_ref2099, _excluded2099);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8.00098 8C9.07612 8 11.4983 7.32669 11.4983 3.5V2H12.9982V8H18.001V10H12.9982V12.9091C13.0013 15.3906 13.0013 16.596 13.001 17C12.9992 19.2084 14.6163 20.4 17.7861 20.4V22C17.1509 21.9992 16.4034 21.9992 15.5437 22C13.1417 22.0023 10.9982 19.9649 10.9982 17.4545V10H7.00098V8H8.00098Z"
  }));
},
    ef = function ef(_ref2100) {
  var _ref2100$color = _ref2100.color,
      C = _ref2100$color === void 0 ? "currentColor" : _ref2100$color,
      _ref2100$size = _ref2100.size,
      e = _ref2100$size === void 0 ? 24 : _ref2100$size,
      l = _ref2100.className,
      i = _objectWithoutProperties(_ref2100, _excluded2100);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 4.00087C2 3.44811 2.45531 3 2.9918 3H21.0082C21.556 3 22 3.44463 22 4.00087V17.9991C22 18.5519 21.5447 19 21.0082 19H2.9918C2.44405 19 2 18.5554 2 17.9991V4.00087ZM5 20H19V22H5V20Z"
  }));
},
    tf = function tf(_ref2101) {
  var _ref2101$color = _ref2101.color,
      C = _ref2101$color === void 0 ? "currentColor" : _ref2101$color,
      _ref2101$size = _ref2101.size,
      e = _ref2101$size === void 0 ? 24 : _ref2101$size,
      l = _ref2101.className,
      i = _objectWithoutProperties(_ref2101, _excluded2101);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 4.00087C2 3.44811 2.45531 3 2.9918 3H21.0082C21.556 3 22 3.44463 22 4.00087V17.9991C22 18.5519 21.5447 19 21.0082 19H2.9918C2.44405 19 2 18.5554 2 17.9991V4.00087ZM4 5V17H20V5H4ZM5 20H19V22H5V20Z"
  }));
},
    Cf = function Cf(_ref2102) {
  var _ref2102$color = _ref2102.color,
      C = _ref2102$color === void 0 ? "currentColor" : _ref2102$color,
      _ref2102$size = _ref2102.size,
      e = _ref2102$size === void 0 ? 24 : _ref2102$size,
      l = _ref2102.className,
      i = _objectWithoutProperties(_ref2102, _excluded2102);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15.4142 4.99998H21.0082C21.556 4.99998 22 5.44461 22 6.00085V19.9991C22 20.5519 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5553 2 19.9991V6.00085C2 5.44808 2.45531 4.99998 2.9918 4.99998H8.58579L6.05025 2.46445L7.46447 1.05023L11.4142 4.99998H12.5858L16.5355 1.05023L17.9497 2.46445L15.4142 4.99998Z"
  }));
},
    lf = function lf(_ref2103) {
  var _ref2103$color = _ref2103.color,
      C = _ref2103$color === void 0 ? "currentColor" : _ref2103$color,
      _ref2103$size = _ref2103.size,
      e = _ref2103$size === void 0 ? 24 : _ref2103$size,
      l = _ref2103.className,
      i = _objectWithoutProperties(_ref2103, _excluded2103);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15.4142 4.99998H21.0082C21.556 4.99998 22 5.44461 22 6.00085V19.9991C22 20.5519 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5553 2 19.9991V6.00085C2 5.44808 2.45531 4.99998 2.9918 4.99998H8.58579L6.05025 2.46445L7.46447 1.05023L11.4142 4.99998H12.5858L16.5355 1.05023L17.9497 2.46445L15.4142 4.99998ZM4 6.99998V19H20V6.99998H4Z"
  }));
},
    sf = function sf(_ref2104) {
  var _ref2104$color = _ref2104.color,
      C = _ref2104$color === void 0 ? "currentColor" : _ref2104$color,
      _ref2104$size = _ref2104.size,
      e = _ref2104$size === void 0 ? 24 : _ref2104$size,
      l = _ref2104.className,
      i = _objectWithoutProperties(_ref2104, _excluded2104);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21.001 3V14.7391L16.3053 19.4348H12.3923L9.95523 21.7826H6.91402V19.4348H3.00098V6.13043L4.2281 3H21.001ZM19.4358 4.56522H6.13141V16.3043H9.26185V18.6522L11.6097 16.3043H16.3053L19.4358 13.1739V4.56522ZM16.3053 7.69565V12.3913H14.7401V7.69565H16.3053ZM12.3923 7.69565V12.3913H10.8271V7.69565H12.3923Z"
  }));
},
    rf = function rf(_ref2105) {
  var _ref2105$color = _ref2105.color,
      C = _ref2105$color === void 0 ? "currentColor" : _ref2105$color,
      _ref2105$size = _ref2105.size,
      e = _ref2105$size === void 0 ? 24 : _ref2105$size,
      l = _ref2105.className,
      i = _objectWithoutProperties(_ref2105, _excluded2105);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4.30098 3H21.001V14.7L16.301 19.4H12.401L9.90098 21.8H7.00098V19.4H3.00098V6.2L4.30098 3ZM5.00098 17.4H9.00098V19.8H9.09636L11.5964 17.4H15.4725L19.001 13.8716V5H5.00098V17.4ZM15.001 8H17.001V12.7H15.001V8ZM15.001 8H17.001V12.7H15.001V8ZM10.001 8H12.001V12.7H10.001V8Z"
  }));
},
    cf = function cf(_ref2106) {
  var _ref2106$color = _ref2106.color,
      C = _ref2106$color === void 0 ? "currentColor" : _ref2106$color,
      _ref2106$size = _ref2106.size,
      e = _ref2106$size === void 0 ? 24 : _ref2106$size,
      l = _ref2106.className,
      i = _objectWithoutProperties(_ref2106, _excluded2106);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22.2125 5.65605C21.4491 5.99375 20.6395 6.21555 19.8106 6.31411C20.6839 5.79132 21.3374 4.9689 21.6493 4.00005C20.8287 4.48761 19.9305 4.83077 18.9938 5.01461C18.2031 4.17106 17.098 3.69303 15.9418 3.69434C13.6326 3.69434 11.7597 5.56661 11.7597 7.87683C11.7597 8.20458 11.7973 8.52242 11.8676 8.82909C8.39047 8.65404 5.31007 6.99005 3.24678 4.45941C2.87529 5.09767 2.68005 5.82318 2.68104 6.56167C2.68104 8.01259 3.4196 9.29324 4.54149 10.043C3.87737 10.022 3.22788 9.84264 2.64718 9.51973C2.64654 9.5373 2.64654 9.55487 2.64654 9.57148C2.64654 11.5984 4.08819 13.2892 6.00199 13.6731C5.6428 13.7703 5.27232 13.8194 4.90022 13.8191C4.62997 13.8191 4.36771 13.7942 4.11279 13.7453C4.64531 15.4065 6.18886 16.6159 8.0196 16.6491C6.53813 17.8118 4.70869 18.4426 2.82543 18.4399C2.49212 18.4402 2.15909 18.4205 1.82812 18.3811C3.74004 19.6102 5.96552 20.2625 8.23842 20.2601C15.9316 20.2601 20.138 13.8875 20.138 8.36111C20.138 8.1803 20.1336 7.99886 20.1256 7.81997C20.9443 7.22845 21.651 6.49567 22.2125 5.65605Z"
  }));
},
    of = function of(_ref2107) {
  var _ref2107$color = _ref2107.color,
      C = _ref2107$color === void 0 ? "currentColor" : _ref2107$color,
      _ref2107$size = _ref2107.size,
      e = _ref2107$size === void 0 ? 24 : _ref2107$size,
      l = _ref2107.className,
      i = _objectWithoutProperties(_ref2107, _excluded2107);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15.3499 5.55005C13.7681 5.55005 12.4786 6.81809 12.4504 8.39658L12.4223 9.97162C12.4164 10.3029 12.143 10.5667 11.8117 10.5608C11.7881 10.5604 11.7646 10.5586 11.7413 10.5554L10.1805 10.3426C8.12699 10.0625 6.15883 9.11736 4.27072 7.54411C3.67275 10.8538 4.84 13.1472 7.65342 14.916L9.40041 16.0142C9.68095 16.1906 9.7654 16.561 9.58903 16.8415C9.54861 16.9058 9.49636 16.9619 9.43504 17.0067L7.84338 18.1696C8.78973 18.229 9.68938 18.1875 10.435 18.0387C15.1526 17.0973 18.2897 13.547 18.2897 7.69109C18.2897 7.213 17.2774 5.55005 15.3499 5.55005ZM10.4507 8.3609C10.4983 5.69584 12.6735 3.55005 15.3499 3.55005C16.7132 3.55005 17.9465 4.10683 18.8348 5.0054C19.5462 5.00005 20.1514 5.17991 21.5035 4.35967C21.1693 6.00005 21.0034 6.71201 20.2897 7.69109C20.2897 15.3326 15.5926 19.0489 10.8264 20C7.5587 20.6522 2.80646 19.5815 1.44531 18.1587C2.13874 18.1054 4.95928 17.802 6.58895 16.6092C5.20994 15.6987 -0.278631 12.4681 3.32772 3.78642C5.02119 5.76307 6.73797 7.10855 8.47807 7.82286C9.63548 8.29798 9.91978 8.2885 10.4507 8.3609Z"
  }));
},
    af = function af(_ref2108) {
  var _ref2108$color = _ref2108.color,
      C = _ref2108$color === void 0 ? "currentColor" : _ref2108$color,
      _ref2108$size = _ref2108.size,
      e = _ref2108$size === void 0 ? 24 : _ref2108$size,
      l = _ref2108.className,
      i = _objectWithoutProperties(_ref2108, _excluded2108);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17.6544 1.70001L14.8716 4.23315C16.147 4.62331 17.3453 5.28102 18.3612 6.20626C21.8744 9.40606 21.8744 14.594 18.3612 17.7938C15.7696 20.1542 11.7644 21.6563 6.3456 22.3L9.12838 19.7669C7.85304 19.3767 6.65466 18.719 5.6388 17.7938C2.1256 14.594 2.1048 9.42501 5.6388 6.20626C8.2304 3.84585 12.2356 2.34376 17.6544 1.70001ZM12 8.00001C9.51472 8.00001 7.5 9.79087 7.5 12C7.5 14.2092 9.51472 16 12 16C14.4853 16 16.5 14.2092 16.5 12C16.5 9.79087 14.4853 8.00001 12 8.00001Z"
  }));
},
    nf = function nf(_ref2109) {
  var _ref2109$color = _ref2109.color,
      C = _ref2109$color === void 0 ? "currentColor" : _ref2109$color,
      _ref2109$size = _ref2109.size,
      e = _ref2109$size === void 0 ? 24 : _ref2109$size,
      l = _ref2109.className,
      i = _objectWithoutProperties(_ref2109, _excluded2109);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17.6544 1.70001L14.8716 4.23315C16.147 4.62331 17.3453 5.28102 18.3612 6.20626C21.8744 9.40606 21.8744 14.594 18.3612 17.7938C15.7696 20.1542 11.7644 21.6563 6.3456 22.3L9.12838 19.7669C7.85304 19.3767 6.65466 18.719 5.6388 17.7938C2.1256 14.594 2.1048 9.42501 5.6388 6.20626C8.2304 3.84585 12.2356 2.34376 17.6544 1.70001ZM12 6.00001C8.13401 6.00001 5 8.6863 5 12C5 15.3137 8.13401 18 12 18C15.866 18 19 15.3137 19 12C19 8.6863 15.866 6.00001 12 6.00001ZM12 8.30001C14.2091 8.30001 16 9.95656 16 12C16 14.0435 14.2091 15.7 12 15.7C9.79086 15.7 8 14.0435 8 12C8 9.95656 9.79086 8.30001 12 8.30001ZM12 10.3C10.8621 10.3 10 11.0975 10 12C10 12.9026 10.8621 13.7 12 13.7C13.1379 13.7 14 12.9026 14 12C14 11.0975 13.1379 10.3 12 10.3Z"
  }));
},
    mf = function mf(_ref2110) {
  var _ref2110$color = _ref2110.color,
      C = _ref2110$color === void 0 ? "currentColor" : _ref2110$color,
      _ref2110$size = _ref2110.size,
      e = _ref2110$size === void 0 ? 24 : _ref2110$size,
      l = _ref2110.className,
      i = _objectWithoutProperties(_ref2110, _excluded2110);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 12H20C20.5523 12 21 12.4477 21 13V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V13C3 12.4477 3.44772 12 4 12ZM5 2H19V10H5V2ZM9 5V7H11V5H9ZM13 5V7H15V5H13Z"
  }));
},
    wf = function wf(_ref2111) {
  var _ref2111$color = _ref2111.color,
      C = _ref2111$color === void 0 ? "currentColor" : _ref2111$color,
      _ref2111$size = _ref2111.size,
      e = _ref2111$size === void 0 ? 24 : _ref2111$size,
      l = _ref2111.className,
      i = _objectWithoutProperties(_ref2111, _excluded2111);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19 12H5V20H19V12ZM5 10V2H19V10H20C20.5523 10 21 10.4477 21 11V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V11C3 10.4477 3.44772 10 4 10H5ZM7 10H17V4H7V10ZM9 6H11V8H9V6ZM13 6H15V8H13V6Z"
  }));
},
    Lf = function Lf(_ref2112) {
  var _ref2112$color = _ref2112.color,
      C = _ref2112$color === void 0 ? "currentColor" : _ref2112$color,
      _ref2112$size = _ref2112.size,
      e = _ref2112$size === void 0 ? 24 : _ref2112$size,
      l = _ref2112.className,
      i = _objectWithoutProperties(_ref2112, _excluded2112);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22.001 12C22.001 17.5224 17.524 22 12.001 22C6.47798 22 2.00098 17.5224 2.00098 12C2.00098 6.4771 6.47833 2 12.001 2C17.524 2 22.001 6.4771 22.001 12ZM5.20128 10.6642C4.46363 10.6642 3.86613 11.2623 3.86613 12C3.86613 12.7372 4.46363 13.3349 5.20128 13.3349C5.93848 13.3349 6.53628 12.7372 6.53628 12C6.53628 11.2622 5.93848 10.6642 5.20128 10.6642ZM14.7337 16.7325C14.0954 17.1015 13.8763 17.9175 14.2454 18.5558C14.6137 19.1942 15.4296 19.4137 16.0682 19.0448C16.7067 18.6759 16.9257 17.8595 16.5571 17.2208C16.1884 16.5832 15.3721 16.3644 14.7337 16.7325V16.7325ZM8.10133 12C8.10133 10.6808 8.75663 9.5152 9.75958 8.80915L8.78348 7.174C7.61518 7.955 6.74598 9.1485 6.38498 10.545C6.80648 10.8895 7.07613 11.4131 7.07613 12C7.07613 12.586 6.80643 13.1097 6.38493 13.4543C6.74583 14.8516 7.61503 16.0448 8.78343 16.826L9.75953 15.1903C8.75653 14.4848 8.10128 13.32 8.10128 12L8.10133 12ZM12.001 8.09975C14.0385 8.09975 15.7098 9.66175 15.8853 11.654L17.788 11.6261C17.6942 10.1551 17.0518 8.83495 16.0645 7.86435C15.5568 8.05565 14.9705 8.02685 14.4637 7.7342C13.9559 7.4412 13.6376 6.9472 13.5506 6.4104C13.0571 6.27455 12.538 6.2005 12.001 6.2005C11.0782 6.2005 10.2053 6.41685 9.43058 6.80035L10.3582 8.46275C10.8577 8.23045 11.4141 8.09975 12.001 8.09975ZM12.001 15.8995C11.4141 15.8995 10.8576 15.7691 10.3585 15.537L9.43063 17.1991C10.2055 17.5831 11.0782 17.8004 12.001 17.8004C12.538 17.8004 13.0575 17.7255 13.5506 17.5888C13.6376 17.0526 13.9561 16.5586 14.4638 16.2652C14.971 15.9726 15.5569 15.9435 16.0646 16.1349C17.0519 15.1642 17.6942 13.8441 17.7881 12.3732L15.8846 12.3456C15.7099 14.338 14.0386 15.8996 12.0011 15.8996L12.001 15.8995ZM14.7334 7.26675C15.372 7.6349 16.1883 7.4169 16.5566 6.77845C16.9257 6.1396 16.7071 5.32395 16.0683 4.95505C15.4296 4.58605 14.6138 4.8048 14.2447 5.44345C13.8763 6.08195 14.0954 6.89795 14.7334 7.2667V7.26675Z"
  }));
},
    hf = function hf(_ref2113) {
  var _ref2113$color = _ref2113.color,
      C = _ref2113$color === void 0 ? "currentColor" : _ref2113$color,
      _ref2113$size = _ref2113.size,
      e = _ref2113$size === void 0 ? 24 : _ref2113$size,
      l = _ref2113.className,
      i = _objectWithoutProperties(_ref2113, _excluded2113);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8.66784 19.2731L9.67371 17.5309C12.4214 18.6911 15.6673 17.6497 17.1971 15C17.6099 14.2851 17.8588 13.5206 17.9555 12.75H19.9677C19.8637 13.8618 19.5241 14.9695 18.9292 16C18.5267 16.6971 18.035 17.3108 17.477 17.8349C16.8385 17.6413 16.1244 17.7022 15.501 18.0621C14.8783 18.4216 14.4688 19.0086 14.3168 19.6575C12.4998 20.2066 10.4923 20.1118 8.66784 19.2731ZM7.3688 18.5231C5.73024 17.3624 4.64445 15.6713 4.21148 13.8232C4.69743 13.3671 5.00098 12.719 5.00098 12C5.00098 11.2801 4.69669 10.6312 4.20973 10.1751C4.38459 9.42975 4.67025 8.69715 5.07277 7.99995C5.66768 6.96954 6.4572 6.12154 7.3681 5.47557L8.3742 7.2182C7.75517 7.68729 7.21755 8.28509 6.80482 8.99995C5.27497 11.6497 5.996 14.9814 8.37467 16.7809L7.3688 18.5231ZM8.66779 4.72671C10.4122 3.92909 12.4225 3.76619 14.3163 4.34045C14.4679 4.99011 14.8776 5.57789 15.501 5.93778C16.1243 6.29766 16.8382 6.3586 17.4766 6.16508C18.9209 7.51805 19.785 9.34047 19.9664 11.25H17.9542C17.7265 9.45286 16.6908 7.77941 15.001 6.8038C13.3112 5.82819 11.3441 5.76797 9.67386 6.46927L8.66779 4.72671ZM16.001 5.07175C15.2835 4.65754 15.0377 3.74015 15.4519 3.02271C15.8662 2.30527 16.7835 2.05946 17.501 2.47367C18.2184 2.88789 18.4642 3.80527 18.05 4.52271C17.6358 5.24015 16.7184 5.48596 16.001 5.07175ZM4.00098 12C4.00098 12.8284 3.3294 13.5 2.50098 13.5C1.67255 13.5 1.00098 12.8284 1.00098 12C1.00098 11.1715 1.67255 10.5 2.50098 10.5C3.3294 10.5 4.00098 11.1715 4.00098 12ZM16.001 18.9282C16.7184 18.5139 17.6358 18.7598 18.05 19.4772C18.4642 20.1946 18.2184 21.112 17.501 21.5262C16.7835 21.9404 15.8662 21.6946 15.4519 20.9772C15.0377 20.2598 15.2835 19.3424 16.001 18.9282Z"
  }));
},
    Hf = function Hf(_ref2114) {
  var _ref2114$color = _ref2114.color,
      C = _ref2114$color === void 0 ? "currentColor" : _ref2114$color,
      _ref2114$size = _ref2114.size,
      e = _ref2114$size === void 0 ? 24 : _ref2114$size,
      l = _ref2114.className,
      i = _objectWithoutProperties(_ref2114, _excluded2114);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.998 2.04938C18.0514 2.5511 21.998 6.81465 21.998 12V13H12.998V19C12.998 20.1046 13.8935 21 14.998 21C16.1026 21 16.998 20.1046 16.998 19V18H18.998V19C18.998 21.2091 17.2072 23 14.998 23C12.7889 23 10.998 21.2091 10.998 19V13H1.99805V12C1.99805 6.81465 5.94472 2.5511 10.998 2.04938V2C10.998 1.44772 11.4458 1 11.998 1C12.5503 1 12.998 1.44772 12.998 2V2.04938Z"
  }));
},
    Vf = function Vf(_ref2115) {
  var _ref2115$color = _ref2115.color,
      C = _ref2115$color === void 0 ? "currentColor" : _ref2115$color,
      _ref2115$size = _ref2115.size,
      e = _ref2115$size === void 0 ? 24 : _ref2115$size,
      l = _ref2115.className,
      i = _objectWithoutProperties(_ref2115, _excluded2115);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.998 2.04938C18.0514 2.5511 21.998 6.81465 21.998 12V13H12.998V19C12.998 20.1046 13.8935 21 14.998 21C16.1026 21 16.998 20.1046 16.998 19V18H18.998V19C18.998 21.2091 17.2072 23 14.998 23C12.7889 23 10.998 21.2091 10.998 19V13H1.99805V12C1.99805 6.81465 5.94472 2.5511 10.998 2.04938V2C10.998 1.44772 11.4458 1 11.998 1C12.5503 1 12.998 1.44772 12.998 2V2.04938ZM19.9362 11C19.4441 7.05369 16.0777 4 11.998 4C7.91843 4 4.55204 7.05369 4.05994 11H19.9362Z"
  }));
},
    gf = function gf(_ref2116) {
  var _ref2116$color = _ref2116.color,
      C = _ref2116$color === void 0 ? "currentColor" : _ref2116$color,
      _ref2116$size = _ref2116.size,
      e = _ref2116$size === void 0 ? 24 : _ref2116$size,
      l = _ref2116.className,
      i = _objectWithoutProperties(_ref2116, _excluded2116);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8 3V12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12V3H18V12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12V3H8ZM4 20H20V22H4V20Z"
  }));
},
    Mf = function Mf(_ref2117) {
  var _ref2117$color = _ref2117.color,
      C = _ref2117$color === void 0 ? "currentColor" : _ref2117$color,
      _ref2117$size = _ref2117.size,
      e = _ref2117$size === void 0 ? 24 : _ref2117$size,
      l = _ref2117.className,
      i = _objectWithoutProperties(_ref2117, _excluded2117);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 2C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V3C3 2.44772 3.44772 2 4 2H20ZM19 16H5V20H19V16ZM17 17V19H15V17H17ZM12 2L8 6H11V11H13V6H16L12 2Z"
  }));
},
    Zf = function Zf(_ref2118) {
  var _ref2118$color = _ref2118.color,
      C = _ref2118$color === void 0 ? "currentColor" : _ref2118$color,
      _ref2118$size = _ref2118.size,
      e = _ref2118$size === void 0 ? 24 : _ref2118$size,
      l = _ref2118.className,
      i = _objectWithoutProperties(_ref2118, _excluded2118);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8 2V4H5L4.999 14H18.999L19 4H16V2H20C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V3C3 2.44772 3.44772 2 4 2H8ZM18.999 16H4.999L5 20H19L18.999 16ZM17 17V19H15V17H17ZM12 2L16 6H13V11H11V6H8L12 2Z"
  }));
},
    xf = function xf(_ref2119) {
  var _ref2119$color = _ref2119.color,
      C = _ref2119$color === void 0 ? "currentColor" : _ref2119$color,
      _ref2119$size = _ref2119.size,
      e = _ref2119$size === void 0 ? 24 : _ref2119$size,
      l = _ref2119.className,
      i = _objectWithoutProperties(_ref2119, _excluded2119);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8.50098 11V16H15.501V11H21.001V21H3.00098V11H8.50098ZM15.501 3V8H8.50098V3H15.501Z"
  }));
},
    vf = function vf(_ref2120) {
  var _ref2120$color = _ref2120.color,
      C = _ref2120$color === void 0 ? "currentColor" : _ref2120$color,
      _ref2120$size = _ref2120.size,
      e = _ref2120$size === void 0 ? 24 : _ref2120$size,
      l = _ref2120.className,
      i = _objectWithoutProperties(_ref2120, _excluded2120);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10.001 10V14H14.0002L14.0012 10H21.0012L21.0002 14L21.001 21H3.00098V10H10.001ZM8.00098 12H5.00098V19H19.001V16L19.0007 12H16.0007L15.9997 16H8.00098V12ZM16.001 3V9H8.00098V3H16.001ZM14.001 5H10.001V7H14.001V5Z"
  }));
},
    df = function df(_ref2121) {
  var _ref2121$color = _ref2121.color,
      C = _ref2121$color === void 0 ? "currentColor" : _ref2121$color,
      _ref2121$size = _ref2121.size,
      e = _ref2121$size === void 0 ? 24 : _ref2121$size,
      l = _ref2121.className,
      i = _objectWithoutProperties(_ref2121, _excluded2121);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 19H20V12H22V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V12H4V19ZM14 9V15H10V9H5L12 2L19 9H14Z"
  }));
},
    pf = function pf(_ref2122) {
  var _ref2122$color = _ref2122.color,
      C = _ref2122$color === void 0 ? "currentColor" : _ref2122$color,
      _ref2122$size = _ref2122.size,
      e = _ref2122$size === void 0 ? 24 : _ref2122$size,
      l = _ref2122.className,
      i = _objectWithoutProperties(_ref2122, _excluded2122);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 19H20V12H22V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V12H4V19ZM13 9V16H11V9H6L12 3L18 9H13Z"
  }));
},
    Ef = function Ef(_ref2123) {
  var _ref2123$color = _ref2123.color,
      C = _ref2123$color === void 0 ? "currentColor" : _ref2123$color,
      _ref2123$size = _ref2123.size,
      e = _ref2123$size === void 0 ? 24 : _ref2123$size,
      l = _ref2123.className,
      i = _objectWithoutProperties(_ref2123, _excluded2123);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 12.5858L16.2426 16.8284L14.8284 18.2426L13 16.415V22H11V16.413L9.17157 18.2426L7.75736 16.8284L12 12.5858ZM12 2C15.5934 2 18.5544 4.70761 18.9541 8.19395C21.2858 8.83154 23 10.9656 23 13.5C23 16.3688 20.8036 18.7246 18.0006 18.9776L18 17C18 13.6863 15.3137 11 12 11C8.7616 11 6.12243 13.5656 6.00414 16.7751L6 17L6.00039 18.9776C3.19696 18.7252 1 16.3692 1 13.5C1 10.9656 2.71424 8.83154 5.04648 8.19411C5.44561 4.70761 8.40661 2 12 2Z"
  }));
},
    Nf = function Nf(_ref2124) {
  var _ref2124$color = _ref2124.color,
      C = _ref2124$color === void 0 ? "currentColor" : _ref2124$color,
      _ref2124$size = _ref2124.size,
      e = _ref2124$size === void 0 ? 24 : _ref2124$size,
      l = _ref2124.className,
      i = _objectWithoutProperties(_ref2124, _excluded2124);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 12.5858L16.2426 16.8284L14.8284 18.2426L13 16.415V22H11V16.413L9.17157 18.2426L7.75736 16.8284L12 12.5858ZM12 2C15.5934 2 18.5544 4.70761 18.9541 8.19395C21.2858 8.83154 23 10.9656 23 13.5C23 16.3688 20.8036 18.7246 18.0006 18.9776L18.0009 16.9644C19.6966 16.7214 21 15.2629 21 13.5C21 11.567 19.433 10 17.5 10C17.2912 10 17.0867 10.0183 16.8887 10.054C16.9616 9.7142 17 9.36158 17 9C17 6.23858 14.7614 4 12 4C9.23858 4 7 6.23858 7 9C7 9.36158 7.03838 9.7142 7.11205 10.0533C6.91331 10.0183 6.70879 10 6.5 10C4.567 10 3 11.567 3 13.5C3 15.2003 4.21241 16.6174 5.81986 16.934L6.00005 16.9646L6.00039 18.9776C3.19696 18.7252 1 16.3692 1 13.5C1 10.9656 2.71424 8.83154 5.04648 8.19411C5.44561 4.70761 8.40661 2 12 2Z"
  }));
},
    uf = function uf(_ref2125) {
  var _ref2125$color = _ref2125.color,
      C = _ref2125$color === void 0 ? "currentColor" : _ref2125$color,
      _ref2125$size = _ref2125.size,
      e = _ref2125$size === void 0 ? 24 : _ref2125$size,
      l = _ref2125.className,
      i = _objectWithoutProperties(_ref2125, _excluded2125);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7 20.9811C3.64378 20.7257 1 17.9216 1 14.5C1 12.1716 2.22429 10.1291 4.06426 8.9812C4.56469 5.044 7.92686 2 12 2C16.0731 2 19.4353 5.044 19.9357 8.9812C21.7757 10.1291 23 12.1716 23 14.5C23 17.9216 20.3562 20.7257 17 20.9811V21H7V20.9811ZM13 13H16L12 8L8 13H11V17H13V13Z"
  }));
},
    Bf = function Bf(_ref2126) {
  var _ref2126$color = _ref2126.color,
      C = _ref2126$color === void 0 ? "currentColor" : _ref2126$color,
      _ref2126$size = _ref2126.size,
      e = _ref2126$size === void 0 ? 24 : _ref2126$size,
      l = _ref2126.className,
      i = _objectWithoutProperties(_ref2126, _excluded2126);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M1 14.5C1 12.1716 2.22429 10.1291 4.06426 8.9812C4.56469 5.044 7.92686 2 12 2C16.0731 2 19.4353 5.044 19.9357 8.9812C21.7757 10.1291 23 12.1716 23 14.5C23 17.9216 20.3562 20.7257 17 20.9811L7 21C3.64378 20.7257 1 17.9216 1 14.5ZM16.8483 18.9868C19.1817 18.8093 21 16.8561 21 14.5C21 12.927 20.1884 11.4962 18.8771 10.6781L18.0714 10.1754L17.9517 9.23338C17.5735 6.25803 15.0288 4 12 4C8.97116 4 6.42647 6.25803 6.0483 9.23338L5.92856 10.1754L5.12288 10.6781C3.81156 11.4962 3 12.927 3 14.5C3 16.8561 4.81833 18.8093 7.1517 18.9868L7.325 19H16.675L16.8483 18.9868ZM13 13V17H11V13H8L12 8L16 13H13Z"
  }));
},
    ff = function ff(_ref2127) {
  var _ref2127$color = _ref2127.color,
      C = _ref2127$color === void 0 ? "currentColor" : _ref2127$color,
      _ref2127$size = _ref2127.size,
      e = _ref2127$size === void 0 ? 24 : _ref2127$size,
      l = _ref2127.className,
      i = _objectWithoutProperties(_ref2127, _excluded2127);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 19H21V21H3V19ZM13 10V18H11V10H4L12 2L20 10H13Z"
  }));
},
    Rf = function Rf(_ref2128) {
  var _ref2128$color = _ref2128.color,
      C = _ref2128$color === void 0 ? "currentColor" : _ref2128$color,
      _ref2128$size = _ref2128.size,
      e = _ref2128$size === void 0 ? 24 : _ref2128$size,
      l = _ref2128.className,
      i = _objectWithoutProperties(_ref2128, _excluded2128);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 19H21V21H3V19ZM13 5.82843V17H11V5.82843L4.92893 11.8995L3.51472 10.4853L12 2L20.4853 10.4853L19.0711 11.8995L13 5.82843Z"
  }));
},
    zf = function zf(_ref2129) {
  var _ref2129$color = _ref2129.color,
      C = _ref2129$color === void 0 ? "currentColor" : _ref2129$color,
      _ref2129$size = _ref2129.size,
      e = _ref2129$size === void 0 ? 24 : _ref2129$size,
      l = _ref2129.className,
      i = _objectWithoutProperties(_ref2129, _excluded2129);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 1L15 6H13V13.381L16 11.882L15.999 11H15V7H19V11H17.999L18 13.118L13 15.618L13.0009 17.171C14.1656 17.5831 15 18.6941 15 20C15 21.6569 13.6569 23 12 23C10.3431 23 9 21.6569 9 20C9 18.813 9.68934 17.7871 10.6895 17.3006L6 14L5.99892 11.7318C5.40172 11.3858 5 10.7398 5 10C5 8.89543 5.89543 8 7 8C8.10457 8 9 8.89543 9 10C9 10.7403 8.59783 11.3866 8.00007 11.7324L8 13L11 15.086V6H9L12 1Z"
  }));
},
    Ff = function Ff(_ref2130) {
  var _ref2130$color = _ref2130.color,
      C = _ref2130$color === void 0 ? "currentColor" : _ref2130$color,
      _ref2130$size = _ref2130.size,
      e = _ref2130$size === void 0 ? 24 : _ref2130$size,
      l = _ref2130.className,
      i = _objectWithoutProperties(_ref2130, _excluded2130);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 1L15 6H13V13.381L16 11.882L15.999 11H15V7H19V11H17.999L18 13.118L13 15.618L13.0009 17.171C14.1656 17.5831 15 18.6941 15 20C15 21.6569 13.6569 23 12 23C10.3431 23 9 21.6569 9 20C9 18.813 9.68934 17.7871 10.6895 17.3006L6 14L5.99892 11.7318C5.40172 11.3858 5 10.7398 5 10C5 8.89543 5.89543 8 7 8C8.10457 8 9 8.89543 9 10C9 10.7403 8.59783 11.3866 8.00007 11.7324L8 13L11 15.086V6H9L12 1ZM12 19C11.4477 19 11 19.4477 11 20C11 20.5523 11.4477 21 12 21C12.5523 21 13 20.5523 13 20C13 19.4477 12.5523 19 12 19Z"
  }));
},
    Sf = function Sf(_ref2131) {
  var _ref2131$color = _ref2131.color,
      C = _ref2131$color === void 0 ? "currentColor" : _ref2131$color,
      _ref2131$size = _ref2131.size,
      e = _ref2131$size === void 0 ? 24 : _ref2131$size,
      l = _ref2131.className,
      i = _objectWithoutProperties(_ref2131, _excluded2131);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11 14.0619V20H13V14.0619C16.9463 14.554 20 17.9204 20 22H4C4 17.9204 7.05369 14.554 11 14.0619ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13Z"
  }));
},
    Af = function Af(_ref2132) {
  var _ref2132$color = _ref2132.color,
      C = _ref2132$color === void 0 ? "currentColor" : _ref2132$color,
      _ref2132$size = _ref2132.size,
      e = _ref2132$size === void 0 ? 24 : _ref2132$size,
      l = _ref2132.className,
      i = _objectWithoutProperties(_ref2132, _excluded2132);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 22C4 17.5817 7.58172 14 12 14C16.4183 14 20 17.5817 20 22H4ZM13 16.083V20H17.6586C16.9423 17.9735 15.1684 16.4467 13 16.083ZM11 20V16.083C8.83165 16.4467 7.05766 17.9735 6.34141 20H11ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM12 11C14.2104 11 16 9.21043 16 7C16 4.78957 14.2104 3 12 3C9.78957 3 8 4.78957 8 7C8 9.21043 9.78957 11 12 11Z"
  }));
},
    kf = function kf(_ref2133) {
  var _ref2133$color = _ref2133.color,
      C = _ref2133$color === void 0 ? "currentColor" : _ref2133$color,
      _ref2133$size = _ref2133.size,
      e = _ref2133$size === void 0 ? 24 : _ref2133$size,
      l = _ref2133.className,
      i = _objectWithoutProperties(_ref2133, _excluded2133);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 22H4V20C4 17.2386 6.23858 15 9 15H15C17.7614 15 20 17.2386 20 20V22ZM12 13C8.68629 13 6 10.3137 6 7C6 3.68629 8.68629 1 12 1C15.3137 1 18 3.68629 18 7C18 10.3137 15.3137 13 12 13Z"
  }));
},
    Pf = function Pf(_ref2134) {
  var _ref2134$color = _ref2134.color,
      C = _ref2134$color === void 0 ? "currentColor" : _ref2134$color,
      _ref2134$size = _ref2134.size,
      e = _ref2134$size === void 0 ? 24 : _ref2134$size,
      l = _ref2134.className,
      i = _objectWithoutProperties(_ref2134, _excluded2134);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 22H18V20C18 18.3431 16.6569 17 15 17H9C7.34315 17 6 18.3431 6 20V22H4V20C4 17.2386 6.23858 15 9 15H15C17.7614 15 20 17.2386 20 20V22ZM12 13C8.68629 13 6 10.3137 6 7C6 3.68629 8.68629 1 12 1C15.3137 1 18 3.68629 18 7C18 10.3137 15.3137 13 12 13ZM12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z"
  }));
},
    Df = function Df(_ref2135) {
  var _ref2135$color = _ref2135.color,
      C = _ref2135$color === void 0 ? "currentColor" : _ref2135$color,
      _ref2135$size = _ref2135.size,
      e = _ref2135$size === void 0 ? 24 : _ref2135$size,
      l = _ref2135.className,
      i = _objectWithoutProperties(_ref2135, _excluded2135);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5 20H19V22H5V20ZM12 18C7.58172 18 4 14.4183 4 10C4 5.58172 7.58172 2 12 2C16.4183 2 20 5.58172 20 10C20 14.4183 16.4183 18 12 18Z"
  }));
},
    yf = function yf(_ref2136) {
  var _ref2136$color = _ref2136.color,
      C = _ref2136$color === void 0 ? "currentColor" : _ref2136$color,
      _ref2136$size = _ref2136.size,
      e = _ref2136$size === void 0 ? 24 : _ref2136$size,
      l = _ref2136.className,
      i = _objectWithoutProperties(_ref2136, _excluded2136);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5 20H19V22H5V20ZM12 18C7.58172 18 4 14.4183 4 10C4 5.58172 7.58172 2 12 2C16.4183 2 20 5.58172 20 10C20 14.4183 16.4183 18 12 18ZM12 16C15.3137 16 18 13.3137 18 10C18 6.68629 15.3137 4 12 4C8.68629 4 6 6.68629 6 10C6 13.3137 8.68629 16 12 16Z"
  }));
},
    bf = function bf(_ref2137) {
  var _ref2137$color = _ref2137.color,
      C = _ref2137$color === void 0 ? "currentColor" : _ref2137$color,
      _ref2137$size = _ref2137.size,
      e = _ref2137$size === void 0 ? 24 : _ref2137$size,
      l = _ref2137.className,
      i = _objectWithoutProperties(_ref2137, _excluded2137);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7.38938 16.5386C5.33894 15.0901 4 12.7014 4 10C4 5.58172 7.58172 2 12 2C16.4183 2 20 5.58172 20 10C20 12.7014 18.6611 15.0901 16.6106 16.5386L18.6936 21.2996C18.8043 21.5526 18.6889 21.8474 18.4359 21.9581C18.3727 21.9857 18.3045 22 18.2355 22H5.76451C5.48837 22 5.26451 21.7761 5.26451 21.5C5.26451 21.431 5.27878 21.3628 5.30643 21.2996L7.38938 16.5386ZM8.11851 10.9704C8.55217 12.7106 10.1255 14 12 14C13.8745 14 15.4478 12.7106 15.8815 10.9704L13.9407 10.4852C13.7239 11.3553 12.9372 12 12 12C11.0628 12 10.2761 11.3553 10.0593 10.4852L8.11851 10.9704Z"
  }));
},
    Tf = function Tf(_ref2138) {
  var _ref2138$color = _ref2138.color,
      C = _ref2138$color === void 0 ? "currentColor" : _ref2138$color,
      _ref2138$size = _ref2138.size,
      e = _ref2138$size === void 0 ? 24 : _ref2138$size,
      l = _ref2138.className,
      i = _objectWithoutProperties(_ref2138, _excluded2138);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7.38938 16.5386C5.33894 15.0901 4 12.7014 4 10C4 5.58172 7.58172 2 12 2C16.4183 2 20 5.58172 20 10C20 12.7014 18.6611 15.0901 16.6106 16.5386L18.6936 21.2996C18.8043 21.5526 18.6889 21.8474 18.4359 21.9581C18.3727 21.9857 18.3045 22 18.2355 22H5.76451C5.48837 22 5.26451 21.7761 5.26451 21.5C5.26451 21.431 5.27878 21.3628 5.30643 21.2996L7.38938 16.5386ZM14.1246 15.846L15.4567 14.905C17.041 13.7858 18 11.9752 18 10C18 6.68629 15.3137 4 12 4C8.68629 4 6 6.68629 6 10C6 11.9752 6.95901 13.7858 8.54335 14.905L9.87539 15.846L8.05803 20H15.942L14.1246 15.846ZM8.11851 10.9704L10.0593 10.4852C10.2761 11.3553 11.0628 12 12 12C12.9372 12 13.7239 11.3553 13.9407 10.4852L15.8815 10.9704C15.4478 12.7106 13.8745 14 12 14C10.1255 14 8.55217 12.7106 8.11851 10.9704Z"
  }));
},
    Uf = function Uf(_ref2139) {
  var _ref2139$color = _ref2139.color,
      C = _ref2139$color === void 0 ? "currentColor" : _ref2139$color,
      _ref2139$size = _ref2139.size,
      e = _ref2139$size === void 0 ? 24 : _ref2139$size,
      l = _ref2139.className,
      i = _objectWithoutProperties(_ref2139, _excluded2139);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11.9999 17C15.6623 17 18.8649 18.5751 20.607 20.9247L18.765 21.796C17.3473 20.1157 14.8473 19 11.9999 19C9.15248 19 6.65252 20.1157 5.23479 21.796L3.39355 20.9238C5.13576 18.5747 8.33796 17 11.9999 17ZM11.9999 2C14.7613 2 16.9999 4.23858 16.9999 7V10C16.9999 12.7614 14.7613 15 11.9999 15C9.23847 15 6.9999 12.7614 6.9999 10V7C6.9999 4.23858 9.23847 2 11.9999 2Z"
  }));
},
    Gf = function Gf(_ref2140) {
  var _ref2140$color = _ref2140.color,
      C = _ref2140$color === void 0 ? "currentColor" : _ref2140$color,
      _ref2140$size = _ref2140.size,
      e = _ref2140$size === void 0 ? 24 : _ref2140$size,
      l = _ref2140.className,
      i = _objectWithoutProperties(_ref2140, _excluded2140);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11.9999 17C15.6623 17 18.8649 18.5751 20.607 20.9247L18.765 21.796C17.3473 20.1157 14.8473 19 11.9999 19C9.15248 19 6.65252 20.1157 5.23479 21.796L3.39355 20.9238C5.13576 18.5747 8.33796 17 11.9999 17ZM11.9999 2C14.7613 2 16.9999 4.23858 16.9999 7V10C16.9999 12.6888 14.8776 14.8818 12.2168 14.9954L11.9999 15C9.23847 15 6.9999 12.7614 6.9999 10V7C6.9999 4.31125 9.1222 2.11818 11.783 2.00462L11.9999 2ZM11.9999 4C10.4022 4 9.09623 5.24892 9.00499 6.82373L8.9999 7V10C8.9999 11.6569 10.343 13 11.9999 13C13.5976 13 14.9036 11.7511 14.9948 10.1763L14.9999 10V7C14.9999 5.34315 13.6567 4 11.9999 4Z"
  }));
},
    If = function If(_ref2141) {
  var _ref2141$color = _ref2141.color,
      C = _ref2141$color === void 0 ? "currentColor" : _ref2141$color,
      _ref2141$size = _ref2141.size,
      e = _ref2141$size === void 0 ? 24 : _ref2141$size,
      l = _ref2141.className,
      i = _objectWithoutProperties(_ref2141, _excluded2141);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14 14.252V22H4C4 17.5817 7.58172 14 12 14C12.6906 14 13.3608 14.0875 14 14.252ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM18 17V14H20V17H23V19H20V22H18V19H15V17H18Z"
  }));
},
    Wf = function Wf(_ref2142) {
  var _ref2142$color = _ref2142.color,
      C = _ref2142$color === void 0 ? "currentColor" : _ref2142$color,
      _ref2142$size = _ref2142.size,
      e = _ref2142$size === void 0 ? 24 : _ref2142$size,
      l = _ref2142.className,
      i = _objectWithoutProperties(_ref2142, _excluded2142);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14 14.252V16.3414C13.3744 16.1203 12.7013 16 12 16C8.68629 16 6 18.6863 6 22H4C4 17.5817 7.58172 14 12 14C12.6906 14 13.3608 14.0875 14 14.252ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11ZM18 17V14H20V17H23V19H20V22H18V19H15V17H18Z"
  }));
},
    Of = function Of(_ref2143) {
  var _ref2143$color = _ref2143.color,
      C = _ref2143$color === void 0 ? "currentColor" : _ref2143$color,
      _ref2143$size = _ref2143.size,
      e = _ref2143$size === void 0 ? 24 : _ref2143$size,
      l = _ref2143.className,
      i = _objectWithoutProperties(_ref2143, _excluded2143);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 22C4 17.5817 7.58172 14 12 14C16.4183 14 20 17.5817 20 22H4ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13Z"
  }));
},
    Kf = function Kf(_ref2144) {
  var _ref2144$color = _ref2144.color,
      C = _ref2144$color === void 0 ? "currentColor" : _ref2144$color,
      _ref2144$size = _ref2144.size,
      e = _ref2144$size === void 0 ? 24 : _ref2144$size,
      l = _ref2144.className,
      i = _objectWithoutProperties(_ref2144, _excluded2144);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13 14.0619V22H4C4 17.5817 7.58172 14 12 14C12.3387 14 12.6724 14.021 13 14.0619ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM17.7929 19.9142L21.3284 16.3787L22.7426 17.7929L17.7929 22.7426L14.2574 19.2071L15.6716 17.7929L17.7929 19.9142Z"
  }));
},
    Qf = function Qf(_ref2145) {
  var _ref2145$color = _ref2145.color,
      C = _ref2145$color === void 0 ? "currentColor" : _ref2145$color,
      _ref2145$size = _ref2145.size,
      e = _ref2145$size === void 0 ? 24 : _ref2145$size,
      l = _ref2145.className,
      i = _objectWithoutProperties(_ref2145, _excluded2145);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14 14.252V16.3414C13.3744 16.1203 12.7013 16 12 16C8.68629 16 6 18.6863 6 22H4C4 17.5817 7.58172 14 12 14C12.6906 14 13.3608 14.0875 14 14.252ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11ZM17.7929 19.9142L21.3284 16.3787L22.7426 17.7929L17.7929 22.7426L14.2574 19.2071L15.6716 17.7929L17.7929 19.9142Z"
  }));
},
    qf = function qf(_ref2146) {
  var _ref2146$color = _ref2146.color,
      C = _ref2146$color === void 0 ? "currentColor" : _ref2146$color,
      _ref2146$size = _ref2146.size,
      e = _ref2146$size === void 0 ? 24 : _ref2146$size,
      l = _ref2146.className,
      i = _objectWithoutProperties(_ref2146, _excluded2146);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17.841 15.659L18.017 15.836L18.1945 15.659C19.0732 14.7803 20.4978 14.7803 21.3765 15.659C22.2552 16.5377 22.2552 17.9623 21.3765 18.841L18.0178 22.1997L14.659 18.841C13.7803 17.9623 13.7803 16.5377 14.659 15.659C15.5377 14.7803 16.9623 14.7803 17.841 15.659ZM12 14V22H4C4 17.6651 7.44784 14.1355 11.7508 14.0038L12 14ZM12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1Z"
  }));
},
    jf = function jf(_ref2147) {
  var _ref2147$color = _ref2147.color,
      C = _ref2147$color === void 0 ? "currentColor" : _ref2147$color,
      _ref2147$size = _ref2147.size,
      e = _ref2147$size === void 0 ? 24 : _ref2147$size,
      l = _ref2147.className,
      i = _objectWithoutProperties(_ref2147, _excluded2147);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17.841 15.659L18.017 15.836L18.1945 15.659C19.0732 14.7803 20.4978 14.7803 21.3765 15.659C22.2552 16.5377 22.2552 17.9623 21.3765 18.841L18.0178 22.1997L14.659 18.841C13.7803 17.9623 13.7803 16.5377 14.659 15.659C15.5377 14.7803 16.9623 14.7803 17.841 15.659ZM12 14V16C8.68629 16 6 18.6863 6 22H4C4 17.6651 7.44784 14.1355 11.7508 14.0038L12 14ZM12 1C15.315 1 18 3.685 18 7C18 10.2397 15.4357 12.8776 12.225 12.9959L12 13C8.685 13 6 10.315 6 7C6 3.76034 8.56434 1.12237 11.775 1.00414L12 1ZM12 3C9.78957 3 8 4.78957 8 7C8 9.21043 9.78957 11 12 11C14.2104 11 16 9.21043 16 7C16 4.78957 14.2104 3 12 3Z"
  }));
},
    Xf = function Xf(_ref2148) {
  var _ref2148$color = _ref2148.color,
      C = _ref2148$color === void 0 ? "currentColor" : _ref2148$color,
      _ref2148$size = _ref2148.size,
      e = _ref2148$size === void 0 ? 24 : _ref2148$size,
      l = _ref2148.className,
      i = _objectWithoutProperties(_ref2148, _excluded2148);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 22C4 17.5817 7.58172 14 12 14C16.4183 14 20 17.5817 20 22H18C18 18.6863 15.3137 16 12 16C8.68629 16 6 18.6863 6 22H4ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11Z"
  }));
},
    Jf = function Jf(_ref2149) {
  var _ref2149$color = _ref2149.color,
      C = _ref2149$color === void 0 ? "currentColor" : _ref2149$color,
      _ref2149$size = _ref2149.size,
      e = _ref2149$size === void 0 ? 24 : _ref2149$size,
      l = _ref2149.className,
      i = _objectWithoutProperties(_ref2149, _excluded2149);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 14V22H4C4 17.5817 7.58172 14 12 14ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM20.8284 20.8284L18 23.6569L15.1716 20.8284C13.6095 19.2663 13.6095 16.7337 15.1716 15.1716C16.7337 13.6095 19.2663 13.6095 20.8284 15.1716C22.3905 16.7337 22.3905 19.2663 20.8284 20.8284ZM18 17C17.4477 17 17 17.4477 17 18C17 18.5523 17.4477 19 18 19C18.5523 19 19 18.5523 19 18C19 17.4477 18.5523 17 18 17Z"
  }));
},
    Yf = function Yf(_ref2150) {
  var _ref2150$color = _ref2150.color,
      C = _ref2150$color === void 0 ? "currentColor" : _ref2150$color,
      _ref2150$size = _ref2150.size,
      e = _ref2150$size === void 0 ? 24 : _ref2150$size,
      l = _ref2150.className,
      i = _objectWithoutProperties(_ref2150, _excluded2150);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 14V16C8.68629 16 6 18.6863 6 22H4C4 17.5817 7.58172 14 12 14ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11ZM20.8284 21.0711L18 24L15.1716 21.0711C13.6095 19.4535 13.6095 16.8308 15.1716 15.2132C16.7337 13.5956 19.2663 13.5956 20.8284 15.2132C22.3905 16.8308 22.3905 19.4535 20.8284 21.0711ZM19.3897 19.6818C20.2034 18.8392 20.2034 17.4451 19.3897 16.6025C18.614 15.7992 17.386 15.7992 16.6103 16.6025C15.7966 17.4451 15.7966 18.8392 16.6103 19.6818L18 21.1209L19.3897 19.6818Z"
  }));
},
    _f = function _f(_ref2151) {
  var _ref2151$color = _ref2151.color,
      C = _ref2151$color === void 0 ? "currentColor" : _ref2151$color,
      _ref2151$size = _ref2151.size,
      e = _ref2151$size === void 0 ? 24 : _ref2151$size,
      l = _ref2151.className,
      i = _objectWithoutProperties(_ref2151, _excluded2151);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14 14.252V22H4C4 17.5817 7.58172 14 12 14C12.6906 14 13.3608 14.0875 14 14.252ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM20 17H23V19H20V22.5L15 18L20 13.5V17Z"
  }));
},
    $f = function $f(_ref2152) {
  var _ref2152$color = _ref2152.color,
      C = _ref2152$color === void 0 ? "currentColor" : _ref2152$color,
      _ref2152$size = _ref2152.size,
      e = _ref2152$size === void 0 ? 24 : _ref2152$size,
      l = _ref2152.className,
      i = _objectWithoutProperties(_ref2152, _excluded2152);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14 14.252V16.3414C13.3744 16.1203 12.7013 16 12 16C8.68629 16 6 18.6863 6 22H4C4 17.5817 7.58172 14 12 14C12.6906 14 13.3608 14.0875 14 14.252ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11ZM20 17H23V19H20V22.5L15 18L20 13.5V17Z"
  }));
},
    eR = function eR(_ref2153) {
  var _ref2153$color = _ref2153.color,
      C = _ref2153$color === void 0 ? "currentColor" : _ref2153$color,
      _ref2153$size = _ref2153.size,
      e = _ref2153$size === void 0 ? 24 : _ref2153$size,
      l = _ref2153.className,
      i = _objectWithoutProperties(_ref2153, _excluded2153);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14 14.252V22H4C4 17.5817 7.58172 14 12 14C12.6906 14 13.3608 14.0875 14 14.252ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM19.4184 17H23.0042V19H19.4184L21.2469 20.8284L19.8326 22.2426L15.59 18L19.8326 13.7574L21.2469 15.1716L19.4184 17Z"
  }));
},
    tR = function tR(_ref2154) {
  var _ref2154$color = _ref2154.color,
      C = _ref2154$color === void 0 ? "currentColor" : _ref2154$color,
      _ref2154$size = _ref2154.size,
      e = _ref2154$size === void 0 ? 24 : _ref2154$size,
      l = _ref2154.className,
      i = _objectWithoutProperties(_ref2154, _excluded2154);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14 14.252V16.3414C13.3744 16.1203 12.7013 16 12 16C8.68629 16 6 18.6863 6 22H4C4 17.5817 7.58172 14 12 14C12.6906 14 13.3608 14.0875 14 14.252ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11ZM19.4184 17H23.0042V19H19.4184L21.2469 20.8284L19.8326 22.2426L15.59 18L19.8326 13.7574L21.2469 15.1716L19.4184 17Z"
  }));
},
    CR = function CR(_ref2155) {
  var _ref2155$color = _ref2155.color,
      C = _ref2155$color === void 0 ? "currentColor" : _ref2155$color,
      _ref2155$size = _ref2155.size,
      e = _ref2155$size === void 0 ? 24 : _ref2155$size,
      l = _ref2155.className,
      i = _objectWithoutProperties(_ref2155, _excluded2155);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 14V22H4C4 17.5817 7.58172 14 12 14ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM21.4462 20.032L22.9497 21.5355L21.5355 22.9497L20.032 21.4462C19.4365 21.7981 18.7418 22 18 22C15.7909 22 14 20.2091 14 18C14 15.7909 15.7909 14 18 14C20.2091 14 22 15.7909 22 18C22 18.7418 21.7981 19.4365 21.4462 20.032ZM18 20C19.1046 20 20 19.1046 20 18C20 16.8954 19.1046 16 18 16C16.8954 16 16 16.8954 16 18C16 19.1046 16.8954 20 18 20Z"
  }));
},
    lR = function lR(_ref2156) {
  var _ref2156$color = _ref2156.color,
      C = _ref2156$color === void 0 ? "currentColor" : _ref2156$color,
      _ref2156$size = _ref2156.size,
      e = _ref2156$size === void 0 ? 24 : _ref2156$size,
      l = _ref2156.className,
      i = _objectWithoutProperties(_ref2156, _excluded2156);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 14V16C8.68629 16 6 18.6863 6 22H4C4 17.5817 7.58172 14 12 14ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11ZM21.4462 20.032L22.9497 21.5355L21.5355 22.9497L20.032 21.4462C19.4365 21.7981 18.7418 22 18 22C15.7909 22 14 20.2091 14 18C14 15.7909 15.7909 14 18 14C20.2091 14 22 15.7909 22 18C22 18.7418 21.7981 19.4365 21.4462 20.032ZM18 20C19.1046 20 20 19.1046 20 18C20 16.8954 19.1046 16 18 16C16.8954 16 16 16.8954 16 18C16 19.1046 16.8954 20 18 20Z"
  }));
},
    iR = function iR(_ref2157) {
  var _ref2157$color = _ref2157.color,
      C = _ref2157$color === void 0 ? "currentColor" : _ref2157$color,
      _ref2157$size = _ref2157.size,
      e = _ref2157$size === void 0 ? 24 : _ref2157$size,
      l = _ref2157.className,
      i = _objectWithoutProperties(_ref2157, _excluded2157);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 14V22H4C4 17.5817 7.58172 14 12 14ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM14.5946 18.8115C14.5327 18.5511 14.5 18.2794 14.5 18C14.5 17.7207 14.5327 17.449 14.5945 17.1886L13.6029 16.6161L14.6029 14.884L15.5952 15.4569C15.9883 15.0851 16.4676 14.8034 17 14.6449V13.5H19V14.6449C19.5324 14.8034 20.0116 15.0851 20.4047 15.4569L21.3971 14.8839L22.3972 16.616L21.4055 17.1885C21.4673 17.449 21.5 17.7207 21.5 18C21.5 18.2793 21.4673 18.551 21.4055 18.8114L22.3972 19.3839L21.3972 21.116L20.4048 20.543C20.0117 20.9149 19.5325 21.1966 19.0001 21.355V22.5H17.0001V21.3551C16.4677 21.1967 15.9884 20.915 15.5953 20.5431L14.603 21.1161L13.6029 19.384L14.5946 18.8115ZM18 17C17.4477 17 17 17.4477 17 18C17 18.5523 17.4477 19 18 19C18.5523 19 19 18.5523 19 18C19 17.4477 18.5523 17 18 17Z"
  }));
},
    sR = function sR(_ref2158) {
  var _ref2158$color = _ref2158.color,
      C = _ref2158$color === void 0 ? "currentColor" : _ref2158$color,
      _ref2158$size = _ref2158.size,
      e = _ref2158$size === void 0 ? 24 : _ref2158$size,
      l = _ref2158.className,
      i = _objectWithoutProperties(_ref2158, _excluded2158);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 14V16C8.68629 16 6 18.6863 6 22H4C4 17.5817 7.58172 14 12 14ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11ZM14.5946 18.8115C14.5327 18.5511 14.5 18.2794 14.5 18C14.5 17.7207 14.5327 17.449 14.5945 17.1886L13.6029 16.6161L14.6029 14.884L15.5952 15.4569C15.9883 15.0851 16.4676 14.8034 17 14.6449V13.5H19V14.6449C19.5324 14.8034 20.0116 15.0851 20.4047 15.4569L21.3971 14.8839L22.3972 16.616L21.4055 17.1885C21.4673 17.449 21.5 17.7207 21.5 18C21.5 18.2793 21.4673 18.551 21.4055 18.8114L22.3972 19.3839L21.3972 21.116L20.4048 20.543C20.0117 20.9149 19.5325 21.1966 19.0001 21.355V22.5H17.0001V21.3551C16.4677 21.1967 15.9884 20.915 15.5953 20.5431L14.603 21.1161L13.6029 19.384L14.5946 18.8115ZM18 19.5C18.8284 19.5 19.5 18.8284 19.5 18C19.5 17.1716 18.8284 16.5 18 16.5C17.1716 16.5 16.5 17.1716 16.5 18C16.5 18.8284 17.1716 19.5 18 19.5Z"
  }));
},
    rR = function rR(_ref2159) {
  var _ref2159$color = _ref2159.color,
      C = _ref2159$color === void 0 ? "currentColor" : _ref2159$color,
      _ref2159$size = _ref2159.size,
      e = _ref2159$size === void 0 ? 24 : _ref2159$size,
      l = _ref2159.className,
      i = _objectWithoutProperties(_ref2159, _excluded2159);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14 14.252V22H4C4 17.5817 7.58172 14 12 14C12.6906 14 13.3608 14.0875 14 14.252ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM18 17V13.5L23 18L18 22.5V19H15V17H18Z"
  }));
},
    cR = function cR(_ref2160) {
  var _ref2160$color = _ref2160.color,
      C = _ref2160$color === void 0 ? "currentColor" : _ref2160$color,
      _ref2160$size = _ref2160.size,
      e = _ref2160$size === void 0 ? 24 : _ref2160$size,
      l = _ref2160.className,
      i = _objectWithoutProperties(_ref2160, _excluded2160);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14 14.252V16.3414C13.3744 16.1203 12.7013 16 12 16C8.68629 16 6 18.6863 6 22H4C4 17.5817 7.58172 14 12 14C12.6906 14 13.3608 14.0875 14 14.252ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11ZM18 17V13.5L23 18L18 22.5V19H15V17H18Z"
  }));
},
    oR = function oR(_ref2161) {
  var _ref2161$color = _ref2161.color,
      C = _ref2161$color === void 0 ? "currentColor" : _ref2161$color,
      _ref2161$size = _ref2161.size,
      e = _ref2161$size === void 0 ? 24 : _ref2161$size,
      l = _ref2161.className,
      i = _objectWithoutProperties(_ref2161, _excluded2161);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14 14.252V22H4C4 17.5817 7.58172 14 12 14C12.6906 14 13.3608 14.0875 14 14.252ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM18.5858 17L16.7574 15.1716L18.1716 13.7574L22.4142 18L18.1716 22.2426L16.7574 20.8284L18.5858 19H15V17H18.5858Z"
  }));
},
    aR = function aR(_ref2162) {
  var _ref2162$color = _ref2162.color,
      C = _ref2162$color === void 0 ? "currentColor" : _ref2162$color,
      _ref2162$size = _ref2162.size,
      e = _ref2162$size === void 0 ? 24 : _ref2162$size,
      l = _ref2162.className,
      i = _objectWithoutProperties(_ref2162, _excluded2162);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14 14.252V16.3414C13.3744 16.1203 12.7013 16 12 16C8.68629 16 6 18.6863 6 22H4C4 17.5817 7.58172 14 12 14C12.6906 14 13.3608 14.0875 14 14.252ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11ZM18.5858 17L16.7574 15.1716L18.1716 13.7574L22.4142 18L18.1716 22.2426L16.7574 20.8284L18.5858 19H15V17H18.5858Z"
  }));
},
    nR = function nR(_ref2163) {
  var _ref2163$color = _ref2163.color,
      C = _ref2163$color === void 0 ? "currentColor" : _ref2163$color,
      _ref2163$size = _ref2163.size,
      e = _ref2163$size === void 0 ? 24 : _ref2163$size,
      l = _ref2163.className,
      i = _objectWithoutProperties(_ref2163, _excluded2163);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM7 12C7 14.7614 9.23858 17 12 17C14.7614 17 17 14.7614 17 12H15C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12H7Z"
  }));
},
    mR = function mR(_ref2164) {
  var _ref2164$color = _ref2164.color,
      C = _ref2164$color === void 0 ? "currentColor" : _ref2164$color,
      _ref2164$size = _ref2164.size,
      e = _ref2164$size === void 0 ? 24 : _ref2164$size,
      l = _ref2164.className,
      i = _objectWithoutProperties(_ref2164, _excluded2164);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM7 12H9C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12H17C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12Z"
  }));
},
    wR = function wR(_ref2165) {
  var _ref2165$color = _ref2165.color,
      C = _ref2165$color === void 0 ? "currentColor" : _ref2165$color,
      _ref2165$size = _ref2165.size,
      e = _ref2165$size === void 0 ? 24 : _ref2165$size,
      l = _ref2165.className,
      i = _objectWithoutProperties(_ref2165, _excluded2165);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 14V22H4C4 17.5817 7.58172 14 12 14ZM18 21.5L15.0611 23.0451L15.6224 19.7725L13.2447 17.4549L16.5305 16.9775L18 14L19.4695 16.9775L22.7553 17.4549L20.3776 19.7725L20.9389 23.0451L18 21.5ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13Z"
  }));
},
    LR = function LR(_ref2166) {
  var _ref2166$color = _ref2166.color,
      C = _ref2166$color === void 0 ? "currentColor" : _ref2166$color,
      _ref2166$size = _ref2166.size,
      e = _ref2166$size === void 0 ? 24 : _ref2166$size,
      l = _ref2166.className,
      i = _objectWithoutProperties(_ref2166, _excluded2166);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 14V16C8.68629 16 6 18.6863 6 22H4C4 17.5817 7.58172 14 12 14ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11ZM18 21.5L15.0611 23.0451L15.6224 19.7725L13.2447 17.4549L16.5305 16.9775L18 14L19.4695 16.9775L22.7553 17.4549L20.3776 19.7725L20.9389 23.0451L18 21.5Z"
  }));
},
    hR = function hR(_ref2167) {
  var _ref2167$color = _ref2167.color,
      C = _ref2167$color === void 0 ? "currentColor" : _ref2167$color,
      _ref2167$size = _ref2167.size,
      e = _ref2167$size === void 0 ? 24 : _ref2167$size,
      l = _ref2167.className,
      i = _objectWithoutProperties(_ref2167, _excluded2167);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14 14.252V22H4C4 17.5817 7.58172 14 12 14C12.6906 14 13.3608 14.0875 14 14.252ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM19 16.5858L21.1213 14.4645L22.5355 15.8787L20.4142 18L22.5355 20.1213L21.1213 21.5355L19 19.4142L16.8787 21.5355L15.4645 20.1213L17.5858 18L15.4645 15.8787L16.8787 14.4645L19 16.5858Z"
  }));
},
    HR = function HR(_ref2168) {
  var _ref2168$color = _ref2168.color,
      C = _ref2168$color === void 0 ? "currentColor" : _ref2168$color,
      _ref2168$size = _ref2168.size,
      e = _ref2168$size === void 0 ? 24 : _ref2168$size,
      l = _ref2168.className,
      i = _objectWithoutProperties(_ref2168, _excluded2168);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14 14.252V16.3414C13.3744 16.1203 12.7013 16 12 16C8.68629 16 6 18.6863 6 22H4C4 17.5817 7.58172 14 12 14C12.6906 14 13.3608 14.0875 14 14.252ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11ZM19 17.5858L21.1213 15.4645L22.5355 16.8787L20.4142 19L22.5355 21.1213L21.1213 22.5355L19 20.4142L16.8787 22.5355L15.4645 21.1213L17.5858 19L15.4645 16.8787L16.8787 15.4645L19 17.5858Z"
  }));
},
    VR = function VR(_ref2169) {
  var _ref2169$color = _ref2169.color,
      C = _ref2169$color === void 0 ? "currentColor" : _ref2169$color,
      _ref2169$size = _ref2169.size,
      e = _ref2169$size === void 0 ? 24 : _ref2169$size,
      l = _ref2169.className,
      i = _objectWithoutProperties(_ref2169, _excluded2169);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M1 22C1 17.5817 4.58172 14 9 14C13.4183 14 17 17.5817 17 22H1ZM9 13C5.685 13 3 10.315 3 7.00002C3 3.68502 5.685 1.00002 9 1.00002C12.315 1.00002 15 3.68502 15 7.00002C15 10.315 12.315 13 9 13ZM18.2463 3.18451C18.732 4.36026 19 5.64884 19 7.00002C19 8.35119 18.732 9.63977 18.2463 10.8155L16.5694 9.59595C16.8485 8.78194 17 7.90867 17 7.00002C17 6.09136 16.8485 5.21809 16.5694 4.40408L18.2463 3.18451ZM21.5476 0.783569C22.4773 2.65651 23 4.76723 23 7.00002C23 9.23281 22.4773 11.3435 21.5476 13.2165L19.9027 12.0201C20.6071 10.4928 21 8.79231 21 7.00002C21 5.20772 20.6071 3.5072 19.9027 1.9799L21.5476 0.783569Z"
  }));
},
    gR = function gR(_ref2170) {
  var _ref2170$color = _ref2170.color,
      C = _ref2170$color === void 0 ? "currentColor" : _ref2170$color,
      _ref2170$size = _ref2170.size,
      e = _ref2170$size === void 0 ? 24 : _ref2170$size,
      l = _ref2170.className,
      i = _objectWithoutProperties(_ref2170, _excluded2170);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M1 22C1 17.5817 4.58172 14 9 14C13.4183 14 17 17.5817 17 22H15C15 18.6863 12.3137 16 9 16C5.68629 16 3 18.6863 3 22H1ZM9 13C5.685 13 3 10.315 3 7.00002C3 3.68502 5.685 1.00002 9 1.00002C12.315 1.00002 15 3.68502 15 7.00002C15 10.315 12.315 13 9 13ZM9 11C11.21 11 13 9.21002 13 7.00002C13 4.79002 11.21 3.00002 9 3.00002C6.79 3.00002 5 4.79002 5 7.00002C5 9.21002 6.79 11 9 11ZM21.5476 0.783569C22.4773 2.65651 23 4.76723 23 7.00002C23 9.23281 22.4773 11.3435 21.5476 13.2165L19.9027 12.0201C20.6071 10.4928 21 8.79231 21 7.00002C21 5.20772 20.6071 3.5072 19.9027 1.9799L21.5476 0.783569ZM18.2463 3.18451C18.732 4.36026 19 5.64884 19 7.00002C19 8.35119 18.732 9.63977 18.2463 10.8155L16.5694 9.59595C16.8485 8.78194 17 7.90867 17 7.00002C17 6.09136 16.8485 5.21809 16.5694 4.40408L18.2463 3.18451Z"
  }));
},
    MR = function MR(_ref2171) {
  var _ref2171$color = _ref2171.color,
      C = _ref2171$color === void 0 ? "currentColor" : _ref2171$color,
      _ref2171$size = _ref2171.size,
      e = _ref2171$size === void 0 ? 24 : _ref2171$size,
      l = _ref2171.className,
      i = _objectWithoutProperties(_ref2171, _excluded2171);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16 4C16.5523 4 17 4.44772 17 5V9.2L22.2133 5.55071C22.4395 5.39235 22.7513 5.44737 22.9096 5.6736C22.9684 5.75764 23 5.85774 23 5.96033V18.0397C23 18.3158 22.7761 18.5397 22.5 18.5397C22.3974 18.5397 22.2973 18.5081 22.2133 18.4493L17 14.8V19C17 19.5523 16.5523 20 16 20H2C1.44772 20 1 19.5523 1 19V5C1 4.44772 1.44772 4 2 4H16ZM8 8V11H5V13H7.999L8 16H10L9.999 13H13V11H10V8H8Z"
  }));
},
    ZR = function ZR(_ref2172) {
  var _ref2172$color = _ref2172.color,
      C = _ref2172$color === void 0 ? "currentColor" : _ref2172$color,
      _ref2172$size = _ref2172.size,
      e = _ref2172$size === void 0 ? 24 : _ref2172$size,
      l = _ref2172.className,
      i = _objectWithoutProperties(_ref2172, _excluded2172);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16 4C16.5523 4 17 4.44772 17 5V9.2L22.2133 5.55071C22.4395 5.39235 22.7513 5.44737 22.9096 5.6736C22.9684 5.75764 23 5.85774 23 5.96033V18.0397C23 18.3158 22.7761 18.5397 22.5 18.5397C22.3974 18.5397 22.2973 18.5081 22.2133 18.4493L17 14.8V19C17 19.5523 16.5523 20 16 20H2C1.44772 20 1 19.5523 1 19V5C1 4.44772 1.44772 4 2 4H16ZM15 6H3V18H15V6ZM8 8H10V11H13V13H9.999L10 16H8L7.999 13H5V11H8V8ZM21 8.84131L17 11.641V12.359L21 15.1587V8.84131Z"
  }));
},
    xR = function xR(_ref2173) {
  var _ref2173$color = _ref2173.color,
      C = _ref2173$color === void 0 ? "currentColor" : _ref2173$color,
      _ref2173$size = _ref2173.size,
      e = _ref2173$size === void 0 ? 24 : _ref2173$size,
      l = _ref2173.className,
      i = _objectWithoutProperties(_ref2173, _excluded2173);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.45455 19L2 22.5V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.45455ZM14 10.25V8H7V14H14V11.75L17 14V8L14 10.25Z"
  }));
},
    vR = function vR(_ref2174) {
  var _ref2174$color = _ref2174.color,
      C = _ref2174$color === void 0 ? "currentColor" : _ref2174$color,
      _ref2174$size = _ref2174.size,
      e = _ref2174$size === void 0 ? 24 : _ref2174$size,
      l = _ref2174.className,
      i = _objectWithoutProperties(_ref2174, _excluded2174);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14 10.25L17 8V14L14 11.75V14H7V8H14V10.25ZM5.76282 17H20V5H4V18.3851L5.76282 17ZM6.45455 19L2 22.5V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.45455Z"
  }));
},
    dR = function dR(_ref2175) {
  var _ref2175$color = _ref2175.color,
      C = _ref2175$color === void 0 ? "currentColor" : _ref2175$color,
      _ref2175$size = _ref2175.size,
      e = _ref2175$size === void 0 ? 24 : _ref2175$size,
      l = _ref2175.className,
      i = _objectWithoutProperties(_ref2175, _excluded2175);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16 4C16.5523 4 17 4.44772 17 5V9.2L22.2133 5.55071C22.4395 5.39235 22.7513 5.44737 22.9096 5.6736C22.9684 5.75764 23 5.85774 23 5.96033V18.0397C23 18.3158 22.7761 18.5397 22.5 18.5397C22.3974 18.5397 22.2973 18.5081 22.2133 18.4493L17 14.8V19C17 19.5523 16.5523 20 16 20H2C1.44772 20 1 19.5523 1 19V5C1 4.44772 1.44772 4 2 4H16ZM10 8H8V12H5L9 16L13 12H10V8Z"
  }));
},
    pR = function pR(_ref2176) {
  var _ref2176$color = _ref2176.color,
      C = _ref2176$color === void 0 ? "currentColor" : _ref2176$color,
      _ref2176$size = _ref2176.size,
      e = _ref2176$size === void 0 ? 24 : _ref2176$size,
      l = _ref2176.className,
      i = _objectWithoutProperties(_ref2176, _excluded2176);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16 4C16.5523 4 17 4.44772 17 5V9.2L22.2133 5.55071C22.4395 5.39235 22.7513 5.44737 22.9096 5.6736C22.9684 5.75764 23 5.85774 23 5.96033V18.0397C23 18.3158 22.7761 18.5397 22.5 18.5397C22.3974 18.5397 22.2973 18.5081 22.2133 18.4493L17 14.8V19C17 19.5523 16.5523 20 16 20H2C1.44772 20 1 19.5523 1 19V5C1 4.44772 1.44772 4 2 4H16ZM15 6H3V18H15V6ZM10 8V12H13L9 16L5 12H8V8H10ZM21 8.84131L17 11.641V12.359L21 15.1587V8.84131Z"
  }));
},
    ER = function ER(_ref2177) {
  var _ref2177$color = _ref2177.color,
      C = _ref2177$color === void 0 ? "currentColor" : _ref2177$color,
      _ref2177$size = _ref2177.size,
      e = _ref2177$size === void 0 ? 24 : _ref2177$size,
      l = _ref2177.className,
      i = _objectWithoutProperties(_ref2177, _excluded2177);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 3.9934C3 3.44476 3.44495 3 3.9934 3H20.0066C20.5552 3 21 3.44495 21 3.9934V20.0066C21 20.5552 20.5551 21 20.0066 21H3.9934C3.44476 21 3 20.5551 3 20.0066V3.9934ZM10.6219 8.41459C10.5562 8.37078 10.479 8.34741 10.4 8.34741C10.1791 8.34741 10 8.52649 10 8.74741V15.2526C10 15.3316 10.0234 15.4088 10.0672 15.4745C10.1897 15.6583 10.4381 15.708 10.6219 15.5854L15.5008 12.3328C15.5447 12.3035 15.5824 12.2658 15.6117 12.2219C15.7343 12.0381 15.6846 11.7897 15.5008 11.6672L10.6219 8.41459Z"
  }));
},
    NR = function NR(_ref2178) {
  var _ref2178$color = _ref2178.color,
      C = _ref2178$color === void 0 ? "currentColor" : _ref2178$color,
      _ref2178$size = _ref2178.size,
      e = _ref2178$size === void 0 ? 24 : _ref2178$size,
      l = _ref2178.className,
      i = _objectWithoutProperties(_ref2178, _excluded2178);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 3.9934C3 3.44476 3.44495 3 3.9934 3H20.0066C20.5552 3 21 3.44495 21 3.9934V20.0066C21 20.5552 20.5551 21 20.0066 21H3.9934C3.44476 21 3 20.5551 3 20.0066V3.9934ZM5 5V19H19V5H5ZM10.6219 8.41459L15.5008 11.6672C15.6846 11.7897 15.7343 12.0381 15.6117 12.2219C15.5824 12.2658 15.5447 12.3035 15.5008 12.3328L10.6219 15.5854C10.4381 15.708 10.1897 15.6583 10.0672 15.4745C10.0234 15.4088 10 15.3316 10 15.2526V8.74741C10 8.52649 10.1791 8.34741 10.4 8.34741C10.479 8.34741 10.5562 8.37078 10.6219 8.41459Z"
  }));
},
    uR = function uR(_ref2179) {
  var _ref2179$color = _ref2179.color,
      C = _ref2179$color === void 0 ? "currentColor" : _ref2179$color,
      _ref2179$size = _ref2179.size,
      e = _ref2179$size === void 0 ? 24 : _ref2179$size,
      l = _ref2179.className,
      i = _objectWithoutProperties(_ref2179, _excluded2179);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16 4C16.5523 4 17 4.44772 17 5V9.2L22.2133 5.55071C22.4395 5.39235 22.7513 5.44737 22.9096 5.6736C22.9684 5.75764 23 5.85774 23 5.96033V18.0397C23 18.3158 22.7761 18.5397 22.5 18.5397C22.3974 18.5397 22.2973 18.5081 22.2133 18.4493L17 14.8V19C17 19.5523 16.5523 20 16 20H2C1.44772 20 1 19.5523 1 19V5C1 4.44772 1.44772 4 2 4H16ZM9 8L5 12H8V16H10V12H13L9 8Z"
  }));
},
    BR = function BR(_ref2180) {
  var _ref2180$color = _ref2180.color,
      C = _ref2180$color === void 0 ? "currentColor" : _ref2180$color,
      _ref2180$size = _ref2180.size,
      e = _ref2180$size === void 0 ? 24 : _ref2180$size,
      l = _ref2180.className,
      i = _objectWithoutProperties(_ref2180, _excluded2180);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16 4C16.5523 4 17 4.44772 17 5V9.2L22.2133 5.55071C22.4395 5.39235 22.7513 5.44737 22.9096 5.6736C22.9684 5.75764 23 5.85774 23 5.96033V18.0397C23 18.3158 22.7761 18.5397 22.5 18.5397C22.3974 18.5397 22.2973 18.5081 22.2133 18.4493L17 14.8V19C17 19.5523 16.5523 20 16 20H2C1.44772 20 1 19.5523 1 19V5C1 4.44772 1.44772 4 2 4H16ZM15 6H3V18H15V6ZM9 8L13 12H10V16H8V12H5L9 8ZM21 8.84131L17 11.641V12.359L21 15.1587V8.84131Z"
  }));
},
    fR = function fR(_ref2181) {
  var _ref2181$color = _ref2181.color,
      C = _ref2181$color === void 0 ? "currentColor" : _ref2181$color,
      _ref2181$size = _ref2181.size,
      e = _ref2181$size === void 0 ? 24 : _ref2181$size,
      l = _ref2181.className,
      i = _objectWithoutProperties(_ref2181, _excluded2181);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13 6V4H5V2H15V6H16C16.5523 6 17 6.44772 17 7V9.2L22.2133 5.55071C22.4395 5.39235 22.7513 5.44737 22.9096 5.6736C22.9684 5.75764 23 5.85774 23 5.96033V18.0397C23 18.3158 22.7761 18.5397 22.5 18.5397C22.3974 18.5397 22.2973 18.5081 22.2133 18.4493L17 14.8V19C17 19.5523 16.5523 20 16 20H2C1.44772 20 1 19.5523 1 19V7C1 6.44772 1.44772 6 2 6H13ZM5 10V12H7V10H5Z"
  }));
},
    RR = function RR(_ref2182) {
  var _ref2182$color = _ref2182.color,
      C = _ref2182$color === void 0 ? "currentColor" : _ref2182$color,
      _ref2182$size = _ref2182.size,
      e = _ref2182$size === void 0 ? 24 : _ref2182$size,
      l = _ref2182.className,
      i = _objectWithoutProperties(_ref2182, _excluded2182);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13 6V4H5V2H15V6H16C16.5523 6 17 6.44772 17 7V9.2L22.2133 5.55071C22.4395 5.39235 22.7513 5.44737 22.9096 5.6736C22.9684 5.75764 23 5.85774 23 5.96033V18.0397C23 18.3158 22.7761 18.5397 22.5 18.5397C22.3974 18.5397 22.2973 18.5081 22.2133 18.4493L17 14.8V19C17 19.5523 16.5523 20 16 20H2C1.44772 20 1 19.5523 1 19V7C1 6.44772 1.44772 6 2 6H13ZM15 8H3V18H15V8ZM17 12.3587L21 15.1587V8.84131L17 11.6413V12.3587ZM5 10H7V12H5V10Z"
  }));
},
    zR = function zR(_ref2183) {
  var _ref2183$color = _ref2183.color,
      C = _ref2183$color === void 0 ? "currentColor" : _ref2183$color,
      _ref2183$size = _ref2183.size,
      e = _ref2183$size === void 0 ? 24 : _ref2183$size,
      l = _ref2183.className,
      i = _objectWithoutProperties(_ref2183, _excluded2183);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17 9.2L22.2133 5.55071C22.4395 5.39235 22.7513 5.44737 22.9096 5.6736C22.9684 5.75764 23 5.85774 23 5.96033V18.0397C23 18.3158 22.7761 18.5397 22.5 18.5397C22.3974 18.5397 22.2973 18.5081 22.2133 18.4493L17 14.8V19C17 19.5523 16.5523 20 16 20H2C1.44772 20 1 19.5523 1 19V5C1 4.44772 1.44772 4 2 4H16C16.5523 4 17 4.44772 17 5V9.2ZM5 8V10H7V8H5Z"
  }));
},
    FR = function FR(_ref2184) {
  var _ref2184$color = _ref2184.color,
      C = _ref2184$color === void 0 ? "currentColor" : _ref2184$color,
      _ref2184$size = _ref2184.size,
      e = _ref2184$size === void 0 ? 24 : _ref2184$size,
      l = _ref2184.className,
      i = _objectWithoutProperties(_ref2184, _excluded2184);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17 9.2L22.2133 5.55071C22.4395 5.39235 22.7513 5.44737 22.9096 5.6736C22.9684 5.75764 23 5.85774 23 5.96033V18.0397C23 18.3158 22.7761 18.5397 22.5 18.5397C22.3974 18.5397 22.2973 18.5081 22.2133 18.4493L17 14.8V19C17 19.5523 16.5523 20 16 20H2C1.44772 20 1 19.5523 1 19V5C1 4.44772 1.44772 4 2 4H16C16.5523 4 17 4.44772 17 5V9.2ZM17 12.3587L21 15.1587V8.84131L17 11.6413V12.3587ZM3 6V18H15V6H3ZM5 8H7V10H5V8Z"
  }));
},
    SR = function SR(_ref2185) {
  var _ref2185$color = _ref2185.color,
      C = _ref2185$color === void 0 ? "currentColor" : _ref2185$color,
      _ref2185$size = _ref2185.size,
      e = _ref2185$size === void 0 ? 24 : _ref2185$size,
      l = _ref2185.className,
      i = _objectWithoutProperties(_ref2185, _excluded2185);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M1.17444 8.30112C0.892531 7.88758 0.922443 7.88758 1.50184 7.37867C2.73388 6.29651 3.8964 5.11316 5.23826 4.1668C6.45346 3.31485 8.06417 2.7652 9.16466 4.1202C10.1791 5.36886 10.203 7.26157 10.4599 8.76952C10.7168 10.3336 10.963 11.9336 11.5114 13.4308C11.6632 13.8514 11.9535 14.6472 12.4793 14.7141C13.1568 14.8073 13.8474 13.6184 14.1617 13.1739C14.979 11.9945 16.0867 10.4053 15.9469 8.88781C15.8094 7.27591 14.0685 7.57941 12.9811 7.96416C13.1556 6.1551 14.8392 4.1214 16.4607 3.43314C18.1801 2.71979 20.7372 2.73174 21.6011 4.67105C22.5235 6.77286 21.6943 9.21402 20.6894 11.1187C19.5925 13.187 18.1801 15.1012 16.671 16.8888C15.3399 18.4768 13.765 20.2189 11.7803 20.9777C9.51357 21.8416 8.17052 20.158 7.39862 18.2079C6.55622 16.0846 6.13682 13.702 5.52862 11.4915C5.27291 10.5571 4.96941 9.49362 4.3624 8.72292C3.57019 7.72757 2.67044 8.66317 1.88779 9.19968C1.61894 8.93322 1.39669 8.59267 1.17444 8.30112Z"
  }));
},
    AR = function AR(_ref2186) {
  var _ref2186$color = _ref2186.color,
      C = _ref2186$color === void 0 ? "currentColor" : _ref2186$color,
      _ref2186$size = _ref2186.size,
      e = _ref2186$size === void 0 ? 24 : _ref2186$size,
      l = _ref2186.className,
      i = _objectWithoutProperties(_ref2186, _excluded2186);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17.9943 3.00439C20.4268 3.00439 21.9991 4.51608 21.9991 7.49995C21.9991 9.21958 21.0011 11.4397 20.1674 12.7348C17.3783 17.0676 13.9341 21.4745 10.5239 21.4745C6.81821 21.4745 5.85467 14.6436 5.43244 13.0427C5.01021 11.4418 4.89884 10.8338 4.26237 9.81039C3.94484 10.0291 3.50145 10.3387 2.9322 10.7392C2.7084 10.8967 2.39959 10.845 2.23929 10.6233L0.925925 8.80744C0.790064 8.6196 0.801127 8.36301 0.952669 8.18758C3.77969 4.91425 6.12916 3.27759 8.0011 3.27759C10.3929 3.27759 11.1255 6.09282 11.325 7.49995C11.6251 9.61689 12.0159 12.2378 12.5696 13.372C13.1258 12.5804 14.7497 10.4841 14.536 9.38116C14.4418 8.89549 13.2189 9.56533 12.6493 9.45951C12.2242 9.38055 11.8435 9.05783 11.8435 8.43376C11.8435 7.12364 13.6951 3.00439 17.9943 3.00439ZM18.0011 5.00439C15.8066 5.00439 14.75 6.53665 14.3478 7.21187C15.5983 7.25758 16.3173 8.03042 16.4816 9.01513C16.8701 11.3443 14.5653 13.9355 14.1425 14.5797C13.7465 15.183 11.0808 17.9083 9.89184 11.2205C9.77992 10.5911 9.52464 9.05669 9.22685 7.03358C9.05749 5.88298 8.35454 5.27079 7.99796 5.27079C7.15495 5.27079 6.07725 5.92036 4.14249 7.78573C6.04712 7.67086 6.68738 10.0616 7.0586 11.4191C7.87446 14.4028 8.62936 19.4745 10.6785 19.4745C12.4048 19.4745 15.1166 16.8286 18.0483 12.4359C18.2569 12.1235 20.0142 9.41071 20.0142 7.39933C20.0142 5.00439 18.5451 5.00439 18.0011 5.00439Z"
  }));
},
    kR = function kR(_ref2187) {
  var _ref2187$color = _ref2187.color,
      C = _ref2187$color === void 0 ? "currentColor" : _ref2187$color,
      _ref2187$size = _ref2187.size,
      e = _ref2187$size === void 0 ? 24 : _ref2187$size,
      l = _ref2187.className,
      i = _objectWithoutProperties(_ref2187, _excluded2187);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2.80577 5.20006L7.00505 7.99958L11.1913 2.13881C11.5123 1.6894 12.1369 1.58531 12.5863 1.90631C12.6761 1.97045 12.7546 2.04901 12.8188 2.13881L17.0051 7.99958L21.2043 5.20006C21.6639 4.89371 22.2847 5.01788 22.5911 5.47741C22.7228 5.67503 22.7799 5.91308 22.7522 6.14895L21.109 20.1164C21.0497 20.62 20.6229 20.9996 20.1158 20.9996H3.8943C3.38722 20.9996 2.9604 20.62 2.90115 20.1164L1.25792 6.14895C1.19339 5.60045 1.58573 5.10349 2.13423 5.03896C2.37011 5.01121 2.60816 5.06832 2.80577 5.20006ZM12.0051 14.9996C13.1096 14.9996 14.0051 14.1042 14.0051 12.9996C14.0051 11.895 13.1096 10.9996 12.0051 10.9996C10.9005 10.9996 10.0051 11.895 10.0051 12.9996C10.0051 14.1042 10.9005 14.9996 12.0051 14.9996Z"
  }));
},
    PR = function PR(_ref2188) {
  var _ref2188$color = _ref2188.color,
      C = _ref2188$color === void 0 ? "currentColor" : _ref2188$color,
      _ref2188$size = _ref2188.size,
      e = _ref2188$size === void 0 ? 24 : _ref2188$size,
      l = _ref2188.className,
      i = _objectWithoutProperties(_ref2188, _excluded2188);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3.49709 8.06464L4.78355 18.9996H19.2266L20.513 8.06464L16.5032 10.7379L12.0051 4.44051L7.50694 10.7379L3.49709 8.06464ZM2.80577 5.20006L7.00505 7.99958L11.1913 2.13881C11.5123 1.6894 12.1369 1.58531 12.5863 1.90631C12.6761 1.97045 12.7546 2.04901 12.8188 2.13881L17.0051 7.99958L21.2043 5.20006C21.6639 4.89371 22.2847 5.01788 22.5911 5.47741C22.7228 5.67503 22.7799 5.91308 22.7522 6.14895L21.109 20.1164C21.0497 20.62 20.6229 20.9996 20.1158 20.9996H3.8943C3.38722 20.9996 2.9604 20.62 2.90115 20.1164L1.25792 6.14895C1.19339 5.60045 1.58573 5.10349 2.13423 5.03896C2.37011 5.01121 2.60816 5.06832 2.80577 5.20006ZM12.0051 14.9996C10.9005 14.9996 10.0051 14.1042 10.0051 12.9996C10.0051 11.895 10.9005 10.9996 12.0051 10.9996C13.1096 10.9996 14.0051 11.895 14.0051 12.9996C14.0051 14.1042 13.1096 14.9996 12.0051 14.9996Z"
  }));
},
    DR = function DR(_ref2189) {
  var _ref2189$color = _ref2189.color,
      C = _ref2189$color === void 0 ? "currentColor" : _ref2189$color,
      _ref2189$size = _ref2189.size,
      e = _ref2189$size === void 0 ? 24 : _ref2189$size,
      l = _ref2189.className,
      i = _objectWithoutProperties(_ref2189, _excluded2189);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2.00488 19H22.0049V21H2.00488V19ZM2.00488 5L7.00488 8L12.0049 2L17.0049 8L22.0049 5V17H2.00488V5Z"
  }));
},
    yR = function yR(_ref2190) {
  var _ref2190$color = _ref2190.color,
      C = _ref2190$color === void 0 ? "currentColor" : _ref2190$color,
      _ref2190$size = _ref2190.size,
      e = _ref2190$size === void 0 ? 24 : _ref2190$size,
      l = _ref2190.className,
      i = _objectWithoutProperties(_ref2190, _excluded2190);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2.00488 19H22.0049V21H2.00488V19ZM2.00488 5L7.00488 8.5L12.0049 2L17.0049 8.5L22.0049 5V17H2.00488V5ZM4.00488 8.84131V15H20.0049V8.84131L16.5854 11.2349L12.0049 5.28024L7.42435 11.2349L4.00488 8.84131Z"
  }));
},
    bR = function bR(_ref2191) {
  var _ref2191$color = _ref2191.color,
      C = _ref2191$color === void 0 ? "currentColor" : _ref2191$color,
      _ref2191$size = _ref2191.size,
      e = _ref2191$size === void 0 ? 24 : _ref2191$size,
      l = _ref2191.className,
      i = _objectWithoutProperties(_ref2191, _excluded2191);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4.87759 3.00275H19.1319C19.4518 3.00275 19.7524 3.15583 19.9406 3.41457L23.7634 8.67097C23.9037 8.86385 23.8882 9.12895 23.7265 9.30419L12.3721 21.6047C12.1848 21.8076 11.8685 21.8203 11.6656 21.633C11.6558 21.6239 11.6464 21.6145 11.6373 21.6047L0.282992 9.30419C0.121226 9.12895 0.10575 8.86385 0.246026 8.67097L4.06886 3.41457C4.25704 3.15583 4.55766 3.00275 4.87759 3.00275Z"
  }));
},
    TR = function TR(_ref2192) {
  var _ref2192$color = _ref2192.color,
      C = _ref2192$color === void 0 ? "currentColor" : _ref2192$color,
      _ref2192$size = _ref2192.size,
      e = _ref2192$size === void 0 ? 24 : _ref2192$size,
      l = _ref2192.className,
      i = _objectWithoutProperties(_ref2192, _excluded2192);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4.87759 3.00275H19.1319C19.4518 3.00275 19.7524 3.15583 19.9406 3.41457L23.7634 8.67097C23.9037 8.86385 23.8882 9.12895 23.7265 9.30419L12.3721 21.6047C12.1848 21.8076 11.8685 21.8203 11.6656 21.633C11.6591 21.627 7.86486 17.5174 0.282992 9.30419C0.121226 9.12895 0.10575 8.86385 0.246026 8.67097L4.06886 3.41457C4.25704 3.15583 4.55766 3.00275 4.87759 3.00275ZM5.38682 5.00275L2.58738 8.85198L12.0047 19.0541L21.4221 8.85198L18.6226 5.00275H5.38682Z"
  }));
},
    UR = function UR(_ref2193) {
  var _ref2193$color = _ref2193.color,
      C = _ref2193$color === void 0 ? "currentColor" : _ref2193$color,
      _ref2193$size = _ref2193.size,
      e = _ref2193$size === void 0 ? 24 : _ref2193$size,
      l = _ref2193.className,
      i = _objectWithoutProperties(_ref2193, _excluded2193);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3.00488 3H21.0049C21.5572 3 22.0049 3.44772 22.0049 4V20C22.0049 20.5523 21.5572 21 21.0049 21H3.00488C2.4526 21 2.00488 20.5523 2.00488 20V4C2.00488 3.44772 2.4526 3 3.00488 3ZM11.0049 8.5V15.5H13.0049V8.5H11.0049ZM10.72 8.5H8.60604L7.10912 12.6127L5.61221 8.5H3.49827L6.10912 15.4637H8.10912L10.72 8.5ZM16.0049 13.5H17.5049C18.8856 13.5 20.0049 12.3807 20.0049 11C20.0049 9.61929 18.8856 8.5 17.5049 8.5H14.0049V15.5H16.0049V13.5ZM16.0049 11.5V10.5H17.5049C17.781 10.5 18.0049 10.7239 18.0049 11C18.0049 11.2761 17.781 11.5 17.5049 11.5H16.0049Z"
  }));
},
    GR = function GR(_ref2194) {
  var _ref2194$color = _ref2194.color,
      C = _ref2194$color === void 0 ? "currentColor" : _ref2194$color,
      _ref2194$size = _ref2194.size,
      e = _ref2194$size === void 0 ? 24 : _ref2194$size,
      l = _ref2194.className,
      i = _objectWithoutProperties(_ref2194, _excluded2194);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2.00488 19H22.0049V21H2.00488V19ZM11.0049 8H13.0049V16H11.0049V8ZM7.97001 8L6.10912 13.1127L4.24824 8H2.12334L5.10912 15.9637H7.10912L10.0949 8H7.97001ZM17.0049 14V16H15.0049V8H19.0049C20.6617 8 22.0049 9.34315 22.0049 11C22.0049 12.6569 20.6617 14 19.0049 14H17.0049ZM17.0049 10V12H19.0049C19.5572 12 20.0049 11.5523 20.0049 11C20.0049 10.4477 19.5572 10 19.0049 10H17.0049ZM2.00488 3H22.0049V5H2.00488V3Z"
  }));
},
    IR = function IR(_ref2195) {
  var _ref2195$color = _ref2195.color,
      C = _ref2195$color === void 0 ? "currentColor" : _ref2195$color,
      _ref2195$size = _ref2195.size,
      e = _ref2195$size === void 0 ? 24 : _ref2195$size,
      l = _ref2195.className,
      i = _objectWithoutProperties(_ref2195, _excluded2195);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13.7163 1.94745L17.4506 3.38092L16.7339 5.24808L15.8003 4.88947L15.0539 6.83436C15.8328 7.29585 16.4983 7.92847 16.9986 8.68044L18.9014 7.83255L18.4947 6.919L20.3218 6.10553L21.9487 9.75971L20.1216 10.5732L19.7149 9.65964L17.8126 10.5071C17.9348 10.9844 17.9998 11.4846 17.9998 12C17.9998 12.4062 17.9594 12.8031 17.8825 13.1867L19.8265 13.9327L20.1852 12.9998L22.0523 13.7165L20.6189 17.4508L18.7517 16.7341L19.1094 15.8009L17.1654 15.0541C16.7039 15.833 16.0713 16.4985 15.3194 16.9988L16.1672 18.9016L17.0808 18.4949L17.8943 20.322L14.2401 21.9489L13.4266 20.1218L14.3402 19.7151L13.4927 17.8128C13.0154 17.935 12.5152 18 11.9998 18C11.5932 18 11.196 17.9595 10.8121 17.8825L10.0662 19.8271L11 20.1854L10.2833 22.0525L6.54897 20.6191L7.2657 18.7519L8.19803 19.11L8.9457 17.1656C8.16683 16.7041 7.50133 16.0715 7.00097 15.3195L5.09818 16.1674L5.50492 17.081L3.67782 17.8944L2.05088 14.2403L3.87797 13.4268L4.28379 14.3407L6.18702 13.4929C6.06479 13.0156 5.99981 12.5154 5.99981 12C5.99981 11.5937 6.04018 11.1969 6.11714 10.8133L4.17174 10.0668L3.81443 11.0002L1.94727 10.2835L3.38074 6.54915L5.2479 7.26588L4.88888 8.19862L6.83418 8.94588C7.29566 8.16702 7.92829 7.50151 8.68026 7.00115L7.83237 5.09836L6.91882 5.5051L6.10535 3.67801L9.75953 2.05106L10.573 3.87815L9.65946 4.28489L10.5069 6.1872C10.9842 6.06497 11.4844 5.99999 11.9998 5.99999C12.4061 5.99999 12.8029 6.04037 13.1865 6.11732L13.9321 4.17233L12.9996 3.81461L13.7163 1.94745ZM10.1338 13.232C9.85764 13.7103 10.0215 14.3219 10.4998 14.5981C10.9781 14.8742 11.5897 14.7103 11.8658 14.232C12.142 13.7537 11.9781 13.1422 11.4998 12.866C11.0215 12.5899 10.4099 12.7537 10.1338 13.232ZM13.9998 11C13.4475 11 12.9998 11.4477 12.9998 12C12.9998 12.5523 13.4475 13 13.9998 13C14.5521 13 14.9998 12.5523 14.9998 12C14.9998 11.4477 14.5521 11 13.9998 11ZM10.4998 9.40191C10.0215 9.67806 9.85764 10.2896 10.1338 10.7679C10.4099 11.2462 11.0215 11.4101 11.4998 11.134C11.9781 10.8578 12.142 10.2462 11.8658 9.76794C11.5897 9.28965 10.9781 9.12577 10.4998 9.40191Z"
  }));
},
    WR = function WR(_ref2196) {
  var _ref2196$color = _ref2196.color,
      C = _ref2196$color === void 0 ? "currentColor" : _ref2196$color,
      _ref2196$size = _ref2196.size,
      e = _ref2196$size === void 0 ? 24 : _ref2196$size,
      l = _ref2196.className,
      i = _objectWithoutProperties(_ref2196, _excluded2196);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13.7163 1.94745L17.4506 3.38092L16.7339 5.24808L15.8003 4.88947L15.0539 6.83436C15.8328 7.29585 16.4983 7.92847 16.9986 8.68044L18.9014 7.83255L18.4947 6.919L20.3218 6.10553L21.9487 9.75971L20.1216 10.5732L19.7149 9.65964L17.8126 10.5071C17.9348 10.9844 17.9998 11.4846 17.9998 12C17.9998 12.4062 17.9594 12.8031 17.8825 13.1867L19.8265 13.9327L20.1852 12.9998L22.0523 13.7165L20.6189 17.4508L18.7517 16.7341L19.1094 15.8009L17.1654 15.0541C16.7039 15.833 16.0713 16.4985 15.3194 16.9988L16.1672 18.9016L17.0808 18.4949L17.8943 20.322L14.2401 21.9489L13.4266 20.1218L14.3402 19.7151L13.4927 17.8128C13.0154 17.935 12.5152 18 11.9998 18C11.5932 18 11.196 17.9595 10.8121 17.8825L10.0662 19.8271L11 20.1854L10.2833 22.0525L6.54897 20.6191L7.2657 18.7519L8.19803 19.11L8.9457 17.1656C8.16683 16.7041 7.50133 16.0715 7.00097 15.3195L5.09818 16.1674L5.50492 17.081L3.67782 17.8944L2.05088 14.2403L3.87797 13.4268L4.28379 14.3407L6.18702 13.4929C6.06479 13.0156 5.99981 12.5154 5.99981 12C5.99981 11.5937 6.04018 11.1969 6.11714 10.8133L4.17174 10.0668L3.81443 11.0002L1.94727 10.2835L3.38074 6.54915L5.2479 7.26588L4.88888 8.19862L6.83418 8.94588C7.29566 8.16702 7.92829 7.50151 8.68026 7.00115L7.83237 5.09836L6.91882 5.5051L6.10535 3.67801L9.75953 2.05106L10.573 3.87815L9.65946 4.28489L10.5069 6.1872C10.9842 6.06497 11.4844 5.99999 11.9998 5.99999C12.4061 5.99999 12.8029 6.04037 13.1865 6.11732L13.9321 4.17233L12.9996 3.81461L13.7163 1.94745ZM11.9998 7.99999C9.79067 7.99999 7.99981 9.79085 7.99981 12C7.99981 14.2091 9.79067 16 11.9998 16C14.2089 16 15.9998 14.2091 15.9998 12C15.9998 9.79085 14.2089 7.99999 11.9998 7.99999ZM11.4998 12.866C11.9781 13.1422 12.142 13.7537 11.8658 14.232C11.5897 14.7103 10.9781 14.8742 10.4998 14.5981C10.0215 14.3219 9.85764 13.7103 10.1338 13.232C10.4099 12.7537 11.0215 12.5899 11.4998 12.866ZM13.9998 11C14.5521 11 14.9998 11.4477 14.9998 12C14.9998 12.5523 14.5521 13 13.9998 13C13.4475 13 12.9998 12.5523 12.9998 12C12.9998 11.4477 13.4475 11 13.9998 11ZM11.8658 9.76794C12.142 10.2462 11.9781 10.8578 11.4998 11.134C11.0215 11.4101 10.4099 11.2462 10.1338 10.7679C9.85764 10.2896 10.0215 9.67806 10.4998 9.40191C10.9781 9.12577 11.5897 9.28965 11.8658 9.76794Z"
  }));
},
    OR = function OR(_ref2197) {
  var _ref2197$color = _ref2197.color,
      C = _ref2197$color === void 0 ? "currentColor" : _ref2197$color,
      _ref2197$size = _ref2197.size,
      e = _ref2197$size === void 0 ? 24 : _ref2197$size,
      l = _ref2197.className,
      i = _objectWithoutProperties(_ref2197, _excluded2197);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M1 4H23V6H1V4ZM1 18H23V20H1V18ZM19.6217 14.9136L19.448 14.0436L17.4994 14.0435L17.1899 14.907L15.6275 14.9105C16.6316 12.5036 17.3767 10.7206 17.8628 9.56169C17.9898 9.25902 18.2156 9.10462 18.5482 9.10699C18.802 9.10888 19.2168 9.10912 19.7927 9.10771L21 14.9108L19.6217 14.9136ZM17.9376 12.8518H19.1936L18.7248 10.6715L17.9376 12.8518ZM7.87203 9.10561L9.44245 9.10764L7.01511 14.9136L5.42535 14.9129C4.88785 12.8424 4.49315 11.3073 4.24125 10.3076C4.16402 10.001 4.01042 9.787 3.71519 9.68577C3.45195 9.59551 3.01355 9.45594 2.4 9.26707V9.10771C3.54718 9.10757 4.38339 9.10757 4.90863 9.10771C5.34299 9.10784 5.59619 9.31703 5.67765 9.74655C5.75942 10.1779 5.96599 11.2743 6.29735 13.0359L7.87203 9.10561ZM11.5994 9.10765L10.3588 14.913L8.86434 14.9108C8.89383 14.7698 9.30682 12.8347 10.1033 9.10561L11.5994 9.10765ZM14.6307 9C15.0773 9 15.6405 9.13846 15.9652 9.26707L15.703 10.4706C15.41 10.3532 14.9284 10.1944 14.5228 10.2006C13.933 10.2097 13.569 10.4566 13.569 10.6936C13.569 11.0783 14.2015 11.272 14.8528 11.6929C15.5956 12.1729 15.6937 12.603 15.6845 13.0713C15.6739 14.0422 14.8528 15 13.12 15C12.3286 14.9882 12.0444 14.9219 11.3995 14.6936L11.6718 13.4376C12.3282 13.712 12.6066 13.7991 13.1675 13.7991C13.6816 13.7991 14.1229 13.5918 14.1267 13.2308C14.1294 12.974 13.972 12.847 13.395 12.5293C12.8181 12.2117 12.0095 11.7726 12.0199 10.8889C12.0332 9.75821 13.1066 9 14.6307 9Z"
  }));
},
    KR = function KR(_ref2198) {
  var _ref2198$color = _ref2198.color,
      C = _ref2198$color === void 0 ? "currentColor" : _ref2198$color,
      _ref2198$size = _ref2198.size,
      e = _ref2198$size === void 0 ? 24 : _ref2198$size,
      l = _ref2198.className,
      i = _objectWithoutProperties(_ref2198, _excluded2198);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22.2215 15.7683L21.9974 14.6431L19.4831 14.6431L19.0837 15.7599L17.0677 15.7643C18.3633 12.6514 19.3247 10.3455 19.952 8.84657C20.1159 8.45511 20.4072 8.25543 20.8364 8.25848C21.1638 8.26094 21.6991 8.26124 22.4421 8.25942L24 15.7648L22.2215 15.7683ZM20.0485 13.1018H21.6692L21.0642 10.2819L20.0485 13.1018ZM7.06069 8.2567L9.08703 8.25933L5.95498 15.7683L3.90367 15.7675C3.21013 13.0896 2.70084 11.1042 2.37581 9.81122C2.27616 9.4148 2.07796 9.13797 1.69702 9.00705C1.35736 8.89031 0.791683 8.7098 0 8.46553V8.25942C1.48023 8.25924 2.55921 8.25924 3.23694 8.25942C3.7974 8.25959 4.12411 8.53015 4.22922 9.08566C4.33473 9.6435 4.60127 11.0616 5.02884 13.3398L7.06069 8.2567ZM11.8702 8.25934L10.2695 15.7676L8.34108 15.7648C8.37914 15.5824 8.91202 13.0797 9.93972 8.2567L11.8702 8.25934ZM15.7815 8.12012C16.3578 8.12012 17.0846 8.2992 17.5035 8.46553L17.1652 10.0221C16.7871 9.87023 16.1657 9.66491 15.6424 9.67294C14.8813 9.68462 14.4117 10.004 14.4117 10.3105C14.4117 10.808 15.2277 11.0586 16.0681 11.603C17.0265 12.2237 17.1531 12.78 17.1412 13.3856C17.1277 14.6413 16.0681 15.8801 13.8322 15.8801C12.8111 15.8648 12.4444 15.7791 11.6122 15.4839L11.9637 13.8595C12.8106 14.2142 13.1698 14.327 13.8935 14.327C14.5569 14.327 15.1263 14.0589 15.1312 13.5919C15.1347 13.2598 14.9316 13.0955 14.1871 12.6847C13.4427 12.2739 12.3994 11.706 12.4128 10.5631C12.43 9.10074 13.815 8.12012 15.7815 8.12012Z"
  }));
},
    QR = function QR(_ref2199) {
  var _ref2199$color = _ref2199.color,
      C = _ref2199$color === void 0 ? "currentColor" : _ref2199$color,
      _ref2199$size = _ref2199.size,
      e = _ref2199$size === void 0 ? 24 : _ref2199$size,
      l = _ref2199.className,
      i = _objectWithoutProperties(_ref2199, _excluded2199);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.998 3V21H2.99805V3H20.998ZM12.998 6H10.998V18H12.998V6ZM8.99805 9H6.99805V15H8.99805V9ZM16.998 9H14.998V15H16.998V9Z"
  }));
},
    qR = function qR(_ref2200) {
  var _ref2200$color = _ref2200.color,
      C = _ref2200$color === void 0 ? "currentColor" : _ref2200$color,
      _ref2200$size = _ref2200.size,
      e = _ref2200$size === void 0 ? 24 : _ref2200$size,
      l = _ref2200.className,
      i = _objectWithoutProperties(_ref2200, _excluded2200);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4.99805 15V19H8.99805V21H2.99805V15H4.99805ZM20.998 15V21H14.998V19H18.998V15H20.998ZM12.998 6V18H10.998V6H12.998ZM8.99805 9V15H6.99805V9H8.99805ZM16.998 9V15H14.998V9H16.998ZM8.99805 3V5H4.99805V9H2.99805V3H8.99805ZM20.998 3V9H18.998V5H14.998V3H20.998Z"
  }));
},
    jR = function jR(_ref2201) {
  var _ref2201$color = _ref2201.color,
      C = _ref2201$color === void 0 ? "currentColor" : _ref2201$color,
      _ref2201$size = _ref2201.size,
      e = _ref2201$size === void 0 ? 24 : _ref2201$size,
      l = _ref2201.className,
      i = _objectWithoutProperties(_ref2201, _excluded2201);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5 7H7V17H5V7ZM1 10H3V14H1V10ZM9 2H11V20H9V2ZM13 4H15V22H13V4ZM17 7H19V17H17V7ZM21 10H23V14H21V10Z"
  }));
},
    XR = function XR(_ref2202) {
  var _ref2202$color = _ref2202.color,
      C = _ref2202$color === void 0 ? "currentColor" : _ref2202$color,
      _ref2202$size = _ref2202.size,
      e = _ref2202$size === void 0 ? 24 : _ref2202$size,
      l = _ref2202.className,
      i = _objectWithoutProperties(_ref2202, _excluded2202);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5 7H7V17H5V7ZM1 10H3V14H1V10ZM9 2H11V20H9V2ZM13 4H15V22H13V4ZM17 7H19V17H17V7ZM21 10H23V14H21V10Z"
  }));
},
    JR = function JR(_ref2203) {
  var _ref2203$color = _ref2203.color,
      C = _ref2203$color === void 0 ? "currentColor" : _ref2203$color,
      _ref2203$size = _ref2203.size,
      e = _ref2203$size === void 0 ? 24 : _ref2203$size,
      l = _ref2203.className,
      i = _objectWithoutProperties(_ref2203, _excluded2203);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8.88889 16.0001H5C4.44772 16.0001 4 15.5524 4 15.0001V9.00007C4 8.44778 4.44772 8.00007 5 8.00007H8.88889L14.1834 3.66821C14.3971 3.49335 14.7121 3.52485 14.887 3.73857C14.9601 3.8279 15 3.93977 15 4.05519V19.9449C15 20.2211 14.7761 20.4449 14.5 20.4449C14.3846 20.4449 14.2727 20.405 14.1834 20.3319L8.88889 16.0001ZM18.8631 16.5911L17.4411 15.1691C18.3892 14.4376 19 13.2902 19 12.0001C19 10.5697 18.2493 9.31476 17.1203 8.60766L18.5589 7.16906C20.0396 8.26166 21 10.0187 21 12.0001C21 13.8422 20.1698 15.4905 18.8631 16.5911Z"
  }));
},
    YR = function YR(_ref2204) {
  var _ref2204$color = _ref2204.color,
      C = _ref2204$color === void 0 ? "currentColor" : _ref2204$color,
      _ref2204$size = _ref2204.size,
      e = _ref2204$size === void 0 ? 24 : _ref2204$size,
      l = _ref2204.className,
      i = _objectWithoutProperties(_ref2204, _excluded2204);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13 7.22056L9.60282 10.0001H6V14.0001H9.60282L13 16.7796V7.22056ZM8.88889 16.0001H5C4.44772 16.0001 4 15.5524 4 15.0001V9.00007C4 8.44778 4.44772 8.00007 5 8.00007H8.88889L14.1834 3.66821C14.3971 3.49335 14.7121 3.52485 14.887 3.73857C14.9601 3.8279 15 3.93977 15 4.05519V19.9449C15 20.2211 14.7761 20.4449 14.5 20.4449C14.3846 20.4449 14.2727 20.405 14.1834 20.3319L8.88889 16.0001ZM18.8631 16.5911L17.4411 15.1691C18.3892 14.4376 19 13.2902 19 12.0001C19 10.5697 18.2493 9.31476 17.1203 8.60766L18.5589 7.16906C20.0396 8.26166 21 10.0187 21 12.0001C21 13.8422 20.1698 15.4905 18.8631 16.5911Z"
  }));
},
    _R = function _R(_ref2205) {
  var _ref2205$color = _ref2205.color,
      C = _ref2205$color === void 0 ? "currentColor" : _ref2205$color,
      _ref2205$size = _ref2205.size,
      e = _ref2205$size === void 0 ? 24 : _ref2205$size,
      l = _ref2205.className,
      i = _objectWithoutProperties(_ref2205, _excluded2205);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5.88889 16.0001H2C1.44772 16.0001 1 15.5524 1 15.0001V9.00007C1 8.44778 1.44772 8.00007 2 8.00007H5.88889L11.1834 3.66821C11.3971 3.49335 11.7121 3.52485 11.887 3.73857C11.9601 3.8279 12 3.93977 12 4.05519V19.9449C12 20.2211 11.7761 20.4449 11.5 20.4449C11.3846 20.4449 11.2727 20.405 11.1834 20.3319L5.88889 16.0001ZM20.4142 12.0001L23.9497 15.5356L22.5355 16.9498L19 13.4143L15.4645 16.9498L14.0503 15.5356L17.5858 12.0001L14.0503 8.46454L15.4645 7.05032L19 10.5859L22.5355 7.05032L23.9497 8.46454L20.4142 12.0001Z"
  }));
},
    $R = function $R(_ref2206) {
  var _ref2206$color = _ref2206.color,
      C = _ref2206$color === void 0 ? "currentColor" : _ref2206$color,
      _ref2206$size = _ref2206.size,
      e = _ref2206$size === void 0 ? 24 : _ref2206$size,
      l = _ref2206.className,
      i = _objectWithoutProperties(_ref2206, _excluded2206);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10 7.22056L6.60282 10.0001H3V14.0001H6.60282L10 16.7796V7.22056ZM5.88889 16.0001H2C1.44772 16.0001 1 15.5524 1 15.0001V9.00007C1 8.44778 1.44772 8.00007 2 8.00007H5.88889L11.1834 3.66821C11.3971 3.49335 11.7121 3.52485 11.887 3.73857C11.9601 3.8279 12 3.93977 12 4.05519V19.9449C12 20.2211 11.7761 20.4449 11.5 20.4449C11.3846 20.4449 11.2727 20.405 11.1834 20.3319L5.88889 16.0001ZM20.4142 12.0001L23.9497 15.5356L22.5355 16.9498L19 13.4143L15.4645 16.9498L14.0503 15.5356L17.5858 12.0001L14.0503 8.46454L15.4645 7.05032L19 10.5859L22.5355 7.05032L23.9497 8.46454L20.4142 12.0001Z"
  }));
},
    ez = function ez(_ref2207) {
  var _ref2207$color = _ref2207.color,
      C = _ref2207$color === void 0 ? "currentColor" : _ref2207$color,
      _ref2207$size = _ref2207.size,
      e = _ref2207$size === void 0 ? 24 : _ref2207$size,
      l = _ref2207.className,
      i = _objectWithoutProperties(_ref2207, _excluded2207);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19.3891 3.16117L20.8033 4.57538L18.3277 7.04955L20.8033 9.52513L18.3277 11.9993L20.8033 14.4749L18.3284 16.9498L20.8033 19.4246L19.3891 20.8388L15.5 16.9498L17.9749 14.4749L15.5 12L17.9749 9.52513L15.5 7.05026L19.3891 3.16117ZM13 19.9449C13 20.221 12.7761 20.4449 12.5 20.4449C12.3846 20.4449 12.2727 20.405 12.1834 20.3319L6.88901 15.9991L3.00001 16C2.44772 16 2.00001 15.5523 2.00001 15V9.00001C2.00001 8.44772 2.44772 8.00001 3.00001 8.00001L5.58362 7.99762L1.80762 4.22183L3.22183 2.80762L12.9996 12.5856L13 19.9449ZM12.887 3.73851C12.9601 3.82784 13 3.93971 13 4.05513V9.75717L9.282 6.04017L12.1834 3.66815C12.3971 3.49328 12.7121 3.52479 12.887 3.73851Z"
  }));
},
    tz = function tz(_ref2208) {
  var _ref2208$color = _ref2208.color,
      C = _ref2208$color === void 0 ? "currentColor" : _ref2208$color,
      _ref2208$size = _ref2208.size,
      e = _ref2208$size === void 0 ? 24 : _ref2208$size,
      l = _ref2208.className,
      i = _objectWithoutProperties(_ref2208, _excluded2208);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19.3891 3.16117L20.8033 4.57538L18.3277 7.04955L20.8033 9.52513L18.3277 11.9993L20.8033 14.4749L18.3284 16.9498L20.8033 19.4246L19.3891 20.8388L15.5 16.9498L17.9749 14.4749L15.5 12L17.9749 9.52513L15.5 7.05026L19.3891 3.16117ZM13 19.9449C13 20.221 12.7761 20.4449 12.5 20.4449C12.3846 20.4449 12.2727 20.405 12.1834 20.3319L6.88901 15.9991L3.00001 16C2.44772 16 2.00001 15.5523 2.00001 15V9.00001C2.00001 8.44772 2.44772 8.00001 3.00001 8.00001L5.58362 7.99762L1.80762 4.22183L3.22183 2.80762L12.9996 12.5856L13 19.9449ZM7.58401 9.99811L4.00001 9.999V14L7.60286 13.9989L11 16.779V13.4141L7.58401 9.99811ZM12.887 3.73851C12.9601 3.82784 13 3.93971 13 4.05513V9.75711L11 7.75711V7.22001L10.704 7.46111L9.28301 6.04011L12.1834 3.66815C12.3971 3.49328 12.7121 3.52479 12.887 3.73851Z"
  }));
},
    Cz = function Cz(_ref2209) {
  var _ref2209$color = _ref2209.color,
      C = _ref2209$color === void 0 ? "currentColor" : _ref2209$color,
      _ref2209$size = _ref2209.size,
      e = _ref2209$size === void 0 ? 24 : _ref2209$size,
      l = _ref2209.className,
      i = _objectWithoutProperties(_ref2209, _excluded2209);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 16.0001H5.88889L11.1834 20.3319C11.2727 20.405 11.3846 20.4449 11.5 20.4449C11.7761 20.4449 12 20.2211 12 19.9449V4.05519C12 3.93977 11.9601 3.8279 11.887 3.73857C11.7121 3.52485 11.3971 3.49335 11.1834 3.66821L5.88889 8.00007H2C1.44772 8.00007 1 8.44778 1 9.00007V15.0001C1 15.5524 1.44772 16.0001 2 16.0001ZM23 12C23 15.292 21.5539 18.2463 19.2622 20.2622L17.8445 18.8444C19.7758 17.1937 21 14.7398 21 12C21 9.26016 19.7758 6.80629 17.8445 5.15557L19.2622 3.73779C21.5539 5.75368 23 8.70795 23 12ZM18 12C18 10.0883 17.106 8.38548 15.7133 7.28673L14.2842 8.71584C15.3213 9.43855 16 10.64 16 12C16 13.36 15.3213 14.5614 14.2842 15.2841L15.7133 16.7132C17.106 15.6145 18 13.9116 18 12Z"
  }));
},
    lz = function lz(_ref2210) {
  var _ref2210$color = _ref2210.color,
      C = _ref2210$color === void 0 ? "currentColor" : _ref2210$color,
      _ref2210$size = _ref2210.size,
      e = _ref2210$size === void 0 ? 24 : _ref2210$size,
      l = _ref2210.className,
      i = _objectWithoutProperties(_ref2210, _excluded2210);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.60282 10.0001L10 7.22056V16.7796L6.60282 14.0001H3V10.0001H6.60282ZM2 16.0001H5.88889L11.1834 20.3319C11.2727 20.405 11.3846 20.4449 11.5 20.4449C11.7761 20.4449 12 20.2211 12 19.9449V4.05519C12 3.93977 11.9601 3.8279 11.887 3.73857C11.7121 3.52485 11.3971 3.49335 11.1834 3.66821L5.88889 8.00007H2C1.44772 8.00007 1 8.44778 1 9.00007V15.0001C1 15.5524 1.44772 16.0001 2 16.0001ZM23 12C23 15.292 21.5539 18.2463 19.2622 20.2622L17.8445 18.8444C19.7758 17.1937 21 14.7398 21 12C21 9.26016 19.7758 6.80629 17.8445 5.15557L19.2622 3.73779C21.5539 5.75368 23 8.70795 23 12ZM18 12C18 10.0883 17.106 8.38548 15.7133 7.28673L14.2842 8.71584C15.3213 9.43855 16 10.64 16 12C16 13.36 15.3213 14.5614 14.2842 15.2841L15.7133 16.7132C17.106 15.6145 18 13.9116 18 12Z"
  }));
},
    iz = function iz(_ref2211) {
  var _ref2211$color = _ref2211.color,
      C = _ref2211$color === void 0 ? "currentColor" : _ref2211$color,
      _ref2211$size = _ref2211.size,
      e = _ref2211$size === void 0 ? 24 : _ref2211$size,
      l = _ref2211.className,
      i = _objectWithoutProperties(_ref2211, _excluded2211);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19.3891 3.16113L20.8033 4.57535L18.3277 7.04951L20.8033 9.52509L18.3277 11.9993L20.8033 14.4748L18.3284 16.9497L20.8033 19.4246L19.3891 20.8388L15.5 16.9497L17.9749 14.4748L15.5 12L17.9749 9.52509L15.5 7.05022L19.3891 3.16113ZM12.887 3.73847C12.9601 3.8278 13 3.93967 13 4.05509V19.9448C13 20.221 12.7761 20.4448 12.5 20.4448C12.3846 20.4448 12.2727 20.4049 12.1834 20.3318L6.889 15.9991L3 16C2.44772 16 2 15.5523 2 15V8.99997C2 8.44768 2.44772 7.99997 3 7.99997L6.889 7.99907L12.1834 3.66811C12.3971 3.49325 12.7121 3.52475 12.887 3.73847Z"
  }));
},
    sz = function sz(_ref2212) {
  var _ref2212$color = _ref2212.color,
      C = _ref2212$color === void 0 ? "currentColor" : _ref2212$color,
      _ref2212$size = _ref2212.size,
      e = _ref2212$size === void 0 ? 24 : _ref2212$size,
      l = _ref2212.className,
      i = _objectWithoutProperties(_ref2212, _excluded2212);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19.3891 3.16113L20.8033 4.57535L18.3277 7.04951L20.8033 9.52509L18.3277 11.9993L20.8033 14.4748L18.3284 16.9497L20.8033 19.4246L19.3891 20.8388L15.5 16.9497L17.9749 14.4748L15.5 12L17.9749 9.52509L15.5 7.05022L19.3891 3.16113ZM12.887 3.73847C12.9601 3.8278 13 3.93967 13 4.05509V19.9448C13 20.221 12.7761 20.4448 12.5 20.4448C12.3846 20.4448 12.2727 20.4049 12.1834 20.3318L6.889 15.9991L3 16C2.44772 16 2 15.5523 2 15V8.99997C2 8.44768 2.44772 7.99997 3 7.99997L6.889 7.99907L12.1834 3.66811C12.3971 3.49325 12.7121 3.52475 12.887 3.73847ZM11 7.21997L7.60302 9.99891L4 9.99897V14L7.60285 13.9989L11 16.779V7.21997Z"
  }));
},
    rz = function rz(_ref2213) {
  var _ref2213$color = _ref2213.color,
      C = _ref2213$color === void 0 ? "currentColor" : _ref2213$color,
      _ref2213$size = _ref2213.size,
      e = _ref2213$size === void 0 ? 24 : _ref2213$size,
      l = _ref2213.className,
      i = _objectWithoutProperties(_ref2213, _excluded2213);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M1.00098 3H5.00098L12.001 15L19.001 3H23.001L12.001 22L1.00098 3ZM9.66764 3L12.001 7L14.3343 3H18.3694L12.001 14L5.63256 3H9.66764Z"
  }));
},
    cz = function cz(_ref2214) {
  var _ref2214$color = _ref2214.color,
      C = _ref2214$color === void 0 ? "currentColor" : _ref2214$color,
      _ref2214$size = _ref2214.size,
      e = _ref2214$size === void 0 ? 24 : _ref2214$size,
      l = _ref2214.className,
      i = _objectWithoutProperties(_ref2214, _excluded2214);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3.31677 3L12.001 18L20.6852 3H23.001L12.001 22L1.00098 3H3.31677ZM7.65887 3L12.001 10.5L16.3431 3H18.6589L12.001 14.5L5.34308 3H7.65887Z"
  }));
},
    oz = function oz(_ref2215) {
  var _ref2215$color = _ref2215.color,
      C = _ref2215$color === void 0 ? "currentColor" : _ref2215$color,
      _ref2215$size = _ref2215.size,
      e = _ref2215$size === void 0 ? 24 : _ref2215$size,
      l = _ref2215.className,
      i = _objectWithoutProperties(_ref2215, _excluded2215);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7.61713 8.71233L10.8222 6.38373C11.174 6.12735 11.6087 5.98543 12.065 6.0008C13.1764 6.02813 14.1524 6.75668 14.4919 7.82036C14.6782 8.40431 14.8481 8.79836 15.0017 9.0025C15.914 10.2155 17.3655 11 19.0002 11V13C16.8255 13 14.8825 12.0083 13.5986 10.4526L12.901 14.4085L14.9621 16.138L17.1853 22.246L15.3059 22.93L13.266 17.3256L9.87576 14.4808C9.32821 14.0382 9.03139 13.3192 9.16231 12.5767L9.67091 9.6923L8.99407 10.1841L6.86706 13.1116L5.24902 11.9361L7.60016 8.7L7.61713 8.71233ZM13.5002 5.5C12.3956 5.5 11.5002 4.60457 11.5002 3.5C11.5002 2.39543 12.3956 1.5 13.5002 1.5C14.6047 1.5 15.5002 2.39543 15.5002 3.5C15.5002 4.60457 14.6047 5.5 13.5002 5.5ZM10.5286 18.6813L7.31465 22.5116L5.78257 21.226L8.75774 17.6803L9.50426 15.5L11.2954 17L10.5286 18.6813Z"
  }));
},
    az = function az(_ref2216) {
  var _ref2216$color = _ref2216.color,
      C = _ref2216$color === void 0 ? "currentColor" : _ref2216$color,
      _ref2216$size = _ref2216.size,
      e = _ref2216$size === void 0 ? 24 : _ref2216$size,
      l = _ref2216.className,
      i = _objectWithoutProperties(_ref2216, _excluded2216);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7.61713 8.71233L10.8222 6.38373C11.174 6.12735 11.6087 5.98543 12.065 6.0008C13.1764 6.02813 14.1524 6.75668 14.4919 7.82036C14.6782 8.40431 14.8481 8.79836 15.0017 9.0025C15.914 10.2155 17.3655 11 19.0002 11V13C16.8255 13 14.8825 12.0083 13.5986 10.4526L12.901 14.4085L14.9621 16.138L17.1853 22.246L15.3059 22.93L13.266 17.3256L9.87576 14.4808C9.32821 14.0382 9.03139 13.3192 9.16231 12.5767L9.67091 9.6923L8.99407 10.1841L6.86706 13.1116L5.24902 11.9361L7.60016 8.7L7.61713 8.71233ZM13.5002 5.5C12.3956 5.5 11.5002 4.60457 11.5002 3.5C11.5002 2.39543 12.3956 1.5 13.5002 1.5C14.6047 1.5 15.5002 2.39543 15.5002 3.5C15.5002 4.60457 14.6047 5.5 13.5002 5.5ZM10.5286 18.6813L7.31465 22.5116L5.78257 21.226L8.75774 17.6803L9.50426 15.5L11.2954 17L10.5286 18.6813Z"
  }));
},
    nz = function nz(_ref2217) {
  var _ref2217$color = _ref2217.color,
      C = _ref2217$color === void 0 ? "currentColor" : _ref2217$color,
      _ref2217$size = _ref2217.size,
      e = _ref2217$size === void 0 ? 24 : _ref2217$size,
      l = _ref2217.className,
      i = _objectWithoutProperties(_ref2217, _excluded2217);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22.0049 7.99979H13.0049C12.4526 7.99979 12.0049 8.4475 12.0049 8.99979V14.9998C12.0049 15.5521 12.4526 15.9998 13.0049 15.9998H22.0049V19.9998C22.0049 20.5521 21.5572 20.9998 21.0049 20.9998H3.00488C2.4526 20.9998 2.00488 20.5521 2.00488 19.9998V3.99979C2.00488 3.4475 2.4526 2.99979 3.00488 2.99979H21.0049C21.5572 2.99979 22.0049 3.4475 22.0049 3.99979V7.99979ZM15.0049 10.9998H18.0049V12.9998H15.0049V10.9998Z"
  }));
},
    mz = function mz(_ref2218) {
  var _ref2218$color = _ref2218.color,
      C = _ref2218$color === void 0 ? "currentColor" : _ref2218$color,
      _ref2218$size = _ref2218.size,
      e = _ref2218$size === void 0 ? 24 : _ref2218$size,
      l = _ref2218.className,
      i = _objectWithoutProperties(_ref2218, _excluded2218);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.0049 6.99979V4.99979H4.00488V18.9998H20.0049V16.9998H12.0049C11.4526 16.9998 11.0049 16.5521 11.0049 15.9998V7.99979C11.0049 7.4475 11.4526 6.99979 12.0049 6.99979H20.0049ZM3.00488 2.99979H21.0049C21.5572 2.99979 22.0049 3.4475 22.0049 3.99979V19.9998C22.0049 20.5521 21.5572 20.9998 21.0049 20.9998H3.00488C2.4526 20.9998 2.00488 20.5521 2.00488 19.9998V3.99979C2.00488 3.4475 2.4526 2.99979 3.00488 2.99979ZM13.0049 8.99979V14.9998H20.0049V8.99979H13.0049ZM15.0049 10.9998H18.0049V12.9998H15.0049V10.9998Z"
  }));
},
    wz = function wz(_ref2219) {
  var _ref2219$color = _ref2219.color,
      C = _ref2219$color === void 0 ? "currentColor" : _ref2219$color,
      _ref2219$size = _ref2219.size,
      e = _ref2219$size === void 0 ? 24 : _ref2219$size,
      l = _ref2219.className,
      i = _objectWithoutProperties(_ref2219, _excluded2219);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22.0049 5.99979H15.0049C11.6912 5.99979 9.00488 8.68608 9.00488 11.9998C9.00488 15.3135 11.6912 17.9998 15.0049 17.9998H22.0049V19.9998C22.0049 20.5521 21.5572 20.9998 21.0049 20.9998H3.00488C2.4526 20.9998 2.00488 20.5521 2.00488 19.9998V3.99979C2.00488 3.4475 2.4526 2.99979 3.00488 2.99979H21.0049C21.5572 2.99979 22.0049 3.4475 22.0049 3.99979V5.99979ZM15.0049 7.99979H23.0049V15.9998H15.0049C12.7957 15.9998 11.0049 14.2089 11.0049 11.9998C11.0049 9.79065 12.7957 7.99979 15.0049 7.99979ZM15.0049 10.9998V12.9998H18.0049V10.9998H15.0049Z"
  }));
},
    Lz = function Lz(_ref2220) {
  var _ref2220$color = _ref2220.color,
      C = _ref2220$color === void 0 ? "currentColor" : _ref2220$color,
      _ref2220$size = _ref2220.size,
      e = _ref2220$size === void 0 ? 24 : _ref2220$size,
      l = _ref2220.className,
      i = _objectWithoutProperties(_ref2220, _excluded2220);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22.0049 6.99979H23.0049V16.9998H22.0049V19.9998C22.0049 20.5521 21.5572 20.9998 21.0049 20.9998H3.00488C2.4526 20.9998 2.00488 20.5521 2.00488 19.9998V3.99979C2.00488 3.4475 2.4526 2.99979 3.00488 2.99979H21.0049C21.5572 2.99979 22.0049 3.4475 22.0049 3.99979V6.99979ZM20.0049 16.9998H14.0049C11.2435 16.9998 9.00488 14.7612 9.00488 11.9998C9.00488 9.23836 11.2435 6.99979 14.0049 6.99979H20.0049V4.99979H4.00488V18.9998H20.0049V16.9998ZM21.0049 14.9998V8.99979H14.0049C12.348 8.99979 11.0049 10.3429 11.0049 11.9998C11.0049 13.6566 12.348 14.9998 14.0049 14.9998H21.0049ZM14.0049 10.9998H17.0049V12.9998H14.0049V10.9998Z"
  }));
},
    hz = function hz(_ref2221) {
  var _ref2221$color = _ref2221.color,
      C = _ref2221$color === void 0 ? "currentColor" : _ref2221$color,
      _ref2221$size = _ref2221.size,
      e = _ref2221$size === void 0 ? 24 : _ref2221$size,
      l = _ref2221.className,
      i = _objectWithoutProperties(_ref2221, _excluded2221);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2.00488 8.99979H21.0049C21.5572 8.99979 22.0049 9.4475 22.0049 9.99979V19.9998C22.0049 20.5521 21.5572 20.9998 21.0049 20.9998H3.00488C2.4526 20.9998 2.00488 20.5521 2.00488 19.9998V8.99979ZM3.00488 2.99979H18.0049V6.99979H2.00488V3.99979C2.00488 3.4475 2.4526 2.99979 3.00488 2.99979ZM15.0049 13.9998V15.9998H18.0049V13.9998H15.0049Z"
  }));
},
    Hz = function Hz(_ref2222) {
  var _ref2222$color = _ref2222.color,
      C = _ref2222$color === void 0 ? "currentColor" : _ref2222$color,
      _ref2222$size = _ref2222.size,
      e = _ref2222$size === void 0 ? 24 : _ref2222$size,
      l = _ref2222.className,
      i = _objectWithoutProperties(_ref2222, _excluded2222);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18.0049 6.99979H21.0049C21.5572 6.99979 22.0049 7.4475 22.0049 7.99979V19.9998C22.0049 20.5521 21.5572 20.9998 21.0049 20.9998H3.00488C2.4526 20.9998 2.00488 20.5521 2.00488 19.9998V3.99979C2.00488 3.4475 2.4526 2.99979 3.00488 2.99979H18.0049V6.99979ZM4.00488 8.99979V18.9998H20.0049V8.99979H4.00488ZM4.00488 4.99979V6.99979H16.0049V4.99979H4.00488ZM15.0049 12.9998H18.0049V14.9998H15.0049V12.9998Z"
  }));
},
    Vz = function Vz(_ref2223) {
  var _ref2223$color = _ref2223.color,
      C = _ref2223$color === void 0 ? "currentColor" : _ref2223$color,
      _ref2223$size = _ref2223.size,
      e = _ref2223$size === void 0 ? 24 : _ref2223$size,
      l = _ref2223.className,
      i = _objectWithoutProperties(_ref2223, _excluded2223);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5.64092 6.63874L12.0049 0.27478L18.3688 6.63874C21.8836 10.1535 21.8836 15.8519 18.3688 19.3667C14.8541 22.8814 9.15564 22.8814 5.64092 19.3667C2.1262 15.8519 2.1262 10.1535 5.64092 6.63874H5.64092ZM13.0049 11.0027V6.5027L8.50488 13.0027H11.0049V17.5027L15.5049 11.0027H13.0049Z"
  }));
},
    gz = function gz(_ref2224) {
  var _ref2224$color = _ref2224.color,
      C = _ref2224$color === void 0 ? "currentColor" : _ref2224$color,
      _ref2224$size = _ref2224.size,
      e = _ref2224$size === void 0 ? 24 : _ref2224$size,
      l = _ref2224.className,
      i = _objectWithoutProperties(_ref2224, _excluded2224);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.0049 3.10321L7.05514 8.05295C4.32147 10.7866 4.32147 15.2188 7.05514 17.9524C9.78881 20.6861 14.221 20.6861 16.9546 17.9524C19.6883 15.2188 19.6883 10.7866 16.9546 8.05296L12.0049 3.10321ZM12.0049 0.27478L18.3688 6.63874C21.8836 10.1535 21.8836 15.8519 18.3688 19.3667C14.8541 22.8814 9.15564 22.8814 5.64092 19.3667C2.1262 15.8519 2.1262 10.1535 5.64092 6.63874L12.0049 0.27478ZM13.0049 11.0027H15.5049L11.0049 17.5027V13.0027H8.50488L13.0049 6.5027V11.0027Z"
  }));
},
    Mz = function Mz(_ref2225) {
  var _ref2225$color = _ref2225.color,
      C = _ref2225$color === void 0 ? "currentColor" : _ref2225$color,
      _ref2225$size = _ref2225.size,
      e = _ref2225$size === void 0 ? 24 : _ref2225$size,
      l = _ref2225.className,
      i = _objectWithoutProperties(_ref2225, _excluded2225);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11 21V19.9291C7.60771 19.4439 5 16.5265 5 13V8C5 4.13401 8.13401 1 12 1C15.866 1 19 4.13401 19 8V13C19 16.5265 16.3923 19.4439 13 19.9291V21H17V23H7V21H11ZM12 9C11.4477 9 11 8.55228 11 8C11 7.44772 11.4477 7 12 7C12.5523 7 13 7.44772 13 8C13 8.55228 12.5523 9 12 9ZM12 11C13.6569 11 15 9.65685 15 8C15 6.34315 13.6569 5 12 5C10.3431 5 9 6.34315 9 8C9 9.65685 10.3431 11 12 11Z"
  }));
},
    Zz = function Zz(_ref2226) {
  var _ref2226$color = _ref2226.color,
      C = _ref2226$color === void 0 ? "currentColor" : _ref2226$color,
      _ref2226$size = _ref2226.size,
      e = _ref2226$size === void 0 ? 24 : _ref2226$size,
      l = _ref2226.className,
      i = _objectWithoutProperties(_ref2226, _excluded2226);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11 21V19.9291C7.60771 19.4439 5 16.5265 5 13V8C5 4.13401 8.13401 1 12 1C15.866 1 19 4.13401 19 8V13C19 16.5265 16.3923 19.4439 13 19.9291V21H17V23H7V21H11ZM12 3C9.23858 3 7 5.23858 7 8V13C7 15.7614 9.23858 18 12 18C14.7614 18 17 15.7614 17 13V8C17 5.23858 14.7614 3 12 3ZM12 9C12.5523 9 13 8.55228 13 8C13 7.44772 12.5523 7 12 7C11.4477 7 11 7.44772 11 8C11 8.55228 11.4477 9 12 9ZM12 11C10.3431 11 9 9.65685 9 8C9 6.34315 10.3431 5 12 5C13.6569 5 15 6.34315 15 8C15 9.65685 13.6569 11 12 11Z"
  }));
},
    xz = function xz(_ref2227) {
  var _ref2227$color = _ref2227.color,
      C = _ref2227$color === void 0 ? "currentColor" : _ref2227$color,
      _ref2227$size = _ref2227.size,
      e = _ref2227$size === void 0 ? 24 : _ref2227$size,
      l = _ref2227.className,
      i = _objectWithoutProperties(_ref2227, _excluded2227);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5.45777 18.1847C3.359 16.677 2.00098 14.4001 2.00098 11.9078C2.00098 7.32317 6.47628 3.6001 12.001 3.6001C17.5257 3.6001 22.001 7.32317 22.001 11.9078C22.001 16.4924 17.5257 20.2155 12.001 20.2155C10.859 20.2155 9.74789 20.0616 8.72937 19.7539C8.63678 19.7232 8.51332 19.7232 8.42073 19.7232C8.23554 19.7232 8.05036 19.7847 7.89604 19.877L5.70468 21.1386C5.64295 21.1693 5.58122 21.2001 5.5195 21.2001C5.33431 21.2001 5.17999 21.0463 5.17999 20.8616C5.17999 20.7693 5.21085 20.7078 5.24172 20.6155C5.27258 20.5847 5.55036 19.5693 5.70468 18.9539C5.70468 18.8924 5.73554 18.8001 5.73554 18.7386C5.73554 18.4924 5.64295 18.3078 5.45777 18.1847ZM8.66764 10.5115C9.38493 10.5115 9.95278 9.94335 9.95278 9.22567C9.95278 8.50799 9.38493 7.93982 8.66764 7.93982C7.95036 7.93982 7.3825 8.50799 7.3825 9.22567C7.3825 9.94335 7.95036 10.5115 8.66764 10.5115ZM15.3343 10.5115C16.0516 10.5115 16.6194 9.94335 16.6194 9.22567C16.6194 8.50799 16.0516 7.93982 15.3343 7.93982C14.617 7.93982 14.0492 8.50799 14.0492 9.22567C14.0492 9.94335 14.617 10.5115 15.3343 10.5115Z"
  }));
},
    vz = function vz(_ref2228) {
  var _ref2228$color = _ref2228.color,
      C = _ref2228$color === void 0 ? "currentColor" : _ref2228$color,
      _ref2228$size = _ref2228.size,
      e = _ref2228$size === void 0 ? 24 : _ref2228$size,
      l = _ref2228.className,
      i = _objectWithoutProperties(_ref2228, _excluded2228);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8.66725 11.5114C7.94997 11.5114 7.38211 10.9432 7.38211 10.2255C7.38211 9.50784 7.94997 8.93968 8.66725 8.93968C9.38454 8.93968 9.95239 9.50784 9.95239 10.2255C9.95239 10.9432 9.38454 11.5114 8.66725 11.5114ZM15.3339 11.5114C14.6166 11.5114 14.0488 10.9432 14.0488 10.2255C14.0488 9.50784 14.6166 8.93968 15.3339 8.93968C16.0512 8.93968 16.6191 9.50784 16.6191 10.2255C16.6191 10.9432 16.0512 11.5114 15.3339 11.5114ZM6.82289 19.2153L7.53841 18.7789C8.34812 18.2851 9.30697 18.095 10.2438 18.2426C10.4553 18.2759 10.6292 18.3015 10.7634 18.3192C11.1696 18.3728 11.5828 18.4 12.0006 18.4C16.4213 18.4 19.9006 15.3776 19.9006 11.8C19.9006 8.22235 16.4213 5.19995 12.0006 5.19995C7.57986 5.19995 4.10059 8.22235 4.10059 11.8C4.10059 13.1655 4.60024 14.4728 5.53227 15.5809C5.58056 15.6383 5.65277 15.7177 5.74666 15.8155C6.54199 16.6438 6.94301 17.7739 6.84765 18.9182L6.82289 19.2153ZM6.19286 21.9423C6.00989 22.0566 5.79484 22.1087 5.57981 22.0908C5.02944 22.045 4.62045 21.5616 4.66631 21.0112L4.85456 18.7521C4.90224 18.1799 4.70173 17.6149 4.30407 17.2008C4.1819 17.0735 4.08111 16.9627 4.0017 16.8683C2.80622 15.447 2.10059 13.6951 2.10059 11.8C2.10059 7.0503 6.53297 3.19995 12.0006 3.19995C17.4682 3.19995 21.9006 7.0503 21.9006 11.8C21.9006 16.5496 17.4682 20.4 12.0006 20.4C11.4911 20.4 10.9906 20.3665 10.5018 20.302C10.3491 20.2819 10.1593 20.254 9.93256 20.2182C9.46412 20.1444 8.9847 20.2395 8.57985 20.4864L6.19286 21.9423Z"
  }));
},
    dz = function dz(_ref2229) {
  var _ref2229$color = _ref2229.color,
      C = _ref2229$color === void 0 ? "currentColor" : _ref2229$color,
      _ref2229$size = _ref2229.size,
      e = _ref2229$size === void 0 ? 24 : _ref2229$size,
      l = _ref2229.className,
      i = _objectWithoutProperties(_ref2229, _excluded2229);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18.5753 13.7114C19.0742 13.7114 19.4733 13.2873 19.4733 12.8134C19.4733 12.3145 19.0742 11.9155 18.5753 11.9155C18.0765 11.9155 17.6774 12.3145 17.6774 12.8134C17.6774 13.3123 18.0765 13.7114 18.5753 13.7114ZM14.1497 13.7114C14.6485 13.7114 15.0476 13.2873 15.0476 12.8134C15.0476 12.3145 14.6485 11.9155 14.1497 11.9155C13.6508 11.9155 13.2517 12.3145 13.2517 12.8134C13.2517 13.3123 13.6508 13.7114 14.1497 13.7114ZM20.717 18.7516C20.5942 18.8253 20.5205 18.9482 20.5451 19.1202C20.5451 19.1693 20.5451 19.2185 20.5696 19.2676C20.6679 19.6854 20.8643 20.349 20.8643 20.3736C20.8643 20.4473 20.8889 20.4964 20.8889 20.5456C20.8889 20.6685 20.7907 20.7668 20.6679 20.7668C20.6187 20.7668 20.5942 20.7422 20.5451 20.7176L19.0961 19.882C18.9978 19.8329 18.875 19.7837 18.7522 19.7837C18.6786 19.7837 18.6049 19.7837 18.5558 19.8083C17.8681 20.0049 17.1559 20.1032 16.3946 20.1032C12.7352 20.1032 9.78815 17.6456 9.78815 14.5983C9.78815 11.5509 12.7352 9.09329 16.3946 9.09329C20.0539 9.09329 23.001 11.5509 23.001 14.5983C23.001 16.2448 22.1168 17.7439 20.717 18.7516ZM16.6737 8.09757C16.581 8.09473 16.488 8.09329 16.3946 8.09329C12.2199 8.09329 8.78815 10.9536 8.78815 14.5983C8.78815 15.1519 8.86733 15.6874 9.01626 16.1975H8.92711C8.04096 16.1975 7.15481 16.0503 6.3425 15.8296C6.26866 15.805 6.19481 15.805 6.12097 15.805C5.97327 15.805 5.82558 15.8541 5.7025 15.9277L3.95482 16.9334C3.90559 16.958 3.85635 16.9825 3.80712 16.9825C3.65943 16.9825 3.53636 16.8599 3.53636 16.7127C3.53636 16.6391 3.56097 16.59 3.58559 16.5164C3.6102 16.4919 3.83174 15.6824 3.95482 15.1918C3.95482 15.1427 3.97943 15.0691 3.97943 15.0201C3.97943 14.8238 3.88097 14.6766 3.75789 14.5785C2.05944 13.3765 1.00098 11.5858 1.00098 9.59876C1.00098 5.94369 4.5702 3 8.95173 3C12.7157 3 15.8802 5.16856 16.6737 8.09757ZM11.5199 8.51604C12.0927 8.51604 12.5462 8.03871 12.5462 7.4898C12.5462 6.91701 12.0927 6.46356 11.5199 6.46356C10.9471 6.46356 10.4937 6.91701 10.4937 7.4898C10.4937 8.06258 10.9471 8.51604 11.5199 8.51604ZM6.26045 8.51604C6.83324 8.51604 7.28669 8.03871 7.28669 7.4898C7.28669 6.91701 6.83324 6.46356 6.26045 6.46356C5.68767 6.46356 5.23421 6.91701 5.23421 7.4898C5.23421 8.06258 5.68767 8.51604 6.26045 8.51604Z"
  }));
},
    pz = function pz(_ref2230) {
  var _ref2230$color = _ref2230.color,
      C = _ref2230$color === void 0 ? "currentColor" : _ref2230$color,
      _ref2230$size = _ref2230.size,
      e = _ref2230$size === void 0 ? 24 : _ref2230$size,
      l = _ref2230.className,
      i = _objectWithoutProperties(_ref2230, _excluded2230);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10.0014 14.6757C10.0011 14.6551 10.001 14.6345 10.001 14.6138C10.001 12.1055 12.0175 9.99564 14.7539 9.38092C14.3904 7.07873 11.9602 5.19995 8.90098 5.19995C5.58037 5.19995 3.00098 7.41344 3.00098 9.9793C3.00098 10.9487 3.36131 11.88 4.04082 12.6781C4.0728 12.7157 4.12443 12.7717 4.19342 12.8427C4.78537 13.4517 5.13709 14.2457 5.19546 15.0805C5.90857 14.6683 6.74285 14.5123 7.55832 14.6392C7.72416 14.665 7.85986 14.6847 7.96345 14.6982C8.27111 14.7383 8.58419 14.7586 8.90098 14.7586C9.27825 14.7586 9.64595 14.7301 10.0014 14.6757ZM10.4581 16.627C9.95467 16.7133 9.43399 16.7586 8.90098 16.7586C8.49441 16.7586 8.09502 16.7323 7.70499 16.6815C7.58312 16.6656 7.4317 16.6436 7.25073 16.6154C6.87693 16.5572 6.49436 16.6321 6.1713 16.8268L4.26653 17.9745C4.12052 18.0646 3.94891 18.1057 3.77733 18.0916C3.33814 18.0554 3.01178 17.6744 3.04837 17.2405L3.19859 15.4596C3.23664 15.0086 3.07664 14.5632 2.75931 14.2367C2.66182 14.1364 2.5814 14.0491 2.51802 13.9747C1.56406 12.8542 1.00098 11.4732 1.00098 9.9793C1.00098 6.23517 4.53793 3.19995 8.90098 3.19995C12.9601 3.19995 16.3041 5.82699 16.7504 9.20788C20.1225 9.36136 22.801 11.723 22.801 14.6138C22.801 15.8068 22.3448 16.9097 21.572 17.8044C21.5206 17.8639 21.4555 17.9336 21.3765 18.0137C21.1194 18.2744 20.9898 18.6301 21.0206 18.9903L21.1423 20.4125C21.172 20.759 20.9076 21.0632 20.5518 21.0921C20.4128 21.1034 20.2738 21.0706 20.1555 20.9986L18.6124 20.0821C18.3506 19.9266 18.0407 19.8668 17.7379 19.9133C17.5913 19.9358 17.4686 19.9533 17.3699 19.966C17.0539 20.0066 16.7303 20.0277 16.401 20.0277C13.7074 20.0277 11.4025 18.6201 10.4581 16.627ZM17.4346 17.9364C18.0019 17.8494 18.5793 17.911 19.1105 18.1111C19.2492 17.5503 19.5373 17.0304 19.9524 16.6094C20.0027 16.5585 20.0388 16.5198 20.0584 16.4971C20.5467 15.9318 20.801 15.2839 20.801 14.6138C20.801 12.8095 18.8983 11.2 16.401 11.2C13.9037 11.2 12.001 12.8095 12.001 14.6138C12.001 16.4181 13.9037 18.0277 16.401 18.0277C16.6424 18.0277 16.8809 18.0124 17.115 17.9823C17.1957 17.972 17.3029 17.9566 17.4346 17.9364Z"
  }));
},
    Ez = function Ez(_ref2231) {
  var _ref2231$color = _ref2231.color,
      C = _ref2231$color === void 0 ? "currentColor" : _ref2231$color,
      _ref2231$size = _ref2231.size,
      e = _ref2231$size === void 0 ? 24 : _ref2231$size,
      l = _ref2231.className,
      i = _objectWithoutProperties(_ref2231, _excluded2231);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9.27099 14.6689C8.9532 14.8312 8.56403 14.7122 8.39132 14.4L8.3477 14.3054L6.53019 10.3069C6.52269 10.2588 6.52269 10.2097 6.53019 10.1615C6.53017 10.0735 6.56564 9.98916 6.62857 9.9276C6.6915 9.86603 6.7766 9.83243 6.86462 9.83438C6.93567 9.83269 7.00508 9.85582 7.06091 9.89981L9.24191 11.4265C9.40329 11.5346 9.59293 11.5928 9.78716 11.5937C9.90424 11.5945 10.0203 11.5723 10.1289 11.5283L20.176 7.02816C18.091 4.72544 15.1103 3.43931 12.0045 3.5022C6.4793 3.5022 2.00098 7.23172 2.00098 11.87C2.06681 14.4052 3.35646 16.7515 5.4615 18.1658C5.6878 18.3326 5.78402 18.6241 5.70141 18.8928L5.25067 20.594C5.22336 20.6714 5.20625 20.7521 5.19978 20.8339C5.19777 20.9232 5.23236 21.0094 5.29552 21.0726C5.35868 21.1358 5.44491 21.1703 5.5342 21.1684C5.60098 21.1645 5.66583 21.1445 5.72322 21.1102L7.90423 19.8452C8.06383 19.7467 8.2474 19.6939 8.43494 19.6925C8.53352 19.6923 8.63157 19.707 8.72574 19.7361C9.78781 20.0363 10.8863 20.188 11.99 20.1869C17.5152 20.1869 22.001 16.4574 22.001 11.8554C22.0108 10.4834 21.6301 9.13687 20.903 7.97326L9.35096 14.6253L9.27099 14.6689Z"
  }));
},
    Nz = function Nz(_ref2232) {
  var _ref2232$color = _ref2232.color,
      C = _ref2232$color === void 0 ? "currentColor" : _ref2232$color,
      _ref2232$size = _ref2232.size,
      e = _ref2232$size === void 0 ? 24 : _ref2232$size,
      l = _ref2232.className,
      i = _objectWithoutProperties(_ref2232, _excluded2232);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19.1458 8.99325L9.34705 14.6006L9.27753 14.6465C9.18483 14.6925 9.09213 14.7154 8.97625 14.7154C8.72133 14.7154 8.51275 14.5776 8.39688 14.3709L8.35053 14.2791L6.51971 10.329C6.49653 10.283 6.49653 10.2371 6.49653 10.1912C6.49653 10.0074 6.63558 9.86964 6.82098 9.86964C6.8905 9.86964 6.96003 9.8926 7.02955 9.93853L9.18483 11.4543C9.34705 11.5461 9.53245 11.615 9.74103 11.615C9.8569 11.615 9.97278 11.5921 10.0887 11.5461L18.3634 7.89746C16.9347 6.27313 14.6348 5.19995 12.0006 5.19995C7.57986 5.19995 4.10059 8.22235 4.10059 11.8C4.10059 13.1655 4.60024 14.4728 5.53227 15.5809C5.58056 15.6383 5.65277 15.7177 5.74666 15.8155C6.54199 16.6438 6.94301 17.7739 6.84765 18.9182L6.82289 19.2153L7.53841 18.7789C8.34812 18.2851 9.30697 18.095 10.2438 18.2426C10.4553 18.2759 10.6292 18.3015 10.7634 18.3192C11.1696 18.3728 11.5828 18.4 12.0006 18.4C16.4213 18.4 19.9006 15.3776 19.9006 11.8C19.9006 10.8036 19.6307 9.85022 19.1458 8.99325ZM6.19286 21.9423C6.00989 22.0566 5.79484 22.1087 5.57981 22.0908C5.02944 22.045 4.62045 21.5616 4.66631 21.0112L4.85456 18.7521C4.90224 18.1799 4.70173 17.6149 4.30407 17.2008C4.1819 17.0735 4.08111 16.9627 4.0017 16.8683C2.80622 15.447 2.10059 13.6951 2.10059 11.8C2.10059 7.0503 6.53297 3.19995 12.0006 3.19995C17.4682 3.19995 21.9006 7.0503 21.9006 11.8C21.9006 16.5496 17.4682 20.4 12.0006 20.4C11.4911 20.4 10.9906 20.3665 10.5018 20.302C10.3491 20.2819 10.1593 20.254 9.93256 20.2182C9.46412 20.1444 8.9847 20.2395 8.57985 20.4864L6.19286 21.9423Z"
  }));
},
    uz = function uz(_ref2233) {
  var _ref2233$color = _ref2233.color,
      C = _ref2233$color === void 0 ? "currentColor" : _ref2233$color,
      _ref2233$size = _ref2233.size,
      e = _ref2233$size === void 0 ? 24 : _ref2233$size,
      l = _ref2233.className,
      i = _objectWithoutProperties(_ref2233, _excluded2233);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4.27799 8.59201C7.05085 5.8217 10.282 4.55876 11.4966 5.77587C12.0338 6.31312 12.0848 7.23996 11.741 8.34757C11.5628 8.9052 12.2655 8.5971 12.2655 8.5971C14.5062 7.66008 16.4618 7.60407 17.1747 8.62511C17.5541 9.16746 17.5184 9.93133 17.1671 10.8149C17.0041 11.2223 17.2154 11.2859 17.5261 11.3776C18.789 11.7697 20.1945 12.7144 20.1945 14.3822C20.1945 17.1448 16.2148 20.6205 10.2311 20.6205C5.66569 20.6205 1.00098 18.4078 1.00098 14.7692C1.00098 12.8671 2.20535 10.6672 4.27799 8.59201ZM16.4108 14.3338C16.174 11.9429 13.0294 10.2954 9.38829 10.657C5.74717 11.016 2.9845 13.2465 3.2213 15.6375C3.4581 18.0309 6.60271 19.6758 10.2438 19.3168C13.885 18.9552 16.6451 16.7247 16.4108 14.3338ZM6.16221 14.4382C6.91589 12.9104 8.87395 12.0473 10.6079 12.4979C12.4005 12.9614 13.3146 14.6521 12.5838 16.2969C11.8403 17.98 9.70148 18.8763 7.88856 18.2906C6.13674 17.7254 5.39579 15.9965 6.16221 14.4382ZM8.8765 15.0162C8.31378 14.7794 7.58556 15.0238 7.23672 15.5687C6.88279 16.1162 7.0483 16.7705 7.60847 17.0252C8.17628 17.2823 8.93252 17.0379 9.2839 16.4752C9.63019 15.9074 9.44686 15.2581 8.8765 15.0162ZM10.2642 14.4382C10.0478 14.3542 9.77787 14.456 9.65056 14.6699C9.52834 14.8838 9.59709 15.1282 9.81352 15.2173C10.0325 15.309 10.3151 15.2046 10.4424 14.9856C10.5647 14.7666 10.4857 14.5197 10.2642 14.4382ZM15.9576 2.92408C17.9258 2.50649 20.0545 3.12017 21.5008 4.71918C22.947 6.31822 23.3341 8.50034 22.7204 10.4228C22.5796 10.8639 22.1036 11.1075 21.6612 10.9626C21.2181 10.8174 20.9762 10.3438 21.1188 9.90078C21.5568 8.54108 21.2806 6.98652 20.2531 5.84971C19.2244 4.71154 17.712 4.27613 16.3115 4.57404C15.8558 4.67099 15.41 4.37994 15.3109 3.92475C15.2115 3.46897 15.5018 3.02078 15.9576 2.92408ZM16.584 5.84971C17.5414 5.64601 18.5802 5.94392 19.283 6.72307C19.9858 7.50222 20.1742 8.56655 19.8737 9.49847C19.7511 9.87865 19.3409 10.089 18.9596 9.96443C18.5777 9.83967 18.3714 9.43227 18.4962 9.04779C18.6464 8.59201 18.5522 8.07258 18.2085 7.69064C17.8622 7.31125 17.3555 7.16611 16.887 7.26542C16.4949 7.35199 16.1104 7.09991 16.0263 6.71034C15.9423 6.31822 16.1917 5.93316 16.584 5.84971Z"
  }));
},
    Bz = function Bz(_ref2234) {
  var _ref2234$color = _ref2234.color,
      C = _ref2234$color === void 0 ? "currentColor" : _ref2234$color,
      _ref2234$size = _ref2234.size,
      e = _ref2234$size === void 0 ? 24 : _ref2234$size,
      l = _ref2234.className,
      i = _objectWithoutProperties(_ref2234, _excluded2234);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.1945 14.1973C20.1945 17.5586 15.6658 20.6206 10.2693 20.6206C5.31907 20.6206 1.00098 18.1885 1.00098 14.5338C1.00098 12.5873 2.1808 10.447 4.24042 8.44571C7.0727 5.69957 10.4695 4.41277 12.0994 5.99781C12.5966 6.48041 12.8225 7.11988 12.8178 7.85577C14.7934 7.28031 16.4689 7.45174 17.3006 8.60768C17.7497 9.2307 17.8332 9.98744 17.6268 10.8152C19.1382 11.4259 20.1945 12.5847 20.1945 14.1973ZM15.755 12.1279C15.3691 11.7166 15.3549 11.2078 15.5572 10.7169C15.7655 10.2087 15.7701 9.90467 15.6776 9.77646C15.4134 9.40925 14.1443 9.41428 12.4833 10.0883C12.4306 10.1106 12.3609 10.1367 12.2765 10.1623C12.1789 10.1917 12.0794 10.2147 11.9744 10.2286C11.6296 10.274 11.3028 10.2293 10.9913 9.96287C10.572 9.60419 10.5175 9.10776 10.6694 8.64655C10.8835 7.97702 10.8482 7.57054 10.7057 7.43232C10.5197 7.25137 9.92883 7.24087 9.04745 7.57477C7.97823 7.97981 6.74875 8.79941 5.63339 9.88084C3.92586 11.54 3.00098 13.2178 3.00098 14.5338C3.00098 16.7755 6.27688 18.6206 10.2693 18.6206C14.6892 18.6206 18.1945 16.2506 18.1945 14.1973C18.1945 13.4588 17.558 12.8585 16.5218 12.5446C16.1276 12.4316 15.9855 12.3736 15.755 12.1279ZM22.8091 10.5099C22.6705 11.0445 22.1247 11.3655 21.5901 11.2268C21.0555 11.0882 20.7345 10.5424 20.8732 10.0078C20.9577 9.68188 21.001 9.34424 21.001 9C21.001 6.79086 19.2101 5 17.001 5C16.7223 5 16.448 5.02834 16.1806 5.08401C15.6399 5.19657 15.1103 4.84949 14.9977 4.3088C14.8852 3.76811 15.2323 3.23854 15.773 3.12599C16.1743 3.04244 16.5852 3 17.001 3C20.3147 3 23.001 5.68629 23.001 9C23.001 9.514 22.9361 10.0203 22.8091 10.5099Z"
  }));
},
    fz = function fz(_ref2235) {
  var _ref2235$color = _ref2235.color,
      C = _ref2235$color === void 0 ? "currentColor" : _ref2235$color,
      _ref2235$size = _ref2235.size,
      e = _ref2235$size === void 0 ? 24 : _ref2235$size,
      l = _ref2235.className,
      i = _objectWithoutProperties(_ref2235, _excluded2235);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.001 2C17.5238 2 22.001 6.47715 22.001 12C22.001 17.5228 17.5238 22 12.001 22C10.1671 22 8.44851 21.5064 6.97086 20.6447L2.00516 22L3.35712 17.0315C2.49494 15.5536 2.00098 13.8345 2.00098 12C2.00098 6.47715 6.47813 2 12.001 2ZM8.59339 7.30019L8.39232 7.30833C8.26293 7.31742 8.13607 7.34902 8.02057 7.40811C7.93392 7.45244 7.85348 7.51651 7.72709 7.63586C7.60774 7.74855 7.53857 7.84697 7.46569 7.94186C7.09599 8.4232 6.89729 9.01405 6.90098 9.62098C6.90299 10.1116 7.03043 10.5884 7.23169 11.0336C7.63982 11.9364 8.31288 12.8908 9.20194 13.7759C9.4155 13.9885 9.62473 14.2034 9.85034 14.402C10.9538 15.3736 12.2688 16.0742 13.6907 16.4482C13.6907 16.4482 14.2507 16.5342 14.2589 16.5347C14.4444 16.5447 14.6296 16.5313 14.8153 16.5218C15.1066 16.5068 15.391 16.428 15.6484 16.2909C15.8139 16.2028 15.8922 16.159 16.0311 16.0714C16.0311 16.0714 16.0737 16.0426 16.1559 15.9814C16.2909 15.8808 16.3743 15.81 16.4866 15.6934C16.5694 15.6074 16.6406 15.5058 16.6956 15.3913C16.7738 15.2281 16.8525 14.9166 16.8838 14.6579C16.9077 14.4603 16.9005 14.3523 16.8979 14.2854C16.8936 14.1778 16.8047 14.0671 16.7073 14.0201L16.1258 13.7587C16.1258 13.7587 15.2563 13.3803 14.7245 13.1377C14.6691 13.1124 14.6085 13.1007 14.5476 13.097C14.4142 13.0888 14.2647 13.1236 14.1696 13.2238C14.1646 13.2218 14.0984 13.279 13.3749 14.1555C13.335 14.2032 13.2415 14.3069 13.0798 14.2972C13.0554 14.2955 13.0311 14.292 13.0074 14.2858C12.9419 14.2685 12.8781 14.2457 12.8157 14.2193C12.692 14.1668 12.6486 14.1469 12.5641 14.1105C11.9868 13.8583 11.457 13.5209 10.9887 13.108C10.8631 12.9974 10.7463 12.8783 10.6259 12.7616C10.2057 12.3543 9.86169 11.9211 9.60577 11.4938C9.5918 11.4705 9.57027 11.4368 9.54708 11.3991C9.50521 11.331 9.45903 11.25 9.44455 11.1944C9.40738 11.0473 9.50599 10.9291 9.50599 10.9291C9.50599 10.9291 9.74939 10.663 9.86248 10.5183C9.97128 10.379 10.0652 10.2428 10.125 10.1457C10.2428 9.95633 10.2801 9.76062 10.2182 9.60963C9.93764 8.92565 9.64818 8.24536 9.34986 7.56894C9.29098 7.43545 9.11585 7.33846 8.95659 7.32007C8.90265 7.31384 8.84875 7.30758 8.79459 7.30402C8.66053 7.29748 8.5262 7.29892 8.39232 7.30833L8.59339 7.30019Z"
  }));
},
    Rz = function Rz(_ref2236) {
  var _ref2236$color = _ref2236.color,
      C = _ref2236$color === void 0 ? "currentColor" : _ref2236$color,
      _ref2236$size = _ref2236.size,
      e = _ref2236$size === void 0 ? 24 : _ref2236$size,
      l = _ref2236.className,
      i = _objectWithoutProperties(_ref2236, _excluded2236);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7.25361 18.4944L7.97834 18.917C9.18909 19.623 10.5651 20 12.001 20C16.4193 20 20.001 16.4183 20.001 12C20.001 7.58172 16.4193 4 12.001 4C7.5827 4 4.00098 7.58172 4.00098 12C4.00098 13.4363 4.37821 14.8128 5.08466 16.0238L5.50704 16.7478L4.85355 19.1494L7.25361 18.4944ZM2.00516 22L3.35712 17.0315C2.49494 15.5536 2.00098 13.8345 2.00098 12C2.00098 6.47715 6.47813 2 12.001 2C17.5238 2 22.001 6.47715 22.001 12C22.001 17.5228 17.5238 22 12.001 22C10.1671 22 8.44851 21.5064 6.97086 20.6447L2.00516 22ZM8.39232 7.30833C8.5262 7.29892 8.66053 7.29748 8.79459 7.30402C8.84875 7.30758 8.90265 7.31384 8.95659 7.32007C9.11585 7.33846 9.29098 7.43545 9.34986 7.56894C9.64818 8.24536 9.93764 8.92565 10.2182 9.60963C10.2801 9.76062 10.2428 9.95633 10.125 10.1457C10.0652 10.2428 9.97128 10.379 9.86248 10.5183C9.74939 10.663 9.50599 10.9291 9.50599 10.9291C9.50599 10.9291 9.40738 11.0473 9.44455 11.1944C9.45903 11.25 9.50521 11.331 9.54708 11.3991C9.57027 11.4368 9.5918 11.4705 9.60577 11.4938C9.86169 11.9211 10.2057 12.3543 10.6259 12.7616C10.7463 12.8783 10.8631 12.9974 10.9887 13.108C11.457 13.5209 11.9868 13.8583 12.559 14.1082L12.5641 14.1105C12.6486 14.1469 12.692 14.1668 12.8157 14.2193C12.8781 14.2457 12.9419 14.2685 13.0074 14.2858C13.0311 14.292 13.0554 14.2955 13.0798 14.2972C13.2415 14.3069 13.335 14.2032 13.3749 14.1555C14.0984 13.279 14.1646 13.2218 14.1696 13.2222V13.2238C14.2647 13.1236 14.4142 13.0888 14.5476 13.097C14.6085 13.1007 14.6691 13.1124 14.7245 13.1377C15.2563 13.3803 16.1258 13.7587 16.1258 13.7587L16.7073 14.0201C16.8047 14.0671 16.8936 14.1778 16.8979 14.2854C16.9005 14.3523 16.9077 14.4603 16.8838 14.6579C16.8525 14.9166 16.7738 15.2281 16.6956 15.3913C16.6406 15.5058 16.5694 15.6074 16.4866 15.6934C16.3743 15.81 16.2909 15.8808 16.1559 15.9814C16.0737 16.0426 16.0311 16.0714 16.0311 16.0714C15.8922 16.159 15.8139 16.2028 15.6484 16.2909C15.391 16.428 15.1066 16.5068 14.8153 16.5218C14.6296 16.5313 14.4444 16.5447 14.2589 16.5347C14.2507 16.5342 13.6907 16.4482 13.6907 16.4482C12.2688 16.0742 10.9538 15.3736 9.85034 14.402C9.62473 14.2034 9.4155 13.9885 9.20194 13.7759C8.31288 12.8908 7.63982 11.9364 7.23169 11.0336C7.03043 10.5884 6.90299 10.1116 6.90098 9.62098C6.89729 9.01405 7.09599 8.4232 7.46569 7.94186C7.53857 7.84697 7.60774 7.74855 7.72709 7.63586C7.85348 7.51651 7.93392 7.45244 8.02057 7.40811C8.13607 7.34902 8.26293 7.31742 8.39232 7.30833Z"
  }));
},
    zz = function zz(_ref2237) {
  var _ref2237$color = _ref2237.color,
      C = _ref2237$color === void 0 ? "currentColor" : _ref2237$color,
      _ref2237$size = _ref2237.size,
      e = _ref2237$size === void 0 ? 24 : _ref2237$size,
      l = _ref2237.className,
      i = _objectWithoutProperties(_ref2237, _excluded2237);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7.99837 10.3413L7.99793 12.5352C6.80239 13.2268 5.99805 14.5195 5.99805 16C5.99805 18.2091 7.78891 20 9.99805 20C11.4786 20 12.7712 19.1957 13.4628 18.0001L15.6565 18.0004C14.8327 20.3306 12.6103 22 9.99805 22C6.68434 22 3.99805 19.3137 3.99805 16C3.99805 13.3874 5.66782 11.1649 7.99837 10.3413ZM11.998 17C10.3412 17 8.99805 15.6569 8.99805 14V10C8.99805 8.34315 10.3412 7 11.998 7C13.6549 7 14.998 8.34315 14.998 10V15H16.4319C17.0803 15 17.6849 15.3141 18.0584 15.8362L18.1468 15.971L20.8555 20.4855L19.1406 21.5145L16.4319 17H11.998ZM11.998 2C13.3788 2 14.498 3.11929 14.498 4.5C14.498 5.88071 13.3788 7 11.998 7C10.6173 7 9.49805 5.88071 9.49805 4.5C9.49805 3.11929 10.6173 2 11.998 2Z"
  }));
},
    Fz = function Fz(_ref2238) {
  var _ref2238$color = _ref2238.color,
      C = _ref2238$color === void 0 ? "currentColor" : _ref2238$color,
      _ref2238$size = _ref2238.size,
      e = _ref2238$size === void 0 ? 24 : _ref2238$size,
      l = _ref2238.className,
      i = _objectWithoutProperties(_ref2238, _excluded2238);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7.99837 10.3413L7.99793 12.5352C6.80239 13.2268 5.99805 14.5195 5.99805 16C5.99805 18.2091 7.78891 20 9.99805 20C11.4786 20 12.7712 19.1957 13.4628 18.0001L15.6565 18.0004C14.8327 20.3306 12.6103 22 9.99805 22C6.68434 22 3.99805 19.3137 3.99805 16C3.99805 13.3874 5.66782 11.1649 7.99837 10.3413ZM11.998 17C10.3412 17 8.99805 15.6569 8.99805 14V10C8.99805 8.95561 9.53172 8.03587 10.3412 7.49861C9.53172 6.96413 8.99805 6.04439 8.99805 5C8.99805 3.34315 10.3412 2 11.998 2C13.6549 2 14.998 3.34315 14.998 5C14.998 6.04439 14.4644 6.96413 13.6548 7.50139C14.4644 8.03587 14.998 8.95561 14.998 10V14.999L16.4319 15C17.0803 15 17.6849 15.3141 18.0584 15.8362L18.1468 15.971L20.8555 20.4855L19.1406 21.5145L16.4319 17L14.998 16.999L11.998 17ZM11.998 9C11.4458 9 10.998 9.44772 10.998 10V14C10.998 14.5523 11.4458 15 11.998 15H12.997L12.998 10C12.998 9.44772 12.5503 9 11.998 9ZM11.998 4C11.4458 4 10.998 4.44772 10.998 5C10.998 5.55228 11.4458 6 11.998 6C12.5503 6 12.998 5.55228 12.998 5C12.998 4.44772 12.5503 4 11.998 4Z"
  }));
},
    Sz = function Sz(_ref2239) {
  var _ref2239$color = _ref2239.color,
      C = _ref2239$color === void 0 ? "currentColor" : _ref2239$color,
      _ref2239$size = _ref2239.size,
      e = _ref2239$size === void 0 ? 24 : _ref2239$size,
      l = _ref2239.className,
      i = _objectWithoutProperties(_ref2239, _excluded2239);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M0.689453 6.99659C3.78027 4.49704 7.71526 3 11.9999 3C16.2845 3 20.2195 4.49704 23.3104 6.99659L21.4253 9.33049C18.8496 7.24753 15.5704 6 11.9999 6C8.42937 6 5.15021 7.24753 2.57453 9.33049L0.689453 6.99659ZM3.83124 10.8864C6.0635 9.08119 8.90544 8 11.9999 8C15.0944 8 17.9363 9.08119 20.1686 10.8864L18.2835 13.2203C16.5664 11.8317 14.3803 11 11.9999 11C9.61954 11 7.43344 11.8317 5.71632 13.2203L3.83124 10.8864ZM6.97304 14.7763C8.34673 13.6653 10.0956 13 11.9999 13C13.9042 13 15.6531 13.6653 17.0268 14.7763L15.1417 17.1102C14.2831 16.4158 13.1901 16 11.9999 16C10.8097 16 9.71667 16.4158 8.85811 17.1102L6.97304 14.7763ZM10.1148 18.6661C10.63 18.2495 11.2858 18 11.9999 18C12.714 18 13.3698 18.2495 13.885 18.6661L11.9999 21L10.1148 18.6661Z"
  }));
},
    Az = function Az(_ref2240) {
  var _ref2240$color = _ref2240.color,
      C = _ref2240$color === void 0 ? "currentColor" : _ref2240$color,
      _ref2240$size = _ref2240.size,
      e = _ref2240$size === void 0 ? 24 : _ref2240$size,
      l = _ref2240.className,
      i = _objectWithoutProperties(_ref2240, _excluded2240);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M0.689453 6.99659C3.78027 4.49704 7.71526 3 11.9999 3C16.2845 3 20.2195 4.49704 23.3104 6.99659L22.0536 8.55252C19.3062 6.3307 15.8085 5 11.9999 5C8.19133 5 4.69356 6.3307 1.94617 8.55252L0.689453 6.99659ZM3.83124 10.8864C6.0635 9.08119 8.90544 8 11.9999 8C15.0944 8 17.9363 9.08119 20.1686 10.8864L18.9118 12.4424C17.023 10.9149 14.6183 10 11.9999 10C9.38151 10 6.97679 10.9149 5.08796 12.4424L3.83124 10.8864ZM6.97304 14.7763C8.34673 13.6653 10.0956 13 11.9999 13C13.9042 13 15.6531 13.6653 17.0268 14.7763L15.7701 16.3322C14.7398 15.499 13.4281 15 11.9999 15C10.5717 15 9.26002 15.499 8.22975 16.3322L6.97304 14.7763ZM10.1148 18.6661C10.63 18.2495 11.2858 18 11.9999 18C12.714 18 13.3698 18.2495 13.885 18.6661L11.9999 21L10.1148 18.6661Z"
  }));
},
    kz = function kz(_ref2241) {
  var _ref2241$color = _ref2241.color,
      C = _ref2241$color === void 0 ? "currentColor" : _ref2241$color,
      _ref2241$size = _ref2241.size,
      e = _ref2241$size === void 0 ? 24 : _ref2241$size,
      l = _ref2241.className,
      i = _objectWithoutProperties(_ref2241, _excluded2241);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.0001 17.9999C12.7144 17.9999 13.3704 18.2496 13.8856 18.6664L12.0001 20.9999L10.1145 18.6664C10.6297 18.2496 11.2857 17.9999 12.0001 17.9999ZM2.80766 1.39331L20.4853 19.071L19.0711 20.4852L15.3895 16.8043L15.1425 17.1106C14.2838 16.416 13.1905 15.9999 12.0001 15.9999C10.81 15.9999 9.71712 16.4156 8.85862 17.1098L6.97363 14.7758C8.24961 13.7441 9.84925 13.0967 11.5964 13.0099L9.82328 11.2375C8.29284 11.5772 6.89439 12.2677 5.71658 13.2201L3.83099 10.8867C4.89946 10.0225 6.10763 9.32426 7.41633 8.83106L5.88489 7.29894C4.69082 7.8327 3.5793 8.51797 2.57479 9.33031L0.689453 6.99662C1.60358 6.25735 2.59156 5.60576 3.64058 5.05467L1.39345 2.80752L2.80766 1.39331ZM16.0844 11.8693L12.2165 8.00231L12.0001 7.99991C15.0948 7.99991 17.9369 9.08129 20.1693 10.8868L18.284 13.2205C17.6163 12.6805 16.8777 12.2247 16.0844 11.8693ZM12.0001 2.99991C16.2849 2.99991 20.22 4.49707 23.3109 6.99679L21.4254 9.33035C18.8497 7.24742 15.5706 5.99991 12.0001 5.99991C11.4284 5.99991 10.8642 6.03189 10.3091 6.09416L7.72455 3.51076C9.09498 3.17689 10.5268 2.99991 12.0001 2.99991Z"
  }));
},
    Pz = function Pz(_ref2242) {
  var _ref2242$color = _ref2242.color,
      C = _ref2242$color === void 0 ? "currentColor" : _ref2242$color,
      _ref2242$size = _ref2242.size,
      e = _ref2242$size === void 0 ? 24 : _ref2242$size,
      l = _ref2242.className,
      i = _objectWithoutProperties(_ref2242, _excluded2242);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.0001 18C12.7144 18 13.3704 18.2497 13.8856 18.6665L12.0001 21L10.1145 18.6665C10.6297 18.2497 11.2857 18 12.0001 18ZM2.80766 1.39343L20.4853 19.0711L19.0711 20.4853L13.8913 15.3042C13.2967 15.1069 12.6609 15 12.0001 15C10.5719 15 9.26024 15.499 8.22998 16.3322L6.97363 14.7759C8.24961 13.7442 9.84925 13.0969 11.5964 13.01L9.00025 10.414C7.55273 10.8234 6.22651 11.5217 5.0878 12.4426L3.83099 10.8868C4.89946 10.0226 6.10763 9.32438 7.41633 8.83118L5.13168 6.5451C3.98878 7.08913 2.92058 7.76472 1.94666 8.55228L0.689453 6.99674C1.60358 6.25747 2.59156 5.60589 3.64058 5.05479L1.39345 2.80765L2.80766 1.39343ZM14.5004 10.2854L12.2165 8.00243L12 8C15.0947 8 17.9369 9.08141 20.1693 10.8869L18.9123 12.4426C17.6438 11.4167 16.1427 10.6672 14.5004 10.2854ZM12.0001 3.00003C16.2849 3.00003 20.22 4.49719 23.3109 6.99691L22.0534 8.55228C19.3061 6.33062 15.8085 5.00003 12.0001 5.00003C11.122 5.00003 10.2604 5.07077 9.42075 5.20685L7.72455 3.51088C9.09498 3.17702 10.5268 3.00003 12.0001 3.00003Z"
  }));
},
    Dz = function Dz(_ref2243) {
  var _ref2243$color = _ref2243.color,
      C = _ref2243$color === void 0 ? "currentColor" : _ref2243$color,
      _ref2243$size = _ref2243.size,
      e = _ref2243$size === void 0 ? 24 : _ref2243$size,
      l = _ref2243.className,
      i = _objectWithoutProperties(_ref2243, _excluded2243);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM20 10H4V19H20V10ZM15 6V8H19V6H15Z"
  }));
},
    yz = function yz(_ref2244) {
  var _ref2244$color = _ref2244.color,
      C = _ref2244$color === void 0 ? "currentColor" : _ref2244$color,
      _ref2244$size = _ref2244.size,
      e = _ref2244$size === void 0 ? 24 : _ref2244$size,
      l = _ref2244.className,
      i = _objectWithoutProperties(_ref2244, _excluded2244);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 3C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21ZM20 11H4V19H20V11ZM20 5H4V9H20V5ZM19 6V8H15V6H19Z"
  }));
},
    bz = function bz(_ref2245) {
  var _ref2245$color = _ref2245.color,
      C = _ref2245$color === void 0 ? "currentColor" : _ref2245$color,
      _ref2245$size = _ref2245.size,
      e = _ref2245$size === void 0 ? 24 : _ref2245$size,
      l = _ref2245.className,
      i = _objectWithoutProperties(_ref2245, _excluded2245);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM20 10H4V19H20V10ZM5 6V8H7V6H5ZM9 6V8H11V6H9Z"
  }));
},
    Tz = function Tz(_ref2246) {
  var _ref2246$color = _ref2246.color,
      C = _ref2246$color === void 0 ? "currentColor" : _ref2246$color,
      _ref2246$size = _ref2246.size,
      e = _ref2246$size === void 0 ? 24 : _ref2246$size,
      l = _ref2246.className,
      i = _objectWithoutProperties(_ref2246, _excluded2246);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 3C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21ZM20 11H4V19H20V11ZM20 5H4V9H20V5ZM11 6V8H9V6H11ZM7 6V8H5V6H7Z"
  }));
},
    Uz = function Uz(_ref2247) {
  var _ref2247$color = _ref2247.color,
      C = _ref2247$color === void 0 ? "currentColor" : _ref2247$color,
      _ref2247$size = _ref2247.size,
      e = _ref2247$size === void 0 ? 24 : _ref2247$size,
      l = _ref2247.className,
      i = _objectWithoutProperties(_ref2247, _excluded2247);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3.00098 5.47902L10.3778 4.4625V11.5902H3.00098V5.47902ZM3.00098 18.521L10.3778 19.5375V12.4982H3.00098V18.521ZM11.1894 19.646L21.001 21V12.4982H11.1894V19.646ZM11.1894 4.35402V11.5902H21.001V3L11.1894 4.35402Z"
  }));
},
    Gz = function Gz(_ref2248) {
  var _ref2248$color = _ref2248.color,
      C = _ref2248$color === void 0 ? "currentColor" : _ref2248$color,
      _ref2248$size = _ref2248.size,
      e = _ref2248$size === void 0 ? 24 : _ref2248$size,
      l = _ref2248.className,
      i = _objectWithoutProperties(_ref2248, _excluded2248);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21.001 2.5V21.5L3.00098 19.5V4.5L21.001 2.5ZM19.001 12.999L12.001 13V18.487L19.001 19.2655V12.999ZM5.00098 17.7099L10.001 18.265V13L5.00098 12.999V17.7099ZM19.001 10.999V4.73453L12.001 5.512V11L19.001 10.999ZM10.001 5.734L5.00098 6.29009V10.999L10.001 11V5.734Z"
  }));
},
    Iz = function Iz(_ref2249) {
  var _ref2249$color = _ref2249.color,
      C = _ref2249$color === void 0 ? "currentColor" : _ref2249$color,
      _ref2249$size = _ref2249.size,
      e = _ref2249$size === void 0 ? 24 : _ref2249$size,
      l = _ref2249.className,
      i = _objectWithoutProperties(_ref2249, _excluded2249);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10.5 17H4V15H10.5C12.433 15 14 16.567 14 18.5C14 20.433 12.433 22 10.5 22C8.99957 22 7.71966 21.0559 7.22196 19.7293L9.09513 19.0268C9.30843 19.5954 9.85696 20 10.5 20C11.3284 20 12 19.3284 12 18.5C12 17.6716 11.3284 17 10.5 17ZM5 11H18.5C20.433 11 22 12.567 22 14.5C22 16.433 20.433 18 18.5 18C16.9996 18 15.7197 17.0559 15.222 15.7293L17.0951 15.0268C17.3084 15.5954 17.857 16 18.5 16C19.3284 16 20 15.3284 20 14.5C20 13.6716 19.3284 13 18.5 13H5C3.34315 13 2 11.6569 2 10C2 8.34315 3.34315 7 5 7H13.5C14.3284 7 15 6.32843 15 5.5C15 4.67157 14.3284 4 13.5 4C12.857 4 12.3084 4.40463 12.0951 4.97317L10.222 4.27073C10.7197 2.94414 11.9996 2 13.5 2C15.433 2 17 3.567 17 5.5C17 7.433 15.433 9 13.5 9H5C4.44772 9 4 9.44772 4 10C4 10.5523 4.44772 11 5 11Z"
  }));
},
    Wz = function Wz(_ref2250) {
  var _ref2250$color = _ref2250.color,
      C = _ref2250$color === void 0 ? "currentColor" : _ref2250$color,
      _ref2250$size = _ref2250.size,
      e = _ref2250$size === void 0 ? 24 : _ref2250$size,
      l = _ref2250.className,
      i = _objectWithoutProperties(_ref2250, _excluded2250);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10.5 17H4V15H10.5C12.433 15 14 16.567 14 18.5C14 20.433 12.433 22 10.5 22C8.99957 22 7.71966 21.0559 7.22196 19.7293L9.09513 19.0268C9.30843 19.5954 9.85696 20 10.5 20C11.3284 20 12 19.3284 12 18.5C12 17.6716 11.3284 17 10.5 17ZM5 11H18.5C20.433 11 22 12.567 22 14.5C22 16.433 20.433 18 18.5 18C16.9996 18 15.7197 17.0559 15.222 15.7293L17.0951 15.0268C17.3084 15.5954 17.857 16 18.5 16C19.3284 16 20 15.3284 20 14.5C20 13.6716 19.3284 13 18.5 13H5C3.34315 13 2 11.6569 2 10C2 8.34315 3.34315 7 5 7H13.5C14.3284 7 15 6.32843 15 5.5C15 4.67157 14.3284 4 13.5 4C12.857 4 12.3084 4.40463 12.0951 4.97317L10.222 4.27073C10.7197 2.94414 11.9996 2 13.5 2C15.433 2 17 3.567 17 5.5C17 7.433 15.433 9 13.5 9H5C4.44772 9 4 9.44772 4 10C4 10.5523 4.44772 11 5 11Z"
  }));
},
    Oz = function Oz(_ref2251) {
  var _ref2251$color = _ref2251.color,
      C = _ref2251$color === void 0 ? "currentColor" : _ref2251$color,
      _ref2251$size = _ref2251.size,
      e = _ref2251$size === void 0 ? 24 : _ref2251$size,
      l = _ref2251.className,
      i = _objectWithoutProperties(_ref2251, _excluded2251);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3.92887 4.92883L5.34315 6.3431C3.89543 7.79082 3 9.79082 3 12C3 14.2091 3.89543 16.2091 5.34315 17.6568L3.92887 19.0711C2.11925 17.2615 1 14.7615 1 12C1 9.23846 2.11925 6.73846 3.92887 4.92883ZM20.0711 4.92883C21.8808 6.73846 23 9.23846 23 12C23 14.7615 21.8808 17.2615 20.0711 19.0711L18.6569 17.6568C20.1046 16.2091 21 14.2091 21 12C21 9.79133 20.105 7.79174 18.6579 6.3441L20.0711 4.92883ZM13 4.99996V11H16L11 19V13H8L13 4.99996ZM6.75736 7.75732L8.17157 9.17153C7.44771 9.89539 7 10.8954 7 12C7 13.1045 7.44771 14.1045 8.17157 14.8284L6.75736 16.2426C5.67157 15.1568 5 13.6568 5 12C5 10.3431 5.67157 8.8431 6.75736 7.75732ZM17.2436 7.7583C18.3288 8.84401 19 10.3436 19 12C19 13.6568 18.3284 15.1568 17.2426 16.2426L15.8284 14.8284C16.5523 14.1045 17 13.1045 17 12C17 10.8959 16.5527 9.89631 15.8294 9.17253L17.2436 7.7583Z"
  }));
},
    Kz = function Kz(_ref2252) {
  var _ref2252$color = _ref2252.color,
      C = _ref2252$color === void 0 ? "currentColor" : _ref2252$color,
      _ref2252$size = _ref2252.size,
      e = _ref2252$size === void 0 ? 24 : _ref2252$size,
      l = _ref2252.className,
      i = _objectWithoutProperties(_ref2252, _excluded2252);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3.92887 4.92896L5.34315 6.34323C3.89543 7.79094 3 9.79094 3 12.0001C3 14.2092 3.89543 16.2092 5.34315 17.6569L3.92887 19.0712C2.11925 17.2616 1 14.7616 1 12.0001C1 9.23858 2.11925 6.73858 3.92887 4.92896ZM20.0711 4.92896C21.8808 6.73858 23 9.23858 23 12.0001C23 14.7616 21.8808 17.2616 20.0711 19.0712L18.6569 17.6569C20.1046 16.2092 21 14.2092 21 12.0001C21 9.79145 20.105 7.79186 18.6579 6.34423L20.0711 4.92896ZM13 5.00008V11.0001H16L11 19.0001V13.0001H8L13 5.00008ZM6.75736 7.75744L8.17157 9.17165C7.44771 9.89551 7 10.8955 7 12.0001C7 13.1046 7.44771 14.1046 8.17157 14.8285L6.75736 16.2427C5.67157 15.1569 5 13.6569 5 12.0001C5 10.3432 5.67157 8.84323 6.75736 7.75744ZM17.2436 7.75842C18.3288 8.84413 19 10.3437 19 12.0001C19 13.6569 18.3284 15.1569 17.2426 16.2427L15.8284 14.8285C16.5523 14.1046 17 13.1046 17 12.0001C17 10.896 16.5527 9.89643 15.8294 9.17265L17.2436 7.75842Z"
  }));
},
    Qz = function Qz(_ref2253) {
  var _ref2253$color = _ref2253.color,
      C = _ref2253$color === void 0 ? "currentColor" : _ref2253$color,
      _ref2253$size = _ref2253.size,
      e = _ref2253$size === void 0 ? 24 : _ref2253$size,
      l = _ref2253.className,
      i = _objectWithoutProperties(_ref2253, _excluded2253);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11 15.9339C7.33064 15.445 4.5 12.3031 4.5 8.5C4.5 4.35786 7.85786 1 12 1C16.1421 1 19.5 4.35786 19.5 8.5C19.5 12.3031 16.6694 15.445 13 15.9339V18H18V20H13V24H11V20H6V18H11V15.9339Z"
  }));
},
    qz = function qz(_ref2254) {
  var _ref2254$color = _ref2254.color,
      C = _ref2254$color === void 0 ? "currentColor" : _ref2254$color,
      _ref2254$size = _ref2254.size,
      e = _ref2254$size === void 0 ? 24 : _ref2254$size,
      l = _ref2254.className,
      i = _objectWithoutProperties(_ref2254, _excluded2254);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11 15.9339C7.33064 15.445 4.5 12.3031 4.5 8.5C4.5 4.35786 7.85786 1 12 1C16.1421 1 19.5 4.35786 19.5 8.5C19.5 12.3031 16.6694 15.445 13 15.9339V18H18V20H13V24H11V20H6V18H11V15.9339ZM12 14C15.0376 14 17.5 11.5376 17.5 8.5C17.5 5.46243 15.0376 3 12 3C8.96243 3 6.5 5.46243 6.5 8.5C6.5 11.5376 8.96243 14 12 14Z"
  }));
},
    jz = function jz(_ref2255) {
  var _ref2255$color = _ref2255.color,
      C = _ref2255$color === void 0 ? "currentColor" : _ref2255$color,
      _ref2255$size = _ref2255.size,
      e = _ref2255$size === void 0 ? 24 : _ref2255$size,
      l = _ref2255.className,
      i = _objectWithoutProperties(_ref2255, _excluded2255);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 21V19H6.662L7.896 12H5V10H8.249L9.13 5H4V3H20V5H11.161L10.279 10H18V19H21V21H3ZM16 12H9.927L8.692 19H16V12Z"
  }));
},
    Xz = function Xz(_ref2256) {
  var _ref2256$color = _ref2256.color,
      C = _ref2256$color === void 0 ? "currentColor" : _ref2256$color,
      _ref2256$size = _ref2256.size,
      e = _ref2256$size === void 0 ? 24 : _ref2256$size,
      l = _ref2256.className,
      i = _objectWithoutProperties(_ref2256, _excluded2256);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5.41931 19.5275C7.17681 21.0675 9.48181 22 12.001 22C14.5226 22 16.8251 21.0675 18.586 19.5275C20.1501 17.9342 14.9893 12.27 12.001 10.0133C9.01598 12.27 3.85181 17.9342 5.41931 19.5275ZM14.7193 7.5225C16.8026 9.99 20.956 16.1167 19.7826 18.2825C21.1693 16.5667 22.001 14.3842 22.001 12.0033C22.001 9.22 20.8635 6.70167 19.026 4.89C19.026 4.89 19.0035 4.87167 18.9576 4.855C18.9051 4.83667 18.831 4.8175 18.7235 4.8175C18.2301 4.8175 17.0693 5.17917 14.7193 7.5225ZM5.04598 4.855C4.99848 4.87167 4.97764 4.88917 4.97431 4.89C3.13848 6.70167 2.00098 9.22 2.00098 12.0033C2.00098 14.3817 2.83264 16.5642 4.21848 18.2808C3.05098 16.11 7.20098 9.98833 9.28514 7.5225C6.93514 5.17833 5.77181 4.81833 5.28014 4.81833C5.17098 4.81833 5.09431 4.83583 5.04598 4.85667V4.855ZM12.001 4.95917C12.001 4.95917 9.54681 3.52333 7.63014 3.455C6.87764 3.4275 6.41848 3.70083 6.36264 3.7375C8.15014 2.53833 10.0501 2 11.9876 2H12.001C13.946 2 15.8385 2.53833 17.6393 3.7375C17.5826 3.69917 17.1268 3.4275 16.3726 3.455C14.456 3.52333 12.001 4.95417 12.001 4.95417V4.95917Z"
  }));
},
    Jz = function Jz(_ref2257) {
  var _ref2257$color = _ref2257.color,
      C = _ref2257$color === void 0 ? "currentColor" : _ref2257$color,
      _ref2257$size = _ref2257.size,
      e = _ref2257$size === void 0 ? 24 : _ref2257$size,
      l = _ref2257.className,
      i = _objectWithoutProperties(_ref2257, _excluded2257);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4.79792 15.485C5.9215 12.9646 7.99755 10.0459 9.28514 8.5225C8.03654 7.277 7.12294 6.59163 6.46709 6.22278C4.94728 7.67896 4.00098 9.72897 4.00098 12C4.00098 13.2492 4.28731 14.4316 4.79792 15.485ZM8.84911 4.64483C10.4487 5.05101 12.001 5.95917 12.001 5.95917V5.95417C12.001 5.95417 13.5529 5.04965 15.1523 4.64461C14.1853 4.22973 13.1199 4 12.001 4C10.8818 4 9.81631 4.22982 8.84911 4.64483ZM17.5353 6.22317C16.8799 6.59249 15.9673 7.27806 14.7193 8.5225C16.0056 10.046 18.0809 12.9643 19.2045 15.484C19.7148 14.4309 20.001 13.2488 20.001 12C20.001 9.72917 19.0548 7.67933 17.5353 6.22317ZM17.9431 17.3565C16.5404 15.1202 13.8533 12.4122 12.001 11.0133C10.1504 12.4124 7.46222 15.1211 6.05981 17.3576C7.52394 18.9802 9.64336 20 12.001 20C14.3591 20 16.479 18.9797 17.9431 17.3565ZM12.001 22C6.47813 22 2.00098 17.5228 2.00098 12C2.00098 6.47715 6.47813 2 12.001 2C17.5238 2 22.001 6.47715 22.001 12C22.001 17.5228 17.5238 22 12.001 22Z"
  }));
},
    Yz = function Yz(_ref2258) {
  var _ref2258$color = _ref2258.color,
      C = _ref2258$color === void 0 ? "currentColor" : _ref2258$color,
      _ref2258$size = _ref2258.size,
      e = _ref2258$size === void 0 ? 24 : _ref2258$size,
      l = _ref2258.className,
      i = _objectWithoutProperties(_ref2258, _excluded2258);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.4619 3.23071C20.6158 3.23071 20.7696 3.30764 20.8465 3.38456C20.9235 3.53841 20.9235 3.69225 20.8465 3.8461L14.7696 14.6153L18.6158 21.6923C18.6927 21.8461 18.6927 21.9999 18.6158 22.1538C18.5388 22.2307 18.385 22.3076 18.2311 22.3076H15.4619C15.0773 22.3076 14.8465 21.9999 14.6927 21.7692L10.7696 14.6153C11.0004 14.3076 16.9235 3.76917 16.9235 3.76917C17.0773 3.46148 17.3081 3.23071 17.6927 3.23071H20.4619ZM8.92345 6.99994C9.30807 6.99994 9.53884 7.30764 9.69268 7.53841L11.6158 10.8461C11.4619 10.9999 8.61576 16.0769 8.61576 16.0769C8.46191 16.3076 8.23114 16.6153 7.84653 16.6153H5.15422C5.00038 16.6153 4.84653 16.5384 4.76961 16.4615C4.69268 16.3076 4.69268 16.1538 4.76961 15.9999L7.61576 10.8461L5.76961 7.61533C5.69268 7.46148 5.69268 7.30764 5.76961 7.15379C5.84653 7.07687 6.00038 6.99994 6.15422 6.99994H8.92345Z"
  }));
},
    _z = function _z(_ref2259) {
  var _ref2259$color = _ref2259.color,
      C = _ref2259$color === void 0 ? "currentColor" : _ref2259$color,
      _ref2259$size = _ref2259.size,
      e = _ref2259$size === void 0 ? 24 : _ref2259$size,
      l = _ref2259.className,
      i = _objectWithoutProperties(_ref2259, _excluded2259);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.4443 3.5L13.8099 14.9901L17.8573 22H15.5473L11.5021 14.9914L11.5003 14.9904L18.1343 3.5H20.4443ZM8.31033 7L10.7324 11.1962L10.7305 11.1973L7.66933 16.5H5.36133L8.42215 11.1951L6.00133 7H8.31033Z"
  }));
},
    $z = function $z(_ref2260) {
  var _ref2260$color = _ref2260.color,
      C = _ref2260$color === void 0 ? "currentColor" : _ref2260$color,
      _ref2260$size = _ref2260.size,
      e = _ref2260$size === void 0 ? 24 : _ref2260$size,
      l = _ref2260.className,
      i = _objectWithoutProperties(_ref2260, _excluded2260);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.2439 4C12.778 4.00294 14.1143 4.01586 15.5341 4.07273L16.0375 4.09468C17.467 4.16236 18.8953 4.27798 19.6037 4.4755C20.5486 4.74095 21.2913 5.5155 21.5423 6.49732C21.942 8.05641 21.992 11.0994 21.9982 11.8358L21.9991 11.9884L21.9991 11.9991C21.9991 11.9991 21.9991 12.0028 21.9991 12.0099L21.9982 12.1625C21.992 12.8989 21.942 15.9419 21.5423 17.501C21.2878 18.4864 20.5451 19.261 19.6037 19.5228C18.8953 19.7203 17.467 19.8359 16.0375 19.9036L15.5341 19.9255C14.1143 19.9824 12.778 19.9953 12.2439 19.9983L12.0095 19.9991L11.9991 19.9991C11.9991 19.9991 11.9956 19.9991 11.9887 19.9991L11.7545 19.9983C10.6241 19.9921 5.89772 19.941 4.39451 19.5228C3.4496 19.2573 2.70692 18.4828 2.45587 17.501C2.0562 15.9419 2.00624 12.8989 2 12.1625V11.8358C2.00624 11.0994 2.0562 8.05641 2.45587 6.49732C2.7104 5.51186 3.45308 4.73732 4.39451 4.4755C5.89772 4.05723 10.6241 4.00622 11.7545 4H12.2439ZM9.99911 8.49914V15.4991L15.9991 11.9991L9.99911 8.49914Z"
  }));
},
    eF = function eF(_ref2261) {
  var _ref2261$color = _ref2261.color,
      C = _ref2261$color === void 0 ? "currentColor" : _ref2261$color,
      _ref2261$size = _ref2261.size,
      e = _ref2261$size === void 0 ? 24 : _ref2261$size,
      l = _ref2261.className,
      i = _objectWithoutProperties(_ref2261, _excluded2261);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19.6069 6.99482C19.5307 6.69695 19.3152 6.47221 19.0684 6.40288C18.6299 6.28062 16.501 6 12.001 6C7.50098 6 5.37252 6.28073 4.93225 6.40323C4.68776 6.47123 4.4723 6.69593 4.3951 6.99482C4.2863 7.41923 4.00098 9.19595 4.00098 12C4.00098 14.804 4.2863 16.5808 4.3954 17.0064C4.47126 17.3031 4.68676 17.5278 4.93251 17.5968C5.37252 17.7193 7.50098 18 12.001 18C16.501 18 18.6299 17.7194 19.0697 17.5968C19.3142 17.5288 19.5297 17.3041 19.6069 17.0052C19.7157 16.5808 20.001 14.8 20.001 12C20.001 9.2 19.7157 7.41923 19.6069 6.99482ZM21.5442 6.49818C22.001 8.28 22.001 12 22.001 12C22.001 12 22.001 15.72 21.5442 17.5018C21.2897 18.4873 20.547 19.2618 19.6056 19.5236C17.8971 20 12.001 20 12.001 20C12.001 20 6.10837 20 4.39637 19.5236C3.45146 19.2582 2.70879 18.4836 2.45774 17.5018C2.00098 15.72 2.00098 12 2.00098 12C2.00098 12 2.00098 8.28 2.45774 6.49818C2.71227 5.51273 3.45495 4.73818 4.39637 4.47636C6.10837 4 12.001 4 12.001 4C12.001 4 17.8971 4 19.6056 4.47636C20.5505 4.74182 21.2932 5.51636 21.5442 6.49818ZM10.001 15.5V8.5L16.001 12L10.001 15.5Z"
  }));
},
    tF = function tF(_ref2262) {
  var _ref2262$color = _ref2262.color,
      C = _ref2262$color === void 0 ? "currentColor" : _ref2262$color,
      _ref2262$size = _ref2262.size,
      e = _ref2262$size === void 0 ? 24 : _ref2262$size,
      l = _ref2262.className,
      i = _objectWithoutProperties(_ref2262, _excluded2262);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9.90338 21.8387C5.539 21.8387 2.00098 18.3003 2.00098 13.9355C2.00098 10.2901 4.46846 7.05968 7.82477 6.30851C11.746 5.4309 13.5286 4.74194 14.9016 2C15.9002 3.93518 15.2254 5.70968 14.9029 6.67742C19.5998 5.54839 21.2732 3.39627 21.6763 3.12903C21.6763 7.08065 20.4448 9.58065 19.2572 11.1935C20.733 11.1382 21.2656 10.7097 22.001 10.6071C21.6763 12.0553 20.5 14.0968 17.67 15.4017C16.9827 19.066 13.7668 21.8387 9.90338 21.8387ZM13.6127 15.3871C13.6127 15.7097 13.5595 15.871 13.2095 15.871L10.0592 15.873L13.0203 12.6251C13.8799 11.7653 13.8799 11.3354 13.8799 10.2369C13.8799 9.90252 13.8322 9.52041 13.9277 9.18607C13.9754 9.04278 13.8799 8.99501 13.7367 9.04278C13.4023 9.1383 12.8292 9.1383 11.8741 9.1383H7.57579C7.33699 9.1383 7.24148 8.99501 7.33699 8.80396C7.33699 8.75619 7.33699 8.6129 7.24147 8.6129C6.62061 8.89949 6.47734 10.1891 6.52509 11.0011C6.52509 11.431 6.76389 11.6698 7.0982 11.6698H10.4891L7.00268 15.3953C6.76389 15.6819 6.52509 16.064 6.52509 16.5894V17.6402C6.52509 18.1179 6.81165 18.4045 7.33699 18.5H13.3248C13.8799 18.5 14.2578 18.2665 14.2578 17.6452V16.5161C14.2578 16.3076 14.2578 15.5484 13.6127 15.3871Z"
  }));
},
    CF = function CF(_ref2263) {
  var _ref2263$color = _ref2263.color,
      C = _ref2263$color === void 0 ? "currentColor" : _ref2263$color,
      _ref2263$size = _ref2263.size,
      e = _ref2263$size === void 0 ? 24 : _ref2263$size,
      l = _ref2263.className,
      i = _objectWithoutProperties(_ref2263, _excluded2263);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8.26158 8.26022C5.8379 8.80266 4.00098 11.2081 4.00098 13.9355C4.00098 17.1958 6.64362 19.8387 9.90338 19.8387C12.7548 19.8387 15.1852 17.8007 15.7043 15.033C15.8238 14.3962 16.2442 13.8568 16.8326 13.5855C17.3154 13.3628 17.7433 13.1123 18.1174 12.8418C17.2537 12.2391 16.9306 10.9804 17.6467 10.0078C18.2274 9.21897 18.6973 8.34856 19.0382 7.35686C17.9545 7.86679 16.7372 8.29346 15.3703 8.62203C14.1085 8.92532 12.9778 7.98421 12.9039 6.80753C11.7237 7.38016 10.2337 7.81884 8.26158 8.26022ZM19.2572 11.1935C20.4234 11.1935 21.1735 10.7697 22.001 10.6071C21.6763 12.0553 20.5 14.0968 17.67 15.4017C16.9827 19.066 13.7668 21.8387 9.90338 21.8387C5.539 21.8387 2.00098 18.3003 2.00098 13.9355C2.00098 10.2901 4.46846 7.05968 7.82477 6.30851C11.746 5.4309 13.5286 4.74194 14.9016 2C15.5905 3.33333 15.591 4.89247 14.9029 6.67742C17.718 6.00736 19.9758 4.82457 21.6763 3.12903C21.6763 7.93116 19.8537 10.315 19.2572 11.1935ZM13.4176 15.1256C14.001 15.2715 14.001 15.9581 14.001 16.1466V17.1675C14.001 17.7294 13.6593 17.9405 13.1574 17.9405H7.7428C7.26775 17.8541 7.00863 17.595 7.00863 17.1631V16.2129C7.00863 15.7378 7.22456 15.3922 7.44049 15.1331L10.5931 11.7642H7.52686C7.22456 11.7642 7.00863 11.5483 7.00863 11.1595C6.96544 10.4253 7.095 9.25914 7.65642 9C7.7428 9 7.7428 9.12957 7.7428 9.17276C7.65642 9.34553 7.7428 9.4751 7.95873 9.4751H11.8455C12.7092 9.4751 13.2275 9.4751 13.5298 9.38872C13.6593 9.34553 13.7457 9.38872 13.7025 9.51829C13.6161 9.82063 13.6593 10.1662 13.6593 10.4685C13.6593 11.4619 13.6593 11.8506 12.882 12.628L10.2044 15.565L13.0531 15.5632C13.3696 15.5632 13.4176 15.4173 13.4176 15.1256Z"
  }));
},
    lF = function lF(_ref2264) {
  var _ref2264$color = _ref2264.color,
      C = _ref2264$color === void 0 ? "currentColor" : _ref2264$color,
      _ref2264$size = _ref2264.size,
      e = _ref2264$size === void 0 ? 24 : _ref2264$size,
      l = _ref2264.className,
      i = _objectWithoutProperties(_ref2264, _excluded2264);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13.3735 18.8965L14.8258 18.8969L15.3039 20.5335L17.9085 18.8969H20.9792V5.39468H13.3735V18.8965ZM14.9191 6.8605H19.4338V17.4311H17.7018L15.9722 18.5181L15.6573 17.4337L14.9193 17.4313V6.8607L14.9191 6.8605ZM12.0895 11.5728H8.84563C8.95376 9.89106 8.98193 8.37101 8.98193 7.01344H12.1538C12.1538 7.01344 12.2758 5.61316 11.622 5.62905H6.13529C6.35155 4.81471 6.62335 3.97414 6.94873 3.10498C6.94873 3.10498 5.45617 3.10498 4.94787 4.44368C4.73756 4.99585 4.12887 7.12109 3.04481 9.29202C3.40987 9.25229 4.61753 9.21853 5.32879 7.91359C5.45974 7.54813 5.48454 7.50046 5.64723 7.01185H7.43679C7.43679 7.66333 7.36259 11.163 7.33244 11.5702H4.09237C3.36424 11.5702 3.12755 13.036 3.12755 13.036H7.19336C6.92056 16.1307 5.45637 18.7386 2.80078 20.8003C4.07114 21.1634 5.33713 20.7427 5.96268 20.1858C5.96268 20.1858 7.38759 18.8888 8.16889 15.8876L11.5145 19.9184C11.5145 19.9184 12.0052 18.2496 11.4375 17.4365C10.9673 16.8827 9.69796 15.3847 9.15672 14.8417L8.25004 15.5621C8.52045 14.6945 8.68314 13.8519 8.7381 13.0376H12.5601C12.5601 13.0376 12.5547 11.5718 12.0895 11.5718V11.5728Z"
  }));
},
    iF = function iF(_ref2265) {
  var _ref2265$color = _ref2265.color,
      C = _ref2265$color === void 0 ? "currentColor" : _ref2265$color,
      _ref2265$size = _ref2265.size,
      e = _ref2265$size === void 0 ? 24 : _ref2265$size,
      l = _ref2265.className,
      i = _objectWithoutProperties(_ref2265, _excluded2265);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.3445 17.9633L10.6572 19.037L8.52534 15.687C8.0855 17.089 7.3539 18.3525 6.38696 19.5123C5.98479 19.9947 5.5676 20.4299 5.08571 20.8876C4.93103 21.0345 4.31113 21.604 4.20793 21.7072L2.79372 20.293C2.93256 20.1542 3.58085 19.5585 3.70848 19.4373C4.13828 19.0292 4.50381 18.6478 4.8508 18.2316C6.11713 16.7127 6.87997 15.0205 6.98764 13.0001H3.00082V11.0001H7.00082V7.00013H6.13284C5.44422 8.26619 4.57451 9.22211 3.51532 9.85763L2.48633 8.14264C3.88223 7.3051 4.91211 5.53959 5.52464 2.7832L7.47701 3.21706C7.33636 3.85 7.17352 4.44451 6.98811 5.00013H11.5008V7.00013H9.00082V11.0001H11.5008V13.0001H9.18613L12.3445 17.9633ZM16.1833 17.8929L17.2993 17.0001H19.0008V7.00013H15.0008V17.0001H15.7369L16.1833 17.8929ZM13.0008 5.00013H21.0008V19.0001H18.0008L15.5008 21.0001L14.5008 19.0001H13.0008V5.00013Z"
  }));
},
    sF = function sF(_ref2266) {
  var _ref2266$color = _ref2266.color,
      C = _ref2266$color === void 0 ? "currentColor" : _ref2266$color,
      _ref2266$size = _ref2266.size,
      e = _ref2266$size === void 0 ? 24 : _ref2266$size,
      l = _ref2266.className,
      i = _objectWithoutProperties(_ref2266, _excluded2266);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18.031 16.6168L22.3137 20.8995L20.8995 22.3137L16.6168 18.031C15.0769 19.263 13.124 20 11 20C6.032 20 2 15.968 2 11C2 6.032 6.032 2 11 2C15.968 2 20 6.032 20 11C20 13.124 19.263 15.0769 18.031 16.6168ZM10 10H7V12H10V15H12V12H15V10H12V7H10V10Z"
  }));
},
    rF = function rF(_ref2267) {
  var _ref2267$color = _ref2267.color,
      C = _ref2267$color === void 0 ? "currentColor" : _ref2267$color,
      _ref2267$size = _ref2267.size,
      e = _ref2267$size === void 0 ? 24 : _ref2267$size,
      l = _ref2267.className,
      i = _objectWithoutProperties(_ref2267, _excluded2267);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18.031 16.6168L22.3137 20.8995L20.8995 22.3137L16.6168 18.031C15.0769 19.263 13.124 20 11 20C6.032 20 2 15.968 2 11C2 6.032 6.032 2 11 2C15.968 2 20 6.032 20 11C20 13.124 19.263 15.0769 18.031 16.6168ZM16.0247 15.8748C17.2475 14.6146 18 12.8956 18 11C18 7.1325 14.8675 4 11 4C7.1325 4 4 7.1325 4 11C4 14.8675 7.1325 18 11 18C12.8956 18 14.6146 17.2475 15.8748 16.0247L16.0247 15.8748ZM10 10V7H12V10H15V12H12V15H10V12H7V10H10Z"
  }));
},
    cF = function cF(_ref2268) {
  var _ref2268$color = _ref2268.color,
      C = _ref2268$color === void 0 ? "currentColor" : _ref2268$color,
      _ref2268$size = _ref2268.size,
      e = _ref2268$size === void 0 ? 24 : _ref2268$size,
      l = _ref2268.className,
      i = _objectWithoutProperties(_ref2268, _excluded2268);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18.031 16.6168L22.3137 20.8995L20.8995 22.3137L16.6168 18.031C15.0769 19.263 13.124 20 11 20C6.032 20 2 15.968 2 11C2 6.032 6.032 2 11 2C15.968 2 20 6.032 20 11C20 13.124 19.263 15.0769 18.031 16.6168ZM7 10V12H15V10H7Z"
  }));
},
    oF = function oF(_ref2269) {
  var _ref2269$color = _ref2269.color,
      C = _ref2269$color === void 0 ? "currentColor" : _ref2269$color,
      _ref2269$size = _ref2269.size,
      e = _ref2269$size === void 0 ? 24 : _ref2269$size,
      l = _ref2269.className,
      i = _objectWithoutProperties(_ref2269, _excluded2269);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18.031 16.6168L22.3137 20.8995L20.8995 22.3137L16.6168 18.031C15.0769 19.263 13.124 20 11 20C6.032 20 2 15.968 2 11C2 6.032 6.032 2 11 2C15.968 2 20 6.032 20 11C20 13.124 19.263 15.0769 18.031 16.6168ZM16.0247 15.8748C17.2475 14.6146 18 12.8956 18 11C18 7.1325 14.8675 4 11 4C7.1325 4 4 7.1325 4 11C4 14.8675 7.1325 18 11 18C12.8956 18 14.6146 17.2475 15.8748 16.0247L16.0247 15.8748ZM7 10H15V12H7V10Z"
  }));
},
    aF = function aF(_ref2270) {
  var _ref2270$color = _ref2270.color,
      C = _ref2270$color === void 0 ? "currentColor" : _ref2270$color,
      _ref2270$size = _ref2270.size,
      e = _ref2270$size === void 0 ? 24 : _ref2270$size,
      l = _ref2270.className,
      i = _objectWithoutProperties(_ref2270, _excluded2270);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11 11V13L5.67257 19H11V21H3V19L8.32557 13H3V11H11ZM21 3V5L15.6726 11H21V13H13V11L18.3256 5H13V3H21Z"
  }));
},
    nF = function nF(_ref2271) {
  var _ref2271$color = _ref2271.color,
      C = _ref2271$color === void 0 ? "currentColor" : _ref2271$color,
      _ref2271$size = _ref2271.size,
      e = _ref2271$size === void 0 ? 24 : _ref2271$size,
      l = _ref2271.className,
      i = _objectWithoutProperties(_ref2271, _excluded2271);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11 11V13L5.67257 19H11V21H3V19L8.32557 13H3V11H11ZM21 3V5L15.6726 11H21V13H13V11L18.3256 5H13V3H21Z"
  }));
},
    mF = function mF(_ref2272) {
  var _ref2272$color = _ref2272.color,
      C = _ref2272$color === void 0 ? "currentColor" : _ref2272$color,
      _ref2272$size = _ref2272.size,
      e = _ref2272$size === void 0 ? 24 : _ref2272$size,
      l = _ref2272.className,
      i = _objectWithoutProperties(_ref2272, _excluded2272);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 19.1642L18.2071 12.9571L16.7929 11.5429L12 16.3358L7.20712 11.5429L5.79291 12.9571L12 19.1642ZM12 13.5143L18.2071 7.30722L16.7929 5.89301L12 10.6859L7.20712 5.89301L5.79291 7.30722L12 13.5143Z"
  }));
},
    wF = function wF(_ref2273) {
  var _ref2273$color = _ref2273.color,
      C = _ref2273$color === void 0 ? "currentColor" : _ref2273$color,
      _ref2273$size = _ref2273.size,
      e = _ref2273$size === void 0 ? 24 : _ref2273$size,
      l = _ref2273.className,
      i = _objectWithoutProperties(_ref2273, _excluded2273);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 19.1642L18.2071 12.9571L16.7929 11.5429L12 16.3358L7.20712 11.5429L5.79291 12.9571L12 19.1642ZM12 13.5143L18.2071 7.30722L16.7929 5.89301L12 10.6859L7.20712 5.89301L5.79291 7.30722L12 13.5143Z"
  }));
},
    LF = function LF(_ref2274) {
  var _ref2274$color = _ref2274.color,
      C = _ref2274$color === void 0 ? "currentColor" : _ref2274$color,
      _ref2274$size = _ref2274.size,
      e = _ref2274$size === void 0 ? 24 : _ref2274$size,
      l = _ref2274.className,
      i = _objectWithoutProperties(_ref2274, _excluded2274);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4.83582 12L11.0429 18.2071L12.4571 16.7929L7.66424 12L12.4571 7.20712L11.0429 5.79291L4.83582 12ZM10.4857 12L16.6928 18.2071L18.107 16.7929L13.3141 12L18.107 7.20712L16.6928 5.79291L10.4857 12Z"
  }));
},
    hF = function hF(_ref2275) {
  var _ref2275$color = _ref2275.color,
      C = _ref2275$color === void 0 ? "currentColor" : _ref2275$color,
      _ref2275$size = _ref2275.size,
      e = _ref2275$size === void 0 ? 24 : _ref2275$size,
      l = _ref2275.className,
      i = _objectWithoutProperties(_ref2275, _excluded2275);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4.83582 12L11.0429 18.2071L12.4571 16.7929L7.66424 12L12.4571 7.20712L11.0429 5.79291L4.83582 12ZM10.4857 12L16.6928 18.2071L18.107 16.7929L13.3141 12L18.107 7.20712L16.6928 5.79291L10.4857 12Z"
  }));
},
    HF = function HF(_ref2276) {
  var _ref2276$color = _ref2276.color,
      C = _ref2276$color === void 0 ? "currentColor" : _ref2276$color,
      _ref2276$size = _ref2276.size,
      e = _ref2276$size === void 0 ? 24 : _ref2276$size,
      l = _ref2276.className,
      i = _objectWithoutProperties(_ref2276, _excluded2276);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19.1642 12L12.9571 5.79291L11.5429 7.20712L16.3358 12L11.5429 16.7929L12.9571 18.2071L19.1642 12ZM13.5143 12L7.30722 5.79291L5.89301 7.20712L10.6859 12L5.89301 16.7929L7.30722 18.2071L13.5143 12Z"
  }));
},
    VF = function VF(_ref2277) {
  var _ref2277$color = _ref2277.color,
      C = _ref2277$color === void 0 ? "currentColor" : _ref2277$color,
      _ref2277$size = _ref2277.size,
      e = _ref2277$size === void 0 ? 24 : _ref2277$size,
      l = _ref2277.className,
      i = _objectWithoutProperties(_ref2277, _excluded2277);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19.1642 12L12.9571 5.79291L11.5429 7.20712L16.3358 12L11.5429 16.7929L12.9571 18.2071L19.1642 12ZM13.5143 12L7.30722 5.79291L5.89301 7.20712L10.6859 12L5.89301 16.7929L7.30722 18.2071L13.5143 12Z"
  }));
},
    gF = function gF(_ref2278) {
  var _ref2278$color = _ref2278.color,
      C = _ref2278$color === void 0 ? "currentColor" : _ref2278$color,
      _ref2278$size = _ref2278.size,
      e = _ref2278$size === void 0 ? 24 : _ref2278$size,
      l = _ref2278.className,
      i = _objectWithoutProperties(_ref2278, _excluded2278);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17 16H13L18 22L23 16H19V11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11V20H5V11C5 7.68629 7.68629 5 11 5C14.3137 5 17 7.68629 17 11V16Z"
  }));
},
    MF = function MF(_ref2279) {
  var _ref2279$color = _ref2279.color,
      C = _ref2279$color === void 0 ? "currentColor" : _ref2279$color,
      _ref2279$size = _ref2279.size,
      e = _ref2279$size === void 0 ? 24 : _ref2279$size,
      l = _ref2279.className,
      i = _objectWithoutProperties(_ref2279, _excluded2279);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17.0004 18.1716L14.4649 15.636L13.0507 17.0503L18.0004 22L22.9502 17.0503L21.536 15.636L19.0004 18.1716V11C19.0004 6.58172 15.4187 3 11.0004 3C6.58215 3 3.00043 6.58172 3.00043 11V20H5.00043V11C5.00043 7.68629 7.68672 5 11.0004 5C14.3141 5 17.0004 7.68629 17.0004 11V18.1716Z"
  }));
},
    ZF = function ZF(_ref2280) {
  var _ref2280$color = _ref2280.color,
      C = _ref2280$color === void 0 ? "currentColor" : _ref2280$color,
      _ref2280$size = _ref2280.size,
      e = _ref2280$size === void 0 ? 24 : _ref2280$size,
      l = _ref2280.className,
      i = _objectWithoutProperties(_ref2280, _excluded2280);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17 8V13C17 16.3137 14.3137 19 11 19C7.68629 19 5 16.3137 5 13V4H3V13C3 17.4183 6.58172 21 11 21C15.4183 21 19 17.4183 19 13V8H23L18 2L13 8H17Z"
  }));
},
    xF = function xF(_ref2281) {
  var _ref2281$color = _ref2281.color,
      C = _ref2281$color === void 0 ? "currentColor" : _ref2281$color,
      _ref2281$size = _ref2281.size,
      e = _ref2281$size === void 0 ? 24 : _ref2281$size,
      l = _ref2281.className,
      i = _objectWithoutProperties(_ref2281, _excluded2281);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17.0004 5.82843V13C17.0004 16.3137 14.3141 19 11.0004 19C7.68672 19 5.00043 16.3137 5.00043 13V4H3.00043V13C3.00043 17.4183 6.58215 21 11.0004 21C15.4187 21 19.0004 17.4183 19.0004 13V5.82843L21.536 8.36396L22.9502 6.94975L18.0004 2L13.0507 6.94975L14.4649 8.36396L17.0004 5.82843Z"
  }));
},
    vF = function vF(_ref2282) {
  var _ref2282$color = _ref2282.color,
      C = _ref2282$color === void 0 ? "currentColor" : _ref2282$color,
      _ref2282$size = _ref2282.size,
      e = _ref2282$size === void 0 ? 24 : _ref2282$size,
      l = _ref2282.className,
      i = _objectWithoutProperties(_ref2282, _excluded2282);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 4.83582L5.79291 11.0429L7.20712 12.4571L12 7.66424L16.7929 12.4571L18.2071 11.0429L12 4.83582ZM12 10.4857L5.79291 16.6928L7.20712 18.107L12 13.3141L16.7929 18.107L18.2071 16.6928L12 10.4857Z"
  }));
},
    dF = function dF(_ref2283) {
  var _ref2283$color = _ref2283.color,
      C = _ref2283$color === void 0 ? "currentColor" : _ref2283$color,
      _ref2283$size = _ref2283.size,
      e = _ref2283$size === void 0 ? 24 : _ref2283$size,
      l = _ref2283.className,
      i = _objectWithoutProperties(_ref2283, _excluded2283);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 4.83582L5.79291 11.0429L7.20712 12.4571L12 7.66424L16.7929 12.4571L18.2071 11.0429L12 4.83582ZM12 10.4857L5.79291 16.6928L7.20712 18.107L12 13.3141L16.7929 18.107L18.2071 16.6928L12 10.4857Z"
  }));
},
    pF = function pF(_ref2284) {
  var _ref2284$color = _ref2284.color,
      C = _ref2284$color === void 0 ? "currentColor" : _ref2284$color,
      _ref2284$size = _ref2284.size,
      e = _ref2284$size === void 0 ? 24 : _ref2284$size,
      l = _ref2284.className,
      i = _objectWithoutProperties(_ref2284, _excluded2284);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10.6144 17.7956 11.492 15.7854C12.2731 13.9966 13.6789 12.5726 15.4325 11.7942L17.8482 10.7219C18.6162 10.381 18.6162 9.26368 17.8482 8.92277L15.5079 7.88394C13.7092 7.08552 12.2782 5.60881 11.5105 3.75894L10.6215 1.61673C10.2916.821765 9.19319.821767 8.8633 1.61673L7.97427 3.75892C7.20657 5.60881 5.77553 7.08552 3.97685 7.88394L1.63658 8.92277C.868537 9.26368.868536 10.381 1.63658 10.7219L4.0523 11.7942C5.80589 12.5726 7.21171 13.9966 7.99275 15.7854L8.8704 17.7956C9.20776 18.5682 10.277 18.5682 10.6144 17.7956ZM19.4014 22.6899 19.6482 22.1242C20.0882 21.1156 20.8807 20.3125 21.8695 19.8732L22.6299 19.5353C23.0412 19.3526 23.0412 18.7549 22.6299 18.5722L21.9121 18.2532C20.8978 17.8026 20.0911 16.9698 19.6586 15.9269L19.4052 15.3156C19.2285 14.8896 18.6395 14.8896 18.4628 15.3156L18.2094 15.9269C17.777 16.9698 16.9703 17.8026 15.956 18.2532L15.2381 18.5722C14.8269 18.7549 14.8269 19.3526 15.2381 19.5353L15.9985 19.8732C16.9874 20.3125 17.7798 21.1156 18.2198 22.1242L18.4667 22.6899C18.6473 23.104 19.2207 23.104 19.4014 22.6899Z"
  }));
},
    EF = function EF(_ref2285) {
  var _ref2285$color = _ref2285.color,
      C = _ref2285$color === void 0 ? "currentColor" : _ref2285$color,
      _ref2285$size = _ref2285.size,
      e = _ref2285$size === void 0 ? 24 : _ref2285$size,
      l = _ref2285.className,
      i = _objectWithoutProperties(_ref2285, _excluded2285);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10.6144 17.7956C10.277 18.5682 9.20776 18.5682 8.8704 17.7956L7.99275 15.7854C7.21171 13.9966 5.80589 12.5726 4.0523 11.7942L1.63658 10.7219C.868536 10.381.868537 9.26368 1.63658 8.92276L3.97685 7.88394C5.77553 7.08552 7.20657 5.60881 7.97427 3.75892L8.8633 1.61673C9.19319.821767 10.2916.821765 10.6215 1.61673L11.5105 3.75894C12.2782 5.60881 13.7092 7.08552 15.5079 7.88394L17.8482 8.92276C18.6162 9.26368 18.6162 10.381 17.8482 10.7219L15.4325 11.7942C13.6789 12.5726 12.2731 13.9966 11.492 15.7854L10.6144 17.7956ZM4.53956 9.82234C6.8254 10.837 8.68402 12.5048 9.74238 14.7996 10.8008 12.5048 12.6594 10.837 14.9452 9.82234 12.6321 8.79557 10.7676 7.04647 9.74239 4.71088 8.71719 7.04648 6.85267 8.79557 4.53956 9.82234ZM19.4014 22.6899 19.6482 22.1242C20.0882 21.1156 20.8807 20.3125 21.8695 19.8732L22.6299 19.5353C23.0412 19.3526 23.0412 18.7549 22.6299 18.5722L21.9121 18.2532C20.8978 17.8026 20.0911 16.9698 19.6586 15.9269L19.4052 15.3156C19.2285 14.8896 18.6395 14.8896 18.4628 15.3156L18.2094 15.9269C17.777 16.9698 16.9703 17.8026 15.956 18.2532L15.2381 18.5722C14.8269 18.7549 14.8269 19.3526 15.2381 19.5353L15.9985 19.8732C16.9874 20.3125 17.7798 21.1156 18.2198 22.1242L18.4667 22.6899C18.6473 23.104 19.2207 23.104 19.4014 22.6899ZM18.3745 19.0469 18.937 18.4883 19.4878 19.0469 18.937 19.5898 18.3745 19.0469Z"
  }));
},
    NF = function NF(_ref2286) {
  var _ref2286$color = _ref2286.color,
      C = _ref2286$color === void 0 ? "currentColor" : _ref2286$color,
      _ref2286$size = _ref2286.size,
      e = _ref2286$size === void 0 ? 24 : _ref2286$size,
      l = _ref2286.className,
      i = _objectWithoutProperties(_ref2286, _excluded2286);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5.42333 3.03818C4.13949 3.03818 3.18953 4.16184 3.23206 5.38047C3.27286 6.55123 3.21985 8.0675 2.83811 9.30405C2.45523 10.5442 1.80769 11.3298 0.75 11.4307V12.5694C1.80769 12.6703 2.45523 13.4559 2.83811 14.696C3.21985 15.9326 3.27286 17.4489 3.23206 18.6196C3.18953 19.8381 4.13949 20.9619 5.42352 20.9619H18.5784C19.8622 20.9619 20.812 19.8382 20.7695 18.6196C20.7287 17.4489 20.7817 15.9326 21.1634 14.696C21.5465 13.4559 22.1923 12.6703 23.25 12.5694V11.4307C22.1923 11.3298 21.5465 10.5442 21.1634 9.30405C20.7817 8.06769 20.7287 6.55123 20.7695 5.38047C20.812 4.16203 19.8622 3.03818 18.5784 3.03818H5.42314H5.42333ZM16.0042 14.0714C16.0042 15.7493 14.7526 16.767 12.6756 16.767H9.13983C9.03869 16.767 8.94169 16.7268 8.87017 16.6553C8.79865 16.5838 8.75847 16.4868 8.75847 16.3856V7.61445C8.75847 7.51331 8.79865 7.41631 8.87017 7.34479C8.94169 7.27327 9.03869 7.23309 9.13983 7.23309H12.6554C14.3873 7.23309 15.5239 8.17123 15.5239 9.61161C15.5239 10.6226 14.7593 11.5277 13.7851 11.6862V11.739C15.1113 11.8845 16.0042 12.8028 16.0042 14.0714ZM12.29 8.44199H10.274V11.2896H11.972C13.2846 11.2896 14.0084 10.761 14.0084 9.81621C14.0084 8.93089 13.386 8.44199 12.29 8.44199ZM10.274 12.4195V15.5577H12.3642C13.7308 15.5577 14.4548 15.0093 14.4548 13.9787C14.4548 12.9479 13.7106 12.4193 12.2763 12.4193L10.274 12.4195Z"
  }));
},
    uF = function uF(_ref2287) {
  var _ref2287$color = _ref2287.color,
      C = _ref2287$color === void 0 ? "currentColor" : _ref2287$color,
      _ref2287$size = _ref2287.size,
      e = _ref2287$size === void 0 ? 24 : _ref2287$size,
      l = _ref2287.className,
      i = _objectWithoutProperties(_ref2287, _excluded2287);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M1 11L1 13C1 13 3 13 3 17V18C3 19.6569 4.34315 21 6 21H18C19.6569 21 21 19.6569 21 18V17C21 13 23 13 23 13V11C23 11 21 11 21 7V6C21 4.34315 19.6569 3 18 3L6 3C4.34315 3 3 4.34315 3 6V7C3 11 1 11 1 11ZM20.6742 12C20.6446 12.0278 20.6151 12.0564 20.5858 12.0858C19.5784 13.0931 19 14.6917 19 17V18C19 18.5523 18.5523 19 18 19H6C5.44772 19 5 18.5523 5 18V17C5 14.6917 4.42157 13.0931 3.41421 12.0858C3.38486 12.0564 3.35539 12.0278 3.32582 12C3.35539 11.9722 3.38486 11.9436 3.41421 11.9142C4.42157 10.9069 5 9.30829 5 7V6C5 5.44772 5.44772 5 6 5L18 5C18.5523 5 19 5.44772 19 6V7C19 9.30829 19.5784 10.9069 20.5858 11.9142C20.6151 11.9436 20.6446 11.9722 20.6742 12ZM8.5 7V17H13.5C15.1569 17 16.5 15.6569 16.5 14C16.5 12.9377 15.9479 12.0044 15.115 11.4714C15.3601 11.0366 15.5 10.5347 15.5 10C15.5 8.34315 14.1569 7 12.5 7L8.5 7ZM10.5 11V9H12.5C13.0523 9 13.5 9.44772 13.5 10C13.5 10.5523 13.0523 11 12.5 11H10.5ZM10.5 13H13.5C14.0523 13 14.5 13.4477 14.5 14C14.5 14.5523 14.0523 15 13.5 15H10.5V13Z"
  }));
},
    BF = function BF(_ref2288) {
  var _ref2288$color = _ref2288.color,
      C = _ref2288$color === void 0 ? "currentColor" : _ref2288$color,
      _ref2288$size = _ref2288.size,
      e = _ref2288$size === void 0 ? 24 : _ref2288$size,
      l = _ref2288.className,
      i = _objectWithoutProperties(_ref2288, _excluded2288);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 1 21.5 6.5V17.5L13 22.4211V11.4234L3.49793 5.92225 12 1ZM2.5 7.6555V17.5L11 22.4211V12.5765L2.5 7.6555Z"
  }));
},
    fF = function fF(_ref2289) {
  var _ref2289$color = _ref2289.color,
      C = _ref2289$color === void 0 ? "currentColor" : _ref2289$color,
      _ref2289$size = _ref2289.size,
      e = _ref2289$size === void 0 ? 24 : _ref2289$size,
      l = _ref2289.className,
      i = _objectWithoutProperties(_ref2289, _excluded2289);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 1L21.5 6.5V17.5L12 23L2.5 17.5V6.5L12 1ZM5.49388 7.0777L13.0001 11.4234V20.11L19.5 16.3469V7.65311L12 3.311L5.49388 7.0777ZM4.5 8.81329V16.3469L11.0001 20.1101V12.5765L4.5 8.81329Z"
  }));
},
    RF = function RF(_ref2290) {
  var _ref2290$color = _ref2290.color,
      C = _ref2290$color === void 0 ? "currentColor" : _ref2290$color,
      _ref2290$size = _ref2290.size,
      e = _ref2290$size === void 0 ? 24 : _ref2290$size,
      l = _ref2290.className,
      i = _objectWithoutProperties(_ref2290, _excluded2290);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 1L21.5 6.5V17.5L12 23L2.5 17.5V6.5L12 1ZM4.5 7.65788V16.3469L12 20.689V12L4.5 7.65788Z"
  }));
},
    zF = function zF(_ref2291) {
  var _ref2291$color = _ref2291.color,
      C = _ref2291$color === void 0 ? "currentColor" : _ref2291$color,
      _ref2291$size = _ref2291.size,
      e = _ref2291$size === void 0 ? 24 : _ref2291$size,
      l = _ref2291.className,
      i = _objectWithoutProperties(_ref2291, _excluded2291);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 1L21.5 6.5V17.5L12 23L2.5 17.5V6.5L12 1ZM4.5 7.65311V7.65788L12 12V20.689L19.5 16.3469V7.65311L12 3.311L4.5 7.65311Z"
  }));
},
    FF = function FF(_ref2292) {
  var _ref2292$color = _ref2292.color,
      C = _ref2292$color === void 0 ? "currentColor" : _ref2292$color,
      _ref2292$size = _ref2292.size,
      e = _ref2292$size === void 0 ? 24 : _ref2292$size,
      l = _ref2292.className,
      i = _objectWithoutProperties(_ref2292, _excluded2292);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.5021 5.92225 12 1 3.49793 5.92225 12 10.8445 20.5021 5.92225ZM2.5 7.6555V17.5L11 22.4211V12.5765L2.5 7.6555ZM13 22.4211 21.5 17.5V7.6555L13 12.5765V22.4211Z"
  }));
},
    SF = function SF(_ref2293) {
  var _ref2293$color = _ref2293.color,
      C = _ref2293$color === void 0 ? "currentColor" : _ref2293$color,
      _ref2293$size = _ref2293.size,
      e = _ref2293$size === void 0 ? 24 : _ref2293$size,
      l = _ref2293.className,
      i = _objectWithoutProperties(_ref2293, _excluded2293);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 1L21.5 6.5V17.5L12 23L2.5 17.5V6.5L12 1ZM5.49388 7.0777L12.0001 10.8444L18.5062 7.07774L12 3.311L5.49388 7.0777ZM4.5 8.81329V16.3469L11.0001 20.1101V12.5765L4.5 8.81329ZM13.0001 20.11L19.5 16.3469V8.81337L13.0001 12.5765V20.11Z"
  }));
},
    AF = function AF(_ref2294) {
  var _ref2294$color = _ref2294.color,
      C = _ref2294$color === void 0 ? "currentColor" : _ref2294$color,
      _ref2294$size = _ref2294.size,
      e = _ref2294$size === void 0 ? 24 : _ref2294$size,
      l = _ref2294.className,
      i = _objectWithoutProperties(_ref2294, _excluded2294);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11 2.53513C10.4117 2.19479 9.72857 2 9 2 6.79086 2 5 3.79086 5 6V7.77422C4.14895 8.11644 3.45143 8.64785 2.94126 9.34933 2.29239 10.2415 2 11.3347 2 12.5 2 14.0614 2.79529 15.4356 4 16.242V17.5C4 19.9853 6.01472 22 8.5 22 9.42507 22 10.285 21.7209 11 21.2422V17.5C11 16.167 10.67 15.3147 10.1402 14.7408 9.59743 14.1528 8.71622 13.7165 7.3356 13.4864L7.6644 11.5136C8.96602 11.7305 10.1058 12.1373 11 12.8271V2.53513ZM13 2.53513V12.8271C13.8942 12.1373 15.034 11.7305 16.3356 11.5136L16.6644 13.4864C15.2838 13.7165 14.4026 14.1528 13.8598 14.7408 13.33 15.3147 13 16.167 13 17.5V21.2422C13.715 21.7209 14.5749 22 15.5 22 17.9853 22 20 19.9853 20 17.5V16.242C21.2047 15.4356 22 14.0614 22 12.5 22 11.3347 21.7076 10.2415 21.0587 9.34933 20.5486 8.64785 19.8511 8.11644 19 7.77422V6C19 3.79086 17.2091 2 15 2 14.2714 2 13.5883 2.19479 13 2.53513Z"
  }));
},
    kF = function kF(_ref2295) {
  var _ref2295$color = _ref2295.color,
      C = _ref2295$color === void 0 ? "currentColor" : _ref2295$color,
      _ref2295$size = _ref2295.size,
      e = _ref2295$size === void 0 ? 24 : _ref2295$size,
      l = _ref2295.className,
      i = _objectWithoutProperties(_ref2295, _excluded2295);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9 4C10.1046 4 11 4.89543 11 6V12.8271C10.1058 12.1373 8.96602 11.7305 7.6644 11.5136L7.3356 13.4864C8.71622 13.7165 9.59743 14.1528 10.1402 14.7408C10.67 15.3147 11 16.167 11 17.5C11 18.8807 9.88071 20 8.5 20C7.11929 20 6 18.8807 6 17.5V17.1493C6.43007 17.2926 6.87634 17.4099 7.3356 17.4864L7.6644 15.5136C6.92149 15.3898 6.1752 15.1144 5.42909 14.7599C4.58157 14.3573 4 13.499 4 12.5C4 11.6653 4.20761 11.0085 4.55874 10.5257C4.90441 10.0504 5.4419 9.6703 6.24254 9.47014L7 9.28078V6C7 4.89543 7.89543 4 9 4ZM12 3.35418C11.2671 2.52376 10.1947 2 9 2C6.79086 2 5 3.79086 5 6V7.77422C4.14895 8.11644 3.45143 8.64785 2.94126 9.34933C2.29239 10.2415 2 11.3347 2 12.5C2 14.0652 2.79565 15.4367 4 16.2422V17.5C4 19.9853 6.01472 22 8.5 22C9.91363 22 11.175 21.3482 12 20.3287C12.825 21.3482 14.0864 22 15.5 22C17.9853 22 20 19.9853 20 17.5V16.2422C21.2044 15.4367 22 14.0652 22 12.5C22 11.3347 21.7076 10.2415 21.0587 9.34933C20.5486 8.64785 19.8511 8.11644 19 7.77422V6C19 3.79086 17.2091 2 15 2C13.8053 2 12.7329 2.52376 12 3.35418ZM18 17.1493V17.5C18 18.8807 16.8807 20 15.5 20C14.1193 20 13 18.8807 13 17.5C13 16.167 13.33 15.3147 13.8598 14.7408C14.4026 14.1528 15.2838 13.7165 16.6644 13.4864L16.3356 11.5136C15.034 11.7305 13.8942 12.1373 13 12.8271V6C13 4.89543 13.8954 4 15 4C16.1046 4 17 4.89543 17 6V9.28078L17.7575 9.47014C18.5581 9.6703 19.0956 10.0504 19.4413 10.5257C19.7924 11.0085 20 11.6653 20 12.5C20 13.499 19.4184 14.3573 18.5709 14.7599C17.8248 15.1144 17.0785 15.3898 16.3356 15.5136L16.6644 17.4864C17.1237 17.4099 17.5699 17.2926 18 17.1493Z"
  }));
},
    PF = function PF(_ref2296) {
  var _ref2296$color = _ref2296.color,
      C = _ref2296$color === void 0 ? "currentColor" : _ref2296$color,
      _ref2296$size = _ref2296.size,
      e = _ref2296$size === void 0 ? 24 : _ref2296$size,
      l = _ref2296.className,
      i = _objectWithoutProperties(_ref2296, _excluded2296);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9.17157 9.33147C7.60948 7.76938 7.60948 5.23672 9.17157 3.67462L12 0.846191L14.8284 3.67462C16.3905 5.23672 16.3905 7.76938 14.8284 9.33147C14.3039 9.85601 13.6699 10.2044 13 10.3767V12H18C18.5523 12 19 12.4477 19 13V20H21V22H3V20H5V13C5 12.4477 5.44772 12 6 12H11V10.3767C10.3301 10.2044 9.69611 9.85601 9.17157 9.33147ZM10.5858 5.08883C9.80474 5.86988 9.80474 7.13621 10.5858 7.91726C11.3668 8.69831 12.6332 8.69831 13.4142 7.91726C14.1953 7.13621 14.1953 5.86988 13.4142 5.08883L12 3.67462L10.5858 5.08883Z"
  }));
},
    DF = function DF(_ref2297) {
  var _ref2297$color = _ref2297.color,
      C = _ref2297$color === void 0 ? "currentColor" : _ref2297$color,
      _ref2297$size = _ref2297.size,
      e = _ref2297$size === void 0 ? 24 : _ref2297$size,
      l = _ref2297.className,
      i = _objectWithoutProperties(_ref2297, _excluded2297);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9.17157 9.33147C7.60948 7.76938 7.60948 5.23672 9.17157 3.67462L12 0.846191L14.8284 3.67462C16.3905 5.23672 16.3905 7.76938 14.8284 9.33147C14.3039 9.85601 13.6699 10.2044 13 10.3767V12H18C18.5523 12 19 12.4477 19 13V20H21V22H3V20H5V13C5 12.4477 5.44772 12 6 12H11V10.3767C10.3301 10.2044 9.69611 9.85601 9.17157 9.33147ZM10.5858 5.08883C9.80474 5.86988 9.80474 7.13621 10.5858 7.91726C11.3668 8.69831 12.6332 8.69831 13.4142 7.91726C14.1953 7.13621 14.1953 5.86988 13.4142 5.08883L12 3.67462L10.5858 5.08883ZM7 14V20H17V14H7Z"
  }));
},
    yF = function yF(_ref2298) {
  var _ref2298$color = _ref2298.color,
      C = _ref2298$color === void 0 ? "currentColor" : _ref2298$color,
      _ref2298$size = _ref2298.size,
      e = _ref2298$size === void 0 ? 24 : _ref2298$size,
      l = _ref2298.className,
      i = _objectWithoutProperties(_ref2298, _excluded2298);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3.00488 4.00293H21.0049C21.5572 4.00293 22.0049 4.45064 22.0049 5.00293V19.0029C22.0049 19.5552 21.5572 20.0029 21.0049 20.0029H3.00488C2.4526 20.0029 2.00488 19.5552 2.00488 19.0029V5.00293C2.00488 4.45064 2.4526 4.00293 3.00488 4.00293ZM6.50037 6H4.00037V8.5C5.38108 8.5 6.50037 7.38071 6.50037 6ZM17.5004 6C17.5004 7.38071 18.6197 8.5 20.0004 8.5V6H17.5004ZM4.00037 15.5V18H6.50037C6.50037 16.6193 5.38108 15.5 4.00037 15.5ZM17.5004 18H20.0004V15.5C18.6197 15.5 17.5004 16.6193 17.5004 18ZM12.0004 16C14.2095 16 16.0004 14.2091 16.0004 12C16.0004 9.79086 14.2095 8 12.0004 8C9.79123 8 8.00037 9.79086 8.00037 12C8.00037 14.2091 9.79123 16 12.0004 16Z"
  }));
},
    bF = function bF(_ref2299) {
  var _ref2299$color = _ref2299.color,
      C = _ref2299$color === void 0 ? "currentColor" : _ref2299$color,
      _ref2299$size = _ref2299.size,
      e = _ref2299$size === void 0 ? 24 : _ref2299$size,
      l = _ref2299.className,
      i = _objectWithoutProperties(_ref2299, _excluded2299);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.0004 16C14.2095 16 16.0004 14.2091 16.0004 12 16.0004 9.79086 14.2095 8 12.0004 8 9.79123 8 8.00037 9.79086 8.00037 12 8.00037 14.2091 9.79123 16 12.0004 16ZM21.0049 4.00293H3.00488C2.4526 4.00293 2.00488 4.45064 2.00488 5.00293V19.0029C2.00488 19.5552 2.4526 20.0029 3.00488 20.0029H21.0049C21.5572 20.0029 22.0049 19.5552 22.0049 19.0029V5.00293C22.0049 4.45064 21.5572 4.00293 21.0049 4.00293ZM4.00488 15.6463V8.35371C5.13065 8.017 6.01836 7.12892 6.35455 6.00293H17.6462C17.9833 7.13193 18.8748 8.02175 20.0049 8.3564V15.6436C18.8729 15.9788 17.9802 16.8711 17.6444 18.0029H6.3563C6.02144 16.8742 5.13261 15.9836 4.00488 15.6463Z"
  }));
},
    TF = function TF(_ref2300) {
  var _ref2300$color = _ref2300.color,
      C = _ref2300$color === void 0 ? "currentColor" : _ref2300$color,
      _ref2300$size = _ref2300.size,
      e = _ref2300$size === void 0 ? 24 : _ref2300$size,
      l = _ref2300.className,
      i = _objectWithoutProperties(_ref2300, _excluded2300);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15.0001 4.99976V10.9998L21.0001 11.0001L21.0001 13.0001L15.0001 12.9998V18.9998L7.99985 12L15.0001 4.99976ZM4.00006 18.9999L4.00006 4.99993H6.00006L6.00006 18.9999H4.00006Z"
  }));
},
    UF = function UF(_ref2301) {
  var _ref2301$color = _ref2301.color,
      C = _ref2301$color === void 0 ? "currentColor" : _ref2301$color,
      _ref2301$size = _ref2301.size,
      e = _ref2301$size === void 0 ? 24 : _ref2301$size,
      l = _ref2301.className,
      i = _objectWithoutProperties(_ref2301, _excluded2301);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15.0712 4.92883L16.4854 6.34305L11.8286 10.9999L21.0004 11L21.0004 13L11.8286 12.9999L16.4854 17.6568L15.0712 19.071L8.00016 11.9999L15.0712 4.92883ZM4.00037 18.9998L4.00037 4.99985H6.00037L6.00037 18.9998H4.00037Z"
  }));
},
    GF = function GF(_ref2302) {
  var _ref2302$color = _ref2302.color,
      C = _ref2302$color === void 0 ? "currentColor" : _ref2302$color,
      _ref2302$size = _ref2302.size,
      e = _ref2302$size === void 0 ? 24 : _ref2302$size,
      l = _ref2302.className,
      i = _objectWithoutProperties(_ref2302, _excluded2302);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5 18 11 12 5 6V18ZM19 6 13 12 19 18V6Z"
  }));
},
    IF = function IF(_ref2303) {
  var _ref2303$color = _ref2303.color,
      C = _ref2303$color === void 0 ? "currentColor" : _ref2303$color,
      _ref2303$size = _ref2303.size,
      e = _ref2303$size === void 0 ? 24 : _ref2303$size,
      l = _ref2303.className,
      i = _objectWithoutProperties(_ref2303, _excluded2303);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18.793 5.79285 12.5859 12 18.793 18.2071 20.2072 16.7928 15.4143 12 20.2072 7.20706 18.793 5.79285ZM5.20694 18.2072 11.414 12.0001 5.20694 5.793 3.79272 7.20721 8.58562 12.0001 3.79272 16.793 5.20694 18.2072Z"
  }));
},
    WF = function WF(_ref2304) {
  var _ref2304$color = _ref2304.color,
      C = _ref2304$color === void 0 ? "currentColor" : _ref2304$color,
      _ref2304$size = _ref2304.size,
      e = _ref2304$size === void 0 ? 24 : _ref2304$size,
      l = _ref2304.className,
      i = _objectWithoutProperties(_ref2304, _excluded2304);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8.99988 4.99976L16.0002 12L8.99988 18.9998V12.9998L2.9999 13.0001L2.99988 11.0001L8.99988 10.9998V4.99976ZM17.9999 18.9999L18 4.99993H20L19.9999 18.9999H17.9999Z"
  }));
},
    OF = function OF(_ref2305) {
  var _ref2305$color = _ref2305.color,
      C = _ref2305$color === void 0 ? "currentColor" : _ref2305$color,
      _ref2305$size = _ref2305.size,
      e = _ref2305$size === void 0 ? 24 : _ref2305$size,
      l = _ref2305.className,
      i = _objectWithoutProperties(_ref2305, _excluded2305);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.1715 10.9999L7.51457 6.34305L8.92878 4.92883L15.9999 11.9999L8.92878 19.071L7.51457 17.6568L12.1714 12.9999L2.9996 13L2.99957 11L12.1715 10.9999ZM17.9996 18.9998L17.9996 4.99985H19.9996L19.9996 18.9998H17.9996Z"
  }));
},
    KF = function KF(_ref2306) {
  var _ref2306$color = _ref2306.color,
      C = _ref2306$color === void 0 ? "currentColor" : _ref2306$color,
      _ref2306$size = _ref2306.size,
      e = _ref2306$size === void 0 ? 24 : _ref2306$size,
      l = _ref2306.className,
      i = _objectWithoutProperties(_ref2306, _excluded2306);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18 5 12 11 6 5H18ZM18 19 12 13 6 19H18Z"
  }));
},
    QF = function QF(_ref2307) {
  var _ref2307$color = _ref2307.color,
      C = _ref2307$color === void 0 ? "currentColor" : _ref2307$color,
      _ref2307$size = _ref2307.size,
      e = _ref2307$size === void 0 ? 24 : _ref2307$size,
      l = _ref2307.className,
      i = _objectWithoutProperties(_ref2307, _excluded2307);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5.79285 5.20718 12 11.4143 18.2071 5.20718 16.7928 3.79297 12 8.58586 7.20706 3.79297 5.79285 5.20718ZM18.2072 18.7928 12.0001 12.5857 5.793 18.7928 7.20721 20.207 12.0001 15.4141 16.793 20.207 18.2072 18.7928Z"
  }));
},
    qF = function qF(_ref2308) {
  var _ref2308$color = _ref2308.color,
      C = _ref2308$color === void 0 ? "currentColor" : _ref2308$color,
      _ref2308$size = _ref2308.size,
      e = _ref2308$size === void 0 ? 24 : _ref2308$size,
      l = _ref2308.className,
      i = _objectWithoutProperties(_ref2308, _excluded2308);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8.66223 14.4841C8.66223 13.9312 9.11034 13.4829 9.6634 13.4829 10.2163 13.4829 10.6646 13.9312 10.6646 14.4841V16.4812C10.6646 17.0341 10.2165 17.4824 9.6634 17.4824 9.11034 17.4824 8.66223 17.0341 8.66223 16.4812V14.4841ZM15.3367 14.4841C15.3367 13.9312 14.8886 13.4829 14.3355 13.4829 13.7822 13.4829 13.3344 13.9314 13.3344 14.4841V16.4812C13.3344 17.0341 13.7825 17.4824 14.3355 17.4824 14.8886 17.4824 15.3367 17.0341 15.3367 16.4812V14.4841ZM11.9995 4.02765C11.1541 2.80927 9.40138 2.71883 8.0541 2.83958 6.51063 2.99438 5.21093 3.52495 4.48026 4.30434 3.2125 5.68959 3.15351 8.59518 3.76523 10.1949 3.70377 10.4683 3.64517 10.7453 3.60293 11.0385 2.4729 11.3362 1.32031 12.9371 1.32031 14.0819V16.2445C1.32031 16.8449 1.60059 17.3921 2.09466 17.7659 4.9186 19.8644 8.43899 21.49 11.9995 21.49 15.5599 21.49 19.0803 19.8644 21.9043 17.7659 22.3983 17.3921 22.6786 16.8449 22.6786 16.2445V14.0819C22.6786 12.9371 21.5261 11.3362 20.396 11.0385 20.3539 10.7453 20.2953 10.4683 20.2338 10.1949 20.8454 8.59518 20.7864 5.68959 19.5187 4.30434 18.788 3.52495 17.4883 2.99438 15.9449 2.83958 14.5976 2.71883 12.8449 2.80927 11.9995 4.02765ZM18.674 17.4874C17.139 18.3415 14.5891 19.4879 11.9995 19.4879 9.40986 19.4879 6.86 18.3415 5.325 17.4874V11.689C7.80186 12.6484 10.6522 12.1537 11.9975 9.93121H12.0014C13.3468 12.1537 16.1971 12.6484 18.674 11.689V17.4874ZM10.6646 6.82895C10.6646 8.41414 10.1848 10.1401 7.99479 10.1401 5.80474 10.1401 5.38758 9.61574 5.38758 8.14315 5.38758 5.80709 5.7441 4.80738 8.70396 4.80738 10.4143 4.80738 10.6646 5.35636 10.6646 6.82895ZM13.3344 6.82895C13.3344 5.35636 13.5847 4.80738 15.2951 4.80738 18.2548 4.80738 18.6114 5.80709 18.6114 8.14315 18.6114 9.61574 18.1942 10.1401 16.0042 10.1401 13.8141 10.1401 13.3344 8.41414 13.3344 6.82895Z"
  }));
},
    jF = function jF(_ref2309) {
  var _ref2309$color = _ref2309.color,
      C = _ref2309$color === void 0 ? "currentColor" : _ref2309$color,
      _ref2309$size = _ref2309.size,
      e = _ref2309$size === void 0 ? 24 : _ref2309$size,
      l = _ref2309.className,
      i = _objectWithoutProperties(_ref2309, _excluded2309);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5.40051 7.7999C5.40051 5.71224 6.57782 4.80022 8.57168 4.80017C9.76759 4.80014 10.7005 5.06367 10.7005 6.39988C10.7005 8.21356 10.1264 10.1499 8.00051 10.1499C6.77216 10.1499 6.20265 9.97396 5.91113 9.72586C5.66394 9.51549 5.40051 9.05672 5.40051 7.7999ZM8.57163 2.80017C5.49709 2.80025 3.40051 4.6258 3.40051 7.7999C3.40051 8.79893 3.53783 9.68921 3.93013 10.4045L3.74781 10.7691C3.25056 11.0535 2.74122 11.4327 2.32288 11.8764C1.26166 13.0019 1.35046 14.2646 1.35046 15.6999C1.35046 17.9666 3.86212 19.3205 5.66543 20.0728C7.79841 20.9626 10.3423 21.4999 12.0005 21.4999C13.6586 21.4999 16.2025 20.9626 18.3355 20.0728C20.1388 19.3205 22.6505 17.9666 22.6505 15.6999C22.6505 14.2646 22.7393 13.0019 21.6781 11.8764C21.2597 11.4327 20.7504 11.0535 20.2532 10.7691L20.0709 10.4046C20.4632 9.68925 20.6005 8.79896 20.6005 7.7999C20.6005 4.6258 18.5039 2.80025 15.4294 2.80017C14.1881 2.80014 12.8109 3.05896 12.0005 4.08294C11.1902 3.05896 9.81287 2.80014 8.57163 2.80017ZM8.00051 12.1499C9.6929 12.1499 11.225 11.3348 12.0005 9.81554C12.776 11.3348 14.3081 12.1499 16.0005 12.1499C16.8955 12.1499 17.77 12.0761 18.5176 11.7702C19.0291 12.3662 19.6883 12.6814 20.2229 13.2484C20.8616 13.9259 20.6505 14.8326 20.6505 15.6999C20.6505 16.9718 18.4846 17.8435 17.5654 18.227C15.6234 19.0371 13.3423 19.4999 12.0005 19.4999C10.6586 19.4999 8.37748 19.0371 6.43547 18.227C5.51631 17.8435 3.35046 16.9718 3.35046 15.6999C3.35046 14.8326 3.13931 13.9259 3.77806 13.2484C4.33864 12.6538 5.1192 12.4985 5.48335 11.7702C6.23093 12.0761 7.10552 12.1499 8.00051 12.1499ZM13.3006 6.39988C13.3006 5.06367 14.2334 4.80014 15.4293 4.80017C17.4232 4.80022 18.6005 5.71224 18.6005 7.7999C18.6005 9.05672 18.3371 9.51549 18.0899 9.72586C17.7984 9.97396 17.2289 10.1499 16.0005 10.1499C13.8746 10.1499 13.3006 8.21356 13.3006 6.39988ZM8.6632 14.4841C8.6632 13.9312 9.11131 13.4829 9.66437 13.4829C10.2172 13.4829 10.6655 13.9312 10.6655 14.4841V16.4812C10.6655 17.0341 10.2174 17.4824 9.66437 17.4824C9.11131 17.4824 8.6632 17.0341 8.6632 16.4812V14.4841ZM15.3377 14.4841C15.3377 13.9312 14.8895 13.4829 14.3365 13.4829C13.7832 13.4829 13.3353 13.9314 13.3353 14.4841V16.4812C13.3353 17.0341 13.7834 17.4824 14.3365 17.4824C14.8895 17.4824 15.3377 17.0341 15.3377 16.4812V14.4841Z"
  }));
},
    XF = function XF(_ref2310) {
  var _ref2310$color = _ref2310.color,
      C = _ref2310$color === void 0 ? "currentColor" : _ref2310$color,
      _ref2310$size = _ref2310.size,
      e = _ref2310$size === void 0 ? 24 : _ref2310$size,
      l = _ref2310.className,
      i = _objectWithoutProperties(_ref2310, _excluded2310);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19.0001 13.9999L19.0002 5.00003L17.0002 5L17.0001 11.9999L9.41406 12V6.58581L2.99986 13L9.41406 19.4142L9.41406 14L19.0001 13.9999Z"
  }));
},
    JF = function JF(_ref2311) {
  var _ref2311$color = _ref2311.color,
      C = _ref2311$color === void 0 ? "currentColor" : _ref2311$color,
      _ref2311$size = _ref2311.size,
      e = _ref2311$size === void 0 ? 24 : _ref2311$size,
      l = _ref2311.className,
      i = _objectWithoutProperties(_ref2311, _excluded2311);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19.0001 13.9999L19.0002 5L17.0002 4.99997L17.0001 11.9999L6.8283 12L10.778 8.05024L9.36382 6.63603L2.99986 13L9.36382 19.364L10.778 17.9497L6.82826 14L19.0001 13.9999Z"
  }));
},
    YF = function YF(_ref2312) {
  var _ref2312$color = _ref2312.color,
      C = _ref2312$color === void 0 ? "currentColor" : _ref2312$color,
      _ref2312$size = _ref2312.size,
      e = _ref2312$size === void 0 ? 24 : _ref2312$size,
      l = _ref2312.className,
      i = _objectWithoutProperties(_ref2312, _excluded2312);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4.99989 13.9999L4.99976 5.00003L6.99976 5L6.99986 11.9999L14.5859 12V6.58581L21.0001 13L14.5859 19.4142L14.5859 14L4.99989 13.9999Z"
  }));
},
    _F = function _F(_ref2313) {
  var _ref2313$color = _ref2313.color,
      C = _ref2313$color === void 0 ? "currentColor" : _ref2313$color,
      _ref2313$size = _ref2313.size,
      e = _ref2313$size === void 0 ? 24 : _ref2313$size,
      l = _ref2313.className,
      i = _objectWithoutProperties(_ref2313, _excluded2313);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4.99989 13.9999L4.99976 5L6.99976 4.99997L6.99986 11.9999L17.1717 12L13.222 8.05024L14.6362 6.63603L21.0001 13L14.6362 19.364L13.222 17.9497L17.1717 14L4.99989 13.9999Z"
  }));
},
    $F = function $F(_ref2314) {
  var _ref2314$color = _ref2314.color,
      C = _ref2314$color === void 0 ? "currentColor" : _ref2314$color,
      _ref2314$size = _ref2314.size,
      e = _ref2314$size === void 0 ? 24 : _ref2314$size,
      l = _ref2314.className,
      i = _objectWithoutProperties(_ref2314, _excluded2314);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10.0001 4.99989L19 4.99976L19 6.99976L12.0001 6.99986L12 14.5859H17.4142L11 21.0001L4.58578 14.5859L10 14.5859L10.0001 4.99989Z"
  }));
},
    eS = function eS(_ref2315) {
  var _ref2315$color = _ref2315.color,
      C = _ref2315$color === void 0 ? "currentColor" : _ref2315$color,
      _ref2315$size = _ref2315.size,
      e = _ref2315$size === void 0 ? 24 : _ref2315$size,
      l = _ref2315.className,
      i = _objectWithoutProperties(_ref2315, _excluded2315);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10.0002 5.00011L19.0001 4.99997L19.0001 6.99997L12.0002 7.00008L12.0001 17.1719L15.9498 13.2222L17.3641 14.6364L11.0001 21.0004L4.63614 14.6364L6.05035 13.2222L10.0001 17.172L10.0002 5.00011Z"
  }));
},
    tS = function tS(_ref2316) {
  var _ref2316$color = _ref2316.color,
      C = _ref2316$color === void 0 ? "currentColor" : _ref2316$color,
      _ref2316$size = _ref2316.size,
      e = _ref2316$size === void 0 ? 24 : _ref2316$size,
      l = _ref2316.className,
      i = _objectWithoutProperties(_ref2316, _excluded2316);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10.0001 19.0001L19 19.0003L19 17.0003L12.0001 17.0002L12 9.41409H17.4142L11 2.99988L4.58578 9.41409L10 9.41409L10.0001 19.0001Z"
  }));
},
    CS = function CS(_ref2317) {
  var _ref2317$color = _ref2317.color,
      C = _ref2317$color === void 0 ? "currentColor" : _ref2317$color,
      _ref2317$size = _ref2317.size,
      e = _ref2317$size === void 0 ? 24 : _ref2317$size,
      l = _ref2317.className,
      i = _objectWithoutProperties(_ref2317, _excluded2317);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10.0001 19.0001L19 19.0002L19 17.0002L12.0001 17.0001L12 6.8283L15.9497 10.778L17.364 9.36381L11 2.99985L4.63603 9.36381L6.05025 10.778L10 6.82825L10.0001 19.0001Z"
  }));
},
    lS = function lS(_ref2318) {
  var _ref2318$color = _ref2318.color,
      C = _ref2318$color === void 0 ? "currentColor" : _ref2318$color,
      _ref2318$size = _ref2318.size,
      e = _ref2318$size === void 0 ? 24 : _ref2318$size,
      l = _ref2318.className,
      i = _objectWithoutProperties(_ref2318, _excluded2318);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13.9999 4.99989L5.00003 4.99976L5 6.99976L11.9999 6.99986L12 14.5859H6.58581L13 21.0001L19.4142 14.5859L14 14.5859L13.9999 4.99989Z"
  }));
},
    iS = function iS(_ref2319) {
  var _ref2319$color = _ref2319.color,
      C = _ref2319$color === void 0 ? "currentColor" : _ref2319$color,
      _ref2319$size = _ref2319.size,
      e = _ref2319$size === void 0 ? 24 : _ref2319$size,
      l = _ref2319.className,
      i = _objectWithoutProperties(_ref2319, _excluded2319);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13.9998 5.00011L4.99991 4.99997L4.99988 6.99997L11.9998 7.00008L11.9999 17.1719L8.05015 13.2222L6.63594 14.6364L12.9999 21.0004L19.3639 14.6364L17.9496 13.2222L13.9999 17.172L13.9998 5.00011Z"
  }));
},
    sS = function sS(_ref2320) {
  var _ref2320$color = _ref2320.color,
      C = _ref2320$color === void 0 ? "currentColor" : _ref2320$color,
      _ref2320$size = _ref2320.size,
      e = _ref2320$size === void 0 ? 24 : _ref2320$size,
      l = _ref2320.className,
      i = _objectWithoutProperties(_ref2320, _excluded2320);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13.9999 19.0001L5.00003 19.0002L5 17.0002L11.9999 17.0001L12 9.41405H6.58581L13 2.99985L19.4142 9.41405L14 9.41406L13.9999 19.0001Z"
  }));
},
    rS = function rS(_ref2321) {
  var _ref2321$color = _ref2321.color,
      C = _ref2321$color === void 0 ? "currentColor" : _ref2321$color,
      _ref2321$size = _ref2321.size,
      e = _ref2321$size === void 0 ? 24 : _ref2321$size,
      l = _ref2321.className,
      i = _objectWithoutProperties(_ref2321, _excluded2321);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13.9999 19.0001L5.00003 19.0002L5 17.0002L11.9999 17.0001L12 6.8283L8.05027 10.778L6.63606 9.36381L13 2.99985L19.364 9.36381L17.9498 10.778L14 6.82825L13.9999 19.0001Z"
  }));
},
    cS = function cS(_ref2322) {
  var _ref2322$color = _ref2322.color,
      C = _ref2322$color === void 0 ? "currentColor" : _ref2322$color,
      _ref2322$size = _ref2322.size,
      e = _ref2322$size === void 0 ? 24 : _ref2322$size,
      l = _ref2322.className,
      i = _objectWithoutProperties(_ref2322, _excluded2322);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.0003 19.0001 20.0002 10.0002 14.4142 10.0002V4.58588L7.99995 11.0001 14.4142 17.4143V12.0002L18.0002 12.0002 18.0003 19.0001 20.0003 19.0001ZM10.1637 6.05023 8.74952 4.63601 2.38556 11 8.74952 17.3639 10.1637 15.9497 5.21399 11 10.1637 6.05023Z"
  }));
},
    oS = function oS(_ref2323) {
  var _ref2323$color = _ref2323.color,
      C = _ref2323$color === void 0 ? "currentColor" : _ref2323$color,
      _ref2323$size = _ref2323.size,
      e = _ref2323$size === void 0 ? 24 : _ref2323$size,
      l = _ref2323.className,
      i = _objectWithoutProperties(_ref2323, _excluded2323);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 10.0003L20.0002 19.0001L18.0002 19.0002L18 12.0002L11.8282 12.0002L15.7779 15.9499L14.3637 17.3641L7.99976 11.0001L14.3637 4.63617L15.7779 6.05038L11.8282 10.0002L20 10.0003ZM8.74958 4.63617L10.1638 6.05038L5.21405 11.0001L10.1638 15.9499L8.74958 17.3641L2.38562 11.0001L8.74958 4.63617Z"
  }));
},
    aS = function aS(_ref2324) {
  var _ref2324$color = _ref2324.color,
      C = _ref2324$color === void 0 ? "currentColor" : _ref2324$color,
      _ref2324$size = _ref2324.size,
      e = _ref2324$size === void 0 ? 24 : _ref2324$size,
      l = _ref2324.className,
      i = _objectWithoutProperties(_ref2324, _excluded2324);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19.0001 10.0001L19.0003 19L17.0003 19L17.0002 12.0001L9.41409 12V17.4142L2.99988 11L9.41409 4.58578L9.41409 10L19.0001 10.0001Z"
  }));
},
    nS = function nS(_ref2325) {
  var _ref2325$color = _ref2325.color,
      C = _ref2325$color === void 0 ? "currentColor" : _ref2325$color,
      _ref2325$size = _ref2325.size,
      e = _ref2325$size === void 0 ? 24 : _ref2325$size,
      l = _ref2325.className,
      i = _objectWithoutProperties(_ref2325, _excluded2325);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19.0001 10.0001L19.0003 19L17.0003 19L17.0002 12.0001L6.82833 12L10.7781 15.9498L9.36384 17.364L2.99988 11L9.36384 4.63605L10.7781 6.05026L6.82828 10L19.0001 10.0001Z"
  }));
},
    mS = function mS(_ref2326) {
  var _ref2326$color = _ref2326.color,
      C = _ref2326$color === void 0 ? "currentColor" : _ref2326$color,
      _ref2326$size = _ref2326.size,
      e = _ref2326$size === void 0 ? 24 : _ref2326$size,
      l = _ref2326.className,
      i = _objectWithoutProperties(_ref2326, _excluded2326);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3.99969 19.0001 3.99983 10.0002 9.58588 10.0002V4.58588L16.0001 11.0001 9.58588 17.4143V12.0002L5.9998 12.0002 5.99969 19.0001 3.99969 19.0001ZM13.8363 6.05023 15.2505 4.63601 21.6145 11 15.2505 17.3639 13.8363 15.9497 18.7861 11 13.8363 6.05023Z"
  }));
},
    wS = function wS(_ref2327) {
  var _ref2327$color = _ref2327.color,
      C = _ref2327$color === void 0 ? "currentColor" : _ref2327$color,
      _ref2327$size = _ref2327.size,
      e = _ref2327$size === void 0 ? 24 : _ref2327$size,
      l = _ref2327.className,
      i = _objectWithoutProperties(_ref2327, _excluded2327);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4.00001 10.0003L3.99988 19.0001L5.99988 19.0002L5.99998 12.0002L12.1718 12.0002L8.22209 15.9499L9.63631 17.3641L16.0003 11.0001L9.63631 4.63617L8.22209 6.05038L12.1719 10.0002L4.00001 10.0003ZM15.2504 4.63617L13.8362 6.05038L18.786 11.0001L13.8362 15.9499L15.2504 17.3641L21.6144 11.0001L15.2504 4.63617Z"
  }));
},
    LS = function LS(_ref2328) {
  var _ref2328$color = _ref2328.color,
      C = _ref2328$color === void 0 ? "currentColor" : _ref2328$color,
      _ref2328$size = _ref2328.size,
      e = _ref2328$size === void 0 ? 24 : _ref2328$size,
      l = _ref2328.className,
      i = _objectWithoutProperties(_ref2328, _excluded2328);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4.99989 10.0001L4.99976 19L6.99976 19L6.99986 12.0001L14.5859 12V17.4142L21.0001 11L14.5859 4.58578L14.5859 10L4.99989 10.0001Z"
  }));
},
    hS = function hS(_ref2329) {
  var _ref2329$color = _ref2329.color,
      C = _ref2329$color === void 0 ? "currentColor" : _ref2329$color,
      _ref2329$size = _ref2329.size,
      e = _ref2329$size === void 0 ? 24 : _ref2329$size,
      l = _ref2329.className,
      i = _objectWithoutProperties(_ref2329, _excluded2329);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4.99989 10.0001L4.99976 19L6.99976 19L6.99986 12.0001L17.1717 12L13.222 15.9498L14.6362 17.364L21.0001 11L14.6362 4.63605L13.222 6.05026L17.1717 10L4.99989 10.0001Z"
  }));
},
    HS = function HS(_ref2330) {
  var _ref2330$color = _ref2330.color,
      C = _ref2330$color === void 0 ? "currentColor" : _ref2330$color,
      _ref2330$size = _ref2330.size,
      e = _ref2330$size === void 0 ? 24 : _ref2330$size,
      l = _ref2330.className,
      i = _objectWithoutProperties(_ref2330, _excluded2330);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14 2H10V8H4V12H10V22H14V12H20V8H14V2Z"
  }));
},
    VS = function VS(_ref2331) {
  var _ref2331$color = _ref2331.color,
      C = _ref2331$color === void 0 ? "currentColor" : _ref2331$color,
      _ref2331$size = _ref2331.size,
      e = _ref2331$size === void 0 ? 24 : _ref2331$size,
      l = _ref2331.className,
      i = _objectWithoutProperties(_ref2331, _excluded2331);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9 2H15V7H20V13H15V22H9V13H4V7H9V2ZM11 4V9H6V11H11V20H13V11H18V9H13V4H11Z"
  }));
},
    gS = function gS(_ref2332) {
  var _ref2332$color = _ref2332.color,
      C = _ref2332$color === void 0 ? "currentColor" : _ref2332$color,
      _ref2332$size = _ref2332.size,
      e = _ref2332$size === void 0 ? 24 : _ref2332$size,
      l = _ref2332.className,
      i = _objectWithoutProperties(_ref2332, _excluded2332);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13.817 21.8353C13.7106 21.8384 13.6049 21.84 13.5 21.84 12.4265 21.84 11.1264 21.2191 10.0806 20.0816 9.04473 18.9549 8.30005 17.363 8.30005 15.5 8.30005 14.0815 8.81836 12.9347 9.50108 12.0942 9.55796 14.5796 11.8588 17.7 16.5 17.7 18.1779 17.7 19.2172 17.2476 19.7794 17.0029 19.9878 16.9122 20.1306 16.85 20.2161 16.85 20.4 16.85 20.5 16.95 20.5 17.15 20.5 17.3366 20.3987 17.4712 20.0742 17.9023L20.0007 18C18.5223 19.9682 16.3345 21.3732 13.817 21.8353ZM10.7016 21.9165C5.79216 21.2799 2 17.0828 2 12 2 10.7202 2.74053 9.67125 3.89749 8.91922 5.05841 8.16463 6.58675 7.75 8 7.75 10.2764 7.75 11.6347 8.51511 12.4284 9.39698 12.4785 9.45269 12.5265 9.50903 12.5725 9.56586 12.3887 9.52278 12.197 9.5 12 9.5L11.996 9.5C11.5608 9.50069 11.1518 9.61255 10.7956 9.80869 10.7171 9.84506 10.6385 9.88421 10.5603 9.92588 10.0565 10.1942 9.52919 10.587 9.04942 11.0938 8.08779 12.1096 7.30005 13.6034 7.30005 15.5 7.30005 17.637 8.15534 19.4651 9.34445 20.7584 9.75828 21.2085 10.2178 21.5991 10.7016 21.9165ZM13.8515 13.5956C14.1178 13.3151 14.5 12.9123 14.5 12 14.5 11.1394 14.1625 9.82898 13.1716 8.72802 12.1653 7.60989 10.5236 6.75 8 6.75 6.41325 6.75 4.69159 7.21037 3.35251 8.08078 3.07269 8.26266 2.80734 8.46421 2.5626 8.68489 3.93023 4.7914 7.63913 2 12 2 17.5228 2 22 6 22 10.5 22 13.3 19.8 15.35 17 15.35 15 15.35 13.6 14.7 13.6 14 13.6 13.8607 13.7092 13.7456 13.8515 13.5956Z"
  }));
},
    MS = function MS(_ref2333) {
  var _ref2333$color = _ref2333.color,
      C = _ref2333$color === void 0 ? "currentColor" : _ref2333$color,
      _ref2333$size = _ref2333.size,
      e = _ref2333$size === void 0 ? 24 : _ref2333$size,
      l = _ref2333.className,
      i = _objectWithoutProperties(_ref2333, _excluded2333);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.94904 18.2042C6.30026 16.775 6 15.201 6 14C6 12.5038 6.58998 10.907 7.60307 9.67679C8.24373 8.89885 9.0774 8.24143 10.0679 7.85877C9.58717 7.78813 9.06479 7.75 8.5 7.75C5.99051 7.75 4 9.6121 4 12C4 14.5028 5.14935 16.7372 6.94904 18.2042ZM12 20C12.9283 20 13.8197 19.8421 14.6488 19.5514C11.2851 18.9939 9.00087 16.9378 8.02881 14.5882C8.1242 15.6137 8.45824 16.8842 9.05806 17.9454C9.7767 19.2169 10.7531 20 12 20ZM16.5 12C16.5 12.474 16.4359 12.9117 16.3121 13.315C16.5177 13.3369 16.7475 13.35 17 13.35C18.7765 13.35 20 12.1161 20 10.5C20 7.37014 16.704 4 12 4C9.98053 4 8.13583 4.74827 6.72803 5.98269C7.29501 5.83052 7.89017 5.75 8.5 5.75C10.907 5.75 12.8964 6.35136 14.3071 7.46512C15.7378 8.59457 16.5 10.1977 16.5 12ZM12 9.5C10.6193 9.5 9.5 10.6193 9.5 12C9.5 14.5 11.8 17.7 16.5 17.7C16.9419 17.7 17.3394 17.6686 17.6957 17.6179C18.0046 17.574 18.2824 17.5155 18.531 17.4504C18.7234 17.4 18.8983 17.3456 19.0566 17.2909C19.194 17.2434 19.3189 17.1956 19.4319 17.15C19.5635 17.0969 19.679 17.0466 19.7794 17.0029C19.9878 16.9122 20.1306 16.85 20.2161 16.85C20.4 16.85 20.5 16.95 20.5 17.15C20.5 17.306 20.4291 17.4257 20.2161 17.7129C20.1745 17.7691 20.1274 17.8317 20.0743 17.9022L20.0007 18C19.8289 18.2288 19.6475 18.4499 19.4571 18.6629C19.1995 18.951 18.9254 19.2241 18.6364 19.4807C16.8708 21.0481 14.5466 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6 22 10.5C22 13.3 19.8 15.35 17 15.35C15 15.35 13.6 14.7 13.6 14C13.6 13.8607 13.7092 13.7456 13.8515 13.5956C14.1178 13.3151 14.5 12.9123 14.5 12C14.5 10.6193 13.3807 9.5 12 9.5Z"
  }));
},
    ZS = function ZS(_ref2334) {
  var _ref2334$color = _ref2334.color,
      C = _ref2334$color === void 0 ? "currentColor" : _ref2334$color,
      _ref2334$size = _ref2334.size,
      e = _ref2334$size === void 0 ? 24 : _ref2334$size,
      l = _ref2334.className,
      i = _objectWithoutProperties(_ref2334, _excluded2334);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19 8H5V10H19V8ZM19 14H5V16H19V14Z"
  }));
},
    xS = function xS(_ref2335) {
  var _ref2335$color = _ref2335.color,
      C = _ref2335$color === void 0 ? "currentColor" : _ref2335$color,
      _ref2335$size = _ref2335.size,
      e = _ref2335$size === void 0 ? 24 : _ref2335$size,
      l = _ref2335.className,
      i = _objectWithoutProperties(_ref2335, _excluded2335);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19 8H5V10H19V8ZM19 14H5V16H19V14Z"
  }));
},
    vS = function vS(_ref2336) {
  var _ref2336$color = _ref2336.color,
      C = _ref2336$color === void 0 ? "currentColor" : _ref2336$color,
      _ref2336$size = _ref2336.size,
      e = _ref2336$size === void 0 ? 24 : _ref2336$size,
      l = _ref2336.className,
      i = _objectWithoutProperties(_ref2336, _excluded2336);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9.99994 4.99988V10.9999L16.0002 11.0002L16.0002 13.0002L9.99994 12.9999V18.9999L2.99994 12.0001L9.99994 4.99988ZM18.0001 19.0001V5.00006H20.0001V19.0001H18.0001Z"
  }));
},
    dS = function dS(_ref2337) {
  var _ref2337$color = _ref2337.color,
      C = _ref2337$color === void 0 ? "currentColor" : _ref2337$color,
      _ref2337$size = _ref2337.size,
      e = _ref2337$size === void 0 ? 24 : _ref2337$size,
      l = _ref2337.className,
      i = _objectWithoutProperties(_ref2337, _excluded2337);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10.071 4.92896L11.4852 6.34317L6.82834 11L16.0002 11.0002L16.0002 13.0002L6.82839 13L11.4852 17.6569L10.071 19.0711L2.99994 12L10.071 4.92896ZM18.0001 19V4.99997H20.0001V19H18.0001Z"
  }));
},
    pS = function pS(_ref2338) {
  var _ref2338$color = _ref2338.color,
      C = _ref2338$color === void 0 ? "currentColor" : _ref2338$color,
      _ref2338$size = _ref2338.size,
      e = _ref2338$size === void 0 ? 24 : _ref2338$size,
      l = _ref2338.className,
      i = _objectWithoutProperties(_ref2338, _excluded2338);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9 6 3 12 9 18V6ZM15 18 21 12 15 6V18Z"
  }));
},
    ES = function ES(_ref2339) {
  var _ref2339$color = _ref2339.color,
      C = _ref2339$color === void 0 ? "currentColor" : _ref2339$color,
      _ref2339$size = _ref2339.size,
      e = _ref2339$size === void 0 ? 24 : _ref2339$size,
      l = _ref2339.className,
      i = _objectWithoutProperties(_ref2339, _excluded2339);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9.04304 5.79285 2.83594 12 9.04304 18.2071 10.4573 16.7928 5.66436 12 10.4573 7.20706 9.04304 5.79285ZM14.957 18.2072 21.1641 12.0001 14.957 5.793 13.5427 7.20721 18.3356 12.0001 13.5427 16.793 14.957 18.2072Z"
  }));
},
    NS = function NS(_ref2340) {
  var _ref2340$color = _ref2340.color,
      C = _ref2340$color === void 0 ? "currentColor" : _ref2340$color,
      _ref2340$size = _ref2340.size,
      e = _ref2340$size === void 0 ? 24 : _ref2340$size,
      l = _ref2340.className,
      i = _objectWithoutProperties(_ref2340, _excluded2340);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13.9998 4.99988L21.0001 11.9999L13.9998 18.9999V13.0001H7.9998L7.99978 11.0001H13.9998V4.99988ZM3.99985 18.9999L3.99985 4.99988H5.99985V18.9999H3.99985Z"
  }));
},
    uS = function uS(_ref2341) {
  var _ref2341$color = _ref2341.color,
      C = _ref2341$color === void 0 ? "currentColor" : _ref2341$color,
      _ref2341$size = _ref2341.size,
      e = _ref2341$size === void 0 ? 24 : _ref2341$size,
      l = _ref2341.className,
      i = _objectWithoutProperties(_ref2341, _excluded2341);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17.1717 11L12.5148 6.34317L13.929 4.92896L21.0001 12L13.929 19.0711L12.5148 17.6569L17.1716 13L7.9998 13.0002L7.99978 11.0002L17.1717 11ZM3.99985 19L3.99985 4.99997H5.99985V19H3.99985Z"
  }));
},
    BS = function BS(_ref2342) {
  var _ref2342$color = _ref2342.color,
      C = _ref2342$color === void 0 ? "currentColor" : _ref2342$color,
      _ref2342$size = _ref2342.size,
      e = _ref2342$size === void 0 ? 24 : _ref2342$size,
      l = _ref2342.className,
      i = _objectWithoutProperties(_ref2342, _excluded2342);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18 9 12 3 6 9H18ZM18 15 12 21 6 15H18Z"
  }));
},
    fS = function fS(_ref2343) {
  var _ref2343$color = _ref2343.color,
      C = _ref2343$color === void 0 ? "currentColor" : _ref2343$color,
      _ref2343$size = _ref2343.size,
      e = _ref2343$size === void 0 ? 24 : _ref2343$size,
      l = _ref2343.className,
      i = _objectWithoutProperties(_ref2343, _excluded2343);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18.2072 9.0428 12.0001 2.83569 5.793 9.0428 7.20721 10.457 12.0001 5.66412 16.793 10.457 18.2072 9.0428ZM5.79285 14.9572 12 21.1643 18.2071 14.9572 16.7928 13.543 12 18.3359 7.20706 13.543 5.79285 14.9572Z"
  }));
},
    RS = function RS(_ref2344) {
  var _ref2344$color = _ref2344.color,
      C = _ref2344$color === void 0 ? "currentColor" : _ref2344$color,
      _ref2344$size = _ref2344.size,
      e = _ref2344$size === void 0 ? 24 : _ref2344$size,
      l = _ref2344.className,
      i = _objectWithoutProperties(_ref2344, _excluded2344);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11 12C11 14.7615 8.76146 17 5.99998 17 3.23849 17 1 14.7615 1 12 1 9.23899 3.23849 7 5.99998 7 8.76146 7 11 9.23899 11 12ZM23 12C23 14.7615 20.7615 17 18 17 15.2385 17 13 14.7615 13 12 13 9.23899 15.2385 7 18 7 20.7615 7 23 9.23899 23 12Z"
  }));
},
    zS = function zS(_ref2345) {
  var _ref2345$color = _ref2345.color,
      C = _ref2345$color === void 0 ? "currentColor" : _ref2345$color,
      _ref2345$size = _ref2345.size,
      e = _ref2345$size === void 0 ? 24 : _ref2345$size,
      l = _ref2345.className,
      i = _objectWithoutProperties(_ref2345, _excluded2345);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5.99998 17C8.76146 17 11 14.7615 11 12 11 9.23899 8.76146 7 5.99998 7 3.23849 7 1 9.23899 1 12 1 14.7615 3.23849 17 5.99998 17ZM8.99995 12C8.99995 13.6569 7.65689 15 5.99998 15 4.34306 15 3 13.6569 3 12 3 10.3434 4.34319 9 5.99998 9 7.65676 9 8.99995 10.3434 8.99995 12ZM18 17C20.7615 17 23 14.7615 23 12 23 9.23899 20.7615 7 18 7 15.2385 7 13 9.23899 13 12 13 14.7615 15.2385 17 18 17ZM21 12C21 13.6569 19.6569 15 18 15 16.3431 15 15 13.6569 15 12 15 10.3434 16.3432 9 18 9 19.6568 9 21 10.3434 21 12Z"
  }));
},
    FS = function FS(_ref2346) {
  var _ref2346$color = _ref2346.color,
      C = _ref2346$color === void 0 ? "currentColor" : _ref2346$color,
      _ref2346$size = _ref2346.size,
      e = _ref2346$size === void 0 ? 24 : _ref2346$size,
      l = _ref2346.className,
      i = _objectWithoutProperties(_ref2346, _excluded2346);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C6.47715 2 2 6.47715 2 12 2 17.5228 6.47715 22 12 22 17.5228 22 22 17.5228 22 12H20C20 16.4183 16.4183 20 12 20 7.58172 20 4 16.4183 4 12 4 7.58172 7.58172 4 12 4 14.4639 4 16.6676 5.11383 18.1351 6.86543L16.1384 8.86165C15.6996 8.48063 15.1267 8.25 14.5 8.25 13.1193 8.25 12 9.36929 12 10.75V13.25C12 14.6307 13.1193 15.75 14.5 15.75 15.8807 15.75 17 14.6307 17 13.25V10.75C17 10.0686 16.7274 9.45094 16.2854 9H22V3L19.5534 5.44648C17.72 3.33509 15.0159 2 12 2ZM15.5 10.75V13.25C15.5 13.8023 15.0523 14.25 14.5 14.25 13.9477 14.25 13.5 13.8023 13.5 13.25V10.75C13.5 10.1977 13.9477 9.75 14.5 9.75 15.0523 9.75 15.5 10.1977 15.5 10.75ZM10 8.5H8.5V15.5H10V8.5Z"
  }));
},
    SS = function SS(_ref2347) {
  var _ref2347$color = _ref2347.color,
      C = _ref2347$color === void 0 ? "currentColor" : _ref2347$color,
      _ref2347$size = _ref2347.size,
      e = _ref2347$size === void 0 ? 24 : _ref2347$size,
      l = _ref2347.className,
      i = _objectWithoutProperties(_ref2347, _excluded2347);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C6.47715 2 2 6.47715 2 12 2 17.5228 6.47715 22 12 22 17.5228 22 22 17.5228 22 12H20C20 16.4183 16.4183 20 12 20 7.58172 20 4 16.4183 4 12 4 7.58172 7.58172 4 12 4 14.7498 4 17.1755 5.38734 18.6155 7.50024L16 7.5V8.74982C15.5822 8.43597 15.0628 8.25 14.5 8.25 13.1193 8.25 12 9.36929 12 10.75V13.25C12 14.6307 13.1193 15.75 14.5 15.75 15.8807 15.75 17 14.6307 17 13.25V10.75C17 10.2946 16.8783 9.86772 16.6655 9.5H22V3.5H20L20.0001 5.99918C18.1757 3.57075 15.2713 2 12 2ZM15.5 10.75V13.25C15.5 13.8023 15.0523 14.25 14.5 14.25 13.9477 14.25 13.5 13.8023 13.5 13.25V10.75C13.5 10.1977 13.9477 9.75 14.5 9.75 15.0523 9.75 15.5 10.1977 15.5 10.75ZM10 8.5H8.5V15.5H10V8.5Z"
  }));
},
    AS = function AS(_ref2348) {
  var _ref2348$color = _ref2348.color,
      C = _ref2348$color === void 0 ? "currentColor" : _ref2348$color,
      _ref2348$size = _ref2348.size,
      e = _ref2348$size === void 0 ? 24 : _ref2348$size,
      l = _ref2348.className,
      i = _objectWithoutProperties(_ref2348, _excluded2348);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C6.47715 2 2 6.47715 2 12 2 17.5228 6.47715 22 12 22 17.5228 22 22 17.5228 22 12H20C20 16.4183 16.4183 20 12 20 7.58172 20 4 16.4183 4 12 4 7.58172 7.58172 4 12 4 14.4639 4 16.6676 5.11383 18.1351 6.86543L16.5001 8.5H12V12.75H14.875C15.2202 12.75 15.5 13.0298 15.5 13.375 15.5 13.7202 15.2202 14 14.875 14H12V15.5H14.875C16.0486 15.5 17 14.5486 17 13.375 17 12.2014 16.0486 11.25 14.875 11.25H13.5V10H16.75V9H22V3L19.5534 5.44648C17.72 3.33509 15.0159 2 12 2ZM8.5 8.5H10V15.5H8.5V8.5Z"
  }));
},
    kS = function kS(_ref2349) {
  var _ref2349$color = _ref2349.color,
      C = _ref2349$color === void 0 ? "currentColor" : _ref2349$color,
      _ref2349$size = _ref2349.size,
      e = _ref2349$size === void 0 ? 24 : _ref2349$size,
      l = _ref2349.className,
      i = _objectWithoutProperties(_ref2349, _excluded2349);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C6.47715 2 2 6.47715 2 12 2 17.5228 6.47715 22 12 22 17.5228 22 22 17.5228 22 12H20C20 16.4183 16.4183 20 12 20 7.58172 20 4 16.4183 4 12 4 7.58172 7.58172 4 12 4 14.7498 4 17.1755 5.38734 18.6155 7.50024L16 7.5V8.5H12V12.75H14.875C15.2202 12.75 15.5 13.0298 15.5 13.375 15.5 13.7202 15.2202 14 14.875 14H12V15.5H14.875C16.0486 15.5 17 14.5486 17 13.375 17 12.2014 16.0486 11.25 14.875 11.25H13.5V10H16.75V9.5H22V3.5H20L20.0001 5.99918C18.1757 3.57075 15.2713 2 12 2ZM8.5 8.5H10V15.5H8.5V8.5Z"
  }));
},
    PS = function PS(_ref2350) {
  var _ref2350$color = _ref2350.color,
      C = _ref2350$color === void 0 ? "currentColor" : _ref2350$color,
      _ref2350$size = _ref2350.size,
      e = _ref2350$size === void 0 ? 24 : _ref2350$size,
      l = _ref2350.className,
      i = _objectWithoutProperties(_ref2350, _excluded2350);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 12C2 6.47715 6.47715 2 12 2 15.0159 2 17.72 3.33509 19.5534 5.44648L22 3V9H16.7854C17.2274 9.45094 17.5 10.0686 17.5 10.75V13.25C17.5 14.6307 16.3807 15.75 15 15.75 13.6193 15.75 12.5 14.6307 12.5 13.25V10.75C12.5 9.36929 13.6193 8.25 15 8.25 15.4985 8.25 15.9629 8.39588 16.3528 8.64728L18.1351 6.86543C16.6676 5.11383 14.4639 4 12 4 7.58172 4 4 7.58172 4 12 4 16.4183 7.58172 20 12 20 16.4183 20 20 16.4183 20 12H22C22 17.5228 17.5228 22 12 22 6.47715 22 2 17.5228 2 12ZM15 9.75C14.4477 9.75 14 10.1977 14 10.75V13.25C14 13.8023 14.4477 14.25 15 14.25 15.5523 14.25 16 13.8023 16 13.25V10.75C16 10.1977 15.5523 9.75 15 9.75ZM9.99981 13.375C9.99981 13.0298 9.71999 12.75 9.37481 12.75H7.5V11.25H9.37481C9.71999 11.25 9.99981 10.9702 9.99981 10.625 9.99981 10.2798 9.71999 10 9.37481 10H6.75V8.5H9.37481C10.5484 8.5 11.4998 9.4514 11.4998 10.625 11.4998 11.1494 11.3099 11.6294 10.9951 12 11.3099 12.3706 11.4998 12.8506 11.4998 13.375 11.4998 14.5486 10.5484 15.5 9.37481 15.5H6.75V14H9.37481C9.71999 14 9.99981 13.7202 9.99981 13.375Z"
  }));
},
    DS = function DS(_ref2351) {
  var _ref2351$color = _ref2351.color,
      C = _ref2351$color === void 0 ? "currentColor" : _ref2351$color,
      _ref2351$size = _ref2351.size,
      e = _ref2351$size === void 0 ? 24 : _ref2351$size,
      l = _ref2351.className,
      i = _objectWithoutProperties(_ref2351, _excluded2351);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 12C2 6.47715 6.47715 2 12 2 15.2713 2 18.1757 3.57075 20.0001 5.99918L20 3.5H22V9.5H17.1655C17.3783 9.86772 17.5 10.2946 17.5 10.75V13.25C17.5 14.6307 16.3807 15.75 15 15.75 13.6193 15.75 12.5 14.6307 12.5 13.25V10.75C12.5 9.36929 13.6193 8.25 15 8.25 15.3556 8.25 15.6938 8.32422 16 8.45802V7.5L18.6155 7.50024C17.1755 5.38734 14.7498 4 12 4 7.58172 4 4 7.58172 4 12 4 16.4183 7.58172 20 12 20 16.4183 20 20 16.4183 20 12H22C22 17.5228 17.5228 22 12 22 6.47715 22 2 17.5228 2 12ZM15 9.75C14.4477 9.75 14 10.1977 14 10.75V13.25C14 13.8023 14.4477 14.25 15 14.25 15.5523 14.25 16 13.8023 16 13.25V10.75C16 10.1977 15.5523 9.75 15 9.75ZM9.37481 12.75C9.71999 12.75 9.99981 13.0298 9.99981 13.375 9.99981 13.7202 9.71999 14 9.37481 14H6.75V15.5H9.37481C10.5484 15.5 11.4998 14.5486 11.4998 13.375 11.4998 12.8506 11.3099 12.3706 10.9951 12 11.3099 11.6294 11.4998 11.1494 11.4998 10.625 11.4998 9.4514 10.5484 8.5 9.37481 8.5H6.75V10H9.37481C9.71999 10 9.99981 10.2798 9.99981 10.625 9.99981 10.9702 9.71999 11.25 9.37481 11.25H7.5V12.75H9.37481Z"
  }));
},
    yS = function yS(_ref2352) {
  var _ref2352$color = _ref2352.color,
      C = _ref2352$color === void 0 ? "currentColor" : _ref2352$color,
      _ref2352$size = _ref2352.size,
      e = _ref2352$size === void 0 ? 24 : _ref2352$size,
      l = _ref2352.className,
      i = _objectWithoutProperties(_ref2352, _excluded2352);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 12C2 6.47715 6.47715 2 12 2 15.0159 2 17.72 3.33509 19.5534 5.44648L22 3V9H16L18.1351 6.86543C16.6676 5.11383 14.4639 4 12 4 7.58172 4 4 7.58172 4 12 4 16.4183 7.58172 20 12 20 16.4183 20 20 16.4183 20 12H22C22 17.5228 17.5228 22 12 22 6.47715 22 2 17.5228 2 12ZM14.5 10V8.5H9.5V12.75H12.625C12.9702 12.75 13.25 13.0298 13.25 13.375 13.25 13.7202 12.9702 14 12.625 14H9.5V15.5H12.625C13.7986 15.5 14.75 14.5486 14.75 13.375 14.75 12.2014 13.7986 11.25 12.625 11.25H11V10H14.5Z"
  }));
},
    bS = function bS(_ref2353) {
  var _ref2353$color = _ref2353.color,
      C = _ref2353$color === void 0 ? "currentColor" : _ref2353$color,
      _ref2353$size = _ref2353.size,
      e = _ref2353$size === void 0 ? 24 : _ref2353$size,
      l = _ref2353.className,
      i = _objectWithoutProperties(_ref2353, _excluded2353);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C6.47715 2 2 6.47715 2 12 2 17.5228 6.47715 22 12 22 17.5228 22 22 17.5228 22 12H20C20 16.4183 16.4183 20 12 20 7.58172 20 4 16.4183 4 12 4 7.58172 7.58172 4 12 4 14.7498 4 17.1755 5.38734 18.6155 7.50024L16 7.5V9.5H22V3.5H20L20.0001 5.99918C18.1757 3.57075 15.2713 2 12 2ZM9.5 8.5H14.5V10H11V11.25H12.625C13.7986 11.25 14.75 12.2014 14.75 13.375 14.75 14.5486 13.7986 15.5 12.625 15.5H9.5V14H12.625C12.9702 14 13.25 13.7202 13.25 13.375 13.25 13.0298 12.9702 12.75 12.625 12.75H9.5V8.5Z"
  }));
},
    TS = function TS(_ref2354) {
  var _ref2354$color = _ref2354.color,
      C = _ref2354$color === void 0 ? "currentColor" : _ref2354$color,
      _ref2354$size = _ref2354.size,
      e = _ref2354$size === void 0 ? 24 : _ref2354$size,
      l = _ref2354.className,
      i = _objectWithoutProperties(_ref2354, _excluded2354);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2 0 9 12 16 22 10.1667V17.5H24V9L12 2ZM3.99902 13.4905V18.0001C5.82344 20.429 8.72812 22.0001 11.9998 22.0001 15.2714 22.0001 18.1761 20.429 20.0005 18.0001L20.0001 13.4913 12.0003 18.1579 3.99902 13.4905Z"
  }));
},
    US = function US(_ref2355) {
  var _ref2355$color = _ref2355.color,
      C = _ref2355$color === void 0 ? "currentColor" : _ref2355$color,
      _ref2355$size = _ref2355.size,
      e = _ref2355$size === void 0 ? 24 : _ref2355$size,
      l = _ref2355.className,
      i = _objectWithoutProperties(_ref2355, _excluded2355);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 11.3333L0 9L12 2L24 9V17.5H22V10.1667L20 11.3333V18.0113L19.7774 18.2864C17.9457 20.5499 15.1418 22 12 22C8.85817 22 6.05429 20.5499 4.22263 18.2864L4 18.0113V11.3333ZM6 12.5V17.2917C7.46721 18.954 9.61112 20 12 20C14.3889 20 16.5328 18.954 18 17.2917V12.5L12 16L6 12.5ZM3.96927 9L12 13.6846L20.0307 9L12 4.31541L3.96927 9Z"
  }));
},
    GS = function GS(_ref2356) {
  var _ref2356$color = _ref2356.color,
      C = _ref2356$color === void 0 ? "currentColor" : _ref2356$color,
      _ref2356$size = _ref2356.size,
      e = _ref2356$size === void 0 ? 24 : _ref2356$size,
      l = _ref2356.className,
      i = _objectWithoutProperties(_ref2356, _excluded2356);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.7999 9H12V17H11V21.0001H5C4.44772 21.0001 4 20.5524 4 20.0001V11.0001L1 11.0001 11.3273 1.61162C11.7087 1.26488 12.2913 1.26488 12.6727 1.61162L20.7999 9ZM14 11H23V18H14V11ZM13 21H24V19H13V21Z"
  }));
},
    IS = function IS(_ref2357) {
  var _ref2357$color = _ref2357.color,
      C = _ref2357$color === void 0 ? "currentColor" : _ref2357$color,
      _ref2357$size = _ref2357.size,
      e = _ref2357$size === void 0 ? 24 : _ref2357$size,
      l = _ref2357.className,
      i = _objectWithoutProperties(_ref2357, _excluded2357);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.6727 1.61162 20.7999 9H17.8267L12 3.70302 6 9.15757V19.0001H11V21.0001H5C4.44772 21.0001 4 20.5524 4 20.0001V11.0001L1 11.0001 11.3273 1.61162C11.7087 1.26488 12.2913 1.26488 12.6727 1.61162ZM14 11H23V18H14V11ZM16 13V16H21V13H16ZM24 21H13V19H24V21Z"
  }));
},
    WS = function WS(_ref2358) {
  var _ref2358$color = _ref2358.color,
      C = _ref2358$color === void 0 ? "currentColor" : _ref2358$color,
      _ref2358$size = _ref2358.size,
      e = _ref2358$size === void 0 ? 24 : _ref2358$size,
      l = _ref2358.className,
      i = _objectWithoutProperties(_ref2358, _excluded2358);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 2H20V6.45994L13.5366 12L20 17.5401V22H4V17.5401L10.4634 12L4 6.45994V2ZM16.2967 7L18 5.54007V4H6V5.54007L7.70326 7H16.2967ZM12 13.3171L6 18.4599V20H7L12 17L17 20H18V18.4599L12 13.3171Z"
  }));
},
    OS = function OS(_ref2359) {
  var _ref2359$color = _ref2359.color,
      C = _ref2359$color === void 0 ? "currentColor" : _ref2359$color,
      _ref2359$size = _ref2359.size,
      e = _ref2359$size === void 0 ? 24 : _ref2359$size,
      l = _ref2359.className,
      i = _objectWithoutProperties(_ref2359, _excluded2359);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 2H20V6.45994L13.5366 12L20 17.5401V22H4V17.5401L10.4634 12L4 6.45994V2ZM12 10.6829L18 5.54007V4H6V5.54007L12 10.6829ZM12 13.3171L6 18.4599V20H18V18.4599L12 13.3171Z"
  }));
},
    KS = function KS(_ref2360) {
  var _ref2360$color = _ref2360.color,
      C = _ref2360$color === void 0 ? "currentColor" : _ref2360$color,
      _ref2360$size = _ref2360.size,
      e = _ref2360$size === void 0 ? 24 : _ref2360$size,
      l = _ref2360.className,
      i = _objectWithoutProperties(_ref2360, _excluded2360);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6 4H4V2H20V4H18V6C18 7.61543 17.1838 8.91468 16.1561 9.97667C15.4532 10.703 14.598 11.372 13.7309 12C14.598 12.628 15.4532 13.297 16.1561 14.0233C17.1838 15.0853 18 16.3846 18 18V20H20V22H4V20H6V18C6 16.3846 6.81616 15.0853 7.8439 14.0233C8.54682 13.297 9.40202 12.628 10.2691 12C9.40202 11.372 8.54682 10.703 7.8439 9.97667C6.81616 8.91468 6 7.61543 6 6V4ZM8 4V6C8 6.68514 8.26026 7.33499 8.77131 8H15.2287C15.7397 7.33499 16 6.68514 16 6V4H8ZM12 13.2219C10.9548 13.9602 10.008 14.663 9.2811 15.4142C9.09008 15.6116 8.92007 15.8064 8.77131 16H15.2287C15.0799 15.8064 14.9099 15.6116 14.7189 15.4142C13.992 14.663 13.0452 13.9602 12 13.2219Z"
  }));
},
    QS = function QS(_ref2361) {
  var _ref2361$color = _ref2361.color,
      C = _ref2361$color === void 0 ? "currentColor" : _ref2361$color,
      _ref2361$size = _ref2361.size,
      e = _ref2361$size === void 0 ? 24 : _ref2361$size,
      l = _ref2361.className,
      i = _objectWithoutProperties(_ref2361, _excluded2361);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6 4H4V2H20V4H18V6C18 7.61543 17.1838 8.91468 16.1561 9.97667C15.4532 10.703 14.598 11.372 13.7309 12C14.598 12.628 15.4532 13.297 16.1561 14.0233C17.1838 15.0853 18 16.3846 18 18V20H20V22H4V20H6V18C6 16.3846 6.81616 15.0853 7.8439 14.0233C8.54682 13.297 9.40202 12.628 10.2691 12C9.40202 11.372 8.54682 10.703 7.8439 9.97667C6.81616 8.91468 6 7.61543 6 6V4ZM8 4V6C8 6.88457 8.43384 7.71032 9.2811 8.58583C10.008 9.33699 10.9548 10.0398 12 10.7781C13.0452 10.0398 13.992 9.33699 14.7189 8.58583C15.5662 7.71032 16 6.88457 16 6V4H8ZM12 13.2219C10.9548 13.9602 10.008 14.663 9.2811 15.4142C8.43384 16.2897 8 17.1154 8 18V20H16V18C16 17.1154 15.5662 16.2897 14.7189 15.4142C13.992 14.663 13.0452 13.9602 12 13.2219Z"
  }));
},
    qS = function qS(_ref2362) {
  var _ref2362$color = _ref2362.color,
      C = _ref2362$color === void 0 ? "currentColor" : _ref2362$color,
      _ref2362$size = _ref2362.size,
      e = _ref2362$size === void 0 ? 24 : _ref2362$size,
      l = _ref2362.className,
      i = _objectWithoutProperties(_ref2362, _excluded2362);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6 3C4.34315 3 3 4.34315 3 6V18C3 19.6569 4.34315 21 6 21H18C19.6569 21 21 19.6569 21 18V6C21 4.34315 19.6569 3 18 3H6ZM13.3344 16.055C14.0531 16.6343 14.7717 16.9203 15.4904 16.913C15.9304 16.913 16.2677 16.8323 16.5024 16.671C16.7297 16.517 16.8434 16.297 16.8434 16.011C16.8434 15.7177 16.7297 15.4683 16.5024 15.263C16.2677 15.0577 15.8241 14.8523 15.1714 14.647C14.3867 14.4197 13.7817 14.1263 13.3564 13.767C12.9384 13.4077 12.7257 12.9053 12.7184 12.26C12.7184 11.6513 12.9824 11.1417 13.5104 10.731C14.0237 10.3203 14.6801 10.115 15.4794 10.115C16.5941 10.115 17.4887 10.3863 18.1634 10.929L17.3934 12.128C17.1221 11.9153 16.8104 11.7613 16.4584 11.666C16.1064 11.556 15.7911 11.501 15.5124 11.501C15.1311 11.501 14.8267 11.5707 14.5994 11.71C14.3721 11.8493 14.2584 12.0327 14.2584 12.26C14.2584 12.5093 14.3977 12.722 14.6764 12.898C14.9551 13.0667 15.4317 13.2537 16.1064 13.459C16.9204 13.701 17.4997 14.0237 17.8444 14.427C18.1891 14.8303 18.3614 15.3437 18.3614 15.967C18.3614 16.605 18.1157 17.155 17.6244 17.617C17.1404 18.0717 16.4364 18.31 15.5124 18.332C14.3024 18.332 13.2904 17.969 12.4764 17.243L13.3344 16.055ZM7.80405 16.693C8.03872 16.8397 8.32105 16.913 8.65105 16.913C8.99572 16.913 9.28172 16.814 9.50905 16.616C9.73639 16.4107 9.85005 16.055 9.85005 15.549V10.247H11.3351V15.835C11.3131 16.7003 11.0637 17.3237 10.5871 17.705C10.3157 17.9323 10.0187 18.0937 9.69605 18.189C9.37339 18.2843 9.06172 18.332 8.76105 18.332C8.21105 18.332 7.72339 18.2367 7.29805 18.046C6.84339 17.8407 6.46205 17.4777 6.15405 16.957L7.18805 16.11C7.37872 16.3667 7.58405 16.561 7.80405 16.693Z"
  }));
},
    jS = function jS(_ref2363) {
  var _ref2363$color = _ref2363.color,
      C = _ref2363$color === void 0 ? "currentColor" : _ref2363$color,
      _ref2363$size = _ref2363.size,
      e = _ref2363$size === void 0 ? 24 : _ref2363$size,
      l = _ref2363.className,
      i = _objectWithoutProperties(_ref2363, _excluded2363);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13.3344 16.055 12.4764 17.243C13.2904 17.969 14.3024 18.332 15.5124 18.332 16.4364 18.31 17.1404 18.0717 17.6244 17.617 18.1157 17.155 18.3614 16.605 18.3614 15.967 18.3614 15.3437 18.1891 14.8303 17.8444 14.427 17.4997 14.0237 16.9204 13.701 16.1064 13.459 15.4317 13.2537 14.9551 13.0667 14.6764 12.898 14.3977 12.722 14.2584 12.5093 14.2584 12.26 14.2584 12.0327 14.3721 11.8493 14.5994 11.71 14.8267 11.5707 15.1311 11.501 15.5124 11.501 15.7911 11.501 16.1064 11.556 16.4584 11.666 16.8104 11.7613 17.1221 11.9153 17.3934 12.128L18.1634 10.929C17.4887 10.3863 16.5941 10.115 15.4794 10.115 14.6801 10.115 14.0237 10.3203 13.5104 10.731 12.9824 11.1417 12.7184 11.6513 12.7184 12.26 12.7257 12.9053 12.9384 13.4077 13.3564 13.767 13.7817 14.1263 14.3867 14.4197 15.1714 14.647 15.8241 14.8523 16.2677 15.0577 16.5024 15.263 16.7297 15.4683 16.8434 15.7177 16.8434 16.011 16.8434 16.297 16.7297 16.517 16.5024 16.671 16.2677 16.8323 15.9304 16.913 15.4904 16.913 14.7717 16.9203 14.0531 16.6343 13.3344 16.055ZM7.80405 16.693C7.58405 16.561 7.37872 16.3667 7.18805 16.11L6.15405 16.957C6.46205 17.4777 6.84339 17.8407 7.29805 18.046 7.72339 18.2367 8.21105 18.332 8.76105 18.332 9.06172 18.332 9.37339 18.2843 9.69605 18.189 10.0187 18.0937 10.3157 17.9323 10.5871 17.705 11.0637 17.3237 11.3131 16.7003 11.3351 15.835V10.247H9.85005V15.549C9.85005 16.055 9.73639 16.4107 9.50905 16.616 9.28172 16.814 8.99572 16.913 8.65105 16.913 8.32105 16.913 8.03872 16.8397 7.80405 16.693ZM3 6C3 4.34315 4.34315 3 6 3H18C19.6569 3 21 4.34315 21 6V18C21 19.6569 19.6569 21 18 21H6C4.34315 21 3 19.6569 3 18V6ZM6 5C5.44772 5 5 5.44772 5 6V18C5 18.5523 5.44772 19 6 19H18C18.5523 19 19 18.5523 19 18V6C19 5.44772 18.5523 5 18 5H6Z"
  }));
},
    XS = function XS(_ref2364) {
  var _ref2364$color = _ref2364.color,
      C = _ref2364$color === void 0 ? "currentColor" : _ref2364$color,
      _ref2364$size = _ref2364.size,
      e = _ref2364$size === void 0 ? 24 : _ref2364$size,
      l = _ref2364.className,
      i = _objectWithoutProperties(_ref2364, _excluded2364);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 4C9.4095 4 7.10606 5.23053 5.64274 7.14274L8 9.5H2V3.5L4.21863 5.71863C6.05061 3.452 8.85558 2 12 2 17.5228 2 22 6.47715 22 12H20C20 7.58172 16.4183 4 12 4ZM4 12C4 16.4183 7.58172 20 12 20 14.5905 20 16.894 18.7695 18.3573 16.8573L16 14.5 22 14.5V20.5L19.7814 18.2814C17.9494 20.548 15.1444 22 12 22 6.47715 22 2 17.5228 2 12H4Z"
  }));
},
    JS = function JS(_ref2365) {
  var _ref2365$color = _ref2365.color,
      C = _ref2365$color === void 0 ? "currentColor" : _ref2365$color,
      _ref2365$size = _ref2365.size,
      e = _ref2365$size === void 0 ? 24 : _ref2365$size,
      l = _ref2365.className,
      i = _objectWithoutProperties(_ref2365, _excluded2365);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 4C9.25144 4 6.82508 5.38626 5.38443 7.5H8V9.5H2V3.5H4V5.99936C5.82381 3.57166 8.72764 2 12 2C17.5228 2 22 6.47715 22 12H20C20 7.58172 16.4183 4 12 4ZM4 12C4 16.4183 7.58172 20 12 20C14.7486 20 17.1749 18.6137 18.6156 16.5H16V14.5H22V20.5H20V18.0006C18.1762 20.4283 15.2724 22 12 22C6.47715 22 2 17.5228 2 12H4Z"
  }));
},
    YS = function YS(_ref2366) {
  var _ref2366$color = _ref2366.color,
      C = _ref2366$color === void 0 ? "currentColor" : _ref2366$color,
      _ref2366$size = _ref2366.size,
      e = _ref2366$size === void 0 ? 24 : _ref2366$size,
      l = _ref2366.className,
      i = _objectWithoutProperties(_ref2366, _excluded2366);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 4C14.5905 4 16.8939 5.23053 18.3573 7.14274L16 9.5H22V3.5L19.7814 5.71863C17.9494 3.452 15.1444 2 12 2 6.47715 2 2 6.47715 2 12H4C4 7.58172 7.58172 4 12 4ZM20 12C20 16.4183 16.4183 20 12 20 9.40951 20 7.10605 18.7695 5.64274 16.8573L8 14.5 2 14.5V20.5L4.21863 18.2814C6.05062 20.548 8.85557 22 12 22 17.5228 22 22 17.5228 22 12H20Z"
  }));
},
    _S = function _S(_ref2367) {
  var _ref2367$color = _ref2367.color,
      C = _ref2367$color === void 0 ? "currentColor" : _ref2367$color,
      _ref2367$size = _ref2367.size,
      e = _ref2367$size === void 0 ? 24 : _ref2367$size,
      l = _ref2367.className,
      i = _objectWithoutProperties(_ref2367, _excluded2367);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 4C14.7486 4 17.1749 5.38626 18.6156 7.5H16V9.5H22V3.5H20V5.99936C18.1762 3.57166 15.2724 2 12 2C6.47715 2 2 6.47715 2 12H4C4 7.58172 7.58172 4 12 4ZM20 12C20 16.4183 16.4183 20 12 20C9.25144 20 6.82508 18.6137 5.38443 16.5H8V14.5H2V20.5H4V18.0006C5.82381 20.4283 8.72764 22 12 22C17.5228 22 22 17.5228 22 12H20Z"
  }));
},
    $S = function $S(_ref2368) {
  var _ref2368$color = _ref2368.color,
      C = _ref2368$color === void 0 ? "currentColor" : _ref2368$color,
      _ref2368$size = _ref2368.size,
      e = _ref2368$size === void 0 ? 24 : _ref2368$size,
      l = _ref2368.className,
      i = _objectWithoutProperties(_ref2368, _excluded2368);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22 12C22 6.47715 17.5228 2 12 2 8.9841 2 6.28002 3.33509 4.44656 5.44648L2 3V9H8L5.86492 6.86543C7.33243 5.11383 9.53614 4 12 4 16.4183 4 20 7.58172 20 12 20 16.4183 16.4183 20 12 20 7.58172 20 4 16.4183 4 12H2C2 17.5228 6.47715 22 12 22 17.5228 22 22 17.5228 22 12ZM10.7774 8.51823 15.376 11.584C15.6728 11.7819 15.6728 12.2181 15.376 12.416L10.7773 15.4818C10.4451 15.7033 10 15.4651 10 15.0657V8.93426C10 8.53491 10.4451 8.29672 10.7774 8.51823Z"
  }));
},
    eA = function eA(_ref2369) {
  var _ref2369$color = _ref2369.color,
      C = _ref2369$color === void 0 ? "currentColor" : _ref2369$color,
      _ref2369$size = _ref2369.size,
      e = _ref2369$size === void 0 ? 24 : _ref2369$size,
      l = _ref2369.className,
      i = _objectWithoutProperties(_ref2369, _excluded2369);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22 12C22 6.47715 17.5228 2 12 2 8.72873 2 5.82434 3.57075 3.99989 5.99918L4 3.5H2V9.5H8V7.5L5.38451 7.50024C6.82447 5.38734 9.25022 4 12 4 16.4183 4 20 7.58172 20 12 20 16.4183 16.4183 20 12 20 7.58172 20 4 16.4183 4 12H2C2 17.5228 6.47715 22 12 22 17.5228 22 22 17.5228 22 12ZM10.7774 8.51823 15.376 11.584C15.6728 11.7819 15.6728 12.2181 15.376 12.416L10.7773 15.4818C10.4451 15.7033 10 15.4651 10 15.0657V8.93426C10 8.53491 10.4451 8.29672 10.7774 8.51823Z"
  }));
},
    tA = function tA(_ref2370) {
  var _ref2370$color = _ref2370.color,
      C = _ref2370$color === void 0 ? "currentColor" : _ref2370$color,
      _ref2370$size = _ref2370.size,
      e = _ref2370$size === void 0 ? 24 : _ref2370$size,
      l = _ref2370.className,
      i = _objectWithoutProperties(_ref2370, _excluded2370);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16.9197 4.5C15.0689 4.5 13.622 5.89404 12.3123 7.6649C10.5124 5.37323 9.00722 4.5 7.20593 4.5C3.53352 4.5 0.719727 9.27931 0.719727 14.3379C0.719727 17.5034 2.25116 19.5 4.81628 19.5C6.66249 19.5 7.99028 18.6296 10.3508 14.5034C10.3508 14.5034 11.3347 12.7658 12.0116 11.5689C12.2488 11.9518 12.4981 12.3639 12.7611 12.8069L13.868 14.669C16.0242 18.2772 17.2256 19.5 19.4025 19.5C21.9014 19.5 23.2921 17.4761 23.2921 14.2448C23.2921 8.94828 20.4149 4.5 16.9197 4.5ZM8.55076 13.3862C6.63697 16.3862 5.9749 17.0586 4.90938 17.0586C3.81283 17.0586 3.16111 16.0959 3.16111 14.3793C3.16111 10.7069 4.99214 6.95172 7.1749 6.95172C8.35692 6.95172 9.34471 7.63438 10.8577 9.80042C9.42105 12.0041 8.55076 13.3862 8.55076 13.3862ZM15.7737 13.0085L14.4502 10.8013C14.0921 10.2188 13.7489 9.6836 13.4177 9.19286C14.6105 7.35183 15.5944 6.43448 16.7646 6.43448C19.1956 6.43448 21.1404 10.0138 21.1404 14.4103C21.1404 16.0862 20.5915 17.0586 19.4542 17.0586C18.3641 17.0586 17.8434 16.3387 15.7737 13.0085Z"
  }));
},
    CA = function CA(_ref2371) {
  var _ref2371$color = _ref2371.color,
      C = _ref2371$color === void 0 ? "currentColor" : _ref2371$color,
      _ref2371$size = _ref2371.size,
      e = _ref2371$size === void 0 ? 24 : _ref2371$size,
      l = _ref2371.className,
      i = _objectWithoutProperties(_ref2371, _excluded2371);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.9744 16.1635C20.6888 17.0545 20.199 17.5 19.5048 17.5C18.6273 17.5 17.7647 16.9735 16.917 15.9206C16.3283 15.1893 15.5026 13.7996 14.44 11.7515C13.984 10.8723 13.5611 10.0959 13.1714 9.42225C13.4809 8.93372 13.757 8.54177 13.9998 8.24641C14.957 7.08214 15.9587 6.5 17.0048 6.5C17.8397 6.5 18.635 7.03584 19.3907 8.10753C20.1673 9.20896 20.7114 10.5694 21.0228 12.1888C21.3292 13.782 21.3131 15.1069 20.9744 16.1635ZM12.0049 11.4296C12.2149 11.8151 12.4349 12.2294 12.6647 12.6725C13.7887 14.839 14.6869 16.3397 15.3591 17.1748C16.6071 18.7249 17.989 19.5 19.5048 19.5C20.3608 19.5 21.0931 19.2297 21.7019 18.6892C22.2267 18.2233 22.6191 17.5849 22.879 16.774C23.3216 15.3931 23.3576 13.7388 22.9868 11.8112C22.6212 9.90978 21.9673 8.29105 21.0252 6.95497C19.8712 5.31832 18.531 4.5 17.0048 4.5C15.3288 4.5 13.8121 5.32543 12.4549 6.97628C12.3132 7.14862 12.1632 7.34668 12.0049 7.57046C11.8466 7.34668 11.6966 7.14862 11.5548 6.97628C10.1976 5.32543 8.68102 4.5 7.005 4.5C5.4788 4.5 4.13867 5.31833 2.98462 6.95498C2.04252 8.29105 1.38864 9.90977 1.02298 11.8112C0.652277 13.7388 0.688225 15.3931 1.13083 16.774C1.39074 17.5849 1.78309 18.2233 2.30788 18.6892C2.91672 19.2297 3.6491 19.5 4.50502 19.5C6.02087 19.5 7.40276 18.7249 8.65069 17.1748C9.32296 16.3397 10.2211 14.839 11.345 12.6726C11.575 12.2294 11.7949 11.8151 12.0049 11.4296ZM10.8384 9.42226C10.4487 10.0959 10.0258 10.8723 9.56972 11.7515C8.50715 13.7996 7.6815 15.1893 7.09279 15.9206C6.24514 16.9735 5.38255 17.5 4.50502 17.5C3.81084 17.5 3.32096 17.0545 3.03539 16.1635C2.69674 15.1069 2.6806 13.782 2.98699 12.1888C3.29843 10.5694 3.84248 9.20896 4.61913 8.10752C5.37481 7.03584 6.1701 6.5 7.005 6.5C8.05111 6.5 9.05277 7.08214 10.01 8.24641C10.2528 8.54176 10.5289 8.93371 10.8384 9.42226Z"
  }));
},
    lA = function lA(_ref2372) {
  var _ref2372$color = _ref2372.color,
      C = _ref2372$color === void 0 ? "currentColor" : _ref2372$color,
      _ref2372$size = _ref2372.size,
      e = _ref2372$size === void 0 ? 24 : _ref2372$size,
      l = _ref2372.className,
      i = _objectWithoutProperties(_ref2372, _excluded2372);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22 12C22 17.5228 17.5228 22 12 22H6.66472C8.68458 20.5479 10 18.1776 10 15.5H12C13.933 15.5 15.5 13.933 15.5 12C15.5 10.067 13.933 8.5 12 8.5C10.067 8.5 8.5 10.067 8.5 12V15.5C8.5 19.0899 5.58985 22 2 22V12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
  }));
},
    iA = function iA(_ref2373) {
  var _ref2373$color = _ref2373.color,
      C = _ref2373$color === void 0 ? "currentColor" : _ref2373$color,
      _ref2373$size = _ref2373.size,
      e = _ref2373$size === void 0 ? 24 : _ref2373$size,
      l = _ref2373.className,
      i = _objectWithoutProperties(_ref2373, _excluded2373);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20H7.69043C8.59297 19.0595 9.21538 17.8481 9.42355 16.5H12C14.4853 16.5 16.5 14.4853 16.5 12C16.5 9.51472 14.4853 7.5 12 7.5C9.51472 7.5 7.5 9.51472 7.5 12V15.5C7.5 17.6416 6.00399 19.4338 4 19.8885V12C4 7.58172 7.58172 4 12 4ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12V22H12ZM9.5 14.5V12C9.5 10.6193 10.6193 9.5 12 9.5C13.3807 9.5 14.5 10.6193 14.5 12C14.5 13.3807 13.3807 14.5 12 14.5H9.5Z"
  }));
},
    sA = function sA(_ref2374) {
  var _ref2374$color = _ref2374.color,
      C = _ref2374$color === void 0 ? "currentColor" : _ref2374$color,
      _ref2374$size = _ref2374.size,
      e = _ref2374$size === void 0 ? 24 : _ref2374$size,
      l = _ref2374.className,
      i = _objectWithoutProperties(_ref2374, _excluded2374);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9 12C10.1046 12 11 11.1046 11 10 11 8.89543 10.1046 8 9 8 7.89543 8 7 8.89543 7 10 7 11.1046 7.89543 12 9 12ZM12 1 21.5 6.5V17.5L12 23 2.5 17.5V6.5L12 1ZM4.5 7.65311V16.3469L6.8724 17.7204 14.9446 11.8008 19.5 14.534V7.65311L12 3.311 4.5 7.65311Z"
  }));
},
    rA = function rA(_ref2375) {
  var _ref2375$color = _ref2375.color,
      C = _ref2375$color === void 0 ? "currentColor" : _ref2375$color,
      _ref2375$size = _ref2375.size,
      e = _ref2375$size === void 0 ? 24 : _ref2375$size,
      l = _ref2375.className,
      i = _objectWithoutProperties(_ref2375, _excluded2375);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9 12C10.1046 12 11 11.1046 11 10 11 8.89543 10.1046 8 9 8 7.89543 8 7 8.89543 7 10 7 11.1046 7.89543 12 9 12ZM21.5 6.5 12 1 2.5 6.5V17.5L12 23 21.5 17.5V6.5ZM12 3.311 19.5 7.65311V14.5338L14.9379 11.7966 6.96669 17.775 4.5 16.3469V7.65311L12 3.311ZM12 20.689 8.84788 18.8641 15.0621 14.2034 19.0595 16.6019 12 20.689Z"
  }));
},
    cA = function cA(_ref2376) {
  var _ref2376$color = _ref2376.color,
      C = _ref2376$color === void 0 ? "currentColor" : _ref2376$color,
      _ref2376$size = _ref2376.size,
      e = _ref2376$size === void 0 ? 24 : _ref2376$size,
      l = _ref2376.className,
      i = _objectWithoutProperties(_ref2376, _excluded2376);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.1039 5.90972C6.68754 6.38386 6.90648 6.34768 8.00238 6.27457L18.3342 5.65418C18.5533 5.65418 18.3711 5.43557 18.2981 5.39924L16.5822 4.15879C16.2534 3.90354 15.8153 3.61122 14.9758 3.68434L4.9715 4.41403C4.60665 4.45021 4.53377 4.63262 4.67909 4.77886L6.1039 5.90972ZM6.72422 8.31752L6.72422 19.1884C6.72422 19.7726 7.01618 19.9912 7.6733 19.955L19.028 19.298C19.6854 19.2619 19.7586 18.86 19.7586 18.3854V7.58753C19.7586 7.1137 19.5764 6.85816 19.1739 6.89464L7.30815 7.58753C6.87027 7.62433 6.72422 7.84337 6.72422 8.31752ZM17.9335 8.90066C18.0063 9.22933 17.9335 9.55767 17.6043 9.5946L17.0571 9.70361V17.7292C16.5822 17.9845 16.1441 18.1304 15.7791 18.1304C15.1947 18.1304 15.0484 17.9479 14.6107 17.401L11.0321 11.783V17.2186L12.1645 17.4741C12.1645 17.4741 12.1645 18.1304 11.2509 18.1304L8.73222 18.2765C8.65905 18.1304 8.73222 17.7659 8.98769 17.6929L9.64494 17.5108V10.324L8.73237 10.2509C8.6592 9.92222 8.84146 9.44837 9.35298 9.41159L12.0549 9.22946L15.7791 14.9205V9.88603L14.8296 9.77704C14.7567 9.37526 15.0484 9.08353 15.4135 9.04735L17.9335 8.90066ZM4.13151 3.4291L14.5376 2.66279C15.8155 2.55318 16.1443 2.6266 16.9475 3.21005L20.2692 5.54473C20.8173 5.9462 21 6.05551 21 6.49316V19.298C21 20.1005 20.7077 20.5751 19.6856 20.6477L7.60101 21.3775C6.83376 21.4141 6.4686 21.3047 6.0668 20.7937L3.6206 17.6199C3.18227 17.0357 3 16.5986 3 16.0873L3 4.70545C3 4.04918 3.29242 3.50177 4.13151 3.4291Z"
  }));
},
    oA = function oA(_ref2377) {
  var _ref2377$color = _ref2377.color,
      C = _ref2377$color === void 0 ? "currentColor" : _ref2377$color,
      _ref2377$size = _ref2377.size,
      e = _ref2377$size === void 0 ? 24 : _ref2377$size,
      l = _ref2377.className,
      i = _objectWithoutProperties(_ref2377, _excluded2377);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16.2852 2.95494C15.9283 2.71702 15.5011 2.60764 15.0738 2.6448L4.01455 3.60647C3.50353 3.65091 3.11133 4.0787 3.11133 4.59164L3.11133 16.1666C3.11133 16.5753 3.24389 16.973 3.48911 17.3L6.25617 20.9894C6.45903 21.2599 6.78602 21.4079 7.12313 21.382L19.9761 20.3933C20.4913 20.3537 20.8891 19.9241 20.8891 19.4074V6.52672C20.8891 6.2128 20.7322 5.91965 20.471 5.74551L16.2852 2.95494ZM15.2278 4.41589C15.2529 4.41371 15.278 4.42014 15.299 4.43414L18.0448 6.26466L7.8385 7.08117L5.97759 5.22026L15.2278 4.41589ZM19.1113 18.6768L8.38911 19.5016V8.82058L19.1113 7.9628V18.6768ZM4.88911 6.64593L6.61133 8.36815L6.61133 18.5L4.91133 16.2333C4.8969 16.2141 4.88911 16.1907 4.88911 16.1666L4.88911 6.64593ZM11.9786 10.1234L10.0022 10.2529V17.8154L11.9979 17.6846V13.3479L15.5098 17.5169L17.4861 17.3874V9.82491L15.4904 9.95571V14.2924L11.9786 10.1234Z"
  }));
},
    aA = function aA(_ref2378) {
  var _ref2378$color = _ref2378.color,
      C = _ref2378$color === void 0 ? "currentColor" : _ref2378$color,
      _ref2378$size = _ref2378.size,
      e = _ref2378$size === void 0 ? 24 : _ref2378$size,
      l = _ref2378.className,
      i = _objectWithoutProperties(_ref2378, _excluded2378);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.5624 10.1875C20.8124 9.5 20.8749 8.8125 20.8124 8.125C20.7499 7.4375 20.4999 6.75 20.1874 6.125C19.6249 5.1875 18.8124 4.4375 17.8749 4C16.8749 3.5625 15.8124 3.4375 14.7499 3.6875C14.2499 3.1875 13.6874 2.75 13.0624 2.4375C12.4374 2.125 11.6874 2 10.9999 2C9.9374 2 8.8749 2.3125 7.9999 2.9375C7.1249 3.5625 6.4999 4.4375 6.1874 5.4375C5.4374 5.625 4.8124 5.9375 4.1874 6.3125C3.6249 6.75 3.1874 7.3125 2.8124 7.875C2.24991 8.8125 2.06241 9.875 2.18741 10.9375C2.31241 12 2.7499 13 3.4374 13.8125C3.1874 14.5 3.1249 15.1875 3.1874 15.875C3.2499 16.5625 3.4999 17.25 3.8124 17.875C4.3749 18.8125 5.1874 19.5625 6.1249 20C7.1249 20.4375 8.1874 20.5625 9.2499 20.3125C9.7499 20.8125 10.3124 21.25 10.9374 21.5625C11.5624 21.875 12.3124 22 12.9999 22C14.0624 22 15.1249 21.6875 15.9999 21.0625C16.8749 20.4375 17.4999 19.5625 17.8124 18.5625C18.4999 18.4375 19.1874 18.125 19.7499 17.6875C20.3124 17.25 20.8124 16.75 21.1249 16.125C21.6874 15.1875 21.8749 14.125 21.7499 13.0625C21.6249 12 21.2499 11 20.5624 10.1875ZM13.0624 20.6875C12.0624 20.6875 11.3124 20.375 10.6249 19.8125C10.6249 19.8125 10.6874 19.75 10.7499 19.75L14.7499 17.4375C14.8749 17.375 14.9374 17.3125 14.9999 17.1875C15.0624 17.0625 15.0624 17 15.0624 16.875V11.25L16.7499 12.25V16.875C16.8124 19.0625 15.0624 20.6875 13.0624 20.6875ZM4.9999 17.25C4.5624 16.5 4.3749 15.625 4.5624 14.75C4.5624 14.75 4.6249 14.8125 4.6874 14.8125L8.6874 17.125C8.8124 17.1875 8.8749 17.1875 8.9999 17.1875C9.1249 17.1875 9.2499 17.1875 9.3124 17.125L14.1874 14.3125V16.25L10.1249 18.625C9.2499 19.125 8.2499 19.25 7.3124 19C6.3124 18.75 5.4999 18.125 4.9999 17.25ZM3.9374 8.5625C4.3749 7.8125 5.0624 7.25 5.8749 6.9375V7.0625V11.6875C5.8749 11.8125 5.8749 11.9375 5.9374 12C5.9999 12.125 6.0624 12.1875 6.1874 12.25L11.0624 15.0625L9.3749 16.0625L5.3749 13.75C4.4999 13.25 3.8749 12.4375 3.6249 11.5C3.3749 10.5625 3.4374 9.4375 3.9374 8.5625ZM17.7499 11.75L12.8749 8.9375L14.5624 7.9375L18.5624 10.25C19.1874 10.625 19.6874 11.125 19.9999 11.75C20.3124 12.375 20.4999 13.0625 20.4374 13.8125C20.3749 14.5 20.1249 15.1875 19.6874 15.75C19.2499 16.3125 18.6874 16.75 17.9999 17V12.25C17.9999 12.125 17.9999 12 17.9374 11.9375C17.9374 11.9375 17.8749 11.8125 17.7499 11.75ZM19.4374 9.25C19.4374 9.25 19.3749 9.1875 19.3124 9.1875L15.3124 6.875C15.1874 6.8125 15.1249 6.8125 14.9999 6.8125C14.8749 6.8125 14.7499 6.8125 14.6874 6.875L9.8124 9.6875V7.75L13.8749 5.375C14.4999 5 15.1874 4.875 15.9374 4.875C16.6249 4.875 17.3124 5.125 17.9374 5.5625C18.4999 6 18.9999 6.5625 19.2499 7.1875C19.4999 7.8125 19.5624 8.5625 19.4374 9.25ZM8.9374 12.75L7.2499 11.75V7.0625C7.2499 6.375 7.4374 5.625 7.8124 5.0625C8.1874 4.4375 8.7499 4 9.3749 3.6875C9.9999 3.375 10.7499 3.25 11.4374 3.375C12.1249 3.4375 12.8124 3.75 13.3749 4.1875C13.3749 4.1875 13.3124 4.25 13.2499 4.25L9.2499 6.5625C9.1249 6.625 9.0624 6.6875 8.9999 6.8125C8.9374 6.9375 8.9374 7 8.9374 7.125V12.75ZM9.8124 10.75L11.9999 9.5L14.1874 10.75V13.25L11.9999 14.5L9.8124 13.25V10.75Z"
  }));
},
    nA = function nA(_ref2379) {
  var _ref2379$color = _ref2379.color,
      C = _ref2379$color === void 0 ? "currentColor" : _ref2379$color,
      _ref2379$size = _ref2379.size,
      e = _ref2379$size === void 0 ? 24 : _ref2379$size,
      l = _ref2379.className,
      i = _objectWithoutProperties(_ref2379, _excluded2379);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11 4C11.6487 4 12.2498 4.20569 12.7411 4.55646C11.4486 5.22914 10.2602 6.07623 8.99996 6.80385L9.99996 8.5359C11.575 7.62654 13.0517 6.48541 14.7608 5.83037C16.1134 5.31198 17.681 5.83976 18.4282 7.13398C18.7526 7.69582 18.8749 8.31917 18.8168 8.92006C17.588 8.13708 16.2602 7.53146 15 6.80385L14 8.5359C15.575 9.44525 17.3016 10.1536 18.7234 11.3061C19.8487 12.2183 20.1754 13.8398 19.4282 15.134C19.1037 15.696 18.6249 16.1137 18.0752 16.3638C18.1385 14.9081 18 13.4553 18 12H16C16 13.8184 16.2498 15.6685 15.9626 17.4758C15.7353 18.9063 14.4944 20 13 20C12.351 20 11.7498 19.7942 11.2584 19.4432C12.5508 18.7701 13.7396 17.9238 15 17.1962L14 15.4641C12.4252 16.3733 10.9478 17.5147 9.23912 18.1696C7.88657 18.688 6.31898 18.1602 5.57176 16.866C5.24729 16.304 5.12493 15.6805 5.18316 15.0794C6.41224 15.8621 7.73964 16.4685 8.99997 17.1962L9.99997 15.4641C8.42517 14.5549 6.69801 13.8462 5.27649 12.6939C4.15128 11.7817 3.82455 10.1602 4.57176 8.86602C4.89624 8.30402 5.37506 7.88628 5.9247 7.63618C5.86145 9.09192 5.99997 10.5447 5.99997 12H7.99997C7.99997 10.1816 7.75013 8.33148 8.03733 6.52422C8.26467 5.09369 9.50554 4 11 4ZM14.7925 3.74171C13.8765 2.67659 12.5176 2 11 2C8.7782 2 6.89621 3.44833 6.24435 5.45243C4.86393 5.71314 3.59851 6.55175 2.83971 7.86602C1.72883 9.79013 2.04213 12.1442 3.4518 13.7107C2.98737 15.0366 3.08092 16.5518 3.83971 17.866C4.95059 19.7901 7.14589 20.6958 9.20742 20.2583C10.1234 21.3234 11.4824 22 13 22C15.2217 22 17.1037 20.5517 17.7556 18.5476C19.136 18.2869 20.4014 17.4482 21.1602 16.134C22.2711 14.2099 21.9578 11.8559 20.5481 10.2893C21.0126 8.96345 20.919 7.44825 20.1602 6.13398C19.0493 4.20987 16.854 3.30419 14.7925 3.74171Z"
  }));
},
    mA = function mA(_ref2380) {
  var _ref2380$color = _ref2380.color,
      C = _ref2380$color === void 0 ? "currentColor" : _ref2380$color,
      _ref2380$size = _ref2380.size,
      e = _ref2380$size === void 0 ? 24 : _ref2380$size,
      l = _ref2380.className,
      i = _objectWithoutProperties(_ref2380, _excluded2380);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15.2459 18H8.75407L7.15407 22H5L11 7H13L19 22H16.8459L15.2459 18ZM14.4459 16L12 9.88516L9.55407 16H14.4459ZM4 3H20V5H4V3Z"
  }));
},
    wA = function wA(_ref2381) {
  var _ref2381$color = _ref2381.color,
      C = _ref2381$color === void 0 ? "currentColor" : _ref2381$color,
      _ref2381$size = _ref2381.size,
      e = _ref2381$size === void 0 ? 24 : _ref2381$size,
      l = _ref2381.className,
      i = _objectWithoutProperties(_ref2381, _excluded2381);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 5C20 6.65685 18.6569 8 17 8C15.3431 8 14 6.65685 14 5C14 3.34315 15.3431 2 17 2C18.6569 2 20 3.34315 20 5ZM7 3C4.79086 3 3 4.79086 3 7V9H5V7C5 5.89543 5.89543 5 7 5H10V3H7ZM17 21C19.2091 21 21 19.2091 21 17V15H19V17C19 18.1046 18.1046 19 17 19H14V21H17ZM7 16C8.65685 16 10 14.6569 10 13C10 11.3431 8.65685 10 7 10C5.34315 10 4 11.3431 4 13C4 14.6569 5.34315 16 7 16ZM17 9C14.7909 9 13 10.7909 13 13H21C21 10.7909 19.2091 9 17 9ZM3 21C3 18.7909 4.79086 17 7 17C9.20914 17 11 18.7909 11 21H3Z"
  }));
},
    LA = function LA(_ref2382) {
  var _ref2382$color = _ref2382.color,
      C = _ref2382$color === void 0 ? "currentColor" : _ref2382$color,
      _ref2382$size = _ref2382.size,
      e = _ref2382$size === void 0 ? 24 : _ref2382$size,
      l = _ref2382.className,
      i = _objectWithoutProperties(_ref2382, _excluded2382);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17 6C16.4477 6 16 5.55228 16 5C16 4.44772 16.4477 4 17 4C17.5523 4 18 4.44772 18 5C18 5.55228 17.5523 6 17 6ZM17 8C18.6569 8 20 6.65685 20 5C20 3.34315 18.6569 2 17 2C15.3431 2 14 3.34315 14 5C14 6.65685 15.3431 8 17 8ZM7 3C4.79086 3 3 4.79086 3 7V9H5V7C5 5.89543 5.89543 5 7 5H10V3H7ZM17 21C19.2091 21 21 19.2091 21 17V15H19V17C19 18.1046 18.1046 19 17 19H14V21H17ZM8 13C8 12.4477 7.55228 12 7 12C6.44772 12 6 12.4477 6 13C6 13.5523 6.44772 14 7 14C7.55228 14 8 13.5523 8 13ZM10 13C10 14.6569 8.65685 16 7 16C5.34315 16 4 14.6569 4 13C4 11.3431 5.34315 10 7 10C8.65685 10 10 11.3431 10 13ZM17 11C15.8954 11 15 11.8954 15 13H13C13 10.7909 14.7909 9 17 9C19.2091 9 21 10.7909 21 13H19C19 11.8954 18.1046 11 17 11ZM5 21C5 19.8954 5.89543 19 7 19C8.10457 19 9 19.8954 9 21H11C11 18.7909 9.20914 17 7 17C4.79086 17 3 18.7909 3 21H5Z"
  }));
},
    hA = function hA(_ref2383) {
  var _ref2383$color = _ref2383.color,
      C = _ref2383$color === void 0 ? "currentColor" : _ref2383$color,
      _ref2383$size = _ref2383.size,
      e = _ref2383$size === void 0 ? 24 : _ref2383$size,
      l = _ref2383.className,
      i = _objectWithoutProperties(_ref2383, _excluded2383);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8 4C8 5.10457 7.10457 6 6 6 4.89543 6 4 5.10457 4 4 4 2.89543 4.89543 2 6 2 7.10457 2 8 2.89543 8 4ZM5 16V22H3V10C3 8.34315 4.34315 7 6 7 6.82059 7 7.56423 7.32946 8.10585 7.86333L10.4803 10.1057 12.7931 7.79289 14.2073 9.20711 10.5201 12.8943 9 11.4587V22H7V16H5ZM10 5H19V14H10V16H14.3654L17.1889 22H19.3993L16.5758 16H20C20.5523 16 21 15.5523 21 15V4C21 3.44772 20.5523 3 20 3H10V5Z"
  }));
},
    HA = function HA(_ref2384) {
  var _ref2384$color = _ref2384.color,
      C = _ref2384$color === void 0 ? "currentColor" : _ref2384$color,
      _ref2384$size = _ref2384.size,
      e = _ref2384$size === void 0 ? 24 : _ref2384$size,
      l = _ref2384.className,
      i = _objectWithoutProperties(_ref2384, _excluded2384);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8 4C8 5.10457 7.10457 6 6 6 4.89543 6 4 5.10457 4 4 4 2.89543 4.89543 2 6 2 7.10457 2 8 2.89543 8 4ZM5 16V22H3V10C3 8.34315 4.34315 7 6 7 6.82059 7 7.56423 7.32946 8.10585 7.86333L10.4803 10.1057 12.7931 7.79289 14.2073 9.20711 10.5201 12.8943 9 11.4587V22H7V16H5ZM6 9C5.44772 9 5 9.44772 5 10V14H7V10C7 9.44772 6.55228 9 6 9ZM19 5H10V3H20C20.5523 3 21 3.44772 21 4V15C21 15.5523 20.5523 16 20 16H16.5758L19.3993 22H17.1889L14.3654 16H10V14H19V5Z"
  }));
},
    VA = function VA(_ref2385) {
  var _ref2385$color = _ref2385.color,
      C = _ref2385$color === void 0 ? "currentColor" : _ref2385$color,
      _ref2385$size = _ref2385.size,
      e = _ref2385$size === void 0 ? 24 : _ref2385$size,
      l = _ref2385.className,
      i = _objectWithoutProperties(_ref2385, _excluded2385);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C17.5228 2 22 6.47715 22 12 22 17.5228 17.5228 22 12 22 6.47715 22 2 17.5228 2 12H4C4 16.4183 7.58172 20 12 20 16.4183 20 20 16.4183 20 12 20 7.58172 16.4183 4 12 4 9.53614 4 7.33243 5.11383 5.86492 6.86543L8 9H2V3L4.44656 5.44648C6.28002 3.33509 8.9841 2 12 2ZM14.5 8.25C13.1193 8.25 12 9.36929 12 10.75V13.25C12 14.6307 13.1193 15.75 14.5 15.75 15.8807 15.75 17 14.6307 17 13.25V10.75C17 9.36929 15.8807 8.25 14.5 8.25ZM15.5 10.75V13.25C15.5 13.8023 15.0523 14.25 14.5 14.25 13.9477 14.25 13.5 13.8023 13.5 13.25V10.75C13.5 10.1977 13.9477 9.75 14.5 9.75 15.0523 9.75 15.5 10.1977 15.5 10.75ZM10 8.5H8.5V15.5H10V8.5Z"
  }));
},
    gA = function gA(_ref2386) {
  var _ref2386$color = _ref2386.color,
      C = _ref2386$color === void 0 ? "currentColor" : _ref2386$color,
      _ref2386$size = _ref2386.size,
      e = _ref2386$size === void 0 ? 24 : _ref2386$size,
      l = _ref2386.className,
      i = _objectWithoutProperties(_ref2386, _excluded2386);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C17.5228 2 22 6.47715 22 12 22 17.5228 17.5228 22 12 22 6.47715 22 2 17.5228 2 12H4C4 16.4183 7.58172 20 12 20 16.4183 20 20 16.4183 20 12 20 7.58172 16.4183 4 12 4 9.25022 4 6.82447 5.38734 5.38451 7.50024L8 7.5V9.5H2V3.5H4L3.99989 5.99918C5.82434 3.57075 8.72873 2 12 2ZM15.5 13.25C15.5 13.8023 15.0523 14.25 14.5 14.25 13.9477 14.25 13.5 13.8023 13.5 13.25V10.75C13.5 10.1977 13.9477 9.75 14.5 9.75 15.0523 9.75 15.5 10.1977 15.5 10.75V13.25ZM14.5 8.25C13.1193 8.25 12 9.36929 12 10.75V13.25C12 14.6307 13.1193 15.75 14.5 15.75 15.8807 15.75 17 14.6307 17 13.25V10.75C17 9.36929 15.8807 8.25 14.5 8.25ZM8.5 15.5V8.5H10V15.5H8.5Z"
  }));
},
    MA = function MA(_ref2387) {
  var _ref2387$color = _ref2387.color,
      C = _ref2387$color === void 0 ? "currentColor" : _ref2387$color,
      _ref2387$size = _ref2387.size,
      e = _ref2387$size === void 0 ? 24 : _ref2387$size,
      l = _ref2387.className,
      i = _objectWithoutProperties(_ref2387, _excluded2387);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C17.5228 2 22 6.47715 22 12 22 17.5228 17.5228 22 12 22 6.47715 22 2 17.5228 2 12H4C4 16.4183 7.58172 20 12 20 16.4183 20 20 16.4183 20 12 20 7.58172 16.4183 4 12 4 9.53614 4 7.33243 5.11383 5.86492 6.86543L8 9H2V3L4.44656 5.44648C6.28002 3.33509 8.9841 2 12 2ZM8.5 8.5H10V15.5H8.5V8.5ZM16.75 8.5H12V12.75H14.875C15.2202 12.75 15.5 13.0298 15.5 13.375 15.5 13.7202 15.2202 14 14.875 14H12V15.5H14.875C16.0486 15.5 17 14.5486 17 13.375 17 12.2014 16.0486 11.25 14.875 11.25H13.5V10H16.75V8.5Z"
  }));
},
    ZA = function ZA(_ref2388) {
  var _ref2388$color = _ref2388.color,
      C = _ref2388$color === void 0 ? "currentColor" : _ref2388$color,
      _ref2388$size = _ref2388.size,
      e = _ref2388$size === void 0 ? 24 : _ref2388$size,
      l = _ref2388.className,
      i = _objectWithoutProperties(_ref2388, _excluded2388);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C17.5228 2 22 6.47715 22 12 22 17.5228 17.5228 22 12 22 6.47715 22 2 17.5228 2 12H4C4 16.4183 7.58172 20 12 20 16.4183 20 20 16.4183 20 12 20 7.58172 16.4183 4 12 4 9.25022 4 6.82447 5.38734 5.38451 7.50024L8 7.5V9.5H2V3.5H4L3.99989 5.99918C5.82434 3.57075 8.72873 2 12 2ZM8.5 15.5V8.5H10V15.5H8.5ZM12 8.5H16.75V10H13.5V11.25H14.875C16.0486 11.25 17 12.2014 17 13.375 17 14.5486 16.0486 15.5 14.875 15.5H12V14H14.875C15.2202 14 15.5 13.7202 15.5 13.375 15.5 13.0298 15.2202 12.75 14.875 12.75H12V8.5Z"
  }));
},
    xA = function xA(_ref2389) {
  var _ref2389$color = _ref2389.color,
      C = _ref2389$color === void 0 ? "currentColor" : _ref2389$color,
      _ref2389$size = _ref2389.size,
      e = _ref2389$size === void 0 ? 24 : _ref2389$size,
      l = _ref2389.className,
      i = _objectWithoutProperties(_ref2389, _excluded2389);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22 12C22 6.47715 17.5228 2 12 2 8.9841 2 6.28002 3.33509 4.44656 5.44648L2 3V9H6.75V10H9.37481C9.71999 10 9.99981 10.2798 9.99981 10.625 9.99981 10.9702 9.71999 11.25 9.37481 11.25H7.5V12.75H9.37481C9.71999 12.75 9.99981 13.0298 9.99981 13.375 9.99981 13.7202 9.71999 14 9.37481 14H6.75V15.5H9.37481C10.5484 15.5 11.4998 14.5486 11.4998 13.375 11.4998 12.8506 11.3099 12.3706 10.9951 12 11.3099 11.6294 11.4998 11.1494 11.4998 10.625 11.4998 9.4514 10.5484 8.5 9.37481 8.5H7.49988L5.86492 6.86543C7.33243 5.11383 9.53614 4 12 4 16.4183 4 20 7.58172 20 12 20 16.4183 16.4183 20 12 20 7.58172 20 4 16.4183 4 12H2C2 17.5228 6.47715 22 12 22 17.5228 22 22 17.5228 22 12ZM12.5 10.75C12.5 9.36929 13.6193 8.25 15 8.25 16.3807 8.25 17.5 9.36929 17.5 10.75V13.25C17.5 14.6307 16.3807 15.75 15 15.75 13.6193 15.75 12.5 14.6307 12.5 13.25V10.75ZM15 9.75C14.4477 9.75 14 10.1977 14 10.75V13.25C14 13.8023 14.4477 14.25 15 14.25 15.5523 14.25 16 13.8023 16 13.25V10.75C16 10.1977 15.5523 9.75 15 9.75Z"
  }));
},
    vA = function vA(_ref2390) {
  var _ref2390$color = _ref2390.color,
      C = _ref2390$color === void 0 ? "currentColor" : _ref2390$color,
      _ref2390$size = _ref2390.size,
      e = _ref2390$size === void 0 ? 24 : _ref2390$size,
      l = _ref2390.className,
      i = _objectWithoutProperties(_ref2390, _excluded2390);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22 12C22 6.47715 17.5228 2 12 2 8.72873 2 5.82434 3.57075 3.99989 5.99918L4 3.5H2V9.5H6.75V10H9.37481C9.71999 10 9.99981 10.2798 9.99981 10.625 9.99981 10.9702 9.71999 11.25 9.37481 11.25H7.5V12.75H9.37481C9.71999 12.75 9.99981 13.0298 9.99981 13.375 9.99981 13.7202 9.71999 14 9.37481 14H6.75V15.5H9.37481C10.5484 15.5 11.4998 14.5486 11.4998 13.375 11.4998 12.8506 11.3099 12.3706 10.9951 12 11.3099 11.6294 11.4998 11.1494 11.4998 10.625 11.4998 9.4514 10.5484 8.5 9.37481 8.5H8V7.5L5.38451 7.50024C6.82447 5.38734 9.25022 4 12 4 16.4183 4 20 7.58172 20 12 20 16.4183 16.4183 20 12 20 7.58172 20 4 16.4183 4 12H2C2 17.5228 6.47715 22 12 22 17.5228 22 22 17.5228 22 12ZM12.5 10.75C12.5 9.36929 13.6193 8.25 15 8.25 16.3807 8.25 17.5 9.36929 17.5 10.75V13.25C17.5 14.6307 16.3807 15.75 15 15.75 13.6193 15.75 12.5 14.6307 12.5 13.25V10.75ZM15 9.75C14.4477 9.75 14 10.1977 14 10.75V13.25C14 13.8023 14.4477 14.25 15 14.25 15.5523 14.25 16 13.8023 16 13.25V10.75C16 10.1977 15.5523 9.75 15 9.75Z"
  }));
},
    dA = function dA(_ref2391) {
  var _ref2391$color = _ref2391.color,
      C = _ref2391$color === void 0 ? "currentColor" : _ref2391$color,
      _ref2391$size = _ref2391.size,
      e = _ref2391$size === void 0 ? 24 : _ref2391$size,
      l = _ref2391.className,
      i = _objectWithoutProperties(_ref2391, _excluded2391);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22 12C22 6.47715 17.5228 2 12 2 8.9841 2 6.28002 3.33509 4.44656 5.44648L2 3V9H8L5.86492 6.86543C7.33243 5.11383 9.53614 4 12 4 16.4183 4 20 7.58172 20 12 20 16.4183 16.4183 20 12 20 7.58172 20 4 16.4183 4 12H2C2 17.5228 6.47715 22 12 22 17.5228 22 22 17.5228 22 12ZM14.5 10V8.5H9.5V12.75H12.625C12.9702 12.75 13.25 13.0298 13.25 13.375 13.25 13.7202 12.9702 14 12.625 14H9.5V15.5H12.625C13.7986 15.5 14.75 14.5486 14.75 13.375 14.75 12.2014 13.7986 11.25 12.625 11.25H11V10H14.5Z"
  }));
},
    pA = function pA(_ref2392) {
  var _ref2392$color = _ref2392.color,
      C = _ref2392$color === void 0 ? "currentColor" : _ref2392$color,
      _ref2392$size = _ref2392.size,
      e = _ref2392$size === void 0 ? 24 : _ref2392$size,
      l = _ref2392.className,
      i = _objectWithoutProperties(_ref2392, _excluded2392);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C17.5228 2 22 6.47715 22 12 22 17.5228 17.5228 22 12 22 6.47715 22 2 17.5228 2 12H4C4 16.4183 7.58172 20 12 20 16.4183 20 20 16.4183 20 12 20 7.58172 16.4183 4 12 4 9.25022 4 6.82447 5.38734 5.38451 7.50024L8 7.5V9.5H2V3.5H4L3.99989 5.99918C5.82434 3.57075 8.72873 2 12 2ZM9.5 8.5H14.5V10H11V11.25H12.625C13.7986 11.25 14.75 12.2014 14.75 13.375 14.75 14.5486 13.7986 15.5 12.625 15.5H9.5V14H12.625C12.9702 14 13.25 13.7202 13.25 13.375 13.25 13.0298 12.9702 12.75 12.625 12.75H9.5V8.5Z"
  }));
},
    EA = function EA(_ref2393) {
  var _ref2393$color = _ref2393.color,
      C = _ref2393$color === void 0 ? "currentColor" : _ref2393$color,
      _ref2393$size = _ref2393.size,
      e = _ref2393$size === void 0 ? 24 : _ref2393$size,
      l = _ref2393.className,
      i = _objectWithoutProperties(_ref2393, _excluded2393);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M23 18.9999H22V8.99991H18V6.58569L12 0.585693L6 6.58569V8.99991H2V18.9999H1V20.9999H23V18.9999ZM6 19H4V11H6V19ZM18 11H20V19H18V11ZM11 12H13V19H11V12Z"
  }));
},
    NA = function NA(_ref2394) {
  var _ref2394$color = _ref2394.color,
      C = _ref2394$color === void 0 ? "currentColor" : _ref2394$color,
      _ref2394$size = _ref2394.size,
      e = _ref2394$size === void 0 ? 24 : _ref2394$size,
      l = _ref2394.className,
      i = _objectWithoutProperties(_ref2394, _excluded2394);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 0.585693L18 6.58569V9H22V19H23V21H1V19H2V9H6V6.58569L12 0.585693ZM18 19H20V11H18V19ZM6 11H4V19H6V11ZM8 7.41412V18.9999H11V12H13V18.9999H16V7.41412L12 3.41412L8 7.41412Z"
  }));
},
    uA = function uA(_ref2395) {
  var _ref2395$color = _ref2395.color,
      C = _ref2395$color === void 0 ? "currentColor" : _ref2395$color,
      _ref2395$size = _ref2395.size,
      e = _ref2395$size === void 0 ? 24 : _ref2395$size,
      l = _ref2395.className,
      i = _objectWithoutProperties(_ref2395, _excluded2395);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 0.5L16 8L23.5 12L16 16L12 23.5L8 16L0.5 12L8 8L12 0.5Z"
  }));
},
    BA = function BA(_ref2396) {
  var _ref2396$color = _ref2396.color,
      C = _ref2396$color === void 0 ? "currentColor" : _ref2396$color,
      _ref2396$size = _ref2396.size,
      e = _ref2396$size === void 0 ? 24 : _ref2396$size,
      l = _ref2396.className,
      i = _objectWithoutProperties(_ref2396, _excluded2396);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16 8L23.5 12L16 16L12 23.5L8 16L0.5 12L8 8L12 0.5L16 8ZM19.25 12L14.5217 9.47826L12 4.75L9.47826 9.47826L4.75 12L9.47826 14.5217L12 19.25L14.5217 14.5217L19.25 12Z"
  }));
},
    fA = function fA(_ref2397) {
  var _ref2397$color = _ref2397.color,
      C = _ref2397$color === void 0 ? "currentColor" : _ref2397$color,
      _ref2397$size = _ref2397.size,
      e = _ref2397$size === void 0 ? 24 : _ref2397$size,
      l = _ref2397.className,
      i = _objectWithoutProperties(_ref2397, _excluded2397);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M1 11C6.52285 11 11 6.52285 11 1H13C13 6.52285 17.4772 11 23 11V13C17.4772 13 13 17.4772 13 23H11C11 17.4772 6.52285 13 1 13V11Z"
  }));
},
    RA = function RA(_ref2398) {
  var _ref2398$color = _ref2398.color,
      C = _ref2398$color === void 0 ? "currentColor" : _ref2398$color,
      _ref2398$size = _ref2398.size,
      e = _ref2398$size === void 0 ? 24 : _ref2398$size,
      l = _ref2398.className,
      i = _objectWithoutProperties(_ref2398, _excluded2398);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M1 11C6.52285 11 11 6.52285 11 1H13C13 6.52285 17.4772 11 23 11V13C17.4772 13 13 17.4772 13 23H11C11 17.4772 6.52285 13 1 13V11ZM5.80342 12C8.56895 13.2093 10.7907 15.431 12 18.1966C13.2093 15.431 15.431 13.2093 18.1966 12C15.431 10.7907 13.2093 8.56895 12 5.80342C10.7907 8.56895 8.56895 10.7907 5.80342 12Z"
  }));
},
    zA = function zA(_ref2399) {
  var _ref2399$color = _ref2399.color,
      C = _ref2399$color === void 0 ? "currentColor" : _ref2399$color,
      _ref2399$size = _ref2399.size,
      e = _ref2399$size === void 0 ? 24 : _ref2399$size,
      l = _ref2399.className,
      i = _objectWithoutProperties(_ref2399, _excluded2399);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10.0357 7.69802C8.38492 9.55932 6.5134 12.2442 4.89465 15.4817C4.64766 15.9757 4.04698 16.1759 3.55301 15.9289C3.05903 15.6819 2.8588 15.0812 3.10579 14.5873C4.79739 11.2041 6.76494 8.37171 8.53943 6.37095C9.4251 5.37234 10.2797 4.56162 11.0449 3.99131C11.4272 3.7063 11.8049 3.46806 12.1677 3.29756C12.5193 3.13234 12.921 3 13.3336 3C13.5496 3 13.7872 3.0535 14.007 3.19476C14.2233 3.33371 14.3629 3.51925 14.4495 3.69083C14.6066 4.00215 14.624 4.33473 14.6201 4.55938C14.6118 5.03651 14.4847 5.6328 14.3216 6.23975C13.9874 7.48318 13.3994 9.13104 12.8149 10.7577L12.7329 10.9858C12.1671 12.5598 11.6101 14.1093 11.248 15.3466C11.1505 15.68 11.0706 15.9792 11.0094 16.2414C11.7035 15.6835 12.5581 14.8454 13.466 13.9534L13.4956 13.9243C14.3772 13.0581 15.3098 12.1418 16.0967 11.5127C16.4872 11.2006 16.9082 10.904 17.3138 10.7322C17.6544 10.5878 18.4343 10.3532 19.0407 10.9596C19.4251 11.344 19.5318 11.8438 19.5594 12.2164C19.5883 12.6064 19.5429 13.0267 19.4725 13.4261C19.3315 14.2258 19.0483 15.159 18.7894 16.0009L18.7478 16.136C18.5165 16.8874 18.3102 17.5577 18.1926 18.0965C18.4529 17.8352 18.7734 17.4216 19.1475 16.811C19.436 16.34 20.0517 16.1921 20.5226 16.4806C20.9935 16.7691 21.1414 17.3848 20.8529 17.8557C20.3099 18.7422 19.748 19.4622 19.1519 19.9092C18.5283 20.377 17.7121 20.6407 16.8863 20.2278C16.2779 19.9235 16.1398 19.3173 16.1091 18.9819C16.0759 18.6192 16.1284 18.2233 16.1979 17.8667C16.3288 17.1944 16.5829 16.3698 16.823 15.5907L16.8777 15.4129C17.1447 14.5451 17.3873 13.734 17.5028 13.0789C17.5117 13.0284 17.5196 12.9802 17.5266 12.9341C17.4697 12.977 17.4094 13.0239 17.3455 13.0749C16.6477 13.6328 15.785 14.4788 14.8677 15.38L14.8381 15.4091C13.9566 16.2752 13.024 17.1915 12.2371 17.8206C11.8466 18.1328 11.4255 18.4293 11.02 18.6012C10.6794 18.7455 9.89947 18.9801 9.29311 18.3738C8.9843 18.065 8.9052 17.6753 8.87972 17.4382C8.8515 17.1755 8.86901 16.8971 8.90269 16.6351C8.9706 16.1069 9.12934 15.4656 9.32855 14.7849C9.70829 13.4872 10.2842 11.8852 10.8411 10.3362L10.9327 10.0814C11.5263 8.42931 12.082 6.8674 12.3901 5.72074C12.4172 5.61968 12.4418 5.52435 12.4638 5.43468C12.3924 5.48361 12.3178 5.53695 12.2401 5.59489C11.6173 6.05907 10.8627 6.76559 10.0357 7.69802Z"
  }));
},
    FA = function FA(_ref2400) {
  var _ref2400$color = _ref2400.color,
      C = _ref2400$color === void 0 ? "currentColor" : _ref2400$color,
      _ref2400$size = _ref2400.size,
      e = _ref2400$size === void 0 ? 24 : _ref2400$size,
      l = _ref2400.className,
      i = _objectWithoutProperties(_ref2400, _excluded2400);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18 17 6 17 6 15 18 15 18 17ZM12 13 18 7H6L12 13Z"
  }));
},
    SA = function SA(_ref2401) {
  var _ref2401$color = _ref2401.color,
      C = _ref2401$color === void 0 ? "currentColor" : _ref2401$color,
      _ref2401$size = _ref2401.size,
      e = _ref2401$size === void 0 ? 24 : _ref2401$size,
      l = _ref2401.className,
      i = _objectWithoutProperties(_ref2401, _excluded2401);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 10.0858L7.20711 5.29291L5.79289 6.70712L12 12.9142L18.2071 6.70712L16.7929 5.29291L12 10.0858ZM18 17L6 17L6 15L18 15V17Z"
  }));
},
    AA = function AA(_ref2402) {
  var _ref2402$color = _ref2402.color,
      C = _ref2402$color === void 0 ? "currentColor" : _ref2402$color,
      _ref2402$size = _ref2402.size,
      e = _ref2402$size === void 0 ? 24 : _ref2402$size,
      l = _ref2402.className,
      i = _objectWithoutProperties(_ref2402, _excluded2402);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7 18V6H9V18H7ZM11 12 17 6V18L11 12Z"
  }));
},
    kA = function kA(_ref2403) {
  var _ref2403$color = _ref2403.color,
      C = _ref2403$color === void 0 ? "currentColor" : _ref2403$color,
      _ref2403$size = _ref2403.size,
      e = _ref2403$size === void 0 ? 24 : _ref2403$size,
      l = _ref2403.className,
      i = _objectWithoutProperties(_ref2403, _excluded2403);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13.9142 12L18.7071 7.20712L17.2929 5.79291L11.0858 12L17.2929 18.2071L18.7071 16.7929L13.9142 12ZM7 18V6.00001H9V18H7Z"
  }));
},
    PA = function PA(_ref2404) {
  var _ref2404$color = _ref2404.color,
      C = _ref2404$color === void 0 ? "currentColor" : _ref2404$color,
      _ref2404$size = _ref2404.size,
      e = _ref2404$size === void 0 ? 24 : _ref2404$size,
      l = _ref2404.className,
      i = _objectWithoutProperties(_ref2404, _excluded2404);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17 6 17 18H15L15 6 17 6ZM13 12 7 18V6L13 12Z"
  }));
},
    DA = function DA(_ref2405) {
  var _ref2405$color = _ref2405.color,
      C = _ref2405$color === void 0 ? "currentColor" : _ref2405$color,
      _ref2405$size = _ref2405.size,
      e = _ref2405$size === void 0 ? 24 : _ref2405$size,
      l = _ref2405.className,
      i = _objectWithoutProperties(_ref2405, _excluded2405);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10.0858 12L5.29289 16.7929L6.70711 18.2071L12.9142 12L6.70711 5.79291L5.29289 7.20712L10.0858 12ZM17 6.00002L17 18H15L15 6.00002L17 6.00002Z"
  }));
},
    yA = function yA(_ref2406) {
  var _ref2406$color = _ref2406.color,
      C = _ref2406$color === void 0 ? "currentColor" : _ref2406$color,
      _ref2406$size = _ref2406.size,
      e = _ref2406$size === void 0 ? 24 : _ref2406$size,
      l = _ref2406.className,
      i = _objectWithoutProperties(_ref2406, _excluded2406);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6 7 18 7V9L6 9 6 7ZM12 11 6 17H18L12 11Z"
  }));
},
    bA = function bA(_ref2407) {
  var _ref2407$color = _ref2407.color,
      C = _ref2407$color === void 0 ? "currentColor" : _ref2407$color,
      _ref2407$size = _ref2407.size,
      e = _ref2407$size === void 0 ? 24 : _ref2407$size,
      l = _ref2407.className,
      i = _objectWithoutProperties(_ref2407, _excluded2407);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 13.9142L16.7929 18.7071L18.2071 17.2929L12 11.0858L5.79289 17.2929L7.20711 18.7071L12 13.9142ZM6 7L18 7V9L6 9L6 7Z"
  }));
},
    TA = function TA(_ref2408) {
  var _ref2408$color = _ref2408.color,
      C = _ref2408$color === void 0 ? "currentColor" : _ref2408$color,
      _ref2408$size = _ref2408.size,
      e = _ref2408$size === void 0 ? 24 : _ref2408$size,
      l = _ref2408.className,
      i = _objectWithoutProperties(_ref2408, _excluded2408);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 13C4 15.2091 4.89543 17.2091 6.34315 18.6569L4.92893 20.0711C3.11929 18.2614 2 15.7614 2 13 2 7.47715 6.47715 3 12 3 17.5228 3 22 7.47715 22 13 22 15.7614 20.8807 18.2614 19.0711 20.0711L17.6569 18.6569C19.1046 17.2091 20 15.2091 20 13 20 8.58172 16.4183 5 12 5 7.58172 5 4 8.58172 4 13ZM8.70703 8.29297 13.5 12.5 11.5 14.5 7.29282 9.70718 8.70703 8.29297Z"
  }));
},
    UA = function UA(_ref2409) {
  var _ref2409$color = _ref2409.color,
      C = _ref2409$color === void 0 ? "currentColor" : _ref2409$color,
      _ref2409$size = _ref2409.size,
      e = _ref2409$size === void 0 ? 24 : _ref2409$size,
      l = _ref2409.className,
      i = _objectWithoutProperties(_ref2409, _excluded2409);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 13C4 15.2091 4.89543 17.2091 6.34315 18.6569L4.92893 20.0711C3.11929 18.2614 2 15.7614 2 13 2 7.47715 6.47715 3 12 3 17.5228 3 22 7.47715 22 13 22 15.7614 20.8807 18.2614 19.0711 20.0711L17.6569 18.6569C19.1046 17.2091 20 15.2091 20 13 20 8.58172 16.4183 5 12 5 7.58172 5 4 8.58172 4 13ZM8.70703 8.29297 13.207 12.793 11.7928 14.2072 7.29282 9.70718 8.70703 8.29297Z"
  }));
},
    GA = function GA(_ref2410) {
  var _ref2410$color = _ref2410.color,
      C = _ref2410$color === void 0 ? "currentColor" : _ref2410$color,
      _ref2410$size = _ref2410.size,
      e = _ref2410$size === void 0 ? 24 : _ref2410$size,
      l = _ref2410.className,
      i = _objectWithoutProperties(_ref2410, _excluded2410);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17.0007 1.20825 18.3195 3.68108 20.7923 4.99992 18.3195 6.31876 17.0007 8.79159 15.6818 6.31876 13.209 4.99992 15.6818 3.68108 17.0007 1.20825ZM8.00065 4.33325 10.6673 9.33325 15.6673 11.9999 10.6673 14.6666 8.00065 19.6666 5.33398 14.6666.333984 11.9999 5.33398 9.33325 8.00065 4.33325ZM19.6673 16.3333 18.0007 13.2083 16.334 16.3333 13.209 17.9999 16.334 19.6666 18.0007 22.7916 19.6673 19.6666 22.7923 17.9999 19.6673 16.3333Z"
  }));
},
    IA = function IA(_ref2411) {
  var _ref2411$color = _ref2411.color,
      C = _ref2411$color === void 0 ? "currentColor" : _ref2411$color,
      _ref2411$size = _ref2411.size,
      e = _ref2411$size === void 0 ? 24 : _ref2411$size,
      l = _ref2411.className,
      i = _objectWithoutProperties(_ref2411, _excluded2411);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17.0007 1.20825 18.3195 3.68108 20.7923 4.99992 18.3195 6.31876 17.0007 8.79159 15.6818 6.31876 13.209 4.99992 15.6818 3.68108 17.0007 1.20825ZM10.6673 9.33325 15.6673 11.9999 10.6673 14.6666 8.00065 19.6666 5.33398 14.6666.333984 11.9999 5.33398 9.33325 8.00065 4.33325 10.6673 9.33325ZM11.4173 11.9999 9.18905 10.8115 8.00065 8.58325 6.81224 10.8115 4.58398 11.9999 6.81224 13.1883 8.00065 15.4166 9.18905 13.1883 11.4173 11.9999ZM19.6673 16.3333 18.0007 13.2083 16.334 16.3333 13.209 17.9999 16.334 19.6666 18.0007 22.7916 19.6673 19.6666 22.7923 17.9999 19.6673 16.3333Z"
  }));
},
    WA = function WA(_ref2412) {
  var _ref2412$color = _ref2412.color,
      C = _ref2412$color === void 0 ? "currentColor" : _ref2412$color,
      _ref2412$size = _ref2412.size,
      e = _ref2412$size === void 0 ? 24 : _ref2412$size,
      l = _ref2412.className,
      i = _objectWithoutProperties(_ref2412, _excluded2412);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14 4.4375C15.3462 4.4375 16.4375 3.34619 16.4375 2H17.5625C17.5625 3.34619 18.6538 4.4375 20 4.4375V5.5625C18.6538 5.5625 17.5625 6.65381 17.5625 8H16.4375C16.4375 6.65381 15.3462 5.5625 14 5.5625V4.4375ZM1 11C4.31371 11 7 8.31371 7 5H9C9 8.31371 11.6863 11 15 11V13C11.6863 13 9 15.6863 9 19H7C7 15.6863 4.31371 13 1 13V11ZM17.25 14C17.25 15.7949 15.7949 17.25 14 17.25V18.75C15.7949 18.75 17.25 20.2051 17.25 22H18.75C18.75 20.2051 20.2051 18.75 22 18.75V17.25C20.2051 17.25 18.75 15.7949 18.75 14H17.25Z"
  }));
},
    OA = function OA(_ref2413) {
  var _ref2413$color = _ref2413.color,
      C = _ref2413$color === void 0 ? "currentColor" : _ref2413$color,
      _ref2413$size = _ref2413.size,
      e = _ref2413$size === void 0 ? 24 : _ref2413$size,
      l = _ref2413.className,
      i = _objectWithoutProperties(_ref2413, _excluded2413);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14 4.4375C15.3462 4.4375 16.4375 3.34619 16.4375 2H17.5625C17.5625 3.34619 18.6538 4.4375 20 4.4375V5.5625C18.6538 5.5625 17.5625 6.65381 17.5625 8H16.4375C16.4375 6.65381 15.3462 5.5625 14 5.5625V4.4375ZM1 11C4.31371 11 7 8.31371 7 5H9C9 8.31371 11.6863 11 15 11V13C11.6863 13 9 15.6863 9 19H7C7 15.6863 4.31371 13 1 13V11ZM4.87601 12C6.18717 12.7276 7.27243 13.8128 8 15.124 8.72757 13.8128 9.81283 12.7276 11.124 12 9.81283 11.2724 8.72757 10.1872 8 8.87601 7.27243 10.1872 6.18717 11.2724 4.87601 12ZM17.25 14C17.25 15.7949 15.7949 17.25 14 17.25V18.75C15.7949 18.75 17.25 20.2051 17.25 22H18.75C18.75 20.2051 20.2051 18.75 22 18.75V17.25C20.2051 17.25 18.75 15.7949 18.75 14H17.25Z"
  }));
},
    KA = function KA(_ref2414) {
  var _ref2414$color = _ref2414.color,
      C = _ref2414$color === void 0 ? "currentColor" : _ref2414$color,
      _ref2414$size = _ref2414.size,
      e = _ref2414$size === void 0 ? 24 : _ref2414$size,
      l = _ref2414.className,
      i = _objectWithoutProperties(_ref2414, _excluded2414);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9 2C13.0675 2 16.426 5.03562 16.9337 8.96494L19.1842 12.5037C19.3324 12.7367 19.3025 13.0847 18.9593 13.2317L17 14.071V17C17 18.1046 16.1046 19 15 19H13.001L13 22H4L4.00025 18.3061C4.00033 17.1252 3.56351 16.0087 2.7555 15.0011 1.65707 13.6313 1 11.8924 1 10 1 5.58172 4.58172 2 9 2ZM21.1535 18.1024 19.4893 16.9929C20.4436 15.5642 21 13.8471 21 12.0001 21 10.153 20.4436 8.4359 19.4893 7.00722L21.1535 5.89771C22.32 7.64386 23 9.74254 23 12.0001 23 14.2576 22.32 16.3562 21.1535 18.1024Z"
  }));
},
    QA = function QA(_ref2415) {
  var _ref2415$color = _ref2415.color,
      C = _ref2415$color === void 0 ? "currentColor" : _ref2415$color,
      _ref2415$size = _ref2415.size,
      e = _ref2415$size === void 0 ? 24 : _ref2415$size,
      l = _ref2415.className,
      i = _objectWithoutProperties(_ref2415, _excluded2415);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16.9337 8.96494C16.426 5.03562 13.0675 2 9 2 4.58172 2 1 5.58172 1 10 1 11.8924 1.65707 13.6313 2.7555 15.0011 3.56351 16.0087 4.00033 17.1252 4.00025 18.3061L4 22H13L13.001 19H15C16.1046 19 17 18.1046 17 17V14.071L18.9593 13.2317C19.3025 13.0847 19.3324 12.7367 19.1842 12.5037L16.9337 8.96494ZM3 10C3 6.68629 5.68629 4 9 4 12.0243 4 14.5665 6.25141 14.9501 9.22118L15.0072 9.66262 16.5497 12.0881 15 12.7519V17H11.0017L11.0007 20H6.00013L6.00025 18.3063C6.00036 16.6672 5.40965 15.114 4.31578 13.7499 3.46818 12.6929 3 11.3849 3 10ZM21.1535 18.1024 19.4893 16.9929C20.4436 15.5642 21 13.8471 21 12.0001 21 10.153 20.4436 8.4359 19.4893 7.00722L21.1535 5.89771C22.32 7.64386 23 9.74254 23 12.0001 23 14.2576 22.32 16.3562 21.1535 18.1024Z"
  }));
},
    qA = function qA(_ref2416) {
  var _ref2416$color = _ref2416.color,
      C = _ref2416$color === void 0 ? "currentColor" : _ref2416$color,
      _ref2416$size = _ref2416.size,
      e = _ref2416$size === void 0 ? 24 : _ref2416$size,
      l = _ref2416.className,
      i = _objectWithoutProperties(_ref2416, _excluded2416);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 13C20 15.2091 19.1046 17.2091 17.6569 18.6569L19.0711 20.0711C20.8807 18.2614 22 15.7614 22 13 22 7.47715 17.5228 3 12 3 6.47715 3 2 7.47715 2 13 2 15.7614 3.11929 18.2614 4.92893 20.0711L6.34315 18.6569C4.89543 17.2091 4 15.2091 4 13 4 8.58172 7.58172 5 12 5 16.4183 5 20 8.58172 20 13ZM15.293 8.29297 10.5 12.5 12.5 14.5 16.7072 9.70718 15.293 8.29297Z"
  }));
},
    jA = function jA(_ref2417) {
  var _ref2417$color = _ref2417.color,
      C = _ref2417$color === void 0 ? "currentColor" : _ref2417$color,
      _ref2417$size = _ref2417.size,
      e = _ref2417$size === void 0 ? 24 : _ref2417$size,
      l = _ref2417.className,
      i = _objectWithoutProperties(_ref2417, _excluded2417);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 13C20 15.2091 19.1046 17.2091 17.6569 18.6569L19.0711 20.0711C20.8807 18.2614 22 15.7614 22 13 22 7.47715 17.5228 3 12 3 6.47715 3 2 7.47715 2 13 2 15.7614 3.11929 18.2614 4.92893 20.0711L6.34315 18.6569C4.89543 17.2091 4 15.2091 4 13 4 8.58172 7.58172 5 12 5 16.4183 5 20 8.58172 20 13ZM15.293 8.29297 10.793 12.793 12.2072 14.2072 16.7072 9.70718 15.293 8.29297Z"
  }));
},
    XA = function XA(_ref2418) {
  var _ref2418$color = _ref2418.color,
      C = _ref2418$color === void 0 ? "currentColor" : _ref2418$color,
      _ref2418$size = _ref2418.size,
      e = _ref2418$size === void 0 ? 24 : _ref2418$size,
      l = _ref2418.className,
      i = _objectWithoutProperties(_ref2418, _excluded2418);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16 8.24537V15.5C16 19.0899 13.0899 22 9.5 22C5.91015 22 3 19.0899 3 15.5C3 11.9101 5.91015 9 9.5 9C10.0163 9 10.5185 9.06019 11 9.17393V12.3368C10.5454 12.1208 10.0368 12 9.5 12C7.567 12 6 13.567 6 15.5C6 17.433 7.567 19 9.5 19C11.433 19 13 17.433 13 15.5V2H16C16 4.76142 18.2386 7 21 7V10C19.1081 10 17.3696 9.34328 16 8.24537Z"
  }));
},
    JA = function JA(_ref2419) {
  var _ref2419$color = _ref2419.color,
      C = _ref2419$color === void 0 ? "currentColor" : _ref2419$color,
      _ref2419$size = _ref2419.size,
      e = _ref2419$size === void 0 ? 24 : _ref2419$size,
      l = _ref2419.className,
      i = _objectWithoutProperties(_ref2419, _excluded2419);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11.0004 2V8.41396C10.5947 8.33909 10.1768 8.3 9.75039 8.3C5.96724 8.3 2.90039 11.3668 2.90039 15.15C2.90039 18.9332 5.96724 22 9.75039 22C13.5335 22 16.6004 18.9332 16.6004 15.15V11.4136C17.6366 11.8539 18.7662 12.1 20.0005 12.1H21.0005V6.5H20.0005C18.0966 6.5 16.6004 4.96259 16.6004 3V2H11.0004ZM13.0004 4H14.688C15.0818 6.22009 16.7673 7.99607 19.0005 8.4091V10.0282C17.9624 9.87602 17.0253 9.48645 16.1567 8.905L14.6004 7.86327V15.15C14.6004 17.8286 12.429 20 9.75039 20C7.07181 20 4.90039 17.8286 4.90039 15.15C4.90039 12.4714 7.07181 10.3 9.75039 10.3C9.83431 10.3 9.91769 10.3021 10.0005 10.3063V11.9095C9.91795 11.9032 9.83454 11.9 9.75039 11.9C7.95547 11.9 6.50039 13.3551 6.50039 15.15C6.50039 16.9449 7.95547 18.4 9.75039 18.4C11.5453 18.4 13.0004 16.9449 13.0004 15.15C13.0004 11.4334 12.9992 7.71665 13.0004 4ZM8.50039 15.15C8.50039 14.4596 9.06003 13.9 9.75039 13.9C10.4407 13.9 11.0004 14.4596 11.0004 15.15C11.0004 15.8404 10.4407 16.4 9.75039 16.4C9.06003 16.4 8.50039 15.8404 8.50039 15.15Z"
  }));
},
    YA = function YA(_ref2420) {
  var _ref2420$color = _ref2420.color,
      C = _ref2420$color === void 0 ? "currentColor" : _ref2420$color,
      _ref2420$size = _ref2420.size,
      e = _ref2420$size === void 0 ? 24 : _ref2420$size,
      l = _ref2420.className,
      i = _objectWithoutProperties(_ref2420, _excluded2420);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21.5 9C21.5 11.7039 19.849 14.0223 17.5 15.0018L17.5 15C17.5 10.3056 13.6944 6.5 9.00001 6.5L8.99817 6.5C9.97773 4.15105 12.2961 2.5 15 2.5C18.5899 2.5 21.5 5.41015 21.5 9ZM7 3C4.79086 3 3 4.79086 3 7V8.5H5V7C5 5.89543 5.89543 5 7 5H8.5V3H7ZM19 15.5V17C19 18.1046 18.1046 19 17 19H15.5V21H17C19.2091 21 21 19.2091 21 17V15.5H19ZM9 21.5C12.5899 21.5 15.5 18.5899 15.5 15C15.5 11.4101 12.5899 8.5 9 8.5C5.41015 8.5 2.5 11.4101 2.5 15C2.5 18.5899 5.41015 21.5 9 21.5ZM9 12.5L11.5 15L9 17.5L6.5 15L9 12.5Z"
  }));
},
    _A = function _A(_ref2421) {
  var _ref2421$color = _ref2421.color,
      C = _ref2421$color === void 0 ? "currentColor" : _ref2421$color,
      _ref2421$size = _ref2421.size,
      e = _ref2421$size === void 0 ? 24 : _ref2421$size,
      l = _ref2421.className,
      i = _objectWithoutProperties(_ref2421, _excluded2421);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9 12.5 6.5 15 9 17.5 11.5 15 9 12.5ZM15 2.5C11.5724 2.5 8.76444 5.15304 8.51763 8.51763 5.15304 8.76445 2.5 11.5724 2.5 15 2.5 18.5899 5.41015 21.5 9 21.5 12.4276 21.5 15.2356 18.847 15.4824 15.4824 18.847 15.2356 21.5 12.4276 21.5 9 21.5 5.41015 18.5899 2.5 15 2.5ZM15.3234 13.4886C14.7575 11.1126 12.8874 9.24245 10.5114 8.67665 10.6772 6.34229 12.6234 4.5 15 4.5 17.4853 4.5 19.5 6.51472 19.5 9 19.5 11.3766 17.6577 13.3228 15.3234 13.4886ZM13.5 15C13.5 17.4853 11.4853 19.5 9 19.5 6.51472 19.5 4.5 17.4853 4.5 15 4.5 12.5147 6.51472 10.5 9 10.5 11.4853 10.5 13.5 12.5147 13.5 15ZM3 7C3 4.79086 4.79086 3 7 3H8.5V5H7C5.89543 5 5 5.89543 5 7V8.5H3V7ZM19 17V15.5H21V17C21 19.2091 19.2091 21 17 21H15.5V19H17C18.1046 19 19 18.1046 19 17Z"
  }));
},
    $A = function $A(_ref2422) {
  var _ref2422$color = _ref2422.color,
      C = _ref2422$color === void 0 ? "currentColor" : _ref2422$color,
      _ref2422$size = _ref2422.size,
      e = _ref2422$size === void 0 ? 24 : _ref2422$size,
      l = _ref2422.className,
      i = _objectWithoutProperties(_ref2422, _excluded2422);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.9711 17.1715 19.5568 18.5858 16.0223 15.0513 15.9486 15.125 15.2415 18.6605 13.8273 20.0747 9.58466 15.8321 4.63492 20.7818 3.2207 19.3676 8.17045 14.4179 3.92781 10.1752 5.34202 8.76101 8.87756 8.0539 8.95127 7.98019 5.4147 4.44362 6.82892 3.02941 20.9711 17.1715ZM18.8508 12.2228 20.1913 10.8823 20.8984 11.5894 22.3126 10.1752 13.8273 1.68994 12.4131 3.10416 13.1202 3.81126 11.7797 5.15176 18.8508 12.2228Z"
  }));
},
    ek = function ek(_ref2423) {
  var _ref2423$color = _ref2423.color,
      C = _ref2423$color === void 0 ? "currentColor" : _ref2423$color,
      _ref2423$size = _ref2423.size,
      e = _ref2423$size === void 0 ? 24 : _ref2423$size,
      l = _ref2423.className,
      i = _objectWithoutProperties(_ref2423, _excluded2423);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.9701 17.1716 19.5559 18.5858 16.0214 15.0513 15.9476 15.1251 15.2405 18.6606 13.8263 20.0748 9.58369 15.8322 4.63394 20.7819 3.21973 19.3677 8.16947 14.418 3.92683 10.1753 5.34105 8.7611 8.87658 8.05399 8.95029 7.98028 5.41373 4.44371 6.82794 3.0295 20.9701 17.1716ZM10.3645 9.39449 9.86261 9.8964 7.04072 10.4608 13.5409 16.9609 14.1052 14.139 14.6071 13.6371 10.3645 9.39449ZM18.7761 9.46821 17.4356 10.8087 18.8498 12.2229 20.1903 10.8824 20.8974 11.5895 22.3116 10.1753 13.8263 1.69003 12.4121 3.10425 13.1192 3.81135 11.7787 5.15185 13.1929 6.56607 14.5334 5.22557 18.7761 9.46821Z"
  }));
},
    tk = function tk(_ref2424) {
  var _ref2424$color = _ref2424.color,
      C = _ref2424$color === void 0 ? "currentColor" : _ref2424$color,
      _ref2424$size = _ref2424.size,
      e = _ref2424$size === void 0 ? 24 : _ref2424$size,
      l = _ref2424.className,
      i = _objectWithoutProperties(_ref2424, _excluded2424);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19.1937 3.18117C20.3555 2.71123 21.3487 3.16205 21.8663 4.45774C23.2592 7.94366 19.9988 21.1333 17.4407 21.1333C16.6131 21.1333 15.7836 20.4447 14.8173 19.2068C14.3818 18.6489 13.9272 17.9838 13.4597 17.2333C13.0858 16.6328 12.7182 16.0015 12.3651 15.3626L12.0001 14.6901L11.9825 14.722C11.5257 15.5772 11.0385 16.4327 10.5399 17.2333C10.0725 17.9838 9.61783 18.6489 9.18231 19.2068C8.21598 20.4447 7.38653 21.1333 6.55888 21.1333C4.00086 21.1333 0.740407 7.94366 2.13327 4.45778C2.6509 3.16204 3.64414 2.71123 4.80589 3.18117C5.6482 3.5219 6.57782 4.3366 7.61665 5.55703C8.23486 6.28331 8.88155 7.14336 9.54718 8.11022C10.2842 9.18072 11.0062 10.3255 11.6841 11.4699L12.0002 12.0085L12.3156 11.4699C12.8578 10.5544 13.4284 9.63861 14.0123 8.76083L14.4524 8.11022C15.1181 7.14336 15.7648 6.28331 16.383 5.55703C17.4218 4.3366 18.3514 3.5219 19.1937 3.18117ZM4.32415 4.35258C3.83357 4.15413 3.58079 4.26886 3.31915 4.92382C2.86195 6.06804 3.05394 8.9514 3.73172 12.1871L3.89027 12.9114L4.06441 13.6438C4.91993 17.1047 6.15077 19.8682 6.55888 19.8682C6.83822 19.8682 7.44795 19.362 8.17369 18.4323C8.57863 17.9136 9.00904 17.284 9.45462 16.5685C9.8163 15.9877 10.1733 15.3745 10.5167 14.7531L10.9319 13.9859L11.2802 13.315L10.916 12.6774L10.5842 12.1107C9.91996 10.9892 9.21275 9.86797 8.49374 8.82358C7.85084 7.88975 7.22921 7.06302 6.64196 6.37311C5.72617 5.29724 4.92611 4.59608 4.32415 4.35258ZM20.6804 4.92377C20.4188 4.26886 20.1661 4.15413 19.6755 4.35258C19.0735 4.59608 18.2735 5.29724 17.3577 6.37311C16.7704 7.06302 16.1488 7.88975 15.5059 8.82358C14.9307 9.6591 14.363 10.5438 13.8189 11.4384L13.2452 12.3998L12.7184 13.315L12.8991 13.6647L13.1443 14.1298C13.5889 14.9621 14.0628 15.7941 14.545 16.5685C14.9906 17.284 15.421 17.9136 15.8259 18.4323C16.5517 19.362 17.1614 19.8682 17.4407 19.8682C17.8488 19.8682 19.0797 17.1047 19.9352 13.6438L20.1094 12.9114C20.9137 9.3881 21.1715 6.1528 20.6804 4.92377Z"
  }));
},
    Ck = function Ck(_ref2425) {
  var _ref2425$color = _ref2425.color,
      C = _ref2425$color === void 0 ? "currentColor" : _ref2425$color,
      _ref2425$size = _ref2425.size,
      e = _ref2425$size === void 0 ? 24 : _ref2425$size,
      l = _ref2425.className,
      i = _objectWithoutProperties(_ref2425, _excluded2425);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.6607 18.9641C6.61877 18.9147 6.56632 18.8464 6.5045 18.7545C6.2667 18.4009 5.99019 17.8492 5.70035 17.1274C5.12527 15.6952 4.56176 13.7552 4.16416 11.8007C3.76442 9.83556 3.54827 7.93245 3.62744 6.55749C3.66773 5.85789 3.77997 5.39553 3.90955 5.14053C3.93885 5.08288 3.96453 5.04507 3.98332 5.02166C3.9913 5.01173 3.99778 5.00472 4.00249 5C4.29419 5.00083 4.74151 5.16186 5.35824 5.65098C5.95837 6.12695 6.6084 6.82548 7.28541 7.68296C8.52093 9.24783 9.74868 11.2146 10.8369 13.009C10.6575 13.3241 10.4674 13.6685 10.2721 14.0226C10.1805 14.1886 10.0877 14.3568 9.99429 14.5251C9.57514 15.2801 9.13019 16.0616 8.66979 16.7698C8.20474 17.4853 7.75161 18.0822 7.3264 18.4904C7.02581 18.7788 6.80541 18.9093 6.6607 18.9641ZM12.0002 11.0762C11.0381 9.51354 9.95752 7.83986 8.85513 6.44361C8.1338 5.53 7.37382 4.69689 6.60102 4.08398C5.8464 3.4855 4.9586 3 4.00024 3C3.07752 3 2.46447 3.56952 2.12656 4.23447C1.8115 4.85447 1.67684 5.64211 1.63075 6.44251C1.53717 8.06755 1.79036 10.1644 2.2043 12.1993C2.62038 14.2448 3.21487 16.3048 3.84438 17.8726C4.15683 18.6508 4.49426 19.3491 4.84482 19.8705C5.01895 20.1295 5.22203 20.3838 5.45774 20.5834C5.68336 20.7745 6.03975 21 6.50023 21C7.39472 21 8.14787 20.4741 8.7113 19.9333C9.29983 19.3684 9.8507 18.6228 10.3466 17.8599C10.8472 17.0898 11.3203 16.2571 11.7429 15.4958C11.8284 15.3418 11.9114 15.1916 11.9919 15.0457C12 15.0606 12.008 15.0757 12.0161 15.0907C12.0845 15.2186 12.1548 15.3497 12.2269 15.4839C12.6352 16.2436 13.093 17.0787 13.584 17.8512C14.0705 18.6168 14.6191 19.3686 15.2225 19.9387C15.8116 20.4953 16.5815 21 17.5002 21C17.9607 21 18.3171 20.7745 18.5427 20.5834C18.7784 20.3838 18.9815 20.1295 19.1556 19.8705C19.5062 19.3492 19.8436 18.6508 20.1561 17.8726C20.7856 16.3049 21.3802 14.2448 21.7963 12.1993C22.2102 10.1645 22.4635 8.06756 22.3699 6.44252C22.3238 5.64211 22.1892 4.85447 21.8741 4.23447C21.5362 3.5695 20.9231 3 20.0004 3C19.042 3 18.1542 3.48548 17.3995 4.08397C16.6267 4.69687 15.8667 5.52998 15.1453 6.4436C14.0429 7.83985 12.9623 9.51354 12.0002 11.0762ZM13.1622 13.0111C14.2508 11.2161 15.479 9.24844 16.715 7.68297C17.3921 6.8255 18.0421 6.12696 18.6423 5.651C19.259 5.16187 19.7064 5.00082 19.9982 5C20.0029 5.00471 20.0093 5.01173 20.0173 5.02167C20.0361 5.04507 20.0618 5.08288 20.0911 5.14053C20.2207 5.39552 20.3329 5.85789 20.3732 6.55748C20.4524 7.93244 20.2362 9.83555 19.8364 11.8006C19.4388 13.7552 18.8753 15.6951 18.3001 17.1274C18.0103 17.8492 17.7338 18.4008 17.496 18.7545C17.4304 18.852 17.3754 18.9229 17.3322 18.9729C17.1588 18.9214 16.9153 18.7865 16.596 18.4849C16.1696 18.0821 15.7249 17.4913 15.2719 16.7785C14.8233 16.0726 14.3952 15.2935 13.9885 14.537C13.9214 14.4121 13.8545 14.2872 13.7881 14.163C13.5732 13.7617 13.3626 13.3683 13.1622 13.0111Z"
  }));
},
    lk = function lk(_ref2426) {
  var _ref2426$color = _ref2426.color,
      C = _ref2426$color === void 0 ? "currentColor" : _ref2426$color,
      _ref2426$size = _ref2426.size,
      e = _ref2426$size === void 0 ? 24 : _ref2426$size,
      l = _ref2426.className,
      i = _objectWithoutProperties(_ref2426, _excluded2426);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3.32308 12C3.32308 15.4385 5.32308 18.4 8.21538 19.8077L4.07692 8.46923C3.57998 9.57999 3.3231 10.7831 3.32308 12ZM12 20.6769C13.0077 20.6769 13.9769 20.5 14.8846 20.1846L14.8231 20.0692L12.1538 12.7615L9.55385 20.3231C10.3231 20.5538 11.1462 20.6769 12 20.6769ZM13.1923 7.93077L16.3308 17.2615L17.2 14.3692C17.5692 13.1692 17.8538 12.3077 17.8538 11.5615C17.8538 10.4846 17.4692 9.74615 17.1462 9.17692C16.7 8.45385 16.2923 7.84615 16.2923 7.13846C16.2923 6.33846 16.8923 5.6 17.7538 5.6H17.8615C16.2627 4.13224 14.1704 3.31946 12 3.32308C10.5629 3.32281 9.14834 3.67979 7.88347 4.3619C6.61861 5.04402 5.54315 6.02987 4.75385 7.23077L5.30769 7.24615C6.21538 7.24615 7.61539 7.13077 7.61539 7.13077C8.09231 7.10769 8.14615 7.79231 7.67692 7.84615C7.67692 7.84615 7.20769 7.90769 6.67692 7.93077L9.84615 17.3308L11.7462 11.6385L10.3923 7.93077C10.0891 7.91404 9.78636 7.88838 9.48462 7.85385C9.01538 7.82308 9.06923 7.10769 9.53846 7.13077C9.53846 7.13077 10.9692 7.24615 11.8231 7.24615C12.7308 7.24615 14.1308 7.13077 14.1308 7.13077C14.6 7.10769 14.6615 7.79231 14.1923 7.84615C14.1923 7.84615 13.7231 7.9 13.1923 7.93077ZM16.3615 19.5C17.6742 18.7368 18.7636 17.6424 19.5208 16.3263C20.2781 15.0102 20.6767 13.5184 20.6769 12C20.6769 10.4923 20.2923 9.07692 19.6154 7.83846C19.7529 9.20099 19.5466 10.5762 19.0154 11.8385L16.3615 19.5ZM12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22Z"
  }));
},
    ik = function ik(_ref2427) {
  var _ref2427$color = _ref2427.color,
      C = _ref2427$color === void 0 ? "currentColor" : _ref2427$color,
      _ref2427$size = _ref2427.size,
      e = _ref2427$size === void 0 ? 24 : _ref2427$size,
      l = _ref2427.className,
      i = _objectWithoutProperties(_ref2427, _excluded2427);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM14.6059 19.566L12.4512 13.5807L10.27 19.8125C10.8271 19.9353 11.406 20 12 20C12.9124 20 13.789 19.8473 14.6059 19.566ZM17.0741 18.1853C18.8605 16.7181 20 14.4921 20 12C20 10.9742 19.8069 9.99354 19.4552 9.09231C19.2048 10.5459 18.7629 12.4415 18.4794 13.4073L17.0741 18.1853ZM16.8726 5.65461C15.5233 4.61695 13.8337 4 12 4C9.47362 4 7.22075 5.17108 5.75463 7H7.14502V9H6.39547L9.15016 16.958L11.3768 10.5962L10.8021 9H8.64502L8.64505 7H13.6451L13.645 9H12.9278L15.5492 16.2817L16.5606 12.8429C17.0844 11.0096 16.653 10.2107 16.2222 9.41327C15.9334 8.87865 15.645 8.34466 15.645 7.5C15.645 6.66923 16.1515 5.95677 16.8726 5.65461ZM4.42479 9.42105C4.14939 10.2302 4 11.0977 4 12C4 14.8098 5.44856 17.2813 7.63963 18.7084L4.42479 9.42105Z"
  }));
},
    sk = function sk(_ref2428) {
  var _ref2428$color = _ref2428.color,
      C = _ref2428$color === void 0 ? "currentColor" : _ref2428$color,
      _ref2428$size = _ref2428.size,
      e = _ref2428$size === void 0 ? 24 : _ref2428$size,
      l = _ref2428.className,
      i = _objectWithoutProperties(_ref2428, _excluded2428);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7.78934 15.7143C7.64573 15.2587 7.54999 14.6754 7.54472 14.3752 7.53944 14.0762 7.60516 13.578 7.60516 13.578L3.09648 17.268C2.30907 17.9041 1.24985 17.9029.751679 17.2644.260811 16.6364.512736 15.6441 1.29204 15.0474L9.58486 8.68273 4.95651 8.68881C4.17152 8.68597 3.65875 8.15697 3.80642 7.51925 3.95003 6.89329 4.67578 6.39796 5.43074 6.39715L14.5767 6.38741 11.582 3.94849C11.1155 3.56594 11.1755 2.95945 11.6996 2.59272 12.2181 2.23005 13.0108 2.22883 13.4822 2.5907L20.6858 8.12208 20.6841 8.1233C21.3961 8.67542 21.9949 9.3314 22.4594 10.0807 22.9673 10.8961 23.2971 11.7906 23.4326 12.7439 23.502 13.2332 23.5178 13.7228 23.4801 14.2117 23.4415 14.7078 23.3454 15.2023 23.1933 15.6896 22.8906 16.6538 22.3795 17.5475 21.6675 18.337 20.9377 19.1455 20.0383 19.7974 18.9986 20.2627 17.9057 20.7504 16.7215 21.0019 15.4935 21.0035 14.2635 21.0055 13.0794 20.7589 11.9865 20.2749 10.9467 19.8141 10.0465 19.165 9.31549 18.3569 8.60313 17.5707 8.09116 16.6786 7.78934 15.7143ZM15.4935 17.5293C16.9008 17.5265 18.2014 16.9897 19.1304 16.0433 19.5844 15.5808 19.9166 15.051 20.1227 14.4851 20.3243 13.9301 20.4026 13.3423 20.3515 12.7492 20.3004 12.1671 20.1288 11.6154 19.8517 11.1148 19.5807 10.6231 19.2079 10.1797 18.7479 9.80483 17.844 9.07136 16.6951 8.67664 15.4915 8.67826 14.2891 8.67989 13.1394 9.07826 12.2364 9.81416 11.7755 10.1906 11.4023 10.6356 11.1313 11.1281 10.8554 11.6291 10.6826 12.1829 10.6335 12.7634 10.5816 13.3573 10.6599 13.946 10.8615 14.5005 11.0672 15.0648 11.4007 15.5946 11.8546 16.0551 12.7836 16.9999 14.0842 17.5317 15.4935 17.5293ZM13.4751 10.9036C14.0308 10.433 14.7789 10.1453 15.5951 10.1453 16.4105 10.1453 17.1586 10.433 17.7148 10.9036 18.2811 11.3827 18.6568 12.0585 18.7002 12.8248 18.7432 13.6131 18.4263 14.3453 17.8706 14.8881 17.3038 15.4402 16.4978 15.7867 15.5951 15.7867 14.6925 15.7867 13.8848 15.4402 13.3185 14.8881 12.7623 14.3453 12.4463 13.6131 12.4897 12.8256 12.5327 12.0585 12.9083 11.3827 13.4751 10.9036ZM13.4751 10.9036C12.9083 11.3827 12.5327 12.0585 12.4897 12.8256 12.4463 13.6131 12.7623 14.3453 13.3185 14.8881 13.8848 15.4402 14.6925 15.7867 15.5951 15.7867 16.4978 15.7867 17.3038 15.4402 17.8706 14.8881 18.4263 14.3453 18.7432 13.6131 18.7002 12.8248 18.6568 12.0585 18.2811 11.3827 17.7148 10.9036 17.1586 10.433 16.4105 10.1453 15.5951 10.1453 14.7789 10.1453 14.0308 10.433 13.4751 10.9036ZM7.78934 15.7143C7.64573 15.2587 7.54999 14.6754 7.54472 14.3752 7.53944 14.0762 7.60516 13.578 7.60516 13.578L3.09648 17.268C2.30907 17.9041 1.24985 17.9029.751679 17.2644.260811 16.6364.512736 15.6441 1.29204 15.0474L9.58486 8.68273 4.95651 8.68881C4.17152 8.68597 3.65875 8.15697 3.80642 7.51925 3.95003 6.89329 4.67578 6.39796 5.43074 6.39715L14.5767 6.38741 11.582 3.94849C11.1155 3.56594 11.1755 2.95945 11.6996 2.59272 12.2181 2.23005 13.0108 2.22883 13.4822 2.5907L20.6858 8.12208 20.6841 8.1233C21.3961 8.67542 21.9949 9.3314 22.4594 10.0807 22.9673 10.8961 23.2971 11.7906 23.4326 12.7439 23.502 13.2332 23.5178 13.7228 23.4801 14.2117 23.4415 14.7078 23.3454 15.2023 23.1933 15.6896 22.8906 16.6538 22.3795 17.5476 21.6675 18.337 20.9377 19.1455 20.0383 19.7974 18.9986 20.2627 17.9057 20.7504 16.7215 21.0019 15.4935 21.0035 14.2635 21.0055 13.0794 20.7589 11.9865 20.2749 10.9467 19.8141 10.0465 19.165 9.31549 18.3569 8.60313 17.5707 8.09116 16.6786 7.78934 15.7143ZM15.4935 17.5293C16.9008 17.5265 18.2014 16.9897 19.1304 16.0433 19.5844 15.5808 19.9166 15.051 20.1227 14.4851 20.3243 13.9301 20.4026 13.3423 20.3515 12.7492 20.3004 12.1671 20.1288 11.6154 19.8517 11.1148 19.5807 10.6231 19.2079 10.1797 18.7479 9.80483 17.844 9.07136 16.6951 8.67664 15.4915 8.67826 14.2891 8.67989 13.1394 9.07826 12.2364 9.81416 11.7755 10.1906 11.4023 10.6356 11.1313 11.1281 10.8554 11.6291 10.6826 12.1829 10.6335 12.7634 10.5816 13.3573 10.6599 13.946 10.8615 14.5005 11.0672 15.0648 11.4007 15.5946 11.8546 16.0551 12.7836 16.9999 14.0842 17.5317 15.4935 17.5293Z"
  }));
},
    rk = function rk(_ref2429) {
  var _ref2429$color = _ref2429.color,
      C = _ref2429$color === void 0 ? "currentColor" : _ref2429$color,
      _ref2429$size = _ref2429.size,
      e = _ref2429$size === void 0 ? 24 : _ref2429$size,
      l = _ref2429.className,
      i = _objectWithoutProperties(_ref2429, _excluded2429);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13.1222 2.21716C12.6898 1.87354 12.0608 1.94549 11.7172 2.37786C11.3735 2.81023 11.4455 3.43929 11.8779 3.78291L15.2968 6.50004H4.50004C3.94775 6.50004 3.50004 6.94775 3.50004 7.50004C3.50004 8.05232 3.94775 8.50004 4.50004 8.50004H9.97176L0.878395 15.7167C0.445791 16.0601 0.373415 16.6891 0.71674 17.1217C1.06006 17.5543 1.68908 17.6267 2.12168 17.2833L7.54456 12.9796C7.51516 13.2324 7.50004 13.4894 7.50004 13.75C7.50004 17.8577 11.1913 21 15.5 21C19.8087 21 23.5 17.8577 23.5 13.75C23.5 11.5033 22.3763 9.52296 20.6647 8.21146L13.1222 2.21716ZM11.5646 9.78924C12.6109 8.99203 13.9834 8.50004 15.5 8.50004C17.0201 8.50004 18.3953 8.99422 19.4425 9.79456C20.7262 10.7757 21.5 12.1982 21.5 13.75C21.5 16.546 18.9233 19 15.5 19C12.0768 19 9.50004 16.546 9.50004 13.75C9.50004 12.2702 10.2037 10.908 11.3822 9.93395L11.5646 9.78924ZM14.4777 14.0919C14.2012 13.8314 14.0793 13.5265 14.0965 13.2102C14.1287 12.6453 14.7205 12 15.595 12C16.468 12 17.0599 12.6438 17.0932 13.209C17.1106 13.539 16.9851 13.8423 16.7153 14.0962C16.4296 14.3651 16.018 14.536 15.595 14.536C15.1815 14.536 14.7685 14.366 14.4777 14.0919ZM15.595 10C13.849 10 12.2007 11.2947 12.0996 13.0992C11.9923 15.0452 13.7253 16.536 15.595 16.536C17.471 16.536 19.1971 15.0592 19.0901 13.098C18.9879 11.2944 17.3406 10 15.595 10Z"
  }));
},
    ck = function ck(_ref2430) {
  var _ref2430$color = _ref2430.color,
      C = _ref2430$color === void 0 ? "currentColor" : _ref2430$color,
      _ref2430$size = _ref2430.size,
      e = _ref2430$size === void 0 ? 24 : _ref2430$size,
      l = _ref2430.className,
      i = _objectWithoutProperties(_ref2430, _excluded2430);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21.9024 10.5976C21.4442 10.5333 20.976 10.5 20.5 10.5C17.2404 10.5 14.3455 12.0604 12.5212 14.471C12.3501 14.4887 12.1763 14.4978 12 14.4978C10.7188 14.4978 9.55217 14.0172 8.66691 13.2248L7.33309 14.7151C8.41871 15.6868 9.81141 16.3253 11.3466 16.4676C10.8023 17.7016 10.5 19.0662 10.5 20.5C10.5 20.976 10.5333 21.4442 10.5976 21.9024C5.7387 21.2205 2 17.0469 2 12C2 6.47715 6.47715 2 12 2C17.0469 2 21.2205 5.7387 21.9024 10.5976ZM21.8707 12.617C21.4254 12.5401 20.9674 12.5 20.5 12.5C17.7656 12.5 15.3512 13.8709 13.9068 15.9675C13.0194 17.2556 12.5 18.8156 12.5 20.5C12.5 20.9674 12.5401 21.4254 12.617 21.8707L21.8707 12.617ZM8.5 11.5C9.32843 11.5 10 10.8284 10 10C10 9.17157 9.32843 8.5 8.5 8.5C7.67157 8.5 7 9.17157 7 10C7 10.8284 7.67157 11.5 8.5 11.5ZM15.5 11.5C16.3284 11.5 17 10.8284 17 10C17 9.17157 16.3284 8.5 15.5 8.5C14.6716 8.5 14 9.17157 14 10C14 10.8284 14.6716 11.5 15.5 11.5Z"
  }));
},
    ok = function ok(_ref2431) {
  var _ref2431$color = _ref2431.color,
      C = _ref2431$color === void 0 ? "currentColor" : _ref2431$color,
      _ref2431$size = _ref2431.size,
      e = _ref2431$size === void 0 ? 24 : _ref2431$size,
      l = _ref2431.className,
      i = _objectWithoutProperties(_ref2431, _excluded2431);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10.5199 19.8634C10.5955 18.6615 10.8833 17.5172 11.3463 16.4676C9.81124 16.3252 8.41864 15.6867 7.33309 14.7151L8.66691 13.2248C9.55217 14.0172 10.7188 14.4978 12 14.4978C12.1763 14.4978 12.3501 14.4887 12.5211 14.471C14.227 12.2169 16.8661 10.7083 19.8634 10.5199C19.1692 6.80877 15.9126 4 12 4C7.58172 4 4 7.58172 4 12C4 15.9126 6.80877 19.1692 10.5199 19.8634ZM19.0233 12.636C15.7891 13.2396 13.2396 15.7891 12.636 19.0233L19.0233 12.636ZM22 12C22 12.1677 21.9959 12.3344 21.9877 12.5L12.5 21.9877C12.3344 21.9959 12.1677 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM10 10C10 10.8284 9.32843 11.5 8.5 11.5C7.67157 11.5 7 10.8284 7 10C7 9.17157 7.67157 8.5 8.5 8.5C9.32843 8.5 10 9.17157 10 10ZM17 10C17 10.8284 16.3284 11.5 15.5 11.5C14.6716 11.5 14 10.8284 14 10C14 9.17157 14.6716 8.5 15.5 8.5C16.3284 8.5 17 9.17157 17 10Z"
  }));
},
    ak = function ak(_ref2432) {
  var _ref2432$color = _ref2432.color,
      C = _ref2432$color === void 0 ? "currentColor" : _ref2432$color,
      _ref2432$size = _ref2432.size,
      e = _ref2432$size === void 0 ? 24 : _ref2432$size,
      l = _ref2432.className,
      i = _objectWithoutProperties(_ref2432, _excluded2432);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 6C3 4.34315 4.34315 3 6 3C7.65685 3 9 4.34315 9 6C9 7.30622 8.16519 8.41746 7 8.82929V15.1707C8.16519 15.5825 9 16.6938 9 18C9 19.6569 7.65685 21 6 21C4.34315 21 3 19.6569 3 18C3 16.6938 3.83481 15.5825 5 15.1707V8.82929C3.83481 8.41746 3 7.30622 3 6ZM15.2929 3.29289C15.6834 2.90237 16.3166 2.90237 16.7071 3.29289L18 4.58579L19.2929 3.29289C19.6834 2.90237 20.3166 2.90237 20.7071 3.29289C21.0976 3.68342 21.0976 4.31658 20.7071 4.70711L19.4142 6L20.7071 7.29289C21.0976 7.68342 21.0976 8.31658 20.7071 8.70711C20.3166 9.09763 19.6834 9.09763 19.2929 8.70711L18 7.41421L16.7071 8.70711C16.3166 9.09763 15.6834 9.09763 15.2929 8.70711C14.9024 8.31658 14.9024 7.68342 15.2929 7.29289L16.5858 6L15.2929 4.70711C14.9024 4.31658 14.9024 3.68342 15.2929 3.29289ZM18 10C18.5523 10 19 10.4477 19 11V15.1707C20.1652 15.5825 21 16.6938 21 18C21 19.6569 19.6569 21 18 21C16.3431 21 15 19.6569 15 18C15 16.6938 15.8348 15.5825 17 15.1707V11C17 10.4477 17.4477 10 18 10Z"
  }));
},
    nk = function nk(_ref2433) {
  var _ref2433$color = _ref2433.color,
      C = _ref2433$color === void 0 ? "currentColor" : _ref2433$color,
      _ref2433$size = _ref2433.size,
      e = _ref2433$size === void 0 ? 24 : _ref2433$size,
      l = _ref2433.className,
      i = _objectWithoutProperties(_ref2433, _excluded2433);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6 5C5.44772 5 5 5.44772 5 6C5 6.55228 5.44772 7 6 7C6.55228 7 7 6.55228 7 6C7 5.44772 6.55228 5 6 5ZM3 6C3 4.34315 4.34315 3 6 3C7.65685 3 9 4.34315 9 6C9 7.30622 8.16519 8.41746 7 8.82929V15.1707C8.16519 15.5825 9 16.6938 9 18C9 19.6569 7.65685 21 6 21C4.34315 21 3 19.6569 3 18C3 16.6938 3.83481 15.5825 5 15.1707V8.82929C3.83481 8.41746 3 7.30622 3 6ZM15.2929 3.29289C15.6834 2.90237 16.3166 2.90237 16.7071 3.29289L18 4.58579L19.2929 3.29289C19.6834 2.90237 20.3166 2.90237 20.7071 3.29289C21.0976 3.68342 21.0976 4.31658 20.7071 4.70711L19.4142 6L20.7071 7.29289C21.0976 7.68342 21.0976 8.31658 20.7071 8.70711C20.3166 9.09763 19.6834 9.09763 19.2929 8.70711L18 7.41421L16.7071 8.70711C16.3166 9.09763 15.6834 9.09763 15.2929 8.70711C14.9024 8.31658 14.9024 7.68342 15.2929 7.29289L16.5858 6L15.2929 4.70711C14.9024 4.31658 14.9024 3.68342 15.2929 3.29289ZM18 10C18.5523 10 19 10.4477 19 11V15.1707C20.1652 15.5825 21 16.6938 21 18C21 19.6569 19.6569 21 18 21C16.3431 21 15 19.6569 15 18C15 16.6938 15.8348 15.5825 17 15.1707V11C17 10.4477 17.4477 10 18 10ZM6 17C5.44772 17 5 17.4477 5 18C5 18.5523 5.44772 19 6 19C6.55228 19 7 18.5523 7 18C7 17.4477 6.55228 17 6 17ZM18 17C17.4477 17 17 17.4477 17 18C17 18.5523 17.4477 19 18 19C18.5523 19 19 18.5523 19 18C19 17.4477 18.5523 17 18 17Z"
  }));
},
    mk = function mk(_ref2434) {
  var _ref2434$color = _ref2434.color,
      C = _ref2434$color === void 0 ? "currentColor" : _ref2434$color,
      _ref2434$size = _ref2434.size,
      e = _ref2434$size === void 0 ? 24 : _ref2434$size,
      l = _ref2434.className,
      i = _objectWithoutProperties(_ref2434, _excluded2434);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 1L21.5 6.5V17.5L12 23L2.5 17.5V6.5L12 1ZM6.49896 9.97089L11 12.5768V17.6252H13V12.5768L17.501 9.9709L16.499 8.24005L12 10.8447L7.50104 8.24004L6.49896 9.97089Z"
  }));
},
    wk = function wk(_ref2435) {
  var _ref2435$color = _ref2435.color,
      C = _ref2435$color === void 0 ? "currentColor" : _ref2435$color,
      _ref2435$size = _ref2435.size,
      e = _ref2435$size === void 0 ? 24 : _ref2435$size,
      l = _ref2435.className,
      i = _objectWithoutProperties(_ref2435, _excluded2435);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4.5 7.65311V16.3469L12 20.689L19.5 16.3469V7.65311L12 3.311L4.5 7.65311ZM12 1L21.5 6.5V17.5L12 23L2.5 17.5V6.5L12 1ZM6.49896 9.97065L11 12.5765V17.625H13V12.5765L17.501 9.97066L16.499 8.2398L12 10.8445L7.50104 8.2398L6.49896 9.97065Z"
  }));
},
    Lk = function Lk(_ref2436) {
  var _ref2436$color = _ref2436.color,
      C = _ref2436$color === void 0 ? "currentColor" : _ref2436$color,
      _ref2436$size = _ref2436.size,
      e = _ref2436$size === void 0 ? 24 : _ref2436$size,
      l = _ref2436.className,
      i = _objectWithoutProperties(_ref2436, _excluded2436);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 10.063V4C21 3.44772 20.5523 3 20 3H19C17.0214 4.97864 13.3027 6.08728 11 6.61281V17.3872C13.3027 17.9127 17.0214 19.0214 19 21H20C20.5523 21 21 20.5523 21 20V13.937C21.8626 13.715 22.5 12.9319 22.5 12 22.5 11.0681 21.8626 10.285 21 10.063ZM5 7C3.89543 7 3 7.89543 3 9V15C3 16.1046 3.89543 17 5 17H6L7 22H9V7H5Z"
  }));
},
    hk = function hk(_ref2437) {
  var _ref2437$color = _ref2437.color,
      C = _ref2437$color === void 0 ? "currentColor" : _ref2437$color,
      _ref2437$size = _ref2437.size,
      e = _ref2437$size === void 0 ? 24 : _ref2437$size,
      l = _ref2437.className,
      i = _objectWithoutProperties(_ref2437, _excluded2437);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9 17C9 17 16 18 19 21H20C20.5523 21 21 20.5523 21 20V13.937C21.8626 13.715 22.5 12.9319 22.5 12C22.5 11.0681 21.8626 10.285 21 10.063V4C21 3.44772 20.5523 3 20 3H19C16 6 9 7 9 7H5C3.89543 7 3 7.89543 3 9V15C3 16.1046 3.89543 17 5 17H6L7 22H9V17ZM11 8.6612C11.6833 8.5146 12.5275 8.31193 13.4393 8.04373C15.1175 7.55014 17.25 6.77262 19 5.57458V18.4254C17.25 17.2274 15.1175 16.4499 13.4393 15.9563C12.5275 15.6881 11.6833 15.4854 11 15.3388V8.6612ZM5 9H9V15H5V9Z"
  }));
},
    Hk = function Hk(_ref2438) {
  var _ref2438$color = _ref2438.color,
      C = _ref2438$color === void 0 ? "currentColor" : _ref2438$color,
      _ref2438$size = _ref2438.size,
      e = _ref2438$size === void 0 ? 24 : _ref2438$size,
      l = _ref2438.className,
      i = _objectWithoutProperties(_ref2438, _excluded2438);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9.00008 10C9.00008 10.5523 8.55236 11 8.00008 11 7.44779 11 7.00008 10.5523 7.00008 10 7.00008 9.44772 7.44779 9 8.00008 9 8.55236 9 9.00008 9.44772 9.00008 10ZM2 4C1.44772 4 1 4.44772 1 5V19C1 19.5523 1.44772 20 2 20H22C22.5523 20 23 19.5523 23 19V5C23 4.44772 22.5523 4 22 4H2ZM11.0001 10C11.0001 11.6569 9.65693 13 8.00008 13 6.34322 13 5.00008 11.6569 5.00008 10 5.00008 8.34315 6.34322 7 8.00008 7 9.65693 7 11.0001 8.34315 11.0001 10ZM5.52725 17.0251 4.11304 15.6109C5.10725 14.6167 6.48362 14 8.00212 14 9.52063 14 10.897 14.6167 11.8912 15.6109L10.477 17.0251C9.84253 16.3907 8.9689 16 8.00212 16 7.03535 16 6.16172 16.3907 5.52725 17.0251ZM16.0001 10.5858 17.793 8.79289 19.2072 10.2071 17.4143 12 19.2072 13.7929 17.793 15.2071 16.0001 13.4142 14.2072 15.2071 12.793 13.7929 14.5859 12 12.793 10.2071 14.2072 8.79289 16.0001 10.5858Z"
  }));
},
    Vk = function Vk(_ref2439) {
  var _ref2439$color = _ref2439.color,
      C = _ref2439$color === void 0 ? "currentColor" : _ref2439$color,
      _ref2439$size = _ref2439.size,
      e = _ref2439$size === void 0 ? 24 : _ref2439$size,
      l = _ref2439.className,
      i = _objectWithoutProperties(_ref2439, _excluded2439);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 18H21V6H3V18ZM1 5C1 4.44772 1.44772 4 2 4H22C22.5523 4 23 4.44772 23 5V19C23 19.5523 22.5523 20 22 20H2C1.44772 20 1 19.5523 1 19V5ZM9 10C9 9.44772 8.55228 9 8 9C7.44772 9 7 9.44772 7 10C7 10.5523 7.44772 11 8 11C8.55228 11 9 10.5523 9 10ZM11 10C11 11.6569 9.65685 13 8 13C6.34315 13 5 11.6569 5 10C5 8.34315 6.34315 7 8 7C9.65685 7 11 8.34315 11 10ZM8.0018 16C7.03503 16 6.1614 16.3907 5.52693 17.0251L4.11272 15.6109C5.10693 14.6167 6.4833 14 8.0018 14C9.52031 14 10.8967 14.6167 11.8909 15.6109L10.4767 17.0251C9.84221 16.3907 8.96858 16 8.0018 16ZM17.7929 8.79289L16 10.5858L14.2071 8.79289L12.7929 10.2071L14.5858 12L12.7929 13.7929L14.2071 15.2071L16 13.4142L17.7929 15.2071L19.2071 13.7929L17.4142 12L19.2071 10.2071L17.7929 8.79289Z"
  }));
},
    gk = function gk(_ref2440) {
  var _ref2440$color = _ref2440.color,
      C = _ref2440$color === void 0 ? "currentColor" : _ref2440$color,
      _ref2440$size = _ref2440.size,
      e = _ref2440$size === void 0 ? 24 : _ref2440$size,
      l = _ref2440.className,
      i = _objectWithoutProperties(_ref2440, _excluded2440);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 4C1.44772 4 1 4.44772 1 5V19C1 19.5523 1.44772 20 2 20H22C22.5523 20 23 19.5523 23 19V5C23 4.44772 22.5523 4 22 4H2ZM9.00008 10C9.00008 9.44772 8.55236 9 8.00008 9C7.44779 9 7.00008 9.44772 7.00008 10C7.00008 10.5523 7.44779 11 8.00008 11C8.55236 11 9.00008 10.5523 9.00008 10ZM11.0001 10C11.0001 11.6569 9.65693 13 8.00008 13C6.34322 13 5.00008 11.6569 5.00008 10C5.00008 8.34315 6.34322 7 8.00008 7C9.65693 7 11.0001 8.34315 11.0001 10ZM5.52725 17.0251L4.11304 15.6109C5.10725 14.6167 6.48362 14 8.00212 14C9.52063 14 10.897 14.6167 11.8912 15.6109L10.477 17.0251C9.84253 16.3907 8.9689 16 8.00212 16C7.03535 16 6.16172 16.3907 5.52725 17.0251ZM13 15V9H15V15H13ZM17 15V9H19V15H17Z"
  }));
},
    Mk = function Mk(_ref2441) {
  var _ref2441$color = _ref2441.color,
      C = _ref2441$color === void 0 ? "currentColor" : _ref2441$color,
      _ref2441$size = _ref2441.size,
      e = _ref2441$size === void 0 ? 24 : _ref2441$size,
      l = _ref2441.className,
      i = _objectWithoutProperties(_ref2441, _excluded2441);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 18H21V6H3V18ZM1 5C1 4.44772 1.44772 4 2 4H22C22.5523 4 23 4.44772 23 5V19C23 19.5523 22.5523 20 22 20H2C1.44772 20 1 19.5523 1 19V5ZM9 10C9 9.44772 8.55228 9 8 9C7.44772 9 7 9.44772 7 10C7 10.5523 7.44772 11 8 11C8.55228 11 9 10.5523 9 10ZM11 10C11 11.6569 9.65685 13 8 13C6.34315 13 5 11.6569 5 10C5 8.34315 6.34315 7 8 7C9.65685 7 11 8.34315 11 10ZM8.0018 16C7.03503 16 6.1614 16.3907 5.52693 17.0251L4.11272 15.6109C5.10693 14.6167 6.4833 14 8.0018 14C9.52031 14 10.8967 14.6167 11.8909 15.6109L10.4767 17.0251C9.84221 16.3907 8.96858 16 8.0018 16ZM13 9V15H15V9H13ZM17 9V15H19V9H17Z"
  }));
},
    Zk = function Zk(_ref2442) {
  var _ref2442$color = _ref2442.color,
      C = _ref2442$color === void 0 ? "currentColor" : _ref2442$color,
      _ref2442$size = _ref2442.size,
      e = _ref2442$size === void 0 ? 24 : _ref2442$size,
      l = _ref2442.className,
      i = _objectWithoutProperties(_ref2442, _excluded2442);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 4C1.44772 4 1 4.44772 1 5V19C1 19.5523 1.44772 20 2 20H22C22.5523 20 23 19.5523 23 19V5C23 4.44772 22.5523 4 22 4H2ZM9.00008 10C9.00008 9.44772 8.55236 9 8.00008 9C7.44779 9 7.00008 9.44772 7.00008 10C7.00008 10.5523 7.44779 11 8.00008 11C8.55236 11 9.00008 10.5523 9.00008 10ZM11.0001 10C11.0001 11.6569 9.65693 13 8.00008 13C6.34322 13 5.00008 11.6569 5.00008 10C5.00008 8.34315 6.34322 7 8.00008 7C9.65693 7 11.0001 8.34315 11.0001 10ZM5.52725 17.0251L4.11304 15.6109C5.10725 14.6167 6.48362 14 8.00212 14C9.52063 14 10.897 14.6167 11.8912 15.6109L10.477 17.0251C9.84253 16.3907 8.9689 16 8.00212 16C7.03535 16 6.16172 16.3907 5.52725 17.0251ZM20.2071 10.7071L16.2071 14.7071L15.5 15.4142L14.7929 14.7071L12.2929 12.2071L13.7071 10.7929L15.5 12.5858L18.7929 9.29289L20.2071 10.7071Z"
  }));
},
    xk = function xk(_ref2443) {
  var _ref2443$color = _ref2443.color,
      C = _ref2443$color === void 0 ? "currentColor" : _ref2443$color,
      _ref2443$size = _ref2443.size,
      e = _ref2443$size === void 0 ? 24 : _ref2443$size,
      l = _ref2443.className,
      i = _objectWithoutProperties(_ref2443, _excluded2443);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 18H21V6H3V18ZM1 5C1 4.44772 1.44772 4 2 4H22C22.5523 4 23 4.44772 23 5V19C23 19.5523 22.5523 20 22 20H2C1.44772 20 1 19.5523 1 19V5ZM9 10C9 9.44772 8.55228 9 8 9C7.44772 9 7 9.44772 7 10C7 10.5523 7.44772 11 8 11C8.55228 11 9 10.5523 9 10ZM11 10C11 11.6569 9.65685 13 8 13C6.34315 13 5 11.6569 5 10C5 8.34315 6.34315 7 8 7C9.65685 7 11 8.34315 11 10ZM8.0018 16C7.03503 16 6.1614 16.3907 5.52693 17.0251L4.11272 15.6109C5.10693 14.6167 6.4833 14 8.0018 14C9.52031 14 10.8967 14.6167 11.8909 15.6109L10.4767 17.0251C9.84221 16.3907 8.96858 16 8.0018 16ZM16.2071 14.7071L20.2071 10.7071L18.7929 9.29289L15.5 12.5858L13.7071 10.7929L12.2929 12.2071L14.7929 14.7071L15.5 15.4142L16.2071 14.7071Z"
  }));
},
    vk = function vk(_ref2444) {
  var _ref2444$color = _ref2444.color,
      C = _ref2444$color === void 0 ? "currentColor" : _ref2444$color,
      _ref2444$size = _ref2444.size,
      e = _ref2444$size === void 0 ? 24 : _ref2444$size,
      l = _ref2444.className,
      i = _objectWithoutProperties(_ref2444, _excluded2444);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19.7134 9.12811L19.4668 9.69379C19.2864 10.1079 18.7136 10.1079 18.5331 9.69379L18.2866 9.12811C17.8471 8.11947 17.0555 7.31641 16.0677 6.87708L15.308 6.53922C14.8973 6.35653 14.8973 5.75881 15.308 5.57612L16.0252 5.25714C17.0384 4.80651 17.8442 3.97373 18.2761 2.93083L18.5293 2.31953C18.7058 1.89349 19.2942 1.89349 19.4706 2.31953L19.7238 2.93083C20.1558 3.97373 20.9616 4.80651 21.9748 5.25714L22.6919 5.57612C23.1027 5.75881 23.1027 6.35653 22.6919 6.53922L21.9323 6.87708C20.9445 7.31641 20.1529 8.11947 19.7134 9.12811ZM6 5C4.89543 5 4 5.89543 4 7V17C4 18.1046 4.89543 19 6 19H18C19.1046 19 20 18.1046 20 17V12H22V17C22 19.2091 20.2091 21 18 21H6C3.79086 21 2 19.2091 2 17V7C2 4.79086 3.79086 3 6 3H13V5H6Z"
  }));
},
    dk = function dk(_ref2445) {
  var _ref2445$color = _ref2445.color,
      C = _ref2445$color === void 0 ? "currentColor" : _ref2445$color,
      _ref2445$size = _ref2445.size,
      e = _ref2445$size === void 0 ? 24 : _ref2445$size,
      l = _ref2445.className,
      i = _objectWithoutProperties(_ref2445, _excluded2445);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9 3V1H7V3H3C2.44772 3 2 3.44772 2 4V20C2 20.5523 2.44772 21 3 21H21C21.5523 21 22 20.5523 22 20V4C22 3.44772 21.5523 3 21 3H17V1H15V3H9ZM4 8H20V19H4V8ZM9.87852 9.9643L11.9999 12.0858L14.1211 9.96432L15.5354 11.3785L13.4141 13.5L15.5353 15.6211L14.1212 17.0354L11.9999 14.9142L9.87845 17.0354L8.46432 15.6211L10.5856 13.5L8.46426 11.3785L9.87852 9.9643Z"
  }));
},
    pk = function pk(_ref2446) {
  var _ref2446$color = _ref2446.color,
      C = _ref2446$color === void 0 ? "currentColor" : _ref2446$color,
      _ref2446$size = _ref2446.size,
      e = _ref2446$size === void 0 ? 24 : _ref2446$size,
      l = _ref2446.className,
      i = _objectWithoutProperties(_ref2446, _excluded2446);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9 3V1H7V3H3C2.44772 3 2 3.44772 2 4V20C2 20.5523 2.44772 21 3 21H21C21.5523 21 22 20.5523 22 20V4C22 3.44772 21.5523 3 21 3H17V1H15V3H9ZM4 10H20V19H4V10ZM4 5H7V6H9V5H15V6H17V5H20V8H4V5ZM9.87862 10.9644L12 13.0858L14.1212 10.9644L15.5355 12.3785L13.4142 14.5001L15.5354 16.6212L14.1213 18.0354L12 15.9143L9.87855 18.0354L8.46442 16.6211L10.5857 14.5001L8.46436 12.3785L9.87862 10.9644Z"
  }));
},
    Ek = function Ek(_ref2447) {
  var _ref2447$color = _ref2447.color,
      C = _ref2447$color === void 0 ? "currentColor" : _ref2447$color,
      _ref2447$size = _ref2447.size,
      e = _ref2447$size === void 0 ? 24 : _ref2447$size,
      l = _ref2447.className,
      i = _objectWithoutProperties(_ref2447, _excluded2447);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8.5 7C9.32843 7 10 6.32843 10 5.5C10 4.67157 9.32843 4 8.5 4C7.67157 4 7 4.67157 7 5.5C7 6.32843 7.67157 7 8.5 7ZM8.5 13.5C9.32843 13.5 10 12.8284 10 12C10 11.1716 9.32843 10.5 8.5 10.5C7.67157 10.5 7 11.1716 7 12C7 12.8284 7.67157 13.5 8.5 13.5ZM10 18.5C10 19.3284 9.32843 20 8.5 20C7.67157 20 7 19.3284 7 18.5C7 17.6716 7.67157 17 8.5 17C9.32843 17 10 17.6716 10 18.5ZM15.5 7C16.3284 7 17 6.32843 17 5.5C17 4.67157 16.3284 4 15.5 4C14.6716 4 14 4.67157 14 5.5C14 6.32843 14.6716 7 15.5 7ZM17 12C17 12.8284 16.3284 13.5 15.5 13.5C14.6716 13.5 14 12.8284 14 12C14 11.1716 14.6716 10.5 15.5 10.5C16.3284 10.5 17 11.1716 17 12ZM15.5 20C16.3284 20 17 19.3284 17 18.5C17 17.6716 16.3284 17 15.5 17C14.6716 17 14 17.6716 14 18.5C14 19.3284 14.6716 20 15.5 20Z"
  }));
},
    Nk = function Nk(_ref2448) {
  var _ref2448$color = _ref2448.color,
      C = _ref2448$color === void 0 ? "currentColor" : _ref2448$color,
      _ref2448$size = _ref2448.size,
      e = _ref2448$size === void 0 ? 24 : _ref2448$size,
      l = _ref2448.className,
      i = _objectWithoutProperties(_ref2448, _excluded2448);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5.55397 22H3.3999L10.9999 3H12.9999L20.5999 22H18.4458L16.0458 16H7.95397L5.55397 22ZM8.75397 14H15.2458L11.9999 5.88517L8.75397 14Z"
  }));
},
    uk = function uk(_ref2449) {
  var _ref2449$color = _ref2449.color,
      C = _ref2449$color === void 0 ? "currentColor" : _ref2449$color,
      _ref2449$size = _ref2449.size,
      e = _ref2449$size === void 0 ? 24 : _ref2449$size,
      l = _ref2449.className,
      i = _objectWithoutProperties(_ref2449, _excluded2449);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6 4H19V6H8V12H18V14H8V21H6V4Z"
  }));
},
    Bk = function Bk(_ref2450) {
  var _ref2450$color = _ref2450.color,
      C = _ref2450$color === void 0 ? "currentColor" : _ref2450$color,
      _ref2450$size = _ref2450.size,
      e = _ref2450$size === void 0 ? 24 : _ref2450$size,
      l = _ref2450.className,
      i = _objectWithoutProperties(_ref2450, _excluded2450);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5 4H19V8H17.5C17 6 17 5 15 5H10V12H13C14 12 15 11.5 15 10H16V15H15C15 13.5 14 13 13 13H10V17.5C10 20 13.5 20 13.5 20V21H5V20C7 19.5 7 18.5 7 17.5V7.5C7 6.5 7 5.5 5 5V4Z"
  }));
},
    fk = function fk(_ref2451) {
  var _ref2451$color = _ref2451.color,
      C = _ref2451$color === void 0 ? "currentColor" : _ref2451$color,
      _ref2451$size = _ref2451.size,
      e = _ref2451$size === void 0 ? 24 : _ref2451$size,
      l = _ref2451.className,
      i = _objectWithoutProperties(_ref2451, _excluded2451);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7 4H19V6H10V12H18V14H10V21H7V4Z"
  }));
},
    Rk = function Rk(_ref2452) {
  var _ref2452$color = _ref2452.color,
      C = _ref2452$color === void 0 ? "currentColor" : _ref2452$color,
      _ref2452$size = _ref2452.size,
      e = _ref2452$size === void 0 ? 24 : _ref2452$size,
      l = _ref2452.className,
      i = _objectWithoutProperties(_ref2452, _excluded2452);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5.5 2C4.99568 2 4.57028 2.37554 4.50772 2.87597L3.00772 14.876C3.00258 14.9171 3 14.9585 3 15V21C3 21.5523 3.44772 22 4 22H20C20.5523 22 21 21.5523 21 21V15C21 14.9585 20.9974 14.9171 20.9923 14.876L19.4923 2.87597C19.4297 2.37554 19.0043 2 18.5 2H5.5ZM5 16H19V20H5V16ZM15 17H17V19H15V17ZM13 17H11V19H13V17Z"
  }));
},
    zk = function zk(_ref2453) {
  var _ref2453$color = _ref2453.color,
      C = _ref2453$color === void 0 ? "currentColor" : _ref2453$color,
      _ref2453$size = _ref2453.size,
      e = _ref2453$size === void 0 ? 24 : _ref2453$size,
      l = _ref2453.className,
      i = _objectWithoutProperties(_ref2453, _excluded2453);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4.50772 2.87597C4.57028 2.37554 4.99568 2 5.5 2H18.5C19.0043 2 19.4297 2.37554 19.4923 2.87597L20.9923 14.876C20.9974 14.9171 21 14.9585 21 15V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V15C3 14.9585 3.00258 14.9171 3.00772 14.876L4.50772 2.87597ZM6.38278 4L5.13278 14H18.8672L17.6172 4H6.38278ZM19 16H5V20H19V16ZM15 17H17V19H15V17ZM13 17H11V19H13V17Z"
  }));
},
    Fk = function Fk(_ref2454) {
  var _ref2454$color = _ref2454.color,
      C = _ref2454$color === void 0 ? "currentColor" : _ref2454$color,
      _ref2454$size = _ref2454.size,
      e = _ref2454$size === void 0 ? 24 : _ref2454$size,
      l = _ref2454.className,
      i = _objectWithoutProperties(_ref2454, _excluded2454);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 3H21V21H3V3ZM10.5637 5.53613H6.25452V18.4635H10.5637V15.5907H12.0001V17.0271H13.4364V18.4635H17.7455V14.1543H16.3091V12.7179H14.8728V11.2816H16.3091V9.8452H17.7455V5.53613H13.4364V6.97249H12.0001V8.40884H10.5637V5.53613Z"
  }));
},
    Sk = function Sk(_ref2455) {
  var _ref2455$color = _ref2455.color,
      C = _ref2455$color === void 0 ? "currentColor" : _ref2455$color,
      _ref2455$size = _ref2455.size,
      e = _ref2455$size === void 0 ? 24 : _ref2455$size,
      l = _ref2455.className,
      i = _objectWithoutProperties(_ref2455, _excluded2455);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 1.99976H11.0001V3.99974H13.0001V1.99976H21V9.99969H19V13.9996H21V21.9997H13.0001V19.9998H11.0001V21.9997H3V1.99976ZM13.0001 17.9998H15.0001V19.9997H19V15.9996H17V13.9997H15V9.99967H17V7.99969H19V3.99976H15.0001V5.99974H13.0001V7.99972H9.0001V3.99976H5V19.9997H9.0001V15.9998H13.0001V17.9998Z"
  }));
},
    Ak = function Ak(_ref2456) {
  var _ref2456$color = _ref2456.color,
      C = _ref2456$color === void 0 ? "currentColor" : _ref2456$color,
      _ref2456$size = _ref2456.size,
      e = _ref2456$size === void 0 ? 24 : _ref2456$size,
      l = _ref2456.className,
      i = _objectWithoutProperties(_ref2456, _excluded2456);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8.00008 6V9H5.00008V6H8.00008ZM3.00008 4V11H10.0001V4H3.00008ZM13.0001 4H21.0001V6H13.0001V4ZM13.0001 11H21.0001V13H13.0001V11ZM13.0001 18H21.0001V20H13.0001V18ZM10.7072 16.2071L9.29297 14.7929L6.00008 18.0858L4.20718 16.2929L2.79297 17.7071L6.00008 20.9142L10.7072 16.2071Z"
  }));
},
    kk = function kk(_ref2457) {
  var _ref2457$color = _ref2457.color,
      C = _ref2457$color === void 0 ? "currentColor" : _ref2457$color,
      _ref2457$size = _ref2457.size,
      e = _ref2457$size === void 0 ? 24 : _ref2457$size,
      l = _ref2457.className,
      i = _objectWithoutProperties(_ref2457, _excluded2457);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13 4H21V6H13V4ZM13 11H21V13H13V11ZM13 18H21V20H13V18ZM6.5 19C5.39543 19 4.5 18.1046 4.5 17C4.5 15.8954 5.39543 15 6.5 15C7.60457 15 8.5 15.8954 8.5 17C8.5 18.1046 7.60457 19 6.5 19ZM6.5 21C8.70914 21 10.5 19.2091 10.5 17C10.5 14.7909 8.70914 13 6.5 13C4.29086 13 2.5 14.7909 2.5 17C2.5 19.2091 4.29086 21 6.5 21ZM5 6V9H8V6H5ZM3 4H10V11H3V4Z"
  }));
},
    Pk = function Pk(_ref2458) {
  var _ref2458$color = _ref2458.color,
      C = _ref2458$color === void 0 ? "currentColor" : _ref2458$color,
      _ref2458$size = _ref2458.size,
      e = _ref2458$size === void 0 ? 24 : _ref2458$size,
      l = _ref2458.className,
      i = _objectWithoutProperties(_ref2458, _excluded2458);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5.75024 3.5H4.71733L3.25 3.89317V5.44582L4.25002 5.17782L4.25018 8.5H3V10H7V8.5H5.75024V3.5ZM10 4H21V6H10V4ZM10 11H21V13H10V11ZM10 18H21V20H10V18ZM2.875 15.625C2.875 14.4514 3.82639 13.5 5 13.5C6.17361 13.5 7.125 14.4514 7.125 15.625C7.125 16.1106 6.96183 16.5587 6.68747 16.9167L6.68271 16.9229L5.31587 18.5H7V20H3.00012L2.99959 18.8786L5.4717 16.035C5.5673 15.9252 5.625 15.7821 5.625 15.625C5.625 15.2798 5.34518 15 5 15C4.67378 15 4.40573 15.2501 4.37747 15.5688L4.3651 15.875H2.875V15.625Z"
  }));
},
    Dk = function Dk(_ref2459) {
  var _ref2459$color = _ref2459.color,
      C = _ref2459$color === void 0 ? "currentColor" : _ref2459$color,
      _ref2459$size = _ref2459.size,
      e = _ref2459$size === void 0 ? 24 : _ref2459$size,
      l = _ref2459.className,
      i = _objectWithoutProperties(_ref2459, _excluded2459);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8.5 7C8.5 5.89543 7.60457 5 6.5 5C5.39543 5 4.5 5.89543 4.5 7C4.5 8.10457 5.39543 9 6.5 9C7.60457 9 8.5 8.10457 8.5 7ZM10.5 7C10.5 9.20914 8.70914 11 6.5 11C4.29086 11 2.5 9.20914 2.5 7C2.5 4.79086 4.29086 3 6.5 3C8.70914 3 10.5 4.79086 10.5 7ZM21 4H13V6H21V4ZM21 11H13V13H21V11ZM21 18H13V20H21V18ZM6.5 19C5.39543 19 4.5 18.1046 4.5 17C4.5 15.8954 5.39543 15 6.5 15C7.60457 15 8.5 15.8954 8.5 17C8.5 18.1046 7.60457 19 6.5 19ZM6.5 21C8.70914 21 10.5 19.2091 10.5 17C10.5 14.7909 8.70914 13 6.5 13C4.29086 13 2.5 14.7909 2.5 17C2.5 19.2091 4.29086 21 6.5 21ZM6.5 8C7.05228 8 7.5 7.55228 7.5 7C7.5 6.44772 7.05228 6 6.5 6C5.94772 6 5.5 6.44772 5.5 7C5.5 7.55228 5.94772 8 6.5 8Z"
  }));
},
    yk = function yk(_ref2460) {
  var _ref2460$color = _ref2460.color,
      C = _ref2460$color === void 0 ? "currentColor" : _ref2460$color,
      _ref2460$size = _ref2460.size,
      e = _ref2460$size === void 0 ? 24 : _ref2460$size,
      l = _ref2460.className,
      i = _objectWithoutProperties(_ref2460, _excluded2460);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.0001 2.76001L21.9992 5.996L21.1001 15.464L12.0001 22.3235L2.90012 15.46L2.01074 6.00001L12.0001 2.76001ZM12.0001 3.58535L3.18898 6.43501L12.0001 20.7932L20.8058 6.43501L12.0001 3.58535Z"
  }));
},
    bk = function bk(_ref2461) {
  var _ref2461$color = _ref2461.color,
      C = _ref2461$color === void 0 ? "currentColor" : _ref2461$color,
      _ref2461$size = _ref2461.size,
      e = _ref2461$size === void 0 ? 24 : _ref2461$size,
      l = _ref2461.className,
      i = _objectWithoutProperties(_ref2461, _excluded2461);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 3L2 5.996L3 15.46L12 22.5L21 15.46L22 5.996L12 3ZM19.8367 7.43572L12 19.9608L4.16326 7.43572L12 5.08783L19.8367 7.43572Z"
  }));
},
    Tk = function Tk(_ref2462) {
  var _ref2462$color = _ref2462.color,
      C = _ref2462$color === void 0 ? "currentColor" : _ref2462$color,
      _ref2462$size = _ref2462.size,
      e = _ref2462$size === void 0 ? 24 : _ref2462$size,
      l = _ref2462.className,
      i = _objectWithoutProperties(_ref2462, _excluded2462);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5.32244 5.96559C5.42367 5.85376 5.5282 5.74386 5.63604 5.63602C6.11945 5.15261 6.64417 4.73569 7.19883 4.38526C6.8849 4.29873 6.60274 4.24748 6.35542 4.22882C5.78308 4.18566 5.53243 4.32157 5.42553 4.42847C5.31863 4.53537 5.18272 4.78602 5.22589 5.35835C5.23974 5.54197 5.27156 5.74481 5.32244 5.96559ZM20.7257 14.2107C20.7873 14.3337 20.8463 14.4557 20.9028 14.5766C21.3793 15.5977 21.6941 16.5944 21.7616 17.4903C21.8289 18.3819 21.656 19.3107 20.9819 19.9848C20.3077 20.659 19.379 20.8318 18.4874 20.7646C17.7068 20.7057 16.8497 20.4592 15.9666 20.0815L15.964 20.0827C15.8109 20.0172 15.657 19.9478 15.5025 19.8746C13.4695 18.9123 11.1435 17.2205 8.9599 15.0369C6.77855 12.8556 5.08807 10.5322 4.1252 8.50073C4.05178 8.34582 3.98205 8.19148 3.91629 8.03796L3.91734 8.03582C3.53815 7.15052 3.29057 6.29122 3.23155 5.50877C3.1643 4.61713 3.33717 3.6884 4.01132 3.01425C4.68547 2.34011 5.61419 2.16724 6.50583 2.23449C7.40174 2.30206 8.3984 2.61685 9.41949 3.09335C9.54253 3.15077 9.66667 3.21089 9.79181 3.27366C12.7623 2.52497 16.0404 3.31242 18.364 5.63602C20.6882 7.96029 21.4755 11.2395 20.7257 14.2107ZM19.6128 16.8042C19.2627 17.3578 18.8465 17.8814 18.364 18.3639C18.257 18.4709 18.1479 18.5747 18.037 18.6752C18.2553 18.7252 18.456 18.7565 18.6378 18.7702C19.2101 18.8134 19.4608 18.6775 19.5677 18.5706C19.6746 18.4637 19.8105 18.2131 19.7673 17.6407C19.7488 17.3952 19.6982 17.1154 19.6128 16.8042ZM5.63604 18.3639C3.37241 16.1003 2.56666 12.9309 3.21877 10.0224C4.30105 12.0032 5.92374 14.1221 7.89924 16.0976C9.87632 18.0747 11.9971 19.6985 13.9794 20.7808C11.0705 21.4337 7.90015 20.6281 5.63604 18.3639Z"
  }));
},
    Uk = function Uk(_ref2463) {
  var _ref2463$color = _ref2463.color,
      C = _ref2463$color === void 0 ? "currentColor" : _ref2463$color,
      _ref2463$size = _ref2463.size,
      e = _ref2463$size === void 0 ? 24 : _ref2463$size,
      l = _ref2463.className,
      i = _objectWithoutProperties(_ref2463, _excluded2463);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3.91762 8.03672C3.32984 9.2334 3 10.5794 3 12C3 16.9705 7.02944 21 12 21C13.4216 21 14.7684 20.6697 15.9657 20.0812C16.8385 20.4545 17.6848 20.6993 18.4564 20.7622C19.3582 20.8357 20.3 20.6666 20.9818 19.9848C21.7339 19.2327 21.8625 18.169 21.7279 17.1728C21.6052 16.2639 21.2481 15.2539 20.726 14.2116C20.9051 13.5031 21 12.762 21 12C21 7.02942 16.9706 2.99998 12 2.99998C11.2389 2.99998 10.4987 3.09467 9.79103 3.27331C8.7474 2.74993 7.73605 2.39184 6.8261 2.26846C5.82897 2.13327 4.76406 2.26141 4.01121 3.01425C3.3287 3.69676 3.16001 4.63968 3.2341 5.54245C3.29752 6.31512 3.54313 7.16259 3.91762 8.03672ZM5.3224 5.96587C5.2734 5.75333 5.24204 5.55727 5.2274 5.37885C5.17928 4.79255 5.31727 4.53661 5.42543 4.42846C5.54452 4.30937 5.84797 4.15415 6.55739 4.25033C6.75482 4.2771 6.96951 4.32201 7.2 4.38559C6.50364 4.82539 5.87203 5.35796 5.3224 5.96587ZM19.6124 16.8031C19.6751 17.0317 19.7195 17.2446 19.7459 17.4405C19.8416 18.1487 19.6865 18.4516 19.5676 18.5706C19.4595 18.6786 19.204 18.8165 18.6189 18.7688C18.4419 18.7543 18.2475 18.7234 18.0368 18.6751C18.6427 18.1269 19.1736 17.4972 19.6124 16.8031ZM15.8812 17.8265C14.2046 16.9483 12.2571 15.5027 10.3752 13.6209C8.4954 11.7411 7.05092 9.79573 6.17241 8.1204C7.06357 6.78477 8.40124 5.77324 9.96933 5.29879C10.6108 5.10469 11.2923 4.99998 12 4.99998C15.866 4.99998 19 8.13399 19 12C19 12.7084 18.8951 13.3905 18.7006 14.0326C18.2261 15.5992 17.2155 16.9357 15.8812 17.8265ZM13.6052 18.8153C13.0901 18.9361 12.5528 19 12 19C8.13401 19 5 15.866 5 12C5 11.4478 5.06377 10.911 5.18429 10.3964C6.14883 11.9131 7.43475 13.5089 8.96096 15.0351C10.489 16.5631 12.0868 17.8503 13.6052 18.8153Z"
  }));
},
    Gk = function Gk(_ref2464) {
  var _ref2464$color = _ref2464.color,
      C = _ref2464$color === void 0 ? "currentColor" : _ref2464$color,
      _ref2464$size = _ref2464.size,
      e = _ref2464$size === void 0 ? 24 : _ref2464$size,
      l = _ref2464.className,
      i = _objectWithoutProperties(_ref2464, _excluded2464);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19.7429 18.3287C21.1536 16.6049 22 14.4013 22 12C22 6.47715 17.5228 2 12 2C9.59873 2 7.39514 2.84637 5.67127 4.25705L19.7429 18.3287ZM4.25705 5.67127C2.84637 7.39514 2 9.59873 2 12C2 17.5228 6.47715 22 12 22C14.4013 22 16.6049 21.1536 18.3287 19.7429L4.25705 5.67127Z"
  }));
},
    Ik = function Ik(_ref2465) {
  var _ref2465$color = _ref2465.color,
      C = _ref2465$color === void 0 ? "currentColor" : _ref2465$color,
      _ref2465$size = _ref2465.size,
      e = _ref2465$size === void 0 ? 24 : _ref2465$size,
      l = _ref2465.className,
      i = _objectWithoutProperties(_ref2465, _excluded2465);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7.0943 5.68009L18.3199 16.9057C19.3736 15.5506 20 13.8491 20 12C20 7.58172 16.4183 4 12 4C10.1509 4 8.44939 4.62644 7.0943 5.68009ZM16.9057 18.3199L5.68009 7.0943C4.62644 8.44939 4 10.1509 4 12C4 16.4183 7.58172 20 12 20C13.8491 20 15.5506 19.3736 16.9057 18.3199ZM4.92893 4.92893C6.73748 3.12038 9.23885 2 12 2C17.5228 2 22 6.47715 22 12C22 14.7611 20.8796 17.2625 19.0711 19.0711C17.2625 20.8796 14.7611 22 12 22C6.47715 22 2 17.5228 2 12C2 9.23885 3.12038 6.73748 4.92893 4.92893Z"
  }));
},
    Wk = function Wk(_ref2466) {
  var _ref2466$color = _ref2466.color,
      C = _ref2466$color === void 0 ? "currentColor" : _ref2466$color,
      _ref2466$size = _ref2466.size,
      e = _ref2466$size === void 0 ? 24 : _ref2466$size,
      l = _ref2466.className,
      i = _objectWithoutProperties(_ref2466, _excluded2466);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 4H3V6H21V4ZM21 11H8V13H21V11ZM21 18H8V20H21V18ZM5 11H3V20H5V11Z"
  }));
},
    Ok = function Ok(_ref2467) {
  var _ref2467$color = _ref2467.color,
      C = _ref2467$color === void 0 ? "currentColor" : _ref2467$color,
      _ref2467$size = _ref2467.size,
      e = _ref2467$size === void 0 ? 24 : _ref2467$size,
      l = _ref2467.className,
      i = _objectWithoutProperties(_ref2467, _excluded2467);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8 3C4.13401 3 1 6.13401 1 10C1 13.866 4.13401 17 8 17H9.07089C9.02417 16.6734 9 16.3395 9 16C9 15.6605 9.02417 15.3266 9.07089 15H8C5.23858 15 3 12.7614 3 10C3 7.23858 5.23858 5 8 5H16C18.7614 5 21 7.23858 21 10C21 10.3428 20.9655 10.6775 20.8998 11.0008C21.4853 11.5748 21.9704 12.2508 22.3264 13C22.7583 12.0907 23 11.0736 23 10C23 6.13401 19.866 3 16 3H8ZM11 16C11 13.2386 13.2386 11 16 11C18.7614 11 21 13.2386 21 16C21 17.0191 20.6951 17.967 20.1716 18.7574L22.7071 21.2929L21.2929 22.7071L18.7574 20.1716C17.967 20.6951 17.0191 21 16 21C13.2386 21 11 18.7614 11 16Z"
  }));
},
    Kk = function Kk(_ref2468) {
  var _ref2468$color = _ref2468.color,
      C = _ref2468$color === void 0 ? "currentColor" : _ref2468$color,
      _ref2468$size = _ref2468.size,
      e = _ref2468$size === void 0 ? 24 : _ref2468$size,
      l = _ref2468.className,
      i = _objectWithoutProperties(_ref2468, _excluded2468);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8 3C4.13401 3 1 6.13401 1 10C1 13.866 4.13401 17 8 17H9.07089C9.02417 16.6734 9 16.3395 9 16C9 15.6605 9.02417 15.3266 9.07089 15H8C5.23858 15 3 12.7614 3 10C3 7.23858 5.23858 5 8 5H16C18.7614 5 21 7.23858 21 10C21 10.3428 20.9655 10.6775 20.8998 11.0008C21.4853 11.5748 21.9704 12.2508 22.3264 13C22.7583 12.0907 23 11.0736 23 10C23 6.13401 19.866 3 16 3H8ZM16 13C14.3431 13 13 14.3431 13 16C13 17.6569 14.3431 19 16 19C17.6569 19 19 17.6569 19 16C19 14.3431 17.6569 13 16 13ZM11 16C11 13.2386 13.2386 11 16 11C18.7614 11 21 13.2386 21 16C21 17.0191 20.6951 17.967 20.1716 18.7574L22.7071 21.2929L21.2929 22.7071L18.7574 20.1716C17.967 20.6951 17.0191 21 16 21C13.2386 21 11 18.7614 11 16Z"
  }));
},
    Qk = function Qk(_ref2469) {
  var _ref2469$color = _ref2469.color,
      C = _ref2469$color === void 0 ? "currentColor" : _ref2469$color,
      _ref2469$size = _ref2469.size,
      e = _ref2469$size === void 0 ? 24 : _ref2469$size,
      l = _ref2469.className,
      i = _objectWithoutProperties(_ref2469, _excluded2469);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 3H5V7H3V3ZM9.78839 21H7.66003L14.2115 3H16.3398L9.78839 21ZM21 3H19V7H21V3Z"
  }));
},
    qk = function qk(_ref2470) {
  var _ref2470$color = _ref2470.color,
      C = _ref2470$color === void 0 ? "currentColor" : _ref2470$color,
      _ref2470$size = _ref2470.size,
      e = _ref2470$size === void 0 ? 24 : _ref2470$size,
      l = _ref2470.className,
      i = _objectWithoutProperties(_ref2470, _excluded2470);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22 20V7L20 3H4L2 7.00353V20C2 20.5523 2.44772 21 3 21H21C21.5523 21 22 20.5523 22 20ZM5.23582 5H18.7638L19.7638 7H4.23682L5.23582 5ZM9 11H15V13H9V11Z"
  }));
},
    jk = function jk(_ref2471) {
  var _ref2471$color = _ref2471.color,
      C = _ref2471$color === void 0 ? "currentColor" : _ref2471$color,
      _ref2471$size = _ref2471.size,
      e = _ref2471$size === void 0 ? 24 : _ref2471$size,
      l = _ref2471.className,
      i = _objectWithoutProperties(_ref2471, _excluded2471);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22 20V7L20 3H4L2 7.00353V20C2 20.5523 2.44772 21 3 21H21C21.5523 21 22 20.5523 22 20ZM4 9H20V19H4V9ZM5.236 5H18.764L19.764 7H4.237L5.236 5ZM15 11H9V13H15V11Z"
  }));
},
    Xk = function Xk(_ref2472) {
  var _ref2472$color = _ref2472.color,
      C = _ref2472$color === void 0 ? "currentColor" : _ref2472$color,
      _ref2472$size = _ref2472.size,
      e = _ref2472$size === void 0 ? 24 : _ref2472$size,
      l = _ref2472.className,
      i = _objectWithoutProperties(_ref2472, _excluded2472);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5 3C4.5313 3 4.12549 3.32553 4.02381 3.78307L2.02381 12.7831C2.00799 12.8543 2 12.927 2 13V20C2 20.5523 2.44772 21 3 21H21C21.5523 21 22 20.5523 22 20V13C22 12.927 21.992 12.8543 21.9762 12.7831L19.9762 3.78307C19.8745 3.32553 19.4687 3 19 3H5ZM19.7534 12H15C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12H4.24662L5.80217 5H18.1978L19.7534 12Z"
  }));
},
    Jk = function Jk(_ref2473) {
  var _ref2473$color = _ref2473.color,
      C = _ref2473$color === void 0 ? "currentColor" : _ref2473$color,
      _ref2473$size = _ref2473.size,
      e = _ref2473$size === void 0 ? 24 : _ref2473$size,
      l = _ref2473.className,
      i = _objectWithoutProperties(_ref2473, _excluded2473);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4.02381 3.78307C4.12549 3.32553 4.5313 3 5 3H19C19.4687 3 19.8745 3.32553 19.9762 3.78307L21.9762 12.7831C21.992 12.8543 22 12.927 22 13V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V13C2 12.927 2.00799 12.8543 2.02381 12.7831L4.02381 3.78307ZM5.80217 5L4.24662 12H9C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12H19.7534L18.1978 5H5.80217ZM16.584 14C15.8124 15.7659 14.0503 17 12 17C9.94968 17 8.1876 15.7659 7.41604 14H4V19H20V14H16.584Z"
  }));
},
    Yk = function Yk(_ref2474) {
  var _ref2474$color = _ref2474.color,
      C = _ref2474$color === void 0 ? "currentColor" : _ref2474$color,
      _ref2474$size = _ref2474.size,
      e = _ref2474$size === void 0 ? 24 : _ref2474$size,
      l = _ref2474.className,
      i = _objectWithoutProperties(_ref2474, _excluded2474);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19.2914 5.99994H20.0002C20.5525 5.99994 21.0002 6.44766 21.0002 6.99994V13.9999C21.0002 14.5522 20.5525 14.9999 20.0002 14.9999H18.0002L13.8319 9.16427C13.3345 8.46797 12.4493 8.16522 11.6297 8.41109L9.14444 9.15668C8.43971 9.3681 7.6758 9.17551 7.15553 8.65524L6.86277 8.36247C6.41655 7.91626 6.49011 7.17336 7.01517 6.82332L12.4162 3.22262C13.0752 2.78333 13.9312 2.77422 14.5994 3.1994L18.7546 5.8436C18.915 5.94571 19.1013 5.99994 19.2914 5.99994ZM5.02708 14.2947L3.41132 15.7085C2.93991 16.1209 2.95945 16.8603 3.45201 17.2474L8.59277 21.2865C9.07284 21.6637 9.77592 21.5264 10.0788 20.9963L10.7827 19.7645C11.2127 19.012 11.1091 18.0682 10.5261 17.4269L7.82397 14.4545C7.09091 13.6481 5.84722 13.5771 5.02708 14.2947ZM7.04557 5H3C2.44772 5 2 5.44772 2 6V13.5158C2 13.9242 2.12475 14.3173 2.35019 14.6464C2.3741 14.6238 2.39856 14.6015 2.42357 14.5796L4.03933 13.1658C5.47457 11.91 7.65103 12.0343 8.93388 13.4455L11.6361 16.4179C12.6563 17.5401 12.8376 19.1918 12.0851 20.5087L11.4308 21.6538C11.9937 21.8671 12.635 21.819 13.169 21.4986L17.5782 18.8531C18.0786 18.5528 18.2166 17.8896 17.8776 17.4146L12.6109 10.0361C12.4865 9.86205 12.2652 9.78636 12.0603 9.84783L9.57505 10.5934C8.34176 10.9634 7.00492 10.6264 6.09446 9.7159L5.80169 9.42313C4.68615 8.30759 4.87005 6.45035 6.18271 5.57524L7.04557 5Z"
  }));
},
    _k = function _k(_ref2475) {
  var _ref2475$color = _ref2475.color,
      C = _ref2475$color === void 0 ? "currentColor" : _ref2475$color,
      _ref2475$size = _ref2475.size,
      e = _ref2475$size === void 0 ? 24 : _ref2475$size,
      l = _ref2475.className,
      i = _objectWithoutProperties(_ref2475, _excluded2475);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11.8611 2.39057C12.8495 1.73163 14.1336 1.71797 15.1358 2.35573L19.291 4.99994H20.9998C21.5521 4.99994 21.9998 5.44766 21.9998 5.99994V14.9999C21.9998 15.5522 21.5521 15.9999 20.9998 15.9999H19.4801C19.5396 16.9472 19.0933 17.9102 18.1955 18.4489L13.1021 21.505C12.4591 21.8907 11.6609 21.8817 11.0314 21.4974C10.3311 22.1167 9.2531 22.1849 8.47104 21.5704L3.33028 17.5312C2.56387 16.9291 2.37006 15.9003 2.76579 15.0847C2.28248 14.7057 2 14.1254 2 13.5109V6C2 5.44772 2.44772 5 3 5H7.94693L11.8611 2.39057ZM4.17264 13.6452L4.86467 13.0397C6.09488 11.9632 7.96042 12.0698 9.06001 13.2794L11.7622 16.2518C12.6317 17.2083 12.7903 18.6135 12.1579 19.739L17.1665 16.7339C17.4479 16.5651 17.5497 16.2276 17.4448 15.9433L13.0177 9.74551C12.769 9.39736 12.3264 9.24598 11.9166 9.36892L9.43135 10.1145C8.37425 10.4316 7.22838 10.1427 6.44799 9.36235L6.15522 9.06958C5.58721 8.50157 5.44032 7.69318 5.67935 7H4V13.5109L4.17264 13.6452ZM14.0621 4.04306C13.728 3.83047 13.3 3.83502 12.9705 4.05467L7.56943 7.65537L7.8622 7.94814C8.12233 8.20827 8.50429 8.30456 8.85666 8.19885L11.3419 7.45327C12.5713 7.08445 13.8992 7.53859 14.6452 8.58303L18.5144 13.9999H19.9998V6.99994H19.291C18.9106 6.99994 18.5381 6.89148 18.2172 6.68727L14.0621 4.04306ZM6.18168 14.5448L4.56593 15.9586L9.70669 19.9978L10.4106 18.7659C10.6256 18.3897 10.5738 17.9178 10.2823 17.5971L7.58013 14.6247C7.2136 14.2215 6.59175 14.186 6.18168 14.5448Z"
  }));
},
    $k = function $k(_ref2476) {
  var _ref2476$color = _ref2476.color,
      C = _ref2476$color === void 0 ? "currentColor" : _ref2476$color,
      _ref2476$size = _ref2476.size,
      e = _ref2476$size === void 0 ? 24 : _ref2476$size,
      l = _ref2476.className,
      i = _objectWithoutProperties(_ref2476, _excluded2476);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3.08378 15.25C1.42044 15.25 0.483971 13.3378 1.5038 12.0237L10.2099 0.806317C10.794 0.053716 11.9999 0.466765 11.9999 1.41944V8.74999H20.9159C22.5793 8.74999 23.5157 10.6622 22.4959 11.9762L13.7898 23.1937C13.2057 23.9463 11.9999 23.5332 11.9999 22.5805V15.25H3.08378Z"
  }));
},
    eP = function eP(_ref2477) {
  var _ref2477$color = _ref2477.color,
      C = _ref2477$color === void 0 ? "currentColor" : _ref2477$color,
      _ref2477$size = _ref2477.size,
      e = _ref2477$size === void 0 ? 24 : _ref2477$size,
      l = _ref2477.className,
      i = _objectWithoutProperties(_ref2477, _excluded2477);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10.9997 2.59833V13.9694H3.90013C3.23055 13.9694 2.83063 13.1846 3.25654 12.6326L10.9997 2.59833ZM12.9997 8.03061V2.33296C12.9997 0.521514 10.7034 -0.291434 9.58194 1.16185L1.67316 11.4108C0.246185 13.26 1.54768 15.9694 3.90013 15.9694H10.9997V21.6671C10.9997 23.4785 13.296 24.2915 14.4175 22.8382L22.3262 12.5892C23.7532 10.74 22.4517 8.03061 20.0993 8.03061H12.9997ZM12.9997 10.0306H20.0993C20.7688 10.0306 21.1688 10.8155 20.7429 11.3674L12.9997 21.4017V10.0306Z"
  }));
},
    tP = function tP(_ref2478) {
  var _ref2478$color = _ref2478.color,
      C = _ref2478$color === void 0 ? "currentColor" : _ref2478$color,
      _ref2478$size = _ref2478.size,
      e = _ref2478$size === void 0 ? 24 : _ref2478$size,
      l = _ref2478.className,
      i = _objectWithoutProperties(_ref2478, _excluded2478);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 0.269043L5.63604 6.633C2.12132 10.1477 2.12132 15.8462 5.63604 19.3609C9.15076 22.8756 14.8492 22.8756 18.364 19.3609C21.8787 15.8462 21.8787 10.1477 18.364 6.633L12 0.269043ZM16.2427 10.1714L9.17161 17.2425L7.7574 15.8282L14.8285 8.75718L16.2427 10.1714ZM8.11095 9.11073C8.69674 8.52494 9.64648 8.52494 10.2323 9.11073C10.8181 9.69652 10.8181 10.6463 10.2323 11.232C9.64648 11.8178 8.69674 11.8178 8.11095 11.232C7.52516 10.6463 7.52516 9.69652 8.11095 9.11073ZM15.8891 16.8889C15.3033 17.4747 14.3536 17.4747 13.7678 16.8889C13.182 16.3031 13.182 15.3534 13.7678 14.7676C14.3536 14.1818 15.3033 14.1818 15.8891 14.7676C16.4749 15.3534 16.4749 16.3031 15.8891 16.8889Z"
  }));
},
    CP = function CP(_ref2479) {
  var _ref2479$color = _ref2479.color,
      C = _ref2479$color === void 0 ? "currentColor" : _ref2479$color,
      _ref2479$size = _ref2479.size,
      e = _ref2479$size === void 0 ? 24 : _ref2479$size,
      l = _ref2479.className,
      i = _objectWithoutProperties(_ref2479, _excluded2479);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7.05025 8.04673L12 3.09698L16.9497 8.04673C19.6834 10.7804 19.6834 15.2126 16.9497 17.9462C14.2161 20.6799 9.78392 20.6799 7.05025 17.9462C4.31658 15.2126 4.31658 10.7804 7.05025 8.04673ZM18.364 6.63252L12 0.268555L5.63604 6.63252C2.12132 10.1472 2.12132 15.8457 5.63604 19.3604C9.15076 22.8752 14.8492 22.8752 18.364 19.3604C21.8787 15.8457 21.8787 10.1472 18.364 6.63252ZM16.2427 10.1714L14.8285 8.75718L7.7574 15.8282L9.17161 17.2425L16.2427 10.1714ZM8.11095 11.232C8.69674 11.8178 9.64648 11.8178 10.2323 11.232C10.8181 10.6463 10.8181 9.69652 10.2323 9.11073C9.64648 8.52494 8.69674 8.52494 8.11095 9.11073C7.52516 9.69652 7.52516 10.6463 8.11095 11.232ZM15.8891 16.8889C15.3033 17.4747 14.3536 17.4747 13.7678 16.8889C13.182 16.3031 13.182 15.3534 13.7678 14.7676C14.3536 14.1818 15.3033 14.1818 15.8891 14.7676C16.4749 15.3534 16.4749 16.3031 15.8891 16.8889Z"
  }));
},
    lP = function lP(_ref2480) {
  var _ref2480$color = _ref2480.color,
      C = _ref2480$color === void 0 ? "currentColor" : _ref2480$color,
      _ref2480$size = _ref2480.size,
      e = _ref2480$size === void 0 ? 24 : _ref2480$size,
      l = _ref2480.className,
      i = _objectWithoutProperties(_ref2480, _excluded2480);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17.2809 2.95549C20.2499 3.1584 21.0363 5.29655 21.1199 5.5524L22.4167 5.64758C22.5466 5.64758 22.5858 5.82844 22.471 5.88421C21.148 6.60011 20.7438 8.05479 20.9814 9.00236C21.071 9.35974 21.2346 9.69179 21.3932 10.0224C21.6998 10.6637 22.0441 11.4403 22.1003 13.0033C22.2168 16.2423 19.5895 19.1778 16.3115 19.5956C17.4813 18.4088 18.1256 17.1518 18.4313 16.2207C19.0373 14.375 18.9393 12.9046 18.4857 11.781C18.0385 10.6732 17.2806 9.98965 16.7036 9.63988C15.021 8.62006 13.4846 8.54938 12.2604 8.878C12.7253 8.28379 13.1361 7.6768 13.4596 7.01357C14.0436 5.36416 13.3581 4.1657 12.7563 3.49525C12.5642 3.24941 12.695 2.83984 13.0607 2.83984C14.4703 2.83984 15.8737 2.8604 17.2809 2.95549ZM3.31872 19.1067C5.24275 16.9048 8.0315 13.7133 10.4814 10.9564C11.04 10.3277 13.2499 8.61858 16.2285 10.424C17.1068 10.9564 18.6589 12.589 17.5605 15.9349C16.7576 18.3804 13.1532 23.7301 1.80115 21.7784C1.5741 21.7394 1.29 21.4242 1.58312 21.0905C1.99794 20.6183 2.59759 19.932 3.31872 19.1067Z"
  }));
},
    iP = function iP(_ref2481) {
  var _ref2481$color = _ref2481.color,
      C = _ref2481$color === void 0 ? "currentColor" : _ref2481$color,
      _ref2481$size = _ref2481.size,
      e = _ref2481$size === void 0 ? 24 : _ref2481$size,
      l = _ref2481.className,
      i = _objectWithoutProperties(_ref2481, _excluded2481);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11.5054 3.04297C11.669 2.75871 11.972 2.5835 12.3 2.5835C13.8467 2.5835 15.3904 2.63208 16.9367 2.73657C19.4462 2.90807 20.6379 4.32779 21.1168 5.16761C21.7132 5.25937 22.5053 5.25541 22.6883 5.97391C22.8288 6.52563 22.4713 6.80718 22.1338 7.12209C21.6507 7.57285 21.0015 8.29822 21.1799 9.0099C21.2355 9.23162 21.3389 9.44722 21.4959 9.77487L21.4975 9.77833C21.8163 10.4451 22.1819 11.288 22.2397 12.8931C22.3958 17.2336 18.644 19.7895 14.9881 19.9721C12.5773 21.7881 8.6429 22.9978 2.43068 21.9298C2.0357 21.8619 1.6727 21.5949 1.48562 21.2213C1.38225 21.0148 1.32573 20.7609 1.36515 20.4856C1.40453 20.2106 1.53081 19.9746 1.69602 19.7865C4.92443 16.111 8.33058 12.54 11.3498 8.68839C11.8761 8.01712 12.3106 7.40861 12.5009 7.0405C12.8087 6.12122 12.4912 5.5962 11.8748 4.57707C11.5926 4.11045 11.1855 3.59904 11.5054 3.04297ZM13.4938 8.88635C14.3682 8.89147 15.3448 9.13482 16.3787 9.76144C18.5029 11.049 18.7134 13.7574 18.004 15.9183C17.84 16.4179 17.5722 17.0164 17.1676 17.6447C19.1038 16.8482 20.4867 15.161 20.4075 12.959C20.3615 11.679 20.0913 11.0875 19.8441 10.5704C19.8346 10.5505 19.8248 10.5302 19.8147 10.5093C19.6818 10.2329 19.5038 9.86323 19.4017 9.45585C19.1309 8.37597 19.577 7.41686 20.0157 6.77846C19.8359 6.66654 19.6969 6.49362 19.6287 6.28509C19.6287 6.28509 19.629 6.28594 19.6281 6.28383C19.6159 6.25255 19.4495 5.85255 19.0499 5.46714C18.6421 5.07386 17.9553 4.64385 16.8127 4.56571C15.85 4.50066 14.8873 4.45784 13.9231 4.43548C14.3747 5.31428 14.6813 6.37679 14.2117 7.70301C14.0609 8.12885 13.7525 8.52245 13.4938 8.88635ZM12.6619 10.8309C11.9432 11.0333 11.4483 11.4605 11.2837 11.6457C8.56713 14.7028 5.40256 18.3349 3.70758 20.2726C9.15721 21.0204 12.3092 19.7821 14.0856 18.3514C15.3813 17.308 16.0109 16.1118 16.2621 15.3465C16.6965 14.0235 16.7989 12.16 15.4284 11.3293C14.2752 10.6303 13.3405 10.6397 12.6619 10.8309Z"
  }));
},
    sP = function sP(_ref2482) {
  var _ref2482$color = _ref2482.color,
      C = _ref2482$color === void 0 ? "currentColor" : _ref2482$color,
      _ref2482$size = _ref2482.size,
      e = _ref2482$size === void 0 ? 24 : _ref2482$size,
      l = _ref2482.className,
      i = _objectWithoutProperties(_ref2482, _excluded2482);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11 5.07089C7.93431 5.5094 5.5094 7.93431 5.07089 11H7V13H5.07089C5.5094 16.0657 7.93431 18.4906 11 18.9291V17H13V18.9291C16.0657 18.4906 18.4906 16.0657 18.9291 13H17V11H18.9291C18.4906 7.93431 16.0657 5.5094 13 5.07089V7H11V5.07089ZM3.05493 11C3.51608 6.82838 6.82838 3.51608 11 3.05493V1H13V3.05493C17.1716 3.51608 20.4839 6.82838 20.9451 11H23V13H20.9451C20.4839 17.1716 17.1716 20.4839 13 20.9451V23H11V20.9451C6.82838 20.4839 3.51608 17.1716 3.05493 13H1V11H3.05493ZM15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z"
  }));
},
    rP = function rP(_ref2483) {
  var _ref2483$color = _ref2483.color,
      C = _ref2483$color === void 0 ? "currentColor" : _ref2483$color,
      _ref2483$size = _ref2483.size,
      e = _ref2483$size === void 0 ? 24 : _ref2483$size,
      l = _ref2483.className,
      i = _objectWithoutProperties(_ref2483, _excluded2483);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11 5.07089C7.93431 5.5094 5.5094 7.93431 5.07089 11H7V13H5.07089C5.5094 16.0657 7.93431 18.4906 11 18.9291V17H13V18.9291C16.0657 18.4906 18.4906 16.0657 18.9291 13H17V11H18.9291C18.4906 7.93431 16.0657 5.5094 13 5.07089V7H11V5.07089ZM3.05493 11C3.51608 6.82838 6.82838 3.51608 11 3.05493V1H13V3.05493C17.1716 3.51608 20.4839 6.82838 20.9451 11H23V13H20.9451C20.4839 17.1716 17.1716 20.4839 13 20.9451V23H11V20.9451C6.82838 20.4839 3.51608 17.1716 3.05493 13H1V11H3.05493ZM14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12Z"
  }));
},
    cP = function cP(_ref2484) {
  var _ref2484$color = _ref2484.color,
      C = _ref2484$color === void 0 ? "currentColor" : _ref2484$color,
      _ref2484$size = _ref2484.size,
      e = _ref2484$size === void 0 ? 24 : _ref2484$size,
      l = _ref2484.className,
      i = _objectWithoutProperties(_ref2484, _excluded2484);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19.9381 13C19.4869 16.6187 16.6187 19.4869 13 19.9381V17H11V19.9381C7.38128 19.4869 4.51314 16.6187 4.06189 13H7V11H4.06189C4.51314 7.38128 7.38128 4.51314 11 4.06189V7H13V4.06189C16.6187 4.51314 19.4869 7.38128 19.9381 11H17V13H19.9381ZM2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12ZM12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
  }));
},
    oP = function oP(_ref2485) {
  var _ref2485$color = _ref2485.color,
      C = _ref2485$color === void 0 ? "currentColor" : _ref2485$color,
      _ref2485$size = _ref2485.size,
      e = _ref2485$size === void 0 ? 24 : _ref2485$size,
      l = _ref2485.className,
      i = _objectWithoutProperties(_ref2485, _excluded2485);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13 19.9381C16.6187 19.4869 19.4869 16.6187 19.9381 13H17V11H19.9381C19.4869 7.38128 16.6187 4.51314 13 4.06189V7H11V4.06189C7.38128 4.51314 4.51314 7.38128 4.06189 11H7V13H4.06189C4.51314 16.6187 7.38128 19.4869 11 19.9381V17H13V19.9381ZM12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14Z"
  }));
},
    aP = function aP(_ref2486) {
  var _ref2486$color = _ref2486.color,
      C = _ref2486$color === void 0 ? "currentColor" : _ref2486$color,
      _ref2486$size = _ref2486.size,
      e = _ref2486$size === void 0 ? 24 : _ref2486$size,
      l = _ref2486.className,
      i = _objectWithoutProperties(_ref2486, _excluded2486);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18 13C19.0928 13 20.1174 13.2922 20.9999 13.8026L20.9998 7L16 2H3.9985C3.44749 2 3 2.44405 3 2.9918V21.0082C3 21.5447 3.44476 22 3.9934 22H12.8027C12.2922 21.1175 12 20.0929 12 19C12 15.6863 14.6863 13 18 13ZM21.5356 21.1212L19.4143 18.9999L21.5356 16.8786L20.1214 15.4644L18.0001 17.5857L15.8788 15.4644L14.4646 16.8786L16.5859 18.9999L14.4646 21.1212L15.8788 22.5354L18.0001 20.4141L20.1214 22.5354L21.5356 21.1212Z"
  }));
},
    nP = function nP(_ref2487) {
  var _ref2487$color = _ref2487.color,
      C = _ref2487$color === void 0 ? "currentColor" : _ref2487$color,
      _ref2487$size = _ref2487.size,
      e = _ref2487$size === void 0 ? 24 : _ref2487$size,
      l = _ref2487.className,
      i = _objectWithoutProperties(_ref2487, _excluded2487);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22V20H5V4H15V8H19V13H20.9998V7L16 2H3.9985C3.44749 2 3 2.44405 3 2.9918V21.0082C3 21.5447 3.44476 22 3.9934 22H12ZM21.5356 21.1212L19.4143 18.9999L21.5356 16.8786L20.1214 15.4644L18.0001 17.5857L15.8788 15.4644L14.4646 16.8786L16.5859 18.9999L14.4646 21.1212L15.8788 22.5354L18.0001 20.4141L20.1214 22.5354L21.5356 21.1212Z"
  }));
},
    mP = function mP(_ref2488) {
  var _ref2488$color = _ref2488.color,
      C = _ref2488$color === void 0 ? "currentColor" : _ref2488$color,
      _ref2488$size = _ref2488.size,
      e = _ref2488$size === void 0 ? 24 : _ref2488$size,
      l = _ref2488.className,
      i = _objectWithoutProperties(_ref2488, _excluded2488);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 12C3 13.933 4.567 15.5 6.5 15.5C7.7035 15.5 8.51959 15.0662 9.19914 14.3866C9.82141 13.7644 10.3213 12.9468 10.8546 12C10.3213 11.0532 9.82141 10.2356 9.19914 9.61336C8.51959 8.9338 7.7035 8.5 6.5 8.5C4.567 8.5 3 10.067 3 12ZM6.5 17.5C3.46243 17.5 1 15.0376 1 12C1 8.96243 3.46243 6.5 6.5 6.5C8.2965 6.5 9.60541 7.1912 10.6134 8.19914C11.1486 8.7344 11.5999 9.36157 12 10.0017C12.4001 9.36157 12.8514 8.7344 13.3866 8.19914C14.3946 7.1912 15.7035 6.5 17.5 6.5C20.5376 6.5 23 8.96243 23 12C23 15.0376 20.5376 17.5 17.5 17.5C15.7035 17.5 14.3946 16.8088 13.3866 15.8009C12.8514 15.2656 12.4001 14.6384 12 13.9983C11.5999 14.6384 11.1486 15.2656 10.6134 15.8009C9.60541 16.8088 8.2965 17.5 6.5 17.5ZM13.1454 12C13.6787 12.9468 14.1786 13.7644 14.8009 14.3866C15.4804 15.0662 16.2965 15.5 17.5 15.5C19.433 15.5 21 13.933 21 12C21 10.067 19.433 8.5 17.5 8.5C16.2965 8.5 15.4804 8.9338 14.8009 9.61336C14.1786 10.2356 13.6787 11.0532 13.1454 12Z"
  }));
},
    wP = function wP(_ref2489) {
  var _ref2489$color = _ref2489.color,
      C = _ref2489$color === void 0 ? "currentColor" : _ref2489$color,
      _ref2489$size = _ref2489.size,
      e = _ref2489$size === void 0 ? 24 : _ref2489$size,
      l = _ref2489.className,
      i = _objectWithoutProperties(_ref2489, _excluded2489);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 12C3 10.067 4.567 8.5 6.5 8.5C7.7035 8.5 8.51959 8.9338 9.19914 9.61336C9.9255 10.3397 10.4851 11.3322 11.1258 12.4856L11.1595 12.5462C11.7605 13.6283 12.4431 14.8573 13.3866 15.8009C14.3946 16.8088 15.7035 17.5 17.5 17.5C20.5376 17.5 23 15.0376 23 12C23 8.96243 20.5376 6.5 17.5 6.5C15.8394 6.5 14.3508 7.2359 13.3423 8.39937C13.7887 9.05406 14.1574 9.70577 14.464 10.2574C15.0681 9.20718 16.2014 8.5 17.5 8.5C19.433 8.5 21 10.067 21 12C21 13.933 19.433 15.5 17.5 15.5C16.2965 15.5 15.4804 15.0662 14.8009 14.3866C14.0745 13.6603 13.5149 12.6678 12.8742 11.5144L12.8405 11.4538C12.2395 10.3717 11.5569 9.14265 10.6134 8.19914C9.60541 7.1912 8.2965 6.5 6.5 6.5C3.46243 6.5 1 8.96243 1 12C1 15.0376 3.46243 17.5 6.5 17.5C8.16056 17.5 9.64923 16.7641 10.6577 15.6006C10.2113 14.9459 9.84262 14.2942 9.53605 13.7426C8.93194 14.7928 7.79856 15.5 6.5 15.5C4.567 15.5 3 13.933 3 12Z"
  }));
},
    LP = function LP(_ref2490) {
  var _ref2490$color = _ref2490.color,
      C = _ref2490$color === void 0 ? "currentColor" : _ref2490$color,
      _ref2490$size = _ref2490.size,
      e = _ref2490$size === void 0 ? 24 : _ref2490$size,
      l = _ref2490.className,
      i = _objectWithoutProperties(_ref2490, _excluded2490);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18.364 18.3641C21.8787 14.8493 21.8787 9.15086 18.364 5.63614L19.7782 4.22192C24.0739 8.51769 24.0739 15.4825 19.7782 19.7783L18.364 18.3641ZM5.63604 5.63614C2.12132 9.15086 2.12132 14.8493 5.63604 18.3641L4.22183 19.7783C-0.0739417 15.4825 -0.0739417 8.51769 4.22183 4.22192L5.63604 5.63614ZM15.5355 15.5355C17.4882 13.5829 17.4882 10.4171 15.5355 8.46445L16.9497 7.05024C19.6834 9.78391 19.6834 14.2161 16.9497 16.9497L15.5355 15.5355ZM8.46447 8.46445C6.51184 10.4171 6.51184 13.5829 8.46447 15.5355L7.05025 16.9497C4.31658 14.2161 4.31658 9.78391 7.05025 7.05024L8.46447 8.46445ZM12 14.0001C13.1046 14.0001 14 13.1046 14 12.0001C14 10.8955 13.1046 10.0001 12 10.0001C10.8954 10.0001 10 10.8955 10 12.0001C10 13.1046 10.8954 14.0001 12 14.0001Z"
  }));
},
    hP = function hP(_ref2491) {
  var _ref2491$color = _ref2491.color,
      C = _ref2491$color === void 0 ? "currentColor" : _ref2491$color,
      _ref2491$size = _ref2491.size,
      e = _ref2491$size === void 0 ? 24 : _ref2491$size,
      l = _ref2491.className,
      i = _objectWithoutProperties(_ref2491, _excluded2491);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18.364 18.3641C21.8787 14.8493 21.8787 9.15086 18.364 5.63614L19.7782 4.22192C24.0739 8.51769 24.0739 15.4825 19.7782 19.7783L18.364 18.3641ZM5.63604 5.63614C2.12132 9.15086 2.12132 14.8493 5.63604 18.3641L4.22183 19.7783C-0.0739417 15.4825 -0.0739417 8.51769 4.22183 4.22192L5.63604 5.63614ZM15.5355 15.5355C17.4882 13.5829 17.4882 10.4171 15.5355 8.46445L16.9497 7.05024C19.6834 9.78391 19.6834 14.2161 16.9497 16.9497L15.5355 15.5355ZM8.46447 8.46445C6.51184 10.4171 6.51184 13.5829 8.46447 15.5355L7.05025 16.9497C4.31658 14.2161 4.31658 9.78391 7.05025 7.05024L8.46447 8.46445ZM12 14.0001C13.1046 14.0001 14 13.1046 14 12.0001C14 10.8955 13.1046 10.0001 12 10.0001C10.8954 10.0001 10 10.8955 10 12.0001C10 13.1046 10.8954 14.0001 12 14.0001Z"
  }));
},
    HP = function HP(_ref2492) {
  var _ref2492$color = _ref2492.color,
      C = _ref2492$color === void 0 ? "currentColor" : _ref2492$color,
      _ref2492$size = _ref2492.size,
      e = _ref2492$size === void 0 ? 24 : _ref2492$size,
      l = _ref2492.className,
      i = _objectWithoutProperties(_ref2492, _excluded2492);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5 2C3.34315 2 2 3.34315 2 5V19C2 20.6569 3.34315 22 5 22H19C20.6569 22 22 20.6569 22 19V5C22 3.34315 20.6569 2 19 2H5ZM4 5C4 4.44772 4.44772 4 5 4H19C19.5523 4 20 4.44772 20 5V19C20 19.5523 19.5523 20 19 20H5C4.44772 20 4 19.5523 4 19V5ZM9.72318 18L16.5803 6H14.2768L7.41968 18H9.72318Z"
  }));
},
    VP = function VP(_ref2493) {
  var _ref2493$color = _ref2493.color,
      C = _ref2493$color === void 0 ? "currentColor" : _ref2493$color,
      _ref2493$size = _ref2493.size,
      e = _ref2493$size === void 0 ? 24 : _ref2493$size,
      l = _ref2493.className,
      i = _objectWithoutProperties(_ref2493, _excluded2493);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 13C15.3137 13 18 10.3137 18 7C18 3.68629 15.3137 1 12 1C8.68629 1 6 3.68629 6 7C6 10.3137 8.68629 13 12 13ZM15 18C15 16.3431 16.3431 15 18 15C18.4631 15 18.9018 15.105 19.2934 15.2924L15.2924 19.2934C15.105 18.9018 15 18.4631 15 18ZM16.7066 20.7076L20.7076 16.7066C20.895 17.0982 21 17.5369 21 18C21 19.6569 19.6569 21 18 21C17.5369 21 17.0982 20.895 16.7066 20.7076ZM18 13C15.2386 13 13 15.2386 13 18C13 20.7614 15.2386 23 18 23C20.7614 23 23 20.7614 23 18C23 15.2386 20.7614 13 18 13ZM12 14C12.0843 14 12.1683 14.0013 12.252 14.0039C11.4628 15.137 11 16.5145 11 18C11 19.4872 11.4638 20.8662 12.2547 22H4C4 17.5817 7.58172 14 12 14Z"
  }));
},
    gP = function gP(_ref2494) {
  var _ref2494$color = _ref2494.color,
      C = _ref2494$color === void 0 ? "currentColor" : _ref2494$color,
      _ref2494$size = _ref2494.size,
      e = _ref2494$size === void 0 ? 24 : _ref2494$size,
      l = _ref2494.className,
      i = _objectWithoutProperties(_ref2494, _excluded2494);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7C16 9.20914 14.2091 11 12 11C9.79086 11 8 9.20914 8 7ZM12 1C8.68629 1 6 3.68629 6 7C6 10.3137 8.68629 13 12 13C15.3137 13 18 10.3137 18 7C18 3.68629 15.3137 1 12 1ZM15 18C15 16.3431 16.3431 15 18 15C18.4631 15 18.9018 15.105 19.2934 15.2924L15.2924 19.2934C15.105 18.9018 15 18.4631 15 18ZM16.7066 20.7076L20.7076 16.7066C20.895 17.0982 21 17.5369 21 18C21 19.6569 19.6569 21 18 21C17.5369 21 17.0982 20.895 16.7066 20.7076ZM18 13C15.2386 13 13 15.2386 13 18C13 20.7614 15.2386 23 18 23C20.7614 23 23 20.7614 23 18C23 15.2386 20.7614 13 18 13ZM12 14C12.0843 14 12.1683 14.0013 12.252 14.0039C11.8236 14.6189 11.4914 15.3059 11.2772 16.0431C8.30431 16.4 6 18.9309 6 22H4C4 17.5817 7.58172 14 12 14Z"
  }));
},
    MP = function MP(_ref2495) {
  var _ref2495$color = _ref2495.color,
      C = _ref2495$color === void 0 ? "currentColor" : _ref2495$color,
      _ref2495$size = _ref2495.size,
      e = _ref2495$size === void 0 ? 24 : _ref2495$size,
      l = _ref2495.className,
      i = _objectWithoutProperties(_ref2495, _excluded2495);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9 3C10.1046 3 11 3.89543 11 5C11 5.11469 10.9904 5.22639 10.9723 5.33454L12.9447 5.66546C12.9812 5.4484 13 5.22602 13 5C13 4.7625 12.9793 4.52984 12.9396 4.30371C13.2472 4.11088 13.6103 4 14 4C15.1046 4 16 4.89543 16 6C16 6.36443 15.903 6.70571 15.7327 7H5C4.44772 7 4 6.55228 4 6C4 5.44772 4.44772 5 5 5C5.20008 5 5.38362 5.05773 5.53851 5.15709C5.81193 5.33249 6.15353 5.36415 6.45453 5.24199C6.75554 5.11982 6.97845 4.85905 7.05229 4.5427C7.25876 3.65813 8.05374 3 9 3ZM10.5164 1.29745C10.0489 1.10575 9.53693 1 9 1C7.50087 1 6.19573 1.82409 5.51068 3.04344C5.34453 3.01488 5.17387 3 5 3C3.34315 3 2 4.34315 2 6C2 6.8885 2.38625 7.68679 3 8.23611V20C3 21.1046 3.89543 22 5 22H15C16.1046 22 17 21.1046 17 20H19C20.1046 20 21 19.1046 21 18V11C21 9.89543 20.1046 9 19 9H17V8.64575C17.6215 7.94132 18 7.01438 18 6C18 3.79086 16.2091 2 14 2C13.3143 2 12.6684 2.17301 12.1042 2.47716C11.6851 1.96201 11.1402 1.5532 10.5164 1.29745ZM17 18V11H19V18H17ZM7 11H9V18H7V11ZM11 11H13V18H11V11Z"
  }));
},
    ZP = function ZP(_ref2496) {
  var _ref2496$color = _ref2496.color,
      C = _ref2496$color === void 0 ? "currentColor" : _ref2496$color,
      _ref2496$size = _ref2496.size,
      e = _ref2496$size === void 0 ? 24 : _ref2496$size,
      l = _ref2496.className,
      i = _objectWithoutProperties(_ref2496, _excluded2496);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9 3C10.1046 3 11 3.89543 11 5C11 5.11469 10.9904 5.22639 10.9723 5.33454L12.9447 5.66546C12.9812 5.4484 13 5.22602 13 5C13 4.7625 12.9793 4.52984 12.9396 4.30371C13.2472 4.11088 13.6103 4 14 4C15.1046 4 16 4.89543 16 6C16 6.36443 15.903 6.70571 15.7327 7H5C4.44772 7 4 6.55228 4 6C4 5.44772 4.44772 5 5 5C5.20008 5 5.38362 5.05773 5.53851 5.15709C5.81193 5.33249 6.15353 5.36415 6.45453 5.24199C6.75554 5.11982 6.97845 4.85905 7.05229 4.5427C7.25876 3.65813 8.05374 3 9 3ZM10.5164 1.29745C10.0489 1.10575 9.53693 1 9 1C7.50087 1 6.19573 1.82409 5.51068 3.04344C5.34453 3.01488 5.17387 3 5 3C3.34315 3 2 4.34315 2 6C2 6.8885 2.38625 7.68679 3 8.23611V20C3 21.1046 3.89543 22 5 22H15C16.1046 22 17 21.1046 17 20H19C20.1046 20 21 19.1046 21 18V11C21 9.89543 20.1046 9 19 9H17V8.64575C17.6215 7.94132 18 7.01438 18 6C18 3.79086 16.2091 2 14 2C13.3143 2 12.6684 2.17301 12.1042 2.47716C11.6851 1.96201 11.1402 1.5532 10.5164 1.29745ZM17 11H19V18H17V11ZM15 9V10V19V20H5V9H15ZM7 11V18H9V11H7ZM13 11V18H11V11H13Z"
  }));
},
    xP = function xP(_ref2497) {
  var _ref2497$color = _ref2497.color,
      C = _ref2497$color === void 0 ? "currentColor" : _ref2497$color,
      _ref2497$size = _ref2497.size,
      e = _ref2497$size === void 0 ? 24 : _ref2497$size,
      l = _ref2497.className,
      i = _objectWithoutProperties(_ref2497, _excluded2497);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
  }));
},
    vP = function vP(_ref2498) {
  var _ref2498$color = _ref2498.color,
      C = _ref2498$color === void 0 ? "currentColor" : _ref2498$color,
      _ref2498$size = _ref2498.size,
      e = _ref2498$size === void 0 ? 24 : _ref2498$size,
      l = _ref2498.className,
      i = _objectWithoutProperties(_ref2498, _excluded2498);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
  }));
},
    dP = function dP(_ref2499) {
  var _ref2499$color = _ref2499.color,
      C = _ref2499$color === void 0 ? "currentColor" : _ref2499$color,
      _ref2499$size = _ref2499.size,
      e = _ref2499$size === void 0 ? 24 : _ref2499$size,
      l = _ref2499.className,
      i = _objectWithoutProperties(_ref2499, _excluded2499);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 5V19H13V21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V9H20V5H4ZM19.7071 11.2929L19 10.5858L18.2929 11.2929L15.2929 14.2929L16.7071 15.7071L19 13.4142L21.2929 15.7071L22.7071 14.2929L19.7071 11.2929ZM16.7071 17.2929L19 19.5858L21.2929 17.2929L22.7071 18.7071L19.7071 21.7071L19 22.4142L18.2929 21.7071L15.2929 18.7071L16.7071 17.2929Z"
  }));
},
    pP = function pP(_ref2500) {
  var _ref2500$color = _ref2500.color,
      C = _ref2500$color === void 0 ? "currentColor" : _ref2500$color,
      _ref2500$size = _ref2500.size,
      e = _ref2500$size === void 0 ? 24 : _ref2500$size,
      l = _ref2500.className,
      i = _objectWithoutProperties(_ref2500, _excluded2500);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 7L16 2H3.9934C3.44495 2 3 2.44405 3 2.9918V21.0082C3 21.5447 3.44476 22 3.9934 22H20.0066C20.5551 22 21 21.556 21 21.0082V7ZM11 9.5C11 10.3284 10.3284 11 9.5 11C8.67157 11 8 10.3284 8 9.5C8 8.67157 8.67157 8 9.5 8C10.3284 8 11 8.67157 11 9.5ZM17.5 17H8L13.5 10L17.5 17Z"
  }));
},
    EP = function EP(_ref2501) {
  var _ref2501$color = _ref2501.color,
      C = _ref2501$color === void 0 ? "currentColor" : _ref2501$color,
      _ref2501$size = _ref2501.size,
      e = _ref2501$size === void 0 ? 24 : _ref2501$size,
      l = _ref2501.className,
      i = _objectWithoutProperties(_ref2501, _excluded2501);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15 8V4H5V20H19V8H15ZM3 2.9918C3 2.44405 3.44749 2 3.9985 2H16L20.9997 7L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918ZM11 9.5C11 10.3284 10.3284 11 9.5 11C8.67157 11 8 10.3284 8 9.5C8 8.67157 8.67157 8 9.5 8C10.3284 8 11 8.67157 11 9.5ZM17.5 17L13.5 10L8 17H17.5Z"
  }));
},
    NP = function NP(_ref2502) {
  var _ref2502$color = _ref2502.color,
      C = _ref2502$color === void 0 ? "currentColor" : _ref2502$color,
      _ref2502$size = _ref2502.size,
      e = _ref2502$size === void 0 ? 24 : _ref2502$size,
      l = _ref2502.className,
      i = _objectWithoutProperties(_ref2502, _excluded2502);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3.9985 2C3.44749 2 3 2.44405 3 2.9918V21.0082C3 21.5447 3.44476 22 3.9934 22H20.0066C20.5551 22 21 21.5489 21 20.9925L20.9997 7L16 2H3.9985ZM10.5 7.5H12.5C12.5 9.98994 14.6436 12.6604 17.3162 13.5513L16.8586 15.49C13.7234 15.0421 10.4821 16.3804 7.5547 18.3321L6.3753 16.7191C7.46149 15.8502 8.50293 14.3757 9.27499 12.6534C10.0443 10.9373 10.5 9.07749 10.5 7.5ZM11.1 13.4716C11.3673 12.8752 11.6043 12.2563 11.8037 11.6285C12.2754 12.3531 12.8553 13.0182 13.5102 13.5953C12.5284 13.7711 11.5666 14.0596 10.6353 14.4276C10.8 14.1143 10.9551 13.7948 11.1 13.4716Z"
  }));
},
    uP = function uP(_ref2503) {
  var _ref2503$color = _ref2503.color,
      C = _ref2503$color === void 0 ? "currentColor" : _ref2503$color,
      _ref2503$size = _ref2503.size,
      e = _ref2503$size === void 0 ? 24 : _ref2503$size,
      l = _ref2503.className,
      i = _objectWithoutProperties(_ref2503, _excluded2503);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5 4H15V8H19V20H5V4ZM3.9985 2C3.44749 2 3 2.44405 3 2.9918V21.0082C3 21.5447 3.44476 22 3.9934 22H20.0066C20.5551 22 21 21.5489 21 20.9925L20.9997 7L16 2H3.9985ZM10.4999 7.5C10.4999 9.07749 10.0442 10.9373 9.27493 12.6534C8.50287 14.3757 7.46143 15.8502 6.37524 16.7191L7.55464 18.3321C10.4821 16.3804 13.7233 15.0421 16.8585 15.49L17.3162 13.5513C14.6435 12.6604 12.4999 9.98994 12.4999 7.5H10.4999ZM11.0999 13.4716C11.3673 12.8752 11.6042 12.2563 11.8037 11.6285C12.2753 12.3531 12.8553 13.0182 13.5101 13.5953C12.5283 13.7711 11.5665 14.0596 10.6352 14.4276C10.7999 14.1143 10.9551 13.7948 11.0999 13.4716Z"
  }));
},
    BP = function BP(_ref2504) {
  var _ref2504$color = _ref2504.color,
      C = _ref2504$color === void 0 ? "currentColor" : _ref2504$color,
      _ref2504$size = _ref2504.size,
      e = _ref2504$size === void 0 ? 24 : _ref2504$size,
      l = _ref2504.className,
      i = _objectWithoutProperties(_ref2504, _excluded2504);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16 2L21 7V21.0082C21 21.556 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918C3 2.44405 3.44495 2 3.9934 2H16ZM15.0008 11.667L10.1219 8.41435C10.0562 8.37054 9.979 8.34717 9.9 8.34717C9.6791 8.34717 9.5 8.52625 9.5 8.74717V15.2524C9.5 15.3314 9.5234 15.4086 9.5672 15.4743C9.6897 15.6581 9.9381 15.7078 10.1219 15.5852L15.0008 12.3326C15.0447 12.3033 15.0824 12.2656 15.1117 12.2217C15.2343 12.0379 15.1846 11.7895 15.0008 11.667Z"
  }));
},
    fP = function fP(_ref2505) {
  var _ref2505$color = _ref2505.color,
      C = _ref2505$color === void 0 ? "currentColor" : _ref2505$color,
      _ref2505$size = _ref2505.size,
      e = _ref2505$size === void 0 ? 24 : _ref2505$size,
      l = _ref2505.className,
      i = _objectWithoutProperties(_ref2505, _excluded2505);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15 4V8H19V20H5V4H15ZM3.9985 2C3.44749 2 3 2.44405 3 2.9918V21.0082C3 21.5447 3.44476 22 3.9934 22H20.0066C20.5551 22 21 21.5489 21 20.9925L20.9997 7L16 2H3.9985ZM15.0008 11.667L10.1219 8.41435C10.0562 8.37054 9.979 8.34717 9.9 8.34717C9.6791 8.34717 9.5 8.52625 9.5 8.74717V15.2524C9.5 15.3314 9.5234 15.4086 9.5672 15.4743C9.6897 15.6581 9.9381 15.7078 10.1219 15.5852L15.0008 12.3326C15.0447 12.3033 15.0824 12.2656 15.1117 12.2217C15.2343 12.0379 15.1846 11.7895 15.0008 11.667Z"
  }));
},
    RP = function RP(_ref2506) {
  var _ref2506$color = _ref2506.color,
      C = _ref2506$color === void 0 ? "currentColor" : _ref2506$color,
      _ref2506$size = _ref2506.size,
      e = _ref2506$size === void 0 ? 24 : _ref2506$size,
      l = _ref2506.className,
      i = _objectWithoutProperties(_ref2506, _excluded2506);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5ZM10 10.5C10 9.67157 9.32843 9 8.5 9C7.67157 9 7 9.67157 7 10.5C7 11.3284 7.67157 12 8.5 12C9.32843 12 10 11.3284 10 10.5ZM18 17L14 11L7 17H18Z"
  }));
},
    zP = function zP(_ref2507) {
  var _ref2507$color = _ref2507.color,
      C = _ref2507$color === void 0 ? "currentColor" : _ref2507$color,
      _ref2507$size = _ref2507.size,
      e = _ref2507$size === void 0 ? 24 : _ref2507$size,
      l = _ref2507.className,
      i = _objectWithoutProperties(_ref2507, _excluded2507);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 5V19H20V7H11.5858L9.58579 5H4ZM12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5ZM10 10.5C10 11.3284 9.32843 12 8.5 12C7.67157 12 7 11.3284 7 10.5C7 9.67157 7.67157 9 8.5 9C9.32843 9 10 9.67157 10 10.5ZM18 17L14 11L7 17H18Z"
  }));
},
    FP = function FP(_ref2508) {
  var _ref2508$color = _ref2508.color,
      C = _ref2508$color === void 0 ? "currentColor" : _ref2508$color,
      _ref2508$size = _ref2508.size,
      e = _ref2508$size === void 0 ? 24 : _ref2508$size,
      l = _ref2508.className,
      i = _objectWithoutProperties(_ref2508, _excluded2508);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 5H12.4142L10.4142 3H3C2.44772 3 2 3.44772 2 4V20C2 20.5523 2.44772 21 3 21H21C21.5523 21 22 20.5523 22 20V6C22 5.44772 21.5523 5 21 5ZM15.0008 12.667C15.1846 12.7895 15.2343 13.0379 15.1117 13.2217C15.0824 13.2656 15.0447 13.3033 15.0008 13.3326L10.1219 16.5852C9.9381 16.7078 9.6897 16.6581 9.5672 16.4743C9.5234 16.4086 9.5 16.3314 9.5 16.2524V9.74717C9.5 9.52625 9.6791 9.34717 9.9 9.34717C9.979 9.34717 10.0562 9.37054 10.1219 9.41435L15.0008 12.667Z"
  }));
},
    SP = function SP(_ref2509) {
  var _ref2509$color = _ref2509.color,
      C = _ref2509$color === void 0 ? "currentColor" : _ref2509$color,
      _ref2509$size = _ref2509.size,
      e = _ref2509$size === void 0 ? 24 : _ref2509$size,
      l = _ref2509.className,
      i = _objectWithoutProperties(_ref2509, _excluded2509);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 19V5H9.58579L11.5858 7H20V19H4ZM21 5H12.4142L10.4142 3H3C2.44772 3 2 3.44772 2 4V20C2 20.5523 2.44772 21 3 21H21C21.5523 21 22 20.5523 22 20V6C22 5.44772 21.5523 5 21 5ZM15.0008 12.667L10.1219 9.41435C10.0562 9.37054 9.979 9.34717 9.9 9.34717C9.6791 9.34717 9.5 9.52625 9.5 9.74717V16.2524C9.5 16.3314 9.5234 16.4086 9.5672 16.4743C9.6897 16.6581 9.9381 16.7078 10.1219 16.5852L15.0008 13.3326C15.0447 13.3033 15.0824 13.2656 15.1117 13.2217C15.2343 13.0379 15.1846 12.7895 15.0008 12.667Z"
  }));
},
    AP = function AP(_ref2510) {
  var _ref2510$color = _ref2510.color,
      C = _ref2510$color === void 0 ? "currentColor" : _ref2510$color,
      _ref2510$size = _ref2510.size,
      e = _ref2510$size === void 0 ? 24 : _ref2510$size,
      l = _ref2510.className,
      i = _objectWithoutProperties(_ref2510, _excluded2510);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17.5 2.5L23 12L17.5 21.5H6.5L1 12L6.5 2.5H17.5Z"
  }));
},
    kP = function kP(_ref2511) {
  var _ref2511$color = _ref2511.color,
      C = _ref2511$color === void 0 ? "currentColor" : _ref2511$color,
      _ref2511$size = _ref2511.size,
      e = _ref2511$size === void 0 ? 24 : _ref2511$size,
      l = _ref2511.className,
      i = _objectWithoutProperties(_ref2511, _excluded2511);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17.5 2.5L23 12L17.5 21.5H6.5L1 12L6.5 2.5H17.5ZM16.3469 4.5H7.65311L3.311 12L7.65311 19.5H16.3469L20.689 12L16.3469 4.5Z"
  }));
},
    PP = function PP(_ref2512) {
  var _ref2512$color = _ref2512.color,
      C = _ref2512$color === void 0 ? "currentColor" : _ref2512$color,
      _ref2512$size = _ref2512.size,
      e = _ref2512$size === void 0 ? 24 : _ref2512$size,
      l = _ref2512.className,
      i = _objectWithoutProperties(_ref2512, _excluded2512);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18.6175 13.0317C17.7315 13.6424 16.6575 14 15.5 14C12.4624 14 10 11.5376 10 8.5C10 5.46243 12.4624 3 15.5 3C18.5376 3 21 5.46243 21 8.5C21 9.6575 20.6424 10.7315 20.0317 11.6175L22.7071 14.2929L21.2929 15.7071L18.6175 13.0317ZM3 4H8V6H3V4ZM3 11H8V13H3V11ZM3 18H21V20H3V18Z"
  }));
},
    DP = function DP(_ref2513) {
  var _ref2513$color = _ref2513.color,
      C = _ref2513$color === void 0 ? "currentColor" : _ref2513$color,
      _ref2513$size = _ref2513.size,
      e = _ref2513$size === void 0 ? 24 : _ref2513$size,
      l = _ref2513.className,
      i = _objectWithoutProperties(_ref2513, _excluded2513);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15.5 5C13.567 5 12 6.567 12 8.5C12 10.433 13.567 12 15.5 12C17.433 12 19 10.433 19 8.5C19 6.567 17.433 5 15.5 5ZM10 8.5C10 5.46243 12.4624 3 15.5 3C18.5376 3 21 5.46243 21 8.5C21 9.6575 20.6424 10.7315 20.0317 11.6175L22.7071 14.2929L21.2929 15.7071L18.6175 13.0317C17.7315 13.6424 16.6575 14 15.5 14C12.4624 14 10 11.5376 10 8.5ZM3 4H8V6H3V4ZM3 11H8V13H3V11ZM21 18V20H3V18H21Z"
  }));
},
    yP = function yP(_ref2514) {
  var _ref2514$color = _ref2514.color,
      C = _ref2514$color === void 0 ? "currentColor" : _ref2514$color,
      _ref2514$size = _ref2514.size,
      e = _ref2514$size === void 0 ? 24 : _ref2514$size,
      l = _ref2514.className,
      i = _objectWithoutProperties(_ref2514, _excluded2514);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15.936 2.50098L21.501 8.06595V15.936L15.936 21.501H8.06595L2.50098 15.936V8.06595L8.06595 2.50098H15.936Z"
  }));
},
    bP = function bP(_ref2515) {
  var _ref2515$color = _ref2515.color,
      C = _ref2515$color === void 0 ? "currentColor" : _ref2515$color,
      _ref2515$size = _ref2515.size,
      e = _ref2515$size === void 0 ? 24 : _ref2515$size,
      l = _ref2515.className,
      i = _objectWithoutProperties(_ref2515, _excluded2515);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15.936 2.50098L21.501 8.06595V15.936L15.936 21.501H8.06595L2.50098 15.936V8.06595L8.06595 2.50098H15.936ZM15.1076 4.50098H8.89437L4.50098 8.89437V15.1076L8.89437 19.501H15.1076L19.501 15.1076V8.89437L15.1076 4.50098Z"
  }));
},
    TP = function TP(_ref2516) {
  var _ref2516$color = _ref2516.color,
      C = _ref2516$color === void 0 ? "currentColor" : _ref2516$color,
      _ref2516$size = _ref2516.size,
      e = _ref2516$size === void 0 ? 24 : _ref2516$size,
      l = _ref2516.className,
      i = _objectWithoutProperties(_ref2516, _excluded2516);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.0004 0.700195L22.7473 8.5083L18.6423 21.1421H5.35838L1.25342 8.5083L12.0004 0.700195Z"
  }));
},
    UP = function UP(_ref2517) {
  var _ref2517$color = _ref2517.color,
      C = _ref2517$color === void 0 ? "currentColor" : _ref2517$color,
      _ref2517$size = _ref2517.size,
      e = _ref2517$size === void 0 ? 24 : _ref2517$size,
      l = _ref2517.className,
      i = _objectWithoutProperties(_ref2517, _excluded2517);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.0004 3.03043L20.5309 9.22822L17.2725 19.2564H6.72821L3.46984 9.22822L12.0004 3.03043ZM22.7473 8.50806L12.0004 0.699951L1.25342 8.50806L5.35838 21.1418H18.6423L22.7473 8.50806Z"
  }));
},
    GP = function GP(_ref2518) {
  var _ref2518$color = _ref2518.color,
      C = _ref2518$color === void 0 ? "currentColor" : _ref2518$color,
      _ref2518$size = _ref2518.size,
      e = _ref2518$size === void 0 ? 24 : _ref2518$size,
      l = _ref2518.className,
      i = _objectWithoutProperties(_ref2518, _excluded2518);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 4H21C21.5523 4 22 4.44772 22 5V19C22 19.5523 21.5523 20 21 20H3C2.44772 20 2 19.5523 2 19V5C2 4.44772 2.44772 4 3 4Z"
  }));
},
    IP = function IP(_ref2519) {
  var _ref2519$color = _ref2519.color,
      C = _ref2519$color === void 0 ? "currentColor" : _ref2519$color,
      _ref2519$size = _ref2519.size,
      e = _ref2519$size === void 0 ? 24 : _ref2519$size,
      l = _ref2519.className,
      i = _objectWithoutProperties(_ref2519, _excluded2519);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 4H21C21.5523 4 22 4.44772 22 5V19C22 19.5523 21.5523 20 21 20H3C2.44772 20 2 19.5523 2 19V5C2 4.44772 2.44772 4 3 4ZM4 6V18H20V6H4Z"
  }));
},
    WP = function WP(_ref2520) {
  var _ref2520$color = _ref2520.color,
      C = _ref2520$color === void 0 ? "currentColor" : _ref2520$color,
      _ref2520$size = _ref2520.size,
      e = _ref2520$size === void 0 ? 24 : _ref2520$size,
      l = _ref2520.className,
      i = _objectWithoutProperties(_ref2520, _excluded2520);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13.5 2C13.5 2.44425 13.3069 2.84339 13 3.11805V5H18C19.6569 5 21 6.34315 21 8V18C21 19.6569 19.6569 21 18 21H6C4.34315 21 3 19.6569 3 18V8C3 6.34315 4.34315 5 6 5H11V3.11805C10.6931 2.84339 10.5 2.44425 10.5 2C10.5 1.17157 11.1716 0.5 12 0.5C12.8284 0.5 13.5 1.17157 13.5 2ZM0 10H2V16H0V10ZM24 10H22V16H24V10ZM9 14.5C9.82843 14.5 10.5 13.8284 10.5 13C10.5 12.1716 9.82843 11.5 9 11.5C8.17157 11.5 7.5 12.1716 7.5 13C7.5 13.8284 8.17157 14.5 9 14.5ZM16.5 13C16.5 12.1716 15.8284 11.5 15 11.5C14.1716 11.5 13.5 12.1716 13.5 13C13.5 13.8284 14.1716 14.5 15 14.5C15.8284 14.5 16.5 13.8284 16.5 13Z"
  }));
},
    OP = function OP(_ref2521) {
  var _ref2521$color = _ref2521.color,
      C = _ref2521$color === void 0 ? "currentColor" : _ref2521$color,
      _ref2521$size = _ref2521.size,
      e = _ref2521$size === void 0 ? 24 : _ref2521$size,
      l = _ref2521.className,
      i = _objectWithoutProperties(_ref2521, _excluded2521);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13.5 2C13.5 2.44425 13.3069 2.84339 13 3.11805V5H18C19.6569 5 21 6.34315 21 8V18C21 19.6569 19.6569 21 18 21H6C4.34315 21 3 19.6569 3 18V8C3 6.34315 4.34315 5 6 5H11V3.11805C10.6931 2.84339 10.5 2.44425 10.5 2C10.5 1.17157 11.1716 0.5 12 0.5C12.8284 0.5 13.5 1.17157 13.5 2ZM6 7C5.44772 7 5 7.44772 5 8V18C5 18.5523 5.44772 19 6 19H18C18.5523 19 19 18.5523 19 18V8C19 7.44772 18.5523 7 18 7H13H11H6ZM2 10H0V16H2V10ZM22 10H24V16H22V10ZM9 14.5C9.82843 14.5 10.5 13.8284 10.5 13C10.5 12.1716 9.82843 11.5 9 11.5C8.17157 11.5 7.5 12.1716 7.5 13C7.5 13.8284 8.17157 14.5 9 14.5ZM15 14.5C15.8284 14.5 16.5 13.8284 16.5 13C16.5 12.1716 15.8284 11.5 15 11.5C14.1716 11.5 13.5 12.1716 13.5 13C13.5 13.8284 14.1716 14.5 15 14.5Z"
  }));
},
    KP = function KP(_ref2522) {
  var _ref2522$color = _ref2522.color,
      C = _ref2522$color === void 0 ? "currentColor" : _ref2522$color,
      _ref2522$size = _ref2522.size,
      e = _ref2522$size === void 0 ? 24 : _ref2522$size,
      l = _ref2522.className,
      i = _objectWithoutProperties(_ref2522, _excluded2522);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11.9998 1L18 11H6L11.9998 1ZM13 13.5H21V21.5H13V13.5ZM6.75 22C9.37335 22 11.5 19.8734 11.5 17.25C11.5 14.6266 9.37335 12.5 6.75 12.5C4.12665 12.5 2 14.6266 2 17.25C2 19.8734 4.12665 22 6.75 22Z"
  }));
},
    QP = function QP(_ref2523) {
  var _ref2523$color = _ref2523.color,
      C = _ref2523$color === void 0 ? "currentColor" : _ref2523$color,
      _ref2523$size = _ref2523.size,
      e = _ref2523$size === void 0 ? 24 : _ref2523$size,
      l = _ref2523.className,
      i = _objectWithoutProperties(_ref2523, _excluded2523);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11.9998 1L6 11H18L11.9998 1ZM11.9998 4.8873L14.4676 9H9.53232L11.9998 4.8873ZM6.75 20C5.23122 20 4 18.7688 4 17.25C4 15.7312 5.23122 14.5 6.75 14.5C8.26878 14.5 9.5 15.7312 9.5 17.25C9.5 18.7688 8.26878 20 6.75 20ZM6.75 22C9.37335 22 11.5 19.8734 11.5 17.25C11.5 14.6266 9.37335 12.5 6.75 12.5C4.12665 12.5 2 14.6266 2 17.25C2 19.8734 4.12665 22 6.75 22ZM15 15.5V19.5H19V15.5H15ZM13 21.5V13.5H21V21.5H13Z"
  }));
},
    qP = function qP(_ref2524) {
  var _ref2524$color = _ref2524.color,
      C = _ref2524$color === void 0 ? "currentColor" : _ref2524$color,
      _ref2524$size = _ref2524.size,
      e = _ref2524$size === void 0 ? 24 : _ref2524$size,
      l = _ref2524.className,
      i = _objectWithoutProperties(_ref2524, _excluded2524);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3Z"
  }));
},
    jP = function jP(_ref2525) {
  var _ref2525$color = _ref2525.color,
      C = _ref2525$color === void 0 ? "currentColor" : _ref2525$color,
      _ref2525$size = _ref2525.size,
      e = _ref2525$size === void 0 ? 24 : _ref2525$size,
      l = _ref2525.className,
      i = _objectWithoutProperties(_ref2525, _excluded2525);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM5 5V19H19V5H5Z"
  }));
},
    XP = function XP(_ref2526) {
  var _ref2526$color = _ref2526.color,
      C = _ref2526$color === void 0 ? "currentColor" : _ref2526$color,
      _ref2526$size = _ref2526.size,
      e = _ref2526$size === void 0 ? 24 : _ref2526$size,
      l = _ref2526.className,
      i = _objectWithoutProperties(_ref2526, _excluded2526);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.8659 3.00017L22.1034 19H23V21H1V19H1.89638L11.1339 3.00017C11.41 2.52187 12.0216 2.358 12.4999 2.63414C12.6519 2.72191 12.7782 2.84815 12.8659 3.00017ZM12 12.9248L8.65869 19H15.3414L12 12.9248Z"
  }));
},
    JP = function JP(_ref2527) {
  var _ref2527$color = _ref2527.color,
      C = _ref2527$color === void 0 ? "currentColor" : _ref2527$color,
      _ref2527$size = _ref2527.size,
      e = _ref2527$size === void 0 ? 24 : _ref2527$size,
      l = _ref2527.className,
      i = _objectWithoutProperties(_ref2527, _excluded2527);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22.1034 19L12.8659 3.00017C12.7782 2.84815 12.6519 2.72191 12.4999 2.63414C12.0216 2.358 11.41 2.52187 11.1339 3.00017L1.89638 19H1V21C8.33333 21 15.6667 21 23 21V19H22.1034ZM7.59991 19.0002H4.20568L11.9999 5.50017L19.7941 19.0002H16.4001L12 11L7.59991 19.0002ZM12 15.1501L14.1175 19H9.88254L12 15.1501Z"
  }));
},
    YP = function YP(_ref2528) {
  var _ref2528$color = _ref2528.color,
      C = _ref2528$color === void 0 ? "currentColor" : _ref2528$color,
      _ref2528$size = _ref2528.size,
      e = _ref2528$size === void 0 ? 24 : _ref2528$size,
      l = _ref2528.className,
      i = _objectWithoutProperties(_ref2528, _excluded2528);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16.7051 11.1081C16.543 8.12137 14.911 6.41148 12.1708 6.39398C10.5193 6.3838 9.13771 7.08389 8.29233 8.36664L9.79941 9.40046C10.4334 8.43852 11.4342 8.24015 12.1593 8.24685C13.0616 8.2526 13.7425 8.51494 14.1832 9.02653C14.5038 9.39899 14.7183 9.91367 14.8245 10.5632C14.0246 10.4273 13.1594 10.3855 12.2345 10.4385C9.62919 10.5886 7.95426 12.1081 8.06675 14.2194C8.12384 15.2904 8.65739 16.2118 9.56906 16.8137C10.3399 17.3225 11.3326 17.5713 12.3644 17.515C13.727 17.4403 14.7959 16.9205 15.5416 15.9699C16.1079 15.248 16.4661 14.3125 16.6243 13.1338C17.2737 13.5257 17.7549 14.0414 18.0207 14.6613C18.4726 15.7151 18.499 17.4469 17.086 18.8587C15.848 20.0955 14.3598 20.6306 12.1108 20.6471C9.61601 20.6286 7.72924 19.8285 6.50253 18.269C5.35381 16.8088 4.76014 14.6996 4.73799 12C4.76014 9.30038 5.35381 7.19117 6.50253 5.73092C7.72924 4.17147 9.61597 3.37141 12.1107 3.35287C14.6236 3.37155 16.5433 4.17547 17.8169 5.74244C18.4415 6.51086 18.9123 7.47721 19.2227 8.60394L20.9888 8.13274C20.6125 6.74587 20.0205 5.55078 19.2148 4.55966C17.582 2.55073 15.1816 1.52134 12.1046 1.5C9.03385 1.52127 6.6725 2.55457 5.08614 4.57117C3.67451 6.3657 2.94634 8.87742 2.92188 12.0074C2.94634 15.1373 3.67451 17.6343 5.08614 19.4289C6.6725 21.4454 9.04616 22.4788 12.1169 22.5C14.847 22.4811 16.7713 21.7663 18.3566 20.1825C20.4307 18.1103 20.3682 15.513 19.6846 13.9185C19.1595 12.6943 18.1141 11.7129 16.7051 11.1081ZM12.2669 15.6648C11.125 15.7291 9.93869 15.2166 9.88019 14.1188C9.83684 13.3048 10.4595 12.3966 12.3369 12.2884C13.2594 12.2352 14.1138 12.2976 14.8701 12.463C14.6538 15.1648 13.3848 15.6035 12.2669 15.6648Z"
  }));
},
    _P = function _P(_ref2529) {
  var _ref2529$color = _ref2529.color,
      C = _ref2529$color === void 0 ? "currentColor" : _ref2529$color,
      _ref2529$size = _ref2529.size,
      e = _ref2529$size === void 0 ? 24 : _ref2529$size,
      l = _ref2529.className,
      i = _objectWithoutProperties(_ref2529, _excluded2529);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.1835 1.41016L12.1822 1.41016C9.09012 1.43158 6.70036 2.47326 5.09369 4.51569C3.66581 6.33087 2.93472 8.86436 2.91016 12.0068V12.0082C2.93472 15.1508 3.66586 17.6696 5.09369 19.4847C6.70043 21.5271 9.10257 22.5688 12.1946 22.5902H12.1958C14.944 22.5711 16.8929 21.8504 18.4985 20.2463C20.6034 18.1434 20.5408 15.5048 19.8456 13.8832C19.3163 12.6493 18.2709 11.6618 16.8701 11.0477C16.6891 8.06345 15.0097 6.32178 12.2496 6.30415C10.6191 6.29409 9.14792 7.02378 8.24685 8.39104L9.90238 9.5267C10.4353 8.71818 11.2789 8.32815 12.2371 8.33701C13.6244 8.34586 14.5362 9.11128 14.7921 10.4541C14.02 10.3333 13.1902 10.2982 12.3076 10.3488C9.66843 10.5008 7.9399 12.061 8.05516 14.2244C8.17571 16.4862 10.367 17.7186 12.4476 17.605C14.9399 17.4684 16.4209 15.6292 16.7722 13.2836C17.3493 13.6575 17.7751 14.1344 18.0163 14.6969C18.4559 15.7222 18.4838 17.4132 17.1006 18.7952C15.8838 20.0108 14.4211 20.5407 12.1891 20.5572C9.71428 20.5388 7.85698 19.746 6.65154 18.2136C5.51973 16.7748 4.92843 14.6882 4.90627 12.0002C4.92843 9.31211 5.51973 7.22549 6.65154 5.78673C7.85698 4.25433 9.71424 3.46156 12.189 3.44303C14.6819 3.4617 16.5728 4.25837 17.8254 5.79937C18.5162 6.64934 18.949 7.66539 19.2379 8.71407L21.1776 8.19656C20.8148 6.85917 20.2414 5.58371 19.363 4.50305C17.7098 2.46918 15.2816 1.43166 12.1835 1.41016ZM12.4204 12.3782C13.3044 12.3272 14.1239 12.3834 14.8521 12.5345C14.7114 14.1116 14.0589 15.4806 12.3401 15.575C11.2282 15.6376 10.1031 15.1413 10.0484 14.114C10.0077 13.3503 10.5726 12.4847 12.4204 12.3782Z"
  }));
},
    $P = function $P(_ref2530) {
  var _ref2530$color = _ref2530.color,
      C = _ref2530$color === void 0 ? "currentColor" : _ref2530$color,
      _ref2530$size = _ref2530.size,
      e = _ref2530$size === void 0 ? 24 : _ref2530$size,
      l = _ref2530.className,
      i = _objectWithoutProperties(_ref2530, _excluded2530);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18 7C18 7.2624 17.9832 7.52086 17.9505 7.77437C19.7712 8.80457 21 10.7588 21 13C21 16.3137 18.3137 19 15 19C14.2987 19 13.6256 18.8797 13 18.6586V22H11V18.4003C10.2499 18.7837 9.40022 19 8.5 19C5.46243 19 3 16.5376 3 13.5C3 12.0474 3.56312 10.7263 4.48297 9.74318C4.87725 10.8232 5.49744 11.7944 6.28576 12.5989L7.71424 11.1991C6.99071 10.4607 6.45705 9.53767 6.1906 8.50688C6.06607 8.02541 6 7.5204 6 7C6 3.68629 8.68629 1 12 1C15.3137 1 18 3.68629 18 7Z"
  }));
},
    eD = function eD(_ref2531) {
  var _ref2531$color = _ref2531.color,
      C = _ref2531$color === void 0 ? "currentColor" : _ref2531$color,
      _ref2531$size = _ref2531.size,
      e = _ref2531$size === void 0 ? 24 : _ref2531$size,
      l = _ref2531.className,
      i = _objectWithoutProperties(_ref2531, _excluded2531);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6 7C6 3.68629 8.68629 1 12 1C15.3137 1 18 3.68629 18 7C18 7.26214 17.9831 7.5207 17.9504 7.77457C19.77 8.80413 21 10.7575 21 13C21 16.3137 18.3137 19 15 19H13V22H11V19H8.5C5.46243 19 3 16.5376 3 13.5C3 11.2863 4.30712 9.37966 6.19098 8.50704C6.06635 8.02551 6 7.52039 6 7ZM7.00964 10.3319C5.82176 10.8918 5 12.1008 5 13.5C5 15.433 6.567 17 8.5 17H15C17.2091 17 19 15.2091 19 13C19 11.3056 17.9461 9.85488 16.4544 9.27234L15.6129 8.94372C15.7907 8.30337 16 7.67183 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 8.30783 8.6266 9.46903 9.60019 10.2005L8.39884 11.7995C7.85767 11.3929 7.38716 10.8963 7.00964 10.3319Z"
  }));
},
    tD = function tD(_ref2532) {
  var _ref2532$color = _ref2532.color,
      C = _ref2532$color === void 0 ? "currentColor" : _ref2532$color,
      _ref2532$size = _ref2532.size,
      e = _ref2532$size === void 0 ? 24 : _ref2532$size,
      l = _ref2532.className,
      i = _objectWithoutProperties(_ref2532, _excluded2532);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.8659 3.00017L22.3922 19.5002C22.6684 19.9785 22.5045 20.5901 22.0262 20.8662C21.8742 20.954 21.7017 21.0002 21.5262 21.0002H2.47363C1.92135 21.0002 1.47363 20.5525 1.47363 20.0002C1.47363 19.8246 1.51984 19.6522 1.60761 19.5002L11.1339 3.00017C11.41 2.52187 12.0216 2.358 12.4999 2.63414C12.6519 2.72191 12.7782 2.84815 12.8659 3.00017Z"
  }));
},
    CD = function CD(_ref2533) {
  var _ref2533$color = _ref2533.color,
      C = _ref2533$color === void 0 ? "currentColor" : _ref2533$color,
      _ref2533$size = _ref2533.size,
      e = _ref2533$size === void 0 ? 24 : _ref2533$size,
      l = _ref2533.className,
      i = _objectWithoutProperties(_ref2533, _excluded2533);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.8659 3.00017L22.3922 19.5002C22.6684 19.9785 22.5045 20.5901 22.0262 20.8662C21.8742 20.954 21.7017 21.0002 21.5262 21.0002H2.47363C1.92135 21.0002 1.47363 20.5525 1.47363 20.0002C1.47363 19.8246 1.51984 19.6522 1.60761 19.5002L11.1339 3.00017C11.41 2.52187 12.0216 2.358 12.4999 2.63414C12.6519 2.72191 12.7782 2.84815 12.8659 3.00017ZM4.20568 19.0002H19.7941L11.9999 5.50017L4.20568 19.0002Z"
  }));
},
    lD = function lD(_ref2534) {
  var _ref2534$color = _ref2534.color,
      C = _ref2534$color === void 0 ? "currentColor" : _ref2534$color,
      _ref2534$size = _ref2534.size,
      e = _ref2534$size === void 0 ? 24 : _ref2534$size,
      l = _ref2534.className,
      i = _objectWithoutProperties(_ref2534, _excluded2534);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17.6874 3.0625L12.6907 8.77425L8.37045 3.0625H2.11328L9.58961 12.8387L2.50378 20.9375H5.53795L11.0068 14.6886L15.7863 20.9375H21.8885L14.095 10.6342L20.7198 3.0625H17.6874ZM16.6232 19.1225L5.65436 4.78217H7.45745L18.3034 19.1225H16.6232Z"
  }));
},
    iD = function iD(_ref2535) {
  var _ref2535$color = _ref2535.color,
      C = _ref2535$color === void 0 ? "currentColor" : _ref2535$color,
      _ref2535$size = _ref2535.size,
      e = _ref2535$size === void 0 ? 24 : _ref2535$size,
      l = _ref2535.className,
      i = _objectWithoutProperties(_ref2535, _excluded2535);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10.4883 14.651L15.25 21H22.25L14.3917 10.5223L20.9308 3H18.2808L13.1643 8.88578L8.75 3H1.75L9.26086 13.0145L2.31915 21H4.96917L10.4883 14.651ZM16.25 19L5.75 5H7.75L18.25 19H16.25Z"
  }));
},
    sD = function sD(_ref2536) {
  var _ref2536$color = _ref2536.color,
      C = _ref2536$color === void 0 ? "currentColor" : _ref2536$color,
      _ref2536$size = _ref2536.size,
      e = _ref2536$size === void 0 ? 24 : _ref2536$size,
      l = _ref2536.className,
      i = _objectWithoutProperties(_ref2536, _excluded2536);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10.007 2.10377C8.60544 1.65006 7.08181 2.28116 6.41156 3.59306L5.60578 5.17023C5.51004 5.35763 5.35763 5.51004 5.17023 5.60578L3.59306 6.41156C2.28116 7.08181 1.65006 8.60544 2.10377 10.007L2.64923 11.692C2.71404 11.8922 2.71404 12.1078 2.64923 12.308L2.10377 13.993C1.65006 15.3946 2.28116 16.9182 3.59306 17.5885L5.17023 18.3942C5.35763 18.49 5.51004 18.6424 5.60578 18.8298L6.41156 20.407C7.08181 21.7189 8.60544 22.35 10.007 21.8963L11.692 21.3508C11.8922 21.286 12.1078 21.286 12.308 21.3508L13.993 21.8963C15.3946 22.35 16.9182 21.7189 17.5885 20.407L18.3942 18.8298C18.49 18.6424 18.6424 18.49 18.8298 18.3942L20.407 17.5885C21.7189 16.9182 22.35 15.3946 21.8963 13.993L21.3508 12.308C21.286 12.1078 21.286 11.8922 21.3508 11.692L21.8963 10.007C22.35 8.60544 21.7189 7.08181 20.407 6.41156L18.8298 5.60578C18.6424 5.51004 18.49 5.35763 18.3942 5.17023L17.5885 3.59306C16.9182 2.28116 15.3946 1.65006 13.993 2.10377L12.308 2.64923C12.1078 2.71403 11.8922 2.71404 11.692 2.64923L10.007 2.10377ZM6.75977 11.7573L8.17399 10.343L11.0024 13.1715L16.6593 7.51465L18.0735 8.92886L11.0024 15.9999L6.75977 11.7573Z"
  }));
},
    rD = function rD(_ref2537) {
  var _ref2537$color = _ref2537.color,
      C = _ref2537$color === void 0 ? "currentColor" : _ref2537$color,
      _ref2537$size = _ref2537.size,
      e = _ref2537$size === void 0 ? 24 : _ref2537$size,
      l = _ref2537.className,
      i = _objectWithoutProperties(_ref2537, _excluded2537);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10.0072 2.10365C8.60556 1.64993 7.08193 2.28104 6.41168 3.59294L5.6059 5.17011C5.51016 5.35751 5.35775 5.50992 5.17036 5.60566L3.59318 6.41144C2.28128 7.08169 1.65018 8.60532 2.10389 10.0069L2.64935 11.6919C2.71416 11.8921 2.71416 12.1077 2.64935 12.3079L2.10389 13.9929C1.65018 15.3945 2.28129 16.9181 3.59318 17.5883L5.17036 18.3941C5.35775 18.4899 5.51016 18.6423 5.6059 18.8297L6.41169 20.4068C7.08194 21.7187 8.60556 22.3498 10.0072 21.8961L11.6922 21.3507C11.8924 21.2859 12.1079 21.2859 12.3081 21.3507L13.9931 21.8961C15.3947 22.3498 16.9183 21.7187 17.5886 20.4068L18.3944 18.8297C18.4901 18.6423 18.6425 18.4899 18.8299 18.3941L20.4071 17.5883C21.719 16.9181 22.3501 15.3945 21.8964 13.9929L21.3509 12.3079C21.2861 12.1077 21.2861 11.8921 21.3509 11.6919L21.8964 10.0069C22.3501 8.60531 21.719 7.08169 20.4071 6.41144L18.8299 5.60566C18.6425 5.50992 18.4901 5.3575 18.3944 5.17011L17.5886 3.59294C16.9183 2.28104 15.3947 1.64993 13.9931 2.10365L12.3081 2.6491C12.1079 2.71391 11.8924 2.71391 11.6922 2.6491L10.0072 2.10365ZM8.19271 4.50286C8.41612 4.06556 8.924 3.8552 9.39119 4.00643L11.0762 4.55189C11.6768 4.74632 12.3235 4.74632 12.9241 4.55189L14.6091 4.00643C15.0763 3.8552 15.5841 4.06556 15.8076 4.50286L16.6133 6.08004C16.9006 6.64222 17.3578 7.09946 17.92 7.38668L19.4972 8.19246C19.9345 8.41588 20.1448 8.92375 19.9936 9.39095L19.4481 11.076C19.2537 11.6766 19.2537 12.3232 19.4481 12.9238L19.9936 14.6088C20.1448 15.076 19.9345 15.5839 19.4972 15.8073L17.92 16.6131C17.3578 16.9003 16.9006 17.3576 16.6133 17.9197L15.8076 19.4969C15.5841 19.9342 15.0763 20.1446 14.6091 19.9933L12.9241 19.4479C12.3235 19.2535 11.6768 19.2535 11.0762 19.4479L9.3912 19.9933C8.924 20.1446 8.41612 19.9342 8.19271 19.4969L7.38692 17.9197C7.09971 17.3576 6.64246 16.9003 6.08028 16.6131L4.50311 15.8073C4.06581 15.5839 3.85544 15.076 4.00668 14.6088L4.55213 12.9238C4.74656 12.3232 4.74656 11.6766 4.55213 11.076L4.00668 9.39095C3.85544 8.92375 4.06581 8.41588 4.50311 8.19246L6.08028 7.38668C6.64246 7.09946 7.09971 6.64222 7.38692 6.08004L8.19271 4.50286ZM6.75972 11.7573L11.0023 15.9999L18.0734 8.92885L16.6592 7.51464L11.0023 13.1715L8.17394 10.343L6.75972 11.7573Z"
  }));
},
    cD = function cD(_ref2538) {
  var _ref2538$color = _ref2538.color,
      C = _ref2538$color === void 0 ? "currentColor" : _ref2538$color,
      _ref2538$size = _ref2538.size,
      e = _ref2538$size === void 0 ? 24 : _ref2538$size,
      l = _ref2538.className,
      i = _objectWithoutProperties(_ref2538, _excluded2538);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16 3H8C5.79086 3 4 4.79086 4 7V8C6.76142 8 9 10.2386 9 13H15C15 10.2386 17.2386 8 20 8V7C20 4.79086 18.2091 3 16 3ZM20 10C18.3431 10 17 11.3431 17 13V16H15V15H9V16H7V13C7 11.3431 5.65685 10 4 10C2.34315 10 1 11.3431 1 13C1 14.3062 1.83481 15.4175 3 15.8293V21H5V20H19V21H21V15.8293C22.1652 15.4175 23 14.3062 23 13C23 11.3431 21.6569 10 20 10Z"
  }));
},
    oD = function oD(_ref2539) {
  var _ref2539$color = _ref2539.color,
      C = _ref2539$color === void 0 ? "currentColor" : _ref2539$color,
      _ref2539$size = _ref2539.size,
      e = _ref2539$size === void 0 ? 24 : _ref2539$size,
      l = _ref2539.className,
      i = _objectWithoutProperties(_ref2539, _excluded2539);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8 3C5.79086 3 4 4.79086 4 7V9.12602C2.27477 9.57006 1 11.1362 1 13C1 14.4817 1.8052 15.7734 3 16.4646V19V21H5V20H19V21H21V19V16.4646C22.1948 15.7734 23 14.4817 23 13C23 11.1362 21.7252 9.57006 20 9.12602V7C20 4.79086 18.2091 3 16 3H8ZM18 9.12602C16.2748 9.57006 15 11.1362 15 13H9C9 11.1362 7.72523 9.57006 6 9.12602V7C6 5.89543 6.89543 5 8 5H16C17.1046 5 18 5.89543 18 7V9.12602ZM9 15H15V16H17V13C17 11.8954 17.8954 11 19 11C20.1046 11 21 11.8954 21 13C21 13.8693 20.4449 14.6114 19.6668 14.8865C19.2672 15.0277 19 15.4055 19 15.8293V18H5V15.8293C5 15.4055 4.73284 15.0277 4.33325 14.8865C3.5551 14.6114 3 13.8693 3 13C3 11.8954 3.89543 11 5 11C6.10457 11 7 11.8954 7 13V16H9V15Z"
  }));
},
    aD = function aD(_ref2540) {
  var _ref2540$color = _ref2540.color,
      C = _ref2540$color === void 0 ? "currentColor" : _ref2540$color,
      _ref2540$size = _ref2540.size,
      e = _ref2540$size === void 0 ? 24 : _ref2540$size,
      l = _ref2540.className,
      i = _objectWithoutProperties(_ref2540, _excluded2540);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.16705 4.36681L12 1L17.833 4.36681L15.6885 5.61061L12 3.48758L8.31152 5.61061L6.16705 4.36681ZM17.833 8.61285L15.6885 7.36907L12 9.49209L8.31152 7.36907L6.16705 8.61285V11.1004L9.85553 13.2234V17.4695L12 18.7133L14.1445 17.4695V13.2234L17.833 11.1004V8.61285ZM17.833 15.3465V12.8589L15.6885 14.1026V16.5902L17.833 15.3465ZM19.3555 16.2257L15.667 18.3487V20.8363L21.5 17.4695V10.7358L19.3555 11.9797V16.2257ZM17.2111 6.48984L19.3555 7.73362V10.2212L21.5 8.97741V6.48984L19.3555 5.24605L17.2111 6.48984ZM9.85553 19.2494V21.737L12 22.9808L14.1445 21.737V19.2494L12 20.4932L9.85553 19.2494ZM6.16705 15.3465L8.31152 16.5902V14.1026L6.16705 12.8589V15.3465ZM9.85553 6.48984L12 7.73362L14.1445 6.48984L12 5.24605L9.85553 6.48984ZM4.64446 7.73362L6.78894 6.48984L4.64446 5.24605L2.5 6.48984V8.97741L4.64446 10.2212V7.73362ZM4.64446 11.9797L2.5 10.7358V17.4695L8.33294 20.8363V18.3487L4.64446 16.2257V11.9797Z"
  }));
},
    nD = function nD(_ref2541) {
  var _ref2541$color = _ref2541.color,
      C = _ref2541$color === void 0 ? "currentColor" : _ref2541$color,
      _ref2541$size = _ref2541.size,
      e = _ref2541$size === void 0 ? 24 : _ref2541$size,
      l = _ref2541.className,
      i = _objectWithoutProperties(_ref2541, _excluded2541);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11.9999 20.689L9.99079 19.5258L9.98802 21.8352L12 23L14.0115 21.8355L14.0087 19.5261L11.9999 20.689ZM16.0073 18.369L16.0101 20.6784L21.5 17.5V11.1457L19.5 12.2972V16.3469L16.0073 18.369ZM19.5 9.9894L21.5 8.83789V6.5L19.5041 5.34448L17.5082 6.49998L19.5 7.65311V9.9894ZM15.5124 5.34448L17.5082 4.18898L12 1L6.49166 4.18904L8.48752 5.34454L11.9999 3.31104L15.5124 5.34448ZM6.49166 6.50004L4.49579 5.34454L2.5 6.5V8.8383L4.49994 9.98977V7.65314L6.49166 6.50004ZM2.5 11.1461L4.49994 12.2976V16.3469L7.99217 18.3687L7.98941 20.6781L2.5 17.5V11.1461ZM17.4999 8.80625L15.5123 7.65551L11.9999 9.68902L8.48758 7.65558L6.5 8.80628V11.1413L9.99841 13.1555L9.99355 17.2164L11.9999 18.378L14.0059 17.2167L14.0011 13.1554L17.4999 11.1409V8.80625ZM7.99494 16.0594L7.99703 14.311L6.5 13.4491V15.1939L7.99494 16.0594ZM10.4834 6.50008L11.9999 7.37802L13.5164 6.50001L12 5.62207L10.4834 6.50008ZM16.0025 14.3109L17.4999 13.4488V15.1938L16.0046 16.0596L16.0025 14.3109Z"
  }));
},
    mD = function mD(_ref2542) {
  var _ref2542$color = _ref2542.color,
      C = _ref2542$color === void 0 ? "currentColor" : _ref2542$color,
      _ref2542$size = _ref2542.size,
      e = _ref2542$size === void 0 ? 24 : _ref2542$size,
      l = _ref2542.className,
      i = _objectWithoutProperties(_ref2542, _excluded2542);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M1 7C1 4.79086 2.79086 3 5 3H7C4.79086 3 3 4.79086 3 7C3 8.48168 3.8052 9.77343 5 10.4646V19C5 20.6569 6.34315 22 8 22H6C4.34315 22 3 20.6569 3 19V10.4646C1.8052 9.77343 1 8.48168 1 7ZM8 22V20C7.44772 20 7 19.5523 7 19V9.12212L6.33325 8.88645C5.5551 8.61142 5 7.86925 5 7C5 5.89543 5.89543 5 7 5V3H19C21.2091 3 23 4.79086 23 7C23 8.48168 22.1948 9.77343 21 10.4646V19C21 20.6569 19.6569 22 18 22H8Z"
  }));
},
    wD = function wD(_ref2543) {
  var _ref2543$color = _ref2543.color,
      C = _ref2543$color === void 0 ? "currentColor" : _ref2543$color,
      _ref2543$size = _ref2543.size,
      e = _ref2543$size === void 0 ? 24 : _ref2543$size,
      l = _ref2543.className,
      i = _objectWithoutProperties(_ref2543, _excluded2543);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5 3C2.79086 3 1 4.79086 1 7C1 8.48168 1.8052 9.77343 3 10.4646V19C3 20.6569 4.34315 22 6 22H18C19.6569 22 21 20.6569 21 19V10.4646C22.1948 9.77343 23 8.48168 23 7C23 4.79086 21.2091 3 19 3H5ZM7 20C6.44772 20 6 19.5523 6 19V9.12212L5.33325 8.88645C4.5551 8.61142 4 7.86925 4 7C4 5.89543 4.89543 5 6 5H19C20.1046 5 21 5.89543 21 7C21 7.86925 20.4449 8.61142 19.6668 8.88645L19 9.12212V19C19 19.5523 18.5523 20 18 20H7Z"
  }));
},
    LD = function LD(_ref2544) {
  var _ref2544$color = _ref2544.color,
      C = _ref2544$color === void 0 ? "currentColor" : _ref2544$color,
      _ref2544$size = _ref2544.size,
      e = _ref2544$size === void 0 ? 24 : _ref2544$size,
      l = _ref2544.className,
      i = _objectWithoutProperties(_ref2544, _excluded2544);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM16.7055 10.564C16.5323 11.6168 15.9806 12.1314 15.235 12.313C16.2271 12.8683 16.7046 13.7112 16.1938 15.1897C15.5586 17.044 14.1367 17.2122 12.2533 16.853L11.7684 18.81L10.6741 18.5388L11.159 16.5818C11.0352 16.5488 10.9104 16.5199 10.7857 16.4909C10.6137 16.4509 10.436 16.4095 10.2602 16.359L9.77531 18.3161L8.683 18.0454L9.16786 16.0883L6.99194 15.4957L7.53278 14.1119C7.53278 14.1119 8.35407 14.3378 8.34133 14.3236C8.64595 14.3977 8.79489 14.1849 8.85591 14.0359L9.63237 10.8985L10.1975 8.66859C10.2219 8.42756 10.1464 8.11223 9.7013 7.99226C9.7316 7.97451 8.90007 7.7937 8.90007 7.7937L9.2241 6.48228L11.4667 7.03806L11.9416 5.12109L13.0714 5.40109L12.5965 7.31806C12.8882 7.38151 13.1711 7.45862 13.4625 7.53269L13.9374 5.61571L15.0367 5.88814L14.5493 7.85537C15.9358 8.36407 16.9345 9.11777 16.7055 10.564ZM11.6062 10.9543C12.2632 11.1517 14.2111 11.7371 14.5393 10.4337C14.8448 9.19469 13.1568 8.81617 12.3726 8.64033C12.2802 8.61959 12.2003 8.60168 12.1377 8.5855L11.5514 10.9378L11.6062 10.9543ZM10.5917 14.7743L10.6869 14.8025C11.4963 15.0433 13.793 15.7264 14.1045 14.4327C14.4254 13.1868 12.3607 12.7016 11.4363 12.4844C11.335 12.4606 11.2473 12.44 11.1781 12.422L10.5917 14.7743Z"
  }));
},
    hD = function hD(_ref2545) {
  var _ref2545$color = _ref2545.color,
      C = _ref2545$color === void 0 ? "currentColor" : _ref2545$color,
      _ref2545$size = _ref2545.size,
      e = _ref2545$size === void 0 ? 24 : _ref2545$size,
      l = _ref2545.className,
      i = _objectWithoutProperties(_ref2545, _excluded2545);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM16.7055 10.564C16.5323 11.6168 15.9806 12.1314 15.235 12.313C16.2271 12.8683 16.7046 13.7112 16.1938 15.1897C15.5586 17.044 14.1367 17.2122 12.2533 16.853L11.7684 18.81L10.6741 18.5388L11.159 16.5818C10.8606 16.5023 10.5571 16.4442 10.2602 16.359L9.77531 18.3161L8.683 18.0454L9.16786 16.0883L6.99194 15.4957L7.53278 14.1119C7.53278 14.1119 8.35407 14.3378 8.34133 14.3236C8.64595 14.3977 8.79489 14.1849 8.85591 14.0359L9.63237 10.8985L10.1975 8.66859C10.2219 8.42756 10.1464 8.11223 9.7013 7.99226C9.7316 7.97451 8.90007 7.7937 8.90007 7.7937L9.2241 6.48228L11.4667 7.03806L11.9416 5.12109L13.0714 5.40109L12.5965 7.31806C12.8882 7.38151 13.1711 7.45862 13.4625 7.53269L13.9374 5.61571L15.0367 5.88814L14.5493 7.85537C15.9358 8.36407 16.9345 9.11777 16.7055 10.564ZM11.6062 10.9543C12.2632 11.1517 14.2111 11.7371 14.5393 10.4337C14.8448 9.19469 13.1568 8.81617 12.3726 8.64033C12.2802 8.61959 12.2003 8.60168 12.1377 8.5855L11.5514 10.9378L11.6062 10.9543ZM10.5917 14.7743L10.6869 14.8025C11.4963 15.0433 13.793 15.7264 14.1045 14.4327C14.4254 13.1868 12.3607 12.7016 11.4363 12.4844C11.335 12.4606 11.2473 12.44 11.1781 12.422L10.5917 14.7743Z"
  }));
},
    HD = function HD(_ref2546) {
  var _ref2546$color = _ref2546.color,
      C = _ref2546$color === void 0 ? "currentColor" : _ref2546$color,
      _ref2546$size = _ref2546.size,
      e = _ref2546$size === void 0 ? 24 : _ref2546$size,
      l = _ref2546.className,
      i = _objectWithoutProperties(_ref2546, _excluded2546);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7 1V3H3C2.44772 3 2 3.44772 2 4V20C2 20.5523 2.44772 21 3 21H10.7546C9.65672 19.6304 9 17.8919 9 16C9 11.5817 12.5817 8 17 8C18.8919 8 20.6304 8.65672 22 9.75463V4C22 3.44772 21.5523 3 21 3H17V1H15V3H9V1H7ZM23 16C23 19.3137 20.3137 22 17 22C13.6863 22 11 19.3137 11 16C11 12.6863 13.6863 10 17 10C20.3137 10 23 12.6863 23 16ZM16 12V16.4142L18.2929 18.7071L19.7071 17.2929L18 15.5858V12H16Z"
  }));
},
    VD = function VD(_ref2547) {
  var _ref2547$color = _ref2547.color,
      C = _ref2547$color === void 0 ? "currentColor" : _ref2547$color,
      _ref2547$size = _ref2547.size,
      e = _ref2547$size === void 0 ? 24 : _ref2547$size,
      l = _ref2547.className,
      i = _objectWithoutProperties(_ref2547, _excluded2547);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7 3V1H9V3H15V1H17V3H21C21.5523 3 22 3.44772 22 4V9H20V5H17V7H15V5H9V7H7V5H4V19H10V21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H7ZM17 12C14.7909 12 13 13.7909 13 16C13 18.2091 14.7909 20 17 20C19.2091 20 21 18.2091 21 16C21 13.7909 19.2091 12 17 12ZM11 16C11 12.6863 13.6863 10 17 10C20.3137 10 23 12.6863 23 16C23 19.3137 20.3137 22 17 22C13.6863 22 11 19.3137 11 16ZM16 13V16.4142L18.2929 18.7071L19.7071 17.2929L18 15.5858V13H16Z"
  }));
},
    gD = function gD(_ref2548) {
  var _ref2548$color = _ref2548.color,
      C = _ref2548$color === void 0 ? "currentColor" : _ref2548$color,
      _ref2548$size = _ref2548.size,
      e = _ref2548$size === void 0 ? 24 : _ref2548$size,
      l = _ref2548.className,
      i = _objectWithoutProperties(_ref2548, _excluded2548);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5 3C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3H5ZM12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14Z"
  }));
},
    MD = function MD(_ref2549) {
  var _ref2549$color = _ref2549.color,
      C = _ref2549$color === void 0 ? "currentColor" : _ref2549$color,
      _ref2549$size = _ref2549.size,
      e = _ref2549$size === void 0 ? 24 : _ref2549$size,
      l = _ref2549.className,
      i = _objectWithoutProperties(_ref2549, _excluded2549);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5 5L5 19H19V5H5ZM3 5C3 3.89543 3.89543 3 5 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5ZM12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z"
  }));
},
    ZD = function ZD(_ref2550) {
  var _ref2550$color = _ref2550.color,
      C = _ref2550$color === void 0 ? "currentColor" : _ref2550$color,
      _ref2550$size = _ref2550.size,
      e = _ref2550$size === void 0 ? 24 : _ref2550$size,
      l = _ref2550.className,
      i = _objectWithoutProperties(_ref2550, _excluded2550);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5 3C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3H5ZM10.5 9C10.5 9.82843 9.82843 10.5 9 10.5C8.17157 10.5 7.5 9.82843 7.5 9C7.5 8.17157 8.17157 7.5 9 7.5C9.82843 7.5 10.5 8.17157 10.5 9ZM16.5 15C16.5 15.8284 15.8284 16.5 15 16.5C14.1716 16.5 13.5 15.8284 13.5 15C13.5 14.1716 14.1716 13.5 15 13.5C15.8284 13.5 16.5 14.1716 16.5 15Z"
  }));
},
    xD = function xD(_ref2551) {
  var _ref2551$color = _ref2551.color,
      C = _ref2551$color === void 0 ? "currentColor" : _ref2551$color,
      _ref2551$size = _ref2551.size,
      e = _ref2551$size === void 0 ? 24 : _ref2551$size,
      l = _ref2551.className,
      i = _objectWithoutProperties(_ref2551, _excluded2551);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19 5V19H5L5 5H19ZM5 3C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3H5ZM16.5 15C16.5 15.8284 15.8284 16.5 15 16.5C14.1716 16.5 13.5 15.8284 13.5 15C13.5 14.1716 14.1716 13.5 15 13.5C15.8284 13.5 16.5 14.1716 16.5 15ZM9 10.5C9.82843 10.5 10.5 9.82843 10.5 9C10.5 8.17157 9.82843 7.5 9 7.5C8.17157 7.5 7.5 8.17157 7.5 9C7.5 9.82843 8.17157 10.5 9 10.5Z"
  }));
},
    vD = function vD(_ref2552) {
  var _ref2552$color = _ref2552.color,
      C = _ref2552$color === void 0 ? "currentColor" : _ref2552$color,
      _ref2552$size = _ref2552.size,
      e = _ref2552$size === void 0 ? 24 : _ref2552$size,
      l = _ref2552.className,
      i = _objectWithoutProperties(_ref2552, _excluded2552);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5 3C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3H5ZM8.5 10C7.67157 10 7 9.32843 7 8.5C7 7.67157 7.67157 7 8.5 7C9.32843 7 10 7.67157 10 8.5C10 9.32843 9.32843 10 8.5 10ZM15.5 17C14.6716 17 14 16.3284 14 15.5C14 14.6716 14.6716 14 15.5 14C16.3284 14 17 14.6716 17 15.5C17 16.3284 16.3284 17 15.5 17ZM13.5 12C13.5 12.8284 12.8284 13.5 12 13.5C11.1716 13.5 10.5 12.8284 10.5 12C10.5 11.1716 11.1716 10.5 12 10.5C12.8284 10.5 13.5 11.1716 13.5 12Z"
  }));
},
    dD = function dD(_ref2553) {
  var _ref2553$color = _ref2553.color,
      C = _ref2553$color === void 0 ? "currentColor" : _ref2553$color,
      _ref2553$size = _ref2553.size,
      e = _ref2553$size === void 0 ? 24 : _ref2553$size,
      l = _ref2553.className,
      i = _objectWithoutProperties(_ref2553, _excluded2553);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5 5L5 19H19V5H5ZM3 5C3 3.89543 3.89543 3 5 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5ZM15.5 17C16.3284 17 17 16.3284 17 15.5C17 14.6716 16.3284 14 15.5 14C14.6716 14 14 14.6716 14 15.5C14 16.3284 14.6716 17 15.5 17ZM10 8.5C10 9.32843 9.32843 10 8.5 10C7.67157 10 7 9.32843 7 8.5C7 7.67157 7.67157 7 8.5 7C9.32843 7 10 7.67157 10 8.5ZM12 13.5C12.8284 13.5 13.5 12.8284 13.5 12C13.5 11.1716 12.8284 10.5 12 10.5C11.1716 10.5 10.5 11.1716 10.5 12C10.5 12.8284 11.1716 13.5 12 13.5Z"
  }));
},
    pD = function pD(_ref2554) {
  var _ref2554$color = _ref2554.color,
      C = _ref2554$color === void 0 ? "currentColor" : _ref2554$color,
      _ref2554$size = _ref2554.size,
      e = _ref2554$size === void 0 ? 24 : _ref2554$size,
      l = _ref2554.className,
      i = _objectWithoutProperties(_ref2554, _excluded2554);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5 3C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3H5ZM9 10.5C8.17157 10.5 7.5 9.82843 7.5 9C7.5 8.17157 8.17157 7.5 9 7.5C9.82843 7.5 10.5 8.17157 10.5 9C10.5 9.82843 9.82843 10.5 9 10.5ZM10.5 15C10.5 15.8284 9.82843 16.5 9 16.5C8.17157 16.5 7.5 15.8284 7.5 15C7.5 14.1716 8.17157 13.5 9 13.5C9.82843 13.5 10.5 14.1716 10.5 15ZM16.5 15C16.5 15.8284 15.8284 16.5 15 16.5C14.1716 16.5 13.5 15.8284 13.5 15C13.5 14.1716 14.1716 13.5 15 13.5C15.8284 13.5 16.5 14.1716 16.5 15ZM16.5 9C16.5 9.82843 15.8284 10.5 15 10.5C14.1716 10.5 13.5 9.82843 13.5 9C13.5 8.17157 14.1716 7.5 15 7.5C15.8284 7.5 16.5 8.17157 16.5 9Z"
  }));
},
    ED = function ED(_ref2555) {
  var _ref2555$color = _ref2555.color,
      C = _ref2555$color === void 0 ? "currentColor" : _ref2555$color,
      _ref2555$size = _ref2555.size,
      e = _ref2555$size === void 0 ? 24 : _ref2555$size,
      l = _ref2555.className,
      i = _objectWithoutProperties(_ref2555, _excluded2555);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19 5V19H5L5 5H19ZM5 3C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3H5ZM16.5 15C16.5 15.8284 15.8284 16.5 15 16.5C14.1716 16.5 13.5 15.8284 13.5 15C13.5 14.1716 14.1716 13.5 15 13.5C15.8284 13.5 16.5 14.1716 16.5 15ZM9 16.5C9.82843 16.5 10.5 15.8284 10.5 15C10.5 14.1716 9.82843 13.5 9 13.5C8.17157 13.5 7.5 14.1716 7.5 15C7.5 15.8284 8.17157 16.5 9 16.5ZM10.5 9C10.5 9.82843 9.82843 10.5 9 10.5C8.17157 10.5 7.5 9.82843 7.5 9C7.5 8.17157 8.17157 7.5 9 7.5C9.82843 7.5 10.5 8.17157 10.5 9ZM15 10.5C15.8284 10.5 16.5 9.82843 16.5 9C16.5 8.17157 15.8284 7.5 15 7.5C14.1716 7.5 13.5 8.17157 13.5 9C13.5 9.82843 14.1716 10.5 15 10.5Z"
  }));
},
    ND = function ND(_ref2556) {
  var _ref2556$color = _ref2556.color,
      C = _ref2556$color === void 0 ? "currentColor" : _ref2556$color,
      _ref2556$size = _ref2556.size,
      e = _ref2556$size === void 0 ? 24 : _ref2556$size,
      l = _ref2556.className,
      i = _objectWithoutProperties(_ref2556, _excluded2556);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5 3C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3H5ZM10 8.5C10 9.32843 9.32843 10 8.5 10C7.67157 10 7 9.32843 7 8.5C7 7.67157 7.67157 7 8.5 7C9.32843 7 10 7.67157 10 8.5ZM8.5 17C7.67157 17 7 16.3284 7 15.5C7 14.6716 7.67157 14 8.5 14C9.32843 14 10 14.6716 10 15.5C10 16.3284 9.32843 17 8.5 17ZM15.5 17C14.6716 17 14 16.3284 14 15.5C14 14.6716 14.6716 14 15.5 14C16.3284 14 17 14.6716 17 15.5C17 16.3284 16.3284 17 15.5 17ZM15.5 10C14.6716 10 14 9.32843 14 8.5C14 7.67157 14.6716 7 15.5 7C16.3284 7 17 7.67157 17 8.5C17 9.32843 16.3284 10 15.5 10ZM13.5 12C13.5 12.8284 12.8284 13.5 12 13.5C11.1716 13.5 10.5 12.8284 10.5 12C10.5 11.1716 11.1716 10.5 12 10.5C12.8284 10.5 13.5 11.1716 13.5 12Z"
  }));
},
    uD = function uD(_ref2557) {
  var _ref2557$color = _ref2557.color,
      C = _ref2557$color === void 0 ? "currentColor" : _ref2557$color,
      _ref2557$size = _ref2557.size,
      e = _ref2557$size === void 0 ? 24 : _ref2557$size,
      l = _ref2557.className,
      i = _objectWithoutProperties(_ref2557, _excluded2557);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5 5L5 19H19V5H5ZM3 5C3 3.89543 3.89543 3 5 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5ZM15.5 17C16.3284 17 17 16.3284 17 15.5C17 14.6716 16.3284 14 15.5 14C14.6716 14 14 14.6716 14 15.5C14 16.3284 14.6716 17 15.5 17ZM10 15.5C10 16.3284 9.32843 17 8.5 17C7.67157 17 7 16.3284 7 15.5C7 14.6716 7.67157 14 8.5 14C9.32843 14 10 14.6716 10 15.5ZM8.5 10C9.32843 10 10 9.32843 10 8.5C10 7.67157 9.32843 7 8.5 7C7.67157 7 7 7.67157 7 8.5C7 9.32843 7.67157 10 8.5 10ZM17 8.5C17 9.32843 16.3284 10 15.5 10C14.6716 10 14 9.32843 14 8.5C14 7.67157 14.6716 7 15.5 7C16.3284 7 17 7.67157 17 8.5ZM12 13.5C12.8284 13.5 13.5 12.8284 13.5 12C13.5 11.1716 12.8284 10.5 12 10.5C11.1716 10.5 10.5 11.1716 10.5 12C10.5 12.8284 11.1716 13.5 12 13.5Z"
  }));
},
    BD = function BD(_ref2558) {
  var _ref2558$color = _ref2558.color,
      C = _ref2558$color === void 0 ? "currentColor" : _ref2558$color,
      _ref2558$size = _ref2558.size,
      e = _ref2558$size === void 0 ? 24 : _ref2558$size,
      l = _ref2558.className,
      i = _objectWithoutProperties(_ref2558, _excluded2558);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5 3C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3H5ZM9 9.5C8.17157 9.5 7.5 8.82843 7.5 8C7.5 7.17157 8.17157 6.5 9 6.5C9.82843 6.5 10.5 7.17157 10.5 8C10.5 8.82843 9.82843 9.5 9 9.5ZM10.5 12C10.5 12.8284 9.82843 13.5 9 13.5C8.17157 13.5 7.5 12.8284 7.5 12C7.5 11.1716 8.17157 10.5 9 10.5C9.82843 10.5 10.5 11.1716 10.5 12ZM10.5 16C10.5 16.8284 9.82843 17.5 9 17.5C8.17157 17.5 7.5 16.8284 7.5 16C7.5 15.1716 8.17157 14.5 9 14.5C9.82843 14.5 10.5 15.1716 10.5 16ZM15 9.5C14.1716 9.5 13.5 8.82843 13.5 8C13.5 7.17157 14.1716 6.5 15 6.5C15.8284 6.5 16.5 7.17157 16.5 8C16.5 8.82843 15.8284 9.5 15 9.5ZM16.5 12C16.5 12.8284 15.8284 13.5 15 13.5C14.1716 13.5 13.5 12.8284 13.5 12C13.5 11.1716 14.1716 10.5 15 10.5C15.8284 10.5 16.5 11.1716 16.5 12ZM16.5 16C16.5 16.8284 15.8284 17.5 15 17.5C14.1716 17.5 13.5 16.8284 13.5 16C13.5 15.1716 14.1716 14.5 15 14.5C15.8284 14.5 16.5 15.1716 16.5 16Z"
  }));
},
    fD = function fD(_ref2559) {
  var _ref2559$color = _ref2559.color,
      C = _ref2559$color === void 0 ? "currentColor" : _ref2559$color,
      _ref2559$size = _ref2559.size,
      e = _ref2559$size === void 0 ? 24 : _ref2559$size,
      l = _ref2559.className,
      i = _objectWithoutProperties(_ref2559, _excluded2559);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19 5V19H5L5 5H19ZM5 3C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3H5ZM9 9.5C9.82843 9.5 10.5 8.82843 10.5 8C10.5 7.17157 9.82843 6.5 9 6.5C8.17157 6.5 7.5 7.17157 7.5 8C7.5 8.82843 8.17157 9.5 9 9.5ZM10.5 12C10.5 12.8284 9.82843 13.5 9 13.5C8.17157 13.5 7.5 12.8284 7.5 12C7.5 11.1716 8.17157 10.5 9 10.5C9.82843 10.5 10.5 11.1716 10.5 12ZM10.5 16C10.5 16.8284 9.82843 17.5 9 17.5C8.17157 17.5 7.5 16.8284 7.5 16C7.5 15.1716 8.17157 14.5 9 14.5C9.82843 14.5 10.5 15.1716 10.5 16ZM16.5 8C16.5 8.82843 15.8284 9.5 15 9.5C14.1716 9.5 13.5 8.82843 13.5 8C13.5 7.17157 14.1716 6.5 15 6.5C15.8284 6.5 16.5 7.17157 16.5 8ZM15 13.5C15.8284 13.5 16.5 12.8284 16.5 12C16.5 11.1716 15.8284 10.5 15 10.5C14.1716 10.5 13.5 11.1716 13.5 12C13.5 12.8284 14.1716 13.5 15 13.5ZM15 17.5C15.8284 17.5 16.5 16.8284 16.5 16C16.5 15.1716 15.8284 14.5 15 14.5C14.1716 14.5 13.5 15.1716 13.5 16C13.5 16.8284 14.1716 17.5 15 17.5Z"
  }));
},
    RD = function RD(_ref2560) {
  var _ref2560$color = _ref2560.color,
      C = _ref2560$color === void 0 ? "currentColor" : _ref2560$color,
      _ref2560$size = _ref2560.size,
      e = _ref2560$size === void 0 ? 24 : _ref2560$size,
      l = _ref2560.className,
      i = _objectWithoutProperties(_ref2560, _excluded2560);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10.9979 1.58018C11.6178 1.22132 12.3822 1.22132 13.0021 1.58018L20.5021 5.92229C21.1197 6.27987 21.5 6.93946 21.5 7.65314V16.3469C21.5 17.0606 21.1197 17.7202 20.5021 18.0778L13.0021 22.4199C12.3822 22.7788 11.6178 22.7788 10.9979 22.4199L3.49793 18.0778C2.88029 17.7202 2.5 17.0606 2.5 16.3469V7.65314C2.5 6.93946 2.88029 6.27987 3.49793 5.92229L10.9979 1.58018ZM5.25052 8.09243C4.91718 7.89945 4.5 8.13997 4.5 8.52514V15.1938C4.5 15.9075 4.88029 16.5671 5.49793 16.9247L11.2495 20.2545C11.5828 20.4475 12 20.207 12 19.8218V13.1531C12 12.4395 11.6197 11.7799 11.0021 11.4223L5.25052 8.09243ZM15.7681 5.51719C15.2898 5.24106 14.5143 5.24106 14.036 5.51719C13.5577 5.79332 13.5577 6.24101 14.036 6.51713C14.5143 6.79326 15.2898 6.79326 15.7681 6.51713C16.2464 6.24101 16.2464 5.79332 15.7681 5.51719ZM9.96825 5.51723C9.48995 5.2411 8.71447 5.2411 8.23617 5.51723C7.75787 5.79335 7.75787 6.24104 8.23617 6.51717C8.71447 6.7933 9.48995 6.7933 9.96825 6.51717C10.4466 6.24104 10.4466 5.79335 9.96825 5.51723ZM16.9925 15.8452C17.5903 15.5 18.0749 14.6605 18.075 13.9702C18.075 13.2798 17.5904 13 16.9926 13.3452C16.3948 13.6904 15.9101 14.5299 15.9101 15.2202C15.9101 15.9106 16.3947 16.1904 16.9925 15.8452ZM6.3662 12.2003C6.84448 12.4765 7.2322 12.2526 7.23218 11.7003C7.23216 11.148 6.84442 10.4765 6.36614 10.2003C5.88785 9.92414 5.50014 10.148 5.50016 10.7003C5.50018 11.2526 5.88792 11.9241 6.3662 12.2003ZM10.6951 17.6982C10.6951 18.2505 10.3074 18.4743 9.82909 18.1981C9.35081 17.922 8.96307 17.2504 8.96305 16.6981C8.96303 16.1458 9.35074 15.922 9.82903 16.1981C10.3073 16.4743 10.6951 17.1459 10.6951 17.6982ZM7.23218 15.6993C7.2322 16.2516 6.84448 16.4755 6.3662 16.1993C5.88792 15.9232 5.50018 15.2516 5.50016 14.6993C5.50014 14.147 5.88785 13.9232 6.36614 14.1993C6.84442 14.4755 7.23216 15.1471 7.23218 15.6993ZM10.6946 13.6998C10.6946 14.2521 10.3069 14.476 9.8286 14.1998C9.35032 13.9236 8.96258 13.2521 8.96256 12.6998C8.96254 12.1475 9.35026 11.9237 9.82854 12.1998C10.3068 12.476 10.6946 13.1476 10.6946 13.6998Z"
  }));
},
    zD = function zD(_ref2561) {
  var _ref2561$color = _ref2561.color,
      C = _ref2561$color === void 0 ? "currentColor" : _ref2561$color,
      _ref2561$size = _ref2561.size,
      e = _ref2561$size === void 0 ? 24 : _ref2561$size,
      l = _ref2561.className,
      i = _objectWithoutProperties(_ref2561, _excluded2561);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10.9979 1.58018C11.6178 1.22132 12.3822 1.22132 13.0021 1.58018L20.5021 5.92229C21.1197 6.27987 21.5 6.93946 21.5 7.65314V16.3469C21.5 17.0606 21.1197 17.7202 20.5021 18.0778L13.0021 22.4199C12.3822 22.7788 11.6178 22.7788 10.9979 22.4199L3.49793 18.0778C2.88029 17.7202 2.5 17.0606 2.5 16.3469V7.65314C2.5 6.93947 2.88029 6.27987 3.49793 5.92229L10.9979 1.58018ZM4.5 7.65314V7.65792L11.0021 11.4223C11.6197 11.7799 12 12.4395 12 13.1531V20.689L19.5 16.3469V7.65314L12 3.31104L4.5 7.65314ZM6.13208 12.3C6.13206 11.7477 5.74432 11.0761 5.26604 10.7999C4.78776 10.5238 4.40004 10.7476 4.40006 11.2999C4.40008 11.8522 4.78782 12.5238 5.2661 12.7999C5.74439 13.0761 6.1321 12.8523 6.13208 12.3ZM8.72899 18.7982C9.20728 19.0743 9.59499 18.8505 9.59497 18.2982C9.59495 17.7459 9.20721 17.0743 8.72893 16.7982C8.25065 16.522 7.86293 16.7459 7.86295 17.2982C7.86297 17.8504 8.25071 18.522 8.72899 18.7982ZM5.2661 16.799C5.74439 17.0751 6.1321 16.8513 6.13208 16.299C6.13206 15.7467 5.74432 15.0751 5.26604 14.799C4.78776 14.5228 4.40004 14.7467 4.40006 15.2989C4.40008 15.8512 4.78782 16.5228 5.2661 16.799ZM8.72851 14.7995C9.20679 15.0756 9.5945 14.8518 9.59448 14.2995C9.59446 13.7472 9.20673 13.0756 8.72844 12.7995C8.25016 12.5233 7.86245 12.7471 7.86246 13.2994C7.86248 13.8517 8.25022 14.5233 8.72851 14.7995ZM14.8979 8.00001C15.3762 7.72388 15.3762 7.27619 14.8979 7.00006C14.4196 6.72394 13.6441 6.72394 13.1658 7.00006C12.6875 7.27619 12.6875 7.72388 13.1658 8.00001C13.6441 8.27614 14.4196 8.27614 14.8979 8.00001ZM10.0981 7.00006C10.5764 7.27619 10.5764 7.72388 10.0981 8.00001C9.61982 8.27614 8.84434 8.27614 8.36604 8.00001C7.88774 7.72388 7.88774 7.27619 8.36604 7.00006C8.84434 6.72394 9.61982 6.72394 10.0981 7.00006ZM15.9954 15.3495C16.5932 15.0043 17.0779 14.1649 17.0779 13.4745C17.0779 12.7842 16.5933 12.5044 15.9955 12.8496C15.3977 13.1948 14.9131 14.0342 14.913 14.7246C14.913 15.4149 15.3976 15.6947 15.9954 15.3495Z"
  }));
},
    FD = function FD(_ref2562) {
  var _ref2562$color = _ref2562.color,
      C = _ref2562$color === void 0 ? "currentColor" : _ref2562$color,
      _ref2562$size = _ref2562.size,
      e = _ref2562$size === void 0 ? 24 : _ref2562$size,
      l = _ref2562.className,
      i = _objectWithoutProperties(_ref2562, _excluded2562);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14 2H6.20495C5.6091 2 5.09608 2.42057 4.97923 3.00485L4.1802 7H2V9H4.10875H19.8912H22V7H19.8198L19.0208 3.00485C18.9039 2.42057 18.3909 2 17.795 2H16V0H14V2ZM19.6605 11H4.33952L5.48105 20.8933C5.55383 21.524 6.08789 22 6.72281 22H17.2772C17.9121 22 18.4462 21.524 18.5189 20.8933L19.6605 11Z"
  }));
},
    SD = function SD(_ref2563) {
  var _ref2563$color = _ref2563.color,
      C = _ref2563$color === void 0 ? "currentColor" : _ref2563$color,
      _ref2563$size = _ref2563.size,
      e = _ref2563$size === void 0 ? 24 : _ref2563$size,
      l = _ref2563.className,
      i = _objectWithoutProperties(_ref2563, _excluded2563);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14 2H6.20495C5.6091 2 5.09608 2.42057 4.97923 3.00485L4.1802 7H2V9H4.10875L5.48105 20.8933C5.55383 21.524 6.08789 22 6.72281 22H17.2772C17.9121 22 18.4462 21.524 18.5189 20.8933L19.8912 9H22V7H19.8198L19.0208 3.00485C18.9039 2.42057 18.3909 2 17.795 2H16V0H14V2ZM17.7802 7H6.2198L6.8198 4H17.1802L17.7802 7ZM6.12202 9H17.878L16.6088 20H7.39125L6.12202 9Z"
  }));
},
    AD = function AD(_ref2564) {
  var _ref2564$color = _ref2564.color,
      C = _ref2564$color === void 0 ? "currentColor" : _ref2564$color,
      _ref2564$size = _ref2564.size,
      e = _ref2564$size === void 0 ? 24 : _ref2564$size,
      l = _ref2564.className,
      i = _objectWithoutProperties(_ref2564, _excluded2564);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 7C3 5.067 4.567 3.5 6.5 3.5C8.433 3.5 10 5.067 10 7C10 8.933 8.433 10.5 6.5 10.5C4.567 10.5 3 8.933 3 7ZM20 8H12V6H20V8ZM14 17C14 15.067 15.567 13.5 17.5 13.5C19.433 13.5 21 15.067 21 17C21 18.933 19.433 20.5 17.5 20.5C15.567 20.5 14 18.933 14 17ZM12 16V18H4V16H12Z"
  }));
},
    kD = function kD(_ref2565) {
  var _ref2565$color = _ref2565.color,
      C = _ref2565$color === void 0 ? "currentColor" : _ref2565$color,
      _ref2565$size = _ref2565.size,
      e = _ref2565$size === void 0 ? 24 : _ref2565$size,
      l = _ref2565.className,
      i = _objectWithoutProperties(_ref2565, _excluded2565);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5 7C5 6.17157 5.67157 5.5 6.5 5.5C7.32843 5.5 8 6.17157 8 7C8 7.82843 7.32843 8.5 6.5 8.5C5.67157 8.5 5 7.82843 5 7ZM6.5 3.5C4.567 3.5 3 5.067 3 7C3 8.933 4.567 10.5 6.5 10.5C8.433 10.5 10 8.933 10 7C10 5.067 8.433 3.5 6.5 3.5ZM12 8H20V6H12V8ZM16 17C16 16.1716 16.6716 15.5 17.5 15.5C18.3284 15.5 19 16.1716 19 17C19 17.8284 18.3284 18.5 17.5 18.5C16.6716 18.5 16 17.8284 16 17ZM17.5 13.5C15.567 13.5 14 15.067 14 17C14 18.933 15.567 20.5 17.5 20.5C19.433 20.5 21 18.933 21 17C21 15.067 19.433 13.5 17.5 13.5ZM4 16V18H12V16H4Z"
  }));
},
    PD = function PD(_ref2566) {
  var _ref2566$color = _ref2566.color,
      C = _ref2566$color === void 0 ? "currentColor" : _ref2566$color,
      _ref2566$size = _ref2566.size,
      e = _ref2566$size === void 0 ? 24 : _ref2566$size,
      l = _ref2566.className,
      i = _objectWithoutProperties(_ref2566, _excluded2566);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7 3V6H3V8H7V11H10V3H7ZM12 8H21V6H12V8ZM17 13V16H21V18H17V21H14V13H17ZM12 18H3V16H12V18Z"
  }));
},
    DD = function DD(_ref2567) {
  var _ref2567$color = _ref2567.color,
      C = _ref2567$color === void 0 ? "currentColor" : _ref2567$color,
      _ref2567$size = _ref2567.size,
      e = _ref2567$size === void 0 ? 24 : _ref2567$size,
      l = _ref2567.className,
      i = _objectWithoutProperties(_ref2567, _excluded2567);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7 3V6H3V8H7V11H9V3H7ZM11 8H21V6H11V8ZM17 13V16H21V18H17V21H15V13H17ZM13 18H3V16H13V18Z"
  }));
},
    yD = function yD(_ref2568) {
  var _ref2568$color = _ref2568.color,
      C = _ref2568$color === void 0 ? "currentColor" : _ref2568$color,
      _ref2568$size = _ref2568.size,
      e = _ref2568$size === void 0 ? 24 : _ref2568$size,
      l = _ref2568.className,
      i = _objectWithoutProperties(_ref2568, _excluded2568);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11.9999 0 4.62988 12.2201 11.9999 16.5743 19.3699 12.2201 11.9999 0ZM11.9999 24 4.62988 13.6172 11.9999 18 19.3699 13.6172 11.9999 24Z"
  }));
},
    bD = function bD(_ref2569) {
  var _ref2569$color = _ref2569.color,
      C = _ref2569$color === void 0 ? "currentColor" : _ref2569$color,
      _ref2569$size = _ref2569.size,
      e = _ref2569$size === void 0 ? 24 : _ref2569$size,
      l = _ref2569.className,
      i = _objectWithoutProperties(_ref2569, _excluded2569);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8.1488 15.3042L12 20.5996L15.8513 15.3042L12 17.6742L8.1488 15.3042ZM17.1374 12.1643L12 3.81608L6.86261 12.1643L12 15.3258L17.1374 12.1643ZM4 13L12 0L20 13L12.0001 24L4 13Z"
  }));
},
    TD = function TD(_ref2570) {
  var _ref2570$color = _ref2570.color,
      C = _ref2570$color === void 0 ? "currentColor" : _ref2570$color,
      _ref2570$size = _ref2570.size,
      e = _ref2570$size === void 0 ? 24 : _ref2570$size,
      l = _ref2570.className,
      i = _objectWithoutProperties(_ref2570, _excluded2570);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.455 2.30885L11.9998 2.07617L11.5447 2.30885C10.3952 2.89646 9.35317 3.6638 8.45557 4.57394C9.77392 5.26024 10.9693 6.15018 12.0001 7.20207C13.0308 6.15028 14.2261 5.26041 15.5443 4.57414C14.6466 3.66391 13.6045 2.8965 12.455 2.30885ZM10.6993 8.73433C8.98925 6.93503 6.72625 5.66541 4.18066 5.19783L3 4.98096V13.0002C3 16.8047 5.36065 20.0579 8.69711 21.3748C8.24472 19.9984 8 18.5278 8 17C8 13.9083 9.00215 11.0507 10.6993 8.73433ZM21 4.98096L19.8193 5.19783C14.233 6.22396 10 11.1168 10 17.0002C10 18.5362 10.2891 20.0071 10.8167 21.3598L11.0569 21.9754C11.3711 21.9852 11.6856 22.0002 12 22.0002C16.9706 22.0002 21 17.9708 21 13.0002V4.98096Z"
  }));
},
    UD = function UD(_ref2571) {
  var _ref2571$color = _ref2571.color,
      C = _ref2571$color === void 0 ? "currentColor" : _ref2571$color,
      _ref2571$size = _ref2571.size,
      e = _ref2571$size === void 0 ? 24 : _ref2571$size,
      l = _ref2571.className,
      i = _objectWithoutProperties(_ref2571, _excluded2571);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11.9999 2.07617L12.4551 2.30885C14.2208 3.21149 15.7328 4.53815 16.8573 6.15479C17.7852 5.71408 18.7788 5.38878 19.8193 5.19765L21 4.98077V12.9998C21 17.9703 16.9706 22 12 22C7.02944 22 3 17.9706 3 13V4.98077L4.18066 5.19765C5.22115 5.38877 6.2147 5.71404 7.14253 6.15472C8.26706 4.53811 9.77902 3.21147 11.5447 2.30885L11.9999 2.07617ZM8.87757 7.1651C10.1073 8.02652 11.1679 9.11272 12 10.3645C12.8322 9.11279 13.893 8.02648 15.1223 7.16521C14.2952 6.016 13.2302 5.04929 11.9999 4.33747C10.7697 5.04926 9.70468 6.01593 8.87757 7.1651ZM10.8993 12.4338C10.0182 10.7203 8.65593 9.29326 6.99112 8.33231C6.3667 7.97189 5.6999 7.67713 5 7.45734V13C5 16.29 7.26961 19.0498 10.3285 19.7992C10.1137 18.9004 10 17.9629 10 16.9998C10 15.3831 10.3198 13.8412 10.8993 12.4338ZM12.4531 19.9856C16.1079 19.7521 19 16.7136 19 12.9998V7.45734C18.3 7.67715 17.6332 7.97193 17.0088 8.33239C14.0127 10.0618 12 13.2964 12 16.9998C12 18.0411 12.1588 19.0437 12.4531 19.9856Z"
  }));
},
    GD = function GD(_ref2572) {
  var _ref2572$color = _ref2572.color,
      C = _ref2572$color === void 0 ? "currentColor" : _ref2572$color,
      _ref2572$size = _ref2572.size,
      e = _ref2572$size === void 0 ? 24 : _ref2572$size,
      l = _ref2572.className,
      i = _objectWithoutProperties(_ref2572, _excluded2572);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3.03118 10.9764C3.0702 9.49537 3.15802 8.30899 3.35562 7.32112C3.68725 5.66312 4.30954 4.66225 5.55495 3.83206L4.44563 2.16791C2.69075 3.33771 1.8129 4.83684 1.39446 6.92885C0.999908 8.90143 0.999948 11.4836 1 14.8799V14.8799L1 14.9994C1 14.9996 1 14.9998 1 15C1 17.7614 3.23858 20 6 20C8.76143 20 11 17.7614 11 15C11 14.7261 10.9779 14.4568 10.9352 14.1941C11.2657 14.0687 11.6242 14 12 14C12.3758 14 12.7344 14.0687 13.0648 14.1941C13.0221 14.4568 13 14.7261 13 15C13 17.7614 15.2386 20 18 20C20.7614 20 23 17.7614 23 15V14.8799C23.0001 11.4836 23.0001 8.90145 22.6056 6.92888C22.1873 4.83693 21.3096 3.33779 19.555 2.16796L18.4456 3.83201C19.6907 4.66217 20.3129 5.66303 20.6445 7.32108C20.842 8.30896 20.9298 9.49537 20.9688 10.9764C20.1386 10.3628 19.1117 9.99998 18 9.99998C16.2216 9.99998 14.6617 10.9281 13.7755 12.3247C13.2232 12.1149 12.6245 12 12 12C11.3755 12 10.7768 12.1149 10.2245 12.3247C9.33834 10.9281 7.77841 9.99998 6 9.99998C4.88835 9.99998 3.86143 10.3628 3.03118 10.9764Z"
  }));
},
    ID = function ID(_ref2573) {
  var _ref2573$color = _ref2573.color,
      C = _ref2573$color === void 0 ? "currentColor" : _ref2573$color,
      _ref2573$size = _ref2573.size,
      e = _ref2573$size === void 0 ? 24 : _ref2573$size,
      l = _ref2573.className,
      i = _objectWithoutProperties(_ref2573, _excluded2573);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3.01513 10.9876C3.04409 9.4534 3.12559 8.46708 3.3548 7.32118C3.68643 5.66318 4.30872 4.66231 5.55413 3.83212L4.44481 2.16797C2.68993 3.33777 1.81208 4.83691 1.39364 6.92891C0.873728 9.52823 0.995882 14.8642 0.999024 14.9975C0.999024 14.9983 0.999023 14.9992 0.999023 15C0.999023 17.7614 3.2376 20 5.99902 20C8.76045 20 10.999 17.7614 10.999 15C10.999 14.7261 10.9769 14.4569 10.9343 14.1941C11.2647 14.0687 11.6233 14 11.999 14C12.3748 14 12.7334 14.0687 13.0638 14.1941C13.0211 14.4569 12.999 14.7261 12.999 15C12.999 17.7614 15.2376 20 17.999 20C20.7604 20 22.999 17.7614 22.999 15C22.999 15 22.999 15 22.999 15L22.9992 15C22.9992 15 23.1312 9.56126 22.6048 6.92895C22.1865 4.83699 21.3088 3.33785 19.5542 2.16802L18.4447 3.83207C19.6899 4.66224 20.3121 5.66309 20.6436 7.32114C20.8728 8.46712 20.9543 9.45349 20.9832 10.9878C20.1503 10.3673 19.1176 10 17.999 10C16.2206 10 14.6607 10.9281 13.7745 12.3247C13.2223 12.1149 12.6235 12 11.999 12C11.3745 12 10.7758 12.1149 10.2236 12.3247C9.33736 10.9281 7.77743 10 5.99902 10C4.88064 10 3.84801 10.3672 3.01513 10.9876ZM2.99902 15C2.99902 13.3431 4.34217 12 5.99902 12C7.30607 12 8.42033 12.8364 8.83082 14.0063C8.93949 14.316 8.99902 14.65 8.99902 15C8.99902 16.6569 7.65588 18 5.99902 18C4.34217 18 2.99902 16.6569 2.99902 15ZM15.1672 14.0063C15.5777 12.8364 16.692 12 17.999 12C19.6559 12 20.999 13.3431 20.999 15C20.999 16.6569 19.6559 18 17.999 18C16.3422 18 14.999 16.6569 14.999 15C14.999 14.65 15.0586 14.316 15.1672 14.0063Z"
  }));
},
    WD = function WD(_ref2574) {
  var _ref2574$color = _ref2574.color,
      C = _ref2574$color === void 0 ? "currentColor" : _ref2574$color,
      _ref2574$size = _ref2574.size,
      e = _ref2574$size === void 0 ? 24 : _ref2574$size,
      l = _ref2574.className,
      i = _objectWithoutProperties(_ref2574, _excluded2574);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M1 12C1 9.23858 3.23858 7 6 7C7.21392 7 8.32661 7.43307 9.19203 8.1515C9.91366 7.44003 10.905 7 12 7C13.095 7 14.0863 7.44003 14.808 8.1515C15.6734 7.43307 16.7861 7 18 7C20.7614 7 23 9.23858 23 12C23 14.7614 20.7614 17 18 17C15.2386 17 13 14.7614 13 12C13 11.1835 13.1964 10.411 13.5445 9.72905C13.177 9.28296 12.6209 9 12 9C11.3791 9 10.823 9.28296 10.4555 9.72905C10.8036 10.411 11 11.1835 11 12C11 14.7614 8.76142 17 6 17C3.23858 17 1 14.7614 1 12Z"
  }));
},
    OD = function OD(_ref2575) {
  var _ref2575$color = _ref2575.color,
      C = _ref2575$color === void 0 ? "currentColor" : _ref2575$color,
      _ref2575$size = _ref2575.size,
      e = _ref2575$size === void 0 ? 24 : _ref2575$size,
      l = _ref2575.className,
      i = _objectWithoutProperties(_ref2575, _excluded2575);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6 9C4.34315 9 3 10.3431 3 12C3 13.6569 4.34315 15 6 15C7.65685 15 9 13.6569 9 12C9 11.3629 8.8025 10.7748 8.46538 10.29C7.92183 9.50831 7.02019 9 6 9ZM1 12C1 9.23858 3.23858 7 6 7C7.21392 7 8.32661 7.43307 9.19203 8.1515C9.91366 7.44003 10.905 7 12 7C13.095 7 14.0863 7.44003 14.808 8.1515C15.6734 7.43307 16.7861 7 18 7C20.7614 7 23 9.23858 23 12C23 14.7614 20.7614 17 18 17C15.2386 17 13 14.7614 13 12C13 11.1835 13.1964 10.411 13.5445 9.72905C13.177 9.28296 12.6209 9 12 9C11.3791 9 10.823 9.28296 10.4555 9.72905C10.8036 10.411 11 11.1835 11 12C11 14.7614 8.76142 17 6 17C3.23858 17 1 14.7614 1 12ZM18 9C16.9798 9 16.0782 9.50831 15.5346 10.29C15.1975 10.7748 15 11.3629 15 12C15 13.6569 16.3431 15 18 15C19.6569 15 21 13.6569 21 12C21 10.3431 19.6569 9 18 9Z"
  }));
},
    KD = function KD(_ref2576) {
  var _ref2576$color = _ref2576.color,
      C = _ref2576$color === void 0 ? "currentColor" : _ref2576$color,
      _ref2576$size = _ref2576.size,
      e = _ref2576$size === void 0 ? 24 : _ref2576$size,
      l = _ref2576.className,
      i = _objectWithoutProperties(_ref2576, _excluded2576);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4.95151 6.94243C7.08082 6.11818 9.75096 6 12 6C14.249 6 16.9192 6.11818 19.0485 6.94243C20.1296 7.36094 21.1294 7.98254 21.8583 8.91561C22.5975 9.86175 23 11.0541 23 12.5C23 13.9701 22.4751 15.4334 21.6205 16.5424C20.7689 17.6475 19.5033 18.5 18 18.5C16.5751 18.5 15.3437 17.7094 14.4251 17.1196C13.7195 16.6666 12.8833 16 12 16C11.1167 16 10.2804 16.6666 9.5749 17.1196C8.65627 17.7094 7.42486 18.5 6 18.5C4.49667 18.5 3.23108 17.6475 2.37947 16.5424C1.52489 15.4334 1 13.9701 1 12.5C1 11.0541 1.40249 9.86175 2.14166 8.91561C2.87062 7.98254 3.87036 7.36094 4.95151 6.94243Z"
  }));
},
    QD = function QD(_ref2577) {
  var _ref2577$color = _ref2577.color,
      C = _ref2577$color === void 0 ? "currentColor" : _ref2577$color,
      _ref2577$size = _ref2577.size,
      e = _ref2577$size === void 0 ? 24 : _ref2577$size,
      l = _ref2577.className,
      i = _objectWithoutProperties(_ref2577, _excluded2577);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3.71771 10.1469C3.28501 10.7007 3 11.4459 3 12.5C3 13.5152 3.37054 14.5519 3.96367 15.3216C4.55979 16.0952 5.29419 16.5 6 16.5C6.76159 16.5 7.5137 16.066 8.53831 15.4084C9.58713 14.7353 10.7058 14 12 14C13.2942 14 14.4129 14.7353 15.4617 15.4084C16.4863 16.066 17.2384 16.5 18 16.5C18.7058 16.5 19.4402 16.0952 20.0363 15.3216C20.6295 14.5519 21 13.5152 21 12.5C21 11.4459 20.715 10.7007 20.2823 10.1469C19.8394 9.57996 19.1829 9.13906 18.3265 8.80757C16.5808 8.13182 14.251 8 12 8C9.74904 8 7.41918 8.13182 5.67349 8.80757C4.81714 9.13906 4.16063 9.57996 3.71771 10.1469ZM4.95151 6.94243C7.08082 6.11818 9.75096 6 12 6C14.249 6 16.9192 6.11818 19.0485 6.94243C20.1296 7.36094 21.1294 7.98254 21.8583 8.91561C22.5975 9.86175 23 11.0541 23 12.5C23 13.9701 22.4751 15.4334 21.6205 16.5424C20.7689 17.6475 19.5033 18.5 18 18.5C16.5751 18.5 15.3437 17.7094 14.4251 17.1196C13.7195 16.6666 12.8833 16 12 16C11.1167 16 10.2804 16.6666 9.5749 17.1196C8.65627 17.7094 7.42486 18.5 6 18.5C4.49667 18.5 3.23108 17.6475 2.37947 16.5424C1.52489 15.4334 1 13.9701 1 12.5C1 11.0541 1.40249 9.86175 2.14166 8.91561C2.87062 7.98254 3.87036 7.36094 4.95151 6.94243Z"
  }));
},
    qD = function qD(_ref2578) {
  var _ref2578$color = _ref2578.color,
      C = _ref2578$color === void 0 ? "currentColor" : _ref2578$color,
      _ref2578$size = _ref2578.size,
      e = _ref2578$size === void 0 ? 24 : _ref2578$size,
      l = _ref2578.className,
      i = _objectWithoutProperties(_ref2578, _excluded2578);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19.5762 14.5759L15.7073 10.707C15.3168 10.3164 14.6836 10.3164 14.2931 10.707L6.86516 18.1349C5.11372 16.6674 4 14.4637 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 12.9012 19.851 13.7676 19.5762 14.5759ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM11 10C11 11.1046 10.1046 12 9 12C7.89543 12 7 11.1046 7 10C7 8.89543 7.89543 8 9 8C10.1046 8 11 8.89543 11 10Z"
  }));
},
    jD = function jD(_ref2579) {
  var _ref2579$color = _ref2579.color,
      C = _ref2579$color === void 0 ? "currentColor" : _ref2579$color,
      _ref2579$size = _ref2579.size,
      e = _ref2579$size === void 0 ? 24 : _ref2579$size,
      l = _ref2579.className,
      i = _objectWithoutProperties(_ref2579, _excluded2579);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19.5761 14.5764L15.7067 10.707C15.3162 10.3164 14.683 10.3164 14.2925 10.707L6.86484 18.1346C5.11358 16.6671 4 14.4636 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 12.9014 19.8509 13.7679 19.5761 14.5764ZM8.58927 19.2386L14.9996 12.8283L18.6379 16.4666C17.1992 18.6003 14.7613 19.9998 11.9996 19.9998C10.7785 19.9998 9.62345 19.7268 8.58927 19.2386ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM11 10C11 11.1046 10.1046 12 9 12C7.89543 12 7 11.1046 7 10C7 8.89543 7.89543 8 9 8C10.1046 8 11 8.89543 11 10Z"
  }));
},
    XD = function XD(_ref2580) {
  var _ref2580$color = _ref2580.color,
      C = _ref2580$color === void 0 ? "currentColor" : _ref2580$color,
      _ref2580$size = _ref2580.size,
      e = _ref2580$size === void 0 ? 24 : _ref2580$size,
      l = _ref2580.className,
      i = _objectWithoutProperties(_ref2580, _excluded2580);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 6C12.8284 6 13.5 5.32843 13.5 4.5C13.5 3.67157 12.8284 3 12 3C11.1716 3 10.5 3.67157 10.5 4.5C10.5 5.32843 11.1716 6 12 6ZM9 10H11V18H9V20H15V18H13V8H9V10Z"
  }));
},
    JD = function JD(_ref2581) {
  var _ref2581$color = _ref2581.color,
      C = _ref2581$color === void 0 ? "currentColor" : _ref2581$color,
      _ref2581$size = _ref2581.size,
      e = _ref2581$size === void 0 ? 24 : _ref2581$size,
      l = _ref2581.className,
      i = _objectWithoutProperties(_ref2581, _excluded2581);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM13.5003 8C13.8278 8.43606 14.0625 8.94584 14.175 9.5H16V11H14.175C13.8275 12.7117 12.3142 14 10.5 14H10.3107L14.0303 17.7197L12.9697 18.7803L8 13.8107V12.5H10.5C11.4797 12.5 12.3131 11.8739 12.622 11H8V9.5H12.622C12.3131 8.62611 11.4797 8 10.5 8H8V6.5H16V8H13.5003Z"
  }));
},
    YD = function YD(_ref2582) {
  var _ref2582$color = _ref2582.color,
      C = _ref2582$color === void 0 ? "currentColor" : _ref2582$color,
      _ref2582$size = _ref2582.size,
      e = _ref2582$size === void 0 ? 24 : _ref2582$size,
      l = _ref2582.className,
      i = _objectWithoutProperties(_ref2582, _excluded2582);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM13.5003 8C13.8278 8.43606 14.0625 8.94584 14.175 9.5H16V11H14.175C13.8275 12.7117 12.3142 14 10.5 14H10.3107L14.0303 17.7197L12.9697 18.7803L8 13.8107V12.5H10.5C11.4797 12.5 12.3131 11.8739 12.622 11H8V9.5H12.622C12.3131 8.62611 11.4797 8 10.5 8H8V6.5H16V8H13.5003Z"
  }));
},
    _D = function _D(_ref2583) {
  var _ref2583$color = _ref2583.color,
      C = _ref2583$color === void 0 ? "currentColor" : _ref2583$color,
      _ref2583$size = _ref2583.size,
      e = _ref2583$size === void 0 ? 24 : _ref2583$size,
      l = _ref2583.className,
      i = _objectWithoutProperties(_ref2583, _excluded2583);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 3C2.44772 3 2 3.44772 2 4V20C2 20.5523 2.44772 21 3 21H21C21.5523 21 22 20.5523 22 20V4C22 3.44772 21.5523 3 21 3H3ZM6 7H12V13H6V7ZM8 9V11H10V9H8ZM18 9H14V7H18V9ZM14 13V11H18V13H14ZM6 17V15L18 15V17L6 17Z"
  }));
},
    $D = function $D(_ref2584) {
  var _ref2584$color = _ref2584.color,
      C = _ref2584$color === void 0 ? "currentColor" : _ref2584$color,
      _ref2584$size = _ref2584.size,
      e = _ref2584$size === void 0 ? 24 : _ref2584$size,
      l = _ref2584.className,
      i = _objectWithoutProperties(_ref2584, _excluded2584);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4ZM4 5V19H20V5H4ZM6 7H12V13H6V7ZM8 9V11H10V9H8ZM14 9H18V7H14V9ZM18 13H14V11H18V13ZM6 15V17L18 17V15L6 15Z"
  }));
},
    ey = function ey(_ref2585) {
  var _ref2585$color = _ref2585.color,
      C = _ref2585$color === void 0 ? "currentColor" : _ref2585$color,
      _ref2585$size = _ref2585.size,
      e = _ref2585$size === void 0 ? 24 : _ref2585$size,
      l = _ref2585.className,
      i = _objectWithoutProperties(_ref2585, _excluded2585);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17 2H13V1H11V2H7C5.34315 2 4 3.34315 4 5V8C4 10.7614 6.23858 13 9 13H15C17.7614 13 20 10.7614 20 8V5C20 3.34315 18.6569 2 17 2ZM11 7.5C11 8.32843 10.3284 9 9.5 9C8.67157 9 8 8.32843 8 7.5C8 6.67157 8.67157 6 9.5 6C10.3284 6 11 6.67157 11 7.5ZM16 7.5C16 8.32843 15.3284 9 14.5 9C13.6716 9 13 8.32843 13 7.5C13 6.67157 13.6716 6 14.5 6C15.3284 6 16 6.67157 16 7.5ZM4 22C4 17.5817 7.58172 14 12 14C16.4183 14 20 17.5817 20 22H4Z"
  }));
},
    ty = function ty(_ref2586) {
  var _ref2586$color = _ref2586.color,
      C = _ref2586$color === void 0 ? "currentColor" : _ref2586$color,
      _ref2586$size = _ref2586.size,
      e = _ref2586$size === void 0 ? 24 : _ref2586$size,
      l = _ref2586.className,
      i = _objectWithoutProperties(_ref2586, _excluded2586);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11 1V2H7C5.34315 2 4 3.34315 4 5V8C4 10.7614 6.23858 13 9 13H15C17.7614 13 20 10.7614 20 8V5C20 3.34315 18.6569 2 17 2H13V1H11ZM6 5C6 4.44772 6.44772 4 7 4H17C17.5523 4 18 4.44772 18 5V8C18 9.65685 16.6569 11 15 11H9C7.34315 11 6 9.65685 6 8V5ZM9.5 9C10.3284 9 11 8.32843 11 7.5C11 6.67157 10.3284 6 9.5 6C8.67157 6 8 6.67157 8 7.5C8 8.32843 8.67157 9 9.5 9ZM14.5 9C15.3284 9 16 8.32843 16 7.5C16 6.67157 15.3284 6 14.5 6C13.6716 6 13 6.67157 13 7.5C13 8.32843 13.6716 9 14.5 9ZM6 22C6 18.6863 8.68629 16 12 16C15.3137 16 18 18.6863 18 22H20C20 17.5817 16.4183 14 12 14C7.58172 14 4 17.5817 4 22H6Z"
  }));
},
    Cy = function Cy(_ref2587) {
  var _ref2587$color = _ref2587.color,
      C = _ref2587$color === void 0 ? "currentColor" : _ref2587$color,
      _ref2587$size = _ref2587.size,
      e = _ref2587$size === void 0 ? 24 : _ref2587$size,
      l = _ref2587.className,
      i = _objectWithoutProperties(_ref2587, _excluded2587);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18.4144 9.00015L12.0002 2.58594L5.58594 9.00015H11V16H13V9.00015H18.4144ZM3 14V18C3 19.6569 4.34315 21 6 21H18C19.6569 21 21 19.6569 21 18V14H19V18C19 18.5523 18.5523 19 18 19H6C5.44772 19 5 18.5523 5 18V14H3Z"
  }));
},
    ly = function ly(_ref2588) {
  var _ref2588$color = _ref2588.color,
      C = _ref2588$color === void 0 ? "currentColor" : _ref2588$color,
      _ref2588$size = _ref2588.size,
      e = _ref2588$size === void 0 ? 24 : _ref2588$size,
      l = _ref2588.className,
      i = _objectWithoutProperties(_ref2588, _excluded2588);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2.58582L18.2071 8.79292L16.7929 10.2071L13 6.41424V16H11V6.41424L7.20711 10.2071L5.79289 8.79292L12 2.58582ZM3 18V14H5V18C5 18.5523 5.44772 19 6 19H18C18.5523 19 19 18.5523 19 18V14H21V18C21 19.6569 19.6569 21 18 21H6C4.34315 21 3 19.6569 3 18Z"
  }));
},
    iy = function iy(_ref2589) {
  var _ref2589$color = _ref2589.color,
      C = _ref2589$color === void 0 ? "currentColor" : _ref2589$color,
      _ref2589$size = _ref2589.size,
      e = _ref2589$size === void 0 ? 24 : _ref2589$size,
      l = _ref2589.className,
      i = _objectWithoutProperties(_ref2589, _excluded2589);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15 3H9C6.02024 3 3.54782 5.17213 3.07974 8.01937C3.21811 8.00655 3.35829 8 3.5 8C5.98528 8 8 10.0147 8 12.5V14H16V12.5C16 10.0147 18.0147 8 20.5 8C20.6417 8 20.7819 8.00655 20.9203 8.01937C20.4522 5.17213 17.9798 3 15 3ZM21 10.05C20.8384 10.0172 20.6712 10 20.5 10C19.1193 10 18 11.1193 18 12.5V17H16V16H8V17H6V12.5C6 11.1193 4.88071 10 3.5 10C3.32877 10 3.16156 10.0172 3 10.05C1.85888 10.2816 1 11.2905 1 12.5C1 13.0886 1.18173 13.5388 1.39024 14.0554C1.67083 14.7505 1.9999 15.5658 1.99978 17V20C1.99978 20.5523 2.44749 21 2.99978 21H12H21.0002C21.5525 21 22.0002 20.5523 22.0002 20V17C22.0001 15.5658 22.3292 14.7505 22.6098 14.0554C22.8183 13.5388 23 13.0886 23 12.5C23 11.2905 22.1411 10.2816 21 10.05Z"
  }));
},
    sy = function sy(_ref2590) {
  var _ref2590$color = _ref2590.color,
      C = _ref2590$color === void 0 ? "currentColor" : _ref2590$color,
      _ref2590$size = _ref2590.size,
      e = _ref2590$size === void 0 ? 24 : _ref2590$size,
      l = _ref2590.className,
      i = _objectWithoutProperties(_ref2590, _excluded2590);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9.00065 3C5.68694 3 3.00065 5.68629 3.00065 9V9.35115C1.47959 10.0975 0.633328 11.916 1.2667 13.6578L1.5792 14.5172C1.85802 15.2839 2.00065 16.0935 2.00065 16.9094V19.5C2.00065 20.3284 2.67222 21 3.50065 21H20.5006C21.3291 21 22.0006 20.3284 22.0006 19.5V16.9094C22.0006 16.0935 22.1433 15.2839 22.4221 14.5172L22.7346 13.6578C23.368 11.916 22.5217 10.0975 21.0006 9.35115V9C21.0006 5.68629 18.3144 3 15.0006 3H9.00065ZM19.0006 9.03175C17.3064 9.2618 16.0006 10.7141 16.0006 12.4715L16.0006 14H8.00065V12.4715C8.00065 10.7141 6.69488 9.2618 5.00065 9.03175V9C5.00065 6.79086 6.79151 5 9.00065 5H15.0006C17.2098 5 19.0006 6.79086 19.0006 9V9.03175ZM16.0006 16L16.0006 17H18.0006V12.4715C18.0006 11.6588 18.6595 11 19.4721 11C20.4933 11 21.204 12.0147 20.855 12.9743L20.5425 13.8337C20.184 14.8195 20.0006 15.8604 20.0006 16.9094V19H4.00065V16.9094C4.00065 15.8604 3.81727 14.8195 3.45879 13.8337L3.14629 12.9743C2.79732 12.0147 3.50802 11 4.52917 11C5.34185 11 6.00065 11.6588 6.00065 12.4715V17H8.00065V16H16.0006Z"
  }));
},
    ry = function ry(_ref2591) {
  var _ref2591$color = _ref2591.color,
      C = _ref2591$color === void 0 ? "currentColor" : _ref2591$color,
      _ref2591$size = _ref2591.size,
      e = _ref2591$size === void 0 ? 24 : _ref2591$size,
      l = _ref2591.className,
      i = _objectWithoutProperties(_ref2591, _excluded2591);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10.99 1.97431C13.9093 0.114363 17.947 0.981629 19.9913 3.90757C20.4765 4.58662 20.8221 5.35574 21.006 6.16979C21.1898 6.98383 21.2092 7.82641 21.063 8.64806C20.9214 9.43262 20.6222 10.1804 20.1836 10.8461C20.8234 12.0671 21.0379 13.4666 20.793 14.8231C20.6485 15.6286 20.3376 16.395 19.8801 17.0734C19.4225 17.7518 18.8284 18.3273 18.1357 18.763L13.0086 22.0307C10.0897 23.8913 6.05178 23.0238 4.00745 20.0975C3.52241 19.4184 3.17783 18.6493 2.99394 17.8352C2.81004 17.0212 2.79053 16.1787 2.93654 15.357C3.07828 14.5723 3.37766 13.8245 3.81658 13.1587C3.17613 11.938 2.96114 10.5386 3.20565 9.18194C3.35026 8.37642 3.6614 7.60994 4.11916 6.93153C4.57692 6.25311 5.17122 5.6777 5.86406 5.24209L10.99 1.97431ZM8.04892 20.2498C8.8306 20.5396 9.68237 20.5825 10.4892 20.3727C10.8578 20.2742 11.2092 20.1198 11.531 19.9149L16.6586 16.6483C17.0751 16.3862 17.4323 16.0401 17.7075 15.6321C17.9827 15.2241 18.1697 14.7632 18.2567 14.2789C18.3445 13.7848 18.3327 13.2782 18.2221 12.7888C18.1115 12.2993 17.9043 11.8369 17.6125 11.4286C17.1374 10.7436 16.4635 10.221 15.6818 9.93121C14.9002 9.64145 14.0484 9.59854 13.2416 9.80828C12.873 9.90665 12.5216 10.061 12.1998 10.2659L10.2435 11.5125C10.1463 11.5741 10.0402 11.6205 9.929 11.6501C9.68583 11.7132 9.42916 11.7001 9.19365 11.6127C8.95813 11.5253 8.75511 11.3677 8.61198 11.1613C8.52418 11.0381 8.46182 10.8986 8.42855 10.7511C8.39527 10.6035 8.39174 10.4508 8.41816 10.3019C8.44437 10.156 8.50072 10.0172 8.58361 9.89433C8.6665 9.77146 8.77411 9.66724 8.89956 9.58832L14.0279 6.31995C14.1251 6.25833 14.2312 6.21193 14.3424 6.18235C14.5855 6.11913 14.8422 6.13208 15.0777 6.21944C15.3133 6.3068 15.5163 6.46436 15.6594 6.67083C15.816 6.89261 15.8893 7.1626 15.8662 7.43313L15.8485 7.62341L16.0392 7.6812C16.7597 7.89874 17.4378 8.23778 18.0442 8.6837L18.3068 8.87615L18.4033 8.58129C18.455 8.42472 18.496 8.2648 18.526 8.10264C18.6137 7.60859 18.602 7.10199 18.4913 6.61255C18.3807 6.12311 18.1735 5.66068 17.8818 5.25238C17.4066 4.56741 16.7327 4.04476 15.951 3.755C15.1693 3.46524 14.3175 3.42232 13.5107 3.63205C13.1421 3.73063 12.7908 3.88502 12.4689 4.08987L7.34135 7.35745C6.92461 7.61925 6.56709 7.96514 6.29167 8.37301C6.01625 8.78088 5.82899 9.24174 5.74186 9.72612C5.65406 10.2202 5.66581 10.7268 5.77643 11.2162C5.88704 11.7057 6.09429 12.1681 6.38602 12.5764C6.8612 13.2614 7.53514 13.784 8.31683 14.0738C9.09852 14.3636 9.9503 14.4065 10.7571 14.1967C11.1257 14.0982 11.477 13.944 11.799 13.7395L13.7554 12.4922C13.8527 12.4306 13.9587 12.3842 14.0699 12.3546C14.3131 12.2916 14.5698 12.3046 14.8053 12.392C15.0408 12.4795 15.2439 12.637 15.387 12.8435C15.4748 12.9667 15.5371 13.1061 15.5705 13.2536C15.6038 13.4011 15.6075 13.5538 15.5812 13.7027C15.5548 13.8486 15.4984 13.9875 15.4154 14.1103C15.3325 14.2332 15.2249 14.3375 15.0994 14.4165L9.97244 17.6846C9.87522 17.7463 9.76916 17.7927 9.65793 17.8222C9.4148 17.8855 9.15811 17.8726 8.92257 17.7852C8.68703 17.6978 8.48399 17.5403 8.34091 17.3338C8.18411 17.1123 8.11078 16.8424 8.13392 16.5721L8.15142 16.3818L7.96094 16.324C7.24041 16.1064 6.56232 15.7673 5.95593 15.3215L5.69311 15.1286L5.5966 15.4235C5.54476 15.58 5.50384 15.74 5.47413 15.9021C5.38636 16.3962 5.3981 16.9028 5.50868 17.3922C5.61926 17.8817 5.82645 18.3441 6.1181 18.7524C6.59329 19.4374 7.26723 19.96 8.04892 20.2498Z"
  }));
},
    cy = function cy(_ref2592) {
  var _ref2592$color = _ref2592.color,
      C = _ref2592$color === void 0 ? "currentColor" : _ref2592$color,
      _ref2592$size = _ref2592.size,
      e = _ref2592$size === void 0 ? 24 : _ref2592$size,
      l = _ref2592.className,
      i = _objectWithoutProperties(_ref2592, _excluded2592);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19.8001 3.77035C17.9455 0.859147 14.082 0.00263458 11.1708 1.85727L6.11044 5.08107C3.23141 6.91521 2.36191 10.714 4.13686 13.6135C2.93471 15.5852 2.87555 18.1496 4.20064 20.2296C6.05528 23.1408 9.91876 23.9973 12.83 22.1427L17.8903 18.9189C20.7693 17.0847 21.6388 13.2859 19.8639 10.3865C21.0656 8.41543 21.1254 5.85071 19.8001 3.77035ZM18.448 8.77425C17.6282 8.11539 16.6628 7.68286 15.6505 7.49851C15.6882 7.26497 15.6437 7.01723 15.5066 6.80202C15.2099 6.33623 14.5917 6.19918 14.1259 6.49593L9.06558 9.71973C8.59979 10.0165 8.46275 10.6346 8.75949 11.1004C9.05623 11.5662 9.67439 11.7033 10.1402 11.4065L12.2487 10.0633C14.2283 8.8021 16.8554 9.38453 18.1166 11.3641C19.3778 13.3438 18.7953 15.9709 16.8157 17.2321L11.7554 20.4559C9.77574 21.717 7.14858 21.1346 5.88742 19.155C5.11002 17.9347 5.03292 16.4671 5.55276 15.2257C6.37258 15.8846 7.33791 16.3171 8.35026 16.5014C8.31252 16.735 8.35701 16.9827 8.49412 17.1979C8.79086 17.6637 9.40902 17.8008 9.87481 17.504L14.9352 14.2802C15.401 13.9835 15.538 13.3653 15.2413 12.8995C14.9445 12.4337 14.3264 12.2967 13.8606 12.5934L11.7521 13.9367C9.77247 15.1978 7.1453 14.6154 5.88415 12.6358C4.62299 10.6562 5.20542 8.02901 7.18504 6.76786L12.2454 3.54406C14.225 2.2829 16.8522 2.86533 18.1133 4.84495C18.8906 6.06498 18.9681 7.5324 18.448 8.77425Z"
  }));
},
    oy = function oy(_ref2593) {
  var _ref2593$color = _ref2593.color,
      C = _ref2593$color === void 0 ? "currentColor" : _ref2593$color,
      _ref2593$size = _ref2593.size,
      e = _ref2593$size === void 0 ? 24 : _ref2593$size,
      l = _ref2593.className,
      i = _objectWithoutProperties(_ref2593, _excluded2593);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4.26 4.26C3 5.532 3 7.566 3 11.64V12.36C3 16.428 3 18.462 4.26 19.74C5.532 21 7.566 21 11.64 21H12.36C16.428 21 18.462 21 19.74 19.74C21 18.468 21 16.434 21 12.36V11.64C21 7.572 21 5.538 19.74 4.26C18.468 3 16.434 3 12.36 3H11.64C7.572 3 5.538 3 4.26 4.26ZM6.03613 8.47817H8.10013C8.16613 11.9102 9.67813 13.3622 10.8781 13.6622V8.47817H12.8161V11.4362C13.9981 11.3102 15.2461 9.96017 15.6661 8.47217H17.5981C17.4406 9.24243 17.1259 9.97193 16.6737 10.6151C16.2216 11.2582 15.6416 11.8012 14.9701 12.2102C15.7195 12.5831 16.3813 13.1107 16.9118 13.7582C17.4424 14.4056 17.8297 15.1581 18.0481 15.9662H15.9181C15.4621 14.5442 14.3221 13.4402 12.8161 13.2902V15.9662H12.5821H12.5761C8.47213 15.9662 6.13213 13.1582 6.03613 8.47817Z"
  }));
},
    ay = function ay(_ref2594) {
  var _ref2594$color = _ref2594.color,
      C = _ref2594$color === void 0 ? "currentColor" : _ref2594$color,
      _ref2594$size = _ref2594.size,
      e = _ref2594$size === void 0 ? 24 : _ref2594$size,
      l = _ref2594.className,
      i = _objectWithoutProperties(_ref2594, _excluded2594);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5.82656 5.82798C5.48307 6.17683 5.25614 6.66694 5.13143 7.59868C5.00237 8.56292 5.00027 9.84122 5.00027 11.68V12.32C5.00027 14.1561 5.00237 15.4331 5.13143 16.3974C5.25612 17.329 5.48316 17.8217 5.82824 18.1737C6.17709 18.5172 6.6672 18.7442 7.59893 18.8689C8.56317 18.9979 9.84147 19 11.6803 19H12.3203C14.1563 19 15.4334 18.9979 16.3976 18.8689C17.3292 18.7442 17.8219 18.5171 18.174 18.172C18.5175 17.8232 18.7444 17.3331 18.8691 16.4014C18.9982 15.4371 19.0003 14.1588 19.0003 12.32V11.68C19.0003 9.84394 18.9982 8.56694 18.8691 7.60268C18.7444 6.67106 18.5174 6.17837 18.1723 5.8263C17.8234 5.48281 17.3333 5.25589 16.4016 5.13118C15.4374 5.00213 14.1591 5.00002 12.3203 5.00002H11.6803C9.84419 5.00002 8.56718 5.00213 7.60293 5.13118C6.67132 5.25587 6.17864 5.48291 5.82656 5.82798ZM11.6803 3.00002H12.3203C13.7646 3.00002 15.2317 2.95676 16.6669 3.14886C17.8234 3.30365 18.8025 3.6354 19.584 4.40957L19.5924 4.4179C20.365 5.20154 20.6966 6.1807 20.8514 7.33736C21.0434 8.77133 21.0003 10.237 21.0003 11.68V12.32C21.0003 13.7644 21.0435 15.2314 20.8514 16.6667C20.6966 17.8232 20.3649 18.8022 19.5907 19.5838L19.5824 19.5922C18.7987 20.3648 17.8196 20.6964 16.6629 20.8512C15.229 21.0431 13.7633 21 12.3203 21H11.6803C10.2359 21 8.76887 21.0433 7.33361 20.8512C6.1771 20.6964 5.19807 20.3646 4.41652 19.5905L4.40811 19.5821C3.63551 18.7985 3.30392 17.8193 3.14911 16.6627C2.95718 15.2287 3.00027 13.7631 3.00027 12.32V11.68C3.00027 10.2357 2.957 8.76863 3.14911 7.33336C3.3039 6.17686 3.63564 5.19782 4.40982 4.41628L4.41814 4.40787C5.20179 3.63527 6.18094 3.30367 7.33761 3.14886C8.77157 2.95694 10.2372 3.00002 11.6803 3.00002ZM6.0364 8.47819C6.1324 13.1582 8.4724 15.9662 12.5764 15.9662H12.5824H12.8164V13.2902C14.3224 13.4402 15.4624 14.5442 15.9184 15.9662H18.0484C17.8299 15.1582 17.4426 14.4056 16.9121 13.7582C16.3815 13.1108 15.7198 12.5832 14.9704 12.2102C15.6419 11.8013 16.2218 11.2583 16.674 10.6151C17.1262 9.97195 17.4409 9.24245 17.5984 8.47219H15.6664C15.2464 9.96019 13.9984 11.3102 12.8164 11.4362V8.47819H10.8784V13.6622C9.6784 13.3622 8.1664 11.9102 8.1004 8.47819H6.0364Z"
  }));
},
    ny = function ny(_ref2595) {
  var _ref2595$color = _ref2595.color,
      C = _ref2595$color === void 0 ? "currentColor" : _ref2595$color,
      _ref2595$size = _ref2595.size,
      e = _ref2595$size === void 0 ? 24 : _ref2595$size,
      l = _ref2595.className,
      i = _objectWithoutProperties(_ref2595, _excluded2595);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21.7782 4H18.9411L14.4519 8.37097C13.7983 9.00497 12.9175 9.36038 11.9998 9.36038C11.0822 9.36038 10.2014 9.00497 9.54783 8.37097L5.06209 4H2.22266L8.12927 9.75399C10.269 11.8366 13.7357 11.8366 15.8739 9.75399L21.7782 4ZM2.22266 20H5.05095L9.55942 15.6151C10.2105 14.9842 11.088 14.6305 12.0021 14.6305C12.9163 14.6305 13.7938 14.9842 14.4449 15.6151L18.9518 20H21.7782L15.8581 14.2388C13.7264 12.1663 10.2729 12.1663 8.14279 14.2388L2.22266 20Z"
  }));
},
    my = function my(_ref2596) {
  var _ref2596$color = _ref2596.color,
      C = _ref2596$color === void 0 ? "currentColor" : _ref2596$color,
      _ref2596$size = _ref2596.size,
      e = _ref2596$size === void 0 ? 24 : _ref2596$size,
      l = _ref2596.className,
      i = _objectWithoutProperties(_ref2596, _excluded2596);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21.7782 4H18.9411L14.4519 8.37097C13.7983 9.00497 12.9175 9.36038 11.9998 9.36038C11.0822 9.36038 10.2014 9.00497 9.54783 8.37097L5.06209 4H2.22266L8.12927 9.75399C10.269 11.8366 13.7357 11.8366 15.8739 9.75399L21.7782 4ZM2.22266 20H5.05095L9.55942 15.6151C10.2105 14.9842 11.088 14.6305 12.0021 14.6305C12.9163 14.6305 13.7938 14.9842 14.4449 15.6151L18.9518 20H21.7782L15.8581 14.2388C13.7264 12.1663 10.2729 12.1663 8.14279 14.2388L2.22266 20Z"
  }));
},
    wy = function wy(_ref2597) {
  var _ref2597$color = _ref2597.color,
      C = _ref2597$color === void 0 ? "currentColor" : _ref2597$color,
      _ref2597$size = _ref2597.size,
      e = _ref2597$size === void 0 ? 24 : _ref2597$size,
      l = _ref2597.className,
      i = _objectWithoutProperties(_ref2597, _excluded2597);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19.6311 17.4936C19.4095 13.6363 14.4811 11.8841 14.0101 11.703C13.9897 11.6938 13.9897 11.6755 13.9999 11.6558L19.0823 6.6343V6.09356C19.0823 6.00825 19.006 5.93213 18.9194 5.93213H9.5527V2L6.09606 2.71135V3.22321H6.28831C6.28831 3.22321 7.13623 3.22321 7.13623 4.05663V5.92294H4.46004C4.41166 5.92294 4.36328 5.97019 4.36328 6.01744V7.20259H7.14515V13.6363C7.14515 15.6548 8.46415 17.0579 10.7737 16.8675C11.2471 16.8224 11.703 16.6603 12.1029 16.3951C12.1875 16.3432 12.2578 16.2696 12.3068 16.1816C12.3559 16.0935 12.3821 15.9939 12.3829 15.8924V15.2558C11.6318 15.7493 10.9952 15.7205 10.9952 15.7205C9.53233 15.7205 9.56161 13.8909 9.56161 13.8909V7.20128H16.3005L11.4497 12.0154L11.4293 13.152C11.4293 13.1717 11.4395 13.1808 11.4586 13.1808C15.9058 13.9198 17.1089 16.7534 17.1089 17.5776C17.1089 17.5776 17.5902 21.5858 13.5186 21.8615C13.5186 21.8615 10.8513 21.9743 10.3803 20.923C10.3612 20.8837 10.3803 20.8469 10.4185 20.8286C10.8615 20.6291 11.1594 20.2406 11.1594 19.7195C11.1594 18.9425 10.6782 18.3073 9.66729 18.3073C8.84991 18.3073 8.17514 18.9425 8.17514 19.7195C8.17514 19.7195 7.79064 23.0925 13.5097 22.9981C20.0359 22.8839 19.6311 17.4936 19.6311 17.4936Z"
  }));
},
    Ly = function Ly(_ref2598) {
  var _ref2598$color = _ref2598.color,
      C = _ref2598$color === void 0 ? "currentColor" : _ref2598$color,
      _ref2598$size = _ref2598.size,
      e = _ref2598$size === void 0 ? 24 : _ref2598$size,
      l = _ref2598.className,
      i = _objectWithoutProperties(_ref2598, _excluded2598);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9 6V2H7V6H4.5V8H7V13C7 15.2091 8.79086 17 11 17C12.0238 17 12.9599 16.614 13.6669 15.9812L12.3331 14.491C11.9786 14.8083 11.5129 15 11 15C9.89543 15 9 14.1046 9 13V8H15.6249L11.5 11.9749L11.5 13.5H12.5C15.5671 13.5 17.5 15.6792 17.5 17.5C17.5 19.3827 15.8727 21 13.75 21C11.9274 21 10.4568 19.7978 10.0902 18.2671L8.14521 18.7329C8.73856 21.2102 11.0514 23 13.75 23C16.874 23 19.5 20.5878 19.5 17.5C19.5 14.9348 17.4658 12.5683 14.5864 11.7783L19 7.5251V6H9Z"
  }));
},
    hy = function hy(_ref2599) {
  var _ref2599$color = _ref2599.color,
      C = _ref2599$color === void 0 ? "currentColor" : _ref2599$color,
      _ref2599$size = _ref2599.size,
      e = _ref2599$size === void 0 ? 24 : _ref2599$size,
      l = _ref2599.className,
      i = _objectWithoutProperties(_ref2599, _excluded2599);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 5H20V3H4V5ZM20 9H4V7H20V9ZM9 13H15V11H21V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V11H9V13Z"
  }));
},
    Hy = function Hy(_ref2600) {
  var _ref2600$color = _ref2600.color,
      C = _ref2600$color === void 0 ? "currentColor" : _ref2600$color,
      _ref2600$size = _ref2600.size,
      e = _ref2600$size === void 0 ? 24 : _ref2600$size,
      l = _ref2600.className,
      i = _objectWithoutProperties(_ref2600, _excluded2600);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 5H20V3H4V5ZM20 9H4V7H20V9ZM3 11H10V13H14V11H21V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V11ZM16 13V15H8V13H5V19H19V13H16Z"
  }));
},
    Vy = function Vy(_ref2601) {
  var _ref2601$color = _ref2601.color,
      C = _ref2601$color === void 0 ? "currentColor" : _ref2601$color,
      _ref2601$size = _ref2601.size,
      e = _ref2601$size === void 0 ? 24 : _ref2601$size,
      l = _ref2601.className,
      i = _objectWithoutProperties(_ref2601, _excluded2601);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8 1.5C8 0.947715 7.55228 0.5 7 0.5C6.44772 0.5 6 0.947715 6 1.5V2.5C6 2.50686 6.00042 2.51285 6.00081 2.51843C6.00385 2.56193 6.00516 2.58063 5.79289 2.79289L5.77277 2.81298C5.50599 3.07912 5 3.58391 5 4.5V5.5C5 6.05228 5.44772 6.5 6 6.5C6.55228 6.5 7 6.05228 7 5.5V4.5C7 4.49314 6.99958 4.48715 6.99919 4.48157C6.99615 4.43807 6.99484 4.41937 7.20711 4.20711L7.22723 4.18702C7.49401 3.92088 8 3.41609 8 2.5V1.5ZM2 9C2 8.44771 2.44772 8 3 8H21C21.5523 8 22 8.44772 22 9V10C22 14.1006 19.5318 17.6248 16 19.1679V20C16 20.5523 15.5523 21 15 21H9C8.44772 21 8 20.5523 8 20V19.1679C4.46819 17.6248 2 14.1006 2 10V9ZM18 0.5C18.5523 0.5 19 0.947715 19 1.5V2.5C19 3.41609 18.494 3.92088 18.2272 4.18702L18.2071 4.20711C17.9948 4.41937 17.9962 4.43807 17.9992 4.48157C17.9996 4.48715 18 4.49314 18 4.5V5.5C18 6.05228 17.5523 6.5 17 6.5C16.4477 6.5 16 6.05228 16 5.5V4.5C16 3.58391 16.506 3.07912 16.7728 2.81298L16.7929 2.79289C17.0052 2.58063 17.0038 2.56193 17.0008 2.51843C17.0004 2.51285 17 2.50686 17 2.5V1.5C17 0.947715 17.4477 0.5 18 0.5ZM13.5 1.5C13.5 0.947715 13.0523 0.5 12.5 0.5C11.9477 0.5 11.5 0.947715 11.5 1.5V2.5C11.5 2.50686 11.5004 2.51285 11.5008 2.51843C11.5038 2.56193 11.5052 2.58063 11.2929 2.79289L11.2728 2.81298C11.006 3.07912 10.5 3.58391 10.5 4.5V5.5C10.5 6.05228 10.9477 6.5 11.5 6.5C12.0523 6.5 12.5 6.05228 12.5 5.5V4.5C12.5 4.49314 12.4996 4.48715 12.4992 4.48157C12.4962 4.43807 12.4948 4.41937 12.7071 4.20711L12.7272 4.18702C12.994 3.92088 13.5 3.41609 13.5 2.5V1.5Z"
  }));
},
    gy = function gy(_ref2602) {
  var _ref2602$color = _ref2602.color,
      C = _ref2602$color === void 0 ? "currentColor" : _ref2602$color,
      _ref2602$size = _ref2602.size,
      e = _ref2602$size === void 0 ? 24 : _ref2602$size,
      l = _ref2602.className,
      i = _objectWithoutProperties(_ref2602, _excluded2602);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8 1.5C8 0.947715 7.55228 0.5 7 0.5C6.44772 0.5 6 0.947715 6 1.5V2.5C6 2.50686 6.00042 2.51285 6.00081 2.51843C6.00385 2.56193 6.00516 2.58063 5.79289 2.79289L5.77277 2.81298C5.50599 3.07912 5 3.58391 5 4.5V5.5C5 6.05228 5.44772 6.5 6 6.5C6.55228 6.5 7 6.05228 7 5.5V4.5C7 4.49314 6.99958 4.48715 6.99919 4.48157C6.99615 4.43807 6.99484 4.41937 7.20711 4.20711L7.22723 4.18702C7.49401 3.92088 8 3.41609 8 2.5V1.5ZM19 1.5C19 0.947715 18.5523 0.5 18 0.5C17.4477 0.5 17 0.947715 17 1.5V2.5C17 2.50686 17.0004 2.51285 17.0008 2.51843C17.0038 2.56193 17.0052 2.58063 16.7929 2.79289L16.7728 2.81298C16.506 3.07912 16 3.58391 16 4.5V5.5C16 6.05228 16.4477 6.5 17 6.5C17.5523 6.5 18 6.05228 18 5.5V4.5C18 4.49314 17.9996 4.48715 17.9992 4.48157C17.9962 4.43807 17.9948 4.41937 18.2071 4.20711L18.2272 4.18702C18.494 3.92088 19 3.41609 19 2.5V1.5ZM12.5 0.5C13.0523 0.5 13.5 0.947715 13.5 1.5V2.5C13.5 3.41609 12.994 3.92088 12.7272 4.18702L12.7071 4.20711C12.4948 4.41937 12.4962 4.43807 12.4992 4.48157C12.4996 4.48715 12.5 4.49314 12.5 4.5V5.5C12.5 6.05228 12.0523 6.5 11.5 6.5C10.9477 6.5 10.5 6.05228 10.5 5.5V4.5C10.5 3.58391 11.006 3.07912 11.2728 2.81298L11.2929 2.79289C11.5052 2.58063 11.5038 2.56193 11.5008 2.51843C11.5004 2.51285 11.5 2.50686 11.5 2.5V1.5C11.5 0.947715 11.9477 0.5 12.5 0.5ZM4 10H20C20 14.4183 16.4183 18 12 18C7.58172 18 4 14.4183 4 10ZM3 8C2.44772 8 2 8.44771 2 9V10C2 14.1006 4.46819 17.6248 8 19.1679V20C8 20.5523 8.44772 21 9 21H15C15.5523 21 16 20.5523 16 20V19.1679C19.5318 17.6248 22 14.1006 22 10V9C22 8.44772 21.5523 8 21 8H3Z"
  }));
},
    My = function My(_ref2603) {
  var _ref2603$color = _ref2603.color,
      C = _ref2603$color === void 0 ? "currentColor" : _ref2603$color,
      _ref2603$size = _ref2603.size,
      e = _ref2603$size === void 0 ? 24 : _ref2603$size,
      l = _ref2603.className,
      i = _objectWithoutProperties(_ref2603, _excluded2603);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4ZM4 19H20V9H4V19ZM11 13H6V17H11V13Z"
  }));
},
    Zy = function Zy(_ref2604) {
  var _ref2604$color = _ref2604.color,
      C = _ref2604$color === void 0 ? "currentColor" : _ref2604$color,
      _ref2604$size = _ref2604.size,
      e = _ref2604$size === void 0 ? 24 : _ref2604$size,
      l = _ref2604.className,
      i = _objectWithoutProperties(_ref2604, _excluded2604);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 3H1V5H3V19H1V21H4C4.55228 21 5 20.5523 5 20V4C5 3.44772 4.55228 3 4 3ZM7 4C7 3.44772 7.44772 3 8 3H16C16.5523 3 17 3.44772 17 4V20C17 20.5523 16.5523 21 16 21H8C7.44772 21 7 20.5523 7 20V4ZM9 5V19H15V5H9ZM19 4C19 3.44772 19.4477 3 20 3H23V5H21V19H23V21H20C19.4477 21 19 20.5523 19 20V4Z"
  }));
},
    xy = function xy(_ref2605) {
  var _ref2605$color = _ref2605.color,
      C = _ref2605$color === void 0 ? "currentColor" : _ref2605$color,
      _ref2605$size = _ref2605.size,
      e = _ref2605$size === void 0 ? 24 : _ref2605$size,
      l = _ref2605.className,
      i = _objectWithoutProperties(_ref2605, _excluded2605);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3.41436 5.99995L5.70726 3.70706L4.29304 2.29285L0.585938 5.99995L4.29304 9.70706L5.70726 8.29285L3.41436 5.99995ZM9.58594 5.99995L7.29304 3.70706L8.70726 2.29285L12.4144 5.99995L8.70726 9.70706L7.29304 8.29285L9.58594 5.99995ZM14.0002 2.99995H21.0002C21.5524 2.99995 22.0002 3.44767 22.0002 3.99995V20C22.0002 20.5522 21.5524 21 21.0002 21H3.00015C2.44787 21 2.00015 20.5522 2.00015 20V12H4.00015V19H20.0002V4.99995H14.0002V2.99995Z"
  }));
},
    vy = function vy(_ref2606) {
  var _ref2606$color = _ref2606.color,
      C = _ref2606$color === void 0 ? "currentColor" : _ref2606$color,
      _ref2606$size = _ref2606.size,
      e = _ref2606$size === void 0 ? 24 : _ref2606$size,
      l = _ref2606.className,
      i = _objectWithoutProperties(_ref2606, _excluded2606);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16.5717 8.02749C16.8469 7.4078 16.9998 6.72176 16.9998 6C16.9998 3.23858 14.7612 1 11.9998 1C9.23839 1 6.99981 3.23858 6.99981 6C6.99981 8.58261 8.95785 10.7079 11.4704 10.9723C12.6858 9.24029 14.576 8.20785 16.5717 8.02749ZM13.1542 17.9462C13.996 16.1276 14.047 13.9741 13.1547 12.0554C14.6399 10.0118 17.4591 9.37883 19.6956 10.6701L19.6957 10.67C22.0871 12.0508 22.9064 15.1086 21.5257 17.5C20.145 19.8915 17.087 20.7109 14.6956 19.3302C14.0707 18.9694 13.5532 18.4942 13.1542 17.9462ZM6.27311 10.0269C7.42726 11.6652 9.26672 12.786 11.3746 12.9726C12.4016 15.2807 11.5401 18.0388 9.30357 19.3301C6.91211 20.7108 3.85415 19.8914 2.47344 17.5C1.09273 15.1085 1.91211 12.0505 4.30357 10.6698C4.92851 10.309 5.59897 10.0984 6.27311 10.0269Z"
  }));
},
    dy = function dy(_ref2607) {
  var _ref2607$color = _ref2607.color,
      C = _ref2607$color === void 0 ? "currentColor" : _ref2607$color,
      _ref2607$size = _ref2607.size,
      e = _ref2607$size === void 0 ? 24 : _ref2607$size,
      l = _ref2607.className,
      i = _objectWithoutProperties(_ref2607, _excluded2607);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2.99988C14.2091 2.99988 16 4.79074 16 6.99988C16 7.54431 15.8917 8.06177 15.6958 8.53327C14.0548 8.70904 12.5038 9.5584 11.4804 10.9666C10.2212 10.8033 9.14476 10.0545 8.53417 8.99859C8.19462 8.41137 7.99998 7.72986 7.99998 6.99988C7.99998 4.79074 9.79084 2.99988 12 2.99988ZM17.7635 8.67236C17.9175 8.14099 18 7.57964 18 6.99988C18 3.68617 15.3137 0.999879 12 0.999878C8.68627 0.999877 5.99998 3.68617 5.99998 6.99988C5.99998 7.57966 6.08247 8.14104 6.23647 8.67242C5.69935 8.80476 5.172 9.01399 4.66995 9.30385C1.80019 10.9607 0.81694 14.6302 2.47379 17.5C4.13065 20.3698 7.80019 21.353 10.6699 19.6962C11.172 19.4063 11.6169 19.0542 12 18.6552C12.3832 19.0542 12.828 19.4062 13.33 19.6961C16.1998 21.3529 19.8693 20.3697 21.5262 17.4999C23.183 14.6302 22.1998 10.9606 19.33 9.30377C18.828 9.01392 18.3006 8.80469 17.7635 8.67236ZM13.1543 16.9342C13.8227 15.4251 13.8627 13.6571 13.1549 12.0667C13.9259 11.0577 15.1125 10.4999 16.3322 10.4991C17.0104 10.4987 17.6979 10.6709 18.33 11.0358C20.2432 12.1404 20.8987 14.5868 19.7941 16.4999C18.6895 18.4131 16.2432 19.0686 14.33 17.964C13.8586 17.6919 13.4647 17.3395 13.1543 16.9342ZM11.3649 12.9668C11.8532 14.139 11.7429 15.4456 11.1337 16.5023C10.7949 17.0899 10.3021 17.5991 9.66995 17.9641C7.75678 19.0687 5.31042 18.4132 4.20585 16.5C3.10128 14.5868 3.75678 12.1405 5.66995 11.0359C6.14142 10.7637 6.64366 10.5987 7.1499 10.5326C8.12267 11.8659 9.63373 12.7845 11.3649 12.9668Z"
  }));
},
    py = function py(_ref2608) {
  var _ref2608$color = _ref2608.color,
      C = _ref2608$color === void 0 ? "currentColor" : _ref2608$color,
      _ref2608$size = _ref2608.size,
      e = _ref2608$size === void 0 ? 24 : _ref2608$size,
      l = _ref2608.className,
      i = _objectWithoutProperties(_ref2608, _excluded2608);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 2C3.44772 2 3 2.44772 3 3V5H5V7H2V9H5V11H2V13H5V15H2V17H5V19H3V21C3 21.5523 3.44772 22 4 22H20C20.5523 22 21 21.5523 21 21V3C21 2.44772 20.5523 2 20 2H4ZM9 16C9 14.3431 10.3431 13 12 13C13.6569 13 15 14.3431 15 16H9ZM12 12C10.8954 12 10 11.1046 10 10C10 8.89543 10.8954 8 12 8C13.1046 8 14 8.89543 14 10C14 11.1046 13.1046 12 12 12Z"
  }));
},
    Ey = function Ey(_ref2609) {
  var _ref2609$color = _ref2609.color,
      C = _ref2609$color === void 0 ? "currentColor" : _ref2609$color,
      _ref2609$size = _ref2609.size,
      e = _ref2609$size === void 0 ? 24 : _ref2609$size,
      l = _ref2609.className,
      i = _objectWithoutProperties(_ref2609, _excluded2609);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 2C3.44772 2 3 2.44772 3 3V5H5V4H19V20H5V19H3V21C3 21.5523 3.44772 22 4 22H20C20.5523 22 21 21.5523 21 21V3C21 2.44772 20.5523 2 20 2H4ZM9 16C9 14.3431 10.3431 13 12 13C13.6569 13 15 14.3431 15 16H9ZM12 12C10.8954 12 10 11.1046 10 10C10 8.89543 10.8954 8 12 8C13.1046 8 14 8.89543 14 10C14 11.1046 13.1046 12 12 12ZM6 9V7H2V9H6ZM6 11V13H2V11H6ZM6 17V15H2V17H6Z"
  }));
},
    Ny = function Ny(_ref2610) {
  var _ref2610$color = _ref2610.color,
      C = _ref2610$color === void 0 ? "currentColor" : _ref2610$color,
      _ref2610$size = _ref2610.size,
      e = _ref2610$size === void 0 ? 24 : _ref2610$size,
      l = _ref2610.className,
      i = _objectWithoutProperties(_ref2610, _excluded2610);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16 2H4C3.44772 2 3 2.44772 3 3V21C3 21.5523 3.44772 22 4 22H12.2547C11.4638 20.8662 11 19.4872 11 18C11 14.134 14.134 11 18 11C19.0736 11 20.0907 11.2417 21 11.6736V7L16 2ZM13.7857 15.3269C13.8246 14.5997 14.3858 14.0083 15.11 13.9313L15.9807 13.8389C16.0841 13.8279 16.1815 13.7845 16.2589 13.715L16.9102 13.1299C17.4519 12.6431 18.2669 12.6218 18.8334 13.0795L19.5145 13.6298C19.5954 13.6951 19.6949 13.7333 19.7988 13.7389L20.6731 13.7857C21.4003 13.8246 21.9917 14.3858 22.0687 15.11L22.1611 15.9807C22.1721 16.0841 22.2155 16.1815 22.285 16.2589L22.8701 16.9102C23.3569 17.4519 23.3782 18.2669 22.9205 18.8334L22.3702 19.5145C22.3049 19.5954 22.2667 19.6949 22.2611 19.7988L22.2143 20.6731C22.1754 21.4003 21.6142 21.9917 20.89 22.0687L20.0193 22.1611C19.9159 22.1721 19.8185 22.2155 19.7411 22.285L19.0898 22.8701C18.5481 23.3569 17.7331 23.3782 17.1666 22.9205L16.4855 22.3702C16.4046 22.3049 16.3051 22.2667 16.2012 22.2611L15.3269 22.2143C14.5997 22.1754 14.0083 21.6142 13.9313 20.89L13.8389 20.0193C13.8279 19.9159 13.7845 19.8185 13.715 19.7411L13.1299 19.0898C12.6431 18.5481 12.6218 17.733 13.0795 17.1666L13.6298 16.4855C13.6951 16.4046 13.7333 16.3051 13.7389 16.2012L13.7857 15.3269ZM21.0303 17.0303L19.9697 15.9697L17.5 18.4393L16.0303 16.9697L14.9697 18.0303L16.9697 20.0303L17.5 20.5607L18.0303 20.0303L21.0303 17.0303Z"
  }));
},
    uy = function uy(_ref2611) {
  var _ref2611$color = _ref2611.color,
      C = _ref2611$color === void 0 ? "currentColor" : _ref2611$color,
      _ref2611$size = _ref2611.size,
      e = _ref2611$size === void 0 ? 24 : _ref2611$size,
      l = _ref2611.className,
      i = _objectWithoutProperties(_ref2611, _excluded2611);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 8V12H19V9H14V4H5V20H11V22H3.9934C3.44495 22 3 21.556 3 21.0082V2.9918C3 2.45531 3.4487 2 4.00221 2H14.9968L21 8ZM13.7857 15.3269C13.8246 14.5997 14.3858 14.0083 15.11 13.9313L15.9807 13.8389C16.0841 13.8279 16.1815 13.7845 16.2589 13.715L16.9102 13.1299C17.4519 12.6431 18.2669 12.6218 18.8334 13.0795L19.5145 13.6298C19.5954 13.6951 19.6949 13.7333 19.7988 13.7389L20.6731 13.7857C21.4003 13.8246 21.9917 14.3858 22.0687 15.11L22.1611 15.9807C22.1721 16.0841 22.2155 16.1815 22.285 16.2589L22.8701 16.9102C23.3569 17.4519 23.3782 18.2669 22.9205 18.8334L22.3702 19.5145C22.3049 19.5954 22.2667 19.6949 22.2611 19.7988L22.2143 20.6731C22.1754 21.4003 21.6142 21.9917 20.89 22.0687L20.0193 22.1611C19.9159 22.1721 19.8185 22.2155 19.7411 22.285L19.0898 22.8701C18.5481 23.3569 17.7331 23.3782 17.1666 22.9205L16.4855 22.3702C16.4046 22.3049 16.3051 22.2667 16.2012 22.2611L15.3269 22.2143C14.5997 22.1754 14.0083 21.6142 13.9313 20.89L13.8389 20.0193C13.8279 19.9159 13.7845 19.8185 13.715 19.7411L13.1299 19.0898C12.6431 18.5481 12.6218 17.733 13.0795 17.1666L13.6298 16.4855C13.6951 16.4046 13.7333 16.3051 13.7389 16.2012L13.7857 15.3269ZM21.0303 17.0303L19.9697 15.9697L17.5 18.4393L16.0303 16.9697L14.9697 18.0303L17.5 20.5607L21.0303 17.0303Z"
  }));
},
    By = function By(_ref2612) {
  var _ref2612$color = _ref2612.color,
      C = _ref2612$color === void 0 ? "currentColor" : _ref2612$color,
      _ref2612$size = _ref2612.size,
      e = _ref2612$size === void 0 ? 24 : _ref2612$size,
      l = _ref2612.className,
      i = _objectWithoutProperties(_ref2612, _excluded2612);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7.32297 2H4V0H8.67703L10.677 5H21V7H18.8824L18.0554 21.0587C18.0243 21.5873 17.5866 22 17.0571 22H6.9429C6.41343 22 5.97572 21.5873 5.94463 21.0587L5.11765 7H3V5H8.52297L7.32297 2ZM7.1211 7L7.29906 10.0252C9.97062 10.1354 11.2679 10.6301 12.36 11.067C13.4113 11.4875 14.28 11.8532 16.5867 11.9676L16.8789 7H7.1211Z"
  }));
},
    fy = function fy(_ref2613) {
  var _ref2613$color = _ref2613.color,
      C = _ref2613$color === void 0 ? "currentColor" : _ref2613$color,
      _ref2613$size = _ref2613.size,
      e = _ref2613$size === void 0 ? 24 : _ref2613$size,
      l = _ref2613.className,
      i = _objectWithoutProperties(_ref2613, _excluded2613);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 2H7.32297L8.52297 5H3V7H5.11765L5.94463 21.0587C5.97572 21.5873 6.41343 22 6.9429 22H17.0571C17.5866 22 18.0243 21.5873 18.0554 21.0587L18.8824 7H21V5H10.677L8.67703 0H4V2ZM7.29906 10.0252L7.1211 7H16.8789L16.5867 11.9675C14.28 11.853 13.4226 11.4919 12.3713 11.0714C11.2792 10.6347 9.97065 10.1354 7.29906 10.0252ZM7.41714 12.0326C9.72097 12.1473 10.5894 12.5128 11.6401 12.933C12.7001 13.357 13.9556 13.8375 16.4692 13.9641L16.1142 20H7.88581L7.41714 12.0326Z"
  }));
},
    Ry = function Ry(_ref2614) {
  var _ref2614$color = _ref2614.color,
      C = _ref2614$color === void 0 ? "currentColor" : _ref2614$color,
      _ref2614$size = _ref2614.size,
      e = _ref2614$size === void 0 ? 24 : _ref2614$size,
      l = _ref2614.className,
      i = _objectWithoutProperties(_ref2614, _excluded2614);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 3H3C2.44772 3 2 3.44772 2 4V20C2 20.5523 2.44772 21 3 21H21C21.5523 21 22 20.5523 22 20V4C22 3.44772 21.5523 3 21 3ZM12 16C10.3431 16 9 14.6569 9 13H4V5H20V13H15C15 14.6569 13.6569 16 12 16ZM16 11H13V14H11V11H8L12 6.5L16 11Z"
  }));
},
    zy = function zy(_ref2615) {
  var _ref2615$color = _ref2615.color,
      C = _ref2615$color === void 0 ? "currentColor" : _ref2615$color,
      _ref2615$size = _ref2615.size,
      e = _ref2615$size === void 0 ? 24 : _ref2615$size,
      l = _ref2615.className,
      i = _objectWithoutProperties(_ref2615, _excluded2615);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22 4C22 3.44772 21.5523 3 21 3H3C2.44772 3 2 3.44772 2 4V20C2 20.5523 2.44772 21 3 21H21C21.5523 21 22 20.5523 22 20V4ZM4 15H7.41604C8.1876 16.7659 9.94968 18 12 18C14.0503 18 15.8124 16.7659 16.584 15H20V19H4V15ZM4 5H20V13H15C15 14.6569 13.6569 16 12 16C10.3431 16 9 14.6569 9 13H4V5ZM16 11H13V14H11V11H8L12 6.5L16 11Z"
  }));
},
    Fy = function Fy(_ref2616) {
  var _ref2616$color = _ref2616.color,
      C = _ref2616$color === void 0 ? "currentColor" : _ref2616$color,
      _ref2616$size = _ref2616.size,
      e = _ref2616$size === void 0 ? 24 : _ref2616$size,
      l = _ref2616.className,
      i = _objectWithoutProperties(_ref2616, _excluded2616);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.9998 7L16 2H3.9985C3.44749 2 3 2.44405 3 2.9918V21.0082C3 21.5447 3.44476 22 3.9934 22H12.3414C12.1203 21.3744 12 20.7013 12 20C12 16.6863 14.6863 14 18 14C19.0928 14 20.1174 14.2922 20.9999 14.8026L20.9998 7ZM14.4646 19.4647L18.0001 23.0002L22.9498 18.0505L21.5356 16.6362L18.0001 20.1718L15.8788 18.0505L14.4646 19.4647Z"
  }));
},
    Sy = function Sy(_ref2617) {
  var _ref2617$color = _ref2617.color,
      C = _ref2617$color === void 0 ? "currentColor" : _ref2617$color,
      _ref2617$size = _ref2617.size,
      e = _ref2617$size === void 0 ? 24 : _ref2617$size,
      l = _ref2617.className,
      i = _objectWithoutProperties(_ref2617, _excluded2617);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 20V22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918C3 2.44405 3.44749 2 3.9985 2H16L20.9998 7V14H19V8H15V4H5V20H12ZM14.4646 19.4647L18.0001 23.0002L22.9498 18.0505L21.5356 16.6362L18.0001 20.1718L15.8788 18.0505L14.4646 19.4647Z"
  }));
},
    Ay = function Ay(_ref2618) {
  var _ref2618$color = _ref2618.color,
      C = _ref2618$color === void 0 ? "currentColor" : _ref2618$color,
      _ref2618$size = _ref2618.size,
      e = _ref2618$size === void 0 ? 24 : _ref2618$size,
      l = _ref2618.className,
      i = _objectWithoutProperties(_ref2618, _excluded2618);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 3C3.44772 3 3 3.44772 3 4V8H5V5H8V3H4ZM20 3H16V5H19V8H21V4C21 3.44772 20.5523 3 20 3ZM5 16V19H8V21H4C3.44772 21 3 20.5523 3 20V16H5ZM19 16V19H16V21H20C20.5523 21 21 20.5523 21 20V16H19ZM10 9C9.44772 9 9 9.44772 9 10V14C9 14.5523 9.44772 15 10 15H14C14.5523 15 15 14.5523 15 14V10C15 9.44772 14.5523 9 14 9H10Z"
  }));
},
    ky = function ky(_ref2619) {
  var _ref2619$color = _ref2619.color,
      C = _ref2619$color === void 0 ? "currentColor" : _ref2619$color,
      _ref2619$size = _ref2619.size,
      e = _ref2619$size === void 0 ? 24 : _ref2619$size,
      l = _ref2619.className,
      i = _objectWithoutProperties(_ref2619, _excluded2619);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 3C2.44772 3 2 3.44772 2 4V7H9.58579L12 4.58579L10.4142 3H3ZM14.4142 5L10.4142 9H2V20C2 20.5523 2.44772 21 3 21H21C21.5523 21 22 20.5523 22 20V6C22 5.44772 21.5523 5 21 5H14.4142Z"
  }));
},
    Py = function Py(_ref2620) {
  var _ref2620$color = _ref2620.color,
      C = _ref2620$color === void 0 ? "currentColor" : _ref2620$color,
      _ref2620$size = _ref2620.size,
      e = _ref2620$size === void 0 ? 24 : _ref2620$size,
      l = _ref2620.className,
      i = _objectWithoutProperties(_ref2620, _excluded2620);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21L3 21C2.45 21 2 20.55 2 20V4ZM10.5858 6L9.58579 5H4V7H9.58579L10.5858 6ZM4 9V19L20 19V7H12.4142L10.4142 9H4Z"
  }));
},
    Dy = function Dy(_ref2621) {
  var _ref2621$color = _ref2621.color,
      C = _ref2621$color === void 0 ? "currentColor" : _ref2621$color,
      _ref2621$size = _ref2621.size,
      e = _ref2621$size === void 0 ? 24 : _ref2621$size,
      l = _ref2621.className,
      i = _objectWithoutProperties(_ref2621, _excluded2621);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19 13C20.0929 13 21.1175 13.2922 22 13.8027V6C22 5.44772 21.5523 5 21 5H12.4142L10.4142 3H3C2.44772 3 2 3.44772 2 4V20C2 20.5523 2.44772 21 3 21H13.3414C13.1203 20.3744 13 19.7013 13 19C13 15.6863 15.6863 13 19 13ZM15.4645 18.4647L19 22.0002L23.9497 17.0505L22.5355 15.6362L19 19.1718L16.8787 17.0505L15.4645 18.4647Z"
  }));
},
    yy = function yy(_ref2622) {
  var _ref2622$color = _ref2622.color,
      C = _ref2622$color === void 0 ? "currentColor" : _ref2622$color,
      _ref2622$size = _ref2622.size,
      e = _ref2622$size === void 0 ? 24 : _ref2622$size,
      l = _ref2622.className,
      i = _objectWithoutProperties(_ref2622, _excluded2622);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 3C2.44772 3 2 3.44772 2 4V20C2 20.5523 2.44772 21 3 21H13V19H4V5H9.58579L11.5858 7H20V13H22V6C22 5.44772 21.5523 5 21 5H12.4142L10.4142 3H3ZM15.4645 18.4647L19 22.0002L23.9497 17.0505L22.5355 15.6362L19 19.1718L16.8787 17.0505L15.4645 18.4647Z"
  }));
},
    by = function by(_ref2623) {
  var _ref2623$color = _ref2623.color,
      C = _ref2623$color === void 0 ? "currentColor" : _ref2623$color,
      _ref2623$size = _ref2623.size,
      e = _ref2623$size === void 0 ? 24 : _ref2623$size,
      l = _ref2623.className,
      i = _objectWithoutProperties(_ref2623, _excluded2623);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19 12C20.0929 12 21.1175 12.2922 22 12.8027V6C22 5.44772 21.5523 5 21 5H12.4142L10.4142 3H3C2.44772 3 2 3.44772 2 4V20C2 20.5523 2.44772 21 3 21H13.8027C13.2922 20.1175 13 19.0929 13 18C13 14.6863 15.6863 12 19 12ZM20.4143 17.9999L22.5356 20.1212L21.1214 21.5354L19.0001 19.4141L16.8788 21.5354L15.4646 20.1212L17.5859 17.9999L15.4646 15.8786L16.8788 14.4644L19.0001 16.5857L21.1214 14.4644L22.5356 15.8786L20.4143 17.9999Z"
  }));
},
    Ty = function Ty(_ref2624) {
  var _ref2624$color = _ref2624.color,
      C = _ref2624$color === void 0 ? "currentColor" : _ref2624$color,
      _ref2624$size = _ref2624.size,
      e = _ref2624$size === void 0 ? 24 : _ref2624$size,
      l = _ref2624.className,
      i = _objectWithoutProperties(_ref2624, _excluded2624);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 3C2.44772 3 2 3.44772 2 4V20C2 20.5523 2.44772 21 3 21H13V19H4V5H9.58579L11.5858 7H20V12H22V6C22 5.44772 21.5523 5 21 5H12.4142L10.4142 3H3ZM20.4143 17.9999L22.5356 20.1212L21.1214 21.5354L19.0001 19.4141L16.8788 21.5354L15.4646 20.1212L17.5859 17.9999L15.4646 15.8786L16.8788 14.4644L19.0001 16.5857L21.1214 14.4644L22.5356 15.8786L20.4143 17.9999Z"
  }));
},
    Uy = function Uy(_ref2625) {
  var _ref2625$color = _ref2625.color,
      C = _ref2625$color === void 0 ? "currentColor" : _ref2625$color,
      _ref2625$size = _ref2625.size,
      e = _ref2625$size === void 0 ? 24 : _ref2625$size,
      l = _ref2625.className,
      i = _objectWithoutProperties(_ref2625, _excluded2625);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5H21C21.5523 5 22 5.44772 22 6V12.3604C21.0023 10.9408 19.3542 10 17.5 10C14.8979 10 12.7015 11.853 12.1394 14.2817C10.8512 15.1306 10 16.5894 10 18.25C10 19.2749 10.3246 20.2239 10.8766 21H3C2.44772 21 2 20.5523 2 20V4ZM14.0015 15.6031C12.8465 15.9291 12 16.9907 12 18.25C12 19.7688 13.2312 21 14.75 21H20.25C21.7688 21 23 19.7688 23 18.25C23 16.9907 22.1535 15.9291 20.9985 15.6031C21.0548 13.6578 19.4477 12 17.5 12C15.5523 12 13.9452 13.6578 14.0015 15.6031Z"
  }));
},
    Gy = function Gy(_ref2626) {
  var _ref2626$color = _ref2626.color,
      C = _ref2626$color === void 0 ? "currentColor" : _ref2626$color,
      _ref2626$size = _ref2626.size,
      e = _ref2626$size === void 0 ? 24 : _ref2626$size,
      l = _ref2626.className,
      i = _objectWithoutProperties(_ref2626, _excluded2626);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 3C2.44772 3 2 3.44772 2 4V20C2 20.5523 2.44772 21 3 21H10V19H4V5H9.58579L11.5858 7H20V11H22V6C22 5.44772 21.5523 5 21 5H12.4142L10.4142 3H3ZM12 18.25C12 16.9907 12.8465 15.9291 14.0015 15.6031C13.9452 13.6578 15.5523 12 17.5 12C19.4477 12 21.0548 13.6578 20.9985 15.6031C22.1535 15.9291 23 16.9907 23 18.25C23 19.7688 21.7688 21 20.25 21H14.75C13.2312 21 12 19.7688 12 18.25ZM17.5 14C16.6716 14 16 14.6716 16 15.5C16 15.9637 16.0239 16.4751 16.0569 16.9605C15.0926 17.1654 14 17.5516 14 18.25C14 18.6642 14.3358 19 14.75 19H20.25C20.6642 19 21 18.6642 21 18.25C21 17.5516 19.9074 17.1654 18.9431 16.9605C18.9761 16.4751 19 15.9637 19 15.5C19 14.6716 18.3284 14 17.5 14Z"
  }));
},
    Iy = function Iy(_ref2627) {
  var _ref2627$color = _ref2627.color,
      C = _ref2627$color === void 0 ? "currentColor" : _ref2627$color,
      _ref2627$size = _ref2627.size,
      e = _ref2627$size === void 0 ? 24 : _ref2627$size,
      l = _ref2627.className,
      i = _objectWithoutProperties(_ref2627, _excluded2627);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 3C2.44772 3 2 3.44772 2 4V10C2 10.5523 2.44772 11 3 11H10C10.5523 11 11 10.5523 11 10V4C11 3.44772 10.5523 3 10 3H3ZM4 9V5H9V9H4ZM3 13C2.44772 13 2 13.4477 2 14V20C2 20.5523 2.44772 21 3 21H10C10.5523 21 11 20.5523 11 20V14C11 13.4477 10.5523 13 10 13H3ZM4 19V15H9V19H4ZM13 4C13 3.44772 13.4477 3 14 3H21C21.5523 3 22 3.44772 22 4V10C22 10.5523 21.5523 11 21 11H14C13.4477 11 13 10.5523 13 10V4ZM15 5V9H20V5H15ZM14 13C13.4477 13 13 13.4477 13 14V20C13 20.5523 13.4477 21 14 21H21C21.5523 21 22 20.5523 22 20V14C22 13.4477 21.5523 13 21 13H14ZM15 19V15H20V19H15Z"
  }));
},
    Wy = function Wy(_ref2628) {
  var _ref2628$color = _ref2628.color,
      C = _ref2628$color === void 0 ? "currentColor" : _ref2628$color,
      _ref2628$size = _ref2628.size,
      e = _ref2628$size === void 0 ? 24 : _ref2628$size,
      l = _ref2628.className,
      i = _objectWithoutProperties(_ref2628, _excluded2628);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4ZM4 5V19H20V5H4ZM6 7H11V11H6V7ZM11 13H6V17H11V13ZM13 7H18V11H13V7ZM18 13H13V17H18V13Z"
  }));
},
    Oy = function Oy(_ref2629) {
  var _ref2629$color = _ref2629.color,
      C = _ref2629$color === void 0 ? "currentColor" : _ref2629$color,
      _ref2629$size = _ref2629.size,
      e = _ref2629$size === void 0 ? 24 : _ref2629$size,
      l = _ref2629.className,
      i = _objectWithoutProperties(_ref2629, _excluded2629);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.5002 2C12.2241 2 12.0002 2.22386 12.0002 2.5V12H10.0002V4.5C10.0002 4.22386 9.77634 4 9.5002 4C9.22405 4 9.0002 4.22386 9.0002 4.5V14C8.64653 14 7.00024 14 7.00024 14C6.61911 12.3792 5.64236 11.4407 4.5954 11.3216C4.87926 12.0664 5.36117 13.2592 6.16634 15.0995C7.02511 17.0622 7.89128 18.5218 9.00374 19.4986C10.0783 20.442 11.4586 21 13.5002 21C16.5378 21 19.0002 18.5377 19.0002 15.5002V7C19.0002 6.72386 18.7763 6.5 18.5002 6.5C18.2241 6.5 18.0002 6.72386 18.0002 7V12H16.0002V4C16.0002 3.72386 15.7763 3.5 15.5002 3.5C15.2241 3.5 15.0002 3.72386 15.0002 4V12H13.0002V2.5C13.0002 2.22386 12.7763 2 12.5002 2ZM21.0002 15.5002C21.0002 19.6424 17.6423 23 13.5002 23C11.0417 23 9.17214 22.308 7.68416 21.0015C6.23411 19.7283 5.22528 17.9381 4.33405 15.9012C3.40393 13.7753 2.89004 12.4804 2.60991 11.7235C2.25318 10.7597 2.74616 9.41212 4.08583 9.31846C5.24076 9.23771 6.22061 9.61249 7.0002 10.2587V4.5C7.0002 3.11929 8.11949 2 9.5002 2C9.68522 2 9.86554 2.0201 10.0391 2.05823C10.2477 0.888227 11.2702 0 12.5002 0C13.5602 0 14.4661 0.659694 14.8298 1.59091C15.0431 1.53167 15.268 1.5 15.5002 1.5C16.8809 1.5 18.0002 2.61929 18.0002 4V4.55001C18.1618 4.51722 18.329 4.5 18.5002 4.5C19.8809 4.5 21.0002 5.61929 21.0002 7V15.5002Z"
  }));
},
    Ky = function Ky(_ref2630) {
  var _ref2630$color = _ref2630.color,
      C = _ref2630$color === void 0 ? "currentColor" : _ref2630$color,
      _ref2630$size = _ref2630.size,
      e = _ref2630$size === void 0 ? 24 : _ref2630$size,
      l = _ref2630.className,
      i = _objectWithoutProperties(_ref2630, _excluded2630);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 3H3C2.44772 3 2 3.44772 2 4V20C2 20.5523 2.44772 21 3 21H21C21.5523 21 22 20.5523 22 20V4C22 3.44772 21.5523 3 21 3ZM12 16C10.3431 16 9 14.6569 9 13H4V5H20V13H15C15 14.6569 13.6569 16 12 16ZM16 9H13V6H11V9H8L12 13.5L16 9Z"
  }));
},
    Qy = function Qy(_ref2631) {
  var _ref2631$color = _ref2631.color,
      C = _ref2631$color === void 0 ? "currentColor" : _ref2631$color,
      _ref2631$size = _ref2631.size,
      e = _ref2631$size === void 0 ? 24 : _ref2631$size,
      l = _ref2631.className,
      i = _objectWithoutProperties(_ref2631, _excluded2631);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22 4C22 3.44772 21.5523 3 21 3H3C2.44772 3 2 3.44772 2 4V20C2 20.5523 2.44772 21 3 21H21C21.5523 21 22 20.5523 22 20V4ZM4 15H7.41604C8.1876 16.7659 9.94968 18 12 18C14.0503 18 15.8124 16.7659 16.584 15H20V19H4V15ZM4 5H20V13H15C15 14.6569 13.6569 16 12 16C10.3431 16 9 14.6569 9 13H4V5ZM16 9H13V6H11V9H8L12 13.5L16 9Z"
  }));
},
    qy = function qy(_ref2632) {
  var _ref2632$color = _ref2632.color,
      C = _ref2632$color === void 0 ? "currentColor" : _ref2632$color,
      _ref2632$size = _ref2632.size,
      e = _ref2632$size === void 0 ? 24 : _ref2632$size,
      l = _ref2632.className,
      i = _objectWithoutProperties(_ref2632, _excluded2632);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 9.5C12.8284 9.5 13.5 8.82843 13.5 8C13.5 7.17157 12.8284 6.5 12 6.5C11.1716 6.5 10.5 7.17157 10.5 8C10.5 8.82843 11.1716 9.5 12 9.5ZM14 15H13V10.5H10V12.5H11V15H10V17H14V15Z"
  }));
},
    jy = function jy(_ref2633) {
  var _ref2633$color = _ref2633.color,
      C = _ref2633$color === void 0 ? "currentColor" : _ref2633$color,
      _ref2633$size = _ref2633.size,
      e = _ref2633$size === void 0 ? 24 : _ref2633$size,
      l = _ref2633.className,
      i = _objectWithoutProperties(_ref2633, _excluded2633);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12 2 6.47715 6.47715 2 12 2 17.5228 2 22 6.47715 22 12 22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12 20 7.58172 16.4183 4 12 4 7.58172 4 4 7.58172 4 12 4 16.4183 7.58172 20 12 20ZM13 10.5V15H14V17H10V15H11V12.5H10V10.5H13ZM13.5 8C13.5 8.82843 12.8284 9.5 12 9.5 11.1716 9.5 10.5 8.82843 10.5 8 10.5 7.17157 11.1716 6.5 12 6.5 12.8284 6.5 13.5 7.17157 13.5 8Z"
  }));
},
    Xy = function Xy(_ref2634) {
  var _ref2634$color = _ref2634.color,
      C = _ref2634$color === void 0 ? "currentColor" : _ref2634$color,
      _ref2634$size = _ref2634.size,
      e = _ref2634$size === void 0 ? 24 : _ref2634$size,
      l = _ref2634.className,
      i = _objectWithoutProperties(_ref2634, _excluded2634);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4ZM16 19H20V5H16V19ZM14 5H10V19H14V5ZM4 5V19H8V5H4Z"
  }));
},
    Jy = function Jy(_ref2635) {
  var _ref2635$color = _ref2635.color,
      C = _ref2635$color === void 0 ? "currentColor" : _ref2635$color,
      _ref2635$size = _ref2635.size,
      e = _ref2635$size === void 0 ? 24 : _ref2635$size,
      l = _ref2635.className,
      i = _objectWithoutProperties(_ref2635, _excluded2635);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 3C2.44772 3 2 3.44772 2 4V20C2 20.5523 2.44772 21 3 21H21C21.5523 21 22 20.5523 22 20V4C22 3.44772 21.5523 3 21 3H3ZM4 19V5H20V19H4ZM9 7H7V15H9V7ZM15 7H17V13H15V7ZM13 7H11V17H13V7Z"
  }));
},
    Yy = function Yy(_ref2636) {
  var _ref2636$color = _ref2636.color,
      C = _ref2636$color === void 0 ? "currentColor" : _ref2636$color,
      _ref2636$size = _ref2636.size,
      e = _ref2636$size === void 0 ? 24 : _ref2636$size,
      l = _ref2636.className,
      i = _objectWithoutProperties(_ref2636, _excluded2636);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4ZM4 5V19H20V5H4ZM6 7H8V9H6V7ZM8 11H6V13H8V11ZM6 15H8V17H6V15ZM18 7H10V9H18V7ZM10 15H18V17H10V15ZM18 11H10V13H18V11Z"
  }));
},
    _y = function _y(_ref2637) {
  var _ref2637$color = _ref2637.color,
      C = _ref2637$color === void 0 ? "currentColor" : _ref2637$color,
      _ref2637$size = _ref2637.size,
      e = _ref2637$size === void 0 ? 24 : _ref2637$size,
      l = _ref2637.className,
      i = _objectWithoutProperties(_ref2637, _excluded2637);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 1C8.68629 1 6 3.68629 6 7V8H4C3.44772 8 3 8.44772 3 9V21C3 21.5523 3.44772 22 4 22H13.044C12.6947 21.2389 12.5 20.3922 12.5 19.5C12.5 16.1863 15.1863 13.5 18.5 13.5C19.3922 13.5 20.2389 13.6947 21 14.044V9C21 8.44772 20.5523 8 20 8H18V7C18 3.68629 15.3137 1 12 1ZM16 8H8V7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7V8ZM21.145 23.1406L20.6399 20.1953L22.7798 18.1094L19.8225 17.6797L18.5 15L17.1775 17.6797L14.2202 18.1094L16.3601 20.1953L15.855 23.1406L18.5 21.75L21.145 23.1406Z"
  }));
},
    $y = function $y(_ref2638) {
  var _ref2638$color = _ref2638.color,
      C = _ref2638$color === void 0 ? "currentColor" : _ref2638$color,
      _ref2638$size = _ref2638.size,
      e = _ref2638$size === void 0 ? 24 : _ref2638$size,
      l = _ref2638.className,
      i = _objectWithoutProperties(_ref2638, _excluded2638);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6 7C6 3.68629 8.68629 1 12 1C15.3137 1 18 3.68629 18 7V8H19.5C20.3284 8 21 8.67157 21 9.5V13H19V10H5V20H13V22H4.5C3.67157 22 3 21.3284 3 20.5V9.5C3 8.67157 3.67157 8 4.5 8H6V7ZM16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7V8H16V7ZM20.6399 20.1953L21.145 23.1406L18.5 21.75L15.855 23.1406L16.3601 20.1953L14.2202 18.1094L17.1775 17.6797L18.5 15L19.8225 17.6797L22.7798 18.1094L20.6399 20.1953Z"
  }));
},
    eb = function eb(_ref2639) {
  var _ref2639$color = _ref2639.color,
      C = _ref2639$color === void 0 ? "currentColor" : _ref2639$color,
      _ref2639$size = _ref2639.size,
      e = _ref2639$size === void 0 ? 24 : _ref2639$size,
      l = _ref2639.className,
      i = _objectWithoutProperties(_ref2639, _excluded2639);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8 4C8 2.34315 9.34315 1 11 1C12.6569 1 14 2.34315 14 4C14 4.35064 13.9398 4.68722 13.8293 5H20C20.5523 5 21 5.44772 21 6V9.12602C21 9.43517 20.857 9.72694 20.6127 9.91635C20.3683 10.1058 20.0501 10.1715 19.7507 10.0945C19.5119 10.033 19.2605 10 19 10C17.3431 10 16 11.3431 16 13C16 14.6569 17.3431 16 19 16C19.2605 16 19.5119 15.967 19.7507 15.9055C20.0501 15.8285 20.3683 15.8942 20.6127 16.0836C20.857 16.2731 21 16.5648 21 16.874V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V6C3 5.44772 3.44772 5 4 5H8.17071C8.06015 4.68722 8 4.35064 8 4Z"
  }));
},
    tb = function tb(_ref2640) {
  var _ref2640$color = _ref2640.color,
      C = _ref2640$color === void 0 ? "currentColor" : _ref2640$color,
      _ref2640$size = _ref2640.size,
      e = _ref2640$size === void 0 ? 24 : _ref2640$size,
      l = _ref2640.className,
      i = _objectWithoutProperties(_ref2640, _excluded2640);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7 5C7 2.79086 8.79086 1 11 1C13.2091 1 15 2.79086 15 5H20C20.5523 5 21 5.44772 21 6V10.1707C21 10.4953 20.8424 10.7997 20.5774 10.9872C20.3123 11.1746 19.9728 11.2217 19.6668 11.1135C19.4595 11.0403 19.2355 11 19 11C17.8954 11 17 11.8954 17 13C17 14.1046 17.8954 15 19 15C19.2355 15 19.4595 14.9597 19.6668 14.8865C19.9728 14.7783 20.3123 14.8254 20.5774 15.0128C20.8424 15.2003 21 15.5047 21 15.8293V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V6C3 5.44772 3.44772 5 4 5H7ZM11 3C9.89543 3 9 3.89543 9 5C9 5.23554 9.0403 5.45952 9.11355 5.66675C9.22172 5.97282 9.17461 6.31235 8.98718 6.57739C8.79974 6.84243 8.49532 7 8.17071 7H5V19H19V17C16.7909 17 15 15.2091 15 13C15 10.7909 16.7909 9 19 9V7H13.8293C13.5047 7 13.2003 6.84243 13.0128 6.57739C12.8254 6.31235 12.7783 5.97282 12.8865 5.66675C12.9597 5.45952 13 5.23555 13 5C13 3.89543 12.1046 3 11 3Z"
  }));
},
    Cb = function Cb(_ref2641) {
  var _ref2641$color = _ref2641.color,
      C = _ref2641$color === void 0 ? "currentColor" : _ref2641$color,
      _ref2641$size = _ref2641.size,
      e = _ref2641$size === void 0 ? 24 : _ref2641$size,
      l = _ref2641.className,
      i = _objectWithoutProperties(_ref2641, _excluded2641);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8 4C8 2.34315 9.34315 1 11 1C12.6569 1 14 2.34315 14 4C14 4.35064 13.9398 4.68722 13.8293 5H18C18.5523 5 19 5.44772 19 6V10.1707C19.3128 10.0602 19.6494 10 20 10C21.6569 10 23 11.3431 23 13C23 14.6569 21.6569 16 20 16C19.6494 16 19.3128 15.9398 19 15.8293V20C19 20.5523 18.5523 21 18 21H4C3.44772 21 3 20.5523 3 20V6C3 5.44772 3.44772 5 4 5H8.17071C8.06015 4.68722 8 4.35064 8 4Z"
  }));
},
    lb = function lb(_ref2642) {
  var _ref2642$color = _ref2642.color,
      C = _ref2642$color === void 0 ? "currentColor" : _ref2642$color,
      _ref2642$size = _ref2642.size,
      e = _ref2642$size === void 0 ? 24 : _ref2642$size,
      l = _ref2642.className,
      i = _objectWithoutProperties(_ref2642, _excluded2642);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7 5C7 2.79086 8.79086 1 11 1C13.2091 1 15 2.79086 15 5H18C18.5523 5 19 5.44772 19 6V9C21.2091 9 23 10.7909 23 13C23 15.2091 21.2091 17 19 17V20C19 20.5523 18.5523 21 18 21H4C3.44772 21 3 20.5523 3 20V6C3 5.44772 3.44772 5 4 5H7ZM11 3C9.89543 3 9 3.89543 9 5C9 5.23554 9.0403 5.45952 9.11355 5.66675C9.22172 5.97282 9.17461 6.31235 8.98718 6.57739C8.79974 6.84243 8.49532 7 8.17071 7H5V19H17V15.8293C17 15.5047 17.1576 15.2003 17.4226 15.0128C17.6877 14.8254 18.0272 14.7783 18.3332 14.8865C18.5405 14.9597 18.7645 15 19 15C20.1046 15 21 14.1046 21 13C21 11.8954 20.1046 11 19 11C18.7645 11 18.5405 11.0403 18.3332 11.1135C18.0272 11.2217 17.6877 11.1746 17.4226 10.9872C17.1576 10.7997 17 10.4953 17 10.1707V7H13.8293C13.5047 7 13.2003 6.84243 13.0128 6.57739C12.8254 6.31235 12.7783 5.97282 12.8865 5.66675C12.9597 5.45952 13 5.23555 13 5C13 3.89543 12.1046 3 11 3Z"
  }));
},
    ib = function ib(_ref2643) {
  var _ref2643$color = _ref2643.color,
      C = _ref2643$color === void 0 ? "currentColor" : _ref2643$color,
      _ref2643$size = _ref2643.size,
      e = _ref2643$size === void 0 ? 24 : _ref2643$size,
      l = _ref2643.className,
      i = _objectWithoutProperties(_ref2643, _excluded2643);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 5H22C22.5523 5 23 5.44772 23 6V15C23 15.5523 22.5523 16 22 16V18C22 18.5523 21.5523 19 21 19H13.5858L12.5858 18H11.4142L10.4142 19H3C2.44772 19 2 18.5523 2 18L2 16C1.44772 16 1 15.5523 1 15V6C1 5.44771 1.44772 5 2 5ZM4 16V17H9.58579L10.5858 16H4ZM13.4142 16L14.4142 17H20V16H13.4142ZM7 9H5V12H7V9ZM9 9V12H11V9H9ZM15 9H13V12H15V9ZM17 9V12H19V9H17Z"
  }));
},
    sb = function sb(_ref2644) {
  var _ref2644$color = _ref2644.color,
      C = _ref2644$color === void 0 ? "currentColor" : _ref2644$color,
      _ref2644$size = _ref2644.size,
      e = _ref2644$size === void 0 ? 24 : _ref2644$size,
      l = _ref2644.className,
      i = _objectWithoutProperties(_ref2644, _excluded2644);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 5C1.44772 5 1 5.44772 1 6V15C1 15.5523 1.44772 16 2 16V18C2 18.5523 2.44772 19 3 19H10.4142L11.4142 18H12.5858L13.5858 19H21C21.5523 19 22 18.5523 22 18V16C22.5523 16 23 15.5523 23 15V6C23 5.44772 22.5523 5 22 5H2ZM20 16V17H14.4142L13.4142 16H20ZM10.5858 16L9.58579 17H4V16H10.5858ZM3 14V7H21V14H3ZM5 9H7V12H5V9ZM11 9H9V12H11V9ZM13 9H15V12H13V9ZM19 9H17V12H19V9Z"
  }));
},
    rb = function rb(_ref2645) {
  var _ref2645$color = _ref2645.color,
      C = _ref2645$color === void 0 ? "currentColor" : _ref2645$color,
      _ref2645$size = _ref2645.size,
      e = _ref2645$size === void 0 ? 24 : _ref2645$size,
      l = _ref2645.className,
      i = _objectWithoutProperties(_ref2645, _excluded2645);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 5C1.44772 5 1 5.44772 1 6V18C1 18.5523 1.44772 19 2 19H5V17H7V19H9V17H11V19H13V17H15V19H17V17H19V19H22C22.5523 19 23 18.5523 23 18V6C23 5.44772 22.5523 5 22 5H2ZM5 9H11V12H5V9ZM13 9H19V12H13V9Z"
  }));
},
    cb = function cb(_ref2646) {
  var _ref2646$color = _ref2646.color,
      C = _ref2646$color === void 0 ? "currentColor" : _ref2646$color,
      _ref2646$size = _ref2646.size,
      e = _ref2646$size === void 0 ? 24 : _ref2646$size,
      l = _ref2646.className,
      i = _objectWithoutProperties(_ref2646, _excluded2646);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 7H21V17H19V15H17V17H15V15H13V17H11V15H9V17H7V15H5V17H3V7ZM2 5C1.44772 5 1 5.44772 1 6V18C1 18.5523 1.44772 19 2 19H22C22.5523 19 23 18.5523 23 18V6C23 5.44772 22.5523 5 22 5H2ZM11 9H5V12H11V9ZM13 9H19V12H13V9Z"
  }));
},
    ob = function ob(_ref2647) {
  var _ref2647$color = _ref2647.color,
      C = _ref2647$color === void 0 ? "currentColor" : _ref2647$color,
      _ref2647$size = _ref2647.size,
      e = _ref2647$size === void 0 ? 24 : _ref2647$size,
      l = _ref2647.className,
      i = _objectWithoutProperties(_ref2647, _excluded2647);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9 4L6 2L3 4V16V19C3 20.6569 4.34315 22 6 22H20C21.6569 22 23 20.6569 23 19V17H7V19C7 19.5523 6.55228 20 6 20C5.44772 20 5 19.5523 5 19V15H21V4L18 2L15 4L12 2L9 4Z"
  }));
},
    ab = function ab(_ref2648) {
  var _ref2648$color = _ref2648.color,
      C = _ref2648$color === void 0 ? "currentColor" : _ref2648$color,
      _ref2648$size = _ref2648.size,
      e = _ref2648$size === void 0 ? 24 : _ref2648$size,
      l = _ref2648.className,
      i = _objectWithoutProperties(_ref2648, _excluded2648);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9 4L6 2L3 4V19C3 20.6569 4.34315 22 6 22H20C21.6569 22 23 20.6569 23 19V16H21V4L18 2L15 4L12 2L9 4ZM19 16H7V19C7 19.5523 6.55228 20 6 20C5.44772 20 5 19.5523 5 19V5.07037L6 4.4037L9 6.4037L12 4.4037L15 6.4037L18 4.4037L19 5.07037V16ZM20 20H8.82929C8.93985 19.6872 9 19.3506 9 19V18H21V19C21 19.5523 20.5523 20 20 20Z"
  }));
},
    nb = function nb(_ref2649) {
  var _ref2649$color = _ref2649.color,
      C = _ref2649$color === void 0 ? "currentColor" : _ref2649$color,
      _ref2649$size = _ref2649.size,
      e = _ref2649$size === void 0 ? 24 : _ref2649$size,
      l = _ref2649.className,
      i = _objectWithoutProperties(_ref2649, _excluded2649);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 3C2 2.44772 2.44772 2 3 2H17C17.5523 2 18 2.44772 18 3V6H21C21.5523 6 22 6.44772 22 7V21C22 21.5523 21.5523 22 21 22H7C6.44772 22 6 21.5523 6 21V18H3C2.44772 18 2 17.5523 2 17V3ZM8 18V20H11.4393L9.43934 18H8ZM11.5607 18L13.5607 20H16.4393L14.4393 18H11.5607ZM20 20V18.5607L18 16.5607V17C18 17.5523 17.5523 18 17 18H16.5607L18.5607 20H20ZM20 13.5607L18 11.5607V14.4393L20 16.4393V13.5607ZM20 11.4393V8H18V9.43934L20 11.4393Z"
  }));
},
    mb = function mb(_ref2650) {
  var _ref2650$color = _ref2650.color,
      C = _ref2650$color === void 0 ? "currentColor" : _ref2650$color,
      _ref2650$size = _ref2650.size,
      e = _ref2650$size === void 0 ? 24 : _ref2650$size,
      l = _ref2650.className,
      i = _objectWithoutProperties(_ref2650, _excluded2650);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 2C2.44772 2 2 2.44772 2 3V17C2 17.5523 2.44772 18 3 18H6V21C6 21.5523 6.44772 22 7 22H21C21.5523 22 22 21.5523 22 21V7C22 6.44772 21.5523 6 21 6H18V3C18 2.44772 17.5523 2 17 2H3ZM18 11.5607L20 13.5607V16.4393L18 14.4393V11.5607ZM18 9.43934V8H20V11.4393L18 9.43934ZM18 17V16.5607L20 18.5607V20H18.5607L16.5607 18H17C17.5523 18 18 17.5523 18 17ZM14.4393 18L16.4393 20H13.5607L11.5607 18H14.4393ZM9.43934 18L11.4393 20H8V18H9.43934ZM4 16V4H16V16H4Z"
  }));
},
    wb = function wb(_ref2651) {
  var _ref2651$color = _ref2651.color,
      C = _ref2651$color === void 0 ? "currentColor" : _ref2651$color,
      _ref2651$size = _ref2651.size,
      e = _ref2651$size === void 0 ? 24 : _ref2651$size,
      l = _ref2651.className,
      i = _objectWithoutProperties(_ref2651, _excluded2651);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13 3H4C3.44772 3 3 3.44772 3 4V20C3 20.5523 3.44772 21 4 21H13V3ZM15 21V3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H15ZM11 8.5V15.5L7 12L11 8.5Z"
  }));
},
    Lb = function Lb(_ref2652) {
  var _ref2652$color = _ref2652.color,
      C = _ref2652$color === void 0 ? "currentColor" : _ref2652$color,
      _ref2652$size = _ref2652.size,
      e = _ref2652$size === void 0 ? 24 : _ref2652$size,
      l = _ref2652.className,
      i = _objectWithoutProperties(_ref2652, _excluded2652);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5 5H13V19H5V5ZM19 19H15V5H19V19ZM4 3C3.44772 3 3 3.44772 3 4V20C3 20.5523 3.44772 21 4 21H20C20.5523 21 21 20.5523 21 20V4C21 3.44772 20.5523 3 20 3H4ZM7 12L11 8.5V15.5L7 12Z"
  }));
},
    hb = function hb(_ref2653) {
  var _ref2653$color = _ref2653.color,
      C = _ref2653$color === void 0 ? "currentColor" : _ref2653$color,
      _ref2653$size = _ref2653.size,
      e = _ref2653$size === void 0 ? 24 : _ref2653$size,
      l = _ref2653.className,
      i = _objectWithoutProperties(_ref2653, _excluded2653);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13 3H4C3.44772 3 3 3.44772 3 4V20C3 20.5523 3.44772 21 4 21H13V3ZM15 21V3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H15ZM7 8.5L11 12L7 15.5V8.5Z"
  }));
},
    Hb = function Hb(_ref2654) {
  var _ref2654$color = _ref2654.color,
      C = _ref2654$color === void 0 ? "currentColor" : _ref2654$color,
      _ref2654$size = _ref2654.size,
      e = _ref2654$size === void 0 ? 24 : _ref2654$size,
      l = _ref2654.className,
      i = _objectWithoutProperties(_ref2654, _excluded2654);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5 5H13V19H5V5ZM19 19H15V5H19V19ZM4 3C3.44772 3 3 3.44772 3 4V20C3 20.5523 3.44772 21 4 21H20C20.5523 21 21 20.5523 21 20V4C21 3.44772 20.5523 3 20 3H4ZM11 12L7 8.5V15.5L11 12Z"
  }));
},
    Vb = function Vb(_ref2655) {
  var _ref2655$color = _ref2655.color,
      C = _ref2655$color === void 0 ? "currentColor" : _ref2655$color,
      _ref2655$size = _ref2655.size,
      e = _ref2655$size === void 0 ? 24 : _ref2655$size,
      l = _ref2655.className,
      i = _objectWithoutProperties(_ref2655, _excluded2655);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4ZM4 14H20V5H4V14ZM4 16V19H8V16H4ZM10 16V19H14V16H10ZM16 16V19H20V16H16Z"
  }));
},
    gb = function gb(_ref2656) {
  var _ref2656$color = _ref2656.color,
      C = _ref2656$color === void 0 ? "currentColor" : _ref2656$color,
      _ref2656$size = _ref2656.size,
      e = _ref2656$size === void 0 ? 24 : _ref2656$size,
      l = _ref2656.className,
      i = _objectWithoutProperties(_ref2656, _excluded2656);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4.86885 11H2.6665L6 3H8L11.3334 11H9.13113L8.7213 10H5.27869L4.86885 11ZM6.09836 8H7.90163L7 5.8L6.09836 8ZM18.9999 16V3H16.9999V16H13.9999L17.9999 21L21.9999 16H18.9999ZM10.9999 13H2.99992V15H7.85414L2.99992 19V21H10.9999V19H6.14605L10.9999 15V13Z"
  }));
},
    Mb = function Mb(_ref2657) {
  var _ref2657$color = _ref2657.color,
      C = _ref2657$color === void 0 ? "currentColor" : _ref2657$color,
      _ref2657$size = _ref2657.size,
      e = _ref2657$size === void 0 ? 24 : _ref2657$size,
      l = _ref2657.className,
      i = _objectWithoutProperties(_ref2657, _excluded2657);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4.86885 11H2.6665L6 3H8L11.3334 11H9.13113L8.7213 10H5.27869L4.86885 11ZM6.09836 8H7.90163L7 5.8L6.09836 8ZM21.9999 8L17.9999 3L13.9999 8H16.9999V21H18.9999V8H21.9999ZM10.9999 13H2.99992V15H7.85414L2.99992 19V21H10.9999V19H6.14605L10.9999 15V13Z"
  }));
},
    Zb = function Zb(_ref2658) {
  var _ref2658$color = _ref2658.color,
      C = _ref2658$color === void 0 ? "currentColor" : _ref2658$color,
      _ref2658$size = _ref2658.size,
      e = _ref2658$size === void 0 ? 24 : _ref2658$size,
      l = _ref2658.className,
      i = _objectWithoutProperties(_ref2658, _excluded2658);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9.00054 3L9 11H7V5.41L5 5.9485V3.61978L7.31304 3H9.00054ZM19 3V16H22L18 21L14 16H17V3H19ZM11 15.5C11 16.0645 10.8441 16.5926 10.5729 17.0436L8.28871 21H5.97931L7.45156 18.45C6.05661 18.1923 5 16.9695 5 15.5C5 13.8431 6.34315 12.5 8 12.5C9.65685 12.5 11 13.8431 11 15.5ZM8 16.5C8.55228 16.5 9 16.0523 9 15.5C9 14.9477 8.55228 14.5 8 14.5C7.44772 14.5 7 14.9477 7 15.5C7 16.0523 7.44772 16.5 8 16.5Z"
  }));
},
    xb = function xb(_ref2659) {
  var _ref2659$color = _ref2659.color,
      C = _ref2659$color === void 0 ? "currentColor" : _ref2659$color,
      _ref2659$size = _ref2659.size,
      e = _ref2659$size === void 0 ? 24 : _ref2659$size,
      l = _ref2659.className,
      i = _objectWithoutProperties(_ref2659, _excluded2659);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9 11L9.00054 3H7.31304L5 3.61978V5.9485L7 5.41V11H9ZM22 8L18 3L14 8H17V21H19V8H22ZM8 16.5C7.44772 16.5 7 16.0523 7 15.5C7 14.9477 7.44772 14.5 8 14.5C8.55228 14.5 9 14.9477 9 15.5C9 16.0523 8.55228 16.5 8 16.5ZM10.5729 17.0436C10.8441 16.5926 11 16.0645 11 15.5C11 13.8431 9.65685 12.5 8 12.5C6.34315 12.5 5 13.8431 5 15.5C5 16.9695 6.05661 18.1923 7.45156 18.45L5.97931 21H8.28871L10.5729 17.0436Z"
  }));
},
    vb = function vb(_ref2660) {
  var _ref2660$color = _ref2660.color,
      C = _ref2660$color === void 0 ? "currentColor" : _ref2660$color,
      _ref2660$size = _ref2660.size,
      e = _ref2660$size === void 0 ? 24 : _ref2660$size,
      l = _ref2660.className,
      i = _objectWithoutProperties(_ref2660, _excluded2660);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 2C3.44772 2 3 2.44772 3 3V14C3 14.5523 3.44772 15 4 15H20C20.5523 15 21 14.5523 21 14V3C21 2.44772 20.5523 2 20 2H4ZM5 13V4H19V13H5ZM4 17C3.44772 17 3 17.4477 3 18V22H5V19H19V22H21V18C21 17.4477 20.5523 17 20 17H4Z"
  }));
},
    db = function db(_ref2661) {
  var _ref2661$color = _ref2661.color,
      C = _ref2661$color === void 0 ? "currentColor" : _ref2661$color,
      _ref2661$size = _ref2661.size,
      e = _ref2661$size === void 0 ? 24 : _ref2661$size,
      l = _ref2661.className,
      i = _objectWithoutProperties(_ref2661, _excluded2661);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 1V4H1V6H4V9H6V6H9V4H6V1H4ZM11 5C11 8.31371 8.31371 11 5 11C4.29873 11 3.62556 10.8797 3 10.6586V20.0066C3 20.5551 3.44694 21 3.99826 21H14V15C14 14.45 14.45 14 15 14H21V3.9985C21 3.44749 20.5552 3 20.0066 3H10.6586C10.8797 3.62556 11 4.29873 11 5ZM21 16L16 20.997V16H21Z"
  }));
},
    pb = function pb(_ref2662) {
  var _ref2662$color = _ref2662.color,
      C = _ref2662$color === void 0 ? "currentColor" : _ref2662$color,
      _ref2662$size = _ref2662.size,
      e = _ref2662$size === void 0 ? 24 : _ref2662$size,
      l = _ref2662.className,
      i = _objectWithoutProperties(_ref2662, _excluded2662);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 1V4H1V6H4V9H6V6H9V4H6V1H4ZM3 20.0066V11H5V19H13V14C13 13.45 13.45 13 14 13L19 12.999V5H11V3H20.0066C20.5552 3 21 3.45576 21 4.00247V15L15 20.996L4.00221 21C3.4487 21 3 20.5551 3 20.0066ZM18.171 14.999L15 15V18.169L18.171 14.999Z"
  }));
},
    Eb = function Eb(_ref2663) {
  var _ref2663$color = _ref2663.color,
      C = _ref2663$color === void 0 ? "currentColor" : _ref2663$color,
      _ref2663$size = _ref2663.size,
      e = _ref2663$size === void 0 ? 24 : _ref2663$size,
      l = _ref2663.className,
      i = _objectWithoutProperties(_ref2663, _excluded2663);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17.2073 2.29291L15.793 3.70712L18.0859 6.00002H13.0002V8.00001H18.0859L15.793 10.2929L17.2073 11.7071L21.9144 7.00001L17.2073 2.29291ZM7.00015 11.5C9.48543 11.5 11.5002 9.4853 11.5002 7.00001C11.5002 4.51473 9.48543 2.50001 7.00015 2.50001C4.51487 2.50001 2.50015 4.51473 2.50015 7.00001C2.50015 9.4853 4.51487 11.5 7.00015 11.5ZM5.91436 18L8.20726 20.2929L6.79304 21.7071L2.08594 17L6.79304 12.2929L8.20726 13.7071L5.91436 16H11.0002V18H5.91436ZM14.0002 13C13.4479 13 13.0002 13.4477 13.0002 14V20C13.0002 20.5523 13.4479 21 14.0002 21H20.0002C20.5524 21 21.0002 20.5523 21.0002 20V14C21.0002 13.4477 20.5524 13 20.0002 13H14.0002Z"
  }));
},
    Nb = function Nb(_ref2664) {
  var _ref2664$color = _ref2664.color,
      C = _ref2664$color === void 0 ? "currentColor" : _ref2664$color,
      _ref2664$size = _ref2664.size,
      e = _ref2664$size === void 0 ? 24 : _ref2664$size,
      l = _ref2664.className,
      i = _objectWithoutProperties(_ref2664, _excluded2664);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17.2073 2.29291L15.793 3.70712L18.0859 6.00002H13.0002V8.00001H18.0859L15.793 10.2929L17.2073 11.7071L21.9144 7.00001L17.2073 2.29291ZM9.50015 7.00001C9.50015 5.6193 8.38086 4.50001 7.00015 4.50001C5.61944 4.50001 4.50015 5.6193 4.50015 7.00001C4.50015 8.38073 5.61944 9.50001 7.00015 9.50001C8.38086 9.50001 9.50015 8.38073 9.50015 7.00001ZM11.5002 7.00001C11.5002 9.4853 9.48543 11.5 7.00015 11.5C4.51487 11.5 2.50015 9.4853 2.50015 7.00001C2.50015 4.51473 4.51487 2.50001 7.00015 2.50001C9.48543 2.50001 11.5002 4.51473 11.5002 7.00001ZM5.91436 18L8.20726 20.2929L6.79304 21.7071L2.08594 17L6.79304 12.2929L8.20726 13.7071L5.91436 16H11.0002V18H5.91436ZM15.0002 19H19.0002V15H15.0002V19ZM13.0002 14C13.0002 13.4477 13.4479 13 14.0002 13H20.0002C20.5524 13 21.0002 13.4477 21.0002 14V20C21.0002 20.5523 20.5524 21 20.0002 21H14.0002C13.4479 21 13.0002 20.5523 13.0002 20V14Z"
  }));
},
    ub = function ub(_ref2665) {
  var _ref2665$color = _ref2665.color,
      C = _ref2665$color === void 0 ? "currentColor" : _ref2665$color,
      _ref2665$size = _ref2665.size,
      e = _ref2665$size === void 0 ? 24 : _ref2665$size,
      l = _ref2665.className,
      i = _objectWithoutProperties(_ref2665, _excluded2665);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.00008 5.91424L3.70718 8.20714L2.29297 6.79292L7.00008 2.08582L11.7072 6.79292L10.293 8.20714L8.00008 5.91424L8.00007 11H6.00008L6.00008 5.91424ZM12.5001 7.00003C12.5001 9.48531 14.5148 11.5 17.0001 11.5C19.4854 11.5 21.5001 9.48531 21.5001 7.00003C21.5001 4.51475 19.4854 2.50003 17.0001 2.50003C14.5148 2.50003 12.5001 4.51475 12.5001 7.00003ZM21.7072 17.2071L20.293 15.7929L18.0001 18.0858V13H16.0001V18.0858L13.7072 15.7929L12.293 17.2071L17.0001 21.9142L21.7072 17.2071ZM11.0001 14C11.0001 13.4477 10.5524 13 10.0001 13H4.00008C3.44779 13 3.00008 13.4477 3.00008 14L3.00008 20C3.00007 20.5523 3.44779 21 4.00007 21H10.0001C10.5524 21 11.0001 20.5523 11.0001 20V14Z"
  }));
},
    Bb = function Bb(_ref2666) {
  var _ref2666$color = _ref2666.color,
      C = _ref2666$color === void 0 ? "currentColor" : _ref2666$color,
      _ref2666$size = _ref2666.size,
      e = _ref2666$size === void 0 ? 24 : _ref2666$size,
      l = _ref2666.className,
      i = _objectWithoutProperties(_ref2666, _excluded2666);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.00008 5.91424L3.70718 8.20714L2.29297 6.79292L7.00008 2.08582L11.7072 6.79292L10.293 8.20714L8.00008 5.91424L8.00007 11H6.00008L6.00008 5.91424ZM17.0001 9.50003C18.3808 9.50003 19.5001 8.38074 19.5001 7.00003C19.5001 5.61932 18.3808 4.50003 17.0001 4.50003C15.6194 4.50003 14.5001 5.61932 14.5001 7.00003C14.5001 8.38074 15.6194 9.50003 17.0001 9.50003ZM17.0001 11.5C14.5148 11.5 12.5001 9.48531 12.5001 7.00003C12.5001 4.51475 14.5148 2.50003 17.0001 2.50003C19.4854 2.50003 21.5001 4.51475 21.5001 7.00003C21.5001 9.48531 19.4854 11.5 17.0001 11.5ZM21.7072 17.2071L20.293 15.7929L18.0001 18.0858V13H16.0001V18.0858L13.7072 15.7929L12.293 17.2071L17.0001 21.9142L21.7072 17.2071ZM5.00008 19H9.00007L9.00008 15H5.00008L5.00008 19ZM10.0001 13C10.5524 13 11.0001 13.4477 11.0001 14V20C11.0001 20.5523 10.5524 21 10.0001 21H4.00007C3.44779 21 3.00007 20.5523 3.00008 20L3.00008 14C3.00008 13.4477 3.44779 13 4.00008 13H10.0001Z"
  }));
},
    fb = function fb(_ref2667) {
  var _ref2667$color = _ref2667.color,
      C = _ref2667$color === void 0 ? "currentColor" : _ref2667$color,
      _ref2667$size = _ref2667.size,
      e = _ref2667$size === void 0 ? 24 : _ref2667$size,
      l = _ref2667.className,
      i = _objectWithoutProperties(_ref2667, _excluded2667);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 3C2.44772 3 2 3.44772 2 4V20C2 20.5523 2.44772 21 3 21H21C21.5523 21 22 20.5523 22 20V4C22 3.44772 21.5523 3 21 3H3ZM11 5V8H4V5H11ZM4 14V10H11V14H4ZM4 16H11V19H4V16ZM13 16H20V19H13V16ZM20 14H13V10H20V14ZM20 5V8H13V5H20Z"
  }));
},
    Rb = function Rb(_ref2668) {
  var _ref2668$color = _ref2668.color,
      C = _ref2668$color === void 0 ? "currentColor" : _ref2668$color,
      _ref2668$size = _ref2668.size,
      e = _ref2668$size === void 0 ? 24 : _ref2668$size,
      l = _ref2668.className,
      i = _objectWithoutProperties(_ref2668, _excluded2668);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 3C2.44772 3 2 3.44772 2 4V20C2 20.5523 2.44772 21 3 21H21C21.5523 21 22 20.5523 22 20V4C22 3.44772 21.5523 3 21 3H3ZM8 5V8H4V5H8ZM4 14V10H8V14H4ZM4 16H8V19H4V16ZM10 16H20V19H10V16ZM20 14H10V10H20V14ZM20 5V8H10V5H20Z"
  }));
},
    zb = function zb(_ref2669) {
  var _ref2669$color = _ref2669.color,
      C = _ref2669$color === void 0 ? "currentColor" : _ref2669$color,
      _ref2669$size = _ref2669.size,
      e = _ref2669$size === void 0 ? 24 : _ref2669$size,
      l = _ref2669.className,
      i = _objectWithoutProperties(_ref2669, _excluded2669);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M1 2V5H3V4H5V9H3.5V11H8.5V9H7V4H9V5H11V2H1ZM21 3H14V5H20V19H4V14H2V20C2 20.5523 2.44772 21 3 21H21C21.5523 21 22 20.5523 22 20V4C22 3.44772 21.5523 3 21 3Z"
  }));
},
    Fb = function Fb(_ref2670) {
  var _ref2670$color = _ref2670.color,
      C = _ref2670$color === void 0 ? "currentColor" : _ref2670$color,
      _ref2670$size = _ref2670.size,
      e = _ref2670$size === void 0 ? 24 : _ref2670$size,
      l = _ref2670.className,
      i = _objectWithoutProperties(_ref2670, _excluded2670);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4ZM4 5V19H20V5H4ZM7 8H17V11H15V10H13V14H14.5V16H9.5V14H11V10H9V11H7V8Z"
  }));
},
    Sb = function Sb(_ref2671) {
  var _ref2671$color = _ref2671.color,
      C = _ref2671$color === void 0 ? "currentColor" : _ref2671$color,
      _ref2671$size = _ref2671.size,
      e = _ref2671$size === void 0 ? 24 : _ref2671$size,
      l = _ref2671.className,
      i = _objectWithoutProperties(_ref2671, _excluded2671);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 3C2.44772 3 2 3.44772 2 4V20C2 20.5523 2.44772 21 3 21H21C21.5523 21 22 20.5523 22 20V4C22 3.44772 21.5523 3 21 3H3ZM4 19V5H20V19H4ZM14 7H6V9H14V7ZM18 15V17H10V15H18ZM16 11H8V13H16V11Z"
  }));
},
    Ab = function Ab(_ref2672) {
  var _ref2672$color = _ref2672.color,
      C = _ref2672$color === void 0 ? "currentColor" : _ref2672$color,
      _ref2672$size = _ref2672.size,
      e = _ref2672$size === void 0 ? 24 : _ref2672$size,
      l = _ref2672.className,
      i = _objectWithoutProperties(_ref2672, _excluded2672);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19.8224 9.72867H18.729C18.1402 9.72867 17.6355 9.22399 17.6355 8.63521C17.6355 5.52306 15.1121 2.99969 12 2.99969H8.63551C5.52336 2.99969 3 5.52306 3 8.63521V15.3642C3 18.4763 5.52336 20.9997 8.63551 20.9997H15.3645C18.4766 20.9997 21 18.4763 21 15.3642V10.9062C21 10.2333 20.4953 9.72867 19.8224 9.72867ZM8.5514 7.54175H12.5888C13.1776 7.54175 13.6822 8.04642 13.6822 8.63521C13.6822 9.22399 13.1776 9.72867 12.5888 9.72867H8.5514C7.96262 9.72867 7.45794 9.22399 7.45794 8.63521C7.45794 8.04642 7.96262 7.54175 8.5514 7.54175ZM15.4486 16.4576H8.63551C8.04673 16.4576 7.54206 15.953 7.54206 15.3642C7.54206 14.7754 8.04673 14.2707 8.63551 14.2707H15.4486C16.0374 14.2707 16.5421 14.7754 16.5421 15.3642C16.5421 15.953 16.0374 16.4576 15.4486 16.4576Z"
  }));
},
    kb = function kb(_ref2673) {
  var _ref2673$color = _ref2673.color,
      C = _ref2673$color === void 0 ? "currentColor" : _ref2673$color,
      _ref2673$size = _ref2673.size,
      e = _ref2673$size === void 0 ? 24 : _ref2673$size,
      l = _ref2673.className,
      i = _objectWithoutProperties(_ref2673, _excluded2673);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 9.00886C3 5.69022 5.69071 2.99951 9.00935 2.99951H12C15.3093 2.99951 17.9942 5.67508 18.0093 8.98082H18.9533C20.1037 8.98082 21 9.87713 21 11.0275V14.9902C21 18.3088 18.3093 20.9995 14.9907 20.9995H9.00935C5.69071 20.9995 3 18.3088 3 14.9902V9.00886ZM9.00935 4.99951C6.79528 4.99951 5 6.79479 5 9.00886V14.9902C5 17.2042 6.79528 18.9995 9.00935 18.9995H14.9907C17.2047 18.9995 19 17.2042 19 14.9902V11H18C16.9243 11 16 10.0756 16 9C16 6.78593 14.2141 4.99951 12 4.99951H9.00935ZM8 9C8 8.44772 8.44772 8 9 8H12.5C13.0523 8 13.5 8.44772 13.5 9C13.5 9.55228 13.0523 10 12.5 10H9C8.44772 10 8 9.55228 8 9ZM9 14C8.44772 14 8 14.4477 8 15C8 15.5523 8.44772 16 9 16H15C15.5523 16 16 15.5523 16 15C16 14.4477 15.5523 14 15 14H9Z"
  }));
},
    Pb = function Pb(_ref2674) {
  var _ref2674$color = _ref2674.color,
      C = _ref2674$color === void 0 ? "currentColor" : _ref2674$color,
      _ref2674$size = _ref2674.size,
      e = _ref2674$size === void 0 ? 24 : _ref2674$size,
      l = _ref2674.className,
      i = _objectWithoutProperties(_ref2674, _excluded2674);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 22L7.29117 20.8242C8.6944 21.5746 10.2975 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 13.7025 2.42544 15.3056 3.17581 16.7088L2 22ZM15.4487 7L15.2737 9.00024H17V11.0002H15.0987L14.9237 13.0002H17V15.0002H14.7488L14.5738 17H12.5662L12.7411 15.0002H10.7335L10.5585 17H8.55089L8.72584 15.0002H7V13.0002H8.90082L9.0758 11.0002H7V9.00024H9.25077L9.42577 7H11.4334L11.2584 9.00024H13.2661L13.4411 7H15.4487ZM11.0834 11.0002L10.9085 13.0002H12.9161L13.0911 11.0002H11.0834Z"
  }));
},
    Db = function Db(_ref2675) {
  var _ref2675$color = _ref2675.color,
      C = _ref2675$color === void 0 ? "currentColor" : _ref2675$color,
      _ref2675$size = _ref2675.size,
      e = _ref2675$size === void 0 ? 24 : _ref2675$size,
      l = _ref2675.className,
      i = _objectWithoutProperties(_ref2675, _excluded2675);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 22L7.29117 20.8242C8.6944 21.5746 10.2975 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 13.7025 2.42544 15.3056 3.17581 16.7088L2 22ZM8.23428 19.0605L7.58075 18.711L4.63416 19.3658L5.28896 16.4192L4.93949 15.7657C4.32549 14.6175 4 13.3345 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C10.6655 20 9.38248 19.6745 8.23428 19.0605ZM15.4487 7H13.4411L13.2661 9.00024H11.2584L11.4334 7H9.42577L9.25077 9.00024H7V11.0002H9.0758L8.90082 13.0002H7V15.0002H8.72584L8.55089 17H10.5585L10.7335 15.0002H12.7411L12.5662 17H14.5738L14.7488 15.0002H17V13.0002H14.9237L15.0987 11.0002H17V9.00024H15.2737L15.4487 7ZM11.0834 11.0002H13.0911L12.9161 13.0002H10.9085L11.0834 11.0002Z"
  }));
},
    yb = function yb(_ref2676) {
  var _ref2676$color = _ref2676.color,
      C = _ref2676$color === void 0 ? "currentColor" : _ref2676$color,
      _ref2676$size = _ref2676.size,
      e = _ref2676$size === void 0 ? 24 : _ref2676$size,
      l = _ref2676.className,
      i = _objectWithoutProperties(_ref2676, _excluded2676);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13.9461 2.09411C12.8248 1.13855 11.1756 1.13856 10.0544 2.0941L8.70636 3.24286C8.54619 3.37935 8.34705 3.46183 8.13728 3.47857L6.3718 3.61946C4.90327 3.73665 3.73714 4.90278 3.61995 6.3713L3.47907 8.13678C3.46234 8.34654 3.37983 8.54573 3.24334 8.70589L2.09458 10.0539C1.13904 11.1752 1.13905 12.8243 2.0946 13.9455L3.24336 15.2936C3.37983 15.4538 3.46232 15.6529 3.47906 15.8627L3.61997 17.6281C3.73716 19.0966 4.9033 20.2627 6.37184 20.3799L8.13729 20.5209C8.34705 20.5376 8.54615 20.6201 8.70631 20.7566L10.0543 21.9053C11.1756 22.8608 12.8248 22.8609 13.9461 21.9053L15.2941 20.7566C15.4542 20.6201 15.6533 20.5376 15.8631 20.5208L17.6286 20.3799C19.0971 20.2628 20.2632 19.0967 20.3805 17.6281L20.5213 15.8627C20.538 15.6529 20.6206 15.4537 20.757 15.2935L21.9058 13.9456C22.8614 12.8243 22.8614 11.1751 21.9058 10.0539L20.757 8.70585C20.6205 8.54568 20.5381 8.34654 20.5214 8.13679L20.3805 6.37131C20.2633 4.9028 19.0971 3.73663 17.6286 3.61945L15.8631 3.47856C15.6533 3.46182 15.4542 3.37935 15.2941 3.24286L13.9461 2.09411ZM14.8284 7.75718L16.2426 9.1714L9.17151 16.2425L7.7573 14.8282L14.8284 7.75718ZM10.2322 10.232C9.64638 10.8178 8.69664 10.8178 8.11085 10.232C7.52506 9.6463 7.52506 8.69652 8.11085 8.11073C8.69664 7.52494 9.64638 7.52494 10.2322 8.11073C10.818 8.69652 10.818 9.6463 10.2322 10.232ZM13.7677 15.8889C13.1819 15.3031 13.1819 14.3534 13.7677 13.7676C14.3535 13.1818 15.3032 13.1818 15.889 13.7676C16.4748 14.3534 16.4748 15.3031 15.889 15.8889C15.3032 16.4747 14.3535 16.4747 13.7677 15.8889Z"
  }));
},
    bb = function bb(_ref2677) {
  var _ref2677$color = _ref2677.color,
      C = _ref2677$color === void 0 ? "currentColor" : _ref2677$color,
      _ref2677$size = _ref2677.size,
      e = _ref2677$size === void 0 ? 24 : _ref2677$size,
      l = _ref2677.className,
      i = _objectWithoutProperties(_ref2677, _excluded2677);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10.0544 2.0941C11.1756 1.13856 12.8248 1.13855 13.9461 2.09411L15.2941 3.24286C15.4542 3.37935 15.6533 3.46182 15.8631 3.47856L17.6286 3.61945C19.0971 3.73663 20.2633 4.9028 20.3805 6.37131L20.5214 8.13679C20.5381 8.34654 20.6205 8.54568 20.757 8.70585L21.9058 10.0539C22.8614 11.1751 22.8614 12.8243 21.9058 13.9456L20.757 15.2935C20.6206 15.4537 20.538 15.6529 20.5213 15.8627L20.3805 17.6281C20.2633 19.0967 19.0971 20.2628 17.6286 20.3799L15.8631 20.5208C15.6533 20.5376 15.4542 20.6201 15.2941 20.7566L13.9461 21.9053C12.8248 22.8609 11.1756 22.8608 10.0543 21.9053L8.70631 20.7566C8.54615 20.6201 8.34705 20.5376 8.1373 20.5209L6.37184 20.3799C4.9033 20.2627 3.73716 19.0966 3.61997 17.6281L3.47906 15.8627C3.46232 15.6529 3.37983 15.4538 3.24336 15.2936L2.0946 13.9455C1.13905 12.8243 1.13904 11.1752 2.09458 10.0539L3.24334 8.70589C3.37983 8.54573 3.46234 8.34654 3.47907 8.13678L3.61996 6.3713C3.73714 4.90278 4.90327 3.73665 6.3718 3.61946L8.13729 3.47857C8.34705 3.46183 8.54619 3.37935 8.70636 3.24286L10.0544 2.0941ZM12.6488 3.61632C12.2751 3.29782 11.7253 3.29781 11.3516 3.61632L10.0036 4.76509C9.5231 5.17456 8.92568 5.42201 8.29637 5.47223L6.5309 5.61312C6.04139 5.65219 5.65268 6.04089 5.61362 6.53041L5.47272 8.29593C5.4225 8.92521 5.17505 9.52259 4.76559 10.0031L3.61683 11.3511C3.29832 11.7248 3.29831 12.2746 3.61683 12.6483L4.76559 13.9963C5.17506 14.4768 5.4225 15.0743 5.47275 15.7035L5.61363 17.469C5.65268 17.9585 6.04139 18.3473 6.53092 18.3863L8.29636 18.5272C8.92563 18.5774 9.5231 18.8249 10.0036 19.2344L11.3516 20.3831C11.7254 20.7016 12.2751 20.7016 12.6488 20.3831L13.9969 19.2343C14.4773 18.8249 15.0747 18.5774 15.704 18.5272L17.4695 18.3863C17.959 18.3472 18.3478 17.9585 18.3868 17.469L18.5277 15.7035C18.5779 15.0742 18.8253 14.4768 19.2349 13.9964L20.3836 12.6483C20.7022 12.2746 20.7021 11.7249 20.3836 11.3511L19.2348 10.0031C18.8253 9.52259 18.5779 8.92519 18.5277 8.2959L18.3868 6.53041C18.3478 6.0409 17.959 5.65219 17.4695 5.61312L15.704 5.47224C15.0748 5.42203 14.4773 5.17455 13.9968 4.76508L12.6488 3.61632ZM14.8284 7.75718L16.2426 9.1714L9.17154 16.2425L7.75733 14.8282L14.8284 7.75718ZM10.2322 10.232C9.64641 10.8178 8.69667 10.8178 8.11088 10.232C7.52509 9.6463 7.52509 8.69652 8.11088 8.11073C8.69667 7.52494 9.64641 7.52494 10.2322 8.11073C10.818 8.69652 10.818 9.6463 10.2322 10.232ZM13.7677 15.8889C14.3535 16.4747 15.3032 16.4747 15.889 15.8889C16.4748 15.3031 16.4748 14.3534 15.889 13.7676C15.3032 13.1818 14.3535 13.1818 13.7677 13.7676C13.1819 14.3534 13.1819 15.3031 13.7677 15.8889Z"
  }));
},
    Tb = function Tb(_ref2678) {
  var _ref2678$color = _ref2678.color,
      C = _ref2678$color === void 0 ? "currentColor" : _ref2678$color,
      _ref2678$size = _ref2678.size,
      e = _ref2678$size === void 0 ? 24 : _ref2678$size,
      l = _ref2678.className,
      i = _objectWithoutProperties(_ref2678, _excluded2678);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7 21.5C4.51472 21.5 2.5 19.4853 2.5 17C2.5 14.5147 4.51472 12.5 7 12.5C9.48528 12.5 11.5 14.5147 11.5 17C11.5 19.4853 9.48528 21.5 7 21.5ZM17 11.5C14.5147 11.5 12.5 9.48528 12.5 7C12.5 4.51472 14.5147 2.5 17 2.5C19.4853 2.5 21.5 4.51472 21.5 7C21.5 9.48528 19.4853 11.5 17 11.5ZM3 8C3 5.23858 5.23858 3 8 3H11V5H8C6.34315 5 5 6.34315 5 8V11H3V8ZM19 13V16C19 17.6569 17.6569 19 16 19H13V21H16C18.7614 21 21 18.7614 21 16V13H19Z"
  }));
},
    Ub = function Ub(_ref2679) {
  var _ref2679$color = _ref2679.color,
      C = _ref2679$color === void 0 ? "currentColor" : _ref2679$color,
      _ref2679$size = _ref2679.size,
      e = _ref2679$size === void 0 ? 24 : _ref2679$size,
      l = _ref2679.className,
      i = _objectWithoutProperties(_ref2679, _excluded2679);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7 21.5C4.51472 21.5 2.5 19.4853 2.5 17C2.5 14.5147 4.51472 12.5 7 12.5C9.48528 12.5 11.5 14.5147 11.5 17C11.5 19.4853 9.48528 21.5 7 21.5ZM17 11.5C14.5147 11.5 12.5 9.48528 12.5 7C12.5 4.51472 14.5147 2.5 17 2.5C19.4853 2.5 21.5 4.51472 21.5 7C21.5 9.48528 19.4853 11.5 17 11.5ZM7 19.5C8.38071 19.5 9.5 18.3807 9.5 17C9.5 15.6193 8.38071 14.5 7 14.5C5.61929 14.5 4.5 15.6193 4.5 17C4.5 18.3807 5.61929 19.5 7 19.5ZM17 9.5C18.3807 9.5 19.5 8.38071 19.5 7C19.5 5.61929 18.3807 4.5 17 4.5C15.6193 4.5 14.5 5.61929 14.5 7C14.5 8.38071 15.6193 9.5 17 9.5ZM3 8C3 5.23858 5.23858 3 8 3H11V5H8C6.34315 5 5 6.34315 5 8V11H3V8ZM21 13H19V16C19 17.6569 17.6569 19 16 19H13V21H16C18.7614 21 21 18.7614 21 16V13Z"
  }));
},
    Gb = function Gb(_ref2680) {
  var _ref2680$color = _ref2680.color,
      C = _ref2680$color === void 0 ? "currentColor" : _ref2680$color,
      _ref2680$size = _ref2680.size,
      e = _ref2680$size === void 0 ? 24 : _ref2680$size,
      l = _ref2680.className,
      i = _objectWithoutProperties(_ref2680, _excluded2680);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9 6C9 7.30622 8.16519 8.41746 7 8.82929V9C7 10.1046 7.89543 11 9 11H15C16.1046 11 17 10.1046 17 9V8.82929C15.8348 8.41746 15 7.30622 15 6C15 4.34315 16.3431 3 18 3C19.6569 3 21 4.34315 21 6C21 7.30622 20.1652 8.41746 19 8.82929V9C19 11.2091 17.2091 13 15 13H13V15.1707C14.1652 15.5825 15 16.6938 15 18C15 19.6569 13.6569 21 12 21C10.3431 21 9 19.6569 9 18C9 16.6938 9.83481 15.5825 11 15.1707V13H9C6.79086 13 5 11.2091 5 9V8.82929C3.83481 8.41746 3 7.30622 3 6C3 4.34315 4.34315 3 6 3C7.65685 3 9 4.34315 9 6Z"
  }));
},
    Ib = function Ib(_ref2681) {
  var _ref2681$color = _ref2681.color,
      C = _ref2681$color === void 0 ? "currentColor" : _ref2681$color,
      _ref2681$size = _ref2681.size,
      e = _ref2681$size === void 0 ? 24 : _ref2681$size,
      l = _ref2681.className,
      i = _objectWithoutProperties(_ref2681, _excluded2681);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6 5C5.44772 5 5 5.44772 5 6C5 6.55228 5.44772 7 6 7C6.55228 7 7 6.55228 7 6C7 5.44772 6.55228 5 6 5ZM3 6C3 4.34315 4.34315 3 6 3C7.65685 3 9 4.34315 9 6C9 7.30622 8.16519 8.41746 7 8.82929V9C7 10.1046 7.89543 11 9 11H15C16.1046 11 17 10.1046 17 9V8.82929C15.8348 8.41746 15 7.30622 15 6C15 4.34315 16.3431 3 18 3C19.6569 3 21 4.34315 21 6C21 7.30622 20.1652 8.41746 19 8.82929V9C19 11.2091 17.2091 13 15 13H13V15.1707C14.1652 15.5825 15 16.6938 15 18C15 19.6569 13.6569 21 12 21C10.3431 21 9 19.6569 9 18C9 16.6938 9.83481 15.5825 11 15.1707V13H9C6.79086 13 5 11.2091 5 9V8.82929C3.83481 8.41746 3 7.30622 3 6ZM18 5C17.4477 5 17 5.44772 17 6C17 6.55228 17.4477 7 18 7C18.5523 7 19 6.55228 19 6C19 5.44772 18.5523 5 18 5ZM12 17C11.4477 17 11 17.4477 11 18C11 18.5523 11.4477 19 12 19C12.5523 19 13 18.5523 13 18C13 17.4477 12.5523 17 12 17Z"
  }));
},
    Wb = function Wb(_ref2682) {
  var _ref2682$color = _ref2682.color,
      C = _ref2682$color === void 0 ? "currentColor" : _ref2682$color,
      _ref2682$size = _ref2682.size,
      e = _ref2682$size === void 0 ? 24 : _ref2682$size,
      l = _ref2682.className,
      i = _objectWithoutProperties(_ref2682, _excluded2682);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8 5H11V19H8V21H16V19H13V5H16V3H8V5ZM2 7C1.44772 7 1 7.44772 1 8V16C1 16.5523 1.44772 17 2 17H8V15H3V9H8V7H2ZM16 9H21V15H16V17H22C22.5523 17 23 16.5523 23 16V8C23 7.44772 22.5523 7 22 7H16V9Z"
  }));
},
    Ob = function Ob(_ref2683) {
  var _ref2683$color = _ref2683.color,
      C = _ref2683$color === void 0 ? "currentColor" : _ref2683$color,
      _ref2683$size = _ref2683.size,
      e = _ref2683$size === void 0 ? 24 : _ref2683$size,
      l = _ref2683.className,
      i = _objectWithoutProperties(_ref2683, _excluded2683);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12 12V6C13.6569 6 15.1569 6.67157 16.2426 7.75736L12 12Z"
  }));
},
    Kb = function Kb(_ref2684) {
  var _ref2684$color = _ref2684.color,
      C = _ref2684$color === void 0 ? "currentColor" : _ref2684$color,
      _ref2684$size = _ref2684.size,
      e = _ref2684$size === void 0 ? 24 : _ref2684$size,
      l = _ref2684.className,
      i = _objectWithoutProperties(_ref2684, _excluded2684);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12ZM20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12ZM12 12V6C13.6569 6 15.1569 6.67157 16.2426 7.75736L12 12Z"
  }));
},
    Qb = function Qb(_ref2685) {
  var _ref2685$color = _ref2685.color,
      C = _ref2685$color === void 0 ? "currentColor" : _ref2685$color,
      _ref2685$size = _ref2685.size,
      e = _ref2685$size === void 0 ? 24 : _ref2685$size,
      l = _ref2685.className,
      i = _objectWithoutProperties(_ref2685, _excluded2685);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12 12V6C15.3137 6 18 8.68629 18 12H12Z"
  }));
},
    qb = function qb(_ref2686) {
  var _ref2686$color = _ref2686.color,
      C = _ref2686$color === void 0 ? "currentColor" : _ref2686$color,
      _ref2686$size = _ref2686.size,
      e = _ref2686$size === void 0 ? 24 : _ref2686$size,
      l = _ref2686.className,
      i = _objectWithoutProperties(_ref2686, _excluded2686);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12ZM20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12ZM12 12V6C15.3137 6 18 8.68629 18 12H12Z"
  }));
},
    jb = function jb(_ref2687) {
  var _ref2687$color = _ref2687.color,
      C = _ref2687$color === void 0 ? "currentColor" : _ref2687$color,
      _ref2687$size = _ref2687.size,
      e = _ref2687$size === void 0 ? 24 : _ref2687$size,
      l = _ref2687.className,
      i = _objectWithoutProperties(_ref2687, _excluded2687);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM18 12C18 13.6569 17.3284 15.1569 16.2426 16.2426L12 12V6C15.3137 6 18 8.68629 18 12Z"
  }));
},
    Xb = function Xb(_ref2688) {
  var _ref2688$color = _ref2688.color,
      C = _ref2688$color === void 0 ? "currentColor" : _ref2688$color,
      _ref2688$size = _ref2688.size,
      e = _ref2688$size === void 0 ? 24 : _ref2688$size,
      l = _ref2688.className,
      i = _objectWithoutProperties(_ref2688, _excluded2688);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12ZM20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12ZM18 12C18 13.6569 17.3284 15.1569 16.2426 16.2426L12 12V6C15.3137 6 18 8.68629 18 12Z"
  }));
},
    Jb = function Jb(_ref2689) {
  var _ref2689$color = _ref2689.color,
      C = _ref2689$color === void 0 ? "currentColor" : _ref2689$color,
      _ref2689$size = _ref2689.size,
      e = _ref2689$size === void 0 ? 24 : _ref2689$size,
      l = _ref2689.className,
      i = _objectWithoutProperties(_ref2689, _excluded2689);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM18 12C18 15.3137 15.3137 18 12 18V6C15.3137 6 18 8.68629 18 12Z"
  }));
},
    Yb = function Yb(_ref2690) {
  var _ref2690$color = _ref2690.color,
      C = _ref2690$color === void 0 ? "currentColor" : _ref2690$color,
      _ref2690$size = _ref2690.size,
      e = _ref2690$size === void 0 ? 24 : _ref2690$size,
      l = _ref2690.className,
      i = _objectWithoutProperties(_ref2690, _excluded2690);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12ZM20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12ZM18 12C18 15.3137 15.3137 18 12 18V6C15.3137 6 18 8.68629 18 12Z"
  }));
},
    _b = function _b(_ref2691) {
  var _ref2691$color = _ref2691.color,
      C = _ref2691$color === void 0 ? "currentColor" : _ref2691$color,
      _ref2691$size = _ref2691.size,
      e = _ref2691$size === void 0 ? 24 : _ref2691$size,
      l = _ref2691.className,
      i = _objectWithoutProperties(_ref2691, _excluded2691);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM18 12C18 15.3137 15.3137 18 12 18C10.3431 18 8.84311 17.3284 7.75732 16.2426L12 12V6C15.3137 6 18 8.68629 18 12Z"
  }));
},
    $b = function $b(_ref2692) {
  var _ref2692$color = _ref2692.color,
      C = _ref2692$color === void 0 ? "currentColor" : _ref2692$color,
      _ref2692$size = _ref2692.size,
      e = _ref2692$size === void 0 ? 24 : _ref2692$size,
      l = _ref2692.className,
      i = _objectWithoutProperties(_ref2692, _excluded2692);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12ZM20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12ZM18 12C18 15.3137 15.3137 18 12 18C10.3431 18 8.84311 17.3284 7.75732 16.2426L12 12V6C15.3137 6 18 8.68629 18 12Z"
  }));
},
    eT = function eT(_ref2693) {
  var _ref2693$color = _ref2693.color,
      C = _ref2693$color === void 0 ? "currentColor" : _ref2693$color,
      _ref2693$size = _ref2693.size,
      e = _ref2693$size === void 0 ? 24 : _ref2693$size,
      l = _ref2693.className,
      i = _objectWithoutProperties(_ref2693, _excluded2693);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM18 12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12H12V6C15.3137 6 18 8.68629 18 12Z"
  }));
},
    tT = function tT(_ref2694) {
  var _ref2694$color = _ref2694.color,
      C = _ref2694$color === void 0 ? "currentColor" : _ref2694$color,
      _ref2694$size = _ref2694.size,
      e = _ref2694$size === void 0 ? 24 : _ref2694$size,
      l = _ref2694.className,
      i = _objectWithoutProperties(_ref2694, _excluded2694);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12ZM20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12ZM17.9998 12C17.9998 15.3137 15.3135 18 11.9998 18C8.68606 18 5.99977 15.3137 5.99977 12H11.9998V6C15.3135 6 17.9998 8.68629 17.9998 12Z"
  }));
},
    CT = function CT(_ref2695) {
  var _ref2695$color = _ref2695.color,
      C = _ref2695$color === void 0 ? "currentColor" : _ref2695$color,
      _ref2695$size = _ref2695.size,
      e = _ref2695$size === void 0 ? 24 : _ref2695$size,
      l = _ref2695.className,
      i = _objectWithoutProperties(_ref2695, _excluded2695);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM18 12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12C6 10.3431 6.67157 8.84315 7.75736 7.75736L12 12V6C15.3137 6 18 8.68629 18 12Z"
  }));
},
    lT = function lT(_ref2696) {
  var _ref2696$color = _ref2696.color,
      C = _ref2696$color === void 0 ? "currentColor" : _ref2696$color,
      _ref2696$size = _ref2696.size,
      e = _ref2696$size === void 0 ? 24 : _ref2696$size,
      l = _ref2696.className,
      i = _objectWithoutProperties(_ref2696, _excluded2696);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12ZM20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12ZM18 12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12C6 10.3431 6.67157 8.84315 7.75736 7.75736L12 12V6C15.3137 6 18 8.68629 18 12Z"
  }));
},
    iT = function iT(_ref2697) {
  var _ref2697$color = _ref2697.color,
      C = _ref2697$color === void 0 ? "currentColor" : _ref2697$color,
      _ref2697$size = _ref2697.size,
      e = _ref2697$size === void 0 ? 24 : _ref2697$size,
      l = _ref2697.className,
      i = _objectWithoutProperties(_ref2697, _excluded2697);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12 18C8.68629 18 6 15.3137 6 12C6 8.68629 8.68629 6 12 6C15.3137 6 18 8.68629 18 12C18 15.3137 15.3137 18 12 18Z"
  }));
},
    sT = function sT(_ref2698) {
  var _ref2698$color = _ref2698.color,
      C = _ref2698$color === void 0 ? "currentColor" : _ref2698$color,
      _ref2698$size = _ref2698.size,
      e = _ref2698$size === void 0 ? 24 : _ref2698$size,
      l = _ref2698.className,
      i = _objectWithoutProperties(_ref2698, _excluded2698);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12ZM20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12ZM12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18Z"
  }));
},
    rT = function rT(_ref2699) {
  var _ref2699$color = _ref2699.color,
      C = _ref2699$color === void 0 ? "currentColor" : _ref2699$color,
      _ref2699$size = _ref2699.size,
      e = _ref2699$size === void 0 ? 24 : _ref2699$size,
      l = _ref2699.className,
      i = _objectWithoutProperties(_ref2699, _excluded2699);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19.1155 20C19.1155 18.9358 19.1155 17.9609 18.9536 15.8812C18.7532 13.7919 17.6654 12.7329 15.8047 12.3608C18.0089 12.0746 19.6406 10.3574 19.6406 7.72423C19.6406 4.20384 17.3219 2 12.6558 2H4V5.66888H11.797C13.8581 5.66888 14.8887 6.55343 14.8887 8.0131C14.8887 9.67314 13.8581 10.3001 11.797 10.3001H4V14.0495H11.568C13.1997 14.0495 14.0871 14.5074 14.2302 16.5682C14.3385 17.9756 14.325 18.6726 14.3119 19.341L14.3119 19.3438C14.3077 19.5579 14.3036 19.7692 14.3036 20L19.1155 20ZM4 17.2046V19.9996H10.1222V18.2108C10.1222 17.8349 9.93768 17.2046 9.08783 17.2046H4Z"
  }));
},
    cT = function cT(_ref2700) {
  var _ref2700$color = _ref2700.color,
      C = _ref2700$color === void 0 ? "currentColor" : _ref2700$color,
      _ref2700$size = _ref2700.size,
      e = _ref2700$size === void 0 ? 24 : _ref2700$size,
      l = _ref2700.className,
      i = _objectWithoutProperties(_ref2700, _excluded2700);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 2H14.5C17.8137 2 20.5 4.68629 20.5 8C20.5 10.1984 19.3177 12.1206 17.5543 13.1655C19.0376 14.2579 20 16.0166 20 18V21H18V18C18 15.7909 16.2091 14 14 14H4V12H14.5C16.7091 12 18.5 10.2091 18.5 8C18.5 5.79086 16.7091 4 14.5 4H4V2ZM11 21H4V19H11V21Z"
  }));
},
    oT = function oT(_ref2701) {
  var _ref2701$color = _ref2701.color,
      C = _ref2701$color === void 0 ? "currentColor" : _ref2701$color,
      _ref2701$size = _ref2701.size,
      e = _ref2701$size === void 0 ? 24 : _ref2701$size,
      l = _ref2701.className,
      i = _objectWithoutProperties(_ref2701, _excluded2701);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 5V2H10V5H4C3.44772 5 3 5.44772 3 6V14C3 14.5523 3.44772 15 4 15H17.4142L21.7071 10.7071C22.0976 10.3166 22.0976 9.68342 21.7071 9.29289L17.4142 5H12ZM12 17H10V22H12V17Z"
  }));
},
    aT = function aT(_ref2702) {
  var _ref2702$color = _ref2702.color,
      C = _ref2702$color === void 0 ? "currentColor" : _ref2702$color,
      _ref2702$size = _ref2702.size,
      e = _ref2702$size === void 0 ? 24 : _ref2702$size,
      l = _ref2702.className,
      i = _objectWithoutProperties(_ref2702, _excluded2702);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 5H17.4142L21.7071 9.29289C22.0976 9.68342 22.0976 10.3166 21.7071 10.7071L17.4142 15H12V22H10V15H4C3.44772 15 3 14.5523 3 14V6C3 5.44772 3.44772 5 4 5H10V2H12V5ZM16.5858 13L19.5858 10L16.5858 7H5V13H16.5858Z"
  }));
},
    nT = function nT(_ref2703) {
  var _ref2703$color = _ref2703.color,
      C = _ref2703$color === void 0 ? "currentColor" : _ref2703$color,
      _ref2703$size = _ref2703.size,
      e = _ref2703$size === void 0 ? 24 : _ref2703$size,
      l = _ref2703.className,
      i = _objectWithoutProperties(_ref2703, _excluded2703);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 2C17.0778 2 21.2717 5.7847 21.9146 10.6871C20.5585 9.62985 18.8528 9 17 9C12.5817 9 9 12.5817 9 17C9 18.8528 9.62985 20.5585 10.6871 21.9146C5.7847 21.2717 2 17.0778 2 12C2 6.47715 6.47715 2 12 2ZM12 3.83333C9.68259 3.83333 7.59062 4.79858 6.1042 6.34896C6.28116 6.47186 6.43537 6.64453 6.54129 6.88256C6.74529 7.34029 6.74529 7.8112 6.74529 8.22764C6.74488 8.55598 6.74449 8.86735 6.84992 9.09302C6.99443 9.40134 7.6164 9.53227 8.16548 9.64736L8.18515 9.6515C8.37513 9.69149 8.57011 9.73254 8.74797 9.78176C9.25405 9.92233 9.64554 10.3765 9.95938 10.7412C10.0896 10.8931 10.2819 11.1163 10.3783 11.1717C10.4286 11.1356 10.59 10.9608 10.6699 10.6735C10.7307 10.4547 10.7134 10.2597 10.6239 10.1543C10.0648 9.49445 10.0952 8.2232 10.268 7.75495C10.5402 7.01606 11.3905 7.07058 12.012 7.11097L12.0178 7.11135C12.2474 7.12612 12.464 7.14006 12.6257 7.11976C13.097 7.06062 13.3212 6.50376 13.4611 6.15632C13.5059 6.0449 13.5421 5.95502 13.575 5.91C13.8671 5.50981 14.7607 4.9071 15.3158 4.53454C14.3025 4.08382 13.1805 3.83333 12 3.83333ZM23 17C23 20.3137 20.3137 23 17 23C13.6863 23 11 20.3137 11 17C11 13.6863 13.6863 11 17 11C20.3137 11 23 13.6863 23 17ZM16 18H20V16H18V14H16V18Z"
  }));
},
    mT = function mT(_ref2704) {
  var _ref2704$color = _ref2704.color,
      C = _ref2704$color === void 0 ? "currentColor" : _ref2704$color,
      _ref2704$size = _ref2704.size,
      e = _ref2704$size === void 0 ? 24 : _ref2704$size,
      l = _ref2704.className,
      i = _objectWithoutProperties(_ref2704, _excluded2704);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 12C4 9.84636 4.85101 7.89148 6.23509 6.45329C6.35689 6.56446 6.46246 6.70541 6.54129 6.88256C6.74529 7.34029 6.74529 7.8112 6.74529 8.22764C6.74488 8.55598 6.74449 8.86735 6.84992 9.09302C6.99443 9.40134 7.6164 9.53227 8.16548 9.64736L8.18515 9.6515C8.37513 9.69149 8.57011 9.73254 8.74797 9.78176C9.25405 9.92233 9.64554 10.3765 9.95938 10.7412C10.0896 10.8931 10.2819 11.1163 10.3783 11.1717C10.4286 11.1356 10.59 10.9608 10.6699 10.6735C10.7307 10.4547 10.7134 10.2597 10.6239 10.1543C10.0648 9.49445 10.0952 8.2232 10.268 7.75495C10.5402 7.01606 11.3905 7.07058 12.012 7.11097L12.0178 7.11135C12.2474 7.12612 12.464 7.14006 12.6257 7.11976C13.097 7.06062 13.3212 6.50376 13.4611 6.15632C13.5059 6.0449 13.5421 5.95502 13.575 5.91C13.8398 5.54726 14.5987 5.01813 15.1519 4.64482C17.2241 5.53398 18.8451 7.27325 19.5762 9.42384C20.4295 9.71393 21.2182 10.1442 21.9146 10.6871C21.2717 5.7847 17.0778 2 12 2C6.47715 2 2 6.47715 2 12C2 17.0778 5.7847 21.2717 10.6871 21.9146C10.1442 21.2182 9.71393 20.4295 9.42384 19.5762C6.26947 18.5039 4 15.517 4 12ZM17 13C14.7909 13 13 14.7909 13 17C13 19.2091 14.7909 21 17 21C19.2091 21 21 19.2091 21 17C21 14.7909 19.2091 13 17 13ZM11 17C11 13.6863 13.6863 11 17 11C20.3137 11 23 13.6863 23 17C23 20.3137 20.3137 23 17 23C13.6863 23 11 20.3137 11 17ZM16 14V18H20V16H18V14H16Z"
  }));
},
    wT = function wT(_ref2705) {
  var _ref2705$color = _ref2705.color,
      C = _ref2705$color === void 0 ? "currentColor" : _ref2705$color,
      _ref2705$size = _ref2705.size,
      e = _ref2705$size === void 0 ? 24 : _ref2705$size,
      l = _ref2705.className,
      i = _objectWithoutProperties(_ref2705, _excluded2705);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 15.6315L20.9679 10.8838L20.0321 9.11619L12 13.3685L3.9679 9.11619L3.03212 10.8838L12 15.6315Z"
  }));
},
    LT = function LT(_ref2706) {
  var _ref2706$color = _ref2706.color,
      C = _ref2706$color === void 0 ? "currentColor" : _ref2706$color,
      _ref2706$size = _ref2706.size,
      e = _ref2706$size === void 0 ? 24 : _ref2706$size,
      l = _ref2706.className,
      i = _objectWithoutProperties(_ref2706, _excluded2706);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 15.6315L20.9679 10.8838L20.0321 9.11619L12 13.3685L3.9679 9.11619L3.03212 10.8838L12 15.6315Z"
  }));
},
    hT = function hT(_ref2707) {
  var _ref2707$color = _ref2707.color,
      C = _ref2707$color === void 0 ? "currentColor" : _ref2707$color,
      _ref2707$size = _ref2707.size,
      e = _ref2707$size === void 0 ? 24 : _ref2707$size,
      l = _ref2707.className,
      i = _objectWithoutProperties(_ref2707, _excluded2707);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8.3685 12L13.1162 3.03212L14.8838 3.9679L10.6315 12L14.8838 20.0321L13.1162 20.9679L8.3685 12Z"
  }));
},
    HT = function HT(_ref2708) {
  var _ref2708$color = _ref2708.color,
      C = _ref2708$color === void 0 ? "currentColor" : _ref2708$color,
      _ref2708$size = _ref2708.size,
      e = _ref2708$size === void 0 ? 24 : _ref2708$size,
      l = _ref2708.className,
      i = _objectWithoutProperties(_ref2708, _excluded2708);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8.3685 12L13.1162 3.03212L14.8838 3.9679L10.6315 12L14.8838 20.0321L13.1162 20.9679L8.3685 12Z"
  }));
},
    VT = function VT(_ref2709) {
  var _ref2709$color = _ref2709.color,
      C = _ref2709$color === void 0 ? "currentColor" : _ref2709$color,
      _ref2709$size = _ref2709.size,
      e = _ref2709$size === void 0 ? 24 : _ref2709$size,
      l = _ref2709.className,
      i = _objectWithoutProperties(_ref2709, _excluded2709);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15.6315 12L10.8838 3.03212L9.11622 3.9679L13.3685 12L9.11622 20.0321L10.8838 20.9679L15.6315 12Z"
  }));
},
    gT = function gT(_ref2710) {
  var _ref2710$color = _ref2710.color,
      C = _ref2710$color === void 0 ? "currentColor" : _ref2710$color,
      _ref2710$size = _ref2710.size,
      e = _ref2710$size === void 0 ? 24 : _ref2710$size,
      l = _ref2710.className,
      i = _objectWithoutProperties(_ref2710, _excluded2710);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15.6315 12L10.8838 3.03212L9.11622 3.9679L13.3685 12L9.11622 20.0321L10.8838 20.9679L15.6315 12Z"
  }));
},
    MT = function MT(_ref2711) {
  var _ref2711$color = _ref2711.color,
      C = _ref2711$color === void 0 ? "currentColor" : _ref2711$color,
      _ref2711$size = _ref2711.size,
      e = _ref2711$size === void 0 ? 24 : _ref2711$size,
      l = _ref2711.className,
      i = _objectWithoutProperties(_ref2711, _excluded2711);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 8.36853L20.9679 13.1162L20.0321 14.8838L12 10.6315L3.96789 14.8838L3.03211 13.1162L12 8.36853Z"
  }));
},
    ZT = function ZT(_ref2712) {
  var _ref2712$color = _ref2712.color,
      C = _ref2712$color === void 0 ? "currentColor" : _ref2712$color,
      _ref2712$size = _ref2712.size,
      e = _ref2712$size === void 0 ? 24 : _ref2712$size,
      l = _ref2712.className,
      i = _objectWithoutProperties(_ref2712, _excluded2712);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 8.36853L20.9679 13.1162L20.0321 14.8838L12 10.6315L3.96789 14.8838L3.03211 13.1162L12 8.36853Z"
  }));
},
    xT = function xT(_ref2713) {
  var _ref2713$color = _ref2713.color,
      C = _ref2713$color === void 0 ? "currentColor" : _ref2713$color,
      _ref2713$size = _ref2713.size,
      e = _ref2713$size === void 0 ? 24 : _ref2713$size,
      l = _ref2713.className,
      i = _objectWithoutProperties(_ref2713, _excluded2713);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 11.3884C11.0942 9.62673 8.62833 6.34423 6.335 4.7259C4.13833 3.17506 3.30083 3.4434 2.75167 3.69256C2.11583 3.9784 2 4.95506 2 5.52839C2 6.10339 2.315 10.2367 2.52 10.9276C3.19917 13.2076 5.61417 13.9776 7.83917 13.7309C4.57917 14.2142 1.68333 15.4017 5.48083 19.6292C9.65833 23.9542 11.2058 18.7017 12 16.0392C12.7942 18.7017 13.7083 23.7651 18.4442 19.6292C22 16.0392 19.4208 14.2142 16.1608 13.7309C18.3858 13.9784 20.8008 13.2076 21.48 10.9276C21.685 10.2376 22 6.10256 22 5.52923C22 4.95423 21.8842 3.97839 21.2483 3.6909C20.6992 3.44256 19.8617 3.17423 17.665 4.72423C15.3717 6.34506 12.9058 9.62756 12 11.3884Z"
  }));
},
    vT = function vT(_ref2714) {
  var _ref2714$color = _ref2714.color,
      C = _ref2714$color === void 0 ? "currentColor" : _ref2714$color,
      _ref2714$size = _ref2714.size,
      e = _ref2714$size === void 0 ? 24 : _ref2714$size,
      l = _ref2714.className,
      i = _objectWithoutProperties(_ref2714, _excluded2714);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4.90727 3.43929C5.61594 3.56009 6.44016 3.94139 7.48302 4.68685C9.27977 5.97119 10.7687 7.73907 12 9.56361C13.2313 7.73907 14.7202 5.97119 16.517 4.68685C17.5598 3.94139 18.3841 3.56009 19.0927 3.43929C19.8605 3.3084 20.3825 3.50358 20.7082 3.63931C21.7166 4.05956 22 5.22508 22 6.21461C22 6.41649 21.9144 7.5166 21.8148 8.57508C21.7634 9.12088 21.7057 9.68306 21.6486 10.1515C21.5963 10.5804 21.5337 11.0321 21.4587 11.2849C21.1161 12.4395 20.3965 13.2618 19.508 13.8021C20.4453 14.5092 20.7854 15.6583 20.4359 16.7856C19.8393 18.71 17.6991 21.1833 15.6005 21.4037C13.8281 21.5898 12.6662 20.0794 12 18.6449C11.3338 20.0794 10.1719 21.5898 8.39954 21.4037C6.30095 21.1833 4.1607 18.71 3.56408 16.7856C3.21457 15.6583 3.55466 14.5092 4.49197 13.8021C3.60345 13.2618 2.88394 12.4395 2.54132 11.2849C2.46631 11.0321 2.40367 10.5804 2.35139 10.1515C2.29429 9.68306 2.23658 9.12088 2.18521 8.57508C2.08559 7.5166 2 6.41649 2 6.21461C2 5.22508 2.28343 4.05956 3.29182 3.63931C3.61753 3.50358 4.13949 3.3084 4.90727 3.43929ZM4.04911 6.91709C4.11331 7.73486 4.22889 9.02507 4.33669 9.90947C4.36927 10.1767 4.39214 10.4536 4.45863 10.7156C4.85637 12.056 6.38779 12.7978 8.14506 12.603C8.68686 12.5429 9.17695 12.9278 9.24697 13.4684C9.31698 14.009 8.94113 14.5061 8.40191 14.586C7.64608 14.6981 5.08656 14.9425 5.47438 16.1934C5.8312 17.3443 7.32212 19.2796 8.60842 19.4146C9.53606 19.5121 10.1084 18.0211 10.3741 17.3697C10.6489 16.6958 10.8622 15.9903 11.0417 15.3885C11.1681 14.9648 11.5578 14.6744 12 14.6744C12.4422 14.6744 12.8319 14.9648 12.9583 15.3885C13.1378 15.9903 13.3511 16.6958 13.6259 17.3697C13.8916 18.0211 14.4639 19.5121 15.3916 19.4146C16.6779 19.2796 18.1688 17.3443 18.5256 16.1934C18.9134 14.9425 16.3539 14.6981 15.5981 14.586C15.0589 14.5061 14.683 14.009 14.753 13.4684C14.8231 12.9278 15.3131 12.5429 15.8549 12.603C17.6122 12.7978 19.1436 12.0563 19.5413 10.7159C19.61 10.45 19.63 10.18 19.6633 9.90948C19.7711 9.02507 19.8867 7.73486 19.9509 6.91709C19.9876 6.44922 20.1985 5.27964 19.4288 5.41084C19.1429 5.45959 18.6059 5.65205 17.68 6.31391C15.7374 7.70252 13.9749 9.82666 12.891 11.954C12.7203 12.289 12.376 12.5 12 12.5C11.624 12.5 11.2797 12.289 11.109 11.954C10.0251 9.82666 8.26258 7.70252 6.31998 6.31391C5.39406 5.65205 4.85713 5.45959 4.57117 5.41084C3.7874 5.27724 4.01205 6.44504 4.04911 6.91709Z"
  }));
},
    dT = function dT(_ref2715) {
  var _ref2715$color = _ref2715.color,
      C = _ref2715$color === void 0 ? "currentColor" : _ref2715$color,
      _ref2715$size = _ref2715.size,
      e = _ref2715$size === void 0 ? 24 : _ref2715$size,
      l = _ref2715.className,
      i = _objectWithoutProperties(_ref2715, _excluded2715);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18 2H6V4H18V2ZM16.9497 9.44975L12 4.5L7.05273 9.44727L11 9.44826V14.5501L7.05078 14.55L12.0005 19.5L16.9502 14.5503L13 14.5502V9.44876L16.9497 9.44975ZM18 20V22H6V20H18Z"
  }));
},
    pT = function pT(_ref2716) {
  var _ref2716$color = _ref2716.color,
      C = _ref2716$color === void 0 ? "currentColor" : _ref2716$color,
      _ref2716$size = _ref2716.size,
      e = _ref2716$size === void 0 ? 24 : _ref2716$size,
      l = _ref2716.className,
      i = _objectWithoutProperties(_ref2716, _excluded2716);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6 2H18V4H6V2ZM16.9497 9.44975L12 4.5L7.05273 9.44727L8.46695 10.8615L11 8.32843V15.6706L8.46499 13.1356L7.05078 14.5498L12 19.5L16.9497 14.5503L15.5355 13.136L13 15.6716V8.32843L15.5355 10.864L16.9497 9.44975ZM18 20V22H6V20H18Z"
  }));
},
    ET = function ET(_ref2717) {
  var _ref2717$color = _ref2717.color,
      C = _ref2717$color === void 0 ? "currentColor" : _ref2717$color,
      _ref2717$size = _ref2717.size,
      e = _ref2717$size === void 0 ? 24 : _ref2717$size,
      l = _ref2717.className,
      i = _objectWithoutProperties(_ref2717, _excluded2717);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 6L2 18H4L4 6H2ZM9.44975 7.05025L4.5 12L9.44727 16.9473L9.44826 13H14.5501L14.55 16.9492L19.5 11.9995L14.5503 7.04976L14.5502 11H9.44876L9.44975 7.05025ZM20 6H22V18H20V6Z"
  }));
},
    NT = function NT(_ref2718) {
  var _ref2718$color = _ref2718.color,
      C = _ref2718$color === void 0 ? "currentColor" : _ref2718$color,
      _ref2718$size = _ref2718.size,
      e = _ref2718$size === void 0 ? 24 : _ref2718$size,
      l = _ref2718.className,
      i = _objectWithoutProperties(_ref2718, _excluded2718);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 18L2 6H4L4 18H2ZM9.44975 7.05025L4.5 12L9.44727 16.9473L10.8615 15.5331L8.32843 13H15.6708L13.1358 15.535L14.55 16.9492L19.5 11.9995L14.5503 7.04976L13.136 8.46398L15.6721 11H8.32843L10.864 8.46447L9.44975 7.05025ZM20 6H22V18H20V6Z"
  }));
},
    uT = function uT(_ref2719) {
  var _ref2719$color = _ref2719.color,
      C = _ref2719$color === void 0 ? "currentColor" : _ref2719$color,
      _ref2719$size = _ref2719.size,
      e = _ref2719$size === void 0 ? 24 : _ref2719$size,
      l = _ref2719.className,
      i = _objectWithoutProperties(_ref2719, _excluded2719);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22 4C21.4477 4 21 4.44772 21 5V10.6665L11.7774 4.51806C11.6952 4.4633 11.5987 4.43408 11.5 4.43408C11.2239 4.43408 11 4.65794 11 4.93408V10.6665L1.77735 4.51806C1.69522 4.4633 1.59871 4.43408 1.5 4.43408C1.22386 4.43408 1 4.65794 1 4.93408V19.0656C1 19.1643 1.02922 19.2608 1.08397 19.3429C1.23715 19.5727 1.54759 19.6348 1.77735 19.4816L11 13.3332V19.0656C11 19.1643 11.0292 19.2608 11.084 19.3429C11.2372 19.5727 11.5476 19.6348 11.7774 19.4816L21 13.3332V19C21 19.5523 21.4477 20 22 20C22.5523 20 23 19.5523 23 19V5C23 4.44772 22.5523 4 22 4Z"
  }));
},
    BT = function BT(_ref2720) {
  var _ref2720$color = _ref2720.color,
      C = _ref2720$color === void 0 ? "currentColor" : _ref2720$color,
      _ref2720$size = _ref2720.size,
      e = _ref2720$size === void 0 ? 24 : _ref2720$size,
      l = _ref2720.className,
      i = _objectWithoutProperties(_ref2720, _excluded2720);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22 4C21.4477 4 21 4.44772 21 5V10.6665L11.7774 4.51806C11.6952 4.4633 11.5987 4.43408 11.5 4.43408C11.2239 4.43408 11 4.65794 11 4.93408V10.6665L1.77735 4.51806C1.69522 4.4633 1.59871 4.43408 1.5 4.43408C1.22386 4.43408 1 4.65794 1 4.93408V19.0656C1 19.1643 1.02922 19.2608 1.08397 19.3429C1.23715 19.5727 1.54759 19.6348 1.77735 19.4816L11 13.3332V19.0656C11 19.1643 11.0292 19.2608 11.084 19.3429C11.2372 19.5727 11.5476 19.6348 11.7774 19.4816L21 13.3332V19C21 19.5523 21.4477 20 22 20C22.5523 20 23 19.5523 23 19V5C23 4.44772 22.5523 4 22 4ZM3 7.73686L9.39445 11.9998L3 16.2628V7.73686ZM13 16.2628V7.73686L19.3944 11.9998L13 16.2628Z"
  }));
},
    fT = function fT(_ref2721) {
  var _ref2721$color = _ref2721.color,
      C = _ref2721$color === void 0 ? "currentColor" : _ref2721$color,
      _ref2721$size = _ref2721.size,
      e = _ref2721$size === void 0 ? 24 : _ref2721$size,
      l = _ref2721.className,
      i = _objectWithoutProperties(_ref2721, _excluded2721);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 6C20.4477 6 20 6.44771 20 7V17C20 17.5523 20.4477 18 21 18C21.5523 18 22 17.5523 22 17V7C22 6.44772 21.5523 6 21 6ZM2.5 17.535C2.60326 17.535 2.70398 17.503 2.78834 17.4434L9.92131 12.4084C10.1469 12.2492 10.2007 11.9372 10.0415 11.7116C10.0086 11.665 9.96792 11.6243 9.92131 11.5914L2.78834 6.5564C2.56274 6.39715 2.25076 6.45094 2.09152 6.67654C2.03197 6.7609 2 6.86163 2 6.96488V17.035C2 17.3111 2.22386 17.535 2.5 17.535ZM11.0915 6.67654C11.032 6.7609 11 6.86163 11 6.96488V17.035C11 17.3111 11.2239 17.535 11.5 17.535C11.6033 17.535 11.704 17.503 11.7883 17.4434L18.9213 12.4084C19.1469 12.2492 19.2007 11.9372 19.0415 11.7116C19.0086 11.665 18.9679 11.6243 18.9213 11.5914L11.7883 6.5564C11.5627 6.39715 11.2508 6.45094 11.0915 6.67654Z"
  }));
},
    RT = function RT(_ref2722) {
  var _ref2722$color = _ref2722.color,
      C = _ref2722$color === void 0 ? "currentColor" : _ref2722$color,
      _ref2722$size = _ref2722.size,
      e = _ref2722$size === void 0 ? 24 : _ref2722$size,
      l = _ref2722.className,
      i = _objectWithoutProperties(_ref2722, _excluded2722);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 6C20.4477 6 20 6.44771 20 7V17C20 17.5523 20.4477 18 21 18C21.5523 18 22 17.5523 22 17V7C22 6.44772 21.5523 6 21 6ZM4 9.85977L7.03189 11.9999L4 14.1401V9.85977ZM2.5 17.535C2.60326 17.535 2.70398 17.503 2.78834 17.4434L9.92131 12.4084C10.1469 12.2492 10.2007 11.9372 10.0415 11.7116C10.0086 11.665 9.96792 11.6243 9.92131 11.5914L2.78834 6.5564C2.56274 6.39715 2.25076 6.45094 2.09152 6.67654C2.03197 6.7609 2 6.86163 2 6.96488V17.035C2 17.3111 2.22386 17.535 2.5 17.535ZM16.0319 11.9999L13 14.1401V9.85977L16.0319 11.9999ZM11.0915 6.67654C11.032 6.7609 11 6.86163 11 6.96488V17.035C11 17.3111 11.2239 17.535 11.5 17.535C11.6033 17.535 11.704 17.503 11.7883 17.4434L18.9213 12.4084C19.1469 12.2492 19.2007 11.9372 19.0415 11.7116C19.0086 11.665 18.9679 11.6243 18.9213 11.5914L11.7883 6.5564C11.5627 6.39715 11.2508 6.45094 11.0915 6.67654Z"
  }));
},
    zT = function zT(_ref2723) {
  var _ref2723$color = _ref2723.color,
      C = _ref2723$color === void 0 ? "currentColor" : _ref2723$color,
      _ref2723$size = _ref2723.size,
      e = _ref2723$size === void 0 ? 24 : _ref2723$size,
      l = _ref2723.className,
      i = _objectWithoutProperties(_ref2723, _excluded2723);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15 3V7.5H9V11.5H15V16.5H9V21H18C19.6569 21 21 19.6569 21 18V6C21 4.34315 19.6569 3 18 3H15ZM2 6C2 3.79086 3.79086 2 6 2H18C20.2091 2 22 3.79086 22 6V18C22 20.2091 20.2091 22 18 22H6C3.79086 22 2 20.2091 2 18V6Z"
  }));
},
    FT = function FT(_ref2724) {
  var _ref2724$color = _ref2724.color,
      C = _ref2724$color === void 0 ? "currentColor" : _ref2724$color,
      _ref2724$size = _ref2724.size,
      e = _ref2724$size === void 0 ? 24 : _ref2724$size,
      l = _ref2724.className,
      i = _objectWithoutProperties(_ref2724, _excluded2724);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16 4V9H10V11H16V17H10V20H18C19.1046 20 20 19.1046 20 18V6C20 4.89543 19.1046 4 18 4H16ZM14 4H6C4.89543 4 4 4.89543 4 6V18C4 19.1046 4.89543 20 6 20H8V15H14V13H8V7H14V4ZM2 6C2 3.79086 3.79086 2 6 2H18C20.2091 2 22 3.79086 22 6V18C22 20.2091 20.2091 22 18 22H6C3.79086 22 2 20.2091 2 18V6Z"
  }));
},
    ST = function ST(_ref2725) {
  var _ref2725$color = _ref2725.color,
      C = _ref2725$color === void 0 ? "currentColor" : _ref2725$color,
      _ref2725$size = _ref2725.size,
      e = _ref2725$size === void 0 ? 24 : _ref2725$size,
      l = _ref2725.className,
      i = _objectWithoutProperties(_ref2725, _excluded2725);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7 8.82929C8.16519 8.41746 9 7.30622 9 6C9 4.34315 7.65685 3 6 3C4.34315 3 3 4.34315 3 6C3 7.30622 3.83481 8.41746 5 8.82929V15.1707C3.83481 15.5825 3 16.6938 3 18C3 19.6569 4.34315 21 6 21C7.65685 21 9 19.6569 9 18C9 16.6938 8.16519 15.5825 7 15.1707V8.82929ZM21 18C21 19.6569 19.6569 21 18 21C16.3431 21 15 19.6569 15 18C15 16.3431 16.3431 15 18 15C19.6569 15 21 16.3431 21 18ZM18 7.5C18.8284 7.5 19.5 6.82843 19.5 6C19.5 5.17157 18.8284 4.5 18 4.5C17.1716 4.5 16.5 5.17157 16.5 6C16.5 6.82843 17.1716 7.5 18 7.5ZM19.5 11.5C19.5 12.3284 18.8284 13 18 13C17.1716 13 16.5 12.3284 16.5 11.5C16.5 10.6716 17.1716 10 18 10C18.8284 10 19.5 10.6716 19.5 11.5Z"
  }));
},
    AT = function AT(_ref2726) {
  var _ref2726$color = _ref2726.color,
      C = _ref2726$color === void 0 ? "currentColor" : _ref2726$color,
      _ref2726$size = _ref2726.size,
      e = _ref2726$size === void 0 ? 24 : _ref2726$size,
      l = _ref2726.className,
      i = _objectWithoutProperties(_ref2726, _excluded2726);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5 6C5 5.44772 5.44772 5 6 5C6.55228 5 7 5.44772 7 6C7 6.55228 6.55228 7 6 7C5.44772 7 5 6.55228 5 6ZM6 3C4.34315 3 3 4.34315 3 6C3 7.30622 3.83481 8.41746 5 8.82929V15.1707C3.83481 15.5825 3 16.6938 3 18C3 19.6569 4.34315 21 6 21C7.65685 21 9 19.6569 9 18C9 16.6938 8.16519 15.5825 7 15.1707V8.82929C8.16519 8.41746 9 7.30622 9 6C9 4.34315 7.65685 3 6 3ZM5 18C5 17.4477 5.44772 17 6 17C6.55228 17 7 17.4477 7 18C7 18.5523 6.55228 19 6 19C5.44772 19 5 18.5523 5 18ZM18 17C17.4477 17 17 17.4477 17 18C17 18.5523 17.4477 19 18 19C18.5523 19 19 18.5523 19 18C19 17.4477 18.5523 17 18 17ZM15 18C15 16.3431 16.3431 15 18 15C19.6569 15 21 16.3431 21 18C21 19.6569 19.6569 21 18 21C16.3431 21 15 19.6569 15 18ZM18 7.5C18.8284 7.5 19.5 6.82843 19.5 6C19.5 5.17157 18.8284 4.5 18 4.5C17.1716 4.5 16.5 5.17157 16.5 6C16.5 6.82843 17.1716 7.5 18 7.5ZM19.5 11.5C19.5 12.3284 18.8284 13 18 13C17.1716 13 16.5 12.3284 16.5 11.5C16.5 10.6716 17.1716 10 18 10C18.8284 10 19.5 10.6716 19.5 11.5Z"
  }));
},
    kT = function kT(_ref2727) {
  var _ref2727$color = _ref2727.color,
      C = _ref2727$color === void 0 ? "currentColor" : _ref2727$color,
      _ref2727$size = _ref2727.size,
      e = _ref2727$size === void 0 ? 24 : _ref2727$size,
      l = _ref2727.className,
      i = _objectWithoutProperties(_ref2727, _excluded2727);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4.62407 12.4161L15.2227 19.4818C15.4524 19.635 15.7629 19.5729 15.9161 19.3432C15.9708 19.261 16 19.1645 16 19.0658V4.93433C16 4.65818 15.7762 4.43433 15.5 4.43433C15.4013 4.43433 15.3048 4.46355 15.2227 4.5183L4.62407 11.584C4.39431 11.7372 4.33222 12.0477 4.4854 12.2774C4.52201 12.3323 4.56914 12.3795 4.62407 12.4161Z"
  }));
},
    PT = function PT(_ref2728) {
  var _ref2728$color = _ref2728.color,
      C = _ref2728$color === void 0 ? "currentColor" : _ref2728$color,
      _ref2728$size = _ref2728.size,
      e = _ref2728$size === void 0 ? 24 : _ref2728$size,
      l = _ref2728.className,
      i = _objectWithoutProperties(_ref2728, _excluded2728);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7.60558 12.0001L14 7.7371V16.263L7.60558 12.0001ZM4.62407 12.4161L15.2227 19.4818C15.4524 19.635 15.7629 19.5729 15.9161 19.3432C15.9708 19.261 16 19.1645 16 19.0658V4.93433C16 4.65818 15.7762 4.43433 15.5 4.43433C15.4013 4.43433 15.3048 4.46355 15.2227 4.5183L4.62407 11.584C4.39431 11.7372 4.33222 12.0477 4.4854 12.2774C4.52201 12.3323 4.56914 12.3795 4.62407 12.4161Z"
  }));
},
    DT = function DT(_ref2729) {
  var _ref2729$color = _ref2729.color,
      C = _ref2729$color === void 0 ? "currentColor" : _ref2729$color,
      _ref2729$size = _ref2729.size,
      e = _ref2729$size === void 0 ? 24 : _ref2729$size,
      l = _ref2729.className,
      i = _objectWithoutProperties(_ref2729, _excluded2729);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16.248 5.43872L5.74033 11.5682C5.50181 11.7073 5.42124 12.0135 5.56038 12.252C5.60384 12.3265 5.66583 12.3885 5.74033 12.432L16.248 18.5615C16.4865 18.7006 16.7927 18.62 16.9318 18.3815C16.9764 18.305 17 18.2181 17 18.1296V5.87061C17 5.59446 16.7761 5.37061 16.5 5.37061C16.4114 5.37061 16.3245 5.39411 16.248 5.43872Z"
  }));
},
    yT = function yT(_ref2730) {
  var _ref2730$color = _ref2730.color,
      C = _ref2730$color === void 0 ? "currentColor" : _ref2730$color,
      _ref2730$size = _ref2730.size,
      e = _ref2730$size === void 0 ? 24 : _ref2730$size,
      l = _ref2730.className,
      i = _objectWithoutProperties(_ref2730, _excluded2730);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15 8.48216V15.518L8.96922 12.0001L15 8.48216ZM16.248 5.43872L5.74033 11.5682C5.50181 11.7073 5.42124 12.0135 5.56038 12.252C5.60384 12.3265 5.66583 12.3885 5.74033 12.432L16.248 18.5615C16.4865 18.7006 16.7927 18.62 16.9318 18.3815C16.9764 18.305 17 18.2181 17 18.1296V5.87061C17 5.59446 16.7761 5.37061 16.5 5.37061C16.4114 5.37061 16.3245 5.39411 16.248 5.43872Z"
  }));
},
    bT = function bT(_ref2731) {
  var _ref2731$color = _ref2731.color,
      C = _ref2731$color === void 0 ? "currentColor" : _ref2731$color,
      _ref2731$size = _ref2731.size,
      e = _ref2731$size === void 0 ? 24 : _ref2731$size,
      l = _ref2731.className,
      i = _objectWithoutProperties(_ref2731, _excluded2731);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 4C1.44772 4 1 4.44772 1 5V19C1 19.5523 1.44772 20 2 20C2.55228 20 3 19.5523 3 19V13.3332L12.2227 19.4816C12.3048 19.5364 12.4013 19.5656 12.5 19.5656C12.7762 19.5656 13 19.3418 13 19.0656V13.3332L22.2227 19.4816C22.3048 19.5364 22.4013 19.5656 22.5 19.5656C22.7762 19.5656 23 19.3418 23 19.0656V4.93413C23 4.83542 22.9708 4.73892 22.9161 4.65679C22.7629 4.42702 22.4524 4.36493 22.2227 4.51811L13 10.6665V4.93413C13 4.83542 12.9708 4.73892 12.9161 4.65679C12.7629 4.42702 12.4524 4.36493 12.2227 4.51811L3 10.6666V5C3 4.44772 2.55228 4 2 4Z"
  }));
},
    TT = function TT(_ref2732) {
  var _ref2732$color = _ref2732.color,
      C = _ref2732$color === void 0 ? "currentColor" : _ref2732$color,
      _ref2732$size = _ref2732.size,
      e = _ref2732$size === void 0 ? 24 : _ref2732$size,
      l = _ref2732.className,
      i = _objectWithoutProperties(_ref2732, _excluded2732);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 4C1.44772 4 1 4.44772 1 5V19C1 19.5523 1.44772 20 2 20C2.55228 20 3 19.5523 3 19V13.3332L12.2227 19.4816C12.3048 19.5364 12.4013 19.5656 12.5 19.5656C12.7762 19.5656 13 19.3418 13 19.0656V13.3332L22.2227 19.4816C22.3048 19.5364 22.4013 19.5656 22.5 19.5656C22.7762 19.5656 23 19.3418 23 19.0656V4.93413C23 4.83542 22.9708 4.73892 22.9161 4.65679C22.7629 4.42702 22.4524 4.36493 22.2227 4.51811L13 10.6665V4.93413C13 4.83542 12.9708 4.73892 12.9161 4.65679C12.7629 4.42702 12.4524 4.36493 12.2227 4.51811L3 10.6666V5C3 4.44772 2.55228 4 2 4ZM11 7.73691V16.2628L4.60558 11.9999L11 7.73691ZM21 7.73691V16.2628L14.6056 11.9999L21 7.73691Z"
  }));
},
    UT = function UT(_ref2733) {
  var _ref2733$color = _ref2733.color,
      C = _ref2733$color === void 0 ? "currentColor" : _ref2733$color,
      _ref2733$size = _ref2733.size,
      e = _ref2733$size === void 0 ? 24 : _ref2733$size,
      l = _ref2733.className,
      i = _objectWithoutProperties(_ref2733, _excluded2733);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 6C2.44772 6 2 6.44771 2 7V17C2 17.5523 2.44772 18 3 18C3.55228 18 4 17.5523 4 17V7C4 6.44772 3.55228 6 3 6ZM12.9087 17.3233C12.9682 17.2389 13.0002 17.1382 13.0002 17.0349V6.96484C13.0002 6.6887 12.7763 6.46484 12.5002 6.46484C12.3969 6.46484 12.2962 6.49681 12.2119 6.55636L5.07889 11.5914C4.85329 11.7506 4.7995 12.0626 4.95874 12.2882C4.99164 12.3348 5.03228 12.3755 5.07889 12.4084L12.2119 17.4434C12.4375 17.6027 12.7494 17.5489 12.9087 17.3233ZM13.9587 12.2882C13.9916 12.3348 14.0323 12.3755 14.0789 12.4084L21.2119 17.4434C21.4375 17.6027 21.7494 17.5489 21.9087 17.3233C21.9682 17.2389 22.0002 17.1382 22.0002 17.0349V6.96484C22.0002 6.6887 21.7763 6.46484 21.5002 6.46484C21.3969 6.46484 21.2962 6.49681 21.2119 6.55636L14.0789 11.5914C13.8533 11.7506 13.7995 12.0626 13.9587 12.2882Z"
  }));
},
    GT = function GT(_ref2734) {
  var _ref2734$color = _ref2734.color,
      C = _ref2734$color === void 0 ? "currentColor" : _ref2734$color,
      _ref2734$size = _ref2734.size,
      e = _ref2734$size === void 0 ? 24 : _ref2734$size,
      l = _ref2734.className,
      i = _objectWithoutProperties(_ref2734, _excluded2734);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 6C2.44772 6 2 6.44771 2 7V17C2 17.5523 2.44772 18 3 18C3.55228 18 4 17.5523 4 17V7C4 6.44772 3.55228 6 3 6ZM7.96831 11.9999L11.0002 9.85972V14.14L7.96831 11.9999ZM12.2119 17.4434C12.4375 17.6027 12.7494 17.5489 12.9087 17.3233C12.9682 17.2389 13.0002 17.1382 13.0002 17.0349V6.96484C13.0002 6.6887 12.7763 6.46484 12.5002 6.46484C12.3969 6.46484 12.2962 6.49681 12.2119 6.55636L5.07889 11.5914C4.85329 11.7506 4.7995 12.0626 4.95874 12.2882C4.99164 12.3348 5.03228 12.3755 5.07889 12.4084L12.2119 17.4434ZM16.9683 11.9999L20.0002 9.85972V14.14L16.9683 11.9999ZM13.9587 12.2882C13.9916 12.3348 14.0323 12.3755 14.0789 12.4084L21.2119 17.4434C21.4375 17.6027 21.7494 17.5489 21.9087 17.3233C21.9682 17.2389 22.0002 17.1382 22.0002 17.0349V6.96484C22.0002 6.6887 21.7763 6.46484 21.5002 6.46484C21.3969 6.46484 21.2962 6.49681 21.2119 6.55636L14.0789 11.5914C13.8533 11.7506 13.7995 12.0626 13.9587 12.2882Z"
  }));
},
    IT = function IT(_ref2735) {
  var _ref2735$color = _ref2735.color,
      C = _ref2735$color === void 0 ? "currentColor" : _ref2735$color,
      _ref2735$size = _ref2735.size,
      e = _ref2735$size === void 0 ? 24 : _ref2735$size,
      l = _ref2735.className,
      i = _objectWithoutProperties(_ref2735, _excluded2735);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.8589 2H11.1411C9.12721 2 8.04724 2.27848 7.06946 2.8014C6.09169 3.32432 5.32432 4.09169 4.8014 5.06946C4.27848 6.04724 4 7.12721 4 9.14111V14.8589C4 16.8728 4.27848 17.9528 4.8014 18.9305C5.32432 19.9083 6.09169 20.6757 7.06946 21.1986C8.04724 21.7215 9.12721 22 11.1411 22H12.8589C14.8728 22 15.9528 21.7215 16.9305 21.1986C17.9083 20.6757 18.6757 19.9083 19.1986 18.9305C19.7215 17.9528 20 16.8728 20 14.8589V9.14111C20 7.12721 19.7215 6.04724 19.1986 5.06946C18.6757 4.09169 17.9083 3.32432 16.9305 2.8014C15.9528 2.27848 14.8728 2 12.8589 2ZM11 11V6H13V11H11ZM7.75781 13.758L9.17203 12.3438L12.0005 15.1722L14.8289 12.3438L16.2431 13.758L12.0005 18.0006L7.75781 13.758Z"
  }));
},
    WT = function WT(_ref2736) {
  var _ref2736$color = _ref2736.color,
      C = _ref2736$color === void 0 ? "currentColor" : _ref2736$color,
      _ref2736$size = _ref2736.size,
      e = _ref2736$size === void 0 ? 24 : _ref2736$size,
      l = _ref2736.className,
      i = _objectWithoutProperties(_ref2736, _excluded2736);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8.01266 4.56502C8.75361 4.16876 9.5587 4 11.1411 4H12.8589C14.4413 4 15.2464 4.16876 15.9873 4.56502C16.6166 4.90155 17.0985 5.38342 17.435 6.01266C17.8312 6.75361 18 7.5587 18 9.14111V14.8589C18 16.4413 17.8312 17.2464 17.435 17.9873C17.0985 18.6166 16.6166 19.0985 15.9873 19.435C15.2464 19.8312 14.4413 20 12.8589 20H11.1411C9.5587 20 8.75361 19.8312 8.01266 19.435C7.38342 19.0985 6.90155 18.6166 6.56502 17.9873C6.16876 17.2464 6 16.4413 6 14.8589V9.14111C6 7.5587 6.16876 6.75361 6.56502 6.01266C6.90155 5.38342 7.38342 4.90155 8.01266 4.56502ZM12.8589 2H11.1411C9.12721 2 8.04724 2.27848 7.06946 2.8014C6.09168 3.32432 5.32432 4.09168 4.8014 5.06946C4.27848 6.04724 4 7.12721 4 9.14111V14.8589C4 16.8728 4.27848 17.9528 4.8014 18.9305C5.32432 19.9083 6.09168 20.6757 7.06946 21.1986C8.04724 21.7215 9.12721 22 11.1411 22H12.8589C14.8728 22 15.9528 21.7215 16.9305 21.1986C17.9083 20.6757 18.6757 19.9083 19.1986 18.9305C19.7215 17.9528 20 16.8728 20 14.8589V9.14111C20 7.12721 19.7215 6.04724 19.1986 5.06946C18.6757 4.09168 17.9083 3.32432 16.9305 2.8014C15.9528 2.27848 14.8728 2 12.8589 2ZM13 6H11V11H13V6ZM7.75781 13.758L12.0005 18.0006L16.2431 13.758L14.8289 12.3438L12.0005 15.1722L9.17203 12.3438L7.75781 13.758Z"
  }));
},
    OT = function OT(_ref2737) {
  var _ref2737$color = _ref2737.color,
      C = _ref2737$color === void 0 ? "currentColor" : _ref2737$color,
      _ref2737$size = _ref2737.size,
      e = _ref2737$size === void 0 ? 24 : _ref2737$size,
      l = _ref2737.className,
      i = _objectWithoutProperties(_ref2737, _excluded2737);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11 11.0001L11 2.0005L13 2.00049L13 11.0001L22.0001 10.9999L22.0002 12.9999L13 13.0001L13.0001 22L11.0001 22L11.0001 13.0001L2.00004 13.0003L2 11.0003L11 11.0001Z"
  }));
},
    KT = function KT(_ref2738) {
  var _ref2738$color = _ref2738.color,
      C = _ref2738$color === void 0 ? "currentColor" : _ref2738$color,
      _ref2738$size = _ref2738.size,
      e = _ref2738$size === void 0 ? 24 : _ref2738$size,
      l = _ref2738.className,
      i = _objectWithoutProperties(_ref2738, _excluded2738);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13.0001 10.9999L22.0002 10.9997L22.0002 12.9997L13.0001 12.9999L13.0001 21.9998L11.0001 21.9998L11.0001 12.9999L2.00004 13.0001L2 11.0001L11.0001 10.9999L11 2.00025L13 2.00024L13.0001 10.9999Z"
  }));
},
    QT = function QT(_ref2739) {
  var _ref2739$color = _ref2739.color,
      C = _ref2739$color === void 0 ? "currentColor" : _ref2739$color,
      _ref2739$size = _ref2739.size,
      e = _ref2739$size === void 0 ? 24 : _ref2739$size,
      l = _ref2739.className,
      i = _objectWithoutProperties(_ref2739, _excluded2739);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8 3C7.44772 3 7 3.44772 7 4V7H4C3.44772 7 3 7.44772 3 8V20C3 20.5523 3.44772 21 4 21H9V23H11V21H16C16.5523 21 17 20.5523 17 20V17H20C20.5523 17 21 16.5523 21 16V4C21 3.44772 20.5523 3 20 3H8ZM17 15V8C17 7.44772 16.5523 7 16 7H9V5H19V15H17Z"
  }));
},
    qT = function qT(_ref2740) {
  var _ref2740$color = _ref2740.color,
      C = _ref2740$color === void 0 ? "currentColor" : _ref2740$color,
      _ref2740$size = _ref2740.size,
      e = _ref2740$size === void 0 ? 24 : _ref2740$size,
      l = _ref2740.className,
      i = _objectWithoutProperties(_ref2740, _excluded2740);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7 4C7 3.44772 7.44772 3 8 3H20C20.5523 3 21 3.44772 21 4V16C21 16.5523 20.5523 17 20 17H17V20C17 20.5523 16.5523 21 16 21H11V23H9V21H4C3.44772 21 3 20.5523 3 20V8C3 7.44772 3.44772 7 4 7H7V4ZM19 15V5H9V7H16C16.5523 7 17 7.44772 17 8V15H19ZM5 9V19H15V9H5Z"
  }));
},
    jT = function jT(_ref2741) {
  var _ref2741$color = _ref2741.color,
      C = _ref2741$color === void 0 ? "currentColor" : _ref2741$color,
      _ref2741$size = _ref2741.size,
      e = _ref2741$size === void 0 ? 24 : _ref2741$size,
      l = _ref2741.className,
      i = _objectWithoutProperties(_ref2741, _excluded2741);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6 3C4.34315 3 3 4.34315 3 6V18C3 19.6569 4.34315 21 6 21H18C19.6569 21 21 19.6569 21 18V6C21 4.34315 19.6569 3 18 3H6ZM16 11L11 18V13H8L13 6V11H16Z"
  }));
},
    XT = function XT(_ref2742) {
  var _ref2742$color = _ref2742.color,
      C = _ref2742$color === void 0 ? "currentColor" : _ref2742$color,
      _ref2742$size = _ref2742.size,
      e = _ref2742$size === void 0 ? 24 : _ref2742$size,
      l = _ref2742.className,
      i = _objectWithoutProperties(_ref2742, _excluded2742);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6 5C5.44772 5 5 5.44772 5 6V18C5 18.5523 5.44772 19 6 19H18C18.5523 19 19 18.5523 19 18V6C19 5.44772 18.5523 5 18 5H6ZM3 6C3 4.34315 4.34315 3 6 3H18C19.6569 3 21 4.34315 21 6V18C21 19.6569 19.6569 21 18 21H6C4.34315 21 3 19.6569 3 18V6ZM16 11H13V6L8 13H11V18L16 11Z"
  }));
},
    JT = function JT(_ref2743) {
  var _ref2743$color = _ref2743.color,
      C = _ref2743$color === void 0 ? "currentColor" : _ref2743$color,
      _ref2743$size = _ref2743.size,
      e = _ref2743$size === void 0 ? 24 : _ref2743$size,
      l = _ref2743.className,
      i = _objectWithoutProperties(_ref2743, _excluded2743);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9.51445 5.14H4.67954C3.70366 5.14 2.76776 5.52766 2.07771 6.21771C1.38766 6.90776 1 7.84366 1 8.81954V15.1778C1 16.1537 1.38766 17.0896 2.07771 17.7796C2.76776 18.4697 3.70366 18.8573 4.67954 18.8573H9.52917L8.35908 17.2015L4.82304 16.1197C4.51117 16.0203 4.23916 15.8239 4.04659 15.5592C3.85401 15.2945 3.75092 14.9753 3.7523 14.6479V9.37147C3.74976 9.04385 3.85241 8.72406 4.04515 8.45913C4.23789 8.19419 4.51055 7.99809 4.82304 7.89965L8.35908 6.79579L9.51445 5.14ZM19.3388 5.14H14.4892L15.6593 6.79579L19.1953 7.89965C19.5074 7.99822 19.7796 8.19447 19.9717 8.45947C20.1638 8.72446 20.2657 9.04418 20.2624 9.37147V14.6479C20.2646 14.9749 20.1622 15.2941 19.9703 15.5589C19.7783 15.8236 19.5068 16.0202 19.1953 16.1197L15.6593 17.2015L14.4892 18.8573H19.3388C19.8213 18.8578 20.2991 18.7628 20.7447 18.5779C21.1903 18.3929 21.5949 18.1216 21.9352 17.7796C22.2755 17.4376 22.5448 17.0316 22.7275 16.5851C22.9103 16.1385 23.0028 15.6603 22.9999 15.1778V8.81954C22.9999 7.84684 22.6148 6.91372 21.9287 6.22419C21.2427 5.53467 20.3115 5.14486 19.3388 5.14ZM15.6666 11.1376H8.33698V12.7897H15.6666V11.1376Z"
  }));
},
    YT = function YT(_ref2744) {
  var _ref2744$color = _ref2744.color,
      C = _ref2744$color === void 0 ? "currentColor" : _ref2744$color,
      _ref2744$size = _ref2744.size,
      e = _ref2744$size === void 0 ? 24 : _ref2744$size,
      l = _ref2744.className,
      i = _objectWithoutProperties(_ref2744, _excluded2744);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5 5C2.79086 5 1 6.79086 1 9V15C1 17.2091 2.79086 19 5 19H9L8 17H5C3.89543 17 3 16.1046 3 15V9C3 7.89543 3.89543 7 5 7H8L9 5H5ZM16 7H19C20.1046 7 21 7.89543 21 9V15C21 16.1046 20.1046 17 19 17H16L15 19H19C21.2091 19 23 17.2091 23 15V9C23 6.79086 21.2091 5 19 5H15L16 7ZM8 13H16V11H8V13Z"
  }));
},
    _T = function _T(_ref2745) {
  var _ref2745$color = _ref2745.color,
      C = _ref2745$color === void 0 ? "currentColor" : _ref2745$color,
      _ref2745$size = _ref2745.size,
      e = _ref2745$size === void 0 ? 24 : _ref2745$size,
      l = _ref2745.className,
      i = _objectWithoutProperties(_ref2745, _excluded2745);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 4C4 3.44772 4.44772 3 5 3H10C10.5523 3 11 3.44772 11 4L11 16C11 16.5523 10.5523 17 10 17H5C4.44772 17 4 16.5523 4 16L4 4ZM14 7C13.4477 7 13 7.44772 13 8V16C13 16.5523 13.4477 17 14 17H19C19.5523 17 20 16.5523 20 16V8C20 7.44772 19.5523 7 19 7L14 7ZM21 19L3 19V21H21V19Z"
  }));
},
    $T = function $T(_ref2746) {
  var _ref2746$color = _ref2746.color,
      C = _ref2746$color === void 0 ? "currentColor" : _ref2746$color,
      _ref2746$size = _ref2746.size,
      e = _ref2746$size === void 0 ? 24 : _ref2746$size,
      l = _ref2746.className,
      i = _objectWithoutProperties(_ref2746, _excluded2746);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9 5L9 15H6L6 5L9 5ZM5 3C4.44772 3 4 3.44772 4 4L4 16C4 16.5523 4.44772 17 5 17H10C10.5523 17 11 16.5523 11 16L11 4C11 3.44772 10.5523 3 10 3H5ZM15 9V15H18V9H15ZM13 8C13 7.44772 13.4477 7 14 7L19 7C19.5523 7 20 7.44772 20 8V16C20 16.5523 19.5523 17 19 17H14C13.4477 17 13 16.5523 13 16V8ZM21 19L3 19V21H21V19Z"
  }));
},
    eU = function eU(_ref2747) {
  var _ref2747$color = _ref2747.color,
      C = _ref2747$color === void 0 ? "currentColor" : _ref2747$color,
      _ref2747$size = _ref2747.size,
      e = _ref2747$size === void 0 ? 24 : _ref2747$size,
      l = _ref2747.className,
      i = _objectWithoutProperties(_ref2747, _excluded2747);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11 4V2H13V4H19C19.5523 4 20 4.44772 20 5V10C20 10.5523 19.5523 11 19 11H13V13H17C17.5523 13 18 13.4477 18 14V19C18 19.5523 17.5523 20 17 20H13V22H11V20H7C6.44772 20 6 19.5523 6 19V14C6 13.4477 6.44772 13 7 13H11V11H5C4.44772 11 4 10.5523 4 10V5C4 4.44772 4.44772 4 5 4H11Z"
  }));
},
    tU = function tU(_ref2748) {
  var _ref2748$color = _ref2748.color,
      C = _ref2748$color === void 0 ? "currentColor" : _ref2748$color,
      _ref2748$size = _ref2748.size,
      e = _ref2748$size === void 0 ? 24 : _ref2748$size,
      l = _ref2748.className,
      i = _objectWithoutProperties(_ref2748, _excluded2748);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11 4V2H13V4H19C19.5523 4 20 4.44772 20 5V10C20 10.5523 19.5523 11 19 11H13V13H17C17.5523 13 18 13.4477 18 14V19C18 19.5523 17.5523 20 17 20H13V22H11V20H7C6.44772 20 6 19.5523 6 19V14C6 13.4477 6.44772 13 7 13H11V11H5C4.44772 11 4 10.5523 4 10V5C4 4.44772 4.44772 4 5 4H11ZM8 15V18H16V15H8ZM6 9H18V6H6V9Z"
  }));
},
    CU = function CU(_ref2749) {
  var _ref2749$color = _ref2749.color,
      C = _ref2749$color === void 0 ? "currentColor" : _ref2749$color,
      _ref2749$size = _ref2749.size,
      e = _ref2749$size === void 0 ? 24 : _ref2749$size,
      l = _ref2749.className,
      i = _objectWithoutProperties(_ref2749, _excluded2749);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 21V3H5V21H3ZM7 14C7 13.4477 7.44772 13 8 13H16C16.5523 13 17 13.4477 17 14V19C17 19.5523 16.5523 20 16 20H8C7.44772 20 7 19.5523 7 19V14ZM8 4C7.44772 4 7 4.44772 7 5V10C7 10.5523 7.44772 11 8 11H20C20.5523 11 21 10.5523 21 10V5C21 4.44772 20.5523 4 20 4H8Z"
  }));
},
    lU = function lU(_ref2750) {
  var _ref2750$color = _ref2750.color,
      C = _ref2750$color === void 0 ? "currentColor" : _ref2750$color,
      _ref2750$size = _ref2750.size,
      e = _ref2750$size === void 0 ? 24 : _ref2750$size,
      l = _ref2750.className,
      i = _objectWithoutProperties(_ref2750, _excluded2750);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 21V3H5V21H3ZM9 15H15V18H9V15ZM8 13C7.44772 13 7 13.4477 7 14V19C7 19.5523 7.44772 20 8 20H16C16.5523 20 17 19.5523 17 19V14C17 13.4477 16.5523 13 16 13H8ZM9 9H19V6H9V9ZM7 5C7 4.44772 7.44772 4 8 4H20C20.5523 4 21 4.44772 21 5V10C21 10.5523 20.5523 11 20 11H8C7.44772 11 7 10.5523 7 10V5Z"
  }));
},
    iU = function iU(_ref2751) {
  var _ref2751$color = _ref2751.color,
      C = _ref2751$color === void 0 ? "currentColor" : _ref2751$color,
      _ref2751$size = _ref2751.size,
      e = _ref2751$size === void 0 ? 24 : _ref2751$size,
      l = _ref2751.className,
      i = _objectWithoutProperties(_ref2751, _excluded2751);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19 21V3H21V21H19ZM7 14C7 13.4477 7.44772 13 8 13H16C16.5523 13 17 13.4477 17 14V19C17 19.5523 16.5523 20 16 20H8C7.44772 20 7 19.5523 7 19V14ZM4 4C3.44772 4 3 4.44772 3 5V10C3 10.5523 3.44772 11 4 11H16C16.5523 11 17 10.5523 17 10V5C17 4.44772 16.5523 4 16 4H4Z"
  }));
},
    sU = function sU(_ref2752) {
  var _ref2752$color = _ref2752.color,
      C = _ref2752$color === void 0 ? "currentColor" : _ref2752$color,
      _ref2752$size = _ref2752.size,
      e = _ref2752$size === void 0 ? 24 : _ref2752$size,
      l = _ref2752.className,
      i = _objectWithoutProperties(_ref2752, _excluded2752);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19 21V3H21V21H19ZM9 15H15V18H9V15ZM8 13C7.44772 13 7 13.4477 7 14V19C7 19.5523 7.44772 20 8 20H16C16.5523 20 17 19.5523 17 19V14C17 13.4477 16.5523 13 16 13H8ZM5 9H15V6H5V9ZM3 5C3 4.44772 3.44772 4 4 4H16C16.5523 4 17 4.44772 17 5V10C17 10.5523 16.5523 11 16 11H4C3.44772 11 3 10.5523 3 10V5Z"
  }));
},
    rU = function rU(_ref2753) {
  var _ref2753$color = _ref2753.color,
      C = _ref2753$color === void 0 ? "currentColor" : _ref2753$color,
      _ref2753$size = _ref2753.size,
      e = _ref2753$size === void 0 ? 24 : _ref2753$size,
      l = _ref2753.className,
      i = _objectWithoutProperties(_ref2753, _excluded2753);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 3H3V5L21 5V3ZM14 7C13.4477 7 13 7.44772 13 8V16C13 16.5523 13.4477 17 14 17H19C19.5523 17 20 16.5523 20 16V8C20 7.44772 19.5523 7 19 7L14 7ZM4 8C4 7.44772 4.44772 7 5 7L10 7C10.5523 7 11 7.44772 11 8L11 20C11 20.5523 10.5523 21 10 21H5C4.44772 21 4 20.5523 4 20L4 8Z"
  }));
},
    cU = function cU(_ref2754) {
  var _ref2754$color = _ref2754.color,
      C = _ref2754$color === void 0 ? "currentColor" : _ref2754$color,
      _ref2754$size = _ref2754.size,
      e = _ref2754$size === void 0 ? 24 : _ref2754$size,
      l = _ref2754.className,
      i = _objectWithoutProperties(_ref2754, _excluded2754);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 3H3V5L21 5V3ZM15 9V15H18V9H15ZM13 8C13 7.44772 13.4477 7 14 7L19 7C19.5523 7 20 7.44772 20 8V16C20 16.5523 19.5523 17 19 17H14C13.4477 17 13 16.5523 13 16V8ZM9 9L9 19H6L6 9H9ZM5 7C4.44772 7 4 7.44772 4 8L4 20C4 20.5523 4.44772 21 5 21H10C10.5523 21 11 20.5523 11 20L11 8C11 7.44772 10.5523 7 10 7L5 7Z"
  }));
},
    oU = function oU(_ref2755) {
  var _ref2755$color = _ref2755.color,
      C = _ref2755$color === void 0 ? "currentColor" : _ref2755$color,
      _ref2755$size = _ref2755.size,
      e = _ref2755$size === void 0 ? 24 : _ref2755$size,
      l = _ref2755.className,
      i = _objectWithoutProperties(_ref2755, _excluded2755);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 19C4 19.5523 4.44772 20 5 20H10C10.5523 20 11 19.5523 11 19V13H13V17C13 17.5523 13.4477 18 14 18H19C19.5523 18 20 17.5523 20 17V13H22V11H20V7C20 6.44772 19.5523 6 19 6L14 6C13.4477 6 13 6.44772 13 7V11H11V5C11 4.44771 10.5523 4 10 4H5C4.44771 4 4 4.44772 4 5L4 11H2V13H4L4 19Z"
  }));
},
    aU = function aU(_ref2756) {
  var _ref2756$color = _ref2756.color,
      C = _ref2756$color === void 0 ? "currentColor" : _ref2756$color,
      _ref2756$size = _ref2756.size,
      e = _ref2756$size === void 0 ? 24 : _ref2756$size,
      l = _ref2756.className,
      i = _objectWithoutProperties(_ref2756, _excluded2756);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9 18L9 6L6 6L6 18H9ZM5 20C4.44772 20 4 19.5523 4 19L4 13H2V11H4L4 5C4 4.44771 4.44771 4 5 4H10C10.5523 4 11 4.44771 11 5V11H13V7C13 6.44771 13.4477 6 14 6L19 6C19.5523 6 20 6.44772 20 7V11H22V13H20V17C20 17.5523 19.5523 18 19 18H14C13.4477 18 13 17.5523 13 17V13H11V19C11 19.5523 10.5523 20 10 20H5ZM15 16H18V8L15 8V16Z"
  }));
},
    nU = function nU(_ref2757) {
  var _ref2757$color = _ref2757.color,
      C = _ref2757$color === void 0 ? "currentColor" : _ref2757$color,
      _ref2757$size = _ref2757.size,
      e = _ref2757$size === void 0 ? 24 : _ref2757$size,
      l = _ref2757.className,
      i = _objectWithoutProperties(_ref2757, _excluded2757);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2.5 7C2.5 9.48528 4.51472 11.5 7 11.5C9.48528 11.5 11.5 9.48528 11.5 7C11.5 4.51472 9.48528 2.5 7 2.5C4.51472 2.5 2.5 4.51472 2.5 7ZM2.5 17C2.5 19.4853 4.51472 21.5 7 21.5C9.48528 21.5 11.5 19.4853 11.5 17C11.5 14.5147 9.48528 12.5 7 12.5C4.51472 12.5 2.5 14.5147 2.5 17ZM12.5 17C12.5 19.4853 14.5147 21.5 17 21.5C19.4853 21.5 21.5 19.4853 21.5 17C21.5 14.5147 19.4853 12.5 17 12.5C14.5147 12.5 12.5 14.5147 12.5 17ZM16 11V8H13V6H16V3H18V6H21V8H18V11H16Z"
  }));
},
    mU = function mU(_ref2758) {
  var _ref2758$color = _ref2758.color,
      C = _ref2758$color === void 0 ? "currentColor" : _ref2758$color,
      _ref2758$size = _ref2758.size,
      e = _ref2758$size === void 0 ? 24 : _ref2758$size,
      l = _ref2758.className,
      i = _objectWithoutProperties(_ref2758, _excluded2758);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2.5 7C2.5 9.48528 4.51472 11.5 7 11.5C9.48528 11.5 11.5 9.48528 11.5 7C11.5 4.51472 9.48528 2.5 7 2.5C4.51472 2.5 2.5 4.51472 2.5 7ZM2.5 17C2.5 19.4853 4.51472 21.5 7 21.5C9.48528 21.5 11.5 19.4853 11.5 17C11.5 14.5147 9.48528 12.5 7 12.5C4.51472 12.5 2.5 14.5147 2.5 17ZM12.5 17C12.5 19.4853 14.5147 21.5 17 21.5C19.4853 21.5 21.5 19.4853 21.5 17C21.5 14.5147 19.4853 12.5 17 12.5C14.5147 12.5 12.5 14.5147 12.5 17ZM9.5 7C9.5 8.38071 8.38071 9.5 7 9.5C5.61929 9.5 4.5 8.38071 4.5 7C4.5 5.61929 5.61929 4.5 7 4.5C8.38071 4.5 9.5 5.61929 9.5 7ZM9.5 17C9.5 18.3807 8.38071 19.5 7 19.5C5.61929 19.5 4.5 18.3807 4.5 17C4.5 15.6193 5.61929 14.5 7 14.5C8.38071 14.5 9.5 15.6193 9.5 17ZM19.5 17C19.5 18.3807 18.3807 19.5 17 19.5C15.6193 19.5 14.5 18.3807 14.5 17C14.5 15.6193 15.6193 14.5 17 14.5C18.3807 14.5 19.5 15.6193 19.5 17ZM16 11V8H13V6H16V3H18V6H21V8H18V11H16Z"
  }));
},
    wU = function wU(_ref2759) {
  var _ref2759$color = _ref2759.color,
      C = _ref2759$color === void 0 ? "currentColor" : _ref2759$color,
      _ref2759$size = _ref2759.size,
      e = _ref2759$size === void 0 ? 24 : _ref2759$size,
      l = _ref2759.className,
      i = _objectWithoutProperties(_ref2759, _excluded2759);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10.5859 12L2.79297 4.20706L4.20718 2.79285L12.0001 10.5857L19.793 2.79285L21.2072 4.20706L13.4143 12L21.2072 19.7928L19.793 21.2071L12.0001 13.4142L4.20718 21.2071L2.79297 19.7928L10.5859 12Z"
  }));
},
    LU = function LU(_ref2760) {
  var _ref2760$color = _ref2760.color,
      C = _ref2760$color === void 0 ? "currentColor" : _ref2760$color,
      _ref2760$size = _ref2760.size,
      e = _ref2760$size === void 0 ? 24 : _ref2760$size,
      l = _ref2760.className,
      i = _objectWithoutProperties(_ref2760, _excluded2760);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10.5859 12L2.79297 4.20706L4.20718 2.79285L12.0001 10.5857L19.793 2.79285L21.2072 4.20706L13.4143 12L21.2072 19.7928L19.793 21.2071L12.0001 13.4142L4.20718 21.2071L2.79297 19.7928L10.5859 12Z"
  }));
},
    hU = function hU(_ref2761) {
  var _ref2761$color = _ref2761.color,
      C = _ref2761$color === void 0 ? "currentColor" : _ref2761$color,
      _ref2761$size = _ref2761.size,
      e = _ref2761$size === void 0 ? 24 : _ref2761$size,
      l = _ref2761.className,
      i = _objectWithoutProperties(_ref2761, _excluded2761);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3.50008 11.0001H11.0001V3.50008L7.95718 6.54297L4.70718 3.29297L3.29297 4.70718L6.54297 7.95718L3.50008 11.0001ZM20.5 13H13V20.5L16.0429 17.4571L19.2929 20.7071L20.7071 19.2929L17.4571 16.0429L20.5 13Z"
  }));
},
    HU = function HU(_ref2762) {
  var _ref2762$color = _ref2762.color,
      C = _ref2762$color === void 0 ? "currentColor" : _ref2762$color,
      _ref2762$size = _ref2762.size,
      e = _ref2762$size === void 0 ? 24 : _ref2762$size,
      l = _ref2762.className,
      i = _objectWithoutProperties(_ref2762, _excluded2762);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9.00008 4.00008H11.0001V11.0001H4.00008V9.00008H7.58586L3.29297 4.70718L4.70718 3.29297L9.00008 7.58586V4.00008ZM20 15H16.4142L20.7071 19.2929L19.2929 20.7071L15 16.4142V20H13V13H20V15Z"
  }));
},
    VU = function VU(_ref2763) {
  var _ref2763$color = _ref2763.color,
      C = _ref2763$color === void 0 ? "currentColor" : _ref2763$color,
      _ref2763$size = _ref2763.size,
      e = _ref2763$size === void 0 ? 24 : _ref2763$size,
      l = _ref2763.className,
      i = _objectWithoutProperties(_ref2763, _excluded2763);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.5 11.0001H13V3.50008L16.0429 6.54297L19.2929 3.29297L20.7071 4.70718L17.4571 7.95718L20.5 11.0001ZM3.50008 13H11.0001V20.5L7.95718 17.4571L4.70718 20.7071L3.29297 19.2929L6.54297 16.0429L3.50008 13Z"
  }));
},
    gU = function gU(_ref2764) {
  var _ref2764$color = _ref2764.color,
      C = _ref2764$color === void 0 ? "currentColor" : _ref2764$color,
      _ref2764$size = _ref2764.size,
      e = _ref2764$size === void 0 ? 24 : _ref2764$size,
      l = _ref2764.className,
      i = _objectWithoutProperties(_ref2764, _excluded2764);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15 4.00008H13V11.0001H20V9.00008H16.4142L20.7071 4.70718L19.2929 3.29297L15 7.58586V4.00008ZM4.00008 15H7.58586L3.29297 19.2929L4.70718 20.7071L9.00008 16.4142V20H11.0001V13H4.00008V15Z"
  }));
},
    MU = function MU(_ref2765) {
  var _ref2765$color = _ref2765.color,
      C = _ref2765$color === void 0 ? "currentColor" : _ref2765$color,
      _ref2765$size = _ref2765.size,
      e = _ref2765$size === void 0 ? 24 : _ref2765$size,
      l = _ref2765.className,
      i = _objectWithoutProperties(_ref2765, _excluded2765);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 3C12.5523 3 13 3.44771 13 4L13 10C13 10.5523 12.5523 11 12 11L4 11C3.44772 11 3 10.5523 3 10L3 4C3 3.44772 3.44772 3 4 3L12 3ZM20 3C20.5523 3 21 3.44771 21 4L21 10C21 10.5523 20.5523 11 20 11L16 11C15.4477 11 15 10.5523 15 10L15 4C15 3.44771 15.4477 3 16 3L20 3ZM20 13C20.5523 13 21 13.4477 21 14L21 20C21 20.5523 20.5523 21 20 21L12 21C11.4477 21 11 20.5523 11 20L11 14C11 13.4477 11.4477 13 12 13L20 13ZM3 14C3 13.4477 3.44772 13 4 13L8 13C8.55229 13 9 13.4477 9 14L9 20C9 20.5523 8.55229 21 8 21L4 21C3.44772 21 3 20.5523 3 20L3 14Z"
  }));
},
    ZU = function ZU(_ref2766) {
  var _ref2766$color = _ref2766.color,
      C = _ref2766$color === void 0 ? "currentColor" : _ref2766$color,
      _ref2766$size = _ref2766.size,
      e = _ref2766$size === void 0 ? 24 : _ref2766$size,
      l = _ref2766.className,
      i = _objectWithoutProperties(_ref2766, _excluded2766);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 10C3 10.5523 3.44772 11 4 11L12 11C12.5523 11 13 10.5523 13 10V4C13 3.44772 12.5523 3 12 3H4C3.44772 3 3 3.44772 3 4V10ZM11 20C11 20.5523 11.4477 21 12 21H20C20.5523 21 21 20.5523 21 20V14C21 13.4477 20.5523 13 20 13H12C11.4477 13 11 13.4477 11 14V20ZM13 15H19V19H13V15ZM3 20C3 20.5523 3.44772 21 4 21H8C8.55229 21 9 20.5523 9 20V14C9 13.4477 8.55229 13 8 13H4C3.44772 13 3 13.4477 3 14V20ZM5 19V15H7V19H5ZM5 9V5L11 5L11 9L5 9ZM20 11C20.5523 11 21 10.5523 21 10V4C21 3.44772 20.5523 3 20 3H16C15.4477 3 15 3.44772 15 4V10C15 10.5523 15.4477 11 16 11H20ZM19 9H17V5H19V9Z"
  }));
},
    xU = function xU(_ref2767) {
  var _ref2767$color = _ref2767.color,
      C = _ref2767$color === void 0 ? "currentColor" : _ref2767$color,
      _ref2767$size = _ref2767.size,
      e = _ref2767$size === void 0 ? 24 : _ref2767$size,
      l = _ref2767.className,
      i = _objectWithoutProperties(_ref2767, _excluded2767);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 3H10.5L7.45711 6.04289L10.7071 9.29289L9.29289 10.7071L6.04289 7.45711L3 10.5V3ZM21 21H13.5L16.5429 17.9571L13.2929 14.7071L14.7071 13.2929L17.9571 16.5429L21 13.5V21Z"
  }));
},
    vU = function vU(_ref2768) {
  var _ref2768$color = _ref2768.color,
      C = _ref2768$color === void 0 ? "currentColor" : _ref2768$color,
      _ref2768$size = _ref2768.size,
      e = _ref2768$size === void 0 ? 24 : _ref2768$size,
      l = _ref2768.className,
      i = _objectWithoutProperties(_ref2768, _excluded2768);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.41421 5H10V3H3V10H5V6.41421L9.29289 10.7071L10.7071 9.29289L6.41421 5ZM21 14H19V17.5858L14.7071 13.2929L13.2929 14.7071L17.5858 19H14V21H21V14Z"
  }));
},
    dU = function dU(_ref2769) {
  var _ref2769$color = _ref2769.color,
      C = _ref2769$color === void 0 ? "currentColor" : _ref2769$color,
      _ref2769$size = _ref2769.size,
      e = _ref2769$size === void 0 ? 24 : _ref2769$size,
      l = _ref2769.className,
      i = _objectWithoutProperties(_ref2769, _excluded2769);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 3H13.5L16.5429 6.04289L13.2929 9.29289L14.7071 10.7071L17.9571 7.45711L21 10.5V3ZM3 21H10.5L7.45711 17.9571L10.7071 14.7071L9.29289 13.2929L6.04289 16.5429L3 13.5V21Z"
  }));
},
    pU = function pU(_ref2770) {
  var _ref2770$color = _ref2770.color,
      C = _ref2770$color === void 0 ? "currentColor" : _ref2770$color,
      _ref2770$size = _ref2770.size,
      e = _ref2770$size === void 0 ? 24 : _ref2770$size,
      l = _ref2770.className,
      i = _objectWithoutProperties(_ref2770, _excluded2770);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17.5858 5H14V3H21V10H19V6.41421L14.7071 10.7071L13.2929 9.29289L17.5858 5ZM3 14H5V17.5858L9.29289 13.2929L10.7071 14.7071L6.41421 19H10V21H3V14Z"
  }));
},
    EU = function EU(_ref2771) {
  var _ref2771$color = _ref2771.color,
      C = _ref2771$color === void 0 ? "currentColor" : _ref2771$color,
      _ref2771$size = _ref2771.size,
      e = _ref2771$size === void 0 ? 24 : _ref2771$size,
      l = _ref2771.className,
      i = _objectWithoutProperties(_ref2771, _excluded2771);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.75651 1.50129L4 18.4998L4.00007 18.4998L9.47342 4.81645L7.69485 1.35292C7.47439 0.923595 6.83377 1.02489 6.75651 1.50129ZM11.5638 4.31793L4.00008 18.4998L4.00012 18.4999L13.8396 6.94912L12.4412 4.32699C12.2546 3.9771 11.7558 3.97408 11.5638 4.31793ZM10.94 22.8373L4.00013 18.4999L17.31 5.66535C17.6037 5.39537 18.0834 5.56273 18.1424 5.96076L20 18.4998L13.06 22.8373C12.4115 23.2426 11.5885 23.2426 10.94 22.8373Z"
  }));
},
    NU = function NU(_ref2772) {
  var _ref2772$color = _ref2772.color,
      C = _ref2772$color === void 0 ? "currentColor" : _ref2772$color,
      _ref2772$size = _ref2772.size,
      e = _ref2772$size === void 0 ? 24 : _ref2772$size,
      l = _ref2772.className,
      i = _objectWithoutProperties(_ref2772, _excluded2772);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9.22296 8.70695L6.91128 13.0414L8.00027 6.32592L9.22296 8.70695ZM10.3684 6.55928L7.69485 1.35292C7.47439 0.923595 6.83377 1.02489 6.75651 1.50129L4 18.4998L5.74819 19.5926L10.94 22.8375C11.5885 23.2428 12.4115 23.2428 13.06 22.8375L20 18.5L18.1424 5.96098C18.0828 5.5587 17.5934 5.39205 17.3007 5.67433L14.566 8.31132L12.4412 4.32721C12.2529 3.97426 11.7471 3.97426 11.5588 4.32721L10.3684 6.55928ZM13.0692 9.75472L8.66667 14L12 7.75L13.0692 9.75472ZM7.23219 18.1616L16.5911 9.137L17.8297 17.4979L12 21.1415L7.23219 18.1616Z"
  }));
},
    uU = function uU(_ref2773) {
  var _ref2773$color = _ref2773.color,
      C = _ref2773$color === void 0 ? "currentColor" : _ref2773$color,
      _ref2773$size = _ref2773.size,
      e = _ref2773$size === void 0 ? 24 : _ref2773$size,
      l = _ref2773.className,
      i = _objectWithoutProperties(_ref2773, _excluded2773);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 3C3.44772 3 3 3.44772 3 4V20C3 20.5523 3.44772 21 4 21H20C20.5523 21 21 20.5523 21 20V4C21 3.44772 20.5523 3 20 3H4ZM10 8V11H14V8L18 12L14 16V13H10V16L6 12L10 8Z"
  }));
},
    BU = function BU(_ref2774) {
  var _ref2774$color = _ref2774.color,
      C = _ref2774$color === void 0 ? "currentColor" : _ref2774$color,
      _ref2774$size = _ref2774.size,
      e = _ref2774$size === void 0 ? 24 : _ref2774$size,
      l = _ref2774.className,
      i = _objectWithoutProperties(_ref2774, _excluded2774);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5 19H19V5H5V19ZM3 4C3 3.44772 3.44772 3 4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4ZM10 8V11H14V8L18 12L14 16V13H10V16L6 12L10 8Z"
  }));
},
    fU = function fU(_ref2775) {
  var _ref2775$color = _ref2775.color,
      C = _ref2775$color === void 0 ? "currentColor" : _ref2775$color,
      _ref2775$size = _ref2775.size,
      e = _ref2775$size === void 0 ? 24 : _ref2775$size,
      l = _ref2775.className,
      i = _objectWithoutProperties(_ref2775, _excluded2775);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11 2V22H13V2H11ZM7 6V18H4L4 6H7ZM4 4C2.89543 4 2 4.89543 2 6V18C2 19.1046 2.89543 20 4 20H7C8.10457 20 9 19.1046 9 18V6C9 4.89543 8.10457 4 7 4H4ZM15 6C15 4.89543 15.8954 4 17 4H20C21.1046 4 22 4.89543 22 6V18C22 19.1046 21.1046 20 20 20H17C15.8954 20 15 19.1046 15 18V6Z"
  }));
},
    RU = function RU(_ref2776) {
  var _ref2776$color = _ref2776.color,
      C = _ref2776$color === void 0 ? "currentColor" : _ref2776$color,
      _ref2776$size = _ref2776.size,
      e = _ref2776$size === void 0 ? 24 : _ref2776$size,
      l = _ref2776.className,
      i = _objectWithoutProperties(_ref2776, _excluded2776);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11 2V22H13V2H11ZM2 6C2 4.89543 2.89543 4 4 4H7C8.10457 4 9 4.89543 9 6V18C9 19.1046 8.10457 20 7 20H4C2.89543 20 2 19.1046 2 18V6ZM20 6V18H17V6H20ZM17 4C15.8954 4 15 4.89543 15 6V18C15 19.1046 15.8954 20 17 20H20C21.1046 20 22 19.1046 22 18V6C22 4.89543 21.1046 4 20 4H17Z"
  }));
},
    zU = function zU(_ref2777) {
  var _ref2777$color = _ref2777.color,
      C = _ref2777$color === void 0 ? "currentColor" : _ref2777$color,
      _ref2777$size = _ref2777.size,
      e = _ref2777$size === void 0 ? 24 : _ref2777$size,
      l = _ref2777.className,
      i = _objectWithoutProperties(_ref2777, _excluded2777);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 3C3.44772 3 3 3.44772 3 4V20C3 20.5523 3.44772 21 4 21H20C20.5523 21 21 20.5523 21 20V4C21 3.44772 20.5523 3 20 3H4ZM8 10L12 6L16 10H13V14H16L12 18L8 14H11L11 10H8Z"
  }));
},
    FU = function FU(_ref2778) {
  var _ref2778$color = _ref2778.color,
      C = _ref2778$color === void 0 ? "currentColor" : _ref2778$color,
      _ref2778$size = _ref2778.size,
      e = _ref2778$size === void 0 ? 24 : _ref2778$size,
      l = _ref2778.className,
      i = _objectWithoutProperties(_ref2778, _excluded2778);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5 19H19V5H5V19ZM3 4C3 3.44772 3.44772 3 4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4ZM8 10L12 6L16 10H13V14H16L12 18L8 14H11V10L8 10Z"
  }));
},
    SU = function SU(_ref2779) {
  var _ref2779$color = _ref2779.color,
      C = _ref2779$color === void 0 ? "currentColor" : _ref2779$color,
      _ref2779$size = _ref2779.size,
      e = _ref2779$size === void 0 ? 24 : _ref2779$size,
      l = _ref2779.className,
      i = _objectWithoutProperties(_ref2779, _excluded2779);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22 11L2 11L2 13L22 13V11ZM18 7L6 7V4L18 4V7ZM20 4C20 2.89543 19.1046 2 18 2L6 2C4.89543 2 4 2.89543 4 4L4 7C4 8.10457 4.89543 9 6 9L18 9C19.1046 9 20 8.10457 20 7V4ZM18 15C19.1046 15 20 15.8954 20 17V20C20 21.1046 19.1046 22 18 22H6C4.89543 22 4 21.1046 4 20L4 17C4 15.8954 4.89543 15 6 15L18 15Z"
  }));
},
    AU = function AU(_ref2780) {
  var _ref2780$color = _ref2780.color,
      C = _ref2780$color === void 0 ? "currentColor" : _ref2780$color,
      _ref2780$size = _ref2780.size,
      e = _ref2780$size === void 0 ? 24 : _ref2780$size,
      l = _ref2780.className,
      i = _objectWithoutProperties(_ref2780, _excluded2780);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22 11L2 11L2 13L22 13V11ZM18 2C19.1046 2 20 2.89543 20 4V7C20 8.10457 19.1046 9 18 9L6 9C4.89543 9 4 8.10457 4 7L4 4C4 2.89543 4.89543 2 6 2L18 2ZM18 20H6V17L18 17V20ZM20 17C20 15.8954 19.1046 15 18 15L6 15C4.89543 15 4 15.8954 4 17L4 20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V17Z"
  }));
},
    kU = function kU(_ref2781) {
  var _ref2781$color = _ref2781.color,
      C = _ref2781$color === void 0 ? "currentColor" : _ref2781$color,
      _ref2781$size = _ref2781.size,
      e = _ref2781$size === void 0 ? 24 : _ref2781$size,
      l = _ref2781.className,
      i = _objectWithoutProperties(_ref2781, _excluded2781);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10 2C7.79086 2 6 3.79086 6 6V9H3V11H6V18C6 19.1046 5.10457 20 4 20H3V22H4C6.20914 22 8 20.2091 8 18V11H11V9H8V6C8 4.89543 8.89543 4 10 4H11V2H10ZM15.2022 16.9971L11.8907 21H14.4864L16.5 18.5659L18.5137 21H21.1093L17.7979 16.9971L21.1046 13H18.5089L16.5 15.4283L14.4912 13H11.8955L15.2022 16.9971Z"
  }));
},
    PU = function PU(_ref2782) {
  var _ref2782$color = _ref2782.color,
      C = _ref2782$color === void 0 ? "currentColor" : _ref2782$color,
      _ref2782$size = _ref2782.size,
      e = _ref2782$size === void 0 ? 24 : _ref2782$size,
      l = _ref2782.className,
      i = _objectWithoutProperties(_ref2782, _excluded2782);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 3C3.44772 3 3 3.44772 3 4V10C3 10.5523 3.44772 11 4 11H10C10.5523 11 11 10.5523 11 10V4C11 3.44772 10.5523 3 10 3H4ZM4 13C3.44772 13 3 13.4477 3 14V20C3 20.5523 3.44772 21 4 21H10C10.5523 21 11 20.5523 11 20V14C11 13.4477 10.5523 13 10 13H4ZM14 13C13.4477 13 13 13.4477 13 14V20C13 20.5523 13.4477 21 14 21H20C20.5523 21 21 20.5523 21 20V14C21 13.4477 20.5523 13 20 13H14ZM16 11V8H13V6H16V3H18V6H21V8H18V11H16Z"
  }));
},
    DU = function DU(_ref2783) {
  var _ref2783$color = _ref2783.color,
      C = _ref2783$color === void 0 ? "currentColor" : _ref2783$color,
      _ref2783$size = _ref2783.size,
      e = _ref2783$size === void 0 ? 24 : _ref2783$size,
      l = _ref2783.className,
      i = _objectWithoutProperties(_ref2783, _excluded2783);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 3C3.44772 3 3 3.44772 3 4V10C3 10.5523 3.44772 11 4 11H10C10.5523 11 11 10.5523 11 10V4C11 3.44772 10.5523 3 10 3H4ZM4 13C3.44772 13 3 13.4477 3 14V20C3 20.5523 3.44772 21 4 21H10C10.5523 21 11 20.5523 11 20V14C11 13.4477 10.5523 13 10 13H4ZM14 13C13.4477 13 13 13.4477 13 14V20C13 20.5523 13.4477 21 14 21H20C20.5523 21 21 20.5523 21 20V14C21 13.4477 20.5523 13 20 13H14ZM15 19V15H19V19H15ZM5 9V5H9V9H5ZM5 19V15H9V19H5ZM16 11V8H13V6H16V3H18V6H21V8H18V11H16Z"
  }));
},
    yU = function yU(_ref2784) {
  var _ref2784$color = _ref2784.color,
      C = _ref2784$color === void 0 ? "currentColor" : _ref2784$color,
      _ref2784$size = _ref2784.size,
      e = _ref2784$size === void 0 ? 24 : _ref2784$size,
      l = _ref2784.className,
      i = _objectWithoutProperties(_ref2784, _excluded2784);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.13317 2L5.01052 9.85858C4.70849 11.9728 5.53231 13.7891 6.89117 15.0465C7.99601 16.0688 9.45948 16.7319 11.0005 16.9343V20H6.00047V22H18.0005V20H13.0005V16.9343C14.5415 16.7319 16.0049 16.0688 17.1098 15.0465C18.4686 13.7891 19.2924 11.9728 18.9904 9.85858L17.8678 2H6.13317ZM10.0003 7C9.16936 7.00013 8.16238 7.24244 7.37122 7.47579L7.86776 4H16.1332L16.6234 7.4314C15.7848 7.70691 14.8897 8 14.0005 8C12.6083 8 11.4276 6.99978 10.0003 7Z"
  }));
},
    bU = function bU(_ref2785) {
  var _ref2785$color = _ref2785.color,
      C = _ref2785$color === void 0 ? "currentColor" : _ref2785$color,
      _ref2785$size = _ref2785.size,
      e = _ref2785$size === void 0 ? 24 : _ref2785$size,
      l = _ref2785.className,
      i = _objectWithoutProperties(_ref2785, _excluded2785);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.13317 2L5.01052 9.85858C4.70849 11.9728 5.53231 13.7891 6.89117 15.0465C7.99601 16.0688 9.45948 16.7319 11.0005 16.9343V20H6.00047V22H18.0005V20H13.0005V16.9343C14.5415 16.7319 16.0049 16.0688 17.1098 15.0465C18.4686 13.7891 19.2924 11.9728 18.9904 9.85858L17.8678 2H6.13317ZM6.99042 10.1414L7.86776 4H16.1332L17.0105 10.1414C17.2085 11.5272 16.6892 12.7109 15.7514 13.5785C14.7968 14.4618 13.4178 15 12.0005 15C10.5831 15 9.20412 14.4618 8.24948 13.5785C7.31177 12.7109 6.79245 11.5272 6.99042 10.1414Z"
  }));
},
    TU = function TU(_ref2786) {
  var _ref2786$color = _ref2786.color,
      C = _ref2786$color === void 0 ? "currentColor" : _ref2786$color,
      _ref2786$size = _ref2786.size,
      e = _ref2786$size === void 0 ? 24 : _ref2786$size,
      l = _ref2786.className,
      i = _objectWithoutProperties(_ref2786, _excluded2786);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM14 7C14 6.44772 13.5523 6 13 6C12.4477 6 12 6.44772 12 7C12 7.55228 12.4477 8 13 8C13.5523 8 14 7.55228 14 7ZM13 11C13.5523 11 14 10.5523 14 10C14 9.44772 13.5523 9 13 9C12.4477 9 12 9.44772 12 10C12 10.5523 12.4477 11 13 11ZM17 12C17 11.4477 16.5523 11 16 11C15.4477 11 15 11.4477 15 12C15 12.5523 15.4477 13 16 13C16.5523 13 17 12.5523 17 12ZM16 10C16.5523 10 17 9.55228 17 9C17 8.44772 16.5523 8 16 8C15.4477 8 15 8.44772 15 9C15 9.55228 15.4477 10 16 10Z"
  }));
},
    UU = function UU(_ref2787) {
  var _ref2787$color = _ref2787.color,
      C = _ref2787$color === void 0 ? "currentColor" : _ref2787$color,
      _ref2787$size = _ref2787.size,
      e = _ref2787$size === void 0 ? 24 : _ref2787$size,
      l = _ref2787.className,
      i = _objectWithoutProperties(_ref2787, _excluded2787);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM14 7C14 7.55228 13.5523 8 13 8C12.4477 8 12 7.55228 12 7C12 6.44772 12.4477 6 13 6C13.5523 6 14 6.44772 14 7ZM13 11C13.5523 11 14 10.5523 14 10C14 9.44771 13.5523 9 13 9C12.4477 9 12 9.44771 12 10C12 10.5523 12.4477 11 13 11ZM17 12C17 12.5523 16.5523 13 16 13C15.4477 13 15 12.5523 15 12C15 11.4477 15.4477 11 16 11C16.5523 11 17 11.4477 17 12ZM16 10C16.5523 10 17 9.55229 17 9C17 8.44771 16.5523 8 16 8C15.4477 8 15 8.44771 15 9C15 9.55229 15.4477 10 16 10Z"
  }));
},
    GU = function GU(_ref2788) {
  var _ref2788$color = _ref2788.color,
      C = _ref2788$color === void 0 ? "currentColor" : _ref2788$color,
      _ref2788$size = _ref2788.size,
      e = _ref2788$size === void 0 ? 24 : _ref2788$size,
      l = _ref2788.className,
      i = _objectWithoutProperties(_ref2788, _excluded2788);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2.5 7C2.5 9.20914 4.29086 11 6.5 11C8.70914 11 10.5 9.20914 10.5 7C10.5 4.79086 8.70914 3 6.5 3C4.29086 3 2.5 4.79086 2.5 7ZM2 21V16.5C2 14.0147 4.01472 12 6.5 12C8.98528 12 11 14.0147 11 16.5V21H2ZM17.5 11C15.2909 11 13.5 9.20914 13.5 7C13.5 4.79086 15.2909 3 17.5 3C19.7091 3 21.5 4.79086 21.5 7C21.5 9.20914 19.7091 11 17.5 11ZM13 21V16.5C13 14.0147 15.0147 12 17.5 12C19.9853 12 22 14.0147 22 16.5V21H13Z"
  }));
},
    IU = function IU(_ref2789) {
  var _ref2789$color = _ref2789.color,
      C = _ref2789$color === void 0 ? "currentColor" : _ref2789$color,
      _ref2789$size = _ref2789.size,
      e = _ref2789$size === void 0 ? 24 : _ref2789$size,
      l = _ref2789.className,
      i = _objectWithoutProperties(_ref2789, _excluded2789);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8.5 7C8.5 8.10457 7.60457 9 6.5 9C5.39543 9 4.5 8.10457 4.5 7C4.5 5.89543 5.39543 5 6.5 5C7.60457 5 8.5 5.89543 8.5 7ZM2.5 7C2.5 9.20914 4.29086 11 6.5 11C8.70914 11 10.5 9.20914 10.5 7C10.5 4.79086 8.70914 3 6.5 3C4.29086 3 2.5 4.79086 2.5 7ZM9 16.5C9 15.1193 7.88071 14 6.5 14C5.11929 14 4 15.1193 4 16.5V19H9V16.5ZM11 21H2V16.5C2 14.0147 4.01472 12 6.5 12C8.98528 12 11 14.0147 11 16.5V21ZM19.5 7C19.5 8.10457 18.6046 9 17.5 9C16.3954 9 15.5 8.10457 15.5 7C15.5 5.89543 16.3954 5 17.5 5C18.6046 5 19.5 5.89543 19.5 7ZM13.5 7C13.5 9.20914 15.2909 11 17.5 11C19.7091 11 21.5 9.20914 21.5 7C21.5 4.79086 19.7091 3 17.5 3C15.2909 3 13.5 4.79086 13.5 7ZM20 16.5C20 15.1193 18.8807 14 17.5 14C16.1193 14 15 15.1193 15 16.5V19H20V16.5ZM13 19V16.5C13 14.0147 15.0147 12 17.5 12C19.9853 12 22 14.0147 22 16.5V21H13V19Z"
  }));
},
    WU = function WU(_ref2790) {
  var _ref2790$color = _ref2790.color,
      C = _ref2790$color === void 0 ? "currentColor" : _ref2790$color,
      _ref2790$size = _ref2790.size,
      e = _ref2790$size === void 0 ? 24 : _ref2790$size,
      l = _ref2790.className,
      i = _objectWithoutProperties(_ref2790, _excluded2790);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16.5 3C19.5376 3 22 5.5 22 9C22 10.4251 21.6891 11.7259 21.1729 12.9066C20.2524 12.332 19.165 12 18 12C14.6863 12 12 14.6863 12 18C12 19.1005 12.2963 20.1318 12.8134 21.0185C12.506 21.2007 12.2316 21.3611 12 21.5C9.50001 20 2 16 2 9C2 5.5 4.5 3 7.5 3C9.35997 3 11 4 12 5C13 4 14.64 3 16.5 3ZM19 17V14H17V17H14V19H16.999L17 22H19L18.999 19H22V17H19Z"
  }));
},
    OU = function OU(_ref2791) {
  var _ref2791$color = _ref2791.color,
      C = _ref2791$color === void 0 ? "currentColor" : _ref2791$color,
      _ref2791$size = _ref2791.size,
      e = _ref2791$size === void 0 ? 24 : _ref2791$size,
      l = _ref2791.className,
      i = _objectWithoutProperties(_ref2791, _excluded2791);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 9C4 6.49238 5.71351 5 7.5 5C9.40609 5 10.7537 6.58211 12 7.82843C13.2463 6.58211 14.5939 5 16.5 5C18.3158 5 20 6.48356 20 9C20 10.1222 19.7639 11.1501 19.3509 12.1019L21.1856 12.8981C21.7005 11.7114 22 10.4135 22 9C22 5.49592 19.5337 3 16.5 3C14.5905 3 13.1464 3.9848 12 5.02802C10.8536 3.9848 9.40952 3 7.5 3C4.50355 3 2 5.49623 2 9C2 12.0199 3.36207 14.4702 5.20346 16.445C7.03313 18.4073 9.38528 19.955 11.4916 21.1985L12.5084 19.4762C10.441 18.2557 8.29313 16.8259 6.66623 15.0811C5.05106 13.3489 4 11.3626 4 9ZM19 17V14H17V17H14V19H16.999L17 22H19L18.999 19H22V17H19Z"
  }));
},
    KU = function KU(_ref2792) {
  var _ref2792$color = _ref2792.color,
      C = _ref2792$color === void 0 ? "currentColor" : _ref2792$color,
      _ref2792$size = _ref2792.size,
      e = _ref2792$size === void 0 ? 24 : _ref2792$size,
      l = _ref2792.className,
      i = _objectWithoutProperties(_ref2792, _excluded2792);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M1 5C1 4.44772 1.44772 4 2 4H22C22.5523 4 23 4.44772 23 5V19C23 19.5523 22.5523 20 22 20H2C1.44772 20 1 19.5523 1 19V5ZM13 8V10H19V8H13ZM18 12H13V14H18V12ZM10.5 10C10.5 8.61929 9.38071 7.5 8 7.5C6.61929 7.5 5.5 8.61929 5.5 10C5.5 11.3807 6.61929 12.5 8 12.5C9.38071 12.5 10.5 11.3807 10.5 10ZM8 13.5C6.067 13.5 4.5 15.067 4.5 17H11.5C11.5 15.067 9.933 13.5 8 13.5Z"
  }));
},
    QU = function QU(_ref2793) {
  var _ref2793$color = _ref2793.color,
      C = _ref2793$color === void 0 ? "currentColor" : _ref2793$color,
      _ref2793$size = _ref2793.size,
      e = _ref2793$size === void 0 ? 24 : _ref2793$size,
      l = _ref2793.className,
      i = _objectWithoutProperties(_ref2793, _excluded2793);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 6H21V18H3V6ZM2 4C1.44772 4 1 4.44772 1 5V19C1 19.5523 1.44772 20 2 20H22C22.5523 20 23 19.5523 23 19V5C23 4.44772 22.5523 4 22 4H2ZM13 8H19V10H13V8ZM18 12H13V14H18V12ZM10.5 10C10.5 11.3807 9.38071 12.5 8 12.5C6.61929 12.5 5.5 11.3807 5.5 10C5.5 8.61929 6.61929 7.5 8 7.5C9.38071 7.5 10.5 8.61929 10.5 10ZM8 13.5C6.067 13.5 4.5 15.067 4.5 17H11.5C11.5 15.067 9.933 13.5 8 13.5Z"
  }));
},
    qU = function qU(_ref2794) {
  var _ref2794$color = _ref2794.color,
      C = _ref2794$color === void 0 ? "currentColor" : _ref2794$color,
      _ref2794$size = _ref2794.size,
      e = _ref2794$size === void 0 ? 24 : _ref2794$size,
      l = _ref2794.className,
      i = _objectWithoutProperties(_ref2794, _excluded2794);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19.7429 18.3287C21.1536 16.6049 22 14.4013 22 12C22 6.47715 17.5228 2 12 2C9.59873 2 7.39514 2.84637 5.67127 4.25705L11.9142 10.5H13V11.5858L19.7429 18.3287ZM10 11.4142L4.25705 5.67127C2.84637 7.39514 2 9.59873 2 12C2 17.5228 6.47715 22 12 22C14.4013 22 16.6049 21.1536 18.3287 19.7429L14 15.4142V17H10V15H11V12.5H10V11.4142ZM13.5858 15H13V14.4142L13.5858 15ZM13.5 8C13.5 8.82843 12.8284 9.5 12 9.5C11.1716 9.5 10.5 8.82843 10.5 8C10.5 7.17157 11.1716 6.5 12 6.5C12.8284 6.5 13.5 7.17157 13.5 8Z"
  }));
},
    jU = function jU(_ref2795) {
  var _ref2795$color = _ref2795.color,
      C = _ref2795$color === void 0 ? "currentColor" : _ref2795$color,
      _ref2795$size = _ref2795.size,
      e = _ref2795$size === void 0 ? 24 : _ref2795$size,
      l = _ref2795.className,
      i = _objectWithoutProperties(_ref2795, _excluded2795);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12ZM16.9056 18.3199C15.551 19.3729 13.8487 20 12 20C7.58172 20 4 16.4183 4 12C4 10.1513 4.62708 8.44904 5.68014 7.09436L10 11.4142V12.5H11V15H10V17H14V15.4142L16.9056 18.3199ZM18.3199 16.9056L13 11.5858V10.5H11.9142L7.09436 5.68014C8.44904 4.62708 10.1513 4 12 4C16.4183 4 20 7.58172 20 12C20 13.8487 19.3729 15.551 18.3199 16.9056ZM13 14.4142V15H13.5858L13 14.4142ZM12 9.5C12.8284 9.5 13.5 8.82843 13.5 8C13.5 7.17157 12.8284 6.5 12 6.5C11.1716 6.5 10.5 7.17157 10.5 8C10.5 8.82843 11.1716 9.5 12 9.5Z"
  }));
},
    XU = function XU(_ref2796) {
  var _ref2796$color = _ref2796.color,
      C = _ref2796$color === void 0 ? "currentColor" : _ref2796$color,
      _ref2796$size = _ref2796.size,
      e = _ref2796$size === void 0 ? 24 : _ref2796$size,
      l = _ref2796.className,
      i = _objectWithoutProperties(_ref2796, _excluded2796);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15.6381 4.56605L15.6938 4.5979C14.9364 4.9983 12.7704 6.28707 12.7704 7.92968C12.7704 8.4836 13.0874 9.01832 13.3844 9.51951C13.6464 9.96157 13.893 10.3776 13.893 10.7576C13.893 11.7154 12.9598 12.4572 12.4328 12.7998L12.3326 12.7419C12.532 12.4988 12.7769 12.0921 12.7769 11.6583C12.7769 11.0601 12.4704 10.5823 12.159 10.0969C11.8375 9.59566 11.5106 9.08622 11.5106 8.42742C11.5106 6.1347 14.6259 4.90505 15.6381 4.56605ZM11.5434 5.77848C12.7958 4.65825 14.1645 3.43386 14.1645 1.59287C14.1645 0.759703 13.8238 0.227919 13.6546 0.0151978L13.6005 0.0463524C13.6419 0.211686 13.7011 0.518006 13.7011 0.917705C13.7011 2.59364 12.2794 3.76866 10.903 4.90626C9.61148 5.97365 8.35986 7.0081 8.35986 8.39247C8.35986 10.3768 10.3182 11.5983 11.1447 12.1138C11.1667 12.1275 11.1879 12.1407 11.2082 12.1534L11.2587 12.1243C11.2135 12.0755 11.1657 12.0246 11.1159 11.9716C10.4801 11.2952 9.51432 10.2677 9.51432 8.69722C9.51432 7.59357 10.4875 6.72305 11.5434 5.77848ZM11.0908 15.6857C12.8553 15.6857 14.0892 15.4328 14.637 15.2776L15.4693 15.7583C14.6762 16.1607 12.918 16.4679 11.0874 16.4679C8.93406 16.4679 6.58033 16.0056 6.57265 15.3901C6.5682 15.0509 7.3385 14.8244 8.1677 14.6778L8.21766 14.7068C8.21766 14.7068 7.93691 14.808 7.93983 15.0402C7.94424 15.3893 9.35916 15.6857 11.0908 15.6857ZM7.56243 17.857C7.56243 17.4495 8.40054 17.2571 8.78509 17.1805L8.83501 17.2094C8.76891 17.2586 8.73343 17.3259 8.73343 17.3827C8.73343 17.6501 9.66273 17.8944 11.0891 17.8944C12.3671 17.8944 13.0768 17.7367 13.4981 17.6363L14.4885 18.2094C14.4444 18.2411 13.4687 18.854 11.0867 18.854C9.35558 18.854 7.56243 18.4216 7.56243 17.857ZM16.0908 16.1289C17.2713 15.4563 18.4524 14.6603 18.519 13.3819C18.5628 12.5433 17.7924 11.9276 16.9493 12.0926L16.994 11.9801L16.9946 11.9781C17.2064 11.9136 17.4675 11.8618 17.761 11.8618C18.7036 11.8618 19.4266 12.427 19.5192 13.2181C19.705 14.8043 17.4574 15.8362 16.1978 16.1906L16.0908 16.1289ZM18.0656 19.1167C18.0751 20.2067 14.3677 20.8553 11.0541 20.8841C8.19296 20.9092 3.57989 20.3685 3.57033 19.2795C3.5637 18.5262 5.57092 18.0045 6.66027 17.8545L6.77512 17.9201C6.77512 17.9201 5.14953 18.2966 5.15551 18.9817C5.16149 19.665 8.58036 20.2563 11.0485 20.2348C14.8736 20.2014 17.4627 19.5776 17.769 18.7331L17.8234 18.702C17.9352 18.7838 18.0639 18.9191 18.0656 19.1167ZM6.43132 21.3375C7.78419 21.5649 9.39241 21.6739 10.7095 21.6623C16.9181 21.6081 18.6693 20.0816 18.9407 19.7504L18.9875 19.7777C18.9226 20.986 15.6401 21.99 11.5914 22.0254C9.52977 22.0433 7.65363 21.8047 6.30604 21.4096L6.43132 21.3375ZM9.03259 12.0541C7.95397 12.1371 5.63738 12.4797 5.63738 13.0904C5.63738 13.5516 7.76084 14.2028 11.0887 14.2028C14.083 14.2028 15.9733 13.6377 16.4136 13.4221L15.7707 13.048C15.3111 13.1734 13.6023 13.5539 11.0886 13.5539C9.60853 13.5539 7.05875 13.281 7.05875 12.8646C7.05875 12.4903 8.65043 12.2016 9.10709 12.1187C9.11713 12.1169 9.12662 12.1152 9.13553 12.1135L9.03259 12.0541Z"
  }));
},
    JU = function JU(_ref2797) {
  var _ref2797$color = _ref2797.color,
      C = _ref2797$color === void 0 ? "currentColor" : _ref2797$color,
      _ref2797$size = _ref2797.size,
      e = _ref2797$size === void 0 ? 24 : _ref2797$size,
      l = _ref2797.className,
      i = _objectWithoutProperties(_ref2797, _excluded2797);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10.8193 8.42654C10.0602 7.34217 9.77392 6.55513 9.71179 5.98243C9.6531 5.44149 9.78522 5.01294 10.0473 4.59929C10.3303 4.15244 10.755 3.73687 11.2954 3.24643C11.8004 2.78803 12.4323 2.24339 12.9281 1.62639L11.369 0.373657C10.9532 0.891134 10.4413 1.32064 9.95118 1.76549C9.41712 2.25024 8.80225 2.82728 8.35773 3.52902C7.89217 4.26395 7.60866 5.13997 7.72346 6.19813C7.83481 7.22454 8.31113 8.33114 9.18085 9.57351L10.8193 8.42654ZM12.0691 5.39666C12.3539 4.71314 12.9313 4.02758 13.8492 3.24077L15.1508 4.75928C14.3187 5.47247 14.0211 5.91191 13.9153 6.16589C13.8112 6.41559 13.8802 6.66497 13.9502 6.91319C14.0337 7.20908 14.1728 7.70231 14.1639 8.23544C14.1522 8.94083 13.9104 9.6872 13.3321 10.5547L11.6679 9.44533C12.0896 8.81285 12.1603 8.43422 12.1642 8.20211C12.1691 7.907 12.0921 7.74146 11.9674 7.24256C11.8478 6.76427 11.7573 6.14506 12.0691 5.39666ZM6.14205 9.99985C6.61127 9.68577 7.19166 9.52606 7.73387 9.39563L7.26613 7.4511C6.45314 7.64666 5.71471 7.91182 5.15413 8.25779C4.64408 8.57258 4 9.13581 4 9.99993C4 10.7262 4.48572 11.306 5.06549 11.6857C5.02301 11.8687 5 12.0596 5 12.2576C5 13.238 5.41805 14.0646 6.14274 14.6786C6.03632 14.9777 5.98811 15.3119 6.00331 15.6465C5.22587 15.7972 4.46698 16.0193 3.83335 16.3097C3.40087 16.5079 2.97509 16.7612 2.64304 17.0874C2.30876 17.4157 2 17.8913 2 18.5C2 18.927 2.18863 19.2717 2.37382 19.5093C2.56286 19.7519 2.8059 19.9586 3.05811 20.1338C3.56429 20.4854 4.24239 20.8028 5.0167 21.0702C6.57504 21.6084 8.68585 22 11 22C14.3273 22 16.6627 21.6161 18.1899 21.2177C18.9534 21.0185 19.5137 20.816 19.894 20.6568C20.1036 20.5691 20.3141 20.4759 20.5102 20.3601C20.5209 20.3537 19.4817 18.6448 19.4864 18.642C18.9216 18.9361 18.2983 19.1224 17.6851 19.2824C16.3373 19.634 14.1727 20 11 20C8.89587 20 7.00668 19.6416 5.6696 19.1798C5.13841 18.9964 4.58196 18.7818 4.12894 18.4405C4.24432 18.3492 4.41971 18.241 4.66665 18.1278C5.22462 17.8721 5.98958 17.6623 6.80607 17.5366C7.03515 17.7796 7.30872 17.994 7.62113 18.1763C8.58641 18.7394 9.91268 19 11.5 19C12.81 19 13.7578 18.8682 14.3982 18.7263C14.7536 18.6476 15.1117 18.5587 15.4402 18.3979C15.4434 18.3964 14.5589 16.6026 14.5589 16.6026C14.3651 16.6735 14.1673 16.729 13.9657 16.7737C13.4775 16.8818 12.6753 17 11.5 17C10.0873 17 9.16359 16.7606 8.62887 16.4487C8.20348 16.2006 8.04009 15.9254 8.00673 15.6255C8.87463 15.8783 9.90235 16 11.0625 16C12.5261 16 13.5815 15.8565 14.2908 15.7033C14.6765 15.62 15.0664 15.5241 15.4255 15.3566C15.4458 15.3469 14.5678 13.5498 14.5678 13.5498C14.513 13.5722 14.2892 13.6575 13.8686 13.7483C13.3082 13.8694 12.3949 14 11.0625 14C9.45935 14 8.39107 13.7356 7.76003 13.3767C7.28904 13.1088 7.08228 12.8089 7.02081 12.487C8.26048 12.8135 9.82491 12.9999 11.5 12.9999C13.3167 12.9999 15.0016 12.7806 16.2832 12.4022L15.7168 10.4841C14.6626 10.7954 13.1762 10.9999 11.5 10.9999C9.77625 10.9999 8.25501 10.7836 7.19789 10.4584C6.69889 10.3048 6.35214 10.1417 6.14205 9.99985ZM17.5905 10.7457C18.8029 10.6355 19.2497 10.934 19.3939 11.0885C19.543 11.2483 19.5952 11.496 19.5299 11.7573C19.4137 12.2219 19.0872 12.6724 18.5567 13.0863C18.0281 13.4988 17.3563 13.8266 16.6839 14.0506L17.3161 15.9481C18.1437 15.6723 19.0344 15.2504 19.787 14.6631C20.5378 14.0773 21.2113 13.278 21.4701 12.2424C21.6547 11.5039 21.5819 10.5016 20.8561 9.72387C20.1252 8.94081 18.9471 8.61417 17.4095 8.75396L17.5905 10.7457Z"
  }));
},
    YU = function YU(_ref2798) {
  var _ref2798$color = _ref2798.color,
      C = _ref2798$color === void 0 ? "currentColor" : _ref2798$color,
      _ref2798$size = _ref2798.size,
      e = _ref2798$size === void 0 ? 24 : _ref2798$size,
      l = _ref2798.className,
      i = _objectWithoutProperties(_ref2798, _excluded2798);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 3C2.44772 3 2 3.44772 2 4V8L7.5 8V3H3ZM9.5 3V8H14.5V3H9.5ZM16.5 3V8H22V4C22 3.44772 21.5523 3 21 3H16.5ZM22 10H16.5V14H22V10ZM22 16H16.5V21H21C21.5523 21 22 20.5523 22 20V16ZM14.5 21V16H9.5V21H14.5ZM7.5 21V16H2V20C2 20.5523 2.44772 21 3 21H7.5ZM2 14H7.5V10L2 10V14ZM9.5 10H14.5V14H9.5V10Z"
  }));
},
    _U = function _U(_ref2799) {
  var _ref2799$color = _ref2799.color,
      C = _ref2799$color === void 0 ? "currentColor" : _ref2799$color,
      _ref2799$size = _ref2799.size,
      e = _ref2799$size === void 0 ? 24 : _ref2799$size,
      l = _ref2799.className,
      i = _objectWithoutProperties(_ref2799, _excluded2799);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 10L8 10V14H4V10ZM4 19V16H8V19H4ZM10 19V16H14V19H10ZM16 19V16H20V19H16ZM16 14V10H20V14H16ZM16 8V5H20V8H16ZM14 5V8H10V5H14ZM14 10V14H10V10H14ZM4 8V5H8V8L4 8ZM3 3C2.44772 3 2 3.44772 2 4V20C2 20.5523 2.44772 21 3 21H21C21.5523 21 22 20.5523 22 20V4C22 3.44772 21.5523 3 21 3H3Z"
  }));
},
    $U = function $U(_ref2800) {
  var _ref2800$color = _ref2800.color,
      C = _ref2800$color === void 0 ? "currentColor" : _ref2800$color,
      _ref2800$size = _ref2800.size,
      e = _ref2800$size === void 0 ? 24 : _ref2800$size,
      l = _ref2800.className,
      i = _objectWithoutProperties(_ref2800, _excluded2800);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 3C3.44772 3 3 3.44772 3 4V20C3 20.5523 3.44772 21 4 21H20C20.5523 21 21 20.5523 21 20V4C21 3.44772 20.5523 3 20 3H4ZM7 9V7H17V9H7ZM7 13V11H17V13H7ZM17 17H7V15H17V17Z"
  }));
},
    eG = function eG(_ref2801) {
  var _ref2801$color = _ref2801.color,
      C = _ref2801$color === void 0 ? "currentColor" : _ref2801$color,
      _ref2801$size = _ref2801.size,
      e = _ref2801$size === void 0 ? 24 : _ref2801$size,
      l = _ref2801.className,
      i = _objectWithoutProperties(_ref2801, _excluded2801);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5 19H19V5H5V19ZM3 4C3 3.44772 3.44772 3 4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4ZM7 9H17V7H7V9ZM17 13H7V11H17V13ZM7 17H17V15H7V17Z"
  }));
},
    tG = function tG(_ref2802) {
  var _ref2802$color = _ref2802.color,
      C = _ref2802$color === void 0 ? "currentColor" : _ref2802$color,
      _ref2802$size = _ref2802.size,
      e = _ref2802$size === void 0 ? 24 : _ref2802$size,
      l = _ref2802.className,
      i = _objectWithoutProperties(_ref2802, _excluded2802);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 3C3.44772 3 3 3.44772 3 4V20C3 20.5523 3.44772 21 4 21H20C20.5523 21 21 20.5523 21 20V4C21 3.44772 20.5523 3 20 3H4ZM6.99993 16.9999V6.99993H8.99993V16.9999H6.99993ZM10.9999 6.99993H12.9999V16.9999H10.9999V6.99993ZM14.9999 6.99993H16.9999V16.9999H14.9999V6.99993Z"
  }));
},
    CG = function CG(_ref2803) {
  var _ref2803$color = _ref2803.color,
      C = _ref2803$color === void 0 ? "currentColor" : _ref2803$color,
      _ref2803$size = _ref2803.size,
      e = _ref2803$size === void 0 ? 24 : _ref2803$size,
      l = _ref2803.className,
      i = _objectWithoutProperties(_ref2803, _excluded2803);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5 19H19V5H5V19ZM3 4C3 3.44772 3.44772 3 4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4ZM15 7V17H17V7H15ZM11 7L11 17H13V7H11ZM7 17L7 7L9 7L9 17H7Z"
  }));
},
    lG = function lG(_ref2804) {
  var _ref2804$color = _ref2804.color,
      C = _ref2804$color === void 0 ? "currentColor" : _ref2804$color,
      _ref2804$size = _ref2804.size,
      e = _ref2804$size === void 0 ? 24 : _ref2804$size,
      l = _ref2804.className,
      i = _objectWithoutProperties(_ref2804, _excluded2804);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 3.5L9 8.49955L4 13.5V3.5ZM21 19.9995V17.9995H3V19.9995H21ZM21 12.9995V10.9995H12V12.9995H21ZM21 5.99951V3.99951H12V5.99951H21Z"
  }));
},
    iG = function iG(_ref2805) {
  var _ref2805$color = _ref2805.color,
      C = _ref2805$color === void 0 ? "currentColor" : _ref2805$color,
      _ref2805$size = _ref2805.size,
      e = _ref2805$size === void 0 ? 24 : _ref2805$size,
      l = _ref2805.className,
      i = _objectWithoutProperties(_ref2805, _excluded2805);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4.40347 3.90332L2.98926 5.31753L6.17124 8.49951L2.98926 11.6815L4.40347 13.0957L8.99967 8.49951L4.40347 3.90332ZM20.9997 19.9995V17.9995H2.99967V19.9995H20.9997ZM20.9997 12.9995V10.9995H11.9997V12.9995H20.9997ZM20.9997 5.99951V3.99951H11.9997V5.99951H20.9997Z"
  }));
},
    sG = function sG(_ref2806) {
  var _ref2806$color = _ref2806.color,
      C = _ref2806$color === void 0 ? "currentColor" : _ref2806$color,
      _ref2806$size = _ref2806.size,
      e = _ref2806$size === void 0 ? 24 : _ref2806$size,
      l = _ref2806.className,
      i = _objectWithoutProperties(_ref2806, _excluded2806);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 4H7V6H21V4ZM21 11H11V13H21V11ZM21 18H7V20H21V18ZM8 17V7L3 11.9996L8 17Z"
  }));
},
    rG = function rG(_ref2807) {
  var _ref2807$color = _ref2807.color,
      C = _ref2807$color === void 0 ? "currentColor" : _ref2807$color,
      _ref2807$size = _ref2807.size,
      e = _ref2807$size === void 0 ? 24 : _ref2807$size,
      l = _ref2807.className,
      i = _objectWithoutProperties(_ref2807, _excluded2807);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 4H7V6H21V4ZM21 11H11V13H21V11ZM21 18H7V20H21V18ZM9.01041 8.81412L7.59619 7.3999L3 11.9961L7.59619 16.5923L9.01041 15.1781L5.82843 11.9961L9.01041 8.81412Z"
  }));
},
    cG = function cG(_ref2808) {
  var _ref2808$color = _ref2808.color,
      C = _ref2808$color === void 0 ? "currentColor" : _ref2808$color,
      _ref2808$size = _ref2808.size,
      e = _ref2808$size === void 0 ? 24 : _ref2808$size,
      l = _ref2808.className,
      i = _objectWithoutProperties(_ref2808, _excluded2808);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 4H7V6H21V4ZM21 11H11V13H21V11ZM21 18H7V20H21V18ZM3 17V7L8 11.9996L3 17Z"
  }));
},
    oG = function oG(_ref2809) {
  var _ref2809$color = _ref2809.color,
      C = _ref2809$color === void 0 ? "currentColor" : _ref2809$color,
      _ref2809$size = _ref2809.size,
      e = _ref2809$size === void 0 ? 24 : _ref2809$size,
      l = _ref2809.className,
      i = _objectWithoutProperties(_ref2809, _excluded2809);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.9997 4H6.99967V6H20.9997V4ZM20.9997 11H10.9997V13H20.9997V11ZM20.9997 18H6.99967V20H20.9997V18ZM1.98926 8.81412L3.40347 7.3999L7.99967 11.9961L3.40347 16.5923L1.98926 15.1781L5.17124 11.9961L1.98926 8.81412Z"
  }));
},
    aG = function aG(_ref2810) {
  var _ref2810$color = _ref2810.color,
      C = _ref2810$color === void 0 ? "currentColor" : _ref2810$color,
      _ref2810$size = _ref2810.size,
      e = _ref2810$size === void 0 ? 24 : _ref2810$size,
      l = _ref2810.className,
      i = _objectWithoutProperties(_ref2810, _excluded2810);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 3.5V13.5L16 8.49955L21 3.5ZM21 19.9995V17.9995H3V19.9995H21ZM12 12.9995V10.9995H3V12.9995H12ZM12 5.99951V3.99951H3V5.99951H12Z"
  }));
},
    nG = function nG(_ref2811) {
  var _ref2811$color = _ref2811.color,
      C = _ref2811$color === void 0 ? "currentColor" : _ref2811$color,
      _ref2811$size = _ref2811.size,
      e = _ref2811$size === void 0 ? 24 : _ref2811$size,
      l = _ref2811.className,
      i = _objectWithoutProperties(_ref2811, _excluded2811);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.5956 3.90332L15.9994 8.49951L20.5956 13.0957L22.0098 11.6815L18.8278 8.49951L22.0098 5.31753L20.5956 3.90332ZM21 19.9995V17.9995H3V19.9995H21ZM12 12.9995V10.9995H3V12.9995H12ZM12 5.99951V3.99951H3V5.99951H12Z"
  }));
},
    mG = function mG(_ref2812) {
  var _ref2812$color = _ref2812.color,
      C = _ref2812$color === void 0 ? "currentColor" : _ref2812$color,
      _ref2812$size = _ref2812.size,
      e = _ref2812$size === void 0 ? 24 : _ref2812$size,
      l = _ref2812.className,
      i = _objectWithoutProperties(_ref2812, _excluded2812);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17 4H3V6H17V4ZM13 11H3V13H13V11ZM17 18H3V20H17V18ZM17 17V7L22 11.9996L17 17Z"
  }));
},
    wG = function wG(_ref2813) {
  var _ref2813$color = _ref2813.color,
      C = _ref2813$color === void 0 ? "currentColor" : _ref2813$color,
      _ref2813$size = _ref2813.size,
      e = _ref2813$size === void 0 ? 24 : _ref2813$size,
      l = _ref2813.className,
      i = _objectWithoutProperties(_ref2813, _excluded2813);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17 4H3V6H17V4ZM13 11H3V13H13V11ZM17 18H3V20H17V18ZM15.9896 8.81412L17.4038 7.3999L22 11.9961L17.4038 16.5923L15.9896 15.1781L19.1716 11.9961L15.9896 8.81412Z"
  }));
},
    LG = function LG(_ref2814) {
  var _ref2814$color = _ref2814.color,
      C = _ref2814$color === void 0 ? "currentColor" : _ref2814$color,
      _ref2814$size = _ref2814.size,
      e = _ref2814$size === void 0 ? 24 : _ref2814$size,
      l = _ref2814.className,
      i = _objectWithoutProperties(_ref2814, _excluded2814);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17 4H3V6H17V4ZM13 11H3V13H13V11ZM17 18H3V20H17V18ZM21 17V7L16 11.9996L21 17Z"
  }));
},
    hG = function hG(_ref2815) {
  var _ref2815$color = _ref2815.color,
      C = _ref2815$color === void 0 ? "currentColor" : _ref2815$color,
      _ref2815$size = _ref2815.size,
      e = _ref2815$size === void 0 ? 24 : _ref2815$size,
      l = _ref2815.className,
      i = _objectWithoutProperties(_ref2815, _excluded2815);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17 4H3V6H17V4ZM13 11H3V13H13V11ZM17 18H3V20H17V18ZM22.0104 8.81412L20.5962 7.3999L16 11.9961L20.5962 16.5923L22.0104 15.1781L18.8284 11.9961L22.0104 8.81412Z"
  }));
},
    HG = function HG(_ref2816) {
  var _ref2816$color = _ref2816.color,
      C = _ref2816$color === void 0 ? "currentColor" : _ref2816$color,
      _ref2816$size = _ref2816.size,
      e = _ref2816$size === void 0 ? 24 : _ref2816$size,
      l = _ref2816.className,
      i = _objectWithoutProperties(_ref2816, _excluded2816);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 6C12 4.46329 12.5777 3.06151 13.5278 2H6C5.44772 2 5 2.44772 5 3V21C5 21.5523 5.44772 22 6 22H18C18.5523 22 19 21.5523 19 21V11.917C18.6748 11.9716 18.3407 12 18 12C14.6863 12 12 9.31371 12 6ZM12 17C12.5523 17 13 17.4477 13 18C13 18.5523 12.5523 19 12 19C11.4477 19 11 18.5523 11 18C11 17.4477 11.4477 17 12 17ZM22 6H19V2H17V6H14L18 10L22 6Z"
  }));
},
    VG = function VG(_ref2817) {
  var _ref2817$color = _ref2817.color,
      C = _ref2817$color === void 0 ? "currentColor" : _ref2817$color,
      _ref2817$size = _ref2817.size,
      e = _ref2817$size === void 0 ? 24 : _ref2817$size,
      l = _ref2817.className,
      i = _objectWithoutProperties(_ref2817, _excluded2817);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7 4V20H17V12H19V21C19 21.5523 18.5523 22 18 22H6C5.44772 22 5 21.5523 5 21V3C5 2.44772 5.44772 2 6 2H13V4H7ZM19 6H22L18 10L14 6H17V2H19V6ZM13 18C13 18.5523 12.5523 19 12 19C11.4477 19 11 18.5523 11 18C11 17.4477 11.4477 17 12 17C12.5523 17 13 17.4477 13 18Z"
  }));
},
    gG = function gG(_ref2818) {
  var _ref2818$color = _ref2818.color,
      C = _ref2818$color === void 0 ? "currentColor" : _ref2818$color,
      _ref2818$size = _ref2818.size,
      e = _ref2818$size === void 0 ? 24 : _ref2818$size,
      l = _ref2818.className,
      i = _objectWithoutProperties(_ref2818, _excluded2818);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM15.9999 8H14.6499V12H15.9999V8ZM9.34609 9.70937L15.405 17.5379L16.4591 16.7293L9.68281 8H8V15.9969H9.34609V9.70937Z"
  }));
},
    MG = function MG(_ref2819) {
  var _ref2819$color = _ref2819.color,
      C = _ref2819$color === void 0 ? "currentColor" : _ref2819$color,
      _ref2819$size = _ref2819.size,
      e = _ref2819$size === void 0 ? 24 : _ref2819$size,
      l = _ref2819.className,
      i = _objectWithoutProperties(_ref2819, _excluded2819);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17.6644 17.6493L10.2602 8H8V16H10V10.9462L16.0869 18.8788C14.8907 19.5909 13.4931 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 14.2053 19.1077 16.2022 17.6644 17.6493ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM14 12V8H16V12H14Z"
  }));
},
    ZG = function ZG(_ref2820) {
  var _ref2820$color = _ref2820.color,
      C = _ref2820$color === void 0 ? "currentColor" : _ref2820$color,
      _ref2820$size = _ref2820.size,
      e = _ref2820$size === void 0 ? 24 : _ref2820$size,
      l = _ref2820.className,
      i = _objectWithoutProperties(_ref2820, _excluded2820);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11.174 22.5552C11.4297 22.6937 11.7051 22.7729 12.0002 22.7729C12.2952 22.7729 12.5902 22.6937 12.8262 22.5947L20.6745 18.023C21.1854 17.7261 21.5 17.172 21.5 16.5781V7.45437C21.5 6.86056 21.1854 6.30644 20.6745 6.00954L12.8262 1.43778C12.3345 1.16072 11.6657 1.16072 11.174 1.43778L3.32604 6.00954C2.81468 6.30644 2.5 6.86056 2.5 7.45437V16.5781C2.5 17.172 2.81468 17.7261 3.32604 18.023L5.3913 19.2105C6.39448 19.7052 6.74854 19.7052 7.20089 19.7052C8.67604 19.7052 9.52182 18.7948 9.52182 17.2313V8.22623C9.52182 8.08765 9.4038 7.98875 9.28578 7.98875H8.28271C8.14495 7.98875 8.04667 8.10749 8.04667 8.22623V17.2313C8.04667 17.924 7.31891 18.6167 6.15844 18.023L4.01453 16.776C3.93578 16.7365 3.89651 16.6376 3.89651 16.5584V7.43453C3.89651 7.35536 3.93578 7.25647 4.01453 7.21689L11.8625 2.66486C11.9214 2.62528 12.0198 2.62528 12.0984 2.66486L19.9466 7.21689C20.0247 7.25647 20.0648 7.33563 20.0648 7.43453V16.5584C20.0648 16.6573 20.0247 16.7365 19.9466 16.776L12.0984 21.3479C12.0394 21.3875 11.9411 21.3875 11.8625 21.3479L9.85624 20.1407C9.79723 20.1011 9.71849 20.0812 9.65948 20.1208C9.10875 20.4375 9.01047 20.477 8.47937 20.6552C8.36135 20.6948 8.16469 20.774 8.55802 20.9917L11.174 22.5552ZM10.2887 13.5698C10.2887 14.9156 10.9967 16.499 14.4393 16.499C16.9169 16.499 18.3531 15.5093 18.3531 13.7677C18.3531 12.0657 17.212 11.6104 14.7929 11.2938C12.3539 10.9772 12.0982 10.799 12.0982 10.225C12.0982 9.75008 12.3146 9.11679 14.1242 9.11679C15.7367 9.11679 16.3463 9.47302 16.5828 10.5615C16.6023 10.6605 16.701 10.7397 16.7987 10.7397H17.8411C17.9008 10.7397 17.9594 10.7001 17.9994 10.6605C18.0385 10.6011 18.058 10.5418 18.058 10.4824C17.9008 8.58241 16.6619 7.71155 14.1438 7.71155C11.9015 7.71155 10.564 8.66157 10.564 10.2646C10.564 11.9865 11.9015 12.4615 14.0454 12.6792C16.6219 12.9365 16.8192 13.3126 16.8192 13.8271C16.8192 14.7177 16.1109 15.0938 14.4588 15.0938C12.3736 15.0938 11.9212 14.5792 11.7639 13.5302C11.7639 13.4115 11.6655 13.3323 11.5475 13.3323H10.5247C10.387 13.3323 10.2887 13.4511 10.2887 13.5698Z"
  }));
},
    xG = function xG(_ref2821) {
  var _ref2821$color = _ref2821.color,
      C = _ref2821$color === void 0 ? "currentColor" : _ref2821$color,
      _ref2821$size = _ref2821.size,
      e = _ref2821$size === void 0 ? 24 : _ref2821$size,
      l = _ref2821.className,
      i = _objectWithoutProperties(_ref2821, _excluded2821);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.8873 1.36173C12.3396 1.03958 11.6604 1.03958 11.1127 1.36173L3.36271 5.92056C2.8282 6.23498 2.5 6.8088 2.5 7.42894V16.571C2.5 17.1912 2.8282 17.765 3.36272 18.0794L5.98596 19.6225C7.31923 20.4068 9 19.4454 9 17.8986V7.74655H7V17.8986L4.5 16.428V7.57193L12 3.16016L19.5 7.57193V16.428L12 20.8398L10.2316 19.7996L9.21757 21.5234L11.1127 22.6382C11.6604 22.9604 12.3396 22.9604 12.8873 22.6382L20.6373 18.0794C21.1718 17.765 21.5 17.1912 21.5 16.571V7.42894C21.5 6.8088 21.1718 6.23498 20.6373 5.92056L12.8873 1.36173ZM13.9999 7.49998C12.6372 7.49998 11.6712 7.85114 11.0504 8.46993C10.4336 9.08484 10.3135 9.80885 10.3135 10.2313C10.3135 10.7862 10.4705 11.289 10.7951 11.7048C11.1076 12.1053 11.5199 12.3537 11.9146 12.5159C12.6341 12.8116 13.5358 12.9086 14.2587 12.9863L14.346 12.9957C15.1774 13.0856 15.7998 13.1627 16.2263 13.3411C16.4189 13.4217 16.4983 13.4954 16.531 13.5379C16.5524 13.5658 16.5934 13.6278 16.5934 13.7977C16.5934 14.0618 16.5027 14.2319 16.2204 14.3926C15.873 14.5904 15.2596 14.7396 14.3368 14.7396C13.4218 14.7396 12.7838 14.5705 12.4192 14.3181C12.1357 14.1218 11.9273 13.821 11.9822 13.1683L9.98923 13.0007C9.88075 14.29 10.3479 15.3167 11.2808 15.9625C12.1325 16.5521 13.2518 16.7396 14.3368 16.7396C15.414 16.7396 16.4289 16.5753 17.2098 16.1307C18.0558 15.6491 18.5934 14.8482 18.5934 13.7977C18.5934 13.2414 18.4381 12.7369 18.1162 12.3184C17.8054 11.9144 17.3942 11.6617 16.9981 11.496C16.2701 11.1915 15.3576 11.0932 14.6296 11.0147H14.6296L14.5609 11.0073C13.7274 10.9172 13.1036 10.8423 12.6748 10.666C12.4808 10.5863 12.4025 10.5137 12.3716 10.4742C12.3528 10.4501 12.3135 10.394 12.3135 10.2313C12.3135 10.1538 12.3363 10.0121 12.4624 9.88637C12.5847 9.76449 12.9618 9.49998 13.9999 9.49998C14.9904 9.49998 15.5674 9.60515 15.897 9.80064C16.1123 9.92838 16.3451 10.1633 16.3761 10.9329L18.3745 10.8524C18.3243 9.60675 17.8694 8.64527 16.9173 8.08051C16.0795 7.58349 15.0094 7.49998 13.9999 7.49998Z"
  }));
},
    vG = function vG(_ref2822) {
  var _ref2822$color = _ref2822.color,
      C = _ref2822$color === void 0 ? "currentColor" : _ref2822$color,
      _ref2822$size = _ref2822.size,
      e = _ref2822$size === void 0 ? 24 : _ref2822$size,
      l = _ref2822.className,
      i = _objectWithoutProperties(_ref2822, _excluded2822);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6 3H8V21H6V3ZM16 3H18V21H16V3Z"
  }));
},
    dG = function dG(_ref2823) {
  var _ref2823$color = _ref2823.color,
      C = _ref2823$color === void 0 ? "currentColor" : _ref2823$color,
      _ref2823$size = _ref2823.size,
      e = _ref2823$size === void 0 ? 24 : _ref2823$size,
      l = _ref2823.className,
      i = _objectWithoutProperties(_ref2823, _excluded2823);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6 3H8V21H6V3ZM16 3H18V21H16V3Z"
  }));
},
    pG = function pG(_ref2824) {
  var _ref2824$color = _ref2824.color,
      C = _ref2824$color === void 0 ? "currentColor" : _ref2824$color,
      _ref2824$size = _ref2824.size,
      e = _ref2824$size === void 0 ? 24 : _ref2824$size,
      l = _ref2824.className,
      i = _objectWithoutProperties(_ref2824, _excluded2824);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6 20.1957V3.80421C6 3.01878 6.86395 2.53993 7.53 2.95621L20.6432 11.152C21.2699 11.5436 21.2699 12.4563 20.6432 12.848L7.53 21.0437C6.86395 21.46 6 20.9812 6 20.1957Z"
  }));
},
    EG = function EG(_ref2825) {
  var _ref2825$color = _ref2825.color,
      C = _ref2825$color === void 0 ? "currentColor" : _ref2825$color,
      _ref2825$size = _ref2825.size,
      e = _ref2825$size === void 0 ? 24 : _ref2825$size,
      l = _ref2825.className,
      i = _objectWithoutProperties(_ref2825, _excluded2825);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8 18.3915V5.60846L18.2264 12L8 18.3915ZM6 3.80421V20.1957C6 20.9812 6.86395 21.46 7.53 21.0437L20.6432 12.848C21.2699 12.4563 21.2699 11.5436 20.6432 11.152L7.53 2.95621C6.86395 2.53993 6 3.01878 6 3.80421Z"
  }));
},
    NG = function NG(_ref2826) {
  var _ref2826$color = _ref2826.color,
      C = _ref2826$color === void 0 ? "currentColor" : _ref2826$color,
      _ref2826$size = _ref2826.size,
      e = _ref2826$size === void 0 ? 24 : _ref2826$size,
      l = _ref2826.className,
      i = _objectWithoutProperties(_ref2826, _excluded2826);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18 20.1957V3.80421C18 3.01878 17.1361 2.53993 16.47 2.95621L3.3568 11.152C2.73013 11.5436 2.73013 12.4563 3.3568 12.848L16.47 21.0437C17.136 21.46 18 20.9812 18 20.1957Z"
  }));
},
    uG = function uG(_ref2827) {
  var _ref2827$color = _ref2827.color,
      C = _ref2827$color === void 0 ? "currentColor" : _ref2827$color,
      _ref2827$size = _ref2827.size,
      e = _ref2827$size === void 0 ? 24 : _ref2827$size,
      l = _ref2827.className,
      i = _objectWithoutProperties(_ref2827, _excluded2827);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16 18.3915V5.60846L5.77359 12L16 18.3915ZM18 3.80421V20.1957C18 20.9812 17.136 21.46 16.47 21.0437L3.3568 12.848C2.73013 12.4563 2.73013 11.5436 3.3568 11.152L16.47 2.95621C17.1361 2.53993 18 3.01878 18 3.80421Z"
  }));
},
    BG = function BG(_ref2828) {
  var _ref2828$color = _ref2828.color,
      C = _ref2828$color === void 0 ? "currentColor" : _ref2828$color,
      _ref2828$size = _ref2828.size,
      e = _ref2828$size === void 0 ? 24 : _ref2828$size,
      l = _ref2828.className,
      i = _objectWithoutProperties(_ref2828, _excluded2828);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2.91312 11.6739C3.23584 10.1953 3.53865 8.80805 2 6.5L5.5 2.5C5.5 2.5 9 4 12 1.5C15 4 18.5 2.5 18.5 2.5L22 6.5C20.4612 8.8081 20.7641 10.1954 21.0868 11.674C21.3933 13.0781 21.7177 14.5645 20.5 17C19.3425 19.315 17.3478 20.1227 15.4849 20.877C14.1289 21.4261 12.8428 21.9469 12.0003 23C11.1577 21.9469 9.8715 21.4261 8.51549 20.8771C6.65245 20.1227 4.65758 19.315 3.50001 17C2.28218 14.5645 2.60663 13.078 2.91312 11.6739ZM14.3776 12.7725L16.7552 10.4549L13.4694 9.97746L11.9999 7L10.5304 9.97746L7.24463 10.4549L9.62227 12.7725L9.06098 16.0451L11.9999 14.5L14.9388 16.0451L14.3776 12.7725Z"
  }));
},
    fG = function fG(_ref2829) {
  var _ref2829$color = _ref2829.color,
      C = _ref2829$color === void 0 ? "currentColor" : _ref2829$color,
      _ref2829$size = _ref2829.size,
      e = _ref2829$size === void 0 ? 24 : _ref2829$size,
      l = _ref2829.className,
      i = _objectWithoutProperties(_ref2829, _excluded2829);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16.4749 4.935C16.9805 4.90972 17.437 4.8446 17.8262 4.76709L19.5583 6.74664C19.168 7.5663 18.9456 8.34894 18.8629 9.12355C18.7392 10.2814 18.9517 11.2675 19.1081 11.9874L19.1152 12.02C19.2771 12.7643 19.3835 13.2536 19.3679 13.8288C19.3533 14.3705 19.2212 15.0854 18.7112 16.1056C17.6105 18.307 15.0162 18.7716 12.9964 19.7815C12.6702 19.9446 12.3335 20.1308 12.0002 20.3499C11.6669 20.1308 11.3301 19.9445 11.0039 19.7814C8.98405 18.7716 6.38962 18.307 5.28885 16.1055C4.77874 15.0854 4.64666 14.3704 4.63201 13.8287C4.61645 13.2535 4.72283 12.7642 4.8847 12.0198L4.89176 11.9873C5.04823 11.2676 5.2607 10.2815 5.13707 9.12358C5.05436 8.34897 4.83196 7.56633 4.44171 6.74666L6.17384 4.76709C6.56299 4.8446 7.01951 4.90972 7.52512 4.935C8.78997 4.99825 10.402 4.81028 12 3.91846C13.598 4.81028 15.21 4.99825 16.4749 4.935ZM21.0868 11.674C20.7641 10.1954 20.4612 8.8081 22 6.5L18.5 2.5C18.5 2.5 15 4 12 1.5C9 4 5.5 2.5 5.5 2.5L2 6.5C3.53865 8.80805 3.23584 10.1953 2.91312 11.6739C2.60663 13.078 2.28218 14.5645 3.50001 17C5.07707 20.1539 8.20822 20.5102 10.4428 21.7453C11.0423 22.0766 11.5772 22.4712 12.0003 23C12.4234 22.4712 12.9583 22.0766 13.5578 21.7452C15.7921 20.5102 18.9231 20.1539 20.5 17C21.7177 14.5645 21.3933 13.0781 21.0868 11.674ZM14.3776 12.7725L14.9388 16.0451L11.9999 14.5L9.06098 16.0451L9.62227 12.7725L7.24463 10.4549L10.5304 9.97746L11.9999 7L13.4694 9.97746L16.7552 10.4549L14.3776 12.7725Z"
  }));
},
    RG = function RG(_ref2830) {
  var _ref2830$color = _ref2830.color,
      C = _ref2830$color === void 0 ? "currentColor" : _ref2830$color,
      _ref2830$size = _ref2830.size,
      e = _ref2830$size === void 0 ? 24 : _ref2830$size,
      l = _ref2830.className,
      i = _objectWithoutProperties(_ref2830, _excluded2830);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4.25705 18.3287C2.84636 16.6049 2 14.4013 2 12C2 6.47715 6.47715 2 12 2C14.4013 2 16.6049 2.84637 18.3287 4.25705L4.25705 18.3287ZM19.7429 5.67127C21.1536 7.39514 22 9.59873 22 12C22 17.5228 17.5228 22 12 22C9.59873 22 7.39514 21.1536 5.67127 19.7429L19.7429 5.67127Z"
  }));
},
    zG = function zG(_ref2831) {
  var _ref2831$color = _ref2831.color,
      C = _ref2831$color === void 0 ? "currentColor" : _ref2831$color,
      _ref2831$size = _ref2831.size,
      e = _ref2831$size === void 0 ? 24 : _ref2831$size,
      l = _ref2831.className,
      i = _objectWithoutProperties(_ref2831, _excluded2831);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16.9057 5.68009L5.68009 16.9057C4.62644 15.5506 4 13.8491 4 12C4 7.58172 7.58172 4 12 4C13.8491 4 15.5506 4.62644 16.9057 5.68009ZM7.0943 18.3199L18.3199 7.0943C19.3736 8.44939 20 10.1509 20 12C20 16.4183 16.4183 20 12 20C10.1509 20 8.44939 19.3736 7.0943 18.3199ZM12 2C6.47715 2 2 6.47715 2 12C2 17.5223 6.47771 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47771 17.5223 2 12 2Z"
  }));
},
    FG = function FG(_ref2832) {
  var _ref2832$color = _ref2832.color,
      C = _ref2832$color === void 0 ? "currentColor" : _ref2832$color,
      _ref2832$size = _ref2832.size,
      e = _ref2832$size === void 0 ? 24 : _ref2832$size,
      l = _ref2832.className,
      i = _objectWithoutProperties(_ref2832, _excluded2832);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9 6C9 4.34315 10.3431 3 12 3C13.6569 3 15 4.34315 15 6H9ZM7 6H4C3.44772 6 3 6.44772 3 7V21C3 21.5523 3.44772 22 4 22H20C20.5523 22 21 21.5523 21 21V7C21 6.44772 20.5523 6 20 6H17C17 3.23858 14.7614 1 12 1C9.23858 1 7 3.23858 7 6ZM9 10C9 11.6569 10.3431 13 12 13C13.6569 13 15 11.6569 15 10H17C17 12.7614 14.7614 15 12 15C9.23858 15 7 12.7614 7 10H9Z"
  }));
},
    SG = function SG(_ref2833) {
  var _ref2833$color = _ref2833.color,
      C = _ref2833$color === void 0 ? "currentColor" : _ref2833$color,
      _ref2833$size = _ref2833.size,
      e = _ref2833$size === void 0 ? 24 : _ref2833$size,
      l = _ref2833.className,
      i = _objectWithoutProperties(_ref2833, _excluded2833);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9 6H15C15 4.34315 13.6569 3 12 3C10.3431 3 9 4.34315 9 6ZM7 6C7 3.23858 9.23858 1 12 1C14.7614 1 17 3.23858 17 6H20C20.5523 6 21 6.44772 21 7V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V7C3 6.44772 3.44772 6 4 6H7ZM5 8V20H19V8H5ZM9 10C9 11.6569 10.3431 13 12 13C13.6569 13 15 11.6569 15 10H17C17 12.7614 14.7614 15 12 15C9.23858 15 7 12.7614 7 10H9Z"
  }));
},
    AG = function AG(_ref2834) {
  var _ref2834$color = _ref2834.color,
      C = _ref2834$color === void 0 ? "currentColor" : _ref2834$color,
      _ref2834$size = _ref2834.size,
      e = _ref2834$size === void 0 ? 24 : _ref2834$size,
      l = _ref2834.className,
      i = _objectWithoutProperties(_ref2834, _excluded2834);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11.9998 3.29814L14.4451 1.66794L15.5545 3.33204L12.9998 5.03517V10.2678L17.5313 7.65149L17.7289 4.58748L19.7247 4.7162L19.5356 7.64899L22.17 8.95159L21.2836 10.7444L18.5313 9.38354L14.0001 11.9996L18.5317 14.616L21.284 13.2551L22.1704 15.0479L19.536 16.3505L19.7251 19.2833L17.7293 19.412L17.5317 16.348L12.9998 13.7315V18.9648L15.5545 20.6679L14.4451 22.332L11.9998 20.7018L9.55446 22.332L8.44506 20.6679L10.9998 18.9648V13.7319L6.46786 16.3484L6.27026 19.4124L4.2744 19.2836L4.46355 16.3508L1.8291 15.0483L2.71555 13.2554L5.46786 14.6163L10.0001 11.9996L5.46824 9.38319L2.71594 10.7441L1.82948 8.95124L4.46393 7.64864L4.27478 4.71585L6.27064 4.58713L6.46824 7.65113L10.9998 10.2674V5.03517L8.44506 3.33204L9.55446 1.66794L11.9998 3.29814Z"
  }));
},
    kG = function kG(_ref2835) {
  var _ref2835$color = _ref2835.color,
      C = _ref2835$color === void 0 ? "currentColor" : _ref2835$color,
      _ref2835$size = _ref2835.size,
      e = _ref2835$size === void 0 ? 24 : _ref2835$size,
      l = _ref2835.className,
      i = _objectWithoutProperties(_ref2835, _excluded2835);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11.9998 3.29814L14.4451 1.66794L15.5545 3.33204L12.9998 5.03517V10.2678L17.5313 7.65149L17.7289 4.58748L19.7247 4.7162L19.5356 7.64899L22.17 8.95159L21.2836 10.7444L18.5313 9.38354L14.0001 11.9996L18.5317 14.616L21.284 13.2551L22.1704 15.0479L19.536 16.3505L19.7251 19.2833L17.7293 19.412L17.5317 16.348L12.9998 13.7315V18.9648L15.5545 20.6679L14.4451 22.332L11.9998 20.7018L9.55446 22.332L8.44506 20.6679L10.9998 18.9648V13.7319L6.46786 16.3484L6.27026 19.4124L4.2744 19.2836L4.46355 16.3508L1.8291 15.0483L2.71555 13.2554L5.46786 14.6163L10.0001 11.9996L5.46824 9.38319L2.71594 10.7441L1.82948 8.95124L4.46393 7.64864L4.27478 4.71585L6.27064 4.58713L6.46824 7.65113L10.9998 10.2674V5.03517L8.44506 3.33204L9.55446 1.66794L11.9998 3.29814Z"
  }));
},
    PG = function PG(_ref2836) {
  var _ref2836$color = _ref2836.color,
      C = _ref2836$color === void 0 ? "currentColor" : _ref2836$color,
      _ref2836$size = _ref2836.size,
      e = _ref2836$size === void 0 ? 24 : _ref2836$size,
      l = _ref2836.className,
      i = _objectWithoutProperties(_ref2836, _excluded2836);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15.382 4H22V6H16.618L9 21.2361L5.38197 14H2V12H6.61803L9 16.7639L15.382 4Z"
  }));
},
    DG = function DG(_ref2837) {
  var _ref2837$color = _ref2837.color,
      C = _ref2837$color === void 0 ? "currentColor" : _ref2837$color,
      _ref2837$size = _ref2837.size,
      e = _ref2837$size === void 0 ? 24 : _ref2837$size,
      l = _ref2837.className,
      i = _objectWithoutProperties(_ref2837, _excluded2837);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 4C3 3.44772 3.44772 3 4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4Z"
  }));
},
    yG = function yG(_ref2838) {
  var _ref2838$color = _ref2838.color,
      C = _ref2838$color === void 0 ? "currentColor" : _ref2838$color,
      _ref2838$size = _ref2838.size,
      e = _ref2838$size === void 0 ? 24 : _ref2838$size,
      l = _ref2838.className,
      i = _objectWithoutProperties(_ref2838, _excluded2838);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5 5H19V19H5V5ZM4 3C3.44772 3 3 3.44772 3 4V20C3 20.5523 3.44772 21 4 21H20C20.5523 21 21 20.5523 21 20V4C21 3.44772 20.5523 3 20 3H4Z"
  }));
},
    bG = function bG(_ref2839) {
  var _ref2839$color = _ref2839.color,
      C = _ref2839$color === void 0 ? "currentColor" : _ref2839$color,
      _ref2839$size = _ref2839.size,
      e = _ref2839$size === void 0 ? 24 : _ref2839$size,
      l = _ref2839.className,
      i = _objectWithoutProperties(_ref2839, _excluded2839);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11.9996 4.85999C8.82628 4.85999 6.84294 6.44665 6.04961 9.61999C7.23961 8.03332 8.62794 7.43832 10.2146 7.83499C11.12 8.06109 11.7666 8.71757 12.4835 9.44545C13.6507 10.6295 15.0004 12 17.9496 12C21.1229 12 23.1063 10.4133 23.8996 7.23998C22.7096 8.82665 21.3213 9.42165 19.7346 9.02499C18.8292 8.79889 18.1827 8.1424 17.4657 7.41452C16.2995 6.23047 14.9498 4.85999 11.9996 4.85999ZM6.04961 12C2.87628 12 0.892943 13.5867 0.0996094 16.76C1.28961 15.1733 2.67794 14.5783 4.26461 14.975C5.17 15.2011 5.81657 15.8576 6.53354 16.5855C7.70073 17.7695 9.05039 19.14 11.9996 19.14C15.1729 19.14 17.1563 17.5533 17.9496 14.38C16.7596 15.9667 15.3713 16.5617 13.7846 16.165C12.8792 15.9389 12.2326 15.2824 11.5157 14.5545C10.3495 13.3705 8.99982 12 6.04961 12Z"
  }));
},
    TG = function TG(_ref2840) {
  var _ref2840$color = _ref2840.color,
      C = _ref2840$color === void 0 ? "currentColor" : _ref2840$color,
      _ref2840$size = _ref2840.size,
      e = _ref2840$size === void 0 ? 24 : _ref2840$size,
      l = _ref2840.className,
      i = _objectWithoutProperties(_ref2840, _excluded2840);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8.1267 6.21913C9.17785 5.37821 10.4989 5 12.0014 5C13.41 5 14.4863 5.33092 15.3593 5.83363C16.0983 6.25922 16.7127 6.84126 17.3072 7.44492C17.953 8.10062 18.3034 8.41984 18.7437 8.52979C19.217 8.64811 19.617 8.61249 19.9825 8.45585C20.3621 8.29317 20.7745 7.96918 21.2014 7.4L22.9715 8.24254C22.6005 9.72673 21.9241 10.9425 20.8761 11.7809C19.8249 12.6218 18.5038 13 17.0014 13C15.5931 13 14.517 12.669 13.6441 12.1664C12.8103 11.6862 12.2012 11.068 11.7232 10.583C11.0611 9.9112 10.7056 9.5817 10.2591 9.47021C9.78583 9.35189 9.3858 9.38751 9.02031 9.54415C8.64071 9.70683 8.22828 10.0308 7.80139 10.6L6.03125 9.75746C6.4023 8.27328 7.07869 7.05754 8.1267 6.21913ZM12.0014 7C11.1728 7 10.5057 7.14609 9.96802 7.40781C11.2881 7.49046 12.1492 8.30299 13.0247 9.12911C13.5289 9.60492 14.0379 10.0852 14.6422 10.4332C15.2012 10.7551 15.9313 11 17.0014 11C17.8299 11 18.497 10.8539 19.0347 10.5922C17.7147 10.5095 16.8538 9.69708 15.9786 8.87101C15.4744 8.39515 14.9655 7.91478 14.3612 7.56679C13.8022 7.24491 13.0719 7 12.0014 7ZM3.1267 12.2191C4.17785 11.3782 5.49894 11 7.00139 11C8.41001 11 9.48634 11.3309 10.3593 11.8336C11.0983 12.2592 11.7127 12.8413 12.3072 13.4449C12.953 14.1006 13.3034 14.4198 13.7437 14.5298C14.217 14.6481 14.617 14.6125 14.9825 14.4559C15.3621 14.2932 15.7745 13.9692 16.2014 13.4L17.9715 14.2425C17.6005 15.7267 16.9241 16.9425 15.8761 17.7809C14.8249 18.6218 13.5038 19 12.0014 19C10.5931 19 9.51701 18.669 8.64412 18.1664C7.81033 17.6862 7.20115 17.068 6.72319 16.583C6.06109 15.9112 5.70557 15.5817 5.25911 15.4702C4.78583 15.3519 4.3858 15.3875 4.02031 15.5441C3.64071 15.7068 3.22828 16.0308 2.80139 16.6L1.03125 15.7575C1.4023 14.2733 2.07869 13.0575 3.1267 12.2191ZM7.00136 13C6.17284 13 5.50571 13.1461 4.96802 13.4078C6.28809 13.4905 7.14918 14.303 8.02466 15.1291L8.02467 15.1291C8.52891 15.6049 9.03793 16.0852 9.64217 16.4332C10.2012 16.7551 10.9313 17 12.0014 17C12.8299 17 13.497 16.8539 14.0347 16.5922C12.7147 16.5095 11.8538 15.6971 10.9786 14.871C10.4744 14.3952 9.96546 13.9148 9.36117 13.5668C8.80225 13.2449 8.0719 13 7.00136 13Z"
  }));
},
    UG = function UG(_ref2841) {
  var _ref2841$color = _ref2841.color,
      C = _ref2841$color === void 0 ? "currentColor" : _ref2841$color,
      _ref2841$size = _ref2841.size,
      e = _ref2841$size === void 0 ? 24 : _ref2841$size,
      l = _ref2841.className,
      i = _objectWithoutProperties(_ref2841, _excluded2841);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.0002 3.23235C13.5819 4.0567 14.7825 5.51252 15.2664 7.26605C15.4134 7.79843 15.9641 8.1109 16.4964 7.96396C17.0288 7.81702 17.3413 7.26633 17.1943 6.73395C16.7346 5.06811 15.7806 3.60711 14.4998 2.519C14.665 2.50641 14.8318 2.5 15 2.5C17.0071 2.5 18.6792 3.228 19.8307 4.60982C20.962 5.96738 21.5 7.84558 21.5 10C21.5 13.0971 20.9858 15.8652 20.1051 17.8976C19.265 19.8362 17.8974 21.5 16 21.5C14.8997 21.5 14.2129 20.8477 13.8053 20.1396C13.4431 19.5106 13.2269 18.7169 13.0529 18.0779C12.8459 17.3179 12.6873 16.7504 12.4615 16.3583C12.2754 16.0352 12.1497 16 12 16C11.8503 16 11.7246 16.0352 11.5385 16.3583C11.3127 16.7504 11.1541 17.3179 10.9471 18.0779L10.9471 18.0779C10.7731 18.7169 10.5569 19.5106 10.1947 20.1396C9.78706 20.8477 9.10027 21.5 8 21.5C6.1026 21.5 4.73499 19.8362 3.89494 17.8976C3.01425 15.8652 2.5 13.0971 2.5 10C2.5 7.84558 3.03797 5.96738 4.16928 4.60982C5.32079 3.228 6.9929 2.5 9 2.5C9.00948 2.5 9.01896 2.50002 9.02843 2.50006C10.0987 2.50466 11.1098 2.7686 12 3.23245C12.0001 3.23242 12.0001 3.23238 12.0002 3.23235Z"
  }));
},
    GG = function GG(_ref2842) {
  var _ref2842$color = _ref2842.color,
      C = _ref2842$color === void 0 ? "currentColor" : _ref2842$color,
      _ref2842$size = _ref2842.size,
      e = _ref2842$size === void 0 ? 24 : _ref2842$size,
      l = _ref2842.className,
      i = _objectWithoutProperties(_ref2842, _excluded2842);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5.70572 5.89018C6.42921 5.022 7.5071 4.5 9 4.5C9.90702 4.5 10.7486 4.7673 11.4538 5.22714C12.2364 5.73739 12.8501 6.48416 13.1936 7.36377C13.3945 7.87822 13.9744 8.13239 14.4888 7.93149C15.0033 7.73058 15.2575 7.15067 15.0565 6.63623C14.769 5.89989 14.3515 5.22943 13.8324 4.65272C14.2044 4.55311 14.5957 4.5 15 4.5C16.4929 4.5 17.5708 5.022 18.2943 5.89018C19.038 6.78262 19.5 8.15442 19.5 10C19.5 12.9029 19.0142 15.3848 18.2699 17.1024C17.485 18.9138 16.6026 19.5 16 19.5C15.8503 19.5 15.7246 19.4648 15.5385 19.1417C15.3127 18.7496 15.1541 18.1821 14.9471 17.4221C14.7731 16.7831 14.5569 15.9894 14.1947 15.3604C13.7871 14.6523 13.1003 14 12 14C10.8997 14 10.2129 14.6523 9.80525 15.3604C9.44313 15.9894 9.22692 16.7831 9.05289 17.4221C8.8459 18.1821 8.68726 18.7496 8.4615 19.1417C8.27544 19.4648 8.14973 19.5 8 19.5C7.3974 19.5 6.51501 18.9138 5.73006 17.1024C4.98575 15.3848 4.5 12.9029 4.5 10C4.5 8.15442 4.96203 6.78262 5.70572 5.89018ZM12 3.23245C11.1019 2.7645 10.0808 2.5 9 2.5C6.9929 2.5 5.32079 3.228 4.16928 4.60982C3.03797 5.96738 2.5 7.84558 2.5 10C2.5 13.0971 3.01425 15.8652 3.89494 17.8976C4.73499 19.8362 6.1026 21.5 8 21.5C9.10027 21.5 9.78706 20.8477 10.1947 20.1396C10.5692 19.4892 10.7876 18.6626 10.9648 18.0131C11.1626 17.2875 11.3192 16.7392 11.5385 16.3583C11.7246 16.0352 11.8503 16 12 16C12.1497 16 12.2754 16.0352 12.4615 16.3583C12.6808 16.7392 12.8374 17.2875 13.0352 18.0131C13.2123 18.6625 13.4308 19.4892 13.8053 20.1396C14.2129 20.8477 14.8997 21.5 16 21.5C17.8974 21.5 19.265 19.8362 20.1051 17.8976C20.9858 15.8652 21.5 13.0971 21.5 10C21.5 7.84558 20.962 5.96738 19.8307 4.60982C18.6792 3.228 17.0071 2.5 15 2.5C13.9192 2.5 12.8981 2.7645 12 3.23245Z"
  }));
},
    IG = function IG(_ref2843) {
  var _ref2843$color = _ref2843.color,
      C = _ref2843$color === void 0 ? "currentColor" : _ref2843$color,
      _ref2843$size = _ref2843.size,
      e = _ref2843$size === void 0 ? 24 : _ref2843$size,
      l = _ref2843.className,
      i = _objectWithoutProperties(_ref2843, _excluded2843);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17 18.4142L21.1925 22.6067L22.6067 21.1925L2.80769 1.39349L1.39348 2.80771L2.58579 4.00001H2C1.44772 4.00001 1 4.44773 1 5.00001V19C1 19.5523 1.44772 20 2 20H16C16.5523 20 17 19.5523 17 19V18.4142ZM16 4.00001H8.21402L22.7083 18.4943C22.8805 18.4153 23 18.2415 23 18.0397V5.96034C23 5.85776 22.9684 5.75765 22.9096 5.67361C22.7513 5.44739 22.4395 5.39237 22.2133 5.55073L17 9.20001V5.00001C17 4.44773 16.5523 4.00001 16 4.00001Z"
  }));
},
    WG = function WG(_ref2844) {
  var _ref2844$color = _ref2844.color,
      C = _ref2844$color === void 0 ? "currentColor" : _ref2844$color,
      _ref2844$size = _ref2844.size,
      e = _ref2844$size === void 0 ? 24 : _ref2844$size,
      l = _ref2844.className,
      i = _objectWithoutProperties(_ref2844, _excluded2844);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17 18.4142L21.1925 22.6067L22.6067 21.1925L2.80769 1.39349L1.39348 2.80771L2.58579 4.00001H2C1.44772 4.00001 1 4.44773 1 5.00001V19C1 19.5523 1.44772 20 2 20H16C16.5523 20 17 19.5523 17 19V18.4142ZM15 16.4142V18H3V6.00001H4.58579L15 16.4142ZM23 18.0397C23 18.2517 22.875 18.4176 22.7083 18.4943L21 16.786V8.84133L17 11.6413V12.786L15 10.786V6.00001H10.214L8.21402 4.00001H16C16.5523 4.00001 17 4.44773 17 5.00001V9.20001L22.2133 5.55073C22.5447 5.31876 23 5.55583 23 5.96034V18.0397Z"
  }));
},
    OG = function OG(_ref2845) {
  var _ref2845$color = _ref2845.color,
      C = _ref2845$color === void 0 ? "currentColor" : _ref2845$color,
      _ref2845$size = _ref2845.size,
      e = _ref2845$size === void 0 ? 24 : _ref2845$size,
      l = _ref2845.className,
      i = _objectWithoutProperties(_ref2845, _excluded2845);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17 9.2L22.2133 5.55071C22.4395 5.39235 22.7513 5.44737 22.9096 5.6736C22.9684 5.75764 23 5.85774 23 5.96033V18.0397C23 18.3158 22.7761 18.5397 22.5 18.5397C22.3974 18.5397 22.2973 18.5081 22.2133 18.4493L17 14.8V19C17 19.5523 16.5523 20 16 20H2C1.44772 20 1 19.5523 1 19V5C1 4.44772 1.44772 4 2 4H16C16.5523 4 17 4.44772 17 5V9.2Z"
  }));
},
    KG = function KG(_ref2846) {
  var _ref2846$color = _ref2846.color,
      C = _ref2846$color === void 0 ? "currentColor" : _ref2846$color,
      _ref2846$size = _ref2846.size,
      e = _ref2846$size === void 0 ? 24 : _ref2846$size,
      l = _ref2846.className,
      i = _objectWithoutProperties(_ref2846, _excluded2846);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17 9.2L22.2133 5.55071C22.4395 5.39235 22.7513 5.44737 22.9096 5.6736C22.9684 5.75764 23 5.85774 23 5.96033V18.0397C23 18.3158 22.7761 18.5397 22.5 18.5397C22.3974 18.5397 22.2973 18.5081 22.2133 18.4493L17 14.8V19C17 19.5523 16.5523 20 16 20H2C1.44772 20 1 19.5523 1 19V5C1 4.44772 1.44772 4 2 4H16C16.5523 4 17 4.44772 17 5V9.2ZM17 12.3587L21 15.1587V8.84131L17 11.6413V12.3587ZM3 6V18H15V6H3Z"
  }));
},
    QG = function QG(_ref2847) {
  var _ref2847$color = _ref2847.color,
      C = _ref2847$color === void 0 ? "currentColor" : _ref2847$color,
      _ref2847$size = _ref2847.size,
      e = _ref2847$size === void 0 ? 24 : _ref2847$size,
      l = _ref2847.className,
      i = _objectWithoutProperties(_ref2847, _excluded2847);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13.5011 4.39885C14.7217 5.10357 15.2612 6.53847 14.8826 7.83501L16.8025 8.3956C17.4334 6.23483 16.5385 3.8431 14.5011 2.6668C12.1096 1.28609 9.05169 2.10547 7.67098 4.49693C6.4615 6.59181 6.94024 9.19811 8.68509 10.7404L6.80304 14.0002L6.7998 14.0002C5.69524 14.0002 4.7998 14.8957 4.7998 16.0002C4.7998 17.1048 5.69524 18.0002 6.7998 18.0002C7.90437 18.0002 8.7998 17.1048 8.7998 16.0002C8.7998 15.8408 8.78115 15.6857 8.7459 15.537C8.66351 15.1896 8.64362 14.8123 8.82215 14.503L11.3671 10.095L10.5011 9.59501C9.06623 8.76658 8.5746 6.93181 9.40303 5.49693C10.2315 4.06205 12.0662 3.57043 13.5011 4.39885ZM15.0313 18.0802C15.9648 19.0563 17.4772 19.3066 18.6978 18.6018C20.1327 17.7734 20.6243 15.9387 19.7959 14.5038C18.9675 13.0689 17.1327 12.5773 15.6978 13.4057L14.8318 13.9057L12.2864 9.49688C12.1079 9.18768 11.7711 9.01623 11.4291 8.91386C11.2827 8.87005 11.1391 8.80868 11.0011 8.72897C10.0445 8.17668 9.71673 6.9535 10.269 5.99692C10.8213 5.04033 12.0445 4.71258 13.0011 5.26487C13.9577 5.81715 14.2854 7.04033 13.7331 7.99692L13.7314 7.99981L15.6139 11.2603C17.822 10.5203 20.3185 11.4089 21.528 13.5038C22.9087 15.8952 22.0893 18.9532 19.6978 20.3339C17.6604 21.5102 15.1417 21.0893 13.5859 19.4625L15.0313 18.0802ZM3.7998 16.0005C3.7998 14.5911 4.77271 13.4064 6.08484 13.086L5.61041 11.1431C3.42366 11.677 1.7998 13.6479 1.7998 16.0005C1.7998 18.7619 4.03838 21.0005 6.7998 21.0005C9.21876 21.0005 11.2365 19.2827 11.6998 17.0005H15.4641L15.4658 17.0036C16.0181 17.9602 17.2413 18.2879 18.1979 17.7356C19.1545 17.1833 19.4822 15.9602 18.9299 15.0036C18.3776 14.047 17.1545 13.7192 16.1979 14.2715C16.0598 14.3512 15.9349 14.4449 15.8238 14.5497C15.5642 14.7947 15.2474 15.0005 14.8904 15.0005H9.7998V16.0005C9.7998 17.6574 8.45666 19.0005 6.7998 19.0005C5.14295 19.0005 3.7998 17.6574 3.7998 16.0005Z"
  }));
},
    qG = function qG(_ref2848) {
  var _ref2848$color = _ref2848.color,
      C = _ref2848$color === void 0 ? "currentColor" : _ref2848$color,
      _ref2848$size = _ref2848.size,
      e = _ref2848$size === void 0 ? 24 : _ref2848$size,
      l = _ref2848.className,
      i = _objectWithoutProperties(_ref2848, _excluded2848);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8.86874 14.1392C8.6556 14.4912 8.55014 14.7778 8.72043 15.2253C9.1905 16.4613 8.52737 17.664 7.28097 17.9905C6.10556 18.2985 4.96035 17.526 4.72713 16.2676C4.52048 15.1537 5.38488 14.0617 6.61294 13.8877C6.67963 13.8781 6.74717 13.874 6.83351 13.8688C6.88044 13.866 6.93293 13.8628 6.99384 13.8582L8.86194 10.7257C7.687 9.55742 6.98767 8.19164 7.14246 6.49936C7.25188 5.30308 7.72226 4.26933 8.58208 3.42201C10.2288 1.79945 12.7411 1.53667 14.68 2.78212C16.5423 3.97841 17.3951 6.30867 16.6681 8.30311L14.9611 7.84C15.1895 6.73115 15.0206 5.73536 14.2727 4.88234C13.7786 4.31914 13.1446 4.02394 12.4236 3.91516C10.9783 3.69681 9.55922 4.6254 9.13816 6.04399C8.66019 7.65406 9.38355 8.96924 11.3603 9.96029C10.5311 11.3541 9.70859 12.7518 8.86874 14.1392ZM13.7838 8.27337C14.3816 9.32798 14.9886 10.3986 15.5902 11.4593C18.631 10.5186 20.9237 12.2018 21.7462 14.004C22.7396 16.1809 22.0605 18.7593 20.1094 20.1023C18.1067 21.481 15.5741 21.2454 13.7997 19.4744L15.1919 18.3094C16.9444 19.4445 18.4772 19.3911 19.6151 18.047C20.5855 16.9003 20.5644 15.1906 19.5659 14.068C18.4136 12.7726 16.8701 12.7331 15.0044 13.9767C14.2305 12.6037 13.443 11.2413 12.6936 9.85845C12.4409 9.39233 12.1618 9.12196 11.5923 9.0233C10.6411 8.85839 10.027 8.04157 9.99016 7.12642C9.95395 6.22138 10.4871 5.4033 11.3205 5.08455C12.146 4.7688 13.1148 5.02367 13.6701 5.72554C14.1239 6.29901 14.2681 6.94443 14.0293 7.65167C13.9843 7.7852 13.9304 7.91584 13.8713 8.05885C13.8431 8.12694 13.8138 8.19801 13.7838 8.27337ZM11.552 16.895H15.2126C15.2636 16.963 15.3113 17.0303 15.3579 17.0959C15.4551 17.233 15.5474 17.3632 15.6551 17.4788C16.4304 18.3077 17.7395 18.3489 18.5682 17.5795C19.4271 16.7821 19.466 15.4426 18.6544 14.6101C17.8602 13.7955 16.5029 13.7177 15.7655 14.5802C15.3176 15.1044 14.8586 15.166 14.2641 15.1567C12.7414 15.1332 11.2177 15.149 9.69524 15.149C9.79406 17.2909 8.98436 18.6255 7.37841 18.9424C5.80582 19.2528 4.3575 18.4504 3.84759 16.9864C3.26842 15.3229 3.98467 13.9925 6.05421 12.9366C5.89847 12.3725 5.74115 11.8016 5.58541 11.236C3.32977 11.7276 1.63749 13.916 1.8122 16.378C1.96652 18.5514 3.71968 20.4815 5.86369 20.8273C7.02819 21.0153 8.12233 20.82 9.13741 20.2442C10.4433 19.5032 11.2011 18.3381 11.552 16.895Z"
  }));
},
    jG = function jG(_ref2849) {
  var _ref2849$color = _ref2849.color,
      C = _ref2849$color === void 0 ? "currentColor" : _ref2849$color,
      _ref2849$size = _ref2849.size,
      e = _ref2849$size === void 0 ? 24 : _ref2849$size,
      l = _ref2849.className,
      i = _objectWithoutProperties(_ref2849, _excluded2849);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14.0004 6C14.0004 7.10457 13.1049 8 12.0004 8C10.8958 8 10.0004 7.10457 10.0004 6C10.0004 4.89543 10.8958 4 12.0004 4C13.1049 4 14.0004 4.89543 14.0004 6ZM15.4652 8C15.8056 7.41165 16.0004 6.72857 16.0004 6C16.0004 3.79086 14.2095 2 12.0004 2C9.79122 2 8.00036 3.79086 8.00036 6C8.00036 6.72857 8.19515 7.41165 8.53549 8H5.06615C4.57888 8 4.16255 8.3512 4.08045 8.8315L2.2001 19.8315C2.0957 20.4423 2.56618 21 3.18581 21H20.8149C21.4345 21 21.905 20.4423 21.8006 19.8315L19.9203 8.8315C19.8382 8.3512 19.4218 8 18.9346 8H15.4652Z"
  }));
},
    XG = function XG(_ref2850) {
  var _ref2850$color = _ref2850.color,
      C = _ref2850$color === void 0 ? "currentColor" : _ref2850$color,
      _ref2850$size = _ref2850.size,
      e = _ref2850$size === void 0 ? 24 : _ref2850$size,
      l = _ref2850.className,
      i = _objectWithoutProperties(_ref2850, _excluded2850);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14.0004 6C14.0004 7.10457 13.1049 8 12.0004 8C10.8958 8 10.0004 7.10457 10.0004 6C10.0004 4.89543 10.8958 4 12.0004 4C13.1049 4 14.0004 4.89543 14.0004 6ZM15.4652 8C15.8056 7.41165 16.0004 6.72857 16.0004 6C16.0004 3.79086 14.2095 2 12.0004 2C9.79122 2 8.00036 3.79086 8.00036 6C8.00036 6.72857 8.19515 7.41165 8.53549 8H5.06615C4.57888 8 4.16255 8.3512 4.08045 8.8315L2.2001 19.8315C2.0957 20.4423 2.56618 21 3.18581 21H20.8149C21.4345 21 21.905 20.4423 21.8006 19.8315L19.9203 8.8315C19.8382 8.3512 19.4218 8 18.9346 8H15.4652ZM12.0004 10H18.091L19.6295 19H4.37125L5.90971 10H12.0004Z"
  }));
},
    JG = function JG(_ref2851) {
  var _ref2851$color = _ref2851.color,
      C = _ref2851$color === void 0 ? "currentColor" : _ref2851$color,
      _ref2851$size = _ref2851.size,
      e = _ref2851$size === void 0 ? 24 : _ref2851$size,
      l = _ref2851.className,
      i = _objectWithoutProperties(_ref2851, _excluded2851);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 3C3.44772 3 3 3.44772 3 4V20C3 20.5523 3.44772 21 4 21H14C14.5523 21 15 20.5523 15 20V10.6973L17.0215 20.2076C17.1363 20.7479 17.6673 21.0927 18.2075 20.9779L21.142 20.3541C21.6822 20.2393 22.027 19.7083 21.9122 19.1681L19.0015 5.47402C18.8866 4.9338 18.3556 4.58896 17.8154 4.70378L15 5.30221V5C15 4.44772 14.5523 4 14 4H9C9 3.44772 8.55228 3 8 3H4ZM9 6H13V14H9V6ZM13 16V19H9V16H13ZM7 17V19H5V17H7ZM18.7699 18.8137L18.3541 16.8577L19.3323 16.6498L19.748 18.6058L18.7699 18.8137Z"
  }));
},
    YG = function YG(_ref2852) {
  var _ref2852$color = _ref2852.color,
      C = _ref2852$color === void 0 ? "currentColor" : _ref2852$color,
      _ref2852$size = _ref2852.size,
      e = _ref2852$size === void 0 ? 24 : _ref2852$size,
      l = _ref2852.className,
      i = _objectWithoutProperties(_ref2852, _excluded2852);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 3C3.44772 3 3 3.44772 3 4V20C3 20.5523 3.44772 21 4 21H14C14.5523 21 15 20.5523 15 20V15.2973L15.9995 19.9996C16.1143 20.5398 16.6454 20.8847 17.1856 20.7699L21.0982 19.9382C21.6384 19.8234 21.9832 19.2924 21.8684 18.7522L18.9576 5.0581C18.8428 4.51788 18.3118 4.17304 17.7716 4.28786L14.9927 4.87853C14.9328 4.38353 14.5112 4 14 4H10C10 3.44772 9.55228 3 9 3H4ZM10 6H13V14H10V6ZM10 19V16H13V19H10ZM8 5V15H5V5H8ZM8 17V19H5V17H8ZM17.3321 16.6496L19.2884 16.2338L19.7042 18.1898L17.7479 18.6057L17.3321 16.6496ZM16.9163 14.6933L15.253 6.86789L17.2092 6.45207L18.8726 14.2775L16.9163 14.6933Z"
  }));
},
    _G = function _G(_ref2853) {
  var _ref2853$color = _ref2853.color,
      C = _ref2853$color === void 0 ? "currentColor" : _ref2853$color,
      _ref2853$size = _ref2853.size,
      e = _ref2853$size === void 0 ? 24 : _ref2853$size,
      l = _ref2853.className,
      i = _objectWithoutProperties(_ref2853, _excluded2853);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8.5 2C6.567 2 5 3.567 5 5.5C5 5.68016 5.01364 5.85714 5.03993 6.02997C3.32436 6.25523 2 7.72295 2 9.5C2 10.4793 2.40223 11.3647 3.05051 12C2.40223 12.6353 2 13.5207 2 14.5C2 15.9018 2.82359 17.1104 4.01353 17.6693C4.00457 17.7785 4 17.8888 4 18C4 20.2091 5.79086 22 8 22C9.19469 22 10.2671 21.4762 11 20.6458V3.05051C10.3647 2.40223 9.47934 2 8.5 2ZM13 3.05051V20.6458C13.7329 21.4762 14.8053 22 16 22C18.2091 22 20 20.2091 20 18C20 17.8888 19.9954 17.7785 19.9865 17.6693C21.1764 17.1104 22 15.9018 22 14.5C22 13.5207 21.5978 12.6353 20.9495 12C21.5978 11.3647 22 10.4793 22 9.5C22 7.72295 20.6756 6.25523 18.9601 6.02997C18.9864 5.85714 19 5.68016 19 5.5C19 3.567 17.433 2 15.5 2C14.5207 2 13.6353 2.40223 13 3.05051Z"
  }));
},
    $G = function $G(_ref2854) {
  var _ref2854$color = _ref2854.color,
      C = _ref2854$color === void 0 ? "currentColor" : _ref2854$color,
      _ref2854$size = _ref2854.size,
      e = _ref2854$size === void 0 ? 24 : _ref2854$size,
      l = _ref2854.className,
      i = _objectWithoutProperties(_ref2854, _excluded2854);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7 6C7 6.23676 7.04072 6.46184 7.11469 6.66999C7.22686 6.98559 7.17357 7.33638 6.97276 7.60444C6.77194 7.8725 6.45026 8.02222 6.11585 8.00327C6.0776 8.0011 6.03898 8 6 8C4.89543 8 4 8.89543 4 10C4 10.5129 4.19174 10.9786 4.50903 11.3331C4.84885 11.7128 4.84885 12.2872 4.50903 12.6669C4.19174 13.0214 4 13.4871 4 14C4 14.8842 4.57447 15.6369 5.37327 15.9001C5.84924 16.057 6.1356 16.5419 6.04308 17.0345C6.01489 17.1846 6 17.3401 6 17.5C6 18.8807 7.11929 20 8.5 20C9.75862 20 10.8015 19.069 10.9746 17.8583C10.9806 17.8165 10.9891 17.7756 11 17.7358V6C11 4.89543 10.1046 4 9 4C7.89543 4 7 4.89543 7 6ZM13 17.7358C13.0109 17.7756 13.0194 17.8165 13.0254 17.8583C13.1985 19.069 14.2414 20 15.5 20C16.8807 20 18 18.8807 18 17.5C18 17.3401 17.9851 17.1846 17.9569 17.0345C17.8644 16.5419 18.1508 16.057 18.6267 15.9001C19.4255 15.6369 20 14.8842 20 14C20 13.4871 19.8083 13.0214 19.491 12.6669C19.1511 12.2872 19.1511 11.7128 19.491 11.3331C19.8083 10.9786 20 10.5129 20 10C20 8.89543 19.1046 8 18 8C17.961 8 17.9224 8.0011 17.8841 8.00327C17.5497 8.02222 17.2281 7.8725 17.0272 7.60444C16.8264 7.33638 16.7731 6.98559 16.8853 6.66999C16.9593 6.46184 17 6.23676 17 6C17 4.89543 16.1046 4 15 4C13.8954 4 13 4.89543 13 6V17.7358ZM9 2C10.1947 2 11.2671 2.52376 12 3.35418C12.7329 2.52376 13.8053 2 15 2C17.2091 2 19 3.79086 19 6C19 6.04198 18.9994 6.08382 18.9981 6.12552C20.7243 6.56889 22 8.13546 22 10C22 10.728 21.8049 11.4116 21.4646 12C21.8049 12.5884 22 13.272 22 14C22 15.4817 21.1949 16.7734 19.9999 17.4646L20 17.5C20 19.9853 17.9853 22 15.5 22C14.0859 22 12.8248 21.3481 12 20.3285C11.1752 21.3481 9.91405 22 8.5 22C6.01472 22 4 19.9853 4 17.5L4.00014 17.4646C2.80512 16.7734 2 15.4817 2 14C2 13.272 2.19513 12.5884 2.53536 12C2.19513 11.4116 2 10.728 2 10C2 8.13546 3.27573 6.56889 5.00194 6.12552C5.00065 6.08382 5 6.04198 5 6C5 3.79086 6.79086 2 9 2Z"
  }));
},
    eI = function eI(_ref2855) {
  var _ref2855$color = _ref2855.color,
      C = _ref2855$color === void 0 ? "currentColor" : _ref2855$color,
      _ref2855$size = _ref2855.size,
      e = _ref2855$size === void 0 ? 24 : _ref2855$size,
      l = _ref2855.className,
      i = _objectWithoutProperties(_ref2855, _excluded2855);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.45455 19L2 22.5V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V12.8027C21.1175 12.2922 20.0929 12 19 12C15.6863 12 13 14.6863 13 18C13 18.3407 13.0284 18.6748 13.083 19H6.45455ZM23.9497 21.5355L22.4462 20.032C22.7981 19.4365 23 18.7418 23 18C23 15.7909 21.2091 14 19 14C16.7909 14 15 15.7909 15 18C15 20.2091 16.7909 22 19 22C19.7418 22 20.4365 21.7981 21.032 21.4462L22.5355 22.9497L23.9497 21.5355ZM21 18C21 19.1046 20.1046 20 19 20C17.8954 20 17 19.1046 17 18C17 16.8954 17.8954 16 19 16C20.1046 16 21 16.8954 21 18Z"
  }));
},
    tI = function tI(_ref2856) {
  var _ref2856$color = _ref2856.color,
      C = _ref2856$color === void 0 ? "currentColor" : _ref2856$color,
      _ref2856$size = _ref2856.size,
      e = _ref2856$size === void 0 ? 24 : _ref2856$size,
      l = _ref2856.className,
      i = _objectWithoutProperties(_ref2856, _excluded2856);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5.76282 17H13.083C13.0284 17.3252 13 17.6593 13 18C13 18.3407 13.0284 18.6748 13.083 19H6.45455L2 22.5V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V12.8027C21.3926 12.4513 20.7179 12.2034 20 12.083V5H4V18.3851L5.76282 17ZM23.9497 21.5355L22.4462 20.032C22.7981 19.4365 23 18.7418 23 18C23 15.7909 21.2091 14 19 14C16.7909 14 15 15.7909 15 18C15 20.2091 16.7909 22 19 22C19.7418 22 20.4365 21.7981 21.032 21.4462L22.5355 22.9497L23.9497 21.5355ZM21 18C21 19.1046 20.1046 20 19 20C17.8954 20 17 19.1046 17 18C17 16.8954 17.8954 16 19 16C20.1046 16 21 16.8954 21 18Z"
  }));
},
    CI = function CI(_ref2857) {
  var _ref2857$color = _ref2857.color,
      C = _ref2857$color === void 0 ? "currentColor" : _ref2857$color,
      _ref2857$size = _ref2857.size,
      e = _ref2857$size === void 0 ? 24 : _ref2857$size,
      l = _ref2857.className,
      i = _objectWithoutProperties(_ref2857, _excluded2857);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 7C22.6569 7 24 5.65685 24 4C24 2.34315 22.6569 1 21 1C19.3431 1 18 2.34315 18 4C18 5.65685 19.3431 7 21 7ZM21 9C21.3425 9 21.6769 8.96557 22 8.89998V18C22 18.5523 21.5523 19 21 19H6.45455L2 22.5V4C2 3.44772 2.44772 3 3 3H16.1C16.0344 3.32311 16 3.65753 16 4C16 6.76142 18.2386 9 21 9Z"
  }));
},
    lI = function lI(_ref2858) {
  var _ref2858$color = _ref2858.color,
      C = _ref2858$color === void 0 ? "currentColor" : _ref2858$color,
      _ref2858$size = _ref2858.size,
      e = _ref2858$size === void 0 ? 24 : _ref2858$size,
      l = _ref2858.className,
      i = _objectWithoutProperties(_ref2858, _excluded2858);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21 7C22.6569 7 24 5.65685 24 4C24 2.34315 22.6569 1 21 1C19.3431 1 18 2.34315 18 4C18 5.65685 19.3431 7 21 7ZM22 18V8.89998C21.6769 8.96557 21.3425 9 21 9C20.6575 9 20.3231 8.96557 20 8.89998V17H5.76282L4 18.3851V5H16.1C16.0344 4.67689 16 4.34247 16 4C16 3.65753 16.0344 3.32311 16.1 3H3C2.44772 3 2 3.44772 2 4V22.5L6.45455 19H21C21.5523 19 22 18.5523 22 18Z"
  }));
},
    iI = function iI(_ref2859) {
  var _ref2859$color = _ref2859.color,
      C = _ref2859$color === void 0 ? "currentColor" : _ref2859$color,
      _ref2859$size = _ref2859.size,
      e = _ref2859$size === void 0 ? 24 : _ref2859$size,
      l = _ref2859.className,
      i = _objectWithoutProperties(_ref2859, _excluded2859);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13.5 12 18.4497 7.05029 18.4488 11H23V13H18.4483L18.4473 16.9473 13.5 12ZM1 13H5.55013L5.55005 16.9493 10.5 11.9996 5.55025 7.0498 5.55017 11H1V13Z"
  }));
},
    sI = function sI(_ref2860) {
  var _ref2860$color = _ref2860.color,
      C = _ref2860$color === void 0 ? "currentColor" : _ref2860$color,
      _ref2860$size = _ref2860.size,
      e = _ref2860$size === void 0 ? 24 : _ref2860$size,
      l = _ref2860.className,
      i = _objectWithoutProperties(_ref2860, _excluded2860);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13.5 12 18.4497 7.05029 19.864 8.46451 17.3284 11H23V13H17.3284L19.8615 15.5331 18.4473 16.9473 13.5 12ZM1 13H6.67084L4.13584 15.535 5.55005 16.9493 10.5 11.9996 5.55025 7.0498 4.13604 8.46402 6.67206 11H1V13Z"
  }));
},
    rI = function rI(_ref2861) {
  var _ref2861$color = _ref2861.color,
      C = _ref2861$color === void 0 ? "currentColor" : _ref2861$color,
      _ref2861$size = _ref2861.size,
      e = _ref2861$size === void 0 ? 24 : _ref2861$size,
      l = _ref2861.className,
      i = _objectWithoutProperties(_ref2861, _excluded2861);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11.9995 13.4995 16.9492 18.4493 12.9995 18.4483 12.9995 22.9995H10.9995L10.9995 18.4478 7.05222 18.4468 11.9995 13.4995ZM10.9995.999512 10.9995 5.54964 7.05026 5.54956 12 10.4995 16.9497 5.54977 12.9995 5.54968V.999512L10.9995.999512Z"
  }));
},
    cI = function cI(_ref2862) {
  var _ref2862$color = _ref2862.color,
      C = _ref2862$color === void 0 ? "currentColor" : _ref2862$color,
      _ref2862$size = _ref2862.size,
      e = _ref2862$size === void 0 ? 24 : _ref2862$size,
      l = _ref2862.className,
      i = _objectWithoutProperties(_ref2862, _excluded2862);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11.9995 13.4995 16.9492 18.4493 15.535 19.8635 12.9995 17.3279 12.9995 22.9995H10.9995L10.9995 17.3279 8.46643 19.861 7.05222 18.4468 11.9995 13.4995ZM10.9995.999512 10.9995 6.67035 8.46448 4.13535 7.05026 5.54956 12 10.4995 16.9497 5.54977 15.5355 4.13555 12.9995 6.67157V.999512L10.9995.999512Z"
  }));
},
    oI = function oI(_ref2863) {
  var _ref2863$color = _ref2863.color,
      C = _ref2863$color === void 0 ? "currentColor" : _ref2863$color,
      _ref2863$size = _ref2863.size,
      e = _ref2863$size === void 0 ? 24 : _ref2863$size,
      l = _ref2863.className,
      i = _objectWithoutProperties(_ref2863, _excluded2863);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18 1C18 1.71561 17.9359 2.37948 17.8155 3H8.23193C8.87053 5.55223 10.7943 7.22876 13.5829 9.4281C13.0772 9.8647 12.5462 10.294 12 10.7267C8.72906 8.13494 6 5.66845 6 1H4C4 6.46624 7.21013 9.46355 10.3863 12C7.21013 14.5365 4 17.5338 4 23H6C6 18.0404 9.08011 15.566 12.6178 12.7863L12.7096 12.7142C16.149 10.0123 20 6.98705 20 1H18ZM17.8155 21.0002H8.23193C8.89098 18.3663 10.9188 16.665 13.8535 14.3592C14.2973 14.0106 14.7419 13.663 15.1811 13.3086C17.7659 15.5981 20 18.44 20 23.0002H18C18 22.2846 17.9359 21.6207 17.8155 21.0002Z"
  }));
},
    aI = function aI(_ref2864) {
  var _ref2864$color = _ref2864.color,
      C = _ref2864$color === void 0 ? "currentColor" : _ref2864$color,
      _ref2864$size = _ref2864.size,
      e = _ref2864$size === void 0 ? 24 : _ref2864$size,
      l = _ref2864.className,
      i = _objectWithoutProperties(_ref2864, _excluded2864);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18 1C18 1.71561 17.9359 2.37948 17.8155 3H8.23193C8.41382 3.72694 8.69997 4.38283 9.08066 5H17.1807C16.132 7.31672 14.1871 8.99371 12 10.7267C8.72906 8.13494 6 5.66845 6 1H4C4 6.46624 7.21013 9.46355 10.3863 12C7.21013 14.5365 4 17.5338 4 23H6C6 18.0404 9.08011 15.566 12.6178 12.7863L12.7096 12.7142C16.149 10.0123 20 6.98705 20 1H18ZM17.8155 21.0002H8.23193C8.41382 20.2733 8.69997 19.6174 9.08066 19.0002H17.1807C16.3939 17.262 15.1026 15.8839 13.583 14.5721C14.1162 14.1516 14.6526 13.7351 15.1811 13.3086C17.7659 15.5981 20 18.44 20 23.0002H18C18 22.2846 17.9359 21.6207 17.8155 21.0002Z"
  }));
},
    nI = function nI(_ref2865) {
  var _ref2865$color = _ref2865.color,
      C = _ref2865$color === void 0 ? "currentColor" : _ref2865$color,
      _ref2865$size = _ref2865.size,
      e = _ref2865$size === void 0 ? 24 : _ref2865$size,
      l = _ref2865.className,
      i = _objectWithoutProperties(_ref2865, _excluded2865);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15.5355 2.80744C17.0976 1.24534 19.6303 1.24534 21.1924 2.80744C22.7545 4.36953 22.7545 6.90219 21.1924 8.46429L18.3638 11.2929L18.7175 11.6466C19.108 12.0371 19.108 12.6703 18.7175 13.0608C18.327 13.4513 17.6938 13.4513 17.3033 13.0608L16.9498 12.7073L10.7351 18.922C10.1767 19.4804 9.46547 19.861 8.6911 20.0159L6.93694 20.3667C6.54976 20.4442 6.19416 20.6345 5.91496 20.9137L4.92894 21.8997C4.53841 22.2902 3.90525 22.2902 3.51472 21.8997L2.10051 20.4855C1.70999 20.095 1.70999 19.4618 2.10051 19.0713L3.08653 18.0852C3.36574 17.806 3.55605 17.4504 3.63348 17.0633L3.98431 15.3091C4.13919 14.5347 4.51981 13.8235 5.07821 13.2651L11.2929 7.05045L10.9393 6.69686C10.5488 6.30634 10.5488 5.67317 10.9393 5.28265C11.3299 4.89212 11.963 4.89212 12.3535 5.28265L12.7069 5.63604L15.5355 2.80744ZM12.7071 8.46466L6.49242 14.6794C6.21322 14.9586 6.02291 15.3142 5.94548 15.7013L5.59464 17.4555C5.43977 18.2299 5.05915 18.9411 4.50075 19.4995C5.05915 18.9411 5.77035 18.5604 6.54471 18.4056L8.29887 18.0547C8.68605 17.9773 9.04165 17.787 9.32085 17.5078L15.5355 11.2931L12.7071 8.46466Z"
  }));
},
    mI = function mI(_ref2866) {
  var _ref2866$color = _ref2866.color,
      C = _ref2866$color === void 0 ? "currentColor" : _ref2866$color,
      _ref2866$size = _ref2866.size,
      e = _ref2866$size === void 0 ? 24 : _ref2866$size,
      l = _ref2866.className,
      i = _objectWithoutProperties(_ref2866, _excluded2866);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19.7782 4.22165C20.5592 5.0027 20.5592 6.26903 19.7782 7.05008L16.9498 9.8785L14.1213 7.05008L16.9498 4.22165C17.7308 3.4406 18.9971 3.4406 19.7782 4.22165ZM21.1924 2.80744C19.6303 1.24534 17.0976 1.24534 15.5355 2.80744L12.7071 5.63586L12.3535 5.28265C11.963 4.89212 11.3299 4.89212 10.9393 5.28265C10.5488 5.67317 10.5488 6.30633 10.9393 6.69686L11.2929 7.05044L5.07821 13.2651C4.51981 13.8235 4.13919 14.5347 3.98431 15.3091L3.63348 17.0633C3.55605 17.4504 3.36574 17.806 3.08653 18.0852L2.10051 19.0713C1.70999 19.4618 1.70999 20.095 2.10051 20.4855L3.51472 21.8997C3.90525 22.2902 4.53841 22.2902 4.92894 21.8997L5.91496 20.9137C6.19416 20.6345 6.54976 20.4442 6.93694 20.3667L8.6911 20.0159C9.46547 19.861 10.1767 19.4804 10.7351 18.922L16.9498 12.7073L17.3033 13.0608C17.6938 13.4513 18.327 13.4513 18.7175 13.0608C19.108 12.6703 19.108 12.0371 18.7175 11.6466L18.364 11.2931L21.1924 8.46429C22.7545 6.90219 22.7545 4.36953 21.1924 2.80744ZM12.7071 8.46466L15.5355 11.2931L9.32085 17.5078C9.04165 17.787 8.68605 17.9773 8.29887 18.0547L6.54471 18.4056C5.77035 18.5604 5.05915 18.9411 4.50075 19.4995C5.05915 18.9411 5.43977 18.2299 5.59464 17.4555L5.94548 15.7013C6.02291 15.3142 6.21322 14.9586 6.49242 14.6794L12.7071 8.46466Z"
  }));
},
    wI = function wI(_ref2867) {
  var _ref2867$color = _ref2867.color,
      C = _ref2867$color === void 0 ? "currentColor" : _ref2867$color,
      _ref2867$size = _ref2867.size,
      e = _ref2867$size === void 0 ? 24 : _ref2867$size,
      l = _ref2867.className,
      i = _objectWithoutProperties(_ref2867, _excluded2867);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5 5L5 12.5L8.04289 9.45711L14.5429 15.9571L11.5 19H19L19 11.5L15.9571 14.5429L9.45711 8.04289L12.5 5L5 5Z"
  }));
},
    LI = function LI(_ref2868) {
  var _ref2868$color = _ref2868.color,
      C = _ref2868$color === void 0 ? "currentColor" : _ref2868$color,
      _ref2868$size = _ref2868.size,
      e = _ref2868$size === void 0 ? 24 : _ref2868$size,
      l = _ref2868.className,
      i = _objectWithoutProperties(_ref2868, _excluded2868);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7 8.41421V12L5 12L5 5L12 5V7L8.41421 7L17 15.5858V12L19 12L19 19H12V17H15.5858L7 8.41421Z"
  }));
},
    hI = function hI(_ref2869) {
  var _ref2869$color = _ref2869.color,
      C = _ref2869$color === void 0 ? "currentColor" : _ref2869$color,
      _ref2869$size = _ref2869.size,
      e = _ref2869$size === void 0 ? 24 : _ref2869$size,
      l = _ref2869.className,
      i = _objectWithoutProperties(_ref2869, _excluded2869);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19 5H11.5L14.5429 8.04289L8.04289 14.5429L5 11.5V19H12.5L9.45711 15.9571L15.9571 9.45711L19 12.5V5Z"
  }));
},
    HI = function HI(_ref2870) {
  var _ref2870$color = _ref2870.color,
      C = _ref2870$color === void 0 ? "currentColor" : _ref2870$color,
      _ref2870$size = _ref2870.size,
      e = _ref2870$size === void 0 ? 24 : _ref2870$size,
      l = _ref2870.className,
      i = _objectWithoutProperties(_ref2870, _excluded2870);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15.5858 7H12V5H19V12H17V8.41421L8.41421 17H12V19H5V12H7V15.5858L15.5858 7Z"
  }));
},
    VI = function VI(_ref2871) {
  var _ref2871$color = _ref2871.color,
      C = _ref2871$color === void 0 ? "currentColor" : _ref2871$color,
      _ref2871$size = _ref2871.size,
      e = _ref2871$size === void 0 ? 24 : _ref2871$size,
      l = _ref2871.className,
      i = _objectWithoutProperties(_ref2871, _excluded2871);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M0.5 12L5.44975 7.05029L5.44876 11H10V13H5.44826L5.44727 16.9473L0.5 12ZM14 13H18.5501L18.55 16.9493L23.5 11.9996L18.5503 7.0498L18.5502 11H14V13Z"
  }));
},
    gI = function gI(_ref2872) {
  var _ref2872$color = _ref2872.color,
      C = _ref2872$color === void 0 ? "currentColor" : _ref2872$color,
      _ref2872$size = _ref2872.size,
      e = _ref2872$size === void 0 ? 24 : _ref2872$size,
      l = _ref2872.className,
      i = _objectWithoutProperties(_ref2872, _excluded2872);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M0.5 12L5.44975 7.05029L6.86396 8.46451L4.32843 11H10V13H4.32843L6.86148 15.5331L5.44727 16.9473L0.5 12ZM14 13H19.6708L17.1358 15.535L18.55 16.9493L23.5 11.9996L18.5503 7.0498L17.136 8.46402L19.6721 11H14V13Z"
  }));
},
    MI = function MI(_ref2873) {
  var _ref2873$color = _ref2873.color,
      C = _ref2873$color === void 0 ? "currentColor" : _ref2873$color,
      _ref2873$size = _ref2873.size,
      e = _ref2873$size === void 0 ? 24 : _ref2873$size,
      l = _ref2873.className,
      i = _objectWithoutProperties(_ref2873, _excluded2873);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7.44975 7.05017L2.5 11.9999L7.44727 16.9472L7.44826 12.9999H16.5501L16.55 16.9491L21.5 11.9994L16.5503 7.04968L16.5502 10.9999H7.44876L7.44975 7.05017Z"
  }));
},
    ZI = function ZI(_ref2874) {
  var _ref2874$color = _ref2874.color,
      C = _ref2874$color === void 0 ? "currentColor" : _ref2874$color,
      _ref2874$size = _ref2874.size,
      e = _ref2874$size === void 0 ? 24 : _ref2874$size,
      l = _ref2874.className,
      i = _objectWithoutProperties(_ref2874, _excluded2874);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7.44975 7.05029L2.5 12L7.44727 16.9473L8.86148 15.5331L6.32843 13H17.6708L15.1358 15.535L16.55 16.9493L21.5 11.9996L16.5503 7.0498L15.136 8.46402L17.6721 11H6.32843L8.86396 8.46451L7.44975 7.05029Z"
  }));
},
    xI = function xI(_ref2875) {
  var _ref2875$color = _ref2875.color,
      C = _ref2875$color === void 0 ? "currentColor" : _ref2875$color,
      _ref2875$size = _ref2875.size,
      e = _ref2875$size === void 0 ? 24 : _ref2875$size,
      l = _ref2875.className,
      i = _objectWithoutProperties(_ref2875, _excluded2875);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11.9995 0.499512L16.9492 5.44926L12.9995 5.44827V9.99951H10.9995V5.44777L7.05222 5.44678L11.9995 0.499512ZM10.9995 13.9995L10.9995 18.5496L7.05026 18.5496L12 23.4995L16.9497 18.5498L12.9995 18.5497V13.9995H10.9995Z"
  }));
},
    vI = function vI(_ref2876) {
  var _ref2876$color = _ref2876.color,
      C = _ref2876$color === void 0 ? "currentColor" : _ref2876$color,
      _ref2876$size = _ref2876.size,
      e = _ref2876$size === void 0 ? 24 : _ref2876$size,
      l = _ref2876.className,
      i = _objectWithoutProperties(_ref2876, _excluded2876);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11.9995 0.499512L16.9492 5.44926L15.535 6.86347L12.9995 4.32794V9.99951H10.9995L10.9995 4.32794L8.46643 6.86099L7.05222 5.44678L11.9995 0.499512ZM10.9995 13.9995L10.9995 19.6704L8.46448 17.1353L7.05026 18.5496L12 23.4995L16.9497 18.5498L15.5355 17.1356L12.9995 19.6716V13.9995H10.9995Z"
  }));
},
    dI = function dI(_ref2877) {
  var _ref2877$color = _ref2877.color,
      C = _ref2877$color === void 0 ? "currentColor" : _ref2877$color,
      _ref2877$size = _ref2877.size,
      e = _ref2877$size === void 0 ? 24 : _ref2877$size,
      l = _ref2877.className,
      i = _objectWithoutProperties(_ref2877, _excluded2877);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16.9493 7.44926L11.9995 2.49951L7.05226 7.44678L10.9995 7.44777L10.9995 16.5496L7.05031 16.5496L12 21.4995L16.9498 16.5498L12.9995 16.5497L12.9995 7.44827L16.9493 7.44926Z"
  }));
},
    pI = function pI(_ref2878) {
  var _ref2878$color = _ref2878.color,
      C = _ref2878$color === void 0 ? "currentColor" : _ref2878$color,
      _ref2878$size = _ref2878.size,
      e = _ref2878$size === void 0 ? 24 : _ref2878$size,
      l = _ref2878.className,
      i = _objectWithoutProperties(_ref2878, _excluded2878);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16.9492 7.44926L11.9995 2.49951L7.05223 7.44678L8.46644 8.86099L10.9995 6.32794L10.9995 17.6704L8.46449 15.1353L7.05028 16.5496L12 21.4995L16.9497 16.5498L15.5355 15.1356L12.9995 17.6716L12.9995 6.32794L15.535 8.86347L16.9492 7.44926Z"
  }));
},
    EI = function EI(_ref2879) {
  var _ref2879$color = _ref2879.color,
      C = _ref2879$color === void 0 ? "currentColor" : _ref2879$color,
      _ref2879$size = _ref2879.size,
      e = _ref2879$size === void 0 ? 24 : _ref2879$size,
      l = _ref2879.className,
      i = _objectWithoutProperties(_ref2879, _excluded2879);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M23.9996 12.0235C17.5625 12.4117 12.4114 17.563 12.0232 24H11.9762C11.588 17.563 6.4369 12.4117 0 12.0235V11.9765C6.4369 11.5883 11.588 6.43719 11.9762 0H12.0232C12.4114 6.43719 17.5625 11.5883 23.9996 11.9765V12.0235Z"
  }));
},
    NI = function NI(_ref2880) {
  var _ref2880$color = _ref2880.color,
      C = _ref2880$color === void 0 ? "currentColor" : _ref2880$color,
      _ref2880$size = _ref2880.size,
      e = _ref2880$size === void 0 ? 24 : _ref2880$size,
      l = _ref2880.className,
      i = _objectWithoutProperties(_ref2880, _excluded2880);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11.1244 1.09094H12.8753L12.9269 1.9453C13.2227 6.85075 17.1493 10.7773 22.0546 11.0732L22.909 11.1247V12.8757L22.0546 12.9272C17.1493 13.2231 13.2227 17.1498 12.9269 22.0551L12.8753 22.9095H11.1244L11.0728 22.0551C10.777 17.1498 6.85036 13.2231 1.94518 12.9272L1.09082 12.8757V11.1247L1.94518 11.0732C6.85036 10.7773 10.777 6.85075 11.0728 1.9453L11.1244 1.09094ZM11.9999 5.85023C10.83 8.61547 8.61512 10.8304 5.84996 12.0002C8.61512 13.1701 10.83 15.385 11.9999 18.1502C13.1697 15.385 15.3846 13.1701 18.1498 12.0002C15.3846 10.8304 13.1697 8.61547 11.9999 5.85023Z"
  }));
},
    uI = function uI(_ref2881) {
  var _ref2881$color = _ref2881.color,
      C = _ref2881$color === void 0 ? "currentColor" : _ref2881$color,
      _ref2881$size = _ref2881.size,
      e = _ref2881$size === void 0 ? 24 : _ref2881$size,
      l = _ref2881.className,
      i = _objectWithoutProperties(_ref2881, _excluded2881);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22 12C22 17.5228 17.5229 22 12 22C6.4772 22 2 17.5228 2 12C2 6.47715 6.4772 2 12 2V4C7.5817 4 4 7.58172 4 12C4 16.4183 7.5817 20 12 20C16.4183 20 20 16.4183 20 12C20 9.53614 18.8862 7.33243 17.1346 5.86492L15 8V2L21 2L18.5535 4.44656C20.6649 6.28002 22 8.9841 22 12Z"
  }));
},
    BI = function BI(_ref2882) {
  var _ref2882$color = _ref2882.color,
      C = _ref2882$color === void 0 ? "currentColor" : _ref2882$color,
      _ref2882$size = _ref2882.size,
      e = _ref2882$size === void 0 ? 24 : _ref2882$size,
      l = _ref2882.className,
      i = _objectWithoutProperties(_ref2882, _excluded2882);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22 12C22 17.5228 17.5229 22 12 22C6.4772 22 2 17.5228 2 12C2 6.47715 6.4772 2 12 2V4C7.5817 4 4 7.58172 4 12C4 16.4183 7.5817 20 12 20C16.4183 20 20 16.4183 20 12C20 9.25022 18.6127 6.82447 16.4998 5.38451L16.5 8H14.5V2L20.5 2V4L18.0008 3.99989C20.4293 5.82434 22 8.72873 22 12Z"
  }));
},
    fI = function fI(_ref2883) {
  var _ref2883$color = _ref2883.color,
      C = _ref2883$color === void 0 ? "currentColor" : _ref2883$color,
      _ref2883$size = _ref2883.size,
      e = _ref2883$size === void 0 ? 24 : _ref2883$size,
      l = _ref2883.className,
      i = _objectWithoutProperties(_ref2883, _excluded2883);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2V4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 9.53614 5.11383 7.33243 6.86543 5.86492L9 8V2L3 2L5.44648 4.44656C3.33509 6.28002 2 8.9841 2 12Z"
  }));
},
    RI = function RI(_ref2884) {
  var _ref2884$color = _ref2884.color,
      C = _ref2884$color === void 0 ? "currentColor" : _ref2884$color,
      _ref2884$size = _ref2884.size,
      e = _ref2884$size === void 0 ? 24 : _ref2884$size,
      l = _ref2884.className,
      i = _objectWithoutProperties(_ref2884, _excluded2884);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2V4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 9.25022 5.38734 6.82447 7.50024 5.38451L7.5 8H9.5V2L3.5 2V4L5.99918 3.99989C3.57075 5.82434 2 8.72873 2 12Z"
  }));
},
    zI = function zI(_ref2885) {
  var _ref2885$color = _ref2885.color,
      C = _ref2885$color === void 0 ? "currentColor" : _ref2885$color,
      _ref2885$size = _ref2885.size,
      e = _ref2885$size === void 0 ? 24 : _ref2885$size,
      l = _ref2885.className,
      i = _objectWithoutProperties(_ref2885, _excluded2885);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15 3H21V21H3V15H7V11H11V7H15V3Z"
  }));
},
    FI = function FI(_ref2886) {
  var _ref2886$color = _ref2886.color,
      C = _ref2886$color === void 0 ? "currentColor" : _ref2886$color,
      _ref2886$size = _ref2886.size,
      e = _ref2886$size === void 0 ? 24 : _ref2886$size,
      l = _ref2886.className,
      i = _objectWithoutProperties(_ref2886, _excluded2886);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15 3H21V21H3V15H7V11H11V7H15V3ZM17 5V9H13V13H9V17H5V19H19V5H17Z"
  }));
},
    SI = function SI(_ref2887) {
  var _ref2887$color = _ref2887.color,
      C = _ref2887$color === void 0 ? "currentColor" : _ref2887$color,
      _ref2887$size = _ref2887.size,
      e = _ref2887$size === void 0 ? 24 : _ref2887$size,
      l = _ref2887.className,
      i = _objectWithoutProperties(_ref2887, _excluded2887);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2.14753 11.8099C7.3949 9.52374 10.894 8.01654 12.6447 7.28833C17.6435 5.20916 18.6822 4.84799 19.3592 4.83606C19.5081 4.83344 19.8411 4.87034 20.0567 5.04534C20.2388 5.1931 20.2889 5.39271 20.3129 5.5328C20.3369 5.6729 20.3667 5.99204 20.343 6.2414C20.0721 9.08763 18.9 15.9947 18.3037 19.1825C18.0514 20.5314 17.5546 20.9836 17.0736 21.0279C16.0283 21.1241 15.2345 20.3371 14.2221 19.6735C12.6379 18.635 11.7429 17.9885 10.2051 16.9751C8.42795 15.804 9.58001 15.1603 10.5928 14.1084C10.8579 13.8331 15.4635 9.64397 15.5526 9.26395C15.5637 9.21642 15.5741 9.03926 15.4688 8.94571C15.3636 8.85216 15.2083 8.88415 15.0962 8.9096C14.9373 8.94566 12.4064 10.6184 7.50365 13.928C6.78528 14.4212 6.13461 14.6616 5.55163 14.649C4.90893 14.6351 3.67265 14.2856 2.7536 13.9869C1.62635 13.6204 0.730432 13.4267 0.808447 12.8044C0.849081 12.4803 1.29544 12.1488 2.14753 11.8099Z"
  }));
},
    AI = function AI(_ref2888) {
  var _ref2888$color = _ref2888.color,
      C = _ref2888$color === void 0 ? "currentColor" : _ref2888$color,
      _ref2888$size = _ref2888.size,
      e = _ref2888$size === void 0 ? 24 : _ref2888$size,
      l = _ref2888.className,
      i = _objectWithoutProperties(_ref2888, _excluded2888);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17.0943 7.14643C17.6874 6.93123 17.9818 6.85378 18.1449 6.82608C18.1461 6.87823 18.1449 6.92051 18.1422 6.94825C17.9096 9.39217 16.8906 15.4048 16.3672 18.2026C16.2447 18.8578 16.1507 19.1697 15.5179 18.798C15.1014 18.5532 14.7245 18.2452 14.3207 17.9805C12.9961 17.1121 11.1 15.8189 11.2557 15.8967C9.95162 15.0373 10.4975 14.5111 11.2255 13.8093C11.3434 13.6957 11.466 13.5775 11.5863 13.4525C11.64 13.3967 11.9027 13.1524 12.2731 12.8081C13.4612 11.7035 15.7571 9.56903 15.8151 9.32202C15.8246 9.2815 15.8334 9.13045 15.7436 9.05068C15.6539 8.97092 15.5215 8.9982 15.4259 9.01989C15.2904 9.05064 13.1326 10.4769 8.95243 13.2986C8.33994 13.7192 7.78517 13.9242 7.28811 13.9134L7.29256 13.9156C6.63781 13.6847 5.9849 13.4859 5.32855 13.286C4.89736 13.1546 4.46469 13.0228 4.02904 12.8812C3.92249 12.8466 3.81853 12.8137 3.72083 12.783C8.24781 10.8109 11.263 9.51243 12.7739 8.884C14.9684 7.97124 16.2701 7.44551 17.0943 7.14643ZM19.5169 5.21806C19.2635 5.01244 18.985 4.91807 18.7915 4.87185C18.5917 4.82412 18.4018 4.80876 18.2578 4.8113C17.7814 4.81969 17.2697 4.95518 16.4121 5.26637C15.5373 5.58382 14.193 6.12763 12.0058 7.03736C10.4638 7.67874 7.39388 9.00115 2.80365 11.001C2.40046 11.1622 2.03086 11.3451 1.73884 11.5619C1.46919 11.7622 1.09173 12.1205 1.02268 12.6714C0.970519 13.0874 1.09182 13.4714 1.33782 13.7738C1.55198 14.037 1.82635 14.1969 2.03529 14.2981C2.34545 14.4483 2.76276 14.5791 3.12952 14.6941C3.70264 14.8737 4.27444 15.0572 4.84879 15.233C6.62691 15.7773 8.09066 16.2253 9.7012 17.2866C10.8825 18.0651 12.041 18.8775 13.2243 19.6531C13.6559 19.936 14.0593 20.2607 14.5049 20.5224C14.9916 20.8084 15.6104 21.0692 16.3636 20.9998C17.5019 20.8951 18.0941 19.8479 18.3331 18.5703C18.8552 15.7796 19.8909 9.68351 20.1332 7.13774C20.1648 6.80544 20.1278 6.433 20.097 6.25318C20.0653 6.068 19.9684 5.58448 19.5169 5.21806Z"
  }));
},
    kI = function kI(_ref2889) {
  var _ref2889$color = _ref2889.color,
      C = _ref2889$color === void 0 ? "currentColor" : _ref2889$color,
      _ref2889$size = _ref2889.size,
      e = _ref2889$size === void 0 ? 24 : _ref2889$size,
      l = _ref2889.className,
      i = _objectWithoutProperties(_ref2889, _excluded2889);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5.66056 2.18123C5.01456 1.61285 4 2.07155 4 2.932V22H6V18.0002H20.9896C21.9116 18.0002 22.3423 16.8584 21.6501 16.2494L5.66056 2.18123Z"
  }));
},
    PI = function PI(_ref2890) {
  var _ref2890$color = _ref2890.color,
      C = _ref2890$color === void 0 ? "currentColor" : _ref2890$color,
      _ref2890$size = _ref2890.size,
      e = _ref2890$size === void 0 ? 24 : _ref2890$size,
      l = _ref2890.className,
      i = _objectWithoutProperties(_ref2890, _excluded2890);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6 5.1438V16.0002H18.3391L6 5.1438ZM4 2.932C4 2.07155 5.01456 1.61285 5.66056 2.18123L21.6501 16.2494C22.3423 16.8584 21.9116 18.0002 20.9896 18.0002H6V22H4V2.932Z"
  }));
},
    DI = function DI(_ref2891) {
  var _ref2891$color = _ref2891.color,
      C = _ref2891$color === void 0 ? "currentColor" : _ref2891$color,
      _ref2891$size = _ref2891.size,
      e = _ref2891$size === void 0 ? 24 : _ref2891$size,
      l = _ref2891.className,
      i = _objectWithoutProperties(_ref2891, _excluded2891);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14 14.252V22H4C4 17.5817 7.58172 14 12 14C12.6906 14 13.3608 14.0875 14 14.252ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM23 18V20H15V18H23Z"
  }));
},
    yI = function yI(_ref2892) {
  var _ref2892$color = _ref2892.color,
      C = _ref2892$color === void 0 ? "currentColor" : _ref2892$color,
      _ref2892$size = _ref2892.size,
      e = _ref2892$size === void 0 ? 24 : _ref2892$size,
      l = _ref2892.className,
      i = _objectWithoutProperties(_ref2892, _excluded2892);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14 14.252V16.3414C13.3744 16.1203 12.7013 16 12 16C8.68629 16 6 18.6863 6 22H4C4 17.5817 7.58172 14 12 14C12.6906 14 13.3608 14.0875 14 14.252ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11ZM23 18V20H15V18H23Z"
  }));
},
    bI = function bI(_ref2893) {
  var _ref2893$color = _ref2893.color,
      C = _ref2893$color === void 0 ? "currentColor" : _ref2893$color,
      _ref2893$size = _ref2893.size,
      e = _ref2893$size === void 0 ? 24 : _ref2893$size,
      l = _ref2893.className,
      i = _objectWithoutProperties(_ref2893, _excluded2893);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 4.99509C3 3.89323 3.89262 3 4.99509 3H19.0049C20.1068 3 21 3.89262 21 4.99509V19.0049C21 20.1068 20.1074 21 19.0049 21H4.99509C3.89323 21 3 20.1074 3 19.0049V4.99509ZM12 8C12.5523 8 13 8.44772 13 9C13 9.55228 12.5523 10 12 10C11.4477 10 11 9.55228 11 9C11 8.44772 11.4477 8 12 8ZM12 12C13.6569 12 15 10.6569 15 9C15 7.34315 13.6569 6 12 6C10.3431 6 9 7.34315 9 9C9 10.6569 10.3431 12 12 12ZM12 15C13.1046 15 14 15.8954 14 17H16C16 14.7909 14.2091 13 12 13C9.79086 13 8 14.7909 8 17H10C10 15.8954 10.8954 15 12 15Z"
  }));
},
    TI = function TI(_ref2894) {
  var _ref2894$color = _ref2894.color,
      C = _ref2894$color === void 0 ? "currentColor" : _ref2894$color,
      _ref2894$size = _ref2894.size,
      e = _ref2894$size === void 0 ? 24 : _ref2894$size,
      l = _ref2894.className,
      i = _objectWithoutProperties(_ref2894, _excluded2894);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4.99509 3C3.89262 3 3 3.89323 3 4.99509V19.0049C3 20.1074 3.89323 21 4.99509 21H19.0049C20.1074 21 21 20.1068 21 19.0049V4.99509C21 3.89262 20.1068 3 19.0049 3H4.99509ZM5 19V5H19V19H5ZM12 8C12.5523 8 13 8.44772 13 9C13 9.55228 12.5523 10 12 10C11.4477 10 11 9.55228 11 9C11 8.44772 11.4477 8 12 8ZM12 12C13.6569 12 15 10.6569 15 9C15 7.34315 13.6569 6 12 6C10.3431 6 9 7.34315 9 9C9 10.6569 10.3431 12 12 12ZM12 15C10.8954 15 10 15.8954 10 17H8C8 14.7909 9.79086 13 12 13C14.2091 13 16 14.7909 16 17H14C14 15.8954 13.1046 15 12 15Z"
  }));
},
    UI = function UI(_ref2895) {
  var _ref2895$color = _ref2895.color,
      C = _ref2895$color === void 0 ? "currentColor" : _ref2895$color,
      _ref2895$size = _ref2895.size,
      e = _ref2895$size === void 0 ? 24 : _ref2895$size,
      l = _ref2895.className,
      i = _objectWithoutProperties(_ref2895, _excluded2895);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 8C12.5523 8 13 8.44772 13 9C13 9.55228 12.5523 10 12 10C11.4477 10 11 9.55228 11 9C11 8.44772 11.4477 8 12 8ZM12 12C13.6569 12 15 10.6569 15 9C15 7.34315 13.6569 6 12 6C10.3431 6 9 7.34315 9 9C9 10.6569 10.3431 12 12 12ZM12 15C13.1046 15 14 15.8954 14 17H16C16 14.7909 14.2091 13 12 13C9.79086 13 8 14.7909 8 17H10C10 15.8954 10.8954 15 12 15Z"
  }));
},
    GI = function GI(_ref2896) {
  var _ref2896$color = _ref2896.color,
      C = _ref2896$color === void 0 ? "currentColor" : _ref2896$color,
      _ref2896$size = _ref2896.size,
      e = _ref2896$size === void 0 ? 24 : _ref2896$size,
      l = _ref2896.className,
      i = _objectWithoutProperties(_ref2896, _excluded2896);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 8C12.5523 8 13 8.44772 13 9C13 9.55228 12.5523 10 12 10C11.4477 10 11 9.55228 11 9C11 8.44772 11.4477 8 12 8ZM12 12C13.6569 12 15 10.6569 15 9C15 7.34315 13.6569 6 12 6C10.3431 6 9 7.34315 9 9C9 10.6569 10.3431 12 12 12ZM12 15C10.8954 15 10 15.8954 10 17H8C8 14.7909 9.79086 13 12 13C14.2091 13 16 14.7909 16 17H14C14 15.8954 13.1046 15 12 15Z"
  }));
},
    II = function II(_ref2897) {
  var _ref2897$color = _ref2897.color,
      C = _ref2897$color === void 0 ? "currentColor" : _ref2897$color,
      _ref2897$size = _ref2897.size,
      e = _ref2897$size === void 0 ? 24 : _ref2897$size,
      l = _ref2897.className,
      i = _objectWithoutProperties(_ref2897, _excluded2897);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3.00012 13.0001C3.00012 17.9707 7.02956 22.0001 12.0001 22.0001C16.9707 22.0001 21.0001 17.9707 21.0001 13.0001C21.0001 8.02956 16.9707 4.00012 12.0001 4.00012C7.02956 4.00012 3.00012 8.02956 3.00012 13.0001ZM5.2826 2.74707L1.74707 6.2826L3.16128 7.69682L6.69682 4.16128L5.2826 2.74707ZM22.2532 6.2826L18.7176 2.74707L17.3034 4.16128L20.839 7.69682L22.2532 6.2826ZM9 11V9H15V11.4142L11.4142 15H15V17H9V14.5858L12.5858 11H9Z"
  }));
},
    WI = function WI(_ref2898) {
  var _ref2898$color = _ref2898.color,
      C = _ref2898$color === void 0 ? "currentColor" : _ref2898$color,
      _ref2898$size = _ref2898.size,
      e = _ref2898$size === void 0 ? 24 : _ref2898$size,
      l = _ref2898.className,
      i = _objectWithoutProperties(_ref2898, _excluded2898);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3.00012 13.0001C3.00012 17.9707 7.02956 22.0001 12.0001 22.0001C16.9707 22.0001 21.0001 17.9707 21.0001 13.0001C21.0001 8.02956 16.9707 4.00012 12.0001 4.00012C7.02956 4.00012 3.00012 8.02956 3.00012 13.0001ZM19.0001 13.0001C19.0001 16.8661 15.8661 20.0001 12.0001 20.0001C8.13412 20.0001 5.00012 16.8661 5.00012 13.0001C5.00012 9.13412 8.13412 6.00012 12.0001 6.00012C15.8661 6.00012 19.0001 9.13412 19.0001 13.0001ZM5.2826 2.74707L1.74707 6.2826L3.16128 7.69682L6.69682 4.16128L5.2826 2.74707ZM22.2532 6.2826L18.7176 2.74707L17.3034 4.16128L20.839 7.69682L22.2532 6.2826ZM9 11H12.5858L9 14.5858V17H15V15H11.4142L15 11.4142V9H9V11Z"
  }));
},
    OI = function OI(_ref2899) {
  var _ref2899$color = _ref2899.color,
      C = _ref2899$color === void 0 ? "currentColor" : _ref2899$color,
      _ref2899$size = _ref2899.size,
      e = _ref2899$size === void 0 ? 24 : _ref2899$size,
      l = _ref2899.className,
      i = _objectWithoutProperties(_ref2899, _excluded2899);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 3C3.44772 3 3 3.44772 3 4V20C3 20.5523 3.44772 21 4 21H20C20.5523 21 21 20.5523 21 20V4C21 3.44772 20.5523 3 20 3H4ZM11.9996 17.656L6.0498 11.7062H10.9996V6.34229H12.9996V11.7062H17.9493L11.9996 17.656Z"
  }));
},
    KI = function KI(_ref2900) {
  var _ref2900$color = _ref2900.color,
      C = _ref2900$color === void 0 ? "currentColor" : _ref2900$color,
      _ref2900$size = _ref2900.size,
      e = _ref2900$size === void 0 ? 24 : _ref2900$size,
      l = _ref2900.className,
      i = _objectWithoutProperties(_ref2900, _excluded2900);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 3H4C3.44772 3 3 3.44772 3 4V20C3 20.5523 3.44772 21 4 21H20C20.5523 21 21 20.5523 21 20V4C21 3.44772 20.5523 3 20 3ZM5 19V5H19V19H5ZM11.0005 6.34375V13.829L7.75789 10.5864L6.34367 12.0006L12.0005 17.6575L17.6574 12.0006L16.2432 10.5864L13.0005 13.829V6.34375H11.0005Z"
  }));
},
    QI = function QI(_ref2901) {
  var _ref2901$color = _ref2901.color,
      C = _ref2901$color === void 0 ? "currentColor" : _ref2901$color,
      _ref2901$size = _ref2901.size,
      e = _ref2901$size === void 0 ? 24 : _ref2901$size,
      l = _ref2901.className,
      i = _objectWithoutProperties(_ref2901, _excluded2901);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 3C3.44772 3 3 3.44772 3 4V20C3 20.5523 3.44772 21 4 21H20C20.5523 21 21 20.5523 21 20V4C21 3.44772 20.5523 3 20 3H4ZM6.34277 11.9996L12.2925 6.0498V10.9996H17.6565V12.9996H12.2925V17.9493L6.34277 11.9996Z"
  }));
},
    qI = function qI(_ref2902) {
  var _ref2902$color = _ref2902.color,
      C = _ref2902$color === void 0 ? "currentColor" : _ref2902$color,
      _ref2902$size = _ref2902.size,
      e = _ref2902$size === void 0 ? 24 : _ref2902$size,
      l = _ref2902.className,
      i = _objectWithoutProperties(_ref2902, _excluded2902);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 3H4C3.44772 3 3 3.44772 3 4V20C3 20.5523 3.44772 21 4 21H20C20.5523 21 21 20.5523 21 20V4C21 3.44772 20.5523 3 20 3ZM5 19V5H19V19H5ZM6.3436 12.001L12.0005 6.34412L13.4147 7.75834L10.172 11.001H17.6573V13.001H10.172L13.4147 16.2436L12.0005 17.6578L6.3436 12.001Z"
  }));
},
    jI = function jI(_ref2903) {
  var _ref2903$color = _ref2903.color,
      C = _ref2903$color === void 0 ? "currentColor" : _ref2903$color,
      _ref2903$size = _ref2903.size,
      e = _ref2903$size === void 0 ? 24 : _ref2903$size,
      l = _ref2903.className,
      i = _objectWithoutProperties(_ref2903, _excluded2903);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 3C3.44772 3 3 3.44772 3 4V20C3 20.5523 3.44772 21 4 21H20C20.5523 21 21 20.5523 21 20V4C21 3.44772 20.5523 3 20 3H4ZM8 15.9991V7.58489L11.5 11.0849L15.2929 7.29199L16.7071 8.70621L12.9142 12.4991L16.4142 15.9991H8Z"
  }));
},
    XI = function XI(_ref2904) {
  var _ref2904$color = _ref2904.color,
      C = _ref2904$color === void 0 ? "currentColor" : _ref2904$color,
      _ref2904$size = _ref2904.size,
      e = _ref2904$size === void 0 ? 24 : _ref2904$size,
      l = _ref2904.className,
      i = _objectWithoutProperties(_ref2904, _excluded2904);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 3H4C3.44772 3 3 3.44772 3 4V20C3 20.5523 3.44772 21 4 21H20C20.5523 21 21 20.5523 21 20V4C21 3.44772 20.5523 3 20 3ZM5 19V5H19V19H5ZM8 16.001V8.00098H10V12.5868L15.2929 7.29387L16.7071 8.70808L11.4142 14.001H16V16.001H8Z"
  }));
},
    JI = function JI(_ref2905) {
  var _ref2905$color = _ref2905.color,
      C = _ref2905$color === void 0 ? "currentColor" : _ref2905$color,
      _ref2905$size = _ref2905.size,
      e = _ref2905$size === void 0 ? 24 : _ref2905$size,
      l = _ref2905.className,
      i = _objectWithoutProperties(_ref2905, _excluded2905);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 3C3.44772 3 3 3.44772 3 4V20C3 20.5523 3.44772 21 4 21H20C20.5523 21 21 20.5523 21 20V4C21 3.44772 20.5523 3 20 3H4ZM8 8H16.4142L12.9142 11.5L16.7071 15.2929L15.2929 16.7071L11.5 12.9142L8 16.4142V8Z"
  }));
},
    YI = function YI(_ref2906) {
  var _ref2906$color = _ref2906.color,
      C = _ref2906$color === void 0 ? "currentColor" : _ref2906$color,
      _ref2906$size = _ref2906.size,
      e = _ref2906$size === void 0 ? 24 : _ref2906$size,
      l = _ref2906.className,
      i = _objectWithoutProperties(_ref2906, _excluded2906);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 3H4C3.44772 3 3 3.44772 3 4V20C3 20.5523 3.44772 21 4 21H20C20.5523 21 21 20.5523 21 20V4C21 3.44772 20.5523 3 20 3ZM5 19V5H19V19H5ZM8 8V16H10V11.4142L15.2929 16.7071L16.7071 15.2929L11.4142 10H16V8H8Z"
  }));
},
    _I = function _I(_ref2907) {
  var _ref2907$color = _ref2907.color,
      C = _ref2907$color === void 0 ? "currentColor" : _ref2907$color,
      _ref2907$size = _ref2907.size,
      e = _ref2907$size === void 0 ? 24 : _ref2907$size,
      l = _ref2907.className,
      i = _objectWithoutProperties(_ref2907, _excluded2907);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 3C3.44772 3 3 3.44772 3 4V20C3 20.5523 3.44772 21 4 21H20C20.5523 21 21 20.5523 21 20V4C21 3.44772 20.5523 3 20 3H4ZM17.6575 11.9996L11.7077 17.9493V12.9996H6.34375V10.9996H11.7077V6.0498L17.6575 11.9996Z"
  }));
},
    $I = function $I(_ref2908) {
  var _ref2908$color = _ref2908.color,
      C = _ref2908$color === void 0 ? "currentColor" : _ref2908$color,
      _ref2908$size = _ref2908.size,
      e = _ref2908$size === void 0 ? 24 : _ref2908$size,
      l = _ref2908.className,
      i = _objectWithoutProperties(_ref2908, _excluded2908);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 3H4C3.44772 3 3 3.44772 3 4V20C3 20.5523 3.44772 21 4 21H20C20.5523 21 21 20.5523 21 20V4C21 3.44772 20.5523 3 20 3ZM5 19V5H19V19H5ZM17.6569 12L12 17.6568L10.5858 16.2426L13.8284 13H6.34315V11L13.8284 11L10.5858 7.75732L12 6.34311L17.6569 12Z"
  }));
},
    eW = function eW(_ref2909) {
  var _ref2909$color = _ref2909.color,
      C = _ref2909$color === void 0 ? "currentColor" : _ref2909$color,
      _ref2909$size = _ref2909.size,
      e = _ref2909$size === void 0 ? 24 : _ref2909$size,
      l = _ref2909.className,
      i = _objectWithoutProperties(_ref2909, _excluded2909);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 3C3.44772 3 3 3.44772 3 4V20C3 20.5523 3.44772 21 4 21H20C20.5523 21 21 20.5523 21 20V4C21 3.44772 20.5523 3 20 3H4ZM16.0001 15.9991H7.58586L11.0859 12.4991L7.29297 8.70621L8.70718 7.29199L12.5001 11.0849L16.0001 7.58489V15.9991Z"
  }));
},
    tW = function tW(_ref2910) {
  var _ref2910$color = _ref2910.color,
      C = _ref2910$color === void 0 ? "currentColor" : _ref2910$color,
      _ref2910$size = _ref2910.size,
      e = _ref2910$size === void 0 ? 24 : _ref2910$size,
      l = _ref2910.className,
      i = _objectWithoutProperties(_ref2910, _excluded2910);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 3H4C3.44772 3 3 3.44772 3 4V20C3 20.5523 3.44772 21 4 21H20C20.5523 21 21 20.5523 21 20V4C21 3.44772 20.5523 3 20 3ZM5 19V5H19V19H5ZM16 16H8V14H12.5858L7.29289 8.70711L8.70711 7.29289L14 12.5858V8H16V16Z"
  }));
},
    CW = function CW(_ref2911) {
  var _ref2911$color = _ref2911.color,
      C = _ref2911$color === void 0 ? "currentColor" : _ref2911$color,
      _ref2911$size = _ref2911.size,
      e = _ref2911$size === void 0 ? 24 : _ref2911$size,
      l = _ref2911.className,
      i = _objectWithoutProperties(_ref2911, _excluded2911);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 3C3.44772 3 3 3.44772 3 4V20C3 20.5523 3.44772 21 4 21H20C20.5523 21 21 20.5523 21 20V4C21 3.44772 20.5523 3 20 3H4ZM16.0001 8V16.4142L12.5001 12.9142L8.70718 16.7071L7.29297 15.2929L11.0859 11.5L7.58586 8H16.0001Z"
  }));
},
    lW = function lW(_ref2912) {
  var _ref2912$color = _ref2912.color,
      C = _ref2912$color === void 0 ? "currentColor" : _ref2912$color,
      _ref2912$size = _ref2912.size,
      e = _ref2912$size === void 0 ? 24 : _ref2912$size,
      l = _ref2912.className,
      i = _objectWithoutProperties(_ref2912, _excluded2912);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 3H4C3.44772 3 3 3.44772 3 4V20C3 20.5523 3.44772 21 4 21H20C20.5523 21 21 20.5523 21 20V4C21 3.44772 20.5523 3 20 3ZM5 19V5H19V19H5ZM16 8V16H14V11.4142L8.70711 16.7071L7.29289 15.2929L12.5858 10H8V8H16Z"
  }));
},
    iW = function iW(_ref2913) {
  var _ref2913$color = _ref2913.color,
      C = _ref2913$color === void 0 ? "currentColor" : _ref2913$color,
      _ref2913$size = _ref2913.size,
      e = _ref2913$size === void 0 ? 24 : _ref2913$size,
      l = _ref2913.className,
      i = _objectWithoutProperties(_ref2913, _excluded2913);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 3C3.44772 3 3 3.44772 3 4V20C3 20.5523 3.44772 21 4 21H20C20.5523 21 21 20.5523 21 20V4C21 3.44772 20.5523 3 20 3H4ZM11.9996 6.34326L17.9493 12.293H12.9996V17.657H10.9996V12.293H6.0498L11.9996 6.34326Z"
  }));
},
    sW = function sW(_ref2914) {
  var _ref2914$color = _ref2914.color,
      C = _ref2914$color === void 0 ? "currentColor" : _ref2914$color,
      _ref2914$size = _ref2914.size,
      e = _ref2914$size === void 0 ? 24 : _ref2914$size,
      l = _ref2914.className,
      i = _objectWithoutProperties(_ref2914, _excluded2914);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20 3H4C3.44772 3 3 3.44772 3 4V20C3 20.5523 3.44772 21 4 21H20C20.5523 21 21 20.5523 21 20V4C21 3.44772 20.5523 3 20 3ZM5 19V5H19V19H5ZM12 6.34311L6.34315 12L7.75736 13.4142L11 10.1715V17.6568H13V10.1715L16.2426 13.4142L17.6569 12L12 6.34311Z"
  }));
},
    rW = function rW(_ref2915) {
  var _ref2915$color = _ref2915.color,
      C = _ref2915$color === void 0 ? "currentColor" : _ref2915$color,
      _ref2915$size = _ref2915.size,
      e = _ref2915$size === void 0 ? 24 : _ref2915$size,
      l = _ref2915.className,
      i = _objectWithoutProperties(_ref2915, _excluded2915);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.7134 8.12811L20.4668 8.69379C20.2864 9.10792 19.7136 9.10792 19.5331 8.69379L19.2866 8.12811C18.8471 7.11947 18.0555 6.31641 17.0677 5.87708L16.308 5.53922C15.8973 5.35653 15.8973 4.75881 16.308 4.57612L17.0252 4.25714C18.0384 3.80651 18.8442 2.97373 19.2761 1.93083L19.5293 1.31953C19.7058 0.893489 20.2942 0.893489 20.4706 1.31953L20.7238 1.93083C21.1558 2.97373 21.9616 3.80651 22.9748 4.25714L23.6919 4.57612C24.1027 4.75881 24.1027 5.35653 23.6919 5.53922L22.9323 5.87708C21.9445 6.31641 21.1529 7.11947 20.7134 8.12811ZM22 20V10.6586C21.3744 10.8797 20.7013 11 20 11C18.9071 11 17.8825 10.7078 17 10.1973V17H15V10H16.6822C15.0655 8.92508 14 7.08697 14 5C14 4.29873 14.1203 3.62556 14.3414 3H3C2.44772 3 2 3.44772 2 4V20C2 20.5523 2.44772 21 3 21H21C21.5523 21 22 20.5523 22 20ZM7 13H9V17H7V13ZM11 7H13V17H11V7Z"
  }));
},
    cW = function cW(_ref2916) {
  var _ref2916$color = _ref2916.color,
      C = _ref2916$color === void 0 ? "currentColor" : _ref2916$color,
      _ref2916$size = _ref2916.size,
      e = _ref2916$size === void 0 ? 24 : _ref2916$size,
      l = _ref2916.className,
      i = _objectWithoutProperties(_ref2916, _excluded2916);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.7134 8.12811L20.4668 8.69379C20.2864 9.10792 19.7136 9.10792 19.5331 8.69379L19.2866 8.12811C18.8471 7.11947 18.0555 6.31641 17.0677 5.87708L16.308 5.53922C15.8973 5.35653 15.8973 4.75881 16.308 4.57612L17.0252 4.25714C18.0384 3.80651 18.8442 2.97373 19.2761 1.93083L19.5293 1.31953C19.7058 0.893489 20.2942 0.893489 20.4706 1.31953L20.7238 1.93083C21.1558 2.97373 21.9616 3.80651 22.9748 4.25714L23.6919 4.57612C24.1027 4.75881 24.1027 5.35653 23.6919 5.53922L22.9323 5.87708C21.9445 6.31641 21.1529 7.11947 20.7134 8.12811ZM2 4C2 3.44772 2.44772 3 3 3H14V5H4V19H20V11H22V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4ZM7 13H9V17H7V13ZM11 7H13V17H11V7ZM15 10H17V17H15V10Z"
  }));
},
    oW = function oW(_ref2917) {
  var _ref2917$color = _ref2917.color,
      C = _ref2917$color === void 0 ? "currentColor" : _ref2917$color,
      _ref2917$size = _ref2917.size,
      e = _ref2917$size === void 0 ? 24 : _ref2917$size,
      l = _ref2917.className,
      i = _objectWithoutProperties(_ref2917, _excluded2917);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4.7134 7.12811L4.46682 7.69379C4.28637 8.10792 3.71357 8.10792 3.53312 7.69379L3.28656 7.12811C2.84706 6.11947 2.05545 5.31641 1.06767 4.87708L0.308047 4.53922C-0.102682 4.35653 -0.102682 3.75881 0.308047 3.57612L1.0252 3.25714C2.03838 2.80651 2.84417 1.97373 3.27612 0.930828L3.52932 0.319534C3.70578 -0.106511 4.29417 -0.106511 4.47063 0.319534L4.72382 0.930828C5.15577 1.97373 5.96158 2.80651 6.9748 3.25714L7.69188 3.57612C8.10271 3.75881 8.10271 4.35653 7.69188 4.53922L6.93228 4.87708C5.94451 5.31641 5.15288 6.11947 4.7134 7.12811ZM18.2278 2.3713L13.2886 6.21289C9.34224 5.23923 5.55843 7.54646 4.5 11.4966C4.39826 11.8763 4.36647 12.262 4.33317 12.666C4.21829 14.0599 4.08554 15.6707 1 17.9966C3.5 19.4966 8 20.9984 11.5016 20.9984C14.8142 20.9984 17.8463 18.7896 18.7444 15.4377C19.0836 14.1719 19.0778 12.895 18.7847 11.7067L22.6253 6.76879C22.9349 6.3707 22.8997 5.80435 22.543 5.44774L19.5488 2.45355C19.1922 2.09694 18.6259 2.06168 18.2278 2.3713ZM16.8952 8.2852C16.8319 8.21952 16.7673 8.15494 16.7015 8.09149L15.5769 6.96685L18.7589 4.49198L20.5046 6.23774L18.0297 9.41972L16.8952 8.2852Z"
  }));
},
    aW = function aW(_ref2918) {
  var _ref2918$color = _ref2918.color,
      C = _ref2918$color === void 0 ? "currentColor" : _ref2918$color,
      _ref2918$size = _ref2918.size,
      e = _ref2918$size === void 0 ? 24 : _ref2918$size,
      l = _ref2918.className,
      i = _objectWithoutProperties(_ref2918, _excluded2918);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4.7134 7.12811L4.46682 7.69379C4.28637 8.10792 3.71357 8.10792 3.53312 7.69379L3.28656 7.12811C2.84706 6.11947 2.05545 5.31641 1.06767 4.87708L0.308047 4.53922C-0.102682 4.35653 -0.102682 3.75881 0.308047 3.57612L1.0252 3.25714C2.03838 2.80651 2.84417 1.97373 3.27612 0.930828L3.52932 0.319534C3.70578 -0.106511 4.29417 -0.106511 4.47063 0.319534L4.72382 0.930828C5.15577 1.97373 5.96158 2.80651 6.9748 3.25714L7.69188 3.57612C8.10271 3.75881 8.10271 4.35653 7.69188 4.53922L6.93228 4.87708C5.94451 5.31641 5.15288 6.11947 4.7134 7.12811ZM15.3144 9.53285L15.4565 9.67491C16.7513 11.018 17.3306 12.9868 16.8126 14.9201C16.1644 17.3393 13.9702 18.9984 11.5016 18.9984C9.46572 18.9984 6.78847 18.3726 4.5286 17.4841C5.73449 16.0696 6.17423 14.675 6.3285 12.805C6.36574 12.3536 6.38901 12.1741 6.43185 12.0142C7.22541 9.05261 10.0168 7.40515 12.9235 8.18399C13.8549 8.43357 14.6661 8.90783 15.3144 9.53285ZM18.2278 2.3713L13.2886 6.21289C9.34224 5.23923 5.55843 7.54646 4.5 11.4966C4.39826 11.8763 4.36647 12.262 4.33317 12.666C4.21829 14.0599 4.08554 15.6707 1 17.9966C3.5 19.4966 8 20.9984 11.5016 20.9984C14.8142 20.9984 17.8463 18.7896 18.7444 15.4377C19.0836 14.1719 19.0778 12.895 18.7847 11.7067L22.6253 6.76879C22.9349 6.3707 22.8997 5.80435 22.543 5.44774L19.5488 2.45355C19.1922 2.09694 18.6259 2.06168 18.2278 2.3713ZM16.8952 8.2852C16.8319 8.21952 16.7673 8.15494 16.7015 8.09149L15.5769 6.96685L18.7589 4.49198L20.5046 6.23774L18.0297 9.41972L16.8952 8.2852Z"
  }));
},
    nW = function nW(_ref2919) {
  var _ref2919$color = _ref2919.color,
      C = _ref2919$color === void 0 ? "currentColor" : _ref2919$color,
      _ref2919$size = _ref2919.size,
      e = _ref2919$size === void 0 ? 24 : _ref2919$size,
      l = _ref2919.className,
      i = _objectWithoutProperties(_ref2919, _excluded2919);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.7134 8.12811L20.4668 8.69379C20.2864 9.10792 19.7136 9.10792 19.5331 8.69379L19.2866 8.12811C18.8471 7.11947 18.0555 6.31641 17.0677 5.87708L16.308 5.53922C15.8973 5.35653 15.8973 4.75881 16.308 4.57612L17.0252 4.25714C18.0384 3.80651 18.8442 2.97373 19.2761 1.93083L19.5293 1.31953C19.7058 0.893489 20.2942 0.893489 20.4706 1.31953L20.7238 1.93083C21.1558 2.97373 21.9616 3.80651 22.9748 4.25714L23.6919 4.57612C24.1027 4.75881 24.1027 5.35653 23.6919 5.53922L22.9323 5.87708C21.9445 6.31641 21.1529 7.11947 20.7134 8.12811ZM22 20V10.6586C21.3744 10.8797 20.7013 11 20 11C19.0753 11 18.1994 10.7908 17.4172 10.4172C17.7908 11.1994 18 12.0753 18 13C18 16.3137 15.3137 19 12 19C8.68629 19 6 16.3137 6 13C6 9.68629 8.68629 7 12 7C12.9247 7 13.8006 7.20919 14.5828 7.58283C14.2092 6.80057 14 5.92472 14 5C14 4.29873 14.1203 3.62556 14.3414 3H9L7 5H3C2.44772 5 2 5.44772 2 6V20C2 20.5523 2.44772 21 3 21H21C21.5523 21 22 20.5523 22 20ZM12 17C9.79086 17 8 15.2091 8 13C8 10.7909 9.79086 9 12 9C14.2091 9 16 10.7909 16 13C16 15.2091 14.2091 17 12 17Z"
  }));
},
    mW = function mW(_ref2920) {
  var _ref2920$color = _ref2920.color,
      C = _ref2920$color === void 0 ? "currentColor" : _ref2920$color,
      _ref2920$size = _ref2920.size,
      e = _ref2920$size === void 0 ? 24 : _ref2920$size,
      l = _ref2920.className,
      i = _objectWithoutProperties(_ref2920, _excluded2920);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.7134 8.12811L20.4668 8.69379C20.2864 9.10792 19.7136 9.10792 19.5331 8.69379L19.2866 8.12811C18.8471 7.11947 18.0555 6.31641 17.0677 5.87708L16.308 5.53922C15.8973 5.35653 15.8973 4.75881 16.308 4.57612L17.0252 4.25714C18.0384 3.80651 18.8442 2.97373 19.2761 1.93083L19.5293 1.31953C19.7058 0.893489 20.2942 0.893489 20.4706 1.31953L20.7238 1.93083C21.1558 2.97373 21.9616 3.80651 22.9748 4.25714L23.6919 4.57612C24.1027 4.75881 24.1027 5.35653 23.6919 5.53922L22.9323 5.87708C21.9445 6.31641 21.1529 7.11947 20.7134 8.12811ZM9 3H14V5H9.82843L7.82843 7H4V19H20V11H22V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V6C2 5.44772 2.44772 5 3 5H7L9 3ZM12 18C8.96243 18 6.5 15.5376 6.5 12.5C6.5 9.46243 8.96243 7 12 7C15.0376 7 17.5 9.46243 17.5 12.5C17.5 15.5376 15.0376 18 12 18ZM12 16C13.933 16 15.5 14.433 15.5 12.5C15.5 10.567 13.933 9 12 9C10.067 9 8.5 10.567 8.5 12.5C8.5 14.433 10.067 16 12 16Z"
  }));
},
    wW = function wW(_ref2921) {
  var _ref2921$color = _ref2921.color,
      C = _ref2921$color === void 0 ? "currentColor" : _ref2921$color,
      _ref2921$size = _ref2921.size,
      e = _ref2921$size === void 0 ? 24 : _ref2921$size,
      l = _ref2921.className,
      i = _objectWithoutProperties(_ref2921, _excluded2921);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.7134 8.12811L20.4668 8.69379C20.2864 9.10792 19.7136 9.10792 19.5331 8.69379L19.2866 8.12811C18.8471 7.11947 18.0555 6.31641 17.0677 5.87708L16.308 5.53922C15.8973 5.35653 15.8973 4.75881 16.308 4.57612L17.0252 4.25714C18.0384 3.80651 18.8442 2.97373 19.2761 1.93083L19.5293 1.31953C19.7058 0.893489 20.2942 0.893489 20.4706 1.31953L20.7238 1.93083C21.1558 2.97373 21.9616 3.80651 22.9748 4.25714L23.6919 4.57612C24.1027 4.75881 24.1027 5.35653 23.6919 5.53922L22.9323 5.87708C21.9445 6.31641 21.1529 7.11947 20.7134 8.12811ZM20 11C20.6986 11 21.3694 10.8806 21.9929 10.6611C21.9976 10.7735 22 10.8865 22 11C22 15.4183 18.4183 19 14 19V22.5C9 20.5 2 17.5 2 11C2 6.58172 5.58172 3 10 3H14C14.1135 3 14.2265 3.00237 14.3389 3.00705C14.1194 3.63061 14 4.30136 14 5C14 8.31371 16.6863 11 20 11Z"
  }));
},
    LW = function LW(_ref2922) {
  var _ref2922$color = _ref2922.color,
      C = _ref2922$color === void 0 ? "currentColor" : _ref2922$color,
      _ref2922$size = _ref2922.size,
      e = _ref2922$size === void 0 ? 24 : _ref2922$size,
      l = _ref2922.className,
      i = _objectWithoutProperties(_ref2922, _excluded2922);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.7134 8.12811L20.4668 8.69379C20.2864 9.10792 19.7136 9.10792 19.5331 8.69379L19.2866 8.12811C18.8471 7.11947 18.0555 6.31641 17.0677 5.87708L16.308 5.53922C15.8973 5.35653 15.8973 4.75881 16.308 4.57612L17.0252 4.25714C18.0384 3.80651 18.8442 2.97373 19.2761 1.93083L19.5293 1.31953C19.7058 0.893489 20.2942 0.893489 20.4706 1.31953L20.7238 1.93083C21.1558 2.97373 21.9616 3.80651 22.9748 4.25714L23.6919 4.57612C24.1027 4.75881 24.1027 5.35653 23.6919 5.53922L22.9323 5.87708C21.9445 6.31641 21.1529 7.11947 20.7134 8.12811ZM10 3H14V5H10C6.68629 5 4 7.68629 4 11C4 14.61 6.46208 16.9656 12 19.4798V17H14C17.3137 17 20 14.3137 20 11H22C22 15.4183 18.4183 19 14 19V22.5C9 20.5 2 17.5 2 11C2 6.58172 5.58172 3 10 3Z"
  }));
},
    hW = function hW(_ref2923) {
  var _ref2923$color = _ref2923.color,
      C = _ref2923$color === void 0 ? "currentColor" : _ref2923$color,
      _ref2923$size = _ref2923.size,
      e = _ref2923$size === void 0 ? 24 : _ref2923$size,
      l = _ref2923.className,
      i = _objectWithoutProperties(_ref2923, _excluded2923);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.7134 8.12811L20.4668 8.69379C20.2864 9.10792 19.7136 9.10792 19.5331 8.69379L19.2866 8.12811C18.8471 7.11947 18.0555 6.31641 17.0677 5.87708L16.308 5.53922C15.8973 5.35653 15.8973 4.75881 16.308 4.57612L17.0252 4.25714C18.0384 3.80651 18.8442 2.97373 19.2761 1.93083L19.5293 1.31953C19.7058 0.893489 20.2942 0.893489 20.4706 1.31953L20.7238 1.93083C21.1558 2.97373 21.9616 3.80651 22.9748 4.25714L23.6919 4.57612C24.1027 4.75881 24.1027 5.35653 23.6919 5.53922L22.9323 5.87708C21.9445 6.31641 21.1529 7.11947 20.7134 8.12811ZM20 11C20.6695 11 21.3134 10.8903 21.9147 10.688C21.971 11.1174 22 11.5553 22 12C22 17.5228 17.5228 22 12 22C10.2975 22 8.6944 21.5746 7.29117 20.8242L2 22L3.17581 16.7088C2.42544 15.3056 2 13.7025 2 12C2 6.47715 6.47715 2 12 2C12.9056 2 13.7831 2.12039 14.6174 2.34603C14.2221 3.14617 14 4.04715 14 5C14 8.31371 16.6863 11 20 11ZM7 12C7 14.7614 9.23858 17 12 17C14.7614 17 17 14.7614 17 12H15C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12H7Z"
  }));
},
    HW = function HW(_ref2924) {
  var _ref2924$color = _ref2924.color,
      C = _ref2924$color === void 0 ? "currentColor" : _ref2924$color,
      _ref2924$size = _ref2924.size,
      e = _ref2924$size === void 0 ? 24 : _ref2924$size,
      l = _ref2924.className,
      i = _objectWithoutProperties(_ref2924, _excluded2924);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.7134 8.12811L20.4668 8.69379C20.2864 9.10792 19.7136 9.10792 19.5331 8.69379L19.2866 8.12811C18.8471 7.11947 18.0555 6.31641 17.0677 5.87708L16.308 5.53922C15.8973 5.35653 15.8973 4.75881 16.308 4.57612L17.0252 4.25714C18.0384 3.80651 18.8442 2.97373 19.2761 1.93083L19.5293 1.31953C19.7058 0.893489 20.2942 0.893489 20.4706 1.31953L20.7238 1.93083C21.1558 2.97373 21.9616 3.80651 22.9748 4.25714L23.6919 4.57612C24.1027 4.75881 24.1027 5.35653 23.6919 5.53922L22.9323 5.87708C21.9445 6.31641 21.1529 7.11947 20.7134 8.12811ZM12 2C6.47715 2 2 6.47715 2 12C2 13.7025 2.42544 15.3056 3.17581 16.7088L2 22L7.29117 20.8242C8.6944 21.5746 10.2975 22 12 22C17.5228 22 22 17.5228 22 12C22 11.5975 21.9762 11.2002 21.9298 10.8094L19.9437 11.0452C19.9809 11.3579 20 11.6765 20 12C20 16.4183 16.4183 20 12 20C10.6655 20 9.38248 19.6745 8.23428 19.0605L7.58075 18.711L4.63416 19.3658L5.28896 16.4192L4.93949 15.7657C4.32549 14.6175 4 13.3345 4 12C4 7.58172 7.58172 4 12 4C12.6919 4 13.3618 4.0876 14 4.25179L14.4983 2.31487C13.6987 2.10914 12.8614 2 12 2ZM9 12H7C7 14.7614 9.23858 17 12 17C14.7614 17 17 14.7614 17 12H15C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12Z"
  }));
},
    VW = function VW(_ref2925) {
  var _ref2925$color = _ref2925.color,
      C = _ref2925$color === void 0 ? "currentColor" : _ref2925$color,
      _ref2925$size = _ref2925.size,
      e = _ref2925$size === void 0 ? 24 : _ref2925$size,
      l = _ref2925.className,
      i = _objectWithoutProperties(_ref2925, _excluded2925);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.7134 8.12811L20.4668 8.69379C20.2864 9.10792 19.7136 9.10792 19.5331 8.69379L19.2866 8.12811C18.8471 7.11947 18.0555 6.31641 17.0677 5.87708L16.308 5.53922C15.8973 5.35653 15.8973 4.75881 16.308 4.57612L17.0252 4.25714C18.0384 3.80651 18.8442 2.97373 19.2761 1.93083L19.5293 1.31953C19.7058 0.893489 20.2942 0.893489 20.4706 1.31953L20.7238 1.93083C21.1558 2.97373 21.9616 3.80651 22.9748 4.25714L23.6919 4.57612C24.1027 4.75881 24.1027 5.35653 23.6919 5.53922L22.9323 5.87708C21.9445 6.31641 21.1529 7.11947 20.7134 8.12811ZM22 12C22 11.5553 21.971 11.1174 21.9147 10.688C21.3134 10.8903 20.6695 11 20 11C18.9071 11 17.8825 10.7078 17 10.1973V15H15V9H15.5278C14.5777 7.93849 14 6.53671 14 5C14 4.04715 14.2221 3.14617 14.6174 2.34603C13.7831 2.12039 12.9056 2 12 2C6.47715 2 2 6.47715 2 12C2 14.7614 3.11929 17.2614 4.92893 19.0711L2 22H12C17.5228 22 22 17.5228 22 12ZM11 6H13V18H11V6ZM7 15V9H9V15H7Z"
  }));
},
    gW = function gW(_ref2926) {
  var _ref2926$color = _ref2926.color,
      C = _ref2926$color === void 0 ? "currentColor" : _ref2926$color,
      _ref2926$size = _ref2926.size,
      e = _ref2926$size === void 0 ? 24 : _ref2926$size,
      l = _ref2926.className,
      i = _objectWithoutProperties(_ref2926, _excluded2926);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.7134 8.12811L20.4668 8.69379C20.2864 9.10792 19.7136 9.10792 19.5331 8.69379L19.2866 8.12811C18.8471 7.11947 18.0555 6.31641 17.0677 5.87708L16.308 5.53922C15.8973 5.35653 15.8973 4.75881 16.308 4.57612L17.0252 4.25714C18.0384 3.80651 18.8442 2.97373 19.2761 1.93083L19.5293 1.31953C19.7058 0.893489 20.2942 0.893489 20.4706 1.31953L20.7238 1.93083C21.1558 2.97373 21.9616 3.80651 22.9748 4.25714L23.6919 4.57612C24.1027 4.75881 24.1027 5.35653 23.6919 5.53922L22.9323 5.87708C21.9445 6.31641 21.1529 7.11947 20.7134 8.12811ZM12 2C6.47715 2 2 6.47715 2 12C2 14.7614 3.11929 17.2614 4.92893 19.0711L2 22H12C17.5228 22 22 17.5228 22 12C22 11.5975 21.9762 11.2002 21.9298 10.8094L19.9437 11.0452C19.9809 11.3579 20 11.6765 20 12C20 16.4183 16.4183 20 12 20H6.82843L7.75736 19.0711L6.34315 17.6569C4.85124 16.1649 4 14.1524 4 12C4 7.58172 7.58172 4 12 4C12.6919 4 13.3618 4.0876 14 4.25179L14.4983 2.31487C13.6987 2.10914 12.8614 2 12 2ZM9 9H7V15H9V9ZM17 9H15V15H17V9ZM13 6H11V18H13V6Z"
  }));
},
    MW = function MW(_ref2927) {
  var _ref2927$color = _ref2927.color,
      C = _ref2927$color === void 0 ? "currentColor" : _ref2927$color,
      _ref2927$size = _ref2927.size,
      e = _ref2927$size === void 0 ? 24 : _ref2927$size,
      l = _ref2927.className,
      i = _objectWithoutProperties(_ref2927, _excluded2927);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17.7134 10.1281L17.4668 10.6938C17.2864 11.1079 16.7136 11.1079 16.5331 10.6938L16.2866 10.1281C15.8471 9.11947 15.0555 8.31641 14.0677 7.87708L13.308 7.53922C12.8973 7.35653 12.8973 6.75881 13.308 6.57612L14.0252 6.25714C15.0384 5.80651 15.8442 4.97373 16.2761 3.93083L16.5293 3.31953C16.7058 2.89349 17.2942 2.89349 17.4706 3.31953L17.7238 3.93083C18.1558 4.97373 18.9616 5.80651 19.9748 6.25714L20.6919 6.57612C21.1027 6.75881 21.1027 7.35653 20.6919 7.53922L19.9323 7.87708C18.9445 8.31641 18.1529 9.11947 17.7134 10.1281ZM2.82843 12.0001L7.07107 16.2428L5.65685 17.657L0 12.0001L5.65685 6.34326L7.07107 7.75748L2.82843 12.0001ZM18.3429 17.6572L23.9998 12.0003L21.1714 9.17188L19.7571 10.5861L21.1714 12.0003L16.9287 16.2429L18.3429 17.6572Z"
  }));
},
    ZW = function ZW(_ref2928) {
  var _ref2928$color = _ref2928.color,
      C = _ref2928$color === void 0 ? "currentColor" : _ref2928$color,
      _ref2928$size = _ref2928.size,
      e = _ref2928$size === void 0 ? 24 : _ref2928$size,
      l = _ref2928.className,
      i = _objectWithoutProperties(_ref2928, _excluded2928);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M17.7134 10.1281L17.4668 10.6938C17.2864 11.1079 16.7136 11.1079 16.5331 10.6938L16.2866 10.1281C15.8471 9.11947 15.0555 8.31641 14.0677 7.87708L13.308 7.53922C12.8973 7.35653 12.8973 6.75881 13.308 6.57612L14.0252 6.25714C15.0384 5.80651 15.8442 4.97373 16.2761 3.93083L16.5293 3.31953C16.7058 2.89349 17.2942 2.89349 17.4706 3.31953L17.7238 3.93083C18.1558 4.97373 18.9616 5.80651 19.9748 6.25714L20.6919 6.57612C21.1027 6.75881 21.1027 7.35653 20.6919 7.53922L19.9323 7.87708C18.9445 8.31641 18.1529 9.11947 17.7134 10.1281ZM2.82843 12.0001L7.07107 16.2428L5.65685 17.657L0 12.0001L5.65685 6.34326L7.07107 7.75748L2.82843 12.0001ZM18.3429 17.6572L23.9998 12.0003L21.1714 9.17188L19.7571 10.5861L21.1714 12.0003L16.9287 16.2429L18.3429 17.6572Z"
  }));
},
    xW = function xW(_ref2929) {
  var _ref2929$color = _ref2929.color,
      C = _ref2929$color === void 0 ? "currentColor" : _ref2929$color,
      _ref2929$size = _ref2929.size,
      e = _ref2929$size === void 0 ? 24 : _ref2929$size,
      l = _ref2929.className,
      i = _objectWithoutProperties(_ref2929, _excluded2929);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15.5111 7.30032C15.8957 7.46801 16.2807 7.63473 16.6635 7.80646C16.6346 7.88102 16.604 7.95471 16.5717 8.02749C14.576 8.20785 12.6858 9.24029 11.4704 10.9723C8.95785 10.7079 6.99981 8.58261 6.99981 6C6.99981 3.23858 9.23839 1 11.9998 1C13.4594 1 14.773 1.62543 15.687 2.62292C14.7051 3.05106 14 3.8962 14 4.99997C14 5.9935 14.6012 6.90361 15.5111 7.30032ZM13.1542 17.9462C13.996 16.1276 14.047 13.9741 13.1547 12.0554C14.6399 10.0118 17.4591 9.37883 19.6956 10.6701C22.087 12.0509 22.9064 15.1086 21.5257 17.5C20.145 19.8915 17.087 20.7109 14.6956 19.3302C14.0707 18.9694 13.5532 18.4942 13.1542 17.9462ZM6.27311 10.0269C7.42726 11.6652 9.26672 12.786 11.3746 12.9726C12.4016 15.2807 11.5401 18.0388 9.30357 19.3301C6.91211 20.7108 3.85415 19.8914 2.47344 17.5C1.09273 15.1085 1.91211 12.0505 4.30357 10.6698C4.92851 10.309 5.59897 10.0984 6.27311 10.0269ZM16.8763 5.7134L16.3106 5.46682C15.8965 5.28637 15.8965 4.71357 16.3106 4.53312L16.8763 4.28656C17.8849 3.84706 18.688 3.05545 19.1273 2.06767L19.4652 1.30805C19.6479 0.897318 20.2456 0.897318 20.4283 1.30805L20.7472 2.0252C21.1979 3.03838 22.0307 3.84417 23.0736 4.27612L23.6849 4.52932C24.1109 4.70578 24.1109 5.29417 23.6849 5.47063L23.0736 5.72382C22.0307 6.15577 21.1979 6.96158 20.7472 7.9748L20.4283 8.69188C20.2456 9.10271 19.6479 9.10271 19.4652 8.69188L19.1273 7.93228C18.688 6.94451 17.8849 6.15288 16.8763 5.7134Z"
  }));
},
    vW = function vW(_ref2930) {
  var _ref2930$color = _ref2930.color,
      C = _ref2930$color === void 0 ? "currentColor" : _ref2930$color,
      _ref2930$size = _ref2930.size,
      e = _ref2930$size === void 0 ? 24 : _ref2930$size,
      l = _ref2930.className,
      i = _objectWithoutProperties(_ref2930, _excluded2930);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.00723 7.29726C6.00242 7.19876 5.99998 7.09965 5.99998 7C5.99998 3.68629 8.68627 1 12 1C13.3496 1 14.5977 1.44677 15.6006 2.20007L14.3994 3.7992C13.731 3.29712 12.9016 3 12 3C11.7239 3 11.4542 3.02798 11.1938 3.08127C9.37112 3.45426 8 5.06701 8 7C8 9.03308 9.51679 10.7119 11.4805 10.9666C12.5039 9.55847 14.055 8.70883 15.696 8.53306C16.3796 8.45983 17.0792 8.50382 17.7635 8.67248C18.3006 8.80481 18.828 9.01404 19.33 9.3039C22.1998 10.9608 23.183 14.6303 21.5262 17.5C19.8693 20.3698 16.1998 21.3531 13.33 19.6962C12.828 19.4064 12.3832 19.0543 12 18.6554C11.6169 19.0543 11.172 19.4064 10.6699 19.6963C7.80019 21.3531 4.13065 20.3699 2.47379 17.5001C0.81694 14.6304 1.80019 10.9608 4.66995 9.30397C5.17193 9.01416 5.69919 8.80494 6.23623 8.67261C6.11278 8.24646 6.03531 7.80079 6.00955 7.3413L6.00723 7.29726ZM7.14979 10.5328C6.64359 10.5989 6.14138 10.7638 5.66995 11.036C3.75678 12.1406 3.10128 14.587 4.20585 16.5001C5.31042 18.4133 7.75678 19.0688 9.66995 17.9642C10.3021 17.5993 10.7949 17.09 11.1337 16.5024C11.7429 15.4457 11.8532 14.1391 11.3649 12.9669C10.9807 12.9264 10.6072 12.8497 10.2481 12.7402C10.2028 12.7264 10.1577 12.712 10.1128 12.6972C8.91238 12.2997 7.87997 11.5335 7.14979 10.5328ZM13.1543 16.9343C13.4647 17.3396 13.8586 17.692 14.33 17.9642C16.2432 19.0687 18.6895 18.4132 19.7941 16.5C20.2936 15.635 20.4332 14.6609 20.2593 13.7511C20.0488 12.6488 19.3781 11.6409 18.33 11.0357C17.6978 10.6708 17.0104 10.4986 16.3322 10.499C15.1125 10.4998 13.9259 11.0576 13.1548 12.0666C13.2661 12.3165 13.3588 12.5707 13.4336 12.8277C13.4336 12.8277 13.4336 12.8277 13.4336 12.8277C13.4774 12.9785 13.5151 13.1302 13.5467 13.2825C13.5602 13.3478 13.5726 13.4131 13.5839 13.4786C13.7871 14.6567 13.6297 15.8611 13.1543 16.9343ZM18.5774 7C18.866 7.33402 19.106 7.71371 19.2866 8.12811L19.5331 8.69379C19.7136 9.10792 20.2864 9.10792 20.4668 8.69379L20.7134 8.12811C21.1529 7.11947 21.9445 6.31641 22.9323 5.87708L23.6919 5.53922C24.1027 5.35653 24.1027 4.75881 23.6919 4.57612L22.9748 4.25714C21.9616 3.80651 21.1558 2.97373 20.7238 1.93083L20.4706 1.31953C20.2942 0.893489 19.7058 0.893489 19.5293 1.31953L19.2761 1.93083C19.1965 2.12319 19.1041 2.3084 19 2.48538C18.5399 3.26793 17.8515 3.88963 17.0252 4.25714L16.308 4.57612C15.8973 4.75881 15.8973 5.35653 16.308 5.53922L17.0677 5.87708C17.6496 6.13591 18.1635 6.521 18.5774 7Z"
  }));
},
    dW = function dW(_ref2931) {
  var _ref2931$color = _ref2931.color,
      C = _ref2931$color === void 0 ? "currentColor" : _ref2931$color,
      _ref2931$size = _ref2931.size,
      e = _ref2931$size === void 0 ? 24 : _ref2931$size,
      l = _ref2931.className,
      i = _objectWithoutProperties(_ref2931, _excluded2931);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8 3H15V0.5L18.5 4L15 7.5V5H8V7.5L4.5 4L8 0.5V3ZM3 17V6.5H5V17C5 18.1046 5.89543 19 7 19H17.5V21H7C4.79086 21 3 19.2091 3 17ZM21 16V9H23.5L20 5.5L16.5 9H19V16H16.5L20 19.5L23.5 16H21Z"
  }));
},
    pW = function pW(_ref2932) {
  var _ref2932$color = _ref2932.color,
      C = _ref2932$color === void 0 ? "currentColor" : _ref2932$color,
      _ref2932$size = _ref2932.size,
      e = _ref2932$size === void 0 ? 24 : _ref2932$size,
      l = _ref2932.className,
      i = _objectWithoutProperties(_ref2932, _excluded2932);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11.2676 1.55469V2.17041L11.5205 6.18555L8.16894 3.95899L7.63622 3.65137L6.90331 4.92042L7.43652 5.22803L11.04 7.0171L7.43652 8.80567L6.90331 9.11328L7.63622 10.3823L8.16894 10.0747L11.5205 7.84815L11.2676 11.8638V12.479H12.7329V11.8638L12.48 7.84815L15.8311 10.0747L16.3642 10.3823L17.0967 9.11328L16.564 8.80567L12.96 7.0171L16.564 5.22803L17.0967 4.92042L16.3642 3.65137L15.8311 3.95899L12.48 6.18555L12.7329 2.17041V1.55469H11.2676ZM5.97215 10.7266V11.3418L6.22509 15.3574L2.87403 13.1309L2.34081 12.8228L1.6084 14.0923L2.14111 14.3999L5.74561 16.1885L2.14111 17.9775L1.6084 18.2852L2.34081 19.5542L2.87403 19.2466L6.22509 17.02L5.97215 21.0352V21.6509H7.4375V21.0352L7.18504 17.0195L10.5361 19.2466L11.0688 19.5542L11.8018 18.2852L11.2686 17.9775L7.66454 16.1885L11.2686 14.3999L11.8018 14.0923L11.0688 12.8228L10.5361 13.1309L7.18504 15.3574L7.4375 11.3418V10.7266H5.97215ZM16.5625 10.7266V11.3418L16.8154 15.3574L13.4643 13.1309L12.9316 12.8228L12.1987 14.0923L12.7314 14.3999L16.3359 16.1885L12.7314 17.9775L12.1987 18.2852L12.9316 19.5542L13.4643 19.2466L16.8154 17.02L16.5625 21.0352V21.6509H18.0283V21.0352L17.7754 17.0195L21.1265 19.2466L21.6592 19.5542L22.3921 18.2852L21.8589 17.9775L18.2549 16.1885L21.8589 14.3999L22.3921 14.0923L21.6592 12.8228L21.1265 13.1309L17.7754 15.3574L18.0283 11.3418V10.7266H16.5625Z"
  }));
},
    EW = function EW(_ref2933) {
  var _ref2933$color = _ref2933.color,
      C = _ref2933$color === void 0 ? "currentColor" : _ref2933$color,
      _ref2933$size = _ref2933.size,
      e = _ref2933$size === void 0 ? 24 : _ref2933$size,
      l = _ref2933.className,
      i = _objectWithoutProperties(_ref2933, _excluded2933);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11.0002 11.5V8.23202L8.17007 9.86602L7.17007 8.13397L10.0002 6.5L7.17007 4.86602L8.17007 3.13397L11.0002 4.76798V1.5H13.0002V4.76792L15.8303 3.13397L16.8303 4.86603L14.0002 6.5L16.8303 8.13397L15.8303 9.86602L13.0002 8.23208V11.5H11.0002ZM21.4596 12.884L18.6294 14.518V11.25H16.6294V14.518L13.7992 12.884L12.7992 14.616L15.6294 16.25L12.7993 17.884L13.7993 19.616L16.6294 17.9821V21.25H18.6294V17.9821L21.4595 19.616L22.4595 17.884L19.6294 16.25L22.4596 14.616L21.4596 12.884ZM7.37109 17.9815L7.37109 21.2495L5.37109 21.2495L5.37109 17.9816L2.54102 19.6155L1.54102 17.8835L4.37114 16.2495L1.54102 14.6155L2.54102 12.8835L5.37109 14.5174L5.37109 11.2495H7.37109L7.37109 14.5175L10.2013 12.8835L11.2013 14.6155L8.37114 16.2495L11.2013 17.8835L10.2013 19.6155L7.37109 17.9815Z"
  }));
},
    NW = function NW(_ref2934) {
  var _ref2934$color = _ref2934.color,
      C = _ref2934$color === void 0 ? "currentColor" : _ref2934$color,
      _ref2934$size = _ref2934.size,
      e = _ref2934$size === void 0 ? 24 : _ref2934$size,
      l = _ref2934.className,
      i = _objectWithoutProperties(_ref2934, _excluded2934);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16.5859 18L21.1925 22.6066L22.6068 21.1924L2.80777 1.39343L1.39355 2.80765L3.00008 4.41417V22H5.00008V16H12.0001L12.7237 17.4472C12.8931 17.786 13.2393 18 13.6181 18H16.5859ZM21.0001 5.99995V16.7576L7.24241 2.99995H12.382C12.7608 2.99995 13.1071 3.21396 13.2765 3.55274L14.0001 4.99995H20.0001C20.5524 4.99995 21.0001 5.44767 21.0001 5.99995Z"
  }));
},
    uW = function uW(_ref2935) {
  var _ref2935$color = _ref2935.color,
      C = _ref2935$color === void 0 ? "currentColor" : _ref2935$color,
      _ref2935$size = _ref2935.size,
      e = _ref2935$size === void 0 ? 24 : _ref2935$size,
      l = _ref2935.className,
      i = _objectWithoutProperties(_ref2935, _excluded2935);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16.5859 18L21.1925 22.6066L22.6068 21.1924L2.80777 1.39343L1.39355 2.80765L3.00008 4.41417V22H5.00008V16H12.0001L12.7237 17.4472C12.8931 17.786 13.2393 18 13.6181 18H16.5859ZM14.5859 16H14.2361L13.8864 15.3005L14.5859 16ZM12.5859 14H5.00008V6.41417L12.5859 14ZM21.0001 5.99995V16.7576L19.0001 14.7576V6.99995H12.764L11.764 4.99995H9.24241L7.24241 2.99995H12.382C12.7608 2.99995 13.1071 3.21396 13.2765 3.55274L14.0001 4.99995H20.0001C20.5524 4.99995 21.0001 5.44767 21.0001 5.99995Z"
  }));
},
    BW = function BW(_ref2936) {
  var _ref2936$color = _ref2936.color,
      C = _ref2936$color === void 0 ? "currentColor" : _ref2936$color,
      _ref2936$size = _ref2936.size,
      e = _ref2936$size === void 0 ? 24 : _ref2936$size,
      l = _ref2936.className,
      i = _objectWithoutProperties(_ref2936, _excluded2936);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.5812 2.68627C12.2335 2.43791 11.7664 2.43791 11.4187 2.68627L1.9187 9.47198L3.08118 11.0994L11.9999 4.7289L20.9187 11.0994L22.0812 9.47198L12.5812 2.68627ZM19.5812 12.6863L12.5812 7.68627C12.2335 7.43791 11.7664 7.43791 11.4187 7.68627L4.4187 12.6863C4.15591 12.874 3.99994 13.177 3.99994 13.5V20C3.99994 20.5523 4.44765 21 4.99994 21H18.9999C19.5522 21 19.9999 20.5523 19.9999 20V13.5C19.9999 13.177 19.844 12.874 19.5812 12.6863Z"
  }));
},
    fW = function fW(_ref2937) {
  var _ref2937$color = _ref2937.color,
      C = _ref2937$color === void 0 ? "currentColor" : _ref2937$color,
      _ref2937$size = _ref2937.size,
      e = _ref2937$size === void 0 ? 24 : _ref2937$size,
      l = _ref2937.className,
      i = _objectWithoutProperties(_ref2937, _excluded2937);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.5812 2.68627C12.2335 2.43791 11.7664 2.43791 11.4187 2.68627L1.9187 9.47198L3.08118 11.0994L11.9999 4.7289L20.9187 11.0994L22.0812 9.47198L12.5812 2.68627ZM19.5812 12.6863L12.5812 7.68627C12.2335 7.43791 11.7664 7.43791 11.4187 7.68627L4.4187 12.6863C4.15591 12.874 3.99994 13.177 3.99994 13.5V20C3.99994 20.5523 4.44765 21 4.99994 21H18.9999C19.5522 21 19.9999 20.5523 19.9999 20V13.5C19.9999 13.177 19.844 12.874 19.5812 12.6863ZM5.99994 19V14.0146L11.9999 9.7289L17.9999 14.0146V19H5.99994Z"
  }));
},
    RW = function RW(_ref2938) {
  var _ref2938$color = _ref2938.color,
      C = _ref2938$color === void 0 ? "currentColor" : _ref2938$color,
      _ref2938$size = _ref2938.size,
      e = _ref2938$size === void 0 ? 24 : _ref2938$size,
      l = _ref2938.className,
      i = _objectWithoutProperties(_ref2938, _excluded2938);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.7134 8.12811L20.4668 8.69379C20.2864 9.10792 19.7136 9.10792 19.5331 8.69379L19.2866 8.12811C18.8471 7.11947 18.0555 6.31641 17.0677 5.87708L16.308 5.53922C15.8973 5.35653 15.8973 4.75881 16.308 4.57612L17.0252 4.25714C18.0384 3.80651 18.8442 2.97373 19.2761 1.93083L19.5293 1.31953C19.7058 0.893489 20.2942 0.893489 20.4706 1.31953L20.7238 1.93083C21.1558 2.97373 21.9616 3.80651 22.9748 4.25714L23.6919 4.57612C24.1027 4.75881 24.1027 5.35653 23.6919 5.53922L22.9323 5.87708C21.9445 6.31641 21.1529 7.11947 20.7134 8.12811ZM2.9918 3H14V5H4V19L13.2923 9.70649C13.6828 9.31595 14.3159 9.31591 14.7065 9.70641L20 15.0104V11H22V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5551 2 20.0066V3.9934C2 3.44476 2.45531 3 2.9918 3ZM8 11C6.89543 11 6 10.1046 6 9C6 7.89543 6.89543 7 8 7C9.10457 7 10 7.89543 10 9C10 10.1046 9.10457 11 8 11Z"
  }));
},
    zW = function zW(_ref2939) {
  var _ref2939$color = _ref2939.color,
      C = _ref2939$color === void 0 ? "currentColor" : _ref2939$color,
      _ref2939$size = _ref2939.size,
      e = _ref2939$size === void 0 ? 24 : _ref2939$size,
      l = _ref2939.className,
      i = _objectWithoutProperties(_ref2939, _excluded2939);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.7134 8.12811L20.4668 8.69379C20.2864 9.10792 19.7136 9.10792 19.5331 8.69379L19.2866 8.12811C18.8471 7.11947 18.0555 6.31641 17.0677 5.87708L16.308 5.53922C15.8973 5.35653 15.8973 4.75881 16.308 4.57612L17.0252 4.25714C18.0384 3.80651 18.8442 2.97373 19.2761 1.93083L19.5293 1.31953C19.7058 0.893489 20.2942 0.893489 20.4706 1.31953L20.7238 1.93083C21.1558 2.97373 21.9616 3.80651 22.9748 4.25714L23.6919 4.57612C24.1027 4.75881 24.1027 5.35653 23.6919 5.53922L22.9323 5.87708C21.9445 6.31641 21.1529 7.11947 20.7134 8.12811ZM2.9918 3H14V5H4V19L14 9L20 15V11H22V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5551 2 20.0066V3.9934C2 3.44476 2.45531 3 2.9918 3ZM20 17.8284L14 11.8284L6.82843 19H20V17.8284ZM8 11C6.89543 11 6 10.1046 6 9C6 7.89543 6.89543 7 8 7C9.10457 7 10 7.89543 10 9C10 10.1046 9.10457 11 8 11Z"
  }));
},
    FW = function FW(_ref2940) {
  var _ref2940$color = _ref2940.color,
      C = _ref2940$color === void 0 ? "currentColor" : _ref2940$color,
      _ref2940$size = _ref2940.size,
      e = _ref2940$size === void 0 ? 24 : _ref2940$size,
      l = _ref2940.className,
      i = _objectWithoutProperties(_ref2940, _excluded2940);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.4668 8.69379L20.7134 8.12811C21.1529 7.11947 21.9445 6.31641 22.9323 5.87708L23.6919 5.53922C24.1027 5.35653 24.1027 4.75881 23.6919 4.57612L22.9748 4.25714C21.9616 3.80651 21.1558 2.97373 20.7238 1.93083L20.4706 1.31953C20.2942 0.893489 19.7058 0.893489 19.5293 1.31953L19.2761 1.93083C18.8442 2.97373 18.0384 3.80651 17.0252 4.25714L16.308 4.57612C15.8973 4.75881 15.8973 5.35653 16.308 5.53922L17.0677 5.87708C18.0555 6.31641 18.8471 7.11947 19.2866 8.12811L19.5331 8.69379C19.7136 9.10792 20.2864 9.10792 20.4668 8.69379ZM12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 11.5975 21.9762 11.2002 21.9298 10.8094L19.9437 11.0452C19.9809 11.3579 20 11.6765 20 12C20 12.9012 19.851 13.7676 19.5762 14.5759L15.7073 10.707C15.3168 10.3164 14.6836 10.3164 14.2931 10.707L6.86516 18.1349C5.11372 16.6674 4 14.4637 4 12C4 7.58172 7.58172 4 12 4C12.6919 4 13.3618 4.0876 14 4.25179L14.4983 2.31487C13.6987 2.10914 12.8614 2 12 2ZM9 12C10.1046 12 11 11.1046 11 10C11 8.89543 10.1046 8 9 8C7.89543 8 7 8.89543 7 10C7 11.1046 7.89543 12 9 12Z"
  }));
},
    SW = function SW(_ref2941) {
  var _ref2941$color = _ref2941.color,
      C = _ref2941$color === void 0 ? "currentColor" : _ref2941$color,
      _ref2941$size = _ref2941.size,
      e = _ref2941$size === void 0 ? 24 : _ref2941$size,
      l = _ref2941.className,
      i = _objectWithoutProperties(_ref2941, _excluded2941);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.4668 8.69379L20.7134 8.12811C21.1529 7.11947 21.9445 6.31641 22.9323 5.87708L23.6919 5.53922C24.1027 5.35653 24.1027 4.75881 23.6919 4.57612L22.9748 4.25714C21.9616 3.80651 21.1558 2.97373 20.7238 1.93083L20.4706 1.31953C20.2942 0.893489 19.7058 0.893489 19.5293 1.31953L19.2761 1.93083C18.8442 2.97373 18.0384 3.80651 17.0252 4.25714L16.308 4.57612C15.8973 4.75881 15.8973 5.35653 16.308 5.53922L17.0677 5.87708C18.0555 6.31641 18.8471 7.11947 19.2866 8.12811L19.5331 8.69379C19.7136 9.10792 20.2864 9.10792 20.4668 8.69379ZM12 4C7.58172 4 4 7.58172 4 12C4 14.4636 5.11358 16.6671 6.86484 18.1346L14.2925 10.707C14.683 10.3164 15.3162 10.3164 15.7067 10.707L19.5761 14.5764C19.5773 14.5729 19.5785 14.5693 19.5797 14.5658C19.8522 13.7604 20 12.8975 20 12C20 11.6765 19.9809 11.3579 19.9437 11.0452L21.9298 10.8094C21.9762 11.2002 22 11.5975 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C12.8614 2 13.6987 2.10914 14.4983 2.31487L14 4.25179C13.3618 4.0876 12.6919 4 12 4ZM10.813 19.9125C11.2 19.9701 11.5962 19.9998 11.9996 19.9998C14.7613 19.9998 17.1992 18.6003 18.6379 16.4666L14.9996 12.8283L8.58927 19.2386L8.59334 19.2405C9.28476 19.5664 10.0304 19.7961 10.813 19.9125ZM11 10C11 11.1046 10.1046 12 9 12C7.89543 12 7 11.1046 7 10C7 8.89543 7.89543 8 9 8C10.1046 8 11 8.89543 11 10Z"
  }));
},
    AW = function AW(_ref2942) {
  var _ref2942$color = _ref2942.color,
      C = _ref2942$color === void 0 ? "currentColor" : _ref2942$color,
      _ref2942$size = _ref2942.size,
      e = _ref2942$size === void 0 ? 24 : _ref2942$size,
      l = _ref2942.className,
      i = _objectWithoutProperties(_ref2942, _excluded2942);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M1 5C1 4.44772 1.44772 4 2 4H22C22.5523 4 23 4.44772 23 5V19C23 19.5523 22.5523 20 22 20H2C1.44772 20 1 19.5523 1 19V5ZM9 8H7V10H9V8ZM7 13V16H9V11H6V13H7ZM13 9V11H19V9H13ZM18 13H13V15H18V13Z"
  }));
},
    kW = function kW(_ref2943) {
  var _ref2943$color = _ref2943.color,
      C = _ref2943$color === void 0 ? "currentColor" : _ref2943$color,
      _ref2943$size = _ref2943.size,
      e = _ref2943$size === void 0 ? 24 : _ref2943$size,
      l = _ref2943.className,
      i = _objectWithoutProperties(_ref2943, _excluded2943);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 6H21V18H3V6ZM2 4C1.44772 4 1 4.44772 1 5V19C1 19.5523 1.44772 20 2 20H22C22.5523 20 23 19.5523 23 19V5C23 4.44772 22.5523 4 22 4H2ZM13 9H19V11H13V9ZM18 13H13V15H18V13ZM6 13H7V16H9V11H6V13ZM9 8H7V10H9V8Z"
  }));
},
    PW = function PW(_ref2944) {
  var _ref2944$color = _ref2944.color,
      C = _ref2944$color === void 0 ? "currentColor" : _ref2944$color,
      _ref2944$size = _ref2944.size,
      e = _ref2944$size === void 0 ? 24 : _ref2944$size,
      l = _ref2944.className,
      i = _objectWithoutProperties(_ref2944, _excluded2944);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.2134 8.62811L5.96682 9.19379C5.78637 9.60792 5.21357 9.60792 5.03312 9.19379L4.78656 8.62811C4.34706 7.61947 3.55545 6.81641 2.56767 6.37708L1.80805 6.03922C1.39732 5.85653 1.39732 5.25881 1.80805 5.07612L2.5252 4.75714C3.53838 4.30651 4.34417 3.47373 4.77612 2.43083L5.02932 1.81953C5.20578 1.39349 5.79417 1.39349 5.97063 1.81953L6.22382 2.43083C6.65577 3.47373 7.46158 4.30651 8.4748 4.75714L9.19188 5.07612C9.60271 5.25881 9.60271 5.85653 9.19188 6.03922L8.43228 6.37708C7.44451 6.81641 6.65288 7.61947 6.2134 8.62811ZM11.2381 12.2698L16 21H23L15 6L11.2381 12.2698ZM14 21L8 10L2 21H14Z"
  }));
},
    DW = function DW(_ref2945) {
  var _ref2945$color = _ref2945.color,
      C = _ref2945$color === void 0 ? "currentColor" : _ref2945$color,
      _ref2945$size = _ref2945.size,
      e = _ref2945$size === void 0 ? 24 : _ref2945$size,
      l = _ref2945.className,
      i = _objectWithoutProperties(_ref2945, _excluded2945);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.2134 8.62811L5.96682 9.19379C5.78637 9.60792 5.21357 9.60792 5.03312 9.19379L4.78656 8.62811C4.34706 7.61947 3.55545 6.81641 2.56767 6.37708L1.80805 6.03922C1.39732 5.85653 1.39732 5.25881 1.80805 5.07612L2.5252 4.75714C3.53838 4.30651 4.34417 3.47373 4.77612 2.43083L5.02932 1.81953C5.20578 1.39349 5.79417 1.39349 5.97063 1.81953L6.22382 2.43083C6.65577 3.47373 7.46158 4.30651 8.4748 4.75714L9.19188 5.07612C9.60271 5.25881 9.60271 5.85653 9.19188 6.03922L8.43228 6.37708C7.44451 6.81641 6.65288 7.61947 6.2134 8.62811ZM15 6L11.2703 12.2162L9 8L2 21H23L15 6ZM14.9873 19L12.3897 14.2378L14.8976 10.058L19.6667 19H14.9873ZM12.6516 19H5.34843L9 12.2185L12.6516 19Z"
  }));
},
    yW = function yW(_ref2946) {
  var _ref2946$color = _ref2946.color,
      C = _ref2946$color === void 0 ? "currentColor" : _ref2946$color,
      _ref2946$size = _ref2946.size,
      e = _ref2946$size === void 0 ? 24 : _ref2946$size,
      l = _ref2946.className,
      i = _objectWithoutProperties(_ref2946, _excluded2946);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6.19983 14H8.3539L9.55389 11H14.4458L15.6458 14H17.7998L12.9998 2H10.9998L6.19983 14ZM11.9998 4.88517 13.6458 9H10.3539L11.9998 4.88517ZM3 16V22L5 22 4.99992 20H18.9999L19 22 21 22 20.9999 16H18.9999V18H4.99992L5 16 3 16Z"
  }));
},
    bW = function bW(_ref2947) {
  var _ref2947$color = _ref2947.color,
      C = _ref2947$color === void 0 ? "currentColor" : _ref2947$color,
      _ref2947$size = _ref2947.size,
      e = _ref2947$size === void 0 ? 24 : _ref2947$size,
      l = _ref2947.className,
      i = _objectWithoutProperties(_ref2947, _excluded2947);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 3.00012L2.00008 5.00012L4.00004 5.00004L4.00004 19L2 19.0001L2.00008 21.0001L8.00004 21V19H6.00004L6.00004 5.00004L8 5.00012L8.00008 3.00012L2 3.00012ZM10.2 18H12.3541L13.5541 15H18.4459L19.6459 18H21.8L17 6H15L10.2 18ZM16 8.88517L17.6459 13H14.3541L16 8.88517Z"
  }));
},
    TW = function TW(_ref2948) {
  var _ref2948$color = _ref2948.color,
      C = _ref2948$color === void 0 ? "currentColor" : _ref2948$color,
      _ref2948$size = _ref2948.size,
      e = _ref2948$size === void 0 ? 24 : _ref2948$size,
      l = _ref2948.className,
      i = _objectWithoutProperties(_ref2948, _excluded2948);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.7134 8.12811L20.4668 8.69379C20.2864 9.10792 19.7136 9.10792 19.5331 8.69379L19.2866 8.12811C18.8471 7.11947 18.0555 6.31641 17.0677 5.87708L16.308 5.53922C15.8973 5.35653 15.8973 4.75881 16.308 4.57612L17.0252 4.25714C18.0384 3.80651 18.8442 2.97373 19.2761 1.93083L19.5293 1.31953C19.7058 0.893489 20.2942 0.893489 20.4706 1.31953L20.7238 1.93083C21.1558 2.97373 21.9616 3.80651 22.9748 4.25714L23.6919 4.57612C24.1027 4.75881 24.1027 5.35653 23.6919 5.53922L22.9323 5.87708C21.9445 6.31641 21.1529 7.11947 20.7134 8.12811ZM19.9999 11C20.7012 11 21.3744 10.8797 22 10.6586V20C22 20.5523 21.5523 21 21 21H2V4C2 3.44772 2.44772 3 3 3H14.3413C14.1202 3.62556 13.9999 4.29873 13.9999 5C13.9999 6.44366 14.5098 7.76824 15.3593 8.80348L11.9999 11.6829L5.6507 6.24074L4.34912 7.75926L11.9999 14.3171L16.8855 10.1294C17.7934 10.6818 18.8595 11 19.9999 11Z"
  }));
},
    UW = function UW(_ref2949) {
  var _ref2949$color = _ref2949.color,
      C = _ref2949$color === void 0 ? "currentColor" : _ref2949$color,
      _ref2949$size = _ref2949.size,
      e = _ref2949$size === void 0 ? 24 : _ref2949$size,
      l = _ref2949.className,
      i = _objectWithoutProperties(_ref2949, _excluded2949);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.7134 8.12811L20.4668 8.69379C20.2864 9.10792 19.7136 9.10792 19.5331 8.69379L19.2866 8.12811C18.8471 7.11947 18.0555 6.31641 17.0677 5.87708L16.308 5.53922C15.8973 5.35653 15.8973 4.75881 16.308 4.57612L17.0252 4.25714C18.0384 3.80651 18.8442 2.97373 19.2761 1.93083L19.5293 1.31953C19.7058 0.893489 20.2942 0.893489 20.4706 1.31953L20.7238 1.93083C21.1558 2.97373 21.9616 3.80651 22.9748 4.25714L23.6919 4.57612C24.1027 4.75881 24.1027 5.35653 23.6919 5.53922L22.9323 5.87708C21.9445 6.31641 21.1529 7.11947 20.7134 8.12811ZM2 4C2 3.44772 2.44772 3 3 3H14V5H4.5052L12 11.662L16.3981 7.75259L17.7269 9.24741L12 14.338L4 7.22684V19H20V11H22V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4Z"
  }));
},
    GW = function GW(_ref2950) {
  var _ref2950$color = _ref2950.color,
      C = _ref2950$color === void 0 ? "currentColor" : _ref2950$color,
      _ref2950$size = _ref2950.size,
      e = _ref2950$size === void 0 ? 24 : _ref2950$size,
      l = _ref2950.className,
      i = _objectWithoutProperties(_ref2950, _excluded2950);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.4668 7.69379L20.7134 7.12811C21.1529 6.11947 21.9445 5.31641 22.9323 4.87708L23.6919 4.53922C24.1027 4.35653 24.1027 3.75881 23.6919 3.57612L22.9748 3.25714C21.9616 2.80651 21.1558 1.97373 20.7238 0.930828L20.4706 0.319534C20.2942 -0.106511 19.7058 -0.106511 19.5293 0.319534L19.2761 0.930828C18.8442 1.97373 18.0384 2.80651 17.0252 3.25714L16.308 3.57612C15.8973 3.75881 15.8973 4.35653 16.308 4.53922L17.0677 4.87708C18.0555 5.31641 18.8471 6.11947 19.2866 7.12811L19.5331 7.69379C19.7136 8.10792 20.2864 8.10792 20.4668 7.69379ZM14.3869 5.33879C14.661 5.77254 15.0357 6.09305 15.5111 6.30032L16.0764 6.54679C16.4567 6.71256 16.7646 6.94544 17.0001 7.24543V12C17.0001 14.7614 14.7615 17 12.0001 17C9.23865 17 7.00008 14.7614 7.00008 12V6C7.00008 3.23858 9.23865 1 12.0001 1C13.1241 1 14.1615 1.37089 14.9965 1.99697C14.7564 2.17669 14.5532 2.39808 14.3869 2.66114C14.129 3.06938 14 3.51566 14 3.99997C14 4.48428 14.129 4.93056 14.3869 5.33879ZM2.19238 13.9615L4.15392 13.5692C4.88321 17.2361 8.11888 20 12.0001 20C15.8813 20 19.1169 17.2361 19.8462 13.5692L21.8078 13.9615C20.8961 18.5452 16.8516 22 12.0001 22C7.14858 22 3.104 18.5452 2.19238 13.9615Z"
  }));
},
    IW = function IW(_ref2951) {
  var _ref2951$color = _ref2951.color,
      C = _ref2951$color === void 0 ? "currentColor" : _ref2951$color,
      _ref2951$size = _ref2951.size,
      e = _ref2951$size === void 0 ? 24 : _ref2951$size,
      l = _ref2951.className,
      i = _objectWithoutProperties(_ref2951, _excluded2951);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.7134 7.12811L20.4668 7.69379C20.2864 8.10792 19.7136 8.10792 19.5331 7.69379L19.2866 7.12811C18.8471 6.11947 18.0555 5.31641 17.0677 4.87708L16.308 4.53922C15.8973 4.35653 15.8973 3.75881 16.308 3.57612L17.0252 3.25714C18.0384 2.80651 18.8442 1.97373 19.2761 0.930828L19.5293 0.319534C19.7058 -0.106511 20.2942 -0.106511 20.4706 0.319534L20.7238 0.930828C21.1558 1.97373 21.9616 2.80651 22.9748 3.25714L23.6919 3.57612C24.1027 3.75881 24.1027 4.35653 23.6919 4.53922L22.9323 4.87708C21.9445 5.31641 21.1529 6.11947 20.7134 7.12811ZM7 6C7 3.23858 9.23858 1 12 1C12.9914 1 13.9182 1.28957 14.6969 1.7891L13.617 3.47248C13.1509 3.17349 12.5972 3 12 3C10.3431 3 9 4.34315 9 6V12C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12V7H17V12C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12V6ZM2.19238 13.9617L4.15392 13.5693C4.88321 17.2362 8.11888 20.0001 12.0001 20.0001C15.8813 20.0001 19.1169 17.2363 19.8462 13.5693L21.8078 13.9617C20.8961 18.5453 16.8516 22.0001 12.0001 22.0001C7.14858 22.0001 3.104 18.5453 2.19238 13.9617Z"
  }));
},
    WW = function WW(_ref2952) {
  var _ref2952$color = _ref2952.color,
      C = _ref2952$color === void 0 ? "currentColor" : _ref2952$color,
      _ref2952$size = _ref2952.size,
      e = _ref2952$size === void 0 ? 24 : _ref2952$size,
      l = _ref2952.className,
      i = _objectWithoutProperties(_ref2952, _excluded2952);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.4668 7.69379L20.7134 7.12811C21.1529 6.11947 21.9445 5.31641 22.9323 4.87708L23.6919 4.53922C24.1027 4.35653 24.1027 3.75881 23.6919 3.57612L22.9748 3.25714C21.9616 2.80651 21.1558 1.97373 20.7238 0.930828L20.4706 0.319534C20.2942 -0.106511 19.7058 -0.106511 19.5293 0.319534L19.2761 0.930828C18.8442 1.97373 18.0384 2.80651 17.0252 3.25714L16.308 3.57612C15.8973 3.75881 15.8973 4.35653 16.308 4.53922L17.0677 4.87708C18.0555 5.31641 18.8471 6.11947 19.2866 7.12811L19.5331 7.69379C19.7136 8.10792 20.2864 8.10792 20.4668 7.69379ZM14.3869 5.33879C14.661 5.77254 15.0357 6.09305 15.5111 6.30032L16.0764 6.54679C16.4565 6.71249 16.7643 6.94524 16.9998 7.24503V10C16.9998 12.7614 14.7612 15 11.9998 15C9.23833 15 6.99976 12.7614 6.99976 10V6C6.99976 3.23858 9.23833 1 11.9998 1C13.1238 1 14.1613 1.37094 14.9964 1.99709C14.7563 2.17678 14.5531 2.39813 14.3869 2.66114C14.129 3.06938 14 3.51566 14 3.99997C14 4.48428 14.129 4.93056 14.3869 5.33879ZM3.05469 11H5.07065C5.55588 14.3923 8.47329 17 11.9998 17C15.5262 17 18.4436 14.3923 18.9289 11H20.9448C20.4837 15.1716 17.1714 18.4839 12.9998 18.9451V23H10.9998V18.9451C6.82814 18.4839 3.51584 15.1716 3.05469 11Z"
  }));
},
    OW = function OW(_ref2953) {
  var _ref2953$color = _ref2953.color,
      C = _ref2953$color === void 0 ? "currentColor" : _ref2953$color,
      _ref2953$size = _ref2953.size,
      e = _ref2953$size === void 0 ? 24 : _ref2953$size,
      l = _ref2953.className,
      i = _objectWithoutProperties(_ref2953, _excluded2953);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.4668 7.69379L20.7134 7.12811C21.1529 6.11947 21.9445 5.31641 22.9323 4.87708L23.6919 4.53922C24.1027 4.35653 24.1027 3.75881 23.6919 3.57612L22.9748 3.25714C21.9616 2.80651 21.1558 1.97373 20.7238 0.930828L20.4706 0.319534C20.2942 -0.106511 19.7058 -0.106511 19.5293 0.319534L19.2761 0.930828C18.8442 1.97373 18.0384 2.80651 17.0252 3.25714L16.308 3.57612C15.8973 3.75881 15.8973 4.35653 16.308 4.53922L17.0677 4.87708C18.0555 5.31641 18.8471 6.11947 19.2866 7.12811L19.5331 7.69379C19.7136 8.10792 20.2864 8.10792 20.4668 7.69379ZM3.05469 11H5.07065C5.55588 14.3923 8.47329 17 11.9998 17C15.5262 17 18.4436 14.3923 18.9289 11H20.9448C20.4837 15.1716 17.1714 18.4839 12.9998 18.9451V23H10.9998V18.9451C6.82814 18.4839 3.51584 15.1716 3.05469 11ZM12 1C9.23858 1 7 3.23858 7 6V10C7 12.7614 9.23858 15 12 15C14.7614 15 17 12.7614 17 10V7H15V10C15 11.6569 13.6569 13 12 13C10.3431 13 9 11.6569 9 10V6C9 4.34315 10.3431 3 12 3C12.5972 3 13.1509 3.17349 13.617 3.47248L14.6969 1.7891C13.9182 1.28957 12.9914 1 12 1Z"
  }));
},
    KW = function KW(_ref2954) {
  var _ref2954$color = _ref2954.color,
      C = _ref2954$color === void 0 ? "currentColor" : _ref2954$color,
      _ref2954$size = _ref2954.size,
      e = _ref2954$size === void 0 ? 24 : _ref2954$size,
      l = _ref2954.className,
      i = _objectWithoutProperties(_ref2954, _excluded2954);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.7134 8.12811L20.4668 8.69379C20.2864 9.10792 19.7136 9.10792 19.5331 8.69379L19.2866 8.12811C18.8471 7.11947 18.0555 6.31641 17.0677 5.87708L16.308 5.53922C15.8973 5.35653 15.8973 4.75881 16.308 4.57612L17.0252 4.25714C18.0384 3.80651 18.8442 2.97373 19.2761 1.93083L19.5293 1.31953C19.7058 0.893489 20.2942 0.893489 20.4706 1.31953L20.7238 1.93083C21.1558 2.97373 21.9616 3.80651 22.9748 4.25714L23.6919 4.57612C24.1027 4.75881 24.1027 5.35653 23.6919 5.53922L22.9323 5.87708C21.9445 6.31641 21.1529 7.11947 20.7134 8.12811ZM20 11C20.7013 11 21.3744 10.8797 22 10.6586V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5551 2 20.0066V3.9934C2 3.44476 2.45531 3 2.9918 3H14.3414C14.1203 3.62556 14 4.29873 14 5C14 8.31371 16.6863 11 20 11ZM10.6219 8.41459C10.5562 8.37078 10.479 8.34741 10.4 8.34741C10.1791 8.34741 10 8.52649 10 8.74741V15.2526C10 15.3316 10.0234 15.4088 10.0672 15.4745C10.1897 15.6583 10.4381 15.708 10.6219 15.5854L15.5008 12.3328C15.5447 12.3035 15.5824 12.2658 15.6117 12.2219C15.7343 12.0381 15.6846 11.7897 15.5008 11.6672L10.6219 8.41459Z"
  }));
},
    QW = function QW(_ref2955) {
  var _ref2955$color = _ref2955.color,
      C = _ref2955$color === void 0 ? "currentColor" : _ref2955$color,
      _ref2955$size = _ref2955.size,
      e = _ref2955$size === void 0 ? 24 : _ref2955$size,
      l = _ref2955.className,
      i = _objectWithoutProperties(_ref2955, _excluded2955);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.7134 8.12811L20.4668 8.69379C20.2864 9.10792 19.7136 9.10792 19.5331 8.69379L19.2866 8.12811C18.8471 7.11947 18.0555 6.31641 17.0677 5.87708L16.308 5.53922C15.8973 5.35653 15.8973 4.75881 16.308 4.57612L17.0252 4.25714C18.0384 3.80651 18.8442 2.97373 19.2761 1.93083L19.5293 1.31953C19.7058 0.893489 20.2942 0.893489 20.4706 1.31953L20.7238 1.93083C21.1558 2.97373 21.9616 3.80651 22.9748 4.25714L23.6919 4.57612C24.1027 4.75881 24.1027 5.35653 23.6919 5.53922L22.9323 5.87708C21.9445 6.31641 21.1529 7.11947 20.7134 8.12811ZM2.9918 3H14V5H4V19H20V11H22V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5551 2 20.0066V3.9934C2 3.44476 2.45531 3 2.9918 3ZM10.6219 8.41459L15.5008 11.6672C15.6846 11.7897 15.7343 12.0381 15.6117 12.2219C15.5824 12.2658 15.5447 12.3035 15.5008 12.3328L10.6219 15.5854C10.4381 15.708 10.1897 15.6583 10.0672 15.4745C10.0234 15.4088 10 15.3316 10 15.2526V8.74741C10 8.52649 10.1791 8.34741 10.4 8.34741C10.479 8.34741 10.5562 8.37078 10.6219 8.41459Z"
  }));
},
    qW = function qW(_ref2956) {
  var _ref2956$color = _ref2956.color,
      C = _ref2956$color === void 0 ? "currentColor" : _ref2956$color,
      _ref2956$size = _ref2956.size,
      e = _ref2956$size === void 0 ? 24 : _ref2956$size,
      l = _ref2956.className,
      i = _objectWithoutProperties(_ref2956, _excluded2956);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18.7134 8.12811L18.4668 8.69379C18.2864 9.10792 17.7136 9.10792 17.5331 8.69379L17.2866 8.12811C16.8471 7.11947 16.0555 6.31641 15.0677 5.87708L14.308 5.53922C13.8973 5.35653 13.8973 4.75881 14.308 4.57612L15.0252 4.25714C16.0384 3.80651 16.8442 2.97373 17.2761 1.93083L17.5293 1.31953C17.7058 0.893489 18.2942 0.893489 18.4706 1.31953L18.7238 1.93083C19.1558 2.97373 19.9616 3.80651 20.9748 4.25714L21.6919 4.57612C22.1027 4.75881 22.1027 5.35653 21.6919 5.53922L20.9323 5.87708C19.9445 6.31641 19.1529 7.11947 18.7134 8.12811ZM7 3H12V6H9V17C9 19.2091 7.20914 21 5 21C2.79086 21 1 19.2091 1 17C1 14.7909 2.79086 13 5 13C5.72857 13 6.41165 13.1948 7 13.5351V3ZM18 13.5351V11H20V17C20 19.2091 18.2091 21 16 21C13.7909 21 12 19.2091 12 17C12 14.7909 13.7909 13 16 13C16.7286 13 17.4117 13.1948 18 13.5351Z"
  }));
},
    jW = function jW(_ref2957) {
  var _ref2957$color = _ref2957.color,
      C = _ref2957$color === void 0 ? "currentColor" : _ref2957$color,
      _ref2957$size = _ref2957.size,
      e = _ref2957$size === void 0 ? 24 : _ref2957$size,
      l = _ref2957.className,
      i = _objectWithoutProperties(_ref2957, _excluded2957);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18.7134 8.12811L18.4668 8.69379C18.2864 9.10792 17.7136 9.10792 17.5331 8.69379L17.2866 8.12811C16.8471 7.11947 16.0555 6.31641 15.0677 5.87708L14.308 5.53922C13.8973 5.35653 13.8973 4.75881 14.308 4.57612L15.0252 4.25714C16.0384 3.80651 16.8442 2.97373 17.2761 1.93083L17.5293 1.31953C17.7058 0.893489 18.2942 0.893489 18.4706 1.31953L18.7238 1.93083C19.1558 2.97373 19.9616 3.80651 20.9748 4.25714L21.6919 4.57612C22.1027 4.75881 22.1027 5.35653 21.6919 5.53922L20.9323 5.87708C19.9445 6.31641 19.1529 7.11947 18.7134 8.12811ZM7 3H12V5H9V17C9 19.2091 7.20914 21 5 21C2.79086 21 1 19.2091 1 17C1 14.7909 2.79086 13 5 13C5.72857 13 6.41165 13.1948 7 13.5351V3ZM18 13.5351V11H20V17C20 19.2091 18.2091 21 16 21C13.7909 21 12 19.2091 12 17C12 14.7909 13.7909 13 16 13C16.7286 13 17.4117 13.1948 18 13.5351ZM5 19C6.10457 19 7 18.1046 7 17C7 15.8954 6.10457 15 5 15C3.89543 15 3 15.8954 3 17C3 18.1046 3.89543 19 5 19ZM16 19C17.1046 19 18 18.1046 18 17C18 15.8954 17.1046 15 16 15C14.8954 15 14 15.8954 14 17C14 18.1046 14.8954 19 16 19Z"
  }));
},
    XW = function XW(_ref2958) {
  var _ref2958$color = _ref2958.color,
      C = _ref2958$color === void 0 ? "currentColor" : _ref2958$color,
      _ref2958$size = _ref2958.size,
      e = _ref2958$size === void 0 ? 24 : _ref2958$size,
      l = _ref2958.className,
      i = _objectWithoutProperties(_ref2958, _excluded2958);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22 17H20V10C20 5.58172 16.4183 2 12 2C7.58172 2 4 5.58172 4 10V17H2V19H22V17ZM15 23V21H9V23H15ZM9 9V7H15V9.41421L11.4142 13H15V15H9V12.5858L12.5858 9H9Z"
  }));
},
    JW = function JW(_ref2959) {
  var _ref2959$color = _ref2959.color,
      C = _ref2959$color === void 0 ? "currentColor" : _ref2959$color,
      _ref2959$size = _ref2959.size,
      e = _ref2959$size === void 0 ? 24 : _ref2959$size,
      l = _ref2959.className,
      i = _objectWithoutProperties(_ref2959, _excluded2959);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22 17H20V10C20 5.58172 16.4183 2 12 2C7.58172 2 4 5.58172 4 10V17H2V19H22V17ZM18 10V17H6V10C6 6.68629 8.68629 4 12 4C15.3137 4 18 6.68629 18 10ZM15 23V21H9V23H15ZM9 9H12.5858L9 12.5858V15H15V13H11.4142L15 9.41421V7H9V9Z"
  }));
},
    YW = function YW(_ref2960) {
  var _ref2960$color = _ref2960.color,
      C = _ref2960$color === void 0 ? "currentColor" : _ref2960$color,
      _ref2960$size = _ref2960.size,
      e = _ref2960$size === void 0 ? 24 : _ref2960$size,
      l = _ref2960.className,
      i = _objectWithoutProperties(_ref2960, _excluded2960);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4.931 9.45962H3.59366L2.86408 13.211H4.05124C4.83891 13.211 5.42541 13.0622 5.81074 12.7661C6.19608 12.4686 6.45533 11.9742 6.58991 11.28C6.72024 10.6142 6.66075 10.1439 6.41425 9.87045C6.16633 9.59703 5.67333 9.45962 4.931 9.45962ZM7.38183 13.6133C7.01208 13.9675 6.56725 14.2338 6.08275 14.3939C5.60675 14.5469 4.999 14.6262 4.26233 14.6262H2.58924L2.126 17.0076H0.173828L1.91633 8.04578H5.67049C6.79958 8.04578 7.62266 8.34187 8.14116 8.93545C8.65966 9.52762 8.81549 10.355 8.60866 11.4175C8.52944 11.8379 8.38357 12.243 8.17658 12.6174C7.97399 12.9786 7.70908 13.3115 7.38183 13.6133ZM13.0825 14.6262L13.8517 10.661C13.941 10.2105 13.907 9.90162 13.7554 9.7387C13.6038 9.57437 13.2794 9.4922 12.7822 9.4922H11.2352L10.2378 14.6276H8.29983L10.0423 5.66437H11.9789L11.5157 8.0472H13.2412C14.3277 8.0472 15.0757 8.23703 15.488 8.61528C15.9002 8.99353 16.0235 9.60695 15.8606 10.4555L15.0502 14.6262H13.0825ZM23.8449 11.4175C23.767 11.8382 23.621 12.2435 23.4128 12.6174C23.2102 12.9786 22.9453 13.3115 22.6181 13.6133C22.2481 13.9664 21.8044 14.233 21.319 14.3939C20.843 14.5469 20.2352 14.6262 19.4972 14.6262H17.8255L17.3622 17.009H15.4101L17.1526 8.0472H20.9053C22.0344 8.0472 22.8575 8.34328 23.376 8.93687C23.8945 9.52762 24.0517 10.355 23.8449 11.4175ZM20.1687 9.45962H18.8327L18.1017 13.211H19.2889C20.078 13.211 20.6645 13.0622 21.0484 12.7661C21.4337 12.4686 21.693 11.9742 21.829 11.28C21.9593 10.6142 21.8984 10.1439 21.6519 9.87045C21.4054 9.59703 20.9096 9.45962 20.1687 9.45962Z"
  }));
},
    _W = function _W(_ref2961) {
  var _ref2961$color = _ref2961.color,
      C = _ref2961$color === void 0 ? "currentColor" : _ref2961$color,
      _ref2961$size = _ref2961.size,
      e = _ref2961$size === void 0 ? 24 : _ref2961$size,
      l = _ref2961.className,
      i = _objectWithoutProperties(_ref2961, _excluded2961);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10.15 5.5498L8.43273 14.3844H10.4327L11.2914 9.96713H12.7914C13.3437 9.96713 13.7059 10.4066 13.6006 10.9488L12.9327 14.3844H14.9327L15.6006 10.9488C15.9167 9.32234 14.8298 8.00387 13.173 8.00387H11.673L12.15 5.5498H10.15ZM2.17285 8.00392H5.92285C7.71777 8.00392 8.89521 9.43226 8.55272 11.1942C8.21023 12.9562 6.47751 14.3845 4.68259 14.3845H2.93259L2.45557 16.8386H0.455566L2.17285 8.00392ZM3.31421 12.4212H5.06421C5.75456 12.4212 6.42099 11.8719 6.55272 11.1942C6.68444 10.5165 6.23159 9.96717 5.54123 9.96717H3.79123L3.31421 12.4212ZM17.1728 8.00392H20.9228C22.7178 8.00392 23.8952 9.43226 23.5527 11.1942C23.2102 12.9562 21.4775 14.3845 19.6826 14.3845H17.9326L17.4556 16.8386H15.4556L17.1728 8.00392ZM18.3142 12.4212H20.0642C20.7546 12.4212 21.421 11.8719 21.5527 11.1942C21.6844 10.5165 21.2316 9.96717 20.5412 9.96717H18.7912L18.3142 12.4212Z"
  }));
},
    $W = function $W(_ref2962) {
  var _ref2962$color = _ref2962.color,
      C = _ref2962$color === void 0 ? "currentColor" : _ref2962$color,
      _ref2962$size = _ref2962.size,
      e = _ref2962$size === void 0 ? 24 : _ref2962$size,
      l = _ref2962.className,
      i = _objectWithoutProperties(_ref2962, _excluded2962);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14.4754 1.7678C13.1086 0.400967 10.8925 0.400967 9.52565 1.7678L5.39898 5.89447C6.50441 5.82558 7.63299 6.2135 8.47774 7.05825L11.4703 10.0508C11.7632 10.3437 12.2381 10.3437 12.531 10.0508L15.5235 7.05833C16.3682 6.2136 17.4967 5.82567 18.6021 5.89454L14.4754 1.7678ZM20.4538 7.74617L22.2328 9.52516C23.5943 10.8867 23.5996 13.091 22.2485 14.4591L20.4741 16.2335C19.3025 17.4051 17.403 17.4051 16.2314 16.2335L13.2381 13.2402C12.5547 12.5567 11.4466 12.5567 10.7632 13.2402L7.76977 16.2336C6.5982 17.4052 4.69871 17.4052 3.52713 16.2336L1.74761 14.4541C0.40149 13.0856 0.408385 10.8851 1.76829 9.52516L3.54282 7.75063C4.71554 6.59381 6.60399 6.59872 7.77063 7.76536L10.7632 10.7579C11.4466 11.4413 12.5547 11.4413 13.2381 10.7579L16.2306 7.76543C17.3957 6.60032 19.2807 6.5939 20.4538 7.74617ZM5.39783 18.1045C6.50336 18.1734 7.63206 17.7855 8.47688 16.9407L11.4703 13.9473C11.7632 13.6544 12.2381 13.6544 12.531 13.9473L15.5243 16.9406C16.3691 17.7854 17.4978 18.1733 18.6033 18.1044L14.4754 22.2323C13.1086 23.5991 10.8925 23.5991 9.52565 22.2323L5.39783 18.1045Z"
  }));
},
    eO = function eO(_ref2963) {
  var _ref2963$color = _ref2963.color,
      C = _ref2963$color === void 0 ? "currentColor" : _ref2963$color,
      _ref2963$size = _ref2963.size,
      e = _ref2963$size === void 0 ? 24 : _ref2963$size,
      l = _ref2963.className,
      i = _objectWithoutProperties(_ref2963, _excluded2963);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14.4727 1.74514L22.2509 9.52334C23.6177 10.8902 23.6177 13.1063 22.2509 14.4731L14.4727 22.2512C13.1059 23.6181 10.8898 23.6181 9.52303 22.2512L1.74486 14.4731C0.378017 13.1063 0.378017 10.8902 1.74486 9.52334L9.52303 1.74514C10.8898 0.378247 13.1059 0.378247 14.4727 1.74514ZM11.9979 14.8266L9.52301 17.3015C9.14344 17.6811 8.69837 17.9552 8.22419 18.124L10.9372 20.837C11.523 21.4228 12.4727 21.4228 13.0585 20.837L15.7716 18.124C15.2974 17.9552 14.8523 17.6811 14.4727 17.3015L11.9979 14.8266ZM5.98823 8.10835L3.15907 10.9376C2.57328 11.5234 2.57328 12.4731 3.15907 13.0589L5.9875 15.8873C6.57328 16.4731 7.52303 16.4731 8.10882 15.8873L10.5836 13.4124C11.3647 12.6314 12.631 12.6314 13.4121 13.4124L15.8869 15.8873C16.4726 16.4729 17.4224 16.4726 18.0083 15.8873L20.8367 13.0589C21.4225 12.4731 21.4225 11.5234 20.8367 10.9376L18.0083 8.10905C17.4225 7.52435 16.4724 7.52365 15.8869 8.10905L13.4121 10.584C12.631 11.3651 11.3647 11.3651 10.5836 10.584L8.10882 8.10905C7.52328 7.52355 6.57408 7.52335 5.98823 8.10835ZM10.9372 3.15935L8.22419 5.87235C8.69837 6.04115 9.14344 6.31535 9.52301 6.69485L11.9979 9.16975L14.4727 6.69485C14.8523 6.31535 15.2974 6.04115 15.7716 5.87235L13.0585 3.15935C12.4727 2.57355 11.523 2.57355 10.9372 3.15935Z"
  }));
},
    tO = function tO(_ref2964) {
  var _ref2964$color = _ref2964.color,
      C = _ref2964$color === void 0 ? "currentColor" : _ref2964$color,
      _ref2964$size = _ref2964.size,
      e = _ref2964$size === void 0 ? 24 : _ref2964$size,
      l = _ref2964.className,
      i = _objectWithoutProperties(_ref2964, _excluded2964);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19.7134 8.12811L19.4668 8.69379C19.2864 9.10792 18.7136 9.10792 18.5331 8.69379L18.2866 8.12811C17.8471 7.11947 17.0555 6.31641 16.0677 5.87708L15.308 5.53922C14.8973 5.35653 14.8973 4.75881 15.308 4.57612L16.0252 4.25714C17.0384 3.80651 17.8442 2.97373 18.2761 1.93083L18.5293 1.31953C18.7058 0.893489 19.2942 0.893489 19.4706 1.31953L19.7238 1.93083C20.1558 2.97373 20.9616 3.80651 21.9748 4.25714L22.6919 4.57612C23.1027 4.75881 23.1027 5.35653 22.6919 5.53922L21.9323 5.87708C20.9445 6.31641 20.1529 7.11947 19.7134 8.12811ZM15 21.5386L9 7.53861L6.6594 13H1V11H5.3406L9 2.46143L15 16.4614L17.3406 11H23V13H18.6594L15 21.5386Z"
  }));
},
    CO = function CO(_ref2965) {
  var _ref2965$color = _ref2965.color,
      C = _ref2965$color === void 0 ? "currentColor" : _ref2965$color,
      _ref2965$size = _ref2965.size,
      e = _ref2965$size === void 0 ? 24 : _ref2965$size,
      l = _ref2965.className,
      i = _objectWithoutProperties(_ref2965, _excluded2965);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19.7134 8.12811L19.4668 8.69379C19.2864 9.10792 18.7136 9.10792 18.5331 8.69379L18.2866 8.12811C17.8471 7.11947 17.0555 6.31641 16.0677 5.87708L15.308 5.53922C14.8973 5.35653 14.8973 4.75881 15.308 4.57612L16.0252 4.25714C17.0384 3.80651 17.8442 2.97373 18.2761 1.93083L18.5293 1.31953C18.7058 0.893489 19.2942 0.893489 19.4706 1.31953L19.7238 1.93083C20.1558 2.97373 20.9616 3.80651 21.9748 4.25714L22.6919 4.57612C23.1027 4.75881 23.1027 5.35653 22.6919 5.53922L21.9323 5.87708C20.9445 6.31641 20.1529 7.11947 19.7134 8.12811ZM15 21.5386L9 7.53861L6.6594 13H1V11H5.3406L9 2.46143L15 16.4614L17.3406 11H23V13H18.6594L15 21.5386Z"
  }));
},
    lO = function lO(_ref2966) {
  var _ref2966$color = _ref2966.color,
      C = _ref2966$color === void 0 ? "currentColor" : _ref2966$color,
      _ref2966$size = _ref2966.size,
      e = _ref2966$size === void 0 ? 24 : _ref2966$size,
      l = _ref2966.className,
      i = _objectWithoutProperties(_ref2966, _excluded2966);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4.7134 7.12811L4.46682 7.69379C4.28637 8.10792 3.71357 8.10792 3.53312 7.69379L3.28656 7.12811C2.84706 6.11947 2.05545 5.31641 1.06767 4.87708L0.308047 4.53922C-0.102682 4.35653 -0.102682 3.75881 0.308047 3.57612L1.0252 3.25714C2.03838 2.80651 2.84417 1.97373 3.27612 0.930828L3.52932 0.319534C3.70578 -0.106511 4.29417 -0.106511 4.47063 0.319534L4.72382 0.930828C5.15577 1.97373 5.96158 2.80651 6.9748 3.25714L7.69188 3.57612C8.10271 3.75881 8.10271 4.35653 7.69188 4.53922L6.93228 4.87708C5.94451 5.31641 5.15288 6.11947 4.7134 7.12811ZM3.06361 21.6132C4.08854 15.422 6.31105 1.99658 21 1.99658C19.5042 4.99658 18.5 6.49658 17.5 7.49658L16.5 8.49658L18 9.49658C17 12.4966 14 15.9966 10 16.4966C7.33146 16.8301 5.66421 18.6635 4.99824 21.9966H3C3.02074 21.8722 3.0419 21.7443 3.06361 21.6132Z"
  }));
},
    iO = function iO(_ref2967) {
  var _ref2967$color = _ref2967.color,
      C = _ref2967$color === void 0 ? "currentColor" : _ref2967$color,
      _ref2967$size = _ref2967.size,
      e = _ref2967$size === void 0 ? 24 : _ref2967$size,
      l = _ref2967.className,
      i = _objectWithoutProperties(_ref2967, _excluded2967);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4.7134 7.12811L4.46682 7.69379C4.28637 8.10792 3.71357 8.10792 3.53312 7.69379L3.28656 7.12811C2.84706 6.11947 2.05545 5.31641 1.06767 4.87708L0.308047 4.53922C-0.102682 4.35653 -0.102682 3.75881 0.308047 3.57612L1.0252 3.25714C2.03838 2.80651 2.84417 1.97373 3.27612 0.930828L3.52932 0.319534C3.70578 -0.106511 4.29417 -0.106511 4.47063 0.319534L4.72382 0.930828C5.15577 1.97373 5.96158 2.80651 6.9748 3.25714L7.69188 3.57612C8.10271 3.75881 8.10271 4.35653 7.69188 4.53922L6.93228 4.87708C5.94451 5.31641 5.15288 6.11947 4.7134 7.12811ZM6.33421 15.8154C6.51032 15.233 6.7072 14.6562 6.93912 14.0327C8.99484 8.50636 12.4197 5.08172 18.0129 4.21479C17.5 5.35838 17.0151 6.15301 16.5858 6.58237C16.2521 6.91603 15.9185 7.24993 15.5848 7.58407L14.1721 8.99878L15.6279 10.4535C14.4976 12.5384 12.2652 14.1979 9.75193 14.512C8.43544 14.6766 7.29345 15.1188 6.33421 15.8154ZM18 9.99658L17 8.99728C17.3331 8.66372 17.6662 8.33039 18.0027 7.99391C19.0018 6.99303 20.0009 4.99392 21 1.99658C6.31105 1.99658 4.08854 15.422 3.06361 21.6132C3.0419 21.7443 3.02074 21.8722 3 21.9966H4.99824C5.66421 18.6635 7.33146 16.8301 10 16.4966C14 15.9966 17 12.9966 18 9.99658Z"
  }));
},
    sO = function sO(_ref2968) {
  var _ref2968$color = _ref2968.color,
      C = _ref2968$color === void 0 ? "currentColor" : _ref2968$color,
      _ref2968$size = _ref2968.size,
      e = _ref2968$size === void 0 ? 24 : _ref2968$size,
      l = _ref2968.className,
      i = _objectWithoutProperties(_ref2968, _excluded2968);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.7134 7.12811L20.4668 7.69379C20.2864 8.10792 19.7136 8.10792 19.5331 7.69379L19.2866 7.12811C18.8471 6.11947 18.0555 5.31641 17.0677 4.87708L16.308 4.53922C15.8973 4.35653 15.8973 3.75881 16.308 3.57612L17.0252 3.25714C18.0384 2.80651 18.8442 1.97373 19.2761 0.930828L19.5293 0.319534C19.7058 -0.106511 20.2942 -0.106511 20.4706 0.319534L20.7238 0.930828C21.1558 1.97373 21.9616 2.80651 22.9748 3.25714L23.6919 3.57612C24.1027 3.75881 24.1027 4.35653 23.6919 4.53922L22.9323 4.87708C21.9445 5.31641 21.1529 6.11947 20.7134 7.12811ZM9 2C13.0675 2 16.426 5.03562 16.9337 8.96494L19.1842 12.5037C19.3324 12.7367 19.3025 13.0847 18.9593 13.2317L17 14.071V17C17 18.1046 16.1046 19 15 19H13.001L13 22H4L4.00025 18.3061C4.00033 17.1252 3.56351 16.0087 2.7555 15.0011C1.65707 13.6313 1 11.8924 1 10C1 5.58172 4.58172 2 9 2ZM21.1535 18.1024L19.4893 16.9929C20.4436 15.5642 21 13.8471 21 12.0001C21 11.489 20.9574 10.9878 20.8756 10.5L22.8186 10C22.9378 10.6486 23 11.317 23 12.0001C23 14.2576 22.32 16.3562 21.1535 18.1024Z"
  }));
},
    rO = function rO(_ref2969) {
  var _ref2969$color = _ref2969.color,
      C = _ref2969$color === void 0 ? "currentColor" : _ref2969$color,
      _ref2969$size = _ref2969.size,
      e = _ref2969$size === void 0 ? 24 : _ref2969$size,
      l = _ref2969.className,
      i = _objectWithoutProperties(_ref2969, _excluded2969);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.7134 7.12811L20.4668 7.69379C20.2864 8.10792 19.7136 8.10792 19.5331 7.69379L19.2866 7.12811C18.8471 6.11947 18.0555 5.31641 17.0677 4.87708L16.308 4.53922C15.8973 4.35653 15.8973 3.75881 16.308 3.57612L17.0252 3.25714C18.0384 2.80651 18.8442 1.97373 19.2761 0.930828L19.5293 0.319534C19.7058 -0.106511 20.2942 -0.106511 20.4706 0.319534L20.7238 0.930828C21.1558 1.97373 21.9616 2.80651 22.9748 3.25714L23.6919 3.57612C24.1027 3.75881 24.1027 4.35653 23.6919 4.53922L22.9323 4.87708C21.9445 5.31641 21.1529 6.11947 20.7134 7.12811ZM9 2C13.0675 2 16.426 5.03562 16.9337 8.96494L19.1842 12.5037C19.3324 12.7367 19.3025 13.0847 18.9593 13.2317L17 14.071V17C17 18.1046 16.1046 19 15 19H13.001L13 22H4L4.00025 18.3061C4.00033 17.1252 3.56351 16.0087 2.7555 15.0011C1.65707 13.6313 1 11.8924 1 10C1 5.58172 4.58172 2 9 2ZM9 4C5.68629 4 3 6.68629 3 10C3 11.3849 3.46818 12.6929 4.31578 13.7499C5.40965 15.114 6.00036 16.6672 6.00025 18.3063L6.00013 20H11.0007L11.0017 17H15V12.7519L16.5497 12.0881L15.0072 9.66262L14.9501 9.22118C14.5665 6.25141 12.0243 4 9 4ZM19.4893 16.9929L21.1535 18.1024C22.32 16.3562 23 14.2576 23 12.0001C23 11.317 22.9378 10.6486 22.8186 10L20.8756 10.5C20.9574 10.9878 21 11.489 21 12.0001C21 13.8471 20.4436 15.5642 19.4893 16.9929Z"
  }));
},
    cO = function cO(_ref2970) {
  var _ref2970$color = _ref2970.color,
      C = _ref2970$color === void 0 ? "currentColor" : _ref2970$color,
      _ref2970$size = _ref2970.size,
      e = _ref2970$size === void 0 ? 24 : _ref2970$size,
      l = _ref2970.className,
      i = _objectWithoutProperties(_ref2970, _excluded2970);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M23.4132 8.7918L18.0211 13.7783L9.70961 5.46678L12.0006 0.5L15.3862 7.84006L23.4132 8.7918ZM18.6224 20.0361L21.193 22.6067L22.6072 21.1925L2.80818 1.39348L1.39397 2.80769L6.65832 8.07205L0.587891 8.7918L6.52248 14.2799L4.94715 22.2082L12.0006 18.26L19.054 22.2082L18.6224 20.0361Z"
  }));
},
    oO = function oO(_ref2971) {
  var _ref2971$color = _ref2971.color,
      C = _ref2971$color === void 0 ? "currentColor" : _ref2971$color,
      _ref2971$size = _ref2971.size,
      e = _ref2971$size === void 0 ? 24 : _ref2971$size,
      l = _ref2971.className,
      i = _objectWithoutProperties(_ref2971, _excluded2971);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M23.4132 8.7918L18.0211 13.7783L16.6058 12.363L18.8719 10.2674L14.039 9.69434L12.0006 5.27502L11.2169 6.97405L9.70961 5.46678L12.0006 0.5L15.3862 7.84006L23.4132 8.7918ZM8.45885 9.87258L5.12921 10.2674L8.70231 13.5717L7.75383 18.3451L12.0006 15.968L16.2473 18.3451L16.0777 17.4914L8.45885 9.87258ZM18.6224 20.0361L19.054 22.2082L12.0006 18.26L4.94715 22.2082L6.52248 14.2799L0.587891 8.7918L6.65832 8.07205L1.39397 2.80769L2.80818 1.39348L22.6072 21.1925L21.193 22.6067L18.6224 20.0361Z"
  }));
},
    aO = function aO(_ref2972) {
  var _ref2972$color = _ref2972.color,
      C = _ref2972$color === void 0 ? "currentColor" : _ref2972$color,
      _ref2972$size = _ref2972.size,
      e = _ref2972$size === void 0 ? 24 : _ref2972$size,
      l = _ref2972.className,
      i = _objectWithoutProperties(_ref2972, _excluded2972);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19.7134 8.12811L19.4668 8.69379C19.2864 9.10792 18.7136 9.10792 18.5331 8.69379L18.2866 8.12811C17.8471 7.11947 17.0555 6.31641 16.0677 5.87708L15.308 5.53922C14.8973 5.35653 14.8973 4.75881 15.308 4.57612L16.0252 4.25714C17.0384 3.80651 17.8442 2.97373 18.2761 1.93083L18.5293 1.31953C18.7058 0.893489 19.2942 0.893489 19.4706 1.31953L19.7238 1.93083C20.1558 2.97373 20.9616 3.80651 21.9748 4.25714L22.6919 4.57612C23.1027 4.75881 23.1027 5.35653 22.6919 5.53922L21.9323 5.87708C20.9445 6.31641 20.1529 7.11947 19.7134 8.12811ZM22.9 21L18.5 10H16.5L12.101 21H14.255L15.454 18H19.544L20.745 21H22.9ZM16.253 16L17.5 12.8852L18.745 16H16.253ZM7.5466 12.3036C6.41407 11.0171 5.45992 9.56967 4.72266 8H6.96329C7.53108 9.04434 8.21011 10.0196 8.98442 10.9097C10.2737 9.48824 11.3027 7.82653 11.9961 6H2V4H8V2H10V4H14.6497C14.5624 4.42994 14.4594 4.85421 14.3412 5.27216C13.5862 7.94155 12.2142 10.3512 10.389 12.3375C11.1089 12.9848 11.8869 13.5688 12.7142 14.0805L11.9615 15.9627C10.8814 15.3228 9.87297 14.5749 8.95119 13.7336C7.17781 15.2694 5.09248 16.4547 2.8027 17.1819L2.1973 15.2757C4.18364 14.6449 5.99672 13.6242 7.5466 12.3036Z"
  }));
},
    nO = function nO(_ref2973) {
  var _ref2973$color = _ref2973.color,
      C = _ref2973$color === void 0 ? "currentColor" : _ref2973$color,
      _ref2973$size = _ref2973.size,
      e = _ref2973$size === void 0 ? 24 : _ref2973$size,
      l = _ref2973.className,
      i = _objectWithoutProperties(_ref2973, _excluded2973);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19.7134 8.12811L19.4668 8.69379C19.2864 9.10792 18.7136 9.10792 18.5331 8.69379L18.2866 8.12811C17.8471 7.11947 17.0555 6.31641 16.0677 5.87708L15.308 5.53922C14.8973 5.35653 14.8973 4.75881 15.308 4.57612L16.0252 4.25714C17.0384 3.80651 17.8442 2.97373 18.2761 1.93083L18.5293 1.31953C18.7058 0.893489 19.2942 0.893489 19.4706 1.31953L19.7238 1.93083C20.1558 2.97373 20.9616 3.80651 21.9748 4.25714L22.6919 4.57612C23.1027 4.75881 23.1027 5.35653 22.6919 5.53922L21.9323 5.87708C20.9445 6.31641 20.1529 7.11947 19.7134 8.12811ZM5 17V15H3V17C3 19.2091 4.79086 21 7 21H10V19H7L6.85074 18.9945C5.81588 18.9182 5 18.0544 5 17ZM22.4 21L18 10H16L11.601 21H13.755L14.954 18H19.044L20.245 21H22.4ZM15.753 16L17 12.8852L18.245 16H15.753ZM8 4V2H6V4H2V11H6V14H8V11H12V4H8ZM4 6H6V9H4V6ZM8 6H10V9H8V6Z"
  }));
},
    mO = function mO(_ref2974) {
  var _ref2974$color = _ref2974.color,
      C = _ref2974$color === void 0 ? "currentColor" : _ref2974$color,
      _ref2974$size = _ref2974.size,
      e = _ref2974$size === void 0 ? 24 : _ref2974$size,
      l = _ref2974.className,
      i = _objectWithoutProperties(_ref2974, _excluded2974);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5.23379 7.72989C6.65303 5.48625 9.15342 4 12.0002 4C14.847 4 17.3474 5.48625 18.7667 7.72989L20.4569 6.66071C18.6865 3.86199 15.5612 2 12.0002 2C8.43928 2 5.31393 3.86199 3.54356 6.66071L5.23379 7.72989ZM12.0002 20C9.15342 20 6.65303 18.5138 5.23379 16.2701L3.54356 17.3393C5.31393 20.138 8.43928 22 12.0002 22C15.5612 22 18.6865 20.138 20.4569 17.3393L18.7667 16.2701C17.3474 18.5138 14.847 20 12.0002 20ZM12 12C13.6569 12 15 10.6569 15 9C15 7.34315 13.6569 6 12 6C10.3431 6 9 7.34315 9 9C9 10.6569 10.3431 12 12 12ZM12 13C14.2091 13 16 14.7909 16 17H8C8 14.7909 9.79086 13 12 13ZM6 12C6 13.6569 4.65685 15 3 15C1.34315 15 0 13.6569 0 12C0 10.3431 1.34315 9 3 9C4.65685 9 6 10.3431 6 12ZM21 15C22.6569 15 24 13.6569 24 12C24 10.3431 22.6569 9 21 9C19.3431 9 18 10.3431 18 12C18 13.6569 19.3431 15 21 15Z"
  }));
},
    wO = function wO(_ref2975) {
  var _ref2975$color = _ref2975.color,
      C = _ref2975$color === void 0 ? "currentColor" : _ref2975$color,
      _ref2975$size = _ref2975.size,
      e = _ref2975$size === void 0 ? 24 : _ref2975$size,
      l = _ref2975.className,
      i = _objectWithoutProperties(_ref2975, _excluded2975);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5.23379 7.72989C6.65303 5.48625 9.15342 4 12.0002 4C14.847 4 17.3474 5.48625 18.7667 7.72989L20.4569 6.66071C18.6865 3.86199 15.5612 2 12.0002 2C8.43928 2 5.31393 3.86199 3.54356 6.66071L5.23379 7.72989ZM12.0002 20C9.15342 20 6.65303 18.5138 5.23379 16.2701L3.54356 17.3393C5.31393 20.138 8.43928 22 12.0002 22C15.5612 22 18.6865 20.138 20.4569 17.3393L18.7667 16.2701C17.3474 18.5138 14.847 20 12.0002 20ZM12 8C12.5523 8 13 8.44772 13 9C13 9.55228 12.5523 10 12 10C11.4477 10 11 9.55228 11 9C11 8.44772 11.4477 8 12 8ZM12 12C13.6569 12 15 10.6569 15 9C15 7.34315 13.6569 6 12 6C10.3431 6 9 7.34315 9 9C9 10.6569 10.3431 12 12 12ZM12 15C10.8954 15 10 15.8954 10 17H8C8 14.7909 9.79086 13 12 13C14.2091 13 16 14.7909 16 17H14C14 15.8954 13.1046 15 12 15ZM3 11C2.44772 11 2 11.4477 2 12C2 12.5523 2.44772 13 3 13C3.55228 13 4 12.5523 4 12C4 11.4477 3.55228 11 3 11ZM0 12C0 10.3431 1.34315 9 3 9C4.65685 9 6 10.3431 6 12C6 13.6569 4.65685 15 3 15C1.34315 15 0 13.6569 0 12ZM20 12C20 11.4477 20.4477 11 21 11C21.5523 11 22 11.4477 22 12C22 12.5523 21.5523 13 21 13C20.4477 13 20 12.5523 20 12ZM21 9C19.3431 9 18 10.3431 18 12C18 13.6569 19.3431 15 21 15C22.6569 15 24 13.6569 24 12C24 10.3431 22.6569 9 21 9Z"
  }));
},
    LO = function LO(_ref2976) {
  var _ref2976$color = _ref2976.color,
      C = _ref2976$color === void 0 ? "currentColor" : _ref2976$color,
      _ref2976$size = _ref2976.size,
      e = _ref2976$size === void 0 ? 24 : _ref2976$size,
      l = _ref2976.className,
      i = _objectWithoutProperties(_ref2976, _excluded2976);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M23 21.6479H1L12 2.35205L23 21.6479Z"
  }));
},
    hO = function hO(_ref2977) {
  var _ref2977$color = _ref2977.color,
      C = _ref2977$color === void 0 ? "currentColor" : _ref2977$color,
      _ref2977$size = _ref2977.size,
      e = _ref2977$size === void 0 ? 24 : _ref2977$size,
      l = _ref2977.className,
      i = _objectWithoutProperties(_ref2977, _excluded2977);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M23 21.6479L12 2.35205L1 21.6479H23ZM19.5577 19.6479H4.4423L12 6.39042L19.5577 19.6479Z"
  }));
},
    HO = function HO(_ref2978) {
  var _ref2978$color = _ref2978.color,
      C = _ref2978$color === void 0 ? "currentColor" : _ref2978$color,
      _ref2978$size = _ref2978.size,
      e = _ref2978$size === void 0 ? 24 : _ref2978$size,
      l = _ref2978.className,
      i = _objectWithoutProperties(_ref2978, _excluded2978);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19.7134 8.12811L19.4668 8.69379C19.2864 9.10792 18.7136 9.10792 18.5331 8.69379L18.2866 8.12811C17.8471 7.11947 17.0555 6.31641 16.0677 5.87708L15.308 5.53922C14.8973 5.35653 14.8973 4.75881 15.308 4.57612L16.0252 4.25714C17.0384 3.80651 17.8442 2.97373 18.2761 1.93083L18.5293 1.31953C18.7058 0.893489 19.2942 0.893489 19.4706 1.31953L19.7238 1.93083C20.1558 2.97373 20.9616 3.80651 21.9748 4.25714L22.6919 4.57612C23.1027 4.75881 23.1027 5.35653 22.6919 5.53922L21.9323 5.87708C20.9445 6.31641 20.1529 7.11947 19.7134 8.12811ZM19 11C19.7013 11 20.3744 10.8797 21 10.6586V20.0066C21 20.5552 20.5551 21 20.0066 21H3.9934C3.44476 21 3 20.5551 3 20.0066V3.9934C3 3.44476 3.44495 3 3.9934 3H13.3414C13.1203 3.62556 13 4.29873 13 5C13 8.31371 15.6863 11 19 11ZM10.6219 8.41459C10.5562 8.37078 10.479 8.34741 10.4 8.34741C10.1791 8.34741 10 8.52649 10 8.74741V15.2526C10 15.3316 10.0234 15.4088 10.0672 15.4745C10.1897 15.6583 10.4381 15.708 10.6219 15.5854L15.5008 12.3328C15.5447 12.3035 15.5824 12.2658 15.6117 12.2219C15.7343 12.0381 15.6846 11.7897 15.5008 11.6672L10.6219 8.41459Z"
  }));
},
    VO = function VO(_ref2979) {
  var _ref2979$color = _ref2979.color,
      C = _ref2979$color === void 0 ? "currentColor" : _ref2979$color,
      _ref2979$size = _ref2979.size,
      e = _ref2979$size === void 0 ? 24 : _ref2979$size,
      l = _ref2979.className,
      i = _objectWithoutProperties(_ref2979, _excluded2979);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19.7134 8.12811L19.4668 8.69379C19.2864 9.10792 18.7136 9.10792 18.5331 8.69379L18.2866 8.12811C17.8471 7.11947 17.0555 6.31641 16.0677 5.87708L15.308 5.53922C14.8973 5.35653 14.8973 4.75881 15.308 4.57612L16.0252 4.25714C17.0384 3.80651 17.8442 2.97373 18.2761 1.93083L18.5293 1.31953C18.7058 0.893489 19.2942 0.893489 19.4706 1.31953L19.7238 1.93083C20.1558 2.97373 20.9616 3.80651 21.9748 4.25714L22.6919 4.57612C23.1027 4.75881 23.1027 5.35653 22.6919 5.53922L21.9323 5.87708C20.9445 6.31641 20.1529 7.11947 19.7134 8.12811ZM3.9934 3H13V5H5V19H19V11H21V20.0066C21 20.5552 20.5551 21 20.0066 21H3.9934C3.44476 21 3 20.5551 3 20.0066V3.9934C3 3.44476 3.44495 3 3.9934 3ZM10.6219 8.41459L15.5008 11.6672C15.6846 11.7897 15.7343 12.0381 15.6117 12.2219C15.5824 12.2658 15.5447 12.3035 15.5008 12.3328L10.6219 15.5854C10.4381 15.708 10.1897 15.6583 10.0672 15.4745C10.0234 15.4088 10 15.3316 10 15.2526V8.74741C10 8.52649 10.1791 8.34741 10.4 8.34741C10.479 8.34741 10.5562 8.37078 10.6219 8.41459Z"
  }));
},
    gO = function gO(_ref2980) {
  var _ref2980$color = _ref2980.color,
      C = _ref2980$color === void 0 ? "currentColor" : _ref2980$color,
      _ref2980$size = _ref2980.size,
      e = _ref2980$size === void 0 ? 24 : _ref2980$size,
      l = _ref2980.className,
      i = _objectWithoutProperties(_ref2980, _excluded2980);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4.7134 9.12811L4.46682 9.69379C4.28637 10.1079 3.71357 10.1079 3.53312 9.69379L3.28656 9.12811C2.84706 8.11947 2.05545 7.31641 1.06767 6.87708L0.308047 6.53922C-0.102682 6.35653 -0.102682 5.75881 0.308047 5.57612L1.0252 5.25714C2.03838 4.80651 2.84417 3.97373 3.27612 2.93083L3.52932 2.31953C3.70578 1.89349 4.29417 1.89349 4.47063 2.31953L4.72382 2.93083C5.15577 3.97373 5.96158 4.80651 6.9748 5.25714L7.69188 5.57612C8.10271 5.75881 8.10271 6.35653 7.69188 6.53922L6.93228 6.87708C5.94451 7.31641 5.15288 8.11947 4.7134 9.12811ZM10 6C10 9.31371 7.31371 12 4 12C2.90714 12 1.88252 11.7078 1 11.1973V19C1 19.5523 1.44772 20 2 20H16C16.5523 20 17 19.5523 17 19V14.8L22.2133 18.4493C22.2973 18.5081 22.3974 18.5397 22.5 18.5397C22.7761 18.5397 23 18.3158 23 18.0397V5.96033C23 5.85774 22.9684 5.75764 22.9096 5.6736C22.7513 5.44737 22.4395 5.39235 22.2133 5.55071L17 9.2V5C17 4.44772 16.5523 4 16 4H9.65859C9.87969 4.62556 10 5.29873 10 6Z"
  }));
},
    MO = function MO(_ref2981) {
  var _ref2981$color = _ref2981.color,
      C = _ref2981$color === void 0 ? "currentColor" : _ref2981$color,
      _ref2981$size = _ref2981.size,
      e = _ref2981$size === void 0 ? 24 : _ref2981$size,
      l = _ref2981.className,
      i = _objectWithoutProperties(_ref2981, _excluded2981);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4.7134 9.12811L4.46682 9.69379C4.28637 10.1079 3.71357 10.1079 3.53312 9.69379L3.28656 9.12811C2.84706 8.11947 2.05545 7.31641 1.06767 6.87708L0.308047 6.53922C-0.102682 6.35653 -0.102682 5.75881 0.308047 5.57612L1.0252 5.25714C2.03838 4.80651 2.84417 3.97373 3.27612 2.93083L3.52932 2.31953C3.70578 1.89349 4.29417 1.89349 4.47063 2.31953L4.72382 2.93083C5.15577 3.97373 5.96158 4.80651 6.9748 5.25714L7.69188 5.57612C8.10271 5.75881 8.10271 6.35653 7.69188 6.53922L6.93228 6.87708C5.94451 7.31641 5.15288 8.11947 4.7134 9.12811ZM1 19V12H3V18H15V6H10V4H16C16.5523 4 17 4.44772 17 5V9.2L22.2133 5.55071C22.4395 5.39235 22.7513 5.44737 22.9096 5.6736C22.9684 5.75764 23 5.85774 23 5.96033V18.0397C23 18.3158 22.7761 18.5397 22.5 18.5397C22.3974 18.5397 22.2973 18.5081 22.2133 18.4493L17 14.8V19C17 19.5523 16.5523 20 16 20H2C1.44772 20 1 19.5523 1 19ZM17 12.3587L21 15.1587V8.84131L17 11.6413V12.3587Z"
  }));
},
    ZO = function ZO(_ref2982) {
  var _ref2982$color = _ref2982.color,
      C = _ref2982$color === void 0 ? "currentColor" : _ref2982$color,
      _ref2982$size = _ref2982.size,
      e = _ref2982$size === void 0 ? 24 : _ref2982$size,
      l = _ref2982.className,
      i = _objectWithoutProperties(_ref2982, _excluded2982);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.7134 7.12811L20.4668 7.69379C20.2864 8.10792 19.7136 8.10792 19.5331 7.69379L19.2866 7.12811C18.8471 6.11947 18.0555 5.31641 17.0677 4.87708L16.308 4.53922C15.8973 4.35653 15.8973 3.75881 16.308 3.57612L17.0252 3.25714C18.0384 2.80651 18.8442 1.97373 19.2761 0.930828L19.5293 0.319534C19.7058 -0.106511 20.2942 -0.106511 20.4706 0.319534L20.7238 0.930828C21.1558 1.97373 21.9616 2.80651 22.9748 3.25714L23.6919 3.57612C24.1027 3.75881 24.1027 4.35653 23.6919 4.53922L22.9323 4.87708C21.9445 5.31641 21.1529 6.11947 20.7134 7.12811ZM8.5 6H6.5V18H8.5V6ZM4 10H2V14H4V10ZM13 2H11V22H13V2ZM17.5 8H15.5V18H17.5V8ZM22 10H20V14H22V10Z"
  }));
},
    xO = function xO(_ref2983) {
  var _ref2983$color = _ref2983.color,
      C = _ref2983$color === void 0 ? "currentColor" : _ref2983$color,
      _ref2983$size = _ref2983.size,
      e = _ref2983$size === void 0 ? 24 : _ref2983$size,
      l = _ref2983.className,
      i = _objectWithoutProperties(_ref2983, _excluded2983);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.7134 7.12811L20.4668 7.69379C20.2864 8.10792 19.7136 8.10792 19.5331 7.69379L19.2866 7.12811C18.8471 6.11947 18.0555 5.31641 17.0677 4.87708L16.308 4.53922C15.8973 4.35653 15.8973 3.75881 16.308 3.57612L17.0252 3.25714C18.0384 2.80651 18.8442 1.97373 19.2761 0.930828L19.5293 0.319534C19.7058 -0.106511 20.2942 -0.106511 20.4706 0.319534L20.7238 0.930828C21.1558 1.97373 21.9616 2.80651 22.9748 3.25714L23.6919 3.57612C24.1027 3.75881 24.1027 4.35653 23.6919 4.53922L22.9323 4.87708C21.9445 5.31641 21.1529 6.11947 20.7134 7.12811ZM8.5 6H6.5V18H8.5V6ZM4 10H2V14H4V10ZM13 2H11V22H13V2ZM17.5 8H15.5V18H17.5V8ZM22 10H20V14H22V10Z"
  }));
},
    vO = function vO(_ref2984) {
  var _ref2984$color = _ref2984.color,
      C = _ref2984$color === void 0 ? "currentColor" : _ref2984$color,
      _ref2984$size = _ref2984.size,
      e = _ref2984$size === void 0 ? 24 : _ref2984$size,
      l = _ref2984.className,
      i = _objectWithoutProperties(_ref2984, _excluded2984);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.4668 8.69379L20.7134 8.12811C21.1529 7.11947 21.9445 6.31641 22.9323 5.87708L23.6919 5.53922C24.1027 5.35653 24.1027 4.75881 23.6919 4.57612L22.9748 4.25714C21.9616 3.80651 21.1558 2.97373 20.7238 1.93083L20.4706 1.31953C20.2942 0.893489 19.7058 0.893489 19.5293 1.31953L19.2761 1.93083C18.8442 2.97373 18.0384 3.80651 17.0252 4.25714L16.308 4.57612C15.8973 4.75881 15.8973 5.35653 16.308 5.53922L17.0677 5.87708C18.0555 6.31641 18.8471 7.11947 19.2866 8.12811L19.5331 8.69379C19.7136 9.10792 20.2864 9.10792 20.4668 8.69379ZM5.79993 16H7.95399L8.55399 14.5H11.4459L12.0459 16H14.1999L10.9999 8H8.99993L5.79993 16ZM9.99993 10.8852L10.6459 12.5H9.35399L9.99993 10.8852ZM15 16V8H17V16H15ZM3 3C2.44772 3 2 3.44772 2 4V20C2 20.5523 2.44772 21 3 21H21C21.5523 21 22 20.5523 22 20V11H20V19H4V5H14V3H3Z"
  }));
},
    dO = function dO(_ref2985) {
  var _ref2985$color = _ref2985.color,
      C = _ref2985$color === void 0 ? "currentColor" : _ref2985$color,
      _ref2985$size = _ref2985.size,
      e = _ref2985$size === void 0 ? 24 : _ref2985$size,
      l = _ref2985.className,
      i = _objectWithoutProperties(_ref2985, _excluded2985);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.4668 8.69379L20.7134 8.12811C21.1529 7.11947 21.9445 6.31641 22.9323 5.87708L23.6919 5.53922C24.1027 5.35653 24.1027 4.75881 23.6919 4.57612L22.9748 4.25714C21.9616 3.80651 21.1558 2.97373 20.7238 1.93083L20.4706 1.31953C20.2942 0.893489 19.7058 0.893489 19.5293 1.31953L19.2761 1.93083C18.8442 2.97373 18.0384 3.80651 17.0252 4.25714L16.308 4.57612C15.8973 4.75881 15.8973 5.35653 16.308 5.53922L17.0677 5.87708C18.0555 6.31641 18.8471 7.11947 19.2866 8.12811L19.5331 8.69379C19.7136 9.10792 20.2864 9.10792 20.4668 8.69379ZM2 4C2 3.44772 2.44772 3 3 3H14V5H4V19H20V11H22V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4ZM7 8H17V11H15V10H13V14H14.5V16H9.5V14H11V10H9V11H7V8Z"
  }));
},
    pO = function pO(_ref2986) {
  var _ref2986$color = _ref2986.color,
      C = _ref2986$color === void 0 ? "currentColor" : _ref2986$color,
      _ref2986$size = _ref2986.size,
      e = _ref2986$size === void 0 ? 24 : _ref2986$size,
      l = _ref2986.className,
      i = _objectWithoutProperties(_ref2986, _excluded2986);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M16.7645 5H13.4568L19.3799 20H22.6107L16.7645 5ZM7.22604 5L1.37988 20H4.68758L5.99527 16.8462H12.1491L13.3799 19.9231H16.6876L10.6876 5H7.30296H7.22604ZM6.91834 14.0769L8.91834 8.76923L10.9953 14.0769H6.99527H6.91834Z"
  }));
},
    EO = function EO(_ref2987) {
  var _ref2987$color = _ref2987.color,
      C = _ref2987$color === void 0 ? "currentColor" : _ref2987$color,
      _ref2987$size = _ref2987.size,
      e = _ref2987$size === void 0 ? 24 : _ref2987$size,
      l = _ref2987.className,
      i = _objectWithoutProperties(_ref2987, _excluded2987);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14.1219 5H16.2678L22.1012 20H19.9553L14.1219 5ZM7.65986 5H10.3411L16.1103 20H13.9675L12.429 16H5.57192L4.03345 20H1.89062L7.65986 5ZM11.6598 14L9.00047 7.08577L6.34115 14H11.6598Z"
  }));
},
    NO = function NO(_ref2988) {
  var _ref2988$color = _ref2988.color,
      C = _ref2988$color === void 0 ? "currentColor" : _ref2988$color,
      _ref2988$size = _ref2988.size,
      e = _ref2988$size === void 0 ? 24 : _ref2988$size,
      l = _ref2988.className,
      i = _objectWithoutProperties(_ref2988, _excluded2988);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2.5 7C2.5 9.48528 4.51472 11.5 7 11.5C9.48528 11.5 11.5 9.48528 11.5 7C11.5 4.51472 9.48528 2.5 7 2.5C4.51472 2.5 2.5 4.51472 2.5 7ZM2.5 17C2.5 19.4853 4.51472 21.5 7 21.5C9.48528 21.5 11.5 19.4853 11.5 17C11.5 14.5147 9.48528 12.5 7 12.5C4.51472 12.5 2.5 14.5147 2.5 17ZM12.5 17C12.5 19.4853 14.5147 21.5 17 21.5C19.4853 21.5 21.5 19.4853 21.5 17C21.5 14.5147 19.4853 12.5 17 12.5C14.5147 12.5 12.5 14.5147 12.5 17ZM17.5252 11.155L17.8026 10.5186C18.297 9.38398 19.1876 8.48059 20.2988 7.98638L21.1534 7.60631C21.6155 7.4008 21.6155 6.7284 21.1534 6.52289L20.3467 6.16406C19.2068 5.65713 18.3002 4.72031 17.8143 3.54712L17.5295 2.85945C17.3309 2.38018 16.669 2.38018 16.4705 2.85945L16.1856 3.54712C15.6997 4.72031 14.7932 5.65713 13.6534 6.16406L12.8466 6.52289C12.3845 6.7284 12.3845 7.4008 12.8466 7.60631L13.7011 7.98638C14.8124 8.48059 15.7029 9.38398 16.1974 10.5186L16.4748 11.155C16.6778 11.6209 17.3222 11.6209 17.5252 11.155Z"
  }));
},
    uO = function uO(_ref2989) {
  var _ref2989$color = _ref2989.color,
      C = _ref2989$color === void 0 ? "currentColor" : _ref2989$color,
      _ref2989$size = _ref2989.size,
      e = _ref2989$size === void 0 ? 24 : _ref2989$size,
      l = _ref2989.className,
      i = _objectWithoutProperties(_ref2989, _excluded2989);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2.5 7C2.5 9.48528 4.51472 11.5 7 11.5C9.48528 11.5 11.5 9.48528 11.5 7C11.5 4.51472 9.48528 2.5 7 2.5C4.51472 2.5 2.5 4.51472 2.5 7ZM2.5 17C2.5 19.4853 4.51472 21.5 7 21.5C9.48528 21.5 11.5 19.4853 11.5 17C11.5 14.5147 9.48528 12.5 7 12.5C4.51472 12.5 2.5 14.5147 2.5 17ZM12.5 17C12.5 19.4853 14.5147 21.5 17 21.5C19.4853 21.5 21.5 19.4853 21.5 17C21.5 14.5147 19.4853 12.5 17 12.5C14.5147 12.5 12.5 14.5147 12.5 17ZM9.5 7C9.5 8.38071 8.38071 9.5 7 9.5C5.61929 9.5 4.5 8.38071 4.5 7C4.5 5.61929 5.61929 4.5 7 4.5C8.38071 4.5 9.5 5.61929 9.5 7ZM9.5 17C9.5 18.3807 8.38071 19.5 7 19.5C5.61929 19.5 4.5 18.3807 4.5 17C4.5 15.6193 5.61929 14.5 7 14.5C8.38071 14.5 9.5 15.6193 9.5 17ZM19.5 17C19.5 18.3807 18.3807 19.5 17 19.5C15.6193 19.5 14.5 18.3807 14.5 17C14.5 15.6193 15.6193 14.5 17 14.5C18.3807 14.5 19.5 15.6193 19.5 17ZM17.5252 11.155L17.8026 10.5186C18.297 9.38398 19.1876 8.48059 20.2988 7.98638L21.1534 7.60631C21.6155 7.4008 21.6155 6.7284 21.1534 6.52289L20.3467 6.16406C19.2068 5.65713 18.3002 4.72031 17.8143 3.54712L17.5295 2.85945C17.3309 2.38018 16.669 2.38018 16.4705 2.85945L16.1856 3.54712C15.6997 4.72031 14.7932 5.65713 13.6534 6.16406L12.8466 6.52289C12.3845 6.7284 12.3845 7.4008 12.8466 7.60631L13.7011 7.98638C14.8124 8.48059 15.7029 9.38398 16.1974 10.5186L16.4748 11.155C16.6778 11.6209 17.3222 11.6209 17.5252 11.155Z"
  }));
},
    BO = function BO(_ref2990) {
  var _ref2990$color = _ref2990.color,
      C = _ref2990$color === void 0 ? "currentColor" : _ref2990$color,
      _ref2990$size = _ref2990.size,
      e = _ref2990$size === void 0 ? 24 : _ref2990$size,
      l = _ref2990.className,
      i = _objectWithoutProperties(_ref2990, _excluded2990);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.4668 8.69379L20.7134 8.12811C21.1529 7.11947 21.9445 6.31641 22.9323 5.87708L23.6919 5.53922C24.1027 5.35653 24.1027 4.75881 23.6919 4.57612L22.9748 4.25714C21.9616 3.80651 21.1558 2.97373 20.7238 1.93083L20.4706 1.31953C20.2942 0.893489 19.7058 0.893489 19.5293 1.31953L19.2761 1.93083C18.8442 2.97373 18.0384 3.80651 17.0252 4.25714L16.308 4.57612C15.8973 4.75881 15.8973 5.35653 16.308 5.53922L17.0677 5.87708C18.0555 6.31641 18.8471 7.11947 19.2866 8.12811L19.5331 8.69379C19.7136 9.10792 20.2864 9.10792 20.4668 8.69379ZM14.3094 14L9.82726 21.7633C10.5268 21.9183 11.2538 22 12 22C14.1805 22 16.198 21.3021 17.8413 20.1175L14.3094 14ZM2.4578 15C3.31516 17.7297 5.3115 19.955 7.88985 21.119L11.4226 15H2.4578ZM2 12C2 12.3375 2.01672 12.6711 2.04938 13H9.11325L4.6322 5.23859C2.99773 7.0187 2 9.39284 2 12ZM12 2C9.81949 2 7.80198 2.6979 6.15866 3.88251L9.6906 10L14.1727 2.2367C13.4732 2.08172 12.7462 2 12 2ZM22 12C22 11.6625 21.9833 11.3289 21.9506 11H14.8868L19.3678 18.7614C21.0023 16.9813 22 14.6072 22 12Z"
  }));
},
    fO = function fO(_ref2991) {
  var _ref2991$color = _ref2991.color,
      C = _ref2991$color === void 0 ? "currentColor" : _ref2991$color,
      _ref2991$size = _ref2991.size,
      e = _ref2991$size === void 0 ? 24 : _ref2991$size,
      l = _ref2991.className,
      i = _objectWithoutProperties(_ref2991, _excluded2991);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.4668 8.69379L20.7134 8.12811C21.1529 7.11947 21.9445 6.31641 22.9323 5.87708L23.6919 5.53922C24.1027 5.35653 24.1027 4.75881 23.6919 4.57612L22.9748 4.25714C21.9616 3.80651 21.1558 2.97373 20.7238 1.93083L20.4706 1.31953C20.2942 0.89349 19.7058 0.89349 19.5293 1.31953L19.2761 1.93083C18.8442 2.97373 18.0384 3.80651 17.0252 4.25714L16.308 4.57612C15.8973 4.75881 15.8973 5.35653 16.308 5.53922L17.0677 5.87708C18.0555 6.31641 18.8471 7.11947 19.2866 8.12811L19.5331 8.69379C19.7136 9.10792 20.2864 9.10792 20.4668 8.69379ZM12 22C17.5228 22 22 17.5228 22 12C22 11.5972 21.9762 11.2 21.9299 10.8097L19.9437 11.0454C19.9809 11.3584 20 11.677 20 12C20 13.4577 19.6101 14.8243 18.929 16.0013L15.4641 10H17.9295L16.7755 8H12.0003L15.1686 2.51246C14.1729 2.1801 13.1074 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12.0003 4L8.53606 10.0003L6.39495 6.29181C7.83839 4.87429 9.81744 4 12.0003 4ZM9.69076 12.0003L10.8456 10H13.1547L14.3095 12.0001L13.1548 14H10.8453L9.69076 12.0003ZM12.0001 16L9.85814 19.7101C7.81886 19.1448 6.10694 17.7921 5.07026 16H12.0001ZM12.0001 20L15.4642 14.0001L17.605 17.7082C16.1616 19.1257 14.183 20 12.0001 20ZM5.07102 7.99869L8.53588 14H4.25204C4.08751 13.3608 4 12.6906 4 12C4 10.5423 4.38987 9.17568 5.07102 7.99869Z"
  }));
},
    RO = function RO(_ref2992) {
  var _ref2992$color = _ref2992.color,
      C = _ref2992$color === void 0 ? "currentColor" : _ref2992$color,
      _ref2992$size = _ref2992.size,
      e = _ref2992$size === void 0 ? 24 : _ref2992$size,
      l = _ref2992.className,
      i = _objectWithoutProperties(_ref2992, _excluded2992);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.4668 8.69379L20.7134 8.12811C21.1529 7.11947 21.9445 6.31641 22.9323 5.87708L23.6919 5.53922C24.1027 5.35653 24.1027 4.75881 23.6919 4.57612L22.9748 4.25714C21.9616 3.80651 21.1558 2.97373 20.7238 1.93083L20.4706 1.31953C20.2942 0.893489 19.7058 0.893489 19.5293 1.31953L19.2761 1.93083C18.8442 2.97373 18.0384 3.80651 17.0252 4.25714L16.308 4.57612C15.8973 4.75881 15.8973 5.35653 16.308 5.53922L17.0677 5.87708C18.0555 6.31641 18.8471 7.11947 19.2866 8.12811L19.5331 8.69379C19.7136 9.10792 20.2864 9.10792 20.4668 8.69379ZM20 11C20.7013 11 21.3744 10.8797 22 10.6586V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5551 2 20.0066V3.9934C2 3.44476 2.45531 3 2.9918 3H5.99807L3.68867 7H5.99807L8.30747 3H11.9981L9.68867 7H11.9981L14.3075 3H14.3414C14.1203 3.62556 14 4.29873 14 5C14 8.31371 16.6863 11 20 11Z"
  }));
},
    zO = function zO(_ref2993) {
  var _ref2993$color = _ref2993.color,
      C = _ref2993$color === void 0 ? "currentColor" : _ref2993$color,
      _ref2993$size = _ref2993.size,
      e = _ref2993$size === void 0 ? 24 : _ref2993$size,
      l = _ref2993.className,
      i = _objectWithoutProperties(_ref2993, _excluded2993);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.4668 8.69379L20.7134 8.12811C21.1529 7.11947 21.9445 6.31641 22.9323 5.87708L23.6919 5.53922C24.1027 5.35653 24.1027 4.75881 23.6919 4.57612L22.9748 4.25714C21.9616 3.80651 21.1558 2.97373 20.7238 1.93083L20.4706 1.31953C20.2942 0.893489 19.7058 0.893489 19.5293 1.31953L19.2761 1.93083C18.8442 2.97373 18.0384 3.80651 17.0252 4.25714L16.308 4.57612C15.8973 4.75881 15.8973 5.35653 16.308 5.53922L17.0677 5.87708C18.0555 6.31641 18.8471 7.11947 19.2866 8.12811L19.5331 8.69379C19.7136 9.10792 20.2864 9.10792 20.4668 8.69379ZM14.3075 3H14.3414C14.1203 3.62556 14 4.29873 14 5C14 5.70127 14.1203 6.37444 14.3414 7H11.9981L14.3075 3ZM20 11V19H4V6.46076L5.99807 3H2.9918C2.45531 3 2 3.44476 2 3.9934V20.0066C2 20.5551 2.44405 21 2.9918 21H21.0082C21.5447 21 22 20.5552 22 20.0066V11H20ZM8.30747 3L5.99807 7H9.68867L11.9981 3H8.30747Z"
  }));
},
    FO = function FO(_ref2994) {
  var _ref2994$color = _ref2994.color,
      C = _ref2994$color === void 0 ? "currentColor" : _ref2994$color,
      _ref2994$size = _ref2994.size,
      e = _ref2994$size === void 0 ? 24 : _ref2994$size,
      l = _ref2994.className,
      i = _objectWithoutProperties(_ref2994, _excluded2994);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5.92 15.3L9.86 13.1L9.92 12.9L9.86 12.8H9.66L9 12.76L6.76 12.7L4.8 12.6L2.9 12.5L2.42 12.4L2 11.8L2.04 11.5L2.44 11.24L3.02 11.28L4.28 11.38L6.18 11.5L7.56 11.58L9.6 11.82H9.92L9.96 11.68L9.86 11.6L9.78 11.52L7.8 10.2L5.68 8.8L4.56 7.98L3.96 7.58L3.66 7.18L3.54 6.34L4.08 5.74L4.82 5.8L5 5.84L5.74 6.42L7.34 7.64L9.4 9.2L9.7 9.44L9.82 9.36L9.84 9.3L9.7 9.08L8.6 7L7.4 4.92L6.86 4.06L6.72 3.54C6.66 3.34 6.64 3.14 6.64 2.94L7.24 2.1L7.6 2L8.44 2.12L8.76 2.4L9.28 3.6L10.1 5.46L11.4 7.98L11.8 8.74L12 9.42L12.06 9.62H12.2V9.52L12.3 8.08L12.5 6.34L12.7 4.1L12.76 3.46L13.08 2.7L13.68 2.3L14.2 2.52L14.6 3.1L14.54 3.46L14.32 5L13.8 7.42L13.5 9.06H13.68L13.88 8.84L14.7 7.76L16.08 6.04L16.68 5.34L17.4 4.6L17.86 4.24H18.72L19.34 5.18L19.06 6.16L18.18 7.28L17.44 8.22L16.38 9.64L15.74 10.78L15.8 10.86H15.94L18.34 10.34L19.62 10.12L21.14 9.86L21.84 10.18L21.92 10.5L21.64 11.18L20 11.58L18.08 11.98L15.22 12.64L15.18 12.66L15.22 12.72L16.5 12.84L17.06 12.88H18.42L20.94 13.08L21.6 13.48L21.98 14.02L21.92 14.42L20.9 14.94L19.54 14.62L16.34 13.86L15.26 13.6H15.1V13.68L16.02 14.58L17.68 16.08L19.8 18.02L19.9 18.5L19.64 18.9L19.36 18.86L17.52 17.46L16.8 16.86L15.2 15.5H15.1V15.64L15.46 16.18L17.42 19.12L17.52 20.02L17.38 20.3L16.86 20.5L16.32 20.38L15.16 18.78L13.96 16.98L13.02 15.34L12.92 15.42L12.34 21.46L12.08 21.76L11.48 22L10.98 21.6L10.7 21L10.98 19.76L11.3 18.16L11.56 16.88L11.8 15.3L11.94 14.78V14.74H11.8L10.6 16.4L8.8 18.86L7.36 20.38L7.02 20.52L6.42 20.22L6.48 19.66L6.8 19.2L8.8 16.64L10 15.06L10.8 14.14L10.78 14.04H10.72L5.44 17.48L4.5 17.6L4.1 17.2L4.14 16.6L4.34 16.4L5.94 15.3H5.92Z"
  }));
},
    SO = function SO(_ref2995) {
  var _ref2995$color = _ref2995.color,
      C = _ref2995$color === void 0 ? "currentColor" : _ref2995$color,
      _ref2995$size = _ref2995.size,
      e = _ref2995$size === void 0 ? 24 : _ref2995$size,
      l = _ref2995.className,
      i = _objectWithoutProperties(_ref2995, _excluded2995);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8.64445 2.55279C8.39746 2.05881 7.79679 1.85859 7.30281 2.10558C6.80883 2.35257 6.60861 2.95324 6.8556 3.44722L9.68128 9.09859L5.06655 5.92596C4.61145 5.61308 3.98887 5.72837 3.67598 6.18348C3.3631 6.63858 3.47839 7.26116 3.9335 7.57405L9.40503 11.3357L3.05258 11.0014C2.50106 10.9724 2.03043 11.3959 2.00141 11.9474C1.97238 12.499 2.39594 12.9696 2.94747 12.9986L8.74187 13.3036L4.44532 16.168C3.9858 16.4743 3.86162 17.0952 4.16797 17.5547C4.47433 18.0142 5.0952 18.1384 5.55473 17.8321L9.19687 15.404L6.68629 18.9188C6.36528 19.3682 6.46937 19.9927 6.91879 20.3137C7.3682 20.6347 7.99275 20.5307 8.31376 20.0812L11.3471 15.8345L10.5136 20.8356C10.4228 21.3804 10.7909 21.8956 11.3356 21.9864C11.8804 22.0772 12.3956 21.7092 12.4864 21.1644L13.2883 16.3532L15.6588 20.0408C15.9575 20.5053 16.5762 20.6398 17.0408 20.3412C17.5054 20.0425 17.6399 19.4238 17.3412 18.9592L15.5553 16.1812L18.3217 18.7348C18.7276 19.1094 19.3602 19.0841 19.7348 18.6783C20.1094 18.2725 20.0841 17.6398 19.6783 17.2652L16.6427 14.4631L20.876 14.9923C21.424 15.0608 21.9238 14.6721 21.9923 14.124C22.0608 13.576 21.6721 13.0762 21.1241 13.0077L16.9342 12.484L21.2291 11.4734C21.7667 11.3469 22.0999 10.8086 21.9734 10.271C21.8469 9.73336 21.3086 9.40009 20.771 9.52659L15.1819 10.8417L19.2863 5.61783C19.6276 5.18356 19.5521 4.5549 19.1178 4.21369C18.6836 3.87247 18.0549 3.94791 17.7137 4.38218L13.8574 9.29015L14.738 3.65438C14.8233 3.10872 14.4501 2.59725 13.9044 2.51199C13.3587 2.42673 12.8473 2.79996 12.762 3.34563L11.876 9.01594L8.64445 2.55279Z"
  }));
},
    AO = function AO(_ref2996) {
  var _ref2996$color = _ref2996.color,
      C = _ref2996$color === void 0 ? "currentColor" : _ref2996$color,
      _ref2996$size = _ref2996.size,
      e = _ref2996$size === void 0 ? 24 : _ref2996$size,
      l = _ref2996.className,
      i = _objectWithoutProperties(_ref2996, _excluded2996);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.4668 8.69379L20.7134 8.12811C21.1529 7.11947 21.9445 6.31641 22.9323 5.87708L23.6919 5.53922C24.1027 5.35653 24.1027 4.75881 23.6919 4.57612L22.9748 4.25714C21.9616 3.80651 21.1558 2.97373 20.7238 1.93083L20.4706 1.31953C20.2942 0.893489 19.7058 0.893489 19.5293 1.31953L19.2761 1.93083C18.8442 2.97373 18.0384 3.80651 17.0252 4.25714L16.308 4.57612C15.8973 4.75881 15.8973 5.35653 16.308 5.53922L17.0677 5.87708C18.0555 6.31641 18.8471 7.11947 19.2866 8.12811L19.5331 8.69379C19.7136 9.10792 20.2864 9.10792 20.4668 8.69379ZM22 20V10.6586C21.3744 10.8797 20.7013 11 20 11C19.1201 11 18.2845 10.8106 17.5316 10.4703L17.4153 10.5866C17.0534 10.2241 16.553 10 16 10C14.895 10 14 10.895 14 12C14 13.105 14.895 14 16 14C16.5525 14 17.0525 13.7762 17.4144 13.4144L18.828 14.828C18.104 15.552 17.104 16 16 16C13.792 16 12 14.208 12 12C12 10.1752 13.224 8.63446 14.8953 8.1547C14.3277 7.23814 14 6.15734 14 5C14 4.29873 14.1203 3.62556 14.3414 3H3C2.44772 3 2 3.44772 2 4V20C2 20.5523 2.44772 21 3 21H21C21.5523 21 22 20.5523 22 20ZM9 8C10.1045 8 11.1049 8.44841 11.829 9.173L10.4153 10.5866C10.0483 10.22 9.55 10 9 10C7.895 10 7 10.895 7 12C7 13.105 7.895 14 9 14C9.5525 14 10.0525 13.7762 10.4144 13.4144L11.828 14.828C11.1 15.55 10.1 16 9 16C6.792 16 5 14.208 5 12C5 9.792 6.792 8 9 8Z"
  }));
},
    kO = function kO(_ref2997) {
  var _ref2997$color = _ref2997.color,
      C = _ref2997$color === void 0 ? "currentColor" : _ref2997$color,
      _ref2997$size = _ref2997.size,
      e = _ref2997$size === void 0 ? 24 : _ref2997$size,
      l = _ref2997.className,
      i = _objectWithoutProperties(_ref2997, _excluded2997);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.4668 8.69379L20.7134 8.12811C21.1529 7.11947 21.9445 6.31641 22.9323 5.87708L23.6919 5.53922C24.1027 5.35653 24.1027 4.75881 23.6919 4.57612L22.9748 4.25714C21.9616 3.80651 21.1558 2.97373 20.7238 1.93083L20.4706 1.31953C20.2942 0.893489 19.7058 0.893489 19.5293 1.31953L19.2761 1.93083C18.8442 2.97373 18.0384 3.80651 17.0252 4.25714L16.308 4.57612C15.8973 4.75881 15.8973 5.35653 16.308 5.53922L17.0677 5.87708C18.0555 6.31641 18.8471 7.11947 19.2866 8.12811L19.5331 8.69379C19.7136 9.10792 20.2864 9.10792 20.4668 8.69379ZM3 3H14V5H4V19H20V11H22V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM9 8C10.1045 8 11.1049 8.44841 11.829 9.173L10.4153 10.5866C10.0534 10.2241 9.55299 10 9 10C7.895 10 7 10.895 7 12C7 13.105 7.895 14 9 14C9.5525 14 10.0525 13.7762 10.4144 13.4144L11.828 14.828C11.104 15.552 10.104 16 9 16C6.792 16 5 14.208 5 12C5 9.792 6.792 8 9 8ZM16 8C17.1045 8 18.1049 8.44841 18.829 9.173L17.4153 10.5866C17.0534 10.2241 16.553 10 16 10C14.895 10 14 10.895 14 12C14 13.105 14.895 14 16 14C16.5525 14 17.0525 13.7762 17.4144 13.4144L18.828 14.828C18.104 15.552 17.104 16 16 16C13.792 16 12 14.208 12 12C12 9.792 13.792 8 16 8Z"
  }));
},
    PO = function PO(_ref2998) {
  var _ref2998$color = _ref2998.color,
      C = _ref2998$color === void 0 ? "currentColor" : _ref2998$color,
      _ref2998$size = _ref2998.size,
      e = _ref2998$size === void 0 ? 24 : _ref2998$size,
      l = _ref2998.className,
      i = _objectWithoutProperties(_ref2998, _excluded2998);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.4668 8.69379L20.7134 8.12811C21.1529 7.11947 21.9445 6.31641 22.9323 5.87708L23.6919 5.53922C24.1027 5.35653 24.1027 4.75881 23.6919 4.57612L22.9748 4.25714C21.9616 3.80651 21.1558 2.97373 20.7238 1.93083L20.4706 1.31953C20.2942 0.893489 19.7058 0.893489 19.5293 1.31953L19.2761 1.93083C18.8442 2.97373 18.0384 3.80651 17.0252 4.25714L16.308 4.57612C15.8973 4.75881 15.8973 5.35653 16.308 5.53922L17.0677 5.87708C18.0555 6.31641 18.8471 7.11947 19.2866 8.12811L19.5331 8.69379C19.7136 9.10792 20.2864 9.10792 20.4668 8.69379ZM20 11C20.6695 11 21.3134 10.8903 21.9147 10.688C21.971 11.1174 22 11.5553 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C12.9056 2 13.7831 2.12039 14.6174 2.34603C14.2221 3.14617 14 4.04715 14 5C14 8.31371 16.6863 11 20 11ZM13 11V6L8 13H11V18L16 11H13Z"
  }));
},
    DO = function DO(_ref2999) {
  var _ref2999$color = _ref2999.color,
      C = _ref2999$color === void 0 ? "currentColor" : _ref2999$color,
      _ref2999$size = _ref2999.size,
      e = _ref2999$size === void 0 ? 24 : _ref2999$size,
      l = _ref2999.className,
      i = _objectWithoutProperties(_ref2999, _excluded2999);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.7134 8.12811L20.4668 8.69379C20.2864 9.10792 19.7136 9.10792 19.5331 8.69379L19.2866 8.12811C18.8471 7.11947 18.0555 6.31641 17.0677 5.87708L16.308 5.53922C15.8973 5.35653 15.8973 4.75881 16.308 4.57612L17.0252 4.25714C18.0384 3.80651 18.8442 2.97373 19.2761 1.93083L19.5293 1.31953C19.7058 0.893489 20.2942 0.893489 20.4706 1.31953L20.7238 1.93083C21.1558 2.97373 21.9616 3.80651 22.9748 4.25714L23.6919 4.57612C24.1027 4.75881 24.1027 5.35653 23.6919 5.53922L22.9323 5.87708C21.9445 6.31641 21.1529 7.11947 20.7134 8.12811ZM12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 11.6765 19.9809 11.3579 19.9437 11.0452L21.9298 10.8094C21.9762 11.2002 22 11.5975 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C12.8614 2 13.6987 2.10914 14.4983 2.31487L14 4.25179C13.3618 4.0876 12.6919 4 12 4ZM13 11H16L11 18V13H8L13 6V11Z"
  }));
},
    yO = function yO(_ref3000) {
  var _ref3000$color = _ref3000.color,
      C = _ref3000$color === void 0 ? "currentColor" : _ref3000$color,
      _ref3000$size = _ref3000.size,
      e = _ref3000$size === void 0 ? 24 : _ref3000$size,
      l = _ref3000.className,
      i = _objectWithoutProperties(_ref3000, _excluded3000);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.4668 8.69379L20.7134 8.12811C21.1529 7.11947 21.9445 6.31641 22.9323 5.87708L23.6919 5.53922C24.1027 5.35653 24.1027 4.75881 23.6919 4.57612L22.9748 4.25714C21.9616 3.80651 21.1558 2.97373 20.7238 1.93083L20.4706 1.31953C20.2942 0.893489 19.7058 0.893489 19.5293 1.31953L19.2761 1.93083C18.8442 2.97373 18.0384 3.80651 17.0252 4.25714L16.308 4.57612C15.8973 4.75881 15.8973 5.35653 16.308 5.53922L17.0677 5.87708C18.0555 6.31641 18.8471 7.11947 19.2866 8.12811L19.5331 8.69379C19.7136 9.10792 20.2864 9.10792 20.4668 8.69379ZM20 11C20.7013 11 21.3744 10.8797 22 10.6586V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5551 2 20.0066V3.9934C2 3.44476 2.45531 3 2.9918 3H14.3414C14.1203 3.62556 14 4.29873 14 5C14 8.31371 16.6863 11 20 11ZM4 5V7H6V5H4ZM4 9V11H6V9H4ZM4 13V15H6V13H4ZM18 13V15H20V13H18ZM4 17V19H6V17H4ZM18 17V19H20V17H18Z"
  }));
},
    bO = function bO(_ref3001) {
  var _ref3001$color = _ref3001.color,
      C = _ref3001$color === void 0 ? "currentColor" : _ref3001$color,
      _ref3001$size = _ref3001.size,
      e = _ref3001$size === void 0 ? 24 : _ref3001$size,
      l = _ref3001.className,
      i = _objectWithoutProperties(_ref3001, _excluded3001);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.4668 8.69379L20.7134 8.12811C21.1529 7.11947 21.9445 6.31641 22.9323 5.87708L23.6919 5.53922C24.1027 5.35653 24.1027 4.75881 23.6919 4.57612L22.9748 4.25714C21.9616 3.80651 21.1558 2.97373 20.7238 1.93083L20.4706 1.31953C20.2942 0.893489 19.7058 0.893489 19.5293 1.31953L19.2761 1.93083C18.8442 2.97373 18.0384 3.80651 17.0252 4.25714L16.308 4.57612C15.8973 4.75881 15.8973 5.35653 16.308 5.53922L17.0677 5.87708C18.0555 6.31641 18.8471 7.11947 19.2866 8.12811L19.5331 8.69379C19.7136 9.10792 20.2864 9.10792 20.4668 8.69379ZM2.9918 3H14V5H8V19H16V9H18V11H20H22V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5551 2 20.0066V3.9934C2 3.44476 2.45531 3 2.9918 3ZM4 5V7H6V5H4ZM4 9V11H6V9H4ZM4 13V15H6V13H4ZM18 13V15H20V13H18ZM4 17V19H6V17H4ZM18 17V19H20V17H18Z"
  }));
},
    TO = function TO(_ref3002) {
  var _ref3002$color = _ref3002.color,
      C = _ref3002$color === void 0 ? "currentColor" : _ref3002$color,
      _ref3002$size = _ref3002.size,
      e = _ref3002$size === void 0 ? 24 : _ref3002$size,
      l = _ref3002.className,
      i = _objectWithoutProperties(_ref3002, _excluded3002);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19.4668 8.69379L19.7134 8.12811C20.1529 7.11947 20.9445 6.31641 21.9323 5.87708L22.6919 5.53922C23.1027 5.35653 23.1027 4.75881 22.6919 4.57612L21.9748 4.25714C20.9616 3.80651 20.1558 2.97373 19.7238 1.93083L19.4706 1.31953C19.2942 0.893489 18.7058 0.893489 18.5293 1.31953L18.2761 1.93083C17.8442 2.97373 17.0384 3.80651 16.0252 4.25714L15.308 4.57612C14.8973 4.75881 14.8973 5.35653 15.308 5.53922L16.0677 5.87708C17.0555 6.31641 17.8471 7.11947 18.2866 8.12811L18.5331 8.69379C18.7136 9.10792 19.2864 9.10792 19.4668 8.69379ZM4.75416 15H11.246L13.246 20H15.4001L9.0001 4H7.0001L0.600098 20H2.75416L4.75416 15ZM8.0001 6.88516L10.446 13H5.55416L8.0001 6.88516ZM21.0001 12V12.5351C20.4118 12.1948 19.7287 12 19.0001 12C16.791 12 15.0001 13.7909 15.0001 16C15.0001 18.2091 16.791 20 19.0001 20C19.7287 20 20.4118 19.8052 21.0001 19.4649V20H23.0001V12H21.0001ZM21.0001 16C21.0001 17.1046 20.1047 18 19.0001 18C17.8955 18 17.0001 17.1046 17.0001 16C17.0001 14.8954 17.8955 14 19.0001 14C20.1047 14 21.0001 14.8954 21.0001 16Z"
  }));
},
    UO = function UO(_ref3003) {
  var _ref3003$color = _ref3003.color,
      C = _ref3003$color === void 0 ? "currentColor" : _ref3003$color,
      _ref3003$size = _ref3003.size,
      e = _ref3003$size === void 0 ? 24 : _ref3003$size,
      l = _ref3003.className,
      i = _objectWithoutProperties(_ref3003, _excluded3003);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 3H6.6V6.6L10.2001 6.6001V10.2001L13.8 10.2002L13.8 6.6001H17.3999V3H20.9999V20.9999H17.3999V13.8002L13.8 13.7998V17.3998H10.2V13.8002L6.6 13.7998V20.9999H3V3Z"
  }));
},
    GO = function GO(_ref3004) {
  var _ref3004$color = _ref3004.color,
      C = _ref3004$color === void 0 ? "currentColor" : _ref3004$color,
      _ref3004$size = _ref3004.size,
      e = _ref3004$size === void 0 ? 24 : _ref3004$size,
      l = _ref3004.className,
      i = _objectWithoutProperties(_ref3004, _excluded3004);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 3H8.20002V6.20004L11.4001 6.20013V9.40015L12.6 9.40018L12.6001 6.2001H15.8V3H21V21H15.8V14.6001L14.6 14.6V17.7999H9.39999V14.6001L8.20002 14.6V21H3V3ZM5 5V19H6.20002V12.5998L11.4 12.6003V15.7999H12.6V12.5998L17.8 12.6003V19H19V5H17.8V8.2001H14.6001L14.6 11.4002L9.40012 11.4001V8.20008L6.20002 8.19999V5H5Z"
  }));
},
    IO = function IO(_ref3005) {
  var _ref3005$color = _ref3005.color,
      C = _ref3005$color === void 0 ? "currentColor" : _ref3005$color,
      _ref3005$size = _ref3005.size,
      e = _ref3005$size === void 0 ? 24 : _ref3005$size,
      l = _ref3005.className,
      i = _objectWithoutProperties(_ref3005, _excluded3005);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.4668 8.69379L20.7134 8.12811C21.1529 7.11947 21.9445 6.31641 22.9323 5.87708L23.6919 5.53922C24.1027 5.35653 24.1027 4.75881 23.6919 4.57612L22.9748 4.25714C21.9616 3.80651 21.1558 2.97373 20.7238 1.93083L20.4706 1.31953C20.2942 0.893489 19.7058 0.893489 19.5293 1.31953L19.2761 1.93083C18.8442 2.97373 18.0384 3.80651 17.0252 4.25714L16.308 4.57612C15.8973 4.75881 15.8973 5.35653 16.308 5.53922L17.0677 5.87708C18.0555 6.31641 18.8471 7.11947 19.2866 8.12811L19.5331 8.69379C19.7136 9.10792 20.2864 9.10792 20.4668 8.69379ZM20 11C20.6695 11 21.3134 10.8903 21.9147 10.688C21.971 11.1174 22 11.5553 22 12C22 15.2712 20.4293 18.1755 18.001 20H20V22H12C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C12.9056 2 13.7831 2.12039 14.6174 2.34603C14.2221 3.14617 14 4.04715 14 5C14 8.31371 16.6863 11 20 11ZM12 10C13.1046 10 14 9.10457 14 8C14 6.89543 13.1046 6 12 6C10.8954 6 10 6.89543 10 8C10 9.10457 10.8954 10 12 10ZM8 14C9.10457 14 10 13.1046 10 12C10 10.8954 9.10457 10 8 10C6.89543 10 6 10.8954 6 12C6 13.1046 6.89543 14 8 14ZM16 14C17.1046 14 18 13.1046 18 12C18 10.8954 17.1046 10 16 10C14.8954 10 14 10.8954 14 12C14 13.1046 14.8954 14 16 14ZM12 18C13.1046 18 14 17.1046 14 16C14 14.8954 13.1046 14 12 14C10.8954 14 10 14.8954 10 16C10 17.1046 10.8954 18 12 18Z"
  }));
},
    WO = function WO(_ref3006) {
  var _ref3006$color = _ref3006.color,
      C = _ref3006$color === void 0 ? "currentColor" : _ref3006$color,
      _ref3006$size = _ref3006.size,
      e = _ref3006$size === void 0 ? 24 : _ref3006$size,
      l = _ref3006.className,
      i = _objectWithoutProperties(_ref3006, _excluded3006);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.7134 8.12811L20.4668 8.69379C20.2864 9.10792 19.7136 9.10792 19.5331 8.69379L19.2866 8.12811C18.8471 7.11947 18.0555 6.31641 17.0677 5.87708L16.308 5.53922C15.8973 5.35653 15.8973 4.75881 16.308 4.57612L17.0252 4.25714C18.0384 3.80651 18.8442 2.97373 19.2761 1.93083L19.5293 1.31953C19.7058 0.893489 20.2942 0.893489 20.4706 1.31953L20.7238 1.93083C21.1558 2.97373 21.9616 3.80651 22.9748 4.25714L23.6919 4.57612C24.1027 4.75881 24.1027 5.35653 23.6919 5.53922L22.9323 5.87708C21.9445 6.31641 21.1529 7.11947 20.7134 8.12811ZM12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22H20V20H18.001C18.7582 19.4311 19.4319 18.7572 20.0007 18C21.2561 16.3287 22 14.2512 22 12C22 11.5975 21.9762 11.2002 21.9298 10.8094L19.9437 11.0452C19.9809 11.3579 20 11.6765 20 12C20 14.3894 18.9525 16.5341 17.2916 18C15.8814 19.2447 14.0289 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C12.6919 4 13.3618 4.0876 14 4.25179L14.4983 2.31487C13.6987 2.10914 12.8614 2 12 2ZM10 8C10 9.10457 10.8954 10 12 10C13.1046 10 14 9.10457 14 8C14 6.89543 13.1046 6 12 6C10.8954 6 10 6.89543 10 8ZM6 12C6 13.1046 6.89543 14 8 14C9.10457 14 10 13.1046 10 12C10 10.8954 9.10457 10 8 10C6.89543 10 6 10.8954 6 12ZM14 12C14 13.1046 14.8954 14 16 14C17.1046 14 18 13.1046 18 12C18 10.8954 17.1046 10 16 10C14.8954 10 14 10.8954 14 12ZM10 16C10 17.1046 10.8954 18 12 18C13.1046 18 14 17.1046 14 16C14 14.8954 13.1046 14 12 14C10.8954 14 10 14.8954 10 16Z"
  }));
},
    OO = function OO(_ref3007) {
  var _ref3007$color = _ref3007.color,
      C = _ref3007$color === void 0 ? "currentColor" : _ref3007$color,
      _ref3007$size = _ref3007.size,
      e = _ref3007$size === void 0 ? 24 : _ref3007$size,
      l = _ref3007.className,
      i = _objectWithoutProperties(_ref3007, _excluded3007);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.4668 8.69379L20.7134 8.12811C21.1529 7.11947 21.9445 6.31641 22.9323 5.87708L23.6919 5.53922C24.1027 5.35653 24.1027 4.75881 23.6919 4.57612L22.9748 4.25714C21.9616 3.80651 21.1558 2.97373 20.7238 1.93083L20.4706 1.31953C20.2942 0.893489 19.7058 0.893489 19.5293 1.31953L19.2761 1.93083C18.8442 2.97373 18.0384 3.80651 17.0252 4.25714L16.308 4.57612C15.8973 4.75881 15.8973 5.35653 16.308 5.53922L17.0677 5.87708C18.0555 6.31641 18.8471 7.11947 19.2866 8.12811L19.5331 8.69379C19.7136 9.10792 20.2864 9.10792 20.4668 8.69379ZM20 11C20.7013 11 21.3744 10.8797 22 10.6586V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5551 2 20.0066V3.9934C2 3.44476 2.45531 3 2.9918 3H14.3414C14.1203 3.62556 14 4.29873 14 5C14 5.34071 14.0284 5.67479 14.083 6H12V12.1707C11.6872 12.0602 11.3506 12 11 12C9.34315 12 8 13.3431 8 15C8 16.6569 9.34315 18 11 18C12.6569 18 14 16.6569 14 15V8H14.8027C15.8401 9.7934 17.7792 11 20 11Z"
  }));
},
    KO = function KO(_ref3008) {
  var _ref3008$color = _ref3008.color,
      C = _ref3008$color === void 0 ? "currentColor" : _ref3008$color,
      _ref3008$size = _ref3008.size,
      e = _ref3008$size === void 0 ? 24 : _ref3008$size,
      l = _ref3008.className,
      i = _objectWithoutProperties(_ref3008, _excluded3008);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M20.4668 8.69379L20.7134 8.12811C21.1529 7.11947 21.9445 6.31641 22.9323 5.87708L23.6919 5.53922C24.1027 5.35653 24.1027 4.75881 23.6919 4.57612L22.9748 4.25714C21.9616 3.80651 21.1558 2.97373 20.7238 1.93083L20.4706 1.31953C20.2942 0.893489 19.7058 0.893489 19.5293 1.31953L19.2761 1.93083C18.8442 2.97373 18.0384 3.80651 17.0252 4.25714L16.308 4.57612C15.8973 4.75881 15.8973 5.35653 16.308 5.53922L17.0677 5.87708C18.0555 6.31641 18.8471 7.11947 19.2866 8.12811L19.5331 8.69379C19.7136 9.10792 20.2864 9.10792 20.4668 8.69379ZM2 4C2 3.44772 2.44772 3 3 3H14V5H4V19H20V11H22V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4ZM12 12.1707V6H16V8H14V15C14 16.6569 12.6569 18 11 18C9.34315 18 8 16.6569 8 15C8 13.3431 9.34315 12 11 12C11.3506 12 11.6872 12.0602 12 12.1707Z"
  }));
},
    QO = function QO(_ref3009) {
  var _ref3009$color = _ref3009.color,
      C = _ref3009$color === void 0 ? "currentColor" : _ref3009$color,
      _ref3009$size = _ref3009.size,
      e = _ref3009$size === void 0 ? 24 : _ref3009$size,
      l = _ref3009.className,
      i = _objectWithoutProperties(_ref3009, _excluded3009);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5.73486 2L11.4299 7.24715V7.24595V2.01211H12.5385V7.27063L18.2591 2V7.98253H20.6078V16.6118H18.2663V21.9389L12.5385 16.9066V21.9967H11.4299V16.9896L5.74131 22V16.6118H3.39258V7.98253H5.73486V2ZM10.5942 9.0776H4.50118V15.5167H5.73992V13.4856L10.5942 9.0776ZM6.84986 13.9715V19.5565L11.4299 15.5225V9.81146L6.84986 13.9715ZM12.5704 15.4691L17.1577 19.4994V16.6118H17.1518V13.9663L12.5704 9.80608V15.4691ZM18.2663 15.5167H19.4992V9.0776H13.4516L18.2663 13.4399V15.5167ZM17.1505 7.98253V4.51888L13.3911 7.98253H17.1505ZM10.6028 7.98253L6.84346 4.51888V7.98253H10.6028Z"
  }));
},
    qO = function qO(_ref3010) {
  var _ref3010$color = _ref3010.color,
      C = _ref3010$color === void 0 ? "currentColor" : _ref3010$color,
      _ref3010$size = _ref3010.size,
      e = _ref3010$size === void 0 ? 24 : _ref3010$size,
      l = _ref3010.className,
      i = _objectWithoutProperties(_ref3010, _excluded3010);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7.17267 3.26011L5.5 1.7395V4.00005V7.50005H4H3V8.50005V16.0001V17.0001H4H5.5V20.0001V22.2606L7.17267 20.74L11 17.2606V22.0001H13V17.2606L16.8273 20.74L18.5 22.2606V20.0001V17.0001H20H21V16.0001V8.50005V7.50005H20H18.5V4.00005V1.7395L16.8273 3.26011L13 6.7395V2.00005H11V6.7395L7.17267 3.26011ZM16.5 7.50005H15.1366L16.5 6.26061V7.50005ZM8.86339 7.50005H7.5V6.26061L8.86339 7.50005ZM9.96339 9.50005L5.82733 13.2601L5.5 13.5577V14.0001V15.0001H5V9.50005H9.96339ZM14.0366 9.50005H19V15.0001H18.5V14.0001V13.5577L18.1727 13.2601L14.0366 9.50005ZM7.5 14.4424L11 11.2606V14.5577L7.5 17.7395V14.4424ZM13 11.2606L16.5 14.4424V17.7395L13 14.5577V11.2606Z"
  }));
},
    jO = function jO(_ref3011) {
  var _ref3011$color = _ref3011.color,
      C = _ref3011$color === void 0 ? "currentColor" : _ref3011$color,
      _ref3011$size = _ref3011.size,
      e = _ref3011$size === void 0 ? 24 : _ref3011$size,
      l = _ref3011.className,
      i = _objectWithoutProperties(_ref3011, _excluded3011);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13.7748 11.0393C14.933 9.26656 16 7.63328 16 6C16 3.79086 14.2091 2 12 2C9.79086 2 8 3.79086 8 6C8 7.63328 9.06704 9.26656 10.2252 11.0393L10.226 11.0405C10.3036 11.1593 10.3816 11.2787 10.4597 11.3988C10.1704 11.179 9.90318 10.9699 9.65213 10.7734C8.27615 9.69663 7.38594 9 6 9C3.79086 9 2 10.7909 2 13C2 15.2091 3.79086 17 6 17C7.63328 17 9.26656 15.933 11.0393 14.7748L11.0701 14.7547C10.9774 17.0361 10.1119 18.4381 9.15685 19.9853L9.15684 19.9853L9.15683 19.9853C9.03494 20.1828 8.91159 20.3826 8.7882 20.5869C8.4039 21.2232 8.87465 22 9.61803 22H14.382C15.1253 22 15.5961 21.2232 15.2118 20.5869C15.0884 20.3826 14.9651 20.1828 14.8432 19.9853L14.8432 19.9853L14.8432 19.9853C13.8881 18.4381 13.0226 17.0361 12.9299 14.7547C12.9402 14.7614 12.9505 14.7681 12.9607 14.7748C14.7334 15.933 16.3667 17 18 17C20.2091 17 22 15.2091 22 13C22 10.7909 20.2091 9 18 9C16.6141 9 15.7238 9.69663 14.3479 10.7734C14.0968 10.9699 13.8296 11.179 13.5403 11.3988C13.6187 11.2783 13.697 11.1585 13.7748 11.0393Z"
  }));
},
    XO = function XO(_ref3012) {
  var _ref3012$color = _ref3012.color,
      C = _ref3012$color === void 0 ? "currentColor" : _ref3012$color,
      _ref3012$size = _ref3012.size,
      e = _ref3012$size === void 0 ? 24 : _ref3012$size,
      l = _ref3012.className,
      i = _objectWithoutProperties(_ref3012, _excluded3012);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M8.23611 7.46049C8.57416 8.54052 9.22587 9.55225 9.86317 10.5037L10.0123 10.7259C10.1653 10.9537 10.316 11.1779 10.4597 11.3988C10.4597 11.3988 9.90318 10.9699 9.65213 10.7734C8.52697 9.89291 7.72662 9.2666 6.71443 9.06753C6.48879 9.02315 6.25263 9 6 9C3.79086 9 2 10.7909 2 13C2 15.2091 3.79086 17 6 17C6.67629 17 7.35259 16.817 8.03878 16.5204C8.72217 16.225 9.41538 15.8169 10.1282 15.3645C10.1123 16.3363 9.99514 17.1443 9.79852 17.8863C9.55229 18.8155 9.18139 19.6409 8.72841 20.5544C8.39815 21.2204 8.87465 22 9.61803 22H14.382C15.1253 22 15.6018 21.2204 15.2716 20.5544C14.8186 19.6409 14.4477 18.8155 14.2015 17.8863C14.0049 17.1443 13.8877 16.3363 13.8718 15.3645C14.5846 15.8169 15.2778 16.225 15.9612 16.5204C16.6474 16.8171 17.3237 17 18 17C20.2091 17 22 15.2091 22 13C22 10.7909 20.2091 9 18 9C17.7332 9 17.4848 9.02581 17.2478 9.07518C16.2533 9.28228 15.459 9.90391 14.3479 10.7734C14.0968 10.9699 13.5403 11.3988 13.5403 11.3988C13.6181 11.2791 13.6959 11.1601 13.7732 11.0417L13.7747 11.0395L13.7748 11.0393L13.7749 11.0391L13.7751 11.0389C13.8946 10.856 14.0131 10.6746 14.1296 10.4945C14.8038 9.45198 15.4097 8.45411 15.7391 7.47113C15.9043 6.97825 16 6.48913 16 6C16 3.79086 14.2091 2 12 2C9.79086 2 8 3.79086 8 6C8 6.50041 8.08792 6.98701 8.23611 7.46049ZM13.4584 7.72074C13.1078 8.40207 12.65 9.10337 12.1022 9.94258L11.9996 10.0997C11.8684 9.90093 11.7419 9.7126 11.6196 9.53077L11.6196 9.53074C11.2389 8.96424 10.9005 8.46087 10.5982 7.90024C10.1889 7.14129 10 6.53374 10 6C10 4.89543 10.8954 4 12 4C13.1046 4 14 4.89543 14 6C14 6.41382 13.8532 6.95355 13.4584 7.72074ZM10.4958 13.3985C10.9721 13.3899 11.4445 13.2117 11.8164 12.8683C11.8826 12.8072 11.9438 12.7426 12 12.6748C12.0562 12.7426 12.1174 12.8072 12.1836 12.8683C12.5555 13.2117 13.0279 13.3899 13.5042 13.3985C13.2933 13.4379 13.0871 13.5116 12.894 13.6198C12.4758 13.8541 12.1635 14.2258 12 14.6599C11.8365 14.2258 11.5242 13.8541 11.106 13.6198C10.9129 13.5116 10.7067 13.4379 10.4958 13.3985ZM11.1853 20C11.5527 19.1113 11.8427 18.1782 12 17.0726C12.1573 18.1782 12.4473 19.1113 12.8147 20H11.1853ZM13.9087 13.3648C14.4532 13.2631 14.902 12.898 15.3304 12.5495C15.4144 12.4811 15.4976 12.4134 15.5807 12.3485C17.0606 11.1904 17.4148 11 18.0002 11C19.1048 11 20.0002 11.8954 20.0002 13C20.0002 14.1046 19.1048 15 18.0002 15C17.3011 15 16.4061 14.604 14.9438 13.6759C14.6281 13.4755 14.2694 13.3714 13.9087 13.3648ZM6 11C6.58546 11 6.93965 11.1904 8.41957 12.3485C8.50259 12.4134 8.58582 12.4811 8.66983 12.5495C9.09823 12.898 9.54698 13.2631 10.0915 13.3648C9.73085 13.3714 9.37215 13.4755 9.05642 13.6759C7.59418 14.604 6.69912 15 6 15C4.89543 15 4 14.1046 4 13C4 11.8954 4.89543 11 6 11Z"
  }));
},
    JO = function JO(_ref3013) {
  var _ref3013$color = _ref3013.color,
      C = _ref3013$color === void 0 ? "currentColor" : _ref3013$color,
      _ref3013$size = _ref3013.size,
      e = _ref3013$size === void 0 ? 24 : _ref3013$size,
      l = _ref3013.className,
      i = _objectWithoutProperties(_ref3013, _excluded3013);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4.03607 10.7336L11.2259 1.94599C11.626 1.45697 12.3737 1.45697 12.7738 1.94599L19.9637 10.7336C20.5664 11.4703 20.5664 12.5298 19.9637 13.2665L12.7738 22.0541C12.3737 22.5431 11.626 22.5431 11.2259 22.0541L4.03607 13.2665C3.43329 12.5298 3.43329 11.4703 4.03607 10.7336Z"
  }));
},
    YO = function YO(_ref3014) {
  var _ref3014$color = _ref3014.color,
      C = _ref3014$color === void 0 ? "currentColor" : _ref3014$color,
      _ref3014$size = _ref3014.size,
      e = _ref3014$size === void 0 ? 24 : _ref3014$size,
      l = _ref3014.className,
      i = _objectWithoutProperties(_ref3014, _excluded3014);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4.03607 10.7336C3.43329 11.4703 3.43329 12.5298 4.03607 13.2665L11.2259 22.0541C11.626 22.5431 12.3737 22.5431 12.7738 22.0541L19.9637 13.2665C20.5664 12.5298 20.5664 11.4703 19.9637 10.7336L12.7738 1.94599C12.3737 1.45697 11.626 1.45697 11.2259 1.94599L4.03607 10.7336ZM11.9999 4.15841L18.4157 12L11.9999 19.8417L5.58398 12L11.9999 4.15841Z"
  }));
},
    _O = function _O(_ref3015) {
  var _ref3015$color = _ref3015.color,
      C = _ref3015$color === void 0 ? "currentColor" : _ref3015$color,
      _ref3015$size = _ref3015.size,
      e = _ref3015$size === void 0 ? 24 : _ref3015$size,
      l = _ref3015.className,
      i = _objectWithoutProperties(_ref3015, _excluded3015);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 8.5C2 5.46243 4.46243 3 7.5 3C9.36016 3 11.0046 3.92345 12 5.33692C12.9954 3.92345 14.6398 3 16.5 3C19.5376 3 22 5.46243 22 8.5C22 16 11.9999 21.4852 11.9999 21.4852C11.9999 21.4852 2 16 2 8.5Z"
  }));
},
    $O = function $O(_ref3016) {
  var _ref3016$color = _ref3016.color,
      C = _ref3016$color === void 0 ? "currentColor" : _ref3016$color,
      _ref3016$size = _ref3016.size,
      e = _ref3016$size === void 0 ? 24 : _ref3016$size,
      l = _ref3016.className,
      i = _objectWithoutProperties(_ref3016, _excluded3016);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 8.81056L13.6352 6.48845C14.2721 5.58412 15.3179 5 16.5 5C18.433 5 20 6.567 20 8.5C20 11.3788 18.0407 14.1215 15.643 16.3358C14.4877 17.4027 13.3237 18.2603 12.4451 18.8521C12.2861 18.9592 12.1371 19.0571 11.9999 19.1456C11.8627 19.0571 11.7137 18.9592 11.5547 18.8521C10.6761 18.2604 9.51216 17.4028 8.35685 16.3358C5.95926 14.1216 4 11.3788 4 8.5C4 6.567 5.567 5 7.5 5C8.68209 5 9.72794 5.58412 10.3648 6.48845L12 8.81056ZM10.5557 3.92626C9.68172 3.3412 8.63071 3 7.5 3C4.46243 3 2 5.46243 2 8.5C2 16 11.9999 21.4852 11.9999 21.4852C11.9999 21.4852 22 16 22 8.5C22 5.46243 19.5376 3 16.5 3C15.3693 3 14.3183 3.3412 13.4443 3.92626C12.8805 4.3037 12.3903 4.78263 12 5.33692C11.6097 4.78263 11.1195 4.3037 10.5557 3.92626Z"
  }));
},
    eK = function eK(_ref3017) {
  var _ref3017$color = _ref3017.color,
      C = _ref3017$color === void 0 ? "currentColor" : _ref3017$color,
      _ref3017$size = _ref3017.size,
      e = _ref3017$size === void 0 ? 24 : _ref3017$size,
      l = _ref3017.className,
      i = _objectWithoutProperties(_ref3017, _excluded3017);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M10.9513 15.8933C10.0076 16.5855 8.80705 17 7.5 17C4.46243 17 2 14.7614 2 12C2 8.45193 5.52486 5.91097 8.64404 3.66245C9.92046 2.74232 11.1289 1.87116 12.0001 1C12.8713 1.87114 14.0797 2.74228 15.3561 3.66238C18.4752 5.91092 22 8.4519 22 12C22 14.7614 19.5376 17 16.5 17C15.193 17 13.9924 16.5855 13.0487 15.8933C13.333 17.5389 14.0578 18.713 14.8432 19.9853C14.965 20.1827 15.0884 20.3826 15.2118 20.5869C15.5961 21.2232 15.1253 22 14.382 22H9.61803C8.87465 22 8.4039 21.2232 8.7882 20.5869C8.91159 20.3826 9.03495 20.1827 9.15685 19.9853C9.94224 18.713 10.667 17.5389 10.9513 15.8933Z"
  }));
},
    tK = function tK(_ref3018) {
  var _ref3018$color = _ref3018.color,
      C = _ref3018$color === void 0 ? "currentColor" : _ref3018$color,
      _ref3018$size = _ref3018.size,
      e = _ref3018$size === void 0 ? 24 : _ref3018$size,
      l = _ref3018.className,
      i = _objectWithoutProperties(_ref3018, _excluded3018);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 15.9157C11.8821 15.467 11.6096 15.0654 11.2182 14.7894C10.6256 14.3715 9.85332 14.3071 9.19971 14.621C8.70291 14.8596 8.12567 15 7.5 15C5.38335 15 4 13.4817 4 12C4 10.9402 4.51493 9.88477 5.61339 8.70965C6.74632 7.49767 8.26768 6.39904 9.89838 5.22372C10.5914 4.72424 11.3194 4.19956 12.0001 3.65734C12.6809 4.19953 13.4088 4.72418 14.1017 5.22364C15.7324 6.39897 17.2537 7.4976 18.3866 8.70959C19.4851 9.88471 20 10.9402 20 12C20 13.4817 18.6166 15 16.5 15C15.8743 15 15.2971 14.8596 14.8003 14.621C14.1467 14.3071 13.3744 14.3715 12.7818 14.7894C12.3904 15.0654 12.1179 15.467 12 15.9157ZM12.0001 1C11.1289 1.87116 9.92046 2.74232 8.64404 3.66245C5.52486 5.91097 2 8.45193 2 12C2 14.7614 4.46243 17 7.5 17C8.42657 17 9.29962 16.7917 10.0656 16.4238C9.9739 17.2908 9.78783 18.0297 9.52965 18.7406C9.31014 19.345 9.03851 19.9291 8.72841 20.5544C8.39815 21.2204 8.87465 22 9.61803 22H14.382C15.1253 22 15.6018 21.2204 15.2716 20.5544C14.9615 19.9291 14.6899 19.345 14.4704 18.7406C14.2122 18.0297 14.0261 17.2908 13.9344 16.4238C14.7004 16.7917 15.5734 17 16.5 17C19.5376 17 22 14.7614 22 12C22 8.4519 18.4752 5.91092 15.3561 3.66238C14.0797 2.74228 12.8713 1.87114 12.0001 1ZM12 17.0738C12.1583 18.1843 12.4514 19.1212 12.8146 20H11.1854C11.5486 19.1212 11.8417 18.1843 12 17.0738Z"
  }));
},
    CK = function CK(_ref3019) {
  var _ref3019$color = _ref3019.color,
      C = _ref3019$color === void 0 ? "currentColor" : _ref3019$color,
      _ref3019$size = _ref3019.size,
      e = _ref3019$size === void 0 ? 24 : _ref3019$size,
      l = _ref3019.className,
      i = _objectWithoutProperties(_ref3019, _excluded3019);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3 3C2.44772 3 2 3.44772 2 4V19C2 19.5523 2.44772 20 3 20H4V22H6V20H18V22H20V20H21C21.5523 20 22 19.5523 22 19V4C22 3.44772 21.5523 3 21 3H3ZM15.3492 8.23642L16.682 6.90366L18.0962 8.31787L16.7634 9.65063C17.4122 10.794 17.4122 12.2057 16.7634 13.3491L18.0962 14.6818L16.682 16.096L15.3492 14.7633C14.2058 15.412 12.7942 15.412 11.6508 14.7633L10.318 16.096L8.90381 14.6818L10.2366 13.3491C9.58781 12.2057 9.58781 10.794 10.2366 9.65063L8.90381 8.31787L10.318 6.90366L11.6508 8.23642C12.7942 7.58767 14.2058 7.58767 15.3492 8.23642ZM14.7374 10.2624C14.054 9.579 12.946 9.579 12.2626 10.2624C11.5791 10.9458 11.5791 12.0539 12.2626 12.7373C12.946 13.4207 14.054 13.4207 14.7374 12.7373C15.4209 12.0539 15.4209 10.9458 14.7374 10.2624ZM5 8H7V15H5V8Z"
  }));
},
    lK = function lK(_ref3020) {
  var _ref3020$color = _ref3020.color,
      C = _ref3020$color === void 0 ? "currentColor" : _ref3020$color,
      _ref3020$size = _ref3020.size,
      e = _ref3020$size === void 0 ? 24 : _ref3020$size,
      l = _ref3020.className,
      i = _objectWithoutProperties(_ref3020, _excluded3020);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M2 4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V19C22 19.5523 21.5523 20 21 20H20V22H18V20H6V22H4V20H3C2.44772 20 2 19.5523 2 19V4ZM4 18H5H19H20V5H4V18ZM15.3492 8.23642C14.2058 7.58767 12.7942 7.58767 11.6508 8.23642L10.318 6.90366L8.90381 8.31787L10.2366 9.65063C9.58781 10.794 9.58781 12.2057 10.2366 13.3491L8.90381 14.6818L10.318 16.096L11.6508 14.7633C12.7942 15.412 14.2058 15.412 15.3492 14.7633L16.682 16.096L18.0962 14.6818L16.7634 13.3491C17.4122 12.2057 17.4122 10.794 16.7634 9.65063L18.0962 8.31787L16.682 6.90366L15.3492 8.23642ZM14.7374 10.2624C15.4209 10.9458 15.4209 12.0539 14.7374 12.7373C14.054 13.4207 12.946 13.4207 12.2626 12.7373C11.5791 12.0539 11.5791 10.9458 12.2626 10.2624C12.946 9.579 14.054 9.579 14.7374 10.2624ZM5 8V15H7V8H5Z"
  }));
},
    iK = function iK(_ref3021) {
  var _ref3021$color = _ref3021.color,
      C = _ref3021$color === void 0 ? "currentColor" : _ref3021$color,
      _ref3021$size = _ref3021.size,
      e = _ref3021$size === void 0 ? 24 : _ref3021$size,
      l = _ref3021.className,
      i = _objectWithoutProperties(_ref3021, _excluded3021);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM13.5 7C13.5 7.82843 12.8284 8.5 12 8.5C11.1716 8.5 10.5 7.82843 10.5 7C10.5 6.17157 11.1716 5.5 12 5.5C12.8284 5.5 13.5 6.17157 13.5 7ZM6.62891 10.4285L7.37107 8.57129C8.82152 9.14306 10.4427 9.49988 12 9.49988C13.5595 9.49988 15.1728 9.13901 16.6264 8.57225C16.6291 8.57118 17.3843 10.4233 17.359 10.4332C16.2818 10.8534 15.1409 11.1471 13.9999 11.3301C13.9999 12.2004 13.9149 13.0939 14.3166 13.8974L15.8943 17.0528L14.1055 17.9472L12.5527 14.8416C12.448 14.6323 12.234 14.5 11.9999 14.5C11.7658 14.5 11.5518 14.6322 11.4471 14.8416L9.89432 17.9472L8.10547 17.0528L9.68318 13.8974C10.0849 13.0939 9.9999 12.2004 9.9999 11.3301C8.85731 11.1468 7.70479 10.8579 6.62891 10.4285Z"
  }));
},
    sK = function sK(_ref3022) {
  var _ref3022$color = _ref3022.color,
      C = _ref3022$color === void 0 ? "currentColor" : _ref3022$color,
      _ref3022$size = _ref3022.size,
      e = _ref3022$size === void 0 ? 24 : _ref3022$size,
      l = _ref3022.className,
      i = _objectWithoutProperties(_ref3022, _excluded3022);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12ZM12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM12 8.5C12.8284 8.5 13.5 7.82843 13.5 7C13.5 6.17157 12.8284 5.5 12 5.5C11.1716 5.5 10.5 6.17157 10.5 7C10.5 7.82843 11.1716 8.5 12 8.5ZM12 9.49988C10.4427 9.49988 8.82151 9.14306 7.37106 8.57129L6.62891 10.4285C7.70479 10.8579 8.8573 11.1468 9.99989 11.3301C9.99989 12.2004 10.0849 13.0939 9.68317 13.8974L8.10546 17.0528L9.89432 17.9472L11.4471 14.8416C11.5518 14.6322 11.7658 14.5 11.9999 14.5C12.234 14.5 12.448 14.6323 12.5527 14.8416L14.1055 17.9472L15.8943 17.0528L14.3166 13.8974C13.9149 13.0939 13.9999 12.2004 13.9999 11.3301C15.1409 11.1471 16.2818 10.8534 17.359 10.4332C17.3843 10.4233 16.6291 8.57118 16.6264 8.57225C15.1728 9.13901 13.5595 9.49988 12 9.49988Z"
  }));
},
    rK = function rK(_ref3023) {
  var _ref3023$color = _ref3023.color,
      C = _ref3023$color === void 0 ? "currentColor" : _ref3023$color,
      _ref3023$size = _ref3023.size,
      e = _ref3023$size === void 0 ? 24 : _ref3023$size,
      l = _ref3023.className,
      i = _objectWithoutProperties(_ref3023, _excluded3023);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3.00012 13.0001C3.00012 17.9707 7.02956 22.0001 12.0001 22.0001C16.9707 22.0001 21.0001 17.9707 21.0001 13.0001C21.0001 8.02956 16.9707 4.00012 12.0001 4.00012C7.02956 4.00012 3.00012 8.02956 3.00012 13.0001ZM5.2826 2.74707L1.74707 6.2826L3.16128 7.69682L6.69682 4.16128L5.2826 2.74707ZM22.2532 6.2826L18.7176 2.74707L17.3034 4.16128L20.839 7.69682L22.2532 6.2826ZM11 9H13V12H16V14H13V17H11V14H8V12H11V9Z"
  }));
},
    cK = function cK(_ref3024) {
  var _ref3024$color = _ref3024.color,
      C = _ref3024$color === void 0 ? "currentColor" : _ref3024$color,
      _ref3024$size = _ref3024.size,
      e = _ref3024$size === void 0 ? 24 : _ref3024$size,
      l = _ref3024.className,
      i = _objectWithoutProperties(_ref3024, _excluded3024);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M3.00012 13.0001C3.00012 17.9707 7.02956 22.0001 12.0001 22.0001C16.9707 22.0001 21.0001 17.9707 21.0001 13.0001C21.0001 8.02956 16.9707 4.00012 12.0001 4.00012C7.02956 4.00012 3.00012 8.02956 3.00012 13.0001ZM19.0001 13.0001C19.0001 16.8661 15.8661 20.0001 12.0001 20.0001C8.13412 20.0001 5.00012 16.8661 5.00012 13.0001C5.00012 9.13412 8.13412 6.00012 12.0001 6.00012C15.8661 6.00012 19.0001 9.13412 19.0001 13.0001ZM5.2826 2.74707L1.74707 6.2826L3.16128 7.69682L6.69682 4.16128L5.2826 2.74707ZM22.2532 6.2826L18.7176 2.74707L17.3034 4.16128L20.839 7.69682L22.2532 6.2826ZM11 9V12H8V14H11V17H13V14H16V12H13V9H11Z"
  }));
},
    oK = function oK(_ref3025) {
  var _ref3025$color = _ref3025.color,
      C = _ref3025$color === void 0 ? "currentColor" : _ref3025$color,
      _ref3025$size = _ref3025.size,
      e = _ref3025$size === void 0 ? 24 : _ref3025$size,
      l = _ref3025.className,
      i = _objectWithoutProperties(_ref3025, _excluded3025);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M12.9999 1.99974L11 1.9996L11 15.5858H5.58582L12 22L18.4142 15.5858L13 15.5858L12.9999 1.99974Z"
  }));
},
    aK = function aK(_ref3026) {
  var _ref3026$color = _ref3026.color,
      C = _ref3026$color === void 0 ? "currentColor" : _ref3026$color,
      _ref3026$size = _ref3026.size,
      e = _ref3026$size === void 0 ? 24 : _ref3026$size,
      l = _ref3026.className,
      i = _objectWithoutProperties(_ref3026, _excluded3026);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13.0001 1.99974L11.0002 1.9996L11.0002 18.1715L7.05044 14.2218L5.63623 15.636L12.0002 22L18.3642 15.636L16.9499 14.2218L13.0002 18.1716L13.0001 1.99974Z"
  }));
},
    nK = function nK(_ref3027) {
  var _ref3027$color = _ref3027.color,
      C = _ref3027$color === void 0 ? "currentColor" : _ref3027$color,
      _ref3027$size = _ref3027.size,
      e = _ref3027$size === void 0 ? 24 : _ref3027$size,
      l = _ref3027.className,
      i = _objectWithoutProperties(_ref3027, _excluded3027);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19.7783 5.63577L18.3643 4.22156L8.75734 13.8284L4.92896 10L4.92896 19.0711L14 19.0711L10.1716 15.2426L19.7783 5.63577Z"
  }));
},
    mK = function mK(_ref3028) {
  var _ref3028$color = _ref3028.color,
      C = _ref3028$color === void 0 ? "currentColor" : _ref3028$color,
      _ref3028$size = _ref3028.size,
      e = _ref3028$size === void 0 ? 24 : _ref3028$size,
      l = _ref3028.className,
      i = _objectWithoutProperties(_ref3028, _excluded3028);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19.7784 5.63589L18.3644 4.22168L6.92908 15.6569L6.92908 10.0712H4.92908L4.92908 19.0712L13.9291 19.0712V17.0712L8.34326 17.0712L19.7784 5.63589Z"
  }));
},
    wK = function wK(_ref3029) {
  var _ref3029$color = _ref3029.color,
      C = _ref3029$color === void 0 ? "currentColor" : _ref3029$color,
      _ref3029$size = _ref3029.size,
      e = _ref3029$size === void 0 ? 24 : _ref3029$size,
      l = _ref3029.className,
      i = _objectWithoutProperties(_ref3029, _excluded3029);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22.0003 12.9999L22.0004 11L8.41421 11V5.58582L2 12L8.41421 18.4142L8.41421 13L22.0003 12.9999Z"
  }));
},
    LK = function LK(_ref3030) {
  var _ref3030$color = _ref3030.color,
      C = _ref3030$color === void 0 ? "currentColor" : _ref3030$color,
      _ref3030$size = _ref3030.size,
      e = _ref3030$size === void 0 ? 24 : _ref3030$size,
      l = _ref3030.className,
      i = _objectWithoutProperties(_ref3030, _excluded3030);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22.0003 13.0001L22.0004 11.0002L5.82845 11.0002L9.77817 7.05044L8.36396 5.63623L2 12.0002L8.36396 18.3642L9.77817 16.9499L5.8284 13.0002L22.0003 13.0001Z"
  }));
},
    hK = function hK(_ref3031) {
  var _ref3031$color = _ref3031.color,
      C = _ref3031$color === void 0 ? "currentColor" : _ref3031$color,
      _ref3031$size = _ref3031.size,
      e = _ref3031$size === void 0 ? 24 : _ref3031$size,
      l = _ref3031.className,
      i = _objectWithoutProperties(_ref3031, _excluded3031);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M18.3642 19.7783L19.7784 18.3643L10.1716 8.75734L14 4.92896L4.92889 4.92896L4.9289 14L8.75735 10.1716L18.3642 19.7783Z"
  }));
},
    HK = function HK(_ref3032) {
  var _ref3032$color = _ref3032.color,
      C = _ref3032$color === void 0 ? "currentColor" : _ref3032$color,
      _ref3032$size = _ref3032.size,
      e = _ref3032$size === void 0 ? 24 : _ref3032$size,
      l = _ref3032.className,
      i = _objectWithoutProperties(_ref3032, _excluded3032);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19.7784 18.3641L18.3644 19.7783L6.92908 8.34305V13.9288H4.92908L4.92908 4.9288L13.9291 4.9288L13.9291 6.9288L8.34326 6.9288L19.7784 18.3641Z"
  }));
},
    VK = function VK(_ref3033) {
  var _ref3033$color = _ref3033.color,
      C = _ref3033$color === void 0 ? "currentColor" : _ref3033$color,
      _ref3033$size = _ref3033.size,
      e = _ref3033$size === void 0 ? 24 : _ref3033$size,
      l = _ref3033.className,
      i = _objectWithoutProperties(_ref3033, _excluded3033);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5.63578 4.22174L4.22157 5.63575L13.8284 15.2427L10 19.0711L19.0711 19.0711L19.0711 10L15.2426 13.8285L5.63578 4.22174Z"
  }));
},
    gK = function gK(_ref3034) {
  var _ref3034$color = _ref3034.color,
      C = _ref3034$color === void 0 ? "currentColor" : _ref3034$color,
      _ref3034$size = _ref3034.size,
      e = _ref3034$size === void 0 ? 24 : _ref3034$size,
      l = _ref3034.className,
      i = _objectWithoutProperties(_ref3034, _excluded3034);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4.2216 5.63589L5.63562 4.22168L17.0709 15.6569V10.0712H19.0709L19.0709 19.0712L10.0709 19.0712L10.0709 17.0712L15.6567 17.0712L4.2216 5.63589Z"
  }));
},
    MK = function MK(_ref3035) {
  var _ref3035$color = _ref3035.color,
      C = _ref3035$color === void 0 ? "currentColor" : _ref3035$color,
      _ref3035$size = _ref3035.size,
      e = _ref3035$size === void 0 ? 24 : _ref3035$size,
      l = _ref3035.className,
      i = _objectWithoutProperties(_ref3035, _excluded3035);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M1.99974 12.9999L1.9996 11L15.5858 11V5.58582L22 12L15.5858 18.4142V13L1.99974 12.9999Z"
  }));
},
    ZK = function ZK(_ref3036) {
  var _ref3036$color = _ref3036.color,
      C = _ref3036$color === void 0 ? "currentColor" : _ref3036$color,
      _ref3036$size = _ref3036.size,
      e = _ref3036$size === void 0 ? 24 : _ref3036$size,
      l = _ref3036.className,
      i = _objectWithoutProperties(_ref3036, _excluded3036);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M1.99974 13.0001L1.9996 11.0002L18.1715 11.0002L14.2218 7.05044L15.636 5.63623L22 12.0002L15.636 18.3642L14.2218 16.9499L18.1716 13.0002L1.99974 13.0001Z"
  }));
},
    xK = function xK(_ref3037) {
  var _ref3037$color = _ref3037.color,
      C = _ref3037$color === void 0 ? "currentColor" : _ref3037$color,
      _ref3037$size = _ref3037.size,
      e = _ref3037$size === void 0 ? 24 : _ref3037$size,
      l = _ref3037.className,
      i = _objectWithoutProperties(_ref3037, _excluded3037);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M4.22173 18.3642L5.63574 19.7784L15.2427 10.1716L19.071 14L19.071 4.92892L9.99999 4.92893L13.8284 8.75738L4.22173 18.3642Z"
  }));
},
    vK = function vK(_ref3038) {
  var _ref3038$color = _ref3038.color,
      C = _ref3038$color === void 0 ? "currentColor" : _ref3038$color,
      _ref3038$size = _ref3038.size,
      e = _ref3038$size === void 0 ? 24 : _ref3038$size,
      l = _ref3038.className,
      i = _objectWithoutProperties(_ref3038, _excluded3038);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5.63589 19.7784L4.22169 18.3644L15.657 6.92908L10.0712 6.92908V4.92908L19.0712 4.92908L19.0712 13.9291H17.0712L17.0712 8.34326L5.63589 19.7784Z"
  }));
},
    dK = function dK(_ref3039) {
  var _ref3039$color = _ref3039.color,
      C = _ref3039$color === void 0 ? "currentColor" : _ref3039$color,
      _ref3039$size = _ref3039.size,
      e = _ref3039$size === void 0 ? 24 : _ref3039$size,
      l = _ref3039.className,
      i = _objectWithoutProperties(_ref3039, _excluded3039);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M11.0001 22.0003L13 22.0004L13 8.41421L18.4142 8.41421L12 2L5.58575 8.41421L11 8.41421L11.0001 22.0003Z"
  }));
},
    pK = function pK(_ref3040) {
  var _ref3040$color = _ref3040.color,
      C = _ref3040$color === void 0 ? "currentColor" : _ref3040$color,
      _ref3040$size = _ref3040.size,
      e = _ref3040$size === void 0 ? 24 : _ref3040$size,
      l = _ref3040.className,
      i = _objectWithoutProperties(_ref3040, _excluded3040);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M13.0001 22.0003L11.0002 22.0004L11.0002 5.82845L7.05044 9.77817L5.63623 8.36396L12.0002 2L18.3642 8.36396L16.9499 9.77817L13.0002 5.8284L13.0001 22.0003Z"
  }));
},
    EK = function EK(_ref3041) {
  var _ref3041$color = _ref3041.color,
      C = _ref3041$color === void 0 ? "currentColor" : _ref3041$color,
      _ref3041$size = _ref3041.size,
      e = _ref3041$size === void 0 ? 24 : _ref3041$size,
      l = _ref3041.className,
      i = _objectWithoutProperties(_ref3041, _excluded3041);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5 16H17.8079C17.4099 14.185 16.3432 12.8528 14.1474 11.9115C13.9274 11.8171 13.8096 11.5713 13.8853 11.3443C13.9521 11.1436 14.1504 11.0171 14.3605 11.041L18.8456 11.5508C19.2427 11.596 19.6285 11.4003 19.8268 11.0534L20.6527 9.60794C20.8612 9.24304 20.8193 8.7867 20.5479 8.46586L15.5 2.5002V0.287109C9.33622 2.83971 5.00008 8.91347 5 16ZM4 17H19V20H20V22H3V20H4V17ZM15 7C15 7.55228 14.5523 8 14 8C13.4477 8 13 7.55228 13 7C13 6.44772 13.4477 6 14 6C14.5523 6 15 6.44772 15 7Z"
  }));
},
    NK = function NK(_ref3042) {
  var _ref3042$color = _ref3042.color,
      C = _ref3042$color === void 0 ? "currentColor" : _ref3042$color,
      _ref3042$size = _ref3042.size,
      e = _ref3042$size === void 0 ? 24 : _ref3042$size,
      l = _ref3042.className,
      i = _objectWithoutProperties(_ref3042, _excluded3042);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15.5 0.287109C14.8092 0.573189 14.1414 0.903497 13.5 1.2745C8.41874 4.21385 5.00007 9.70768 5 16H4V20H3V22H20V20H19V16H17.8079C17.6579 15.3163 17.4132 14.7012 17.0489 14.1496C16.4823 13.2917 15.6268 12.5877 14.3897 12.019C14.2591 11.959 14.1273 11.902 13.9945 11.8473C13.8804 11.8004 13.8483 11.6519 13.9355 11.5647C13.9898 11.5104 14.0574 11.5117 14.1267 11.5255L15.8799 11.8762L18.2932 12.3589C18.7153 12.4433 19.144 12.2481 19.3576 11.8744L20.6527 9.60794C20.8612 9.24304 20.8193 8.7867 20.5479 8.46586L15.5 2.5V0.287109ZM17 20H6V18.0002H17V20ZM7 16C7.00007 10.7793 9.66759 6.17842 13.7185 3.49105L18.569 9.2234L17.9787 10.2563L14.4816 9.55692C13.7702 9.41464 13.0347 9.63724 12.5216 10.1502C11.3888 11.2825 11.8463 13.127 13.2345 13.6972C14.4814 14.2095 15.094 14.7791 15.4356 15.3394C15.5531 15.532 15.6544 15.7496 15.7375 16H7ZM14 8C14.5523 8 15 7.55228 15 7C15 6.44772 14.5523 6 14 6C13.4477 6 13 6.44772 13 7C13 7.55228 13.4477 8 14 8Z"
  }));
},
    uK = function uK(_ref3043) {
  var _ref3043$color = _ref3043.color,
      C = _ref3043$color === void 0 ? "currentColor" : _ref3043$color,
      _ref3043$size = _ref3043.size,
      e = _ref3043$size === void 0 ? 24 : _ref3043$size,
      l = _ref3043.className,
      i = _objectWithoutProperties(_ref3043, _excluded3043);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19.4668 8.69379L19.7134 8.12811C20.1529 7.11947 20.9445 6.31641 21.9323 5.87708L22.6919 5.53922C23.1027 5.35653 23.1027 4.75881 22.6919 4.57612L21.9748 4.25714C20.9616 3.80651 20.1558 2.97373 19.7238 1.93083L19.4706 1.31953C19.2942 0.893489 18.7058 0.893489 18.5293 1.31953L18.2761 1.93083C17.8442 2.97373 17.0384 3.80651 16.0252 4.25714L15.308 4.57612C14.8973 4.75881 14.8973 5.35653 15.308 5.53922L16.0677 5.87708C17.0555 6.31641 17.8471 7.11947 18.2866 8.12811L18.5331 8.69379C18.7136 9.10792 19.2864 9.10792 19.4668 8.69379ZM13.3869 6.33879C13.661 6.77254 14.0357 7.09305 14.5111 7.30032L15.0764 7.54679C15.6466 7.79534 16.054 8.19476 16.2987 8.74505L16.6365 9.5047C17.364 11.1416 19.5284 11.3993 20.709 10.2787L20.8 10.4C21.0867 10.7822 21.0629 11.3138 20.7433 11.669L11.7433 21.669C11.5537 21.8797 11.2835 22 11 22C10.7165 22 10.4464 21.8797 10.2567 21.669L1.25671 11.669C0.937093 11.3138 0.913337 10.7822 1.2 10.4L4.2 6.4C4.38886 6.14819 4.68525 6 5 6H13.2063C13.2571 6.1157 13.3173 6.22863 13.3869 6.33879Z"
  }));
},
    BK = function BK(_ref3044) {
  var _ref3044$color = _ref3044.color,
      C = _ref3044$color === void 0 ? "currentColor" : _ref3044$color,
      _ref3044$size = _ref3044.size,
      e = _ref3044$size === void 0 ? 24 : _ref3044$size,
      l = _ref3044.className,
      i = _objectWithoutProperties(_ref3044, _excluded3044);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19.4668 8.69379L19.7134 8.12811C20.1529 7.11947 20.9445 6.31641 21.9323 5.87708L22.6919 5.53922C23.1027 5.35653 23.1027 4.75881 22.6919 4.57612L21.9748 4.25714C20.9616 3.80651 20.1558 2.97373 19.7238 1.93083L19.4706 1.31953C19.2942 0.893489 18.7058 0.893489 18.5293 1.31953L18.2761 1.93083C17.8442 2.97373 17.0384 3.80651 16.0252 4.25714L15.3081 4.57612C14.8973 4.75881 14.8973 5.35653 15.3081 5.53922L16.0677 5.87708C17.0555 6.31641 17.8471 7.11947 18.2866 8.12811L18.5331 8.69379C18.7136 9.10792 19.2864 9.10792 19.4668 8.69379ZM5 6C4.68525 6 4.38886 6.14819 4.2 6.4L1.2 10.4C0.913337 10.7822 0.937093 11.3138 1.25671 11.669L10.2567 21.669C10.4464 21.8797 10.7165 22 11 22C11.2835 22 11.5537 21.8797 11.7433 21.669L20.7433 11.669L19.2567 10.331L11 19.5052L3.29335 10.9422L5.5 8H14V6H5Z"
  }));
},
    fK = function fK(_ref3045) {
  var _ref3045$color = _ref3045.color,
      C = _ref3045$color === void 0 ? "currentColor" : _ref3045$color,
      _ref3045$size = _ref3045.size,
      e = _ref3045$size === void 0 ? 24 : _ref3045$size,
      l = _ref3045.className,
      i = _objectWithoutProperties(_ref3045, _excluded3045);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M14.5352 1H9.4648L7.69067 3.66118L9.55573 5.35669C6.0527 6.40665 3.5 9.65522 3.5 13.5C3.5 18.1944 7.30558 22 12 22C16.6944 22 20.5 18.1944 20.5 13.5C20.5 9.65521 17.9473 6.40663 14.4442 5.35668L16.3093 3.66118L14.5352 1ZM12 7C15.5899 7 18.5 9.91015 18.5 13.5C18.5 17.0899 15.5899 20 12 20C8.41015 20 5.5 17.0899 5.5 13.5C5.5 9.91015 8.41015 7 12 7Z"
  }));
},
    RK = function RK(_ref3046) {
  var _ref3046$color = _ref3046.color,
      C = _ref3046$color === void 0 ? "currentColor" : _ref3046$color,
      _ref3046$size = _ref3046.size,
      e = _ref3046$size === void 0 ? 24 : _ref3046$size,
      l = _ref3046.className,
      i = _objectWithoutProperties(_ref3046, _excluded3046);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9.46488 1L7.69076 3.66118L9.55579 5.35667C6.05273 6.40661 3.5 9.6552 3.5 13.5C3.5 18.1944 7.30558 22 12 22C16.6944 22 20.5 18.1944 20.5 13.5C20.5 9.65523 17.9473 6.40667 14.4443 5.35669L16.3094 3.66118L14.5352 1H9.46488ZM12 7C15.5899 7 18.5 9.91015 18.5 13.5C18.5 17.0899 15.5899 20 12 20C8.41015 20 5.5 17.0899 5.5 13.5C5.5 9.91015 8.41015 7 12 7ZM10.3094 3.33882L10.5352 3H13.4649L13.6908 3.33882L12.0001 4.87581L10.3094 3.33882Z"
  }));
},
    zK = function zK(_ref3047) {
  var _ref3047$color = _ref3047.color,
      C = _ref3047$color === void 0 ? "currentColor" : _ref3047$color,
      _ref3047$size = _ref3047.size,
      e = _ref3047$size === void 0 ? 24 : _ref3047$size,
      l = _ref3047.className,
      i = _objectWithoutProperties(_ref3047, _excluded3047);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5.33317 5.33333C5.33317 3.49238 6.82556 2 8.6665 2H11.9997H11.9998H15.333C17.174 2 18.6663 3.49238 18.6663 5.33333C18.6663 7.17428 17.174 8.66667 15.333 8.66667H11.9998H11.9997L11.9997 12L11.9997 15.3333V18.6667C11.9997 20.5076 10.5073 22 8.66634 22C6.82539 22 5.33301 20.5076 5.33301 18.6667C5.33301 16.8257 6.82539 15.3333 8.66634 15.3333C6.82539 15.3333 5.33301 13.841 5.33301 12C5.33301 10.1591 6.82539 8.66667 8.66634 8.66667H8.6665C6.82555 8.66667 5.33317 7.17428 5.33317 5.33333ZM11.9997 12C11.9997 13.841 13.4921 15.3333 15.333 15.3333C17.174 15.3333 18.6663 13.841 18.6663 12C18.6663 10.1591 17.174 8.66667 15.333 8.66667C13.4921 8.66667 11.9997 10.1591 11.9997 12Z"
  }));
},
    FK = function FK(_ref3048) {
  var _ref3048$color = _ref3048.color,
      C = _ref3048$color === void 0 ? "currentColor" : _ref3048$color,
      _ref3048$size = _ref3048.size,
      e = _ref3048$size === void 0 ? 24 : _ref3048$size,
      l = _ref3048.className,
      i = _objectWithoutProperties(_ref3048, _excluded3048);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M5 6C5 3.79086 6.79086 2 9 2H15C17.2091 2 19 3.79086 19 6C19 7.19469 18.4762 8.26706 17.6458 9C18.4762 9.73295 19 10.8053 19 12C19 14.2091 17.2091 16 15 16C14.2714 16 13.5883 15.8052 13 15.4649V18C13 20.2091 11.2091 22 9 22C6.79086 22 5 20.2091 5 18C5 16.8053 5.52376 15.7329 6.35418 15C5.52376 14.2671 5 13.1947 5 12C5 10.8053 5.52376 9.73295 6.35418 9C5.52376 8.26706 5 7.19469 5 6ZM11 10H9C7.89543 10 7 10.8954 7 12C7 13.1046 7.89543 14 9 14H11V10ZM13 12C13 13.1046 13.8954 14 15 14C16.1046 14 17 13.1046 17 12C17 10.8954 16.1046 10 15 10C13.8954 10 13 10.8954 13 12ZM15 8C16.1046 8 17 7.10457 17 6C17 4.89543 16.1046 4 15 4H13V8H15ZM9 4C7.89543 4 7 4.89543 7 6C7 7.10457 7.89543 8 9 8H11V4H9ZM11 16H9C7.89543 16 7 16.8954 7 18C7 19.1046 7.89543 20 9 20C10.1046 20 11 19.1046 11 18V16Z"
  }));
},
    SK = function SK(_ref3049) {
  var _ref3049$color = _ref3049.color,
      C = _ref3049$color === void 0 ? "currentColor" : _ref3049$color,
      _ref3049$size = _ref3049.size,
      e = _ref3049$size === void 0 ? 24 : _ref3049$size,
      l = _ref3049.className,
      i = _objectWithoutProperties(_ref3049, _excluded3049);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M21.2827 8.26012C20.8473 7.213 19.9656 6.08244 19.2733 5.72516C19.7521 6.6637 20.1656 7.72752 20.2895 8.78174C19.1569 5.95869 17.2363 4.82021 15.6678 2.34173C15.4719 2.03155 15.2431 1.61425 15.1225 1.32928C12.8952 2.63386 11.972 4.91762 11.7347 6.37128C11.0465 6.41037 10.3724 6.58239 9.7497 6.87781C9.63641 6.93386 9.57928 7.07722 9.62296 7.19583C9.67063 7.33373 9.83148 7.40294 9.9644 7.34275C10.599 7.0433 11.2978 6.8858 11.9991 6.87856C13.8038 6.86599 15.517 7.86963 16.4149 9.43745C15.88 9.06171 14.9224 8.69063 13.9997 8.8511C17.6025 10.6522 16.6353 16.8547 11.6429 16.6205C9.62869 16.5384 7.69791 14.9706 7.51696 12.8904C7.51696 12.8904 7.97932 11.1676 10.8277 11.1676C11.1356 11.1676 12.0159 10.3084 12.0323 10.0592C12.0285 9.97778 10.2852 9.28436 9.60553 8.61473C9.30353 8.3172 9.01156 7.99714 8.65778 7.75909C8.42944 6.96033 8.41973 6.11491 8.62964 5.31111C7.6007 5.77968 6.7957 6.52028 6.21389 7.1742C5.81676 6.67125 5.84482 5.01215 5.86745 4.66575C4.9941 5.13081 4.22465 5.9396 3.6187 6.80337C2.59006 8.26122 1.99707 10.1738 1.99707 11.9845C1.99707 17.5158 6.46835 21.9997 12.0002 21.9997C16.9545 21.9997 21.0815 18.4032 21.8869 13.6792C22.128 11.8573 21.9935 9.97004 21.2827 8.26012Z"
  }));
},
    AK = function AK(_ref3050) {
  var _ref3050$color = _ref3050.color,
      C = _ref3050$color === void 0 ? "currentColor" : _ref3050$color,
      _ref3050$size = _ref3050.size,
      e = _ref3050$size === void 0 ? 24 : _ref3050$size,
      l = _ref3050.className,
      i = _objectWithoutProperties(_ref3050, _excluded3050);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M22 12.0001C22 17.523 17.5228 22.0001 12 22.0001C6.47715 22.0001 2 17.523 2 12.0001C2 8.84411 3.24891 6.30485 5.5 4.68754C5.90861 4.39397 6.34156 4.18048 6.81518 3.94694C7.03421 3.83894 7.26195 3.72664 7.5 3.60015V5.50015C7.5 5.50015 10.0984 4.2191 10.45 4.15015C10.4272 4.24797 10.3774 4.41827 10.315 4.63159C10.1194 5.30083 9.8 6.39352 9.8 7.00015C9.8 7.21017 9.81607 7.40022 9.84546 7.56444C10.1315 7.78962 10.3767 8.07806 10.6199 8.36401C10.6749 8.42871 10.7298 8.49328 10.785 8.55696C11.2278 9.06739 12.0415 9.59731 12.5485 9.92748C12.813 10.0997 12.994 10.2176 12.9953 10.25C12.9953 10.5266 12.35 11.5182 11.5 11.5182C9.33 11.5182 8.43403 11.5182 9 13.1485C9.47525 14.5174 10.75 15.2501 12 15.2501C13.5 15.2501 14.9 14.0053 14.9 12.5001C14.9 10.7243 14.0248 9.92669 13.1625 9.14081C12.3252 8.37773 11.5 7.62572 11.5 6C11.5 3.60015 13.5 1.9 15.3 0.850098C15.7808 2.51309 16.9521 3.50972 18.1832 4.55734C20.0246 6.12422 22 7.80514 22 12.0001ZM5.5 7.4C4.45585 8.66765 4 10.3427 4 11.9858C4 16.4133 7.57804 19.9995 12.0029 19.9995C15.9613 19.9995 19.2604 17.1298 19.9119 13.3612C20.0981 11.936 20.0336 10.5316 19.55 9.25L18.5 9.47568C18.5 7.52933 17.331 6.49491 16.1816 5.47774C15.5737 4.93982 14.9712 4.40671 14.55 3.74609C13.6403 4.62161 13.2629 5.25 13.2629 5.99994C13.2629 6.89473 13.8938 7.27188 15.012 7.94037C15.491 8.22672 16.0595 8.56653 16.706 9.02337L15.7106 9.29717C16.4561 10.2592 16.8984 11.3335 16.8984 12.5C16.8984 15.0002 14.6612 17.2165 12.0029 17.25C9.35 17.2827 6.83984 15.0736 6.83984 12.4375C6.83984 11.8 6.99992 10.2 9.1 9.67969C8.87855 9.35 8.31255 8.85 8 8.65C7.9171 8.36 7.8 7.6 7.8 7.6L5.5 8.7V7.4Z"
  }));
},
    kK = function kK(_ref3051) {
  var _ref3051$color = _ref3051.color,
      C = _ref3051$color === void 0 ? "currentColor" : _ref3051$color,
      _ref3051$size = _ref3051.size,
      e = _ref3051$size === void 0 ? 24 : _ref3051$size,
      l = _ref3051.className,
      i = _objectWithoutProperties(_ref3051, _excluded3051);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15.0004 2.84711V4.86312C15.0004 5.25164 15.2255 5.605 15.5775 5.7693L15.9865 5.96013C15.9009 7.36343 15.4285 8.59569 14.7433 9.48646C13.985 10.4723 13.0066 11 12.0004 11C10.9942 11 10.0158 10.4723 9.25751 9.48646C8.57231 8.59569 8.09992 7.36343 8.01438 5.96013L8.42331 5.7693C8.77538 5.605 9.00042 5.25164 9.00042 4.86312V2.84711C9.00042 2.35827 9.35407 1.94216 9.83969 1.88611C11.2822 1.71961 12.7187 1.71961 14.1612 1.88611C14.6468 1.94216 15.0004 2.35827 15.0004 2.84711ZM6.09747 6.85469L2.8504 8.36999C2.10333 8.71862 1.77764 9.60481 2.12113 10.3542L6.59937 20.125C6.84375 20.6581 7.37646 21 7.96297 21H16.0379C16.6244 21 17.1571 20.6581 17.4015 20.125L21.8797 10.3542C22.2232 9.60481 21.8975 8.71862 21.1504 8.36999L17.9034 6.85469C17.6905 8.3225 17.1365 9.65563 16.3286 10.7059C15.4157 11.8926 14.1482 12.7481 12.6811 12.9529L14.189 15.0641C14.3753 15.3248 14.3753 15.6751 14.189 15.9359L12.2039 18.7152C12.1042 18.8548 11.8967 18.8548 11.797 18.7152L9.8118 15.9359C9.62554 15.6751 9.62554 15.3248 9.8118 15.0641L11.3198 12.9529C9.85266 12.7481 8.58516 11.8926 7.67227 10.7059C6.86438 9.65563 6.3103 8.3225 6.09747 6.85469Z"
  }));
},
    PK = function PK(_ref3052) {
  var _ref3052$color = _ref3052.color,
      C = _ref3052$color === void 0 ? "currentColor" : _ref3052$color,
      _ref3052$size = _ref3052.size,
      e = _ref3052$size === void 0 ? 24 : _ref3052$size,
      l = _ref3052.className,
      i = _objectWithoutProperties(_ref3052, _excluded3052);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M9.00032 2.90029C9.00032 2.43746 9.31885 2.03489 9.76902 1.9274C11.1648 1.59611 12.8343 1.60081 14.2306 1.92717C14.6765 2.03317 15.0003 2.44174 15.0003 2.90029V5.03783C15.0003 5.32881 15.1686 5.59353 15.4321 5.71698L21.1261 8.38477C21.8713 8.73392 22.196 9.61827 21.8539 10.3667L17.3806 20.1519C17.1443 20.6689 16.6281 21.0005 16.0597 21.0005H7.94102C7.37261 21.0005 6.85644 20.6689 6.62012 20.1519L2.14688 10.3667C1.80474 9.61827 2.12948 8.73393 2.87468 8.38477L8.56853 5.71699C8.83202 5.59353 9.00032 5.32882 9.00032 5.03784V2.90029ZM11.0003 3.78008V5.03763C11.0003 6.10455 10.3832 7.07518 9.41707 7.52785L8.43616 7.98744C9.14194 9.88937 10.5704 11 12.0003 11C13.4303 11 14.8587 9.88937 15.5645 7.98745L14.5836 7.52785C13.6174 7.07518 13.0003 6.10455 13.0003 5.03762V3.78007C12.7366 3.76097 12.4041 3.74658 12.0003 3.74658C11.5965 3.74658 11.264 3.76097 11.0003 3.78008ZM11.3191 12.9536C9.16718 12.6579 7.47502 10.9785 6.62299 8.83698L4.17175 9.98547L8.2928 19.0003H15.7079L19.829 9.98548L17.3777 8.83697C16.5256 10.9785 14.8335 12.6579 12.6815 12.9536L14.189 15.064C14.3752 15.3248 14.3752 15.6751 14.189 15.9359L12.2038 18.7151C12.1041 18.8547 11.8966 18.8547 11.7969 18.7151L9.81171 15.9359C9.62544 15.6751 9.62544 15.3248 9.81171 15.064L11.3191 12.9536Z"
  }));
},
    DK = function DK(_ref3053) {
  var _ref3053$color = _ref3053.color,
      C = _ref3053$color === void 0 ? "currentColor" : _ref3053$color,
      _ref3053$size = _ref3053.size,
      e = _ref3053$size === void 0 ? 24 : _ref3053$size,
      l = _ref3053.className,
      i = _objectWithoutProperties(_ref3053, _excluded3053);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M6 4C6 3.44772 6.44772 3 7 3H21C21.5523 3 22 3.44772 22 4V16C22 16.5523 21.5523 17 21 17H18V20C18 20.5523 17.5523 21 17 21H3C2.44772 21 2 20.5523 2 20V8C2 7.44772 2.44772 7 3 7H6V4ZM8 7H17C17.5523 7 18 7.44772 18 8V15H20V5H8V7ZM16 15.7394V9H4V18.6321L11.4911 11.6404L16 15.7394ZM7 13.5C7.82843 13.5 8.5 12.8284 8.5 12C8.5 11.1716 7.82843 10.5 7 10.5C6.17157 10.5 5.5 11.1716 5.5 12C5.5 12.8284 6.17157 13.5 7 13.5Z"
  }));
},
    yK = function yK(_ref3054) {
  var _ref3054$color = _ref3054.color,
      C = _ref3054$color === void 0 ? "currentColor" : _ref3054$color,
      _ref3054$size = _ref3054.size,
      e = _ref3054$size === void 0 ? 24 : _ref3054$size,
      l = _ref3054.className,
      i = _objectWithoutProperties(_ref3054, _excluded3054);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M7 3C6.44772 3 6 3.44772 6 4V7H3C2.44772 7 2 7.44772 2 8V20C2 20.5523 2.44772 21 3 21H17C17.5523 21 18 20.5523 18 20V17H21C21.5523 17 22 16.5523 22 16V4C22 3.44772 21.5523 3 21 3H7ZM17 7H8V5H20V15H18V8C18 7.44772 17.5523 7 17 7ZM16 9V15.7394L11.4911 11.6404L4 18.6321V9H16ZM11.5089 14.3596L16 18.4424V19H6.53702L11.5089 14.3596ZM7 13.5C7.82843 13.5 8.5 12.8284 8.5 12C8.5 11.1716 7.82843 10.5 7 10.5C6.17157 10.5 5.5 11.1716 5.5 12C5.5 12.8284 6.17157 13.5 7 13.5Z"
  }));
},
    bK = function bK(_ref3055) {
  var _ref3055$color = _ref3055.color,
      C = _ref3055$color === void 0 ? "currentColor" : _ref3055$color,
      _ref3055$size = _ref3055.size,
      e = _ref3055$size === void 0 ? 24 : _ref3055$size,
      l = _ref3055.className,
      i = _objectWithoutProperties(_ref3055, _excluded3055);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19.5859 21L21.1925 22.6067L22.6068 21.1925L2.80777 1.39348L1.39355 2.80769L2.11974 3.53387C2.04627 3.67306 2.00468 3.83167 2.00468 4V7H5.58586L9.58586 11H2.00468V20C2.00468 20.5523 2.4524 21 3.00468 21H19.5859ZM22.0047 11V17.7622L15.2425 11H22.0047ZM22.0047 7H11.2425L7.24251 3H21.0047C21.557 3 22.0047 3.44771 22.0047 4V7Z"
  }));
},
    TK = function TK(_ref3056) {
  var _ref3056$color = _ref3056.color,
      C = _ref3056$color === void 0 ? "currentColor" : _ref3056$color,
      _ref3056$size = _ref3056.size,
      e = _ref3056$size === void 0 ? 24 : _ref3056$size,
      l = _ref3056.className,
      i = _objectWithoutProperties(_ref3056, _excluded3056);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M19.5859 21L21.1925 22.6067L22.6068 21.1925L2.80777 1.39348L1.39355 2.80769L2.11974 3.53387C2.04627 3.67306 2.00468 3.83167 2.00468 4V20C2.00468 20.5523 2.4524 21 3.00468 21H19.5859ZM17.5859 19H4.00468V12H10.5859L17.5859 19ZM6.58586 8H4.00468V5.41882L6.58586 8ZM22.0047 4V17.7622L20.0047 15.7622V12H16.2425L12.2425 8H20.0047V5H9.24251L7.24251 3H21.0047C21.557 3 22.0047 3.44771 22.0047 4Z"
  }));
},
    UK = function UK(_ref3057) {
  var _ref3057$color = _ref3057.color,
      C = _ref3057$color === void 0 ? "currentColor" : _ref3057$color,
      _ref3057$size = _ref3057.size,
      e = _ref3057$size === void 0 ? 24 : _ref3057$size,
      l = _ref3057.className,
      i = _objectWithoutProperties(_ref3057, _excluded3057);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15 3V5H13V6.04938C18.0533 6.5511 22 10.8147 22 16H2C2 10.8147 5.94668 6.5511 11 6.04938V5H9V3H15ZM23 20V18H1V20H23Z"
  }));
},
    GK = function GK(_ref3058) {
  var _ref3058$color = _ref3058.color,
      C = _ref3058$color === void 0 ? "currentColor" : _ref3058$color,
      _ref3058$size = _ref3058.size,
      e = _ref3058$size === void 0 ? 24 : _ref3058$size,
      l = _ref3058.className,
      i = _objectWithoutProperties(_ref3058, _excluded3058);

  return t.createElement("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: C
  }, i), {}, {
    className: "remixicon " + (l || "")
  }), t.createElement("path", {
    d: "M15 3H9V5H11V6.04938C5.94668 6.5511 2 10.8147 2 16V17H22V16C22 10.8147 18.0533 6.5511 13 6.04938V5H15V3ZM12 8C16.0796 8 19.446 11.0537 19.9381 15H4.06189C4.55399 11.0537 7.92038 8 12 8ZM23 20V18H1V20H23Z"
  }));
};

export { s as Ri24HoursFill, r as Ri24HoursLine, c as Ri4kFill, o as Ri4kLine, a as RiAB, iK as RiAccessibilityFill, sK as RiAccessibilityLine, bI as RiAccountBox2Fill, TI as RiAccountBox2Line, n as RiAccountBoxFill, m as RiAccountBoxLine, UI as RiAccountCircle2Fill, GI as RiAccountCircle2Line, w as RiAccountCircleFill, L as RiAccountCircleLine, h as RiAccountPinBoxFill, H as RiAccountPinBoxLine, V as RiAccountPinCircleFill, g as RiAccountPinCircleLine, M as RiAddBoxFill, Z as RiAddBoxLine, x as RiAddCircleFill, v as RiAddCircleLine, d as RiAddFill, OT as RiAddLargeFill, KT as RiAddLargeLine, p as RiAddLine, E as RiAdminFill, N as RiAdminLine, u as RiAdvertisementFill, B as RiAdvertisementLine, QT as RiAedElectrodesFill, qT as RiAedElectrodesLine, jT as RiAedFill, XT as RiAedLine, vk as RiAiGenerate, vO as RiAiGenerate2, dO as RiAiGenerateText, f as RiAirplayFill, R as RiAirplayLine, rK as RiAlarmAddFill, cK as RiAlarmAddLine, z as RiAlarmFill, F as RiAlarmLine, II as RiAlarmSnoozeFill, WI as RiAlarmSnoozeLine, S as RiAlarmWarningFill, A as RiAlarmWarningLine, k as RiAlbumFill, P as RiAlbumLine, D as RiAlertFill, y as RiAlertLine, JT as RiAlibabaCloudFill, YT as RiAlibabaCloudLine, b as RiAliensFill, T as RiAliensLine, U as RiAlignBottom, G as RiAlignCenter, _T as RiAlignItemBottomFill, $T as RiAlignItemBottomLine, eU as RiAlignItemHorizontalCenterFill, tU as RiAlignItemHorizontalCenterLine, CU as RiAlignItemLeftFill, lU as RiAlignItemLeftLine, iU as RiAlignItemRightFill, sU as RiAlignItemRightLine, rU as RiAlignItemTopFill, cU as RiAlignItemTopLine, oU as RiAlignItemVerticalCenterFill, aU as RiAlignItemVerticalCenterLine, I as RiAlignJustify, W as RiAlignLeft, O as RiAlignRight, K as RiAlignTop, Q as RiAlignVertically, q as RiAlipayFill, j as RiAlipayLine, X as RiAmazonFill, J as RiAmazonLine, Y as RiAnchorFill, _ as RiAnchorLine, $ as RiAncientGateFill, e1 as RiAncientGateLine, t1 as RiAncientPavilionFill, C1 as RiAncientPavilionLine, l1 as RiAndroidFill, i1 as RiAndroidLine, s1 as RiAngularjsFill, r1 as RiAngularjsLine, pO as RiAnthropicFill, EO as RiAnthropicLine, c1 as RiAnticlockwise2Fill, o1 as RiAnticlockwise2Line, a1 as RiAnticlockwiseFill, n1 as RiAnticlockwiseLine, m1 as RiAppStoreFill, w1 as RiAppStoreLine, L1 as RiAppleFill, h1 as RiAppleLine, nU as RiApps2AddFill, mU as RiApps2AddLine, NO as RiApps2AiFill, uO as RiApps2AiLine, H1 as RiApps2Fill, V1 as RiApps2Line, g1 as RiAppsFill, M1 as RiAppsLine, qk as RiArchive2Fill, jk as RiArchive2Line, Z1 as RiArchiveDrawerFill, x1 as RiArchiveDrawerLine, v1 as RiArchiveFill, d1 as RiArchiveLine, hy as RiArchiveStackFill, Hy as RiArchiveStackLine, cD as RiArmchairFill, oD as RiArmchairLine, OI as RiArrowDownBoxFill, KI as RiArrowDownBoxLine, p1 as RiArrowDownCircleFill, E1 as RiArrowDownCircleLine, mF as RiArrowDownDoubleFill, wF as RiArrowDownDoubleLine, N1 as RiArrowDownFill, u1 as RiArrowDownLine, oK as RiArrowDownLongFill, aK as RiArrowDownLongLine, B1 as RiArrowDownSFill, f1 as RiArrowDownSLine, wT as RiArrowDownWideFill, LT as RiArrowDownWideLine, R1 as RiArrowDropDownFill, z1 as RiArrowDropDownLine, F1 as RiArrowDropLeftFill, S1 as RiArrowDropLeftLine, A1 as RiArrowDropRightFill, k1 as RiArrowDropRightLine, P1 as RiArrowDropUpFill, D1 as RiArrowDropUpLine, y1 as RiArrowGoBackFill, b1 as RiArrowGoBackLine, T1 as RiArrowGoForwardFill, U1 as RiArrowGoForwardLine, QI as RiArrowLeftBoxFill, qI as RiArrowLeftBoxLine, G1 as RiArrowLeftCircleFill, I1 as RiArrowLeftCircleLine, LF as RiArrowLeftDoubleFill, hF as RiArrowLeftDoubleLine, jI as RiArrowLeftDownBoxFill, XI as RiArrowLeftDownBoxLine, W1 as RiArrowLeftDownFill, O1 as RiArrowLeftDownLine, nK as RiArrowLeftDownLongFill, mK as RiArrowLeftDownLongLine, K1 as RiArrowLeftFill, Q1 as RiArrowLeftLine, wK as RiArrowLeftLongFill, LK as RiArrowLeftLongLine, q1 as RiArrowLeftRightFill, j1 as RiArrowLeftRightLine, X1 as RiArrowLeftSFill, J1 as RiArrowLeftSLine, JI as RiArrowLeftUpBoxFill, YI as RiArrowLeftUpBoxLine, Y1 as RiArrowLeftUpFill, _1 as RiArrowLeftUpLine, hK as RiArrowLeftUpLongFill, HK as RiArrowLeftUpLongLine, hT as RiArrowLeftWideFill, HT as RiArrowLeftWideLine, _I as RiArrowRightBoxFill, $I as RiArrowRightBoxLine, $1 as RiArrowRightCircleFill, e2 as RiArrowRightCircleLine, HF as RiArrowRightDoubleFill, VF as RiArrowRightDoubleLine, eW as RiArrowRightDownBoxFill, tW as RiArrowRightDownBoxLine, t2 as RiArrowRightDownFill, C2 as RiArrowRightDownLine, VK as RiArrowRightDownLongFill, gK as RiArrowRightDownLongLine, l2 as RiArrowRightFill, i2 as RiArrowRightLine, MK as RiArrowRightLongFill, ZK as RiArrowRightLongLine, s2 as RiArrowRightSFill, r2 as RiArrowRightSLine, CW as RiArrowRightUpBoxFill, lW as RiArrowRightUpBoxLine, c2 as RiArrowRightUpFill, o2 as RiArrowRightUpLine, xK as RiArrowRightUpLongFill, vK as RiArrowRightUpLongLine, VT as RiArrowRightWideFill, gT as RiArrowRightWideLine, gF as RiArrowTurnBackFill, MF as RiArrowTurnBackLine, ZF as RiArrowTurnForwardFill, xF as RiArrowTurnForwardLine, iW as RiArrowUpBoxFill, sW as RiArrowUpBoxLine, a2 as RiArrowUpCircleFill, n2 as RiArrowUpCircleLine, vF as RiArrowUpDoubleFill, dF as RiArrowUpDoubleLine, m2 as RiArrowUpDownFill, w2 as RiArrowUpDownLine, L2 as RiArrowUpFill, h2 as RiArrowUpLine, dK as RiArrowUpLongFill, pK as RiArrowUpLongLine, H2 as RiArrowUpSFill, V2 as RiArrowUpSLine, MT as RiArrowUpWideFill, ZT as RiArrowUpWideLine, g2 as RiArtboard2Fill, M2 as RiArtboard2Line, Z2 as RiArtboardFill, x2 as RiArtboardLine, v2 as RiArticleFill, d2 as RiArticleLine, p2 as RiAspectRatioFill, E2 as RiAspectRatioLine, N2 as RiAsterisk, u2 as RiAtFill, B2 as RiAtLine, f2 as RiAttachment2, R2 as RiAttachmentFill, z2 as RiAttachmentLine, F2 as RiAuctionFill, S2 as RiAuctionLine, A2 as RiAwardFill, k2 as RiAwardLine, P2 as RiBaiduFill, D2 as RiBaiduLine, y2 as RiBallPenFill, b2 as RiBallPenLine, T2 as RiBankCard2Fill, U2 as RiBankCard2Line, G2 as RiBankCardFill, I2 as RiBankCardLine, W2 as RiBankFill, O2 as RiBankLine, K2 as RiBarChart2Fill, Q2 as RiBarChart2Line, rW as RiBarChartBoxAiFill, cW as RiBarChartBoxAiLine, q2 as RiBarChartBoxFill, j2 as RiBarChartBoxLine, X2 as RiBarChartFill, J2 as RiBarChartGroupedFill, Y2 as RiBarChartGroupedLine, _2 as RiBarChartHorizontalFill, $2 as RiBarChartHorizontalLine, e0 as RiBarChartLine, t0 as RiBarcodeBoxFill, C0 as RiBarcodeBoxLine, l0 as RiBarcodeFill, i0 as RiBarcodeLine, pF as RiBardFill, EF as RiBardLine, s0 as RiBarricadeFill, r0 as RiBarricadeLine, c0 as RiBaseStationFill, o0 as RiBaseStationLine, a0 as RiBasketballFill, n0 as RiBasketballLine, m0 as RiBattery2ChargeFill, w0 as RiBattery2ChargeLine, L0 as RiBattery2Fill, h0 as RiBattery2Line, H0 as RiBatteryChargeFill, V0 as RiBatteryChargeLine, g0 as RiBatteryFill, M0 as RiBatteryLine, Z0 as RiBatteryLowFill, x0 as RiBatteryLowLine, v0 as RiBatterySaverFill, d0 as RiBatterySaverLine, p0 as RiBatteryShareFill, E0 as RiBatteryShareLine, N0 as RiBearSmileFill, u0 as RiBearSmileLine, MP as RiBeerFill, ZP as RiBeerLine, B0 as RiBehanceFill, f0 as RiBehanceLine, R0 as RiBellFill, z0 as RiBellLine, F0 as RiBikeFill, S0 as RiBikeLine, A0 as RiBilibiliFill, k0 as RiBilibiliLine, P0 as RiBillFill, D0 as RiBillLine, y0 as RiBilliardsFill, b0 as RiBilliardsLine, T0 as RiBitCoinFill, U0 as RiBitCoinLine, G0 as RiBlazeFill, I0 as RiBlazeLine, sk as RiBlenderFill, rk as RiBlenderLine, Ab as RiBloggerFill, kb as RiBloggerLine, xT as RiBlueskyFill, vT as RiBlueskyLine, W0 as RiBluetoothConnectFill, O0 as RiBluetoothConnectLine, K0 as RiBluetoothFill, Q0 as RiBluetoothLine, q0 as RiBlurOffFill, j0 as RiBlurOffLine, aD as RiBnbFill, nD as RiBnbLine, X0 as RiBodyScanFill, J0 as RiBodyScanLine, Y0 as RiBold, _0 as RiBook2Fill, $0 as RiBook2Line, e4 as RiBook3Fill, t4 as RiBook3Line, C4 as RiBookFill, l4 as RiBookLine, i4 as RiBookMarkedFill, s4 as RiBookMarkedLine, r4 as RiBookOpenFill, c4 as RiBookOpenLine, o4 as RiBookReadFill, a4 as RiBookReadLine, JG as RiBookShelfFill, YG as RiBookShelfLine, n4 as RiBookletFill, m4 as RiBookletLine, w4 as RiBookmark2Fill, L4 as RiBookmark2Line, h4 as RiBookmark3Fill, H4 as RiBookmark3Line, V4 as RiBookmarkFill, g4 as RiBookmarkLine, NF as RiBootstrapFill, uF as RiBootstrapLine, Vy as RiBowlFill, gy as RiBowlLine, BF as RiBox1Fill, fF as RiBox1Line, RF as RiBox2Fill, zF as RiBox2Line, FF as RiBox3Fill, SF as RiBox3Line, M4 as RiBoxingFill, Z4 as RiBoxingLine, x4 as RiBracesFill, v4 as RiBracesLine, d4 as RiBracketsFill, p4 as RiBracketsLine, _G as RiBrain2Fill, $G as RiBrain2Line, AF as RiBrainFill, kF as RiBrainLine, mD as RiBreadFill, wD as RiBreadLine, E4 as RiBriefcase2Fill, N4 as RiBriefcase2Line, u4 as RiBriefcase3Fill, B4 as RiBriefcase3Line, f4 as RiBriefcase4Fill, R4 as RiBriefcase4Line, z4 as RiBriefcase5Fill, F4 as RiBriefcase5Line, S4 as RiBriefcaseFill, A4 as RiBriefcaseLine, k4 as RiBringForward, P4 as RiBringToFront, D4 as RiBroadcastFill, y4 as RiBroadcastLine, b4 as RiBrush2Fill, T4 as RiBrush2Line, U4 as RiBrush3Fill, G4 as RiBrush3Line, I4 as RiBrush4Fill, W4 as RiBrush4Line, oW as RiBrushAiFill, aW as RiBrushAiLine, O4 as RiBrushFill, K4 as RiBrushLine, LD as RiBtcFill, hD as RiBtcLine, Q4 as RiBubbleChartFill, q4 as RiBubbleChartLine, j4 as RiBug2Fill, X4 as RiBug2Line, J4 as RiBugFill, Y4 as RiBugLine, _4 as RiBuilding2Fill, $4 as RiBuilding2Line, e5 as RiBuilding3Fill, t5 as RiBuilding3Line, C5 as RiBuilding4Fill, l5 as RiBuilding4Line, i5 as RiBuildingFill, s5 as RiBuildingLine, r5 as RiBus2Fill, c5 as RiBus2Line, o5 as RiBusFill, a5 as RiBusLine, n5 as RiBusWifiFill, m5 as RiBusWifiLine, w5 as RiCactusFill, L5 as RiCactusLine, h5 as RiCake2Fill, H5 as RiCake2Line, V5 as RiCake3Fill, g5 as RiCake3Line, M5 as RiCakeFill, Z5 as RiCakeLine, x5 as RiCalculatorFill, v5 as RiCalculatorLine, d5 as RiCalendar2Fill, p5 as RiCalendar2Line, E5 as RiCalendarCheckFill, N5 as RiCalendarCheckLine, dk as RiCalendarCloseFill, pk as RiCalendarCloseLine, u5 as RiCalendarEventFill, B5 as RiCalendarEventLine, f5 as RiCalendarFill, R5 as RiCalendarLine, HD as RiCalendarScheduleFill, VD as RiCalendarScheduleLine, z5 as RiCalendarTodoFill, F5 as RiCalendarTodoLine, My as RiCalendarView, S5 as RiCamera2Fill, A5 as RiCamera2Line, k5 as RiCamera3Fill, P5 as RiCamera3Line, nW as RiCameraAiFill, mW as RiCameraAiLine, D5 as RiCameraFill, BO as RiCameraLensAiFill, fO as RiCameraLensAiLine, y5 as RiCameraLensFill, b5 as RiCameraLensLine, T5 as RiCameraLine, U5 as RiCameraOffFill, G5 as RiCameraOffLine, I5 as RiCameraSwitchFill, W5 as RiCameraSwitchLine, PF as RiCandleFill, DF as RiCandleLine, O5 as RiCapsuleFill, K5 as RiCapsuleLine, Q5 as RiCarFill, q5 as RiCarLine, j5 as RiCarWashingFill, X5 as RiCarWashingLine, J5 as RiCaravanFill, Y5 as RiCaravanLine, Zy as RiCarouselView, yF as RiCashFill, bF as RiCashLine, _5 as RiCastFill, $5 as RiCastLine, e9 as RiCellphoneFill, t9 as RiCellphoneLine, C9 as RiCelsiusFill, l9 as RiCelsiusLine, i9 as RiCentosFill, s9 as RiCentosLine, r9 as RiCharacterRecognitionFill, c9 as RiCharacterRecognitionLine, o9 as RiChargingPile2Fill, a9 as RiChargingPile2Line, n9 as RiChargingPileFill, m9 as RiChargingPileLine, w9 as RiChat1Fill, L9 as RiChat1Line, h9 as RiChat2Fill, H9 as RiChat2Line, V9 as RiChat3Fill, g9 as RiChat3Line, M9 as RiChat4Fill, Z9 as RiChat4Line, wW as RiChatAiFill, LW as RiChatAiLine, x9 as RiChatCheckFill, v9 as RiChatCheckLine, d9 as RiChatDeleteFill, p9 as RiChatDeleteLine, E9 as RiChatDownloadFill, N9 as RiChatDownloadLine, u9 as RiChatFollowUpFill, B9 as RiChatFollowUpLine, f9 as RiChatForwardFill, R9 as RiChatForwardLine, z9 as RiChatHeartFill, F9 as RiChatHeartLine, S9 as RiChatHistoryFill, A9 as RiChatHistoryLine, k9 as RiChatNewFill, P9 as RiChatNewLine, D9 as RiChatOffFill, y9 as RiChatOffLine, b9 as RiChatPollFill, T9 as RiChatPollLine, U9 as RiChatPrivateFill, G9 as RiChatPrivateLine, I9 as RiChatQuoteFill, W9 as RiChatQuoteLine, eI as RiChatSearchFill, tI as RiChatSearchLine, O9 as RiChatSettingsFill, K9 as RiChatSettingsLine, Q9 as RiChatSmile2Fill, q9 as RiChatSmile2Line, j9 as RiChatSmile3Fill, X9 as RiChatSmile3Line, hW as RiChatSmileAiFill, HW as RiChatSmileAiLine, J9 as RiChatSmileFill, Y9 as RiChatSmileLine, Pb as RiChatThreadFill, Db as RiChatThreadLine, CI as RiChatUnreadFill, lI as RiChatUnreadLine, _9 as RiChatUploadFill, $9 as RiChatUploadLine, VW as RiChatVoiceAiFill, gW as RiChatVoiceAiLine, e7 as RiChatVoiceFill, t7 as RiChatVoiceLine, C7 as RiCheckDoubleFill, l7 as RiCheckDoubleLine, i7 as RiCheckFill, s7 as RiCheckLine, r7 as RiCheckboxBlankCircleFill, c7 as RiCheckboxBlankCircleLine, o7 as RiCheckboxBlankFill, a7 as RiCheckboxBlankLine, n7 as RiCheckboxCircleFill, m7 as RiCheckboxCircleLine, w7 as RiCheckboxFill, L7 as RiCheckboxIndeterminateFill, h7 as RiCheckboxIndeterminateLine, H7 as RiCheckboxLine, V7 as RiCheckboxMultipleBlankFill, g7 as RiCheckboxMultipleBlankLine, M7 as RiCheckboxMultipleFill, Z7 as RiCheckboxMultipleLine, EK as RiChessFill, NK as RiChessLine, x7 as RiChinaRailwayFill, v7 as RiChinaRailwayLine, d7 as RiChromeFill, p7 as RiChromeLine, xP as RiCircleFill, vP as RiCircleLine, RO as RiClapperboardAiFill, zO as RiClapperboardAiLine, E7 as RiClapperboardFill, N7 as RiClapperboardLine, FO as RiClaudeFill, SO as RiClaudeLine, u7 as RiClipboardFill, B7 as RiClipboardLine, f7 as RiClockwise2Fill, R7 as RiClockwise2Line, z7 as RiClockwiseFill, F7 as RiClockwiseLine, S7 as RiCloseCircleFill, A7 as RiCloseCircleLine, k7 as RiCloseFill, wU as RiCloseLargeFill, LU as RiCloseLargeLine, P7 as RiCloseLine, AO as RiClosedCaptioningAiFill, kO as RiClosedCaptioningAiLine, D7 as RiClosedCaptioningFill, y7 as RiClosedCaptioningLine, b7 as RiCloudFill, T7 as RiCloudLine, U7 as RiCloudOffFill, G7 as RiCloudOffLine, I7 as RiCloudWindyFill, W7 as RiCloudWindyLine, O7 as RiCloudy2Fill, K7 as RiCloudy2Line, Q7 as RiCloudyFill, q7 as RiCloudyLine, MW as RiCodeAiFill, ZW as RiCodeAiLine, xy as RiCodeBlock, j7 as RiCodeBoxFill, X7 as RiCodeBoxLine, J7 as RiCodeFill, Y7 as RiCodeLine, _7 as RiCodeSFill, $7 as RiCodeSLine, e3 as RiCodeSSlashFill, t3 as RiCodeSSlashLine, C3 as RiCodeView, l3 as RiCodepenFill, i3 as RiCodepenLine, s3 as RiCoinFill, r3 as RiCoinLine, c3 as RiCoinsFill, o3 as RiCoinsLine, a3 as RiCollageFill, n3 as RiCollageLine, hU as RiCollapseDiagonal2Fill, HU as RiCollapseDiagonal2Line, VU as RiCollapseDiagonalFill, gU as RiCollapseDiagonalLine, iI as RiCollapseHorizontalFill, sI as RiCollapseHorizontalLine, rI as RiCollapseVerticalFill, cI as RiCollapseVerticalLine, xW as RiColorFilterAiFill, vW as RiColorFilterAiLine, vy as RiColorFilterFill, dy as RiColorFilterLine, m3 as RiCommandFill, w3 as RiCommandLine, L3 as RiCommunityFill, h3 as RiCommunityLine, H3 as RiCompass2Fill, V3 as RiCompass2Line, g3 as RiCompass3Fill, M3 as RiCompass3Line, Z3 as RiCompass4Fill, x3 as RiCompass4Line, v3 as RiCompassDiscoverFill, d3 as RiCompassDiscoverLine, p3 as RiCompassFill, E3 as RiCompassLine, N3 as RiCompasses2Fill, u3 as RiCompasses2Line, B3 as RiCompassesFill, f3 as RiCompassesLine, R3 as RiComputerFill, z3 as RiComputerLine, F3 as RiContactsBook2Fill, S3 as RiContactsBook2Line, py as RiContactsBook3Fill, Ey as RiContactsBook3Line, A3 as RiContactsBookFill, k3 as RiContactsBookLine, P3 as RiContactsBookUploadFill, D3 as RiContactsBookUploadLine, y3 as RiContactsFill, b3 as RiContactsLine, Ny as RiContractFill, TF as RiContractLeftFill, UF as RiContractLeftLine, GF as RiContractLeftRightFill, IF as RiContractLeftRightLine, uy as RiContractLine, WF as RiContractRightFill, OF as RiContractRightLine, KF as RiContractUpDownFill, QF as RiContractUpDownLine, T3 as RiContrast2Fill, U3 as RiContrast2Line, G3 as RiContrastDrop2Fill, I3 as RiContrastDrop2Line, W3 as RiContrastDropFill, O3 as RiContrastDropLine, K3 as RiContrastFill, Q3 as RiContrastLine, qF as RiCopilotFill, jF as RiCopilotLine, q3 as RiCopperCoinFill, j3 as RiCopperCoinLine, X3 as RiCopperDiamondFill, J3 as RiCopperDiamondLine, Y3 as RiCopyleftFill, _3 as RiCopyleftLine, $3 as RiCopyrightFill, e8 as RiCopyrightLine, t8 as RiCoreosFill, C8 as RiCoreosLine, XF as RiCornerDownLeftFill, JF as RiCornerDownLeftLine, YF as RiCornerDownRightFill, _F as RiCornerDownRightLine, $F as RiCornerLeftDownFill, eS as RiCornerLeftDownLine, tS as RiCornerLeftUpFill, CS as RiCornerLeftUpLine, lS as RiCornerRightDownFill, iS as RiCornerRightDownLine, sS as RiCornerRightUpFill, rS as RiCornerRightUpLine, cS as RiCornerUpLeftDoubleFill, oS as RiCornerUpLeftDoubleLine, aS as RiCornerUpLeftFill, nS as RiCornerUpLeftLine, mS as RiCornerUpRightDoubleFill, wS as RiCornerUpRightDoubleLine, LS as RiCornerUpRightFill, hS as RiCornerUpRightLine, l8 as RiCoupon2Fill, i8 as RiCoupon2Line, s8 as RiCoupon3Fill, r8 as RiCoupon3Line, c8 as RiCoupon4Fill, o8 as RiCoupon4Line, a8 as RiCoupon5Fill, n8 as RiCoupon5Line, m8 as RiCouponFill, w8 as RiCouponLine, L8 as RiCpuFill, h8 as RiCpuLine, H8 as RiCreativeCommonsByFill, V8 as RiCreativeCommonsByLine, g8 as RiCreativeCommonsFill, M8 as RiCreativeCommonsLine, Z8 as RiCreativeCommonsNcFill, x8 as RiCreativeCommonsNcLine, v8 as RiCreativeCommonsNdFill, d8 as RiCreativeCommonsNdLine, p8 as RiCreativeCommonsSaFill, E8 as RiCreativeCommonsSaLine, N8 as RiCreativeCommonsZeroFill, u8 as RiCreativeCommonsZeroLine, B8 as RiCriminalFill, f8 as RiCriminalLine, R8 as RiCrop2Fill, z8 as RiCrop2Line, F8 as RiCropFill, S8 as RiCropLine, HS as RiCrossFill, VS as RiCrossLine, sP as RiCrosshair2Fill, rP as RiCrosshair2Line, cP as RiCrosshairFill, oP as RiCrosshairLine, A8 as RiCss3Fill, k8 as RiCss3Line, P8 as RiCupFill, D8 as RiCupLine, y8 as RiCurrencyFill, b8 as RiCurrencyLine, T8 as RiCursorFill, U8 as RiCursorLine, dW as RiCustomSize, G8 as RiCustomerService2Fill, I8 as RiCustomerService2Line, W8 as RiCustomerServiceFill, O8 as RiCustomerServiceLine, K8 as RiDashboard2Fill, Q8 as RiDashboard2Line, q8 as RiDashboard3Fill, j8 as RiDashboard3Line, X8 as RiDashboardFill, MU as RiDashboardHorizontalFill, ZU as RiDashboardHorizontalLine, J8 as RiDashboardLine, Y8 as RiDatabase2Fill, _8 as RiDatabase2Line, $8 as RiDatabaseFill, e6 as RiDatabaseLine, t6 as RiDeleteBack2Fill, C6 as RiDeleteBack2Line, l6 as RiDeleteBackFill, i6 as RiDeleteBackLine, s6 as RiDeleteBin2Fill, r6 as RiDeleteBin2Line, c6 as RiDeleteBin3Fill, o6 as RiDeleteBin3Line, a6 as RiDeleteBin4Fill, n6 as RiDeleteBin4Line, m6 as RiDeleteBin5Fill, w6 as RiDeleteBin5Line, L6 as RiDeleteBin6Fill, h6 as RiDeleteBin6Line, H6 as RiDeleteBin7Fill, V6 as RiDeleteBin7Line, g6 as RiDeleteBinFill, M6 as RiDeleteBinLine, Z6 as RiDeleteColumn, x6 as RiDeleteRow, v6 as RiDeviceFill, d6 as RiDeviceLine, p6 as RiDeviceRecoverFill, E6 as RiDeviceRecoverLine, uK as RiDiamondFill, BK as RiDiamondLine, fK as RiDiamondRingFill, RK as RiDiamondRingLine, gD as RiDice1Fill, MD as RiDice1Line, ZD as RiDice2Fill, xD as RiDice2Line, vD as RiDice3Fill, dD as RiDice3Line, pD as RiDice4Fill, ED as RiDice4Line, ND as RiDice5Fill, uD as RiDice5Line, BD as RiDice6Fill, fD as RiDice6Line, RD as RiDiceFill, zD as RiDiceLine, N6 as RiDingdingFill, u6 as RiDingdingLine, B6 as RiDirectionFill, f6 as RiDirectionLine, R6 as RiDiscFill, z6 as RiDiscLine, F6 as RiDiscordFill, S6 as RiDiscordLine, yb as RiDiscountPercentFill, bb as RiDiscountPercentLine, A6 as RiDiscussFill, k6 as RiDiscussLine, P6 as RiDislikeFill, D6 as RiDislikeLine, y6 as RiDisqusFill, b6 as RiDisqusLine, T6 as RiDivideFill, U6 as RiDivideLine, oI as RiDnaFill, aI as RiDnaLine, G6 as RiDonutChartFill, I6 as RiDonutChartLine, W6 as RiDoorClosedFill, O6 as RiDoorClosedLine, K6 as RiDoorFill, Q6 as RiDoorLine, q6 as RiDoorLockBoxFill, j6 as RiDoorLockBoxLine, X6 as RiDoorLockFill, J6 as RiDoorLockLine, Y6 as RiDoorOpenFill, _6 as RiDoorOpenLine, $6 as RiDossierFill, ee as RiDossierLine, te as RiDoubanFill, Ce as RiDoubanLine, le as RiDoubleQuotesL, ie as RiDoubleQuotesR, se as RiDownload2Fill, re as RiDownload2Line, ce as RiDownloadCloud2Fill, oe as RiDownloadCloud2Line, ae as RiDownloadCloudFill, ne as RiDownloadCloudLine, me as RiDownloadFill, we as RiDownloadLine, Le as RiDraftFill, he as RiDraftLine, He as RiDragDropFill, Ve as RiDragDropLine, ge as RiDragMove2Fill, Me as RiDragMove2Line, Ze as RiDragMoveFill, xe as RiDragMoveLine, Ek as RiDraggable, ve as RiDribbbleFill, de as RiDribbbleLine, By as RiDrinks2Fill, fy as RiDrinks2Line, FD as RiDrinksFill, SD as RiDrinksLine, pe as RiDriveFill, Ee as RiDriveLine, Ne as RiDrizzleFill, ue as RiDrizzleLine, Be as RiDropFill, fe as RiDropLine, Re as RiDropboxFill, ze as RiDropboxLine, dP as RiDropdownList, nI as RiDropperFill, mI as RiDropperLine, Fe as RiDualSim1Fill, Se as RiDualSim1Line, Ae as RiDualSim2Fill, ke as RiDualSim2Line, Pe as RiDvFill, De as RiDvLine, PO as RiDvdAiFill, DO as RiDvdAiLine, ye as RiDvdFill, be as RiDvdLine, Te as RiEBike2Fill, Ue as RiEBike2Line, Ge as RiEBikeFill, Ie as RiEBikeLine, We as RiEarthFill, Oe as RiEarthLine, Ke as RiEarthquakeFill, Qe as RiEarthquakeLine, qe as RiEdgeFill, je as RiEdgeLine, gS as RiEdgeNewFill, MS as RiEdgeNewLine, Xe as RiEdit2Fill, Je as RiEdit2Line, Ye as RiEditBoxFill, _e as RiEditBoxLine, $e as RiEditCircleFill, et as RiEditCircleLine, tt as RiEditFill, Ct as RiEditLine, lt as RiEjectFill, it as RiEjectLine, ck as RiEmojiStickerFill, ok as RiEmojiStickerLine, st as RiEmotion2Fill, rt as RiEmotion2Line, ct as RiEmotionFill, ot as RiEmotionHappyFill, at as RiEmotionHappyLine, nt as RiEmotionLaughFill, mt as RiEmotionLaughLine, wt as RiEmotionLine, Lt as RiEmotionNormalFill, ht as RiEmotionNormalLine, Ht as RiEmotionSadFill, Vt as RiEmotionSadLine, gt as RiEmotionUnhappyFill, Mt as RiEmotionUnhappyLine, Zt as RiEmpathizeFill, xt as RiEmpathizeLine, dt as RiEmphasis, vt as RiEmphasisCn, pt as RiEnglishInput, ZS as RiEqualFill, xS as RiEqualLine, AD as RiEqualizer2Fill, kD as RiEqualizer2Line, PD as RiEqualizer3Fill, DD as RiEqualizer3Line, Et as RiEqualizerFill, Nt as RiEqualizerLine, ut as RiEraserFill, Bt as RiEraserLine, ft as RiErrorWarningFill, Rt as RiErrorWarningLine, yD as RiEthFill, bD as RiEthLine, zt as RiEvernoteFill, Ft as RiEvernoteLine, Tb as RiExchange2Fill, Ub as RiExchange2Line, St as RiExchangeBoxFill, At as RiExchangeBoxLine, kt as RiExchangeCnyFill, Pt as RiExchangeCnyLine, Dt as RiExchangeDollarFill, yt as RiExchangeDollarLine, bt as RiExchangeFill, Tt as RiExchangeFundsFill, Ut as RiExchangeFundsLine, Gt as RiExchangeLine, xU as RiExpandDiagonal2Fill, vU as RiExpandDiagonal2Line, dU as RiExpandDiagonalFill, pU as RiExpandDiagonalLine, wI as RiExpandDiagonalS2Fill, LI as RiExpandDiagonalS2Line, hI as RiExpandDiagonalSFill, HI as RiExpandDiagonalSLine, dT as RiExpandHeightFill, pT as RiExpandHeightLine, VI as RiExpandHorizontalFill, gI as RiExpandHorizontalLine, MI as RiExpandHorizontalSFill, ZI as RiExpandHorizontalSLine, vS as RiExpandLeftFill, dS as RiExpandLeftLine, pS as RiExpandLeftRightFill, ES as RiExpandLeftRightLine, NS as RiExpandRightFill, uS as RiExpandRightLine, BS as RiExpandUpDownFill, fS as RiExpandUpDownLine, xI as RiExpandVerticalFill, vI as RiExpandVerticalLine, dI as RiExpandVerticalSFill, pI as RiExpandVerticalSLine, ET as RiExpandWidthFill, NT as RiExpandWidthLine, Ry as RiExportFill, zy as RiExportLine, It as RiExternalLinkFill, Wt as RiExternalLinkLine, Ot as RiEye2Fill, Kt as RiEye2Line, Qt as RiEyeCloseFill, qt as RiEyeCloseLine, jt as RiEyeFill, Xt as RiEyeLine, Jt as RiEyeOffFill, Yt as RiEyeOffLine, _t as RiFacebookBoxFill, $t as RiFacebookBoxLine, eC as RiFacebookCircleFill, tC as RiFacebookCircleLine, CC as RiFacebookFill, lC as RiFacebookLine, iC as RiFahrenheitFill, sC as RiFahrenheitLine, pW as RiFediverseFill, EW as RiFediverseLine, rC as RiFeedbackFill, cC as RiFeedbackLine, zK as RiFigmaFill, FK as RiFigmaLine, oC as RiFile2Fill, aC as RiFile2Line, nC as RiFile3Fill, mC as RiFile3Line, wC as RiFile4Fill, LC as RiFile4Line, hC as RiFileAddFill, HC as RiFileAddLine, VC as RiFileChart2Fill, gC as RiFileChart2Line, MC as RiFileChartFill, ZC as RiFileChartLine, Fy as RiFileCheckFill, Sy as RiFileCheckLine, aP as RiFileCloseFill, nP as RiFileCloseLine, xC as RiFileCloudFill, vC as RiFileCloudLine, dC as RiFileCodeFill, pC as RiFileCodeLine, EC as RiFileCopy2Fill, NC as RiFileCopy2Line, uC as RiFileCopyFill, BC as RiFileCopyLine, fC as RiFileDamageFill, RC as RiFileDamageLine, zC as RiFileDownloadFill, FC as RiFileDownloadLine, SC as RiFileEditFill, AC as RiFileEditLine, kC as RiFileExcel2Fill, PC as RiFileExcel2Line, DC as RiFileExcelFill, yC as RiFileExcelLine, bC as RiFileFill, TC as RiFileForbidFill, UC as RiFileForbidLine, GC as RiFileGifFill, IC as RiFileGifLine, WC as RiFileHistoryFill, OC as RiFileHistoryLine, KC as RiFileHwpFill, QC as RiFileHwpLine, pP as RiFileImageFill, EP as RiFileImageLine, qC as RiFileInfoFill, jC as RiFileInfoLine, XC as RiFileLine, JC as RiFileList2Fill, YC as RiFileList2Line, _C as RiFileList3Fill, $C as RiFileList3Line, el as RiFileListFill, tl as RiFileListLine, Cl as RiFileLockFill, ll as RiFileLockLine, il as RiFileMarkedFill, sl as RiFileMarkedLine, rl as RiFileMusicFill, cl as RiFileMusicLine, ol as RiFilePaper2Fill, al as RiFilePaper2Line, nl as RiFilePaperFill, ml as RiFilePaperLine, NP as RiFilePdf2Fill, uP as RiFilePdf2Line, wl as RiFilePdfFill, Ll as RiFilePdfLine, hl as RiFilePpt2Fill, Hl as RiFilePpt2Line, Vl as RiFilePptFill, gl as RiFilePptLine, Ml as RiFileReduceFill, Zl as RiFileReduceLine, xl as RiFileSearchFill, vl as RiFileSearchLine, dl as RiFileSettingsFill, pl as RiFileSettingsLine, El as RiFileShield2Fill, Nl as RiFileShield2Line, ul as RiFileShieldFill, Bl as RiFileShieldLine, fl as RiFileShredFill, Rl as RiFileShredLine, zl as RiFileTextFill, Fl as RiFileTextLine, Sl as RiFileTransferFill, Al as RiFileTransferLine, kl as RiFileUnknowFill, Pl as RiFileUnknowLine, Dl as RiFileUploadFill, yl as RiFileUploadLine, bl as RiFileUserFill, Tl as RiFileUserLine, BP as RiFileVideoFill, fP as RiFileVideoLine, Ul as RiFileWarningFill, Gl as RiFileWarningLine, Il as RiFileWord2Fill, Wl as RiFileWord2Line, Ol as RiFileWordFill, Kl as RiFileWordLine, Ql as RiFileZipFill, ql as RiFileZipLine, yO as RiFilmAiFill, bO as RiFilmAiLine, jl as RiFilmFill, Xl as RiFilmLine, Jl as RiFilter2Fill, Yl as RiFilter2Line, _l as RiFilter3Fill, $l as RiFilter3Line, ei as RiFilterFill, ti as RiFilterLine, Ci as RiFilterOffFill, li as RiFilterOffLine, ii as RiFindReplaceFill, si as RiFindReplaceLine, ri as RiFinderFill, ci as RiFinderLine, oi as RiFingerprint2Fill, ai as RiFingerprint2Line, ni as RiFingerprintFill, mi as RiFingerprintLine, wi as RiFireFill, Li as RiFireLine, EU as RiFirebaseFill, NU as RiFirebaseLine, SK as RiFirefoxBrowserFill, AK as RiFirefoxBrowserLine, hi as RiFirefoxFill, Hi as RiFirefoxLine, Vi as RiFirstAidKitFill, gi as RiFirstAidKitLine, Mi as RiFlag2Fill, Zi as RiFlag2Line, xi as RiFlagFill, vi as RiFlagLine, NW as RiFlagOffFill, uW as RiFlagOffLine, di as RiFlashlightFill, pi as RiFlashlightLine, Ei as RiFlaskFill, Ni as RiFlaskLine, RS as RiFlickrFill, zS as RiFlickrLine, ui as RiFlightLandFill, Bi as RiFlightLandLine, fi as RiFlightTakeoffFill, Ri as RiFlightTakeoffLine, uU as RiFlipHorizontal2Fill, BU as RiFlipHorizontal2Line, fU as RiFlipHorizontalFill, RU as RiFlipHorizontalLine, zU as RiFlipVertical2Fill, FU as RiFlipVertical2Line, SU as RiFlipVerticalFill, AU as RiFlipVerticalLine, zi as RiFloodFill, Fi as RiFloodLine, Si as RiFlowChart, TD as RiFlowerFill, UD as RiFlowerLine, Ai as RiFlutterFill, ki as RiFlutterLine, Pi as RiFocus2Fill, Di as RiFocus2Line, yi as RiFocus3Fill, bi as RiFocus3Line, Ti as RiFocusFill, Ui as RiFocusLine, Ay as RiFocusMode, Gi as RiFoggyFill, Ii as RiFoggyLine, Wi as RiFolder2Fill, Oi as RiFolder2Line, Ki as RiFolder3Fill, Qi as RiFolder3Line, qi as RiFolder4Fill, ji as RiFolder4Line, Xi as RiFolder5Fill, Ji as RiFolder5Line, ky as RiFolder6Fill, Py as RiFolder6Line, Yi as RiFolderAddFill, _i as RiFolderAddLine, $i as RiFolderChart2Fill, es as RiFolderChart2Line, ts as RiFolderChartFill, Cs as RiFolderChartLine, Dy as RiFolderCheckFill, yy as RiFolderCheckLine, by as RiFolderCloseFill, Ty as RiFolderCloseLine, Uy as RiFolderCloudFill, Gy as RiFolderCloudLine, ls as RiFolderDownloadFill, is as RiFolderDownloadLine, ss as RiFolderFill, rs as RiFolderForbidFill, cs as RiFolderForbidLine, os as RiFolderHistoryFill, as as RiFolderHistoryLine, RP as RiFolderImageFill, zP as RiFolderImageLine, ns as RiFolderInfoFill, ms as RiFolderInfoLine, ws as RiFolderKeyholeFill, Ls as RiFolderKeyholeLine, hs as RiFolderLine, Hs as RiFolderLockFill, Vs as RiFolderLockLine, gs as RiFolderMusicFill, Ms as RiFolderMusicLine, Zs as RiFolderOpenFill, xs as RiFolderOpenLine, vs as RiFolderReceivedFill, ds as RiFolderReceivedLine, ps as RiFolderReduceFill, Es as RiFolderReduceLine, Ns as RiFolderSettingsFill, us as RiFolderSettingsLine, Bs as RiFolderSharedFill, fs as RiFolderSharedLine, Rs as RiFolderShield2Fill, zs as RiFolderShield2Line, Fs as RiFolderShieldFill, Ss as RiFolderShieldLine, As as RiFolderTransferFill, ks as RiFolderTransferLine, Ps as RiFolderUnknowFill, Ds as RiFolderUnknowLine, ys as RiFolderUploadFill, bs as RiFolderUploadLine, Ts as RiFolderUserFill, Us as RiFolderUserLine, FP as RiFolderVideoFill, SP as RiFolderVideoLine, Gs as RiFolderWarningFill, Is as RiFolderWarningLine, Ws as RiFolderZipFill, Os as RiFolderZipLine, Ks as RiFoldersFill, Qs as RiFoldersLine, qs as RiFontColor, Nk as RiFontFamily, uk as RiFontMono, fk as RiFontSans, Bk as RiFontSansSerif, Xs as RiFontSize, js as RiFontSize2, TO as RiFontSizeAi, Js as RiFootballFill, Ys as RiFootballLine, _s as RiFootprintFill, $s as RiFootprintLine, er as RiForbid2Fill, tr as RiForbid2Line, Cr as RiForbidFill, lr as RiForbidLine, ir as RiFormatClear, kU as RiFormula, FS as RiForward10Fill, SS as RiForward10Line, AS as RiForward15Fill, kS as RiForward15Line, PS as RiForward30Fill, DS as RiForward30Line, yS as RiForward5Fill, bS as RiForward5Line, uT as RiForwardEndFill, BT as RiForwardEndLine, fT as RiForwardEndMiniFill, RT as RiForwardEndMiniLine, sr as RiFridgeFill, rr as RiFridgeLine, zT as RiFriendicaFill, FT as RiFriendicaLine, cr as RiFullscreenExitFill, or as RiFullscreenExitLine, ar as RiFullscreenFill, nr as RiFullscreenLine, PU as RiFunctionAddFill, DU as RiFunctionAddLine, mr as RiFunctionFill, wr as RiFunctionLine, Lr as RiFunctions, hr as RiFundsBoxFill, Hr as RiFundsBoxLine, Vr as RiFundsFill, gr as RiFundsLine, Mr as RiGalleryFill, Zr as RiGalleryLine, xr as RiGalleryUploadFill, vr as RiGalleryUploadLine, Wy as RiGalleryView, Iy as RiGalleryView2, dr as RiGameFill, pr as RiGameLine, Er as RiGamepadFill, Nr as RiGamepadLine, ur as RiGasStationFill, Br as RiGasStationLine, fr as RiGatsbyFill, Rr as RiGatsbyLine, EI as RiGeminiFill, NI as RiGeminiLine, zr as RiGenderlessFill, Fr as RiGenderlessLine, Sr as RiGhost2Fill, Ar as RiGhost2Line, kr as RiGhostFill, Pr as RiGhostLine, Dr as RiGhostSmileFill, yr as RiGhostSmileLine, br as RiGift2Fill, Tr as RiGift2Line, Ur as RiGiftFill, Gr as RiGiftLine, Ir as RiGitBranchFill, Wr as RiGitBranchLine, ak as RiGitClosePullRequestFill, nk as RiGitClosePullRequestLine, Or as RiGitCommitFill, Kr as RiGitCommitLine, Gb as RiGitForkFill, Ib as RiGitForkLine, Qr as RiGitMergeFill, qr as RiGitMergeLine, ST as RiGitPrDraftFill, AT as RiGitPrDraftLine, jr as RiGitPullRequestFill, Xr as RiGitPullRequestLine, Jr as RiGitRepositoryCommitsFill, Yr as RiGitRepositoryCommitsLine, _r as RiGitRepositoryFill, $r as RiGitRepositoryLine, ec as RiGitRepositoryPrivateFill, tc as RiGitRepositoryPrivateLine, Cc as RiGithubFill, lc as RiGithubLine, ic as RiGitlabFill, sc as RiGitlabLine, GD as RiGlasses2Fill, ID as RiGlasses2Line, WD as RiGlassesFill, OD as RiGlassesLine, rc as RiGlobalFill, cc as RiGlobalLine, oc as RiGlobeFill, ac as RiGlobeLine, yU as RiGoblet2Fill, bU as RiGoblet2Line, nc as RiGobletFill, mc as RiGobletLine, KD as RiGogglesFill, QD as RiGogglesLine, TU as RiGolfBallFill, UU as RiGolfBallLine, wc as RiGoogleFill, Lc as RiGoogleLine, hc as RiGooglePlayFill, Hc as RiGooglePlayLine, Vc as RiGovernmentFill, gc as RiGovernmentLine, Mc as RiGpsFill, Zc as RiGpsLine, xc as RiGradienterFill, vc as RiGradienterLine, TS as RiGraduationCapFill, US as RiGraduationCapLine, dc as RiGridFill, pc as RiGridLine, Ec as RiGroup2Fill, Nc as RiGroup2Line, GU as RiGroup3Fill, IU as RiGroup3Line, uc as RiGroupFill, Bc as RiGroupLine, fc as RiGuideFill, Rc as RiGuideLine, zc as RiH1, Fc as RiH2, Sc as RiH3, Ac as RiH4, kc as RiH5, Pc as RiH6, Dc as RiHailFill, yc as RiHailLine, bc as RiHammerFill, Tc as RiHammerLine, Oy as RiHand, Uc as RiHandCoinFill, Gc as RiHandCoinLine, Ic as RiHandHeartFill, Wc as RiHandHeartLine, Oc as RiHandSanitizerFill, Kc as RiHandSanitizerLine, Qc as RiHandbagFill, qc as RiHandbagLine, jc as RiHardDrive2Fill, Xc as RiHardDrive2Line, Rk as RiHardDrive3Fill, zk as RiHardDrive3Line, Jc as RiHardDriveFill, Yc as RiHardDriveLine, _c as RiHashtag, $c as RiHaze2Fill, eo as RiHaze2Line, to as RiHazeFill, Co as RiHazeLine, lo as RiHdFill, io as RiHdLine, so as RiHeading, ro as RiHeadphoneFill, co as RiHeadphoneLine, oo as RiHealthBookFill, ao as RiHealthBookLine, no as RiHeart2Fill, mo as RiHeart2Line, wo as RiHeart3Fill, Lo as RiHeart3Line, WU as RiHeartAdd2Fill, OU as RiHeartAdd2Line, ho as RiHeartAddFill, Ho as RiHeartAddLine, Vo as RiHeartFill, go as RiHeartLine, Mo as RiHeartPulseFill, Zo as RiHeartPulseLine, xo as RiHeartsFill, vo as RiHeartsLine, po as RiHeavyShowersFill, Eo as RiHeavyShowersLine, AP as RiHexagonFill, kP as RiHexagonLine, No as RiHistoryFill, uo as RiHistoryLine, Bo as RiHome2Fill, fo as RiHome2Line, Ro as RiHome3Fill, zo as RiHome3Line, Fo as RiHome4Fill, So as RiHome4Line, Ao as RiHome5Fill, ko as RiHome5Line, Po as RiHome6Fill, Do as RiHome6Line, yo as RiHome7Fill, bo as RiHome7Line, To as RiHome8Fill, Uo as RiHome8Line, BW as RiHome9Fill, fW as RiHome9Line, Go as RiHomeFill, Io as RiHomeGearFill, Wo as RiHomeGearLine, Oo as RiHomeHeartFill, Ko as RiHomeHeartLine, Qo as RiHomeLine, GS as RiHomeOfficeFill, IS as RiHomeOfficeLine, qo as RiHomeSmile2Fill, jo as RiHomeSmile2Line, Xo as RiHomeSmileFill, Jo as RiHomeSmileLine, Yo as RiHomeWifiFill, _o as RiHomeWifiLine, $o as RiHonorOfKingsFill, ea as RiHonorOfKingsLine, ta as RiHonourFill, Ca as RiHonourLine, la as RiHospitalFill, ia as RiHospitalLine, sa as RiHotelBedFill, ra as RiHotelBedLine, ca as RiHotelFill, oa as RiHotelLine, aa as RiHotspotFill, na as RiHotspotLine, WS as RiHourglass2Fill, OS as RiHourglass2Line, KS as RiHourglassFill, QS as RiHourglassLine, ma as RiHqFill, wa as RiHqLine, La as RiHtml5Fill, ha as RiHtml5Line, KU as RiIdCardFill, QU as RiIdCardLine, Ha as RiIeFill, Va as RiIeLine, ga as RiImage2Fill, Ma as RiImage2Line, Za as RiImageAddFill, xa as RiImageAddLine, RW as RiImageAiFill, zW as RiImageAiLine, FW as RiImageCircleAiFill, SW as RiImageCircleAiLine, qD as RiImageCircleFill, jD as RiImageCircleLine, va as RiImageEditFill, da as RiImageEditLine, pa as RiImageFill, Ea as RiImageLine, Ky as RiImportFill, Qy as RiImportLine, Xk as RiInbox2Fill, Jk as RiInbox2Line, Na as RiInboxArchiveFill, ua as RiInboxArchiveLine, Ba as RiInboxFill, fa as RiInboxLine, Ra as RiInboxUnarchiveFill, za as RiInboxUnarchiveLine, Fa as RiIncreaseDecreaseFill, Sa as RiIncreaseDecreaseLine, Aa as RiIndentDecrease, ka as RiIndentIncrease, Pa as RiIndeterminateCircleFill, Da as RiIndeterminateCircleLine, mP as RiInfinityFill, wP as RiInfinityLine, AW as RiInfoCardFill, kW as RiInfoCardLine, XD as RiInfoI, qy as RiInformation2Fill, jy as RiInformation2Line, ya as RiInformationFill, ba as RiInformationLine, qU as RiInformationOffFill, jU as RiInformationOffLine, Ta as RiInfraredThermometerFill, Ua as RiInfraredThermometerLine, Ga as RiInkBottleFill, Ia as RiInkBottleLine, Wa as RiInputCursorMove, Wb as RiInputField, Oa as RiInputMethodFill, Ka as RiInputMethodLine, Qa as RiInsertColumnLeft, qa as RiInsertColumnRight, ja as RiInsertRowBottom, Xa as RiInsertRowTop, Ja as RiInstagramFill, Ya as RiInstagramLine, _a as RiInstallFill, $a as RiInstallLine, mk as RiInstanceFill, wk as RiInstanceLine, en as RiInvisionFill, tn as RiInvisionLine, Cn as RiItalic, XU as RiJavaFill, JU as RiJavaLine, qS as RiJavascriptFill, jS as RiJavascriptLine, kK as RiJewelryFill, PK as RiJewelryLine, ln as RiKakaoTalkFill, sn as RiKakaoTalkLine, Jy as RiKanbanView, Xy as RiKanbanView2, rn as RiKey2Fill, cn as RiKey2Line, on as RiKeyFill, an as RiKeyLine, nn as RiKeyboardBoxFill, mn as RiKeyboardBoxLine, wn as RiKeyboardFill, Ln as RiKeyboardLine, hn as RiKeynoteFill, Hn as RiKeynoteLine, Fk as RiKickFill, Sk as RiKickLine, Vn as RiKnifeBloodFill, gn as RiKnifeBloodLine, Mn as RiKnifeFill, Zn as RiKnifeLine, PW as RiLandscapeAiFill, DW as RiLandscapeAiLine, xn as RiLandscapeFill, vn as RiLandscapeLine, dn as RiLayout2Fill, pn as RiLayout2Line, En as RiLayout3Fill, Nn as RiLayout3Line, un as RiLayout4Fill, Bn as RiLayout4Line, fn as RiLayout5Fill, Rn as RiLayout5Line, zn as RiLayout6Fill, Fn as RiLayout6Line, Sn as RiLayoutBottom2Fill, An as RiLayoutBottom2Line, kn as RiLayoutBottomFill, Pn as RiLayoutBottomLine, Dn as RiLayoutColumnFill, yn as RiLayoutColumnLine, bn as RiLayoutFill, YU as RiLayoutGrid2Fill, _U as RiLayoutGrid2Line, Tn as RiLayoutGridFill, Un as RiLayoutGridLine, $U as RiLayoutHorizontalFill, eG as RiLayoutHorizontalLine, Gn as RiLayoutLeft2Fill, In as RiLayoutLeft2Line, Wn as RiLayoutLeftFill, On as RiLayoutLeftLine, Kn as RiLayoutLine, Qn as RiLayoutMasonryFill, qn as RiLayoutMasonryLine, jn as RiLayoutRight2Fill, Xn as RiLayoutRight2Line, Jn as RiLayoutRightFill, Yn as RiLayoutRightLine, _n as RiLayoutRowFill, $n as RiLayoutRowLine, em as RiLayoutTop2Fill, tm as RiLayoutTop2Line, Cm as RiLayoutTopFill, lm as RiLayoutTopLine, tG as RiLayoutVerticalFill, CG as RiLayoutVerticalLine, im as RiLeafFill, sm as RiLeafLine, yW as RiLetterSpacing2, rm as RiLifebuoyFill, cm as RiLifebuoyLine, om as RiLightbulbFill, am as RiLightbulbFlashFill, nm as RiLightbulbFlashLine, mm as RiLightbulbLine, wm as RiLineChartFill, Lm as RiLineChartLine, hm as RiLineFill, Hm as RiLineHeight, bW as RiLineHeight2, Vm as RiLineLine, xm as RiLink, gm as RiLinkM, Zm as RiLinkUnlink, Mm as RiLinkUnlinkM, vm as RiLinkedinBoxFill, dm as RiLinkedinBoxLine, pm as RiLinkedinFill, Em as RiLinkedinLine, Nm as RiLinksFill, um as RiLinksLine, fm as RiListCheck, Bm as RiListCheck2, Ak as RiListCheck3, kk as RiListIndefinite, Rm as RiListOrdered, Pk as RiListOrdered2, Dk as RiListRadio, zm as RiListSettingsFill, Fm as RiListSettingsLine, Sm as RiListUnordered, Yy as RiListView, Am as RiLiveFill, km as RiLiveLine, Pm as RiLoader2Fill, Dm as RiLoader2Line, ym as RiLoader3Fill, bm as RiLoader3Line, Tm as RiLoader4Fill, Um as RiLoader4Line, Gm as RiLoader5Fill, Im as RiLoader5Line, Wm as RiLoaderFill, Om as RiLoaderLine, Km as RiLock2Fill, Qm as RiLock2Line, qm as RiLockFill, jm as RiLockLine, Xm as RiLockPasswordFill, Jm as RiLockPasswordLine, _y as RiLockStarFill, $y as RiLockStarLine, Ym as RiLockUnlockFill, _m as RiLockUnlockLine, $m as RiLoginBoxFill, ew as RiLoginBoxLine, tw as RiLoginCircleFill, Cw as RiLoginCircleLine, lw as RiLogoutBoxFill, iw as RiLogoutBoxLine, sw as RiLogoutBoxRFill, rw as RiLogoutBoxRLine, cw as RiLogoutCircleFill, ow as RiLogoutCircleLine, aw as RiLogoutCircleRFill, nw as RiLogoutCircleRLine, XS as RiLoopLeftFill, JS as RiLoopLeftLine, YS as RiLoopRightFill, _S as RiLoopRightLine, mw as RiLuggageCartFill, ww as RiLuggageCartLine, Lw as RiLuggageDepositFill, hw as RiLuggageDepositLine, Hw as RiLungsFill, Vw as RiLungsLine, gw as RiMacFill, Mw as RiMacLine, Zw as RiMacbookFill, xw as RiMacbookLine, vw as RiMagicFill, dw as RiMagicLine, pw as RiMailAddFill, Ew as RiMailAddLine, TW as RiMailAiFill, UW as RiMailAiLine, Nw as RiMailCheckFill, uw as RiMailCheckLine, Bw as RiMailCloseFill, fw as RiMailCloseLine, Rw as RiMailDownloadFill, zw as RiMailDownloadLine, Fw as RiMailFill, Sw as RiMailForbidFill, Aw as RiMailForbidLine, kw as RiMailLine, Pw as RiMailLockFill, Dw as RiMailLockLine, yw as RiMailOpenFill, bw as RiMailOpenLine, Tw as RiMailSendFill, Uw as RiMailSendLine, Gw as RiMailSettingsFill, Iw as RiMailSettingsLine, Ww as RiMailStarFill, Ow as RiMailStarLine, Kw as RiMailUnreadFill, Qw as RiMailUnreadLine, qw as RiMailVolumeFill, jw as RiMailVolumeLine, Xw as RiMap2Fill, Jw as RiMap2Line, Yw as RiMapFill, _w as RiMapLine, $w as RiMapPin2Fill, eL as RiMapPin2Line, tL as RiMapPin3Fill, CL as RiMapPin3Line, lL as RiMapPin4Fill, iL as RiMapPin4Line, sL as RiMapPin5Fill, rL as RiMapPin5Line, cL as RiMapPinAddFill, oL as RiMapPinAddLine, aL as RiMapPinFill, nL as RiMapPinLine, mL as RiMapPinRangeFill, wL as RiMapPinRangeLine, LL as RiMapPinTimeFill, hL as RiMapPinTimeLine, HL as RiMapPinUserFill, VL as RiMapPinUserLine, gL as RiMarkPenFill, ML as RiMarkPenLine, ZL as RiMarkdownFill, xL as RiMarkdownLine, vL as RiMarkupFill, dL as RiMarkupLine, pL as RiMastercardFill, EL as RiMastercardLine, NL as RiMastodonFill, uL as RiMastodonLine, BL as RiMedal2Fill, fL as RiMedal2Line, RL as RiMedalFill, zL as RiMedalLine, FL as RiMedicineBottleFill, SL as RiMedicineBottleLine, AL as RiMediumFill, kL as RiMediumLine, Lk as RiMegaphoneFill, hk as RiMegaphoneLine, $S as RiMemoriesFill, eA as RiMemoriesLine, PL as RiMenFill, DL as RiMenLine, yL as RiMentalHealthFill, bL as RiMentalHealthLine, TL as RiMenu2Fill, UL as RiMenu2Line, GL as RiMenu3Fill, IL as RiMenu3Line, WL as RiMenu4Fill, OL as RiMenu4Line, KL as RiMenu5Fill, QL as RiMenu5Line, qL as RiMenuAddFill, jL as RiMenuAddLine, XL as RiMenuFill, lG as RiMenuFold2Fill, iG as RiMenuFold2Line, sG as RiMenuFold3Fill, rG as RiMenuFold3Line, cG as RiMenuFold4Fill, oG as RiMenuFold4Line, JL as RiMenuFoldFill, YL as RiMenuFoldLine, _L as RiMenuLine, PP as RiMenuSearchFill, DP as RiMenuSearchLine, aG as RiMenuUnfold2Fill, nG as RiMenuUnfold2Line, mG as RiMenuUnfold3Fill, wG as RiMenuUnfold3Line, LG as RiMenuUnfold4Fill, hG as RiMenuUnfold4Line, $L as RiMenuUnfoldFill, eh as RiMenuUnfoldLine, th as RiMergeCellsHorizontal, Ch as RiMergeCellsVertical, lh as RiMessage2Fill, ih as RiMessage2Line, sh as RiMessage3Fill, rh as RiMessage3Line, ch as RiMessageFill, oh as RiMessageLine, ah as RiMessengerFill, nh as RiMessengerLine, tA as RiMetaFill, CA as RiMetaLine, mh as RiMeteorFill, wh as RiMeteorLine, GW as RiMic2AiFill, IW as RiMic2AiLine, Lh as RiMic2Fill, hh as RiMic2Line, WW as RiMicAiFill, OW as RiMicAiLine, Hh as RiMicFill, Vh as RiMicLine, gh as RiMicOffFill, Mh as RiMicOffLine, Zh as RiMickeyFill, xh as RiMickeyLine, vh as RiMicroscopeFill, dh as RiMicroscopeLine, ph as RiMicrosoftFill, Eh as RiMicrosoftLine, lA as RiMicrosoftLoopFill, iA as RiMicrosoftLoopLine, Nh as RiMindMap, uh as RiMiniProgramFill, Bh as RiMiniProgramLine, fh as RiMistFill, Rh as RiMistLine, UO as RiMixtralFill, GO as RiMixtralLine, HG as RiMobileDownloadFill, VG as RiMobileDownloadLine, zh as RiMoneyCnyBoxFill, Fh as RiMoneyCnyBoxLine, Sh as RiMoneyCnyCircleFill, Ah as RiMoneyCnyCircleLine, kh as RiMoneyDollarBoxFill, Ph as RiMoneyDollarBoxLine, Dh as RiMoneyDollarCircleFill, yh as RiMoneyDollarCircleLine, bh as RiMoneyEuroBoxFill, Th as RiMoneyEuroBoxLine, Uh as RiMoneyEuroCircleFill, Gh as RiMoneyEuroCircleLine, Ih as RiMoneyPoundBoxFill, Wh as RiMoneyPoundBoxLine, Oh as RiMoneyPoundCircleFill, Kh as RiMoneyPoundCircleLine, JD as RiMoneyRupeeCircleFill, YD as RiMoneyRupeeCircleLine, Qh as RiMoonClearFill, qh as RiMoonClearLine, jh as RiMoonCloudyFill, Xh as RiMoonCloudyLine, Jh as RiMoonFill, Yh as RiMoonFoggyFill, _h as RiMoonFoggyLine, $h as RiMoonLine, eH as RiMore2Fill, tH as RiMore2Line, CH as RiMoreFill, lH as RiMoreLine, iH as RiMotorbikeFill, sH as RiMotorbikeLine, rH as RiMouseFill, cH as RiMouseLine, IO as RiMovie2AiFill, WO as RiMovie2AiLine, oH as RiMovie2Fill, aH as RiMovie2Line, KW as RiMovieAiFill, QW as RiMovieAiLine, nH as RiMovieFill, mH as RiMovieLine, DK as RiMultiImageFill, yK as RiMultiImageLine, wH as RiMusic2Fill, LH as RiMusic2Line, qW as RiMusicAiFill, jW as RiMusicAiLine, hH as RiMusicFill, HH as RiMusicLine, OO as RiMvAiFill, KO as RiMvAiLine, VH as RiMvFill, gH as RiMvLine, MH as RiNavigationFill, ZH as RiNavigationLine, xH as RiNeteaseCloudMusicFill, vH as RiNeteaseCloudMusicLine, dH as RiNetflixFill, pH as RiNetflixLine, _D as RiNewsFill, $D as RiNewsLine, EH as RiNewspaperFill, NH as RiNewspaperLine, gG as RiNextjsFill, MG as RiNextjsLine, sA as RiNftFill, rA as RiNftLine, bK as RiNoCreditCardFill, TK as RiNoCreditCardLine, uH as RiNodeTree, ZG as RiNodejsFill, xG as RiNodejsLine, BH as RiNotification2Fill, fH as RiNotification2Line, RH as RiNotification3Fill, zH as RiNotification3Line, FH as RiNotification4Fill, SH as RiNotification4Line, AH as RiNotificationBadgeFill, kH as RiNotificationBadgeLine, PH as RiNotificationFill, DH as RiNotificationLine, yH as RiNotificationOffFill, bH as RiNotificationOffLine, XW as RiNotificationSnoozeFill, JW as RiNotificationSnoozeLine, cA as RiNotionFill, oA as RiNotionLine, TH as RiNpmjsFill, UH as RiNpmjsLine, GH as RiNumber0, IH as RiNumber1, WH as RiNumber2, OH as RiNumber3, KH as RiNumber4, QH as RiNumber5, qH as RiNumber6, jH as RiNumber7, XH as RiNumber8, JH as RiNumber9, YH as RiNumbersFill, _H as RiNumbersLine, $H as RiNurseFill, eV as RiNurseLine, yP as RiOctagonFill, bP as RiOctagonLine, tV as RiOilFill, CV as RiOilLine, lV as RiOmega, iV as RiOpenArmFill, sV as RiOpenArmLine, rV as RiOpenSourceFill, cV as RiOpenSourceLine, aA as RiOpenaiFill, nA as RiOpenaiLine, yk as RiOpenbaseFill, bk as RiOpenbaseLine, oV as RiOperaFill, aV as RiOperaLine, nV as RiOrderPlayFill, mV as RiOrderPlayLine, wV as RiOrganizationChart, LV as RiOutlet2Fill, hV as RiOutlet2Line, HV as RiOutletFill, VV as RiOutletLine, mA as RiOverline, wA as RiP2pFill, LA as RiP2pLine, gV as RiPageSeparator, MV as RiPagesFill, ZV as RiPagesLine, xV as RiPaintBrushFill, vV as RiPaintBrushLine, dV as RiPaintFill, pV as RiPaintLine, EV as RiPaletteFill, NV as RiPaletteLine, uV as RiPantoneFill, BV as RiPantoneLine, fV as RiParagraph, RV as RiParentFill, zV as RiParentLine, FV as RiParenthesesFill, SV as RiParenthesesLine, AV as RiParkingBoxFill, kV as RiParkingBoxLine, PV as RiParkingFill, DV as RiParkingLine, Hk as RiPassExpiredFill, Vk as RiPassExpiredLine, gk as RiPassPendingFill, Mk as RiPassPendingLine, Zk as RiPassValidFill, xk as RiPassValidLine, yV as RiPassportFill, bV as RiPassportLine, TV as RiPatreonFill, UV as RiPatreonLine, GV as RiPauseCircleFill, IV as RiPauseCircleLine, WV as RiPauseFill, vG as RiPauseLargeFill, dG as RiPauseLargeLine, OV as RiPauseLine, KV as RiPauseMiniFill, QV as RiPauseMiniLine, qV as RiPaypalFill, jV as RiPaypalLine, XV as RiPenNibFill, JV as RiPenNibLine, YV as RiPencilFill, _V as RiPencilLine, $V as RiPencilRuler2Fill, eg as RiPencilRuler2Line, tg as RiPencilRulerFill, Cg as RiPencilRulerLine, TP as RiPentagonFill, UP as RiPentagonLine, lg as RiPercentFill, ig as RiPercentLine, QO as RiPerplexityFill, qO as RiPerplexityLine, sg as RiPhoneCameraFill, rg as RiPhoneCameraLine, cg as RiPhoneFill, og as RiPhoneFindFill, ag as RiPhoneFindLine, ng as RiPhoneLine, mg as RiPhoneLockFill, wg as RiPhoneLockLine, YW as RiPhpFill, _W as RiPhpLine, Lg as RiPictureInPicture2Fill, hg as RiPictureInPicture2Line, Hg as RiPictureInPictureExitFill, Vg as RiPictureInPictureExitLine, gg as RiPictureInPictureFill, Mg as RiPictureInPictureLine, Zg as RiPieChart2Fill, xg as RiPieChart2Line, vg as RiPieChartBoxFill, dg as RiPieChartBoxLine, pg as RiPieChartFill, Eg as RiPieChartLine, Ng as RiPinDistanceFill, ug as RiPinDistanceLine, Bg as RiPingPongFill, fg as RiPingPongLine, Rg as RiPinterestFill, zg as RiPinterestLine, Fg as RiPinyinInput, $W as RiPixFill, eO as RiPixLine, Sg as RiPixelfedFill, Ag as RiPixelfedLine, kg as RiPlaneFill, Pg as RiPlaneLine, Tk as RiPlanetFill, Uk as RiPlanetLine, Dg as RiPlantFill, yg as RiPlantLine, bg as RiPlayCircleFill, Tg as RiPlayCircleLine, Ug as RiPlayFill, pG as RiPlayLargeFill, EG as RiPlayLargeLine, Gg as RiPlayLine, Ig as RiPlayList2Fill, Wg as RiPlayList2Line, Og as RiPlayListAddFill, Kg as RiPlayListAddLine, Qg as RiPlayListFill, qg as RiPlayListLine, jg as RiPlayMiniFill, Xg as RiPlayMiniLine, kT as RiPlayReverseFill, NG as RiPlayReverseLargeFill, uG as RiPlayReverseLargeLine, PT as RiPlayReverseLine, DT as RiPlayReverseMiniFill, yT as RiPlayReverseMiniLine, Jg as RiPlaystationFill, Yg as RiPlaystationLine, _g as RiPlug2Fill, $g as RiPlug2Line, eM as RiPlugFill, tM as RiPlugLine, jO as RiPokerClubsFill, XO as RiPokerClubsLine, JO as RiPokerDiamondsFill, YO as RiPokerDiamondsLine, _O as RiPokerHeartsFill, $O as RiPokerHeartsLine, eK as RiPokerSpadesFill, tK as RiPokerSpadesLine, CM as RiPolaroid2Fill, lM as RiPolaroid2Line, iM as RiPolaroidFill, sM as RiPolaroidLine, BG as RiPoliceBadgeFill, fG as RiPoliceBadgeLine, rM as RiPoliceCarFill, cM as RiPoliceCarLine, hA as RiPresentationFill, HA as RiPresentationLine, oM as RiPriceTag2Fill, aM as RiPriceTag2Line, nM as RiPriceTag3Fill, mM as RiPriceTag3Line, wM as RiPriceTagFill, LM as RiPriceTagLine, hM as RiPrinterCloudFill, HM as RiPrinterCloudLine, VM as RiPrinterFill, gM as RiPrinterLine, MM as RiProductHuntFill, ZM as RiProductHuntLine, xM as RiProfileFill, vM as RiProfileLine, Ob as RiProgress1Fill, Kb as RiProgress1Line, Qb as RiProgress2Fill, qb as RiProgress2Line, jb as RiProgress3Fill, Xb as RiProgress3Line, Jb as RiProgress4Fill, Yb as RiProgress4Line, _b as RiProgress5Fill, $b as RiProgress5Line, eT as RiProgress6Fill, tT as RiProgress6Line, CT as RiProgress7Fill, lT as RiProgress7Line, iT as RiProgress8Fill, sT as RiProgress8Line, RG as RiProhibited2Fill, zG as RiProhibited2Line, Gk as RiProhibitedFill, Ik as RiProhibitedLine, dM as RiProjector2Fill, pM as RiProjector2Line, EM as RiProjectorFill, NM as RiProjectorLine, uM as RiPsychotherapyFill, BM as RiPsychotherapyLine, tO as RiPulseAiFill, CO as RiPulseAiLine, fM as RiPulseFill, RM as RiPulseLine, zM as RiPushpin2Fill, FM as RiPushpin2Line, SM as RiPushpinFill, AM as RiPushpinLine, eb as RiPuzzle2Fill, tb as RiPuzzle2Line, Cb as RiPuzzleFill, lb as RiPuzzleLine, kM as RiQqFill, PM as RiQqLine, DM as RiQrCodeFill, yM as RiQrCodeLine, bM as RiQrScan2Fill, TM as RiQrScan2Line, UM as RiQrScanFill, GM as RiQrScanLine, IM as RiQuestionAnswerFill, WM as RiQuestionAnswerLine, OM as RiQuestionFill, KM as RiQuestionLine, QM as RiQuestionMark, qM as RiQuestionnaireFill, jM as RiQuestionnaireLine, lO as RiQuillPenAiFill, iO as RiQuillPenAiLine, XM as RiQuillPenFill, JM as RiQuillPenLine, Wk as RiQuoteText, YM as RiRadarFill, _M as RiRadarLine, $M as RiRadio2Fill, eZ as RiRadio2Line, tZ as RiRadioButtonFill, CZ as RiRadioButtonLine, lZ as RiRadioFill, iZ as RiRadioLine, sZ as RiRainbowFill, rZ as RiRainbowLine, cZ as RiRainyFill, oZ as RiRainyLine, ib as RiRam2Fill, sb as RiRam2Line, rb as RiRamFill, cb as RiRamLine, aZ as RiReactjsFill, nZ as RiReactjsLine, ob as RiReceiptFill, ab as RiReceiptLine, mZ as RiRecordCircleFill, wZ as RiRecordCircleLine, LZ as RiRecordMailFill, hZ as RiRecordMailLine, GP as RiRectangleFill, IP as RiRectangleLine, HZ as RiRecycleFill, VZ as RiRecycleLine, gZ as RiRedPacketFill, MZ as RiRedPacketLine, ZZ as RiRedditFill, xZ as RiRedditLine, vZ as RiRefreshFill, dZ as RiRefreshLine, pZ as RiRefund2Fill, EZ as RiRefund2Line, NZ as RiRefundFill, uZ as RiRefundLine, BZ as RiRegisteredFill, fZ as RiRegisteredLine, rT as RiRemixRunFill, cT as RiRemixRunLine, RZ as RiRemixiconFill, zZ as RiRemixiconLine, FZ as RiRemoteControl2Fill, SZ as RiRemoteControl2Line, AZ as RiRemoteControlFill, kZ as RiRemoteControlLine, PZ as RiRepeat2Fill, DZ as RiRepeat2Line, yZ as RiRepeatFill, bZ as RiRepeatLine, TZ as RiRepeatOneFill, UZ as RiRepeatOneLine, VA as RiReplay10Fill, gA as RiReplay10Line, MA as RiReplay15Fill, ZA as RiReplay15Line, xA as RiReplay30Fill, vA as RiReplay30Line, dA as RiReplay5Fill, pA as RiReplay5Line, GZ as RiReplyAllFill, IZ as RiReplyAllLine, WZ as RiReplyFill, OZ as RiReplyLine, KZ as RiReservedFill, QZ as RiReservedLine, uI as RiResetLeftFill, BI as RiResetLeftLine, fI as RiResetRightFill, RI as RiResetRightLine, qZ as RiRestTimeFill, jZ as RiRestTimeLine, XZ as RiRestartFill, JZ as RiRestartLine, YZ as RiRestaurant2Fill, _Z as RiRestaurant2Line, $Z as RiRestaurantFill, ex as RiRestaurantLine, tx as RiRewindFill, Cx as RiRewindLine, lx as RiRewindMiniFill, ix as RiRewindMiniLine, bT as RiRewindStartFill, TT as RiRewindStartLine, UT as RiRewindStartMiniFill, GT as RiRewindStartMiniLine, LP as RiRfidFill, hP as RiRfidLine, sx as RiRhythmFill, rx as RiRhythmLine, cx as RiRidingFill, ox as RiRidingLine, ax as RiRoadMapFill, nx as RiRoadMapLine, mx as RiRoadsterFill, wx as RiRoadsterLine, WP as RiRobot2Fill, OP as RiRobot2Line, ey as RiRobot3Fill, ty as RiRobot3Line, Lx as RiRobotFill, hx as RiRobotLine, Hx as RiRocket2Fill, Vx as RiRocket2Line, gx as RiRocketFill, Mx as RiRocketLine, Zx as RiRotateLockFill, xx as RiRotateLockLine, vx as RiRoundedCorner, dx as RiRouteFill, px as RiRouteLine, Ex as RiRouterFill, Nx as RiRouterLine, ux as RiRssFill, Bx as RiRssLine, fx as RiRuler2Fill, Rx as RiRuler2Line, zx as RiRulerFill, Fx as RiRulerLine, Sx as RiRunFill, Ax as RiRunLine, kx as RiSafariFill, Px as RiSafariLine, Dx as RiSafe2Fill, yx as RiSafe2Line, CK as RiSafe3Fill, lK as RiSafe3Line, bx as RiSafeFill, Tx as RiSafeLine, Ux as RiSailboatFill, Gx as RiSailboatLine, Ix as RiSave2Fill, Wx as RiSave2Line, Ox as RiSave3Fill, Kx as RiSave3Line, Qx as RiSaveFill, qx as RiSaveLine, jx as RiScales2Fill, Xx as RiScales2Line, Jx as RiScales3Fill, Yx as RiScales3Line, _x as RiScalesFill, $x as RiScalesLine, ev as RiScan2Fill, tv as RiScan2Line, Cv as RiScanFill, lv as RiScanLine, EA as RiSchoolFill, NA as RiSchoolLine, iv as RiScissors2Fill, sv as RiScissors2Line, rv as RiScissorsCutFill, cv as RiScissorsCutLine, ov as RiScissorsFill, av as RiScissorsLine, nv as RiScreenshot2Fill, mv as RiScreenshot2Line, wv as RiScreenshotFill, Lv as RiScreenshotLine, IT as RiScrollToBottomFill, WT as RiScrollToBottomLine, hv as RiSdCardFill, Hv as RiSdCardLine, Vv as RiSdCardMiniFill, gv as RiSdCardMiniLine, Mv as RiSearch2Fill, Zv as RiSearch2Line, xv as RiSearchEyeFill, vv as RiSearchEyeLine, dv as RiSearchFill, pv as RiSearchLine, Ev as RiSecurePaymentFill, Nv as RiSecurePaymentLine, uv as RiSeedlingFill, Bv as RiSeedlingLine, fv as RiSendBackward, Rv as RiSendPlane2Fill, zv as RiSendPlane2Line, Fv as RiSendPlaneFill, Sv as RiSendPlaneLine, Av as RiSendToBack, kv as RiSensorFill, Pv as RiSensorLine, Ok as RiSeoFill, Kk as RiSeoLine, Dv as RiSeparator, yv as RiServerFill, bv as RiServerLine, UK as RiServiceBellFill, GK as RiServiceBellLine, Tv as RiServiceFill, Uv as RiServiceLine, Gv as RiSettings2Fill, Iv as RiSettings2Line, Wv as RiSettings3Fill, Ov as RiSettings3Line, Kv as RiSettings4Fill, Qv as RiSettings4Line, qv as RiSettings5Fill, jv as RiSettings5Line, Xv as RiSettings6Fill, Jv as RiSettings6Line, Yv as RiSettingsFill, _v as RiSettingsLine, nb as RiShadowFill, mb as RiShadowLine, Yk as RiShakeHandsFill, _k as RiShakeHandsLine, $v as RiShape2Fill, ed as RiShape2Line, td as RiShapeFill, Cd as RiShapeLine, KP as RiShapesFill, QP as RiShapesLine, Cy as RiShare2Fill, ly as RiShare2Line, ld as RiShareBoxFill, id as RiShareBoxLine, sd as RiShareCircleFill, rd as RiShareCircleLine, cd as RiShareFill, od as RiShareForward2Fill, ad as RiShareForward2Line, nd as RiShareForwardBoxFill, md as RiShareForwardBoxLine, wd as RiShareForwardFill, Ld as RiShareForwardLine, hd as RiShareLine, Hd as RiShieldCheckFill, Vd as RiShieldCheckLine, gd as RiShieldCrossFill, Md as RiShieldCrossLine, Zd as RiShieldFill, xd as RiShieldFlashFill, vd as RiShieldFlashLine, dd as RiShieldKeyholeFill, pd as RiShieldKeyholeLine, Ed as RiShieldLine, Nd as RiShieldStarFill, ud as RiShieldStarLine, Bd as RiShieldUserFill, fd as RiShieldUserLine, uA as RiShining2Fill, BA as RiShining2Line, fA as RiShiningFill, RA as RiShiningLine, Rd as RiShip2Fill, zd as RiShip2Line, Fd as RiShipFill, Sd as RiShipLine, Ad as RiShirtFill, kd as RiShirtLine, Pd as RiShoppingBag2Fill, Dd as RiShoppingBag2Line, yd as RiShoppingBag3Fill, bd as RiShoppingBag3Line, FG as RiShoppingBag4Fill, SG as RiShoppingBag4Line, Td as RiShoppingBagFill, Ud as RiShoppingBagLine, Gd as RiShoppingBasket2Fill, Id as RiShoppingBasket2Line, Wd as RiShoppingBasketFill, Od as RiShoppingBasketLine, Kd as RiShoppingCart2Fill, Qd as RiShoppingCart2Line, qd as RiShoppingCartFill, jd as RiShoppingCartLine, Xd as RiShowersFill, Jd as RiShowersLine, Yd as RiShuffleFill, _d as RiShuffleLine, $d as RiShutDownFill, ep as RiShutDownLine, tp as RiSideBarFill, Cp as RiSideBarLine, wb as RiSidebarFoldFill, Lb as RiSidebarFoldLine, hb as RiSidebarUnfoldFill, Hb as RiSidebarUnfoldLine, lp as RiSignalTowerFill, ip as RiSignalTowerLine, sp as RiSignalWifi1Fill, rp as RiSignalWifi1Line, cp as RiSignalWifi2Fill, op as RiSignalWifi2Line, ap as RiSignalWifi3Fill, np as RiSignalWifi3Line, mp as RiSignalWifiErrorFill, wp as RiSignalWifiErrorLine, Lp as RiSignalWifiFill, hp as RiSignalWifiLine, Hp as RiSignalWifiOffFill, Vp as RiSignalWifiOffLine, oT as RiSignpostFill, aT as RiSignpostLine, gp as RiSimCard2Fill, Mp as RiSimCard2Line, Zp as RiSimCardFill, xp as RiSimCardLine, vp as RiSingleQuotesL, dp as RiSingleQuotesR, pp as RiSipFill, Ep as RiSipLine, zA as RiSketching, Np as RiSkipBackFill, up as RiSkipBackLine, Bp as RiSkipBackMiniFill, fp as RiSkipBackMiniLine, FA as RiSkipDownFill, SA as RiSkipDownLine, Rp as RiSkipForwardFill, zp as RiSkipForwardLine, Fp as RiSkipForwardMiniFill, Sp as RiSkipForwardMiniLine, AA as RiSkipLeftFill, kA as RiSkipLeftLine, PA as RiSkipRightFill, DA as RiSkipRightLine, yA as RiSkipUpFill, bA as RiSkipUpLine, Ap as RiSkull2Fill, kp as RiSkull2Line, Pp as RiSkullFill, Dp as RiSkullLine, yp as RiSkypeFill, bp as RiSkypeLine, Tp as RiSlackFill, Up as RiSlackLine, Qk as RiSlashCommands, HP as RiSlashCommands2, Gp as RiSliceFill, Ip as RiSliceLine, Wp as RiSlideshow2Fill, Op as RiSlideshow2Line, Kp as RiSlideshow3Fill, Qp as RiSlideshow3Line, qp as RiSlideshow4Fill, jp as RiSlideshow4Line, Xp as RiSlideshowFill, Jp as RiSlideshowLine, Vb as RiSlideshowView, TA as RiSlowDownFill, UA as RiSlowDownLine, Yp as RiSmartphoneFill, _p as RiSmartphoneLine, $p as RiSnapchatFill, eE as RiSnapchatLine, AG as RiSnowflakeFill, kG as RiSnowflakeLine, tE as RiSnowyFill, CE as RiSnowyLine, iy as RiSofaFill, sy as RiSofaLine, gb as RiSortAlphabetAsc, Mb as RiSortAlphabetDesc, lE as RiSortAsc, iE as RiSortDesc, Zb as RiSortNumberAsc, xb as RiSortNumberDesc, sE as RiSoundModuleFill, rE as RiSoundModuleLine, cE as RiSoundcloudFill, oE as RiSoundcloudLine, mE as RiSpace, aE as RiSpaceShipFill, nE as RiSpaceShipLine, wE as RiSpam2Fill, LE as RiSpam2Line, hE as RiSpam3Fill, HE as RiSpam3Line, VE as RiSpamFill, gE as RiSpamLine, GA as RiSparkling2Fill, IA as RiSparkling2Line, WA as RiSparklingFill, OA as RiSparklingLine, sO as RiSpeakAiFill, rO as RiSpeakAiLine, KA as RiSpeakFill, QA as RiSpeakLine, ME as RiSpeaker2Fill, ZE as RiSpeaker2Line, xE as RiSpeaker3Fill, vE as RiSpeaker3Line, dE as RiSpeakerFill, pE as RiSpeakerLine, EE as RiSpectrumFill, NE as RiSpectrumLine, uE as RiSpeedFill, BE as RiSpeedLine, fE as RiSpeedMiniFill, RE as RiSpeedMiniLine, qA as RiSpeedUpFill, jA as RiSpeedUpLine, zE as RiSplitCellsHorizontal, FE as RiSplitCellsVertical, SE as RiSpotifyFill, AE as RiSpotifyLine, kE as RiSpyFill, PE as RiSpyLine, qP as RiSquareFill, jP as RiSquareLine, PG as RiSquareRoot, DE as RiStackFill, yE as RiStackLine, bE as RiStackOverflowFill, TE as RiStackOverflowLine, vb as RiStackedView, UE as RiStackshareFill, GE as RiStackshareLine, zI as RiStairsFill, FI as RiStairsLine, IE as RiStarFill, WE as RiStarHalfFill, OE as RiStarHalfLine, KE as RiStarHalfSFill, QE as RiStarHalfSLine, qE as RiStarLine, cO as RiStarOffFill, oO as RiStarOffLine, jE as RiStarSFill, XE as RiStarSLine, JE as RiStarSmileFill, YE as RiStarSmileLine, _E as RiSteamFill, $E as RiSteamLine, eN as RiSteering2Fill, tN as RiSteering2Line, CN as RiSteeringFill, lN as RiSteeringLine, iN as RiStethoscopeFill, sN as RiStethoscopeLine, rN as RiStickyNote2Fill, cN as RiStickyNote2Line, db as RiStickyNoteAddFill, pb as RiStickyNoteAddLine, oN as RiStickyNoteFill, aN as RiStickyNoteLine, nN as RiStockFill, mN as RiStockLine, wN as RiStopCircleFill, LN as RiStopCircleLine, hN as RiStopFill, DG as RiStopLargeFill, yG as RiStopLargeLine, HN as RiStopLine, VN as RiStopMiniFill, gN as RiStopMiniLine, MN as RiStore2Fill, ZN as RiStore2Line, xN as RiStore3Fill, vN as RiStore3Line, dN as RiStoreFill, pN as RiStoreLine, NN as RiStrikethrough, EN as RiStrikethrough2, BN as RiSubscript, uN as RiSubscript2, fN as RiSubtractFill, RN as RiSubtractLine, zN as RiSubwayFill, FN as RiSubwayLine, SN as RiSubwayWifiFill, AN as RiSubwayWifiLine, kN as RiSuitcase2Fill, PN as RiSuitcase2Line, DN as RiSuitcase3Fill, yN as RiSuitcase3Line, bN as RiSuitcaseFill, TN as RiSuitcaseLine, UN as RiSunCloudyFill, GN as RiSunCloudyLine, IN as RiSunFill, WN as RiSunFoggyFill, ON as RiSunFoggyLine, KN as RiSunLine, $k as RiSupabaseFill, eP as RiSupabaseLine, qN as RiSuperscript, QN as RiSuperscript2, jN as RiSurgicalMaskFill, XN as RiSurgicalMaskLine, JN as RiSurroundSoundFill, YN as RiSurroundSoundLine, _N as RiSurveyFill, $N as RiSurveyLine, ry as RiSvelteFill, cy as RiSvelteLine, Eb as RiSwap2Fill, Nb as RiSwap2Line, ub as RiSwap3Fill, Bb as RiSwap3Line, eu as RiSwapBoxFill, tu as RiSwapBoxLine, Cu as RiSwapFill, lu as RiSwapLine, iu as RiSwitchFill, su as RiSwitchLine, ru as RiSwordFill, cu as RiSwordLine, ou as RiSyringeFill, au as RiSyringeLine, nu as RiTBoxFill, mu as RiTBoxLine, wu as RiTShirt2Fill, Lu as RiTShirt2Line, hu as RiTShirtAirFill, Hu as RiTShirtAirLine, Vu as RiTShirtFill, gu as RiTShirtLine, Mu as RiTable2, fb as RiTable3, Zu as RiTableAltFill, xu as RiTableAltLine, vu as RiTableFill, du as RiTableLine, Rb as RiTableView, pu as RiTabletFill, Eu as RiTabletLine, bG as RiTailwindCssFill, TG as RiTailwindCssLine, Nu as RiTakeawayFill, uu as RiTakeawayLine, Bu as RiTaobaoFill, fu as RiTaobaoLine, Ru as RiTapeFill, zu as RiTapeLine, Fu as RiTaskFill, Su as RiTaskLine, Au as RiTaxiFill, ku as RiTaxiLine, Pu as RiTaxiWifiFill, Du as RiTaxiWifiLine, yu as RiTeamFill, bu as RiTeamLine, SI as RiTelegram2Fill, AI as RiTelegram2Line, Tu as RiTelegramFill, Uu as RiTelegramLine, Gu as RiTempColdFill, Iu as RiTempColdLine, Wu as RiTempHotFill, Ou as RiTempHotLine, XP as RiTentFill, JP as RiTentLine, Ku as RiTerminalBoxFill, Qu as RiTerminalBoxLine, qu as RiTerminalFill, ju as RiTerminalLine, Xu as RiTerminalWindowFill, Ju as RiTerminalWindowLine, Yu as RiTestTubeFill, _u as RiTestTubeLine, lB as RiText, zb as RiTextBlock, $u as RiTextDirectionL, eB as RiTextDirectionR, Fb as RiTextSnippet, tB as RiTextSpacing, CB as RiTextWrap, iB as RiThermometerFill, sB as RiThermometerLine, YP as RiThreadsFill, _P as RiThreadsLine, rB as RiThumbDownFill, cB as RiThumbDownLine, oB as RiThumbUpFill, aB as RiThumbUpLine, nB as RiThunderstormsFill, mB as RiThunderstormsLine, wB as RiTicket2Fill, LB as RiTicket2Line, hB as RiTicketFill, HB as RiTicketLine, XA as RiTiktokFill, JA as RiTiktokLine, VB as RiTimeFill, gB as RiTimeLine, nT as RiTimeZoneFill, mT as RiTimeZoneLine, Sb as RiTimelineView, MB as RiTimer2Fill, ZB as RiTimer2Line, xB as RiTimerFill, vB as RiTimerFlashFill, dB as RiTimerFlashLine, pB as RiTimerLine, EB as RiTodoFill, NB as RiTodoLine, uB as RiToggleFill, BB as RiToggleLine, YA as RiTokenSwapFill, _A as RiTokenSwapLine, fB as RiToolsFill, RB as RiToolsLine, UG as RiToothFill, GG as RiToothLine, zB as RiTornadoFill, FB as RiTornadoLine, SB as RiTrademarkFill, AB as RiTrademarkLine, kB as RiTrafficLightFill, PB as RiTrafficLightLine, DB as RiTrainFill, yB as RiTrainLine, bB as RiTrainWifiFill, TB as RiTrainWifiLine, GB as RiTranslate, UB as RiTranslate2, nO as RiTranslateAi, aO as RiTranslateAi2, IB as RiTravestiFill, WB as RiTravestiLine, OB as RiTreasureMapFill, KB as RiTreasureMapLine, $P as RiTreeFill, eD as RiTreeLine, QB as RiTrelloFill, qB as RiTrelloLine, tD as RiTriangleFill, CD as RiTriangleLine, kI as RiTriangularFlagFill, PI as RiTriangularFlagLine, jB as RiTrophyFill, XB as RiTrophyLine, JB as RiTruckFill, YB as RiTruckLine, _B as RiTumblrFill, $B as RiTumblrLine, ef as RiTv2Fill, tf as RiTv2Line, Cf as RiTvFill, lf as RiTvLine, sf as RiTwitchFill, rf as RiTwitchLine, cf as RiTwitterFill, of as RiTwitterLine, lD as RiTwitterXFill, iD as RiTwitterXLine, af as RiTyphoonFill, nf as RiTyphoonLine, mf as RiUDiskFill, wf as RiUDiskLine, Lf as RiUbuntuFill, hf as RiUbuntuLine, Hf as RiUmbrellaFill, Vf as RiUmbrellaLine, gf as RiUnderline, Mf as RiUninstallFill, Zf as RiUninstallLine, $A as RiUnpinFill, ek as RiUnpinLine, xf as RiUnsplashFill, vf as RiUnsplashLine, df as RiUpload2Fill, pf as RiUpload2Line, Ef as RiUploadCloud2Fill, Nf as RiUploadCloud2Line, uf as RiUploadCloudFill, Bf as RiUploadCloudLine, ff as RiUploadFill, Rf as RiUploadLine, zf as RiUsbFill, Ff as RiUsbLine, Sf as RiUser2Fill, Af as RiUser2Line, kf as RiUser3Fill, Pf as RiUser3Line, Df as RiUser4Fill, yf as RiUser4Line, bf as RiUser5Fill, Tf as RiUser5Line, Uf as RiUser6Fill, Gf as RiUser6Line, If as RiUserAddFill, Wf as RiUserAddLine, mO as RiUserCommunityFill, wO as RiUserCommunityLine, Of as RiUserFill, Kf as RiUserFollowFill, Qf as RiUserFollowLine, VP as RiUserForbidFill, gP as RiUserForbidLine, qf as RiUserHeartFill, jf as RiUserHeartLine, Xf as RiUserLine, Jf as RiUserLocationFill, Yf as RiUserLocationLine, DI as RiUserMinusFill, yI as RiUserMinusLine, _f as RiUserReceived2Fill, $f as RiUserReceived2Line, eR as RiUserReceivedFill, tR as RiUserReceivedLine, CR as RiUserSearchFill, lR as RiUserSearchLine, iR as RiUserSettingsFill, sR as RiUserSettingsLine, rR as RiUserShared2Fill, cR as RiUserShared2Line, oR as RiUserSharedFill, aR as RiUserSharedLine, nR as RiUserSmileFill, mR as RiUserSmileLine, wR as RiUserStarFill, LR as RiUserStarLine, hR as RiUserUnfollowFill, HR as RiUserUnfollowLine, VR as RiUserVoiceFill, gR as RiUserVoiceLine, LO as RiVercelFill, hO as RiVercelLine, sD as RiVerifiedBadgeFill, rD as RiVerifiedBadgeLine, MR as RiVideoAddFill, ZR as RiVideoAddLine, HO as RiVideoAiFill, VO as RiVideoAiLine, xR as RiVideoChatFill, vR as RiVideoChatLine, dR as RiVideoDownloadFill, pR as RiVideoDownloadLine, ER as RiVideoFill, NR as RiVideoLine, IG as RiVideoOffFill, WG as RiVideoOffLine, gO as RiVideoOnAiFill, MO as RiVideoOnAiLine, OG as RiVideoOnFill, KG as RiVideoOnLine, uR as RiVideoUploadFill, BR as RiVideoUploadLine, fR as RiVidicon2Fill, RR as RiVidicon2Line, zR as RiVidiconFill, FR as RiVidiconLine, SR as RiVimeoFill, AR as RiVimeoLine, kR as RiVipCrown2Fill, PR as RiVipCrown2Line, DR as RiVipCrownFill, yR as RiVipCrownLine, bR as RiVipDiamondFill, TR as RiVipDiamondLine, UR as RiVipFill, GR as RiVipLine, IR as RiVirusFill, WR as RiVirusLine, OR as RiVisaFill, KR as RiVisaLine, oy as RiVkFill, ay as RiVkLine, ZO as RiVoiceAiFill, xO as RiVoiceAiLine, QR as RiVoiceRecognitionFill, qR as RiVoiceRecognitionLine, jR as RiVoiceprintFill, XR as RiVoiceprintLine, JR as RiVolumeDownFill, YR as RiVolumeDownLine, _R as RiVolumeMuteFill, $R as RiVolumeMuteLine, ez as RiVolumeOffVibrateFill, tz as RiVolumeOffVibrateLine, Cz as RiVolumeUpFill, lz as RiVolumeUpLine, iz as RiVolumeVibrateFill, sz as RiVolumeVibrateLine, rz as RiVuejsFill, cz as RiVuejsLine, oz as RiWalkFill, az as RiWalkLine, nz as RiWallet2Fill, mz as RiWallet2Line, wz as RiWallet3Fill, Lz as RiWallet3Line, hz as RiWalletFill, Hz as RiWalletLine, Vz as RiWaterFlashFill, gz as RiWaterFlashLine, tP as RiWaterPercentFill, CP as RiWaterPercentLine, Mz as RiWebcamFill, Zz as RiWebcamLine, QG as RiWebhookFill, qG as RiWebhookLine, xz as RiWechat2Fill, vz as RiWechat2Line, tk as RiWechatChannelsFill, Ck as RiWechatChannelsLine, dz as RiWechatFill, pz as RiWechatLine, Ez as RiWechatPayFill, Nz as RiWechatPayLine, uz as RiWeiboFill, Bz as RiWeiboLine, jG as RiWeightFill, XG as RiWeightLine, fz as RiWhatsappFill, Rz as RiWhatsappLine, zz as RiWheelchairFill, Fz as RiWheelchairLine, Sz as RiWifiFill, Az as RiWifiLine, kz as RiWifiOffFill, Pz as RiWifiOffLine, Dz as RiWindow2Fill, yz as RiWindow2Line, bz as RiWindowFill, Tz as RiWindowLine, Uz as RiWindowsFill, Gz as RiWindowsLine, Iz as RiWindyFill, Wz as RiWindyLine, Oz as RiWirelessChargingFill, Kz as RiWirelessChargingLine, Qz as RiWomenFill, qz as RiWomenLine, lk as RiWordpressFill, ik as RiWordpressLine, jz as RiWubiInput, Xz as RiXboxFill, Jz as RiXboxLine, Yz as RiXingFill, _z as RiXingLine, ny as RiXrpFill, my as RiXrpLine, wy as RiXtzFill, Ly as RiXtzLine, $z as RiYoutubeFill, eF as RiYoutubeLine, lP as RiYuqueFill, iP as RiYuqueLine, tF as RiZcoolFill, CF as RiZcoolLine, lF as RiZhihuFill, iF as RiZhihuLine, sF as RiZoomInFill, rF as RiZoomInLine, cF as RiZoomOutFill, oF as RiZoomOutLine, aF as RiZzzFill, nF as RiZzzLine };